import require$$1$1 from 'http';
import require$$2$1 from 'https';
import require$$2 from 'stream';
import require$$0$1 from 'tty';
import require$$0 from 'os';
import require$$8 from 'zlib';
import * as React from 'react';
import React__default, { createContext, useState, useEffect } from 'react';
import crypto from 'crypto';

// import moment from "moment-timezone";
var Front$h = 1;
var Rear$h = 2;
var Interior = 3;
//Blackvue7 Box 옵션 카메라 방향 추가 (8460)
var Option$h = 3;
var FenceTypeCode = {
    polygon: 1,
    polyline: 4,
    circle: 3,
    rectangle: 2,
};
var FenceTypeName = {
    1: 'polygon',
    2: 'rectangle',
    3: 'circle',
    4: 'polyline',
};
var EventAbbrToEventFull = {
    N: 'Normal',
    E: 'Event',
    P: 'Parking',
    M: 'Manual',
    S: 'Event',
    J: 'Event',
};
// export const ECODE_TO_MTYPE: { [key: string]: number } = {
//   E: 1,
//   I: 2,
//   O: 3,
//   A: 4,
//   T: 5,
//   B: 6,
//   R: 7,
//   X: 8,
//   G: 9,
// };
var MCODE_TO_TEXT = {
    0: 'Event',
    1: 'Overspeed',
    2: 'Driving impact',
    3: 'Hard acceleration',
    4: 'Hard braking',
    5: 'Hard cornering',
    6: 'Drowsiness',
    7: 'Distracted',
    8: 'Detected',
    // 9: "Calling",
    // 10: "Smoking",
    9: 'Hand distraction',
    10: 'Hand distraction',
    11: 'Undetected',
    12: 'Mask off',
    13: 'Geofence-Enter',
    14: 'Geofence-Exit',
    15: 'Geofence-Pass',
    16: 'Geofence-Speed Alert',
    18: 'No Seat Belt',
};
var StatusNames = {
    P: 'Pending',
    A: 'Accepted',
    E: 'Expired',
};
var ECODE_TO_MTYPE = {
    E: 2,
    I: 2,
    O: 1,
    A: 3,
    T: 5,
    B: 4,
    R: 13,
    X: 14,
    G: 15,
    J: 16,
    F: 11,
    D: 6,
    L: 7,
    C: 9,
    S: 10,
    Y: 18, // Seat Belt
};
var MTYPE_TO_ECODE = {
    1: 'O',
    2: 'E',
    3: 'A',
    4: 'B',
    5: 'T',
    6: 'D',
    7: 'L',
    9: 'C',
    10: 'S',
    11: 'F',
    13: 'R',
    14: 'X',
    15: 'G',
    16: 'J',
    18: 'Y',
};
var UserNames = {
    SubMaster: 'Admin',
    User: 'Driver',
    Master: 'Master',
    Etc: '',
};
var RoleNames = {
    SubMaster: 'Admin',
    User: 'Driver',
};
var BatteryModel;
(function (BatteryModel) {
    BatteryModel["B124X"] = "B-124X";
    BatteryModel["B130X"] = "B-130X";
})(BatteryModel || (BatteryModel = {}));
var BatteryChangeSettingResult;
(function (BatteryChangeSettingResult) {
    BatteryChangeSettingResult["SUCCESS"] = "success";
    BatteryChangeSettingResult["FAIL"] = "fail";
    BatteryChangeSettingResult["NONE"] = "";
})(BatteryChangeSettingResult || (BatteryChangeSettingResult = {}));
var BatteryManualStatus;
(function (BatteryManualStatus) {
    BatteryManualStatus["SUCCESS"] = "success";
    BatteryManualStatus["DOING"] = "doing";
    BatteryManualStatus["FAIL"] = "fail";
    BatteryManualStatus["NONE"] = "";
    BatteryManualStatus["START"] = "start";
    BatteryManualStatus["IN_USE"] = "in_use";
    BatteryManualStatus["NOT_STARTED"] = "not_started";
})(BatteryManualStatus || (BatteryManualStatus = {}));
var BatteryManualCommand;
(function (BatteryManualCommand) {
    BatteryManualCommand["START"] = "batteryManualStart";
    BatteryManualCommand["MANUAL"] = "batteryManual";
    BatteryManualCommand["END"] = "batteryManualEnd";
})(BatteryManualCommand || (BatteryManualCommand = {}));
var BatteryFailPart;
(function (BatteryFailPart) {
    BatteryFailPart["INFO"] = "info";
    BatteryFailPart["DAYHISTORY"] = "day";
    BatteryFailPart["WEEKHISTORY"] = "week";
    BatteryFailPart["SETTINGS"] = "settings";
})(BatteryFailPart || (BatteryFailPart = {}));
var BatteryHistoryType;
(function (BatteryHistoryType) {
    BatteryHistoryType["TEMP"] = "temp";
    BatteryHistoryType["CHARGE"] = "charge";
})(BatteryHistoryType || (BatteryHistoryType = {}));

var DR750_2CH_LTE = {
    default: {
        Time: {
            GpsSync: {},
            TimeSet: {},
        },
        Video: {
            ImageSetting: {
                options: [{ key: "0", value: "FHD @60 + FHD @30" }],
            },
            VideoQuality: {
                options: [
                    { key: "0", value: "Highest(Extreme)" },
                    { key: "1", value: "Highest" },
                    { key: "2", value: "High" },
                    { key: "3", value: "Normal" },
                ],
            },
            NightVision: {
                options: [
                    { key: "1", value: "Always" },
                    { key: "2", value: "Parking mode only" },
                ],
            },
            FrontBrightness: {},
            RearBrightness: {},
        },
        Recording: {
            NormalRecord: {},
            AutoParking: {},
            RearParkingMode: {
                explain: "ON: front and_",
            },
            VoiceRecord: {},
            DateDisplay: {},
            SpeedUnit: {},
            UseGpsInfo: {},
            RecordTime: {
                options: [
                    {
                        key: "1",
                        value: "1 min",
                    },
                ],
            },
            LockEvent: {},
            overWriteLock: {},
            FrontRotate: {},
            RearRotate: {
                options: [
                    {
                        key: "0",
                        value: "Default",
                    },
                    {
                        key: "1",
                        value: "Rotate video 180°",
                    },
                    {
                        key: "2",
                        value: "Mirror video",
                    },
                ],
            },
        },
        Gsensor: {
            Normal: {},
            Parking: {},
        },
        MotionDetection: {},
        System: {
            LED: {
                RECLED: {},
                NORMALLED: {},
                PARKINGLED: {},
                RearLED: {},
                LTELED: {},
                WifiLED: {},
            },
            PSENSOR: {},
            VoiceGuidance: {
                STARTVOICE: {},
                NORMALSTARTVOICE: {},
                EVENTSTARTVOICE: {},
                CHANGERECORDMODEVOICE: {},
                ENDVOICE: {},
                SPEEDALERTVOICE: {},
                PARKINGEVENTVOICE: {},
                CLOUDVOICE: {},
                CHANGECONFIGVOICE: {},
                SHARPTURNVOICE: {},
                HARSHBRAKINGVOICE: {},
                ACCELERATIONVOICE: {},
            },
            VOLUME: {},
            ScheduledReboot: {},
            SpeedAlert: {},
            UserTextOverlay: {},
        },
        Wifi: {
            LoginCredentials: {},
            WifiSleepMode: {},
            onstart_LTE: {},
        },
        Cloud: { CloudService: {}, sta1: {}, sta2: {}, sta3: {} },
        FirmwareLanguage: [
            "English",
            "Japan",
            "China",
            "German",
            "French",
            "Thai",
            "Idn",
            "Vietnam",
            "Spain",
            "Italian",
            "Dutch",
            "Polish",
            "Norwegian",
            "Finnish",
            "Arabic",
        ],
    },
    1.008: {
        System: {
            EventRev: {},
        },
    },
    1.01: {
        System: {
            Seamless: {},
        },
    },
};

var DR900X_2CH = {
    default: {
        Time: {
            GpsSync: {},
            TimeSet: {},
        },
        Video: {
            ImageSetting: {
                options: [{ key: "0", value: "4K UHD@30 + FHD@30" }],
            },
            VideoQuality: {
                options: [
                    { key: "0", value: "Highest(Extreme)" },
                    { key: "1", value: "Highest" },
                    { key: "2", value: "High" },
                    { key: "3", value: "Normal" },
                ],
            },
            VCodecType: {},
            NightVision: {
                options: [
                    { key: "1", value: "Always" },
                    { key: "2", value: "Parking mode only" },
                ],
            },
            FrontBrightness: {},
            RearBrightness: {},
        },
        Recording: {
            NormalRecord: {},
            AutoParking: {},
            RearParkingMode: {
                explain: "ON: front and_",
            },
            VoiceRecord: {},
            UseGpsInfo: {},
            DateDisplay: {},
            SpeedUnit: {},
            RecordTime: {
                options: [
                    {
                        key: "1",
                        value: "1 min",
                    },
                ],
            },
            LockEvent: {},
            FrontRotate: {},
            RearRotate: {
                options: [
                    {
                        key: "0",
                        value: "Default",
                    },
                    {
                        key: "1",
                        value: "Rotate video 180°",
                    },
                    {
                        key: "2",
                        value: "Mirror video",
                    },
                ],
            },
        },
        Gsensor: {
            Normal: {},
            Parking: {},
        },
        MotionDetection: {
            MOTIONSENSOR: {},
        },
        System: {
            LED: {
                RECLED: {},
                NORMALLED: {},
                PARKINGLED: {},
                RearLED: {},
                LTELED: {},
                WifiLED: {},
            },
            PSENSOR: {},
            VoiceGuidance: {
                STARTVOICE: {},
                NORMALSTARTVOICE: {},
                EVENTSTARTVOICE: {},
                CHANGERECORDMODEVOICE: {},
                ENDVOICE: {},
                SPEEDALERTVOICE: {},
                PARKINGEVENTVOICE: {},
                CLOUDVOICE: {},
                CHANGECONFIGVOICE: {},
                SHARPTURNVOICE: {},
                HARSHBRAKINGVOICE: {},
                ACCELERATIONVOICE: {},
            },
            VOLUME: {},
            ScheduledReboot: {},
            SpeedAlert: {},
            BatteryProtection: {},
            UserTextOverlay: {},
        },
        Wifi: {
            LoginCredentials: {},
            WifiBand: {},
            WifiSleepMode: {},
        },
        Cloud: { CloudService: {}, sta1: {}, sta2: {}, sta3: {} },
        FirmwareLanguage: [
            "English",
            "Japan",
            "China",
            "German",
            "French",
            "Thai",
            "Idn",
            "Vietnam",
            "Spain",
            "Italian",
            "Dutch",
            "Polish",
            "Norwegian",
            "Finnish",
            "Arabic",
        ],
    },
    1.008: {
        System: {
            EventRev: {},
        },
    },
    1.01: {
        System: {
            Seamless: {},
        },
    },
};

var DR900S_1CH = {
    default: {
        Time: {
            GpsSync: {},
            TimeSet: {},
        },
        Video: {
            ImageSetting: {
                options: [
                    { key: "0", value: "4K UHD @30(Extreme)" },
                    { key: "1", value: "4K UHD @30" },
                    { key: "2", value: "FHD @60" },
                    { key: "3", value: "FHD @30" },
                ],
            },
            VideoQuality: {
                options: [
                    { key: "0", value: "Highest" },
                    { key: "1", value: "High" },
                    { key: "2", value: "Normal" },
                ],
                options4k: [{ key: "0", value: "Highest (Extreme)" }],
            },
            VCodecType: {},
            NightVision: {
                options: [
                    { key: "1", value: "Always" },
                    { key: "2", value: "Parking mode only" },
                ],
            },
            FrontBrightness: {},
        },
        Recording: {
            NormalRecord: {},
            AutoParking: {},
            VoiceRecord: {},
            DateDisplay: {},
            SpeedUnit: {},
            UseGpsInfo: {},
            RecordTime: {
                options: [
                    {
                        key: "1",
                        value: "1 min",
                    },
                    {
                        key: "2",
                        value: "2 min",
                    },
                    {
                        key: "3",
                        value: "3 min",
                    },
                ],
                options4k: [
                    {
                        key: "1",
                        value: "1 min (Extreme)",
                    },
                ],
            },
            LockEvent: {},
            overWriteLock: {},
            FrontRotate: {},
        },
        Gsensor: {
            Normal: {},
            Parking: {},
        },
        MotionDetection: {
            MOTIONSENSOR: {},
        },
        System: {
            LED: {
                RECLED: {},
                NORMALLED: {},
                PARKINGLED: {},
                WifiLED: {},
            },
            PSENSOR: {},
            VoiceGuidance: {
                STARTVOICE: {},
                NORMALSTARTVOICE: {},
                EVENTSTARTVOICE: {},
                CHANGERECORDMODEVOICE: {},
                ENDVOICE: {},
                SPEEDALERTVOICE: {},
                PARKINGEVENTVOICE: {},
                CLOUDVOICE: {},
                CHANGECONFIGVOICE: {},
                SHARPTURNVOICE: {},
                HARSHBRAKINGVOICE: {},
                ACCELERATIONVOICE: {},
            },
            VOLUME: {},
            ScheduledReboot: {},
            SpeedAlert: {},
            //BatteryProtection: {},
            UserTextOverlay: {},
        },
        Wifi: {
            LoginCredentials: {},
            WifiBand: {},
            WifiSleepMode: {},
            onstart: {},
            // onstart_LTE: {},
        },
        Cloud: { CloudService: {}, sta1: {}, sta2: {}, sta3: {} },
        FirmwareLanguage: [
            "English",
            "Japan",
            "China",
            "German",
            "French",
            "Thai",
            "Idn",
            "Vietnam",
            "Spain",
            "Italian",
            "Dutch",
            "Polish",
            "Norwegian",
            "Finnish",
        ],
    },
    1.014: {
        System: {
            EventRev: {},
        },
    },
};

var DR750S_1CH = {
    default: {
        Time: {
            GpsSync: {},
            TimeSet: {},
        },
        Video: {
            ImageSetting: {
                options: [
                    { key: "3", value: "Full HD @60fps (Extreme)" },
                    { key: "0", value: "Full HD @60fps (Sports)" },
                    { key: "1", value: "Full HD @30fps" },
                    { key: "2", value: "HD @30fps" },
                ],
            },
            VideoQuality: {
                options: [
                    { key: "0", value: "Highest" },
                    { key: "1", value: "High" },
                    { key: "2", value: "Normal" },
                ],
                options4k: [
                    { key: "0", value: "Highest (Extreme)" },
                    { key: "0", value: "Highest (Sports)" },
                ],
            },
            NightVision: {
                options: [
                    { key: "1", value: "Always" },
                    { key: "2", value: "Parking mode only" },
                ],
            },
            FrontBrightness: {},
        },
        Recording: {
            NormalRecord: {},
            AutoParking: {},
            VoiceRecord: {},
            DateDisplay: {},
            SpeedUnit: {},
            UseGpsInfo: {},
            RecordTime: {
                options: [
                    {
                        key: "1",
                        value: "1 min",
                    },
                    {
                        key: "2",
                        value: "2 min",
                    },
                    {
                        key: "3",
                        value: "3 min",
                    },
                ],
                options4k: [
                    {
                        key: "1",
                        value: "1 min (Extreme)",
                    },
                    {
                        key: "1",
                        value: "1 min (Sports)",
                    },
                ],
            },
            LockEvent: {},
            FrontRotate: {},
        },
        Gsensor: {
            Normal: {},
            Parking: {},
        },
        MotionDetection: {
            MOTIONSENSOR: {},
        },
        System: {
            LED: {
                RECLED: {},
                NORMALLED: {},
                PARKINGLED: {},
                WifiLED: {},
            },
            PSENSOR: {},
            VoiceGuidance: {
                STARTVOICE: {},
                NORMALSTARTVOICE: {},
                EVENTSTARTVOICE: {},
                CHANGERECORDMODEVOICE: {},
                ENDVOICE: {},
                SPEEDALERTVOICE: {},
                PARKINGEVENTVOICE: {},
                CLOUDVOICE: {},
                CHANGECONFIGVOICE: {},
                SHARPTURNVOICE: {},
                HARSHBRAKINGVOICE: {},
                ACCELERATIONVOICE: {},
            },
            VOLUME: {},
            ScheduledReboot: {},
            SpeedAlert: {},
            //BatteryProtection: {},
            UserTextOverlay: {},
        },
        Wifi: {
            LoginCredentials: {},
            WifiSleepMode: {},
            onstart: {},
        },
        Cloud: { CloudService: {}, sta1: {}, sta2: {}, sta3: {} },
        FirmwareLanguage: [
            "English",
            "Japan",
            "China",
            "German",
            "French",
            "Thai",
            "Idn",
            "Vietnam",
            "Spain",
            "Italian",
            "Dutch",
            "Polish",
            "Norwegian",
            "Finnish",
        ],
    },
    1.019: {
        System: {
            EventRev: {},
        },
    },
};

var DR750S_2CH = {
    default: {
        Time: {
            GpsSync: {},
            TimeSet: {},
        },
        Video: {
            ImageSetting: {
                options: [
                    { key: "4", value: "FHD@60 + FHD@30 (Extreme)" },
                    { key: "0", value: "FHD@60 + FHD@30 (Sports)" },
                    { key: "1", value: "FHD@30 + FHD@30" },
                    { key: "2", value: "FHD@30 + HD@30" },
                    { key: "3", value: "HD@30 + HD@30" },
                ],
            },
            VideoQuality: {
                options: [
                    { key: "0", value: "Highest" },
                    { key: "1", value: "High" },
                    { key: "2", value: "Normal" },
                ],
                options4k: [
                    { key: "0", value: "Highest (Extreme)" },
                    { key: "0", value: "Highest (Sports)" },
                ],
            },
            NightVision: {
                options: [
                    { key: "1", value: "Always" },
                    { key: "2", value: "Parking mode only" },
                ],
            },
            FrontBrightness: {},
            RearBrightness: {},
        },
        Recording: {
            NormalRecord: {},
            AutoParking: {},
            VoiceRecord: {},
            DateDisplay: {},
            SpeedUnit: {},
            UseGpsInfo: {},
            RecordTime: {
                options: [
                    {
                        key: "1",
                        value: "1 min",
                    },
                    {
                        key: "2",
                        value: "2 min",
                    },
                    {
                        key: "3",
                        value: "3 min",
                    },
                ],
                options4k: [
                    {
                        key: "1",
                        value: "1 min (Extreme)",
                    },
                    {
                        key: "1",
                        value: "1 min (Sports)",
                    },
                ],
            },
            LockEvent: {},
            FrontRotate: {},
            RearRotate: {
                options: [
                    {
                        key: "0",
                        value: "Default",
                    },
                    {
                        key: "1",
                        value: "Rotate video 180°",
                    },
                    {
                        key: "2",
                        value: "Mirror video",
                    },
                ],
            },
        },
        Gsensor: {
            Normal: {},
            Parking: {},
        },
        MotionDetection: {
            MOTIONSENSOR: {},
        },
        System: {
            LED: {
                RECLED: {},
                NORMALLED: {},
                PARKINGLED: {},
                RearLED: {},
                WifiLED: {},
            },
            PSENSOR: {},
            VoiceGuidance: {
                STARTVOICE: {},
                NORMALSTARTVOICE: {},
                EVENTSTARTVOICE: {},
                CHANGERECORDMODEVOICE: {},
                ENDVOICE: {},
                SPEEDALERTVOICE: {},
                PARKINGEVENTVOICE: {},
                CLOUDVOICE: {},
                CHANGECONFIGVOICE: {},
                SHARPTURNVOICE: {},
                HARSHBRAKINGVOICE: {},
                ACCELERATIONVOICE: {},
            },
            VOLUME: {},
            ScheduledReboot: {},
            SpeedAlert: {},
            //BatteryProtection: {},
            UserTextOverlay: {},
            // LowvoltageTime: {},
        },
        Wifi: {
            LoginCredentials: {},
            // WifiBand: {},
            WifiSleepMode: {},
            onstart: {},
            // onstart_LTE: {},
        },
        Cloud: { CloudService: {}, sta1: {}, sta2: {}, sta3: {} },
        FirmwareLanguage: [
            "English",
            "Japan",
            "China",
            "German",
            "French",
            "Thai",
            "Idn",
            "Vietnam",
            "Spain",
            "Italian",
            "Dutch",
            "Polish",
            "Norwegian",
            "Finnish",
        ],
    },
    1.019: {
        System: {
            EventRev: {},
        },
    },
};

var DR900S_2CH = {
    default: {
        Time: {
            GpsSync: {},
            TimeSet: {},
        },
        Video: {
            ImageSetting: {
                options: [
                    { key: "0", value: "4K UHD@30 (Extreme) + FHD@30" },
                    { key: "1", value: "4K UHD@30 + FHD@30" },
                    { key: "2", value: "FHD@60 + FHD@30" },
                    { key: "3", value: "FHD@30 + FHD@30" },
                ],
            },
            VideoQuality: {
                options: [
                    { key: "0", value: "Highest" },
                    { key: "1", value: "High" },
                    { key: "2", value: "Normal" },
                ],
                options4k: [{ key: "0", value: "Highest (Extreme)" }],
            },
            VCodecType: {},
            NightVision: {
                options: [
                    { key: "1", value: "Always" },
                    { key: "2", value: "Parking mode only" },
                ],
            },
            FrontBrightness: {},
            RearBrightness: {},
        },
        Recording: {
            NormalRecord: {},
            AutoParking: {},
            RearParkingMode: {
                explain: "ON: front and_",
            },
            VoiceRecord: {},
            DateDisplay: {},
            UseGpsInfo: {},
            SpeedUnit: {},
            RecordTime: {
                options: [
                    {
                        key: "1",
                        value: "1 min",
                    },
                    {
                        key: "2",
                        value: "2 min",
                    },
                    {
                        key: "3",
                        value: "3 min",
                    },
                ],
                options4k: [
                    {
                        key: "1",
                        value: "1 min (Extreme)",
                    },
                ],
            },
            LockEvent: {},
            FrontRotate: {},
            RearRotate: {
                options: [
                    {
                        key: "0",
                        value: "Default",
                    },
                    {
                        key: "1",
                        value: "Rotate video 180°",
                    },
                    {
                        key: "2",
                        value: "Mirror video",
                    },
                ],
            },
        },
        Gsensor: {
            Normal: {},
            Parking: {},
        },
        MotionDetection: {
            MOTIONSENSOR: {},
        },
        System: {
            LED: {
                RECLED: {},
                NORMALLED: {},
                PARKINGLED: {},
                RearLED: {},
                WifiLED: {},
            },
            PSENSOR: {},
            VoiceGuidance: {
                STARTVOICE: {},
                NORMALSTARTVOICE: {},
                EVENTSTARTVOICE: {},
                CHANGERECORDMODEVOICE: {},
                ENDVOICE: {},
                SPEEDALERTVOICE: {},
                PARKINGEVENTVOICE: {},
                CLOUDVOICE: {},
                CHANGECONFIGVOICE: {},
                SHARPTURNVOICE: {},
                HARSHBRAKINGVOICE: {},
                ACCELERATIONVOICE: {},
            },
            VOLUME: {},
            ScheduledReboot: {},
            SpeedAlert: {},
            //BatteryProtection: {},
            UserTextOverlay: {},
        },
        Wifi: {
            LoginCredentials: {},
            WifiBand: {},
            WifiSleepMode: {},
            onstart: {},
        },
        Cloud: { CloudService: {}, sta1: {}, sta2: {}, sta3: {} },
        FirmwareLanguage: [
            "English",
            "Japan",
            "China",
            "German",
            "French",
            "Thai",
            "Idn",
            "Vietnam",
            "Spain",
            "Italian",
            "Dutch",
            "Polish",
            "Norwegian",
            "Finnish",
        ],
    },
    1.014: {
        System: {
            EventRev: {},
        },
    },
};

var DR750G_1CH = {
    default: {
        Time: {
            GpsSync: {},
            TimeSet: {},
        },
        Video: {
            ImageSetting: {
                options: [
                    { key: "3", value: "Full HD @60fps (Extreme)" },
                    { key: "0", value: "Full HD @60fps (Sports)" },
                    { key: "1", value: "Full HD @30fps" },
                    { key: "2", value: "HD @30fps" },
                ],
            },
            VideoQuality: {
                options: [
                    { key: "0", value: "Highest" },
                    { key: "1", value: "High" },
                    { key: "2", value: "Normal" },
                ],
                options4k: [
                    { key: "0", value: "Highest (Extreme)" },
                    { key: "0", value: "Highest (Sports)" },
                ],
            },
            NightVision: {
                options: [
                    { key: "1", value: "Always" },
                    { key: "2", value: "Parking mode only" },
                ],
            },
            FrontBrightness: {},
        },
        Recording: {
            NormalRecord: {},
            AutoParking: {},
            VoiceRecord: {},
            DateDisplay: {},
            SpeedUnit: {},
            UseGpsInfo: {},
            RecordTime: {
                options: [
                    {
                        key: "1",
                        value: "1 min",
                    },
                    {
                        key: "2",
                        value: "2 min",
                    },
                    {
                        key: "3",
                        value: "3 min",
                    },
                ],
                options4k: [
                    {
                        key: "1",
                        value: "1 min (Extreme)",
                    },
                    {
                        key: "1",
                        value: "1 min (Sports)",
                    },
                ],
            },
            LockEvent: {},
            FrontRotate: {},
        },
        Gsensor: {
            Normal: {},
            Parking: {},
        },
        MotionDetection: {
            MOTIONSENSOR: {},
        },
        System: {
            LED: {
                RECLED: {},
                NORMALLED: {},
                PARKINGLED: {},
                WifiLED: {},
            },
            PSENSOR: {},
            VoiceGuidance: {
                STARTVOICE: {},
                NORMALSTARTVOICE: {},
                EVENTSTARTVOICE: {},
                CHANGERECORDMODEVOICE: {},
                ENDVOICE: {},
                SPEEDALERTVOICE: {},
                PARKINGEVENTVOICE: {},
                CLOUDVOICE: {},
                CHANGECONFIGVOICE: {},
                SHARPTURNVOICE: {},
                HARSHBRAKINGVOICE: {},
                ACCELERATIONVOICE: {},
            },
            VOLUME: {},
            ScheduledReboot: {},
            SpeedAlert: {},
            ADAS: {},
            UserTextOverlay: {},
        },
        Wifi: {
            LoginCredentials: {},
            WifiSleepMode: {},
            onstart: {},
        },
        Cloud: { CloudService: {}, sta1: {}, sta2: {}, sta3: {} },
        FirmwareLanguage: ["English"],
    },
    1.004: {
        System: {
            EventRev: {},
        },
    },
};

var DR750G_2CH = {
    default: {
        Time: {
            GpsSync: {},
            TimeSet: {},
        },
        Video: {
            ImageSetting: {
                options: [
                    { key: "4", value: "FHD @60 + FHD @30 (Extreme)" },
                    { key: "0", value: "FHD @60 + FHD @30 (Sports)" },
                    { key: "1", value: "FHD @30 + FHD @30" },
                    { key: "2", value: "FHD @30 + HD @30" },
                    { key: "3", value: "HD @30 + HD @30" },
                ],
            },
            VideoQuality: {
                options: [
                    { key: "0", value: "Highest" },
                    { key: "1", value: "High" },
                    { key: "2", value: "Normal" },
                ],
                options4k: [
                    { key: "0", value: "Highest (Extreme)" },
                    { key: "0", value: "Highest (Sports)" },
                ],
            },
            // VCodecType: {},
            NightVision: {
                options: [
                    { key: "1", value: "Always" },
                    { key: "2", value: "Parking mode only" },
                ],
            },
            FrontBrightness: {},
            RearBrightness: {},
        },
        Recording: {
            NormalRecord: {},
            AutoParking: {},
            // RearParkingMode: {
            //   explain: "ON: front and_",
            // },
            VoiceRecord: {},
            DateDisplay: {},
            SpeedUnit: {},
            UseGpsInfo: {},
            RecordTime: {
                options: [
                    {
                        key: "1",
                        value: "1 min",
                    },
                    {
                        key: "2",
                        value: "2 min",
                    },
                    {
                        key: "3",
                        value: "3 min",
                    },
                ],
                options4k: [
                    {
                        key: "1",
                        value: "1 min (Extreme)",
                    },
                    {
                        key: "1",
                        value: "1 min (Sports)",
                    },
                ],
            },
            LockEvent: {},
            FrontRotate: {},
            RearRotate: {
                options: [
                    {
                        key: "0",
                        value: "Default",
                    },
                    {
                        key: "1",
                        value: "Rotate video 180°",
                    },
                    {
                        key: "2",
                        value: "Mirror video",
                    },
                ],
            },
        },
        Gsensor: {
            Normal: {},
            Parking: {},
        },
        MotionDetection: {
            MOTIONSENSOR: {},
        },
        System: {
            LED: {
                RECLED: {},
                NORMALLED: {},
                PARKINGLED: {},
                RearLED: {},
                // LTELED: {},
                WifiLED: {},
            },
            PSENSOR: {},
            VoiceGuidance: {
                STARTVOICE: {},
                NORMALSTARTVOICE: {},
                EVENTSTARTVOICE: {},
                CHANGERECORDMODEVOICE: {},
                ENDVOICE: {},
                SPEEDALERTVOICE: {},
                PARKINGEVENTVOICE: {},
                CLOUDVOICE: {},
                CHANGECONFIGVOICE: {},
                SHARPTURNVOICE: {},
                HARSHBRAKINGVOICE: {},
                ACCELERATIONVOICE: {},
            },
            VOLUME: {},
            ScheduledReboot: {},
            SpeedAlert: {},
            ADAS: {},
            // BatteryProtection: {},
            UserTextOverlay: {},
        },
        Wifi: {
            LoginCredentials: {},
            // WifiBand: {},
            WifiSleepMode: {},
            onstart: {},
        },
        Cloud: { CloudService: {}, sta1: {}, sta2: {}, sta3: {} },
        FirmwareLanguage: ["English"],
    },
    1.004: {
        System: {
            EventRev: {},
        },
    },
};

var DR750X_1CH = {
    default: {
        Time: {
            GpsSync: {},
            TimeSet: {},
        },
        Video: {
            ImageSetting: {
                options: [{ key: "0", value: "Full HD @60fps" }],
            },
            VideoQuality: {
                options: [
                    { key: "0", value: "Highest(Extreme)" },
                    { key: "1", value: "Highest" },
                    { key: "2", value: "High" },
                    { key: "3", value: "Normal" },
                ],
            },
            NightVision: {
                options: [
                    { key: "1", value: "Always" },
                    { key: "2", value: "Parking mode only" },
                ],
            },
            FrontBrightness: {},
        },
        Recording: {
            NormalRecord: {},
            AutoParking: {},
            VoiceRecord: {},
            DateDisplay: {},
            SpeedUnit: {},
            UseGpsInfo: {},
            RecordTime: {
                options: [
                    {
                        key: "1",
                        value: "1 min",
                    },
                ],
            },
            LockEvent: {},
            FrontRotate: {},
        },
        Gsensor: {
            Normal: {},
            Parking: {},
        },
        MotionDetection: {
            MOTIONSENSOR: {},
        },
        System: {
            LED: {
                RECLED: {},
                NORMALLED: {},
                PARKINGLED: {},
                LTELED: {},
                WifiLED: {},
            },
            PSENSOR: {},
            VoiceGuidance: {
                STARTVOICE: {},
                NORMALSTARTVOICE: {},
                EVENTSTARTVOICE: {},
                CHANGERECORDMODEVOICE: {},
                ENDVOICE: {},
                SPEEDALERTVOICE: {},
                PARKINGEVENTVOICE: {},
                CLOUDVOICE: {},
                CHANGECONFIGVOICE: {},
                SHARPTURNVOICE: {},
                HARSHBRAKINGVOICE: {},
                ACCELERATIONVOICE: {},
            },
            VOLUME: {},
            ScheduledReboot: {},
            SpeedAlert: {},
            BatteryProtection: {},
            UserTextOverlay: {},
        },
        Wifi: {
            LoginCredentials: {},
            WifiSleepMode: {},
        },
        Cloud: { CloudService: {}, sta1: {}, sta2: {}, sta3: {} },
        FirmwareLanguage: [
            "English",
            "Japan",
            "China",
            "German",
            "French",
            "Thai",
            "Idn",
            "Vietnam",
            "Spain",
            "Italian",
            "Dutch",
            "Polish",
            "Norwegian",
            "Finnish",
        ],
    },
    1.008: {
        System: {
            EventRev: {},
        },
    },
    1.009: {
        System: {
            Seamless: {},
        },
    },
};

var DR750X_2CH = {
    default: {
        Time: {
            GpsSync: {},
            TimeSet: {},
        },
        Video: {
            ImageSetting: {
                options: [{ key: "0", value: "FHD @60 + FHD @30" }],
            },
            VideoQuality: {
                options: [
                    { key: "0", value: "Highest(Extreme)" },
                    { key: "1", value: "Highest" },
                    { key: "2", value: "High" },
                    { key: "3", value: "Normal" },
                ],
            },
            NightVision: {
                options: [
                    { key: "1", value: "Always" },
                    { key: "2", value: "Parking mode only" },
                ],
            },
            FrontBrightness: {},
            RearBrightness: {},
        },
        Recording: {
            NormalRecord: {},
            AutoParking: {},
            RearParkingMode: {
                explain: "ON: front and_",
            },
            VoiceRecord: {},
            DateDisplay: {},
            SpeedUnit: {},
            UseGpsInfo: {},
            RecordTime: {
                options: [
                    {
                        key: "1",
                        value: "1 min",
                    },
                ],
            },
            LockEvent: {},
            FrontRotate: {},
            RearRotate: {
                options: [
                    {
                        key: "0",
                        value: "Default",
                    },
                    {
                        key: "1",
                        value: "Rotate video 180°",
                    },
                    {
                        key: "2",
                        value: "Mirror video",
                    },
                ],
            },
        },
        Gsensor: {
            Normal: {},
            Parking: {},
        },
        MotionDetection: {
            MOTIONSENSOR: {},
        },
        System: {
            LED: {
                RECLED: {},
                NORMALLED: {},
                PARKINGLED: {},
                RearLED: {},
                LTELED: {},
                WifiLED: {},
            },
            PSENSOR: {},
            VoiceGuidance: {
                STARTVOICE: {},
                NORMALSTARTVOICE: {},
                EVENTSTARTVOICE: {},
                CHANGERECORDMODEVOICE: {},
                ENDVOICE: {},
                SPEEDALERTVOICE: {},
                PARKINGEVENTVOICE: {},
                CLOUDVOICE: {},
                CHANGECONFIGVOICE: {},
                SHARPTURNVOICE: {},
                HARSHBRAKINGVOICE: {},
                ACCELERATIONVOICE: {},
            },
            VOLUME: {},
            ScheduledReboot: {},
            SpeedAlert: {},
            BatteryProtection: {},
            UserTextOverlay: {},
        },
        Wifi: {
            LoginCredentials: {},
            WifiSleepMode: {},
        },
        Cloud: { CloudService: {}, sta1: {}, sta2: {}, sta3: {} },
        FirmwareLanguage: [
            "English",
            "Japan",
            "China",
            "German",
            "French",
            "Thai",
            "Idn",
            "Vietnam",
            "Spain",
            "Italian",
            "Dutch",
            "Polish",
            "Norwegian",
            "Finnish",
            "Arabic", // 문서에 언어목록 나와있지 않음
        ],
    },
    1.008: {
        System: {
            EventRev: {},
        },
    },
    1.009: {
        System: {
            Seamless: {},
        },
    },
};

var DR900X_1CH = {
    default: {
        Time: {
            GpsSync: {},
            TimeSet: {},
        },
        Video: {
            ImageSetting: {
                options: [{ key: "0", value: "4K UHD @30" }],
            },
            VCodecType: {},
            VideoQuality: {
                options: [
                    { key: "0", value: "Highest(Extreme)" },
                    { key: "1", value: "Highest" },
                    { key: "2", value: "High" },
                    { key: "3", value: "Normal" },
                ],
            },
            NightVision: {
                options: [
                    { key: "1", value: "Always" },
                    { key: "2", value: "Parking mode only" },
                ],
            },
            FrontBrightness: {},
        },
        Recording: {
            NormalRecord: {},
            AutoParking: {},
            VoiceRecord: {},
            DateDisplay: {},
            SpeedUnit: {},
            UseGpsInfo: {},
            RecordTime: {
                options: [
                    {
                        key: "1",
                        value: "1 min",
                    },
                ],
            },
            LockEvent: {},
            overWriteLock: {},
            FrontRotate: {},
        },
        Gsensor: {
            Normal: {},
            Parking: {},
        },
        MotionDetection: {
            MOTIONSENSOR: {},
        },
        System: {
            LED: {
                RECLED: {},
                NORMALLED: {},
                PARKINGLED: {},
                LTELED: {},
                WifiLED: {},
            },
            PSENSOR: {},
            VoiceGuidance: {
                STARTVOICE: {},
                NORMALSTARTVOICE: {},
                EVENTSTARTVOICE: {},
                CHANGERECORDMODEVOICE: {},
                ENDVOICE: {},
                SPEEDALERTVOICE: {},
                PARKINGEVENTVOICE: {},
                CLOUDVOICE: {},
                CHANGECONFIGVOICE: {},
                SHARPTURNVOICE: {},
                HARSHBRAKINGVOICE: {},
                ACCELERATIONVOICE: {},
            },
            VOLUME: {},
            ScheduledReboot: {},
            SpeedAlert: {},
            BatteryProtection: {},
            UserTextOverlay: {},
        },
        Wifi: {
            LoginCredentials: {},
            WifiBand: {},
            WifiSleepMode: {},
        },
        Cloud: { CloudService: {}, sta1: {}, sta2: {}, sta3: {} },
        FirmwareLanguage: [
            "English",
            "Japan",
            "China",
            "German",
            "French",
            "Thai",
            "Idn",
            "Vietnam",
            "Spain",
            "Italian",
            "Dutch",
            "Polish",
            "Norwegian",
            "Finnish",
            "Arabic",
        ],
    },
    1.008: {
        System: {
            EventRev: {},
        },
    },
    1.01: {
        System: {
            Seamless: {},
        },
    },
};

var DR750G_1CH_PRO = {
    default: {
        Time: {
            GpsSync: {},
            TimeSet: {},
        },
        Video: {
            ImageSetting: {
                options: [{ key: "0", value: "2K QHD@30fps" }],
            },
            VideoQuality: {
                options: [
                    { key: "0", value: "Highest(Extreme)" },
                    { key: "1", value: "Highest" },
                    { key: "2", value: "High" },
                    { key: "3", value: "Normal" },
                ],
            },
            NightVision: {
                options: [
                    { key: "1", value: "Always" },
                    { key: "2", value: "Parking mode only" },
                ],
            },
            FrontBrightness: {},
        },
        Recording: {
            NormalRecord: {},
            AutoParking: {},
            VoiceRecord: {},
            DateDisplay: {},
            SpeedUnit: {},
            UseGpsInfo: {},
            RecordTime: {
                options: [
                    {
                        key: "1",
                        value: "1 min",
                    },
                ],
            },
            LockEvent: {},
            FrontRotate: {},
        },
        Gsensor: {
            Normal: {},
            Parking: {},
        },
        MotionDetection: {
            MOTIONSENSOR: {},
        },
        System: {
            LED: {
                RECLED: {},
                NORMALLED: {},
                PARKINGLED: {},
                WifiLED: {},
                LTELED: {}, //문서에는 있는데 값이 안 넘어와짐 (대신에 RearLED가 넘어와짐 문서에는 없음)
            },
            PSENSOR: {},
            VoiceGuidance: {
                STARTVOICE: {},
                NORMALSTARTVOICE: {},
                EVENTSTARTVOICE: {},
                CHANGERECORDMODEVOICE: {},
                ENDVOICE: {},
                SPEEDALERTVOICE: {},
                PARKINGEVENTVOICE: {},
                CLOUDVOICE: {},
                CHANGECONFIGVOICE: {},
                SHARPTURNVOICE: {},
                HARSHBRAKINGVOICE: {},
                ACCELERATIONVOICE: {},
            },
            VOLUME: {},
            ScheduledReboot: {},
            SpeedAlert: {},
            ADAS: {},
            BatteryProtection: {},
            UserTextOverlay: {},
        },
        Wifi: {
            LoginCredentials: {},
            WifiSleepMode: {},
        },
        Cloud: { CloudService: {}, sta1: {}, sta2: {}, sta3: {} },
        FirmwareLanguage: ["English"],
    },
    1.004: {
        System: {
            EventRev: {},
        },
    },
    1.005: {
        System: {
            Seamless: {},
        },
    },
};

var DR750G_2CH_PRO = {
    default: {
        Time: {
            GpsSync: {},
            TimeSet: {},
        },
        Video: {
            ImageSetting: {
                options: [{ key: "0", value: "2K QHD@30fps + FHD@30fps" }],
            },
            VideoQuality: {
                options: [
                    { key: "0", value: "Highest(Extreme)" },
                    { key: "1", value: "Highest" },
                    { key: "2", value: "High" },
                    { key: "3", value: "Normal" },
                ],
            },
            NightVision: {
                options: [
                    { key: "1", value: "Always" },
                    { key: "2", value: "Parking mode only" },
                ],
            },
            FrontBrightness: {},
            RearBrightness: {},
        },
        Recording: {
            NormalRecord: {},
            AutoParking: {},
            RearParkingMode: {
                explain: "ON: front and_",
            },
            UseGpsInfo: {},
            VoiceRecord: {},
            DateDisplay: {},
            SpeedUnit: {},
            RecordTime: {
                options: [
                    {
                        key: "1",
                        value: "1 min",
                    },
                ],
            },
            LockEvent: {},
            FrontRotate: {},
            RearRotate: {
                options: [
                    {
                        key: "0",
                        value: "Default",
                    },
                    {
                        key: "1",
                        value: "Rotate video 180°",
                    },
                    {
                        key: "2",
                        value: "Mirror video",
                    },
                ],
            },
        },
        Gsensor: {
            Normal: {},
            Parking: {},
        },
        MotionDetection: {
            MOTIONSENSOR: {},
        },
        System: {
            LED: {
                RECLED: {},
                NORMALLED: {},
                PARKINGLED: {},
                RearLED: {},
                LTELED: {},
                WifiLED: {},
            },
            PSENSOR: {},
            VoiceGuidance: {
                STARTVOICE: {},
                NORMALSTARTVOICE: {},
                EVENTSTARTVOICE: {},
                CHANGERECORDMODEVOICE: {},
                ENDVOICE: {},
                SPEEDALERTVOICE: {},
                PARKINGEVENTVOICE: {},
                CLOUDVOICE: {},
                CHANGECONFIGVOICE: {},
                SHARPTURNVOICE: {},
                HARSHBRAKINGVOICE: {},
                ACCELERATIONVOICE: {},
            },
            VOLUME: {},
            ScheduledReboot: {},
            SpeedAlert: {},
            ADAS: {},
            BatteryProtection: {},
            UserTextOverlay: {},
        },
        Wifi: {
            LoginCredentials: {},
            WifiSleepMode: {},
        },
        Cloud: { CloudService: {}, sta1: {}, sta2: {}, sta3: {} },
        FirmwareLanguage: ["English"],
    },
    1.004: {
        System: {
            EventRev: {},
        },
    },
    1.005: {
        System: {
            Seamless: {},
        },
    },
};

var DR750X_Plus = {
    default: {
        Time: {
            GpsSync: {},
            TimeSet: {},
        },
        Video: {
            ImageSetting: {
                options: [{ key: "0", value: "FHD@60 + FHD@30" }],
            },
            VideoQuality: {
                options: [
                    { key: "0", value: "Highest(Extreme)" },
                    { key: "1", value: "Highest" },
                    { key: "2", value: "High" },
                    { key: "3", value: "Normal" },
                ],
            },
            NightVision: {
                options: [
                    { key: "1", value: "Always" },
                    { key: "2", value: "Parking mode only" },
                ],
            },
            FrontBrightness: {},
            RearBrightness: {},
        },
        Recording: {
            NormalRecord: {},
            AutoParking: {},
            RearParkingMode: {
                explain: "ON: front and_",
            },
            VoiceRecord: {},
            DateDisplay: {},
            SpeedUnit: {},
            UseGpsInfo: {},
            RecordTime: {
                options: [
                    {
                        key: "1",
                        value: "1 min",
                    },
                ],
            },
            LockEvent: {},
            FrontRotate: {},
            RearRotate: {
                options: [
                    {
                        key: "0",
                        value: "Default",
                    },
                    {
                        key: "1",
                        value: "Rotate video 180°",
                    },
                    {
                        key: "2",
                        value: "Mirror video",
                    },
                ],
            },
        },
        Gsensor: {
            Normal: {},
            Parking: {},
        },
        MotionDetection: {
            MOTIONSENSOR: {},
        },
        System: {
            LED: {
                RECLED: {},
                NORMALLED: {},
                PARKINGLED: {},
                RearLED: {},
                WifiLED: {},
                LTELED: {},
            },
            PSENSOR: {},
            VoiceGuidance: {
                STARTVOICE: {},
                NORMALSTARTVOICE: {},
                EVENTSTARTVOICE: {},
                CHANGERECORDMODEVOICE: {},
                ENDVOICE: {},
                SPEEDALERTVOICE: {},
                PARKINGEVENTVOICE: {},
                CLOUDVOICE: {},
                CHANGECONFIGVOICE: {},
                SHARPTURNVOICE: {},
                HARSHBRAKINGVOICE: {},
                ACCELERATIONVOICE: {},
            },
            VOLUME: {},
            ScheduledReboot: {},
            SpeedAlert: {},
            BatteryProtection: {},
            LowvoltageVolt: {},
            LowvoltageTime: {},
            UserTextOverlay: {},
        },
        Wifi: {
            LoginCredentials: {},
            WifiSleepMode: {},
        },
        Cloud: { CloudService: {}, sta1: {}, sta2: {}, sta3: {} },
        FirmwareLanguage: [
            "English",
            "Japan",
            "China",
            "German",
            "French",
            "Thai",
            "Idn",
            "Vietnam",
            "Spain",
            "Italian",
            "Dutch",
            "Polish",
            "Norwegian",
            "Finnish",
            "Arabic",
            "Korea",
        ],
    },
    1.003: {
        Video: {
            NightVision: undefined,
            FrontBrightness: undefined,
            RearBrightness: undefined,
        },
        System: {
            LED: {
                RECLED: {},
                NORMALLED: {},
                PARKINGLED: {},
                RearLED: {},
                WifiLED: {},
                LTELED: {},
                BTLED: {},
            },
            BatteryProtection: undefined,
            BatteryProtectionRev: {
                minVolt: 11.8,
                maxVolt: 12.5,
                defaultVolt: 12,
                minVoltHeavy: 22.8,
                maxVoltHeavy: 24,
                defaultVoltHeavy: 23.2,
                defaultTime: "1200",
                minTime: "100",
                maxTime: "4800",
                // Rev버전으로 업데이트 직후 기존 설정값은 0~3으로 저장되어 있는데,
                // 이것을 Rev용 값으로 변경해주는 테이블
                LowvoltageVolt: {
                    "1": "1180",
                    "2": "1200",
                    "3": "1250",
                },
                LowvoltageVoltHeavy: {
                    "1": "2280",
                    "2": "2320",
                    "3": "2400",
                },
            },
            EventRev: {},
        },
    },
    1.006: {
        System: {
            Seamless: {},
        },
    },
    1.008: {
        DMS: {},
    },
    1.01: {
        System: {
            EventRev: undefined,
            EventRev2: {},
        },
    },
    1.011: {
        CloudNative: {},
    },
    1.013: {
        CloudNative3: {},
        CloudNative4: {},
    },
};

var DR900X_Plus = {
    default: {
        Time: {
            GpsSync: {},
            TimeSet: {},
        },
        Video: {
            ImageSetting: {
                options: [{ key: "0", value: "4K UHD@30 + FHD@30" }],
            },
            VideoQuality: {
                options: [
                    { key: "0", value: "Highest(Extreme)" },
                    { key: "1", value: "Highest" },
                    { key: "2", value: "High" },
                    { key: "3", value: "Normal" },
                ],
            },
        },
        Recording: {
            NormalRecord: {},
            AutoParking: {},
            RearParkingMode: {
                explain: "ON: front and_",
            },
            VoiceRecord: {},
            DateDisplay: {},
            SpeedUnit: {},
            UseGpsInfo: {},
            RecordTime: {
                options: [
                    {
                        key: "1",
                        value: "1 min",
                    },
                ],
            },
            LockEvent: {},
            overWriteLock: {},
            FrontRotate: {},
            RearRotate: {
                options: [
                    {
                        key: "0",
                        value: "Default",
                    },
                    {
                        key: "1",
                        value: "Rotate video 180°",
                    },
                    {
                        key: "2",
                        value: "Mirror video",
                    },
                ],
            },
        },
        Gsensor: {
            Normal: {},
            Parking: {},
        },
        MotionDetection: {
            MOTIONSENSOR: {},
        },
        System: {
            LED: {
                RECLED: {},
                NORMALLED: {},
                PARKINGLED: {},
                RearLED: {},
                WifiLED: {},
                LTELED: {},
                BTLED: {},
            },
            PSENSOR: {},
            VoiceGuidance: {
                STARTVOICE: {},
                NORMALSTARTVOICE: {},
                EVENTSTARTVOICE: {},
                CHANGERECORDMODEVOICE: {},
                ENDVOICE: {},
                SPEEDALERTVOICE: {},
                SHARPTURNVOICE: {},
                HARSHBRAKINGVOICE: {},
                ACCELERATIONVOICE: {},
                CHANGECONFIGVOICE: {},
                CLOUDVOICE: {},
                PARKINGEVENTVOICE: {},
            },
            VOLUME: {},
            ScheduledReboot: {},
            SpeedAlert: {},
            BatteryProtectionRev: {
                minVolt: 11.8,
                maxVolt: 12.5,
                defaultVolt: 12,
                minVoltHeavy: 22.8,
                maxVoltHeavy: 24,
                defaultVoltHeavy: 23.2,
                defaultTime: "1200",
                minTime: "100",
                maxTime: "4800",
                LowvoltageVolt: {
                    "1": "1180",
                    "2": "1200",
                    "3": "1250",
                },
                LowvoltageVoltHeavy: {
                    "1": "2280",
                    "2": "2320",
                    "3": "2400",
                },
            },
            EventRev: {},
            UserTextOverlay: {},
        },
        Wifi: {
            LoginCredentials: {},
            WifiBand: {},
            WifiSleepMode: {},
        },
        Cloud: { CloudService: {}, sta1: {}, sta2: {}, sta3: {} },
        FirmwareLanguage: [
            "English",
            "Japan",
            "Spain",
            "French",
            "Italian",
            "German",
            "China",
            "Dutch",
            "Thai",
            "Idn",
            "Vietnam",
            "Polish",
            "Norwegian",
            "Finnish",
            "Arabic",
            "Korea",
        ],
    },
    1.003: {
        System: {
            Seamless: {},
        },
    },
    1.006: {
        DMS: {},
    },
    1.008: {
        System: {
            EventRev: undefined,
            EventRev2: {},
        },
    },
    1.009: {
        CloudNative: {},
    },
    1.011: {
        CloudNative3: {},
        CloudNative4: {},
    },
};

var DR750G_PRO = {
    default: {
        Time: {
            GpsSync: {},
            TimeSet: {},
        },
        Video: {
            ImageSetting: {
                options: [{ key: "0", value: "2K QHD@30fps + FHD@30fps" }],
            },
            VideoQuality: {
                options: [
                    { key: "0", value: "Highest(Extreme)" },
                    { key: "1", value: "Highest" },
                    { key: "2", value: "High" },
                    { key: "3", value: "Normal" },
                ],
            },
            NightVision: {
                options: [
                    { key: "1", value: "Always" },
                    { key: "2", value: "Parking mode only" },
                ],
            },
            FrontBrightness: {},
            RearBrightness: {},
        },
        Recording: {
            NormalRecord: {},
            AutoParking: {},
            RearParkingMode: {
                explain: "ON: front and_",
            },
            UseGpsInfo: {},
            VoiceRecord: {},
            DateDisplay: {},
            SpeedUnit: {},
            RecordTime: {
                options: [
                    {
                        key: "1",
                        value: "1 min",
                    },
                ],
            },
            LockEvent: {},
            FrontRotate: {},
            RearRotate: {
                options: [
                    {
                        key: "0",
                        value: "Default",
                    },
                    {
                        key: "1",
                        value: "Rotate video 180°",
                    },
                    {
                        key: "2",
                        value: "Mirror video",
                    },
                ],
            },
        },
        Gsensor: {
            Normal: {},
            Parking: {},
        },
        MotionDetection: {
            MOTIONSENSOR: {},
        },
        System: {
            LED: {
                RECLED: {},
                NORMALLED: {},
                PARKINGLED: {},
                RearLED: {},
                LTELED: {},
                WifiLED: {},
            },
            PSENSOR: {},
            VoiceGuidance: {
                STARTVOICE: {},
                NORMALSTARTVOICE: {},
                EVENTSTARTVOICE: {},
                CHANGERECORDMODEVOICE: {},
                ENDVOICE: {},
                SPEEDALERTVOICE: {},
                PARKINGEVENTVOICE: {},
                CLOUDVOICE: {},
                CHANGECONFIGVOICE: {},
                SHARPTURNVOICE: {},
                HARSHBRAKINGVOICE: {},
                ACCELERATIONVOICE: {},
            },
            VOLUME: {},
            ScheduledReboot: {},
            SpeedAlert: {},
            ADAS: {},
            BatteryProtection: {},
            UserTextOverlay: {},
        },
        Wifi: {
            LoginCredentials: {},
            WifiSleepMode: {},
        },
        Cloud: { CloudService: {}, sta1: {}, sta2: {}, sta3: {} },
        FirmwareLanguage: ["English"],
    },
    1.004: {
        System: {
            EventRev: {},
        },
    },
    1.005: {
        Video: {
            NightVision: undefined,
            FrontBrightness: undefined,
            RearBrightness: undefined,
        },
        System: {
            LED: {
                RECLED: {},
                NORMALLED: {},
                PARKINGLED: {},
                RearLED: {},
                BTLED: {},
                LTELED: {},
                WifiLED: {},
            },
            BatteryProtection: undefined,
            BatteryProtectionRev: {
                minVolt: 12,
                maxVolt: 12.5,
                defaultVolt: 12,
                minVoltHeavy: 23.2,
                maxVoltHeavy: 24,
                defaultVoltHeavy: 23.2,
                defaultTime: "600",
                minTime: "100",
                maxTime: "4800",
                // Rev버전으로 업데이트 직후 기존 설정값은 0~3으로 저장되어 있는데,
                // 이것을 Rev용 값으로 변경해주는 테이블
                LowvoltageVolt: {
                    "1": "1200",
                    "2": "1220",
                    "3": "1250",
                },
                LowvoltageVoltHeavy: {
                    "1": "2320",
                    "2": "2360",
                    "3": "2400",
                },
            },
            Seamless: {},
        },
    },
    1.007: {
        CloudNative: {},
    },
    1.009: {
        CloudNative3: {},
        CloudNative4: {},
    },
};

var DR750X_3CH_Plus = {
    default: {
        Time: {
            GpsSync: {},
            TimeSet: {},
        },
        Video: {
            ImageSetting: {
                options: [{ key: "0", value: "FHD@60 + FHD@30 + HD@30" }],
            },
            VideoQuality: {
                options: [
                    { key: "0", value: "Highest(Extreme)" },
                    { key: "1", value: "Highest" },
                    { key: "2", value: "High" },
                    { key: "3", value: "Normal" },
                ],
            },
        },
        Recording: {
            NormalRecord: {},
            AutoParking: {},
            RearParkingMode: {
                explain: "ON: front and_",
            },
            InteriorParkingMode: {},
            VoiceRecord: {},
            DateDisplay: {},
            SpeedUnit: {},
            UseGpsInfo: {},
            RecordTime: {
                options: [
                    {
                        key: "1",
                        value: "1 min",
                    },
                ],
            },
            LockEvent: {},
            FrontRotate: {},
            RearRotate: {
                options: [
                    {
                        key: "0",
                        value: "Default",
                    },
                    {
                        key: "1",
                        value: "Rotate video 180°",
                    },
                    {
                        key: "2",
                        value: "Mirror video",
                    },
                ],
            },
            InteriorRotate: {},
        },
        Gsensor: {
            Normal: {},
            Parking: {},
        },
        MotionDetection: {
            MOTIONSENSOR: {},
        },
        System: {
            LED: {
                RECLED: {},
                NORMALLED: {},
                PARKINGLED: {},
                RearLED: {},
                WifiLED: {},
                BTLED: {},
                LTELED: {},
                InteriorLED: {},
            },
            PSENSOR: {},
            VoiceGuidance: {
                STARTVOICE: {},
                NORMALSTARTVOICE: {},
                EVENTSTARTVOICE: {},
                CHANGERECORDMODEVOICE: {},
                ENDVOICE: {},
                SPEEDALERTVOICE: {},
                PARKINGEVENTVOICE: {},
                CLOUDVOICE: {},
                CHANGECONFIGVOICE: {},
                SHARPTURNVOICE: {},
                HARSHBRAKINGVOICE: {},
                ACCELERATIONVOICE: {},
            },
            VOLUME: {},
            ScheduledReboot: {},
            SpeedAlert: {},
            BatteryProtectionRev: {
                minVolt: 11.8,
                maxVolt: 12.5,
                defaultVolt: 11.8,
                minVoltHeavy: 22.8,
                maxVoltHeavy: 24,
                defaultVoltHeavy: 22.8,
                defaultTime: "1200",
                minTime: "100",
                maxTime: "4800",
                // Rev버전으로 업데이트 직후 기존 설정값은 0~3으로 저장되어 있는데,
                // 이것을 Rev용 값으로 변경해주는 테이블
                LowvoltageVolt: {
                    "1": "1180",
                    "2": "1200",
                    "3": "1250",
                },
                LowvoltageVoltHeavy: {
                    "1": "2280",
                    "2": "2320",
                    "3": "2400",
                },
            },
            DMS: {},
            UserTextOverlay: {},
            EventRev: {},
        },
        Wifi: {
            LoginCredentials: {},
            WifiSleepMode: {},
        },
        Cloud: { CloudService: {}, sta1: {}, sta2: {}, sta3: {} },
        FirmwareLanguage: [
            "English",
            "Japan",
            "China",
            "German",
            "French",
            "Thai",
            "Idn",
            "Vietnam",
            "Spain",
            "Italian",
            "Dutch",
            "Polish",
            "Norwegian",
            "Finnish",
            "Arabic",
            "Korea",
        ],
    },
    1.001: {
        System: {
            BatteryProtectionRev: {
                minVolt: 11.8,
                maxVolt: 12.5,
                defaultVolt: 12.0,
                minVoltHeavy: 22.8,
                maxVoltHeavy: 24,
                defaultVoltHeavy: 23.2,
                defaultTime: "1200",
                minTime: "100",
                maxTime: "4800",
                // Rev버전으로 업데이트 직후 기존 설정값은 0~3으로 저장되어 있는데,
                // 이것을 Rev용 값으로 변경해주는 테이블
                LowvoltageVolt: {
                    "1": "1180",
                    "2": "1200",
                    "3": "1250",
                },
                LowvoltageVoltHeavy: {
                    "1": "2280",
                    "2": "2320",
                    "3": "2400",
                },
            },
        },
    },
    1.003: {
        System: {
            Seamless: {},
        },
    },
    1.005: {
        CloudNative: {},
    },
};

var DR750X_LTE_Plus = {
    default: {
        Time: {
            GpsSync: {},
            TimeSet: {},
        },
        Video: {
            ImageSetting: {
                options: [{ key: "0", value: "FHD@60 + FHD@30" }],
            },
            VideoQuality: {
                options: [
                    { key: "0", value: "Highest(Extreme)" },
                    { key: "1", value: "Highest" },
                    { key: "2", value: "High" },
                    { key: "3", value: "Normal" },
                ],
            },
        },
        Recording: {
            NormalRecord: {},
            AutoParking: {},
            RearParkingMode: {
                explain: "ON: front and_",
            },
            VoiceRecord: {},
            DateDisplay: {},
            SpeedUnit: {},
            UseGpsInfo: {},
            RecordTime: {
                options: [
                    {
                        key: "1",
                        value: "1 min",
                    },
                ],
            },
            LockEvent: {},
            FrontRotate: {},
            RearRotate: {
                options: [
                    {
                        key: "0",
                        value: "Default",
                    },
                    {
                        key: "1",
                        value: "Rotate video 180°",
                    },
                    {
                        key: "2",
                        value: "Mirror video",
                    },
                ],
            },
        },
        Gsensor: {
            Normal: {},
            Parking: {},
        },
        MotionDetection: {
            MOTIONSENSOR: {},
        },
        System: {
            LED: {
                RECLED: {},
                NORMALLED: {},
                PARKINGLED: {},
                RearLED: {},
                WifiLED: {},
                BTLED: {},
                LTELED: {},
            },
            PSENSOR: {},
            VoiceGuidance: {
                STARTVOICE: {},
                NORMALSTARTVOICE: {},
                EVENTSTARTVOICE: {},
                CHANGERECORDMODEVOICE: {},
                ENDVOICE: {},
                SPEEDALERTVOICE: {},
                PARKINGEVENTVOICE: {},
                CLOUDVOICE: {},
                CHANGECONFIGVOICE: {},
                SHARPTURNVOICE: {},
                HARSHBRAKINGVOICE: {},
                ACCELERATIONVOICE: {},
            },
            VOLUME: {},
            ScheduledReboot: {},
            SpeedAlert: {},
            EventRev: {},
            UserTextOverlay: {},
        },
        Wifi: {
            LoginCredentials: {},
            WifiSleepMode: {},
            onstart_LTE: {},
        },
        Cloud: { CloudService: {}, sta1: {}, sta2: {}, sta3: {} },
        FirmwareLanguage: [
            "English",
            "Japan",
            "China",
            "German",
            "French",
            "Thai",
            "Idn",
            "Vietnam",
            "Spain",
            "Italian",
            "Dutch",
            "Polish",
            "Norwegian",
            "Finnish",
            "Arabic",
            "Korea",
        ],
    },
    1.003: {
        DMS: {},
        System: {
            Seamless: {},
        },
    },
    1.005: {
        System: {
            EventRev: undefined,
            EventRev2: {},
        },
    },
    1.006: {
        CloudNative: {},
    },
    1.008: {
        CloudNative3: {},
        CloudNative4: {},
    },
};

var DR770X = {
    default: {
        Time: {
            GpsSync: {},
            TimeSet: {},
        },
        Video: {
            ImageSetting: {
                options: [{ key: "0", value: "FHD@60 + FHD@30" }],
            },
            VideoQuality: {
                options: [
                    { key: "0", value: "Highest(Extreme)" },
                    { key: "1", value: "Highest" },
                    { key: "2", value: "High" },
                    { key: "3", value: "Normal" },
                ],
            },
        },
        Recording: {
            NormalRecord: {},
            AutoParking: {},
            RearParkingMode: {
                explain: "ON: front and_",
            },
            VoiceRecord: {},
            DateDisplay: {},
            SpeedUnit: {},
            UseGpsInfo: {},
            RecordTime: {
                options: [
                    {
                        key: "1",
                        value: "1 min",
                    },
                ],
            },
            LockEvent: {},
            FrontRotate: {},
            RearRotate: {
                options: [
                    {
                        key: "0",
                        value: "Default",
                    },
                    {
                        key: "1",
                        value: "Rotate video 180°",
                    },
                    {
                        key: "2",
                        value: "Mirror video",
                    },
                ],
            },
        },
        Gsensor: {
            Normal: {},
            Parking: {},
        },
        MotionDetection: {
            MOTIONSENSOR: {},
        },
        System: {
            LED: {
                RECLED: {},
                NORMALLED: {},
                PARKINGLED: {},
                RearLED: {},
                WifiLED: {},
                BTLED: {},
                LTELED: {},
            },
            PSENSOR: {},
            VoiceGuidance: {
                STARTVOICE: {},
                NORMALSTARTVOICE: {},
                EVENTSTARTVOICE: {},
                CHANGERECORDMODEVOICE: {},
                ENDVOICE: {},
                SPEEDALERTVOICE: {},
                PARKINGEVENTVOICE: {},
                CLOUDVOICE: {},
                CHANGECONFIGVOICE: {},
                SHARPTURNVOICE: {},
                HARSHBRAKINGVOICE: {},
                ACCELERATIONVOICE: {},
            },
            VOLUME: {},
            ScheduledReboot: {},
            SpeedAlert: {},
            BatteryProtectionRev: {
                minVolt: 11.8,
                maxVolt: 12.5,
                defaultVolt: 12,
                minVoltHeavy: 22.8,
                maxVoltHeavy: 24,
                defaultVoltHeavy: 23.2,
                // mantis - 10194, default 값 12:00 (Leehj) 23.01.16
                defaultTime: "1200",
                minTime: "100",
                maxTime: "4800",
                // Rev버전으로 업데이트 직후 기존 설정값은 0~3으로 저장되어 있는데,
                // 이것을 Rev용 값으로 변경해주는 테이블
                LowvoltageVolt: {
                    "1": "1180",
                    "2": "1200",
                    "3": "1250",
                },
                LowvoltageVoltHeavy: {
                    "1": "2280",
                    "2": "2320",
                    "3": "2400",
                },
            },
            UserTextOverlay: {},
            EventRev2: {},
            Seamless: {},
        },
        Wifi: {
            LoginCredentials: {},
        },
        Cloud: { CloudService: {}, sta1: {}, sta2: {}, sta3: {} },
        FirmwareLanguage: [
            "English",
            "Japan",
            "China",
            "German",
            "French",
            "Thai",
            "Idn",
            "Vietnam",
            "Spain",
            "Italian",
            "Dutch",
            "Polish",
            "Norwegian",
            "Finnish",
            "Arabic",
            "Korea",
        ],
        DMS: {},
        CloudNative: {},
        UXUI: {},
        CloudNative3: {},
        CloudNative4: {},
        HDLiveview: {},
    },
};

var BlackVue_7G_PRO = {
    default: {
        Time: {
            GpsSync: {},
            TimeSet: {},
        },
        Video: {
            ImageSetting: {
                options: [{ key: "0", value: "2K QHD@30fps + FHD@30fps" }],
            },
            VideoQuality: {
                options: [
                    { key: "0", value: "Highest(Extreme)" },
                    { key: "1", value: "Highest" },
                    { key: "2", value: "High" },
                    { key: "3", value: "Normal" },
                ],
            },
        },
        Recording: {
            NormalRecord: {},
            AutoParking: {},
            RearParkingMode: {
                explain: "ON: front and_",
            },
            VoiceRecord: {},
            DateDisplay: {},
            SpeedUnit: {},
            UseGpsInfo: {},
            RecordTime: {
                options: [
                    {
                        key: "1",
                        value: "1 min",
                    },
                ],
            },
            LockEvent: {},
            FrontRotate: {},
            RearRotate: {
                options: [
                    {
                        key: "0",
                        value: "Default",
                    },
                    {
                        key: "1",
                        value: "Rotate video 180°",
                    },
                    {
                        key: "2",
                        value: "Mirror video",
                    },
                ],
            },
        },
        Gsensor: {
            Normal: {},
            Parking: {},
        },
        MotionDetection: {
            MOTIONSENSOR: {},
        },
        System: {
            LED: {
                RECLED: {},
                NORMALLED: {},
                PARKINGLED: {},
                RearLED: {},
                WifiLED: {},
                BTLED: {},
                LTELED: {},
            },
            PSENSOR: {},
            VoiceGuidance: {
                STARTVOICE: {},
                NORMALSTARTVOICE: {},
                EVENTSTARTVOICE: {},
                CHANGERECORDMODEVOICE: {},
                ENDVOICE: {},
                SPEEDALERTVOICE: {},
                PARKINGEVENTVOICE: {},
                CLOUDVOICE: {},
                CHANGECONFIGVOICE: {},
                SHARPTURNVOICE: {},
                HARSHBRAKINGVOICE: {},
                ACCELERATIONVOICE: {},
            },
            VOLUME: {},
            ScheduledReboot: {},
            SpeedAlert: {},
            ADAS: {},
            BatteryProtectionRev: {
                minVolt: 11.8,
                maxVolt: 12.5,
                defaultVolt: 12.2,
                minVoltHeavy: 22.8,
                maxVoltHeavy: 24,
                defaultVoltHeavy: 23.2,
                defaultTime: "600",
                minTime: "100",
                maxTime: "4800",
                // Rev버전으로 업데이트 직후 기존 설정값은 0~3으로 저장되어 있는데,
                // 이것을 Rev용 값으로 변경해주는 테이블
                LowvoltageVolt: {
                    "1": "1180",
                    "2": "1200",
                    "3": "1250",
                },
                LowvoltageVoltHeavy: {
                    "1": "2280",
                    "2": "2320",
                    "3": "2400",
                },
            },
            UserTextOverlay: {},
            EventRev: {},
            Seamless: {},
        },
        Wifi: {
            LoginCredentials: {},
        },
        Cloud: { CloudService: {}, sta1: {}, sta2: {}, sta3: {} },
        FirmwareLanguage: ["English"],
        CloudNative: {},
    },
};

var DR970X = {
    default: {
        Time: {
            GpsSync: {},
            TimeSet: {},
        },
        Video: {
            ImageSetting: {
                options: [{ key: "0", value: "4K UHD@30 + FHD@30" }],
            },
            VideoQuality: {
                options: [
                    { key: "0", value: "Highest(Extreme)" },
                    { key: "1", value: "Highest" },
                    { key: "2", value: "High" },
                    { key: "3", value: "Normal" },
                ],
            },
        },
        Recording: {
            NormalRecord: {},
            AutoParking: {},
            RearParkingMode: {
                explain: "ON: front and_",
            },
            VoiceRecord: {},
            DateDisplay: {},
            SpeedUnit: {},
            UseGpsInfo: {},
            RecordTime: {
                options: [
                    {
                        key: "1",
                        value: "1 min",
                    },
                ],
            },
            LockEvent: {},
            FrontRotate: {},
            RearRotate: {
                options: [
                    {
                        key: "0",
                        value: "Default",
                    },
                    {
                        key: "1",
                        value: "Rotate video 180°",
                    },
                    {
                        key: "2",
                        value: "Mirror video",
                    },
                ],
            },
        },
        Gsensor: {
            Normal: {},
            Parking: {},
        },
        MotionDetection: {
            MOTIONSENSOR: {},
        },
        System: {
            LED: {
                RECLED: {},
                NORMALLED: {},
                PARKINGLED: {},
                RearLED: {},
                WifiLED: {},
                BTLED: {},
                LTELED: {},
            },
            PSENSOR: {},
            VoiceGuidance: {
                STARTVOICE: {},
                NORMALSTARTVOICE: {},
                EVENTSTARTVOICE: {},
                CHANGERECORDMODEVOICE: {},
                ENDVOICE: {},
                SPEEDALERTVOICE: {},
                PARKINGEVENTVOICE: {},
                CLOUDVOICE: {},
                CHANGECONFIGVOICE: {},
                SHARPTURNVOICE: {},
                HARSHBRAKINGVOICE: {},
                ACCELERATIONVOICE: {},
            },
            VOLUME: {},
            ScheduledReboot: {},
            SpeedAlert: {},
            BatteryProtectionRev: {
                minVolt: 11.8,
                maxVolt: 12.5,
                defaultVolt: 12,
                minVoltHeavy: 22.8,
                maxVoltHeavy: 24,
                defaultVoltHeavy: 23.2,
                // mantis - 10194, default 값 12:00 (Leehj) 23.01.16
                defaultTime: "1200",
                minTime: "100",
                maxTime: "4800",
                // Rev버전으로 업데이트 직후 기존 설정값은 0~3으로 저장되어 있는데,
                // 이것을 Rev용 값으로 변경해주는 테이블
                LowvoltageVolt: {
                    "1": "1180",
                    "2": "1200",
                    "3": "1250",
                },
                LowvoltageVoltHeavy: {
                    "1": "2280",
                    "2": "2320",
                    "3": "2400",
                },
            },
            UserTextOverlay: {},
            EventRev2: {},
            Seamless: {},
        },
        Wifi: {
            LoginCredentials: {},
            WifiBand: {},
        },
        Cloud: { CloudService: {}, sta1: {}, sta2: {}, sta3: {} },
        FirmwareLanguage: [
            "English",
            "Japan",
            "China",
            "German",
            "French",
            "Thai",
            "Idn",
            "Vietnam",
            "Spain",
            "Italian",
            "Dutch",
            "Polish",
            "Norwegian",
            "Finnish",
            "Arabic",
            "Korea",
        ],
        CloudNative: {},
        UXUI: {},
        CloudNative3: {},
        CloudNative4: {},
        HDLiveview: {},
    },
};

var DR790X = {
    default: {
        Time: {
            GpsSync: {},
            TimeSet: {},
        },
        Video: {
            ImageSetting: {
                options: [{ key: "0", value: "FHD@60 + FHD@30" }],
            },
            VideoQuality: {
                options: [
                    { key: "0", value: "Highest(Extreme)" },
                    { key: "1", value: "Highest" },
                    { key: "2", value: "High" },
                    { key: "3", value: "Normal" },
                ],
            },
        },
        Recording: {
            NormalRecord: {},
            AutoParking: {},
            RearParkingMode: {
                explain: "ON: front and_",
            },
            VoiceRecord: {},
            DateDisplay: {},
            SpeedUnit: {},
            UseGpsInfo: {},
            RecordTime: {
                options: [
                    {
                        key: "1",
                        value: "1 min",
                    },
                ],
            },
            LockEvent: {},
            FrontRotate: {},
            RearRotate: {
                options: [
                    {
                        key: "0",
                        value: "Default",
                    },
                    {
                        key: "1",
                        value: "Rotate video 180°",
                    },
                    {
                        key: "2",
                        value: "Mirror video",
                    },
                ],
            },
        },
        Gsensor: {
            Normal: {},
            Parking: {},
        },
        MotionDetection: {
            MOTIONSENSOR: {},
        },
        System: {
            LED: {
                RECLED: {},
                NORMALLED: {},
                PARKINGLED: {},
                RearLED: {},
                WifiLED: {},
                BTLED: {},
                LTELED: {},
            },
            PSENSOR: {},
            VoiceGuidance: {
                STARTVOICE: {},
                NORMALSTARTVOICE: {},
                EVENTSTARTVOICE: {},
                CHANGERECORDMODEVOICE: {},
                ENDVOICE: {},
                SPEEDALERTVOICE: {},
                PARKINGEVENTVOICE: {},
                CLOUDVOICE: {},
                CHANGECONFIGVOICE: {},
                SHARPTURNVOICE: {},
                HARSHBRAKINGVOICE: {},
                ACCELERATIONVOICE: {},
            },
            VOLUME: {},
            ScheduledReboot: {},
            SpeedAlert: {},
            BatteryProtectionRev: {
                minVolt: 11.8,
                maxVolt: 12.5,
                defaultVolt: 12,
                minVoltHeavy: 22.8,
                maxVoltHeavy: 24,
                defaultVoltHeavy: 23.2,
                // mantis - 10194, default 값 12:00 (Leehj) 23.01.16
                defaultTime: "1200",
                minTime: "100",
                maxTime: "4800",
                // Rev버전으로 업데이트 직후 기존 설정값은 0~3으로 저장되어 있는데,
                // 이것을 Rev용 값으로 변경해주는 테이블
                LowvoltageVolt: {
                    "1": "1180",
                    "2": "1200",
                    "3": "1250",
                },
                LowvoltageVoltHeavy: {
                    "1": "2280",
                    "2": "2320",
                    "3": "2400",
                },
            },
            UserTextOverlay: {},
            EventRev2: {},
            Seamless: {},
        },
        Wifi: {
            LoginCredentials: {},
        },
        Cloud: { CloudService: {}, sta1: {}, sta2: {}, sta3: {} },
        FirmwareLanguage: [
            "English",
            "Japan",
            "China",
            "German",
            "French",
            "Thai",
            "Idn",
            "Vietnam",
            "Spain",
            "Italian",
            "Dutch",
            "Polish",
            "Norwegian",
            "Finnish",
            "Arabic",
            "Korea",
        ],
        CloudNative: {},
        UXUI: {},
        CloudNative3: {},
        CloudNative4: {},
        HDLiveview: {},
    },
};

var DR770X_Box = {
    default: {
        Time: {
            GpsSync: {},
            TimeSet: {},
        },
        Video: {
            ImageSetting: {
                // mantis - 10836, 펌웨어 설정표 적용 (Leehj)
                options: [{ key: "0", value: "FHD@60 + FHD@30 + FHD@30" }],
            },
            VideoQuality: {
                options: [
                    { key: "0", value: "Highest(Extreme)" },
                    { key: "1", value: "Highest" },
                    { key: "2", value: "High" },
                    { key: "3", value: "Normal" },
                ],
            },
        },
        Recording: {
            NormalRecord: {},
            AutoParking: {},
            RearParkingMode: {
                explain: "ON: front and_",
            },
            OptionRearParkingMode: {},
            VoiceRecord: {},
            DateDisplay: {},
            SpeedUnit: {},
            UseGpsInfo: {},
            RecordTime: {
                options: [
                    {
                        key: "1",
                        value: "1 min",
                    },
                ],
            },
            LockEvent: {},
            FrontRotate: {},
            RearRotate: {
                options: [
                    {
                        key: "0",
                        value: "Default",
                    },
                    {
                        key: "1",
                        value: "Rotate video 180°",
                    },
                    {
                        key: "2",
                        value: "Mirror video",
                    },
                ],
            },
            // mantis - 8647, checkbox-> selectbox로 변경 options추가
            OptionRearRotate: {
                options: [
                    {
                        key: "0",
                        value: "Default",
                    },
                    {
                        key: "1",
                        value: "Rotate video 180°",
                    },
                    {
                        key: "2",
                        value: "Mirror video",
                    },
                ],
            },
        },
        Gsensor: {
            Normal: {},
            Parking: {},
        },
        MotionDetection: {
            MOTIONSENSOR: {},
        },
        System: {
            LED: {
                RECLED: {},
                NORMALLED: {},
                PARKINGLED: {},
                RearLED: {},
                WifiLED: {},
                BTLED: {},
                LTELED: {},
                OptionRearLED: {},
            },
            PSENSOR: {},
            VoiceGuidance: {
                STARTVOICE: {},
                NORMALSTARTVOICE: {},
                EVENTSTARTVOICE: {},
                CHANGERECORDMODEVOICE: {},
                ENDVOICE: {},
                SPEEDALERTVOICE: {},
                PARKINGEVENTVOICE: {},
                CLOUDVOICE: {},
                CHANGECONFIGVOICE: {},
                SHARPTURNVOICE: {},
                HARSHBRAKINGVOICE: {},
                ACCELERATIONVOICE: {},
            },
            VOLUME: {},
            ScheduledReboot: {},
            SpeedAlert: {},
            BatteryProtectionRev: {
                minVolt: 11.8,
                maxVolt: 12.5,
                defaultVolt: 11.8,
                minVoltHeavy: 22.8,
                maxVoltHeavy: 24,
                defaultVoltHeavy: 22.8,
                // mantis - 10194, default 값 12:00 (Leehj) 23.01.16
                defaultTime: "1200",
                minTime: "100",
                maxTime: "4800",
                // Rev버전으로 업데이트 직후 기존 설정값은 0~3으로 저장되어 있는데,
                // 이것을 Rev용 값으로 변경해주는 테이블
                LowvoltageVolt: {
                    "1": "1180",
                    "2": "1200",
                    "3": "1250",
                },
                LowvoltageVoltHeavy: {
                    "1": "2280",
                    "2": "2320",
                    "3": "2400",
                },
            },
            UserTextOverlay: {},
            EventRev2: {},
            Seamless: {},
        },
        Wifi: {
            LoginCredentials: {},
            WifiSleepMode: {},
        },
        Cloud: { CloudService: {}, sta1: {}, sta2: {}, sta3: {} },
        FirmwareLanguage: [
            "English",
            "Japan",
            "China",
            "German",
            "French",
            "Thai",
            "Idn",
            "Vietnam",
            "Spain",
            "Italian",
            "Dutch",
            "Polish",
            "Norwegian",
            "Finnish",
            "Arabic",
            "Korea",
        ],
        // DMS: {},
        CloudNative: {},
        UXUI: {},
        CloudNative3: {},
        CloudNative4: {},
        HDLiveview: {},
    },
};

var DR770X_2CH_DMS_II = {
    default: {
        Time: {
            GpsSync: {},
            TimeSet: {},
        },
        Video: {
            ImageSetting: {
                options: [{ key: '0', value: 'FHD@60 + FHD@30' }],
            },
            VideoQuality: {
                options: [
                    { key: '0', value: 'Highest(Extreme)' },
                    { key: '1', value: 'Highest' },
                    { key: '2', value: 'High' },
                    { key: '3', value: 'Normal' },
                ],
            },
        },
        Recording: {
            NormalRecord: {},
            AutoParking: {},
            RearParkingMode: {
                explain: 'ON: front and_',
            },
            VoiceRecord: {},
            DateDisplay: {},
            SpeedUnit: {},
            UseGpsInfo: {},
            RecordTime: {
                options: [
                    {
                        key: '1',
                        value: '1 min',
                    },
                ],
            },
            LockEvent: {},
            FrontRotate: {},
            RearRotate: {
                options: [
                    {
                        key: '0',
                        value: 'Default',
                    },
                    {
                        key: '1',
                        value: 'Rotate video 180°',
                    },
                    {
                        key: '2',
                        value: 'Mirror video',
                    },
                ],
            },
        },
        Gsensor: {
            Normal: {},
            Parking: {},
        },
        MotionDetection: {
            MOTIONSENSOR: {},
        },
        System: {
            LED: {
                RECLED: {},
                NORMALLED: {},
                PARKINGLED: {},
                RearLED: {},
                WifiLED: {},
                BTLED: {},
                LTELED: {},
            },
            PSENSOR: {},
            VoiceGuidance: {
                STARTVOICE: {},
                NORMALSTARTVOICE: {},
                EVENTSTARTVOICE: {},
                CHANGERECORDMODEVOICE: {},
                ENDVOICE: {},
                SPEEDALERTVOICE: {},
                PARKINGEVENTVOICE: {},
                CLOUDVOICE: {},
                CHANGECONFIGVOICE: {},
                SHARPTURNVOICE: {},
                HARSHBRAKINGVOICE: {},
                ACCELERATIONVOICE: {},
            },
            VOLUME: {},
            ScheduledReboot: {},
            SpeedAlert: {},
            BatteryProtectionRev: {
                minVolt: 11.8,
                maxVolt: 12.5,
                defaultVolt: 12,
                minVoltHeavy: 22.8,
                maxVoltHeavy: 24,
                defaultVoltHeavy: 23.2,
                // mantis - 10194, default 값 12:00 (Leehj) 23.01.16
                defaultTime: '1200',
                minTime: '100',
                maxTime: '4800',
                // Rev버전으로 업데이트 직후 기존 설정값은 0~3으로 저장되어 있는데,
                // 이것을 Rev용 값으로 변경해주는 테이블
                LowvoltageVolt: {
                    '1': '1180',
                    '2': '1200',
                    '3': '1250',
                },
                LowvoltageVoltHeavy: {
                    '1': '2280',
                    '2': '2320',
                    '3': '2400',
                },
            },
            UserTextOverlay: {},
            EventRev2: {},
            Seamless: {},
            ADAS: {},
        },
        Wifi: {
            LoginCredentials: {},
        },
        Cloud: { CloudService: {}, sta1: {}, sta2: {}, sta3: {} },
        FirmwareLanguage: [
            'English',
            'Idn',
            'China',
            'German',
            'Spain',
            'French',
            'Italian',
            'Japan',
            'Dutch',
            'Norwegian',
            'Polish',
            'Finnish',
            'Thai',
            'Vietnam',
            'Arabic',
            'Korea',
        ],
        DMS: {},
        CloudNative: {},
        UXUI: {},
        CloudNative3: {},
        CloudNative4: {},
        HDLiveview: {},
    },
};

var DR770X_LTE = {
    default: {
        Time: {
            GpsSync: {},
            TimeSet: {},
        },
        Video: {
            ImageSetting: {
                options: [{ key: "0", value: "FHD@60 + FHD@30" }],
            },
            VideoQuality: {
                options: [
                    { key: "0", value: "Highest(Extreme)" },
                    { key: "1", value: "Highest" },
                    { key: "2", value: "High" },
                    { key: "3", value: "Normal" },
                ],
            },
        },
        Recording: {
            NormalRecord: {},
            AutoParking: {},
            RearParkingMode: {
                explain: "ON: front and_",
            },
            VoiceRecord: {},
            DateDisplay: {},
            SpeedUnit: {},
            UseGpsInfo: {},
            RecordTime: {
                options: [
                    {
                        key: "1",
                        value: "1 min",
                    },
                ],
            },
            LockEvent: {},
            FrontRotate: {},
            RearRotate: {
                options: [
                    {
                        key: "0",
                        value: "Default",
                    },
                    {
                        key: "1",
                        value: "Rotate video 180°",
                    },
                    {
                        key: "2",
                        value: "Mirror video",
                    },
                ],
            },
        },
        Gsensor: {
            Normal: {},
            Parking: {},
        },
        MotionDetection: {
            MOTIONSENSOR: {},
        },
        System: {
            LED: {
                RECLED: {},
                NORMALLED: {},
                PARKINGLED: {},
                RearLED: {},
                WifiLED: {},
                BTLED: {},
                LTELED: {},
            },
            PSENSOR: {},
            VoiceGuidance: {
                STARTVOICE: {},
                NORMALSTARTVOICE: {},
                EVENTSTARTVOICE: {},
                CHANGERECORDMODEVOICE: {},
                ENDVOICE: {},
                SPEEDALERTVOICE: {},
                PARKINGEVENTVOICE: {},
                CLOUDVOICE: {},
                CHANGECONFIGVOICE: {},
                SHARPTURNVOICE: {},
                HARSHBRAKINGVOICE: {},
                ACCELERATIONVOICE: {},
            },
            VOLUME: {},
            ScheduledReboot: {},
            SpeedAlert: {},
            BatteryProtectionRev: {
                minVolt: 11.8,
                maxVolt: 12.5,
                defaultVolt: 12,
                minVoltHeavy: 22.8,
                maxVoltHeavy: 24,
                defaultVoltHeavy: 23.2,
                // mantis - 10194, default 값 12:00 (Leehj) 23.01.16
                defaultTime: "1200",
                minTime: "100",
                maxTime: "4800",
                // Rev버전으로 업데이트 직후 기존 설정값은 0~3으로 저장되어 있는데,
                // 이것을 Rev용 값으로 변경해주는 테이블
                LowvoltageVolt: {
                    "1": "1180",
                    "2": "1200",
                    "3": "1250",
                },
                LowvoltageVoltHeavy: {
                    "1": "2280",
                    "2": "2320",
                    "3": "2400",
                },
            },
            UserTextOverlay: {},
            EventRev2: {},
            Seamless: {},
        },
        Wifi: {
            LoginCredentials: {},
            // mantis - 8816, LTE항목 추가(Leehj)
            onstart_LTE: {},
        },
        Cloud: { CloudService: {}, sta1: {}, sta2: {}, sta3: {} },
        FirmwareLanguage: [
            "English",
            "Japan",
            "China",
            "German",
            "French",
            "Thai",
            "Idn",
            "Vietnam",
            "Spain",
            "Italian",
            "Dutch",
            "Polish",
            "Norwegian",
            "Finnish",
            "Arabic",
            "Korea",
        ],
        CloudNative: {},
        UXUI: {},
        CloudNative3: {},
        CloudNative4: {},
        HDLiveview: {},
    },
};

var DR770X_Box_Pro = {
    default: {
        Time: {
            GpsSync: {},
            TimeSet: {},
        },
        Video: {
            ImageSetting: {
                options: [{ key: "0", value: "FHD@60 + FHD@30 + FHD@30" }],
            },
            VideoQuality: {
                options: [
                    { key: "0", value: "Highest(Extreme)" },
                    { key: "1", value: "Highest" },
                    { key: "2", value: "High" },
                    { key: "3", value: "Normal" },
                ],
            },
        },
        Recording: {
            NormalRecord: {},
            AutoParking: {},
            RearParkingMode: {
                explain: "ON: front and_",
            },
            OptionRearParkingMode: {},
            VoiceRecord: {},
            DateDisplay: {},
            SpeedUnit: {},
            UseGpsInfo: {},
            RecordTime: {
                options: [
                    {
                        key: "1",
                        value: "1 min",
                    },
                ],
            },
            LockEvent: {},
            FrontRotate: {},
            RearRotate: {
                options: [
                    {
                        key: "0",
                        value: "Default",
                    },
                    {
                        key: "1",
                        value: "Rotate video 180°",
                    },
                    {
                        key: "2",
                        value: "Mirror video",
                    },
                ],
            },
            OptionRearRotate: {
                options: [
                    {
                        key: "0",
                        value: "Default",
                    },
                    {
                        key: "1",
                        value: "Rotate video 180°",
                    },
                    {
                        key: "2",
                        value: "Mirror video",
                    },
                ],
            },
        },
        Gsensor: {
            Normal: {},
            Parking: {},
        },
        MotionDetection: {
            MOTIONSENSOR: {},
        },
        System: {
            LED: {
                RECLED: {},
                NORMALLED: {},
                PARKINGLED: {},
                RearLED: {},
                WifiLED: {},
                BTLED: {},
                LTELED: {},
                OptionRearLED: {},
            },
            PSENSOR: {},
            VoiceGuidance: {
                STARTVOICE: {},
                NORMALSTARTVOICE: {},
                EVENTSTARTVOICE: {},
                CHANGERECORDMODEVOICE: {},
                ENDVOICE: {},
                SPEEDALERTVOICE: {},
                PARKINGEVENTVOICE: {},
                CLOUDVOICE: {},
                CHANGECONFIGVOICE: {},
                SHARPTURNVOICE: {},
                HARSHBRAKINGVOICE: {},
                ACCELERATIONVOICE: {},
            },
            VOLUME: {},
            ScheduledReboot: {},
            SpeedAlert: {},
            BatteryProtectionRev: {
                minVolt: 11.8,
                maxVolt: 12.5,
                defaultVolt: 11.8,
                minVoltHeavy: 22.8,
                maxVoltHeavy: 24,
                defaultVoltHeavy: 22.8,
                defaultTime: "1200",
                minTime: "100",
                maxTime: "4800",
                // Rev버전으로 업데이트 직후 기존 설정값은 0~3으로 저장되어 있는데,
                // 이것을 Rev용 값으로 변경해주는 테이블
                LowvoltageVolt: {
                    "1": "1180",
                    "2": "1200",
                    "3": "1250",
                },
                LowvoltageVoltHeavy: {
                    "1": "2280",
                    "2": "2320",
                    "3": "2400",
                },
            },
            UserTextOverlay: {},
            EventRev2: {},
            Seamless: {},
        },
        Wifi: {
            LoginCredentials: {},
            WifiSleepMode: {},
        },
        Cloud: { CloudService: {}, sta1: {}, sta2: {}, sta3: {} },
        FirmwareLanguage: [
            "English",
            "Japan",
            "China",
            "German",
            "French",
            "Thai",
            "Idn",
            "Vietnam",
            "Spain",
            "Italian",
            "Dutch",
            "Polish",
            "Norwegian",
            "Finnish",
            "Arabic",
            "Korea",
        ],
        DMS: {},
        CloudNative: {},
        UXUI: {},
        CloudNative3: {},
        CloudNative4: {},
        HDLiveview: {},
    },
};

var DR790X_LTE = {
    default: {
        Time: {
            GpsSync: {},
            TimeSet: {},
        },
        Video: {
            ImageSetting: {
                options: [{ key: "0", value: "FHD@60 + FHD@30" }],
            },
            VideoQuality: {
                options: [
                    { key: "0", value: "Highest(Extreme)" },
                    { key: "1", value: "Highest" },
                    { key: "2", value: "High" },
                    { key: "3", value: "Normal" },
                ],
            },
        },
        Recording: {
            NormalRecord: {},
            AutoParking: {},
            RearParkingMode: {
                explain: "ON: front and_",
            },
            VoiceRecord: {},
            DateDisplay: {},
            SpeedUnit: {},
            UseGpsInfo: {},
            RecordTime: {
                options: [
                    {
                        key: "1",
                        value: "1 min",
                    },
                ],
            },
            LockEvent: {},
            FrontRotate: {},
            RearRotate: {
                options: [
                    {
                        key: "0",
                        value: "Default",
                    },
                    {
                        key: "1",
                        value: "Rotate video 180°",
                    },
                    {
                        key: "2",
                        value: "Mirror video",
                    },
                ],
            },
        },
        Gsensor: {
            Normal: {},
            Parking: {},
        },
        MotionDetection: {
            MOTIONSENSOR: {},
        },
        System: {
            LED: {
                RECLED: {},
                NORMALLED: {},
                PARKINGLED: {},
                RearLED: {},
                WifiLED: {},
                BTLED: {},
                LTELED: {},
            },
            PSENSOR: {},
            VoiceGuidance: {
                STARTVOICE: {},
                NORMALSTARTVOICE: {},
                EVENTSTARTVOICE: {},
                CHANGERECORDMODEVOICE: {},
                ENDVOICE: {},
                SPEEDALERTVOICE: {},
                PARKINGEVENTVOICE: {},
                CLOUDVOICE: {},
                CHANGECONFIGVOICE: {},
                SHARPTURNVOICE: {},
                HARSHBRAKINGVOICE: {},
                ACCELERATIONVOICE: {},
            },
            VOLUME: {},
            ScheduledReboot: {},
            SpeedAlert: {},
            BatteryProtectionRev: {
                minVolt: 11.8,
                maxVolt: 12.5,
                defaultVolt: 12,
                minVoltHeavy: 22.8,
                maxVoltHeavy: 24,
                defaultVoltHeavy: 23.2,
                // mantis - 10194, default 값 12:00 (Leehj) 23.01.16
                defaultTime: "1200",
                minTime: "100",
                maxTime: "4800",
                // Rev버전으로 업데이트 직후 기존 설정값은 0~3으로 저장되어 있는데,
                // 이것을 Rev용 값으로 변경해주는 테이블
                LowvoltageVolt: {
                    "1": "1180",
                    "2": "1200",
                    "3": "1250",
                },
                LowvoltageVoltHeavy: {
                    "1": "2280",
                    "2": "2320",
                    "3": "2400",
                },
            },
            UserTextOverlay: {},
            EventRev2: {},
            Seamless: {},
        },
        Wifi: {
            LoginCredentials: {},
            // mantis - 8816, LTE항목 추가(Leehj)
            onstart_LTE: {},
        },
        Cloud: { CloudService: {}, sta1: {}, sta2: {}, sta3: {} },
        FirmwareLanguage: [
            "English",
            "Japan",
            "China",
            "German",
            "French",
            "Thai",
            "Idn",
            "Vietnam",
            "Spain",
            "Italian",
            "Dutch",
            "Polish",
            "Norwegian",
            "Finnish",
            "Arabic",
            "Korea",
        ],
        CloudNative: {},
        UXUI: {},
        CloudNative3: {},
        CloudNative4: {},
        HDLiveview: {},
    },
};

var DR970X_LTE = {
    default: {
        Time: {
            GpsSync: {},
            TimeSet: {},
        },
        Video: {
            ImageSetting: {
                options: [{ key: "0", value: "4K UHD@30 + FHD@30" }],
            },
            VideoQuality: {
                options: [
                    { key: "0", value: "Highest(Extreme)" },
                    { key: "1", value: "Highest" },
                    { key: "2", value: "High" },
                    { key: "3", value: "Normal" },
                ],
            },
        },
        Recording: {
            NormalRecord: {},
            AutoParking: {},
            RearParkingMode: {
                explain: "ON: front and_",
            },
            VoiceRecord: {},
            DateDisplay: {},
            SpeedUnit: {},
            UseGpsInfo: {},
            RecordTime: {
                options: [
                    {
                        key: "1",
                        value: "1 min",
                    },
                ],
            },
            LockEvent: {},
            FrontRotate: {},
            RearRotate: {
                options: [
                    {
                        key: "0",
                        value: "Default",
                    },
                    {
                        key: "1",
                        value: "Rotate video 180°",
                    },
                    {
                        key: "2",
                        value: "Mirror video",
                    },
                ],
            },
        },
        Gsensor: {
            Normal: {},
            Parking: {},
        },
        MotionDetection: {
            MOTIONSENSOR: {},
        },
        System: {
            LED: {
                RECLED: {},
                NORMALLED: {},
                PARKINGLED: {},
                RearLED: {},
                WifiLED: {},
                BTLED: {},
                LTELED: {},
            },
            PSENSOR: {},
            VoiceGuidance: {
                STARTVOICE: {},
                NORMALSTARTVOICE: {},
                EVENTSTARTVOICE: {},
                CHANGERECORDMODEVOICE: {},
                ENDVOICE: {},
                SPEEDALERTVOICE: {},
                PARKINGEVENTVOICE: {},
                CLOUDVOICE: {},
                CHANGECONFIGVOICE: {},
                SHARPTURNVOICE: {},
                HARSHBRAKINGVOICE: {},
                ACCELERATIONVOICE: {},
            },
            VOLUME: {},
            ScheduledReboot: {},
            SpeedAlert: {},
            BatteryProtectionRev: {
                minVolt: 11.8,
                maxVolt: 12.5,
                defaultVolt: 12,
                minVoltHeavy: 22.8,
                maxVoltHeavy: 24,
                defaultVoltHeavy: 23.2,
                // mantis - 10194, default 값 12:00 (Leehj) 23.01.16
                defaultTime: "1200",
                minTime: "100",
                maxTime: "4800",
                // Rev버전으로 업데이트 직후 기존 설정값은 0~3으로 저장되어 있는데,
                // 이것을 Rev용 값으로 변경해주는 테이블
                LowvoltageVolt: {
                    "1": "1180",
                    "2": "1200",
                    "3": "1250",
                },
                LowvoltageVoltHeavy: {
                    "1": "2280",
                    "2": "2320",
                    "3": "2400",
                },
            },
            UserTextOverlay: {},
            EventRev2: {},
            Seamless: {},
        },
        Wifi: {
            LoginCredentials: {},
            WifiBand: {},
            // mantis - 8816, LTE항목 추가(Leehj)
            onstart_LTE: {},
        },
        Cloud: { CloudService: {}, sta1: {}, sta2: {}, sta3: {} },
        FirmwareLanguage: [
            "English",
            "Japan",
            "China",
            "German",
            "French",
            "Thai",
            "Idn",
            "Vietnam",
            "Spain",
            "Italian",
            "Dutch",
            "Polish",
            "Norwegian",
            "Finnish",
            "Arabic",
            "Korea",
        ],
        CloudNative: {},
        UXUI: {},
        CloudNative3: {},
        CloudNative4: {},
        HDLiveview: {},
    },
};

var DR800_GOLD = {
    default: {
        Time: {
            GpsSync: {},
            TimeSet: {},
        },
        Video: {
            ImageSetting: {
                options: [{ key: "0", value: "2K QHD@30 + FHD@30" }],
            },
            VideoQuality: {
                options: [
                    { key: "0", value: "Highest(Extreme)" },
                    { key: "1", value: "Highest" },
                    { key: "2", value: "High" },
                    { key: "3", value: "Normal" },
                ],
            },
        },
        Recording: {
            NormalRecord: {},
            AutoParking: {},
            RearParkingMode: {
                explain: "ON: front and_",
            },
            VoiceRecord: {},
            DateDisplay: {},
            SpeedUnit: {},
            UseGpsInfo: {},
            RecordTime: {
                options: [
                    {
                        key: "1",
                        value: "1 min",
                    },
                ],
            },
            LockEvent: {},
            FrontRotate: {},
            RearRotate: {
                options: [
                    {
                        key: "0",
                        value: "Default",
                    },
                    {
                        key: "1",
                        value: "Rotate video 180°",
                    },
                    {
                        key: "2",
                        value: "Mirror video",
                    },
                ],
            },
        },
        Gsensor: {
            Normal: {},
            Parking: {},
        },
        MotionDetection: {
            MOTIONSENSOR: {},
        },
        System: {
            LED: {
                RECLED: {},
                NORMALLED: {},
                PARKINGLED: {},
                RearLED: {},
                WifiLED: {},
                BTLED: {},
                LTELED: {},
            },
            PSENSOR: {},
            VoiceGuidance: {
                STARTVOICE: {},
                NORMALSTARTVOICE: {},
                EVENTSTARTVOICE: {},
                CHANGERECORDMODEVOICE: {},
                ENDVOICE: {},
                SPEEDALERTVOICE: {},
                PARKINGEVENTVOICE: {},
                CLOUDVOICE: {},
                CHANGECONFIGVOICE: {},
                SHARPTURNVOICE: {},
                HARSHBRAKINGVOICE: {},
                ACCELERATIONVOICE: {},
            },
            VOLUME: {},
            ScheduledReboot: {},
            SpeedAlert: {},
            BatteryProtectionRev: {
                minVolt: 11.8,
                maxVolt: 12.5,
                defaultVolt: 12,
                minVoltHeavy: 22.8,
                maxVoltHeavy: 24,
                defaultVoltHeavy: 23.2,
                // mantis - 10194, default 값 12:00 (Leehj) 23.01.16
                defaultTime: "0600",
                minTime: "100",
                maxTime: "4800",
                // Rev버전으로 업데이트 직후 기존 설정값은 0~3으로 저장되어 있는데,
                // 이것을 Rev용 값으로 변경해주는 테이블
                LowvoltageVolt: {
                    "1": "1180",
                    "2": "1200",
                    "3": "1250",
                },
                LowvoltageVoltHeavy: {
                    "1": "2280",
                    "2": "2320",
                    "3": "2400",
                },
            },
            UserTextOverlay: {},
            EventRev2: {},
            Seamless: {},
            ADAS: {},
        },
        Wifi: {
            LoginCredentials: {},
            // mantis - 13612, Wi-Fi band 설정 제거 (Hongcs) 24.04.11
            // WifiBand: {},
        },
        Cloud: { CloudService: {}, sta1: {}, sta2: {}, sta3: {} },
        FirmwareLanguage: ["English"],
        CloudNative: {},
        CloudNative3: {},
        UXUI: {},
        CloudNative4: {},
        HDLiveview: {},
    },
};

var DR800Gold_Pro = {
    default: {
        Time: {
            GpsSync: {},
            TimeSet: {},
        },
        Video: {
            ImageSetting: {
                options: [{ key: "0", value: "2K QHD@30 + FHD@30" }],
            },
            VideoQuality: {
                options: [
                    { key: "0", value: "Highest(Extreme)" },
                    { key: "1", value: "Highest" },
                    { key: "2", value: "High" },
                    { key: "3", value: "Normal" },
                ],
            },
        },
        Recording: {
            NormalRecord: {},
            AutoParking: {},
            RearParkingMode: {
                explain: "ON: front and_",
            },
            VoiceRecord: {},
            DateDisplay: {},
            SpeedUnit: {},
            UseGpsInfo: {},
            RecordTime: {
                options: [
                    {
                        key: "1",
                        value: "1 min",
                    },
                ],
            },
            LockEvent: {},
            FrontRotate: {},
            RearRotate: {
                options: [
                    {
                        key: "0",
                        value: "Default",
                    },
                    {
                        key: "1",
                        value: "Rotate video 180°",
                    },
                    {
                        key: "2",
                        value: "Mirror video",
                    },
                ],
            },
        },
        Gsensor: {
            Normal: {},
            Parking: {},
        },
        MotionDetection: {
            MOTIONSENSOR: {},
        },
        System: {
            LED: {
                RECLED: {},
                NORMALLED: {},
                PARKINGLED: {},
                RearLED: {},
                WifiLED: {},
                BTLED: {},
                LTELED: {},
            },
            PSENSOR: {},
            VoiceGuidance: {
                STARTVOICE: {},
                NORMALSTARTVOICE: {},
                EVENTSTARTVOICE: {},
                CHANGERECORDMODEVOICE: {},
                ENDVOICE: {},
                SPEEDALERTVOICE: {},
                PARKINGEVENTVOICE: {},
                CLOUDVOICE: {},
                CHANGECONFIGVOICE: {},
                SHARPTURNVOICE: {},
                HARSHBRAKINGVOICE: {},
                ACCELERATIONVOICE: {},
            },
            VOLUME: {},
            ScheduledReboot: {},
            SpeedAlert: {},
            BatteryProtectionRev: {
                minVolt: 12,
                maxVolt: 12.5,
                defaultVolt: 12.2,
                minVoltHeavy: 23.2,
                maxVoltHeavy: 24,
                defaultVoltHeavy: 23.6,
                defaultTime: "0600",
                minTime: "100",
                maxTime: "4800",
                // Rev버전으로 업데이트 직후 기존 설정값은 0~3으로 저장되어 있는데,
                // 이것을 Rev용 값으로 변경해주는 테이블
                LowvoltageVolt: {
                    "1": "1180",
                    "2": "1200",
                    "3": "1250",
                },
                LowvoltageVoltHeavy: {
                    "1": "2280",
                    "2": "2320",
                    "3": "2400",
                },
            },
            UserTextOverlay: {},
            EventRev2: {},
            Seamless: {},
            ADAS: {},
        },
        Wifi: {
            LoginCredentials: {},
        },
        Cloud: { CloudService: {}, sta1: {}, sta2: {}, sta3: {} },
        FirmwareLanguage: ["English"],
        CloudNative: {},
        CloudNative3: {},
        UXUI: {},
        CloudNative4: {},
        HDLiveview: {},
    },
};

var DR970X_Plus = {
    default: {
        Time: {
            GpsSync: {},
            TimeSet: {},
        },
        Video: {
            ImageSetting: {
                options: [{ key: "0", value: "4K UHD@30 + FHD@30" }],
            },
            VideoQuality: {
                options: [
                    { key: "0", value: "Highest(Extreme)" },
                    { key: "1", value: "Highest" },
                    { key: "2", value: "High" },
                    { key: "3", value: "Normal" },
                ],
            },
            VCodecType: {},
        },
        Recording: {
            NormalRecord: {},
            AutoParking: {},
            RearParkingMode: {
                explain: "ON: front and_",
            },
            VoiceRecord: {},
            DateDisplay: {},
            SpeedUnit: {},
            UseGpsInfo: {},
            RecordTime: {
                options: [
                    {
                        key: "1",
                        value: "1 min",
                    },
                ],
            },
            LockEvent: {},
            FrontRotate: {},
            RearRotate: {
                options: [
                    {
                        key: "0",
                        value: "Default",
                    },
                    {
                        key: "1",
                        value: "Rotate video 180°",
                    },
                    {
                        key: "2",
                        value: "Mirror video",
                    },
                ],
            },
        },
        Gsensor: {
            Normal: {},
            Parking: {},
        },
        MotionDetection: {
            MOTIONSENSOR: {},
        },
        System: {
            LED: {
                RECLED: {},
                NORMALLED: {},
                PARKINGLED: {},
                RearLED: {},
                WifiLED: {},
                BTLED: {},
                LTELED: {},
            },
            PSENSOR: {},
            VoiceGuidance: {
                STARTVOICE: {},
                NORMALSTARTVOICE: {},
                EVENTSTARTVOICE: {},
                CHANGERECORDMODEVOICE: {},
                ENDVOICE: {},
                SPEEDALERTVOICE: {},
                PARKINGEVENTVOICE: {},
                CLOUDVOICE: {},
                CHANGECONFIGVOICE: {},
                SHARPTURNVOICE: {},
                HARSHBRAKINGVOICE: {},
                ACCELERATIONVOICE: {},
            },
            VOLUME: {},
            ScheduledReboot: {},
            SpeedAlert: {},
            BatteryProtectionRev: {
                minVolt: 11.8,
                maxVolt: 12.5,
                defaultVolt: 12,
                minVoltHeavy: 22.8,
                maxVoltHeavy: 24,
                defaultVoltHeavy: 23.2,
                defaultTime: "1200",
                minTime: "100",
                maxTime: "4800",
                LowvoltageVolt: {
                    "1": "1180",
                    "2": "1200",
                    "3": "1250",
                },
                LowvoltageVoltHeavy: {
                    "1": "2280",
                    "2": "2320",
                    "3": "2400",
                },
            },
            UserTextOverlay: {},
            EventRev2: {},
            Seamless: {},
        },
        Wifi: {
            LoginCredentials: {},
            WifiBand: {},
        },
        Cloud: { CloudService: {}, sta1: {}, sta2: {}, sta3: {} },
        FirmwareLanguage: [
            "English",
            "Japan",
            "Spain",
            "French",
            "Italian",
            "German",
            "China",
            "Dutch",
            "Thai",
            "Idn",
            "Vietnam",
            "Polish",
            "Norwegian",
            "Finnish",
            "Arabic",
            "Korea",
        ],
        CloudNative: {},
        UXUI: {},
        CloudNative3: {},
        CloudNative4: {},
        HDLiveview: {},
    },
};

var DR970X_LTE_Plus = {
    default: {
        Time: {
            GpsSync: {},
            TimeSet: {},
        },
        Video: {
            ImageSetting: {
                options: [{ key: "0", value: "4K UHD@30 + FHD@30" }],
            },
            VideoQuality: {
                options: [
                    { key: "0", value: "Highest(Extreme)" },
                    { key: "1", value: "Highest" },
                    { key: "2", value: "High" },
                    { key: "3", value: "Normal" },
                ],
            },
            VCodecType: {},
        },
        Recording: {
            NormalRecord: {},
            AutoParking: {},
            RearParkingMode: {
                explain: "ON: front and_",
            },
            VoiceRecord: {},
            DateDisplay: {},
            SpeedUnit: {},
            UseGpsInfo: {},
            RecordTime: {
                options: [
                    {
                        key: "1",
                        value: "1 min",
                    },
                ],
            },
            LockEvent: {},
            FrontRotate: {},
            RearRotate: {
                options: [
                    {
                        key: "0",
                        value: "Default",
                    },
                    {
                        key: "1",
                        value: "Rotate video 180°",
                    },
                    {
                        key: "2",
                        value: "Mirror video",
                    },
                ],
            },
        },
        Gsensor: {
            Normal: {},
            Parking: {},
        },
        MotionDetection: {
            MOTIONSENSOR: {},
        },
        System: {
            LED: {
                RECLED: {},
                NORMALLED: {},
                PARKINGLED: {},
                RearLED: {},
                WifiLED: {},
                BTLED: {},
                LTELED: {},
            },
            PSENSOR: {},
            VoiceGuidance: {
                STARTVOICE: {},
                NORMALSTARTVOICE: {},
                EVENTSTARTVOICE: {},
                CHANGERECORDMODEVOICE: {},
                ENDVOICE: {},
                SPEEDALERTVOICE: {},
                PARKINGEVENTVOICE: {},
                CLOUDVOICE: {},
                CHANGECONFIGVOICE: {},
                SHARPTURNVOICE: {},
                HARSHBRAKINGVOICE: {},
                ACCELERATIONVOICE: {},
            },
            VOLUME: {},
            ScheduledReboot: {},
            SpeedAlert: {},
            BatteryProtectionRev: {
                minVolt: 11.8,
                maxVolt: 12.5,
                defaultVolt: 12,
                minVoltHeavy: 22.8,
                maxVoltHeavy: 24,
                defaultVoltHeavy: 23.2,
                defaultTime: "1200",
                minTime: "100",
                maxTime: "4800",
                LowvoltageVolt: {
                    "1": "1180",
                    "2": "1200",
                    "3": "1250",
                },
                LowvoltageVoltHeavy: {
                    "1": "2280",
                    "2": "2320",
                    "3": "2400",
                },
            },
            UserTextOverlay: {},
            EventRev2: {},
            Seamless: {},
        },
        Wifi: {
            LoginCredentials: {},
            WifiBand: {},
            onstart_LTE: {},
        },
        Cloud: { CloudService: {}, sta1: {}, sta2: {}, sta3: {} },
        FirmwareLanguage: [
            "English",
            "Japan",
            "Spain",
            "French",
            "Italian",
            "German",
            "China",
            "Dutch",
            "Thai",
            "Idn",
            "Vietnam",
            "Polish",
            "Norwegian",
            "Finnish",
            "Arabic",
            "Korea",
        ],
        CloudNative: {},
        UXUI: {},
        CloudNative3: {},
        CloudNative4: {},
        HDLiveview: {},
    },
};

var DR970X_Box_Plus = {
    default: {
        Time: {
            GpsSync: {},
            TimeSet: {},
        },
        Video: {
            ImageSetting: {
                options: [{ key: "0", value: "4K UHD@30 + FHD@30" }],
            },
            VideoQuality: {
                options: [
                    { key: "0", value: "Highest(Extreme)" },
                    { key: "1", value: "Highest" },
                    { key: "2", value: "High" },
                    { key: "3", value: "Normal" },
                ],
            },
            VCodecType: {},
        },
        Recording: {
            NormalRecord: {},
            AutoParking: {},
            RearParkingMode: {
                explain: "ON: front and_",
            },
            VoiceRecord: {},
            DateDisplay: {},
            SpeedUnit: {},
            UseGpsInfo: {},
            RecordTime: {
                options: [
                    {
                        key: "1",
                        value: "1 min",
                    },
                ],
            },
            LockEvent: {},
            FrontRotate: {},
            RearRotate: {
                options: [
                    {
                        key: "0",
                        value: "Default",
                    },
                    {
                        key: "1",
                        value: "Rotate video 180°",
                    },
                    {
                        key: "2",
                        value: "Mirror video",
                    },
                ],
            },
            OptionRearRotate: {
                options: [
                    {
                        key: "0",
                        value: "Default",
                    },
                    {
                        key: "1",
                        value: "Rotate video 180°",
                    },
                    {
                        key: "2",
                        value: "Mirror video",
                    },
                ],
            },
        },
        Gsensor: {
            Normal: {},
            Parking: {},
        },
        MotionDetection: {
            MOTIONSENSOR: {},
        },
        System: {
            LED: {
                RECLED: {},
                NORMALLED: {},
                PARKINGLED: {},
                RearLED: {},
                WifiLED: {},
                BTLED: {},
                LTELED: {},
            },
            PSENSOR: {},
            VoiceGuidance: {
                STARTVOICE: {},
                NORMALSTARTVOICE: {},
                EVENTSTARTVOICE: {},
                CHANGERECORDMODEVOICE: {},
                ENDVOICE: {},
                SPEEDALERTVOICE: {},
                PARKINGEVENTVOICE: {},
                CLOUDVOICE: {},
                CHANGECONFIGVOICE: {},
                SHARPTURNVOICE: {},
                HARSHBRAKINGVOICE: {},
                ACCELERATIONVOICE: {},
            },
            VOLUME: {},
            ScheduledReboot: {},
            SpeedAlert: {},
            BatteryProtectionRev: {
                minVolt: 11.8,
                maxVolt: 12.5,
                defaultVolt: 12,
                minVoltHeavy: 22.8,
                maxVoltHeavy: 24,
                defaultVoltHeavy: 23.2,
                defaultTime: "1200",
                minTime: "100",
                maxTime: "4800",
                LowvoltageVolt: {
                    "1": "1180",
                    "2": "1200",
                    "3": "1250",
                },
                LowvoltageVoltHeavy: {
                    "1": "2280",
                    "2": "2320",
                    "3": "2400",
                },
            },
            UserTextOverlay: {},
            EventRev2: {},
            Seamless: {},
        },
        Wifi: {
            LoginCredentials: {},
            WifiBand: {},
        },
        Cloud: { CloudService: {}, sta1: {}, sta2: {}, sta3: {} },
        FirmwareLanguage: [
            "English",
            "Japan",
            "Spain",
            "French",
            "Italian",
            "German",
            "China",
            "Dutch",
            "Thai",
            "Idn",
            "Vietnam",
            "Polish",
            "Norwegian",
            "Finnish",
            "Arabic",
            "Korea",
        ],
        CloudNative: {},
        UXUI: {},
        CloudNative3: {},
        CloudNative4: {},
        HDLiveview: {},
    },
};

var DR590X_1CH_Plus = {
    default: {
        Time: {
            GpsSync: {},
            TimeSet: {},
        },
        Video: {
            ImageSetting: {
                options: [{ key: "0", value: "FHD @60" }],
            },
            VideoQuality: {
                options: [
                    { key: "0", value: "Highest(Extreme)" },
                    { key: "1", value: "Highest" },
                    { key: "2", value: "High" },
                    { key: "3", value: "Normal" },
                ],
            },
            NightVision: {
                options: [
                    { key: "1", value: "Always" },
                    { key: "2", value: "Parking mode only" },
                ],
            },
            FrontBrightness: {},
        },
        Recording: {
            NormalRecord: {},
            AutoParking: {},
            VoiceRecord: {},
            DateDisplay: {},
            SpeedUnit: {},
            UseGpsInfo: {},
            RecordTime: {
                options: [
                    {
                        key: "1",
                        value: "1 min",
                    },
                ],
            },
            LockEvent: {},
            FrontRotate: {},
        },
        Gsensor: {
            Normal: {},
            Parking: {},
        },
        MotionDetection: {
            MOTIONSENSOR: {},
        },
        System: {
            LED: {
                RECLED: {},
                NORMALLED: {},
                PARKINGLED: {},
                WifiLED: {},
            },
            PSENSOR: {},
            VoiceGuidance: {
                STARTVOICE: {},
                NORMALSTARTVOICE: {},
                EVENTSTARTVOICE: {},
                CHANGERECORDMODEVOICE: {},
                ENDVOICE: {},
                SPEEDALERTVOICE: {},
                PARKINGEVENTVOICE: {},
                // CLOUDVOICE: {},
                CHANGECONFIGVOICE: {},
                SHARPTURNVOICE: {},
                HARSHBRAKINGVOICE: {},
                ACCELERATIONVOICE: {},
            },
            VOLUME: {},
            ScheduledReboot: {},
            SpeedAlert: {},
            BatteryProtection: {},
            UserTextOverlay: {},
        },
        Wifi: {
            LoginCredentials: {},
            WifiSleepMode: {},
        },
        // Cloud: { CloudService: {}, sta1: {}, sta2: {}, sta3: {} },
        FirmwareLanguage: [
            "English",
            "Japan",
            "China",
            "German",
            "French",
            "Thai",
            "Idn",
            "Vietnam",
            "Spain",
            "Italian",
            "Dutch",
            "Polish",
            "Norwegian",
            "Finnish",
            "Arabic",
        ],
    },
};

var DR590X_2CH_Plus = {
    default: {
        Time: {
            GpsSync: {},
            TimeSet: {},
        },
        Video: {
            ImageSetting: {
                options: [{ key: "0", value: "FHD @60" }],
            },
            VideoQuality: {
                options: [
                    { key: "0", value: "Highest(Extreme)" },
                    { key: "1", value: "Highest" },
                    { key: "2", value: "High" },
                    { key: "3", value: "Normal" },
                ],
            },
            NightVision: {
                options: [
                    { key: "1", value: "Always" },
                    { key: "2", value: "Parking mode only" },
                ],
            },
            FrontBrightness: {},
        },
        Recording: {
            NormalRecord: {},
            AutoParking: {},
            VoiceRecord: {},
            DateDisplay: {},
            SpeedUnit: {},
            UseGpsInfo: {},
            RecordTime: {
                options: [
                    {
                        key: "1",
                        value: "1 min",
                    },
                ],
            },
            LockEvent: {},
            FrontRotate: {},
        },
        Gsensor: {
            Normal: {},
            Parking: {},
        },
        MotionDetection: {
            MOTIONSENSOR: {},
        },
        System: {
            LED: {
                RECLED: {},
                NORMALLED: {},
                PARKINGLED: {},
                WifiLED: {},
            },
            PSENSOR: {},
            VoiceGuidance: {
                STARTVOICE: {},
                NORMALSTARTVOICE: {},
                EVENTSTARTVOICE: {},
                CHANGERECORDMODEVOICE: {},
                ENDVOICE: {},
                SPEEDALERTVOICE: {},
                PARKINGEVENTVOICE: {},
                // CLOUDVOICE: {},
                CHANGECONFIGVOICE: {},
                SHARPTURNVOICE: {},
                HARSHBRAKINGVOICE: {},
                ACCELERATIONVOICE: {},
            },
            VOLUME: {},
            ScheduledReboot: {},
            SpeedAlert: {},
            BatteryProtection: {},
            UserTextOverlay: {},
        },
        Wifi: {
            LoginCredentials: {},
            WifiSleepMode: {},
        },
        // Cloud: { CloudService: {}, sta1: {}, sta2: {}, sta3: {} },
        FirmwareLanguage: [
            "English",
            "Japan",
            "China",
            "German",
            "French",
            "Thai",
            "Idn",
            "Vietnam",
            "Spain",
            "Italian",
            "Dutch",
            "Polish",
            "Norwegian",
            "Finnish",
            "Arabic",
        ],
    },
};

var K770X = {
    default: {
        Time: {
            GpsSync: {},
            TimeSet: {},
        },
        Video: {
            ImageSetting: {
                options: [{ key: "0", value: "FHD@60 + FHD@30" }],
            },
            VideoQuality: {
                options: [
                    { key: "0", value: "Highest(Extreme)" },
                    { key: "1", value: "Highest" },
                    { key: "2", value: "High" },
                    { key: "3", value: "Normal" },
                ],
            },
        },
        Recording: {
            NormalRecord: {},
            AutoParking: {},
            RearParkingMode: {
                explain: "ON: front and_",
            },
            VoiceRecord: {},
            DateDisplay: {},
            SpeedUnit: {},
            UseGpsInfo: {},
            RecordTime: {
                options: [
                    {
                        key: "1",
                        value: "1 min",
                    },
                ],
            },
            LockEvent: {},
            FrontRotate: {},
            RearRotate: {
                options: [
                    {
                        key: "0",
                        value: "Default",
                    },
                    {
                        key: "1",
                        value: "Rotate video 180°",
                    },
                    {
                        key: "2",
                        value: "Mirror video",
                    },
                ],
            },
        },
        Gsensor: {
            Normal: {},
            Parking: {},
        },
        MotionDetection: {
            MOTIONSENSOR: {},
        },
        System: {
            LED: {
                RECLED: {},
                NORMALLED: {},
                PARKINGLED: {},
                RearLED: {},
                WifiLED: {},
                BTLED: {},
                LTELED: {},
            },
            PSENSOR: {},
            VoiceGuidance: {
                STARTVOICE: {},
                NORMALSTARTVOICE: {},
                EVENTSTARTVOICE: {},
                CHANGERECORDMODEVOICE: {},
                ENDVOICE: {},
                SPEEDALERTVOICE: {},
                PARKINGEVENTVOICE: {},
                CLOUDVOICE: {},
                CHANGECONFIGVOICE: {},
                SHARPTURNVOICE: {},
                HARSHBRAKINGVOICE: {},
                ACCELERATIONVOICE: {},
            },
            VOLUME: {},
            ScheduledReboot: {},
            SpeedAlert: {},
            BatteryProtectionRev: {
                minVolt: 11.8,
                maxVolt: 12.5,
                defaultVolt: 12,
                minVoltHeavy: 22.8,
                maxVoltHeavy: 24,
                defaultVoltHeavy: 23.2,
                // mantis - 10194, default 값 12:00 (Leehj) 23.01.16
                defaultTime: "1200",
                minTime: "100",
                maxTime: "4800",
                // Rev버전으로 업데이트 직후 기존 설정값은 0~3으로 저장되어 있는데,
                // 이것을 Rev용 값으로 변경해주는 테이블
                LowvoltageVolt: {
                    "1": "1180",
                    "2": "1200",
                    "3": "1250",
                },
                LowvoltageVoltHeavy: {
                    "1": "2280",
                    "2": "2320",
                    "3": "2400",
                },
            },
            UserTextOverlay: {},
            EventRev2: {},
            Seamless: {},
        },
        Wifi: {
            LoginCredentials: {},
        },
        Cloud: { CloudService: {}, sta1: {}, sta2: {}, sta3: {} },
        FirmwareLanguage: [
            "English",
            "Japan",
            "China",
            "German",
            "French",
            "Thai",
            "Idn",
            "Vietnam",
            "Spain",
            "Italian",
            "Dutch",
            "Polish",
            "Norwegian",
            "Finnish",
            "Arabic",
            "Korea",
        ],
        CloudNative: {},
        UXUI: {},
        CloudNative3: {},
        CloudNative4: {},
        HDLiveview: {},
    },
};

var K970X_Plus = {
    default: {
        Time: {
            GpsSync: {},
            TimeSet: {},
        },
        Video: {
            ImageSetting: {
                options: [{ key: "0", value: "4K UHD@30 + FHD@30" }],
            },
            VideoQuality: {
                options: [
                    { key: "0", value: "Highest(Extreme)" },
                    { key: "1", value: "Highest" },
                    { key: "2", value: "High" },
                    { key: "3", value: "Normal" },
                ],
            },
            VCodecType: {},
        },
        Recording: {
            NormalRecord: {},
            AutoParking: {},
            RearParkingMode: {
                explain: "ON: front and_",
            },
            VoiceRecord: {},
            DateDisplay: {},
            SpeedUnit: {},
            UseGpsInfo: {},
            RecordTime: {
                options: [
                    {
                        key: "1",
                        value: "1 min",
                    },
                ],
            },
            LockEvent: {},
            FrontRotate: {},
            RearRotate: {
                options: [
                    {
                        key: "0",
                        value: "Default",
                    },
                    {
                        key: "1",
                        value: "Rotate video 180°",
                    },
                    {
                        key: "2",
                        value: "Mirror video",
                    },
                ],
            },
        },
        Gsensor: {
            Normal: {},
            Parking: {},
        },
        MotionDetection: {
            MOTIONSENSOR: {},
        },
        System: {
            LED: {
                RECLED: {},
                NORMALLED: {},
                PARKINGLED: {},
                RearLED: {},
                WifiLED: {},
                BTLED: {},
                LTELED: {},
            },
            PSENSOR: {},
            VoiceGuidance: {
                STARTVOICE: {},
                NORMALSTARTVOICE: {},
                EVENTSTARTVOICE: {},
                CHANGERECORDMODEVOICE: {},
                ENDVOICE: {},
                SPEEDALERTVOICE: {},
                PARKINGEVENTVOICE: {},
                CLOUDVOICE: {},
                CHANGECONFIGVOICE: {},
                SHARPTURNVOICE: {},
                HARSHBRAKINGVOICE: {},
                ACCELERATIONVOICE: {},
            },
            VOLUME: {},
            ScheduledReboot: {},
            SpeedAlert: {},
            BatteryProtectionRev: {
                minVolt: 11.8,
                maxVolt: 12.5,
                defaultVolt: 12,
                minVoltHeavy: 22.8,
                maxVoltHeavy: 24,
                defaultVoltHeavy: 23.2,
                defaultTime: "1200",
                minTime: "100",
                maxTime: "4800",
                LowvoltageVolt: {
                    "1": "1180",
                    "2": "1200",
                    "3": "1250",
                },
                LowvoltageVoltHeavy: {
                    "1": "2280",
                    "2": "2320",
                    "3": "2400",
                },
            },
            UserTextOverlay: {},
            EventRev2: {},
            Seamless: {},
        },
        Wifi: {
            LoginCredentials: {},
            WifiBand: {},
        },
        Cloud: { CloudService: {}, sta1: {}, sta2: {}, sta3: {} },
        FirmwareLanguage: [
            "English",
            "Japan",
            "Spain",
            "French",
            "Italian",
            "German",
            "China",
            "Dutch",
            "Thai",
            "Idn",
            "Vietnam",
            "Polish",
            "Norwegian",
            "Finnish",
            "Arabic",
            "Korea",
        ],
        CloudNative: {},
        UXUI: {},
        CloudNative3: {},
        CloudNative4: {},
        HDLiveview: {},
    },
};

var Elite8 = {
    default: {
        Time: {
            GpsSync: {},
            TimeSet: {},
        },
        Video: {
            ImageSetting: {
                options: [{ key: '0', value: '2K QHD@30 + 2K QHD@30' }],
            },
            VideoQuality: {
                options: [
                    { key: '0', value: 'Highest(Extreme)' },
                    { key: '1', value: 'Highest' },
                    { key: '2', value: 'High' },
                    { key: '3', value: 'Normal' },
                ],
            },
            VCodecType: {},
        },
        Recording: {
            NormalRecord: {},
            AutoParking: {},
            RearParkingMode: {
                explain: 'ON: front and_',
            },
            VoiceRecord: {},
            DateDisplay: {},
            SpeedUnit: {},
            UseGpsInfo: {},
            RecordTime: {
                options: [
                    {
                        key: '1',
                        value: '1 min',
                    },
                ],
            },
            LockEvent: {},
            FrontRotate: {},
            RearRotate: {
                options: [
                    {
                        key: '0',
                        value: 'Default',
                    },
                    {
                        key: '1',
                        value: 'Rotate video 180°',
                    },
                    {
                        key: '2',
                        value: 'Mirror video',
                    },
                ],
            },
        },
        Gsensor: {
            Normal: {},
            Parking: {},
        },
        MotionDetection: {
            MOTIONSENSOR: {},
        },
        System: {
            LED: {
                RECLED: {},
                NORMALLED: {},
                PARKINGLED: {},
                RearLED: {},
                WifiLED: {},
                BTLED: {},
                LTELED: {},
            },
            PSENSOR: {},
            VoiceGuidance: {
                STARTVOICE: {},
                NORMALSTARTVOICE: {},
                EVENTSTARTVOICE: {},
                CHANGERECORDMODEVOICE: {},
                ENDVOICE: {},
                SPEEDALERTVOICE: {},
                PARKINGEVENTVOICE: {},
                CLOUDVOICE: {},
                CHANGECONFIGVOICE: {},
                SHARPTURNVOICE: {},
                HARSHBRAKINGVOICE: {},
                ACCELERATIONVOICE: {},
            },
            VOLUME: {},
            ScheduledReboot: {},
            SpeedAlert: {},
            UserTextOverlay: {},
            EventRev2: {},
            Seamless: {},
        },
        Wifi: {
            LoginCredentials: {},
            WifiBand: {},
        },
        Cloud: { CloudService: {}, sta1: {}, sta2: {}, sta3: {} },
        FirmwareLanguage: [
            'English',
            'Japan',
            'Spain',
            'French',
            'Italian',
            'German',
            'China',
            'Dutch',
            'Thai',
            'Idn',
            'Vietnam',
            'Polish',
            'Norwegian',
            'Finnish',
            'Korea',
            'Russian',
        ],
        CloudNative: {},
        UXUI: {},
        CloudNative3: {},
        CloudNative4: {},
        HDLiveview: {},
    },
};

var Elite9 = {
    default: {
        Time: {
            GpsSync: {},
            TimeSet: {},
        },
        Video: {
            ImageSetting: {
                options: [{ key: '0', value: '4K UHD@30 + 2K QHD@30' }],
            },
            VideoQuality: {
                options: [
                    { key: '0', value: 'Highest(Extreme)' },
                    { key: '1', value: 'Highest' },
                    { key: '2', value: 'High' },
                    { key: '3', value: 'Normal' },
                ],
            },
            VCodecType: {},
        },
        Recording: {
            NormalRecord: {},
            AutoParking: {},
            RearParkingMode: {
                explain: 'ON: front and_',
            },
            VoiceRecord: {},
            DateDisplay: {},
            SpeedUnit: {},
            UseGpsInfo: {},
            RecordTime: {
                options: [
                    {
                        key: '1',
                        value: '1 min',
                    },
                ],
            },
            LockEvent: {},
            FrontRotate: {},
            RearRotate: {
                options: [
                    {
                        key: '0',
                        value: 'Default',
                    },
                    {
                        key: '1',
                        value: 'Rotate video 180°',
                    },
                    {
                        key: '2',
                        value: 'Mirror video',
                    },
                ],
            },
        },
        Gsensor: {
            Normal: {},
            Parking: {},
        },
        MotionDetection: {
            MOTIONSENSOR: {},
        },
        System: {
            LED: {
                RECLED: {},
                NORMALLED: {},
                PARKINGLED: {},
                RearLED: {},
                WifiLED: {},
                BTLED: {},
                LTELED: {},
            },
            PSENSOR: {},
            VoiceGuidance: {
                STARTVOICE: {},
                NORMALSTARTVOICE: {},
                EVENTSTARTVOICE: {},
                CHANGERECORDMODEVOICE: {},
                ENDVOICE: {},
                SPEEDALERTVOICE: {},
                PARKINGEVENTVOICE: {},
                CLOUDVOICE: {},
                CHANGECONFIGVOICE: {},
                SHARPTURNVOICE: {},
                HARSHBRAKINGVOICE: {},
                ACCELERATIONVOICE: {},
            },
            VOLUME: {},
            ScheduledReboot: {},
            SpeedAlert: {},
            UserTextOverlay: {},
            EventRev2: {},
            Seamless: {},
        },
        Wifi: {
            LoginCredentials: {},
            WifiBand: {},
        },
        Cloud: { CloudService: {}, sta1: {}, sta2: {}, sta3: {} },
        FirmwareLanguage: [
            'English',
            'Japan',
            'Spain',
            'French',
            'Italian',
            'German',
            'China',
            'Dutch',
            'Thai',
            'Idn',
            'Vietnam',
            'Polish',
            'Norwegian',
            'Finnish',
            'Korea',
            'Russian',
        ],
        CloudNative: {},
        UXUI: {},
        CloudNative3: {},
        CloudNative4: {},
        HDLiveview: {},
    },
};

var Elite10 = {
    default: {
        Time: {
            GpsSync: {},
            TimeSet: {},
        },
        Video: {
            ImageSetting: {
                options: [{ key: '0', value: '4K UHD@30 + 4K UHD@30' }],
            },
            VideoQuality: {
                options: [
                    { key: '0', value: 'Highest(Extreme)' },
                    { key: '1', value: 'Highest' },
                    { key: '2', value: 'High' },
                    { key: '3', value: 'Normal' },
                ],
            },
            VCodecType: {},
        },
        Recording: {
            NormalRecord: {},
            AutoParking: {},
            RearParkingMode: {
                explain: 'ON: front and_',
            },
            VoiceRecord: {},
            DateDisplay: {},
            SpeedUnit: {},
            UseGpsInfo: {},
            RecordTime: {
                options: [
                    {
                        key: '1',
                        value: '1 min',
                    },
                ],
            },
            LockEvent: {},
            FrontRotate: {},
            RearRotate: {
                options: [
                    {
                        key: '0',
                        value: 'Default',
                    },
                    {
                        key: '1',
                        value: 'Rotate video 180°',
                    },
                    {
                        key: '2',
                        value: 'Mirror video',
                    },
                ],
            },
        },
        Gsensor: {
            Normal: {},
            Parking: {},
        },
        MotionDetection: {
            MOTIONSENSOR: {},
        },
        System: {
            LED: {
                RECLED: {},
                NORMALLED: {},
                PARKINGLED: {},
                RearLED: {},
                WifiLED: {},
                BTLED: {},
                LTELED: {},
            },
            PSENSOR: {},
            VoiceGuidance: {
                STARTVOICE: {},
                NORMALSTARTVOICE: {},
                EVENTSTARTVOICE: {},
                CHANGERECORDMODEVOICE: {},
                ENDVOICE: {},
                SPEEDALERTVOICE: {},
                PARKINGEVENTVOICE: {},
                CLOUDVOICE: {},
                CHANGECONFIGVOICE: {},
                SHARPTURNVOICE: {},
                HARSHBRAKINGVOICE: {},
                ACCELERATIONVOICE: {},
            },
            VOLUME: {},
            ScheduledReboot: {},
            SpeedAlert: {},
            UserTextOverlay: {},
            EventRev2: {},
            Seamless: {},
        },
        Wifi: {
            LoginCredentials: {},
            WifiBand: {},
        },
        Cloud: { CloudService: {}, sta1: {}, sta2: {}, sta3: {} },
        FirmwareLanguage: [
            'English',
            'Japan',
            'Spain',
            'French',
            'Italian',
            'German',
            'China',
            'Dutch',
            'Thai',
            'Idn',
            'Vietnam',
            'Polish',
            'Norwegian',
            'Finnish',
            'Korea',
            'Russian',
        ],
        CloudNative: {},
        UXUI: {},
        CloudNative3: {},
        CloudNative4: {},
        HDLiveview: {},
    },
};

var Elite_Gold = {
    default: {
        Time: {
            GpsSync: {},
            TimeSet: {},
        },
        Video: {
            ImageSetting: {
                options: [{ key: '0', value: '2K QHD@30 + 2K QHD@30' }],
            },
            VideoQuality: {
                options: [
                    { key: '0', value: 'Extreme' },
                    { key: '1', value: 'High' },
                    { key: '2', value: 'Medium' },
                    { key: '3', value: 'Low' },
                ],
            },
        },
        Recording: {
            NormalRecord: {},
            AutoParking: {},
            RearParkingMode: {
                explain: 'ON: front and_',
            },
            VoiceRecord: {},
            DateDisplay: {},
            SpeedUnit: {},
            UseGpsInfo: {},
            RecordTime: {
                options: [
                    {
                        key: '1',
                        value: '1 min',
                    },
                ],
            },
            LockEvent: {},
            FrontRotate: {},
            RearRotate: {
                options: [
                    {
                        key: '0',
                        value: 'Default',
                    },
                    {
                        key: '1',
                        value: 'Rotate video 180°',
                    },
                    {
                        key: '2',
                        value: 'Mirror video',
                    },
                ],
            },
        },
        Gsensor: {
            Normal: {},
            Parking: {},
        },
        MotionDetection: {
            MOTIONSENSOR: {},
        },
        System: {
            LED: {
                RECLED: {},
                NORMALLED: {},
                PARKINGLED: {},
                RearLED: {},
                WifiLED: {},
                BTLED: {},
                LTELED: {},
            },
            PSENSOR: {},
            VoiceGuidance: {
                STARTVOICE: {},
                NORMALSTARTVOICE: {},
                EVENTSTARTVOICE: {},
                CHANGERECORDMODEVOICE: {},
                ENDVOICE: {},
                SPEEDALERTVOICE: {},
                PARKINGEVENTVOICE: {},
                CLOUDVOICE: {},
                CHANGECONFIGVOICE: {},
                SHARPTURNVOICE: {},
                HARSHBRAKINGVOICE: {},
                ACCELERATIONVOICE: {},
            },
            VOLUME: {},
            ScheduledReboot: {},
            SpeedAlert: {},
            BatteryProtectionRev: {
                minVolt: 11.8,
                maxVolt: 12.5,
                defaultVolt: 11.8,
                minVoltHeavy: 22.8,
                maxVoltHeavy: 24,
                defaultVoltHeavy: 22.8,
                defaultTime: '1200',
                minTime: '100',
                maxTime: '4800',
                // Rev버전으로 업데이트 직후 기존 설정값은 0~3으로 저장되어 있는데,
                // 이것을 Rev용 값으로 변경해주는 테이블
                LowvoltageVolt: {
                    '1': '1180',
                    '2': '1200',
                    '3': '1250',
                },
                LowvoltageVoltHeavy: {
                    '1': '2280',
                    '2': '2320',
                    '3': '2400',
                },
            },
            UserTextOverlay: {},
            EventRev2: {},
            Seamless: {},
        },
        Wifi: {
            LoginCredentials: {},
            WifiBand: {},
        },
        Cloud: { CloudService: {}, sta1: {}, sta2: {}, sta3: {} },
        FirmwareLanguage: [
            'English',
            'Idn',
            'China',
            'German',
            'Spain',
            'French',
            'Italian',
            'Japan',
            'Dutch',
            'Norwegian',
            'Polish',
            'Russian',
            'Finnish',
            'Thai',
            'Vietnam',
            'Arabic',
            'Korea',
        ],
        CloudNative: {},
        UXUI: {},
        CloudNative3: {},
        CloudNative4: {},
        HDLiveview: {},
    },
    0.9: {
        PlaybackDelete: {},
    },
};

var SUPPORT_REBOOT_FW = {
    'DR750X Plus': 1.003,
    'DR750-2CH LTE': 1.008,
    'DR900X-1CH': 1.008,
    'DR900X-2CH': 1.008,
    'DR900S-1CH': 1.014,
    'DR900S-2CH': 1.014,
    'DR750X-1CH': 1.008,
    'DR750X-2CH': 1.008,
    'DR750S-1CH': 1.019,
    'DR750S-2CH': 1.019,
    'DR750G-1CH': 1.004,
    'DR750G-2CH': 1.004,
    'DR750G-1CH Pro': 1.004,
    'DR750G-2CH Pro': 1.004,
    'DR750G Pro': 1.004,
    // "DR750K LTE": 1.0,
    'DR750X LTE Plus': 1.0,
    'DR900X Plus': 1.0,
    'DR750X-3CH Plus': 0,
    DR770X: 0,
    DR790X: 0,
    'BlackVue 7G Pro': 0,
    DR970X: 0,
    'DR770X Box': 0,
    'DR770X LTE': 0,
    'DR770X-2CH DMS II': 0,
    'DR770X Box Pro': 0,
    'DR790X LTE': 0,
    'DR970X LTE': 0,
    'DR800 GOLD': 0,
    'DR800Gold Pro': 0,
    'DR970X Plus': 0,
    'DR970X LTE Plus': 0,
    'DR970X Box Plus': 0,
    'DR590X-1CH Plus': 0,
    'DR590X-2CH Plus': 0,
    K770X: 0,
    'K970X Plus': 0,
    'ELITE 8': 0,
    'ELITE 9': 0,
    'ELITE 10': 0,
    'ELITE + GOLD': 0,
};
var FIRMWARE_SETTINGS = {
    'DR750-2CH LTE': DR750_2CH_LTE,
    //750S
    'DR750S-1CH': DR750S_1CH,
    'DR750S-2CH': DR750S_2CH,
    //750G
    'DR750G-1CH': DR750G_1CH,
    'DR750G-2CH': DR750G_2CH,
    'DR750G Pro': DR750G_PRO,
    'DR750G-1CH Pro': DR750G_1CH_PRO,
    'DR750G-2CH Pro': DR750G_2CH_PRO,
    //750X
    'DR750X-1CH': DR750X_1CH,
    'DR750X-2CH': DR750X_2CH,
    'DR750X Plus': DR750X_Plus,
    'DR750X-3CH Plus': DR750X_3CH_Plus,
    'DR750X LTE Plus': DR750X_LTE_Plus,
    // "DR750K LTE": DR750K_LTE,
    //900S
    'DR900S-1CH': DR900S_1CH,
    'DR900S-2CH': DR900S_2CH,
    //900X
    'DR900X-1CH': DR900X_1CH,
    'DR900X-2CH': DR900X_2CH,
    'DR900X Plus': DR900X_Plus,
    DR770X: DR770X,
    'BlackVue 7G Pro': BlackVue_7G_PRO,
    DR970X: DR970X,
    DR790X: DR790X,
    'DR770X Box': DR770X_Box,
    'DR770X-2CH DMS II': DR770X_2CH_DMS_II,
    'DR770X LTE': DR770X_LTE,
    'DR770X Box Pro': DR770X_Box_Pro,
    'DR790X LTE': DR790X_LTE,
    'DR970X LTE': DR970X_LTE,
    'DR800 GOLD': DR800_GOLD,
    'DR800Gold Pro': DR800Gold_Pro,
    'DR970X Plus': DR970X_Plus,
    'DR970X LTE Plus': DR970X_LTE_Plus,
    'DR970X Box Plus': DR970X_Box_Plus,
    'DR590X-1CH Plus': DR590X_1CH_Plus,
    'DR590X-2CH Plus': DR590X_2CH_Plus,
    K770X: K770X,
    'K970X Plus': K970X_Plus,
    'ELITE 8': Elite8,
    'ELITE 9': Elite9,
    'ELITE 10': Elite10,
    'ELITE + GOLD': Elite_Gold,
};

var ADASLDWS = {
    "1": "50km/h",
    "2": "60km/h",
    "3": "70km/h",
};

var Webviewer = {
    menuHide: 1140,
    reportMobile: 1348,
    reportMobileClose: 1185,
    reportMobileView: 879,
    playbackMobile: 1104,
    playbackMobileClose: 935,
    mobile: 956,
    geofenceMobile: 956,
    smallMobile: 380,
};

var LightColors = {
    primary: {
        0: "#FFFFFF",
        1: "#13131C",
        2: "#68686E",
        3: "#7E7E83",
        4: "#BEBEC1",
        5: "#D4D4D5",
        6: "#E9E9EA",
        7: "#0095E0",
        8: "#2EA8E5",
        9: "#D0EBF9",
        10: "#E7F5FC",
        disabled: "#9DD5F0",
    },
    secondary: {
        11: "#D81A26",
        12: "#DF434D",
        13: "#F4C0C3",
        14: "#F7D5D7",
        15: "#00AA64",
        16: "#D0EFE2",
        17: "#ED9600",
        18: "#FBEBD0",
        19: "#FFEC00",
        20: "#424EB9",
        disabled: "#F2B0B4",
    },
};
var DarkColors = {
    primary: {
        0: "#121216",
        1: "#EEEEF3",
        2: "#D0D0D5",
        3: "#ABABB0",
        4: "#636367",
        5: "#505054",
        6: "#404045",
        7: "#37B7FF",
        8: "#239DE2",
        9: "#BCE5FD",
        10: "#DDF2FE",
        disabled: "#9DD5F0",
    },
    secondary: {
        11: "#F95D67",
        12: "#DE535C",
        13: "#F95D674D",
        14: "#F95D6726",
        15: "#15B674",
        16: "#15B67426",
        17: "#FBEBD0",
        18: "#EE9F1726",
        19: "#FFBB4526",
        20: "#8A3FFC",
    },
};
var StatusColors = {
    P: LightColors.secondary["17"],
    A: LightColors.secondary["15"],
    E: LightColors.secondary["11"],
};
var SemanticDarkColors = {
    primary: {
        0: "#323236",
        1: "#1E1E23",
        2: "#505054",
    },
    secondary: {},
};

var ERROR_TIMEOUT = 6000;
// 7660 upload list 호출 주기 단축
var UPLOADING_QUEUE_UPDATE_INTERVAL = process.env.REACT_APP_ENV === "production" ||
    process.env.REACT_APP_ENV === "staging"
    ? 30 * 1000
    : 10 * 1000;
var FLEETA_PROMO_CODE = "FleetPromotion";

var Countries = {
    country: "Country",
    af: "Afghanistan",
    al: "Albania",
    dz: "Algeria",
    ad: "Andorra",
    ao: "Angola",
    ag: "Antigua and Barbuda",
    ar: "Argentina",
    am: "Armenia",
    au: "Australia",
    at: "Austria",
    az: "Azerbaijan",
    bs: "Bahamas",
    bh: "Bahrain",
    bd: "Bangladesh",
    bb: "Barbados",
    by: "Belarus",
    be: "Belgium",
    bz: "Belize",
    bj: "Benin",
    bt: "Bhutan",
    bo: "Bolivia",
    ba: "Bosnia and Herzegovina",
    bw: "Botswana",
    br: "Brazil",
    bn: "Brunei",
    bg: "Bulgaria",
    bf: "Burkina Faso",
    bi: "Burundi",
    ci: "Côte d'Ivoire",
    cv: "Cabo Verde",
    kh: "Cambodia",
    cm: "Cameroon",
    ca: "Canada",
    cf: "Central African Republic",
    td: "Chad",
    cl: "Chile",
    cn: "China",
    co: "Colombia",
    km: "Comoros",
    cg: "Congo (Congo-Brazzaville)",
    cr: "Costa Rica",
    hr: "Croatia",
    cu: "Cuba",
    cy: "Cyprus",
    cz: "Czechia (Czech Republic)",
    cd: "Democratic Republic of the Congo",
    dk: "Denmark",
    dj: "Djibouti",
    dm: "Dominica",
    do: "Dominican Republic",
    ec: "Ecuador",
    eg: "Egypt",
    sv: "El Salvador",
    gq: "Equatorial Guinea",
    er: "Eritrea",
    ee: "Estonia",
    sz: "Eswatini (fmr. Swaziland)",
    et: "Ethiopia",
    fj: "Fiji",
    fi: "Finland",
    fr: "France",
    ga: "Gabon",
    gm: "Gambia",
    ge: "Georgia",
    de: "Germany",
    gh: "Ghana",
    gr: "Greece",
    gd: "Grenada",
    gt: "Guatemala",
    gn: "Guinea",
    gw: "Guinea-Bissau",
    gy: "Guyana",
    ht: "Haiti",
    va: "Holy See",
    hn: "Honduras",
    hu: "Hungary",
    is: "Iceland",
    in: "India",
    id: "Indonesia",
    ir: "Iran",
    iq: "Iraq",
    ie: "Ireland",
    il: "Israel",
    it: "Italy",
    jm: "Jamaica",
    jp: "Japan",
    jo: "Jordan",
    kz: "Kazakhstan",
    ke: "Kenya",
    ki: "Kiribati",
    kw: "Kuwait",
    kg: "Kyrgyzstan",
    la: "Laos",
    lv: "Latvia",
    lb: "Lebanon",
    ls: "Lesotho",
    lr: "Liberia",
    ly: "Libya",
    li: "Liechtenstein",
    lt: "Lithuania",
    lu: "Luxembourg",
    mg: "Madagascar",
    mw: "Malawi",
    my: "Malaysia",
    mv: "Maldives",
    ml: "Mali",
    mt: "Malta",
    mh: "Marshall Islands",
    mr: "Mauritania",
    mu: "Mauritius",
    mx: "Mexico",
    fm: "Micronesia",
    md: "Moldova",
    mc: "Monaco",
    mn: "Mongolia",
    me: "Montenegro",
    ma: "Morocco",
    mz: "Mozambique",
    mm: "Myanmar (formerly Burma)",
    na: "Namibia",
    nr: "Nauru",
    np: "Nepal",
    nl: "Netherlands",
    nz: "New Zealand",
    ni: "Nicaragua",
    ne: "Niger",
    ng: "Nigeria",
    kp: "North Korea",
    mk: "North Macedonia",
    no: "Norway",
    om: "Oman",
    pk: "Pakistan",
    pw: "Palau",
    ps: "Palestine State",
    pa: "Panama",
    pg: "Papua New Guinea",
    py: "Paraguay",
    pe: "Peru",
    ph: "Philippines",
    pl: "Poland",
    pt: "Portugal",
    qa: "Qatar",
    ro: "Romania",
    ru: "Russia",
    rw: "Rwanda",
    kn: "Saint Kitts and Nevis",
    lc: "Saint Lucia",
    vc: "Saint Vincent and the Grenadines",
    ws: "Samoa",
    sm: "San Marino",
    st: "Sao Tome and Principe",
    sa: "Saudi Arabia",
    sn: "Senegal",
    rs: "Serbia",
    sc: "Seychelles",
    sl: "Sierra Leone",
    sg: "Singapore",
    sk: "Slovakia",
    si: "Slovenia",
    sb: "Solomon Islands",
    so: "Somalia",
    za: "South Africa",
    kr: "South Korea",
    ss: "South Sudan",
    es: "Spain",
    lk: "Sri Lanka",
    sd: "Sudan",
    sr: "Suriname",
    se: "Sweden",
    ch: "Switzerland",
    sy: "Syria",
    tj: "Tajikistan",
    tz: "Tanzania",
    th: "Thailand",
    tl: "Timor-Leste",
    tg: "Togo",
    to: "Tonga",
    tt: "Trinidad and Tobago",
    tn: "Tunisia",
    tr: "Turkey",
    tm: "Turkmenistan",
    tv: "Tuvalu",
    ug: "Uganda",
    ua: "Ukraine",
    ae: "United Arab Emirates",
    gb: "United Kingdom",
    us: "United States of America",
    uy: "Uruguay",
    uz: "Uzbekistan",
    vu: "Vanuatu",
    ve: "Venezuela",
    vn: "Vietnam",
    ye: "Yemen",
    zm: "Zambia",
    zw: "Zimbabwe",
};

var DsmSensitivity = {
    "0": "Low",
    "1": "Medium",
    "2": "High_2",
};

var DsmSensitivityUXUI = {
    "0": "Low_2",
    "1": "Medium_2",
    "2": "High_3",
};

var DsmDrivePosition = {
    "1": "Left-Hand Drive",
    "2": "Right-Hand Drive",
};

var EventName = {
    ALARM_MANUAL: "Manual recording",
    ALARM_EVENT: "Driving Impact",
    ALARM_SPEED: "Overspeed",
    ALARM_HARSHBRAKING: "Hard Braking",
    ALARM_ACCELERATION: "Hard Acceleration",
    ALARM_SHARPTURN: "Hard Cornering",
    ALARM_PARK_EVENT: "Parking impact",
    ALARM_PARK_MOTION: "Motion Detection",
    ALARM_PARK_IN: "Parking mode enter_",
    ALARM_GEOFENCE_ENTER: "Entering",
    ALARM_GEOFENCE_EXIT: "Exiting",
    ALARM_GEOFENCE_PASS: "Passing",
    ALARM_GEOFENCE_SPEED: "Speed Alert",
    ALARM_GEOFENCE: "Geofence",
    ALARM_UNDETECTED: "Undetected",
    ALARM_DETECTED: "Detected",
    ALARM_DROWSY: "Drowsiness",
    ALARM_DROWSY_SECOND: "Second Drowsiness Alert",
    ALARM_DISTRACTED: "Distracted",
    ALARM_CALLING: "Hand distraction",
    ALARM_MASK_OFF: "Mask",
    ALARM_LOW_VOLTAGE: "Low Voltage Warning_2",
    DEVICE_CONNECT: "Cloud Connectivity",
    ALARM_CLOUDSTORAGE: "Cloud Storage",
    ALARM_SEATBELT: "Seat Belt",
    ALARM_FATIGUE: "Fatigue Risk Alert",
};
var DMS_EVENTS = [
    "ALARM_DROWSY",
    //mantis - 8775, 2차졸음 타입 추가
    "ALARM_DROWSY_SECOND",
    "ALARM_DISTRACTED",
    "ALARM_UNDETECTED",
    "ALARM_DETECTED",
    "ALARM_CALLING",
    "ALARM_SMOKING",
    "ALARM_MASK_OFF",
    "ALARM_SEATBELT",
];
var MSG_CODE_TYPE = [
    "ALARM_MANUAL",
    // Normal event recording
    "ALARM_EVENT",
    "ALARM_SPEED",
    "ALARM_HARSHBRAKING",
    "ALARM_ACCELERATION",
    "ALARM_SHARPTURN",
    // Parking event recording
    "ALARM_PARK_EVENT",
    "ALARM_PARK_MOTION",
    "ALARM_PARK_IN",
    "ALARM_PARK_OUT",
    // Geofencing
    "ALARM_GEOFENCE_ENTER",
    "ALARM_GEOFENCE_EXIT",
    "ALARM_GEOFENCE_PASS",
    "ALARM_GEOFENCE_SPEED",
    "ALARM_GEOFENCE",
    // Battery Cloud
    "ALARM_BATTERY_DISCHARGE",
    // Driver monitoring system (DMS)
    "ALARM_CALLING",
    "ALARM_SMOKING",
    "ALARM_MASK_OFF",
    "ALARM_DROWSY",
    "ALARM_DROWSY_SECOND",
    "ALARM_DISTRACTED",
    "ALARM_UNDETECTED",
    "ALARM_DETECTED",
    "ALARM_SEATBELT",
    // Etc
    "DEVICE_CONNECT",
    "DEVICE_DISCONNECT",
    "ALARM_CLOUDSTORAGE",
    "ALARM_LOW_VOLTAGE",
    "ALARM_SETTING_SAVED",
    "ALARM_FATIGUE",
];
var THUMBNAIL_EVENTS = [
    "ALARM_EVENT",
    "ALARM_PARK_EVENT",
    "ALARM_MANUAL",
    "ALARM_DROWSY",
    //mantis - 8775, 2차졸음 타입 추가
    "ALARM_DROWSY_SECOND",
    "ALARM_DISTRACTED",
    "ALARM_UNDETECTED",
    "ALARM_DETECTED",
    "ALARM_CALLING",
    "ALARM_SMOKING",
    "ALARM_MASK_OFF",
    "ALARM_ACCELERATION",
    "ALARM_HARSHBRAKING",
    "ALARM_SHARPTURN",
    "ALARM_SPEED",
    "ALARM_SEATBELT",
];
var NO_PLAYBACK_EVENTS = [
    "ALARM_MASK_OFF",
    "ALARM_DETECTED",
    "ALARM_LOW_VOLTAGE",
    "DEVICE_CONNECT",
    "DEVICE_DISCONNECT",
    "ALARM_CLOUDSTORAGE",
    //9951
    "ALARM_SETTING_SAVED",
    // mantis - 11703, dms/펌웨어 업데이트 실패,완료 타입 추가 (Leehj)
    "ALARM_FOTA_SUCCESS",
    "ALARM_FOTA_FAIL",
    "ALARM_BATTERY_DISCHARGE",
    "ALARM_FATIGUE",
];
var NO_LIVEVIEW_EVENTS = [
    "ALARM_LOW_VOLTAGE",
    "DEVICE_DISCONNECT",
    "ALARM_CLOUDSTORAGE",
    "DEVICE_CONNECT",
    //9951
    "ALARM_SETTING_SAVED",
    // mantis - 11703, dms/펌웨어 업데이트 실패,완료 타입 추가 (Leehj)
    "ALARM_FOTA_SUCCESS",
    "ALARM_FOTA_FAIL",
    "ALARM_BATTERY_DISCHARGE",
    "ALARM_FATIGUE",
];
var NO_THUMBNAIL_EVENTS = [
    "ALARM_LOW_VOLTAGE",
    "DEVICE_CONNECT",
    "DEVICE_DISCONNECT",
    "ALARM_CLOUDSTORAGE",
    "ALARM_PARK_MOTION",
    "ALARM_PARK_IN",
    "ALARM_PARK_OUT",
    "ALARM_GEOFENCE_PASS",
    "ALARM_GEOFENCE_SPEED",
    "ALARM_GEOFENCE_ENTER",
    "ALARM_GEOFENCE_EXIT",
    "ALARM_GEOFENCE",
    //9951
    "ALARM_SETTING_SAVED",
    // mantis - 11703, dms/펌웨어 업데이트 실패,완료 타입 추가 (Leehj)
    "ALARM_FOTA_SUCCESS",
    "ALARM_FOTA_FAIL",
    "ALARM_BATTERY_DISCHARGE",
    "ALARM_FATIGUE",
];
var PARKING_EVENTS = [
    "ALARM_PARK_EVENT",
    "ALARM_PARK_MOTION",
    "ALARM_PARK_IN",
    "ALARM_PARK_OUT",
];
var AI_EVENTS = ["F", "D", "L", "C", "S", "Y"];
var EventNames = {
    E: "Driving impact",
    I: "Parking impact",
    O: "Overspeed",
    A: "Hard Acceleration",
    T: "Hard cornering",
    B: "Hard braking",
    R: "Geofence-enter",
    X: "Geofence-exit",
    G: "Geofence-pass",
    J: "Geofence-speed alert",
    F: "Undetected",
    D: "Drowsiness",
    L: "Distracted",
    // C: "Calling",
    // S: "Smoking",
    C: "Hand distraction",
    S: "Hand distraction",
    M: "Manual",
    Y: "No Seat Belt",
    TEST: "Geofence-pass Geofence-pass Geofence-pass",
};

var config = {
    apiKey: "AIzaSyA9tY6Kd0eWg953zK1qNo-GRVXhEWoS8zs",
    authDomain: "comb-totalone.firebaseapp.com",
    databaseURL: "https://comb-totalone.firebaseio.com",
    projectId: "comb-totalone",
    storageBucket: "comb-totalone.appspot.com",
    messagingSenderId: "948301488227",
    appId: "1:948301488227:web:867eb9e52da9f963c61856",
    measurementId: "G-GSDGVQM0X8",
};

var FwAbbr = {
    "DR900X Plus": "DR900X Plus",
    "DR750X LTE Plus": "DR750X LTE Plus",
    "DR750X-3CH Plus": "DR750X-3CH Plus",
    "DR750X Plus": "DR750X Plus",
    "DR900X-2CH": "900X2",
    "DR900X-1CH": "900X1",
    "DR750X-2CH": "750X2",
    "DR750X-1CH": "750X1",
    "DR590X-2CH": "590X2",
    "DR590X-1CH": "590X1",
    "DR750G Pro": "DR750G Pro",
    "DR750G-1CH Pro": "750GPRO1",
    "DR750G-2CH Pro": "750GPRO2",
    "DR750-2CH LTE": "750LTE2",
    "DR900S-2CH": "900S2",
    "DR900S-1CH": "900S1",
    "DR750S-2CH": "750S2",
    "DR750S-1CH": "750S1",
    "DR750G-2CH": "750G2",
    "DR750G-1CH": "750G1",
    // 시그마스타 신규모델 추가
    DR770X: "DR770X",
    DR970X: "DR970X",
    DR790X: "DR790X",
    "DR770X LTE": "DR770X LTE",
    "DR790X LTE": "DR790X LTE",
    "DR970X LTE": "DR970X LTE",
    // mantis - 12630, 시그마스타 Plus 모델 추가
    "DR970X Plus": "DR970X Plus",
    "DR970X LTE Plus": "DR970X LTE Plus",
    "DR970X Box Plus": "DR970X Box Plus",
    // mantis - 8458, BlackVue 7 Box모델 추가
    "DR770X Box": "DR770X Box",
    "DR770X Box Pro": "DR770X Box Pro",
    "DR800 GOLD": "DR800 GOLD",
    "DR800Gold Pro": "DR800Gold Pro",
    // "":"570W2",
    // "":"570W1",
    // "":"650S2",
    // "":"650S1",
    // "":"650GW",
    // "":"650GW1CH",
    // "":"590W2",
    // "":"590W1",
    // "":"550GWII2",
    // "":"550GWII1",
    // "":"550GW",
    // "":"550GW1CH",
    // "":"750LW",
    // "":"600GW",
    // "":"500GW"
};

var TOP_LEFT = 1;
var TOP_RIGHT = 3;
var BOTTOM_RIGHT = 12;
var GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_API_KEY;
var MOBILE_BOUNDS_PADDING = {
    bottom: 50,
    left: 50,
    right: 50,
    top: 50,
};
var PC_BOUNDS_PADDING = {
    bottom: 250,
    left: 400,
    right: 100,
    top: 250,
};
var LocationMarkerIcon = "data:image/svg+xml;utf-8,<svg width=\"32\" height=\"36\" viewBox=\"0 0 32 36\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g filter=\"url(%23filter0_ddd)\">\n<circle cx=\"15\" cy=\"21\" r=\"11.5\" fill=\"%230095E0\" stroke=\"white\"/>\n<g clip-path=\"url(%23clip0)\">\n<path d=\"M11.4688 23.0938C12.6979 22.5938 13.875 22.3438 15 22.3438C16.125 22.3438 17.2917 22.5938 18.5 23.0938C19.7292 23.5729 20.3438 24.2083 20.3438 25V26.3438H9.65625V25C9.65625 24.2083 10.2604 23.5729 11.4688 23.0938ZM16.875 20.2188C16.3542 20.7396 15.7292 21 15 21C14.2708 21 13.6458 20.7396 13.125 20.2188C12.6042 19.6979 12.3438 19.0729 12.3438 18.3438C12.3438 17.6146 12.6042 16.9896 13.125 16.4688C13.6458 15.9271 14.2708 15.6562 15 15.6562C15.7292 15.6562 16.3542 15.9271 16.875 16.4688C17.3958 16.9896 17.6562 17.6146 17.6562 18.3438C17.6562 19.0729 17.3958 19.6979 16.875 20.2188Z\" fill=\"white\"/>\n</g>\n<rect x=\"12.5\" y=\"4.5\" width=\"15\" height=\"9\" rx=\"2.5\" fill=\"%2313131C\" stroke=\"white\"/>\n<circle cx=\"18\" cy=\"9\" r=\"1.5\" fill=\"%2313131C\" stroke=\"white\"/>\n<circle cx=\"26\" cy=\"6\" r=\"2.5\" fill=\"%23D81A26\" stroke=\"white\"/>\n</g>\n<defs>\n<filter id=\"filter0_ddd\" x=\"0\" y=\"0\" width=\"32\" height=\"36\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\">\n<feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"/>\n<feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\"/>\n<feOffset/>\n<feGaussianBlur stdDeviation=\"1.5\"/>\n<feColorMatrix type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0\"/>\n<feBlend mode=\"normal\" in2=\"BackgroundImageFix\" result=\"effect1_dropShadow\"/>\n<feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\"/>\n<feOffset dy=\"1\"/>\n<feGaussianBlur stdDeviation=\"0.5\"/>\n<feColorMatrix type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0\"/>\n<feBlend mode=\"normal\" in2=\"effect1_dropShadow\" result=\"effect2_dropShadow\"/>\n<feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\"/>\n<feOffset/>\n<feGaussianBlur stdDeviation=\"0.5\"/>\n<feColorMatrix type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0\"/>\n<feBlend mode=\"normal\" in2=\"effect2_dropShadow\" result=\"effect3_dropShadow\"/>\n<feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"effect3_dropShadow\" result=\"shape\"/>\n</filter>\n<clipPath id=\"clip0\">\n<rect width=\"24\" height=\"24\" fill=\"white\" transform=\"translate(3 9)\"/>\n</clipPath>\n</defs>\n</svg>\n";
var INITIAL_MAP_LOCATION = {
    lat: 39.123098,
    lng: -101.008655,
};

var Languages = {
    en: "English",
    id: "Bahasa Indonesia",
    de: "Deutsch",
    es: "Español",
    fr: "Français",
    it: "Italiano",
    nl: "Nederlands",
    nb: "Norsk",
    pl: "Polski",
    fi: "Suomi",
    vi: "Tiếng Việt",
    ru: "Русский",
    ar: "اﻟﻌﺮﺑﻴﺔ",
    th: "ไทย",
    ko: "한국어",
    sc: "中文 (简体)",
    ja: "日本語",
};
var MobileLang = {
    en: "eng",
    id: "ind",
    de: "deu",
    es: "lad",
    fr: "fra",
    it: "ita",
    nl: "nld",
    nb: "nor",
    pl: "pol",
    fi: "fin",
    vi: "vol",
    ru: "rus",
    ar: "ara",
    th: "tha",
    ko: "kor",
    sc: "zho",
    zh: "zho",
    ja: "jpn",
};
var cardLanguages = {
    en: "en",
    id: "id",
    de: "de",
    es: "es",
    fr: "fr",
    it: "it",
    nl: "nl",
    nb: "nb",
    pl: "pl",
    fi: "fi",
    vi: "vi",
    ru: "ru",
    ar: "ar",
    th: "th",
    ko: "ko",
    sc: "zh",
    ja: "ja",
};
var FirmwareLanguages = {
    English: "English",
    Idn: "Bahasa Indonesia",
    German: "Deutsch",
    Spain: "Español",
    French: "Français",
    Italian: "Italiano",
    Dutch: "Nederlands",
    Norwegian: "Norsk",
    Polish: "Polski",
    Finnish: "Suomi",
    Vietnam: "Tiếng Việt",
    Russian: "Русский",
    Arabic: "اﻟﻌﺮﺑﻴﺔ",
    Thai: "ไทย",
    Korea: "한국어",
    China: "中文 (简体)",
    Japan: "日本語",
};

var APPSTORE = "https://apps.apple.com/kr/app/blackvue/id1049209637";
var GOOGLEPLAY = "https://play.google.com/store/apps/details?id=comb.blackvuec";
var MACAPP = "https://www.blackvue.com/downloads/#app-viewer";
var WINDOWAPP = "https://www.blackvue.com/downloads/#app-viewer";
var Firmware$h = "https://blackvue.com/downloads/";
var TUTORIAL = 
// "https://helpcenter.blackvue.com/hc/en-us/sections/205396547-BlackVue-Cloud-Service";
"https://cloudmanual.blackvue.com/docs/blackvueweb/";
var HELPCENTER = "https://helpcenter.blackvue.com/hc/en-us?_ga=2.50642985.1622374351.1606961554-1684053571.1604299594&mobile_site=false";
var HELPCENTER_MOBILE = "https://helpcenter.blackvue.com/hc/en-us?mobile_site=true";
var Privacy_Policy = {
    en: "https://blackvue.com/warranty-terms-conditions/?tab=cloud-privacy-policy",
    ko: "https://blackvue.com/terms-conditions-korean/?tab=privacy_kr",
    jp: "https://blackvue.com/terms-conditions-japan/?tab=privacy_jp"
};
var TermsConditions = {
    en: "https://blackvue.com/warranty-terms-conditions/?tab=cloud-terms-of-service",
    ko: "https://blackvue.com/terms-conditions-korean/?tab=terms_and_conditions_kr",
    jp: "https://blackvue.com/terms-conditions-japan/?tab=terms_and_conditions_jp"
};
var TermsOfLocation = {
    en: "https://blackvue.com/warranty-terms-conditions/?tab=terms-of-location-based-service",
    ko: "https://blackvue.com/terms-conditions-korean/?tab=service_terms_and_conditions_kr",
    jp: "https://blackvue.com/terms-conditions-japan/?tab=service_terms_and_conditions_jp"
};
var InformationWe = {
    en: "https://blackvue.com/warranty-terms-conditions/?tab=information-we-collect-and-why",
    ko: "https://blackvue.com/terms-conditions-korean/?tab=confirmation_of_consent_kr",
    jp: "https://blackvue.com/terms-conditions-japan/?tab=service_terms_and_conditions_jp"
};
var CloudConnectionSettings = 
// "https://cloudmanual.blackvue.com/docs/blackvueapp/change-cloud-connection-settings/";
"https://cloudmanual.blackvue.com/docs/blackvueapp/add-camera/#0-toc-title";
var BlackVueCloud = "https://www.blackvuecloud.com";

var ROWS_PER_PAGE = 50;

var MOBILE_NAME = "webviewer";
var APP_VERSION = "1.0.0";
var TOKEN_TYPE = "web";

var LowvoltageTime = {
    "1": "6h",
    "2": "12h",
    "3": "24h",
    "4": "48h",
};

var LowvoltageVolt = {
    "1": "11.8V & 22.8V",
    "2": "12V &23.2V",
    "3": "12.5V &24V",
};
var LowvoltageVolt_GPRO = {
    "1": "12V & 23.2V",
    "2": "12.2V &23.6V",
    "3": "12.5V &24V",
};

var DEFAULT_MAP_STYLE = "mapbox://styles/pittasoft-mapbox/cl63bx9a8000k15ql4r829si5?optimize=true";
// 영어외 폰트 렌더링 제대로 안되는 브라우져용 스타일
var NO_INT_MAP_STYLE = "mapbox://styles/pittasoft-mapbox/cl9pecumk000415s0iuot2ben?optimize=true";
var SATELLITE_MAP_STYLE = "mapbox://styles/mapbox/satellite-v9?optimize=true";
var DARKMODE_MAP_STYLE = "mapbox://styles/pittasoft-mapbox/clfc7nlwg000d01qc66totbki";
var DEFAULT_ZOOM = process.env.NODE_ENV === "development" ? 15 : 4;
var DEFAULT_LOCATION = process.env.NODE_ENV === "development"
    ? [127.1105433, 37.4032191]
    : [-101.008655, 39.123098];

// 아래 버전보다 작거나 같으면 카메라 세팅메뉴 내 Live Event Upload / Push notifications / Firmware 설정 지원안함 (disable) (7103)
var CAMERA_SETTING_UNSUPPORTED = {
    'DR750S-1CH': 1.017,
    'DR750S-2CH': 1.017,
    'DR900S-1CH': 1.012,
    'DR900S-2CH': 1.012,
    'DR750G-1CH': 1.002,
    'DR750G-2CH': 1.002,
    'DR750-2CH LTE': 1.006,
    'DR750X-1CH': 1.005,
    'DR750X-2CH': 1.005,
    'DR900X-1CH': 1.005,
    'DR900X-2CH': 1.005,
    'DR750G-1CH Pro': 1.0,
    'DR750G-2CH Pro': 1.0,
    'DR750X Plus': 1.0,
    'DR750G Pro': 1.0,
};
var DMC100_MODELS = ['DR750X-3CH Plus'];
var DMC200_MODELS = [
    'DR750X LTE Plus',
    'DR750X Plus',
    'DR900X Plus',
    'DR770X',
    'K770X',
];
var BOXPRO_MODELS = ['DR770X Box Pro'];
var MODELS_1CH = [
    'DR750S-1CH',
    'DR900S-1CH',
    'DR750G-1CH',
    'DR750X-1CH',
    'DR900X-1CH',
    // "DR590X-1CH",
    'DR590X-1CH Plus',
    'DR750G-1CH Pro',
];
var MODELS_2CH = [
    'DR750S-2CH',
    'DR900S-2CH',
    'DR750G-2CH',
    'DR750-2CH LTE',
    'DR750X-2CH',
    'DR900X-2CH',
    // "DR590X-2CH",
    'DR590X-2CH Plus',
    'DR750G-2CH Pro',
    'DR750X Plus',
    // "DR750LTE Plus",
    'DR900X Plus',
    'DR750G Pro',
    'DR750X LTE Plus',
    // "DR750K LTE",
    'DR770X',
    'DR790X',
    'DR770X-2CH DMS II',
    'DR770X LTE',
    'DR790X LTE',
    'BlackVue 7G Pro',
    'DR970X',
    'DR970X LTE',
    'DR800 GOLD',
    'DR800Gold Pro',
    'DR970X Plus',
    'DR970X LTE Plus',
    'DR970X Box Plus',
    'K770X',
    'K970X Plus',
    'ELITE 8',
    'ELITE 9',
    'ELITE 10',
    'ELITE + GOLD',
];
var MODELS_3CH = [
    'DR750X-3CH Plus',
    'DR770X Box',
    'DR770X Box Pro',
];
var LOW_VOLTAGE_MODELS = [
    'DR750X-1CH',
    'DR900X-1CH',
    // "DR590X-1CH",
    'DR750X-2CH',
    'DR900X-2CH',
    // "DR590X-2CH",
    'DR750X Plus',
    'DR900X Plus',
    'DR750X-3CH Plus',
    'DR770X',
    'DR790X',
    'DR770X Box',
    'DR770X-2CH DMS II',
    'DR770X LTE',
    'DR770X Box Pro',
    'DR790X LTE',
    'BlackVue 7G Pro',
    'DR970X',
    'DR970X LTE',
    // mantis - 10635 시그마 DR800Gold 모델 Low voltage warning항목 노출되도록 추가(Leehj)
    'DR800 GOLD',
    'DR800Gold Pro',
    // mantis - 10584, DR750X LTE Plus모델 Low voltage warning항목 노출되도록 추가(Leehj)
    'DR750X LTE Plus',
    // mantis - 12565, DR970X Plus 시리즈 Low voltage warning항목 추가(Hongcs)
    'DR970X Plus',
    'DR970X LTE Plus',
    'DR970X Box Plus',
    'K770X',
    'K970X Plus',
    'ELITE 8',
    'ELITE 9',
    'ELITE 10',
    'ELITE + GOLD',
];
var BATTERY_PROTECTION_WARNING_MODELS = [
    'DR750G Pro',
    'DR750G-1CH Pro',
    'DR750G-2CH Pro',
    'BlackVue 7G Pro',
    // mantis - 10299 Recording Mode setting G Model인 경우 설정 변경 경고 팝업창 출력을 위한 모델추가 (Leehj)
    'DR800 GOLD',
    'DR800Gold Pro',
    'ELITE 8',
    'ELITE 9',
    'ELITE 10',
    'ELITE + GOLD',
];
var HDR_RESTARTING_MODEL = [
    'DR900S-1CH',
    'DR900S-2CH',
    'DR900X-1CH',
    'DR900X-2CH',
    'DR750G-1CH Pro',
    'DR750G-2CH Pro',
    'DR750G Pro',
];
var UnableAddCameraPSN4 = [
    'D65G',
    'DR65',
    'D65S',
    'DR6S',
    '59X1',
    '59X2',
];
var PSN650 = ['D65G', 'DR65', 'D65S', 'DR6S'];
// 옵션 카메라로 표시되는 모델 추가 8487/
var OPTION_CAMERA_MODELS = [
    'DR770X Box',
    'DR770X Box Pro',
];
// SOS 버튼 표시 모델 추가 (Hongcs)
var SOS_BUTTON_MODELS = [
    'DR770X Box',
    'DR770X Box Pro',
    'DR970X Box Plus',
];
var TOUCH_SENSOR_MODELS = [
    'DR770X',
    'DR790X',
    'DR770X-2CH DMS II',
    'BlackVue 7G Pro',
    'DR770X LTE',
    'DR790X LTE',
    'DR970X',
    'DR970X LTE',
    'DR800 GOLD',
    'DR800Gold Pro',
    'DR970X Plus',
    'DR970X LTE Plus',
    'DR970X Box Plus',
    'K770X',
    'K970X Plus',
];
// WifiSleepMode 표시 안되는 모델 추가 8653
var NON_WIFI_SLEEP_MODELS = [
    'DR770X',
    'DR790X',
    'DR770X Box',
    'DR770X LTE',
    'DR770X Box Pro',
    'DR790X LTE',
    'BlackVue 7G Pro',
    'DR970X',
    'DR970X LTE',
    'DR970X Plus',
    'DR970X LTE Plus',
    'DR970X Box Plus',
    'K770X',
    'K970X Plus',
];
// Sigmastar 모델 추가
var SIGMASTAR_MODELS = [
    'DR770X',
    'DR790X',
    'DR770X Box',
    'DR770X LTE',
    'DR770X Box Pro',
    'DR790X LTE',
    'BlackVue 7G Pro',
    'DR970X',
    'DR970X LTE',
    'DR800 GOLD',
    'DR800Gold Pro',
    'DR970X Plus',
    'DR970X LTE Plus',
    'DR970X Box Plus',
    'K770X',
    'K970X Plus',
];
// Sigmastar X Plus 모델 추가 (Hongcs)
var SIGMASTAR_XPLUS_MODELS = [
    'DR970X Plus',
    'DR970X LTE Plus',
    'DR970X Box Plus',
    'K970X Plus',
];
// 클라우드 사용 가능한 구모델 추가(Leehj)
var ENABLED_CLOUD_OLD_MODELS = [
    // 구모델
    'DR650GW-1CH',
    'DR650GW-2CH',
    'DR650S-1CH',
    'DR650S-2CH',
    'DR750S-1CH',
    'DR750S-2CH',
    'DR900S-1CH',
    'DR900S-2CH',
    'DR750X-1CH',
    'DR750X-2CH',
    'DR900X-1CH',
    'DR900X-2CH',
    'DR750-2CH LTE',
    'DR750G-1CH',
    'DR750G-2CH',
    'DR750G-1CH Pro',
    'DR750G-2CH Pro',
    'DR750G Pro',
];
// 구모델 추가
var OLD_MODELS = [
    'DR500W-1CH',
    'DR500GW-HD',
    'DR530W-2CH',
    'DR550GW-1CH',
    'DR550GW-2CH',
    'DR590W-1CH',
    'DR590W-2CH',
    'DR590X-1CH',
    'DR590X-2CH',
    'DR600GW-HD',
    'DR750LW-2CH',
    'DR650GW-1CH',
    'DR650GW-2CH',
    'DR650S-1CH',
    'DR650S-2CH',
    'DR750S-1CH',
    'DR750S-2CH',
    'DR900S-1CH',
    'DR900S-2CH',
    'DR750X-1CH',
    'DR750X-2CH',
    'DR900X-1CH',
    'DR900X-2CH',
    'DR750-2CH LTE',
    'DR750G-1CH',
    'DR750G-2CH',
    'DR750G-1CH Pro',
    'DR750G-2CH Pro',
    'DR590X-1CH Plus',
    'DR590X-2CH Plus',
    '590X2',
];
// Drows 모델 추가
var DROWS_SUPPORTED = {
    'DR750X Plus': 1.011,
    'DR750X LTE Plus': 1.006,
    'DR900X Plus': 1.009,
    DR770X: 1.0,
    'DR770X LTE': 1.0,
    'DR770X Box': 1.0,
    'DR770X Box Pro': 1.0,
    K770X: 1.0,
};
// mantis - 12440, Format microSD card 지원모델 (Leehj)
var FORMAT_MICROSD_CARD_MODEL = {
    'DR750X Plus': 1.003,
    'DR900X Plus': 1.003,
    'DR750G Pro': 1.003,
    'DR750X LTE Plus': 1.0,
    'DR750X-3CH Plus': 1.0,
    DR770X: 1.0,
    'DR770X Box': 1.0,
    'DR770X LTE': 1.0,
    'DR770X Box Pro': 1.0,
    'DR790X LTE': 1.0,
    'BlackVue 7G Pro': 1.0,
    DR970X: 1.0,
    'DR970X LTE': 1.0,
    'DR800 GOLD': 1.0,
    'DR800Gold Pro': 1.0,
    'DR970X Plus': 1.0,
    'DR970X LTE Plus': 1.0,
    'DR970X Box Plus': 1.0,
    K770X: 1.0,
    'K970X Plus': 1.0,
    'ELITE 8': 1.0,
    'ELITE 9': 1.0,
    'ELITE 10': 1.0,
    'ELITE + GOLD': 1.0,
};
// High temperature protection 모델 추가
var HIGHTEMPER_PROTECTION_MODALS = {
    DR970X: 1.006,
    'DR970X LTE': 1.006,
    'DR770X LTE': 1.006,
};
var BATTERY_CLOUD_SUPPORTED = {
    'DR750X Plus': 1.016,
    'DR750G-2CH Pro': 1.012,
    'DR750G Pro': 1.012,
    'DR750X LTE Plus': 1.011,
    'DR900X Plus': 1.014,
    DR770X: 1.007,
    K770X: 0.9,
    DR970X: 1.008,
    'DR770X LTE': 1.009,
    'DR970X LTE': 1.009,
    'DR770X Box': 1.009,
    'DR770X Box Pro': 0.9,
    'DR800 GOLD': 1.003,
    'DR970X Plus': 1.002,
    'K970X Plus': 0.9,
    'DR970X LTE Plus': 1.003,
    'DR970X Box Plus': 1.002,
    'ELITE 8': 0.9,
    'ELITE 9': 0.9,
    'ELITE 10': 0.9,
    'ELITE + GOLD': 0.9,
};
var RCT_TIMESYNC_MODALS = {
    DR770X: 1.009,
    DR970X: 1.009,
    'DR970X Plus': 1.004,
    'DR770X Box': 1.01,
    K770X: 1.0,
    'K970X Plus': 1.0,
    'DR770X-2CH DMS II': 0.9,
};
var BOXPRO_EXTEND_MODELS = {
    DR770X: 1.013,
    K770X: 1.001,
    DR970X: 1.012,
    'DR770X LTE': 1.013,
    'DR970X LTE': 1.013,
    'DR770X Box': 1.013,
    'DR800 GOLD': 1.007,
    'DR970X Plus': 1.008,
    'K970X Plus': 1.001,
    'DR970X LTE Plus': 1.007,
    'DR970X Box Plus': 1.006,
    'DR770X Box Pro': 1.0,
    'DR770X-2CH DMS II': 0.9,
    'ELITE 8': 0.9,
    'ELITE 9': 0.9,
    'ELITE 10': 0.9,
    'ELITE + GOLD': 0.9,
};
var EVENT_AUTO_UPLOAD_MODELS = [
    'DR650GW-1CH',
    'DR650GW-2CH',
    'DR650S-1CH',
    'DR650S-2CH',
];
var ELITE_MODELS = ['ELITE 8', 'ELITE 9', 'ELITE 10', 'ELITE + GOLD'];

var LITE = 3.99;
var SMART = 7.99;
var LITE_EXTRA = 3;
var SMART_EXTRA = 6;
var FLEET_PRICE = 15.99;
var FLEET_EXTRA = 12;
var MAX_CAM_COUNT = 999;

var ScheduledRebootTime = {
    "1": "01:00",
    "2": "02:00",
    "3": "03:00",
    "4": "04:00",
    "5": "05:00",
    "6": "06:00",
    "7": "07:00",
    "8": "08:00",
    "9": "09:00",
    "10": "10:00",
    "11": "11:00",
    "12": "12:00",
    "13": "13:00",
    "14": "14:00",
    "15": "15:00",
    "16": "16:00",
    "17": "17:00",
    "18": "18:00",
    "19": "19:00",
    "20": "20:00",
    "21": "21:00",
    "22": "22:00",
    "23": "23:00",
    "24": "24:00",
};

var EVENTMAP_REV_TILE_URI;
// if (process.env.NODE_ENV === "development") {
//   EVENTMAP_REV_TILE_URI = "https://d1bd8gyrzespxs.cloudfront.net";
//   // "https://d1bd8gyrzespxs.cloudfront.net";
//   // "https://3r412o3j8b.execute-api.ap-northeast-2.amazonaws.com/dev";
//   // EVENTMAP_REV_TILE_URI = "http://localhost:3000/dev";
//   // EVENTMAP_REV_TILE_URI = "https://djlrh4ffm0092.cloudfront.net";
//   // EVENTMAP_REV_TILE_URI = "https://d2at5a73ayeid1.cloudfront.net";
// } else
if (process.env.REACT_APP_ENV === 'qa') {
    EVENTMAP_REV_TILE_URI = 'https://d1bd8gyrzespxs.cloudfront.net';
}
else if (process.env.REACT_APP_ENV === 'staging') {
    // EVENTMAP_REV_TILE_URI = "https://d2at5a73ayeid1.cloudfront.net";
    EVENTMAP_REV_TILE_URI = 'https://djlrh4ffm0092.cloudfront.net';
}
else if (process.env.REACT_APP_ENV === 'production') {
    EVENTMAP_REV_TILE_URI = 'https://djlrh4ffm0092.cloudfront.net';
}
var EVENTMAP_REV_API_SERVER_URI;
// if (process.env.NODE_ENV === "development") {
//   EVENTMAP_REV_API_SERVER_URI =
//     // "https://3r412o3j8b.execute-api.ap-northeast-2.amazonaws.com/dev";
//     // "https://2p7mljc3gg.execute-api.us-west-1.amazonaws.com/stage";
//     "https://r5ec4uwj9i.execute-api.us-west-1.amazonaws.com/prod";
//   // "http://localhost:3000/dev";
// } else
if (process.env.REACT_APP_ENV === 'qa') {
    EVENTMAP_REV_API_SERVER_URI =
        'https://3r412o3j8b.execute-api.ap-northeast-2.amazonaws.com/dev';
}
else if (process.env.REACT_APP_ENV === 'staging') {
    EVENTMAP_REV_API_SERVER_URI =
        // "https://2p7mljc3gg.execute-api.us-west-1.amazonaws.com/stage";
        'https://r5ec4uwj9i.execute-api.us-west-1.amazonaws.com/prod';
}
else if (process.env.REACT_APP_ENV === 'production') {
    EVENTMAP_REV_API_SERVER_URI =
        'https://r5ec4uwj9i.execute-api.us-west-1.amazonaws.com/prod';
}
var MAINTENANCE_SERVER_URI;
if (process.env.NODE_ENV === 'development') {
    MAINTENANCE_SERVER_URI = '/blackvuesrc3/maintenance/maintenance_dev.json';
}
else if (process.env.REACT_APP_ENV === 'qa') {
    MAINTENANCE_SERVER_URI =
        'https://blackvuesrc3.blackvuecloud.com/maintenance/maintenance_dev.json';
}
else if (process.env.REACT_APP_ENV === 'staging') {
    MAINTENANCE_SERVER_URI =
        'https://blackvuesrc3.blackvuecloud.com/maintenance/maintenance_stage.json';
}
else if (process.env.REACT_APP_ENV === 'production') {
    MAINTENANCE_SERVER_URI =
        'https://blackvuesrc3.blackvuecloud.com/maintenance/maintenance.json';
}
// export let LOGIN_SERVER_URI: string;
// if (process.env.NODE_ENV === "development") {
//   LOGIN_SERVER_URI = "/lambda";
// } else if (process.env.REACT_APP_ENV === "qa") {
//   LOGIN_SERVER_URI =
//     "https://ucxw6yl3zk.execute-api.ap-northeast-2.amazonaws.com/dev";
// } else if (process.env.REACT_APP_ENV === "staging") {
// } else if (process.env.REACT_APP_ENV === "production") {
//   LOGIN_SERVER_URI =
//     "https://mcybl18i03.execute-api.ap-northeast-2.amazonaws.com/prod";
// }
var SIMCARD_URI;
if (process.env.NODE_ENV === 'development') {
    SIMCARD_URI = 'http://localhost:3001';
}
else if (process.env.REACT_APP_ENV === 'qa') {
    SIMCARD_URI = 'https://sim-dev.blackvuecloud.com';
}
else if (process.env.REACT_APP_ENV === 'staging') {
    SIMCARD_URI = 'https://sim-stage.blackvuecloud.com';
}
else if (process.env.REACT_APP_ENV === 'production') {
    SIMCARD_URI = 'https://sim.blackvuecloud.com';
}
var ALPHA_API_SERVER_URI = 'https://alpha1.blackvuecloud.com';
var PRODUCTION_API_SERVER_URI = 'https://api.blackvuecloud.com';
var STAGE_API_SERVER_URI = 'https://api.blackvuecloud.com';
var API_SERVER_URI;
if (process.env.NODE_ENV === 'development') {
    API_SERVER_URI = '/api';
}
else if (process.env.REACT_APP_ENV === 'qa') {
    API_SERVER_URI = ALPHA_API_SERVER_URI;
}
else if (process.env.REACT_APP_ENV === 'staging') {
    API_SERVER_URI = STAGE_API_SERVER_URI;
}
else if (process.env.REACT_APP_ENV === 'production') {
    API_SERVER_URI = PRODUCTION_API_SERVER_URI;
}
var ALPHA_API_GATEWAY_URI = 'https://alpha-gateway.blackvuecloud.com';
var PRODUCTION_API_GATEWAY_URI = 'https://gateway.blackvuecloud.com';
var STAGE_API_GATEWAY_URI = 'https://stage-gateway.blackvuecloud.com';
var API_GATEWAY_URI;
if (process.env.NODE_ENV === 'development') {
    API_GATEWAY_URI = '/gateway';
}
else if (process.env.REACT_APP_ENV === 'qa') {
    API_GATEWAY_URI = ALPHA_API_GATEWAY_URI;
}
else if (process.env.REACT_APP_ENV === 'staging') {
    API_GATEWAY_URI = STAGE_API_GATEWAY_URI;
}
else if (process.env.REACT_APP_ENV === 'production') {
    API_GATEWAY_URI = PRODUCTION_API_GATEWAY_URI;
}
var FIRMWARE_INFO_URI;
if (process.env.NODE_ENV === 'development') {
    FIRMWARE_INFO_URI = '/blackvuesrc3/fw_folder/firmware_info_test.json';
}
else if (process.env.REACT_APP_ENV === 'production') {
    FIRMWARE_INFO_URI =
        'https://blackvuesrc3.blackvuecloud.com/fw_folder/firmware_info.json';
}
else {
    FIRMWARE_INFO_URI =
        'https://blackvuesrc3.blackvuecloud.com/fw_folder/firmware_info_test.json';
}
var ALPHA_WS_SERVER_URI = 'wss://alpha-webpush.blackvuecloud.com:15673/ws/';
var PRODUCTION_WS_SERVER_URI = 'wss://webpush.blackvuecloud.com:15673/ws/';
var WS_SERVER_URI;
if (process.env.REACT_APP_ENV === 'qa') {
    WS_SERVER_URI = ALPHA_WS_SERVER_URI;
}
else if (process.env.REACT_APP_ENV === 'production' ||
    process.env.REACT_APP_ENV === 'staging') {
    WS_SERVER_URI = PRODUCTION_WS_SERVER_URI;
}
var STRIPE_OS_TYPE;
if (process.env.NODE_ENV === 'development') {
    STRIPE_OS_TYPE = 'stripe_sandbox';
}
else if (process.env.REACT_APP_ENV === 'qa' ||
    process.env.REACT_APP_ENV === 'staging') {
    STRIPE_OS_TYPE = 'stripe_sandbox';
}
else if (process.env.REACT_APP_ENV === 'production') {
    STRIPE_OS_TYPE = 'stripe';
}
var STRIPE_API_KEY;
if (process.env.NODE_ENV === 'development') {
    STRIPE_API_KEY = 'pk_test_30Ah19N51uj4ErDcR3beBiZU00ydngcn0Z';
}
else if (process.env.REACT_APP_ENV === 'qa' ||
    process.env.REACT_APP_ENV === 'staging') {
    STRIPE_API_KEY = 'pk_test_30Ah19N51uj4ErDcR3beBiZU00ydngcn0Z';
}
else if (process.env.REACT_APP_ENV === 'production') {
    STRIPE_API_KEY = 'pk_live_sQMEB5KXacXq1HLdJv36FDd100ZGI7aNZm';
}
var SERVER_MAINTENANCE_NOTICE_URI = 'https://blackvue.com/blog/';
var getS3URI = function (presignedURL) {
    if (process.env.NODE_ENV === 'development') {
        if (process.env.REACT_APP_ENV === 'qa') {
            return presignedURL.replace('https://s3.ap-northeast-2.amazonaws.com', '/s3');
        }
        else if (process.env.REACT_APP_ENV === 'production') {
            return presignedURL.replace('https://s3-ap-southeast-1.amazonaws.com', '/s3-prod');
        }
    }
    return presignedURL;
};
var getLbURI = function (server_name, port) {
    var uri = "https://".concat(server_name, ":").concat(port);
    if (process.env.NODE_ENV === 'development') {
        if (port === '11001') {
            uri = '/lb1';
        }
        else if (port === '11002') {
            uri = '/lb2';
        }
        else if (port === '11003') {
            uri = '/lb3';
        }
        else if (port === '11004') {
            uri = '/lb4';
        }
    }
    return uri;
};
var getFotaURI = function (uri) {
    if (process.env.NODE_ENV === 'development') {
        return uri.replace('https://fota.blackvuecloud.com', '/fota');
    }
    return uri;
};
var ALPHA_GPS_WS_SERVER_URI = 'wss://gps-websocket-001.blackvuecloud.com';
var PRODUCTION_GPS_WS_SERVER_URI = 'wss://gps-websocket.blackvuecloud.com';
var GPS_WS_SERVER_URI = ALPHA_GPS_WS_SERVER_URI;
// if (process.env.REACT_APP_ENV === "development") {
//   GPS_WS_SERVER_URI = "wss://gps-websocket-001.blackvuecloud.com";
// } else
if (process.env.REACT_APP_ENV === 'qa') {
    GPS_WS_SERVER_URI = ALPHA_GPS_WS_SERVER_URI;
}
else if (process.env.REACT_APP_ENV === 'staging') {
    GPS_WS_SERVER_URI = PRODUCTION_GPS_WS_SERVER_URI;
}
else if (process.env.REACT_APP_ENV === 'production') {
    GPS_WS_SERVER_URI = PRODUCTION_GPS_WS_SERVER_URI;
}

var SystemADASLDWS = {
    "0": "Off",
    "1": "On(50km/h)",
    "2": "On(60km/h)",
    "3": "On(70km/h)",
};

function chainPropTypes(propType1, propType2) {
  if (process.env.NODE_ENV === 'production') {
    return function () {
      return null;
    };
  }

  return function validate() {
    return propType1.apply(void 0, arguments) || propType2.apply(void 0, arguments);
  };
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

function _typeof$1(obj) {
  "@babel/helpers - typeof";

  return _typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof$1(obj);
}

function isPlainObject$1(item) {
  return item && _typeof$1(item) === 'object' && item.constructor === Object;
}
function deepmerge(target, source) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    clone: true
  };
  var output = options.clone ? _extends({}, target) : target;

  if (isPlainObject$1(target) && isPlainObject$1(source)) {
    Object.keys(source).forEach(function (key) {
      // Avoid prototype pollution
      if (key === '__proto__') {
        return;
      }

      if (isPlainObject$1(source[key]) && key in target) {
        output[key] = deepmerge(target[key], source[key], options);
      } else {
        output[key] = source[key];
      }
    });
  }

  return output;
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function getAugmentedNamespace(n) {
  if (n.__esModule) return n;
  var f = n.default;
	if (typeof f == "function") {
		var a = function a () {
			if (this instanceof a) {
				var args = [null];
				args.push.apply(args, arguments);
				var Ctor = Function.bind.apply(f, args);
				return new Ctor();
			}
			return f.apply(this, arguments);
		};
		a.prototype = f.prototype;
  } else a = {};
  Object.defineProperty(a, '__esModule', {value: true});
	Object.keys(n).forEach(function (k) {
		var d = Object.getOwnPropertyDescriptor(n, k);
		Object.defineProperty(a, k, d.get ? d : {
			enumerable: true,
			get: function () {
				return n[k];
			}
		});
	});
	return a;
}

var propTypes = {exports: {}};

var reactIs$2 = {exports: {}};

var reactIs_production_min$1 = {};

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_production_min$1;

function requireReactIs_production_min$1 () {
	if (hasRequiredReactIs_production_min$1) return reactIs_production_min$1;
	hasRequiredReactIs_production_min$1 = 1;
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
	Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
	function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}reactIs_production_min$1.AsyncMode=l;reactIs_production_min$1.ConcurrentMode=m;reactIs_production_min$1.ContextConsumer=k;reactIs_production_min$1.ContextProvider=h;reactIs_production_min$1.Element=c;reactIs_production_min$1.ForwardRef=n;reactIs_production_min$1.Fragment=e;reactIs_production_min$1.Lazy=t;reactIs_production_min$1.Memo=r;reactIs_production_min$1.Portal=d;
	reactIs_production_min$1.Profiler=g;reactIs_production_min$1.StrictMode=f;reactIs_production_min$1.Suspense=p;reactIs_production_min$1.isAsyncMode=function(a){return A(a)||z(a)===l};reactIs_production_min$1.isConcurrentMode=A;reactIs_production_min$1.isContextConsumer=function(a){return z(a)===k};reactIs_production_min$1.isContextProvider=function(a){return z(a)===h};reactIs_production_min$1.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};reactIs_production_min$1.isForwardRef=function(a){return z(a)===n};reactIs_production_min$1.isFragment=function(a){return z(a)===e};reactIs_production_min$1.isLazy=function(a){return z(a)===t};
	reactIs_production_min$1.isMemo=function(a){return z(a)===r};reactIs_production_min$1.isPortal=function(a){return z(a)===d};reactIs_production_min$1.isProfiler=function(a){return z(a)===g};reactIs_production_min$1.isStrictMode=function(a){return z(a)===f};reactIs_production_min$1.isSuspense=function(a){return z(a)===p};
	reactIs_production_min$1.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};reactIs_production_min$1.typeOf=z;
	return reactIs_production_min$1;
}

var reactIs_development$1 = {};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_development$1;

function requireReactIs_development$1 () {
	if (hasRequiredReactIs_development$1) return reactIs_development$1;
	hasRequiredReactIs_development$1 = 1;



	if (process.env.NODE_ENV !== "production") {
	  (function() {

	// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	var hasSymbol = typeof Symbol === 'function' && Symbol.for;
	var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
	var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
	var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
	var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
	var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
	var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
	var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
	// (unstable) APIs that have been removed. Can we remove the symbols?

	var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
	var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
	var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
	var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
	var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
	var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
	var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
	var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
	var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
	var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
	var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

	function isValidElementType(type) {
	  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
	  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
	}

	function typeOf(object) {
	  if (typeof object === 'object' && object !== null) {
	    var $$typeof = object.$$typeof;

	    switch ($$typeof) {
	      case REACT_ELEMENT_TYPE:
	        var type = object.type;

	        switch (type) {
	          case REACT_ASYNC_MODE_TYPE:
	          case REACT_CONCURRENT_MODE_TYPE:
	          case REACT_FRAGMENT_TYPE:
	          case REACT_PROFILER_TYPE:
	          case REACT_STRICT_MODE_TYPE:
	          case REACT_SUSPENSE_TYPE:
	            return type;

	          default:
	            var $$typeofType = type && type.$$typeof;

	            switch ($$typeofType) {
	              case REACT_CONTEXT_TYPE:
	              case REACT_FORWARD_REF_TYPE:
	              case REACT_LAZY_TYPE:
	              case REACT_MEMO_TYPE:
	              case REACT_PROVIDER_TYPE:
	                return $$typeofType;

	              default:
	                return $$typeof;
	            }

	        }

	      case REACT_PORTAL_TYPE:
	        return $$typeof;
	    }
	  }

	  return undefined;
	} // AsyncMode is deprecated along with isAsyncMode

	var AsyncMode = REACT_ASYNC_MODE_TYPE;
	var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
	var ContextConsumer = REACT_CONTEXT_TYPE;
	var ContextProvider = REACT_PROVIDER_TYPE;
	var Element = REACT_ELEMENT_TYPE;
	var ForwardRef = REACT_FORWARD_REF_TYPE;
	var Fragment = REACT_FRAGMENT_TYPE;
	var Lazy = REACT_LAZY_TYPE;
	var Memo = REACT_MEMO_TYPE;
	var Portal = REACT_PORTAL_TYPE;
	var Profiler = REACT_PROFILER_TYPE;
	var StrictMode = REACT_STRICT_MODE_TYPE;
	var Suspense = REACT_SUSPENSE_TYPE;
	var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

	function isAsyncMode(object) {
	  {
	    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
	      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

	      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
	    }
	  }

	  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
	}
	function isConcurrentMode(object) {
	  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
	}
	function isContextConsumer(object) {
	  return typeOf(object) === REACT_CONTEXT_TYPE;
	}
	function isContextProvider(object) {
	  return typeOf(object) === REACT_PROVIDER_TYPE;
	}
	function isElement(object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	}
	function isForwardRef(object) {
	  return typeOf(object) === REACT_FORWARD_REF_TYPE;
	}
	function isFragment(object) {
	  return typeOf(object) === REACT_FRAGMENT_TYPE;
	}
	function isLazy(object) {
	  return typeOf(object) === REACT_LAZY_TYPE;
	}
	function isMemo(object) {
	  return typeOf(object) === REACT_MEMO_TYPE;
	}
	function isPortal(object) {
	  return typeOf(object) === REACT_PORTAL_TYPE;
	}
	function isProfiler(object) {
	  return typeOf(object) === REACT_PROFILER_TYPE;
	}
	function isStrictMode(object) {
	  return typeOf(object) === REACT_STRICT_MODE_TYPE;
	}
	function isSuspense(object) {
	  return typeOf(object) === REACT_SUSPENSE_TYPE;
	}

	reactIs_development$1.AsyncMode = AsyncMode;
	reactIs_development$1.ConcurrentMode = ConcurrentMode;
	reactIs_development$1.ContextConsumer = ContextConsumer;
	reactIs_development$1.ContextProvider = ContextProvider;
	reactIs_development$1.Element = Element;
	reactIs_development$1.ForwardRef = ForwardRef;
	reactIs_development$1.Fragment = Fragment;
	reactIs_development$1.Lazy = Lazy;
	reactIs_development$1.Memo = Memo;
	reactIs_development$1.Portal = Portal;
	reactIs_development$1.Profiler = Profiler;
	reactIs_development$1.StrictMode = StrictMode;
	reactIs_development$1.Suspense = Suspense;
	reactIs_development$1.isAsyncMode = isAsyncMode;
	reactIs_development$1.isConcurrentMode = isConcurrentMode;
	reactIs_development$1.isContextConsumer = isContextConsumer;
	reactIs_development$1.isContextProvider = isContextProvider;
	reactIs_development$1.isElement = isElement;
	reactIs_development$1.isForwardRef = isForwardRef;
	reactIs_development$1.isFragment = isFragment;
	reactIs_development$1.isLazy = isLazy;
	reactIs_development$1.isMemo = isMemo;
	reactIs_development$1.isPortal = isPortal;
	reactIs_development$1.isProfiler = isProfiler;
	reactIs_development$1.isStrictMode = isStrictMode;
	reactIs_development$1.isSuspense = isSuspense;
	reactIs_development$1.isValidElementType = isValidElementType;
	reactIs_development$1.typeOf = typeOf;
	  })();
	}
	return reactIs_development$1;
}

if (process.env.NODE_ENV === 'production') {
  reactIs$2.exports = requireReactIs_production_min$1();
} else {
  reactIs$2.exports = requireReactIs_development$1();
}

var reactIsExports$1 = reactIs$2.exports;

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */
var getOwnPropertySymbols$1 = Object.getOwnPropertySymbols;
var hasOwnProperty$1 = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty$1.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols$1) {
			symbols = getOwnPropertySymbols$1(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret_1;
var hasRequiredReactPropTypesSecret;

function requireReactPropTypesSecret () {
	if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
	hasRequiredReactPropTypesSecret = 1;

	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

	ReactPropTypesSecret_1 = ReactPropTypesSecret;
	return ReactPropTypesSecret_1;
}

var has$4;
var hasRequiredHas;

function requireHas () {
	if (hasRequiredHas) return has$4;
	hasRequiredHas = 1;
	has$4 = Function.call.bind(Object.prototype.hasOwnProperty);
	return has$4;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var checkPropTypes_1;
var hasRequiredCheckPropTypes;

function requireCheckPropTypes () {
	if (hasRequiredCheckPropTypes) return checkPropTypes_1;
	hasRequiredCheckPropTypes = 1;

	var printWarning = function() {};

	if (process.env.NODE_ENV !== 'production') {
	  var ReactPropTypesSecret = requireReactPropTypesSecret();
	  var loggedTypeFailures = {};
	  var has = requireHas();

	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) { /**/ }
	  };
	}

	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (process.env.NODE_ENV !== 'production') {
	    for (var typeSpecName in typeSpecs) {
	      if (has(typeSpecs, typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          if (typeof typeSpecs[typeSpecName] !== 'function') {
	            var err = Error(
	              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
	              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' +
	              'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.'
	            );
	            err.name = 'Invariant Violation';
	            throw err;
	          }
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        if (error && !(error instanceof Error)) {
	          printWarning(
	            (componentName || 'React class') + ': type specification of ' +
	            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
	            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
	            'You may have forgotten to pass an argument to the type checker ' +
	            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
	            'shape all require an argument).'
	          );
	        }
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;

	          var stack = getStack ? getStack() : '';

	          printWarning(
	            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
	          );
	        }
	      }
	    }
	  }
	}

	/**
	 * Resets warning cache when testing.
	 *
	 * @private
	 */
	checkPropTypes.resetWarningCache = function() {
	  if (process.env.NODE_ENV !== 'production') {
	    loggedTypeFailures = {};
	  }
	};

	checkPropTypes_1 = checkPropTypes;
	return checkPropTypes_1;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var factoryWithTypeCheckers;
var hasRequiredFactoryWithTypeCheckers;

function requireFactoryWithTypeCheckers () {
	if (hasRequiredFactoryWithTypeCheckers) return factoryWithTypeCheckers;
	hasRequiredFactoryWithTypeCheckers = 1;

	var ReactIs = reactIsExports$1;
	var assign = objectAssign;

	var ReactPropTypesSecret = requireReactPropTypesSecret();
	var has = requireHas();
	var checkPropTypes = requireCheckPropTypes();

	var printWarning = function() {};

	if (process.env.NODE_ENV !== 'production') {
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}

	function emptyFunctionThatReturnsNull() {
	  return null;
	}

	factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }

	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */

	  var ANONYMOUS = '<<anonymous>>';

	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bigint: createPrimitiveTypeChecker('bigint'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),

	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    elementType: createElementTypeTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };

	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/

	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message, data) {
	    this.message = message;
	    this.data = data && typeof data === 'object' ? data: {};
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;

	  function createChainableTypeChecker(validate) {
	    if (process.env.NODE_ENV !== 'production') {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;

	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          var err = new Error(
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	          err.name = 'Invariant Violation';
	          throw err;
	        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            printWarning(
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }

	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);

	    return chainedCheckType;
	  }

	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);

	        return new PropTypeError(
	          'Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'),
	          {expectedType: expectedType}
	        );
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
	  }

	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createElementTypeTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!ReactIs.isValidElementType(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	      if (process.env.NODE_ENV !== 'production') {
	        if (arguments.length > 1) {
	          printWarning(
	            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
	            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
	          );
	        } else {
	          printWarning('Invalid argument supplied to oneOf, expected an array.');
	        }
	      }
	      return emptyFunctionThatReturnsNull;
	    }

	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }

	      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
	        var type = getPreciseType(value);
	        if (type === 'symbol') {
	          return String(value);
	        }
	        return value;
	      });
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (has(propValue, key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunctionThatReturnsNull;
	    }

	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        printWarning(
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
	        );
	        return emptyFunctionThatReturnsNull;
	      }
	    }

	    function validate(props, propName, componentName, location, propFullName) {
	      var expectedTypes = [];
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
	        if (checkerResult == null) {
	          return null;
	        }
	        if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
	          expectedTypes.push(checkerResult.data.expectedType);
	        }
	      }
	      var expectedTypesMessage = (expectedTypes.length > 0) ? ', expected one of type [' + expectedTypes.join(', ') + ']': '';
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function invalidValidatorError(componentName, location, propFullName, key, type) {
	    return new PropTypeError(
	      (componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' +
	      'it must be a function, usually from the `prop-types` package, but received `' + type + '`.'
	    );
	  }

	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (typeof checker !== 'function') {
	          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from props.
	      var allKeys = assign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (has(shapeTypes, key) && typeof checker !== 'function') {
	          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
	        }
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }

	    return createChainableTypeChecker(validate);
	  }

	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }

	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }

	        return true;
	      default:
	        return false;
	    }
	  }

	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }

	    // falsy value can't be a Symbol
	    if (!propValue) {
	      return false;
	    }

	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }

	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }

	    return false;
	  }

	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }

	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }

	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }

	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }

	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
	  ReactPropTypes.PropTypes = ReactPropTypes;

	  return ReactPropTypes;
	};
	return factoryWithTypeCheckers;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var factoryWithThrowingShims;
var hasRequiredFactoryWithThrowingShims;

function requireFactoryWithThrowingShims () {
	if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
	hasRequiredFactoryWithThrowingShims = 1;

	var ReactPropTypesSecret = requireReactPropTypesSecret();

	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;

	factoryWithThrowingShims = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  }	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  }	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bigint: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,

	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,

	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };

	  ReactPropTypes.PropTypes = ReactPropTypes;

	  return ReactPropTypes;
	};
	return factoryWithThrowingShims;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs = reactIsExports$1;

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  propTypes.exports = requireFactoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  propTypes.exports = requireFactoryWithThrowingShims()();
}

var propTypesExports = propTypes.exports;
var PropTypes = /*@__PURE__*/getDefaultExportFromCjs(propTypesExports);

function _toPrimitive(input, hint) {
  if (_typeof$1(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof$1(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}

function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof$1(key) === "symbol" ? key : String(key);
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

// This module is based on https://github.com/airbnb/prop-types-exact repository.
// However, in order to reduce the number of dependencies and to remove some extra safe checks
// the module was forked.
// Only exported for test purposes.
var specialProperty = "exact-prop: \u200B";
function exactProp(propTypes) {
  if (process.env.NODE_ENV === 'production') {
    return propTypes;
  }

  return _extends({}, propTypes, _defineProperty({}, specialProperty, function (props) {
    var unsupportedProps = Object.keys(props).filter(function (prop) {
      return !propTypes.hasOwnProperty(prop);
    });

    if (unsupportedProps.length > 0) {
      return new Error("The following props are not supported: ".concat(unsupportedProps.map(function (prop) {
        return "`".concat(prop, "`");
      }).join(', '), ". Please remove them."));
    }

    return null;
  }));
}

/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@material-ui/utils/macros/MuiError.macro` instead.
 * @param {number} code
 */
function formatMuiErrorMessage(code) {
  // Apply babel-plugin-transform-template-literals in loose mode
  // loose mode is safe iff we're concatenating primitives
  // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose

  /* eslint-disable prefer-template */
  var url = 'https://mui.com/production-error/?code=' + code;

  for (var i = 1; i < arguments.length; i += 1) {
    // rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += '&args[]=' + encodeURIComponent(arguments[i]);
  }

  return 'Minified Material-UI error #' + code + '; visit ' + url + ' for the full message.';
  /* eslint-enable prefer-template */
}

var reactIs$1 = {exports: {}};

var reactIs_production_min = {};

/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_production_min;

function requireReactIs_production_min () {
	if (hasRequiredReactIs_production_min) return reactIs_production_min;
	hasRequiredReactIs_production_min = 1;
var b=60103,c=60106,d=60107,e=60108,f=60114,g=60109,h=60110,k=60112,l=60113,m=60120,n=60115,p=60116,q=60121,r=60122,u=60117,v=60129,w=60131;
	if("function"===typeof Symbol&&Symbol.for){var x=Symbol.for;b=x("react.element");c=x("react.portal");d=x("react.fragment");e=x("react.strict_mode");f=x("react.profiler");g=x("react.provider");h=x("react.context");k=x("react.forward_ref");l=x("react.suspense");m=x("react.suspense_list");n=x("react.memo");p=x("react.lazy");q=x("react.block");r=x("react.server.block");u=x("react.fundamental");v=x("react.debug_trace_mode");w=x("react.legacy_hidden");}
	function y(a){if("object"===typeof a&&null!==a){var t=a.$$typeof;switch(t){case b:switch(a=a.type,a){case d:case f:case e:case l:case m:return a;default:switch(a=a&&a.$$typeof,a){case h:case k:case p:case n:case g:return a;default:return t}}case c:return t}}}var z=g,A=b,B=k,C=d,D=p,E=n,F=c,G=f,H=e,I=l;reactIs_production_min.ContextConsumer=h;reactIs_production_min.ContextProvider=z;reactIs_production_min.Element=A;reactIs_production_min.ForwardRef=B;reactIs_production_min.Fragment=C;reactIs_production_min.Lazy=D;reactIs_production_min.Memo=E;reactIs_production_min.Portal=F;reactIs_production_min.Profiler=G;reactIs_production_min.StrictMode=H;
	reactIs_production_min.Suspense=I;reactIs_production_min.isAsyncMode=function(){return !1};reactIs_production_min.isConcurrentMode=function(){return !1};reactIs_production_min.isContextConsumer=function(a){return y(a)===h};reactIs_production_min.isContextProvider=function(a){return y(a)===g};reactIs_production_min.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===b};reactIs_production_min.isForwardRef=function(a){return y(a)===k};reactIs_production_min.isFragment=function(a){return y(a)===d};reactIs_production_min.isLazy=function(a){return y(a)===p};reactIs_production_min.isMemo=function(a){return y(a)===n};
	reactIs_production_min.isPortal=function(a){return y(a)===c};reactIs_production_min.isProfiler=function(a){return y(a)===f};reactIs_production_min.isStrictMode=function(a){return y(a)===e};reactIs_production_min.isSuspense=function(a){return y(a)===l};reactIs_production_min.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===d||a===f||a===v||a===e||a===l||a===m||a===w||"object"===typeof a&&null!==a&&(a.$$typeof===p||a.$$typeof===n||a.$$typeof===g||a.$$typeof===h||a.$$typeof===k||a.$$typeof===u||a.$$typeof===q||a[0]===r)?!0:!1};
	reactIs_production_min.typeOf=y;
	return reactIs_production_min;
}

var reactIs_development = {};

/** @license React v17.0.2
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_development;

function requireReactIs_development () {
	if (hasRequiredReactIs_development) return reactIs_development;
	hasRequiredReactIs_development = 1;

	if (process.env.NODE_ENV !== "production") {
	  (function() {

	// ATTENTION
	// When adding new symbols to this file,
	// Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
	// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	var REACT_ELEMENT_TYPE = 0xeac7;
	var REACT_PORTAL_TYPE = 0xeaca;
	var REACT_FRAGMENT_TYPE = 0xeacb;
	var REACT_STRICT_MODE_TYPE = 0xeacc;
	var REACT_PROFILER_TYPE = 0xead2;
	var REACT_PROVIDER_TYPE = 0xeacd;
	var REACT_CONTEXT_TYPE = 0xeace;
	var REACT_FORWARD_REF_TYPE = 0xead0;
	var REACT_SUSPENSE_TYPE = 0xead1;
	var REACT_SUSPENSE_LIST_TYPE = 0xead8;
	var REACT_MEMO_TYPE = 0xead3;
	var REACT_LAZY_TYPE = 0xead4;
	var REACT_BLOCK_TYPE = 0xead9;
	var REACT_SERVER_BLOCK_TYPE = 0xeada;
	var REACT_FUNDAMENTAL_TYPE = 0xead5;
	var REACT_DEBUG_TRACING_MODE_TYPE = 0xeae1;
	var REACT_LEGACY_HIDDEN_TYPE = 0xeae3;

	if (typeof Symbol === 'function' && Symbol.for) {
	  var symbolFor = Symbol.for;
	  REACT_ELEMENT_TYPE = symbolFor('react.element');
	  REACT_PORTAL_TYPE = symbolFor('react.portal');
	  REACT_FRAGMENT_TYPE = symbolFor('react.fragment');
	  REACT_STRICT_MODE_TYPE = symbolFor('react.strict_mode');
	  REACT_PROFILER_TYPE = symbolFor('react.profiler');
	  REACT_PROVIDER_TYPE = symbolFor('react.provider');
	  REACT_CONTEXT_TYPE = symbolFor('react.context');
	  REACT_FORWARD_REF_TYPE = symbolFor('react.forward_ref');
	  REACT_SUSPENSE_TYPE = symbolFor('react.suspense');
	  REACT_SUSPENSE_LIST_TYPE = symbolFor('react.suspense_list');
	  REACT_MEMO_TYPE = symbolFor('react.memo');
	  REACT_LAZY_TYPE = symbolFor('react.lazy');
	  REACT_BLOCK_TYPE = symbolFor('react.block');
	  REACT_SERVER_BLOCK_TYPE = symbolFor('react.server.block');
	  REACT_FUNDAMENTAL_TYPE = symbolFor('react.fundamental');
	  symbolFor('react.scope');
	  symbolFor('react.opaque.id');
	  REACT_DEBUG_TRACING_MODE_TYPE = symbolFor('react.debug_trace_mode');
	  symbolFor('react.offscreen');
	  REACT_LEGACY_HIDDEN_TYPE = symbolFor('react.legacy_hidden');
	}

	// Filter certain DOM attributes (e.g. src, href) if their values are empty strings.

	var enableScopeAPI = false; // Experimental Create Event Handle API.

	function isValidElementType(type) {
	  if (typeof type === 'string' || typeof type === 'function') {
	    return true;
	  } // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).


	  if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || type === REACT_DEBUG_TRACING_MODE_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || type === REACT_LEGACY_HIDDEN_TYPE || enableScopeAPI ) {
	    return true;
	  }

	  if (typeof type === 'object' && type !== null) {
	    if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_BLOCK_TYPE || type[0] === REACT_SERVER_BLOCK_TYPE) {
	      return true;
	    }
	  }

	  return false;
	}

	function typeOf(object) {
	  if (typeof object === 'object' && object !== null) {
	    var $$typeof = object.$$typeof;

	    switch ($$typeof) {
	      case REACT_ELEMENT_TYPE:
	        var type = object.type;

	        switch (type) {
	          case REACT_FRAGMENT_TYPE:
	          case REACT_PROFILER_TYPE:
	          case REACT_STRICT_MODE_TYPE:
	          case REACT_SUSPENSE_TYPE:
	          case REACT_SUSPENSE_LIST_TYPE:
	            return type;

	          default:
	            var $$typeofType = type && type.$$typeof;

	            switch ($$typeofType) {
	              case REACT_CONTEXT_TYPE:
	              case REACT_FORWARD_REF_TYPE:
	              case REACT_LAZY_TYPE:
	              case REACT_MEMO_TYPE:
	              case REACT_PROVIDER_TYPE:
	                return $$typeofType;

	              default:
	                return $$typeof;
	            }

	        }

	      case REACT_PORTAL_TYPE:
	        return $$typeof;
	    }
	  }

	  return undefined;
	}
	var ContextConsumer = REACT_CONTEXT_TYPE;
	var ContextProvider = REACT_PROVIDER_TYPE;
	var Element = REACT_ELEMENT_TYPE;
	var ForwardRef = REACT_FORWARD_REF_TYPE;
	var Fragment = REACT_FRAGMENT_TYPE;
	var Lazy = REACT_LAZY_TYPE;
	var Memo = REACT_MEMO_TYPE;
	var Portal = REACT_PORTAL_TYPE;
	var Profiler = REACT_PROFILER_TYPE;
	var StrictMode = REACT_STRICT_MODE_TYPE;
	var Suspense = REACT_SUSPENSE_TYPE;
	var hasWarnedAboutDeprecatedIsAsyncMode = false;
	var hasWarnedAboutDeprecatedIsConcurrentMode = false; // AsyncMode should be deprecated

	function isAsyncMode(object) {
	  {
	    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
	      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

	      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 18+.');
	    }
	  }

	  return false;
	}
	function isConcurrentMode(object) {
	  {
	    if (!hasWarnedAboutDeprecatedIsConcurrentMode) {
	      hasWarnedAboutDeprecatedIsConcurrentMode = true; // Using console['warn'] to evade Babel and ESLint

	      console['warn']('The ReactIs.isConcurrentMode() alias has been deprecated, ' + 'and will be removed in React 18+.');
	    }
	  }

	  return false;
	}
	function isContextConsumer(object) {
	  return typeOf(object) === REACT_CONTEXT_TYPE;
	}
	function isContextProvider(object) {
	  return typeOf(object) === REACT_PROVIDER_TYPE;
	}
	function isElement(object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	}
	function isForwardRef(object) {
	  return typeOf(object) === REACT_FORWARD_REF_TYPE;
	}
	function isFragment(object) {
	  return typeOf(object) === REACT_FRAGMENT_TYPE;
	}
	function isLazy(object) {
	  return typeOf(object) === REACT_LAZY_TYPE;
	}
	function isMemo(object) {
	  return typeOf(object) === REACT_MEMO_TYPE;
	}
	function isPortal(object) {
	  return typeOf(object) === REACT_PORTAL_TYPE;
	}
	function isProfiler(object) {
	  return typeOf(object) === REACT_PROFILER_TYPE;
	}
	function isStrictMode(object) {
	  return typeOf(object) === REACT_STRICT_MODE_TYPE;
	}
	function isSuspense(object) {
	  return typeOf(object) === REACT_SUSPENSE_TYPE;
	}

	reactIs_development.ContextConsumer = ContextConsumer;
	reactIs_development.ContextProvider = ContextProvider;
	reactIs_development.Element = Element;
	reactIs_development.ForwardRef = ForwardRef;
	reactIs_development.Fragment = Fragment;
	reactIs_development.Lazy = Lazy;
	reactIs_development.Memo = Memo;
	reactIs_development.Portal = Portal;
	reactIs_development.Profiler = Profiler;
	reactIs_development.StrictMode = StrictMode;
	reactIs_development.Suspense = Suspense;
	reactIs_development.isAsyncMode = isAsyncMode;
	reactIs_development.isConcurrentMode = isConcurrentMode;
	reactIs_development.isContextConsumer = isContextConsumer;
	reactIs_development.isContextProvider = isContextProvider;
	reactIs_development.isElement = isElement;
	reactIs_development.isForwardRef = isForwardRef;
	reactIs_development.isFragment = isFragment;
	reactIs_development.isLazy = isLazy;
	reactIs_development.isMemo = isMemo;
	reactIs_development.isPortal = isPortal;
	reactIs_development.isProfiler = isProfiler;
	reactIs_development.isStrictMode = isStrictMode;
	reactIs_development.isSuspense = isSuspense;
	reactIs_development.isValidElementType = isValidElementType;
	reactIs_development.typeOf = typeOf;
	  })();
	}
	return reactIs_development;
}

if (process.env.NODE_ENV === 'production') {
  reactIs$1.exports = requireReactIs_production_min();
} else {
  reactIs$1.exports = requireReactIs_development();
}

var reactIsExports = reactIs$1.exports;

// https://github.com/JamesMGreene/Function.name/blob/58b314d4a983110c3682f1228f845d39ccca1817/Function.name.js#L3

var fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function getFunctionName(fn) {
  var match = "".concat(fn).match(fnNameMatchRegex);
  var name = match && match[1];
  return name || '';
}
/**
 * @param {function} Component
 * @param {string} fallback
 * @returns {string | undefined}
 */

function getFunctionComponentName(Component) {
  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return Component.displayName || Component.name || getFunctionName(Component) || fallback;
}

function getWrappedName(outerType, innerType, wrapperName) {
  var functionName = getFunctionComponentName(innerType);
  return outerType.displayName || (functionName !== '' ? "".concat(wrapperName, "(").concat(functionName, ")") : wrapperName);
}
/**
 * cherry-pick from
 * https://github.com/facebook/react/blob/769b1f270e1251d9dbdce0fcbd9e92e502d059b8/packages/shared/getComponentName.js
 * originally forked from recompose/getDisplayName with added IE 11 support
 *
 * @param {React.ReactType} Component
 * @returns {string | undefined}
 */


function getDisplayName(Component) {
  if (Component == null) {
    return undefined;
  }

  if (typeof Component === 'string') {
    return Component;
  }

  if (typeof Component === 'function') {
    return getFunctionComponentName(Component, 'Component');
  }

  if (_typeof$1(Component) === 'object') {
    switch (Component.$$typeof) {
      case reactIsExports.ForwardRef:
        return getWrappedName(Component, Component.render, 'ForwardRef');

      case reactIsExports.Memo:
        return getWrappedName(Component, Component.type, 'memo');

      default:
        return undefined;
    }
  }

  return undefined;
}

/* eslint-disable no-use-before-define */

/**
 * Returns a number whose value is limited to the given range.
 *
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */
function clamp(value) {
  var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

  if (process.env.NODE_ENV !== 'production') {
    if (value < min || value > max) {
      console.error("Material-UI: The value provided ".concat(value, " is out of range [").concat(min, ", ").concat(max, "]."));
    }
  }

  return Math.min(Math.max(min, value), max);
}
/**
 * Converts a color from CSS hex format to CSS rgb format.
 *
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */


function hexToRgb(color) {
  color = color.substr(1);
  var re = new RegExp(".{1,".concat(color.length >= 6 ? 2 : 1, "}"), 'g');
  var colors = color.match(re);

  if (colors && colors[0].length === 1) {
    colors = colors.map(function (n) {
      return n + n;
    });
  }

  return colors ? "rgb".concat(colors.length === 4 ? 'a' : '', "(").concat(colors.map(function (n, index) {
    return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
  }).join(', '), ")") : '';
}
/**
 * Converts a color from hsl format to rgb format.
 *
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */

function hslToRgb(color) {
  color = decomposeColor(color);
  var _color = color,
      values = _color.values;
  var h = values[0];
  var s = values[1] / 100;
  var l = values[2] / 100;
  var a = s * Math.min(l, 1 - l);

  var f = function f(n) {
    var k = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (n + h / 30) % 12;
    return l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
  };

  var type = 'rgb';
  var rgb = [Math.round(f(0) * 255), Math.round(f(8) * 255), Math.round(f(4) * 255)];

  if (color.type === 'hsla') {
    type += 'a';
    rgb.push(values[3]);
  }

  return recomposeColor({
    type: type,
    values: rgb
  });
}
/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */

function decomposeColor(color) {
  // Idempotent
  if (color.type) {
    return color;
  }

  if (color.charAt(0) === '#') {
    return decomposeColor(hexToRgb(color));
  }

  var marker = color.indexOf('(');
  var type = color.substring(0, marker);

  if (['rgb', 'rgba', 'hsl', 'hsla'].indexOf(type) === -1) {
    throw new Error(process.env.NODE_ENV !== "production" ? "Material-UI: Unsupported `".concat(color, "` color.\nWe support the following formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla().") : formatMuiErrorMessage(3, color));
  }

  var values = color.substring(marker + 1, color.length - 1).split(',');
  values = values.map(function (value) {
    return parseFloat(value);
  });
  return {
    type: type,
    values: values
  };
}
/**
 * Converts a color object with type and values to a string.
 *
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */

function recomposeColor(color) {
  var type = color.type;
  var values = color.values;

  if (type.indexOf('rgb') !== -1) {
    // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map(function (n, i) {
      return i < 3 ? parseInt(n, 10) : n;
    });
  } else if (type.indexOf('hsl') !== -1) {
    values[1] = "".concat(values[1], "%");
    values[2] = "".concat(values[2], "%");
  }

  return "".concat(type, "(").concat(values.join(', '), ")");
}
/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 *
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */

function getContrastRatio(foreground, background) {
  var lumA = getLuminance(foreground);
  var lumB = getLuminance(background);
  return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */

function getLuminance(color) {
  color = decomposeColor(color);
  var rgb = color.type === 'hsl' ? decomposeColor(hslToRgb(color)).values : color.values;
  rgb = rgb.map(function (val) {
    val /= 255; // normalized

    return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
  }); // Truncate at 3 digits

  return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
/**
 * Darkens a color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */

function darken(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clamp(coefficient);

  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] *= 1 - coefficient;
  } else if (color.type.indexOf('rgb') !== -1) {
    for (var i = 0; i < 3; i += 1) {
      color.values[i] *= 1 - coefficient;
    }
  }

  return recomposeColor(color);
}
/**
 * Lightens a color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */

function lighten(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clamp(coefficient);

  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] += (100 - color.values[2]) * coefficient;
  } else if (color.type.indexOf('rgb') !== -1) {
    for (var i = 0; i < 3; i += 1) {
      color.values[i] += (255 - color.values[i]) * coefficient;
    }
  }

  return recomposeColor(color);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

// Sorted ASC by size. That's important.
// It can't be configured as it's used statically for propTypes.
var keys = ['xs', 'sm', 'md', 'lg', 'xl']; // Keep in mind that @media is inclusive by the CSS specification.

function createBreakpoints(breakpoints) {
  var _breakpoints$values = breakpoints.values,
      values = _breakpoints$values === void 0 ? {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920
  } : _breakpoints$values,
      _breakpoints$unit = breakpoints.unit,
      unit = _breakpoints$unit === void 0 ? 'px' : _breakpoints$unit,
      _breakpoints$step = breakpoints.step,
      step = _breakpoints$step === void 0 ? 5 : _breakpoints$step,
      other = _objectWithoutProperties(breakpoints, ["values", "unit", "step"]);

  function up(key) {
    var value = typeof values[key] === 'number' ? values[key] : key;
    return "@media (min-width:".concat(value).concat(unit, ")");
  }

  function down(key) {
    var endIndex = keys.indexOf(key) + 1;
    var upperbound = values[keys[endIndex]];

    if (endIndex === keys.length) {
      // xl down applies to all sizes
      return up('xs');
    }

    var value = typeof upperbound === 'number' && endIndex > 0 ? upperbound : key;
    return "@media (max-width:".concat(value - step / 100).concat(unit, ")");
  }

  function between(start, end) {
    var endIndex = keys.indexOf(end);

    if (endIndex === keys.length - 1) {
      return up(start);
    }

    return "@media (min-width:".concat(typeof values[start] === 'number' ? values[start] : start).concat(unit, ") and ") + "(max-width:".concat((endIndex !== -1 && typeof values[keys[endIndex + 1]] === 'number' ? values[keys[endIndex + 1]] : end) - step / 100).concat(unit, ")");
  }

  function only(key) {
    return between(key, key);
  }

  function width(key) {
    return values[key];
  }

  return _extends({
    keys: keys,
    values: values,
    up: up,
    down: down,
    between: between,
    only: only,
    width: width
  }, other);
}

function createMixins(breakpoints, spacing, mixins) {
  var _toolbar;

  return _extends({
    gutters: function gutters() {
      var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      // To deprecate in v4.1
      //       warning(
      //         false,
      //         [
      //           'Material-UI: Theme.mixins.gutters() is deprecated.',
      //           'You can use the source of the mixin directly:',
      //           `
      // paddingLeft: theme.spacing(2),
      // paddingRight: theme.spacing(2),
      // [theme.breakpoints.up('sm')]: {
      //   paddingLeft: theme.spacing(3),
      //   paddingRight: theme.spacing(3),
      // },
      // `,
      //         ].join('\n'),
      //       );
      return _extends({
        paddingLeft: spacing(2),
        paddingRight: spacing(2)
      }, styles, _defineProperty({}, breakpoints.up('sm'), _extends({
        paddingLeft: spacing(3),
        paddingRight: spacing(3)
      }, styles[breakpoints.up('sm')])));
    },
    toolbar: (_toolbar = {
      minHeight: 56
    }, _defineProperty(_toolbar, "".concat(breakpoints.up('xs'), " and (orientation: landscape)"), {
      minHeight: 48
    }), _defineProperty(_toolbar, breakpoints.up('sm'), {
      minHeight: 64
    }), _toolbar)
  }, mixins);
}

var common$1 = {
  black: '#000',
  white: '#fff'
};
var common$2 = common$1;

var grey = {
  50: '#fafafa',
  100: '#f5f5f5',
  200: '#eeeeee',
  300: '#e0e0e0',
  400: '#bdbdbd',
  500: '#9e9e9e',
  600: '#757575',
  700: '#616161',
  800: '#424242',
  900: '#212121',
  A100: '#d5d5d5',
  A200: '#aaaaaa',
  A400: '#303030',
  A700: '#616161'
};
var grey$1 = grey;

var indigo = {
  50: '#e8eaf6',
  100: '#c5cae9',
  200: '#9fa8da',
  300: '#7986cb',
  400: '#5c6bc0',
  500: '#3f51b5',
  600: '#3949ab',
  700: '#303f9f',
  800: '#283593',
  900: '#1a237e',
  A100: '#8c9eff',
  A200: '#536dfe',
  A400: '#3d5afe',
  A700: '#304ffe'
};
var indigo$1 = indigo;

var pink = {
  50: '#fce4ec',
  100: '#f8bbd0',
  200: '#f48fb1',
  300: '#f06292',
  400: '#ec407a',
  500: '#e91e63',
  600: '#d81b60',
  700: '#c2185b',
  800: '#ad1457',
  900: '#880e4f',
  A100: '#ff80ab',
  A200: '#ff4081',
  A400: '#f50057',
  A700: '#c51162'
};
var pink$1 = pink;

var red = {
  50: '#ffebee',
  100: '#ffcdd2',
  200: '#ef9a9a',
  300: '#e57373',
  400: '#ef5350',
  500: '#f44336',
  600: '#e53935',
  700: '#d32f2f',
  800: '#c62828',
  900: '#b71c1c',
  A100: '#ff8a80',
  A200: '#ff5252',
  A400: '#ff1744',
  A700: '#d50000'
};
var red$1 = red;

var orange = {
  50: '#fff3e0',
  100: '#ffe0b2',
  200: '#ffcc80',
  300: '#ffb74d',
  400: '#ffa726',
  500: '#ff9800',
  600: '#fb8c00',
  700: '#f57c00',
  800: '#ef6c00',
  900: '#e65100',
  A100: '#ffd180',
  A200: '#ffab40',
  A400: '#ff9100',
  A700: '#ff6d00'
};
var orange$1 = orange;

var blue = {
  50: '#e3f2fd',
  100: '#bbdefb',
  200: '#90caf9',
  300: '#64b5f6',
  400: '#42a5f5',
  500: '#2196f3',
  600: '#1e88e5',
  700: '#1976d2',
  800: '#1565c0',
  900: '#0d47a1',
  A100: '#82b1ff',
  A200: '#448aff',
  A400: '#2979ff',
  A700: '#2962ff'
};
var blue$1 = blue;

var green = {
  50: '#e8f5e9',
  100: '#c8e6c9',
  200: '#a5d6a7',
  300: '#81c784',
  400: '#66bb6a',
  500: '#4caf50',
  600: '#43a047',
  700: '#388e3c',
  800: '#2e7d32',
  900: '#1b5e20',
  A100: '#b9f6ca',
  A200: '#69f0ae',
  A400: '#00e676',
  A700: '#00c853'
};
var green$1 = green;

var light = {
  // The colors used to style the text.
  text: {
    // The most important text.
    primary: 'rgba(0, 0, 0, 0.87)',
    // Secondary text.
    secondary: 'rgba(0, 0, 0, 0.54)',
    // Disabled text have even lower visual prominence.
    disabled: 'rgba(0, 0, 0, 0.38)',
    // Text hints.
    hint: 'rgba(0, 0, 0, 0.38)'
  },
  // The color used to divide different elements.
  divider: 'rgba(0, 0, 0, 0.12)',
  // The background colors used to style the surfaces.
  // Consistency between these values is important.
  background: {
    paper: common$2.white,
    default: grey$1[50]
  },
  // The colors used to style the action elements.
  action: {
    // The color of an active action like an icon button.
    active: 'rgba(0, 0, 0, 0.54)',
    // The color of an hovered action.
    hover: 'rgba(0, 0, 0, 0.04)',
    hoverOpacity: 0.04,
    // The color of a selected action.
    selected: 'rgba(0, 0, 0, 0.08)',
    selectedOpacity: 0.08,
    // The color of a disabled action.
    disabled: 'rgba(0, 0, 0, 0.26)',
    // The background color of a disabled action.
    disabledBackground: 'rgba(0, 0, 0, 0.12)',
    disabledOpacity: 0.38,
    focus: 'rgba(0, 0, 0, 0.12)',
    focusOpacity: 0.12,
    activatedOpacity: 0.12
  }
};
var dark = {
  text: {
    primary: common$2.white,
    secondary: 'rgba(255, 255, 255, 0.7)',
    disabled: 'rgba(255, 255, 255, 0.5)',
    hint: 'rgba(255, 255, 255, 0.5)',
    icon: 'rgba(255, 255, 255, 0.5)'
  },
  divider: 'rgba(255, 255, 255, 0.12)',
  background: {
    paper: grey$1[800],
    default: '#303030'
  },
  action: {
    active: common$2.white,
    hover: 'rgba(255, 255, 255, 0.08)',
    hoverOpacity: 0.08,
    selected: 'rgba(255, 255, 255, 0.16)',
    selectedOpacity: 0.16,
    disabled: 'rgba(255, 255, 255, 0.3)',
    disabledBackground: 'rgba(255, 255, 255, 0.12)',
    disabledOpacity: 0.38,
    focus: 'rgba(255, 255, 255, 0.12)',
    focusOpacity: 0.12,
    activatedOpacity: 0.24
  }
};

function addLightOrDark(intent, direction, shade, tonalOffset) {
  var tonalOffsetLight = tonalOffset.light || tonalOffset;
  var tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;

  if (!intent[direction]) {
    if (intent.hasOwnProperty(shade)) {
      intent[direction] = intent[shade];
    } else if (direction === 'light') {
      intent.light = lighten(intent.main, tonalOffsetLight);
    } else if (direction === 'dark') {
      intent.dark = darken(intent.main, tonalOffsetDark);
    }
  }
}

function createPalette(palette) {
  var _palette$primary = palette.primary,
      primary = _palette$primary === void 0 ? {
    light: indigo$1[300],
    main: indigo$1[500],
    dark: indigo$1[700]
  } : _palette$primary,
      _palette$secondary = palette.secondary,
      secondary = _palette$secondary === void 0 ? {
    light: pink$1.A200,
    main: pink$1.A400,
    dark: pink$1.A700
  } : _palette$secondary,
      _palette$error = palette.error,
      error = _palette$error === void 0 ? {
    light: red$1[300],
    main: red$1[500],
    dark: red$1[700]
  } : _palette$error,
      _palette$warning = palette.warning,
      warning = _palette$warning === void 0 ? {
    light: orange$1[300],
    main: orange$1[500],
    dark: orange$1[700]
  } : _palette$warning,
      _palette$info = palette.info,
      info = _palette$info === void 0 ? {
    light: blue$1[300],
    main: blue$1[500],
    dark: blue$1[700]
  } : _palette$info,
      _palette$success = palette.success,
      success = _palette$success === void 0 ? {
    light: green$1[300],
    main: green$1[500],
    dark: green$1[700]
  } : _palette$success,
      _palette$type = palette.type,
      type = _palette$type === void 0 ? 'light' : _palette$type,
      _palette$contrastThre = palette.contrastThreshold,
      contrastThreshold = _palette$contrastThre === void 0 ? 3 : _palette$contrastThre,
      _palette$tonalOffset = palette.tonalOffset,
      tonalOffset = _palette$tonalOffset === void 0 ? 0.2 : _palette$tonalOffset,
      other = _objectWithoutProperties(palette, ["primary", "secondary", "error", "warning", "info", "success", "type", "contrastThreshold", "tonalOffset"]); // Use the same logic as
  // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
  // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54


  function getContrastText(background) {
    var contrastText = getContrastRatio(background, dark.text.primary) >= contrastThreshold ? dark.text.primary : light.text.primary;

    if (process.env.NODE_ENV !== 'production') {
      var contrast = getContrastRatio(background, contrastText);

      if (contrast < 3) {
        console.error(["Material-UI: The contrast ratio of ".concat(contrast, ":1 for ").concat(contrastText, " on ").concat(background), 'falls below the WCAG recommended absolute minimum contrast ratio of 3:1.', 'https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast'].join('\n'));
      }
    }

    return contrastText;
  }

  var augmentColor = function augmentColor(color) {
    var mainShade = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
    var lightShade = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 300;
    var darkShade = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 700;
    color = _extends({}, color);

    if (!color.main && color[mainShade]) {
      color.main = color[mainShade];
    }

    if (!color.main) {
      throw new Error(process.env.NODE_ENV !== "production" ? "Material-UI: The color provided to augmentColor(color) is invalid.\nThe color object needs to have a `main` property or a `".concat(mainShade, "` property.") : formatMuiErrorMessage(4, mainShade));
    }

    if (typeof color.main !== 'string') {
      throw new Error(process.env.NODE_ENV !== "production" ? "Material-UI: The color provided to augmentColor(color) is invalid.\n`color.main` should be a string, but `".concat(JSON.stringify(color.main), "` was provided instead.\n\nDid you intend to use one of the following approaches?\n\nimport {\xA0green } from \"@material-ui/core/colors\";\n\nconst theme1 = createMuiTheme({ palette: {\n  primary: green,\n} });\n\nconst theme2 = createMuiTheme({ palette: {\n  primary: { main: green[500] },\n} });") : formatMuiErrorMessage(5, JSON.stringify(color.main)));
    }

    addLightOrDark(color, 'light', lightShade, tonalOffset);
    addLightOrDark(color, 'dark', darkShade, tonalOffset);

    if (!color.contrastText) {
      color.contrastText = getContrastText(color.main);
    }

    return color;
  };

  var types = {
    dark: dark,
    light: light
  };

  if (process.env.NODE_ENV !== 'production') {
    if (!types[type]) {
      console.error("Material-UI: The palette type `".concat(type, "` is not supported."));
    }
  }

  var paletteOutput = deepmerge(_extends({
    // A collection of common colors.
    common: common$2,
    // The palette type, can be light or dark.
    type: type,
    // The colors used to represent primary interface elements for a user.
    primary: augmentColor(primary),
    // The colors used to represent secondary interface elements for a user.
    secondary: augmentColor(secondary, 'A400', 'A200', 'A700'),
    // The colors used to represent interface elements that the user should be made aware of.
    error: augmentColor(error),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: augmentColor(warning),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: augmentColor(info),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: augmentColor(success),
    // The grey colors.
    grey: grey$1,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: contrastThreshold,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText: getContrastText,
    // Generate a rich color object.
    augmentColor: augmentColor,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: tonalOffset
  }, types[type]), other);
  return paletteOutput;
}

function round$1(value) {
  return Math.round(value * 1e5) / 1e5;
}

var caseAllCaps = {
  textTransform: 'uppercase'
};
var defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
/**
 * @see @link{https://material.io/design/typography/the-type-system.html}
 * @see @link{https://material.io/design/typography/understanding-typography.html}
 */

function createTypography(palette, typography) {
  var _ref = typeof typography === 'function' ? typography(palette) : typography,
      _ref$fontFamily = _ref.fontFamily,
      fontFamily = _ref$fontFamily === void 0 ? defaultFontFamily : _ref$fontFamily,
      _ref$fontSize = _ref.fontSize,
      fontSize = _ref$fontSize === void 0 ? 14 : _ref$fontSize,
      _ref$fontWeightLight = _ref.fontWeightLight,
      fontWeightLight = _ref$fontWeightLight === void 0 ? 300 : _ref$fontWeightLight,
      _ref$fontWeightRegula = _ref.fontWeightRegular,
      fontWeightRegular = _ref$fontWeightRegula === void 0 ? 400 : _ref$fontWeightRegula,
      _ref$fontWeightMedium = _ref.fontWeightMedium,
      fontWeightMedium = _ref$fontWeightMedium === void 0 ? 500 : _ref$fontWeightMedium,
      _ref$fontWeightBold = _ref.fontWeightBold,
      fontWeightBold = _ref$fontWeightBold === void 0 ? 700 : _ref$fontWeightBold,
      _ref$htmlFontSize = _ref.htmlFontSize,
      htmlFontSize = _ref$htmlFontSize === void 0 ? 16 : _ref$htmlFontSize,
      allVariants = _ref.allVariants,
      pxToRem2 = _ref.pxToRem,
      other = _objectWithoutProperties(_ref, ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"]);

  if (process.env.NODE_ENV !== 'production') {
    if (typeof fontSize !== 'number') {
      console.error('Material-UI: `fontSize` is required to be a number.');
    }

    if (typeof htmlFontSize !== 'number') {
      console.error('Material-UI: `htmlFontSize` is required to be a number.');
    }
  }

  var coef = fontSize / 14;

  var pxToRem = pxToRem2 || function (size) {
    return "".concat(size / htmlFontSize * coef, "rem");
  };

  var buildVariant = function buildVariant(fontWeight, size, lineHeight, letterSpacing, casing) {
    return _extends({
      fontFamily: fontFamily,
      fontWeight: fontWeight,
      fontSize: pxToRem(size),
      // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
      lineHeight: lineHeight
    }, fontFamily === defaultFontFamily ? {
      letterSpacing: "".concat(round$1(letterSpacing / size), "em")
    } : {}, casing, allVariants);
  };

  var variants = {
    h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
    h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
    h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
    h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
    h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
    h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
    subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
    subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
    body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
    body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
    button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, caseAllCaps),
    caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
    overline: buildVariant(fontWeightRegular, 12, 2.66, 1, caseAllCaps)
  };
  return deepmerge(_extends({
    htmlFontSize: htmlFontSize,
    pxToRem: pxToRem,
    round: round$1,
    // TODO v5: remove
    fontFamily: fontFamily,
    fontSize: fontSize,
    fontWeightLight: fontWeightLight,
    fontWeightRegular: fontWeightRegular,
    fontWeightMedium: fontWeightMedium,
    fontWeightBold: fontWeightBold
  }, variants), other, {
    clone: false // No need to clone deep

  });
}

var shadowKeyUmbraOpacity = 0.2;
var shadowKeyPenumbraOpacity = 0.14;
var shadowAmbientShadowOpacity = 0.12;

function createShadow() {
  return ["".concat(arguments.length <= 0 ? undefined : arguments[0], "px ").concat(arguments.length <= 1 ? undefined : arguments[1], "px ").concat(arguments.length <= 2 ? undefined : arguments[2], "px ").concat(arguments.length <= 3 ? undefined : arguments[3], "px rgba(0,0,0,").concat(shadowKeyUmbraOpacity, ")"), "".concat(arguments.length <= 4 ? undefined : arguments[4], "px ").concat(arguments.length <= 5 ? undefined : arguments[5], "px ").concat(arguments.length <= 6 ? undefined : arguments[6], "px ").concat(arguments.length <= 7 ? undefined : arguments[7], "px rgba(0,0,0,").concat(shadowKeyPenumbraOpacity, ")"), "".concat(arguments.length <= 8 ? undefined : arguments[8], "px ").concat(arguments.length <= 9 ? undefined : arguments[9], "px ").concat(arguments.length <= 10 ? undefined : arguments[10], "px ").concat(arguments.length <= 11 ? undefined : arguments[11], "px rgba(0,0,0,").concat(shadowAmbientShadowOpacity, ")")].join(',');
} // Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss


var shadows = ['none', createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)];
var shadows$1 = shadows;

var shape = {
  borderRadius: 4
};
var shape$1 = shape;

var responsivePropType = process.env.NODE_ENV !== 'production' ? PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.object, PropTypes.array]) : {};
var responsivePropType$1 = responsivePropType;

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

var spacingKeys = ['m', 'mt', 'mr', 'mb', 'ml', 'mx', 'my', 'p', 'pt', 'pr', 'pb', 'pl', 'px', 'py', 'margin', 'marginTop', 'marginRight', 'marginBottom', 'marginLeft', 'marginX', 'marginY', 'padding', 'paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft', 'paddingX', 'paddingY'];
function createUnarySpacing(theme) {
  var themeSpacing = theme.spacing || 8;

  if (typeof themeSpacing === 'number') {
    return function (abs) {
      if (process.env.NODE_ENV !== 'production') {
        if (typeof abs !== 'number') {
          console.error("Material-UI: Expected spacing argument to be a number, got ".concat(abs, "."));
        }
      }

      return themeSpacing * abs;
    };
  }

  if (Array.isArray(themeSpacing)) {
    return function (abs) {
      if (process.env.NODE_ENV !== 'production') {
        if (abs > themeSpacing.length - 1) {
          console.error(["Material-UI: The value provided (".concat(abs, ") overflows."), "The supported values are: ".concat(JSON.stringify(themeSpacing), "."), "".concat(abs, " > ").concat(themeSpacing.length - 1, ", you need to add the missing values.")].join('\n'));
        }
      }

      return themeSpacing[abs];
    };
  }

  if (typeof themeSpacing === 'function') {
    return themeSpacing;
  }

  if (process.env.NODE_ENV !== 'production') {
    console.error(["Material-UI: The `theme.spacing` value (".concat(themeSpacing, ") is invalid."), 'It should be a number, an array or a function.'].join('\n'));
  }

  return function () {
    return undefined;
  };
}

process.env.NODE_ENV !== 'production' ? spacingKeys.reduce(function (obj, key) {
  obj[key] = responsivePropType$1;
  return obj;
}, {}) : {};

var warnOnce;
function createSpacing() {
  var spacingInput = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 8;

  // Already transformed.
  if (spacingInput.mui) {
    return spacingInput;
  } // Material Design layouts are visually balanced. Most measurements align to an 8dp grid applied, which aligns both spacing and the overall layout.
  // Smaller components, such as icons and type, can align to a 4dp grid.
  // https://material.io/design/layout/understanding-layout.html#usage


  var transform = createUnarySpacing({
    spacing: spacingInput
  });

  var spacing = function spacing() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (process.env.NODE_ENV !== 'production') {
      if (!(args.length <= 4)) {
        console.error("Material-UI: Too many arguments provided, expected between 0 and 4, got ".concat(args.length));
      }
    }

    if (args.length === 0) {
      return transform(1);
    }

    if (args.length === 1) {
      return transform(args[0]);
    }

    return args.map(function (argument) {
      if (typeof argument === 'string') {
        return argument;
      }

      var output = transform(argument);
      return typeof output === 'number' ? "".concat(output, "px") : output;
    }).join(' ');
  }; // Backward compatibility, to remove in v5.


  Object.defineProperty(spacing, 'unit', {
    get: function get() {
      if (process.env.NODE_ENV !== 'production') {
        if (!warnOnce || process.env.NODE_ENV === 'test') {
          console.error(['Material-UI: theme.spacing.unit usage has been deprecated.', 'It will be removed in v5.', 'You can replace `theme.spacing.unit * y` with `theme.spacing(y)`.', '', 'You can use the `https://github.com/mui-org/material-ui/tree/master/packages/material-ui-codemod/README.md#theme-spacing-api` migration helper to make the process smoother.'].join('\n'));
        }

        warnOnce = true;
      }

      return spacingInput;
    }
  });
  spacing.mui = true;
  return spacing;
}

// Follow https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves
// to learn the context in which each easing should be used.
var easing = {
  // This is the most common easing curve.
  easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
}; // Follow https://material.io/guidelines/motion/duration-easing.html#duration-easing-common-durations
// to learn when use what timing

var duration = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};

function formatMs(milliseconds) {
  return "".concat(Math.round(milliseconds), "ms");
}
/**
 * @param {string|Array} props
 * @param {object} param
 * @param {string} param.prop
 * @param {number} param.duration
 * @param {string} param.easing
 * @param {number} param.delay
 */


var transitions = {
  easing: easing,
  duration: duration,
  create: function create() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['all'];
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var _options$duration = options.duration,
        durationOption = _options$duration === void 0 ? duration.standard : _options$duration,
        _options$easing = options.easing,
        easingOption = _options$easing === void 0 ? easing.easeInOut : _options$easing,
        _options$delay = options.delay,
        delay = _options$delay === void 0 ? 0 : _options$delay,
        other = _objectWithoutProperties(options, ["duration", "easing", "delay"]);

    if (process.env.NODE_ENV !== 'production') {
      var isString = function isString(value) {
        return typeof value === 'string';
      };

      var isNumber = function isNumber(value) {
        return !isNaN(parseFloat(value));
      };

      if (!isString(props) && !Array.isArray(props)) {
        console.error('Material-UI: Argument "props" must be a string or Array.');
      }

      if (!isNumber(durationOption) && !isString(durationOption)) {
        console.error("Material-UI: Argument \"duration\" must be a number or a string but found ".concat(durationOption, "."));
      }

      if (!isString(easingOption)) {
        console.error('Material-UI: Argument "easing" must be a string.');
      }

      if (!isNumber(delay) && !isString(delay)) {
        console.error('Material-UI: Argument "delay" must be a number or a string.');
      }

      if (Object.keys(other).length !== 0) {
        console.error("Material-UI: Unrecognized argument(s) [".concat(Object.keys(other).join(','), "]."));
      }
    }

    return (Array.isArray(props) ? props : [props]).map(function (animatedProp) {
      return "".concat(animatedProp, " ").concat(typeof durationOption === 'string' ? durationOption : formatMs(durationOption), " ").concat(easingOption, " ").concat(typeof delay === 'string' ? delay : formatMs(delay));
    }).join(',');
  },
  getAutoHeightDuration: function getAutoHeightDuration(height) {
    if (!height) {
      return 0;
    }

    var constant = height / 36; // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10

    return Math.round((4 + 15 * Math.pow(constant, 0.25) + constant / 5) * 10);
  }
};

// We need to centralize the zIndex definitions as they work
// like global values in the browser.
var zIndex = {
  mobileStepper: 1000,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};
var zIndex$1 = zIndex;

function createMuiTheme() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _options$breakpoints = options.breakpoints,
      breakpointsInput = _options$breakpoints === void 0 ? {} : _options$breakpoints,
      _options$mixins = options.mixins,
      mixinsInput = _options$mixins === void 0 ? {} : _options$mixins,
      _options$palette = options.palette,
      paletteInput = _options$palette === void 0 ? {} : _options$palette,
      spacingInput = options.spacing,
      _options$typography = options.typography,
      typographyInput = _options$typography === void 0 ? {} : _options$typography,
      other = _objectWithoutProperties(options, ["breakpoints", "mixins", "palette", "spacing", "typography"]);

  var palette = createPalette(paletteInput);
  var breakpoints = createBreakpoints(breakpointsInput);
  var spacing = createSpacing(spacingInput);
  var muiTheme = deepmerge({
    breakpoints: breakpoints,
    direction: 'ltr',
    mixins: createMixins(breakpoints, spacing, mixinsInput),
    overrides: {},
    // Inject custom styles
    palette: palette,
    props: {},
    // Provide default props
    shadows: shadows$1,
    typography: createTypography(palette, typographyInput),
    spacing: spacing,
    shape: shape$1,
    transitions: transitions,
    zIndex: zIndex$1
  }, other);

  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  muiTheme = args.reduce(function (acc, argument) {
    return deepmerge(acc, argument);
  }, muiTheme);

  if (process.env.NODE_ENV !== 'production') {
    var pseudoClasses = ['checked', 'disabled', 'error', 'focused', 'focusVisible', 'required', 'expanded', 'selected'];

    var traverse = function traverse(node, parentKey) {
      var depth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      var key; // eslint-disable-next-line guard-for-in, no-restricted-syntax

      for (key in node) {
        var child = node[key];

        if (depth === 1) {
          if (key.indexOf('Mui') === 0 && child) {
            traverse(child, key, depth + 1);
          }
        } else if (pseudoClasses.indexOf(key) !== -1 && Object.keys(child).length > 0) {
          if (process.env.NODE_ENV !== 'production') {
            console.error(["Material-UI: The `".concat(parentKey, "` component increases ") + "the CSS specificity of the `".concat(key, "` internal state."), 'You can not override it like this: ', JSON.stringify(node, null, 2), '', 'Instead, you need to use the $ruleName syntax:', JSON.stringify({
              root: _defineProperty({}, "&$".concat(key), child)
            }, null, 2), '', 'https://material-ui.com/r/pseudo-classes-guide'].join('\n'));
          } // Remove the style to prevent global conflicts.


          node[key] = {};
        }
      }
    };

    traverse(muiTheme.overrides);
  }

  return muiTheme;
}

var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var nested = hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__';

/**
 * This is the list of the style rule name we use as drop in replacement for the built-in
 * pseudo classes (:checked, :disabled, :focused, etc.).
 *
 * Why do they exist in the first place?
 * These classes are used at a specificity of 2.
 * It allows them to override previously definied styles as well as
 * being untouched by simple user overrides.
 */

var pseudoClasses = ['checked', 'disabled', 'error', 'focused', 'focusVisible', 'required', 'expanded', 'selected']; // Returns a function which generates unique class names based on counters.
// When new generator function is created, rule counter is reset.
// We need to reset the rule counter for SSR for each request.
//
// It's inspired by
// https://github.com/cssinjs/jss/blob/4e6a05dd3f7b6572fdd3ab216861d9e446c20331/src/utils/createGenerateClassName.js

function createGenerateClassName() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$disableGloba = options.disableGlobal,
      disableGlobal = _options$disableGloba === void 0 ? false : _options$disableGloba,
      _options$productionPr = options.productionPrefix,
      productionPrefix = _options$productionPr === void 0 ? 'jss' : _options$productionPr,
      _options$seed = options.seed,
      seed = _options$seed === void 0 ? '' : _options$seed;
  var seedPrefix = seed === '' ? '' : "".concat(seed, "-");
  var ruleCounter = 0;

  var getNextCounterId = function getNextCounterId() {
    ruleCounter += 1;

    if (process.env.NODE_ENV !== 'production') {
      if (ruleCounter >= 1e10) {
        console.warn(['Material-UI: You might have a memory leak.', 'The ruleCounter is not supposed to grow that much.'].join(''));
      }
    }

    return ruleCounter;
  };

  return function (rule, styleSheet) {
    var name = styleSheet.options.name; // Is a global static MUI style?

    if (name && name.indexOf('Mui') === 0 && !styleSheet.options.link && !disableGlobal) {
      // We can use a shorthand class name, we never use the keys to style the components.
      if (pseudoClasses.indexOf(rule.key) !== -1) {
        return "Mui-".concat(rule.key);
      }

      var prefix = "".concat(seedPrefix).concat(name, "-").concat(rule.key);

      if (!styleSheet.options.theme[nested] || seed !== '') {
        return prefix;
      }

      return "".concat(prefix, "-").concat(getNextCounterId());
    }

    if (process.env.NODE_ENV === 'production') {
      return "".concat(seedPrefix).concat(productionPrefix).concat(getNextCounterId());
    }

    var suffix = "".concat(rule.key, "-").concat(getNextCounterId()); // Help with debuggability.

    if (styleSheet.options.classNamePrefix) {
      return "".concat(seedPrefix).concat(styleSheet.options.classNamePrefix, "-").concat(suffix);
    }

    return "".concat(seedPrefix).concat(suffix);
  };
}

/* eslint-disable no-restricted-syntax */
function getThemeProps(params) {
  var theme = params.theme,
      name = params.name,
      props = params.props;

  if (!theme || !theme.props || !theme.props[name]) {
    return props;
  } // Resolve default props, code borrow from React source.
  // https://github.com/facebook/react/blob/15a8f031838a553e41c0b66eb1bcf1da8448104d/packages/react/src/ReactElement.js#L221


  var defaultProps = theme.props[name];
  var propName;

  for (propName in defaultProps) {
    if (props[propName] === undefined) {
      props[propName] = defaultProps[propName];
    }
  }

  return props;
}

var isProduction = process.env.NODE_ENV === 'production';
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var isBrowser = (typeof window === "undefined" ? "undefined" : _typeof(window)) === "object" && (typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && document.nodeType === 9;

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

var plainObjectConstrurctor = {}.constructor;
function cloneStyle(style) {
  if (style == null || typeof style !== 'object') return style;
  if (Array.isArray(style)) return style.map(cloneStyle);
  if (style.constructor !== plainObjectConstrurctor) return style;
  var newStyle = {};

  for (var name in style) {
    newStyle[name] = cloneStyle(style[name]);
  }

  return newStyle;
}

/**
 * Create a rule instance.
 */

function createRule(name, decl, options) {
  if (name === void 0) {
    name = 'unnamed';
  }

  var jss = options.jss;
  var declCopy = cloneStyle(decl);
  var rule = jss.plugins.onCreateRule(name, declCopy, options);
  if (rule) return rule; // It is an at-rule and it has no instance.

  if (name[0] === '@') {
    process.env.NODE_ENV !== "production" ? warning(false, "[JSS] Unknown rule " + name) : void 0;
  }

  return null;
}

var join = function join(value, by) {
  var result = '';

  for (var i = 0; i < value.length; i++) {
    // Remove !important from the value, it will be readded later.
    if (value[i] === '!important') break;
    if (result) result += by;
    result += value[i];
  }

  return result;
};
/**
 * Converts JSS array value to a CSS string.
 *
 * `margin: [['5px', '10px']]` > `margin: 5px 10px;`
 * `border: ['1px', '2px']` > `border: 1px, 2px;`
 * `margin: [['5px', '10px'], '!important']` > `margin: 5px 10px !important;`
 * `color: ['red', !important]` > `color: red !important;`
 */


var toCssValue = function toCssValue(value) {
  if (!Array.isArray(value)) return value;
  var cssValue = ''; // Support space separated values via `[['5px', '10px']]`.

  if (Array.isArray(value[0])) {
    for (var i = 0; i < value.length; i++) {
      if (value[i] === '!important') break;
      if (cssValue) cssValue += ', ';
      cssValue += join(value[i], ' ');
    }
  } else cssValue = join(value, ', '); // Add !important, because it was ignored.


  if (value[value.length - 1] === '!important') {
    cssValue += ' !important';
  }

  return cssValue;
};

function getWhitespaceSymbols(options) {
  if (options && options.format === false) {
    return {
      linebreak: '',
      space: ''
    };
  }

  return {
    linebreak: '\n',
    space: ' '
  };
}

/**
 * Indent a string.
 * http://jsperf.com/array-join-vs-for
 */

function indentStr(str, indent) {
  var result = '';

  for (var index = 0; index < indent; index++) {
    result += '  ';
  }

  return result + str;
}
/**
 * Converts a Rule to CSS string.
 */


function toCss(selector, style, options) {
  if (options === void 0) {
    options = {};
  }

  var result = '';
  if (!style) return result;
  var _options = options,
      _options$indent = _options.indent,
      indent = _options$indent === void 0 ? 0 : _options$indent;
  var fallbacks = style.fallbacks;

  if (options.format === false) {
    indent = -Infinity;
  }

  var _getWhitespaceSymbols = getWhitespaceSymbols(options),
      linebreak = _getWhitespaceSymbols.linebreak,
      space = _getWhitespaceSymbols.space;

  if (selector) indent++; // Apply fallbacks first.

  if (fallbacks) {
    // Array syntax {fallbacks: [{prop: value}]}
    if (Array.isArray(fallbacks)) {
      for (var index = 0; index < fallbacks.length; index++) {
        var fallback = fallbacks[index];

        for (var prop in fallback) {
          var value = fallback[prop];

          if (value != null) {
            if (result) result += linebreak;
            result += indentStr(prop + ":" + space + toCssValue(value) + ";", indent);
          }
        }
      }
    } else {
      // Object syntax {fallbacks: {prop: value}}
      for (var _prop in fallbacks) {
        var _value = fallbacks[_prop];

        if (_value != null) {
          if (result) result += linebreak;
          result += indentStr(_prop + ":" + space + toCssValue(_value) + ";", indent);
        }
      }
    }
  }

  for (var _prop2 in style) {
    var _value2 = style[_prop2];

    if (_value2 != null && _prop2 !== 'fallbacks') {
      if (result) result += linebreak;
      result += indentStr(_prop2 + ":" + space + toCssValue(_value2) + ";", indent);
    }
  } // Allow empty style in this case, because properties will be added dynamically.


  if (!result && !options.allowEmpty) return result; // When rule is being stringified before selector was defined.

  if (!selector) return result;
  indent--;
  if (result) result = "" + linebreak + result + linebreak;
  return indentStr("" + selector + space + "{" + result, indent) + indentStr('}', indent);
}

var escapeRegex = /([[\].#*$><+~=|^:(),"'`\s])/g;
var nativeEscape = typeof CSS !== 'undefined' && CSS.escape;
var escape$2 = (function (str) {
  return nativeEscape ? nativeEscape(str) : str.replace(escapeRegex, '\\$1');
});

var BaseStyleRule =
/*#__PURE__*/
function () {
  function BaseStyleRule(key, style, options) {
    this.type = 'style';
    this.isProcessed = false;
    var sheet = options.sheet,
        Renderer = options.Renderer;
    this.key = key;
    this.options = options;
    this.style = style;
    if (sheet) this.renderer = sheet.renderer;else if (Renderer) this.renderer = new Renderer();
  }
  /**
   * Get or set a style property.
   */


  var _proto = BaseStyleRule.prototype;

  _proto.prop = function prop(name, value, options) {
    // It's a getter.
    if (value === undefined) return this.style[name]; // Don't do anything if the value has not changed.

    var force = options ? options.force : false;
    if (!force && this.style[name] === value) return this;
    var newValue = value;

    if (!options || options.process !== false) {
      newValue = this.options.jss.plugins.onChangeValue(value, name, this);
    }

    var isEmpty = newValue == null || newValue === false;
    var isDefined = name in this.style; // Value is empty and wasn't defined before.

    if (isEmpty && !isDefined && !force) return this; // We are going to remove this value.

    var remove = isEmpty && isDefined;
    if (remove) delete this.style[name];else this.style[name] = newValue; // Renderable is defined if StyleSheet option `link` is true.

    if (this.renderable && this.renderer) {
      if (remove) this.renderer.removeProperty(this.renderable, name);else this.renderer.setProperty(this.renderable, name, newValue);
      return this;
    }

    var sheet = this.options.sheet;

    if (sheet && sheet.attached) {
      process.env.NODE_ENV !== "production" ? warning(false, '[JSS] Rule is not linked. Missing sheet option "link: true".') : void 0;
    }

    return this;
  };

  return BaseStyleRule;
}();
var StyleRule =
/*#__PURE__*/
function (_BaseStyleRule) {
  _inheritsLoose(StyleRule, _BaseStyleRule);

  function StyleRule(key, style, options) {
    var _this;

    _this = _BaseStyleRule.call(this, key, style, options) || this;
    var selector = options.selector,
        scoped = options.scoped,
        sheet = options.sheet,
        generateId = options.generateId;

    if (selector) {
      _this.selectorText = selector;
    } else if (scoped !== false) {
      _this.id = generateId(_assertThisInitialized(_assertThisInitialized(_this)), sheet);
      _this.selectorText = "." + escape$2(_this.id);
    }

    return _this;
  }
  /**
   * Set selector string.
   * Attention: use this with caution. Most browsers didn't implement
   * selectorText setter, so this may result in rerendering of entire Style Sheet.
   */


  var _proto2 = StyleRule.prototype;

  /**
   * Apply rule to an element inline.
   */
  _proto2.applyTo = function applyTo(renderable) {
    var renderer = this.renderer;

    if (renderer) {
      var json = this.toJSON();

      for (var prop in json) {
        renderer.setProperty(renderable, prop, json[prop]);
      }
    }

    return this;
  }
  /**
   * Returns JSON representation of the rule.
   * Fallbacks are not supported.
   * Useful for inline styles.
   */
  ;

  _proto2.toJSON = function toJSON() {
    var json = {};

    for (var prop in this.style) {
      var value = this.style[prop];
      if (typeof value !== 'object') json[prop] = value;else if (Array.isArray(value)) json[prop] = toCssValue(value);
    }

    return json;
  }
  /**
   * Generates a CSS string.
   */
  ;

  _proto2.toString = function toString(options) {
    var sheet = this.options.sheet;
    var link = sheet ? sheet.options.link : false;
    var opts = link ? _extends({}, options, {
      allowEmpty: true
    }) : options;
    return toCss(this.selectorText, this.style, opts);
  };

  _createClass(StyleRule, [{
    key: "selector",
    set: function set(selector) {
      if (selector === this.selectorText) return;
      this.selectorText = selector;
      var renderer = this.renderer,
          renderable = this.renderable;
      if (!renderable || !renderer) return;
      var hasChanged = renderer.setSelector(renderable, selector); // If selector setter is not implemented, rerender the rule.

      if (!hasChanged) {
        renderer.replaceRule(renderable, this);
      }
    }
    /**
     * Get selector string.
     */
    ,
    get: function get() {
      return this.selectorText;
    }
  }]);

  return StyleRule;
}(BaseStyleRule);
var pluginStyleRule = {
  onCreateRule: function onCreateRule(key, style, options) {
    if (key[0] === '@' || options.parent && options.parent.type === 'keyframes') {
      return null;
    }

    return new StyleRule(key, style, options);
  }
};

var defaultToStringOptions = {
  indent: 1,
  children: true
};
var atRegExp = /@([\w-]+)/;
/**
 * Conditional rule for @media, @supports
 */

var ConditionalRule =
/*#__PURE__*/
function () {
  function ConditionalRule(key, styles, options) {
    this.type = 'conditional';
    this.isProcessed = false;
    this.key = key;
    var atMatch = key.match(atRegExp);
    this.at = atMatch ? atMatch[1] : 'unknown'; // Key might contain a unique suffix in case the `name` passed by user was duplicate.

    this.query = options.name || "@" + this.at;
    this.options = options;
    this.rules = new RuleList(_extends({}, options, {
      parent: this
    }));

    for (var name in styles) {
      this.rules.add(name, styles[name]);
    }

    this.rules.process();
  }
  /**
   * Get a rule.
   */


  var _proto = ConditionalRule.prototype;

  _proto.getRule = function getRule(name) {
    return this.rules.get(name);
  }
  /**
   * Get index of a rule.
   */
  ;

  _proto.indexOf = function indexOf(rule) {
    return this.rules.indexOf(rule);
  }
  /**
   * Create and register rule, run plugins.
   */
  ;

  _proto.addRule = function addRule(name, style, options) {
    var rule = this.rules.add(name, style, options);
    if (!rule) return null;
    this.options.jss.plugins.onProcessRule(rule);
    return rule;
  }
  /**
   * Replace rule, run plugins.
   */
  ;

  _proto.replaceRule = function replaceRule(name, style, options) {
    var newRule = this.rules.replace(name, style, options);
    if (newRule) this.options.jss.plugins.onProcessRule(newRule);
    return newRule;
  }
  /**
   * Generates a CSS string.
   */
  ;

  _proto.toString = function toString(options) {
    if (options === void 0) {
      options = defaultToStringOptions;
    }

    var _getWhitespaceSymbols = getWhitespaceSymbols(options),
        linebreak = _getWhitespaceSymbols.linebreak;

    if (options.indent == null) options.indent = defaultToStringOptions.indent;
    if (options.children == null) options.children = defaultToStringOptions.children;

    if (options.children === false) {
      return this.query + " {}";
    }

    var children = this.rules.toString(options);
    return children ? this.query + " {" + linebreak + children + linebreak + "}" : '';
  };

  return ConditionalRule;
}();
var keyRegExp = /@container|@media|@supports\s+/;
var pluginConditionalRule = {
  onCreateRule: function onCreateRule(key, styles, options) {
    return keyRegExp.test(key) ? new ConditionalRule(key, styles, options) : null;
  }
};

var defaultToStringOptions$1 = {
  indent: 1,
  children: true
};
var nameRegExp = /@keyframes\s+([\w-]+)/;
/**
 * Rule for @keyframes
 */

var KeyframesRule =
/*#__PURE__*/
function () {
  function KeyframesRule(key, frames, options) {
    this.type = 'keyframes';
    this.at = '@keyframes';
    this.isProcessed = false;
    var nameMatch = key.match(nameRegExp);

    if (nameMatch && nameMatch[1]) {
      this.name = nameMatch[1];
    } else {
      this.name = 'noname';
      process.env.NODE_ENV !== "production" ? warning(false, "[JSS] Bad keyframes name " + key) : void 0;
    }

    this.key = this.type + "-" + this.name;
    this.options = options;
    var scoped = options.scoped,
        sheet = options.sheet,
        generateId = options.generateId;
    this.id = scoped === false ? this.name : escape$2(generateId(this, sheet));
    this.rules = new RuleList(_extends({}, options, {
      parent: this
    }));

    for (var name in frames) {
      this.rules.add(name, frames[name], _extends({}, options, {
        parent: this
      }));
    }

    this.rules.process();
  }
  /**
   * Generates a CSS string.
   */


  var _proto = KeyframesRule.prototype;

  _proto.toString = function toString(options) {
    if (options === void 0) {
      options = defaultToStringOptions$1;
    }

    var _getWhitespaceSymbols = getWhitespaceSymbols(options),
        linebreak = _getWhitespaceSymbols.linebreak;

    if (options.indent == null) options.indent = defaultToStringOptions$1.indent;
    if (options.children == null) options.children = defaultToStringOptions$1.children;

    if (options.children === false) {
      return this.at + " " + this.id + " {}";
    }

    var children = this.rules.toString(options);
    if (children) children = "" + linebreak + children + linebreak;
    return this.at + " " + this.id + " {" + children + "}";
  };

  return KeyframesRule;
}();
var keyRegExp$1 = /@keyframes\s+/;
var refRegExp$1 = /\$([\w-]+)/g;

var findReferencedKeyframe = function findReferencedKeyframe(val, keyframes) {
  if (typeof val === 'string') {
    return val.replace(refRegExp$1, function (match, name) {
      if (name in keyframes) {
        return keyframes[name];
      }

      process.env.NODE_ENV !== "production" ? warning(false, "[JSS] Referenced keyframes rule \"" + name + "\" is not defined.") : void 0;
      return match;
    });
  }

  return val;
};
/**
 * Replace the reference for a animation name.
 */


var replaceRef = function replaceRef(style, prop, keyframes) {
  var value = style[prop];
  var refKeyframe = findReferencedKeyframe(value, keyframes);

  if (refKeyframe !== value) {
    style[prop] = refKeyframe;
  }
};

var pluginKeyframesRule = {
  onCreateRule: function onCreateRule(key, frames, options) {
    return typeof key === 'string' && keyRegExp$1.test(key) ? new KeyframesRule(key, frames, options) : null;
  },
  // Animation name ref replacer.
  onProcessStyle: function onProcessStyle(style, rule, sheet) {
    if (rule.type !== 'style' || !sheet) return style;
    if ('animation-name' in style) replaceRef(style, 'animation-name', sheet.keyframes);
    if ('animation' in style) replaceRef(style, 'animation', sheet.keyframes);
    return style;
  },
  onChangeValue: function onChangeValue(val, prop, rule) {
    var sheet = rule.options.sheet;

    if (!sheet) {
      return val;
    }

    switch (prop) {
      case 'animation':
        return findReferencedKeyframe(val, sheet.keyframes);

      case 'animation-name':
        return findReferencedKeyframe(val, sheet.keyframes);

      default:
        return val;
    }
  }
};

var KeyframeRule =
/*#__PURE__*/
function (_BaseStyleRule) {
  _inheritsLoose(KeyframeRule, _BaseStyleRule);

  function KeyframeRule() {
    return _BaseStyleRule.apply(this, arguments) || this;
  }

  var _proto = KeyframeRule.prototype;

  /**
   * Generates a CSS string.
   */
  _proto.toString = function toString(options) {
    var sheet = this.options.sheet;
    var link = sheet ? sheet.options.link : false;
    var opts = link ? _extends({}, options, {
      allowEmpty: true
    }) : options;
    return toCss(this.key, this.style, opts);
  };

  return KeyframeRule;
}(BaseStyleRule);
var pluginKeyframeRule = {
  onCreateRule: function onCreateRule(key, style, options) {
    if (options.parent && options.parent.type === 'keyframes') {
      return new KeyframeRule(key, style, options);
    }

    return null;
  }
};

var FontFaceRule =
/*#__PURE__*/
function () {
  function FontFaceRule(key, style, options) {
    this.type = 'font-face';
    this.at = '@font-face';
    this.isProcessed = false;
    this.key = key;
    this.style = style;
    this.options = options;
  }
  /**
   * Generates a CSS string.
   */


  var _proto = FontFaceRule.prototype;

  _proto.toString = function toString(options) {
    var _getWhitespaceSymbols = getWhitespaceSymbols(options),
        linebreak = _getWhitespaceSymbols.linebreak;

    if (Array.isArray(this.style)) {
      var str = '';

      for (var index = 0; index < this.style.length; index++) {
        str += toCss(this.at, this.style[index]);
        if (this.style[index + 1]) str += linebreak;
      }

      return str;
    }

    return toCss(this.at, this.style, options);
  };

  return FontFaceRule;
}();
var keyRegExp$2 = /@font-face/;
var pluginFontFaceRule = {
  onCreateRule: function onCreateRule(key, style, options) {
    return keyRegExp$2.test(key) ? new FontFaceRule(key, style, options) : null;
  }
};

var ViewportRule =
/*#__PURE__*/
function () {
  function ViewportRule(key, style, options) {
    this.type = 'viewport';
    this.at = '@viewport';
    this.isProcessed = false;
    this.key = key;
    this.style = style;
    this.options = options;
  }
  /**
   * Generates a CSS string.
   */


  var _proto = ViewportRule.prototype;

  _proto.toString = function toString(options) {
    return toCss(this.key, this.style, options);
  };

  return ViewportRule;
}();
var pluginViewportRule = {
  onCreateRule: function onCreateRule(key, style, options) {
    return key === '@viewport' || key === '@-ms-viewport' ? new ViewportRule(key, style, options) : null;
  }
};

var SimpleRule =
/*#__PURE__*/
function () {
  function SimpleRule(key, value, options) {
    this.type = 'simple';
    this.isProcessed = false;
    this.key = key;
    this.value = value;
    this.options = options;
  }
  /**
   * Generates a CSS string.
   */
  // eslint-disable-next-line no-unused-vars


  var _proto = SimpleRule.prototype;

  _proto.toString = function toString(options) {
    if (Array.isArray(this.value)) {
      var str = '';

      for (var index = 0; index < this.value.length; index++) {
        str += this.key + " " + this.value[index] + ";";
        if (this.value[index + 1]) str += '\n';
      }

      return str;
    }

    return this.key + " " + this.value + ";";
  };

  return SimpleRule;
}();
var keysMap = {
  '@charset': true,
  '@import': true,
  '@namespace': true
};
var pluginSimpleRule = {
  onCreateRule: function onCreateRule(key, value, options) {
    return key in keysMap ? new SimpleRule(key, value, options) : null;
  }
};

var plugins$1 = [pluginStyleRule, pluginConditionalRule, pluginKeyframesRule, pluginKeyframeRule, pluginFontFaceRule, pluginViewportRule, pluginSimpleRule];

var defaultUpdateOptions = {
  process: true
};
var forceUpdateOptions = {
  force: true,
  process: true
  /**
   * Contains rules objects and allows adding/removing etc.
   * Is used for e.g. by `StyleSheet` or `ConditionalRule`.
   */

};

var RuleList =
/*#__PURE__*/
function () {
  // Rules registry for access by .get() method.
  // It contains the same rule registered by name and by selector.
  // Original styles object.
  // Used to ensure correct rules order.
  function RuleList(options) {
    this.map = {};
    this.raw = {};
    this.index = [];
    this.counter = 0;
    this.options = options;
    this.classes = options.classes;
    this.keyframes = options.keyframes;
  }
  /**
   * Create and register rule.
   *
   * Will not render after Style Sheet was rendered the first time.
   */


  var _proto = RuleList.prototype;

  _proto.add = function add(name, decl, ruleOptions) {
    var _this$options = this.options,
        parent = _this$options.parent,
        sheet = _this$options.sheet,
        jss = _this$options.jss,
        Renderer = _this$options.Renderer,
        generateId = _this$options.generateId,
        scoped = _this$options.scoped;

    var options = _extends({
      classes: this.classes,
      parent: parent,
      sheet: sheet,
      jss: jss,
      Renderer: Renderer,
      generateId: generateId,
      scoped: scoped,
      name: name,
      keyframes: this.keyframes,
      selector: undefined
    }, ruleOptions); // When user uses .createStyleSheet(), duplicate names are not possible, but
    // `sheet.addRule()` opens the door for any duplicate rule name. When this happens
    // we need to make the key unique within this RuleList instance scope.


    var key = name;

    if (name in this.raw) {
      key = name + "-d" + this.counter++;
    } // We need to save the original decl before creating the rule
    // because cache plugin needs to use it as a key to return a cached rule.


    this.raw[key] = decl;

    if (key in this.classes) {
      // E.g. rules inside of @media container
      options.selector = "." + escape$2(this.classes[key]);
    }

    var rule = createRule(key, decl, options);
    if (!rule) return null;
    this.register(rule);
    var index = options.index === undefined ? this.index.length : options.index;
    this.index.splice(index, 0, rule);
    return rule;
  }
  /**
   * Replace rule.
   * Create a new rule and remove old one instead of overwriting
   * because we want to invoke onCreateRule hook to make plugins work.
   */
  ;

  _proto.replace = function replace(name, decl, ruleOptions) {
    var oldRule = this.get(name);
    var oldIndex = this.index.indexOf(oldRule);

    if (oldRule) {
      this.remove(oldRule);
    }

    var options = ruleOptions;
    if (oldIndex !== -1) options = _extends({}, ruleOptions, {
      index: oldIndex
    });
    return this.add(name, decl, options);
  }
  /**
   * Get a rule by name or selector.
   */
  ;

  _proto.get = function get(nameOrSelector) {
    return this.map[nameOrSelector];
  }
  /**
   * Delete a rule.
   */
  ;

  _proto.remove = function remove(rule) {
    this.unregister(rule);
    delete this.raw[rule.key];
    this.index.splice(this.index.indexOf(rule), 1);
  }
  /**
   * Get index of a rule.
   */
  ;

  _proto.indexOf = function indexOf(rule) {
    return this.index.indexOf(rule);
  }
  /**
   * Run `onProcessRule()` plugins on every rule.
   */
  ;

  _proto.process = function process() {
    var plugins = this.options.jss.plugins; // We need to clone array because if we modify the index somewhere else during a loop
    // we end up with very hard-to-track-down side effects.

    this.index.slice(0).forEach(plugins.onProcessRule, plugins);
  }
  /**
   * Register a rule in `.map`, `.classes` and `.keyframes` maps.
   */
  ;

  _proto.register = function register(rule) {
    this.map[rule.key] = rule;

    if (rule instanceof StyleRule) {
      this.map[rule.selector] = rule;
      if (rule.id) this.classes[rule.key] = rule.id;
    } else if (rule instanceof KeyframesRule && this.keyframes) {
      this.keyframes[rule.name] = rule.id;
    }
  }
  /**
   * Unregister a rule.
   */
  ;

  _proto.unregister = function unregister(rule) {
    delete this.map[rule.key];

    if (rule instanceof StyleRule) {
      delete this.map[rule.selector];
      delete this.classes[rule.key];
    } else if (rule instanceof KeyframesRule) {
      delete this.keyframes[rule.name];
    }
  }
  /**
   * Update the function values with a new data.
   */
  ;

  _proto.update = function update() {
    var name;
    var data;
    var options;

    if (typeof (arguments.length <= 0 ? undefined : arguments[0]) === 'string') {
      name = arguments.length <= 0 ? undefined : arguments[0];
      data = arguments.length <= 1 ? undefined : arguments[1];
      options = arguments.length <= 2 ? undefined : arguments[2];
    } else {
      data = arguments.length <= 0 ? undefined : arguments[0];
      options = arguments.length <= 1 ? undefined : arguments[1];
      name = null;
    }

    if (name) {
      this.updateOne(this.get(name), data, options);
    } else {
      for (var index = 0; index < this.index.length; index++) {
        this.updateOne(this.index[index], data, options);
      }
    }
  }
  /**
   * Execute plugins, update rule props.
   */
  ;

  _proto.updateOne = function updateOne(rule, data, options) {
    if (options === void 0) {
      options = defaultUpdateOptions;
    }

    var _this$options2 = this.options,
        plugins = _this$options2.jss.plugins,
        sheet = _this$options2.sheet; // It is a rules container like for e.g. ConditionalRule.

    if (rule.rules instanceof RuleList) {
      rule.rules.update(data, options);
      return;
    }

    var style = rule.style;
    plugins.onUpdate(data, rule, sheet, options); // We rely on a new `style` ref in case it was mutated during onUpdate hook.

    if (options.process && style && style !== rule.style) {
      // We need to run the plugins in case new `style` relies on syntax plugins.
      plugins.onProcessStyle(rule.style, rule, sheet); // Update and add props.

      for (var prop in rule.style) {
        var nextValue = rule.style[prop];
        var prevValue = style[prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
        // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.

        if (nextValue !== prevValue) {
          rule.prop(prop, nextValue, forceUpdateOptions);
        }
      } // Remove props.


      for (var _prop in style) {
        var _nextValue = rule.style[_prop];
        var _prevValue = style[_prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
        // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.

        if (_nextValue == null && _nextValue !== _prevValue) {
          rule.prop(_prop, null, forceUpdateOptions);
        }
      }
    }
  }
  /**
   * Convert rules to a CSS string.
   */
  ;

  _proto.toString = function toString(options) {
    var str = '';
    var sheet = this.options.sheet;
    var link = sheet ? sheet.options.link : false;

    var _getWhitespaceSymbols = getWhitespaceSymbols(options),
        linebreak = _getWhitespaceSymbols.linebreak;

    for (var index = 0; index < this.index.length; index++) {
      var rule = this.index[index];
      var css = rule.toString(options); // No need to render an empty rule.

      if (!css && !link) continue;
      if (str) str += linebreak;
      str += css;
    }

    return str;
  };

  return RuleList;
}();

var StyleSheet =
/*#__PURE__*/
function () {
  function StyleSheet(styles, options) {
    this.attached = false;
    this.deployed = false;
    this.classes = {};
    this.keyframes = {};
    this.options = _extends({}, options, {
      sheet: this,
      parent: this,
      classes: this.classes,
      keyframes: this.keyframes
    });

    if (options.Renderer) {
      this.renderer = new options.Renderer(this);
    }

    this.rules = new RuleList(this.options);

    for (var name in styles) {
      this.rules.add(name, styles[name]);
    }

    this.rules.process();
  }
  /**
   * Attach renderable to the render tree.
   */


  var _proto = StyleSheet.prototype;

  _proto.attach = function attach() {
    if (this.attached) return this;
    if (this.renderer) this.renderer.attach();
    this.attached = true; // Order is important, because we can't use insertRule API if style element is not attached.

    if (!this.deployed) this.deploy();
    return this;
  }
  /**
   * Remove renderable from render tree.
   */
  ;

  _proto.detach = function detach() {
    if (!this.attached) return this;
    if (this.renderer) this.renderer.detach();
    this.attached = false;
    return this;
  }
  /**
   * Add a rule to the current stylesheet.
   * Will insert a rule also after the stylesheet has been rendered first time.
   */
  ;

  _proto.addRule = function addRule(name, decl, options) {
    var queue = this.queue; // Plugins can create rules.
    // In order to preserve the right order, we need to queue all `.addRule` calls,
    // which happen after the first `rules.add()` call.

    if (this.attached && !queue) this.queue = [];
    var rule = this.rules.add(name, decl, options);
    if (!rule) return null;
    this.options.jss.plugins.onProcessRule(rule);

    if (this.attached) {
      if (!this.deployed) return rule; // Don't insert rule directly if there is no stringified version yet.
      // It will be inserted all together when .attach is called.

      if (queue) queue.push(rule);else {
        this.insertRule(rule);

        if (this.queue) {
          this.queue.forEach(this.insertRule, this);
          this.queue = undefined;
        }
      }
      return rule;
    } // We can't add rules to a detached style node.
    // We will redeploy the sheet once user will attach it.


    this.deployed = false;
    return rule;
  }
  /**
   * Replace a rule in the current stylesheet.
   */
  ;

  _proto.replaceRule = function replaceRule(nameOrSelector, decl, options) {
    var oldRule = this.rules.get(nameOrSelector);
    if (!oldRule) return this.addRule(nameOrSelector, decl, options);
    var newRule = this.rules.replace(nameOrSelector, decl, options);

    if (newRule) {
      this.options.jss.plugins.onProcessRule(newRule);
    }

    if (this.attached) {
      if (!this.deployed) return newRule; // Don't replace / delete rule directly if there is no stringified version yet.
      // It will be inserted all together when .attach is called.

      if (this.renderer) {
        if (!newRule) {
          this.renderer.deleteRule(oldRule);
        } else if (oldRule.renderable) {
          this.renderer.replaceRule(oldRule.renderable, newRule);
        }
      }

      return newRule;
    } // We can't replace rules to a detached style node.
    // We will redeploy the sheet once user will attach it.


    this.deployed = false;
    return newRule;
  }
  /**
   * Insert rule into the StyleSheet
   */
  ;

  _proto.insertRule = function insertRule(rule) {
    if (this.renderer) {
      this.renderer.insertRule(rule);
    }
  }
  /**
   * Create and add rules.
   * Will render also after Style Sheet was rendered the first time.
   */
  ;

  _proto.addRules = function addRules(styles, options) {
    var added = [];

    for (var name in styles) {
      var rule = this.addRule(name, styles[name], options);
      if (rule) added.push(rule);
    }

    return added;
  }
  /**
   * Get a rule by name or selector.
   */
  ;

  _proto.getRule = function getRule(nameOrSelector) {
    return this.rules.get(nameOrSelector);
  }
  /**
   * Delete a rule by name.
   * Returns `true`: if rule has been deleted from the DOM.
   */
  ;

  _proto.deleteRule = function deleteRule(name) {
    var rule = typeof name === 'object' ? name : this.rules.get(name);

    if (!rule || // Style sheet was created without link: true and attached, in this case we
    // won't be able to remove the CSS rule from the DOM.
    this.attached && !rule.renderable) {
      return false;
    }

    this.rules.remove(rule);

    if (this.attached && rule.renderable && this.renderer) {
      return this.renderer.deleteRule(rule.renderable);
    }

    return true;
  }
  /**
   * Get index of a rule.
   */
  ;

  _proto.indexOf = function indexOf(rule) {
    return this.rules.indexOf(rule);
  }
  /**
   * Deploy pure CSS string to a renderable.
   */
  ;

  _proto.deploy = function deploy() {
    if (this.renderer) this.renderer.deploy();
    this.deployed = true;
    return this;
  }
  /**
   * Update the function values with a new data.
   */
  ;

  _proto.update = function update() {
    var _this$rules;

    (_this$rules = this.rules).update.apply(_this$rules, arguments);

    return this;
  }
  /**
   * Updates a single rule.
   */
  ;

  _proto.updateOne = function updateOne(rule, data, options) {
    this.rules.updateOne(rule, data, options);
    return this;
  }
  /**
   * Convert rules to a CSS string.
   */
  ;

  _proto.toString = function toString(options) {
    return this.rules.toString(options);
  };

  return StyleSheet;
}();

var PluginsRegistry =
/*#__PURE__*/
function () {
  function PluginsRegistry() {
    this.plugins = {
      internal: [],
      external: []
    };
    this.registry = {};
  }

  var _proto = PluginsRegistry.prototype;

  /**
   * Call `onCreateRule` hooks and return an object if returned by a hook.
   */
  _proto.onCreateRule = function onCreateRule(name, decl, options) {
    for (var i = 0; i < this.registry.onCreateRule.length; i++) {
      var rule = this.registry.onCreateRule[i](name, decl, options);
      if (rule) return rule;
    }

    return null;
  }
  /**
   * Call `onProcessRule` hooks.
   */
  ;

  _proto.onProcessRule = function onProcessRule(rule) {
    if (rule.isProcessed) return;
    var sheet = rule.options.sheet;

    for (var i = 0; i < this.registry.onProcessRule.length; i++) {
      this.registry.onProcessRule[i](rule, sheet);
    }

    if (rule.style) this.onProcessStyle(rule.style, rule, sheet);
    rule.isProcessed = true;
  }
  /**
   * Call `onProcessStyle` hooks.
   */
  ;

  _proto.onProcessStyle = function onProcessStyle(style, rule, sheet) {
    for (var i = 0; i < this.registry.onProcessStyle.length; i++) {
      rule.style = this.registry.onProcessStyle[i](rule.style, rule, sheet);
    }
  }
  /**
   * Call `onProcessSheet` hooks.
   */
  ;

  _proto.onProcessSheet = function onProcessSheet(sheet) {
    for (var i = 0; i < this.registry.onProcessSheet.length; i++) {
      this.registry.onProcessSheet[i](sheet);
    }
  }
  /**
   * Call `onUpdate` hooks.
   */
  ;

  _proto.onUpdate = function onUpdate(data, rule, sheet, options) {
    for (var i = 0; i < this.registry.onUpdate.length; i++) {
      this.registry.onUpdate[i](data, rule, sheet, options);
    }
  }
  /**
   * Call `onChangeValue` hooks.
   */
  ;

  _proto.onChangeValue = function onChangeValue(value, prop, rule) {
    var processedValue = value;

    for (var i = 0; i < this.registry.onChangeValue.length; i++) {
      processedValue = this.registry.onChangeValue[i](processedValue, prop, rule);
    }

    return processedValue;
  }
  /**
   * Register a plugin.
   */
  ;

  _proto.use = function use(newPlugin, options) {
    if (options === void 0) {
      options = {
        queue: 'external'
      };
    }

    var plugins = this.plugins[options.queue]; // Avoids applying same plugin twice, at least based on ref.

    if (plugins.indexOf(newPlugin) !== -1) {
      return;
    }

    plugins.push(newPlugin);
    this.registry = [].concat(this.plugins.external, this.plugins.internal).reduce(function (registry, plugin) {
      for (var name in plugin) {
        if (name in registry) {
          registry[name].push(plugin[name]);
        } else {
          process.env.NODE_ENV !== "production" ? warning(false, "[JSS] Unknown hook \"" + name + "\".") : void 0;
        }
      }

      return registry;
    }, {
      onCreateRule: [],
      onProcessRule: [],
      onProcessStyle: [],
      onProcessSheet: [],
      onChangeValue: [],
      onUpdate: []
    });
  };

  return PluginsRegistry;
}();

/**
 * Sheets registry to access all instances in one place.
 */

var SheetsRegistry =
/*#__PURE__*/
function () {
  function SheetsRegistry() {
    this.registry = [];
  }

  var _proto = SheetsRegistry.prototype;

  /**
   * Register a Style Sheet.
   */
  _proto.add = function add(sheet) {
    var registry = this.registry;
    var index = sheet.options.index;
    if (registry.indexOf(sheet) !== -1) return;

    if (registry.length === 0 || index >= this.index) {
      registry.push(sheet);
      return;
    } // Find a position.


    for (var i = 0; i < registry.length; i++) {
      if (registry[i].options.index > index) {
        registry.splice(i, 0, sheet);
        return;
      }
    }
  }
  /**
   * Reset the registry.
   */
  ;

  _proto.reset = function reset() {
    this.registry = [];
  }
  /**
   * Remove a Style Sheet.
   */
  ;

  _proto.remove = function remove(sheet) {
    var index = this.registry.indexOf(sheet);
    this.registry.splice(index, 1);
  }
  /**
   * Convert all attached sheets to a CSS string.
   */
  ;

  _proto.toString = function toString(_temp) {
    var _ref = _temp === void 0 ? {} : _temp,
        attached = _ref.attached,
        options = _objectWithoutPropertiesLoose(_ref, ["attached"]);

    var _getWhitespaceSymbols = getWhitespaceSymbols(options),
        linebreak = _getWhitespaceSymbols.linebreak;

    var css = '';

    for (var i = 0; i < this.registry.length; i++) {
      var sheet = this.registry[i];

      if (attached != null && sheet.attached !== attached) {
        continue;
      }

      if (css) css += linebreak;
      css += sheet.toString(options);
    }

    return css;
  };

  _createClass(SheetsRegistry, [{
    key: "index",

    /**
     * Current highest index number.
     */
    get: function get() {
      return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
    }
  }]);

  return SheetsRegistry;
}();

/**
 * This is a global sheets registry. Only DomRenderer will add sheets to it.
 * On the server one should use an own SheetsRegistry instance and add the
 * sheets to it, because you need to make sure to create a new registry for
 * each request in order to not leak sheets across requests.
 */

var sheets = new SheetsRegistry();

/* eslint-disable */

/**
 * Now that `globalThis` is available on most platforms
 * (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/globalThis#browser_compatibility)
 * we check for `globalThis` first. `globalThis` is necessary for jss
 * to run in Agoric's secure version of JavaScript (SES). Under SES,
 * `globalThis` exists, but `window`, `self`, and `Function('return
 * this')()` are all undefined for security reasons.
 *
 * https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
 */
var globalThis$1 = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' && window.Math === Math ? window : typeof self !== 'undefined' && self.Math === Math ? self : Function('return this')();

var ns = '2f1acc6c3a606b082e5eef5e54414ffb';
if (globalThis$1[ns] == null) globalThis$1[ns] = 0; // Bundle may contain multiple JSS versions at the same time. In order to identify
// the current version with just one short number and use it for classes generation
// we use a counter. Also it is more accurate, because user can manually reevaluate
// the module.

var moduleId = globalThis$1[ns]++;

var maxRules = 1e10;
/**
 * Returns a function which generates unique class names based on counters.
 * When new generator function is created, rule counter is reseted.
 * We need to reset the rule counter for SSR for each request.
 */

var createGenerateId = function createGenerateId(options) {
  if (options === void 0) {
    options = {};
  }

  var ruleCounter = 0;

  var generateId = function generateId(rule, sheet) {
    ruleCounter += 1;

    if (ruleCounter > maxRules) {
      process.env.NODE_ENV !== "production" ? warning(false, "[JSS] You might have a memory leak. Rule counter is at " + ruleCounter + ".") : void 0;
    }

    var jssId = '';
    var prefix = '';

    if (sheet) {
      if (sheet.options.classNamePrefix) {
        prefix = sheet.options.classNamePrefix;
      }

      if (sheet.options.jss.id != null) {
        jssId = String(sheet.options.jss.id);
      }
    }

    if (options.minify) {
      // Using "c" because a number can't be the first char in a class name.
      return "" + (prefix || 'c') + moduleId + jssId + ruleCounter;
    }

    return prefix + rule.key + "-" + moduleId + (jssId ? "-" + jssId : '') + "-" + ruleCounter;
  };

  return generateId;
};

/**
 * Cache the value from the first time a function is called.
 */

var memoize = function memoize(fn) {
  var value;
  return function () {
    if (!value) value = fn();
    return value;
  };
};
/**
 * Get a style property value.
 */


var getPropertyValue = function getPropertyValue(cssRule, prop) {
  try {
    // Support CSSTOM.
    if (cssRule.attributeStyleMap) {
      return cssRule.attributeStyleMap.get(prop);
    }

    return cssRule.style.getPropertyValue(prop);
  } catch (err) {
    // IE may throw if property is unknown.
    return '';
  }
};
/**
 * Set a style property.
 */


var setProperty = function setProperty(cssRule, prop, value) {
  try {
    var cssValue = value;

    if (Array.isArray(value)) {
      cssValue = toCssValue(value);
    } // Support CSSTOM.


    if (cssRule.attributeStyleMap) {
      cssRule.attributeStyleMap.set(prop, cssValue);
    } else {
      var indexOfImportantFlag = cssValue ? cssValue.indexOf('!important') : -1;
      var cssValueWithoutImportantFlag = indexOfImportantFlag > -1 ? cssValue.substr(0, indexOfImportantFlag - 1) : cssValue;
      cssRule.style.setProperty(prop, cssValueWithoutImportantFlag, indexOfImportantFlag > -1 ? 'important' : '');
    }
  } catch (err) {
    // IE may throw if property is unknown.
    return false;
  }

  return true;
};
/**
 * Remove a style property.
 */


var removeProperty = function removeProperty(cssRule, prop) {
  try {
    // Support CSSTOM.
    if (cssRule.attributeStyleMap) {
      cssRule.attributeStyleMap.delete(prop);
    } else {
      cssRule.style.removeProperty(prop);
    }
  } catch (err) {
    process.env.NODE_ENV !== "production" ? warning(false, "[JSS] DOMException \"" + err.message + "\" was thrown. Tried to remove property \"" + prop + "\".") : void 0;
  }
};
/**
 * Set the selector.
 */


var setSelector = function setSelector(cssRule, selectorText) {
  cssRule.selectorText = selectorText; // Return false if setter was not successful.
  // Currently works in chrome only.

  return cssRule.selectorText === selectorText;
};
/**
 * Gets the `head` element upon the first call and caches it.
 * We assume it can't be null.
 */


var getHead = memoize(function () {
  return document.querySelector('head');
});
/**
 * Find attached sheet with an index higher than the passed one.
 */

function findHigherSheet(registry, options) {
  for (var i = 0; i < registry.length; i++) {
    var sheet = registry[i];

    if (sheet.attached && sheet.options.index > options.index && sheet.options.insertionPoint === options.insertionPoint) {
      return sheet;
    }
  }

  return null;
}
/**
 * Find attached sheet with the highest index.
 */


function findHighestSheet(registry, options) {
  for (var i = registry.length - 1; i >= 0; i--) {
    var sheet = registry[i];

    if (sheet.attached && sheet.options.insertionPoint === options.insertionPoint) {
      return sheet;
    }
  }

  return null;
}
/**
 * Find a comment with "jss" inside.
 */


function findCommentNode(text) {
  var head = getHead();

  for (var i = 0; i < head.childNodes.length; i++) {
    var node = head.childNodes[i];

    if (node.nodeType === 8 && node.nodeValue.trim() === text) {
      return node;
    }
  }

  return null;
}
/**
 * Find a node before which we can insert the sheet.
 */


function findPrevNode(options) {
  var registry = sheets.registry;

  if (registry.length > 0) {
    // Try to insert before the next higher sheet.
    var sheet = findHigherSheet(registry, options);

    if (sheet && sheet.renderer) {
      return {
        parent: sheet.renderer.element.parentNode,
        node: sheet.renderer.element
      };
    } // Otherwise insert after the last attached.


    sheet = findHighestSheet(registry, options);

    if (sheet && sheet.renderer) {
      return {
        parent: sheet.renderer.element.parentNode,
        node: sheet.renderer.element.nextSibling
      };
    }
  } // Try to find a comment placeholder if registry is empty.


  var insertionPoint = options.insertionPoint;

  if (insertionPoint && typeof insertionPoint === 'string') {
    var comment = findCommentNode(insertionPoint);

    if (comment) {
      return {
        parent: comment.parentNode,
        node: comment.nextSibling
      };
    } // If user specifies an insertion point and it can't be found in the document -
    // bad specificity issues may appear.


    process.env.NODE_ENV !== "production" ? warning(false, "[JSS] Insertion point \"" + insertionPoint + "\" not found.") : void 0;
  }

  return false;
}
/**
 * Insert style element into the DOM.
 */


function insertStyle(style, options) {
  var insertionPoint = options.insertionPoint;
  var nextNode = findPrevNode(options);

  if (nextNode !== false && nextNode.parent) {
    nextNode.parent.insertBefore(style, nextNode.node);
    return;
  } // Works with iframes and any node types.


  if (insertionPoint && typeof insertionPoint.nodeType === 'number') {
    var insertionPointElement = insertionPoint;
    var parentNode = insertionPointElement.parentNode;
    if (parentNode) parentNode.insertBefore(style, insertionPointElement.nextSibling);else process.env.NODE_ENV !== "production" ? warning(false, '[JSS] Insertion point is not in the DOM.') : void 0;
    return;
  }

  getHead().appendChild(style);
}
/**
 * Read jss nonce setting from the page if the user has set it.
 */


var getNonce = memoize(function () {
  var node = document.querySelector('meta[property="csp-nonce"]');
  return node ? node.getAttribute('content') : null;
});

var _insertRule = function insertRule(container, rule, index) {
  try {
    if ('insertRule' in container) {
      container.insertRule(rule, index);
    } // Keyframes rule.
    else if ('appendRule' in container) {
        container.appendRule(rule);
      }
  } catch (err) {
    process.env.NODE_ENV !== "production" ? warning(false, "[JSS] " + err.message) : void 0;
    return false;
  }

  return container.cssRules[index];
};

var getValidRuleInsertionIndex = function getValidRuleInsertionIndex(container, index) {
  var maxIndex = container.cssRules.length; // In case previous insertion fails, passed index might be wrong

  if (index === undefined || index > maxIndex) {
    // eslint-disable-next-line no-param-reassign
    return maxIndex;
  }

  return index;
};

var createStyle = function createStyle() {
  var el = document.createElement('style'); // Without it, IE will have a broken source order specificity if we
  // insert rules after we insert the style tag.
  // It seems to kick-off the source order specificity algorithm.

  el.textContent = '\n';
  return el;
};

var DomRenderer =
/*#__PURE__*/
function () {
  // Will be empty if link: true option is not set, because
  // it is only for use together with insertRule API.
  function DomRenderer(sheet) {
    this.getPropertyValue = getPropertyValue;
    this.setProperty = setProperty;
    this.removeProperty = removeProperty;
    this.setSelector = setSelector;
    this.hasInsertedRules = false;
    this.cssRules = [];
    // There is no sheet when the renderer is used from a standalone StyleRule.
    if (sheet) sheets.add(sheet);
    this.sheet = sheet;

    var _ref = this.sheet ? this.sheet.options : {},
        media = _ref.media,
        meta = _ref.meta,
        element = _ref.element;

    this.element = element || createStyle();
    this.element.setAttribute('data-jss', '');
    if (media) this.element.setAttribute('media', media);
    if (meta) this.element.setAttribute('data-meta', meta);
    var nonce = getNonce();
    if (nonce) this.element.setAttribute('nonce', nonce);
  }
  /**
   * Insert style element into render tree.
   */


  var _proto = DomRenderer.prototype;

  _proto.attach = function attach() {
    // In the case the element node is external and it is already in the DOM.
    if (this.element.parentNode || !this.sheet) return;
    insertStyle(this.element, this.sheet.options); // When rules are inserted using `insertRule` API, after `sheet.detach().attach()`
    // most browsers create a new CSSStyleSheet, except of all IEs.

    var deployed = Boolean(this.sheet && this.sheet.deployed);

    if (this.hasInsertedRules && deployed) {
      this.hasInsertedRules = false;
      this.deploy();
    }
  }
  /**
   * Remove style element from render tree.
   */
  ;

  _proto.detach = function detach() {
    if (!this.sheet) return;
    var parentNode = this.element.parentNode;
    if (parentNode) parentNode.removeChild(this.element); // In the most browsers, rules inserted using insertRule() API will be lost when style element is removed.
    // Though IE will keep them and we need a consistent behavior.

    if (this.sheet.options.link) {
      this.cssRules = [];
      this.element.textContent = '\n';
    }
  }
  /**
   * Inject CSS string into element.
   */
  ;

  _proto.deploy = function deploy() {
    var sheet = this.sheet;
    if (!sheet) return;

    if (sheet.options.link) {
      this.insertRules(sheet.rules);
      return;
    }

    this.element.textContent = "\n" + sheet.toString() + "\n";
  }
  /**
   * Insert RuleList into an element.
   */
  ;

  _proto.insertRules = function insertRules(rules, nativeParent) {
    for (var i = 0; i < rules.index.length; i++) {
      this.insertRule(rules.index[i], i, nativeParent);
    }
  }
  /**
   * Insert a rule into element.
   */
  ;

  _proto.insertRule = function insertRule(rule, index, nativeParent) {
    if (nativeParent === void 0) {
      nativeParent = this.element.sheet;
    }

    if (rule.rules) {
      var parent = rule;
      var latestNativeParent = nativeParent;

      if (rule.type === 'conditional' || rule.type === 'keyframes') {
        var _insertionIndex = getValidRuleInsertionIndex(nativeParent, index); // We need to render the container without children first.


        latestNativeParent = _insertRule(nativeParent, parent.toString({
          children: false
        }), _insertionIndex);

        if (latestNativeParent === false) {
          return false;
        }

        this.refCssRule(rule, _insertionIndex, latestNativeParent);
      }

      this.insertRules(parent.rules, latestNativeParent);
      return latestNativeParent;
    }

    var ruleStr = rule.toString();
    if (!ruleStr) return false;
    var insertionIndex = getValidRuleInsertionIndex(nativeParent, index);

    var nativeRule = _insertRule(nativeParent, ruleStr, insertionIndex);

    if (nativeRule === false) {
      return false;
    }

    this.hasInsertedRules = true;
    this.refCssRule(rule, insertionIndex, nativeRule);
    return nativeRule;
  };

  _proto.refCssRule = function refCssRule(rule, index, cssRule) {
    rule.renderable = cssRule; // We only want to reference the top level rules, deleteRule API doesn't support removing nested rules
    // like rules inside media queries or keyframes

    if (rule.options.parent instanceof StyleSheet) {
      this.cssRules.splice(index, 0, cssRule);
    }
  }
  /**
   * Delete a rule.
   */
  ;

  _proto.deleteRule = function deleteRule(cssRule) {
    var sheet = this.element.sheet;
    var index = this.indexOf(cssRule);
    if (index === -1) return false;
    sheet.deleteRule(index);
    this.cssRules.splice(index, 1);
    return true;
  }
  /**
   * Get index of a CSS Rule.
   */
  ;

  _proto.indexOf = function indexOf(cssRule) {
    return this.cssRules.indexOf(cssRule);
  }
  /**
   * Generate a new CSS rule and replace the existing one.
   */
  ;

  _proto.replaceRule = function replaceRule(cssRule, rule) {
    var index = this.indexOf(cssRule);
    if (index === -1) return false;
    this.element.sheet.deleteRule(index);
    this.cssRules.splice(index, 1);
    return this.insertRule(rule, index);
  }
  /**
   * Get all rules elements.
   */
  ;

  _proto.getRules = function getRules() {
    return this.element.sheet.cssRules;
  };

  return DomRenderer;
}();

var instanceCounter = 0;

var Jss =
/*#__PURE__*/
function () {
  function Jss(options) {
    this.id = instanceCounter++;
    this.version = "10.10.0";
    this.plugins = new PluginsRegistry();
    this.options = {
      id: {
        minify: false
      },
      createGenerateId: createGenerateId,
      Renderer: isBrowser ? DomRenderer : null,
      plugins: []
    };
    this.generateId = createGenerateId({
      minify: false
    });

    for (var i = 0; i < plugins$1.length; i++) {
      this.plugins.use(plugins$1[i], {
        queue: 'internal'
      });
    }

    this.setup(options);
  }
  /**
   * Prepares various options, applies plugins.
   * Should not be used twice on the same instance, because there is no plugins
   * deduplication logic.
   */


  var _proto = Jss.prototype;

  _proto.setup = function setup(options) {
    if (options === void 0) {
      options = {};
    }

    if (options.createGenerateId) {
      this.options.createGenerateId = options.createGenerateId;
    }

    if (options.id) {
      this.options.id = _extends({}, this.options.id, options.id);
    }

    if (options.createGenerateId || options.id) {
      this.generateId = this.options.createGenerateId(this.options.id);
    }

    if (options.insertionPoint != null) this.options.insertionPoint = options.insertionPoint;

    if ('Renderer' in options) {
      this.options.Renderer = options.Renderer;
    } // eslint-disable-next-line prefer-spread


    if (options.plugins) this.use.apply(this, options.plugins);
    return this;
  }
  /**
   * Create a Style Sheet.
   */
  ;

  _proto.createStyleSheet = function createStyleSheet(styles, options) {
    if (options === void 0) {
      options = {};
    }

    var _options = options,
        index = _options.index;

    if (typeof index !== 'number') {
      index = sheets.index === 0 ? 0 : sheets.index + 1;
    }

    var sheet = new StyleSheet(styles, _extends({}, options, {
      jss: this,
      generateId: options.generateId || this.generateId,
      insertionPoint: this.options.insertionPoint,
      Renderer: this.options.Renderer,
      index: index
    }));
    this.plugins.onProcessSheet(sheet);
    return sheet;
  }
  /**
   * Detach the Style Sheet and remove it from the registry.
   */
  ;

  _proto.removeStyleSheet = function removeStyleSheet(sheet) {
    sheet.detach();
    sheets.remove(sheet);
    return this;
  }
  /**
   * Create a rule without a Style Sheet.
   * [Deprecated] will be removed in the next major version.
   */
  ;

  _proto.createRule = function createRule$1(name, style, options) {
    if (style === void 0) {
      style = {};
    }

    if (options === void 0) {
      options = {};
    }

    // Enable rule without name for inline styles.
    if (typeof name === 'object') {
      return this.createRule(undefined, name, style);
    }

    var ruleOptions = _extends({}, options, {
      name: name,
      jss: this,
      Renderer: this.options.Renderer
    });

    if (!ruleOptions.generateId) ruleOptions.generateId = this.generateId;
    if (!ruleOptions.classes) ruleOptions.classes = {};
    if (!ruleOptions.keyframes) ruleOptions.keyframes = {};

    var rule = createRule(name, style, ruleOptions);

    if (rule) this.plugins.onProcessRule(rule);
    return rule;
  }
  /**
   * Register plugin. Passed function will be invoked with a rule instance.
   */
  ;

  _proto.use = function use() {
    var _this = this;

    for (var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++) {
      plugins[_key] = arguments[_key];
    }

    plugins.forEach(function (plugin) {
      _this.plugins.use(plugin);
    });
    return this;
  };

  return Jss;
}();

var createJss = function createJss(options) {
  return new Jss(options);
};

/**
* Export a constant indicating if this browser has CSSTOM support.
* https://developers.google.com/web/updates/2018/03/cssom
*/
var hasCSSTOMSupport = typeof CSS === 'object' && CSS != null && 'number' in CSS;

/**
 * Extracts a styles object with only props that contain function values.
 */
function getDynamicStyles(styles) {
  var to = null;

  for (var key in styles) {
    var value = styles[key];
    var type = typeof value;

    if (type === 'function') {
      if (!to) to = {};
      to[key] = value;
    } else if (type === 'object' && value !== null && !Array.isArray(value)) {
      var extracted = getDynamicStyles(value);

      if (extracted) {
        if (!to) to = {};
        to[key] = extracted;
      }
    }
  }

  return to;
}

/**
 * A better abstraction over CSS.
 *
 * @copyright Oleg Isonen (Slobodskoi) / Isonen 2014-present
 * @website https://github.com/cssinjs/jss
 * @license MIT
 */
createJss();

var now = Date.now();
var fnValuesNs = "fnValues" + now;
var fnRuleNs = "fnStyle" + ++now;

var functionPlugin = function functionPlugin() {
  return {
    onCreateRule: function onCreateRule(name, decl, options) {
      if (typeof decl !== 'function') return null;
      var rule = createRule(name, {}, options);
      rule[fnRuleNs] = decl;
      return rule;
    },
    onProcessStyle: function onProcessStyle(style, rule) {
      // We need to extract function values from the declaration, so that we can keep core unaware of them.
      // We need to do that only once.
      // We don't need to extract functions on each style update, since this can happen only once.
      // We don't support function values inside of function rules.
      if (fnValuesNs in rule || fnRuleNs in rule) return style;
      var fnValues = {};

      for (var prop in style) {
        var value = style[prop];
        if (typeof value !== 'function') continue;
        delete style[prop];
        fnValues[prop] = value;
      }

      rule[fnValuesNs] = fnValues;
      return style;
    },
    onUpdate: function onUpdate(data, rule, sheet, options) {
      var styleRule = rule;
      var fnRule = styleRule[fnRuleNs]; // If we have a style function, the entire rule is dynamic and style object
      // will be returned from that function.

      if (fnRule) {
        // Empty object will remove all currently defined props
        // in case function rule returns a falsy value.
        styleRule.style = fnRule(data) || {};

        if (process.env.NODE_ENV === 'development') {
          for (var prop in styleRule.style) {
            if (typeof styleRule.style[prop] === 'function') {
              process.env.NODE_ENV !== "production" ? warning(false, '[JSS] Function values inside function rules are not supported.') : void 0;
              break;
            }
          }
        }
      }

      var fnValues = styleRule[fnValuesNs]; // If we have a fn values map, it is a rule with function values.

      if (fnValues) {
        for (var _prop in fnValues) {
          styleRule.prop(_prop, fnValues[_prop](data), options);
        }
      }
    }
  };
};

var functions = functionPlugin;

var at = '@global';
var atPrefix = '@global ';

var GlobalContainerRule =
/*#__PURE__*/
function () {
  function GlobalContainerRule(key, styles, options) {
    this.type = 'global';
    this.at = at;
    this.isProcessed = false;
    this.key = key;
    this.options = options;
    this.rules = new RuleList(_extends({}, options, {
      parent: this
    }));

    for (var selector in styles) {
      this.rules.add(selector, styles[selector]);
    }

    this.rules.process();
  }
  /**
   * Get a rule.
   */


  var _proto = GlobalContainerRule.prototype;

  _proto.getRule = function getRule(name) {
    return this.rules.get(name);
  }
  /**
   * Create and register rule, run plugins.
   */
  ;

  _proto.addRule = function addRule(name, style, options) {
    var rule = this.rules.add(name, style, options);
    if (rule) this.options.jss.plugins.onProcessRule(rule);
    return rule;
  }
  /**
   * Replace rule, run plugins.
   */
  ;

  _proto.replaceRule = function replaceRule(name, style, options) {
    var newRule = this.rules.replace(name, style, options);
    if (newRule) this.options.jss.plugins.onProcessRule(newRule);
    return newRule;
  }
  /**
   * Get index of a rule.
   */
  ;

  _proto.indexOf = function indexOf(rule) {
    return this.rules.indexOf(rule);
  }
  /**
   * Generates a CSS string.
   */
  ;

  _proto.toString = function toString(options) {
    return this.rules.toString(options);
  };

  return GlobalContainerRule;
}();

var GlobalPrefixedRule =
/*#__PURE__*/
function () {
  function GlobalPrefixedRule(key, style, options) {
    this.type = 'global';
    this.at = at;
    this.isProcessed = false;
    this.key = key;
    this.options = options;
    var selector = key.substr(atPrefix.length);
    this.rule = options.jss.createRule(selector, style, _extends({}, options, {
      parent: this
    }));
  }

  var _proto2 = GlobalPrefixedRule.prototype;

  _proto2.toString = function toString(options) {
    return this.rule ? this.rule.toString(options) : '';
  };

  return GlobalPrefixedRule;
}();

var separatorRegExp$1 = /\s*,\s*/g;

function addScope(selector, scope) {
  var parts = selector.split(separatorRegExp$1);
  var scoped = '';

  for (var i = 0; i < parts.length; i++) {
    scoped += scope + " " + parts[i].trim();
    if (parts[i + 1]) scoped += ', ';
  }

  return scoped;
}

function handleNestedGlobalContainerRule(rule, sheet) {
  var options = rule.options,
      style = rule.style;
  var rules = style ? style[at] : null;
  if (!rules) return;

  for (var name in rules) {
    sheet.addRule(name, rules[name], _extends({}, options, {
      selector: addScope(name, rule.selector)
    }));
  }

  delete style[at];
}

function handlePrefixedGlobalRule(rule, sheet) {
  var options = rule.options,
      style = rule.style;

  for (var prop in style) {
    if (prop[0] !== '@' || prop.substr(0, at.length) !== at) continue;
    var selector = addScope(prop.substr(at.length), rule.selector);
    sheet.addRule(selector, style[prop], _extends({}, options, {
      selector: selector
    }));
    delete style[prop];
  }
}
/**
 * Convert nested rules to separate, remove them from original styles.
 */


function jssGlobal() {
  function onCreateRule(name, styles, options) {
    if (!name) return null;

    if (name === at) {
      return new GlobalContainerRule(name, styles, options);
    }

    if (name[0] === '@' && name.substr(0, atPrefix.length) === atPrefix) {
      return new GlobalPrefixedRule(name, styles, options);
    }

    var parent = options.parent;

    if (parent) {
      if (parent.type === 'global' || parent.options.parent && parent.options.parent.type === 'global') {
        options.scoped = false;
      }
    }

    if (!options.selector && options.scoped === false) {
      options.selector = name;
    }

    return null;
  }

  function onProcessRule(rule, sheet) {
    if (rule.type !== 'style' || !sheet) return;
    handleNestedGlobalContainerRule(rule, sheet);
    handlePrefixedGlobalRule(rule, sheet);
  }

  return {
    onCreateRule: onCreateRule,
    onProcessRule: onProcessRule
  };
}

var separatorRegExp = /\s*,\s*/g;
var parentRegExp = /&/g;
var refRegExp = /\$([\w-]+)/g;
/**
 * Convert nested rules to separate, remove them from original styles.
 */

function jssNested() {
  // Get a function to be used for $ref replacement.
  function getReplaceRef(container, sheet) {
    return function (match, key) {
      var rule = container.getRule(key) || sheet && sheet.getRule(key);

      if (rule) {
        return rule.selector;
      }

      process.env.NODE_ENV !== "production" ? warning(false, "[JSS] Could not find the referenced rule \"" + key + "\" in \"" + (container.options.meta || container.toString()) + "\".") : void 0;
      return key;
    };
  }

  function replaceParentRefs(nestedProp, parentProp) {
    var parentSelectors = parentProp.split(separatorRegExp);
    var nestedSelectors = nestedProp.split(separatorRegExp);
    var result = '';

    for (var i = 0; i < parentSelectors.length; i++) {
      var parent = parentSelectors[i];

      for (var j = 0; j < nestedSelectors.length; j++) {
        var nested = nestedSelectors[j];
        if (result) result += ', '; // Replace all & by the parent or prefix & with the parent.

        result += nested.indexOf('&') !== -1 ? nested.replace(parentRegExp, parent) : parent + " " + nested;
      }
    }

    return result;
  }

  function getOptions(rule, container, prevOptions) {
    // Options has been already created, now we only increase index.
    if (prevOptions) return _extends({}, prevOptions, {
      index: prevOptions.index + 1
    });
    var nestingLevel = rule.options.nestingLevel;
    nestingLevel = nestingLevel === undefined ? 1 : nestingLevel + 1;

    var options = _extends({}, rule.options, {
      nestingLevel: nestingLevel,
      index: container.indexOf(rule) + 1 // We don't need the parent name to be set options for chlid.

    });

    delete options.name;
    return options;
  }

  function onProcessStyle(style, rule, sheet) {
    if (rule.type !== 'style') return style;
    var styleRule = rule;
    var container = styleRule.options.parent;
    var options;
    var replaceRef;

    for (var prop in style) {
      var isNested = prop.indexOf('&') !== -1;
      var isNestedConditional = prop[0] === '@';
      if (!isNested && !isNestedConditional) continue;
      options = getOptions(styleRule, container, options);

      if (isNested) {
        var selector = replaceParentRefs(prop, styleRule.selector); // Lazily create the ref replacer function just once for
        // all nested rules within the sheet.

        if (!replaceRef) replaceRef = getReplaceRef(container, sheet); // Replace all $refs.

        selector = selector.replace(refRegExp, replaceRef);
        var name = styleRule.key + "-" + prop;

        if ('replaceRule' in container) {
          // for backward compatibility
          container.replaceRule(name, style[prop], _extends({}, options, {
            selector: selector
          }));
        } else {
          container.addRule(name, style[prop], _extends({}, options, {
            selector: selector
          }));
        }
      } else if (isNestedConditional) {
        // Place conditional right after the parent rule to ensure right ordering.
        container.addRule(prop, {}, options).addRule(styleRule.key, style[prop], {
          selector: styleRule.selector
        });
      }

      delete style[prop];
    }

    return style;
  }

  return {
    onProcessStyle: onProcessStyle
  };
}

/* eslint-disable no-var, prefer-template */
var uppercasePattern = /[A-Z]/g;
var msPattern = /^ms-/;
var cache$2 = {};

function toHyphenLower(match) {
  return '-' + match.toLowerCase()
}

function hyphenateStyleName(name) {
  if (cache$2.hasOwnProperty(name)) {
    return cache$2[name]
  }

  var hName = name.replace(uppercasePattern, toHyphenLower);
  return (cache$2[name] = msPattern.test(hName) ? '-' + hName : hName)
}

/**
 * Convert camel cased property names to dash separated.
 */

function convertCase(style) {
  var converted = {};

  for (var prop in style) {
    var key = prop.indexOf('--') === 0 ? prop : hyphenateStyleName(prop);
    converted[key] = style[prop];
  }

  if (style.fallbacks) {
    if (Array.isArray(style.fallbacks)) converted.fallbacks = style.fallbacks.map(convertCase);else converted.fallbacks = convertCase(style.fallbacks);
  }

  return converted;
}
/**
 * Allow camel cased property names by converting them back to dasherized.
 */


function camelCase() {
  function onProcessStyle(style) {
    if (Array.isArray(style)) {
      // Handle rules like @font-face, which can have multiple styles in an array
      for (var index = 0; index < style.length; index++) {
        style[index] = convertCase(style[index]);
      }

      return style;
    }

    return convertCase(style);
  }

  function onChangeValue(value, prop, rule) {
    if (prop.indexOf('--') === 0) {
      return value;
    }

    var hyphenatedProp = hyphenateStyleName(prop); // There was no camel case in place

    if (prop === hyphenatedProp) return value;
    rule.prop(hyphenatedProp, value); // Core will ignore that property value we set the proper one above.

    return null;
  }

  return {
    onProcessStyle: onProcessStyle,
    onChangeValue: onChangeValue
  };
}

var px = hasCSSTOMSupport && CSS ? CSS.px : 'px';
var ms$1 = hasCSSTOMSupport && CSS ? CSS.ms : 'ms';
var percent = hasCSSTOMSupport && CSS ? CSS.percent : '%';
/**
 * Generated jss-plugin-default-unit CSS property units
 */

var defaultUnits = {
  // Animation properties
  'animation-delay': ms$1,
  'animation-duration': ms$1,
  // Background properties
  'background-position': px,
  'background-position-x': px,
  'background-position-y': px,
  'background-size': px,
  // Border Properties
  border: px,
  'border-bottom': px,
  'border-bottom-left-radius': px,
  'border-bottom-right-radius': px,
  'border-bottom-width': px,
  'border-left': px,
  'border-left-width': px,
  'border-radius': px,
  'border-right': px,
  'border-right-width': px,
  'border-top': px,
  'border-top-left-radius': px,
  'border-top-right-radius': px,
  'border-top-width': px,
  'border-width': px,
  'border-block': px,
  'border-block-end': px,
  'border-block-end-width': px,
  'border-block-start': px,
  'border-block-start-width': px,
  'border-block-width': px,
  'border-inline': px,
  'border-inline-end': px,
  'border-inline-end-width': px,
  'border-inline-start': px,
  'border-inline-start-width': px,
  'border-inline-width': px,
  'border-start-start-radius': px,
  'border-start-end-radius': px,
  'border-end-start-radius': px,
  'border-end-end-radius': px,
  // Margin properties
  margin: px,
  'margin-bottom': px,
  'margin-left': px,
  'margin-right': px,
  'margin-top': px,
  'margin-block': px,
  'margin-block-end': px,
  'margin-block-start': px,
  'margin-inline': px,
  'margin-inline-end': px,
  'margin-inline-start': px,
  // Padding properties
  padding: px,
  'padding-bottom': px,
  'padding-left': px,
  'padding-right': px,
  'padding-top': px,
  'padding-block': px,
  'padding-block-end': px,
  'padding-block-start': px,
  'padding-inline': px,
  'padding-inline-end': px,
  'padding-inline-start': px,
  // Mask properties
  'mask-position-x': px,
  'mask-position-y': px,
  'mask-size': px,
  // Width and height properties
  height: px,
  width: px,
  'min-height': px,
  'max-height': px,
  'min-width': px,
  'max-width': px,
  // Position properties
  bottom: px,
  left: px,
  top: px,
  right: px,
  inset: px,
  'inset-block': px,
  'inset-block-end': px,
  'inset-block-start': px,
  'inset-inline': px,
  'inset-inline-end': px,
  'inset-inline-start': px,
  // Shadow properties
  'box-shadow': px,
  'text-shadow': px,
  // Column properties
  'column-gap': px,
  'column-rule': px,
  'column-rule-width': px,
  'column-width': px,
  // Font and text properties
  'font-size': px,
  'font-size-delta': px,
  'letter-spacing': px,
  'text-decoration-thickness': px,
  'text-indent': px,
  'text-stroke': px,
  'text-stroke-width': px,
  'word-spacing': px,
  // Motion properties
  motion: px,
  'motion-offset': px,
  // Outline properties
  outline: px,
  'outline-offset': px,
  'outline-width': px,
  // Perspective properties
  perspective: px,
  'perspective-origin-x': percent,
  'perspective-origin-y': percent,
  // Transform properties
  'transform-origin': percent,
  'transform-origin-x': percent,
  'transform-origin-y': percent,
  'transform-origin-z': percent,
  // Transition properties
  'transition-delay': ms$1,
  'transition-duration': ms$1,
  // Alignment properties
  'vertical-align': px,
  'flex-basis': px,
  // Some random properties
  'shape-margin': px,
  size: px,
  gap: px,
  // Grid properties
  grid: px,
  'grid-gap': px,
  'row-gap': px,
  'grid-row-gap': px,
  'grid-column-gap': px,
  'grid-template-rows': px,
  'grid-template-columns': px,
  'grid-auto-rows': px,
  'grid-auto-columns': px,
  // Not existing properties.
  // Used to avoid issues with jss-plugin-expand integration.
  'box-shadow-x': px,
  'box-shadow-y': px,
  'box-shadow-blur': px,
  'box-shadow-spread': px,
  'font-line-height': px,
  'text-shadow-x': px,
  'text-shadow-y': px,
  'text-shadow-blur': px
};

/**
 * Clones the object and adds a camel cased property version.
 */

function addCamelCasedVersion(obj) {
  var regExp = /(-[a-z])/g;

  var replace = function replace(str) {
    return str[1].toUpperCase();
  };

  var newObj = {};

  for (var key in obj) {
    newObj[key] = obj[key];
    newObj[key.replace(regExp, replace)] = obj[key];
  }

  return newObj;
}

var units = addCamelCasedVersion(defaultUnits);
/**
 * Recursive deep style passing function
 */

function iterate(prop, value, options) {
  if (value == null) return value;

  if (Array.isArray(value)) {
    for (var i = 0; i < value.length; i++) {
      value[i] = iterate(prop, value[i], options);
    }
  } else if (typeof value === 'object') {
    if (prop === 'fallbacks') {
      for (var innerProp in value) {
        value[innerProp] = iterate(innerProp, value[innerProp], options);
      }
    } else {
      for (var _innerProp in value) {
        value[_innerProp] = iterate(prop + "-" + _innerProp, value[_innerProp], options);
      }
    } // eslint-disable-next-line no-restricted-globals

  } else if (typeof value === 'number' && isNaN(value) === false) {
    var unit = options[prop] || units[prop]; // Add the unit if available, except for the special case of 0px.

    if (unit && !(value === 0 && unit === px)) {
      return typeof unit === 'function' ? unit(value).toString() : "" + value + unit;
    }

    return value.toString();
  }

  return value;
}
/**
 * Add unit to numeric values.
 */


function defaultUnit(options) {
  if (options === void 0) {
    options = {};
  }

  var camelCasedOptions = addCamelCasedVersion(options);

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;

    for (var prop in style) {
      style[prop] = iterate(prop, style[prop], camelCasedOptions);
    }

    return style;
  }

  function onChangeValue(value, prop) {
    return iterate(prop, value, camelCasedOptions);
  }

  return {
    onProcessStyle: onProcessStyle,
    onChangeValue: onChangeValue
  };
}

// Export javascript style and css style vendor prefixes.
var js = '';
var css = '';
var vendor = '';
var browser$2 = '';
var isTouch = isBrowser && 'ontouchstart' in document.documentElement; // We should not do anything if required serverside.

if (isBrowser) {
  // Order matters. We need to check Webkit the last one because
  // other vendors use to add Webkit prefixes to some properties
  var jsCssMap = {
    Moz: '-moz-',
    ms: '-ms-',
    O: '-o-',
    Webkit: '-webkit-'
  };

  var _document$createEleme = document.createElement('p'),
      style = _document$createEleme.style;

  var testProp = 'Transform';

  for (var key in jsCssMap) {
    if (key + testProp in style) {
      js = key;
      css = jsCssMap[key];
      break;
    }
  } // Correctly detect the Edge browser.


  if (js === 'Webkit' && 'msHyphens' in style) {
    js = 'ms';
    css = jsCssMap.ms;
    browser$2 = 'edge';
  } // Correctly detect the Safari browser.


  if (js === 'Webkit' && '-apple-trailing-word' in style) {
    vendor = 'apple';
  }
}
/**
 * Vendor prefix string for the current browser.
 *
 * @type {{js: String, css: String, vendor: String, browser: String}}
 * @api public
 */


var prefix = {
  js: js,
  css: css,
  vendor: vendor,
  browser: browser$2,
  isTouch: isTouch
};

/**
 * Test if a keyframe at-rule should be prefixed or not
 *
 * @param {String} vendor prefix string for the current browser.
 * @return {String}
 * @api public
 */

function supportedKeyframes(key) {
  // Keyframes is already prefixed. e.g. key = '@-webkit-keyframes a'
  if (key[1] === '-') return key; // No need to prefix IE/Edge. Older browsers will ignore unsupported rules.
  // https://caniuse.com/#search=keyframes

  if (prefix.js === 'ms') return key;
  return "@" + prefix.css + "keyframes" + key.substr(10);
}

// https://caniuse.com/#search=appearance

var appearence = {
  noPrefill: ['appearance'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'appearance') return false;
    if (prefix.js === 'ms') return "-webkit-" + prop;
    return prefix.css + prop;
  }
};

// https://caniuse.com/#search=color-adjust

var colorAdjust = {
  noPrefill: ['color-adjust'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'color-adjust') return false;
    if (prefix.js === 'Webkit') return prefix.css + "print-" + prop;
    return prop;
  }
};

var regExp = /[-\s]+(.)?/g;
/**
 * Replaces the letter with the capital letter
 *
 * @param {String} match
 * @param {String} c
 * @return {String}
 * @api private
 */

function toUpper(match, c) {
  return c ? c.toUpperCase() : '';
}
/**
 * Convert dash separated strings to camel-cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */


function camelize(str) {
  return str.replace(regExp, toUpper);
}

/**
 * Convert dash separated strings to pascal cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */

function pascalize(str) {
  return camelize("-" + str);
}

// but we can use a longhand property instead.
// https://caniuse.com/#search=mask

var mask = {
  noPrefill: ['mask'],
  supportedProperty: function supportedProperty(prop, style) {
    if (!/^mask/.test(prop)) return false;

    if (prefix.js === 'Webkit') {
      var longhand = 'mask-image';

      if (camelize(longhand) in style) {
        return prop;
      }

      if (prefix.js + pascalize(longhand) in style) {
        return prefix.css + prop;
      }
    }

    return prop;
  }
};

// https://caniuse.com/#search=text-orientation

var textOrientation = {
  noPrefill: ['text-orientation'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'text-orientation') return false;

    if (prefix.vendor === 'apple' && !prefix.isTouch) {
      return prefix.css + prop;
    }

    return prop;
  }
};

// https://caniuse.com/#search=transform

var transform = {
  noPrefill: ['transform'],
  supportedProperty: function supportedProperty(prop, style, options) {
    if (prop !== 'transform') return false;

    if (options.transform) {
      return prop;
    }

    return prefix.css + prop;
  }
};

// https://caniuse.com/#search=transition

var transition = {
  noPrefill: ['transition'],
  supportedProperty: function supportedProperty(prop, style, options) {
    if (prop !== 'transition') return false;

    if (options.transition) {
      return prop;
    }

    return prefix.css + prop;
  }
};

// https://caniuse.com/#search=writing-mode

var writingMode = {
  noPrefill: ['writing-mode'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'writing-mode') return false;

    if (prefix.js === 'Webkit' || prefix.js === 'ms' && prefix.browser !== 'edge') {
      return prefix.css + prop;
    }

    return prop;
  }
};

// https://caniuse.com/#search=user-select

var userSelect = {
  noPrefill: ['user-select'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'user-select') return false;

    if (prefix.js === 'Moz' || prefix.js === 'ms' || prefix.vendor === 'apple') {
      return prefix.css + prop;
    }

    return prop;
  }
};

// https://caniuse.com/#search=multicolumn
// https://github.com/postcss/autoprefixer/issues/491
// https://github.com/postcss/autoprefixer/issues/177

var breakPropsOld = {
  supportedProperty: function supportedProperty(prop, style) {
    if (!/^break-/.test(prop)) return false;

    if (prefix.js === 'Webkit') {
      var jsProp = "WebkitColumn" + pascalize(prop);
      return jsProp in style ? prefix.css + "column-" + prop : false;
    }

    if (prefix.js === 'Moz') {
      var _jsProp = "page" + pascalize(prop);

      return _jsProp in style ? "page-" + prop : false;
    }

    return false;
  }
};

// See https://github.com/postcss/autoprefixer/issues/324.

var inlineLogicalOld = {
  supportedProperty: function supportedProperty(prop, style) {
    if (!/^(border|margin|padding)-inline/.test(prop)) return false;
    if (prefix.js === 'Moz') return prop;
    var newProp = prop.replace('-inline', '');
    return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
  }
};

// Camelization is required because we can't test using.
// CSS syntax for e.g. in FF.

var unprefixed = {
  supportedProperty: function supportedProperty(prop, style) {
    return camelize(prop) in style ? prop : false;
  }
};

var prefixed = {
  supportedProperty: function supportedProperty(prop, style) {
    var pascalized = pascalize(prop); // Return custom CSS variable without prefixing.

    if (prop[0] === '-') return prop; // Return already prefixed value without prefixing.

    if (prop[0] === '-' && prop[1] === '-') return prop;
    if (prefix.js + pascalized in style) return prefix.css + prop; // Try webkit fallback.

    if (prefix.js !== 'Webkit' && "Webkit" + pascalized in style) return "-webkit-" + prop;
    return false;
  }
};

// https://caniuse.com/#search=scroll-snap

var scrollSnap = {
  supportedProperty: function supportedProperty(prop) {
    if (prop.substring(0, 11) !== 'scroll-snap') return false;

    if (prefix.js === 'ms') {
      return "" + prefix.css + prop;
    }

    return prop;
  }
};

// https://caniuse.com/#search=overscroll-behavior

var overscrollBehavior = {
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'overscroll-behavior') return false;

    if (prefix.js === 'ms') {
      return prefix.css + "scroll-chaining";
    }

    return prop;
  }
};

var propMap = {
  'flex-grow': 'flex-positive',
  'flex-shrink': 'flex-negative',
  'flex-basis': 'flex-preferred-size',
  'justify-content': 'flex-pack',
  order: 'flex-order',
  'align-items': 'flex-align',
  'align-content': 'flex-line-pack' // 'align-self' is handled by 'align-self' plugin.

}; // Support old flex spec from 2012.

var flex2012 = {
  supportedProperty: function supportedProperty(prop, style) {
    var newProp = propMap[prop];
    if (!newProp) return false;
    return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
  }
};

var propMap$1 = {
  flex: 'box-flex',
  'flex-grow': 'box-flex',
  'flex-direction': ['box-orient', 'box-direction'],
  order: 'box-ordinal-group',
  'align-items': 'box-align',
  'flex-flow': ['box-orient', 'box-direction'],
  'justify-content': 'box-pack'
};
var propKeys = Object.keys(propMap$1);

var prefixCss = function prefixCss(p) {
  return prefix.css + p;
}; // Support old flex spec from 2009.


var flex2009 = {
  supportedProperty: function supportedProperty(prop, style, _ref) {
    var multiple = _ref.multiple;

    if (propKeys.indexOf(prop) > -1) {
      var newProp = propMap$1[prop];

      if (!Array.isArray(newProp)) {
        return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
      }

      if (!multiple) return false;

      for (var i = 0; i < newProp.length; i++) {
        if (!(prefix.js + pascalize(newProp[0]) in style)) {
          return false;
        }
      }

      return newProp.map(prefixCss);
    }

    return false;
  }
};

// plugins = [
//   ...plugins,
//    breakPropsOld,
//    inlineLogicalOld,
//    unprefixed,
//    prefixed,
//    scrollSnap,
//    flex2012,
//    flex2009
// ]
// Plugins without 'noPrefill' value, going last.
// 'flex-*' plugins should be at the bottom.
// 'flex2009' going after 'flex2012'.
// 'prefixed' going after 'unprefixed'

var plugins = [appearence, colorAdjust, mask, textOrientation, transform, transition, writingMode, userSelect, breakPropsOld, inlineLogicalOld, unprefixed, prefixed, scrollSnap, overscrollBehavior, flex2012, flex2009];
var propertyDetectors = plugins.filter(function (p) {
  return p.supportedProperty;
}).map(function (p) {
  return p.supportedProperty;
});
var noPrefill = plugins.filter(function (p) {
  return p.noPrefill;
}).reduce(function (a, p) {
  a.push.apply(a, _toConsumableArray(p.noPrefill));
  return a;
}, []);

var el;
var cache = {};

if (isBrowser) {
  el = document.createElement('p'); // We test every property on vendor prefix requirement.
  // Once tested, result is cached. It gives us up to 70% perf boost.
  // http://jsperf.com/element-style-object-access-vs-plain-object
  //
  // Prefill cache with known css properties to reduce amount of
  // properties we need to feature test at runtime.
  // http://davidwalsh.name/vendor-prefix

  var computed = window.getComputedStyle(document.documentElement, '');

  for (var key$1 in computed) {
    // eslint-disable-next-line no-restricted-globals
    if (!isNaN(key$1)) cache[computed[key$1]] = computed[key$1];
  } // Properties that cannot be correctly detected using the
  // cache prefill method.


  noPrefill.forEach(function (x) {
    return delete cache[x];
  });
}
/**
 * Test if a property is supported, returns supported property with vendor
 * prefix if required. Returns `false` if not supported.
 *
 * @param {String} prop dash separated
 * @param {Object} [options]
 * @return {String|Boolean}
 * @api public
 */


function supportedProperty(prop, options) {
  if (options === void 0) {
    options = {};
  }

  // For server-side rendering.
  if (!el) return prop; // Remove cache for benchmark tests or return property from the cache.

  if (process.env.NODE_ENV !== 'benchmark' && cache[prop] != null) {
    return cache[prop];
  } // Check if 'transition' or 'transform' natively supported in browser.


  if (prop === 'transition' || prop === 'transform') {
    options[prop] = prop in el.style;
  } // Find a plugin for current prefix property.


  for (var i = 0; i < propertyDetectors.length; i++) {
    cache[prop] = propertyDetectors[i](prop, el.style, options); // Break loop, if value found.

    if (cache[prop]) break;
  } // Reset styles for current property.
  // Firefox can even throw an error for invalid properties, e.g., "0".


  try {
    el.style[prop] = '';
  } catch (err) {
    return false;
  }

  return cache[prop];
}

var cache$1 = {};
var transitionProperties = {
  transition: 1,
  'transition-property': 1,
  '-webkit-transition': 1,
  '-webkit-transition-property': 1
};
var transPropsRegExp = /(^\s*[\w-]+)|, (\s*[\w-]+)(?![^()]*\))/g;
var el$1;
/**
 * Returns prefixed value transition/transform if needed.
 *
 * @param {String} match
 * @param {String} p1
 * @param {String} p2
 * @return {String}
 * @api private
 */

function prefixTransitionCallback(match, p1, p2) {
  if (p1 === 'var') return 'var';
  if (p1 === 'all') return 'all';
  if (p2 === 'all') return ', all';
  var prefixedValue = p1 ? supportedProperty(p1) : ", " + supportedProperty(p2);
  if (!prefixedValue) return p1 || p2;
  return prefixedValue;
}

if (isBrowser) el$1 = document.createElement('p');
/**
 * Returns prefixed value if needed. Returns `false` if value is not supported.
 *
 * @param {String} property
 * @param {String} value
 * @return {String|Boolean}
 * @api public
 */

function supportedValue(property, value) {
  // For server-side rendering.
  var prefixedValue = value;
  if (!el$1 || property === 'content') return value; // It is a string or a number as a string like '1'.
  // We want only prefixable values here.
  // eslint-disable-next-line no-restricted-globals

  if (typeof prefixedValue !== 'string' || !isNaN(parseInt(prefixedValue, 10))) {
    return prefixedValue;
  } // Create cache key for current value.


  var cacheKey = property + prefixedValue; // Remove cache for benchmark tests or return value from cache.

  if (process.env.NODE_ENV !== 'benchmark' && cache$1[cacheKey] != null) {
    return cache$1[cacheKey];
  } // IE can even throw an error in some cases, for e.g. style.content = 'bar'.


  try {
    // Test value as it is.
    el$1.style[property] = prefixedValue;
  } catch (err) {
    // Return false if value not supported.
    cache$1[cacheKey] = false;
    return false;
  } // If 'transition' or 'transition-property' property.


  if (transitionProperties[property]) {
    prefixedValue = prefixedValue.replace(transPropsRegExp, prefixTransitionCallback);
  } else if (el$1.style[property] === '') {
    // Value with a vendor prefix.
    prefixedValue = prefix.css + prefixedValue; // Hardcode test to convert "flex" to "-ms-flexbox" for IE10.

    if (prefixedValue === '-ms-flex') el$1.style[property] = '-ms-flexbox'; // Test prefixed value.

    el$1.style[property] = prefixedValue; // Return false if value not supported.

    if (el$1.style[property] === '') {
      cache$1[cacheKey] = false;
      return false;
    }
  } // Reset styles for current property.


  el$1.style[property] = ''; // Write current value to cache.

  cache$1[cacheKey] = prefixedValue;
  return cache$1[cacheKey];
}

/**
 * Add vendor prefix to a property name when needed.
 */

function jssVendorPrefixer() {
  function onProcessRule(rule) {
    if (rule.type === 'keyframes') {
      var atRule = rule;
      atRule.at = supportedKeyframes(atRule.at);
    }
  }

  function prefixStyle(style) {
    for (var prop in style) {
      var value = style[prop];

      if (prop === 'fallbacks' && Array.isArray(value)) {
        style[prop] = value.map(prefixStyle);
        continue;
      }

      var changeProp = false;
      var supportedProp = supportedProperty(prop);
      if (supportedProp && supportedProp !== prop) changeProp = true;
      var changeValue = false;
      var supportedValue$1 = supportedValue(supportedProp, toCssValue(value));
      if (supportedValue$1 && supportedValue$1 !== value) changeValue = true;

      if (changeProp || changeValue) {
        if (changeProp) delete style[prop];
        style[supportedProp || prop] = supportedValue$1 || value;
      }
    }

    return style;
  }

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;
    return prefixStyle(style);
  }

  function onChangeValue(value, prop) {
    return supportedValue(prop, toCssValue(value)) || value;
  }

  return {
    onProcessRule: onProcessRule,
    onProcessStyle: onProcessStyle,
    onChangeValue: onChangeValue
  };
}

/**
 * Sort props by length.
 */
function jssPropsSort() {
  var sort = function sort(prop0, prop1) {
    if (prop0.length === prop1.length) {
      return prop0 > prop1 ? 1 : -1;
    }

    return prop0.length - prop1.length;
  };

  return {
    onProcessStyle: function onProcessStyle(style, rule) {
      if (rule.type !== 'style') return style;
      var newStyle = {};
      var props = Object.keys(style).sort(sort);

      for (var i = 0; i < props.length; i++) {
        newStyle[props[i]] = style[props[i]];
      }

      return newStyle;
    }
  };
}

function jssPreset() {
  return {
    plugins: [functions(), jssGlobal(), jssNested(), camelCase(), defaultUnit(), // Disable the vendor prefixer server-side, it does nothing.
    // This way, we can get a performance boost.
    // In the documentation, we are using `autoprefixer` to solve this problem.
    typeof window === 'undefined' ? null : jssVendorPrefixer(), jssPropsSort()]
  };
}

function mergeClasses() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var baseClasses = options.baseClasses,
      newClasses = options.newClasses,
      Component = options.Component;

  if (!newClasses) {
    return baseClasses;
  }

  var nextClasses = _extends({}, baseClasses);

  if (process.env.NODE_ENV !== 'production') {
    if (typeof newClasses === 'string') {
      console.error(["Material-UI: The value `".concat(newClasses, "` ") + "provided to the classes prop of ".concat(getDisplayName(Component), " is incorrect."), 'You might want to use the className prop instead.'].join('\n'));
      return baseClasses;
    }
  }

  Object.keys(newClasses).forEach(function (key) {
    if (process.env.NODE_ENV !== 'production') {
      if (!baseClasses[key] && newClasses[key]) {
        console.error(["Material-UI: The key `".concat(key, "` ") + "provided to the classes prop is not implemented in ".concat(getDisplayName(Component), "."), "You can only override one of the following: ".concat(Object.keys(baseClasses).join(','), ".")].join('\n'));
      }

      if (newClasses[key] && typeof newClasses[key] !== 'string') {
        console.error(["Material-UI: The key `".concat(key, "` ") + "provided to the classes prop is not valid for ".concat(getDisplayName(Component), "."), "You need to provide a non empty string instead of: ".concat(newClasses[key], ".")].join('\n'));
      }
    }

    if (newClasses[key]) {
      nextClasses[key] = "".concat(baseClasses[key], " ").concat(newClasses[key]);
    }
  });
  return nextClasses;
}

// Used https://github.com/thinkloop/multi-key-cache as inspiration
var multiKeyStore = {
  set: function set(cache, key1, key2, value) {
    var subCache = cache.get(key1);

    if (!subCache) {
      subCache = new Map();
      cache.set(key1, subCache);
    }

    subCache.set(key2, value);
  },
  get: function get(cache, key1, key2) {
    var subCache = cache.get(key1);
    return subCache ? subCache.get(key2) : undefined;
  },
  delete: function _delete(cache, key1, key2) {
    var subCache = cache.get(key1);
    subCache.delete(key2);
  }
};
var multiKeyStore$1 = multiKeyStore;

var ThemeContext = React__default.createContext(null);

if (process.env.NODE_ENV !== 'production') {
  ThemeContext.displayName = 'ThemeContext';
}

var ThemeContext$1 = ThemeContext;

function useTheme() {
  var theme = React__default.useContext(ThemeContext$1);

  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React__default.useDebugValue(theme);
  }

  return theme;
}

var jss = createJss(jssPreset()); // Use a singleton or the provided one by the context.
//
// The counter-based approach doesn't tolerate any mistake.
// It's much safer to use the same counter everywhere.

var generateClassName = createGenerateClassName(); // Exported for test purposes

var sheetsManager = new Map();
var defaultOptions$1 = {
  disableGeneration: false,
  generateClassName: generateClassName,
  jss: jss,
  sheetsCache: null,
  sheetsManager: sheetsManager,
  sheetsRegistry: null
};
var StylesContext = React__default.createContext(defaultOptions$1);

if (process.env.NODE_ENV !== 'production') {
  StylesContext.displayName = 'StylesContext';
}

var injectFirstNode;
function StylesProvider(props) {
  var children = props.children,
      _props$injectFirst = props.injectFirst,
      injectFirst = _props$injectFirst === void 0 ? false : _props$injectFirst,
      _props$disableGenerat = props.disableGeneration,
      disableGeneration = _props$disableGenerat === void 0 ? false : _props$disableGenerat,
      localOptions = _objectWithoutProperties(props, ["children", "injectFirst", "disableGeneration"]);

  var outerOptions = React__default.useContext(StylesContext);

  var context = _extends({}, outerOptions, {
    disableGeneration: disableGeneration
  }, localOptions);

  if (process.env.NODE_ENV !== 'production') {
    if (typeof window === 'undefined' && !context.sheetsManager) {
      console.error('Material-UI: You need to use the ServerStyleSheets API when rendering on the server.');
    }
  }

  if (process.env.NODE_ENV !== 'production') {
    if (context.jss.options.insertionPoint && injectFirst) {
      console.error('Material-UI: You cannot use a custom insertionPoint and <StylesContext injectFirst> at the same time.');
    }
  }

  if (process.env.NODE_ENV !== 'production') {
    if (injectFirst && localOptions.jss) {
      console.error('Material-UI: You cannot use the jss and injectFirst props at the same time.');
    }
  }

  if (!context.jss.options.insertionPoint && injectFirst && typeof window !== 'undefined') {
    if (!injectFirstNode) {
      var head = document.head;
      injectFirstNode = document.createComment('mui-inject-first');
      head.insertBefore(injectFirstNode, head.firstChild);
    }

    context.jss = createJss({
      plugins: jssPreset().plugins,
      insertionPoint: injectFirstNode
    });
  }

  return /*#__PURE__*/React__default.createElement(StylesContext.Provider, {
    value: context
  }, children);
}
process.env.NODE_ENV !== "production" ? StylesProvider.propTypes = {
  /**
   * Your component tree.
   */
  children: PropTypes.node.isRequired,

  /**
   * You can disable the generation of the styles with this option.
   * It can be useful when traversing the React tree outside of the HTML
   * rendering step on the server.
   * Let's say you are using react-apollo to extract all
   * the queries made by the interface server-side - you can significantly speed up the traversal with this prop.
   */
  disableGeneration: PropTypes.bool,

  /**
   * JSS's class name generator.
   */
  generateClassName: PropTypes.func,

  /**
   * By default, the styles are injected last in the <head> element of the page.
   * As a result, they gain more specificity than any other style sheet.
   * If you want to override Material-UI's styles, set this prop.
   */
  injectFirst: PropTypes.bool,

  /**
   * JSS's instance.
   */
  jss: PropTypes.object,

  /**
   * @ignore
   */
  serverGenerateClassName: PropTypes.func,

  /**
   * @ignore
   *
   * Beta feature.
   *
   * Cache for the sheets.
   */
  sheetsCache: PropTypes.object,

  /**
   * @ignore
   *
   * The sheetsManager is used to deduplicate style sheet injection in the page.
   * It's deduplicating using the (theme, styles) couple.
   * On the server, you should provide a new instance for each request.
   */
  sheetsManager: PropTypes.object,

  /**
   * @ignore
   *
   * Collect the sheets.
   */
  sheetsRegistry: PropTypes.object
} : void 0;

if (process.env.NODE_ENV !== 'production') {
  process.env.NODE_ENV !== "production" ? StylesProvider.propTypes = exactProp(StylesProvider.propTypes) : void 0;
}

/* eslint-disable import/prefer-default-export */
// Global index counter to preserve source order.
// We create the style sheet during the creation of the component,
// children are handled after the parents, so the order of style elements would be parent->child.
// It is a problem though when a parent passes a className
// which needs to override any child's styles.
// StyleSheet of the child has a higher specificity, because of the source order.
// So our solution is to render sheets them in the reverse order child->sheet, so
// that parent has a higher specificity.
var indexCounter = -1e9;
function increment() {
  indexCounter += 1;

  if (process.env.NODE_ENV !== 'production') {
    if (indexCounter >= 0) {
      console.warn(['Material-UI: You might have a memory leak.', 'The indexCounter is not supposed to grow that much.'].join('\n'));
    }
  }

  return indexCounter;
}

// We use the same empty object to ref count the styles that don't need a theme object.
var noopTheme = {};
var noopTheme$1 = noopTheme;

function getStylesCreator(stylesOrCreator) {
  var themingEnabled = typeof stylesOrCreator === 'function';

  if (process.env.NODE_ENV !== 'production') {
    if (_typeof$1(stylesOrCreator) !== 'object' && !themingEnabled) {
      console.error(['Material-UI: The `styles` argument provided is invalid.', 'You need to provide a function generating the styles or a styles object.'].join('\n'));
    }
  }

  return {
    create: function create(theme, name) {
      var styles;

      try {
        styles = themingEnabled ? stylesOrCreator(theme) : stylesOrCreator;
      } catch (err) {
        if (process.env.NODE_ENV !== 'production') {
          if (themingEnabled === true && theme === noopTheme$1) {
            // TODO: prepend error message/name instead
            console.error(['Material-UI: The `styles` argument provided is invalid.', 'You are providing a function without a theme in the context.', 'One of the parent elements needs to use a ThemeProvider.'].join('\n'));
          }
        }

        throw err;
      }

      if (!name || !theme.overrides || !theme.overrides[name]) {
        return styles;
      }

      var overrides = theme.overrides[name];

      var stylesWithOverrides = _extends({}, styles);

      Object.keys(overrides).forEach(function (key) {
        if (process.env.NODE_ENV !== 'production') {
          if (!stylesWithOverrides[key]) {
            console.warn(['Material-UI: You are trying to override a style that does not exist.', "Fix the `".concat(key, "` key of `theme.overrides.").concat(name, "`.")].join('\n'));
          }
        }

        stylesWithOverrides[key] = deepmerge(stylesWithOverrides[key], overrides[key]);
      });
      return stylesWithOverrides;
    },
    options: {}
  };
}

function getClasses(_ref, classes, Component) {
  var state = _ref.state,
      stylesOptions = _ref.stylesOptions;

  if (stylesOptions.disableGeneration) {
    return classes || {};
  }

  if (!state.cacheClasses) {
    state.cacheClasses = {
      // Cache for the finalized classes value.
      value: null,
      // Cache for the last used classes prop pointer.
      lastProp: null,
      // Cache for the last used rendered classes pointer.
      lastJSS: {}
    };
  } // Tracks if either the rendered classes or classes prop has changed,
  // requiring the generation of a new finalized classes object.


  var generate = false;

  if (state.classes !== state.cacheClasses.lastJSS) {
    state.cacheClasses.lastJSS = state.classes;
    generate = true;
  }

  if (classes !== state.cacheClasses.lastProp) {
    state.cacheClasses.lastProp = classes;
    generate = true;
  }

  if (generate) {
    state.cacheClasses.value = mergeClasses({
      baseClasses: state.cacheClasses.lastJSS,
      newClasses: classes,
      Component: Component
    });
  }

  return state.cacheClasses.value;
}

function attach(_ref2, props) {
  var state = _ref2.state,
      theme = _ref2.theme,
      stylesOptions = _ref2.stylesOptions,
      stylesCreator = _ref2.stylesCreator,
      name = _ref2.name;

  if (stylesOptions.disableGeneration) {
    return;
  }

  var sheetManager = multiKeyStore$1.get(stylesOptions.sheetsManager, stylesCreator, theme);

  if (!sheetManager) {
    sheetManager = {
      refs: 0,
      staticSheet: null,
      dynamicStyles: null
    };
    multiKeyStore$1.set(stylesOptions.sheetsManager, stylesCreator, theme, sheetManager);
  }

  var options = _extends({}, stylesCreator.options, stylesOptions, {
    theme: theme,
    flip: typeof stylesOptions.flip === 'boolean' ? stylesOptions.flip : theme.direction === 'rtl'
  });

  options.generateId = options.serverGenerateClassName || options.generateClassName;
  var sheetsRegistry = stylesOptions.sheetsRegistry;

  if (sheetManager.refs === 0) {
    var staticSheet;

    if (stylesOptions.sheetsCache) {
      staticSheet = multiKeyStore$1.get(stylesOptions.sheetsCache, stylesCreator, theme);
    }

    var styles = stylesCreator.create(theme, name);

    if (!staticSheet) {
      staticSheet = stylesOptions.jss.createStyleSheet(styles, _extends({
        link: false
      }, options));
      staticSheet.attach();

      if (stylesOptions.sheetsCache) {
        multiKeyStore$1.set(stylesOptions.sheetsCache, stylesCreator, theme, staticSheet);
      }
    }

    if (sheetsRegistry) {
      sheetsRegistry.add(staticSheet);
    }

    sheetManager.staticSheet = staticSheet;
    sheetManager.dynamicStyles = getDynamicStyles(styles);
  }

  if (sheetManager.dynamicStyles) {
    var dynamicSheet = stylesOptions.jss.createStyleSheet(sheetManager.dynamicStyles, _extends({
      link: true
    }, options));
    dynamicSheet.update(props);
    dynamicSheet.attach();
    state.dynamicSheet = dynamicSheet;
    state.classes = mergeClasses({
      baseClasses: sheetManager.staticSheet.classes,
      newClasses: dynamicSheet.classes
    });

    if (sheetsRegistry) {
      sheetsRegistry.add(dynamicSheet);
    }
  } else {
    state.classes = sheetManager.staticSheet.classes;
  }

  sheetManager.refs += 1;
}

function update(_ref3, props) {
  var state = _ref3.state;

  if (state.dynamicSheet) {
    state.dynamicSheet.update(props);
  }
}

function detach(_ref4) {
  var state = _ref4.state,
      theme = _ref4.theme,
      stylesOptions = _ref4.stylesOptions,
      stylesCreator = _ref4.stylesCreator;

  if (stylesOptions.disableGeneration) {
    return;
  }

  var sheetManager = multiKeyStore$1.get(stylesOptions.sheetsManager, stylesCreator, theme);
  sheetManager.refs -= 1;
  var sheetsRegistry = stylesOptions.sheetsRegistry;

  if (sheetManager.refs === 0) {
    multiKeyStore$1.delete(stylesOptions.sheetsManager, stylesCreator, theme);
    stylesOptions.jss.removeStyleSheet(sheetManager.staticSheet);

    if (sheetsRegistry) {
      sheetsRegistry.remove(sheetManager.staticSheet);
    }
  }

  if (state.dynamicSheet) {
    stylesOptions.jss.removeStyleSheet(state.dynamicSheet);

    if (sheetsRegistry) {
      sheetsRegistry.remove(state.dynamicSheet);
    }
  }
}

function useSynchronousEffect(func, values) {
  var key = React__default.useRef([]);
  var output; // Store "generation" key. Just returns a new object every time

  var currentKey = React__default.useMemo(function () {
    return {};
  }, values); // eslint-disable-line react-hooks/exhaustive-deps
  // "the first render", or "memo dropped the value"

  if (key.current !== currentKey) {
    key.current = currentKey;
    output = func();
  }

  React__default.useEffect(function () {
    return function () {
      if (output) {
        output();
      }
    };
  }, [currentKey] // eslint-disable-line react-hooks/exhaustive-deps
  );
}

function makeStyles(stylesOrCreator) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var name = options.name,
      classNamePrefixOption = options.classNamePrefix,
      Component = options.Component,
      _options$defaultTheme = options.defaultTheme,
      defaultTheme = _options$defaultTheme === void 0 ? noopTheme$1 : _options$defaultTheme,
      stylesOptions2 = _objectWithoutProperties(options, ["name", "classNamePrefix", "Component", "defaultTheme"]);

  var stylesCreator = getStylesCreator(stylesOrCreator);
  var classNamePrefix = name || classNamePrefixOption || 'makeStyles';
  stylesCreator.options = {
    index: increment(),
    name: name,
    meta: classNamePrefix,
    classNamePrefix: classNamePrefix
  };

  var useStyles = function useStyles() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var theme = useTheme() || defaultTheme;

    var stylesOptions = _extends({}, React__default.useContext(StylesContext), stylesOptions2);

    var instance = React__default.useRef();
    var shouldUpdate = React__default.useRef();
    useSynchronousEffect(function () {
      var current = {
        name: name,
        state: {},
        stylesCreator: stylesCreator,
        stylesOptions: stylesOptions,
        theme: theme
      };
      attach(current, props);
      shouldUpdate.current = false;
      instance.current = current;
      return function () {
        detach(current);
      };
    }, [theme, stylesCreator]);
    React__default.useEffect(function () {
      if (shouldUpdate.current) {
        update(instance.current, props);
      }

      shouldUpdate.current = true;
    });
    var classes = getClasses(instance.current, props.classes, Component);

    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      React__default.useDebugValue(classes);
    }

    return classes;
  };

  return useStyles;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function toVal(mix) {
	var k, y, str='';

	if (typeof mix === 'string' || typeof mix === 'number') {
		str += mix;
	} else if (typeof mix === 'object') {
		if (Array.isArray(mix)) {
			for (k=0; k < mix.length; k++) {
				if (mix[k]) {
					if (y = toVal(mix[k])) {
						str && (str += ' ');
						str += y;
					}
				}
			}
		} else {
			for (k in mix) {
				if (mix[k]) {
					str && (str += ' ');
					str += k;
				}
			}
		}
	}

	return str;
}

function clsx () {
	var i=0, tmp, x, str='';
	while (i < arguments.length) {
		if (tmp = arguments[i++]) {
			if (x = toVal(tmp)) {
				str && (str += ' ');
				str += x;
			}
		}
	}
	return str;
}

var reactIs = reactIsExports$1;

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

var hoistNonReactStatics_cjs = hoistNonReactStatics;

var hoistNonReactStatics$1 = /*@__PURE__*/getDefaultExportFromCjs(hoistNonReactStatics_cjs);

function mergeOuterLocalTheme(outerTheme, localTheme) {
  if (typeof localTheme === 'function') {
    var mergedTheme = localTheme(outerTheme);

    if (process.env.NODE_ENV !== 'production') {
      if (!mergedTheme) {
        console.error(['Material-UI: You should return an object from your theme function, i.e.', '<ThemeProvider theme={() => ({})} />'].join('\n'));
      }
    }

    return mergedTheme;
  }

  return _extends({}, outerTheme, localTheme);
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */


function ThemeProvider(props) {
  var children = props.children,
      localTheme = props.theme;
  var outerTheme = useTheme();

  if (process.env.NODE_ENV !== 'production') {
    if (outerTheme === null && typeof localTheme === 'function') {
      console.error(['Material-UI: You are providing a theme function prop to the ThemeProvider component:', '<ThemeProvider theme={outerTheme => outerTheme} />', '', 'However, no outer theme is present.', 'Make sure a theme is already injected higher in the React tree ' + 'or provide a theme object.'].join('\n'));
    }
  }

  var theme = React__default.useMemo(function () {
    var output = outerTheme === null ? localTheme : mergeOuterLocalTheme(outerTheme, localTheme);

    if (output != null) {
      output[nested] = outerTheme !== null;
    }

    return output;
  }, [localTheme, outerTheme]);
  return /*#__PURE__*/React__default.createElement(ThemeContext$1.Provider, {
    value: theme
  }, children);
}

process.env.NODE_ENV !== "production" ? ThemeProvider.propTypes = {
  /**
   * Your component tree.
   */
  children: PropTypes.node.isRequired,

  /**
   * A theme object. You can provide a function to extend the outer theme.
   */
  theme: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired
} : void 0;

if (process.env.NODE_ENV !== 'production') {
  process.env.NODE_ENV !== "production" ? ThemeProvider.propTypes = exactProp(ThemeProvider.propTypes) : void 0;
}

// It does not modify the component passed to it;
// instead, it returns a new component, with a `classes` property.

var withStyles$1 = function withStyles(stylesOrCreator) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (Component) {
    var defaultTheme = options.defaultTheme,
        _options$withTheme = options.withTheme,
        withTheme = _options$withTheme === void 0 ? false : _options$withTheme,
        name = options.name,
        stylesOptions = _objectWithoutProperties(options, ["defaultTheme", "withTheme", "name"]);

    if (process.env.NODE_ENV !== 'production') {
      if (Component === undefined) {
        throw new Error(['You are calling withStyles(styles)(Component) with an undefined component.', 'You may have forgotten to import it.'].join('\n'));
      }
    }

    var classNamePrefix = name;

    if (process.env.NODE_ENV !== 'production') {
      if (!name) {
        // Provide a better DX outside production.
        var displayName = getDisplayName(Component);

        if (displayName !== undefined) {
          classNamePrefix = displayName;
        }
      }
    }

    var useStyles = makeStyles(stylesOrCreator, _extends({
      defaultTheme: defaultTheme,
      Component: Component,
      name: name || Component.displayName,
      classNamePrefix: classNamePrefix
    }, stylesOptions));
    var WithStyles = /*#__PURE__*/React__default.forwardRef(function WithStyles(props, ref) {
      props.classes;
          var innerRef = props.innerRef,
          other = _objectWithoutProperties(props, ["classes", "innerRef"]); // The wrapper receives only user supplied props, which could be a subset of
      // the actual props Component might receive due to merging with defaultProps.
      // So copying it here would give us the same result in the wrapper as well.


      var classes = useStyles(_extends({}, Component.defaultProps, props));
      var theme;
      var more = other;

      if (typeof name === 'string' || withTheme) {
        // name and withTheme are invariant in the outer scope
        // eslint-disable-next-line react-hooks/rules-of-hooks
        theme = useTheme() || defaultTheme;

        if (name) {
          more = getThemeProps({
            theme: theme,
            name: name,
            props: other
          });
        } // Provide the theme to the wrapped component.
        // So we don't have to use the `withTheme()` Higher-order Component.


        if (withTheme && !more.theme) {
          more.theme = theme;
        }
      }

      return /*#__PURE__*/React__default.createElement(Component, _extends({
        ref: innerRef || ref,
        classes: classes
      }, more));
    });
    process.env.NODE_ENV !== "production" ? WithStyles.propTypes = {
      /**
       * Override or extend the styles applied to the component.
       */
      classes: PropTypes.object,

      /**
       * Use that prop to pass a ref to the decorated component.
       * @deprecated
       */
      innerRef: chainPropTypes(PropTypes.oneOfType([PropTypes.func, PropTypes.object]), function (props) {
        if (props.innerRef == null) {
          return null;
        }

        return null; // return new Error(
        //   'Material-UI: The `innerRef` prop is deprecated and will be removed in v5. ' +
        //     'Refs are now automatically forwarded to the inner component.',
        // );
      })
    } : void 0;

    if (process.env.NODE_ENV !== 'production') {
      WithStyles.displayName = "WithStyles(".concat(getDisplayName(Component), ")");
    }

    hoistNonReactStatics$1(WithStyles, Component);

    if (process.env.NODE_ENV !== 'production') {
      // Exposed for test purposes.
      WithStyles.Naked = Component;
      WithStyles.options = options;
      WithStyles.useStyles = useStyles;
    }

    return WithStyles;
  };
};

var withStylesWithoutDefault = withStyles$1;

var defaultTheme = createMuiTheme();
var defaultTheme$1 = defaultTheme;

function withStyles(stylesOrCreator, options) {
  return withStylesWithoutDefault(stylesOrCreator, _extends({
    defaultTheme: defaultTheme$1
  }, options));
}

var theme = function (_a) {
    var Colors = _a.Colors, dir = _a.dir, breakpoints = _a.breakpoints, fontFamily = _a.fontFamily;
    return createMuiTheme({
        direction: dir,
        breakpoints: breakpoints,
        typography: {
            fontFamily: fontFamily || "Roboto",
        },
        palette: {
            primary: {
                dark: Colors.primary["8"],
                main: Colors.primary["7"],
                light: Colors.primary["8"],
                contrastText: Colors.primary["0"],
            },
            secondary: {
                dark: Colors.secondary["12"],
                main: Colors.secondary["11"],
                light: Colors.secondary["12"],
            },
        },
    });
};

var TimeZone = {
    "-1100": "GMT-11:00",
    "-1000": "GMT-10:00",
    "-930": "GMT-09:30",
    "-900": "GMT-09:00",
    "-800": "GMT-08:00",
    "-700": "GMT-07:00",
    "-600": "GMT-06:00",
    "-500": "GMT-05:00",
    "-400": "GMT-04:00",
    "-330": "GMT-03:30",
    "-300": "GMT-03:00",
    "-200": "GMT-02:00",
    "-100": "GMT-01:00",
    // mantis - 8834, loadFirmwareSettings api호출 하면 결과가  "000"이 아닌 "0"으로 나와서 키값 변경 (Leehj)
    "0": "GMT+00:00",
    "100": "GMT+01:00",
    "200": "GMT+02:00",
    "300": "GMT+03:00",
    "330": "GMT+03:30",
    "400": "GMT+04:00",
    "430": "GMT+04:30",
    "500": "GMT+05:00",
    "530": "GMT+05:30",
    "600": "GMT+06:00",
    "630": "GMT+06:30",
    "700": "GMT+07:00",
    "800": "GMT+08:00",
    "900": "GMT+09:00",
    "930": "GMT+09:30",
    "1000": "GMT+10:00",
    "1030": "GMT+10:30",
    "1100": "GMT+11:00",
    "1200": "GMT+12:00",
    "1300": "GMT+13:00",
};
var TimeZoneList = {
    ACDT: "Australian Central Daylight Saving Time",
    ACST: "Australian Central Standard Time",
    ACT: "Acre Time",
    ACWST: "Australian Central Western Standard Time",
    ADT: "Atlantic Daylight Time",
    AEDT: "Australian Eastern Daylight Saving Time",
    AEST: "Australian Eastern Standard Time",
    AET: "Australian Eastern Time",
    AFT: "Afghanistan Time",
    AKDT: "Alaska Daylight Time",
    AKST: "Alaska Standard Time",
    ALMT: "Alma-Ata Time",
    AMST: "Amazon Summer Time",
    AMT: "Amazon Time",
    ANAT: "Anadyr Time",
    AQTT: "Aqtobe Time",
    ART: "Argentina Time",
    AST: "Arabia Standard Time",
    AWST: "Australian Western Standard Time",
    AZOST: "Azores Summer Time",
    AZOT: "Azores Standard Time",
    AZT: "Azerbaijan Time",
    BNT: "Brunei Time",
    BIOT: "British Indian Ocean Time",
    BIT: "Baker Island Time",
    BOT: "Bolivia Time",
    BRST: "Brasília Summer Time",
    BRT: "Brasília Time",
    BST: "Bangladesh Standard Time",
    BTT: "Bhutan Time",
    CAT: "Central Africa Time",
    CCT: "Cocos Islands Time",
    CDT: "Central Daylight Time",
    CEST: "Central European Summer Time",
    CET: "Central European Time",
    CHADT: "Chatham Daylight Time",
    CHAST: "Chatham Standard Time",
    CHOT: "Choibalsan Standard Time",
    CHOST: "Choibalsan Summer Time",
    CHST: "Chamorro Standard Time",
    CHUT: "Chuuk Time",
    CIST: "Clipperton Island Standard Time",
    CKT: "Cook Island Time",
    CLST: "Chile Summer Time",
    CLT: "Chile Standard Time",
    COST: "Colombia Summer Time",
    COT: "Colombia Time",
    CST: "Central Standard Time",
    CT: "Central Time",
    CVT: "Cape Verde Time",
    CWST: "Central Western Standard Time",
    CXT: "Christmas Island Time",
    DAVT: "Davis Time",
    DDUT: "Dumont d'Urville Time",
    DFT: "AIX-specific equivalent of Central European Time",
    EASST: "Easter Island Summer Time",
    EAST: "Easter Island Standard Time",
    EAT: "East Africa Time",
    ECT: "Eastern Caribbean Time",
    EDT: "Eastern Daylight Time",
    EEST: "Eastern European Summer Time",
    EET: "Eastern European Time",
    EGST: "Eastern Greenland Summer Time",
    EGT: "Eastern Greenland Time",
    EST: "Eastern Standard Time",
    ET: "Eastern Time",
    FET: "Further-eastern European Time",
    FJT: "Fiji Time",
    FKST: "Falkland Islands Summer Time",
    FKT: "Falkland Islands Time",
    FNT: "Fernando de Noronha Time",
    GALT: "Galápagos Time",
    GAMT: "Gambier Islands Time",
    GET: "Georgia Standard Time",
    GFT: "French Guiana Time",
    GILT: "Gilbert Island Time",
    GIT: "Gambier Island Time",
    GMT: "Greenwich Mean Time",
    GST: "South Georgia and the South Sandwich Islands Time",
    GYT: "Guyana Time",
    HDT: "Hawaii–Aleutian Daylight Time",
    HAEC: "Heure Avancée d'Europe Centrale French-language name for CEST",
    HST: "Hawaii–Aleutian Standard Time",
    HKT: "Hong Kong Time",
    HMT: "Heard and McDonald Islands Time",
    HOVST: "Hovd Summer Time",
    HOVT: "Hovd Time",
    ICT: "Indochina Time",
    IDLW: "International Day Line West time zone",
    IDT: "Israel Daylight Time",
    IOT: "Indian Ocean Time",
    IRDT: "Iran Daylight Time",
    IRKT: "Irkutsk Time",
    IRST: "Iran Standard Time",
    IST: "Indian Standard Time",
    JST: "Japan Standard Time",
    KALT: "Kaliningrad Time",
    KGT: "Kyrgyzstan Time",
    KOST: "Kosrae Time",
    KRAT: "Krasnoyarsk Time",
    KST: "Korea Standard Time",
    LHST: "Lord Howe Standard Time",
    LINT: "Line Islands Time",
    MAGT: "Magadan Time",
    MART: "Marquesas Islands Time",
    MAWT: "Mawson Station Time",
    MDT: "Mountain Daylight Time",
    MET: "Middle European Time",
    MEST: "Middle European Summer Time",
    MHT: "Marshall Islands Time",
    MIST: "Macquarie Island Station Time",
    MIT: "Marquesas Islands Time",
    MMT: "Myanmar Standard Time",
    MSK: "Moscow Time",
    MST: "Malaysia Standard Time",
    MUT: "Mauritius Time",
    MVT: "Maldives Time",
    MYT: "Malaysia Time",
    NCT: "New Caledonia Time",
    NDT: "Newfoundland Daylight Time",
    NFT: "Norfolk Island Time",
    NOVT: "Novosibirsk Time",
    NPT: "Nepal Time",
    NST: "Newfoundland Standard Time",
    NT: "Newfoundland Time",
    NUT: "Niue Time",
    NZDT: "New Zealand Daylight Time",
    NZST: "New Zealand Standard Time",
    OMST: "Omsk Time",
    ORAT: "Oral Time",
    PDT: "Pacific Daylight Time",
    PET: "Peru Time",
    PETT: "Kamchatka Time",
    PGT: "Papua New Guinea Time",
    PHOT: "Phoenix Island Time",
    PHT: "Philippine Time",
    PHST: "Philippine Standard Time",
    PKT: "Pakistan Standard Time",
    PMDT: "Saint Pierre and Miquelon Daylight Time",
    PMST: "Saint Pierre and Miquelon Standard Time",
    PONT: "Pohnpei Standard Time",
    PST: "Pacific Standard Time",
    PWT: "Palau Time",
    PYST: "Paraguay Summer Time",
    PYT: "Paraguay Time",
    RET: "Réunion Time",
    ROTT: "Rothera Research Station Time",
    SAKT: "Sakhalin Island Time",
    SAMT: "Samara Time",
    SAST: "South African Standard Time",
    SBT: "Solomon Islands Time",
    SCT: "Seychelles Time",
    SDT: "Samoa Daylight Time",
    SGT: "Singapore Time",
    SLST: "Sri Lanka Standard Time",
    SRET: "Srednekolymsk Time",
    SRT: "Suriname Time",
    SST: "Samoa Standard Time",
    SYOT: "Showa Station Time",
    TAHT: "Tahiti Time",
    THA: "Thailand Standard Time",
    TFT: "French Southern and Antarctic Time",
    TJT: "Tajikistan Time",
    TKT: "Tokelau Time",
    TLT: "Timor Leste Time",
    TMT: "Turkmenistan Time",
    TRT: "Turkey Time",
    TOT: "Tonga Time",
    TVT: "Tuvalu Time",
    ULAST: "Ulaanbaatar Summer Time",
    ULAT: "Ulaanbaatar Standard Time",
    UTC: "Coordinated Universal Time",
    UYST: "Uruguay Summer Time",
    UYT: "Uruguay Standard Time",
    UZT: "Uzbekistan Time",
    VET: "Venezuelan Standard Time",
    VLAT: "Vladivostok Time",
    VOLT: "Volgograd Time",
    VOST: "Vostok Station Time",
    VUT: "Vanuatu Time",
    WAKT: "Wake Island Time",
    WAST: "West Africa Summer Time",
    WAT: "West Africa Time",
    WEST: "Western European Summer Time",
    WET: "Western European Time",
    WIB: "Western Indonesian Time",
    WIT: "Eastern Indonesian Time",
    WITA: "Central Indonesia Time",
    WGST: "West Greenland Summer Time",
    WGT: "West Greenland Time",
    WST: "Western Standard Time",
    YAKT: "Yakutsk Time",
    YEKT: "Yekaterinburg Time",
};

var TimeZoneCountries = [
    {
        value: -1100,
        prefix: "(GMT-11:00)",
        en: "American Samoa",
        ko: "아메리칸 사모아",
        sc: "美属萨摩亚",
        es: "Samoa Americana",
        ru: "Американское Самоа",
        ja: "アメリカ領サモア",
        fr: "Samoa américaines",
        de: "Amerikanischen Samoa-Inseln",
        it: "Samoa americane",
        th: "อเมริกันซามัว",
        id: "Samoa Amerika",
        vi: "Samoa thuộc Mỹ",
        nl: "Amerikaans Samoa",
        pl: "Samoa Amerykańskie",
        nb: "Amerikansk Samoa",
        fi: "Amerikan Samoa",
        ar: "ساموا الأمريكية",
    },
    {
        value: -1100,
        prefix: "(GMT-11:00)",
        en: "Niue",
        ko: "니우에",
        sc: "纽埃",
        es: "Niue",
        ru: "Ниуэ",
        ja: "ニウエ",
        fr: "Niué",
        de: "Niue",
        it: "Niue",
        th: "นีอูเอ",
        id: "Niue",
        vi: "Niue",
        nl: "Niue",
        pl: "Niue",
        nb: "Niue",
        fi: "Niue",
        ar: "نيوي",
    },
    {
        value: -1000,
        prefix: "(GMT-10:00)",
        en: "Alaska (Adak, Unalaska), USA",
        ko: "알래스카(아닥, 어날래스카), 미국",
        sc: "阿拉斯加（阿达克、乌纳拉斯加）、美国",
        es: "Alaska (Adak, Unalaska), EE. UU.",
        ru: "Аляска (Адак, Уналаска), США",
        ja: "アラスカ（アダック、ウナラスカ）、米国",
        fr: "Alaska (Adak, Unalaska), États-Unis",
        de: "Alaska (Adak, Unalaska), USA",
        it: "Alaska (Adak, Unalaska), Stati Uniti",
        th: "อลาสก้า (Adak, Unalaska), สหรัฐอเมริกา",
        id: "Alaska (Adak, Unalaska), AS",
        vi: "Alaska (Adak, Unalaska), Hoa Kỳ",
        nl: "Alaska (Adak, Unalaska), VS",
        pl: "Alaska (Adak, Unalaska), USA",
        nb: "Alaska (Adak, Unalaska), USA",
        fi: "Alaska (Adak, Unalaska), Yhdysvallat",
        ar: "ألاسكا (أداك ، أونالاسكا) ، الولايات المتحدة الأمريكية",
    },
    {
        value: -1000,
        prefix: "(GMT-10:00)",
        en: "Cook Islands ",
        ko: "쿡 제도",
        sc: "库克群岛",
        es: "Islas Cook",
        ru: "Острова Кука",
        ja: "クック諸島",
        fr: "les Îles Cook",
        de: "Cookinseln",
        it: "Isole Cook",
        th: "หมู่เกาะคุก",
        id: "Kepulauan Cook",
        vi: "Quần đảo Cook",
        nl: "Cook Eilanden",
        pl: "Wyspy Cooka",
        nb: "Cook-øyene",
        fi: "Cook saaret",
        ar: "جزر كوك",
    },
    {
        value: -1000,
        prefix: "(GMT-10:00)",
        en: "Hawaii, USA",
        ko: "하와이, 미국",
        sc: "美国夏威夷",
        es: "Hawái, EE. UU.",
        ru: "Гавайи, США",
        ja: "ハワイ、アメリカ",
        fr: "Hawaï, États-Unis",
        de: "Hawaii, USA",
        it: "Hawaii, Stati Uniti",
        th: "ฮาวาย สหรัฐอเมริกา",
        id: "Hawaii, Amerika Serikat",
        vi: "Hawaii, Hoa Kỳ",
        nl: "Hawaï, VS",
        pl: "Hawaje, USA",
        nb: "Hawaii, USA",
        fi: "Havaiji, Yhdysvallat",
        ar: "هاواي ، الولايات المتحدة الأمريكية",
    },
    {
        value: -1000,
        prefix: "(GMT-10:00)",
        en: "French Polynesia, Tahiti Island",
        ko: "프랑스령 폴리네시아, 타히티 섬",
        sc: "法属波利尼西亚、大溪地",
        es: "Polinesia Francesa, Isla Tahití",
        ru: "Французская Полинезия, остров Таити",
        ja: "フランス領ポリネシア、タヒチ島",
        fr: "Polynésie française, île de Tahiti",
        de: "Französisch-Polynesien, Insel Tahiti",
        it: "Polinesia francese, isola di Tahiti",
        th: "เฟรนช์โปลินีเซีย, เกาะตาฮิติ",
        id: "Polinesia Prancis, Pulau Tahiti",
        vi: "Polynesia thuộc Pháp, Đảo Tahiti",
        nl: "Frans-Polynesië, Tahiti-eiland",
        pl: "Polinezja Francuska, wyspa Tahiti",
        nb: "Fransk Polynesia, Tahiti Island",
        fi: "Ranskan Polynesia, Tahitin saari",
        ar: "بولينيزيا الفرنسية ، جزيرة تاهيتي",
    },
    {
        value: -930,
        prefix: "(GMT-09:30)",
        en: "French Polynesia, Marquesas Islands",
        ko: "프랑스령 폴리네시아, 마르키즈 제도",
        sc: "法属波利尼西亚、马克萨斯群岛",
        es: "Polinesia Francesa, Islas Marquesas",
        ru: "Французская Полинезия, Маркизские острова",
        ja: "フランス領ポリネシア、マルケサス諸島",
        fr: "Polynésie française, Îles Marquises",
        de: "Französisch-Polynesien, Marquesas-Inseln",
        it: "Polinesia francese, Isole Marchesi",
        th: "เฟรนช์โปลินีเซีย, หมู่เกาะมาร์เคซัส",
        id: "Polinesia Prancis, Kepulauan Marquesas",
        vi: "Polynesia thuộc Pháp, Quần đảo Marquesas",
        nl: "Frans-Polynesië, Marquesas-eilanden",
        pl: "Polinezja Francuska, Markizy",
        nb: "Fransk Polynesia, Marquesas-øyene",
        fi: "Ranskan Polynesia, Marquesassaaret",
        ar: "بولينيزيا الفرنسية ، جزر ماركيساس",
    },
    {
        value: -900,
        prefix: "(GMT-09:00)",
        en: "Alaska (Juneau), USA",
        ko: "알래스카(주노), 미국",
        sc: "阿拉斯加（朱诺），美国",
        es: "Alaska (Juneau), EE. UU.",
        ru: "Аляска (Джуно), США",
        ja: "アラスカ（ジュノー）、米国",
        fr: "Alaska (Juneau), États-Unis",
        de: "Alaska (Juneau), USA",
        it: "Alaska (Juneau), Stati Uniti",
        th: "อลาสก้า (จูโน), สหรัฐอเมริกา",
        id: "Alaska (Juneau), AS",
        vi: "Alaska (Juneau), Hoa Kỳ",
        nl: "Alaska (Juneau), VS",
        pl: "Alaska (Juneau), USA",
        nb: "Alaska (Juneau), USA",
        fi: "Alaska (Juneau), Yhdysvallat",
        ar: "ألاسكا (جونو) ، الولايات المتحدة الأمريكية",
    },
    {
        value: -900,
        prefix: "(GMT-09:00)",
        en: "French Polynesia, Gambier Islands",
        ko: "프랑스령 폴리네시아, 갬비어 제도",
        sc: "法属波利尼西亚、甘比尔群岛",
        es: "Polinesia Francesa, Islas Gambier",
        ru: "Французская Полинезия, острова Гамбье",
        ja: "フランス領ポリネシア、ガンビエ諸島",
        fr: "Polynésie française, îles Gambier",
        de: "Französisch-Polynesien, Gambier-Inseln",
        it: "Polinesia francese, Isole Gambier",
        th: "เฟรนช์โปลินีเซีย, หมู่เกาะแกมเบียร์",
        id: "Polinesia Prancis, Kepulauan Gambier",
        vi: "Polynesia thuộc Pháp, Quần đảo Gambier",
        nl: "Frans-Polynesië, Gambiereilanden",
        pl: "Polinezja Francuska, Wyspy Gambier",
        nb: "Fransk Polynesia, Gambierøyene",
        fi: "Ranskan Polynesia, Gambier-saaret",
        ar: "بولينيزيا الفرنسية ، جزر غامبير",
    },
    {
        value: -800,
        prefix: "(GMT-08:00)",
        en: "Alaska (Metlakatla Indian Community), USA",
        ko: "알래스카(메틀라카틀라 인디언 커뮤니티), 미국",
        sc: "阿拉斯加（梅特拉卡特拉印第安社区），美国",
        es: "Alaska (Comunidad indígena de Metlakatla), EE. UU.",
        ru: "Аляска (индейская община Метлакатла), США",
        ja: "アラスカ（メトラカットラインディアンコミュニティ）、アメリカ",
        fr: "Alaska (Communauté indienne Metlakatla), États-Unis",
        de: "Alaska (Indianergemeinde Metlakatla), USA",
        it: "Alaska (Comunità indiana Metlakatla), Stati Uniti",
        th: "อลาสก้า (ชุมชนอินเดียเมตลาคัทลา), สหรัฐอเมริกา",
        id: "Alaska (Komunitas India Metlakatla), AS",
        vi: "Alaska (Cộng đồng người da đỏ Metlakatla), Hoa Kỳ",
        nl: "Alaska (Indische Gemeenschap Metlakatla), VS",
        pl: "Alaska (Wspólnota Indian Metlakatla), USA",
        nb: "Alaska (Metlakatla Indian Community), USA",
        fi: "Alaska (Metlakatlan intiaaniyhteisö), USA",
        ar: "ألاسكا (مجتمع ميتلاكاتلا الهندي) ، الولايات المتحدة الأمريكية",
    },
    {
        value: -800,
        prefix: "(GMT-08:00)",
        en: "British Columbia (Victoria), Canada",
        ko: "브리티시 컬럼비아(빅토리아), 캐나다",
        sc: "加拿大不列颠哥伦比亚省（维多利亚）",
        es: "Columbia Británica (Victoria), Canadá",
        ru: "Британская Колумбия (Виктория), Канада",
        ja: "ブリティッシュコロンビア（ビクトリア）、カナダ",
        fr: "Colombie-Britannique (Victoria), Canada",
        de: "British Columbia (Victoria), Kanada",
        it: "Columbia Britannica (Vittoria), Canada",
        th: "บริติชโคลัมเบีย (วิกตอเรีย), แคนาดา",
        id: "British Columbia (Victoria), Kanada",
        vi: "British Columbia (Victoria), Canada",
        nl: "Brits-Columbia (Victoria), Canada",
        pl: "Kolumbia Brytyjska (Victoria), Kanada",
        nb: "Britisk Columbia (Victoria), Canada",
        fi: "Brittiläinen Kolumbia (Victoria), Kanada",
        ar: "كولومبيا البريطانية (فيكتوريا) ، كندا",
    },
    {
        value: -800,
        prefix: "(GMT-08:00)",
        en: "California, USA",
        ko: "캘리포니아, 미국",
        sc: "美国加利福尼亚州",
        es: "California, EE.UU",
        ru: "Калифорния, США",
        ja: "米国カリフォルニア州",
        fr: "Californie, États-Unis",
        de: "Kalifornien, USA",
        it: "California, Stati Uniti",
        th: "แคลิฟอร์เนีย สหรัฐอเมริกา",
        id: "California, AS",
        vi: "California, Hoa Kỳ",
        nl: "Californië, VS",
        pl: "Kalifornia, USA",
        nb: "California, USA",
        fi: "Kalifornia, Yhdysvallat",
        ar: "كاليفورنيا، الولايات المتحدة الأمريكية",
    },
    {
        value: -800,
        prefix: "(GMT-08:00)",
        en: "Idaho(Coeur d'Alene), USA",
        ko: "아이다호(코어 드얼린), 미국 ",
        sc: "美国爱达荷州（科达伦）",
        es: "Idaho (Coeur d'Alene), EE. UU.",
        ru: "Айдахо (Кёр д'Ален), США",
        ja: "アイダホ（コーダレーン）、アメリカ",
        fr: "Idaho (Coeur d'Alene), États-Unis",
        de: "Idaho (Coeur d’Alene), USA",
        it: "Idaho (Coeur d'Alene), Stati Uniti",
        th: "ไอดาโฮ(Coeur d'Alene), สหรัฐอเมริกา",
        id: "Idaho (Coeur d'Alene), AS",
        vi: "Idaho (Coeur d'Alene), Hoa Kỳ",
        nl: "Idaho (Coeur d'Alene), VS",
        pl: "Idaho (Coeur d'Alene), USA",
        nb: "Idaho (Coeur d'Alene), USA",
        fi: "Idaho (Coeur d'Alene), Yhdysvallat",
        ar: "أيداهو (Coeur d'Alene) ، الولايات المتحدة الأمريكية",
    },
    {
        value: -800,
        prefix: "(GMT-08:00)",
        en: "State of Baja California, Mexico",
        ko: "바하칼리포르니아주, 멕시코",
        sc: "墨西哥下加利福尼亚州",
        es: "Estado de Baja California, México",
        ru: "Штат Нижняя Калифорния, Мексика",
        ja: "メキシコ、バハカリフォルニア州",
        fr: "État de Basse-Californie, Mexique",
        de: "Bundesstaat Baja California, Mexiko",
        it: "Stato della Bassa California, Messico",
        th: "รัฐบาฮากาลิฟอร์เนีย เม็กซิโก",
        id: "Negara Bagian Baja California, Meksiko",
        vi: "Bang Baja California, México",
        nl: "Staat Baja California, Mexico",
        pl: "Stan Kalifornia Dolna, Meksyk",
        nb: "Delstaten Baja California, Mexico",
        fi: "Baja Californian osavaltio, Meksiko",
        ar: "ولاية باجا كاليفورنيا ، المكسيك",
    },
    {
        value: -800,
        prefix: "(GMT-08:00)",
        en: "Pitcairn Islands",
        ko: "핏케언 제도",
        sc: "皮特凯恩群岛",
        es: "Islas Pitcairn",
        ru: "Острова Питкэрн",
        ja: "ピトケアン諸島",
        fr: "Îles Pitcairn",
        de: "Pitcairn-Inseln",
        it: "Isole Pitcairn",
        th: "หมู่เกาะพิตแคร์น",
        id: "Kepulauan Pitcairn",
        vi: "Quần đảo Pitcairn",
        nl: "Pitcairneilanden",
        pl: "Wyspy Pitcairn",
        nb: "Pitcairnøyene",
        fi: "Pitcairnin saaret",
        ar: "جزر بيتكيرن",
    },
    {
        value: -800,
        prefix: "(GMT-08:00)",
        en: "Washington, USA",
        ko: "워싱턴, 미국",
        sc: "华盛顿州",
        es: "Washington (estado)",
        ru: "Вашингтон (штат)",
        ja: "米国ワシントン州",
        fr: "Washington, États-Unis",
        de: "Washington, USA",
        it: "Washington, Stati Uniti",
        th: "วอชิงตัน สหรัฐอเมริกา",
        id: "Washington, AS",
        vi: "Washington, Hoa Kỳ",
        nl: "Washington, VS",
        pl: "Waszyngton, USA",
        nb: "Washington, USA",
        fi: "Washington, Yhdysvallat",
        ar: "واشنطن ، الولايات المتحدة الأمريكية",
    },
    {
        value: -700,
        prefix: "(GMT-07:00)",
        en: "Alberta, Canada",
        ko: "앨버타, 캐나다 ",
        sc: "加拿大艾伯塔省",
        es: "Alberta, Canadá",
        ru: "Альберта, Канада",
        ja: "カナダ、アルバータ州",
        fr: "Alberta, Canada",
        de: "Alberta, Kanada",
        it: "Alberta, Canada",
        th: "อัลเบอร์ตา แคนาดา",
        id: "Alberta, Kanada",
        vi: "Alberta Canada",
        nl: "Alberta, Canada",
        pl: "Alberta, Kanada",
        nb: "Alberta, Canada",
        fi: "Alberta, Kanada",
        ar: "ألبرتا ، كندا",
    },
    {
        value: -700,
        prefix: "(GMT-07:00)",
        en: "Arizona (Phoenix), USA",
        ko: "애리조나(피닉스), 미국",
        sc: "美国亚利桑那州（凤凰城）",
        es: "Arizona (Phoenix), EE. UU.",
        ru: "Аризона (Феникс), США",
        ja: "アリゾナ（フェニックス）、米国",
        fr: "Arizona (Phœnix), États-Unis",
        de: "Arizona (Phönix), USA",
        it: "Arizona (Fenice), Stati Uniti",
        th: "แอริโซนา (ฟีนิกซ์) สหรัฐอเมริกา",
        id: "Arizona (Phoenix), AS",
        vi: "Arizona (Phoenix), Hoa Kỳ",
        nl: "Arizona (Phoenix), VS",
        pl: "Arizona (Feniks), USA",
        nb: "Arizona (Phoenix), USA",
        fi: "Arizona (Phoenix), Yhdysvallat",
        ar: "أريزونا (فينيكس) ، الولايات المتحدة الأمريكية",
    },
    {
        value: -700,
        prefix: "(GMT-07:00)",
        en: "British Columbia (Peace River District), Canada",
        ko: "브리티시 컬럼비아(피스 리버 지구), 캐나다 ",
        sc: "加拿大不列颠哥伦比亚省（和平河区）",
        es: "Columbia Británica (Distrito de Peace River), Canadá",
        ru: "Британская Колумбия (район Пис-Ривер), Канада",
        ja: "ブリティッシュコロンビア（ピースリバー地区）、カナダ",
        fr: "Colombie-Britannique (District de Peace River), Canada",
        de: "British Columbia (Peace River District), Kanada",
        it: "Columbia Britannica (distretto del fiume Peace), Canada",
        th: "บริติชโคลัมเบีย (เขตพีซริเวอร์), แคนาดา",
        id: "British Columbia (Distrik Sungai Perdamaian), Kanada",
        vi: "British Columbia (Quận sông Hòa bình), Canada",
        nl: "Brits-Columbia (Peace River District), Canada",
        pl: "Kolumbia Brytyjska (Peace River District), Kanada",
        nb: "British Columbia (Peace River District), Canada",
        fi: "Brittiläinen Kolumbia (Peace River District), Kanada",
        ar: "كولومبيا البريطانية (منطقة نهر السلام) ، كندا",
    },
    {
        value: -700,
        prefix: "(GMT-07:00)",
        en: "British Columbia (Central Kootenay District), Canada",
        ko: "브리티시 컬럼비아(중앙 쿠트니 지구), 캐나다",
        sc: "加拿大不列颠哥伦比亚省（中央库特尼区）",
        es: "Columbia Británica (Distrito Central de Kootenay), Canadá",
        ru: "Британская Колумбия (Центральный округ Кутеней), Канада",
        ja: "ブリティッシュコロンビア（セントラルクートニー地区）、カナダ",
        fr: "Colombie-Britannique (district central de Kootenay), Canada",
        de: "British Columbia (Central Kootenay District), Kanada",
        it: "Columbia Britannica (Distretto centrale di Kootenay), Canada",
        th: "บริติชโคลัมเบีย (เขตเซ็นทรัลคูทเนย์), แคนาดา",
        id: "British Columbia (Distrik Kootenay Tengah), Kanada",
        vi: "British Columbia (Quận Trung tâm Kootenay), Canada",
        nl: "Brits-Columbia (Central Kootenay District), Canada",
        pl: "Kolumbia Brytyjska (Central Kootenay District), Kanada",
        nb: "British Columbia (Central Kootenay District), Canada",
        fi: "Brittiläinen Kolumbia (Central Kootenay District), Kanada",
        ar: "كولومبيا البريطانية (منطقة كوتيناي الوسطى) ، كندا",
    },
    {
        value: -700,
        prefix: "(GMT-07:00)",
        en: "British Columbia (East Kootenay District and Columbia Valley), Canada",
        ko: "브리티시 컬럼비아(이스트 쿠트니 지구 및 컬럼비아 밸리), 캐나다",
        sc: "加拿大不列颠哥伦比亚省（东库特尼区和哥伦比亚谷）",
        es: "Columbia Británica (Distrito de East Kootenay y Valle de Columbia), Canadá",
        ru: "Британская Колумбия (Восточный округ Кутеней и долина Колумбия), Канада",
        ja: "ブリティッシュコロンビア（イーストクートニー地区とコロンビアバレー）、カナダ",
        fr: "Colombie-Britannique (district d'East Kootenay et vallée du Columbia), Canada",
        de: "British Columbia (East Kootenay District und Columbia Valley), Kanada",
        it: "Columbia Britannica (distretto di Kootenay orientale e Columbia Valley), Canada",
        th: "บริติชโคลัมเบีย (เขต East Kootenay และ Columbia Valley), แคนาดา",
        id: "British Columbia (Distrik Kootenay Timur dan Lembah Columbia), Kanada",
        vi: "British Columbia (Quận Đông Kootenay và Thung lũng Columbia), Canada",
        nl: "British Columbia (East Kootenay District en Columbia Valley), Canada",
        pl: "Kolumbia Brytyjska (East Kootenay District i Columbia Valley), Kanada",
        nb: "British Columbia (East Kootenay District og Columbia Valley), Canada",
        fi: "Brittiläinen Kolumbia (East Kootenay District ja Columbia Valley), Kanada",
        ar: "كولومبيا البريطانية (مقاطعة إيست كوتيناي ووادي كولومبيا) ، كندا",
    },
    {
        value: -700,
        prefix: "(GMT-07:00)",
        en: "Colorado, USA",
        ko: "콜로라도, 미국 ",
        sc: "美国科罗拉多州",
        es: "Colorado, EE. UU.",
        ru: "Колорадо, США",
        ja: "米国コロラド州",
        fr: "Colorado, États-Unis",
        de: "Colorado, USA",
        it: "Colorado, Stati Uniti",
        th: "โคโลราโด สหรัฐอเมริกา",
        id: "Colorado, Amerika Serikat",
        vi: "Colorado, Hoa Kỳ",
        nl: "Colorado, VS",
        pl: "Kolorado, USA",
        nb: "Colorado, USA",
        fi: "Colorado, USA",
        ar: "كولورادو ، الولايات المتحدة الأمريكية",
    },
    {
        value: -700,
        prefix: "(GMT-07:00)",
        en: "Idaho (Boise), USA",
        ko: "아이다호(보이시), 미국 ",
        sc: "美国爱达荷州（博伊西）",
        es: "Idaho (Boise), EE. UU.",
        ru: "Айдахо (Бойсе), США",
        ja: "アイダホ（ボイジー）、アメリカ",
        fr: "Idaho (Boise), États-Unis",
        de: "Idaho (Boise), USA",
        it: "Idaho (Boise), Stati Uniti",
        th: "ไอดาโฮ (บอยซี), สหรัฐอเมริกา",
        id: "Idaho (Boise), AS",
        vi: "Idaho (Boise), Hoa Kỳ",
        nl: "Idaho (Boise), VS",
        pl: "Idaho (Boise), USA",
        nb: "Idaho (Boise), USA",
        fi: "Idaho (Boise), Yhdysvallat",
        ar: "ايداهو (بويز) ، الولايات المتحدة الأمريكية",
    },
    {
        value: -700,
        prefix: "(GMT-07:00)",
        en: "Kansas (Goodland), USA",
        ko: "캔자스(굿랜드), 미국",
        sc: "美国堪萨斯州（古德兰）",
        es: "Kansas (Goodland), EE. UU.",
        ru: "Канзас (Гудленд), США",
        ja: "カンザス（グッドランド）、米国",
        fr: "Kansas (Goodland), États-Unis",
        de: "Kansas (Goodland), USA",
        it: "Kansas (Goodland), Stati Uniti",
        th: "แคนซัส (กู๊ดแลนด์), สหรัฐอเมริกา",
        id: "Kansas (Goodland), AS",
        vi: "Kansas (Goodland), Hoa Kỳ",
        nl: "Kansas (Goodland), VS",
        pl: "Kansas (Goodland), USA",
        nb: "Kansas (Goodland), USA",
        fi: "Kansas (Goodland), Yhdysvallat",
        ar: "كانساس (جودلاند) ، الولايات المتحدة الأمريكية",
    },
    {
        value: -700,
        prefix: "(GMT-07:00)",
        en: "Chihuahua, Mexico",
        ko: "치와와, 멕시코 ",
        sc: "墨西哥奇瓦瓦",
        es: "Chihuahua, México",
        ru: "Чиуауа, Мексика",
        ja: "メキシコ、チワワ",
        fr: "Chihuahua, Mexique",
        de: "Chihuahua, Mexiko",
        it: "Chihuahua, Messico",
        th: "ชีวาวา, เม็กซิโก",
        id: "Chihuahua, Meksiko",
        vi: "Chihuahua, México",
        nl: "Chihuahua, Mexico",
        pl: "Chihuahua, Meksyk",
        nb: "Chihuahua, Mexico",
        fi: "Chihuahua, Meksiko",
        ar: "شيواوا ، المكسيك",
    },
    {
        value: -700,
        prefix: "(GMT-07:00)",
        en: "Nayarit, Mexico",
        ko: "나야리트, 멕시코 ",
        sc: "墨西哥纳亚里特",
        es: "Nayarit, México",
        ru: "Наярит, Мексика",
        ja: "メキシコ、ナヤリト",
        fr: "Nayarit, Mexique",
        de: "Nayarit, Mexiko",
        it: "Nayarit, Messico",
        th: "นายาริต, เม็กซิโก",
        id: "Nayarit, Meksiko",
        vi: "Nayarit, México",
        nl: "Nayarit, Mexico",
        pl: "Nayarit, Meksyk",
        nb: "Nayarit, Mexico",
        fi: "Nayarit, Meksiko",
        ar: "ناياريت ، المكسيك",
    },
    {
        value: -700,
        prefix: "(GMT-07:00)",
        en: "Sinaloa, Mexico",
        ko: "시날로아, 멕시코 ",
        sc: "墨西哥锡那罗亚",
        es: "Sinaloa, México",
        ru: "Синалоа, Мексика",
        ja: "メキシコ、シナロア州",
        fr: "Sinaloa, Mexique",
        de: "Sinaloa, Mexiko",
        it: "Sinaloa, Messico",
        th: "ซีนาโลอา, เม็กซิโก",
        id: "Sinaloa, Meksiko",
        vi: "Sinaloa, México",
        nl: "Sinaloa, Mexico",
        pl: "Sinaloa, Meksyk",
        nb: "Sinaloa, Mexico",
        fi: "Sinaloa, Meksiko",
        ar: "سينالوا ، المكسيك",
    },
    {
        value: -700,
        prefix: "(GMT-07:00)",
        en: "States of Baja California Sur, Mexico",
        ko: "바하칼리포르니아수르주, 멕시코 ",
        sc: "墨西哥南下加利福尼亚州",
        es: "Estados de Baja California Sur, México",
        ru: "Штаты Южная Нижняя Калифорния, Мексика",
        ja: "メキシコ、バハカリフォルニアスル州",
        fr: "États de Basse-Californie du Sud, Mexique",
        de: "Staaten von Baja California Sur, Mexiko",
        it: "Stati della Bassa California Sur, Messico",
        th: "รัฐบาฮากาลิฟอร์เนียซูร์ ประเทศเม็กซิโก",
        id: "Negara Bagian Baja California Sur, Meksiko",
        vi: "Bang Baja California Sur, México",
        nl: "Staten van Baja California Sur, Mexico",
        pl: "Stany Baja California Sur, Meksyk",
        nb: "Delstatene Baja California Sur, Mexico",
        fi: "Baja California Surin osavaltiot, Meksiko",
        ar: "ولايات باجا كاليفورنيا سور ، المكسيك",
    },
    {
        value: -700,
        prefix: "(GMT-07:00)",
        en: "State of Sonora, Mexico",
        ko: "소노라 주, 멕시코 ",
        sc: "墨西哥索诺拉州",
        es: "Estado de Sonora, México",
        ru: "Штат Сонора, Мексика",
        ja: "メキシコ、ソノラ州",
        fr: "État de Sonora, Mexique",
        de: "Bundesstaat Sonora, Mexiko",
        it: "Stato di Sonora, Messico",
        th: "รัฐโซโนรา ประเทศเม็กซิโก",
        id: "Negara Bagian Sonora, Meksiko",
        vi: "Bang Sonora, México",
        nl: "Staat Sonora, Mexico",
        pl: "Stan Sonora, Meksyk",
        nb: "Delstaten Sonora, Mexico",
        fi: "Sonoran osavaltio, Meksiko",
        ar: "ولاية سونورا ، المكسيك",
    },
    {
        value: -700,
        prefix: "(GMT-07:00)",
        en: "Montana, USA",
        ko: "몬태나, 미국 ",
        sc: "美国蒙大拿州",
        es: "Montana, EE. UU.",
        ru: "Монтана, США",
        ja: "米国モンタナ州",
        fr: "Montana, États-Unis",
        de: "Montana, USA",
        it: "Montana, Stati Uniti",
        th: "มอนแทนา สหรัฐอเมริกา",
        id: "Montana, AS",
        vi: "Montana, Hoa Kỳ",
        nl: "Montana, VS",
        pl: "Montana, USA",
        nb: "Montana, USA",
        fi: "Montana, Yhdysvallat",
        ar: "مونتانا ، الولايات المتحدة الأمريكية",
    },
    {
        value: -700,
        prefix: "(GMT-07:00)",
        en: "Nebraska (Scottsbluff), USA",
        ko: "네브래스카(스코츠블러프), 미국 ",
        sc: "美国内布拉斯加州（斯科茨布拉夫）",
        es: "Nebraska (Scottsbluff), EE. UU.",
        ru: "Небраска (Скоттсблафф), США",
        ja: "ネブラスカ（スコッツブラフ）、米国",
        fr: "Nebraska (Scottsbluff), États-Unis",
        de: "Nebraska (Scottsbluff), USA",
        it: "Nebraska (Scottsbluff), Stati Uniti",
        th: "เนบราสก้า (สกอตส์บลัฟฟ์), สหรัฐอเมริกา",
        id: "Nebraska (Scottsbluff), AS",
        vi: "Nebraska (Scottsbluff), Hoa Kỳ",
        nl: "Nebraska (Scottsbluff), VS",
        pl: "Nebraska (Scottsbluff), USA",
        nb: "Nebraska (Scottsbluff), USA",
        fi: "Nebraska (Scottsbluff), Yhdysvallat",
        ar: "نبراسكا (سكوتسبلوف) ، الولايات المتحدة الأمريكية",
    },
    {
        value: -700,
        prefix: "(GMT-07:00)",
        en: "Nevada (West Wendover), USA",
        ko: "네바다주(웨스트 웬도버), 미국 ",
        sc: "美国内华达州（西温多弗）",
        es: "Nevada (West Wendover), EE. UU.",
        ru: "Невада (Западный Вендовер), США",
        ja: "ネバダ州（ウェストウェンドーバー）、米国",
        fr: "Nevada (West Wendover), États-Unis",
        de: "Nevada (West-Wendover), USA",
        it: "Nevada (West Wendover), Stati Uniti",
        th: "เนวาดา (เวสต์เวนโดเวอร์), สหรัฐอเมริกา",
        id: "Nevada (Wendover Barat), AS",
        vi: "Nevada (West Wendover), Hoa Kỳ",
        nl: "Nevada (West Wendover), VS",
        pl: "Nevada (West Wendover), USA",
        nb: "Nevada (West Wendover), USA",
        fi: "Nevada (West Wendover), Yhdysvallat",
        ar: "نيفادا (ويست ويندوفر) ، الولايات المتحدة الأمريكية",
    },
    {
        value: -700,
        prefix: "(GMT-07:00)",
        en: "New Mexico, USA",
        ko: "뉴멕시코, 미국 ",
        sc: "美国新墨西哥州",
        es: "Nuevo México, EE. UU.",
        ru: "Нью-Мексико, США",
        ja: "ニューメキシコ、米国",
        fr: "Nouveau-Mexique, États-Unis",
        de: "New Mexiko, USA",
        it: "Nuovo Messico, Stati Uniti",
        th: "นิวเม็กซิโก สหรัฐอเมริกา",
        id: "New Mexico, AS",
        vi: "New Mexico, Hoa Kỳ",
        nl: "New Mexico, VS",
        pl: "Nowy Meksyk, USA",
        nb: "New Mexico, USA",
        fi: "New Mexico, Yhdysvallat",
        ar: "نيو مكسيكو ، الولايات المتحدة الأمريكية",
    },
    {
        value: -700,
        prefix: "(GMT-07:00)",
        en: "North Dakota (Dickinson), USA",
        ko: "노스다코타(디킨슨), 미국 ",
        sc: "美国北达科他州（迪金森）",
        es: "Dakota del Norte (Dickinson), EE. UU.",
        ru: "Северная Дакота (Дикинсон), США",
        ja: "ノースダコタ州（ディキンソン）、米国",
        fr: "Dakota du Nord (Dickinson), États-Unis",
        de: "North Dakota (Dickinson), USA",
        it: "Dakota del Nord (Dickinson), Stati Uniti",
        th: "นอร์ทดาโคตา (ดิกคินสัน), สหรัฐอเมริกา",
        id: "Dakota Utara (Dickinson), AS",
        vi: "North Dakota (Dickinson), Hoa Kỳ",
        nl: "North Dakota (Dickinson), VS",
        pl: "Dakota Północna (Dickinson), USA",
        nb: "North Dakota (Dickinson), USA",
        fi: "Pohjois-Dakota (Dickinson), Yhdysvallat",
        ar: "داكوتا الشمالية (ديكنسون) ، الولايات المتحدة الأمريكية",
    },
    {
        value: -700,
        prefix: "(GMT-07:00)",
        en: "Northwest Territories, Canada",
        ko: "노스웨스트 준주, 캐나다 ",
        sc: "加拿大西北地区",
        es: "Territorios del Noroeste, Canadá",
        ru: "Северо-Западные территории, Канада",
        ja: "カナダ、ノースウェスト準州",
        fr: "Territoires du Nord-Ouest, Canada",
        de: "Nordwest-Territorien, Kanada",
        it: "Territori del Nordovest, Canada",
        th: "นอร์ทเวสต์เทร์ริทอรีส์ แคนาดา",
        id: "Wilayah Barat Laut, Kanada",
        vi: "Lãnh thổ Tây Bắc, Canada",
        nl: "Northwest Territories, Canada",
        pl: "Terytoria Północno-Zachodnie, Kanada",
        nb: "Northwest Territories, Canada",
        fi: "Northwest Territories, Kanada",
        ar: "الأقاليم الشمالية الغربية ، كندا",
    },
    {
        value: -700,
        prefix: "(GMT-07:00)",
        en: "Nunavut (Cambridge Bay), Canada",
        ko: "누나부트(캠브리지 베이), 캐나다",
        sc: "加拿大努纳武特（剑桥湾）",
        es: "Nunavut (Bahía de Cambridge), Canadá",
        ru: "Нунавут (Кембриджский залив), Канада",
        ja: "ヌナブト準州（ケンブリッジベイ）、カナダ",
        fr: "Nunavut (Cambridge Bay), Canada",
        de: "Nunavut (Cambridge Bay), Kanada",
        it: "Nunavut (Baia di Cambridge), Canada",
        th: "นูนาวุต (เคมบริดจ์เบย์), แคนาดา",
        id: "Nunavut (Teluk Cambridge), Kanada",
        vi: "Nunavut (Vịnh Cambridge), Canada",
        nl: "Nunavut (Cambridge Bay), Canada",
        pl: "Nunavut (Cambridge Bay), Kanada",
        nb: "Nunavut (Cambridge Bay), Canada",
        fi: "Nunavut (Cambridge Bay), Kanada",
        ar: "نونافوت (كامبردج باي) ، كندا",
    },
    {
        value: -700,
        prefix: "(GMT-07:00)",
        en: "Oregon (Ontario), USA",
        ko: "오리건(온타리오), 미국 ",
        sc: "美国俄勒冈州（安大略省）",
        es: "Oregón (Ontario), EE. UU.",
        ru: "Орегон (Онтарио), США",
        ja: "オレゴン（オンタリオ州）、米国",
        fr: "Oregon (Ontario), États-Unis",
        de: "Oregon (Ontario), USA",
        it: "Oregon (Ontario), Stati Uniti",
        th: "โอเรกอน (ออนแทรีโอ), สหรัฐอเมริกา",
        id: "Oregon (Ontario), AS",
        vi: "Oregon (Ontario), Hoa Kỳ",
        nl: "Oregon (Ontario), VS",
        pl: "Oregon (Ontario), USA",
        nb: "Oregon (Ontario), USA",
        fi: "Oregon (Ontario), Yhdysvallat",
        ar: "أوريغون (أونتاريو) ، الولايات المتحدة الأمريكية",
    },
    {
        value: -700,
        prefix: "(GMT-07:00)",
        en: "Saskatchewan (Lloydminster), Canada",
        ko: "서스캐처원(로이드민스터), 캐나다",
        sc: "加拿大萨斯喀彻温省（劳埃德明斯特）",
        es: "Saskatchewan (Lloydminster), Canadá",
        ru: "Саскачеван (Ллойдминстер), Канада",
        ja: "サスカチュワン（ロイドミンスター）、カナダ",
        fr: "Saskatchewan (Lloydminster), Canada",
        de: "Saskatchewan (Lloydminster), Kanada",
        it: "Saskatchewan (Lloydminster), Canada",
        th: "ซัสแคตเชวัน (ลอยด์มินสเตอร์), แคนาดา",
        id: "Saskatchewan (Lloydminster), Kanada",
        vi: "Saskatchewan (Lloydminster), Canada",
        nl: "Saskatchewan (Lloydminster), Canada",
        pl: "Saskatchewan (Lloydminster), Kanada",
        nb: "Saskatchewan (Lloydminster), Canada",
        fi: "Saskatchewan (Lloydminster), Kanada",
        ar: "ساسكاتشوان (لويدمينستر) ، كندا",
    },
    {
        value: -700,
        prefix: "(GMT-07:00)",
        en: "South Dakota (Rapid City), USA",
        ko: "미국 사우스다코타주(래피드시티)",
        sc: "美国南达科他州（拉皮德城）",
        es: "Dakota del Sur (Rapid City), EE. UU.",
        ru: "Южная Дакота (Рапид-Сити), США",
        ja: "サウスダコタ州（ラピッドシティー）、アメリカ",
        fr: "Dakota du Sud (Rapid City), États-Unis",
        de: "South Dakota (Schnelle Stadt), USA",
        it: "Dakota del Sud (Città Rapida), Stati Uniti",
        th: "เซาท์ดาโคตา (แรพิดซิตี), สหรัฐอเมริกา",
        id: "South Dakota (Kota Cepat), AS",
        vi: "Nam Dakota (Thành phố Rapid), Hoa Kỳ",
        nl: "South Dakota (Rapid City), VS",
        pl: "Dakota Południowa (Rapid City), USA",
        nb: "South Dakota (Rapid City), USA",
        fi: "Etelä-Dakota (Rapid City), Yhdysvallat",
        ar: "داكوتا الجنوبية (رابيد سيتي) ، الولايات المتحدة الأمريكية",
    },
    {
        value: -700,
        prefix: "(GMT-07:00)",
        en: "Texas (El Paso), USA",
        ko: "텍사스(엘파소), 미국",
        sc: "美国德克萨斯州（埃尔帕索）",
        es: "Texas (El Paso), EE. UU.",
        ru: "Техас (Эль-Пасо), США",
        ja: "テキサス（エルパソ）、米国",
        fr: "Texas (El Paso), États-Unis",
        de: "Texas (El Paso), USA",
        it: "Texas (El Paso), Stati Uniti",
        th: "เท็กซัส (เอลพาโซ), สหรัฐอเมริกา",
        id: "Texas (El Paso), AS",
        vi: "Texas (El Paso), Hoa Kỳ",
        nl: "Texas (El Paso), VS",
        pl: "Teksas (El Paso), USA",
        nb: "Texas (El Paso), USA",
        fi: "Texas (El Paso), Yhdysvallat",
        ar: "تكساس (الباسو) ، الولايات المتحدة الأمريكية",
    },
    {
        value: -700,
        prefix: "(GMT-07:00)",
        en: "Utah, USA",
        ko: "유타, 미국",
        sc: "美国犹他州",
        es: "Utah, EE. UU.",
        ru: "Юта, США",
        ja: "米国ユタ州",
        fr: "Utah, États-Unis",
        de: "Utah, USA",
        it: "Utah, Stati Uniti",
        th: "ยูทาห์ สหรัฐอเมริกา",
        id: "Utah, AS",
        vi: "Utah, Hoa Kỳ",
        nl: "Utah, VS",
        pl: "Utah, USA",
        nb: "Utah, USA",
        fi: "Utah, Yhdysvallat",
        ar: "يوتا ، الولايات المتحدة الأمريكية",
    },
    {
        value: -700,
        prefix: "(GMT-07:00)",
        en: "Wyoming, USA",
        ko: "와이오밍, 미국 ",
        sc: "美国怀俄明州",
        es: "Wyoming, EE. UU.",
        ru: "Вайоминг, США",
        ja: "米国ワイオミング州",
        fr: "Wyoming, États-Unis",
        de: "Wyoming, USA",
        it: "Wyoming, Stati Uniti",
        th: "ไวโอมิง สหรัฐอเมริกา",
        id: "Wyoming, AS",
        vi: "Wyoming, Hoa Kỳ",
        nl: "Wyoming, VS",
        pl: "Wyoming, USA",
        nb: "Wyoming, USA",
        fi: "Wyoming, Yhdysvallat",
        ar: "وايومنغ ، الولايات المتحدة الأمريكية",
    },
    {
        value: -600,
        prefix: "(GMT-06:00)",
        en: "Alabama, USA",
        ko: "앨라배마, 미국 ",
        sc: "美国阿拉巴马州",
        es: "Alabama, EE. UU.",
        ru: "Алабама, США",
        ja: "米国アラバマ州",
        fr: "Alabama, États-Unis",
        de: "Alabama, USA",
        it: "Alabama, Stati Uniti",
        th: "อลาบามา สหรัฐอเมริกา",
        id: "Alabama, AS",
        vi: "Alabama, Hoa Kỳ",
        nl: "Alabama, VS",
        pl: "Alabama, USA",
        nb: "Alabama, USA",
        fi: "Alabama, Yhdysvallat",
        ar: "ألاباما ، الولايات المتحدة الأمريكية",
    },
    {
        value: -600,
        prefix: "(GMT-06:00)",
        en: "Arkansas, USA",
        ko: "아칸소주, 미국 ",
        sc: "美国阿肯色州",
        es: "Arkansas, EE. UU.",
        ru: "Арканзас, США",
        ja: "アーカンソー、米国",
        fr: "Arkansas, États-Unis",
        de: "Arkansas, USA",
        it: "Arkansas, Stati Uniti",
        th: "อาร์คันซอ สหรัฐอเมริกา",
        id: "Arkansas, AS",
        vi: "Arkansas, Hoa Kỳ",
        nl: "Arkansas, VS",
        pl: "Arkansas, USA",
        nb: "Arkansas, USA",
        fi: "Arkansas, Yhdysvallat",
        ar: "أركنساس ، الولايات المتحدة الأمريكية",
    },
    {
        value: -600,
        prefix: "(GMT-06:00)",
        en: "Belize",
        ko: "벨리즈",
        sc: "伯利兹",
        es: "Belice",
        ru: "Белиз",
        ja: "ベリーズ",
        fr: "Bélize",
        de: "Belize",
        it: "Belize",
        th: "เบลีซ",
        id: "Belize",
        vi: "Belize",
        nl: "Belize",
        pl: "Belize",
        nb: "Belize",
        fi: "Belize",
        ar: "بليز",
    },
    {
        value: -600,
        prefix: "(GMT-06:00)",
        en: "Chile, Easter Island",
        ko: "칠레, 이스터 섬",
        sc: "智利，复活节岛",
        es: "Chile, Isla de Pascua",
        ru: "Чили, остров Пасхи",
        ja: "チリ、イースター島",
        fr: "Chili, île de Pâques",
        de: "Chile, Osterinsel",
        it: "Cile, Isola di Pasqua",
        th: "ชิลี เกาะอีสเตอร์",
        id: "Chili, Pulau Paskah",
        vi: "Chile, Đảo Phục sinh",
        nl: "Chili, Paaseiland",
        pl: "Chile, Wyspa Wielkanocna",
        nb: "Chile, Påskeøya",
        fi: "Chile, Pääsiäissaari",
        ar: "شيلي ، جزيرة الفصح",
    },
    {
        value: -600,
        prefix: "(GMT-06:00)",
        en: "Costa Rica",
        ko: "코스타리카",
        sc: "哥斯达黎加",
        es: "Costa Rica",
        ru: "Коста-Рика",
        ja: "コスタリカ",
        fr: "Costa Rica",
        de: "Costa Rica",
        it: "Costa Rica",
        th: "คอสตาริกา",
        id: "Kosta Rika",
        vi: "Costa Rica",
        nl: "Costa Rica",
        pl: "Kostaryka",
        nb: "Costa Rica",
        fi: "Costa Rica",
        ar: "كوستا ريكا",
    },
    {
        value: -600,
        prefix: "(GMT-06:00)",
        en: "Ecuador, Galapagos Province",
        ko: "에콰도르, 갈라파고스 주",
        sc: "厄瓜多尔，加拉帕戈斯省",
        es: "Ecuador, Provincia de Galápagos",
        ru: "Эквадор, Галапагосская провинция",
        ja: "エクアドル、ガラパゴス州",
        fr: "Equateur, Province des Galápagos",
        de: "Ecuador, Provinz Galapagos",
        it: "Ecuador, provincia delle Galapagos",
        th: "เอกวาดอร์, จังหวัดกาลาปาโกส",
        id: "Ekuador, Provinsi Galapagos",
        vi: "Ecuador, tỉnh Galapagos",
        nl: "Ecuador, Galapagos Provincie",
        pl: "Ekwador, Prowincja Galapagos",
        nb: "Ecuador, Galapagos-provinsen",
        fi: "Ecuador, Galapagosin maakunta",
        ar: "الإكوادور ، مقاطعة غالاباغوس",
    },
    {
        value: -600,
        prefix: "(GMT-06:00)",
        en: "El Salvador",
        ko: "엘살바도르",
        sc: "萨尔瓦多",
        es: "El Salvador",
        ru: "Эль Сальвадор",
        ja: "エルサルバドル",
        fr: "Le Salvador",
        de: "El Salvador",
        it: "El Salvador",
        th: "เอลซัลวาดอร์",
        id: "El Salvador",
        vi: "El Salvador",
        nl: "El Salvador",
        pl: "Salwador",
        nb: "El Salvador",
        fi: "El Salvador",
        ar: "السلفادور",
    },
    {
        value: -600,
        prefix: "(GMT-06:00)",
        en: "Florida (Pensacola), USA",
        ko: "플로리다(펜사콜라), 미국",
        sc: "美国佛罗里达州（彭萨科拉）",
        es: "Florida (Pensacola), EE. UU.",
        ru: "Флорида (Пенсакола), США",
        ja: "フロリダ（ペンサコーラ）、米国",
        fr: "Floride (Pensacola), États-Unis",
        de: "Florida (Pensacola), USA",
        it: "Florida (Pensacola), Stati Uniti",
        th: "ฟลอริดา (เพนซาโคลา) สหรัฐอเมริกา",
        id: "Florida (Pensacola), AS",
        vi: "Florida (Pensacola), Hoa Kỳ",
        nl: "Florida (Pensacola), VS",
        pl: "Floryda (Pensacola), USA",
        nb: "Florida (Pensacola), USA",
        fi: "Florida (Pensacola), Yhdysvallat",
        ar: "فلوريدا (بينساكولا) ، الولايات المتحدة الأمريكية",
    },
    {
        value: -600,
        prefix: "(GMT-06:00)",
        en: "Guatemala",
        ko: "과테말라",
        sc: "危地马拉",
        es: "Guatemala",
        ru: "Гватемала",
        ja: "グアテマラ",
        fr: "Guatemala",
        de: "Guatemala",
        it: "Guatemala",
        th: "กัวเตมาลา",
        id: "Guatemala",
        vi: "Guatemala",
        nl: "Guatemala",
        pl: "Gwatemala",
        nb: "Guatemala",
        fi: "Guatemala",
        ar: "غواتيمالا",
    },
    {
        value: -600,
        prefix: "(GMT-06:00)",
        en: "Honduras",
        ko: "온두라스",
        sc: "洪都拉斯",
        es: "Honduras",
        ru: "Гондурас",
        ja: "ホンジュラス",
        fr: "Honduras",
        de: "Honduras",
        it: "Honduras",
        th: "ฮอนดูรัส",
        id: "Honduras",
        vi: "Honduras",
        nl: "Honduras",
        pl: "Honduras",
        nb: "Honduras",
        fi: "Honduras",
        ar: "هندوراس",
    },
    {
        value: -600,
        prefix: "(GMT-06:00)",
        en: "Illinois, USA",
        ko: "일리노이주, 미국 ",
        sc: "美国伊利诺伊州",
        es: "Illinois, EE. UU.",
        ru: "Иллинойс, США",
        ja: "イリノイ州、米国",
        fr: "Illinois, États-Unis",
        de: "Illinois, USA",
        it: "Illinois, Stati Uniti",
        th: "อิลลินอยส์ สหรัฐอเมริกา",
        id: "Illinois, AS",
        vi: "Illinois, Hoa Kỳ",
        nl: "Illinois, VS",
        pl: "Illinois, USA",
        nb: "Illinois, USA",
        fi: "Illinois, Yhdysvallat",
        ar: "إلينوي ، الولايات المتحدة الأمريكية",
    },
    {
        value: -600,
        prefix: "(GMT-06:00)",
        en: "Indiana (Evansville), USA",
        ko: "인디애나(에반스빌), 미국",
        sc: "美国印第安纳州（埃文斯维尔）",
        es: "Indiana (Evansville), EE. UU.",
        ru: "Индиана (Эвансвилл), США",
        ja: "インディアナ（エバンズビル）、米国",
        fr: "Indiana (Evansville), États-Unis",
        de: "Indiana (Evansville), USA",
        it: "Indiana (Evansville), Stati Uniti",
        th: "อินดีแอนา (อีแวนส์วิลล์), สหรัฐอเมริกา",
        id: "Indiana (Evansville), AS",
        vi: "Indiana (Evansville), Hoa Kỳ",
        nl: "Indiana (Evansville), VS",
        pl: "Indiana (Evansville), USA",
        nb: "Indiana (Evansville), USA",
        fi: "Indiana (Evansville), Yhdysvallat",
        ar: "إنديانا (إيفانسفيل) ، الولايات المتحدة الأمريكية",
    },
    {
        value: -600,
        prefix: "(GMT-06:00)",
        en: "Iowa, USA",
        ko: "아이오와, 미국 ",
        sc: "美国爱荷华州",
        es: "Iowa, EE. UU.",
        ru: "Айова, США",
        ja: "米国アイオワ州",
        fr: "Iowa, États-Unis",
        de: "Iowa, USA",
        it: "Iowa, Stati Uniti",
        th: "ไอโอวา สหรัฐอเมริกา",
        id: "Iowa, AS",
        vi: "Iowa, Hoa Kỳ",
        nl: "Iowa, VS",
        pl: "Iowa, USA",
        nb: "Iowa, USA",
        fi: "Iowa, Yhdysvallat",
        ar: "أيوا ، الولايات المتحدة الأمريكية",
    },
    {
        value: -600,
        prefix: "(GMT-06:00)",
        en: "Kansas (Topeka), USA",
        ko: "캔자스(토피카), 미국",
        sc: "美国堪萨斯州（托皮卡）",
        es: "Kansas (Topeka), EE. UU.",
        ru: "Канзас (Топека), США",
        ja: "カンザス（トピーカ）、米国",
        fr: "Kansas (Topeka), États-Unis",
        de: "Kansas (Topeka), USA",
        it: "Kansas (Topeka), Stati Uniti",
        th: "แคนซัส (โทพีกา), สหรัฐอเมริกา",
        id: "Kansas (Topeka), AS",
        vi: "Kansas (Topeka), Hoa Kỳ",
        nl: "Kansas (Topeka), VS",
        pl: "Kansas (Topeka), USA",
        nb: "Kansas (Topeka), USA",
        fi: "Kansas (Topeka), Yhdysvallat",
        ar: "كانساس (توبيكا) ، الولايات المتحدة الأمريكية",
    },
    {
        value: -600,
        prefix: "(GMT-06:00)",
        en: "Kentucky (Bowling Green), USA",
        ko: "켄터키주(볼링 그린), 미국",
        sc: "美国肯塔基州（鲍灵格林）",
        es: "Kentucky (Bowling Green), EE. UU.",
        ru: "Кентукки (Боулинг-Грин), США",
        ja: "ケンタッキー（ボーリンググリーン）、アメリカ",
        fr: "Kentucky (Bowling Green), États-Unis",
        de: "Kentucky (Bowling Green), USA",
        it: "Kentucky (Bowling Green), Stati Uniti",
        th: "เคนตักกี้ (โบว์ลิ่งกรีน), สหรัฐอเมริกา",
        id: "Kentucky (Bowling Green), AS",
        vi: "Kentucky (Bowling Green), Hoa Kỳ",
        nl: "Kentucky (Bowling Green), VS",
        pl: "Kentucky (Bowling Green), USA",
        nb: "Kentucky (Bowling Green), USA",
        fi: "Kentucky (Bowling Green), Yhdysvallat",
        ar: "كنتاكي (بولينج جرين) ، الولايات المتحدة الأمريكية",
    },
    {
        value: -600,
        prefix: "(GMT-06:00)",
        en: "Louisiana, USA",
        ko: "루이지애나, 미국 ",
        sc: "美国路易斯安那州",
        es: "Luisiana, EE. UU.",
        ru: "Луизиана, США",
        ja: "ルイジアナ州、米国",
        fr: "Louisiane, États-Unis",
        de: "Louisiana, USA",
        it: "Louisiana, Stati Uniti",
        th: "หลุยเซียน่า สหรัฐอเมริกา",
        id: "Louisiana, AS",
        vi: "Louisiana, Hoa Kỳ",
        nl: "Louisiana, VS",
        pl: "Luizjana, USA",
        nb: "Louisiana, USA",
        fi: "Louisiana, Yhdysvallat",
        ar: "لويزيانا ، الولايات المتحدة الأمريكية",
    },
    {
        value: -600,
        prefix: "(GMT-06:00)",
        en: "Manitoba, Canada",
        ko: "매니토바, 캐나다",
        sc: "加拿大马尼托巴",
        es: "Manitoba, Canadá",
        ru: "Манитоба, Канада",
        ja: "カナダ、マニトバ州",
        fr: "Manitoba, Canada",
        de: "Manitoba, Kanada",
        it: "Manitoba, Canada",
        th: "แมนิโทบา แคนาดา",
        id: "Manitoba, Kanada",
        vi: "Manitoba, Canada",
        nl: "Manitoba, Canada",
        pl: "Manitoba, Kanada",
        nb: "Manitoba, Canada",
        fi: "Manitoba, Kanada",
        ar: "مانيتوبا ، كندا",
    },
    {
        value: -600,
        prefix: "(GMT-06:00)",
        en: "Mexico",
        ko: "멕시코",
        sc: "墨西哥",
        es: "México",
        ru: "Мексика",
        ja: "メキシコ",
        fr: "Mexique",
        de: "Mexiko",
        it: "Messico",
        th: "เม็กซิโก",
        id: "Meksiko",
        vi: "México",
        nl: "Mexico",
        pl: "Meksyk",
        nb: "Mexico",
        fi: "Meksiko",
        ar: "المكسيك",
    },
    {
        value: -600,
        prefix: "(GMT-06:00)",
        en: "Michigan (Iron Mountain), USA",
        ko: "미시간(아이언 마운틴), 미국 ",
        sc: "美国密歇根州（铁山）",
        es: "Míchigan (Montaña de Hierro), EE. UU.",
        ru: "Мичиган (Железная гора), США",
        ja: "ミシガン州（アイアンマウンテン）、米国",
        fr: "Michigan (Iron Mountain), États-Unis",
        de: "Michigan (Eisenberg), USA",
        it: "Michigan (Montagna di ferro), Stati Uniti",
        th: "มิชิแกน (ภูเขาเหล็ก) สหรัฐอเมริกา",
        id: "Michigan (Gunung Besi), AS",
        vi: "Michigan (Núi Sắt), Hoa Kỳ",
        nl: "Michigan (Iron Mountain), VS",
        pl: "Michigan (Iron Mountain), USA",
        nb: "Michigan (Iron Mountain), USA",
        fi: "Michigan (Iron Mountain), Yhdysvallat",
        ar: "ميشيغان (آيرون ماونتن) ، الولايات المتحدة الأمريكية",
    },
    {
        value: -600,
        prefix: "(GMT-06:00)",
        en: "Minnesota, USA",
        ko: "미네소타, 미국 ",
        sc: "美国明尼苏达州",
        es: "Minnesota, EE. UU.",
        ru: "Миннесота, США",
        ja: "ミネソタ州、米国",
        fr: "Minnesota, États-Unis",
        de: "Minnesota, USA",
        it: "Minnesota, Stati Uniti",
        th: "มินนิโซตา สหรัฐอเมริกา",
        id: "Minnesota, AS",
        vi: "Minnesota, Hoa Kỳ",
        nl: "Minnesota, VS",
        pl: "Minnesota, USA",
        nb: "Minnesota, USA",
        fi: "Minnesota, Yhdysvallat",
        ar: "مينيسوتا ، الولايات المتحدة الأمريكية",
    },
    {
        value: -600,
        prefix: "(GMT-06:00)",
        en: "Mississippi, USA",
        ko: "미시시피, 미국 ",
        sc: "美国密西西比州",
        es: "Misisipi, EE. UU.",
        ru: "Миссисипи, США",
        ja: "ミシシッピ州、米国",
        fr: "Mississippi, États-Unis",
        de: "Mississippi, USA",
        it: "Mississippi, Stati Uniti",
        th: "มิสซิสซิปปี้ สหรัฐอเมริกา",
        id: "Mississippi, AS",
        vi: "Mississippi, Hoa Kỳ",
        nl: "Mississippi, VS",
        pl: "Missisipi, USA",
        nb: "Mississippi, USA",
        fi: "Mississippi, Yhdysvallat",
        ar: "ميسيسيبي ، الولايات المتحدة الأمريكية",
    },
    {
        value: -600,
        prefix: "(GMT-06:00)",
        en: "Missouri, USA",
        ko: "미주리주, 미국 ",
        sc: "美国密苏里州",
        es: "Misuri, EE. UU.",
        ru: "Миссури, США",
        ja: "ミズーリ州、米国",
        fr: "Missouri, États-Unis",
        de: "Missouri, USA",
        it: "Missouri, Stati Uniti",
        th: "มิสซูรี สหรัฐอเมริกา",
        id: "Missouri, AS",
        vi: "Missouri, Hoa Kỳ",
        nl: "Missouri, VS",
        pl: "Missouri, USA",
        nb: "Missouri, USA",
        fi: "Missouri, Yhdysvallat",
        ar: "ميسوري ، الولايات المتحدة الأمريكية",
    },
    {
        value: -600,
        prefix: "(GMT-06:00)",
        en: "Nicaragua",
        ko: "니카라과",
        sc: "尼加拉瓜",
        es: "Nicaragua",
        ru: "Никарагуа",
        ja: "ニカラグア",
        fr: "Nicaragua",
        de: "Nicaragua",
        it: "Nicaragua",
        th: "นิการากัว",
        id: "Nikaragua",
        vi: "Nicaragua",
        nl: "Nicaragua",
        pl: "Nikaragua",
        nb: "Nicaragua",
        fi: "Nicaragua",
        ar: "نيكاراغوا",
    },
    {
        value: -600,
        prefix: "(GMT-06:00)",
        en: "Nebraska (Lincoln), USA",
        ko: "네브래스카(링컨), 미국 ",
        sc: "美国内布拉斯加州（林肯）",
        es: "Nebraska (Lincoln), EE. UU.",
        ru: "Небраска (Линкольн), США",
        ja: "ネブラスカ（リンカーン）、米国",
        fr: "Nebraska (Lincoln), États-Unis",
        de: "Nebraska (Lincoln), USA",
        it: "Nebraska (Lincoln), Stati Uniti",
        th: "เนบราสก้า (ลินคอล์น) สหรัฐอเมริกา",
        id: "Nebraska (Lincoln), AS",
        vi: "Nebraska (Lincoln), Hoa Kỳ",
        nl: "Nebraska (Lincoln), VS",
        pl: "Nebraska (Lincoln), USA",
        nb: "Nebraska (Lincoln), USA",
        fi: "Nebraska (Lincoln), Yhdysvallat",
        ar: "نبراسكا (لينكولن) ، الولايات المتحدة الأمريكية",
    },
    {
        value: -600,
        prefix: "(GMT-06:00)",
        en: "North Dakota (Bismarck), USA",
        ko: "노스다코타(비스마르크), 미국 ",
        sc: "美国北达科他州（俾斯麦）",
        es: "Dakota del Norte (Bismarck), EE. UU.",
        ru: "Северная Дакота (Бисмарк), США",
        ja: "ノースダコタ州（ビスマルク）、米国",
        fr: "Dakota du Nord (Bismarck), États-Unis",
        de: "North Dakota (Bismarck), USA",
        it: "Dakota del Nord (Bismarck), Stati Uniti",
        th: "รัฐนอร์ทดาโคตา (บิสมาร์ก), สหรัฐอเมริกา",
        id: "Dakota Utara (Bismarck), AS",
        vi: "North Dakota (Bismarck), Hoa Kỳ",
        nl: "North Dakota (Bismarck), VS",
        pl: "Dakota Północna (Bismarck), USA",
        nb: "North Dakota (Bismarck), USA",
        fi: "Pohjois-Dakota (Bismarck), Yhdysvallat",
        ar: "داكوتا الشمالية (بسمارك) ، الولايات المتحدة الأمريكية",
    },
    {
        value: -600,
        prefix: "(GMT-06:00)",
        en: "Nunavut (Baker Lake), Canada",
        ko: "누나부트(베이커 호수), 캐나다",
        sc: "加拿大努纳武特（贝克湖）",
        es: "Nunavut (lago Baker), Canadá",
        ru: "Нунавут (Бейкер-Лейк), Канада",
        ja: "カナダ、ヌナブト準州（ベーカーレイク）",
        fr: "Nunavut (Baker Lake), Canada",
        de: "Nunavut (Baker Lake), Kanada",
        it: "Nunavut (Lago Baker), Canada",
        th: "นูนาวุต (เบเกอร์เลค), แคนาดา",
        id: "Nunavut (Danau Baker), Kanada",
        vi: "Nunavut (Hồ Baker), Canada",
        nl: "Nunavut (Baker Lake), Canada",
        pl: "Nunavut (Jezioro Baker), Kanada",
        nb: "Nunavut (Baker Lake), Canada",
        fi: "Nunavut (Baker Lake), Kanada",
        ar: "نونافوت (بحيرة بيكر) ، كندا",
    },
    {
        value: -600,
        prefix: "(GMT-06:00)",
        en: "Oklahoma, USA",
        ko: "오클라호마, 미국 ",
        sc: "美国俄克拉荷马州",
        es: "Oklahoma, EE. UU.",
        ru: "Оклахома, США",
        ja: "米国オクラホマ州",
        fr: "Oklahoma, États-Unis",
        de: "Oklahoma, USA",
        it: "Oklahoma, Stati Uniti",
        th: "โอคลาโฮมา สหรัฐอเมริกา",
        id: "Oklahoma, AS",
        vi: "Oklahoma, Hoa Kỳ",
        nl: "Oklahoma, VS",
        pl: "Oklahoma, USA",
        nb: "Oklahoma, USA",
        fi: "Oklahoma, Yhdysvallat",
        ar: "أوكلاهوما ، الولايات المتحدة الأمريكية",
    },
    {
        value: -600,
        prefix: "(GMT-06:00)",
        en: "Ontario (western part of Northwestern Ontario), Canada",
        ko: "온타리오주(온타리오주 북서부 서부), 캐나다",
        sc: "安大略省（安大略省西北部的西部），加拿大",
        es: "Ontario (parte occidental del noroeste de Ontario), Canadá",
        ru: "Онтарио (западная часть Северо-Западного Онтарио), Канада",
        ja: "オンタリオ州（北西オンタリオ州の西部）、カナダ",
        fr: "Ontario (partie ouest du nord-ouest de l'Ontario), Canada",
        de: "Ontario (westlicher Teil des Nordwestens von Ontario), Kanada",
        it: "Ontario (parte occidentale dell'Ontario nordoccidentale), Canada",
        th: "ออนแทรีโอ (ทางตะวันตกของออนแทรีโอตะวันตกเฉียงเหนือ), แคนาดา",
        id: "Ontario (bagian barat Ontario Barat Laut), Kanada",
        vi: "Ontario (phần phía tây của Tây Bắc Ontario), Canada",
        nl: "Ontario (westelijk deel van Noordwest-Ontario), Canada",
        pl: "Ontario (zachodnia część północno-zachodniego Ontario), Kanada",
        nb: "Ontario (vestlige delen av Nordvestlige Ontario), Canada",
        fi: "Ontario (Länsiosa Luoteis-Ontariosta), Kanada",
        ar: "أونتاريو (الجزء الغربي من شمال غرب أونتاريو) ، كندا",
    },
    {
        value: -600,
        prefix: "(GMT-06:00)",
        en: "Saskatchewan (Regina), Canada",
        ko: "서스캐처원(레지나), 캐나다",
        sc: "加拿大萨斯喀彻温省（里贾纳）",
        es: "Saskatchewan (Regina), Canadá",
        ru: "Саскачеван (Регина), Канада",
        ja: "サスカチュワン（レジーナ）、カナダ",
        fr: "Saskatchewan (Régina), Canada",
        de: "Saskatchewan (Regina), Kanada",
        it: "Saskatchewan (Regina), Canada",
        th: "ซัสแคตเชวัน (Regina), แคนาดา",
        id: "Saskatchewan (Regina), Kanada",
        vi: "Saskatchewan (Regina), Canada",
        nl: "Saskatchewan (Regina), Canada",
        pl: "Saskatchewan (Regina), Kanada",
        nb: "Saskatchewan (Regina), Canada",
        fi: "Saskatchewan (Regina), Kanada",
        ar: "ساسكاتشوان (ريجينا) ، كندا",
    },
    {
        value: -600,
        prefix: "(GMT-06:00)",
        en: "South Dakota (Pierre), USA",
        ko: "사우스다코타주(피에르), 미국 ",
        sc: "美国南达科他州（皮埃尔）",
        es: "Dakota del Sur (Pierre), EE. UU.",
        ru: "Южная Дакота (Пьер), США",
        ja: "サウスダコタ州（ピエール）、アメリカ",
        fr: "Dakota du Sud (Pierre), États-Unis",
        de: "South Dakota (Pierre), USA",
        it: "Dakota del Sud (Pierre), Stati Uniti",
        th: "เซาท์ดาโคตา (ปิแอร์), สหรัฐอเมริกา",
        id: "South Dakota (Pierre), AS",
        vi: "Nam Dakota (Pierre), Hoa Kỳ",
        nl: "South Dakota (Pierre), VS",
        pl: "Dakota Południowa (Pierre), USA",
        nb: "South Dakota (Pierre), USA",
        fi: "Etelä-Dakota (Pierre), Yhdysvallat",
        ar: "داكوتا الجنوبية (بيير) ، الولايات المتحدة الأمريكية",
    },
    {
        value: -600,
        prefix: "(GMT-06:00)",
        en: "Tennessee (Nashville), USA",
        ko: "테네시(내슈빌), 미국",
        sc: "美国田纳西州（纳什维尔）",
        es: "Tennessee (Nashville), EE. UU.",
        ru: "Теннесси (Нэшвилл), США",
        ja: "テネシー州（ナッシュビル）、米国",
        fr: "Tennessee (Nashville), États-Unis",
        de: "Tennessee (Nashville), USA",
        it: "Tennessee (Nashville), Stati Uniti",
        th: "เทนเนสซี (แนชวิลล์), สหรัฐอเมริกา",
        id: "Tennessee (Nashville), AS",
        vi: "Tennessee (Nashville), Hoa Kỳ",
        nl: "Tennessee (Nashville), VS",
        pl: "Tennessee (Nashville), USA",
        nb: "Tennessee (Nashville), USA",
        fi: "Tennessee (Nashville), Yhdysvallat",
        ar: "تينيسي (ناشفيل) ، الولايات المتحدة الأمريكية",
    },
    {
        value: -600,
        prefix: "(GMT-06:00)",
        en: "Texas (Austin), USA",
        ko: "텍사스(오스틴), 미국",
        sc: "美国德克萨斯州（奥斯汀）",
        es: "Texas (Austin), EE. UU.",
        ru: "Техас (Остин), США",
        ja: "テキサス（オースティン）、米国",
        fr: "Texas (Austin), États-Unis",
        de: "Texas (Austin), USA",
        it: "Texas (Austin), Stati Uniti",
        th: "เท็กซัส (ออสติน), สหรัฐอเมริกา",
        id: "Texas (Austin), AS",
        vi: "Texas (Austin), Hoa Kỳ",
        nl: "Texas (Austin), VS",
        pl: "Teksas (Austin), USA",
        nb: "Texas (Austin), USA",
        fi: "Texas (Austin), Yhdysvallat",
        ar: "تكساس (أوستن) ، الولايات المتحدة الأمريكية",
    },
    {
        value: -600,
        prefix: "(GMT-06:00)",
        en: "Wisconsin, USA",
        ko: "위스콘신, 미국 ",
        sc: "美国威斯康星州",
        es: "Wisconsin, EE. UU.",
        ru: "Висконсин, США",
        ja: "米国ウィスコンシン州",
        fr: "Wisconsin, États-Unis",
        de: "Wisconsin, USA",
        it: "Wisconsin, Stati Uniti",
        th: "วิสคอนซิน สหรัฐอเมริกา",
        id: "Wisconsin, Amerika Serikat",
        vi: "Wisconsin, Hoa Kỳ",
        nl: "Wisconsin, VS",
        pl: "Wisconsin, USA",
        nb: "Wisconsin, USA",
        fi: "Wisconsin, Yhdysvallat",
        ar: "ولاية ويسكونسن ، الولايات المتحدة الأمريكية",
    },
    {
        value: -500,
        prefix: "(GMT-05:00)",
        en: "Acre, Brazil",
        ko: "아크리, 브라질",
        sc: "阿克里州巴西",
        es: "Acre, Brasil",
        ru: "Акри, Бразилия",
        ja: "ブラジル、エーカー",
        fr: "Acre, Brésil",
        de: "Acre, Brasilien",
        it: "Acri, Brasile",
        th: "รัฐอาครี, บราซิล",
        id: "Acre, Brasil",
        vi: "Acre, Brazil",
        nl: "Acre, Brazilië",
        pl: "Akr, Brazylia",
        nb: "Acre, Brasil",
        fi: "Acre, Brasilia",
        ar: "عكا ، البرازيل",
    },
    {
        value: -500,
        prefix: "(GMT-05:00)",
        en: "Bahamas",
        ko: "바하마",
        sc: "巴哈马",
        es: "Bahamas",
        ru: "Багамы",
        ja: "バハマ",
        fr: "Bahamas",
        de: "Bahamas",
        it: "Bahamas",
        th: "บาฮามาส",
        id: "Bahama",
        vi: "Bahamas",
        nl: "Bahamas",
        pl: "Bahamy",
        nb: "Bahamas",
        fi: "Bahama",
        ar: "جزر البهاما",
    },
    {
        value: -500,
        prefix: "(GMT-05:00)",
        en: "Cayman Islands",
        ko: "케이맨 제도",
        sc: "开曼群岛",
        es: "Islas Caimán",
        ru: "Каймановы острова",
        ja: "ケイマン諸島",
        fr: "Îles Caïmans",
        de: "Cayman Inseln",
        it: "Isole Cayman",
        th: "หมู่เกาะเคย์แมน",
        id: "Pulau cayman",
        vi: "Quần đảo Cayman",
        nl: "Kaaiman Eilanden",
        pl: "Kajmany",
        nb: "Caymanøyene",
        fi: "Caymansaaret",
        ar: "جزر كايمان",
    },
    {
        value: -500,
        prefix: "(GMT-05:00)",
        en: "Colombia",
        ko: "콜롬비아",
        sc: "哥伦比亚",
        es: "Colombia",
        ru: "Колумбия",
        ja: "コロンビア",
        fr: "Colombie",
        de: "Kolumbien",
        it: "Colombia",
        th: "โคลอมเบีย",
        id: "Kolumbia",
        vi: "Colombia",
        nl: "Colombia",
        pl: "Kolumbia",
        nb: "Colombia",
        fi: "Kolumbia",
        ar: "كولومبيا",
    },
    {
        value: -500,
        prefix: "(GMT-05:00)",
        en: "Connecticut, USA",
        ko: "코네티컷, 미국",
        sc: "美国康涅狄格州",
        es: "Connecticut, EE. UU.",
        ru: "Коннектикут, США",
        ja: "コネチカット、米国",
        fr: "Connecticut, États-Unis",
        de: "Connecticut, USA",
        it: "Connecticut, Stati Uniti",
        th: "คอนเนตทิคัต สหรัฐอเมริกา",
        id: "Connecticut, AS",
        vi: "Connecticut, Hoa Kỳ",
        nl: "Connecticut, VS",
        pl: "Connecticut, USA",
        nb: "Connecticut, USA",
        fi: "Connecticut, Yhdysvallat",
        ar: "كونيتيكت ، الولايات المتحدة الأمريكية",
    },
    {
        value: -500,
        prefix: "(GMT-05:00)",
        en: "Cuba",
        ko: "쿠바",
        sc: "古巴",
        es: "Cuba",
        ru: "Куба",
        ja: "キューバ",
        fr: "Cuba",
        de: "Kuba",
        it: "Cuba",
        th: "คิวบา",
        id: "Kuba",
        vi: "Cuba",
        nl: "Cuba",
        pl: "Kuba",
        nb: "Cuba",
        fi: "Kuuba",
        ar: "كوبا",
    },
    {
        value: -500,
        prefix: "(GMT-05:00)",
        en: "Delaware, USA",
        ko: "델라웨어, 미국",
        sc: "美国特拉华州",
        es: "Delaware, EE. UU.",
        ru: "Делавэр, США",
        ja: "デラウェア、米国",
        fr: "Delaware, États-Unis",
        de: "Delaware, USA",
        it: "Delaware, Stati Uniti",
        th: "เดลาแวร์ สหรัฐอเมริกา",
        id: "Delaware, AS",
        vi: "Delaware, Hoa Kỳ",
        nl: "Delaware, VS",
        pl: "Delaware, USA",
        nb: "Delaware, USA",
        fi: "Delaware, Yhdysvallat",
        ar: "ديلاوير ، الولايات المتحدة الأمريكية",
    },
    {
        value: -500,
        prefix: "(GMT-05:00)",
        en: "District of Columbia(Washington D.C), USA",
        ko: "컬럼비아 특별구(워싱턴 D.C), 미국",
        sc: "美国华盛顿哥伦比亚特区",
        es: "Distrito de Columbia (Washington D.C), EE. UU.",
        ru: "Округ Колумбия (Вашингтон, округ Колумбия), США",
        ja: "コロンビア特別区（ワシントンD.C）、米国",
        fr: "District de Columbia (Washington DC), États-Unis",
        de: "District of Columbia (Washington D.C.), USA",
        it: "Distretto di Columbia (Washington DC), Stati Uniti",
        th: "เขตโคลัมเบีย (วอชิงตัน ดี.ซี.), สหรัฐอเมริกา",
        id: "Distrik Columbia (Washington D.C), AS",
        vi: "Đặc khu Columbia (Washington D.C), Hoa Kỳ",
        nl: "District of Columbia (Washington D.C.), VS",
        pl: "Dystrykt Kolumbii (Waszyngton), USA",
        nb: "District of Columbia (Washington D.C), USA",
        fi: "District of Columbia (Washington D.C), Yhdysvallat",
        ar: "مقاطعة كولومبيا (واشنطن العاصمة) ، الولايات المتحدة الأمريكية",
    },
    {
        value: -500,
        prefix: "(GMT-05:00)",
        en: "Ecuador",
        ko: "에콰도르",
        sc: "厄瓜多尔",
        es: "Ecuador",
        ru: "Эквадор",
        ja: "エクアドル",
        fr: "Equateur",
        de: "Ecuador",
        it: "Ecuador",
        th: "เอกวาดอร์",
        id: "Ekuador",
        vi: "Ecuador",
        nl: "Ecuador",
        pl: "Ekwador",
        nb: "Ecuador",
        fi: "Ecuador",
        ar: "الاكوادور",
    },
    {
        value: -500,
        prefix: "(GMT-05:00)",
        en: "Florida (Tallahassee), USA",
        ko: "플로리다(탤러해시), 미국",
        sc: "美国佛罗里达州（塔拉哈西）",
        es: "Florida (Tallahassee), EE. UU.",
        ru: "Флорида (Таллахасси), США",
        ja: "フロリダ（タラハシー）、米国",
        fr: "Floride (Tallahassee), États-Unis",
        de: "Florida (Tallahassee), USA",
        it: "Florida (Tallahassee), Stati Uniti",
        th: "ฟลอริดา (แทลลาแฮสซี), สหรัฐอเมริกา",
        id: "Florida (Tallahassee), AS",
        vi: "Florida (Tallahassee), Hoa Kỳ",
        nl: "Florida (Tallahassee), VS",
        pl: "Floryda (Tallahassee), USA",
        nb: "Florida (Tallahassee), USA",
        fi: "Florida (Tallahassee), Yhdysvallat",
        ar: "فلوريدا (تالاهاسي) ، الولايات المتحدة الأمريكية",
    },
    {
        value: -500,
        prefix: "(GMT-05:00)",
        en: "Georgia, USA",
        ko: "조지아, 미국",
        sc: "美国乔治亚州",
        es: "georgia, EE. UU.",
        ru: "Джорджия, США",
        ja: "米国ジョージア州",
        fr: "Géorgie, États-Unis",
        de: "Georgien, USA",
        it: "Georgia, Stati Uniti",
        th: "จอร์เจีย สหรัฐอเมริกา",
        id: "Georgia, AS",
        vi: "Georgia, Hoa Kỳ",
        nl: "Georgië, VS",
        pl: "Gruzja, USA",
        nb: "Georgia, USA",
        fi: "Georgia, Yhdysvallat",
        ar: "جورجيا ، الولايات المتحدة الأمريكية",
    },
    {
        value: -500,
        prefix: "(GMT-05:00)",
        en: "Haiti",
        ko: "아이티",
        sc: "海地",
        es: "Haití",
        ru: "Гаити",
        ja: "ハイチ",
        fr: "Haïti",
        de: "Haiti",
        it: "Haiti",
        th: "เฮติ",
        id: "Haiti",
        vi: "Haiti",
        nl: "Haïti",
        pl: "Haiti",
        nb: "Haiti",
        fi: "Haiti",
        ar: "هايتي",
    },
    {
        value: -500,
        prefix: "(GMT-05:00)",
        en: "Indiana (Indianapolis), USA",
        ko: "인디애나(인디아나폴리스), 미국",
        sc: "美国印第安纳州（印第安纳波利斯）",
        es: "Indiana (Indianápolis), EE. UU.",
        ru: "Индиана (Индианаполис), США",
        ja: "インディアナ（インディアナポリス）、米国",
        fr: "Indiana (Indianapolis), États-Unis",
        de: "Indiana (Indianapolis), USA",
        it: "Indiana (Indianapolis), Stati Uniti",
        th: "อินดีแอนา (อินเดียแนโพลิส), สหรัฐอเมริกา",
        id: "Indiana (Indianapolis), AS",
        vi: "Indiana (Indianapolis), Hoa Kỳ",
        nl: "Indiana (Indianapolis), VS",
        pl: "Indiana (Indianapolis), USA",
        nb: "Indiana (Indianapolis), USA",
        fi: "Indiana (Indianapolis), Yhdysvallat",
        ar: "إنديانا (إنديانابوليس) ، الولايات المتحدة الأمريكية",
    },
    {
        value: -500,
        prefix: "(GMT-05:00)",
        en: "Jamaica",
        ko: "자메이카",
        sc: "牙买加",
        es: "Jamaica",
        ru: "Ямайка",
        ja: "ジャマイカ",
        fr: "Jamaïque",
        de: "Jamaika",
        it: "Giamaica",
        th: "จาไมก้า",
        id: "Jamaika",
        vi: "Jamaica",
        nl: "Jamaica",
        pl: "Jamajka",
        nb: "Jamaica",
        fi: "Jamaika",
        ar: "جامايكا",
    },
    {
        value: -500,
        prefix: "(GMT-05:00)",
        en: "Kentucky (Frankfort), USA",
        ko: "켄터키(프랭크포트), 미국",
        sc: "美国肯塔基州（法兰克福）",
        es: "Kentucky (Fráncfort), EE. UU.",
        ru: "Кентукки (Франкфорт), США",
        ja: "ケンタッキー（フランクフォート）、米国",
        fr: "Kentucky (Francfort), États-Unis",
        de: "Kentucky (Frankfurt), USA",
        it: "Kentucky (Francoforte), Stati Uniti",
        th: "เคนตักกี้ (แฟรงก์เฟิร์ต) สหรัฐอเมริกา",
        id: "Kentucky (Frankfort), AS",
        vi: "Kentucky (Frankfort), Hoa Kỳ",
        nl: "Kentucky (Frankfort), VS",
        pl: "Kentucky (Frankfort), USA",
        nb: "Kentucky (Frankfort), USA",
        fi: "Kentucky (Frankfort), Yhdysvallat",
        ar: "كنتاكي (فرانكفورت) ، الولايات المتحدة الأمريكية",
    },
    {
        value: -500,
        prefix: "(GMT-05:00)",
        en: "Maine, USA",
        ko: "메인, 미국",
        sc: "美国缅因州",
        es: "Maine, EE. UU.",
        ru: "Мэн, США",
        ja: "米国メイン州",
        fr: "Maine, États-Unis",
        de: "Maine, USA",
        it: "Maine, Stati Uniti",
        th: "เมน สหรัฐอเมริกา",
        id: "Maine, Amerika Serikat",
        vi: "Maine, Hoa Kỳ",
        nl: "Maine, VS",
        pl: "Maine, USA",
        nb: "Maine, USA",
        fi: "Maine, Yhdysvallat",
        ar: "مين ، الولايات المتحدة الأمريكية",
    },
    {
        value: -500,
        prefix: "(GMT-05:00)",
        en: "Maryland, USA",
        ko: "메릴랜드, 미국",
        sc: "美国马里兰州",
        es: "Maryland, EE. UU.",
        ru: "Мэриленд, США",
        ja: "米国メリーランド州",
        fr: "Maryland, États-Unis",
        de: "Maryland, USA",
        it: "Maryland, Stati Uniti",
        th: "แมริแลนด์ สหรัฐอเมริกา",
        id: "Maryland, AS",
        vi: "Maryland, Hoa Kỳ",
        nl: "Maryland, VS",
        pl: "Maryland, USA",
        nb: "Maryland, USA",
        fi: "Maryland, Yhdysvallat",
        ar: "ماريلاند ، الولايات المتحدة الأمريكية",
    },
    {
        value: -500,
        prefix: "(GMT-05:00)",
        en: "Massachusetts, USA",
        ko: "매사추세츠, 미국",
        sc: "美国马萨诸塞州",
        es: "Massachusetts, EE. UU.",
        ru: "Массачусетс, США",
        ja: "米国マサチューセッツ州",
        fr: "Massachusetts, États-Unis",
        de: "Massachusetts, USA",
        it: "Massachusetts, Stati Uniti",
        th: "แมสซาชูเซตส์ สหรัฐอเมริกา",
        id: "Massachusetts, AS",
        vi: "Massachusetts, Hoa Kỳ",
        nl: "Massachusetts, VS",
        pl: "Massachusetts, USA",
        nb: "Massachusetts, USA",
        fi: "Massachusetts, Yhdysvallat",
        ar: "ماساتشوستس ، الولايات المتحدة الأمريكية",
    },
    {
        value: -500,
        prefix: "(GMT-05:00)",
        en: "Michigan (Lansing), USA",
        ko: "미시간(랜싱), 미국",
        sc: "美国密歇根州（兰辛）",
        es: "Míchigan (Lansing), EE. UU.",
        ru: "Мичиган (Лансинг), США",
        ja: "ミシガン（ランシング）、米国",
        fr: "Michigan (Lansing), États-Unis",
        de: "Michigan (Lansing), USA",
        it: "Michigan (Lansing), Stati Uniti",
        th: "มิชิแกน (แลนซิง), สหรัฐอเมริกา",
        id: "Michigan (Lansing), AS",
        vi: "Michigan (Lansing), Hoa Kỳ",
        nl: "Michigan (Lansing), VS",
        pl: "Michigan (Lansing), USA",
        nb: "Michigan (Lansing), USA",
        fi: "Michigan (Lansing), Yhdysvallat",
        ar: "ميشيغان (لانسينغ) ، الولايات المتحدة الأمريكية",
    },
    {
        value: -500,
        prefix: "(GMT-05:00)",
        en: "Mexico, state of Quintana Roo",
        ko: "멕시코 킨타나로오주",
        sc: "墨西哥，金塔纳罗奥州",
        es: "México, estado de Quintana Roo",
        ru: "Мексика, штат Кинтана-Роо",
        ja: "メキシコ、キンタナロー州",
        fr: "Mexique, État de Quintana Roo",
        de: "Mexiko, Bundesstaat Quintana Roo",
        it: "Messico, stato di Quintana Roo",
        th: "เม็กซิโก รัฐกินตานาโร",
        id: "Meksiko, negara bagian Quintana Roo",
        vi: "México, bang Quintana Roo",
        nl: "Mexico, staat Quintana Roo",
        pl: "Meksyk, stan Quintana Roo",
        nb: "Mexico, delstaten Quintana Roo",
        fi: "Meksiko, Quintana Roon osavaltio",
        ar: "المكسيك ، ولاية كوينتانا رو",
    },
    {
        value: -500,
        prefix: "(GMT-05:00)",
        en: "New Hampshire, USA",
        ko: "뉴햄프셔, 미국",
        sc: "美国新罕布什尔州",
        es: "Nuevo Hampshire, EE. UU.",
        ru: "Нью-Гэмпшир, США",
        ja: "ニューハンプシャー、米国",
        fr: "New Hampshire, États-Unis",
        de: "NewHampshire, USA",
        it: "New Hampshire, Stati Uniti",
        th: "นิวแฮมป์เชียร์ สหรัฐอเมริกา",
        id: "New Hampshire, AS",
        vi: "New Hampshire, Hoa Kỳ",
        nl: "New Hampshire, VS",
        pl: "New Hampshire, USA",
        nb: "New Hampshire, USA",
        fi: "New Hampshire, Yhdysvallat",
        ar: "نيو هامبشاير ، الولايات المتحدة الأمريكية",
    },
    {
        value: -500,
        prefix: "(GMT-05:00)",
        en: "New Jersey, USA",
        ko: "뉴저지, 미국",
        sc: "美国新泽西州",
        es: "Nueva Jersey, EE. UU.",
        ru: "Нью-Джерси, США",
        ja: "ニュージャージー、米国",
        fr: "New Jersey, États-Unis",
        de: "New-Jersey, USA",
        it: "New Jersey, Stati Uniti",
        th: "นิวเจอร์ซีย์ สหรัฐอเมริกา",
        id: "New Jersey, AS",
        vi: "New Jersey, Hoa Kỳ",
        nl: "New Jersey, VS",
        pl: "New Jersey, USA",
        nb: "New Jersey, USA",
        fi: "New Jersey, Yhdysvallat",
        ar: "نيو جيرسي ، الولايات المتحدة الأمريكية",
    },
    {
        value: -500,
        prefix: "(GMT-05:00)",
        en: "New York, USA",
        ko: "뉴욕, 미국",
        sc: "美国纽约",
        es: "Nueva York, EE. UU.",
        ru: "Нью-Йорк, США",
        ja: "ニューヨーク、アメリカ",
        fr: "New York, États-Unis",
        de: "New York, USA",
        it: "New York, Stati Uniti",
        th: "นิวยอร์ก สหรัฐอเมริกา",
        id: "New York, AS",
        vi: "New York, Hoa Kỳ",
        nl: "New York, VS",
        pl: "Nowy Jork, USA",
        nb: "New York, USA",
        fi: "New York, Yhdysvallat",
        ar: "نيويورك ، الولايات المتحدة الأمريكية",
    },
    {
        value: -500,
        prefix: "(GMT-05:00)",
        en: "Nunavut (Coral Harbour), Canada",
        ko: "누나부트(코랄하버), 캐나다",
        sc: "加拿大努纳武特（珊瑚港）",
        es: "Nunavut (Puerto de Coral), Canadá",
        ru: "Нунавут (Корал-Харбор), Канада",
        ja: "ヌナブト準州（コーラルハーバー）、カナダ",
        fr: "Nunavut (port de corail), Canada",
        de: "Nunavut (Korallenhafen), Kanada",
        it: "Nunavut (Porto di Corallo), Canada",
        th: "นูนาวุต (คอรัล ฮาร์เบอร์), แคนาดา",
        id: "Nunavut (Pelabuhan Karang), Kanada",
        vi: "Nunavut (Cảng Coral), Canada",
        nl: "Nunavut (Coral Harbour), Canada",
        pl: "Nunavut (port koralowy), Kanada",
        nb: "Nunavut (Coral Harbour), Canada",
        fi: "Nunavut (Coral Harbour), Kanada",
        ar: "نونافوت (كورال هاربور) ، كندا",
    },
    {
        value: -500,
        prefix: "(GMT-05:00)",
        en: "Nunavut (Iqaluit), Canada",
        ko: "누나부트(이칼루이트), 캐나다",
        sc: "加拿大努纳武特（伊魁特）",
        es: "Nunavut (Iqaluit), Canadá",
        ru: "Нунавут (Икалуит), Канада",
        ja: "ヌナブト準州（イカルイト）、カナダ",
        fr: "Nunavut (Iqaluit), Canada",
        de: "Nunavut (Iqaluit), Kanada",
        it: "Nunavut (Iqaluit), Canada",
        th: "นูนาวุต (อีคาลูอิต), แคนาดา",
        id: "Nunavut (Iqaluit), Kanada",
        vi: "Nunavut (Iqaluit), Canada",
        nl: "Nunavut (Iqaluit), Canada",
        pl: "Nunavut (Iqaluit), Kanada",
        nb: "Nunavut (Iqaluit), Canada",
        fi: "Nunavut (Iqaluit), Kanada",
        ar: "نونافوت (إيكالويت) ، كندا",
    },
    {
        value: -500,
        prefix: "(GMT-05:00)",
        en: "North Carolina, USA",
        ko: "노스캐롤라이나, 미국",
        sc: "美国北卡罗来纳州",
        es: "Carolina del Norte, EE. UU.",
        ru: "Северная Каролина, США",
        ja: "米国ノースカロライナ州",
        fr: "Caroline du Nord, États-Unis",
        de: "North Carolina, USA",
        it: "Carolina del Nord, Stati Uniti",
        th: "นอร์ทแคโรไลนา สหรัฐอเมริกา",
        id: "Carolina Utara, AS",
        vi: "Bắc Carolina, Hoa Kỳ",
        nl: "Noord-Carolina, VS",
        pl: "Karolina Północna, USA",
        nb: "North Carolina, USA",
        fi: "Pohjois-Carolina, Yhdysvallat",
        ar: "كارولينا الشمالية ، الولايات المتحدة الأمريكية",
    },
    {
        value: -500,
        prefix: "(GMT-05:00)",
        en: "Ohio, USA",
        ko: "오하이오, 미국",
        sc: "美国俄亥俄州",
        es: "Ohio, EE. UU.",
        ru: "Огайо, США",
        ja: "米国オハイオ州",
        fr: "Ohio, États-Unis",
        de: "Ohio, USA",
        it: "Ohio, Stati Uniti",
        th: "โอไฮโอ สหรัฐอเมริกา",
        id: "Ohio, Amerika Serikat",
        vi: "Ohio, Hoa Kỳ",
        nl: "Ohio, VS",
        pl: "Ohio, USA",
        nb: "Ohio, USA",
        fi: "Ohio, Yhdysvallat",
        ar: "أوهايو ، الولايات المتحدة الأمريكية",
    },
    {
        value: -500,
        prefix: "(GMT-05:00)",
        en: "Ontario (Toronto, Ottawa), Canada",
        ko: "온타리오(토론토, 오타와), 캐나다",
        sc: "安大略省（多伦多，渥太华），加拿大",
        es: "Ontario (Toronto, Ottawa), Canadá",
        ru: "Онтарио (Торонто, Оттава), Канада",
        ja: "オンタリオ州（トロント、オタワ）、カナダ",
        fr: "Ontario (Toronto, Ottawa), Canada",
        de: "Ontario (Toronto, Ottawa), Kanada",
        it: "Ontario (Toronto, Ottawa), Canada",
        th: "ออนแทรีโอ (โตรอนโต ออตตาวา) แคนาดา",
        id: "Ontario (Toronto, Ottawa), Kanada",
        vi: "Ontario (Toronto, Ottawa), Canada",
        nl: "Ontario (Toronto, Ottawa), Canada",
        pl: "Ontario (Toronto, Ottawa), Kanada",
        nb: "Ontario (Toronto, Ottawa), Canada",
        fi: "Ontario (Toronto, Ottawa), Kanada",
        ar: "أونتاريو (تورنتو ، أوتاوا) ، كندا",
    },
    {
        value: -500,
        prefix: "(GMT-05:00)",
        en: "Ontario (Quetico Provincial Park), Canada",
        ko: "온타리오(퀘티코 주립공원), 캐나다",
        sc: "加拿大安大略省（Quetico 省立公园）",
        es: "Ontario (Parque Provincial de Quetico), Canadá",
        ru: "Онтарио (провинциальный парк Кетико), Канада",
        ja: "カナダ、オンタリオ州（ケティコ州立公園）",
        fr: "Ontario (parc provincial Quetico), Canada",
        de: "Ontario (Provinzpark Quetico), Kanada",
        it: "Ontario (Parco Provinciale del Quetico), Canada",
        th: "ออนแทรีโอ (อุทยานประจำจังหวัดเกติโก), แคนาดา",
        id: "Ontario (Taman Provinsi Quetico), Kanada",
        vi: "Ontario (Công viên tỉnh Quetico), Canada",
        nl: "Ontario (Quetico Provincial Park), Canada",
        pl: "Ontario (Quetico Provincial Park), Kanada",
        nb: "Ontario (Quetico Provincial Park), Canada",
        fi: "Ontario (Queticon maakuntapuisto), Kanada",
        ar: "أونتاريو (Quetico Provincial Park) ، كندا",
    },
    {
        value: -500,
        prefix: "(GMT-05:00)",
        en: "Panama",
        ko: "파나마",
        sc: "巴拿马",
        es: "Panamá",
        ru: "Панама",
        ja: "パナマ",
        fr: "Panama",
        de: "Panama",
        it: "Panama",
        th: "ปานามา",
        id: "Panama",
        vi: "Panama",
        nl: "Panama",
        pl: "Panama",
        nb: "Panama",
        fi: "Panama",
        ar: "بنما",
    },
    {
        value: -500,
        prefix: "(GMT-05:00)",
        en: "Pennsylvania, USA",
        ko: "펜실베니아, 미국",
        sc: "美国宾夕法尼亚州",
        es: "Pensilvania, EE. UU.",
        ru: "Пенсильвания, США",
        ja: "米国ペンシルベニア州",
        fr: "Pennsylvanie, États-Unis",
        de: "Pennsylvanien, USA",
        it: "Pennsylvania, Stati Uniti",
        th: "เพนซิลเวเนีย สหรัฐอเมริกา",
        id: "Pennsylvania, Amerika Serikat",
        vi: "Pennsylvania, Hoa Kỳ",
        nl: "Pennsylvania, VS",
        pl: "Pensylwania, USA",
        nb: "Pennsylvania, USA",
        fi: "Pennsylvania, Yhdysvallat",
        ar: "بنسلفانيا ، الولايات المتحدة الأمريكية",
    },
    {
        value: -500,
        prefix: "(GMT-05:00)",
        en: "Peru",
        ko: "페루",
        sc: "秘鲁",
        es: "Perú",
        ru: "Перу",
        ja: "ペルー",
        fr: "Pérou",
        de: "Peru",
        it: "Perù",
        th: "เปรู",
        id: "Peru",
        vi: "Peru",
        nl: "Peru",
        pl: "Peru",
        nb: "Peru",
        fi: "Peru",
        ar: "بيرو",
    },
    {
        value: -500,
        prefix: "(GMT-05:00)",
        en: "Rhode Island, USA",
        ko: "로드 아일랜드, 미국",
        sc: "美国罗德岛",
        es: "Rhode Island, EE. UU.",
        ru: "Род-Айленд, США",
        ja: "ロードアイランド、米国",
        fr: "Rhode Island, États-Unis",
        de: "Rhode Island, USA",
        it: "Rhode Island, Stati Uniti",
        th: "โรดไอแลนด์ สหรัฐอเมริกา",
        id: "Pulau Rhode, AS",
        vi: "Đảo Rhode, Hoa Kỳ",
        nl: "Rhode Island, VS",
        pl: "Rhode Island, USA",
        nb: "Rhode Island, USA",
        fi: "Rhode Island, Yhdysvallat",
        ar: "رود آيلاند ، الولايات المتحدة الأمريكية",
    },
    {
        value: -500,
        prefix: "(GMT-05:00)",
        en: "Quebec (Quebec City), Canada",
        ko: "퀘벡(퀘벡시티), 캐나다",
        sc: "加拿大魁北克（魁北克市）",
        es: "Quebec (Ciudad de Quebec), Canadá",
        ru: "Квебек (город Квебек), Канада",
        ja: "ケベック（ケベックシティ）、カナダ",
        fr: "Québec (ville de Québec), Canada",
        de: "Quebec (Quebec City), Kanada",
        it: "Quebec (città del Quebec), Canada",
        th: "ควิเบก (เมืองควิเบก), แคนาดา",
        id: "Quebec (Kota Quebec), Kanada",
        vi: "Quebec (Thành phố Quebec), Canada",
        nl: "Quebec (Quebec City), Canada",
        pl: "Quebec (Quebec City), Kanada",
        nb: "Quebec (Quebec City), Canada",
        fi: "Quebec (Quebec City), Kanada",
        ar: "كيبيك (مدينة كيبيك) ، كندا",
    },
    {
        value: -500,
        prefix: "(GMT-05:00)",
        en: "South Carolina, USA",
        ko: "사우스캐롤라이나, 미국",
        sc: "美国南卡罗来纳州",
        es: "Carolina del Sur, EE. UU.",
        ru: "Южная Каролина, США",
        ja: "米国サウスカロライナ州",
        fr: "Caroline du Sud, États-Unis",
        de: "South Carolina, USA",
        it: "Carolina del Sud, Stati Uniti",
        th: "เซาท์แคโรไลนา สหรัฐอเมริกา",
        id: "Carolina Selatan, AS",
        vi: "Nam Carolina, Hoa Kỳ",
        nl: "Zuid-Carolina, VS",
        pl: "Karolina Południowa, USA",
        nb: "Sør-Carolina, USA",
        fi: "Etelä-Carolina, Yhdysvallat",
        ar: "ساوث كارولينا ، الولايات المتحدة الأمريكية",
    },
    {
        value: -500,
        prefix: "(GMT-05:00)",
        en: "Southwest Amazonas, Brazil",
        ko: "브라질 아마조나스 남서부",
        sc: "巴西亚马孙西南部",
        es: "Sudoeste de Amazonas, Brasil",
        ru: "Юго-западная Амазонас, Бразилия",
        ja: "アマゾナス南西部、ブラジル",
        fr: "Sud-ouest de l'Amazonas, Brésil",
        de: "Südwest Amazonas, Brasilien",
        it: "Amazonas sudoccidentale, Brasile",
        th: "อเมซอนตะวันตกเฉียงใต้ บราซิล",
        id: "Amazonas Barat Daya, Brasil",
        vi: "Tây nam Amazonas, Brazil",
        nl: "Zuidwest-Amazonas, Brazilië",
        pl: "Południowo-zachodnia Amazonia, Brazylia",
        nb: "Sørvest-Amazonas, Brasil",
        fi: "Lounais Amazonas, Brasilia",
        ar: "جنوب غرب أمازوناس ، البرازيل",
    },
    {
        value: -500,
        prefix: "(GMT-05:00)",
        en: "Tennessee (Knoxville), USA",
        ko: "테네시(녹스빌), 미국",
        sc: "美国田纳西州（诺克斯维尔）",
        es: "Tennessee (Knoxville), EE. UU.",
        ru: "Теннесси (Ноксвилл), США",
        ja: "テネシー州（ノックスビル）、米国",
        fr: "Tennessee (Knoxville), États-Unis",
        de: "Tennessee (Knoxville), USA",
        it: "Tennessee (Knoxville), Stati Uniti",
        th: "เทนเนสซี (นอกซ์วิลล์), สหรัฐอเมริกา",
        id: "Tennessee (Knoxville), AS",
        vi: "Tennessee (Knoxville), Hoa Kỳ",
        nl: "Tennessee (Knoxville), VS",
        pl: "Tennessee (Knoxville), USA",
        nb: "Tennessee (Knoxville), USA",
        fi: "Tennessee (Knoxville), Yhdysvallat",
        ar: "تينيسي (نوكسفيل) ، الولايات المتحدة الأمريكية",
    },
    {
        value: -500,
        prefix: "(GMT-05:00)",
        en: "Vermont, USA",
        ko: "버몬트주, 미국",
        sc: "美国佛蒙特州",
        es: "Vermont, EE. UU.",
        ru: "Вермонт, США",
        ja: "バーモント州、米国",
        fr: "Vermont, États-Unis",
        de: "Vermont, USA",
        it: "Vermont, Stati Uniti",
        th: "เวอร์มอนต์ สหรัฐอเมริกา",
        id: "Vermont, AS",
        vi: "Vermont, Hoa Kỳ",
        nl: "Vermont, VS",
        pl: "Vermont, USA",
        nb: "Vermont, USA",
        fi: "Vermont, Yhdysvallat",
        ar: "فيرمونت ، الولايات المتحدة الأمريكية",
    },
    {
        value: -500,
        prefix: "(GMT-05:00)",
        en: "Virginia, USA",
        ko: "버지니아, 미국",
        sc: "美国弗吉尼亚州",
        es: "Virginia, EE. UU.",
        ru: "Вирджиния, США",
        ja: "米国バージニア州",
        fr: "Virginie, États-Unis",
        de: "Virginia, USA",
        it: "Virginia, Stati Uniti",
        th: "เวอร์จิเนีย สหรัฐอเมริกา",
        id: "Virginia, Amerika Serikat",
        vi: "Virginia, Hoa Kỳ",
        nl: "Virginia, VS",
        pl: "Wirginia, USA",
        nb: "Virginia, USA",
        fi: "Virginia, Yhdysvallat",
        ar: "فيرجينيا ، الولايات المتحدة الأمريكية",
    },
    {
        value: -500,
        prefix: "(GMT-05:00)",
        en: "West Virginia, USA",
        ko: "웨스트버지니아, 미국",
        sc: "美国西弗吉尼亚州",
        es: "Virginia Occidental, EE. UU.",
        ru: "Западная Вирджиния, США",
        ja: "米国ウェストバージニア州",
        fr: "Virginie-Occidentale, États-Unis",
        de: "West-Virginia, USA",
        it: "Virginia Occidentale, Stati Uniti",
        th: "เวสต์เวอร์จิเนีย สหรัฐอเมริกา",
        id: "Virginia Barat, AS",
        vi: "Tây Virginia, Hoa Kỳ",
        nl: "West Virginia, VS",
        pl: "Wirginia Zachodnia, USA",
        nb: "West Virginia, USA",
        fi: "Länsi-Virginia, Yhdysvallat",
        ar: "فيرجينيا الغربية ، الولايات المتحدة الأمريكية",
    },
    {
        value: -400,
        prefix: "(GMT-04:00)",
        en: "Amazonas, Brazil",
        ko: "아마조나스, 브라질",
        sc: "巴西亚马孙州",
        es: "Amazonas, Brasil",
        ru: "Амасонас, Бразилия",
        ja: "アマゾナス、ブラジル",
        fr: "Amazonas, Brésil",
        de: "Amazonas, Brasilien",
        it: "Amazonas, Brasile",
        th: "รัฐอามาโซนัช, บราซิล",
        id: "Amazonas, Brasil",
        vi: "Amazonas, Brazil",
        nl: "Amazonas, Brazilië",
        pl: "Amazonas, Brazylia",
        nb: "Amazonas, Brasil",
        fi: "Amazonas, Brasilia",
        ar: "أمازوناس ، البرازيل",
    },
    {
        value: -400,
        prefix: "(GMT-04:00)",
        en: "Anguilla",
        ko: "앵귈라",
        sc: "安圭拉",
        es: "Anguila",
        ru: "Ангилья",
        ja: "アンギラ",
        fr: "Anguilla",
        de: "Anguilla",
        it: "Anguilla",
        th: "แองกวิลลา",
        id: "Anguila",
        vi: "Anguilla",
        nl: "Anguilla",
        pl: "Anguilla",
        nb: "Anguilla",
        fi: "Anguilla",
        ar: "أنغيلا",
    },
    {
        value: -400,
        prefix: "(GMT-04:00)",
        en: "Antigua and Barbuda",
        ko: "앤티가 바부다",
        sc: "安提瓜和巴布达",
        es: "Antigua y Barbuda",
        ru: "Антигуа и Барбуда",
        ja: "アンティグアバーブーダ",
        fr: "Antigua-et-Barbuda",
        de: "Antigua und Barbuda",
        it: "Antigua e Barbuda",
        th: "แอนติกาและบาร์บูดา",
        id: "Antigua dan Barbuda",
        vi: "Antigua và Barbuda",
        nl: "Antigua en Barbuda",
        pl: "Antigua i Barbuda",
        nb: "Antigua og Barbuda",
        fi: "Antigua ja Barbuda",
        ar: "أنتيغوا وبربودا",
    },
    {
        value: -400,
        prefix: "(GMT-04:00)",
        en: "Aruba",
        ko: "아루바",
        sc: "阿鲁巴岛",
        es: "Aruba",
        ru: "Аруба",
        ja: "アルバ",
        fr: "Aruba",
        de: "Aruba",
        it: "Aruba",
        th: "อารูบา",
        id: "Aruba",
        vi: "Aruba",
        nl: "Aruba",
        pl: "Aruba",
        nb: "Aruba",
        fi: "Aruba",
        ar: "أروبا",
    },
    {
        value: -400,
        prefix: "(GMT-04:00)",
        en: "Barbados",
        ko: "바베이도스",
        sc: "巴巴多斯",
        es: "barbados",
        ru: "Барбадос",
        ja: "バルバドス",
        fr: "Barbade",
        de: "Barbados",
        it: "Barbados",
        th: "บาร์เบโดส",
        id: "Barbados",
        vi: "Barbados",
        nl: "Barbados",
        pl: "Barbados",
        nb: "Barbados",
        fi: "Barbados",
        ar: "بربادوس",
    },
    {
        value: -400,
        prefix: "(GMT-04:00)",
        en: "Bermuda",
        ko: "버뮤다",
        sc: "百慕大",
        es: "islas Bermudas",
        ru: "Бермуды",
        ja: "バミューダ",
        fr: "Bermudes",
        de: "Bermudas",
        it: "Bermuda",
        th: "เบอร์มิวดา",
        id: "Bermuda",
        vi: "Bermuda",
        nl: "Bermuda",
        pl: "Bermudy",
        nb: "Bermuda",
        fi: "Bermuda",
        ar: "برمودا",
    },
    {
        value: -400,
        prefix: "(GMT-04:00)",
        en: "Bolivia",
        ko: "볼리비아",
        sc: "玻利维亚",
        es: "Bolivia",
        ru: "Боливия",
        ja: "ボリビア",
        fr: "Bolivie",
        de: "Bolivien",
        it: "Bolivia",
        th: "โบลิเวีย",
        id: "Bolivia",
        vi: "Bolivia",
        nl: "Bolivia",
        pl: "Boliwia",
        nb: "Bolivia",
        fi: "Bolivia",
        ar: "بوليفيا",
    },
    {
        value: -400,
        prefix: "(GMT-04:00)",
        en: "Bonaire",
        ko: "보네르",
        sc: "博内尔岛",
        es: "bonaire",
        ru: "Бонайре",
        ja: "ボネール",
        fr: "Bonaire",
        de: "Bonaire",
        it: "Bonaire",
        th: "โบแนร์",
        id: "Bonaire",
        vi: "Bonaire",
        nl: "Bonaire",
        pl: "Bonaire",
        nb: "Bonaire",
        fi: "Bonaire",
        ar: "بونير",
    },
    {
        value: -400,
        prefix: "(GMT-04:00)",
        en: "British Virgin Islands",
        ko: "영국령 버진 아일랜드",
        sc: "英属维尔京群岛",
        es: "Islas Vírgenes Británicas",
        ru: "Британские Виргинские острова",
        ja: "イギリス領バージン諸島",
        fr: "Îles Vierges britanniques",
        de: "Britische Jungferninseln",
        it: "Isole Vergini Britanniche",
        th: "หมู่เกาะบริติชเวอร์จิน",
        id: "Kepulauan Virgin Inggris",
        vi: "Quần đảo British Virgin",
        nl: "Britse Maagdeneilanden",
        pl: "Brytyjskie Wyspy Dziewicze",
        nb: "De britiske jomfruøyene",
        fi: "Britannian Neitsytsaaret",
        ar: "جزر فيرجن البريطانية",
    },
    {
        value: -400,
        prefix: "(GMT-04:00)",
        en: "Caribbean Netherlands",
        ko: "카리브해 네덜란드",
        sc: "加勒比海荷兰",
        es: "Caribe neerlandés",
        ru: "Карибские Нидерланды",
        ja: "カリブ海オランダ",
        fr: "Pays-Bas caribéens",
        de: "Karibische Niederlande",
        it: "Paesi Bassi caraibici",
        th: "แคริบเบียนเนเธอร์แลนด์",
        id: "Karibia Belanda",
        vi: "Caribe Hà Lan",
        nl: "Caribisch Nederland",
        pl: "Karaiby Holandia",
        nb: "Karibiske Nederland",
        fi: "Karibian Alankomaat",
        ar: "هولندا الكاريبية",
    },
    {
        value: -400,
        prefix: "(GMT-04:00)",
        en: "Chile",
        ko: "칠레",
        sc: "智利",
        es: "Chile",
        ru: "Чили",
        ja: "チリ",
        fr: "Chili",
        de: "Chile",
        it: "Chile",
        th: "ชิลี",
        id: "Chili",
        vi: "Chile",
        nl: "Chili",
        pl: "Chile",
        nb: "Chile",
        fi: "Chile",
        ar: "تشيلي",
    },
    {
        value: -400,
        prefix: "(GMT-04:00)",
        en: "Curacao",
        ko: "큐라소",
        sc: "库拉索",
        es: "curazao",
        ru: "Кюрасао",
        ja: "キュラソー",
        fr: "Curacao",
        de: "Curacao",
        it: "Curacao",
        th: "คูราเซา",
        id: "Curacao",
        vi: "rượu cam bì",
        nl: "Curacao",
        pl: "Curaçao",
        nb: "Curacao",
        fi: "Curacao",
        ar: "كوراكاو",
    },
    {
        value: -400,
        prefix: "(GMT-04:00)",
        en: "Dominica",
        ko: "도미니카",
        sc: "多米尼克",
        es: "Dominica",
        ru: "Доминика",
        ja: "ドミニカ",
        fr: "Dominique",
        de: "Dominika",
        it: "Dominica",
        th: "โดมินิกา",
        id: "Dominika",
        vi: "Dominica",
        nl: "Dominica",
        pl: "Dominika",
        nb: "Dominica",
        fi: "Dominica",
        ar: "دومينيكا",
    },
    {
        value: -400,
        prefix: "(GMT-04:00)",
        en: "Dominican Republic",
        ko: "도미니카 공화국",
        sc: "多明尼加共和国",
        es: "República Dominicana",
        ru: "Доминиканская Респблика",
        ja: "ドミニカ共和国",
        fr: "République Dominicaine",
        de: "Dominikanische Republik",
        it: "Repubblica Dominicana",
        th: "สาธารณรัฐโดมินิกัน",
        id: "Republik Dominika",
        vi: "Cộng hòa Dominica",
        nl: "Dominicaanse Republiek",
        pl: "Republika Dominikany",
        nb: "den dominikanske republikk",
        fi: "Dominikaaninen tasavalta",
        ar: "جمهورية الدومينيكان",
    },
    {
        value: -400,
        prefix: "(GMT-04:00)",
        en: "Greenland, Thule Air Base",
        ko: "그린란드 툴레 공군기지",
        sc: "格陵兰，图勒空军基地",
        es: "Groenlandia, base aérea de Thule",
        ru: "Гренландия, авиабаза Туле",
        ja: "グリーンランド、トゥーレ空軍基地",
        fr: "Groenland, base aérienne de Thulé",
        de: "Grönland, Thule Air Base",
        it: "Groenlandia, base aerea di Thule",
        th: "กรีนแลนด์ ฐานทัพอากาศทูเล่",
        id: "Greenland, Pangkalan Udara Thule",
        vi: "Căn cứ không quân Greenland, Thule",
        nl: "Groenland, Thule Air Base",
        pl: "Grenlandia, baza lotnicza Thule",
        nb: "Grønland, Thule flybase",
        fi: "Grönlanti, Thulen lentotukikohta",
        ar: "جرينلاند ، قاعدة ثول الجوية",
    },
    {
        value: -400,
        prefix: "(GMT-04:00)",
        en: "Grenada",
        ko: "그레나다",
        sc: "格林纳达",
        es: "Granada",
        ru: "Гренада",
        ja: "グレナダ",
        fr: "Grenade",
        de: "Grenada",
        it: "Grenada",
        th: "เกรเนดา",
        id: "Grenada",
        vi: "Grenada",
        nl: "Grenada",
        pl: "Grenada",
        nb: "Grenada",
        fi: "Grenada",
        ar: "غرينادا",
    },
    {
        value: -400,
        prefix: "(GMT-04:00)",
        en: "Guadeloupe",
        ko: "과들루프",
        sc: "瓜德罗普",
        es: "Guadalupe",
        ru: "Гваделупа",
        ja: "グアドループ",
        fr: "Guadeloupe",
        de: "Guadeloupe",
        it: "Guadalupa",
        th: "กวาเดอลูป",
        id: "Guadeloupe",
        vi: "Guadeloupe",
        nl: "Guadeloupe",
        pl: "Gwadelupa",
        nb: "Guadeloupe",
        fi: "Guadeloupe",
        ar: "جوادلوب",
    },
    {
        value: -400,
        prefix: "(GMT-04:00)",
        en: "Guyana",
        ko: "가이아나",
        sc: "圭亚那",
        es: "Guayana",
        ru: "Гайана",
        ja: "ガイアナ",
        fr: "Guyane",
        de: "Guyana",
        it: "Guyana",
        th: "กายอานา",
        id: "Guyana",
        vi: "Guyana",
        nl: "Guyana",
        pl: "Gujana",
        nb: "Guyana",
        fi: "Guyana",
        ar: "غيانا",
    },
    {
        value: -400,
        prefix: "(GMT-04:00)",
        en: "Martinique",
        ko: "마르티니크",
        sc: "马提尼克岛",
        es: "Martinica",
        ru: "Мартиника",
        ja: "マルティニーク",
        fr: "Martinique",
        de: "Martinique",
        it: "Martinica",
        th: "มาร์ตินีก",
        id: "Martinik",
        vi: "Martinique",
        nl: "Martinique",
        pl: "Martynika",
        nb: "Martinique",
        fi: "Martinique",
        ar: "مارتينيك",
    },
    {
        value: -400,
        prefix: "(GMT-04:00)",
        en: "Mato Grosso do Sul, Brazil",
        ko: "마투그로수두술, 브라질",
        sc: "巴西南马托格罗索州",
        es: "Mato Grosso do Sul, Brasil",
        ru: "Мату-Гросу-ду-Сул, Бразилия",
        ja: "マトグロッソドスル、ブラジル",
        fr: "Mato Grosso do Sul, Brésil",
        de: "Mato Grosso do Sul, Brasilien",
        it: "Mato Grosso do Sul, Brasile",
        th: "มาตู กรอสโซ ดู ซูล บราซิล",
        id: "Mato Grosso do Sul, Brasil",
        vi: "Mato Grosso do Sul, Brazil",
        nl: "Mato Grosso do Sul, Brazilië",
        pl: "Mato Grosso do Sul, Brazylia",
        nb: "Mato Grosso do Sul, Brasil",
        fi: "Mato Grosso do Sul, Brasilia",
        ar: "ماتو جروسو دو سول ، البرازيل",
    },
    {
        value: -400,
        prefix: "(GMT-04:00)",
        en: "Mato Grosso, Brazil",
        ko: "브라질 마투 그로수",
        sc: "巴西马托格罗索",
        es: "Mato Grosso, Brasil",
        ru: "Мату-Гросу, Бразилия",
        ja: "マットグロッソ、ブラジル",
        fr: "Mato Grosso, Brésil",
        de: "Mato Grosso, Brasilien",
        it: "Mato Grosso, Brasile",
        th: "มาตู กรอสโซ่ บราซิล",
        id: "Mato Grosso, Brasil",
        vi: "Mato Grosso, Brazil",
        nl: "Mato Grosso, Brazilië",
        pl: "Mato Grosso, Brazylia",
        nb: "Mato Grosso, Brasil",
        fi: "Mato Grosso, Brasilia",
        ar: "ماتو جروسو ، البرازيل",
    },
    {
        value: -400,
        prefix: "(GMT-04:00)",
        en: "Montserrat",
        ko: "몬세라트",
        sc: "蒙特塞拉特",
        es: "Montserrat",
        ru: "Монтсеррат",
        ja: "モントセラト",
        fr: "Montserrat",
        de: "Montserrat",
        it: "Montserrat",
        th: "มอนต์เซอร์รัต",
        id: "Montserrat",
        vi: "Montserrat",
        nl: "Montserrat",
        pl: "Montserrat",
        nb: "Montserrat",
        fi: "Montserrat",
        ar: "مونتسيرات",
    },
    {
        value: -400,
        prefix: "(GMT-04:00)",
        en: "New Brunswick, Canada",
        ko: "뉴브런즈윅, 캐나다 ",
        sc: "加拿大新不伦瑞克",
        es: "Nuevo Brunswick, Canadá",
        ru: "Нью-Брансуик, Канада",
        ja: "ニューブランズウィック、カナダ",
        fr: "Nouveau-Brunswick, Canada",
        de: "Neubraunschweig, Kanada",
        it: "Nuovo Brunswick, Canada",
        th: "นิวบรันสวิก แคนาดา",
        id: "New Brunswick, Kanada",
        vi: "New Brunswick, Canada",
        nl: "New Brunswick, Canada",
        pl: "Nowy Brunszwik, Kanada",
        nb: "New Brunswick, Canada",
        fi: "New Brunswick, Kanada",
        ar: "نيو برونزويك ، كندا",
    },
    {
        value: -400,
        prefix: "(GMT-04:00)",
        en: "Newfoundland and Labrador (Labrador), Canada",
        ko: "뉴펀들랜드 래브라도(래브라도), 캐나다",
        sc: "加拿大纽芬兰和拉布拉多（拉布拉多）",
        es: "Terranova y Labrador (Labrador), Canadá",
        ru: "Ньюфаундленд и Лабрадор (Лабрадор), Канада",
        ja: "ニューファンドランド・ラブラドール（ラブラドール）、カナダ",
        fr: "Terre-Neuve-et-Labrador (Labrador), Canada",
        de: "Neufundland und Labrador (Labrador), Kanada",
        it: "Terranova e Labrador (Labrador), Canada",
        th: "รัฐนิวฟันด์แลนด์และแลบราดอร์ (ลาบราดอร์), แคนาดา",
        id: "Newfoundland dan Labrador (Labrador), Kanada",
        vi: "Newfoundland và Labrador (Labrador), Canada",
        nl: "Newfoundland en Labrador (Labrador), Canada",
        pl: "Nowa Fundlandia i Labrador (Labrador), Kanada",
        nb: "Newfoundland og Labrador (Labrador), Canada",
        fi: "Newfoundland ja Labrador (Labrador), Kanada",
        ar: "نيوفاوندلاند ولابرادور (لابرادور) ، كندا",
    },
    {
        value: -400,
        prefix: "(GMT-04:00)",
        en: "Nova Scotia, Canada",
        ko: "노바스코샤주, 캐나다",
        sc: "加拿大新斯科舍省",
        es: "Nueva Escocia, Canadá",
        ru: "Новая Шотландия, Канада",
        ja: "カナダ、ノバスコシア",
        fr: "Nouvelle-Écosse, Canada",
        de: "Nova Scotia, Kanada",
        it: "Nuova Scozia, Canada",
        th: "โนวาสโกเชีย แคนาดา",
        id: "Nova Scotia, Kanada",
        vi: "Nova Scotia, Canada",
        nl: "Nova Scotia, Canada",
        pl: "Nowa Szkocja, Kanada",
        nb: "Nova Scotia, Canada",
        fi: "Nova Scotia, Kanada",
        ar: "نوفا سكوشا ، كندا",
    },
    {
        value: -400,
        prefix: "(GMT-04:00)",
        en: "Paraguay",
        ko: "파라과이",
        sc: "巴拉圭",
        es: "Paraguay",
        ru: "Парагвай",
        ja: "パラグアイ",
        fr: "Paraguay",
        de: "Paraguay",
        it: "Paraguay",
        th: "ประเทศปารากวัย",
        id: "Paraguay",
        vi: "Paraguay",
        nl: "Paraguay",
        pl: "Paragwaj",
        nb: "Paraguay",
        fi: "Paraguay",
        ar: "باراغواي",
    },
    {
        value: -400,
        prefix: "(GMT-04:00)",
        en: "Prince Edward Island, Canada",
        ko: "프린스 에드워드 아일랜드, 캐나다 ",
        sc: "加拿大爱德华王子岛",
        es: "Isla del Príncipe Eduardo, Canadá",
        ru: "Остров Принца Эдуарда, Канада",
        ja: "プリンスエドワードアイランド、カナダ",
        fr: "Île-du-Prince-Édouard, Canada",
        de: "Prince Edward Island, Kanada",
        it: "Isola del Principe Edoardo, Canada",
        th: "เกาะปรินซ์เอ็ดเวิร์ด แคนาดา",
        id: "Pulau Pangeran Edward, Kanada",
        vi: "Đảo Hoàng tử Edward, Canada",
        nl: "Prins Edwardeiland, Canada",
        pl: "Wyspa Księcia Edwarda, Kanada",
        nb: "Prince Edward Island, Canada",
        fi: "Prinssi Edwardin saari, Kanada",
        ar: "جزيرة الأمير إدوارد ، كندا",
    },
    {
        value: -400,
        prefix: "(GMT-04:00)",
        en: "Puerto Rico",
        ko: "푸에르토 리코",
        sc: "波多黎各",
        es: "Puerto Rico",
        ru: "Пуэрто-Рико",
        ja: "プエルトリコ",
        fr: "Porto Rico",
        de: "Puerto Rico",
        it: "Portorico",
        th: "เปอร์โตริโก้",
        id: "Puerto Riko",
        vi: "Puerto Rico",
        nl: "Puerto Rico",
        pl: "Portoryko",
        nb: "Puerto Rico",
        fi: "Puerto Rico",
        ar: "بورتوريكو",
    },
    {
        value: -400,
        prefix: "(GMT-04:00)",
        en: "Roraima, Brazil",
        ko: "브라질 로라이마",
        sc: "巴西罗赖马",
        es: "Roraima, Brasil",
        ru: "Рорайма, Бразилия",
        ja: "ロライマ、ブラジル",
        fr: "Roraima, Brésil",
        de: "Roraima, Brasilien",
        it: "Roraima, Brasile",
        th: "โรไรมา บราซิล",
        id: "Roraima, Brasil",
        vi: "Roraima, Brazil",
        nl: "Roraima, Brazilië",
        pl: "Roraima, Brazylia",
        nb: "Roraima, Brasil",
        fi: "Roraima, Brasilia",
        ar: "رورايما ، البرازيل",
    },
    {
        value: -400,
        prefix: "(GMT-04:00)",
        en: "Rondonia, Brazil",
        ko: "브라질 론도니아",
        sc: "巴西朗多尼亚",
        es: "Rondonia, Brasil",
        ru: "Рондония, Бразилия",
        ja: "ロンドニア、ブラジル",
        fr: "Rondonie, Brésil",
        de: "Rondonia, Brasilien",
        it: "Rondonia, Brasile",
        th: "รอนโดเนีย บราซิล",
        id: "Rondonia, Brasil",
        vi: "Rondonia, Brazil",
        nl: "Rondonia, Brazilië",
        pl: "Rondonia, Brazylia",
        nb: "Rondonia, Brasil",
        fi: "Rondonia, Brasilia",
        ar: "روندونيا ، البرازيل",
    },
    {
        value: -400,
        prefix: "(GMT-04:00)",
        en: "Saba",
        ko: "사바섬",
        sc: "萨巴",
        es: "Isla de Saba",
        ru: "Саба",
        ja: "サバ島",
        fr: "Saba",
        de: "Saba",
        it: "Saba",
        th: "สะบ้า",
        id: "saba",
        vi: "Saba",
        nl: "Saba",
        pl: "Saba",
        nb: "Saba",
        fi: "Saba",
        ar: "سابا",
    },
    {
        value: -400,
        prefix: "(GMT-04:00)",
        en: "Saint Barthelemy",
        ko: "생 바르텔레미",
        sc: "圣巴泰勒米",
        es: "San Bartolomé",
        ru: "Сен-Бартельми",
        ja: "サンバルテルミー",
        fr: "Saint Barthélemy",
        de: "Heiliger Barthelemäus",
        it: "San Bartolomeo",
        th: "นักบุญบาร์เธเลมี",
        id: "Saint Barthelemy",
        vi: "Saint Barthelemy",
        nl: "Sint-Bartholomeus",
        pl: "Św Barthelemy",
        nb: "Saint Barthelemy",
        fi: "Saint Barthelemy",
        ar: "سانت بارتيليمي",
    },
    {
        value: -400,
        prefix: "(GMT-04:00)",
        en: "Saint Kitts and Nevis",
        ko: "세인트키츠 네비스",
        sc: "圣基茨和尼维斯",
        es: "San Cristóbal y Nieves",
        ru: "Сент-Китс и Невис",
        ja: "セントクリストファー・ネイビス",
        fr: "Saint-Christophe-et-Niévès",
        de: "St. Kitts und Nevis",
        it: "Saint Kitts e Nevis",
        th: "เซนต์คิตส์และเนวิส",
        id: "Saint Kitts dan Nevis",
        vi: "Saint Kitts và Nevis",
        nl: "Saint Kitts en Nevis",
        pl: "Saint Kitts i Nevis",
        nb: "Saint Kitts og Nevis",
        fi: "Saint Kitts ja Nevis",
        ar: "سانت كيتس ونيفيس",
    },
    {
        value: -400,
        prefix: "(GMT-04:00)",
        en: "Saint Lucia",
        ko: "세인트루시아",
        sc: "圣卢西亚",
        es: "Santa Lucía",
        ru: "Сент-Люсия",
        ja: "セントルシア",
        fr: "Sainte-Lucie",
        de: "St. Lucia",
        it: "Santa Lucia",
        th: "เซนต์ลูเซีย",
        id: "Saint Lucia",
        vi: "Saint Lucia",
        nl: "Sint Lucia",
        pl: "święta Lucia",
        nb: "Saint Lucia",
        fi: "Saint Lucia",
        ar: "القديسة لوسيا",
    },
    {
        value: -400,
        prefix: "(GMT-04:00)",
        en: "Saint Martin",
        ko: "세인트 마틴",
        sc: "圣马丁",
        es: "San Martín",
        ru: "Сен-Мартен",
        ja: "サンマルタン",
        fr: "Saint Martin",
        de: "Sankt Martin",
        it: "San Martino",
        th: "เซนต์มาร์ติน",
        id: "Saint Martin",
        vi: "Saint martin",
        nl: "Sint-Maarten",
        pl: "święty Marcin",
        nb: "Saint Martin",
        fi: "Pyhä Martin",
        ar: "القديس مارتن",
    },
    {
        value: -400,
        prefix: "(GMT-04:00)",
        en: "Saint Vincent and the Grenadines",
        ko: "세인트 빈센트 그레나딘",
        sc: "圣文森特和格林纳丁斯",
        es: "San Vicente y las Granadinas",
        ru: "Святой Винсент и Гренадины",
        ja: "セントビンセントおよびグレナディーン諸島",
        fr: "Saint-Vincent-et-les-Grenadines",
        de: "St. Vincent und die Grenadinen",
        it: "Saint Vincent e Grenadine",
        th: "เซนต์วินเซนต์และเกรนาดีนส์",
        id: "Saint Vincent dan Grenadines",
        vi: "Saint Vincent và Grenadines",
        nl: "Saint Vincent en de Grenadines",
        pl: "Saint Vincent i Grenadyny",
        nb: "Saint Vincent og Grenadinene",
        fi: "Saint Vincent ja Grenadiinit",
        ar: "سانت فنسنت وجزر غرينادين",
    },
    {
        value: -400,
        prefix: "(GMT-04:00)",
        en: "Sint Eustatius",
        ko: "성 유스타티우스",
        sc: "圣尤斯特歇斯",
        es: "San Eustaquio",
        ru: "Синт-Эстатиус",
        ja: "シントユースタティウス",
        fr: "Saint Eustache",
        de: "Sint Eustatius",
        it: "Sint Eustatius",
        th: "ซินต์เอิสทาทิอุส",
        id: "Sint Eustatius",
        vi: "Sint Eustatius",
        nl: "Sint Eustatius",
        pl: "Sint Eustatius",
        nb: "Sint Eustatius",
        fi: "Sint Eustatius",
        ar: "سينت يوستاتيوس",
    },
    {
        value: -400,
        prefix: "(GMT-04:00)",
        en: "Sint Maarten",
        ko: "세인트 마틴",
        sc: "圣马丁",
        es: "San Martín",
        ru: "Синт-Мартен",
        ja: "シントマールテン",
        fr: "Saint-Martin",
        de: "Sint Maarten",
        it: "Sint Maarten",
        th: "ซินต์มาร์เทิน",
        id: "Sint Maarten",
        vi: "Sint Maarten",
        nl: "Sint Maarten",
        pl: "Sint Maarten",
        nb: "Sint Maarten",
        fi: "Sint Maarten",
        ar: "سينت مارتن",
    },
    {
        value: -400,
        prefix: "(GMT-04:00)",
        en: "Trinidad and Tobago",
        ko: "트리니다드토바고",
        sc: "特立尼达和多巴哥",
        es: "Trinidad y Tobago",
        ru: "Тринидад и Тобаго",
        ja: "トリニダード・トバゴ",
        fr: "Trinité-et-Tobago",
        de: "Trinidad und Tobago",
        it: "Trinidad e Tobago",
        th: "ตรินิแดดและโตเบโก",
        id: "Trinidad dan Tobago",
        vi: "Trinidad và Tobago",
        nl: "Trinidad en Tobago",
        pl: "Trynidad i Tobago",
        nb: "Trinidad og Tobago",
        fi: "Trinidad ja Tobago",
        ar: "ترينداد وتوباغو",
    },
    {
        value: -400,
        prefix: "(GMT-04:00)",
        en: "Turks and Caicos Islands",
        ko: "터크스케이커스 제도",
        sc: "特克斯和凯科斯群岛",
        es: "Islas Turcas y Caicos",
        ru: "острова Теркс и Кайкос",
        ja: "タークス・カイコス諸島",
        fr: "îles Turques-et-Caïques",
        de: "Turks- und Caicosinseln",
        it: "Isole Turks e Caicos",
        th: "หมู่เกาะเติกส์และหมู่เกาะเคคอส",
        id: "Kepulauan Turks dan Caicos",
        vi: "Quần đảo Turks và Caicos",
        nl: "Turks- en Caicoseilanden",
        pl: "Wyspy Turks i Caicos",
        nb: "Turks- og Caicosøyene",
        fi: "Turks-ja Caicossaaret",
        ar: "جزر تركس وكايكوس",
    },
    {
        value: -400,
        prefix: "(GMT-04:00)",
        en: "US Virgin Islands",
        ko: "미국령 버진 아일랜드",
        sc: "美属维尔京群岛",
        es: "Islas Vírgenes de EE.UU",
        ru: "Виргинские острова США",
        ja: "アメリカ領バージン諸島",
        fr: "Îles Vierges américaines",
        de: "US Jungferninseln",
        it: "Isole Vergini americane",
        th: "หมู่เกาะเวอร์จินของสหรัฐอเมริกา",
        id: "Kepulauan Virgin AS",
        vi: "Quần đảo Virgin thuộc Hoa Kỳ",
        nl: "Amerikaanse Maagdeneilanden",
        pl: "Wyspy Dziewicze Stanów Zjednoczonych",
        nb: "De amerikanske jomfruøyene",
        fi: "Yhdysvaltain Neitsytsaaret",
        ar: "جزر فيرجن الأمريكية",
    },
    {
        value: -400,
        prefix: "(GMT-04:00)",
        en: "Venezuela",
        ko: "베네수엘라",
        sc: "委内瑞拉",
        es: "Venezuela",
        ru: "Венесуэла",
        ja: "ベネズエラ",
        fr: "Venezuela",
        de: "Venezuela",
        it: "Venezuela",
        th: "เวเนซุเอลา",
        id: "Venezuela",
        vi: "Venezuela",
        nl: "Venezuela",
        pl: "Wenezuela",
        nb: "Venezuela",
        fi: "Venezuela",
        ar: "فنزويلا",
    },
    {
        value: -400,
        prefix: "(GMT-04:00)",
        en: "Quebec (Blanc-Sablon), Canada",
        ko: "퀘벡(블렁-싸블롱), 캐나다",
        sc: "魁北克（布兰克-萨布隆），加拿大",
        es: "Québec (Blanc-Sablon), Canadá",
        ru: "Квебек (Блан-Саблон), Канада",
        ja: "ケベック（ブランサブロン）、カナダ",
        fr: "Québec (Blanc-Sablon), Canada",
        de: "Quebec (Blanc-Sablon), Kanada",
        it: "Quebec (Blanc-Sablon), Canada",
        th: "ควิเบก (Blanc-Sablon), แคนาดา",
        id: "Quebec (Blanc-Sablon), Kanada",
        vi: "Quebec (Blanc-Sablon), Canada",
        nl: "Quebec (Blanc-Sablon), Canada",
        pl: "Quebec (Blanc-Sablon), Kanada",
        nb: "Quebec (Blanc-Sablon), Canada",
        fi: "Quebec (Blanc-Sablon), Kanada",
        ar: "كيبيك (بلانك سابلون) ، كندا",
    },
    {
        value: -330,
        prefix: "(GMT-03:30)",
        en: "Newfoundland and Labrador (Newfoundland), Canada",
        ko: "뉴펀들랜드 및 래브라도(뉴펀들랜드), 캐나다",
        sc: "加拿大纽芬兰和拉布拉多（纽芬兰）",
        es: "Terranova y Labrador (Terranova), Canadá",
        ru: "Ньюфаундленд и Лабрадор (Ньюфаундленд), Канада",
        ja: "ニューファンドランド・ラブラドール州（ニューファンドランド）、カナダ",
        fr: "Terre-Neuve-et-Labrador (Terre-Neuve), Canada",
        de: "Neufundland und Labrador (Neufundland), Kanada",
        it: "Terranova e Labrador (Terranova), Canada",
        th: "รัฐนิวฟันด์แลนด์และแลบราดอร์ (เกาะนิวฟันด์แลนด์), แคนาดา",
        id: "Newfoundland dan Labrador (Newfoundland), Kanada",
        vi: "Newfoundland và Labrador (Newfoundland), Canada",
        nl: "Newfoundland en Labrador (Newfoundland), Canada",
        pl: "Nowa Fundlandia i Labrador (Nowa Fundlandia), Kanada",
        nb: "Newfoundland og Labrador (Newfoundland), Canada",
        fi: "Newfoundland ja Labrador (Newfoundland), Kanada",
        ar: "نيوفاوندلاند ولابرادور (نيوفاوندلاند) ، كندا",
    },
    {
        value: -300,
        prefix: "(GMT-03:00)",
        en: "Alagoas, Brazil",
        ko: "알라고아스, 브라질",
        sc: "巴西阿拉戈斯",
        es: "Alagoas, Brasil",
        ru: "Алагоас, Бразилия",
        ja: "アラゴアス、ブラジル",
        fr: "Alagoas, Brésil",
        de: "Alagoas, Brasilien",
        it: "Alagoas, Brasile",
        th: "อาลาโกอัส, บราซิล",
        id: "Alagoas, Brasil",
        vi: "Alagoas, Brazil",
        nl: "Alagoas, Brazilië",
        pl: "Alagoas, Brazylia",
        nb: "Alagoas, Brasil",
        fi: "Alagoas, Brasilia",
        ar: "ألاغواس ، البرازيل",
    },
    {
        value: -300,
        prefix: "(GMT-03:00)",
        en: "Amapa, Brazil",
        ko: "아마파, 브라질",
        sc: "巴西阿马帕",
        es: "Amapá, Brasil",
        ru: "Амапа, Бразилия",
        ja: "アマパ、ブラジル",
        fr: "Amapá, Brésil",
        de: "Amapá, Brasilien",
        it: "Amapa, Brasile",
        th: "รัฐอามาปา, บราซิล",
        id: "Amapa, Brasil",
        vi: "Amapa, Brazil",
        nl: "Amapa, Brazilië",
        pl: "Amapa, Brazylia",
        nb: "Amapa, Brasil",
        fi: "Amapa, Brasilia",
        ar: "أمابا ، البرازيل",
    },
    {
        value: -300,
        prefix: "(GMT-03:00)",
        en: "Argentina",
        ko: "아르헨티나",
        sc: "阿根廷",
        es: "Argentina",
        ru: "Аргентина",
        ja: "アルゼンチン",
        fr: "Argentine",
        de: "Argentinien",
        it: "Argentina",
        th: "อาร์เจนตินา",
        id: "Argentina",
        vi: "Argentina",
        nl: "Argentinië",
        pl: "Argentyna",
        nb: "Argentina",
        fi: "Argentiina",
        ar: "الأرجنتين",
    },
    {
        value: -300,
        prefix: "(GMT-03:00)",
        en: "Bahia, Brazil",
        ko: "바이아, 브라질",
        sc: "巴西巴伊亚",
        es: "Bahía, Brasil",
        ru: "Баия, Бразилия",
        ja: "バイーア州、ブラジル",
        fr: "Bahia, Brésil",
        de: "Bahía, Brasilien",
        it: "Bahia, Brasile",
        th: "บาเฮีย บราซิล",
        id: "Bahia, Brasil",
        vi: "Bahia, Brazil",
        nl: "Bahia, Brazilië",
        pl: "Bahia, Brazylia",
        nb: "Bahia, Brasil",
        fi: "Bahia, Brasilia",
        ar: "باهيا ، البرازيل",
    },
    {
        value: -300,
        prefix: "(GMT-03:00)",
        en: "Ceara, Brazil",
        ko: "세아라, 브라질",
        sc: "巴西塞阿拉",
        es: "Ceará, Brasil",
        ru: "Сеара, Бразилия",
        ja: "セアラ、ブラジル",
        fr: "Ceara, Brésil",
        de: "Ceara, Brasilien",
        it: "Ceará, Brasile",
        th: "รัฐเซอารา, บราซิล",
        id: "Ceara, Brasil",
        vi: "Ceara, Brazil",
        nl: "Ceará, Brazilië",
        pl: "Ceara, Brazylia",
        nb: "Ceara, Brasil",
        fi: "Ceara, Brasilia",
        ar: "سيارا ، البرازيل",
    },
    {
        value: -300,
        prefix: "(GMT-03:00)",
        en: "Chile, Magallanes Region",
        ko: "칠레, 마가야네스 지역",
        sc: "智利，麦哲伦地区",
        es: "Chile, Región de Magallanes",
        ru: "Чили, Магальянес",
        ja: "チリ、マガジャネス地域",
        fr: "Chili, région de Magallanes",
        de: "Chile, Region Magallanes",
        it: "Cile, regione di Magallanes",
        th: "ชิลี แคว้นมากายาเนส",
        id: "Chili, Wilayah Magallanes",
        vi: "Chile, Vùng Magallanes",
        nl: "Chili, regio Magallanes",
        pl: "Chile, Region Magallanes",
        nb: "Chile, Magallanes-regionen",
        fi: "Chile, Magallanesin alue",
        ar: "شيلي ، منطقة ماجالانيس",
    },
    {
        value: -300,
        prefix: "(GMT-03:00)",
        en: "Distrito Federal, Brazil",
        ko: "디스트리토, 브라질 연방",
        sc: "巴西联邦区",
        es: "Distrito Federal, Brasil",
        ru: "Федеральный округ, Бразилия",
        ja: "ブラジル連邦直轄区",
        fr: "District fédéral, Brésil",
        de: "Distrito Federal, Brasilien",
        it: "Distretto Federale, Brasile",
        th: "เฟเดอรัลดิสตริกต์, บราซิล",
        id: "Distrito Federal, Brasil",
        vi: "Liên bang Distrito, Brazil",
        nl: "Distrito Federal, Brazilië",
        pl: "Dystrykt Federalny, Brazylia",
        nb: "Distrito Federal, Brasil",
        fi: "Distrito Federal, Brasilia",
        ar: "ديستريتو فيدرال ، البرازيل",
    },
    {
        value: -300,
        prefix: "(GMT-03:00)",
        en: "Espirito Santo, Brazil",
        ko: "이스피리투산투 주, 브라질",
        sc: "巴西圣埃斯皮里图",
        es: "Espírito Santo, Brasil",
        ru: "Эспириту-Санту, Бразилия",
        ja: "エスピリトサント、ブラジル",
        fr: "Espirito Santo, Brésil",
        de: "Espírito Santo, Brasilien",
        it: "Espírito Santo, Brasile",
        th: "เอสปีรีตูซันตู บราซิล",
        id: "Espirito Santo, Brasil",
        vi: "Espirito Santo, Brazil",
        nl: "Espírito Santo, Brazilië",
        pl: "Espirito Santo, Brazylia",
        nb: "Espirito Santo, Brasil",
        fi: "Espirito Santo, Brasilia",
        ar: "اسبيريتو سانتو ، البرازيل",
    },
    {
        value: -300,
        prefix: "(GMT-03:00)",
        en: "Falkland Islands",
        ko: "포클랜드 제도",
        sc: "福克兰群岛",
        es: "Islas Malvinas",
        ru: "Фолклендские острова",
        ja: "フォークランド諸島",
        fr: "les îles Falkland",
        de: "Falkland Inseln",
        it: "Isole Falkland",
        th: "หมู่เกาะฟอล์กแลนด์",
        id: "Kepulauan Falkland",
        vi: "Quần đảo Falkland",
        nl: "Falkland Eilanden",
        pl: "Falklandy",
        nb: "Falklandsøyene",
        fi: "Falkland saaret",
        ar: "جزر فوكلاند",
    },
    {
        value: -300,
        prefix: "(GMT-03:00)",
        en: "French Guiana",
        ko: "프랑스령 기아나",
        sc: "法属圭亚那",
        es: "Guayana Francesa",
        ru: "Французская Гвиана",
        ja: "フランス領ギアナ",
        fr: "Guyane Française",
        de: "Französisch-Guayana",
        it: "Guiana francese",
        th: "เฟรนช์เกียนา",
        id: "Guyana Perancis",
        vi: "Guiana thuộc Pháp",
        nl: "Frans Guyana",
        pl: "Gujana Francuska",
        nb: "fransk Guyana",
        fi: "Ranskan Guayana",
        ar: "غيانا الفرنسية",
    },
    {
        value: -300,
        prefix: "(GMT-03:00)",
        en: "Goias, Brazil",
        ko: "고이아스, 브라질",
        sc: "巴西戈亚斯",
        es: "Goiás, Brasil",
        ru: "Гояс, Бразилия",
        ja: "ゴイアス、ブラジル",
        fr: "Goias, Brésil",
        de: "Goias, Brasilien",
        it: "Goia, Brasile",
        th: "โกยาส, บราซิล",
        id: "Goias, Brasil",
        vi: "Goias, Brazil",
        nl: "Goias, Brazilië",
        pl: "Goias, Brazylia",
        nb: "Goias, Brasil",
        fi: "Goias, Brasilia",
        ar: "جوياس ، البرازيل",
    },
    {
        value: -300,
        prefix: "(GMT-03:00)",
        en: "Greenland",
        ko: "그린란드",
        sc: "格陵兰",
        es: "Groenlandia",
        ru: "Гренландия",
        ja: "グリーンランド",
        fr: "Groenland",
        de: "Grönland",
        it: "Groenlandia",
        th: "กรีนแลนด์",
        id: "Greenland",
        vi: "Greenland",
        nl: "Groenland",
        pl: "Grenlandia",
        nb: "Grønland",
        fi: "Grönlanti",
        ar: "جرينلاند",
    },
    {
        value: -300,
        prefix: "(GMT-03:00)",
        en: "Maranhao, Brazil",
        ko: "마라냐오, 브라질",
        sc: "巴西马拉尼奥",
        es: "Maranhão, Brasil",
        ru: "Мараньян, Бразилия",
        ja: "ブラジル、マラニャン",
        fr: "Maranhão, Brésil",
        de: "Maranhao, Brasilien",
        it: "Maranhao, Brasile",
        th: "มารันเฮา บราซิล",
        id: "Maranhao, Brasil",
        vi: "Maranhao, Brazil",
        nl: "Maranho, Brazilië",
        pl: "Maranhao, Brazylia",
        nb: "Maranhao, Brasil",
        fi: "Maranhao, Brasilia",
        ar: "مارانهاو ، البرازيل",
    },
    {
        value: -300,
        prefix: "(GMT-03:00)",
        en: "Minas Gerais, Brazil",
        ko: "미나스 제라이스, 브라질",
        sc: "巴西米纳斯吉拉斯州",
        es: "Minas Gerais, Brasil",
        ru: "Минас-Жерайс, Бразилия",
        ja: "ミナスジェライス、ブラジル",
        fr: "Minas Gerais, Brésil",
        de: "Minas Gerais, Brasilien",
        it: "Minas Gerais, Brasile",
        th: "มินัสเชไรส์, บราซิล",
        id: "Minas Gerais, Brasil",
        vi: "Minas Gerais, Brazil",
        nl: "Minas Gerais, Brazilië",
        pl: "Minas Gerais, Brazylia",
        nb: "Minas Gerais, Brasil",
        fi: "Minas Gerais, Brasilia",
        ar: "ميناس جيرايس ، البرازيل",
    },
    {
        value: -300,
        prefix: "(GMT-03:00)",
        en: "Para, Brazil",
        ko: "파라, 브라질",
        sc: "帕拉，巴西",
        es: "Pará, Brasil",
        ru: "Пара, Бразилия",
        ja: "パラ、ブラジル",
        fr: "Pará, Brésil",
        de: "Para, Brasilien",
        it: "Para, Brasile",
        th: "รัฐปารา, บราซิล",
        id: "Para, Brasil",
        vi: "Para, Brazil",
        nl: "Para, Brazilië",
        pl: "Pará, Brazylia",
        nb: "Para, Brasil",
        fi: "Para, Brasilia",
        ar: "بارا ، البرازيل",
    },
    {
        value: -300,
        prefix: "(GMT-03:00)",
        en: "Paraiba, Brazil",
        ko: "파라이바, 브라질",
        sc: "巴西帕拉伊巴",
        es: "Paraíba, Brasil",
        ru: "Параиба, Бразилия",
        ja: "パライバ、ブラジル",
        fr: "Paraïba, Brésil",
        de: "Paraiba, Brasilien",
        it: "Paraiba, Brasile",
        th: "รัฐปาราอีบา, บราซิล",
        id: "Paraiba, Brasil",
        vi: "Paraiba, Brazil",
        nl: "Paraiba, Brazilië",
        pl: "Paraiba, Brazylia",
        nb: "Paraiba, Brasil",
        fi: "Paraiba, Brasilia",
        ar: "بارايبا ، البرازيل",
    },
    {
        value: -300,
        prefix: "(GMT-03:00)",
        en: "Parana, Brazil",
        ko: "파라나, 브라질",
        sc: "巴西巴拉那",
        es: "Paraná, Brasil",
        ru: "Парана, Бразилия",
        ja: "パラナ、ブラジル",
        fr: "Paraná, Brésil",
        de: "Parana, Brasilien",
        it: "Paranà, Brasile",
        th: "รัฐปารานา, บราซิล",
        id: "Parana, Brasil",
        vi: "Parana, Brazil",
        nl: "Paraná, Brazilië",
        pl: "Parana, Brazylia",
        nb: "Parana, Brasil",
        fi: "Parana, Brasilia",
        ar: "بارانا ، البرازيل",
    },
    {
        value: -300,
        prefix: "(GMT-03:00)",
        en: "Pernambuco, Brazil",
        ko: "페르남부쿠, 브라질",
        sc: "巴西伯南布哥",
        es: "Pernambuco, Brasil",
        ru: "Пернамбуку, Бразилия",
        ja: "ペルナンブコ、ブラジル",
        fr: "Pernambouc, Brésil",
        de: "Pernambuco, Brasilien",
        it: "Pernambuco, Brasile",
        th: "เปร์นัมบูโก, บราซิล",
        id: "Pernambuco, Brasil",
        vi: "Pernambuco, Brazil",
        nl: "Pernambuco, Brazilië",
        pl: "Pernambuco, Brazylia",
        nb: "Pernambuco, Brasil",
        fi: "Pernambuco, Brasilia",
        ar: "بيرنامبوكو ، البرازيل",
    },
    {
        value: -300,
        prefix: "(GMT-03:00)",
        en: "Piaui, Brazil",
        ko: "피아우이, 브라질",
        sc: "巴西皮奥伊",
        es: "Piauí, Brasil",
        ru: "Пиауи, Бразилия",
        ja: "ピアウイ、ブラジル",
        fr: "Piauí, Brésil",
        de: "Piauí, Brasilien",
        it: "Piaui, Brasile",
        th: "รัฐปีเอาอี, บราซิล",
        id: "Piaui, Brasil",
        vi: "Piaui, Brazil",
        nl: "Piaui, Brazilië",
        pl: "Piaui, Brazylia",
        nb: "Piaui, Brasil",
        fi: "Piaui, Brasilia",
        ar: "بياوي ، البرازيل",
    },
    {
        value: -300,
        prefix: "(GMT-03:00)",
        en: "Rio de Janeiro, Brazil",
        ko: "리우데자네이루, 브라질",
        sc: "巴西里约热内卢",
        es: "Rio de Janeiro, Brasil",
        ru: "Рио-де-Жанейро, Бразилия",
        ja: "リオデジャネイロ、ブラジル",
        fr: "Rio de Janeiro, Brésil",
        de: "Rio de Janeiro, Brasilien",
        it: "Rio de Janeiro, Brasile",
        th: "รีโอเดจาเนโร บราซิล",
        id: "Rio de Janeiro, Brasil",
        vi: "Rio de Janeiro, Brazil",
        nl: "Rio de Janeiro, Brazilië",
        pl: "Rio de Janeiro, Brazylia",
        nb: "Rio de Janeiro, Brasil",
        fi: "Rio de Janeiro, Brasilia",
        ar: "ريو دي جانيرو، البرازيل",
    },
    {
        value: -300,
        prefix: "(GMT-03:00)",
        en: "Rio Grande do Norte, Brazil",
        ko: "리오그란데두노르테, 브라질",
        sc: "巴西北里奥格兰德",
        es: "Río Grande del Norte, Brasil",
        ru: "Риу-Гранди-ду-Норти, Бразилия",
        ja: "リオグランデドノルテ、ブラジル",
        fr: "Rio Grande do Norte, Brésil",
        de: "Rio Grande do Norte, Brasilien",
        it: "Rio Grande do Norte, Brasile",
        th: "รีโอกรันดีดูนอร์เต บราซิล",
        id: "Rio Grande do Norte, Brasil",
        vi: "Rio Grande do Norte, Brazil",
        nl: "Rio Grande do Norte, Brazilië",
        pl: "Rio Grande do Norte, Brazylia",
        nb: "Rio Grande do Norte, Brasil",
        fi: "Rio Grande do Norte, Brasilia",
        ar: "ريو غراندي دو نورتي ، البرازيل",
    },
    {
        value: -300,
        prefix: "(GMT-03:00)",
        en: "Rio Grande do Sul, Brazil",
        ko: "리오그란데두술, 브라질",
        sc: "巴西南里奥格兰德",
        es: "Rio Grande do Sul, Brasil",
        ru: "Риу-Гранди-ду-Сул, Бразилия",
        ja: "リオグランデドスル、ブラジル",
        fr: "Rio Grande do Sul, Brésil",
        de: "Rio Grande do Sul, Brasilien",
        it: "Rio Grande do Sul, Brasile",
        th: "รีโอกรันดีดูซูล บราซิล",
        id: "Rio Grande do Sul, Brasil",
        vi: "Rio Grande do Sul, Brazil",
        nl: "Rio Grande do Sul, Brazilië",
        pl: "Rio Grande do Sul, Brazylia",
        nb: "Rio Grande do Sul, Brasil",
        fi: "Rio Grande do Sul, Brasilia",
        ar: "ريو غراندي دو سول ، البرازيل",
    },
    {
        value: -300,
        prefix: "(GMT-03:00)",
        en: "Saint Pierre and Miquelon",
        ko: "생 피에르와 미클롱",
        sc: "圣皮埃尔和密克隆",
        es: "San Pedro y Miquelón",
        ru: "Сен-Пьер и Микелон",
        ja: "サンピエール島とミクロン島",
        fr: "Saint-Pierre-et-Miquelon",
        de: "St. Pierre und Miquelon",
        it: "Saint Pierre e Miquelon",
        th: "แซงปีแยร์และมีเกอลง",
        id: "Saint Pierre dan Miquelon",
        vi: "Saint Pierre và Miquelon",
        nl: "Saint Pierre en Miquelon",
        pl: "Saint-Pierre i Miquelon",
        nb: "Saint Pierre og Miquelon",
        fi: "Saint Pierre ja Miquelon",
        ar: "سانت بيير وميكلون",
    },
    {
        value: -300,
        prefix: "(GMT-03:00)",
        en: "Santa Catarina, Brazil",
        ko: "산타 카타리나, 브라질",
        sc: "巴西圣卡塔琳娜",
        es: "Santa Catarina, Brasil",
        ru: "Санта-Катарина, Бразилия",
        ja: "サンタカタリーナ、ブラジル",
        fr: "Santa Catarina, Brésil",
        de: "Santa Catarina, Brasilien",
        it: "Santa Catarina, Brasile",
        th: "ซานตา กาตารีนา บราซิล",
        id: "Santa Catarina, Brasil",
        vi: "Santa Catarina, Brazil",
        nl: "Santa Catarina, Brazilië",
        pl: "Santa Catarina, Brazylia",
        nb: "Santa Catarina, Brasil",
        fi: "Santa Catarina, Brasilia",
        ar: "سانتا كاتارينا ، البرازيل",
    },
    {
        value: -300,
        prefix: "(GMT-03:00)",
        en: "Sergipe, Brazil",
        ko: "세르지페, 브라질",
        sc: "巴西塞尔希佩",
        es: "Sergipe, Brasil",
        ru: "Сержипи, Бразилия",
        ja: "セルジッペ、ブラジル",
        fr: "Sergipé, Brésil",
        de: "Sergipe, Brasilien",
        it: "Sergipe, Brasile",
        th: "รัฐแซร์จีปี, บราซิล",
        id: "Sergipe, Brasil",
        vi: "Sergipe, Brazil",
        nl: "Sergipe, Brazilië",
        pl: "Sergipe, Brazylia",
        nb: "Sergipe, Brasil",
        fi: "Sergipe, Brasilia",
        ar: "سيرغيبي ، البرازيل",
    },
    {
        value: -300,
        prefix: "(GMT-03:00)",
        en: "Sao Paulo, Brazil",
        ko: "상파울루, 브라질",
        sc: "巴西圣保罗",
        es: "São Paulo, Brasil",
        ru: "Сан-Паулу, Бразилия",
        ja: "サンパウロ、ブラジル",
        fr: "São Paulo, Brésil",
        de: "Sao Paulo, Brasilien",
        it: "San Paolo, Brasile",
        th: "เซาเปาโล บราซิล",
        id: "Sao Paulo, Brasil",
        vi: "São Paulo, Brazil",
        nl: "São Paulo, Brazilië",
        pl: "São Paulo, Brazylia",
        nb: "São Paulo, Brasil",
        fi: "Sao Paulo, Brasilia",
        ar: "ساو باولو، البرازيل",
    },
    {
        value: -300,
        prefix: "(GMT-03:00)",
        en: "Suriname",
        ko: "수리남",
        sc: "苏里南",
        es: "Surinam",
        ru: "Суринам",
        ja: "スリナム",
        fr: "Suriname",
        de: "Surinam",
        it: "Suriname",
        th: "ซูรินาเม",
        id: "Suriname",
        vi: "Suriname",
        nl: "Suriname",
        pl: "Surinam",
        nb: "Surinam",
        fi: "Suriname",
        ar: "سورينام",
    },
    {
        value: -300,
        prefix: "(GMT-03:00)",
        en: "Tocantins, Brazil",
        ko: "토칸틴, 브라질",
        sc: "巴西托坎廷斯",
        es: "Tocantins, Brasil",
        ru: "Токантинс, Бразилия",
        ja: "トカンティンス、ブラジル",
        fr: "Tocantins, Brésil",
        de: "Tocantins, Brasilien",
        it: "Tocantins, Brasile",
        th: "รัฐโตกังจิงช์, บราซิล",
        id: "Tocantins, Brasil",
        vi: "Tocantins, Brazil",
        nl: "Tocantins, Brazilië",
        pl: "Tocantins, Brazylia",
        nb: "Tocantins, Brasil",
        fi: "Tocantins, Brasilia",
        ar: "توكانتينز ، البرازيل",
    },
    {
        value: -300,
        prefix: "(GMT-03:00)",
        en: "Uruguay",
        ko: "우루과이",
        sc: "乌拉圭",
        es: "Uruguay",
        ru: "Уругвай",
        ja: "ウルグアイ",
        fr: "Uruguay",
        de: "Uruguay",
        it: "Uruguay",
        th: "อุรุกวัย",
        id: "Uruguay",
        vi: "Uruguay",
        nl: "Uruguay",
        pl: "Urugwaj",
        nb: "Uruguay",
        fi: "Uruguay",
        ar: "أوروغواي",
    },
    {
        value: -200,
        prefix: "(GMT-02:00)",
        en: "Fernando de Noronha, Brazil",
        ko: "페르난도 데 노로냐, 브라질",
        sc: "费尔南多·迪诺罗尼亚，巴西",
        es: "Fernando de Noronha, Brasil",
        ru: "Фернандо де Норонья, Бразилия",
        ja: "フェルナンドデノローニャ、ブラジル",
        fr: "Fernando de Noronha, Brésil",
        de: "Fernando de Noronha, Brasilien",
        it: "Fernando de Noronha, Brasile",
        th: "เฟร์นานโด เด โนรอนญา บราซิล",
        id: "Fernando de Noronha, Brasil",
        vi: "Fernando de Noronha, Brazil",
        nl: "Fernando de Noronha, Brazilië",
        pl: "Fernando de Noronha, Brazylia",
        nb: "Fernando de Noronha, Brasil",
        fi: "Fernando de Noronha, Brasilia",
        ar: "فرناندو دي نورونها ، البرازيل",
    },
    {
        value: -200,
        prefix: "(GMT-02:00)",
        en: "South Georgia Island ",
        ko: "사우스 조지아 섬",
        sc: "南乔治亚岛",
        es: "Isla Georgia del Sur",
        ru: "Остров Южная Джорджия",
        ja: "サウスジョージア島",
        fr: "Île de Géorgie du Sud",
        de: "Insel Südgeorgien",
        it: "Isola della Georgia del Sud",
        th: "เกาะเซาท์จอร์เจีย",
        id: "Pulau Georgia Selatan",
        vi: "Đảo Nam Georgia",
        nl: "Eiland van Zuid-Georgia",
        pl: "Georgia Południowa",
        nb: "Sør-Georgia-øya",
        fi: "Etelä-Georgian saari",
        ar: "جزيرة جورجيا الجنوبية",
    },
    {
        value: -200,
        prefix: "(GMT-02:00)",
        en: "Trindade, Brazil",
        ko: "트린다데, 브라질",
        sc: "巴西特林达德",
        es: "Trinidad, Brasil",
        ru: "Триндади, Бразилия",
        ja: "トリンダーデ、ブラジル",
        fr: "Trindade, Brésil",
        de: "Trindade, Brasilien",
        it: "Trindade, Brasile",
        th: "Trindade, บราซิล",
        id: "Trindade, Brasil",
        vi: "Trindade, Brazil",
        nl: "Trindade, Brazilië",
        pl: "Trindade, Brazylia",
        nb: "Trindade, Brasil",
        fi: "Trindade, Brasilia",
        ar: "ترينداد ، البرازيل",
    },
    {
        value: -100,
        prefix: "(GMT-01:00)",
        en: "Cabo Verde",
        ko: "카보 베르데",
        sc: "佛得角",
        es: "Cabo Verde",
        ru: "Кабо-Верде",
        ja: "カーボベルデ",
        fr: "Cap-Vert",
        de: "Cabo Verde",
        it: "Capo Verde",
        th: "ประเทศกาบูเวร์ดี",
        id: "Cabo Verde",
        vi: "Cabo Verde",
        nl: "Kaapverdië",
        pl: "Cabo Verde",
        nb: "Cabo Verde",
        fi: "Cabo Verde",
        ar: "كابو فيردي",
    },
    {
        value: -100,
        prefix: "(GMT-01:00)",
        en: "Greenland, Ittoqqortoormiit",
        ko: "그린란드, 이토코르토르미우트",
        sc: "格陵兰岛，伊托克图尔米特",
        es: "Groenlandia, Ittoqqortoormiit",
        ru: "Гренландия, Иттоккортоормиит",
        ja: "グリーンランド、イットコルトールミート",
        fr: "Groenland, Ittoqqortoormiit",
        de: "Grönland, Ittoqqortoormiit",
        it: "Groenlandia, Ittoqqortoormiit",
        th: "กรีนแลนด์ อิตต็อกคอร์ทูร์มิต",
        id: "Greenland, Ittoqqortoormiit",
        vi: "Greenland, Ittoqqortoormiit",
        nl: "Groenland, Ittoqqortoormiit",
        pl: "Grenlandia, Ittoqqortoormiit",
        nb: "Grønland, Ittoqqortoormiit",
        fi: "Grönlanti, Ittoqqortoormiit",
        ar: "جرينلاند ، Ittoqqortoormiit",
    },
    {
        value: -100,
        prefix: "(GMT-01:00)",
        en: "Portugal, Azores",
        ko: "포르투갈, 아조레스 제도",
        sc: "葡萄牙、亚速尔群岛",
        es: "Portugal, Azores",
        ru: "Португалия, Азорские острова",
        ja: "ポルトガル、アゾレス諸島",
        fr: "Portugal, Açores",
        de: "Portugal, Azoren",
        it: "Portogallo, Azzorre",
        th: "โปรตุเกส, อะซอเรส",
        id: "Portugal, Azores",
        vi: "Bồ Đào Nha, Azores",
        nl: "Portugal, Azoren",
        pl: "Portugalia, Azory",
        nb: "Portugal, Azorene",
        fi: "Portugali, Azorit",
        ar: "البرتغال ، جزر الأزور",
    },
    {
        value: 0,
        prefix: "(GMT±00:00)",
        en: "Ascension Island",
        ko: "아센시온 아일랜드",
        sc: "阿森松岛",
        es: "Isla Ascensión",
        ru: "Остров Вознесения",
        ja: "アセンション島",
        fr: "Île de l'Ascension",
        de: "Himmelfahrtsinsel",
        it: "Isola dell'Ascensione",
        th: "เกาะอัสเซนชัน",
        id: "Pulau Ascension",
        vi: "Đảo Ascension",
        nl: "Hemelvaart Eiland",
        pl: "Wyspa Wniebowstąpienia",
        nb: "Ascension Island",
        fi: "Ascension Island",
        ar: "جزيرة أسنسيون",
    },
    {
        value: 0,
        prefix: "(GMT±00:00)",
        en: "Burkina Faso",
        ko: "부키 나 파소",
        sc: "布基纳法索",
        es: "Burkina Faso",
        ru: "Буркина-Фасо",
        ja: "ブルキナファソ",
        fr: "Burkina Faso",
        de: "Burkina Faso",
        it: "Burkina Faso",
        th: "บูร์กินาฟาโซ",
        id: "Burkina Faso",
        vi: "Burkina Faso",
        nl: "Burkina Faso",
        pl: "Burkina Faso",
        nb: "Burkina Faso",
        fi: "Burkina Faso",
        ar: "بوركينا فاسو",
    },
    {
        value: 0,
        prefix: "(GMT±00:00)",
        en: "Cote d'Ivoire",
        ko: "코트디부아르",
        sc: "科特迪瓦",
        es: "Costa de Marfil",
        ru: "Кот-д’Ивуар",
        ja: "コートジボワール",
        fr: "Côte d'Ivoire",
        de: "Elfenbeinküste",
        it: "Costa d'Avorio",
        th: "ประเทศโกตดิวัวร์",
        id: "Pantai Gading",
        vi: "Bờ Biển Ngà",
        nl: "Ivoorkust",
        pl: "Wybrzeże Kości Słoniowej",
        nb: "Elfenbenskysten",
        fi: "Norsunluurannikko",
        ar: "كوت ديفوار",
    },
    {
        value: 0,
        prefix: "(GMT±00:00)",
        en: "Faroe Islands",
        ko: "페로 제도",
        sc: "法罗群岛",
        es: "Islas Faroe",
        ru: "Фарерские острова",
        ja: "フェロー諸島",
        fr: "Îles Féroé",
        de: "Färöer Inseln",
        it: "Isole Faroe",
        th: "หมู่เกาะแฟโร",
        id: "Kepulauan Faroe",
        vi: "Quần đảo Faroe",
        nl: "Faeröer",
        pl: "Wyspy Owcze",
        nb: "Færøyene",
        fi: "Färsaaret",
        ar: "جزر فاروس",
    },
    {
        value: 0,
        prefix: "(GMT±00:00)",
        en: "Gambia",
        ko: "감비아",
        sc: "冈比亚",
        es: "Gambia",
        ru: "Гамбия",
        ja: "ガンビア",
        fr: "Gambie",
        de: "Gambia",
        it: "Gambia",
        th: "แกมเบีย",
        id: "Gambia",
        vi: "Gambia",
        nl: "Gambia",
        pl: "Gambia",
        nb: "Gambia",
        fi: "Gambia",
        ar: "غامبيا",
    },
    {
        value: 0,
        prefix: "(GMT±00:00)",
        en: "Ghana",
        ko: "가나",
        sc: "加纳",
        es: "Ghana",
        ru: "Гана",
        ja: "ガーナ",
        fr: "Ghana",
        de: "Ghana",
        it: "Ghana",
        th: "กานา",
        id: "Ghana",
        vi: "Ghana",
        nl: "Ghana",
        pl: "Ghana",
        nb: "Ghana",
        fi: "Ghana",
        ar: "غانا",
    },
    {
        value: 0,
        prefix: "(GMT±00:00)",
        en: "Greenland",
        ko: "그린란드",
        sc: "格陵兰",
        es: "Groenlandia",
        ru: "Гренландия",
        ja: "グリーンランド",
        fr: "Groenland",
        de: "Grönland",
        it: "Groenlandia",
        th: "กรีนแลนด์",
        id: "Greenland",
        vi: "Greenland",
        nl: "Groenland",
        pl: "Grenlandia",
        nb: "Grønland",
        fi: "Grönlanti",
        ar: "جرينلاند",
    },
    {
        value: 0,
        prefix: "(GMT±00:00)",
        en: "Guernsey",
        ko: "건지",
        sc: "根西岛",
        es: "Guernesey",
        ru: "Гернси",
        ja: "ガーンジー",
        fr: "Guernesey",
        de: "Guernsey",
        it: "Guernsey",
        th: "เกิร์นซีย์",
        id: "Guernsey",
        vi: "Guernsey",
        nl: "Guernsey",
        pl: "Guernsey",
        nb: "Guernsey",
        fi: "Guernseyssä",
        ar: "غيرنسي",
    },
    {
        value: 0,
        prefix: "(GMT±00:00)",
        en: "Guinea",
        ko: "기니",
        sc: "几内亚",
        es: "Guinea",
        ru: "Гвинея",
        ja: "ギニア",
        fr: "Guinée",
        de: "Guinea",
        it: "Guinea",
        th: "กินี",
        id: "Guinea",
        vi: "Guinea",
        nl: "Guinea",
        pl: "Gwinea",
        nb: "Guinea",
        fi: "Guinea",
        ar: "غينيا",
    },
    {
        value: 0,
        prefix: "(GMT±00:00)",
        en: "Guinea-Bissau",
        ko: "기니비사우",
        sc: "几内亚比绍",
        es: "Guinea-Bisáu",
        ru: "Гвинея-Бисау",
        ja: "ギニアビサウ",
        fr: "Guinée-Bissau",
        de: "Guinea-Bissau",
        it: "Guinea Bissau",
        th: "กินี-บิสเซา",
        id: "Guinea-Bissau",
        vi: "Guinea-Bissau",
        nl: "Guinee-Bissau",
        pl: "Gwinea Bissau",
        nb: "Guinea-Bissau",
        fi: "Guinea-Bissau",
        ar: "غينيا بيساو",
    },
    {
        value: 0,
        prefix: "(GMT±00:00)",
        en: "Iceland",
        ko: "아이슬란드",
        sc: "冰岛",
        es: "Islandia",
        ru: "Исландия",
        ja: "アイスランド",
        fr: "Islande",
        de: "Island",
        it: "Islanda",
        th: "ไอซ์แลนด์",
        id: "Islandia",
        vi: "Nước Iceland",
        nl: "IJsland",
        pl: "Islandia",
        nb: "Island",
        fi: "Islanti",
        ar: "أيسلندا",
    },
    {
        value: 0,
        prefix: "(GMT±00:00)",
        en: "Ireland",
        ko: "아일랜드",
        sc: "爱尔兰",
        es: "Irlanda",
        ru: "Ирландия",
        ja: "アイルランド",
        fr: "Irlande",
        de: "Irland",
        it: "Irlanda",
        th: "ไอร์แลนด์",
        id: "Irlandia",
        vi: "Ailen",
        nl: "Ierland",
        pl: "Irlandia",
        nb: "Irland",
        fi: "Irlanti",
        ar: "أيرلندا",
    },
    {
        value: 0,
        prefix: "(GMT±00:00)",
        en: "Isle of Man",
        ko: "맨 섬",
        sc: "马恩岛",
        es: "Isla del hombre",
        ru: "Остров Мэн",
        ja: "マン島",
        fr: "île de Man",
        de: "Isle of Man",
        it: "Isola di Man",
        th: "เกาะแมน",
        id: "Pulau Man",
        vi: "Đảo Man",
        nl: "eiland Man",
        pl: "Wyspa Man",
        nb: "Isle of Man",
        fi: "Mansaari",
        ar: "جزيرة آيل أوف مان",
    },
    {
        value: 0,
        prefix: "(GMT±00:00)",
        en: "Jersey",
        ko: "저지",
        sc: "澤西",
        es: "Jersey",
        ru: "Джерси",
        ja: "ジャージー",
        fr: "Jersey",
        de: "Jersey",
        it: "Baliato di Jersey",
        th: "เจอร์ซีย์",
        id: "Jersey",
        vi: "Jersey",
        nl: "Jersey",
        pl: "Jersey",
        nb: "Jersey",
        fi: "Jersey",
        ar: "جيرسي",
    },
    {
        value: 0,
        prefix: "(GMT±00:00)",
        en: "Liberia",
        ko: "라이베리아",
        sc: "利比里亚",
        es: "Liberia",
        ru: "Либерия",
        ja: "リベリア",
        fr: "Libéria",
        de: "Liberia",
        it: "Liberia",
        th: "ไลบีเรีย",
        id: "Liberia",
        vi: "Liberia",
        nl: "Liberia",
        pl: "Liberia",
        nb: "Liberia",
        fi: "Liberia",
        ar: "ليبيريا",
    },
    {
        value: 0,
        prefix: "(GMT±00:00)",
        en: "Mali",
        ko: "말리",
        sc: "马里",
        es: "Malí",
        ru: "Мали",
        ja: "マリ",
        fr: "Mali",
        de: "Mali",
        it: "Mali",
        th: "มาลี",
        id: "mali",
        vi: "Mali",
        nl: "Mali",
        pl: "Mali",
        nb: "Mali",
        fi: "Mali",
        ar: "مالي",
    },
    {
        value: 0,
        prefix: "(GMT±00:00)",
        en: "Mauritania",
        ko: "모리타니",
        sc: "毛里塔尼亚",
        es: "Mauritania",
        ru: "Мавритания",
        ja: "モーリタニア",
        fr: "Mauritanie",
        de: "Mauretanien",
        it: "Mauritania",
        th: "มอริเตเนีย",
        id: "Mauritania",
        vi: "Mauritania",
        nl: "Mauritanië",
        pl: "Mauretania",
        nb: "Mauritania",
        fi: "Mauritania",
        ar: "موريتانيا",
    },
    {
        value: 0,
        prefix: "(GMT±00:00)",
        en: "Portugal, main territory",
        ko: "포르투갈, 주요 영토",
        sc: "葡萄牙，主要领土",
        es: "Portugal, territorio principal",
        ru: "Португалия, основная территория",
        ja: "ポルトガル、主要な領土",
        fr: "Portugal, territoire principal",
        de: "Portugal, Hauptgebiet",
        it: "Portogallo, territorio principale",
        th: "โปรตุเกส ดินแดนหลัก",
        id: "Portugal, wilayah utama",
        vi: "Bồ Đào Nha, lãnh thổ chính",
        nl: "Portugal, hoofdgebied",
        pl: "Portugalia, główne terytorium",
        nb: "Portugal, hovedterritorium",
        fi: "Portugali, pääalue",
        ar: "البرتغال ، الإقليم الرئيسي",
    },
    {
        value: 0,
        prefix: "(GMT±00:00)",
        en: "Saint Helena",
        ko: "세인트 헬레나",
        sc: "圣赫勒拿",
        es: "Santa Elena",
        ru: "Святая Елена",
        ja: "セントヘレナ",
        fr: "Sainte-Hélène",
        de: "Heilige Helena",
        it: "Sant'Elena",
        th: "เซนต์เฮเลนา",
        id: "Saint Helena",
        vi: "Saint Helena",
        nl: "Sint Helena",
        pl: "Święta Helena",
        nb: "Saint Helena",
        fi: "Pyhä Helena",
        ar: "سانت هيلانة",
    },
    {
        value: 0,
        prefix: "(GMT±00:00)",
        en: "Sao Tome and Principe",
        ko: "상투메프린시페",
        sc: "圣多美和普林西比",
        es: "Santo Tomé y Príncipe",
        ru: "Сан-Томе и Принсипи",
        ja: "サントメ・プリンシペ",
        fr: "Sao Tomé et Principe",
        de: "Sao Tome und Principe",
        it: "Sao Tomé e Principe",
        th: "เซาตูเมและปรินซิปี",
        id: "Sao Tome dan Principe",
        vi: "Sao Tome và Principe",
        nl: "Sao Tomé en Principe",
        pl: "Wyspy Świętego Tomasza i Książęca",
        nb: "Sao Tome og Principe",
        fi: "Sao Tome ja Principe",
        ar: "ساو تومي وبرينسيبي",
    },
    {
        value: 0,
        prefix: "(GMT±00:00)",
        en: "Senegal",
        ko: "세네갈",
        sc: "塞内加尔",
        es: "Senegal",
        ru: "Сенегал",
        ja: "セネガル",
        fr: "Sénégal",
        de: "Senegal",
        it: "Senegal",
        th: "เซเนกัล",
        id: "Senegal",
        vi: "Senegal",
        nl: "Senegal",
        pl: "Senegal",
        nb: "Senegal",
        fi: "Senegal",
        ar: "السنغال",
    },
    {
        value: 0,
        prefix: "(GMT±00:00)",
        en: "Sierra Leone",
        ko: "시에라리온",
        sc: "塞拉利昂",
        es: "Sierra Leona",
        ru: "Сьерра-Леоне",
        ja: "シエラレオネ",
        fr: "Sierra Leone",
        de: "Sierra Leone",
        it: "Sierra Leone",
        th: "เซียร์ราลีโอน",
        id: "Sierra Leone",
        vi: "Sierra Leone",
        nl: "Sierra Leone",
        pl: "Sierra Leone",
        nb: "Sierra Leone",
        fi: "Sierra Leone",
        ar: "سيرا ليون",
    },
    {
        value: 0,
        prefix: "(GMT±00:00)",
        en: "Spain, Canary Islands",
        ko: "스페인, 카나리아 제도",
        sc: "西班牙、加那利群岛",
        es: "España, Islas Canarias",
        ru: "Испания, Канарские острова",
        ja: "スペイン、カナリア諸島",
        fr: "Espagne, Îles Canaries",
        de: "Spanien, Kanarische Inseln",
        it: "Spagna, Isole Canarie",
        th: "สเปน, หมู่เกาะคะเนรี",
        id: "Spanyol, Kepulauan Canary",
        vi: "Tây Ban Nha, quần đảo Canary",
        nl: "Spanje, Canarische Eilanden",
        pl: "Hiszpania, Wyspy Kanaryjskie",
        nb: "Spania, Kanariøyene",
        fi: "Espanja, Kanariansaaret",
        ar: "إسبانيا ، جزر الكناري",
    },
    {
        value: 0,
        prefix: "(GMT±00:00)",
        en: "Togo",
        ko: "토고",
        sc: "多哥",
        es: "Togo",
        ru: "Того",
        ja: "トーゴ",
        fr: "Togo",
        de: "Togo",
        it: "Togo",
        th: "ประเทศโตโก",
        id: "Togo",
        vi: "Togo",
        nl: "Togo",
        pl: "Togo",
        nb: "Togo",
        fi: "Togo",
        ar: "توجو",
    },
    {
        value: 0,
        prefix: "(GMT±00:00)",
        en: "Tristan da Cunha",
        ko: "트리스탄 다 쿠냐",
        sc: "特里斯坦达库尼亚",
        es: "Tristán da Cunha",
        ru: "Тристан-да-Кунья",
        ja: "トリスタンダクーニャ",
        fr: "Tristan de Cunha",
        de: "Tristan da Cunha",
        it: "Tristano da Cunha",
        th: "ทริสตัน ดา กุนยา",
        id: "Tristan da Cunha",
        vi: "Tristan da Cunha",
        nl: "Tristan da Cunha",
        pl: "Tristan da Cunha",
        nb: "Tristan da Cunha",
        fi: "Tristan da Cunha",
        ar: "تريستان دا كونها",
    },
    {
        value: 0,
        prefix: "(GMT±00:00)",
        en: "United Kingdom",
        ko: "영국",
        sc: "英国",
        es: "Reino Unido",
        ru: "Соединенное Королевство",
        ja: "イギリス",
        fr: "Royaume-Uni",
        de: "Vereinigtes Königreich",
        it: "Regno Unito",
        th: "ประเทศอังกฤษ",
        id: "Britania Raya",
        vi: "Vương quốc Anh",
        nl: "Verenigd Koninkrijk",
        pl: "Zjednoczone Królestwo",
        nb: "Storbritannia",
        fi: "Yhdistynyt kuningaskunta",
        ar: "المملكة المتحدة",
    },
    {
        value: 100,
        prefix: "(GMT+01:00)",
        en: "Albania",
        ko: "알바니아",
        sc: "阿尔巴尼亚",
        es: "Albania",
        ru: "Албания",
        ja: "アルバニア",
        fr: "Albanie",
        de: "Albanien",
        it: "Albania",
        th: "แอลเบเนีย",
        id: "Albania",
        vi: "Albania",
        nl: "Albanië",
        pl: "Albania",
        nb: "Albania",
        fi: "Albania",
        ar: "ألبانيا",
    },
    {
        value: 100,
        prefix: "(GMT+01:00)",
        en: "Algeria",
        ko: "알제리",
        sc: "阿尔及利亚",
        es: "Argelia",
        ru: "Алжир",
        ja: "アルジェリア",
        fr: "Algérie",
        de: "Algerien",
        it: "Algeria",
        th: "แอลจีเรีย",
        id: "Aljazair",
        vi: "Algeria",
        nl: "Algerije",
        pl: "Algieria",
        nb: "Algerie",
        fi: "Algeria",
        ar: "الجزائر",
    },
    {
        value: 100,
        prefix: "(GMT+01:00)",
        en: "Andorra",
        ko: "안도라",
        sc: "安道尔",
        es: "Andorra",
        ru: "Андорра",
        ja: "アンドラ",
        fr: "Andorre",
        de: "Andorra",
        it: "Andorra",
        th: "อันดอร์รา",
        id: "andora",
        vi: "Andorra",
        nl: "Andorra",
        pl: "Andora",
        nb: "Andorra",
        fi: "Andorra",
        ar: "أندورا",
    },
    {
        value: 100,
        prefix: "(GMT+01:00)",
        en: "Angola",
        ko: "앙골라",
        sc: "安哥拉",
        es: "angola",
        ru: "Ангола",
        ja: "アンゴラ",
        fr: "Angola",
        de: "Angola",
        it: "Angola",
        th: "แองโกลา",
        id: "Angola",
        vi: "Angola",
        nl: "Angola",
        pl: "Angola",
        nb: "Angola",
        fi: "Angola",
        ar: "أنغولا",
    },
    {
        value: 100,
        prefix: "(GMT+01:00)",
        en: "Austria",
        ko: "오스트리아",
        sc: "奥地利",
        es: "Austria",
        ru: "Австрия",
        ja: "オーストリア",
        fr: "L'Autriche",
        de: "Österreich",
        it: "Austria",
        th: "ออสเตรีย",
        id: "Austria",
        vi: "Áo",
        nl: "Oostenrijk",
        pl: "Austria",
        nb: "Østerrike",
        fi: "Itävalta",
        ar: "النمسا",
    },
    {
        value: 100,
        prefix: "(GMT+01:00)",
        en: "Belgium",
        ko: "벨기에",
        sc: "比利时",
        es: "Bélgica",
        ru: "Бельгия",
        ja: "ベルギー",
        fr: "Belgique",
        de: "Belgien",
        it: "Belgio",
        th: "เบลเยียม",
        id: "Belgium",
        vi: "nước Bỉ",
        nl: "België",
        pl: "Belgia",
        nb: "Belgia",
        fi: "Belgia",
        ar: "بلجيكا",
    },
    {
        value: 100,
        prefix: "(GMT+01:00)",
        en: "Benin",
        ko: "베냉",
        sc: "贝宁",
        es: "Benín",
        ru: "Бенин",
        ja: "ベナン",
        fr: "Bénin",
        de: "Benin",
        it: "Benin",
        th: "เบนิน",
        id: "Benin",
        vi: "Benin",
        nl: "Benin",
        pl: "Benin",
        nb: "Benin",
        fi: "Benin",
        ar: "بنين",
    },
    {
        value: 100,
        prefix: "(GMT+01:00)",
        en: "Bosnia and Herzegovina",
        ko: "보스니아 헤르체고비나",
        sc: "波斯尼亚和黑塞哥维那",
        es: "Bosnia y Herzegovina",
        ru: "Босния и Герцеговина",
        ja: "ボスニア・ヘルツェゴビナ",
        fr: "Bosnie Herzégovine",
        de: "Bosnien und Herzegowina",
        it: "Bosnia Erzegovina",
        th: "บอสเนียและเฮอร์เซโก",
        id: "Bosnia dan Herzegovina",
        vi: "Bosnia và Herzegovina",
        nl: "Bosnië-Herzegovina",
        pl: "Bośnia i Hercegowina",
        nb: "Bosnia og Herzegovina",
        fi: "Bosnia ja Hertsegovina",
        ar: "البوسنة والهرسك",
    },
    {
        value: 100,
        prefix: "(GMT+01:00)",
        en: "Cameroon",
        ko: "카메룬",
        sc: "喀麦隆",
        es: "Camerún",
        ru: "Камерун",
        ja: "カメルーン",
        fr: "Cameroun",
        de: "Kamerun",
        it: "Camerun",
        th: "แคเมอรูน",
        id: "Kamerun",
        vi: "Cameroon",
        nl: "Kameroen",
        pl: "Kamerun",
        nb: "Kamerun",
        fi: "Kamerun",
        ar: "الكاميرون",
    },
    {
        value: 100,
        prefix: "(GMT+01:00)",
        en: "Central African Republic",
        ko: "중앙 아프리카 공화국",
        sc: "中非共和国",
        es: "República Centroafricana",
        ru: "Центрально-Африканская Республика",
        ja: "中央アフリカ共和国",
        fr: "République centrafricaine",
        de: "Zentralafrikanische Republik",
        it: "Repubblica Centrafricana",
        th: "สาธารณรัฐแอฟริกากลาง",
        id: "Republik Afrika Tengah",
        vi: "Cộng hòa trung phi",
        nl: "Centraal Afrikaanse Republiek",
        pl: "Republika Środkowoafrykańska",
        nb: "Den sentralafrikanske republikk",
        fi: "Keski-Afrikan tasavalta",
        ar: "جمهورية افريقيا الوسطى",
    },
    {
        value: 100,
        prefix: "(GMT+01:00)",
        en: "Chad",
        ko: "차드",
        sc: "乍得",
        es: "Chad",
        ru: "Чад",
        ja: "チャド",
        fr: "Tchad",
        de: "Tschad",
        it: "Chad",
        th: "ประเทศชาด",
        id: "Chad",
        vi: "Chad",
        nl: "Tsjaad",
        pl: "Czad",
        nb: "Tsjad",
        fi: "Tšad",
        ar: "تشاد",
    },
    {
        value: 100,
        prefix: "(GMT+01:00)",
        en: "Congo, Republic of the",
        ko: "콩고 공화국",
        sc: "刚果共和国",
        es: "Congo, República del",
        ru: "Конго, Республика",
        ja: "コンゴ共和国",
        fr: "Congo, République du",
        de: "Kongo, Republik der",
        it: "Congo, Repubblica del",
        th: "คองโก สาธารณรัฐ",
        id: "Kongo, Republik",
        vi: "Congo, Cộng hòa",
        nl: "Congo, Republiek der",
        pl: "Kongo, Republika",
        nb: "Kongo, republikken",
        fi: "Kongon tasavalta",
        ar: "جمهورية الكونغو",
    },
    {
        value: 100,
        prefix: "(GMT+01:00)",
        en: "Congo, Democratic Republic of, western part",
        ko: "콩고민주공화국 서부",
        sc: "刚果民主共和国，西部",
        es: "República Democrática del, parte occidental",
        ru: "Конго, Демократическая Республика, западная часть",
        ja: "コンゴ民主共和国、西部",
        fr: "Congo, République démocratique du, partie occidentale",
        de: "Kongo, Demokratische Republik, westlicher Teil",
        it: "Congo, Repubblica Democratica del, parte occidentale",
        th: "คองโก สาธารณรัฐประชาธิปไตย ภาคตะวันตก",
        id: "Kongo, Republik Demokratik, bagian barat",
        vi: "Congo, Cộng hòa dân chủ, phần phía tây",
        nl: "Congo, Democratische Republiek, westelijk deel",
        pl: "Kongo, Demokratyczna Republika, część zachodnia",
        nb: "Kongo, Den demokratiske republikken, vestlige del",
        fi: "Kongon demokraattinen tasavalta, länsiosa",
        ar: "جمهورية الكونغو الديمقراطية ، الجزء الغربي",
    },
    {
        value: 100,
        prefix: "(GMT+01:00)",
        en: "Croatia",
        ko: "크로아티아",
        sc: "克罗地亚",
        es: "Croacia",
        ru: "Хорватия",
        ja: "クロアチア",
        fr: "Croatie",
        de: "Kroatien",
        it: "Croazia",
        th: "โครเอเชีย",
        id: "Kroasia",
        vi: "Croatia",
        nl: "Kroatië",
        pl: "Chorwacja",
        nb: "Kroatia",
        fi: "Kroatia",
        ar: "كرواتيا",
    },
    {
        value: 100,
        prefix: "(GMT+01:00)",
        en: "Czechia",
        ko: "체코",
        sc: "捷克",
        es: "Chequia",
        ru: "Чехия",
        ja: "チェコ",
        fr: "Tchéquie",
        de: "Tschechien",
        it: "Cechia",
        th: "เช็กเกีย",
        id: "Ceko",
        vi: "Czechia",
        nl: "Tsjechië",
        pl: "Czechy",
        nb: "Tsjekkia",
        fi: "Tšekki",
        ar: "التشيك",
    },
    {
        value: 100,
        prefix: "(GMT+01:00)",
        en: "Denmark",
        ko: "덴마크",
        sc: "丹麦",
        es: "Dinamarca",
        ru: "Дания",
        ja: "デンマーク",
        fr: "Danemark",
        de: "Dänemark",
        it: "Danimarca",
        th: "เดนมาร์ก",
        id: "Denmark",
        vi: "Đan mạch",
        nl: "Denemarken",
        pl: "Dania",
        nb: "Danmark",
        fi: "Tanska",
        ar: "الدنمارك",
    },
    {
        value: 100,
        prefix: "(GMT+01:00)",
        en: "Equatorial Guinea",
        ko: "적도 기니",
        sc: "赤道几内亚",
        es: "Guinea Ecuatorial",
        ru: "Экваториальная Гвинея",
        ja: "赤道ギニア",
        fr: "Guinée Équatoriale",
        de: "Äquatorialguinea",
        it: "Guinea Equatoriale",
        th: "อิเควทอเรียลกินี",
        id: "Guinea ekuator",
        vi: "Equatorial Guinea",
        nl: "Equatoriaal-Guinea",
        pl: "Gwinea Równikowa",
        nb: "Ekvatorial-Guinea",
        fi: "Päiväntasaajan Guinea",
        ar: "غينيا الإستوائية",
    },
    {
        value: 100,
        prefix: "(GMT+01:00)",
        en: "France",
        ko: "프랑스",
        sc: "法国",
        es: "Francia",
        ru: "Франция",
        ja: "フランス",
        fr: "France",
        de: "Frankreich",
        it: "Francia",
        th: "ฝรั่งเศส",
        id: "Perancis",
        vi: "Nước pháp",
        nl: "Frankrijk",
        pl: "Francja",
        nb: "Frankrike",
        fi: "Ranska",
        ar: "فرنسا",
    },
    {
        value: 100,
        prefix: "(GMT+01:00)",
        en: "Gabon",
        ko: "가봉",
        sc: "加蓬",
        es: "Gabón",
        ru: "Габон",
        ja: "ガボン",
        fr: "Gabon",
        de: "Gabun",
        it: "Gabon",
        th: "กาบอง",
        id: "Gabon",
        vi: "Gabon",
        nl: "Gabon",
        pl: "Gabon",
        nb: "Gabon",
        fi: "Gabon",
        ar: "الجابون",
    },
    {
        value: 100,
        prefix: "(GMT+01:00)",
        en: "Germany",
        ko: "독일",
        sc: "德国",
        es: "Alemania",
        ru: "Германия",
        ja: "ドイツ",
        fr: "Allemagne",
        de: "Deutschland",
        it: "Germania",
        th: "เยอรมนี",
        id: "Jerman",
        vi: "nước Đức",
        nl: "Duitsland",
        pl: "Niemcy",
        nb: "Tyskland",
        fi: "Saksa",
        ar: "ألمانيا",
    },
    {
        value: 100,
        prefix: "(GMT+01:00)",
        en: "Gibraltar",
        ko: "지브롤터",
        sc: "直布罗陀",
        es: "Gibraltar",
        ru: "Гибралтар",
        ja: "ジブラルタル",
        fr: "Gibraltar",
        de: "Gibraltar",
        it: "Gibilterra",
        th: "ยิบรอลตาร์",
        id: "Gibraltar",
        vi: "Gibraltar",
        nl: "Gibraltar",
        pl: "Gibraltar",
        nb: "Gibraltar",
        fi: "Gibraltar",
        ar: "جبل طارق",
    },
    {
        value: 100,
        prefix: "(GMT+01:00)",
        en: "Hungary",
        ko: "헝가리",
        sc: "匈牙利",
        es: "Hungría",
        ru: "Венгрия",
        ja: "ハンガリー",
        fr: "Hongrie",
        de: "Ungarn",
        it: "Ungheria",
        th: "ฮังการี",
        id: "Hungaria",
        vi: "Hungary",
        nl: "Hongarije",
        pl: "Węgry",
        nb: "Ungarn",
        fi: "Unkari",
        ar: "هنغاريا",
    },
    {
        value: 100,
        prefix: "(GMT+01:00)",
        en: "Italy",
        ko: "이탈리아",
        sc: "意大利",
        es: "Italia",
        ru: "Италия",
        ja: "イタリア",
        fr: "Italie",
        de: "Italien",
        it: "Italia",
        th: "อิตาลี",
        id: "Italia",
        vi: "Nước Ý",
        nl: "Italië",
        pl: "Włochy",
        nb: "Italia",
        fi: "Italia",
        ar: "إيطاليا",
    },
    {
        value: 100,
        prefix: "(GMT+01:00)",
        en: "Kosovo",
        ko: "코소보",
        sc: "科索沃",
        es: "Kosovo",
        ru: "Косово",
        ja: "コソボ",
        fr: "Kosovo",
        de: "Kosovo",
        it: "Kosovo",
        th: "โคโซโว",
        id: "Kosovo",
        vi: "Kosovo",
        nl: "Kosovo",
        pl: "Kosowo",
        nb: "Kosovo",
        fi: "Kosovo",
        ar: "كوسوفو",
    },
    {
        value: 100,
        prefix: "(GMT+01:00)",
        en: "Liechtenstein",
        ko: "리히텐슈타인",
        sc: "列支敦士登",
        es: "Liechtenstein",
        ru: "Лихтенштейн",
        ja: "リヒテンシュタイン",
        fr: "Liechtenstein",
        de: "Liechtenstein",
        it: "Liechtenstein",
        th: "ลิกเตนสไตน์",
        id: "Liechtenstein",
        vi: "Liechtenstein",
        nl: "Liechtenstein",
        pl: "Liechtenstein",
        nb: "Liechtenstein",
        fi: "Liechtenstein",
        ar: "ليختنشتاين",
    },
    {
        value: 100,
        prefix: "(GMT+01:00)",
        en: "Luxembourg",
        ko: "룩셈부르크",
        sc: "卢森堡",
        es: "luxemburgo",
        ru: "Люксембург",
        ja: "ルクセンブルク",
        fr: "Luxembourg",
        de: "Luxemburg",
        it: "Lussemburgo",
        th: "ลักเซมเบิร์ก",
        id: "Luksemburg",
        vi: "Luxembourg",
        nl: "Luxemburg",
        pl: "Luksemburg",
        nb: "Luxembourg",
        fi: "Luxemburg",
        ar: "لوكسمبورغ",
    },
    {
        value: 100,
        prefix: "(GMT+01:00)",
        en: "Malta",
        ko: "몰타",
        sc: "马耳他",
        es: "Malta",
        ru: "Мальта",
        ja: "マルタ",
        fr: "Malte",
        de: "Malta",
        it: "Malta",
        th: "มอลตา",
        id: "Malta",
        vi: "Malta",
        nl: "Malta",
        pl: "Malta",
        nb: "Malta",
        fi: "Malta",
        ar: "مالطا",
    },
    {
        value: 100,
        prefix: "(GMT+01:00)",
        en: "Monaco",
        ko: "모나코",
        sc: "摩纳哥",
        es: "Mónaco",
        ru: "Монако",
        ja: "モナコ",
        fr: "Monaco",
        de: "Monaco",
        it: "Monaco",
        th: "โมนาโก",
        id: "Monako",
        vi: "Monaco",
        nl: "Monaco",
        pl: "Monako",
        nb: "Monaco",
        fi: "Monaco",
        ar: "موناكو",
    },
    {
        value: 100,
        prefix: "(GMT+01:00)",
        en: "Montenegro",
        ko: "몬테네그로",
        sc: "黑山",
        es: "montenegro",
        ru: "Черногория",
        ja: "モンテネグロ",
        fr: "Monténégro",
        de: "Montenegro",
        it: "Montenegro",
        th: "มอนเตเนโกร",
        id: "Montenegro",
        vi: "Montenegro",
        nl: "Montenegro",
        pl: "Czarnogóra",
        nb: "Montenegro",
        fi: "Montenegro",
        ar: "الجبل الأسود",
    },
    {
        value: 100,
        prefix: "(GMT+01:00)",
        en: "Morocco",
        ko: "모로코",
        sc: "摩洛哥",
        es: "Marruecos",
        ru: "Марокко",
        ja: "モロッコ",
        fr: "Maroc",
        de: "Marokko",
        it: "Marocco",
        th: "โมร็อกโก",
        id: "Maroko",
        vi: "Maroc",
        nl: "Marokko",
        pl: "Maroko",
        nb: "Marokko",
        fi: "Marokko",
        ar: "المغرب",
    },
    {
        value: 100,
        prefix: "(GMT+01:00)",
        en: "Netherlands",
        ko: "네덜란드",
        sc: "荷兰",
        es: "Países Bajos",
        ru: "Нидерланды",
        ja: "オランダ",
        fr: "Pays-Bas",
        de: "Niederlande",
        it: "Olanda",
        th: "เนเธอร์แลนด์",
        id: "Belanda",
        vi: "nước Hà Lan",
        nl: "Nederland",
        pl: "Holandia",
        nb: "Nederland",
        fi: "Alankomaat",
        ar: "هولندا",
    },
    {
        value: 100,
        prefix: "(GMT+01:00)",
        en: "Niger",
        ko: "니제르",
        sc: "尼日尔",
        es: "Níger",
        ru: "Нигер",
        ja: "ニジェール",
        fr: "Niger",
        de: "Niger",
        it: "Niger",
        th: "ไนเจอร์",
        id: "Nigeria",
        vi: "Niger",
        nl: "Niger",
        pl: "Niger",
        nb: "Niger",
        fi: "Niger",
        ar: "النيجر",
    },
    {
        value: 100,
        prefix: "(GMT+01:00)",
        en: "Nigeria",
        ko: "나이지리아",
        sc: "尼日利亚",
        es: "Nigeria",
        ru: "Нигерия",
        ja: "ナイジェリア",
        fr: "Nigeria",
        de: "Nigeria",
        it: "Nigeria",
        th: "ไนจีเรีย",
        id: "Nigeria",
        vi: "Nigeria",
        nl: "Nigeria",
        pl: "Nigeria",
        nb: "Nigeria",
        fi: "Nigeria",
        ar: "نيجيريا",
    },
    {
        value: 100,
        prefix: "(GMT+01:00)",
        en: "North Macedonia",
        ko: "북 마케도니아",
        sc: "北马其顿",
        es: "macedonia del norte",
        ru: "Северная Македония",
        ja: "北マケドニア",
        fr: "Macédoine du Nord",
        de: "Nordmazedonien",
        it: "Macedonia del Nord",
        th: "มาซิโดเนียเหนือ",
        id: "Makedonia Utara",
        vi: "Bắc Macedonia",
        nl: "Noord-Macedonië",
        pl: "Macedonia Północna",
        nb: "Nord-Makedonia",
        fi: "Pohjois-Makedonia",
        ar: "مقدونيا الشمالية",
    },
    {
        value: 100,
        prefix: "(GMT+01:00)",
        en: "Norway",
        ko: "노르웨이",
        sc: "挪威",
        es: "Noruega",
        ru: "Норвегия",
        ja: "ノルウェー",
        fr: "Norvège",
        de: "Norwegen",
        it: "Norvegia",
        th: "นอร์เวย์",
        id: "Norway",
        vi: "Na Uy",
        nl: "Noorwegen",
        pl: "Norwegia",
        nb: "Norge",
        fi: "Norja",
        ar: "النرويج",
    },
    {
        value: 100,
        prefix: "(GMT+01:00)",
        en: "Poland",
        ko: "폴란드",
        sc: "波兰",
        es: "Polonia",
        ru: "Польша",
        ja: "ポーランド",
        fr: "Pologne",
        de: "Polen",
        it: "Polonia",
        th: "โปแลนด์",
        id: "Polandia",
        vi: "Ba lan",
        nl: "Polen",
        pl: "Polska",
        nb: "Polen",
        fi: "Puola",
        ar: "بولندا",
    },
    {
        value: 100,
        prefix: "(GMT+01:00)",
        en: "San Marino",
        ko: "산 마리노",
        sc: "圣马力诺",
        es: "San Marino",
        ru: "Сан-Марино",
        ja: "サンマリノ",
        fr: "Saint Marin",
        de: "San Marino",
        it: "San Marino",
        th: "ซานมารีโน",
        id: "San Marino",
        vi: "San Marino",
        nl: "San Marino",
        pl: "San Marino",
        nb: "San Marino",
        fi: "San Marino",
        ar: "سان مارينو",
    },
    {
        value: 100,
        prefix: "(GMT+01:00)",
        en: "Serbia",
        ko: "세르비아",
        sc: "塞尔维亚",
        es: "Serbia",
        ru: "Сербия",
        ja: "セルビア",
        fr: "Serbie",
        de: "Serbien",
        it: "Serbia",
        th: "เซอร์เบีย",
        id: "Serbia",
        vi: "Xéc-bi-a",
        nl: "Servië",
        pl: "Serbia",
        nb: "Serbia",
        fi: "Serbia",
        ar: "صربيا",
    },
    {
        value: 100,
        prefix: "(GMT+01:00)",
        en: "Slovakia",
        ko: "슬로바키아",
        sc: "斯洛伐克",
        es: "Eslovaquia",
        ru: "Словакия",
        ja: "スロバキア",
        fr: "Slovaquie",
        de: "Slowakei",
        it: "Slovacchia",
        th: "สโลวาเกีย",
        id: "Slowakia",
        vi: "Xlô-va-ki-a",
        nl: "Slowakije",
        pl: "Słowacja",
        nb: "Slovakia",
        fi: "Slovakia",
        ar: "سلوفاكيا",
    },
    {
        value: 100,
        prefix: "(GMT+01:00)",
        en: "Slovenia",
        ko: "슬로베니아",
        sc: "斯洛文尼亚",
        es: "Eslovenia",
        ru: "Словения",
        ja: "スロベニア",
        fr: "Slovénie",
        de: "Slowenien",
        it: "Slovenia",
        th: "สโลวีเนีย",
        id: "Slovenia",
        vi: "Slovenia",
        nl: "Slovenië",
        pl: "Słowenia",
        nb: "Slovenia",
        fi: "Slovenia",
        ar: "سلوفينيا",
    },
    {
        value: 100,
        prefix: "(GMT+01:00)",
        en: "Spain, main territory",
        ko: "스페인, 주요 영토",
        sc: "西班牙，主要领土",
        es: "España, territorio principal",
        ru: "Испания, основная территория",
        ja: "スペイン、主要な領土",
        fr: "Espagne, territoire principal",
        de: "Spanien, Hauptgebiet",
        it: "Spagna, territorio principale",
        th: "สเปน ดินแดนหลัก",
        id: "Spanyol, wilayah utama",
        vi: "Tây Ban Nha, lãnh thổ chính",
        nl: "Spanje, hoofdgebied",
        pl: "Hiszpania, główne terytorium",
        nb: "Spania, hovedterritorium",
        fi: "Espanja, pääalue",
        ar: "إسبانيا ، الإقليم الرئيسي",
    },
    {
        value: 100,
        prefix: "(GMT+01:00)",
        en: "Svalbard and Jan Mayen",
        ko: "스발바르와 얀 마옌",
        sc: "斯瓦尔巴和扬马延",
        es: "Svalbard y Jan Mayen",
        ru: "Шпицберген и Ян-Майен",
        ja: "スバールバル諸島およびヤンマイエン",
        fr: "Svalbard et Jan Mayen",
        de: "Spitzbergen und Jan Mayen",
        it: "Svalbard e Jan Mayen",
        th: "สฟาลบาร์และยานไมเอน",
        id: "Svalbard dan Jan Mayen",
        vi: "Svalbard và Jan Mayen",
        nl: "Svalbard en Jan Mayen",
        pl: "Svalbard i Jan Mayen",
        nb: "Svalbard og Jan Mayen",
        fi: "Svalbard ja Jan Mayen",
        ar: "سفالبارد وجان ماين",
    },
    {
        value: 100,
        prefix: "(GMT+01:00)",
        en: "Sweden",
        ko: "스웨덴",
        sc: "瑞典",
        es: "Suecia",
        ru: "Швеция",
        ja: "スウェーデン",
        fr: "Suède",
        de: "Schweden",
        it: "Svezia",
        th: "สวีเดน",
        id: "Swedia",
        vi: "Thụy Điển",
        nl: "Zweden",
        pl: "Szwecja",
        nb: "Sverige",
        fi: "Ruotsi",
        ar: "السويد",
    },
    {
        value: 100,
        prefix: "(GMT+01:00)",
        en: "Switzerland",
        ko: "스위스",
        sc: "瑞士",
        es: "Suiza",
        ru: "Швейцария",
        ja: "スイス",
        fr: "Suisse",
        de: "Schweiz",
        it: "Svizzera",
        th: "สวิตเซอร์แลนด์",
        id: "Swiss",
        vi: "Thụy sĩ",
        nl: "Zwitserland",
        pl: "Szwajcaria",
        nb: "Sveits",
        fi: "Sveitsi",
        ar: "سويسرا",
    },
    {
        value: 100,
        prefix: "(GMT+01:00)",
        en: "Tunisia",
        ko: "튀니지",
        sc: "突尼斯",
        es: "Túnez",
        ru: "Тунис",
        ja: "チュニジア",
        fr: "Tunisie",
        de: "Tunesien",
        it: "Tunisia",
        th: "ตูนิเซีย",
        id: "Tunisia",
        vi: "Tunisia",
        nl: "Tunesië",
        pl: "Tunezja",
        nb: "Tunisia",
        fi: "Tunisia",
        ar: "تونس",
    },
    {
        value: 100,
        prefix: "(GMT+01:00)",
        en: "Vatican City (Holy See)",
        ko: "바티칸 시국(교황청)",
        sc: "梵蒂冈城（教廷）",
        es: "Ciudad del Vaticano (Santa Sede)",
        ru: "Ватикан (Святой Престол)",
        ja: "バチカン市国（聖座）",
        fr: "Cité du Vatican (Saint-Siège)",
        de: "Vatikanstadt (Heiliger Stuhl)",
        it: "Città del Vaticano (Santa Sede)",
        th: "นครวาติกัน (สันตะสำนัก)",
        id: "Kota Vatikan (Tahta Suci)",
        vi: "Thành phố Vatican (Tòa thánh)",
        nl: "Vaticaanstad (Heilige Stoel)",
        pl: "Watykan (Stolica Apostolska)",
        nb: "Vatikanstaten (Holy See)",
        fi: "Vatikaani (Pyhä istuin)",
        ar: "مدينة الفاتيكان (الكرسي الرسولي)",
    },
    {
        value: 200,
        prefix: "(GMT+02:00)",
        en: "Aland Islands",
        ko: "올란드 제도",
        sc: "奥兰群岛",
        es: "Islas Aland",
        ru: "Аландские острова",
        ja: "オーランド諸島",
        fr: "Iles Aland",
        de: "Aland-Inseln",
        it: "Isole Aland",
        th: "หมู่เกาะโอลันด์",
        id: "Pulau Aland",
        vi: "Quần đảo Aland",
        nl: "Aland-eilanden",
        pl: "Wyspy Alandzkie",
        nb: "Ålandsøyene",
        fi: "Ahvenanmaan saaret",
        ar: "جزر آلاند",
    },
    {
        value: 200,
        prefix: "(GMT+02:00)",
        en: "Botswana",
        ko: "보츠와나",
        sc: "博茨瓦纳",
        es: "Botsuana",
        ru: "Ботсвана",
        ja: "ボツワナ",
        fr: "Bostwana",
        de: "Botswana",
        it: "Botswana",
        th: "บอตสวานา",
        id: "Botswana",
        vi: "Botswana",
        nl: "Botswana",
        pl: "Botswana",
        nb: "Botswana",
        fi: "Botswana",
        ar: "بوتسوانا",
    },
    {
        value: 200,
        prefix: "(GMT+02:00)",
        en: "Bulgaria",
        ko: "불가리아",
        sc: "保加利亚",
        es: "Bulgaria",
        ru: "Болгария",
        ja: "ブルガリア",
        fr: "Bulgarie",
        de: "Bulgarien",
        it: "Bulgaria",
        th: "บัลแกเรีย",
        id: "Bulgaria",
        vi: "Bungari",
        nl: "Bulgarije",
        pl: "Bułgaria",
        nb: "Bulgaria",
        fi: "Bulgaria",
        ar: "بلغاريا",
    },
    {
        value: 200,
        prefix: "(GMT+02:00)",
        en: "Burundi",
        ko: "부룬디",
        sc: "布隆迪",
        es: "Burundi",
        ru: "Бурунди",
        ja: "ブルンジ",
        fr: "Burundi",
        de: "Burundi",
        it: "Burundi",
        th: "บุรุนดี",
        id: "Burundi",
        vi: "Burundi",
        nl: "Burundi",
        pl: "Burundi",
        nb: "Burundi",
        fi: "Burundi",
        ar: "بوروندي",
    },
    {
        value: 200,
        prefix: "(GMT+02:00)",
        en: "Congo, Democratic Republic of, eastern part",
        ko: "콩고, 민주공화국 동부",
        sc: "刚果民主共和国，东部",
        es: "Congo, República Democrática del, parte oriental",
        ru: "Конго, Демократическая Республика, восточная часть",
        ja: "コンゴ民主共和国、東部",
        fr: "Congo, République démocratique du, partie orientale",
        de: "Kongo, Demokratische Republik, östlicher Teil",
        it: "Congo, Repubblica Democratica del, parte orientale",
        th: "คองโก สาธารณรัฐประชาธิปไตย ภาคตะวันออก",
        id: "Kongo, Republik Demokratik, bagian timur",
        vi: "Congo, Cộng hòa dân chủ, miền đông",
        nl: "Congo, Democratische Republiek, oostelijk deel",
        pl: "Kongo, Demokratyczna Republika, część wschodnia",
        nb: "Kongo, Den demokratiske republikken, østlige del",
        fi: "Kongon demokraattinen tasavalta, itäosa",
        ar: "جمهورية الكونغو الديمقراطية ، الجزء الشرقي",
    },
    {
        value: 200,
        prefix: "(GMT+02:00)",
        en: "Cyprus",
        ko: "키프로스",
        sc: "塞浦路斯",
        es: "Chipre",
        ru: "Кипр",
        ja: "キプロス",
        fr: "Chypre",
        de: "Zypern",
        it: "Cipro",
        th: "ไซปรัส",
        id: "Siprus",
        vi: "Síp",
        nl: "Cyprus",
        pl: "Cypr",
        nb: "Kypros",
        fi: "Kypros",
        ar: "قبرص",
    },
    {
        value: 200,
        prefix: "(GMT+02:00)",
        en: "Egypt",
        ko: "이집트",
        sc: "埃及",
        es: "Egipto",
        ru: "Египет",
        ja: "エジプト",
        fr: "Egypte",
        de: "Ägypten",
        it: "Egitto",
        th: "อียิปต์",
        id: "Mesir",
        vi: "Ai cập",
        nl: "Egypte",
        pl: "Egipt",
        nb: "Egypt",
        fi: "Egypti",
        ar: "مصر",
    },
    {
        value: 200,
        prefix: "(GMT+02:00)",
        en: "Estonia",
        ko: "에스토니아",
        sc: "爱沙尼亚",
        es: "Estonia",
        ru: "Эстония",
        ja: "エストニア",
        fr: "Estonie",
        de: "Estland",
        it: "Estonia",
        th: "เอสโตเนีย",
        id: "Estonia",
        vi: "Estonia",
        nl: "Estland",
        pl: "Estonia",
        nb: "Estland",
        fi: "Viro",
        ar: "إستونيا",
    },
    {
        value: 200,
        prefix: "(GMT+02:00)",
        en: "Eswatini",
        ko: "에스와티니",
        sc: "斯威士兰",
        es: "Esuatini",
        ru: "Эсватини",
        ja: "エスワティニ",
        fr: "Eswatini",
        de: "Eswatini",
        it: "Eswatini",
        th: "เอสวาตินี",
        id: "Eswatini",
        vi: "Eswatini",
        nl: "Swatini",
        pl: "Eswatini",
        nb: "Eswatini",
        fi: "Eswatini",
        ar: "إيسواتيني",
    },
    {
        value: 200,
        prefix: "(GMT+02:00)",
        en: "Finland",
        ko: "핀란드",
        sc: "芬兰",
        es: "Finlandia",
        ru: "Финляндия",
        ja: "フィンランド",
        fr: "Finlande",
        de: "Finnland",
        it: "Finlandia",
        th: "ฟินแลนด์",
        id: "Finlandia",
        vi: "Phần Lan",
        nl: "Finland",
        pl: "Finlandia",
        nb: "Finland",
        fi: "Suomi",
        ar: "فنلندا",
    },
    {
        value: 200,
        prefix: "(GMT+02:00)",
        en: "Greece",
        ko: "그리스",
        sc: "希腊",
        es: "Grecia",
        ru: "Греция",
        ja: "ギリシャ",
        fr: "Grèce",
        de: "Griechenland",
        it: "Grecia",
        th: "กรีซ",
        id: "Yunani",
        vi: "Hy Lạp",
        nl: "Griekenland",
        pl: "Grecja",
        nb: "Hellas",
        fi: "Kreikka",
        ar: "اليونان",
    },
    {
        value: 200,
        prefix: "(GMT+02:00)",
        en: "Israel",
        ko: "이스라엘",
        sc: "以色列",
        es: "Israel",
        ru: "Израиль",
        ja: "イスラエル",
        fr: "Israël",
        de: "Israel",
        it: "Israele",
        th: "อิสราเอล",
        id: "Israel",
        vi: "Người israel",
        nl: "Israël",
        pl: "Izrael",
        nb: "Israel",
        fi: "Israel",
        ar: "إسرائيل",
    },
    {
        value: 200,
        prefix: "(GMT+02:00)",
        en: "Jordan",
        ko: "요르단",
        sc: "约旦",
        es: "Jordán",
        ru: "Иордания",
        ja: "ヨルダン",
        fr: "Jordan",
        de: "Jordanien",
        it: "Giordania",
        th: "จอร์แดน",
        id: "Yordania",
        vi: "Jordan",
        nl: "Jordanië",
        pl: "Jordania",
        nb: "Jordan",
        fi: "Jordania",
        ar: "الأردن",
    },
    {
        value: 200,
        prefix: "(GMT+02:00)",
        en: "Kaliningrad, Russia",
        ko: "러시아 칼리닌그라드",
        sc: "俄罗斯加里宁格勒",
        es: "Kaliningrado, Rusia",
        ru: "Калининград, Россия",
        ja: "カリーニングラード、ロシア",
        fr: "Kaliningrad, Russie",
        de: "Kaliningrad, Russland",
        it: "Kaliningrad, Russia",
        th: "คาลินินกราด รัสเซีย",
        id: "Kaliningrad, Rusia",
        vi: "Kaliningrad, Nga",
        nl: "Kaliningrad, Rusland",
        pl: "Kaliningrad, Rosja",
        nb: "Kaliningrad, Russland",
        fi: "Kaliningrad, Venäjä",
        ar: "كالينينغراد ، روسيا",
    },
    {
        value: 200,
        prefix: "(GMT+02:00)",
        en: "Latvia",
        ko: "라트비아",
        sc: "拉脱维亚",
        es: "letonia",
        ru: "Латвия",
        ja: "ラトビア",
        fr: "Lettonie",
        de: "Lettland",
        it: "Lettonia",
        th: "ลัตเวีย",
        id: "Latvia",
        vi: "Latvia",
        nl: "Letland",
        pl: "Łotwa",
        nb: "Latvia",
        fi: "Latvia",
        ar: "لاتفيا",
    },
    {
        value: 200,
        prefix: "(GMT+02:00)",
        en: "Lebanon",
        ko: "레바논",
        sc: "黎巴嫩",
        es: "Líbano",
        ru: "Ливан",
        ja: "レバノン",
        fr: "Liban",
        de: "Libanon",
        it: "Libano",
        th: "เลบานอน",
        id: "Libanon",
        vi: "Lebanon",
        nl: "Libanon",
        pl: "Liban",
        nb: "Libanon",
        fi: "Libanon",
        ar: "لبنان",
    },
    {
        value: 200,
        prefix: "(GMT+02:00)",
        en: "Lesotho",
        ko: "레소토",
        sc: "莱索托",
        es: "Lesoto",
        ru: "Лесото",
        ja: "レソト",
        fr: "Lesotho",
        de: "Lesotho",
        it: "Lesoto",
        th: "เลโซโท",
        id: "Lesotho",
        vi: "Lesotho",
        nl: "Lesotho",
        pl: "Lesoto",
        nb: "Lesotho",
        fi: "Lesotho",
        ar: "ليسوتو",
    },
    {
        value: 200,
        prefix: "(GMT+02:00)",
        en: "Libya",
        ko: "리비아",
        sc: "利比亚",
        es: "Libia",
        ru: "Ливия",
        ja: "リビア",
        fr: "Libye",
        de: "Libyen",
        it: "Libia",
        th: "ลิเบีย",
        id: "Libya",
        vi: "Libya",
        nl: "Libië",
        pl: "Libia",
        nb: "Libya",
        fi: "Libya",
        ar: "ليبيا",
    },
    {
        value: 200,
        prefix: "(GMT+02:00)",
        en: "Lithuania",
        ko: "리투아니아",
        sc: "立陶宛",
        es: "Lituania",
        ru: "Литва",
        ja: "リトアニア",
        fr: "Lituanie",
        de: "Litauen",
        it: "Lituania",
        th: "ลิทัวเนีย",
        id: "Lithuania",
        vi: "Lithuania",
        nl: "Litouwen",
        pl: "Litwa",
        nb: "Litauen",
        fi: "Liettua",
        ar: "ليتوانيا",
    },
    {
        value: 200,
        prefix: "(GMT+02:00)",
        en: "Malawi",
        ko: "말라위",
        sc: "马拉维",
        es: "Malaui",
        ru: "Малави",
        ja: "マラウイ",
        fr: "Malawi",
        de: "Malawi",
        it: "Malawi",
        th: "มาลาวี",
        id: "Malawi",
        vi: "Malawi",
        nl: "Malawi",
        pl: "Malawi",
        nb: "Malawi",
        fi: "Malawi",
        ar: "ملاوي",
    },
    {
        value: 200,
        prefix: "(GMT+02:00)",
        en: "Moldova",
        ko: "몰도바",
        sc: "摩尔多瓦",
        es: "Moldavia",
        ru: "Молдова",
        ja: "モルドバ",
        fr: "Moldavie",
        de: "Moldawien",
        it: "Moldavia",
        th: "มอลโดวา",
        id: "Moldova",
        vi: "Moldova",
        nl: "Moldavië",
        pl: "Moldova",
        nb: "Moldova",
        fi: "Moldova",
        ar: "مولدوفا",
    },
    {
        value: 200,
        prefix: "(GMT+02:00)",
        en: "Mozambique",
        ko: "모잠비크",
        sc: "莫桑比克",
        es: "Mozambique",
        ru: "Мозамбик",
        ja: "モザンビーク",
        fr: "Mozambique",
        de: "Mosambik",
        it: "Mozambico",
        th: "โมซัมบิก",
        id: "Mozambik",
        vi: "Mozambique",
        nl: "Mozambique",
        pl: "Mozambik",
        nb: "Mosambik",
        fi: "Mosambik",
        ar: "موزمبيق",
    },
    {
        value: 200,
        prefix: "(GMT+02:00)",
        en: "Namibia",
        ko: "나미비아",
        sc: "纳米比亚",
        es: "Namibia",
        ru: "Намибия",
        ja: "ナミビア",
        fr: "Namibie",
        de: "Namibia",
        it: "Namibia",
        th: "นามิเบีย",
        id: "Namibia",
        vi: "Namibia",
        nl: "Namibië",
        pl: "Namibia",
        nb: "Namibia",
        fi: "Namibia",
        ar: "ناميبيا",
    },
    {
        value: 200,
        prefix: "(GMT+02:00)",
        en: "Palestine",
        ko: "팔레스타인",
        sc: "巴勒斯坦",
        es: "Palestina",
        ru: "Палестина",
        ja: "パレスチナ",
        fr: "Palestine",
        de: "Palästina",
        it: "Palestina",
        th: "ปาเลสไตน์",
        id: "Palestina",
        vi: "Palestine",
        nl: "Palestina",
        pl: "Palestyna",
        nb: "Palestina",
        fi: "Palestiina",
        ar: "فلسطين",
    },
    {
        value: 200,
        prefix: "(GMT+02:00)",
        en: "Romania",
        ko: "루마니아",
        sc: "罗马尼亚",
        es: "Rumania",
        ru: "Румыния",
        ja: "ルーマニア",
        fr: "Roumanie",
        de: "Rumänien",
        it: "Romania",
        th: "โรมาเนีย",
        id: "Rumania",
        vi: "Romania",
        nl: "Roemenië",
        pl: "Rumunia",
        nb: "Romania",
        fi: "Romania",
        ar: "رومانيا",
    },
    {
        value: 200,
        prefix: "(GMT+02:00)",
        en: "Rwanda",
        ko: "르완다",
        sc: "卢旺达",
        es: "Ruanda",
        ru: "Руанда",
        ja: "ルワンダ",
        fr: "Rwanda",
        de: "Ruanda",
        it: "Ruanda",
        th: "รวันดา",
        id: "Rwanda",
        vi: "Rwanda",
        nl: "Rwanda",
        pl: "Rwanda",
        nb: "Rwanda",
        fi: "Ruanda",
        ar: "رواندا",
    },
    {
        value: 200,
        prefix: "(GMT+02:00)",
        en: "South Africa",
        ko: "남아프리카",
        sc: "南非",
        es: "Sudáfrica",
        ru: "Южная Африка",
        ja: "南アフリカ",
        fr: "Afrique du Sud",
        de: "Südafrika",
        it: "Sud Africa",
        th: "แอฟริกาใต้",
        id: "Afrika Selatan",
        vi: "Nam Phi",
        nl: "Zuid-Afrika",
        pl: "Afryka Południowa",
        nb: "Sør-Afrika",
        fi: "Etelä-Afrikka",
        ar: "جنوب أفريقيا",
    },
    {
        value: 200,
        prefix: "(GMT+02:00)",
        en: "South Sudan",
        ko: "남 수단",
        sc: "南苏丹",
        es: "Sudán del Sur",
        ru: "южный Судан",
        ja: "南スーダン",
        fr: "Soudan du sud",
        de: "Südsudan",
        it: "Sudan del Sud",
        th: "ซูดานใต้",
        id: "Sudan Selatan",
        vi: "phía nam Sudan",
        nl: "Zuid Soedan",
        pl: "Południowy Sudan",
        nb: "Sør-Sudan",
        fi: "eteläsudan",
        ar: "جنوب السودان",
    },
    {
        value: 200,
        prefix: "(GMT+02:00)",
        en: "Sudan",
        ko: "수단",
        sc: "苏丹",
        es: "Sudán",
        ru: "Судан",
        ja: "スーダン",
        fr: "Soudan",
        de: "Sudan",
        it: "Sudan",
        th: "ซูดาน",
        id: "Sudan",
        vi: "Sudan",
        nl: "Soedan",
        pl: "Sudan",
        nb: "Sudan",
        fi: "Sudan",
        ar: "السودان",
    },
    {
        value: 200,
        prefix: "(GMT+02:00)",
        en: "Syria",
        ko: "시리아",
        sc: "叙利亚",
        es: "Siria",
        ru: "Сирия",
        ja: "シリア",
        fr: "Syrie",
        de: "Syrien",
        it: "Siria",
        th: "ซีเรีย",
        id: "Suriah",
        vi: "Syria",
        nl: "Syrië",
        pl: "Syria",
        nb: "Syria",
        fi: "Syyria",
        ar: "سوريا",
    },
    {
        value: 200,
        prefix: "(GMT+02:00)",
        en: "Ukraine",
        ko: "우크라이나",
        sc: "乌克兰",
        es: "Ucrania",
        ru: "Украина",
        ja: "ウクライナ",
        fr: "Ukraine",
        de: "Ukraine",
        it: "Ucraina",
        th: "ยูเครน",
        id: "Ukraina",
        vi: "Ukraine",
        nl: "Oekraïne",
        pl: "Ukraina",
        nb: "Ukraina",
        fi: "Ukraina",
        ar: "أوكرانيا",
    },
    {
        value: 200,
        prefix: "(GMT+02:00)",
        en: "Zambia",
        ko: "잠비아",
        sc: "赞比亚",
        es: "Zambia",
        ru: "Замбия",
        ja: "ザンビア",
        fr: "Zambie",
        de: "Sambia",
        it: "Zambia",
        th: "แซมเบีย",
        id: "Zambia",
        vi: "Zambia",
        nl: "Zambia",
        pl: "Zambia",
        nb: "Zambia",
        fi: "Sambia",
        ar: "زامبيا",
    },
    {
        value: 200,
        prefix: "(GMT+02:00)",
        en: "Zimbabwe",
        ko: "짐바브웨",
        sc: "津巴布韦",
        es: "Zimbabue",
        ru: "Зимбабве",
        ja: "ジンバブエ",
        fr: "Zimbabwe",
        de: "Zimbabwe",
        it: "Zimbabwe",
        th: "ซิมบับเว",
        id: "Zimbabwe",
        vi: "Zimbabwe",
        nl: "Zimbabwe",
        pl: "Zimbabwe",
        nb: "Zimbabwe",
        fi: "Zimbabwe",
        ar: "زيمبابوي",
    },
    {
        value: 300,
        prefix: "(GMT+03:00)",
        en: "Arkhangelsk, Russia",
        ko: "아르한겔스크, 러시아",
        sc: "俄罗斯阿尔汉格尔斯克",
        es: "Arcángel, Rusia",
        ru: "Архангельск, Россия",
        ja: "アルハンゲリスク、ロシア",
        fr: "Arkhangelsk, Russie",
        de: "Archangelsk, Russland",
        it: "Arkhangelsk, Russia",
        th: "อาร์คันเกลสค์ รัสเซีย",
        id: "Arkhangelsk, Rusia",
        vi: "Arkhangelsk, Nga",
        nl: "Archangelsk, Rusland",
        pl: "Archangielsk, Rosja",
        nb: "Arkhangelsk, Russland",
        fi: "Arkhangelsk, Venäjä",
        ar: "أرخانجيلسك ، روسيا",
    },
    {
        value: 300,
        prefix: "(GMT+03:00)",
        en: "Bahrain",
        ko: "바레인",
        sc: "巴林",
        es: "Baréin",
        ru: "Бахрейн",
        ja: "バーレーン",
        fr: "Bahreïn",
        de: "Bahrein",
        it: "Bahrein",
        th: "บาห์เรน",
        id: "Bahrain",
        vi: "Bahrain",
        nl: "Bahrein",
        pl: "Bahrajn",
        nb: "Bahrain",
        fi: "Bahrain",
        ar: "البحرين",
    },
    {
        value: 300,
        prefix: "(GMT+03:00)",
        en: "Belgorod, Russia",
        ko: "벨고로드, 러시아",
        sc: "俄罗斯别尔哥罗德",
        es: "Bélgorod, Rusia",
        ru: "Белгород, Россия",
        ja: "ベルゴロド、ロシア",
        fr: "Belgorod, Russie",
        de: "Belgorod, Russland",
        it: "Belgorod, Russia",
        th: "เบลโกรอด รัสเซีย",
        id: "Belgorod, Rusia",
        vi: "Belgorod, Nga",
        nl: "Belgorod, Rusland",
        pl: "Biełgorod, Rosja",
        nb: "Belgorod, Russland",
        fi: "Belgorod, Venäjä",
        ar: "بيلغورود ، روسيا",
    },
    {
        value: 300,
        prefix: "(GMT+03:00)",
        en: "Belarus",
        ko: "벨라루스",
        sc: "白俄罗斯",
        es: "Bielorrusia",
        ru: "Беларусь",
        ja: "ベラルーシ",
        fr: "Biélorussie",
        de: "Weißrussland",
        it: "Bielorussia",
        th: "เบลารุส",
        id: "Belarusia",
        vi: "Belarus",
        nl: "Wit-Rusland",
        pl: "Białoruś",
        nb: "Hviterussland",
        fi: "Valko-Venäjä",
        ar: "بيلاروسيا",
    },
    {
        value: 300,
        prefix: "(GMT+03:00)",
        en: "Bryansk, Russia",
        ko: "브랸스크, 러시아",
        sc: "俄罗斯布良斯克",
        es: "Briansk, Rusia",
        ru: "Брянск, Россия",
        ja: "ブリャンスク、ロシア",
        fr: "Briansk, Russie",
        de: "Brjansk, Russland",
        it: "Brjansk, Russia",
        th: "ไบรอันสค์ รัสเซีย",
        id: "Bryansk, Rusia",
        vi: "Bryansk, Nga",
        nl: "Brjansk, Rusland",
        pl: "Briańsk, Rosja",
        nb: "Bryansk, Russland",
        fi: "Bryansk, Venäjä",
        ar: "بريانسك ، روسيا",
    },
    {
        value: 300,
        prefix: "(GMT+03:00)",
        en: "Cheboksary, Russia",
        ko: "체복사리, 러시아",
        sc: "俄罗斯切博克萨雷",
        es: "Cheboksary, Rusia",
        ru: "Чебоксары, Россия",
        ja: "チェボクサリ、ロシア",
        fr: "Tcheboksary, Russie",
        de: "Tscheboksary, Russland",
        it: "Cheboksary, Russia",
        th: "เชบอคซารี รัสเซีย",
        id: "Cheboksary, Rusia",
        vi: "Cheboksary, Nga",
        nl: "Tsjeboksary, Rusland",
        pl: "Czeboksary, Rosja",
        nb: "Cheboksary, Russland",
        fi: "Cheboksary, Venäjä",
        ar: "تشيبوكساري ، روسيا",
    },
    {
        value: 300,
        prefix: "(GMT+03:00)",
        en: "Cherkessk, Russia",
        ko: "체르케스크, 러시아",
        sc: "俄罗斯切尔克斯克",
        es: "Cherkesk, Rusia",
        ru: "Черкесск, Россия",
        ja: "チェルケスク、ロシア",
        fr: "Tcherkessk, Russie",
        de: "Tscherkessk, Russland",
        it: "Cherkessk, Russia",
        th: "เชียร์เคสสค์ รัสเซีย",
        id: "Cherkessk, Rusia",
        vi: "Cherkessk, Nga",
        nl: "Tsjerkessk, Rusland",
        pl: "Czerkiesk, Rosja",
        nb: "Cherkessk, Russland",
        fi: "Cherkessk, Venäjä",
        ar: "تشيركيسك ، روسيا",
    },
    {
        value: 300,
        prefix: "(GMT+03:00)",
        en: "Comoros",
        ko: "코모로",
        sc: "科摩罗",
        es: "Comoras",
        ru: "Коморы",
        ja: "コモロ",
        fr: "Comores",
        de: "Komoren",
        it: "Comore",
        th: "คอโมโรส",
        id: "Komoro",
        vi: "Comoros",
        nl: "Comoren",
        pl: "Komory",
        nb: "Komorene",
        fi: "Komorit",
        ar: "جزر القمر",
    },
    {
        value: 300,
        prefix: "(GMT+03:00)",
        en: "Djibouti",
        ko: "지부티",
        sc: "吉布提",
        es: "Yibuti",
        ru: "Джибути",
        ja: "ジブチ",
        fr: "Djibouti",
        de: "Dschibuti",
        it: "Gibuti",
        th: "จิบูตี",
        id: "Djibouti",
        vi: "Djibouti",
        nl: "Djibouti",
        pl: "Dżibuti",
        nb: "Djibouti",
        fi: "Djibouti",
        ar: "جيبوتي",
    },
    {
        value: 300,
        prefix: "(GMT+03:00)",
        en: "Elista, Russia",
        ko: "엘리스타, 러시아",
        sc: "俄罗斯埃利斯塔",
        es: "Elistá, Rusia",
        ru: "Элиста, Россия",
        ja: "エリスタ、ロシア",
        fr: "Élista, Russie",
        de: "Elista, Russland",
        it: "Elista, Russia",
        th: "เอลิสตา รัสเซีย",
        id: "Elista, Rusia",
        vi: "Elista, Nga",
        nl: "Elista, Rusland",
        pl: "Elista, Rosja",
        nb: "Elista, Russland",
        fi: "Elista, Venäjä",
        ar: "إليستا ، روسيا",
    },
    {
        value: 300,
        prefix: "(GMT+03:00)",
        en: "Eritrea",
        ko: "에리트레아",
        sc: "厄立特里亚",
        es: "Eritrea",
        ru: "Эритрея",
        ja: "エリトリア",
        fr: "Érythrée",
        de: "Eritrea",
        it: "Eritrea",
        th: "เอริเทรีย",
        id: "Eritrea",
        vi: "Eritrea",
        nl: "Eritrea",
        pl: "Erytrea",
        nb: "Eritrea",
        fi: "Eritrea",
        ar: "إريتريا",
    },
    {
        value: 300,
        prefix: "(GMT+03:00)",
        en: "Ethiopia",
        ko: "에티오피아",
        sc: "埃塞俄比亚",
        es: "Etiopía",
        ru: "Эфиопия",
        ja: "エチオピア",
        fr: "Ethiopie",
        de: "Äthiopien",
        it: "Etiopia",
        th: "เอธิโอเปีย",
        id: "Etiopia",
        vi: "Ethiopia",
        nl: "Ethiopië",
        pl: "Etiopia",
        nb: "Etiopia",
        fi: "Etiopia",
        ar: "أثيوبيا",
    },
    {
        value: 300,
        prefix: "(GMT+03:00)",
        en: "Grozny, Russia",
        ko: "그로즈니, 러시아",
        sc: "俄罗斯格罗兹尼",
        es: "Grozni, Rusia",
        ru: "Грозный, Россия",
        ja: "グロズヌイ、ロシア",
        fr: "Grozny, Russie",
        de: "Grosny, Russland",
        it: "Grozny, Russia",
        th: "กรอซนี รัสเซีย",
        id: "Grozny, Rusia",
        vi: "Grozny, Nga",
        nl: "Grozny, Rusland",
        pl: "Grozny, Rosja",
        nb: "Grozny, Russland",
        fi: "Grozny, Venäjä",
        ar: "غروزني ، روسيا",
    },
    {
        value: 300,
        prefix: "(GMT+03:00)",
        en: "Iraq",
        ko: "이라크",
        sc: "伊拉克",
        es: "Irak",
        ru: "Ирак",
        ja: "イラク",
        fr: "Irak",
        de: "Irak",
        it: "Iraq",
        th: "อิรัก",
        id: "Irak",
        vi: "I-rắc",
        nl: "Irak",
        pl: "Irak",
        nb: "Irak",
        fi: "Irak",
        ar: "العراق",
    },
    {
        value: 300,
        prefix: "(GMT+03:00)",
        en: "Ivanovo, Russia",
        ko: "이바노보, 러시아 ",
        sc: "俄罗斯伊万诺沃",
        es: "Ivánovo, Rusia",
        ru: "Иваново, Россия",
        ja: "イヴァノヴォ、ロシア",
        fr: "Ivanovo, Russie",
        de: "Iwanowo, Russland",
        it: "Ivanovo, Russia",
        th: "อิวาโนโว, รัสเซีย",
        id: "Ivanovo, Rusia",
        vi: "Ivanovo, Nga",
        nl: "Ivanovo, Rusland",
        pl: "Iwanowo, Rosja",
        nb: "Ivanovo, Russland",
        fi: "Ivanovo, Venäjä",
        ar: "إيفانوفو ، روسيا",
    },
    {
        value: 300,
        prefix: "(GMT+03:00)",
        en: "Kaluga, Russia",
        ko: "칼루가, 러시아",
        sc: "俄罗斯卡卢加",
        es: "Kaluga, Rusia",
        ru: "Калуга, Россия",
        ja: "カルーガ、ロシア",
        fr: "Kalouga, Russie",
        de: "Kaluga, Russland",
        it: "Kaluga, Russia",
        th: "คาลูกา, รัสเซีย",
        id: "Kaluga, Rusia",
        vi: "Kaluga, Nga",
        nl: "Kaluga, Rusland",
        pl: "Kaługa, Rosja",
        nb: "Kaluga, Russland",
        fi: "Kaluga, Venäjä",
        ar: "كالوغا ، روسيا",
    },
    {
        value: 300,
        prefix: "(GMT+03:00)",
        en: "Kazan, Russia",
        ko: "카잔, 러시아",
        sc: "俄罗斯喀山",
        es: "Kazán, Rusia",
        ru: "Казань, Россия",
        ja: "カザン、ロシア",
        fr: "Kazan, Russie",
        de: "Kasan, Russland",
        it: "Kazan, Russia",
        th: "คาซาน, รัสเซีย",
        id: "Kazan, Rusia",
        vi: "Kazan, Nga",
        nl: "Kazan, Rusland",
        pl: "Kazań, Rosja",
        nb: "Kazan, Russland",
        fi: "Kazan, Venäjä",
        ar: "قازان ، روسيا",
    },
    {
        value: 300,
        prefix: "(GMT+03:00)",
        en: "Kenya",
        ko: "케냐",
        sc: "肯尼亚",
        es: "Kenia",
        ru: "Кения",
        ja: "ケニア",
        fr: "Kenya",
        de: "Kenia",
        it: "Kenia",
        th: "เคนยา",
        id: "Kenya",
        vi: "Kenya",
        nl: "Kenia",
        pl: "Kenia",
        nb: "Kenya",
        fi: "Kenia",
        ar: "كينيا",
    },
    {
        value: 300,
        prefix: "(GMT+03:00)",
        en: "Kirov, Russia",
        ko: "키로프, 러시아 ",
        sc: "俄罗斯基洛夫",
        es: "Kírov, Rusia",
        ru: "Киров, Россия",
        ja: "キーロフ、ロシア",
        fr: "Kirov, Russie",
        de: "Kirow, Russland",
        it: "Kirov, Russia",
        th: "คิรอฟ รัสเซีย",
        id: "Kirov, Rusia",
        vi: "Kirov, Nga",
        nl: "Kirov, Rusland",
        pl: "Kirow, Rosja",
        nb: "Kirov, Russland",
        fi: "Kirov, Venäjä",
        ar: "كيروف ، روسيا",
    },
    {
        value: 300,
        prefix: "(GMT+03:00)",
        en: "Kostroma, Russia",
        ko: "코스트로마, 러시아 ",
        sc: "俄罗斯科斯特罗马",
        es: "Kostromá, Rusia",
        ru: "Кострома, Россия",
        ja: "コストロマ、ロシア",
        fr: "Kostroma, Russie",
        de: "Kostroma, Russland",
        it: "Kostroma, Russia",
        th: "คอสโตรมา, รัสเซีย",
        id: "Kostroma, Rusia",
        vi: "Kostroma, Nga",
        nl: "Kostroma, Rusland",
        pl: "Kostroma, Rosja",
        nb: "Kostroma, Russland",
        fi: "Kostroma, Venäjä",
        ar: "كوستروما ، روسيا",
    },
    {
        value: 300,
        prefix: "(GMT+03:00)",
        en: "Krasnodar, Russia",
        ko: "크라스노다르, 러시아 ",
        sc: "俄罗斯克拉斯诺达尔",
        es: "Krasnodar, Rusia",
        ru: "Краснодар, Россия",
        ja: "クラスノダール、ロシア",
        fr: "Krasnodar, Russie",
        de: "Krasnodar, Russland",
        it: "Krasnodar, Russia",
        th: "ครัสโนดาร์ รัสเซีย",
        id: "Krasnodar, Rusia",
        vi: "Krasnodar, Nga",
        nl: "Krasnodar, Rusland",
        pl: "Krasnodar, Rosja",
        nb: "Krasnodar, Russland",
        fi: "Krasnodar, Venäjä",
        ar: "كراسنودار ، روسيا",
    },
    {
        value: 300,
        prefix: "(GMT+03:00)",
        en: "Kuwait",
        ko: "쿠웨이트",
        sc: "科威特",
        es: "Kuwait",
        ru: "Кувейт",
        ja: "クウェート",
        fr: "Koweit",
        de: "Kuwait",
        it: "Kuwait",
        th: "คูเวต",
        id: "Kuwait",
        vi: "Kuwait",
        nl: "Koeweit",
        pl: "Kuwejt",
        nb: "Kuwait",
        fi: "Kuwait",
        ar: "الكويت",
    },
    {
        value: 300,
        prefix: "(GMT+03:00)",
        en: "Kursk, Russia",
        ko: "쿠르스크, 러시아 ",
        sc: "俄罗斯库尔斯克",
        es: "Kursk, Rusia",
        ru: "Курск, Россия",
        ja: "クルスク、ロシア",
        fr: "Koursk, Russie",
        de: "Kursk, Russland",
        it: "Kursk, Russia",
        th: "คูสค์, รัสเซีย",
        id: "Kursk, Rusia",
        vi: "Kursk, Nga",
        nl: "Koersk, Rusland",
        pl: "Kursk, Rosja",
        nb: "Kursk, Russland",
        fi: "Kursk, Venäjä",
        ar: "كورسك ، روسيا",
    },
    {
        value: 300,
        prefix: "(GMT+03:00)",
        en: "Lipetsk, Russia",
        ko: "리페츠크, 러시아",
        sc: "俄罗斯利佩茨克",
        es: "Lípetsk, Rusia",
        ru: "Липецк, Россия",
        ja: "リペツク、ロシア",
        fr: "Lipetsk, Russie",
        de: "Lipezk, Russland",
        it: "Lipeck, Russia",
        th: "ลีเปตสค์ รัสเซีย",
        id: "Lipetsk, Rusia",
        vi: "Lipetsk, Nga",
        nl: "Lipetsk, Rusland",
        pl: "Lipieck, Rosja",
        nb: "Lipetsk, Russland",
        fi: "Lipetsk, Venäjä",
        ar: "ليبيتسك ، روسيا",
    },
    {
        value: 300,
        prefix: "(GMT+03:00)",
        en: "Madagascar",
        ko: "마다가스카르",
        sc: "马达加斯加",
        es: "Madagascar",
        ru: "Мадагаскар",
        ja: "マダガスカル",
        fr: "Madagascar",
        de: "Madagaskar",
        it: "Madagascar",
        th: "มาดากัสการ์",
        id: "Madagaskar",
        vi: "Madagascar",
        nl: "Madagascar",
        pl: "Madagaskar",
        nb: "Madagaskar",
        fi: "Madagaskar",
        ar: "مدغشقر",
    },
    {
        value: 300,
        prefix: "(GMT+03:00)",
        en: "Magas, Russia",
        ko: "마가스, 러시아",
        sc: "俄罗斯马加斯",
        es: "Magás, Rusia",
        ru: "Магас, Россия",
        ja: "マガス、ロシア",
        fr: "Magas, Russie",
        de: "Magas, Russland",
        it: "Magas, Russia",
        th: "มากัส รัสเซีย",
        id: "Magas, Rusia",
        vi: "Magas, Nga",
        nl: "Magas, Rusland",
        pl: "Magas, Rosja",
        nb: "Magas, Russland",
        fi: "Magas, Venäjä",
        ar: "ماجاس ، روسيا",
    },
    {
        value: 300,
        prefix: "(GMT+03:00)",
        en: "Makhachkala, Russia",
        ko: "마하치칼라, 러시아",
        sc: "俄罗斯马哈奇卡拉",
        es: "Majachkalá, Rusia",
        ru: "Махачкала, Россия",
        ja: "マハチカラ、ロシア",
        fr: "Makhatchkala, Russie",
        de: "Machatschkala, Russland",
        it: "Machačkala, Russia",
        th: "มาคัชคาลา รัสเซีย",
        id: "Makhachkala, Rusia",
        vi: "Makhachkala, Nga",
        nl: "Makhachkala, Rusland",
        pl: "Machaczkała, Rosja",
        nb: "Makhachkala, Russland",
        fi: "Makhachkala, Venäjä",
        ar: "محج قلعة ، روسيا",
    },
    {
        value: 300,
        prefix: "(GMT+03:00)",
        en: "Maykop, Russia",
        ko: "메이콥, 러시아",
        sc: "俄罗斯梅科普",
        es: "Maykop, Rusia",
        ru: "Майкоп, Россия",
        ja: "マイコープ、ロシア",
        fr: "Maïkop, Russie",
        de: "Maikop, Russland",
        it: "Maykop, Russia",
        th: "มายคอป รัสเซีย",
        id: "Maykop, Rusia",
        vi: "Maykop, Nga",
        nl: "Maykop, Rusland",
        pl: "Majkop, Rosja",
        nb: "Maykop, Russland",
        fi: "Maykop, Venäjä",
        ar: "مايكوب ، روسيا",
    },
    {
        value: 300,
        prefix: "(GMT+03:00)",
        en: "Mayotte",
        ko: "마요트",
        sc: "马约特岛",
        es: "Mayotte",
        ru: "Майотта",
        ja: "マヨット",
        fr: "Mayotte",
        de: "Mayotte",
        it: "Mayotte",
        th: "มายอต",
        id: "mayotte",
        vi: "Mayotte",
        nl: "Mayotte",
        pl: "Majotta",
        nb: "Mayotte",
        fi: "Mayotte",
        ar: "مايوت",
    },
    {
        value: 300,
        prefix: "(GMT+03:00)",
        en: "Moscow, Russia",
        ko: "모스크바, 러시아",
        sc: "俄罗斯莫斯科",
        es: "Moscú, Rusia",
        ru: "Москва, Россия",
        ja: "ロシアのモスクワ",
        fr: "Moscou, Russie",
        de: "Moskau, Russland",
        it: "Mosca, Russia",
        th: "มอสโควประเทศรัสเซีย",
        id: "Moskow, Rusia",
        vi: "Mát-xcơ-va, Nga",
        nl: "Moskou, Rusland",
        pl: "Moskwa, Rosja",
        nb: "Moskva, Russland",
        fi: "Moskova, Venäjä",
        ar: "موسكو، روسيا",
    },
    {
        value: 300,
        prefix: "(GMT+03:00)",
        en: "Murmansk, Russia",
        ko: "무르만스크, 러시아",
        sc: "俄罗斯摩尔曼斯克",
        es: "Múrmansk, Rusia",
        ru: "Мурманск, Россия",
        ja: "ムルマンスク、ロシア",
        fr: "Mourmansk, Russie",
        de: "Murmansk, Russland",
        it: "Murmansk, Russia",
        th: "มูร์มันสค์ รัสเซีย",
        id: "Murmansk, Rusia",
        vi: "Murmansk, Nga",
        nl: "Moermansk, Rusland",
        pl: "Murmańsk, Rosja",
        nb: "Murmansk, Russland",
        fi: "Murmansk, Venäjä",
        ar: "مورمانسك ، روسيا",
    },
    {
        value: 300,
        prefix: "(GMT+03:00)",
        en: "Nalchik, Russia",
        ko: "날치크, 러시아",
        sc: "俄罗斯纳尔奇克",
        es: "Nálchik, Rusia",
        ru: "Нальчик, Россия",
        ja: "ナリチク、ロシア",
        fr: "Naltchik, Russie",
        de: "Naltschik, Russland",
        it: "Nalčik, Russia",
        th: "นัลชิค รัสเซีย",
        id: "Nalchik, Rusia",
        vi: "Nalchik, Nga",
        nl: "Nalchik, Rusland",
        pl: "Nalczyk, Rosja",
        nb: "Nalchik, Russland",
        fi: "Naltshik, Venäjä",
        ar: "نالتشيك ، روسيا",
    },
    {
        value: 300,
        prefix: "(GMT+03:00)",
        en: "Naryan-Mar, Russia",
        ko: "나리얀마르, 러시아 ",
        sc: "俄罗斯纳良马尔",
        es: "Naryan-Mar, Rusia",
        ru: "Нарьян-Мар, Россия",
        ja: "ナリヤンマル、ロシア",
        fr: "Narian-Mar, Russie",
        de: "Naryan-Mar, Russland",
        it: "Naryan-Mar, Russia",
        th: "Naryan-Mar รัสเซีย",
        id: "Naryan-Mar, Rusia",
        vi: "Naryan-Mar, Nga",
        nl: "Naryan-Mar, Rusland",
        pl: "Naryan-Mar, Rosja",
        nb: "Naryan-Mar, Russland",
        fi: "Naryan-Mar, Venäjä",
        ar: "ناريان مار ، روسيا",
    },
    {
        value: 300,
        prefix: "(GMT+03:00)",
        en: "Nizhny Novgorod, Russia",
        ko: "니즈니노브고로드, 러시아",
        sc: "俄罗斯下诺夫哥罗德",
        es: "Nizhni Nóvgorod, Rusia",
        ru: "Нижний Новгород, Россия",
        ja: "ニジニノヴゴロド、ロシア",
        fr: "Nijni Novgorod, Russie",
        de: "Nischni Nowgorod, Russland",
        it: "Nizhny Novgorod, Russia",
        th: "นิชนีย์ นอฟโกรอด รัสเซีย",
        id: "Nizhny Novgorod, Rusia",
        vi: "Nizhny Novgorod, Nga",
        nl: "Nizjni Novgorod, Rusland",
        pl: "Niżny Nowogród, Rosja",
        nb: "Nizhny Novgorod, Russland",
        fi: "Nižni Novgorod, Venäjä",
        ar: "نيجني نوفغورود ، روسيا",
    },
    {
        value: 300,
        prefix: "(GMT+03:00)",
        en: "Oryol, Russia",
        ko: "오뇰, 러시아 ",
        sc: "俄罗斯奥廖尔",
        es: "Oriol, Rusia",
        ru: "Орёл, Россия",
        ja: "オリョール、ロシア",
        fr: "Orel, Russie",
        de: "Orjol, Russland",
        it: "Orël, Russia",
        th: "โอริออล, รัสเซีย",
        id: "Oryol, Rusia",
        vi: "Oryol, Nga",
        nl: "Orjol, Rusland",
        pl: "Oryol, Rosja",
        nb: "Oryol, Russland",
        fi: "Oryol, Venäjä",
        ar: "أوريول ، روسيا",
    },
    {
        value: 300,
        prefix: "(GMT+03:00)",
        en: "Penza, Russia",
        ko: "펜자, 러시아",
        sc: "俄罗斯奔萨",
        es: "Penza, Rusia",
        ru: "Пенза, Россия",
        ja: "ペンザ、ロシア",
        fr: "Penza, Russie",
        de: "Pensa, Russland",
        it: "Penza, Russia",
        th: "เพนซา รัสเซีย",
        id: "Penza, Rusia",
        vi: "Penza, Nga",
        nl: "Penza, Rusland",
        pl: "Penza, Rosja",
        nb: "Penza, Russland",
        fi: "Penza, Venäjä",
        ar: "بينزا ، روسيا",
    },
    {
        value: 300,
        prefix: "(GMT+03:00)",
        en: "Petrozavodsk, Russia",
        ko: "페트로자보츠크, 러시아",
        sc: "俄罗斯彼得罗扎沃茨克",
        es: "Petrozavodsk, Rusia",
        ru: "Петрозаводск, Россия",
        ja: "ペトロザボーツク、ロシア",
        fr: "Petrozavodsk, Russie",
        de: "Petrosawodsk, Russland",
        it: "Petrozavodsk, Russia",
        th: "เปโตรซาวอดสค์ รัสเซีย",
        id: "Petrozavodsk, Rusia",
        vi: "Petrozavodsk, Nga",
        nl: "Petrozavodsk, Rusland",
        pl: "Pietrozawodsk, Rosja",
        nb: "Petrozavodsk, Russland",
        fi: "Petroskoi, Venäjä",
        ar: "بتروزافودسك ، روسيا",
    },
    {
        value: 300,
        prefix: "(GMT+03:00)",
        en: "Pskov, Russia",
        ko: "프스코프, 러시아",
        sc: "俄罗斯普斯科夫",
        es: "Pskov, Rusia",
        ru: "Псков, Россия",
        ja: "プスコフ、ロシア",
        fr: "Pskov, Russie",
        de: "Pskow, Russland",
        it: "Pskov, Russia",
        th: "ปัสคอฟ รัสเซีย",
        id: "Pskov, Rusia",
        vi: "Pskov, Nga",
        nl: "Pskov, Rusland",
        pl: "Psków, Rosja",
        nb: "Pskov, Russland",
        fi: "Pihkova, Venäjä",
        ar: "بسكوف ، روسيا",
    },
    {
        value: 300,
        prefix: "(GMT+03:00)",
        en: "Qatar",
        ko: "카타르",
        sc: "卡塔尔",
        es: "Katar",
        ru: "Катар",
        ja: "カタール",
        fr: "Qatar",
        de: "Katar",
        it: "Qatar",
        th: "กาตาร์",
        id: "Qatar",
        vi: "Qatar",
        nl: "Qatar",
        pl: "Katar",
        nb: "Qatar",
        fi: "Qatar",
        ar: "دولة قطر",
    },
    {
        value: 300,
        prefix: "(GMT+03:00)",
        en: "Rostov-on-Don, Russia",
        ko: "로스토프나도누, 러시아",
        sc: "俄罗斯顿河畔罗斯托夫",
        es: "Rostov del Don, Rusia",
        ru: "Ростов-на-Дону, Россия",
        ja: "ロストフオンドン、ロシア",
        fr: "Rostov-sur-le-Don, Russie",
        de: "Rostow am Don, Russland",
        it: "Rostov sul Don, Russia",
        th: "รอสตอฟ ออนดอน รัสเซีย",
        id: "Rostov-on-Don, Rusia",
        vi: "Rostov-on-Don, Nga",
        nl: "Rostov aan de Don, Rusland",
        pl: "Rostów nad Donem, Rosja",
        nb: "Rostov ved Don, Russland",
        fi: "Rostov-on-Don, Venäjä",
        ar: "روستوف أون دون ، روسيا",
    },
    {
        value: 300,
        prefix: "(GMT+03:00)",
        en: "Ryazan, Russia",
        ko: "랴잔, 러시아",
        sc: "俄罗斯梁赞",
        es: "Riazán, Rusia",
        ru: "Рязань, Россия",
        ja: "リャザン、ロシア",
        fr: "Riazan, Russie",
        de: "Rjasan, Russland",
        it: "Riazán, Russia",
        th: "เรียซัน, รัสเซีย",
        id: "Ryazan, Rusia",
        vi: "Ryazan, Nga",
        nl: "Ryazan, Rusland",
        pl: "Riazań, Rosja",
        nb: "Ryazan, Russland",
        fi: "Ryazan, Venäjä",
        ar: "ريازان ، روسيا",
    },
    {
        value: 300,
        prefix: "(GMT+03:00)",
        en: "Saint Petersburg, Russia",
        ko: "상트페테르부르크, 러시아",
        sc: "俄罗斯圣彼得堡",
        es: "San Petersburgo, Rusia",
        ru: "Санкт-Петербург, Россия",
        ja: "サンクトペテルブルク、ロシア",
        fr: "Saint-Pétersbourg, Russie",
        de: "Sankt Petersburg, Russland",
        it: "San Pietroburgo, Russia",
        th: "เซนต์ปีเตอร์สเบิร์ก รัสเซีย",
        id: "Saint Petersburg, Rusia",
        vi: "Saint Petersburg, Nga",
        nl: "Sint-Petersburg, Rusland",
        pl: "Sankt Petersburg, Rosja",
        nb: "Sankt Petersburg, Russland",
        fi: "Pietari, Venäjä",
        ar: "سانت بطرسبرغ ، روسيا",
    },
    {
        value: 300,
        prefix: "(GMT+03:00)",
        en: "Saransk, Russia",
        ko: "사란스크, 러시아",
        sc: "俄罗斯萨兰斯克",
        es: "Saransk, Rusia",
        ru: "Саранск, Россия",
        ja: "サランスク、ロシア",
        fr: "Saransk, Russie",
        de: "Saransk, Russland",
        it: "Saransk, Russia",
        th: "ซารันสค์ รัสเซีย",
        id: "Saransk, Rusia",
        vi: "Saransk, Nga",
        nl: "Saransk, Rusland",
        pl: "Sarańsk, Rosja",
        nb: "Saransk, Russland",
        fi: "Saransk, Venäjä",
        ar: "سارانسك ، روسيا",
    },
    {
        value: 300,
        prefix: "(GMT+03:00)",
        en: "Saratov, Russia",
        ko: "사라토프, 러시아",
        sc: "俄罗斯萨拉托夫",
        es: "Sarátov, Rusia",
        ru: "Саратов, Россия",
        ja: "サラトフ、ロシア",
        fr: "Saratov, Russie",
        de: "Saratow, Russland",
        it: "Saratov, Russia",
        th: "ซาราตอฟ รัสเซีย",
        id: "Saratov, Rusia",
        vi: "Saratov, Nga",
        nl: "Saratov, Rusland",
        pl: "Saratów, Rosja",
        nb: "Saratov, Russland",
        fi: "Saratov, Venäjä",
        ar: "ساراتوف ، روسيا",
    },
    {
        value: 300,
        prefix: "(GMT+03:00)",
        en: "Saudi Arabia",
        ko: "사우디 아라비아",
        sc: "沙特阿拉伯",
        es: "Arabia Saudita",
        ru: "Саудовская Аравия",
        ja: "サウジアラビア",
        fr: "Arabie Saoudite",
        de: "Saudi-Arabien",
        it: "Arabia Saudita",
        th: "ซาอุดิอาราเบีย",
        id: "Arab Saudi",
        vi: "Ả Rập Saudi",
        nl: "Saoedi-Arabië",
        pl: "Arabia Saudyjska",
        nb: "Saudi-Arabia",
        fi: "Saudi-Arabia",
        ar: "المملكة العربية السعودية",
    },
    {
        value: 300,
        prefix: "(GMT+03:00)",
        en: "Sevastopol, Russia",
        ko: "세바스토폴, 러시아",
        sc: "俄罗斯塞瓦斯托波尔",
        es: "Sebastopol, Rusia",
        ru: "Севастополь, Россия",
        ja: "セヴァストポリ、ロシア",
        fr: "Sébastopol, Russie",
        de: "Sewastopol, Russland",
        it: "Sebastopoli, Russia",
        th: "เซวาสโทพอล รัสเซีย",
        id: "Sevastopol, Rusia",
        vi: "Sevastopol, Nga",
        nl: "Sebastopol, Rusland",
        pl: "Sewastopol, Rosja",
        nb: "Sevastopol, Russland",
        fi: "Sevastopol, Venäjä",
        ar: "سيفاستوبول ، روسيا",
    },
    {
        value: 300,
        prefix: "(GMT+03:00)",
        en: "Simferopol, Russia",
        ko: "심페로폴, 러시아",
        sc: "俄罗斯辛菲罗波尔",
        es: "Simferópol, Rusia",
        ru: "Симферополь, Россия",
        ja: "シンフェロポリ、ロシア",
        fr: "Simferopol, Russie",
        de: "Simferopol, Russland",
        it: "Simferopoli, Russia",
        th: "ซิมเฟอโรโพล รัสเซีย",
        id: "Simferopol, Rusia",
        vi: "Simferopol, Nga",
        nl: "Simferopol, Rusland",
        pl: "Symferopol, Rosja",
        nb: "Simferopol, Russland",
        fi: "Simferopol, Venäjä",
        ar: "سيمفيروبول ، روسيا",
    },
    {
        value: 300,
        prefix: "(GMT+03:00)",
        en: "Smolensk, Russia",
        ko: "스몰렌스크, 러시아",
        sc: "俄罗斯斯摩棱斯克",
        es: "Smolensk, Rusia",
        ru: "Смоленск, Россия",
        ja: "スモレンスク、ロシア",
        fr: "Smolensk, Russie",
        de: "Smolensk, Russland",
        it: "Smolensk, Russia",
        th: "สโมเลนสค์ รัสเซีย",
        id: "Smolensk, Rusia",
        vi: "Smolensk, Nga",
        nl: "Smolensk, Rusland",
        pl: "Smoleńsk, Rosja",
        nb: "Smolensk, Russland",
        fi: "Smolensk, Venäjä",
        ar: "سمولينسك ، روسيا",
    },
    {
        value: 300,
        prefix: "(GMT+03:00)",
        en: "Somalia",
        ko: "소말리아",
        sc: "索马里",
        es: "Somalia",
        ru: "Сомали",
        ja: "ソマリア",
        fr: "Somalie",
        de: "Somalia",
        it: "Somalia",
        th: "โซมาเลีย",
        id: "Somalia",
        vi: "Somalia",
        nl: "Somalië",
        pl: "Somali",
        nb: "Somalia",
        fi: "Somalia",
        ar: "الصومال",
    },
    {
        value: 300,
        prefix: "(GMT+03:00)",
        en: "Stavropol, Russia",
        ko: "스타브로폴, 러시아",
        sc: "俄罗斯斯塔夫罗波尔",
        es: "Stavropol, Rusia",
        ru: "Ставрополь, Россия",
        ja: "スタヴロポリ、ロシア",
        fr: "Stavropol, Russie",
        de: "Stawropol, Russland",
        it: "Stavropol, Russia",
        th: "สตัฟโรปอล, รัสเซีย",
        id: "Stavropol, Rusia",
        vi: "Stavropol, Nga",
        nl: "Stavropol, Rusland",
        pl: "Stawropol, Rosja",
        nb: "Stavropol, Russland",
        fi: "Stavropol, Venäjä",
        ar: "ستافروبول ، روسيا",
    },
    {
        value: 300,
        prefix: "(GMT+03:00)",
        en: "Syktyvkar, Russia",
        ko: "식티프카르, 러시아",
        sc: "俄罗斯塞克特夫卡尔",
        es: "Syktyvkar, Rusia",
        ru: "Сыктывкар, Россия",
        ja: "シクティフカル、ロシア",
        fr: "Syktyvkar, Russie",
        de: "Syktywkar, Russland",
        it: "Syktyvkar, Russia",
        th: "ซิคทิฟคาร์ รัสเซีย",
        id: "Syktyvkar, Rusia",
        vi: "Syktyvkar, Nga",
        nl: "Syktyvkar, Rusland",
        pl: "Syktywkar, Rosja",
        nb: "Syktyvkar, Russland",
        fi: "Syktyvkar, Venäjä",
        ar: "سيكتيفكار ، روسيا",
    },
    {
        value: 300,
        prefix: "(GMT+03:00)",
        en: "Tambov, Russia",
        ko: "탐보프, 러시아",
        sc: "俄罗斯坦波夫",
        es: "Tambov, Rusia",
        ru: "Тамбов, Россия",
        ja: "タンボフ、ロシア",
        fr: "Tambov, Russie",
        de: "Tambow, Russland",
        it: "Tambov, Russia",
        th: "ตัมบอฟ รัสเซีย",
        id: "Tambov, Rusia",
        vi: "Tambov, Nga",
        nl: "Tambov, Rusland",
        pl: "Tambow, Rosja",
        nb: "Tambov, Russland",
        fi: "Tambov, Venäjä",
        ar: "تامبوف ، روسيا",
    },
    {
        value: 300,
        prefix: "(GMT+03:00)",
        en: "Tanzania",
        ko: "탄자니아",
        sc: "坦桑尼亚",
        es: "Tanzania",
        ru: "Танзания",
        ja: "タンザニア",
        fr: "Tanzanie",
        de: "Tansania",
        it: "Tanzania",
        th: "แทนซาเนีย",
        id: "Tanzania",
        vi: "Tanzania",
        nl: "Tanzania",
        pl: "Tanzania",
        nb: "Tanzania",
        fi: "Tansania",
        ar: "تنزانيا",
    },
    {
        value: 300,
        prefix: "(GMT+03:00)",
        en: "Tula, Russia",
        ko: "툴라, 러시아",
        sc: "俄罗斯图拉",
        es: "Tula, Rusia",
        ru: "Тула, Россия",
        ja: "トゥーラ、ロシア",
        fr: "Toula, Russie",
        de: "Tula, Russland",
        it: "Tula, Russia",
        th: "ทูลา รัสเซีย",
        id: "Tula, Rusia",
        vi: "Tula, Nga",
        nl: "Tula, Rusland",
        pl: "Tuła, Rosja",
        nb: "Tula, Russland",
        fi: "Tula, Venäjä",
        ar: "تولا ، روسيا",
    },
    {
        value: 300,
        prefix: "(GMT+03:00)",
        en: "Turkey (Türkiye)",
        ko: "터키(튀르키예)",
        sc: "土耳其",
        es: "Turquía (Türkiye)",
        ru: "Турция (Türkiye)",
        ja: "トルコ（Türkiye）",
        fr: "Turquie (Türkiye)",
        de: "Türkei (Türkiye)",
        it: "Turchia (Turchia)",
        th: "ตุรกี (Türkiye)",
        id: "Turki (Turkiye)",
        vi: "Thổ Nhĩ Kỳ (Türkiye)",
        nl: "Turkije",
        pl: "Turcja (Turcja)",
        nb: "Tyrkia (Türkiye)",
        fi: "Turkki (Türkiye)",
        ar: "تركيا (Türkiye)",
    },
    {
        value: 300,
        prefix: "(GMT+03:00)",
        en: "Tver, Russia",
        ko: "트베르, 러시아",
        sc: "俄罗斯特维尔",
        es: "Tver, Rusia",
        ru: "Тверь, Россия",
        ja: "トヴェリ、ロシア",
        fr: "Tver, Russie",
        de: "Twer, Russland",
        it: "Tver, Russia",
        th: "ตเวียร์, รัสเซีย",
        id: "Tver, Rusia",
        vi: "Tver, Nga",
        nl: "Tver, Rusland",
        pl: "Twer, Rosja",
        nb: "Tver, Russland",
        fi: "Tver, Venäjä",
        ar: "تفير ، روسيا",
    },
    {
        value: 300,
        prefix: "(GMT+03:00)",
        en: "Uganda",
        ko: "우간다",
        sc: "乌干达",
        es: "Uganda",
        ru: "Уганда",
        ja: "ウガンダ",
        fr: "Ouganda",
        de: "Uganda",
        it: "Uganda",
        th: "ยูกันดา",
        id: "Uganda",
        vi: "Uganda",
        nl: "Oeganda",
        pl: "Uganda",
        nb: "Uganda",
        fi: "Uganda",
        ar: "أوغندا",
    },
    {
        value: 300,
        prefix: "(GMT+03:00)",
        en: "Veliky Novgorod, Russia",
        ko: "벨리키 노브고로드, 러시아",
        sc: "俄罗斯大诺夫哥罗德",
        es: "Veliky Nóvgorod, Rusia",
        ru: "Великий Новгород, Россия",
        ja: "ノヴゴロド、ロシア",
        fr: "Veliki Novgorod, Russie",
        de: "Weliki Nowgorod, Russland",
        it: "Velikij Novgorod, Russia",
        th: "เวลิกี นอฟโกรอด รัสเซีย",
        id: "Veliky Novgorod, Rusia",
        vi: "Veliky Novgorod, Nga",
        nl: "Veliki Novgorod, Rusland",
        pl: "Nowogród Wielki, Rosja",
        nb: "Veliky Novgorod, Russland",
        fi: "Veliki Novgorod, Venäjä",
        ar: "فيليكي نوفغورود ، روسيا",
    },
    {
        value: 300,
        prefix: "(GMT+03:00)",
        en: "Vladimir, Russia",
        ko: "블라디미르, 러시아",
        sc: "俄罗斯弗拉基米尔",
        es: "Vladímir, Rusia",
        ru: "Владимир, Россия",
        ja: "ウラジミール、ロシア",
        fr: "Vladimir, Russie",
        de: "Wladimir, Russland",
        it: "Vladimir, Russia",
        th: "วลาดิเมียร์ รัสเซีย",
        id: "Vladimir, Rusia",
        vi: "Vladimir, Nga",
        nl: "Vladimir, Rusland",
        pl: "Włodzimierz, Rosja",
        nb: "Vladimir, Russland",
        fi: "Vladimir, Venäjä",
        ar: "فلاديمير ، روسيا",
    },
    {
        value: 300,
        prefix: "(GMT+03:00)",
        en: "Vladikavkaz, Russia",
        ko: "블라디카프카즈, 러시아",
        sc: "俄罗斯弗拉季高加索",
        es: "Vladikavkaz, Rusia",
        ru: "Владикавказ, Россия",
        ja: "ウラジカフカス、ロシア",
        fr: "Vladikavkaz, Russie",
        de: "Wladikawkas, Russland",
        it: "Vladikavkaz, Russia",
        th: "วลาดิคัฟคัซ รัสเซีย",
        id: "Vladikavkaz, Rusia",
        vi: "Vladikavkaz, Nga",
        nl: "Vladikavkaz, Rusland",
        pl: "Władykaukaz, Rosja",
        nb: "Vladikavkaz, Russland",
        fi: "Vladikavkaz, Venäjä",
        ar: "فلاديكافكاز ، روسيا",
    },
    {
        value: 300,
        prefix: "(GMT+03:00)",
        en: "Volgograd, Russia",
        ko: "볼고그라드, 러시아",
        sc: "俄罗斯伏尔加格勒",
        es: "Volgogrado, Rusia",
        ru: "Волгоград, Россия",
        ja: "ヴォルゴグラード、ロシア",
        fr: "Volgograd, Russie",
        de: "Wolgograd, Russland",
        it: "Volgograd, Russia",
        th: "โวลโกกราด รัสเซีย",
        id: "Volgograd, Rusia",
        vi: "Volgograd, Nga",
        nl: "Volgograd, Rusland",
        pl: "Wołgograd, Rosja",
        nb: "Volgograd, Russland",
        fi: "Volgograd, Venäjä",
        ar: "فولغوغراد ، روسيا",
    },
    {
        value: 300,
        prefix: "(GMT+03:00)",
        en: "Vologda, Russia",
        ko: "볼로그다, 러시아",
        sc: "俄罗斯沃洛格达",
        es: "Vólogda, Rusia",
        ru: "Вологда, Россия",
        ja: "ヴォログダ、ロシア",
        fr: "Vologda, Russie",
        de: "Wologda, Russland",
        it: "Vologda, Russia",
        th: "โวลอกดา, รัสเซีย",
        id: "Vologda, Rusia",
        vi: "Vologda, Nga",
        nl: "Vologda, Rusland",
        pl: "Wołogda, Rosja",
        nb: "Vologda, Russland",
        fi: "Vologda, Venäjä",
        ar: "فولوغدا ، روسيا",
    },
    {
        value: 300,
        prefix: "(GMT+03:00)",
        en: "Voronezh, Russia",
        ko: "보로네시, 러시아",
        sc: "俄罗斯沃罗涅日",
        es: "Vorónezh, Rusia",
        ru: "Воронеж, Россия",
        ja: "ヴォロネジ、ロシア",
        fr: "Voronej, Russie",
        de: "Woronesch, Russland",
        it: "Voronez, Russia",
        th: "โวโรเนจ รัสเซีย",
        id: "Voronezh, Rusia",
        vi: "Voronezh, Nga",
        nl: "Voronezj, Rusland",
        pl: "Woroneż, Rosja",
        nb: "Voronezh, Russland",
        fi: "Voronezh, Venäjä",
        ar: "فورونيج ، روسيا",
    },
    {
        value: 300,
        prefix: "(GMT+03:00)",
        en: "Yaroslavl, Russia",
        ko: "야로슬라블, 러시아",
        sc: "俄罗斯雅罗斯拉夫尔",
        es: "Yaroslavl, Rusia",
        ru: "Ярославль, Россия",
        ja: "ヤロスラヴリ、ロシア",
        fr: "Iaroslavl, Russie",
        de: "Jaroslawl, Russland",
        it: "Jaroslavl, Russia",
        th: "ยาโรสลาฟล์, รัสเซีย",
        id: "Yaroslavl, Rusia",
        vi: "Yaroslavl, Nga",
        nl: "Yaroslavl, Rusland",
        pl: "Jarosław, Rosja",
        nb: "Yaroslavl, Russland",
        fi: "Jaroslavl, Venäjä",
        ar: "ياروسلافل ، روسيا",
    },
    {
        value: 300,
        prefix: "(GMT+03:00)",
        en: "Yemen",
        ko: "예멘",
        sc: "也门",
        es: "Yemen",
        ru: "Йемен",
        ja: "イエメン",
        fr: "Yémen",
        de: "Jemen",
        it: "Yemen",
        th: "เยเมน",
        id: "Yaman",
        vi: "Yemen",
        nl: "Jemen",
        pl: "Jemen",
        nb: "Jemen",
        fi: "Jemen",
        ar: "اليمن",
    },
    {
        value: 300,
        prefix: "(GMT+03:00)",
        en: "Yoshkar-Ola, Russia",
        ko: "요시카르올라, 러시아",
        sc: "俄罗斯约什卡尔奥拉",
        es: "Yoshkar-Ola, Rusia",
        ru: "Йошкар-Ола, Россия",
        ja: "ヨシュカル・オラ、ロシア",
        fr: "Iochkar-Ola, Russie",
        de: "Joschkar-Ola, Russland",
        it: "Yoshkar-Ola, Russia",
        th: "ยอชคาร์-โอลา, รัสเซีย",
        id: "Yoshikar-Ola, Rusia",
        vi: "Yoshkar-Ola, Nga",
        nl: "Yoshkar-Ola, Rusland",
        pl: "Joszkar-Ola, Rosja",
        nb: "Yoshkar-Ola, Russland",
        fi: "Joškar-Ola, Venäjä",
        ar: "يوشكار أولا ، روسيا",
    },
    {
        value: 330,
        prefix: "(GMT+03:30)",
        en: "Iran",
        ko: "이란",
        sc: "伊朗",
        es: "Irán",
        ru: "Иран",
        ja: "イラン",
        fr: "L'Iran",
        de: "Iran",
        it: "Iran",
        th: "อิหร่าน",
        id: "Iran",
        vi: "Iran",
        nl: "Iran",
        pl: "Iran",
        nb: "Iran",
        fi: "Iran",
        ar: "إيران",
    },
    {
        value: 400,
        prefix: "(GMT+04:00)",
        en: "Armenia",
        ko: "아르메니아",
        sc: "亚美尼亚",
        es: "Armenia",
        ru: "Армения",
        ja: "アルメニア",
        fr: "Arménie",
        de: "Armenien",
        it: "Armenia",
        th: "อาร์เมเนีย",
        id: "Armenia",
        vi: "Armenia",
        nl: "Armenië",
        pl: "Armenia",
        nb: "Armenia",
        fi: "Armenia",
        ar: "أرمينيا",
    },
    {
        value: 400,
        prefix: "(GMT+04:00)",
        en: "Astrakhan, Russia",
        ko: "아스트라한, 러시아",
        sc: "俄罗斯阿斯特拉罕",
        es: "Astracán, Rusia",
        ru: "Астрахань, Россия",
        ja: "アストラハン、ロシア",
        fr: "Astrakhan, Russie",
        de: "Astrachan, Russland",
        it: "Astrachan, Russia",
        th: "อัสตราคาน รัสเซีย",
        id: "Astrakhan, Rusia",
        vi: "Astrakhan, Nga",
        nl: "Astrachan, Rusland",
        pl: "Astrachań, Rosja",
        nb: "Astrakhan, Russland",
        fi: "Astrakhan, Venäjä",
        ar: "استراخان ، روسيا",
    },
    {
        value: 400,
        prefix: "(GMT+04:00)",
        en: "Azerbaijan",
        ko: "아제르바이잔",
        sc: "阿塞拜疆",
        es: "Azerbaiyán",
        ru: "Азербайджан",
        ja: "アゼルバイジャン",
        fr: "Azerbaïdjan",
        de: "Aserbaidschan",
        it: "Azerbaigian",
        th: "อาเซอร์ไบจาน",
        id: "Azerbaijan",
        vi: "Azerbaijan",
        nl: "Azerbeidzjan",
        pl: "Azerbejdżan",
        nb: "Aserbajdsjan",
        fi: "Azerbaidžan",
        ar: "أذربيجان",
    },
    {
        value: 400,
        prefix: "(GMT+04:00)",
        en: "Georgia",
        ko: "조지아",
        sc: "乔治亚州",
        es: "Georgia",
        ru: "Грузия",
        ja: "ジョージア",
        fr: "Géorgie",
        de: "Georgia",
        it: "Georgia",
        th: "จอร์เจีย",
        id: "Georgia",
        vi: "Georgia",
        nl: "Georgië",
        pl: "Gruzja",
        nb: "Georgia",
        fi: "Georgia",
        ar: "جورجيا",
    },
    {
        value: 400,
        prefix: "(GMT+04:00)",
        en: "Izhevsk, Russia",
        ko: "이젭스크, 러시아",
        sc: "俄罗斯伊热夫斯克",
        es: "Izhevsk, Rusia",
        ru: "Ижевск, Россия",
        ja: "イジェフスク、ロシア",
        fr: "Ijevsk, Russie",
        de: "Ischewsk, Russland",
        it: "Iževsk, Russia",
        th: "อีเจฟสค์ รัสเซีย",
        id: "Izhevsk, Rusia",
        vi: "Izhevsk, Nga",
        nl: "Izjevsk, Rusland",
        pl: "Iżewsk, Rosja",
        nb: "Izhevsk, Russland",
        fi: "Izhevsk, Venäjä",
        ar: "إيجيفسك ، روسيا",
    },
    {
        value: 400,
        prefix: "(GMT+04:00)",
        en: "Mauritius",
        ko: "모리셔스",
        sc: "毛里求斯",
        es: "Mauricio",
        ru: "Маврикий",
        ja: "モーリシャス",
        fr: "Maurice",
        de: "Mauritius",
        it: "Maurizio",
        th: "มอริเชียส",
        id: "Mauritius",
        vi: "Mauritius",
        nl: "Mauritius",
        pl: "Mauritius",
        nb: "Mauritius",
        fi: "Mauritius",
        ar: "موريشيوس",
    },
    {
        value: 400,
        prefix: "(GMT+04:00)",
        en: "Oman",
        ko: "오만",
        sc: "阿曼",
        es: "Omán",
        ru: "Оман",
        ja: "オマーン",
        fr: "Oman",
        de: "Oman",
        it: "Oman",
        th: "โอมาน",
        id: "Oman",
        vi: "Oman",
        nl: "Oman",
        pl: "Oman",
        nb: "Oman",
        fi: "Oman",
        ar: "سلطنة عمان",
    },
    {
        value: 400,
        prefix: "(GMT+04:00)",
        en: "Réunion",
        ko: "레이뉘옹",
        sc: "Réunion",
        es: "Reunión",
        ru: "Реюньон",
        ja: "レユニオン",
        fr: "Réunion",
        de: "Réunion",
        it: "La Riunione",
        th: "เรอูว์นียง",
        id: "Réunion",
        vi: "Réunion",
        nl: "Réunion",
        pl: "Reunion",
        nb: "Réunion",
        fi: "Réunion",
        ar: "لا ريونيون",
    },
    {
        value: 400,
        prefix: "(GMT+04:00)",
        en: "Samara, Russia",
        ko: "사마라, 러시아",
        sc: "俄罗斯萨马拉",
        es: "Samara, Rusia",
        ru: "Самара, Россия",
        ja: "サマラ、ロシア",
        fr: "Samara, Russie",
        de: "Samara, Russland",
        it: "Samara, Russia",
        th: "ซามารา รัสเซีย",
        id: "Samara, Rusia",
        vi: "Samara, Nga",
        nl: "Samara, Rusland",
        pl: "Samara, Rosja",
        nb: "Samara, Russland",
        fi: "Samara, Venäjä",
        ar: "سامارا ، روسيا",
    },
    {
        value: 400,
        prefix: "(GMT+04:00)",
        en: "Seychelles",
        ko: "세이셸",
        sc: "塞舌尔",
        es: "Seychelles",
        ru: "Сейшелы",
        ja: "セイシェル",
        fr: "les Seychelles",
        de: "Seychellen",
        it: "Seychelles",
        th: "เซเชลส์",
        id: "Seychelles",
        vi: "Seychelles",
        nl: "Seychellen",
        pl: "Seszele",
        nb: "Seychellene",
        fi: "Seychellit",
        ar: "سيشيل",
    },
    {
        value: 400,
        prefix: "(GMT+04:00)",
        en: "Ulyanovsk, Russia",
        ko: "울리야놉스크, 러시아",
        sc: "俄罗斯乌里扬诺夫斯克",
        es: "Uliánovsk, Rusia",
        ru: "Ульяновск, Россия",
        ja: "ウリヤノフスク、ロシア",
        fr: "Oulianovsk, Russie",
        de: "Uljanowsk, Russland",
        it: "Ulyanovsk, Russia",
        th: "อุลยานอฟสค์ รัสเซีย",
        id: "Ulyanovsk, Rusia",
        vi: "Ulyanovsk, Nga",
        nl: "Oeljanovsk, Rusland",
        pl: "Uljanowsk, Rosja",
        nb: "Ulyanovsk, Russland",
        fi: "Uljanovski, Venäjä",
        ar: "أوليانوفسك ، روسيا",
    },
    {
        value: 400,
        prefix: "(GMT+04:00)",
        en: "United Arab Emirates",
        ko: "아랍 에미리트",
        sc: "阿拉伯联合酋长国",
        es: "Emiratos Árabes Unidos",
        ru: "Объединенные Арабские Эмираты",
        ja: "アラブ首長国連邦",
        fr: "Emirats Arabes Unis",
        de: "Vereinigte Arabische Emirate",
        it: "Emirati Arabi Uniti",
        th: "สหรัฐอาหรับเอมิเรตส์",
        id: "Uni Emirat Arab",
        vi: "các Tiểu Vương Quốc Ả Rập Thống Nhất",
        nl: "Verenigde Arabische Emiraten",
        pl: "Zjednoczone Emiraty Arabskie",
        nb: "De forente arabiske emirater",
        fi: "Yhdistyneet Arabiemiirikunnat",
        ar: "الإمارات العربية المتحدة",
    },
    {
        value: 430,
        prefix: "(GMT+04:30)",
        en: "Afghanistan",
        ko: "아프가니스탄",
        sc: "阿富汗",
        es: "Afganistán",
        ru: "Афганистан",
        ja: "アフガニスタン",
        fr: "Afghanistan",
        de: "Afghanistan",
        it: "Afghanistan",
        th: "อัฟกานิสถาน",
        id: "Afganistan",
        vi: "Afghanistan",
        nl: "Afghanistan",
        pl: "Afganistan",
        nb: "Afghanistan",
        fi: "Afganistan",
        ar: "أفغانستان",
    },
    {
        value: 500,
        prefix: "(GMT+05:00)",
        en: "Chelyabinsk, Russia",
        ko: "첼랴빈스크, 러시아",
        sc: "俄罗斯车里雅宾斯克",
        es: "Cheliábinsk, Rusia",
        ru: "Челябинск, Россия",
        ja: "チェリャビンスク、ロシア",
        fr: "Tcheliabinsk, Russie",
        de: "Tscheljabinsk, Russland",
        it: "Chelyabinsk, Russia",
        th: "เชเลียบินสค์ รัสเซีย",
        id: "Chelyabinsk, Rusia",
        vi: "Chelyabinsk, Nga",
        nl: "Tsjeljabinsk, Rusland",
        pl: "Czelabińsk, Rosja",
        nb: "Chelyabinsk, Russland",
        fi: "Tšeljabinsk, Venäjä",
        ar: "تشيليابينسك ، روسيا",
    },
    {
        value: 500,
        prefix: "(GMT+05:00)",
        en: "Kazakhstan, western part",
        ko: "카자흐스탄, 서부",
        sc: "哈萨克斯坦，西部",
        es: "Kazajstán, parte occidental",
        ru: "Казахстан, западная часть",
        ja: "カザフスタン、西部",
        fr: "Kazakhstan, partie ouest",
        de: "Kasachstan, westlicher Teil",
        it: "Kazakistan, parte occidentale",
        th: "คาซัคสถาน ทางตะวันตก",
        id: "Kazakstan, bagian barat",
        vi: "Kazakhstan, phần phía tây",
        nl: "Kazachstan, westelijk deel",
        pl: "Kazachstan, część zachodnia",
        nb: "Kasakhstan, den vestlige delen",
        fi: "Kazakstan, länsiosa",
        ar: "كازاخستان الجزء الغربي",
    },
    {
        value: 500,
        prefix: "(GMT+05:00)",
        en: "Kerguelen Islands",
        ko: "케르겔렌 제도",
        sc: "凯尔盖朗群岛",
        es: "Islas Kerguelén",
        ru: "Острова Кергелен",
        ja: "ケルゲレン諸島",
        fr: "Îles Kerguelen",
        de: "Kerguelen-Inseln",
        it: "Isole Kerguelen",
        th: "หมู่เกาะ Kerguelen",
        id: "Kepulauan Kerguelen",
        vi: "Quần đảo Kerguelen",
        nl: "Kerguelen-eilanden",
        pl: "Wyspy Kerguelena",
        nb: "Kerguelen-øyene",
        fi: "Kerguelenin saaret",
        ar: "جزر كيرغولين",
    },
    {
        value: 500,
        prefix: "(GMT+05:00)",
        en: "Khanty-Mansiysk, Russia",
        ko: "한티만시스크, 러시아",
        sc: "俄罗斯汉特-曼西斯克",
        es: "Khanty-Mansiysk, Rusia",
        ru: "Ханты-Мансийск, Россия",
        ja: "ハンティ・マンシースク、ロシア",
        fr: "Khanty-Mansiysk, Russie",
        de: "Chanty-Mansijsk, Russland",
        it: "Khanty-Mansijsk, Russia",
        th: "Khanty-Mansiysk รัสเซีย",
        id: "Khanty-Mansiysk, Rusia",
        vi: "Khanty-Mansiysk, Nga",
        nl: "Khanty-Mansiysk, Rusland",
        pl: "Chanty-Mansyjsk, Rosja",
        nb: "Khanty-Mansiysk, Russland",
        fi: "Hanti-Mansiysk, Venäjä",
        ar: "خانتي مانسيسك ، روسيا",
    },
    {
        value: 500,
        prefix: "(GMT+05:00)",
        en: "Kurgan, Russia",
        ko: "쿠르간, 러시아",
        sc: "俄罗斯库尔干",
        es: "Kurgán, Rusia",
        ru: "Курган, Россия",
        ja: "クルガン、ロシア",
        fr: "Kourgane, Russie",
        de: "Kurgan, Russland",
        it: "Kurgan, Russia",
        th: "Kurgan, รัสเซีย",
        id: "Kurgan, Rusia",
        vi: "Kurgan, Nga",
        nl: "Koergan, Rusland",
        pl: "Kurgan, Rosja",
        nb: "Kurgan, Russland",
        fi: "Kurgan, Venäjä",
        ar: "كورغان ، روسيا",
    },
    {
        value: 500,
        prefix: "(GMT+05:00)",
        en: "Maldives",
        ko: "몰디브",
        sc: "马尔代夫",
        es: "Maldivas",
        ru: "Мальдивы",
        ja: "モルディブ",
        fr: "Maldives",
        de: "Malediven",
        it: "Maldive",
        th: "มัลดีฟส์",
        id: "Maladewa",
        vi: "Maldives",
        nl: "Maldiven",
        pl: "Malediwy",
        nb: "Maldivene",
        fi: "Malediivit",
        ar: "جزر المالديف",
    },
    {
        value: 500,
        prefix: "(GMT+05:00)",
        en: "Orenburg, Russia",
        ko: "오렌부르크, 러시아",
        sc: "俄罗斯奥伦堡",
        es: "Oremburgo, Rusia",
        ru: "Оренбург, Россия",
        ja: "オレンブルク、ロシア",
        fr: "Orenbourg, Russie",
        de: "Orenburg, Russland",
        it: "Orenburg, Russia",
        th: "โอเรนบุร์ก, รัสเซีย",
        id: "Orenburg, Rusia",
        vi: "Orenburg, Nga",
        nl: "Orenburg, Rusland",
        pl: "Orenburg, Rosja",
        nb: "Orenburg, Russland",
        fi: "Orenburg, Venäjä",
        ar: "أورينبورغ ، روسيا",
    },
    {
        value: 500,
        prefix: "(GMT+05:00)",
        en: "Pakistan",
        ko: "파키스탄",
        sc: "巴基斯坦",
        es: "Pakistán",
        ru: "Пакистан",
        ja: "パキスタン",
        fr: "Pakistan",
        de: "Pakistan",
        it: "Pakistan",
        th: "ปากีสถาน",
        id: "pakistan",
        vi: "Pakistan",
        nl: "Pakistan",
        pl: "Pakistan",
        nb: "Pakistan",
        fi: "Pakistan",
        ar: "باكستان",
    },
    {
        value: 500,
        prefix: "(GMT+05:00)",
        en: "Perm, Russia",
        ko: "페름, 러시아",
        sc: "俄罗斯彼尔姆",
        es: "Perm, Rusia",
        ru: "Пермь, Россия",
        ja: "ペルミ、ロシア",
        fr: "Perm, Russie",
        de: "Perm, Russland",
        it: "Perm, Russia",
        th: "เปียร์ม รัสเซีย",
        id: "Perm, Rusia",
        vi: "Perm, Nga",
        nl: "Perm, Rusland",
        pl: "Perm, Rosja",
        nb: "Perm, Russland",
        fi: "Perm, Venäjä",
        ar: "بيرم ، روسيا",
    },
    {
        value: 500,
        prefix: "(GMT+05:00)",
        en: "Salekhard, Russia",
        ko: "살레하르트, 러시아",
        sc: "俄罗斯萨列哈德",
        es: "Salejard, Rusia",
        ru: "Салехард, Россия",
        ja: "サレハルト、ロシア",
        fr: "Salekhard, Russie",
        de: "Salechard, Russland",
        it: "Salekhard, Russia",
        th: "Salekhard รัสเซีย",
        id: "Salehard, Rusia",
        vi: "Salekhard, Nga",
        nl: "Salechard, Rusland",
        pl: "Salechard, Rosja",
        nb: "Salekhard, Russland",
        fi: "Salekhard, Venäjä",
        ar: "سالخارد ، روسيا",
    },
    {
        value: 500,
        prefix: "(GMT+05:00)",
        en: "Tajikistan",
        ko: "타지키스탄",
        sc: "塔吉克斯坦",
        es: "Tayikistán",
        ru: "Таджикистан",
        ja: "タジキスタン",
        fr: "Tadjikistan",
        de: "Tadschikistan",
        it: "Tagikistan",
        th: "ทาจิกิสถาน",
        id: "Tajikistan",
        vi: "Tajikistan",
        nl: "Tadzjikistan",
        pl: "Tadżykistan",
        nb: "Tadsjikistan",
        fi: "Tadžikistan",
        ar: "طاجيكستان",
    },
    {
        value: 500,
        prefix: "(GMT+05:00)",
        en: "Turkmenistan",
        ko: "투르크메니스탄",
        sc: "土库曼斯坦",
        es: "turkmenistán",
        ru: "Туркменистан",
        ja: "トルクメニスタン",
        fr: "Turkménistan",
        de: "Turkmenistan",
        it: "Turkmenistan",
        th: "เติร์กเมนิสถาน",
        id: "Turkmenistan",
        vi: "Turkmenistan",
        nl: "Turkmenistan",
        pl: "Turkmenia",
        nb: "Turkmenistan",
        fi: "Turkmenistan",
        ar: "تركمانستان",
    },
    {
        value: 500,
        prefix: "(GMT+05:00)",
        en: "Tyumen, Russia",
        ko: "튜멘, 러시아",
        sc: "俄罗斯秋明",
        es: "Tiumén, Rusia",
        ru: "Тюмень, Россия",
        ja: "チュメニ、ロシア",
        fr: "Tioumen, Russie",
        de: "Tjumen, Russland",
        it: "Tjumen', Russia",
        th: "Tyumen, รัสเซีย",
        id: "Tyumen, Rusia",
        vi: "Tyumen, Nga",
        nl: "Tyumen, Rusland",
        pl: "Tiumeń, Rosja",
        nb: "Tyumen, Russland",
        fi: "Tyumen, Venäjä",
        ar: "تيومين ، روسيا",
    },
    {
        value: 500,
        prefix: "(GMT+05:00)",
        en: "Ufa, Russia",
        ko: "우파, 러시아",
        sc: "俄罗斯乌法",
        es: "Ufá, Rusia",
        ru: "Уфа, Россия",
        ja: "ウファ、ロシア",
        fr: "Oufa, Russie",
        de: "Ufa, Russland",
        it: "Ufa, Russia",
        th: "อูฟา รัสเซีย",
        id: "Ufa, Rusia",
        vi: "Ufa, Nga",
        nl: "Oefa, Rusland",
        pl: "Ufa, Rosja",
        nb: "Ufa, Russland",
        fi: "Ufa, Venäjä",
        ar: "أوفا ، روسيا",
    },
    {
        value: 500,
        prefix: "(GMT+05:00)",
        en: "Uzbekistan",
        ko: "우즈베키스탄",
        sc: "乌兹别克斯坦",
        es: "Uzbekistán",
        ru: "Узбекистан",
        ja: "ウズベキスタン",
        fr: "Ouzbékistan",
        de: "Usbekistan",
        it: "Uzbekistan",
        th: "อุซเบกิสถาน",
        id: "Uzbekistan",
        vi: "U-dơ-bê-ki-xtan",
        nl: "Oezbekistan",
        pl: "Uzbekistan",
        nb: "Usbekistan",
        fi: "Uzbekistan",
        ar: "أوزبكستان",
    },
    {
        value: 500,
        prefix: "(GMT+05:00)",
        en: "Yekaterinburg, Russia",
        ko: "예카테린부르크, 러시아",
        sc: "俄罗斯叶卡捷琳堡",
        es: "Ekaterimburgo, Rusia",
        ru: "Екатеринбург, Россия",
        ja: "エカテリンブルク、ロシア",
        fr: "Iekaterinbourg, Russie",
        de: "Jekaterinburg, Russland",
        it: "Ekaterinburg, Russia",
        th: "เยคาเตรินเบิร์ก รัสเซีย",
        id: "Yekaterinburg, Rusia",
        vi: "Yekaterinburg, Nga",
        nl: "Jekaterinenburg, Rusland",
        pl: "Jekaterynburg, Rosja",
        nb: "Jekaterinburg, Russland",
        fi: "Jekaterinburg, Venäjä",
        ar: "يكاترينبورغ ، روسيا",
    },
    {
        value: 530,
        prefix: "(GMT+05:30)",
        en: "India",
        ko: "인도",
        sc: "印度",
        es: "India",
        ru: "Индия",
        ja: "インド",
        fr: "Inde",
        de: "Indien",
        it: "India",
        th: "อินเดีย",
        id: "India",
        vi: "Ấn Độ",
        nl: "India",
        pl: "Indie",
        nb: "India",
        fi: "Intia",
        ar: "الهند",
    },
    {
        value: 530,
        prefix: "(GMT+05:30)",
        en: "Sri Lanka",
        ko: "스리랑카",
        sc: "斯里兰卡",
        es: "Sri Lanka",
        ru: "Шри-Ланка",
        ja: "スリランカ",
        fr: "Sri Lanka",
        de: "Sri Lanka",
        it: "Sri Lanka",
        th: "ศรีลังกา",
        id: "Srilanka",
        vi: "Sri Lanka",
        nl: "Sri Lanka",
        pl: "Sri Lanka",
        nb: "Sri Lanka",
        fi: "Sri Lanka",
        ar: "سيريلانكا",
    },
    {
        value: 600,
        prefix: "(GMT+06:00)",
        en: "Bangladesh",
        ko: "방글라데시",
        sc: "孟加拉国",
        es: "Bangladesh",
        ru: "Бангладеш",
        ja: "バングラデシュ",
        fr: "Bengladesh",
        de: "Bangladesch",
        it: "Bangladesh",
        th: "บังคลาเทศ",
        id: "Bangladesh",
        vi: "Bangladesh",
        nl: "Bangladesh",
        pl: "Bangladesz",
        nb: "Bangladesh",
        fi: "Bangladesh",
        ar: "بنغلاديش",
    },
    {
        value: 600,
        prefix: "(GMT+06:00)",
        en: "Bhutan",
        ko: "부탄",
        sc: "不丹",
        es: "Bután",
        ru: "Бутан",
        ja: "ブータン",
        fr: "Bhoutan",
        de: "Bhutan",
        it: "Bhutan",
        th: "ภูฏาน",
        id: "Bhutan",
        vi: "Bhutan",
        nl: "Bhutan",
        pl: "Bhutan",
        nb: "Bhutan",
        fi: "Bhutan",
        ar: "بوتان",
    },
    {
        value: 600,
        prefix: "(GMT+06:00)",
        en: "British Indian Ocean Territory",
        ko: "영국령 인도양 영토",
        sc: "英属印度洋领地",
        es: "Territorio Británico del Océano Índico",
        ru: "Британская территория Индийского океана",
        ja: "イギリス領インド洋地域",
        fr: "Territoire britannique de l'océan Indien",
        de: "Britisches Territorium des Indischen Ozeans",
        it: "Territorio britannico dell'Oceano Indiano",
        th: "บริติชอินเดียนโอเชียนเทร์ริทอรี",
        id: "Wilayah Samudra Hindia Britania",
        vi: "Lãnh thổ Ấn Độ Dương thuộc Anh",
        nl: "Brits-Indisch oceaan gebied",
        pl: "Brytyjskie Terytorium Oceanu Indyjskiego",
        nb: "Britisk territorium i det indiske hav",
        fi: "Brittiläinen Intian valtameren alue",
        ar: "إقليم المحيط البريطاني الهندي",
    },
    {
        value: 600,
        prefix: "(GMT+06:00)",
        en: "Kazakhstan, eastern part",
        ko: "카자흐스탄, 동부",
        sc: "哈萨克斯坦，东部",
        es: "Kazajstán, parte oriental",
        ru: "Казахстан, восточная часть",
        ja: "カザフスタン、東部",
        fr: "Kazakhstan, partie orientale",
        de: "Kasachstan, östlicher Teil",
        it: "Kazakistan, parte orientale",
        th: "คาซัคสถาน ภาคตะวันออก",
        id: "Kazakstan, bagian timur",
        vi: "Kazakhstan, phần phía đông",
        nl: "Kazachstan, oostelijk deel",
        pl: "Kazachstan, część wschodnia",
        nb: "Kasakhstan, østlige del",
        fi: "Kazakstan, itäosa",
        ar: "كازاخستان ، الجزء الشرقي",
    },
    {
        value: 600,
        prefix: "(GMT+06:00)",
        en: "Kyrgyzstan",
        ko: "키르기스스탄",
        sc: "吉尔吉斯斯坦",
        es: "Kirguistán",
        ru: "Кыргызстан",
        ja: "キルギスタン",
        fr: "Kirghizistan",
        de: "Kirgistan",
        it: "Kirghizistan",
        th: "คีร์กีซสถาน",
        id: "Kirgistan",
        vi: "Kyrgyzstan",
        nl: "Kirgizië",
        pl: "Kirgistan",
        nb: "Kirgisistan",
        fi: "Kirgisia",
        ar: "قيرغيزستان",
    },
    {
        value: 600,
        prefix: "(GMT+06:00)",
        en: "Omsk, Russia",
        ko: "옴스크, 러시아",
        sc: "俄罗斯鄂木斯克",
        es: "Omsk, Rusia",
        ru: "Омск, Россия",
        ja: "オムスク、ロシア",
        fr: "Omsk, Russie",
        de: "Omsk, Russland",
        it: "Omsk, Russia",
        th: "ออมสค์ รัสเซีย",
        id: "Omsk, Rusia",
        vi: "Omsk, Nga",
        nl: "Omsk, Rusland",
        pl: "Omsk, Rosja",
        nb: "Omsk, Russland",
        fi: "Omsk, Venäjä",
        ar: "أومسك ، روسيا",
    },
    {
        value: 630,
        prefix: "(GMT+06:30)",
        en: "Cocos (Keeling) Islands",
        ko: "코코스(킬링) 제도",
        sc: "科科斯（基林）群岛",
        es: "Islas Cocos (Keeling)",
        ru: "Кокосовые (Килинг) острова",
        ja: "ココス（キーリング）諸島",
        fr: "Îles Cocos (Keeling)",
        de: "Kokosinseln (Keelinginseln).",
        it: "Isole Cocos (Keeling).",
        th: "หมู่เกาะโคโคส (คีลิง)",
        id: "Kepulauan Cocos (Keeling)",
        vi: "Quần đảo Cocos (Keeling)",
        nl: "Cocos (Keeling) Eilanden",
        pl: "Wyspy Kokosowe (Keelinga)",
        nb: "Kokosøyene",
        fi: "Kookossaaret (Keeling).",
        ar: "جزر كوكوس (كيلينغ)",
    },
    {
        value: 630,
        prefix: "(GMT+06:30)",
        en: "Myanmar",
        ko: "미얀마",
        sc: "缅甸",
        es: "Birmania",
        ru: "Мьянма",
        ja: "ミャンマー",
        fr: "Birmanie",
        de: "Burma",
        it: "Birmania",
        th: "พม่า",
        id: "Myanmar",
        vi: "Myanmar",
        nl: "Myanmar",
        pl: "Myanmar",
        nb: "Myanmar",
        fi: "Myanmar",
        ar: "ميانمار",
    },
    {
        value: 700,
        prefix: "(GMT+07:00)",
        en: "Abakan, Russia",
        ko: "아바칸, 러시아",
        sc: "俄罗斯阿巴坎",
        es: "Abakán, Rusia",
        ru: "Абакан, Россия",
        ja: "アバカン、ロシア",
        fr: "Abakan, Russie",
        de: "Abakan, Russland",
        it: "Abakan, Russia",
        th: "อาบาคาน รัสเซีย",
        id: "Abakan, Rusia",
        vi: "Abakan, Nga",
        nl: "Abakan, Rusland",
        pl: "Abakan, Rosja",
        nb: "Abakan, Russland",
        fi: "Abakan, Venäjä",
        ar: "أباكان ، روسيا",
    },
    {
        value: 700,
        prefix: "(GMT+07:00)",
        en: "Barnaul, Russia",
        ko: "바르나울, 러시아",
        sc: "俄罗斯巴尔瑙尔",
        es: "Barnaúl, Rusia",
        ru: "Барнаул, Россия",
        ja: "バルナウル、ロシア",
        fr: "Barnaoul, Russie",
        de: "Barnaul, Russland",
        it: "Barnaul, Russia",
        th: "บาร์นาอูล รัสเซีย",
        id: "Barnaul, Rusia",
        vi: "Barnaul, Nga",
        nl: "Barnaul, Rusland",
        pl: "Barnauł, Rosja",
        nb: "Barnaul, Russland",
        fi: "Barnaul, Venäjä",
        ar: "بارناول ، روسيا",
    },
    {
        value: 700,
        prefix: "(GMT+07:00)",
        en: "Bayan-Olgii, Mongolia",
        ko: "바얀올기, 몽골",
        sc: "蒙古巴彦奥尔盖",
        es: "Bayan-Olgii, Mongolia",
        ru: "Баян-Улгий, Монголия",
        ja: "バヤンウルギー、モンゴル",
        fr: "Bayan-Olgii, Mongolie",
        de: "Bayan-Olgii, Mongolei",
        it: "Bayan-Olgii, Mongolia",
        th: "บายัน-ออลจิ, มองโกเลีย",
        id: "Bayan-Olgii, Mongolia",
        vi: "Bayan-Olgii, Mông Cổ",
        nl: "Bayan-Olgii, Mongolië",
        pl: "Bayan-Olgii, Mongolia",
        nb: "Bayan-Olgii, Mongolia",
        fi: "Bayan-Olgii, Mongolia",
        ar: "بيان أولجي ، منغوليا",
    },
    {
        value: 700,
        prefix: "(GMT+07:00)",
        en: "Cambodia",
        ko: "캄보디아",
        sc: "柬埔寨",
        es: "Camboya",
        ru: "Камбоджа",
        ja: "カンボジア",
        fr: "Cambodge",
        de: "Kambodscha",
        it: "Cambogia",
        th: "กัมพูชา",
        id: "Kamboja",
        vi: "Campuchia",
        nl: "Cambodja",
        pl: "Kambodża",
        nb: "Kambodsja",
        fi: "Kambodža",
        ar: "كمبوديا",
    },
    {
        value: 700,
        prefix: "(GMT+07:00)",
        en: "Central Kalimantan, Indonesia",
        ko: "인도네시아 중부 칼리만탄",
        sc: "印度尼西亚中加里曼丹",
        es: "Kalimantán central, Indonesia",
        ru: "Центральный Калимантан, Индонезия",
        ja: "インドネシア中部カリマンタン",
        fr: "Kalimantan central, Indonésie",
        de: "Zentralkalimantan, Indonesien",
        it: "Kalimantan centrale, Indonesia",
        th: "กาลิมันตันกลาง อินโดนีเซีย",
        id: "Kalimantan Tengah, Indonesia",
        vi: "Trung tâm Kalimantan, Indonesia",
        nl: "Centraal Kalimantan, Indonesië",
        pl: "Środkowy Kalimantan, Indonezja",
        nb: "Sentral-Kalimantan, Indonesia",
        fi: "Keski-Kalimantan, Indonesia",
        ar: "كاليمانتان الوسطى ، إندونيسيا",
    },
    {
        value: 700,
        prefix: "(GMT+07:00)",
        en: "Christmas Island",
        ko: "크리스마스 섬",
        sc: "圣诞岛",
        es: "Isla de Navidad",
        ru: "Остров Рождества",
        ja: "クリスマス島",
        fr: "L'île de noël",
        de: "Weihnachtsinsel",
        it: "Isola di Natale",
        th: "เกาะคริสต์มาส",
        id: "Pulau Natal",
        vi: "Đảo giáng sinh",
        nl: "Kersteiland",
        pl: "Wyspa Bożego Narodzenia",
        nb: "Juleøya",
        fi: "Joulusaari",
        ar: "جزيرة الكريسماس",
    },
    {
        value: 700,
        prefix: "(GMT+07:00)",
        en: "Gorno-Altaysk, Russia",
        ko: "러시아 고르노 알타이스크",
        sc: "俄罗斯戈尔诺-阿尔泰",
        es: "Gorno-Altaisk, Rusia",
        ru: "Горно-Алтайск, Россия",
        ja: "ゴルノアルタイスク、ロシア",
        fr: "Gorno-Altaïsk, Russie",
        de: "Gorno-Altaisk, Russland",
        it: "Gorno-Altajsk, Russia",
        th: "กอร์โน-อัลไตสค์ รัสเซีย",
        id: "Gorno-Altaysk, Rusia",
        vi: "Gorno-Altaysk, Nga",
        nl: "Gorno-Altajsk, Rusland",
        pl: "Gornoałtajsk, Rosja",
        nb: "Gorno-Altaysk, Russland",
        fi: "Gorno-Altaysk, Venäjä",
        ar: "جورنو ألتايسك ، روسيا",
    },
    {
        value: 700,
        prefix: "(GMT+07:00)",
        en: "Java Island, Indonesia",
        ko: "자바 섬, 인도네시아",
        sc: "印度尼西亚爪哇岛",
        es: "Isla de Java, Indonesia",
        ru: "Остров Ява, Индонезия",
        ja: "ジャワ島、インドネシア",
        fr: "Île de Java, Indonésie",
        de: "Insel Java, Indonesien",
        it: "Isola di Giava, Indonesia",
        th: "เกาะชวา อินโดนีเซีย",
        id: "Pulau Jawa, Indonesia",
        vi: "Đảo Java, Indonesia",
        nl: "Java-eiland, Indonesië",
        pl: "Wyspa Jawa, Indonezja",
        nb: "Java Island, Indonesia",
        fi: "Java Island, Indonesia",
        ar: "جزيرة جافا ، إندونيسيا",
    },
    {
        value: 700,
        prefix: "(GMT+07:00)",
        en: "Kemerovo, Russia",
        ko: "케메로보, 러시아",
        sc: "俄罗斯克麦罗沃",
        es: "Kémerovo, Rusia",
        ru: "Кемерово, Россия",
        ja: "ケメロヴォ、ロシア",
        fr: "Kemerovo, Russie",
        de: "Kemerowo, Russland",
        it: "Kemerovo, Russia",
        th: "เคเมโรโว รัสเซีย",
        id: "Kemerovo, Rusia",
        vi: "Kemerovo, Nga",
        nl: "Kemerovo, Rusland",
        pl: "Kemerowo, Rosja",
        nb: "Kemerovo, Russland",
        fi: "Kemerovo, Venäjä",
        ar: "كيميروفو ، روسيا",
    },
    {
        value: 700,
        prefix: "(GMT+07:00)",
        en: "Krasnoyarsk, Russia",
        ko: "크라스노야르스크, 러시아",
        sc: "俄罗斯克拉斯诺亚尔斯克",
        es: "Krasnoyarsk, Rusia",
        ru: "Красноярск, Россия",
        ja: "クラスノヤルスク、ロシア",
        fr: "Krasnoïarsk, Russie",
        de: "Krasnojarsk, Russland",
        it: "Krasnojarsk, Russia",
        th: "ครัสโนยาสค์ รัสเซีย",
        id: "Krasnoyarsk, Rusia",
        vi: "Krasnoyarsk, Nga",
        nl: "Krasnojarsk, Rusland",
        pl: "Krasnojarsk, Rosja",
        nb: "Krasnoyarsk, Russland",
        fi: "Krasnojarsk, Venäjä",
        ar: "كراسنويارسك ، روسيا",
    },
    {
        value: 700,
        prefix: "(GMT+07:00)",
        en: "Kyzyl, Russia",
        ko: "키질, 러시아",
        sc: "俄罗斯克孜勒",
        es: "Kyzyl, Rusia",
        ru: "Кызыл, Россия",
        ja: "クズル、ロシア",
        fr: "Kyzil, Russie",
        de: "Kysyl, Russland",
        it: "Kyzyl, Russia",
        th: "คืยซิล, รัสเซีย",
        id: "Kyzyl, Rusia",
        vi: "Kyzyl, Nga",
        nl: "Kyzyl, Rusland",
        pl: "Kyzył, Rosja",
        nb: "Kyzyl, Russland",
        fi: "Kyzyl, Venäjä",
        ar: "كيزيل ، روسيا",
    },
    {
        value: 700,
        prefix: "(GMT+07:00)",
        en: "Laos",
        ko: "라오스",
        sc: "老挝",
        es: "Laos",
        ru: "Лаос",
        ja: "ラオス",
        fr: "Laos",
        de: "Laos",
        it: "Laos",
        th: "ลาว",
        id: "Laos",
        vi: "Nước Lào",
        nl: "Laos",
        pl: "Laos",
        nb: "Laos",
        fi: "Laos",
        ar: "لاوس",
    },
    {
        value: 700,
        prefix: "(GMT+07:00)",
        en: "Novosibirsk, Russia",
        ko: "노보시비르스크, 러시아",
        sc: "俄罗斯新西伯利亚",
        es: "Novosibirsk, Rusia",
        ru: "Новосибирск, Россия",
        ja: "ノボシビルスク、ロシア",
        fr: "Novossibirsk, Russie",
        de: "Nowosibirsk, Russland",
        it: "Novosibirsk, Russia",
        th: "โนโวซีบีสค์ รัสเซีย",
        id: "Novosibirsk, Rusia",
        vi: "Novosibirsk, Nga",
        nl: "Novosibirsk, Rusland",
        pl: "Nowosybirsk, Rosja",
        nb: "Novosibirsk, Russland",
        fi: "Novosibirsk, Venäjä",
        ar: "نوفوسيبيرسك ، روسيا",
    },
    {
        value: 700,
        prefix: "(GMT+07:00)",
        en: "Provinces of Khovd, Mongolia",
        ko: "몽골 코브드 지방",
        sc: "蒙古霍布德省",
        es: "Provincias de Khovd, Mongolia",
        ru: "Провинция Ховд, Монголия",
        ja: "モンゴル、ホブド州",
        fr: "Provinces de Khovd, Mongolie",
        de: "Provinzen Khovd, Mongolei",
        it: "Province di Khovd, Mongolia",
        th: "จังหวัดของ Khovd มองโกเลีย",
        id: "Provinsi Khovd, Mongolia",
        vi: "Các tỉnh Khovd, Mông Cổ",
        nl: "Provincies van Khovd, Mongolië",
        pl: "Prowincje Khovd, Mongolia",
        nb: "Provinsene Khovd, Mongolia",
        fi: "Khovdin maakunnat, Mongolia",
        ar: "مقاطعات خوفد ، منغوليا",
    },
    {
        value: 700,
        prefix: "(GMT+07:00)",
        en: "Sumatra Island, Indonesia",
        ko: "인도네시아 수마트라 섬",
        sc: "印度尼西亚苏门答腊岛",
        es: "Isla de Sumatra, Indonesia",
        ru: "Остров Суматра, Индонезия",
        ja: "インドネシア、スマトラ島",
        fr: "Île de Sumatra, Indonésie",
        de: "Insel Sumatra, Indonesien",
        it: "Isola di Sumatra, Indonesia",
        th: "เกาะสุมาตรา อินโดนีเซีย",
        id: "Pulau Sumatera, Indonesia",
        vi: "Đảo Sumatra, Indonesia",
        nl: "Sumatra, Indonesië",
        pl: "Sumatra, Indonezja",
        nb: "Sumatra Island, Indonesia",
        fi: "Sumatran saari, Indonesia",
        ar: "جزيرة سومطرة ، إندونيسيا",
    },
    {
        value: 700,
        prefix: "(GMT+07:00)",
        en: "Thailand",
        ko: "태국",
        sc: "泰国",
        es: "Tailandia",
        ru: "Таиланд",
        ja: "タイ",
        fr: "Thaïlande",
        de: "Thailand",
        it: "Tailandia",
        th: "ประเทศไทย",
        id: "Thailand",
        vi: "nước Thái Lan",
        nl: "Thailand",
        pl: "Tajlandia",
        nb: "Thailand",
        fi: "Thaimaa",
        ar: "تايلاند",
    },
    {
        value: 700,
        prefix: "(GMT+07:00)",
        en: "Tomsk, Russia",
        ko: "톰스크, 러시아",
        sc: "俄罗斯托木斯克",
        es: "Tomsk, Rusia",
        ru: "Томск, Россия",
        ja: "トムスク、ロシア",
        fr: "Tomsk, Russie",
        de: "Tomsk, Russland",
        it: "Tomsk, Russia",
        th: "ทอมสค์ รัสเซีย",
        id: "Tomsk, Rusia",
        vi: "Tomsk, Nga",
        nl: "Tomsk, Rusland",
        pl: "Tomsk, Rosja",
        nb: "Tomsk, Russland",
        fi: "Tomsk, Venäjä",
        ar: "تومسك ، روسيا",
    },
    {
        value: 700,
        prefix: "(GMT+07:00)",
        en: "Uvs, Mongolia",
        ko: "오브스, 몽골",
        sc: "乌布苏省, 蒙古",
        es: "UVS, Mongolia",
        ru: "Увс, Монголия",
        ja: "ウブス、モンゴル",
        fr: "Uvs, Mongolie",
        de: "Uws-Aimag, Mongolei",
        it: "Provincia dell'Uvs, Mongolia",
        th: "จังหวัดอุฟส์, มองโกเลีย",
        id: "Uvs, Mongolia",
        vi: "Uvs, Mông Cổ",
        nl: "Uvs, Mongolië",
        pl: "Ajmak uwski, Mongolia",
        nb: "Uvs, Mongolia",
        fi: "Uvs, Mongolia",
        ar: "Uvs ، منغوليا",
    },
    {
        value: 700,
        prefix: "(GMT+07:00)",
        en: "Vietnam",
        ko: "베트남",
        sc: "越南",
        es: "Vietnam",
        ru: "Вьетнам",
        ja: "ベトナム",
        fr: "Viêt Nam",
        de: "Vietnam",
        it: "Vietnam",
        th: "เวียดนาม",
        id: "Vietnam",
        vi: "Việt Nam",
        nl: "Vietnam",
        pl: "Wietnam",
        nb: "Vietnam",
        fi: "Vietnam",
        ar: "فيتنام",
    },
    {
        value: 700,
        prefix: "(GMT+07:00)",
        en: "West Kalimantan, Indonesia",
        ko: "인도네시아 서부 칼리만탄",
        sc: "印度尼西亚西加里曼丹",
        es: "Borneo Occidental, Indonesia",
        ru: "Западный Калимантан, Индонезия",
        ja: "インドネシア、西カリマンタン",
        fr: "Kalimantan occidental, Indonésie",
        de: "Westkalimantan, Indonesien",
        it: "Kalimantan occidentale, Indonesia",
        th: "กาลิมันตันตะวันตก อินโดนีเซีย",
        id: "Kalimantan Barat, Indonesia",
        vi: "Tây Kalimantan, Indonesia",
        nl: "West Kalimantan, Indonesië",
        pl: "Zachodni Kalimantan, Indonezja",
        nb: "Vest-Kalimantan, Indonesia",
        fi: "Länsi-Kalimantan, Indonesia",
        ar: "كاليمانتان الغربية ، إندونيسيا",
    },
    {
        value: 800,
        prefix: "(GMT+08:00)",
        en: "Brunei",
        ko: "브루나이",
        sc: "文莱",
        es: "Brunéi",
        ru: "Бруней",
        ja: "ブルネイ",
        fr: "Brunéi",
        de: "Brunei",
        it: "Brunei",
        th: "บรูไน",
        id: "brunei",
        vi: "Brunei",
        nl: "Brunei",
        pl: "Brunei",
        nb: "Brunei",
        fi: "Brunei",
        ar: "بروناي",
    },
    {
        value: 800,
        prefix: "(GMT+08:00)",
        en: "China",
        ko: "중국",
        sc: "中国",
        es: "República Popular China",
        ru: "Китай",
        ja: "中国",
        fr: "Chine",
        de: "China",
        it: "Cina",
        th: "จีน",
        id: "Cina",
        vi: "Trung Quốc",
        nl: "China",
        pl: "Chiny",
        nb: "Kina",
        fi: "Kiina",
        ar: "الصين",
    },
    {
        value: 800,
        prefix: "(GMT+08:00)",
        en: "East Kalimantan, Indonesia",
        ko: "인도네시아 동부 칼리만탄",
        sc: "印度尼西亚东加里曼丹",
        es: "Borneo Oriental, Indonesia",
        ru: "Восточный Калимантан, Индонезия",
        ja: "東カリマンタン、インドネシア",
        fr: "Kalimantan oriental, Indonésie",
        de: "Ostkalimantan, Indonesien",
        it: "Kalimantan orientale, Indonesia",
        th: "กาลิมันตันตะวันออก อินโดนีเซีย",
        id: "Kalimantan Timur, Indonesia",
        vi: "Đông Kalimantan, Indonesia",
        nl: "Oost-Kalimantan, Indonesië",
        pl: "Wschodni Kalimantan, Indonezja",
        nb: "Øst-Kalimantan, Indonesia",
        fi: "Itä-Kalimantan, Indonesia",
        ar: "كاليمانتان الشرقية ، إندونيسيا",
    },
    {
        value: 800,
        prefix: "(GMT+08:00)",
        en: "Hong Kong",
        ko: "홍콩",
        sc: "香港",
        es: "Hong Kong",
        ru: "Гонконг",
        ja: "香港",
        fr: "Hong Kong",
        de: "Hongkong",
        it: "Hong Kong",
        th: "ฮ่องกง",
        id: "Hongkong",
        vi: "Hồng Kông",
        nl: "Hongkong",
        pl: "Hongkong",
        nb: "Hong Kong",
        fi: "Hong Kong",
        ar: "هونج كونج",
    },
    {
        value: 800,
        prefix: "(GMT+08:00)",
        en: "Irkutsk, Russia",
        ko: "이르쿠츠크, 러시아",
        sc: "俄罗斯伊尔库茨克",
        es: "Irkutsk, Rusia",
        ru: "Иркутск, Россия",
        ja: "イルクーツク、ロシア",
        fr: "Irkoutsk, Russie",
        de: "Irkutsk, Russland",
        it: "Irkutsk, Russia",
        th: "อีร์คุตสค์ รัสเซีย",
        id: "Irkutsk, Rusia",
        vi: "Irkutsk, Nga",
        nl: "Irkoetsk, Rusland",
        pl: "Irkuck, Rosja",
        nb: "Irkutsk, Russland",
        fi: "Irkutsk, Venäjä",
        ar: "إيركوتسك ، روسيا",
    },
    {
        value: 800,
        prefix: "(GMT+08:00)",
        en: "Lesser Sunda Islands, Indonesia",
        ko: "인도네시아 소순다 제도",
        sc: "印度尼西亚小巽他群岛",
        es: "Islas menores de la Sonda, Indonesia",
        ru: "Малые Зондские острова, Индонезия",
        ja: "小スンダ列島、インドネシア",
        fr: "Petites îles de la Sonde, Indonésie",
        de: "Kleine Sunda-Inseln, Indonesien",
        it: "Piccole Isole della Sonda, Indonesia",
        th: "หมู่เกาะเลสเซอร์ซุนดา อินโดนีเซีย",
        id: "Kepulauan Sunda Kecil, Indonesia",
        vi: "Quần đảo Sunda Nhỏ, Indonesia",
        nl: "Kleine Soenda-eilanden, Indonesië",
        pl: "Małe Wyspy Sundajskie, Indonezja",
        nb: "De mindre Sundaøyene, Indonesia",
        fi: "Pienet Sundan saaret, Indonesia",
        ar: "جزر سوندا الصغرى ، إندونيسيا",
    },
    {
        value: 800,
        prefix: "(GMT+08:00)",
        en: "Macau",
        ko: "마카오",
        sc: "澳门",
        es: "Macao",
        ru: "Макао",
        ja: "マカオ",
        fr: "Macao",
        de: "Macau",
        it: "Macao",
        th: "มาเก๊า",
        id: "Makau",
        vi: "Ma Cao",
        nl: "Macau",
        pl: "Makau",
        nb: "Macau",
        fi: "Macao",
        ar: "ماكاو",
    },
    {
        value: 800,
        prefix: "(GMT+08:00)",
        en: "Malaysia",
        ko: "말레이시아",
        sc: "马来西亚",
        es: "Malasia",
        ru: "Малайзия",
        ja: "マレーシア",
        fr: "Malaisie",
        de: "Malaysia",
        it: "Malaysia",
        th: "มาเลเซีย",
        id: "Malaysia",
        vi: "Malaysia",
        nl: "Maleisië",
        pl: "Malezja",
        nb: "Malaysia",
        fi: "Malesia",
        ar: "ماليزيا",
    },
    {
        value: 800,
        prefix: "(GMT+08:00)",
        en: "Mongolia, most of",
        ko: "대부분의 몽골",
        sc: "蒙古，大部分",
        es: "Mongolia, la mayor parte",
        ru: "Монголия, большая часть",
        ja: "モンゴル、ほとんど",
        fr: "Mongolie, la plupart",
        de: "Mongolei, die meisten",
        it: "Mongolia, la maggior parte",
        th: "มองโกเลีย ส่วนใหญ่",
        id: "Mongolia, sebagian besar",
        vi: "Mông Cổ, hầu hết",
        nl: "Mongolië, de meeste",
        pl: "Mongolia, większość",
        nb: "Mongolia, de fleste",
        fi: "Mongolia, suurin osa",
        ar: "منغوليا ، معظم",
    },
    {
        value: 800,
        prefix: "(GMT+08:00)",
        en: "North Kalimantan, Indonesia",
        ko: "인도네시아 북부 칼리만탄",
        sc: "印度尼西亚北加里曼丹",
        es: "Kalimantán del Norte, Indonesia",
        ru: "Северный Калимантан, Индонезия",
        ja: "北カリマンタン、インドネシア",
        fr: "Kalimantan du Nord, Indonésie",
        de: "Nordkalimantan, Indonesien",
        it: "Kalimantan settentrionale, Indonesia",
        th: "กาลิมันตันเหนือ อินโดนีเซีย",
        id: "Kalimantan Utara, Indonesia",
        vi: "Bắc Kalimantan, Indonesia",
        nl: "Noord Kalimantan, Indonesië",
        pl: "Północny Kalimantan, Indonezja",
        nb: "Nord-Kalimantan, Indonesia",
        fi: "Pohjois-Kalimantan, Indonesia",
        ar: "كاليمانتان الشمالية ، إندونيسيا",
    },
    {
        value: 800,
        prefix: "(GMT+08:00)",
        en: "Philippines",
        ko: "필리핀 제도",
        sc: "菲律宾",
        es: "Filipinas",
        ru: "Филиппины",
        ja: "フィリピン",
        fr: "Philippines",
        de: "Philippinen",
        it: "Filippine",
        th: "ฟิลิปปินส์",
        id: "Filipina",
        vi: "Phi-líp-pin",
        nl: "Filippijnen",
        pl: "Filipiny",
        nb: "Filippinene",
        fi: "Filippiinit",
        ar: "فيلبيني",
    },
    {
        value: 800,
        prefix: "(GMT+08:00)",
        en: "Singapore, Perth",
        ko: "싱가포르, 퍼스",
        sc: "新加坡，珀斯",
        es: "Singapur, Perth",
        ru: "Сингапур, Перт",
        ja: "シンガポール、パース",
        fr: "Singapour, Perth",
        de: "Singapur, Perth",
        it: "Singapore, Perth",
        th: "สิงคโปร์ เพิร์ธ",
        id: "Singapura, Perth",
        vi: "Singapore, Perth",
        nl: "Singapore, Perth",
        pl: "Singapur, Perth",
        nb: "Singapore, Perth",
        fi: "Singapore, Perth",
        ar: "سنغافورة، بيرث",
    },
    {
        value: 800,
        prefix: "(GMT+08:00)",
        en: "South Kalimantan, Indonesia",
        ko: "인도네시아 남부 칼리만탄",
        sc: "印度尼西亚南加里曼丹",
        es: "Borneo Meridional, Indonesia",
        ru: "Южный Калимантан, Индонезия",
        ja: "南カリマンタン、インドネシア",
        fr: "Kalimantan du Sud, Indonésie",
        de: "Süd-Kalimantan, Indonesien",
        it: "Kalimantan meridionale, Indonesia",
        th: "กาลิมันตันใต้ อินโดนีเซีย",
        id: "Kalimantan Selatan, Indonesia",
        vi: "Nam Kalimantan, Indonesia",
        nl: "Zuid-Kalimantan, Indonesië",
        pl: "Południowy Kalimantan, Indonezja",
        nb: "Sør-Kalimantan, Indonesia",
        fi: "Etelä-Kalimantan, Indonesia",
        ar: "كاليمانتان الجنوبية ، إندونيسيا",
    },
    {
        value: 800,
        prefix: "(GMT+08:00)",
        en: "Sulawesi Island, Indonesia",
        ko: "인도네시아 술라웨시 섬",
        sc: "印度尼西亚苏拉威西岛",
        es: "Isla de Sulawesi, Indonesia",
        ru: "Остров Сулавеси, Индонезия",
        ja: "スラウェシ島、インドネシア",
        fr: "Île de Sulawesi, Indonésie",
        de: "Insel Sulawesi, Indonesien",
        it: "Isola di Sulawesi, Indonesia",
        th: "เกาะสุลาเวสี อินโดนีเซีย",
        id: "Pulau Sulawesi, Indonesia",
        vi: "Đảo Sulawesi, Indonesia",
        nl: "Sulawesi, Indonesië",
        pl: "Wyspa Sulawesi, Indonezja",
        nb: "Sulawesi Island, Indonesia",
        fi: "Sulawesin saari, Indonesia",
        ar: "جزيرة سولاويزي ، إندونيسيا",
    },
    {
        value: 800,
        prefix: "(GMT+08:00)",
        en: "Taiwan",
        ko: "대만",
        sc: "台湾",
        es: "Taiwán",
        ru: "Тайвань",
        ja: "台湾",
        fr: "Taïwan",
        de: "Taiwan",
        it: "Taiwan",
        th: "ไต้หวัน",
        id: "Taiwan",
        vi: "Đài loan",
        nl: "Taiwan",
        pl: "Tajwan",
        nb: "Taiwan",
        fi: "Taiwan",
        ar: "تايوان",
    },
    {
        value: 800,
        prefix: "(GMT+08:00)",
        en: "Ulan-Ude, Russia",
        ko: "울란우데, 러시아",
        sc: "俄罗斯乌兰乌德",
        es: "Ulan-Ude, Rusia",
        ru: "Улан-Удэ, Россия",
        ja: "ウランウデ、ロシア",
        fr: "Oulan-Oude, Russie",
        de: "Ulan-Ude, Russland",
        it: "Ulan-Ude, Russia",
        th: "อูลาน-อูเด รัสเซีย",
        id: "Ulan-Ude, Rusia",
        vi: "Ulan-Ude, Nga",
        nl: "Oelan-Oede, Rusland",
        pl: "Ułan-Ude, Rosja",
        nb: "Ulan-Ude, Russland",
        fi: "Ulan-Ude, Venäjä",
        ar: "أولان أودي ، روسيا",
    },
    {
        value: 800,
        prefix: "(GMT+08:00)",
        en: "Western Australia, Australia ",
        ko: "웨스턴 오스트레일리아주, 호주",
        sc: "澳大利亚西澳大利亚州",
        es: "Australia Occidental, Australia",
        ru: "Западная Австралия, Австралия",
        ja: "西オーストラリア、オーストラリア",
        fr: "Australie-Occidentale, Australie",
        de: "Westaustralien, Australien",
        it: "Australia occidentale, Australia",
        th: "เวสเทิร์นออสเตรเลีย, ออสเตรเลีย",
        id: "Australia Barat, Australia",
        vi: "Tây Úc, Úc",
        nl: "West-Australië, Australië",
        pl: "Australia Zachodnia, Australia",
        nb: "Vest-Australia, Australia",
        fi: "Länsi-Australia, Australia",
        ar: "أستراليا الغربية ، أستراليا",
    },
    {
        value: 900,
        prefix: "(GMT+09:00)",
        en: "Blagoveshchensk, Russia",
        ko: "블라고베셴스크, 러시아",
        sc: "俄罗斯布拉戈维申斯克",
        es: "Blagovéshchensk, Rusia",
        ru: "Благовещенск, Россия",
        ja: "ブラゴヴェシチェンスク、ロシア",
        fr: "Blagovechtchensk, Russie",
        de: "Blagoweschtschensk, Russland",
        it: "Blagoveshchensk, Russia",
        th: "บลาโกเวชเชนสค์ รัสเซีย",
        id: "Blagoveshchensk, Rusia",
        vi: "Blagoveshchensk, Nga",
        nl: "Blagovesjtsjensk, Rusland",
        pl: "Błagowieszczeńsk, Rosja",
        nb: "Blagoveshchensk, Russland",
        fi: "Blagoveshchensk, Venäjä",
        ar: "بلاغوفيشتشينسك ، روسيا",
    },
    {
        value: 900,
        prefix: "(GMT+09:00)",
        en: "Chita, Russia",
        ko: "치타, 러시아",
        sc: "俄罗斯赤塔",
        es: "Chitá, Rusia",
        ru: "Чита, Россия",
        ja: "チタ、ロシア",
        fr: "Tchita, Russie",
        de: "Chita, Russland",
        it: "Chita, Russia",
        th: "ชิตา รัสเซีย",
        id: "Chita, Rusia",
        vi: "Chita, Nga",
        nl: "Tsjita, Rusland",
        pl: "Czyta, Rosja",
        nb: "Chita, Russland",
        fi: "Chita, Venäjä",
        ar: "شيتا ، روسيا",
    },
    {
        value: 900,
        prefix: "(GMT+09:00)",
        en: "Japan",
        ko: "일본",
        sc: "日本",
        es: "Japón",
        ru: "Япония",
        ja: "日本",
        fr: "Japon",
        de: "Japan",
        it: "Giappone",
        th: "ญี่ปุ่น",
        id: "Jepang",
        vi: "Nhật Bản",
        nl: "Japan",
        pl: "Japonia",
        nb: "Japan",
        fi: "Japani",
        ar: "اليابان",
    },
    {
        value: 900,
        prefix: "(GMT+09:00)",
        en: "Maluku Islands, Indonesia",
        ko: "말루쿠 제도, 인도네시아",
        sc: "印度尼西亚马鲁古群岛",
        es: "Islas Molucas, Indonesia",
        ru: "Молуккские острова, Индонезия",
        ja: "マルク諸島、インドネシア",
        fr: "Îles Moluques, Indonésie",
        de: "Maluku-Inseln, Indonesien",
        it: "Isole Maluku, Indonesia",
        th: "หมู่เกาะมาลูกู อินโดนีเซีย",
        id: "Kepulauan Maluku, Indonesia",
        vi: "Quần đảo Maluku, Indonesia",
        nl: "Molukken, Indonesië",
        pl: "Moluki, Indonezja",
        nb: "Maluku-øyene, Indonesia",
        fi: "Maluku saaret, Indonesia",
        ar: "جزر مالوكو ، إندونيسيا",
    },
    {
        value: 900,
        prefix: "(GMT+09:00)",
        en: "North Korea",
        ko: "북한",
        sc: "北朝鲜",
        es: "Corea del Norte",
        ru: "Северная Корея",
        ja: "北朝鮮",
        fr: "Corée du Nord",
        de: "Nord Korea",
        it: "Corea del nord",
        th: "เกาหลีเหนือ",
        id: "Korea Utara",
        vi: "Bắc Triều Tiên",
        nl: "Noord Korea",
        pl: "Korea Północna",
        nb: "Nord-Korea",
        fi: "Pohjois-Korea",
        ar: "كوريا الشمالية",
    },
    {
        value: 900,
        prefix: "(GMT+09:00)",
        en: "Palau",
        ko: "팔라우",
        sc: "帕劳",
        es: "palaos",
        ru: "Палау",
        ja: "パラオ",
        fr: "Palaos",
        de: "Palau",
        it: "Palau",
        th: "ปาเลา",
        id: "Palau",
        vi: "Palau",
        nl: "Palau",
        pl: "Palau",
        nb: "Palau",
        fi: "Palau",
        ar: "بالاو",
    },
    {
        value: 900,
        prefix: "(GMT+09:00)",
        en: "Papua, Indonesia",
        ko: "파푸아, 인도네시아",
        sc: "印度尼西亚巴布亚",
        es: "Papúa, Indonesia",
        ru: "Папуа, Индонезия",
        ja: "インドネシア、パプア",
        fr: "Papouasie, Indonésie",
        de: "Papua, Indonesien",
        it: "Papua, Indonesia",
        th: "ปาปัว อินโดนีเซีย",
        id: "Papua, Indonesia",
        vi: "Papua, Indonesia",
        nl: "Papoea, Indonesië",
        pl: "Papua, Indonezja",
        nb: "Papua, Indonesia",
        fi: "Papua, Indonesia",
        ar: "بابوا ، إندونيسيا",
    },
    {
        value: 900,
        prefix: "(GMT+09:00)",
        en: "South Korea",
        ko: "대한민국",
        sc: "韩国",
        es: "Corea del Sur",
        ru: "Южная Корея",
        ja: "韓国",
        fr: "Corée du Sud",
        de: "Südkorea",
        it: "Corea del Sud",
        th: "เกาหลีใต้",
        id: "Korea Selatan",
        vi: "Nam Triều Tiên",
        nl: "Zuid-Korea",
        pl: "Korea Południowa",
        nb: "Sør-Korea",
        fi: "Etelä-Korea",
        ar: "كوريا الجنوبية",
    },
    {
        value: 900,
        prefix: "(GMT+09:00)",
        en: "Timor-Leste",
        ko: "동티모르",
        sc: "东帝汶",
        es: "Timor Oriental",
        ru: "Тимор-Лешти",
        ja: "東ティモール",
        fr: "Timor oriental",
        de: "Timor-Leste",
        it: "Timor Est",
        th: "ติมอร์-เลสเต",
        id: "Timor-Leste",
        vi: "Đông Timor",
        nl: "Oost-Timor",
        pl: "Timor Wschodni",
        nb: "Øst-Timor",
        fi: "Itä-Timor",
        ar: "تيمور ليشتي",
    },
    {
        value: 900,
        prefix: "(GMT+09:00)",
        en: "West Papua, Indonesia",
        ko: "서파푸아, 인도네시아",
        sc: "印度尼西亚西巴布亚",
        es: "Papúa Occidental, Indonesia",
        ru: "Западное Папуа, Индонезия",
        ja: "インドネシア、西パプア",
        fr: "Papouasie occidentale, Indonésie",
        de: "West Papua, Indonesien",
        it: "Papua occidentale, Indonesia",
        th: "ปาปัวตะวันตก อินโดนีเซีย",
        id: "Papua Barat, Indonesia",
        vi: "Tây Papua, Indonesia",
        nl: "West Papoea, Indonesië",
        pl: "Papua Zachodnia, Indonezja",
        nb: "Vest-Papua, Indonesia",
        fi: "Länsi-Papua, Indonesia",
        ar: "بابوا الغربية ، إندونيسيا",
    },
    {
        value: 900,
        prefix: "(GMT+09:00)",
        en: "Yakutsk, Russia",
        ko: "러시아 야쿠츠크",
        sc: "俄罗斯雅库茨克",
        es: "Yakutsk, Rusia",
        ru: "Якутск, Россия",
        ja: "ヤクーツク、ロシア",
        fr: "Iakoutsk, Russie",
        de: "Jakutsk, Russland",
        it: "Jakutsk, Russia",
        th: "ยาคุตสค์ รัสเซีย",
        id: "Yakutsk, Rusia",
        vi: "Yakutsk, Nga",
        nl: "Jakoetsk, Rusland",
        pl: "Jakuck, Rosja",
        nb: "Yakutsk, Russland",
        fi: "Jakutsk, Venäjä",
        ar: "ياكوتسك ، روسيا",
    },
    {
        value: 930,
        prefix: "(GMT+09:30)",
        en: "Northern Territory, Australia ",
        ko: "노던 준주, 호주",
        sc: "澳大利亚北领地",
        es: "Territorio del Norte, Australia",
        ru: "Северная территория, Австралия",
        ja: "オーストラリア、ノーザンテリトリー",
        fr: "Territoire du Nord, Australie",
        de: "Northern Territory, Australien",
        it: "Territorio del Nord, Australia",
        th: "นอร์เทิร์นเทร์ริทอรี ออสเตรเลีย",
        id: "Northern Territory, Australia",
        vi: "Lãnh thổ phía Bắc, Úc",
        nl: "Noordelijk Territorium, Australië",
        pl: "Terytorium Północne, Australia",
        nb: "Northern Territory, Australia",
        fi: "Northern Territory, Australia",
        ar: "الإقليم الشمالي ، أستراليا",
    },
    {
        value: 930,
        prefix: "(GMT+09:30)",
        en: "South Australia, Australia ",
        ko: "사우스 오스트레일리아주, 호주",
        sc: "南澳大利亚, 澳大利亚",
        es: "Australia Meridional, Australia",
        ru: "Южная Австралия, Австралия",
        ja: "南オーストラリア、オーストラリア",
        fr: "Australie-Méridionale, Australie",
        de: "Südaustralien, Australien",
        it: "Australia Meridionale, Australia",
        th: "เซาท์ออสเตรเลีย, ออสเตรเลีย",
        id: "Australia Selatan, Australia",
        vi: "Nam Úc, Úc",
        nl: "Zuid-Australië, Australië",
        pl: "Australia Południowa, Australia",
        nb: "Sør-Australia, Australia",
        fi: "Etelä-Australia, Australia",
        ar: "جنوب أستراليا ، أستراليا",
    },
    {
        value: 1000,
        prefix: "(GMT+10:00)",
        en: "Australian Capital Territory with Canberra capital city, Australia",
        ko: "호주 수도권과 캔버라 주도 오스트레일리아",
        sc: "澳大利亚首都领地与澳大利亚堪培拉首都",
        es: "Territorio de la Capital Australiana con la ciudad capital de Canberra, Australia",
        ru: "Австралийская столичная территория со столицей Канберра, Австралия",
        ja: "キャンベラの首都、オーストラリアとオーストラリア首都特別地域",
        fr: "Territoire de la capitale australienne avec la capitale Canberra, Australie",
        de: "Australian Capital Territory mit der Hauptstadt Canberra, Australien",
        it: "Territorio della capitale australiana con la capitale Canberra, Australia",
        th: "ออสเตรเลียนแคพิทอลเทร์ริทอรี กับเมืองหลวง แคนเบอร์รา ประเทศออสเตรเลีย",
        id: "Wilayah Ibu Kota Australia dengan ibu kota Canberra, Australia",
        vi: "Lãnh thổ Thủ đô Úc với thành phố thủ đô Canberra, Úc",
        nl: "Australisch Hoofdstedelijk Territorium met de hoofdstad van Canberra, Australië",
        pl: "Australijskie Terytorium Stołeczne ze stolicą Canberry, Australia",
        nb: "Australian Capital Territory med Canberra hovedstad, Australia",
        fi: "Australian pääkaupunkialue Canberran pääkaupungin Australian kanssa",
        ar: "إقليم العاصمة الأسترالية وعاصمة كانبرا ، أستراليا",
    },
    {
        value: 1000,
        prefix: "(GMT+10:00)",
        en: "Birobidzhan, Russia",
        ko: "비로비잔, 러시아",
        sc: "俄罗斯比罗比詹",
        es: "Birobidzhán, Rusia",
        ru: "Биробиджан, Россия",
        ja: "ビロビジャン、ロシア",
        fr: "Birobidjan, Russie",
        de: "Birobidschan, Russland",
        it: "Birobidzhan, Russia",
        th: "Birobidzhan, รัสเซีย",
        id: "Birobidzhan, Rusia",
        vi: "Birobidzhan, Nga",
        nl: "Birobidzhan, Rusland",
        pl: "Birobidżan, Rosja",
        nb: "Birobidzhan, Russland",
        fi: "Birobidzhan, Venäjä",
        ar: "بيروبيدجان ، روسيا",
    },
    {
        value: 1000,
        prefix: "(GMT+10:00)",
        en: "Guam",
        ko: "괌",
        sc: "关岛",
        es: "Guam",
        ru: "Гуам",
        ja: "グアム",
        fr: "Guam",
        de: "Guam",
        it: "Guam",
        th: "กวม",
        id: "Guam",
        vi: "Guam",
        nl: "Guam",
        pl: "Guam",
        nb: "Guam",
        fi: "Guam",
        ar: "غوام",
    },
    {
        value: 1000,
        prefix: "(GMT+10:00)",
        en: "Khabarovsk, Russia",
        ko: "하바롭스크, 러시아",
        sc: "俄罗斯哈巴罗夫斯克",
        es: "Jabárovsk, Rusia",
        ru: "Хабаровск, Россия",
        ja: "ハバロフスク、ロシア",
        fr: "Khabarovsk, Russie",
        de: "Chabarowsk, Russland",
        it: "Khabarovsk, Russia",
        th: "ฮาบารอฟสค์ รัสเซีย",
        id: "Khabarovsk, Rusia",
        vi: "Khabarovsk, Nga",
        nl: "Chabarovsk, Rusland",
        pl: "Chabarowsk, Rosja",
        nb: "Khabarovsk, Russland",
        fi: "Habarovsk, Venäjä",
        ar: "خاباروفسك ، روسيا",
    },
    {
        value: 1000,
        prefix: "(GMT+10:00)",
        en: "States of Chuuk and Yap, Micronesia",
        ko: "추크, 야프, 미크로네시아",
        sc: "Chuuk 和 Yap 州，密克罗尼西亚",
        es: "Estados de Chuuk y Yap, Micronesia",
        ru: "Штаты Чуук и Яп, Микронезия",
        ja: "ミクロネシア連邦、チュウクとヤップの州",
        fr: "États de Chuuk et Yap, Micronésie",
        de: "Bundesstaaten Chuuk und Yap, Mikronesien",
        it: "Stati di Chuuk e Yap, Micronesia",
        th: "รัฐชุกและแยป ไมโครนีเซีย",
        id: "Negara Bagian Chuuk dan Yap, Mikronesia",
        vi: "Bang Chuuk và Yap, Micronesia",
        nl: "Staten van Chuuk en Yap, Micronesië",
        pl: "Stany Chuuk i Yap, Mikronezja",
        nb: "Statene Chuuk og Yap, Mikronesia",
        fi: "Chuukin ja Yapin osavaltiot, Mikronesia",
        ar: "ولايتي تشوك وياب ، ميكرونيزيا",
    },
    {
        value: 1000,
        prefix: "(GMT+10:00)",
        en: "New South Wales, Australia",
        ko: "뉴사우스웨일즈, 호주",
        sc: "澳大利亚新南威尔士州",
        es: "Nueva Gales del Sur, Australia",
        ru: "Новый Южный Уэльс, Австралия",
        ja: "ニューサウスウェールズ、オーストラリア",
        fr: "Nouvelle-Galles du Sud, Australie",
        de: "New South Wales, Australien",
        it: "Nuovo Galles del Sud, Australia",
        th: "นิวเซาท์เวลส์ ออสเตรเลีย",
        id: "New South Wales, Australia",
        vi: "New South Wales, Úc",
        nl: "Nieuw Zuid-Wales, Australië",
        pl: "Nowa Południowa Walia, Australia",
        nb: "New South Wales, Australia",
        fi: "Uusi Etelä-Wales, Australia",
        ar: "نيو ساوث ويلز ، أستراليا",
    },
    {
        value: 1000,
        prefix: "(GMT+10:00)",
        en: "Northern Mariana Islands",
        ko: "북마리아나 제도",
        sc: "北马里亚纳群岛",
        es: "Islas Marianas del Norte",
        ru: "Северные Марианские острова",
        ja: "北マリアナ諸島",
        fr: "Îles Mariannes du Nord",
        de: "Nördliche Marianneninseln",
        it: "Isole Marianne settentrionali",
        th: "หมู่เกาะนอร์เทิร์นมาเรียนา",
        id: "Kepulauan Mariana Utara",
        vi: "Quần đảo Bắc Mariana",
        nl: "noordelijke Mariana eilanden",
        pl: "Mariany Północne",
        nb: "Nord-Marianene",
        fi: "Pohjois-Mariaanit",
        ar: "جزر مريانا الشمالية",
    },
    {
        value: 1000,
        prefix: "(GMT+10:00)",
        en: "Papua New Guinea",
        ko: "파푸아 뉴기니",
        sc: "巴布亚新几内亚",
        es: "Papúa Nueva Guinea",
        ru: "Папуа - Новая Гвинея",
        ja: "パプアニューギニア",
        fr: "Papouasie Nouvelle Guinée",
        de: "Papua Neu-Guinea",
        it: "Papua Nuova Guinea",
        th: "ปาปัวนิวกินี",
        id: "Papua Nugini",
        vi: "Papua New Guinea",
        nl: "Papoea-Nieuw-Guinea",
        pl: "Papua Nowa Gwinea",
        nb: "Papua Ny-Guinea",
        fi: "Papua-Uusi-Guinea",
        ar: "بابوا غينيا الجديدة",
    },
    {
        value: 1000,
        prefix: "(GMT+10:00)",
        en: "Queensland, Australia",
        ko: "퀸즐랜드, 호주",
        sc: "澳大利亚昆士兰",
        es: "Queensland, Australia",
        ru: "Квинсленд, Австралия",
        ja: "オーストラリア、クイーンズランド州",
        fr: "Queensland, Australie",
        de: "Queensland, Australien",
        it: "Queensland, Australia",
        th: "ควีนส์แลนด์ ออสเตรเลีย",
        id: "Queensland, Australia",
        vi: "Queensland, Úc",
        nl: "Queensland, Australië",
        pl: "Queensland, Australia",
        nb: "Queensland, Australia",
        fi: "Queensland, Australia",
        ar: "كوينزلاند ، أستراليا",
    },
    {
        value: 1000,
        prefix: "(GMT+10:00)",
        en: "Tasmania, Australia",
        ko: "태즈메이니아, 호주 ",
        sc: "澳大利亚塔斯马尼亚",
        es: "Tasmania, Australia",
        ru: "Тасмания, Австралия",
        ja: "タスマニア、オーストラリア",
        fr: "Tasmanie, Australie",
        de: "Tasmanien, Australien",
        it: "Tasmania, Australia",
        th: "แทสมาเนีย ออสเตรเลีย",
        id: "Tasmania, Australia",
        vi: "Tasmania, Úc",
        nl: "Tasmanië, Australië",
        pl: "Tasmania, Australia",
        nb: "Tasmania, Australia",
        fi: "Tasmania, Australia",
        ar: "تسمانيا ، أستراليا",
    },
    {
        value: 1000,
        prefix: "(GMT+10:00)",
        en: "Victoria, Australia",
        ko: "빅토리아, 호주",
        sc: "澳大利亚维多利亚",
        es: "Victoria, Australia",
        ru: "Виктория, Австралия",
        ja: "オーストラリア、ビクトリア",
        fr: "Victoria, Australie",
        de: "Viktoria, Australien",
        it: "Vittoria, Australia",
        th: "วิกตอเรีย ออสเตรเลีย",
        id: "Victoria, Australia",
        vi: "Victoria, Úc",
        nl: "Victoria, Australië",
        pl: "Wiktoria, Australia",
        nb: "Victoria, Australia",
        fi: "Victoria, Australia",
        ar: "فيكتوريا ، أستراليا",
    },
    {
        value: 1000,
        prefix: "(GMT+10:00)",
        en: "Vladivostok, Russia",
        ko: "블라디보스토크, 러시아",
        sc: "俄罗斯符拉迪沃斯托克",
        es: "Vladivostok, Rusia",
        ru: "Владивосток, Россия",
        ja: "ウラジオストク、ロシア",
        fr: "Vladivostok, Russie",
        de: "Wladiwostok, Russland",
        it: "Vladivostok, Russia",
        th: "วลาดีวอสตอค รัสเซีย",
        id: "Vladivostok, Rusia",
        vi: "Vladivostok, Nga",
        nl: "Vladivostok, Rusland",
        pl: "Władywostok, Rosja",
        nb: "Vladivostok, Russland",
        fi: "Vladivostok, Venäjä",
        ar: "فلاديفوستوك ، روسيا",
    },
    {
        value: 1030,
        prefix: "(GMT+10:30)",
        en: "Lord Howe Island, Australia",
        ko: "로드 하우 아일랜드, 호주",
        sc: "澳大利亚豪勋爵岛",
        es: "Isla de Lord Howe, Australia",
        ru: "Остров Лорд-Хау, Австралия",
        ja: "ロードハウ島、オーストラリア",
        fr: "Île Lord Howe, Australie",
        de: "Lord-Howe-Insel, Australien",
        it: "Isola di Lord Howe, Australia",
        th: "เกาะลอร์ดโฮวี ออสเตรเลีย",
        id: "Pulau Lord Howe, Australia",
        vi: "Đảo Lord Howe, Úc",
        nl: "Lord Howe Island, Australië",
        pl: "Wyspa Lorda Howe, Australia",
        nb: "Lord Howe Island, Australia",
        fi: "Lord Howe Island, Australia",
        ar: "جزيرة لورد هاو ، أستراليا",
    },
    {
        value: 1100,
        prefix: "(GMT+11:00)",
        en: "Macquarie Island, Australia",
        ko: "맥쿼리 아일랜드, 호주",
        sc: "澳大利亚麦格理岛",
        es: "Isla Macquarie, Australia",
        ru: "Остров Маккуори, Австралия",
        ja: "マッコーリー島、オーストラリア",
        fr: "Île Macquarie, Australie",
        de: "Macquarie-Insel, Australien",
        it: "Isola di Macquarie, Australia",
        th: "Macquarie Island, ออสเตรเลีย",
        id: "Pulau Macquarie, Australia",
        vi: "Đảo Macquarie, Úc",
        nl: "Macquarie Island, Australië",
        pl: "Wyspa Macquarie, Australia",
        nb: "Macquarie Island, Australia",
        fi: "Macquarie Island, Australia",
        ar: "جزيرة ماكواري ، أستراليا",
    },
    {
        value: 1100,
        prefix: "(GMT+11:00)",
        en: "Magadan, Russia",
        ko: "마가단, 러시아",
        sc: "俄罗斯马加丹",
        es: "Magadán, Rusia",
        ru: "Магадан, Россия",
        ja: "マガダン、ロシア",
        fr: "Magadan, Russie",
        de: "Magadan, Russland",
        it: "Magadan, Russia",
        th: "มากาดาน รัสเซีย",
        id: "Magadan, Rusia",
        vi: "Magadan, Nga",
        nl: "Magadan, Rusland",
        pl: "Magadan, Rosja",
        nb: "Magadan, Russland",
        fi: "Magadan, Venäjä",
        ar: "ماجادان ، روسيا",
    },
    {
        value: 1100,
        prefix: "(GMT+11:00)",
        en: "Micronesia, states of Kosrae and Pohnpei",
        ko: "미크로네시아, 코스라에 주와 폰페이 주",
        sc: "密克罗尼西亚、科斯雷州和波纳佩州",
        es: "Micronesia, estados de Kosrae y Pohnpei",
        ru: "Микронезия, штаты Косраэ и Понпеи",
        ja: "ミクロネシア、コスラエ島とポンペイ州",
        fr: "Micronésie, états de Kosrae et Pohnpei",
        de: "Mikronesien, Bundesstaaten Kosrae und Pohnpei",
        it: "Micronesia, stati di Kosrae e Pohnpei",
        th: "ไมโครนีเซีย รัฐคอสแรและโปนเป",
        id: "Mikronesia, negara bagian Kosrae dan Pohnpei",
        vi: "Micronesia, các bang Kosrae và Pohnpei",
        nl: "Micronesië, staten Kosrae en Pohnpei",
        pl: "Mikronezja, stany Kosrae i Pohnpei",
        nb: "Mikronesia, delstatene Kosrae og Pohnpei",
        fi: "Mikronesia, Kosraen ja Pohnpein osavaltiot",
        ar: "ولايات ميكرونيزيا كوسراي وبوهنباي",
    },
    {
        value: 1100,
        prefix: "(GMT+11:00)",
        en: "New Caledonia",
        ko: "뉴 칼레도니아",
        sc: "新喀里多尼亚",
        es: "Nueva Caledonia",
        ru: "Новая Каледония",
        ja: "ニューカレドニア",
        fr: "Nouvelle Calédonie",
        de: "Neu-Kaledonien",
        it: "Nuova Caledonia",
        th: "นิวแคลิโดเนีย",
        id: "Kaledonia Baru",
        vi: "New Caledonia",
        nl: "Nieuw-Caledonië",
        pl: "Nowa Kaledonia",
        nb: "Ny Caledonia",
        fi: "Uusi-Caledonia",
        ar: "كاليدونيا الجديدة",
    },
    {
        value: 1100,
        prefix: "(GMT+11:00)",
        en: "Norfolk Island",
        ko: "노퍽 섬",
        sc: "诺福克岛",
        es: "Isla Norfolk",
        ru: "Остров Норфолк",
        ja: "ノーフォーク島",
        fr: "l'ile de Norfolk",
        de: "Norfolkinsel",
        it: "Isola Norfolk",
        th: "เกาะนอร์ฟอล์ก",
        id: "Pulau Norfolk",
        vi: "Đảo Norfolk",
        nl: "Norfolkeiland",
        pl: "Wyspa Norfolk",
        nb: "Norfolkøya",
        fi: "Norfolkin saari",
        ar: "جزيرة نورفولك",
    },
    {
        value: 1100,
        prefix: "(GMT+11:00)",
        en: "Papua New Guinea, Bougainville Island",
        ko: "파푸아뉴기니, 부겐빌 아일랜드",
        sc: "巴布亚新几内亚，布干维尔岛",
        es: "Papua Nueva Guinea, Isla Bougainville",
        ru: "Папуа-Новая Гвинея, остров Бугенвиль",
        ja: "パプアニューギニア、ブーゲンビル島",
        fr: "Papouasie-Nouvelle-Guinée, île de Bougainville",
        de: "Papua-Neuguinea, Bougainville-Insel",
        it: "Papua Nuova Guinea, isola di Bougainville",
        th: "ปาปัวนิวกินี เกาะบูเกนวิลล์",
        id: "Papua Nugini, Pulau Bougainville",
        vi: "Papua New Guinea, Đảo Bougainville",
        nl: "Papoea-Nieuw-Guinea, Bougainville Island",
        pl: "Papua Nowa Gwinea, wyspa Bougainville",
        nb: "Papua Ny-Guinea, Bougainville-øya",
        fi: "Papua-Uusi-Guinea, Bougainville Island",
        ar: "بابوا غينيا الجديدة ، جزيرة بوغانفيل",
    },
    {
        value: 1100,
        prefix: "(GMT+11:00)",
        en: "Solomon Islands",
        ko: "솔로몬 제도",
        sc: "所罗门群岛",
        es: "Islas Salomón",
        ru: "Соломоновы острова",
        ja: "ソロモン諸島",
        fr: "îles Salomon",
        de: "Salomon-Inseln",
        it: "Isole Salomone",
        th: "หมู่เกาะโซโลมอน",
        id: "Pulau Solomon",
        vi: "Quần đảo Solomon",
        nl: "Solomon eilanden",
        pl: "Wyspy Salomona",
        nb: "Solomon øyene",
        fi: "Solomonsaaret",
        ar: "جزر سليمان",
    },
    {
        value: 1100,
        prefix: "(GMT+11:00)",
        en: "Vanuatu",
        ko: "바누아투",
        sc: "瓦努阿图",
        es: "Vanuatu",
        ru: "Вануату",
        ja: "バヌアツ",
        fr: "Vanuatu",
        de: "Vanuatu",
        it: "Vanuatu",
        th: "วานูอาตู",
        id: "Vanuatu",
        vi: "Vanuatu",
        nl: "Vanuatu",
        pl: "Vanuatu",
        nb: "Vanuatu",
        fi: "Vanuatu",
        ar: "فانواتو",
    },
    {
        value: 1100,
        prefix: "(GMT+11:00)",
        en: "Yuzhno-Sakhalinsk, Russia",
        ko: "유즈노사할린스크, 러시아 ",
        sc: "俄罗斯南萨哈林斯克",
        es: "Yuzhno-Sakhalinsk, Rusia",
        ru: "Южно-Сахалинск, Россия",
        ja: "ユジノサハリンスク、ロシア",
        fr: "Ioujno-Sakhalinsk, Russie",
        de: "Juschno-Sachalinsk, Russland",
        it: "Yuzhno-Sakhalinsk, Russia",
        th: "Yuzhno-Sakhalinsk, รัสเซีย",
        id: "Yuzhno-Sakhalinsk, Rusia",
        vi: "Yuzhno-Sakhalinsk, Nga",
        nl: "Joezjno-Sachalinsk, Rusland",
        pl: "Jużno-Sachalińsk, Rosja",
        nb: "Yuzhno-Sakhalinsk, Russland",
        fi: "Yuzhno-Sakhalinsk, Venäjä",
        ar: "يوجنو ساخالينسك ، روسيا",
    },
    {
        value: 1200,
        prefix: "(GMT+12:00)",
        en: "Anadyr, Russia",
        ko: "아나디르, 러시아 ",
        sc: "俄罗斯阿纳德尔",
        es: "Anádyr, Rusia",
        ru: "Анадырь, Россия",
        ja: "アナディル、ロシア",
        fr: "Anadyr, Russie",
        de: "Anadyr, Russland",
        it: "Anadyr, Russia",
        th: "Anadyr, รัสเซีย",
        id: "Anadyr, Rusia",
        vi: "Anadyr, Nga",
        nl: "Anadyr, Rusland",
        pl: "Anadyr, Rosja",
        nb: "Anadyr, Russland",
        fi: "Anadyr, Venäjä",
        ar: "أنادير ، روسيا",
    },
    {
        value: 1200,
        prefix: "(GMT+12:00)",
        en: "Fiji",
        ko: "피지",
        sc: "斐济",
        es: "Fiyi",
        ru: "Фиджи",
        ja: "フィジー",
        fr: "Fidji",
        de: "Fidschi",
        it: "Figi",
        th: "ฟิจิ",
        id: "Fiji",
        vi: "Fiji",
        nl: "Fiji",
        pl: "Fidżi",
        nb: "Fiji",
        fi: "Fidži",
        ar: "فيجي",
    },
    {
        value: 1200,
        prefix: "(GMT+12:00)",
        en: "Gilbert Islands, Kiribati",
        ko: "길버트 제도, 키리바시",
        sc: "吉尔伯特群岛，基里巴斯",
        es: "Islas Gilbert, Kiribati",
        ru: "Острова Гилберта, Кирибати",
        ja: "キリバスのギルバート諸島",
        fr: "Îles Gilbert, Kiribati",
        de: "Gilbert-Inseln, Kiribati",
        it: "Isole Gilbert, Kiribati",
        th: "หมู่เกาะกิลเบิร์ต คิริบาส",
        id: "Kepulauan Gilbert, Kiribati",
        vi: "Quần đảo Gilbert, Kiribati",
        nl: "Gilbert-eilanden, Kiribati",
        pl: "Wyspy Gilberta, Kiribati",
        nb: "Gilbertøyene, Kiribati",
        fi: "Gilbertin saaret, Kiribati",
        ar: "جزر جيلبرت ، كيريباتي",
    },
    {
        value: 1200,
        prefix: "(GMT+12:00)",
        en: "Marshall Islands",
        ko: "마셜 제도",
        sc: "马绍尔群岛",
        es: "Islas Marshall",
        ru: "Маршалловы острова",
        ja: "マーシャル諸島",
        fr: "Iles Marshall",
        de: "Marshallinseln",
        it: "Isole Marshall",
        th: "หมู่เกาะมาร์แชลล์",
        id: "Pulau Marshall",
        vi: "đảo Marshall",
        nl: "Marshall eilanden",
        pl: "Wyspy Marshalla",
        nb: "Marshalløyene",
        fi: "Marshallsaaret",
        ar: "جزر مارشال",
    },
    {
        value: 1200,
        prefix: "(GMT+12:00)",
        en: "Nauru",
        ko: "나우루",
        sc: "瑙鲁",
        es: "Nauru",
        ru: "Науру",
        ja: "ナウル",
        fr: "Nauru",
        de: "Nauru",
        it: "Nauru",
        th: "นาอูรู",
        id: "Nauru",
        vi: "Nauru",
        nl: "Nauru",
        pl: "Nauru",
        nb: "Nauru",
        fi: "Nauru",
        ar: "ناورو",
    },
    {
        value: 1200,
        prefix: "(GMT+12:00)",
        en: "New Zealand",
        ko: "뉴질랜드",
        sc: "新西兰",
        es: "Nueva Zelanda",
        ru: "Новая Зеландия",
        ja: "ニュージーランド",
        fr: "Nouvelle-Zélande",
        de: "Neuseeland",
        it: "Nuova Zelanda",
        th: "นิวซีแลนด์",
        id: "Selandia Baru",
        vi: "New Zealand",
        nl: "Nieuw-Zeeland",
        pl: "Nowa Zelandia",
        nb: "New Zealand",
        fi: "Uusi Seelanti",
        ar: "نيوزيلاندا",
    },
    {
        value: 1200,
        prefix: "(GMT+12:00)",
        en: "Petropavlovsk-Kamchatsky, Russia",
        ko: "페트로파블롭스크-캄차츠키, 러시아 ",
        sc: "俄罗斯堪察加彼得罗巴甫洛夫斯克",
        es: "Petropavlovsk-Kamchatsky, Rusia",
        ru: "Петропавловск-Камчатский, Россия",
        ja: "ペトロパブロフスク-カムチャツキー、ロシア",
        fr: "Petropavlovsk-Kamtchatski, Russie",
        de: "Petropawlowsk-Kamtschatski, Russland",
        it: "Petropavlovsk-Kamchatsky, Russia",
        th: "ปิตราปัฟลัฟสค์-คัมชัตสกี รัสเซีย",
        id: "Petropavlovsk-Kamchatsky, Rusia",
        vi: "Petropavlovsk-Kamchatsky, Nga",
        nl: "Petropavlovsk-Kamchatsky, Rusland",
        pl: "Pietropawłowsk Kamczacki, Rosja",
        nb: "Petropavlovsk-Kamchatsky, Russland",
        fi: "Petropavlovsk-Kamchatsky, Venäjä",
        ar: "بتروبافلوفسك كامتشاتسكي ، روسيا",
    },
    {
        value: 1200,
        prefix: "(GMT+12:00)",
        en: "Tuvalu",
        ko: "투발루",
        sc: "图瓦卢",
        es: "Tuvalu",
        ru: "Тувалу",
        ja: "ツバル",
        fr: "Tuvalu",
        de: "Tuvalu",
        it: "Tuvalù",
        th: "ตูวาลู",
        id: "Tuvalu",
        vi: "Tuvalu",
        nl: "Tuvalu",
        pl: "Tuvalu",
        nb: "Tuvalu",
        fi: "Tuvalu",
        ar: "توفالو",
    },
    {
        value: 1200,
        prefix: "(GMT+12:00)",
        en: "Wake Island ",
        ko: "웨이크 아일랜드",
        sc: "威克岛",
        es: "Isla Wake",
        ru: "Остров Уэйк",
        ja: "ウェーク島",
        fr: "Île Wake",
        de: "Wake-Insel",
        it: "Wake Island",
        th: "เกาะเวก",
        id: "Pulau Bangun",
        vi: "Đảo Wake",
        nl: "Wake Island",
        pl: "Wyspa Wake",
        nb: "Wake Island",
        fi: "Waken saari",
        ar: "جزيرة ويك",
    },
    {
        value: 1200,
        prefix: "(GMT+12:00)",
        en: "Wallis and Futuna ",
        ko: "월리스와 푸투나",
        sc: "瓦利斯和富图纳",
        es: "Wallis y Futuna",
        ru: "Уоллис и Футуна",
        ja: "ウォリス・フツナ",
        fr: "Wallis et Futuna",
        de: "Wallis und Futuna",
        it: "Wallis e Futuna",
        th: "วาลลิสและฟุตูนา",
        id: "Wallis dan Futuna",
        vi: "Wallis và Futuna",
        nl: "Wallis en Futuna",
        pl: "Wallis i Futuna",
        nb: "Wallis og Futuna",
        fi: "Wallis ja Futuna",
        ar: "واليس وفوتونا",
    },
    {
        value: 1300,
        prefix: "(GMT+13:00)",
        en: "Phoenix Islands, Kiribati",
        ko: "피닉스 제도, 키리바시",
        sc: "菲尼克斯群岛，基里巴斯",
        es: "Islas Fénix, Kiribati",
        ru: "Острова Феникс, Кирибати",
        ja: "フェニックス諸島、キリバス",
        fr: "Îles Phoenix, Kiribati",
        de: "Phoenix-Inseln, Kiribati",
        it: "Isole Phoenix, Kiribati",
        th: "หมู่เกาะฟีนิกซ์ คิริบาส",
        id: "Kepulauan Phoenix, Kiribati",
        vi: "Quần đảo Phoenix, Kiribati",
        nl: "Phoenix-eilanden, Kiribati",
        pl: "Wyspy Phoenix, Kiribati",
        nb: "Phoenix-øyene, Kiribati",
        fi: "Phoenix-saaret, Kiribati",
        ar: "جزر فينيكس ، كيريباتي",
    },
    {
        value: 1300,
        prefix: "(GMT+13:00)",
        en: "Samoa",
        ko: "사모아",
        sc: "萨摩亚",
        es: "samoa",
        ru: "Самоа",
        ja: "サモア",
        fr: "Samoa",
        de: "Samoa",
        it: "Samoa",
        th: "ซามัว",
        id: "Samoa",
        vi: "Samoa",
        nl: "Samoa",
        pl: "Samoa",
        nb: "Samoa",
        fi: "Samoa",
        ar: "ساموا",
    },
    {
        value: 1300,
        prefix: "(GMT+13:00)",
        en: "Tokelau",
        ko: "토켈라우",
        sc: "托克劳",
        es: "Tokelau",
        ru: "Токелау",
        ja: "トケラウ",
        fr: "Tokélaou",
        de: "Tokelau",
        it: "Tokelau",
        th: "โตเกเลา",
        id: "Tokelau",
        vi: "Tokelau",
        nl: "Tokelau",
        pl: "Tokelau",
        nb: "Tokelau",
        fi: "Tokelau",
        ar: "توكيلاو",
    },
];

var VideoImage = {
    "0": "Highest(Extreme)",
    "1": "Highest",
    "2": "High",
    "3": "Normal",
};

var VideoResolution = {
    "0": "4K UHD 30fps (Extreme) + FHD 30fps",
    "1": "4K UHD 30fps + FHD 30fps",
    "2": "FHD 60fps + FHD 30fps",
    "3": "FHD 30fps + FHD 30fps",
};

var axios$3 = {exports: {}};

var bind$4 = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};

var bind$3 = bind$4;

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray$5(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer$3(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString$2(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber$3(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject$1(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */
function isPlainObject(val) {
  if (toString.call(val) !== '[object Object]') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate$2(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject$1(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach$1(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray$5(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge$1(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge$1(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge$1({}, val);
    } else if (isArray$5(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach$1(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach$1(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind$3(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */
function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

var utils$c = {
  isArray: isArray$5,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer$3,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString$2,
  isNumber: isNumber$3,
  isObject: isObject$1,
  isPlainObject: isPlainObject,
  isUndefined: isUndefined,
  isDate: isDate$2,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach$1,
  merge: merge$1,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM
};

var utils$b = utils$c;

function encode$2(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
var buildURL$1 = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils$b.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils$b.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils$b.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils$b.forEach(val, function parseValue(v) {
        if (utils$b.isDate(v)) {
          v = v.toISOString();
        } else if (utils$b.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode$2(key) + '=' + encode$2(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};

var utils$a = utils$c;

function InterceptorManager$1() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager$1.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager$1.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager$1.prototype.forEach = function forEach(fn) {
  utils$a.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

var InterceptorManager_1 = InterceptorManager$1;

var utils$9 = utils$c;

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
var transformData$1 = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils$9.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};

var isCancel$1;
var hasRequiredIsCancel;

function requireIsCancel () {
	if (hasRequiredIsCancel) return isCancel$1;
	hasRequiredIsCancel = 1;

	isCancel$1 = function isCancel(value) {
	  return !!(value && value.__CANCEL__);
	};
	return isCancel$1;
}

var utils$8 = utils$c;

var normalizeHeaderName$1 = function normalizeHeaderName(headers, normalizedName) {
  utils$8.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};

var enhanceError;
var hasRequiredEnhanceError;

function requireEnhanceError () {
	if (hasRequiredEnhanceError) return enhanceError;
	hasRequiredEnhanceError = 1;

	/**
	 * Update an Error with the specified config, error code, and response.
	 *
	 * @param {Error} error The error to update.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The error.
	 */
	enhanceError = function enhanceError(error, config, code, request, response) {
	  error.config = config;
	  if (code) {
	    error.code = code;
	  }

	  error.request = request;
	  error.response = response;
	  error.isAxiosError = true;

	  error.toJSON = function toJSON() {
	    return {
	      // Standard
	      message: this.message,
	      name: this.name,
	      // Microsoft
	      description: this.description,
	      number: this.number,
	      // Mozilla
	      fileName: this.fileName,
	      lineNumber: this.lineNumber,
	      columnNumber: this.columnNumber,
	      stack: this.stack,
	      // Axios
	      config: this.config,
	      code: this.code
	    };
	  };
	  return error;
	};
	return enhanceError;
}

var createError;
var hasRequiredCreateError;

function requireCreateError () {
	if (hasRequiredCreateError) return createError;
	hasRequiredCreateError = 1;

	var enhanceError = requireEnhanceError();

	/**
	 * Create an Error with the specified message, config, error code, request and response.
	 *
	 * @param {string} message The error message.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The created error.
	 */
	createError = function createError(message, config, code, request, response) {
	  var error = new Error(message);
	  return enhanceError(error, config, code, request, response);
	};
	return createError;
}

var settle;
var hasRequiredSettle;

function requireSettle () {
	if (hasRequiredSettle) return settle;
	hasRequiredSettle = 1;

	var createError = requireCreateError();

	/**
	 * Resolve or reject a Promise based on response status.
	 *
	 * @param {Function} resolve A function that resolves the promise.
	 * @param {Function} reject A function that rejects the promise.
	 * @param {object} response The response.
	 */
	settle = function settle(resolve, reject, response) {
	  var validateStatus = response.config.validateStatus;
	  if (!response.status || !validateStatus || validateStatus(response.status)) {
	    resolve(response);
	  } else {
	    reject(createError(
	      'Request failed with status code ' + response.status,
	      response.config,
	      null,
	      response.request,
	      response
	    ));
	  }
	};
	return settle;
}

var cookies;
var hasRequiredCookies;

function requireCookies () {
	if (hasRequiredCookies) return cookies;
	hasRequiredCookies = 1;

	var utils = utils$c;

	cookies = (
	  utils.isStandardBrowserEnv() ?

	  // Standard browser envs support document.cookie
	    (function standardBrowserEnv() {
	      return {
	        write: function write(name, value, expires, path, domain, secure) {
	          var cookie = [];
	          cookie.push(name + '=' + encodeURIComponent(value));

	          if (utils.isNumber(expires)) {
	            cookie.push('expires=' + new Date(expires).toGMTString());
	          }

	          if (utils.isString(path)) {
	            cookie.push('path=' + path);
	          }

	          if (utils.isString(domain)) {
	            cookie.push('domain=' + domain);
	          }

	          if (secure === true) {
	            cookie.push('secure');
	          }

	          document.cookie = cookie.join('; ');
	        },

	        read: function read(name) {
	          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
	          return (match ? decodeURIComponent(match[3]) : null);
	        },

	        remove: function remove(name) {
	          this.write(name, '', Date.now() - 86400000);
	        }
	      };
	    })() :

	  // Non standard browser env (web workers, react-native) lack needed support.
	    (function nonStandardBrowserEnv() {
	      return {
	        write: function write() {},
	        read: function read() { return null; },
	        remove: function remove() {}
	      };
	    })()
	);
	return cookies;
}

var isAbsoluteURL;
var hasRequiredIsAbsoluteURL;

function requireIsAbsoluteURL () {
	if (hasRequiredIsAbsoluteURL) return isAbsoluteURL;
	hasRequiredIsAbsoluteURL = 1;

	/**
	 * Determines whether the specified URL is absolute
	 *
	 * @param {string} url The URL to test
	 * @returns {boolean} True if the specified URL is absolute, otherwise false
	 */
	isAbsoluteURL = function isAbsoluteURL(url) {
	  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
	  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
	  // by any combination of letters, digits, plus, period, or hyphen.
	  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
	};
	return isAbsoluteURL;
}

var combineURLs;
var hasRequiredCombineURLs;

function requireCombineURLs () {
	if (hasRequiredCombineURLs) return combineURLs;
	hasRequiredCombineURLs = 1;

	/**
	 * Creates a new URL by combining the specified URLs
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} relativeURL The relative URL
	 * @returns {string} The combined URL
	 */
	combineURLs = function combineURLs(baseURL, relativeURL) {
	  return relativeURL
	    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
	    : baseURL;
	};
	return combineURLs;
}

var buildFullPath;
var hasRequiredBuildFullPath;

function requireBuildFullPath () {
	if (hasRequiredBuildFullPath) return buildFullPath;
	hasRequiredBuildFullPath = 1;

	var isAbsoluteURL = requireIsAbsoluteURL();
	var combineURLs = requireCombineURLs();

	/**
	 * Creates a new URL by combining the baseURL with the requestedURL,
	 * only when the requestedURL is not already an absolute URL.
	 * If the requestURL is absolute, this function returns the requestedURL untouched.
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} requestedURL Absolute or relative URL to combine
	 * @returns {string} The combined full path
	 */
	buildFullPath = function buildFullPath(baseURL, requestedURL) {
	  if (baseURL && !isAbsoluteURL(requestedURL)) {
	    return combineURLs(baseURL, requestedURL);
	  }
	  return requestedURL;
	};
	return buildFullPath;
}

var parseHeaders;
var hasRequiredParseHeaders;

function requireParseHeaders () {
	if (hasRequiredParseHeaders) return parseHeaders;
	hasRequiredParseHeaders = 1;

	var utils = utils$c;

	// Headers whose duplicates are ignored by node
	// c.f. https://nodejs.org/api/http.html#http_message_headers
	var ignoreDuplicateOf = [
	  'age', 'authorization', 'content-length', 'content-type', 'etag',
	  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
	  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
	  'referer', 'retry-after', 'user-agent'
	];

	/**
	 * Parse headers into an object
	 *
	 * ```
	 * Date: Wed, 27 Aug 2014 08:58:49 GMT
	 * Content-Type: application/json
	 * Connection: keep-alive
	 * Transfer-Encoding: chunked
	 * ```
	 *
	 * @param {String} headers Headers needing to be parsed
	 * @returns {Object} Headers parsed into an object
	 */
	parseHeaders = function parseHeaders(headers) {
	  var parsed = {};
	  var key;
	  var val;
	  var i;

	  if (!headers) { return parsed; }

	  utils.forEach(headers.split('\n'), function parser(line) {
	    i = line.indexOf(':');
	    key = utils.trim(line.substr(0, i)).toLowerCase();
	    val = utils.trim(line.substr(i + 1));

	    if (key) {
	      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
	        return;
	      }
	      if (key === 'set-cookie') {
	        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
	      } else {
	        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	      }
	    }
	  });

	  return parsed;
	};
	return parseHeaders;
}

var isURLSameOrigin;
var hasRequiredIsURLSameOrigin;

function requireIsURLSameOrigin () {
	if (hasRequiredIsURLSameOrigin) return isURLSameOrigin;
	hasRequiredIsURLSameOrigin = 1;

	var utils = utils$c;

	isURLSameOrigin = (
	  utils.isStandardBrowserEnv() ?

	  // Standard browser envs have full support of the APIs needed to test
	  // whether the request URL is of the same origin as current location.
	    (function standardBrowserEnv() {
	      var msie = /(msie|trident)/i.test(navigator.userAgent);
	      var urlParsingNode = document.createElement('a');
	      var originURL;

	      /**
	    * Parse a URL to discover it's components
	    *
	    * @param {String} url The URL to be parsed
	    * @returns {Object}
	    */
	      function resolveURL(url) {
	        var href = url;

	        if (msie) {
	        // IE needs attribute set twice to normalize properties
	          urlParsingNode.setAttribute('href', href);
	          href = urlParsingNode.href;
	        }

	        urlParsingNode.setAttribute('href', href);

	        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	        return {
	          href: urlParsingNode.href,
	          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	          host: urlParsingNode.host,
	          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	          hostname: urlParsingNode.hostname,
	          port: urlParsingNode.port,
	          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
	            urlParsingNode.pathname :
	            '/' + urlParsingNode.pathname
	        };
	      }

	      originURL = resolveURL(window.location.href);

	      /**
	    * Determine if a URL shares the same origin as the current location
	    *
	    * @param {String} requestURL The URL to test
	    * @returns {boolean} True if URL shares the same origin, otherwise false
	    */
	      return function isURLSameOrigin(requestURL) {
	        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
	        return (parsed.protocol === originURL.protocol &&
	            parsed.host === originURL.host);
	      };
	    })() :

	  // Non standard browser envs (web workers, react-native) lack needed support.
	    (function nonStandardBrowserEnv() {
	      return function isURLSameOrigin() {
	        return true;
	      };
	    })()
	);
	return isURLSameOrigin;
}

var xhr;
var hasRequiredXhr;

function requireXhr () {
	if (hasRequiredXhr) return xhr;
	hasRequiredXhr = 1;

	var utils = utils$c;
	var settle = requireSettle();
	var cookies = requireCookies();
	var buildURL = buildURL$1;
	var buildFullPath = requireBuildFullPath();
	var parseHeaders = requireParseHeaders();
	var isURLSameOrigin = requireIsURLSameOrigin();
	var createError = requireCreateError();

	xhr = function xhrAdapter(config) {
	  return new Promise(function dispatchXhrRequest(resolve, reject) {
	    var requestData = config.data;
	    var requestHeaders = config.headers;

	    if (utils.isFormData(requestData)) {
	      delete requestHeaders['Content-Type']; // Let the browser set it
	    }

	    var request = new XMLHttpRequest();

	    // HTTP basic authentication
	    if (config.auth) {
	      var username = config.auth.username || '';
	      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
	      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
	    }

	    var fullPath = buildFullPath(config.baseURL, config.url);
	    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

	    // Set the request timeout in MS
	    request.timeout = config.timeout;

	    // Listen for ready state
	    request.onreadystatechange = function handleLoad() {
	      if (!request || request.readyState !== 4) {
	        return;
	      }

	      // The request errored out and we didn't get a response, this will be
	      // handled by onerror instead
	      // With one exception: request that using file: protocol, most browsers
	      // will return status as 0 even though it's a successful request
	      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
	        return;
	      }

	      // Prepare the response
	      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
	      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
	      var response = {
	        data: responseData,
	        status: request.status,
	        statusText: request.statusText,
	        headers: responseHeaders,
	        config: config,
	        request: request
	      };

	      settle(resolve, reject, response);

	      // Clean up request
	      request = null;
	    };

	    // Handle browser request cancellation (as opposed to a manual cancellation)
	    request.onabort = function handleAbort() {
	      if (!request) {
	        return;
	      }

	      reject(createError('Request aborted', config, 'ECONNABORTED', request));

	      // Clean up request
	      request = null;
	    };

	    // Handle low level network errors
	    request.onerror = function handleError() {
	      // Real errors are hidden from us by the browser
	      // onerror should only fire if it's a network error
	      reject(createError('Network Error', config, null, request));

	      // Clean up request
	      request = null;
	    };

	    // Handle timeout
	    request.ontimeout = function handleTimeout() {
	      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
	      if (config.timeoutErrorMessage) {
	        timeoutErrorMessage = config.timeoutErrorMessage;
	      }
	      reject(createError(timeoutErrorMessage, config, 'ECONNABORTED',
	        request));

	      // Clean up request
	      request = null;
	    };

	    // Add xsrf header
	    // This is only done if running in a standard browser environment.
	    // Specifically not if we're in a web worker, or react-native.
	    if (utils.isStandardBrowserEnv()) {
	      // Add xsrf header
	      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
	        cookies.read(config.xsrfCookieName) :
	        undefined;

	      if (xsrfValue) {
	        requestHeaders[config.xsrfHeaderName] = xsrfValue;
	      }
	    }

	    // Add headers to the request
	    if ('setRequestHeader' in request) {
	      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
	        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
	          // Remove Content-Type if data is undefined
	          delete requestHeaders[key];
	        } else {
	          // Otherwise add header to the request
	          request.setRequestHeader(key, val);
	        }
	      });
	    }

	    // Add withCredentials to request if needed
	    if (!utils.isUndefined(config.withCredentials)) {
	      request.withCredentials = !!config.withCredentials;
	    }

	    // Add responseType to request if needed
	    if (config.responseType) {
	      try {
	        request.responseType = config.responseType;
	      } catch (e) {
	        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
	        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
	        if (config.responseType !== 'json') {
	          throw e;
	        }
	      }
	    }

	    // Handle progress if needed
	    if (typeof config.onDownloadProgress === 'function') {
	      request.addEventListener('progress', config.onDownloadProgress);
	    }

	    // Not all browsers support upload events
	    if (typeof config.onUploadProgress === 'function' && request.upload) {
	      request.upload.addEventListener('progress', config.onUploadProgress);
	    }

	    if (config.cancelToken) {
	      // Handle cancellation
	      config.cancelToken.promise.then(function onCanceled(cancel) {
	        if (!request) {
	          return;
	        }

	        request.abort();
	        reject(cancel);
	        // Clean up request
	        request = null;
	      });
	    }

	    if (!requestData) {
	      requestData = null;
	    }

	    // Send the request
	    request.send(requestData);
	  });
	};
	return xhr;
}

var followRedirects = {exports: {}};

var url = {};

var punycode = {exports: {}};

/*! https://mths.be/punycode v1.3.2 by @mathias */
punycode.exports;

var hasRequiredPunycode;

function requirePunycode () {
	if (hasRequiredPunycode) return punycode.exports;
	hasRequiredPunycode = 1;
	(function (module, exports) {
(function(root) {

			/** Detect free variables */
			var freeExports = exports &&
				!exports.nodeType && exports;
			var freeModule = module &&
				!module.nodeType && module;
			var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal;
			if (
				freeGlobal.global === freeGlobal ||
				freeGlobal.window === freeGlobal ||
				freeGlobal.self === freeGlobal
			) {
				root = freeGlobal;
			}

			/**
			 * The `punycode` object.
			 * @name punycode
			 * @type Object
			 */
			var punycode,

			/** Highest positive signed 32-bit float value */
			maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1

			/** Bootstring parameters */
			base = 36,
			tMin = 1,
			tMax = 26,
			skew = 38,
			damp = 700,
			initialBias = 72,
			initialN = 128, // 0x80
			delimiter = '-', // '\x2D'

			/** Regular expressions */
			regexPunycode = /^xn--/,
			regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
			regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators

			/** Error messages */
			errors = {
				'overflow': 'Overflow: input needs wider integers to process',
				'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
				'invalid-input': 'Invalid input'
			},

			/** Convenience shortcuts */
			baseMinusTMin = base - tMin,
			floor = Math.floor,
			stringFromCharCode = String.fromCharCode,

			/** Temporary variable */
			key;

			/*--------------------------------------------------------------------------*/

			/**
			 * A generic error utility function.
			 * @private
			 * @param {String} type The error type.
			 * @returns {Error} Throws a `RangeError` with the applicable error message.
			 */
			function error(type) {
				throw RangeError(errors[type]);
			}

			/**
			 * A generic `Array#map` utility function.
			 * @private
			 * @param {Array} array The array to iterate over.
			 * @param {Function} callback The function that gets called for every array
			 * item.
			 * @returns {Array} A new array of values returned by the callback function.
			 */
			function map(array, fn) {
				var length = array.length;
				var result = [];
				while (length--) {
					result[length] = fn(array[length]);
				}
				return result;
			}

			/**
			 * A simple `Array#map`-like wrapper to work with domain name strings or email
			 * addresses.
			 * @private
			 * @param {String} domain The domain name or email address.
			 * @param {Function} callback The function that gets called for every
			 * character.
			 * @returns {Array} A new string of characters returned by the callback
			 * function.
			 */
			function mapDomain(string, fn) {
				var parts = string.split('@');
				var result = '';
				if (parts.length > 1) {
					// In email addresses, only the domain name should be punycoded. Leave
					// the local part (i.e. everything up to `@`) intact.
					result = parts[0] + '@';
					string = parts[1];
				}
				// Avoid `split(regex)` for IE8 compatibility. See #17.
				string = string.replace(regexSeparators, '\x2E');
				var labels = string.split('.');
				var encoded = map(labels, fn).join('.');
				return result + encoded;
			}

			/**
			 * Creates an array containing the numeric code points of each Unicode
			 * character in the string. While JavaScript uses UCS-2 internally,
			 * this function will convert a pair of surrogate halves (each of which
			 * UCS-2 exposes as separate characters) into a single code point,
			 * matching UTF-16.
			 * @see `punycode.ucs2.encode`
			 * @see <https://mathiasbynens.be/notes/javascript-encoding>
			 * @memberOf punycode.ucs2
			 * @name decode
			 * @param {String} string The Unicode input string (UCS-2).
			 * @returns {Array} The new array of code points.
			 */
			function ucs2decode(string) {
				var output = [],
				    counter = 0,
				    length = string.length,
				    value,
				    extra;
				while (counter < length) {
					value = string.charCodeAt(counter++);
					if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
						// high surrogate, and there is a next character
						extra = string.charCodeAt(counter++);
						if ((extra & 0xFC00) == 0xDC00) { // low surrogate
							output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
						} else {
							// unmatched surrogate; only append this code unit, in case the next
							// code unit is the high surrogate of a surrogate pair
							output.push(value);
							counter--;
						}
					} else {
						output.push(value);
					}
				}
				return output;
			}

			/**
			 * Creates a string based on an array of numeric code points.
			 * @see `punycode.ucs2.decode`
			 * @memberOf punycode.ucs2
			 * @name encode
			 * @param {Array} codePoints The array of numeric code points.
			 * @returns {String} The new Unicode string (UCS-2).
			 */
			function ucs2encode(array) {
				return map(array, function(value) {
					var output = '';
					if (value > 0xFFFF) {
						value -= 0x10000;
						output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
						value = 0xDC00 | value & 0x3FF;
					}
					output += stringFromCharCode(value);
					return output;
				}).join('');
			}

			/**
			 * Converts a basic code point into a digit/integer.
			 * @see `digitToBasic()`
			 * @private
			 * @param {Number} codePoint The basic numeric code point value.
			 * @returns {Number} The numeric value of a basic code point (for use in
			 * representing integers) in the range `0` to `base - 1`, or `base` if
			 * the code point does not represent a value.
			 */
			function basicToDigit(codePoint) {
				if (codePoint - 48 < 10) {
					return codePoint - 22;
				}
				if (codePoint - 65 < 26) {
					return codePoint - 65;
				}
				if (codePoint - 97 < 26) {
					return codePoint - 97;
				}
				return base;
			}

			/**
			 * Converts a digit/integer into a basic code point.
			 * @see `basicToDigit()`
			 * @private
			 * @param {Number} digit The numeric value of a basic code point.
			 * @returns {Number} The basic code point whose value (when used for
			 * representing integers) is `digit`, which needs to be in the range
			 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
			 * used; else, the lowercase form is used. The behavior is undefined
			 * if `flag` is non-zero and `digit` has no uppercase form.
			 */
			function digitToBasic(digit, flag) {
				//  0..25 map to ASCII a..z or A..Z
				// 26..35 map to ASCII 0..9
				return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
			}

			/**
			 * Bias adaptation function as per section 3.4 of RFC 3492.
			 * http://tools.ietf.org/html/rfc3492#section-3.4
			 * @private
			 */
			function adapt(delta, numPoints, firstTime) {
				var k = 0;
				delta = firstTime ? floor(delta / damp) : delta >> 1;
				delta += floor(delta / numPoints);
				for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
					delta = floor(delta / baseMinusTMin);
				}
				return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
			}

			/**
			 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
			 * symbols.
			 * @memberOf punycode
			 * @param {String} input The Punycode string of ASCII-only symbols.
			 * @returns {String} The resulting string of Unicode symbols.
			 */
			function decode(input) {
				// Don't use UCS-2
				var output = [],
				    inputLength = input.length,
				    out,
				    i = 0,
				    n = initialN,
				    bias = initialBias,
				    basic,
				    j,
				    index,
				    oldi,
				    w,
				    k,
				    digit,
				    t,
				    /** Cached calculation results */
				    baseMinusT;

				// Handle the basic code points: let `basic` be the number of input code
				// points before the last delimiter, or `0` if there is none, then copy
				// the first basic code points to the output.

				basic = input.lastIndexOf(delimiter);
				if (basic < 0) {
					basic = 0;
				}

				for (j = 0; j < basic; ++j) {
					// if it's not a basic code point
					if (input.charCodeAt(j) >= 0x80) {
						error('not-basic');
					}
					output.push(input.charCodeAt(j));
				}

				// Main decoding loop: start just after the last delimiter if any basic code
				// points were copied; start at the beginning otherwise.

				for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {

					// `index` is the index of the next character to be consumed.
					// Decode a generalized variable-length integer into `delta`,
					// which gets added to `i`. The overflow checking is easier
					// if we increase `i` as we go, then subtract off its starting
					// value at the end to obtain `delta`.
					for (oldi = i, w = 1, k = base; /* no condition */; k += base) {

						if (index >= inputLength) {
							error('invalid-input');
						}

						digit = basicToDigit(input.charCodeAt(index++));

						if (digit >= base || digit > floor((maxInt - i) / w)) {
							error('overflow');
						}

						i += digit * w;
						t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);

						if (digit < t) {
							break;
						}

						baseMinusT = base - t;
						if (w > floor(maxInt / baseMinusT)) {
							error('overflow');
						}

						w *= baseMinusT;

					}

					out = output.length + 1;
					bias = adapt(i - oldi, out, oldi == 0);

					// `i` was supposed to wrap around from `out` to `0`,
					// incrementing `n` each time, so we'll fix that now:
					if (floor(i / out) > maxInt - n) {
						error('overflow');
					}

					n += floor(i / out);
					i %= out;

					// Insert `n` at position `i` of the output
					output.splice(i++, 0, n);

				}

				return ucs2encode(output);
			}

			/**
			 * Converts a string of Unicode symbols (e.g. a domain name label) to a
			 * Punycode string of ASCII-only symbols.
			 * @memberOf punycode
			 * @param {String} input The string of Unicode symbols.
			 * @returns {String} The resulting Punycode string of ASCII-only symbols.
			 */
			function encode(input) {
				var n,
				    delta,
				    handledCPCount,
				    basicLength,
				    bias,
				    j,
				    m,
				    q,
				    k,
				    t,
				    currentValue,
				    output = [],
				    /** `inputLength` will hold the number of code points in `input`. */
				    inputLength,
				    /** Cached calculation results */
				    handledCPCountPlusOne,
				    baseMinusT,
				    qMinusT;

				// Convert the input in UCS-2 to Unicode
				input = ucs2decode(input);

				// Cache the length
				inputLength = input.length;

				// Initialize the state
				n = initialN;
				delta = 0;
				bias = initialBias;

				// Handle the basic code points
				for (j = 0; j < inputLength; ++j) {
					currentValue = input[j];
					if (currentValue < 0x80) {
						output.push(stringFromCharCode(currentValue));
					}
				}

				handledCPCount = basicLength = output.length;

				// `handledCPCount` is the number of code points that have been handled;
				// `basicLength` is the number of basic code points.

				// Finish the basic string - if it is not empty - with a delimiter
				if (basicLength) {
					output.push(delimiter);
				}

				// Main encoding loop:
				while (handledCPCount < inputLength) {

					// All non-basic code points < n have been handled already. Find the next
					// larger one:
					for (m = maxInt, j = 0; j < inputLength; ++j) {
						currentValue = input[j];
						if (currentValue >= n && currentValue < m) {
							m = currentValue;
						}
					}

					// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
					// but guard against overflow
					handledCPCountPlusOne = handledCPCount + 1;
					if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
						error('overflow');
					}

					delta += (m - n) * handledCPCountPlusOne;
					n = m;

					for (j = 0; j < inputLength; ++j) {
						currentValue = input[j];

						if (currentValue < n && ++delta > maxInt) {
							error('overflow');
						}

						if (currentValue == n) {
							// Represent delta as a generalized variable-length integer
							for (q = delta, k = base; /* no condition */; k += base) {
								t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
								if (q < t) {
									break;
								}
								qMinusT = q - t;
								baseMinusT = base - t;
								output.push(
									stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
								);
								q = floor(qMinusT / baseMinusT);
							}

							output.push(stringFromCharCode(digitToBasic(q, 0)));
							bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
							delta = 0;
							++handledCPCount;
						}
					}

					++delta;
					++n;

				}
				return output.join('');
			}

			/**
			 * Converts a Punycode string representing a domain name or an email address
			 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
			 * it doesn't matter if you call it on a string that has already been
			 * converted to Unicode.
			 * @memberOf punycode
			 * @param {String} input The Punycoded domain name or email address to
			 * convert to Unicode.
			 * @returns {String} The Unicode representation of the given Punycode
			 * string.
			 */
			function toUnicode(input) {
				return mapDomain(input, function(string) {
					return regexPunycode.test(string)
						? decode(string.slice(4).toLowerCase())
						: string;
				});
			}

			/**
			 * Converts a Unicode string representing a domain name or an email address to
			 * Punycode. Only the non-ASCII parts of the domain name will be converted,
			 * i.e. it doesn't matter if you call it with a domain that's already in
			 * ASCII.
			 * @memberOf punycode
			 * @param {String} input The domain name or email address to convert, as a
			 * Unicode string.
			 * @returns {String} The Punycode representation of the given domain name or
			 * email address.
			 */
			function toASCII(input) {
				return mapDomain(input, function(string) {
					return regexNonASCII.test(string)
						? 'xn--' + encode(string)
						: string;
				});
			}

			/*--------------------------------------------------------------------------*/

			/** Define the public API */
			punycode = {
				/**
				 * A string representing the current Punycode.js version number.
				 * @memberOf punycode
				 * @type String
				 */
				'version': '1.3.2',
				/**
				 * An object of methods to convert from JavaScript's internal character
				 * representation (UCS-2) to Unicode code points, and back.
				 * @see <https://mathiasbynens.be/notes/javascript-encoding>
				 * @memberOf punycode
				 * @type Object
				 */
				'ucs2': {
					'decode': ucs2decode,
					'encode': ucs2encode
				},
				'decode': decode,
				'encode': encode,
				'toASCII': toASCII,
				'toUnicode': toUnicode
			};

			/** Expose `punycode` */
			// Some AMD build optimizers, like r.js, check for specific condition patterns
			// like the following:
			if (freeExports && freeModule) {
				if (module.exports == freeExports) { // in Node.js or RingoJS v0.8.0+
					freeModule.exports = punycode;
				} else { // in Narwhal or RingoJS v0.7.0-
					for (key in punycode) {
						punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
					}
				}
			} else { // in Rhino or a web browser
				root.punycode = punycode;
			}

		}(commonjsGlobal)); 
	} (punycode, punycode.exports));
	return punycode.exports;
}

var querystring = {};

var decode$1;
var hasRequiredDecode;

function requireDecode () {
	if (hasRequiredDecode) return decode$1;
	hasRequiredDecode = 1;

	// If obj.hasOwnProperty has been overridden, then calling
	// obj.hasOwnProperty(prop) will break.
	// See: https://github.com/joyent/node/issues/1707
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}

	decode$1 = function(qs, sep, eq, options) {
	  sep = sep || '&';
	  eq = eq || '=';
	  var obj = {};

	  if (typeof qs !== 'string' || qs.length === 0) {
	    return obj;
	  }

	  var regexp = /\+/g;
	  qs = qs.split(sep);

	  var maxKeys = 1000;
	  if (options && typeof options.maxKeys === 'number') {
	    maxKeys = options.maxKeys;
	  }

	  var len = qs.length;
	  // maxKeys <= 0 means that we should not limit keys count
	  if (maxKeys > 0 && len > maxKeys) {
	    len = maxKeys;
	  }

	  for (var i = 0; i < len; ++i) {
	    var x = qs[i].replace(regexp, '%20'),
	        idx = x.indexOf(eq),
	        kstr, vstr, k, v;

	    if (idx >= 0) {
	      kstr = x.substr(0, idx);
	      vstr = x.substr(idx + 1);
	    } else {
	      kstr = x;
	      vstr = '';
	    }

	    k = decodeURIComponent(kstr);
	    v = decodeURIComponent(vstr);

	    if (!hasOwnProperty(obj, k)) {
	      obj[k] = v;
	    } else if (Array.isArray(obj[k])) {
	      obj[k].push(v);
	    } else {
	      obj[k] = [obj[k], v];
	    }
	  }

	  return obj;
	};
	return decode$1;
}

var encode$1;
var hasRequiredEncode;

function requireEncode () {
	if (hasRequiredEncode) return encode$1;
	hasRequiredEncode = 1;

	var stringifyPrimitive = function(v) {
	  switch (typeof v) {
	    case 'string':
	      return v;

	    case 'boolean':
	      return v ? 'true' : 'false';

	    case 'number':
	      return isFinite(v) ? v : '';

	    default:
	      return '';
	  }
	};

	encode$1 = function(obj, sep, eq, name) {
	  sep = sep || '&';
	  eq = eq || '=';
	  if (obj === null) {
	    obj = undefined;
	  }

	  if (typeof obj === 'object') {
	    return Object.keys(obj).map(function(k) {
	      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
	      if (Array.isArray(obj[k])) {
	        return obj[k].map(function(v) {
	          return ks + encodeURIComponent(stringifyPrimitive(v));
	        }).join(sep);
	      } else {
	        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
	      }
	    }).join(sep);

	  }

	  if (!name) return '';
	  return encodeURIComponent(stringifyPrimitive(name)) + eq +
	         encodeURIComponent(stringifyPrimitive(obj));
	};
	return encode$1;
}

var hasRequiredQuerystring;

function requireQuerystring () {
	if (hasRequiredQuerystring) return querystring;
	hasRequiredQuerystring = 1;

	querystring.decode = querystring.parse = requireDecode();
	querystring.encode = querystring.stringify = requireEncode();
	return querystring;
}

var hasRequiredUrl;

function requireUrl () {
	if (hasRequiredUrl) return url;
	hasRequiredUrl = 1;
	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.

	var punycode = requirePunycode();

	url.parse = urlParse;
	url.resolve = urlResolve;
	url.resolveObject = urlResolveObject;
	url.format = urlFormat;

	url.Url = Url;

	function Url() {
	  this.protocol = null;
	  this.slashes = null;
	  this.auth = null;
	  this.host = null;
	  this.port = null;
	  this.hostname = null;
	  this.hash = null;
	  this.search = null;
	  this.query = null;
	  this.pathname = null;
	  this.path = null;
	  this.href = null;
	}

	// Reference: RFC 3986, RFC 1808, RFC 2396

	// define these here so at least they only have to be
	// compiled once on the first module load.
	var protocolPattern = /^([a-z0-9.+-]+:)/i,
	    portPattern = /:[0-9]*$/,

	    // RFC 2396: characters reserved for delimiting URLs.
	    // We actually just auto-escape these.
	    delims = ['<', '>', '"', '`', ' ', '\r', '\n', '\t'],

	    // RFC 2396: characters not allowed for various reasons.
	    unwise = ['{', '}', '|', '\\', '^', '`'].concat(delims),

	    // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
	    autoEscape = ['\''].concat(unwise),
	    // Characters that are never ever allowed in a hostname.
	    // Note that any invalid chars are also handled, but these
	    // are the ones that are *expected* to be seen, so we fast-path
	    // them.
	    nonHostChars = ['%', '/', '?', ';', '#'].concat(autoEscape),
	    hostEndingChars = ['/', '?', '#'],
	    hostnameMaxLen = 255,
	    hostnamePartPattern = /^[a-z0-9A-Z_-]{0,63}$/,
	    hostnamePartStart = /^([a-z0-9A-Z_-]{0,63})(.*)$/,
	    // protocols that can allow "unsafe" and "unwise" chars.
	    unsafeProtocol = {
	      'javascript': true,
	      'javascript:': true
	    },
	    // protocols that never have a hostname.
	    hostlessProtocol = {
	      'javascript': true,
	      'javascript:': true
	    },
	    // protocols that always contain a // bit.
	    slashedProtocol = {
	      'http': true,
	      'https': true,
	      'ftp': true,
	      'gopher': true,
	      'file': true,
	      'http:': true,
	      'https:': true,
	      'ftp:': true,
	      'gopher:': true,
	      'file:': true
	    },
	    querystring = requireQuerystring();

	function urlParse(url, parseQueryString, slashesDenoteHost) {
	  if (url && isObject(url) && url instanceof Url) return url;

	  var u = new Url;
	  u.parse(url, parseQueryString, slashesDenoteHost);
	  return u;
	}

	Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
	  if (!isString(url)) {
	    throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
	  }

	  var rest = url;

	  // trim before proceeding.
	  // This is to support parse stuff like "  http://foo.com  \n"
	  rest = rest.trim();

	  var proto = protocolPattern.exec(rest);
	  if (proto) {
	    proto = proto[0];
	    var lowerProto = proto.toLowerCase();
	    this.protocol = lowerProto;
	    rest = rest.substr(proto.length);
	  }

	  // figure out if it's got a host
	  // user@server is *always* interpreted as a hostname, and url
	  // resolution will treat //foo/bar as host=foo,path=bar because that's
	  // how the browser resolves relative URLs.
	  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
	    var slashes = rest.substr(0, 2) === '//';
	    if (slashes && !(proto && hostlessProtocol[proto])) {
	      rest = rest.substr(2);
	      this.slashes = true;
	    }
	  }

	  if (!hostlessProtocol[proto] &&
	      (slashes || (proto && !slashedProtocol[proto]))) {

	    // there's a hostname.
	    // the first instance of /, ?, ;, or # ends the host.
	    //
	    // If there is an @ in the hostname, then non-host chars *are* allowed
	    // to the left of the last @ sign, unless some host-ending character
	    // comes *before* the @-sign.
	    // URLs are obnoxious.
	    //
	    // ex:
	    // http://a@b@c/ => user:a@b host:c
	    // http://a@b?@c => user:a host:c path:/?@c

	    // v0.12 TODO(isaacs): This is not quite how Chrome does things.
	    // Review our test case against browsers more comprehensively.

	    // find the first instance of any hostEndingChars
	    var hostEnd = -1;
	    for (var i = 0; i < hostEndingChars.length; i++) {
	      var hec = rest.indexOf(hostEndingChars[i]);
	      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
	        hostEnd = hec;
	    }

	    // at this point, either we have an explicit point where the
	    // auth portion cannot go past, or the last @ char is the decider.
	    var auth, atSign;
	    if (hostEnd === -1) {
	      // atSign can be anywhere.
	      atSign = rest.lastIndexOf('@');
	    } else {
	      // atSign must be in auth portion.
	      // http://a@b/c@d => host:b auth:a path:/c@d
	      atSign = rest.lastIndexOf('@', hostEnd);
	    }

	    // Now we have a portion which is definitely the auth.
	    // Pull that off.
	    if (atSign !== -1) {
	      auth = rest.slice(0, atSign);
	      rest = rest.slice(atSign + 1);
	      this.auth = decodeURIComponent(auth);
	    }

	    // the host is the remaining to the left of the first non-host char
	    hostEnd = -1;
	    for (var i = 0; i < nonHostChars.length; i++) {
	      var hec = rest.indexOf(nonHostChars[i]);
	      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
	        hostEnd = hec;
	    }
	    // if we still have not hit it, then the entire thing is a host.
	    if (hostEnd === -1)
	      hostEnd = rest.length;

	    this.host = rest.slice(0, hostEnd);
	    rest = rest.slice(hostEnd);

	    // pull out port.
	    this.parseHost();

	    // we've indicated that there is a hostname,
	    // so even if it's empty, it has to be present.
	    this.hostname = this.hostname || '';

	    // if hostname begins with [ and ends with ]
	    // assume that it's an IPv6 address.
	    var ipv6Hostname = this.hostname[0] === '[' &&
	        this.hostname[this.hostname.length - 1] === ']';

	    // validate a little.
	    if (!ipv6Hostname) {
	      var hostparts = this.hostname.split(/\./);
	      for (var i = 0, l = hostparts.length; i < l; i++) {
	        var part = hostparts[i];
	        if (!part) continue;
	        if (!part.match(hostnamePartPattern)) {
	          var newpart = '';
	          for (var j = 0, k = part.length; j < k; j++) {
	            if (part.charCodeAt(j) > 127) {
	              // we replace non-ASCII char with a temporary placeholder
	              // we need this to make sure size of hostname is not
	              // broken by replacing non-ASCII by nothing
	              newpart += 'x';
	            } else {
	              newpart += part[j];
	            }
	          }
	          // we test again with ASCII char only
	          if (!newpart.match(hostnamePartPattern)) {
	            var validParts = hostparts.slice(0, i);
	            var notHost = hostparts.slice(i + 1);
	            var bit = part.match(hostnamePartStart);
	            if (bit) {
	              validParts.push(bit[1]);
	              notHost.unshift(bit[2]);
	            }
	            if (notHost.length) {
	              rest = '/' + notHost.join('.') + rest;
	            }
	            this.hostname = validParts.join('.');
	            break;
	          }
	        }
	      }
	    }

	    if (this.hostname.length > hostnameMaxLen) {
	      this.hostname = '';
	    } else {
	      // hostnames are always lower case.
	      this.hostname = this.hostname.toLowerCase();
	    }

	    if (!ipv6Hostname) {
	      // IDNA Support: Returns a puny coded representation of "domain".
	      // It only converts the part of the domain name that
	      // has non ASCII characters. I.e. it dosent matter if
	      // you call it with a domain that already is in ASCII.
	      var domainArray = this.hostname.split('.');
	      var newOut = [];
	      for (var i = 0; i < domainArray.length; ++i) {
	        var s = domainArray[i];
	        newOut.push(s.match(/[^A-Za-z0-9_-]/) ?
	            'xn--' + punycode.encode(s) : s);
	      }
	      this.hostname = newOut.join('.');
	    }

	    var p = this.port ? ':' + this.port : '';
	    var h = this.hostname || '';
	    this.host = h + p;
	    this.href += this.host;

	    // strip [ and ] from the hostname
	    // the host field still retains them, though
	    if (ipv6Hostname) {
	      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
	      if (rest[0] !== '/') {
	        rest = '/' + rest;
	      }
	    }
	  }

	  // now rest is set to the post-host stuff.
	  // chop off any delim chars.
	  if (!unsafeProtocol[lowerProto]) {

	    // First, make 100% sure that any "autoEscape" chars get
	    // escaped, even if encodeURIComponent doesn't think they
	    // need to be.
	    for (var i = 0, l = autoEscape.length; i < l; i++) {
	      var ae = autoEscape[i];
	      var esc = encodeURIComponent(ae);
	      if (esc === ae) {
	        esc = escape(ae);
	      }
	      rest = rest.split(ae).join(esc);
	    }
	  }


	  // chop off from the tail first.
	  var hash = rest.indexOf('#');
	  if (hash !== -1) {
	    // got a fragment string.
	    this.hash = rest.substr(hash);
	    rest = rest.slice(0, hash);
	  }
	  var qm = rest.indexOf('?');
	  if (qm !== -1) {
	    this.search = rest.substr(qm);
	    this.query = rest.substr(qm + 1);
	    if (parseQueryString) {
	      this.query = querystring.parse(this.query);
	    }
	    rest = rest.slice(0, qm);
	  } else if (parseQueryString) {
	    // no query string, but parseQueryString still requested
	    this.search = '';
	    this.query = {};
	  }
	  if (rest) this.pathname = rest;
	  if (slashedProtocol[lowerProto] &&
	      this.hostname && !this.pathname) {
	    this.pathname = '/';
	  }

	  //to support http.request
	  if (this.pathname || this.search) {
	    var p = this.pathname || '';
	    var s = this.search || '';
	    this.path = p + s;
	  }

	  // finally, reconstruct the href based on what has been validated.
	  this.href = this.format();
	  return this;
	};

	// format a parsed object into a url string
	function urlFormat(obj) {
	  // ensure it's an object, and not a string url.
	  // If it's an obj, this is a no-op.
	  // this way, you can call url_format() on strings
	  // to clean up potentially wonky urls.
	  if (isString(obj)) obj = urlParse(obj);
	  if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
	  return obj.format();
	}

	Url.prototype.format = function() {
	  var auth = this.auth || '';
	  if (auth) {
	    auth = encodeURIComponent(auth);
	    auth = auth.replace(/%3A/i, ':');
	    auth += '@';
	  }

	  var protocol = this.protocol || '',
	      pathname = this.pathname || '',
	      hash = this.hash || '',
	      host = false,
	      query = '';

	  if (this.host) {
	    host = auth + this.host;
	  } else if (this.hostname) {
	    host = auth + (this.hostname.indexOf(':') === -1 ?
	        this.hostname :
	        '[' + this.hostname + ']');
	    if (this.port) {
	      host += ':' + this.port;
	    }
	  }

	  if (this.query &&
	      isObject(this.query) &&
	      Object.keys(this.query).length) {
	    query = querystring.stringify(this.query);
	  }

	  var search = this.search || (query && ('?' + query)) || '';

	  if (protocol && protocol.substr(-1) !== ':') protocol += ':';

	  // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
	  // unless they had them to begin with.
	  if (this.slashes ||
	      (!protocol || slashedProtocol[protocol]) && host !== false) {
	    host = '//' + (host || '');
	    if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
	  } else if (!host) {
	    host = '';
	  }

	  if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
	  if (search && search.charAt(0) !== '?') search = '?' + search;

	  pathname = pathname.replace(/[?#]/g, function(match) {
	    return encodeURIComponent(match);
	  });
	  search = search.replace('#', '%23');

	  return protocol + host + pathname + search + hash;
	};

	function urlResolve(source, relative) {
	  return urlParse(source, false, true).resolve(relative);
	}

	Url.prototype.resolve = function(relative) {
	  return this.resolveObject(urlParse(relative, false, true)).format();
	};

	function urlResolveObject(source, relative) {
	  if (!source) return relative;
	  return urlParse(source, false, true).resolveObject(relative);
	}

	Url.prototype.resolveObject = function(relative) {
	  if (isString(relative)) {
	    var rel = new Url();
	    rel.parse(relative, false, true);
	    relative = rel;
	  }

	  var result = new Url();
	  Object.keys(this).forEach(function(k) {
	    result[k] = this[k];
	  }, this);

	  // hash is always overridden, no matter what.
	  // even href="" will remove it.
	  result.hash = relative.hash;

	  // if the relative url is empty, then there's nothing left to do here.
	  if (relative.href === '') {
	    result.href = result.format();
	    return result;
	  }

	  // hrefs like //foo/bar always cut to the protocol.
	  if (relative.slashes && !relative.protocol) {
	    // take everything except the protocol from relative
	    Object.keys(relative).forEach(function(k) {
	      if (k !== 'protocol')
	        result[k] = relative[k];
	    });

	    //urlParse appends trailing / to urls like http://www.example.com
	    if (slashedProtocol[result.protocol] &&
	        result.hostname && !result.pathname) {
	      result.path = result.pathname = '/';
	    }

	    result.href = result.format();
	    return result;
	  }

	  if (relative.protocol && relative.protocol !== result.protocol) {
	    // if it's a known url protocol, then changing
	    // the protocol does weird things
	    // first, if it's not file:, then we MUST have a host,
	    // and if there was a path
	    // to begin with, then we MUST have a path.
	    // if it is file:, then the host is dropped,
	    // because that's known to be hostless.
	    // anything else is assumed to be absolute.
	    if (!slashedProtocol[relative.protocol]) {
	      Object.keys(relative).forEach(function(k) {
	        result[k] = relative[k];
	      });
	      result.href = result.format();
	      return result;
	    }

	    result.protocol = relative.protocol;
	    if (!relative.host && !hostlessProtocol[relative.protocol]) {
	      var relPath = (relative.pathname || '').split('/');
	      while (relPath.length && !(relative.host = relPath.shift()));
	      if (!relative.host) relative.host = '';
	      if (!relative.hostname) relative.hostname = '';
	      if (relPath[0] !== '') relPath.unshift('');
	      if (relPath.length < 2) relPath.unshift('');
	      result.pathname = relPath.join('/');
	    } else {
	      result.pathname = relative.pathname;
	    }
	    result.search = relative.search;
	    result.query = relative.query;
	    result.host = relative.host || '';
	    result.auth = relative.auth;
	    result.hostname = relative.hostname || relative.host;
	    result.port = relative.port;
	    // to support http.request
	    if (result.pathname || result.search) {
	      var p = result.pathname || '';
	      var s = result.search || '';
	      result.path = p + s;
	    }
	    result.slashes = result.slashes || relative.slashes;
	    result.href = result.format();
	    return result;
	  }

	  var isSourceAbs = (result.pathname && result.pathname.charAt(0) === '/'),
	      isRelAbs = (
	          relative.host ||
	          relative.pathname && relative.pathname.charAt(0) === '/'
	      ),
	      mustEndAbs = (isRelAbs || isSourceAbs ||
	                    (result.host && relative.pathname)),
	      removeAllDots = mustEndAbs,
	      srcPath = result.pathname && result.pathname.split('/') || [],
	      relPath = relative.pathname && relative.pathname.split('/') || [],
	      psychotic = result.protocol && !slashedProtocol[result.protocol];

	  // if the url is a non-slashed url, then relative
	  // links like ../.. should be able
	  // to crawl up to the hostname, as well.  This is strange.
	  // result.protocol has already been set by now.
	  // Later on, put the first path part into the host field.
	  if (psychotic) {
	    result.hostname = '';
	    result.port = null;
	    if (result.host) {
	      if (srcPath[0] === '') srcPath[0] = result.host;
	      else srcPath.unshift(result.host);
	    }
	    result.host = '';
	    if (relative.protocol) {
	      relative.hostname = null;
	      relative.port = null;
	      if (relative.host) {
	        if (relPath[0] === '') relPath[0] = relative.host;
	        else relPath.unshift(relative.host);
	      }
	      relative.host = null;
	    }
	    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
	  }

	  if (isRelAbs) {
	    // it's absolute.
	    result.host = (relative.host || relative.host === '') ?
	                  relative.host : result.host;
	    result.hostname = (relative.hostname || relative.hostname === '') ?
	                      relative.hostname : result.hostname;
	    result.search = relative.search;
	    result.query = relative.query;
	    srcPath = relPath;
	    // fall through to the dot-handling below.
	  } else if (relPath.length) {
	    // it's relative
	    // throw away the existing file, and take the new path instead.
	    if (!srcPath) srcPath = [];
	    srcPath.pop();
	    srcPath = srcPath.concat(relPath);
	    result.search = relative.search;
	    result.query = relative.query;
	  } else if (!isNullOrUndefined(relative.search)) {
	    // just pull out the search.
	    // like href='?foo'.
	    // Put this after the other two cases because it simplifies the booleans
	    if (psychotic) {
	      result.hostname = result.host = srcPath.shift();
	      //occationaly the auth can get stuck only in host
	      //this especialy happens in cases like
	      //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
	      var authInHost = result.host && result.host.indexOf('@') > 0 ?
	                       result.host.split('@') : false;
	      if (authInHost) {
	        result.auth = authInHost.shift();
	        result.host = result.hostname = authInHost.shift();
	      }
	    }
	    result.search = relative.search;
	    result.query = relative.query;
	    //to support http.request
	    if (!isNull(result.pathname) || !isNull(result.search)) {
	      result.path = (result.pathname ? result.pathname : '') +
	                    (result.search ? result.search : '');
	    }
	    result.href = result.format();
	    return result;
	  }

	  if (!srcPath.length) {
	    // no path at all.  easy.
	    // we've already handled the other stuff above.
	    result.pathname = null;
	    //to support http.request
	    if (result.search) {
	      result.path = '/' + result.search;
	    } else {
	      result.path = null;
	    }
	    result.href = result.format();
	    return result;
	  }

	  // if a url ENDs in . or .., then it must get a trailing slash.
	  // however, if it ends in anything else non-slashy,
	  // then it must NOT get a trailing slash.
	  var last = srcPath.slice(-1)[0];
	  var hasTrailingSlash = (
	      (result.host || relative.host) && (last === '.' || last === '..') ||
	      last === '');

	  // strip single dots, resolve double dots to parent dir
	  // if the path tries to go above the root, `up` ends up > 0
	  var up = 0;
	  for (var i = srcPath.length; i >= 0; i--) {
	    last = srcPath[i];
	    if (last == '.') {
	      srcPath.splice(i, 1);
	    } else if (last === '..') {
	      srcPath.splice(i, 1);
	      up++;
	    } else if (up) {
	      srcPath.splice(i, 1);
	      up--;
	    }
	  }

	  // if the path is allowed to go above the root, restore leading ..s
	  if (!mustEndAbs && !removeAllDots) {
	    for (; up--; up) {
	      srcPath.unshift('..');
	    }
	  }

	  if (mustEndAbs && srcPath[0] !== '' &&
	      (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
	    srcPath.unshift('');
	  }

	  if (hasTrailingSlash && (srcPath.join('/').substr(-1) !== '/')) {
	    srcPath.push('');
	  }

	  var isAbsolute = srcPath[0] === '' ||
	      (srcPath[0] && srcPath[0].charAt(0) === '/');

	  // put the host back
	  if (psychotic) {
	    result.hostname = result.host = isAbsolute ? '' :
	                                    srcPath.length ? srcPath.shift() : '';
	    //occationaly the auth can get stuck only in host
	    //this especialy happens in cases like
	    //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
	    var authInHost = result.host && result.host.indexOf('@') > 0 ?
	                     result.host.split('@') : false;
	    if (authInHost) {
	      result.auth = authInHost.shift();
	      result.host = result.hostname = authInHost.shift();
	    }
	  }

	  mustEndAbs = mustEndAbs || (result.host && srcPath.length);

	  if (mustEndAbs && !isAbsolute) {
	    srcPath.unshift('');
	  }

	  if (!srcPath.length) {
	    result.pathname = null;
	    result.path = null;
	  } else {
	    result.pathname = srcPath.join('/');
	  }

	  //to support request.http
	  if (!isNull(result.pathname) || !isNull(result.search)) {
	    result.path = (result.pathname ? result.pathname : '') +
	                  (result.search ? result.search : '');
	  }
	  result.auth = relative.auth || result.auth;
	  result.slashes = result.slashes || relative.slashes;
	  result.href = result.format();
	  return result;
	};

	Url.prototype.parseHost = function() {
	  var host = this.host;
	  var port = portPattern.exec(host);
	  if (port) {
	    port = port[0];
	    if (port !== ':') {
	      this.port = port.substr(1);
	    }
	    host = host.substr(0, host.length - port.length);
	  }
	  if (host) this.hostname = host;
	};

	function isString(arg) {
	  return typeof arg === "string";
	}

	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}

	function isNull(arg) {
	  return arg === null;
	}
	function isNullOrUndefined(arg) {
	  return  arg == null;
	}
	return url;
}

var assert = {exports: {}};

var util$1 = {};

var isBuffer$2;
var hasRequiredIsBuffer;

function requireIsBuffer () {
	if (hasRequiredIsBuffer) return isBuffer$2;
	hasRequiredIsBuffer = 1;
	isBuffer$2 = function isBuffer(arg) {
	  return arg instanceof Buffer;
	};
	return isBuffer$2;
}

var util = {};

var isBuffer$1 = function isBuffer(arg) {
  return arg instanceof Buffer;
};

var inherits$1 = {exports: {}};

var inherits_browser = {exports: {}};

var hasRequiredInherits_browser;

function requireInherits_browser () {
	if (hasRequiredInherits_browser) return inherits_browser.exports;
	hasRequiredInherits_browser = 1;
	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  inherits_browser.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor;
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  };
	} else {
	  // old school shim for old browsers
	  inherits_browser.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor;
	    var TempCtor = function () {};
	    TempCtor.prototype = superCtor.prototype;
	    ctor.prototype = new TempCtor();
	    ctor.prototype.constructor = ctor;
	  };
	}
	return inherits_browser.exports;
}

var hasRequiredInherits$1;

function requireInherits$1 () {
	if (hasRequiredInherits$1) return inherits$1.exports;
	hasRequiredInherits$1 = 1;
	try {
	  var util = requireUtil$1();
	  if (typeof util.inherits !== 'function') throw '';
	  inherits$1.exports = util.inherits;
	} catch (e) {
	  inherits$1.exports = requireInherits_browser();
	}
	return inherits$1.exports;
}

var hasRequiredUtil$1;

function requireUtil$1 () {
	if (hasRequiredUtil$1) return util;
	hasRequiredUtil$1 = 1;
	(function (exports) {
		// Copyright Joyent, Inc. and other Node contributors.
		//
		// Permission is hereby granted, free of charge, to any person obtaining a
		// copy of this software and associated documentation files (the
		// "Software"), to deal in the Software without restriction, including
		// without limitation the rights to use, copy, modify, merge, publish,
		// distribute, sublicense, and/or sell copies of the Software, and to permit
		// persons to whom the Software is furnished to do so, subject to the
		// following conditions:
		//
		// The above copyright notice and this permission notice shall be included
		// in all copies or substantial portions of the Software.
		//
		// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
		// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
		// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
		// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
		// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
		// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
		// USE OR OTHER DEALINGS IN THE SOFTWARE.

		var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors ||
		  function getOwnPropertyDescriptors(obj) {
		    var keys = Object.keys(obj);
		    var descriptors = {};
		    for (var i = 0; i < keys.length; i++) {
		      descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
		    }
		    return descriptors;
		  };

		var formatRegExp = /%[sdj%]/g;
		exports.format = function(f) {
		  if (!isString(f)) {
		    var objects = [];
		    for (var i = 0; i < arguments.length; i++) {
		      objects.push(inspect(arguments[i]));
		    }
		    return objects.join(' ');
		  }

		  var i = 1;
		  var args = arguments;
		  var len = args.length;
		  var str = String(f).replace(formatRegExp, function(x) {
		    if (x === '%%') return '%';
		    if (i >= len) return x;
		    switch (x) {
		      case '%s': return String(args[i++]);
		      case '%d': return Number(args[i++]);
		      case '%j':
		        try {
		          return JSON.stringify(args[i++]);
		        } catch (_) {
		          return '[Circular]';
		        }
		      default:
		        return x;
		    }
		  });
		  for (var x = args[i]; i < len; x = args[++i]) {
		    if (isNull(x) || !isObject(x)) {
		      str += ' ' + x;
		    } else {
		      str += ' ' + inspect(x);
		    }
		  }
		  return str;
		};


		// Mark that a method should not be used.
		// Returns a modified function which warns once by default.
		// If --no-deprecation is set, then it is a no-op.
		exports.deprecate = function(fn, msg) {
		  if (typeof process !== 'undefined' && process.noDeprecation === true) {
		    return fn;
		  }

		  // Allow for deprecating things in the process of starting up.
		  if (typeof process === 'undefined') {
		    return function() {
		      return exports.deprecate(fn, msg).apply(this, arguments);
		    };
		  }

		  var warned = false;
		  function deprecated() {
		    if (!warned) {
		      if (process.throwDeprecation) {
		        throw new Error(msg);
		      } else if (process.traceDeprecation) {
		        console.trace(msg);
		      } else {
		        console.error(msg);
		      }
		      warned = true;
		    }
		    return fn.apply(this, arguments);
		  }

		  return deprecated;
		};


		var debugs = {};
		var debugEnviron;
		exports.debuglog = function(set) {
		  if (isUndefined(debugEnviron))
		    debugEnviron = process.env.NODE_DEBUG || '';
		  set = set.toUpperCase();
		  if (!debugs[set]) {
		    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
		      var pid = process.pid;
		      debugs[set] = function() {
		        var msg = exports.format.apply(exports, arguments);
		        console.error('%s %d: %s', set, pid, msg);
		      };
		    } else {
		      debugs[set] = function() {};
		    }
		  }
		  return debugs[set];
		};


		/**
		 * Echos the value of a value. Trys to print the value out
		 * in the best way possible given the different types.
		 *
		 * @param {Object} obj The object to print out.
		 * @param {Object} opts Optional options object that alters the output.
		 */
		/* legacy: obj, showHidden, depth, colors*/
		function inspect(obj, opts) {
		  // default options
		  var ctx = {
		    seen: [],
		    stylize: stylizeNoColor
		  };
		  // legacy...
		  if (arguments.length >= 3) ctx.depth = arguments[2];
		  if (arguments.length >= 4) ctx.colors = arguments[3];
		  if (isBoolean(opts)) {
		    // legacy...
		    ctx.showHidden = opts;
		  } else if (opts) {
		    // got an "options" object
		    exports._extend(ctx, opts);
		  }
		  // set default options
		  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
		  if (isUndefined(ctx.depth)) ctx.depth = 2;
		  if (isUndefined(ctx.colors)) ctx.colors = false;
		  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
		  if (ctx.colors) ctx.stylize = stylizeWithColor;
		  return formatValue(ctx, obj, ctx.depth);
		}
		exports.inspect = inspect;


		// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
		inspect.colors = {
		  'bold' : [1, 22],
		  'italic' : [3, 23],
		  'underline' : [4, 24],
		  'inverse' : [7, 27],
		  'white' : [37, 39],
		  'grey' : [90, 39],
		  'black' : [30, 39],
		  'blue' : [34, 39],
		  'cyan' : [36, 39],
		  'green' : [32, 39],
		  'magenta' : [35, 39],
		  'red' : [31, 39],
		  'yellow' : [33, 39]
		};

		// Don't use 'blue' not visible on cmd.exe
		inspect.styles = {
		  'special': 'cyan',
		  'number': 'yellow',
		  'boolean': 'yellow',
		  'undefined': 'grey',
		  'null': 'bold',
		  'string': 'green',
		  'date': 'magenta',
		  // "name": intentionally not styling
		  'regexp': 'red'
		};


		function stylizeWithColor(str, styleType) {
		  var style = inspect.styles[styleType];

		  if (style) {
		    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
		           '\u001b[' + inspect.colors[style][1] + 'm';
		  } else {
		    return str;
		  }
		}


		function stylizeNoColor(str, styleType) {
		  return str;
		}


		function arrayToHash(array) {
		  var hash = {};

		  array.forEach(function(val, idx) {
		    hash[val] = true;
		  });

		  return hash;
		}


		function formatValue(ctx, value, recurseTimes) {
		  // Provide a hook for user-specified inspect functions.
		  // Check that value is an object with an inspect function on it
		  if (ctx.customInspect &&
		      value &&
		      isFunction(value.inspect) &&
		      // Filter out the util module, it's inspect function is special
		      value.inspect !== exports.inspect &&
		      // Also filter out any prototype objects using the circular check.
		      !(value.constructor && value.constructor.prototype === value)) {
		    var ret = value.inspect(recurseTimes, ctx);
		    if (!isString(ret)) {
		      ret = formatValue(ctx, ret, recurseTimes);
		    }
		    return ret;
		  }

		  // Primitive types cannot have properties
		  var primitive = formatPrimitive(ctx, value);
		  if (primitive) {
		    return primitive;
		  }

		  // Look up the keys of the object.
		  var keys = Object.keys(value);
		  var visibleKeys = arrayToHash(keys);

		  if (ctx.showHidden) {
		    keys = Object.getOwnPropertyNames(value);
		  }

		  // IE doesn't make error fields non-enumerable
		  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
		  if (isError(value)
		      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
		    return formatError(value);
		  }

		  // Some type of object without properties can be shortcutted.
		  if (keys.length === 0) {
		    if (isFunction(value)) {
		      var name = value.name ? ': ' + value.name : '';
		      return ctx.stylize('[Function' + name + ']', 'special');
		    }
		    if (isRegExp(value)) {
		      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
		    }
		    if (isDate(value)) {
		      return ctx.stylize(Date.prototype.toString.call(value), 'date');
		    }
		    if (isError(value)) {
		      return formatError(value);
		    }
		  }

		  var base = '', array = false, braces = ['{', '}'];

		  // Make Array say that they are Array
		  if (isArray(value)) {
		    array = true;
		    braces = ['[', ']'];
		  }

		  // Make functions say that they are functions
		  if (isFunction(value)) {
		    var n = value.name ? ': ' + value.name : '';
		    base = ' [Function' + n + ']';
		  }

		  // Make RegExps say that they are RegExps
		  if (isRegExp(value)) {
		    base = ' ' + RegExp.prototype.toString.call(value);
		  }

		  // Make dates with properties first say the date
		  if (isDate(value)) {
		    base = ' ' + Date.prototype.toUTCString.call(value);
		  }

		  // Make error with message first say the error
		  if (isError(value)) {
		    base = ' ' + formatError(value);
		  }

		  if (keys.length === 0 && (!array || value.length == 0)) {
		    return braces[0] + base + braces[1];
		  }

		  if (recurseTimes < 0) {
		    if (isRegExp(value)) {
		      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
		    } else {
		      return ctx.stylize('[Object]', 'special');
		    }
		  }

		  ctx.seen.push(value);

		  var output;
		  if (array) {
		    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
		  } else {
		    output = keys.map(function(key) {
		      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
		    });
		  }

		  ctx.seen.pop();

		  return reduceToSingleString(output, base, braces);
		}


		function formatPrimitive(ctx, value) {
		  if (isUndefined(value))
		    return ctx.stylize('undefined', 'undefined');
		  if (isString(value)) {
		    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
		                                             .replace(/'/g, "\\'")
		                                             .replace(/\\"/g, '"') + '\'';
		    return ctx.stylize(simple, 'string');
		  }
		  if (isNumber(value))
		    return ctx.stylize('' + value, 'number');
		  if (isBoolean(value))
		    return ctx.stylize('' + value, 'boolean');
		  // For some reason typeof null is "object", so special case here.
		  if (isNull(value))
		    return ctx.stylize('null', 'null');
		}


		function formatError(value) {
		  return '[' + Error.prototype.toString.call(value) + ']';
		}


		function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
		  var output = [];
		  for (var i = 0, l = value.length; i < l; ++i) {
		    if (hasOwnProperty(value, String(i))) {
		      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
		          String(i), true));
		    } else {
		      output.push('');
		    }
		  }
		  keys.forEach(function(key) {
		    if (!key.match(/^\d+$/)) {
		      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
		          key, true));
		    }
		  });
		  return output;
		}


		function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
		  var name, str, desc;
		  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
		  if (desc.get) {
		    if (desc.set) {
		      str = ctx.stylize('[Getter/Setter]', 'special');
		    } else {
		      str = ctx.stylize('[Getter]', 'special');
		    }
		  } else {
		    if (desc.set) {
		      str = ctx.stylize('[Setter]', 'special');
		    }
		  }
		  if (!hasOwnProperty(visibleKeys, key)) {
		    name = '[' + key + ']';
		  }
		  if (!str) {
		    if (ctx.seen.indexOf(desc.value) < 0) {
		      if (isNull(recurseTimes)) {
		        str = formatValue(ctx, desc.value, null);
		      } else {
		        str = formatValue(ctx, desc.value, recurseTimes - 1);
		      }
		      if (str.indexOf('\n') > -1) {
		        if (array) {
		          str = str.split('\n').map(function(line) {
		            return '  ' + line;
		          }).join('\n').substr(2);
		        } else {
		          str = '\n' + str.split('\n').map(function(line) {
		            return '   ' + line;
		          }).join('\n');
		        }
		      }
		    } else {
		      str = ctx.stylize('[Circular]', 'special');
		    }
		  }
		  if (isUndefined(name)) {
		    if (array && key.match(/^\d+$/)) {
		      return str;
		    }
		    name = JSON.stringify('' + key);
		    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
		      name = name.substr(1, name.length - 2);
		      name = ctx.stylize(name, 'name');
		    } else {
		      name = name.replace(/'/g, "\\'")
		                 .replace(/\\"/g, '"')
		                 .replace(/(^"|"$)/g, "'");
		      name = ctx.stylize(name, 'string');
		    }
		  }

		  return name + ': ' + str;
		}


		function reduceToSingleString(output, base, braces) {
		  var length = output.reduce(function(prev, cur) {
		    if (cur.indexOf('\n') >= 0) ;
		    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
		  }, 0);

		  if (length > 60) {
		    return braces[0] +
		           (base === '' ? '' : base + '\n ') +
		           ' ' +
		           output.join(',\n  ') +
		           ' ' +
		           braces[1];
		  }

		  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
		}


		// NOTE: These type checking functions intentionally don't use `instanceof`
		// because it is fragile and can be easily faked with `Object.create()`.
		function isArray(ar) {
		  return Array.isArray(ar);
		}
		exports.isArray = isArray;

		function isBoolean(arg) {
		  return typeof arg === 'boolean';
		}
		exports.isBoolean = isBoolean;

		function isNull(arg) {
		  return arg === null;
		}
		exports.isNull = isNull;

		function isNullOrUndefined(arg) {
		  return arg == null;
		}
		exports.isNullOrUndefined = isNullOrUndefined;

		function isNumber(arg) {
		  return typeof arg === 'number';
		}
		exports.isNumber = isNumber;

		function isString(arg) {
		  return typeof arg === 'string';
		}
		exports.isString = isString;

		function isSymbol(arg) {
		  return typeof arg === 'symbol';
		}
		exports.isSymbol = isSymbol;

		function isUndefined(arg) {
		  return arg === void 0;
		}
		exports.isUndefined = isUndefined;

		function isRegExp(re) {
		  return isObject(re) && objectToString(re) === '[object RegExp]';
		}
		exports.isRegExp = isRegExp;

		function isObject(arg) {
		  return typeof arg === 'object' && arg !== null;
		}
		exports.isObject = isObject;

		function isDate(d) {
		  return isObject(d) && objectToString(d) === '[object Date]';
		}
		exports.isDate = isDate;

		function isError(e) {
		  return isObject(e) &&
		      (objectToString(e) === '[object Error]' || e instanceof Error);
		}
		exports.isError = isError;

		function isFunction(arg) {
		  return typeof arg === 'function';
		}
		exports.isFunction = isFunction;

		function isPrimitive(arg) {
		  return arg === null ||
		         typeof arg === 'boolean' ||
		         typeof arg === 'number' ||
		         typeof arg === 'string' ||
		         typeof arg === 'symbol' ||  // ES6 symbol
		         typeof arg === 'undefined';
		}
		exports.isPrimitive = isPrimitive;

		exports.isBuffer = isBuffer$1;

		function objectToString(o) {
		  return Object.prototype.toString.call(o);
		}


		function pad(n) {
		  return n < 10 ? '0' + n.toString(10) : n.toString(10);
		}


		var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
		              'Oct', 'Nov', 'Dec'];

		// 26 Feb 16:19:34
		function timestamp() {
		  var d = new Date();
		  var time = [pad(d.getHours()),
		              pad(d.getMinutes()),
		              pad(d.getSeconds())].join(':');
		  return [d.getDate(), months[d.getMonth()], time].join(' ');
		}


		// log is just a thin wrapper to console.log that prepends a timestamp
		exports.log = function() {
		  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
		};


		/**
		 * Inherit the prototype methods from one constructor into another.
		 *
		 * The Function.prototype.inherits from lang.js rewritten as a standalone
		 * function (not on Function.prototype). NOTE: If this file is to be loaded
		 * during bootstrapping this function needs to be rewritten using some native
		 * functions as prototype setup using normal JavaScript does not work as
		 * expected during bootstrapping (see mirror.js in r114903).
		 *
		 * @param {function} ctor Constructor function which needs to inherit the
		 *     prototype.
		 * @param {function} superCtor Constructor function to inherit prototype from.
		 */
		exports.inherits = requireInherits$1();

		exports._extend = function(origin, add) {
		  // Don't do anything if add isn't an object
		  if (!add || !isObject(add)) return origin;

		  var keys = Object.keys(add);
		  var i = keys.length;
		  while (i--) {
		    origin[keys[i]] = add[keys[i]];
		  }
		  return origin;
		};

		function hasOwnProperty(obj, prop) {
		  return Object.prototype.hasOwnProperty.call(obj, prop);
		}

		var kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;

		exports.promisify = function promisify(original) {
		  if (typeof original !== 'function')
		    throw new TypeError('The "original" argument must be of type Function');

		  if (kCustomPromisifiedSymbol && original[kCustomPromisifiedSymbol]) {
		    var fn = original[kCustomPromisifiedSymbol];
		    if (typeof fn !== 'function') {
		      throw new TypeError('The "util.promisify.custom" argument must be of type Function');
		    }
		    Object.defineProperty(fn, kCustomPromisifiedSymbol, {
		      value: fn, enumerable: false, writable: false, configurable: true
		    });
		    return fn;
		  }

		  function fn() {
		    var promiseResolve, promiseReject;
		    var promise = new Promise(function (resolve, reject) {
		      promiseResolve = resolve;
		      promiseReject = reject;
		    });

		    var args = [];
		    for (var i = 0; i < arguments.length; i++) {
		      args.push(arguments[i]);
		    }
		    args.push(function (err, value) {
		      if (err) {
		        promiseReject(err);
		      } else {
		        promiseResolve(value);
		      }
		    });

		    try {
		      original.apply(this, args);
		    } catch (err) {
		      promiseReject(err);
		    }

		    return promise;
		  }

		  Object.setPrototypeOf(fn, Object.getPrototypeOf(original));

		  if (kCustomPromisifiedSymbol) Object.defineProperty(fn, kCustomPromisifiedSymbol, {
		    value: fn, enumerable: false, writable: false, configurable: true
		  });
		  return Object.defineProperties(
		    fn,
		    getOwnPropertyDescriptors(original)
		  );
		};

		exports.promisify.custom = kCustomPromisifiedSymbol;

		function callbackifyOnRejected(reason, cb) {
		  // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
		  // Because `null` is a special error value in callbacks which means "no error
		  // occurred", we error-wrap so the callback consumer can distinguish between
		  // "the promise rejected with null" or "the promise fulfilled with undefined".
		  if (!reason) {
		    var newReason = new Error('Promise was rejected with a falsy value');
		    newReason.reason = reason;
		    reason = newReason;
		  }
		  return cb(reason);
		}

		function callbackify(original) {
		  if (typeof original !== 'function') {
		    throw new TypeError('The "original" argument must be of type Function');
		  }

		  // We DO NOT return the promise as it gives the user a false sense that
		  // the promise is actually somehow related to the callback's execution
		  // and that the callback throwing will reject the promise.
		  function callbackified() {
		    var args = [];
		    for (var i = 0; i < arguments.length; i++) {
		      args.push(arguments[i]);
		    }

		    var maybeCb = args.pop();
		    if (typeof maybeCb !== 'function') {
		      throw new TypeError('The last argument must be of type Function');
		    }
		    var self = this;
		    var cb = function() {
		      return maybeCb.apply(self, arguments);
		    };
		    // In true node style we process the callback on `nextTick` with all the
		    // implications (stack, `uncaughtException`, `async_hooks`)
		    original.apply(this, args)
		      .then(function(ret) { process.nextTick(cb, null, ret); },
		            function(rej) { process.nextTick(callbackifyOnRejected, rej, cb); });
		  }

		  Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
		  Object.defineProperties(callbackified,
		                          getOwnPropertyDescriptors(original));
		  return callbackified;
		}
		exports.callbackify = callbackify; 
	} (util));
	return util;
}

var inherits;
var hasRequiredInherits;

function requireInherits () {
	if (hasRequiredInherits) return inherits;
	hasRequiredInherits = 1;
	inherits = requireUtil$1().inherits;
	return inherits;
}

var hasRequiredUtil;

function requireUtil () {
	if (hasRequiredUtil) return util$1;
	hasRequiredUtil = 1;
	(function (exports) {
		// Copyright Joyent, Inc. and other Node contributors.
		//
		// Permission is hereby granted, free of charge, to any person obtaining a
		// copy of this software and associated documentation files (the
		// "Software"), to deal in the Software without restriction, including
		// without limitation the rights to use, copy, modify, merge, publish,
		// distribute, sublicense, and/or sell copies of the Software, and to permit
		// persons to whom the Software is furnished to do so, subject to the
		// following conditions:
		//
		// The above copyright notice and this permission notice shall be included
		// in all copies or substantial portions of the Software.
		//
		// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
		// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
		// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
		// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
		// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
		// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
		// USE OR OTHER DEALINGS IN THE SOFTWARE.

		var formatRegExp = /%[sdj%]/g;
		exports.format = function(f) {
		  if (!isString(f)) {
		    var objects = [];
		    for (var i = 0; i < arguments.length; i++) {
		      objects.push(inspect(arguments[i]));
		    }
		    return objects.join(' ');
		  }

		  var i = 1;
		  var args = arguments;
		  var len = args.length;
		  var str = String(f).replace(formatRegExp, function(x) {
		    if (x === '%%') return '%';
		    if (i >= len) return x;
		    switch (x) {
		      case '%s': return String(args[i++]);
		      case '%d': return Number(args[i++]);
		      case '%j':
		        try {
		          return JSON.stringify(args[i++]);
		        } catch (_) {
		          return '[Circular]';
		        }
		      default:
		        return x;
		    }
		  });
		  for (var x = args[i]; i < len; x = args[++i]) {
		    if (isNull(x) || !isObject(x)) {
		      str += ' ' + x;
		    } else {
		      str += ' ' + inspect(x);
		    }
		  }
		  return str;
		};


		// Mark that a method should not be used.
		// Returns a modified function which warns once by default.
		// If --no-deprecation is set, then it is a no-op.
		exports.deprecate = function(fn, msg) {
		  // Allow for deprecating things in the process of starting up.
		  if (isUndefined(commonjsGlobal.process)) {
		    return function() {
		      return exports.deprecate(fn, msg).apply(this, arguments);
		    };
		  }

		  if (process.noDeprecation === true) {
		    return fn;
		  }

		  var warned = false;
		  function deprecated() {
		    if (!warned) {
		      if (process.throwDeprecation) {
		        throw new Error(msg);
		      } else if (process.traceDeprecation) {
		        console.trace(msg);
		      } else {
		        console.error(msg);
		      }
		      warned = true;
		    }
		    return fn.apply(this, arguments);
		  }

		  return deprecated;
		};


		var debugs = {};
		var debugEnviron;
		exports.debuglog = function(set) {
		  if (isUndefined(debugEnviron))
		    debugEnviron = process.env.NODE_DEBUG || '';
		  set = set.toUpperCase();
		  if (!debugs[set]) {
		    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
		      var pid = process.pid;
		      debugs[set] = function() {
		        var msg = exports.format.apply(exports, arguments);
		        console.error('%s %d: %s', set, pid, msg);
		      };
		    } else {
		      debugs[set] = function() {};
		    }
		  }
		  return debugs[set];
		};


		/**
		 * Echos the value of a value. Trys to print the value out
		 * in the best way possible given the different types.
		 *
		 * @param {Object} obj The object to print out.
		 * @param {Object} opts Optional options object that alters the output.
		 */
		/* legacy: obj, showHidden, depth, colors*/
		function inspect(obj, opts) {
		  // default options
		  var ctx = {
		    seen: [],
		    stylize: stylizeNoColor
		  };
		  // legacy...
		  if (arguments.length >= 3) ctx.depth = arguments[2];
		  if (arguments.length >= 4) ctx.colors = arguments[3];
		  if (isBoolean(opts)) {
		    // legacy...
		    ctx.showHidden = opts;
		  } else if (opts) {
		    // got an "options" object
		    exports._extend(ctx, opts);
		  }
		  // set default options
		  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
		  if (isUndefined(ctx.depth)) ctx.depth = 2;
		  if (isUndefined(ctx.colors)) ctx.colors = false;
		  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
		  if (ctx.colors) ctx.stylize = stylizeWithColor;
		  return formatValue(ctx, obj, ctx.depth);
		}
		exports.inspect = inspect;


		// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
		inspect.colors = {
		  'bold' : [1, 22],
		  'italic' : [3, 23],
		  'underline' : [4, 24],
		  'inverse' : [7, 27],
		  'white' : [37, 39],
		  'grey' : [90, 39],
		  'black' : [30, 39],
		  'blue' : [34, 39],
		  'cyan' : [36, 39],
		  'green' : [32, 39],
		  'magenta' : [35, 39],
		  'red' : [31, 39],
		  'yellow' : [33, 39]
		};

		// Don't use 'blue' not visible on cmd.exe
		inspect.styles = {
		  'special': 'cyan',
		  'number': 'yellow',
		  'boolean': 'yellow',
		  'undefined': 'grey',
		  'null': 'bold',
		  'string': 'green',
		  'date': 'magenta',
		  // "name": intentionally not styling
		  'regexp': 'red'
		};


		function stylizeWithColor(str, styleType) {
		  var style = inspect.styles[styleType];

		  if (style) {
		    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
		           '\u001b[' + inspect.colors[style][1] + 'm';
		  } else {
		    return str;
		  }
		}


		function stylizeNoColor(str, styleType) {
		  return str;
		}


		function arrayToHash(array) {
		  var hash = {};

		  array.forEach(function(val, idx) {
		    hash[val] = true;
		  });

		  return hash;
		}


		function formatValue(ctx, value, recurseTimes) {
		  // Provide a hook for user-specified inspect functions.
		  // Check that value is an object with an inspect function on it
		  if (ctx.customInspect &&
		      value &&
		      isFunction(value.inspect) &&
		      // Filter out the util module, it's inspect function is special
		      value.inspect !== exports.inspect &&
		      // Also filter out any prototype objects using the circular check.
		      !(value.constructor && value.constructor.prototype === value)) {
		    var ret = value.inspect(recurseTimes, ctx);
		    if (!isString(ret)) {
		      ret = formatValue(ctx, ret, recurseTimes);
		    }
		    return ret;
		  }

		  // Primitive types cannot have properties
		  var primitive = formatPrimitive(ctx, value);
		  if (primitive) {
		    return primitive;
		  }

		  // Look up the keys of the object.
		  var keys = Object.keys(value);
		  var visibleKeys = arrayToHash(keys);

		  if (ctx.showHidden) {
		    keys = Object.getOwnPropertyNames(value);
		  }

		  // IE doesn't make error fields non-enumerable
		  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
		  if (isError(value)
		      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
		    return formatError(value);
		  }

		  // Some type of object without properties can be shortcutted.
		  if (keys.length === 0) {
		    if (isFunction(value)) {
		      var name = value.name ? ': ' + value.name : '';
		      return ctx.stylize('[Function' + name + ']', 'special');
		    }
		    if (isRegExp(value)) {
		      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
		    }
		    if (isDate(value)) {
		      return ctx.stylize(Date.prototype.toString.call(value), 'date');
		    }
		    if (isError(value)) {
		      return formatError(value);
		    }
		  }

		  var base = '', array = false, braces = ['{', '}'];

		  // Make Array say that they are Array
		  if (isArray(value)) {
		    array = true;
		    braces = ['[', ']'];
		  }

		  // Make functions say that they are functions
		  if (isFunction(value)) {
		    var n = value.name ? ': ' + value.name : '';
		    base = ' [Function' + n + ']';
		  }

		  // Make RegExps say that they are RegExps
		  if (isRegExp(value)) {
		    base = ' ' + RegExp.prototype.toString.call(value);
		  }

		  // Make dates with properties first say the date
		  if (isDate(value)) {
		    base = ' ' + Date.prototype.toUTCString.call(value);
		  }

		  // Make error with message first say the error
		  if (isError(value)) {
		    base = ' ' + formatError(value);
		  }

		  if (keys.length === 0 && (!array || value.length == 0)) {
		    return braces[0] + base + braces[1];
		  }

		  if (recurseTimes < 0) {
		    if (isRegExp(value)) {
		      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
		    } else {
		      return ctx.stylize('[Object]', 'special');
		    }
		  }

		  ctx.seen.push(value);

		  var output;
		  if (array) {
		    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
		  } else {
		    output = keys.map(function(key) {
		      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
		    });
		  }

		  ctx.seen.pop();

		  return reduceToSingleString(output, base, braces);
		}


		function formatPrimitive(ctx, value) {
		  if (isUndefined(value))
		    return ctx.stylize('undefined', 'undefined');
		  if (isString(value)) {
		    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
		                                             .replace(/'/g, "\\'")
		                                             .replace(/\\"/g, '"') + '\'';
		    return ctx.stylize(simple, 'string');
		  }
		  if (isNumber(value))
		    return ctx.stylize('' + value, 'number');
		  if (isBoolean(value))
		    return ctx.stylize('' + value, 'boolean');
		  // For some reason typeof null is "object", so special case here.
		  if (isNull(value))
		    return ctx.stylize('null', 'null');
		}


		function formatError(value) {
		  return '[' + Error.prototype.toString.call(value) + ']';
		}


		function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
		  var output = [];
		  for (var i = 0, l = value.length; i < l; ++i) {
		    if (hasOwnProperty(value, String(i))) {
		      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
		          String(i), true));
		    } else {
		      output.push('');
		    }
		  }
		  keys.forEach(function(key) {
		    if (!key.match(/^\d+$/)) {
		      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
		          key, true));
		    }
		  });
		  return output;
		}


		function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
		  var name, str, desc;
		  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
		  if (desc.get) {
		    if (desc.set) {
		      str = ctx.stylize('[Getter/Setter]', 'special');
		    } else {
		      str = ctx.stylize('[Getter]', 'special');
		    }
		  } else {
		    if (desc.set) {
		      str = ctx.stylize('[Setter]', 'special');
		    }
		  }
		  if (!hasOwnProperty(visibleKeys, key)) {
		    name = '[' + key + ']';
		  }
		  if (!str) {
		    if (ctx.seen.indexOf(desc.value) < 0) {
		      if (isNull(recurseTimes)) {
		        str = formatValue(ctx, desc.value, null);
		      } else {
		        str = formatValue(ctx, desc.value, recurseTimes - 1);
		      }
		      if (str.indexOf('\n') > -1) {
		        if (array) {
		          str = str.split('\n').map(function(line) {
		            return '  ' + line;
		          }).join('\n').substr(2);
		        } else {
		          str = '\n' + str.split('\n').map(function(line) {
		            return '   ' + line;
		          }).join('\n');
		        }
		      }
		    } else {
		      str = ctx.stylize('[Circular]', 'special');
		    }
		  }
		  if (isUndefined(name)) {
		    if (array && key.match(/^\d+$/)) {
		      return str;
		    }
		    name = JSON.stringify('' + key);
		    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
		      name = name.substr(1, name.length - 2);
		      name = ctx.stylize(name, 'name');
		    } else {
		      name = name.replace(/'/g, "\\'")
		                 .replace(/\\"/g, '"')
		                 .replace(/(^"|"$)/g, "'");
		      name = ctx.stylize(name, 'string');
		    }
		  }

		  return name + ': ' + str;
		}


		function reduceToSingleString(output, base, braces) {
		  var length = output.reduce(function(prev, cur) {
		    if (cur.indexOf('\n') >= 0) ;
		    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
		  }, 0);

		  if (length > 60) {
		    return braces[0] +
		           (base === '' ? '' : base + '\n ') +
		           ' ' +
		           output.join(',\n  ') +
		           ' ' +
		           braces[1];
		  }

		  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
		}


		// NOTE: These type checking functions intentionally don't use `instanceof`
		// because it is fragile and can be easily faked with `Object.create()`.
		function isArray(ar) {
		  return Array.isArray(ar);
		}
		exports.isArray = isArray;

		function isBoolean(arg) {
		  return typeof arg === 'boolean';
		}
		exports.isBoolean = isBoolean;

		function isNull(arg) {
		  return arg === null;
		}
		exports.isNull = isNull;

		function isNullOrUndefined(arg) {
		  return arg == null;
		}
		exports.isNullOrUndefined = isNullOrUndefined;

		function isNumber(arg) {
		  return typeof arg === 'number';
		}
		exports.isNumber = isNumber;

		function isString(arg) {
		  return typeof arg === 'string';
		}
		exports.isString = isString;

		function isSymbol(arg) {
		  return typeof arg === 'symbol';
		}
		exports.isSymbol = isSymbol;

		function isUndefined(arg) {
		  return arg === void 0;
		}
		exports.isUndefined = isUndefined;

		function isRegExp(re) {
		  return isObject(re) && objectToString(re) === '[object RegExp]';
		}
		exports.isRegExp = isRegExp;

		function isObject(arg) {
		  return typeof arg === 'object' && arg !== null;
		}
		exports.isObject = isObject;

		function isDate(d) {
		  return isObject(d) && objectToString(d) === '[object Date]';
		}
		exports.isDate = isDate;

		function isError(e) {
		  return isObject(e) &&
		      (objectToString(e) === '[object Error]' || e instanceof Error);
		}
		exports.isError = isError;

		function isFunction(arg) {
		  return typeof arg === 'function';
		}
		exports.isFunction = isFunction;

		function isPrimitive(arg) {
		  return arg === null ||
		         typeof arg === 'boolean' ||
		         typeof arg === 'number' ||
		         typeof arg === 'string' ||
		         typeof arg === 'symbol' ||  // ES6 symbol
		         typeof arg === 'undefined';
		}
		exports.isPrimitive = isPrimitive;

		exports.isBuffer = requireIsBuffer();

		function objectToString(o) {
		  return Object.prototype.toString.call(o);
		}


		function pad(n) {
		  return n < 10 ? '0' + n.toString(10) : n.toString(10);
		}


		var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
		              'Oct', 'Nov', 'Dec'];

		// 26 Feb 16:19:34
		function timestamp() {
		  var d = new Date();
		  var time = [pad(d.getHours()),
		              pad(d.getMinutes()),
		              pad(d.getSeconds())].join(':');
		  return [d.getDate(), months[d.getMonth()], time].join(' ');
		}


		// log is just a thin wrapper to console.log that prepends a timestamp
		exports.log = function() {
		  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
		};


		/**
		 * Inherit the prototype methods from one constructor into another.
		 *
		 * The Function.prototype.inherits from lang.js rewritten as a standalone
		 * function (not on Function.prototype). NOTE: If this file is to be loaded
		 * during bootstrapping this function needs to be rewritten using some native
		 * functions as prototype setup using normal JavaScript does not work as
		 * expected during bootstrapping (see mirror.js in r114903).
		 *
		 * @param {function} ctor Constructor function which needs to inherit the
		 *     prototype.
		 * @param {function} superCtor Constructor function to inherit prototype from.
		 */
		exports.inherits = requireInherits();

		exports._extend = function(origin, add) {
		  // Don't do anything if add isn't an object
		  if (!add || !isObject(add)) return origin;

		  var keys = Object.keys(add);
		  var i = keys.length;
		  while (i--) {
		    origin[keys[i]] = add[keys[i]];
		  }
		  return origin;
		};

		function hasOwnProperty(obj, prop) {
		  return Object.prototype.hasOwnProperty.call(obj, prop);
		} 
	} (util$1));
	return util$1;
}

var hasRequiredAssert;

function requireAssert () {
	if (hasRequiredAssert) return assert.exports;
	hasRequiredAssert = 1;

	var objectAssign$1 = objectAssign;

	// compare and isBuffer taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
	// original notice:

	/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	function compare(a, b) {
	  if (a === b) {
	    return 0;
	  }

	  var x = a.length;
	  var y = b.length;

	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i];
	      y = b[i];
	      break;
	    }
	  }

	  if (x < y) {
	    return -1;
	  }
	  if (y < x) {
	    return 1;
	  }
	  return 0;
	}
	function isBuffer(b) {
	  if (commonjsGlobal.Buffer && typeof commonjsGlobal.Buffer.isBuffer === 'function') {
	    return commonjsGlobal.Buffer.isBuffer(b);
	  }
	  return !!(b != null && b._isBuffer);
	}

	// based on node assert, original notice:
	// NB: The URL to the CommonJS spec is kept just for tradition.
	//     node-assert has evolved a lot since then, both in API and behavior.

	// http://wiki.commonjs.org/wiki/Unit_Testing/1.0
	//
	// THIS IS NOT TESTED NOR LIKELY TO WORK OUTSIDE V8!
	//
	// Originally from narwhal.js (http://narwhaljs.org)
	// Copyright (c) 2009 Thomas Robinson <280north.com>
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the 'Software'), to
	// deal in the Software without restriction, including without limitation the
	// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
	// sell copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
	// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
	// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

	var util = requireUtil();
	var hasOwn = Object.prototype.hasOwnProperty;
	var pSlice = Array.prototype.slice;
	var functionsHaveNames = (function () {
	  return function foo() {}.name === 'foo';
	}());
	function pToString (obj) {
	  return Object.prototype.toString.call(obj);
	}
	function isView(arrbuf) {
	  if (isBuffer(arrbuf)) {
	    return false;
	  }
	  if (typeof commonjsGlobal.ArrayBuffer !== 'function') {
	    return false;
	  }
	  if (typeof ArrayBuffer.isView === 'function') {
	    return ArrayBuffer.isView(arrbuf);
	  }
	  if (!arrbuf) {
	    return false;
	  }
	  if (arrbuf instanceof DataView) {
	    return true;
	  }
	  if (arrbuf.buffer && arrbuf.buffer instanceof ArrayBuffer) {
	    return true;
	  }
	  return false;
	}
	// 1. The assert module provides functions that throw
	// AssertionError's when particular conditions are not met. The
	// assert module must conform to the following interface.

	var assert$1 = assert.exports = ok;

	// 2. The AssertionError is defined in assert.
	// new assert.AssertionError({ message: message,
	//                             actual: actual,
	//                             expected: expected })

	var regex = /\s*function\s+([^\(\s]*)\s*/;
	// based on https://github.com/ljharb/function.prototype.name/blob/adeeeec8bfcc6068b187d7d9fb3d5bb1d3a30899/implementation.js
	function getName(func) {
	  if (!util.isFunction(func)) {
	    return;
	  }
	  if (functionsHaveNames) {
	    return func.name;
	  }
	  var str = func.toString();
	  var match = str.match(regex);
	  return match && match[1];
	}
	assert$1.AssertionError = function AssertionError(options) {
	  this.name = 'AssertionError';
	  this.actual = options.actual;
	  this.expected = options.expected;
	  this.operator = options.operator;
	  if (options.message) {
	    this.message = options.message;
	    this.generatedMessage = false;
	  } else {
	    this.message = getMessage(this);
	    this.generatedMessage = true;
	  }
	  var stackStartFunction = options.stackStartFunction || fail;
	  if (Error.captureStackTrace) {
	    Error.captureStackTrace(this, stackStartFunction);
	  } else {
	    // non v8 browsers so we can have a stacktrace
	    var err = new Error();
	    if (err.stack) {
	      var out = err.stack;

	      // try to strip useless frames
	      var fn_name = getName(stackStartFunction);
	      var idx = out.indexOf('\n' + fn_name);
	      if (idx >= 0) {
	        // once we have located the function frame
	        // we need to strip out everything before it (and its line)
	        var next_line = out.indexOf('\n', idx + 1);
	        out = out.substring(next_line + 1);
	      }

	      this.stack = out;
	    }
	  }
	};

	// assert.AssertionError instanceof Error
	util.inherits(assert$1.AssertionError, Error);

	function truncate(s, n) {
	  if (typeof s === 'string') {
	    return s.length < n ? s : s.slice(0, n);
	  } else {
	    return s;
	  }
	}
	function inspect(something) {
	  if (functionsHaveNames || !util.isFunction(something)) {
	    return util.inspect(something);
	  }
	  var rawname = getName(something);
	  var name = rawname ? ': ' + rawname : '';
	  return '[Function' +  name + ']';
	}
	function getMessage(self) {
	  return truncate(inspect(self.actual), 128) + ' ' +
	         self.operator + ' ' +
	         truncate(inspect(self.expected), 128);
	}

	// At present only the three keys mentioned above are used and
	// understood by the spec. Implementations or sub modules can pass
	// other keys to the AssertionError's constructor - they will be
	// ignored.

	// 3. All of the following functions must throw an AssertionError
	// when a corresponding condition is not met, with a message that
	// may be undefined if not provided.  All assertion methods provide
	// both the actual and expected values to the assertion error for
	// display purposes.

	function fail(actual, expected, message, operator, stackStartFunction) {
	  throw new assert$1.AssertionError({
	    message: message,
	    actual: actual,
	    expected: expected,
	    operator: operator,
	    stackStartFunction: stackStartFunction
	  });
	}

	// EXTENSION! allows for well behaved errors defined elsewhere.
	assert$1.fail = fail;

	// 4. Pure assertion tests whether a value is truthy, as determined
	// by !!guard.
	// assert.ok(guard, message_opt);
	// This statement is equivalent to assert.equal(true, !!guard,
	// message_opt);. To test strictly for the value true, use
	// assert.strictEqual(true, guard, message_opt);.

	function ok(value, message) {
	  if (!value) fail(value, true, message, '==', assert$1.ok);
	}
	assert$1.ok = ok;

	// 5. The equality assertion tests shallow, coercive equality with
	// ==.
	// assert.equal(actual, expected, message_opt);

	assert$1.equal = function equal(actual, expected, message) {
	  if (actual != expected) fail(actual, expected, message, '==', assert$1.equal);
	};

	// 6. The non-equality assertion tests for whether two objects are not equal
	// with != assert.notEqual(actual, expected, message_opt);

	assert$1.notEqual = function notEqual(actual, expected, message) {
	  if (actual == expected) {
	    fail(actual, expected, message, '!=', assert$1.notEqual);
	  }
	};

	// 7. The equivalence assertion tests a deep equality relation.
	// assert.deepEqual(actual, expected, message_opt);

	assert$1.deepEqual = function deepEqual(actual, expected, message) {
	  if (!_deepEqual(actual, expected, false)) {
	    fail(actual, expected, message, 'deepEqual', assert$1.deepEqual);
	  }
	};

	assert$1.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
	  if (!_deepEqual(actual, expected, true)) {
	    fail(actual, expected, message, 'deepStrictEqual', assert$1.deepStrictEqual);
	  }
	};

	function _deepEqual(actual, expected, strict, memos) {
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	  } else if (isBuffer(actual) && isBuffer(expected)) {
	    return compare(actual, expected) === 0;

	  // 7.2. If the expected value is a Date object, the actual value is
	  // equivalent if it is also a Date object that refers to the same time.
	  } else if (util.isDate(actual) && util.isDate(expected)) {
	    return actual.getTime() === expected.getTime();

	  // 7.3 If the expected value is a RegExp object, the actual value is
	  // equivalent if it is also a RegExp object with the same source and
	  // properties (`global`, `multiline`, `lastIndex`, `ignoreCase`).
	  } else if (util.isRegExp(actual) && util.isRegExp(expected)) {
	    return actual.source === expected.source &&
	           actual.global === expected.global &&
	           actual.multiline === expected.multiline &&
	           actual.lastIndex === expected.lastIndex &&
	           actual.ignoreCase === expected.ignoreCase;

	  // 7.4. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if ((actual === null || typeof actual !== 'object') &&
	             (expected === null || typeof expected !== 'object')) {
	    return strict ? actual === expected : actual == expected;

	  // If both values are instances of typed arrays, wrap their underlying
	  // ArrayBuffers in a Buffer each to increase performance
	  // This optimization requires the arrays to have the same type as checked by
	  // Object.prototype.toString (aka pToString). Never perform binary
	  // comparisons for Float*Arrays, though, since e.g. +0 === -0 but their
	  // bit patterns are not identical.
	  } else if (isView(actual) && isView(expected) &&
	             pToString(actual) === pToString(expected) &&
	             !(actual instanceof Float32Array ||
	               actual instanceof Float64Array)) {
	    return compare(new Uint8Array(actual.buffer),
	                   new Uint8Array(expected.buffer)) === 0;

	  // 7.5 For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else if (isBuffer(actual) !== isBuffer(expected)) {
	    return false;
	  } else {
	    memos = memos || {actual: [], expected: []};

	    var actualIndex = memos.actual.indexOf(actual);
	    if (actualIndex !== -1) {
	      if (actualIndex === memos.expected.indexOf(expected)) {
	        return true;
	      }
	    }

	    memos.actual.push(actual);
	    memos.expected.push(expected);

	    return objEquiv(actual, expected, strict, memos);
	  }
	}

	function isArguments(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	}

	function objEquiv(a, b, strict, actualVisitedObjects) {
	  if (a === null || a === undefined || b === null || b === undefined)
	    return false;
	  // if one is a primitive, the other must be same
	  if (util.isPrimitive(a) || util.isPrimitive(b))
	    return a === b;
	  if (strict && Object.getPrototypeOf(a) !== Object.getPrototypeOf(b))
	    return false;
	  var aIsArgs = isArguments(a);
	  var bIsArgs = isArguments(b);
	  if ((aIsArgs && !bIsArgs) || (!aIsArgs && bIsArgs))
	    return false;
	  if (aIsArgs) {
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return _deepEqual(a, b, strict);
	  }
	  var ka = objectKeys(a);
	  var kb = objectKeys(b);
	  var key, i;
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length !== kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] !== kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!_deepEqual(a[key], b[key], strict, actualVisitedObjects))
	      return false;
	  }
	  return true;
	}

	// 8. The non-equivalence assertion tests for any deep inequality.
	// assert.notDeepEqual(actual, expected, message_opt);

	assert$1.notDeepEqual = function notDeepEqual(actual, expected, message) {
	  if (_deepEqual(actual, expected, false)) {
	    fail(actual, expected, message, 'notDeepEqual', assert$1.notDeepEqual);
	  }
	};

	assert$1.notDeepStrictEqual = notDeepStrictEqual;
	function notDeepStrictEqual(actual, expected, message) {
	  if (_deepEqual(actual, expected, true)) {
	    fail(actual, expected, message, 'notDeepStrictEqual', notDeepStrictEqual);
	  }
	}


	// 9. The strict equality assertion tests strict equality, as determined by ===.
	// assert.strictEqual(actual, expected, message_opt);

	assert$1.strictEqual = function strictEqual(actual, expected, message) {
	  if (actual !== expected) {
	    fail(actual, expected, message, '===', assert$1.strictEqual);
	  }
	};

	// 10. The strict non-equality assertion tests for strict inequality, as
	// determined by !==.  assert.notStrictEqual(actual, expected, message_opt);

	assert$1.notStrictEqual = function notStrictEqual(actual, expected, message) {
	  if (actual === expected) {
	    fail(actual, expected, message, '!==', assert$1.notStrictEqual);
	  }
	};

	function expectedException(actual, expected) {
	  if (!actual || !expected) {
	    return false;
	  }

	  if (Object.prototype.toString.call(expected) == '[object RegExp]') {
	    return expected.test(actual);
	  }

	  try {
	    if (actual instanceof expected) {
	      return true;
	    }
	  } catch (e) {
	    // Ignore.  The instanceof check doesn't work for arrow functions.
	  }

	  if (Error.isPrototypeOf(expected)) {
	    return false;
	  }

	  return expected.call({}, actual) === true;
	}

	function _tryBlock(block) {
	  var error;
	  try {
	    block();
	  } catch (e) {
	    error = e;
	  }
	  return error;
	}

	function _throws(shouldThrow, block, expected, message) {
	  var actual;

	  if (typeof block !== 'function') {
	    throw new TypeError('"block" argument must be a function');
	  }

	  if (typeof expected === 'string') {
	    message = expected;
	    expected = null;
	  }

	  actual = _tryBlock(block);

	  message = (expected && expected.name ? ' (' + expected.name + ').' : '.') +
	            (message ? ' ' + message : '.');

	  if (shouldThrow && !actual) {
	    fail(actual, expected, 'Missing expected exception' + message);
	  }

	  var userProvidedMessage = typeof message === 'string';
	  var isUnwantedException = !shouldThrow && util.isError(actual);
	  var isUnexpectedException = !shouldThrow && actual && !expected;

	  if ((isUnwantedException &&
	      userProvidedMessage &&
	      expectedException(actual, expected)) ||
	      isUnexpectedException) {
	    fail(actual, expected, 'Got unwanted exception' + message);
	  }

	  if ((shouldThrow && actual && expected &&
	      !expectedException(actual, expected)) || (!shouldThrow && actual)) {
	    throw actual;
	  }
	}

	// 11. Expected to throw an error:
	// assert.throws(block, Error_opt, message_opt);

	assert$1.throws = function(block, /*optional*/error, /*optional*/message) {
	  _throws(true, block, error, message);
	};

	// EXTENSION! This is annoying to write outside this module.
	assert$1.doesNotThrow = function(block, /*optional*/error, /*optional*/message) {
	  _throws(false, block, error, message);
	};

	assert$1.ifError = function(err) { if (err) throw err; };

	// Expose a strict only variant of assert
	function strict(value, message) {
	  if (!value) fail(value, true, message, '==', strict);
	}
	assert$1.strict = objectAssign$1(strict, assert$1, {
	  equal: assert$1.strictEqual,
	  deepEqual: assert$1.deepStrictEqual,
	  notEqual: assert$1.notStrictEqual,
	  notDeepEqual: assert$1.notDeepStrictEqual
	});
	assert$1.strict.strict = assert$1.strict;

	var objectKeys = Object.keys || function (obj) {
	  var keys = [];
	  for (var key in obj) {
	    if (hasOwn.call(obj, key)) keys.push(key);
	  }
	  return keys;
	};
	return assert.exports;
}

var src$1 = {exports: {}};

var browser$1 = {exports: {}};

/**
 * Helpers.
 */

var ms;
var hasRequiredMs;

function requireMs () {
	if (hasRequiredMs) return ms;
	hasRequiredMs = 1;
	var s = 1000;
	var m = s * 60;
	var h = m * 60;
	var d = h * 24;
	var w = d * 7;
	var y = d * 365.25;

	/**
	 * Parse or format the given `val`.
	 *
	 * Options:
	 *
	 *  - `long` verbose formatting [false]
	 *
	 * @param {String|Number} val
	 * @param {Object} [options]
	 * @throws {Error} throw an error if val is not a non-empty string or a number
	 * @return {String|Number}
	 * @api public
	 */

	ms = function(val, options) {
	  options = options || {};
	  var type = typeof val;
	  if (type === 'string' && val.length > 0) {
	    return parse(val);
	  } else if (type === 'number' && isFinite(val)) {
	    return options.long ? fmtLong(val) : fmtShort(val);
	  }
	  throw new Error(
	    'val is not a non-empty string or a valid number. val=' +
	      JSON.stringify(val)
	  );
	};

	/**
	 * Parse the given `str` and return milliseconds.
	 *
	 * @param {String} str
	 * @return {Number}
	 * @api private
	 */

	function parse(str) {
	  str = String(str);
	  if (str.length > 100) {
	    return;
	  }
	  var match = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(
	    str
	  );
	  if (!match) {
	    return;
	  }
	  var n = parseFloat(match[1]);
	  var type = (match[2] || 'ms').toLowerCase();
	  switch (type) {
	    case 'years':
	    case 'year':
	    case 'yrs':
	    case 'yr':
	    case 'y':
	      return n * y;
	    case 'weeks':
	    case 'week':
	    case 'w':
	      return n * w;
	    case 'days':
	    case 'day':
	    case 'd':
	      return n * d;
	    case 'hours':
	    case 'hour':
	    case 'hrs':
	    case 'hr':
	    case 'h':
	      return n * h;
	    case 'minutes':
	    case 'minute':
	    case 'mins':
	    case 'min':
	    case 'm':
	      return n * m;
	    case 'seconds':
	    case 'second':
	    case 'secs':
	    case 'sec':
	    case 's':
	      return n * s;
	    case 'milliseconds':
	    case 'millisecond':
	    case 'msecs':
	    case 'msec':
	    case 'ms':
	      return n;
	    default:
	      return undefined;
	  }
	}

	/**
	 * Short format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */

	function fmtShort(ms) {
	  var msAbs = Math.abs(ms);
	  if (msAbs >= d) {
	    return Math.round(ms / d) + 'd';
	  }
	  if (msAbs >= h) {
	    return Math.round(ms / h) + 'h';
	  }
	  if (msAbs >= m) {
	    return Math.round(ms / m) + 'm';
	  }
	  if (msAbs >= s) {
	    return Math.round(ms / s) + 's';
	  }
	  return ms + 'ms';
	}

	/**
	 * Long format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */

	function fmtLong(ms) {
	  var msAbs = Math.abs(ms);
	  if (msAbs >= d) {
	    return plural(ms, msAbs, d, 'day');
	  }
	  if (msAbs >= h) {
	    return plural(ms, msAbs, h, 'hour');
	  }
	  if (msAbs >= m) {
	    return plural(ms, msAbs, m, 'minute');
	  }
	  if (msAbs >= s) {
	    return plural(ms, msAbs, s, 'second');
	  }
	  return ms + ' ms';
	}

	/**
	 * Pluralization helper.
	 */

	function plural(ms, msAbs, n, name) {
	  var isPlural = msAbs >= n * 1.5;
	  return Math.round(ms / n) + ' ' + name + (isPlural ? 's' : '');
	}
	return ms;
}

var common;
var hasRequiredCommon;

function requireCommon () {
	if (hasRequiredCommon) return common;
	hasRequiredCommon = 1;
	/**
	 * This is the common logic for both the Node.js and web browser
	 * implementations of `debug()`.
	 */

	function setup(env) {
		createDebug.debug = createDebug;
		createDebug.default = createDebug;
		createDebug.coerce = coerce;
		createDebug.disable = disable;
		createDebug.enable = enable;
		createDebug.enabled = enabled;
		createDebug.humanize = requireMs();
		createDebug.destroy = destroy;

		Object.keys(env).forEach(key => {
			createDebug[key] = env[key];
		});

		/**
		* The currently active debug mode names, and names to skip.
		*/

		createDebug.names = [];
		createDebug.skips = [];

		/**
		* Map of special "%n" handling functions, for the debug "format" argument.
		*
		* Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
		*/
		createDebug.formatters = {};

		/**
		* Selects a color for a debug namespace
		* @param {String} namespace The namespace string for the debug instance to be colored
		* @return {Number|String} An ANSI color code for the given namespace
		* @api private
		*/
		function selectColor(namespace) {
			let hash = 0;

			for (let i = 0; i < namespace.length; i++) {
				hash = ((hash << 5) - hash) + namespace.charCodeAt(i);
				hash |= 0; // Convert to 32bit integer
			}

			return createDebug.colors[Math.abs(hash) % createDebug.colors.length];
		}
		createDebug.selectColor = selectColor;

		/**
		* Create a debugger with the given `namespace`.
		*
		* @param {String} namespace
		* @return {Function}
		* @api public
		*/
		function createDebug(namespace) {
			let prevTime;
			let enableOverride = null;
			let namespacesCache;
			let enabledCache;

			function debug(...args) {
				// Disabled?
				if (!debug.enabled) {
					return;
				}

				const self = debug;

				// Set `diff` timestamp
				const curr = Number(new Date());
				const ms = curr - (prevTime || curr);
				self.diff = ms;
				self.prev = prevTime;
				self.curr = curr;
				prevTime = curr;

				args[0] = createDebug.coerce(args[0]);

				if (typeof args[0] !== 'string') {
					// Anything else let's inspect with %O
					args.unshift('%O');
				}

				// Apply any `formatters` transformations
				let index = 0;
				args[0] = args[0].replace(/%([a-zA-Z%])/g, (match, format) => {
					// If we encounter an escaped % then don't increase the array index
					if (match === '%%') {
						return '%';
					}
					index++;
					const formatter = createDebug.formatters[format];
					if (typeof formatter === 'function') {
						const val = args[index];
						match = formatter.call(self, val);

						// Now we need to remove `args[index]` since it's inlined in the `format`
						args.splice(index, 1);
						index--;
					}
					return match;
				});

				// Apply env-specific formatting (colors, etc.)
				createDebug.formatArgs.call(self, args);

				const logFn = self.log || createDebug.log;
				logFn.apply(self, args);
			}

			debug.namespace = namespace;
			debug.useColors = createDebug.useColors();
			debug.color = createDebug.selectColor(namespace);
			debug.extend = extend;
			debug.destroy = createDebug.destroy; // XXX Temporary. Will be removed in the next major release.

			Object.defineProperty(debug, 'enabled', {
				enumerable: true,
				configurable: false,
				get: () => {
					if (enableOverride !== null) {
						return enableOverride;
					}
					if (namespacesCache !== createDebug.namespaces) {
						namespacesCache = createDebug.namespaces;
						enabledCache = createDebug.enabled(namespace);
					}

					return enabledCache;
				},
				set: v => {
					enableOverride = v;
				}
			});

			// Env-specific initialization logic for debug instances
			if (typeof createDebug.init === 'function') {
				createDebug.init(debug);
			}

			return debug;
		}

		function extend(namespace, delimiter) {
			const newDebug = createDebug(this.namespace + (typeof delimiter === 'undefined' ? ':' : delimiter) + namespace);
			newDebug.log = this.log;
			return newDebug;
		}

		/**
		* Enables a debug mode by namespaces. This can include modes
		* separated by a colon and wildcards.
		*
		* @param {String} namespaces
		* @api public
		*/
		function enable(namespaces) {
			createDebug.save(namespaces);
			createDebug.namespaces = namespaces;

			createDebug.names = [];
			createDebug.skips = [];

			let i;
			const split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
			const len = split.length;

			for (i = 0; i < len; i++) {
				if (!split[i]) {
					// ignore empty strings
					continue;
				}

				namespaces = split[i].replace(/\*/g, '.*?');

				if (namespaces[0] === '-') {
					createDebug.skips.push(new RegExp('^' + namespaces.slice(1) + '$'));
				} else {
					createDebug.names.push(new RegExp('^' + namespaces + '$'));
				}
			}
		}

		/**
		* Disable debug output.
		*
		* @return {String} namespaces
		* @api public
		*/
		function disable() {
			const namespaces = [
				...createDebug.names.map(toNamespace),
				...createDebug.skips.map(toNamespace).map(namespace => '-' + namespace)
			].join(',');
			createDebug.enable('');
			return namespaces;
		}

		/**
		* Returns true if the given mode name is enabled, false otherwise.
		*
		* @param {String} name
		* @return {Boolean}
		* @api public
		*/
		function enabled(name) {
			if (name[name.length - 1] === '*') {
				return true;
			}

			let i;
			let len;

			for (i = 0, len = createDebug.skips.length; i < len; i++) {
				if (createDebug.skips[i].test(name)) {
					return false;
				}
			}

			for (i = 0, len = createDebug.names.length; i < len; i++) {
				if (createDebug.names[i].test(name)) {
					return true;
				}
			}

			return false;
		}

		/**
		* Convert regexp to namespace
		*
		* @param {RegExp} regxep
		* @return {String} namespace
		* @api private
		*/
		function toNamespace(regexp) {
			return regexp.toString()
				.substring(2, regexp.toString().length - 2)
				.replace(/\.\*\?$/, '*');
		}

		/**
		* Coerce `val`.
		*
		* @param {Mixed} val
		* @return {Mixed}
		* @api private
		*/
		function coerce(val) {
			if (val instanceof Error) {
				return val.stack || val.message;
			}
			return val;
		}

		/**
		* XXX DO NOT USE. This is a temporary stub function.
		* XXX It WILL be removed in the next major release.
		*/
		function destroy() {
			console.warn('Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.');
		}

		createDebug.enable(createDebug.load());

		return createDebug;
	}

	common = setup;
	return common;
}

/* eslint-env browser */

var hasRequiredBrowser;

function requireBrowser () {
	if (hasRequiredBrowser) return browser$1.exports;
	hasRequiredBrowser = 1;
	(function (module, exports) {
		/**
		 * This is the web browser implementation of `debug()`.
		 */

		exports.formatArgs = formatArgs;
		exports.save = save;
		exports.load = load;
		exports.useColors = useColors;
		exports.storage = localstorage();
		exports.destroy = (() => {
			let warned = false;

			return () => {
				if (!warned) {
					warned = true;
					console.warn('Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.');
				}
			};
		})();

		/**
		 * Colors.
		 */

		exports.colors = [
			'#0000CC',
			'#0000FF',
			'#0033CC',
			'#0033FF',
			'#0066CC',
			'#0066FF',
			'#0099CC',
			'#0099FF',
			'#00CC00',
			'#00CC33',
			'#00CC66',
			'#00CC99',
			'#00CCCC',
			'#00CCFF',
			'#3300CC',
			'#3300FF',
			'#3333CC',
			'#3333FF',
			'#3366CC',
			'#3366FF',
			'#3399CC',
			'#3399FF',
			'#33CC00',
			'#33CC33',
			'#33CC66',
			'#33CC99',
			'#33CCCC',
			'#33CCFF',
			'#6600CC',
			'#6600FF',
			'#6633CC',
			'#6633FF',
			'#66CC00',
			'#66CC33',
			'#9900CC',
			'#9900FF',
			'#9933CC',
			'#9933FF',
			'#99CC00',
			'#99CC33',
			'#CC0000',
			'#CC0033',
			'#CC0066',
			'#CC0099',
			'#CC00CC',
			'#CC00FF',
			'#CC3300',
			'#CC3333',
			'#CC3366',
			'#CC3399',
			'#CC33CC',
			'#CC33FF',
			'#CC6600',
			'#CC6633',
			'#CC9900',
			'#CC9933',
			'#CCCC00',
			'#CCCC33',
			'#FF0000',
			'#FF0033',
			'#FF0066',
			'#FF0099',
			'#FF00CC',
			'#FF00FF',
			'#FF3300',
			'#FF3333',
			'#FF3366',
			'#FF3399',
			'#FF33CC',
			'#FF33FF',
			'#FF6600',
			'#FF6633',
			'#FF9900',
			'#FF9933',
			'#FFCC00',
			'#FFCC33'
		];

		/**
		 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
		 * and the Firebug extension (any Firefox version) are known
		 * to support "%c" CSS customizations.
		 *
		 * TODO: add a `localStorage` variable to explicitly enable/disable colors
		 */

		// eslint-disable-next-line complexity
		function useColors() {
			// NB: In an Electron preload script, document will be defined but not fully
			// initialized. Since we know we're in Chrome, we'll just detect this case
			// explicitly
			if (typeof window !== 'undefined' && window.process && (window.process.type === 'renderer' || window.process.__nwjs)) {
				return true;
			}

			// Internet Explorer and Edge do not support colors.
			if (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) {
				return false;
			}

			// Is webkit? http://stackoverflow.com/a/16459606/376773
			// document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
			return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
				// Is firebug? http://stackoverflow.com/a/398120/376773
				(typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
				// Is firefox >= v31?
				// https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
				(typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
				// Double check webkit in userAgent just in case we are in a worker
				(typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
		}

		/**
		 * Colorize log arguments if enabled.
		 *
		 * @api public
		 */

		function formatArgs(args) {
			args[0] = (this.useColors ? '%c' : '') +
				this.namespace +
				(this.useColors ? ' %c' : ' ') +
				args[0] +
				(this.useColors ? '%c ' : ' ') +
				'+' + module.exports.humanize(this.diff);

			if (!this.useColors) {
				return;
			}

			const c = 'color: ' + this.color;
			args.splice(1, 0, c, 'color: inherit');

			// The final "%c" is somewhat tricky, because there could be other
			// arguments passed either before or after the %c, so we need to
			// figure out the correct index to insert the CSS into
			let index = 0;
			let lastC = 0;
			args[0].replace(/%[a-zA-Z%]/g, match => {
				if (match === '%%') {
					return;
				}
				index++;
				if (match === '%c') {
					// We only are interested in the *last* %c
					// (the user may have provided their own)
					lastC = index;
				}
			});

			args.splice(lastC, 0, c);
		}

		/**
		 * Invokes `console.debug()` when available.
		 * No-op when `console.debug` is not a "function".
		 * If `console.debug` is not available, falls back
		 * to `console.log`.
		 *
		 * @api public
		 */
		exports.log = console.debug || console.log || (() => {});

		/**
		 * Save `namespaces`.
		 *
		 * @param {String} namespaces
		 * @api private
		 */
		function save(namespaces) {
			try {
				if (namespaces) {
					exports.storage.setItem('debug', namespaces);
				} else {
					exports.storage.removeItem('debug');
				}
			} catch (error) {
				// Swallow
				// XXX (@Qix-) should we be logging these?
			}
		}

		/**
		 * Load `namespaces`.
		 *
		 * @return {String} returns the previously persisted debug modes
		 * @api private
		 */
		function load() {
			let r;
			try {
				r = exports.storage.getItem('debug');
			} catch (error) {
				// Swallow
				// XXX (@Qix-) should we be logging these?
			}

			// If debug isn't set in LS, and we're in Electron, try to load $DEBUG
			if (!r && typeof process !== 'undefined' && 'env' in process) {
				r = process.env.DEBUG;
			}

			return r;
		}

		/**
		 * Localstorage attempts to return the localstorage.
		 *
		 * This is necessary because safari throws
		 * when a user disables cookies/localstorage
		 * and you attempt to access it.
		 *
		 * @return {LocalStorage}
		 * @api private
		 */

		function localstorage() {
			try {
				// TVMLKit (Apple TV JS Runtime) does not have a window object, just localStorage in the global context
				// The Browser also has localStorage in the global context.
				return localStorage;
			} catch (error) {
				// Swallow
				// XXX (@Qix-) should we be logging these?
			}
		}

		module.exports = requireCommon()(exports);

		const {formatters} = module.exports;

		/**
		 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
		 */

		formatters.j = function (v) {
			try {
				return JSON.stringify(v);
			} catch (error) {
				return '[UnexpectedJSONParseError]: ' + error.message;
			}
		}; 
	} (browser$1, browser$1.exports));
	return browser$1.exports;
}

var node = {exports: {}};

var hasFlag;
var hasRequiredHasFlag;

function requireHasFlag () {
	if (hasRequiredHasFlag) return hasFlag;
	hasRequiredHasFlag = 1;
	hasFlag = (flag, argv) => {
		argv = argv || process.argv;
		const prefix = flag.startsWith('-') ? '' : (flag.length === 1 ? '-' : '--');
		const pos = argv.indexOf(prefix + flag);
		const terminatorPos = argv.indexOf('--');
		return pos !== -1 && (terminatorPos === -1 ? true : pos < terminatorPos);
	};
	return hasFlag;
}

var supportsColor_1;
var hasRequiredSupportsColor;

function requireSupportsColor () {
	if (hasRequiredSupportsColor) return supportsColor_1;
	hasRequiredSupportsColor = 1;
	const os = require$$0;
	const hasFlag = requireHasFlag();

	const {env} = process;

	let forceColor;
	if (hasFlag('no-color') ||
		hasFlag('no-colors') ||
		hasFlag('color=false') ||
		hasFlag('color=never')) {
		forceColor = 0;
	} else if (hasFlag('color') ||
		hasFlag('colors') ||
		hasFlag('color=true') ||
		hasFlag('color=always')) {
		forceColor = 1;
	}
	if ('FORCE_COLOR' in env) {
		if (env.FORCE_COLOR === true || env.FORCE_COLOR === 'true') {
			forceColor = 1;
		} else if (env.FORCE_COLOR === false || env.FORCE_COLOR === 'false') {
			forceColor = 0;
		} else {
			forceColor = env.FORCE_COLOR.length === 0 ? 1 : Math.min(parseInt(env.FORCE_COLOR, 10), 3);
		}
	}

	function translateLevel(level) {
		if (level === 0) {
			return false;
		}

		return {
			level,
			hasBasic: true,
			has256: level >= 2,
			has16m: level >= 3
		};
	}

	function supportsColor(stream) {
		if (forceColor === 0) {
			return 0;
		}

		if (hasFlag('color=16m') ||
			hasFlag('color=full') ||
			hasFlag('color=truecolor')) {
			return 3;
		}

		if (hasFlag('color=256')) {
			return 2;
		}

		if (stream && !stream.isTTY && forceColor === undefined) {
			return 0;
		}

		const min = forceColor || 0;

		if (env.TERM === 'dumb') {
			return min;
		}

		if (process.platform === 'win32') {
			// Node.js 7.5.0 is the first version of Node.js to include a patch to
			// libuv that enables 256 color output on Windows. Anything earlier and it
			// won't work. However, here we target Node.js 8 at minimum as it is an LTS
			// release, and Node.js 7 is not. Windows 10 build 10586 is the first Windows
			// release that supports 256 colors. Windows 10 build 14931 is the first release
			// that supports 16m/TrueColor.
			const osRelease = os.release().split('.');
			if (
				Number(process.versions.node.split('.')[0]) >= 8 &&
				Number(osRelease[0]) >= 10 &&
				Number(osRelease[2]) >= 10586
			) {
				return Number(osRelease[2]) >= 14931 ? 3 : 2;
			}

			return 1;
		}

		if ('CI' in env) {
			if (['TRAVIS', 'CIRCLECI', 'APPVEYOR', 'GITLAB_CI'].some(sign => sign in env) || env.CI_NAME === 'codeship') {
				return 1;
			}

			return min;
		}

		if ('TEAMCITY_VERSION' in env) {
			return /^(9\.(0*[1-9]\d*)\.|\d{2,}\.)/.test(env.TEAMCITY_VERSION) ? 1 : 0;
		}

		if (env.COLORTERM === 'truecolor') {
			return 3;
		}

		if ('TERM_PROGRAM' in env) {
			const version = parseInt((env.TERM_PROGRAM_VERSION || '').split('.')[0], 10);

			switch (env.TERM_PROGRAM) {
				case 'iTerm.app':
					return version >= 3 ? 3 : 2;
				case 'Apple_Terminal':
					return 2;
				// No default
			}
		}

		if (/-256(color)?$/i.test(env.TERM)) {
			return 2;
		}

		if (/^screen|^xterm|^vt100|^vt220|^rxvt|color|ansi|cygwin|linux/i.test(env.TERM)) {
			return 1;
		}

		if ('COLORTERM' in env) {
			return 1;
		}

		return min;
	}

	function getSupportLevel(stream) {
		const level = supportsColor(stream);
		return translateLevel(level);
	}

	supportsColor_1 = {
		supportsColor: getSupportLevel,
		stdout: getSupportLevel(process.stdout),
		stderr: getSupportLevel(process.stderr)
	};
	return supportsColor_1;
}

/**
 * Module dependencies.
 */

var hasRequiredNode;

function requireNode () {
	if (hasRequiredNode) return node.exports;
	hasRequiredNode = 1;
	(function (module, exports) {
		const tty = require$$0$1;
		const util = requireUtil$1();

		/**
		 * This is the Node.js implementation of `debug()`.
		 */

		exports.init = init;
		exports.log = log;
		exports.formatArgs = formatArgs;
		exports.save = save;
		exports.load = load;
		exports.useColors = useColors;
		exports.destroy = util.deprecate(
			() => {},
			'Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.'
		);

		/**
		 * Colors.
		 */

		exports.colors = [6, 2, 3, 4, 5, 1];

		try {
			// Optional dependency (as in, doesn't need to be installed, NOT like optionalDependencies in package.json)
			// eslint-disable-next-line import/no-extraneous-dependencies
			const supportsColor = requireSupportsColor();

			if (supportsColor && (supportsColor.stderr || supportsColor).level >= 2) {
				exports.colors = [
					20,
					21,
					26,
					27,
					32,
					33,
					38,
					39,
					40,
					41,
					42,
					43,
					44,
					45,
					56,
					57,
					62,
					63,
					68,
					69,
					74,
					75,
					76,
					77,
					78,
					79,
					80,
					81,
					92,
					93,
					98,
					99,
					112,
					113,
					128,
					129,
					134,
					135,
					148,
					149,
					160,
					161,
					162,
					163,
					164,
					165,
					166,
					167,
					168,
					169,
					170,
					171,
					172,
					173,
					178,
					179,
					184,
					185,
					196,
					197,
					198,
					199,
					200,
					201,
					202,
					203,
					204,
					205,
					206,
					207,
					208,
					209,
					214,
					215,
					220,
					221
				];
			}
		} catch (error) {
			// Swallow - we only care if `supports-color` is available; it doesn't have to be.
		}

		/**
		 * Build up the default `inspectOpts` object from the environment variables.
		 *
		 *   $ DEBUG_COLORS=no DEBUG_DEPTH=10 DEBUG_SHOW_HIDDEN=enabled node script.js
		 */

		exports.inspectOpts = Object.keys(process.env).filter(key => {
			return /^debug_/i.test(key);
		}).reduce((obj, key) => {
			// Camel-case
			const prop = key
				.substring(6)
				.toLowerCase()
				.replace(/_([a-z])/g, (_, k) => {
					return k.toUpperCase();
				});

			// Coerce string value into JS value
			let val = process.env[key];
			if (/^(yes|on|true|enabled)$/i.test(val)) {
				val = true;
			} else if (/^(no|off|false|disabled)$/i.test(val)) {
				val = false;
			} else if (val === 'null') {
				val = null;
			} else {
				val = Number(val);
			}

			obj[prop] = val;
			return obj;
		}, {});

		/**
		 * Is stdout a TTY? Colored output is enabled when `true`.
		 */

		function useColors() {
			return 'colors' in exports.inspectOpts ?
				Boolean(exports.inspectOpts.colors) :
				tty.isatty(process.stderr.fd);
		}

		/**
		 * Adds ANSI color escape codes if enabled.
		 *
		 * @api public
		 */

		function formatArgs(args) {
			const {namespace: name, useColors} = this;

			if (useColors) {
				const c = this.color;
				const colorCode = '\u001B[3' + (c < 8 ? c : '8;5;' + c);
				const prefix = `  ${colorCode};1m${name} \u001B[0m`;

				args[0] = prefix + args[0].split('\n').join('\n' + prefix);
				args.push(colorCode + 'm+' + module.exports.humanize(this.diff) + '\u001B[0m');
			} else {
				args[0] = getDate() + name + ' ' + args[0];
			}
		}

		function getDate() {
			if (exports.inspectOpts.hideDate) {
				return '';
			}
			return new Date().toISOString() + ' ';
		}

		/**
		 * Invokes `util.format()` with the specified arguments and writes to stderr.
		 */

		function log(...args) {
			return process.stderr.write(util.format(...args) + '\n');
		}

		/**
		 * Save `namespaces`.
		 *
		 * @param {String} namespaces
		 * @api private
		 */
		function save(namespaces) {
			if (namespaces) {
				process.env.DEBUG = namespaces;
			} else {
				// If you set a process.env field to null or undefined, it gets cast to the
				// string 'null' or 'undefined'. Just delete instead.
				delete process.env.DEBUG;
			}
		}

		/**
		 * Load `namespaces`.
		 *
		 * @return {String} returns the previously persisted debug modes
		 * @api private
		 */

		function load() {
			return process.env.DEBUG;
		}

		/**
		 * Init logic for `debug` instances.
		 *
		 * Create a new `inspectOpts` object in case `useColors` is set
		 * differently for a particular `debug` instance.
		 */

		function init(debug) {
			debug.inspectOpts = {};

			const keys = Object.keys(exports.inspectOpts);
			for (let i = 0; i < keys.length; i++) {
				debug.inspectOpts[keys[i]] = exports.inspectOpts[keys[i]];
			}
		}

		module.exports = requireCommon()(exports);

		const {formatters} = module.exports;

		/**
		 * Map %o to `util.inspect()`, all on a single line.
		 */

		formatters.o = function (v) {
			this.inspectOpts.colors = this.useColors;
			return util.inspect(v, this.inspectOpts)
				.split('\n')
				.map(str => str.trim())
				.join(' ');
		};

		/**
		 * Map %O to `util.inspect()`, allowing multiple lines if needed.
		 */

		formatters.O = function (v) {
			this.inspectOpts.colors = this.useColors;
			return util.inspect(v, this.inspectOpts);
		}; 
	} (node, node.exports));
	return node.exports;
}

/**
 * Detect Electron renderer / nwjs process, which is node, but we should
 * treat as a browser.
 */

var hasRequiredSrc;

function requireSrc () {
	if (hasRequiredSrc) return src$1.exports;
	hasRequiredSrc = 1;
	if (typeof process === 'undefined' || process.type === 'renderer' || process.browser === true || process.__nwjs) {
		src$1.exports = requireBrowser();
	} else {
		src$1.exports = requireNode();
	}
	return src$1.exports;
}

var debug_1;
var hasRequiredDebug;

function requireDebug () {
	if (hasRequiredDebug) return debug_1;
	hasRequiredDebug = 1;
	var debug;

	debug_1 = function () {
	  if (!debug) {
	    try {
	      /* eslint global-require: off */
	      debug = requireSrc()("follow-redirects");
	    }
	    catch (error) { /* */ }
	    if (typeof debug !== "function") {
	      debug = function () { /* */ };
	    }
	  }
	  debug.apply(null, arguments);
	};
	return debug_1;
}

var hasRequiredFollowRedirects;

function requireFollowRedirects () {
	if (hasRequiredFollowRedirects) return followRedirects.exports;
	hasRequiredFollowRedirects = 1;
	var url = requireUrl();
	var URL = url.URL;
	var http = require$$1$1;
	var https = require$$2$1;
	var Writable = require$$2.Writable;
	var assert = requireAssert();
	var debug = requireDebug();

	// Create handlers that pass events from native requests
	var events = ["abort", "aborted", "connect", "error", "socket", "timeout"];
	var eventHandlers = Object.create(null);
	events.forEach(function (event) {
	  eventHandlers[event] = function (arg1, arg2, arg3) {
	    this._redirectable.emit(event, arg1, arg2, arg3);
	  };
	});

	var InvalidUrlError = createErrorType(
	  "ERR_INVALID_URL",
	  "Invalid URL",
	  TypeError
	);
	// Error types with codes
	var RedirectionError = createErrorType(
	  "ERR_FR_REDIRECTION_FAILURE",
	  "Redirected request failed"
	);
	var TooManyRedirectsError = createErrorType(
	  "ERR_FR_TOO_MANY_REDIRECTS",
	  "Maximum number of redirects exceeded"
	);
	var MaxBodyLengthExceededError = createErrorType(
	  "ERR_FR_MAX_BODY_LENGTH_EXCEEDED",
	  "Request body larger than maxBodyLength limit"
	);
	var WriteAfterEndError = createErrorType(
	  "ERR_STREAM_WRITE_AFTER_END",
	  "write after end"
	);

	// An HTTP(S) request that can be redirected
	function RedirectableRequest(options, responseCallback) {
	  // Initialize the request
	  Writable.call(this);
	  this._sanitizeOptions(options);
	  this._options = options;
	  this._ended = false;
	  this._ending = false;
	  this._redirectCount = 0;
	  this._redirects = [];
	  this._requestBodyLength = 0;
	  this._requestBodyBuffers = [];

	  // Attach a callback if passed
	  if (responseCallback) {
	    this.on("response", responseCallback);
	  }

	  // React to responses of native requests
	  var self = this;
	  this._onNativeResponse = function (response) {
	    self._processResponse(response);
	  };

	  // Perform the first request
	  this._performRequest();
	}
	RedirectableRequest.prototype = Object.create(Writable.prototype);

	RedirectableRequest.prototype.abort = function () {
	  abortRequest(this._currentRequest);
	  this.emit("abort");
	};

	// Writes buffered data to the current native request
	RedirectableRequest.prototype.write = function (data, encoding, callback) {
	  // Writing is not allowed if end has been called
	  if (this._ending) {
	    throw new WriteAfterEndError();
	  }

	  // Validate input and shift parameters if necessary
	  if (!isString(data) && !isBuffer(data)) {
	    throw new TypeError("data should be a string, Buffer or Uint8Array");
	  }
	  if (isFunction(encoding)) {
	    callback = encoding;
	    encoding = null;
	  }

	  // Ignore empty buffers, since writing them doesn't invoke the callback
	  // https://github.com/nodejs/node/issues/22066
	  if (data.length === 0) {
	    if (callback) {
	      callback();
	    }
	    return;
	  }
	  // Only write when we don't exceed the maximum body length
	  if (this._requestBodyLength + data.length <= this._options.maxBodyLength) {
	    this._requestBodyLength += data.length;
	    this._requestBodyBuffers.push({ data: data, encoding: encoding });
	    this._currentRequest.write(data, encoding, callback);
	  }
	  // Error when we exceed the maximum body length
	  else {
	    this.emit("error", new MaxBodyLengthExceededError());
	    this.abort();
	  }
	};

	// Ends the current native request
	RedirectableRequest.prototype.end = function (data, encoding, callback) {
	  // Shift parameters if necessary
	  if (isFunction(data)) {
	    callback = data;
	    data = encoding = null;
	  }
	  else if (isFunction(encoding)) {
	    callback = encoding;
	    encoding = null;
	  }

	  // Write data if needed and end
	  if (!data) {
	    this._ended = this._ending = true;
	    this._currentRequest.end(null, null, callback);
	  }
	  else {
	    var self = this;
	    var currentRequest = this._currentRequest;
	    this.write(data, encoding, function () {
	      self._ended = true;
	      currentRequest.end(null, null, callback);
	    });
	    this._ending = true;
	  }
	};

	// Sets a header value on the current native request
	RedirectableRequest.prototype.setHeader = function (name, value) {
	  this._options.headers[name] = value;
	  this._currentRequest.setHeader(name, value);
	};

	// Clears a header value on the current native request
	RedirectableRequest.prototype.removeHeader = function (name) {
	  delete this._options.headers[name];
	  this._currentRequest.removeHeader(name);
	};

	// Global timeout for all underlying requests
	RedirectableRequest.prototype.setTimeout = function (msecs, callback) {
	  var self = this;

	  // Destroys the socket on timeout
	  function destroyOnTimeout(socket) {
	    socket.setTimeout(msecs);
	    socket.removeListener("timeout", socket.destroy);
	    socket.addListener("timeout", socket.destroy);
	  }

	  // Sets up a timer to trigger a timeout event
	  function startTimer(socket) {
	    if (self._timeout) {
	      clearTimeout(self._timeout);
	    }
	    self._timeout = setTimeout(function () {
	      self.emit("timeout");
	      clearTimer();
	    }, msecs);
	    destroyOnTimeout(socket);
	  }

	  // Stops a timeout from triggering
	  function clearTimer() {
	    // Clear the timeout
	    if (self._timeout) {
	      clearTimeout(self._timeout);
	      self._timeout = null;
	    }

	    // Clean up all attached listeners
	    self.removeListener("abort", clearTimer);
	    self.removeListener("error", clearTimer);
	    self.removeListener("response", clearTimer);
	    if (callback) {
	      self.removeListener("timeout", callback);
	    }
	    if (!self.socket) {
	      self._currentRequest.removeListener("socket", startTimer);
	    }
	  }

	  // Attach callback if passed
	  if (callback) {
	    this.on("timeout", callback);
	  }

	  // Start the timer if or when the socket is opened
	  if (this.socket) {
	    startTimer(this.socket);
	  }
	  else {
	    this._currentRequest.once("socket", startTimer);
	  }

	  // Clean up on events
	  this.on("socket", destroyOnTimeout);
	  this.on("abort", clearTimer);
	  this.on("error", clearTimer);
	  this.on("response", clearTimer);

	  return this;
	};

	// Proxy all other public ClientRequest methods
	[
	  "flushHeaders", "getHeader",
	  "setNoDelay", "setSocketKeepAlive",
	].forEach(function (method) {
	  RedirectableRequest.prototype[method] = function (a, b) {
	    return this._currentRequest[method](a, b);
	  };
	});

	// Proxy all public ClientRequest properties
	["aborted", "connection", "socket"].forEach(function (property) {
	  Object.defineProperty(RedirectableRequest.prototype, property, {
	    get: function () { return this._currentRequest[property]; },
	  });
	});

	RedirectableRequest.prototype._sanitizeOptions = function (options) {
	  // Ensure headers are always present
	  if (!options.headers) {
	    options.headers = {};
	  }

	  // Since http.request treats host as an alias of hostname,
	  // but the url module interprets host as hostname plus port,
	  // eliminate the host property to avoid confusion.
	  if (options.host) {
	    // Use hostname if set, because it has precedence
	    if (!options.hostname) {
	      options.hostname = options.host;
	    }
	    delete options.host;
	  }

	  // Complete the URL object when necessary
	  if (!options.pathname && options.path) {
	    var searchPos = options.path.indexOf("?");
	    if (searchPos < 0) {
	      options.pathname = options.path;
	    }
	    else {
	      options.pathname = options.path.substring(0, searchPos);
	      options.search = options.path.substring(searchPos);
	    }
	  }
	};


	// Executes the next native request (initial or redirect)
	RedirectableRequest.prototype._performRequest = function () {
	  // Load the native protocol
	  var protocol = this._options.protocol;
	  var nativeProtocol = this._options.nativeProtocols[protocol];
	  if (!nativeProtocol) {
	    this.emit("error", new TypeError("Unsupported protocol " + protocol));
	    return;
	  }

	  // If specified, use the agent corresponding to the protocol
	  // (HTTP and HTTPS use different types of agents)
	  if (this._options.agents) {
	    var scheme = protocol.slice(0, -1);
	    this._options.agent = this._options.agents[scheme];
	  }

	  // Create the native request and set up its event handlers
	  var request = this._currentRequest =
	        nativeProtocol.request(this._options, this._onNativeResponse);
	  request._redirectable = this;
	  for (var event of events) {
	    request.on(event, eventHandlers[event]);
	  }

	  // RFC7230§5.3.1: When making a request directly to an origin server, […]
	  // a client MUST send only the absolute path […] as the request-target.
	  this._currentUrl = /^\//.test(this._options.path) ?
	    url.format(this._options) :
	    // When making a request to a proxy, […]
	    // a client MUST send the target URI in absolute-form […].
	    this._options.path;

	  // End a redirected request
	  // (The first request must be ended explicitly with RedirectableRequest#end)
	  if (this._isRedirect) {
	    // Write the request entity and end
	    var i = 0;
	    var self = this;
	    var buffers = this._requestBodyBuffers;
	    (function writeNext(error) {
	      // Only write if this request has not been redirected yet
	      /* istanbul ignore else */
	      if (request === self._currentRequest) {
	        // Report any write errors
	        /* istanbul ignore if */
	        if (error) {
	          self.emit("error", error);
	        }
	        // Write the next buffer if there are still left
	        else if (i < buffers.length) {
	          var buffer = buffers[i++];
	          /* istanbul ignore else */
	          if (!request.finished) {
	            request.write(buffer.data, buffer.encoding, writeNext);
	          }
	        }
	        // End the request if `end` has been called on us
	        else if (self._ended) {
	          request.end();
	        }
	      }
	    }());
	  }
	};

	// Processes a response from the current native request
	RedirectableRequest.prototype._processResponse = function (response) {
	  // Store the redirected response
	  var statusCode = response.statusCode;
	  if (this._options.trackRedirects) {
	    this._redirects.push({
	      url: this._currentUrl,
	      headers: response.headers,
	      statusCode: statusCode,
	    });
	  }

	  // RFC7231§6.4: The 3xx (Redirection) class of status code indicates
	  // that further action needs to be taken by the user agent in order to
	  // fulfill the request. If a Location header field is provided,
	  // the user agent MAY automatically redirect its request to the URI
	  // referenced by the Location field value,
	  // even if the specific status code is not understood.

	  // If the response is not a redirect; return it as-is
	  var location = response.headers.location;
	  if (!location || this._options.followRedirects === false ||
	      statusCode < 300 || statusCode >= 400) {
	    response.responseUrl = this._currentUrl;
	    response.redirects = this._redirects;
	    this.emit("response", response);

	    // Clean up
	    this._requestBodyBuffers = [];
	    return;
	  }

	  // The response is a redirect, so abort the current request
	  abortRequest(this._currentRequest);
	  // Discard the remainder of the response to avoid waiting for data
	  response.destroy();

	  // RFC7231§6.4: A client SHOULD detect and intervene
	  // in cyclical redirections (i.e., "infinite" redirection loops).
	  if (++this._redirectCount > this._options.maxRedirects) {
	    this.emit("error", new TooManyRedirectsError());
	    return;
	  }

	  // Store the request headers if applicable
	  var requestHeaders;
	  var beforeRedirect = this._options.beforeRedirect;
	  if (beforeRedirect) {
	    requestHeaders = Object.assign({
	      // The Host header was set by nativeProtocol.request
	      Host: response.req.getHeader("host"),
	    }, this._options.headers);
	  }

	  // RFC7231§6.4: Automatic redirection needs to done with
	  // care for methods not known to be safe, […]
	  // RFC7231§6.4.2–3: For historical reasons, a user agent MAY change
	  // the request method from POST to GET for the subsequent request.
	  var method = this._options.method;
	  if ((statusCode === 301 || statusCode === 302) && this._options.method === "POST" ||
	      // RFC7231§6.4.4: The 303 (See Other) status code indicates that
	      // the server is redirecting the user agent to a different resource […]
	      // A user agent can perform a retrieval request targeting that URI
	      // (a GET or HEAD request if using HTTP) […]
	      (statusCode === 303) && !/^(?:GET|HEAD)$/.test(this._options.method)) {
	    this._options.method = "GET";
	    // Drop a possible entity and headers related to it
	    this._requestBodyBuffers = [];
	    removeMatchingHeaders(/^content-/i, this._options.headers);
	  }

	  // Drop the Host header, as the redirect might lead to a different host
	  var currentHostHeader = removeMatchingHeaders(/^host$/i, this._options.headers);

	  // If the redirect is relative, carry over the host of the last request
	  var currentUrlParts = url.parse(this._currentUrl);
	  var currentHost = currentHostHeader || currentUrlParts.host;
	  var currentUrl = /^\w+:/.test(location) ? this._currentUrl :
	    url.format(Object.assign(currentUrlParts, { host: currentHost }));

	  // Determine the URL of the redirection
	  var redirectUrl;
	  try {
	    redirectUrl = url.resolve(currentUrl, location);
	  }
	  catch (cause) {
	    this.emit("error", new RedirectionError({ cause: cause }));
	    return;
	  }

	  // Create the redirected request
	  debug("redirecting to", redirectUrl);
	  this._isRedirect = true;
	  var redirectUrlParts = url.parse(redirectUrl);
	  Object.assign(this._options, redirectUrlParts);

	  // Drop confidential headers when redirecting to a less secure protocol
	  // or to a different domain that is not a superdomain
	  if (redirectUrlParts.protocol !== currentUrlParts.protocol &&
	     redirectUrlParts.protocol !== "https:" ||
	     redirectUrlParts.host !== currentHost &&
	     !isSubdomain(redirectUrlParts.host, currentHost)) {
	    removeMatchingHeaders(/^(?:authorization|cookie)$/i, this._options.headers);
	  }

	  // Evaluate the beforeRedirect callback
	  if (isFunction(beforeRedirect)) {
	    var responseDetails = {
	      headers: response.headers,
	      statusCode: statusCode,
	    };
	    var requestDetails = {
	      url: currentUrl,
	      method: method,
	      headers: requestHeaders,
	    };
	    try {
	      beforeRedirect(this._options, responseDetails, requestDetails);
	    }
	    catch (err) {
	      this.emit("error", err);
	      return;
	    }
	    this._sanitizeOptions(this._options);
	  }

	  // Perform the redirected request
	  try {
	    this._performRequest();
	  }
	  catch (cause) {
	    this.emit("error", new RedirectionError({ cause: cause }));
	  }
	};

	// Wraps the key/value object of protocols with redirect functionality
	function wrap(protocols) {
	  // Default settings
	  var exports = {
	    maxRedirects: 21,
	    maxBodyLength: 10 * 1024 * 1024,
	  };

	  // Wrap each protocol
	  var nativeProtocols = {};
	  Object.keys(protocols).forEach(function (scheme) {
	    var protocol = scheme + ":";
	    var nativeProtocol = nativeProtocols[protocol] = protocols[scheme];
	    var wrappedProtocol = exports[scheme] = Object.create(nativeProtocol);

	    // Executes a request, following redirects
	    function request(input, options, callback) {
	      // Parse parameters
	      if (isString(input)) {
	        var parsed;
	        try {
	          parsed = urlToOptions(new URL(input));
	        }
	        catch (err) {
	          /* istanbul ignore next */
	          parsed = url.parse(input);
	        }
	        if (!isString(parsed.protocol)) {
	          throw new InvalidUrlError({ input });
	        }
	        input = parsed;
	      }
	      else if (URL && (input instanceof URL)) {
	        input = urlToOptions(input);
	      }
	      else {
	        callback = options;
	        options = input;
	        input = { protocol: protocol };
	      }
	      if (isFunction(options)) {
	        callback = options;
	        options = null;
	      }

	      // Set defaults
	      options = Object.assign({
	        maxRedirects: exports.maxRedirects,
	        maxBodyLength: exports.maxBodyLength,
	      }, input, options);
	      options.nativeProtocols = nativeProtocols;
	      if (!isString(options.host) && !isString(options.hostname)) {
	        options.hostname = "::1";
	      }

	      assert.equal(options.protocol, protocol, "protocol mismatch");
	      debug("options", options);
	      return new RedirectableRequest(options, callback);
	    }

	    // Executes a GET request, following redirects
	    function get(input, options, callback) {
	      var wrappedRequest = wrappedProtocol.request(input, options, callback);
	      wrappedRequest.end();
	      return wrappedRequest;
	    }

	    // Expose the properties on the wrapped protocol
	    Object.defineProperties(wrappedProtocol, {
	      request: { value: request, configurable: true, enumerable: true, writable: true },
	      get: { value: get, configurable: true, enumerable: true, writable: true },
	    });
	  });
	  return exports;
	}

	/* istanbul ignore next */
	function noop() { /* empty */ }

	// from https://github.com/nodejs/node/blob/master/lib/internal/url.js
	function urlToOptions(urlObject) {
	  var options = {
	    protocol: urlObject.protocol,
	    hostname: urlObject.hostname.startsWith("[") ?
	      /* istanbul ignore next */
	      urlObject.hostname.slice(1, -1) :
	      urlObject.hostname,
	    hash: urlObject.hash,
	    search: urlObject.search,
	    pathname: urlObject.pathname,
	    path: urlObject.pathname + urlObject.search,
	    href: urlObject.href,
	  };
	  if (urlObject.port !== "") {
	    options.port = Number(urlObject.port);
	  }
	  return options;
	}

	function removeMatchingHeaders(regex, headers) {
	  var lastValue;
	  for (var header in headers) {
	    if (regex.test(header)) {
	      lastValue = headers[header];
	      delete headers[header];
	    }
	  }
	  return (lastValue === null || typeof lastValue === "undefined") ?
	    undefined : String(lastValue).trim();
	}

	function createErrorType(code, message, baseClass) {
	  // Create constructor
	  function CustomError(properties) {
	    Error.captureStackTrace(this, this.constructor);
	    Object.assign(this, properties || {});
	    this.code = code;
	    this.message = this.cause ? message + ": " + this.cause.message : message;
	  }

	  // Attach constructor and set default properties
	  CustomError.prototype = new (baseClass || Error)();
	  CustomError.prototype.constructor = CustomError;
	  CustomError.prototype.name = "Error [" + code + "]";
	  return CustomError;
	}

	function abortRequest(request) {
	  for (var event of events) {
	    request.removeListener(event, eventHandlers[event]);
	  }
	  request.on("error", noop);
	  request.abort();
	}

	function isSubdomain(subdomain, domain) {
	  assert(isString(subdomain) && isString(domain));
	  var dot = subdomain.length - domain.length - 1;
	  return dot > 0 && subdomain[dot] === "." && subdomain.endsWith(domain);
	}

	function isString(value) {
	  return typeof value === "string" || value instanceof String;
	}

	function isFunction(value) {
	  return typeof value === "function";
	}

	function isBuffer(value) {
	  return typeof value === "object" && ("length" in value);
	}

	// Exports
	followRedirects.exports = wrap({ http: http, https: https });
	followRedirects.exports.wrap = wrap;
	return followRedirects.exports;
}

var name = "axios";
var version = "0.21.1";
var description = "Promise based HTTP client for the browser and node.js";
var main = "index.js";
var scripts = {
	test: "grunt test && bundlesize",
	start: "node ./sandbox/server.js",
	build: "NODE_ENV=production grunt build",
	preversion: "npm test",
	version: "npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json",
	postversion: "git push && git push --tags",
	examples: "node ./examples/server.js",
	coveralls: "cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js",
	fix: "eslint --fix lib/**/*.js"
};
var repository = {
	type: "git",
	url: "https://github.com/axios/axios.git"
};
var keywords = [
	"xhr",
	"http",
	"ajax",
	"promise",
	"node"
];
var author = "Matt Zabriskie";
var license = "MIT";
var bugs = {
	url: "https://github.com/axios/axios/issues"
};
var homepage = "https://github.com/axios/axios";
var devDependencies = {
	bundlesize: "^0.17.0",
	coveralls: "^3.0.0",
	"es6-promise": "^4.2.4",
	grunt: "^1.0.2",
	"grunt-banner": "^0.6.0",
	"grunt-cli": "^1.2.0",
	"grunt-contrib-clean": "^1.1.0",
	"grunt-contrib-watch": "^1.0.0",
	"grunt-eslint": "^20.1.0",
	"grunt-karma": "^2.0.0",
	"grunt-mocha-test": "^0.13.3",
	"grunt-ts": "^6.0.0-beta.19",
	"grunt-webpack": "^1.0.18",
	"istanbul-instrumenter-loader": "^1.0.0",
	"jasmine-core": "^2.4.1",
	karma: "^1.3.0",
	"karma-chrome-launcher": "^2.2.0",
	"karma-coverage": "^1.1.1",
	"karma-firefox-launcher": "^1.1.0",
	"karma-jasmine": "^1.1.1",
	"karma-jasmine-ajax": "^0.1.13",
	"karma-opera-launcher": "^1.0.0",
	"karma-safari-launcher": "^1.0.0",
	"karma-sauce-launcher": "^1.2.0",
	"karma-sinon": "^1.0.5",
	"karma-sourcemap-loader": "^0.3.7",
	"karma-webpack": "^1.7.0",
	"load-grunt-tasks": "^3.5.2",
	minimist: "^1.2.0",
	mocha: "^5.2.0",
	sinon: "^4.5.0",
	typescript: "^2.8.1",
	"url-search-params": "^0.10.0",
	webpack: "^1.13.1",
	"webpack-dev-server": "^1.14.1"
};
var browser = {
	"./lib/adapters/http.js": "./lib/adapters/xhr.js"
};
var jsdelivr = "dist/axios.min.js";
var unpkg = "dist/axios.min.js";
var typings = "./index.d.ts";
var dependencies = {
	"follow-redirects": "^1.10.0"
};
var bundlesize = [
	{
		path: "./dist/axios.min.js",
		threshold: "5kB"
	}
];
var require$$9 = {
	name: name,
	version: version,
	description: description,
	main: main,
	scripts: scripts,
	repository: repository,
	keywords: keywords,
	author: author,
	license: license,
	bugs: bugs,
	homepage: homepage,
	devDependencies: devDependencies,
	browser: browser,
	jsdelivr: jsdelivr,
	unpkg: unpkg,
	typings: typings,
	dependencies: dependencies,
	bundlesize: bundlesize
};

var http_1;
var hasRequiredHttp;

function requireHttp () {
	if (hasRequiredHttp) return http_1;
	hasRequiredHttp = 1;

	var utils = utils$c;
	var settle = requireSettle();
	var buildFullPath = requireBuildFullPath();
	var buildURL = buildURL$1;
	var http = require$$1$1;
	var https = require$$2$1;
	var httpFollow = requireFollowRedirects().http;
	var httpsFollow = requireFollowRedirects().https;
	var url = requireUrl();
	var zlib = require$$8;
	var pkg = require$$9;
	var createError = requireCreateError();
	var enhanceError = requireEnhanceError();

	var isHttps = /https:?/;

	/**
	 *
	 * @param {http.ClientRequestArgs} options
	 * @param {AxiosProxyConfig} proxy
	 * @param {string} location
	 */
	function setProxy(options, proxy, location) {
	  options.hostname = proxy.host;
	  options.host = proxy.host;
	  options.port = proxy.port;
	  options.path = location;

	  // Basic proxy authorization
	  if (proxy.auth) {
	    var base64 = Buffer.from(proxy.auth.username + ':' + proxy.auth.password, 'utf8').toString('base64');
	    options.headers['Proxy-Authorization'] = 'Basic ' + base64;
	  }

	  // If a proxy is used, any redirects must also pass through the proxy
	  options.beforeRedirect = function beforeRedirect(redirection) {
	    redirection.headers.host = redirection.host;
	    setProxy(redirection, proxy, redirection.href);
	  };
	}

	/*eslint consistent-return:0*/
	http_1 = function httpAdapter(config) {
	  return new Promise(function dispatchHttpRequest(resolvePromise, rejectPromise) {
	    var resolve = function resolve(value) {
	      resolvePromise(value);
	    };
	    var reject = function reject(value) {
	      rejectPromise(value);
	    };
	    var data = config.data;
	    var headers = config.headers;

	    // Set User-Agent (required by some servers)
	    // Only set header if it hasn't been set in config
	    // See https://github.com/axios/axios/issues/69
	    if (!headers['User-Agent'] && !headers['user-agent']) {
	      headers['User-Agent'] = 'axios/' + pkg.version;
	    }

	    if (data && !utils.isStream(data)) {
	      if (Buffer.isBuffer(data)) ; else if (utils.isArrayBuffer(data)) {
	        data = Buffer.from(new Uint8Array(data));
	      } else if (utils.isString(data)) {
	        data = Buffer.from(data, 'utf-8');
	      } else {
	        return reject(createError(
	          'Data after transformation must be a string, an ArrayBuffer, a Buffer, or a Stream',
	          config
	        ));
	      }

	      // Add Content-Length header if data exists
	      headers['Content-Length'] = data.length;
	    }

	    // HTTP basic authentication
	    var auth = undefined;
	    if (config.auth) {
	      var username = config.auth.username || '';
	      var password = config.auth.password || '';
	      auth = username + ':' + password;
	    }

	    // Parse url
	    var fullPath = buildFullPath(config.baseURL, config.url);
	    var parsed = url.parse(fullPath);
	    var protocol = parsed.protocol || 'http:';

	    if (!auth && parsed.auth) {
	      var urlAuth = parsed.auth.split(':');
	      var urlUsername = urlAuth[0] || '';
	      var urlPassword = urlAuth[1] || '';
	      auth = urlUsername + ':' + urlPassword;
	    }

	    if (auth) {
	      delete headers.Authorization;
	    }

	    var isHttpsRequest = isHttps.test(protocol);
	    var agent = isHttpsRequest ? config.httpsAgent : config.httpAgent;

	    var options = {
	      path: buildURL(parsed.path, config.params, config.paramsSerializer).replace(/^\?/, ''),
	      method: config.method.toUpperCase(),
	      headers: headers,
	      agent: agent,
	      agents: { http: config.httpAgent, https: config.httpsAgent },
	      auth: auth
	    };

	    if (config.socketPath) {
	      options.socketPath = config.socketPath;
	    } else {
	      options.hostname = parsed.hostname;
	      options.port = parsed.port;
	    }

	    var proxy = config.proxy;
	    if (!proxy && proxy !== false) {
	      var proxyEnv = protocol.slice(0, -1) + '_proxy';
	      var proxyUrl = process.env[proxyEnv] || process.env[proxyEnv.toUpperCase()];
	      if (proxyUrl) {
	        var parsedProxyUrl = url.parse(proxyUrl);
	        var noProxyEnv = process.env.no_proxy || process.env.NO_PROXY;
	        var shouldProxy = true;

	        if (noProxyEnv) {
	          var noProxy = noProxyEnv.split(',').map(function trim(s) {
	            return s.trim();
	          });

	          shouldProxy = !noProxy.some(function proxyMatch(proxyElement) {
	            if (!proxyElement) {
	              return false;
	            }
	            if (proxyElement === '*') {
	              return true;
	            }
	            if (proxyElement[0] === '.' &&
	                parsed.hostname.substr(parsed.hostname.length - proxyElement.length) === proxyElement) {
	              return true;
	            }

	            return parsed.hostname === proxyElement;
	          });
	        }

	        if (shouldProxy) {
	          proxy = {
	            host: parsedProxyUrl.hostname,
	            port: parsedProxyUrl.port,
	            protocol: parsedProxyUrl.protocol
	          };

	          if (parsedProxyUrl.auth) {
	            var proxyUrlAuth = parsedProxyUrl.auth.split(':');
	            proxy.auth = {
	              username: proxyUrlAuth[0],
	              password: proxyUrlAuth[1]
	            };
	          }
	        }
	      }
	    }

	    if (proxy) {
	      options.headers.host = parsed.hostname + (parsed.port ? ':' + parsed.port : '');
	      setProxy(options, proxy, protocol + '//' + parsed.hostname + (parsed.port ? ':' + parsed.port : '') + options.path);
	    }

	    var transport;
	    var isHttpsProxy = isHttpsRequest && (proxy ? isHttps.test(proxy.protocol) : true);
	    if (config.transport) {
	      transport = config.transport;
	    } else if (config.maxRedirects === 0) {
	      transport = isHttpsProxy ? https : http;
	    } else {
	      if (config.maxRedirects) {
	        options.maxRedirects = config.maxRedirects;
	      }
	      transport = isHttpsProxy ? httpsFollow : httpFollow;
	    }

	    if (config.maxBodyLength > -1) {
	      options.maxBodyLength = config.maxBodyLength;
	    }

	    // Create the request
	    var req = transport.request(options, function handleResponse(res) {
	      if (req.aborted) return;

	      // uncompress the response body transparently if required
	      var stream = res;

	      // return the last request in case of redirects
	      var lastRequest = res.req || req;


	      // if no content, is HEAD request or decompress disabled we should not decompress
	      if (res.statusCode !== 204 && lastRequest.method !== 'HEAD' && config.decompress !== false) {
	        switch (res.headers['content-encoding']) {
	        /*eslint default-case:0*/
	        case 'gzip':
	        case 'compress':
	        case 'deflate':
	        // add the unzipper to the body stream processing pipeline
	          stream = stream.pipe(zlib.createUnzip());

	          // remove the content-encoding in order to not confuse downstream operations
	          delete res.headers['content-encoding'];
	          break;
	        }
	      }

	      var response = {
	        status: res.statusCode,
	        statusText: res.statusMessage,
	        headers: res.headers,
	        config: config,
	        request: lastRequest
	      };

	      if (config.responseType === 'stream') {
	        response.data = stream;
	        settle(resolve, reject, response);
	      } else {
	        var responseBuffer = [];
	        stream.on('data', function handleStreamData(chunk) {
	          responseBuffer.push(chunk);

	          // make sure the content length is not over the maxContentLength if specified
	          if (config.maxContentLength > -1 && Buffer.concat(responseBuffer).length > config.maxContentLength) {
	            stream.destroy();
	            reject(createError('maxContentLength size of ' + config.maxContentLength + ' exceeded',
	              config, null, lastRequest));
	          }
	        });

	        stream.on('error', function handleStreamError(err) {
	          if (req.aborted) return;
	          reject(enhanceError(err, config, null, lastRequest));
	        });

	        stream.on('end', function handleStreamEnd() {
	          var responseData = Buffer.concat(responseBuffer);
	          if (config.responseType !== 'arraybuffer') {
	            responseData = responseData.toString(config.responseEncoding);
	            if (!config.responseEncoding || config.responseEncoding === 'utf8') {
	              responseData = utils.stripBOM(responseData);
	            }
	          }

	          response.data = responseData;
	          settle(resolve, reject, response);
	        });
	      }
	    });

	    // Handle errors
	    req.on('error', function handleRequestError(err) {
	      if (req.aborted && err.code !== 'ERR_FR_TOO_MANY_REDIRECTS') return;
	      reject(enhanceError(err, config, null, req));
	    });

	    // Handle request timeout
	    if (config.timeout) {
	      // Sometime, the response will be very slow, and does not respond, the connect event will be block by event loop system.
	      // And timer callback will be fired, and abort() will be invoked before connection, then get "socket hang up" and code ECONNRESET.
	      // At this time, if we have a large number of request, nodejs will hang up some socket on background. and the number will up and up.
	      // And then these socket which be hang up will devoring CPU little by little.
	      // ClientRequest.setTimeout will be fired on the specify milliseconds, and can make sure that abort() will be fired after connect.
	      req.setTimeout(config.timeout, function handleRequestTimeout() {
	        req.abort();
	        reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED', req));
	      });
	    }

	    if (config.cancelToken) {
	      // Handle cancellation
	      config.cancelToken.promise.then(function onCanceled(cancel) {
	        if (req.aborted) return;

	        req.abort();
	        reject(cancel);
	      });
	    }

	    // Send the request
	    if (utils.isStream(data)) {
	      data.on('error', function handleStreamError(err) {
	        reject(enhanceError(err, config, null, req));
	      }).pipe(req);
	    } else {
	      req.end(data);
	    }
	  });
	};
	return http_1;
}

var utils$7 = utils$c;
var normalizeHeaderName = normalizeHeaderName$1;

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils$7.isUndefined(headers) && utils$7.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = requireXhr();
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = requireHttp();
  }
  return adapter;
}

var defaults$4 = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');
    if (utils$7.isFormData(data) ||
      utils$7.isArrayBuffer(data) ||
      utils$7.isBuffer(data) ||
      utils$7.isStream(data) ||
      utils$7.isFile(data) ||
      utils$7.isBlob(data)
    ) {
      return data;
    }
    if (utils$7.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils$7.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils$7.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults$4.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils$7.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults$4.headers[method] = {};
});

utils$7.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults$4.headers[method] = utils$7.merge(DEFAULT_CONTENT_TYPE);
});

var defaults_1 = defaults$4;

var utils$6 = utils$c;
var transformData = transformData$1;
var isCancel = requireIsCancel();
var defaults$3 = defaults_1;

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
var dispatchRequest$1 = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils$6.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils$6.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults$3.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};

var utils$5 = utils$c;

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
var mergeConfig$2 = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy', 'params'];
  var defaultToConfig2Keys = [
    'baseURL', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'timeoutMessage', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress', 'decompress',
    'maxContentLength', 'maxBodyLength', 'maxRedirects', 'transport', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath', 'responseEncoding'
  ];
  var directMergeKeys = ['validateStatus'];

  function getMergedValue(target, source) {
    if (utils$5.isPlainObject(target) && utils$5.isPlainObject(source)) {
      return utils$5.merge(target, source);
    } else if (utils$5.isPlainObject(source)) {
      return utils$5.merge({}, source);
    } else if (utils$5.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  function mergeDeepProperties(prop) {
    if (!utils$5.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (!utils$5.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  }

  utils$5.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (!utils$5.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    }
  });

  utils$5.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);

  utils$5.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (!utils$5.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    } else if (!utils$5.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });

  utils$5.forEach(directMergeKeys, function merge(prop) {
    if (prop in config2) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys)
    .concat(directMergeKeys);

  var otherKeys = Object
    .keys(config1)
    .concat(Object.keys(config2))
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils$5.forEach(otherKeys, mergeDeepProperties);

  return config;
};

var utils$4 = utils$c;
var buildURL = buildURL$1;
var InterceptorManager = InterceptorManager_1;
var dispatchRequest = dispatchRequest$1;
var mergeConfig$1 = mergeConfig$2;

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios$1(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios$1.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig$1(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

Axios$1.prototype.getUri = function getUri(config) {
  config = mergeConfig$1(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils$4.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios$1.prototype[method] = function(url, config) {
    return this.request(mergeConfig$1(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});

utils$4.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios$1.prototype[method] = function(url, data, config) {
    return this.request(mergeConfig$1(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

var Axios_1 = Axios$1;

var Cancel_1;
var hasRequiredCancel;

function requireCancel () {
	if (hasRequiredCancel) return Cancel_1;
	hasRequiredCancel = 1;

	/**
	 * A `Cancel` is an object that is thrown when an operation is canceled.
	 *
	 * @class
	 * @param {string=} message The message.
	 */
	function Cancel(message) {
	  this.message = message;
	}

	Cancel.prototype.toString = function toString() {
	  return 'Cancel' + (this.message ? ': ' + this.message : '');
	};

	Cancel.prototype.__CANCEL__ = true;

	Cancel_1 = Cancel;
	return Cancel_1;
}

var CancelToken_1;
var hasRequiredCancelToken;

function requireCancelToken () {
	if (hasRequiredCancelToken) return CancelToken_1;
	hasRequiredCancelToken = 1;

	var Cancel = requireCancel();

	/**
	 * A `CancelToken` is an object that can be used to request cancellation of an operation.
	 *
	 * @class
	 * @param {Function} executor The executor function.
	 */
	function CancelToken(executor) {
	  if (typeof executor !== 'function') {
	    throw new TypeError('executor must be a function.');
	  }

	  var resolvePromise;
	  this.promise = new Promise(function promiseExecutor(resolve) {
	    resolvePromise = resolve;
	  });

	  var token = this;
	  executor(function cancel(message) {
	    if (token.reason) {
	      // Cancellation has already been requested
	      return;
	    }

	    token.reason = new Cancel(message);
	    resolvePromise(token.reason);
	  });
	}

	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	CancelToken.prototype.throwIfRequested = function throwIfRequested() {
	  if (this.reason) {
	    throw this.reason;
	  }
	};

	/**
	 * Returns an object that contains a new `CancelToken` and a function that, when called,
	 * cancels the `CancelToken`.
	 */
	CancelToken.source = function source() {
	  var cancel;
	  var token = new CancelToken(function executor(c) {
	    cancel = c;
	  });
	  return {
	    token: token,
	    cancel: cancel
	  };
	};

	CancelToken_1 = CancelToken;
	return CancelToken_1;
}

var spread;
var hasRequiredSpread;

function requireSpread () {
	if (hasRequiredSpread) return spread;
	hasRequiredSpread = 1;

	/**
	 * Syntactic sugar for invoking a function and expanding an array for arguments.
	 *
	 * Common use case would be to use `Function.prototype.apply`.
	 *
	 *  ```js
	 *  function f(x, y, z) {}
	 *  var args = [1, 2, 3];
	 *  f.apply(null, args);
	 *  ```
	 *
	 * With `spread` this example can be re-written.
	 *
	 *  ```js
	 *  spread(function(x, y, z) {})([1, 2, 3]);
	 *  ```
	 *
	 * @param {Function} callback
	 * @returns {Function}
	 */
	spread = function spread(callback) {
	  return function wrap(arr) {
	    return callback.apply(null, arr);
	  };
	};
	return spread;
}

var isAxiosError;
var hasRequiredIsAxiosError;

function requireIsAxiosError () {
	if (hasRequiredIsAxiosError) return isAxiosError;
	hasRequiredIsAxiosError = 1;

	/**
	 * Determines whether the payload is an error thrown by Axios
	 *
	 * @param {*} payload The value to test
	 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
	 */
	isAxiosError = function isAxiosError(payload) {
	  return (typeof payload === 'object') && (payload.isAxiosError === true);
	};
	return isAxiosError;
}

var utils$3 = utils$c;
var bind$2 = bind$4;
var Axios = Axios_1;
var mergeConfig = mergeConfig$2;
var defaults$2 = defaults_1;

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind$2(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils$3.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils$3.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios$2 = createInstance(defaults$2);

// Expose Axios class to allow class inheritance
axios$2.Axios = Axios;

// Factory for creating new instances
axios$2.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios$2.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios$2.Cancel = requireCancel();
axios$2.CancelToken = requireCancelToken();
axios$2.isCancel = requireIsCancel();

// Expose all/spread
axios$2.all = function all(promises) {
  return Promise.all(promises);
};
axios$2.spread = requireSpread();

// Expose isAxiosError
axios$2.isAxiosError = requireIsAxiosError();

axios$3.exports = axios$2;

// Allow use of default import syntax in TypeScript
axios$3.exports.default = axios$2;

var axiosExports = axios$3.exports;

var axios = axiosExports;

var axios$1 = /*@__PURE__*/getDefaultExportFromCjs(axios);

var createOnFulfilled = function (jwt, tokenType, baseUrl) { return function (config) {
    if (baseUrl) {
        config.baseURL = baseUrl;
    }
    if (jwt) {
        config.headers.Authorization = "Bearer ".concat(jwt);
    }
    if (tokenType) {
        config.headers["X-Token-Type"] = tokenType;
    }
    return config;
}; };

var __spreadArray$1 = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var BrowserInfo = /** @class */ (function () {
    function BrowserInfo(name, version, os) {
        this.name = name;
        this.version = version;
        this.os = os;
        this.type = 'browser';
    }
    return BrowserInfo;
}());
var NodeInfo = /** @class */ (function () {
    function NodeInfo(version) {
        this.version = version;
        this.type = 'node';
        this.name = 'node';
        this.os = process.platform;
    }
    return NodeInfo;
}());
var SearchBotDeviceInfo = /** @class */ (function () {
    function SearchBotDeviceInfo(name, version, os, bot) {
        this.name = name;
        this.version = version;
        this.os = os;
        this.bot = bot;
        this.type = 'bot-device';
    }
    return SearchBotDeviceInfo;
}());
var BotInfo = /** @class */ (function () {
    function BotInfo() {
        this.type = 'bot';
        this.bot = true; // NOTE: deprecated test name instead
        this.name = 'bot';
        this.version = null;
        this.os = null;
    }
    return BotInfo;
}());
var ReactNativeInfo = /** @class */ (function () {
    function ReactNativeInfo() {
        this.type = 'react-native';
        this.name = 'react-native';
        this.version = null;
        this.os = null;
    }
    return ReactNativeInfo;
}());
// tslint:disable-next-line:max-line-length
var SEARCHBOX_UA_REGEX = /alexa|bot|crawl(er|ing)|facebookexternalhit|feedburner|google web preview|nagios|postrank|pingdom|slurp|spider|yahoo!|yandex/;
var SEARCHBOT_OS_REGEX = /(nuhk|curl|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask\ Jeeves\/Teoma|ia_archiver)/;
var REQUIRED_VERSION_PARTS = 3;
var userAgentRules = [
    ['aol', /AOLShield\/([0-9\._]+)/],
    ['edge', /Edge\/([0-9\._]+)/],
    ['edge-ios', /EdgiOS\/([0-9\._]+)/],
    ['yandexbrowser', /YaBrowser\/([0-9\._]+)/],
    ['kakaotalk', /KAKAOTALK\s([0-9\.]+)/],
    ['samsung', /SamsungBrowser\/([0-9\.]+)/],
    ['silk', /\bSilk\/([0-9._-]+)\b/],
    ['miui', /MiuiBrowser\/([0-9\.]+)$/],
    ['beaker', /BeakerBrowser\/([0-9\.]+)/],
    ['edge-chromium', /EdgA?\/([0-9\.]+)/],
    [
        'chromium-webview',
        /(?!Chrom.*OPR)wv\).*Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/,
    ],
    ['chrome', /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/],
    ['phantomjs', /PhantomJS\/([0-9\.]+)(:?\s|$)/],
    ['crios', /CriOS\/([0-9\.]+)(:?\s|$)/],
    ['firefox', /Firefox\/([0-9\.]+)(?:\s|$)/],
    ['fxios', /FxiOS\/([0-9\.]+)/],
    ['opera-mini', /Opera Mini.*Version\/([0-9\.]+)/],
    ['opera', /Opera\/([0-9\.]+)(?:\s|$)/],
    ['opera', /OPR\/([0-9\.]+)(:?\s|$)/],
    ['pie', /^Microsoft Pocket Internet Explorer\/(\d+\.\d+)$/],
    ['pie', /^Mozilla\/\d\.\d+\s\(compatible;\s(?:MSP?IE|MSInternet Explorer) (\d+\.\d+);.*Windows CE.*\)$/],
    ['netfront', /^Mozilla\/\d\.\d+.*NetFront\/(\d.\d)/],
    ['ie', /Trident\/7\.0.*rv\:([0-9\.]+).*\).*Gecko$/],
    ['ie', /MSIE\s([0-9\.]+);.*Trident\/[4-7].0/],
    ['ie', /MSIE\s(7\.0)/],
    ['bb10', /BB10;\sTouch.*Version\/([0-9\.]+)/],
    ['android', /Android\s([0-9\.]+)/],
    ['ios', /Version\/([0-9\._]+).*Mobile.*Safari.*/],
    ['safari', /Version\/([0-9\._]+).*Safari/],
    ['facebook', /FB[AS]V\/([0-9\.]+)/],
    ['instagram', /Instagram\s([0-9\.]+)/],
    ['ios-webview', /AppleWebKit\/([0-9\.]+).*Mobile/],
    ['ios-webview', /AppleWebKit\/([0-9\.]+).*Gecko\)$/],
    ['curl', /^curl\/([0-9\.]+)$/],
    ['searchbot', SEARCHBOX_UA_REGEX],
];
var operatingSystemRules = [
    ['iOS', /iP(hone|od|ad)/],
    ['Android OS', /Android/],
    ['BlackBerry OS', /BlackBerry|BB10/],
    ['Windows Mobile', /IEMobile/],
    ['Amazon OS', /Kindle/],
    ['Windows 3.11', /Win16/],
    ['Windows 95', /(Windows 95)|(Win95)|(Windows_95)/],
    ['Windows 98', /(Windows 98)|(Win98)/],
    ['Windows 2000', /(Windows NT 5.0)|(Windows 2000)/],
    ['Windows XP', /(Windows NT 5.1)|(Windows XP)/],
    ['Windows Server 2003', /(Windows NT 5.2)/],
    ['Windows Vista', /(Windows NT 6.0)/],
    ['Windows 7', /(Windows NT 6.1)/],
    ['Windows 8', /(Windows NT 6.2)/],
    ['Windows 8.1', /(Windows NT 6.3)/],
    ['Windows 10', /(Windows NT 10.0)/],
    ['Windows ME', /Windows ME/],
    ['Windows CE', /Windows CE|WinCE|Microsoft Pocket Internet Explorer/],
    ['Open BSD', /OpenBSD/],
    ['Sun OS', /SunOS/],
    ['Chrome OS', /CrOS/],
    ['Linux', /(Linux)|(X11)/],
    ['Mac OS', /(Mac_PowerPC)|(Macintosh)/],
    ['QNX', /QNX/],
    ['BeOS', /BeOS/],
    ['OS/2', /OS\/2/],
];
function detect(userAgent) {
    if (!!userAgent) {
        return parseUserAgent(userAgent);
    }
    if (typeof document === 'undefined' &&
        typeof navigator !== 'undefined' &&
        navigator.product === 'ReactNative') {
        return new ReactNativeInfo();
    }
    if (typeof navigator !== 'undefined') {
        return parseUserAgent(navigator.userAgent);
    }
    return getNodeVersion();
}
function matchUserAgent(ua) {
    // opted for using reduce here rather than Array#first with a regex.test call
    // this is primarily because using the reduce we only perform the regex
    // execution once rather than once for the test and for the exec again below
    // probably something that needs to be benchmarked though
    return (ua !== '' &&
        userAgentRules.reduce(function (matched, _a) {
            var browser = _a[0], regex = _a[1];
            if (matched) {
                return matched;
            }
            var uaMatch = regex.exec(ua);
            return !!uaMatch && [browser, uaMatch];
        }, false));
}
function parseUserAgent(ua) {
    var matchedRule = matchUserAgent(ua);
    if (!matchedRule) {
        return null;
    }
    var name = matchedRule[0], match = matchedRule[1];
    if (name === 'searchbot') {
        return new BotInfo();
    }
    // Do not use RegExp for split operation as some browser do not support it (See: http://blog.stevenlevithan.com/archives/cross-browser-split)
    var versionParts = match[1] && match[1].split('.').join('_').split('_').slice(0, 3);
    if (versionParts) {
        if (versionParts.length < REQUIRED_VERSION_PARTS) {
            versionParts = __spreadArray$1(__spreadArray$1([], versionParts, true), createVersionParts(REQUIRED_VERSION_PARTS - versionParts.length), true);
        }
    }
    else {
        versionParts = [];
    }
    var version = versionParts.join('.');
    var os = detectOS(ua);
    var searchBotMatch = SEARCHBOT_OS_REGEX.exec(ua);
    if (searchBotMatch && searchBotMatch[1]) {
        return new SearchBotDeviceInfo(name, version, os, searchBotMatch[1]);
    }
    return new BrowserInfo(name, version, os);
}
function detectOS(ua) {
    for (var ii = 0, count = operatingSystemRules.length; ii < count; ii++) {
        var _a = operatingSystemRules[ii], os = _a[0], regex = _a[1];
        var match = regex.exec(ua);
        if (match) {
            return os;
        }
    }
    return null;
}
function getNodeVersion() {
    var isNode = typeof process !== 'undefined' && process.version;
    return isNode ? new NodeInfo(process.version.slice(1)) : null;
}
function createVersionParts(count) {
    var output = [];
    for (var ii = 0; ii < count; ii++) {
        output.push('0');
    }
    return output;
}

var exceedLiveview = function () {
    var _a, _b;
    var browser = detect();
    if ((browser === null || browser === void 0 ? void 0 : browser.name) === "ios-webview") {
        //@ts-ignore
        return webkit.messageHandlers.exceedLiveview.postMessage({});
    }
    if ((browser === null || browser === void 0 ? void 0 : browser.name) === "chromium-webview") {
        //@ts-ignore
        (_b = (_a = window.Webviewer) === null || _a === void 0 ? void 0 : _a.exceedLiveview) === null || _b === void 0 ? void 0 : _b.call(_a);
    }
};
var sendMessageBack = function (reason) {
    var _a;
    var browser = detect();
    if ((browser === null || browser === void 0 ? void 0 : browser.name) === "ios-webview") {
        //@ts-ignore
        return webkit.messageHandlers.back.postMessage({ reason: reason });
    }
    if ((browser === null || browser === void 0 ? void 0 : browser.name) === "chromium-webview") {
        //@ts-ignore
        (_a = window.Webviewer) === null || _a === void 0 ? void 0 : _a.back(JSON.stringify({ reason: reason }));
    }
};
var hideGNB = function () {
    var _a, _b, _c, _d;
    console.log("Eventmap", "hideGNB");
    var browserName = (_a = detect()) === null || _a === void 0 ? void 0 : _a.name;
    if (browserName === "ios-webview" &&
        //@ts-ignore
        webkit.messageHandlers.hideGNB) {
        //@ts-ignore
        webkit.messageHandlers.hideGNB.postMessage({});
    }
    if (browserName === "chromium-webview" &&
        (
        //@ts-ignore
        (_b = window.Webviewer) === null || _b === void 0 ? void 0 : _b.hideGNB)) {
        //@ts-ignore
        (_d = (_c = window.Webviewer) === null || _c === void 0 ? void 0 : _c.hideGNB) === null || _d === void 0 ? void 0 : _d.call(_c);
    }
};
var showGNB = function () {
    var _a, _b, _c, _d;
    console.log("Eventmap", "showGNB");
    var browserName = (_a = detect()) === null || _a === void 0 ? void 0 : _a.name;
    if (browserName === "ios-webview" &&
        //@ts-ignore
        webkit.messageHandlers.showGNB) {
        //@ts-ignore
        webkit.messageHandlers.showGNB.postMessage({});
    }
    if (browserName === "chromium-webview" &&
        (
        //@ts-ignore
        (_b = window.Webviewer) === null || _b === void 0 ? void 0 : _b.showGNB)) {
        //@ts-ignore
        (_d = (_c = window.Webviewer) === null || _c === void 0 ? void 0 : _c.showGNB) === null || _d === void 0 ? void 0 : _d.call(_c);
    }
};
var changePortrait = function () {
    var _a, _b, _c, _d;
    var browserName = (_a = detect()) === null || _a === void 0 ? void 0 : _a.name;
    if (browserName === "ios-webview" &&
        //@ts-ignore
        webkit.messageHandlers.changePortrait) {
        //@ts-ignore
        webkit.messageHandlers.changePortrait.postMessage({});
    }
    if (browserName === "chromium-webview" &&
        (
        //@ts-ignore
        (_b = window.Webviewer) === null || _b === void 0 ? void 0 : _b.changePortrait)) {
        //@ts-ignore
        (_d = (_c = window.Webviewer) === null || _c === void 0 ? void 0 : _c.changePortrait) === null || _d === void 0 ? void 0 : _d.call(_c);
    }
};
var changeLandscape = function () {
    var _a, _b, _c, _d;
    var browserName = (_a = detect()) === null || _a === void 0 ? void 0 : _a.name;
    if (browserName === "ios-webview" &&
        //@ts-ignore
        webkit.messageHandlers.changeLandscape) {
        //@ts-ignore
        webkit.messageHandlers.changeLandscape.postMessage({});
    }
    if (browserName === "chromium-webview" &&
        (
        //@ts-ignore
        (_b = window.Webviewer) === null || _b === void 0 ? void 0 : _b.changeLandscape)) {
        //@ts-ignore
        (_d = (_c = window.Webviewer) === null || _c === void 0 ? void 0 : _c.changeLandscape) === null || _d === void 0 ? void 0 : _d.call(_c);
    }
};
var enableRotate = function () {
    var _a, _b, _c, _d;
    var browserName = (_a = detect()) === null || _a === void 0 ? void 0 : _a.name;
    if (browserName === "ios-webview" &&
        //@ts-ignore
        webkit.messageHandlers.enableRotate) {
        //@ts-ignore
        webkit.messageHandlers.enableRotate.postMessage({});
    }
    if (browserName === "chromium-webview" &&
        (
        //@ts-ignore
        (_b = window.Webviewer) === null || _b === void 0 ? void 0 : _b.enableRotate)) {
        //@ts-ignore
        (_d = (_c = window.Webviewer) === null || _c === void 0 ? void 0 : _c.enableRotate) === null || _d === void 0 ? void 0 : _d.call(_c);
    }
};
var disableRotate = function () {
    var _a, _b, _c, _d;
    var browserName = (_a = detect()) === null || _a === void 0 ? void 0 : _a.name;
    if (browserName === "ios-webview" &&
        //@ts-ignore
        webkit.messageHandlers.disableRotate) {
        //@ts-ignore
        webkit.messageHandlers.disableRotate.postMessage({});
    }
    if (browserName === "chromium-webview" &&
        (
        //@ts-ignore
        (_b = window.Webviewer) === null || _b === void 0 ? void 0 : _b.disableRotate)) {
        //@ts-ignore
        (_d = (_c = window.Webviewer) === null || _c === void 0 ? void 0 : _c.disableRotate) === null || _d === void 0 ? void 0 : _d.call(_c);
    }
};

var lodash = {exports: {}};

/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
lodash.exports;

(function (module, exports) {
(function() {

	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined$1;

	  /** Used as the semantic version number. */
	  var VERSION = '4.17.21';

	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;

	  /** Error message constants. */
	  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
	      FUNC_ERROR_TEXT = 'Expected a function',
	      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';

	  /** Used to stand-in for `undefined` hash values. */
	  var HASH_UNDEFINED = '__lodash_hash_undefined__';

	  /** Used as the maximum memoize cache size. */
	  var MAX_MEMOIZE_SIZE = 500;

	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';

	  /** Used to compose bitmasks for cloning. */
	  var CLONE_DEEP_FLAG = 1,
	      CLONE_FLAT_FLAG = 2,
	      CLONE_SYMBOLS_FLAG = 4;

	  /** Used to compose bitmasks for value comparisons. */
	  var COMPARE_PARTIAL_FLAG = 1,
	      COMPARE_UNORDERED_FLAG = 2;

	  /** Used to compose bitmasks for function metadata. */
	  var WRAP_BIND_FLAG = 1,
	      WRAP_BIND_KEY_FLAG = 2,
	      WRAP_CURRY_BOUND_FLAG = 4,
	      WRAP_CURRY_FLAG = 8,
	      WRAP_CURRY_RIGHT_FLAG = 16,
	      WRAP_PARTIAL_FLAG = 32,
	      WRAP_PARTIAL_RIGHT_FLAG = 64,
	      WRAP_ARY_FLAG = 128,
	      WRAP_REARG_FLAG = 256,
	      WRAP_FLIP_FLAG = 512;

	  /** Used as default options for `_.truncate`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';

	  /** Used to detect hot functions by number of calls within a span of milliseconds. */
	  var HOT_COUNT = 800,
	      HOT_SPAN = 16;

	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2,
	      LAZY_WHILE_FLAG = 3;

	  /** Used as references for various `Number` constants. */
	  var INFINITY = 1 / 0,
	      MAX_SAFE_INTEGER = 9007199254740991,
	      MAX_INTEGER = 1.7976931348623157e+308,
	      NAN = 0 / 0;

	  /** Used as references for the maximum length and index of an array. */
	  var MAX_ARRAY_LENGTH = 4294967295,
	      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

	  /** Used to associate wrap methods with their bit flags. */
	  var wrapFlags = [
	    ['ary', WRAP_ARY_FLAG],
	    ['bind', WRAP_BIND_FLAG],
	    ['bindKey', WRAP_BIND_KEY_FLAG],
	    ['curry', WRAP_CURRY_FLAG],
	    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
	    ['flip', WRAP_FLIP_FLAG],
	    ['partial', WRAP_PARTIAL_FLAG],
	    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
	    ['rearg', WRAP_REARG_FLAG]
	  ];

	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      asyncTag = '[object AsyncFunction]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      domExcTag = '[object DOMException]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      genTag = '[object GeneratorFunction]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      nullTag = '[object Null]',
	      objectTag = '[object Object]',
	      promiseTag = '[object Promise]',
	      proxyTag = '[object Proxy]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      symbolTag = '[object Symbol]',
	      undefinedTag = '[object Undefined]',
	      weakMapTag = '[object WeakMap]',
	      weakSetTag = '[object WeakSet]';

	  var arrayBufferTag = '[object ArrayBuffer]',
	      dataViewTag = '[object DataView]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';

	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
	      reUnescapedHtml = /[&<>"']/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;

	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

	  /**
	   * Used to match `RegExp`
	   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	   */
	  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
	      reHasRegExpChar = RegExp(reRegExpChar.source);

	  /** Used to match leading whitespace. */
	  var reTrimStart = /^\s+/;

	  /** Used to match a single whitespace character. */
	  var reWhitespace = /\s/;

	  /** Used to match wrap detail comments. */
	  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
	      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	      reSplitDetails = /,? & /;

	  /** Used to match words composed of alphanumeric characters. */
	  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

	  /**
	   * Used to validate the `validate` option in `_.template` variable.
	   *
	   * Forbids characters which could potentially change the meaning of the function argument definition:
	   * - "()," (modification of function parameters)
	   * - "=" (default value)
	   * - "[]{}" (destructuring of function parameters)
	   * - "/" (beginning of a comment)
	   * - whitespace
	   */
	  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;

	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;

	  /**
	   * Used to match
	   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
	   */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;

	  /** Used to detect bad signed hexadecimal string values. */
	  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

	  /** Used to detect binary string values. */
	  var reIsBinary = /^0b[01]+$/i;

	  /** Used to detect host constructors (Safari). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;

	  /** Used to detect octal string values. */
	  var reIsOctal = /^0o[0-7]+$/i;

	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^(?:0|[1-9]\d*)$/;

	  /** Used to match Latin Unicode letters (excluding mathematical operators). */
	  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;

	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

	  /** Used to compose unicode character classes. */
	  var rsAstralRange = '\\ud800-\\udfff',
	      rsComboMarksRange = '\\u0300-\\u036f',
	      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	      rsComboSymbolsRange = '\\u20d0-\\u20ff',
	      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	      rsDingbatRange = '\\u2700-\\u27bf',
	      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	      rsPunctuationRange = '\\u2000-\\u206f',
	      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	      rsVarRange = '\\ufe0e\\ufe0f',
	      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

	  /** Used to compose unicode capture groups. */
	  var rsApos = "['\u2019]",
	      rsAstral = '[' + rsAstralRange + ']',
	      rsBreak = '[' + rsBreakRange + ']',
	      rsCombo = '[' + rsComboRange + ']',
	      rsDigits = '\\d+',
	      rsDingbat = '[' + rsDingbatRange + ']',
	      rsLower = '[' + rsLowerRange + ']',
	      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	      rsFitz = '\\ud83c[\\udffb-\\udfff]',
	      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	      rsNonAstral = '[^' + rsAstralRange + ']',
	      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	      rsUpper = '[' + rsUpperRange + ']',
	      rsZWJ = '\\u200d';

	  /** Used to compose unicode regexes. */
	  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
	      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
	      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	      reOptMod = rsModifier + '?',
	      rsOptVar = '[' + rsVarRange + ']?',
	      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
	      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
	      rsSeq = rsOptVar + reOptMod + rsOptJoin,
	      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
	      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

	  /** Used to match apostrophes. */
	  var reApos = RegExp(rsApos, 'g');

	  /**
	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	   */
	  var reComboMark = RegExp(rsCombo, 'g');

	  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

	  /** Used to match complex or compound words. */
	  var reUnicodeWord = RegExp([
	    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
	    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
	    rsUpper + '+' + rsOptContrUpper,
	    rsOrdUpper,
	    rsOrdLower,
	    rsDigits,
	    rsEmoji
	  ].join('|'), 'g');

	  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

	  /** Used to detect strings that need a more robust regexp to match words. */
	  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
	    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
	    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
	  ];

	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;

	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	  typedArrayTags[setTag] = typedArrayTags[stringTag] =
	  typedArrayTags[weakMapTag] = false;

	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	  cloneableTags[boolTag] = cloneableTags[dateTag] =
	  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	  cloneableTags[int32Tag] = cloneableTags[mapTag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[setTag] =
	  cloneableTags[stringTag] = cloneableTags[symbolTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[weakMapTag] = false;

	  /** Used to map Latin Unicode letters to basic Latin letters. */
	  var deburredLetters = {
	    // Latin-1 Supplement block.
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss',
	    // Latin Extended-A block.
	    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	    '\u0134': 'J',  '\u0135': 'j',
	    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	    '\u0174': 'W',  '\u0175': 'w',
	    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	    '\u0132': 'IJ', '\u0133': 'ij',
	    '\u0152': 'Oe', '\u0153': 'oe',
	    '\u0149': "'n", '\u017f': 's'
	  };

	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;'
	  };

	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'"
	  };

	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };

	  /** Built-in method references without a dependency on `root`. */
	  var freeParseFloat = parseFloat,
	      freeParseInt = parseInt;

	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

	  /** Detect free variable `self`. */
	  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

	  /** Used as a reference to the global object. */
	  var root = freeGlobal || freeSelf || Function('return this')();

	  /** Detect free variable `exports`. */
	  var freeExports = exports && !exports.nodeType && exports;

	  /** Detect free variable `module`. */
	  var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports;

	  /** Detect free variable `process` from Node.js. */
	  var freeProcess = moduleExports && freeGlobal.process;

	  /** Used to access faster Node.js helpers. */
	  var nodeUtil = (function() {
	    try {
	      // Use `util.types` for Node.js 10+.
	      var types = freeModule && freeModule.require && freeModule.require('util').types;

	      if (types) {
	        return types;
	      }

	      // Legacy `process.binding('util')` for Node.js < 10.
	      return freeProcess && freeProcess.binding && freeProcess.binding('util');
	    } catch (e) {}
	  }());

	  /* Node.js helper references. */
	  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
	      nodeIsDate = nodeUtil && nodeUtil.isDate,
	      nodeIsMap = nodeUtil && nodeUtil.isMap,
	      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
	      nodeIsSet = nodeUtil && nodeUtil.isSet,
	      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

	  /*--------------------------------------------------------------------------*/

	  /**
	   * A faster alternative to `Function#apply`, this function invokes `func`
	   * with the `this` binding of `thisArg` and the arguments of `args`.
	   *
	   * @private
	   * @param {Function} func The function to invoke.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {Array} args The arguments to invoke `func` with.
	   * @returns {*} Returns the result of `func`.
	   */
	  function apply(func, thisArg, args) {
	    switch (args.length) {
	      case 0: return func.call(thisArg);
	      case 1: return func.call(thisArg, args[0]);
	      case 2: return func.call(thisArg, args[0], args[1]);
	      case 3: return func.call(thisArg, args[0], args[1], args[2]);
	    }
	    return func.apply(thisArg, args);
	  }

	  /**
	   * A specialized version of `baseAggregator` for arrays.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} setter The function to set `accumulator` values.
	   * @param {Function} iteratee The iteratee to transform keys.
	   * @param {Object} accumulator The initial aggregated object.
	   * @returns {Function} Returns `accumulator`.
	   */
	  function arrayAggregator(array, setter, iteratee, accumulator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;

	    while (++index < length) {
	      var value = array[index];
	      setter(accumulator, value, iteratee(value), array);
	    }
	    return accumulator;
	  }

	  /**
	   * A specialized version of `_.forEach` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEach(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length;

	    while (++index < length) {
	      if (iteratee(array[index], index, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }

	  /**
	   * A specialized version of `_.forEachRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEachRight(array, iteratee) {
	    var length = array == null ? 0 : array.length;

	    while (length--) {
	      if (iteratee(array[length], length, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }

	  /**
	   * A specialized version of `_.every` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if all elements pass the predicate check,
	   *  else `false`.
	   */
	  function arrayEvery(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;

	    while (++index < length) {
	      if (!predicate(array[index], index, array)) {
	        return false;
	      }
	    }
	    return true;
	  }

	  /**
	   * A specialized version of `_.filter` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {Array} Returns the new filtered array.
	   */
	  function arrayFilter(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        resIndex = 0,
	        result = [];

	    while (++index < length) {
	      var value = array[index];
	      if (predicate(value, index, array)) {
	        result[resIndex++] = value;
	      }
	    }
	    return result;
	  }

	  /**
	   * A specialized version of `_.includes` for arrays without support for
	   * specifying an index to search from.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludes(array, value) {
	    var length = array == null ? 0 : array.length;
	    return !!length && baseIndexOf(array, value, 0) > -1;
	  }

	  /**
	   * This function is like `arrayIncludes` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludesWith(array, value, comparator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;

	    while (++index < length) {
	      if (comparator(value, array[index])) {
	        return true;
	      }
	    }
	    return false;
	  }

	  /**
	   * A specialized version of `_.map` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */
	  function arrayMap(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        result = Array(length);

	    while (++index < length) {
	      result[index] = iteratee(array[index], index, array);
	    }
	    return result;
	  }

	  /**
	   * Appends the elements of `values` to `array`.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {Array} values The values to append.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayPush(array, values) {
	    var index = -1,
	        length = values.length,
	        offset = array.length;

	    while (++index < length) {
	      array[offset + index] = values[index];
	    }
	    return array;
	  }

	  /**
	   * A specialized version of `_.reduce` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the first element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduce(array, iteratee, accumulator, initAccum) {
	    var index = -1,
	        length = array == null ? 0 : array.length;

	    if (initAccum && length) {
	      accumulator = array[++index];
	    }
	    while (++index < length) {
	      accumulator = iteratee(accumulator, array[index], index, array);
	    }
	    return accumulator;
	  }

	  /**
	   * A specialized version of `_.reduceRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the last element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
	    var length = array == null ? 0 : array.length;
	    if (initAccum && length) {
	      accumulator = array[--length];
	    }
	    while (length--) {
	      accumulator = iteratee(accumulator, array[length], length, array);
	    }
	    return accumulator;
	  }

	  /**
	   * A specialized version of `_.some` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if any element passes the predicate check,
	   *  else `false`.
	   */
	  function arraySome(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;

	    while (++index < length) {
	      if (predicate(array[index], index, array)) {
	        return true;
	      }
	    }
	    return false;
	  }

	  /**
	   * Gets the size of an ASCII `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  var asciiSize = baseProperty('length');

	  /**
	   * Converts an ASCII `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function asciiToArray(string) {
	    return string.split('');
	  }

	  /**
	   * Splits an ASCII `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function asciiWords(string) {
	    return string.match(reAsciiWord) || [];
	  }

	  /**
	   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
	   * without support for iteratee shorthands, which iterates over `collection`
	   * using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the found element or its key, else `undefined`.
	   */
	  function baseFindKey(collection, predicate, eachFunc) {
	    var result;
	    eachFunc(collection, function(value, key, collection) {
	      if (predicate(value, key, collection)) {
	        result = key;
	        return false;
	      }
	    });
	    return result;
	  }

	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 1 : -1);

	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }

	  /**
	   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    return value === value
	      ? strictIndexOf(array, value, fromIndex)
	      : baseFindIndex(array, baseIsNaN, fromIndex);
	  }

	  /**
	   * This function is like `baseIndexOf` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOfWith(array, value, fromIndex, comparator) {
	    var index = fromIndex - 1,
	        length = array.length;

	    while (++index < length) {
	      if (comparator(array[index], value)) {
	        return index;
	      }
	    }
	    return -1;
	  }

	  /**
	   * The base implementation of `_.isNaN` without support for number objects.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	   */
	  function baseIsNaN(value) {
	    return value !== value;
	  }

	  /**
	   * The base implementation of `_.mean` and `_.meanBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the mean.
	   */
	  function baseMean(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	    return length ? (baseSum(array, iteratee) / length) : NAN;
	  }

	  /**
	   * The base implementation of `_.property` without support for deep paths.
	   *
	   * @private
	   * @param {string} key The key of the property to get.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function baseProperty(key) {
	    return function(object) {
	      return object == null ? undefined$1 : object[key];
	    };
	  }

	  /**
	   * The base implementation of `_.propertyOf` without support for deep paths.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function basePropertyOf(object) {
	    return function(key) {
	      return object == null ? undefined$1 : object[key];
	    };
	  }

	  /**
	   * The base implementation of `_.reduce` and `_.reduceRight`, without support
	   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} accumulator The initial value.
	   * @param {boolean} initAccum Specify using the first or last element of
	   *  `collection` as the initial value.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the accumulated value.
	   */
	  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	    eachFunc(collection, function(value, index, collection) {
	      accumulator = initAccum
	        ? (initAccum = false, value)
	        : iteratee(accumulator, value, index, collection);
	    });
	    return accumulator;
	  }

	  /**
	   * The base implementation of `_.sortBy` which uses `comparer` to define the
	   * sort order of `array` and replaces criteria objects with their corresponding
	   * values.
	   *
	   * @private
	   * @param {Array} array The array to sort.
	   * @param {Function} comparer The function to define sort order.
	   * @returns {Array} Returns `array`.
	   */
	  function baseSortBy(array, comparer) {
	    var length = array.length;

	    array.sort(comparer);
	    while (length--) {
	      array[length] = array[length].value;
	    }
	    return array;
	  }

	  /**
	   * The base implementation of `_.sum` and `_.sumBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the sum.
	   */
	  function baseSum(array, iteratee) {
	    var result,
	        index = -1,
	        length = array.length;

	    while (++index < length) {
	      var current = iteratee(array[index]);
	      if (current !== undefined$1) {
	        result = result === undefined$1 ? current : (result + current);
	      }
	    }
	    return result;
	  }

	  /**
	   * The base implementation of `_.times` without support for iteratee shorthands
	   * or max array length checks.
	   *
	   * @private
	   * @param {number} n The number of times to invoke `iteratee`.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the array of results.
	   */
	  function baseTimes(n, iteratee) {
	    var index = -1,
	        result = Array(n);

	    while (++index < n) {
	      result[index] = iteratee(index);
	    }
	    return result;
	  }

	  /**
	   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	   * of key-value pairs for `object` corresponding to the property names of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the key-value pairs.
	   */
	  function baseToPairs(object, props) {
	    return arrayMap(props, function(key) {
	      return [key, object[key]];
	    });
	  }

	  /**
	   * The base implementation of `_.trim`.
	   *
	   * @private
	   * @param {string} string The string to trim.
	   * @returns {string} Returns the trimmed string.
	   */
	  function baseTrim(string) {
	    return string
	      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
	      : string;
	  }

	  /**
	   * The base implementation of `_.unary` without support for storing metadata.
	   *
	   * @private
	   * @param {Function} func The function to cap arguments for.
	   * @returns {Function} Returns the new capped function.
	   */
	  function baseUnary(func) {
	    return function(value) {
	      return func(value);
	    };
	  }

	  /**
	   * The base implementation of `_.values` and `_.valuesIn` which creates an
	   * array of `object` property values corresponding to the property names
	   * of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the array of property values.
	   */
	  function baseValues(object, props) {
	    return arrayMap(props, function(key) {
	      return object[key];
	    });
	  }

	  /**
	   * Checks if a `cache` value for `key` exists.
	   *
	   * @private
	   * @param {Object} cache The cache to query.
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */
	  function cacheHas(cache, key) {
	    return cache.has(key);
	  }

	  /**
	   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the first unmatched string symbol.
	   */
	  function charsStartIndex(strSymbols, chrSymbols) {
	    var index = -1,
	        length = strSymbols.length;

	    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }

	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the last unmatched string symbol.
	   */
	  function charsEndIndex(strSymbols, chrSymbols) {
	    var index = strSymbols.length;

	    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }

	  /**
	   * Gets the number of `placeholder` occurrences in `array`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} placeholder The placeholder to search for.
	   * @returns {number} Returns the placeholder count.
	   */
	  function countHolders(array, placeholder) {
	    var length = array.length,
	        result = 0;

	    while (length--) {
	      if (array[length] === placeholder) {
	        ++result;
	      }
	    }
	    return result;
	  }

	  /**
	   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	   * letters to basic Latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  var deburrLetter = basePropertyOf(deburredLetters);

	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  var escapeHtmlChar = basePropertyOf(htmlEscapes);

	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }

	  /**
	   * Gets the value at `key` of `object`.
	   *
	   * @private
	   * @param {Object} [object] The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */
	  function getValue(object, key) {
	    return object == null ? undefined$1 : object[key];
	  }

	  /**
	   * Checks if `string` contains Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	   */
	  function hasUnicode(string) {
	    return reHasUnicode.test(string);
	  }

	  /**
	   * Checks if `string` contains a word composed of Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a word is found, else `false`.
	   */
	  function hasUnicodeWord(string) {
	    return reHasUnicodeWord.test(string);
	  }

	  /**
	   * Converts `iterator` to an array.
	   *
	   * @private
	   * @param {Object} iterator The iterator to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function iteratorToArray(iterator) {
	    var data,
	        result = [];

	    while (!(data = iterator.next()).done) {
	      result.push(data.value);
	    }
	    return result;
	  }

	  /**
	   * Converts `map` to its key-value pairs.
	   *
	   * @private
	   * @param {Object} map The map to convert.
	   * @returns {Array} Returns the key-value pairs.
	   */
	  function mapToArray(map) {
	    var index = -1,
	        result = Array(map.size);

	    map.forEach(function(value, key) {
	      result[++index] = [key, value];
	    });
	    return result;
	  }

	  /**
	   * Creates a unary function that invokes `func` with its argument transformed.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {Function} transform The argument transform.
	   * @returns {Function} Returns the new function.
	   */
	  function overArg(func, transform) {
	    return function(arg) {
	      return func(transform(arg));
	    };
	  }

	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = 0,
	        result = [];

	    while (++index < length) {
	      var value = array[index];
	      if (value === placeholder || value === PLACEHOLDER) {
	        array[index] = PLACEHOLDER;
	        result[resIndex++] = index;
	      }
	    }
	    return result;
	  }

	  /**
	   * Converts `set` to an array of its values.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the values.
	   */
	  function setToArray(set) {
	    var index = -1,
	        result = Array(set.size);

	    set.forEach(function(value) {
	      result[++index] = value;
	    });
	    return result;
	  }

	  /**
	   * Converts `set` to its value-value pairs.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the value-value pairs.
	   */
	  function setToPairs(set) {
	    var index = -1,
	        result = Array(set.size);

	    set.forEach(function(value) {
	      result[++index] = [value, value];
	    });
	    return result;
	  }

	  /**
	   * A specialized version of `_.indexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictIndexOf(array, value, fromIndex) {
	    var index = fromIndex - 1,
	        length = array.length;

	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }

	  /**
	   * A specialized version of `_.lastIndexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictLastIndexOf(array, value, fromIndex) {
	    var index = fromIndex + 1;
	    while (index--) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return index;
	  }

	  /**
	   * Gets the number of symbols in `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the string size.
	   */
	  function stringSize(string) {
	    return hasUnicode(string)
	      ? unicodeSize(string)
	      : asciiSize(string);
	  }

	  /**
	   * Converts `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function stringToArray(string) {
	    return hasUnicode(string)
	      ? unicodeToArray(string)
	      : asciiToArray(string);
	  }

	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
	   * character of `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the index of the last non-whitespace character.
	   */
	  function trimmedEndIndex(string) {
	    var index = string.length;

	    while (index-- && reWhitespace.test(string.charAt(index))) {}
	    return index;
	  }

	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

	  /**
	   * Gets the size of a Unicode `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  function unicodeSize(string) {
	    var result = reUnicode.lastIndex = 0;
	    while (reUnicode.test(string)) {
	      ++result;
	    }
	    return result;
	  }

	  /**
	   * Converts a Unicode `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function unicodeToArray(string) {
	    return string.match(reUnicode) || [];
	  }

	  /**
	   * Splits a Unicode `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function unicodeWords(string) {
	    return string.match(reUnicodeWord) || [];
	  }

	  /*--------------------------------------------------------------------------*/

	  /**
	   * Create a new pristine `lodash` function using the `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 1.1.0
	   * @category Util
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // Create a suped-up `defer` in Node.js.
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  var runInContext = (function runInContext(context) {
	    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

	    /** Built-in constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;

	    /** Used for built-in method references. */
	    var arrayProto = Array.prototype,
	        funcProto = Function.prototype,
	        objectProto = Object.prototype;

	    /** Used to detect overreaching core-js shims. */
	    var coreJsData = context['__core-js_shared__'];

	    /** Used to resolve the decompiled source of functions. */
	    var funcToString = funcProto.toString;

	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;

	    /** Used to generate unique IDs. */
	    var idCounter = 0;

	    /** Used to detect methods masquerading as native. */
	    var maskSrcKey = (function() {
	      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	      return uid ? ('Symbol(src)_1.' + uid) : '';
	    }());

	    /**
	     * Used to resolve the
	     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var nativeObjectToString = objectProto.toString;

	    /** Used to infer the `Object` constructor. */
	    var objectCtorString = funcToString.call(Object);

	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;

	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );

	    /** Built-in value references. */
	    var Buffer = moduleExports ? context.Buffer : undefined$1,
	        Symbol = context.Symbol,
	        Uint8Array = context.Uint8Array,
	        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined$1,
	        getPrototype = overArg(Object.getPrototypeOf, Object),
	        objectCreate = Object.create,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        splice = arrayProto.splice,
	        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined$1,
	        symIterator = Symbol ? Symbol.iterator : undefined$1,
	        symToStringTag = Symbol ? Symbol.toStringTag : undefined$1;

	    var defineProperty = (function() {
	      try {
	        var func = getNative(Object, 'defineProperty');
	        func({}, '', {});
	        return func;
	      } catch (e) {}
	    }());

	    /** Mocked built-ins. */
	    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
	        ctxNow = Date && Date.now !== root.Date.now && Date.now,
	        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

	    /* Built-in method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeFloor = Math.floor,
	        nativeGetSymbols = Object.getOwnPropertySymbols,
	        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined$1,
	        nativeIsFinite = context.isFinite,
	        nativeJoin = arrayProto.join,
	        nativeKeys = overArg(Object.keys, Object),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = Date.now,
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random,
	        nativeReverse = arrayProto.reverse;

	    /* Built-in method references that are verified to be native. */
	    var DataView = getNative(context, 'DataView'),
	        Map = getNative(context, 'Map'),
	        Promise = getNative(context, 'Promise'),
	        Set = getNative(context, 'Set'),
	        WeakMap = getNative(context, 'WeakMap'),
	        nativeCreate = getNative(Object, 'create');

	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;

	    /** Used to lookup unminified function names. */
	    var realNames = {};

	    /** Used to detect maps, sets, and weakmaps. */
	    var dataViewCtorString = toSource(DataView),
	        mapCtorString = toSource(Map),
	        promiseCtorString = toSource(Promise),
	        setCtorString = toSource(Set),
	        weakMapCtorString = toSource(WeakMap);

	    /** Used to convert symbols to primitives and strings. */
	    var symbolProto = Symbol ? Symbol.prototype : undefined$1,
	        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined$1,
	        symbolToString = symbolProto ? symbolProto.toString : undefined$1;

	    /*------------------------------------------------------------------------*/

	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit method
	     * chain sequences. Methods that operate on and return arrays, collections,
	     * and functions can be chained together. Methods that retrieve a single value
	     * or may return a primitive value will automatically end the chain sequence
	     * and return the unwrapped value. Otherwise, the value must be unwrapped
	     * with `_#value`.
	     *
	     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	     * enabled using `_.chain`.
	     *
	     * The execution of chained methods is lazy, that is, it's deferred until
	     * `_#value` is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion.
	     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	     * the creation of intermediate arrays and can greatly reduce the number of
	     * iteratee executions. Sections of a chain sequence qualify for shortcut
	     * fusion if the section is applied to an array and iteratees accept only
	     * one argument. The heuristic for whether a section qualifies for shortcut
	     * fusion is subject to change.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	     * `zipObject`, `zipObjectDeep`, and `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	     * `upperFirst`, `value`, and `words`
	     *
	     * @name _
	     * @constructor
	     * @category Seq
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // Returns an unwrapped value.
	     * wrapped.reduce(_.add);
	     * // => 6
	     *
	     * // Returns a wrapped value.
	     * var squares = wrapped.map(square);
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }

	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} proto The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(proto) {
	        if (!isObject(proto)) {
	          return {};
	        }
	        if (objectCreate) {
	          return objectCreate(proto);
	        }
	        object.prototype = proto;
	        var result = new object;
	        object.prototype = undefined$1;
	        return result;
	      };
	    }());

	    /**
	     * The function whose prototype chain sequence wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }

	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable explicit method chain sequences.
	     */
	    function LodashWrapper(value, chainAll) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__chain__ = !!chainAll;
	      this.__index__ = 0;
	      this.__values__ = undefined$1;
	    }

	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
	     * following template settings to use alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type {Object}
	     */
	    lodash.templateSettings = {

	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'escape': reEscape,

	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'evaluate': reEvaluate,

	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'interpolate': reInterpolate,

	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type {string}
	       */
	      'variable': '',

	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type {Object}
	       */
	      'imports': {

	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type {Function}
	         */
	        '_': lodash
	      }
	    };

	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	    lodash.prototype.constructor = lodash;

	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;

	    /*------------------------------------------------------------------------*/

	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @constructor
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = MAX_ARRAY_LENGTH;
	      this.__views__ = [];
	    }

	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = copyArray(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = copyArray(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = copyArray(this.__views__);
	      return result;
	    }

	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }

	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);

	      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
	        return baseWrapperValue(array, this.__actions__);
	      }
	      var result = [];

	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;

	        var iterIndex = -1,
	            value = array[index];

	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);

	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }

	    // Ensure `LazyWrapper` is an instance of `baseLodash`.
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;

	    /*------------------------------------------------------------------------*/

	    /**
	     * Creates a hash object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Hash(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;

	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }

	    /**
	     * Removes all key-value entries from the hash.
	     *
	     * @private
	     * @name clear
	     * @memberOf Hash
	     */
	    function hashClear() {
	      this.__data__ = nativeCreate ? nativeCreate(null) : {};
	      this.size = 0;
	    }

	    /**
	     * Removes `key` and its value from the hash.
	     *
	     * @private
	     * @name delete
	     * @memberOf Hash
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function hashDelete(key) {
	      var result = this.has(key) && delete this.__data__[key];
	      this.size -= result ? 1 : 0;
	      return result;
	    }

	    /**
	     * Gets the hash value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Hash
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function hashGet(key) {
	      var data = this.__data__;
	      if (nativeCreate) {
	        var result = data[key];
	        return result === HASH_UNDEFINED ? undefined$1 : result;
	      }
	      return hasOwnProperty.call(data, key) ? data[key] : undefined$1;
	    }

	    /**
	     * Checks if a hash value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Hash
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function hashHas(key) {
	      var data = this.__data__;
	      return nativeCreate ? (data[key] !== undefined$1) : hasOwnProperty.call(data, key);
	    }

	    /**
	     * Sets the hash `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Hash
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the hash instance.
	     */
	    function hashSet(key, value) {
	      var data = this.__data__;
	      this.size += this.has(key) ? 0 : 1;
	      data[key] = (nativeCreate && value === undefined$1) ? HASH_UNDEFINED : value;
	      return this;
	    }

	    // Add methods to `Hash`.
	    Hash.prototype.clear = hashClear;
	    Hash.prototype['delete'] = hashDelete;
	    Hash.prototype.get = hashGet;
	    Hash.prototype.has = hashHas;
	    Hash.prototype.set = hashSet;

	    /*------------------------------------------------------------------------*/

	    /**
	     * Creates an list cache object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function ListCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;

	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }

	    /**
	     * Removes all key-value entries from the list cache.
	     *
	     * @private
	     * @name clear
	     * @memberOf ListCache
	     */
	    function listCacheClear() {
	      this.__data__ = [];
	      this.size = 0;
	    }

	    /**
	     * Removes `key` and its value from the list cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf ListCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function listCacheDelete(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);

	      if (index < 0) {
	        return false;
	      }
	      var lastIndex = data.length - 1;
	      if (index == lastIndex) {
	        data.pop();
	      } else {
	        splice.call(data, index, 1);
	      }
	      --this.size;
	      return true;
	    }

	    /**
	     * Gets the list cache value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf ListCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function listCacheGet(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);

	      return index < 0 ? undefined$1 : data[index][1];
	    }

	    /**
	     * Checks if a list cache value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf ListCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function listCacheHas(key) {
	      return assocIndexOf(this.__data__, key) > -1;
	    }

	    /**
	     * Sets the list cache `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf ListCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the list cache instance.
	     */
	    function listCacheSet(key, value) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);

	      if (index < 0) {
	        ++this.size;
	        data.push([key, value]);
	      } else {
	        data[index][1] = value;
	      }
	      return this;
	    }

	    // Add methods to `ListCache`.
	    ListCache.prototype.clear = listCacheClear;
	    ListCache.prototype['delete'] = listCacheDelete;
	    ListCache.prototype.get = listCacheGet;
	    ListCache.prototype.has = listCacheHas;
	    ListCache.prototype.set = listCacheSet;

	    /*------------------------------------------------------------------------*/

	    /**
	     * Creates a map cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function MapCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;

	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }

	    /**
	     * Removes all key-value entries from the map.
	     *
	     * @private
	     * @name clear
	     * @memberOf MapCache
	     */
	    function mapCacheClear() {
	      this.size = 0;
	      this.__data__ = {
	        'hash': new Hash,
	        'map': new (Map || ListCache),
	        'string': new Hash
	      };
	    }

	    /**
	     * Removes `key` and its value from the map.
	     *
	     * @private
	     * @name delete
	     * @memberOf MapCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function mapCacheDelete(key) {
	      var result = getMapData(this, key)['delete'](key);
	      this.size -= result ? 1 : 0;
	      return result;
	    }

	    /**
	     * Gets the map value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf MapCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function mapCacheGet(key) {
	      return getMapData(this, key).get(key);
	    }

	    /**
	     * Checks if a map value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf MapCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapCacheHas(key) {
	      return getMapData(this, key).has(key);
	    }

	    /**
	     * Sets the map `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf MapCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the map cache instance.
	     */
	    function mapCacheSet(key, value) {
	      var data = getMapData(this, key),
	          size = data.size;

	      data.set(key, value);
	      this.size += data.size == size ? 0 : 1;
	      return this;
	    }

	    // Add methods to `MapCache`.
	    MapCache.prototype.clear = mapCacheClear;
	    MapCache.prototype['delete'] = mapCacheDelete;
	    MapCache.prototype.get = mapCacheGet;
	    MapCache.prototype.has = mapCacheHas;
	    MapCache.prototype.set = mapCacheSet;

	    /*------------------------------------------------------------------------*/

	    /**
	     *
	     * Creates an array cache object to store unique values.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var index = -1,
	          length = values == null ? 0 : values.length;

	      this.__data__ = new MapCache;
	      while (++index < length) {
	        this.add(values[index]);
	      }
	    }

	    /**
	     * Adds `value` to the array cache.
	     *
	     * @private
	     * @name add
	     * @memberOf SetCache
	     * @alias push
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache instance.
	     */
	    function setCacheAdd(value) {
	      this.__data__.set(value, HASH_UNDEFINED);
	      return this;
	    }

	    /**
	     * Checks if `value` is in the array cache.
	     *
	     * @private
	     * @name has
	     * @memberOf SetCache
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `true` if `value` is found, else `false`.
	     */
	    function setCacheHas(value) {
	      return this.__data__.has(value);
	    }

	    // Add methods to `SetCache`.
	    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	    SetCache.prototype.has = setCacheHas;

	    /*------------------------------------------------------------------------*/

	    /**
	     * Creates a stack cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Stack(entries) {
	      var data = this.__data__ = new ListCache(entries);
	      this.size = data.size;
	    }

	    /**
	     * Removes all key-value entries from the stack.
	     *
	     * @private
	     * @name clear
	     * @memberOf Stack
	     */
	    function stackClear() {
	      this.__data__ = new ListCache;
	      this.size = 0;
	    }

	    /**
	     * Removes `key` and its value from the stack.
	     *
	     * @private
	     * @name delete
	     * @memberOf Stack
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function stackDelete(key) {
	      var data = this.__data__,
	          result = data['delete'](key);

	      this.size = data.size;
	      return result;
	    }

	    /**
	     * Gets the stack value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Stack
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function stackGet(key) {
	      return this.__data__.get(key);
	    }

	    /**
	     * Checks if a stack value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Stack
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function stackHas(key) {
	      return this.__data__.has(key);
	    }

	    /**
	     * Sets the stack `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Stack
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the stack cache instance.
	     */
	    function stackSet(key, value) {
	      var data = this.__data__;
	      if (data instanceof ListCache) {
	        var pairs = data.__data__;
	        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	          pairs.push([key, value]);
	          this.size = ++data.size;
	          return this;
	        }
	        data = this.__data__ = new MapCache(pairs);
	      }
	      data.set(key, value);
	      this.size = data.size;
	      return this;
	    }

	    // Add methods to `Stack`.
	    Stack.prototype.clear = stackClear;
	    Stack.prototype['delete'] = stackDelete;
	    Stack.prototype.get = stackGet;
	    Stack.prototype.has = stackHas;
	    Stack.prototype.set = stackSet;

	    /*------------------------------------------------------------------------*/

	    /**
	     * Creates an array of the enumerable property names of the array-like `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @param {boolean} inherited Specify returning inherited property names.
	     * @returns {Array} Returns the array of property names.
	     */
	    function arrayLikeKeys(value, inherited) {
	      var isArr = isArray(value),
	          isArg = !isArr && isArguments(value),
	          isBuff = !isArr && !isArg && isBuffer(value),
	          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	          skipIndexes = isArr || isArg || isBuff || isType,
	          result = skipIndexes ? baseTimes(value.length, String) : [],
	          length = result.length;

	      for (var key in value) {
	        if ((inherited || hasOwnProperty.call(value, key)) &&
	            !(skipIndexes && (
	               // Safari 9 has enumerable `arguments.length` in strict mode.
	               key == 'length' ||
	               // Node.js 0.10 has enumerable non-index properties on buffers.
	               (isBuff && (key == 'offset' || key == 'parent')) ||
	               // PhantomJS 2 has enumerable non-index properties on typed arrays.
	               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	               // Skip index properties.
	               isIndex(key, length)
	            ))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }

	    /**
	     * A specialized version of `_.sample` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @returns {*} Returns the random element.
	     */
	    function arraySample(array) {
	      var length = array.length;
	      return length ? array[baseRandom(0, length - 1)] : undefined$1;
	    }

	    /**
	     * A specialized version of `_.sampleSize` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function arraySampleSize(array, n) {
	      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
	    }

	    /**
	     * A specialized version of `_.shuffle` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function arrayShuffle(array) {
	      return shuffleSelf(copyArray(array));
	    }

	    /**
	     * This function is like `assignValue` except that it doesn't assign
	     * `undefined` values.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignMergeValue(object, key, value) {
	      if ((value !== undefined$1 && !eq(object[key], value)) ||
	          (value === undefined$1 && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }

	    /**
	     * Assigns `value` to `key` of `object` if the existing value is not equivalent
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignValue(object, key, value) {
	      var objValue = object[key];
	      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	          (value === undefined$1 && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }

	    /**
	     * Gets the index at which the `key` is found in `array` of key-value pairs.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {*} key The key to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     */
	    function assocIndexOf(array, key) {
	      var length = array.length;
	      while (length--) {
	        if (eq(array[length][0], key)) {
	          return length;
	        }
	      }
	      return -1;
	    }

	    /**
	     * Aggregates elements of `collection` on `accumulator` with keys transformed
	     * by `iteratee` and values set by `setter`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform keys.
	     * @param {Object} accumulator The initial aggregated object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseAggregator(collection, setter, iteratee, accumulator) {
	      baseEach(collection, function(value, key, collection) {
	        setter(accumulator, value, iteratee(value), collection);
	      });
	      return accumulator;
	    }

	    /**
	     * The base implementation of `_.assign` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return object && copyObject(source, keys(source), object);
	    }

	    /**
	     * The base implementation of `_.assignIn` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssignIn(object, source) {
	      return object && copyObject(source, keysIn(source), object);
	    }

	    /**
	     * The base implementation of `assignValue` and `assignMergeValue` without
	     * value checks.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function baseAssignValue(object, key, value) {
	      if (key == '__proto__' && defineProperty) {
	        defineProperty(object, key, {
	          'configurable': true,
	          'enumerable': true,
	          'value': value,
	          'writable': true
	        });
	      } else {
	        object[key] = value;
	      }
	    }

	    /**
	     * The base implementation of `_.at` without support for individual paths.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Array} Returns the picked elements.
	     */
	    function baseAt(object, paths) {
	      var index = -1,
	          length = paths.length,
	          result = Array(length),
	          skip = object == null;

	      while (++index < length) {
	        result[index] = skip ? undefined$1 : get(object, paths[index]);
	      }
	      return result;
	    }

	    /**
	     * The base implementation of `_.clamp` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     */
	    function baseClamp(number, lower, upper) {
	      if (number === number) {
	        if (upper !== undefined$1) {
	          number = number <= upper ? number : upper;
	        }
	        if (lower !== undefined$1) {
	          number = number >= lower ? number : lower;
	        }
	      }
	      return number;
	    }

	    /**
	     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	     * traversed objects.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Deep clone
	     *  2 - Flatten inherited properties
	     *  4 - Clone symbols
	     * @param {Function} [customizer] The function to customize cloning.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The parent object of `value`.
	     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, bitmask, customizer, key, object, stack) {
	      var result,
	          isDeep = bitmask & CLONE_DEEP_FLAG,
	          isFlat = bitmask & CLONE_FLAT_FLAG,
	          isFull = bitmask & CLONE_SYMBOLS_FLAG;

	      if (customizer) {
	        result = object ? customizer(value, key, object, stack) : customizer(value);
	      }
	      if (result !== undefined$1) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return copyArray(value, result);
	        }
	      } else {
	        var tag = getTag(value),
	            isFunc = tag == funcTag || tag == genTag;

	        if (isBuffer(value)) {
	          return cloneBuffer(value, isDeep);
	        }
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = (isFlat || isFunc) ? {} : initCloneObject(value);
	          if (!isDeep) {
	            return isFlat
	              ? copySymbolsIn(value, baseAssignIn(result, value))
	              : copySymbols(value, baseAssign(result, value));
	          }
	        } else {
	          if (!cloneableTags[tag]) {
	            return object ? value : {};
	          }
	          result = initCloneByTag(value, tag, isDeep);
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stack || (stack = new Stack);
	      var stacked = stack.get(value);
	      if (stacked) {
	        return stacked;
	      }
	      stack.set(value, result);

	      if (isSet(value)) {
	        value.forEach(function(subValue) {
	          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
	        });
	      } else if (isMap(value)) {
	        value.forEach(function(subValue, key) {
	          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
	        });
	      }

	      var keysFunc = isFull
	        ? (isFlat ? getAllKeysIn : getAllKeys)
	        : (isFlat ? keysIn : keys);

	      var props = isArr ? undefined$1 : keysFunc(value);
	      arrayEach(props || value, function(subValue, key) {
	        if (props) {
	          key = subValue;
	          subValue = value[key];
	        }
	        // Recursively populate clone (susceptible to call stack limits).
	        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	      });
	      return result;
	    }

	    /**
	     * The base implementation of `_.conforms` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseConforms(source) {
	      var props = keys(source);
	      return function(object) {
	        return baseConformsTo(object, source, props);
	      };
	    }

	    /**
	     * The base implementation of `_.conformsTo` which accepts `props` to check.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     */
	    function baseConformsTo(object, source, props) {
	      var length = props.length;
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (length--) {
	        var key = props[length],
	            predicate = source[key],
	            value = object[key];

	        if ((value === undefined$1 && !(key in object)) || !predicate(value)) {
	          return false;
	        }
	      }
	      return true;
	    }

	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts `args`
	     * to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Array} args The arguments to provide to `func`.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined$1, args); }, wait);
	    }

	    /**
	     * The base implementation of methods like `_.difference` without support
	     * for excluding multiple arrays or iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          isCommon = true,
	          length = array.length,
	          result = [],
	          valuesLength = values.length;

	      if (!length) {
	        return result;
	      }
	      if (iteratee) {
	        values = arrayMap(values, baseUnary(iteratee));
	      }
	      if (comparator) {
	        includes = arrayIncludesWith;
	        isCommon = false;
	      }
	      else if (values.length >= LARGE_ARRAY_SIZE) {
	        includes = cacheHas;
	        isCommon = false;
	        values = new SetCache(values);
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee == null ? value : iteratee(value);

	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === computed) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (!includes(values, computed, comparator)) {
	          result.push(value);
	        }
	      }
	      return result;
	    }

	    /**
	     * The base implementation of `_.forEach` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);

	    /**
	     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);

	    /**
	     * The base implementation of `_.every` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }

	    /**
	     * The base implementation of methods like `_.max` and `_.min` which accepts a
	     * `comparator` to determine the extremum value.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The iteratee invoked per iteration.
	     * @param {Function} comparator The comparator used to compare values.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(array, iteratee, comparator) {
	      var index = -1,
	          length = array.length;

	      while (++index < length) {
	        var value = array[index],
	            current = iteratee(value);

	        if (current != null && (computed === undefined$1
	              ? (current === current && !isSymbol(current))
	              : comparator(current, computed)
	            )) {
	          var computed = current,
	              result = value;
	        }
	      }
	      return result;
	    }

	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;

	      start = toInteger(start);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined$1 || end > length) ? length : toInteger(end);
	      if (end < 0) {
	        end += length;
	      }
	      end = start > end ? 0 : toLength(end);
	      while (start < end) {
	        array[start++] = value;
	      }
	      return array;
	    }

	    /**
	     * The base implementation of `_.filter` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }

	    /**
	     * The base implementation of `_.flatten` with support for restricting flattening.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {number} depth The maximum recursion depth.
	     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, depth, predicate, isStrict, result) {
	      var index = -1,
	          length = array.length;

	      predicate || (predicate = isFlattenable);
	      result || (result = []);

	      while (++index < length) {
	        var value = array[index];
	        if (depth > 0 && predicate(value)) {
	          if (depth > 1) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, depth - 1, predicate, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }

	    /**
	     * The base implementation of `baseForOwn` which iterates over `object`
	     * properties returned by `keysFunc` and invokes `iteratee` for each property.
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();

	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);

	    /**
	     * The base implementation of `_.forOwn` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return object && baseFor(object, iteratee, keys);
	    }

	    /**
	     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return object && baseForRight(object, iteratee, keys);
	    }

	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from `props`.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the function names.
	     */
	    function baseFunctions(object, props) {
	      return arrayFilter(props, function(key) {
	        return isFunction(object[key]);
	      });
	    }

	    /**
	     * The base implementation of `_.get` without support for default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path) {
	      path = castPath(path, object);

	      var index = 0,
	          length = path.length;

	      while (object != null && index < length) {
	        object = object[toKey(path[index++])];
	      }
	      return (index && index == length) ? object : undefined$1;
	    }

	    /**
	     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @param {Function} symbolsFunc The function to get the symbols of `object`.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	      var result = keysFunc(object);
	      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	    }

	    /**
	     * The base implementation of `getTag` without fallbacks for buggy environments.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    function baseGetTag(value) {
	      if (value == null) {
	        return value === undefined$1 ? undefinedTag : nullTag;
	      }
	      return (symToStringTag && symToStringTag in Object(value))
	        ? getRawTag(value)
	        : objectToString(value);
	    }

	    /**
	     * The base implementation of `_.gt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     */
	    function baseGt(value, other) {
	      return value > other;
	    }

	    /**
	     * The base implementation of `_.has` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHas(object, key) {
	      return object != null && hasOwnProperty.call(object, key);
	    }

	    /**
	     * The base implementation of `_.hasIn` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHasIn(object, key) {
	      return object != null && key in Object(object);
	    }

	    /**
	     * The base implementation of `_.inRange` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to check.
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     */
	    function baseInRange(number, start, end) {
	      return number >= nativeMin(start, end) && number < nativeMax(start, end);
	    }

	    /**
	     * The base implementation of methods like `_.intersection`, without support
	     * for iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of shared values.
	     */
	    function baseIntersection(arrays, iteratee, comparator) {
	      var includes = comparator ? arrayIncludesWith : arrayIncludes,
	          length = arrays[0].length,
	          othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(othLength),
	          maxLength = Infinity,
	          result = [];

	      while (othIndex--) {
	        var array = arrays[othIndex];
	        if (othIndex && iteratee) {
	          array = arrayMap(array, baseUnary(iteratee));
	        }
	        maxLength = nativeMin(array.length, maxLength);
	        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	          ? new SetCache(othIndex && array)
	          : undefined$1;
	      }
	      array = arrays[0];

	      var index = -1,
	          seen = caches[0];

	      outer:
	      while (++index < length && result.length < maxLength) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;

	        value = (comparator || value !== 0) ? value : 0;
	        if (!(seen
	              ? cacheHas(seen, computed)
	              : includes(result, computed, comparator)
	            )) {
	          othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if (!(cache
	                  ? cacheHas(cache, computed)
	                  : includes(arrays[othIndex], computed, comparator))
	                ) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }

	    /**
	     * The base implementation of `_.invert` and `_.invertBy` which inverts
	     * `object` with values transformed by `iteratee` and set by `setter`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform values.
	     * @param {Object} accumulator The initial inverted object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseInverter(object, setter, iteratee, accumulator) {
	      baseForOwn(object, function(value, key, object) {
	        setter(accumulator, iteratee(value), key, object);
	      });
	      return accumulator;
	    }

	    /**
	     * The base implementation of `_.invoke` without support for individual
	     * method arguments.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function baseInvoke(object, path, args) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      var func = object == null ? object : object[toKey(last(path))];
	      return func == null ? undefined$1 : apply(func, object, args);
	    }

	    /**
	     * The base implementation of `_.isArguments`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     */
	    function baseIsArguments(value) {
	      return isObjectLike(value) && baseGetTag(value) == argsTag;
	    }

	    /**
	     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     */
	    function baseIsArrayBuffer(value) {
	      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
	    }

	    /**
	     * The base implementation of `_.isDate` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     */
	    function baseIsDate(value) {
	      return isObjectLike(value) && baseGetTag(value) == dateTag;
	    }

	    /**
	     * The base implementation of `_.isEqual` which supports partial comparisons
	     * and tracks traversed objects.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Unordered comparison
	     *  2 - Partial comparison
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, bitmask, customizer, stack) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	    }

	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = objIsArr ? arrayTag : getTag(object),
	          othTag = othIsArr ? arrayTag : getTag(other);

	      objTag = objTag == argsTag ? objectTag : objTag;
	      othTag = othTag == argsTag ? objectTag : othTag;

	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;

	      if (isSameTag && isBuffer(object)) {
	        if (!isBuffer(other)) {
	          return false;
	        }
	        objIsArr = true;
	        objIsObj = false;
	      }
	      if (isSameTag && !objIsObj) {
	        stack || (stack = new Stack);
	        return (objIsArr || isTypedArray(object))
	          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	      }
	      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

	        if (objIsWrapped || othIsWrapped) {
	          var objUnwrapped = objIsWrapped ? object.value() : object,
	              othUnwrapped = othIsWrapped ? other.value() : other;

	          stack || (stack = new Stack);
	          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      stack || (stack = new Stack);
	      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	    }

	    /**
	     * The base implementation of `_.isMap` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     */
	    function baseIsMap(value) {
	      return isObjectLike(value) && getTag(value) == mapTag;
	    }

	    /**
	     * The base implementation of `_.isMatch` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Array} matchData The property names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, source, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;

	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];

	        if (noCustomizer && data[2]) {
	          if (objValue === undefined$1 && !(key in object)) {
	            return false;
	          }
	        } else {
	          var stack = new Stack;
	          if (customizer) {
	            var result = customizer(objValue, srcValue, key, object, source, stack);
	          }
	          if (!(result === undefined$1
	                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	                : result
	              )) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }

	    /**
	     * The base implementation of `_.isNative` without bad shim checks.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     */
	    function baseIsNative(value) {
	      if (!isObject(value) || isMasked(value)) {
	        return false;
	      }
	      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	      return pattern.test(toSource(value));
	    }

	    /**
	     * The base implementation of `_.isRegExp` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     */
	    function baseIsRegExp(value) {
	      return isObjectLike(value) && baseGetTag(value) == regexpTag;
	    }

	    /**
	     * The base implementation of `_.isSet` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     */
	    function baseIsSet(value) {
	      return isObjectLike(value) && getTag(value) == setTag;
	    }

	    /**
	     * The base implementation of `_.isTypedArray` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     */
	    function baseIsTypedArray(value) {
	      return isObjectLike(value) &&
	        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	    }

	    /**
	     * The base implementation of `_.iteratee`.
	     *
	     * @private
	     * @param {*} [value=_.identity] The value to convert to an iteratee.
	     * @returns {Function} Returns the iteratee.
	     */
	    function baseIteratee(value) {
	      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	      if (typeof value == 'function') {
	        return value;
	      }
	      if (value == null) {
	        return identity;
	      }
	      if (typeof value == 'object') {
	        return isArray(value)
	          ? baseMatchesProperty(value[0], value[1])
	          : baseMatches(value);
	      }
	      return property(value);
	    }

	    /**
	     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeys(object) {
	      if (!isPrototype(object)) {
	        return nativeKeys(object);
	      }
	      var result = [];
	      for (var key in Object(object)) {
	        if (hasOwnProperty.call(object, key) && key != 'constructor') {
	          result.push(key);
	        }
	      }
	      return result;
	    }

	    /**
	     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeysIn(object) {
	      if (!isObject(object)) {
	        return nativeKeysIn(object);
	      }
	      var isProto = isPrototype(object),
	          result = [];

	      for (var key in object) {
	        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }

	    /**
	     * The base implementation of `_.lt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     */
	    function baseLt(value, other) {
	      return value < other;
	    }

	    /**
	     * The base implementation of `_.map` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];

	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }

	    /**
	     * The base implementation of `_.matches` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	      }
	      return function(object) {
	        return object === source || baseIsMatch(object, source, matchData);
	      };
	    }

	    /**
	     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      if (isKey(path) && isStrictComparable(srcValue)) {
	        return matchesStrictComparable(toKey(path), srcValue);
	      }
	      return function(object) {
	        var objValue = get(object, path);
	        return (objValue === undefined$1 && objValue === srcValue)
	          ? hasIn(object, path)
	          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	      };
	    }

	    /**
	     * The base implementation of `_.merge` without support for multiple sources.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMerge(object, source, srcIndex, customizer, stack) {
	      if (object === source) {
	        return;
	      }
	      baseFor(source, function(srcValue, key) {
	        stack || (stack = new Stack);
	        if (isObject(srcValue)) {
	          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	        }
	        else {
	          var newValue = customizer
	            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
	            : undefined$1;

	          if (newValue === undefined$1) {
	            newValue = srcValue;
	          }
	          assignMergeValue(object, key, newValue);
	        }
	      }, keysIn);
	    }

	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	      var objValue = safeGet(object, key),
	          srcValue = safeGet(source, key),
	          stacked = stack.get(srcValue);

	      if (stacked) {
	        assignMergeValue(object, key, stacked);
	        return;
	      }
	      var newValue = customizer
	        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	        : undefined$1;

	      var isCommon = newValue === undefined$1;

	      if (isCommon) {
	        var isArr = isArray(srcValue),
	            isBuff = !isArr && isBuffer(srcValue),
	            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

	        newValue = srcValue;
	        if (isArr || isBuff || isTyped) {
	          if (isArray(objValue)) {
	            newValue = objValue;
	          }
	          else if (isArrayLikeObject(objValue)) {
	            newValue = copyArray(objValue);
	          }
	          else if (isBuff) {
	            isCommon = false;
	            newValue = cloneBuffer(srcValue, true);
	          }
	          else if (isTyped) {
	            isCommon = false;
	            newValue = cloneTypedArray(srcValue, true);
	          }
	          else {
	            newValue = [];
	          }
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          newValue = objValue;
	          if (isArguments(objValue)) {
	            newValue = toPlainObject(objValue);
	          }
	          else if (!isObject(objValue) || isFunction(objValue)) {
	            newValue = initCloneObject(srcValue);
	          }
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, newValue);
	        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	        stack['delete'](srcValue);
	      }
	      assignMergeValue(object, key, newValue);
	    }

	    /**
	     * The base implementation of `_.nth` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {number} n The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     */
	    function baseNth(array, n) {
	      var length = array.length;
	      if (!length) {
	        return;
	      }
	      n += n < 0 ? length : 0;
	      return isIndex(n, length) ? array[n] : undefined$1;
	    }

	    /**
	     * The base implementation of `_.orderBy` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {string[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseOrderBy(collection, iteratees, orders) {
	      if (iteratees.length) {
	        iteratees = arrayMap(iteratees, function(iteratee) {
	          if (isArray(iteratee)) {
	            return function(value) {
	              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
	            }
	          }
	          return iteratee;
	        });
	      } else {
	        iteratees = [identity];
	      }

	      var index = -1;
	      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

	      var result = baseMap(collection, function(value, key, collection) {
	        var criteria = arrayMap(iteratees, function(iteratee) {
	          return iteratee(value);
	        });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });

	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }

	    /**
	     * The base implementation of `_.pick` without support for individual
	     * property identifiers.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function basePick(object, paths) {
	      return basePickBy(object, paths, function(value, path) {
	        return hasIn(object, path);
	      });
	    }

	    /**
	     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @param {Function} predicate The function invoked per property.
	     * @returns {Object} Returns the new object.
	     */
	    function basePickBy(object, paths, predicate) {
	      var index = -1,
	          length = paths.length,
	          result = {};

	      while (++index < length) {
	        var path = paths[index],
	            value = baseGet(object, path);

	        if (predicate(value, path)) {
	          baseSet(result, castPath(path, object), value);
	        }
	      }
	      return result;
	    }

	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     */
	    function basePropertyDeep(path) {
	      return function(object) {
	        return baseGet(object, path);
	      };
	    }

	    /**
	     * The base implementation of `_.pullAllBy` without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAll(array, values, iteratee, comparator) {
	      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
	          index = -1,
	          length = values.length,
	          seen = array;

	      if (array === values) {
	        values = copyArray(values);
	      }
	      if (iteratee) {
	        seen = arrayMap(array, baseUnary(iteratee));
	      }
	      while (++index < length) {
	        var fromIndex = 0,
	            value = values[index],
	            computed = iteratee ? iteratee(value) : value;

	        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
	          if (seen !== array) {
	            splice.call(seen, fromIndex, 1);
	          }
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }

	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * indexes or capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0,
	          lastIndex = length - 1;

	      while (length--) {
	        var index = indexes[length];
	        if (length == lastIndex || index !== previous) {
	          var previous = index;
	          if (isIndex(index)) {
	            splice.call(array, index, 1);
	          } else {
	            baseUnset(array, index);
	          }
	        }
	      }
	      return array;
	    }

	    /**
	     * The base implementation of `_.random` without support for returning
	     * floating-point numbers.
	     *
	     * @private
	     * @param {number} lower The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(lower, upper) {
	      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	    }

	    /**
	     * The base implementation of `_.range` and `_.rangeRight` which doesn't
	     * coerce arguments.
	     *
	     * @private
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} step The value to increment or decrement by.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the range of numbers.
	     */
	    function baseRange(start, end, step, fromRight) {
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);

	      while (length--) {
	        result[fromRight ? length : ++index] = start;
	        start += step;
	      }
	      return result;
	    }

	    /**
	     * The base implementation of `_.repeat` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {string} string The string to repeat.
	     * @param {number} n The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     */
	    function baseRepeat(string, n) {
	      var result = '';
	      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        if (n) {
	          string += string;
	        }
	      } while (n);

	      return result;
	    }

	    /**
	     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     */
	    function baseRest(func, start) {
	      return setToString(overRest(func, start, identity), func + '');
	    }

	    /**
	     * The base implementation of `_.sample`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     */
	    function baseSample(collection) {
	      return arraySample(values(collection));
	    }

	    /**
	     * The base implementation of `_.sampleSize` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function baseSampleSize(collection, n) {
	      var array = values(collection);
	      return shuffleSelf(array, baseClamp(n, 0, array.length));
	    }

	    /**
	     * The base implementation of `_.set`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseSet(object, path, value, customizer) {
	      if (!isObject(object)) {
	        return object;
	      }
	      path = castPath(path, object);

	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;

	      while (nested != null && ++index < length) {
	        var key = toKey(path[index]),
	            newValue = value;

	        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
	          return object;
	        }

	        if (index != lastIndex) {
	          var objValue = nested[key];
	          newValue = customizer ? customizer(objValue, key, nested) : undefined$1;
	          if (newValue === undefined$1) {
	            newValue = isObject(objValue)
	              ? objValue
	              : (isIndex(path[index + 1]) ? [] : {});
	          }
	        }
	        assignValue(nested, key, newValue);
	        nested = nested[key];
	      }
	      return object;
	    }

	    /**
	     * The base implementation of `setData` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };

	    /**
	     * The base implementation of `setToString` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetToString = !defineProperty ? identity : function(func, string) {
	      return defineProperty(func, 'toString', {
	        'configurable': true,
	        'enumerable': false,
	        'value': constant(string),
	        'writable': true
	      });
	    };

	    /**
	     * The base implementation of `_.shuffle`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function baseShuffle(collection) {
	      return shuffleSelf(values(collection));
	    }

	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;

	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = end > length ? length : end;
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;

	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }

	    /**
	     * The base implementation of `_.some` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;

	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }

	    /**
	     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
	     * performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndex(array, value, retHighest) {
	      var low = 0,
	          high = array == null ? low : array.length;

	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];

	          if (computed !== null && !isSymbol(computed) &&
	              (retHighest ? (computed <= value) : (computed < value))) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return baseSortedIndexBy(array, value, identity, retHighest);
	    }

	    /**
	     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
	     * which invokes `iteratee` for `value` and each element of `array` to compute
	     * their sort ranking. The iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The iteratee invoked per element.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndexBy(array, value, iteratee, retHighest) {
	      var low = 0,
	          high = array == null ? 0 : array.length;
	      if (high === 0) {
	        return 0;
	      }

	      value = iteratee(value);
	      var valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsSymbol = isSymbol(value),
	          valIsUndefined = value === undefined$1;

	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            othIsDefined = computed !== undefined$1,
	            othIsNull = computed === null,
	            othIsReflexive = computed === computed,
	            othIsSymbol = isSymbol(computed);

	        if (valIsNaN) {
	          var setLow = retHighest || othIsReflexive;
	        } else if (valIsUndefined) {
	          setLow = othIsReflexive && (retHighest || othIsDefined);
	        } else if (valIsNull) {
	          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
	        } else if (valIsSymbol) {
	          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
	        } else if (othIsNull || othIsSymbol) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }

	    /**
	     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
	     * support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseSortedUniq(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          resIndex = 0,
	          result = [];

	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;

	        if (!index || !eq(computed, seen)) {
	          var seen = computed;
	          result[resIndex++] = value === 0 ? 0 : value;
	        }
	      }
	      return result;
	    }

	    /**
	     * The base implementation of `_.toNumber` which doesn't ensure correct
	     * conversions of binary, hexadecimal, or octal string values.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     */
	    function baseToNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      return +value;
	    }

	    /**
	     * The base implementation of `_.toString` which doesn't convert nullish
	     * values to empty strings.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     */
	    function baseToString(value) {
	      // Exit early for strings to avoid a performance hit in some environments.
	      if (typeof value == 'string') {
	        return value;
	      }
	      if (isArray(value)) {
	        // Recursively convert values (susceptible to call stack limits).
	        return arrayMap(value, baseToString) + '';
	      }
	      if (isSymbol(value)) {
	        return symbolToString ? symbolToString.call(value) : '';
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }

	    /**
	     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseUniq(array, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          length = array.length,
	          isCommon = true,
	          result = [],
	          seen = result;

	      if (comparator) {
	        isCommon = false;
	        includes = arrayIncludesWith;
	      }
	      else if (length >= LARGE_ARRAY_SIZE) {
	        var set = iteratee ? null : createSet(array);
	        if (set) {
	          return setToArray(set);
	        }
	        isCommon = false;
	        includes = cacheHas;
	        seen = new SetCache;
	      }
	      else {
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;

	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (!includes(seen, computed, comparator)) {
	          if (seen !== result) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }

	    /**
	     * The base implementation of `_.unset`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The property path to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     */
	    function baseUnset(object, path) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      return object == null || delete object[toKey(last(path))];
	    }

	    /**
	     * The base implementation of `_.update`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to update.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseUpdate(object, path, updater, customizer) {
	      return baseSet(object, path, updater(baseGet(object, path)), customizer);
	    }

	    /**
	     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
	     * without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;

	      while ((fromRight ? index-- : ++index < length) &&
	        predicate(array[index], index, array)) {}

	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }

	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to perform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      return arrayReduce(actions, function(result, action) {
	        return action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }, result);
	    }

	    /**
	     * The base implementation of methods like `_.xor`, without support for
	     * iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     */
	    function baseXor(arrays, iteratee, comparator) {
	      var length = arrays.length;
	      if (length < 2) {
	        return length ? baseUniq(arrays[0]) : [];
	      }
	      var index = -1,
	          result = Array(length);

	      while (++index < length) {
	        var array = arrays[index],
	            othIndex = -1;

	        while (++othIndex < length) {
	          if (othIndex != index) {
	            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
	          }
	        }
	      }
	      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
	    }

	    /**
	     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
	     *
	     * @private
	     * @param {Array} props The property identifiers.
	     * @param {Array} values The property values.
	     * @param {Function} assignFunc The function to assign values.
	     * @returns {Object} Returns the new object.
	     */
	    function baseZipObject(props, values, assignFunc) {
	      var index = -1,
	          length = props.length,
	          valsLength = values.length,
	          result = {};

	      while (++index < length) {
	        var value = index < valsLength ? values[index] : undefined$1;
	        assignFunc(result, props[index], value);
	      }
	      return result;
	    }

	    /**
	     * Casts `value` to an empty array if it's not an array like object.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array|Object} Returns the cast array-like object.
	     */
	    function castArrayLikeObject(value) {
	      return isArrayLikeObject(value) ? value : [];
	    }

	    /**
	     * Casts `value` to `identity` if it's not a function.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Function} Returns cast function.
	     */
	    function castFunction(value) {
	      return typeof value == 'function' ? value : identity;
	    }

	    /**
	     * Casts `value` to a path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {Array} Returns the cast property path array.
	     */
	    function castPath(value, object) {
	      if (isArray(value)) {
	        return value;
	      }
	      return isKey(value, object) ? [value] : stringToPath(toString(value));
	    }

	    /**
	     * A `baseRest` alias which can be replaced with `identity` by module
	     * replacement plugins.
	     *
	     * @private
	     * @type {Function}
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    var castRest = baseRest;

	    /**
	     * Casts `array` to a slice if it's needed.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {number} start The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the cast slice.
	     */
	    function castSlice(array, start, end) {
	      var length = array.length;
	      end = end === undefined$1 ? length : end;
	      return (!start && end >= length) ? array : baseSlice(array, start, end);
	    }

	    /**
	     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
	     *
	     * @private
	     * @param {number|Object} id The timer id or timeout object of the timer to clear.
	     */
	    var clearTimeout = ctxClearTimeout || function(id) {
	      return root.clearTimeout(id);
	    };

	    /**
	     * Creates a clone of  `buffer`.
	     *
	     * @private
	     * @param {Buffer} buffer The buffer to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Buffer} Returns the cloned buffer.
	     */
	    function cloneBuffer(buffer, isDeep) {
	      if (isDeep) {
	        return buffer.slice();
	      }
	      var length = buffer.length,
	          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

	      buffer.copy(result);
	      return result;
	    }

	    /**
	     * Creates a clone of `arrayBuffer`.
	     *
	     * @private
	     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function cloneArrayBuffer(arrayBuffer) {
	      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	      return result;
	    }

	    /**
	     * Creates a clone of `dataView`.
	     *
	     * @private
	     * @param {Object} dataView The data view to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned data view.
	     */
	    function cloneDataView(dataView, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	    }

	    /**
	     * Creates a clone of `regexp`.
	     *
	     * @private
	     * @param {Object} regexp The regexp to clone.
	     * @returns {Object} Returns the cloned regexp.
	     */
	    function cloneRegExp(regexp) {
	      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	      result.lastIndex = regexp.lastIndex;
	      return result;
	    }

	    /**
	     * Creates a clone of the `symbol` object.
	     *
	     * @private
	     * @param {Object} symbol The symbol object to clone.
	     * @returns {Object} Returns the cloned symbol object.
	     */
	    function cloneSymbol(symbol) {
	      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	    }

	    /**
	     * Creates a clone of `typedArray`.
	     *
	     * @private
	     * @param {Object} typedArray The typed array to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned typed array.
	     */
	    function cloneTypedArray(typedArray, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	    }

	    /**
	     * Compares values to sort them in ascending order.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {number} Returns the sort order indicator for `value`.
	     */
	    function compareAscending(value, other) {
	      if (value !== other) {
	        var valIsDefined = value !== undefined$1,
	            valIsNull = value === null,
	            valIsReflexive = value === value,
	            valIsSymbol = isSymbol(value);

	        var othIsDefined = other !== undefined$1,
	            othIsNull = other === null,
	            othIsReflexive = other === other,
	            othIsSymbol = isSymbol(other);

	        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	            (valIsNull && othIsDefined && othIsReflexive) ||
	            (!valIsDefined && othIsReflexive) ||
	            !valIsReflexive) {
	          return 1;
	        }
	        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	            (othIsNull && valIsDefined && valIsReflexive) ||
	            (!othIsDefined && valIsReflexive) ||
	            !othIsReflexive) {
	          return -1;
	        }
	      }
	      return 0;
	    }

	    /**
	     * Used by `_.orderBy` to compare multiple properties of a value to another
	     * and stable sort them.
	     *
	     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	     * specify an order of "desc" for descending or "asc" for ascending sort order
	     * of corresponding values.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {boolean[]|string[]} orders The order to sort by for each property.
	     * @returns {number} Returns the sort order indicator for `object`.
	     */
	    function compareMultiple(object, other, orders) {
	      var index = -1,
	          objCriteria = object.criteria,
	          othCriteria = other.criteria,
	          length = objCriteria.length,
	          ordersLength = orders.length;

	      while (++index < length) {
	        var result = compareAscending(objCriteria[index], othCriteria[index]);
	        if (result) {
	          if (index >= ordersLength) {
	            return result;
	          }
	          var order = orders[index];
	          return result * (order == 'desc' ? -1 : 1);
	        }
	      }
	      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	      // that causes it, under certain circumstances, to provide the same value for
	      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	      // for more details.
	      //
	      // This also ensures a stable sort in V8 and other engines.
	      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	      return object.index - other.index;
	    }

	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersLength = holders.length,
	          leftIndex = -1,
	          leftLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(leftLength + rangeLength),
	          isUncurried = !isCurried;

	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[holders[argsIndex]] = args[argsIndex];
	        }
	      }
	      while (rangeLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }

	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersIndex = -1,
	          holdersLength = holders.length,
	          rightIndex = -1,
	          rightLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(rangeLength + rightLength),
	          isUncurried = !isCurried;

	      while (++argsIndex < rangeLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[offset + holders[holdersIndex]] = args[argsIndex++];
	        }
	      }
	      return result;
	    }

	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function copyArray(source, array) {
	      var index = -1,
	          length = source.length;

	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }

	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property identifiers to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @param {Function} [customizer] The function to customize copied values.
	     * @returns {Object} Returns `object`.
	     */
	    function copyObject(source, props, object, customizer) {
	      var isNew = !object;
	      object || (object = {});

	      var index = -1,
	          length = props.length;

	      while (++index < length) {
	        var key = props[index];

	        var newValue = customizer
	          ? customizer(object[key], source[key], key, object, source)
	          : undefined$1;

	        if (newValue === undefined$1) {
	          newValue = source[key];
	        }
	        if (isNew) {
	          baseAssignValue(object, key, newValue);
	        } else {
	          assignValue(object, key, newValue);
	        }
	      }
	      return object;
	    }

	    /**
	     * Copies own symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbols(source, object) {
	      return copyObject(source, getSymbols(source), object);
	    }

	    /**
	     * Copies own and inherited symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbolsIn(source, object) {
	      return copyObject(source, getSymbolsIn(source), object);
	    }

	    /**
	     * Creates a function like `_.groupBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} [initializer] The accumulator object initializer.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee) {
	        var func = isArray(collection) ? arrayAggregator : baseAggregator,
	            accumulator = initializer ? initializer() : {};

	        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
	      };
	    }

	    /**
	     * Creates a function like `_.assign`.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return baseRest(function(object, sources) {
	        var index = -1,
	            length = sources.length,
	            customizer = length > 1 ? sources[length - 1] : undefined$1,
	            guard = length > 2 ? sources[2] : undefined$1;

	        customizer = (assigner.length > 3 && typeof customizer == 'function')
	          ? (length--, customizer)
	          : undefined$1;

	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined$1 : customizer;
	          length = 1;
	        }
	        object = Object(object);
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, index, customizer);
	          }
	        }
	        return object;
	      });
	    }

	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        if (collection == null) {
	          return collection;
	        }
	        if (!isArrayLike(collection)) {
	          return eachFunc(collection, iteratee);
	        }
	        var length = collection.length,
	            index = fromRight ? length : -1,
	            iterable = Object(collection);

	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }

	    /**
	     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var index = -1,
	            iterable = Object(object),
	            props = keysFunc(object),
	            length = props.length;

	        while (length--) {
	          var key = props[fromRight ? length : ++index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }

	    /**
	     * Creates a function that wraps `func` to invoke it with the optional `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createBind(func, bitmask, thisArg) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);

	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, arguments);
	      }
	      return wrapper;
	    }

	    /**
	     * Creates a function like `_.lowerFirst`.
	     *
	     * @private
	     * @param {string} methodName The name of the `String` case method to use.
	     * @returns {Function} Returns the new case function.
	     */
	    function createCaseFirst(methodName) {
	      return function(string) {
	        string = toString(string);

	        var strSymbols = hasUnicode(string)
	          ? stringToArray(string)
	          : undefined$1;

	        var chr = strSymbols
	          ? strSymbols[0]
	          : string.charAt(0);

	        var trailing = strSymbols
	          ? castSlice(strSymbols, 1).join('')
	          : string.slice(1);

	        return chr[methodName]() + trailing;
	      };
	    }

	    /**
	     * Creates a function like `_.camelCase`.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	      };
	    }

	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtor(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors. See
	        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);

	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }

	    /**
	     * Creates a function that wraps `func` to enable currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {number} arity The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCurry(func, bitmask, arity) {
	      var Ctor = createCtor(func);

	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length,
	            placeholder = getHolder(wrapper);

	        while (index--) {
	          args[index] = arguments[index];
	        }
	        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	          ? []
	          : replaceHolders(args, placeholder);

	        length -= holders.length;
	        if (length < arity) {
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, undefined$1,
	            args, holders, undefined$1, undefined$1, arity - length);
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return apply(fn, this, args);
	      }
	      return wrapper;
	    }

	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} findIndexFunc The function to find the collection index.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(findIndexFunc) {
	      return function(collection, predicate, fromIndex) {
	        var iterable = Object(collection);
	        if (!isArrayLike(collection)) {
	          var iteratee = getIteratee(predicate, 3);
	          collection = keys(collection);
	          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	        }
	        var index = findIndexFunc(collection, predicate, fromIndex);
	        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined$1;
	      };
	    }

	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return flatRest(function(funcs) {
	        var length = funcs.length,
	            index = length,
	            prereq = LodashWrapper.prototype.thru;

	        if (fromRight) {
	          funcs.reverse();
	        }
	        while (index--) {
	          var func = funcs[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	            var wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? index : length;
	        while (++index < length) {
	          func = funcs[index];

	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined$1;

	          if (data && isLaziable(data[0]) &&
	                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
	                !data[4].length && data[9] == 1
	              ) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func))
	              ? wrapper[funcName]()
	              : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];

	          if (wrapper && args.length == 1 && isArray(value)) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;

	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      });
	    }

	    /**
	     * Creates a function that wraps `func` to invoke it with optional `this`
	     * binding of `thisArg`, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided
	     *  to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & WRAP_ARY_FLAG,
	          isBind = bitmask & WRAP_BIND_FLAG,
	          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
	          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
	          isFlip = bitmask & WRAP_FLIP_FLAG,
	          Ctor = isBindKey ? undefined$1 : createCtor(func);

	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length;

	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (isCurried) {
	          var placeholder = getHolder(wrapper),
	              holdersCount = countHolders(args, placeholder);
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders, isCurried);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	        }
	        length -= holdersCount;
	        if (isCurried && length < arity) {
	          var newHolders = replaceHolders(args, placeholder);
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	            args, newHolders, argPos, ary, arity - length
	          );
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;

	        length = args.length;
	        if (argPos) {
	          args = reorder(args, argPos);
	        } else if (isFlip && length > 1) {
	          args.reverse();
	        }
	        if (isAry && ary < length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtor(fn);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }

	    /**
	     * Creates a function like `_.invertBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} toIteratee The function to resolve iteratees.
	     * @returns {Function} Returns the new inverter function.
	     */
	    function createInverter(setter, toIteratee) {
	      return function(object, iteratee) {
	        return baseInverter(object, setter, toIteratee(iteratee), {});
	      };
	    }

	    /**
	     * Creates a function that performs a mathematical operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @param {number} [defaultValue] The value used for `undefined` arguments.
	     * @returns {Function} Returns the new mathematical operation function.
	     */
	    function createMathOperation(operator, defaultValue) {
	      return function(value, other) {
	        var result;
	        if (value === undefined$1 && other === undefined$1) {
	          return defaultValue;
	        }
	        if (value !== undefined$1) {
	          result = value;
	        }
	        if (other !== undefined$1) {
	          if (result === undefined$1) {
	            return other;
	          }
	          if (typeof value == 'string' || typeof other == 'string') {
	            value = baseToString(value);
	            other = baseToString(other);
	          } else {
	            value = baseToNumber(value);
	            other = baseToNumber(other);
	          }
	          result = operator(value, other);
	        }
	        return result;
	      };
	    }

	    /**
	     * Creates a function like `_.over`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over iteratees.
	     * @returns {Function} Returns the new over function.
	     */
	    function createOver(arrayFunc) {
	      return flatRest(function(iteratees) {
	        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	        return baseRest(function(args) {
	          var thisArg = this;
	          return arrayFunc(iteratees, function(iteratee) {
	            return apply(iteratee, thisArg, args);
	          });
	        });
	      });
	    }

	    /**
	     * Creates the padding for `string` based on `length`. The `chars` string
	     * is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {number} length The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padding for `string`.
	     */
	    function createPadding(length, chars) {
	      chars = chars === undefined$1 ? ' ' : baseToString(chars);

	      var charsLength = chars.length;
	      if (charsLength < 2) {
	        return charsLength ? baseRepeat(chars, length) : chars;
	      }
	      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
	      return hasUnicode(chars)
	        ? castSlice(stringToArray(result), 0, length).join('')
	        : result.slice(0, length);
	    }

	    /**
	     * Creates a function that wraps `func` to invoke it with the `this` binding
	     * of `thisArg` and `partials` prepended to the arguments it receives.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to
	     *  the new function.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createPartial(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);

	      function wrapper() {
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength),
	            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        return apply(fn, isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }

	    /**
	     * Creates a `_.range` or `_.rangeRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new range function.
	     */
	    function createRange(fromRight) {
	      return function(start, end, step) {
	        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	          end = step = undefined$1;
	        }
	        // Ensure the sign of `-0` is preserved.
	        start = toFinite(start);
	        if (end === undefined$1) {
	          end = start;
	          start = 0;
	        } else {
	          end = toFinite(end);
	        }
	        step = step === undefined$1 ? (start < end ? 1 : -1) : toFinite(step);
	        return baseRange(start, end, step, fromRight);
	      };
	    }

	    /**
	     * Creates a function that performs a relational operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @returns {Function} Returns the new relational operation function.
	     */
	    function createRelationalOperation(operator) {
	      return function(value, other) {
	        if (!(typeof value == 'string' && typeof other == 'string')) {
	          value = toNumber(value);
	          other = toNumber(other);
	        }
	        return operator(value, other);
	      };
	    }

	    /**
	     * Creates a function that wraps `func` to continue currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {Function} wrapFunc The function to create the `func` wrapper.
	     * @param {*} placeholder The placeholder value.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	      var isCurry = bitmask & WRAP_CURRY_FLAG,
	          newHolders = isCurry ? holders : undefined$1,
	          newHoldersRight = isCurry ? undefined$1 : holders,
	          newPartials = isCurry ? partials : undefined$1,
	          newPartialsRight = isCurry ? undefined$1 : partials;

	      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
	      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

	      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
	        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
	      }
	      var newData = [
	        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	        newHoldersRight, argPos, ary, arity
	      ];

	      var result = wrapFunc.apply(undefined$1, newData);
	      if (isLaziable(func)) {
	        setData(result, newData);
	      }
	      result.placeholder = placeholder;
	      return setWrapToString(result, func, bitmask);
	    }

	    /**
	     * Creates a function like `_.round`.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        number = toNumber(number);
	        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
	        if (precision && nativeIsFinite(number)) {
	          // Shift with exponential notation to avoid floating-point issues.
	          // See [MDN](https://mdn.io/round#Examples) for more details.
	          var pair = (toString(number) + 'e').split('e'),
	              value = func(pair[0] + 'e' + (+pair[1] + precision));

	          pair = (toString(value) + 'e').split('e');
	          return +(pair[0] + 'e' + (+pair[1] - precision));
	        }
	        return func(number);
	      };
	    }

	    /**
	     * Creates a set object of `values`.
	     *
	     * @private
	     * @param {Array} values The values to add to the set.
	     * @returns {Object} Returns the new set.
	     */
	    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	      return new Set(values);
	    };

	    /**
	     * Creates a `_.toPairs` or `_.toPairsIn` function.
	     *
	     * @private
	     * @param {Function} keysFunc The function to get the keys of a given object.
	     * @returns {Function} Returns the new pairs function.
	     */
	    function createToPairs(keysFunc) {
	      return function(object) {
	        var tag = getTag(object);
	        if (tag == mapTag) {
	          return mapToArray(object);
	        }
	        if (tag == setTag) {
	          return setToPairs(object);
	        }
	        return baseToPairs(object, keysFunc(object));
	      };
	    }

	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags.
	     *    1 - `_.bind`
	     *    2 - `_.bindKey`
	     *    4 - `_.curry` or `_.curryRight` of a bound function
	     *    8 - `_.curry`
	     *   16 - `_.curryRight`
	     *   32 - `_.partial`
	     *   64 - `_.partialRight`
	     *  128 - `_.rearg`
	     *  256 - `_.ary`
	     *  512 - `_.flip`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined$1;
	      }
	      ary = ary === undefined$1 ? ary : nativeMax(toInteger(ary), 0);
	      arity = arity === undefined$1 ? arity : toInteger(arity);
	      length -= holders ? holders.length : 0;

	      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;

	        partials = holders = undefined$1;
	      }
	      var data = isBindKey ? undefined$1 : getData(func);

	      var newData = [
	        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	        argPos, ary, arity
	      ];

	      if (data) {
	        mergeData(newData, data);
	      }
	      func = newData[0];
	      bitmask = newData[1];
	      thisArg = newData[2];
	      partials = newData[3];
	      holders = newData[4];
	      arity = newData[9] = newData[9] === undefined$1
	        ? (isBindKey ? 0 : func.length)
	        : nativeMax(newData[9] - length, 0);

	      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
	        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
	      }
	      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
	        var result = createBind(func, bitmask, thisArg);
	      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
	        result = createCurry(func, bitmask, arity);
	      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
	        result = createPartial(func, bitmask, thisArg, partials);
	      } else {
	        result = createHybrid.apply(undefined$1, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setWrapToString(setter(result, newData), func, bitmask);
	    }

	    /**
	     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
	     * of source objects to the destination object for all destination properties
	     * that resolve to `undefined`.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to assign.
	     * @param {Object} object The parent object of `objValue`.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsAssignIn(objValue, srcValue, key, object) {
	      if (objValue === undefined$1 ||
	          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	        return srcValue;
	      }
	      return objValue;
	    }

	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
	     * objects into destination objects that are passed thru.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to merge.
	     * @param {Object} object The parent object of `objValue`.
	     * @param {Object} source The parent object of `srcValue`.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
	      if (isObject(objValue) && isObject(srcValue)) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, objValue);
	        baseMerge(objValue, srcValue, undefined$1, customDefaultsMerge, stack);
	        stack['delete'](srcValue);
	      }
	      return objValue;
	    }

	    /**
	     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	     * objects.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {string} key The key of the property to inspect.
	     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	     */
	    function customOmitClone(value) {
	      return isPlainObject(value) ? undefined$1 : value;
	    }

	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `array` and `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          arrLength = array.length,
	          othLength = other.length;

	      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	        return false;
	      }
	      // Check that cyclic values are equal.
	      var arrStacked = stack.get(array);
	      var othStacked = stack.get(other);
	      if (arrStacked && othStacked) {
	        return arrStacked == other && othStacked == array;
	      }
	      var index = -1,
	          result = true,
	          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined$1;

	      stack.set(array, other);
	      stack.set(other, array);

	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index];

	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, arrValue, index, other, array, stack)
	            : customizer(arrValue, othValue, index, array, other, stack);
	        }
	        if (compared !== undefined$1) {
	          if (compared) {
	            continue;
	          }
	          result = false;
	          break;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (seen) {
	          if (!arraySome(other, function(othValue, othIndex) {
	                if (!cacheHas(seen, othIndex) &&
	                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	                  return seen.push(othIndex);
	                }
	              })) {
	            result = false;
	            break;
	          }
	        } else if (!(
	              arrValue === othValue ||
	                equalFunc(arrValue, othValue, bitmask, customizer, stack)
	            )) {
	          result = false;
	          break;
	        }
	      }
	      stack['delete'](array);
	      stack['delete'](other);
	      return result;
	    }

	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	      switch (tag) {
	        case dataViewTag:
	          if ((object.byteLength != other.byteLength) ||
	              (object.byteOffset != other.byteOffset)) {
	            return false;
	          }
	          object = object.buffer;
	          other = other.buffer;

	        case arrayBufferTag:
	          if ((object.byteLength != other.byteLength) ||
	              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	            return false;
	          }
	          return true;

	        case boolTag:
	        case dateTag:
	        case numberTag:
	          // Coerce booleans to `1` or `0` and dates to milliseconds.
	          // Invalid dates are coerced to `NaN`.
	          return eq(+object, +other);

	        case errorTag:
	          return object.name == other.name && object.message == other.message;

	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings, primitives and objects,
	          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	          // for more details.
	          return object == (other + '');

	        case mapTag:
	          var convert = mapToArray;

	        case setTag:
	          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	          convert || (convert = setToArray);

	          if (object.size != other.size && !isPartial) {
	            return false;
	          }
	          // Assume cyclic values are equal.
	          var stacked = stack.get(object);
	          if (stacked) {
	            return stacked == other;
	          }
	          bitmask |= COMPARE_UNORDERED_FLAG;

	          // Recursively compare objects (susceptible to call stack limits).
	          stack.set(object, other);
	          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	          stack['delete'](object);
	          return result;

	        case symbolTag:
	          if (symbolValueOf) {
	            return symbolValueOf.call(object) == symbolValueOf.call(other);
	          }
	      }
	      return false;
	    }

	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          objProps = getAllKeys(object),
	          objLength = objProps.length,
	          othProps = getAllKeys(other),
	          othLength = othProps.length;

	      if (objLength != othLength && !isPartial) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      // Check that cyclic values are equal.
	      var objStacked = stack.get(object);
	      var othStacked = stack.get(other);
	      if (objStacked && othStacked) {
	        return objStacked == other && othStacked == object;
	      }
	      var result = true;
	      stack.set(object, other);
	      stack.set(other, object);

	      var skipCtor = isPartial;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key];

	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, objValue, key, other, object, stack)
	            : customizer(objValue, othValue, key, object, other, stack);
	        }
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(compared === undefined$1
	              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	              : compared
	            )) {
	          result = false;
	          break;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (result && !skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;

	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          result = false;
	        }
	      }
	      stack['delete'](object);
	      stack['delete'](other);
	      return result;
	    }

	    /**
	     * A specialized version of `baseRest` which flattens the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    function flatRest(func) {
	      return setToString(overRest(func, undefined$1, flatten), func + '');
	    }

	    /**
	     * Creates an array of own enumerable property names and symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeys(object) {
	      return baseGetAllKeys(object, keys, getSymbols);
	    }

	    /**
	     * Creates an array of own and inherited enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeysIn(object) {
	      return baseGetAllKeys(object, keysIn, getSymbolsIn);
	    }

	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };

	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = (func.name + ''),
	          array = realNames[result],
	          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }

	    /**
	     * Gets the argument placeholder value for `func`.
	     *
	     * @private
	     * @param {Function} func The function to inspect.
	     * @returns {*} Returns the placeholder value.
	     */
	    function getHolder(func) {
	      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
	      return object.placeholder;
	    }

	    /**
	     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
	     * this function returns the custom method, otherwise it returns `baseIteratee`.
	     * If arguments are provided, the chosen function is invoked with them and
	     * its result is returned.
	     *
	     * @private
	     * @param {*} [value] The value to convert to an iteratee.
	     * @param {number} [arity] The arity of the created iteratee.
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getIteratee() {
	      var result = lodash.iteratee || iteratee;
	      result = result === iteratee ? baseIteratee : result;
	      return arguments.length ? result(arguments[0], arguments[1]) : result;
	    }

	    /**
	     * Gets the data for `map`.
	     *
	     * @private
	     * @param {Object} map The map to query.
	     * @param {string} key The reference key.
	     * @returns {*} Returns the map data.
	     */
	    function getMapData(map, key) {
	      var data = map.__data__;
	      return isKeyable(key)
	        ? data[typeof key == 'string' ? 'string' : 'hash']
	        : data.map;
	    }

	    /**
	     * Gets the property names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = keys(object),
	          length = result.length;

	      while (length--) {
	        var key = result[length],
	            value = object[key];

	        result[length] = [key, value, isStrictComparable(value)];
	      }
	      return result;
	    }

	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = getValue(object, key);
	      return baseIsNative(value) ? value : undefined$1;
	    }

	    /**
	     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the raw `toStringTag`.
	     */
	    function getRawTag(value) {
	      var isOwn = hasOwnProperty.call(value, symToStringTag),
	          tag = value[symToStringTag];

	      try {
	        value[symToStringTag] = undefined$1;
	        var unmasked = true;
	      } catch (e) {}

	      var result = nativeObjectToString.call(value);
	      if (unmasked) {
	        if (isOwn) {
	          value[symToStringTag] = tag;
	        } else {
	          delete value[symToStringTag];
	        }
	      }
	      return result;
	    }

	    /**
	     * Creates an array of the own enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	      if (object == null) {
	        return [];
	      }
	      object = Object(object);
	      return arrayFilter(nativeGetSymbols(object), function(symbol) {
	        return propertyIsEnumerable.call(object, symbol);
	      });
	    };

	    /**
	     * Creates an array of the own and inherited enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	      var result = [];
	      while (object) {
	        arrayPush(result, getSymbols(object));
	        object = getPrototype(object);
	      }
	      return result;
	    };

	    /**
	     * Gets the `toStringTag` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    var getTag = baseGetTag;

	    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	        (Map && getTag(new Map) != mapTag) ||
	        (Promise && getTag(Promise.resolve()) != promiseTag) ||
	        (Set && getTag(new Set) != setTag) ||
	        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	      getTag = function(value) {
	        var result = baseGetTag(value),
	            Ctor = result == objectTag ? value.constructor : undefined$1,
	            ctorString = Ctor ? toSource(Ctor) : '';

	        if (ctorString) {
	          switch (ctorString) {
	            case dataViewCtorString: return dataViewTag;
	            case mapCtorString: return mapTag;
	            case promiseCtorString: return promiseTag;
	            case setCtorString: return setTag;
	            case weakMapCtorString: return weakMapTag;
	          }
	        }
	        return result;
	      };
	    }

	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;

	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;

	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }

	    /**
	     * Extracts wrapper details from the `source` body comment.
	     *
	     * @private
	     * @param {string} source The source to inspect.
	     * @returns {Array} Returns the wrapper details.
	     */
	    function getWrapDetails(source) {
	      var match = source.match(reWrapDetails);
	      return match ? match[1].split(reSplitDetails) : [];
	    }

	    /**
	     * Checks if `path` exists on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @param {Function} hasFunc The function to check properties.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     */
	    function hasPath(object, path, hasFunc) {
	      path = castPath(path, object);

	      var index = -1,
	          length = path.length,
	          result = false;

	      while (++index < length) {
	        var key = toKey(path[index]);
	        if (!(result = object != null && hasFunc(object, key))) {
	          break;
	        }
	        object = object[key];
	      }
	      if (result || ++index != length) {
	        return result;
	      }
	      length = object == null ? 0 : object.length;
	      return !!length && isLength(length) && isIndex(key, length) &&
	        (isArray(object) || isArguments(object));
	    }

	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = new array.constructor(length);

	      // Add properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }

	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      return (typeof object.constructor == 'function' && !isPrototype(object))
	        ? baseCreate(getPrototype(object))
	        : {};
	    }

	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return cloneArrayBuffer(object);

	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);

	        case dataViewTag:
	          return cloneDataView(object, isDeep);

	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          return cloneTypedArray(object, isDeep);

	        case mapTag:
	          return new Ctor;

	        case numberTag:
	        case stringTag:
	          return new Ctor(object);

	        case regexpTag:
	          return cloneRegExp(object);

	        case setTag:
	          return new Ctor;

	        case symbolTag:
	          return cloneSymbol(object);
	      }
	    }

	    /**
	     * Inserts wrapper `details` in a comment at the top of the `source` body.
	     *
	     * @private
	     * @param {string} source The source to modify.
	     * @returns {Array} details The details to insert.
	     * @returns {string} Returns the modified source.
	     */
	    function insertWrapDetails(source, details) {
	      var length = details.length;
	      if (!length) {
	        return source;
	      }
	      var lastIndex = length - 1;
	      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	      details = details.join(length > 2 ? ', ' : ' ');
	      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	    }

	    /**
	     * Checks if `value` is a flattenable `arguments` object or array.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	     */
	    function isFlattenable(value) {
	      return isArray(value) || isArguments(value) ||
	        !!(spreadableSymbol && value && value[spreadableSymbol]);
	    }

	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      var type = typeof value;
	      length = length == null ? MAX_SAFE_INTEGER : length;

	      return !!length &&
	        (type == 'number' ||
	          (type != 'symbol' && reIsUint.test(value))) &&
	            (value > -1 && value % 1 == 0 && value < length);
	    }

	    /**
	     * Checks if the given arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	     *  else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	            ? (isArrayLike(object) && isIndex(index, object.length))
	            : (type == 'string' && index in object)
	          ) {
	        return eq(object[index], value);
	      }
	      return false;
	    }

	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      if (isArray(value)) {
	        return false;
	      }
	      var type = typeof value;
	      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	          value == null || isSymbol(value)) {
	        return true;
	      }
	      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	        (object != null && value in Object(object));
	    }

	    /**
	     * Checks if `value` is suitable for use as unique object key.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	     */
	    function isKeyable(value) {
	      var type = typeof value;
	      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	        ? (value !== '__proto__')
	        : (value === null);
	    }

	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	     *  else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func),
	          other = lodash[funcName];

	      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }

	    /**
	     * Checks if `func` has its source masked.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	     */
	    function isMasked(func) {
	      return !!maskSrcKey && (maskSrcKey in func);
	    }

	    /**
	     * Checks if `func` is capable of being masked.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
	     */
	    var isMaskable = coreJsData ? isFunction : stubFalse;

	    /**
	     * Checks if `value` is likely a prototype object.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	     */
	    function isPrototype(value) {
	      var Ctor = value && value.constructor,
	          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

	      return value === proto;
	    }

	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }

	    /**
	     * A specialized version of `matchesProperty` for source values suitable
	     * for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function matchesStrictComparable(key, srcValue) {
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        return object[key] === srcValue &&
	          (srcValue !== undefined$1 || (key in Object(object)));
	      };
	    }

	    /**
	     * A specialized version of `_.memoize` which clears the memoized function's
	     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	     *
	     * @private
	     * @param {Function} func The function to have its output memoized.
	     * @returns {Function} Returns the new memoized function.
	     */
	    function memoizeCapped(func) {
	      var result = memoize(func, function(key) {
	        if (cache.size === MAX_MEMOIZE_SIZE) {
	          cache.clear();
	        }
	        return key;
	      });

	      var cache = result.cache;
	      return result;
	    }

	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers used to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and
	     * `_.rearg` modify function arguments, making the order in which they are
	     * executed important, preventing the merging of metadata. However, we make
	     * an exception for a safe combined case where curried functions have `_.ary`
	     * and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

	      var isCombo =
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
	        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & WRAP_BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = value;
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & WRAP_ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;

	      return data;
	    }

	    /**
	     * This function is like
	     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * except that it includes inherited enumerable properties.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function nativeKeysIn(object) {
	      var result = [];
	      if (object != null) {
	        for (var key in Object(object)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }

	    /**
	     * Converts `value` to a string using `Object.prototype.toString`.
	     *
	     * @private
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     */
	    function objectToString(value) {
	      return nativeObjectToString.call(value);
	    }

	    /**
	     * A specialized version of `baseRest` which transforms the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @param {Function} transform The rest array transform.
	     * @returns {Function} Returns the new function.
	     */
	    function overRest(func, start, transform) {
	      start = nativeMax(start === undefined$1 ? (func.length - 1) : start, 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            array = Array(length);

	        while (++index < length) {
	          array[index] = args[start + index];
	        }
	        index = -1;
	        var otherArgs = Array(start + 1);
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = transform(array);
	        return apply(func, this, otherArgs);
	      };
	    }

	    /**
	     * Gets the parent value at `path` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path to get the parent value of.
	     * @returns {*} Returns the parent value.
	     */
	    function parent(object, path) {
	      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	    }

	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = copyArray(array);

	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined$1;
	      }
	      return array;
	    }

	    /**
	     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the property to get.
	     * @returns {*} Returns the property value.
	     */
	    function safeGet(object, key) {
	      if (key === 'constructor' && typeof object[key] === 'function') {
	        return;
	      }

	      if (key == '__proto__') {
	        return;
	      }

	      return object[key];
	    }

	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity
	     * function to avoid garbage collection pauses in V8. See
	     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = shortOut(baseSetData);

	    /**
	     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    var setTimeout = ctxSetTimeout || function(func, wait) {
	      return root.setTimeout(func, wait);
	    };

	    /**
	     * Sets the `toString` method of `func` to return `string`.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var setToString = shortOut(baseSetToString);

	    /**
	     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	     * with wrapper details in a comment at the top of the source body.
	     *
	     * @private
	     * @param {Function} wrapper The function to modify.
	     * @param {Function} reference The reference function.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Function} Returns `wrapper`.
	     */
	    function setWrapToString(wrapper, reference, bitmask) {
	      var source = (reference + '');
	      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
	    }

	    /**
	     * Creates a function that'll short out and invoke `identity` instead
	     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	     * milliseconds.
	     *
	     * @private
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new shortable function.
	     */
	    function shortOut(func) {
	      var count = 0,
	          lastCalled = 0;

	      return function() {
	        var stamp = nativeNow(),
	            remaining = HOT_SPAN - (stamp - lastCalled);

	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return arguments[0];
	          }
	        } else {
	          count = 0;
	        }
	        return func.apply(undefined$1, arguments);
	      };
	    }

	    /**
	     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @param {number} [size=array.length] The size of `array`.
	     * @returns {Array} Returns `array`.
	     */
	    function shuffleSelf(array, size) {
	      var index = -1,
	          length = array.length,
	          lastIndex = length - 1;

	      size = size === undefined$1 ? length : size;
	      while (++index < size) {
	        var rand = baseRandom(index, lastIndex),
	            value = array[rand];

	        array[rand] = array[index];
	        array[index] = value;
	      }
	      array.length = size;
	      return array;
	    }

	    /**
	     * Converts `string` to a property path array.
	     *
	     * @private
	     * @param {string} string The string to convert.
	     * @returns {Array} Returns the property path array.
	     */
	    var stringToPath = memoizeCapped(function(string) {
	      var result = [];
	      if (string.charCodeAt(0) === 46 /* . */) {
	        result.push('');
	      }
	      string.replace(rePropName, function(match, number, quote, subString) {
	        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    });

	    /**
	     * Converts `value` to a string key if it's not a string or symbol.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {string|symbol} Returns the key.
	     */
	    function toKey(value) {
	      if (typeof value == 'string' || isSymbol(value)) {
	        return value;
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }

	    /**
	     * Converts `func` to its source code.
	     *
	     * @private
	     * @param {Function} func The function to convert.
	     * @returns {string} Returns the source code.
	     */
	    function toSource(func) {
	      if (func != null) {
	        try {
	          return funcToString.call(func);
	        } catch (e) {}
	        try {
	          return (func + '');
	        } catch (e) {}
	      }
	      return '';
	    }

	    /**
	     * Updates wrapper `details` based on `bitmask` flags.
	     *
	     * @private
	     * @returns {Array} details The details to modify.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Array} Returns `details`.
	     */
	    function updateWrapDetails(details, bitmask) {
	      arrayEach(wrapFlags, function(pair) {
	        var value = '_.' + pair[0];
	        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	          details.push(value);
	        }
	      });
	      return details.sort();
	    }

	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      if (wrapper instanceof LazyWrapper) {
	        return wrapper.clone();
	      }
	      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	      result.__actions__ = copyArray(wrapper.__actions__);
	      result.__index__  = wrapper.__index__;
	      result.__values__ = wrapper.__values__;
	      return result;
	    }

	    /*------------------------------------------------------------------------*/

	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `array` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the new array of chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if ((guard ? isIterateeCall(array, size, guard) : size === undefined$1)) {
	        size = 1;
	      } else {
	        size = nativeMax(toInteger(size), 0);
	      }
	      var length = array == null ? 0 : array.length;
	      if (!length || size < 1) {
	        return [];
	      }
	      var index = 0,
	          resIndex = 0,
	          result = Array(nativeCeil(length / size));

	      while (index < length) {
	        result[resIndex++] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }

	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array == null ? 0 : array.length,
	          resIndex = 0,
	          result = [];

	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[resIndex++] = value;
	        }
	      }
	      return result;
	    }

	    /**
	     * Creates a new array concatenating `array` with any additional arrays
	     * and/or values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to concatenate.
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var other = _.concat(array, 2, [3], [[4]]);
	     *
	     * console.log(other);
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    function concat() {
	      var length = arguments.length;
	      if (!length) {
	        return [];
	      }
	      var args = Array(length - 1),
	          array = arguments[0],
	          index = length;

	      while (index--) {
	        args[index - 1] = arguments[index];
	      }
	      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
	    }

	    /**
	     * Creates an array of `array` values not included in the other given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * **Note:** Unlike `_.pullAll`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.without, _.xor
	     * @example
	     *
	     * _.difference([2, 1], [2, 3]);
	     * // => [1]
	     */
	    var difference = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	        : [];
	    });

	    /**
	     * This method is like `_.difference` except that it accepts `iteratee` which
	     * is invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var differenceBy = baseRest(function(array, values) {
	      var iteratee = last(values);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined$1;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
	        : [];
	    });

	    /**
	     * This method is like `_.difference` except that it accepts `comparator`
	     * which is invoked to compare elements of `array` to `values`. The order and
	     * references of result values are determined by the first array. The comparator
	     * is invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     *
	     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }]
	     */
	    var differenceWith = baseRest(function(array, values) {
	      var comparator = last(values);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined$1;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined$1, comparator)
	        : [];
	    });

	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined$1) ? 1 : toInteger(n);
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }

	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined$1) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }

	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.dropRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropRightWhile(users, ['active', false]);
	     * // => objects for ['barney']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropRightWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true, true)
	        : [];
	    }

	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.dropWhile(users, function(o) { return !o.active; });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropWhile(users, ['active', false]);
	     * // => objects for ['pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true)
	        : [];
	    }

	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8, 10], '*', 1, 3);
	     * // => [4, '*', '*', 10]
	     */
	    function fill(array, value, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }

	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(o) { return o.user == 'barney'; });
	     * // => 0
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findIndex(users, ['active', false]);
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    function findIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index);
	    }

	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	     * // => 2
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastIndex(users, ['active', false]);
	     * // => 2
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    function findLastIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length - 1;
	      if (fromIndex !== undefined$1) {
	        index = toInteger(fromIndex);
	        index = fromIndex < 0
	          ? nativeMax(length + index, 0)
	          : nativeMin(index, length - 1);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
	    }

	    /**
	     * Flattens `array` a single level deep.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, [3, [4]], 5]
	     */
	    function flatten(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, 1) : [];
	    }

	    /**
	     * Recursively flattens `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, 3, 4, 5]
	     */
	    function flattenDeep(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, INFINITY) : [];
	    }

	    /**
	     * Recursively flatten `array` up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * var array = [1, [2, [3, [4]], 5]];
	     *
	     * _.flattenDepth(array, 1);
	     * // => [1, 2, [3, [4]], 5]
	     *
	     * _.flattenDepth(array, 2);
	     * // => [1, 2, 3, [4], 5]
	     */
	    function flattenDepth(array, depth) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      depth = depth === undefined$1 ? 1 : toInteger(depth);
	      return baseFlatten(array, depth);
	    }

	    /**
	     * The inverse of `_.toPairs`; this method returns an object composed
	     * from key-value `pairs`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} pairs The key-value pairs.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.fromPairs([['a', 1], ['b', 2]]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function fromPairs(pairs) {
	      var index = -1,
	          length = pairs == null ? 0 : pairs.length,
	          result = {};

	      while (++index < length) {
	        var pair = pairs[index];
	        result[pair[0]] = pair[1];
	      }
	      return result;
	    }

	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias first
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.head([1, 2, 3]);
	     * // => 1
	     *
	     * _.head([]);
	     * // => undefined
	     */
	    function head(array) {
	      return (array && array.length) ? array[0] : undefined$1;
	    }

	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it's used as the
	     * offset from the end of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // Search from the `fromIndex`.
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseIndexOf(array, value, index);
	    }

	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 0, -1) : [];
	    }

	    /**
	     * Creates an array of unique values that are included in all given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersection([2, 1], [2, 3]);
	     * // => [2]
	     */
	    var intersection = baseRest(function(arrays) {
	      var mapped = arrayMap(arrays, castArrayLikeObject);
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped)
	        : [];
	    });

	    /**
	     * This method is like `_.intersection` except that it accepts `iteratee`
	     * which is invoked for each element of each `arrays` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [2.1]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }]
	     */
	    var intersectionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);

	      if (iteratee === last(mapped)) {
	        iteratee = undefined$1;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, getIteratee(iteratee, 2))
	        : [];
	    });

	    /**
	     * This method is like `_.intersection` except that it accepts `comparator`
	     * which is invoked to compare elements of `arrays`. The order and references
	     * of result values are determined by the first array. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.intersectionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }]
	     */
	    var intersectionWith = baseRest(function(arrays) {
	      var comparator = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);

	      comparator = typeof comparator == 'function' ? comparator : undefined$1;
	      if (comparator) {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, undefined$1, comparator)
	        : [];
	    });

	    /**
	     * Converts all elements in `array` into a string separated by `separator`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to convert.
	     * @param {string} [separator=','] The element separator.
	     * @returns {string} Returns the joined string.
	     * @example
	     *
	     * _.join(['a', 'b', 'c'], '~');
	     * // => 'a~b~c'
	     */
	    function join(array, separator) {
	      return array == null ? '' : nativeJoin.call(array, separator);
	    }

	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? array[length - 1] : undefined$1;
	    }

	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // Search from the `fromIndex`.
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (fromIndex !== undefined$1) {
	        index = toInteger(fromIndex);
	        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
	      }
	      return value === value
	        ? strictLastIndexOf(array, value, index)
	        : baseFindIndex(array, baseIsNaN, index, true);
	    }

	    /**
	     * Gets the element at index `n` of `array`. If `n` is negative, the nth
	     * element from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.11.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=0] The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     *
	     * _.nth(array, 1);
	     * // => 'b'
	     *
	     * _.nth(array, -2);
	     * // => 'c';
	     */
	    function nth(array, n) {
	      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined$1;
	    }

	    /**
	     * Removes all given values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	     * to remove elements from an array by predicate.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pull(array, 'a', 'c');
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    var pull = baseRest(pullAll);

	    /**
	     * This method is like `_.pull` except that it accepts an array of values to remove.
	     *
	     * **Note:** Unlike `_.difference`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pullAll(array, ['a', 'c']);
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    function pullAll(array, values) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values)
	        : array;
	    }

	    /**
	     * This method is like `_.pullAll` except that it accepts `iteratee` which is
	     * invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The iteratee is invoked with one argument: (value).
	     *
	     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
	     *
	     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
	     * console.log(array);
	     * // => [{ 'x': 2 }]
	     */
	    function pullAllBy(array, values, iteratee) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, getIteratee(iteratee, 2))
	        : array;
	    }

	    /**
	     * This method is like `_.pullAll` except that it accepts `comparator` which
	     * is invoked to compare elements of `array` to `values`. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
	     *
	     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
	     * console.log(array);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
	     */
	    function pullAllWith(array, values, comparator) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, undefined$1, comparator)
	        : array;
	    }

	    /**
	     * Removes elements from `array` corresponding to `indexes` and returns an
	     * array of removed elements.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     * var pulled = _.pullAt(array, [1, 3]);
	     *
	     * console.log(array);
	     * // => ['a', 'c']
	     *
	     * console.log(pulled);
	     * // => ['b', 'd']
	     */
	    var pullAt = flatRest(function(array, indexes) {
	      var length = array == null ? 0 : array.length,
	          result = baseAt(array, indexes);

	      basePullAt(array, arrayMap(indexes, function(index) {
	        return isIndex(index, length) ? +index : index;
	      }).sort(compareAscending));

	      return result;
	    });

	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is invoked
	     * with three arguments: (value, index, array).
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	     * to pull elements from an array by value.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;

	      predicate = getIteratee(predicate, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }

	    /**
	     * Reverses `array` so that the first element becomes the last, the second
	     * element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates `array` and is based on
	     * [`Array#reverse`](https://mdn.io/Array/reverse).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.reverse(array);
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function reverse(array) {
	      return array == null ? array : nativeReverse.call(array);
	    }

	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of
	     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
	     * returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      else {
	        start = start == null ? 0 : toInteger(start);
	        end = end === undefined$1 ? length : toInteger(end);
	      }
	      return baseSlice(array, start, end);
	    }

	    /**
	     * Uses a binary search to determine the lowest index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     */
	    function sortedIndex(array, value) {
	      return baseSortedIndex(array, value);
	    }

	    /**
	     * This method is like `_.sortedIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 0
	     */
	    function sortedIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
	    }

	    /**
	     * This method is like `_.indexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 1
	     */
	    function sortedIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value);
	        if (index < length && eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }

	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
	     * // => 4
	     */
	    function sortedLastIndex(array, value) {
	      return baseSortedIndex(array, value, true);
	    }

	    /**
	     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 1
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 1
	     */
	    function sortedLastIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
	    }

	    /**
	     * This method is like `_.lastIndexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 3
	     */
	    function sortedLastIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value, true) - 1;
	        if (eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }

	    /**
	     * This method is like `_.uniq` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniq([1, 1, 2]);
	     * // => [1, 2]
	     */
	    function sortedUniq(array) {
	      return (array && array.length)
	        ? baseSortedUniq(array)
	        : [];
	    }

	    /**
	     * This method is like `_.uniqBy` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
	     * // => [1.1, 2.3]
	     */
	    function sortedUniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSortedUniq(array, getIteratee(iteratee, 2))
	        : [];
	    }

	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.tail([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function tail(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 1, length) : [];
	    }

	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      n = (guard || n === undefined$1) ? 1 : toInteger(n);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }

	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined$1) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }

	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.takeRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeRightWhile(users, ['active', false]);
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeRightWhile(users, 'active');
	     * // => []
	     */
	    function takeRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), false, true)
	        : [];
	    }

	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.takeWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeWhile(users, ['active', false]);
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeWhile(users, 'active');
	     * // => []
	     */
	    function takeWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3))
	        : [];
	    }

	    /**
	     * Creates an array of unique values, in order, from all given arrays using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([2], [1, 2]);
	     * // => [2, 1]
	     */
	    var union = baseRest(function(arrays) {
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	    });

	    /**
	     * This method is like `_.union` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which uniqueness is computed. Result values are chosen from the first
	     * array in which the value occurs. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    var unionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined$1;
	      }
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
	    });

	    /**
	     * This method is like `_.union` except that it accepts `comparator` which
	     * is invoked to compare elements of `arrays`. Result values are chosen from
	     * the first array in which the value occurs. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.unionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var unionWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined$1;
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined$1, comparator);
	    });

	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurrence of each element
	     * is kept. The order of result values is determined by the order they occur
	     * in the array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     */
	    function uniq(array) {
	      return (array && array.length) ? baseUniq(array) : [];
	    }

	    /**
	     * This method is like `_.uniq` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * uniqueness is computed. The order of result values is determined by the
	     * order they occur in the array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniqBy(array, iteratee) {
	      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
	    }

	    /**
	     * This method is like `_.uniq` except that it accepts `comparator` which
	     * is invoked to compare elements of `array`. The order of result values is
	     * determined by the order they occur in the array.The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.uniqWith(objects, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
	     */
	    function uniqWith(array, comparator) {
	      comparator = typeof comparator == 'function' ? comparator : undefined$1;
	      return (array && array.length) ? baseUniq(array, undefined$1, comparator) : [];
	    }

	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.2.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['a', 'b'], [1, 2], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var length = 0;
	      array = arrayFilter(array, function(group) {
	        if (isArrayLikeObject(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      return baseTimes(length, function(index) {
	        return arrayMap(array, baseProperty(index));
	      });
	    }

	    /**
	     * This method is like `_.unzip` except that it accepts `iteratee` to specify
	     * how regrouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  regrouped values.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      return arrayMap(result, function(group) {
	        return apply(iteratee, undefined$1, group);
	      });
	    }

	    /**
	     * Creates an array excluding all given values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.pull`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.xor
	     * @example
	     *
	     * _.without([2, 1, 2, 3], 1, 2);
	     * // => [3]
	     */
	    var without = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, values)
	        : [];
	    });

	    /**
	     * Creates an array of unique values that is the
	     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the given arrays. The order of result values is determined by the order
	     * they occur in the arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.without
	     * @example
	     *
	     * _.xor([2, 1], [2, 3]);
	     * // => [1, 3]
	     */
	    var xor = baseRest(function(arrays) {
	      return baseXor(arrayFilter(arrays, isArrayLikeObject));
	    });

	    /**
	     * This method is like `_.xor` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which by which they're compared. The order of result values is determined
	     * by the order they occur in the arrays. The iteratee is invoked with one
	     * argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2, 3.4]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var xorBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined$1;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
	    });

	    /**
	     * This method is like `_.xor` except that it accepts `comparator` which is
	     * invoked to compare elements of `arrays`. The order of result values is
	     * determined by the order they occur in the arrays. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.xorWith(objects, others, _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var xorWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined$1;
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined$1, comparator);
	    });

	    /**
	     * Creates an array of grouped elements, the first of which contains the
	     * first elements of the given arrays, the second of which contains the
	     * second elements of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     */
	    var zip = baseRest(unzip);

	    /**
	     * This method is like `_.fromPairs` except that it accepts two arrays,
	     * one of property identifiers and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.4.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject(['a', 'b'], [1, 2]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function zipObject(props, values) {
	      return baseZipObject(props || [], values || [], assignValue);
	    }

	    /**
	     * This method is like `_.zipObject` except that it supports property paths.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
	     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
	     */
	    function zipObjectDeep(props, values) {
	      return baseZipObject(props || [], values || [], baseSet);
	    }

	    /**
	     * This method is like `_.zip` except that it accepts `iteratee` to specify
	     * how grouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  grouped values.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
	     *   return a + b + c;
	     * });
	     * // => [111, 222]
	     */
	    var zipWith = baseRest(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 1 ? arrays[length - 1] : undefined$1;

	      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined$1;
	      return unzipWith(arrays, iteratee);
	    });

	    /*------------------------------------------------------------------------*/

	    /**
	     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
	     * chain sequences enabled. The result of such sequences must be unwrapped
	     * with `_#value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Seq
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _
	     *   .chain(users)
	     *   .sortBy('age')
	     *   .map(function(o) {
	     *     return o.user + ' is ' + o.age;
	     *   })
	     *   .head()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }

	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor
	     * is invoked with one argument; (value). The purpose of this method is to
	     * "tap into" a method chain sequence in order to modify intermediate results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    // Mutate input array.
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor) {
	      interceptor(value);
	      return value;
	    }

	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     * The purpose of this method is to "pass thru" values replacing intermediate
	     * results in a method chain sequence.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor) {
	      return interceptor(value);
	    }

	    /**
	     * This method is the wrapper version of `_.at`.
	     *
	     * @name at
	     * @memberOf _
	     * @since 1.0.0
	     * @category Seq
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _(object).at(['a[0].b.c', 'a[1]']).value();
	     * // => [3, 4]
	     */
	    var wrapperAt = flatRest(function(paths) {
	      var length = paths.length,
	          start = length ? paths[0] : 0,
	          value = this.__wrapped__,
	          interceptor = function(object) { return baseAt(object, paths); };

	      if (length > 1 || this.__actions__.length ||
	          !(value instanceof LazyWrapper) || !isIndex(start)) {
	        return this.thru(interceptor);
	      }
	      value = value.slice(start, +start + (length ? 1 : 0));
	      value.__actions__.push({
	        'func': thru,
	        'args': [interceptor],
	        'thisArg': undefined$1
	      });
	      return new LodashWrapper(value, this.__chain__).thru(function(array) {
	        if (length && !array.length) {
	          array.push(undefined$1);
	        }
	        return array;
	      });
	    });

	    /**
	     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
	     *
	     * @name chain
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // A sequence without explicit chaining.
	     * _(users).head();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // A sequence with explicit chaining.
	     * _(users)
	     *   .chain()
	     *   .head()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }

	    /**
	     * Executes the chain sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }

	    /**
	     * Gets the next value on a wrapped object following the
	     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
	     *
	     * @name next
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the next iterator value.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 1 }
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 2 }
	     *
	     * wrapped.next();
	     * // => { 'done': true, 'value': undefined }
	     */
	    function wrapperNext() {
	      if (this.__values__ === undefined$1) {
	        this.__values__ = toArray(this.value());
	      }
	      var done = this.__index__ >= this.__values__.length,
	          value = done ? undefined$1 : this.__values__[this.__index__++];

	      return { 'done': done, 'value': value };
	    }

	    /**
	     * Enables the wrapper to be iterable.
	     *
	     * @name Symbol.iterator
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the wrapper object.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped[Symbol.iterator]() === wrapped;
	     * // => true
	     *
	     * Array.from(wrapped);
	     * // => [1, 2]
	     */
	    function wrapperToIterator() {
	      return this;
	    }

	    /**
	     * Creates a clone of the chain sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @param {*} value The value to plant.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2]).map(square);
	     * var other = wrapped.plant([3, 4]);
	     *
	     * other.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;

	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        clone.__index__ = 0;
	        clone.__values__ = undefined$1;
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }

	    /**
	     * This method is the wrapper version of `_.reverse`.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({
	          'func': thru,
	          'args': [reverse],
	          'thisArg': undefined$1
	        });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(reverse);
	    }

	    /**
	     * Executes the chain sequence to resolve the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @since 0.1.0
	     * @alias toJSON, valueOf
	     * @category Seq
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }

	    /*------------------------------------------------------------------------*/

	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the number of times the key was returned by `iteratee`. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': 1, '6': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        ++result[key];
	      } else {
	        baseAssignValue(result, key, 1);
	      }
	    });

	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * Iteration is stopped once `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * **Note:** This method returns `true` for
	     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	     * elements of empty collections.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.every(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, guard) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined$1;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }

	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * **Note:** Unlike `_.remove`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.reject
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, { 'age': 36, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.filter(users, 'active');
	     * // => objects for ['barney']
	     *
	     * // Combining several predicates using `_.overEvery` or `_.overSome`.
	     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
	     * // => objects for ['fred', 'barney']
	     */
	    function filter(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, getIteratee(predicate, 3));
	    }

	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.find(users, function(o) { return o.age < 40; });
	     * // => object for 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.find(users, { 'age': 1, 'active': true });
	     * // => object for 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.find(users, ['active', false]);
	     * // => object for 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.find(users, 'active');
	     * // => object for 'barney'
	     */
	    var find = createFind(findIndex);

	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=collection.length-1] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(findLastIndex);

	    /**
	     * Creates a flattened array of values by running each element in `collection`
	     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [n, n];
	     * }
	     *
	     * _.flatMap([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMap(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), 1);
	    }

	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDeep([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMapDeep(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), INFINITY);
	    }

	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDepth([1, 2], duplicate, 2);
	     * // => [[1, 1], [2, 2]]
	     */
	    function flatMapDepth(collection, iteratee, depth) {
	      depth = depth === undefined$1 ? 1 : toInteger(depth);
	      return baseFlatten(map(collection, iteratee), depth);
	    }

	    /**
	     * Iterates over elements of `collection` and invokes `iteratee` for each element.
	     * The iteratee is invoked with three arguments: (value, index|key, collection).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length"
	     * property are iterated like arrays. To avoid this behavior use `_.forIn`
	     * or `_.forOwn` for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias each
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEachRight
	     * @example
	     *
	     * _.forEach([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `1` then `2`.
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forEach(collection, iteratee) {
	      var func = isArray(collection) ? arrayEach : baseEach;
	      return func(collection, getIteratee(iteratee, 3));
	    }

	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEach
	     * @example
	     *
	     * _.forEachRight([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `2` then `1`.
	     */
	    function forEachRight(collection, iteratee) {
	      var func = isArray(collection) ? arrayEachRight : baseEachRight;
	      return func(collection, getIteratee(iteratee, 3));
	    }

	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The order of grouped values
	     * is determined by the order they occur in `collection`. The corresponding
	     * value of each key is an array of elements responsible for generating the
	     * key. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': [4.2], '6': [6.1, 6.3] }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        baseAssignValue(result, key, [value]);
	      }
	    });

	    /**
	     * Checks if `value` is in `collection`. If `collection` is a string, it's
	     * checked for a substring of `value`, otherwise
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * is used for equality comparisons. If `fromIndex` is negative, it's used as
	     * the offset from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {boolean} Returns `true` if `value` is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'a': 1, 'b': 2 }, 1);
	     * // => true
	     *
	     * _.includes('abcd', 'bc');
	     * // => true
	     */
	    function includes(collection, value, fromIndex, guard) {
	      collection = isArrayLike(collection) ? collection : values(collection);
	      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

	      var length = collection.length;
	      if (fromIndex < 0) {
	        fromIndex = nativeMax(length + fromIndex, 0);
	      }
	      return isString(collection)
	        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	    }

	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `path` is a function, it's invoked
	     * for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke each method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invokeMap([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invokeMap = baseRest(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          result = isArrayLike(collection) ? Array(collection.length) : [];

	      baseEach(collection, function(value) {
	        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
	      });
	      return result;
	    });

	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the last element responsible for generating the key. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var array = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.keyBy(array, function(o) {
	     *   return String.fromCharCode(o.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.keyBy(array, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     */
	    var keyBy = createAggregator(function(result, value, key) {
	      baseAssignValue(result, key, value);
	    });

	    /**
	     * Creates an array of values by running each element in `collection` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * _.map([4, 8], square);
	     * // => [16, 64]
	     *
	     * _.map({ 'a': 4, 'b': 8 }, square);
	     * // => [16, 64] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      return func(collection, getIteratee(iteratee, 3));
	    }

	    /**
	     * This method is like `_.sortBy` except that it allows specifying the sort
	     * orders of the iteratees to sort by. If `orders` is unspecified, all values
	     * are sorted in ascending order. Otherwise, specify an order of "desc" for
	     * descending or "asc" for ascending sort order of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @param {string[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // Sort by `user` in ascending order and by `age` in descending order.
	     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */
	    function orderBy(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      orders = guard ? undefined$1 : orders;
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseOrderBy(collection, iteratees, orders);
	    }

	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, the second of which
	     * contains elements `predicate` returns falsey for. The predicate is
	     * invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * _.partition(users, function(o) { return o.active; });
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.partition(users, { 'age': 1, 'active': false });
	     * // => objects for [['pebbles'], ['barney', 'fred']]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.partition(users, ['active', false]);
	     * // => objects for [['barney', 'pebbles'], ['fred']]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.partition(users, 'active');
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });

	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` thru `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not given, the first element of `collection` is used as the initial
	     * value. The iteratee is invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	     * and `sortBy`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduceRight
	     * @example
	     *
	     * _.reduce([1, 2], function(sum, n) {
	     *   return sum + n;
	     * }, 0);
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     *   return result;
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	     */
	    function reduce(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduce : baseReduce,
	          initAccum = arguments.length < 3;

	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	    }

	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduce
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    function reduceRight(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduceRight : baseReduce,
	          initAccum = arguments.length < 3;

	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
	    }

	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.filter
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * _.reject(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.reject(users, { 'age': 40, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.reject(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.reject(users, 'active');
	     * // => objects for ['barney']
	     */
	    function reject(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, negate(getIteratee(predicate, 3)));
	    }

	    /**
	     * Gets a random element from `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     */
	    function sample(collection) {
	      var func = isArray(collection) ? arraySample : baseSample;
	      return func(collection);
	    }

	    /**
	     * Gets `n` random elements at unique keys from `collection` up to the
	     * size of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} [n=1] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the random elements.
	     * @example
	     *
	     * _.sampleSize([1, 2, 3], 2);
	     * // => [3, 1]
	     *
	     * _.sampleSize([1, 2, 3], 4);
	     * // => [2, 3, 1]
	     */
	    function sampleSize(collection, n, guard) {
	      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined$1)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
	      return func(collection, n);
	    }

	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      var func = isArray(collection) ? arrayShuffle : baseShuffle;
	      return func(collection);
	    }

	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable string keyed properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the collection size.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      if (collection == null) {
	        return 0;
	      }
	      if (isArrayLike(collection)) {
	        return isString(collection) ? stringSize(collection) : collection.length;
	      }
	      var tag = getTag(collection);
	      if (tag == mapTag || tag == setTag) {
	        return collection.size;
	      }
	      return baseKeys(collection).length;
	    }

	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * Iteration is stopped once `predicate` returns truthy. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.some(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, guard) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined$1;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }

	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection thru each iteratee. This method
	     * performs a stable sort, that is, it preserves the original sort order of
	     * equal elements. The iteratees are invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 30 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.sortBy(users, [function(o) { return o.user; }]);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
	     *
	     * _.sortBy(users, ['user', 'age']);
	     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
	     */
	    var sortBy = baseRest(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var length = iteratees.length;
	      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	        iteratees = [];
	      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	        iteratees = [iteratees[0]];
	      }
	      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	    });

	    /*------------------------------------------------------------------------*/

	    /**
	     * Gets the timestamp of the number of milliseconds that have elapsed since
	     * the Unix epoch (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Date
	     * @returns {number} Returns the timestamp.
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => Logs the number of milliseconds it took for the deferred invocation.
	     */
	    var now = ctxNow || function() {
	      return root.Date.now();
	    };

	    /*------------------------------------------------------------------------*/

	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it's called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => Logs 'done saving!' after the two async saves have completed.
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }

	    /**
	     * Creates a function that invokes `func`, with up to `n` arguments,
	     * ignoring any additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      n = guard ? undefined$1 : n;
	      n = (func && n == null) ? func.length : n;
	      return createWrap(func, WRAP_ARY_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, n);
	    }

	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it's called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery(element).on('click', _.before(5, addContactToList));
	     * // => Allows adding up to 4 contacts to the list.
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined$1;
	        }
	        return result;
	      };
	    }

	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and `partials` prepended to the arguments it receives.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * function greet(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * }
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = baseRest(function(func, thisArg, partials) {
	      var bitmask = WRAP_BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bind));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(func, bitmask, thisArg, partials, holders);
	    });

	    /**
	     * Creates a function that invokes the method at `object[key]` with `partials`
	     * prepended to the arguments it receives.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist. See
	     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Function
	     * @param {Object} object The object to invoke the method on.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = baseRest(function(object, key, partials) {
	      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bindKey));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(key, bitmask, object, partials, holders);
	    });

	    /**
	     * Creates a function that accepts arguments of `func` and either invokes
	     * `func` returning its result, if at least `arity` number of arguments have
	     * been provided, or returns a function that accepts the remaining `func`
	     * arguments, and so on. The arity of `func` may be specified if `func.length`
	     * is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    function curry(func, arity, guard) {
	      arity = guard ? undefined$1 : arity;
	      var result = createWrap(func, WRAP_CURRY_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, undefined$1, arity);
	      result.placeholder = curry.placeholder;
	      return result;
	    }

	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    function curryRight(func, arity, guard) {
	      arity = guard ? undefined$1 : arity;
	      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, undefined$1, arity);
	      result.placeholder = curryRight.placeholder;
	      return result;
	    }

	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed `func` invocations and a `flush` method to immediately invoke them.
	     * Provide `options` to indicate whether `func` should be invoked on the
	     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	     * with the last arguments provided to the debounced function. Subsequent
	     * calls to the debounced function return the result of the last `func`
	     * invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the debounced function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=false]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {number} [options.maxWait]
	     *  The maximum time `func` is allowed to be delayed before it's invoked.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // Avoid costly calculations while the window size is in flux.
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	     * jQuery(element).on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', debounced);
	     *
	     * // Cancel the trailing debounced invocation.
	     * jQuery(window).on('popstate', debounced.cancel);
	     */
	    function debounce(func, wait, options) {
	      var lastArgs,
	          lastThis,
	          maxWait,
	          result,
	          timerId,
	          lastCallTime,
	          lastInvokeTime = 0,
	          leading = false,
	          maxing = false,
	          trailing = true;

	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = toNumber(wait) || 0;
	      if (isObject(options)) {
	        leading = !!options.leading;
	        maxing = 'maxWait' in options;
	        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }

	      function invokeFunc(time) {
	        var args = lastArgs,
	            thisArg = lastThis;

	        lastArgs = lastThis = undefined$1;
	        lastInvokeTime = time;
	        result = func.apply(thisArg, args);
	        return result;
	      }

	      function leadingEdge(time) {
	        // Reset any `maxWait` timer.
	        lastInvokeTime = time;
	        // Start the timer for the trailing edge.
	        timerId = setTimeout(timerExpired, wait);
	        // Invoke the leading edge.
	        return leading ? invokeFunc(time) : result;
	      }

	      function remainingWait(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime,
	            timeWaiting = wait - timeSinceLastCall;

	        return maxing
	          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
	          : timeWaiting;
	      }

	      function shouldInvoke(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime;

	        // Either this is the first call, activity has stopped and we're at the
	        // trailing edge, the system time has gone backwards and we're treating
	        // it as the trailing edge, or we've hit the `maxWait` limit.
	        return (lastCallTime === undefined$1 || (timeSinceLastCall >= wait) ||
	          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	      }

	      function timerExpired() {
	        var time = now();
	        if (shouldInvoke(time)) {
	          return trailingEdge(time);
	        }
	        // Restart the timer.
	        timerId = setTimeout(timerExpired, remainingWait(time));
	      }

	      function trailingEdge(time) {
	        timerId = undefined$1;

	        // Only invoke if we have `lastArgs` which means `func` has been
	        // debounced at least once.
	        if (trailing && lastArgs) {
	          return invokeFunc(time);
	        }
	        lastArgs = lastThis = undefined$1;
	        return result;
	      }

	      function cancel() {
	        if (timerId !== undefined$1) {
	          clearTimeout(timerId);
	        }
	        lastInvokeTime = 0;
	        lastArgs = lastCallTime = lastThis = timerId = undefined$1;
	      }

	      function flush() {
	        return timerId === undefined$1 ? result : trailingEdge(now());
	      }

	      function debounced() {
	        var time = now(),
	            isInvoking = shouldInvoke(time);

	        lastArgs = arguments;
	        lastThis = this;
	        lastCallTime = time;

	        if (isInvoking) {
	          if (timerId === undefined$1) {
	            return leadingEdge(lastCallTime);
	          }
	          if (maxing) {
	            // Handle invocations in a tight loop.
	            clearTimeout(timerId);
	            timerId = setTimeout(timerExpired, wait);
	            return invokeFunc(lastCallTime);
	          }
	        }
	        if (timerId === undefined$1) {
	          timerId = setTimeout(timerExpired, wait);
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      debounced.flush = flush;
	      return debounced;
	    }

	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // => Logs 'deferred' after one millisecond.
	     */
	    var defer = baseRest(function(func, args) {
	      return baseDelay(func, 1, args);
	    });

	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => Logs 'later' after one second.
	     */
	    var delay = baseRest(function(func, wait, args) {
	      return baseDelay(func, toNumber(wait) || 0, args);
	    });

	    /**
	     * Creates a function that invokes `func` with arguments reversed.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to flip arguments for.
	     * @returns {Function} Returns the new flipped function.
	     * @example
	     *
	     * var flipped = _.flip(function() {
	     *   return _.toArray(arguments);
	     * });
	     *
	     * flipped('a', 'b', 'c', 'd');
	     * // => ['d', 'c', 'b', 'a']
	     */
	    function flip(func) {
	      return createWrap(func, WRAP_FLIP_FLAG);
	    }

	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided, it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is used as the map cache key. The `func`
	     * is invoked with the `this` binding of the memoized function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the
	     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoized function.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     * var other = { 'c': 3, 'd': 4 };
	     *
	     * var values = _.memoize(_.values);
	     * values(object);
	     * // => [1, 2]
	     *
	     * values(other);
	     * // => [3, 4]
	     *
	     * object.a = 2;
	     * values(object);
	     * // => [1, 2]
	     *
	     * // Modify the result cache.
	     * values.cache.set(object, ['a', 'b']);
	     * values(object);
	     * // => ['a', 'b']
	     *
	     * // Replace `_.memoize.Cache`.
	     * _.memoize.Cache = WeakMap;
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;

	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result) || cache;
	        return result;
	      };
	      memoized.cache = new (memoize.Cache || MapCache);
	      return memoized;
	    }

	    // Expose `MapCache`.
	    memoize.Cache = MapCache;

	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new negated function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        var args = arguments;
	        switch (args.length) {
	          case 0: return !predicate.call(this);
	          case 1: return !predicate.call(this, args[0]);
	          case 2: return !predicate.call(this, args[0], args[1]);
	          case 3: return !predicate.call(this, args[0], args[1], args[2]);
	        }
	        return !predicate.apply(this, args);
	      };
	    }

	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first invocation. The `func` is
	     * invoked with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // => `createApplication` is invoked once
	     */
	    function once(func) {
	      return before(2, func);
	    }

	    /**
	     * Creates a function that invokes `func` with its arguments transformed.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms=[_.identity]]
	     *  The argument transforms.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var func = _.overArgs(function(x, y) {
	     *   return [x, y];
	     * }, [square, doubled]);
	     *
	     * func(9, 3);
	     * // => [81, 6]
	     *
	     * func(10, 5);
	     * // => [100, 10]
	     */
	    var overArgs = castRest(function(func, transforms) {
	      transforms = (transforms.length == 1 && isArray(transforms[0]))
	        ? arrayMap(transforms[0], baseUnary(getIteratee()))
	        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

	      var funcsLength = transforms.length;
	      return baseRest(function(args) {
	        var index = -1,
	            length = nativeMin(args.length, funcsLength);

	        while (++index < length) {
	          args[index] = transforms[index].call(this, args[index]);
	        }
	        return apply(func, this, args);
	      });
	    });

	    /**
	     * Creates a function that invokes `func` with `partials` prepended to the
	     * arguments it receives. This method is like `_.bind` except it does **not**
	     * alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.2.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // Partially applied with placeholders.
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partial));
	      return createWrap(func, WRAP_PARTIAL_FLAG, undefined$1, partials, holders);
	    });

	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to the arguments it receives.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // Partially applied with placeholders.
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partialRight));
	      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined$1, partials, holders);
	    });

	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified `indexes` where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, [2, 0, 1]);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     */
	    var rearg = flatRest(function(func, indexes) {
	      return createWrap(func, WRAP_REARG_FLAG, undefined$1, undefined$1, undefined$1, indexes);
	    });

	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as
	     * an array.
	     *
	     * **Note:** This method is based on the
	     * [rest parameter](https://mdn.io/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.rest(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function rest(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start === undefined$1 ? start : toInteger(start);
	      return baseRest(func, start);
	    }

	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * create function and an array of arguments much like
	     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
	     *
	     * **Note:** This method is based on the
	     * [spread operator](https://mdn.io/spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @param {number} [start=0] The start position of the spread.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start == null ? 0 : nativeMax(toInteger(start), 0);
	      return baseRest(function(args) {
	        var array = args[start],
	            otherArgs = castSlice(args, 0, start);

	        if (array) {
	          arrayPush(otherArgs, array);
	        }
	        return apply(func, this, otherArgs);
	      });
	    }

	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed `func` invocations and a `flush` method to
	     * immediately invoke them. Provide `options` to indicate whether `func`
	     * should be invoked on the leading and/or trailing edge of the `wait`
	     * timeout. The `func` is invoked with the last arguments provided to the
	     * throttled function. Subsequent calls to the throttled function return the
	     * result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the throttled function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=true]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // Avoid excessively updating the position while scrolling.
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	     * jQuery(element).on('click', throttled);
	     *
	     * // Cancel the trailing throttled invocation.
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;

	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, {
	        'leading': leading,
	        'maxWait': wait,
	        'trailing': trailing
	      });
	    }

	    /**
	     * Creates a function that accepts up to one argument, ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.unary(parseInt));
	     * // => [6, 8, 10]
	     */
	    function unary(func) {
	      return ary(func, 1);
	    }

	    /**
	     * Creates a function that provides `value` to `wrapper` as its first
	     * argument. Any additional arguments provided to the function are appended
	     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
	     * binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} [wrapper=identity] The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      return partial(castFunction(wrapper), value);
	    }

	    /*------------------------------------------------------------------------*/

	    /**
	     * Casts `value` as an array if it's not one.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Lang
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast array.
	     * @example
	     *
	     * _.castArray(1);
	     * // => [1]
	     *
	     * _.castArray({ 'a': 1 });
	     * // => [{ 'a': 1 }]
	     *
	     * _.castArray('abc');
	     * // => ['abc']
	     *
	     * _.castArray(null);
	     * // => [null]
	     *
	     * _.castArray(undefined);
	     * // => [undefined]
	     *
	     * _.castArray();
	     * // => []
	     *
	     * var array = [1, 2, 3];
	     * console.log(_.castArray(array) === array);
	     * // => true
	     */
	    function castArray() {
	      if (!arguments.length) {
	        return [];
	      }
	      var value = arguments[0];
	      return isArray(value) ? value : [value];
	    }

	    /**
	     * Creates a shallow clone of `value`.
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	     * and supports cloning arrays, array buffers, booleans, date objects, maps,
	     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	     * arrays. The own enumerable properties of `arguments` objects are cloned
	     * as plain objects. An empty object is returned for uncloneable values such
	     * as error objects, functions, DOM nodes, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeep
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var shallow = _.clone(objects);
	     * console.log(shallow[0] === objects[0]);
	     * // => true
	     */
	    function clone(value) {
	      return baseClone(value, CLONE_SYMBOLS_FLAG);
	    }

	    /**
	     * This method is like `_.clone` except that it accepts `customizer` which
	     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
	     * cloning is handled by the method instead. The `customizer` is invoked with
	     * up to four arguments; (value [, index|key, object, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeepWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * }
	     *
	     * var el = _.cloneWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 0
	     */
	    function cloneWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined$1;
	      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
	    }

	    /**
	     * This method is like `_.clone` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.clone
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var deep = _.cloneDeep(objects);
	     * console.log(deep[0] === objects[0]);
	     * // => false
	     */
	    function cloneDeep(value) {
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	    }

	    /**
	     * This method is like `_.cloneWith` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.cloneWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * }
	     *
	     * var el = _.cloneDeepWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 20
	     */
	    function cloneDeepWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined$1;
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
	    }

	    /**
	     * Checks if `object` conforms to `source` by invoking the predicate
	     * properties of `source` with the corresponding property values of `object`.
	     *
	     * **Note:** This method is equivalent to `_.conforms` when `source` is
	     * partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
	     * // => true
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
	     * // => false
	     */
	    function conformsTo(object, source) {
	      return source == null || baseConformsTo(object, source, keys(source));
	    }

	    /**
	     * Performs a
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * comparison between two values to determine if they are equivalent.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.eq(object, object);
	     * // => true
	     *
	     * _.eq(object, other);
	     * // => false
	     *
	     * _.eq('a', 'a');
	     * // => true
	     *
	     * _.eq('a', Object('a'));
	     * // => false
	     *
	     * _.eq(NaN, NaN);
	     * // => true
	     */
	    function eq(value, other) {
	      return value === other || (value !== value && other !== other);
	    }

	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     * @see _.lt
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    var gt = createRelationalOperation(baseGt);

	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to
	     *  `other`, else `false`.
	     * @see _.lte
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    var gte = createRelationalOperation(function(value, other) {
	      return value >= other;
	    });

	    /**
	     * Checks if `value` is likely an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	        !propertyIsEnumerable.call(value, 'callee');
	    };

	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(document.body.children);
	     * // => false
	     *
	     * _.isArray('abc');
	     * // => false
	     *
	     * _.isArray(_.noop);
	     * // => false
	     */
	    var isArray = Array.isArray;

	    /**
	     * Checks if `value` is classified as an `ArrayBuffer` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     * @example
	     *
	     * _.isArrayBuffer(new ArrayBuffer(2));
	     * // => true
	     *
	     * _.isArrayBuffer(new Array(2));
	     * // => false
	     */
	    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

	    /**
	     * Checks if `value` is array-like. A value is considered array-like if it's
	     * not a function and has a `value.length` that's an integer greater than or
	     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     * @example
	     *
	     * _.isArrayLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLike(document.body.children);
	     * // => true
	     *
	     * _.isArrayLike('abc');
	     * // => true
	     *
	     * _.isArrayLike(_.noop);
	     * // => false
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(value.length) && !isFunction(value);
	    }

	    /**
	     * This method is like `_.isArrayLike` except that it also checks if `value`
	     * is an object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array-like object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArrayLikeObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLikeObject(document.body.children);
	     * // => true
	     *
	     * _.isArrayLikeObject('abc');
	     * // => false
	     *
	     * _.isArrayLikeObject(_.noop);
	     * // => false
	     */
	    function isArrayLikeObject(value) {
	      return isObjectLike(value) && isArrayLike(value);
	    }

	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false ||
	        (isObjectLike(value) && baseGetTag(value) == boolTag);
	    }

	    /**
	     * Checks if `value` is a buffer.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	     * @example
	     *
	     * _.isBuffer(new Buffer(2));
	     * // => true
	     *
	     * _.isBuffer(new Uint8Array(2));
	     * // => false
	     */
	    var isBuffer = nativeIsBuffer || stubFalse;

	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

	    /**
	     * Checks if `value` is likely a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
	    }

	    /**
	     * Checks if `value` is an empty object, collection, map, or set.
	     *
	     * Objects are considered empty if they have no own enumerable string keyed
	     * properties.
	     *
	     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	     * jQuery-like collections are considered empty if they have a `length` of `0`.
	     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (value == null) {
	        return true;
	      }
	      if (isArrayLike(value) &&
	          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	        return !value.length;
	      }
	      var tag = getTag(value);
	      if (tag == mapTag || tag == setTag) {
	        return !value.size;
	      }
	      if (isPrototype(value)) {
	        return !baseKeys(value).length;
	      }
	      for (var key in value) {
	        if (hasOwnProperty.call(value, key)) {
	          return false;
	        }
	      }
	      return true;
	    }

	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent.
	     *
	     * **Note:** This method supports comparing arrays, array buffers, booleans,
	     * date objects, error objects, maps, numbers, `Object` objects, regexes,
	     * sets, strings, symbols, and typed arrays. `Object` objects are compared
	     * by their own, not inherited, enumerable properties. Functions and DOM
	     * nodes are compared by strict equality, i.e. `===`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * object === other;
	     * // => false
	     */
	    function isEqual(value, other) {
	      return baseIsEqual(value, other);
	    }

	    /**
	     * This method is like `_.isEqual` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with up to
	     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, othValue) {
	     *   if (isGreeting(objValue) && isGreeting(othValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqualWith(array, other, customizer);
	     * // => true
	     */
	    function isEqualWith(value, other, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined$1;
	      var result = customizer ? customizer(value, other) : undefined$1;
	      return result === undefined$1 ? baseIsEqual(value, other, undefined$1, customizer) : !!result;
	    }

	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      if (!isObjectLike(value)) {
	        return false;
	      }
	      var tag = baseGetTag(value);
	      return tag == errorTag || tag == domExcTag ||
	        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
	    }

	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on
	     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(3);
	     * // => true
	     *
	     * _.isFinite(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     *
	     * _.isFinite('3');
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }

	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      if (!isObject(value)) {
	        return false;
	      }
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in Safari 9 which returns 'object' for typed arrays and other constructors.
	      var tag = baseGetTag(value);
	      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	    }

	    /**
	     * Checks if `value` is an integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	     * @example
	     *
	     * _.isInteger(3);
	     * // => true
	     *
	     * _.isInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isInteger(Infinity);
	     * // => false
	     *
	     * _.isInteger('3');
	     * // => false
	     */
	    function isInteger(value) {
	      return typeof value == 'number' && value == toInteger(value);
	    }

	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     * @example
	     *
	     * _.isLength(3);
	     * // => true
	     *
	     * _.isLength(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isLength(Infinity);
	     * // => false
	     *
	     * _.isLength('3');
	     * // => false
	     */
	    function isLength(value) {
	      return typeof value == 'number' &&
	        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }

	    /**
	     * Checks if `value` is the
	     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(_.noop);
	     * // => true
	     *
	     * _.isObject(null);
	     * // => false
	     */
	    function isObject(value) {
	      var type = typeof value;
	      return value != null && (type == 'object' || type == 'function');
	    }

	    /**
	     * Checks if `value` is object-like. A value is object-like if it's not `null`
	     * and has a `typeof` result of "object".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	     * @example
	     *
	     * _.isObjectLike({});
	     * // => true
	     *
	     * _.isObjectLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isObjectLike(_.noop);
	     * // => false
	     *
	     * _.isObjectLike(null);
	     * // => false
	     */
	    function isObjectLike(value) {
	      return value != null && typeof value == 'object';
	    }

	    /**
	     * Checks if `value` is classified as a `Map` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     * @example
	     *
	     * _.isMap(new Map);
	     * // => true
	     *
	     * _.isMap(new WeakMap);
	     * // => false
	     */
	    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

	    /**
	     * Performs a partial deep comparison between `object` and `source` to
	     * determine if `object` contains equivalent property values.
	     *
	     * **Note:** This method is equivalent to `_.matches` when `source` is
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.isMatch(object, { 'b': 2 });
	     * // => true
	     *
	     * _.isMatch(object, { 'b': 1 });
	     * // => false
	     */
	    function isMatch(object, source) {
	      return object === source || baseIsMatch(object, source, getMatchData(source));
	    }

	    /**
	     * This method is like `_.isMatch` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with five
	     * arguments: (objValue, srcValue, index|key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatchWith(object, source, customizer);
	     * // => true
	     */
	    function isMatchWith(object, source, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined$1;
	      return baseIsMatch(object, source, getMatchData(source), customizer);
	    }

	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is based on
	     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	     * `undefined` and other non-number values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some
	      // ActiveX objects in IE.
	      return isNumber(value) && value != +value;
	    }

	    /**
	     * Checks if `value` is a pristine native function.
	     *
	     * **Note:** This method can't reliably detect native functions in the presence
	     * of the core-js package because core-js circumvents this kind of detection.
	     * Despite multiple requests, the core-js maintainer has made it clear: any
	     * attempt to fix the detection will be obstructed. As a result, we're left
	     * with little choice but to throw an error. Unfortunately, this also affects
	     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
	     * which rely on core-js.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (isMaskable(value)) {
	        throw new Error(CORE_ERROR_TEXT);
	      }
	      return baseIsNative(value);
	    }

	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }

	    /**
	     * Checks if `value` is `null` or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	     * @example
	     *
	     * _.isNil(null);
	     * // => true
	     *
	     * _.isNil(void 0);
	     * // => true
	     *
	     * _.isNil(NaN);
	     * // => false
	     */
	    function isNil(value) {
	      return value == null;
	    }

	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	     * classified as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	     * @example
	     *
	     * _.isNumber(3);
	     * // => true
	     *
	     * _.isNumber(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isNumber(Infinity);
	     * // => true
	     *
	     * _.isNumber('3');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' ||
	        (isObjectLike(value) && baseGetTag(value) == numberTag);
	    }

	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.8.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	        return false;
	      }
	      var proto = getPrototype(value);
	      if (proto === null) {
	        return true;
	      }
	      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	        funcToString.call(Ctor) == objectCtorString;
	    }

	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

	    /**
	     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
	     * double precision number which isn't the result of a rounded unsafe integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
	     * @example
	     *
	     * _.isSafeInteger(3);
	     * // => true
	     *
	     * _.isSafeInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isSafeInteger(Infinity);
	     * // => false
	     *
	     * _.isSafeInteger('3');
	     * // => false
	     */
	    function isSafeInteger(value) {
	      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
	    }

	    /**
	     * Checks if `value` is classified as a `Set` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     * @example
	     *
	     * _.isSet(new Set);
	     * // => true
	     *
	     * _.isSet(new WeakSet);
	     * // => false
	     */
	    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' ||
	        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	    }

	    /**
	     * Checks if `value` is classified as a `Symbol` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	     * @example
	     *
	     * _.isSymbol(Symbol.iterator);
	     * // => true
	     *
	     * _.isSymbol('abc');
	     * // => false
	     */
	    function isSymbol(value) {
	      return typeof value == 'symbol' ||
	        (isObjectLike(value) && baseGetTag(value) == symbolTag);
	    }

	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined$1;
	    }

	    /**
	     * Checks if `value` is classified as a `WeakMap` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
	     * @example
	     *
	     * _.isWeakMap(new WeakMap);
	     * // => true
	     *
	     * _.isWeakMap(new Map);
	     * // => false
	     */
	    function isWeakMap(value) {
	      return isObjectLike(value) && getTag(value) == weakMapTag;
	    }

	    /**
	     * Checks if `value` is classified as a `WeakSet` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
	     * @example
	     *
	     * _.isWeakSet(new WeakSet);
	     * // => true
	     *
	     * _.isWeakSet(new Set);
	     * // => false
	     */
	    function isWeakSet(value) {
	      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
	    }

	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     * @see _.gt
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    var lt = createRelationalOperation(baseLt);

	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to
	     *  `other`, else `false`.
	     * @see _.gte
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    var lte = createRelationalOperation(function(value, other) {
	      return value <= other;
	    });

	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * _.toArray({ 'a': 1, 'b': 2 });
	     * // => [1, 2]
	     *
	     * _.toArray('abc');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toArray(1);
	     * // => []
	     *
	     * _.toArray(null);
	     * // => []
	     */
	    function toArray(value) {
	      if (!value) {
	        return [];
	      }
	      if (isArrayLike(value)) {
	        return isString(value) ? stringToArray(value) : copyArray(value);
	      }
	      if (symIterator && value[symIterator]) {
	        return iteratorToArray(value[symIterator]());
	      }
	      var tag = getTag(value),
	          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

	      return func(value);
	    }

	    /**
	     * Converts `value` to a finite number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.12.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted number.
	     * @example
	     *
	     * _.toFinite(3.2);
	     * // => 3.2
	     *
	     * _.toFinite(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toFinite(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toFinite('3.2');
	     * // => 3.2
	     */
	    function toFinite(value) {
	      if (!value) {
	        return value === 0 ? value : 0;
	      }
	      value = toNumber(value);
	      if (value === INFINITY || value === -INFINITY) {
	        var sign = (value < 0 ? -1 : 1);
	        return sign * MAX_INTEGER;
	      }
	      return value === value ? value : 0;
	    }

	    /**
	     * Converts `value` to an integer.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toInteger(3.2);
	     * // => 3
	     *
	     * _.toInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toInteger(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toInteger('3.2');
	     * // => 3
	     */
	    function toInteger(value) {
	      var result = toFinite(value),
	          remainder = result % 1;

	      return result === result ? (remainder ? result - remainder : result) : 0;
	    }

	    /**
	     * Converts `value` to an integer suitable for use as the length of an
	     * array-like object.
	     *
	     * **Note:** This method is based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toLength(3.2);
	     * // => 3
	     *
	     * _.toLength(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toLength(Infinity);
	     * // => 4294967295
	     *
	     * _.toLength('3.2');
	     * // => 3
	     */
	    function toLength(value) {
	      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
	    }

	    /**
	     * Converts `value` to a number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     * @example
	     *
	     * _.toNumber(3.2);
	     * // => 3.2
	     *
	     * _.toNumber(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toNumber(Infinity);
	     * // => Infinity
	     *
	     * _.toNumber('3.2');
	     * // => 3.2
	     */
	    function toNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      if (isObject(value)) {
	        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	        value = isObject(other) ? (other + '') : other;
	      }
	      if (typeof value != 'string') {
	        return value === 0 ? value : +value;
	      }
	      value = baseTrim(value);
	      var isBinary = reIsBinary.test(value);
	      return (isBinary || reIsOctal.test(value))
	        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	        : (reIsBadHex.test(value) ? NAN : +value);
	    }

	    /**
	     * Converts `value` to a plain object flattening inherited enumerable string
	     * keyed properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return copyObject(value, keysIn(value));
	    }

	    /**
	     * Converts `value` to a safe integer. A safe integer can be compared and
	     * represented correctly.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toSafeInteger(3.2);
	     * // => 3
	     *
	     * _.toSafeInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toSafeInteger(Infinity);
	     * // => 9007199254740991
	     *
	     * _.toSafeInteger('3.2');
	     * // => 3
	     */
	    function toSafeInteger(value) {
	      return value
	        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
	        : (value === 0 ? value : 0);
	    }

	    /**
	     * Converts `value` to a string. An empty string is returned for `null`
	     * and `undefined` values. The sign of `-0` is preserved.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.toString(null);
	     * // => ''
	     *
	     * _.toString(-0);
	     * // => '-0'
	     *
	     * _.toString([1, 2, 3]);
	     * // => '1,2,3'
	     */
	    function toString(value) {
	      return value == null ? '' : baseToString(value);
	    }

	    /*------------------------------------------------------------------------*/

	    /**
	     * Assigns own enumerable string keyed properties of source objects to the
	     * destination object. Source objects are applied from left to right.
	     * Subsequent sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object` and is loosely based on
	     * [`Object.assign`](https://mdn.io/Object/assign).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assignIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assign({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var assign = createAssigner(function(object, source) {
	      if (isPrototype(source) || isArrayLike(source)) {
	        copyObject(source, keys(source), object);
	        return;
	      }
	      for (var key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          assignValue(object, key, source[key]);
	        }
	      }
	    });

	    /**
	     * This method is like `_.assign` except that it iterates over own and
	     * inherited source properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assign
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	     */
	    var assignIn = createAssigner(function(object, source) {
	      copyObject(source, keysIn(source), object);
	    });

	    /**
	     * This method is like `_.assignIn` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extendWith
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignInWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keysIn(source), object, customizer);
	    });

	    /**
	     * This method is like `_.assign` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignInWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keys(source), object, customizer);
	    });

	    /**
	     * Creates an array of values corresponding to `paths` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Array} Returns the picked values.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _.at(object, ['a[0].b.c', 'a[1]']);
	     * // => [3, 4]
	     */
	    var at = flatRest(baseAt);

	    /**
	     * Creates an object that inherits from the `prototype` object. If a
	     * `properties` object is given, its own enumerable string keyed properties
	     * are assigned to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties) {
	      var result = baseCreate(prototype);
	      return properties == null ? result : baseAssign(result, properties);
	    }

	    /**
	     * Assigns own and inherited enumerable string keyed properties of source
	     * objects to the destination object for all destination properties that
	     * resolve to `undefined`. Source objects are applied from left to right.
	     * Once a property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaultsDeep
	     * @example
	     *
	     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var defaults = baseRest(function(object, sources) {
	      object = Object(object);

	      var index = -1;
	      var length = sources.length;
	      var guard = length > 2 ? sources[2] : undefined$1;

	      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	        length = 1;
	      }

	      while (++index < length) {
	        var source = sources[index];
	        var props = keysIn(source);
	        var propsIndex = -1;
	        var propsLength = props.length;

	        while (++propsIndex < propsLength) {
	          var key = props[propsIndex];
	          var value = object[key];

	          if (value === undefined$1 ||
	              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	            object[key] = source[key];
	          }
	        }
	      }

	      return object;
	    });

	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaults
	     * @example
	     *
	     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
	     * // => { 'a': { 'b': 2, 'c': 3 } }
	     */
	    var defaultsDeep = baseRest(function(args) {
	      args.push(undefined$1, customDefaultsMerge);
	      return apply(mergeWith, undefined$1, args);
	    });

	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(o) { return o.age < 40; });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    function findKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
	    }

	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(o) { return o.age < 40; });
	     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    function findLastKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
	    }

	    /**
	     * Iterates over own and inherited enumerable string keyed properties of an
	     * object and invokes `iteratee` for each property. The iteratee is invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forInRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
	     */
	    function forIn(object, iteratee) {
	      return object == null
	        ? object
	        : baseFor(object, getIteratee(iteratee, 3), keysIn);
	    }

	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
	     */
	    function forInRight(object, iteratee) {
	      return object == null
	        ? object
	        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
	    }

	    /**
	     * Iterates over own enumerable string keyed properties of an object and
	     * invokes `iteratee` for each property. The iteratee is invoked with three
	     * arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwnRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forOwn(object, iteratee) {
	      return object && baseForOwn(object, getIteratee(iteratee, 3));
	    }

	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
	     */
	    function forOwnRight(object, iteratee) {
	      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
	    }

	    /**
	     * Creates an array of function property names from own enumerable properties
	     * of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functionsIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functions(new Foo);
	     * // => ['a', 'b']
	     */
	    function functions(object) {
	      return object == null ? [] : baseFunctions(object, keys(object));
	    }

	    /**
	     * Creates an array of function property names from own and inherited
	     * enumerable properties of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functions
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functionsIn(new Foo);
	     * // => ['a', 'b', 'c']
	     */
	    function functionsIn(object) {
	      return object == null ? [] : baseFunctions(object, keysIn(object));
	    }

	    /**
	     * Gets the value at `path` of `object`. If the resolved value is
	     * `undefined`, the `defaultValue` is returned in its place.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined$1 : baseGet(object, path);
	      return result === undefined$1 ? defaultValue : result;
	    }

	    /**
	     * Checks if `path` is a direct property of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': 2 } };
	     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b');
	     * // => true
	     *
	     * _.has(object, ['a', 'b']);
	     * // => true
	     *
	     * _.has(other, 'a');
	     * // => false
	     */
	    function has(object, path) {
	      return object != null && hasPath(object, path, baseHas);
	    }

	    /**
	     * Checks if `path` is a direct or inherited property of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.hasIn(object, 'a');
	     * // => true
	     *
	     * _.hasIn(object, 'a.b');
	     * // => true
	     *
	     * _.hasIn(object, ['a', 'b']);
	     * // => true
	     *
	     * _.hasIn(object, 'b');
	     * // => false
	     */
	    function hasIn(object, path) {
	      return object != null && hasPath(object, path, baseHasIn);
	    }

	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite
	     * property assignments of previous values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     */
	    var invert = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }

	      result[value] = key;
	    }, constant(identity));

	    /**
	     * This method is like `_.invert` except that the inverted object is generated
	     * from the results of running each element of `object` thru `iteratee`. The
	     * corresponding inverted value of each inverted key is an array of keys
	     * responsible for generating the inverted value. The iteratee is invoked
	     * with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invertBy(object);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     *
	     * _.invertBy(object, function(value) {
	     *   return 'group' + value;
	     * });
	     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
	     */
	    var invertBy = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }

	      if (hasOwnProperty.call(result, value)) {
	        result[value].push(key);
	      } else {
	        result[value] = [key];
	      }
	    }, getIteratee);

	    /**
	     * Invokes the method at `path` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	     *
	     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	     * // => [2, 3]
	     */
	    var invoke = baseRest(baseInvoke);

	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    function keys(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	    }

	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	    }

	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	     * with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapValues
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    function mapKeys(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);

	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, iteratee(value, key, object), value);
	      });
	      return result;
	    }

	    /**
	     * Creates an object with the same keys as `object` and values generated
	     * by running each own enumerable string keyed property of `object` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapKeys
	     * @example
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * _.mapValues(users, function(o) { return o.age; });
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    function mapValues(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);

	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, key, iteratee(value, key, object));
	      });
	      return result;
	    }

	    /**
	     * This method is like `_.assign` except that it recursively merges own and
	     * inherited enumerable string keyed properties of source objects into the
	     * destination object. Source properties that resolve to `undefined` are
	     * skipped if a destination value exists. Array and plain object properties
	     * are merged recursively. Other objects and value types are overridden by
	     * assignment. Source objects are applied from left to right. Subsequent
	     * sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {
	     *   'a': [{ 'b': 2 }, { 'd': 4 }]
	     * };
	     *
	     * var other = {
	     *   'a': [{ 'c': 3 }, { 'e': 5 }]
	     * };
	     *
	     * _.merge(object, other);
	     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	     */
	    var merge = createAssigner(function(object, source, srcIndex) {
	      baseMerge(object, source, srcIndex);
	    });

	    /**
	     * This method is like `_.merge` except that it accepts `customizer` which
	     * is invoked to produce the merged values of the destination and source
	     * properties. If `customizer` returns `undefined`, merging is handled by the
	     * method instead. The `customizer` is invoked with six arguments:
	     * (objValue, srcValue, key, object, source, stack).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (_.isArray(objValue)) {
	     *     return objValue.concat(srcValue);
	     *   }
	     * }
	     *
	     * var object = { 'a': [1], 'b': [2] };
	     * var other = { 'a': [3], 'b': [4] };
	     *
	     * _.mergeWith(object, other, customizer);
	     * // => { 'a': [1, 3], 'b': [2, 4] }
	     */
	    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
	      baseMerge(object, source, srcIndex, customizer);
	    });

	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable property paths of `object` that are not omitted.
	     *
	     * **Note:** This method is considerably slower than `_.pick`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to omit.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omit(object, ['a', 'c']);
	     * // => { 'b': '2' }
	     */
	    var omit = flatRest(function(object, paths) {
	      var result = {};
	      if (object == null) {
	        return result;
	      }
	      var isDeep = false;
	      paths = arrayMap(paths, function(path) {
	        path = castPath(path, object);
	        isDeep || (isDeep = path.length > 1);
	        return path;
	      });
	      copyObject(object, getAllKeysIn(object), result);
	      if (isDeep) {
	        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	      }
	      var length = paths.length;
	      while (length--) {
	        baseUnset(result, paths[length]);
	      }
	      return result;
	    });

	    /**
	     * The opposite of `_.pickBy`; this method creates an object composed of
	     * the own and inherited enumerable string keyed properties of `object` that
	     * `predicate` doesn't return truthy for. The predicate is invoked with two
	     * arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omitBy(object, _.isNumber);
	     * // => { 'b': '2' }
	     */
	    function omitBy(object, predicate) {
	      return pickBy(object, negate(getIteratee(predicate)));
	    }

	    /**
	     * Creates an object composed of the picked `object` properties.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pick(object, ['a', 'c']);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var pick = flatRest(function(object, paths) {
	      return object == null ? {} : basePick(object, paths);
	    });

	    /**
	     * Creates an object composed of the `object` properties `predicate` returns
	     * truthy for. The predicate is invoked with two arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pickBy(object, _.isNumber);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    function pickBy(object, predicate) {
	      if (object == null) {
	        return {};
	      }
	      var props = arrayMap(getAllKeysIn(object), function(prop) {
	        return [prop];
	      });
	      predicate = getIteratee(predicate);
	      return basePickBy(object, props, function(value, path) {
	        return predicate(value, path[0]);
	      });
	    }

	    /**
	     * This method is like `_.get` except that if the resolved value is a
	     * function it's invoked with the `this` binding of its parent object and
	     * its result is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a[0].b.c3', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a[0].b.c3', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      path = castPath(path, object);

	      var index = -1,
	          length = path.length;

	      // Ensure the loop is entered when path is empty.
	      if (!length) {
	        length = 1;
	        object = undefined$1;
	      }
	      while (++index < length) {
	        var value = object == null ? undefined$1 : object[toKey(path[index])];
	        if (value === undefined$1) {
	          index = length;
	          value = defaultValue;
	        }
	        object = isFunction(value) ? value.call(object) : value;
	      }
	      return object;
	    }

	    /**
	     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	     * it's created. Arrays are created for missing index properties while objects
	     * are created for all other missing properties. Use `_.setWith` to customize
	     * `path` creation.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, ['x', '0', 'y', 'z'], 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      return object == null ? object : baseSet(object, path, value);
	    }

	    /**
	     * This method is like `_.set` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.setWith(object, '[0][1]', 'a', Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function setWith(object, path, value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined$1;
	      return object == null ? object : baseSet(object, path, value, customizer);
	    }

	    /**
	     * Creates an array of own enumerable string keyed-value pairs for `object`
	     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	     * entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entries
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairs(new Foo);
	     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	     */
	    var toPairs = createToPairs(keys);

	    /**
	     * Creates an array of own and inherited enumerable string keyed-value pairs
	     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
	     * or set, its entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entriesIn
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairsIn(new Foo);
	     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
	     */
	    var toPairsIn = createToPairs(keysIn);

	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own
	     * enumerable string keyed properties thru `iteratee`, with each invocation
	     * potentially mutating the `accumulator` object. If `accumulator` is not
	     * provided, a new object with the same `[[Prototype]]` will be used. The
	     * iteratee is invoked with four arguments: (accumulator, value, key, object).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * }, []);
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function transform(object, iteratee, accumulator) {
	      var isArr = isArray(object),
	          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

	      iteratee = getIteratee(iteratee, 4);
	      if (accumulator == null) {
	        var Ctor = object && object.constructor;
	        if (isArrLike) {
	          accumulator = isArr ? new Ctor : [];
	        }
	        else if (isObject(object)) {
	          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
	        }
	        else {
	          accumulator = {};
	        }
	      }
	      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }

	    /**
	     * Removes the property at `path` of `object`.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	     * _.unset(object, 'a[0].b.c');
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     *
	     * _.unset(object, ['a', '0', 'b', 'c']);
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     */
	    function unset(object, path) {
	      return object == null ? true : baseUnset(object, path);
	    }

	    /**
	     * This method is like `_.set` except that accepts `updater` to produce the
	     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
	     * is invoked with one argument: (value).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
	     * console.log(object.a[0].b.c);
	     * // => 9
	     *
	     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
	     * console.log(object.x[0].y.z);
	     * // => 0
	     */
	    function update(object, path, updater) {
	      return object == null ? object : baseUpdate(object, path, castFunction(updater));
	    }

	    /**
	     * This method is like `_.update` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function updateWith(object, path, updater, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined$1;
	      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
	    }

	    /**
	     * Creates an array of the own enumerable string keyed property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return object == null ? [] : baseValues(object, keys(object));
	    }

	    /**
	     * Creates an array of the own and inherited enumerable string keyed property
	     * values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return object == null ? [] : baseValues(object, keysIn(object));
	    }

	    /*------------------------------------------------------------------------*/

	    /**
	     * Clamps `number` within the inclusive `lower` and `upper` bounds.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Number
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     * @example
	     *
	     * _.clamp(-10, -5, 5);
	     * // => -5
	     *
	     * _.clamp(10, -5, 5);
	     * // => 5
	     */
	    function clamp(number, lower, upper) {
	      if (upper === undefined$1) {
	        upper = lower;
	        lower = undefined$1;
	      }
	      if (upper !== undefined$1) {
	        upper = toNumber(upper);
	        upper = upper === upper ? upper : 0;
	      }
	      if (lower !== undefined$1) {
	        lower = toNumber(lower);
	        lower = lower === lower ? lower : 0;
	      }
	      return baseClamp(toNumber(number), lower, upper);
	    }

	    /**
	     * Checks if `n` is between `start` and up to, but not including, `end`. If
	     * `end` is not specified, it's set to `start` with `start` then set to `0`.
	     * If `start` is greater than `end` the params are swapped to support
	     * negative ranges.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.3.0
	     * @category Number
	     * @param {number} number The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     * @see _.range, _.rangeRight
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     *
	     * _.inRange(-3, -2, -6);
	     * // => true
	     */
	    function inRange(number, start, end) {
	      start = toFinite(start);
	      if (end === undefined$1) {
	        end = start;
	        start = 0;
	      } else {
	        end = toFinite(end);
	      }
	      number = toNumber(number);
	      return baseInRange(number, start, end);
	    }

	    /**
	     * Produces a random number between the inclusive `lower` and `upper` bounds.
	     * If only one argument is provided a number between `0` and the given number
	     * is returned. If `floating` is `true`, or either `lower` or `upper` are
	     * floats, a floating-point number is returned instead of an integer.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Number
	     * @param {number} [lower=0] The lower bound.
	     * @param {number} [upper=1] The upper bound.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(lower, upper, floating) {
	      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
	        upper = floating = undefined$1;
	      }
	      if (floating === undefined$1) {
	        if (typeof upper == 'boolean') {
	          floating = upper;
	          upper = undefined$1;
	        }
	        else if (typeof lower == 'boolean') {
	          floating = lower;
	          lower = undefined$1;
	        }
	      }
	      if (lower === undefined$1 && upper === undefined$1) {
	        lower = 0;
	        upper = 1;
	      }
	      else {
	        lower = toFinite(lower);
	        if (upper === undefined$1) {
	          upper = lower;
	          lower = 0;
	        } else {
	          upper = toFinite(upper);
	        }
	      }
	      if (lower > upper) {
	        var temp = lower;
	        lower = upper;
	        upper = temp;
	      }
	      if (floating || lower % 1 || upper % 1) {
	        var rand = nativeRandom();
	        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
	      }
	      return baseRandom(lower, upper);
	    }

	    /*------------------------------------------------------------------------*/

	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar--');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__FOO_BAR__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? capitalize(word) : word);
	    });

	    /**
	     * Converts the first character of `string` to upper case and the remaining
	     * to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('FRED');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      return upperFirst(toString(string).toLowerCase());
	    }

	    /**
	     * Deburrs `string` by converting
	     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	     * letters to basic Latin letters and removing
	     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = toString(string);
	      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	    }

	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search up to.
	     * @returns {boolean} Returns `true` if `string` ends with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = toString(string);
	      target = baseToString(target);

	      var length = string.length;
	      position = position === undefined$1
	        ? length
	        : baseClamp(toInteger(position), 0, length);

	      var end = position;
	      position -= target.length;
	      return position >= 0 && string.slice(position, end) == target;
	    }

	    /**
	     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
	     * corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional
	     * characters use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value. See
	     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * When working with HTML you should always
	     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
	     * XSS vectors.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      string = toString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }

	    /**
	     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https://lodash\.com/\)'
	     */
	    function escapeRegExp(string) {
	      string = toString(string);
	      return (string && reHasRegExpChar.test(string))
	        ? string.replace(reRegExpChar, '\\$&')
	        : string;
	    }

	    /**
	     * Converts `string` to
	     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__FOO_BAR__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });

	    /**
	     * Converts `string`, as space separated words, to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.lowerCase('--Foo-Bar--');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('fooBar');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('__FOO_BAR__');
	     * // => 'foo bar'
	     */
	    var lowerCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toLowerCase();
	    });

	    /**
	     * Converts the first character of `string` to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.lowerFirst('Fred');
	     * // => 'fred'
	     *
	     * _.lowerFirst('FRED');
	     * // => 'fRED'
	     */
	    var lowerFirst = createCaseFirst('toLowerCase');

	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);

	      var strLength = length ? stringSize(string) : 0;
	      if (!length || strLength >= length) {
	        return string;
	      }
	      var mid = (length - strLength) / 2;
	      return (
	        createPadding(nativeFloor(mid), chars) +
	        string +
	        createPadding(nativeCeil(mid), chars)
	      );
	    }

	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padEnd('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padEnd('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padEnd('abc', 3);
	     * // => 'abc'
	     */
	    function padEnd(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);

	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (string + createPadding(length - strLength, chars))
	        : string;
	    }

	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padStart('abc', 6);
	     * // => '   abc'
	     *
	     * _.padStart('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padStart('abc', 3);
	     * // => 'abc'
	     */
	    function padStart(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);

	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (createPadding(length - strLength, chars) + string)
	        : string;
	    }

	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
	     * hexadecimal, in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the
	     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix=10] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      if (guard || radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
	    }

	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=1] The number of times to repeat the string.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n, guard) {
	      if ((guard ? isIterateeCall(string, n, guard) : n === undefined$1)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      return baseRepeat(toString(string), n);
	    }

	    /**
	     * Replaces matches for `pattern` in `string` with `replacement`.
	     *
	     * **Note:** This method is based on
	     * [`String#replace`](https://mdn.io/String/replace).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to modify.
	     * @param {RegExp|string} pattern The pattern to replace.
	     * @param {Function|string} replacement The match replacement.
	     * @returns {string} Returns the modified string.
	     * @example
	     *
	     * _.replace('Hi Fred', 'Fred', 'Barney');
	     * // => 'Hi Barney'
	     */
	    function replace() {
	      var args = arguments,
	          string = toString(args[0]);

	      return args.length < 3 ? string : string.replace(args[1], args[2]);
	    }

	    /**
	     * Converts `string` to
	     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--FOO-BAR--');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });

	    /**
	     * Splits `string` by `separator`.
	     *
	     * **Note:** This method is based on
	     * [`String#split`](https://mdn.io/String/split).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to split.
	     * @param {RegExp|string} separator The separator pattern to split by.
	     * @param {number} [limit] The length to truncate results to.
	     * @returns {Array} Returns the string segments.
	     * @example
	     *
	     * _.split('a-b-c', '-', 2);
	     * // => ['a', 'b']
	     */
	    function split(string, separator, limit) {
	      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
	        separator = limit = undefined$1;
	      }
	      limit = limit === undefined$1 ? MAX_ARRAY_LENGTH : limit >>> 0;
	      if (!limit) {
	        return [];
	      }
	      string = toString(string);
	      if (string && (
	            typeof separator == 'string' ||
	            (separator != null && !isRegExp(separator))
	          )) {
	        separator = baseToString(separator);
	        if (!separator && hasUnicode(string)) {
	          return castSlice(stringToArray(string), 0, limit);
	        }
	      }
	      return string.split(separator, limit);
	    }

	    /**
	     * Converts `string` to
	     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.1.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar--');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__FOO_BAR__');
	     * // => 'FOO BAR'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + upperFirst(word);
	    });

	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = toString(string);
	      position = position == null
	        ? 0
	        : baseClamp(toInteger(position), 0, string.length);

	      target = baseToString(target);
	      return string.slice(position, position + target.length) == target;
	    }

	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is given, it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options={}] The options object.
	     * @param {RegExp} [options.escape=_.templateSettings.escape]
	     *  The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
	     *  The "evaluate" delimiter.
	     * @param {Object} [options.imports=_.templateSettings.imports]
	     *  An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
	     *  The "interpolate" delimiter.
	     * @param {string} [options.sourceURL='lodash.templateSources[n]']
	     *  The sourceURL of the compiled template.
	     * @param {string} [options.variable='obj']
	     *  The data object variable name.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // Use the "interpolate" delimiter to create a compiled template.
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // Use the HTML "escape" delimiter to escape data property values.
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the internal `print` function in "evaluate" delimiters.
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // Use the ES template literal delimiter as an "interpolate" delimiter.
	     * // Disable support by replacing the "interpolate" delimiter.
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // Use backslashes to treat delimiters as plain text.
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // Use the `imports` option to import `jQuery` as `jq`.
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
	     *
	     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // Use custom template delimiters.
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // Use the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and stack traces.
	     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, guard) {
	      // Based on John Resig's `tmpl` implementation
	      // (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;

	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined$1;
	      }
	      string = toString(string);
	      options = assignInWith({}, options, settings, customDefaultsAssignIn);

	      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);

	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";

	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');

	      // Use a sourceURL for easier debugging.
	      // The sourceURL gets injected into the source that's eval-ed, so be careful
	      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
	      // and escape the comment, thus injecting code that gets evaled.
	      var sourceURL = '//# sourceURL=' +
	        (hasOwnProperty.call(options, 'sourceURL')
	          ? (options.sourceURL + '').replace(/\s/g, ' ')
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';

	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);

	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;

	        // The JS engine embedded in Adobe products needs `match` returned in
	        // order to produce the correct `offset` value.
	        return match;
	      });

	      source += "';\n";

	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Throw an error if a forbidden character was found in `variable`, to prevent
	      // potential command injection attacks.
	      else if (reForbiddenIdentifierChars.test(variable)) {
	        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
	      }

	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');

	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';

	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source)
	          .apply(undefined$1, importsValues);
	      });

	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }

	    /**
	     * Converts `string`, as a whole, to lower case just like
	     * [String#toLowerCase](https://mdn.io/toLowerCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.toLower('--Foo-Bar--');
	     * // => '--foo-bar--'
	     *
	     * _.toLower('fooBar');
	     * // => 'foobar'
	     *
	     * _.toLower('__FOO_BAR__');
	     * // => '__foo_bar__'
	     */
	    function toLower(value) {
	      return toString(value).toLowerCase();
	    }

	    /**
	     * Converts `string`, as a whole, to upper case just like
	     * [String#toUpperCase](https://mdn.io/toUpperCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.toUpper('--foo-bar--');
	     * // => '--FOO-BAR--'
	     *
	     * _.toUpper('fooBar');
	     * // => 'FOOBAR'
	     *
	     * _.toUpper('__foo_bar__');
	     * // => '__FOO_BAR__'
	     */
	    function toUpper(value) {
	      return toString(value).toUpperCase();
	    }

	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined$1)) {
	        return baseTrim(string);
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          chrSymbols = stringToArray(chars),
	          start = charsStartIndex(strSymbols, chrSymbols),
	          end = charsEndIndex(strSymbols, chrSymbols) + 1;

	      return castSlice(strSymbols, start, end).join('');
	    }

	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimEnd('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimEnd('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimEnd(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined$1)) {
	        return string.slice(0, trimmedEndIndex(string) + 1);
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

	      return castSlice(strSymbols, 0, end).join('');
	    }

	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimStart('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimStart('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimStart(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined$1)) {
	        return string.replace(reTrimStart, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          start = charsStartIndex(strSymbols, stringToArray(chars));

	      return castSlice(strSymbols, start).join('');
	    }

	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object} [options={}] The options object.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.truncate('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function truncate(string, options) {
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;

	      if (isObject(options)) {
	        var separator = 'separator' in options ? options.separator : separator;
	        length = 'length' in options ? toInteger(options.length) : length;
	        omission = 'omission' in options ? baseToString(options.omission) : omission;
	      }
	      string = toString(string);

	      var strLength = string.length;
	      if (hasUnicode(string)) {
	        var strSymbols = stringToArray(string);
	        strLength = strSymbols.length;
	      }
	      if (length >= strLength) {
	        return string;
	      }
	      var end = length - stringSize(omission);
	      if (end < 1) {
	        return omission;
	      }
	      var result = strSymbols
	        ? castSlice(strSymbols, 0, end).join('')
	        : string.slice(0, end);

	      if (separator === undefined$1) {
	        return result + omission;
	      }
	      if (strSymbols) {
	        end += (result.length - end);
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              substring = result;

	          if (!separator.global) {
	            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            var newEnd = match.index;
	          }
	          result = result.slice(0, newEnd === undefined$1 ? end : newEnd);
	        }
	      } else if (string.indexOf(baseToString(separator), end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }

	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
	     * their corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional
	     * HTML entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.6.0
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = toString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }

	    /**
	     * Converts `string`, as space separated words, to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.upperCase('--foo-bar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('fooBar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('__foo_bar__');
	     * // => 'FOO BAR'
	     */
	    var upperCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toUpperCase();
	    });

	    /**
	     * Converts the first character of `string` to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.upperFirst('fred');
	     * // => 'Fred'
	     *
	     * _.upperFirst('FRED');
	     * // => 'FRED'
	     */
	    var upperFirst = createCaseFirst('toUpperCase');

	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      string = toString(string);
	      pattern = guard ? undefined$1 : pattern;

	      if (pattern === undefined$1) {
	        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	      }
	      return string.match(pattern) || [];
	    }

	    /*------------------------------------------------------------------------*/

	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Function} func The function to attempt.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // Avoid throwing errors for invalid selectors.
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = baseRest(function(func, args) {
	      try {
	        return apply(func, undefined$1, args);
	      } catch (e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });

	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method.
	     *
	     * **Note:** This method doesn't set the "length" property of bound functions.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} methodNames The object method names to bind.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'click': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view, ['click']);
	     * jQuery(element).on('click', view.click);
	     * // => Logs 'clicked docs' when clicked.
	     */
	    var bindAll = flatRest(function(object, methodNames) {
	      arrayEach(methodNames, function(key) {
	        key = toKey(key);
	        baseAssignValue(object, key, bind(object[key], object));
	      });
	      return object;
	    });

	    /**
	     * Creates a function that iterates over `pairs` and invokes the corresponding
	     * function of the first predicate to return truthy. The predicate-function
	     * pairs are invoked with the `this` binding and arguments of the created
	     * function.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Array} pairs The predicate-function pairs.
	     * @returns {Function} Returns the new composite function.
	     * @example
	     *
	     * var func = _.cond([
	     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
	     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
	     *   [_.stubTrue,                      _.constant('no match')]
	     * ]);
	     *
	     * func({ 'a': 1, 'b': 2 });
	     * // => 'matches A'
	     *
	     * func({ 'a': 0, 'b': 1 });
	     * // => 'matches B'
	     *
	     * func({ 'a': '1', 'b': '2' });
	     * // => 'no match'
	     */
	    function cond(pairs) {
	      var length = pairs == null ? 0 : pairs.length,
	          toIteratee = getIteratee();

	      pairs = !length ? [] : arrayMap(pairs, function(pair) {
	        if (typeof pair[1] != 'function') {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	        return [toIteratee(pair[0]), pair[1]];
	      });

	      return baseRest(function(args) {
	        var index = -1;
	        while (++index < length) {
	          var pair = pairs[index];
	          if (apply(pair[0], this, args)) {
	            return apply(pair[1], this, args);
	          }
	        }
	      });
	    }

	    /**
	     * Creates a function that invokes the predicate properties of `source` with
	     * the corresponding property values of a given object, returning `true` if
	     * all predicates return truthy, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.conformsTo` with
	     * `source` partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 2, 'b': 1 },
	     *   { 'a': 1, 'b': 2 }
	     * ];
	     *
	     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
	     * // => [{ 'a': 1, 'b': 2 }]
	     */
	    function conforms(source) {
	      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
	    }

	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new constant function.
	     * @example
	     *
	     * var objects = _.times(2, _.constant({ 'a': 1 }));
	     *
	     * console.log(objects);
	     * // => [{ 'a': 1 }, { 'a': 1 }]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }

	    /**
	     * Checks `value` to determine whether a default value should be returned in
	     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
	     * or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Util
	     * @param {*} value The value to check.
	     * @param {*} defaultValue The default value.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * _.defaultTo(1, 10);
	     * // => 1
	     *
	     * _.defaultTo(undefined, 10);
	     * // => 10
	     */
	    function defaultTo(value, defaultValue) {
	      return (value == null || value !== value) ? defaultValue : value;
	    }

	    /**
	     * Creates a function that returns the result of invoking the given functions
	     * with the `this` binding of the created function, where each successive
	     * invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flowRight
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow([_.add, square]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();

	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the given functions from right to left.
	     *
	     * @static
	     * @since 3.0.0
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flow
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight([square, _.add]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);

	    /**
	     * This method returns the first argument it receives.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     *
	     * console.log(_.identity(object) === object);
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }

	    /**
	     * Creates a function that invokes `func` with the arguments of the created
	     * function. If `func` is a property name, the created function returns the
	     * property value for a given element. If `func` is an array or object, the
	     * created function returns `true` for elements that contain the equivalent
	     * source properties, otherwise it returns `false`.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Util
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, _.iteratee(['user', 'fred']));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, _.iteratee('user'));
	     * // => ['barney', 'fred']
	     *
	     * // Create custom iteratee shorthands.
	     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	     *     return func.test(string);
	     *   };
	     * });
	     *
	     * _.filter(['abc', 'def'], /ef/);
	     * // => ['def']
	     */
	    function iteratee(func) {
	      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
	    }

	    /**
	     * Creates a function that performs a partial deep comparison between a given
	     * object and `source`, returning `true` if the given object has equivalent
	     * property values, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.isMatch` with `source`
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * **Note:** Multiple values can be checked by combining several matchers
	     * using `_.overSome`
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
	     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
	     *
	     * // Checking for several possible values
	     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
	     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
	    }

	    /**
	     * Creates a function that performs a partial deep comparison between the
	     * value at `path` of a given object to `srcValue`, returning `true` if the
	     * object value is equivalent, else `false`.
	     *
	     * **Note:** Partial comparisons will match empty array and empty object
	     * `srcValue` values against any array or object value, respectively. See
	     * `_.isEqual` for a list of supported value comparisons.
	     *
	     * **Note:** Multiple values can be checked by combining several matchers
	     * using `_.overSome`
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.find(objects, _.matchesProperty('a', 4));
	     * // => { 'a': 4, 'b': 5, 'c': 6 }
	     *
	     * // Checking for several possible values
	     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
	     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
	    }

	    /**
	     * Creates a function that invokes the method at `path` of a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': _.constant(2) } },
	     *   { 'a': { 'b': _.constant(1) } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(objects, _.method(['a', 'b']));
	     * // => [2, 1]
	     */
	    var method = baseRest(function(path, args) {
	      return function(object) {
	        return baseInvoke(object, path, args);
	      };
	    });

	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path of `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = baseRest(function(object, args) {
	      return function(path) {
	        return baseInvoke(object, path, args);
	      };
	    });

	    /**
	     * Adds all own enumerable string keyed function properties of a source
	     * object to the destination object. If `object` is a function, then methods
	     * are added to its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      var props = keys(source),
	          methodNames = baseFunctions(source, props);

	      if (options == null &&
	          !(isObject(source) && (methodNames.length || !props.length))) {
	        options = source;
	        source = object;
	        object = this;
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
	          isFunc = isFunction(object);

	      arrayEach(methodNames, function(methodName) {
	        var func = source[methodName];
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = function() {
	            var chainAll = this.__chain__;
	            if (chain || chainAll) {
	              var result = object(this.__wrapped__),
	                  actions = result.__actions__ = copyArray(this.__actions__);

	              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	              result.__chain__ = chainAll;
	              return result;
	            }
	            return func.apply(object, arrayPush([this.value()], arguments));
	          };
	        }
	      });

	      return object;
	    }

	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      if (root._ === this) {
	        root._ = oldDash;
	      }
	      return this;
	    }

	    /**
	     * This method returns `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Util
	     * @example
	     *
	     * _.times(2, _.noop);
	     * // => [undefined, undefined]
	     */
	    function noop() {
	      // No operation performed.
	    }

	    /**
	     * Creates a function that gets the argument at index `n`. If `n` is negative,
	     * the nth argument from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [n=0] The index of the argument to return.
	     * @returns {Function} Returns the new pass-thru function.
	     * @example
	     *
	     * var func = _.nthArg(1);
	     * func('a', 'b', 'c', 'd');
	     * // => 'b'
	     *
	     * var func = _.nthArg(-2);
	     * func('a', 'b', 'c', 'd');
	     * // => 'c'
	     */
	    function nthArg(n) {
	      n = toInteger(n);
	      return baseRest(function(args) {
	        return baseNth(args, n);
	      });
	    }

	    /**
	     * Creates a function that invokes `iteratees` with the arguments it receives
	     * and returns their results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.over([Math.max, Math.min]);
	     *
	     * func(1, 2, 3, 4);
	     * // => [4, 1]
	     */
	    var over = createOver(arrayMap);

	    /**
	     * Creates a function that checks if **all** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * Following shorthands are possible for providing predicates.
	     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
	     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overEvery([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => false
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overEvery = createOver(arrayEvery);

	    /**
	     * Creates a function that checks if **any** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * Following shorthands are possible for providing predicates.
	     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
	     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overSome([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => true
	     *
	     * func(NaN);
	     * // => false
	     *
	     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
	     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
	     */
	    var overSome = createOver(arraySome);

	    /**
	     * Creates a function that returns the value at `path` of a given object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': 2 } },
	     *   { 'a': { 'b': 1 } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	    }

	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the value at a given path of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return object == null ? undefined$1 : baseGet(object, path);
	      };
	    }

	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	     * `start` is specified without an `end` or `step`. If `end` is not specified,
	     * it's set to `start` with `start` then set to `0`.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.rangeRight
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(-4);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    var range = createRange();

	    /**
	     * This method is like `_.range` except that it populates values in
	     * descending order.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.range
	     * @example
	     *
	     * _.rangeRight(4);
	     * // => [3, 2, 1, 0]
	     *
	     * _.rangeRight(-4);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 5);
	     * // => [4, 3, 2, 1]
	     *
	     * _.rangeRight(0, 20, 5);
	     * // => [15, 10, 5, 0]
	     *
	     * _.rangeRight(0, -4, -1);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.rangeRight(0);
	     * // => []
	     */
	    var rangeRight = createRange(true);

	    /**
	     * This method returns a new empty array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Array} Returns the new empty array.
	     * @example
	     *
	     * var arrays = _.times(2, _.stubArray);
	     *
	     * console.log(arrays);
	     * // => [[], []]
	     *
	     * console.log(arrays[0] === arrays[1]);
	     * // => false
	     */
	    function stubArray() {
	      return [];
	    }

	    /**
	     * This method returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `false`.
	     * @example
	     *
	     * _.times(2, _.stubFalse);
	     * // => [false, false]
	     */
	    function stubFalse() {
	      return false;
	    }

	    /**
	     * This method returns a new empty object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Object} Returns the new empty object.
	     * @example
	     *
	     * var objects = _.times(2, _.stubObject);
	     *
	     * console.log(objects);
	     * // => [{}, {}]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => false
	     */
	    function stubObject() {
	      return {};
	    }

	    /**
	     * This method returns an empty string.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {string} Returns the empty string.
	     * @example
	     *
	     * _.times(2, _.stubString);
	     * // => ['', '']
	     */
	    function stubString() {
	      return '';
	    }

	    /**
	     * This method returns `true`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `true`.
	     * @example
	     *
	     * _.times(2, _.stubTrue);
	     * // => [true, true]
	     */
	    function stubTrue() {
	      return true;
	    }

	    /**
	     * Invokes the iteratee `n` times, returning an array of the results of
	     * each invocation. The iteratee is invoked with one argument; (index).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.times(3, String);
	     * // => ['0', '1', '2']
	     *
	     *  _.times(4, _.constant(0));
	     * // => [0, 0, 0, 0]
	     */
	    function times(n, iteratee) {
	      n = toInteger(n);
	      if (n < 1 || n > MAX_SAFE_INTEGER) {
	        return [];
	      }
	      var index = MAX_ARRAY_LENGTH,
	          length = nativeMin(n, MAX_ARRAY_LENGTH);

	      iteratee = getIteratee(iteratee);
	      n -= MAX_ARRAY_LENGTH;

	      var result = baseTimes(length, iteratee);
	      while (++index < n) {
	        iteratee(index);
	      }
	      return result;
	    }

	    /**
	     * Converts `value` to a property path array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the new property path array.
	     * @example
	     *
	     * _.toPath('a.b.c');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toPath('a[0].b.c');
	     * // => ['a', '0', 'b', 'c']
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return arrayMap(value, toKey);
	      }
	      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
	    }

	    /**
	     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {string} [prefix=''] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return toString(prefix) + id;
	    }

	    /*------------------------------------------------------------------------*/

	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {number} augend The first number in an addition.
	     * @param {number} addend The second number in an addition.
	     * @returns {number} Returns the total.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    var add = createMathOperation(function(augend, addend) {
	      return augend + addend;
	    }, 0);

	    /**
	     * Computes `number` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');

	    /**
	     * Divide two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} dividend The first number in a division.
	     * @param {number} divisor The second number in a division.
	     * @returns {number} Returns the quotient.
	     * @example
	     *
	     * _.divide(6, 4);
	     * // => 1.5
	     */
	    var divide = createMathOperation(function(dividend, divisor) {
	      return dividend / divisor;
	    }, 1);

	    /**
	     * Computes `number` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');

	    /**
	     * Computes the maximum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => undefined
	     */
	    function max(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseGt)
	        : undefined$1;
	    }

	    /**
	     * This method is like `_.max` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.maxBy(objects, function(o) { return o.n; });
	     * // => { 'n': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.maxBy(objects, 'n');
	     * // => { 'n': 2 }
	     */
	    function maxBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
	        : undefined$1;
	    }

	    /**
	     * Computes the mean of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * _.mean([4, 2, 8, 6]);
	     * // => 5
	     */
	    function mean(array) {
	      return baseMean(array, identity);
	    }

	    /**
	     * This method is like `_.mean` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be averaged.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.meanBy(objects, function(o) { return o.n; });
	     * // => 5
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.meanBy(objects, 'n');
	     * // => 5
	     */
	    function meanBy(array, iteratee) {
	      return baseMean(array, getIteratee(iteratee, 2));
	    }

	    /**
	     * Computes the minimum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => undefined
	     */
	    function min(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseLt)
	        : undefined$1;
	    }

	    /**
	     * This method is like `_.min` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.minBy(objects, function(o) { return o.n; });
	     * // => { 'n': 1 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.minBy(objects, 'n');
	     * // => { 'n': 1 }
	     */
	    function minBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
	        : undefined$1;
	    }

	    /**
	     * Multiply two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} multiplier The first number in a multiplication.
	     * @param {number} multiplicand The second number in a multiplication.
	     * @returns {number} Returns the product.
	     * @example
	     *
	     * _.multiply(6, 4);
	     * // => 24
	     */
	    var multiply = createMathOperation(function(multiplier, multiplicand) {
	      return multiplier * multiplicand;
	    }, 1);

	    /**
	     * Computes `number` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');

	    /**
	     * Subtract two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {number} minuend The first number in a subtraction.
	     * @param {number} subtrahend The second number in a subtraction.
	     * @returns {number} Returns the difference.
	     * @example
	     *
	     * _.subtract(6, 4);
	     * // => 2
	     */
	    var subtract = createMathOperation(function(minuend, subtrahend) {
	      return minuend - subtrahend;
	    }, 0);

	    /**
	     * Computes the sum of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 2, 8, 6]);
	     * // => 20
	     */
	    function sum(array) {
	      return (array && array.length)
	        ? baseSum(array, identity)
	        : 0;
	    }

	    /**
	     * This method is like `_.sum` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be summed.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.sumBy(objects, function(o) { return o.n; });
	     * // => 20
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sumBy(objects, 'n');
	     * // => 20
	     */
	    function sumBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSum(array, getIteratee(iteratee, 2))
	        : 0;
	    }

	    /*------------------------------------------------------------------------*/

	    // Add methods that return wrapped values in chain sequences.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.assignIn = assignIn;
	    lodash.assignInWith = assignInWith;
	    lodash.assignWith = assignWith;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.castArray = castArray;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.concat = concat;
	    lodash.cond = cond;
	    lodash.conforms = conforms;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.differenceBy = differenceBy;
	    lodash.differenceWith = differenceWith;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatMap = flatMap;
	    lodash.flatMapDeep = flatMapDeep;
	    lodash.flatMapDepth = flatMapDepth;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flattenDepth = flattenDepth;
	    lodash.flip = flip;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.fromPairs = fromPairs;
	    lodash.functions = functions;
	    lodash.functionsIn = functionsIn;
	    lodash.groupBy = groupBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.intersectionBy = intersectionBy;
	    lodash.intersectionWith = intersectionWith;
	    lodash.invert = invert;
	    lodash.invertBy = invertBy;
	    lodash.invokeMap = invokeMap;
	    lodash.iteratee = iteratee;
	    lodash.keyBy = keyBy;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.mergeWith = mergeWith;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.negate = negate;
	    lodash.nthArg = nthArg;
	    lodash.omit = omit;
	    lodash.omitBy = omitBy;
	    lodash.once = once;
	    lodash.orderBy = orderBy;
	    lodash.over = over;
	    lodash.overArgs = overArgs;
	    lodash.overEvery = overEvery;
	    lodash.overSome = overSome;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pickBy = pickBy;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAll = pullAll;
	    lodash.pullAllBy = pullAllBy;
	    lodash.pullAllWith = pullAllWith;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rangeRight = rangeRight;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.reverse = reverse;
	    lodash.sampleSize = sampleSize;
	    lodash.set = set;
	    lodash.setWith = setWith;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortedUniq = sortedUniq;
	    lodash.sortedUniqBy = sortedUniqBy;
	    lodash.split = split;
	    lodash.spread = spread;
	    lodash.tail = tail;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.toArray = toArray;
	    lodash.toPairs = toPairs;
	    lodash.toPairsIn = toPairsIn;
	    lodash.toPath = toPath;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.unary = unary;
	    lodash.union = union;
	    lodash.unionBy = unionBy;
	    lodash.unionWith = unionWith;
	    lodash.uniq = uniq;
	    lodash.uniqBy = uniqBy;
	    lodash.uniqWith = uniqWith;
	    lodash.unset = unset;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.update = update;
	    lodash.updateWith = updateWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.without = without;
	    lodash.words = words;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.xorBy = xorBy;
	    lodash.xorWith = xorWith;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipObjectDeep = zipObjectDeep;
	    lodash.zipWith = zipWith;

	    // Add aliases.
	    lodash.entries = toPairs;
	    lodash.entriesIn = toPairsIn;
	    lodash.extend = assignIn;
	    lodash.extendWith = assignInWith;

	    // Add methods to `lodash.prototype`.
	    mixin(lodash, lodash);

	    /*------------------------------------------------------------------------*/

	    // Add methods that return unwrapped values in chain sequences.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clamp = clamp;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.cloneDeepWith = cloneDeepWith;
	    lodash.cloneWith = cloneWith;
	    lodash.conformsTo = conformsTo;
	    lodash.deburr = deburr;
	    lodash.defaultTo = defaultTo;
	    lodash.divide = divide;
	    lodash.endsWith = endsWith;
	    lodash.eq = eq;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.floor = floor;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.hasIn = hasIn;
	    lodash.head = head;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.invoke = invoke;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isArrayBuffer = isArrayBuffer;
	    lodash.isArrayLike = isArrayLike;
	    lodash.isArrayLikeObject = isArrayLikeObject;
	    lodash.isBoolean = isBoolean;
	    lodash.isBuffer = isBuffer;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isEqualWith = isEqualWith;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isInteger = isInteger;
	    lodash.isLength = isLength;
	    lodash.isMap = isMap;
	    lodash.isMatch = isMatch;
	    lodash.isMatchWith = isMatchWith;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNil = isNil;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isObjectLike = isObjectLike;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isSafeInteger = isSafeInteger;
	    lodash.isSet = isSet;
	    lodash.isString = isString;
	    lodash.isSymbol = isSymbol;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.isWeakMap = isWeakMap;
	    lodash.isWeakSet = isWeakSet;
	    lodash.join = join;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lowerCase = lowerCase;
	    lodash.lowerFirst = lowerFirst;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.maxBy = maxBy;
	    lodash.mean = mean;
	    lodash.meanBy = meanBy;
	    lodash.min = min;
	    lodash.minBy = minBy;
	    lodash.stubArray = stubArray;
	    lodash.stubFalse = stubFalse;
	    lodash.stubObject = stubObject;
	    lodash.stubString = stubString;
	    lodash.stubTrue = stubTrue;
	    lodash.multiply = multiply;
	    lodash.nth = nth;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padEnd = padEnd;
	    lodash.padStart = padStart;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.replace = replace;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.sample = sample;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedIndexBy = sortedIndexBy;
	    lodash.sortedIndexOf = sortedIndexOf;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.sortedLastIndexBy = sortedLastIndexBy;
	    lodash.sortedLastIndexOf = sortedLastIndexOf;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.subtract = subtract;
	    lodash.sum = sum;
	    lodash.sumBy = sumBy;
	    lodash.template = template;
	    lodash.times = times;
	    lodash.toFinite = toFinite;
	    lodash.toInteger = toInteger;
	    lodash.toLength = toLength;
	    lodash.toLower = toLower;
	    lodash.toNumber = toNumber;
	    lodash.toSafeInteger = toSafeInteger;
	    lodash.toString = toString;
	    lodash.toUpper = toUpper;
	    lodash.trim = trim;
	    lodash.trimEnd = trimEnd;
	    lodash.trimStart = trimStart;
	    lodash.truncate = truncate;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.upperCase = upperCase;
	    lodash.upperFirst = upperFirst;

	    // Add aliases.
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.first = head;

	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), { 'chain': false });

	    /*------------------------------------------------------------------------*/

	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type {string}
	     */
	    lodash.VERSION = VERSION;

	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });

	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        n = n === undefined$1 ? 1 : nativeMax(toInteger(n), 0);

	        var result = (this.__filtered__ && !index)
	          ? new LazyWrapper(this)
	          : this.clone();

	        if (result.__filtered__) {
	          result.__takeCount__ = nativeMin(n, result.__takeCount__);
	        } else {
	          result.__views__.push({
	            'size': nativeMin(n, MAX_ARRAY_LENGTH),
	            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
	          });
	        }
	        return result;
	      };

	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });

	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

	      LazyWrapper.prototype[methodName] = function(iteratee) {
	        var result = this.clone();
	        result.__iteratees__.push({
	          'iteratee': getIteratee(iteratee, 3),
	          'type': type
	        });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });

	    // Add `LazyWrapper` methods for `_.head` and `_.last`.
	    arrayEach(['head', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');

	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });

	    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
	    arrayEach(['initial', 'tail'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');

	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });

	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };

	    LazyWrapper.prototype.find = function(predicate) {
	      return this.filter(predicate).head();
	    };

	    LazyWrapper.prototype.findLast = function(predicate) {
	      return this.reverse().find(predicate);
	    };

	    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
	      if (typeof path == 'function') {
	        return new LazyWrapper(this);
	      }
	      return this.map(function(value) {
	        return baseInvoke(value, path, args);
	      });
	    });

	    LazyWrapper.prototype.reject = function(predicate) {
	      return this.filter(negate(getIteratee(predicate)));
	    };

	    LazyWrapper.prototype.slice = function(start, end) {
	      start = toInteger(start);

	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined$1) {
	        end = toInteger(end);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };

	    LazyWrapper.prototype.takeRightWhile = function(predicate) {
	      return this.reverse().takeWhile(predicate).reverse();
	    };

	    LazyWrapper.prototype.toArray = function() {
	      return this.take(MAX_ARRAY_LENGTH);
	    };

	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
	          isTaker = /^(?:head|last)$/.test(methodName),
	          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
	          retUnwrapped = isTaker || /^find/.test(methodName);

	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var value = this.__wrapped__,
	            args = isTaker ? [1] : arguments,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);

	        var interceptor = function(value) {
	          var result = lodashFunc.apply(lodash, arrayPush([value], args));
	          return (isTaker && chainAll) ? result[0] : result;
	        };

	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var chainAll = this.__chain__,
	            isHybrid = !!this.__actions__.length,
	            isUnwrapped = retUnwrapped && !chainAll,
	            onlyLazy = isLazy && !isHybrid;

	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined$1 });
	          return new LodashWrapper(result, chainAll);
	        }
	        if (isUnwrapped && onlyLazy) {
	          return func.apply(this, args);
	        }
	        result = this.thru(interceptor);
	        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
	      };
	    });

	    // Add `Array` methods to `lodash.prototype`.
	    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
	      var func = arrayProto[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          var value = this.value();
	          return func.apply(isArray(value) ? value : [], args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(isArray(value) ? value : [], args);
	        });
	      };
	    });

	    // Map minified method names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = lodashFunc.name + '';
	        if (!hasOwnProperty.call(realNames, key)) {
	          realNames[key] = [];
	        }
	        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });

	    realNames[createHybrid(undefined$1, WRAP_BIND_KEY_FLAG).name] = [{
	      'name': 'wrapper',
	      'func': undefined$1
	    }];

	    // Add methods to `LazyWrapper`.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;

	    // Add chain sequence methods to the `lodash` wrapper.
	    lodash.prototype.at = wrapperAt;
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.next = wrapperNext;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

	    // Add lazy aliases.
	    lodash.prototype.first = lodash.prototype.head;

	    if (symIterator) {
	      lodash.prototype[symIterator] = wrapperToIterator;
	    }
	    return lodash;
	  });

	  /*--------------------------------------------------------------------------*/

	  // Export lodash.
	  var _ = runInContext();

	  // Some AMD build optimizers, like r.js, check for condition patterns like:
	  if (freeModule) {
	    // Export for Node.js.
	    (freeModule.exports = _)._ = _;
	    // Export for CommonJS support.
	    freeExports._ = _;
	  }
	  else {
	    // Export to the global object.
	    root._ = _;
	  }
	}.call(commonjsGlobal)); 
} (lodash, lodash.exports));

var lodashExports = lodash.exports;
var _ = /*@__PURE__*/getDefaultExportFromCjs(lodashExports);

var generateAuthToken = function (email, token) {
    var buffer = Buffer.from("".concat(email, ":").concat(token), "utf8");
    return "".concat(buffer.toString("base64"));
};
var createPermissions = function (param) {
    var userProfile = param.userProfile, perm = param.perm, subscriptionInfo = param.subscriptionInfo, planName = param.planName;
    return {
        uploadVodPerm: (userProfile === null || userProfile === void 0 ? void 0 : userProfile.userType) === "Master" ||
            ((userProfile === null || userProfile === void 0 ? void 0 : userProfile.userType) === "SubMaster" && (perm === null || perm === void 0 ? void 0 : perm.cloudUploadManual)) ||
            (subscriptionInfo === null || subscriptionInfo === void 0 ? void 0 : subscriptionInfo.servicePlanID) === 1 ||
            planName === "Lite plan" ||
            // mantis - 12546, Smart plan도 권한 추가 (Leehj)
            planName === "Smart plan",
        // mantis - 8882, admin의 다운 권한이 있는 경우에만 다운가능하도록 수정(Leehj)
        downloadCameraVodPerm: (userProfile === null || userProfile === void 0 ? void 0 : userProfile.userType) === "Master" ||
            ((userProfile === null || userProfile === void 0 ? void 0 : userProfile.userType) === "SubMaster" && (perm === null || perm === void 0 ? void 0 : perm.myBlackVueFilePlay)) ||
            (subscriptionInfo === null || subscriptionInfo === void 0 ? void 0 : subscriptionInfo.servicePlanID) === 1 ||
            planName === "Smart plan" ||
            planName === "Basic plan" ||
            planName === "Lite plan",
        downloadCloudVodPerm: (userProfile === null || userProfile === void 0 ? void 0 : userProfile.userType) === "Master" ||
            ((userProfile === null || userProfile === void 0 ? void 0 : userProfile.userType) === "SubMaster" && (perm === null || perm === void 0 ? void 0 : perm.cloudFilePlay)) ||
            (subscriptionInfo === null || subscriptionInfo === void 0 ? void 0 : subscriptionInfo.servicePlanID) === 1 ||
            planName === "Smart plan" ||
            planName === "Basic plan" ||
            planName === "Lite plan",
        deleteVodPerm: (userProfile === null || userProfile === void 0 ? void 0 : userProfile.userType) === "Master" ||
            ((userProfile === null || userProfile === void 0 ? void 0 : userProfile.userType) === "SubMaster" && (perm === null || perm === void 0 ? void 0 : perm.fileDelete)) ||
            (subscriptionInfo === null || subscriptionInfo === void 0 ? void 0 : subscriptionInfo.servicePlanID) === 1 ||
            planName === "Smart plan" ||
            planName === "Basic plan" ||
            planName === "Lite plan",
        moveToCloudVodPerm: _.includes(["Master"], userProfile === null || userProfile === void 0 ? void 0 : userProfile.userType) ||
            ((userProfile === null || userProfile === void 0 ? void 0 : userProfile.userType) === "SubMaster" && (perm === null || perm === void 0 ? void 0 : perm.fileMove)) ||
            (subscriptionInfo === null || subscriptionInfo === void 0 ? void 0 : subscriptionInfo.servicePlanID) === 1 ||
            planName === "Smart plan" ||
            planName === "Basic plan" ||
            planName === "Lite plan",
        cameraVodPerm: 
        // mantis - 8882, admin camera탭 활성화되도록 수정(Leehj)
        _.includes(["Master", "SubMaster"], userProfile === null || userProfile === void 0 ? void 0 : userProfile.userType) ||
            ((userProfile === null || userProfile === void 0 ? void 0 : userProfile.userType) === "User" && (perm === null || perm === void 0 ? void 0 : perm.myBlackVueFilePlay)) ||
            (subscriptionInfo === null || subscriptionInfo === void 0 ? void 0 : subscriptionInfo.servicePlanID) === 1 ||
            planName === "Smart plan" ||
            planName === "Basic plan" ||
            planName === "Lite plan",
        cloudVodPerm: 
        // mantis - 8882, admin camera탭 cloud탭 활성화되도록 수정(Leehj)
        _.includes(["Master", "SubMaster"], userProfile === null || userProfile === void 0 ? void 0 : userProfile.userType) ||
            ((userProfile === null || userProfile === void 0 ? void 0 : userProfile.userType) === "User" && (perm === null || perm === void 0 ? void 0 : perm.cloudFilePlay)) ||
            (subscriptionInfo === null || subscriptionInfo === void 0 ? void 0 : subscriptionInfo.servicePlanID) === 1 ||
            planName === "Smart plan" ||
            planName === "Basic plan" ||
            planName === "Lite plan",
        fotaCamPerm: _.includes(["Master"], userProfile === null || userProfile === void 0 ? void 0 : userProfile.userType) ||
            // mantis - 11828, admin 계정 FOTA 권한이 없는 경우 비활성화 되도록 수정 (Leehj)
            (_.includes(["SubMaster"], userProfile === null || userProfile === void 0 ? void 0 : userProfile.userType) &&
                (perm === null || perm === void 0 ? void 0 : perm.firmwareUpdate)) ||
            (subscriptionInfo === null || subscriptionInfo === void 0 ? void 0 : subscriptionInfo.servicePlanID) === 1 ||
            planName === "Smart plan" ||
            planName === "Basic plan" ||
            planName === "Lite plan",
        settingsCamPerm: 
        // _.includes(["Master", "SubMaster"], userProfile?.userType) ||
        (userProfile === null || userProfile === void 0 ? void 0 : userProfile.userType) === "Master" ||
            ((userProfile === null || userProfile === void 0 ? void 0 : userProfile.userType) === "SubMaster" &&
                ((perm === null || perm === void 0 ? void 0 : perm.privacy) ||
                    (perm === null || perm === void 0 ? void 0 : perm.eventAutoUpload) ||
                    (
                    // mantis - 10244, admin 계정은 camera setting권한 없는 경우 비활성화 되도록 수정 (Leehj)
                    // perm?.pushNotifications ||
                    perm === null || perm === void 0 ? void 0 : perm.firmwareSettings))) ||
            (subscriptionInfo === null || subscriptionInfo === void 0 ? void 0 : subscriptionInfo.servicePlanID) === 1 ||
            planName === "Smart plan" ||
            planName === "Basic plan" ||
            planName === "Lite plan",
        renameCamPerm: _.includes(["Master"], userProfile === null || userProfile === void 0 ? void 0 : userProfile.userType) ||
            // mantis - 11828, admin 계정 Camera profile setting 권한이 없는 경우 비활성화 되도록 수정 (Leehj)
            (_.includes(["SubMaster"], userProfile === null || userProfile === void 0 ? void 0 : userProfile.userType) &&
                (perm === null || perm === void 0 ? void 0 : perm.changeDashcamName)) ||
            (subscriptionInfo === null || subscriptionInfo === void 0 ? void 0 : subscriptionInfo.servicePlanID) === 1 ||
            planName === "Smart plan" ||
            planName === "Basic plan" ||
            planName === "Lite plan",
        deleteCamPerm: _.includes(["Master"], userProfile === null || userProfile === void 0 ? void 0 : userProfile.userType) ||
            (subscriptionInfo === null || subscriptionInfo === void 0 ? void 0 : subscriptionInfo.servicePlanID) === 1 ||
            planName === "Smart plan" ||
            planName === "Basic plan" ||
            planName === "Lite plan",
        rebootCamPerm: _.includes(["Master"], userProfile === null || userProfile === void 0 ? void 0 : userProfile.userType) ||
            (subscriptionInfo === null || subscriptionInfo === void 0 ? void 0 : subscriptionInfo.servicePlanID) === 1 ||
            planName === "Smart plan" ||
            planName === "Basic plan" ||
            planName === "Lite plan",
        // Playback more Tab 권한 추가
        moreTabPerm: _.includes(["Master", "SubMaster"], userProfile === null || userProfile === void 0 ? void 0 : userProfile.userType) ||
            (subscriptionInfo === null || subscriptionInfo === void 0 ? void 0 : subscriptionInfo.servicePlanID) === 1 ||
            planName === "Smart plan" ||
            planName === "Basic plan" ||
            planName === "Lite plan",
        //
        gpsTrackingPerm: (userProfile === null || userProfile === void 0 ? void 0 : userProfile.userType) === 'Master' ||
            ((userProfile === null || userProfile === void 0 ? void 0 : userProfile.userType) === 'SubMaster' && (perm === null || perm === void 0 ? void 0 : perm.gpsTracking)) ||
            (perm === null || perm === void 0 ? void 0 : perm.gpsTracking),
        geofencePerm: (userProfile === null || userProfile === void 0 ? void 0 : userProfile.userType) === "Master" ||
            ((userProfile === null || userProfile === void 0 ? void 0 : userProfile.userType) === "SubMaster" && (perm === null || perm === void 0 ? void 0 : perm.geoFence)),
        reportPerm: (userProfile === null || userProfile === void 0 ? void 0 : userProfile.userType) === "Master" ||
            ((userProfile === null || userProfile === void 0 ? void 0 : userProfile.userType) === "SubMaster" && (perm === null || perm === void 0 ? void 0 : perm.driveReports)) ||
            (subscriptionInfo === null || subscriptionInfo === void 0 ? void 0 : subscriptionInfo.servicePlanID) === 1 ||
            planName === "Smart plan" ||
            planName === "Basic plan" ||
            planName === "Lite plan",
        liveviewPerm: (userProfile === null || userProfile === void 0 ? void 0 : userProfile.userType) === "Master" ||
            ((userProfile === null || userProfile === void 0 ? void 0 : userProfile.userType) === "SubMaster" && (perm === null || perm === void 0 ? void 0 : perm.liveView) !== -1) ||
            ((userProfile === null || userProfile === void 0 ? void 0 : userProfile.userType) === "User" && (perm === null || perm === void 0 ? void 0 : perm.liveView) !== -1) ||
            (subscriptionInfo === null || subscriptionInfo === void 0 ? void 0 : subscriptionInfo.servicePlanID) === 1 ||
            planName === "Smart plan" ||
            planName === "Basic plan" ||
            planName === "Lite plan",
        // 멀티 라이브뷰 권한
        multiLiveviewPerm: (userProfile === null || userProfile === void 0 ? void 0 : userProfile.userType) === "Master" ||
            ((userProfile === null || userProfile === void 0 ? void 0 : userProfile.userType) === "SubMaster" && (perm === null || perm === void 0 ? void 0 : perm.liveView) !== -1) ||
            ((userProfile === null || userProfile === void 0 ? void 0 : userProfile.userType) === "User" && (perm === null || perm === void 0 ? void 0 : perm.liveView) !== -1),
        privacyPerm: (userProfile === null || userProfile === void 0 ? void 0 : userProfile.userType) === "Master" ||
            ((userProfile === null || userProfile === void 0 ? void 0 : userProfile.userType) === "SubMaster" && (perm === null || perm === void 0 ? void 0 : perm.privacy)) ||
            (subscriptionInfo === null || subscriptionInfo === void 0 ? void 0 : subscriptionInfo.servicePlanID) === 1 ||
            planName === "Smart plan" ||
            planName === "Basic plan" ||
            planName === "Lite plan",
        pushNotificationsPerm: (userProfile === null || userProfile === void 0 ? void 0 : userProfile.userType) === "Master" ||
            ((userProfile === null || userProfile === void 0 ? void 0 : userProfile.userType) === "SubMaster" && (perm === null || perm === void 0 ? void 0 : perm.pushNotifications)) ||
            (subscriptionInfo === null || subscriptionInfo === void 0 ? void 0 : subscriptionInfo.servicePlanID) === 1 ||
            planName === "Smart plan" ||
            planName === "Basic plan" ||
            planName === "Lite plan",
        eventAutoUploadPerm: (userProfile === null || userProfile === void 0 ? void 0 : userProfile.userType) === "Master" ||
            ((userProfile === null || userProfile === void 0 ? void 0 : userProfile.userType) === "SubMaster" && (perm === null || perm === void 0 ? void 0 : perm.eventAutoUpload)) ||
            (subscriptionInfo === null || subscriptionInfo === void 0 ? void 0 : subscriptionInfo.servicePlanID) === 1 ||
            planName === "Smart plan" ||
            planName === "Basic plan" ||
            planName === "Lite plan",
        firmwareSettingPerm: (userProfile === null || userProfile === void 0 ? void 0 : userProfile.userType) === "Master" ||
            ((userProfile === null || userProfile === void 0 ? void 0 : userProfile.userType) === "SubMaster" && (perm === null || perm === void 0 ? void 0 : perm.firmwareSettings)) ||
            (subscriptionInfo === null || subscriptionInfo === void 0 ? void 0 : subscriptionInfo.servicePlanID) === 1 ||
            planName === "Smart plan" ||
            planName === "Basic plan" ||
            planName === "Lite plan",
        downloadCSVReportPerm: (userProfile === null || userProfile === void 0 ? void 0 : userProfile.userType) === "Master" ||
            ((userProfile === null || userProfile === void 0 ? void 0 : userProfile.userType) === "SubMaster" && (perm === null || perm === void 0 ? void 0 : perm.driveReports)),
        shareToEventmapPerm: (userProfile === null || userProfile === void 0 ? void 0 : userProfile.userType) === "Master" ||
            ((userProfile === null || userProfile === void 0 ? void 0 : userProfile.userType) === "SubMaster" && (perm === null || perm === void 0 ? void 0 : perm.sharingVideoToEventMap)) ||
            (subscriptionInfo === null || subscriptionInfo === void 0 ? void 0 : subscriptionInfo.servicePlanID) === 1 ||
            planName === "Smart plan" ||
            planName === "Basic plan" ||
            planName === "Lite plan",
    };
};

var getFirmwareConfig = function (camera) {
    var _a;
    var fwVersion = parseFloat(camera.fw_ver);
    console.log(camera);
    var config = FIRMWARE_SETTINGS[camera.model];
    var defaultConfig = (_a = config === null || config === void 0 ? void 0 : config.default) !== null && _a !== void 0 ? _a : {};
    var configs = _.filter(config, function (c, key) {
        var fw = parseFloat(key);
        return !isNaN(fw) && fw <= fwVersion;
    });
    // console.log("getFirmwareConfig", defaultConfig, configs);
    return _.reduce(configs, function (result, conf) {
        return _.mergeWith(result, conf, function (objValue, srcValue) {
            return _.assignIn(objValue, srcValue);
        });
    }, _.cloneDeep(defaultConfig));
};
var findNewFw = function (camera, firmwares) {
    var model = FwAbbr[camera.model];
    var fws = _.find(firmwares, function (f) { return f.model === model; });
    var blackvue = undefined;
    if (fws) {
        var info = _.find(fws.info, function (info) { return _.includes(info.lang, camera.lang); });
        if (info && parseFloat(info.version) > parseFloat(camera.fw_ver)) {
            blackvue = info;
        }
    }
    var dmc200 = undefined;
    // if (camera.dms_type === "DMC100")
    if (camera.dms_type === "DMC200") {
        var fwsDmc = _.find(firmwares, function (f) { return f.model === "DMC200"; });
        if (fwsDmc) {
            var info = _.find(fwsDmc.info, function (info) {
                return _.includes(info.lang, camera.lang);
            });
            if (info &&
                camera.dms_version &&
                parseFloat(info.version) > parseFloat(camera.dms_version)) {
                dmc200 = info;
            }
        }
    }
    if (blackvue || dmc200) {
        return { blackvue: blackvue, dmc200: dmc200 };
    }
    return undefined;
};

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */


var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

/**
 * @module helpers
 */
/**
 * Earth Radius used with the Harvesine formula and approximates using a spherical (non-ellipsoid) Earth.
 *
 * @memberof helpers
 * @type {number}
 */
var earthRadius = 6371008.8;
/**
 * Unit of measurement factors using a spherical (non-ellipsoid) earth radius.
 *
 * @memberof helpers
 * @type {Object}
 */
var factors = {
    centimeters: earthRadius * 100,
    centimetres: earthRadius * 100,
    degrees: earthRadius / 111325,
    feet: earthRadius * 3.28084,
    inches: earthRadius * 39.37,
    kilometers: earthRadius / 1000,
    kilometres: earthRadius / 1000,
    meters: earthRadius,
    metres: earthRadius,
    miles: earthRadius / 1609.344,
    millimeters: earthRadius * 1000,
    millimetres: earthRadius * 1000,
    nauticalmiles: earthRadius / 1852,
    radians: 1,
    yards: earthRadius * 1.0936,
};
/**
 * Units of measurement factors based on 1 meter.
 *
 * @memberof helpers
 * @type {Object}
 */
var unitsFactors = {
    centimeters: 100,
    centimetres: 100,
    degrees: 1 / 111325,
    feet: 3.28084,
    inches: 39.37,
    kilometers: 1 / 1000,
    kilometres: 1 / 1000,
    meters: 1,
    metres: 1,
    miles: 1 / 1609.344,
    millimeters: 1000,
    millimetres: 1000,
    nauticalmiles: 1 / 1852,
    radians: 1 / earthRadius,
    yards: 1.0936133,
};
/**
 * Area of measurement factors based on 1 square meter.
 *
 * @memberof helpers
 * @type {Object}
 */
var areaFactors = {
    acres: 0.000247105,
    centimeters: 10000,
    centimetres: 10000,
    feet: 10.763910417,
    hectares: 0.0001,
    inches: 1550.003100006,
    kilometers: 0.000001,
    kilometres: 0.000001,
    meters: 1,
    metres: 1,
    miles: 3.86e-7,
    millimeters: 1000000,
    millimetres: 1000000,
    yards: 1.195990046,
};
/**
 * Wraps a GeoJSON {@link Geometry} in a GeoJSON {@link Feature}.
 *
 * @name feature
 * @param {Geometry} geometry input geometry
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature} a GeoJSON Feature
 * @example
 * var geometry = {
 *   "type": "Point",
 *   "coordinates": [110, 50]
 * };
 *
 * var feature = turf.feature(geometry);
 *
 * //=feature
 */
function feature(geom, properties, options) {
    if (options === void 0) { options = {}; }
    var feat = { type: "Feature" };
    if (options.id === 0 || options.id) {
        feat.id = options.id;
    }
    if (options.bbox) {
        feat.bbox = options.bbox;
    }
    feat.properties = properties || {};
    feat.geometry = geom;
    return feat;
}
/**
 * Creates a GeoJSON {@link Geometry} from a Geometry string type & coordinates.
 * For GeometryCollection type use `helpers.geometryCollection`
 *
 * @name geometry
 * @param {string} type Geometry Type
 * @param {Array<any>} coordinates Coordinates
 * @param {Object} [options={}] Optional Parameters
 * @returns {Geometry} a GeoJSON Geometry
 * @example
 * var type = "Point";
 * var coordinates = [110, 50];
 * var geometry = turf.geometry(type, coordinates);
 * // => geometry
 */
function geometry(type, coordinates, _options) {
    switch (type) {
        case "Point":
            return point(coordinates).geometry;
        case "LineString":
            return lineString(coordinates).geometry;
        case "Polygon":
            return polygon(coordinates).geometry;
        case "MultiPoint":
            return multiPoint(coordinates).geometry;
        case "MultiLineString":
            return multiLineString(coordinates).geometry;
        case "MultiPolygon":
            return multiPolygon(coordinates).geometry;
        default:
            throw new Error(type + " is invalid");
    }
}
/**
 * Creates a {@link Point} {@link Feature} from a Position.
 *
 * @name point
 * @param {Array<number>} coordinates longitude, latitude position (each in decimal degrees)
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<Point>} a Point feature
 * @example
 * var point = turf.point([-75.343, 39.984]);
 *
 * //=point
 */
function point(coordinates, properties, options) {
    if (options === void 0) { options = {}; }
    if (!coordinates) {
        throw new Error("coordinates is required");
    }
    if (!Array.isArray(coordinates)) {
        throw new Error("coordinates must be an Array");
    }
    if (coordinates.length < 2) {
        throw new Error("coordinates must be at least 2 numbers long");
    }
    if (!isNumber$2(coordinates[0]) || !isNumber$2(coordinates[1])) {
        throw new Error("coordinates must contain numbers");
    }
    var geom = {
        type: "Point",
        coordinates: coordinates,
    };
    return feature(geom, properties, options);
}
/**
 * Creates a {@link Point} {@link FeatureCollection} from an Array of Point coordinates.
 *
 * @name points
 * @param {Array<Array<number>>} coordinates an array of Points
 * @param {Object} [properties={}] Translate these properties to each Feature
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north]
 * associated with the FeatureCollection
 * @param {string|number} [options.id] Identifier associated with the FeatureCollection
 * @returns {FeatureCollection<Point>} Point Feature
 * @example
 * var points = turf.points([
 *   [-75, 39],
 *   [-80, 45],
 *   [-78, 50]
 * ]);
 *
 * //=points
 */
function points(coordinates, properties, options) {
    if (options === void 0) { options = {}; }
    return featureCollection(coordinates.map(function (coords) {
        return point(coords, properties);
    }), options);
}
/**
 * Creates a {@link Polygon} {@link Feature} from an Array of LinearRings.
 *
 * @name polygon
 * @param {Array<Array<Array<number>>>} coordinates an array of LinearRings
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<Polygon>} Polygon Feature
 * @example
 * var polygon = turf.polygon([[[-5, 52], [-4, 56], [-2, 51], [-7, 54], [-5, 52]]], { name: 'poly1' });
 *
 * //=polygon
 */
function polygon(coordinates, properties, options) {
    if (options === void 0) { options = {}; }
    for (var _i = 0, coordinates_1 = coordinates; _i < coordinates_1.length; _i++) {
        var ring = coordinates_1[_i];
        if (ring.length < 4) {
            throw new Error("Each LinearRing of a Polygon must have 4 or more Positions.");
        }
        for (var j = 0; j < ring[ring.length - 1].length; j++) {
            // Check if first point of Polygon contains two numbers
            if (ring[ring.length - 1][j] !== ring[0][j]) {
                throw new Error("First and last Position are not equivalent.");
            }
        }
    }
    var geom = {
        type: "Polygon",
        coordinates: coordinates,
    };
    return feature(geom, properties, options);
}
/**
 * Creates a {@link Polygon} {@link FeatureCollection} from an Array of Polygon coordinates.
 *
 * @name polygons
 * @param {Array<Array<Array<Array<number>>>>} coordinates an array of Polygon coordinates
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the FeatureCollection
 * @returns {FeatureCollection<Polygon>} Polygon FeatureCollection
 * @example
 * var polygons = turf.polygons([
 *   [[[-5, 52], [-4, 56], [-2, 51], [-7, 54], [-5, 52]]],
 *   [[[-15, 42], [-14, 46], [-12, 41], [-17, 44], [-15, 42]]],
 * ]);
 *
 * //=polygons
 */
function polygons(coordinates, properties, options) {
    if (options === void 0) { options = {}; }
    return featureCollection(coordinates.map(function (coords) {
        return polygon(coords, properties);
    }), options);
}
/**
 * Creates a {@link LineString} {@link Feature} from an Array of Positions.
 *
 * @name lineString
 * @param {Array<Array<number>>} coordinates an array of Positions
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<LineString>} LineString Feature
 * @example
 * var linestring1 = turf.lineString([[-24, 63], [-23, 60], [-25, 65], [-20, 69]], {name: 'line 1'});
 * var linestring2 = turf.lineString([[-14, 43], [-13, 40], [-15, 45], [-10, 49]], {name: 'line 2'});
 *
 * //=linestring1
 * //=linestring2
 */
function lineString(coordinates, properties, options) {
    if (options === void 0) { options = {}; }
    if (coordinates.length < 2) {
        throw new Error("coordinates must be an array of two or more positions");
    }
    var geom = {
        type: "LineString",
        coordinates: coordinates,
    };
    return feature(geom, properties, options);
}
/**
 * Creates a {@link LineString} {@link FeatureCollection} from an Array of LineString coordinates.
 *
 * @name lineStrings
 * @param {Array<Array<Array<number>>>} coordinates an array of LinearRings
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north]
 * associated with the FeatureCollection
 * @param {string|number} [options.id] Identifier associated with the FeatureCollection
 * @returns {FeatureCollection<LineString>} LineString FeatureCollection
 * @example
 * var linestrings = turf.lineStrings([
 *   [[-24, 63], [-23, 60], [-25, 65], [-20, 69]],
 *   [[-14, 43], [-13, 40], [-15, 45], [-10, 49]]
 * ]);
 *
 * //=linestrings
 */
function lineStrings(coordinates, properties, options) {
    if (options === void 0) { options = {}; }
    return featureCollection(coordinates.map(function (coords) {
        return lineString(coords, properties);
    }), options);
}
/**
 * Takes one or more {@link Feature|Features} and creates a {@link FeatureCollection}.
 *
 * @name featureCollection
 * @param {Feature[]} features input features
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {FeatureCollection} FeatureCollection of Features
 * @example
 * var locationA = turf.point([-75.343, 39.984], {name: 'Location A'});
 * var locationB = turf.point([-75.833, 39.284], {name: 'Location B'});
 * var locationC = turf.point([-75.534, 39.123], {name: 'Location C'});
 *
 * var collection = turf.featureCollection([
 *   locationA,
 *   locationB,
 *   locationC
 * ]);
 *
 * //=collection
 */
function featureCollection(features, options) {
    if (options === void 0) { options = {}; }
    var fc = { type: "FeatureCollection" };
    if (options.id) {
        fc.id = options.id;
    }
    if (options.bbox) {
        fc.bbox = options.bbox;
    }
    fc.features = features;
    return fc;
}
/**
 * Creates a {@link Feature<MultiLineString>} based on a
 * coordinate array. Properties can be added optionally.
 *
 * @name multiLineString
 * @param {Array<Array<Array<number>>>} coordinates an array of LineStrings
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<MultiLineString>} a MultiLineString feature
 * @throws {Error} if no coordinates are passed
 * @example
 * var multiLine = turf.multiLineString([[[0,0],[10,10]]]);
 *
 * //=multiLine
 */
function multiLineString(coordinates, properties, options) {
    if (options === void 0) { options = {}; }
    var geom = {
        type: "MultiLineString",
        coordinates: coordinates,
    };
    return feature(geom, properties, options);
}
/**
 * Creates a {@link Feature<MultiPoint>} based on a
 * coordinate array. Properties can be added optionally.
 *
 * @name multiPoint
 * @param {Array<Array<number>>} coordinates an array of Positions
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<MultiPoint>} a MultiPoint feature
 * @throws {Error} if no coordinates are passed
 * @example
 * var multiPt = turf.multiPoint([[0,0],[10,10]]);
 *
 * //=multiPt
 */
function multiPoint(coordinates, properties, options) {
    if (options === void 0) { options = {}; }
    var geom = {
        type: "MultiPoint",
        coordinates: coordinates,
    };
    return feature(geom, properties, options);
}
/**
 * Creates a {@link Feature<MultiPolygon>} based on a
 * coordinate array. Properties can be added optionally.
 *
 * @name multiPolygon
 * @param {Array<Array<Array<Array<number>>>>} coordinates an array of Polygons
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<MultiPolygon>} a multipolygon feature
 * @throws {Error} if no coordinates are passed
 * @example
 * var multiPoly = turf.multiPolygon([[[[0,0],[0,10],[10,10],[10,0],[0,0]]]]);
 *
 * //=multiPoly
 *
 */
function multiPolygon(coordinates, properties, options) {
    if (options === void 0) { options = {}; }
    var geom = {
        type: "MultiPolygon",
        coordinates: coordinates,
    };
    return feature(geom, properties, options);
}
/**
 * Creates a {@link Feature<GeometryCollection>} based on a
 * coordinate array. Properties can be added optionally.
 *
 * @name geometryCollection
 * @param {Array<Geometry>} geometries an array of GeoJSON Geometries
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<GeometryCollection>} a GeoJSON GeometryCollection Feature
 * @example
 * var pt = turf.geometry("Point", [100, 0]);
 * var line = turf.geometry("LineString", [[101, 0], [102, 1]]);
 * var collection = turf.geometryCollection([pt, line]);
 *
 * // => collection
 */
function geometryCollection(geometries, properties, options) {
    if (options === void 0) { options = {}; }
    var geom = {
        type: "GeometryCollection",
        geometries: geometries,
    };
    return feature(geom, properties, options);
}
/**
 * Round number to precision
 *
 * @param {number} num Number
 * @param {number} [precision=0] Precision
 * @returns {number} rounded number
 * @example
 * turf.round(120.4321)
 * //=120
 *
 * turf.round(120.4321, 2)
 * //=120.43
 */
function round(num, precision) {
    if (precision === void 0) { precision = 0; }
    if (precision && !(precision >= 0)) {
        throw new Error("precision must be a positive number");
    }
    var multiplier = Math.pow(10, precision || 0);
    return Math.round(num * multiplier) / multiplier;
}
/**
 * Convert a distance measurement (assuming a spherical Earth) from radians to a more friendly unit.
 * Valid units: miles, nauticalmiles, inches, yards, meters, metres, kilometers, centimeters, feet
 *
 * @name radiansToLength
 * @param {number} radians in radians across the sphere
 * @param {string} [units="kilometers"] can be degrees, radians, miles, inches, yards, metres,
 * meters, kilometres, kilometers.
 * @returns {number} distance
 */
function radiansToLength(radians, units) {
    if (units === void 0) { units = "kilometers"; }
    var factor = factors[units];
    if (!factor) {
        throw new Error(units + " units is invalid");
    }
    return radians * factor;
}
/**
 * Convert a distance measurement (assuming a spherical Earth) from a real-world unit into radians
 * Valid units: miles, nauticalmiles, inches, yards, meters, metres, kilometers, centimeters, feet
 *
 * @name lengthToRadians
 * @param {number} distance in real units
 * @param {string} [units="kilometers"] can be degrees, radians, miles, inches, yards, metres,
 * meters, kilometres, kilometers.
 * @returns {number} radians
 */
function lengthToRadians(distance, units) {
    if (units === void 0) { units = "kilometers"; }
    var factor = factors[units];
    if (!factor) {
        throw new Error(units + " units is invalid");
    }
    return distance / factor;
}
/**
 * Convert a distance measurement (assuming a spherical Earth) from a real-world unit into degrees
 * Valid units: miles, nauticalmiles, inches, yards, meters, metres, centimeters, kilometres, feet
 *
 * @name lengthToDegrees
 * @param {number} distance in real units
 * @param {string} [units="kilometers"] can be degrees, radians, miles, inches, yards, metres,
 * meters, kilometres, kilometers.
 * @returns {number} degrees
 */
function lengthToDegrees(distance, units) {
    return radiansToDegrees(lengthToRadians(distance, units));
}
/**
 * Converts any bearing angle from the north line direction (positive clockwise)
 * and returns an angle between 0-360 degrees (positive clockwise), 0 being the north line
 *
 * @name bearingToAzimuth
 * @param {number} bearing angle, between -180 and +180 degrees
 * @returns {number} angle between 0 and 360 degrees
 */
function bearingToAzimuth(bearing) {
    var angle = bearing % 360;
    if (angle < 0) {
        angle += 360;
    }
    return angle;
}
/**
 * Converts an angle in radians to degrees
 *
 * @name radiansToDegrees
 * @param {number} radians angle in radians
 * @returns {number} degrees between 0 and 360 degrees
 */
function radiansToDegrees(radians) {
    var degrees = radians % (2 * Math.PI);
    return (degrees * 180) / Math.PI;
}
/**
 * Converts an angle in degrees to radians
 *
 * @name degreesToRadians
 * @param {number} degrees angle between 0 and 360 degrees
 * @returns {number} angle in radians
 */
function degreesToRadians(degrees) {
    var radians = degrees % 360;
    return (radians * Math.PI) / 180;
}
/**
 * Converts a length to the requested unit.
 * Valid units: miles, nauticalmiles, inches, yards, meters, metres, kilometers, centimeters, feet
 *
 * @param {number} length to be converted
 * @param {Units} [originalUnit="kilometers"] of the length
 * @param {Units} [finalUnit="kilometers"] returned unit
 * @returns {number} the converted length
 */
function convertLength(length, originalUnit, finalUnit) {
    if (originalUnit === void 0) { originalUnit = "kilometers"; }
    if (finalUnit === void 0) { finalUnit = "kilometers"; }
    if (!(length >= 0)) {
        throw new Error("length must be a positive number");
    }
    return radiansToLength(lengthToRadians(length, originalUnit), finalUnit);
}
/**
 * Converts a area to the requested unit.
 * Valid units: kilometers, kilometres, meters, metres, centimetres, millimeters, acres, miles, yards, feet, inches, hectares
 * @param {number} area to be converted
 * @param {Units} [originalUnit="meters"] of the distance
 * @param {Units} [finalUnit="kilometers"] returned unit
 * @returns {number} the converted area
 */
function convertArea(area, originalUnit, finalUnit) {
    if (originalUnit === void 0) { originalUnit = "meters"; }
    if (finalUnit === void 0) { finalUnit = "kilometers"; }
    if (!(area >= 0)) {
        throw new Error("area must be a positive number");
    }
    var startFactor = areaFactors[originalUnit];
    if (!startFactor) {
        throw new Error("invalid original units");
    }
    var finalFactor = areaFactors[finalUnit];
    if (!finalFactor) {
        throw new Error("invalid final units");
    }
    return (area / startFactor) * finalFactor;
}
/**
 * isNumber
 *
 * @param {*} num Number to validate
 * @returns {boolean} true/false
 * @example
 * turf.isNumber(123)
 * //=true
 * turf.isNumber('foo')
 * //=false
 */
function isNumber$2(num) {
    return !isNaN(num) && num !== null && !Array.isArray(num);
}
/**
 * isObject
 *
 * @param {*} input variable to validate
 * @returns {boolean} true/false
 * @example
 * turf.isObject({elevation: 10})
 * //=true
 * turf.isObject('foo')
 * //=false
 */
function isObject(input) {
    return !!input && input.constructor === Object;
}
/**
 * Validate BBox
 *
 * @private
 * @param {Array<number>} bbox BBox to validate
 * @returns {void}
 * @throws Error if BBox is not valid
 * @example
 * validateBBox([-180, -40, 110, 50])
 * //=OK
 * validateBBox([-180, -40])
 * //=Error
 * validateBBox('Foo')
 * //=Error
 * validateBBox(5)
 * //=Error
 * validateBBox(null)
 * //=Error
 * validateBBox(undefined)
 * //=Error
 */
function validateBBox(bbox) {
    if (!bbox) {
        throw new Error("bbox is required");
    }
    if (!Array.isArray(bbox)) {
        throw new Error("bbox must be an Array");
    }
    if (bbox.length !== 4 && bbox.length !== 6) {
        throw new Error("bbox must be an Array of 4 or 6 numbers");
    }
    bbox.forEach(function (num) {
        if (!isNumber$2(num)) {
            throw new Error("bbox must only contain numbers");
        }
    });
}
/**
 * Validate Id
 *
 * @private
 * @param {string|number} id Id to validate
 * @returns {void}
 * @throws Error if Id is not valid
 * @example
 * validateId([-180, -40, 110, 50])
 * //=Error
 * validateId([-180, -40])
 * //=Error
 * validateId('Foo')
 * //=OK
 * validateId(5)
 * //=OK
 * validateId(null)
 * //=Error
 * validateId(undefined)
 * //=Error
 */
function validateId(id) {
    if (!id) {
        throw new Error("id is required");
    }
    if (["string", "number"].indexOf(typeof id) === -1) {
        throw new Error("id must be a number or a string");
    }
}

var index$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    areaFactors: areaFactors,
    bearingToAzimuth: bearingToAzimuth,
    convertArea: convertArea,
    convertLength: convertLength,
    degreesToRadians: degreesToRadians,
    earthRadius: earthRadius,
    factors: factors,
    feature: feature,
    featureCollection: featureCollection,
    geometry: geometry,
    geometryCollection: geometryCollection,
    isNumber: isNumber$2,
    isObject: isObject,
    lengthToDegrees: lengthToDegrees,
    lengthToRadians: lengthToRadians,
    lineString: lineString,
    lineStrings: lineStrings,
    multiLineString: multiLineString,
    multiPoint: multiPoint,
    multiPolygon: multiPolygon,
    point: point,
    points: points,
    polygon: polygon,
    polygons: polygons,
    radiansToDegrees: radiansToDegrees,
    radiansToLength: radiansToLength,
    round: round,
    unitsFactors: unitsFactors,
    validateBBox: validateBBox,
    validateId: validateId
});

/**
 * Callback for coordEach
 *
 * @callback coordEachCallback
 * @param {Array<number>} currentCoord The current coordinate being processed.
 * @param {number} coordIndex The current index of the coordinate being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed.
 * @param {number} geometryIndex The current index of the Geometry being processed.
 */

/**
 * Iterate over coordinates in any GeoJSON object, similar to Array.forEach()
 *
 * @name coordEach
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @param {Function} callback a method that takes (currentCoord, coordIndex, featureIndex, multiFeatureIndex)
 * @param {boolean} [excludeWrapCoord=false] whether or not to include the final coordinate of LinearRings that wraps the ring in its iteration.
 * @returns {void}
 * @example
 * var features = turf.featureCollection([
 *   turf.point([26, 37], {"foo": "bar"}),
 *   turf.point([36, 53], {"hello": "world"})
 * ]);
 *
 * turf.coordEach(features, function (currentCoord, coordIndex, featureIndex, multiFeatureIndex, geometryIndex) {
 *   //=currentCoord
 *   //=coordIndex
 *   //=featureIndex
 *   //=multiFeatureIndex
 *   //=geometryIndex
 * });
 */
function coordEach(geojson, callback, excludeWrapCoord) {
  // Handles null Geometry -- Skips this GeoJSON
  if (geojson === null) return;
  var j,
    k,
    l,
    geometry,
    stopG,
    coords,
    geometryMaybeCollection,
    wrapShrink = 0,
    coordIndex = 0,
    isGeometryCollection,
    type = geojson.type,
    isFeatureCollection = type === "FeatureCollection",
    isFeature = type === "Feature",
    stop = isFeatureCollection ? geojson.features.length : 1;

  // This logic may look a little weird. The reason why it is that way
  // is because it's trying to be fast. GeoJSON supports multiple kinds
  // of objects at its root: FeatureCollection, Features, Geometries.
  // This function has the responsibility of handling all of them, and that
  // means that some of the `for` loops you see below actually just don't apply
  // to certain inputs. For instance, if you give this just a
  // Point geometry, then both loops are short-circuited and all we do
  // is gradually rename the input until it's called 'geometry'.
  //
  // This also aims to allocate as few resources as possible: just a
  // few numbers and booleans, rather than any temporary arrays as would
  // be required with the normalization approach.
  for (var featureIndex = 0; featureIndex < stop; featureIndex++) {
    geometryMaybeCollection = isFeatureCollection
      ? geojson.features[featureIndex].geometry
      : isFeature
      ? geojson.geometry
      : geojson;
    isGeometryCollection = geometryMaybeCollection
      ? geometryMaybeCollection.type === "GeometryCollection"
      : false;
    stopG = isGeometryCollection
      ? geometryMaybeCollection.geometries.length
      : 1;

    for (var geomIndex = 0; geomIndex < stopG; geomIndex++) {
      var multiFeatureIndex = 0;
      var geometryIndex = 0;
      geometry = isGeometryCollection
        ? geometryMaybeCollection.geometries[geomIndex]
        : geometryMaybeCollection;

      // Handles null Geometry -- Skips this geometry
      if (geometry === null) continue;
      coords = geometry.coordinates;
      var geomType = geometry.type;

      wrapShrink =
        excludeWrapCoord &&
        (geomType === "Polygon" || geomType === "MultiPolygon")
          ? 1
          : 0;

      switch (geomType) {
        case null:
          break;
        case "Point":
          if (
            callback(
              coords,
              coordIndex,
              featureIndex,
              multiFeatureIndex,
              geometryIndex
            ) === false
          )
            return false;
          coordIndex++;
          multiFeatureIndex++;
          break;
        case "LineString":
        case "MultiPoint":
          for (j = 0; j < coords.length; j++) {
            if (
              callback(
                coords[j],
                coordIndex,
                featureIndex,
                multiFeatureIndex,
                geometryIndex
              ) === false
            )
              return false;
            coordIndex++;
            if (geomType === "MultiPoint") multiFeatureIndex++;
          }
          if (geomType === "LineString") multiFeatureIndex++;
          break;
        case "Polygon":
        case "MultiLineString":
          for (j = 0; j < coords.length; j++) {
            for (k = 0; k < coords[j].length - wrapShrink; k++) {
              if (
                callback(
                  coords[j][k],
                  coordIndex,
                  featureIndex,
                  multiFeatureIndex,
                  geometryIndex
                ) === false
              )
                return false;
              coordIndex++;
            }
            if (geomType === "MultiLineString") multiFeatureIndex++;
            if (geomType === "Polygon") geometryIndex++;
          }
          if (geomType === "Polygon") multiFeatureIndex++;
          break;
        case "MultiPolygon":
          for (j = 0; j < coords.length; j++) {
            geometryIndex = 0;
            for (k = 0; k < coords[j].length; k++) {
              for (l = 0; l < coords[j][k].length - wrapShrink; l++) {
                if (
                  callback(
                    coords[j][k][l],
                    coordIndex,
                    featureIndex,
                    multiFeatureIndex,
                    geometryIndex
                  ) === false
                )
                  return false;
                coordIndex++;
              }
              geometryIndex++;
            }
            multiFeatureIndex++;
          }
          break;
        case "GeometryCollection":
          for (j = 0; j < geometry.geometries.length; j++)
            if (
              coordEach(geometry.geometries[j], callback, excludeWrapCoord) ===
              false
            )
              return false;
          break;
        default:
          throw new Error("Unknown Geometry Type");
      }
    }
  }
}

/**
 * Takes a set of features, calculates the bbox of all input features, and returns a bounding box.
 *
 * @name bbox
 * @param {GeoJSON} geojson any GeoJSON object
 * @returns {BBox} bbox extent in [minX, minY, maxX, maxY] order
 * @example
 * var line = turf.lineString([[-74, 40], [-78, 42], [-82, 35]]);
 * var bbox = turf.bbox(line);
 * var bboxPolygon = turf.bboxPolygon(bbox);
 *
 * //addToMap
 * var addToMap = [line, bboxPolygon]
 */
function bbox(geojson) {
    var result = [Infinity, Infinity, -Infinity, -Infinity];
    coordEach(geojson, function (coord) {
        if (result[0] > coord[0]) {
            result[0] = coord[0];
        }
        if (result[1] > coord[1]) {
            result[1] = coord[1];
        }
        if (result[2] < coord[0]) {
            result[2] = coord[0];
        }
        if (result[3] < coord[1]) {
            result[3] = coord[1];
        }
    });
    return result;
}
bbox["default"] = bbox;

/**
 * Unwrap a coordinate from a Point Feature, Geometry or a single coordinate.
 *
 * @name getCoord
 * @param {Array<number>|Geometry<Point>|Feature<Point>} coord GeoJSON Point or an Array of numbers
 * @returns {Array<number>} coordinates
 * @example
 * var pt = turf.point([10, 10]);
 *
 * var coord = turf.getCoord(pt);
 * //= [10, 10]
 */
function getCoord(coord) {
    if (!coord) {
        throw new Error("coord is required");
    }
    if (!Array.isArray(coord)) {
        if (coord.type === "Feature" &&
            coord.geometry !== null &&
            coord.geometry.type === "Point") {
            return coord.geometry.coordinates;
        }
        if (coord.type === "Point") {
            return coord.coordinates;
        }
    }
    if (Array.isArray(coord) &&
        coord.length >= 2 &&
        !Array.isArray(coord[0]) &&
        !Array.isArray(coord[1])) {
        return coord;
    }
    throw new Error("coord must be GeoJSON Point or an Array of numbers");
}

//http://en.wikipedia.org/wiki/Haversine_formula
//http://www.movable-type.co.uk/scripts/latlong.html
/**
 * Calculates the distance between two {@link Point|points} in degrees, radians, miles, or kilometers.
 * This uses the [Haversine formula](http://en.wikipedia.org/wiki/Haversine_formula) to account for global curvature.
 *
 * @name distance
 * @param {Coord | Point} from origin point or coordinate
 * @param {Coord | Point} to destination point or coordinate
 * @param {Object} [options={}] Optional parameters
 * @param {string} [options.units='kilometers'] can be degrees, radians, miles, or kilometers
 * @returns {number} distance between the two points
 * @example
 * var from = turf.point([-75.343, 39.984]);
 * var to = turf.point([-75.534, 39.123]);
 * var options = {units: 'miles'};
 *
 * var distance = turf.distance(from, to, options);
 *
 * //addToMap
 * var addToMap = [from, to];
 * from.properties.distance = distance;
 * to.properties.distance = distance;
 */
function distance$1(from, to, options) {
    if (options === void 0) { options = {}; }
    var coordinates1 = getCoord(from);
    var coordinates2 = getCoord(to);
    var dLat = degreesToRadians(coordinates2[1] - coordinates1[1]);
    var dLon = degreesToRadians(coordinates2[0] - coordinates1[0]);
    var lat1 = degreesToRadians(coordinates1[1]);
    var lat2 = degreesToRadians(coordinates2[1]);
    var a = Math.pow(Math.sin(dLat / 2), 2) +
        Math.pow(Math.sin(dLon / 2), 2) * Math.cos(lat1) * Math.cos(lat2);
    return radiansToLength(2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a)), options.units);
}

// http://en.wikipedia.org/wiki/Haversine_formula
// http://www.movable-type.co.uk/scripts/latlong.html
/**
 * Takes a {@link Point} and calculates the location of a destination point given a distance in
 * degrees, radians, miles, or kilometers; and bearing in degrees.
 * This uses the [Haversine formula](http://en.wikipedia.org/wiki/Haversine_formula) to account for global curvature.
 *
 * @name destination
 * @param {Coord} origin starting point
 * @param {number} distance distance from the origin point
 * @param {number} bearing ranging from -180 to 180
 * @param {Object} [options={}] Optional parameters
 * @param {string} [options.units='kilometers'] miles, kilometers, degrees, or radians
 * @param {Object} [options.properties={}] Translate properties to Point
 * @returns {Feature<Point>} destination point
 * @example
 * var point = turf.point([-75.343, 39.984]);
 * var distance = 50;
 * var bearing = 90;
 * var options = {units: 'miles'};
 *
 * var destination = turf.destination(point, distance, bearing, options);
 *
 * //addToMap
 * var addToMap = [point, destination]
 * destination.properties['marker-color'] = '#f00';
 * point.properties['marker-color'] = '#0f0';
 */
function destination(origin, distance, bearing, options) {
    if (options === void 0) { options = {}; }
    // Handle input
    var coordinates1 = getCoord(origin);
    var longitude1 = degreesToRadians(coordinates1[0]);
    var latitude1 = degreesToRadians(coordinates1[1]);
    var bearingRad = degreesToRadians(bearing);
    var radians = lengthToRadians(distance, options.units);
    // Main
    var latitude2 = Math.asin(Math.sin(latitude1) * Math.cos(radians) +
        Math.cos(latitude1) * Math.sin(radians) * Math.cos(bearingRad));
    var longitude2 = longitude1 +
        Math.atan2(Math.sin(bearingRad) * Math.sin(radians) * Math.cos(latitude1), Math.cos(radians) - Math.sin(latitude1) * Math.sin(latitude2));
    var lng = radiansToDegrees(longitude2);
    var lat = radiansToDegrees(latitude2);
    return point([lng, lat], options.properties);
}

/**
 * Takes a {@link Point} and calculates the circle polygon given a radius in degrees, radians, miles, or kilometers; and steps for precision.
 *
 * @name circle
 * @param {Feature<Point>|number[]} center center point
 * @param {number} radius radius of the circle
 * @param {Object} [options={}] Optional parameters
 * @param {number} [options.steps=64] number of steps
 * @param {string} [options.units='kilometers'] miles, kilometers, degrees, or radians
 * @param {Object} [options.properties={}] properties
 * @returns {Feature<Polygon>} circle polygon
 * @example
 * var center = [-75.343, 39.984];
 * var radius = 5;
 * var options = {steps: 10, units: 'kilometers', properties: {foo: 'bar'}};
 * var circle = turf.circle(center, radius, options);
 *
 * //addToMap
 * var addToMap = [turf.point(center), circle]
 */
function circle$1(center, radius, options) {
    if (options === void 0) { options = {}; }
    // default params
    var steps = options.steps || 64;
    var properties = options.properties
        ? options.properties
        : !Array.isArray(center) && center.type === "Feature" && center.properties
            ? center.properties
            : {};
    // main
    var coordinates = [];
    for (var i = 0; i < steps; i++) {
        coordinates.push(destination(center, radius, (i * -360) / steps, options).geometry
            .coordinates);
    }
    coordinates.push(coordinates[0]);
    return polygon([coordinates], properties);
}

/* eslint complexity: [2, 18], max-statements: [2, 33] */
var shams = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};

var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = shams;

var hasSymbols$1 = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};

var test = {
	foo: {}
};

var $Object = Object;

var hasProto$1 = function hasProto() {
	return { __proto__: test }.foo === test.foo && !({ __proto__: null } instanceof $Object);
};

/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var slice = Array.prototype.slice;
var toStr$1 = Object.prototype.toString;
var funcType = '[object Function]';

var implementation$1 = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr$1.call(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slice.call(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                args.concat(slice.call(arguments))
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        } else {
            return target.apply(
                that,
                args.concat(slice.call(arguments))
            );
        }
    };

    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs.push('$' + i);
    }

    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};

var implementation = implementation$1;

var functionBind = Function.prototype.bind || implementation;

var bind$1 = functionBind;

var src = bind$1.call(Function.call, Object.prototype.hasOwnProperty);

var undefined$1;

var $SyntaxError = SyntaxError;
var $Function = Function;
var $TypeError$1 = TypeError;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) {
	try {
		$gOPD({}, '');
	} catch (e) {
		$gOPD = null; // this is IE 8, which has a broken gOPD
	}
}

var throwTypeError = function () {
	throw new $TypeError$1();
};
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols = hasSymbols$1();
var hasProto = hasProto$1();

var getProto = Object.getPrototypeOf || (
	hasProto
		? function (x) { return x.__proto__; } // eslint-disable-line no-proto
		: null
);

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' || !getProto ? undefined$1 : getProto(Uint8Array);

var INTRINSICS = {
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined$1 : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined$1 : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols && getProto ? getProto([][Symbol.iterator]()) : undefined$1,
	'%AsyncFromSyncIteratorPrototype%': undefined$1,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined$1 : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined$1 : BigInt,
	'%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined$1 : BigInt64Array,
	'%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined$1 : BigUint64Array,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined$1 : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': EvalError,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined$1 : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined$1 : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined$1 : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined$1 : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined$1 : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined$1 : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined$1,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined$1,
	'%Map%': typeof Map === 'undefined' ? undefined$1 : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols || !getProto ? undefined$1 : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': Object,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined$1 : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined$1 : Proxy,
	'%RangeError%': RangeError,
	'%ReferenceError%': ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined$1 : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined$1 : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols || !getProto ? undefined$1 : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined$1 : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols && getProto ? getProto(''[Symbol.iterator]()) : undefined$1,
	'%Symbol%': hasSymbols ? Symbol : undefined$1,
	'%SyntaxError%': $SyntaxError,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError$1,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined$1 : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined$1 : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined$1 : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined$1 : Uint32Array,
	'%URIError%': URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined$1 : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined$1 : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined$1 : WeakSet
};

if (getProto) {
	try {
		null.error; // eslint-disable-line no-unused-expressions
	} catch (e) {
		// https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
		var errorProto = getProto(getProto(e));
		INTRINSICS['%Error.prototype%'] = errorProto;
	}
}

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen && getProto) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};

var bind = functionBind;
var hasOwn$1 = src;
var $concat$1 = bind.call(Function.call, Array.prototype.concat);
var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
var $replace$1 = bind.call(Function.call, String.prototype.replace);
var $strSlice = bind.call(Function.call, String.prototype.slice);
var $exec = bind.call(Function.call, RegExp.prototype.exec);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace$1(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace$1(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (hasOwn$1(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (hasOwn$1(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError$1('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

var getIntrinsic = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError$1('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError$1('"allowMissing" argument must be a boolean');
	}

	if ($exec(/^%?[^%]*%?$/, name) === null) {
		throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
	}
	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat$1([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if (
			(
				(first === '"' || first === "'" || first === '`')
				|| (last === '"' || last === "'" || last === '`')
			)
			&& first !== last
		) {
			throw new $SyntaxError('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (hasOwn$1(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError$1('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined$1;
			}
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = hasOwn$1(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};

var callBind$1 = {exports: {}};

(function (module) {

	var bind = functionBind;
	var GetIntrinsic = getIntrinsic;

	var $apply = GetIntrinsic('%Function.prototype.apply%');
	var $call = GetIntrinsic('%Function.prototype.call%');
	var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);

	var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);
	var $defineProperty = GetIntrinsic('%Object.defineProperty%', true);
	var $max = GetIntrinsic('%Math.max%');

	if ($defineProperty) {
		try {
			$defineProperty({}, 'a', { value: 1 });
		} catch (e) {
			// IE 8 has a broken defineProperty
			$defineProperty = null;
		}
	}

	module.exports = function callBind(originalFunction) {
		var func = $reflectApply(bind, $call, arguments);
		if ($gOPD && $defineProperty) {
			var desc = $gOPD(func, 'length');
			if (desc.configurable) {
				// original length, plus the receiver, minus any additional arguments (after the receiver)
				$defineProperty(
					func,
					'length',
					{ value: 1 + $max(0, originalFunction.length - (arguments.length - 1)) }
				);
			}
		}
		return func;
	};

	var applyBind = function applyBind() {
		return $reflectApply(bind, $apply, arguments);
	};

	if ($defineProperty) {
		$defineProperty(module.exports, 'apply', { value: applyBind });
	} else {
		module.exports.apply = applyBind;
	} 
} (callBind$1));

var callBindExports = callBind$1.exports;

var GetIntrinsic$1 = getIntrinsic;

var callBind = callBindExports;

var $indexOf = callBind(GetIntrinsic$1('String.prototype.indexOf'));

var callBound$1 = function callBoundIntrinsic(name, allowMissing) {
	var intrinsic = GetIntrinsic$1(name, !!allowMissing);
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
		return callBind(intrinsic);
	}
	return intrinsic;
};

var GEOFENCE_POLYGON_SOURCE_NAME = "geofence-polygon-source";
var GEOFENCE_POLYGON_LAYER_NAME = "geofence-polygon-layer";
var GEOFENCE_POLYGON_LAYER = {
    id: GEOFENCE_POLYGON_LAYER_NAME,
    type: "fill",
    source: GEOFENCE_POLYGON_SOURCE_NAME,
    paint: {
        "fill-color": ["get", "color"],
        "fill-opacity": ["get", "opacity"],
    },
};
var GEOFENCE_POLYGON_LINE_LAYER_NAME = "geofence-polygon-line-layer";
var GEOFENCE_POLYGON_LINE_LAYER = {
    id: GEOFENCE_POLYGON_LINE_LAYER_NAME,
    type: "line",
    source: GEOFENCE_POLYGON_SOURCE_NAME,
    paint: {
        "line-color": ["get", "color"],
        "line-width": 2,
    },
};
var GEOFENCE_LINE_SOURCE_NAME = "geofence-line-source";
var GEOFENCE_LINE_LAYER_NAME = "geofence-line-layer";
var GEOFENCE_LINE_LAYER = {
    id: GEOFENCE_LINE_LAYER_NAME,
    type: "line",
    source: GEOFENCE_LINE_SOURCE_NAME,
    paint: {
        "line-color": ["get", "color"],
        "line-width": 2,
    },
};
var updateGeofence = function (mapInst, geofences, mode, currentGeofence, noZoom, mobile) {
    var polySource = mapInst.getSource(GEOFENCE_POLYGON_SOURCE_NAME);
    var polygons = [];
    var circles = [];
    var lines = [];
    if (polySource) {
        if (mode !== "add" && !currentGeofence) {
            polygons = _.chain(geofences)
                .filter(function (fence) { return fence.fenceType === 1 || fence.fenceType === 2; })
                .map(function (fence) {
                try {
                    if (!fence.polygon && !fence.rectangle)
                        return undefined;
                    var points = [];
                    if (fence.polygon) {
                        points = __spreadArray(__spreadArray([], fence.polygon, true), [fence.polygon[0]], false);
                    }
                    if (fence.rectangle) {
                        points = __spreadArray(__spreadArray([], fence.rectangle, true), [fence.rectangle[0]], false);
                    }
                    return polygon([
                        _.chain(points)
                            .compact()
                            .map(function (p) { return [p.lng, p.lat]; })
                            .value(),
                    ], __assign(__assign({}, fence), { color: fence.setShape.Color, opacity: fence.setShape.Transparency }));
                }
                catch (_a) {
                    return undefined;
                }
            })
                .compact()
                .value();
            circles = _.chain(geofences)
                .filter(function (fence) { return fence.fenceType === 3; })
                .map(function (fence) {
                if (!fence.circle)
                    return undefined;
                var c = fence.circle[0];
                return circle$1(point([c.lng, c.lat], __assign(__assign({}, fence), { color: fence.setShape.Color, opacity: fence.setShape.Transparency })), c.radius, {
                    units: "meters",
                });
            })
                .compact()
                .value();
            polySource.setData(featureCollection(__spreadArray(__spreadArray([], polygons, true), circles, true)));
        }
        else {
            polySource.setData(featureCollection([]));
        }
    }
    var lineSource = mapInst.getSource(GEOFENCE_LINE_SOURCE_NAME);
    if (lineSource) {
        if (mode !== "add" && !currentGeofence) {
            lines = _.chain(geofences)
                .filter(function (fence) { return fence.fenceType === 4; })
                .map(function (fence) {
                if (!fence.polyline)
                    return undefined;
                return lineString(_.map(fence.polyline, function (p) { return [p.lng, p.lat]; }), __assign(__assign({}, fence), { color: fence.setShape.Color, opacity: fence.setShape.Transparency }));
            })
                .compact()
                .value();
            lineSource.setData(featureCollection(lines));
        }
        else {
            lineSource.setData(featureCollection([]));
        }
    }
    if (!noZoom) {
        var bbox$1 = bbox(featureCollection(__spreadArray(__spreadArray(__spreadArray([], polygons, true), circles, true), lines, true)));
        if (bbox$1[0] === Infinity)
            return;
        mapInst.fitBounds(bbox$1, {
            padding: mobile
                ? { top: 50, left: 50, right: 50, bottom: 50 }
                : { top: 200, left: 500, right: 200, bottom: 200 },
            duration: 0,
            animate: false,
        });
    }
};
var initGeofenceSourcesAndLayers = function (map) {
    if (!map.getSource(GEOFENCE_POLYGON_SOURCE_NAME)) {
        map.addSource(GEOFENCE_POLYGON_SOURCE_NAME, {
            type: "geojson",
            data: featureCollection([]),
        });
    }
    if (!map.getSource(GEOFENCE_LINE_SOURCE_NAME)) {
        map.addSource(GEOFENCE_LINE_SOURCE_NAME, {
            type: "geojson",
            data: featureCollection([]),
        });
    }
    if (!map.getLayer(GEOFENCE_POLYGON_LAYER_NAME)) {
        map.addLayer(GEOFENCE_POLYGON_LAYER);
    }
    if (!map.getLayer(GEOFENCE_LINE_LAYER_NAME)) {
        map.addLayer(GEOFENCE_LINE_LAYER);
    }
    if (!map.getLayer(GEOFENCE_POLYGON_LINE_LAYER_NAME)) {
        map.addLayer(GEOFENCE_POLYGON_LINE_LAYER);
    }
};

var screenfull$1 = {exports: {}};

/*!
* screenfull
* v5.1.0 - 2020-12-24
* (c) Sindre Sorhus; MIT License
*/

(function (module) {
	(function () {

		var document = typeof window !== 'undefined' && typeof window.document !== 'undefined' ? window.document : {};
		var isCommonjs = module.exports;

		var fn = (function () {
			var val;

			var fnMap = [
				[
					'requestFullscreen',
					'exitFullscreen',
					'fullscreenElement',
					'fullscreenEnabled',
					'fullscreenchange',
					'fullscreenerror'
				],
				// New WebKit
				[
					'webkitRequestFullscreen',
					'webkitExitFullscreen',
					'webkitFullscreenElement',
					'webkitFullscreenEnabled',
					'webkitfullscreenchange',
					'webkitfullscreenerror'

				],
				// Old WebKit
				[
					'webkitRequestFullScreen',
					'webkitCancelFullScreen',
					'webkitCurrentFullScreenElement',
					'webkitCancelFullScreen',
					'webkitfullscreenchange',
					'webkitfullscreenerror'

				],
				[
					'mozRequestFullScreen',
					'mozCancelFullScreen',
					'mozFullScreenElement',
					'mozFullScreenEnabled',
					'mozfullscreenchange',
					'mozfullscreenerror'
				],
				[
					'msRequestFullscreen',
					'msExitFullscreen',
					'msFullscreenElement',
					'msFullscreenEnabled',
					'MSFullscreenChange',
					'MSFullscreenError'
				]
			];

			var i = 0;
			var l = fnMap.length;
			var ret = {};

			for (; i < l; i++) {
				val = fnMap[i];
				if (val && val[1] in document) {
					for (i = 0; i < val.length; i++) {
						ret[fnMap[0][i]] = val[i];
					}
					return ret;
				}
			}

			return false;
		})();

		var eventNameMap = {
			change: fn.fullscreenchange,
			error: fn.fullscreenerror
		};

		var screenfull = {
			request: function (element, options) {
				return new Promise(function (resolve, reject) {
					var onFullScreenEntered = function () {
						this.off('change', onFullScreenEntered);
						resolve();
					}.bind(this);

					this.on('change', onFullScreenEntered);

					element = element || document.documentElement;

					var returnPromise = element[fn.requestFullscreen](options);

					if (returnPromise instanceof Promise) {
						returnPromise.then(onFullScreenEntered).catch(reject);
					}
				}.bind(this));
			},
			exit: function () {
				return new Promise(function (resolve, reject) {
					if (!this.isFullscreen) {
						resolve();
						return;
					}

					var onFullScreenExit = function () {
						this.off('change', onFullScreenExit);
						resolve();
					}.bind(this);

					this.on('change', onFullScreenExit);

					var returnPromise = document[fn.exitFullscreen]();

					if (returnPromise instanceof Promise) {
						returnPromise.then(onFullScreenExit).catch(reject);
					}
				}.bind(this));
			},
			toggle: function (element, options) {
				return this.isFullscreen ? this.exit() : this.request(element, options);
			},
			onchange: function (callback) {
				this.on('change', callback);
			},
			onerror: function (callback) {
				this.on('error', callback);
			},
			on: function (event, callback) {
				var eventName = eventNameMap[event];
				if (eventName) {
					document.addEventListener(eventName, callback, false);
				}
			},
			off: function (event, callback) {
				var eventName = eventNameMap[event];
				if (eventName) {
					document.removeEventListener(eventName, callback, false);
				}
			},
			raw: fn
		};

		if (!fn) {
			if (isCommonjs) {
				module.exports = {isEnabled: false};
			} else {
				window.screenfull = {isEnabled: false};
			}

			return;
		}

		Object.defineProperties(screenfull, {
			isFullscreen: {
				get: function () {
					return Boolean(document[fn.fullscreenElement]);
				}
			},
			element: {
				enumerable: true,
				get: function () {
					return document[fn.fullscreenElement];
				}
			},
			isEnabled: {
				enumerable: true,
				get: function () {
					// Coerce to boolean in case of old WebKit
					return Boolean(document[fn.fullscreenEnabled]);
				}
			}
		});

		if (isCommonjs) {
			module.exports = screenfull;
		} else {
			window.screenfull = screenfull;
		}
	})(); 
} (screenfull$1));

var screenfullExports = screenfull$1.exports;
var screenfull = /*@__PURE__*/getDefaultExportFromCjs(screenfullExports);

// mantis - 8437, MPH로 설정 시 0 MPH로 표시
var getSpeedValue = function (loc, speedUnit) {
    var _a;
    var speed = parseFloat((_a = loc.speed) !== null && _a !== void 0 ? _a : "0");
    if (loc.active === "off") {
        return "0 km/h";
    }
    else if (speed <= 0) {
        return "0 ".concat(speedUnit === "1" ? "MPH" : "km/h");
    }
    else if (speedUnit === "1") {
        return "".concat(Math.floor(speed * 1.150779), " MPH");
    }
    else {
        return "".concat(Math.floor(speed * 1.852), " km/h");
    }
};
var getLocationLabel = function (loc, speedUnit, hideName) {
    // 파킹모드면서 내 대시캠 볼떄는 이름 표시 안함 + 속도도 표시 안함
    // if (hideName && loc.mode === "1") {
    //   return;
    // }
    var _a;
    var isParking = loc.active === "on" && loc.mode === "1";
    var showSpeed = loc.speed !== undefined && loc.mode === "0" && loc.active === "on";
    // mantis : 8438
    // cloud가 해제된 카메라는 이름크기만큼만 높이가 나오도록 수정.
    var height = 19;
    if (!hideName && loc.mode === "0" && loc.active === "on") {
        height = 29;
    }
    var padding = 2;
    var paddingHeight = 0;
    var name = hideName ? "" : (_a = loc.name) !== null && _a !== void 0 ? _a : "";
    var maxTextWidth = isParking ? 74 : 84;
    var textPadding = isParking ? 26 : 16;
    var textWidth = getTextWidth(name, "11px Roboto") + textPadding;
    if (textWidth > maxTextWidth + textPadding) {
        do {
            name = name.substring(0, name.length - 2);
            textWidth = getTextWidth(name, "11px Roboto");
        } while (textWidth > maxTextWidth);
        name = name + "...";
        textWidth = getTextWidth(name, "11px Roboto") + textPadding;
    }
    var speedValue = getSpeedValue(loc, speedUnit);
    var speedWidth = getTextWidth(speedValue, "9px Roboto") + textPadding;
    if (!loc.name || hideName) {
        textWidth = 16;
    }
    if (textWidth < speedWidth && showSpeed) {
        textWidth = Math.min(speedWidth, 100);
    }
    // mantis : 8438
    //  cloud가 해제된 카메라는 speedText가 나타나지 않게 수정.
    var speedText = showSpeed &&
        "<text x=\"".concat((textWidth + padding) / 2, "\" y=\"").concat(hideName ? 14 : 25, "\" font-family=\"Roboto\" font-size=\"9\" text-anchor=\"middle\" fill=\"").concat(LightColors.primary["2"].replace("#", "%23"), "\" >").concat(speedValue, "</text>");
    // 이름도 표시 안하고 속도도 표시 안하는 경우(parking모드)
    if (!loc.name && !speedText) {
        textWidth = 16;
    }
    var parkingMarkup = "";
    var nameTextTranslate = "";
    if (loc.active === "on" && loc.mode === "1") {
        parkingMarkup = "<g transform=\"translate(".concat(textWidth + padding - 12, ", 6)\">\n      <path d=\"M0.5 0.5H4.26923C5.12608 0.5 5.94784 0.816071 6.55373 1.37868C7.15962 1.94129 7.5 2.70435 7.5 3.5C7.5 4.29565 7.15962 5.05871 6.55373 5.62132C5.94784 6.18393 5.12608 6.5 4.26923 6.5H2.65385V9.5H0.5V0.5ZM2.65385 2.5V4.5H4.26923C4.55485 4.5 4.82877 4.39464 5.03073 4.20711C5.23269 4.01957 5.34615 3.76522 5.34615 3.5C5.34615 3.23478 5.23269 2.98043 5.03073 2.79289C4.82877 2.60536 4.55485 2.5 4.26923 2.5H2.65385Z\" fill=\"%232EA8E5\"/>\n      </g>");
        nameTextTranslate = "transform=\"translate(-4,0)\"";
    }
    // console.log(
    //   "LocationMap",
    //   "getLocationLabel",
    //   loc,
    //   "hideName",
    //   hideName,
    //   "height",
    //   height,
    //   "name",
    //   name,
    //   "isParking",
    //   isParking,
    //   "maxTextWidth",
    //   maxTextWidth,
    //   "textPadding",
    //   textPadding,
    //   "speedWidth",
    //   speedWidth,
    //   "speedText",
    //   speedText,
    //   "single",
    //   !(!hideName && loc.mode === "0" && loc.active === "on")
    // );
    return {
        width: textWidth + padding,
        height: height + paddingHeight,
        single: !(!hideName && loc.mode === "0" && loc.active === "on"),
        svg: "data:image/svg+xml;utf-8,\n    <svg width=\"".concat(textWidth + padding, "\" height=\"").concat(height + paddingHeight, "\" viewBox=\"0 0 ").concat(textWidth + padding, " ").concat(height + paddingHeight, "\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n      <g>\n      <g >\n          <rect x=\"0\" y=\"0\" width=\"").concat(textWidth + padding, "\" height=\"").concat(height + paddingHeight, "\" rx=\"4\" ry=\"4\" fill=\"white\" />\n      </g>\n\n      <g ").concat(nameTextTranslate, ">\n      <text x=\"").concat((textWidth + padding) / 2, "\" y=\"").concat(14, "\" font-family=\"Roboto\" font-size=\"11\" text-anchor=\"middle\" fill=\"").concat(LightColors.primary["1"].replace("#", "%23"), "\" >").concat(name, "</text>\n      </g>\n      ").concat(parkingMarkup, "\n\n      ").concat(speedText, "\n      </g>\n      \n    </svg>"),
    };
};
function getElementByXpath(path) {
    return document.evaluate(path, document, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null).singleNodeValue;
}
var simulateDblClick = function (x, y) {
    var event = new MouseEvent("dblclick", {
        view: window,
        bubbles: true,
        cancelable: true,
        screenX: x,
        screenY: y,
    });
    var element = document.elementFromPoint(x, y);
    element === null || element === void 0 ? void 0 : element.dispatchEvent(event);
};
function toggleFullscreen(element) {
    var browser = detect();
    //@ts-ignore
    console.log("element", element, element.fullscreen);
    //@ts-ignore
    if (element.fullscreen) {
        console.log("element is fullscreen");
        //@ts-ignore
        element.fullscreen = false;
        if ((browser === null || browser === void 0 ? void 0 : browser.name) === "ios-webview") {
            //@ts-ignore
            exitFullscreen(element);
        }
        else {
            //@ts-ignore
            screenfull.toggle(element);
        }
    }
    else {
        console.log("element is not fullscreen", browser === null || browser === void 0 ? void 0 : browser.name, element);
        //@ts-ignore
        element.fullscreen = true;
        if ((browser === null || browser === void 0 ? void 0 : browser.name) === "ios-webview") {
            //@ts-ignore
            requestFullscreen(element);
        }
        else {
            //@ts-ignore
            screenfull.request(element);
        }
    }
}
//|| (browser?.os === "Android OS" && browser?.name === "chrome")
// @ts-nocheck
function isFullscreen(element) {
    var browser = detect();
    console.log("isFullscreen", browser);
    if ((browser === null || browser === void 0 ? void 0 : browser.name) === "ios" || (browser === null || browser === void 0 ? void 0 : browser.name) === "crios") {
        return element.classList.contains("ios-map-fullscreen");
    }
    else {
        //@ts-ignore
        return screenfull.isFullscreen;
    }
}
function requestFullscreen(element) {
    var browser = detect();
    console.log("requestFullscreen", browser, element);
    if ((browser === null || browser === void 0 ? void 0 : browser.name) === "ios" ||
        (browser === null || browser === void 0 ? void 0 : browser.name) === "crios" ||
        (browser === null || browser === void 0 ? void 0 : browser.name) === "ios-webview" ||
        (browser === null || browser === void 0 ? void 0 : browser.name) == "chromium-webview") {
        element.classList.add("ios-map-fullscreen");
    }
    else {
        //@ts-ignore
        screenfull.request(element);
    }
}
function exitFullscreen(element) {
    var browser = detect();
    console.log("exitFullscreen", browser, element);
    if ((browser === null || browser === void 0 ? void 0 : browser.name) === "ios" ||
        (browser === null || browser === void 0 ? void 0 : browser.name) === "crios" ||
        (browser === null || browser === void 0 ? void 0 : browser.name) === "ios-webview" ||
        (browser === null || browser === void 0 ? void 0 : browser.name) == "chromium-webview") {
        element.classList.remove("ios-map-fullscreen");
    }
    else {
        // @ts-ignore
        screenfull.exit();
    }
}
var DMStoDegree = function (dms) {
    var degree = Math.floor(dms / 100);
    var min = (dms / 100 - degree) * 100;
    // console.log("DMStoDegree", dms, degree, min, degree + min / 60);
    return degree + min / 60;
};
var getAngle = function (v1, v2) {
    var dx = v2[0] - v1[0];
    var dy = v2[1] - v1[1];
    if (dx > 0) {
        return Math.PI * 0.5 - Math.atan2(dy, dx);
    }
    else if (dx < 0) {
        return Math.PI * 1.5 - Math.atan2(dy, dx);
    }
    else if (dy > 0) {
        return 0;
    }
    else if (dy < 0) {
        return Math.PI;
    }
    return NaN;
};
var getTextWidth = function (text, font) {
    var _a;
    var canvas = document.createElement("canvas");
    var context = canvas.getContext("2d");
    if (context) {
        context.font = font || getComputedStyle(document.body).font;
    }
    return (_a = context === null || context === void 0 ? void 0 : context.measureText(text).width) !== null && _a !== void 0 ? _a : 0;
};
var convertGeofenceToGeometries = function (geofences) {
    return _.chain(geofences)
        .map(function (geofence) {
        if (geofence.polygon) {
            return {
                fenceId: geofence.fenceId,
                type: "polygon",
                coords: geofence.polygon,
                color: geofence.setShape.Color,
                opacity: geofence.setShape.Transparency,
            };
        }
        else if (geofence.polyline) {
            return {
                fenceId: geofence.fenceId,
                type: "polyline",
                coords: geofence.polyline,
                color: geofence.setShape.Color,
                opacity: geofence.setShape.Transparency,
            };
        }
        else if (geofence.circle) {
            return {
                fenceId: geofence.fenceId,
                type: "circle",
                center: {
                    lat: geofence.circle[0].lat,
                    lng: geofence.circle[0].lng,
                },
                radius: geofence.circle[0].radius,
                color: geofence.setShape.Color,
                opacity: geofence.setShape.Transparency,
            };
        }
        else if (geofence.rectangle) {
            var east = _.chain(geofence.rectangle)
                .map(function (r) { return r.lng; })
                .max()
                .value();
            var west = _.chain(geofence.rectangle)
                .map(function (r) { return r.lng; })
                .min()
                .value();
            var north = _.chain(geofence.rectangle)
                .map(function (r) { return r.lat; })
                .max()
                .value();
            var south = _.chain(geofence.rectangle)
                .map(function (r) { return r.lat; })
                .min()
                .value();
            return {
                fenceId: geofence.fenceId,
                type: "rectangle",
                bounds: { east: east, west: west, north: north, south: south },
                color: geofence.setShape.Color,
                opacity: geofence.setShape.Transparency,
            };
        }
        return undefined;
    })
        .compact()
        .value();
};
var renderGeofences = function (map, maps, geometries, mobile, fitBounds, onSelectGeofence) {
    var minLat = 999, minLng = 999, maxLat = -999, maxLng = -999;
    var objects = _.chain(geometries)
        .map(function (geo) {
        if (geo.type === "polygon") {
            _.forEach(geo.coords, function (coord) {
                minLat = Math.min(minLat, coord.lat);
                minLng = Math.min(minLng, coord.lng);
                maxLat = Math.max(maxLat, coord.lat);
                maxLng = Math.max(maxLng, coord.lng);
            });
            var obj = new maps.Polygon({
                paths: geo.coords,
                strokeColor: geo.color,
                strokeWeight: 3,
                fillColor: geo.color,
                fillOpacity: geo.opacity,
            });
            obj.setMap(map);
            obj.addListener("click", function () {
                onSelectGeofence && geo.fenceId && onSelectGeofence(geo.fenceId);
            });
            return obj;
        }
        else if (geo.type === "polyline") {
            _.forEach(geo.coords, function (coord) {
                minLat = Math.min(minLat, coord.lat);
                minLng = Math.min(minLng, coord.lng);
                maxLat = Math.max(maxLat, coord.lat);
                maxLng = Math.max(maxLng, coord.lng);
            });
            var obj = new maps.Polyline({
                path: geo.coords,
                geodesic: true,
                strokeColor: geo.color,
                strokeWeight: 3,
                strokeOpacity: 1.0,
            });
            obj.setMap(map);
            obj.addListener("click", function () {
                onSelectGeofence && geo.fenceId && onSelectGeofence(geo.fenceId);
            });
            return obj;
        }
        else if (geo.type === "circle") {
            var obj = new maps.Circle({
                center: geo.center,
                radius: geo.radius,
                strokeColor: geo.color,
                strokeWeight: 3,
                fillColor: geo.color,
                fillOpacity: geo.opacity,
            });
            obj.setMap(map);
            var bound = obj.getBounds();
            var ne = bound.getNorthEast();
            var sw = bound.getSouthWest();
            minLat = Math.min(minLat, sw.lat());
            minLng = Math.min(minLng, sw.lng());
            maxLat = Math.max(maxLat, ne.lat());
            maxLng = Math.max(maxLng, ne.lng());
            obj.addListener("click", function () {
                onSelectGeofence && geo.fenceId && onSelectGeofence(geo.fenceId);
            });
            return obj;
        }
        else if (geo.type === "rectangle") {
            var obj = new maps.Rectangle({
                bounds: geo.bounds,
                strokeColor: geo.color,
                strokeWeight: 3,
                fillColor: geo.color,
                fillOpacity: geo.opacity,
            });
            obj.setMap(map);
            var bound = geo.bounds;
            if (bound) {
                minLat = Math.min(minLat, bound.south);
                minLng = Math.min(minLng, bound.west);
                maxLat = Math.max(maxLat, bound.north);
                maxLng = Math.max(maxLng, bound.east);
            }
            obj.addListener("click", function () {
                onSelectGeofence && geo.fenceId && onSelectGeofence(geo.fenceId);
            });
            return obj;
        }
        return undefined;
    })
        .compact()
        .value();
    if (fitBounds) {
        map.fitBounds({
            east: maxLng,
            north: maxLat,
            west: minLng,
            south: minLat,
        });
    }
    return objects;
};
var getIcon = function (d, type, maps, tindx, // tindx or heading
big) {
    var width = big ? 46 : 38;
    var height = big ? 50 : 42;
    if (type === "first") {
        return {
            anchor: new maps.Point(16, 40),
            size: new maps.Size(32, 47),
            scaledSize: new maps.Size(32, 47),
            url: "data:image/svg+xml;utf-8,\n    <svg width=\"32\" height=\"47\" viewBox=\"0 0 32 47\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"event-marker\">\n    <ellipse cx=\"16\" cy=\"40.5\" rx=\"6\" ry=\"3.5\" fill=\"%23D81A26\"/>\n    <g filter=\"url(%23filter0_d)\">\n    <mask id=\"path-2-inside-1\" fill=\"white\">\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M18 25.8186C23.1202 24.8781 27 20.3921 27 15C27 8.92487 22.0751 4 16 4C9.92487 4 5 8.92487 5 15C5 20.3921 8.87976 24.8781 14 25.8186V41H18V25.8186Z\"/>\n    </mask>\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M18 25.8186C23.1202 24.8781 27 20.3921 27 15C27 8.92487 22.0751 4 16 4C9.92487 4 5 8.92487 5 15C5 20.3921 8.87976 24.8781 14 25.8186V41H18V25.8186Z\" fill=\"%23D81A26\"/>\n    <path d=\"M18 25.8186L17.8193 24.8351L17 24.9856V25.8186H18ZM14 25.8186H15V24.9856L14.1807 24.8351L14 25.8186ZM14 41H13V42H14V41ZM18 41V42H19V41H18ZM26 15C26 19.9009 22.4735 23.9802 17.8193 24.8351L18.1807 26.8022C23.767 25.776 28 20.8834 28 15H26ZM16 5C21.5228 5 26 9.47715 26 15H28C28 8.37258 22.6274 3 16 3V5ZM6 15C6 9.47715 10.4772 5 16 5V3C9.37258 3 4 8.37258 4 15H6ZM14.1807 24.8351C9.52652 23.9802 6 19.9009 6 15H4C4 20.8834 8.23301 25.776 13.8193 26.8022L14.1807 24.8351ZM15 41V25.8186H13V41H15ZM18 40H14V42H18V40ZM17 25.8186V41H19V25.8186H17Z\" fill=\"white\" mask=\"url(%23path-2-inside-1)\"/>\n    </g>\n    <text text-anchor=\"middle\" alignment-baseline=\"middle\"  fill=\"%23ffffff\" x=\"16\" y=\"16\" font-size=\"10\" font-family=\"rotobo\">A".concat(tindx, "</text>\n    <defs>\n    <filter id=\"filter0_d\" x=\"0\" y=\"0\" width=\"32\" height=\"47\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\">\n    <feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"/>\n    <feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\"/>\n    <feOffset dy=\"1\"/>\n    <feGaussianBlur stdDeviation=\"2.5\"/>\n    <feColorMatrix type=\"matrix\" values=\"0 0 0 0 0.847059 0 0 0 0 0.101961 0 0 0 0 0.14902 0 0 0 0.45 0\"/>\n    <feBlend mode=\"normal\" in2=\"BackgroundImageFix\" result=\"effect1_dropShadow\"/>\n    <feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"effect1_dropShadow\" result=\"shape\"/>\n    </filter>\n    </defs>\n    </svg>\n    "),
        };
    }
    else if (type === "last") {
        return {
            anchor: new maps.Point(7, 40),
            size: new maps.Size(35, 47),
            scaledSize: new maps.Size(35, 47),
            url: "data:image/svg+xml;utf-8,\n    <svg width=\"35\" height=\"47\" viewBox=\"0 0 35 47\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n    <ellipse cx=\"7\" cy=\"40.5\" rx=\"6\" ry=\"3.5\" fill=\"%23D81A26\"/>\n    <g filter=\"url(%23filter0_d)\">\n    <path d=\"M30 7H9V4H5V41H9V25H30L25 16L30 7Z\" fill=\"%23D81A26\"/>\n    <path d=\"M8.5 7V7.5H9H29.1502L24.5629 15.7572L24.428 16L24.5629 16.2428L29.1502 24.5H9H8.5V25V40.5H5.5V4.5H8.5V7Z\" stroke=\"white\"/>\n    </g>\n    <defs>\n    <filter id=\"filter0_d\" x=\"0\" y=\"0\" width=\"35\" height=\"47\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\">\n    <feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"/>\n    <feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\"/>\n    <feOffset dy=\"1\"/>\n    <feGaussianBlur stdDeviation=\"2.5\"/>\n    <feColorMatrix type=\"matrix\" values=\"0 0 0 0 0.847059 0 0 0 0 0.101961 0 0 0 0 0.14902 0 0 0 0.45 0\"/>\n    <feBlend mode=\"normal\" in2=\"BackgroundImageFix\" result=\"effect1_dropShadow\"/>\n    <feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"effect1_dropShadow\" result=\"shape\"/>\n    </filter>\n    </defs>\n    </svg>",
        };
    }
    else if (type === "arrow") {
        return {
            anchor: new maps.Point(10, 10),
            size: new maps.Size(20, 20),
            scaledSize: new maps.Size(20, 20),
            url: "data:image/svg+xml;utf-8,\n    <svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n      <g transform=\"rotate(".concat(tindx, ",10,10)\">\n      <path d=\"M4 16.2632L10 3L16 16.2632L15.2 17L10 15L4.8 17L4 16.2632Z\" fill=\"%230095E0\"/>\n      <path d=\"M10.1795 14.5333L10 14.4643L9.82051 14.5333L4.91033 16.4219L4.60444 16.1401L10 4.2131L15.3956 16.1401L15.0897 16.4219L10.1795 14.5333Z\" stroke=\"white\"/>\n      </g>\n    </svg>"),
        };
    }
    else if (type === "event") {
        if (d.mode === "M") {
            return {
                anchor: new maps.Point(width / 2, height - 6),
                size: new maps.Size(width, height),
                scaledSize: new maps.Size(width, height),
                url: "data:image/svg+xml;utf-8,\n        <svg width=\"".concat(width, "\" height=\"").concat(height, "\" viewBox=\"0 0 38 42\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n        <g filter=\"url(%23filter0_d_14309_4164)\">\n        <path d=\"M32.5 17.7143C32.5 23.4606 28.7508 28.3588 23.5031 30.1757C22.8482 30.4025 22.3353 30.9237 21.9187 31.4855C21.513 32.0326 21.1524 32.6838 20.8209 33.2824C20.8089 33.3042 20.7969 33.3259 20.7849 33.3475C20.4332 33.9822 20.1176 34.5436 19.7904 34.9497C19.4543 35.3668 19.2007 35.5 19 35.5C18.7997 35.5 18.5487 35.3681 18.2162 34.9528C17.8919 34.5479 17.5801 33.9882 17.2306 33.3537L17.2044 33.3061C16.8723 32.7031 16.5096 32.0444 16.0975 31.4906C15.6777 30.9265 15.1601 30.4053 14.4969 30.1757C9.24924 28.3588 5.5 23.4606 5.5 17.7143C5.5 10.4259 11.5344 4.5 19 4.5C26.4656 4.5 32.5 10.4259 32.5 17.7143Z\" fill=\"%23ED9600\" stroke=\"white\"/>\n        <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13.14 19.6188C13.1443 19.4995 13.1203 19.3809 13.0699 19.2727C13.0194 19.1646 12.9441 19.07 12.85 18.9969C12.5437 18.7899 12.206 18.6341 11.85 18.5354C11.4534 18.404 11.0659 18.2465 10.69 18.0639C10.2721 17.9168 9.9083 17.6466 9.64603 17.2886C9.38376 16.9307 9.23526 16.5017 9.22 16.0577C9.21341 15.6567 9.34006 15.265 9.57999 14.9442C9.84189 14.6099 10.1867 14.3505 10.58 14.1918C11.0782 14.005 11.6085 13.9198 12.14 13.9411C12.6416 13.9346 13.1389 14.0337 13.6 14.232C14.0028 14.4128 14.3486 14.7008 14.6 15.0646C14.8411 15.4301 14.9666 15.8602 14.96 16.2984H13.14C13.1489 16.1663 13.1284 16.0339 13.08 15.9107C13.0316 15.7875 12.9564 15.6767 12.86 15.5862C12.646 15.4038 12.3704 15.3105 12.09 15.3254C11.8158 15.3091 11.5442 15.387 11.32 15.5461C11.229 15.6028 11.154 15.6819 11.102 15.7758C11.05 15.8697 11.0227 15.9753 11.0227 16.0828C11.0227 16.1902 11.05 16.2958 11.102 16.3897C11.154 16.4836 11.229 16.5627 11.32 16.6194C11.6589 16.8397 12.0301 17.0055 12.42 17.111C12.8867 17.2465 13.3389 17.428 13.77 17.6527C14.1419 17.8369 14.4539 18.1232 14.6699 18.4784C14.8859 18.8336 14.9969 19.2429 14.99 19.6589C15.0016 19.9613 14.9394 20.262 14.8087 20.5348C14.678 20.8075 14.4827 21.0441 14.24 21.2238C13.6386 21.6369 12.9176 21.8381 12.19 21.7956C11.6094 21.8096 11.0327 21.6967 10.5 21.4646C10.0286 21.256 9.63362 20.9054 9.36997 20.4614C9.11762 20.067 8.98876 19.6058 8.99997 19.1373H10.83C10.8151 19.3012 10.835 19.4664 10.8884 19.6221C10.9418 19.7777 11.0276 19.9202 11.14 20.0401C11.428 20.2538 11.7827 20.3569 12.14 20.331C12.3952 20.3427 12.6474 20.2724 12.86 20.1304C12.9431 20.0728 13.0116 19.9966 13.0602 19.9078C13.1088 19.819 13.1361 19.72 13.14 19.6188ZM22.31 18.0036C22.3276 18.695 22.1874 19.3813 21.9 20.0099C21.646 20.5298 21.2552 20.9703 20.77 21.2839C20.2515 21.5973 19.6552 21.7573 19.05 21.7453C18.4461 21.7571 17.8507 21.6008 17.33 21.2939C16.8239 20.9935 16.4171 20.5504 16.16 20.0199C15.8773 19.4281 15.7304 18.7803 15.73 18.124V17.6927C15.7092 17.0021 15.846 16.3158 16.13 15.6864C16.381 15.1724 16.773 14.7409 17.26 14.4425C17.7838 14.1368 18.379 13.9757 18.985 13.9757C19.591 13.9757 20.1862 14.1368 20.71 14.4425C21.2152 14.7573 21.6209 15.2095 21.88 15.7466C22.1674 16.3546 22.3143 17.0198 22.31 17.6927V18.0036ZM20.45 17.6826C20.4903 17.0861 20.3584 16.4905 20.07 15.9673C19.96 15.7822 19.803 15.6299 19.6149 15.5259C19.4269 15.4219 19.2146 15.3699 19 15.3754C18.08 15.3754 17.6 16.0676 17.55 17.4419V18.0036C17.5142 18.5986 17.6422 19.1921 17.92 19.719C18.0316 19.9094 18.1932 20.0653 18.3872 20.1697C18.5812 20.2741 18.8001 20.3229 19.02 20.3108C19.2325 20.3187 19.4432 20.2688 19.6298 20.1664C19.8164 20.0639 19.972 19.9128 20.08 19.729C20.3616 19.2105 20.4932 18.6233 20.46 18.0337L20.45 17.6826ZM27.0843 19.2742C27.133 19.3823 27.1555 19.5003 27.15 19.6188C27.1462 19.72 27.1188 19.819 27.0702 19.9078C27.0216 19.9966 26.953 20.0728 26.87 20.1304C26.6574 20.2725 26.4052 20.3427 26.15 20.331C25.7927 20.357 25.438 20.2538 25.15 20.0401C25.0376 19.9202 24.9518 19.7777 24.8984 19.6221C24.845 19.4665 24.8251 19.3012 24.84 19.1373H23.01C22.9988 19.6058 23.1276 20.067 23.38 20.4614C23.6462 20.9033 24.0404 21.2533 24.51 21.4646C25.0396 21.6953 25.6127 21.8082 26.19 21.7956C26.9205 21.8365 27.6443 21.6356 28.25 21.2238C28.4915 21.0436 28.6853 20.8067 28.8144 20.5339C28.9434 20.261 29.0036 19.9606 28.99 19.6589C28.9969 19.243 28.8859 18.8336 28.6699 18.4784C28.4539 18.1232 28.1419 17.8369 27.77 17.6527C27.3485 17.4298 26.9064 17.2484 26.45 17.111C26.0607 17.0038 25.6898 16.838 25.35 16.6194C25.2594 16.5649 25.1837 16.4887 25.1296 16.3977C25.0755 16.3067 25.0448 16.2037 25.04 16.0978C25.0392 15.9901 25.0642 15.8837 25.1129 15.7877C25.1616 15.6917 25.2326 15.6088 25.32 15.5461C25.5442 15.387 25.8158 15.3092 26.09 15.3254C26.3704 15.3105 26.646 15.4039 26.86 15.5862C26.9564 15.6767 27.0316 15.7875 27.08 15.9107C27.1284 16.0339 27.1489 16.1663 27.14 16.2984H28.96C28.9653 15.8618 28.8437 15.433 28.61 15.0646C28.3575 14.7018 28.012 14.4142 27.61 14.232C27.149 14.0338 26.6516 13.9347 26.15 13.9411C25.6219 13.9211 25.0951 14.0064 24.6 14.1919C24.2067 14.3505 23.8619 14.6099 23.6 14.9442C23.3601 15.265 23.2334 15.6567 23.24 16.0577C23.2552 16.5017 23.4037 16.9307 23.666 17.2886C23.9283 17.6466 24.2921 17.9168 24.71 18.064C25.0859 18.2465 25.4734 18.404 25.87 18.5354C26.2254 18.6355 26.5629 18.7913 26.87 18.9969C26.9622 19.0711 27.0357 19.1661 27.0843 19.2742Z\" fill=\"white\"/>\n        </g>\n        <defs>\n        <filter id=\"filter0_d_14309_4164\" x=\"0\" y=\"0\" width=\"38\" height=\"42\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\">\n        <feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"/>\n        <feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\"/>\n        <feOffset dy=\"1\"/>\n        <feGaussianBlur stdDeviation=\"2.5\"/>\n        <feColorMatrix type=\"matrix\" values=\"0 0 0 0 0.937255 0 0 0 0 0.588235 0 0 0 0 0 0 0 0 0.45 0\"/>\n        <feBlend mode=\"normal\" in2=\"BackgroundImageFix\" result=\"effect1_dropShadow_14309_4164\"/>\n        <feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"effect1_dropShadow_14309_4164\" result=\"shape\"/>\n        </filter>\n        </defs>\n        </svg>"),
            };
        }
        else if (d.mode === "E" || d.mode === "S") {
            var iconUrl = "data:image/svg+xml;utf-8,\n        <svg width=\"".concat(width, "\" height=\"").concat(height, "\" viewBox=\"0 0 38 42\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"event-marker\">\n        <g filter=\"url(%23filter0_d_14309_4166)\">\n        <path d=\"M5.5 17.7143C5.5 10.4259 11.5344 4.5 19 4.5C26.4656 4.5 32.5 10.4259 32.5 17.7143C32.5 23.4606 28.7508 28.3588 23.5031 30.1757C22.8482 30.4025 22.3353 30.9237 21.9187 31.4855C21.513 32.0326 21.1524 32.6838 20.8209 33.2824L20.7849 33.3475C20.4332 33.9822 20.1176 34.5436 19.7904 34.9497C19.4543 35.3668 19.2007 35.5 19 35.5C18.7997 35.5 18.5487 35.3681 18.2162 34.9528C17.8919 34.5479 17.5801 33.9882 17.2306 33.3537L17.2044 33.3061C16.8723 32.7031 16.5096 32.0444 16.0975 31.4906C15.6777 30.9265 15.1601 30.4053 14.4969 30.1757C9.24924 28.3588 5.5 23.4606 5.5 17.7143Z\" fill=\"%23D81A26\" stroke=\"white\"/>\n        <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M15.4834 18.1562V18.3464C15.4739 18.4957 15.5025 18.6449 15.5664 18.7796V19.2656L13.2837 21.3788L13.9996 18.1034L10.7 18.209L13.3148 16.1592L10.7208 14.046L14.01 14.1834L13.3356 10.8973L15.774 13.1584L17.3304 10.2L17.7765 13.4754L20.7856 12.3026L19.25 14.7645H18.4821C18.2047 14.762 17.9327 14.8429 17.7002 14.997C17.4676 15.1511 17.2849 15.3716 17.1747 15.6309L16.6455 17.237H16.3861C16.1484 17.2423 15.9218 17.3409 15.7537 17.5122C15.5855 17.6834 15.4887 17.9141 15.4834 18.1562ZM24.7932 15.4162C24.9246 15.5146 25.0276 15.6472 25.0917 15.8L25.6831 17.8815H26.3368C26.4315 17.8866 26.521 17.9272 26.5881 17.9954C26.6551 18.0637 26.695 18.1549 26.7 18.2513V18.4415C26.6952 18.539 26.6557 18.6314 26.5889 18.7015C26.522 18.7715 26.4324 18.8143 26.3368 18.8219H26.2434L26.5236 19.1071V23.5343C26.5324 23.6974 26.4791 23.8577 26.3747 23.9817C26.2703 24.1057 26.1229 24.1839 25.9633 24.2H25.4964C25.2266 24.2 24.9464 23.8196 24.9464 23.5343V22.4777H17.6831V23.5343C17.6919 23.6974 17.6386 23.8577 17.5342 23.9817C17.4298 24.1057 17.2824 24.1839 17.1228 24.2H16.6559C16.3861 24.2 16.106 23.8196 16.106 23.5343V19.1071L16.4795 18.7268H16.3861C16.2894 18.7194 16.1985 18.677 16.13 18.6072C16.0614 18.5374 16.0198 18.4448 16.0126 18.3464V18.1562C16.02 18.0588 16.0621 17.9676 16.1308 17.8995C16.1996 17.8315 16.2904 17.7912 16.3861 17.7864H17.0294L17.6831 15.8C17.7475 15.6306 17.862 15.4857 18.0107 15.3854C18.1594 15.2851 18.3349 15.2343 18.5132 15.24H24.3446C24.5069 15.2568 24.6618 15.3177 24.7932 15.4162ZM24.3446 16.0853H18.5132L17.6831 18.5366H25.1851L24.3446 16.0853ZM17.822 20.9236C17.9227 20.966 18.0307 20.9879 18.1397 20.9879C18.2496 20.9893 18.3586 20.9685 18.4605 20.9266C18.5624 20.8848 18.6552 20.8227 18.7334 20.7441C18.8115 20.6655 18.8736 20.5718 18.916 20.4686C18.9584 20.3653 18.9802 20.2545 18.9802 20.1426C18.9802 19.9156 18.8916 19.6979 18.734 19.5374C18.5764 19.3769 18.3626 19.2868 18.1397 19.2868C18.0298 19.2868 17.921 19.309 17.8196 19.3521C17.7182 19.3952 17.6263 19.4585 17.549 19.5381C17.4718 19.6177 17.4109 19.7121 17.3698 19.8159C17.3287 19.9197 17.3082 20.0307 17.3096 20.1426C17.3096 20.2536 17.3311 20.3635 17.3728 20.4661C17.4145 20.5687 17.4756 20.6618 17.5527 20.7403C17.6298 20.8188 17.7213 20.8811 17.822 20.9236ZM24.3071 20.9236C24.4078 20.966 24.5158 20.9879 24.6248 20.9879C24.7338 20.9879 24.8417 20.966 24.9424 20.9236C25.0432 20.8811 25.1346 20.8188 25.2117 20.7403C25.2888 20.6618 25.35 20.5687 25.3917 20.4661C25.4334 20.3635 25.4549 20.2536 25.4549 20.1426C25.4562 20.0307 25.4358 19.9197 25.3947 19.8159C25.3536 19.7121 25.2926 19.6177 25.2154 19.5381C25.1382 19.4585 25.0462 19.3952 24.9448 19.3521C24.8435 19.309 24.7347 19.2868 24.6248 19.2868C24.5149 19.2868 24.4061 19.309 24.3047 19.3521C24.2033 19.3952 24.1113 19.4585 24.0341 19.5381C23.9569 19.6177 23.896 19.7121 23.8549 19.8159C23.8138 19.9197 23.7933 20.0307 23.7947 20.1426C23.7947 20.2536 23.8162 20.3635 23.8579 20.4661C23.8996 20.5687 23.9607 20.6618 24.0378 20.7403C24.1149 20.8188 24.2064 20.8811 24.3071 20.9236Z\" fill=\"white\"/>\n        </g>\n        <defs>\n        <filter id=\"filter0_d_14309_4166\" x=\"0\" y=\"0\" width=\"38\" height=\"42\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\">\n        <feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"/>\n        <feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\"/>\n        <feOffset dy=\"1\"/>\n        <feGaussianBlur stdDeviation=\"2.5\"/>\n        <feColorMatrix type=\"matrix\" values=\"0 0 0 0 0.847059 0 0 0 0 0.101961 0 0 0 0 0.14902 0 0 0 0.45 0\"/>\n        <feBlend mode=\"normal\" in2=\"BackgroundImageFix\" result=\"effect1_dropShadow_14309_4166\"/>\n        <feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"effect1_dropShadow_14309_4166\" result=\"shape\"/>\n        </filter>\n        </defs>\n        </svg>");
            if (_.includes([1, 3, 4, 5], d.mtype)) {
                iconUrl = "data:image/svg+xml;utf-8,\n        <svg width=\"".concat(width, "\" height=\"").concat(height, "\" viewBox=\"0 0 38 42\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n        <g filter=\"url(%23filter0_d_14309_4165)\">\n        <path d=\"M32.5 17.7143C32.5 23.4606 28.7508 28.3588 23.5031 30.1757C22.8482 30.4025 22.3353 30.9237 21.9187 31.4855C21.513 32.0326 21.1524 32.6838 20.8209 33.2824C20.8089 33.3042 20.7969 33.3259 20.7849 33.3475C20.4332 33.9822 20.1176 34.5436 19.7904 34.9497C19.4543 35.3668 19.2007 35.5 19 35.5C18.7997 35.5 18.5487 35.3681 18.2162 34.9528C17.8919 34.5479 17.5801 33.9882 17.2306 33.3537L17.2044 33.3061C16.8723 32.7031 16.5096 32.0444 16.0975 31.4906C15.6777 30.9265 15.1601 30.4053 14.4969 30.1757C9.24924 28.3588 5.5 23.4606 5.5 17.7143C5.5 10.4259 11.5344 4.5 19 4.5C26.4656 4.5 32.5 10.4259 32.5 17.7143Z\" fill=\"%23D81A26\" stroke=\"white\"/>\n        <path d=\"M19 28.5C24.9371 28.5 29.75 23.6871 29.75 17.75C29.75 11.8129 24.9371 7 19 7C13.0629 7 8.25 11.8129 8.25 17.75C8.25 23.6871 13.0629 28.5 19 28.5Z\" fill=\"%23FFEC00\"/>\n        <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M19.6283 9.37707C19.4992 9.17482 19.2609 9.08132 19.0203 9.14043L15.177 10.0849C14.9311 10.1453 14.7686 10.3373 14.7426 10.5777L14.6211 12.0171L14.1712 12.1276C14.0236 12.1639 13.935 12.3197 13.9733 12.4755L14.008 12.6166C14.0463 12.7725 14.197 12.8694 14.3446 12.8332L14.4355 12.8108L14.2681 13.0983L15.0086 16.1115C15.0601 16.3211 15.2836 16.4928 15.4868 16.4429L15.8182 16.3615C16.0213 16.3115 16.1302 16.0625 16.0786 15.8529L15.9042 15.1433L20.7151 13.961L20.8895 14.6707C20.941 14.8803 21.1582 15.0492 21.3613 14.9993L21.6874 14.9191C21.8905 14.8692 22.009 14.6135 21.9575 14.4038L21.2171 11.3907L20.9355 11.2135L21.0263 11.1912C21.1739 11.1549 21.2626 10.9991 21.2243 10.8433L21.1896 10.7022C21.1513 10.5463 21.0006 10.4494 20.853 10.4856L20.4031 10.5962L19.6283 9.37707ZM15.3125 10.6365L19.1559 9.69204L20.1131 11.2116L15.1686 12.4266L15.3125 10.6365ZM15.9067 14C15.6127 14.0723 15.3112 13.8832 15.2366 13.5798C15.1621 13.2764 15.3416 12.969 15.6356 12.8968C15.9296 12.8246 16.2311 13.0137 16.3057 13.317C16.3803 13.6204 16.2007 13.9278 15.9067 14ZM20.183 12.9491C19.889 13.0214 19.5875 12.8323 19.5129 12.5289C19.4384 12.2255 19.6179 11.9182 19.9119 11.8459C20.2059 11.7737 20.5074 11.9628 20.582 12.2662C20.6565 12.5696 20.477 12.8769 20.183 12.9491Z\" fill=\"%2313131C\"/>\n        <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M24.58 16.8921C23.1909 16.4248 21.7381 16.1247 20.26 16C21.6337 16.322 22.9523 16.8081 24.18 17.4452C24.75 17.7664 25.29 18.2838 25.36 18.605C25.43 18.9262 25.04 19.283 24.52 19.6042L25.47 20.6391C25.7906 20.3789 26.0668 20.0783 26.29 19.7469C26.416 19.5383 26.4942 19.3093 26.52 19.0735C26.5457 18.8376 26.5185 18.5995 26.44 18.3731C26.2626 17.9875 25.964 17.6559 25.58 17.4185C25.2675 17.2133 24.9324 17.037 24.58 16.8921ZM18.53 16.1874C19.6923 16.54 20.8141 16.9911 21.88 17.5345C22.4473 17.8054 22.942 18.1828 23.33 18.6407C23.4462 18.7834 23.5185 18.9507 23.5395 19.126C23.5606 19.3013 23.5297 19.4785 23.45 19.6399C23.274 19.931 23.0063 20.1698 22.68 20.3268C22.0954 20.557 21.6084 20.9477 21.29 21.442C21.2357 21.5342 21.2073 21.6367 21.2073 21.7409C21.2073 21.8012 21.2351 21.8919 21.2584 21.9576C21.2781 22.0128 21.3058 22.0645 21.3398 22.1123C21.3817 22.171 21.4436 22.2527 21.5 22.3074C21.5973 22.4016 21.6902 22.4565 21.7884 22.5144C21.8119 22.5283 21.8358 22.5423 21.86 22.5571C22.9835 23.1653 24.3254 23.3664 25.61 23.1192L25.8 24.4485C24.1666 24.613 22.5244 24.214 21.21 23.3333C21.0411 23.2146 20.8839 23.0833 20.74 22.9408C20.588 22.7745 20.5032 22.6775 20.38 22.3876C20.2568 22.0978 20.2448 21.9603 20.2568 21.7385C20.2689 21.5167 20.3348 21.2998 20.45 21.103C20.9089 20.4781 21.5879 20.0073 22.38 19.7648C22.88 19.5418 23.18 19.2652 22.91 18.8727C22.5945 18.4452 22.1865 18.0782 21.71 17.7932C20.7099 17.1685 19.6451 16.6308 18.53 16.1874ZM17.12 16.4639C17.5749 16.709 17.9694 17.0337 18.28 17.4185C18.4516 17.6272 18.5364 17.8827 18.52 18.1411C18.4831 18.4094 18.3329 18.6551 18.1 18.828C17.6598 19.1343 17.1571 19.3615 16.62 19.4971C16.104 19.6334 15.4317 19.8022 15.05 19.8272C14.1513 19.886 13.2575 20.0516 12.43 20.3625C12.05 20.5052 11.75 20.7372 11.73 20.8799C11.71 21.0226 11.8 21.1832 12.01 21.4509L10.78 22.2092C10.6095 21.964 10.4845 21.6959 10.41 21.4152C10.3076 21.0755 10.3466 20.7141 10.52 20.3981C10.6839 20.1508 10.9022 19.9356 11.1617 19.7655C11.4212 19.5953 11.7165 19.4737 12.03 19.4079C12.5248 19.2748 13.0346 19.1911 13.55 19.1581C14.0462 19.1313 14.5438 19.1313 15.04 19.1581C15.5461 19.138 16.0504 19.0903 16.55 19.0154C17.0221 18.9418 17.4738 18.7873 17.88 18.5604C17.9764 18.5068 18.0598 18.4366 18.1252 18.3538C18.1907 18.2711 18.2369 18.1775 18.2611 18.0785C18.2854 17.9796 18.2871 17.8773 18.2663 17.7777C18.2455 17.6781 18.2026 17.5833 18.14 17.4987C17.8807 17.0966 17.5339 16.7447 17.12 16.4639Z\" fill=\"%2313131C\"/>\n        </g>\n        <defs>\n        <filter id=\"filter0_d_14309_4165\" x=\"0\" y=\"0\" width=\"38\" height=\"42\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\">\n        <feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"/>\n        <feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\"/>\n        <feOffset dy=\"1\"/>\n        <feGaussianBlur stdDeviation=\"2.5\"/>\n        <feColorMatrix type=\"matrix\" values=\"0 0 0 0 0.847059 0 0 0 0 0.101961 0 0 0 0 0.14902 0 0 0 0.45 0\"/>\n        <feBlend mode=\"normal\" in2=\"BackgroundImageFix\" result=\"effect1_dropShadow_14309_4165\"/>\n        <feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"effect1_dropShadow_14309_4165\" result=\"shape\"/>\n        </filter>\n        </defs>\n        </svg>");
            }
            if (d.mtype >= 6 && d.mtype <= 12) {
                iconUrl = "data:image/svg+xml;utf-8,\n        <svg width=\"".concat(width, "\" height=\"").concat(height, "\" viewBox=\"0 0 38 42\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n        <g filter=\"url(%23filter0_d_14312_4187)\">\n        <path d=\"M5.5 17.7143C5.5 10.4259 11.5344 4.5 19 4.5C26.4656 4.5 32.5 10.4259 32.5 17.7143C32.5 23.4606 28.7508 28.3588 23.5031 30.1757C22.8482 30.4025 22.3353 30.9237 21.9187 31.4855C21.513 32.0326 21.1524 32.6838 20.8209 33.2824L20.7849 33.3475C20.4332 33.9822 20.1176 34.5436 19.7904 34.9497C19.4543 35.3668 19.2007 35.5 19 35.5C18.7997 35.5 18.5487 35.3681 18.2162 34.9528C17.8919 34.5479 17.5801 33.9882 17.2306 33.3537L17.2044 33.3061C16.8723 32.7031 16.5096 32.0444 16.0975 31.4906C15.6777 30.9265 15.1601 30.4053 14.4969 30.1757C9.24924 28.3588 5.5 23.4606 5.5 17.7143Z\" fill=\"%23D81A26\" stroke=\"white\"/>\n        <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M23.3471 11.5H27.8238V12.3313L25.1545 16.1063H27.8471V17.3H23.3471V16.446L25.9712 12.7052H23.3471V11.5ZM19.5 15.5H22.4608V16.1559L22.2574 16.504L20.951 18.4928H22.5V19.5H19.5V18.8314L20.1056 17.8891L21.0189 16.5072H19.5V15.5Z\" fill=\"white\"/>\n        <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M18.14 16.8875C18.14 18.206 17.0744 19.2749 15.76 19.2749C14.4455 19.2749 13.38 18.206 13.38 16.8875C13.38 15.5689 14.4455 14.5 15.76 14.5C17.0744 14.5 18.14 15.5689 18.14 16.8875ZM20.5 22.6367C20.5 21.0518 17.34 20.2493 15.75 20.2493C14.16 20.2493 11 21.0518 11 22.6367V23.8305H12.77C12.77 23.0323 13.0861 22.2669 13.6487 21.7025C14.2113 21.1381 14.9743 20.8211 15.77 20.8211C16.5656 20.8211 17.3287 21.1381 17.8913 21.7025C18.4539 22.2669 18.77 23.0323 18.77 23.8305H20.54L20.5 22.6367ZM15.75 21.6737C15.1798 21.6737 14.6329 21.9009 14.2297 22.3054C13.8265 22.7098 13.6 23.2584 13.6 23.8304H17.93C17.93 23.5446 17.8734 23.2617 17.7635 22.9981C17.6536 22.7344 17.4925 22.4953 17.2897 22.2946C17.0869 22.094 16.8463 21.9357 16.582 21.8291C16.3176 21.7225 16.0349 21.6697 15.75 21.6737Z\" fill=\"white\"/>\n        </g>\n        <defs>\n        <filter id=\"filter0_d_14312_4187\" x=\"0\" y=\"0\" width=\"38\" height=\"42\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\">\n        <feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"/>\n        <feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\"/>\n        <feOffset dy=\"1\"/>\n        <feGaussianBlur stdDeviation=\"2.5\"/>\n        <feColorMatrix type=\"matrix\" values=\"0 0 0 0 0.847059 0 0 0 0 0.101961 0 0 0 0 0.14902 0 0 0 0.45 0\"/>\n        <feBlend mode=\"normal\" in2=\"BackgroundImageFix\" result=\"effect1_dropShadow_14312_4187\"/>\n        <feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"effect1_dropShadow_14312_4187\" result=\"shape\"/>\n        </filter>\n        </defs>\n        </svg>");
            }
            if (d.mtype >= 13 && d.mtype <= 15) {
                iconUrl = "data:image/svg+xml;utf-8,\n        <svg width=\"".concat(width, "\" height=\"").concat(height, "\" viewBox=\"0 0 38 42\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n        <g filter=\"url(%23filter0_d_14732_4121)\">\n        <path d=\"M32.5 17.7143C32.5 23.4606 28.7508 28.3588 23.5031 30.1757C22.8482 30.4025 22.3353 30.9237 21.9187 31.4855C21.513 32.0326 21.1524 32.6838 20.8209 33.2824C20.8089 33.3042 20.7969 33.3259 20.7849 33.3475C20.4332 33.9822 20.1176 34.5436 19.7904 34.9497C19.4543 35.3668 19.2007 35.5 19 35.5C18.7997 35.5 18.5487 35.3681 18.2162 34.9528C17.8919 34.5479 17.5801 33.9882 17.2306 33.3537L17.2044 33.3061C16.8723 32.7031 16.5096 32.0444 16.0975 31.4906C15.6777 30.9265 15.1601 30.4053 14.4969 30.1757C9.24924 28.3588 5.5 23.4606 5.5 17.7143C5.5 10.4259 11.5344 4.5 19 4.5C26.4656 4.5 32.5 10.4259 32.5 17.7143Z\" fill=\"%23D81A26\" stroke=\"white\"/>\n        <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M19.0065 10.1747C21.4852 10.1747 23.5016 12.0149 23.5016 14.2771C23.5016 18.3795 19.0065 21.8958 19.0065 21.8958C19.0065 21.8958 14.5113 18.3795 14.5113 14.2771C14.5113 12.0149 16.5277 10.1747 19.0065 10.1747ZM21.3373 14.5034C21.3373 15.7907 20.2937 16.8342 19.0065 16.8342C17.7192 16.8342 16.6756 15.7907 16.6756 14.5034C16.6756 13.2161 17.7192 12.1726 19.0065 12.1726C20.2937 12.1726 21.3373 13.2161 21.3373 14.5034ZM21.6421 20.3556C21.3913 20.3112 21.1525 20.482 21.1089 20.7371C21.0652 20.9922 21.2332 21.235 21.484 21.2794C21.8294 21.3405 22.1498 21.4136 22.4405 21.4964C22.6856 21.5663 22.9401 21.4208 23.0088 21.1715C23.0775 20.9222 22.9345 20.6634 22.6893 20.5935C22.3654 20.5012 22.0144 20.4214 21.6421 20.3556ZM16.5289 21.2794C16.7798 21.235 16.9477 20.9922 16.9041 20.7371C16.8604 20.482 16.6217 20.3112 16.3708 20.3556C15.9985 20.4214 15.6475 20.5012 15.3236 20.5935C15.0785 20.6634 14.9354 20.9222 15.0041 21.1715C15.0729 21.4208 15.3273 21.5663 15.5725 21.4964C15.8631 21.4136 16.1835 21.3405 16.5289 21.2794ZM14.0174 22.2933C14.175 22.09 14.1407 21.7952 13.9408 21.6348C13.7408 21.4745 13.4509 21.5094 13.2933 21.7127C13.1267 21.9275 13.0129 22.1871 13.0129 22.481C13.0129 22.775 13.1267 23.0345 13.2933 23.2493C13.4509 23.4527 13.7408 23.4875 13.9408 23.3272C14.1407 23.1669 14.175 22.8721 14.0174 22.6688C13.9473 22.5784 13.935 22.5175 13.935 22.481C13.935 22.4446 13.9473 22.3837 14.0174 22.2933ZM24.7197 21.7127C24.562 21.5094 24.2721 21.4745 24.0722 21.6348C23.8722 21.7952 23.8379 22.09 23.9956 22.2933C24.0657 22.3837 24.0779 22.4446 24.0779 22.481C24.0779 22.5175 24.0657 22.5784 23.9956 22.6688C23.8379 22.8721 23.8722 23.1669 24.0722 23.3272C24.2721 23.4875 24.562 23.4527 24.7197 23.2493C24.8862 23.0345 25 22.775 25 22.481C25 22.1871 24.8862 21.9275 24.7197 21.7127ZM15.5725 23.4656C15.3273 23.3958 15.0729 23.5412 15.0041 23.7906C14.9354 24.0399 15.0785 24.2987 15.3236 24.3685C15.6475 24.4608 15.9985 24.5406 16.3708 24.6065C16.6217 24.6509 16.8604 24.4801 16.9041 24.225C16.9477 23.9699 16.7798 23.7271 16.5289 23.6827C16.1835 23.6216 15.8631 23.5485 15.5725 23.4656ZM22.6893 24.3685C22.9345 24.2987 23.0775 24.0399 23.0088 23.7906C22.9401 23.5412 22.6856 23.3958 22.4405 23.4656C22.1498 23.5485 21.8294 23.6216 21.484 23.6827C21.2332 23.7271 21.0652 23.9699 21.1089 24.225C21.1525 24.4801 21.3913 24.6509 21.6421 24.6065C22.0144 24.5406 22.3654 24.4608 22.6893 24.3685ZM18.5069 23.8798C18.2524 23.8719 18.0397 24.0752 18.0319 24.334C18.0241 24.5929 18.2241 24.8091 18.4786 24.8171C18.6525 24.8225 18.8286 24.8253 19.0065 24.8253C19.1844 24.8253 19.3605 24.8225 19.5343 24.8171C19.7888 24.8091 19.9888 24.5929 19.981 24.334C19.9732 24.0752 19.7605 23.8719 19.506 23.8798C19.3416 23.8849 19.175 23.8876 19.0065 23.8876C18.838 23.8876 18.6713 23.8849 18.5069 23.8798Z\" fill=\"white\"/>\n        </g>\n        <defs>\n        <filter id=\"filter0_d_14732_4121\" x=\"0\" y=\"0\" width=\"38\" height=\"42\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\">\n        <feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"/>\n        <feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\"/>\n        <feOffset dy=\"1\"/>\n        <feGaussianBlur stdDeviation=\"2.5\"/>\n        <feColorMatrix type=\"matrix\" values=\"0 0 0 0 0.847059 0 0 0 0 0.101961 0 0 0 0 0.14902 0 0 0 0.45 0\"/>\n        <feBlend mode=\"normal\" in2=\"BackgroundImageFix\" result=\"effect1_dropShadow_14732_4121\"/>\n        <feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"effect1_dropShadow_14732_4121\" result=\"shape\"/>\n        </filter>\n        </defs>\n        </svg>\n        ");
            }
            return {
                anchor: new maps.Point(width / 2, height - 6),
                size: new maps.Size(width, height),
                scaledSize: new maps.Size(width, height),
                url: iconUrl,
            };
        }
        else if (d.mode === "P") {
            if (!d.pevents || d.pevents.length === 0) {
                return {
                    anchor: new maps.Point(width / 2, height - 6),
                    size: new maps.Size(width, height),
                    scaledSize: new maps.Size(width, height),
                    url: "data:image/svg+xml;utf-8,\n          <svg width=\"".concat(width, "\" height=\"").concat(height, "\" viewBox=\"0 0 38 42\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n          <g filter=\"url(%23filter0_d_14309_4173)\">\n          <path d=\"M32 26.5C32 28.433 30.433 30 28.5 30H23.3983C23.0741 30 22.6913 30.1046 22.4204 30.4163C22.0812 30.8065 21.7882 31.3438 21.5336 31.8517C21.4361 32.0464 21.3447 32.2355 21.2569 32.4172C21.1031 32.7353 20.9602 33.0309 20.8142 33.2945C20.4564 33.9407 20.1364 34.5153 19.8038 34.9329C19.4617 35.3624 19.2039 35.5 19 35.5C18.7977 35.5 18.544 35.3654 18.2077 34.9422C17.8801 34.53 17.5655 33.9619 17.212 33.32C17.0682 33.0588 16.9281 32.7682 16.7771 32.4551C16.6852 32.2646 16.5894 32.0658 16.4862 31.8603C16.2284 31.3464 15.9301 30.8027 15.5821 30.409C15.3111 30.1025 14.9319 30 14.6106 30H9.5C7.567 30 6 28.433 6 26.5V8.5C6 6.567 7.567 5 9.5 5H28.5C30.433 5 32 6.567 32 8.5V26.5Z\" fill=\"%230095E0\" stroke=\"white\"/>\n          <path d=\"M18.1084 19.7684V23.5H15.5V12.501H19.8236C20.5795 12.4855 21.329 12.6441 22.0158 12.9649C22.6289 13.2488 23.1448 13.7117 23.4976 14.2947C23.8438 14.8785 24.0165 15.5515 23.9949 16.2326C24.0225 16.7278 23.9371 17.2227 23.7452 17.6787C23.5533 18.1347 23.2601 18.5394 22.8886 18.8613C21.9949 19.5461 20.8906 19.8859 19.7729 19.8199L18.1084 19.7684ZM18.1084 17.7067H19.8236C20.232 17.7336 20.635 17.6008 20.9502 17.3356C21.0801 17.199 21.182 17.0376 21.25 16.8606C21.3179 16.6836 21.3506 16.4947 21.346 16.3048C21.3703 15.8551 21.2251 15.4128 20.94 15.0678C20.7967 14.9148 20.6232 14.7943 20.4307 14.7144C20.2383 14.6344 20.0314 14.5968 19.8236 14.6039H18.1084V17.7067Z\" fill=\"white\"/>\n          </g>\n          <defs>\n          <filter id=\"filter0_d_14309_4173\" x=\"0\" y=\"0\" width=\"38\" height=\"42\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\">\n          <feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"/>\n          <feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\"/>\n          <feOffset dy=\"1\"/>\n          <feGaussianBlur stdDeviation=\"2.5\"/>\n          <feColorMatrix type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0.584314 0 0 0 0 0.878431 0 0 0 0.45 0\"/>\n          <feBlend mode=\"normal\" in2=\"BackgroundImageFix\" result=\"effect1_dropShadow_14309_4173\"/>\n          <feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"effect1_dropShadow_14309_4173\" result=\"shape\"/>\n          </filter>\n          </defs>\n          </svg>\n          "),
                };
            }
            else {
                return {
                    anchor: new maps.Point(width / 2, height - 6),
                    size: new maps.Size(width, height),
                    scaledSize: new maps.Size(width, height),
                    url: "data:image/svg+xml;utf-8,\n          <svg width=\"".concat(width, "\" height=\"").concat(height, "\" viewBox=\"0 0 39 43\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n          <g filter=\"url(%23filter0_d_11713_3971)\">\n          <path d=\"M32 27.5C32 29.433 30.433 31 28.5 31H23.3983C23.0741 31 22.6913 31.1046 22.4204 31.4163C22.0812 31.8065 21.7882 32.3438 21.5336 32.8517C21.4361 33.0464 21.3447 33.2355 21.2569 33.4172C21.1031 33.7353 20.9602 34.0309 20.8142 34.2945C20.4564 34.9407 20.1364 35.5153 19.8038 35.9329C19.4617 36.3624 19.2039 36.5 19 36.5C18.7977 36.5 18.544 36.3654 18.2077 35.9422C17.8801 35.53 17.5655 34.9619 17.212 34.32C17.0682 34.0588 16.9281 33.7682 16.7771 33.4551C16.6852 33.2646 16.5894 33.0658 16.4862 32.8603C16.2284 32.3464 15.9301 31.8027 15.5821 31.409C15.3111 31.1025 14.9319 31 14.6106 31H9.5C7.567 31 6 29.433 6 27.5V9.5C6 7.567 7.567 6 9.5 6H28.5C30.433 6 32 7.567 32 9.5V27.5Z\" fill=\"%230095E0\" stroke=\"white\"/>\n          <path d=\"M18.1084 20.7684V24.5H15.5V13.501H19.8236C20.5795 13.4855 21.329 13.6441 22.0158 13.9649C22.6289 14.2488 23.1448 14.7117 23.4976 15.2947C23.8438 15.8785 24.0165 16.5515 23.9949 17.2326C24.0225 17.7278 23.9371 18.2227 23.7452 18.6787C23.5533 19.1347 23.2601 19.5394 22.8886 19.8613C21.9949 20.5461 20.8906 20.8859 19.7729 20.8199L18.1084 20.7684ZM18.1084 18.7067H19.8236C20.232 18.7336 20.635 18.6008 20.9502 18.3356C21.0801 18.199 21.182 18.0376 21.25 17.8606C21.3179 17.6836 21.3506 17.4947 21.346 17.3048C21.3703 16.8551 21.2251 16.4128 20.94 16.0678C20.7967 15.9148 20.6232 15.7943 20.4307 15.7144C20.2383 15.6344 20.0314 15.5968 19.8236 15.6039H18.1084V18.7067Z\" fill=\"white\"/>\n          <circle cx=\"30\" cy=\"8\" r=\"3.5\" fill=\"%23D81A26\" stroke=\"white\"/>\n          </g>\n          <defs>\n          <filter id=\"filter0_d_11713_3971\" x=\"0\" y=\"0\" width=\"39\" height=\"43\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\">\n          <feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"/>\n          <feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\"/>\n          <feOffset dy=\"1\"/>\n          <feGaussianBlur stdDeviation=\"2.5\"/>\n          <feColorMatrix type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0.584314 0 0 0 0 0.878431 0 0 0 0.45 0\"/>\n          <feBlend mode=\"normal\" in2=\"BackgroundImageFix\" result=\"effect1_dropShadow_11713_3971\"/>\n          <feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"effect1_dropShadow_11713_3971\" result=\"shape\"/>\n          </filter>\n          </defs>\n          </svg>\n          "),
                };
            }
        }
    }
};
var getZIndexOfMarker = function (d, type) {
    if (type === "first") {
        return 2;
    }
    else if (type === "last") {
        return 2;
    }
    else if (type === "arrow") {
        return 1;
    }
    else if (type === "event") {
        if (d.mode === "E" || d.mode === "S") {
            return 5;
        }
        else if (d.mode === "M") {
            return 6;
        }
        else if (d.mode === "P") {
            if (!d.pevents || d.pevents.length === 0) {
                return 3;
            }
            else {
                return 4;
            }
        }
    }
    return 1;
};
var getMarker = function (d, map, maps, type, tindx // tindx or heading
) {
    if (type === "first") {
        return new maps.Marker({
            position: { lat: d.loc[1], lng: d.loc[0] },
            map: map,
            zIndex: 2,
            clickable: true,
            icon: getIcon(d, type, maps, tindx),
        });
    }
    else if (type === "last") {
        return new maps.Marker({
            position: { lat: d.loc[1], lng: d.loc[0] },
            zIndex: 2,
            map: map,
            icon: getIcon(d, type, maps, tindx),
        });
    }
    else if (type === "arrow") {
        return new maps.Marker({
            position: { lat: d.loc[1], lng: d.loc[0] },
            map: map,
            zIndex: 1,
            icon: getIcon(d, type, maps, tindx),
        });
    }
    else if (type === "event") {
        if (d.mode === "E" || d.mode === "S") {
            return new maps.Marker({
                position: { lat: d.loc[1], lng: d.loc[0] },
                zIndex: 5,
                map: map,
                icon: getIcon(d, type, maps, tindx),
            });
        }
        else if (d.mode === "M") {
            return new maps.Marker({
                position: { lat: d.loc[1], lng: d.loc[0] },
                zIndex: 6,
                map: map,
                icon: getIcon(d, type, maps, tindx),
            });
        }
        else if (d.mode === "P") {
            if (!d.pevents || d.pevents.length === 0) {
                return new maps.Marker({
                    position: { lat: d.loc[1], lng: d.loc[0] },
                    zIndex: 3,
                    map: map,
                    icon: getIcon(d, type, maps, tindx),
                });
            }
            else {
                return new maps.Marker({
                    position: { lat: d.loc[1], lng: d.loc[0] },
                    zIndex: 4,
                    map: map,
                    icon: getIcon(d, type, maps, tindx),
                });
            }
        }
    }
};

// It should to be noted that this function isn't equivalent to `text-transform: capitalize`.
//
// A strict capitalization should uppercase the first letter of each word a the sentence.
// We only handle the first word.
function capitalize$1(string) {
  if (typeof string !== 'string') {
    throw new Error(process.env.NODE_ENV !== "production" ? "Material-UI: capitalize(string) expects a string argument." : formatMuiErrorMessage(7));
  }

  return string.charAt(0).toUpperCase() + string.slice(1);
}

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      margin: 0
    },

    /* Styles applied to the root element if `variant="body2"`. */
    body2: theme.typography.body2,

    /* Styles applied to the root element if `variant="body1"`. */
    body1: theme.typography.body1,

    /* Styles applied to the root element if `variant="caption"`. */
    caption: theme.typography.caption,

    /* Styles applied to the root element if `variant="button"`. */
    button: theme.typography.button,

    /* Styles applied to the root element if `variant="h1"`. */
    h1: theme.typography.h1,

    /* Styles applied to the root element if `variant="h2"`. */
    h2: theme.typography.h2,

    /* Styles applied to the root element if `variant="h3"`. */
    h3: theme.typography.h3,

    /* Styles applied to the root element if `variant="h4"`. */
    h4: theme.typography.h4,

    /* Styles applied to the root element if `variant="h5"`. */
    h5: theme.typography.h5,

    /* Styles applied to the root element if `variant="h6"`. */
    h6: theme.typography.h6,

    /* Styles applied to the root element if `variant="subtitle1"`. */
    subtitle1: theme.typography.subtitle1,

    /* Styles applied to the root element if `variant="subtitle2"`. */
    subtitle2: theme.typography.subtitle2,

    /* Styles applied to the root element if `variant="overline"`. */
    overline: theme.typography.overline,

    /* Styles applied to the root element if `variant="srOnly"`. Only accessible to screen readers. */
    srOnly: {
      position: 'absolute',
      height: 1,
      width: 1,
      overflow: 'hidden'
    },

    /* Styles applied to the root element if `align="left"`. */
    alignLeft: {
      textAlign: 'left'
    },

    /* Styles applied to the root element if `align="center"`. */
    alignCenter: {
      textAlign: 'center'
    },

    /* Styles applied to the root element if `align="right"`. */
    alignRight: {
      textAlign: 'right'
    },

    /* Styles applied to the root element if `align="justify"`. */
    alignJustify: {
      textAlign: 'justify'
    },

    /* Styles applied to the root element if `nowrap={true}`. */
    noWrap: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    },

    /* Styles applied to the root element if `gutterBottom={true}`. */
    gutterBottom: {
      marginBottom: '0.35em'
    },

    /* Styles applied to the root element if `paragraph={true}`. */
    paragraph: {
      marginBottom: 16
    },

    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: 'inherit'
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main
    },

    /* Styles applied to the root element if `color="textPrimary"`. */
    colorTextPrimary: {
      color: theme.palette.text.primary
    },

    /* Styles applied to the root element if `color="textSecondary"`. */
    colorTextSecondary: {
      color: theme.palette.text.secondary
    },

    /* Styles applied to the root element if `color="error"`. */
    colorError: {
      color: theme.palette.error.main
    },

    /* Styles applied to the root element if `display="inline"`. */
    displayInline: {
      display: 'inline'
    },

    /* Styles applied to the root element if `display="block"`. */
    displayBlock: {
      display: 'block'
    }
  };
};
var defaultVariantMapping = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6',
  subtitle1: 'h6',
  subtitle2: 'h6',
  body1: 'p',
  body2: 'p'
};
var Typography = /*#__PURE__*/React.forwardRef(function Typography(props, ref) {
  var _props$align = props.align,
      align = _props$align === void 0 ? 'inherit' : _props$align,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'initial' : _props$color,
      component = props.component,
      _props$display = props.display,
      display = _props$display === void 0 ? 'initial' : _props$display,
      _props$gutterBottom = props.gutterBottom,
      gutterBottom = _props$gutterBottom === void 0 ? false : _props$gutterBottom,
      _props$noWrap = props.noWrap,
      noWrap = _props$noWrap === void 0 ? false : _props$noWrap,
      _props$paragraph = props.paragraph,
      paragraph = _props$paragraph === void 0 ? false : _props$paragraph,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'body1' : _props$variant,
      _props$variantMapping = props.variantMapping,
      variantMapping = _props$variantMapping === void 0 ? defaultVariantMapping : _props$variantMapping,
      other = _objectWithoutProperties(props, ["align", "classes", "className", "color", "component", "display", "gutterBottom", "noWrap", "paragraph", "variant", "variantMapping"]);

  var Component = component || (paragraph ? 'p' : variantMapping[variant] || defaultVariantMapping[variant]) || 'span';
  return /*#__PURE__*/React.createElement(Component, _extends({
    className: clsx(classes.root, className, variant !== 'inherit' && classes[variant], color !== 'initial' && classes["color".concat(capitalize$1(color))], noWrap && classes.noWrap, gutterBottom && classes.gutterBottom, paragraph && classes.paragraph, align !== 'inherit' && classes["align".concat(capitalize$1(align))], display !== 'initial' && classes["display".concat(capitalize$1(display))]),
    ref: ref
  }, other));
});
process.env.NODE_ENV !== "production" ? Typography.propTypes = {
  /**
   * Set the text-align on the component.
   */
  align: PropTypes.oneOf(['inherit', 'left', 'center', 'right', 'justify']),

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['initial', 'inherit', 'primary', 'secondary', 'textPrimary', 'textSecondary', 'error']),

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   * Overrides the behavior of the `variantMapping` prop.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * Controls the display type
   */
  display: PropTypes.oneOf(['initial', 'block', 'inline']),

  /**
   * If `true`, the text will have a bottom margin.
   */
  gutterBottom: PropTypes.bool,

  /**
   * If `true`, the text will not wrap, but instead will truncate with a text overflow ellipsis.
   *
   * Note that text overflow can only happen with block or inline-block level elements
   * (the element needs to have a width in order to overflow).
   */
  noWrap: PropTypes.bool,

  /**
   * If `true`, the text will have a bottom margin.
   */
  paragraph: PropTypes.bool,

  /**
   * Applies the theme typography styles.
   */
  variant: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'subtitle1', 'subtitle2', 'body1', 'body2', 'caption', 'button', 'overline', 'srOnly', 'inherit']),

  /**
   * The component maps the variant prop to a range of different HTML element types.
   * For instance, subtitle1 to `<h6>`.
   * If you wish to change that mapping, you can provide your own.
   * Alternatively, you can use the `component` prop.
   */
  variantMapping: PropTypes.object
} : void 0;
var Typography$1 = withStyles(styles, {
  name: 'MuiTypography'
})(Typography);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof$1(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

var mapboxGl = {exports: {}};

/* Mapbox GL JS is Copyright © 2020 Mapbox and subject to the Mapbox Terms of Service ((https://www.mapbox.com/legal/tos/). */

(function (module, exports) {
	(function (global, factory) {
	module.exports = factory() ;
	})(commonjsGlobal, (function () {
	/* eslint-disable */

	var shared, worker, mapboxgl;
	// define gets called three times: one for each chunk. we rely on the order
	// they're imported to know which is which
	function define(_, chunk) {
	if (!shared) {
	    shared = chunk;
	} else if (!worker) {
	    worker = chunk;
	} else {
	    var workerBundleString = "self.onerror = function() { console.error('An error occurred while parsing the WebWorker bundle. This is most likely due to improper transpilation by Babel; please see https://docs.mapbox.com/mapbox-gl-js/guides/install/#transpiling'); }; var sharedChunk = {}; (" + shared + ")(sharedChunk); (" + worker + ")(sharedChunk); self.onerror = null;";

	    var sharedChunk = {};
	    shared(sharedChunk);
	    mapboxgl = chunk(sharedChunk);
	    if (typeof window !== 'undefined' && window && window.URL && window.URL.createObjectURL) {
	        mapboxgl.workerUrl = window.URL.createObjectURL(new Blob([workerBundleString], { type: 'text/javascript' }));
	    }
	}
	}


	define(["exports"],(function(t){var e="undefined"!=typeof self?self:{},r=n;function n(t,e,r,n){this.cx=3*t,this.bx=3*(r-t)-this.cx,this.ax=1-this.cx-this.bx,this.cy=3*e,this.by=3*(n-e)-this.cy,this.ay=1-this.cy-this.by,this.p1x=t,this.p1y=n,this.p2x=r,this.p2y=n;}n.prototype.sampleCurveX=function(t){return ((this.ax*t+this.bx)*t+this.cx)*t},n.prototype.sampleCurveY=function(t){return ((this.ay*t+this.by)*t+this.cy)*t},n.prototype.sampleCurveDerivativeX=function(t){return (3*this.ax*t+2*this.bx)*t+this.cx},n.prototype.solveCurveX=function(t,e){var r,n,i,s,a;for(void 0===e&&(e=1e-6),i=t,a=0;a<8;a++){if(s=this.sampleCurveX(i)-t,Math.abs(s)<e)return i;var o=this.sampleCurveDerivativeX(i);if(Math.abs(o)<1e-6)break;i-=s/o;}if((i=t)<(r=0))return r;if(i>(n=1))return n;for(;r<n;){if(s=this.sampleCurveX(i),Math.abs(s-t)<e)return i;t>s?r=i:n=i,i=.5*(n-r)+r;}return i},n.prototype.solve=function(t,e){return this.sampleCurveY(this.solveCurveX(t,e))};var i=s;function s(t,e){this.x=t,this.y=e;}s.prototype={clone:function(){return new s(this.x,this.y)},add:function(t){return this.clone()._add(t)},sub:function(t){return this.clone()._sub(t)},multByPoint:function(t){return this.clone()._multByPoint(t)},divByPoint:function(t){return this.clone()._divByPoint(t)},mult:function(t){return this.clone()._mult(t)},div:function(t){return this.clone()._div(t)},rotate:function(t){return this.clone()._rotate(t)},rotateAround:function(t,e){return this.clone()._rotateAround(t,e)},matMult:function(t){return this.clone()._matMult(t)},unit:function(){return this.clone()._unit()},perp:function(){return this.clone()._perp()},round:function(){return this.clone()._round()},mag:function(){return Math.sqrt(this.x*this.x+this.y*this.y)},equals:function(t){return this.x===t.x&&this.y===t.y},dist:function(t){return Math.sqrt(this.distSqr(t))},distSqr:function(t){var e=t.x-this.x,r=t.y-this.y;return e*e+r*r},angle:function(){return Math.atan2(this.y,this.x)},angleTo:function(t){return Math.atan2(this.y-t.y,this.x-t.x)},angleWith:function(t){return this.angleWithSep(t.x,t.y)},angleWithSep:function(t,e){return Math.atan2(this.x*e-this.y*t,this.x*t+this.y*e)},_matMult:function(t){var e=t[2]*this.x+t[3]*this.y;return this.x=t[0]*this.x+t[1]*this.y,this.y=e,this},_add:function(t){return this.x+=t.x,this.y+=t.y,this},_sub:function(t){return this.x-=t.x,this.y-=t.y,this},_mult:function(t){return this.x*=t,this.y*=t,this},_div:function(t){return this.x/=t,this.y/=t,this},_multByPoint:function(t){return this.x*=t.x,this.y*=t.y,this},_divByPoint:function(t){return this.x/=t.x,this.y/=t.y,this},_unit:function(){return this._div(this.mag()),this},_perp:function(){var t=this.y;return this.y=this.x,this.x=-t,this},_rotate:function(t){var e=Math.cos(t),r=Math.sin(t),n=r*this.x+e*this.y;return this.x=e*this.x-r*this.y,this.y=n,this},_rotateAround:function(t,e){var r=Math.cos(t),n=Math.sin(t),i=e.y+n*(this.x-e.x)+r*(this.y-e.y);return this.x=e.x+r*(this.x-e.x)-n*(this.y-e.y),this.y=i,this},_round:function(){return this.x=Math.round(this.x),this.y=Math.round(this.y),this}},s.convert=function(t){return t instanceof s?t:Array.isArray(t)?new s(t[0],t[1]):t};const a=Math.PI/180,o=180/Math.PI;function l(t){return t*a}function u(t){return t*o}const c=[[0,0],[1,0],[1,1],[0,1]];function h(t){if(t<=0)return 0;if(t>=1)return 1;const e=t*t,r=e*t;return 4*(t<.5?r:3*(t-e)+r-.75)}function p(t,e,n,i){const s=new r(t,e,n,i);return function(t){return s.solve(t)}}const f=p(.25,.1,.25,1);function d(t,e,r){return Math.min(r,Math.max(e,t))}function y(t,e,r){return (r=d((r-t)/(e-t),0,1))*r*(3-2*r)}function m(t,e,r){const n=r-e,i=((t-e)%n+n)%n+e;return i===e?r:i}function g(t,e,r){if(!t.length)return r(null,[]);let n=t.length;const i=new Array(t.length);let s=null;t.forEach(((t,a)=>{e(t,((t,e)=>{t&&(s=t),i[a]=e,0==--n&&r(s,i);}));}));}function x(t){const e=[];for(const r in t)e.push(t[r]);return e}function v(t,...e){for(const r of e)for(const e in r)t[e]=r[e];return t}let b=1;function _(){return b++}function w(){return function t(e){return e?(e^Math.random()*(16>>e/4)).toString(16):([1e7]+-[1e3]+-4e3+-8e3+-1e11).replace(/[018]/g,t)}()}function A(t){return t<=1?1:Math.pow(2,Math.ceil(Math.log(t)/Math.LN2))}function S(t){return !!t&&/^[0-9a-f]{8}-[0-9a-f]{4}-[4][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(t)}function k(t,e){t.forEach((t=>{e[t]&&(e[t]=e[t].bind(e));}));}function I(t,e){return -1!==t.indexOf(e,t.length-e.length)}function M(t,e,r){const n={};for(const i in t)n[i]=e.call(r||this,t[i],i,t);return n}function z(t,e,r){const n={};for(const i in t)e.call(r||this,t[i],i,t)&&(n[i]=t[i]);return n}function T(t){return Array.isArray(t)?t.map(T):"object"==typeof t&&t?M(t,T):t}const B={};function E(t){B[t]||("undefined"!=typeof console&&console.warn(t),B[t]=!0);}function C(t,e,r){return (r.y-t.y)*(e.x-t.x)>(e.y-t.y)*(r.x-t.x)}function P(t){let e=0;for(let r,n,i=0,s=t.length,a=s-1;i<s;a=i++)r=t[i],n=t[a],e+=(n.x-r.x)*(r.y+n.y);return e}function D(){return "undefined"!=typeof WorkerGlobalScope&&"undefined"!=typeof self&&self instanceof WorkerGlobalScope}function V(t){const e={};if(t.replace(/(?:^|(?:\s*\,\s*))([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)(?:\=(?:([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)|(?:\"((?:[^"\\]|\\.)*)\")))?/g,((t,r,n,i)=>{const s=n||i;return e[r]=!s||s.toLowerCase(),""})),e["max-age"]){const t=parseInt(e["max-age"],10);isNaN(t)?delete e["max-age"]:e["max-age"]=t;}return e}let F=null;function L(t){if(null==F){const e=t.navigator?t.navigator.userAgent:null;F=!!t.safari||!(!e||!(/\b(iPad|iPhone|iPod)\b/.test(e)||e.match("Safari")&&!e.match("Chrome")));}return F}function R(t){try{const r=e[t];return r.setItem("_mapbox_test_",1),r.removeItem("_mapbox_test_"),!0}catch(t){return !1}}function U(t,e){return [t[4*e],t[4*e+1],t[4*e+2],t[4*e+3]]}const j=e.performance;function $(t){const e=t?t.url.toString():void 0;return j.getEntriesByName(e)}var O="2.10.0";let q,N,G,Z;const X={now:()=>void 0!==G?G:e.performance.now(),setNow(t){G=t;},restoreNow(){G=void 0;},frame(t){const r=e.requestAnimationFrame(t);return {cancel:()=>e.cancelAnimationFrame(r)}},getImageData(t,r=0){const{width:n,height:i}=t;Z||(Z=e.document.createElement("canvas"));const s=Z.getContext("2d");if(!s)throw new Error("failed to create canvas 2d context");return (n>Z.width||i>Z.height)&&(Z.width=n,Z.height=i),s.clearRect(-r,-r,n+2*r,i+2*r),s.drawImage(t,0,0,n,i),s.getImageData(-r,-r,n+2*r,i+2*r)},resolveURL:t=>(q||(q=e.document.createElement("a")),q.href=t,q.href),get devicePixelRatio(){return e.devicePixelRatio},get prefersReducedMotion(){return !!e.matchMedia&&(null==N&&(N=e.matchMedia("(prefers-reduced-motion: reduce)")),N.matches)}};let K;const H={API_URL:"https://api.mapbox.com",get API_URL_REGEX(){if(null==K){const t=/^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/|\?|$)/i;try{K=null!=process.env.API_URL_REGEX?new RegExp(process.env.API_URL_REGEX):t;}catch(e){K=t;}}return K},get EVENTS_URL(){return this.API_URL?0===this.API_URL.indexOf("https://api.mapbox.cn")?"https://events.mapbox.cn/events/v2":0===this.API_URL.indexOf("https://api.mapbox.com")?"https://events.mapbox.com/events/v2":null:null},SESSION_PATH:"/map-sessions/v1",FEEDBACK_URL:"https://apps.mapbox.com/feedback",TILE_URL_VERSION:"v4",RASTER_URL_PREFIX:"raster/v1",REQUIRE_ACCESS_TOKEN:!0,ACCESS_TOKEN:null,MAX_PARALLEL_IMAGE_REQUESTS:16},Y={supported:!1,testSupport:function(t){!Q&&J&&(tt?et(t):W=t);}};let W,J,Q=!1,tt=!1;function et(t){const e=t.createTexture();t.bindTexture(t.TEXTURE_2D,e);try{if(t.texImage2D(t.TEXTURE_2D,0,t.RGBA,t.RGBA,t.UNSIGNED_BYTE,J),t.isContextLost())return;Y.supported=!0;}catch(t){}t.deleteTexture(e),Q=!0;}e.document&&(J=e.document.createElement("img"),J.onload=function(){W&&et(W),W=null,tt=!0;},J.onerror=function(){Q=!0,W=null;},J.src="data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAQAAAAfQ//73v/+BiOh/AAA=");const rt="01",nt="NO_ACCESS_TOKEN";function it(t){return 0===t.indexOf("mapbox:")}function st(t){return H.API_URL_REGEX.test(t)}const at=/^(\w+):\/\/([^/?]*)(\/[^?]+)?\??(.+)?/;function ot(t){const e=t.match(at);if(!e)throw new Error("Unable to parse URL object");return {protocol:e[1],authority:e[2],path:e[3]||"/",params:e[4]?e[4].split("&"):[]}}function lt(t){const e=t.params.length?`?${t.params.join("&")}`:"";return `${t.protocol}://${t.authority}${t.path}${e}`}function ut(t){if(!t)return null;const r=t.split(".");if(!r||3!==r.length)return null;try{return JSON.parse(decodeURIComponent(e.atob(r[1]).split("").map((t=>"%"+("00"+t.charCodeAt(0).toString(16)).slice(-2))).join("")))}catch(t){return null}}class ct{constructor(t){this.type=t,this.anonId=null,this.eventData={},this.queue=[],this.pendingRequest=null;}getStorageKey(t){const r=ut(H.ACCESS_TOKEN);let n="";return n=r&&r.u?e.btoa(encodeURIComponent(r.u).replace(/%([0-9A-F]{2})/g,((t,e)=>String.fromCharCode(Number("0x"+e))))):H.ACCESS_TOKEN||"",t?`mapbox.eventData.${t}:${n}`:`mapbox.eventData:${n}`}fetchEventData(){const t=R("localStorage"),r=this.getStorageKey(),n=this.getStorageKey("uuid");if(t)try{const t=e.localStorage.getItem(r);t&&(this.eventData=JSON.parse(t));const i=e.localStorage.getItem(n);i&&(this.anonId=i);}catch(t){E("Unable to read from LocalStorage");}}saveEventData(){const t=R("localStorage"),r=this.getStorageKey(),n=this.getStorageKey("uuid");if(t)try{e.localStorage.setItem(n,this.anonId),Object.keys(this.eventData).length>=1&&e.localStorage.setItem(r,JSON.stringify(this.eventData));}catch(t){E("Unable to write to LocalStorage");}}processRequests(t){}postEvent(t,e,r,n){if(!H.EVENTS_URL)return;const i=ot(H.EVENTS_URL);i.params.push(`access_token=${n||H.ACCESS_TOKEN||""}`);const s={event:this.type,created:new Date(t).toISOString(),sdkIdentifier:"mapbox-gl-js",sdkVersion:O,skuId:rt,userId:this.anonId},a=e?v(s,e):s,o={url:lt(i),headers:{"Content-Type":"text/plain"},body:JSON.stringify([a])};this.pendingRequest=Pt(o,(t=>{this.pendingRequest=null,r(t),this.saveEventData(),this.processRequests(n);}));}queueRequest(t,e){this.queue.push(t),this.processRequests(e);}}const ht=new class extends ct{constructor(t){super("appUserTurnstile"),this._customAccessToken=t;}postTurnstileEvent(t,e){H.EVENTS_URL&&H.ACCESS_TOKEN&&Array.isArray(t)&&t.some((t=>it(t)||st(t)))&&this.queueRequest(Date.now(),e);}processRequests(t){if(this.pendingRequest||0===this.queue.length)return;this.anonId&&this.eventData.lastSuccess&&this.eventData.tokenU||this.fetchEventData();const e=ut(H.ACCESS_TOKEN),r=e?e.u:H.ACCESS_TOKEN;let n=r!==this.eventData.tokenU;S(this.anonId)||(this.anonId=w(),n=!0);const i=this.queue.shift();if(this.eventData.lastSuccess){const t=new Date(this.eventData.lastSuccess),e=new Date(i),r=(i-this.eventData.lastSuccess)/864e5;n=n||r>=1||r<-1||t.getDate()!==e.getDate();}else n=!0;n?this.postEvent(i,{"enabled.telemetry":!1},(t=>{t||(this.eventData.lastSuccess=i,this.eventData.tokenU=r);}),t):this.processRequests();}},pt=ht.postTurnstileEvent.bind(ht),ft=new class extends ct{constructor(){super("map.load"),this.success={},this.skuToken="";}postMapLoadEvent(t,e,r,n){this.skuToken=e,this.errorCb=n,H.EVENTS_URL&&(r||H.ACCESS_TOKEN?this.queueRequest({id:t,timestamp:Date.now()},r):this.errorCb(new Error(nt)));}processRequests(t){if(this.pendingRequest||0===this.queue.length)return;const{id:e,timestamp:r}=this.queue.shift();e&&this.success[e]||(this.anonId||this.fetchEventData(),S(this.anonId)||(this.anonId=w()),this.postEvent(r,{skuToken:this.skuToken},(t=>{t?this.errorCb(t):e&&(this.success[e]=!0);}),t));}},dt=ft.postMapLoadEvent.bind(ft),yt=new class extends ct{constructor(){super("map.auth"),this.success={},this.skuToken="";}getSession(t,e,r,n){if(!H.API_URL||!H.SESSION_PATH)return;const i=ot(H.API_URL+H.SESSION_PATH);i.params.push(`sku=${e||""}`),i.params.push(`access_token=${n||H.ACCESS_TOKEN||""}`);const s={url:lt(i),headers:{"Content-Type":"text/plain"}};this.pendingRequest=Dt(s,(t=>{this.pendingRequest=null,r(t),this.saveEventData(),this.processRequests(n);}));}getSessionAPI(t,e,r,n){this.skuToken=e,this.errorCb=n,H.SESSION_PATH&&H.API_URL&&(r||H.ACCESS_TOKEN?this.queueRequest({id:t,timestamp:Date.now()},r):this.errorCb(new Error(nt)));}processRequests(t){if(this.pendingRequest||0===this.queue.length)return;const{id:e,timestamp:r}=this.queue.shift();e&&this.success[e]||this.getSession(r,this.skuToken,(t=>{t?this.errorCb(t):e&&(this.success[e]=!0);}),t);}},mt=yt.getSessionAPI.bind(yt),gt=new Set;let xt,vt=500,bt=50,_t={};function wt(t){const e=kt(t);let r,n;e&&e.forEach((t=>{const e=t.split("=");"language"===e[0]?r=e[1]:"worldview"===e[0]&&(n=e[1]);}));let i="mapbox-tiles";return r&&(i+=`-${r}`),n&&(i+=`-${n}`),i}function At(){try{return e.caches}catch(t){}}function St(t){const e=At();e&&!_t[t]&&(_t[t]=e.open(t));}function kt(t){const e=t.indexOf("?");return e>0?t.slice(e+1).split("&"):[]}function It(t){const e=t.indexOf("?");if(e<0)return t;const r=kt(t).filter((t=>{const e=t.split("=");return "language"===e[0]||"worldview"===e[0]}));return r.length?`${t.slice(0,e)}?${r.join("&")}`:t.slice(0,e)}let Mt=1/0;const zt={Unknown:"Unknown",Style:"Style",Source:"Source",Tile:"Tile",Glyphs:"Glyphs",SpriteImage:"SpriteImage",SpriteJSON:"SpriteJSON",Image:"Image"};"function"==typeof Object.freeze&&Object.freeze(zt);class Tt extends Error{constructor(t,e,r){401===e&&st(r)&&(t+=": you may have provided an invalid Mapbox access token. See https://www.mapbox.com/api-documentation/#access-tokens-and-token-scopes"),super(t),this.status=e,this.url=r;}toString(){return `${this.name}: ${this.message} (${this.status}): ${this.url}`}}const Bt=D()?()=>self.worker&&self.worker.referrer:()=>("blob:"===e.location.protocol?e.parent:e).location.href;const Et=function(t,r){if(!(/^file:/.test(n=t.url)||/^file:/.test(Bt())&&!/^\w+:/.test(n))){if(e.fetch&&e.Request&&e.AbortController&&e.Request.prototype.hasOwnProperty("signal"))return function(t,r){const n=new e.AbortController,i=new e.Request(t.url,{method:t.method||"GET",body:t.body,credentials:t.credentials,headers:t.headers,referrer:Bt(),signal:n.signal});let s=!1,a=!1;const o=(l=i.url).indexOf("sku=")>0&&st(l);var l;"json"===t.type&&i.headers.set("Accept","application/json");const u=(n,s,l)=>{if(a)return;if(n&&"SecurityError"!==n.message&&E(n),s&&l)return c(s);const u=Date.now();e.fetch(i).then((e=>{if(e.ok){const t=o?e.clone():null;return c(e,t,u)}return r(new Tt(e.statusText,e.status,t.url))})).catch((t=>{20!==t.code&&r(new Error(t.message));}));},c=(n,o,l)=>{("arrayBuffer"===t.type?n.arrayBuffer():"json"===t.type?n.json():n.text()).then((t=>{a||(o&&l&&function(t,r,n){const i=wt(t.url);if(St(i),!_t[i])return;const s={status:r.status,statusText:r.statusText,headers:new e.Headers};r.headers.forEach(((t,e)=>s.headers.set(e,t)));const a=V(r.headers.get("Cache-Control")||"");if(a["no-store"])return;a["max-age"]&&s.headers.set("Expires",new Date(n+1e3*a["max-age"]).toUTCString());const o=s.headers.get("Expires");o&&(new Date(o).getTime()-n<42e4||function(t,e){if(void 0===xt)try{new Response(new ReadableStream),xt=!0;}catch(t){xt=!1;}xt?e(t.body):t.blob().then(e);}(r,(r=>{const n=new e.Response(r,s);St(i),_t[i]&&_t[i].then((e=>e.put(It(t.url),n))).catch((t=>E(t.message)));})));}(i,o,l),s=!0,r(null,t,n.headers.get("Cache-Control"),n.headers.get("Expires")));})).catch((t=>{a||r(new Error(t.message));}));};return o?function(t,e){const r=wt(t.url);if(St(r),!_t[r])return e(null);const n=It(t.url);_t[r].then((t=>{t.match(n).then((r=>{const i=function(t){if(!t)return !1;const e=new Date(t.headers.get("Expires")||0),r=V(t.headers.get("Cache-Control")||"");return e>Date.now()&&!r["no-cache"]}(r);t.delete(n),i&&t.put(n,r.clone()),e(null,r,i);})).catch(e);})).catch(e);}(i,u):u(null,null),{cancel:()=>{a=!0,s||n.abort();}}}(t,r);if(D()&&self.worker&&self.worker.actor)return self.worker.actor.send("getResource",t,r,void 0,!0)}var n;return function(t,r){const n=new e.XMLHttpRequest;n.open(t.method||"GET",t.url,!0),"arrayBuffer"===t.type&&(n.responseType="arraybuffer");for(const e in t.headers)n.setRequestHeader(e,t.headers[e]);return "json"===t.type&&(n.responseType="text",n.setRequestHeader("Accept","application/json")),n.withCredentials="include"===t.credentials,n.onerror=()=>{r(new Error(n.statusText));},n.onload=()=>{if((n.status>=200&&n.status<300||0===n.status)&&null!==n.response){let e=n.response;if("json"===t.type)try{e=JSON.parse(n.response);}catch(t){return r(t)}r(null,e,n.getResponseHeader("Cache-Control"),n.getResponseHeader("Expires"));}else r(new Tt(n.statusText,n.status,t.url));},n.send(t.body),{cancel:()=>n.abort()}}(t,r)},Ct=function(t,e){return Et(v(t,{type:"arrayBuffer"}),e)},Pt=function(t,e){return Et(v(t,{method:"POST"}),e)},Dt=function(t,e){return Et(v(t,{method:"GET"}),e)};function Vt(t){const r=e.document.createElement("a");return r.href=t,r.protocol===e.document.location.protocol&&r.host===e.document.location.host}const Ft="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAC0lEQVQYV2NgAAIAAAUAAarVyFEAAAAASUVORK5CYII=";let Lt,Rt;Lt=[],Rt=0;const Ut=function(t,r){if(Y.supported&&(t.headers||(t.headers={}),t.headers.accept="image/webp,*/*"),Rt>=H.MAX_PARALLEL_IMAGE_REQUESTS){const e={requestParameters:t,callback:r,cancelled:!1,cancel(){this.cancelled=!0;}};return Lt.push(e),e}Rt++;let n=!1;const i=()=>{if(!n)for(n=!0,Rt--;Lt.length&&Rt<H.MAX_PARALLEL_IMAGE_REQUESTS;){const t=Lt.shift(),{requestParameters:e,callback:r,cancelled:n}=t;n||(t.cancel=Ut(e,r).cancel);}},s=Ct(t,((t,n,s,a)=>{i(),t?r(t):n&&(e.createImageBitmap?function(t,r){const n=new e.Blob([new Uint8Array(t)],{type:"image/png"});e.createImageBitmap(n).then((t=>{r(null,t);})).catch((t=>{r(new Error(`Could not load image because of ${t.message}. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported.`));}));}(n,((t,e)=>r(t,e,s,a))):function(t,r){const n=new e.Image,i=e.URL;n.onload=()=>{r(null,n),i.revokeObjectURL(n.src),n.onload=null,e.requestAnimationFrame((()=>{n.src=Ft;}));},n.onerror=()=>r(new Error("Could not load image. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported."));const s=new e.Blob([new Uint8Array(t)],{type:"image/png"});n.src=t.byteLength?i.createObjectURL(s):Ft;}(n,((t,e)=>r(t,e,s,a))));}));return {cancel:()=>{s.cancel(),i();}}};function jt(t,e,r){r[t]&&-1!==r[t].indexOf(e)||(r[t]=r[t]||[],r[t].push(e));}function $t(t,e,r){if(r&&r[t]){const n=r[t].indexOf(e);-1!==n&&r[t].splice(n,1);}}class Ot{constructor(t,e={}){v(this,e),this.type=t;}}class qt extends Ot{constructor(t,e={}){super("error",v({error:t},e));}}class Nt{on(t,e){return this._listeners=this._listeners||{},jt(t,e,this._listeners),this}off(t,e){return $t(t,e,this._listeners),$t(t,e,this._oneTimeListeners),this}once(t,e){return e?(this._oneTimeListeners=this._oneTimeListeners||{},jt(t,e,this._oneTimeListeners),this):new Promise((e=>this.once(t,e)))}fire(t,e){"string"==typeof t&&(t=new Ot(t,e||{}));const r=t.type;if(this.listens(r)){t.target=this;const e=this._listeners&&this._listeners[r]?this._listeners[r].slice():[];for(const r of e)r.call(this,t);const n=this._oneTimeListeners&&this._oneTimeListeners[r]?this._oneTimeListeners[r].slice():[];for(const e of n)$t(r,e,this._oneTimeListeners),e.call(this,t);const i=this._eventedParent;i&&(v(t,"function"==typeof this._eventedParentData?this._eventedParentData():this._eventedParentData),i.fire(t));}else t instanceof qt&&console.error(t.error);return this}listens(t){return !!(this._listeners&&this._listeners[t]&&this._listeners[t].length>0||this._oneTimeListeners&&this._oneTimeListeners[t]&&this._oneTimeListeners[t].length>0||this._eventedParent&&this._eventedParent.listens(t))}setEventedParent(t,e){return this._eventedParent=t,this._eventedParentData=e,this}}var Gt=JSON.parse('{"$version":8,"$root":{"version":{"required":true,"type":"enum","values":[8]},"name":{"type":"string"},"metadata":{"type":"*"},"center":{"type":"array","value":"number"},"zoom":{"type":"number"},"bearing":{"type":"number","default":0,"period":360,"units":"degrees"},"pitch":{"type":"number","default":0,"units":"degrees"},"light":{"type":"light"},"terrain":{"type":"terrain"},"fog":{"type":"fog"},"sources":{"required":true,"type":"sources"},"sprite":{"type":"string"},"glyphs":{"type":"string"},"transition":{"type":"transition"},"projection":{"type":"projection"},"layers":{"required":true,"type":"array","value":"layer"}},"sources":{"*":{"type":"source"}},"source":["source_vector","source_raster","source_raster_dem","source_geojson","source_video","source_image"],"source_vector":{"type":{"required":true,"type":"enum","values":{"vector":{}}},"url":{"type":"string"},"tiles":{"type":"array","value":"string"},"bounds":{"type":"array","value":"number","length":4,"default":[-180,-85.051129,180,85.051129]},"scheme":{"type":"enum","values":{"xyz":{},"tms":{}},"default":"xyz"},"minzoom":{"type":"number","default":0},"maxzoom":{"type":"number","default":22},"attribution":{"type":"string"},"promoteId":{"type":"promoteId"},"volatile":{"type":"boolean","default":false},"*":{"type":"*"}},"source_raster":{"type":{"required":true,"type":"enum","values":{"raster":{}}},"url":{"type":"string"},"tiles":{"type":"array","value":"string"},"bounds":{"type":"array","value":"number","length":4,"default":[-180,-85.051129,180,85.051129]},"minzoom":{"type":"number","default":0},"maxzoom":{"type":"number","default":22},"tileSize":{"type":"number","default":512,"units":"pixels"},"scheme":{"type":"enum","values":{"xyz":{},"tms":{}},"default":"xyz"},"attribution":{"type":"string"},"volatile":{"type":"boolean","default":false},"*":{"type":"*"}},"source_raster_dem":{"type":{"required":true,"type":"enum","values":{"raster-dem":{}}},"url":{"type":"string"},"tiles":{"type":"array","value":"string"},"bounds":{"type":"array","value":"number","length":4,"default":[-180,-85.051129,180,85.051129]},"minzoom":{"type":"number","default":0},"maxzoom":{"type":"number","default":22},"tileSize":{"type":"number","default":512,"units":"pixels"},"attribution":{"type":"string"},"encoding":{"type":"enum","values":{"terrarium":{},"mapbox":{}},"default":"mapbox"},"volatile":{"type":"boolean","default":false},"*":{"type":"*"}},"source_geojson":{"type":{"required":true,"type":"enum","values":{"geojson":{}}},"data":{"type":"*"},"maxzoom":{"type":"number","default":18},"attribution":{"type":"string"},"buffer":{"type":"number","default":128,"maximum":512,"minimum":0},"filter":{"type":"*"},"tolerance":{"type":"number","default":0.375},"cluster":{"type":"boolean","default":false},"clusterRadius":{"type":"number","default":50,"minimum":0},"clusterMaxZoom":{"type":"number"},"clusterMinPoints":{"type":"number"},"clusterProperties":{"type":"*"},"lineMetrics":{"type":"boolean","default":false},"generateId":{"type":"boolean","default":false},"promoteId":{"type":"promoteId"}},"source_video":{"type":{"required":true,"type":"enum","values":{"video":{}}},"urls":{"required":true,"type":"array","value":"string"},"coordinates":{"required":true,"type":"array","length":4,"value":{"type":"array","length":2,"value":"number"}}},"source_image":{"type":{"required":true,"type":"enum","values":{"image":{}}},"url":{"required":true,"type":"string"},"coordinates":{"required":true,"type":"array","length":4,"value":{"type":"array","length":2,"value":"number"}}},"layer":{"id":{"type":"string","required":true},"type":{"type":"enum","values":{"fill":{},"line":{},"symbol":{},"circle":{},"heatmap":{},"fill-extrusion":{},"raster":{},"hillshade":{},"background":{},"sky":{}},"required":true},"metadata":{"type":"*"},"source":{"type":"string"},"source-layer":{"type":"string"},"minzoom":{"type":"number","minimum":0,"maximum":24},"maxzoom":{"type":"number","minimum":0,"maximum":24},"filter":{"type":"filter"},"layout":{"type":"layout"},"paint":{"type":"paint"}},"layout":["layout_fill","layout_line","layout_circle","layout_heatmap","layout_fill-extrusion","layout_symbol","layout_raster","layout_hillshade","layout_background","layout_sky"],"layout_background":{"visibility":{"type":"enum","values":{"visible":{},"none":{}},"default":"visible","property-type":"constant"}},"layout_sky":{"visibility":{"type":"enum","values":{"visible":{},"none":{}},"default":"visible","property-type":"constant"}},"layout_fill":{"fill-sort-key":{"type":"number","expression":{"interpolated":false,"parameters":["zoom","feature"]},"property-type":"data-driven"},"visibility":{"type":"enum","values":{"visible":{},"none":{}},"default":"visible","property-type":"constant"}},"layout_circle":{"circle-sort-key":{"type":"number","expression":{"interpolated":false,"parameters":["zoom","feature"]},"property-type":"data-driven"},"visibility":{"type":"enum","values":{"visible":{},"none":{}},"default":"visible","property-type":"constant"}},"layout_heatmap":{"visibility":{"type":"enum","values":{"visible":{},"none":{}},"default":"visible","property-type":"constant"}},"layout_fill-extrusion":{"visibility":{"type":"enum","values":{"visible":{},"none":{}},"default":"visible","property-type":"constant"},"fill-extrusion-edge-radius":{"type":"number","private":true,"default":0,"minimum":0,"maximum":1,"property-type":"constant"}},"layout_line":{"line-cap":{"type":"enum","values":{"butt":{},"round":{},"square":{}},"default":"butt","expression":{"interpolated":false,"parameters":["zoom","feature"]},"property-type":"data-driven"},"line-join":{"type":"enum","values":{"bevel":{},"round":{},"miter":{}},"default":"miter","expression":{"interpolated":false,"parameters":["zoom","feature"]},"property-type":"data-driven"},"line-miter-limit":{"type":"number","default":2,"requires":[{"line-join":"miter"}],"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"line-round-limit":{"type":"number","default":1.05,"requires":[{"line-join":"round"}],"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"line-sort-key":{"type":"number","expression":{"interpolated":false,"parameters":["zoom","feature"]},"property-type":"data-driven"},"visibility":{"type":"enum","values":{"visible":{},"none":{}},"default":"visible","property-type":"constant"}},"layout_symbol":{"symbol-placement":{"type":"enum","values":{"point":{},"line":{},"line-center":{}},"default":"point","expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"symbol-spacing":{"type":"number","default":250,"minimum":1,"units":"pixels","requires":[{"symbol-placement":"line"}],"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"symbol-avoid-edges":{"type":"boolean","default":false,"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"symbol-sort-key":{"type":"number","expression":{"interpolated":false,"parameters":["zoom","feature"]},"property-type":"data-driven"},"symbol-z-order":{"type":"enum","values":{"auto":{},"viewport-y":{},"source":{}},"default":"auto","expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"icon-allow-overlap":{"type":"boolean","default":false,"requires":["icon-image"],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"icon-ignore-placement":{"type":"boolean","default":false,"requires":["icon-image"],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"icon-optional":{"type":"boolean","default":false,"requires":["icon-image","text-field"],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"icon-rotation-alignment":{"type":"enum","values":{"map":{},"viewport":{},"auto":{}},"default":"auto","requires":["icon-image"],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"icon-size":{"type":"number","default":1,"minimum":0,"units":"factor of the original icon size","requires":["icon-image"],"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-text-fit":{"type":"enum","values":{"none":{},"width":{},"height":{},"both":{}},"default":"none","requires":["icon-image","text-field"],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"icon-text-fit-padding":{"type":"array","value":"number","length":4,"default":[0,0,0,0],"units":"pixels","requires":["icon-image","text-field",{"icon-text-fit":["both","width","height"]}],"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"icon-image":{"type":"resolvedImage","tokens":true,"expression":{"interpolated":false,"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-rotate":{"type":"number","default":0,"period":360,"units":"degrees","requires":["icon-image"],"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-padding":{"type":"number","default":2,"minimum":0,"units":"pixels","requires":["icon-image"],"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"icon-keep-upright":{"type":"boolean","default":false,"requires":["icon-image",{"icon-rotation-alignment":"map"},{"symbol-placement":["line","line-center"]}],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"icon-offset":{"type":"array","value":"number","length":2,"default":[0,0],"requires":["icon-image"],"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-anchor":{"type":"enum","values":{"center":{},"left":{},"right":{},"top":{},"bottom":{},"top-left":{},"top-right":{},"bottom-left":{},"bottom-right":{}},"default":"center","requires":["icon-image"],"expression":{"interpolated":false,"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-pitch-alignment":{"type":"enum","values":{"map":{},"viewport":{},"auto":{}},"default":"auto","requires":["icon-image"],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"text-pitch-alignment":{"type":"enum","values":{"map":{},"viewport":{},"auto":{}},"default":"auto","requires":["text-field"],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"text-rotation-alignment":{"type":"enum","values":{"map":{},"viewport":{},"auto":{}},"default":"auto","requires":["text-field"],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"text-field":{"type":"formatted","default":"","tokens":true,"expression":{"interpolated":false,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-font":{"type":"array","value":"string","default":["Open Sans Regular","Arial Unicode MS Regular"],"requires":["text-field"],"expression":{"interpolated":false,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-size":{"type":"number","default":16,"minimum":0,"units":"pixels","requires":["text-field"],"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-max-width":{"type":"number","default":10,"minimum":0,"units":"ems","requires":["text-field",{"symbol-placement":["point"]}],"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-line-height":{"type":"number","default":1.2,"units":"ems","requires":["text-field"],"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-letter-spacing":{"type":"number","default":0,"units":"ems","requires":["text-field"],"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-justify":{"type":"enum","values":{"auto":{},"left":{},"center":{},"right":{}},"default":"center","requires":["text-field"],"expression":{"interpolated":false,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-radial-offset":{"type":"number","units":"ems","default":0,"requires":["text-field"],"property-type":"data-driven","expression":{"interpolated":true,"parameters":["zoom","feature"]}},"text-variable-anchor":{"type":"array","value":"enum","values":{"center":{},"left":{},"right":{},"top":{},"bottom":{},"top-left":{},"top-right":{},"bottom-left":{},"bottom-right":{}},"requires":["text-field",{"symbol-placement":["point"]}],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"text-anchor":{"type":"enum","values":{"center":{},"left":{},"right":{},"top":{},"bottom":{},"top-left":{},"top-right":{},"bottom-left":{},"bottom-right":{}},"default":"center","requires":["text-field",{"!":"text-variable-anchor"}],"expression":{"interpolated":false,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-max-angle":{"type":"number","default":45,"units":"degrees","requires":["text-field",{"symbol-placement":["line","line-center"]}],"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"text-writing-mode":{"type":"array","value":"enum","values":{"horizontal":{},"vertical":{}},"requires":["text-field"],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"text-rotate":{"type":"number","default":0,"period":360,"units":"degrees","requires":["text-field"],"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-padding":{"type":"number","default":2,"minimum":0,"units":"pixels","requires":["text-field"],"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"text-keep-upright":{"type":"boolean","default":true,"requires":["text-field",{"text-rotation-alignment":"map"},{"symbol-placement":["line","line-center"]}],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"text-transform":{"type":"enum","values":{"none":{},"uppercase":{},"lowercase":{}},"default":"none","requires":["text-field"],"expression":{"interpolated":false,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-offset":{"type":"array","value":"number","units":"ems","length":2,"default":[0,0],"requires":["text-field",{"!":"text-radial-offset"}],"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-allow-overlap":{"type":"boolean","default":false,"requires":["text-field"],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"text-ignore-placement":{"type":"boolean","default":false,"requires":["text-field"],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"text-optional":{"type":"boolean","default":false,"requires":["text-field","icon-image"],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"visibility":{"type":"enum","values":{"visible":{},"none":{}},"default":"visible","property-type":"constant"}},"layout_raster":{"visibility":{"type":"enum","values":{"visible":{},"none":{}},"default":"visible","property-type":"constant"}},"layout_hillshade":{"visibility":{"type":"enum","values":{"visible":{},"none":{}},"default":"visible","property-type":"constant"}},"filter":{"type":"array","value":"*"},"filter_symbol":{"type":"boolean","default":false,"transition":false,"property-type":"data-driven","expression":{"interpolated":false,"parameters":["zoom","feature","pitch","distance-from-center"]}},"filter_fill":{"type":"boolean","default":false,"transition":false,"property-type":"data-driven","expression":{"interpolated":false,"parameters":["zoom","feature"]}},"filter_line":{"type":"boolean","default":false,"transition":false,"property-type":"data-driven","expression":{"interpolated":false,"parameters":["zoom","feature"]}},"filter_circle":{"type":"boolean","default":false,"transition":false,"property-type":"data-driven","expression":{"interpolated":false,"parameters":["zoom","feature"]}},"filter_fill-extrusion":{"type":"boolean","default":false,"transition":false,"property-type":"data-driven","expression":{"interpolated":false,"parameters":["zoom","feature"]}},"filter_heatmap":{"type":"boolean","default":false,"transition":false,"property-type":"data-driven","expression":{"interpolated":false,"parameters":["zoom","feature"]}},"filter_operator":{"type":"enum","values":{"==":{},"!=":{},">":{},">=":{},"<":{},"<=":{},"in":{},"!in":{},"all":{},"any":{},"none":{},"has":{},"!has":{},"within":{}}},"geometry_type":{"type":"enum","values":{"Point":{},"LineString":{},"Polygon":{}}},"function":{"expression":{"type":"expression"},"stops":{"type":"array","value":"function_stop"},"base":{"type":"number","default":1,"minimum":0},"property":{"type":"string","default":"$zoom"},"type":{"type":"enum","values":{"identity":{},"exponential":{},"interval":{},"categorical":{}},"default":"exponential"},"colorSpace":{"type":"enum","values":{"rgb":{},"lab":{},"hcl":{}},"default":"rgb"},"default":{"type":"*","required":false}},"function_stop":{"type":"array","minimum":0,"maximum":24,"value":["number","color"],"length":2},"expression":{"type":"array","value":"*","minimum":1},"fog":{"range":{"type":"array","default":[0.5,10],"minimum":-20,"maximum":20,"length":2,"value":"number","property-type":"data-constant","transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"color":{"type":"color","property-type":"data-constant","default":"#ffffff","expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"high-color":{"type":"color","property-type":"data-constant","default":"#245cdf","expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"space-color":{"type":"color","property-type":"data-constant","default":["interpolate",["linear"],["zoom"],4,"#010b19",7,"#367ab9"],"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"horizon-blend":{"type":"number","property-type":"data-constant","default":["interpolate",["linear"],["zoom"],4,0.2,7,0.1],"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"star-intensity":{"type":"number","property-type":"data-constant","default":["interpolate",["linear"],["zoom"],5,0.35,6,0],"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true}},"light":{"anchor":{"type":"enum","default":"viewport","values":{"map":{},"viewport":{}},"property-type":"data-constant","transition":false,"expression":{"interpolated":false,"parameters":["zoom"]}},"position":{"type":"array","default":[1.15,210,30],"length":3,"value":"number","property-type":"data-constant","transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"color":{"type":"color","property-type":"data-constant","default":"#ffffff","expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"intensity":{"type":"number","property-type":"data-constant","default":0.5,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true}},"projection":{"name":{"type":"enum","values":{"albers":{},"equalEarth":{},"equirectangular":{},"lambertConformalConic":{},"mercator":{},"naturalEarth":{},"winkelTripel":{},"globe":{}},"default":"mercator","required":true},"center":{"type":"array","length":2,"value":"number","property-type":"data-constant","minimum":[-180,-90],"maximum":[180,90],"transition":false,"requires":[{"name":["albers","lambertConformalConic"]}]},"parallels":{"type":"array","length":2,"value":"number","property-type":"data-constant","minimum":[-90,-90],"maximum":[90,90],"transition":false,"requires":[{"name":["albers","lambertConformalConic"]}]}},"terrain":{"source":{"type":"string","required":true},"exaggeration":{"type":"number","property-type":"data-constant","default":1,"minimum":0,"maximum":1000,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true,"requires":["source"]}},"paint":["paint_fill","paint_line","paint_circle","paint_heatmap","paint_fill-extrusion","paint_symbol","paint_raster","paint_hillshade","paint_background","paint_sky"],"paint_fill":{"fill-antialias":{"type":"boolean","default":true,"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"fill-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-color":{"type":"color","default":"#000000","transition":true,"requires":[{"!":"fill-pattern"}],"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-outline-color":{"type":"color","transition":true,"requires":[{"!":"fill-pattern"},{"fill-antialias":true}],"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"units":"pixels","expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"fill-translate-anchor":{"type":"enum","values":{"map":{},"viewport":{}},"default":"map","requires":["fill-translate"],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"fill-pattern":{"type":"resolvedImage","transition":true,"expression":{"interpolated":false,"parameters":["zoom","feature"]},"property-type":"cross-faded-data-driven"}},"paint_fill-extrusion":{"fill-extrusion-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"fill-extrusion-color":{"type":"color","default":"#000000","transition":true,"requires":[{"!":"fill-extrusion-pattern"}],"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-extrusion-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"units":"pixels","expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"fill-extrusion-translate-anchor":{"type":"enum","values":{"map":{},"viewport":{}},"default":"map","requires":["fill-extrusion-translate"],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"fill-extrusion-pattern":{"type":"resolvedImage","transition":true,"expression":{"interpolated":false,"parameters":["zoom","feature"]},"property-type":"cross-faded-data-driven"},"fill-extrusion-height":{"type":"number","default":0,"minimum":0,"units":"meters","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-extrusion-base":{"type":"number","default":0,"minimum":0,"units":"meters","transition":true,"requires":["fill-extrusion-height"],"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-extrusion-vertical-gradient":{"type":"boolean","default":true,"transition":false,"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"fill-extrusion-ambient-occlusion-intensity":{"property-type":"data-constant","type":"number","private":true,"default":0,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"fill-extrusion-ambient-occlusion-radius":{"property-type":"data-constant","type":"number","private":true,"default":3,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true}},"paint_line":{"line-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-color":{"type":"color","default":"#000000","transition":true,"requires":[{"!":"line-pattern"}],"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"units":"pixels","expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"line-translate-anchor":{"type":"enum","values":{"map":{},"viewport":{}},"default":"map","requires":["line-translate"],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"line-width":{"type":"number","default":1,"minimum":0,"transition":true,"units":"pixels","expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-gap-width":{"type":"number","default":0,"minimum":0,"transition":true,"units":"pixels","expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-offset":{"type":"number","default":0,"transition":true,"units":"pixels","expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-blur":{"type":"number","default":0,"minimum":0,"transition":true,"units":"pixels","expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-dasharray":{"type":"array","value":"number","minimum":0,"transition":true,"units":"line widths","requires":[{"!":"line-pattern"}],"expression":{"interpolated":false,"parameters":["zoom","feature"]},"property-type":"cross-faded-data-driven"},"line-pattern":{"type":"resolvedImage","transition":true,"expression":{"interpolated":false,"parameters":["zoom","feature"]},"property-type":"cross-faded-data-driven"},"line-gradient":{"type":"color","transition":false,"requires":[{"!":"line-pattern"},{"source":"geojson","has":{"lineMetrics":true}}],"expression":{"interpolated":true,"parameters":["line-progress"]},"property-type":"color-ramp"},"line-trim-offset":{"type":"array","value":"number","length":2,"default":[0,0],"minimum":[0,0],"maximum":[1,1],"transition":false,"requires":[{"source":"geojson","has":{"lineMetrics":true}}],"property-type":"constant"}},"paint_circle":{"circle-radius":{"type":"number","default":5,"minimum":0,"transition":true,"units":"pixels","expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"circle-color":{"type":"color","default":"#000000","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"circle-blur":{"type":"number","default":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"circle-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"circle-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"units":"pixels","expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"circle-translate-anchor":{"type":"enum","values":{"map":{},"viewport":{}},"default":"map","requires":["circle-translate"],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"circle-pitch-scale":{"type":"enum","values":{"map":{},"viewport":{}},"default":"map","expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"circle-pitch-alignment":{"type":"enum","values":{"map":{},"viewport":{}},"default":"viewport","expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"circle-stroke-width":{"type":"number","default":0,"minimum":0,"transition":true,"units":"pixels","expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"circle-stroke-color":{"type":"color","default":"#000000","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"circle-stroke-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"}},"paint_heatmap":{"heatmap-radius":{"type":"number","default":30,"minimum":1,"transition":true,"units":"pixels","expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"heatmap-weight":{"type":"number","default":1,"minimum":0,"transition":false,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"heatmap-intensity":{"type":"number","default":1,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"heatmap-color":{"type":"color","default":["interpolate",["linear"],["heatmap-density"],0,"rgba(0, 0, 255, 0)",0.1,"royalblue",0.3,"cyan",0.5,"lime",0.7,"yellow",1,"red"],"transition":false,"expression":{"interpolated":true,"parameters":["heatmap-density"]},"property-type":"color-ramp"},"heatmap-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"}},"paint_symbol":{"icon-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"requires":["icon-image"],"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"icon-color":{"type":"color","default":"#000000","transition":true,"requires":["icon-image"],"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"icon-halo-color":{"type":"color","default":"rgba(0, 0, 0, 0)","transition":true,"requires":["icon-image"],"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"icon-halo-width":{"type":"number","default":0,"minimum":0,"transition":true,"units":"pixels","requires":["icon-image"],"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"icon-halo-blur":{"type":"number","default":0,"minimum":0,"transition":true,"units":"pixels","requires":["icon-image"],"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"icon-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"units":"pixels","requires":["icon-image"],"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"icon-translate-anchor":{"type":"enum","values":{"map":{},"viewport":{}},"default":"map","requires":["icon-image","icon-translate"],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"text-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"requires":["text-field"],"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"text-color":{"type":"color","default":"#000000","transition":true,"overridable":true,"requires":["text-field"],"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"text-halo-color":{"type":"color","default":"rgba(0, 0, 0, 0)","transition":true,"requires":["text-field"],"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"text-halo-width":{"type":"number","default":0,"minimum":0,"transition":true,"units":"pixels","requires":["text-field"],"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"text-halo-blur":{"type":"number","default":0,"minimum":0,"transition":true,"units":"pixels","requires":["text-field"],"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"text-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"units":"pixels","requires":["text-field"],"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"text-translate-anchor":{"type":"enum","values":{"map":{},"viewport":{}},"default":"map","requires":["text-field","text-translate"],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"}},"paint_raster":{"raster-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-hue-rotate":{"type":"number","default":0,"period":360,"transition":true,"units":"degrees","expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-brightness-min":{"type":"number","default":0,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-brightness-max":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-saturation":{"type":"number","default":0,"minimum":-1,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-contrast":{"type":"number","default":0,"minimum":-1,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-resampling":{"type":"enum","values":{"linear":{},"nearest":{}},"default":"linear","expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"raster-fade-duration":{"type":"number","default":300,"minimum":0,"transition":false,"units":"milliseconds","expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"}},"paint_hillshade":{"hillshade-illumination-direction":{"type":"number","default":335,"minimum":0,"maximum":359,"transition":false,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"hillshade-illumination-anchor":{"type":"enum","values":{"map":{},"viewport":{}},"default":"viewport","expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"hillshade-exaggeration":{"type":"number","default":0.5,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"hillshade-shadow-color":{"type":"color","default":"#000000","transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"hillshade-highlight-color":{"type":"color","default":"#FFFFFF","transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"hillshade-accent-color":{"type":"color","default":"#000000","transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"}},"paint_background":{"background-color":{"type":"color","default":"#000000","transition":true,"requires":[{"!":"background-pattern"}],"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"background-pattern":{"type":"resolvedImage","transition":true,"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"cross-faded"},"background-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"}},"paint_sky":{"sky-type":{"type":"enum","values":{"gradient":{},"atmosphere":{}},"default":"atmosphere","expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"sky-atmosphere-sun":{"type":"array","value":"number","length":2,"units":"degrees","minimum":[0,0],"maximum":[360,180],"transition":false,"requires":[{"sky-type":"atmosphere"}],"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"sky-atmosphere-sun-intensity":{"type":"number","requires":[{"sky-type":"atmosphere"}],"default":10,"minimum":0,"maximum":100,"transition":false,"property-type":"data-constant"},"sky-gradient-center":{"type":"array","requires":[{"sky-type":"gradient"}],"value":"number","default":[0,0],"length":2,"units":"degrees","minimum":[0,0],"maximum":[360,180],"transition":false,"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"sky-gradient-radius":{"type":"number","requires":[{"sky-type":"gradient"}],"default":90,"minimum":0,"maximum":180,"transition":false,"expression":{"interpolated":false,"parameters":["zoom"]},"property-type":"data-constant"},"sky-gradient":{"type":"color","default":["interpolate",["linear"],["sky-radial-progress"],0.8,"#87ceeb",1,"white"],"transition":false,"requires":[{"sky-type":"gradient"}],"expression":{"interpolated":true,"parameters":["sky-radial-progress"]},"property-type":"color-ramp"},"sky-atmosphere-halo-color":{"type":"color","default":"white","transition":false,"requires":[{"sky-type":"atmosphere"}],"property-type":"data-constant"},"sky-atmosphere-color":{"type":"color","default":"white","transition":false,"requires":[{"sky-type":"atmosphere"}],"property-type":"data-constant"},"sky-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"}},"transition":{"duration":{"type":"number","default":300,"minimum":0,"units":"milliseconds"},"delay":{"type":"number","default":0,"minimum":0,"units":"milliseconds"}},"property-type":{"data-driven":{"type":"property-type"},"cross-faded":{"type":"property-type"},"cross-faded-data-driven":{"type":"property-type"},"color-ramp":{"type":"property-type"},"data-constant":{"type":"property-type"},"constant":{"type":"property-type"}},"promoteId":{"*":{"type":"string"}}}');function Zt(t,...e){for(const r of e)for(const e in r)t[e]=r[e];return t}function Xt(t){return t instanceof Number||t instanceof String||t instanceof Boolean?t.valueOf():t}function Kt(t){if(Array.isArray(t))return t.map(Kt);if(t instanceof Object&&!(t instanceof Number||t instanceof String||t instanceof Boolean)){const e={};for(const r in t)e[r]=Kt(t[r]);return e}return Xt(t)}class Ht extends Error{constructor(t,e){super(e),this.message=e,this.key=t;}}var Yt=Ht;class Wt{constructor(t,e=[]){this.parent=t,this.bindings={};for(const[t,r]of e)this.bindings[t]=r;}concat(t){return new Wt(this,t)}get(t){if(this.bindings[t])return this.bindings[t];if(this.parent)return this.parent.get(t);throw new Error(`${t} not found in scope.`)}has(t){return !!this.bindings[t]||!!this.parent&&this.parent.has(t)}}var Jt=Wt;const Qt={kind:"null"},te={kind:"number"},ee={kind:"string"},re={kind:"boolean"},ne={kind:"color"},ie={kind:"object"},se={kind:"value"},ae={kind:"collator"},oe={kind:"formatted"},le={kind:"resolvedImage"};function ue(t,e){return {kind:"array",itemType:t,N:e}}function ce(t){if("array"===t.kind){const e=ce(t.itemType);return "number"==typeof t.N?`array<${e}, ${t.N}>`:"value"===t.itemType.kind?"array":`array<${e}>`}return t.kind}const he=[Qt,te,ee,re,ne,oe,ie,ue(se),le];function pe(t,e){if("error"===e.kind)return null;if("array"===t.kind){if("array"===e.kind&&(0===e.N&&"value"===e.itemType.kind||!pe(t.itemType,e.itemType))&&("number"!=typeof t.N||t.N===e.N))return null}else {if(t.kind===e.kind)return null;if("value"===t.kind)for(const t of he)if(!pe(t,e))return null}return `Expected ${ce(t)} but found ${ce(e)} instead.`}function fe(t,e){return e.some((e=>e.kind===t.kind))}function de(t,e){return e.some((e=>"null"===e?null===t:"array"===e?Array.isArray(t):"object"===e?t&&!Array.isArray(t)&&"object"==typeof t:e===typeof t))}function ye(t){var e={exports:{}};return t(e,e.exports),e.exports}var me=ye((function(t,e){var r={transparent:[0,0,0,0],aliceblue:[240,248,255,1],antiquewhite:[250,235,215,1],aqua:[0,255,255,1],aquamarine:[127,255,212,1],azure:[240,255,255,1],beige:[245,245,220,1],bisque:[255,228,196,1],black:[0,0,0,1],blanchedalmond:[255,235,205,1],blue:[0,0,255,1],blueviolet:[138,43,226,1],brown:[165,42,42,1],burlywood:[222,184,135,1],cadetblue:[95,158,160,1],chartreuse:[127,255,0,1],chocolate:[210,105,30,1],coral:[255,127,80,1],cornflowerblue:[100,149,237,1],cornsilk:[255,248,220,1],crimson:[220,20,60,1],cyan:[0,255,255,1],darkblue:[0,0,139,1],darkcyan:[0,139,139,1],darkgoldenrod:[184,134,11,1],darkgray:[169,169,169,1],darkgreen:[0,100,0,1],darkgrey:[169,169,169,1],darkkhaki:[189,183,107,1],darkmagenta:[139,0,139,1],darkolivegreen:[85,107,47,1],darkorange:[255,140,0,1],darkorchid:[153,50,204,1],darkred:[139,0,0,1],darksalmon:[233,150,122,1],darkseagreen:[143,188,143,1],darkslateblue:[72,61,139,1],darkslategray:[47,79,79,1],darkslategrey:[47,79,79,1],darkturquoise:[0,206,209,1],darkviolet:[148,0,211,1],deeppink:[255,20,147,1],deepskyblue:[0,191,255,1],dimgray:[105,105,105,1],dimgrey:[105,105,105,1],dodgerblue:[30,144,255,1],firebrick:[178,34,34,1],floralwhite:[255,250,240,1],forestgreen:[34,139,34,1],fuchsia:[255,0,255,1],gainsboro:[220,220,220,1],ghostwhite:[248,248,255,1],gold:[255,215,0,1],goldenrod:[218,165,32,1],gray:[128,128,128,1],green:[0,128,0,1],greenyellow:[173,255,47,1],grey:[128,128,128,1],honeydew:[240,255,240,1],hotpink:[255,105,180,1],indianred:[205,92,92,1],indigo:[75,0,130,1],ivory:[255,255,240,1],khaki:[240,230,140,1],lavender:[230,230,250,1],lavenderblush:[255,240,245,1],lawngreen:[124,252,0,1],lemonchiffon:[255,250,205,1],lightblue:[173,216,230,1],lightcoral:[240,128,128,1],lightcyan:[224,255,255,1],lightgoldenrodyellow:[250,250,210,1],lightgray:[211,211,211,1],lightgreen:[144,238,144,1],lightgrey:[211,211,211,1],lightpink:[255,182,193,1],lightsalmon:[255,160,122,1],lightseagreen:[32,178,170,1],lightskyblue:[135,206,250,1],lightslategray:[119,136,153,1],lightslategrey:[119,136,153,1],lightsteelblue:[176,196,222,1],lightyellow:[255,255,224,1],lime:[0,255,0,1],limegreen:[50,205,50,1],linen:[250,240,230,1],magenta:[255,0,255,1],maroon:[128,0,0,1],mediumaquamarine:[102,205,170,1],mediumblue:[0,0,205,1],mediumorchid:[186,85,211,1],mediumpurple:[147,112,219,1],mediumseagreen:[60,179,113,1],mediumslateblue:[123,104,238,1],mediumspringgreen:[0,250,154,1],mediumturquoise:[72,209,204,1],mediumvioletred:[199,21,133,1],midnightblue:[25,25,112,1],mintcream:[245,255,250,1],mistyrose:[255,228,225,1],moccasin:[255,228,181,1],navajowhite:[255,222,173,1],navy:[0,0,128,1],oldlace:[253,245,230,1],olive:[128,128,0,1],olivedrab:[107,142,35,1],orange:[255,165,0,1],orangered:[255,69,0,1],orchid:[218,112,214,1],palegoldenrod:[238,232,170,1],palegreen:[152,251,152,1],paleturquoise:[175,238,238,1],palevioletred:[219,112,147,1],papayawhip:[255,239,213,1],peachpuff:[255,218,185,1],peru:[205,133,63,1],pink:[255,192,203,1],plum:[221,160,221,1],powderblue:[176,224,230,1],purple:[128,0,128,1],rebeccapurple:[102,51,153,1],red:[255,0,0,1],rosybrown:[188,143,143,1],royalblue:[65,105,225,1],saddlebrown:[139,69,19,1],salmon:[250,128,114,1],sandybrown:[244,164,96,1],seagreen:[46,139,87,1],seashell:[255,245,238,1],sienna:[160,82,45,1],silver:[192,192,192,1],skyblue:[135,206,235,1],slateblue:[106,90,205,1],slategray:[112,128,144,1],slategrey:[112,128,144,1],snow:[255,250,250,1],springgreen:[0,255,127,1],steelblue:[70,130,180,1],tan:[210,180,140,1],teal:[0,128,128,1],thistle:[216,191,216,1],tomato:[255,99,71,1],turquoise:[64,224,208,1],violet:[238,130,238,1],wheat:[245,222,179,1],white:[255,255,255,1],whitesmoke:[245,245,245,1],yellow:[255,255,0,1],yellowgreen:[154,205,50,1]};function n(t){return (t=Math.round(t))<0?0:t>255?255:t}function i(t){return n("%"===t[t.length-1]?parseFloat(t)/100*255:parseInt(t))}function s(t){return (e="%"===t[t.length-1]?parseFloat(t)/100:parseFloat(t))<0?0:e>1?1:e;var e;}function a(t,e,r){return r<0?r+=1:r>1&&(r-=1),6*r<1?t+(e-t)*r*6:2*r<1?e:3*r<2?t+(e-t)*(2/3-r)*6:t}try{e.parseCSSColor=function(t){var e,o=t.replace(/ /g,"").toLowerCase();if(o in r)return r[o].slice();if("#"===o[0])return 4===o.length?(e=parseInt(o.substr(1),16))>=0&&e<=4095?[(3840&e)>>4|(3840&e)>>8,240&e|(240&e)>>4,15&e|(15&e)<<4,1]:null:7===o.length&&(e=parseInt(o.substr(1),16))>=0&&e<=16777215?[(16711680&e)>>16,(65280&e)>>8,255&e,1]:null;var l=o.indexOf("("),u=o.indexOf(")");if(-1!==l&&u+1===o.length){var c=o.substr(0,l),h=o.substr(l+1,u-(l+1)).split(","),p=1;switch(c){case"rgba":if(4!==h.length)return null;p=s(h.pop());case"rgb":return 3!==h.length?null:[i(h[0]),i(h[1]),i(h[2]),p];case"hsla":if(4!==h.length)return null;p=s(h.pop());case"hsl":if(3!==h.length)return null;var f=(parseFloat(h[0])%360+360)%360/360,d=s(h[1]),y=s(h[2]),m=y<=.5?y*(d+1):y+d-y*d,g=2*y-m;return [n(255*a(g,m,f+1/3)),n(255*a(g,m,f)),n(255*a(g,m,f-1/3)),p];default:return null}}return null};}catch(t){}}));class ge{constructor(t,e,r,n=1){this.r=t,this.g=e,this.b=r,this.a=n;}static parse(t){if(!t)return;if(t instanceof ge)return t;if("string"!=typeof t)return;const e=me.parseCSSColor(t);return e?new ge(e[0]/255*e[3],e[1]/255*e[3],e[2]/255*e[3],e[3]):void 0}toString(){const[t,e,r,n]=this.toArray();return `rgba(${Math.round(t)},${Math.round(e)},${Math.round(r)},${n})`}toArray(){const{r:t,g:e,b:r,a:n}=this;return 0===n?[0,0,0,0]:[255*t/n,255*e/n,255*r/n,n]}toArray01(){const{r:t,g:e,b:r,a:n}=this;return 0===n?[0,0,0,0]:[t/n,e/n,r/n,n]}toArray01PremultipliedAlpha(){const{r:t,g:e,b:r,a:n}=this;return [t,e,r,n]}}ge.black=new ge(0,0,0,1),ge.white=new ge(1,1,1,1),ge.transparent=new ge(0,0,0,0),ge.red=new ge(1,0,0,1),ge.blue=new ge(0,0,1,1);var xe=ge;class ve{constructor(t,e,r){this.sensitivity=t?e?"variant":"case":e?"accent":"base",this.locale=r,this.collator=new Intl.Collator(this.locale?this.locale:[],{sensitivity:this.sensitivity,usage:"search"});}compare(t,e){return this.collator.compare(t,e)}resolvedLocale(){return new Intl.Collator(this.locale?this.locale:[]).resolvedOptions().locale}}class be{constructor(t,e,r,n,i){this.text=t.normalize?t.normalize():t,this.image=e,this.scale=r,this.fontStack=n,this.textColor=i;}}class _e{constructor(t){this.sections=t;}static fromString(t){return new _e([new be(t,null,null,null,null)])}isEmpty(){return 0===this.sections.length||!this.sections.some((t=>0!==t.text.length||t.image&&0!==t.image.name.length))}static factory(t){return t instanceof _e?t:_e.fromString(t)}toString(){return 0===this.sections.length?"":this.sections.map((t=>t.text)).join("")}serialize(){const t=["format"];for(const e of this.sections){if(e.image){t.push(["image",e.image.name]);continue}t.push(e.text);const r={};e.fontStack&&(r["text-font"]=["literal",e.fontStack.split(",")]),e.scale&&(r["font-scale"]=e.scale),e.textColor&&(r["text-color"]=["rgba"].concat(e.textColor.toArray())),t.push(r);}return t}}class we{constructor(t){this.name=t.name,this.available=t.available;}toString(){return this.name}static fromString(t){return t?new we({name:t,available:!1}):null}serialize(){return ["image",this.name]}}function Ae(t,e,r,n){return "number"==typeof t&&t>=0&&t<=255&&"number"==typeof e&&e>=0&&e<=255&&"number"==typeof r&&r>=0&&r<=255?void 0===n||"number"==typeof n&&n>=0&&n<=1?null:`Invalid rgba value [${[t,e,r,n].join(", ")}]: 'a' must be between 0 and 1.`:`Invalid rgba value [${("number"==typeof n?[t,e,r,n]:[t,e,r]).join(", ")}]: 'r', 'g', and 'b' must be between 0 and 255.`}function Se(t){if(null===t)return !0;if("string"==typeof t)return !0;if("boolean"==typeof t)return !0;if("number"==typeof t)return !0;if(t instanceof xe)return !0;if(t instanceof ve)return !0;if(t instanceof _e)return !0;if(t instanceof we)return !0;if(Array.isArray(t)){for(const e of t)if(!Se(e))return !1;return !0}if("object"==typeof t){for(const e in t)if(!Se(t[e]))return !1;return !0}return !1}function ke(t){if(null===t)return Qt;if("string"==typeof t)return ee;if("boolean"==typeof t)return re;if("number"==typeof t)return te;if(t instanceof xe)return ne;if(t instanceof ve)return ae;if(t instanceof _e)return oe;if(t instanceof we)return le;if(Array.isArray(t)){const e=t.length;let r;for(const e of t){const t=ke(e);if(r){if(r===t)continue;r=se;break}r=t;}return ue(r||se,e)}return ie}function Ie(t){const e=typeof t;return null===t?"":"string"===e||"number"===e||"boolean"===e?String(t):t instanceof xe||t instanceof _e||t instanceof we?t.toString():JSON.stringify(t)}class Me{constructor(t,e){this.type=t,this.value=e;}static parse(t,e){if(2!==t.length)return e.error(`'literal' expression requires exactly one argument, but found ${t.length-1} instead.`);if(!Se(t[1]))return e.error("invalid value");const r=t[1];let n=ke(r);const i=e.expectedType;return "array"!==n.kind||0!==n.N||!i||"array"!==i.kind||"number"==typeof i.N&&0!==i.N||(n=i),new Me(n,r)}evaluate(){return this.value}eachChild(){}outputDefined(){return !0}serialize(){return "array"===this.type.kind||"object"===this.type.kind?["literal",this.value]:this.value instanceof xe?["rgba"].concat(this.value.toArray()):this.value instanceof _e?this.value.serialize():this.value}}var ze=Me,Te=class{constructor(t){this.name="ExpressionEvaluationError",this.message=t;}toJSON(){return this.message}};const Be={string:ee,number:te,boolean:re,object:ie};class Ee{constructor(t,e){this.type=t,this.args=e;}static parse(t,e){if(t.length<2)return e.error("Expected at least one argument.");let r,n=1;const i=t[0];if("array"===i){let i,s;if(t.length>2){const r=t[1];if("string"!=typeof r||!(r in Be)||"object"===r)return e.error('The item type argument of "array" must be one of string, number, boolean',1);i=Be[r],n++;}else i=se;if(t.length>3){if(null!==t[2]&&("number"!=typeof t[2]||t[2]<0||t[2]!==Math.floor(t[2])))return e.error('The length argument to "array" must be a positive integer literal',2);s=t[2],n++;}r=ue(i,s);}else r=Be[i];const s=[];for(;n<t.length;n++){const r=e.parse(t[n],n,se);if(!r)return null;s.push(r);}return new Ee(r,s)}evaluate(t){for(let e=0;e<this.args.length;e++){const r=this.args[e].evaluate(t);if(!pe(this.type,ke(r)))return r;if(e===this.args.length-1)throw new Te(`Expected value to be of type ${ce(this.type)}, but found ${ce(ke(r))} instead.`)}return null}eachChild(t){this.args.forEach(t);}outputDefined(){return this.args.every((t=>t.outputDefined()))}serialize(){const t=this.type,e=[t.kind];if("array"===t.kind){const r=t.itemType;if("string"===r.kind||"number"===r.kind||"boolean"===r.kind){e.push(r.kind);const n=t.N;("number"==typeof n||this.args.length>1)&&e.push(n);}}return e.concat(this.args.map((t=>t.serialize())))}}var Ce=Ee;class Pe{constructor(t){this.type=oe,this.sections=t;}static parse(t,e){if(t.length<2)return e.error("Expected at least one argument.");const r=t[1];if(!Array.isArray(r)&&"object"==typeof r)return e.error("First argument must be an image or text section.");const n=[];let i=!1;for(let r=1;r<=t.length-1;++r){const s=t[r];if(i&&"object"==typeof s&&!Array.isArray(s)){i=!1;let t=null;if(s["font-scale"]&&(t=e.parse(s["font-scale"],1,te),!t))return null;let r=null;if(s["text-font"]&&(r=e.parse(s["text-font"],1,ue(ee)),!r))return null;let a=null;if(s["text-color"]&&(a=e.parse(s["text-color"],1,ne),!a))return null;const o=n[n.length-1];o.scale=t,o.font=r,o.textColor=a;}else {const s=e.parse(t[r],1,se);if(!s)return null;const a=s.type.kind;if("string"!==a&&"value"!==a&&"null"!==a&&"resolvedImage"!==a)return e.error("Formatted text type must be 'string', 'value', 'image' or 'null'.");i=!0,n.push({content:s,scale:null,font:null,textColor:null});}}return new Pe(n)}evaluate(t){return new _e(this.sections.map((e=>{const r=e.content.evaluate(t);return ke(r)===le?new be("",r,null,null,null):new be(Ie(r),null,e.scale?e.scale.evaluate(t):null,e.font?e.font.evaluate(t).join(","):null,e.textColor?e.textColor.evaluate(t):null)})))}eachChild(t){for(const e of this.sections)t(e.content),e.scale&&t(e.scale),e.font&&t(e.font),e.textColor&&t(e.textColor);}outputDefined(){return !1}serialize(){const t=["format"];for(const e of this.sections){t.push(e.content.serialize());const r={};e.scale&&(r["font-scale"]=e.scale.serialize()),e.font&&(r["text-font"]=e.font.serialize()),e.textColor&&(r["text-color"]=e.textColor.serialize()),t.push(r);}return t}}class De{constructor(t){this.type=le,this.input=t;}static parse(t,e){if(2!==t.length)return e.error("Expected two arguments.");const r=e.parse(t[1],1,ee);return r?new De(r):e.error("No image name provided.")}evaluate(t){const e=this.input.evaluate(t),r=we.fromString(e);return r&&t.availableImages&&(r.available=t.availableImages.indexOf(e)>-1),r}eachChild(t){t(this.input);}outputDefined(){return !1}serialize(){return ["image",this.input.serialize()]}}const Ve={"to-boolean":re,"to-color":ne,"to-number":te,"to-string":ee};class Fe{constructor(t,e){this.type=t,this.args=e;}static parse(t,e){if(t.length<2)return e.error("Expected at least one argument.");const r=t[0];if(("to-boolean"===r||"to-string"===r)&&2!==t.length)return e.error("Expected one argument.");const n=Ve[r],i=[];for(let r=1;r<t.length;r++){const n=e.parse(t[r],r,se);if(!n)return null;i.push(n);}return new Fe(n,i)}evaluate(t){if("boolean"===this.type.kind)return Boolean(this.args[0].evaluate(t));if("color"===this.type.kind){let e,r;for(const n of this.args){if(e=n.evaluate(t),r=null,e instanceof xe)return e;if("string"==typeof e){const r=t.parseColor(e);if(r)return r}else if(Array.isArray(e)&&(r=e.length<3||e.length>4?`Invalid rbga value ${JSON.stringify(e)}: expected an array containing either three or four numeric values.`:Ae(e[0],e[1],e[2],e[3]),!r))return new xe(e[0]/255,e[1]/255,e[2]/255,e[3])}throw new Te(r||`Could not parse color from value '${"string"==typeof e?e:String(JSON.stringify(e))}'`)}if("number"===this.type.kind){let e=null;for(const r of this.args){if(e=r.evaluate(t),null===e)return 0;const n=Number(e);if(!isNaN(n))return n}throw new Te(`Could not convert ${JSON.stringify(e)} to number.`)}return "formatted"===this.type.kind?_e.fromString(Ie(this.args[0].evaluate(t))):"resolvedImage"===this.type.kind?we.fromString(Ie(this.args[0].evaluate(t))):Ie(this.args[0].evaluate(t))}eachChild(t){this.args.forEach(t);}outputDefined(){return this.args.every((t=>t.outputDefined()))}serialize(){if("formatted"===this.type.kind)return new Pe([{content:this.args[0],scale:null,font:null,textColor:null}]).serialize();if("resolvedImage"===this.type.kind)return new De(this.args[0]).serialize();const t=[`to-${this.type.kind}`];return this.eachChild((e=>{t.push(e.serialize());})),t}}var Le=Fe;const Re=["Unknown","Point","LineString","Polygon"];var Ue=class{constructor(){this.globals=null,this.feature=null,this.featureState=null,this.formattedSection=null,this._parseColorCache={},this.availableImages=null,this.canonical=null,this.featureTileCoord=null,this.featureDistanceData=null;}id(){return this.feature&&void 0!==this.feature.id?this.feature.id:null}geometryType(){return this.feature?"number"==typeof this.feature.type?Re[this.feature.type]:this.feature.type:null}geometry(){return this.feature&&"geometry"in this.feature?this.feature.geometry:null}canonicalID(){return this.canonical}properties(){return this.feature&&this.feature.properties||{}}distanceFromCenter(){if(this.featureTileCoord&&this.featureDistanceData){const t=this.featureDistanceData.center,e=this.featureDistanceData.scale,{x:r,y:n}=this.featureTileCoord;return this.featureDistanceData.bearing[0]*(r*e-t[0])+this.featureDistanceData.bearing[1]*(n*e-t[1])}return 0}parseColor(t){let e=this._parseColorCache[t];return e||(e=this._parseColorCache[t]=xe.parse(t)),e}};class je{constructor(t,e,r,n){this.name=t,this.type=e,this._evaluate=r,this.args=n;}evaluate(t){return this._evaluate(t,this.args)}eachChild(t){this.args.forEach(t);}outputDefined(){return !1}serialize(){return [this.name].concat(this.args.map((t=>t.serialize())))}static parse(t,e){const r=t[0],n=je.definitions[r];if(!n)return e.error(`Unknown expression "${r}". If you wanted a literal array, use ["literal", [...]].`,0);const i=Array.isArray(n)?n[0]:n.type,s=Array.isArray(n)?[[n[1],n[2]]]:n.overloads,a=s.filter((([e])=>!Array.isArray(e)||e.length===t.length-1));let o=null;for(const[n,s]of a){o=new fr(e.registry,e.path,null,e.scope);const a=[];let l=!1;for(let e=1;e<t.length;e++){const r=t[e],i=Array.isArray(n)?n[e-1]:n.type,s=o.parse(r,1+a.length,i);if(!s){l=!0;break}a.push(s);}if(!l)if(Array.isArray(n)&&n.length!==a.length)o.error(`Expected ${n.length} arguments, but found ${a.length} instead.`);else {for(let t=0;t<a.length;t++){const e=Array.isArray(n)?n[t]:n.type,r=a[t];o.concat(t+1).checkSubtype(e,r.type);}if(0===o.errors.length)return new je(r,i,s,a)}}if(1===a.length)e.errors.push(...o.errors);else {const r=(a.length?a:s).map((([t])=>{return e=t,Array.isArray(e)?`(${e.map(ce).join(", ")})`:`(${ce(e.type)}...)`;var e;})).join(" | "),n=[];for(let r=1;r<t.length;r++){const i=e.parse(t[r],1+n.length);if(!i)return null;n.push(ce(i.type));}e.error(`Expected arguments of type ${r}, but found (${n.join(", ")}) instead.`);}return null}static register(t,e){je.definitions=e;for(const r in e)t[r]=je;}}var $e=je;class Oe{constructor(t,e,r){this.type=ae,this.locale=r,this.caseSensitive=t,this.diacriticSensitive=e;}static parse(t,e){if(2!==t.length)return e.error("Expected one argument.");const r=t[1];if("object"!=typeof r||Array.isArray(r))return e.error("Collator options argument must be an object.");const n=e.parse(void 0!==r["case-sensitive"]&&r["case-sensitive"],1,re);if(!n)return null;const i=e.parse(void 0!==r["diacritic-sensitive"]&&r["diacritic-sensitive"],1,re);if(!i)return null;let s=null;return r.locale&&(s=e.parse(r.locale,1,ee),!s)?null:new Oe(n,i,s)}evaluate(t){return new ve(this.caseSensitive.evaluate(t),this.diacriticSensitive.evaluate(t),this.locale?this.locale.evaluate(t):null)}eachChild(t){t(this.caseSensitive),t(this.diacriticSensitive),this.locale&&t(this.locale);}outputDefined(){return !1}serialize(){const t={};return t["case-sensitive"]=this.caseSensitive.serialize(),t["diacritic-sensitive"]=this.diacriticSensitive.serialize(),this.locale&&(t.locale=this.locale.serialize()),["collator",t]}}const qe=8192;function Ne(t,e){t[0]=Math.min(t[0],e[0]),t[1]=Math.min(t[1],e[1]),t[2]=Math.max(t[2],e[0]),t[3]=Math.max(t[3],e[1]);}function Ge(t,e){return !(t[0]<=e[0]||t[2]>=e[2]||t[1]<=e[1]||t[3]>=e[3])}function Ze(t,e){const r=(180+t[0])/360,n=(180-180/Math.PI*Math.log(Math.tan(Math.PI/4+t[1]*Math.PI/360)))/360,i=Math.pow(2,e.z);return [Math.round(r*i*qe),Math.round(n*i*qe)]}function Xe(t,e,r){const n=t[0]-e[0],i=t[1]-e[1],s=t[0]-r[0],a=t[1]-r[1];return n*a-s*i==0&&n*s<=0&&i*a<=0}function Ke(t,e){let r=!1;for(let a=0,o=e.length;a<o;a++){const o=e[a];for(let e=0,a=o.length;e<a-1;e++){if(Xe(t,o[e],o[e+1]))return !1;(i=o[e])[1]>(n=t)[1]!=(s=o[e+1])[1]>n[1]&&n[0]<(s[0]-i[0])*(n[1]-i[1])/(s[1]-i[1])+i[0]&&(r=!r);}}var n,i,s;return r}function He(t,e){for(let r=0;r<e.length;r++)if(Ke(t,e[r]))return !0;return !1}function Ye(t,e,r,n){const i=n[0]-r[0],s=n[1]-r[1],a=(t[0]-r[0])*s-i*(t[1]-r[1]),o=(e[0]-r[0])*s-i*(e[1]-r[1]);return a>0&&o<0||a<0&&o>0}function We(t,e,r){for(const u of r)for(let r=0;r<u.length-1;++r)if(0!=(o=[(a=u[r+1])[0]-(s=u[r])[0],a[1]-s[1]])[0]*(l=[(i=e)[0]-(n=t)[0],i[1]-n[1]])[1]-o[1]*l[0]&&Ye(n,i,s,a)&&Ye(s,a,n,i))return !0;var n,i,s,a,o,l;return !1}function Je(t,e){for(let r=0;r<t.length;++r)if(!Ke(t[r],e))return !1;for(let r=0;r<t.length-1;++r)if(We(t[r],t[r+1],e))return !1;return !0}function Qe(t,e){for(let r=0;r<e.length;r++)if(Je(t,e[r]))return !0;return !1}function tr(t,e,r){const n=[];for(let i=0;i<t.length;i++){const s=[];for(let n=0;n<t[i].length;n++){const a=Ze(t[i][n],r);Ne(e,a),s.push(a);}n.push(s);}return n}function er(t,e,r){const n=[];for(let i=0;i<t.length;i++){const s=tr(t[i],e,r);n.push(s);}return n}function rr(t,e,r,n){if(t[0]<r[0]||t[0]>r[2]){const e=.5*n;let i=t[0]-r[0]>e?-n:r[0]-t[0]>e?n:0;0===i&&(i=t[0]-r[2]>e?-n:r[2]-t[0]>e?n:0),t[0]+=i;}Ne(e,t);}function nr(t,e,r,n){const i=Math.pow(2,n.z)*qe,s=[n.x*qe,n.y*qe],a=[];if(!t)return a;for(const n of t)for(const t of n){const n=[t.x+s[0],t.y+s[1]];rr(n,e,r,i),a.push(n);}return a}function ir(t,e,r,n){const i=Math.pow(2,n.z)*qe,s=[n.x*qe,n.y*qe],a=[];if(!t)return a;for(const r of t){const t=[];for(const n of r){const r=[n.x+s[0],n.y+s[1]];Ne(e,r),t.push(r);}a.push(t);}if(e[2]-e[0]<=i/2){(o=e)[0]=o[1]=1/0,o[2]=o[3]=-1/0;for(const t of a)for(const n of t)rr(n,e,r,i);}var o;return a}class sr{constructor(t,e){this.type=re,this.geojson=t,this.geometries=e;}static parse(t,e){if(2!==t.length)return e.error(`'within' expression requires exactly one argument, but found ${t.length-1} instead.`);if(Se(t[1])){const e=t[1];if("FeatureCollection"===e.type)for(let t=0;t<e.features.length;++t){const r=e.features[t].geometry.type;if("Polygon"===r||"MultiPolygon"===r)return new sr(e,e.features[t].geometry)}else if("Feature"===e.type){const t=e.geometry.type;if("Polygon"===t||"MultiPolygon"===t)return new sr(e,e.geometry)}else if("Polygon"===e.type||"MultiPolygon"===e.type)return new sr(e,e)}return e.error("'within' expression requires valid geojson object that contains polygon geometry type.")}evaluate(t){if(null!=t.geometry()&&null!=t.canonicalID()){if("Point"===t.geometryType())return function(t,e){const r=[1/0,1/0,-1/0,-1/0],n=[1/0,1/0,-1/0,-1/0],i=t.canonicalID();if(!i)return !1;if("Polygon"===e.type){const s=tr(e.coordinates,n,i),a=nr(t.geometry(),r,n,i);if(!Ge(r,n))return !1;for(const t of a)if(!Ke(t,s))return !1}if("MultiPolygon"===e.type){const s=er(e.coordinates,n,i),a=nr(t.geometry(),r,n,i);if(!Ge(r,n))return !1;for(const t of a)if(!He(t,s))return !1}return !0}(t,this.geometries);if("LineString"===t.geometryType())return function(t,e){const r=[1/0,1/0,-1/0,-1/0],n=[1/0,1/0,-1/0,-1/0],i=t.canonicalID();if(!i)return !1;if("Polygon"===e.type){const s=tr(e.coordinates,n,i),a=ir(t.geometry(),r,n,i);if(!Ge(r,n))return !1;for(const t of a)if(!Je(t,s))return !1}if("MultiPolygon"===e.type){const s=er(e.coordinates,n,i),a=ir(t.geometry(),r,n,i);if(!Ge(r,n))return !1;for(const t of a)if(!Qe(t,s))return !1}return !0}(t,this.geometries)}return !1}eachChild(){}outputDefined(){return !0}serialize(){return ["within",this.geojson]}}var ar=sr;function or(t){if(t instanceof $e){if("get"===t.name&&1===t.args.length)return !1;if("feature-state"===t.name)return !1;if("has"===t.name&&1===t.args.length)return !1;if("properties"===t.name||"geometry-type"===t.name||"id"===t.name)return !1;if(/^filter-/.test(t.name))return !1}if(t instanceof ar)return !1;let e=!0;return t.eachChild((t=>{e&&!or(t)&&(e=!1);})),e}function lr(t){if(t instanceof $e&&"feature-state"===t.name)return !1;let e=!0;return t.eachChild((t=>{e&&!lr(t)&&(e=!1);})),e}function ur(t,e){if(t instanceof $e&&e.indexOf(t.name)>=0)return !1;let r=!0;return t.eachChild((t=>{r&&!ur(t,e)&&(r=!1);})),r}class cr{constructor(t,e){this.type=e.type,this.name=t,this.boundExpression=e;}static parse(t,e){if(2!==t.length||"string"!=typeof t[1])return e.error("'var' expression requires exactly one string literal argument.");const r=t[1];return e.scope.has(r)?new cr(r,e.scope.get(r)):e.error(`Unknown variable "${r}". Make sure "${r}" has been bound in an enclosing "let" expression before using it.`,1)}evaluate(t){return this.boundExpression.evaluate(t)}eachChild(){}outputDefined(){return !1}serialize(){return ["var",this.name]}}var hr=cr;class pr{constructor(t,e=[],r,n=new Jt,i=[]){this.registry=t,this.path=e,this.key=e.map((t=>`[${t}]`)).join(""),this.scope=n,this.errors=i,this.expectedType=r;}parse(t,e,r,n,i={}){return e?this.concat(e,r,n)._parse(t,i):this._parse(t,i)}_parse(t,e){function r(t,e,r){return "assert"===r?new Ce(e,[t]):"coerce"===r?new Le(e,[t]):t}if(null!==t&&"string"!=typeof t&&"boolean"!=typeof t&&"number"!=typeof t||(t=["literal",t]),Array.isArray(t)){if(0===t.length)return this.error('Expected an array with at least one element. If you wanted a literal array, use ["literal", []].');const n=t[0];if("string"!=typeof n)return this.error(`Expression name must be a string, but found ${typeof n} instead. If you wanted a literal array, use ["literal", [...]].`,0),null;const i=this.registry[n];if(i){let n=i.parse(t,this);if(!n)return null;if(this.expectedType){const t=this.expectedType,i=n.type;if("string"!==t.kind&&"number"!==t.kind&&"boolean"!==t.kind&&"object"!==t.kind&&"array"!==t.kind||"value"!==i.kind)if("color"!==t.kind&&"formatted"!==t.kind&&"resolvedImage"!==t.kind||"value"!==i.kind&&"string"!==i.kind){if(this.checkSubtype(t,i))return null}else n=r(n,t,e.typeAnnotation||"coerce");else n=r(n,t,e.typeAnnotation||"assert");}if(!(n instanceof ze)&&"resolvedImage"!==n.type.kind&&dr(n)){const t=new Ue;try{n=new ze(n.type,n.evaluate(t));}catch(t){return this.error(t.message),null}}return n}return this.error(`Unknown expression "${n}". If you wanted a literal array, use ["literal", [...]].`,0)}return this.error(void 0===t?"'undefined' value invalid. Use null instead.":"object"==typeof t?'Bare objects invalid. Use ["literal", {...}] instead.':`Expected an array, but found ${typeof t} instead.`)}concat(t,e,r){const n="number"==typeof t?this.path.concat(t):this.path,i=r?this.scope.concat(r):this.scope;return new pr(this.registry,n,e||null,i,this.errors)}error(t,...e){const r=`${this.key}${e.map((t=>`[${t}]`)).join("")}`;this.errors.push(new Yt(r,t));}checkSubtype(t,e){const r=pe(t,e);return r&&this.error(r),r}}var fr=pr;function dr(t){if(t instanceof hr)return dr(t.boundExpression);if(t instanceof $e&&"error"===t.name)return !1;if(t instanceof Oe)return !1;if(t instanceof ar)return !1;const e=t instanceof Le||t instanceof Ce;let r=!0;return t.eachChild((t=>{r=e?r&&dr(t):r&&t instanceof ze;})),!!r&&or(t)&&ur(t,["zoom","heatmap-density","line-progress","sky-radial-progress","accumulated","is-supported-script","pitch","distance-from-center"])}function yr(t,e){const r=t.length-1;let n,i,s=0,a=r,o=0;for(;s<=a;)if(o=Math.floor((s+a)/2),n=t[o],i=t[o+1],n<=e){if(o===r||e<i)return o;s=o+1;}else {if(!(n>e))throw new Te("Input is not a number.");a=o-1;}return 0}class mr{constructor(t,e,r){this.type=t,this.input=e,this.labels=[],this.outputs=[];for(const[t,e]of r)this.labels.push(t),this.outputs.push(e);}static parse(t,e){if(t.length-1<4)return e.error(`Expected at least 4 arguments, but found only ${t.length-1}.`);if((t.length-1)%2!=0)return e.error("Expected an even number of arguments.");const r=e.parse(t[1],1,te);if(!r)return null;const n=[];let i=null;e.expectedType&&"value"!==e.expectedType.kind&&(i=e.expectedType);for(let r=1;r<t.length;r+=2){const s=1===r?-1/0:t[r],a=t[r+1],o=r,l=r+1;if("number"!=typeof s)return e.error('Input/output pairs for "step" expressions must be defined using literal numeric values (not computed expressions) for the input values.',o);if(n.length&&n[n.length-1][0]>=s)return e.error('Input/output pairs for "step" expressions must be arranged with input values in strictly ascending order.',o);const u=e.parse(a,l,i);if(!u)return null;i=i||u.type,n.push([s,u]);}return new mr(i,r,n)}evaluate(t){const e=this.labels,r=this.outputs;if(1===e.length)return r[0].evaluate(t);const n=this.input.evaluate(t);if(n<=e[0])return r[0].evaluate(t);const i=e.length;return n>=e[i-1]?r[i-1].evaluate(t):r[yr(e,n)].evaluate(t)}eachChild(t){t(this.input);for(const e of this.outputs)t(e);}outputDefined(){return this.outputs.every((t=>t.outputDefined()))}serialize(){const t=["step",this.input.serialize()];for(let e=0;e<this.labels.length;e++)e>0&&t.push(this.labels[e]),t.push(this.outputs[e].serialize());return t}}var gr=mr;function xr(t,e,r){return t*(1-r)+e*r}function vr(t,e,r){return t.map(((t,n)=>xr(t,e[n],r)))}var br=Object.freeze({__proto__:null,number:xr,color:function(t,e,r){return new xe(xr(t.r,e.r,r),xr(t.g,e.g,r),xr(t.b,e.b,r),xr(t.a,e.a,r))},array:vr});const _r=.95047,wr=1.08883,Ar=4/29,Sr=6/29,kr=3*Sr*Sr,Ir=Math.PI/180,Mr=180/Math.PI;function zr(t){return t>.008856451679035631?Math.pow(t,1/3):t/kr+Ar}function Tr(t){return t>Sr?t*t*t:kr*(t-Ar)}function Br(t){return 255*(t<=.0031308?12.92*t:1.055*Math.pow(t,1/2.4)-.055)}function Er(t){return (t/=255)<=.04045?t/12.92:Math.pow((t+.055)/1.055,2.4)}function Cr(t){const e=Er(t.r),r=Er(t.g),n=Er(t.b),i=zr((.4124564*e+.3575761*r+.1804375*n)/_r),s=zr((.2126729*e+.7151522*r+.072175*n)/1);return {l:116*s-16,a:500*(i-s),b:200*(s-zr((.0193339*e+.119192*r+.9503041*n)/wr)),alpha:t.a}}function Pr(t){let e=(t.l+16)/116,r=isNaN(t.a)?e:e+t.a/500,n=isNaN(t.b)?e:e-t.b/200;return e=1*Tr(e),r=_r*Tr(r),n=wr*Tr(n),new xe(Br(3.2404542*r-1.5371385*e-.4985314*n),Br(-.969266*r+1.8760108*e+.041556*n),Br(.0556434*r-.2040259*e+1.0572252*n),t.alpha)}function Dr(t,e,r){const n=e-t;return t+r*(n>180||n<-180?n-360*Math.round(n/360):n)}const Vr={forward:Cr,reverse:Pr,interpolate:function(t,e,r){return {l:xr(t.l,e.l,r),a:xr(t.a,e.a,r),b:xr(t.b,e.b,r),alpha:xr(t.alpha,e.alpha,r)}}},Fr={forward:function(t){const{l:e,a:r,b:n}=Cr(t),i=Math.atan2(n,r)*Mr;return {h:i<0?i+360:i,c:Math.sqrt(r*r+n*n),l:e,alpha:t.a}},reverse:function(t){const e=t.h*Ir,r=t.c;return Pr({l:t.l,a:Math.cos(e)*r,b:Math.sin(e)*r,alpha:t.alpha})},interpolate:function(t,e,r){return {h:Dr(t.h,e.h,r),c:xr(t.c,e.c,r),l:xr(t.l,e.l,r),alpha:xr(t.alpha,e.alpha,r)}}};var Lr=Object.freeze({__proto__:null,lab:Vr,hcl:Fr});class Rr{constructor(t,e,r,n,i){this.type=t,this.operator=e,this.interpolation=r,this.input=n,this.labels=[],this.outputs=[];for(const[t,e]of i)this.labels.push(t),this.outputs.push(e);}static interpolationFactor(t,e,n,i){let s=0;if("exponential"===t.name)s=Ur(e,t.base,n,i);else if("linear"===t.name)s=Ur(e,1,n,i);else if("cubic-bezier"===t.name){const a=t.controlPoints;s=new r(a[0],a[1],a[2],a[3]).solve(Ur(e,1,n,i));}return s}static parse(t,e){let[r,n,i,...s]=t;if(!Array.isArray(n)||0===n.length)return e.error("Expected an interpolation type expression.",1);if("linear"===n[0])n={name:"linear"};else if("exponential"===n[0]){const t=n[1];if("number"!=typeof t)return e.error("Exponential interpolation requires a numeric base.",1,1);n={name:"exponential",base:t};}else {if("cubic-bezier"!==n[0])return e.error(`Unknown interpolation type ${String(n[0])}`,1,0);{const t=n.slice(1);if(4!==t.length||t.some((t=>"number"!=typeof t||t<0||t>1)))return e.error("Cubic bezier interpolation requires four numeric arguments with values between 0 and 1.",1);n={name:"cubic-bezier",controlPoints:t};}}if(t.length-1<4)return e.error(`Expected at least 4 arguments, but found only ${t.length-1}.`);if((t.length-1)%2!=0)return e.error("Expected an even number of arguments.");if(i=e.parse(i,2,te),!i)return null;const a=[];let o=null;"interpolate-hcl"===r||"interpolate-lab"===r?o=ne:e.expectedType&&"value"!==e.expectedType.kind&&(o=e.expectedType);for(let t=0;t<s.length;t+=2){const r=s[t],n=s[t+1],i=t+3,l=t+4;if("number"!=typeof r)return e.error('Input/output pairs for "interpolate" expressions must be defined using literal numeric values (not computed expressions) for the input values.',i);if(a.length&&a[a.length-1][0]>=r)return e.error('Input/output pairs for "interpolate" expressions must be arranged with input values in strictly ascending order.',i);const u=e.parse(n,l,o);if(!u)return null;o=o||u.type,a.push([r,u]);}return "number"===o.kind||"color"===o.kind||"array"===o.kind&&"number"===o.itemType.kind&&"number"==typeof o.N?new Rr(o,r,n,i,a):e.error(`Type ${ce(o)} is not interpolatable.`)}evaluate(t){const e=this.labels,r=this.outputs;if(1===e.length)return r[0].evaluate(t);const n=this.input.evaluate(t);if(n<=e[0])return r[0].evaluate(t);const i=e.length;if(n>=e[i-1])return r[i-1].evaluate(t);const s=yr(e,n),a=Rr.interpolationFactor(this.interpolation,n,e[s],e[s+1]),o=r[s].evaluate(t),l=r[s+1].evaluate(t);return "interpolate"===this.operator?br[this.type.kind.toLowerCase()](o,l,a):"interpolate-hcl"===this.operator?Fr.reverse(Fr.interpolate(Fr.forward(o),Fr.forward(l),a)):Vr.reverse(Vr.interpolate(Vr.forward(o),Vr.forward(l),a))}eachChild(t){t(this.input);for(const e of this.outputs)t(e);}outputDefined(){return this.outputs.every((t=>t.outputDefined()))}serialize(){let t;t="linear"===this.interpolation.name?["linear"]:"exponential"===this.interpolation.name?1===this.interpolation.base?["linear"]:["exponential",this.interpolation.base]:["cubic-bezier"].concat(this.interpolation.controlPoints);const e=[this.operator,t,this.input.serialize()];for(let t=0;t<this.labels.length;t++)e.push(this.labels[t],this.outputs[t].serialize());return e}}function Ur(t,e,r,n){const i=n-r,s=t-r;return 0===i?0:1===e?s/i:(Math.pow(e,s)-1)/(Math.pow(e,i)-1)}var jr=Rr;class $r{constructor(t,e){this.type=t,this.args=e;}static parse(t,e){if(t.length<2)return e.error("Expectected at least one argument.");let r=null;const n=e.expectedType;n&&"value"!==n.kind&&(r=n);const i=[];for(const n of t.slice(1)){const t=e.parse(n,1+i.length,r,void 0,{typeAnnotation:"omit"});if(!t)return null;r=r||t.type,i.push(t);}const s=n&&i.some((t=>pe(n,t.type)));return new $r(s?se:r,i)}evaluate(t){let e,r=null,n=0;for(const i of this.args){if(n++,r=i.evaluate(t),r&&r instanceof we&&!r.available&&(e||(e=r),r=null,n===this.args.length))return e;if(null!==r)break}return r}eachChild(t){this.args.forEach(t);}outputDefined(){return this.args.every((t=>t.outputDefined()))}serialize(){const t=["coalesce"];return this.eachChild((e=>{t.push(e.serialize());})),t}}var Or=$r;class qr{constructor(t,e){this.type=e.type,this.bindings=[].concat(t),this.result=e;}evaluate(t){return this.result.evaluate(t)}eachChild(t){for(const e of this.bindings)t(e[1]);t(this.result);}static parse(t,e){if(t.length<4)return e.error(`Expected at least 3 arguments, but found ${t.length-1} instead.`);const r=[];for(let n=1;n<t.length-1;n+=2){const i=t[n];if("string"!=typeof i)return e.error(`Expected string, but found ${typeof i} instead.`,n);if(/[^a-zA-Z0-9_]/.test(i))return e.error("Variable names must contain only alphanumeric characters or '_'.",n);const s=e.parse(t[n+1],n+1);if(!s)return null;r.push([i,s]);}const n=e.parse(t[t.length-1],t.length-1,e.expectedType,r);return n?new qr(r,n):null}outputDefined(){return this.result.outputDefined()}serialize(){const t=["let"];for(const[e,r]of this.bindings)t.push(e,r.serialize());return t.push(this.result.serialize()),t}}var Nr=qr;class Gr{constructor(t,e,r){this.type=t,this.index=e,this.input=r;}static parse(t,e){if(3!==t.length)return e.error(`Expected 2 arguments, but found ${t.length-1} instead.`);const r=e.parse(t[1],1,te),n=e.parse(t[2],2,ue(e.expectedType||se));return r&&n?new Gr(n.type.itemType,r,n):null}evaluate(t){const e=this.index.evaluate(t),r=this.input.evaluate(t);if(e<0)throw new Te(`Array index out of bounds: ${e} < 0.`);if(e>=r.length)throw new Te(`Array index out of bounds: ${e} > ${r.length-1}.`);if(e!==Math.floor(e))throw new Te(`Array index must be an integer, but found ${e} instead.`);return r[e]}eachChild(t){t(this.index),t(this.input);}outputDefined(){return !1}serialize(){return ["at",this.index.serialize(),this.input.serialize()]}}var Zr=Gr;class Xr{constructor(t,e){this.type=re,this.needle=t,this.haystack=e;}static parse(t,e){if(3!==t.length)return e.error(`Expected 2 arguments, but found ${t.length-1} instead.`);const r=e.parse(t[1],1,se),n=e.parse(t[2],2,se);return r&&n?fe(r.type,[re,ee,te,Qt,se])?new Xr(r,n):e.error(`Expected first argument to be of type boolean, string, number or null, but found ${ce(r.type)} instead`):null}evaluate(t){const e=this.needle.evaluate(t),r=this.haystack.evaluate(t);if(null==r)return !1;if(!de(e,["boolean","string","number","null"]))throw new Te(`Expected first argument to be of type boolean, string, number or null, but found ${ce(ke(e))} instead.`);if(!de(r,["string","array"]))throw new Te(`Expected second argument to be of type array or string, but found ${ce(ke(r))} instead.`);return r.indexOf(e)>=0}eachChild(t){t(this.needle),t(this.haystack);}outputDefined(){return !0}serialize(){return ["in",this.needle.serialize(),this.haystack.serialize()]}}var Kr=Xr;class Hr{constructor(t,e,r){this.type=te,this.needle=t,this.haystack=e,this.fromIndex=r;}static parse(t,e){if(t.length<=2||t.length>=5)return e.error(`Expected 3 or 4 arguments, but found ${t.length-1} instead.`);const r=e.parse(t[1],1,se),n=e.parse(t[2],2,se);if(!r||!n)return null;if(!fe(r.type,[re,ee,te,Qt,se]))return e.error(`Expected first argument to be of type boolean, string, number or null, but found ${ce(r.type)} instead`);if(4===t.length){const i=e.parse(t[3],3,te);return i?new Hr(r,n,i):null}return new Hr(r,n)}evaluate(t){const e=this.needle.evaluate(t),r=this.haystack.evaluate(t);if(!de(e,["boolean","string","number","null"]))throw new Te(`Expected first argument to be of type boolean, string, number or null, but found ${ce(ke(e))} instead.`);if(!de(r,["string","array"]))throw new Te(`Expected second argument to be of type array or string, but found ${ce(ke(r))} instead.`);if(this.fromIndex){const n=this.fromIndex.evaluate(t);return r.indexOf(e,n)}return r.indexOf(e)}eachChild(t){t(this.needle),t(this.haystack),this.fromIndex&&t(this.fromIndex);}outputDefined(){return !1}serialize(){if(null!=this.fromIndex&&void 0!==this.fromIndex){const t=this.fromIndex.serialize();return ["index-of",this.needle.serialize(),this.haystack.serialize(),t]}return ["index-of",this.needle.serialize(),this.haystack.serialize()]}}var Yr=Hr;class Wr{constructor(t,e,r,n,i,s){this.inputType=t,this.type=e,this.input=r,this.cases=n,this.outputs=i,this.otherwise=s;}static parse(t,e){if(t.length<5)return e.error(`Expected at least 4 arguments, but found only ${t.length-1}.`);if(t.length%2!=1)return e.error("Expected an even number of arguments.");let r,n;e.expectedType&&"value"!==e.expectedType.kind&&(n=e.expectedType);const i={},s=[];for(let a=2;a<t.length-1;a+=2){let o=t[a];const l=t[a+1];Array.isArray(o)||(o=[o]);const u=e.concat(a);if(0===o.length)return u.error("Expected at least one branch label.");for(const t of o){if("number"!=typeof t&&"string"!=typeof t)return u.error("Branch labels must be numbers or strings.");if("number"==typeof t&&Math.abs(t)>Number.MAX_SAFE_INTEGER)return u.error(`Branch labels must be integers no larger than ${Number.MAX_SAFE_INTEGER}.`);if("number"==typeof t&&Math.floor(t)!==t)return u.error("Numeric branch labels must be integer values.");if(r){if(u.checkSubtype(r,ke(t)))return null}else r=ke(t);if(void 0!==i[String(t)])return u.error("Branch labels must be unique.");i[String(t)]=s.length;}const c=e.parse(l,a,n);if(!c)return null;n=n||c.type,s.push(c);}const a=e.parse(t[1],1,se);if(!a)return null;const o=e.parse(t[t.length-1],t.length-1,n);return o?"value"!==a.type.kind&&e.concat(1).checkSubtype(r,a.type)?null:new Wr(r,n,a,i,s,o):null}evaluate(t){const e=this.input.evaluate(t);return (ke(e)===this.inputType&&this.outputs[this.cases[e]]||this.otherwise).evaluate(t)}eachChild(t){t(this.input),this.outputs.forEach(t),t(this.otherwise);}outputDefined(){return this.outputs.every((t=>t.outputDefined()))&&this.otherwise.outputDefined()}serialize(){const t=["match",this.input.serialize()],e=Object.keys(this.cases).sort(),r=[],n={};for(const t of e){const e=n[this.cases[t]];void 0===e?(n[this.cases[t]]=r.length,r.push([this.cases[t],[t]])):r[e][1].push(t);}const i=t=>"number"===this.inputType.kind?Number(t):t;for(const[e,n]of r)t.push(1===n.length?i(n[0]):n.map(i)),t.push(this.outputs[e].serialize());return t.push(this.otherwise.serialize()),t}}var Jr=Wr;class Qr{constructor(t,e,r){this.type=t,this.branches=e,this.otherwise=r;}static parse(t,e){if(t.length<4)return e.error(`Expected at least 3 arguments, but found only ${t.length-1}.`);if(t.length%2!=0)return e.error("Expected an odd number of arguments.");let r;e.expectedType&&"value"!==e.expectedType.kind&&(r=e.expectedType);const n=[];for(let i=1;i<t.length-1;i+=2){const s=e.parse(t[i],i,re);if(!s)return null;const a=e.parse(t[i+1],i+1,r);if(!a)return null;n.push([s,a]),r=r||a.type;}const i=e.parse(t[t.length-1],t.length-1,r);return i?new Qr(r,n,i):null}evaluate(t){for(const[e,r]of this.branches)if(e.evaluate(t))return r.evaluate(t);return this.otherwise.evaluate(t)}eachChild(t){for(const[e,r]of this.branches)t(e),t(r);t(this.otherwise);}outputDefined(){return this.branches.every((([t,e])=>e.outputDefined()))&&this.otherwise.outputDefined()}serialize(){const t=["case"];return this.eachChild((e=>{t.push(e.serialize());})),t}}var tn=Qr;class en{constructor(t,e,r,n){this.type=t,this.input=e,this.beginIndex=r,this.endIndex=n;}static parse(t,e){if(t.length<=2||t.length>=5)return e.error(`Expected 3 or 4 arguments, but found ${t.length-1} instead.`);const r=e.parse(t[1],1,se),n=e.parse(t[2],2,te);if(!r||!n)return null;if(!fe(r.type,[ue(se),ee,se]))return e.error(`Expected first argument to be of type array or string, but found ${ce(r.type)} instead`);if(4===t.length){const i=e.parse(t[3],3,te);return i?new en(r.type,r,n,i):null}return new en(r.type,r,n)}evaluate(t){const e=this.input.evaluate(t),r=this.beginIndex.evaluate(t);if(!de(e,["string","array"]))throw new Te(`Expected first argument to be of type array or string, but found ${ce(ke(e))} instead.`);if(this.endIndex){const n=this.endIndex.evaluate(t);return e.slice(r,n)}return e.slice(r)}eachChild(t){t(this.input),t(this.beginIndex),this.endIndex&&t(this.endIndex);}outputDefined(){return !1}serialize(){if(null!=this.endIndex&&void 0!==this.endIndex){const t=this.endIndex.serialize();return ["slice",this.input.serialize(),this.beginIndex.serialize(),t]}return ["slice",this.input.serialize(),this.beginIndex.serialize()]}}var rn=en;function nn(t,e){return "=="===t||"!="===t?"boolean"===e.kind||"string"===e.kind||"number"===e.kind||"null"===e.kind||"value"===e.kind:"string"===e.kind||"number"===e.kind||"value"===e.kind}function sn(t,e,r,n){return 0===n.compare(e,r)}function an(t,e,r){const n="=="!==t&&"!="!==t;return class i{constructor(t,e,r){this.type=re,this.lhs=t,this.rhs=e,this.collator=r,this.hasUntypedArgument="value"===t.type.kind||"value"===e.type.kind;}static parse(t,e){if(3!==t.length&&4!==t.length)return e.error("Expected two or three arguments.");const r=t[0];let s=e.parse(t[1],1,se);if(!s)return null;if(!nn(r,s.type))return e.concat(1).error(`"${r}" comparisons are not supported for type '${ce(s.type)}'.`);let a=e.parse(t[2],2,se);if(!a)return null;if(!nn(r,a.type))return e.concat(2).error(`"${r}" comparisons are not supported for type '${ce(a.type)}'.`);if(s.type.kind!==a.type.kind&&"value"!==s.type.kind&&"value"!==a.type.kind)return e.error(`Cannot compare types '${ce(s.type)}' and '${ce(a.type)}'.`);n&&("value"===s.type.kind&&"value"!==a.type.kind?s=new Ce(a.type,[s]):"value"!==s.type.kind&&"value"===a.type.kind&&(a=new Ce(s.type,[a])));let o=null;if(4===t.length){if("string"!==s.type.kind&&"string"!==a.type.kind&&"value"!==s.type.kind&&"value"!==a.type.kind)return e.error("Cannot use collator to compare non-string types.");if(o=e.parse(t[3],3,ae),!o)return null}return new i(s,a,o)}evaluate(i){const s=this.lhs.evaluate(i),a=this.rhs.evaluate(i);if(n&&this.hasUntypedArgument){const e=ke(s),r=ke(a);if(e.kind!==r.kind||"string"!==e.kind&&"number"!==e.kind)throw new Te(`Expected arguments for "${t}" to be (string, string) or (number, number), but found (${e.kind}, ${r.kind}) instead.`)}if(this.collator&&!n&&this.hasUntypedArgument){const t=ke(s),r=ke(a);if("string"!==t.kind||"string"!==r.kind)return e(i,s,a)}return this.collator?r(i,s,a,this.collator.evaluate(i)):e(i,s,a)}eachChild(t){t(this.lhs),t(this.rhs),this.collator&&t(this.collator);}outputDefined(){return !0}serialize(){const e=[t];return this.eachChild((t=>{e.push(t.serialize());})),e}}}const on=an("==",(function(t,e,r){return e===r}),sn),ln=an("!=",(function(t,e,r){return e!==r}),(function(t,e,r,n){return !sn(0,e,r,n)})),un=an("<",(function(t,e,r){return e<r}),(function(t,e,r,n){return n.compare(e,r)<0})),cn=an(">",(function(t,e,r){return e>r}),(function(t,e,r,n){return n.compare(e,r)>0})),hn=an("<=",(function(t,e,r){return e<=r}),(function(t,e,r,n){return n.compare(e,r)<=0})),pn=an(">=",(function(t,e,r){return e>=r}),(function(t,e,r,n){return n.compare(e,r)>=0}));class fn{constructor(t,e,r,n,i,s){this.type=ee,this.number=t,this.locale=e,this.currency=r,this.unit=n,this.minFractionDigits=i,this.maxFractionDigits=s;}static parse(t,e){if(3!==t.length)return e.error("Expected two arguments.");const r=e.parse(t[1],1,te);if(!r)return null;const n=t[2];if("object"!=typeof n||Array.isArray(n))return e.error("NumberFormat options argument must be an object.");let i=null;if(n.locale&&(i=e.parse(n.locale,1,ee),!i))return null;let s=null;if(n.currency&&(s=e.parse(n.currency,1,ee),!s))return null;let a=null;if(n.unit&&(a=e.parse(n.unit,1,ee),!a))return null;let o=null;if(n["min-fraction-digits"]&&(o=e.parse(n["min-fraction-digits"],1,te),!o))return null;let l=null;return n["max-fraction-digits"]&&(l=e.parse(n["max-fraction-digits"],1,te),!l)?null:new fn(r,i,s,a,o,l)}evaluate(t){return new Intl.NumberFormat(this.locale?this.locale.evaluate(t):[],{style:(this.currency?"currency":this.unit&&"unit")||"decimal",currency:this.currency?this.currency.evaluate(t):void 0,unit:this.unit?this.unit.evaluate(t):void 0,minimumFractionDigits:this.minFractionDigits?this.minFractionDigits.evaluate(t):void 0,maximumFractionDigits:this.maxFractionDigits?this.maxFractionDigits.evaluate(t):void 0}).format(this.number.evaluate(t))}eachChild(t){t(this.number),this.locale&&t(this.locale),this.currency&&t(this.currency),this.unit&&t(this.unit),this.minFractionDigits&&t(this.minFractionDigits),this.maxFractionDigits&&t(this.maxFractionDigits);}outputDefined(){return !1}serialize(){const t={};return this.locale&&(t.locale=this.locale.serialize()),this.currency&&(t.currency=this.currency.serialize()),this.unit&&(t.unit=this.unit.serialize()),this.minFractionDigits&&(t["min-fraction-digits"]=this.minFractionDigits.serialize()),this.maxFractionDigits&&(t["max-fraction-digits"]=this.maxFractionDigits.serialize()),["number-format",this.number.serialize(),t]}}class dn{constructor(t){this.type=te,this.input=t;}static parse(t,e){if(2!==t.length)return e.error(`Expected 1 argument, but found ${t.length-1} instead.`);const r=e.parse(t[1],1);return r?"array"!==r.type.kind&&"string"!==r.type.kind&&"value"!==r.type.kind?e.error(`Expected argument of type string or array, but found ${ce(r.type)} instead.`):new dn(r):null}evaluate(t){const e=this.input.evaluate(t);if("string"==typeof e)return e.length;if(Array.isArray(e))return e.length;throw new Te(`Expected value to be of type string or array, but found ${ce(ke(e))} instead.`)}eachChild(t){t(this.input);}outputDefined(){return !1}serialize(){const t=["length"];return this.eachChild((e=>{t.push(e.serialize());})),t}}const yn={"==":on,"!=":ln,">":cn,"<":un,">=":pn,"<=":hn,array:Ce,at:Zr,boolean:Ce,case:tn,coalesce:Or,collator:Oe,format:Pe,image:De,in:Kr,"index-of":Yr,interpolate:jr,"interpolate-hcl":jr,"interpolate-lab":jr,length:dn,let:Nr,literal:ze,match:Jr,number:Ce,"number-format":fn,object:Ce,slice:rn,step:gr,string:Ce,"to-boolean":Le,"to-color":Le,"to-number":Le,"to-string":Le,var:hr,within:ar};function mn(t,[e,r,n,i]){e=e.evaluate(t),r=r.evaluate(t),n=n.evaluate(t);const s=i?i.evaluate(t):1,a=Ae(e,r,n,s);if(a)throw new Te(a);return new xe(e/255*s,r/255*s,n/255*s,s)}function gn(t,e){return t in e}function xn(t,e){const r=e[t];return void 0===r?null:r}function vn(t){return {type:t}}$e.register(yn,{error:[{kind:"error"},[ee],(t,[e])=>{throw new Te(e.evaluate(t))}],typeof:[ee,[se],(t,[e])=>ce(ke(e.evaluate(t)))],"to-rgba":[ue(te,4),[ne],(t,[e])=>e.evaluate(t).toArray()],rgb:[ne,[te,te,te],mn],rgba:[ne,[te,te,te,te],mn],has:{type:re,overloads:[[[ee],(t,[e])=>gn(e.evaluate(t),t.properties())],[[ee,ie],(t,[e,r])=>gn(e.evaluate(t),r.evaluate(t))]]},get:{type:se,overloads:[[[ee],(t,[e])=>xn(e.evaluate(t),t.properties())],[[ee,ie],(t,[e,r])=>xn(e.evaluate(t),r.evaluate(t))]]},"feature-state":[se,[ee],(t,[e])=>xn(e.evaluate(t),t.featureState||{})],properties:[ie,[],t=>t.properties()],"geometry-type":[ee,[],t=>t.geometryType()],id:[se,[],t=>t.id()],zoom:[te,[],t=>t.globals.zoom],pitch:[te,[],t=>t.globals.pitch||0],"distance-from-center":[te,[],t=>t.distanceFromCenter()],"heatmap-density":[te,[],t=>t.globals.heatmapDensity||0],"line-progress":[te,[],t=>t.globals.lineProgress||0],"sky-radial-progress":[te,[],t=>t.globals.skyRadialProgress||0],accumulated:[se,[],t=>void 0===t.globals.accumulated?null:t.globals.accumulated],"+":[te,vn(te),(t,e)=>{let r=0;for(const n of e)r+=n.evaluate(t);return r}],"*":[te,vn(te),(t,e)=>{let r=1;for(const n of e)r*=n.evaluate(t);return r}],"-":{type:te,overloads:[[[te,te],(t,[e,r])=>e.evaluate(t)-r.evaluate(t)],[[te],(t,[e])=>-e.evaluate(t)]]},"/":[te,[te,te],(t,[e,r])=>e.evaluate(t)/r.evaluate(t)],"%":[te,[te,te],(t,[e,r])=>e.evaluate(t)%r.evaluate(t)],ln2:[te,[],()=>Math.LN2],pi:[te,[],()=>Math.PI],e:[te,[],()=>Math.E],"^":[te,[te,te],(t,[e,r])=>Math.pow(e.evaluate(t),r.evaluate(t))],sqrt:[te,[te],(t,[e])=>Math.sqrt(e.evaluate(t))],log10:[te,[te],(t,[e])=>Math.log(e.evaluate(t))/Math.LN10],ln:[te,[te],(t,[e])=>Math.log(e.evaluate(t))],log2:[te,[te],(t,[e])=>Math.log(e.evaluate(t))/Math.LN2],sin:[te,[te],(t,[e])=>Math.sin(e.evaluate(t))],cos:[te,[te],(t,[e])=>Math.cos(e.evaluate(t))],tan:[te,[te],(t,[e])=>Math.tan(e.evaluate(t))],asin:[te,[te],(t,[e])=>Math.asin(e.evaluate(t))],acos:[te,[te],(t,[e])=>Math.acos(e.evaluate(t))],atan:[te,[te],(t,[e])=>Math.atan(e.evaluate(t))],min:[te,vn(te),(t,e)=>Math.min(...e.map((e=>e.evaluate(t))))],max:[te,vn(te),(t,e)=>Math.max(...e.map((e=>e.evaluate(t))))],abs:[te,[te],(t,[e])=>Math.abs(e.evaluate(t))],round:[te,[te],(t,[e])=>{const r=e.evaluate(t);return r<0?-Math.round(-r):Math.round(r)}],floor:[te,[te],(t,[e])=>Math.floor(e.evaluate(t))],ceil:[te,[te],(t,[e])=>Math.ceil(e.evaluate(t))],"filter-==":[re,[ee,se],(t,[e,r])=>t.properties()[e.value]===r.value],"filter-id-==":[re,[se],(t,[e])=>t.id()===e.value],"filter-type-==":[re,[ee],(t,[e])=>t.geometryType()===e.value],"filter-<":[re,[ee,se],(t,[e,r])=>{const n=t.properties()[e.value],i=r.value;return typeof n==typeof i&&n<i}],"filter-id-<":[re,[se],(t,[e])=>{const r=t.id(),n=e.value;return typeof r==typeof n&&r<n}],"filter->":[re,[ee,se],(t,[e,r])=>{const n=t.properties()[e.value],i=r.value;return typeof n==typeof i&&n>i}],"filter-id->":[re,[se],(t,[e])=>{const r=t.id(),n=e.value;return typeof r==typeof n&&r>n}],"filter-<=":[re,[ee,se],(t,[e,r])=>{const n=t.properties()[e.value],i=r.value;return typeof n==typeof i&&n<=i}],"filter-id-<=":[re,[se],(t,[e])=>{const r=t.id(),n=e.value;return typeof r==typeof n&&r<=n}],"filter->=":[re,[ee,se],(t,[e,r])=>{const n=t.properties()[e.value],i=r.value;return typeof n==typeof i&&n>=i}],"filter-id->=":[re,[se],(t,[e])=>{const r=t.id(),n=e.value;return typeof r==typeof n&&r>=n}],"filter-has":[re,[se],(t,[e])=>e.value in t.properties()],"filter-has-id":[re,[],t=>null!==t.id()&&void 0!==t.id()],"filter-type-in":[re,[ue(ee)],(t,[e])=>e.value.indexOf(t.geometryType())>=0],"filter-id-in":[re,[ue(se)],(t,[e])=>e.value.indexOf(t.id())>=0],"filter-in-small":[re,[ee,ue(se)],(t,[e,r])=>r.value.indexOf(t.properties()[e.value])>=0],"filter-in-large":[re,[ee,ue(se)],(t,[e,r])=>function(t,e,r,n){for(;r<=n;){const i=r+n>>1;if(e[i]===t)return !0;e[i]>t?n=i-1:r=i+1;}return !1}(t.properties()[e.value],r.value,0,r.value.length-1)],all:{type:re,overloads:[[[re,re],(t,[e,r])=>e.evaluate(t)&&r.evaluate(t)],[vn(re),(t,e)=>{for(const r of e)if(!r.evaluate(t))return !1;return !0}]]},any:{type:re,overloads:[[[re,re],(t,[e,r])=>e.evaluate(t)||r.evaluate(t)],[vn(re),(t,e)=>{for(const r of e)if(r.evaluate(t))return !0;return !1}]]},"!":[re,[re],(t,[e])=>!e.evaluate(t)],"is-supported-script":[re,[ee],(t,[e])=>{const r=t.globals&&t.globals.isSupportedScript;return !r||r(e.evaluate(t))}],upcase:[ee,[ee],(t,[e])=>e.evaluate(t).toUpperCase()],downcase:[ee,[ee],(t,[e])=>e.evaluate(t).toLowerCase()],concat:[ee,vn(se),(t,e)=>e.map((e=>Ie(e.evaluate(t)))).join("")],"resolved-locale":[ee,[ae],(t,[e])=>e.evaluate(t).resolvedLocale()]});var bn=yn;function _n(t){return {result:"success",value:t}}function wn(t){return {result:"error",value:t}}function An(t){return "data-driven"===t["property-type"]||"cross-faded-data-driven"===t["property-type"]}function Sn(t){return !!t.expression&&t.expression.parameters.indexOf("zoom")>-1}function kn(t){return !!t.expression&&t.expression.interpolated}function In(t){return t instanceof Number?"number":t instanceof String?"string":t instanceof Boolean?"boolean":Array.isArray(t)?"array":null===t?"null":typeof t}function Mn(t){return "object"==typeof t&&null!==t&&!Array.isArray(t)}function zn(t){return t}function Tn(t,e){const r="color"===e.type,n=t.stops&&"object"==typeof t.stops[0][0],i=n||!(n||void 0!==t.property),s=t.type||(kn(e)?"exponential":"interval");if(r&&((t=Zt({},t)).stops&&(t.stops=t.stops.map((t=>[t[0],xe.parse(t[1])]))),t.default=xe.parse(t.default?t.default:e.default)),t.colorSpace&&"rgb"!==t.colorSpace&&!Lr[t.colorSpace])throw new Error(`Unknown color space: ${t.colorSpace}`);let a,o,l;if("exponential"===s)a=Pn;else if("interval"===s)a=Cn;else if("categorical"===s){a=En,o=Object.create(null);for(const e of t.stops)o[e[0]]=e[1];l=typeof t.stops[0][0];}else {if("identity"!==s)throw new Error(`Unknown function type "${s}"`);a=Dn;}if(n){const r={},n=[];for(let e=0;e<t.stops.length;e++){const i=t.stops[e],s=i[0].zoom;void 0===r[s]&&(r[s]={zoom:s,type:t.type,property:t.property,default:t.default,stops:[]},n.push(s)),r[s].stops.push([i[0].value,i[1]]);}const i=[];for(const t of n)i.push([r[t].zoom,Tn(r[t],e)]);const s={name:"linear"};return {kind:"composite",interpolationType:s,interpolationFactor:jr.interpolationFactor.bind(void 0,s),zoomStops:i.map((t=>t[0])),evaluate:({zoom:r},n)=>Pn({stops:i,base:t.base},e,r).evaluate(r,n)}}if(i){const r="exponential"===s?{name:"exponential",base:void 0!==t.base?t.base:1}:null;return {kind:"camera",interpolationType:r,interpolationFactor:jr.interpolationFactor.bind(void 0,r),zoomStops:t.stops.map((t=>t[0])),evaluate:({zoom:r})=>a(t,e,r,o,l)}}return {kind:"source",evaluate(r,n){const i=n&&n.properties?n.properties[t.property]:void 0;return void 0===i?Bn(t.default,e.default):a(t,e,i,o,l)}}}function Bn(t,e,r){return void 0!==t?t:void 0!==e?e:void 0!==r?r:void 0}function En(t,e,r,n,i){return Bn(typeof r===i?n[r]:void 0,t.default,e.default)}function Cn(t,e,r){if("number"!==In(r))return Bn(t.default,e.default);const n=t.stops.length;if(1===n)return t.stops[0][1];if(r<=t.stops[0][0])return t.stops[0][1];if(r>=t.stops[n-1][0])return t.stops[n-1][1];const i=yr(t.stops.map((t=>t[0])),r);return t.stops[i][1]}function Pn(t,e,r){const n=void 0!==t.base?t.base:1;if("number"!==In(r))return Bn(t.default,e.default);const i=t.stops.length;if(1===i)return t.stops[0][1];if(r<=t.stops[0][0])return t.stops[0][1];if(r>=t.stops[i-1][0])return t.stops[i-1][1];const s=yr(t.stops.map((t=>t[0])),r),a=function(t,e,r,n){const i=n-r,s=t-r;return 0===i?0:1===e?s/i:(Math.pow(e,s)-1)/(Math.pow(e,i)-1)}(r,n,t.stops[s][0],t.stops[s+1][0]),o=t.stops[s][1],l=t.stops[s+1][1];let u=br[e.type]||zn;if(t.colorSpace&&"rgb"!==t.colorSpace){const e=Lr[t.colorSpace];u=(t,r)=>e.reverse(e.interpolate(e.forward(t),e.forward(r),a));}return "function"==typeof o.evaluate?{evaluate(...t){const e=o.evaluate.apply(void 0,t),r=l.evaluate.apply(void 0,t);if(void 0!==e&&void 0!==r)return u(e,r,a)}}:u(o,l,a)}function Dn(t,e,r){return "color"===e.type?r=xe.parse(r):"formatted"===e.type?r=_e.fromString(r.toString()):"resolvedImage"===e.type?r=we.fromString(r.toString()):In(r)===e.type||"enum"===e.type&&e.values[r]||(r=void 0),Bn(r,t.default,e.default)}class Vn{constructor(t,e){this.expression=t,this._warningHistory={},this._evaluator=new Ue,this._defaultValue=e?function(t){return "color"===t.type&&(Mn(t.default)||Array.isArray(t.default))?new xe(0,0,0,0):"color"===t.type?xe.parse(t.default)||null:void 0===t.default?null:t.default}(e):null,this._enumValues=e&&"enum"===e.type?e.values:null;}evaluateWithoutErrorHandling(t,e,r,n,i,s,a,o){return this._evaluator.globals=t,this._evaluator.feature=e,this._evaluator.featureState=r,this._evaluator.canonical=n||null,this._evaluator.availableImages=i||null,this._evaluator.formattedSection=s,this._evaluator.featureTileCoord=a||null,this._evaluator.featureDistanceData=o||null,this.expression.evaluate(this._evaluator)}evaluate(t,e,r,n,i,s,a,o){this._evaluator.globals=t,this._evaluator.feature=e||null,this._evaluator.featureState=r||null,this._evaluator.canonical=n||null,this._evaluator.availableImages=i||null,this._evaluator.formattedSection=s||null,this._evaluator.featureTileCoord=a||null,this._evaluator.featureDistanceData=o||null;try{const t=this.expression.evaluate(this._evaluator);if(null==t||"number"==typeof t&&t!=t)return this._defaultValue;if(this._enumValues&&!(t in this._enumValues))throw new Te(`Expected value to be one of ${Object.keys(this._enumValues).map((t=>JSON.stringify(t))).join(", ")}, but found ${JSON.stringify(t)} instead.`);return t}catch(t){return this._warningHistory[t.message]||(this._warningHistory[t.message]=!0,"undefined"!=typeof console&&console.warn(t.message)),this._defaultValue}}}function Fn(t){return Array.isArray(t)&&t.length>0&&"string"==typeof t[0]&&t[0]in bn}function Ln(t,e){const r=new fr(bn,[],e?function(t){const e={color:ne,string:ee,number:te,enum:ee,boolean:re,formatted:oe,resolvedImage:le};return "array"===t.type?ue(e[t.value]||se,t.length):e[t.type]}(e):void 0),n=r.parse(t,void 0,void 0,void 0,e&&"string"===e.type?{typeAnnotation:"coerce"}:void 0);return n?_n(new Vn(n,e)):wn(r.errors)}class Rn{constructor(t,e){this.kind=t,this._styleExpression=e,this.isStateDependent="constant"!==t&&!lr(e.expression);}evaluateWithoutErrorHandling(t,e,r,n,i,s){return this._styleExpression.evaluateWithoutErrorHandling(t,e,r,n,i,s)}evaluate(t,e,r,n,i,s){return this._styleExpression.evaluate(t,e,r,n,i,s)}}class Un{constructor(t,e,r,n){this.kind=t,this.zoomStops=r,this._styleExpression=e,this.isStateDependent="camera"!==t&&!lr(e.expression),this.interpolationType=n;}evaluateWithoutErrorHandling(t,e,r,n,i,s){return this._styleExpression.evaluateWithoutErrorHandling(t,e,r,n,i,s)}evaluate(t,e,r,n,i,s){return this._styleExpression.evaluate(t,e,r,n,i,s)}interpolationFactor(t,e,r){return this.interpolationType?jr.interpolationFactor(this.interpolationType,t,e,r):0}}function jn(t,e){if("error"===(t=Ln(t,e)).result)return t;const r=t.value.expression,n=or(r);if(!n&&!An(e))return wn([new Yt("","data expressions not supported")]);const i=ur(r,["zoom","pitch","distance-from-center"]);if(!i&&!Sn(e))return wn([new Yt("","zoom expressions not supported")]);const s=On(r);return s||i?s instanceof Yt?wn([s]):s instanceof jr&&!kn(e)?wn([new Yt("",'"interpolate" expressions cannot be used with this property')]):_n(s?new Un(n?"camera":"composite",t.value,s.labels,s instanceof jr?s.interpolation:void 0):new Rn(n?"constant":"source",t.value)):wn([new Yt("",'"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression.')])}class $n{constructor(t,e){this._parameters=t,this._specification=e,Zt(this,Tn(this._parameters,this._specification));}static deserialize(t){return new $n(t._parameters,t._specification)}static serialize(t){return {_parameters:t._parameters,_specification:t._specification}}}function On(t){let e=null;if(t instanceof Nr)e=On(t.result);else if(t instanceof Or){for(const r of t.args)if(e=On(r),e)break}else (t instanceof gr||t instanceof jr)&&t.input instanceof $e&&"zoom"===t.input.name&&(e=t);return e instanceof Yt||t.eachChild((t=>{const r=On(t);r instanceof Yt?e=r:!e&&r?e=new Yt("",'"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression.'):e&&r&&e!==r&&(e=new Yt("",'Only one zoom-based "step" or "interpolate" subexpression may be used in an expression.'));})),e}class qn{constructor(t,e,r,n){this.message=(t?`${t}: `:"")+r,n&&(this.identifier=n),null!=e&&e.__line__&&(this.line=e.__line__);}}function Nn(t){const e=t.key,r=t.value,n=t.valueSpec||{},i=t.objectElementValidators||{},s=t.style,a=t.styleSpec;let o=[];const l=In(r);if("object"!==l)return [new qn(e,r,`object expected, ${l} found`)];for(const t in r){const l=t.split(".")[0],u=n[l]||n["*"];let c;i[l]?c=i[l]:n[l]?c=Ai:i["*"]?c=i["*"]:n["*"]&&(c=Ai),c?o=o.concat(c({key:(e?`${e}.`:e)+t,value:r[t],valueSpec:u,style:s,styleSpec:a,object:r,objectKey:t},r)):o.push(new qn(e,r[t],`unknown property "${t}"`));}for(const t in n)i[t]||n[t].required&&void 0===n[t].default&&void 0===r[t]&&o.push(new qn(e,r,`missing required property "${t}"`));return o}function Gn(t){const e=t.value,r=t.valueSpec,n=t.style,i=t.styleSpec,s=t.key,a=t.arrayElementValidator||Ai;if("array"!==In(e))return [new qn(s,e,`array expected, ${In(e)} found`)];if(r.length&&e.length!==r.length)return [new qn(s,e,`array length ${r.length} expected, length ${e.length} found`)];if(r["min-length"]&&e.length<r["min-length"])return [new qn(s,e,`array length at least ${r["min-length"]} expected, length ${e.length} found`)];let o={type:r.value,values:r.values,minimum:r.minimum,maximum:r.maximum,function:void 0};i.$version<7&&(o.function=r.function),"object"===In(r.value)&&(o=r.value);let l=[];for(let t=0;t<e.length;t++)l=l.concat(a({array:e,arrayIndex:t,value:e[t],valueSpec:o,style:n,styleSpec:i,key:`${s}[${t}]`}));return l}function Zn(t){const e=t.key,r=t.value,n=t.valueSpec;let i=In(r);if("number"===i&&r!=r&&(i="NaN"),"number"!==i)return [new qn(e,r,`number expected, ${i} found`)];if("minimum"in n){let i=n.minimum;if("array"===In(n.minimum)&&(i=n.minimum[t.arrayIndex]),r<i)return [new qn(e,r,`${r} is less than the minimum value ${i}`)]}if("maximum"in n){let i=n.maximum;if("array"===In(n.maximum)&&(i=n.maximum[t.arrayIndex]),r>i)return [new qn(e,r,`${r} is greater than the maximum value ${i}`)]}return []}function Xn(t){const e=t.valueSpec,r=Xt(t.value.type);let n,i,s,a={};const o="categorical"!==r&&void 0===t.value.property,l=!o,u="array"===In(t.value.stops)&&"array"===In(t.value.stops[0])&&"object"===In(t.value.stops[0][0]),c=Nn({key:t.key,value:t.value,valueSpec:t.styleSpec.function,style:t.style,styleSpec:t.styleSpec,objectElementValidators:{stops:function(t){if("identity"===r)return [new qn(t.key,t.value,'identity function may not have a "stops" property')];let e=[];const n=t.value;return e=e.concat(Gn({key:t.key,value:n,valueSpec:t.valueSpec,style:t.style,styleSpec:t.styleSpec,arrayElementValidator:h})),"array"===In(n)&&0===n.length&&e.push(new qn(t.key,n,"array must have at least one stop")),e},default:function(t){return Ai({key:t.key,value:t.value,valueSpec:e,style:t.style,styleSpec:t.styleSpec})}}});return "identity"===r&&o&&c.push(new qn(t.key,t.value,'missing required property "property"')),"identity"===r||t.value.stops||c.push(new qn(t.key,t.value,'missing required property "stops"')),"exponential"===r&&t.valueSpec.expression&&!kn(t.valueSpec)&&c.push(new qn(t.key,t.value,"exponential functions not supported")),t.styleSpec.$version>=8&&(l&&!An(t.valueSpec)?c.push(new qn(t.key,t.value,"property functions not supported")):o&&!Sn(t.valueSpec)&&c.push(new qn(t.key,t.value,"zoom functions not supported"))),"categorical"!==r&&!u||void 0!==t.value.property||c.push(new qn(t.key,t.value,'"property" property is required')),c;function h(t){let r=[];const n=t.value,o=t.key;if("array"!==In(n))return [new qn(o,n,`array expected, ${In(n)} found`)];if(2!==n.length)return [new qn(o,n,`array length 2 expected, length ${n.length} found`)];if(u){if("object"!==In(n[0]))return [new qn(o,n,`object expected, ${In(n[0])} found`)];if(void 0===n[0].zoom)return [new qn(o,n,"object stop key must have zoom")];if(void 0===n[0].value)return [new qn(o,n,"object stop key must have value")];const e=Xt(n[0].zoom);if("number"!=typeof e)return [new qn(o,n[0].zoom,"stop zoom values must be numbers")];if(s&&s>e)return [new qn(o,n[0].zoom,"stop zoom values must appear in ascending order")];e!==s&&(s=e,i=void 0,a={}),r=r.concat(Nn({key:`${o}[0]`,value:n[0],valueSpec:{zoom:{}},style:t.style,styleSpec:t.styleSpec,objectElementValidators:{zoom:Zn,value:p}}));}else r=r.concat(p({key:`${o}[0]`,value:n[0],valueSpec:{},style:t.style,styleSpec:t.styleSpec},n));return Fn(Kt(n[1]))?r.concat([new qn(`${o}[1]`,n[1],"expressions are not allowed in function stops.")]):r.concat(Ai({key:`${o}[1]`,value:n[1],valueSpec:e,style:t.style,styleSpec:t.styleSpec}))}function p(t,s){const o=In(t.value),l=Xt(t.value),u=null!==t.value?t.value:s;if(n){if(o!==n)return [new qn(t.key,u,`${o} stop domain type must match previous stop domain type ${n}`)]}else n=o;if("number"!==o&&"string"!==o&&"boolean"!==o&&"number"!=typeof l&&"string"!=typeof l&&"boolean"!=typeof l)return [new qn(t.key,u,"stop domain value must be a number, string, or boolean")];if("number"!==o&&"categorical"!==r){let n=`number expected, ${o} found`;return An(e)&&void 0===r&&(n+='\nIf you intended to use a categorical function, specify `"type": "categorical"`.'),[new qn(t.key,u,n)]}return "categorical"!==r||"number"!==o||"number"==typeof l&&isFinite(l)&&Math.floor(l)===l?"categorical"!==r&&"number"===o&&"number"==typeof l&&"number"==typeof i&&void 0!==i&&l<i?[new qn(t.key,u,"stop domain values must appear in ascending order")]:(i=l,"categorical"===r&&l in a?[new qn(t.key,u,"stop domain values must be unique")]:(a[l]=!0,[])):[new qn(t.key,u,`integer expected, found ${String(l)}`)]}}function Kn(t){const e=("property"===t.expressionContext?jn:Ln)(Kt(t.value),t.valueSpec);if("error"===e.result)return e.value.map((e=>new qn(`${t.key}${e.key}`,t.value,e.message)));const r=e.value.expression||e.value._styleExpression.expression;if("property"===t.expressionContext&&"text-font"===t.propertyKey&&!r.outputDefined())return [new qn(t.key,t.value,`Invalid data expression for "${t.propertyKey}". Output values must be contained as literals within the expression.`)];if("property"===t.expressionContext&&"layout"===t.propertyType&&!lr(r))return [new qn(t.key,t.value,'"feature-state" data expressions are not supported with layout properties.')];if("filter"===t.expressionContext)return Hn(r,t);if(t.expressionContext&&0===t.expressionContext.indexOf("cluster")){if(!ur(r,["zoom","feature-state"]))return [new qn(t.key,t.value,'"zoom" and "feature-state" expressions are not supported with cluster properties.')];if("cluster-initial"===t.expressionContext&&!or(r))return [new qn(t.key,t.value,"Feature data expressions are not supported with initial expression part of cluster properties.")]}return []}function Hn(t,e){const r=new Set(["zoom","feature-state","pitch","distance-from-center"]);if(e.valueSpec&&e.valueSpec.expression)for(const t of e.valueSpec.expression.parameters)r.delete(t);if(0===r.size)return [];const n=[];return t instanceof $e&&r.has(t.name)?[new qn(e.key,e.value,`["${t.name}"] expression is not supported in a filter for a ${e.object.type} layer with id: ${e.object.id}`)]:(t.eachChild((t=>{n.push(...Hn(t,e));})),n)}function Yn(t){const e=t.key,r=t.value,n=t.valueSpec,i=[];return Array.isArray(n.values)?-1===n.values.indexOf(Xt(r))&&i.push(new qn(e,r,`expected one of [${n.values.join(", ")}], ${JSON.stringify(r)} found`)):-1===Object.keys(n.values).indexOf(Xt(r))&&i.push(new qn(e,r,`expected one of [${Object.keys(n.values).join(", ")}], ${JSON.stringify(r)} found`)),i}function Wn(t){if(!0===t||!1===t)return !0;if(!Array.isArray(t)||0===t.length)return !1;switch(t[0]){case"has":return t.length>=2&&"$id"!==t[1]&&"$type"!==t[1];case"in":return t.length>=3&&("string"!=typeof t[1]||Array.isArray(t[2]));case"!in":case"!has":case"none":return !1;case"==":case"!=":case">":case">=":case"<":case"<=":return 3!==t.length||Array.isArray(t[1])||Array.isArray(t[2]);case"any":case"all":for(const e of t.slice(1))if(!Wn(e)&&"boolean"!=typeof e)return !1;return !0;default:return !0}}function Jn(t,e="fill"){if(null==t)return {filter:()=>!0,needGeometry:!1,needFeature:!1};Wn(t)||(t=si(t));const r=t;let n=!0;try{n=function(t){if(!ei(t))return t;let e=Kt(t);return ti(e),e=Qn(e),e}(r);}catch(t){console.warn(`Failed to extract static filter. Filter will continue working, but at higher memory usage and slower framerate.\nThis is most likely a bug, please report this via https://github.com/mapbox/mapbox-gl-js/issues/new?assignees=&labels=&template=Bug_report.md\nand paste the contents of this message in the report.\nThank you!\nFilter Expression:\n${JSON.stringify(r,null,2)}\n        `);}const i=Gt[`filter_${e}`],s=Ln(n,i);let a=null;if("error"===s.result)throw new Error(s.value.map((t=>`${t.key}: ${t.message}`)).join(", "));a=(t,e,r)=>s.value.evaluate(t,e,{},r);let o=null,l=null;if(n!==r){const t=Ln(r,i);if("error"===t.result)throw new Error(t.value.map((t=>`${t.key}: ${t.message}`)).join(", "));o=(e,r,n,i,s)=>t.value.evaluate(e,r,{},n,void 0,void 0,i,s),l=!or(t.value.expression);}return a=a,{filter:a,dynamicFilter:o||void 0,needGeometry:ii(n),needFeature:!!l}}function Qn(t){if(!Array.isArray(t))return t;const e=function(t){if(ri.has(t[0]))for(let e=1;e<t.length;e++)if(ei(t[e]))return !0;return t}(t);return !0===e?e:e.map((t=>Qn(t)))}function ti(t){let e=!1;const r=[];if("case"===t[0]){for(let n=1;n<t.length-1;n+=2)e=e||ei(t[n]),r.push(t[n+1]);r.push(t[t.length-1]);}else if("match"===t[0]){e=e||ei(t[1]);for(let e=2;e<t.length-1;e+=2)r.push(t[e+1]);r.push(t[t.length-1]);}else if("step"===t[0]){e=e||ei(t[1]);for(let e=1;e<t.length-1;e+=2)r.push(t[e+1]);}e&&(t.length=0,t.push("any",...r));for(let e=1;e<t.length;e++)ti(t[e]);}function ei(t){if(!Array.isArray(t))return !1;if("pitch"===(e=t[0])||"distance-from-center"===e)return !0;var e;for(let e=1;e<t.length;e++)if(ei(t[e]))return !0;return !1}const ri=new Set(["in","==","!=",">",">=","<","<=","to-boolean"]);function ni(t,e){return t<e?-1:t>e?1:0}function ii(t){if(!Array.isArray(t))return !1;if("within"===t[0])return !0;for(let e=1;e<t.length;e++)if(ii(t[e]))return !0;return !1}function si(t){if(!t)return !0;const e=t[0];return t.length<=1?"any"!==e:"=="===e?ai(t[1],t[2],"=="):"!="===e?ui(ai(t[1],t[2],"==")):"<"===e||">"===e||"<="===e||">="===e?ai(t[1],t[2],e):"any"===e?(r=t.slice(1),["any"].concat(r.map(si))):"all"===e?["all"].concat(t.slice(1).map(si)):"none"===e?["all"].concat(t.slice(1).map(si).map(ui)):"in"===e?oi(t[1],t.slice(2)):"!in"===e?ui(oi(t[1],t.slice(2))):"has"===e?li(t[1]):"!has"===e?ui(li(t[1])):"within"!==e||t;var r;}function ai(t,e,r){switch(t){case"$type":return [`filter-type-${r}`,e];case"$id":return [`filter-id-${r}`,e];default:return [`filter-${r}`,t,e]}}function oi(t,e){if(0===e.length)return !1;switch(t){case"$type":return ["filter-type-in",["literal",e]];case"$id":return ["filter-id-in",["literal",e]];default:return e.length>200&&!e.some((t=>typeof t!=typeof e[0]))?["filter-in-large",t,["literal",e.sort(ni)]]:["filter-in-small",t,["literal",e]]}}function li(t){switch(t){case"$type":return !0;case"$id":return ["filter-has-id"];default:return ["filter-has",t]}}function ui(t){return ["!",t]}function ci(t){return Wn(Kt(t.value))?Kn(Zt({},t,{expressionContext:"filter",valueSpec:t.styleSpec[`filter_${t.layerType||"fill"}`]})):hi(t)}function hi(t){const e=t.value,r=t.key;if("array"!==In(e))return [new qn(r,e,`array expected, ${In(e)} found`)];const n=t.styleSpec;let i,s=[];if(e.length<1)return [new qn(r,e,"filter array must have at least 1 element")];switch(s=s.concat(Yn({key:`${r}[0]`,value:e[0],valueSpec:n.filter_operator,style:t.style,styleSpec:t.styleSpec})),Xt(e[0])){case"<":case"<=":case">":case">=":e.length>=2&&"$type"===Xt(e[1])&&s.push(new qn(r,e,`"$type" cannot be use with operator "${e[0]}"`));case"==":case"!=":3!==e.length&&s.push(new qn(r,e,`filter array for operator "${e[0]}" must have 3 elements`));case"in":case"!in":e.length>=2&&(i=In(e[1]),"string"!==i&&s.push(new qn(`${r}[1]`,e[1],`string expected, ${i} found`)));for(let a=2;a<e.length;a++)i=In(e[a]),"$type"===Xt(e[1])?s=s.concat(Yn({key:`${r}[${a}]`,value:e[a],valueSpec:n.geometry_type,style:t.style,styleSpec:t.styleSpec})):"string"!==i&&"number"!==i&&"boolean"!==i&&s.push(new qn(`${r}[${a}]`,e[a],`string, number, or boolean expected, ${i} found`));break;case"any":case"all":case"none":for(let n=1;n<e.length;n++)s=s.concat(hi({key:`${r}[${n}]`,value:e[n],style:t.style,styleSpec:t.styleSpec}));break;case"has":case"!has":i=In(e[1]),2!==e.length?s.push(new qn(r,e,`filter array for "${e[0]}" operator must have 2 elements`)):"string"!==i&&s.push(new qn(`${r}[1]`,e[1],`string expected, ${i} found`));break;case"within":i=In(e[1]),2!==e.length?s.push(new qn(r,e,`filter array for "${e[0]}" operator must have 2 elements`)):"object"!==i&&s.push(new qn(`${r}[1]`,e[1],`object expected, ${i} found`));}return s}function pi(t,e){const r=t.key,n=t.style,i=t.styleSpec,s=t.value,a=t.objectKey,o=i[`${e}_${t.layerType}`];if(!o)return [];const l=a.match(/^(.*)-transition$/);if("paint"===e&&l&&o[l[1]]&&o[l[1]].transition)return Ai({key:r,value:s,valueSpec:i.transition,style:n,styleSpec:i});const u=t.valueSpec||o[a];if(!u)return [new qn(r,s,`unknown property "${a}"`)];let c;if("string"===In(s)&&An(u)&&!u.tokens&&(c=/^{([^}]+)}$/.exec(s)))return [new qn(r,s,`"${a}" does not support interpolation syntax\nUse an identity property function instead: \`{ "type": "identity", "property": ${JSON.stringify(c[1])} }\`.`)];const h=[];return "symbol"===t.layerType&&("text-field"===a&&n&&!n.glyphs&&h.push(new qn(r,s,'use of "text-field" requires a style "glyphs" property')),"text-font"===a&&Mn(Kt(s))&&"identity"===Xt(s.type)&&h.push(new qn(r,s,'"text-font" does not support identity functions'))),h.concat(Ai({key:t.key,value:s,valueSpec:u,style:n,styleSpec:i,expressionContext:"property",propertyType:e,propertyKey:a}))}function fi(t){return pi(t,"paint")}function di(t){return pi(t,"layout")}function yi(t){let e=[];const r=t.value,n=t.key,i=t.style,s=t.styleSpec;r.type||r.ref||e.push(new qn(n,r,'either "type" or "ref" is required'));let a=Xt(r.type);const o=Xt(r.ref);if(r.id){const s=Xt(r.id);for(let a=0;a<t.arrayIndex;a++){const t=i.layers[a];Xt(t.id)===s&&e.push(new qn(n,r.id,`duplicate layer id "${r.id}", previously used at line ${t.id.__line__}`));}}if("ref"in r){let t;["type","source","source-layer","filter","layout"].forEach((t=>{t in r&&e.push(new qn(n,r[t],`"${t}" is prohibited for ref layers`));})),i.layers.forEach((e=>{Xt(e.id)===o&&(t=e);})),t?t.ref?e.push(new qn(n,r.ref,"ref cannot reference another ref layer")):a=Xt(t.type):"string"==typeof o&&e.push(new qn(n,r.ref,`ref layer "${o}" not found`));}else if("background"!==a&&"sky"!==a)if(r.source){const t=i.sources&&i.sources[r.source],s=t&&Xt(t.type);t?"vector"===s&&"raster"===a?e.push(new qn(n,r.source,`layer "${r.id}" requires a raster source`)):"raster"===s&&"raster"!==a?e.push(new qn(n,r.source,`layer "${r.id}" requires a vector source`)):"vector"!==s||r["source-layer"]?"raster-dem"===s&&"hillshade"!==a?e.push(new qn(n,r.source,"raster-dem source can only be used with layer type 'hillshade'.")):"line"!==a||!r.paint||!r.paint["line-gradient"]&&!r.paint["line-trim-offset"]||"geojson"===s&&t.lineMetrics||e.push(new qn(n,r,`layer "${r.id}" specifies a line-gradient, which requires a GeoJSON source with \`lineMetrics\` enabled.`)):e.push(new qn(n,r,`layer "${r.id}" must specify a "source-layer"`)):e.push(new qn(n,r.source,`source "${r.source}" not found`));}else e.push(new qn(n,r,'missing required property "source"'));return e=e.concat(Nn({key:n,value:r,valueSpec:s.layer,style:t.style,styleSpec:t.styleSpec,objectElementValidators:{"*":()=>[],type:()=>Ai({key:`${n}.type`,value:r.type,valueSpec:s.layer.type,style:t.style,styleSpec:t.styleSpec,object:r,objectKey:"type"}),filter:t=>ci(Zt({layerType:a},t)),layout:t=>Nn({layer:r,key:t.key,value:t.value,valueSpec:{},style:t.style,styleSpec:t.styleSpec,objectElementValidators:{"*":t=>di(Zt({layerType:a},t))}}),paint:t=>Nn({layer:r,key:t.key,value:t.value,valueSpec:{},style:t.style,styleSpec:t.styleSpec,objectElementValidators:{"*":t=>fi(Zt({layerType:a},t))}})}})),e}function mi(t){const e=t.value,r=t.key,n=In(e);return "string"!==n?[new qn(r,e,`string expected, ${n} found`)]:[]}const gi={promoteId:function({key:t,value:e}){if("string"===In(e))return mi({key:t,value:e});{const r=[];for(const n in e)r.push(...mi({key:`${t}.${n}`,value:e[n]}));return r}}};function xi(t){const e=t.value,r=t.key,n=t.styleSpec,i=t.style;if(!e.type)return [new qn(r,e,'"type" is required')];const s=Xt(e.type);let a;switch(s){case"vector":case"raster":case"raster-dem":return a=Nn({key:r,value:e,valueSpec:n[`source_${s.replace("-","_")}`],style:t.style,styleSpec:n,objectElementValidators:gi}),a;case"geojson":if(a=Nn({key:r,value:e,valueSpec:n.source_geojson,style:i,styleSpec:n,objectElementValidators:gi}),e.cluster)for(const t in e.clusterProperties){const[n,i]=e.clusterProperties[t],s="string"==typeof n?[n,["accumulated"],["get",t]]:n;a.push(...Kn({key:`${r}.${t}.map`,value:i,expressionContext:"cluster-map"})),a.push(...Kn({key:`${r}.${t}.reduce`,value:s,expressionContext:"cluster-reduce"}));}return a;case"video":return Nn({key:r,value:e,valueSpec:n.source_video,style:i,styleSpec:n});case"image":return Nn({key:r,value:e,valueSpec:n.source_image,style:i,styleSpec:n});case"canvas":return [new qn(r,null,"Please use runtime APIs to add canvas sources, rather than including them in stylesheets.","source.canvas")];default:return Yn({key:`${r}.type`,value:e.type,valueSpec:{values:["vector","raster","raster-dem","geojson","video","image"]},style:i,styleSpec:n})}}function vi(t){const e=t.value,r=t.styleSpec,n=r.light,i=t.style;let s=[];const a=In(e);if(void 0===e)return s;if("object"!==a)return s=s.concat([new qn("light",e,`object expected, ${a} found`)]),s;for(const t in e){const a=t.match(/^(.*)-transition$/);s=s.concat(a&&n[a[1]]&&n[a[1]].transition?Ai({key:t,value:e[t],valueSpec:r.transition,style:i,styleSpec:r}):n[t]?Ai({key:t,value:e[t],valueSpec:n[t],style:i,styleSpec:r}):[new qn(t,e[t],`unknown property "${t}"`)]);}return s}function bi(t){const e=t.value,r=t.key,n=t.style,i=t.styleSpec,s=i.terrain;let a=[];const o=In(e);if(void 0===e)return a;if("object"!==o)return a=a.concat([new qn("terrain",e,`object expected, ${o} found`)]),a;for(const t in e){const r=t.match(/^(.*)-transition$/);a=a.concat(r&&s[r[1]]&&s[r[1]].transition?Ai({key:t,value:e[t],valueSpec:i.transition,style:n,styleSpec:i}):s[t]?Ai({key:t,value:e[t],valueSpec:s[t],style:n,styleSpec:i}):[new qn(t,e[t],`unknown property "${t}"`)]);}if(e.source){const t=n.sources&&n.sources[e.source],i=t&&Xt(t.type);t?"raster-dem"!==i&&a.push(new qn(r,e.source,`terrain cannot be used with a source of type ${String(i)}, it only be used with a "raster-dem" source type`)):a.push(new qn(r,e.source,`source "${e.source}" not found`));}else a.push(new qn(r,e,'terrain is missing required property "source"'));return a}function _i(t){const e=t.value,r=t.style,n=t.styleSpec,i=n.fog;let s=[];const a=In(e);if(void 0===e)return s;if("object"!==a)return s=s.concat([new qn("fog",e,`object expected, ${a} found`)]),s;for(const t in e){const a=t.match(/^(.*)-transition$/);s=s.concat(a&&i[a[1]]&&i[a[1]].transition?Ai({key:t,value:e[t],valueSpec:n.transition,style:r,styleSpec:n}):i[t]?Ai({key:t,value:e[t],valueSpec:i[t],style:r,styleSpec:n}):[new qn(t,e[t],`unknown property "${t}"`)]);}return s}const wi={"*":()=>[],array:Gn,boolean:function(t){const e=t.value,r=t.key,n=In(e);return "boolean"!==n?[new qn(r,e,`boolean expected, ${n} found`)]:[]},number:Zn,color:function(t){const e=t.key,r=t.value,n=In(r);return "string"!==n?[new qn(e,r,`color expected, ${n} found`)]:null===me.parseCSSColor(r)?[new qn(e,r,`color expected, "${r}" found`)]:[]},enum:Yn,filter:ci,function:Xn,layer:yi,object:Nn,source:xi,light:vi,terrain:bi,fog:_i,string:mi,formatted:function(t){return 0===mi(t).length?[]:Kn(t)},resolvedImage:function(t){return 0===mi(t).length?[]:Kn(t)},projection:function(t){const e=t.value,r=t.styleSpec,n=r.projection,i=t.style;let s=[];const a=In(e);if("object"===a)for(const t in e)s=s.concat(Ai({key:t,value:e[t],valueSpec:n[t],style:i,styleSpec:r}));else "string"!==a&&(s=s.concat([new qn("projection",e,`object or string expected, ${a} found`)]));return s}};function Ai(t){const e=t.value,r=t.valueSpec,n=t.styleSpec;return r.expression&&Mn(Xt(e))?Xn(t):r.expression&&Fn(Kt(e))?Kn(t):r.type&&wi[r.type]?wi[r.type](t):Nn(Zt({},t,{valueSpec:r.type?n[r.type]:r}))}function Si(t){const e=t.value,r=t.key,n=mi(t);return n.length||(-1===e.indexOf("{fontstack}")&&n.push(new qn(r,e,'"glyphs" url must include a "{fontstack}" token')),-1===e.indexOf("{range}")&&n.push(new qn(r,e,'"glyphs" url must include a "{range}" token'))),n}function ki(t,e=Gt){return zi(Ai({key:"",value:t,valueSpec:e.$root,styleSpec:e,style:t,objectElementValidators:{glyphs:Si,"*":()=>[]}}))}const Ii=t=>zi(fi(t)),Mi=t=>zi(di(t));function zi(t){return t.slice().sort(((t,e)=>t.line&&e.line?t.line-e.line:0))}function Ti(t,e){let r=!1;if(e&&e.length)for(const n of e)t.fire(new qt(new Error(n.message))),r=!0;return r}var Bi=Ei;function Ei(t,e,r){var n=this.cells=[];if(t instanceof ArrayBuffer){this.arrayBuffer=t;var i=new Int32Array(this.arrayBuffer);t=i[0],this.d=(e=i[1])+2*(r=i[2]);for(var s=0;s<this.d*this.d;s++){var a=i[3+s],o=i[3+s+1];n.push(a===o?null:i.subarray(a,o));}var l=i[3+n.length+1];this.keys=i.subarray(i[3+n.length],l),this.bboxes=i.subarray(l),this.insert=this._insertReadonly;}else {this.d=e+2*r;for(var u=0;u<this.d*this.d;u++)n.push([]);this.keys=[],this.bboxes=[];}this.n=e,this.extent=t,this.padding=r,this.scale=e/t,this.uid=0;var c=r/e*t;this.min=-c,this.max=t+c;}Ei.prototype.insert=function(t,e,r,n,i){this._forEachCell(e,r,n,i,this._insertCell,this.uid++),this.keys.push(t),this.bboxes.push(e),this.bboxes.push(r),this.bboxes.push(n),this.bboxes.push(i);},Ei.prototype._insertReadonly=function(){throw "Cannot insert into a GridIndex created from an ArrayBuffer."},Ei.prototype._insertCell=function(t,e,r,n,i,s){this.cells[i].push(s);},Ei.prototype.query=function(t,e,r,n,i){var s=this.min,a=this.max;if(t<=s&&e<=s&&a<=r&&a<=n&&!i)return Array.prototype.slice.call(this.keys);var o=[];return this._forEachCell(t,e,r,n,this._queryCell,o,{},i),o},Ei.prototype._queryCell=function(t,e,r,n,i,s,a,o){var l=this.cells[i];if(null!==l)for(var u=this.keys,c=this.bboxes,h=0;h<l.length;h++){var p=l[h];if(void 0===a[p]){var f=4*p;(o?o(c[f+0],c[f+1],c[f+2],c[f+3]):t<=c[f+2]&&e<=c[f+3]&&r>=c[f+0]&&n>=c[f+1])?(a[p]=!0,s.push(u[p])):a[p]=!1;}}},Ei.prototype._forEachCell=function(t,e,r,n,i,s,a,o){for(var l=this._convertToCellCoord(t),u=this._convertToCellCoord(e),c=this._convertToCellCoord(r),h=this._convertToCellCoord(n),p=l;p<=c;p++)for(var f=u;f<=h;f++){var d=this.d*f+p;if((!o||o(this._convertFromCellCoord(p),this._convertFromCellCoord(f),this._convertFromCellCoord(p+1),this._convertFromCellCoord(f+1)))&&i.call(this,t,e,r,n,d,s,a,o))return}},Ei.prototype._convertFromCellCoord=function(t){return (t-this.padding)/this.scale},Ei.prototype._convertToCellCoord=function(t){return Math.max(0,Math.min(this.d-1,Math.floor(t*this.scale)+this.padding))},Ei.prototype.toArrayBuffer=function(){if(this.arrayBuffer)return this.arrayBuffer;for(var t=this.cells,e=3+this.cells.length+1+1,r=0,n=0;n<this.cells.length;n++)r+=this.cells[n].length;var i=new Int32Array(e+r+this.keys.length+this.bboxes.length);i[0]=this.extent,i[1]=this.n,i[2]=this.padding;for(var s=e,a=0;a<t.length;a++){var o=t[a];i[3+a]=s,i.set(o,s),s+=o.length;}return i[3+t.length]=s,i.set(this.keys,s),i[3+t.length+1]=s+=this.keys.length,i.set(this.bboxes,s),s+=this.bboxes.length,i.buffer};const Ci={};function Pi(t,e,r={}){Object.defineProperty(t,"_classRegistryKey",{value:e,writeable:!1}),Ci[e]={klass:t,omit:r.omit||[]};}Pi(Object,"Object"),Bi.serialize=function(t,e){const r=t.toArrayBuffer();return e&&e.push(r),{buffer:r}},Bi.deserialize=function(t){return new Bi(t.buffer)},Object.defineProperty(Bi,"name",{value:"Grid"}),Pi(Bi,"Grid"),Pi(xe,"Color"),Pi(Error,"Error"),Pi(Tt,"AJAXError"),Pi(we,"ResolvedImage"),Pi($n,"StylePropertyFunction"),Pi(Vn,"StyleExpression",{omit:["_evaluator"]}),Pi(Un,"ZoomDependentExpression"),Pi(Rn,"ZoomConstantExpression"),Pi($e,"CompoundExpression",{omit:["_evaluate"]});for(const t in bn)Ci[bn[t]._classRegistryKey]||Pi(bn[t],`Expression${t}`);function Di(t){return t&&"undefined"!=typeof ArrayBuffer&&(t instanceof ArrayBuffer||t.constructor&&"ArrayBuffer"===t.constructor.name)}function Vi(t){return e.ImageBitmap&&t instanceof e.ImageBitmap}function Fi(t,r){if(null==t||"boolean"==typeof t||"number"==typeof t||"string"==typeof t||t instanceof Boolean||t instanceof Number||t instanceof String||t instanceof Date||t instanceof RegExp)return t;if(Di(t)||Vi(t))return r&&r.push(t),t;if(ArrayBuffer.isView(t)){const e=t;return r&&r.push(e.buffer),e}if(t instanceof e.ImageData)return r&&r.push(t.data.buffer),t;if(Array.isArray(t)){const e=[];for(const n of t)e.push(Fi(n,r));return e}if("object"==typeof t){const e=t.constructor,n=e._classRegistryKey;if(!n)throw new Error(`can't serialize object of unregistered class ${n}`);const i=e.serialize?e.serialize(t,r):{};if(!e.serialize){for(const e in t)t.hasOwnProperty(e)&&(Ci[n].omit.indexOf(e)>=0||(i[e]=Fi(t[e],r)));t instanceof Error&&(i.message=t.message);}if(i.$name)throw new Error("$name property is reserved for worker serialization logic.");return "Object"!==n&&(i.$name=n),i}throw new Error("can't serialize object of type "+typeof t)}function Li(t){if(null==t||"boolean"==typeof t||"number"==typeof t||"string"==typeof t||t instanceof Boolean||t instanceof Number||t instanceof String||t instanceof Date||t instanceof RegExp||Di(t)||Vi(t)||ArrayBuffer.isView(t)||t instanceof e.ImageData)return t;if(Array.isArray(t))return t.map(Li);if("object"==typeof t){const e=t.$name||"Object",{klass:r}=Ci[e];if(!r)throw new Error(`can't deserialize unregistered class ${e}`);if(r.deserialize)return r.deserialize(t);const n=Object.create(r.prototype);for(const e of Object.keys(t))"$name"!==e&&(n[e]=Li(t[e]));return n}throw new Error("can't deserialize object of type "+typeof t)}class Ri{constructor(){this.first=!0;}update(t,e){const r=Math.floor(t);return this.first?(this.first=!1,this.lastIntegerZoom=r,this.lastIntegerZoomTime=0,this.lastZoom=t,this.lastFloorZoom=r,!0):(this.lastFloorZoom>r?(this.lastIntegerZoom=r+1,this.lastIntegerZoomTime=e):this.lastFloorZoom<r&&(this.lastIntegerZoom=r,this.lastIntegerZoomTime=e),t!==this.lastZoom&&(this.lastZoom=t,this.lastFloorZoom=r,!0))}}const Ui=t=>t>=1536&&t<=1791,ji=t=>t>=1872&&t<=1919,$i=t=>t>=2208&&t<=2303,Oi=t=>t>=11904&&t<=12031,qi=t=>t>=12032&&t<=12255,Ni=t=>t>=12272&&t<=12287,Gi=t=>t>=12288&&t<=12351,Zi=t=>t>=12352&&t<=12447,Xi=t=>t>=12448&&t<=12543,Ki=t=>t>=12544&&t<=12591,Hi=t=>t>=12704&&t<=12735,Yi=t=>t>=12736&&t<=12783,Wi=t=>t>=12784&&t<=12799,Ji=t=>t>=12800&&t<=13055,Qi=t=>t>=13056&&t<=13311,ts=t=>t>=13312&&t<=19903,es=t=>t>=19968&&t<=40959,rs=t=>t>=40960&&t<=42127,ns=t=>t>=42128&&t<=42191,is=t=>t>=44032&&t<=55215,ss=t=>t>=63744&&t<=64255,as=t=>t>=64336&&t<=65023,os=t=>t>=65040&&t<=65055,ls=t=>t>=65072&&t<=65103,us=t=>t>=65104&&t<=65135,cs=t=>t>=65136&&t<=65279,hs=t=>t>=65280&&t<=65519;function ps(t){for(const e of t)if(ys(e.charCodeAt(0)))return !0;return !1}function fs(t){for(const e of t)if(!ds(e.charCodeAt(0)))return !1;return !0}function ds(t){return !(Ui(t)||ji(t)||$i(t)||as(t)||cs(t))}function ys(t){return !(746!==t&&747!==t&&(t<4352||!(Hi(t)||Ki(t)||ls(t)&&!(t>=65097&&t<=65103)||ss(t)||Qi(t)||Oi(t)||Yi(t)||!(!Gi(t)||t>=12296&&t<=12305||t>=12308&&t<=12319||12336===t)||ts(t)||es(t)||Ji(t)||(t=>t>=12592&&t<=12687)(t)||(t=>t>=43360&&t<=43391)(t)||(t=>t>=55216&&t<=55295)(t)||(t=>t>=4352&&t<=4607)(t)||is(t)||Zi(t)||Ni(t)||(t=>t>=12688&&t<=12703)(t)||qi(t)||Wi(t)||Xi(t)&&12540!==t||!(!hs(t)||65288===t||65289===t||65293===t||t>=65306&&t<=65310||65339===t||65341===t||65343===t||t>=65371&&t<=65503||65507===t||t>=65512&&t<=65519)||!(!us(t)||t>=65112&&t<=65118||t>=65123&&t<=65126)||(t=>t>=5120&&t<=5759)(t)||(t=>t>=6320&&t<=6399)(t)||os(t)||(t=>t>=19904&&t<=19967)(t)||rs(t)||ns(t))))}function ms(t){return !(ys(t)||function(t){return !!((t=>t>=128&&t<=255)(t)&&(167===t||169===t||174===t||177===t||188===t||189===t||190===t||215===t||247===t)||(t=>t>=8192&&t<=8303)(t)&&(8214===t||8224===t||8225===t||8240===t||8241===t||8251===t||8252===t||8258===t||8263===t||8264===t||8265===t||8273===t)||(t=>t>=8448&&t<=8527)(t)||(t=>t>=8528&&t<=8591)(t)||(t=>t>=8960&&t<=9215)(t)&&(t>=8960&&t<=8967||t>=8972&&t<=8991||t>=8996&&t<=9e3||9003===t||t>=9085&&t<=9114||t>=9150&&t<=9165||9167===t||t>=9169&&t<=9179||t>=9186&&t<=9215)||(t=>t>=9216&&t<=9279)(t)&&9251!==t||(t=>t>=9280&&t<=9311)(t)||(t=>t>=9312&&t<=9471)(t)||(t=>t>=9632&&t<=9727)(t)||(t=>t>=9728&&t<=9983)(t)&&!(t>=9754&&t<=9759)||(t=>t>=11008&&t<=11263)(t)&&(t>=11026&&t<=11055||t>=11088&&t<=11097||t>=11192&&t<=11243)||Gi(t)||Xi(t)||(t=>t>=57344&&t<=63743)(t)||ls(t)||us(t)||hs(t)||8734===t||8756===t||8757===t||t>=9984&&t<=10087||t>=10102&&t<=10131||65532===t||65533===t)}(t))}function gs(t){return t>=1424&&t<=2303||as(t)||cs(t)}function xs(t,e){return !(!e&&gs(t)||t>=2304&&t<=3583||t>=3840&&t<=4255||(t=>t>=6016&&t<=6143)(t))}function vs(t){for(const e of t)if(gs(e.charCodeAt(0)))return !0;return !1}const bs="deferred",_s="loading",ws="loaded";let As=null,Ss="unavailable",ks=null;const Is=function(t){t&&"string"==typeof t&&t.indexOf("NetworkError")>-1&&(Ss="error"),As&&As(t);};function Ms(){zs.fire(new Ot("pluginStateChange",{pluginStatus:Ss,pluginURL:ks}));}const zs=new Nt,Ts=function(){return Ss},Bs=function(){if(Ss!==bs||!ks)throw new Error("rtl-text-plugin cannot be downloaded unless a pluginURL is specified");Ss=_s,Ms(),ks&&Ct({url:ks},(t=>{t?Is(t):(Ss=ws,Ms());}));},Es={applyArabicShaping:null,processBidirectionalText:null,processStyledBidirectionalText:null,isLoaded:()=>Ss===ws||null!=Es.applyArabicShaping,isLoading:()=>Ss===_s,setState(t){Ss=t.pluginStatus,ks=t.pluginURL;},isParsed:()=>null!=Es.applyArabicShaping&&null!=Es.processBidirectionalText&&null!=Es.processStyledBidirectionalText,getPluginURL:()=>ks};class Cs{constructor(t,e){this.zoom=t,e?(this.now=e.now,this.fadeDuration=e.fadeDuration,this.zoomHistory=e.zoomHistory,this.transition=e.transition,this.pitch=e.pitch):(this.now=0,this.fadeDuration=0,this.zoomHistory=new Ri,this.transition={},this.pitch=0);}isSupportedScript(t){return function(t,e){for(const r of t)if(!xs(r.charCodeAt(0),e))return !1;return !0}(t,Es.isLoaded())}crossFadingFactor(){return 0===this.fadeDuration?1:Math.min((this.now-this.zoomHistory.lastIntegerZoomTime)/this.fadeDuration,1)}getCrossfadeParameters(){const t=this.zoom,e=t-Math.floor(t),r=this.crossFadingFactor();return t>this.zoomHistory.lastIntegerZoom?{fromScale:2,toScale:1,t:e+(1-e)*r}:{fromScale:.5,toScale:1,t:1-(1-r)*e}}}class Ps{constructor(t,e){this.property=t,this.value=e,this.expression=function(t,e){if(Mn(t))return new $n(t,e);if(Fn(t)){const r=jn(t,e);if("error"===r.result)throw new Error(r.value.map((t=>`${t.key}: ${t.message}`)).join(", "));return r.value}{let r=t;return "string"==typeof t&&"color"===e.type&&(r=xe.parse(t)),{kind:"constant",evaluate:()=>r}}}(void 0===e?t.specification.default:e,t.specification);}isDataDriven(){return "source"===this.expression.kind||"composite"===this.expression.kind}possiblyEvaluate(t,e,r){return this.property.possiblyEvaluate(this,t,e,r)}}class Ds{constructor(t){this.property=t,this.value=new Ps(t,void 0);}transitioned(t,e){return new Fs(this.property,this.value,e,v({},t.transition,this.transition),t.now)}untransitioned(){return new Fs(this.property,this.value,null,{},0)}}class Vs{constructor(t){this._properties=t,this._values=Object.create(t.defaultTransitionablePropertyValues);}getValue(t){return T(this._values[t].value.value)}setValue(t,e){this._values.hasOwnProperty(t)||(this._values[t]=new Ds(this._values[t].property)),this._values[t].value=new Ps(this._values[t].property,null===e?void 0:T(e));}getTransition(t){return T(this._values[t].transition)}setTransition(t,e){this._values.hasOwnProperty(t)||(this._values[t]=new Ds(this._values[t].property)),this._values[t].transition=T(e)||void 0;}serialize(){const t={};for(const e of Object.keys(this._values)){const r=this.getValue(e);void 0!==r&&(t[e]=r);const n=this.getTransition(e);void 0!==n&&(t[`${e}-transition`]=n);}return t}transitioned(t,e){const r=new Ls(this._properties);for(const n of Object.keys(this._values))r._values[n]=this._values[n].transitioned(t,e._values[n]);return r}untransitioned(){const t=new Ls(this._properties);for(const e of Object.keys(this._values))t._values[e]=this._values[e].untransitioned();return t}}class Fs{constructor(t,e,r,n,i){const s=n.delay||0,a=n.duration||0;i=i||0,this.property=t,this.value=e,this.begin=i+s,this.end=this.begin+a,t.specification.transition&&(n.delay||n.duration)&&(this.prior=r);}possiblyEvaluate(t,e,r){const n=t.now||0,i=this.value.possiblyEvaluate(t,e,r),s=this.prior;if(s){if(n>this.end)return this.prior=null,i;if(this.value.isDataDriven())return this.prior=null,i;if(n<this.begin)return s.possiblyEvaluate(t,e,r);{const a=(n-this.begin)/(this.end-this.begin);return this.property.interpolate(s.possiblyEvaluate(t,e,r),i,h(a))}}return i}}class Ls{constructor(t){this._properties=t,this._values=Object.create(t.defaultTransitioningPropertyValues);}possiblyEvaluate(t,e,r){const n=new js(this._properties);for(const i of Object.keys(this._values))n._values[i]=this._values[i].possiblyEvaluate(t,e,r);return n}hasTransition(){for(const t of Object.keys(this._values))if(this._values[t].prior)return !0;return !1}}class Rs{constructor(t){this._properties=t,this._values=Object.create(t.defaultPropertyValues);}getValue(t){return T(this._values[t].value)}setValue(t,e){this._values[t]=new Ps(this._values[t].property,null===e?void 0:T(e));}serialize(){const t={};for(const e of Object.keys(this._values)){const r=this.getValue(e);void 0!==r&&(t[e]=r);}return t}possiblyEvaluate(t,e,r){const n=new js(this._properties);for(const i of Object.keys(this._values))n._values[i]=this._values[i].possiblyEvaluate(t,e,r);return n}}class Us{constructor(t,e,r){this.property=t,this.value=e,this.parameters=r;}isConstant(){return "constant"===this.value.kind}constantOr(t){return "constant"===this.value.kind?this.value.value:t}evaluate(t,e,r,n){return this.property.evaluate(this.value,this.parameters,t,e,r,n)}}class js{constructor(t){this._properties=t,this._values=Object.create(t.defaultPossiblyEvaluatedValues);}get(t){return this._values[t]}}class $s{constructor(t){this.specification=t;}possiblyEvaluate(t,e){return t.expression.evaluate(e)}interpolate(t,e,r){const n=br[this.specification.type];return n?n(t,e,r):t}}class Os{constructor(t,e){this.specification=t,this.overrides=e;}possiblyEvaluate(t,e,r,n){return new Us(this,"constant"===t.expression.kind||"camera"===t.expression.kind?{kind:"constant",value:t.expression.evaluate(e,null,{},r,n)}:t.expression,e)}interpolate(t,e,r){if("constant"!==t.value.kind||"constant"!==e.value.kind)return t;if(void 0===t.value.value||void 0===e.value.value)return new Us(this,{kind:"constant",value:void 0},t.parameters);const n=br[this.specification.type];return n?new Us(this,{kind:"constant",value:n(t.value.value,e.value.value,r)},t.parameters):t}evaluate(t,e,r,n,i,s){return "constant"===t.kind?t.value:t.evaluate(e,r,n,i,s)}}class qs extends Os{possiblyEvaluate(t,e,r,n){if(void 0===t.value)return new Us(this,{kind:"constant",value:void 0},e);if("constant"===t.expression.kind){const i=t.expression.evaluate(e,null,{},r,n),s="resolvedImage"===t.property.specification.type&&"string"!=typeof i?i.name:i,a=this._calculate(s,s,s,e);return new Us(this,{kind:"constant",value:a},e)}if("camera"===t.expression.kind){const r=this._calculate(t.expression.evaluate({zoom:e.zoom-1}),t.expression.evaluate({zoom:e.zoom}),t.expression.evaluate({zoom:e.zoom+1}),e);return new Us(this,{kind:"constant",value:r},e)}return new Us(this,t.expression,e)}evaluate(t,e,r,n,i,s){if("source"===t.kind){const a=t.evaluate(e,r,n,i,s);return this._calculate(a,a,a,e)}return "composite"===t.kind?this._calculate(t.evaluate({zoom:Math.floor(e.zoom)-1},r,n),t.evaluate({zoom:Math.floor(e.zoom)},r,n),t.evaluate({zoom:Math.floor(e.zoom)+1},r,n),e):t.value}_calculate(t,e,r,n){return n.zoom>n.zoomHistory.lastIntegerZoom?{from:t,to:e,other:r}:{from:r,to:e,other:t}}interpolate(t){return t}}class Ns{constructor(t){this.specification=t;}possiblyEvaluate(t,e,r,n){if(void 0!==t.value){if("constant"===t.expression.kind){const i=t.expression.evaluate(e,null,{},r,n);return this._calculate(i,i,i,e)}return this._calculate(t.expression.evaluate(new Cs(Math.floor(e.zoom-1),e)),t.expression.evaluate(new Cs(Math.floor(e.zoom),e)),t.expression.evaluate(new Cs(Math.floor(e.zoom+1),e)),e)}}_calculate(t,e,r,n){return n.zoom>n.zoomHistory.lastIntegerZoom?{from:t,to:e}:{from:r,to:e}}interpolate(t){return t}}class Gs{constructor(t){this.specification=t;}possiblyEvaluate(t,e,r,n){return !!t.expression.evaluate(e,null,{},r,n)}interpolate(){return !1}}class Zs{constructor(t){this.properties=t,this.defaultPropertyValues={},this.defaultTransitionablePropertyValues={},this.defaultTransitioningPropertyValues={},this.defaultPossiblyEvaluatedValues={},this.overridableProperties=[];const e=new Cs(0,{});for(const r in t){const n=t[r];n.specification.overridable&&this.overridableProperties.push(r);const i=this.defaultPropertyValues[r]=new Ps(n,void 0),s=this.defaultTransitionablePropertyValues[r]=new Ds(n);this.defaultTransitioningPropertyValues[r]=s.untransitioned(),this.defaultPossiblyEvaluatedValues[r]=i.possiblyEvaluate(e);}}}function Xs(t,e){return 256*(t=d(Math.floor(t),0,255))+d(Math.floor(e),0,255)}Pi(Os,"DataDrivenProperty"),Pi($s,"DataConstantProperty"),Pi(qs,"CrossFadedDataDrivenProperty"),Pi(Ns,"CrossFadedProperty"),Pi(Gs,"ColorRampProperty");const Ks={Int8:Int8Array,Uint8:Uint8Array,Int16:Int16Array,Uint16:Uint16Array,Int32:Int32Array,Uint32:Uint32Array,Float32:Float32Array};class Hs{constructor(t,e){this._structArray=t,this._pos1=e*this.size,this._pos2=this._pos1/2,this._pos4=this._pos1/4,this._pos8=this._pos1/8;}}class Ys{constructor(){this.isTransferred=!1,this.capacity=-1,this.resize(0);}static serialize(t,e){return t._trim(),e&&(t.isTransferred=!0,e.push(t.arrayBuffer)),{length:t.length,arrayBuffer:t.arrayBuffer}}static deserialize(t){const e=Object.create(this.prototype);return e.arrayBuffer=t.arrayBuffer,e.length=t.length,e.capacity=t.arrayBuffer.byteLength/e.bytesPerElement,e._refreshViews(),e}_trim(){this.length!==this.capacity&&(this.capacity=this.length,this.arrayBuffer=this.arrayBuffer.slice(0,this.length*this.bytesPerElement),this._refreshViews());}clear(){this.length=0;}resize(t){this.reserve(t),this.length=t;}reserve(t){if(t>this.capacity){this.capacity=Math.max(t,Math.floor(5*this.capacity),128),this.arrayBuffer=new ArrayBuffer(this.capacity*this.bytesPerElement);const e=this.uint8;this._refreshViews(),e&&this.uint8.set(e);}}_refreshViews(){throw new Error("_refreshViews() must be implemented by each concrete StructArray layout")}destroy(){this.int8=this.uint8=this.int16=this.uint16=this.int32=this.uint32=this.float32=null,this.arrayBuffer=null;}}function Ws(t,e=1){let r=0,n=0;return {members:t.map((t=>{const i=Ks[t.type].BYTES_PER_ELEMENT,s=r=Js(r,Math.max(e,i)),a=t.components||1;return n=Math.max(n,i),r+=i*a,{name:t.name,type:t.type,components:a,offset:s}})),size:Js(r,Math.max(n,e)),alignment:e}}function Js(t,e){return Math.ceil(t/e)*e}class Qs extends Ys{_refreshViews(){this.uint8=new Uint8Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer);}emplaceBack(t,e){const r=this.length;return this.resize(r+1),this.emplace(r,t,e)}emplace(t,e,r){const n=2*t;return this.int16[n+0]=e,this.int16[n+1]=r,t}}Qs.prototype.bytesPerElement=4,Pi(Qs,"StructArrayLayout2i4");class ta extends Ys{_refreshViews(){this.uint8=new Uint8Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer);}emplaceBack(t,e,r){const n=this.length;return this.resize(n+1),this.emplace(n,t,e,r)}emplace(t,e,r,n){const i=3*t;return this.int16[i+0]=e,this.int16[i+1]=r,this.int16[i+2]=n,t}}ta.prototype.bytesPerElement=6,Pi(ta,"StructArrayLayout3i6");class ea extends Ys{_refreshViews(){this.uint8=new Uint8Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer);}emplaceBack(t,e,r,n){const i=this.length;return this.resize(i+1),this.emplace(i,t,e,r,n)}emplace(t,e,r,n,i){const s=4*t;return this.int16[s+0]=e,this.int16[s+1]=r,this.int16[s+2]=n,this.int16[s+3]=i,t}}ea.prototype.bytesPerElement=8,Pi(ea,"StructArrayLayout4i8");class ra extends Ys{_refreshViews(){this.uint8=new Uint8Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer),this.float32=new Float32Array(this.arrayBuffer);}emplaceBack(t,e,r,n,i,s,a){const o=this.length;return this.resize(o+1),this.emplace(o,t,e,r,n,i,s,a)}emplace(t,e,r,n,i,s,a,o){const l=6*t,u=12*t,c=3*t;return this.int16[l+0]=e,this.int16[l+1]=r,this.uint8[u+4]=n,this.uint8[u+5]=i,this.uint8[u+6]=s,this.uint8[u+7]=a,this.float32[c+2]=o,t}}ra.prototype.bytesPerElement=12,Pi(ra,"StructArrayLayout2i4ub1f12");class na extends Ys{_refreshViews(){this.uint8=new Uint8Array(this.arrayBuffer),this.float32=new Float32Array(this.arrayBuffer);}emplaceBack(t,e,r,n){const i=this.length;return this.resize(i+1),this.emplace(i,t,e,r,n)}emplace(t,e,r,n,i){const s=4*t;return this.float32[s+0]=e,this.float32[s+1]=r,this.float32[s+2]=n,this.float32[s+3]=i,t}}na.prototype.bytesPerElement=16,Pi(na,"StructArrayLayout4f16");class ia extends Ys{_refreshViews(){this.uint8=new Uint8Array(this.arrayBuffer),this.uint16=new Uint16Array(this.arrayBuffer);}emplaceBack(t,e,r,n,i,s,a,o,l,u){const c=this.length;return this.resize(c+1),this.emplace(c,t,e,r,n,i,s,a,o,l,u)}emplace(t,e,r,n,i,s,a,o,l,u,c){const h=10*t;return this.uint16[h+0]=e,this.uint16[h+1]=r,this.uint16[h+2]=n,this.uint16[h+3]=i,this.uint16[h+4]=s,this.uint16[h+5]=a,this.uint16[h+6]=o,this.uint16[h+7]=l,this.uint16[h+8]=u,this.uint16[h+9]=c,t}}ia.prototype.bytesPerElement=20,Pi(ia,"StructArrayLayout10ui20");class sa extends Ys{_refreshViews(){this.uint8=new Uint8Array(this.arrayBuffer),this.uint16=new Uint16Array(this.arrayBuffer);}emplaceBack(t,e,r,n,i,s,a,o){const l=this.length;return this.resize(l+1),this.emplace(l,t,e,r,n,i,s,a,o)}emplace(t,e,r,n,i,s,a,o,l){const u=8*t;return this.uint16[u+0]=e,this.uint16[u+1]=r,this.uint16[u+2]=n,this.uint16[u+3]=i,this.uint16[u+4]=s,this.uint16[u+5]=a,this.uint16[u+6]=o,this.uint16[u+7]=l,t}}sa.prototype.bytesPerElement=16,Pi(sa,"StructArrayLayout8ui16");class aa extends Ys{_refreshViews(){this.uint8=new Uint8Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer);}emplaceBack(t,e,r,n,i,s){const a=this.length;return this.resize(a+1),this.emplace(a,t,e,r,n,i,s)}emplace(t,e,r,n,i,s,a){const o=6*t;return this.int16[o+0]=e,this.int16[o+1]=r,this.int16[o+2]=n,this.int16[o+3]=i,this.int16[o+4]=s,this.int16[o+5]=a,t}}aa.prototype.bytesPerElement=12,Pi(aa,"StructArrayLayout6i12");class oa extends Ys{_refreshViews(){this.uint8=new Uint8Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer),this.uint16=new Uint16Array(this.arrayBuffer);}emplaceBack(t,e,r,n,i,s,a,o,l,u,c,h){const p=this.length;return this.resize(p+1),this.emplace(p,t,e,r,n,i,s,a,o,l,u,c,h)}emplace(t,e,r,n,i,s,a,o,l,u,c,h,p){const f=12*t;return this.int16[f+0]=e,this.int16[f+1]=r,this.int16[f+2]=n,this.int16[f+3]=i,this.uint16[f+4]=s,this.uint16[f+5]=a,this.uint16[f+6]=o,this.uint16[f+7]=l,this.int16[f+8]=u,this.int16[f+9]=c,this.int16[f+10]=h,this.int16[f+11]=p,t}}oa.prototype.bytesPerElement=24,Pi(oa,"StructArrayLayout4i4ui4i24");class la extends Ys{_refreshViews(){this.uint8=new Uint8Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer),this.float32=new Float32Array(this.arrayBuffer);}emplaceBack(t,e,r,n,i,s){const a=this.length;return this.resize(a+1),this.emplace(a,t,e,r,n,i,s)}emplace(t,e,r,n,i,s,a){const o=10*t,l=5*t;return this.int16[o+0]=e,this.int16[o+1]=r,this.int16[o+2]=n,this.float32[l+2]=i,this.float32[l+3]=s,this.float32[l+4]=a,t}}la.prototype.bytesPerElement=20,Pi(la,"StructArrayLayout3i3f20");class ua extends Ys{_refreshViews(){this.uint8=new Uint8Array(this.arrayBuffer),this.uint32=new Uint32Array(this.arrayBuffer);}emplaceBack(t){const e=this.length;return this.resize(e+1),this.emplace(e,t)}emplace(t,e){return this.uint32[1*t+0]=e,t}}ua.prototype.bytesPerElement=4,Pi(ua,"StructArrayLayout1ul4");class ca extends Ys{_refreshViews(){this.uint8=new Uint8Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer),this.float32=new Float32Array(this.arrayBuffer),this.uint32=new Uint32Array(this.arrayBuffer),this.uint16=new Uint16Array(this.arrayBuffer);}emplaceBack(t,e,r,n,i,s,a,o,l,u,c,h,p){const f=this.length;return this.resize(f+1),this.emplace(f,t,e,r,n,i,s,a,o,l,u,c,h,p)}emplace(t,e,r,n,i,s,a,o,l,u,c,h,p,f){const d=20*t,y=10*t;return this.int16[d+0]=e,this.int16[d+1]=r,this.int16[d+2]=n,this.int16[d+3]=i,this.int16[d+4]=s,this.float32[y+3]=a,this.float32[y+4]=o,this.float32[y+5]=l,this.float32[y+6]=u,this.int16[d+14]=c,this.uint32[y+8]=h,this.uint16[d+18]=p,this.uint16[d+19]=f,t}}ca.prototype.bytesPerElement=40,Pi(ca,"StructArrayLayout5i4f1i1ul2ui40");class ha extends Ys{_refreshViews(){this.uint8=new Uint8Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer);}emplaceBack(t,e,r,n,i,s,a){const o=this.length;return this.resize(o+1),this.emplace(o,t,e,r,n,i,s,a)}emplace(t,e,r,n,i,s,a,o){const l=8*t;return this.int16[l+0]=e,this.int16[l+1]=r,this.int16[l+2]=n,this.int16[l+4]=i,this.int16[l+5]=s,this.int16[l+6]=a,this.int16[l+7]=o,t}}ha.prototype.bytesPerElement=16,Pi(ha,"StructArrayLayout3i2i2i16");class pa extends Ys{_refreshViews(){this.uint8=new Uint8Array(this.arrayBuffer),this.float32=new Float32Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer);}emplaceBack(t,e,r,n,i){const s=this.length;return this.resize(s+1),this.emplace(s,t,e,r,n,i)}emplace(t,e,r,n,i,s){const a=4*t,o=8*t;return this.float32[a+0]=e,this.float32[a+1]=r,this.float32[a+2]=n,this.int16[o+6]=i,this.int16[o+7]=s,t}}pa.prototype.bytesPerElement=16,Pi(pa,"StructArrayLayout2f1f2i16");class fa extends Ys{_refreshViews(){this.uint8=new Uint8Array(this.arrayBuffer),this.float32=new Float32Array(this.arrayBuffer);}emplaceBack(t,e,r,n){const i=this.length;return this.resize(i+1),this.emplace(i,t,e,r,n)}emplace(t,e,r,n,i){const s=12*t,a=3*t;return this.uint8[s+0]=e,this.uint8[s+1]=r,this.float32[a+1]=n,this.float32[a+2]=i,t}}fa.prototype.bytesPerElement=12,Pi(fa,"StructArrayLayout2ub2f12");class da extends Ys{_refreshViews(){this.uint8=new Uint8Array(this.arrayBuffer),this.float32=new Float32Array(this.arrayBuffer);}emplaceBack(t,e,r){const n=this.length;return this.resize(n+1),this.emplace(n,t,e,r)}emplace(t,e,r,n){const i=3*t;return this.float32[i+0]=e,this.float32[i+1]=r,this.float32[i+2]=n,t}}da.prototype.bytesPerElement=12,Pi(da,"StructArrayLayout3f12");class ya extends Ys{_refreshViews(){this.uint8=new Uint8Array(this.arrayBuffer),this.uint16=new Uint16Array(this.arrayBuffer);}emplaceBack(t,e,r){const n=this.length;return this.resize(n+1),this.emplace(n,t,e,r)}emplace(t,e,r,n){const i=3*t;return this.uint16[i+0]=e,this.uint16[i+1]=r,this.uint16[i+2]=n,t}}ya.prototype.bytesPerElement=6,Pi(ya,"StructArrayLayout3ui6");class ma extends Ys{_refreshViews(){this.uint8=new Uint8Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer),this.float32=new Float32Array(this.arrayBuffer),this.uint16=new Uint16Array(this.arrayBuffer),this.uint32=new Uint32Array(this.arrayBuffer);}emplaceBack(t,e,r,n,i,s,a,o,l,u,c,h,p,f,d,y,m,g,x,v,b){const _=this.length;return this.resize(_+1),this.emplace(_,t,e,r,n,i,s,a,o,l,u,c,h,p,f,d,y,m,g,x,v,b)}emplace(t,e,r,n,i,s,a,o,l,u,c,h,p,f,d,y,m,g,x,v,b,_){const w=30*t,A=15*t,S=60*t;return this.int16[w+0]=e,this.int16[w+1]=r,this.int16[w+2]=n,this.float32[A+2]=i,this.float32[A+3]=s,this.uint16[w+8]=a,this.uint16[w+9]=o,this.uint32[A+5]=l,this.uint32[A+6]=u,this.uint32[A+7]=c,this.uint16[w+16]=h,this.uint16[w+17]=p,this.uint16[w+18]=f,this.float32[A+10]=d,this.float32[A+11]=y,this.uint8[S+48]=m,this.uint8[S+49]=g,this.uint8[S+50]=x,this.uint32[A+13]=v,this.int16[w+28]=b,this.uint8[S+58]=_,t}}ma.prototype.bytesPerElement=60,Pi(ma,"StructArrayLayout3i2f2ui3ul3ui2f3ub1ul1i1ub60");class ga extends Ys{_refreshViews(){this.uint8=new Uint8Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer),this.float32=new Float32Array(this.arrayBuffer),this.uint16=new Uint16Array(this.arrayBuffer),this.uint32=new Uint32Array(this.arrayBuffer);}emplaceBack(t,e,r,n,i,s,a,o,l,u,c,h,p,f,d,y,m,g,x,v,b,_,w,A,S,k,I,M,z,T){const B=this.length;return this.resize(B+1),this.emplace(B,t,e,r,n,i,s,a,o,l,u,c,h,p,f,d,y,m,g,x,v,b,_,w,A,S,k,I,M,z,T)}emplace(t,e,r,n,i,s,a,o,l,u,c,h,p,f,d,y,m,g,x,v,b,_,w,A,S,k,I,M,z,T,B){const E=38*t,C=19*t;return this.int16[E+0]=e,this.int16[E+1]=r,this.int16[E+2]=n,this.float32[C+2]=i,this.float32[C+3]=s,this.int16[E+8]=a,this.int16[E+9]=o,this.int16[E+10]=l,this.int16[E+11]=u,this.int16[E+12]=c,this.int16[E+13]=h,this.uint16[E+14]=p,this.uint16[E+15]=f,this.uint16[E+16]=d,this.uint16[E+17]=y,this.uint16[E+18]=m,this.uint16[E+19]=g,this.uint16[E+20]=x,this.uint16[E+21]=v,this.uint16[E+22]=b,this.uint16[E+23]=_,this.uint16[E+24]=w,this.uint16[E+25]=A,this.uint16[E+26]=S,this.uint16[E+27]=k,this.uint16[E+28]=I,this.uint32[C+15]=M,this.float32[C+16]=z,this.float32[C+17]=T,this.float32[C+18]=B,t}}ga.prototype.bytesPerElement=76,Pi(ga,"StructArrayLayout3i2f6i15ui1ul3f76");class xa extends Ys{_refreshViews(){this.uint8=new Uint8Array(this.arrayBuffer),this.float32=new Float32Array(this.arrayBuffer);}emplaceBack(t){const e=this.length;return this.resize(e+1),this.emplace(e,t)}emplace(t,e){return this.float32[1*t+0]=e,t}}xa.prototype.bytesPerElement=4,Pi(xa,"StructArrayLayout1f4");class va extends Ys{_refreshViews(){this.uint8=new Uint8Array(this.arrayBuffer),this.float32=new Float32Array(this.arrayBuffer);}emplaceBack(t,e,r,n,i){const s=this.length;return this.resize(s+1),this.emplace(s,t,e,r,n,i)}emplace(t,e,r,n,i,s){const a=5*t;return this.float32[a+0]=e,this.float32[a+1]=r,this.float32[a+2]=n,this.float32[a+3]=i,this.float32[a+4]=s,t}}va.prototype.bytesPerElement=20,Pi(va,"StructArrayLayout5f20");class ba extends Ys{_refreshViews(){this.uint8=new Uint8Array(this.arrayBuffer),this.uint32=new Uint32Array(this.arrayBuffer),this.uint16=new Uint16Array(this.arrayBuffer);}emplaceBack(t,e,r,n){const i=this.length;return this.resize(i+1),this.emplace(i,t,e,r,n)}emplace(t,e,r,n,i){const s=6*t;return this.uint32[3*t+0]=e,this.uint16[s+2]=r,this.uint16[s+3]=n,this.uint16[s+4]=i,t}}ba.prototype.bytesPerElement=12,Pi(ba,"StructArrayLayout1ul3ui12");class _a extends Ys{_refreshViews(){this.uint8=new Uint8Array(this.arrayBuffer),this.uint16=new Uint16Array(this.arrayBuffer);}emplaceBack(t,e){const r=this.length;return this.resize(r+1),this.emplace(r,t,e)}emplace(t,e,r){const n=2*t;return this.uint16[n+0]=e,this.uint16[n+1]=r,t}}_a.prototype.bytesPerElement=4,Pi(_a,"StructArrayLayout2ui4");class wa extends Ys{_refreshViews(){this.uint8=new Uint8Array(this.arrayBuffer),this.uint16=new Uint16Array(this.arrayBuffer);}emplaceBack(t){const e=this.length;return this.resize(e+1),this.emplace(e,t)}emplace(t,e){return this.uint16[1*t+0]=e,t}}wa.prototype.bytesPerElement=2,Pi(wa,"StructArrayLayout1ui2");class Aa extends Ys{_refreshViews(){this.uint8=new Uint8Array(this.arrayBuffer),this.float32=new Float32Array(this.arrayBuffer);}emplaceBack(t,e){const r=this.length;return this.resize(r+1),this.emplace(r,t,e)}emplace(t,e,r){const n=2*t;return this.float32[n+0]=e,this.float32[n+1]=r,t}}Aa.prototype.bytesPerElement=8,Pi(Aa,"StructArrayLayout2f8");class Sa extends Hs{get a_pos_30(){return this._structArray.int16[this._pos2+0]}get a_pos_31(){return this._structArray.int16[this._pos2+1]}get a_pos_32(){return this._structArray.int16[this._pos2+2]}get a_pos_normal_30(){return this._structArray.int16[this._pos2+3]}get a_pos_normal_31(){return this._structArray.int16[this._pos2+4]}get a_pos_normal_32(){return this._structArray.int16[this._pos2+5]}}Sa.prototype.size=12;class ka extends aa{get(t){return new Sa(this,t)}}Pi(ka,"FillExtrusionExtArray");class Ia extends Hs{get projectedAnchorX(){return this._structArray.int16[this._pos2+0]}get projectedAnchorY(){return this._structArray.int16[this._pos2+1]}get projectedAnchorZ(){return this._structArray.int16[this._pos2+2]}get tileAnchorX(){return this._structArray.int16[this._pos2+3]}get tileAnchorY(){return this._structArray.int16[this._pos2+4]}get x1(){return this._structArray.float32[this._pos4+3]}get y1(){return this._structArray.float32[this._pos4+4]}get x2(){return this._structArray.float32[this._pos4+5]}get y2(){return this._structArray.float32[this._pos4+6]}get padding(){return this._structArray.int16[this._pos2+14]}get featureIndex(){return this._structArray.uint32[this._pos4+8]}get sourceLayerIndex(){return this._structArray.uint16[this._pos2+18]}get bucketIndex(){return this._structArray.uint16[this._pos2+19]}}Ia.prototype.size=40;class Ma extends ca{get(t){return new Ia(this,t)}}Pi(Ma,"CollisionBoxArray");class za extends Hs{get projectedAnchorX(){return this._structArray.int16[this._pos2+0]}get projectedAnchorY(){return this._structArray.int16[this._pos2+1]}get projectedAnchorZ(){return this._structArray.int16[this._pos2+2]}get tileAnchorX(){return this._structArray.float32[this._pos4+2]}get tileAnchorY(){return this._structArray.float32[this._pos4+3]}get glyphStartIndex(){return this._structArray.uint16[this._pos2+8]}get numGlyphs(){return this._structArray.uint16[this._pos2+9]}get vertexStartIndex(){return this._structArray.uint32[this._pos4+5]}get lineStartIndex(){return this._structArray.uint32[this._pos4+6]}get lineLength(){return this._structArray.uint32[this._pos4+7]}get segment(){return this._structArray.uint16[this._pos2+16]}get lowerSize(){return this._structArray.uint16[this._pos2+17]}get upperSize(){return this._structArray.uint16[this._pos2+18]}get lineOffsetX(){return this._structArray.float32[this._pos4+10]}get lineOffsetY(){return this._structArray.float32[this._pos4+11]}get writingMode(){return this._structArray.uint8[this._pos1+48]}get placedOrientation(){return this._structArray.uint8[this._pos1+49]}set placedOrientation(t){this._structArray.uint8[this._pos1+49]=t;}get hidden(){return this._structArray.uint8[this._pos1+50]}set hidden(t){this._structArray.uint8[this._pos1+50]=t;}get crossTileID(){return this._structArray.uint32[this._pos4+13]}set crossTileID(t){this._structArray.uint32[this._pos4+13]=t;}get associatedIconIndex(){return this._structArray.int16[this._pos2+28]}get flipState(){return this._structArray.uint8[this._pos1+58]}set flipState(t){this._structArray.uint8[this._pos1+58]=t;}}za.prototype.size=60;class Ta extends ma{get(t){return new za(this,t)}}Pi(Ta,"PlacedSymbolArray");class Ba extends Hs{get projectedAnchorX(){return this._structArray.int16[this._pos2+0]}get projectedAnchorY(){return this._structArray.int16[this._pos2+1]}get projectedAnchorZ(){return this._structArray.int16[this._pos2+2]}get tileAnchorX(){return this._structArray.float32[this._pos4+2]}get tileAnchorY(){return this._structArray.float32[this._pos4+3]}get rightJustifiedTextSymbolIndex(){return this._structArray.int16[this._pos2+8]}get centerJustifiedTextSymbolIndex(){return this._structArray.int16[this._pos2+9]}get leftJustifiedTextSymbolIndex(){return this._structArray.int16[this._pos2+10]}get verticalPlacedTextSymbolIndex(){return this._structArray.int16[this._pos2+11]}get placedIconSymbolIndex(){return this._structArray.int16[this._pos2+12]}get verticalPlacedIconSymbolIndex(){return this._structArray.int16[this._pos2+13]}get key(){return this._structArray.uint16[this._pos2+14]}get textBoxStartIndex(){return this._structArray.uint16[this._pos2+15]}get textBoxEndIndex(){return this._structArray.uint16[this._pos2+16]}get verticalTextBoxStartIndex(){return this._structArray.uint16[this._pos2+17]}get verticalTextBoxEndIndex(){return this._structArray.uint16[this._pos2+18]}get iconBoxStartIndex(){return this._structArray.uint16[this._pos2+19]}get iconBoxEndIndex(){return this._structArray.uint16[this._pos2+20]}get verticalIconBoxStartIndex(){return this._structArray.uint16[this._pos2+21]}get verticalIconBoxEndIndex(){return this._structArray.uint16[this._pos2+22]}get featureIndex(){return this._structArray.uint16[this._pos2+23]}get numHorizontalGlyphVertices(){return this._structArray.uint16[this._pos2+24]}get numVerticalGlyphVertices(){return this._structArray.uint16[this._pos2+25]}get numIconVertices(){return this._structArray.uint16[this._pos2+26]}get numVerticalIconVertices(){return this._structArray.uint16[this._pos2+27]}get useRuntimeCollisionCircles(){return this._structArray.uint16[this._pos2+28]}get crossTileID(){return this._structArray.uint32[this._pos4+15]}set crossTileID(t){this._structArray.uint32[this._pos4+15]=t;}get textOffset0(){return this._structArray.float32[this._pos4+16]}get textOffset1(){return this._structArray.float32[this._pos4+17]}get collisionCircleDiameter(){return this._structArray.float32[this._pos4+18]}}Ba.prototype.size=76;class Ea extends ga{get(t){return new Ba(this,t)}}Pi(Ea,"SymbolInstanceArray");class Ca extends xa{getoffsetX(t){return this.float32[1*t+0]}}Pi(Ca,"GlyphOffsetArray");class Pa extends ta{getx(t){return this.int16[3*t+0]}gety(t){return this.int16[3*t+1]}gettileUnitDistanceFromAnchor(t){return this.int16[3*t+2]}}Pi(Pa,"SymbolLineVertexArray");class Da extends Hs{get featureIndex(){return this._structArray.uint32[this._pos4+0]}get sourceLayerIndex(){return this._structArray.uint16[this._pos2+2]}get bucketIndex(){return this._structArray.uint16[this._pos2+3]}get layoutVertexArrayOffset(){return this._structArray.uint16[this._pos2+4]}}Da.prototype.size=12;class Va extends ba{get(t){return new Da(this,t)}}Pi(Va,"FeatureIndexArray");class Fa extends Hs{get a_centroid_pos0(){return this._structArray.uint16[this._pos2+0]}get a_centroid_pos1(){return this._structArray.uint16[this._pos2+1]}}Fa.prototype.size=4;class La extends _a{get(t){return new Fa(this,t)}}Pi(La,"FillExtrusionCentroidArray");class Ra extends Hs{get a_pos_30(){return this._structArray.int16[this._pos2+0]}get a_pos_31(){return this._structArray.int16[this._pos2+1]}get a_pos_32(){return this._structArray.int16[this._pos2+2]}get a_pos_normal_30(){return this._structArray.int16[this._pos2+3]}get a_pos_normal_31(){return this._structArray.int16[this._pos2+4]}get a_pos_normal_32(){return this._structArray.int16[this._pos2+5]}}Ra.prototype.size=12;class Ua extends aa{get(t){return new Ra(this,t)}}Pi(Ua,"CircleGlobeExtArray");const ja=Ws([{name:"a_pattern_to",components:4,type:"Uint16"},{name:"a_pattern_from",components:4,type:"Uint16"},{name:"a_pixel_ratio_to",components:1,type:"Uint16"},{name:"a_pixel_ratio_from",components:1,type:"Uint16"}]),$a=Ws([{name:"a_dash_to",components:4,type:"Uint16"},{name:"a_dash_from",components:4,type:"Uint16"}]);var Oa=ye((function(t){t.exports=function(t,e){var r,n,i,s,a,o,l,u;for(n=t.length-(r=3&t.length),i=e,a=3432918353,o=461845907,u=0;u<n;)l=255&t.charCodeAt(u)|(255&t.charCodeAt(++u))<<8|(255&t.charCodeAt(++u))<<16|(255&t.charCodeAt(++u))<<24,++u,i=27492+(65535&(s=5*(65535&(i=(i^=l=(65535&(l=(l=(65535&l)*a+(((l>>>16)*a&65535)<<16)&4294967295)<<15|l>>>17))*o+(((l>>>16)*o&65535)<<16)&4294967295)<<13|i>>>19))+((5*(i>>>16)&65535)<<16)&4294967295))+((58964+(s>>>16)&65535)<<16);switch(l=0,r){case 3:l^=(255&t.charCodeAt(u+2))<<16;case 2:l^=(255&t.charCodeAt(u+1))<<8;case 1:i^=l=(65535&(l=(l=(65535&(l^=255&t.charCodeAt(u)))*a+(((l>>>16)*a&65535)<<16)&4294967295)<<15|l>>>17))*o+(((l>>>16)*o&65535)<<16)&4294967295;}return i^=t.length,i=2246822507*(65535&(i^=i>>>16))+((2246822507*(i>>>16)&65535)<<16)&4294967295,i=3266489909*(65535&(i^=i>>>13))+((3266489909*(i>>>16)&65535)<<16)&4294967295,(i^=i>>>16)>>>0};})),qa=ye((function(t){t.exports=function(t,e){for(var r,n=t.length,i=e^n,s=0;n>=4;)r=1540483477*(65535&(r=255&t.charCodeAt(s)|(255&t.charCodeAt(++s))<<8|(255&t.charCodeAt(++s))<<16|(255&t.charCodeAt(++s))<<24))+((1540483477*(r>>>16)&65535)<<16),i=1540483477*(65535&i)+((1540483477*(i>>>16)&65535)<<16)^(r=1540483477*(65535&(r^=r>>>24))+((1540483477*(r>>>16)&65535)<<16)),n-=4,++s;switch(n){case 3:i^=(255&t.charCodeAt(s+2))<<16;case 2:i^=(255&t.charCodeAt(s+1))<<8;case 1:i=1540483477*(65535&(i^=255&t.charCodeAt(s)))+((1540483477*(i>>>16)&65535)<<16);}return i=1540483477*(65535&(i^=i>>>13))+((1540483477*(i>>>16)&65535)<<16),(i^=i>>>15)>>>0};})),Na=Oa,Ga=qa;Na.murmur3=Oa,Na.murmur2=Ga;class Za{constructor(){this.ids=[],this.positions=[],this.indexed=!1;}add(t,e,r,n){this.ids.push(Xa(t)),this.positions.push(e,r,n);}getPositions(t){const e=Xa(t);let r=0,n=this.ids.length-1;for(;r<n;){const t=r+n>>1;this.ids[t]>=e?n=t:r=t+1;}const i=[];for(;this.ids[r]===e;)i.push({index:this.positions[3*r],start:this.positions[3*r+1],end:this.positions[3*r+2]}),r++;return i}static serialize(t,e){const r=new Float64Array(t.ids),n=new Uint32Array(t.positions);return Ka(r,n,0,r.length-1),e&&e.push(r.buffer,n.buffer),{ids:r,positions:n}}static deserialize(t){const e=new Za;return e.ids=t.ids,e.positions=t.positions,e.indexed=!0,e}}function Xa(t){const e=+t;return !isNaN(e)&&Number.MIN_SAFE_INTEGER<=e&&e<=Number.MAX_SAFE_INTEGER?e:Na(String(t))}function Ka(t,e,r,n){for(;r<n;){const i=t[r+n>>1];let s=r-1,a=n+1;for(;;){do{s++;}while(t[s]<i);do{a--;}while(t[a]>i);if(s>=a)break;Ha(t,s,a),Ha(e,3*s,3*a),Ha(e,3*s+1,3*a+1),Ha(e,3*s+2,3*a+2);}a-r<n-a?(Ka(t,e,r,a),r=a+1):(Ka(t,e,a+1,n),n=a);}}function Ha(t,e,r){const n=t[e];t[e]=t[r],t[r]=n;}Pi(Za,"FeaturePositionMap");class Ya{constructor(t){this.gl=t.gl,this.initialized=!1;}fetchUniformLocation(t,e){return this.location||this.initialized||(this.location=this.gl.getUniformLocation(t,e),this.initialized=!0),!!this.location}}class Wa extends Ya{constructor(t){super(t),this.current=0;}set(t,e,r){this.fetchUniformLocation(t,e)&&this.current!==r&&(this.current=r,this.gl.uniform1f(this.location,r));}}class Ja extends Ya{constructor(t){super(t),this.current=[0,0,0,0];}set(t,e,r){this.fetchUniformLocation(t,e)&&(r[0]===this.current[0]&&r[1]===this.current[1]&&r[2]===this.current[2]&&r[3]===this.current[3]||(this.current=r,this.gl.uniform4f(this.location,r[0],r[1],r[2],r[3])));}}class Qa extends Ya{constructor(t){super(t),this.current=xe.transparent;}set(t,e,r){this.fetchUniformLocation(t,e)&&(r.r===this.current.r&&r.g===this.current.g&&r.b===this.current.b&&r.a===this.current.a||(this.current=r,this.gl.uniform4f(this.location,r.r,r.g,r.b,r.a)));}}const to=new Float32Array(16),eo=new Float32Array(9),ro=new Float32Array(4);function no(t){return [Xs(255*t.r,255*t.g),Xs(255*t.b,255*t.a)]}class io{constructor(t,e,r){this.value=t,this.uniformNames=e.map((t=>`u_${t}`)),this.type=r;}setUniform(t,e,r,n,i){e.set(t,i,n.constantOr(this.value));}getBinding(t,e){return "color"===this.type?new Qa(t):new Wa(t)}}class so{constructor(t,e){this.uniformNames=e.map((t=>`u_${t}`)),this.patternFrom=null,this.patternTo=null,this.pixelRatioFrom=1,this.pixelRatioTo=1;}setConstantPatternPositions(t,e){this.pixelRatioFrom=e.pixelRatio||1,this.pixelRatioTo=t.pixelRatio||1,this.patternFrom=e.tl.concat(e.br),this.patternTo=t.tl.concat(t.br);}setUniform(t,e,r,n,i){const s="u_pattern_to"===i||"u_dash_to"===i?this.patternTo:"u_pattern_from"===i||"u_dash_from"===i?this.patternFrom:"u_pixel_ratio_to"===i?this.pixelRatioTo:"u_pixel_ratio_from"===i?this.pixelRatioFrom:null;s&&e.set(t,i,s);}getBinding(t,e){return "u_pattern_from"===e||"u_pattern_to"===e||"u_dash_from"===e||"u_dash_to"===e?new Ja(t):new Wa(t)}}class ao{constructor(t,e,r,n){this.expression=t,this.type=r,this.maxValue=0,this.paintVertexAttributes=e.map((t=>({name:`a_${t}`,type:"Float32",components:"color"===r?2:1,offset:0}))),this.paintVertexArray=new n;}populatePaintArray(t,e,r,n,i,s){const a=this.paintVertexArray.length,o=this.expression.evaluate(new Cs(0),e,{},i,n,s);this.paintVertexArray.resize(t),this._setPaintValue(a,t,o);}updatePaintArray(t,e,r,n,i){const s=this.expression.evaluate({zoom:0},r,n,void 0,i);this._setPaintValue(t,e,s);}_setPaintValue(t,e,r){if("color"===this.type){const n=no(r);for(let r=t;r<e;r++)this.paintVertexArray.emplace(r,n[0],n[1]);}else {for(let n=t;n<e;n++)this.paintVertexArray.emplace(n,r);this.maxValue=Math.max(this.maxValue,Math.abs(r));}}upload(t){this.paintVertexArray&&this.paintVertexArray.arrayBuffer&&(this.paintVertexBuffer&&this.paintVertexBuffer.buffer?this.paintVertexBuffer.updateData(this.paintVertexArray):this.paintVertexBuffer=t.createVertexBuffer(this.paintVertexArray,this.paintVertexAttributes,this.expression.isStateDependent));}destroy(){this.paintVertexBuffer&&this.paintVertexBuffer.destroy();}}class oo{constructor(t,e,r,n,i,s){this.expression=t,this.uniformNames=e.map((t=>`u_${t}_t`)),this.type=r,this.useIntegerZoom=n,this.zoom=i,this.maxValue=0,this.paintVertexAttributes=e.map((t=>({name:`a_${t}`,type:"Float32",components:"color"===r?4:2,offset:0}))),this.paintVertexArray=new s;}populatePaintArray(t,e,r,n,i,s){const a=this.expression.evaluate(new Cs(this.zoom),e,{},i,n,s),o=this.expression.evaluate(new Cs(this.zoom+1),e,{},i,n,s),l=this.paintVertexArray.length;this.paintVertexArray.resize(t),this._setPaintValue(l,t,a,o);}updatePaintArray(t,e,r,n,i){const s=this.expression.evaluate({zoom:this.zoom},r,n,void 0,i),a=this.expression.evaluate({zoom:this.zoom+1},r,n,void 0,i);this._setPaintValue(t,e,s,a);}_setPaintValue(t,e,r,n){if("color"===this.type){const i=no(r),s=no(n);for(let r=t;r<e;r++)this.paintVertexArray.emplace(r,i[0],i[1],s[0],s[1]);}else {for(let i=t;i<e;i++)this.paintVertexArray.emplace(i,r,n);this.maxValue=Math.max(this.maxValue,Math.abs(r),Math.abs(n));}}upload(t){this.paintVertexArray&&this.paintVertexArray.arrayBuffer&&(this.paintVertexBuffer&&this.paintVertexBuffer.buffer?this.paintVertexBuffer.updateData(this.paintVertexArray):this.paintVertexBuffer=t.createVertexBuffer(this.paintVertexArray,this.paintVertexAttributes,this.expression.isStateDependent));}destroy(){this.paintVertexBuffer&&this.paintVertexBuffer.destroy();}setUniform(t,e,r,n,i){const s=this.useIntegerZoom?Math.floor(r.zoom):r.zoom,a=d(this.expression.interpolationFactor(s,this.zoom,this.zoom+1),0,1);e.set(t,i,a);}getBinding(t,e){return new Wa(t)}}class lo{constructor(t,e,r,n,i,s,a){this.expression=t,this.type=r,this.useIntegerZoom=n,this.zoom=i,this.layerId=a,this.paintVertexAttributes=("array"===r?$a:ja).members;for(let t=0;t<e.length;++t);this.zoomInPaintVertexArray=new s,this.zoomOutPaintVertexArray=new s;}populatePaintArray(t,e,r){const n=this.zoomInPaintVertexArray.length;this.zoomInPaintVertexArray.resize(t),this.zoomOutPaintVertexArray.resize(t),this._setPaintValues(n,t,e.patterns&&e.patterns[this.layerId],r);}updatePaintArray(t,e,r,n,i,s){this._setPaintValues(t,e,r.patterns&&r.patterns[this.layerId],s);}_setPaintValues(t,e,r,n){if(!n||!r)return;const{min:i,mid:s,max:a}=r,o=n[i],l=n[s],u=n[a];if(o&&l&&u)for(let r=t;r<e;r++)this._setPaintValue(this.zoomInPaintVertexArray,r,l,o),this._setPaintValue(this.zoomOutPaintVertexArray,r,l,u);}_setPaintValue(t,e,r,n){t.emplace(e,r.tl[0],r.tl[1],r.br[0],r.br[1],n.tl[0],n.tl[1],n.br[0],n.br[1],r.pixelRatio,n.pixelRatio);}upload(t){this.zoomInPaintVertexArray&&this.zoomInPaintVertexArray.arrayBuffer&&this.zoomOutPaintVertexArray&&this.zoomOutPaintVertexArray.arrayBuffer&&(this.zoomInPaintVertexBuffer=t.createVertexBuffer(this.zoomInPaintVertexArray,this.paintVertexAttributes,this.expression.isStateDependent),this.zoomOutPaintVertexBuffer=t.createVertexBuffer(this.zoomOutPaintVertexArray,this.paintVertexAttributes,this.expression.isStateDependent));}destroy(){this.zoomOutPaintVertexBuffer&&this.zoomOutPaintVertexBuffer.destroy(),this.zoomInPaintVertexBuffer&&this.zoomInPaintVertexBuffer.destroy();}}class uo{constructor(t,e,r=(()=>!0)){this.binders={},this._buffers=[];const n=[];for(const i in t.paint._values){if(!r(i))continue;const s=t.paint.get(i);if(!(s instanceof Us&&An(s.property.specification)))continue;const a=po(i,t.type),o=s.value,l=s.property.specification.type,u=s.property.useIntegerZoom,c=s.property.specification["property-type"],h="cross-faded"===c||"cross-faded-data-driven"===c,p="line-dasharray"===String(i)&&"constant"!==t.layout.get("line-cap").value.kind;if("constant"!==o.kind||p)if("source"===o.kind||p||h){const r=mo(i,l,"source");this.binders[i]=h?new lo(o,a,l,u,e,r,t.id):new ao(o,a,l,r),n.push(`/a_${i}`);}else {const t=mo(i,l,"composite");this.binders[i]=new oo(o,a,l,u,e,t),n.push(`/z_${i}`);}else this.binders[i]=h?new so(o.value,a):new io(o.value,a,l),n.push(`/u_${i}`);}this.cacheKey=n.sort().join("");}getMaxValue(t){const e=this.binders[t];return e instanceof ao||e instanceof oo?e.maxValue:0}populatePaintArrays(t,e,r,n,i,s){for(const a in this.binders){const o=this.binders[a];(o instanceof ao||o instanceof oo||o instanceof lo)&&o.populatePaintArray(t,e,r,n,i,s);}}setConstantPatternPositions(t,e){for(const r in this.binders){const n=this.binders[r];n instanceof so&&n.setConstantPatternPositions(t,e);}}updatePaintArrays(t,e,r,n,i,s){let a=!1;for(const o in t){const l=e.getPositions(o);for(const e of l){const l=r.feature(e.index);for(const r in this.binders){const u=this.binders[r];if((u instanceof ao||u instanceof oo||u instanceof lo)&&!0===u.expression.isStateDependent){const c=n.paint.get(r);u.expression=c.value,u.updatePaintArray(e.start,e.end,l,t[o],i,s),a=!0;}}}}return a}defines(){const t=[];for(const e in this.binders){const r=this.binders[e];(r instanceof io||r instanceof so)&&t.push(...r.uniformNames.map((t=>`#define HAS_UNIFORM_${t}`)));}return t}getBinderAttributes(){const t=[];for(const e in this.binders){const r=this.binders[e];if(r instanceof ao||r instanceof oo||r instanceof lo)for(let e=0;e<r.paintVertexAttributes.length;e++)t.push(r.paintVertexAttributes[e].name);}return t}getBinderUniforms(){const t=[];for(const e in this.binders){const r=this.binders[e];if(r instanceof io||r instanceof so||r instanceof oo)for(const e of r.uniformNames)t.push(e);}return t}getPaintVertexBuffers(){return this._buffers}getUniforms(t){const e=[];for(const r in this.binders){const n=this.binders[r];if(n instanceof io||n instanceof so||n instanceof oo)for(const i of n.uniformNames)e.push({name:i,property:r,binding:n.getBinding(t,i)});}return e}setUniforms(t,e,r,n,i){for(const{name:e,property:s,binding:a}of r)this.binders[s].setUniform(t,a,i,n.get(s),e);}updatePaintBuffers(t){this._buffers=[];for(const e in this.binders){const r=this.binders[e];if(t&&r instanceof lo){const e=2===t.fromScale?r.zoomInPaintVertexBuffer:r.zoomOutPaintVertexBuffer;e&&this._buffers.push(e);}else (r instanceof ao||r instanceof oo)&&r.paintVertexBuffer&&this._buffers.push(r.paintVertexBuffer);}}upload(t){for(const e in this.binders){const r=this.binders[e];(r instanceof ao||r instanceof oo||r instanceof lo)&&r.upload(t);}this.updatePaintBuffers();}destroy(){for(const t in this.binders){const e=this.binders[t];(e instanceof ao||e instanceof oo||e instanceof lo)&&e.destroy();}}}class co{constructor(t,e,r=(()=>!0)){this.programConfigurations={};for(const n of t)this.programConfigurations[n.id]=new uo(n,e,r);this.needsUpload=!1,this._featureMap=new Za,this._bufferOffset=0;}populatePaintArrays(t,e,r,n,i,s,a){for(const r in this.programConfigurations)this.programConfigurations[r].populatePaintArrays(t,e,n,i,s,a);void 0!==e.id&&this._featureMap.add(e.id,r,this._bufferOffset,t),this._bufferOffset=t,this.needsUpload=!0;}updatePaintArrays(t,e,r,n,i){for(const s of r)this.needsUpload=this.programConfigurations[s.id].updatePaintArrays(t,this._featureMap,e,s,n,i)||this.needsUpload;}get(t){return this.programConfigurations[t]}upload(t){if(this.needsUpload){for(const e in this.programConfigurations)this.programConfigurations[e].upload(t);this.needsUpload=!1;}}destroy(){for(const t in this.programConfigurations)this.programConfigurations[t].destroy();}}const ho={"text-opacity":["opacity"],"icon-opacity":["opacity"],"text-color":["fill_color"],"icon-color":["fill_color"],"text-halo-color":["halo_color"],"icon-halo-color":["halo_color"],"text-halo-blur":["halo_blur"],"icon-halo-blur":["halo_blur"],"text-halo-width":["halo_width"],"icon-halo-width":["halo_width"],"line-gap-width":["gapwidth"],"line-pattern":["pattern_to","pattern_from","pixel_ratio_to","pixel_ratio_from"],"fill-pattern":["pattern_to","pattern_from","pixel_ratio_to","pixel_ratio_from"],"fill-extrusion-pattern":["pattern_to","pattern_from","pixel_ratio_to","pixel_ratio_from"],"line-dasharray":["dash_to","dash_from"]};function po(t,e){return ho[t]||[t.replace(`${e}-`,"").replace(/-/g,"_")]}const fo={"line-pattern":{source:ia,composite:ia},"fill-pattern":{source:ia,composite:ia},"fill-extrusion-pattern":{source:ia,composite:ia},"line-dasharray":{source:sa,composite:sa}},yo={color:{source:Aa,composite:na},number:{source:xa,composite:Aa}};function mo(t,e,r){const n=fo[t];return n&&n[r]||yo[e][r]}Pi(io,"ConstantBinder"),Pi(so,"CrossFadedConstantBinder"),Pi(ao,"SourceExpressionBinder"),Pi(lo,"CrossFadedCompositeBinder"),Pi(oo,"CompositeExpressionBinder"),Pi(uo,"ProgramConfiguration",{omit:["_buffers"]}),Pi(co,"ProgramConfigurationSet");const go="-transition";class xo extends Nt{constructor(t,e){if(super(),this.id=t.id,this.type=t.type,this._featureFilter={filter:()=>!0,needGeometry:!1,needFeature:!1},this._filterCompiled=!1,"custom"!==t.type&&(this.metadata=(t=t).metadata,this.minzoom=t.minzoom,this.maxzoom=t.maxzoom,"background"!==t.type&&"sky"!==t.type&&(this.source=t.source,this.sourceLayer=t["source-layer"],this.filter=t.filter),e.layout&&(this._unevaluatedLayout=new Rs(e.layout)),e.paint)){this._transitionablePaint=new Vs(e.paint);for(const e in t.paint)this.setPaintProperty(e,t.paint[e],{validate:!1});for(const e in t.layout)this.setLayoutProperty(e,t.layout[e],{validate:!1});this._transitioningPaint=this._transitionablePaint.untransitioned(),this.paint=new js(e.paint);}}getCrossfadeParameters(){return this._crossfadeParameters}getLayoutProperty(t){return "visibility"===t?this.visibility:this._unevaluatedLayout.getValue(t)}setLayoutProperty(t,e,r={}){null!=e&&this._validate(Mi,`layers.${this.id}.layout.${t}`,t,e,r)||("visibility"!==t?this._unevaluatedLayout.setValue(t,e):this.visibility=e);}getPaintProperty(t){return I(t,go)?this._transitionablePaint.getTransition(t.slice(0,-go.length)):this._transitionablePaint.getValue(t)}setPaintProperty(t,e,r={}){if(null!=e&&this._validate(Ii,`layers.${this.id}.paint.${t}`,t,e,r))return !1;if(I(t,go))return this._transitionablePaint.setTransition(t.slice(0,-go.length),e||void 0),!1;{const r=this._transitionablePaint._values[t],n="cross-faded-data-driven"===r.property.specification["property-type"],i=r.value.isDataDriven(),s=r.value;this._transitionablePaint.setValue(t,e),this._handleSpecialPaintPropertyUpdate(t);const a=this._transitionablePaint._values[t].value;return a.isDataDriven()||i||n||this._handleOverridablePaintPropertyUpdate(t,s,a)}}_handleSpecialPaintPropertyUpdate(t){}getProgramIds(){return null}getProgramConfiguration(t){return null}_handleOverridablePaintPropertyUpdate(t,e,r){return !1}isHidden(t){return !!(this.minzoom&&t<this.minzoom)||!!(this.maxzoom&&t>=this.maxzoom)||"none"===this.visibility}updateTransitions(t){this._transitioningPaint=this._transitionablePaint.transitioned(t,this._transitioningPaint);}hasTransition(){return this._transitioningPaint.hasTransition()}recalculate(t,e){t.getCrossfadeParameters&&(this._crossfadeParameters=t.getCrossfadeParameters()),this._unevaluatedLayout&&(this.layout=this._unevaluatedLayout.possiblyEvaluate(t,void 0,e)),this.paint=this._transitioningPaint.possiblyEvaluate(t,void 0,e);}serialize(){const t={id:this.id,type:this.type,source:this.source,"source-layer":this.sourceLayer,metadata:this.metadata,minzoom:this.minzoom,maxzoom:this.maxzoom,filter:this.filter,layout:this._unevaluatedLayout&&this._unevaluatedLayout.serialize(),paint:this._transitionablePaint&&this._transitionablePaint.serialize()};return this.visibility&&(t.layout=t.layout||{},t.layout.visibility=this.visibility),z(t,((t,e)=>!(void 0===t||"layout"===e&&!Object.keys(t).length||"paint"===e&&!Object.keys(t).length)))}_validate(t,e,r,n,i={}){return (!i||!1!==i.validate)&&Ti(this,t.call(ki,{key:e,layerType:this.type,objectKey:r,value:n,styleSpec:Gt,style:{glyphs:!0,sprite:!0}}))}is3D(){return !1}isSky(){return !1}isTileClipped(){return !1}hasOffscreenPass(){return !1}resize(){}isStateDependent(){for(const t in this.paint._values){const e=this.paint.get(t);if(e instanceof Us&&An(e.property.specification)&&("source"===e.value.kind||"composite"===e.value.kind)&&e.value.isStateDependent)return !0}return !1}compileFilter(){this._filterCompiled||(this._featureFilter=Jn(this.filter),this._filterCompiled=!0);}invalidateCompiledFilter(){this._filterCompiled=!1;}dynamicFilter(){return this._featureFilter.dynamicFilter}dynamicFilterNeedsFeature(){return this._featureFilter.needFeature}}const vo=Ws([{name:"a_pos",components:2,type:"Int16"}],4),bo=Ws([{name:"a_pos_3",components:3,type:"Int16"},{name:"a_pos_normal_3",components:3,type:"Int16"}]);class _o{constructor(t=[]){this.segments=t;}prepareSegment(t,e,r,n){let i=this.segments[this.segments.length-1];return t>_o.MAX_VERTEX_ARRAY_LENGTH&&E(`Max vertices per segment is ${_o.MAX_VERTEX_ARRAY_LENGTH}: bucket requested ${t}`),(!i||i.vertexLength+t>_o.MAX_VERTEX_ARRAY_LENGTH||i.sortKey!==n)&&(i={vertexOffset:e.length,primitiveOffset:r.length,vertexLength:0,primitiveLength:0},void 0!==n&&(i.sortKey=n),this.segments.push(i)),i}get(){return this.segments}destroy(){for(const t of this.segments)for(const e in t.vaos)t.vaos[e].destroy();}static simpleSegment(t,e,r,n){return new _o([{vertexOffset:t,primitiveOffset:e,vertexLength:r,primitiveLength:n,vaos:{},sortKey:0}])}}_o.MAX_VERTEX_ARRAY_LENGTH=Math.pow(2,16)-1,Pi(_o,"SegmentVector");var wo=8192;class Ao{constructor(t,e){t&&(e?this.setSouthWest(t).setNorthEast(e):4===t.length?this.setSouthWest([t[0],t[1]]).setNorthEast([t[2],t[3]]):this.setSouthWest(t[0]).setNorthEast(t[1]));}setNorthEast(t){return this._ne=t instanceof ko?new ko(t.lng,t.lat):ko.convert(t),this}setSouthWest(t){return this._sw=t instanceof ko?new ko(t.lng,t.lat):ko.convert(t),this}extend(t){const e=this._sw,r=this._ne;let n,i;if(t instanceof ko)n=t,i=t;else {if(!(t instanceof Ao))return Array.isArray(t)?4===t.length||t.every(Array.isArray)?this.extend(Ao.convert(t)):this.extend(ko.convert(t)):this;if(n=t._sw,i=t._ne,!n||!i)return this}return e||r?(e.lng=Math.min(n.lng,e.lng),e.lat=Math.min(n.lat,e.lat),r.lng=Math.max(i.lng,r.lng),r.lat=Math.max(i.lat,r.lat)):(this._sw=new ko(n.lng,n.lat),this._ne=new ko(i.lng,i.lat)),this}getCenter(){return new ko((this._sw.lng+this._ne.lng)/2,(this._sw.lat+this._ne.lat)/2)}getSouthWest(){return this._sw}getNorthEast(){return this._ne}getNorthWest(){return new ko(this.getWest(),this.getNorth())}getSouthEast(){return new ko(this.getEast(),this.getSouth())}getWest(){return this._sw.lng}getSouth(){return this._sw.lat}getEast(){return this._ne.lng}getNorth(){return this._ne.lat}toArray(){return [this._sw.toArray(),this._ne.toArray()]}toString(){return `LngLatBounds(${this._sw.toString()}, ${this._ne.toString()})`}isEmpty(){return !(this._sw&&this._ne)}contains(t){const{lng:e,lat:r}=ko.convert(t);let n=this._sw.lng<=e&&e<=this._ne.lng;return this._sw.lng>this._ne.lng&&(n=this._sw.lng>=e&&e>=this._ne.lng),this._sw.lat<=r&&r<=this._ne.lat&&n}static convert(t){return !t||t instanceof Ao?t:new Ao(t)}}const So=6371008.8;class ko{constructor(t,e){if(isNaN(t)||isNaN(e))throw new Error(`Invalid LngLat object: (${t}, ${e})`);if(this.lng=+t,this.lat=+e,this.lat>90||this.lat<-90)throw new Error("Invalid LngLat latitude value: must be between -90 and 90")}wrap(){return new ko(m(this.lng,-180,180),this.lat)}toArray(){return [this.lng,this.lat]}toString(){return `LngLat(${this.lng}, ${this.lat})`}distanceTo(t){const e=Math.PI/180,r=this.lat*e,n=t.lat*e,i=Math.sin(r)*Math.sin(n)+Math.cos(r)*Math.cos(n)*Math.cos((t.lng-this.lng)*e);return So*Math.acos(Math.min(i,1))}toBounds(t=0){const e=360*t/40075017,r=e/Math.cos(Math.PI/180*this.lat);return new Ao(new ko(this.lng-r,this.lat-e),new ko(this.lng+r,this.lat+e))}static convert(t){if(t instanceof ko)return t;if(Array.isArray(t)&&(2===t.length||3===t.length))return new ko(Number(t[0]),Number(t[1]));if(!Array.isArray(t)&&"object"==typeof t&&null!==t)return new ko(Number("lng"in t?t.lng:t.lon),Number(t.lat));throw new Error("`LngLatLike` argument must be specified as a LngLat instance, an object {lng: <lng>, lat: <lat>}, an object {lon: <lng>, lat: <lat>}, or an array of [<lng>, <lat>]")}}const Io=2*Math.PI*So;function Mo(t){return Io*Math.cos(t*Math.PI/180)}function zo(t){return (180+t)/360}function To(t){return (180-180/Math.PI*Math.log(Math.tan(Math.PI/4+t*Math.PI/360)))/360}function Bo(t,e){return t/Mo(e)}function Eo(t){return 360*t-180}function Co(t){return 360/Math.PI*Math.atan(Math.exp((180-360*t)*Math.PI/180))-90}function Po(t,e){return t*Mo(Co(e))}const Do=85.051129;function Vo(t){return 1/Math.cos(t*Math.PI/180)}class Fo{constructor(t,e,r=0){this.x=+t,this.y=+e,this.z=+r;}static fromLngLat(t,e=0){const r=ko.convert(t);return new Fo(zo(r.lng),To(r.lat),Bo(e,r.lat))}toLngLat(){return new ko(Eo(this.x),Co(this.y))}toAltitude(){return Po(this.z,this.y)}meterInMercatorCoordinateUnits(){return 1/Io*Vo(Co(this.y))}}function Lo(t,e,r,n,s,a,o,l,u){const c=(e+n)/2,h=(r+s)/2,p=new i(c,h);l(p),function(t,e,r,n,i,s){const a=r-i,o=n-s;return Math.abs((n-e)*a-(r-t)*o)/Math.hypot(a,o)}(p.x,p.y,a.x,a.y,o.x,o.y)>=u?(Lo(t,e,r,c,h,a,p,l,u),Lo(t,c,h,n,s,p,o,l,u)):t.push(o);}function Ro(t,e,r){let n=t[0],i=n.x,s=n.y;e(n);const a=[n];for(let o=1;o<t.length;o++){const l=t[o],{x:u,y:c}=l;e(l),Lo(a,i,s,u,c,n,l,e,r),i=u,s=c,n=l;}return a}function Uo(t,e,r,n,i){if(i(e,r)){const s=e.add(r).mult(.5);n(s),Uo(t,e,s,n,i),Uo(t,s,r,n,i);}else t.push(r);}function jo(t,e,r){let n=t[0];e(n);const i=[n];for(let s=1;s<t.length;s++){const a=t[s];e(a),Uo(i,n,a,e,r),n=a;}return i}const $o=Math.pow(2,14)-1,Oo=-$o-1;function qo(t,e){const r=Math.round(t.x*e),n=Math.round(t.y*e);return t.x=d(r,Oo,$o),t.y=d(n,Oo,$o),(r<t.x||r>t.x+1||n<t.y||n>t.y+1)&&E("Geometry exceeds allowed extent, reduce your vector tile buffer size"),t}function No(t,e,r){const n=t.loadGeometry(),i=t.extent,s=wo/i;if(e&&r&&r.projection.isReprojectedInTileSpace){const s=1<<e.z,{scale:a,x:o,y:l,projection:u}=r,c=t=>{const r=Eo((e.x+t.x/i)/s),n=Co((e.y+t.y/i)/s),c=u.project(r,n);t.x=(c.x*a-o)*i,t.y=(c.y*a-l)*i;};for(let e=0;e<n.length;e++)if(1!==t.type)n[e]=Ro(n[e],c,1);else {const t=[];for(const r of n[e])r.x<0||r.x>=i||r.y<0||r.y>=i||(c(r),t.push(r));n[e]=t;}}for(const t of n)for(const e of t)qo(e,s);return n}function Go(t,e){return {type:t.type,id:t.id,properties:t.properties,geometry:e?No(t):[]}}function Zo(t,e,r,n,i){t.emplaceBack(2*e+(n+1)/2,2*r+(i+1)/2);}function Xo(t,e,r){const n=16384;t.emplaceBack(e.x,e.y,e.z,r[0]*n,r[1]*n,r[2]*n);}class Ko{constructor(t){this.zoom=t.zoom,this.overscaling=t.overscaling,this.layers=t.layers,this.layerIds=this.layers.map((t=>t.id)),this.index=t.index,this.hasPattern=!1,this.projection=t.projection,this.layoutVertexArray=new Qs,this.indexArray=new ya,this.segments=new _o,this.programConfigurations=new co(t.layers,t.zoom),this.stateDependentLayerIds=this.layers.filter((t=>t.isStateDependent())).map((t=>t.id));}populate(t,e,r,n){const i=this.layers[0],s=[];let a=null;"circle"===i.type&&(a=i.layout.get("circle-sort-key"));for(const{feature:e,id:i,index:o,sourceLayerIndex:l}of t){const t=this.layers[0]._featureFilter.needGeometry,u=Go(e,t);if(!this.layers[0]._featureFilter.filter(new Cs(this.zoom),u,r))continue;const c=a?a.evaluate(u,{},r):void 0,h={id:i,properties:e.properties,type:e.type,sourceLayerIndex:l,index:o,geometry:t?u.geometry:No(e,r,n),patterns:{},sortKey:c};s.push(h);}a&&s.sort(((t,e)=>t.sortKey-e.sortKey));let o=null;"globe"===n.projection.name&&(this.globeExtVertexArray=new Ua,o=n.projection);for(const n of s){const{geometry:i,index:s,sourceLayerIndex:a}=n,l=t[s].feature;this.addFeature(n,i,s,e.availableImages,r,o),e.featureIndex.insert(l,i,s,a,this.index);}}update(t,e,r,n){this.stateDependentLayers.length&&this.programConfigurations.updatePaintArrays(t,e,this.stateDependentLayers,r,n);}isEmpty(){return 0===this.layoutVertexArray.length}uploadPending(){return !this.uploaded||this.programConfigurations.needsUpload}upload(t){this.uploaded||(this.layoutVertexBuffer=t.createVertexBuffer(this.layoutVertexArray,vo.members),this.indexBuffer=t.createIndexBuffer(this.indexArray),this.globeExtVertexArray&&(this.globeExtVertexBuffer=t.createVertexBuffer(this.globeExtVertexArray,bo.members))),this.programConfigurations.upload(t),this.uploaded=!0;}destroy(){this.layoutVertexBuffer&&(this.layoutVertexBuffer.destroy(),this.indexBuffer.destroy(),this.programConfigurations.destroy(),this.segments.destroy(),this.globeExtVertexBuffer&&this.globeExtVertexBuffer.destroy());}addFeature(t,e,r,n,i,s){for(const r of e)for(const e of r){const r=e.x,n=e.y;if(r<0||r>=wo||n<0||n>=wo)continue;if(s){const t=s.projectTilePoint(r,n,i),e=s.upVector(i,r,n),a=this.globeExtVertexArray;Xo(a,t,e),Xo(a,t,e),Xo(a,t,e),Xo(a,t,e);}const a=this.segments.prepareSegment(4,this.layoutVertexArray,this.indexArray,t.sortKey),o=a.vertexLength;Zo(this.layoutVertexArray,r,n,-1,-1),Zo(this.layoutVertexArray,r,n,1,-1),Zo(this.layoutVertexArray,r,n,1,1),Zo(this.layoutVertexArray,r,n,-1,1),this.indexArray.emplaceBack(o,o+1,o+2),this.indexArray.emplaceBack(o,o+2,o+3),a.vertexLength+=4,a.primitiveLength+=2;}this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length,t,r,{},n,i);}}function Ho(t,e){for(let r=0;r<t.length;r++)if(il(e,t[r]))return !0;for(let r=0;r<e.length;r++)if(il(t,e[r]))return !0;return !!Qo(t,e)}function Yo(t,e,r){return !!il(t,e)||!!el(e,t,r)}function Wo(t,e){if(1===t.length)return nl(e,t[0]);for(let r=0;r<e.length;r++){const n=e[r];for(let e=0;e<n.length;e++)if(il(t,n[e]))return !0}for(let r=0;r<t.length;r++)if(nl(e,t[r]))return !0;for(let r=0;r<e.length;r++)if(Qo(t,e[r]))return !0;return !1}function Jo(t,e,r){if(t.length>1){if(Qo(t,e))return !0;for(let n=0;n<e.length;n++)if(el(e[n],t,r))return !0}for(let n=0;n<t.length;n++)if(el(t[n],e,r))return !0;return !1}function Qo(t,e){if(0===t.length||0===e.length)return !1;for(let r=0;r<t.length-1;r++){const n=t[r],i=t[r+1];for(let t=0;t<e.length-1;t++)if(tl(n,i,e[t],e[t+1]))return !0}return !1}function tl(t,e,r,n){return C(t,r,n)!==C(e,r,n)&&C(t,e,r)!==C(t,e,n)}function el(t,e,r){const n=r*r;if(1===e.length)return t.distSqr(e[0])<n;for(let r=1;r<e.length;r++)if(rl(t,e[r-1],e[r])<n)return !0;return !1}function rl(t,e,r){const n=e.distSqr(r);if(0===n)return t.distSqr(e);const i=((t.x-e.x)*(r.x-e.x)+(t.y-e.y)*(r.y-e.y))/n;return t.distSqr(i<0?e:i>1?r:r.sub(e)._mult(i)._add(e))}function nl(t,e){let r,n,i,s=!1;for(let a=0;a<t.length;a++){r=t[a];for(let t=0,a=r.length-1;t<r.length;a=t++)n=r[t],i=r[a],n.y>e.y!=i.y>e.y&&e.x<(i.x-n.x)*(e.y-n.y)/(i.y-n.y)+n.x&&(s=!s);}return s}function il(t,e){let r=!1;for(let n=0,i=t.length-1;n<t.length;i=n++){const s=t[n],a=t[i];s.y>e.y!=a.y>e.y&&e.x<(a.x-s.x)*(e.y-s.y)/(a.y-s.y)+s.x&&(r=!r);}return r}function sl(t,e,r,n,s){for(const i of t)if(e<=i.x&&r<=i.y&&n>=i.x&&s>=i.y)return !0;const a=[new i(e,r),new i(e,s),new i(n,s),new i(n,r)];if(t.length>2)for(const e of a)if(il(t,e))return !0;for(let e=0;e<t.length-1;e++)if(al(t[e],t[e+1],a))return !0;return !1}function al(t,e,r){const n=r[0],i=r[2];if(t.x<n.x&&e.x<n.x||t.x>i.x&&e.x>i.x||t.y<n.y&&e.y<n.y||t.y>i.y&&e.y>i.y)return !1;const s=C(t,e,r[0]);return s!==C(t,e,r[1])||s!==C(t,e,r[2])||s!==C(t,e,r[3])}function ol(t,e,r){const n=e.paint.get(t).value;return "constant"===n.kind?n.value:r.programConfigurations.get(e.id).getMaxValue(t)}function ll(t){return Math.sqrt(t[0]*t[0]+t[1]*t[1])}function ul(t,e,r,n,s){if(!e[0]&&!e[1])return t;const a=i.convert(e)._mult(s);"viewport"===r&&a._rotate(-n);const o=[];for(let e=0;e<t.length;e++)o.push(t[e].sub(a));return o}function cl(t,e,r,n){const s=i.convert(t)._mult(n);return "viewport"===e&&s._rotate(-r),s}Pi(Ko,"CircleBucket",{omit:["layers"]});const hl=new Zs({"circle-sort-key":new Os(Gt.layout_circle["circle-sort-key"])});var pl={paint:new Zs({"circle-radius":new Os(Gt.paint_circle["circle-radius"]),"circle-color":new Os(Gt.paint_circle["circle-color"]),"circle-blur":new Os(Gt.paint_circle["circle-blur"]),"circle-opacity":new Os(Gt.paint_circle["circle-opacity"]),"circle-translate":new $s(Gt.paint_circle["circle-translate"]),"circle-translate-anchor":new $s(Gt.paint_circle["circle-translate-anchor"]),"circle-pitch-scale":new $s(Gt.paint_circle["circle-pitch-scale"]),"circle-pitch-alignment":new $s(Gt.paint_circle["circle-pitch-alignment"]),"circle-stroke-width":new Os(Gt.paint_circle["circle-stroke-width"]),"circle-stroke-color":new Os(Gt.paint_circle["circle-stroke-color"]),"circle-stroke-opacity":new Os(Gt.paint_circle["circle-stroke-opacity"])}),layout:hl},fl=1e-6,dl="undefined"!=typeof Float32Array?Float32Array:Array;function yl(){var t=new dl(9);return dl!=Float32Array&&(t[1]=0,t[2]=0,t[3]=0,t[5]=0,t[6]=0,t[7]=0),t[0]=1,t[4]=1,t[8]=1,t}function ml(t){return t[0]=1,t[1]=0,t[2]=0,t[3]=0,t[4]=0,t[5]=1,t[6]=0,t[7]=0,t[8]=0,t[9]=0,t[10]=1,t[11]=0,t[12]=0,t[13]=0,t[14]=0,t[15]=1,t}function gl(t,e){var r=e[0],n=e[1],i=e[2],s=e[3],a=e[4],o=e[5],l=e[6],u=e[7],c=e[8],h=e[9],p=e[10],f=e[11],d=e[12],y=e[13],m=e[14],g=e[15],x=r*o-n*a,v=r*l-i*a,b=r*u-s*a,_=n*l-i*o,w=n*u-s*o,A=i*u-s*l,S=c*y-h*d,k=c*m-p*d,I=c*g-f*d,M=h*m-p*y,z=h*g-f*y,T=p*g-f*m,B=x*T-v*z+b*M+_*I-w*k+A*S;return B?(t[0]=(o*T-l*z+u*M)*(B=1/B),t[1]=(i*z-n*T-s*M)*B,t[2]=(y*A-m*w+g*_)*B,t[3]=(p*w-h*A-f*_)*B,t[4]=(l*I-a*T-u*k)*B,t[5]=(r*T-i*I+s*k)*B,t[6]=(m*b-d*A-g*v)*B,t[7]=(c*A-p*b+f*v)*B,t[8]=(a*z-o*I+u*S)*B,t[9]=(n*I-r*z-s*S)*B,t[10]=(d*w-y*b+g*x)*B,t[11]=(h*b-c*w-f*x)*B,t[12]=(o*k-a*M-l*S)*B,t[13]=(r*M-n*k+i*S)*B,t[14]=(y*v-d*_-m*x)*B,t[15]=(c*_-h*v+p*x)*B,t):null}function xl(t,e,r){var n=e[0],i=e[1],s=e[2],a=e[3],o=e[4],l=e[5],u=e[6],c=e[7],h=e[8],p=e[9],f=e[10],d=e[11],y=e[12],m=e[13],g=e[14],x=e[15],v=r[0],b=r[1],_=r[2],w=r[3];return t[0]=v*n+b*o+_*h+w*y,t[1]=v*i+b*l+_*p+w*m,t[2]=v*s+b*u+_*f+w*g,t[3]=v*a+b*c+_*d+w*x,t[4]=(v=r[4])*n+(b=r[5])*o+(_=r[6])*h+(w=r[7])*y,t[5]=v*i+b*l+_*p+w*m,t[6]=v*s+b*u+_*f+w*g,t[7]=v*a+b*c+_*d+w*x,t[8]=(v=r[8])*n+(b=r[9])*o+(_=r[10])*h+(w=r[11])*y,t[9]=v*i+b*l+_*p+w*m,t[10]=v*s+b*u+_*f+w*g,t[11]=v*a+b*c+_*d+w*x,t[12]=(v=r[12])*n+(b=r[13])*o+(_=r[14])*h+(w=r[15])*y,t[13]=v*i+b*l+_*p+w*m,t[14]=v*s+b*u+_*f+w*g,t[15]=v*a+b*c+_*d+w*x,t}function vl(t,e,r){var n,i,s,a,o,l,u,c,h,p,f,d,y=r[0],m=r[1],g=r[2];return e===t?(t[12]=e[0]*y+e[4]*m+e[8]*g+e[12],t[13]=e[1]*y+e[5]*m+e[9]*g+e[13],t[14]=e[2]*y+e[6]*m+e[10]*g+e[14],t[15]=e[3]*y+e[7]*m+e[11]*g+e[15]):(i=e[1],s=e[2],a=e[3],o=e[4],l=e[5],u=e[6],c=e[7],h=e[8],p=e[9],f=e[10],d=e[11],t[0]=n=e[0],t[1]=i,t[2]=s,t[3]=a,t[4]=o,t[5]=l,t[6]=u,t[7]=c,t[8]=h,t[9]=p,t[10]=f,t[11]=d,t[12]=n*y+o*m+h*g+e[12],t[13]=i*y+l*m+p*g+e[13],t[14]=s*y+u*m+f*g+e[14],t[15]=a*y+c*m+d*g+e[15]),t}function bl(t,e,r){var n=r[0],i=r[1],s=r[2];return t[0]=e[0]*n,t[1]=e[1]*n,t[2]=e[2]*n,t[3]=e[3]*n,t[4]=e[4]*i,t[5]=e[5]*i,t[6]=e[6]*i,t[7]=e[7]*i,t[8]=e[8]*s,t[9]=e[9]*s,t[10]=e[10]*s,t[11]=e[11]*s,t[12]=e[12],t[13]=e[13],t[14]=e[14],t[15]=e[15],t}function _l(t,e,r){var n=Math.sin(r),i=Math.cos(r),s=e[4],a=e[5],o=e[6],l=e[7],u=e[8],c=e[9],h=e[10],p=e[11];return e!==t&&(t[0]=e[0],t[1]=e[1],t[2]=e[2],t[3]=e[3],t[12]=e[12],t[13]=e[13],t[14]=e[14],t[15]=e[15]),t[4]=s*i+u*n,t[5]=a*i+c*n,t[6]=o*i+h*n,t[7]=l*i+p*n,t[8]=u*i-s*n,t[9]=c*i-a*n,t[10]=h*i-o*n,t[11]=p*i-l*n,t}function wl(t,e,r){var n=Math.sin(r),i=Math.cos(r),s=e[0],a=e[1],o=e[2],l=e[3],u=e[8],c=e[9],h=e[10],p=e[11];return e!==t&&(t[4]=e[4],t[5]=e[5],t[6]=e[6],t[7]=e[7],t[12]=e[12],t[13]=e[13],t[14]=e[14],t[15]=e[15]),t[0]=s*i-u*n,t[1]=a*i-c*n,t[2]=o*i-h*n,t[3]=l*i-p*n,t[8]=s*n+u*i,t[9]=a*n+c*i,t[10]=o*n+h*i,t[11]=l*n+p*i,t}function Al(t,e){return t[0]=e[0],t[1]=0,t[2]=0,t[3]=0,t[4]=0,t[5]=e[1],t[6]=0,t[7]=0,t[8]=0,t[9]=0,t[10]=e[2],t[11]=0,t[12]=0,t[13]=0,t[14]=0,t[15]=1,t}function Sl(t,e,r){var n,i,s,a=r[0],o=r[1],l=r[2],u=Math.hypot(a,o,l);return u<fl?null:(a*=u=1/u,o*=u,l*=u,n=Math.sin(e),i=Math.cos(e),t[0]=a*a*(s=1-i)+i,t[1]=o*a*s+l*n,t[2]=l*a*s-o*n,t[3]=0,t[4]=a*o*s-l*n,t[5]=o*o*s+i,t[6]=l*o*s+a*n,t[7]=0,t[8]=a*l*s+o*n,t[9]=o*l*s-a*n,t[10]=l*l*s+i,t[11]=0,t[12]=0,t[13]=0,t[14]=0,t[15]=1,t)}Math.hypot||(Math.hypot=function(){for(var t=0,e=arguments.length;e--;)t+=arguments[e]*arguments[e];return Math.sqrt(t)});var kl=xl;function Il(){var t=new dl(3);return dl!=Float32Array&&(t[0]=0,t[1]=0,t[2]=0),t}function Ml(t){var e=new dl(3);return e[0]=t[0],e[1]=t[1],e[2]=t[2],e}function zl(t){return Math.hypot(t[0],t[1],t[2])}function Tl(t,e,r){var n=new dl(3);return n[0]=t,n[1]=e,n[2]=r,n}function Bl(t,e,r){return t[0]=e[0]+r[0],t[1]=e[1]+r[1],t[2]=e[2]+r[2],t}function El(t,e,r){return t[0]=e[0]-r[0],t[1]=e[1]-r[1],t[2]=e[2]-r[2],t}function Cl(t,e,r){return t[0]=e[0]*r[0],t[1]=e[1]*r[1],t[2]=e[2]*r[2],t}function Pl(t,e,r){return t[0]=Math.min(e[0],r[0]),t[1]=Math.min(e[1],r[1]),t[2]=Math.min(e[2],r[2]),t}function Dl(t,e,r){return t[0]=Math.max(e[0],r[0]),t[1]=Math.max(e[1],r[1]),t[2]=Math.max(e[2],r[2]),t}function Vl(t,e,r){return t[0]=e[0]*r,t[1]=e[1]*r,t[2]=e[2]*r,t}function Fl(t,e,r,n){return t[0]=e[0]+r[0]*n,t[1]=e[1]+r[1]*n,t[2]=e[2]+r[2]*n,t}function Ll(t,e){var r=e[0],n=e[1],i=e[2],s=r*r+n*n+i*i;return s>0&&(s=1/Math.sqrt(s)),t[0]=e[0]*s,t[1]=e[1]*s,t[2]=e[2]*s,t}function Rl(t,e){return t[0]*e[0]+t[1]*e[1]+t[2]*e[2]}function Ul(t,e,r){var n=e[0],i=e[1],s=e[2],a=r[0],o=r[1],l=r[2];return t[0]=i*l-s*o,t[1]=s*a-n*l,t[2]=n*o-i*a,t}function jl(t,e,r){var n=e[0],i=e[1],s=e[2],a=r[3]*n+r[7]*i+r[11]*s+r[15];return t[0]=(r[0]*n+r[4]*i+r[8]*s+r[12])/(a=a||1),t[1]=(r[1]*n+r[5]*i+r[9]*s+r[13])/a,t[2]=(r[2]*n+r[6]*i+r[10]*s+r[14])/a,t}function $l(t,e,r){var n=r[0],i=r[1],s=r[2],a=e[0],o=e[1],l=e[2],u=i*l-s*o,c=s*a-n*l,h=n*o-i*a,p=i*h-s*c,f=s*u-n*h,d=n*c-i*u,y=2*r[3];return c*=y,h*=y,f*=2,d*=2,t[0]=a+(u*=y)+(p*=2),t[1]=o+c+f,t[2]=l+h+d,t}var Ol,ql=El,Nl=Cl,Gl=zl;function Zl(t,e,r){return t[0]=e[0]*r,t[1]=e[1]*r,t[2]=e[2]*r,t[3]=e[3]*r,t}function Xl(t,e,r){var n=e[0],i=e[1],s=e[2],a=e[3];return t[0]=r[0]*n+r[4]*i+r[8]*s+r[12]*a,t[1]=r[1]*n+r[5]*i+r[9]*s+r[13]*a,t[2]=r[2]*n+r[6]*i+r[10]*s+r[14]*a,t[3]=r[3]*n+r[7]*i+r[11]*s+r[15]*a,t}function Kl(){var t=new dl(4);return dl!=Float32Array&&(t[0]=0,t[1]=0,t[2]=0),t[3]=1,t}function Hl(t){return t[0]=0,t[1]=0,t[2]=0,t[3]=1,t}function Yl(t,e,r){r*=.5;var n=e[0],i=e[1],s=e[2],a=e[3],o=Math.sin(r),l=Math.cos(r);return t[0]=n*l+a*o,t[1]=i*l+s*o,t[2]=s*l-i*o,t[3]=a*l-n*o,t}function Wl(t,e,r){r*=.5;var n=e[0],i=e[1],s=e[2],a=e[3],o=Math.sin(r),l=Math.cos(r);return t[0]=n*l-s*o,t[1]=i*l+a*o,t[2]=s*l+n*o,t[3]=a*l-i*o,t}Il(),Ol=new dl(4),dl!=Float32Array&&(Ol[0]=0,Ol[1]=0,Ol[2]=0,Ol[3]=0),Il(),Tl(1,0,0),Tl(0,1,0),Kl(),Kl(),yl();class Jl{constructor(t,e){this.pos=t,this.dir=e;}intersectsPlane(t,e,r){const n=Rl(e,this.dir);if(Math.abs(n)<1e-6)return !1;const i=((t[0]-this.pos[0])*e[0]+(t[1]-this.pos[1])*e[1]+(t[2]-this.pos[2])*e[2])/n;return r[0]=this.pos[0]+this.dir[0]*i,r[1]=this.pos[1]+this.dir[1]*i,r[2]=this.pos[2]+this.dir[2]*i,!0}closestPointOnSphere(t,e,r){if(function(t,e){var r=t[0],n=t[1],i=t[2],s=e[0],a=e[1],o=e[2];return Math.abs(r-s)<=fl*Math.max(1,Math.abs(r),Math.abs(s))&&Math.abs(n-a)<=fl*Math.max(1,Math.abs(n),Math.abs(a))&&Math.abs(i-o)<=fl*Math.max(1,Math.abs(i),Math.abs(o))}(this.pos,t)||0===e)return r[0]=r[1]=r[2]=0,!1;const[n,i,s]=this.dir,a=this.pos[0]-t[0],o=this.pos[1]-t[1],l=this.pos[2]-t[2],u=n*n+i*i+s*s,c=2*(a*n+o*i+l*s),h=c*c-4*u*(a*a+o*o+l*l-e*e);if(h<0){const t=Math.max(-c/2,0),u=a+n*t,h=o+i*t,p=l+s*t,f=Math.hypot(u,h,p);return r[0]=u*e/f,r[1]=h*e/f,r[2]=p*e/f,!1}{const t=(-c-Math.sqrt(h))/(2*u);if(t<0){const t=Math.hypot(a,o,l);return r[0]=a*e/t,r[1]=o*e/t,r[2]=l*e/t,!1}return r[0]=a+n*t,r[1]=o+i*t,r[2]=l+s*t,!0}}}class Ql{constructor(t,e,r,n,i){this.TL=t,this.TR=e,this.BR=r,this.BL=n,this.horizon=i;}static fromInvProjectionMatrix(t,e,r){const n=[-1,1,1],i=[1,1,1],s=[1,-1,1],a=[-1,-1,1],o=jl(n,n,t),l=jl(i,i,t),u=jl(s,s,t),c=jl(a,a,t);return new Ql(o,l,u,c,e/r)}}class tu{constructor(t,e){this.points=t,this.planes=e;}static fromInvProjectionMatrix(t,e,r,n){const i=Math.pow(2,r),s=[[-1,1,-1,1],[1,1,-1,1],[1,-1,-1,1],[-1,-1,-1,1],[-1,1,1,1],[1,1,1,1],[1,-1,1,1],[-1,-1,1,1]].map((r=>{const s=Xl([],r,t),a=1/s[3]/e*i;return function(t,e,r){return t[0]=e[0]*r[0],t[1]=e[1]*r[1],t[2]=e[2]*r[2],t[3]=e[3]*r[3],t}(s,s,[a,a,n?1/s[3]:a,a])})),a=[[0,1,2],[6,5,4],[0,3,7],[2,1,5],[3,2,6],[0,4,5]].map((t=>{const e=Ll([],Ul([],ql([],s[t[0]],s[t[1]]),ql([],s[t[2]],s[t[1]]))),r=-Rl(e,s[t[1]]);return e.concat(r)}));return new tu(s,a)}}class eu{static fromPoints(t){const e=[Number.MAX_VALUE,Number.MAX_VALUE,Number.MAX_VALUE],r=[Number.MIN_VALUE,Number.MIN_VALUE,Number.MIN_VALUE];for(const n of t)e[0]=Math.min(e[0],n[0]),e[1]=Math.min(e[1],n[1]),e[2]=Math.min(e[2],n[2]),r[0]=Math.max(r[0],n[0]),r[1]=Math.max(r[1],n[1]),r[2]=Math.max(r[2],n[2]);return new eu(e,r)}constructor(t,e){this.min=t,this.max=e,this.center=Vl([],Bl([],this.min,this.max),.5);}quadrant(t){const e=[t%2==0,t<2],r=Ml(this.min),n=Ml(this.max);for(let t=0;t<e.length;t++)r[t]=e[t]?this.min[t]:this.center[t],n[t]=e[t]?this.center[t]:this.max[t];return n[2]=this.max[2],new eu(r,n)}distanceX(t){return Math.max(Math.min(this.max[0],t[0]),this.min[0])-t[0]}distanceY(t){return Math.max(Math.min(this.max[1],t[1]),this.min[1])-t[1]}distanceZ(t){return Math.max(Math.min(this.max[2],t[2]),this.min[2])-t[2]}getCorners(){const t=this.min,e=this.max;return [[t[0],t[1],t[2]],[e[0],t[1],t[2]],[e[0],e[1],t[2]],[t[0],e[1],t[2]],[t[0],t[1],e[2]],[e[0],t[1],e[2]],[e[0],e[1],e[2]],[t[0],e[1],e[2]]]}intersects(t){const e=this.getCorners();let r=!0;for(let n=0;n<t.planes.length;n++){const i=t.planes[n];let s=0;for(let t=0;t<e.length;t++)s+=Rl(i,e[t])+i[3]>=0;if(0===s)return 0;s!==e.length&&(r=!1);}if(r)return 2;for(let e=0;e<3;e++){let r=Number.MAX_VALUE,n=-Number.MAX_VALUE;for(let i=0;i<t.points.length;i++){const s=t.points[i][e]-this.min[e];r=Math.min(r,s),n=Math.max(n,s);}if(n<0||r>this.max[e]-this.min[e])return 0}return 1}}function ru(t,e,r,n,i,s,a,o,l){if(s&&t.queryGeometry.isAboveHorizon)return !1;s&&(l*=t.pixelToTileUnitsFactor);const u=t.tileID.canonical,c=r.projection.upVectorScale(u,r.center.lat,r.worldSize).metersToTile;for(const h of e)for(const e of h){const h=e.add(o),p=i&&r.elevation?r.elevation.exaggeration()*i.getElevationAt(h.x,h.y,!0):0,f=r.projection.projectTilePoint(h.x,h.y,u);if(p>0){const t=r.projection.upVector(u,h.x,h.y);f.x+=t[0]*c*p,f.y+=t[1]*c*p,f.z+=t[2]*c*p;}const d=s?h:nu(f.x,f.y,f.z,n),y=s?t.tilespaceRays.map((t=>au(t,p))):t.queryGeometry.screenGeometry,m=Xl([],[f.x,f.y,f.z,1],n);if(!a&&s?l*=m[3]/r.cameraToCenterDistance:a&&!s&&(l*=r.cameraToCenterDistance/m[3]),s){const t=Co((e.y/wo+u.y)/(1<<u.z));l/=r.projection.pixelsPerMeter(t,1)/Bo(1,t);}if(Yo(y,d,l))return !0}return !1}function nu(t,e,r,n){const s=Xl([],[t,e,r,1],n);return new i(s[0]/s[3],s[1]/s[3])}const iu=Tl(0,0,0),su=Tl(0,0,1);function au(t,e){const r=Il();return iu[2]=e,t.intersectsPlane(iu,su,r),new i(r[0],r[1])}class ou extends Ko{}function lu(t,{width:e,height:r},n,i){if(i){if(i instanceof Uint8ClampedArray)i=new Uint8Array(i.buffer);else if(i.length!==e*r*n)throw new RangeError("mismatched image size")}else i=new Uint8Array(e*r*n);return t.width=e,t.height=r,t.data=i,t}function uu(t,e,r){const{width:n,height:i}=e;n===t.width&&i===t.height||(cu(t,e,{x:0,y:0},{x:0,y:0},{width:Math.min(t.width,n),height:Math.min(t.height,i)},r),t.width=n,t.height=i,t.data=e.data);}function cu(t,e,r,n,i,s){if(0===i.width||0===i.height)return e;if(i.width>t.width||i.height>t.height||r.x>t.width-i.width||r.y>t.height-i.height)throw new RangeError("out of range source coordinates for image copy");if(i.width>e.width||i.height>e.height||n.x>e.width-i.width||n.y>e.height-i.height)throw new RangeError("out of range destination coordinates for image copy");const a=t.data,o=e.data;for(let l=0;l<i.height;l++){const u=((r.y+l)*t.width+r.x)*s,c=((n.y+l)*e.width+n.x)*s;for(let t=0;t<i.width*s;t++)o[c+t]=a[u+t];}return e}Pi(ou,"HeatmapBucket",{omit:["layers"]});class hu{constructor(t,e){lu(this,t,1,e);}resize(t){uu(this,new hu(t),1);}clone(){return new hu({width:this.width,height:this.height},new Uint8Array(this.data))}static copy(t,e,r,n,i){cu(t,e,r,n,i,1);}}class pu{constructor(t,e){lu(this,t,4,e);}resize(t){uu(this,new pu(t),4);}replace(t,e){e?this.data.set(t):this.data=t instanceof Uint8ClampedArray?new Uint8Array(t.buffer):t;}clone(){return new pu({width:this.width,height:this.height},new Uint8Array(this.data))}static copy(t,e,r,n,i){cu(t,e,r,n,i,4);}}Pi(hu,"AlphaImage"),Pi(pu,"RGBAImage");var fu={paint:new Zs({"heatmap-radius":new Os(Gt.paint_heatmap["heatmap-radius"]),"heatmap-weight":new Os(Gt.paint_heatmap["heatmap-weight"]),"heatmap-intensity":new $s(Gt.paint_heatmap["heatmap-intensity"]),"heatmap-color":new Gs(Gt.paint_heatmap["heatmap-color"]),"heatmap-opacity":new $s(Gt.paint_heatmap["heatmap-opacity"])})};function du(t){const e={},r=t.resolution||256,n=t.clips?t.clips.length:1,i=t.image||new pu({width:r,height:n}),s=(r,n,s)=>{e[t.evaluationKey]=s;const a=t.expression.evaluate(e);i.data[r+n+0]=Math.floor(255*a.r/a.a),i.data[r+n+1]=Math.floor(255*a.g/a.a),i.data[r+n+2]=Math.floor(255*a.b/a.a),i.data[r+n+3]=Math.floor(255*a.a);};if(t.clips)for(let e=0,i=0;e<n;++e,i+=4*r)for(let n=0,a=0;n<r;n++,a+=4){const o=n/(r-1),{start:l,end:u}=t.clips[e];s(i,a,l*(1-o)+u*o);}else for(let t=0,e=0;t<r;t++,e+=4)s(0,e,t/(r-1));return i}var yu={paint:new Zs({"hillshade-illumination-direction":new $s(Gt.paint_hillshade["hillshade-illumination-direction"]),"hillshade-illumination-anchor":new $s(Gt.paint_hillshade["hillshade-illumination-anchor"]),"hillshade-exaggeration":new $s(Gt.paint_hillshade["hillshade-exaggeration"]),"hillshade-shadow-color":new $s(Gt.paint_hillshade["hillshade-shadow-color"]),"hillshade-highlight-color":new $s(Gt.paint_hillshade["hillshade-highlight-color"]),"hillshade-accent-color":new $s(Gt.paint_hillshade["hillshade-accent-color"])})};const mu=Ws([{name:"a_pos",components:2,type:"Int16"}],4),{members:gu}=mu;var xu=bu,vu=bu;function bu(t,e,r){r=r||2;var n,i,s,a,o,l,u,c=e&&e.length,h=c?e[0]*r:t.length,p=_u(t,0,h,r,!0),f=[];if(!p||p.next===p.prev)return f;if(c&&(p=function(t,e,r,n){var i,s,a,o=[];for(i=0,s=e.length;i<s;i++)(a=_u(t,e[i]*n,i<s-1?e[i+1]*n:t.length,n,!1))===a.next&&(a.steiner=!0),o.push(Cu(a));for(o.sort(zu),i=0;i<o.length;i++)r=Tu(o[i],r);return r}(t,e,p,r)),t.length>80*r){n=s=t[0],i=a=t[1];for(var d=r;d<h;d+=r)(o=t[d])<n&&(n=o),(l=t[d+1])<i&&(i=l),o>s&&(s=o),l>a&&(a=l);u=0!==(u=Math.max(s-n,a-i))?32767/u:0;}return Au(p,f,r,n,i,u,0),f}function _u(t,e,r,n,i){var s,a;if(i===Gu(t,e,r,n)>0)for(s=e;s<r;s+=n)a=Ou(s,t[s],t[s+1],a);else for(s=r-n;s>=e;s-=n)a=Ou(s,t[s],t[s+1],a);return a&&Fu(a,a.next)&&(qu(a),a=a.next),a}function wu(t,e){if(!t)return t;e||(e=t);var r,n=t;do{if(r=!1,n.steiner||!Fu(n,n.next)&&0!==Vu(n.prev,n,n.next))n=n.next;else {if(qu(n),(n=e=n.prev)===n.next)break;r=!0;}}while(r||n!==e);return e}function Au(t,e,r,n,i,s,a){if(t){!a&&s&&function(t,e,r,n){var i=t;do{0===i.z&&(i.z=Eu(i.x,i.y,e,r,n)),i.prevZ=i.prev,i.nextZ=i.next,i=i.next;}while(i!==t);i.prevZ.nextZ=null,i.prevZ=null,function(t){var e,r,n,i,s,a,o,l,u=1;do{for(r=t,t=null,s=null,a=0;r;){for(a++,n=r,o=0,e=0;e<u&&(o++,n=n.nextZ);e++);for(l=u;o>0||l>0&&n;)0!==o&&(0===l||!n||r.z<=n.z)?(i=r,r=r.nextZ,o--):(i=n,n=n.nextZ,l--),s?s.nextZ=i:t=i,i.prevZ=s,s=i;r=n;}s.nextZ=null,u*=2;}while(a>1)}(i);}(t,n,i,s);for(var o,l,u=t;t.prev!==t.next;)if(o=t.prev,l=t.next,s?ku(t,n,i,s):Su(t))e.push(o.i/r|0),e.push(t.i/r|0),e.push(l.i/r|0),qu(t),t=l.next,u=l.next;else if((t=l)===u){a?1===a?Au(t=Iu(wu(t),e,r),e,r,n,i,s,2):2===a&&Mu(t,e,r,n,i,s):Au(wu(t),e,r,n,i,s,1);break}}}function Su(t){var e=t.prev,r=t,n=t.next;if(Vu(e,r,n)>=0)return !1;for(var i=e.x,s=r.x,a=n.x,o=e.y,l=r.y,u=n.y,c=i<s?i<a?i:a:s<a?s:a,h=o<l?o<u?o:u:l<u?l:u,p=i>s?i>a?i:a:s>a?s:a,f=o>l?o>u?o:u:l>u?l:u,d=n.next;d!==e;){if(d.x>=c&&d.x<=p&&d.y>=h&&d.y<=f&&Pu(i,o,s,l,a,u,d.x,d.y)&&Vu(d.prev,d,d.next)>=0)return !1;d=d.next;}return !0}function ku(t,e,r,n){var i=t.prev,s=t,a=t.next;if(Vu(i,s,a)>=0)return !1;for(var o=i.x,l=s.x,u=a.x,c=i.y,h=s.y,p=a.y,f=o<l?o<u?o:u:l<u?l:u,d=c<h?c<p?c:p:h<p?h:p,y=o>l?o>u?o:u:l>u?l:u,m=c>h?c>p?c:p:h>p?h:p,g=Eu(f,d,e,r,n),x=Eu(y,m,e,r,n),v=t.prevZ,b=t.nextZ;v&&v.z>=g&&b&&b.z<=x;){if(v.x>=f&&v.x<=y&&v.y>=d&&v.y<=m&&v!==i&&v!==a&&Pu(o,c,l,h,u,p,v.x,v.y)&&Vu(v.prev,v,v.next)>=0)return !1;if(v=v.prevZ,b.x>=f&&b.x<=y&&b.y>=d&&b.y<=m&&b!==i&&b!==a&&Pu(o,c,l,h,u,p,b.x,b.y)&&Vu(b.prev,b,b.next)>=0)return !1;b=b.nextZ;}for(;v&&v.z>=g;){if(v.x>=f&&v.x<=y&&v.y>=d&&v.y<=m&&v!==i&&v!==a&&Pu(o,c,l,h,u,p,v.x,v.y)&&Vu(v.prev,v,v.next)>=0)return !1;v=v.prevZ;}for(;b&&b.z<=x;){if(b.x>=f&&b.x<=y&&b.y>=d&&b.y<=m&&b!==i&&b!==a&&Pu(o,c,l,h,u,p,b.x,b.y)&&Vu(b.prev,b,b.next)>=0)return !1;b=b.nextZ;}return !0}function Iu(t,e,r){var n=t;do{var i=n.prev,s=n.next.next;!Fu(i,s)&&Lu(i,n,n.next,s)&&ju(i,s)&&ju(s,i)&&(e.push(i.i/r|0),e.push(n.i/r|0),e.push(s.i/r|0),qu(n),qu(n.next),n=t=s),n=n.next;}while(n!==t);return wu(n)}function Mu(t,e,r,n,i,s){var a=t;do{for(var o=a.next.next;o!==a.prev;){if(a.i!==o.i&&Du(a,o)){var l=$u(a,o);return a=wu(a,a.next),l=wu(l,l.next),Au(a,e,r,n,i,s,0),void Au(l,e,r,n,i,s,0)}o=o.next;}a=a.next;}while(a!==t)}function zu(t,e){return t.x-e.x}function Tu(t,e){var r=function(t,e){var r,n=e,i=t.x,s=t.y,a=-1/0;do{if(s<=n.y&&s>=n.next.y&&n.next.y!==n.y){var o=n.x+(s-n.y)*(n.next.x-n.x)/(n.next.y-n.y);if(o<=i&&o>a&&(a=o,r=n.x<n.next.x?n:n.next,o===i))return r}n=n.next;}while(n!==e);if(!r)return null;var l,u=r,c=r.x,h=r.y,p=1/0;n=r;do{i>=n.x&&n.x>=c&&i!==n.x&&Pu(s<h?i:a,s,c,h,s<h?a:i,s,n.x,n.y)&&(l=Math.abs(s-n.y)/(i-n.x),ju(n,t)&&(l<p||l===p&&(n.x>r.x||n.x===r.x&&Bu(r,n)))&&(r=n,p=l)),n=n.next;}while(n!==u);return r}(t,e);if(!r)return e;var n=$u(r,t);return wu(n,n.next),wu(r,r.next)}function Bu(t,e){return Vu(t.prev,t,e.prev)<0&&Vu(e.next,t,t.next)<0}function Eu(t,e,r,n,i){return (t=1431655765&((t=858993459&((t=252645135&((t=16711935&((t=(t-r)*i|0)|t<<8))|t<<4))|t<<2))|t<<1))|(e=1431655765&((e=858993459&((e=252645135&((e=16711935&((e=(e-n)*i|0)|e<<8))|e<<4))|e<<2))|e<<1))<<1}function Cu(t){var e=t,r=t;do{(e.x<r.x||e.x===r.x&&e.y<r.y)&&(r=e),e=e.next;}while(e!==t);return r}function Pu(t,e,r,n,i,s,a,o){return (i-a)*(e-o)>=(t-a)*(s-o)&&(t-a)*(n-o)>=(r-a)*(e-o)&&(r-a)*(s-o)>=(i-a)*(n-o)}function Du(t,e){return t.next.i!==e.i&&t.prev.i!==e.i&&!function(t,e){var r=t;do{if(r.i!==t.i&&r.next.i!==t.i&&r.i!==e.i&&r.next.i!==e.i&&Lu(r,r.next,t,e))return !0;r=r.next;}while(r!==t);return !1}(t,e)&&(ju(t,e)&&ju(e,t)&&function(t,e){var r=t,n=!1,i=(t.x+e.x)/2,s=(t.y+e.y)/2;do{r.y>s!=r.next.y>s&&r.next.y!==r.y&&i<(r.next.x-r.x)*(s-r.y)/(r.next.y-r.y)+r.x&&(n=!n),r=r.next;}while(r!==t);return n}(t,e)&&(Vu(t.prev,t,e.prev)||Vu(t,e.prev,e))||Fu(t,e)&&Vu(t.prev,t,t.next)>0&&Vu(e.prev,e,e.next)>0)}function Vu(t,e,r){return (e.y-t.y)*(r.x-e.x)-(e.x-t.x)*(r.y-e.y)}function Fu(t,e){return t.x===e.x&&t.y===e.y}function Lu(t,e,r,n){var i=Uu(Vu(t,e,r)),s=Uu(Vu(t,e,n)),a=Uu(Vu(r,n,t)),o=Uu(Vu(r,n,e));return i!==s&&a!==o||!(0!==i||!Ru(t,r,e))||!(0!==s||!Ru(t,n,e))||!(0!==a||!Ru(r,t,n))||!(0!==o||!Ru(r,e,n))}function Ru(t,e,r){return e.x<=Math.max(t.x,r.x)&&e.x>=Math.min(t.x,r.x)&&e.y<=Math.max(t.y,r.y)&&e.y>=Math.min(t.y,r.y)}function Uu(t){return t>0?1:t<0?-1:0}function ju(t,e){return Vu(t.prev,t,t.next)<0?Vu(t,e,t.next)>=0&&Vu(t,t.prev,e)>=0:Vu(t,e,t.prev)<0||Vu(t,t.next,e)<0}function $u(t,e){var r=new Nu(t.i,t.x,t.y),n=new Nu(e.i,e.x,e.y),i=t.next,s=e.prev;return t.next=e,e.prev=t,r.next=i,i.prev=r,n.next=r,r.prev=n,s.next=n,n.prev=s,n}function Ou(t,e,r,n){var i=new Nu(t,e,r);return n?(i.next=n.next,i.prev=n,n.next.prev=i,n.next=i):(i.prev=i,i.next=i),i}function qu(t){t.next.prev=t.prev,t.prev.next=t.next,t.prevZ&&(t.prevZ.nextZ=t.nextZ),t.nextZ&&(t.nextZ.prevZ=t.prevZ);}function Nu(t,e,r){this.i=t,this.x=e,this.y=r,this.prev=null,this.next=null,this.z=0,this.prevZ=null,this.nextZ=null,this.steiner=!1;}function Gu(t,e,r,n){for(var i=0,s=e,a=r-n;s<r;s+=n)i+=(t[a]-t[s])*(t[s+1]+t[a+1]),a=s;return i}function Zu(t,e,r,n,i){Xu(t,e,r||0,n||t.length-1,i||Hu);}function Xu(t,e,r,n,i){for(;n>r;){if(n-r>600){var s=n-r+1,a=e-r+1,o=Math.log(s),l=.5*Math.exp(2*o/3),u=.5*Math.sqrt(o*l*(s-l)/s)*(a-s/2<0?-1:1);Xu(t,e,Math.max(r,Math.floor(e-a*l/s+u)),Math.min(n,Math.floor(e+(s-a)*l/s+u)),i);}var c=t[e],h=r,p=n;for(Ku(t,r,e),i(t[n],c)>0&&Ku(t,r,n);h<p;){for(Ku(t,h,p),h++,p--;i(t[h],c)<0;)h++;for(;i(t[p],c)>0;)p--;}0===i(t[r],c)?Ku(t,r,p):Ku(t,++p,n),p<=e&&(r=p+1),e<=p&&(n=p-1);}}function Ku(t,e,r){var n=t[e];t[e]=t[r],t[r]=n;}function Hu(t,e){return t<e?-1:t>e?1:0}function Yu(t,e){const r=t.length;if(r<=1)return [t];const n=[];let i,s;for(let e=0;e<r;e++){const r=P(t[e]);0!==r&&(t[e].area=Math.abs(r),void 0===s&&(s=r<0),s===r<0?(i&&n.push(i),i=[t[e]]):i.push(t[e]));}if(i&&n.push(i),e>1)for(let t=0;t<n.length;t++)n[t].length<=e||(Zu(n[t],e,1,n[t].length-1,Wu),n[t]=n[t].slice(0,e));return n}function Wu(t,e){return e.area-t.area}function Ju(t,e,r){const n=r.patternDependencies;let i=!1;for(const r of e){const e=r.paint.get(`${t}-pattern`);e.isConstant()||(i=!0);const s=e.constantOr(null);s&&(i=!0,n[s.to]=!0,n[s.from]=!0);}return i}function Qu(t,e,r,n,i){const s=i.patternDependencies;for(const a of e){const e=a.paint.get(`${t}-pattern`).value;if("constant"!==e.kind){let t=e.evaluate({zoom:n-1},r,{},i.availableImages),o=e.evaluate({zoom:n},r,{},i.availableImages),l=e.evaluate({zoom:n+1},r,{},i.availableImages);t=t&&t.name?t.name:t,o=o&&o.name?o.name:o,l=l&&l.name?l.name:l,s[t]=!0,s[o]=!0,s[l]=!0,r.patterns[a.id]={min:t,mid:o,max:l};}}return r}bu.deviation=function(t,e,r,n){var i=e&&e.length,s=Math.abs(Gu(t,0,i?e[0]*r:t.length,r));if(i)for(var a=0,o=e.length;a<o;a++)s-=Math.abs(Gu(t,e[a]*r,a<o-1?e[a+1]*r:t.length,r));var l=0;for(a=0;a<n.length;a+=3){var u=n[a]*r,c=n[a+1]*r,h=n[a+2]*r;l+=Math.abs((t[u]-t[h])*(t[c+1]-t[u+1])-(t[u]-t[c])*(t[h+1]-t[u+1]));}return 0===s&&0===l?0:Math.abs((l-s)/s)},bu.flatten=function(t){for(var e=t[0][0].length,r={vertices:[],holes:[],dimensions:e},n=0,i=0;i<t.length;i++){for(var s=0;s<t[i].length;s++)for(var a=0;a<e;a++)r.vertices.push(t[i][s][a]);i>0&&r.holes.push(n+=t[i-1].length);}return r},xu.default=vu;class tc{constructor(t){this.zoom=t.zoom,this.overscaling=t.overscaling,this.layers=t.layers,this.layerIds=this.layers.map((t=>t.id)),this.index=t.index,this.hasPattern=!1,this.patternFeatures=[],this.layoutVertexArray=new Qs,this.indexArray=new ya,this.indexArray2=new _a,this.programConfigurations=new co(t.layers,t.zoom),this.segments=new _o,this.segments2=new _o,this.stateDependentLayerIds=this.layers.filter((t=>t.isStateDependent())).map((t=>t.id)),this.projection=t.projection;}populate(t,e,r,n){this.hasPattern=Ju("fill",this.layers,e);const i=this.layers[0].layout.get("fill-sort-key"),s=[];for(const{feature:a,id:o,index:l,sourceLayerIndex:u}of t){const t=this.layers[0]._featureFilter.needGeometry,c=Go(a,t);if(!this.layers[0]._featureFilter.filter(new Cs(this.zoom),c,r))continue;const h=i?i.evaluate(c,{},r,e.availableImages):void 0,p={id:o,properties:a.properties,type:a.type,sourceLayerIndex:u,index:l,geometry:t?c.geometry:No(a,r,n),patterns:{},sortKey:h};s.push(p);}i&&s.sort(((t,e)=>t.sortKey-e.sortKey));for(const n of s){const{geometry:i,index:s,sourceLayerIndex:a}=n;if(this.hasPattern){const t=Qu("fill",this.layers,n,this.zoom,e);this.patternFeatures.push(t);}else this.addFeature(n,i,s,r,{},e.availableImages);e.featureIndex.insert(t[s].feature,i,s,a,this.index);}}update(t,e,r,n){this.stateDependentLayers.length&&this.programConfigurations.updatePaintArrays(t,e,this.stateDependentLayers,r,n);}addFeatures(t,e,r,n,i){for(const t of this.patternFeatures)this.addFeature(t,t.geometry,t.index,e,r,n);}isEmpty(){return 0===this.layoutVertexArray.length}uploadPending(){return !this.uploaded||this.programConfigurations.needsUpload}upload(t){this.uploaded||(this.layoutVertexBuffer=t.createVertexBuffer(this.layoutVertexArray,gu),this.indexBuffer=t.createIndexBuffer(this.indexArray),this.indexBuffer2=t.createIndexBuffer(this.indexArray2)),this.programConfigurations.upload(t),this.uploaded=!0;}destroy(){this.layoutVertexBuffer&&(this.layoutVertexBuffer.destroy(),this.indexBuffer.destroy(),this.indexBuffer2.destroy(),this.programConfigurations.destroy(),this.segments.destroy(),this.segments2.destroy());}addFeature(t,e,r,n,i,s=[]){for(const t of Yu(e,500)){let e=0;for(const r of t)e+=r.length;const r=this.segments.prepareSegment(e,this.layoutVertexArray,this.indexArray),n=r.vertexLength,i=[],s=[];for(const e of t){if(0===e.length)continue;e!==t[0]&&s.push(i.length/2);const r=this.segments2.prepareSegment(e.length,this.layoutVertexArray,this.indexArray2),n=r.vertexLength;this.layoutVertexArray.emplaceBack(e[0].x,e[0].y),this.indexArray2.emplaceBack(n+e.length-1,n),i.push(e[0].x),i.push(e[0].y);for(let t=1;t<e.length;t++)this.layoutVertexArray.emplaceBack(e[t].x,e[t].y),this.indexArray2.emplaceBack(n+t-1,n+t),i.push(e[t].x),i.push(e[t].y);r.vertexLength+=e.length,r.primitiveLength+=e.length;}const a=xu(i,s);for(let t=0;t<a.length;t+=3)this.indexArray.emplaceBack(n+a[t],n+a[t+1],n+a[t+2]);r.vertexLength+=e,r.primitiveLength+=a.length/3;}this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length,t,r,i,s,n);}}Pi(tc,"FillBucket",{omit:["layers","patternFeatures"]});const ec=new Zs({"fill-sort-key":new Os(Gt.layout_fill["fill-sort-key"])});var rc={paint:new Zs({"fill-antialias":new $s(Gt.paint_fill["fill-antialias"]),"fill-opacity":new Os(Gt.paint_fill["fill-opacity"]),"fill-color":new Os(Gt.paint_fill["fill-color"]),"fill-outline-color":new Os(Gt.paint_fill["fill-outline-color"]),"fill-translate":new $s(Gt.paint_fill["fill-translate"]),"fill-translate-anchor":new $s(Gt.paint_fill["fill-translate-anchor"]),"fill-pattern":new qs(Gt.paint_fill["fill-pattern"])}),layout:ec};const nc=Ws([{name:"a_pos_normal_ed",components:4,type:"Int16"}]),ic=Ws([{name:"a_centroid_pos",components:2,type:"Uint16"}]),sc=Ws([{name:"a_pos_3",components:3,type:"Int16"},{name:"a_pos_normal_3",components:3,type:"Int16"}]),{members:ac}=nc;var oc=lc;function lc(t,e,r,n,i){this.properties={},this.extent=r,this.type=0,this._pbf=t,this._geometry=-1,this._keys=n,this._values=i,t.readFields(uc,this,e);}function uc(t,e,r){1==t?e.id=r.readVarint():2==t?function(t,e){for(var r=t.readVarint()+t.pos;t.pos<r;){var n=e._keys[t.readVarint()],i=e._values[t.readVarint()];e.properties[n]=i;}}(r,e):3==t?e.type=r.readVarint():4==t&&(e._geometry=r.pos);}function cc(t){for(var e,r,n=0,i=0,s=t.length,a=s-1;i<s;a=i++)n+=((r=t[a]).x-(e=t[i]).x)*(e.y+r.y);return n}lc.types=["Unknown","Point","LineString","Polygon"],lc.prototype.loadGeometry=function(){var t=this._pbf;t.pos=this._geometry;for(var e,r=t.readVarint()+t.pos,n=1,s=0,a=0,o=0,l=[];t.pos<r;){if(s<=0){var u=t.readVarint();n=7&u,s=u>>3;}if(s--,1===n||2===n)a+=t.readSVarint(),o+=t.readSVarint(),1===n&&(e&&l.push(e),e=[]),e.push(new i(a,o));else {if(7!==n)throw new Error("unknown command "+n);e&&e.push(e[0].clone());}}return e&&l.push(e),l},lc.prototype.bbox=function(){var t=this._pbf;t.pos=this._geometry;for(var e=t.readVarint()+t.pos,r=1,n=0,i=0,s=0,a=1/0,o=-1/0,l=1/0,u=-1/0;t.pos<e;){if(n<=0){var c=t.readVarint();r=7&c,n=c>>3;}if(n--,1===r||2===r)(i+=t.readSVarint())<a&&(a=i),i>o&&(o=i),(s+=t.readSVarint())<l&&(l=s),s>u&&(u=s);else if(7!==r)throw new Error("unknown command "+r)}return [a,l,o,u]},lc.prototype.toGeoJSON=function(t,e,r){var n,i,s=this.extent*Math.pow(2,r),a=this.extent*t,o=this.extent*e,l=this.loadGeometry(),u=lc.types[this.type];function c(t){for(var e=0;e<t.length;e++){var r=t[e];t[e]=[360*(r.x+a)/s-180,360/Math.PI*Math.atan(Math.exp((180-360*(r.y+o)/s)*Math.PI/180))-90];}}switch(this.type){case 1:var h=[];for(n=0;n<l.length;n++)h[n]=l[n][0];c(l=h);break;case 2:for(n=0;n<l.length;n++)c(l[n]);break;case 3:for(l=function(t){var e=t.length;if(e<=1)return [t];for(var r,n,i=[],s=0;s<e;s++){var a=cc(t[s]);0!==a&&(void 0===n&&(n=a<0),n===a<0?(r&&i.push(r),r=[t[s]]):r.push(t[s]));}return r&&i.push(r),i}(l),n=0;n<l.length;n++)for(i=0;i<l[n].length;i++)c(l[n][i]);}1===l.length?l=l[0]:u="Multi"+u;var p={type:"Feature",geometry:{type:u,coordinates:l},properties:this.properties};return "id"in this&&(p.id=this.id),p};var hc=pc;function pc(t,e){this.version=1,this.name=null,this.extent=4096,this.length=0,this._pbf=t,this._keys=[],this._values=[],this._features=[],t.readFields(fc,this,e),this.length=this._features.length;}function fc(t,e,r){15===t?e.version=r.readVarint():1===t?e.name=r.readString():5===t?e.extent=r.readVarint():2===t?e._features.push(r.pos):3===t?e._keys.push(r.readString()):4===t&&e._values.push(function(t){for(var e=null,r=t.readVarint()+t.pos;t.pos<r;){var n=t.readVarint()>>3;e=1===n?t.readString():2===n?t.readFloat():3===n?t.readDouble():4===n?t.readVarint64():5===n?t.readVarint():6===n?t.readSVarint():7===n?t.readBoolean():null;}return e}(r));}function dc(t,e,r){if(3===t){var n=new hc(r,r.readVarint()+r.pos);n.length&&(e[n.name]=n);}}pc.prototype.feature=function(t){if(t<0||t>=this._features.length)throw new Error("feature index out of bounds");this._pbf.pos=this._features[t];var e=this._pbf.readVarint()+this._pbf.pos;return new oc(this._pbf,e,this.extent,this._keys,this._values)};var yc={VectorTile:function(t,e){this.layers=t.readFields(dc,{},e);},VectorTileFeature:oc,VectorTileLayer:hc};function mc(t,e,r,n){const s=[],a=0===n?(t,e,r,n,s,a)=>{t.push(new i(a,r+(a-e)/(n-e)*(s-r)));}:(t,e,r,n,s,a)=>{t.push(new i(e+(a-r)/(s-r)*(n-e),a));};for(const i of t){const t=[];for(const s of i){if(s.length<=2)continue;const i=[];for(let t=0;t<s.length-1;t++){const o=s[t].x,l=s[t].y,u=s[t+1].x,c=s[t+1].y,h=0===n?o:l,p=0===n?u:c;h<e?p>e&&a(i,o,l,u,c,e):h>r?p<r&&a(i,o,l,u,c,r):i.push(s[t]),p<e&&h>=e&&a(i,o,l,u,c,e),p>r&&h<=r&&a(i,o,l,u,c,r);}let o=s[s.length-1];const l=0===n?o.x:o.y;l>=e&&l<=r&&i.push(o),i.length&&(o=i[i.length-1],i[0].x===o.x&&i[0].y===o.y||i.push(i[0]),t.push(i));}t.length&&s.push(t);}return s}const gc=yc.VectorTileFeature.types,xc=Math.pow(2,13);function vc(t,e,r,n,i,s,a,o){t.emplaceBack((e<<1)+a,(r<<1)+s,(Math.floor(n*xc)<<1)+i,Math.round(o));}function bc(t,e,r){const n=16384;t.emplaceBack(e.x,e.y,e.z,r[0]*n,r[1]*n,r[2]*n);}class _c{constructor(){this.acc=new i(0,0),this.polyCount=[];}startRing(t){this.currentPolyCount={edges:0,top:0},this.polyCount.push(this.currentPolyCount),this.min||(this.min=new i(t.x,t.y),this.max=new i(t.x,t.y));}append(t,e){this.currentPolyCount.edges++,this.acc._add(t);const r=this.min,n=this.max;t.x<r.x?r.x=t.x:t.x>n.x&&(n.x=t.x),t.y<r.y?r.y=t.y:t.y>n.y&&(n.y=t.y),((0===t.x||t.x===wo)&&t.x===e.x)!=((0===t.y||t.y===wo)&&t.y===e.y)&&this.processBorderOverlap(t,e),e.x<0!=t.x<0&&this.addBorderIntersection(0,xr(e.y,t.y,(0-e.x)/(t.x-e.x))),e.x>wo!=t.x>wo&&this.addBorderIntersection(1,xr(e.y,t.y,(wo-e.x)/(t.x-e.x))),e.y<0!=t.y<0&&this.addBorderIntersection(2,xr(e.x,t.x,(0-e.y)/(t.y-e.y))),e.y>wo!=t.y>wo&&this.addBorderIntersection(3,xr(e.x,t.x,(wo-e.y)/(t.y-e.y)));}addBorderIntersection(t,e){this.borders||(this.borders=[[Number.MAX_VALUE,-Number.MAX_VALUE],[Number.MAX_VALUE,-Number.MAX_VALUE],[Number.MAX_VALUE,-Number.MAX_VALUE],[Number.MAX_VALUE,-Number.MAX_VALUE]]);const r=this.borders[t];e<r[0]&&(r[0]=e),e>r[1]&&(r[1]=e);}processBorderOverlap(t,e){if(t.x===e.x){if(t.y===e.y)return;const r=0===t.x?0:1;this.addBorderIntersection(r,e.y),this.addBorderIntersection(r,t.y);}else {const r=0===t.y?2:3;this.addBorderIntersection(r,e.x),this.addBorderIntersection(r,t.x);}}centroid(){const t=this.polyCount.reduce(((t,e)=>t+e.edges),0);return 0!==t?this.acc.div(t)._round():new i(0,0)}span(){return new i(this.max.x-this.min.x,this.max.y-this.min.y)}intersectsCount(){return this.borders.reduce(((t,e)=>t+ +(e[0]!==Number.MAX_VALUE)),0)}}class wc{constructor(t){this.zoom=t.zoom,this.canonical=t.canonical,this.overscaling=t.overscaling,this.layers=t.layers,this.layerIds=this.layers.map((t=>t.id)),this.index=t.index,this.hasPattern=!1,this.edgeRadius=0,this.projection=t.projection,this.layoutVertexArray=new ea,this.centroidVertexArray=new La,this.indexArray=new ya,this.programConfigurations=new co(t.layers,t.zoom),this.segments=new _o,this.stateDependentLayerIds=this.layers.filter((t=>t.isStateDependent())).map((t=>t.id)),this.enableTerrain=t.enableTerrain;}populate(t,e,r,n){this.features=[],this.hasPattern=Ju("fill-extrusion",this.layers,e),this.featuresOnBorder=[],this.borders=[[],[],[],[]],this.borderDoneWithNeighborZ=[-1,-1,-1,-1],this.tileToMeter=function(t){const e=Math.exp(Math.PI*(1-t.y/(1<<t.z)*2));return 80150034*e/(e*e+1)/wo/(1<<t.z)}(r),this.edgeRadius=this.layers[0].layout.get("fill-extrusion-edge-radius")/this.tileToMeter;for(const{feature:i,id:s,index:a,sourceLayerIndex:o}of t){const t=this.layers[0]._featureFilter.needGeometry,l=Go(i,t);if(!this.layers[0]._featureFilter.filter(new Cs(this.zoom),l,r))continue;const u={id:s,sourceLayerIndex:o,index:a,geometry:t?l.geometry:No(i,r,n),properties:i.properties,type:i.type,patterns:{}},c=this.layoutVertexArray.length;this.hasPattern?this.features.push(Qu("fill-extrusion",this.layers,u,this.zoom,e)):this.addFeature(u,u.geometry,a,r,{},e.availableImages,n),e.featureIndex.insert(i,u.geometry,a,o,this.index,c);}this.sortBorders();}addFeatures(t,e,r,n,i){for(const t of this.features){const{geometry:s}=t;this.addFeature(t,s,t.index,e,r,n,i);}this.sortBorders();}update(t,e,r,n){this.stateDependentLayers.length&&this.programConfigurations.updatePaintArrays(t,e,this.stateDependentLayers,r,n);}isEmpty(){return 0===this.layoutVertexArray.length}uploadPending(){return !this.uploaded||this.programConfigurations.needsUpload}upload(t){this.uploaded||(this.layoutVertexBuffer=t.createVertexBuffer(this.layoutVertexArray,ac),this.indexBuffer=t.createIndexBuffer(this.indexArray),this.layoutVertexExtArray&&(this.layoutVertexExtBuffer=t.createVertexBuffer(this.layoutVertexExtArray,sc.members,!0))),this.programConfigurations.upload(t),this.uploaded=!0;}uploadCentroid(t){0!==this.centroidVertexArray.length&&(this.centroidVertexBuffer?this.needsCentroidUpdate&&this.centroidVertexBuffer.updateData(this.centroidVertexArray):this.centroidVertexBuffer=t.createVertexBuffer(this.centroidVertexArray,ic.members,!0),this.needsCentroidUpdate=!1);}destroy(){this.layoutVertexBuffer&&(this.layoutVertexBuffer.destroy(),this.centroidVertexBuffer&&this.centroidVertexBuffer.destroy(),this.layoutVertexExtBuffer&&this.layoutVertexExtBuffer.destroy(),this.indexBuffer.destroy(),this.programConfigurations.destroy(),this.segments.destroy());}addFeature(t,e,r,n,s,a,o){const l=[new i(0,0),new i(wo,wo)],u=o.projection,c="globe"===u.name,h=this.enableTerrain&&!c?new _c:null,p="Polygon"===gc[t.type];c&&!this.layoutVertexExtArray&&(this.layoutVertexExtArray=new ka);const f=Yu(e,500);for(let t=f.length-1;t>=0;t--){const e=f[t];(0===e.length||(d=e[0]).every((t=>t.x<=0))||d.every((t=>t.x>=wo))||d.every((t=>t.y<=0))||d.every((t=>t.y>=wo)))&&f.splice(t,1);}var d;let y;if(c)y=Bc(f,l,n);else {y=[];for(const t of f)y.push({polygon:t,bounds:l});}const m=p?this.edgeRadius:0;for(const{polygon:t,bounds:e}of y){let r=0,i=0;for(const e of t)p&&!e[0].equals(e[e.length-1])&&e.push(e[0]),i+=p?e.length-1:e.length;const s=this.segments.prepareSegment((p?5:4)*i,this.layoutVertexArray,this.indexArray);if(p){const e=[],i=[];r=s.vertexLength;for(const r of t){let a,o;r.length&&r!==t[0]&&i.push(e.length/2),a=r[1].sub(r[0])._perp()._unit();for(let t=1;t<r.length;t++){const i=r[t],l=r[t===r.length-1?1:t+1];let{x:h,y:p}=i;if(m){o=l.sub(i)._perp()._unit();const t=a.add(o)._unit(),e=m*Math.min(4,1/(a.x*t.x+a.y*t.y));h+=e*t.x,p+=e*t.y,a=o;}vc(this.layoutVertexArray,h,p,0,0,1,1,0),s.vertexLength++,e.push(i.x,i.y),c&&bc(this.layoutVertexExtArray,u.projectTilePoint(h,p,n),u.upVector(n,h,p));}}const a=xu(e,i);for(let t=0;t<a.length;t+=3)this.indexArray.emplaceBack(r+a[t],r+a[t+2],r+a[t+1]),s.primitiveLength++;}for(const i of t){h&&i.length&&h.startRing(i[0]);let t,a,o,l=i.length>4&&Mc(i[i.length-2],i[0],i[1]),f=m?Sc(i[i.length-2],i[0],i[1],m):0;a=i[1].sub(i[0])._perp()._unit();for(let d=1,y=0;d<i.length;d++){let g=i[d-1],x=i[d];const v=i[d===i.length-1?1:d+1];if(h&&p&&h.currentPolyCount.top++,Ic(x,g,e)){m&&(a=v.sub(x)._perp()._unit());continue}h&&h.append(x,g);const b=x.sub(g)._perp(),_=b.x/(Math.abs(b.x)+Math.abs(b.y)),w=b.y>0?1:0,A=g.dist(x);if(y+A>32768&&(y=0),m){o=v.sub(x)._perp()._unit();let t=kc(g,x,v,Ac(a,o),m);isNaN(t)&&(t=0);const e=x.sub(g)._unit();g=g.add(e.mult(f))._round(),x=x.add(e.mult(-t))._round(),f=t,a=o;}const S=s.vertexLength,k=i.length>4&&Mc(g,x,v);let I=zc(y,l,!0);if(vc(this.layoutVertexArray,g.x,g.y,_,w,0,0,I),vc(this.layoutVertexArray,g.x,g.y,_,w,0,1,I),y+=A,I=zc(y,k,!1),l=k,vc(this.layoutVertexArray,x.x,x.y,_,w,0,0,I),vc(this.layoutVertexArray,x.x,x.y,_,w,0,1,I),s.vertexLength+=4,this.indexArray.emplaceBack(S+0,S+1,S+2),this.indexArray.emplaceBack(S+1,S+3,S+2),s.primitiveLength+=2,m){const n=r+(1===d?i.length-2:d-2),a=1===d?r:n+1;if(this.indexArray.emplaceBack(S+1,n,S+3),this.indexArray.emplaceBack(n,a,S+3),s.primitiveLength+=2,void 0===t&&(t=S),!Ic(v,i[d],e)){const e=d===i.length-1?t:s.vertexLength;this.indexArray.emplaceBack(S+2,S+3,e),this.indexArray.emplaceBack(S+3,e+1,e),this.indexArray.emplaceBack(S+3,a,e+1),s.primitiveLength+=3;}}if(c){const t=this.layoutVertexExtArray,e=u.projectTilePoint(g.x,g.y,n),r=u.projectTilePoint(x.x,x.y,n),i=u.upVector(n,g.x,g.y),s=u.upVector(n,x.x,x.y);bc(t,e,i),bc(t,e,i),bc(t,r,s),bc(t,r,s);}}p&&(r+=i.length-1);}}if(h&&h.polyCount.length>0){if(h.borders){h.vertexArrayOffset=this.centroidVertexArray.length;const t=h.borders,e=this.featuresOnBorder.push(h)-1;for(let r=0;r<4;r++)t[r][0]!==Number.MAX_VALUE&&this.borders[r].push(e);}this.encodeCentroid(h.borders?void 0:h.centroid(),h);}this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length,t,r,s,a,n);}sortBorders(){for(let t=0;t<4;t++)this.borders[t].sort(((e,r)=>this.featuresOnBorder[e].borders[t][0]-this.featuresOnBorder[r].borders[t][0]));}encodeCentroid(t,e,r=!0){let n,i;if(t)if(0!==t.y){const r=e.span()._mult(this.tileToMeter);n=(Math.max(t.x,1)<<3)+Math.min(7,Math.round(r.x/10)),i=(Math.max(t.y,1)<<3)+Math.min(7,Math.round(r.y/10));}else n=Math.ceil(7*(t.x+450)),i=0;else n=0,i=+r;let s=r?this.centroidVertexArray.length:e.vertexArrayOffset;for(const t of e.polyCount){r&&this.centroidVertexArray.resize(this.centroidVertexArray.length+4*t.edges+t.top);for(let e=0;e<t.top;e++)this.centroidVertexArray.emplace(s++,n,i);for(let e=0;e<2*t.edges;e++)this.centroidVertexArray.emplace(s++,0,i),this.centroidVertexArray.emplace(s++,n,i);}}}function Ac(t,e){const r=t.add(e)._unit();return t.x*r.x+t.y*r.y}function Sc(t,e,r,n){const i=e.sub(t)._perp()._unit(),s=r.sub(e)._perp()._unit();return kc(t,e,r,Ac(i,s),n)}function kc(t,e,r,n,i){const s=Math.sqrt(1-n*n);return Math.min(t.dist(e)/3,e.dist(r)/3,i*s/n)}function Ic(t,e,r){return t.x<r[0].x&&e.x<r[0].x||t.x>r[1].x&&e.x>r[1].x||t.y<r[0].y&&e.y<r[0].y||t.y>r[1].y&&e.y>r[1].y}function Mc(t,e,r){if(t.x<0||t.x>=wo||e.x<0||e.x>=wo||r.x<0||r.x>=wo)return !1;const n=r.sub(e),i=n.perp(),s=t.sub(e);return (n.x*s.x+n.y*s.y)/Math.sqrt((n.x*n.x+n.y*n.y)*(s.x*s.x+s.y*s.y))>-.866&&i.x*s.x+i.y*s.y<0}function zc(t,e,r){const n=e?2|t:-3&t;return r?1|n:-2&n}function Tc(){const t=Math.PI/32,e=Math.tan(t),r=So;return r*Math.sqrt(1+2*e*e)-r}function Bc(t,e,r){const n=1<<r.z,s=Eo(r.x/n),a=Eo((r.x+1)/n),o=Co(r.y/n),l=Co((r.y+1)/n);return function(t,e,r,n,s=0,a){const o=[];if(!t.length||!r||!n)return o;const l=(t,e)=>{for(const r of t)o.push({polygon:r,bounds:e});},u=Math.ceil(Math.log2(r)),c=Math.ceil(Math.log2(n)),h=u-c,p=[];for(let t=0;t<Math.abs(h);t++)p.push(h>0?0:1);for(let t=0;t<Math.min(u,c);t++)p.push(0),p.push(1);let f=t;if(f=mc(f,e[0].y-s,e[1].y+s,1),f=mc(f,e[0].x-s,e[1].x+s,0),!f.length)return o;const d=[];for(p.length?d.push({polygons:f,bounds:e,depth:0}):l(f,e);d.length;){const t=d.pop(),e=t.depth,r=p[e],n=t.bounds[0],o=t.bounds[1],u=0===r?n.x:n.y,c=0===r?o.x:o.y,h=a?a(r,u,c):.5*(u+c),f=mc(t.polygons,u-s,h+s,r),y=mc(t.polygons,h-s,c+s,r);if(f.length){const t=[n,new i(0===r?h:o.x,1===r?h:o.y)];p.length>e+1?d.push({polygons:f,bounds:t,depth:e+1}):l(f,t);}if(y.length){const t=[new i(0===r?h:n.x,1===r?h:n.y),o];p.length>e+1?d.push({polygons:y,bounds:t,depth:e+1}):l(y,t);}}return o}(t,e,Math.ceil((a-s)/11.25),Math.ceil((o-l)/11.25),1,((t,e,i)=>{if(0===t)return .5*(e+i);{const t=Co((r.y+e/wo)/n);return (To(.5*(Co((r.y+i/wo)/n)+t))*n-r.y)*wo}}))}Pi(wc,"FillExtrusionBucket",{omit:["layers","features"]}),Pi(_c,"PartMetadata");const Ec=new Zs({"fill-extrusion-edge-radius":new $s(Gt["layout_fill-extrusion"]["fill-extrusion-edge-radius"])});var Cc={paint:new Zs({"fill-extrusion-opacity":new $s(Gt["paint_fill-extrusion"]["fill-extrusion-opacity"]),"fill-extrusion-color":new Os(Gt["paint_fill-extrusion"]["fill-extrusion-color"]),"fill-extrusion-translate":new $s(Gt["paint_fill-extrusion"]["fill-extrusion-translate"]),"fill-extrusion-translate-anchor":new $s(Gt["paint_fill-extrusion"]["fill-extrusion-translate-anchor"]),"fill-extrusion-pattern":new qs(Gt["paint_fill-extrusion"]["fill-extrusion-pattern"]),"fill-extrusion-height":new Os(Gt["paint_fill-extrusion"]["fill-extrusion-height"]),"fill-extrusion-base":new Os(Gt["paint_fill-extrusion"]["fill-extrusion-base"]),"fill-extrusion-vertical-gradient":new $s(Gt["paint_fill-extrusion"]["fill-extrusion-vertical-gradient"]),"fill-extrusion-ambient-occlusion-intensity":new $s(Gt["paint_fill-extrusion"]["fill-extrusion-ambient-occlusion-intensity"]),"fill-extrusion-ambient-occlusion-radius":new $s(Gt["paint_fill-extrusion"]["fill-extrusion-ambient-occlusion-radius"])}),layout:Ec};function Pc(t,e,r){var n=2*Math.PI*6378137/256/Math.pow(2,r);return [t*n-2*Math.PI*6378137/2,e*n-2*Math.PI*6378137/2]}class Dc{constructor(t,e,r){this.z=t,this.x=e,this.y=r,this.key=Lc(0,t,t,e,r);}equals(t){return this.z===t.z&&this.x===t.x&&this.y===t.y}url(t,e){const r=function(t,e,r){var n=Pc(256*t,256*(e=Math.pow(2,r)-e-1),r),i=Pc(256*(t+1),256*(e+1),r);return n[0]+","+n[1]+","+i[0]+","+i[1]}(this.x,this.y,this.z),n=function(t,e,r){let n,i="";for(let s=t;s>0;s--)n=1<<s-1,i+=(e&n?1:0)+(r&n?2:0);return i}(this.z,this.x,this.y);return t[(this.x+this.y)%t.length].replace("{prefix}",(this.x%16).toString(16)+(this.y%16).toString(16)).replace(/{z}/g,String(this.z)).replace(/{x}/g,String(this.x)).replace(/{y}/g,String("tms"===e?Math.pow(2,this.z)-this.y-1:this.y)).replace("{quadkey}",n).replace("{bbox-epsg-3857}",r)}toString(){return `${this.z}/${this.x}/${this.y}`}}class Vc{constructor(t,e){this.wrap=t,this.canonical=e,this.key=Lc(t,e.z,e.z,e.x,e.y);}}class Fc{constructor(t,e,r,n,i){this.overscaledZ=t,this.wrap=e,this.canonical=new Dc(r,+n,+i),this.key=0===e&&t===r?this.canonical.key:Lc(e,t,r,n,i);}equals(t){return this.overscaledZ===t.overscaledZ&&this.wrap===t.wrap&&this.canonical.equals(t.canonical)}scaledTo(t){const e=this.canonical.z-t;return t>this.canonical.z?new Fc(t,this.wrap,this.canonical.z,this.canonical.x,this.canonical.y):new Fc(t,this.wrap,t,this.canonical.x>>e,this.canonical.y>>e)}calculateScaledKey(t,e=!0){if(this.overscaledZ===t&&e)return this.key;if(t>this.canonical.z)return Lc(this.wrap*+e,t,this.canonical.z,this.canonical.x,this.canonical.y);{const r=this.canonical.z-t;return Lc(this.wrap*+e,t,t,this.canonical.x>>r,this.canonical.y>>r)}}isChildOf(t){if(t.wrap!==this.wrap)return !1;const e=this.canonical.z-t.canonical.z;return 0===t.overscaledZ||t.overscaledZ<this.overscaledZ&&t.canonical.x===this.canonical.x>>e&&t.canonical.y===this.canonical.y>>e}children(t){if(this.overscaledZ>=t)return [new Fc(this.overscaledZ+1,this.wrap,this.canonical.z,this.canonical.x,this.canonical.y)];const e=this.canonical.z+1,r=2*this.canonical.x,n=2*this.canonical.y;return [new Fc(e,this.wrap,e,r,n),new Fc(e,this.wrap,e,r+1,n),new Fc(e,this.wrap,e,r,n+1),new Fc(e,this.wrap,e,r+1,n+1)]}isLessThan(t){return this.wrap<t.wrap||!(this.wrap>t.wrap)&&(this.overscaledZ<t.overscaledZ||!(this.overscaledZ>t.overscaledZ)&&(this.canonical.x<t.canonical.x||!(this.canonical.x>t.canonical.x)&&this.canonical.y<t.canonical.y))}wrapped(){return new Fc(this.overscaledZ,0,this.canonical.z,this.canonical.x,this.canonical.y)}unwrapTo(t){return new Fc(this.overscaledZ,t,this.canonical.z,this.canonical.x,this.canonical.y)}overscaleFactor(){return Math.pow(2,this.overscaledZ-this.canonical.z)}toUnwrapped(){return new Vc(this.wrap,this.canonical)}toString(){return `${this.overscaledZ}/${this.canonical.x}/${this.canonical.y}`}}function Lc(t,e,r,n,i){const s=1<<Math.min(r,22);let a=s*(i%s)+n%s;return t&&r<22&&(a+=s*s*((t<0?-2*t-1:2*t)%(1<<2*(22-r)))),16*(32*a+r)+(e-r)}function Rc(t,e){return t.x*e.x+t.y*e.y}function Uc(t,e){if(1===t.length){let r=0;const n=e[r++];let i;for(;!i||n.equals(i);)if(i=e[r++],!i)return 1/0;for(;r<e.length;r++){const s=e[r],a=t[0],o=i.sub(n),l=s.sub(n),u=a.sub(n),c=Rc(o,o),h=Rc(o,l),p=Rc(l,l),f=Rc(u,o),d=Rc(u,l),y=c*p-h*h,m=(p*f-h*d)/y,g=(c*d-h*f)/y,x=n.z*(1-m-g)+i.z*m+s.z*g;if(isFinite(x))return x}return 1/0}{let t=1/0;for(const r of e)t=Math.min(t,r.z);return t}}function jc(t){const e=new i(t[0],t[1]);return e.z=t[2],e}function $c(t,e,r,n,i,s,a,o){const l=a*i.getElevationAt(t,e,!0,!0),u=0!==s[0],c=u?0===s[1]?a*(s[0]/7-450):a*function(t,e,r){const n=Math.floor(e[0]/8),i=Math.floor(e[1]/8),s=10*(e[0]-8*n),a=10*(e[1]-8*i),o=t.getElevationAt(n,i,!0,!0),l=t.getMeterToDEM(r),u=Math.floor(.5*(s*l-1)),c=Math.floor(.5*(a*l-1)),h=t.tileCoordToPixel(n,i),p=2*u+1,f=2*c+1,d=function(t,e,r,n,i){return [t.getElevationAtPixel(e,r,!0),t.getElevationAtPixel(e+i,r,!0),t.getElevationAtPixel(e,r+i,!0),t.getElevationAtPixel(e+n,r+i,!0)]}(t,h.x-u,h.y-c,p,f),y=Math.abs(d[0]-d[1]),m=Math.abs(d[2]-d[3]),g=Math.abs(d[0]-d[2])+Math.abs(d[1]-d[3]),x=Math.min(.25,.5*l*(y+m)/p),v=Math.min(.25,.5*l*g/f);return o+Math.max(x*s,v*a)}(i,s,o):l;return {base:l+(0===r)?-1:r,top:u?Math.max(c+n,l+r+2):l+n}}Pi(Dc,"CanonicalTileID"),Pi(Fc,"OverscaledTileID",{omit:["projMatrix"]});const Oc=Ws([{name:"a_pos_normal",components:2,type:"Int16"},{name:"a_data",components:4,type:"Uint8"},{name:"a_linesofar",components:1,type:"Float32"}],4),{members:qc}=Oc,Nc=Ws([{name:"a_packed",components:4,type:"Float32"}]),{members:Gc}=Nc,Zc=yc.VectorTileFeature.types,Xc=Math.cos(Math.PI/180*37.5);class Kc{constructor(t){this.zoom=t.zoom,this.overscaling=t.overscaling,this.layers=t.layers,this.layerIds=this.layers.map((t=>t.id)),this.index=t.index,this.projection=t.projection,this.hasPattern=!1,this.patternFeatures=[],this.lineClipsArray=[],this.gradients={},this.layers.forEach((t=>{this.gradients[t.id]={};})),this.layoutVertexArray=new ra,this.layoutVertexArray2=new na,this.indexArray=new ya,this.programConfigurations=new co(t.layers,t.zoom),this.segments=new _o,this.maxLineLength=0,this.stateDependentLayerIds=this.layers.filter((t=>t.isStateDependent())).map((t=>t.id));}populate(t,e,r,n){this.hasPattern=Ju("line",this.layers,e);const i=this.layers[0].layout.get("line-sort-key"),s=[];for(const{feature:e,id:a,index:o,sourceLayerIndex:l}of t){const t=this.layers[0]._featureFilter.needGeometry,u=Go(e,t);if(!this.layers[0]._featureFilter.filter(new Cs(this.zoom),u,r))continue;const c=i?i.evaluate(u,{},r):void 0,h={id:a,properties:e.properties,type:e.type,sourceLayerIndex:l,index:o,geometry:t?u.geometry:No(e,r,n),patterns:{},sortKey:c};s.push(h);}i&&s.sort(((t,e)=>t.sortKey-e.sortKey));const{lineAtlas:a,featureIndex:o}=e,l=this.addConstantDashes(a);for(const n of s){const{geometry:i,index:s,sourceLayerIndex:u}=n;if(l&&this.addFeatureDashes(n,a),this.hasPattern){const t=Qu("line",this.layers,n,this.zoom,e);this.patternFeatures.push(t);}else this.addFeature(n,i,s,r,a.positions,e.availableImages);o.insert(t[s].feature,i,s,u,this.index);}}addConstantDashes(t){let e=!1;for(const r of this.layers){const n=r.paint.get("line-dasharray").value,i=r.layout.get("line-cap").value;if("constant"!==n.kind||"constant"!==i.kind)e=!0;else {const e=i.value,r=n.value;if(!r)continue;t.addDash(r.from,e),t.addDash(r.to,e),r.other&&t.addDash(r.other,e);}}return e}addFeatureDashes(t,e){const r=this.zoom;for(const n of this.layers){const i=n.paint.get("line-dasharray").value,s=n.layout.get("line-cap").value;if("constant"===i.kind&&"constant"===s.kind)continue;let a,o,l,u,c,h;if("constant"===i.kind){const t=i.value;if(!t)continue;a=t.other||t.to,o=t.to,l=t.from;}else a=i.evaluate({zoom:r-1},t),o=i.evaluate({zoom:r},t),l=i.evaluate({zoom:r+1},t);"constant"===s.kind?u=c=h=s.value:(u=s.evaluate({zoom:r-1},t),c=s.evaluate({zoom:r},t),h=s.evaluate({zoom:r+1},t)),e.addDash(a,u),e.addDash(o,c),e.addDash(l,h);const p=e.getKey(a,u),f=e.getKey(o,c),d=e.getKey(l,h);t.patterns[n.id]={min:p,mid:f,max:d};}}update(t,e,r,n){this.stateDependentLayers.length&&this.programConfigurations.updatePaintArrays(t,e,this.stateDependentLayers,r,n);}addFeatures(t,e,r,n,i){for(const t of this.patternFeatures)this.addFeature(t,t.geometry,t.index,e,r,n);}isEmpty(){return 0===this.layoutVertexArray.length}uploadPending(){return !this.uploaded||this.programConfigurations.needsUpload}upload(t){this.uploaded||(0!==this.layoutVertexArray2.length&&(this.layoutVertexBuffer2=t.createVertexBuffer(this.layoutVertexArray2,Gc)),this.layoutVertexBuffer=t.createVertexBuffer(this.layoutVertexArray,qc),this.indexBuffer=t.createIndexBuffer(this.indexArray)),this.programConfigurations.upload(t),this.uploaded=!0;}destroy(){this.layoutVertexBuffer&&(this.layoutVertexBuffer.destroy(),this.indexBuffer.destroy(),this.programConfigurations.destroy(),this.segments.destroy());}lineFeatureClips(t){if(t.properties&&t.properties.hasOwnProperty("mapbox_clip_start")&&t.properties.hasOwnProperty("mapbox_clip_end"))return {start:+t.properties.mapbox_clip_start,end:+t.properties.mapbox_clip_end}}addFeature(t,e,r,n,i,s){const a=this.layers[0].layout,o=a.get("line-join").evaluate(t,{}),l=a.get("line-cap").evaluate(t,{}),u=a.get("line-miter-limit"),c=a.get("line-round-limit");this.lineClips=this.lineFeatureClips(t);for(const r of e)this.addLine(r,t,o,l,u,c);this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length,t,r,i,s,n);}addLine(t,e,r,n,i,s){if(this.distance=0,this.scaledDistance=0,this.totalDistance=0,this.lineSoFar=0,this.lineClips){this.lineClipsArray.push(this.lineClips);for(let e=0;e<t.length-1;e++)this.totalDistance+=t[e].dist(t[e+1]);this.updateScaledDistance(),this.maxLineLength=Math.max(this.maxLineLength,this.totalDistance);}const a="Polygon"===Zc[e.type];let o=t.length;for(;o>=2&&t[o-1].equals(t[o-2]);)o--;let l=0;for(;l<o-1&&t[l].equals(t[l+1]);)l++;if(o<(a?3:2))return;"bevel"===r&&(i=1.05);const u=this.overscaling<=16?122880/(512*this.overscaling):0,c=this.segments.prepareSegment(10*o,this.layoutVertexArray,this.indexArray);let h,p,f,d,y;this.e1=this.e2=-1,a&&(h=t[o-2],y=t[l].sub(h)._unit()._perp());for(let e=l;e<o;e++){if(f=e===o-1?a?t[l+1]:void 0:t[e+1],f&&t[e].equals(f))continue;y&&(d=y),h&&(p=h),h=t[e],y=f?f.sub(h)._unit()._perp():d,d=d||y;let m=d.add(y);0===m.x&&0===m.y||m._unit();const g=d.x*y.x+d.y*y.y,x=m.x*y.x+m.y*y.y,v=0!==x?1/x:1/0,b=2*Math.sqrt(2-2*x),_=x<Xc&&p&&f,w=d.x*y.y-d.y*y.x>0;if(_&&e>l){const t=h.dist(p);if(t>2*u){const e=h.sub(h.sub(p)._mult(u/t)._round());this.updateDistance(p,e),this.addCurrentVertex(e,d,0,0,c),p=e;}}const A=p&&f;let S=A?r:a?"butt":n;if(A&&"round"===S&&(v<s?S="miter":v<=2&&(S="fakeround")),"miter"===S&&v>i&&(S="bevel"),"bevel"===S&&(v>2&&(S="flipbevel"),v<i&&(S="miter")),p&&this.updateDistance(p,h),"miter"===S)m._mult(v),this.addCurrentVertex(h,m,0,0,c);else if("flipbevel"===S){if(v>100)m=y.mult(-1);else {const t=v*d.add(y).mag()/d.sub(y).mag();m._perp()._mult(t*(w?-1:1));}this.addCurrentVertex(h,m,0,0,c),this.addCurrentVertex(h,m.mult(-1),0,0,c);}else if("bevel"===S||"fakeround"===S){const t=-Math.sqrt(v*v-1),e=w?t:0,r=w?0:t;if(p&&this.addCurrentVertex(h,d,e,r,c),"fakeround"===S){const t=Math.round(180*b/Math.PI/20);for(let e=1;e<t;e++){let r=e/t;if(.5!==r){const t=r-.5;r+=r*t*(r-1)*((1.0904+g*(g*(3.55645-1.43519*g)-3.2452))*t*t+(.848013+g*(.215638*g-1.06021)));}const n=y.sub(d)._mult(r)._add(d)._unit()._mult(w?-1:1);this.addHalfVertex(h,n.x,n.y,!1,w,0,c);}}f&&this.addCurrentVertex(h,y,-e,-r,c);}else if("butt"===S)this.addCurrentVertex(h,m,0,0,c);else if("square"===S){const t=p?1:-1;p||this.addCurrentVertex(h,m,t,t,c),this.addCurrentVertex(h,m,0,0,c),p&&this.addCurrentVertex(h,m,t,t,c);}else "round"===S&&(p&&(this.addCurrentVertex(h,d,0,0,c),this.addCurrentVertex(h,d,1,1,c,!0)),f&&(this.addCurrentVertex(h,y,-1,-1,c,!0),this.addCurrentVertex(h,y,0,0,c)));if(_&&e<o-1){const t=h.dist(f);if(t>2*u){const e=h.add(f.sub(h)._mult(u/t)._round());this.updateDistance(h,e),this.addCurrentVertex(e,y,0,0,c),h=e;}}}}addCurrentVertex(t,e,r,n,i,s=!1){const a=e.y*n-e.x,o=-e.y-e.x*n;this.addHalfVertex(t,e.x+e.y*r,e.y-e.x*r,s,!1,r,i),this.addHalfVertex(t,a,o,s,!0,-n,i);}addHalfVertex({x:t,y:e},r,n,i,s,a,o){this.layoutVertexArray.emplaceBack((t<<1)+(i?1:0),(e<<1)+(s?1:0),Math.round(63*r)+128,Math.round(63*n)+128,1+(0===a?0:a<0?-1:1),0,this.lineSoFar),this.lineClips&&this.layoutVertexArray2.emplaceBack(this.scaledDistance,this.lineClipsArray.length,this.lineClips.start,this.lineClips.end);const l=o.vertexLength++;this.e1>=0&&this.e2>=0&&(this.indexArray.emplaceBack(this.e1,this.e2,l),o.primitiveLength++),s?this.e2=l:this.e1=l;}updateScaledDistance(){if(this.lineClips){const t=this.totalDistance/(this.lineClips.end-this.lineClips.start);this.scaledDistance=this.distance/this.totalDistance,this.lineSoFar=t*this.lineClips.start+this.distance;}else this.lineSoFar=this.distance;}updateDistance(t,e){this.distance+=t.dist(e),this.updateScaledDistance();}}Pi(Kc,"LineBucket",{omit:["layers","patternFeatures"]});const Hc=new Zs({"line-cap":new Os(Gt.layout_line["line-cap"]),"line-join":new Os(Gt.layout_line["line-join"]),"line-miter-limit":new $s(Gt.layout_line["line-miter-limit"]),"line-round-limit":new $s(Gt.layout_line["line-round-limit"]),"line-sort-key":new Os(Gt.layout_line["line-sort-key"])});var Yc={paint:new Zs({"line-opacity":new Os(Gt.paint_line["line-opacity"]),"line-color":new Os(Gt.paint_line["line-color"]),"line-translate":new $s(Gt.paint_line["line-translate"]),"line-translate-anchor":new $s(Gt.paint_line["line-translate-anchor"]),"line-width":new Os(Gt.paint_line["line-width"]),"line-gap-width":new Os(Gt.paint_line["line-gap-width"]),"line-offset":new Os(Gt.paint_line["line-offset"]),"line-blur":new Os(Gt.paint_line["line-blur"]),"line-dasharray":new qs(Gt.paint_line["line-dasharray"]),"line-pattern":new qs(Gt.paint_line["line-pattern"]),"line-gradient":new Gs(Gt.paint_line["line-gradient"]),"line-trim-offset":new $s(Gt.paint_line["line-trim-offset"])}),layout:Hc};const Wc=new class extends Os{possiblyEvaluate(t,e){return e=new Cs(Math.floor(e.zoom),{now:e.now,fadeDuration:e.fadeDuration,zoomHistory:e.zoomHistory,transition:e.transition}),super.possiblyEvaluate(t,e)}evaluate(t,e,r,n){return e=v({},e,{zoom:Math.floor(e.zoom)}),super.evaluate(t,e,r,n)}}(Yc.paint.properties["line-width"].specification);function Jc(t,e){return e>0?e+2*t:t}Wc.useIntegerZoom=!0;const Qc=Ws([{name:"a_pos_offset",components:4,type:"Int16"},{name:"a_tex_size",components:4,type:"Uint16"},{name:"a_pixeloffset",components:4,type:"Int16"}],4),th=Ws([{name:"a_globe_anchor",components:3,type:"Int16"},{name:"a_globe_normal",components:3,type:"Float32"}],4),eh=Ws([{name:"a_projected_pos",components:4,type:"Float32"}],4);Ws([{name:"a_fade_opacity",components:1,type:"Uint32"}],4);const rh=Ws([{name:"a_placed",components:2,type:"Uint8"},{name:"a_shift",components:2,type:"Float32"}]),nh=Ws([{name:"a_size_scale",components:1,type:"Float32"},{name:"a_padding",components:2,type:"Float32"}]);Ws([{type:"Int16",name:"projectedAnchorX"},{type:"Int16",name:"projectedAnchorY"},{type:"Int16",name:"projectedAnchorZ"},{type:"Int16",name:"tileAnchorX"},{type:"Int16",name:"tileAnchorY"},{type:"Float32",name:"x1"},{type:"Float32",name:"y1"},{type:"Float32",name:"x2"},{type:"Float32",name:"y2"},{type:"Int16",name:"padding"},{type:"Uint32",name:"featureIndex"},{type:"Uint16",name:"sourceLayerIndex"},{type:"Uint16",name:"bucketIndex"}]);const ih=Ws([{name:"a_pos",components:3,type:"Int16"},{name:"a_anchor_pos",components:2,type:"Int16"},{name:"a_extrude",components:2,type:"Int16"}],4),sh=Ws([{name:"a_pos_2f",components:2,type:"Float32"},{name:"a_radius",components:1,type:"Float32"},{name:"a_flags",components:2,type:"Int16"}],4);Ws([{name:"triangle",components:3,type:"Uint16"}]),Ws([{type:"Int16",name:"projectedAnchorX"},{type:"Int16",name:"projectedAnchorY"},{type:"Int16",name:"projectedAnchorZ"},{type:"Float32",name:"tileAnchorX"},{type:"Float32",name:"tileAnchorY"},{type:"Uint16",name:"glyphStartIndex"},{type:"Uint16",name:"numGlyphs"},{type:"Uint32",name:"vertexStartIndex"},{type:"Uint32",name:"lineStartIndex"},{type:"Uint32",name:"lineLength"},{type:"Uint16",name:"segment"},{type:"Uint16",name:"lowerSize"},{type:"Uint16",name:"upperSize"},{type:"Float32",name:"lineOffsetX"},{type:"Float32",name:"lineOffsetY"},{type:"Uint8",name:"writingMode"},{type:"Uint8",name:"placedOrientation"},{type:"Uint8",name:"hidden"},{type:"Uint32",name:"crossTileID"},{type:"Int16",name:"associatedIconIndex"},{type:"Uint8",name:"flipState"}]),Ws([{type:"Int16",name:"projectedAnchorX"},{type:"Int16",name:"projectedAnchorY"},{type:"Int16",name:"projectedAnchorZ"},{type:"Float32",name:"tileAnchorX"},{type:"Float32",name:"tileAnchorY"},{type:"Int16",name:"rightJustifiedTextSymbolIndex"},{type:"Int16",name:"centerJustifiedTextSymbolIndex"},{type:"Int16",name:"leftJustifiedTextSymbolIndex"},{type:"Int16",name:"verticalPlacedTextSymbolIndex"},{type:"Int16",name:"placedIconSymbolIndex"},{type:"Int16",name:"verticalPlacedIconSymbolIndex"},{type:"Uint16",name:"key"},{type:"Uint16",name:"textBoxStartIndex"},{type:"Uint16",name:"textBoxEndIndex"},{type:"Uint16",name:"verticalTextBoxStartIndex"},{type:"Uint16",name:"verticalTextBoxEndIndex"},{type:"Uint16",name:"iconBoxStartIndex"},{type:"Uint16",name:"iconBoxEndIndex"},{type:"Uint16",name:"verticalIconBoxStartIndex"},{type:"Uint16",name:"verticalIconBoxEndIndex"},{type:"Uint16",name:"featureIndex"},{type:"Uint16",name:"numHorizontalGlyphVertices"},{type:"Uint16",name:"numVerticalGlyphVertices"},{type:"Uint16",name:"numIconVertices"},{type:"Uint16",name:"numVerticalIconVertices"},{type:"Uint16",name:"useRuntimeCollisionCircles"},{type:"Uint32",name:"crossTileID"},{type:"Float32",components:2,name:"textOffset"},{type:"Float32",name:"collisionCircleDiameter"}]),Ws([{type:"Float32",name:"offsetX"}]),Ws([{type:"Int16",name:"x"},{type:"Int16",name:"y"},{type:"Int16",name:"tileUnitDistanceFromAnchor"}]);var ah=24;const oh=128;function lh(t,e){const{expression:r}=e;if("constant"===r.kind)return {kind:"constant",layoutSize:r.evaluate(new Cs(t+1))};if("source"===r.kind)return {kind:"source"};{const{zoomStops:e,interpolationType:n}=r;let i=0;for(;i<e.length&&e[i]<=t;)i++;i=Math.max(0,i-1);let s=i;for(;s<e.length&&e[s]<t+1;)s++;s=Math.min(e.length-1,s);const a=e[i],o=e[s];return "composite"===r.kind?{kind:"composite",minZoom:a,maxZoom:o,interpolationType:n}:{kind:"camera",minZoom:a,maxZoom:o,minSize:r.evaluate(new Cs(a)),maxSize:r.evaluate(new Cs(o)),interpolationType:n}}}function uh(t,{uSize:e,uSizeT:r},{lowerSize:n,upperSize:i}){return "source"===t.kind?n/oh:"composite"===t.kind?xr(n/oh,i/oh,r):e}function ch(t,e){let r=0,n=0;if("constant"===t.kind)n=t.layoutSize;else if("source"!==t.kind){const{interpolationType:i,minZoom:s,maxZoom:a}=t,o=i?d(jr.interpolationFactor(i,e,s,a),0,1):0;"camera"===t.kind?n=xr(t.minSize,t.maxSize,o):r=o;}return {uSizeT:r,uSize:n}}var hh=Object.freeze({__proto__:null,getSizeData:lh,evaluateSizeForFeature:uh,evaluateSizeForZoom:ch,SIZE_PACK_FACTOR:oh});function ph(t,e,r){return t.sections.forEach((t=>{t.text=function(t,e,r){const n=e.layout.get("text-transform").evaluate(r,{});return "uppercase"===n?t=t.toLocaleUpperCase():"lowercase"===n&&(t=t.toLocaleLowerCase()),Es.applyArabicShaping&&(t=Es.applyArabicShaping(t)),t}(t.text,e,r);})),t}const fh={"!":"︕","#":"＃",$:"＄","%":"％","&":"＆","(":"︵",")":"︶","*":"＊","+":"＋",",":"︐","-":"︲",".":"・","/":"／",":":"︓",";":"︔","<":"︿","=":"＝",">":"﹀","?":"︖","@":"＠","[":"﹇","\\":"＼","]":"﹈","^":"＾",_:"︳","`":"｀","{":"︷","|":"―","}":"︸","~":"～","¢":"￠","£":"￡","¥":"￥","¦":"￤","¬":"￢","¯":"￣","–":"︲","—":"︱","‘":"﹃","’":"﹄","“":"﹁","”":"﹂","…":"︙","‧":"・","₩":"￦","、":"︑","。":"︒","〈":"︿","〉":"﹀","《":"︽","》":"︾","「":"﹁","」":"﹂","『":"﹃","』":"﹄","【":"︻","】":"︼","〔":"︹","〕":"︺","〖":"︗","〗":"︘","！":"︕","（":"︵","）":"︶","，":"︐","－":"︲","．":"・","：":"︓","；":"︔","＜":"︿","＞":"﹀","？":"︖","［":"﹇","］":"﹈","＿":"︳","｛":"︷","｜":"―","｝":"︸","｟":"︵","｠":"︶","｡":"︒","｢":"﹁","｣":"﹂"};function dh(t){return "︶"===t||"﹈"===t||"︸"===t||"﹄"===t||"﹂"===t||"︾"===t||"︼"===t||"︺"===t||"︘"===t||"﹀"===t||"︐"===t||"︓"===t||"︔"===t||"｀"===t||"￣"===t||"︑"===t||"︒"===t}function yh(t){return "︵"===t||"﹇"===t||"︷"===t||"﹃"===t||"﹁"===t||"︽"===t||"︻"===t||"︹"===t||"︗"===t||"︿"===t}var mh=function(t,e,r,n,i){var s,a,o=8*i-n-1,l=(1<<o)-1,u=l>>1,c=-7,h=r?i-1:0,p=r?-1:1,f=t[e+h];for(h+=p,s=f&(1<<-c)-1,f>>=-c,c+=o;c>0;s=256*s+t[e+h],h+=p,c-=8);for(a=s&(1<<-c)-1,s>>=-c,c+=n;c>0;a=256*a+t[e+h],h+=p,c-=8);if(0===s)s=1-u;else {if(s===l)return a?NaN:1/0*(f?-1:1);a+=Math.pow(2,n),s-=u;}return (f?-1:1)*a*Math.pow(2,s-n)},gh=function(t,e,r,n,i,s){var a,o,l,u=8*s-i-1,c=(1<<u)-1,h=c>>1,p=23===i?Math.pow(2,-24)-Math.pow(2,-77):0,f=n?0:s-1,d=n?1:-1,y=e<0||0===e&&1/e<0?1:0;for(e=Math.abs(e),isNaN(e)||e===1/0?(o=isNaN(e)?1:0,a=c):(a=Math.floor(Math.log(e)/Math.LN2),e*(l=Math.pow(2,-a))<1&&(a--,l*=2),(e+=a+h>=1?p/l:p*Math.pow(2,1-h))*l>=2&&(a++,l/=2),a+h>=c?(o=0,a=c):a+h>=1?(o=(e*l-1)*Math.pow(2,i),a+=h):(o=e*Math.pow(2,h-1)*Math.pow(2,i),a=0));i>=8;t[r+f]=255&o,f+=d,o/=256,i-=8);for(a=a<<i|o,u+=i;u>0;t[r+f]=255&a,f+=d,a/=256,u-=8);t[r+f-d]|=128*y;},xh=vh;function vh(t){this.buf=ArrayBuffer.isView&&ArrayBuffer.isView(t)?t:new Uint8Array(t||0),this.pos=0,this.type=0,this.length=this.buf.length;}vh.Varint=0,vh.Fixed64=1,vh.Bytes=2,vh.Fixed32=5;var bh=4294967296,_h=1/bh,wh="undefined"==typeof TextDecoder?null:new TextDecoder("utf8");function Ah(t){return t.type===vh.Bytes?t.readVarint()+t.pos:t.pos+1}function Sh(t,e,r){return r?4294967296*e+(t>>>0):4294967296*(e>>>0)+(t>>>0)}function kh(t,e,r){var n=e<=16383?1:e<=2097151?2:e<=268435455?3:Math.floor(Math.log(e)/(7*Math.LN2));r.realloc(n);for(var i=r.pos-1;i>=t;i--)r.buf[i+n]=r.buf[i];}function Ih(t,e){for(var r=0;r<t.length;r++)e.writeVarint(t[r]);}function Mh(t,e){for(var r=0;r<t.length;r++)e.writeSVarint(t[r]);}function zh(t,e){for(var r=0;r<t.length;r++)e.writeFloat(t[r]);}function Th(t,e){for(var r=0;r<t.length;r++)e.writeDouble(t[r]);}function Bh(t,e){for(var r=0;r<t.length;r++)e.writeBoolean(t[r]);}function Eh(t,e){for(var r=0;r<t.length;r++)e.writeFixed32(t[r]);}function Ch(t,e){for(var r=0;r<t.length;r++)e.writeSFixed32(t[r]);}function Ph(t,e){for(var r=0;r<t.length;r++)e.writeFixed64(t[r]);}function Dh(t,e){for(var r=0;r<t.length;r++)e.writeSFixed64(t[r]);}function Vh(t,e){return (t[e]|t[e+1]<<8|t[e+2]<<16)+16777216*t[e+3]}function Fh(t,e,r){t[r]=e,t[r+1]=e>>>8,t[r+2]=e>>>16,t[r+3]=e>>>24;}function Lh(t,e){return (t[e]|t[e+1]<<8|t[e+2]<<16)+(t[e+3]<<24)}function Rh(t,e,r){e.glyphs=[],1===t&&r.readMessage(Uh,e);}function Uh(t,e,r){if(3===t){const{id:t,bitmap:n,width:i,height:s,left:a,top:o,advance:l}=r.readMessage(jh,{});e.glyphs.push({id:t,bitmap:new hu({width:i+6,height:s+6},n),metrics:{width:i,height:s,left:a,top:o,advance:l}});}else 4===t?e.ascender=r.readSVarint():5===t&&(e.descender=r.readSVarint());}function jh(t,e,r){1===t?e.id=r.readVarint():2===t?e.bitmap=r.readBytes():3===t?e.width=r.readVarint():4===t?e.height=r.readVarint():5===t?e.left=r.readSVarint():6===t?e.top=r.readSVarint():7===t&&(e.advance=r.readVarint());}function $h(t){let e=0,r=0;for(const n of t)e+=n.w*n.h,r=Math.max(r,n.w);t.sort(((t,e)=>e.h-t.h));const n=[{x:0,y:0,w:Math.max(Math.ceil(Math.sqrt(e/.95)),r),h:1/0}];let i=0,s=0;for(const e of t)for(let t=n.length-1;t>=0;t--){const r=n[t];if(!(e.w>r.w||e.h>r.h)){if(e.x=r.x,e.y=r.y,s=Math.max(s,e.y+e.h),i=Math.max(i,e.x+e.w),e.w===r.w&&e.h===r.h){const e=n.pop();t<n.length&&(n[t]=e);}else e.h===r.h?(r.x+=e.w,r.w-=e.w):e.w===r.w?(r.y+=e.h,r.h-=e.h):(n.push({x:r.x+e.w,y:r.y,w:r.w-e.w,h:e.h}),r.y+=e.h,r.h-=e.h);break}}return {w:i,h:s,fill:e/(i*s)||0}}vh.prototype={destroy:function(){this.buf=null;},readFields:function(t,e,r){for(r=r||this.length;this.pos<r;){var n=this.readVarint(),i=n>>3,s=this.pos;this.type=7&n,t(i,e,this),this.pos===s&&this.skip(n);}return e},readMessage:function(t,e){return this.readFields(t,e,this.readVarint()+this.pos)},readFixed32:function(){var t=Vh(this.buf,this.pos);return this.pos+=4,t},readSFixed32:function(){var t=Lh(this.buf,this.pos);return this.pos+=4,t},readFixed64:function(){var t=Vh(this.buf,this.pos)+Vh(this.buf,this.pos+4)*bh;return this.pos+=8,t},readSFixed64:function(){var t=Vh(this.buf,this.pos)+Lh(this.buf,this.pos+4)*bh;return this.pos+=8,t},readFloat:function(){var t=mh(this.buf,this.pos,!0,23,4);return this.pos+=4,t},readDouble:function(){var t=mh(this.buf,this.pos,!0,52,8);return this.pos+=8,t},readVarint:function(t){var e,r,n=this.buf;return e=127&(r=n[this.pos++]),r<128?e:(e|=(127&(r=n[this.pos++]))<<7,r<128?e:(e|=(127&(r=n[this.pos++]))<<14,r<128?e:(e|=(127&(r=n[this.pos++]))<<21,r<128?e:function(t,e,r){var n,i,s=r.buf;if(n=(112&(i=s[r.pos++]))>>4,i<128)return Sh(t,n,e);if(n|=(127&(i=s[r.pos++]))<<3,i<128)return Sh(t,n,e);if(n|=(127&(i=s[r.pos++]))<<10,i<128)return Sh(t,n,e);if(n|=(127&(i=s[r.pos++]))<<17,i<128)return Sh(t,n,e);if(n|=(127&(i=s[r.pos++]))<<24,i<128)return Sh(t,n,e);if(n|=(1&(i=s[r.pos++]))<<31,i<128)return Sh(t,n,e);throw new Error("Expected varint not more than 10 bytes")}(e|=(15&(r=n[this.pos]))<<28,t,this))))},readVarint64:function(){return this.readVarint(!0)},readSVarint:function(){var t=this.readVarint();return t%2==1?(t+1)/-2:t/2},readBoolean:function(){return Boolean(this.readVarint())},readString:function(){var t=this.readVarint()+this.pos,e=this.pos;return this.pos=t,t-e>=12&&wh?function(t,e,r){return wh.decode(t.subarray(e,r))}(this.buf,e,t):function(t,e,r){for(var n="",i=e;i<r;){var s,a,o,l=t[i],u=null,c=l>239?4:l>223?3:l>191?2:1;if(i+c>r)break;1===c?l<128&&(u=l):2===c?128==(192&(s=t[i+1]))&&(u=(31&l)<<6|63&s)<=127&&(u=null):3===c?(a=t[i+2],128==(192&(s=t[i+1]))&&128==(192&a)&&((u=(15&l)<<12|(63&s)<<6|63&a)<=2047||u>=55296&&u<=57343)&&(u=null)):4===c&&(a=t[i+2],o=t[i+3],128==(192&(s=t[i+1]))&&128==(192&a)&&128==(192&o)&&((u=(15&l)<<18|(63&s)<<12|(63&a)<<6|63&o)<=65535||u>=1114112)&&(u=null)),null===u?(u=65533,c=1):u>65535&&(u-=65536,n+=String.fromCharCode(u>>>10&1023|55296),u=56320|1023&u),n+=String.fromCharCode(u),i+=c;}return n}(this.buf,e,t)},readBytes:function(){var t=this.readVarint()+this.pos,e=this.buf.subarray(this.pos,t);return this.pos=t,e},readPackedVarint:function(t,e){if(this.type!==vh.Bytes)return t.push(this.readVarint(e));var r=Ah(this);for(t=t||[];this.pos<r;)t.push(this.readVarint(e));return t},readPackedSVarint:function(t){if(this.type!==vh.Bytes)return t.push(this.readSVarint());var e=Ah(this);for(t=t||[];this.pos<e;)t.push(this.readSVarint());return t},readPackedBoolean:function(t){if(this.type!==vh.Bytes)return t.push(this.readBoolean());var e=Ah(this);for(t=t||[];this.pos<e;)t.push(this.readBoolean());return t},readPackedFloat:function(t){if(this.type!==vh.Bytes)return t.push(this.readFloat());var e=Ah(this);for(t=t||[];this.pos<e;)t.push(this.readFloat());return t},readPackedDouble:function(t){if(this.type!==vh.Bytes)return t.push(this.readDouble());var e=Ah(this);for(t=t||[];this.pos<e;)t.push(this.readDouble());return t},readPackedFixed32:function(t){if(this.type!==vh.Bytes)return t.push(this.readFixed32());var e=Ah(this);for(t=t||[];this.pos<e;)t.push(this.readFixed32());return t},readPackedSFixed32:function(t){if(this.type!==vh.Bytes)return t.push(this.readSFixed32());var e=Ah(this);for(t=t||[];this.pos<e;)t.push(this.readSFixed32());return t},readPackedFixed64:function(t){if(this.type!==vh.Bytes)return t.push(this.readFixed64());var e=Ah(this);for(t=t||[];this.pos<e;)t.push(this.readFixed64());return t},readPackedSFixed64:function(t){if(this.type!==vh.Bytes)return t.push(this.readSFixed64());var e=Ah(this);for(t=t||[];this.pos<e;)t.push(this.readSFixed64());return t},skip:function(t){var e=7&t;if(e===vh.Varint)for(;this.buf[this.pos++]>127;);else if(e===vh.Bytes)this.pos=this.readVarint()+this.pos;else if(e===vh.Fixed32)this.pos+=4;else {if(e!==vh.Fixed64)throw new Error("Unimplemented type: "+e);this.pos+=8;}},writeTag:function(t,e){this.writeVarint(t<<3|e);},realloc:function(t){for(var e=this.length||16;e<this.pos+t;)e*=2;if(e!==this.length){var r=new Uint8Array(e);r.set(this.buf),this.buf=r,this.length=e;}},finish:function(){return this.length=this.pos,this.pos=0,this.buf.subarray(0,this.length)},writeFixed32:function(t){this.realloc(4),Fh(this.buf,t,this.pos),this.pos+=4;},writeSFixed32:function(t){this.realloc(4),Fh(this.buf,t,this.pos),this.pos+=4;},writeFixed64:function(t){this.realloc(8),Fh(this.buf,-1&t,this.pos),Fh(this.buf,Math.floor(t*_h),this.pos+4),this.pos+=8;},writeSFixed64:function(t){this.realloc(8),Fh(this.buf,-1&t,this.pos),Fh(this.buf,Math.floor(t*_h),this.pos+4),this.pos+=8;},writeVarint:function(t){(t=+t||0)>268435455||t<0?function(t,e){var r,n;if(t>=0?(r=t%4294967296|0,n=t/4294967296|0):(n=~(-t/4294967296),4294967295^(r=~(-t%4294967296))?r=r+1|0:(r=0,n=n+1|0)),t>=0x10000000000000000||t<-0x10000000000000000)throw new Error("Given varint doesn't fit into 10 bytes");e.realloc(10),function(t,e,r){r.buf[r.pos++]=127&t|128,t>>>=7,r.buf[r.pos++]=127&t|128,t>>>=7,r.buf[r.pos++]=127&t|128,t>>>=7,r.buf[r.pos++]=127&t|128,r.buf[r.pos]=127&(t>>>=7);}(r,0,e),function(t,e){var r=(7&t)<<4;e.buf[e.pos++]|=r|((t>>>=3)?128:0),t&&(e.buf[e.pos++]=127&t|((t>>>=7)?128:0),t&&(e.buf[e.pos++]=127&t|((t>>>=7)?128:0),t&&(e.buf[e.pos++]=127&t|((t>>>=7)?128:0),t&&(e.buf[e.pos++]=127&t|((t>>>=7)?128:0),t&&(e.buf[e.pos++]=127&t)))));}(n,e);}(t,this):(this.realloc(4),this.buf[this.pos++]=127&t|(t>127?128:0),t<=127||(this.buf[this.pos++]=127&(t>>>=7)|(t>127?128:0),t<=127||(this.buf[this.pos++]=127&(t>>>=7)|(t>127?128:0),t<=127||(this.buf[this.pos++]=t>>>7&127))));},writeSVarint:function(t){this.writeVarint(t<0?2*-t-1:2*t);},writeBoolean:function(t){this.writeVarint(Boolean(t));},writeString:function(t){t=String(t),this.realloc(4*t.length),this.pos++;var e=this.pos;this.pos=function(t,e,r){for(var n,i,s=0;s<e.length;s++){if((n=e.charCodeAt(s))>55295&&n<57344){if(!i){n>56319||s+1===e.length?(t[r++]=239,t[r++]=191,t[r++]=189):i=n;continue}if(n<56320){t[r++]=239,t[r++]=191,t[r++]=189,i=n;continue}n=i-55296<<10|n-56320|65536,i=null;}else i&&(t[r++]=239,t[r++]=191,t[r++]=189,i=null);n<128?t[r++]=n:(n<2048?t[r++]=n>>6|192:(n<65536?t[r++]=n>>12|224:(t[r++]=n>>18|240,t[r++]=n>>12&63|128),t[r++]=n>>6&63|128),t[r++]=63&n|128);}return r}(this.buf,t,this.pos);var r=this.pos-e;r>=128&&kh(e,r,this),this.pos=e-1,this.writeVarint(r),this.pos+=r;},writeFloat:function(t){this.realloc(4),gh(this.buf,t,this.pos,!0,23,4),this.pos+=4;},writeDouble:function(t){this.realloc(8),gh(this.buf,t,this.pos,!0,52,8),this.pos+=8;},writeBytes:function(t){var e=t.length;this.writeVarint(e),this.realloc(e);for(var r=0;r<e;r++)this.buf[this.pos++]=t[r];},writeRawMessage:function(t,e){this.pos++;var r=this.pos;t(e,this);var n=this.pos-r;n>=128&&kh(r,n,this),this.pos=r-1,this.writeVarint(n),this.pos+=n;},writeMessage:function(t,e,r){this.writeTag(t,vh.Bytes),this.writeRawMessage(e,r);},writePackedVarint:function(t,e){e.length&&this.writeMessage(t,Ih,e);},writePackedSVarint:function(t,e){e.length&&this.writeMessage(t,Mh,e);},writePackedBoolean:function(t,e){e.length&&this.writeMessage(t,Bh,e);},writePackedFloat:function(t,e){e.length&&this.writeMessage(t,zh,e);},writePackedDouble:function(t,e){e.length&&this.writeMessage(t,Th,e);},writePackedFixed32:function(t,e){e.length&&this.writeMessage(t,Eh,e);},writePackedSFixed32:function(t,e){e.length&&this.writeMessage(t,Ch,e);},writePackedFixed64:function(t,e){e.length&&this.writeMessage(t,Ph,e);},writePackedSFixed64:function(t,e){e.length&&this.writeMessage(t,Dh,e);},writeBytesField:function(t,e){this.writeTag(t,vh.Bytes),this.writeBytes(e);},writeFixed32Field:function(t,e){this.writeTag(t,vh.Fixed32),this.writeFixed32(e);},writeSFixed32Field:function(t,e){this.writeTag(t,vh.Fixed32),this.writeSFixed32(e);},writeFixed64Field:function(t,e){this.writeTag(t,vh.Fixed64),this.writeFixed64(e);},writeSFixed64Field:function(t,e){this.writeTag(t,vh.Fixed64),this.writeSFixed64(e);},writeVarintField:function(t,e){this.writeTag(t,vh.Varint),this.writeVarint(e);},writeSVarintField:function(t,e){this.writeTag(t,vh.Varint),this.writeSVarint(e);},writeStringField:function(t,e){this.writeTag(t,vh.Bytes),this.writeString(e);},writeFloatField:function(t,e){this.writeTag(t,vh.Fixed32),this.writeFloat(e);},writeDoubleField:function(t,e){this.writeTag(t,vh.Fixed64),this.writeDouble(e);},writeBooleanField:function(t,e){this.writeVarintField(t,Boolean(e));}};class Oh{constructor(t,{pixelRatio:e,version:r,stretchX:n,stretchY:i,content:s}){this.paddedRect=t,this.pixelRatio=e,this.stretchX=n,this.stretchY=i,this.content=s,this.version=r;}get tl(){return [this.paddedRect.x+1,this.paddedRect.y+1]}get br(){return [this.paddedRect.x+this.paddedRect.w-1,this.paddedRect.y+this.paddedRect.h-1]}get displaySize(){return [(this.paddedRect.w-2)/this.pixelRatio,(this.paddedRect.h-2)/this.pixelRatio]}}class qh{constructor(t,e){const r={},n={};this.haveRenderCallbacks=[];const i=[];this.addImages(t,r,i),this.addImages(e,n,i);const{w:s,h:a}=$h(i),o=new pu({width:s||1,height:a||1});for(const e in t){const n=t[e],i=r[e].paddedRect;pu.copy(n.data,o,{x:0,y:0},{x:i.x+1,y:i.y+1},n.data);}for(const t in e){const r=e[t],i=n[t].paddedRect,s=i.x+1,a=i.y+1,l=r.data.width,u=r.data.height;pu.copy(r.data,o,{x:0,y:0},{x:s,y:a},r.data),pu.copy(r.data,o,{x:0,y:u-1},{x:s,y:a-1},{width:l,height:1}),pu.copy(r.data,o,{x:0,y:0},{x:s,y:a+u},{width:l,height:1}),pu.copy(r.data,o,{x:l-1,y:0},{x:s-1,y:a},{width:1,height:u}),pu.copy(r.data,o,{x:0,y:0},{x:s+l,y:a},{width:1,height:u});}this.image=o,this.iconPositions=r,this.patternPositions=n;}addImages(t,e,r){for(const n in t){const i=t[n],s={x:0,y:0,w:i.data.width+2,h:i.data.height+2};r.push(s),e[n]=new Oh(s,i),i.hasRenderCallback&&this.haveRenderCallbacks.push(n);}}patchUpdatedImages(t,e){this.haveRenderCallbacks=this.haveRenderCallbacks.filter((e=>t.hasImage(e))),t.dispatchRenderCallbacks(this.haveRenderCallbacks);for(const r in t.updatedImages)this.patchUpdatedImage(this.iconPositions[r],t.getImage(r),e),this.patchUpdatedImage(this.patternPositions[r],t.getImage(r),e);}patchUpdatedImage(t,e,r){if(!t||!e)return;if(t.version===e.version)return;t.version=e.version;const[n,i]=t.tl;r.update(e.data,void 0,{x:n,y:i});}}Pi(Oh,"ImagePosition"),Pi(qh,"ImageAtlas");const Nh={horizontal:1,vertical:2,horizontalOnly:3};class Gh{constructor(){this.scale=1,this.fontStack="",this.imageName=null;}static forText(t,e){const r=new Gh;return r.scale=t||1,r.fontStack=e,r}static forImage(t){const e=new Gh;return e.imageName=t,e}}class Zh{constructor(){this.text="",this.sectionIndex=[],this.sections=[],this.imageSectionID=null;}static fromFeature(t,e){const r=new Zh;for(let n=0;n<t.sections.length;n++){const i=t.sections[n];i.image?r.addImageSection(i):r.addTextSection(i,e);}return r}length(){return this.text.length}getSection(t){return this.sections[this.sectionIndex[t]]}getSections(){return this.sections}getSectionIndex(t){return this.sectionIndex[t]}getCharCode(t){return this.text.charCodeAt(t)}verticalizePunctuation(t){this.text=function(t,e){let r="";for(let n=0;n<t.length;n++){const i=t.charCodeAt(n+1)||null,s=t.charCodeAt(n-1)||null;r+=!e&&(i&&ms(i)&&!fh[t[n+1]]||s&&ms(s)&&!fh[t[n-1]])||!fh[t[n]]?t[n]:fh[t[n]];}return r}(this.text,t);}trim(){let t=0;for(let e=0;e<this.text.length&&Kh[this.text.charCodeAt(e)];e++)t++;let e=this.text.length;for(let r=this.text.length-1;r>=0&&r>=t&&Kh[this.text.charCodeAt(r)];r--)e--;this.text=this.text.substring(t,e),this.sectionIndex=this.sectionIndex.slice(t,e);}substring(t,e){const r=new Zh;return r.text=this.text.substring(t,e),r.sectionIndex=this.sectionIndex.slice(t,e),r.sections=this.sections,r}toString(){return this.text}getMaxScale(){return this.sectionIndex.reduce(((t,e)=>Math.max(t,this.sections[e].scale)),0)}addTextSection(t,e){this.text+=t.text,this.sections.push(Gh.forText(t.scale,t.fontStack||e));const r=this.sections.length-1;for(let e=0;e<t.text.length;++e)this.sectionIndex.push(r);}addImageSection(t){const e=t.image?t.image.name:"";if(0===e.length)return void E("Can't add FormattedSection with an empty image.");const r=this.getNextImageSectionCharCode();r?(this.text+=String.fromCharCode(r),this.sections.push(Gh.forImage(e)),this.sectionIndex.push(this.sections.length-1)):E("Reached maximum number of images 6401");}getNextImageSectionCharCode(){return this.imageSectionID?this.imageSectionID>=63743?null:++this.imageSectionID:(this.imageSectionID=57344,this.imageSectionID)}}function Xh(t,e,r,n,i,s,a,o,l,u,c,h,p,f,d,y){const m=Zh.fromFeature(t,i);let g;h===Nh.vertical&&m.verticalizePunctuation(p);const{processBidirectionalText:x,processStyledBidirectionalText:v}=Es;if(x&&1===m.sections.length){g=[];const t=x(m.toString(),ep(m,u,s,e,n,f,d));for(const e of t){const t=new Zh;t.text=e,t.sections=m.sections;for(let r=0;r<e.length;r++)t.sectionIndex.push(0);g.push(t);}}else if(v){g=[];const t=v(m.text,m.sectionIndex,ep(m,u,s,e,n,f,d));for(const e of t){const t=new Zh;t.text=e[0],t.sectionIndex=e[1],t.sections=m.sections,g.push(t);}}else g=function(t,e){const r=[],n=t.text;let i=0;for(const n of e)r.push(t.substring(i,n)),i=n;return i<n.length&&r.push(t.substring(i,n.length)),r}(m,ep(m,u,s,e,n,f,d));const b=[],_={positionedLines:b,text:m.toString(),top:c[1],bottom:c[1],left:c[0],right:c[0],writingMode:h,iconsInText:!1,verticalizable:!1,hasBaseline:!1};return function(t,e,r,n,i,s,a,o,l,u,c,h){let p=0,f=0,d=0;const y="right"===o?1:"left"===o?0:.5;let m=!1;for(const t of i){const r=t.getSections();for(const t of r){if(t.imageName)continue;const r=e[t.fontStack];if(r&&(m=void 0!==r.ascender&&void 0!==r.descender,!m))break}if(!m)break}let g=0;for(const a of i){a.trim();const i=a.getMaxScale(),o=(i-1)*ah,v={positionedGlyphs:[],lineOffset:0};t.positionedLines[g]=v;const b=v.positionedGlyphs;let _=0;if(!a.length()){f+=s,++g;continue}let w=0,A=0;for(let s=0;s<a.length();s++){const o=a.getSection(s),d=a.getSectionIndex(s),y=a.getCharCode(s);let g=o.scale,v=null,S=null,k=null,I=ah,M=0;const z=!(l===Nh.horizontal||!c&&!ys(y)||c&&(Kh[y]||(x=y,Ui(x)||ji(x)||$i(x)||as(x)||cs(x))));if(o.imageName){const e=n[o.imageName];if(!e)continue;k=o.imageName,t.iconsInText=t.iconsInText||!0,S=e.paddedRect;const r=e.displaySize;g=g*ah/h,v={width:r[0],height:r[1],left:1,top:-3,advance:z?r[1]:r[0],localGlyph:!1},M=m?-v.height*g:i*ah-17-r[1]*g,I=v.advance;const s=(z?r[0]:r[1])*g-ah*i;s>0&&s>_&&(_=s);}else {const t=r[o.fontStack];if(!t)continue;t[y]&&(S=t[y]);const n=e[o.fontStack];if(!n)continue;const s=n.glyphs[y];if(!s)continue;if(v=s.metrics,I=8203!==y?ah:0,m){const t=void 0!==n.ascender?Math.abs(n.ascender):0,e=void 0!==n.descender?Math.abs(n.descender):0,r=(t+e)*g;w<r&&(w=r,A=(t-e)/2*g),M=-t*g;}else M=(i-g)*ah-17;}z?(t.verticalizable=!0,b.push({glyph:y,imageName:k,x:p,y:f+M,vertical:z,scale:g,localGlyph:v.localGlyph,fontStack:o.fontStack,sectionIndex:d,metrics:v,rect:S}),p+=I*g+u):(b.push({glyph:y,imageName:k,x:p,y:f+M,vertical:z,scale:g,localGlyph:v.localGlyph,fontStack:o.fontStack,sectionIndex:d,metrics:v,rect:S}),p+=v.advance*g+u);}0!==b.length&&(d=Math.max(p-u,d),m?np(b,y,_,A,s*i/2):np(b,y,_,0,s/2)),p=0;const S=s*i+_;v.lineOffset=Math.max(_,o),f+=S,++g;}var x;const v=f,{horizontalAlign:b,verticalAlign:_}=rp(a);(((function(t,e,r,n,i,s){const a=(e-r)*i,o=-s*n;for(const e of t)for(const t of e.positionedGlyphs)t.x+=a,t.y+=o;})))(t.positionedLines,y,b,_,d,v),t.top+=-_*v,t.bottom=t.top+v,t.left+=-b*d,t.right=t.left+d,t.hasBaseline=m;}(_,e,r,n,g,a,o,l,h,u,p,y),!function(t){for(const e of t)if(0!==e.positionedGlyphs.length)return !1;return !0}(b)&&_}const Kh={9:!0,10:!0,11:!0,12:!0,13:!0,32:!0},Hh={10:!0,32:!0,38:!0,40:!0,41:!0,43:!0,45:!0,47:!0,173:!0,183:!0,8203:!0,8208:!0,8211:!0,8231:!0};function Yh(t,e,r,n,i,s){if(e.imageName){const t=n[e.imageName];return t?t.displaySize[0]*e.scale*ah/s+i:0}{const n=r[e.fontStack],s=n&&n.glyphs[t];return s?s.metrics.advance*e.scale+i:0}}function Wh(t,e,r,n){const i=Math.pow(t-e,2);return n?t<e?i/2:2*i:i+Math.abs(r)*r}function Jh(t,e,r){let n=0;return 10===t&&(n-=1e4),r&&(n+=150),40!==t&&65288!==t||(n+=50),41!==e&&65289!==e||(n+=50),n}function Qh(t,e,r,n,i,s){let a=null,o=Wh(e,r,i,s);for(const t of n){const n=Wh(e-t.x,r,i,s)+t.badness;n<=o&&(a=t,o=n);}return {index:t,x:e,priorBreak:a,badness:o}}function tp(t){return t?tp(t.priorBreak).concat(t.index):[]}function ep(t,e,r,n,i,s,a){if("point"!==s)return [];if(!t)return [];const o=[],l=function(t,e,r,n,i,s){let a=0;for(let r=0;r<t.length();r++){const o=t.getSection(r);a+=Yh(t.getCharCode(r),o,n,i,e,s);}return a/Math.max(1,Math.ceil(a/r))}(t,e,r,n,i,a),u=t.text.indexOf("​")>=0;let c=0;for(let r=0;r<t.length();r++){const s=t.getSection(r),p=t.getCharCode(r);if(Kh[p]||(c+=Yh(p,s,n,i,e,a)),r<t.length()-1){const e=!((h=p)<11904||!(Hi(h)||Ki(h)||ls(h)||ss(h)||Qi(h)||Oi(h)||Yi(h)||Gi(h)||ts(h)||es(h)||Ji(h)||hs(h)||Zi(h)||Ni(h)||qi(h)||Wi(h)||Xi(h)||os(h)||ns(h)||rs(h)));(Hh[p]||e||s.imageName)&&o.push(Qh(r+1,c,l,o,Jh(p,t.getCharCode(r+1),e&&u),!1));}}var h;return tp(Qh(t.length(),c,l,o,0,!0))}function rp(t){let e=.5,r=.5;switch(t){case"right":case"top-right":case"bottom-right":e=1;break;case"left":case"top-left":case"bottom-left":e=0;}switch(t){case"bottom":case"bottom-right":case"bottom-left":r=1;break;case"top":case"top-right":case"top-left":r=0;}return {horizontalAlign:e,verticalAlign:r}}function np(t,e,r,n,i){if(!(e||r||n||i))return;const s=t.length-1,a=t[s],o=(a.x+a.metrics.advance*a.scale)*e;for(let e=0;e<=s;e++)t[e].x-=o,t[e].y+=r+n+i;}function ip(t,e,r){const{horizontalAlign:n,verticalAlign:i}=rp(r),s=e[0]-t.displaySize[0]*n,a=e[1]-t.displaySize[1]*i;return {image:t,top:a,bottom:a+t.displaySize[1],left:s,right:s+t.displaySize[0]}}function sp(t,e,r,n,i,s){const a=t.image;let o;if(a.content){const t=a.content,e=a.pixelRatio||1;o=[t[0]/e,t[1]/e,a.displaySize[0]-t[2]/e,a.displaySize[1]-t[3]/e];}const l=e.left*s,u=e.right*s;let c,h,p,f;"width"===r||"both"===r?(f=i[0]+l-n[3],h=i[0]+u+n[1]):(f=i[0]+(l+u-a.displaySize[0])/2,h=f+a.displaySize[0]);const d=e.top*s,y=e.bottom*s;return "height"===r||"both"===r?(c=i[1]+d-n[0],p=i[1]+y+n[2]):(c=i[1]+(d+y-a.displaySize[1])/2,p=c+a.displaySize[1]),{image:a,top:c,right:h,bottom:p,left:f,collisionPadding:o}}class ap extends i{constructor(t,e,r,n,i){super(t,e),this.angle=n,this.z=r,void 0!==i&&(this.segment=i);}clone(){return new ap(this.x,this.y,this.z,this.angle,this.segment)}}function op(t,e,r,n,i){if(void 0===e.segment)return !0;let s=e,a=e.segment+1,o=0;for(;o>-r/2;){if(a--,a<0)return !1;o-=t[a].dist(s),s=t[a];}o+=t[a].dist(t[a+1]),a++;const l=[];let u=0;for(;o<r/2;){const e=t[a],r=t[a+1];if(!r)return !1;let s=t[a-1].angleTo(e)-e.angleTo(r);for(s=Math.abs((s+3*Math.PI)%(2*Math.PI)-Math.PI),l.push({distance:o,angleDelta:s}),u+=s;o-l[0].distance>n;)u-=l.shift().angleDelta;if(u>i)return !1;a++,o+=e.dist(r);}return !0}function lp(t){let e=0;for(let r=0;r<t.length-1;r++)e+=t[r].dist(t[r+1]);return e}function up(t,e,r){return t?.6*e*r:0}function cp(t,e){return Math.max(t?t.right-t.left:0,e?e.right-e.left:0)}function hp(t,e,r,n,i,s){const a=up(r,i,s),o=cp(r,n)*s;let l=0;const u=lp(t)/2;for(let r=0;r<t.length-1;r++){const n=t[r],i=t[r+1],s=n.dist(i);if(l+s>u){const c=(u-l)/s,h=xr(n.x,i.x,c),p=xr(n.y,i.y,c),f=new ap(h,p,0,i.angleTo(n),r);return !a||op(t,f,o,a,e)?f:void 0}l+=s;}}function pp(t,e,r,n,i,s,a,o,l){const u=up(n,s,a),c=cp(n,i),h=c*a,p=0===t[0].x||t[0].x===l||0===t[0].y||t[0].y===l;return e-h<e/4&&(e=h+e/4),fp(t,p?e/2*o%e:(c/2+2*s)*a*o%e,e,u,r,h,p,!1,l)}function fp(t,e,r,n,i,s,a,o,l){const u=s/2,c=lp(t);let h=0,p=e-r,f=[];for(let e=0;e<t.length-1;e++){const a=t[e],o=t[e+1],d=a.dist(o),y=o.angleTo(a);for(;p+r<h+d;){p+=r;const m=(p-h)/d,g=xr(a.x,o.x,m),x=xr(a.y,o.y,m);if(g>=0&&g<l&&x>=0&&x<l&&p-u>=0&&p+u<=c){const r=new ap(g,x,0,y,e);r._round(),n&&!op(t,r,s,n,i)||f.push(r);}}h+=d;}return o||f.length||a||(f=fp(t,h/2,r,n,i,s,a,!0,l)),f}function dp(t,e,r,n,s){const a=[];for(let o=0;o<t.length;o++){const l=t[o];let u;for(let t=0;t<l.length-1;t++){let o=l[t],c=l[t+1];o.x<e&&c.x<e||(o.x<e?o=new i(e,o.y+(e-o.x)/(c.x-o.x)*(c.y-o.y))._round():c.x<e&&(c=new i(e,o.y+(e-o.x)/(c.x-o.x)*(c.y-o.y))._round()),o.y<r&&c.y<r||(o.y<r?o=new i(o.x+(r-o.y)/(c.y-o.y)*(c.x-o.x),r)._round():c.y<r&&(c=new i(o.x+(r-o.y)/(c.y-o.y)*(c.x-o.x),r)._round()),o.x>=n&&c.x>=n||(o.x>=n?o=new i(n,o.y+(n-o.x)/(c.x-o.x)*(c.y-o.y))._round():c.x>=n&&(c=new i(n,o.y+(n-o.x)/(c.x-o.x)*(c.y-o.y))._round()),o.y>=s&&c.y>=s||(o.y>=s?o=new i(o.x+(s-o.y)/(c.y-o.y)*(c.x-o.x),s)._round():c.y>=s&&(c=new i(o.x+(s-o.y)/(c.y-o.y)*(c.x-o.x),s)._round()),u&&o.equals(u[u.length-1])||(u=[o],a.push(u)),u.push(c)))));}}return a}Pi(ap,"Anchor");const yp=1e20;function mp(t,e,r,n,i,s,a,o,l){for(let u=e;u<e+n;u++)gp(t,r*s+u,s,i,a,o,l);for(let u=r;u<r+i;u++)gp(t,u*s+e,1,n,a,o,l);}function gp(t,e,r,n,i,s,a){s[0]=0,a[0]=-yp,a[1]=yp,i[0]=t[e];for(let o=1,l=0,u=0;o<n;o++){i[o]=t[e+o*r];const n=o*o;do{const t=s[l];u=(i[o]-i[t]+n-t*t)/(o-t)/2;}while(u<=a[l]&&--l>-1);l++,s[l]=o,a[l]=u,a[l+1]=yp;}for(let o=0,l=0;o<n;o++){for(;a[l+1]<o;)l++;const n=s[l],u=o-n;t[e+o*r]=i[n]+u*u;}}const xp={none:0,ideographs:1,all:2};class vp{constructor(t,e,r){this.requestManager=t,this.localGlyphMode=e,this.localFontFamily=r,this.entries={},this.localGlyphs={200:{},400:{},500:{},900:{}};}setURL(t){this.url=t;}getGlyphs(t,e){const r=[];for(const e in t)for(const n of t[e])r.push({stack:e,id:n});g(r,(({stack:t,id:e},r)=>{let n=this.entries[t];n||(n=this.entries[t]={glyphs:{},requests:{},ranges:{},ascender:void 0,descender:void 0});let i=n.glyphs[e];if(void 0!==i)return void r(null,{stack:t,id:e,glyph:i});if(i=this._tinySDF(n,t,e),i)return n.glyphs[e]=i,void r(null,{stack:t,id:e,glyph:i});const s=Math.floor(e/256);if(256*s>65535)return void r(new Error("glyphs > 65535 not supported"));if(n.ranges[s])return void r(null,{stack:t,id:e,glyph:i});let a=n.requests[s];a||(a=n.requests[s]=[],vp.loadGlyphRange(t,s,this.url,this.requestManager,((t,e)=>{if(e){n.ascender=e.ascender,n.descender=e.descender;for(const t in e.glyphs)this._doesCharSupportLocalGlyph(+t)||(n.glyphs[+t]=e.glyphs[+t]);n.ranges[s]=!0;}for(const r of a)r(t,e);delete n.requests[s];}))),a.push(((n,i)=>{n?r(n):i&&r(null,{stack:t,id:e,glyph:i.glyphs[e]||null});}));}),((t,r)=>{if(t)e(t);else if(r){const t={};for(const{stack:e,id:n,glyph:i}of r)void 0===t[e]&&(t[e]={}),void 0===t[e].glyphs&&(t[e].glyphs={}),t[e].glyphs[n]=i&&{id:i.id,bitmap:i.bitmap.clone(),metrics:i.metrics},t[e].ascender=this.entries[e].ascender,t[e].descender=this.entries[e].descender;e(null,t);}}));}_doesCharSupportLocalGlyph(t){return this.localGlyphMode!==xp.none&&(this.localGlyphMode===xp.all?!!this.localFontFamily:!!this.localFontFamily&&(es(t)||is(t)||Zi(t)||Xi(t)||Gi(t)))}_tinySDF(t,e,r){const n=this.localFontFamily;if(!n||!this._doesCharSupportLocalGlyph(r))return;let i=t.tinySDF;if(!i){let r="400";/bold/i.test(e)?r="900":/medium/i.test(e)?r="500":/light/i.test(e)&&(r="200"),i=t.tinySDF=new vp.TinySDF({fontFamily:n,fontWeight:r,fontSize:48,buffer:6,radius:16}),i.fontWeight=r;}if(this.localGlyphs[i.fontWeight][r])return this.localGlyphs[i.fontWeight][r];const s=String.fromCharCode(r),{data:a,width:o,height:l,glyphWidth:u,glyphHeight:c,glyphLeft:h,glyphTop:p,glyphAdvance:f}=i.draw(s);return this.localGlyphs[i.fontWeight][r]={id:r,bitmap:new hu({width:o,height:l},a),metrics:{width:u/2,height:c/2,left:h/2,top:p/2-27,advance:f/2,localGlyph:!0}}}}function bp(t,e,r,n){const s=[],a=t.image,o=a.pixelRatio,l=a.paddedRect.w-2,u=a.paddedRect.h-2,c=t.right-t.left,h=t.bottom-t.top,p=a.stretchX||[[0,l]],f=a.stretchY||[[0,u]],d=(t,e)=>t+e[1]-e[0],y=p.reduce(d,0),m=f.reduce(d,0),g=l-y,x=u-m;let v=0,b=y,_=0,w=m,A=0,S=g,k=0,I=x;if(a.content&&n){const t=a.content;v=_p(p,0,t[0]),_=_p(f,0,t[1]),b=_p(p,t[0],t[2]),w=_p(f,t[1],t[3]),A=t[0]-v,k=t[1]-_,S=t[2]-t[0]-b,I=t[3]-t[1]-w;}const M=(n,s,l,u)=>{const p=Ap(n.stretch-v,b,c,t.left),f=Sp(n.fixed-A,S,n.stretch,y),d=Ap(s.stretch-_,w,h,t.top),g=Sp(s.fixed-k,I,s.stretch,m),x=Ap(l.stretch-v,b,c,t.left),M=Sp(l.fixed-A,S,l.stretch,y),z=Ap(u.stretch-_,w,h,t.top),T=Sp(u.fixed-k,I,u.stretch,m),B=new i(p,d),E=new i(x,d),C=new i(x,z),P=new i(p,z),D=new i(f/o,g/o),V=new i(M/o,T/o),F=e*Math.PI/180;if(F){const t=Math.sin(F),e=Math.cos(F),r=[e,-t,t,e];B._matMult(r),E._matMult(r),P._matMult(r),C._matMult(r);}const L=n.stretch+n.fixed,R=s.stretch+s.fixed;return {tl:B,tr:E,bl:P,br:C,tex:{x:a.paddedRect.x+1+L,y:a.paddedRect.y+1+R,w:l.stretch+l.fixed-L,h:u.stretch+u.fixed-R},writingMode:void 0,glyphOffset:[0,0],sectionIndex:0,pixelOffsetTL:D,pixelOffsetBR:V,minFontScaleX:S/o/c,minFontScaleY:I/o/h,isSDF:r}};if(n&&(a.stretchX||a.stretchY)){const t=wp(p,g,y),e=wp(f,x,m);for(let r=0;r<t.length-1;r++){const n=t[r],i=t[r+1];for(let t=0;t<e.length-1;t++)s.push(M(n,e[t],i,e[t+1]));}}else s.push(M({fixed:0,stretch:-1},{fixed:0,stretch:-1},{fixed:0,stretch:l+1},{fixed:0,stretch:u+1}));return s}function _p(t,e,r){let n=0;for(const i of t)n+=Math.max(e,Math.min(r,i[1]))-Math.max(e,Math.min(r,i[0]));return n}function wp(t,e,r){const n=[{fixed:-1,stretch:0}];for(const[e,r]of t){const t=n[n.length-1];n.push({fixed:e-t.stretch,stretch:t.stretch}),n.push({fixed:e-t.stretch,stretch:t.stretch+(r-e)});}return n.push({fixed:e+1,stretch:r}),n}function Ap(t,e,r,n){return t/e*r+n}function Sp(t,e,r,n){return t-e*r/n}function kp(t,e,r,n){const i=e+t.positionedLines[n].lineOffset;return 0===n?r+i/2:r+(i+(e+t.positionedLines[n-1].lineOffset))/2}vp.loadGlyphRange=function(t,e,r,n,i){const s=256*e,a=s+255,o=n.transformRequest(n.normalizeGlyphsURL(r).replace("{fontstack}",t).replace("{range}",`${s}-${a}`),zt.Glyphs);Ct(o,((t,e)=>{if(t)i(t);else if(e){const t={},r=function(t){return new xh(t).readFields(Rh,{})}(e);for(const e of r.glyphs)t[e.id]=e;i(null,{glyphs:t,ascender:r.ascender,descender:r.descender});}}));},vp.TinySDF=class{constructor({fontSize:t=24,buffer:e=3,radius:r=8,cutoff:n=.25,fontFamily:i="sans-serif",fontWeight:s="normal",fontStyle:a="normal"}={}){this.buffer=e,this.cutoff=n,this.radius=r;const o=this.size=t+4*e,l=this._createCanvas(o),u=this.ctx=l.getContext("2d",{willReadFrequently:!0});u.font=`${a} ${s} ${t}px ${i}`,u.textBaseline="alphabetic",u.textAlign="left",u.fillStyle="black",this.gridOuter=new Float64Array(o*o),this.gridInner=new Float64Array(o*o),this.f=new Float64Array(o),this.z=new Float64Array(o+1),this.v=new Uint16Array(o);}_createCanvas(t){const e=document.createElement("canvas");return e.width=e.height=t,e}draw(t){const{width:e,actualBoundingBoxAscent:r,actualBoundingBoxDescent:n,actualBoundingBoxLeft:i,actualBoundingBoxRight:s}=this.ctx.measureText(t),a=Math.ceil(r),o=Math.min(this.size-this.buffer,Math.ceil(s-i)),l=Math.min(this.size-this.buffer,a+Math.ceil(n)),u=o+2*this.buffer,c=l+2*this.buffer,h=Math.max(u*c,0),p=new Uint8ClampedArray(h),f={data:p,width:u,height:c,glyphWidth:o,glyphHeight:l,glyphTop:a,glyphLeft:0,glyphAdvance:e};if(0===o||0===l)return f;const{ctx:d,buffer:y,gridInner:m,gridOuter:g}=this;d.clearRect(y,y,o,l),d.fillText(t,y,y+a);const x=d.getImageData(y,y,o,l);g.fill(yp,0,h),m.fill(0,0,h);for(let t=0;t<l;t++)for(let e=0;e<o;e++){const r=x.data[4*(t*o+e)+3]/255;if(0===r)continue;const n=(t+y)*u+e+y;if(1===r)g[n]=0,m[n]=yp;else {const t=.5-r;g[n]=t>0?t*t:0,m[n]=t<0?t*t:0;}}mp(g,0,0,u,c,u,this.f,this.v,this.z),mp(m,y,y,o,l,u,this.f,this.v,this.z);for(let t=0;t<h;t++){const e=Math.sqrt(g[t])-Math.sqrt(m[t]);p[t]=Math.round(255-255*(e/this.radius+this.cutoff));}return f}};class Ip{constructor(t=[],e=Mp){if(this.data=t,this.length=this.data.length,this.compare=e,this.length>0)for(let t=(this.length>>1)-1;t>=0;t--)this._down(t);}push(t){this.data.push(t),this.length++,this._up(this.length-1);}pop(){if(0===this.length)return;const t=this.data[0],e=this.data.pop();return this.length--,this.length>0&&(this.data[0]=e,this._down(0)),t}peek(){return this.data[0]}_up(t){const{data:e,compare:r}=this,n=e[t];for(;t>0;){const i=t-1>>1,s=e[i];if(r(n,s)>=0)break;e[t]=s,t=i;}e[t]=n;}_down(t){const{data:e,compare:r}=this,n=this.length>>1,i=e[t];for(;t<n;){let n=1+(t<<1),s=e[n];const a=n+1;if(a<this.length&&r(e[a],s)<0&&(n=a,s=e[a]),r(s,i)>=0)break;e[t]=s,t=n;}e[t]=i;}}function Mp(t,e){return t<e?-1:t>e?1:0}function zp(t,e=1,r=!1){let n=1/0,s=1/0,a=-1/0,o=-1/0;const l=t[0];for(let t=0;t<l.length;t++){const e=l[t];(!t||e.x<n)&&(n=e.x),(!t||e.y<s)&&(s=e.y),(!t||e.x>a)&&(a=e.x),(!t||e.y>o)&&(o=e.y);}const u=Math.min(a-n,o-s);let c=u/2;const h=new Ip([],Tp);if(0===u)return new i(n,s);for(let e=n;e<a;e+=u)for(let r=s;r<o;r+=u)h.push(new Bp(e+c,r+c,c,t));let p=function(t){let e=0,r=0,n=0;const i=t[0];for(let t=0,s=i.length,a=s-1;t<s;a=t++){const s=i[t],o=i[a],l=s.x*o.y-o.x*s.y;r+=(s.x+o.x)*l,n+=(s.y+o.y)*l,e+=3*l;}return new Bp(r/e,n/e,0,t)}(t),f=h.length;for(;h.length;){const n=h.pop();(n.d>p.d||!p.d)&&(p=n,r&&console.log("found best %d after %d probes",Math.round(1e4*n.d)/1e4,f)),n.max-p.d<=e||(c=n.h/2,h.push(new Bp(n.p.x-c,n.p.y-c,c,t)),h.push(new Bp(n.p.x+c,n.p.y-c,c,t)),h.push(new Bp(n.p.x-c,n.p.y+c,c,t)),h.push(new Bp(n.p.x+c,n.p.y+c,c,t)),f+=4);}return r&&(console.log(`num probes: ${f}`),console.log(`best distance: ${p.d}`)),p.p}function Tp(t,e){return e.max-t.max}function Bp(t,e,r,n){this.p=new i(t,e),this.h=r,this.d=function(t,e){let r=!1,n=1/0;for(let i=0;i<e.length;i++){const s=e[i];for(let e=0,i=s.length,a=i-1;e<i;a=e++){const i=s[e],o=s[a];i.y>t.y!=o.y>t.y&&t.x<(o.x-i.x)*(t.y-i.y)/(o.y-i.y)+i.x&&(r=!r),n=Math.min(n,rl(t,i,o));}}return (r?1:-1)*Math.sqrt(n)}(this.p,n),this.max=this.d+this.h*Math.SQRT2;}const Ep=Number.POSITIVE_INFINITY,Cp=Math.sqrt(2);function Pp(t,e){return e[1]!==Ep?function(t,e,r){let n=0,i=0;switch(e=Math.abs(e),r=Math.abs(r),t){case"top-right":case"top-left":case"top":i=r-7;break;case"bottom-right":case"bottom-left":case"bottom":i=7-r;}switch(t){case"top-right":case"bottom-right":case"right":n=-e;break;case"top-left":case"bottom-left":case"left":n=e;}return [n,i]}(t,e[0],e[1]):function(t,e){let r=0,n=0;e<0&&(e=0);const i=e/Cp;switch(t){case"top-right":case"top-left":n=i-7;break;case"bottom-right":case"bottom-left":n=7-i;break;case"bottom":n=7-e;break;case"top":n=e-7;}switch(t){case"top-right":case"bottom-right":r=-i;break;case"top-left":case"bottom-left":r=i;break;case"left":r=e;break;case"right":r=-e;}return [r,n]}(t,e[0])}function Dp(t,e,r,n,i,s,a,o,l,u){t.createArrays(),t.tilePixelRatio=wo/(512*t.overscaling),t.compareText={},t.iconsNeedLinear=!1;const c=t.layers[0].layout,h=t.layers[0]._unevaluatedLayout._values,p={};if("composite"===t.textSizeData.kind){const{minZoom:e,maxZoom:r}=t.textSizeData;p.compositeTextSizes=[h["text-size"].possiblyEvaluate(new Cs(e),o),h["text-size"].possiblyEvaluate(new Cs(r),o)];}if("composite"===t.iconSizeData.kind){const{minZoom:e,maxZoom:r}=t.iconSizeData;p.compositeIconSizes=[h["icon-size"].possiblyEvaluate(new Cs(e),o),h["icon-size"].possiblyEvaluate(new Cs(r),o)];}p.layoutTextSize=h["text-size"].possiblyEvaluate(new Cs(l+1),o),p.layoutIconSize=h["icon-size"].possiblyEvaluate(new Cs(l+1),o),p.textMaxSize=h["text-size"].possiblyEvaluate(new Cs(18),o);const f="map"===c.get("text-rotation-alignment")&&"point"!==c.get("symbol-placement"),d=c.get("text-size");for(const s of t.features){const l=c.get("text-font").evaluate(s,{},o).join(","),h=d.evaluate(s,{},o),y=p.layoutTextSize.evaluate(s,{},o),m=(p.layoutIconSize.evaluate(s,{},o),{horizontal:{},vertical:void 0}),g=s.text;let x,v=[0,0];if(g){const n=g.toString(),a=c.get("text-letter-spacing").evaluate(s,{},o)*ah,u=c.get("text-line-height").evaluate(s,{},o)*ah,p=fs(n)?a:0,d=c.get("text-anchor").evaluate(s,{},o),x=c.get("text-variable-anchor");if(!x){const t=c.get("text-radial-offset").evaluate(s,{},o);v=t?Pp(d,[t*ah,Ep]):c.get("text-offset").evaluate(s,{},o).map((t=>t*ah));}let b=f?"center":c.get("text-justify").evaluate(s,{},o);const _=c.get("symbol-placement"),w="point"===_,A="point"===_?c.get("text-max-width").evaluate(s,{},o)*ah:0,S=s=>{t.allowVerticalPlacement&&ps(n)&&(m.vertical=Xh(g,e,r,i,l,A,u,d,s,p,v,Nh.vertical,!0,_,y,h));};if(!f&&x){const t="auto"===b?x.map((t=>Vp(t))):[b];let n=!1;for(let s=0;s<t.length;s++){const a=t[s];if(!m.horizontal[a])if(n)m.horizontal[a]=m.horizontal[0];else {const t=Xh(g,e,r,i,l,A,u,"center",a,p,v,Nh.horizontal,!1,_,y,h);t&&(m.horizontal[a]=t,n=1===t.positionedLines.length);}}S("left");}else {if("auto"===b&&(b=Vp(d)),w||c.get("text-writing-mode").indexOf("horizontal")>=0||!ps(n)){const t=Xh(g,e,r,i,l,A,u,d,b,p,v,Nh.horizontal,!1,_,y,h);t&&(m.horizontal[b]=t);}S("point"===_?"left":b);}}let b=!1;if(s.icon&&s.icon.name){const e=n[s.icon.name];e&&(x=ip(i[s.icon.name],c.get("icon-offset").evaluate(s,{},o),c.get("icon-anchor").evaluate(s,{},o)),b=e.sdf,void 0===t.sdfIcons?t.sdfIcons=e.sdf:t.sdfIcons!==e.sdf&&E("Style sheet warning: Cannot mix SDF and non-SDF icons in one buffer"),(e.pixelRatio!==t.pixelRatio||0!==c.get("icon-rotate").constantOr(1))&&(t.iconsNeedLinear=!0));}const _=Up(m.horizontal)||m.vertical;t.iconsInText||(t.iconsInText=!!_&&_.iconsInText),(_||x)&&Fp(t,s,m,x,n,p,y,0,v,b,a,o,u);}s&&t.generateCollisionDebugBuffers(l,t.collisionBoxArray);}function Vp(t){switch(t){case"right":case"top-right":case"bottom-right":return "right";case"left":case"top-left":case"bottom-left":return "left"}return "center"}function Fp(t,e,r,n,i,s,a,o,u,c,h,p,f){let d=s.textMaxSize.evaluate(e,{},p);void 0===d&&(d=a);const y=t.layers[0].layout,m=y.get("icon-offset").evaluate(e,{},p),g=Up(r.horizontal)||r.vertical,x="globe"===f.name,v=a/24,b=t.tilePixelRatio*d/24,_=(T=t.overscaling,t.zoom>18&&T>2&&(T>>=1),Math.max(wo/(512*T),1)*y.get("symbol-spacing")),w=y.get("text-padding")*t.tilePixelRatio,A=y.get("icon-padding")*t.tilePixelRatio,S=l(y.get("text-max-angle")),k="map"===y.get("text-rotation-alignment")&&"point"!==y.get("symbol-placement"),I="map"===y.get("icon-rotation-alignment")&&"point"!==y.get("symbol-placement"),M=y.get("symbol-placement"),z=_/2;var T;const B=y.get("icon-text-fit");let C;n&&"none"!==B&&(t.allowVerticalPlacement&&r.vertical&&(C=sp(n,r.vertical,B,y.get("icon-text-fit-padding"),m,v)),g&&(n=sp(n,g,B,y.get("icon-text-fit-padding"),m,v)));const P=(a,o,l)=>{if(o.x<0||o.x>=wo||o.y<0||o.y>=wo)return;let d=null;if(x){const{x:t,y:e,z:r}=f.projectTilePoint(o.x,o.y,l);d={anchor:new ap(t,e,r,0,void 0),up:f.upVector(l,o.x,o.y)};}!function(t,e,r,n,i,s,a,o,l,u,c,h,p,f,d,y,m,g,x,v,b,_,w,A,S){const k=t.addToLineVertexArray(e,n);let I,M,z,T,B,C,P,D=0,V=0,F=0,L=0,R=-1,U=-1;const j={};let $=Na("");const O=r?r.anchor:e;let q=0,N=0;if(void 0===l._unevaluatedLayout.getValue("text-radial-offset")?[q,N]=l.layout.get("text-offset").evaluate(b,{},S).map((t=>t*ah)):(q=l.layout.get("text-radial-offset").evaluate(b,{},S)*ah,N=Ep),t.allowVerticalPlacement&&i.vertical){const t=i.vertical;if(d)C=$p(t),o&&(P=$p(o));else {const r=l.layout.get("text-rotate").evaluate(b,{},S)+90;z=jp(u,O,e,c,h,p,t,f,r,y),o&&(T=jp(u,O,e,c,h,p,o,g,r));}}if(s){const n=l.layout.get("icon-rotate").evaluate(b,{},S),i="none"!==l.layout.get("icon-text-fit"),a=bp(s,n,w,i),f=o?bp(o,n,w,i):void 0;M=jp(u,O,e,c,h,p,s,g,n),D=4*a.length;const d=t.iconSizeData;let y=null;"source"===d.kind?(y=[oh*l.layout.get("icon-size").evaluate(b,{},S)],y[0]>Lp&&E(`${t.layerIds[0]}: Value for "icon-size" is >= 255. Reduce your "icon-size".`)):"composite"===d.kind&&(y=[oh*_.compositeIconSizes[0].evaluate(b,{},S),oh*_.compositeIconSizes[1].evaluate(b,{},S)],(y[0]>Lp||y[1]>Lp)&&E(`${t.layerIds[0]}: Value for "icon-size" is >= 255. Reduce your "icon-size".`)),t.addSymbols(t.icon,a,y,v,x,b,!1,r,e,k.lineStartIndex,k.lineLength,-1,A,S),R=t.icon.placedSymbolArray.length-1,f&&(V=4*f.length,t.addSymbols(t.icon,f,y,v,x,b,Nh.vertical,r,e,k.lineStartIndex,k.lineLength,-1,A,S),U=t.icon.placedSymbolArray.length-1);}for(const n in i.horizontal){const s=i.horizontal[n];I||($=Na(s.text),d?B=$p(s):I=jp(u,O,e,c,h,p,s,f,l.layout.get("text-rotate").evaluate(b,{},S),y));const o=1===s.positionedLines.length;if(F+=Rp(t,r,e,s,a,l,d,b,y,k,i.vertical?Nh.horizontal:Nh.horizontalOnly,o?Object.keys(i.horizontal):[n],j,R,_,A,S),o)break}i.vertical&&(L+=Rp(t,r,e,i.vertical,a,l,d,b,y,k,Nh.vertical,["vertical"],j,U,_,A,S));let G=-1;const Z=(t,e)=>t?Math.max(t,e):e;G=Z(B,G),G=Z(C,G),G=Z(P,G);const X=G>-1?1:0;t.glyphOffsetArray.length>=Qf.MAX_GLYPHS&&E("Too many glyphs being rendered in a tile. See https://github.com/mapbox/mapbox-gl-js/issues/2907"),void 0!==b.sortKey&&t.addToSortKeyRanges(t.symbolInstances.length,b.sortKey),t.symbolInstances.emplaceBack(O.x,O.y,O.z,e.x,e.y,j.right>=0?j.right:-1,j.center>=0?j.center:-1,j.left>=0?j.left:-1,j.vertical>=0?j.vertical:-1,R,U,$,void 0!==I?I:t.collisionBoxArray.length,void 0!==I?I+1:t.collisionBoxArray.length,void 0!==z?z:t.collisionBoxArray.length,void 0!==z?z+1:t.collisionBoxArray.length,void 0!==M?M:t.collisionBoxArray.length,void 0!==M?M+1:t.collisionBoxArray.length,T||t.collisionBoxArray.length,T?T+1:t.collisionBoxArray.length,c,F,L,D,V,X,0,q,N,G);}(t,o,d,a,r,n,i,C,t.layers[0],t.collisionBoxArray,e.index,e.sourceLayerIndex,t.index,w,k,u,0,A,I,m,e,s,c,h,p);};if("line"===M)for(const i of dp(e.geometry,0,0,wo,wo)){const e=pp(i,_,S,r.vertical||g,n,24,b,t.overscaling,wo);for(const r of e){const e=g;e&&Op(t,e.text,z,r)||P(i,r,p);}}else if("line-center"===M){for(const t of e.geometry)if(t.length>1){const e=hp(t,S,r.vertical||g,n,24,b);e&&P(t,e,p);}}else if("Polygon"===e.type)for(const t of Yu(e.geometry,0)){const e=zp(t,16);P(t[0],new ap(e.x,e.y,0,0,void 0),p);}else if("LineString"===e.type)for(const t of e.geometry)P(t,new ap(t[0].x,t[0].y,0,0,void 0),p);else if("Point"===e.type)for(const t of e.geometry)for(const e of t)P([e],new ap(e.x,e.y,0,0,void 0),p);}const Lp=32640;function Rp(t,e,r,n,s,a,o,l,u,c,h,p,f,d,y,m,g){const x=function(t,e,r,n,s,a,o,l){const u=[];if(0===e.positionedLines.length)return u;const c=n.layout.get("text-rotate").evaluate(a,{})*Math.PI/180,h=function(t){const e=t[0],r=t[1],n=e*r;return n>0?[e,-r]:n<0?[-e,r]:0===e?[r,e]:[r,-e]}(r);let p=Math.abs(e.top-e.bottom);for(const t of e.positionedLines)p-=t.lineOffset;const f=e.positionedLines.length,d=p/f;let y=e.top-r[1];for(let t=0;t<f;++t){const n=e.positionedLines[t];y=kp(e,d,y,t);for(const t of n.positionedGlyphs){if(!t.rect)continue;const n=t.rect||{};let a=4,p=!0,f=1,d=0;if(t.imageName){const e=o[t.imageName];if(!e)continue;if(e.sdf){E("SDF images are not supported in formatted text and will be ignored.");continue}p=!1,f=e.pixelRatio,a=1/f;}const m=(s||l)&&t.vertical,g=t.metrics.advance*t.scale/2,x=t.metrics,v=t.rect;if(null===v)continue;l&&e.verticalizable&&(d=t.imageName?g-t.metrics.width*t.scale/2:0);const b=s?[t.x+g,t.y]:[0,0];let _=[0,0],w=[0,0],A=!1;s||(m?(w=[t.x+g+h[0],t.y+h[1]-d],A=!0):_=[t.x+g+r[0],t.y+r[1]-d]);const S=v.w*t.scale/(f*(t.localGlyph?2:1)),k=v.h*t.scale/(f*(t.localGlyph?2:1));let I,M,z,T;if(m){const e=t.y-y,r=new i(-g,g-e),n=-Math.PI/2,s=new i(...w);I=new i(-g+_[0],_[1]),I._rotateAround(n,r)._add(s),I.x+=-e+g,I.y-=(x.left-a)*t.scale;const o=t.imageName?x.advance*t.scale:ah*t.scale,l=String.fromCharCode(t.glyph);dh(l)?I.x+=(1-a)*t.scale:yh(l)?I.x+=o-x.height*t.scale+(-a-1)*t.scale:I.x+=t.imageName||x.width+2*a===v.w&&x.height+2*a===v.h?(o-k)/2:(o-(x.height+2*a)*t.scale)/2,M=new i(I.x,I.y-S),z=new i(I.x+k,I.y),T=new i(I.x+k,I.y-S);}else {const e=(x.left-a)*t.scale-g+_[0],r=(-x.top-a)*t.scale+_[1],n=e+S,s=r+k;I=new i(e,r),M=new i(n,r),z=new i(e,s),T=new i(n,s);}if(c){let t;t=s?new i(0,0):A?new i(h[0],h[1]):new i(r[0],r[1]),I._rotateAround(c,t),M._rotateAround(c,t),z._rotateAround(c,t),T._rotateAround(c,t);}const B=new i(0,0),C=new i(0,0);u.push({tl:I,tr:M,bl:z,br:T,tex:n,writingMode:e.writingMode,glyphOffset:b,sectionIndex:t.sectionIndex,isSDF:p,pixelOffsetTL:B,pixelOffsetBR:C,minFontScaleX:0,minFontScaleY:0});}}return u}(0,n,u,a,o,l,s,t.allowVerticalPlacement),v=t.textSizeData;let b=null;"source"===v.kind?(b=[oh*a.layout.get("text-size").evaluate(l,{},g)],b[0]>Lp&&E(`${t.layerIds[0]}: Value for "text-size" is >= 255. Reduce your "text-size".`)):"composite"===v.kind&&(b=[oh*y.compositeTextSizes[0].evaluate(l,{},g),oh*y.compositeTextSizes[1].evaluate(l,{},g)],(b[0]>Lp||b[1]>Lp)&&E(`${t.layerIds[0]}: Value for "text-size" is >= 255. Reduce your "text-size".`)),t.addSymbols(t.text,x,b,u,o,l,h,e,r,c.lineStartIndex,c.lineLength,d,m,g);for(const e of p)f[e]=t.text.placedSymbolArray.length-1;return 4*x.length}function Up(t){for(const e in t)return t[e];return null}function jp(t,e,r,n,s,a,o,u,c,h){let p=o.top,f=o.bottom,d=o.left,y=o.right;const m=o.collisionPadding;if(m&&(d-=m[0],p-=m[1],y+=m[2],f+=m[3]),c){const t=new i(d,p),e=new i(y,p),r=new i(d,f),n=new i(y,f),s=l(c);let a=new i(0,0);h&&(a=new i(h[0],h[1])),t._rotateAround(s,a),e._rotateAround(s,a),r._rotateAround(s,a),n._rotateAround(s,a),d=Math.min(t.x,e.x,r.x,n.x),y=Math.max(t.x,e.x,r.x,n.x),p=Math.min(t.y,e.y,r.y,n.y),f=Math.max(t.y,e.y,r.y,n.y);}return t.emplaceBack(e.x,e.y,e.z,r.x,r.y,d,p,y,f,u,n,s,a),t.length-1}function $p(t){t.collisionPadding&&(t.top-=t.collisionPadding[1],t.bottom+=t.collisionPadding[3]);const e=t.bottom-t.top;return e>0?Math.max(10,e):null}function Op(t,e,r,n){const i=t.compareText;if(e in i){const t=i[e];for(let e=t.length-1;e>=0;e--)if(n.dist(t[e])<r)return !0}else i[e]=[];return i[e].push(n),!1}const qp=Ws([{type:"Float32",name:"a_globe_pos",components:3},{type:"Float32",name:"a_uv",components:2}]),{members:Np}=qp,Gp=Ws([{name:"a_pos_3",components:3,type:"Int16"}]);var Zp=Ws([{name:"a_pos",type:"Int16",components:2}]);const Xp=wo/Math.PI/2,Kp=2*Bo(1,0)*Xp*Math.PI,Hp=[64,32,16],Yp=-Xp,Wp=Xp,Jp=[new eu([Yp,Yp,Yp],[Wp,Wp,Wp]),new eu([Yp,Yp,Yp],[0,0,Wp]),new eu([0,Yp,Yp],[Wp,0,Wp]),new eu([Yp,0,Yp],[0,Wp,Wp]),new eu([0,0,Yp],[Wp,Wp,Wp])];function Qp(t,e,r,n=!0){const i=Vl([],t._camera.position,t.worldSize),s=[e,r,1,1];Xl(s,s,t.pixelMatrixInverse),Zl(s,s,1/s[3]);const a=Ll([],ql([],s,i)),o=t.globeMatrix,l=[o[12],o[13],o[14]],c=ql([],l,i),h=zl(c),p=Ll([],c),f=t.worldSize/(2*Math.PI),y=Rl(p,a),m=Math.asin(f/h);if(m<Math.acos(y)){if(!n)return null;const t=[],e=[];Vl(t,a,h/y),Ll(e,ql(e,t,c)),Ll(a,Bl(a,c,Vl(a,e,Math.tan(m)*h)));}const g=[];new Jl(i,a).closestPointOnSphere(l,f,g);const x=Ll([],U(o,0)),v=Ll([],U(o,1)),b=Ll([],U(o,2)),_=Rl(x,g),w=Rl(v,g),A=Rl(b,g),S=u(Math.asin(-w/f));let k=u(Math.atan2(_,A));k=t.center.lng+function(t,e){const r=(e-t+180)%360-180;return r<-180?r+360:r}(t.center.lng,k);const I=zo(k),M=d(To(S),0,1);return new Fo(I,M)}class tf{constructor(t,e,r){this.a=ql([],t,r),this.b=ql([],e,r),this.center=r;const n=Ll([],this.a),i=Ll([],this.b);this.angle=Math.acos(Rl(n,i));}}function ef(t,e){if(0===t.angle)return null;let r;return r=0===t.a[e]?1/t.angle*.5*Math.PI:1/t.angle*Math.atan(t.b[e]/t.a[e]/Math.sin(t.angle)-1/Math.tan(t.angle)),r<0||r>1?null:function(t,e,r,n){const i=Math.sin(r);return t*(Math.sin((1-n)*r)/i)+e*(Math.sin(n*r)/i)}(t.a[e],t.b[e],t.angle,d(r,0,1))+t.center[e]}function rf(t){if(t.z<=1)return Jp[t.z+2*t.y+t.x];const e=lf(of(t));return eu.fromPoints(e)}function nf(t,e){const r=gf(e.zoom);if(0===r)return rf(t);const n=of(t),i=lf(n),s=zo(n.getWest())*e.worldSize,a=zo(n.getEast())*e.worldSize,o=To(n.getNorth())*e.worldSize,l=To(n.getSouth())*e.worldSize,u=[s,o,0],c=[a,o,0],h=[s,l,0],p=[a,l,0],f=gl([],e.globeMatrix);return jl(u,u,f),jl(c,c,f),jl(h,h,f),jl(p,p,f),i[0]=vr(i[0],h,r),i[1]=vr(i[1],p,r),i[2]=vr(i[2],c,r),i[3]=vr(i[3],u,r),eu.fromPoints(i)}function sf(t,e,r,n,i){for(const s of r)jl(s,s,n),Vl(s,s,i),Pl(t,t,s),Dl(e,e,s);}function af(t,e,r){const n=e/t.worldSize,i=Number.MAX_VALUE,s=[-i,-i,-i],a=[i,i,i],o=t.globeMatrix;if(r.z<=1)return sf(a,s,rf(r).getCorners(),o,n),new eu(a,s);const u=of(r),c=lf(u);if(sf(a,s,c,o,n),u.contains(t.center)){s[2]=0;const e=t.point,r=[e.x*n,e.y*n,0];return Pl(a,a,r),Dl(s,s,r),new eu(a,s)}const h=[o[12]*n,o[13]*n,o[14]*n],p=u.getCenter(),f=d(t.center.lat,-85.051129,Do),y=d(p.lat,-85.051129,Do),m=zo(t.center.lng),g=To(f);let x=m-zo(p.lng);const v=g-To(y);x>.5?x-=1:x<-.5&&(x+=1);let b=0;Math.abs(x)>Math.abs(v)?b=x>=0?1:3:(b=v>=0?0:2,Fl(h,h,[o[4]*n,o[5]*n,o[6]*n],-Math.sin(l(v>=0?u.getSouth():u.getNorth()))*Xp));const _=c[b],w=c[(b+1)%4],A=new tf(_,w,h),S=[ef(A,0)||_[0],ef(A,1)||_[1],ef(A,2)||_[2]];return a[2]=Math.min(_[2],w[2]),Pl(a,a,S),Dl(s,s,S),new eu(a,s)}function of({x:t,y:e,z:r}){const n=1/(1<<r),i=new ko(Eo(t*n),Co((e+1)*n)),s=new ko(Eo((t+1)*n),Co(e*n));return new Ao(i,s)}function lf(t){const e=l(t.getNorth()),r=l(t.getSouth()),n=Math.cos(e),i=Math.cos(r),s=Math.sin(e),a=Math.sin(r),o=t.getWest(),u=t.getEast();return [uf(i,a,o),uf(i,a,u),uf(n,s,u),uf(n,s,o)]}function uf(t,e,r,n=Xp){return r=l(r),[t*Math.sin(r)*n,-e*n,t*Math.cos(r)*n]}function cf(t,e,r){return uf(Math.cos(l(t)),Math.sin(l(t)),e,r)}function hf(t,e,r,n){const i=1<<r.z,s=(t/wo+r.x)/i;return cf(Co((e/wo+r.y)/i),Eo(s),n)}function pf({min:t,max:e}){return 16383/Math.max(e[0]-t[0],e[1]-t[1],e[2]-t[2])}const ff=new Float64Array(16);function df(t){const e=pf(t),r=Al(ff,[e,e,e]);return vl(r,r,((n=[])[0]=-(i=t.min)[0],n[1]=-i[1],n[2]=-i[2],n));var n,i;}function yf(t){const e=(n=t.min,(r=ff)[0]=1,r[1]=0,r[2]=0,r[3]=0,r[4]=0,r[5]=1,r[6]=0,r[7]=0,r[8]=0,r[9]=0,r[10]=1,r[11]=0,r[12]=n[0],r[13]=n[1],r[14]=n[2],r[15]=1,r);var r,n;const i=1/pf(t);return bl(e,e,[i,i,i])}function mf(t,e,r,n,i){const s=function(t){const e=wo/(2*Math.PI);return t/(2*Math.PI)/e}(r),a=[t,e,-r/(2*Math.PI)],o=ml(new Float64Array(16));return vl(o,o,a),bl(o,o,[s,s,s]),_l(o,o,l(-i)),wl(o,o,l(-n)),o}function gf(t){return y(5,6,t)}function xf(t,e){const r=cf(e.lat,e.lng);return s=(n=El([],function(t){const e=cf(t._center.lat,t._center.lng);let r=Ul([],Tl(0,1,0),e);const n=Sl([],-t.angle,e);r=jl(r,r,n),Sl(n,-t._pitch,r);const i=Ll([],e);return Vl(i,i,t.cameraToCenterDistance/t.pixelsPerMeter*Kp),jl(i,i,n),Bl([],e,i)}(t),r))[0],a=n[1],o=n[2],l=(i=r)[0],u=i[1],c=i[2],p=(h=Math.sqrt(s*s+a*a+o*o)*Math.sqrt(l*l+u*u+c*c))&&Rl(n,i)/h,Math.acos(Math.min(Math.max(p,-1),1));var n,i,s,a,o,l,u,c,h,p;}const vf=l(85),bf=Math.cos(vf),_f=Math.sin(vf);function wf(t,e){const r=t.fovAboveCenter,n=t.elevation?t.elevation.getMinElevationBelowMSL()*e:0,i=(t._camera.position[2]*t.worldSize-n)/Math.cos(t._pitch),s=Math.sin(r)*i/Math.sin(Math.max(Math.PI/2-t._pitch-r,.01)),a=Math.sin(t._pitch)*s+i;return Math.min(1.01*a,i*(1/t._horizonShift))}function Af(t,e){if(!e.isReprojectedInTileSpace)return {scale:1<<t.z,x:t.x,y:t.y,x2:t.x+1,y2:t.y+1,projection:e};const r=Math.pow(2,-t.z),n=t.x*r,i=(t.x+1)*r,s=t.y*r,a=(t.y+1)*r,o=Eo(n),l=Eo(i),u=Co(s),c=Co(a),h=e.project(o,u),p=e.project(l,u),f=e.project(l,c),d=e.project(o,c);let y=Math.min(h.x,p.x,f.x,d.x),m=Math.min(h.y,p.y,f.y,d.y),g=Math.max(h.x,p.x,f.x,d.x),x=Math.max(h.y,p.y,f.y,d.y);const v=r/16;function b(t,r,n,i,s,a){const o=(n+s)/2,l=(i+a)/2,u=e.project(Eo(o),Co(l)),c=Math.max(0,y-u.x,m-u.y,u.x-g,u.y-x);y=Math.min(y,u.x),g=Math.max(g,u.x),m=Math.min(m,u.y),x=Math.max(x,u.y),c>v&&(b(t,u,n,i,o,l),b(u,r,o,l,s,a));}b(h,p,n,s,i,s),b(p,f,i,s,i,a),b(f,d,i,a,n,a),b(d,h,n,a,n,s),y-=v,m-=v,g+=v,x+=v;const _=1/Math.max(g-y,x-m);return {scale:_,x:y*_,y:m*_,x2:g*_,y2:x*_,projection:e}}const Sf=ml(new Float32Array(16));class kf{constructor(t){this.spec=t,this.name=t.name,this.wrap=!1,this.requiresDraping=!1,this.supportsWorldCopies=!1,this.supportsTerrain=!1,this.supportsFog=!1,this.supportsFreeCamera=!1,this.zAxisUnit="meters",this.isReprojectedInTileSpace=!0,this.unsupportedLayers=["custom"],this.center=[0,0],this.range=[3.5,7];}project(t,e){return {x:0,y:0,z:0}}unproject(t,e){return new ko(0,0)}projectTilePoint(t,e,r){return {x:t,y:e,z:0}}locationPoint(t,e,r=!0){return t._coordinatePoint(t.locationCoordinate(e),r)}pixelsPerMeter(t,e){return Bo(1,t)*e}pixelSpaceConversion(t,e,r){return 1}farthestPixelDistance(t){return wf(t,t.pixelsPerMeter)}pointCoordinate(t,e,r,n){const s=t.horizonLineFromTop(!1),a=new i(e,Math.max(s,r));return t.rayIntersectionCoordinate(t.pointRayIntersection(a,n))}pointCoordinate3D(t,e,r){const n=new i(e,r);if(t.elevation)return t.elevation.pointCoordinate(n);{const e=this.pointCoordinate(t,n.x,n.y,0);return [e.x,e.y,e.z]}}isPointAboveHorizon(t,e){if(t.elevation)return !this.pointCoordinate3D(t,e.x,e.y);const r=t.horizonLineFromTop();return e.y<r}createInversionMatrix(t,e){return Sf}createTileMatrix(t,e,r){let n,i,s;const a=r.canonical,o=ml(new Float64Array(16));if(this.isReprojectedInTileSpace){const l=Af(a,this);n=1,i=l.x+r.wrap*l.scale,s=l.y,bl(o,o,[n/l.scale,n/l.scale,t.pixelsPerMeter/e]);}else n=e/t.zoomScale(a.z),i=(a.x+Math.pow(2,a.z)*r.wrap)*n,s=a.y*n;return vl(o,o,[i,s,0]),bl(o,o,[n/wo,n/wo,1]),o}upVector(t,e,r){return [0,0,1]}upVectorScale(t,e,r){return {metersToTile:1}}}class If extends kf{constructor(t){super(t),this.range=[4,7],this.center=t.center||[-96,37.5];const[e,r]=this.parallels=t.parallels||[29.5,45.5],n=Math.sin(l(e));this.n=(n+Math.sin(l(r)))/2,this.c=1+n*(2*this.n-n),this.r0=Math.sqrt(this.c)/this.n;}project(t,e){const{n:r,c:n,r0:i}=this,s=l(t-this.center[0]),a=l(e),o=Math.sqrt(n-2*r*Math.sin(a))/r;return {x:o*Math.sin(s*r),y:o*Math.cos(s*r)-i,z:0}}unproject(t,e){const{n:r,c:n,r0:i}=this,s=i+e;let a=Math.atan2(t,Math.abs(s))*Math.sign(s);s*r<0&&(a-=Math.PI*Math.sign(t)*Math.sign(s));const o=l(this.center[0])*r;a=m(a,-Math.PI-o,Math.PI-o);const c=u(a/r)+this.center[0],h=Math.asin(d((n-(t*t+s*s)*r*r)/(2*r),-1,1)),p=d(u(h),-85.051129,Do);return new ko(c,p)}}const Mf=1.340264,zf=-.081106,Tf=893e-6,Bf=.003796,Ef=Math.sqrt(3)/2;class Cf extends kf{project(t,e){e=e/180*Math.PI,t=t/180*Math.PI;const r=Math.asin(Ef*Math.sin(e)),n=r*r,i=n*n*n;return {x:.5*(t*Math.cos(r)/(Ef*(Mf+3*zf*n+i*(7*Tf+9*Bf*n)))/Math.PI+.5),y:1-.5*(r*(Mf+zf*n+i*(Tf+Bf*n))/Math.PI+1),z:0}}unproject(t,e){t=(2*t-.5)*Math.PI;let r=e=(2*(1-e)-1)*Math.PI,n=r*r,i=n*n*n;for(let t,s,a,o=0;o<12&&(s=r*(Mf+zf*n+i*(Tf+Bf*n))-e,a=Mf+3*zf*n+i*(7*Tf+9*Bf*n),t=s/a,r=d(r-t,-Math.PI/3,Math.PI/3),n=r*r,i=n*n*n,!(Math.abs(t)<1e-12));++o);const s=Ef*t*(Mf+3*zf*n+i*(7*Tf+9*Bf*n))/Math.cos(r),a=Math.asin(Math.sin(r)/Ef),o=d(180*s/Math.PI,-180,180),l=d(180*a/Math.PI,-85.051129,Do);return new ko(o,l)}}class Pf extends kf{constructor(t){super(t),this.wrap=!0,this.supportsWorldCopies=!0;}project(t,e){return {x:.5+t/360,y:.5-e/360,z:0}}unproject(t,e){const r=360*(t-.5),n=d(360*(.5-e),-85.051129,Do);return new ko(r,n)}}const Df=Math.PI/2;function Vf(t){return Math.tan((Df+t)/2)}class Ff extends kf{constructor(t){super(t),this.center=t.center||[0,30];const[e,r]=this.parallels=t.parallels||[30,30],n=l(e),i=l(r),s=Math.cos(n);this.n=n===i?Math.sin(n):Math.log(s/Math.cos(i))/Math.log(Vf(i)/Vf(n)),this.f=s*Math.pow(Vf(n),this.n)/this.n;}project(t,e){e=l(e),t=l(t-this.center[0]);const r=1e-6,{n:n,f:i}=this;i>0?e<-Df+r&&(e=-Df+r):e>Df-r&&(e=Df-r);const s=i/Math.pow(Vf(e),n),a=s*Math.sin(n*t),o=i-s*Math.cos(n*t);return {x:.5*(a/Math.PI+.5),y:1-.5*(o/Math.PI+.5),z:0}}unproject(t,e){t=(2*t-.5)*Math.PI,e=(2*(1-e)-.5)*Math.PI;const{n:r,f:n}=this,i=n-e,s=Math.sign(i),a=Math.sign(r)*Math.sqrt(t*t+i*i);let o=Math.atan2(t,Math.abs(i))*s;i*r<0&&(o-=Math.PI*Math.sign(t)*s);const l=d(u(o/r)+this.center[0],-180,180),c=d(u(2*Math.atan(Math.pow(n/a,1/r))-Df),-85.051129,Do);return new ko(l,c)}}class Lf extends kf{constructor(t){super(t),this.wrap=!0,this.supportsWorldCopies=!0,this.supportsTerrain=!0,this.supportsFog=!0,this.supportsFreeCamera=!0,this.isReprojectedInTileSpace=!1,this.unsupportedLayers=[],this.range=null;}project(t,e){return {x:zo(t),y:To(e),z:0}}unproject(t,e){const r=Eo(t),n=Co(e);return new ko(r,n)}}const Rf=l(Do);class Uf extends kf{project(t,e){const r=(e=l(e))*e,n=r*r;return {x:.5*((t=l(t))*(.8707-.131979*r+n*(n*(.003971*r-.001529*n)-.013791))/Math.PI+.5),y:1-.5*(e*(1.007226+r*(.015085+n*(.028874*r-.044475-.005916*n)))/Math.PI+1),z:0}}unproject(t,e){t=(2*t-.5)*Math.PI;let r=e=(2*(1-e)-1)*Math.PI,n=25,i=0,s=r*r;do{s=r*r;const t=s*s;i=(r*(1.007226+s*(.015085+t*(.028874*s-.044475-.005916*t)))-e)/(1.007226+s*(.045255+t*(.259866*s-.311325-.005916*11*t))),r=d(r-i,-Rf,Rf);}while(Math.abs(i)>1e-6&&--n>0);s=r*r;const a=d(u(t/(.8707+s*(s*(s*s*s*(.003971-.001529*s)-.013791)-.131979))),-180,180),o=u(r);return new ko(a,o)}}const jf=l(Do);class $f extends kf{project(t,e){e=l(e),t=l(t);const r=Math.cos(e),n=2/Math.PI,i=Math.acos(r*Math.cos(t/2)),s=Math.sin(i)/i,a=.5*(t*n+2*r*Math.sin(t/2)/s)||0,o=.5*(e+Math.sin(e)/s)||0;return {x:.5*(a/Math.PI+.5),y:1-.5*(o/Math.PI+1),z:0}}unproject(t,e){let r=t=(2*t-.5)*Math.PI,n=e=(2*(1-e)-1)*Math.PI,i=25;const s=1e-6;let a=0,o=0;do{const i=Math.cos(n),s=Math.sin(n),l=2*s*i,u=s*s,c=i*i,h=Math.cos(r/2),p=Math.sin(r/2),f=2*h*p,y=p*p,m=1-c*h*h,g=m?1/m:0,x=m?Math.acos(i*h)*Math.sqrt(1/m):0,v=.5*(2*x*i*p+2*r/Math.PI)-t,b=.5*(x*s+n)-e,_=.5*g*(c*y+x*i*h*u)+1/Math.PI,w=g*(f*l/4-x*s*p),A=.125*g*(l*p-x*s*c*f),S=.5*g*(u*h+x*y*i)+.5,k=w*A-S*_;a=(b*w-v*S)/k,o=(v*A-b*_)/k,r=d(r-a,-Math.PI,Math.PI),n=d(n-o,-jf,jf);}while((Math.abs(a)>s||Math.abs(o)>s)&&--i>0);return new ko(u(r),u(n))}}class Of extends kf{constructor(t){super(t),this.center=t.center||[0,0],this.parallels=t.parallels||[0,0],this.cosPhi=Math.max(.01,Math.cos(l(this.parallels[0]))),this.scale=1/(2*Math.max(Math.PI*this.cosPhi,1/this.cosPhi)),this.wrap=!0,this.supportsWorldCopies=!0;}project(t,e){const{scale:r,cosPhi:n}=this;return {x:l(t)*n*r+.5,y:-Math.sin(l(e))/n*r+.5,z:0}}unproject(t,e){const{scale:r,cosPhi:n}=this,i=-(e-.5)/r,s=d(u((t-.5)/r)/n,-180,180),a=Math.asin(d(i*n,-1,1)),o=d(u(a),-85.051129,Do);return new ko(s,o)}}class qf extends Lf{constructor(t){super(t),this.requiresDraping=!0,this.supportsWorldCopies=!1,this.supportsFog=!0,this.zAxisUnit="pixels",this.unsupportedLayers=["debug","custom"],this.range=[3,5];}projectTilePoint(t,e,r){const n=hf(t,e,r);return jl(n,n,df(rf(r))),{x:n[0],y:n[1],z:n[2]}}locationPoint(t,e){const r=cf(e.lat,e.lng),n=Ll([],r),s=t.elevation?t.elevation.getAtPointOrZero(t.locationCoordinate(e),t._centerAltitude):t._centerAltitude;Fl(r,r,n,Bo(1,0)*wo*s);const a=ml(new Float64Array(16));return xl(a,t.pixelMatrix,t.globeMatrix),jl(r,r,a),new i(r[0],r[1])}pixelsPerMeter(t,e){return Bo(1,0)*e}pixelSpaceConversion(t,e,r){const n=xr(Bo(1,45)*e,Bo(1,t)*e,r);return this.pixelsPerMeter(t,e)/n}createTileMatrix(t,e,r){const n=yf(rf(r.canonical));return xl(new Float64Array(16),t.globeMatrix,n)}createInversionMatrix(t,e){const{center:r}=t,n=df(rf(e));return wl(n,n,l(r.lng)),_l(n,n,l(r.lat)),bl(n,n,[t._pixelsPerMercatorPixel,t._pixelsPerMercatorPixel,1]),Float32Array.from(n)}pointCoordinate(t,e,r,n){return Qp(t,e,r,!0)||new Fo(0,0)}pointCoordinate3D(t,e,r){const n=this.pointCoordinate(t,e,r,0);return [n.x,n.y,n.z]}isPointAboveHorizon(t,e){return !Qp(t,e.x,e.y,!1)}farthestPixelDistance(t){const e=function(t,e){const r=t.cameraToCenterDistance,n=t._centerAltitude*e,i=t._camera,s=t._camera.forward(),a=Bl([],Vl([],s,-r),[0,0,n]),o=t.worldSize/(2*Math.PI),l=[0,0,-o],u=t.width/t.height,c=Math.tan(t.fovAboveCenter),h=Vl([],i.up(),c),p=Vl([],i.right(),c*u),f=Ll([],Bl([],Bl([],s,h),p)),d=[];let y;if(new Jl(a,f).closestPointOnSphere(l,o,d)){const e=Bl([],d,l),r=ql([],e,a);y=Math.cos(t.fovAboveCenter)*zl(r);}else {const t=ql([],a,l),e=ql([],l,a);Ll(e,e);const r=zl(t)-o;y=Math.sqrt(r*(r+2*o));const n=Math.acos(y/(o+r))-Math.acos(Rl(s,e));y*=Math.cos(n);}return 1.01*y}(t,this.pixelsPerMeter(t.center.lat,t.worldSize)),r=gf(t.zoom);if(r>0){const n=wf(t,Bo(1,t.center.lat)*t.worldSize),i=t.worldSize/(2*Math.PI),s=Math.max(t.width,t.height)/t.worldSize*Math.PI;return xr(e,n+i*(1-Math.cos(s)),Math.pow(r,10))}return e}upVector(t,e,r){return hf(e,r,t,1)}upVectorScale(t){return {metersToTile:Kp*pf(rf(t))}}}function Nf(t){const e=t.parallels,r=!!e&&Math.abs(e[0]+e[1])<.01;switch(t.name){case"mercator":return new Lf(t);case"equirectangular":return new Pf(t);case"naturalEarth":return new Uf(t);case"equalEarth":return new Cf(t);case"winkelTripel":return new $f(t);case"albers":return r?new Of(t):new If(t);case"lambertConformalConic":return r?new Of(t):new Ff(t);case"globe":return new qf(t)}throw new Error(`Invalid projection name: ${t.name}`)}const Gf=yc.VectorTileFeature.types,Zf=[{name:"a_fade_opacity",components:1,type:"Uint8",offset:0}];function Xf(t,e,r,n,i,s,a,o,l,u,c,h,p){const f=o?Math.min(Lp,Math.round(o[0])):0,d=o?Math.min(Lp,Math.round(o[1])):0;t.emplaceBack(e,r,Math.round(32*n),Math.round(32*i),s,a,(f<<1)+(l?1:0),d,16*u,16*c,256*h,256*p);}function Kf(t,e,r,n,i,s,a){t.emplaceBack(e,r,n,i,s,a);}function Hf(t,e,r,n,i){t.emplaceBack(e,r,n,i),t.emplaceBack(e,r,n,i),t.emplaceBack(e,r,n,i),t.emplaceBack(e,r,n,i);}function Yf(t){for(const e of t.sections)if(vs(e.text))return !0;return !1}class Wf{constructor(t){this.layoutVertexArray=new oa,this.indexArray=new ya,this.programConfigurations=t,this.segments=new _o,this.dynamicLayoutVertexArray=new na,this.opacityVertexArray=new ua,this.placedSymbolArray=new Ta,this.globeExtVertexArray=new la;}isEmpty(){return 0===this.layoutVertexArray.length&&0===this.indexArray.length&&0===this.dynamicLayoutVertexArray.length&&0===this.opacityVertexArray.length}upload(t,e,r,n){this.isEmpty()||(r&&(this.layoutVertexBuffer=t.createVertexBuffer(this.layoutVertexArray,Qc.members),this.indexBuffer=t.createIndexBuffer(this.indexArray,e),this.dynamicLayoutVertexBuffer=t.createVertexBuffer(this.dynamicLayoutVertexArray,eh.members,!0),this.opacityVertexBuffer=t.createVertexBuffer(this.opacityVertexArray,Zf,!0),this.globeExtVertexArray.length>0&&(this.globeExtVertexBuffer=t.createVertexBuffer(this.globeExtVertexArray,th.members,!0)),this.opacityVertexBuffer.itemSize=1),(r||n)&&this.programConfigurations.upload(t));}destroy(){this.layoutVertexBuffer&&(this.layoutVertexBuffer.destroy(),this.indexBuffer.destroy(),this.programConfigurations.destroy(),this.segments.destroy(),this.dynamicLayoutVertexBuffer.destroy(),this.opacityVertexBuffer.destroy(),this.globeExtVertexBuffer&&this.globeExtVertexBuffer.destroy());}}Pi(Wf,"SymbolBuffers");class Jf{constructor(t,e,r){this.layoutVertexArray=new t,this.layoutAttributes=e,this.indexArray=new r,this.segments=new _o,this.collisionVertexArray=new fa,this.collisionVertexArrayExt=new da;}upload(t){this.layoutVertexBuffer=t.createVertexBuffer(this.layoutVertexArray,this.layoutAttributes),this.indexBuffer=t.createIndexBuffer(this.indexArray),this.collisionVertexBuffer=t.createVertexBuffer(this.collisionVertexArray,rh.members,!0),this.collisionVertexBufferExt=t.createVertexBuffer(this.collisionVertexArrayExt,nh.members,!0);}destroy(){this.layoutVertexBuffer&&(this.layoutVertexBuffer.destroy(),this.indexBuffer.destroy(),this.segments.destroy(),this.collisionVertexBuffer.destroy(),this.collisionVertexBufferExt.destroy());}}Pi(Jf,"CollisionBuffers");class Qf{constructor(t){this.collisionBoxArray=t.collisionBoxArray,this.zoom=t.zoom,this.overscaling=t.overscaling,this.layers=t.layers,this.layerIds=this.layers.map((t=>t.id)),this.index=t.index,this.pixelRatio=t.pixelRatio,this.sourceLayerIndex=t.sourceLayerIndex,this.hasPattern=!1,this.hasRTLText=!1,this.fullyClipped=!1,this.sortKeyRanges=[],this.collisionCircleArray=[],this.placementInvProjMatrix=ml([]),this.placementViewportMatrix=ml([]);const e=this.layers[0]._unevaluatedLayout._values;this.textSizeData=lh(this.zoom,e["text-size"]),this.iconSizeData=lh(this.zoom,e["icon-size"]);const r=this.layers[0].layout,n=r.get("symbol-sort-key"),i=r.get("symbol-z-order");this.canOverlap=r.get("text-allow-overlap")||r.get("icon-allow-overlap")||r.get("text-ignore-placement")||r.get("icon-ignore-placement"),this.sortFeaturesByKey="viewport-y"!==i&&void 0!==n.constantOr(1),this.sortFeaturesByY=("viewport-y"===i||"auto"===i&&!this.sortFeaturesByKey)&&this.canOverlap,this.writingModes=r.get("text-writing-mode").map((t=>Nh[t])),this.stateDependentLayerIds=this.layers.filter((t=>t.isStateDependent())).map((t=>t.id)),this.sourceID=t.sourceID,this.projection=t.projection;}createArrays(){this.text=new Wf(new co(this.layers,this.zoom,(t=>/^text/.test(t)))),this.icon=new Wf(new co(this.layers,this.zoom,(t=>/^icon/.test(t)))),this.glyphOffsetArray=new Ca,this.lineVertexArray=new Pa,this.symbolInstances=new Ea;}calculateGlyphDependencies(t,e,r,n,i){for(let r=0;r<t.length;r++)if(e[t.charCodeAt(r)]=!0,n&&i){const n=fh[t.charAt(r)];n&&(e[n.charCodeAt(0)]=!0);}}populate(t,e,r,n){const i=this.layers[0],s=i.layout,a="globe"===this.projection.name,o=s.get("text-font"),l=s.get("text-field"),u=s.get("icon-image"),c=("constant"!==l.value.kind||l.value.value instanceof _e&&!l.value.value.isEmpty()||l.value.value.toString().length>0)&&("constant"!==o.value.kind||o.value.value.length>0),h="constant"!==u.value.kind||!!u.value.value||Object.keys(u.parameters).length>0,p=s.get("symbol-sort-key");if(this.features=[],!c&&!h)return;const f=e.iconDependencies,d=e.glyphDependencies,y=e.availableImages,m=new Cs(this.zoom);for(const{feature:e,id:l,index:u,sourceLayerIndex:g}of t){const t=i._featureFilter.needGeometry,x=Go(e,t);if(!i._featureFilter.filter(m,x,r))continue;if(t||(x.geometry=No(e,r,n)),a&&1!==e.type&&r.z<=5){const t=x.geometry,e=.98078528056;for(let n=0;n<t.length;n++)t[n]=jo(t[n],(t=>t),((t,n)=>Rl(hf(t.x,t.y,r,1),hf(n.x,n.y,r,1))<e));}let v,b;if(c){const t=i.getValueAndResolveTokens("text-field",x,r,y),e=_e.factory(t);Yf(e)&&(this.hasRTLText=!0),(!this.hasRTLText||"unavailable"===Ts()||this.hasRTLText&&Es.isParsed())&&(v=ph(e,i,x));}if(h){const t=i.getValueAndResolveTokens("icon-image",x,r,y);b=t instanceof we?t:we.fromString(t);}if(!v&&!b)continue;const _=this.sortFeaturesByKey?p.evaluate(x,{},r):void 0;if(this.features.push({id:l,text:v,icon:b,index:u,sourceLayerIndex:g,geometry:x.geometry,properties:e.properties,type:Gf[e.type],sortKey:_}),b&&(f[b.name]=!0),v){const t=o.evaluate(x,{},r).join(","),e="map"===s.get("text-rotation-alignment")&&"point"!==s.get("symbol-placement");this.allowVerticalPlacement=this.writingModes&&this.writingModes.indexOf(Nh.vertical)>=0;for(const r of v.sections)if(r.image)f[r.image.name]=!0;else {const n=ps(v.toString()),i=r.fontStack||t,s=d[i]=d[i]||{};this.calculateGlyphDependencies(r.text,s,e,this.allowVerticalPlacement,n);}}}"line"===s.get("symbol-placement")&&(this.features=function(t){const e={},r={},n=[];let i=0;function s(e){n.push(t[e]),i++;}function a(t,e,i){const s=r[t];return delete r[t],r[e]=s,n[s].geometry[0].pop(),n[s].geometry[0]=n[s].geometry[0].concat(i[0]),s}function o(t,r,i){const s=e[r];return delete e[r],e[t]=s,n[s].geometry[0].shift(),n[s].geometry[0]=i[0].concat(n[s].geometry[0]),s}function l(t,e,r){const n=r?e[0][e[0].length-1]:e[0][0];return `${t}:${n.x}:${n.y}`}for(let u=0;u<t.length;u++){const c=t[u],h=c.geometry,p=c.text?c.text.toString():null;if(!p){s(u);continue}const f=l(p,h),d=l(p,h,!0);if(f in r&&d in e&&r[f]!==e[d]){const t=o(f,d,h),i=a(f,d,n[t].geometry);delete e[f],delete r[d],r[l(p,n[i].geometry,!0)]=i,n[t].geometry=null;}else f in r?a(f,d,h):d in e?o(f,d,h):(s(u),e[f]=i-1,r[d]=i-1);}return n.filter((t=>t.geometry))}(this.features)),this.sortFeaturesByKey&&this.features.sort(((t,e)=>t.sortKey-e.sortKey));}update(t,e,r,n){this.stateDependentLayers.length&&(this.text.programConfigurations.updatePaintArrays(t,e,this.layers,r,n),this.icon.programConfigurations.updatePaintArrays(t,e,this.layers,r,n));}isEmpty(){return 0===this.symbolInstances.length&&!this.hasRTLText}uploadPending(){return !this.uploaded||this.text.programConfigurations.needsUpload||this.icon.programConfigurations.needsUpload}upload(t){!this.uploaded&&this.hasDebugData()&&(this.textCollisionBox.upload(t),this.iconCollisionBox.upload(t)),this.text.upload(t,this.sortFeaturesByY,!this.uploaded,this.text.programConfigurations.needsUpload),this.icon.upload(t,this.sortFeaturesByY,!this.uploaded,this.icon.programConfigurations.needsUpload),this.uploaded=!0;}destroyDebugData(){this.textCollisionBox.destroy(),this.iconCollisionBox.destroy();}getProjection(){return this.projectionInstance||(this.projectionInstance=Nf(this.projection)),this.projectionInstance}destroy(){this.text.destroy(),this.icon.destroy(),this.hasDebugData()&&this.destroyDebugData();}addToLineVertexArray(t,e){const r=this.lineVertexArray.length,n=t.segment;if(void 0!==n){let r=t.dist(e[n+1]),i=t.dist(e[n]);const s={};for(let t=n+1;t<e.length;t++)s[t]={x:e[t].x,y:e[t].y,tileUnitDistanceFromAnchor:r},t<e.length-1&&(r+=e[t+1].dist(e[t]));for(let t=n||0;t>=0;t--)s[t]={x:e[t].x,y:e[t].y,tileUnitDistanceFromAnchor:i},t>0&&(i+=e[t-1].dist(e[t]));for(let t=0;t<e.length;t++){const e=s[t];this.lineVertexArray.emplaceBack(e.x,e.y,e.tileUnitDistanceFromAnchor);}}return {lineStartIndex:r,lineLength:this.lineVertexArray.length-r}}addSymbols(t,e,r,n,i,s,a,o,l,u,c,h,p,f){const d=t.indexArray,y=t.layoutVertexArray,m=t.globeExtVertexArray,g=t.segments.prepareSegment(4*e.length,y,d,this.canOverlap?s.sortKey:void 0),x=this.glyphOffsetArray.length,v=g.vertexLength,b=this.allowVerticalPlacement&&a===Nh.vertical?Math.PI/2:0,_=s.text&&s.text.sections;for(let n=0;n<e.length;n++){const{tl:i,tr:a,bl:u,br:c,tex:h,pixelOffsetTL:x,pixelOffsetBR:v,minFontScaleX:w,minFontScaleY:A,glyphOffset:S,isSDF:k,sectionIndex:I}=e[n],M=g.vertexLength,z=S[1];if(Xf(y,l.x,l.y,i.x,z+i.y,h.x,h.y,r,k,x.x,x.y,w,A),Xf(y,l.x,l.y,a.x,z+a.y,h.x+h.w,h.y,r,k,v.x,x.y,w,A),Xf(y,l.x,l.y,u.x,z+u.y,h.x,h.y+h.h,r,k,x.x,v.y,w,A),Xf(y,l.x,l.y,c.x,z+c.y,h.x+h.w,h.y+h.h,r,k,v.x,v.y,w,A),o){const e=o.anchor,r=o.up;Kf(m,e.x,e.y,e.z,r[0],r[1],r[2]),Kf(m,e.x,e.y,e.z,r[0],r[1],r[2]),Kf(m,e.x,e.y,e.z,r[0],r[1],r[2]),Kf(m,e.x,e.y,e.z,r[0],r[1],r[2]),Hf(t.dynamicLayoutVertexArray,e.x,e.y,e.z,b);}else Hf(t.dynamicLayoutVertexArray,l.x,l.y,l.z,b);d.emplaceBack(M,M+1,M+2),d.emplaceBack(M+1,M+2,M+3),g.vertexLength+=4,g.primitiveLength+=2,this.glyphOffsetArray.emplaceBack(S[0]),n!==e.length-1&&I===e[n+1].sectionIndex||t.programConfigurations.populatePaintArrays(y.length,s,s.index,{},p,f,_&&_[I]);}const w=o?o.anchor:l;t.placedSymbolArray.emplaceBack(w.x,w.y,w.z,l.x,l.y,x,this.glyphOffsetArray.length-x,v,u,c,l.segment,r?r[0]:0,r?r[1]:0,n[0],n[1],a,0,!1,0,h,0);}_commitLayoutVertex(t,e,r,n,i,s,a){t.emplaceBack(e,r,n,i,s,Math.round(a.x),Math.round(a.y));}_addCollisionDebugVertices(t,e,r,n,s,a,o){const l=r.segments.prepareSegment(4,r.layoutVertexArray,r.indexArray),u=l.vertexLength,c=o.tileAnchorX,h=o.tileAnchorY;for(let t=0;t<4;t++)r.collisionVertexArray.emplaceBack(0,0,0,0);r.collisionVertexArrayExt.emplaceBack(e,-t.padding,-t.padding),r.collisionVertexArrayExt.emplaceBack(e,t.padding,-t.padding),r.collisionVertexArrayExt.emplaceBack(e,t.padding,t.padding),r.collisionVertexArrayExt.emplaceBack(e,-t.padding,t.padding),this._commitLayoutVertex(r.layoutVertexArray,n,s,a,c,h,new i(t.x1,t.y1)),this._commitLayoutVertex(r.layoutVertexArray,n,s,a,c,h,new i(t.x2,t.y1)),this._commitLayoutVertex(r.layoutVertexArray,n,s,a,c,h,new i(t.x2,t.y2)),this._commitLayoutVertex(r.layoutVertexArray,n,s,a,c,h,new i(t.x1,t.y2)),l.vertexLength+=4;const p=r.indexArray;p.emplaceBack(u,u+1),p.emplaceBack(u+1,u+2),p.emplaceBack(u+2,u+3),p.emplaceBack(u+3,u),l.primitiveLength+=4;}_addTextDebugCollisionBoxes(t,e,r,n,i,s){for(let a=n;a<i;a++){const n=r.get(a),i=this.getSymbolInstanceTextSize(t,s,e,a);this._addCollisionDebugVertices(n,i,this.textCollisionBox,n.projectedAnchorX,n.projectedAnchorY,n.projectedAnchorZ,s);}}_addIconDebugCollisionBoxes(t,e,r,n,i,s){for(let a=n;a<i;a++){const n=r.get(a),i=this.getSymbolInstanceIconSize(t,e,a);this._addCollisionDebugVertices(n,i,this.iconCollisionBox,n.projectedAnchorX,n.projectedAnchorY,n.projectedAnchorZ,s);}}generateCollisionDebugBuffers(t,e){this.hasDebugData()&&this.destroyDebugData(),this.textCollisionBox=new Jf(ha,ih.members,_a),this.iconCollisionBox=new Jf(ha,ih.members,_a);const r=ch(this.iconSizeData,t),n=ch(this.textSizeData,t);for(let i=0;i<this.symbolInstances.length;i++){const s=this.symbolInstances.get(i);this._addTextDebugCollisionBoxes(n,t,e,s.textBoxStartIndex,s.textBoxEndIndex,s),this._addTextDebugCollisionBoxes(n,t,e,s.verticalTextBoxStartIndex,s.verticalTextBoxEndIndex,s),this._addIconDebugCollisionBoxes(r,t,e,s.iconBoxStartIndex,s.iconBoxEndIndex,s),this._addIconDebugCollisionBoxes(r,t,e,s.verticalIconBoxStartIndex,s.verticalIconBoxEndIndex,s);}}getSymbolInstanceTextSize(t,e,r,n){const i=this.text.placedSymbolArray.get(e.rightJustifiedTextSymbolIndex>=0?e.rightJustifiedTextSymbolIndex:e.centerJustifiedTextSymbolIndex>=0?e.centerJustifiedTextSymbolIndex:e.leftJustifiedTextSymbolIndex>=0?e.leftJustifiedTextSymbolIndex:e.verticalPlacedTextSymbolIndex>=0?e.verticalPlacedTextSymbolIndex:n),s=uh(this.textSizeData,t,i)/ah;return this.tilePixelRatio*s}getSymbolInstanceIconSize(t,e,r){const n=this.icon.placedSymbolArray.get(r),i=uh(this.iconSizeData,t,n);return this.tilePixelRatio*i}_commitDebugCollisionVertexUpdate(t,e,r){t.emplaceBack(e,-r,-r),t.emplaceBack(e,r,-r),t.emplaceBack(e,r,r),t.emplaceBack(e,-r,r);}_updateTextDebugCollisionBoxes(t,e,r,n,i,s){for(let a=n;a<i;a++){const n=r.get(a),i=this.getSymbolInstanceTextSize(t,s,e,a);this._commitDebugCollisionVertexUpdate(this.textCollisionBox.collisionVertexArrayExt,i,n.padding);}}_updateIconDebugCollisionBoxes(t,e,r,n,i){for(let s=n;s<i;s++){const n=r.get(s),i=this.getSymbolInstanceIconSize(t,e,s);this._commitDebugCollisionVertexUpdate(this.iconCollisionBox.collisionVertexArrayExt,i,n.padding);}}updateCollisionDebugBuffers(t,e){if(!this.hasDebugData())return;this.hasTextCollisionBoxData()&&this.textCollisionBox.collisionVertexArrayExt.clear(),this.hasIconCollisionBoxData()&&this.iconCollisionBox.collisionVertexArrayExt.clear();const r=ch(this.iconSizeData,t),n=ch(this.textSizeData,t);for(let i=0;i<this.symbolInstances.length;i++){const s=this.symbolInstances.get(i);this._updateTextDebugCollisionBoxes(n,t,e,s.textBoxStartIndex,s.textBoxEndIndex,s),this._updateTextDebugCollisionBoxes(n,t,e,s.verticalTextBoxStartIndex,s.verticalTextBoxEndIndex,s),this._updateIconDebugCollisionBoxes(r,t,e,s.iconBoxStartIndex,s.iconBoxEndIndex),this._updateIconDebugCollisionBoxes(r,t,e,s.verticalIconBoxStartIndex,s.verticalIconBoxEndIndex);}this.hasTextCollisionBoxData()&&this.textCollisionBox.collisionVertexBufferExt&&this.textCollisionBox.collisionVertexBufferExt.updateData(this.textCollisionBox.collisionVertexArrayExt),this.hasIconCollisionBoxData()&&this.iconCollisionBox.collisionVertexBufferExt&&this.iconCollisionBox.collisionVertexBufferExt.updateData(this.iconCollisionBox.collisionVertexArrayExt);}_deserializeCollisionBoxesForSymbol(t,e,r,n,i,s,a,o,l){const u={};for(let n=e;n<r;n++){const e=t.get(n);u.textBox={x1:e.x1,y1:e.y1,x2:e.x2,y2:e.y2,padding:e.padding,projectedAnchorX:e.projectedAnchorX,projectedAnchorY:e.projectedAnchorY,projectedAnchorZ:e.projectedAnchorZ,tileAnchorX:e.tileAnchorX,tileAnchorY:e.tileAnchorY},u.textFeatureIndex=e.featureIndex;break}for(let e=n;e<i;e++){const r=t.get(e);u.verticalTextBox={x1:r.x1,y1:r.y1,x2:r.x2,y2:r.y2,padding:r.padding,projectedAnchorX:r.projectedAnchorX,projectedAnchorY:r.projectedAnchorY,projectedAnchorZ:r.projectedAnchorZ,tileAnchorX:r.tileAnchorX,tileAnchorY:r.tileAnchorY},u.verticalTextFeatureIndex=r.featureIndex;break}for(let e=s;e<a;e++){const r=t.get(e);u.iconBox={x1:r.x1,y1:r.y1,x2:r.x2,y2:r.y2,padding:r.padding,projectedAnchorX:r.projectedAnchorX,projectedAnchorY:r.projectedAnchorY,projectedAnchorZ:r.projectedAnchorZ,tileAnchorX:r.tileAnchorX,tileAnchorY:r.tileAnchorY},u.iconFeatureIndex=r.featureIndex;break}for(let e=o;e<l;e++){const r=t.get(e);u.verticalIconBox={x1:r.x1,y1:r.y1,x2:r.x2,y2:r.y2,padding:r.padding,projectedAnchorX:r.projectedAnchorX,projectedAnchorY:r.projectedAnchorY,projectedAnchorZ:r.projectedAnchorZ,tileAnchorX:r.tileAnchorX,tileAnchorY:r.tileAnchorY},u.verticalIconFeatureIndex=r.featureIndex;break}return u}deserializeCollisionBoxes(t){this.collisionArrays=[];for(let e=0;e<this.symbolInstances.length;e++){const r=this.symbolInstances.get(e);this.collisionArrays.push(this._deserializeCollisionBoxesForSymbol(t,r.textBoxStartIndex,r.textBoxEndIndex,r.verticalTextBoxStartIndex,r.verticalTextBoxEndIndex,r.iconBoxStartIndex,r.iconBoxEndIndex,r.verticalIconBoxStartIndex,r.verticalIconBoxEndIndex));}}hasTextData(){return this.text.segments.get().length>0}hasIconData(){return this.icon.segments.get().length>0}hasDebugData(){return this.textCollisionBox&&this.iconCollisionBox}hasTextCollisionBoxData(){return this.hasDebugData()&&this.textCollisionBox.segments.get().length>0}hasIconCollisionBoxData(){return this.hasDebugData()&&this.iconCollisionBox.segments.get().length>0}addIndicesForPlacedSymbol(t,e){const r=t.placedSymbolArray.get(e),n=r.vertexStartIndex+4*r.numGlyphs;for(let e=r.vertexStartIndex;e<n;e+=4)t.indexArray.emplaceBack(e,e+1,e+2),t.indexArray.emplaceBack(e+1,e+2,e+3);}getSortedSymbolIndexes(t){if(this.sortedAngle===t&&void 0!==this.symbolInstanceIndexes)return this.symbolInstanceIndexes;const e=Math.sin(t),r=Math.cos(t),n=[],i=[],s=[];for(let t=0;t<this.symbolInstances.length;++t){s.push(t);const a=this.symbolInstances.get(t);n.push(0|Math.round(e*a.tileAnchorX+r*a.tileAnchorY)),i.push(a.featureIndex);}return s.sort(((t,e)=>n[t]-n[e]||i[e]-i[t])),s}addToSortKeyRanges(t,e){const r=this.sortKeyRanges[this.sortKeyRanges.length-1];r&&r.sortKey===e?r.symbolInstanceEnd=t+1:this.sortKeyRanges.push({sortKey:e,symbolInstanceStart:t,symbolInstanceEnd:t+1});}sortFeatures(t){if(this.sortFeaturesByY&&this.sortedAngle!==t&&!(this.text.segments.get().length>1||this.icon.segments.get().length>1)){this.symbolInstanceIndexes=this.getSortedSymbolIndexes(t),this.sortedAngle=t,this.text.indexArray.clear(),this.icon.indexArray.clear(),this.featureSortOrder=[];for(const t of this.symbolInstanceIndexes){const e=this.symbolInstances.get(t);this.featureSortOrder.push(e.featureIndex),[e.rightJustifiedTextSymbolIndex,e.centerJustifiedTextSymbolIndex,e.leftJustifiedTextSymbolIndex].forEach(((t,e,r)=>{t>=0&&r.indexOf(t)===e&&this.addIndicesForPlacedSymbol(this.text,t);})),e.verticalPlacedTextSymbolIndex>=0&&this.addIndicesForPlacedSymbol(this.text,e.verticalPlacedTextSymbolIndex),e.placedIconSymbolIndex>=0&&this.addIndicesForPlacedSymbol(this.icon,e.placedIconSymbolIndex),e.verticalPlacedIconSymbolIndex>=0&&this.addIndicesForPlacedSymbol(this.icon,e.verticalPlacedIconSymbolIndex);}this.text.indexBuffer&&this.text.indexBuffer.updateData(this.text.indexArray),this.icon.indexBuffer&&this.icon.indexBuffer.updateData(this.icon.indexArray);}}}Pi(Qf,"SymbolBucket",{omit:["layers","collisionBoxArray","features","compareText"]}),Qf.MAX_GLYPHS=65535,Qf.addDynamicAttributes=Hf;const td=new Zs({"symbol-placement":new $s(Gt.layout_symbol["symbol-placement"]),"symbol-spacing":new $s(Gt.layout_symbol["symbol-spacing"]),"symbol-avoid-edges":new $s(Gt.layout_symbol["symbol-avoid-edges"]),"symbol-sort-key":new Os(Gt.layout_symbol["symbol-sort-key"]),"symbol-z-order":new $s(Gt.layout_symbol["symbol-z-order"]),"icon-allow-overlap":new $s(Gt.layout_symbol["icon-allow-overlap"]),"icon-ignore-placement":new $s(Gt.layout_symbol["icon-ignore-placement"]),"icon-optional":new $s(Gt.layout_symbol["icon-optional"]),"icon-rotation-alignment":new $s(Gt.layout_symbol["icon-rotation-alignment"]),"icon-size":new Os(Gt.layout_symbol["icon-size"]),"icon-text-fit":new $s(Gt.layout_symbol["icon-text-fit"]),"icon-text-fit-padding":new $s(Gt.layout_symbol["icon-text-fit-padding"]),"icon-image":new Os(Gt.layout_symbol["icon-image"]),"icon-rotate":new Os(Gt.layout_symbol["icon-rotate"]),"icon-padding":new $s(Gt.layout_symbol["icon-padding"]),"icon-keep-upright":new $s(Gt.layout_symbol["icon-keep-upright"]),"icon-offset":new Os(Gt.layout_symbol["icon-offset"]),"icon-anchor":new Os(Gt.layout_symbol["icon-anchor"]),"icon-pitch-alignment":new $s(Gt.layout_symbol["icon-pitch-alignment"]),"text-pitch-alignment":new $s(Gt.layout_symbol["text-pitch-alignment"]),"text-rotation-alignment":new $s(Gt.layout_symbol["text-rotation-alignment"]),"text-field":new Os(Gt.layout_symbol["text-field"]),"text-font":new Os(Gt.layout_symbol["text-font"]),"text-size":new Os(Gt.layout_symbol["text-size"]),"text-max-width":new Os(Gt.layout_symbol["text-max-width"]),"text-line-height":new Os(Gt.layout_symbol["text-line-height"]),"text-letter-spacing":new Os(Gt.layout_symbol["text-letter-spacing"]),"text-justify":new Os(Gt.layout_symbol["text-justify"]),"text-radial-offset":new Os(Gt.layout_symbol["text-radial-offset"]),"text-variable-anchor":new $s(Gt.layout_symbol["text-variable-anchor"]),"text-anchor":new Os(Gt.layout_symbol["text-anchor"]),"text-max-angle":new $s(Gt.layout_symbol["text-max-angle"]),"text-writing-mode":new $s(Gt.layout_symbol["text-writing-mode"]),"text-rotate":new Os(Gt.layout_symbol["text-rotate"]),"text-padding":new $s(Gt.layout_symbol["text-padding"]),"text-keep-upright":new $s(Gt.layout_symbol["text-keep-upright"]),"text-transform":new Os(Gt.layout_symbol["text-transform"]),"text-offset":new Os(Gt.layout_symbol["text-offset"]),"text-allow-overlap":new $s(Gt.layout_symbol["text-allow-overlap"]),"text-ignore-placement":new $s(Gt.layout_symbol["text-ignore-placement"]),"text-optional":new $s(Gt.layout_symbol["text-optional"])});var ed={paint:new Zs({"icon-opacity":new Os(Gt.paint_symbol["icon-opacity"]),"icon-color":new Os(Gt.paint_symbol["icon-color"]),"icon-halo-color":new Os(Gt.paint_symbol["icon-halo-color"]),"icon-halo-width":new Os(Gt.paint_symbol["icon-halo-width"]),"icon-halo-blur":new Os(Gt.paint_symbol["icon-halo-blur"]),"icon-translate":new $s(Gt.paint_symbol["icon-translate"]),"icon-translate-anchor":new $s(Gt.paint_symbol["icon-translate-anchor"]),"text-opacity":new Os(Gt.paint_symbol["text-opacity"]),"text-color":new Os(Gt.paint_symbol["text-color"],{runtimeType:ne,getOverride:t=>t.textColor,hasOverride:t=>!!t.textColor}),"text-halo-color":new Os(Gt.paint_symbol["text-halo-color"]),"text-halo-width":new Os(Gt.paint_symbol["text-halo-width"]),"text-halo-blur":new Os(Gt.paint_symbol["text-halo-blur"]),"text-translate":new $s(Gt.paint_symbol["text-translate"]),"text-translate-anchor":new $s(Gt.paint_symbol["text-translate-anchor"])}),layout:td};class rd{constructor(t){this.type=t.property.overrides?t.property.overrides.runtimeType:Qt,this.defaultValue=t;}evaluate(t){if(t.formattedSection){const e=this.defaultValue.property.overrides;if(e&&e.hasOverride(t.formattedSection))return e.getOverride(t.formattedSection)}return t.feature&&t.featureState?this.defaultValue.evaluate(t.feature,t.featureState):this.defaultValue.property.specification.default}eachChild(t){this.defaultValue.isConstant()||t(this.defaultValue.value._styleExpression.expression);}outputDefined(){return !1}serialize(){return null}}Pi(rd,"FormatSectionOverride",{omit:["defaultValue"]});class nd extends xo{constructor(t){super(t,ed);}recalculate(t,e){super.recalculate(t,e),"auto"===this.layout.get("icon-rotation-alignment")&&(this.layout._values["icon-rotation-alignment"]="point"!==this.layout.get("symbol-placement")?"map":"viewport"),"auto"===this.layout.get("text-rotation-alignment")&&(this.layout._values["text-rotation-alignment"]="point"!==this.layout.get("symbol-placement")?"map":"viewport"),"auto"===this.layout.get("text-pitch-alignment")&&(this.layout._values["text-pitch-alignment"]=this.layout.get("text-rotation-alignment")),"auto"===this.layout.get("icon-pitch-alignment")&&(this.layout._values["icon-pitch-alignment"]=this.layout.get("icon-rotation-alignment"));const r=this.layout.get("text-writing-mode");if(r){const t=[];for(const e of r)t.indexOf(e)<0&&t.push(e);this.layout._values["text-writing-mode"]=t;}else this.layout._values["text-writing-mode"]="point"===this.layout.get("symbol-placement")?["horizontal"]:["horizontal","vertical"];this._setPaintOverrides();}getValueAndResolveTokens(t,e,r,n){const i=this.layout.get(t).evaluate(e,{},r,n),s=this._unevaluatedLayout._values[t];return s.isDataDriven()||Fn(s.value)||!i?i:function(t,e){return e.replace(/{([^{}]+)}/g,((e,r)=>r in t?String(t[r]):""))}(e.properties,i)}createBucket(t){return new Qf(t)}queryRadius(){return 0}queryIntersectsFeature(){return !1}_setPaintOverrides(){for(const t of ed.paint.overridableProperties){if(!nd.hasPaintOverride(this.layout,t))continue;const e=this.paint.get(t),r=new rd(e),n=new Vn(r,e.property.specification);let i=null;i="constant"===e.value.kind||"source"===e.value.kind?new Rn("source",n):new Un("composite",n,e.value.zoomStops,e.value._interpolationType),this.paint._values[t]=new Us(e.property,i,e.parameters);}}_handleOverridablePaintPropertyUpdate(t,e,r){return !(!this.layout||e.isDataDriven()||r.isDataDriven())&&nd.hasPaintOverride(this.layout,t)}static hasPaintOverride(t,e){const r=t.get("text-field"),n=ed.paint.properties[e];let i=!1;const s=t=>{for(const e of t)if(n.overrides&&n.overrides.hasOverride(e))return void(i=!0)};if("constant"===r.value.kind&&r.value.value instanceof _e)s(r.value.value.sections);else if("source"===r.value.kind){const t=e=>{i||(e instanceof ze&&ke(e.value)===oe?s(e.value.sections):e instanceof Pe?s(e.sections):e.eachChild(t));},e=r.value;e._styleExpression&&t(e._styleExpression.expression);}return i}getProgramConfiguration(t){return new uo(this,t)}}var id={paint:new Zs({"background-color":new $s(Gt.paint_background["background-color"]),"background-pattern":new Ns(Gt.paint_background["background-pattern"]),"background-opacity":new $s(Gt.paint_background["background-opacity"])})},sd={paint:new Zs({"raster-opacity":new $s(Gt.paint_raster["raster-opacity"]),"raster-hue-rotate":new $s(Gt.paint_raster["raster-hue-rotate"]),"raster-brightness-min":new $s(Gt.paint_raster["raster-brightness-min"]),"raster-brightness-max":new $s(Gt.paint_raster["raster-brightness-max"]),"raster-saturation":new $s(Gt.paint_raster["raster-saturation"]),"raster-contrast":new $s(Gt.paint_raster["raster-contrast"]),"raster-resampling":new $s(Gt.paint_raster["raster-resampling"]),"raster-fade-duration":new $s(Gt.paint_raster["raster-fade-duration"])})};class ad extends xo{constructor(t){super(t,{}),this.implementation=t;}is3D(){return "3d"===this.implementation.renderingMode}hasOffscreenPass(){return void 0!==this.implementation.prerender}recalculate(){}updateTransitions(){}hasTransition(){return !1}serialize(){}onAdd(t){this.implementation.onAdd&&this.implementation.onAdd(t,t.painter.context.gl);}onRemove(t){this.implementation.onRemove&&this.implementation.onRemove(t,t.painter.context.gl);}}var od={paint:new Zs({"sky-type":new $s(Gt.paint_sky["sky-type"]),"sky-atmosphere-sun":new $s(Gt.paint_sky["sky-atmosphere-sun"]),"sky-atmosphere-sun-intensity":new $s(Gt.paint_sky["sky-atmosphere-sun-intensity"]),"sky-gradient-center":new $s(Gt.paint_sky["sky-gradient-center"]),"sky-gradient-radius":new $s(Gt.paint_sky["sky-gradient-radius"]),"sky-gradient":new Gs(Gt.paint_sky["sky-gradient"]),"sky-atmosphere-halo-color":new $s(Gt.paint_sky["sky-atmosphere-halo-color"]),"sky-atmosphere-color":new $s(Gt.paint_sky["sky-atmosphere-color"]),"sky-opacity":new $s(Gt.paint_sky["sky-opacity"])})};function ld(t,e,r){const n=[0,0,1],i=Hl([]);return Wl(i,i,r?-l(t)+Math.PI:l(t)),Yl(i,i,-l(e)),$l(n,n,i),Ll(n,n)}const ud={circle:class extends xo{constructor(t){super(t,pl);}createBucket(t){return new Ko(t)}queryRadius(t){const e=t;return ol("circle-radius",this,e)+ol("circle-stroke-width",this,e)+ll(this.paint.get("circle-translate"))}queryIntersectsFeature(t,e,r,n,i,s,a,o){const l=cl(this.paint.get("circle-translate"),this.paint.get("circle-translate-anchor"),s.angle,t.pixelToTileUnitsFactor),u=this.paint.get("circle-radius").evaluate(e,r)+this.paint.get("circle-stroke-width").evaluate(e,r);return ru(t,n,s,a,o,"map"===this.paint.get("circle-pitch-alignment"),"map"===this.paint.get("circle-pitch-scale"),l,u)}getProgramIds(){return ["circle"]}getProgramConfiguration(t){return new uo(this,t)}},heatmap:class extends xo{createBucket(t){return new ou(t)}constructor(t){super(t,fu),this._updateColorRamp();}_handleSpecialPaintPropertyUpdate(t){"heatmap-color"===t&&this._updateColorRamp();}_updateColorRamp(){this.colorRamp=du({expression:this._transitionablePaint._values["heatmap-color"].value.expression,evaluationKey:"heatmapDensity",image:this.colorRamp}),this.colorRampTexture=null;}resize(){this.heatmapFbo&&(this.heatmapFbo.destroy(),this.heatmapFbo=null);}queryRadius(t){return ol("heatmap-radius",this,t)}queryIntersectsFeature(t,e,r,n,s,a,o,l){const u=this.paint.get("heatmap-radius").evaluate(e,r);return ru(t,n,a,o,l,!0,!0,new i(0,0),u)}hasOffscreenPass(){return 0!==this.paint.get("heatmap-opacity")&&"none"!==this.visibility}getProgramIds(){return ["heatmap","heatmapTexture"]}getProgramConfiguration(t){return new uo(this,t)}},hillshade:class extends xo{constructor(t){super(t,yu);}hasOffscreenPass(){return 0!==this.paint.get("hillshade-exaggeration")&&"none"!==this.visibility}getProgramIds(){return ["hillshade","hillshadePrepare"]}},fill:class extends xo{constructor(t){super(t,rc);}getProgramIds(){const t=this.paint.get("fill-pattern"),e=t&&t.constantOr(1),r=[e?"fillPattern":"fill"];return this.paint.get("fill-antialias")&&r.push(e&&!this.getPaintProperty("fill-outline-color")?"fillOutlinePattern":"fillOutline"),r}getProgramConfiguration(t){return new uo(this,t)}recalculate(t,e){super.recalculate(t,e);const r=this.paint._values["fill-outline-color"];"constant"===r.value.kind&&void 0===r.value.value&&(this.paint._values["fill-outline-color"]=this.paint._values["fill-color"]);}createBucket(t){return new tc(t)}queryRadius(){return ll(this.paint.get("fill-translate"))}queryIntersectsFeature(t,e,r,n,i,s){return !t.queryGeometry.isAboveHorizon&&Wo(ul(t.tilespaceGeometry,this.paint.get("fill-translate"),this.paint.get("fill-translate-anchor"),s.angle,t.pixelToTileUnitsFactor),n)}isTileClipped(){return !0}},"fill-extrusion":class extends xo{constructor(t){super(t,Cc);}createBucket(t){return new wc(t)}queryRadius(){return ll(this.paint.get("fill-extrusion-translate"))}is3D(){return !0}getProgramIds(){return [this.paint.get("fill-extrusion-pattern").constantOr(1)?"fillExtrusionPattern":"fillExtrusion"]}getProgramConfiguration(t){return new uo(this,t)}queryIntersectsFeature(t,e,r,n,s,a,o,l,u){const c=cl(this.paint.get("fill-extrusion-translate"),this.paint.get("fill-extrusion-translate-anchor"),a.angle,t.pixelToTileUnitsFactor),h=this.paint.get("fill-extrusion-height").evaluate(e,r),p=this.paint.get("fill-extrusion-base").evaluate(e,r),f=[0,0],d=l&&a.elevation,y=a.elevation?a.elevation.exaggeration():1,m=t.tile.getBucket(this);if(d&&m instanceof wc){const t=m.centroidVertexArray,e=u+1;if(e<t.length){const r=t.get(e);f[0]=r.a_centroid_pos0,f[1]=r.a_centroid_pos1;}}if(0===f[0]&&1===f[1])return !1;"globe"===a.projection.name&&(n=Bc([n],[new i(0,0),new i(wo,wo)],t.tileID.canonical).map((t=>t.polygon)).flat());const g=function(t,e,r,n,s,a,o,l,u,c,h){return "globe"===t.projection.name?function(t,e,r,n,i,s,a,o,l,u,c){const h=[],p=[],f=t.projection.upVectorScale(c,t.center.lat,t.worldSize).metersToTile,d=[0,0,0,1],y=[0,0,0,1],m=(t,e,r,n)=>{t[0]=e,t[1]=r,t[2]=n,t[3]=1;},g=Tc();r>0&&(r+=g),n+=g;for(const g of e){const e=[],x=[];for(const h of g){const p=h.x+i.x,g=h.y+i.y,v=t.projection.projectTilePoint(p,g,c),b=t.projection.upVector(c,h.x,h.y);let _=r,w=n;if(a){const t=$c(p,g,r,n,a,o,l,u);_+=t.base,w+=t.top;}0!==r?m(d,v.x+b[0]*f*_,v.y+b[1]*f*_,v.z+b[2]*f*_):m(d,v.x,v.y,v.z),m(y,v.x+b[0]*f*w,v.y+b[1]*f*w,v.z+b[2]*f*w),jl(d,d,s),jl(y,y,s),e.push(jc(d)),x.push(jc(y));}h.push(e),p.push(x);}return [h,p]}(t,e,r,n,s,a,o,l,u,c,h):o?function(t,e,r,n,i,s,a,o,l){const u=[],c=[],h=[0,0,0,1];for(const p of t){const t=[],f=[];for(const u of p){const c=u.x+n.x,p=u.y+n.y,d=$c(c,p,e,r,s,a,o,l);h[0]=c,h[1]=p,h[2]=d.base,h[3]=1,Xl(h,h,i),h[3]=Math.max(h[3],1e-5);const y=jc([h[0]/h[3],h[1]/h[3],h[2]/h[3]]);h[0]=c,h[1]=p,h[2]=d.top,h[3]=1,Xl(h,h,i),h[3]=Math.max(h[3],1e-5);const m=jc([h[0]/h[3],h[1]/h[3],h[2]/h[3]]);t.push(y),f.push(m);}u.push(t),c.push(f);}return [u,c]}(e,r,n,s,a,o,l,u,c):function(t,e,r,n,s){const a=[],o=[],l=s[8]*e,u=s[9]*e,c=s[10]*e,h=s[11]*e,p=s[8]*r,f=s[9]*r,d=s[10]*r,y=s[11]*r;for(const e of t){const t=[],r=[];for(const a of e){const e=a.x+n.x,o=a.y+n.y,m=s[0]*e+s[4]*o+s[12],g=s[1]*e+s[5]*o+s[13],x=s[2]*e+s[6]*o+s[14],v=s[3]*e+s[7]*o+s[15],b=m+l,_=g+u,w=x+c,A=Math.max(v+h,1e-5),S=m+p,k=g+f,I=x+d,M=Math.max(v+y,1e-5),z=new i(b/A,_/A);z.z=w/A,t.push(z);const T=new i(S/M,k/M);T.z=I/M,r.push(T);}a.push(t),o.push(r);}return [a,o]}(e,r,n,s,a)}(a,n,p,h,c,o,d?l:null,f,y,a.center.lat,t.tileID.canonical),x=t.queryGeometry;return function(t,e,r){let n=1/0;Wo(r,e)&&(n=Uc(r,e[0]));for(let i=0;i<e.length;i++){const s=e[i],a=t[i];for(let t=0;t<s.length-1;t++){const e=s[t],i=[e,s[t+1],a[t+1],a[t],e];Ho(r,i)&&(n=Math.min(n,Uc(r,i)));}}return n!==1/0&&n}(g[0],g[1],x.isPointQuery()?x.screenBounds:x.screenGeometry)}},line:class extends xo{constructor(t){super(t,Yc),this.gradientVersion=0;}_handleSpecialPaintPropertyUpdate(t){if("line-gradient"===t){const t=this._transitionablePaint._values["line-gradient"].value.expression;this.stepInterpolant=t._styleExpression&&t._styleExpression.expression instanceof gr,this.gradientVersion=(this.gradientVersion+1)%Number.MAX_SAFE_INTEGER;}}gradientExpression(){return this._transitionablePaint._values["line-gradient"].value.expression}recalculate(t,e){super.recalculate(t,e),this.paint._values["line-floorwidth"]=Wc.possiblyEvaluate(this._transitioningPaint._values["line-width"].value,t);}createBucket(t){return new Kc(t)}getProgramIds(){return [this.paint.get("line-pattern").constantOr(1)?"linePattern":"line"]}getProgramConfiguration(t){return new uo(this,t)}queryRadius(t){const e=t,r=Jc(ol("line-width",this,e),ol("line-gap-width",this,e)),n=ol("line-offset",this,e);return r/2+Math.abs(n)+ll(this.paint.get("line-translate"))}queryIntersectsFeature(t,e,r,n,s,a){if(t.queryGeometry.isAboveHorizon)return !1;const o=ul(t.tilespaceGeometry,this.paint.get("line-translate"),this.paint.get("line-translate-anchor"),a.angle,t.pixelToTileUnitsFactor),l=t.pixelToTileUnitsFactor/2*Jc(this.paint.get("line-width").evaluate(e,r),this.paint.get("line-gap-width").evaluate(e,r)),u=this.paint.get("line-offset").evaluate(e,r);return u&&(n=function(t,e){const r=[],n=new i(0,0);for(let i=0;i<t.length;i++){const s=t[i],a=[];for(let t=0;t<s.length;t++){const r=s[t-1],i=s[t],o=s[t+1],l=0===t?n:i.sub(r)._unit()._perp(),u=t===s.length-1?n:o.sub(i)._unit()._perp(),c=l._add(u)._unit();c._mult(1/(c.x*u.x+c.y*u.y)),a.push(c._mult(e)._add(i));}r.push(a);}return r}(n,u*t.pixelToTileUnitsFactor)),function(t,e,r){for(let n=0;n<e.length;n++){const i=e[n];if(t.length>=3)for(let e=0;e<i.length;e++)if(il(t,i[e]))return !0;if(Jo(t,i,r))return !0}return !1}(o,n,l)}isTileClipped(){return !0}},symbol:nd,background:class extends xo{constructor(t){super(t,id);}getProgramIds(){return [this.paint.get("background-pattern")?"backgroundPattern":"background"]}},raster:class extends xo{constructor(t){super(t,sd);}getProgramIds(){return ["raster"]}},sky:class extends xo{constructor(t){super(t,od),this._updateColorRamp();}_handleSpecialPaintPropertyUpdate(t){"sky-gradient"===t?this._updateColorRamp():"sky-atmosphere-sun"!==t&&"sky-atmosphere-halo-color"!==t&&"sky-atmosphere-color"!==t&&"sky-atmosphere-sun-intensity"!==t||(this._skyboxInvalidated=!0);}_updateColorRamp(){this.colorRamp=du({expression:this._transitionablePaint._values["sky-gradient"].value.expression,evaluationKey:"skyRadialProgress"}),this.colorRampTexture&&(this.colorRampTexture.destroy(),this.colorRampTexture=null);}needsSkyboxCapture(t){if(this._skyboxInvalidated||!this.skyboxTexture||!this.skyboxGeometry)return !0;if(!this.paint.get("sky-atmosphere-sun")){const e=t.style.light.properties.get("position");return this._lightPosition.azimuthal!==e.azimuthal||this._lightPosition.polar!==e.polar}return !1}getCenter(t,e){if("atmosphere"===this.paint.get("sky-type")){const r=this.paint.get("sky-atmosphere-sun"),n=!r,i=t.style.light,s=i.properties.get("position");return n&&"viewport"===i.properties.get("anchor")&&E("The sun direction is attached to a light with viewport anchor, lighting may behave unexpectedly."),n?ld(s.azimuthal,90-s.polar,e):ld(r[0],90-r[1],e)}const r=this.paint.get("sky-gradient-center");return ld(r[0],90-r[1],e)}is3D(){return !1}isSky(){return !0}markSkyboxValid(t){this._skyboxInvalidated=!1,this._lightPosition=t.style.light.properties.get("position");}hasOffscreenPass(){return !0}getProgramIds(){const t=this.paint.get("sky-type");return "atmosphere"===t?["skyboxCapture","skybox"]:"gradient"===t?["skyboxGradient"]:null}}};class cd{constructor(t,e,r,n){this.context=t,this.format=r,this.texture=t.gl.createTexture(),this.update(e,n);}update(t,r,n){const{width:i,height:s}=t,{context:a}=this,{gl:o}=a,{HTMLImageElement:l,HTMLCanvasElement:u,HTMLVideoElement:c,ImageData:h,ImageBitmap:p}=e;if(o.bindTexture(o.TEXTURE_2D,this.texture),a.pixelStoreUnpackFlipY.set(!1),a.pixelStoreUnpack.set(1),a.pixelStoreUnpackPremultiplyAlpha.set(this.format===o.RGBA&&(!r||!1!==r.premultiply)),n||this.size&&this.size[0]===i&&this.size[1]===s){const{x:e,y:r}=n||{x:0,y:0};t instanceof l||t instanceof u||t instanceof c||t instanceof h||p&&t instanceof p?o.texSubImage2D(o.TEXTURE_2D,0,e,r,o.RGBA,o.UNSIGNED_BYTE,t):o.texSubImage2D(o.TEXTURE_2D,0,e,r,i,s,o.RGBA,o.UNSIGNED_BYTE,t.data);}else this.size=[i,s],t instanceof l||t instanceof u||t instanceof c||t instanceof h||p&&t instanceof p?o.texImage2D(o.TEXTURE_2D,0,this.format,this.format,o.UNSIGNED_BYTE,t):o.texImage2D(o.TEXTURE_2D,0,this.format,i,s,0,this.format,o.UNSIGNED_BYTE,t.data);this.useMipmap=Boolean(r&&r.useMipmap&&this.isSizePowerOfTwo()),this.useMipmap&&o.generateMipmap(o.TEXTURE_2D);}bind(t,e){const{context:r}=this,{gl:n}=r;n.bindTexture(n.TEXTURE_2D,this.texture),t!==this.filter&&(n.texParameteri(n.TEXTURE_2D,n.TEXTURE_MAG_FILTER,t),n.texParameteri(n.TEXTURE_2D,n.TEXTURE_MIN_FILTER,this.useMipmap?t===n.NEAREST?n.NEAREST_MIPMAP_NEAREST:n.LINEAR_MIPMAP_NEAREST:t),this.filter=t),e!==this.wrap&&(n.texParameteri(n.TEXTURE_2D,n.TEXTURE_WRAP_S,e),n.texParameteri(n.TEXTURE_2D,n.TEXTURE_WRAP_T,e),this.wrap=e);}isSizePowerOfTwo(){return this.size[0]===this.size[1]&&Math.log(this.size[0])/Math.LN2%1==0}destroy(){const{gl:t}=this.context;t.deleteTexture(this.texture),this.texture=null;}}class hd{constructor(t,e){this.width=t,this.height=e,this.nextRow=0,this.image=new hu({width:t,height:e}),this.positions={},this.uploaded=!1;}getDash(t,e){const r=this.getKey(t,e);return this.positions[r]}trim(){const t=this.width,e=this.height=A(this.nextRow);this.image.resize({width:t,height:e});}getKey(t,e){return t.join(",")+e}getDashRanges(t,e,r){const n=[];let i=t.length%2==1?-t[t.length-1]*r:0,s=t[0]*r,a=!0;n.push({left:i,right:s,isDash:a,zeroLength:0===t[0]});let o=t[0];for(let e=1;e<t.length;e++){a=!a;const l=t[e];i=o*r,o+=l,s=o*r,n.push({left:i,right:s,isDash:a,zeroLength:0===l});}return n}addRoundDash(t,e,r){const n=e/2;for(let e=-r;e<=r;e++){const i=this.width*(this.nextRow+r+e);let s=0,a=t[s];for(let o=0;o<this.width;o++){o/a.right>1&&(a=t[++s]);const l=Math.abs(o-a.left),u=Math.abs(o-a.right),c=Math.min(l,u);let h;const p=e/r*(n+1);if(a.isDash){const t=n-Math.abs(p);h=Math.sqrt(c*c+t*t);}else h=n-Math.sqrt(c*c+p*p);this.image.data[i+o]=Math.max(0,Math.min(255,h+128));}}}addRegularDash(t,e){for(let e=t.length-1;e>=0;--e){const r=t[e],n=t[e+1];r.zeroLength?t.splice(e,1):n&&n.isDash===r.isDash&&(n.left=r.left,t.splice(e,1));}const r=t[0],n=t[t.length-1];r.isDash===n.isDash&&(r.left=n.left-this.width,n.right=r.right+this.width);const i=this.width*this.nextRow;let s=0,a=t[s];for(let r=0;r<this.width;r++){r/a.right>1&&(a=t[++s]);const n=Math.abs(r-a.left),o=Math.abs(r-a.right),l=Math.min(n,o);this.image.data[i+r]=Math.max(0,Math.min(255,(a.isDash?l:-l)+e+128));}}addDash(t,e){const r=this.getKey(t,e);if(this.positions[r])return this.positions[r];const n="round"===e,i=n?7:0,s=2*i+1;if(this.nextRow+s>this.height)return E("LineAtlas out of space"),null;0===t.length&&t.push(1);let a=0;for(let e=0;e<t.length;e++)t[e]<0&&(E("Negative value is found in line dasharray, replacing values with 0"),t[e]=0),a+=t[e];if(0!==a){const r=this.width/a,s=this.getDashRanges(t,this.width,r);n?this.addRoundDash(s,r,i):this.addRegularDash(s,"square"===e?.5*r:0);}const o=this.nextRow+i;this.nextRow+=s;const l={tl:[o,i],br:[a,0]};return this.positions[r]=l,l}}Pi(hd,"LineAtlas");class pd{constructor(t){this._callback=t,this._triggered=!1,"undefined"!=typeof MessageChannel&&(this._channel=new MessageChannel,this._channel.port2.onmessage=()=>{this._triggered=!1,this._callback();});}trigger(){this._triggered||(this._triggered=!0,this._channel?this._channel.port1.postMessage(!0):setTimeout((()=>{this._triggered=!1,this._callback();}),0));}remove(){this._channel=void 0,this._callback=()=>{};}}class fd{constructor(){this.tasks={},this.taskQueue=[],k(["process"],this),this.invoker=new pd(this.process),this.nextId=0;}add(t,e){const r=this.nextId++,n=function({type:t,isSymbolTile:e,zoom:r}){return r=r||0,"message"===t?0:"maybePrepare"!==t||e?"parseTile"!==t||e?"parseTile"===t&&e?300-r:"maybePrepare"===t&&e?400-r:500:200-r:100-r}(e);if(0===n){D();try{t();}finally{}return {cancel:()=>{}}}return this.tasks[r]={fn:t,metadata:e,priority:n,id:r},this.taskQueue.push(r),this.invoker.trigger(),{cancel:()=>{delete this.tasks[r];}}}process(){D();try{if(this.taskQueue=this.taskQueue.filter((t=>!!this.tasks[t])),!this.taskQueue.length)return;const t=this.pick();if(null===t)return;const e=this.tasks[t];if(delete this.tasks[t],this.taskQueue.length&&this.invoker.trigger(),!e)return;e.fn();}finally{}}pick(){let t=null,e=1/0;for(let r=0;r<this.taskQueue.length;r++){const n=this.tasks[this.taskQueue[r]];n.priority<e&&(e=n.priority,t=r);}if(null===t)return null;const r=this.taskQueue[t];return this.taskQueue.splice(t,1),r}remove(){this.invoker.remove();}}class dd{constructor(t){this._stringToNumber={},this._numberToString=[];for(let e=0;e<t.length;e++){const r=t[e];this._stringToNumber[r]=e,this._numberToString[e]=r;}}encode(t){return this._stringToNumber[t]}decode(t){return this._numberToString[t]}}const yd=["tile","layer","source","sourceLayer","state"];class md{constructor(t,e,r,n,i){this.type="Feature",this._vectorTileFeature=t,this._z=e,this._x=r,this._y=n,this.properties=t.properties,this.id=i;}get geometry(){return void 0===this._geometry&&(this._geometry=this._vectorTileFeature.toGeoJSON(this._x,this._y,this._z).geometry),this._geometry}set geometry(t){this._geometry=t;}toJSON(){const t={type:"Feature",geometry:this.geometry,properties:this.properties};void 0!==this.id&&(t.id=this.id);for(const e of yd)void 0!==this[e]&&(t[e]=this[e]);return t}}const gd=32,xd=33,vd=new Uint16Array(8184);for(let t=0;t<2046;t++){let e=t+2,r=0,n=0,i=0,s=0,a=0,o=0;for(1&e?i=s=a=gd:r=n=o=gd;(e>>=1)>1;){const t=r+i>>1,l=n+s>>1;1&e?(i=r,s=n,r=a,n=o):(r=i,n=s,i=a,s=o),a=t,o=l;}const l=4*t;vd[l+0]=r,vd[l+1]=n,vd[l+2]=i,vd[l+3]=s;}const bd=new Uint16Array(2178),_d=new Uint8Array(1089),wd=new Uint16Array(1089);function Ad(t){return 0===t?-.03125:32===t?.03125:0}var Sd=Ws([{name:"a_pos",type:"Int16",components:2},{name:"a_texture_pos",type:"Int16",components:2}]);const kd={type:2,extent:wo,loadGeometry:()=>[[new i(0,0),new i(8193,0),new i(8193,8193),new i(0,8193),new i(0,0)]]};class Id{constructor(t,e,r,n,i){this.tileID=t,this.uid=_(),this.uses=0,this.tileSize=e,this.tileZoom=r,this.buckets={},this.expirationTime=null,this.queryPadding=0,this.hasSymbolBuckets=!1,this.hasRTLText=!1,this.dependencies={},this.isRaster=i,this.expiredRequestCount=0,this.state="loading",n&&n.transform&&(this.projection=n.transform.projection);}registerFadeDuration(t){const e=t+this.timeAdded;e<X.now()||this.fadeEndTime&&e<this.fadeEndTime||(this.fadeEndTime=e);}wasRequested(){return "errored"===this.state||"loaded"===this.state||"reloading"===this.state}get tileTransform(){return this._tileTransform||(this._tileTransform=Af(this.tileID.canonical,this.projection)),this._tileTransform}loadVectorData(t,e,r){if(this.unloadVectorData(),this.state="loaded",t){t.featureIndex&&(this.latestFeatureIndex=t.featureIndex,t.rawTileData?(this.latestRawTileData=t.rawTileData,this.latestFeatureIndex.rawTileData=t.rawTileData):this.latestRawTileData&&(this.latestFeatureIndex.rawTileData=this.latestRawTileData)),this.collisionBoxArray=t.collisionBoxArray,this.buckets=function(t,e){const r={};if(!e)return r;for(const n of t){const t=n.layerIds.map((t=>e.getLayer(t))).filter(Boolean);if(0!==t.length){n.layers=t,n.stateDependentLayerIds&&(n.stateDependentLayers=n.stateDependentLayerIds.map((e=>t.filter((t=>t.id===e))[0])));for(const e of t)r[e.id]=n;}}return r}(t.buckets,e.style),this.hasSymbolBuckets=!1;for(const t in this.buckets){const e=this.buckets[t];if(e instanceof Qf){if(this.hasSymbolBuckets=!0,!r)break;e.justReloaded=!0;}}if(this.hasRTLText=!1,this.hasSymbolBuckets)for(const t in this.buckets){const e=this.buckets[t];if(e instanceof Qf&&e.hasRTLText){this.hasRTLText=!0,Es.isLoading()||Es.isLoaded()||"deferred"!==Ts()||Bs();break}}this.queryPadding=0;for(const t in this.buckets){const r=this.buckets[t];this.queryPadding=Math.max(this.queryPadding,e.style.getLayer(t).queryRadius(r));}t.imageAtlas&&(this.imageAtlas=t.imageAtlas),t.glyphAtlasImage&&(this.glyphAtlasImage=t.glyphAtlasImage),t.lineAtlas&&(this.lineAtlas=t.lineAtlas);}else this.collisionBoxArray=new Ma;}unloadVectorData(){if(this.hasData()){for(const t in this.buckets)this.buckets[t].destroy();this.buckets={},this.imageAtlas&&(this.imageAtlas=null),this.lineAtlas&&(this.lineAtlas=null),this.imageAtlasTexture&&this.imageAtlasTexture.destroy(),this.glyphAtlasTexture&&this.glyphAtlasTexture.destroy(),this.lineAtlasTexture&&this.lineAtlasTexture.destroy(),this._tileBoundsBuffer&&(this._tileBoundsBuffer.destroy(),this._tileBoundsIndexBuffer.destroy(),this._tileBoundsSegments.destroy(),this._tileBoundsBuffer=null),this._tileDebugBuffer&&(this._tileDebugBuffer.destroy(),this._tileDebugSegments.destroy(),this._tileDebugBuffer=null),this._tileDebugIndexBuffer&&(this._tileDebugIndexBuffer.destroy(),this._tileDebugIndexBuffer=null),this._globeTileDebugBorderBuffer&&(this._globeTileDebugBorderBuffer.destroy(),this._globeTileDebugBorderBuffer=null),this._tileDebugTextBuffer&&(this._tileDebugTextBuffer.destroy(),this._tileDebugTextSegments.destroy(),this._tileDebugTextIndexBuffer.destroy(),this._tileDebugTextBuffer=null),this._globeTileDebugTextBuffer&&(this._globeTileDebugTextBuffer.destroy(),this._globeTileDebugTextBuffer=null),this.latestFeatureIndex=null,this.state="unloaded";}}getBucket(t){return this.buckets[t.id]}upload(t){for(const e in this.buckets){const r=this.buckets[e];r.uploadPending()&&r.upload(t);}const e=t.gl;this.imageAtlas&&!this.imageAtlas.uploaded&&(this.imageAtlasTexture=new cd(t,this.imageAtlas.image,e.RGBA),this.imageAtlas.uploaded=!0),this.glyphAtlasImage&&(this.glyphAtlasTexture=new cd(t,this.glyphAtlasImage,e.ALPHA),this.glyphAtlasImage=null),this.lineAtlas&&!this.lineAtlas.uploaded&&(this.lineAtlasTexture=new cd(t,this.lineAtlas.image,e.ALPHA),this.lineAtlas.uploaded=!0);}prepare(t){this.imageAtlas&&this.imageAtlas.patchUpdatedImages(t,this.imageAtlasTexture);}queryRenderedFeatures(t,e,r,n,i,s,a,o){return this.latestFeatureIndex&&this.latestFeatureIndex.rawTileData?this.latestFeatureIndex.query({tileResult:n,pixelPosMatrix:a,transform:s,params:i,tileTransform:this.tileTransform},t,e,r):{}}querySourceFeatures(t,e){const r=this.latestFeatureIndex;if(!r||!r.rawTileData)return;const n=r.loadVTLayers(),i=e?e.sourceLayer:"",s=n._geojsonTileLayer||n[i];if(!s)return;const a=Jn(e&&e.filter),{z:o,x:l,y:u}=this.tileID.canonical,c={z:o,x:l,y:u};for(let e=0;e<s.length;e++){const n=s.feature(e);if(a.needGeometry){const t=Go(n,!0);if(!a.filter(new Cs(this.tileID.overscaledZ),t,this.tileID.canonical))continue}else if(!a.filter(new Cs(this.tileID.overscaledZ),n))continue;const h=r.getId(n,i),p=new md(n,o,l,u,h);p.tile=c,t.push(p);}}hasData(){return "loaded"===this.state||"reloading"===this.state||"expired"===this.state}patternsLoaded(){return !!this.imageAtlas&&!!Object.keys(this.imageAtlas.patternPositions).length}setExpiryData(t){const e=this.expirationTime;if(t.cacheControl){const e=V(t.cacheControl);e["max-age"]&&(this.expirationTime=Date.now()+1e3*e["max-age"]);}else t.expires&&(this.expirationTime=new Date(t.expires).getTime());if(this.expirationTime){const t=Date.now();let r=!1;if(this.expirationTime>t)r=!1;else if(e)if(this.expirationTime<e)r=!0;else {const n=this.expirationTime-e;n?this.expirationTime=t+Math.max(n,3e4):r=!0;}else r=!0;r?(this.expiredRequestCount++,this.state="expired"):this.expiredRequestCount=0;}}getExpiryTimeout(){if(this.expirationTime)return this.expiredRequestCount?1e3*(1<<Math.min(this.expiredRequestCount-1,31)):Math.min(this.expirationTime-(new Date).getTime(),Math.pow(2,31)-1)}setFeatureState(t,e){if(!this.latestFeatureIndex||!this.latestFeatureIndex.rawTileData||0===Object.keys(t).length||!e)return;const r=this.latestFeatureIndex.loadVTLayers(),n=e.style.listImages();for(const i in this.buckets){if(!e.style.hasLayer(i))continue;const s=this.buckets[i],a=s.layers[0].sourceLayer||"_geojsonTileLayer",o=r[a],l=t[a];if(!o||!l||0===Object.keys(l).length)continue;if(s.update(l,o,n,this.imageAtlas&&this.imageAtlas.patternPositions||{}),s instanceof Kc||s instanceof tc){const t=e.style._getSourceCache(s.layers[0].source);e._terrain&&e._terrain.enabled&&t&&s.programConfigurations.needsUpload&&e._terrain._clearRenderCacheForTile(t.id,this.tileID);}const u=e&&e.style&&e.style.getLayer(i);u&&(this.queryPadding=Math.max(this.queryPadding,u.queryRadius(s)));}}holdingForFade(){return void 0!==this.symbolFadeHoldUntil}symbolFadeFinished(){return !this.symbolFadeHoldUntil||this.symbolFadeHoldUntil<X.now()}clearFadeHold(){this.symbolFadeHoldUntil=void 0;}setHoldDuration(t){this.symbolFadeHoldUntil=X.now()+t;}setTexture(t,e){const r=e.context,n=r.gl;this.texture=e.getTileTexture(t.width),this.texture?this.texture.update(t,{useMipmap:!0}):(this.texture=new cd(r,t,n.RGBA,{useMipmap:!0}),this.texture.bind(n.LINEAR,n.CLAMP_TO_EDGE),r.extTextureFilterAnisotropic&&n.texParameterf(n.TEXTURE_2D,r.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT,r.extTextureFilterAnisotropicMax));}setDependencies(t,e){const r={};for(const t of e)r[t]=!0;this.dependencies[t]=r;}hasDependency(t,e){for(const r of t){const t=this.dependencies[r];if(t)for(const r of e)if(t[r])return !0}return !1}clearQueryDebugViz(){}_makeDebugTileBoundsBuffers(t,e){if(!e||"mercator"===e.name||this._tileDebugBuffer)return;const r=No(kd,this.tileID.canonical,this.tileTransform)[0],n=new Qs,i=new wa;for(let t=0;t<r.length;t++){const{x:e,y:s}=r[t];n.emplaceBack(e,s),i.emplaceBack(t);}i.emplaceBack(0),this._tileDebugIndexBuffer=t.createIndexBuffer(i),this._tileDebugBuffer=t.createVertexBuffer(n,Zp.members),this._tileDebugSegments=_o.simpleSegment(0,0,n.length,i.length);}_makeTileBoundsBuffers(t,e){if(this._tileBoundsBuffer||!e||"mercator"===e.name)return;const r=No(kd,this.tileID.canonical,this.tileTransform)[0];let n,i;if(this.isRaster){const t=function(t,e){const r=Af(t,e),n=Math.pow(2,t.z);for(let i=0;i<xd;i++)for(let s=0;s<xd;s++){const a=Eo((t.x+(s+Ad(s))/gd)/n),o=Co((t.y+(i+Ad(i))/gd)/n),l=e.project(a,o),u=i*xd+s;bd[2*u+0]=Math.round((l.x*r.scale-r.x)*wo),bd[2*u+1]=Math.round((l.y*r.scale-r.y)*wo);}_d.fill(0),wd.fill(0);for(let t=2045;t>=0;t--){const e=4*t,r=vd[e+0],n=vd[e+1],i=vd[e+2],s=vd[e+3],a=r+i>>1,o=n+s>>1,l=a+o-n,u=o+r-a,c=n*xd+r,h=s*xd+i,p=o*xd+a,f=Math.hypot((bd[2*c+0]+bd[2*h+0])/2-bd[2*p+0],(bd[2*c+1]+bd[2*h+1])/2-bd[2*p+1])>=16;if(_d[p]=_d[p]||(f?1:0),t<1022){const t=(n+u>>1)*xd+(r+l>>1),e=(s+u>>1)*xd+(i+l>>1);_d[p]=_d[p]||_d[t]||_d[e];}}const i=new ea,s=new ya;let a=0;function o(t,e){const r=e*xd+t;return 0===wd[r]&&(i.emplaceBack(bd[2*r+0],bd[2*r+1],t*wo/gd,e*wo/gd),wd[r]=++a),wd[r]-1}function l(t,e,r,n,i,a){const u=t+r>>1,c=e+n>>1;if(Math.abs(t-i)+Math.abs(e-a)>1&&_d[c*xd+u])l(i,a,t,e,u,c),l(r,n,i,a,u,c);else {const l=o(t,e),u=o(r,n),c=o(i,a);s.emplaceBack(l,u,c);}}return l(0,0,gd,gd,gd,0),l(gd,gd,0,0,0,gd),{vertices:i,indices:s}}(this.tileID.canonical,e);n=t.vertices,i=t.indices;}else {n=new ea,i=new ya;for(const{x:t,y:e}of r)n.emplaceBack(t,e,0,0);const t=xu(n.int16,void 0,4);for(let e=0;e<t.length;e+=3)i.emplaceBack(t[e],t[e+1],t[e+2]);}this._tileBoundsBuffer=t.createVertexBuffer(n,Sd.members),this._tileBoundsIndexBuffer=t.createIndexBuffer(i),this._tileBoundsSegments=_o.simpleSegment(0,0,n.length,i.length);}_makeGlobeTileDebugBuffers(t,e){const r=e.projection;if(!r||"globe"!==r.name||e.freezeTileCoverage)return;const n=this.tileID.canonical,i=df(nf(n,e)),s=gf(e.zoom);let a;s>0&&(a=gl(new Float64Array(16),e.globeMatrix));const o=(n.x+.5)/(1<<n.z)-zo(e.center.lng);let l=0;o>.5?l=-1:o<-.5&&(l=1),this._makeGlobeTileDebugBorderBuffer(t,n,e,i,a,s,l),this._makeGlobeTileDebugTextBuffer(t,n,e,i,a,s,l);}_globePoint(t,e,r,n,i,s,a,o){let l=hf(t,e,r);if(s){const i=1<<r.z,u=[((t/wo+r.x)/i+o)*n,(e/wo+r.y)/i*n,0];jl(u,u,s),l=vr(l,u,a);}return jl(l,l,i)}_makeGlobeTileDebugBorderBuffer(t,e,r,n,i,s,a){const o=new Qs,l=new wa,u=new ta,c=(t,c,h,p,f)=>{const d=(h-t)/(f-1),y=(p-c)/(f-1),m=o.length;for(let h=0;h<f;h++){const p=t+h*d,f=c+h*y;o.emplaceBack(p,f);const g=this._globePoint(p,f,e,r.worldSize,n,i,s,a);u.emplaceBack(g[0],g[1],g[2]),l.emplaceBack(m+h);}},h=wo;c(0,0,h,0,16),c(h,0,h,h,16),c(h,h,0,h,16),c(0,h,0,0,16),this._tileDebugIndexBuffer=t.createIndexBuffer(l),this._tileDebugBuffer=t.createVertexBuffer(o,Zp.members),this._globeTileDebugBorderBuffer=t.createVertexBuffer(u,Gp.members),this._tileDebugSegments=_o.simpleSegment(0,0,o.length,l.length);}_makeGlobeTileDebugTextBuffer(t,e,r,n,i,s,a){const o=new Qs,l=new ya,u=new ta,c=25;l.reserve(32),o.reserve(c),u.reserve(c);const h=(t,e)=>c*t+e;for(let t=0;t<c;t++){const l=2048*t;for(let t=0;t<c;t++){const c=2048*t;o.emplaceBack(c,l);const h=this._globePoint(c,l,e,r.worldSize,n,i,s,a);u.emplaceBack(h[0],h[1],h[2]);}}for(let t=0;t<4;t++)for(let e=0;e<4;e++){const r=h(t,e),n=h(t,e+1),i=h(t+1,e),s=h(t+1,e+1);l.emplaceBack(r,n,i),l.emplaceBack(i,n,s);}this._tileDebugTextIndexBuffer=t.createIndexBuffer(l),this._tileDebugTextBuffer=t.createVertexBuffer(o,Zp.members),this._globeTileDebugTextBuffer=t.createVertexBuffer(u,Gp.members),this._tileDebugTextSegments=_o.simpleSegment(0,0,c,32);}}class Md{constructor(){this.state={},this.stateChanges={},this.deletedStates={};}updateState(t,e,r){const n=String(e);if(this.stateChanges[t]=this.stateChanges[t]||{},this.stateChanges[t][n]=this.stateChanges[t][n]||{},v(this.stateChanges[t][n],r),null===this.deletedStates[t]){this.deletedStates[t]={};for(const e in this.state[t])e!==n&&(this.deletedStates[t][e]=null);}else if(this.deletedStates[t]&&null===this.deletedStates[t][n]){this.deletedStates[t][n]={};for(const e in this.state[t][n])r[e]||(this.deletedStates[t][n][e]=null);}else for(const e in r)this.deletedStates[t]&&this.deletedStates[t][n]&&null===this.deletedStates[t][n][e]&&delete this.deletedStates[t][n][e];}removeFeatureState(t,e,r){if(null===this.deletedStates[t])return;const n=String(e);if(this.deletedStates[t]=this.deletedStates[t]||{},r&&void 0!==e)null!==this.deletedStates[t][n]&&(this.deletedStates[t][n]=this.deletedStates[t][n]||{},this.deletedStates[t][n][r]=null);else if(void 0!==e)if(this.stateChanges[t]&&this.stateChanges[t][n])for(r in this.deletedStates[t][n]={},this.stateChanges[t][n])this.deletedStates[t][n][r]=null;else this.deletedStates[t][n]=null;else this.deletedStates[t]=null;}getState(t,e){const r=String(e),n=v({},(this.state[t]||{})[r],(this.stateChanges[t]||{})[r]);if(null===this.deletedStates[t])return {};if(this.deletedStates[t]){const r=this.deletedStates[t][e];if(null===r)return {};for(const t in r)delete n[t];}return n}initializeTileState(t,e){t.setFeatureState(this.state,e);}coalesceChanges(t,e){const r={};for(const t in this.stateChanges){this.state[t]=this.state[t]||{};const e={};for(const r in this.stateChanges[t])this.state[t][r]||(this.state[t][r]={}),v(this.state[t][r],this.stateChanges[t][r]),e[r]=this.state[t][r];r[t]=e;}for(const t in this.deletedStates){this.state[t]=this.state[t]||{};const e={};if(null===this.deletedStates[t])for(const r in this.state[t])e[r]={},this.state[t][r]={};else for(const r in this.deletedStates[t]){if(null===this.deletedStates[t][r])this.state[t][r]={};else for(const e of Object.keys(this.deletedStates[t][r]))delete this.state[t][r][e];e[r]=this.state[t][r];}r[t]=r[t]||{},v(r[t],e);}if(this.stateChanges={},this.deletedStates={},0!==Object.keys(r).length)for(const n in t)t[n].setFeatureState(r,e);}}class zd{constructor(t){this.size=t,this.minimums=[],this.maximums=[],this.leaves=[];}getElevation(t,e){const r=this.toIdx(t,e);return {min:this.minimums[r],max:this.maximums[r]}}isLeaf(t,e){return this.leaves[this.toIdx(t,e)]}toIdx(t,e){return e*this.size+t}}function Td(t,e,r,n){let i=0,s=Number.MAX_VALUE;for(let a=0;a<3;a++)if(Math.abs(n[a])<1e-15){if(r[a]<t[a]||r[a]>e[a])return null}else {const o=1/n[a];let l=(t[a]-r[a])*o,u=(e[a]-r[a])*o;if(l>u){const t=l;l=u,u=t;}if(l>i&&(i=l),u<s&&(s=u),i>s)return null}return i}function Bd(t,e,r,n,i,s,a,o,l,u,c){const h=n-t,p=i-e,f=s-r,d=a-t,y=o-e,m=l-r,g=c[1]*m-c[2]*y,x=c[2]*d-c[0]*m,v=c[0]*y-c[1]*d,b=h*g+p*x+f*v;if(Math.abs(b)<1e-15)return null;const _=1/b,w=u[0]-t,A=u[1]-e,S=u[2]-r,k=(w*g+A*x+S*v)*_;if(k<0||k>1)return null;const I=A*f-S*p,M=S*h-w*f,z=w*p-A*h,T=(c[0]*I+c[1]*M+c[2]*z)*_;return T<0||k+T>1?null:(d*I+y*M+m*z)*_}function Ed(t,e,r){return (t-e)/(r-e)}function Cd(t,e,r,n,i,s,a,o,l){const u=1<<r,c=s-n,h=a-i,p=(t+1)/u*c+n,f=(e+0)/u*h+i,d=(e+1)/u*h+i;o[0]=(t+0)/u*c+n,o[1]=f,l[0]=p,l[1]=d;}class Pd{constructor(t){if(this.maximums=[],this.minimums=[],this.leaves=[],this.childOffsets=[],this.nodeCount=0,this.dem=t,this._siblingOffset=[[0,0],[1,0],[0,1],[1,1]],!this.dem)return;const e=function(t){const e=Math.ceil(Math.log2(t.dim/8)),r=[];let n=Math.ceil(Math.pow(2,e));const i=1/n,s=(t,e,r,n,i)=>{const s=n?1:0,a=(t+1)*r-s,o=e*r,l=(e+1)*r-s;i[0]=t*r,i[1]=o,i[2]=a,i[3]=l;};let a=new zd(n);const o=[];for(let e=0;e<n*n;e++){s(e%n,Math.floor(e/n),i,!1,o);const r=Vd(o[0],o[1],t),l=Vd(o[2],o[1],t),u=Vd(o[2],o[3],t),c=Vd(o[0],o[3],t);a.minimums.push(Math.min(r,l,u,c)),a.maximums.push(Math.max(r,l,u,c)),a.leaves.push(1);}for(r.push(a),n/=2;n>=1;n/=2){const t=r[r.length-1];a=new zd(n);for(let e=0;e<n*n;e++){s(e%n,Math.floor(e/n),2,!0,o);const r=t.getElevation(o[0],o[1]),i=t.getElevation(o[2],o[1]),l=t.getElevation(o[2],o[3]),u=t.getElevation(o[0],o[3]),c=t.isLeaf(o[0],o[1]),h=t.isLeaf(o[2],o[1]),p=t.isLeaf(o[2],o[3]),f=t.isLeaf(o[0],o[3]),d=Math.min(r.min,i.min,l.min,u.min),y=Math.max(r.max,i.max,l.max,u.max),m=c&&h&&p&&f;a.maximums.push(y),a.minimums.push(d),a.leaves.push(y-d<=5&&m?1:0);}r.push(a);}return r}(this.dem),r=e.length-1,n=e[r];this._addNode(n.minimums[0],n.maximums[0],n.leaves[0]),this._construct(e,0,0,r,0);}raycastRoot(t,e,r,n,i,s,a=1){return Td([t,e,-100],[r,n,this.maximums[0]*a],i,s)}raycast(t,e,r,n,i,s,a=1){if(!this.nodeCount)return null;const o=this.raycastRoot(t,e,r,n,i,s,a);if(null==o)return null;const l=[],u=[],c=[],h=[],p=[{idx:0,t:o,nodex:0,nodey:0,depth:0}];for(;p.length>0;){const{idx:o,t:f,nodex:d,nodey:y,depth:m}=p.pop();if(this.leaves[o]){Cd(d,y,m,t,e,r,n,c,h);const o=1<<m,l=(d+0)/o,u=(d+1)/o,p=(y+0)/o,g=(y+1)/o,x=Vd(l,p,this.dem)*a,v=Vd(u,p,this.dem)*a,b=Vd(u,g,this.dem)*a,_=Vd(l,g,this.dem)*a,w=Bd(c[0],c[1],x,h[0],c[1],v,h[0],h[1],b,i,s),A=Bd(h[0],h[1],b,c[0],h[1],_,c[0],c[1],x,i,s),S=Math.min(null!==w?w:Number.MAX_VALUE,null!==A?A:Number.MAX_VALUE);if(S!==Number.MAX_VALUE)return S;{const t=Fl([],i,s,f);if(Dd(x,v,_,b,Ed(t[0],c[0],h[0]),Ed(t[1],c[1],h[1]))>=t[2])return f}continue}let g=0;for(let p=0;p<this._siblingOffset.length;p++){Cd((d<<1)+this._siblingOffset[p][0],(y<<1)+this._siblingOffset[p][1],m+1,t,e,r,n,c,h),c[2]=-100,h[2]=this.maximums[this.childOffsets[o]+p]*a;const f=Td(c,h,i,s);if(null!=f){const t=f;l[p]=t;let e=!1;for(let r=0;r<g&&!e;r++)t>=l[u[r]]&&(u.splice(r,0,p),e=!0);e||(u[g]=p),g++;}}for(let t=0;t<g;t++){const e=u[t];p.push({idx:this.childOffsets[o]+e,t:l[e],nodex:(d<<1)+this._siblingOffset[e][0],nodey:(y<<1)+this._siblingOffset[e][1],depth:m+1});}}return null}_addNode(t,e,r){return this.minimums.push(t),this.maximums.push(e),this.leaves.push(r),this.childOffsets.push(0),this.nodeCount++}_construct(t,e,r,n,i){if(1===t[n].isLeaf(e,r))return;this.childOffsets[i]||(this.childOffsets[i]=this.nodeCount);const s=n-1,a=t[s];let o=0,l=0;for(let t=0;t<this._siblingOffset.length;t++){const n=2*e+this._siblingOffset[t][0],i=2*r+this._siblingOffset[t][1],s=a.getElevation(n,i),u=a.isLeaf(n,i),c=this._addNode(s.min,s.max,u);u&&(o|=1<<t),l||(l=c);}for(let n=0;n<this._siblingOffset.length;n++)o&1<<n||this._construct(t,2*e+this._siblingOffset[n][0],2*r+this._siblingOffset[n][1],s,l+n);}}function Dd(t,e,r,n,i,s){return xr(xr(t,r,s),xr(e,n,s),i)}function Vd(t,e,r){const n=r.dim,i=d(t*n-.5,0,n-1),s=d(e*n-.5,0,n-1),a=Math.floor(i),o=Math.floor(s),l=Math.min(a+1,n-1),u=Math.min(o+1,n-1);return Dd(r.get(a,o),r.get(l,o),r.get(a,u),r.get(l,u),i-a,s-o)}const Fd={mapbox:[6553.6,25.6,.1,1e4],terrarium:[256,1,1/256,32768]};class Ld{get tree(){return this._tree||this._buildQuadTree(),this._tree}constructor(t,e,r,n=!1,i=!1){if(this.uid=t,e.height!==e.width)throw new RangeError("DEM tiles must be square");if(r&&"mapbox"!==r&&"terrarium"!==r)return E(`"${r}" is not a valid encoding type. Valid types include "mapbox" and "terrarium".`);this.stride=e.height;const s=this.dim=e.height-2,a=new Uint32Array(e.data.buffer);if(this.pixels=new Uint8Array(e.data.buffer),this.encoding=r||"mapbox",this.borderReady=n,!n){for(let t=0;t<s;t++)a[this._idx(-1,t)]=a[this._idx(0,t)],a[this._idx(s,t)]=a[this._idx(s-1,t)],a[this._idx(t,-1)]=a[this._idx(t,0)],a[this._idx(t,s)]=a[this._idx(t,s-1)];a[this._idx(-1,-1)]=a[this._idx(0,0)],a[this._idx(s,-1)]=a[this._idx(s-1,0)],a[this._idx(-1,s)]=a[this._idx(0,s-1)],a[this._idx(s,s)]=a[this._idx(s-1,s-1)],i&&this._buildQuadTree();}}_buildQuadTree(){this._tree=new Pd(this);}get(t,e,r=!1){r&&(t=d(t,-1,this.dim),e=d(e,-1,this.dim));const n=4*this._idx(t,e);return ("terrarium"===this.encoding?this._unpackTerrarium:this._unpackMapbox)(this.pixels[n],this.pixels[n+1],this.pixels[n+2])}static getUnpackVector(t){return Fd[t]}get unpackVector(){return Fd[this.encoding]}_idx(t,e){if(t<-1||t>=this.dim+1||e<-1||e>=this.dim+1)throw new RangeError("out of range source coordinates for DEM data");return (e+1)*this.stride+(t+1)}_unpackMapbox(t,e,r){return (256*t*256+256*e+r)/10-1e4}_unpackTerrarium(t,e,r){return 256*t+e+r/256-32768}static pack(t,e){const r=[0,0,0,0],n=Ld.getUnpackVector(e);let i=Math.floor((t+n[3])/n[2]);return r[2]=i%256,i=Math.floor(i/256),r[1]=i%256,i=Math.floor(i/256),r[0]=i,r}getPixels(){return new pu({width:this.stride,height:this.stride},this.pixels)}backfillBorder(t,e,r){if(this.dim!==t.dim)throw new Error("dem dimension mismatch");let n=e*this.dim,i=e*this.dim+this.dim,s=r*this.dim,a=r*this.dim+this.dim;switch(e){case-1:n=i-1;break;case 1:i=n+1;}switch(r){case-1:s=a-1;break;case 1:a=s+1;}const o=-e*this.dim,l=-r*this.dim;for(let e=s;e<a;e++)for(let r=n;r<i;r++){const n=4*this._idx(r,e),i=4*this._idx(r+o,e+l);this.pixels[n+0]=t.pixels[i+0],this.pixels[n+1]=t.pixels[i+1],this.pixels[n+2]=t.pixels[i+2],this.pixels[n+3]=t.pixels[i+3];}}onDeserialize(){this._tree&&(this._tree.dem=this);}}Pi(Ld,"DEMData"),Pi(Pd,"DemMinMaxQuadTree",{omit:["dem"]});class Rd{constructor(t,e){this.max=t,this.onRemove=e,this.reset();}reset(){for(const t in this.data)for(const e of this.data[t])e.timeout&&clearTimeout(e.timeout),this.onRemove(e.value);return this.data={},this.order=[],this}add(t,e,r){const n=t.wrapped().key;void 0===this.data[n]&&(this.data[n]=[]);const i={value:e,timeout:void 0};if(void 0!==r&&(i.timeout=setTimeout((()=>{this.remove(t,i);}),r)),this.data[n].push(i),this.order.push(n),this.order.length>this.max){const t=this._getAndRemoveByKey(this.order[0]);t&&this.onRemove(t);}return this}has(t){return t.wrapped().key in this.data}getAndRemove(t){return this.has(t)?this._getAndRemoveByKey(t.wrapped().key):null}_getAndRemoveByKey(t){const e=this.data[t].shift();return e.timeout&&clearTimeout(e.timeout),0===this.data[t].length&&delete this.data[t],this.order.splice(this.order.indexOf(t),1),e.value}getByKey(t){const e=this.data[t];return e?e[0].value:null}get(t){return this.has(t)?this.data[t.wrapped().key][0].value:null}remove(t,e){if(!this.has(t))return this;const r=t.wrapped().key,n=void 0===e?0:this.data[r].indexOf(e),i=this.data[r][n];return this.data[r].splice(n,1),i.timeout&&clearTimeout(i.timeout),0===this.data[r].length&&delete this.data[r],this.onRemove(i.value),this.order.splice(this.order.indexOf(r),1),this}setMaxSize(t){for(this.max=t;this.order.length>this.max;){const t=this._getAndRemoveByKey(this.order[0]);t&&this.onRemove(t);}return this}filter(t){const e=[];for(const r in this.data)for(const n of this.data[r])t(n.value)||e.push(n);for(const t of e)this.remove(t.value.tileID,t);}}class Ud{constructor(t,e,r){this.func=t,this.mask=e,this.range=r;}}Ud.ReadOnly=!1,Ud.ReadWrite=!0,Ud.disabled=new Ud(519,Ud.ReadOnly,[0,1]);const jd=7680;class $d{constructor(t,e,r,n,i,s){this.test=t,this.ref=e,this.mask=r,this.fail=n,this.depthFail=i,this.pass=s;}}$d.disabled=new $d({func:519,mask:0},0,0,jd,jd,jd);class Od{constructor(t,e,r){this.blendFunction=t,this.blendColor=e,this.mask=r;}}Od.Replace=[1,0],Od.disabled=new Od(Od.Replace,xe.transparent,[!1,!1,!1,!1]),Od.unblended=new Od(Od.Replace,xe.transparent,[!0,!0,!0,!0]),Od.alphaBlended=new Od([1,771],xe.transparent,[!0,!0,!0,!0]);const qd=1029,Nd=2305;class Gd{constructor(t,e,r){this.enable=t,this.mode=e,this.frontFace=r;}}Gd.disabled=new Gd(!1,qd,Nd),Gd.backCCW=new Gd(!0,qd,Nd),Gd.backCW=new Gd(!0,qd,2304),Gd.frontCW=new Gd(!0,1028,2304),Gd.frontCCW=new Gd(!0,1028,Nd);class Zd extends Nt{constructor(t,e,r){super(),this.id=t,this._onlySymbols=r,e.on("data",(t=>{"source"===t.dataType&&"metadata"===t.sourceDataType&&(this._sourceLoaded=!0),this._sourceLoaded&&!this._paused&&"source"===t.dataType&&"content"===t.sourceDataType&&(this.reload(),this.transform&&this.update(this.transform));})),e.on("error",(()=>{this._sourceErrored=!0;})),this._source=e,this._tiles={},this._cache=new Rd(0,this._unloadTile.bind(this)),this._timers={},this._cacheTimers={},this._minTileCacheSize=e.minTileCacheSize,this._maxTileCacheSize=e.maxTileCacheSize,this._loadedParentTiles={},this._coveredTiles={},this._state=new Md,this._isRaster="raster"===this._source.type||"raster-dem"===this._source.type||"custom"===this._source.type&&"raster"===this._source._dataType;}onAdd(t){this.map=t,this._minTileCacheSize=void 0===this._minTileCacheSize&&t?t._minTileCacheSize:this._minTileCacheSize,this._maxTileCacheSize=void 0===this._maxTileCacheSize&&t?t._maxTileCacheSize:this._maxTileCacheSize;}loaded(){if(this._sourceErrored)return !0;if(!this._sourceLoaded)return !1;if(!this._source.loaded())return !1;for(const t in this._tiles){const e=this._tiles[t];if("loaded"!==e.state&&"errored"!==e.state)return !1}return !0}getSource(){return this._source}pause(){this._paused=!0;}resume(){if(!this._paused)return;const t=this._shouldReloadOnResume;this._paused=!1,this._shouldReloadOnResume=!1,t&&this.reload(),this.transform&&this.update(this.transform);}_loadTile(t,e){return t.isSymbolTile=this._onlySymbols,this._source.loadTile(t,e)}_unloadTile(t){if(this._source.unloadTile)return this._source.unloadTile(t,(()=>{}))}_abortTile(t){if(this._source.abortTile)return this._source.abortTile(t,(()=>{}))}serialize(){return this._source.serialize()}prepare(t){if(this._source.prepare&&this._source.prepare(),this._state.coalesceChanges(this._tiles,this.map?this.map.painter:null),this._source.prepareTile)for(const e in this._tiles){const r=this._tiles[e];this._source.prepareTile(r)&&this.map.painter.terrain&&this.map.painter.terrain._clearRenderCacheForTile(this.id,r.tileID),r.upload(t),r.prepare(this.map.style.imageManager);}else for(const e in this._tiles){const r=this._tiles[e];r.upload(t),r.prepare(this.map.style.imageManager);}}getIds(){return x(this._tiles).map((t=>t.tileID)).sort(Xd).map((t=>t.key))}getRenderableIds(t){const e=[];for(const r in this._tiles)this._isIdRenderable(+r,t)&&e.push(this._tiles[r]);return t?e.sort(((t,e)=>{const r=t.tileID,n=e.tileID,s=new i(r.canonical.x,r.canonical.y)._rotate(this.transform.angle),a=new i(n.canonical.x,n.canonical.y)._rotate(this.transform.angle);return r.overscaledZ-n.overscaledZ||a.y-s.y||a.x-s.x})).map((t=>t.tileID.key)):e.map((t=>t.tileID)).sort(Xd).map((t=>t.key))}hasRenderableParent(t){const e=this.findLoadedParent(t,0);return !!e&&this._isIdRenderable(e.tileID.key)}_isIdRenderable(t,e){return this._tiles[t]&&this._tiles[t].hasData()&&!this._coveredTiles[t]&&(e||!this._tiles[t].holdingForFade())}reload(){if(this._paused)this._shouldReloadOnResume=!0;else {this._cache.reset();for(const t in this._tiles)"errored"!==this._tiles[t].state&&this._reloadTile(+t,"reloading");}}_reloadTile(t,e){const r=this._tiles[t];r&&("loading"!==r.state&&(r.state=e),this._loadTile(r,this._tileLoaded.bind(this,r,t,e)));}_tileLoaded(t,e,r,n){if(n)if(t.state="errored",404!==n.status)this._source.fire(new qt(n,{tile:t}));else if("raster-dem"===this._source.type&&this.usedForTerrain&&this.map.painter.terrain){const t=this.map.painter.terrain;this.update(this.transform,t.getScaledDemTileSize(),!0),t.resetTileLookupCache(this.id);}else this.update(this.transform);else t.timeAdded=X.now(),"expired"===r&&(t.refreshedUponExpiration=!0),this._setTileReloadTimer(e,t),"raster-dem"===this._source.type&&t.dem&&this._backfillDEM(t),this._state.initializeTileState(t,this.map?this.map.painter:null),this._source.fire(new Ot("data",{dataType:"source",tile:t,coord:t.tileID,sourceCacheId:this.id}));}_backfillDEM(t){const e=this.getRenderableIds();for(let n=0;n<e.length;n++){const i=e[n];if(t.neighboringTiles&&t.neighboringTiles[i]){const e=this.getTileByID(i);r(t,e),r(e,t);}}function r(t,e){if(!t.dem||t.dem.borderReady)return;t.needsHillshadePrepare=!0,t.needsDEMTextureUpload=!0;let r=e.tileID.canonical.x-t.tileID.canonical.x;const n=e.tileID.canonical.y-t.tileID.canonical.y,i=Math.pow(2,t.tileID.canonical.z),s=e.tileID.key;0===r&&0===n||Math.abs(n)>1||(Math.abs(r)>1&&(1===Math.abs(r+i)?r+=i:1===Math.abs(r-i)&&(r-=i)),e.dem&&t.dem&&(t.dem.backfillBorder(e.dem,r,n),t.neighboringTiles&&t.neighboringTiles[s]&&(t.neighboringTiles[s].backfilled=!0)));}}getTile(t){return this.getTileByID(t.key)}getTileByID(t){return this._tiles[t]}_retainLoadedChildren(t,e,r,n){for(const i in this._tiles){let s=this._tiles[i];if(n[i]||!s.hasData()||s.tileID.overscaledZ<=e||s.tileID.overscaledZ>r)continue;let a=s.tileID;for(;s&&s.tileID.overscaledZ>e+1;){const t=s.tileID.scaledTo(s.tileID.overscaledZ-1);s=this._tiles[t.key],s&&s.hasData()&&(a=t);}let o=a;for(;o.overscaledZ>e;)if(o=o.scaledTo(o.overscaledZ-1),t[o.key]){n[a.key]=a;break}}}findLoadedParent(t,e){if(t.key in this._loadedParentTiles){const r=this._loadedParentTiles[t.key];return r&&r.tileID.overscaledZ>=e?r:null}for(let r=t.overscaledZ-1;r>=e;r--){const e=t.scaledTo(r),n=this._getLoadedTile(e);if(n)return n}}_getLoadedTile(t){const e=this._tiles[t.key];return e&&e.hasData()?e:this._cache.getByKey(this._source.reparseOverscaled?t.wrapped().key:t.canonical.key)}updateCacheSize(t,e){e=e||this._source.tileSize;const r=Math.ceil(t.width/e)+1,n=Math.ceil(t.height/e)+1,i=Math.floor(r*n*5),s="number"==typeof this._minTileCacheSize?Math.max(this._minTileCacheSize,i):i,a="number"==typeof this._maxTileCacheSize?Math.min(this._maxTileCacheSize,s):s;this._cache.setMaxSize(a);}handleWrapJump(t){const e=Math.round((t-(void 0===this._prevLng?t:this._prevLng))/360);if(this._prevLng=t,e){const t={};for(const r in this._tiles){const n=this._tiles[r];n.tileID=n.tileID.unwrapTo(n.tileID.wrap+e),t[n.tileID.key]=n;}this._tiles=t;for(const t in this._timers)clearTimeout(this._timers[t]),delete this._timers[t];for(const t in this._tiles)this._setTileReloadTimer(+t,this._tiles[t]);}}update(t,e,r){if(this.transform=t,!this._sourceLoaded||this._paused||this.transform.freezeTileCoverage)return;if(this.usedForTerrain&&!r)return;let n;this.updateCacheSize(t,e),"globe"!==this.transform.projection.name&&this.handleWrapJump(this.transform.center.lng),this._coveredTiles={},this.used||this.usedForTerrain?this._source.tileID?n=t.getVisibleUnwrappedCoordinates(this._source.tileID).map((t=>new Fc(t.canonical.z,t.wrap,t.canonical.z,t.canonical.x,t.canonical.y))):(n=t.coveringTiles({tileSize:e||this._source.tileSize,minzoom:this._source.minzoom,maxzoom:this._source.maxzoom,roundZoom:this._source.roundZoom&&!r,reparseOverscaled:this._source.reparseOverscaled,isTerrainDEM:this.usedForTerrain}),this._source.hasTile&&(n=n.filter((t=>this._source.hasTile(t))))):n=[];const i=this._updateRetainedTiles(n);if(Kd(this._source.type)&&0!==n.length){const t={},e={},r=Object.keys(i);for(const n of r){const r=i[n],s=this._tiles[n];if(!s||s.fadeEndTime&&s.fadeEndTime<=X.now())continue;const a=this.findLoadedParent(r,Math.max(r.overscaledZ-Zd.maxOverzooming,this._source.minzoom));a&&(this._addTile(a.tileID),t[a.tileID.key]=a.tileID),e[n]=r;}const s=n[n.length-1].overscaledZ;for(const t in this._tiles){const r=this._tiles[t];if(i[t]||!r.hasData())continue;let n=r.tileID;for(;n.overscaledZ>s;){n=n.scaledTo(n.overscaledZ-1);const s=this._tiles[n.key];if(s&&s.hasData()&&e[n.key]){i[t]=r.tileID;break}}}for(const e in t)i[e]||(this._coveredTiles[e]=!0,i[e]=t[e]);}for(const t in i)this._tiles[t].clearFadeHold();const s=function(t,e){const r=[];for(const n in t)n in e||r.push(n);return r}(this._tiles,i);for(const t of s){const e=this._tiles[t];e.hasSymbolBuckets&&!e.holdingForFade()?e.setHoldDuration(this.map._fadeDuration):e.hasSymbolBuckets&&!e.symbolFadeFinished()||this._removeTile(+t);}this._updateLoadedParentTileCache(),this._onlySymbols&&this._source.afterUpdate&&this._source.afterUpdate();}releaseSymbolFadeTiles(){for(const t in this._tiles)this._tiles[t].holdingForFade()&&this._removeTile(+t);}_updateRetainedTiles(t){const e={};if(0===t.length)return e;const r={},n=t.reduce(((t,e)=>Math.min(t,e.overscaledZ)),1/0),i=t[0].overscaledZ,s=Math.max(i-Zd.maxOverzooming,this._source.minzoom),a=Math.max(i+Zd.maxUnderzooming,this._source.minzoom),o={};for(const r of t){const t=this._addTile(r);e[r.key]=r,t.hasData()||n<this._source.maxzoom&&(o[r.key]=r);}this._retainLoadedChildren(o,n,a,e);for(const n of t){let t=this._tiles[n.key];if(t.hasData())continue;if(n.canonical.z>=this._source.maxzoom){const t=n.children(this._source.maxzoom)[0],r=this.getTile(t);if(r&&r.hasData()){e[t.key]=t;continue}}else {const t=n.children(this._source.maxzoom);if(e[t[0].key]&&e[t[1].key]&&e[t[2].key]&&e[t[3].key])continue}let i=t.wasRequested();for(let a=n.overscaledZ-1;a>=s;--a){const s=n.scaledTo(a);if(r[s.key])break;if(r[s.key]=!0,t=this.getTile(s),!t&&i&&(t=this._addTile(s)),t&&(e[s.key]=s,i=t.wasRequested(),t.hasData()))break}}return e}_updateLoadedParentTileCache(){this._loadedParentTiles={};for(const t in this._tiles){const e=[];let r,n=this._tiles[t].tileID;for(;n.overscaledZ>0;){if(n.key in this._loadedParentTiles){r=this._loadedParentTiles[n.key];break}e.push(n.key);const t=n.scaledTo(n.overscaledZ-1);if(r=this._getLoadedTile(t),r)break;n=t;}for(const t of e)this._loadedParentTiles[t]=r;}}_addTile(t){let e=this._tiles[t.key];if(e)return this._source.prepareTile&&this._source.prepareTile(e),e;e=this._cache.getAndRemove(t),e&&(this._setTileReloadTimer(t.key,e),e.tileID=t,this._state.initializeTileState(e,this.map?this.map.painter:null),this._cacheTimers[t.key]&&(clearTimeout(this._cacheTimers[t.key]),delete this._cacheTimers[t.key],this._setTileReloadTimer(t.key,e)));const r=Boolean(e);if(!r){const r=this.map?this.map.painter:null;e=new Id(t,this._source.tileSize*t.overscaleFactor(),this.transform.tileZoom,r,this._isRaster),this._source.prepareTile&&this._source.prepareTile(e)||this._loadTile(e,this._tileLoaded.bind(this,e,t.key,e.state));}return e?(e.uses++,this._tiles[t.key]=e,r||this._source.fire(new Ot("dataloading",{tile:e,coord:e.tileID,dataType:"source"})),e):null}_setTileReloadTimer(t,e){t in this._timers&&(clearTimeout(this._timers[t]),delete this._timers[t]);const r=e.getExpiryTimeout();r&&(this._timers[t]=setTimeout((()=>{this._reloadTile(t,"expired"),delete this._timers[t];}),r));}_removeTile(t){const e=this._tiles[t];e&&(e.uses--,delete this._tiles[t],this._timers[t]&&(clearTimeout(this._timers[t]),delete this._timers[t]),e.uses>0||(e.hasData()&&"reloading"!==e.state?this._cache.add(e.tileID,e,e.getExpiryTimeout()):(e.aborted=!0,this._abortTile(e),this._unloadTile(e))));}clearTiles(){this._shouldReloadOnResume=!1,this._paused=!1;for(const t in this._tiles)this._removeTile(+t);this._source._clear&&this._source._clear(),this._cache.reset(),this.map&&this.usedForTerrain&&this.map.painter.terrain&&this.map.painter.terrain.resetTileLookupCache(this.id);}tilesIn(t,e,r){const n=[],i=this.transform;if(!i)return n;const s="globe"===i.projection.name,a=zo(i.center.lng);for(const o in this._tiles){const l=this._tiles[o];if(r&&l.clearQueryDebugViz(),l.holdingForFade())continue;let u;if(s){const t=l.tileID.canonical;if(0===t.z){const e=[Math.abs(d(a,...Hd(t,-1))-a),Math.abs(d(a,...Hd(t,1))-a)];u=[0,2*e.indexOf(Math.min(...e))-1];}else {const e=[Math.abs(d(a,...Hd(t,-1))-a),Math.abs(d(a,...Hd(t,0))-a),Math.abs(d(a,...Hd(t,1))-a)];u=[e.indexOf(Math.min(...e))-1];}}else u=[0];for(const r of u){const s=t.containsTile(l,i,e,r);s&&n.push(s);}}return n}getVisibleCoordinates(t){const e=this.getRenderableIds(t).map((t=>this._tiles[t].tileID));for(const t of e)t.projMatrix=this.transform.calculateProjMatrix(t.toUnwrapped());return e}hasTransition(){if(this._source.hasTransition())return !0;if(Kd(this._source.type))for(const t in this._tiles){const e=this._tiles[t];if(void 0!==e.fadeEndTime&&e.fadeEndTime>=X.now())return !0}return !1}setFeatureState(t,e,r){this._state.updateState(t=t||"_geojsonTileLayer",e,r);}removeFeatureState(t,e,r){this._state.removeFeatureState(t=t||"_geojsonTileLayer",e,r);}getFeatureState(t,e){return this._state.getState(t=t||"_geojsonTileLayer",e)}setDependencies(t,e,r){const n=this._tiles[t];n&&n.setDependencies(e,r);}reloadTilesForDependencies(t,e){for(const r in this._tiles)this._tiles[r].hasDependency(t,e)&&this._reloadTile(+r,"reloading");this._cache.filter((r=>!r.hasDependency(t,e)));}_preloadTiles(t,e){const r=new Map,n=Array.isArray(t)?t:[t],i=this.map.painter.terrain,s=this.usedForTerrain&&i?i.getScaledDemTileSize():this._source.tileSize;for(const t of n){const e=t.coveringTiles({tileSize:s,minzoom:this._source.minzoom,maxzoom:this._source.maxzoom,roundZoom:this._source.roundZoom&&!this.usedForTerrain,reparseOverscaled:this._source.reparseOverscaled,isTerrainDEM:this.usedForTerrain});for(const t of e)r.set(t.key,t);this.usedForTerrain&&t.updateElevation(!1);}g(Array.from(r.values()),((t,e)=>{const r=new Id(t,this._source.tileSize*t.overscaleFactor(),this.transform.tileZoom,this.map.painter,this._isRaster);this._loadTile(r,(t=>{"raster-dem"===this._source.type&&r.dem&&this._backfillDEM(r),e(t,r);}));}),e);}}function Xd(t,e){const r=Math.abs(2*t.wrap)-+(t.wrap<0),n=Math.abs(2*e.wrap)-+(e.wrap<0);return t.overscaledZ-e.overscaledZ||n-r||e.canonical.y-t.canonical.y||e.canonical.x-t.canonical.x}function Kd(t){return "raster"===t||"image"===t||"video"===t}function Hd(t,e){const r=1<<t.z;return [t.x/r+e,(t.x+1)/r+e]}Zd.maxOverzooming=10,Zd.maxUnderzooming=3;class Yd{constructor(t,e,r){this._demTile=t,this._dem=this._demTile.dem,this._scale=e,this._offset=r;}static create(t,e,r){const n=r||t.findDEMTileFor(e);if(!n||!n.dem)return;const i=n.dem,s=n.tileID,a=1<<e.canonical.z-s.canonical.z;return new Yd(n,n.tileSize/wo/a,[(e.canonical.x/a-s.canonical.x)*i.dim,(e.canonical.y/a-s.canonical.y)*i.dim])}tileCoordToPixel(t,e){const r=e*this._scale+this._offset[1],n=Math.floor(t*this._scale+this._offset[0]),s=Math.floor(r);return new i(n,s)}getElevationAt(t,e,r,n){const i=t*this._scale+this._offset[0],s=e*this._scale+this._offset[1],a=Math.floor(i),o=Math.floor(s),l=this._dem;return n=!!n,r?xr(xr(l.get(a,o,n),l.get(a,o+1,n),s-o),xr(l.get(a+1,o,n),l.get(a+1,o+1,n),s-o),i-a):l.get(a,o,n)}getElevationAtPixel(t,e,r){return this._dem.get(t,e,!!r)}getMeterToDEM(t){return (1<<this._demTile.tileID.canonical.z)*Bo(1,t)*this._dem.stride}}class Wd{constructor(t,e){this.tileID=t,this.x=t.canonical.x,this.y=t.canonical.y,this.z=t.canonical.z,this.grid=new Bi(wo,16,0),this.featureIndexArray=new Va,this.promoteId=e;}insert(t,e,r,n,i,s=0){const a=this.featureIndexArray.length;this.featureIndexArray.emplaceBack(r,n,i,s);const o=this.grid;for(let t=0;t<e.length;t++){const r=e[t],n=[1/0,1/0,-1/0,-1/0];for(let t=0;t<r.length;t++){const e=r[t];n[0]=Math.min(n[0],e.x),n[1]=Math.min(n[1],e.y),n[2]=Math.max(n[2],e.x),n[3]=Math.max(n[3],e.y);}n[0]<wo&&n[1]<wo&&n[2]>=0&&n[3]>=0&&o.insert(a,n[0],n[1],n[2],n[3]);}}loadVTLayers(){if(!this.vtLayers){this.vtLayers=new yc.VectorTile(new xh(this.rawTileData)).layers,this.sourceLayerCoder=new dd(this.vtLayers?Object.keys(this.vtLayers).sort():["_geojsonTileLayer"]),this.vtFeatures={};for(const t in this.vtLayers)this.vtFeatures[t]=[];}return this.vtLayers}query(t,e,r,n){this.loadVTLayers();const i=t.params||{},s=Jn(i.filter),a=t.tileResult,o=t.transform,l=a.bufferedTilespaceBounds,u=this.grid.query(l.min.x,l.min.y,l.max.x,l.max.y,((t,e,r,n)=>sl(a.bufferedTilespaceGeometry,t,e,r,n)));u.sort(Qd);let c=null;o.elevation&&u.length>0&&(c=Yd.create(o.elevation,this.tileID));const h={};let p;for(let o=0;o<u.length;o++){const l=u[o];if(l===p)continue;p=l;const f=this.featureIndexArray.get(l);let d=null;this.loadMatchingFeature(h,f,s,i.layers,i.availableImages,e,r,n,((e,r,n,i=0)=>(d||(d=No(e,this.tileID.canonical,t.tileTransform)),r.queryIntersectsFeature(a,e,n,d,this.z,t.transform,t.pixelPosMatrix,c,i))));}return h}loadMatchingFeature(t,e,r,n,i,s,a,o,l){const{featureIndex:u,bucketIndex:c,sourceLayerIndex:h,layoutVertexArrayOffset:p}=e,f=this.bucketLayerIDs[c];if(n&&!function(t,e){for(let r=0;r<t.length;r++)if(e.indexOf(t[r])>=0)return !0;return !1}(n,f))return;const d=this.sourceLayerCoder.decode(h),y=this.vtLayers[d].feature(u);if(r.needGeometry){const t=Go(y,!0);if(!r.filter(new Cs(this.tileID.overscaledZ),t,this.tileID.canonical))return}else if(!r.filter(new Cs(this.tileID.overscaledZ),y))return;const m=this.getId(y,d);for(let e=0;e<f.length;e++){const r=f[e];if(n&&n.indexOf(r)<0)continue;const c=s[r];if(!c)continue;let h={};void 0!==m&&o&&(h=o.getState(c.sourceLayer||"_geojsonTileLayer",m));const d=v({},a[r]);d.paint=Jd(d.paint,c.paint,y,h,i),d.layout=Jd(d.layout,c.layout,y,h,i);const g=!l||l(y,c,h,p);if(!g)continue;const x=new md(y,this.z,this.x,this.y,m);x.layer=d;let b=t[r];void 0===b&&(b=t[r]=[]),b.push({featureIndex:u,feature:x,intersectionZ:g});}}lookupSymbolFeatures(t,e,r,n,i,s,a,o){const l={};this.loadVTLayers();const u=Jn(i);for(const i of t)this.loadMatchingFeature(l,{bucketIndex:r,sourceLayerIndex:n,featureIndex:i,layoutVertexArrayOffset:0},u,s,a,o,e);return l}loadFeature(t){const{featureIndex:e,sourceLayerIndex:r}=t;this.loadVTLayers();const n=this.sourceLayerCoder.decode(r),i=this.vtFeatures[n];if(i[e])return i[e];const s=this.vtLayers[n].feature(e);return i[e]=s,s}hasLayer(t){for(const e of this.bucketLayerIDs)for(const r of e)if(t===r)return !0;return !1}getId(t,e){let r=t.id;return this.promoteId&&(r=t.properties["string"==typeof this.promoteId?this.promoteId:this.promoteId[e]],"boolean"==typeof r&&(r=Number(r))),r}}function Jd(t,e,r,n,i){return M(t,((t,s)=>{const a=e instanceof js?e.get(s):null;return a&&a.evaluate?a.evaluate(r,n,i):a}))}function Qd(t,e){return e-t}Pi(Wd,"FeatureIndex",{omit:["rawTileData","sourceLayerCoder"]});class ty{constructor(t){const e={},r=[];for(const n in t){const i=t[n],s=e[n]={};for(const t in i.glyphs){const e=i.glyphs[+t];if(!e||0===e.bitmap.width||0===e.bitmap.height)continue;const n=e.metrics.localGlyph?2:1,a={x:0,y:0,w:e.bitmap.width+2*n,h:e.bitmap.height+2*n};r.push(a),s[t]=a;}}const{w:n,h:i}=$h(r),s=new hu({width:n||1,height:i||1});for(const r in t){const n=t[r];for(const t in n.glyphs){const i=n.glyphs[+t];if(!i||0===i.bitmap.width||0===i.bitmap.height)continue;const a=e[r][t],o=i.metrics.localGlyph?2:1;hu.copy(i.bitmap,s,{x:0,y:0},{x:a.x+o,y:a.y+o},i.bitmap);}}this.image=s,this.positions=e;}}Pi(ty,"GlyphAtlas");class ey{constructor(t){this.tileID=new Fc(t.tileID.overscaledZ,t.tileID.wrap,t.tileID.canonical.z,t.tileID.canonical.x,t.tileID.canonical.y),this.tileZoom=t.tileZoom,this.uid=t.uid,this.zoom=t.zoom,this.canonical=t.tileID.canonical,this.pixelRatio=t.pixelRatio,this.tileSize=t.tileSize,this.source=t.source,this.overscaling=this.tileID.overscaleFactor(),this.showCollisionBoxes=t.showCollisionBoxes,this.collectResourceTiming=!!t.collectResourceTiming,this.returnDependencies=!!t.returnDependencies,this.promoteId=t.promoteId,this.enableTerrain=!!t.enableTerrain,this.isSymbolTile=t.isSymbolTile,this.tileTransform=Af(t.tileID.canonical,t.projection),this.projection=t.projection;}parse(t,e,r,n,i){this.status="parsing",this.data=t,this.collisionBoxArray=new Ma;const s=new dd(Object.keys(t.layers).sort()),a=new Wd(this.tileID,this.promoteId);a.bucketLayerIDs=[];const o={},l=new hd(256,256),u={featureIndex:a,iconDependencies:{},patternDependencies:{},glyphDependencies:{},lineAtlas:l,availableImages:r},c=e.familiesBySource[this.source];for(const e in c){const n=t.layers[e];if(!n)continue;let i=!1,l=!1;for(const t of c[e])"symbol"===t[0].type?i=!0:l=!0;if(!0===this.isSymbolTile&&!i)continue;if(!1===this.isSymbolTile&&!l)continue;1===n.version&&E(`Vector tile source "${this.source}" layer "${e}" does not use vector tile spec v2 and therefore may have some rendering errors.`);const h=s.encode(e),p=[];for(let t=0;t<n.length;t++){const r=n.feature(t),i=a.getId(r,e);p.push({feature:r,id:i,index:t,sourceLayerIndex:h});}for(const t of c[e]){const e=t[0];void 0!==this.isSymbolTile&&"symbol"===e.type!==this.isSymbolTile||e.minzoom&&this.zoom<Math.floor(e.minzoom)||e.maxzoom&&this.zoom>=e.maxzoom||"none"!==e.visibility&&(ry(t,this.zoom,r),(o[e.id]=e.createBucket({index:a.bucketLayerIDs.length,layers:t,zoom:this.zoom,canonical:this.canonical,pixelRatio:this.pixelRatio,overscaling:this.overscaling,collisionBoxArray:this.collisionBoxArray,sourceLayerIndex:h,sourceID:this.source,enableTerrain:this.enableTerrain,projection:this.projection.spec,availableImages:r})).populate(p,u,this.tileID.canonical,this.tileTransform),a.bucketLayerIDs.push(t.map((t=>t.id))));}}let h,p,f,d;l.trim();const y={type:"maybePrepare",isSymbolTile:this.isSymbolTile,zoom:this.zoom},m=M(u.glyphDependencies,(t=>Object.keys(t).map(Number)));Object.keys(m).length?n.send("getGlyphs",{uid:this.uid,stacks:m},((t,e)=>{h||(h=t,p=e,b.call(this));}),void 0,!1,y):p={};const g=Object.keys(u.iconDependencies);g.length?n.send("getImages",{icons:g,source:this.source,tileID:this.tileID,type:"icons"},((t,e)=>{h||(h=t,f=e,b.call(this));}),void 0,!1,y):f={};const v=Object.keys(u.patternDependencies);function b(){if(h)return i(h);if(p&&f&&d){const t=new ty(p),e=new qh(f,d);for(const n in o){const i=o[n];i instanceof Qf?(ry(i.layers,this.zoom,r),Dp(i,p,t.positions,f,e.iconPositions,this.showCollisionBoxes,r,this.tileID.canonical,this.tileZoom,this.projection)):i.hasPattern&&(i instanceof Kc||i instanceof tc||i instanceof wc)&&(ry(i.layers,this.zoom,r),i.addFeatures(u,this.tileID.canonical,e.patternPositions,r,this.tileTransform));}this.status="done",i(null,{buckets:x(o).filter((t=>!t.isEmpty())),featureIndex:a,collisionBoxArray:this.collisionBoxArray,glyphAtlasImage:t.image,lineAtlas:l,imageAtlas:e,glyphMap:this.returnDependencies?p:null,iconMap:this.returnDependencies?f:null,glyphPositions:this.returnDependencies?t.positions:null});}}v.length?n.send("getImages",{icons:v,source:this.source,tileID:this.tileID,type:"patterns"},((t,e)=>{h||(h=t,d=e,b.call(this));}),void 0,!1,y):d={},b.call(this);}}function ry(t,e,r){const n=new Cs(e);for(const e of t)e.recalculate(n,r);}class ny{constructor(t){this.entries={},this.scheduler=t;}request(t,e,r,n){const i=this.entries[t]=this.entries[t]||{callbacks:[]};if(i.result){const[t,r]=i.result;return this.scheduler?this.scheduler.add((()=>{n(t,r);}),e):n(t,r),()=>{}}return i.callbacks.push(n),i.cancel||(i.cancel=r(((r,n)=>{i.result=[r,n];for(const t of i.callbacks)this.scheduler?this.scheduler.add((()=>{t(r,n);}),e):t(r,n);setTimeout((()=>delete this.entries[t]),3e3);}))),()=>{i.result||(i.callbacks=i.callbacks.filter((t=>t!==n)),i.callbacks.length||(i.cancel(),delete this.entries[t]));}}}function iy(t,e,r){const n=JSON.stringify(t.request);return t.data&&(this.deduped.entries[n]={result:[null,t.data]}),this.deduped.request(n,{type:"parseTile",isSymbolTile:t.isSymbolTile,zoom:t.tileZoom},(e=>{const n=Ct(t.request,((t,n,i,s)=>{t?e(t):n&&e(null,{vectorTile:r?void 0:new yc.VectorTile(new xh(n)),rawData:n,cacheControl:i,expires:s});}));return ()=>{n.cancel(),e();}}),e)}t.ARRAY_TYPE=dl,t.AUTH_ERR_MSG=nt,t.Aabb=eu,t.Actor=class{constructor(t,r,n){this.target=t,this.parent=r,this.mapId=n,this.callbacks={},this.cancelCallbacks={},k(["receive"],this),this.target.addEventListener("message",this.receive,!1),this.globalScope=D()?t:e,this.scheduler=new fd;}send(t,e,r,n,i=!1,s){const a=Math.round(1e18*Math.random()).toString(36).substring(0,10);r&&(r.metadata=s,this.callbacks[a]=r);const o=L(this.globalScope)?void 0:[];return this.target.postMessage({id:a,type:t,hasCallback:!!r,targetMapId:n,mustQueue:i,sourceMapId:this.mapId,data:Fi(e,o)},o),{cancel:()=>{r&&delete this.callbacks[a],this.target.postMessage({id:a,type:"<cancel>",targetMapId:n,sourceMapId:this.mapId});}}}receive(t){const e=t.data,r=e.id;if(r&&(!e.targetMapId||this.mapId===e.targetMapId))if("<cancel>"===e.type){const t=this.cancelCallbacks[r];delete this.cancelCallbacks[r],t&&t.cancel();}else if(e.mustQueue||D()){const t=this.callbacks[r];this.cancelCallbacks[r]=this.scheduler.add((()=>this.processTask(r,e)),t&&t.metadata||{type:"message"});}else this.processTask(r,e);}processTask(t,e){if("<response>"===e.type){const r=this.callbacks[t];delete this.callbacks[t],r&&(e.error?r(Li(e.error)):r(null,Li(e.data)));}else {const r=L(this.globalScope)?void 0:[],n=e.hasCallback?(e,n)=>{delete this.cancelCallbacks[t],this.target.postMessage({id:t,type:"<response>",sourceMapId:this.mapId,error:e?Fi(e):null,data:Fi(n,r)},r);}:t=>{},i=Li(e.data);if(this.parent[e.type])this.parent[e.type](e.sourceMapId,i,n);else if(this.parent.getWorkerSource){const t=e.type.split(".");this.parent.getWorkerSource(e.sourceMapId,t[0],i.source)[t[1]](i,n);}else n(new Error(`Could not find function ${e.type}`));}}remove(){this.scheduler.remove(),this.target.removeEventListener("message",this.receive,!1);}},t.CanonicalTileID=Dc,t.Color=xe,t.ColorMode=Od,t.CullFaceMode=Gd,t.DEMData=Ld,t.DataConstantProperty=$s,t.DedupedRequest=ny,t.DepthMode=Ud,t.EXTENT=wo,t.Elevation=class{isDataAvailableAtPoint(t){const e=this._source();if(!e||t.y<0||t.y>1)return !1;const r=e.getSource().maxzoom,n=1<<r,i=Math.floor(t.x),s=Math.floor((t.x-i)*n),a=Math.floor(t.y*n),o=this.findDEMTileFor(new Fc(r,i,r,s,a));return !(!o||!o.dem)}getAtPointOrZero(t,e=0){return this.getAtPoint(t,e)||0}getAtPoint(t,e,r=!0){null==e&&(e=null);const n=this._source();if(!n)return e;if(t.y<0||t.y>1)return e;const i=n.getSource().maxzoom,s=1<<i,a=Math.floor(t.x),o=t.x-a,l=new Fc(i,a,i,Math.floor(o*s),Math.floor(t.y*s)),u=this.findDEMTileFor(l);if(!u||!u.dem)return e;const c=u.dem,h=1<<u.tileID.canonical.z,p=(o*h-u.tileID.canonical.x)*c.dim,f=(t.y*h-u.tileID.canonical.y)*c.dim,d=Math.floor(p),y=Math.floor(f);return (r?this.exaggeration():1)*xr(xr(c.get(d,y),c.get(d,y+1),f-y),xr(c.get(d+1,y),c.get(d+1,y+1),f-y),p-d)}getAtTileOffset(t,e,r){const n=1<<t.canonical.z;return this.getAtPointOrZero(new Fo(t.wrap+(t.canonical.x+e/wo)/n,(t.canonical.y+r/wo)/n))}getAtTileOffsetFunc(t,e,r,n){return i=>{const s=this.getAtTileOffset(t,i.x,i.y),a=n.upVector(t.canonical,i.x,i.y);return Vl(a,a,s*n.upVectorScale(t.canonical,e,r).metersToTile),a}}getForTilePoints(t,e,r,n){const i=Yd.create(this,t,n);return !!i&&(e.forEach((t=>{t[2]=this.exaggeration()*i.getElevationAt(t[0],t[1],r);})),!0)}getMinMaxForTile(t){const e=this.findDEMTileFor(t);if(!e||!e.dem)return null;const r=e.dem.tree,n=e.tileID,i=1<<t.canonical.z-n.canonical.z;let s=t.canonical.x/i-n.canonical.x,a=t.canonical.y/i-n.canonical.y,o=0;for(let e=0;e<t.canonical.z-n.canonical.z&&!r.leaves[o];e++){s*=2,a*=2;const t=2*Math.floor(a)+Math.floor(s);o=r.childOffsets[o]+t,s%=1,a%=1;}return {min:this.exaggeration()*r.minimums[o],max:this.exaggeration()*r.maximums[o]}}getMinElevationBelowMSL(){throw new Error("Pure virtual method called.")}raycast(t,e,r){throw new Error("Pure virtual method called.")}pointCoordinate(t){throw new Error("Pure virtual method called.")}_source(){throw new Error("Pure virtual method called.")}exaggeration(){throw new Error("Pure virtual method called.")}findDEMTileFor(t){throw new Error("Pure virtual method called.")}get visibleDemTiles(){throw new Error("Getter must be implemented in subclass.")}},t.ErrorEvent=qt,t.EvaluationParameters=Cs,t.Event=Ot,t.Evented=Nt,t.FillExtrusionBucket=wc,t.Frustum=tu,t.FrustumCorners=Ql,t.GLOBE_METERS_TO_ECEF=Kp,t.GLOBE_RADIUS=Xp,t.GLOBE_SCALE_MATCH_LATITUDE=45,t.GLOBE_ZOOM_THRESHOLD_MAX=6,t.GLOBE_ZOOM_THRESHOLD_MIN=5,t.GlobeSharedBuffers=class{constructor(t){this._createGrid(t),this._createPoles(t);}destroy(){this._poleIndexBuffer.destroy(),this._gridBuffer.destroy(),this._gridIndexBuffer.destroy(),this._poleNorthVertexBuffer.destroy(),this._poleSouthVertexBuffer.destroy();for(const t of this._poleSegments)t.destroy();for(const t of this._gridSegments)t.destroy();if(this._wireframeIndexBuffer){this._wireframeIndexBuffer.destroy();for(const t of this._wireframeSegments)t.destroy();}}_createGrid(t){const e=new Qs,r=new ya,n=65;for(let t=0;t<n;t++)for(let r=0;r<n;r++)e.emplaceBack(r,t);this._gridSegments=[];for(let t=0,e=0;t<Hp.length;t++){const i=Hp[t];for(let t=0;t<i;t++)for(let e=0;e<64;e++){const i=t*n+e;r.emplaceBack(i+1,i,i+n),r.emplaceBack(i+n,i+n+1,i+1);}const s=64*i*2;this._gridSegments.push(_o.simpleSegment(0,e,(i+1)*n,s)),e+=s;}this._gridBuffer=t.createVertexBuffer(e,Zp.members),this._gridIndexBuffer=t.createIndexBuffer(r,!0);}_createPoles(t){const e=new ya;for(let t=0;t<=64;t++)e.emplaceBack(0,t+1,t+2);this._poleIndexBuffer=t.createIndexBuffer(e,!0);const r=new va,n=new va;this._poleSegments=[];for(let t=0,e=0;t<5;t++){const i=360/(1<<t);r.emplaceBack(0,-Xp,0,.5,0),n.emplaceBack(0,-Xp,0,.5,1);for(let t=0;t<=64;t++){const e=t/64,s=xr(0,i,e),[a,o,l]=uf(bf,_f,s,Xp);r.emplaceBack(a,o,l,e,0),n.emplaceBack(a,o,l,e,1);}this._poleSegments.push(_o.simpleSegment(e,0,66,64)),e+=66;}this._poleNorthVertexBuffer=t.createVertexBuffer(r,Np,!1),this._poleSouthVertexBuffer=t.createVertexBuffer(n,Np,!1);}getGridBuffers(t){return [this._gridBuffer,this._gridIndexBuffer,this._gridSegments[t]]}getPoleBuffers(t){return [this._poleNorthVertexBuffer,this._poleSouthVertexBuffer,this._poleIndexBuffer,this._poleSegments[t]]}getWirefameBuffers(t,e){if(!this._wireframeSegments){const e=new _a,r=64,n=r+1;this._wireframeSegments=[];for(let t=0,i=0;t<Hp.length;t++){const s=Hp[t];for(let t=0;t<s;t++)for(let i=0;i<r;i++){const r=t*n+i;e.emplaceBack(r,r+1),e.emplaceBack(r,r+n),e.emplaceBack(r,r+n+1);}const a=s*r*3;this._wireframeSegments.push(_o.simpleSegment(0,i,(s+1)*n,a)),i+=a;}this._wireframeIndexBuffer=t.createIndexBuffer(e);}return [this._gridBuffer,this._wireframeIndexBuffer,this._wireframeSegments[e]]}},t.GlyphManager=vp,t.ImagePosition=Oh,t.LineAtlas=hd,t.LngLat=ko,t.LngLatBounds=Ao,t.LocalGlyphMode=xp,t.MAX_MERCATOR_LATITUDE=Do,t.MercatorCoordinate=Fo,t.ONE_EM=ah,t.OverscaledTileID=Fc,t.Properties=Zs,t.RGBAImage=pu,t.Ray=Jl,t.RequestManager=class{constructor(t,e,r){this._transformRequestFn=t,this._customAccessToken=e,this._silenceAuthErrors=!!r,this._createSkuToken();}_createSkuToken(){const t=function(){let t="";for(let e=0;e<10;e++)t+="0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ"[Math.floor(62*Math.random())];return {token:["1",rt,t].join(""),tokenExpiresAt:Date.now()+432e5}}();this._skuToken=t.token,this._skuTokenExpiresAt=t.tokenExpiresAt;}_isSkuTokenExpired(){return Date.now()>this._skuTokenExpiresAt}transformRequest(t,e){return this._transformRequestFn&&this._transformRequestFn(t,e)||{url:t}}normalizeStyleURL(t,e){if(!it(t))return t;const r=ot(t);return r.path=`/styles/v1${r.path}`,this._makeAPIURL(r,this._customAccessToken||e)}normalizeGlyphsURL(t,e){if(!it(t))return t;const r=ot(t);return r.path=`/fonts/v1${r.path}`,this._makeAPIURL(r,this._customAccessToken||e)}normalizeSourceURL(t,e,r,n){if(!it(t))return t;const i=ot(t);return i.path=`/v4/${i.authority}.json`,i.params.push("secure"),r&&i.params.push(`language=${r}`),n&&i.params.push(`worldview=${n}`),this._makeAPIURL(i,this._customAccessToken||e)}normalizeSpriteURL(t,e,r,n){const i=ot(t);return it(t)?(i.path=`/styles/v1${i.path}/sprite${e}${r}`,this._makeAPIURL(i,this._customAccessToken||n)):(i.path+=`${e}${r}`,lt(i))}normalizeTileURL(t,e,r){if(this._isSkuTokenExpired()&&this._createSkuToken(),t&&!it(t))return t;const n=ot(t);n.path=n.path.replace(/(\.(png|jpg)\d*)(?=$)/,`${e||r&&"raster"!==n.authority&&512===r?"@2x":""}${Y.supported?".webp":"$1"}`),"raster"===n.authority?n.path=`/${H.RASTER_URL_PREFIX}${n.path}`:(n.path=n.path.replace(/^.+\/v4\//,"/"),n.path=`/${H.TILE_URL_VERSION}${n.path}`);const i=this._customAccessToken||function(t){for(const e of t){const t=e.match(/^access_token=(.*)$/);if(t)return t[1]}return null}(n.params)||H.ACCESS_TOKEN;return H.REQUIRE_ACCESS_TOKEN&&i&&this._skuToken&&n.params.push(`sku=${this._skuToken}`),this._makeAPIURL(n,i)}canonicalizeTileURL(t,e){const r=ot(t);if(!r.path.match(/^(\/v4\/|\/raster\/v1\/)/)||!r.path.match(/\.[\w]+$/))return t;let n="mapbox://";r.path.match(/^\/raster\/v1\//)?n+=`raster/${r.path.replace(`/${H.RASTER_URL_PREFIX}/`,"")}`:n+=`tiles/${r.path.replace(`/${H.TILE_URL_VERSION}/`,"")}`;let i=r.params;return e&&(i=i.filter((t=>!t.match(/^access_token=/)))),i.length&&(n+=`?${i.join("&")}`),n}canonicalizeTileset(t,e){const r=!!e&&it(e),n=[];for(const e of t.tiles||[])st(e)?n.push(this.canonicalizeTileURL(e,r)):n.push(e);return n}_makeAPIURL(t,e){const r="See https://www.mapbox.com/api-documentation/#access-tokens-and-token-scopes",n=ot(H.API_URL);if(t.protocol=n.protocol,t.authority=n.authority,"http"===t.protocol){const e=t.params.indexOf("secure");e>=0&&t.params.splice(e,1);}if("/"!==n.path&&(t.path=`${n.path}${t.path}`),!H.REQUIRE_ACCESS_TOKEN)return lt(t);if(e=e||H.ACCESS_TOKEN,!this._silenceAuthErrors){if(!e)throw new Error(`An API access token is required to use Mapbox GL. ${r}`);if("s"===e[0])throw new Error(`Use a public access token (pk.*) with Mapbox GL, not a secret access token (sk.*). ${r}`)}return t.params=t.params.filter((t=>-1===t.indexOf("access_token"))),t.params.push(`access_token=${e||""}`),lt(t)}},t.ResourceType=zt,t.SegmentVector=_o,t.SourceCache=Zd,t.StencilMode=$d,t.StructArrayLayout1ui2=wa,t.StructArrayLayout2f1f2i16=pa,t.StructArrayLayout2i4=Qs,t.StructArrayLayout2ui4=_a,t.StructArrayLayout3f12=da,t.StructArrayLayout3ui6=ya,t.StructArrayLayout4i8=ea,t.StructArrayLayout5f20=va,t.Texture=cd,t.Tile=Id,t.Transitionable=Vs,t.Uniform1f=Wa,t.Uniform1i=class extends Ya{constructor(t){super(t),this.current=0;}set(t,e,r){this.fetchUniformLocation(t,e)&&this.current!==r&&(this.current=r,this.gl.uniform1i(this.location,r));}},t.Uniform2f=class extends Ya{constructor(t){super(t),this.current=[0,0];}set(t,e,r){this.fetchUniformLocation(t,e)&&(r[0]===this.current[0]&&r[1]===this.current[1]||(this.current=r,this.gl.uniform2f(this.location,r[0],r[1])));}},t.Uniform3f=class extends Ya{constructor(t){super(t),this.current=[0,0,0];}set(t,e,r){this.fetchUniformLocation(t,e)&&(r[0]===this.current[0]&&r[1]===this.current[1]&&r[2]===this.current[2]||(this.current=r,this.gl.uniform3f(this.location,r[0],r[1],r[2])));}},t.Uniform4f=Ja,t.UniformColor=Qa,t.UniformMatrix2f=class extends Ya{constructor(t){super(t),this.current=ro;}set(t,e,r){if(this.fetchUniformLocation(t,e))for(let t=0;t<4;t++)if(r[t]!==this.current[t]){this.current=r,this.gl.uniformMatrix2fv(this.location,!1,r);break}}},t.UniformMatrix3f=class extends Ya{constructor(t){super(t),this.current=eo;}set(t,e,r){if(this.fetchUniformLocation(t,e))for(let t=0;t<9;t++)if(r[t]!==this.current[t]){this.current=r,this.gl.uniformMatrix3fv(this.location,!1,r);break}}},t.UniformMatrix4f=class extends Ya{constructor(t){super(t),this.current=to;}set(t,e,r){if(this.fetchUniformLocation(t,e)){if(r[12]!==this.current[12]||r[0]!==this.current[0])return this.current=r,void this.gl.uniformMatrix4fv(this.location,!1,r);for(let t=1;t<16;t++)if(r[t]!==this.current[t]){this.current=r,this.gl.uniformMatrix4fv(this.location,!1,r);break}}}},t.UnwrappedTileID=Vc,t.ValidationError=qn,t.VectorTileWorkerSource=class extends Nt{constructor(t,e,r,n,i){super(),this.actor=t,this.layerIndex=e,this.availableImages=r,this.loadVectorData=i||iy,this.loading={},this.loaded={},this.deduped=new ny(t.scheduler),this.isSpriteLoaded=n,this.scheduler=t.scheduler;}loadTile(t,e){const r=t.uid,n=t&&t.request,i=n&&n.collectResourceTiming,s=this.loading[r]=new ey(t);s.abort=this.loadVectorData(t,((a,o)=>{const l=!this.loading[r];if(delete this.loading[r],l||a||!o)return s.status="done",l||(this.loaded[r]=s),e(a);const u=o.rawData,c={};o.expires&&(c.expires=o.expires),o.cacheControl&&(c.cacheControl=o.cacheControl),s.vectorTile=o.vectorTile||new yc.VectorTile(new xh(u));const h=()=>{s.parse(s.vectorTile,this.layerIndex,this.availableImages,this.actor,((t,r)=>{if(t||!r)return e(t);const s={};if(i){const t=$(n);t.length>0&&(s.resourceTiming=JSON.parse(JSON.stringify(t)));}e(null,v({rawTileData:u.slice(0)},r,c,s));}));};this.isSpriteLoaded?h():this.once("isSpriteLoaded",(()=>{this.scheduler?this.scheduler.add(h,{type:"parseTile",isSymbolTile:t.isSymbolTile,zoom:t.tileZoom}):h();})),this.loaded=this.loaded||{},this.loaded[r]=s;}));}reloadTile(t,e){const r=this.loaded,n=t.uid,i=this;if(r&&r[n]){const s=r[n];s.showCollisionBoxes=t.showCollisionBoxes,s.enableTerrain=!!t.enableTerrain,s.projection=t.projection,s.tileTransform=Af(t.tileID.canonical,t.projection);const a=(t,r)=>{const n=s.reloadCallback;n&&(delete s.reloadCallback,s.parse(s.vectorTile,i.layerIndex,this.availableImages,i.actor,n)),e(t,r);};"parsing"===s.status?s.reloadCallback=a:"done"===s.status&&(s.vectorTile?s.parse(s.vectorTile,this.layerIndex,this.availableImages,this.actor,a):a());}}abortTile(t,e){const r=t.uid,n=this.loading[r];n&&(n.abort&&n.abort(),delete this.loading[r]),e();}removeTile(t,e){const r=this.loaded,n=t.uid;r&&r[n]&&delete r[n],e();}},t.WritingMode=Nh,t.ZoomHistory=Ri,t.add=Bl,t.addDynamicAttributes=Hf,t.adjoint=function(t,e){var r=e[0],n=e[1],i=e[2],s=e[3],a=e[4],o=e[5],l=e[6],u=e[7],c=e[8];return t[0]=a*c-o*u,t[1]=i*u-n*c,t[2]=n*o-i*a,t[3]=o*l-s*c,t[4]=r*c-i*l,t[5]=i*s-r*o,t[6]=s*u-a*l,t[7]=n*l-r*u,t[8]=r*a-n*s,t},t.asyncAll=g,t.bezier=p,t.bindAll=k,t.boundsAttributes=Sd,t.bufferConvexPolygon=function(t,e){const r=[];for(let n=0;n<t.length;n++){const i=m(n-1,-1,t.length-1),s=m(n+1,-1,t.length-1),a=t[n],o=t[s],l=t[i].sub(a).unit(),u=o.sub(a).unit(),c=u.angleWithSep(l.x,l.y),h=l.add(u).unit().mult(-1*e/Math.sin(c/2));r.push(a.add(h));}return r},t.cacheEntryPossiblyAdded=function(t){Mt++,Mt>bt&&(t.getActor().send("enforceCacheSizeLimit",vt),Mt=0);},t.calculateGlobeLabelMatrix=function(t,e){const{x:r,y:n}=t.point,i=mf(r,n,t.worldSize/t._pixelsPerMercatorPixel,0,0);return xl(i,i,yf(rf(e)))},t.calculateGlobeMatrix=function(t){const{x:e,y:r}=t.point,{lng:n,lat:i}=t._center;return mf(e,r,t.worldSize,n,i)},t.calculateGlobeMercatorMatrix=function(t){const e=t.pixelsPerMeter,r=e/Bo(1,t.center.lat),n=ml(new Float64Array(16));return vl(n,n,[t.point.x,t.point.y,0]),bl(n,n,[r,r,e]),Float32Array.from(n)},t.circumferenceAtLatitude=Mo,t.clamp=d,t.clearTileCache=function(t){const e=At(),r=[];for(const t in _t)e&&r.push(e.delete(t)),delete _t[t];t&&Promise.all(r).catch(t).then((()=>t()));},t.clipLine=dp,t.clone=function(t){var e=new dl(16);return e[0]=t[0],e[1]=t[1],e[2]=t[2],e[3]=t[3],e[4]=t[4],e[5]=t[5],e[6]=t[6],e[7]=t[7],e[8]=t[8],e[9]=t[9],e[10]=t[10],e[11]=t[11],e[12]=t[12],e[13]=t[13],e[14]=t[14],e[15]=t[15],e},t.clone$1=T,t.collisionCircleLayout=sh,t.config=H,t.conjugate=function(t,e){return t[0]=-e[0],t[1]=-e[1],t[2]=-e[2],t[3]=e[3],t},t.create=function(){var t=new dl(16);return dl!=Float32Array&&(t[1]=0,t[2]=0,t[3]=0,t[4]=0,t[6]=0,t[7]=0,t[8]=0,t[9]=0,t[11]=0,t[12]=0,t[13]=0,t[14]=0),t[0]=1,t[5]=1,t[10]=1,t[15]=1,t},t.create$1=yl,t.createExpression=Ln,t.createLayout=Ws,t.createStyleLayer=function(t){return "custom"===t.type?new ad(t):new ud[t.type](t)},t.cross=Ul,t.degToRad=l,t.distance=function(t,e){return Math.hypot(e[0]-t[0],e[1]-t[1],e[2]-t[2])},t.div=function(t,e,r){return t[0]=e[0]/r[0],t[1]=e[1]/r[1],t[2]=e[2]/r[2],t},t.dot=Rl,t.ease=f,t.easeCubicInOut=h,t.emitValidationErrors=Ti,t.endsWith=I,t.enforceCacheSizeLimit=function(t){for(const e in _t)St(e),_t[e].then((e=>{e.keys().then((r=>{for(let n=0;n<r.length-t;n++)e.delete(r[n]);}));}));},t.evaluateSizeForFeature=uh,t.evaluateSizeForZoom=ch,t.evaluateVariableOffset=Pp,t.evented=zs,t.exactEquals=function(t,e){return t[0]===e[0]&&t[1]===e[1]&&t[2]===e[2]&&t[3]===e[3]},t.exactEquals$1=function(t,e){return t[0]===e[0]&&t[1]===e[1]&&t[2]===e[2]},t.exported=X,t.exported$1=Y,t.extend=v,t.extend$1=Zt,t.fillExtrusionHeightLift=Tc,t.filterObject=z,t.fromMat4=function(t,e){return t[0]=e[0],t[1]=e[1],t[2]=e[2],t[3]=e[4],t[4]=e[5],t[5]=e[6],t[6]=e[8],t[7]=e[9],t[8]=e[10],t},t.fromQuat=function(t,e){var r=e[0],n=e[1],i=e[2],s=e[3],a=r+r,o=n+n,l=i+i,u=r*a,c=n*a,h=n*o,p=i*a,f=i*o,d=i*l,y=s*a,m=s*o,g=s*l;return t[0]=1-h-d,t[1]=c+g,t[2]=p-m,t[3]=0,t[4]=c-g,t[5]=1-u-d,t[6]=f+y,t[7]=0,t[8]=p+m,t[9]=f-y,t[10]=1-u-h,t[11]=0,t[12]=0,t[13]=0,t[14]=0,t[15]=1,t},t.fromRotation=function(t,e){var r=Math.sin(e),n=Math.cos(e);return t[0]=n,t[1]=r,t[2]=0,t[3]=-r,t[4]=n,t[5]=0,t[6]=0,t[7]=0,t[8]=1,t},t.fromScaling=Al,t.furthestTileCorner=function(t){const e=Math.round((t+45+360)%360/90)%4;return c[e]},t.getAABBPointSquareDist=function(t,e,r){let n=0;for(let i=0;i<2;++i){const s=r?r[i]:0;t[i]>s&&(n+=(t[i]-s)*(t[i]-s)),e[i]<s&&(n+=(s-e[i])*(s-e[i]));}return n},t.getAnchorAlignment=rp,t.getAnchorJustification=Vp,t.getBounds=function(t){let e=1/0,r=1/0,n=-1/0,s=-1/0;for(const i of t)e=Math.min(e,i.x),r=Math.min(r,i.y),n=Math.max(n,i.x),s=Math.max(s,i.y);return {min:new i(e,r),max:new i(n,s)}},t.getColumn=U,t.getGridMatrix=function(t,e,r){const n=e.getNorth(),i=e.getSouth(),s=e.getWest(),a=.015625;return [0,(e.getEast()-s)*a,1<<t.z,(i-n)/Hp[r],0,t.y,n,s,a]},t.getImage=Ut,t.getJSON=function(t,e){return Et(v(t,{type:"json"}),e)},t.getLatitudinalLod=function(t){const e=80.051129;t=d(t,-80.051129,e)/e*90;const r=Math.pow(Math.abs(Math.sin(l(t))),3);return Math.round(r*(Hp.length-1))},t.getMapSessionAPI=mt,t.getPerformanceMeasurement=$,t.getProjection=Nf,t.getRTLTextPluginStatus=Ts,t.getReferrer=Bt,t.getTilePoint=function(t,{x:e,y:r},n=0){return new i(((e-n)*t.scale-t.x)*wo,(r*t.scale-t.y)*wo)},t.getTileVec3=function(t,e,r=0){return Tl(((e.x-r)*t.scale-t.x)*wo,(e.y*t.scale-t.y)*wo,Po(e.z,e.y))},t.getVideo=function(t,r){const n=e.document.createElement("video");n.muted=!0,n.onloadstart=function(){r(null,n);};for(let r=0;r<t.length;r++){const i=e.document.createElement("source");Vt(t[r])||(n.crossOrigin="Anonymous"),i.src=t[r],n.appendChild(i);}return {cancel:()=>{}}},t.globeCenterToScreenPoint=function(t){const e=[0,0,0],r=ml(new Float64Array(16));return xl(r,t.pixelMatrix,t.globeMatrix),jl(e,e,r),new i(e[0],e[1])},t.globeDenormalizeECEF=yf,t.globeECEFOrigin=function(t,e){const r=[0,0,0];return jl(r,r,df(rf(e.canonical))),jl(r,r,t),r},t.globeNormalizeECEF=df,t.globePixelsToTileUnits=function(t,e){return wo/(512*Math.pow(2,t))*pf(rf(e))},t.globePoleMatrixForTile=function(t,e,r){const n=ml(new Float64Array(16)),i=(e/(1<<t)-.5)*Math.PI*2;return wl(n,r.globeMatrix,i),Float32Array.from(n)},t.globeTileBounds=rf,t.globeTiltAtLngLat=xf,t.globeToMercatorTransition=gf,t.globeUseCustomAntiAliasing=function(t,e,r){const n=gf(r.zoom),i=t.style.map._antialias,s=!!e.extStandardDerivatives,a=e.extStandardDerivativesForceOff||t.terrain&&t.terrain.exaggeration()>0;return 0===n&&!i&&!a&&s},t.identity=ml,t.identity$1=Hl,t.invert=gl,t.isFullscreen=function(){return !!e.document.fullscreenElement||!!e.document.webkitFullscreenElement},t.isLngLatBehindGlobe=function(t,e){return xf(t,e)>Math.PI/2*1.01},t.isMapAuthenticated=function(t){return gt.has(t)},t.isMapboxURL=it,t.isSafariWithAntialiasingBug=function(t){const e=t.navigator?t.navigator.userAgent:null;return !!L(t)&&e&&(e.match("Version/15.4")||e.match("Version/15.5")||e.match(/CPU (OS|iPhone OS) (15_4|15_5) like Mac OS X/))},t.latFromMercatorY=Co,t.len=Gl,t.length=zl,t.length$1=function(t){return Math.hypot(t[0],t[1],t[2],t[3])},t.loadVectorTile=iy,t.makeRequest=Et,t.mapValue=function(t,e,r,n,i){return d((t-e)/(r-e)*(i-n)+n,n,i)},t.mercatorScale=Vo,t.mercatorXfromLng=zo,t.mercatorYfromLat=To,t.mercatorZfromAltitude=Bo,t.mul=kl,t.mul$1=Nl,t.multiply=xl,t.multiply$1=function(t,e,r){var n=e[0],i=e[1],s=e[2],a=e[3],o=e[4],l=e[5],u=e[6],c=e[7],h=e[8],p=r[0],f=r[1],d=r[2],y=r[3],m=r[4],g=r[5],x=r[6],v=r[7],b=r[8];return t[0]=p*n+f*a+d*u,t[1]=p*i+f*o+d*c,t[2]=p*s+f*l+d*h,t[3]=y*n+m*a+g*u,t[4]=y*i+m*o+g*c,t[5]=y*s+m*l+g*h,t[6]=x*n+v*a+b*u,t[7]=x*i+v*o+b*c,t[8]=x*s+v*l+b*h,t},t.multiply$2=Cl,t.nextPowerOfTwo=A,t.normalize=Ll,t.normalize$1=function(t,e){var r=e[0],n=e[1],i=e[2],s=e[3],a=r*r+n*n+i*i+s*s;return a>0&&(a=1/Math.sqrt(a)),t[0]=r*a,t[1]=n*a,t[2]=i*a,t[3]=s*a,t},t.number=xr,t.ortho=function(t,e,r,n,i,s,a){var o=1/(e-r),l=1/(n-i),u=1/(s-a);return t[0]=-2*o,t[1]=0,t[2]=0,t[3]=0,t[4]=0,t[5]=-2*l,t[6]=0,t[7]=0,t[8]=0,t[9]=0,t[10]=2*u,t[11]=0,t[12]=(e+r)*o,t[13]=(i+n)*l,t[14]=(a+s)*u,t[15]=1,t},t.pbf=xh,t.perspective=function(t,e,r,n,i){var s,a=1/Math.tan(e/2);return t[0]=a/r,t[1]=0,t[2]=0,t[3]=0,t[4]=0,t[5]=a,t[6]=0,t[7]=0,t[8]=0,t[9]=0,t[11]=-1,t[12]=0,t[13]=0,t[15]=0,null!=i&&i!==1/0?(t[10]=(i+n)*(s=1/(n-i)),t[14]=2*i*n*s):(t[10]=-1,t[14]=-2*n),t},t.pick=function(t,e){const r={};for(let n=0;n<e.length;n++){const i=e[n];i in t&&(r[i]=t[i]);}return r},t.plugin=Es,t.pointGeometry=i,t.polygonContainsPoint=il,t.polygonIntersectsBox=sl,t.polygonIntersectsPolygon=Ho,t.polygonizeBounds=function(t,e,r=0,n=!0){const s=new i(r,r),a=t.sub(s),o=e.add(s),l=[a,new i(o.x,a.y),o,new i(a.x,o.y)];return n&&l.push(a.clone()),l},t.posAttributes=Zp,t.postMapLoadEvent=dt,t.postTurnstileEvent=pt,t.potpack=$h,t.prevPowerOfTwo=function(t){return t<=1?1:Math.pow(2,Math.floor(Math.log(t)/Math.LN2))},t.radToDeg=u,t.refProperties=["type","source","source-layer","minzoom","maxzoom","filter","layout"],t.registerForPluginStateChange=function(t){return t({pluginStatus:Ss,pluginURL:ks}),zs.on("pluginStateChange",t),t},t.removeAuthState=function(t){gt.delete(t);},t.renderColorRamp=du,t.resample=Ro,t.rotateX=_l,t.rotateX$1=Yl,t.rotateY=wl,t.rotateY$1=Wl,t.rotateZ=function(t,e,r){var n=Math.sin(r),i=Math.cos(r),s=e[0],a=e[1],o=e[2],l=e[3],u=e[4],c=e[5],h=e[6],p=e[7];return e!==t&&(t[8]=e[8],t[9]=e[9],t[10]=e[10],t[11]=e[11],t[12]=e[12],t[13]=e[13],t[14]=e[14],t[15]=e[15]),t[0]=s*i+u*n,t[1]=a*i+c*n,t[2]=o*i+h*n,t[3]=l*i+p*n,t[4]=u*i-s*n,t[5]=c*i-a*n,t[6]=h*i-o*n,t[7]=p*i-l*n,t},t.rotateZ$1=function(t,e,r){r*=.5;var n=e[0],i=e[1],s=e[2],a=e[3],o=Math.sin(r),l=Math.cos(r);return t[0]=n*l+i*o,t[1]=i*l-n*o,t[2]=s*l+a*o,t[3]=a*l-s*o,t},t.scale=bl,t.scale$1=Zl,t.scale$2=Vl,t.scaleAndAdd=Fl,t.setCacheLimits=function(t,e){vt=t,bt=e;},t.setColumn=function(t,e,r){t[4*e+0]=r[0],t[4*e+1]=r[1],t[4*e+2]=r[2],t[4*e+3]=r[3];},t.setRTLTextPlugin=function(t,e,r=!1){if(Ss===bs||Ss===_s||Ss===ws)throw new Error("setRTLTextPlugin cannot be called multiple times.");ks=X.resolveURL(t),Ss=bs,As=e,Ms(),r||Bs();},t.smoothstep=y,t.spec=Gt,t.storeAuthState=function(t,e){e?gt.add(t):gt.delete(t);},t.sub=ql,t.subtract=El,t.symbolSize=hh,t.tileAABB=function(t,e,r,n,i,s,a,o,l){if("globe"===l.name)return af(t,e,new Dc(r,n,i));const u=Af({z:r,x:n,y:i},l);return new eu([(s+u.x/u.scale)*e,e*(u.y/u.scale),a],[(s+u.x2/u.scale)*e,e*(u.y2/u.scale),o])},t.tileCornersToBounds=of,t.tileTransform=Af,t.transformMat3=function(t,e,r){var n=e[0],i=e[1],s=e[2];return t[0]=n*r[0]+i*r[3]+s*r[6],t[1]=n*r[1]+i*r[4]+s*r[7],t[2]=n*r[2]+i*r[5]+s*r[8],t},t.transformMat4=jl,t.transformMat4$1=Xl,t.transformQuat=$l,t.transitionTileAABBinECEF=nf,t.translate=vl,t.transpose=function(t,e){if(t===e){var r=e[1],n=e[2],i=e[5];t[1]=e[3],t[2]=e[6],t[3]=r,t[5]=e[7],t[6]=n,t[7]=i;}else t[0]=e[0],t[1]=e[3],t[2]=e[6],t[3]=e[1],t[4]=e[4],t[5]=e[7],t[6]=e[2],t[7]=e[5],t[8]=e[8];return t},t.triggerPluginCompletionEvent=Is,t.uniqueId=_,t.updateGlobeVertexNormal=function(t,e,r,n,i){const s=5*e+2;t.float32[s+0]=r,t.float32[s+1]=n,t.float32[s+2]=i;},t.validateCustomStyleLayer=function(t){const e=[],r=t.id;return void 0===r&&e.push({message:`layers.${r}: missing required property "id"`}),void 0===t.render&&e.push({message:`layers.${r}: missing required method "render"`}),t.renderingMode&&"2d"!==t.renderingMode&&"3d"!==t.renderingMode&&e.push({message:`layers.${r}: property "renderingMode" must be either "2d" or "3d"`}),e},t.validateFilter=t=>zi(ci(t)),t.validateFog=t=>zi(_i(t)),t.validateLayer=t=>zi(yi(t)),t.validateLight=t=>zi(vi(t)),t.validateSource=t=>zi(xi(t)),t.validateStyle=ki,t.validateTerrain=t=>zi(bi(t)),t.values=x,t.vectorTile=yc,t.version=O,t.warnOnce=E,t.window=e,t.wrap=m;}));

	define(["./shared"],(function(e){function t(e){if("number"==typeof e||"boolean"==typeof e||"string"==typeof e||null==e)return JSON.stringify(e);if(Array.isArray(e)){let r="[";for(const o of e)r+=`${t(o)},`;return `${r}]`}let r="{";for(const o of Object.keys(e).sort())r+=`${o}:${t(e[o])},`;return `${r}}`}function r(r){let o="";for(const n of e.refProperties)o+=`/${t(r[n])}`;return o}class o{constructor(e){this.keyCache={},e&&this.replace(e);}replace(e){this._layerConfigs={},this._layers={},this.update(e,[]);}update(t,o){for(const r of t)this._layerConfigs[r.id]=r,(this._layers[r.id]=e.createStyleLayer(r)).compileFilter(),this.keyCache[r.id]&&delete this.keyCache[r.id];for(const e of o)delete this.keyCache[e],delete this._layerConfigs[e],delete this._layers[e];this.familiesBySource={};const n=function(e,t){const o={};for(let n=0;n<e.length;n++){const i=t&&t[e[n].id]||r(e[n]);t&&(t[e[n].id]=i);let s=o[i];s||(s=o[i]=[]),s.push(e[n]);}const n=[];for(const e in o)n.push(o[e]);return n}(e.values(this._layerConfigs),this.keyCache);for(const e of n){const t=e.map((e=>this._layers[e.id])),r=t[0];if("none"===r.visibility)continue;const o=r.source||"";let n=this.familiesBySource[o];n||(n=this.familiesBySource[o]={});const i=r.sourceLayer||"_geojsonTileLayer";let s=n[i];s||(s=n[i]=[]),s.push(t);}}}class n{loadTile(t,r){const{uid:o,encoding:n,rawImageData:i,padding:s,buildQuadTree:a}=t,l=e.window.ImageBitmap&&i instanceof e.window.ImageBitmap?this.getImageData(i,s):i;r(null,new e.DEMData(o,l,n,s<1,a));}getImageData(e,t){this.offscreenCanvas&&this.offscreenCanvasContext||(this.offscreenCanvas=new OffscreenCanvas(e.width,e.height),this.offscreenCanvasContext=this.offscreenCanvas.getContext("2d")),this.offscreenCanvas.width=e.width,this.offscreenCanvas.height=e.height,this.offscreenCanvasContext.drawImage(e,0,0,e.width,e.height);const r=this.offscreenCanvasContext.getImageData(-t,-t,e.width+2*t,e.height+2*t);return this.offscreenCanvasContext.clearRect(0,0,this.offscreenCanvas.width,this.offscreenCanvas.height),r}}var i=function e(t,r){var o,n=t&&t.type;if("FeatureCollection"===n)for(o=0;o<t.features.length;o++)e(t.features[o],r);else if("GeometryCollection"===n)for(o=0;o<t.geometries.length;o++)e(t.geometries[o],r);else if("Feature"===n)e(t.geometry,r);else if("Polygon"===n)s(t.coordinates,r);else if("MultiPolygon"===n)for(o=0;o<t.coordinates.length;o++)s(t.coordinates[o],r);return t};function s(e,t){if(0!==e.length){a(e[0],t);for(var r=1;r<e.length;r++)a(e[r],!t);}}function a(e,t){for(var r=0,o=0,n=0,i=e.length,s=i-1;n<i;s=n++){var a=(e[n][0]-e[s][0])*(e[s][1]+e[n][1]),l=r+a;o+=Math.abs(r)>=Math.abs(a)?r-l+a:a-l+r,r=l;}r+o>=0!=!!t&&e.reverse();}const l=e.vectorTile.VectorTileFeature.prototype.toGeoJSON;class u{constructor(t){this._feature=t,this.extent=e.EXTENT,this.type=t.type,this.properties=t.tags,"id"in t&&!isNaN(t.id)&&(this.id=parseInt(t.id,10));}loadGeometry(){if(1===this._feature.type){const t=[];for(const r of this._feature.geometry)t.push([new e.pointGeometry(r[0],r[1])]);return t}{const t=[];for(const r of this._feature.geometry){const o=[];for(const t of r)o.push(new e.pointGeometry(t[0],t[1]));t.push(o);}return t}}toGeoJSON(e,t,r){return l.call(this,e,t,r)}}class h{constructor(t){this.layers={_geojsonTileLayer:this},this.name="_geojsonTileLayer",this.extent=e.EXTENT,this.length=t.length,this._features=t;}feature(e){return new u(this._features[e])}}var c=e.vectorTile.VectorTileFeature,f=p;function p(e,t){this.options=t||{},this.features=e,this.length=e.length;}function g(e,t){this.id="number"==typeof e.id?e.id:void 0,this.type=e.type,this.rawGeometry=1===e.type?[e.geometry]:e.geometry,this.properties=e.tags,this.extent=t||4096;}p.prototype.feature=function(e){return new g(this.features[e],this.options.extent)},g.prototype.loadGeometry=function(){var t=this.rawGeometry;this.geometry=[];for(var r=0;r<t.length;r++){for(var o=t[r],n=[],i=0;i<o.length;i++)n.push(new e.pointGeometry(o[i][0],o[i][1]));this.geometry.push(n);}return this.geometry},g.prototype.bbox=function(){this.geometry||this.loadGeometry();for(var e=this.geometry,t=1/0,r=-1/0,o=1/0,n=-1/0,i=0;i<e.length;i++)for(var s=e[i],a=0;a<s.length;a++){var l=s[a];t=Math.min(t,l.x),r=Math.max(r,l.x),o=Math.min(o,l.y),n=Math.max(n,l.y);}return [t,o,r,n]},g.prototype.toGeoJSON=c.prototype.toGeoJSON;var d=y,m=f;function y(t){var r=new e.pbf;return function(e,t){for(var r in e.layers)t.writeMessage(3,v,e.layers[r]);}(t,r),r.finish()}function v(e,t){var r;t.writeVarintField(15,e.version||1),t.writeStringField(1,e.name||""),t.writeVarintField(5,e.extent||4096);var o={keys:[],values:[],keycache:{},valuecache:{}};for(r=0;r<e.length;r++)o.feature=e.feature(r),t.writeMessage(2,x,o);var n=o.keys;for(r=0;r<n.length;r++)t.writeStringField(3,n[r]);var i=o.values;for(r=0;r<i.length;r++)t.writeMessage(4,b,i[r]);}function x(e,t){var r=e.feature;void 0!==r.id&&t.writeVarintField(1,r.id),t.writeMessage(2,w,e),t.writeVarintField(3,r.type),t.writeMessage(4,P,r);}function w(e,t){var r=e.feature,o=e.keys,n=e.values,i=e.keycache,s=e.valuecache;for(var a in r.properties){var l=r.properties[a],u=i[a];if(null!==l){void 0===u&&(o.push(a),i[a]=u=o.length-1),t.writeVarint(u);var h=typeof l;"string"!==h&&"boolean"!==h&&"number"!==h&&(l=JSON.stringify(l));var c=h+":"+l,f=s[c];void 0===f&&(n.push(l),s[c]=f=n.length-1),t.writeVarint(f);}}}function S(e,t){return (t<<3)+(7&e)}function M(e){return e<<1^e>>31}function P(e,t){for(var r=e.loadGeometry(),o=e.type,n=0,i=0,s=r.length,a=0;a<s;a++){var l=r[a],u=1;1===o&&(u=l.length),t.writeVarint(S(1,u));for(var h=3===o?l.length-1:l.length,c=0;c<h;c++){1===c&&1!==o&&t.writeVarint(S(2,h-1));var f=l[c].x-n,p=l[c].y-i;t.writeVarint(M(f)),t.writeVarint(M(p)),n+=f,i+=p;}3===o&&t.writeVarint(S(7,1));}}function b(e,t){var r=typeof e;"string"===r?t.writeStringField(1,e):"boolean"===r?t.writeBooleanField(7,e):"number"===r&&(e%1!=0?t.writeDoubleField(3,e):e<0?t.writeSVarintField(6,e):t.writeVarintField(5,e));}function T(e,t,r,o,n,i){if(n-o<=r)return;const s=o+n>>1;k(e,t,s,o,n,i%2),T(e,t,r,o,s-1,i+1),T(e,t,r,s+1,n,i+1);}function k(e,t,r,o,n,i){for(;n>o;){if(n-o>600){const s=n-o+1,a=r-o+1,l=Math.log(s),u=.5*Math.exp(2*l/3),h=.5*Math.sqrt(l*u*(s-u)/s)*(a-s/2<0?-1:1);k(e,t,r,Math.max(o,Math.floor(r-a*u/s+h)),Math.min(n,Math.floor(r+(s-a)*u/s+h)),i);}const s=t[2*r+i];let a=o,l=n;for(I(e,t,o,r),t[2*n+i]>s&&I(e,t,o,n);a<l;){for(I(e,t,a,l),a++,l--;t[2*a+i]<s;)a++;for(;t[2*l+i]>s;)l--;}t[2*o+i]===s?I(e,t,o,l):(l++,I(e,t,l,n)),l<=r&&(o=l+1),r<=l&&(n=l-1);}}function I(e,t,r,o){_(e,r,o),_(t,2*r,2*o),_(t,2*r+1,2*o+1);}function _(e,t,r){const o=e[t];e[t]=e[r],e[r]=o;}function L(e,t,r,o){const n=e-r,i=t-o;return n*n+i*i}d.fromVectorTileJs=y,d.fromGeojsonVt=function(e,t){t=t||{};var r={};for(var o in e)r[o]=new f(e[o].features,t),r[o].name=o,r[o].version=t.version,r[o].extent=t.extent;return y({layers:r})},d.GeoJSONWrapper=m;const C=e=>e[0],O=e=>e[1];class z{constructor(e,t=C,r=O,o=64,n=Float64Array){this.nodeSize=o,this.points=e;const i=e.length<65536?Uint16Array:Uint32Array,s=this.ids=new i(e.length),a=this.coords=new n(2*e.length);for(let o=0;o<e.length;o++)s[o]=o,a[2*o]=t(e[o]),a[2*o+1]=r(e[o]);T(s,a,o,0,s.length-1,0);}range(e,t,r,o){return function(e,t,r,o,n,i,s){const a=[0,e.length-1,0],l=[];let u,h;for(;a.length;){const c=a.pop(),f=a.pop(),p=a.pop();if(f-p<=s){for(let s=p;s<=f;s++)u=t[2*s],h=t[2*s+1],u>=r&&u<=n&&h>=o&&h<=i&&l.push(e[s]);continue}const g=Math.floor((p+f)/2);u=t[2*g],h=t[2*g+1],u>=r&&u<=n&&h>=o&&h<=i&&l.push(e[g]);const d=(c+1)%2;(0===c?r<=u:o<=h)&&(a.push(p),a.push(g-1),a.push(d)),(0===c?n>=u:i>=h)&&(a.push(g+1),a.push(f),a.push(d));}return l}(this.ids,this.coords,e,t,r,o,this.nodeSize)}within(e,t,r){return function(e,t,r,o,n,i){const s=[0,e.length-1,0],a=[],l=n*n;for(;s.length;){const u=s.pop(),h=s.pop(),c=s.pop();if(h-c<=i){for(let n=c;n<=h;n++)L(t[2*n],t[2*n+1],r,o)<=l&&a.push(e[n]);continue}const f=Math.floor((c+h)/2),p=t[2*f],g=t[2*f+1];L(p,g,r,o)<=l&&a.push(e[f]);const d=(u+1)%2;(0===u?r-n<=p:o-n<=g)&&(s.push(c),s.push(f-1),s.push(d)),(0===u?r+n>=p:o+n>=g)&&(s.push(f+1),s.push(h),s.push(d));}return a}(this.ids,this.coords,e,t,r,this.nodeSize)}}const E={minZoom:0,maxZoom:16,minPoints:2,radius:40,extent:512,nodeSize:64,log:!1,generateId:!1,reduce:null,map:e=>e},F=Math.fround||(N=new Float32Array(1),e=>(N[0]=+e,N[0]));var N;class j{constructor(e){this.options=A(Object.create(E),e),this.trees=new Array(this.options.maxZoom+1);}load(e){const{log:t,minZoom:r,maxZoom:o,nodeSize:n}=this.options;t&&console.time("total time");const i=`prepare ${e.length} points`;t&&console.time(i),this.points=e;let s=[];for(let t=0;t<e.length;t++)e[t].geometry&&s.push(G(e[t],t));this.trees[o+1]=new z(s,D,$,n,Float32Array),t&&console.timeEnd(i);for(let e=o;e>=r;e--){const r=+Date.now();s=this._cluster(s,e),this.trees[e]=new z(s,D,$,n,Float32Array),t&&console.log("z%d: %d clusters in %dms",e,s.length,+Date.now()-r);}return t&&console.timeEnd("total time"),this}getClusters(e,t){let r=((e[0]+180)%360+360)%360-180;const o=Math.max(-90,Math.min(90,e[1]));let n=180===e[2]?180:((e[2]+180)%360+360)%360-180;const i=Math.max(-90,Math.min(90,e[3]));if(e[2]-e[0]>=360)r=-180,n=180;else if(r>n){const e=this.getClusters([r,o,180,i],t),s=this.getClusters([-180,o,n,i],t);return e.concat(s)}const s=this.trees[this._limitZoom(t)],a=s.range(Y(r),X(i),Y(n),X(o)),l=[];for(const e of a){const t=s.points[e];l.push(t.numPoints?J(t):this.points[t.index]);}return l}getChildren(e){const t=this._getOriginId(e),r=this._getOriginZoom(e),o="No cluster with the specified id.",n=this.trees[r];if(!n)throw new Error(o);const i=n.points[t];if(!i)throw new Error(o);const s=this.options.radius/(this.options.extent*Math.pow(2,r-1)),a=n.within(i.x,i.y,s),l=[];for(const t of a){const r=n.points[t];r.parentId===e&&l.push(r.numPoints?J(r):this.points[r.index]);}if(0===l.length)throw new Error(o);return l}getLeaves(e,t,r){const o=[];return this._appendLeaves(o,e,t=t||10,r=r||0,0),o}getTile(e,t,r){const o=this.trees[this._limitZoom(e)],n=Math.pow(2,e),{extent:i,radius:s}=this.options,a=s/i,l=(r-a)/n,u=(r+1+a)/n,h={features:[]};return this._addTileFeatures(o.range((t-a)/n,l,(t+1+a)/n,u),o.points,t,r,n,h),0===t&&this._addTileFeatures(o.range(1-a/n,l,1,u),o.points,n,r,n,h),t===n-1&&this._addTileFeatures(o.range(0,l,a/n,u),o.points,-1,r,n,h),h.features.length?h:null}getClusterExpansionZoom(e){let t=this._getOriginZoom(e)-1;for(;t<=this.options.maxZoom;){const r=this.getChildren(e);if(t++,1!==r.length)break;e=r[0].properties.cluster_id;}return t}_appendLeaves(e,t,r,o,n){const i=this.getChildren(t);for(const t of i){const i=t.properties;if(i&&i.cluster?n+i.point_count<=o?n+=i.point_count:n=this._appendLeaves(e,i.cluster_id,r,o,n):n<o?n++:e.push(t),e.length===r)break}return n}_addTileFeatures(e,t,r,o,n,i){for(const s of e){const e=t[s],a=e.numPoints;let l,u,h;if(a)l=W(e),u=e.x,h=e.y;else {const t=this.points[e.index];l=t.properties,u=Y(t.geometry.coordinates[0]),h=X(t.geometry.coordinates[1]);}const c={type:1,geometry:[[Math.round(this.options.extent*(u*n-r)),Math.round(this.options.extent*(h*n-o))]],tags:l};let f;a?f=e.id:this.options.generateId?f=e.index:this.points[e.index].id&&(f=this.points[e.index].id),void 0!==f&&(c.id=f),i.features.push(c);}}_limitZoom(e){return Math.max(this.options.minZoom,Math.min(+e,this.options.maxZoom+1))}_cluster(e,t){const r=[],{radius:o,extent:n,reduce:i,minPoints:s}=this.options,a=o/(n*Math.pow(2,t));for(let o=0;o<e.length;o++){const n=e[o];if(n.zoom<=t)continue;n.zoom=t;const l=this.trees[t+1],u=l.within(n.x,n.y,a),h=n.numPoints||1;let c=h;for(const e of u){const r=l.points[e];r.zoom>t&&(c+=r.numPoints||1);}if(c>h&&c>=s){let e=n.x*h,s=n.y*h,a=i&&h>1?this._map(n,!0):null;const f=(o<<5)+(t+1)+this.points.length;for(const r of u){const o=l.points[r];if(o.zoom<=t)continue;o.zoom=t;const u=o.numPoints||1;e+=o.x*u,s+=o.y*u,o.parentId=f,i&&(a||(a=this._map(n,!0)),i(a,this._map(o)));}n.parentId=f,r.push(Z(e/c,s/c,f,c,a));}else if(r.push(n),c>1)for(const e of u){const o=l.points[e];o.zoom<=t||(o.zoom=t,r.push(o));}}return r}_getOriginId(e){return e-this.points.length>>5}_getOriginZoom(e){return (e-this.points.length)%32}_map(e,t){if(e.numPoints)return t?A({},e.properties):e.properties;const r=this.points[e.index].properties,o=this.options.map(r);return t&&o===r?A({},o):o}}function Z(e,t,r,o,n){return {x:F(e),y:F(t),zoom:1/0,id:r,parentId:-1,numPoints:o,properties:n}}function G(e,t){const[r,o]=e.geometry.coordinates;return {x:F(Y(r)),y:F(X(o)),zoom:1/0,index:t,parentId:-1}}function J(e){return {type:"Feature",id:e.id,properties:W(e),geometry:{type:"Point",coordinates:[(t=e.x,360*(t-.5)),V(e.y)]}};var t;}function W(e){const t=e.numPoints,r=t>=1e4?`${Math.round(t/1e3)}k`:t>=1e3?Math.round(t/100)/10+"k":t;return A(A({},e.properties),{cluster:!0,cluster_id:e.id,point_count:t,point_count_abbreviated:r})}function Y(e){return e/360+.5}function X(e){const t=Math.sin(e*Math.PI/180),r=.5-.25*Math.log((1+t)/(1-t))/Math.PI;return r<0?0:r>1?1:r}function V(e){const t=(180-360*e)*Math.PI/180;return 360*Math.atan(Math.exp(t))/Math.PI-90}function A(e,t){for(const r in t)e[r]=t[r];return e}function D(e){return e.x}function $(e){return e.y}function B(e,t,r,o){for(var n,i=o,s=r-t>>1,a=r-t,l=e[t],u=e[t+1],h=e[r],c=e[r+1],f=t+3;f<r;f+=3){var p=R(e[f],e[f+1],l,u,h,c);if(p>i)n=f,i=p;else if(p===i){var g=Math.abs(f-s);g<a&&(n=f,a=g);}}i>o&&(n-t>3&&B(e,t,n,o),e[n+2]=i,r-n>3&&B(e,n,r,o));}function R(e,t,r,o,n,i){var s=n-r,a=i-o;if(0!==s||0!==a){var l=((e-r)*s+(t-o)*a)/(s*s+a*a);l>1?(r=n,o=i):l>0&&(r+=s*l,o+=a*l);}return (s=e-r)*s+(a=t-o)*a}function q(e,t,r,o){var n={id:void 0===e?null:e,type:t,geometry:r,tags:o,minX:1/0,minY:1/0,maxX:-1/0,maxY:-1/0};return function(e){var t=e.geometry,r=e.type;if("Point"===r||"MultiPoint"===r||"LineString"===r)U(e,t);else if("Polygon"===r||"MultiLineString"===r)for(var o=0;o<t.length;o++)U(e,t[o]);else if("MultiPolygon"===r)for(o=0;o<t.length;o++)for(var n=0;n<t[o].length;n++)U(e,t[o][n]);}(n),n}function U(e,t){for(var r=0;r<t.length;r+=3)e.minX=Math.min(e.minX,t[r]),e.minY=Math.min(e.minY,t[r+1]),e.maxX=Math.max(e.maxX,t[r]),e.maxY=Math.max(e.maxY,t[r+1]);}function Q(e,t,r,o){if(t.geometry){var n=t.geometry.coordinates,i=t.geometry.type,s=Math.pow(r.tolerance/((1<<r.maxZoom)*r.extent),2),a=[],l=t.id;if(r.promoteId?l=t.properties[r.promoteId]:r.generateId&&(l=o||0),"Point"===i)H(n,a);else if("MultiPoint"===i)for(var u=0;u<n.length;u++)H(n[u],a);else if("LineString"===i)K(n,a,s,!1);else if("MultiLineString"===i){if(r.lineMetrics){for(u=0;u<n.length;u++)K(n[u],a=[],s,!1),e.push(q(l,"LineString",a,t.properties));return}ee(n,a,s,!1);}else if("Polygon"===i)ee(n,a,s,!0);else {if("MultiPolygon"!==i){if("GeometryCollection"===i){for(u=0;u<t.geometry.geometries.length;u++)Q(e,{id:l,geometry:t.geometry.geometries[u],properties:t.properties},r,o);return}throw new Error("Input data is not a valid GeoJSON object.")}for(u=0;u<n.length;u++){var h=[];ee(n[u],h,s,!0),a.push(h);}}e.push(q(l,i,a,t.properties));}}function H(e,t){t.push(te(e[0])),t.push(re(e[1])),t.push(0);}function K(e,t,r,o){for(var n,i,s=0,a=0;a<e.length;a++){var l=te(e[a][0]),u=re(e[a][1]);t.push(l),t.push(u),t.push(0),a>0&&(s+=o?(n*u-l*i)/2:Math.sqrt(Math.pow(l-n,2)+Math.pow(u-i,2))),n=l,i=u;}var h=t.length-3;t[2]=1,B(t,0,h,r),t[h+2]=1,t.size=Math.abs(s),t.start=0,t.end=t.size;}function ee(e,t,r,o){for(var n=0;n<e.length;n++){var i=[];K(e[n],i,r,o),t.push(i);}}function te(e){return e/360+.5}function re(e){var t=Math.sin(e*Math.PI/180),r=.5-.25*Math.log((1+t)/(1-t))/Math.PI;return r<0?0:r>1?1:r}function oe(e,t,r,o,n,i,s,a){if(o/=t,i>=(r/=t)&&s<o)return e;if(s<r||i>=o)return null;for(var l=[],u=0;u<e.length;u++){var h=e[u],c=h.geometry,f=h.type,p=0===n?h.minX:h.minY,g=0===n?h.maxX:h.maxY;if(p>=r&&g<o)l.push(h);else if(!(g<r||p>=o)){var d=[];if("Point"===f||"MultiPoint"===f)ne(c,d,r,o,n);else if("LineString"===f)ie(c,d,r,o,n,!1,a.lineMetrics);else if("MultiLineString"===f)ae(c,d,r,o,n,!1);else if("Polygon"===f)ae(c,d,r,o,n,!0);else if("MultiPolygon"===f)for(var m=0;m<c.length;m++){var y=[];ae(c[m],y,r,o,n,!0),y.length&&d.push(y);}if(d.length){if(a.lineMetrics&&"LineString"===f){for(m=0;m<d.length;m++)l.push(q(h.id,f,d[m],h.tags));continue}"LineString"!==f&&"MultiLineString"!==f||(1===d.length?(f="LineString",d=d[0]):f="MultiLineString"),"Point"!==f&&"MultiPoint"!==f||(f=3===d.length?"Point":"MultiPoint"),l.push(q(h.id,f,d,h.tags));}}}return l.length?l:null}function ne(e,t,r,o,n){for(var i=0;i<e.length;i+=3){var s=e[i+n];s>=r&&s<=o&&(t.push(e[i]),t.push(e[i+1]),t.push(e[i+2]));}}function ie(e,t,r,o,n,i,s){for(var a,l,u=se(e),h=0===n?ue:he,c=e.start,f=0;f<e.length-3;f+=3){var p=e[f],g=e[f+1],d=e[f+2],m=e[f+3],y=e[f+4],v=0===n?p:g,x=0===n?m:y,w=!1;s&&(a=Math.sqrt(Math.pow(p-m,2)+Math.pow(g-y,2))),v<r?x>r&&(l=h(u,p,g,m,y,r),s&&(u.start=c+a*l)):v>o?x<o&&(l=h(u,p,g,m,y,o),s&&(u.start=c+a*l)):le(u,p,g,d),x<r&&v>=r&&(l=h(u,p,g,m,y,r),w=!0),x>o&&v<=o&&(l=h(u,p,g,m,y,o),w=!0),!i&&w&&(s&&(u.end=c+a*l),t.push(u),u=se(e)),s&&(c+=a);}var S=e.length-3;p=e[S],g=e[S+1],d=e[S+2],(v=0===n?p:g)>=r&&v<=o&&le(u,p,g,d),S=u.length-3,i&&S>=3&&(u[S]!==u[0]||u[S+1]!==u[1])&&le(u,u[0],u[1],u[2]),u.length&&t.push(u);}function se(e){var t=[];return t.size=e.size,t.start=e.start,t.end=e.end,t}function ae(e,t,r,o,n,i){for(var s=0;s<e.length;s++)ie(e[s],t,r,o,n,i,!1);}function le(e,t,r,o){e.push(t),e.push(r),e.push(o);}function ue(e,t,r,o,n,i){var s=(i-t)/(o-t);return e.push(i),e.push(r+(n-r)*s),e.push(1),s}function he(e,t,r,o,n,i){var s=(i-r)/(n-r);return e.push(t+(o-t)*s),e.push(i),e.push(1),s}function ce(e,t){for(var r=[],o=0;o<e.length;o++){var n,i=e[o],s=i.type;if("Point"===s||"MultiPoint"===s||"LineString"===s)n=fe(i.geometry,t);else if("MultiLineString"===s||"Polygon"===s){n=[];for(var a=0;a<i.geometry.length;a++)n.push(fe(i.geometry[a],t));}else if("MultiPolygon"===s)for(n=[],a=0;a<i.geometry.length;a++){for(var l=[],u=0;u<i.geometry[a].length;u++)l.push(fe(i.geometry[a][u],t));n.push(l);}r.push(q(i.id,s,n,i.tags));}return r}function fe(e,t){var r=[];r.size=e.size,void 0!==e.start&&(r.start=e.start,r.end=e.end);for(var o=0;o<e.length;o+=3)r.push(e[o]+t,e[o+1],e[o+2]);return r}function pe(e,t){if(e.transformed)return e;var r,o,n,i=1<<e.z,s=e.x,a=e.y;for(r=0;r<e.features.length;r++){var l=e.features[r],u=l.geometry,h=l.type;if(l.geometry=[],1===h)for(o=0;o<u.length;o+=2)l.geometry.push(ge(u[o],u[o+1],t,i,s,a));else for(o=0;o<u.length;o++){var c=[];for(n=0;n<u[o].length;n+=2)c.push(ge(u[o][n],u[o][n+1],t,i,s,a));l.geometry.push(c);}}return e.transformed=!0,e}function ge(e,t,r,o,n,i){return [Math.round(r*(e*o-n)),Math.round(r*(t*o-i))]}function de(e,t,r,o,n){for(var i=t===n.maxZoom?0:n.tolerance/((1<<t)*n.extent),s={features:[],numPoints:0,numSimplified:0,numFeatures:0,source:null,x:r,y:o,z:t,transformed:!1,minX:2,minY:1,maxX:-1,maxY:0},a=0;a<e.length;a++){s.numFeatures++,me(s,e[a],i,n);var l=e[a].minX,u=e[a].minY,h=e[a].maxX,c=e[a].maxY;l<s.minX&&(s.minX=l),u<s.minY&&(s.minY=u),h>s.maxX&&(s.maxX=h),c>s.maxY&&(s.maxY=c);}return s}function me(e,t,r,o){var n=t.geometry,i=t.type,s=[];if("Point"===i||"MultiPoint"===i)for(var a=0;a<n.length;a+=3)s.push(n[a]),s.push(n[a+1]),e.numPoints++,e.numSimplified++;else if("LineString"===i)ye(s,n,e,r,!1,!1);else if("MultiLineString"===i||"Polygon"===i)for(a=0;a<n.length;a++)ye(s,n[a],e,r,"Polygon"===i,0===a);else if("MultiPolygon"===i)for(var l=0;l<n.length;l++){var u=n[l];for(a=0;a<u.length;a++)ye(s,u[a],e,r,!0,0===a);}if(s.length){var h=t.tags||null;if("LineString"===i&&o.lineMetrics){for(var c in h={},t.tags)h[c]=t.tags[c];h.mapbox_clip_start=n.start/n.size,h.mapbox_clip_end=n.end/n.size;}var f={geometry:s,type:"Polygon"===i||"MultiPolygon"===i?3:"LineString"===i||"MultiLineString"===i?2:1,tags:h};null!==t.id&&(f.id=t.id),e.features.push(f);}}function ye(e,t,r,o,n,i){var s=o*o;if(o>0&&t.size<(n?s:o))r.numPoints+=t.length/3;else {for(var a=[],l=0;l<t.length;l+=3)(0===o||t[l+2]>s)&&(r.numSimplified++,a.push(t[l]),a.push(t[l+1])),r.numPoints++;n&&function(e,t){for(var r=0,o=0,n=e.length,i=n-2;o<n;i=o,o+=2)r+=(e[o]-e[i])*(e[o+1]+e[i+1]);if(r>0===t)for(o=0,n=e.length;o<n/2;o+=2){var s=e[o],a=e[o+1];e[o]=e[n-2-o],e[o+1]=e[n-1-o],e[n-2-o]=s,e[n-1-o]=a;}}(a,i),e.push(a);}}function ve(e,t){var r=(t=this.options=function(e,t){for(var r in t)e[r]=t[r];return e}(Object.create(this.options),t)).debug;if(r&&console.time("preprocess data"),t.maxZoom<0||t.maxZoom>24)throw new Error("maxZoom should be in the 0-24 range");if(t.promoteId&&t.generateId)throw new Error("promoteId and generateId cannot be used together.");var o=function(e,t){var r=[];if("FeatureCollection"===e.type)for(var o=0;o<e.features.length;o++)Q(r,e.features[o],t,o);else Q(r,"Feature"===e.type?e:{geometry:e},t);return r}(e,t);this.tiles={},this.tileCoords=[],r&&(console.timeEnd("preprocess data"),console.log("index: maxZoom: %d, maxPoints: %d",t.indexMaxZoom,t.indexMaxPoints),console.time("generate tiles"),this.stats={},this.total=0),(o=function(e,t){var r=t.buffer/t.extent,o=e,n=oe(e,1,-1-r,r,0,-1,2,t),i=oe(e,1,1-r,2+r,0,-1,2,t);return (n||i)&&(o=oe(e,1,-r,1+r,0,-1,2,t)||[],n&&(o=ce(n,1).concat(o)),i&&(o=o.concat(ce(i,-1)))),o}(o,t)).length&&this.splitTile(o,0,0,0),r&&(o.length&&console.log("features: %d, points: %d",this.tiles[0].numFeatures,this.tiles[0].numPoints),console.timeEnd("generate tiles"),console.log("tiles generated:",this.total,JSON.stringify(this.stats)));}function xe(e,t,r){return 32*((1<<e)*r+t)+e}function we(e,t){const r=e.tileID.canonical;if(!this._geoJSONIndex)return t(null,null);const o=this._geoJSONIndex.getTile(r.z,r.x,r.y);if(!o)return t(null,null);const n=new h(o.features);let i=d(n);0===i.byteOffset&&i.byteLength===i.buffer.byteLength||(i=new Uint8Array(i)),t(null,{vectorTile:n,rawData:i.buffer});}ve.prototype.options={maxZoom:14,indexMaxZoom:5,indexMaxPoints:1e5,tolerance:3,extent:4096,buffer:64,lineMetrics:!1,promoteId:null,generateId:!1,debug:0},ve.prototype.splitTile=function(e,t,r,o,n,i,s){for(var a=[e,t,r,o],l=this.options,u=l.debug;a.length;){o=a.pop(),r=a.pop(),t=a.pop(),e=a.pop();var h=1<<t,c=xe(t,r,o),f=this.tiles[c];if(!f&&(u>1&&console.time("creation"),f=this.tiles[c]=de(e,t,r,o,l),this.tileCoords.push({z:t,x:r,y:o}),u)){u>1&&(console.log("tile z%d-%d-%d (features: %d, points: %d, simplified: %d)",t,r,o,f.numFeatures,f.numPoints,f.numSimplified),console.timeEnd("creation"));var p="z"+t;this.stats[p]=(this.stats[p]||0)+1,this.total++;}if(f.source=e,n){if(t===l.maxZoom||t===n)continue;var g=1<<n-t;if(r!==Math.floor(i/g)||o!==Math.floor(s/g))continue}else if(t===l.indexMaxZoom||f.numPoints<=l.indexMaxPoints)continue;if(f.source=null,0!==e.length){u>1&&console.time("clipping");var d,m,y,v,x,w,S=.5*l.buffer/l.extent,M=.5-S,P=.5+S,b=1+S;d=m=y=v=null,x=oe(e,h,r-S,r+P,0,f.minX,f.maxX,l),w=oe(e,h,r+M,r+b,0,f.minX,f.maxX,l),e=null,x&&(d=oe(x,h,o-S,o+P,1,f.minY,f.maxY,l),m=oe(x,h,o+M,o+b,1,f.minY,f.maxY,l),x=null),w&&(y=oe(w,h,o-S,o+P,1,f.minY,f.maxY,l),v=oe(w,h,o+M,o+b,1,f.minY,f.maxY,l),w=null),u>1&&console.timeEnd("clipping"),a.push(d||[],t+1,2*r,2*o),a.push(m||[],t+1,2*r,2*o+1),a.push(y||[],t+1,2*r+1,2*o),a.push(v||[],t+1,2*r+1,2*o+1);}}},ve.prototype.getTile=function(e,t,r){var o=this.options,n=o.extent,i=o.debug;if(e<0||e>24)return null;var s=1<<e,a=xe(e,t=(t%s+s)%s,r);if(this.tiles[a])return pe(this.tiles[a],n);i>1&&console.log("drilling down to z%d-%d-%d",e,t,r);for(var l,u=e,h=t,c=r;!l&&u>0;)u--,h=Math.floor(h/2),c=Math.floor(c/2),l=this.tiles[xe(u,h,c)];return l&&l.source?(i>1&&console.log("found parent tile z%d-%d-%d",u,h,c),i>1&&console.time("drilling down"),this.splitTile(l.source,u,h,c,e,t,r),i>1&&console.timeEnd("drilling down"),this.tiles[a]?pe(this.tiles[a],n):null):null};class Se extends e.VectorTileWorkerSource{constructor(e,t,r,o,n){super(e,t,r,o,we),n&&(this.loadGeoJSON=n);}loadData(t,r){const o=t&&t.request,n=o&&o.collectResourceTiming;this.loadGeoJSON(t,((s,a)=>{if(s||!a)return r(s);if("object"!=typeof a)return r(new Error(`Input data given to '${t.source}' is not a valid GeoJSON object.`));{i(a,!0);try{if(t.filter){const r=e.createExpression(t.filter,{type:"boolean","property-type":"data-driven",overridable:!1,transition:!1});if("error"===r.result)throw new Error(r.value.map((e=>`${e.key}: ${e.message}`)).join(", "));const o=a.features.filter((e=>r.value.evaluate({zoom:0},e)));a={type:"FeatureCollection",features:o};}this._geoJSONIndex=t.cluster?new j(function({superclusterOptions:t,clusterProperties:r}){if(!r||!t)return t;const o={},n={},i={accumulated:null,zoom:0},s={properties:null},a=Object.keys(r);for(const t of a){const[i,s]=r[t],a=e.createExpression(s),l=e.createExpression("string"==typeof i?[i,["accumulated"],["get",t]]:i);o[t]=a.value,n[t]=l.value;}return t.map=e=>{s.properties=e;const t={};for(const e of a)t[e]=o[e].evaluate(i,s);return t},t.reduce=(e,t)=>{s.properties=t;for(const t of a)i.accumulated=e[t],e[t]=n[t].evaluate(i,s);},t}(t)).load(a.features):function(e,t){return new ve(e,t)}(a,t.geojsonVtOptions);}catch(s){return r(s)}this.loaded={};const l={};if(n){const r=e.getPerformanceMeasurement(o);r&&(l.resourceTiming={},l.resourceTiming[t.source]=JSON.parse(JSON.stringify(r)));}r(null,l);}}));}reloadTile(e,t){const r=this.loaded;return r&&r[e.uid]?super.reloadTile(e,t):this.loadTile(e,t)}loadGeoJSON(t,r){if(t.request)e.getJSON(t.request,r);else {if("string"!=typeof t.data)return r(new Error(`Input data given to '${t.source}' is not a valid GeoJSON object.`));try{return r(null,JSON.parse(t.data))}catch(e){return r(new Error(`Input data given to '${t.source}' is not a valid GeoJSON object.`))}}}getClusterExpansionZoom(e,t){try{t(null,this._geoJSONIndex.getClusterExpansionZoom(e.clusterId));}catch(e){t(e);}}getClusterChildren(e,t){try{t(null,this._geoJSONIndex.getChildren(e.clusterId));}catch(e){t(e);}}getClusterLeaves(e,t){try{t(null,this._geoJSONIndex.getLeaves(e.clusterId,e.limit,e.offset));}catch(e){t(e);}}}class Me{constructor(t){this.self=t,this.actor=new e.Actor(t,this),this.layerIndexes={},this.availableImages={},this.isSpriteLoaded={},this.projections={},this.defaultProjection=e.getProjection({name:"mercator"}),this.workerSourceTypes={vector:e.VectorTileWorkerSource,geojson:Se},this.workerSources={},this.demWorkerSources={},this.self.registerWorkerSource=(e,t)=>{if(this.workerSourceTypes[e])throw new Error(`Worker source with name "${e}" already registered.`);this.workerSourceTypes[e]=t;},this.self.registerRTLTextPlugin=t=>{if(e.plugin.isParsed())throw new Error("RTL text plugin already registered.");e.plugin.applyArabicShaping=t.applyArabicShaping,e.plugin.processBidirectionalText=t.processBidirectionalText,e.plugin.processStyledBidirectionalText=t.processStyledBidirectionalText;};}clearCaches(e,t,r){delete this.layerIndexes[e],delete this.availableImages[e],delete this.workerSources[e],delete this.demWorkerSources[e],r();}checkIfReady(e,t,r){r();}setReferrer(e,t){this.referrer=t;}spriteLoaded(t,r){this.isSpriteLoaded[t]=r;for(const o in this.workerSources[t]){const n=this.workerSources[t][o];for(const t in n)n[t]instanceof e.VectorTileWorkerSource&&(n[t].isSpriteLoaded=r,n[t].fire(new e.Event("isSpriteLoaded")));}}setImages(e,t,r){this.availableImages[e]=t;for(const r in this.workerSources[e]){const o=this.workerSources[e][r];for(const e in o)o[e].availableImages=t;}r();}enableTerrain(e,t,r){this.terrain=t,r();}setProjection(t,r){this.projections[t]=e.getProjection(r);}setLayers(e,t,r){this.getLayerIndex(e).replace(t),r();}updateLayers(e,t,r){this.getLayerIndex(e).update(t.layers,t.removedIds),r();}loadTile(t,r,o){const n=this.enableTerrain?e.extend({enableTerrain:this.terrain},r):r;n.projection=this.projections[t]||this.defaultProjection,this.getWorkerSource(t,r.type,r.source).loadTile(n,o);}loadDEMTile(t,r,o){const n=this.enableTerrain?e.extend({buildQuadTree:this.terrain},r):r;this.getDEMWorkerSource(t,r.source).loadTile(n,o);}reloadTile(t,r,o){const n=this.enableTerrain?e.extend({enableTerrain:this.terrain},r):r;n.projection=this.projections[t]||this.defaultProjection,this.getWorkerSource(t,r.type,r.source).reloadTile(n,o);}abortTile(e,t,r){this.getWorkerSource(e,t.type,t.source).abortTile(t,r);}removeTile(e,t,r){this.getWorkerSource(e,t.type,t.source).removeTile(t,r);}removeSource(e,t,r){if(!this.workerSources[e]||!this.workerSources[e][t.type]||!this.workerSources[e][t.type][t.source])return;const o=this.workerSources[e][t.type][t.source];delete this.workerSources[e][t.type][t.source],void 0!==o.removeSource?o.removeSource(t,r):r();}loadWorkerSource(e,t,r){try{this.self.importScripts(t.url),r();}catch(e){r(e.toString());}}syncRTLPluginState(t,r,o){try{e.plugin.setState(r);const t=e.plugin.getPluginURL();if(e.plugin.isLoaded()&&!e.plugin.isParsed()&&null!=t){this.self.importScripts(t);const r=e.plugin.isParsed();o(r?void 0:new Error(`RTL Text Plugin failed to import scripts from ${t}`),r);}}catch(e){o(e.toString());}}getAvailableImages(e){let t=this.availableImages[e];return t||(t=[]),t}getLayerIndex(e){let t=this.layerIndexes[e];return t||(t=this.layerIndexes[e]=new o),t}getWorkerSource(e,t,r){return this.workerSources[e]||(this.workerSources[e]={}),this.workerSources[e][t]||(this.workerSources[e][t]={}),this.workerSources[e][t][r]||(this.workerSources[e][t][r]=new this.workerSourceTypes[t]({send:(t,r,o,n,i,s)=>{this.actor.send(t,r,o,e,i,s);},scheduler:this.actor.scheduler},this.getLayerIndex(e),this.getAvailableImages(e),this.isSpriteLoaded[e])),this.workerSources[e][t][r]}getDEMWorkerSource(e,t){return this.demWorkerSources[e]||(this.demWorkerSources[e]={}),this.demWorkerSources[e][t]||(this.demWorkerSources[e][t]=new n),this.demWorkerSources[e][t]}enforceCacheSizeLimit(t,r){e.enforceCacheSizeLimit(r);}getWorkerPerformanceMetrics(e,t,r){r(void 0,void 0);}}return "undefined"!=typeof WorkerGlobalScope&&"undefined"!=typeof self&&self instanceof WorkerGlobalScope&&(self.worker=new Me(self)),Me}));

	define(["./shared"],(function(e){function t(e,i){if(Array.isArray(e)){if(!Array.isArray(i)||e.length!==i.length)return !1;for(let o=0;o<e.length;o++)if(!t(e[o],i[o]))return !1;return !0}if("object"==typeof e&&null!==e&&null!==i){if("object"!=typeof i)return !1;if(Object.keys(e).length!==Object.keys(i).length)return !1;for(const o in e)if(!t(e[o],i[o]))return !1;return !0}return e===i}var i=o;function o(e){return !function(e){return "undefined"==typeof window||"undefined"==typeof document?"not a browser":Array.prototype&&Array.prototype.every&&Array.prototype.filter&&Array.prototype.forEach&&Array.prototype.indexOf&&Array.prototype.lastIndexOf&&Array.prototype.map&&Array.prototype.some&&Array.prototype.reduce&&Array.prototype.reduceRight&&Array.isArray?Function.prototype&&Function.prototype.bind?Object.keys&&Object.create&&Object.getPrototypeOf&&Object.getOwnPropertyNames&&Object.isSealed&&Object.isFrozen&&Object.isExtensible&&Object.getOwnPropertyDescriptor&&Object.defineProperty&&Object.defineProperties&&Object.seal&&Object.freeze&&Object.preventExtensions?"JSON"in window&&"parse"in JSON&&"stringify"in JSON?function(){if(!("Worker"in window&&"Blob"in window&&"URL"in window))return !1;var e,t,i=new Blob([""],{type:"text/javascript"}),o=URL.createObjectURL(i);try{t=new Worker(o),e=!0;}catch(t){e=!1;}return t&&t.terminate(),URL.revokeObjectURL(o),e}()?"Uint8ClampedArray"in window?ArrayBuffer.isView?function(){var e=document.createElement("canvas");e.width=e.height=1;var t=e.getContext("2d");if(!t)return !1;var i=t.getImageData(0,0,1,1);return i&&i.width===e.width}()?(void 0===r[t=e&&e.failIfMajorPerformanceCaveat]&&(r[t]=function(e){var t,i=function(e){var t=document.createElement("canvas"),i=Object.create(o.webGLContextAttributes);return i.failIfMajorPerformanceCaveat=e,t.getContext("webgl",i)||t.getContext("experimental-webgl",i)}(e);if(!i)return !1;try{t=i.createShader(i.VERTEX_SHADER);}catch(e){return !1}return !(!t||i.isContextLost())&&(i.shaderSource(t,"void main() {}"),i.compileShader(t),!0===i.getShaderParameter(t,i.COMPILE_STATUS))}(t)),r[t]?document.documentMode?"insufficient ECMAScript 6 support":void 0:"insufficient WebGL support"):"insufficient Canvas/getImageData support":"insufficient ArrayBuffer support":"insufficient Uint8ClampedArray support":"insufficient worker support":"insufficient JSON support":"insufficient Object support":"insufficient Function support":"insufficent Array support";var t;}(e)}var r={};function n(t,i,o){const r=e.window.document.createElement(t);return void 0!==i&&(r.className=i),o&&o.appendChild(r),r}function a(t,i,o){const r=e.window.document.createElementNS("http://www.w3.org/2000/svg",t);for(const e of Object.keys(i))r.setAttributeNS(null,e,i[e]);return o&&o.appendChild(r),r}o.webGLContextAttributes={antialias:!1,alpha:!0,stencil:!0,depth:!0};const s=e.window.document&&e.window.document.documentElement.style,l=s&&void 0!==s.userSelect?"userSelect":"WebkitUserSelect";let c;function h(){s&&l&&(c=s[l],s[l]="none");}function u(){s&&l&&(s[l]=c);}function _(t){t.preventDefault(),t.stopPropagation(),e.window.removeEventListener("click",_,!0);}function d(){e.window.addEventListener("click",_,!0),e.window.setTimeout((()=>{e.window.removeEventListener("click",_,!0);}),0);}function p(e,t){const i=e.getBoundingClientRect();return g(e,i,t)}function m(e,t){const i=e.getBoundingClientRect(),o=[];for(let r=0;r<t.length;r++)o.push(g(e,i,t[r]));return o}function f(t){return void 0!==e.window.InstallTrigger&&2===t.button&&t.ctrlKey&&e.window.navigator.platform.toUpperCase().indexOf("MAC")>=0?0:t.button}function g(t,i,o){const r=t.offsetWidth===i.width?1:t.offsetWidth/i.width;return new e.pointGeometry((o.clientX-i.left)*r,(o.clientY-i.top)*r)}function v(e,t){var i=t[0],o=t[1],r=t[2],n=t[3],a=i*n-r*o;return a?(e[0]=n*(a=1/a),e[1]=-o*a,e[2]=-r*a,e[3]=i*a,e):null}function x(e){const{userImage:t}=e;return !!(t&&t.render&&t.render())&&(e.data.replace(new Uint8Array(t.data.buffer)),!0)}class y extends e.Evented{constructor(){super(),this.images={},this.updatedImages={},this.callbackDispatchedThisFrame={},this.loaded=!1,this.requestors=[],this.patterns={},this.atlasImage=new e.RGBAImage({width:1,height:1}),this.dirty=!0;}isLoaded(){return this.loaded}setLoaded(e){if(this.loaded!==e&&(this.loaded=e,e)){for(const{ids:e,callback:t}of this.requestors)this._notify(e,t);this.requestors=[];}}hasImage(e){return !!this.getImage(e)}getImage(e){return this.images[e]}addImage(e,t){this._validate(e,t)&&(this.images[e]=t);}_validate(t,i){let o=!0;return this._validateStretch(i.stretchX,i.data&&i.data.width)||(this.fire(new e.ErrorEvent(new Error(`Image "${t}" has invalid "stretchX" value`))),o=!1),this._validateStretch(i.stretchY,i.data&&i.data.height)||(this.fire(new e.ErrorEvent(new Error(`Image "${t}" has invalid "stretchY" value`))),o=!1),this._validateContent(i.content,i)||(this.fire(new e.ErrorEvent(new Error(`Image "${t}" has invalid "content" value`))),o=!1),o}_validateStretch(e,t){if(!e)return !0;let i=0;for(const o of e){if(o[0]<i||o[1]<o[0]||t<o[1])return !1;i=o[1];}return !0}_validateContent(e,t){return !(e&&(4!==e.length||e[0]<0||t.data.width<e[0]||e[1]<0||t.data.height<e[1]||e[2]<0||t.data.width<e[2]||e[3]<0||t.data.height<e[3]||e[2]<e[0]||e[3]<e[1]))}updateImage(e,t){t.version=this.images[e].version+1,this.images[e]=t,this.updatedImages[e]=!0;}removeImage(e){const t=this.images[e];delete this.images[e],delete this.patterns[e],t.userImage&&t.userImage.onRemove&&t.userImage.onRemove();}listImages(){return Object.keys(this.images)}getImages(e,t){let i=!0;if(!this.isLoaded())for(const t of e)this.images[t]||(i=!1);this.isLoaded()||i?this._notify(e,t):this.requestors.push({ids:e,callback:t});}_notify(t,i){const o={};for(const i of t){this.images[i]||this.fire(new e.Event("styleimagemissing",{id:i}));const t=this.images[i];t?o[i]={data:t.data.clone(),pixelRatio:t.pixelRatio,sdf:t.sdf,version:t.version,stretchX:t.stretchX,stretchY:t.stretchY,content:t.content,hasRenderCallback:Boolean(t.userImage&&t.userImage.render)}:e.warnOnce(`Image "${i}" could not be loaded. Please make sure you have added the image with map.addImage() or a "sprite" property in your style. You can provide missing images by listening for the "styleimagemissing" map event.`);}i(null,o);}getPixelSize(){const{width:e,height:t}=this.atlasImage;return {width:e,height:t}}getPattern(t){const i=this.patterns[t],o=this.getImage(t);if(!o)return null;if(i&&i.position.version===o.version)return i.position;if(i)i.position.version=o.version;else {const i={w:o.data.width+2,h:o.data.height+2,x:0,y:0},r=new e.ImagePosition(i,o);this.patterns[t]={bin:i,position:r};}return this._updatePatternAtlas(),this.patterns[t].position}bind(t){const i=t.gl;this.atlasTexture?this.dirty&&(this.atlasTexture.update(this.atlasImage),this.dirty=!1):this.atlasTexture=new e.Texture(t,this.atlasImage,i.RGBA),this.atlasTexture.bind(i.LINEAR,i.CLAMP_TO_EDGE);}_updatePatternAtlas(){const t=[];for(const e in this.patterns)t.push(this.patterns[e].bin);const{w:i,h:o}=e.potpack(t),r=this.atlasImage;r.resize({width:i||1,height:o||1});for(const t in this.patterns){const{bin:i}=this.patterns[t],o=i.x+1,n=i.y+1,a=this.images[t].data,s=a.width,l=a.height;e.RGBAImage.copy(a,r,{x:0,y:0},{x:o,y:n},{width:s,height:l}),e.RGBAImage.copy(a,r,{x:0,y:l-1},{x:o,y:n-1},{width:s,height:1}),e.RGBAImage.copy(a,r,{x:0,y:0},{x:o,y:n+l},{width:s,height:1}),e.RGBAImage.copy(a,r,{x:s-1,y:0},{x:o-1,y:n},{width:1,height:l}),e.RGBAImage.copy(a,r,{x:0,y:0},{x:o+s,y:n},{width:1,height:l});}this.dirty=!0;}beginFrame(){this.callbackDispatchedThisFrame={};}dispatchRenderCallbacks(e){for(const t of e){if(this.callbackDispatchedThisFrame[t])continue;this.callbackDispatchedThisFrame[t]=!0;const e=this.images[t];x(e)&&this.updateImage(t,e);}}}const b=new e.Properties({anchor:new e.DataConstantProperty(e.spec.light.anchor),position:new class{constructor(){this.specification=e.spec.light.position;}possiblyEvaluate(t,i){return function([t,i,o]){const r=e.degToRad(i+90),n=e.degToRad(o);return {x:t*Math.cos(r)*Math.sin(n),y:t*Math.sin(r)*Math.sin(n),z:t*Math.cos(n),azimuthal:i,polar:o}}(t.expression.evaluate(i))}interpolate(t,i,o){return {x:e.number(t.x,i.x,o),y:e.number(t.y,i.y,o),z:e.number(t.z,i.z,o),azimuthal:e.number(t.azimuthal,i.azimuthal,o),polar:e.number(t.polar,i.polar,o)}}},color:new e.DataConstantProperty(e.spec.light.color),intensity:new e.DataConstantProperty(e.spec.light.intensity)}),w="-transition";class T extends e.Evented{constructor(t){super(),this._transitionable=new e.Transitionable(b),this.setLight(t),this._transitioning=this._transitionable.untransitioned();}getLight(){return this._transitionable.serialize()}setLight(t,i={}){if(!this._validate(e.validateLight,t,i))for(const i in t){const o=t[i];e.endsWith(i,w)?this._transitionable.setTransition(i.slice(0,-w.length),o):this._transitionable.setValue(i,o);}}updateTransitions(e){this._transitioning=this._transitionable.transitioned(e,this._transitioning);}hasTransition(){return this._transitioning.hasTransition()}recalculate(e){this.properties=this._transitioning.possiblyEvaluate(e);}_validate(t,i,o){return (!o||!1!==o.validate)&&e.emitValidationErrors(this,t.call(e.validateStyle,e.extend({value:i,style:{glyphs:!0,sprite:!0},styleSpec:e.spec})))}}const E=new e.Properties({source:new e.DataConstantProperty(e.spec.terrain.source),exaggeration:new e.DataConstantProperty(e.spec.terrain.exaggeration)}),C="-transition";class I extends e.Evented{constructor(t,i){super(),this._transitionable=new e.Transitionable(E),this.set(t),this._transitioning=this._transitionable.untransitioned(),this.drapeRenderMode=i;}get(){return this._transitionable.serialize()}set(t){for(const i in t){const o=t[i];e.endsWith(i,C)?this._transitionable.setTransition(i.slice(0,-C.length),o):this._transitionable.setValue(i,o);}}updateTransitions(e){this._transitioning=this._transitionable.transitioned(e,this._transitioning);}hasTransition(){return this._transitioning.hasTransition()}recalculate(e){this.properties=this._transitioning.possiblyEvaluate(e);}}function M(t,i,o,r){const n=e.smoothstep(45,65,o),[a,s]=S(t,r),l=e.length(i);let c=1-Math.min(1,Math.exp((l-a)/(s-a)*-6));return c*=c*c,c=Math.min(1,1.00747*c),c*n*t.alpha}function S(e,t){const i=.5/Math.tan(.5*t);return [e.range[0]+i,e.range[1]+i]}const z=new e.Properties({range:new e.DataConstantProperty(e.spec.fog.range),color:new e.DataConstantProperty(e.spec.fog.color),"high-color":new e.DataConstantProperty(e.spec.fog["high-color"]),"space-color":new e.DataConstantProperty(e.spec.fog["space-color"]),"horizon-blend":new e.DataConstantProperty(e.spec.fog["horizon-blend"]),"star-intensity":new e.DataConstantProperty(e.spec.fog["star-intensity"])}),D="-transition";class P extends e.Evented{constructor(t,i){super(),this._transitionable=new e.Transitionable(z),this.set(t),this._transitioning=this._transitionable.untransitioned(),this._transform=i;}get state(){const t=this._transform,i="globe"===t.projection.name,o=e.globeToMercatorTransition(t.zoom),r=this.properties.get("range"),n=[.5,3];return {range:i?[e.number(n[0],r[0],o),e.number(n[1],r[1],o)]:r,horizonBlend:this.properties.get("horizon-blend"),alpha:this.properties.get("color").a}}get(){return this._transitionable.serialize()}set(t,i={}){if(!this._validate(e.validateFog,t,i)){for(const i of Object.keys(e.spec.fog))t&&void 0===t[i]&&(t[i]=e.spec.fog[i].default);for(const i in t){const o=t[i];e.endsWith(i,D)?this._transitionable.setTransition(i.slice(0,-D.length),o):this._transitionable.setValue(i,o);}}}getOpacity(t){if(!this._transform.projection.supportsFog)return 0;const i=this.properties&&this.properties.get("color")||1;return ("globe"===this._transform.projection.name?1:e.smoothstep(45,65,t))*i.a}getOpacityAtLatLng(t,i){return this._transform.projection.supportsFog?function(t,i,o){const r=e.MercatorCoordinate.fromLngLat(i),n=o.elevation?o.elevation.getAtPointOrZero(r):0,a=[r.x,r.y,n];return e.transformMat4(a,a,o.mercatorFogMatrix),M(t,a,o.pitch,o._fov)}(this.state,t,i):0}getFovAdjustedRange(e){return this._transform.projection.supportsFog?S(this.state,e):[0,1]}updateTransitions(e){this._transitioning=this._transitionable.transitioned(e,this._transitioning);}hasTransition(){return this._transitioning.hasTransition()}recalculate(e){this.properties=this._transitioning.possiblyEvaluate(e);}_validate(t,i,o){return (!o||!1!==o.validate)&&e.emitValidationErrors(this,t.call(e.validateStyle,e.extend({value:i,style:{glyphs:!0,sprite:!0},styleSpec:e.spec})))}}class A{constructor(t,i){this.workerPool=t,this.actors=[],this.currentActor=0,this.id=e.uniqueId();const o=this.workerPool.acquire(this.id);for(let e=0;e<o.length;e++){const t=new A.Actor(o[e],i,this.id);t.name=`Worker ${e}`,this.actors.push(t);}this.ready=!1,this.broadcast("checkIfReady",null,(()=>{this.ready=!0;}));}broadcast(t,i,o){e.asyncAll(this.actors,((e,o)=>{e.send(t,i,o);}),o=o||function(){});}getActor(){return this.currentActor=(this.currentActor+1)%this.actors.length,this.actors[this.currentActor]}remove(){this.actors.forEach((e=>{e.remove();})),this.actors=[],this.workerPool.release(this.id);}}function L(t,i,o){return i*(e.EXTENT/(t.tileSize*Math.pow(2,o-t.tileID.overscaledZ)))}A.Actor=e.Actor;class R{constructor(e,t,i,o){this.screenBounds=e,this.cameraPoint=t,this._screenRaycastCache={},this._cameraRaycastCache={},this.isAboveHorizon=i,this.screenGeometry=this.bufferedScreenGeometry(0),this.screenGeometryMercator=this._bufferedScreenMercator(0,o);}static createFromScreenPoints(t,i){let o,r;if(t instanceof e.pointGeometry||"number"==typeof t[0]){const n=e.pointGeometry.convert(t);o=[e.pointGeometry.convert(t)],r=i.isPointAboveHorizon(n);}else {const n=e.pointGeometry.convert(t[0]),a=e.pointGeometry.convert(t[1]);o=[n,a],r=e.polygonizeBounds(n,a).every((e=>i.isPointAboveHorizon(e)));}return new R(o,i.getCameraPoint(),r,i)}isPointQuery(){return 1===this.screenBounds.length}bufferedScreenGeometry(t){return e.polygonizeBounds(this.screenBounds[0],1===this.screenBounds.length?this.screenBounds[0]:this.screenBounds[1],t)}bufferedCameraGeometry(t){const i=this.screenBounds[0],o=1===this.screenBounds.length?this.screenBounds[0].add(new e.pointGeometry(1,1)):this.screenBounds[1],r=e.polygonizeBounds(i,o,0,!1);return this.cameraPoint.y>o.y&&(this.cameraPoint.x>i.x&&this.cameraPoint.x<o.x?r.splice(3,0,this.cameraPoint):this.cameraPoint.x>=o.x?r[2]=this.cameraPoint:this.cameraPoint.x<=i.x&&(r[3]=this.cameraPoint)),e.bufferConvexPolygon(r,t)}bufferedCameraGeometryGlobe(t){const i=this.screenBounds[0],o=1===this.screenBounds.length?this.screenBounds[0].add(new e.pointGeometry(1,1)):this.screenBounds[1],r=e.polygonizeBounds(i,o,t),n=this.cameraPoint.clone();switch(3*((n.y>i.y)+(n.y>o.y))+((n.x>i.x)+(n.x>o.x))){case 0:r[0]=n,r[4]=n.clone();break;case 1:r.splice(1,0,n);break;case 2:r[1]=n;break;case 3:r.splice(4,0,n);break;case 5:r.splice(2,0,n);break;case 6:r[3]=n;break;case 7:r.splice(3,0,n);break;case 8:r[2]=n;}return r}containsTile(t,i,o,r=0){const n=t.queryPadding/i._pixelsPerMercatorPixel+1,a=o?this._bufferedCameraMercator(n,i):this._bufferedScreenMercator(n,i);let s=t.tileID.wrap+(a.unwrapped?r:0);const l=a.polygon.map((i=>e.getTilePoint(t.tileTransform,i,s)));if(!e.polygonIntersectsBox(l,0,0,e.EXTENT,e.EXTENT))return;s=t.tileID.wrap+(this.screenGeometryMercator.unwrapped?r:0);const c=this.screenGeometryMercator.polygon.map((i=>e.getTileVec3(t.tileTransform,i,s))),h=c.map((t=>new e.pointGeometry(t[0],t[1]))),u=i.getFreeCameraOptions().position||new e.MercatorCoordinate(0,0,0),_=e.getTileVec3(t.tileTransform,u,s),d=c.map((t=>{const i=e.sub(t,t,_);return e.normalize(i,i),new e.Ray(_,i)})),p=L(t,1,i.zoom)*i._pixelsPerMercatorPixel;return {queryGeometry:this,tilespaceGeometry:h,tilespaceRays:d,bufferedTilespaceGeometry:l,bufferedTilespaceBounds:(m=e.getBounds(l),m.min.x=e.clamp(m.min.x,0,e.EXTENT),m.min.y=e.clamp(m.min.y,0,e.EXTENT),m.max.x=e.clamp(m.max.x,0,e.EXTENT),m.max.y=e.clamp(m.max.y,0,e.EXTENT),m),tile:t,tileID:t.tileID,pixelToTileUnitsFactor:p};var m;}_bufferedScreenMercator(e,t){const i=k(e);if(this._screenRaycastCache[i])return this._screenRaycastCache[i];{let o;return o="globe"===t.projection.name?this._projectAndResample(this.bufferedScreenGeometry(e),t):{polygon:this.bufferedScreenGeometry(e).map((e=>t.pointCoordinate3D(e))),unwrapped:!0},this._screenRaycastCache[i]=o,o}}_bufferedCameraMercator(e,t){const i=k(e);if(this._cameraRaycastCache[i])return this._cameraRaycastCache[i];{let o;return o="globe"===t.projection.name?this._projectAndResample(this.bufferedCameraGeometryGlobe(e),t):{polygon:this.bufferedCameraGeometry(e).map((e=>t.pointCoordinate3D(e))),unwrapped:!0},this._cameraRaycastCache[i]=o,o}}_projectAndResample(t,i){const o=function(t,i){const o=e.multiply([],i.pixelMatrix,i.globeMatrix),r=[0,-e.GLOBE_RADIUS,0,1],n=[0,e.GLOBE_RADIUS,0,1],a=[0,0,0,1];e.transformMat4$1(r,r,o),e.transformMat4$1(n,n,o),e.transformMat4$1(a,a,o);const s=new e.pointGeometry(r[0]/r[3],r[1]/r[3]),l=new e.pointGeometry(n[0]/n[3],n[1]/n[3]),c=e.polygonContainsPoint(t,s)&&r[3]<a[3],h=e.polygonContainsPoint(t,l)&&n[3]<a[3];if(!c&&!h)return null;const u=function(e,t,i){for(let o=1;o<e.length;o++){const r=B(t.pointCoordinate3D(e[o-1]).x),n=B(t.pointCoordinate3D(e[o]).x);if(i<0){if(r<n)return {idx:o,t:-r/(n-1-r)}}else if(n<r)return {idx:o,t:(1-r)/(n+1-r)}}return null}(t,i,c?-1:1);if(!u)return null;const{idx:_,t:d}=u;let p=_>1?O(t.slice(0,_),i):[],m=_<t.length?O(t.slice(_),i):[];p=p.map((t=>new e.pointGeometry(B(t.x),t.y))),m=m.map((t=>new e.pointGeometry(B(t.x),t.y)));const f=[...p];0===f.length&&f.push(m[m.length-1]);const g=e.number(f[f.length-1].y,(0===m.length?p[0]:m[0]).y,d);let v;return v=c?[new e.pointGeometry(0,g),new e.pointGeometry(0,0),new e.pointGeometry(1,0),new e.pointGeometry(1,g)]:[new e.pointGeometry(1,g),new e.pointGeometry(1,1),new e.pointGeometry(0,1),new e.pointGeometry(0,g)],f.push(...v),0===m.length?f.push(p[0]):f.push(...m),{polygon:f.map((t=>new e.MercatorCoordinate(t.x,t.y))),unwrapped:!1}}(t,i);if(o)return o;const r=function(t,i){let o=!1,r=-1/0,n=0;for(let e=0;e<t.length-1;e++)t[e].x>r&&(r=t[e].x,n=e);for(let e=0;e<t.length-1;e++){const i=(n+e)%(t.length-1),r=t[i],a=t[i+1];Math.abs(r.x-a.x)>.5&&(r.x<a.x?(r.x+=1,0===i&&(t[t.length-1].x+=1)):(a.x+=1,i+1===t.length-1&&(t[0].x+=1)),o=!0);}const a=e.mercatorXfromLng(i.center.lng);return o&&a<Math.abs(a-1)&&t.forEach((e=>{e.x-=1;})),{polygon:t,unwrapped:o}}(O(t,i).map((t=>new e.pointGeometry(B(t.x),t.y))),i);return {polygon:r.polygon.map((t=>new e.MercatorCoordinate(t.x,t.y))),unwrapped:r.unwrapped}}}function O(t,i){return e.resample(t,(e=>{const t=i.pointCoordinate3D(e);e.x=t.x,e.y=t.y;}),1/256)}function B(e){return e<0?1+e%1:e%1}function k(e){return 100*e|0}function F(t,i,o,r,n){const a=function(o,r){if(o)return n(o);if(r){const o=e.pick(e.extend(r,t),["tiles","minzoom","maxzoom","attribution","mapbox_logo","bounds","scheme","tileSize","encoding"]);r.vector_layers&&(o.vectorLayers=r.vector_layers,o.vectorLayerIds=o.vectorLayers.map((e=>e.id))),r.language_options&&(o.languageOptions=r.language_options),r.language&&r.language[r.id]&&(o.language=r.language[r.id]),r.worldview_options&&(o.worldviewOptions=r.worldview_options),r.worldview?o.worldview=r.worldview[r.id]:r.worldview_default&&(o.worldview=r.worldview_default),o.tiles=i.canonicalizeTileset(o,t.url),n(null,o);}};return t.url?e.getJSON(i.transformRequest(i.normalizeSourceURL(t.url,null,o,r),e.ResourceType.Source),a):e.exported.frame((()=>a(null,t)))}class U{constructor(t,i,o){this.bounds=e.LngLatBounds.convert(this.validateBounds(t)),this.minzoom=i||0,this.maxzoom=o||24;}validateBounds(e){return Array.isArray(e)&&4===e.length?[Math.max(-180,e[0]),Math.max(-90,e[1]),Math.min(180,e[2]),Math.min(90,e[3])]:[-180,-90,180,90]}contains(t){const i=Math.pow(2,t.z),o=Math.floor(e.mercatorXfromLng(this.bounds.getWest())*i),r=Math.floor(e.mercatorYfromLat(this.bounds.getNorth())*i),n=Math.ceil(e.mercatorXfromLng(this.bounds.getEast())*i),a=Math.ceil(e.mercatorYfromLat(this.bounds.getSouth())*i);return t.x>=o&&t.x<n&&t.y>=r&&t.y<a}}class N{constructor(e,t,i){this.context=e;const o=e.gl;this.buffer=o.createBuffer(),this.dynamicDraw=Boolean(i),this.context.unbindVAO(),e.bindElementBuffer.set(this.buffer),o.bufferData(o.ELEMENT_ARRAY_BUFFER,t.arrayBuffer,this.dynamicDraw?o.DYNAMIC_DRAW:o.STATIC_DRAW),this.dynamicDraw||t.destroy();}bind(){this.context.bindElementBuffer.set(this.buffer);}updateData(e){const t=this.context.gl;this.context.unbindVAO(),this.bind(),t.bufferSubData(t.ELEMENT_ARRAY_BUFFER,0,e.arrayBuffer);}destroy(){this.buffer&&(this.context.gl.deleteBuffer(this.buffer),delete this.buffer);}}const G={Int8:"BYTE",Uint8:"UNSIGNED_BYTE",Int16:"SHORT",Uint16:"UNSIGNED_SHORT",Int32:"INT",Uint32:"UNSIGNED_INT",Float32:"FLOAT"};class j{constructor(e,t,i,o){this.length=t.length,this.attributes=i,this.itemSize=t.bytesPerElement,this.dynamicDraw=o,this.context=e;const r=e.gl;this.buffer=r.createBuffer(),e.bindVertexBuffer.set(this.buffer),r.bufferData(r.ARRAY_BUFFER,t.arrayBuffer,this.dynamicDraw?r.DYNAMIC_DRAW:r.STATIC_DRAW),this.dynamicDraw||t.destroy();}bind(){this.context.bindVertexBuffer.set(this.buffer);}updateData(e){const t=this.context.gl;this.bind(),t.bufferSubData(t.ARRAY_BUFFER,0,e.arrayBuffer);}enableAttributes(e,t){for(let i=0;i<this.attributes.length;i++){const o=t.attributes[this.attributes[i].name];void 0!==o&&e.enableVertexAttribArray(o);}}setVertexAttribPointers(e,t,i){for(let o=0;o<this.attributes.length;o++){const r=this.attributes[o],n=t.attributes[r.name];void 0!==n&&e.vertexAttribPointer(n,r.components,e[G[r.type]],!1,this.itemSize,r.offset+this.itemSize*(i||0));}}destroy(){this.buffer&&(this.context.gl.deleteBuffer(this.buffer),delete this.buffer);}}class Z{constructor(e){this.gl=e.gl,this.default=this.getDefault(),this.current=this.default,this.dirty=!1;}get(){return this.current}set(e){}getDefault(){return this.default}setDefault(){this.set(this.default);}}class V extends Z{getDefault(){return e.Color.transparent}set(e){const t=this.current;(e.r!==t.r||e.g!==t.g||e.b!==t.b||e.a!==t.a||this.dirty)&&(this.gl.clearColor(e.r,e.g,e.b,e.a),this.current=e,this.dirty=!1);}}class W extends Z{getDefault(){return 1}set(e){(e!==this.current||this.dirty)&&(this.gl.clearDepth(e),this.current=e,this.dirty=!1);}}class X extends Z{getDefault(){return 0}set(e){(e!==this.current||this.dirty)&&(this.gl.clearStencil(e),this.current=e,this.dirty=!1);}}class q extends Z{getDefault(){return [!0,!0,!0,!0]}set(e){const t=this.current;(e[0]!==t[0]||e[1]!==t[1]||e[2]!==t[2]||e[3]!==t[3]||this.dirty)&&(this.gl.colorMask(e[0],e[1],e[2],e[3]),this.current=e,this.dirty=!1);}}class $ extends Z{getDefault(){return !0}set(e){(e!==this.current||this.dirty)&&(this.gl.depthMask(e),this.current=e,this.dirty=!1);}}class H extends Z{getDefault(){return 255}set(e){(e!==this.current||this.dirty)&&(this.gl.stencilMask(e),this.current=e,this.dirty=!1);}}class Y extends Z{getDefault(){return {func:this.gl.ALWAYS,ref:0,mask:255}}set(e){const t=this.current;(e.func!==t.func||e.ref!==t.ref||e.mask!==t.mask||this.dirty)&&(this.gl.stencilFunc(e.func,e.ref,e.mask),this.current=e,this.dirty=!1);}}class K extends Z{getDefault(){const e=this.gl;return [e.KEEP,e.KEEP,e.KEEP]}set(e){const t=this.current;(e[0]!==t[0]||e[1]!==t[1]||e[2]!==t[2]||this.dirty)&&(this.gl.stencilOp(e[0],e[1],e[2]),this.current=e,this.dirty=!1);}}class J extends Z{getDefault(){return !1}set(e){if(e===this.current&&!this.dirty)return;const t=this.gl;e?t.enable(t.STENCIL_TEST):t.disable(t.STENCIL_TEST),this.current=e,this.dirty=!1;}}class Q extends Z{getDefault(){return [0,1]}set(e){const t=this.current;(e[0]!==t[0]||e[1]!==t[1]||this.dirty)&&(this.gl.depthRange(e[0],e[1]),this.current=e,this.dirty=!1);}}class ee extends Z{getDefault(){return !1}set(e){if(e===this.current&&!this.dirty)return;const t=this.gl;e?t.enable(t.DEPTH_TEST):t.disable(t.DEPTH_TEST),this.current=e,this.dirty=!1;}}class te extends Z{getDefault(){return this.gl.LESS}set(e){(e!==this.current||this.dirty)&&(this.gl.depthFunc(e),this.current=e,this.dirty=!1);}}class ie extends Z{getDefault(){return !1}set(e){if(e===this.current&&!this.dirty)return;const t=this.gl;e?t.enable(t.BLEND):t.disable(t.BLEND),this.current=e,this.dirty=!1;}}class oe extends Z{getDefault(){const e=this.gl;return [e.ONE,e.ZERO]}set(e){const t=this.current;(e[0]!==t[0]||e[1]!==t[1]||this.dirty)&&(this.gl.blendFunc(e[0],e[1]),this.current=e,this.dirty=!1);}}class re extends Z{getDefault(){return e.Color.transparent}set(e){const t=this.current;(e.r!==t.r||e.g!==t.g||e.b!==t.b||e.a!==t.a||this.dirty)&&(this.gl.blendColor(e.r,e.g,e.b,e.a),this.current=e,this.dirty=!1);}}class ne extends Z{getDefault(){return this.gl.FUNC_ADD}set(e){(e!==this.current||this.dirty)&&(this.gl.blendEquation(e),this.current=e,this.dirty=!1);}}class ae extends Z{getDefault(){return !1}set(e){if(e===this.current&&!this.dirty)return;const t=this.gl;e?t.enable(t.CULL_FACE):t.disable(t.CULL_FACE),this.current=e,this.dirty=!1;}}class se extends Z{getDefault(){return this.gl.BACK}set(e){(e!==this.current||this.dirty)&&(this.gl.cullFace(e),this.current=e,this.dirty=!1);}}class le extends Z{getDefault(){return this.gl.CCW}set(e){(e!==this.current||this.dirty)&&(this.gl.frontFace(e),this.current=e,this.dirty=!1);}}class ce extends Z{getDefault(){return null}set(e){(e!==this.current||this.dirty)&&(this.gl.useProgram(e),this.current=e,this.dirty=!1);}}class he extends Z{getDefault(){return this.gl.TEXTURE0}set(e){(e!==this.current||this.dirty)&&(this.gl.activeTexture(e),this.current=e,this.dirty=!1);}}class ue extends Z{getDefault(){const e=this.gl;return [0,0,e.drawingBufferWidth,e.drawingBufferHeight]}set(e){const t=this.current;(e[0]!==t[0]||e[1]!==t[1]||e[2]!==t[2]||e[3]!==t[3]||this.dirty)&&(this.gl.viewport(e[0],e[1],e[2],e[3]),this.current=e,this.dirty=!1);}}class _e extends Z{getDefault(){return null}set(e){if(e===this.current&&!this.dirty)return;const t=this.gl;t.bindFramebuffer(t.FRAMEBUFFER,e),this.current=e,this.dirty=!1;}}class de extends Z{getDefault(){return null}set(e){if(e===this.current&&!this.dirty)return;const t=this.gl;t.bindRenderbuffer(t.RENDERBUFFER,e),this.current=e,this.dirty=!1;}}class pe extends Z{getDefault(){return null}set(e){if(e===this.current&&!this.dirty)return;const t=this.gl;t.bindTexture(t.TEXTURE_2D,e),this.current=e,this.dirty=!1;}}class me extends Z{getDefault(){return null}set(e){if(e===this.current&&!this.dirty)return;const t=this.gl;t.bindBuffer(t.ARRAY_BUFFER,e),this.current=e,this.dirty=!1;}}class fe extends Z{getDefault(){return null}set(e){const t=this.gl;t.bindBuffer(t.ELEMENT_ARRAY_BUFFER,e),this.current=e,this.dirty=!1;}}class ge extends Z{constructor(e){super(e),this.vao=e.extVertexArrayObject;}getDefault(){return null}set(e){this.vao&&(e!==this.current||this.dirty)&&(this.vao.bindVertexArrayOES(e),this.current=e,this.dirty=!1);}}class ve extends Z{getDefault(){return 4}set(e){if(e===this.current&&!this.dirty)return;const t=this.gl;t.pixelStorei(t.UNPACK_ALIGNMENT,e),this.current=e,this.dirty=!1;}}class xe extends Z{getDefault(){return !1}set(e){if(e===this.current&&!this.dirty)return;const t=this.gl;t.pixelStorei(t.UNPACK_PREMULTIPLY_ALPHA_WEBGL,e),this.current=e,this.dirty=!1;}}class ye extends Z{getDefault(){return !1}set(e){if(e===this.current&&!this.dirty)return;const t=this.gl;t.pixelStorei(t.UNPACK_FLIP_Y_WEBGL,e),this.current=e,this.dirty=!1;}}class be extends Z{constructor(e,t){super(e),this.context=e,this.parent=t;}getDefault(){return null}}class we extends be{setDirty(){this.dirty=!0;}set(e){if(e===this.current&&!this.dirty)return;this.context.bindFramebuffer.set(this.parent);const t=this.gl;t.framebufferTexture2D(t.FRAMEBUFFER,t.COLOR_ATTACHMENT0,t.TEXTURE_2D,e,0),this.current=e,this.dirty=!1;}}class Te extends be{attachment(){return this.gl.DEPTH_ATTACHMENT}set(e){if(e===this.current&&!this.dirty)return;this.context.bindFramebuffer.set(this.parent);const t=this.gl;t.framebufferRenderbuffer(t.FRAMEBUFFER,this.attachment(),t.RENDERBUFFER,e),this.current=e,this.dirty=!1;}}class Ee extends Te{attachment(){return this.gl.DEPTH_STENCIL_ATTACHMENT}}class Ce{constructor(e,t,i,o){this.context=e,this.width=t,this.height=i;const r=this.framebuffer=e.gl.createFramebuffer();this.colorAttachment=new we(e,r),o&&(this.depthAttachment=new Te(e,r));}destroy(){const e=this.context.gl,t=this.colorAttachment.get();if(t&&e.deleteTexture(t),this.depthAttachment){const t=this.depthAttachment.get();t&&e.deleteRenderbuffer(t);}e.deleteFramebuffer(this.framebuffer);}}class Ie{constructor(e){this.gl=e,this.extVertexArrayObject=this.gl.getExtension("OES_vertex_array_object"),this.clearColor=new V(this),this.clearDepth=new W(this),this.clearStencil=new X(this),this.colorMask=new q(this),this.depthMask=new $(this),this.stencilMask=new H(this),this.stencilFunc=new Y(this),this.stencilOp=new K(this),this.stencilTest=new J(this),this.depthRange=new Q(this),this.depthTest=new ee(this),this.depthFunc=new te(this),this.blend=new ie(this),this.blendFunc=new oe(this),this.blendColor=new re(this),this.blendEquation=new ne(this),this.cullFace=new ae(this),this.cullFaceSide=new se(this),this.frontFace=new le(this),this.program=new ce(this),this.activeTexture=new he(this),this.viewport=new ue(this),this.bindFramebuffer=new _e(this),this.bindRenderbuffer=new de(this),this.bindTexture=new pe(this),this.bindVertexBuffer=new me(this),this.bindElementBuffer=new fe(this),this.bindVertexArrayOES=this.extVertexArrayObject&&new ge(this),this.pixelStoreUnpack=new ve(this),this.pixelStoreUnpackPremultiplyAlpha=new xe(this),this.pixelStoreUnpackFlipY=new ye(this),this.extTextureFilterAnisotropic=e.getExtension("EXT_texture_filter_anisotropic")||e.getExtension("MOZ_EXT_texture_filter_anisotropic")||e.getExtension("WEBKIT_EXT_texture_filter_anisotropic"),this.extTextureFilterAnisotropic&&(this.extTextureFilterAnisotropicMax=e.getParameter(this.extTextureFilterAnisotropic.MAX_TEXTURE_MAX_ANISOTROPY_EXT)),this.extTextureFilterAnisotropicForceOff=!1,this.extStandardDerivativesForceOff=!1,this.extTextureHalfFloat=e.getExtension("OES_texture_half_float"),this.extTextureHalfFloat&&(e.getExtension("OES_texture_half_float_linear"),this.extRenderToTextureHalfFloat=e.getExtension("EXT_color_buffer_half_float")),this.extStandardDerivatives=e.getExtension("OES_standard_derivatives"),this.extTimerQuery=e.getExtension("EXT_disjoint_timer_query"),this.maxTextureSize=e.getParameter(e.MAX_TEXTURE_SIZE);}setDefault(){this.unbindVAO(),this.clearColor.setDefault(),this.clearDepth.setDefault(),this.clearStencil.setDefault(),this.colorMask.setDefault(),this.depthMask.setDefault(),this.stencilMask.setDefault(),this.stencilFunc.setDefault(),this.stencilOp.setDefault(),this.stencilTest.setDefault(),this.depthRange.setDefault(),this.depthTest.setDefault(),this.depthFunc.setDefault(),this.blend.setDefault(),this.blendFunc.setDefault(),this.blendColor.setDefault(),this.blendEquation.setDefault(),this.cullFace.setDefault(),this.cullFaceSide.setDefault(),this.frontFace.setDefault(),this.program.setDefault(),this.activeTexture.setDefault(),this.bindFramebuffer.setDefault(),this.pixelStoreUnpack.setDefault(),this.pixelStoreUnpackPremultiplyAlpha.setDefault(),this.pixelStoreUnpackFlipY.setDefault();}setDirty(){this.clearColor.dirty=!0,this.clearDepth.dirty=!0,this.clearStencil.dirty=!0,this.colorMask.dirty=!0,this.depthMask.dirty=!0,this.stencilMask.dirty=!0,this.stencilFunc.dirty=!0,this.stencilOp.dirty=!0,this.stencilTest.dirty=!0,this.depthRange.dirty=!0,this.depthTest.dirty=!0,this.depthFunc.dirty=!0,this.blend.dirty=!0,this.blendFunc.dirty=!0,this.blendColor.dirty=!0,this.blendEquation.dirty=!0,this.cullFace.dirty=!0,this.cullFaceSide.dirty=!0,this.frontFace.dirty=!0,this.program.dirty=!0,this.activeTexture.dirty=!0,this.viewport.dirty=!0,this.bindFramebuffer.dirty=!0,this.bindRenderbuffer.dirty=!0,this.bindTexture.dirty=!0,this.bindVertexBuffer.dirty=!0,this.bindElementBuffer.dirty=!0,this.extVertexArrayObject&&(this.bindVertexArrayOES.dirty=!0),this.pixelStoreUnpack.dirty=!0,this.pixelStoreUnpackPremultiplyAlpha.dirty=!0,this.pixelStoreUnpackFlipY.dirty=!0;}createIndexBuffer(e,t){return new N(this,e,t)}createVertexBuffer(e,t,i){return new j(this,e,t,i)}createRenderbuffer(e,t,i){const o=this.gl,r=o.createRenderbuffer();return this.bindRenderbuffer.set(r),o.renderbufferStorage(o.RENDERBUFFER,e,t,i),this.bindRenderbuffer.set(null),r}createFramebuffer(e,t,i){return new Ce(this,e,t,i)}clear({color:e,depth:t,stencil:i}){const o=this.gl;let r=0;e&&(r|=o.COLOR_BUFFER_BIT,this.clearColor.set(e),this.colorMask.set([!0,!0,!0,!0])),void 0!==t&&(r|=o.DEPTH_BUFFER_BIT,this.depthRange.set([0,1]),this.clearDepth.set(t),this.depthMask.set(!0)),void 0!==i&&(r|=o.STENCIL_BUFFER_BIT,this.clearStencil.set(i),this.stencilMask.set(255)),o.clear(r);}setCullFace(e){!1===e.enable?this.cullFace.set(!1):(this.cullFace.set(!0),this.cullFaceSide.set(e.mode),this.frontFace.set(e.frontFace));}setDepthMode(e){e.func!==this.gl.ALWAYS||e.mask?(this.depthTest.set(!0),this.depthFunc.set(e.func),this.depthMask.set(e.mask),this.depthRange.set(e.range)):this.depthTest.set(!1);}setStencilMode(e){e.test.func!==this.gl.ALWAYS||e.mask?(this.stencilTest.set(!0),this.stencilMask.set(e.mask),this.stencilOp.set([e.fail,e.depthFail,e.pass]),this.stencilFunc.set({func:e.test.func,ref:e.ref,mask:e.test.mask})):this.stencilTest.set(!1);}setColorMode(i){t(i.blendFunction,e.ColorMode.Replace)?this.blend.set(!1):(this.blend.set(!0),this.blendFunc.set(i.blendFunction),this.blendColor.set(i.blendColor)),this.colorMask.set(i.mask);}unbindVAO(){this.extVertexArrayObject&&this.bindVertexArrayOES.set(null);}}class Me extends e.Evented{constructor(t,i,o,r){super(),this.id=t,this.dispatcher=o,this.setEventedParent(r),this.type="raster",this.minzoom=0,this.maxzoom=22,this.roundZoom=!0,this.scheme="xyz",this.tileSize=512,this._loaded=!1,this._options=e.extend({type:"raster"},i),e.extend(this,e.pick(i,["url","scheme","tileSize"]));}load(){this._loaded=!1,this.fire(new e.Event("dataloading",{dataType:"source"})),this._tileJSONRequest=F(this._options,this.map._requestManager,null,null,((t,i)=>{this._tileJSONRequest=null,this._loaded=!0,t?this.fire(new e.ErrorEvent(t)):i&&(e.extend(this,i),i.bounds&&(this.tileBounds=new U(i.bounds,this.minzoom,this.maxzoom)),e.postTurnstileEvent(i.tiles),this.fire(new e.Event("data",{dataType:"source",sourceDataType:"metadata"})),this.fire(new e.Event("data",{dataType:"source",sourceDataType:"content"})));}));}loaded(){return this._loaded}onAdd(e){this.map=e,this.load();}onRemove(){this._tileJSONRequest&&(this._tileJSONRequest.cancel(),this._tileJSONRequest=null);}serialize(){return e.extend({},this._options)}hasTile(e){return !this.tileBounds||this.tileBounds.contains(e.canonical)}loadTile(t,i){const o=e.exported.devicePixelRatio>=2,r=this.map._requestManager.normalizeTileURL(t.tileID.canonical.url(this.tiles,this.scheme),o,this.tileSize);t.request=e.getImage(this.map._requestManager.transformRequest(r,e.ResourceType.Tile),((o,r,n,a)=>(delete t.request,t.aborted?(t.state="unloaded",i(null)):o?(t.state="errored",i(o)):r?(this.map._refreshExpiredTiles&&t.setExpiryData({cacheControl:n,expires:a}),t.setTexture(r,this.map.painter),t.state="loaded",e.cacheEntryPossiblyAdded(this.dispatcher),void i(null)):i(null))));}static loadTileData(e,t,i){e.setTexture(t,i);}static unloadTileData(e,t){e.texture&&t.saveTileTexture(e.texture);}abortTile(e,t){e.request&&(e.request.cancel(),delete e.request),t();}unloadTile(e,t){e.texture&&this.map.painter.saveTileTexture(e.texture),t();}hasTransition(){return !1}}let Se;function ze(t,i,o,r,n,a,s,l){const c=[t,o,n,i,r,a,1,1,1],h=[s,l,1],u=e.adjoint([],c),[_,d,p]=e.transformMat3(h,h,e.transpose(u,u));return e.multiply$1(c,[_,0,0,0,d,0,0,0,p],c)}class De extends e.Evented{constructor(e,t,i,o){super(),this.id=e,this.dispatcher=i,this.coordinates=t.coordinates,this.type="image",this.minzoom=0,this.maxzoom=22,this.tileSize=512,this.tiles={},this._loaded=!1,this.setEventedParent(o),this.options=t;}load(t,i){this._loaded=i||!1,this.fire(new e.Event("dataloading",{dataType:"source"})),this.url=this.options.url,e.getImage(this.map._requestManager.transformRequest(this.url,e.ResourceType.Image),((i,o)=>{if(this._loaded=!0,i)this.fire(new e.ErrorEvent(i));else if(o){const{HTMLImageElement:i}=e.window;this.image=o instanceof i?e.exported.getImageData(o):o,this.width=this.image.width,this.height=this.image.height,t&&(this.coordinates=t),this._finishLoading();}}));}loaded(){return this._loaded}updateImage(e){return this.image&&e.url?(this.options.url=e.url,this.load(e.coordinates,this._loaded),this):this}_finishLoading(){this.map&&(this.setCoordinates(this.coordinates),this.fire(new e.Event("data",{dataType:"source",sourceDataType:"metadata"})));}onAdd(e){this.map=e,this.load();}onRemove(){this.texture&&this.texture.destroy();}setCoordinates(t){this.coordinates=t,this._boundsArray=void 0;const i=t.map(e.MercatorCoordinate.fromLngLat);return this.tileID=function(t){let i=1/0,o=1/0,r=-1/0,n=-1/0;for(const e of t)i=Math.min(i,e.x),o=Math.min(o,e.y),r=Math.max(r,e.x),n=Math.max(n,e.y);const a=Math.max(r-i,n-o),s=Math.max(0,Math.floor(-Math.log(a)/Math.LN2)),l=Math.pow(2,s);return new e.CanonicalTileID(s,Math.floor((i+r)/2*l),Math.floor((o+n)/2*l))}(i),this.minzoom=this.maxzoom=this.tileID.z,this.fire(new e.Event("data",{dataType:"source",sourceDataType:"content"})),this}_clear(){this._boundsArray=void 0;}_prepareData(t){for(const e in this.tiles){const t=this.tiles[e];"loaded"!==t.state&&(t.state="loaded",t.texture=this.texture);}if(this._boundsArray)return;const i=e.tileTransform(this.tileID,this.map.transform.projection),[o,r,n,a]=this.coordinates.map((t=>{const o=i.projection.project(t[0],t[1]);return e.getTilePoint(i,o)._round()}));this.perspectiveTransform=function(t,i,o,r,n,a,s,l,c,h){const u=ze(0,0,t,0,0,i,t,i),_=ze(o,r,n,a,s,l,c,h);return e.multiply$1(_,e.adjoint(u,u),_),[_[6]/_[8]*t/e.EXTENT,_[7]/_[8]*i/e.EXTENT]}(this.width,this.height,o.x,o.y,r.x,r.y,a.x,a.y,n.x,n.y);const s=this._boundsArray=new e.StructArrayLayout4i8;s.emplaceBack(o.x,o.y,0,0),s.emplaceBack(r.x,r.y,e.EXTENT,0),s.emplaceBack(a.x,a.y,0,e.EXTENT),s.emplaceBack(n.x,n.y,e.EXTENT,e.EXTENT),this.boundsBuffer&&this.boundsBuffer.destroy(),this.boundsBuffer=t.createVertexBuffer(s,e.boundsAttributes.members),this.boundsSegments=e.SegmentVector.simpleSegment(0,0,4,2);}prepare(){if(0===Object.keys(this.tiles).length||!this.image)return;const t=this.map.painter.context,i=t.gl;this.texture?this.texture.update(this.image):(this.texture=new e.Texture(t,this.image,i.RGBA),this.texture.bind(i.LINEAR,i.CLAMP_TO_EDGE)),this._prepareData(t);}loadTile(e,t){this.tileID&&this.tileID.equals(e.tileID.canonical)?(this.tiles[String(e.tileID.wrap)]=e,e.buckets={},t(null)):(e.state="errored",t(null));}serialize(){return {type:"image",url:this.options.url,coordinates:this.coordinates}}hasTransition(){return !1}}const Pe={vector:class extends e.Evented{constructor(t,i,o,r){if(super(),this.id=t,this.dispatcher=o,this.type="vector",this.minzoom=0,this.maxzoom=22,this.scheme="xyz",this.tileSize=512,this.reparseOverscaled=!0,this.isTileClipped=!0,this._loaded=!1,e.extend(this,e.pick(i,["url","scheme","tileSize","promoteId"])),this._options=e.extend({type:"vector"},i),this._collectResourceTiming=i.collectResourceTiming,512!==this.tileSize)throw new Error("vector tile sources must have a tileSize of 512");this.setEventedParent(r),this._tileWorkers={},this._deduped=new e.DedupedRequest;}load(t){this._loaded=!1,this.fire(new e.Event("dataloading",{dataType:"source"}));const i=this.language||this.map._language,o=this.worldview||this.map._worldview;this._tileJSONRequest=F(this._options,this.map._requestManager,i,o,((r,n)=>{this._tileJSONRequest=null,this._loaded=!0,r?(i&&console.warn(`Ensure that your requested language string is a valid BCP-47 code. Found: ${i}`),o&&2!==o.length&&console.warn(`Requested worldview strings must be a valid ISO alpha-2 code. Found: ${o}`),this.fire(new e.ErrorEvent(r))):n&&(e.extend(this,n),n.bounds&&(this.tileBounds=new U(n.bounds,this.minzoom,this.maxzoom)),e.postTurnstileEvent(n.tiles,this.map._requestManager._customAccessToken),this.fire(new e.Event("data",{dataType:"source",sourceDataType:"metadata"})),this.fire(new e.Event("data",{dataType:"source",sourceDataType:"content"}))),t&&t(r);}));}loaded(){return this._loaded}hasTile(e){return !this.tileBounds||this.tileBounds.contains(e.canonical)}onAdd(e){this.map=e,this.load();}setSourceProperty(e){this._tileJSONRequest&&this._tileJSONRequest.cancel(),e(),this.load((()=>{const e=this.map.style._getSourceCaches(this.id);for(const t of e)t.clearTiles();}));}setTiles(e){return this.setSourceProperty((()=>{this._options.tiles=e;})),this}setUrl(e){return this.setSourceProperty((()=>{this.url=e,this._options.url=e;})),this}_setLanguage(e){return e===this.language||this.setSourceProperty((()=>{this.language=e;})),this}_setWorldview(e){return e===this.worldview?this:this.worldviewOptions&&e&&!this.worldviewOptions[e]?(console.warn(`Vector tile source "${this.id}" does not support worldview "${e}".`),this):(this.setSourceProperty((()=>{this.worldview=e;})),this)}onRemove(){this._tileJSONRequest&&(this._tileJSONRequest.cancel(),this._tileJSONRequest=null);}serialize(){return e.extend({},this._options)}loadTile(t,i){const o=this.map._requestManager.normalizeTileURL(t.tileID.canonical.url(this.tiles,this.scheme)),r={request:this.map._requestManager.transformRequest(o,e.ResourceType.Tile),data:void 0,uid:t.uid,tileID:t.tileID,tileZoom:t.tileZoom,zoom:t.tileID.overscaledZ,tileSize:this.tileSize*t.tileID.overscaleFactor(),type:this.type,source:this.id,pixelRatio:e.exported.devicePixelRatio,showCollisionBoxes:this.map.showCollisionBoxes,promoteId:this.promoteId,isSymbolTile:t.isSymbolTile};if(r.request.collectResourceTiming=this._collectResourceTiming,t.actor&&"expired"!==t.state)"loading"===t.state?t.reloadCallback=i:t.request=t.actor.send("reloadTile",r,n.bind(this));else if(t.actor=this._tileWorkers[o]=this._tileWorkers[o]||this.dispatcher.getActor(),this.dispatcher.ready)t.request=t.actor.send("loadTile",r,n.bind(this),void 0,!0);else {const i=e.loadVectorTile.call({deduped:this._deduped},r,((e,i)=>{e||!i?n.call(this,e):(r.data={cacheControl:i.cacheControl,expires:i.expires,rawData:i.rawData.slice(0)},t.actor&&t.actor.send("loadTile",r,n.bind(this),void 0,!0));}),!0);t.request={cancel:i};}function n(o,r){return delete t.request,t.aborted?i(null):o&&404!==o.status?i(o):(r&&r.resourceTiming&&(t.resourceTiming=r.resourceTiming),this.map._refreshExpiredTiles&&r&&t.setExpiryData(r),t.loadVectorData(r,this.map.painter),e.cacheEntryPossiblyAdded(this.dispatcher),i(null),void(t.reloadCallback&&(this.loadTile(t,t.reloadCallback),t.reloadCallback=null)))}}abortTile(e){e.request&&(e.request.cancel(),delete e.request),e.actor&&e.actor.send("abortTile",{uid:e.uid,type:this.type,source:this.id});}unloadTile(e){e.unloadVectorData(),e.actor&&e.actor.send("removeTile",{uid:e.uid,type:this.type,source:this.id});}hasTransition(){return !1}afterUpdate(){this._tileWorkers={};}},raster:Me,"raster-dem":class extends Me{constructor(t,i,o,r){super(t,i,o,r),this.type="raster-dem",this.maxzoom=22,this._options=e.extend({type:"raster-dem"},i),this.encoding=i.encoding||"mapbox";}loadTile(t,i){const o=this.map._requestManager.normalizeTileURL(t.tileID.canonical.url(this.tiles,this.scheme),!1,this.tileSize);function r(e,o){e&&(t.state="errored",i(e)),o&&(t.dem=o,t.dem.onDeserialize(),t.needsHillshadePrepare=!0,t.needsDEMTextureUpload=!0,t.state="loaded",i(null));}t.request=e.getImage(this.map._requestManager.transformRequest(o,e.ResourceType.Tile),function(o,n,a,s){if(delete t.request,t.aborted)t.state="unloaded",i(null);else if(o)t.state="errored",i(o);else if(n){this.map._refreshExpiredTiles&&t.setExpiryData({cacheControl:a,expires:s});const i=e.window.ImageBitmap&&n instanceof e.window.ImageBitmap&&(null==Se&&(Se=e.window.OffscreenCanvas&&new e.window.OffscreenCanvas(1,1).getContext("2d")&&"function"==typeof e.window.createImageBitmap),Se),o=1-(n.width-e.prevPowerOfTwo(n.width))/2;o<1||t.neighboringTiles||(t.neighboringTiles=this._getNeighboringTiles(t.tileID));const l=i?n:e.exported.getImageData(n,o),c={uid:t.uid,coord:t.tileID,source:this.id,rawImageData:l,encoding:this.encoding,padding:o};t.actor&&"expired"!==t.state||(t.actor=this.dispatcher.getActor(),t.actor.send("loadDEMTile",c,r.bind(this),void 0,!0));}}.bind(this));}_getNeighboringTiles(t){const i=t.canonical,o=Math.pow(2,i.z),r=(i.x-1+o)%o,n=0===i.x?t.wrap-1:t.wrap,a=(i.x+1+o)%o,s=i.x+1===o?t.wrap+1:t.wrap,l={};return l[new e.OverscaledTileID(t.overscaledZ,n,i.z,r,i.y).key]={backfilled:!1},l[new e.OverscaledTileID(t.overscaledZ,s,i.z,a,i.y).key]={backfilled:!1},i.y>0&&(l[new e.OverscaledTileID(t.overscaledZ,n,i.z,r,i.y-1).key]={backfilled:!1},l[new e.OverscaledTileID(t.overscaledZ,t.wrap,i.z,i.x,i.y-1).key]={backfilled:!1},l[new e.OverscaledTileID(t.overscaledZ,s,i.z,a,i.y-1).key]={backfilled:!1}),i.y+1<o&&(l[new e.OverscaledTileID(t.overscaledZ,n,i.z,r,i.y+1).key]={backfilled:!1},l[new e.OverscaledTileID(t.overscaledZ,t.wrap,i.z,i.x,i.y+1).key]={backfilled:!1},l[new e.OverscaledTileID(t.overscaledZ,s,i.z,a,i.y+1).key]={backfilled:!1}),l}unloadTile(e){e.demTexture&&this.map.painter.saveTileTexture(e.demTexture),e.fbo&&(e.fbo.destroy(),delete e.fbo),e.dem&&delete e.dem,delete e.neighboringTiles,e.state="unloaded";}},geojson:class extends e.Evented{constructor(t,i,o,r){super(),this.id=t,this.type="geojson",this.minzoom=0,this.maxzoom=18,this.tileSize=512,this.isTileClipped=!0,this.reparseOverscaled=!0,this._loaded=!1,this.actor=o.getActor(),this.setEventedParent(r),this._data=i.data,this._options=e.extend({},i),this._collectResourceTiming=i.collectResourceTiming,void 0!==i.maxzoom&&(this.maxzoom=i.maxzoom),i.type&&(this.type=i.type),i.attribution&&(this.attribution=i.attribution),this.promoteId=i.promoteId;const n=e.EXTENT/this.tileSize;this.workerOptions=e.extend({source:this.id,cluster:i.cluster||!1,geojsonVtOptions:{buffer:(void 0!==i.buffer?i.buffer:128)*n,tolerance:(void 0!==i.tolerance?i.tolerance:.375)*n,extent:e.EXTENT,maxZoom:this.maxzoom,lineMetrics:i.lineMetrics||!1,generateId:i.generateId||!1},superclusterOptions:{maxZoom:void 0!==i.clusterMaxZoom?i.clusterMaxZoom:this.maxzoom-1,minPoints:Math.max(2,i.clusterMinPoints||2),extent:e.EXTENT,radius:(void 0!==i.clusterRadius?i.clusterRadius:50)*n,log:!1,generateId:i.generateId||!1},clusterProperties:i.clusterProperties,filter:i.filter},i.workerOptions);}onAdd(e){this.map=e,this.setData(this._data);}setData(e){return this._data=e,this._updateWorkerData(),this}getClusterExpansionZoom(e,t){return this.actor.send("geojson.getClusterExpansionZoom",{clusterId:e,source:this.id},t),this}getClusterChildren(e,t){return this.actor.send("geojson.getClusterChildren",{clusterId:e,source:this.id},t),this}getClusterLeaves(e,t,i,o){return this.actor.send("geojson.getClusterLeaves",{source:this.id,clusterId:e,limit:t,offset:i},o),this}_updateWorkerData(){if(this._pendingLoad)return void(this._coalesce=!0);this.fire(new e.Event("dataloading",{dataType:"source"})),this._loaded=!1;const t=e.extend({},this.workerOptions),i=this._data;"string"==typeof i?(t.request=this.map._requestManager.transformRequest(e.exported.resolveURL(i),e.ResourceType.Source),t.request.collectResourceTiming=this._collectResourceTiming):t.data=JSON.stringify(i),this._pendingLoad=this.actor.send(`${this.type}.loadData`,t,((t,i)=>{if(this._loaded=!0,this._pendingLoad=null,t)this.fire(new e.ErrorEvent(t));else {const t={dataType:"source",sourceDataType:this._metadataFired?"content":"metadata"};this._collectResourceTiming&&i&&i.resourceTiming&&i.resourceTiming[this.id]&&(t.resourceTiming=i.resourceTiming[this.id]),this.fire(new e.Event("data",t)),this._metadataFired=!0;}this._coalesce&&(this._updateWorkerData(),this._coalesce=!1);}));}loaded(){return this._loaded}loadTile(t,i){const o=t.actor?"reloadTile":"loadTile";t.actor=this.actor,t.request=this.actor.send(o,{type:this.type,uid:t.uid,tileID:t.tileID,tileZoom:t.tileZoom,zoom:t.tileID.overscaledZ,maxZoom:this.maxzoom,tileSize:this.tileSize,source:this.id,pixelRatio:e.exported.devicePixelRatio,showCollisionBoxes:this.map.showCollisionBoxes,promoteId:this.promoteId},((e,r)=>(delete t.request,t.unloadVectorData(),t.aborted?i(null):e?i(e):(t.loadVectorData(r,this.map.painter,"reloadTile"===o),i(null)))),void 0,"loadTile"===o);}abortTile(e){e.request&&(e.request.cancel(),delete e.request),e.aborted=!0;}unloadTile(e){e.unloadVectorData(),this.actor.send("removeTile",{uid:e.uid,type:this.type,source:this.id});}onRemove(){this._pendingLoad&&this._pendingLoad.cancel();}serialize(){return e.extend({},this._options,{type:this.type,data:this._data})}hasTransition(){return !1}},video:class extends De{constructor(e,t,i,o){super(e,t,i,o),this.roundZoom=!0,this.type="video",this.options=t;}load(){this._loaded=!1;const t=this.options;this.urls=[];for(const i of t.urls)this.urls.push(this.map._requestManager.transformRequest(i,e.ResourceType.Source).url);e.getVideo(this.urls,((t,i)=>{this._loaded=!0,t?this.fire(new e.ErrorEvent(t)):i&&(this.video=i,this.video.loop=!0,this.video.setAttribute("playsinline",""),this.video.addEventListener("playing",(()=>{this.map.triggerRepaint();})),this.map&&this.video.play(),this._finishLoading());}));}pause(){this.video&&this.video.pause();}play(){this.video&&this.video.play();}seek(t){if(this.video){const i=this.video.seekable;t<i.start(0)||t>i.end(0)?this.fire(new e.ErrorEvent(new e.ValidationError(`sources.${this.id}`,null,`Playback for this video can be set only between the ${i.start(0)} and ${i.end(0)}-second mark.`))):this.video.currentTime=t;}}getVideo(){return this.video}onAdd(e){this.map||(this.map=e,this.load(),this.video&&(this.video.play(),this.setCoordinates(this.coordinates)));}prepare(){if(0===Object.keys(this.tiles).length||this.video.readyState<2)return;const t=this.map.painter.context,i=t.gl;this.texture?this.video.paused||(this.texture.bind(i.LINEAR,i.CLAMP_TO_EDGE),i.texSubImage2D(i.TEXTURE_2D,0,0,0,i.RGBA,i.UNSIGNED_BYTE,this.video)):(this.texture=new e.Texture(t,this.video,i.RGBA),this.texture.bind(i.LINEAR,i.CLAMP_TO_EDGE),this.width=this.video.videoWidth,this.height=this.video.videoHeight),this._prepareData(t);}serialize(){return {type:"video",urls:this.urls,coordinates:this.coordinates}}hasTransition(){return this.video&&!this.video.paused}},image:De,canvas:class extends De{constructor(t,i,o,r){super(t,i,o,r),i.coordinates?Array.isArray(i.coordinates)&&4===i.coordinates.length&&!i.coordinates.some((e=>!Array.isArray(e)||2!==e.length||e.some((e=>"number"!=typeof e))))||this.fire(new e.ErrorEvent(new e.ValidationError(`sources.${t}`,null,'"coordinates" property must be an array of 4 longitude/latitude array pairs'))):this.fire(new e.ErrorEvent(new e.ValidationError(`sources.${t}`,null,'missing required property "coordinates"'))),i.animate&&"boolean"!=typeof i.animate&&this.fire(new e.ErrorEvent(new e.ValidationError(`sources.${t}`,null,'optional "animate" property must be a boolean value'))),i.canvas?"string"==typeof i.canvas||i.canvas instanceof e.window.HTMLCanvasElement||this.fire(new e.ErrorEvent(new e.ValidationError(`sources.${t}`,null,'"canvas" must be either a string representing the ID of the canvas element from which to read, or an HTMLCanvasElement instance'))):this.fire(new e.ErrorEvent(new e.ValidationError(`sources.${t}`,null,'missing required property "canvas"'))),this.options=i,this.animate=void 0===i.animate||i.animate;}load(){this._loaded=!0,this.canvas||(this.canvas=this.options.canvas instanceof e.window.HTMLCanvasElement?this.options.canvas:e.window.document.getElementById(this.options.canvas)),this.width=this.canvas.width,this.height=this.canvas.height,this._hasInvalidDimensions()?this.fire(new e.ErrorEvent(new Error("Canvas dimensions cannot be less than or equal to zero."))):(this.play=function(){this._playing=!0,this.map.triggerRepaint();},this.pause=function(){this._playing&&(this.prepare(),this._playing=!1);},this._finishLoading());}getCanvas(){return this.canvas}onAdd(e){this.map=e,this.load(),this.canvas&&this.animate&&this.play();}onRemove(){this.pause();}prepare(){let t=!1;if(this.canvas.width!==this.width&&(this.width=this.canvas.width,t=!0),this.canvas.height!==this.height&&(this.height=this.canvas.height,t=!0),this._hasInvalidDimensions())return;if(0===Object.keys(this.tiles).length)return;const i=this.map.painter.context;this.texture?(t||this._playing)&&this.texture.update(this.canvas,{premultiply:!0}):this.texture=new e.Texture(i,this.canvas,i.gl.RGBA,{premultiply:!0}),this._prepareData(i);}serialize(){return {type:"canvas",coordinates:this.coordinates}}hasTransition(){return this._playing}_hasInvalidDimensions(){for(const e of [this.canvas.width,this.canvas.height])if(isNaN(e)||e<=0)return !0;return !1}},custom:class extends e.Evented{constructor(t,i,o,r){super(),this.id=t,this.type="custom",this._dataType="raster",this._dispatcher=o,this._implementation=i,this.setEventedParent(r),this.scheme="xyz",this.minzoom=0,this.maxzoom=22,this.tileSize=512,this._loaded=!1,this.roundZoom=!0,this._implementation||this.fire(new e.ErrorEvent(new Error(`Missing implementation for ${this.id} custom source`))),this._implementation.loadTile||this.fire(new e.ErrorEvent(new Error(`Missing loadTile implementation for ${this.id} custom source`))),this._implementation.bounds&&(this.tileBounds=new U(this._implementation.bounds,this.minzoom,this.maxzoom)),i.update=this._update.bind(this),i.coveringTiles=this._coveringTiles.bind(this),e.extend(this,e.pick(i,["dataType","scheme","minzoom","maxzoom","tileSize","attribution","minTileCacheSize","maxTileCacheSize"]));}serialize(){return e.pick(this,["type","scheme","minzoom","maxzoom","tileSize","attribution"])}load(){this._loaded=!0,this.fire(new e.Event("data",{dataType:"source",sourceDataType:"metadata"})),this.fire(new e.Event("data",{dataType:"source",sourceDataType:"content"}));}loaded(){return this._loaded}onAdd(t){this._map=t,this._loaded=!1,this.fire(new e.Event("dataloading",{dataType:"source"})),this._implementation.onAdd&&this._implementation.onAdd(t),this.load();}onRemove(e){this._implementation.onRemove&&this._implementation.onRemove(e);}hasTile(e){if(this._implementation.hasTile){const{x:t,y:i,z:o}=e.canonical;return this._implementation.hasTile({x:t,y:i,z:o})}return !this.tileBounds||this.tileBounds.contains(e.canonical)}loadTile(t,i){const{x:o,y:r,z:n}=t.tileID.canonical,a=new e.window.AbortController,s=this._implementation.loadTile({x:o,y:r,z:n},{signal:a.signal});if(!s)return this.loadTileData(t,{width:this.tileSize,height:this.tileSize,data:null}),t.state="loaded",i(null);s.cancel=()=>a.abort(),t.request=s.then(function(o){return delete t.request,t.aborted?(t.state="unloaded",i(null)):o?function(t){return t instanceof e.window.ImageData||t instanceof e.window.ImageBitmap||t instanceof e.window.HTMLCanvasElement}(o)?(this.loadTileData(t,o),t.state="loaded",void i(null)):(t.state="errored",i(new Error(`Can't infer data type for ${this.id}, only raster data supported at the moment`))):(this.loadTileData(t,{width:this.tileSize,height:this.tileSize,data:null}),t.state="loaded",i(null))}.bind(this)).catch((e=>{20!==e.code&&(t.state="errored",i(e));}));}loadTileData(e,t){Me.loadTileData(e,t,this._map.painter);}unloadTileData(e){Me.unloadTileData(e,this._map.painter);}prepareTile(e){if(!this._implementation.prepareTile)return null;const{x:t,y:i,z:o}=e.tileID.canonical,r=this._implementation.prepareTile({x:t,y:i,z:o});return r?(this.loadTileData(e,r),e.state="loaded",r):null}unloadTile(e,t){if(this.unloadTileData(e),this._implementation.unloadTile){const{x:t,y:i,z:o}=e.tileID.canonical;this._implementation.unloadTile({x:t,y:i,z:o});}t();}abortTile(e,t){e.request&&e.request.cancel&&(e.request.cancel(),delete e.request),t();}hasTransition(){return !1}_coveringTiles(){return this._map.transform.coveringTiles({tileSize:this.tileSize,minzoom:this.minzoom,maxzoom:this.maxzoom,roundZoom:this.roundZoom}).map((e=>({x:e.canonical.x,y:e.canonical.y,z:e.canonical.z})))}_update(){this.fire(new e.Event("data",{dataType:"source",sourceDataType:"content"}));}}},Ae=function(t,i,o,r){const n=new Pe[i.type](t,i,o,r);if(n.id!==t)throw new Error(`Expected Source id to be ${t} instead of ${n.id}`);return e.bindAll(["load","abort","unload","serialize","prepare"],n),n};function Le(t,i){const o=e.identity([]);return e.scale(o,o,[.5*t.width,.5*-t.height,1]),e.translate(o,o,[1,-1,0]),e.multiply(o,o,t.calculateProjMatrix(i.toUnwrapped())),Float32Array.from(o)}function Re(e,t,i,o,r,n,a,s=!1){const l=e.tilesIn(o,a,s);l.sort(Be);const c=[];for(const o of l)c.push({wrappedTileID:o.tile.tileID.wrapped().key,queryResults:o.tile.queryRenderedFeatures(t,i,e._state,o,r,n,Le(e.transform,o.tile.tileID),s)});const h=function(e){const t={},i={};for(const o of e){const e=o.queryResults,r=o.wrappedTileID,n=i[r]=i[r]||{};for(const i in e){const o=e[i],r=n[i]=n[i]||{},a=t[i]=t[i]||[];for(const e of o)r[e.featureIndex]||(r[e.featureIndex]=!0,a.push(e));}}return t}(c);for(const t in h)h[t].forEach((t=>{const i=t.feature,o=i.layer;o&&"background"!==o.type&&"sky"!==o.type&&(i.source=o.source,o["source-layer"]&&(i.sourceLayer=o["source-layer"]),i.state=void 0!==i.id?e.getFeatureState(o["source-layer"],i.id):{});}));return h}function Oe(e,t){const i=e.getRenderableIds().map((t=>e.getTileByID(t))),o=[],r={};for(let e=0;e<i.length;e++){const n=i[e],a=n.tileID.canonical.key;r[a]||(r[a]=!0,n.querySourceFeatures(o,t));}return o}function Be(e,t){const i=e.tileID,o=t.tileID;return i.overscaledZ-o.overscaledZ||i.canonical.y-o.canonical.y||i.wrap-o.wrap||i.canonical.x-o.canonical.x}function ke(){return null!=gn.workerClass?new gn.workerClass:new e.window.Worker(gn.workerUrl)}const Fe="mapboxgl_preloaded_worker_pool";class Ue{constructor(){this.active={};}acquire(e){if(!this.workers)for(this.workers=[];this.workers.length<Ue.workerCount;)this.workers.push(new ke);return this.active[e]=!0,this.workers.slice()}release(e){delete this.active[e],0===this.numActive()&&(this.workers.forEach((e=>{e.terminate();})),this.workers=null);}isPreloaded(){return !!this.active[Fe]}numActive(){return Object.keys(this.active).length}}let Ne;function Ge(){return Ne||(Ne=new Ue),Ne}function je(t,i){const o={};for(const e in t)"ref"!==e&&(o[e]=t[e]);return e.refProperties.forEach((e=>{e in i&&(o[e]=i[e]);})),o}function Ze(e){e=e.slice();const t=Object.create(null);for(let i=0;i<e.length;i++)t[e[i].id]=e[i];for(let i=0;i<e.length;i++)"ref"in e[i]&&(e[i]=je(e[i],t[e[i].ref]));return e}Ue.workerCount=2;const Ve={setStyle:"setStyle",addLayer:"addLayer",removeLayer:"removeLayer",setPaintProperty:"setPaintProperty",setLayoutProperty:"setLayoutProperty",setFilter:"setFilter",addSource:"addSource",removeSource:"removeSource",setGeoJSONSourceData:"setGeoJSONSourceData",setLayerZoomRange:"setLayerZoomRange",setLayerProperty:"setLayerProperty",setCenter:"setCenter",setZoom:"setZoom",setBearing:"setBearing",setPitch:"setPitch",setSprite:"setSprite",setGlyphs:"setGlyphs",setTransition:"setTransition",setLight:"setLight",setTerrain:"setTerrain",setFog:"setFog",setProjection:"setProjection"};function We(e,t,i){i.push({command:Ve.addSource,args:[e,t[e]]});}function Xe(e,t,i){t.push({command:Ve.removeSource,args:[e]}),i[e]=!0;}function qe(e,t,i,o){Xe(e,i,o),We(e,t,i);}function $e(e,i,o){let r;for(r in e[o])if(e[o].hasOwnProperty(r)&&"data"!==r&&!t(e[o][r],i[o][r]))return !1;for(r in i[o])if(i[o].hasOwnProperty(r)&&"data"!==r&&!t(e[o][r],i[o][r]))return !1;return !0}function He(e,i,o,r,n,a){let s;for(s in i=i||{},e=e||{})e.hasOwnProperty(s)&&(t(e[s],i[s])||o.push({command:a,args:[r,s,i[s],n]}));for(s in i)i.hasOwnProperty(s)&&!e.hasOwnProperty(s)&&(t(e[s],i[s])||o.push({command:a,args:[r,s,i[s],n]}));}function Ye(e){return e.id}function Ke(e,t){return e[t.id]=t,e}class Je{constructor(e,t){this.reset(e,t);}reset(e,t){this.points=e||[],this._distances=[0];for(let e=1;e<this.points.length;e++)this._distances[e]=this._distances[e-1]+this.points[e].dist(this.points[e-1]);this.length=this._distances[this._distances.length-1],this.padding=Math.min(t||0,.5*this.length),this.paddedLength=this.length-2*this.padding;}lerp(t){if(1===this.points.length)return this.points[0];t=e.clamp(t,0,1);let i=1,o=this._distances[i];const r=t*this.paddedLength+this.padding;for(;o<r&&i<this._distances.length;)o=this._distances[++i];const n=i-1,a=this._distances[n],s=o-a,l=s>0?(r-a)/s:0;return this.points[n].mult(1-l).add(this.points[i].mult(l))}}class Qe{constructor(e,t,i){const o=this.boxCells=[],r=this.circleCells=[];this.xCellCount=Math.ceil(e/i),this.yCellCount=Math.ceil(t/i);for(let e=0;e<this.xCellCount*this.yCellCount;e++)o.push([]),r.push([]);this.circleKeys=[],this.boxKeys=[],this.bboxes=[],this.circles=[],this.width=e,this.height=t,this.xScale=this.xCellCount/e,this.yScale=this.yCellCount/t,this.boxUid=0,this.circleUid=0;}keysLength(){return this.boxKeys.length+this.circleKeys.length}insert(e,t,i,o,r){this._forEachCell(t,i,o,r,this._insertBoxCell,this.boxUid++),this.boxKeys.push(e),this.bboxes.push(t),this.bboxes.push(i),this.bboxes.push(o),this.bboxes.push(r);}insertCircle(e,t,i,o){this._forEachCell(t-o,i-o,t+o,i+o,this._insertCircleCell,this.circleUid++),this.circleKeys.push(e),this.circles.push(t),this.circles.push(i),this.circles.push(o);}_insertBoxCell(e,t,i,o,r,n){this.boxCells[r].push(n);}_insertCircleCell(e,t,i,o,r,n){this.circleCells[r].push(n);}_query(e,t,i,o,r,n){if(i<0||e>this.width||o<0||t>this.height)return !r&&[];const a=[];if(e<=0&&t<=0&&this.width<=i&&this.height<=o){if(r)return !0;for(let e=0;e<this.boxKeys.length;e++)a.push({key:this.boxKeys[e],x1:this.bboxes[4*e],y1:this.bboxes[4*e+1],x2:this.bboxes[4*e+2],y2:this.bboxes[4*e+3]});for(let e=0;e<this.circleKeys.length;e++){const t=this.circles[3*e],i=this.circles[3*e+1],o=this.circles[3*e+2];a.push({key:this.circleKeys[e],x1:t-o,y1:i-o,x2:t+o,y2:i+o});}return n?a.filter(n):a}return this._forEachCell(e,t,i,o,this._queryCell,a,{hitTest:r,seenUids:{box:{},circle:{}}},n),r?a.length>0:a}_queryCircle(e,t,i,o,r){const n=e-i,a=e+i,s=t-i,l=t+i;if(a<0||n>this.width||l<0||s>this.height)return !o&&[];const c=[];return this._forEachCell(n,s,a,l,this._queryCellCircle,c,{hitTest:o,circle:{x:e,y:t,radius:i},seenUids:{box:{},circle:{}}},r),o?c.length>0:c}query(e,t,i,o,r){return this._query(e,t,i,o,!1,r)}hitTest(e,t,i,o,r){return this._query(e,t,i,o,!0,r)}hitTestCircle(e,t,i,o){return this._queryCircle(e,t,i,!0,o)}_queryCell(e,t,i,o,r,n,a,s){const l=a.seenUids,c=this.boxCells[r];if(null!==c){const r=this.bboxes;for(const h of c)if(!l.box[h]){l.box[h]=!0;const c=4*h;if(e<=r[c+2]&&t<=r[c+3]&&i>=r[c+0]&&o>=r[c+1]&&(!s||s(this.boxKeys[h]))){if(a.hitTest)return n.push(!0),!0;n.push({key:this.boxKeys[h],x1:r[c],y1:r[c+1],x2:r[c+2],y2:r[c+3]});}}}const h=this.circleCells[r];if(null!==h){const r=this.circles;for(const c of h)if(!l.circle[c]){l.circle[c]=!0;const h=3*c;if(this._circleAndRectCollide(r[h],r[h+1],r[h+2],e,t,i,o)&&(!s||s(this.circleKeys[c]))){if(a.hitTest)return n.push(!0),!0;{const e=r[h],t=r[h+1],i=r[h+2];n.push({key:this.circleKeys[c],x1:e-i,y1:t-i,x2:e+i,y2:t+i});}}}}}_queryCellCircle(e,t,i,o,r,n,a,s){const l=a.circle,c=a.seenUids,h=this.boxCells[r];if(null!==h){const e=this.bboxes;for(const t of h)if(!c.box[t]){c.box[t]=!0;const i=4*t;if(this._circleAndRectCollide(l.x,l.y,l.radius,e[i+0],e[i+1],e[i+2],e[i+3])&&(!s||s(this.boxKeys[t])))return n.push(!0),!0}}const u=this.circleCells[r];if(null!==u){const e=this.circles;for(const t of u)if(!c.circle[t]){c.circle[t]=!0;const i=3*t;if(this._circlesCollide(e[i],e[i+1],e[i+2],l.x,l.y,l.radius)&&(!s||s(this.circleKeys[t])))return n.push(!0),!0}}}_forEachCell(e,t,i,o,r,n,a,s){const l=this._convertToXCellCoord(e),c=this._convertToYCellCoord(t),h=this._convertToXCellCoord(i),u=this._convertToYCellCoord(o);for(let _=l;_<=h;_++)for(let l=c;l<=u;l++)if(r.call(this,e,t,i,o,this.xCellCount*l+_,n,a,s))return}_convertToXCellCoord(e){return Math.max(0,Math.min(this.xCellCount-1,Math.floor(e*this.xScale)))}_convertToYCellCoord(e){return Math.max(0,Math.min(this.yCellCount-1,Math.floor(e*this.yScale)))}_circlesCollide(e,t,i,o,r,n){const a=o-e,s=r-t,l=i+n;return l*l>a*a+s*s}_circleAndRectCollide(e,t,i,o,r,n,a){const s=(n-o)/2,l=Math.abs(e-(o+s));if(l>s+i)return !1;const c=(a-r)/2,h=Math.abs(t-(r+c));if(h>c+i)return !1;if(l<=s||h<=c)return !0;const u=l-s,_=h-c;return u*u+_*_<=i*i}}const et=Math.tan(85*Math.PI/180);function tt(t,i,o,r,n,a,s){const l=e.create();if(o)if("globe"===a.name){const t=e.calculateGlobeLabelMatrix(n,i);e.multiply(l,l,t);}else {const t=v([],s);l[0]=t[0],l[1]=t[1],l[4]=t[2],l[5]=t[3],r||e.rotateZ(l,l,n.angle);}else e.multiply(l,n.labelPlaneMatrix,t);return l}function it(e,t,i,o,r,n,a){const s=tt(e,t,i,o,r,n,a);return "globe"===n.name&&i||(s[2]=s[6]=s[10]=s[14]=0),s}function ot(t,i,o,r,n,a,s){if(o){if("globe"===a.name){const l=tt(t,i,o,r,n,a,s);return e.invert(l,l),e.multiply(l,t,l),l}{const i=e.clone(t),o=e.identity([]);return o[0]=s[0],o[1]=s[1],o[4]=s[2],o[5]=s[3],e.multiply(i,i,o),r||e.rotateZ(i,i,-n.angle),i}}return n.glCoordMatrix}function rt(t,i,o=0){const r=[t.x,t.y,o,1];o?e.transformMat4$1(r,r,i):gt(r,r,i);const n=r[3];return {point:[r[0]/n,r[1]/n,r[2]/n],signedDistanceFromCamera:n}}function nt(t,i){const o=[t[0],t[1],t[2],1];e.transformMat4$1(o,o,i);const r=o[3];return {point:[o[0]/r,o[1]/r,o[2]/r],signedDistanceFromCamera:r}}function at(e,t){return Math.min(.5+e/t*.5,1.5)}function st(e,t){const i=e[0]/e[3],o=e[1]/e[3];return i>=-t[0]&&i<=t[0]&&o>=-t[1]&&o<=t[1]}function lt(t,i,o,r,n,a,s,l,c,h){const u=o.transform,_=r?t.textSizeData:t.iconSizeData,d=e.evaluateSizeForZoom(_,o.transform.zoom),p="globe"===u.projection.name,m=[256/o.width*2+1,256/o.height*2+1],f=r?t.text.dynamicLayoutVertexArray:t.icon.dynamicLayoutVertexArray;f.clear();let g=null;p&&(g=r?t.text.globeExtVertexArray:t.icon.globeExtVertexArray);const v=t.lineVertexArray,x=r?t.text.placedSymbolArray:t.icon.placedSymbolArray,y=o.transform.width/o.transform.height;let b=!1;for(let r=0;r<x.length;r++){const p=x.get(r);if(p.writingMode!==e.WritingMode.vertical||b||0!==r&&x.get(r-1).writingMode===e.WritingMode.horizontal||(b=!0),(p.hidden||p.writingMode===e.WritingMode.vertical)&&!b){ft(p.numGlyphs,f);continue}b=!1;const w=new e.pointGeometry(p.tileAnchorX,p.tileAnchorY),T=c?c(w):[0,0,0],E=u.projection.projectTilePoint(w.x,w.y,h.canonical),C=[E.x+T[0],E.y+T[1],E.z+T[2]],I=[...C,1];if(e.transformMat4$1(I,I,i),!st(I,m)){ft(p.numGlyphs,f);continue}const M=at(o.transform.cameraToCenterDistance,I[3]),S=e.evaluateSizeForFeature(_,d,p),z=s?S/M:S*M,D=rt(new e.pointGeometry(C[0],C[1]),n,C[2]);if(D.signedDistanceFromCamera<=0){ft(p.numGlyphs,f);continue}let P={};const A=s?null:c,L=ut(p,z,!1,l,i,n,a,t.glyphOffsetArray,v,f,g,D.point,w,P,y,A,u.projection,h,s);b=L.useVertical,A&&L.needsFlipping&&(P={}),(L.notEnoughRoom||b||L.needsFlipping&&ut(p,z,!0,l,i,n,a,t.glyphOffsetArray,v,f,g,D.point,w,P,y,A,u.projection,h,s).notEnoughRoom)&&ft(p.numGlyphs,f);}r?(t.text.dynamicLayoutVertexBuffer.updateData(f),g&&t.text.globeExtVertexBuffer.updateData(g)):(t.icon.dynamicLayoutVertexBuffer.updateData(f),g&&t.icon.globeExtVertexBuffer.updateData(g));}function ct(e,t,i,o,r,n,a,s,l,c,h,u,_,d,p,m){const f=s.glyphStartIndex+s.numGlyphs,g=s.lineStartIndex,v=s.lineStartIndex+s.lineLength,x=t.getoffsetX(s.glyphStartIndex),y=t.getoffsetX(f-1),b=pt(e*x,i,o,r,n,a,s.segment,g,v,l,c,h,u,_,!0,d,p,m);if(!b)return null;const w=pt(e*y,i,o,r,n,a,s.segment,g,v,l,c,h,u,_,!0,d,p,m);return w?{first:b,last:w}:null}function ht(t,i,o,r){return t.writingMode===e.WritingMode.horizontal&&Math.abs(o.y-i.y)>Math.abs(o.x-i.x)*r?{useVertical:!0}:t.writingMode===e.WritingMode.vertical?i.y<o.y?{needsFlipping:!0}:null:0!==t.flipState&&function(e,t,i){const o=(t.x-e.x)*i;return 0===o||Math.abs((t.y-e.y)/o)>et}(i,o,r)?1===t.flipState?{needsFlipping:!0}:null:i.x>o.x?{needsFlipping:!0}:null}function ut(t,i,o,r,n,a,s,l,c,h,u,_,d,p,m,f,g,v,x){const y=i/24,b=t.lineOffsetX*y,w=t.lineOffsetY*y;let T;if(t.numGlyphs>1){const i=t.glyphStartIndex+t.numGlyphs,n=t.lineStartIndex,h=t.lineStartIndex+t.lineLength,u=ct(y,l,b,w,o,_,d,t,c,a,p,f,!1,g,v,x);if(!u)return {notEnoughRoom:!0};const E=nt(u.first.point,s).point,C=nt(u.last.point,s).point,I=new e.pointGeometry(E[0],E[1]),M=new e.pointGeometry(C[0],C[1]);if(r&&!o){const e=ht(t,I,M,m);if(t.flipState=e&&e.needsFlipping?1:2,e)return e}T=[u.first];for(let e=t.glyphStartIndex+1;e<i-1;e++)T.push(pt(y*l.getoffsetX(e),b,w,o,_,d,t.segment,n,h,c,a,p,f,!1,!1,g,v,x));T.push(u.last);}else {if(r&&!o){const i=rt(d,n).point,o=t.lineStartIndex+t.segment+1,r=new e.pointGeometry(c.getx(o),c.gety(o)),a=rt(r,n),s=a.signedDistanceFromCamera>0?a.point:dt(d,r,i,1,n,void 0,g,v.canonical),l=ht(t,new e.pointGeometry(i[0],i[1]),new e.pointGeometry(s[0],s[1]),m);if(t.flipState=l&&l.needsFlipping?1:2,l)return l}const i=pt(y*l.getoffsetX(t.glyphStartIndex),b,w,o,_,d,t.segment,t.lineStartIndex,t.lineStartIndex+t.lineLength,c,a,p,f,!1,!1,g,v,x);if(!i)return {notEnoughRoom:!0};T=[i];}if(u)for(const t of T)e.updateGlobeVertexNormal(u,h.length+0,t.up[0],t.up[1],t.up[2]),e.updateGlobeVertexNormal(u,h.length+1,t.up[0],t.up[1],t.up[2]),e.updateGlobeVertexNormal(u,h.length+2,t.up[0],t.up[1],t.up[2]),e.updateGlobeVertexNormal(u,h.length+3,t.up[0],t.up[1],t.up[2]),e.addDynamicAttributes(h,t.point[0],t.point[1],t.point[2],t.angle);else for(const t of T)e.addDynamicAttributes(h,t.point[0],t.point[1],t.point[2],t.angle);return {}}function _t(t,i,o,r,n){const a=r.projectTilePoint(t.x,t.y,i);if(!n)return rt(a,o,a.z);const s=n(t);return rt(new e.pointGeometry(a.x+s[0],a.y+s[1]),o,a.z+s[2])}function dt(t,i,o,r,n,a,s,l){const c=_t(t.add(t.sub(i)._unit()),l,n,s,a).point,h=e.sub([],o,c);return e.scaleAndAdd([],o,h,r/e.length(h))}function pt(t,i,o,r,n,a,s,l,c,h,u,_,d,p,m,f,g,v){const x=r?t-i:t+i;let y=x>0?1:-1,b=0;r&&(y*=-1,b=Math.PI),y<0&&(b+=Math.PI);let w=y>0?l+s:l+s+1,T=n,E=n,C=0,I=0;const M=Math.abs(x),S=[],z=[];let D=a;const P=()=>{const t=w-y;return 0===C?a:new e.pointGeometry(h.getx(t),h.gety(t))},A=()=>dt(P(),D,E,M-C+1,u,d,f,g.canonical);for(;C+I<=M;){if(w+=y,w<l||w>=c)return null;if(E=T,S.push(T),p&&z.push(D||P()),T=_[w],void 0===T){D=new e.pointGeometry(h.getx(w),h.gety(w));const t=_t(D,g.canonical,u,f,d);T=t.signedDistanceFromCamera>0?_[w]=t.point:A();}else D=null;C+=I,I=e.distance(E,T);}D=D||new e.pointGeometry(h.getx(w),h.gety(w));const L=P();m&&d&&(_[w]=T=void 0===_[w]?T:A(),I=e.distance(E,T));const R=(M-C)/I,O=D.sub(L).mult(R)._add(L),B=e.sub([],T,E),k=e.scaleAndAdd([],E,B,R);let F=[0,0,1],U=B[0],N=B[1];if(v&&(F=f.upVector(g.canonical,O.x,O.y),0!==F[0]||0!==F[1]||1!==F[2])){const t=[1,0,0],i=[0,1,0];t[0]=F[2],t[1]=0,t[2]=-F[0],e.cross(i,F,t),e.normalize(t,t),e.normalize(i,i),U=e.dot(B,t),N=e.dot(B,i);}if(o){const t=e.cross([],F,B);e.normalize(t,t),e.scaleAndAdd(k,k,t,o*y);}const G=b+Math.atan2(N,U);return S.push(k),p&&z.push(O),{point:k,angle:G,path:S,tilePath:z,up:F}}const mt=new Float32Array([-1/0,-1/0,0,-1/0,-1/0,0,-1/0,-1/0,0,-1/0,-1/0,0,-1/0,-1/0,0]);function ft(e,t){for(let i=0;i<e;i++){const e=t.length;t.resize(e+4),t.float32.set(mt,4*e);}}function gt(e,t,i){const o=t[0],r=t[1];return e[0]=i[0]*o+i[4]*r+i[12],e[1]=i[1]*o+i[5]*r+i[13],e[3]=i[3]*o+i[7]*r+i[15],e}const vt=100;class xt{constructor(e,t,i=new Qe(e.width+200,e.height+200,25),o=new Qe(e.width+200,e.height+200,25)){this.transform=e,this.grid=i,this.ignoredGrid=o,this.pitchfactor=Math.cos(e._pitch)*e.cameraToCenterDistance,this.screenRightBoundary=e.width+vt,this.screenBottomBoundary=e.height+vt,this.gridRightBoundary=e.width+200,this.gridBottomBoundary=e.height+200,this.fogState=t;}placeCollisionBox(e,t,i,o,r,n,a,s){let l=i.projectedAnchorX,c=i.projectedAnchorY,h=i.projectedAnchorZ;const u=i.elevation,_=i.tileID;if(u&&_){const t=e.getProjection().upVector(_.canonical,i.tileAnchorX,i.tileAnchorY),o=e.getProjection().upVectorScale(_.canonical,this.transform.center.lat,this.transform.worldSize).metersToTile;l+=t[0]*u*o,c+=t[1]*u*o,h+=t[2]*u*o;}const d=this.projectAndGetPerspectiveRatio(a,[l,c,h],i.tileID,"globe"===e.projection.name||!!u||this.transform.pitch>0,e.getProjection()),p=n*d.perspectiveRatio,m=(i.x1*t+o.x-i.padding)*p+d.point.x,f=(i.y1*t+o.y-i.padding)*p+d.point.y,g=(i.x2*t+o.x+i.padding)*p+d.point.x,v=(i.y2*t+o.y+i.padding)*p+d.point.y,x=d.perspectiveRatio<=.55||d.occluded;return !this.isInsideGrid(m,f,g,v)||!r&&this.grid.hitTest(m,f,g,v,s)||x?{box:[],offscreen:!1,occluded:d.occluded}:{box:[m,f,g,v],offscreen:this.isOffscreen(m,f,g,v),occluded:!1}}placeCollisionCircles(t,i,o,r,n,a,s,l,c,h,u,_,d,p,m){const f=[],g=this.transform.elevation,v=g?g.getAtTileOffsetFunc(m,this.transform.center.lat,this.transform.worldSize,t.getProjection()):e=>[0,0,0],x=new e.pointGeometry(o.tileAnchorX,o.tileAnchorY),y=t.getProjection().projectTilePoint(o.tileAnchorX,o.tileAnchorY,m.canonical),b=v(x),w=[y.x+b[0],y.y+b[1],y.z+b[2]],T="globe"===t.projection.name,E=this.projectAndGetPerspectiveRatio(s,[w[0],w[1],w[2]],m,T||!!g||this.transform.pitch>0,t.getProjection()),{perspectiveRatio:C}=E,I=(u?a/C:a*C)/e.ONE_EM,M=rt(new e.pointGeometry(w[0],w[1]),l,w[2]).point,S=E.signedDistanceFromCamera>0?ct(I,n,o.lineOffsetX*I,o.lineOffsetY*I,!1,M,x,o,r,l,{},g&&!u?v:null,u&&!!g,t.getProjection(),m,u):null;let z=!1,D=!1,P=!0;if(S&&!E.occluded){const t=.5*d*C+p,o=new e.pointGeometry(-100,-100),r=new e.pointGeometry(this.screenRightBoundary,this.screenBottomBoundary),n=new Je,a=S.first,s=S.last;let l=[];for(let e=a.path.length-1;e>=1;e--)l.push(a.path[e]);for(let e=1;e<s.path.length;e++)l.push(s.path[e]);const u=2.5*t;if(c){const e=l.map(g&&!T?(e,t)=>{const i=v(t<a.path.length-1?a.tilePath[a.path.length-1-t]:s.tilePath[t-a.path.length+2]);return e[2]=i[2],nt(e,c)}:e=>nt(e,c));l=e.some((e=>e.signedDistanceFromCamera<=0))?[]:e.map((e=>e.point));}let m=[];if(l.length>0){const t=l.map((t=>new e.pointGeometry(t[0],t[1])));let i=1/0,n=-1/0,a=1/0,s=-1/0;for(let e=0;e<t.length;e++)i=Math.min(i,t[e].x),a=Math.min(a,t[e].y),n=Math.max(n,t[e].x),s=Math.max(s,t[e].y);m=i>=o.x&&n<=r.x&&a>=o.y&&s<=r.y?[t]:n<o.x||i>r.x||s<o.y||a>r.y?[]:e.clipLine([t],o.x,o.y,r.x,r.y);}for(const e of m){n.reset(e,.25*t);let o=0;o=n.length<=.5*t?1:Math.ceil(n.paddedLength/u)+1;for(let e=0;e<o;e++){const r=e/Math.max(o-1,1),a=n.lerp(r),s=a.x+vt,l=a.y+vt;f.push(s,l,t,0);const c=s-t,u=l-t,d=s+t,p=l+t;if(P=P&&this.isOffscreen(c,u,d,p),D=D||this.isInsideGrid(c,u,d,p),!i&&this.grid.hitTestCircle(s,l,t,_)&&(z=!0,!h))return {circles:[],offscreen:!1,collisionDetected:z,occluded:!1}}}}return {circles:!h&&z||!D?[]:f,offscreen:P,collisionDetected:z,occluded:E.occluded}}queryRenderedSymbols(t){if(0===t.length||0===this.grid.keysLength()&&0===this.ignoredGrid.keysLength())return {};const i=[];let o=1/0,r=1/0,n=-1/0,a=-1/0;for(const s of t){const t=new e.pointGeometry(s.x+vt,s.y+vt);o=Math.min(o,t.x),r=Math.min(r,t.y),n=Math.max(n,t.x),a=Math.max(a,t.y),i.push(t);}const s=this.grid.query(o,r,n,a).concat(this.ignoredGrid.query(o,r,n,a)),l={},c={};for(const t of s){const o=t.key;if(void 0===l[o.bucketInstanceId]&&(l[o.bucketInstanceId]={}),l[o.bucketInstanceId][o.featureIndex])continue;const r=[new e.pointGeometry(t.x1,t.y1),new e.pointGeometry(t.x2,t.y1),new e.pointGeometry(t.x2,t.y2),new e.pointGeometry(t.x1,t.y2)];e.polygonIntersectsPolygon(i,r)&&(l[o.bucketInstanceId][o.featureIndex]=!0,void 0===c[o.bucketInstanceId]&&(c[o.bucketInstanceId]=[]),c[o.bucketInstanceId].push(o.featureIndex));}return c}insertCollisionBox(e,t,i,o,r){(t?this.ignoredGrid:this.grid).insert({bucketInstanceId:i,featureIndex:o,collisionGroupID:r},e[0],e[1],e[2],e[3]);}insertCollisionCircles(e,t,i,o,r){const n=t?this.ignoredGrid:this.grid,a={bucketInstanceId:i,featureIndex:o,collisionGroupID:r};for(let t=0;t<e.length;t+=4)n.insertCircle(a,e[t],e[t+1],e[t+2]);}projectAndGetPerspectiveRatio(t,i,o,r,n){const a=[i[0],i[1],i[2],1];let s=!1;if(i[2]||this.transform.pitch>0){e.transformMat4$1(a,a,t);const r="globe"===n.name;this.fogState&&o&&!r&&(s=function(t,i,o,r,n,a){const s=a.calculateFogTileMatrix(n),l=[i,o,r];return e.transformMat4(l,l,s),M(t,l,a.pitch,a._fov)}(this.fogState,i[0],i[1],i[2],o.toUnwrapped(),this.transform)>.9);}else gt(a,a,t);return {point:new e.pointGeometry((a[0]/a[3]+1)/2*this.transform.width+vt,(-a[1]/a[3]+1)/2*this.transform.height+vt),perspectiveRatio:Math.min(.5+this.transform.getCameraToCenterDistance(n)/a[3]*.5,1.5),signedDistanceFromCamera:a[3],occluded:r&&a[2]>a[3]||s}}isOffscreen(e,t,i,o){return i<vt||e>=this.screenRightBoundary||o<vt||t>this.screenBottomBoundary}isInsideGrid(e,t,i,o){return i>=0&&e<this.gridRightBoundary&&o>=0&&t<this.gridBottomBoundary}getViewportMatrix(){const t=e.identity([]);return e.translate(t,t,[-100,-100,0]),t}}function yt(t,i,o){const r=i.createTileMatrix(t,t.worldSize,o.toUnwrapped());return e.multiply(new Float32Array(16),t.projMatrix,r)}function bt(e,t,i){if(t.projection.name===i.projection.name)return e.projMatrix;const o=i.clone();return o.setProjection(t.projection),yt(o,t.getProjection(),e)}function wt(e,t,i){return t.name===i.projection.name?e.projMatrix:yt(i,t,e)}class Tt{constructor(e,t,i,o){this.opacity=e?Math.max(0,Math.min(1,e.opacity+(e.placed?t:-t))):o&&i?1:0,this.placed=i;}isHidden(){return 0===this.opacity&&!this.placed}}class Et{constructor(e,t,i,o,r,n=!1){this.text=new Tt(e?e.text:null,t,i,r),this.icon=new Tt(e?e.icon:null,t,o,r),this.clipped=n;}isHidden(){return this.text.isHidden()&&this.icon.isHidden()}}class Ct{constructor(e,t,i,o=!1){this.text=e,this.icon=t,this.skipFade=i,this.clipped=o;}}class It{constructor(){this.invProjMatrix=e.create(),this.viewportMatrix=e.create(),this.circles=[];}}class Mt{constructor(e,t,i,o,r){this.bucketInstanceId=e,this.featureIndex=t,this.sourceLayerIndex=i,this.bucketIndex=o,this.tileID=r;}}class St{constructor(e){this.crossSourceCollisions=e,this.maxGroupID=0,this.collisionGroups={};}get(e){if(this.crossSourceCollisions)return {ID:0,predicate:null};if(!this.collisionGroups[e]){const t=++this.maxGroupID;this.collisionGroups[e]={ID:t,predicate:e=>e.collisionGroupID===t};}return this.collisionGroups[e]}}function zt(t,i,o,r,n){const{horizontalAlign:a,verticalAlign:s}=e.getAnchorAlignment(t),l=-(a-.5)*i,c=-(s-.5)*o,h=e.evaluateVariableOffset(t,r);return new e.pointGeometry(l+h[0]*n,c+h[1]*n)}function Dt(t,i,o,r,n){const a=new e.pointGeometry(t,i);return o&&a._rotate(r?n:-n),a}class Pt{constructor(e,t,i,o,r){this.transform=e.clone(),this.projection=e.projection.name,this.collisionIndex=new xt(this.transform,r),this.placements={},this.opacities={},this.variableOffsets={},this.stale=!1,this.commitTime=0,this.fadeDuration=t,this.retainedQueryData={},this.collisionGroups=new St(i),this.collisionCircleArrays={},this.prevPlacement=o,o&&(o.prevPlacement=void 0),this.placedOrientations={};}getBucketParts(t,i,o,r){const n=o.getBucket(i),a=o.latestFeatureIndex;if(!n||!a||i.id!==n.layerIds[0])return;const s=n.layers[0].layout,l=o.collisionBoxArray,c=Math.pow(2,this.transform.zoom-o.tileID.overscaledZ),h=o.tileSize/e.EXTENT,u=o.tileID.toUnwrapped();this.transform.setProjection(n.projection);const _=(d=o.tileID,p=n.getProjection(),m=this.transform,p.name===this.projection?m.calculateProjMatrix(d.toUnwrapped()):yt(m,p,d));var d,p,m;const f="map"===s.get("text-pitch-alignment"),g="map"===s.get("text-rotation-alignment");i.compileFilter();const v=i.dynamicFilter(),x=i.dynamicFilterNeedsFeature(),y=this.transform.calculatePixelsToTileUnitsMatrix(o),b=it(_,o.tileID.canonical,f,g,this.transform,n.getProjection(),y);let w=null;if(f){const t=ot(_,o.tileID.canonical,f,g,this.transform,n.getProjection(),y);w=e.multiply([],this.transform.labelPlaneMatrix,t);}let T=null;v&&o.latestFeatureIndex&&(T={unwrappedTileID:u,dynamicFilter:v,dynamicFilterNeedsFeature:x,featureIndex:o.latestFeatureIndex}),this.retainedQueryData[n.bucketInstanceId]=new Mt(n.bucketInstanceId,a,n.sourceLayerIndex,n.index,o.tileID);const E={bucket:n,layout:s,posMatrix:_,textLabelPlaneMatrix:b,labelToScreenMatrix:w,clippingData:T,scale:c,textPixelRatio:h,holdingForFade:o.holdingForFade(),collisionBoxArray:l,partiallyEvaluatedTextSize:e.evaluateSizeForZoom(n.textSizeData,this.transform.zoom),partiallyEvaluatedIconSize:e.evaluateSizeForZoom(n.iconSizeData,this.transform.zoom),collisionGroup:this.collisionGroups.get(n.sourceID)};if(r)for(const e of n.sortKeyRanges){const{sortKey:i,symbolInstanceStart:o,symbolInstanceEnd:r}=e;t.push({sortKey:i,symbolInstanceStart:o,symbolInstanceEnd:r,parameters:E});}else t.push({symbolInstanceStart:0,symbolInstanceEnd:n.symbolInstances.length,parameters:E});}attemptAnchorPlacement(e,t,i,o,r,n,a,s,l,c,h,u,_,d,p,m,f,g){const v=[u.textOffset0,u.textOffset1],x=zt(e,i,o,v,r),y=this.collisionIndex.placeCollisionBox(d,r,t,Dt(x.x,x.y,n,a,this.transform.angle),h,s,l,c.predicate);if((!m||0!==this.collisionIndex.placeCollisionBox(d,d.getSymbolInstanceIconSize(g,this.transform.zoom,_),m,Dt(x.x,x.y,n,a,this.transform.angle),h,s,l,c.predicate).box.length)&&y.box.length>0){let t;return this.prevPlacement&&this.prevPlacement.variableOffsets[u.crossTileID]&&this.prevPlacement.placements[u.crossTileID]&&this.prevPlacement.placements[u.crossTileID].text&&(t=this.prevPlacement.variableOffsets[u.crossTileID].anchor),this.variableOffsets[u.crossTileID]={textOffset:v,width:i,height:o,anchor:e,textScale:r,prevAnchor:t},this.markUsedJustification(d,e,u,p),d.allowVerticalPlacement&&(this.markUsedOrientation(d,p,u),this.placedOrientations[u.crossTileID]=p),{shift:x,placedGlyphBoxes:y}}}placeLayerBucketPart(t,i,o,r){const{bucket:n,layout:a,posMatrix:s,textLabelPlaneMatrix:l,labelToScreenMatrix:c,clippingData:h,textPixelRatio:u,holdingForFade:_,collisionBoxArray:d,partiallyEvaluatedTextSize:p,partiallyEvaluatedIconSize:m,collisionGroup:f}=t.parameters,g=a.get("text-optional"),v=a.get("icon-optional"),x=a.get("text-allow-overlap"),y=a.get("icon-allow-overlap"),b="map"===a.get("text-rotation-alignment"),w="map"===a.get("text-pitch-alignment"),T="none"!==a.get("icon-text-fit"),E="viewport-y"===a.get("symbol-z-order");this.transform.setProjection(n.projection);let C=x&&(y||!n.hasIconData()||v),I=y&&(x||!n.hasTextData()||g);!n.collisionArrays&&d&&n.deserializeCollisionBoxes(d),o&&r&&n.updateCollisionDebugBuffers(this.transform.zoom,d);const M=(t,r,d)=>{if(h){const o={zoom:this.transform.zoom,pitch:this.transform.pitch};let r=null;if(h.dynamicFilterNeedsFeature){const e=this.retainedQueryData[n.bucketInstanceId];r=h.featureIndex.loadFeature({featureIndex:t.featureIndex,bucketIndex:e.bucketIndex,sourceLayerIndex:e.sourceLayerIndex,layoutVertexArrayOffset:0});}if(!(0, h.dynamicFilter)(o,r,this.retainedQueryData[n.bucketInstanceId].tileID.canonical,new e.pointGeometry(t.tileAnchorX,t.tileAnchorY),this.transform.calculateDistanceTileData(h.unwrappedTileID)))return this.placements[t.crossTileID]=new Ct(!1,!1,!1,!0),void(i[t.crossTileID]=!0)}if(i[t.crossTileID])return;if(_)return void(this.placements[t.crossTileID]=new Ct(!1,!1,!1));let E=!1,M=!1,S=!0,z=!1,D=!1,P=null,A={box:null,offscreen:null,occluded:null},L={box:null,offscreen:null,occluded:null},R=null,O=null,B=null,k=0,F=0,U=0;d.textFeatureIndex?k=d.textFeatureIndex:t.useRuntimeCollisionCircles&&(k=t.featureIndex),d.verticalTextFeatureIndex&&(F=d.verticalTextFeatureIndex);const N=e=>{e.tileID=this.retainedQueryData[n.bucketInstanceId].tileID,(this.transform.elevation||e.elevation)&&(e.elevation=this.transform.elevation?this.transform.elevation.getAtTileOffset(this.retainedQueryData[n.bucketInstanceId].tileID,e.tileAnchorX,e.tileAnchorY):0);},G=d.textBox;if(G){N(G);const i=i=>{let o=e.WritingMode.horizontal;if(n.allowVerticalPlacement&&!i&&this.prevPlacement){const e=this.prevPlacement.placedOrientations[t.crossTileID];e&&(this.placedOrientations[t.crossTileID]=e,o=e,this.markUsedOrientation(n,o,t));}return o},o=(i,o)=>{if(n.allowVerticalPlacement&&t.numVerticalGlyphVertices>0&&d.verticalTextBox){for(const t of n.writingModes)if(t===e.WritingMode.vertical?(A=o(),L=A):A=i(),A&&A.box&&A.box.length)break}else A=i();};if(a.get("text-variable-anchor")){let l=a.get("text-variable-anchor");if(this.prevPlacement&&this.prevPlacement.variableOffsets[t.crossTileID]){const e=this.prevPlacement.variableOffsets[t.crossTileID];l.indexOf(e.anchor)>0&&(l=l.filter((t=>t!==e.anchor)),l.unshift(e.anchor));}const c=(e,i,o)=>{const a=n.getSymbolInstanceTextSize(p,t,this.transform.zoom,r),c=(e.x2-e.x1)*a+2*e.padding,h=(e.y2-e.y1)*a+2*e.padding,_=T&&!y?i:null;_&&N(_);let d={box:[],offscreen:!1,occluded:!1};const g=x?2*l.length:l.length;for(let i=0;i<g;++i){const g=this.attemptAnchorPlacement(l[i%l.length],e,c,h,a,b,w,u,s,f,i>=l.length,t,r,n,o,_,p,m);if(g&&(d=g.placedGlyphBoxes,d&&d.box&&d.box.length)){E=!0,P=g.shift;break}}return d};o((()=>c(G,d.iconBox,e.WritingMode.horizontal)),(()=>{const i=d.verticalTextBox;return i&&N(i),n.allowVerticalPlacement&&!(A&&A.box&&A.box.length)&&t.numVerticalGlyphVertices>0&&i?c(i,d.verticalIconBox,e.WritingMode.vertical):{box:null,offscreen:null,occluded:null}})),A&&(E=A.box,S=A.offscreen,z=A.occluded);const h=i(A&&A.box);if(!E&&this.prevPlacement){const e=this.prevPlacement.variableOffsets[t.crossTileID];e&&(this.variableOffsets[t.crossTileID]=e,this.markUsedJustification(n,e.anchor,t,h));}}else {const a=(i,o)=>{const a=n.getSymbolInstanceTextSize(p,t,this.transform.zoom,r),l=this.collisionIndex.placeCollisionBox(n,a,i,new e.pointGeometry(0,0),x,u,s,f.predicate);return l&&l.box&&l.box.length&&(this.markUsedOrientation(n,o,t),this.placedOrientations[t.crossTileID]=o),l};o((()=>a(G,e.WritingMode.horizontal)),(()=>{const i=d.verticalTextBox;return n.allowVerticalPlacement&&t.numVerticalGlyphVertices>0&&i?(N(i),a(i,e.WritingMode.vertical)):{box:null,offscreen:null,occluded:null}})),i(A&&A.box&&A.box.length);}}if(R=A,E=R&&R.box&&R.box.length>0,S=R&&R.offscreen,z=R&&R.occluded,t.useRuntimeCollisionCircles){const i=n.text.placedSymbolArray.get(t.centerJustifiedTextSymbolIndex>=0?t.centerJustifiedTextSymbolIndex:t.verticalPlacedTextSymbolIndex),r=e.evaluateSizeForFeature(n.textSizeData,p,i),h=a.get("text-padding");O=this.collisionIndex.placeCollisionCircles(n,x,i,n.lineVertexArray,n.glyphOffsetArray,r,s,l,c,o,w,f.predicate,t.collisionCircleDiameter*r/e.ONE_EM,h,this.retainedQueryData[n.bucketInstanceId].tileID),E=x||O.circles.length>0&&!O.collisionDetected,S=S&&O.offscreen,z=O.occluded;}if(d.iconFeatureIndex&&(U=d.iconFeatureIndex),d.iconBox){const t=t=>{N(t);const i=T&&P?Dt(P.x,P.y,b,w,this.transform.angle):new e.pointGeometry(0,0),o=n.getSymbolInstanceIconSize(m,this.transform.zoom,r);return this.collisionIndex.placeCollisionBox(n,o,t,i,y,u,s,f.predicate)};L&&L.box&&L.box.length&&d.verticalIconBox?(B=t(d.verticalIconBox),M=B.box.length>0):(B=t(d.iconBox),M=B.box.length>0),S=S&&B.offscreen,D=B.occluded;}const j=g||0===t.numHorizontalGlyphVertices&&0===t.numVerticalGlyphVertices,Z=v||0===t.numIconVertices;if(j||Z?Z?j||(M=M&&E):E=M&&E:M=E=M&&E,E&&R&&R.box&&this.collisionIndex.insertCollisionBox(R.box,a.get("text-ignore-placement"),n.bucketInstanceId,L&&L.box&&F?F:k,f.ID),M&&B&&this.collisionIndex.insertCollisionBox(B.box,a.get("icon-ignore-placement"),n.bucketInstanceId,U,f.ID),O&&(E&&this.collisionIndex.insertCollisionCircles(O.circles,a.get("text-ignore-placement"),n.bucketInstanceId,k,f.ID),o)){const e=n.bucketInstanceId;let t=this.collisionCircleArrays[e];void 0===t&&(t=this.collisionCircleArrays[e]=new It);for(let e=0;e<O.circles.length;e+=4)t.circles.push(O.circles[e+0]),t.circles.push(O.circles[e+1]),t.circles.push(O.circles[e+2]),t.circles.push(O.collisionDetected?1:0);}const V="globe"!==n.projection.name;C=C&&(V||!z),I=I&&(V||!D),this.placements[t.crossTileID]=new Ct(E||C,M||I,S||n.justReloaded),i[t.crossTileID]=!0;};if(E){const e=n.getSortedSymbolIndexes(this.transform.angle);for(let t=e.length-1;t>=0;--t){const i=e[t];M(n.symbolInstances.get(i),i,n.collisionArrays[i]);}}else for(let e=t.symbolInstanceStart;e<t.symbolInstanceEnd;e++)M(n.symbolInstances.get(e),e,n.collisionArrays[e]);if(o&&n.bucketInstanceId in this.collisionCircleArrays){const t=this.collisionCircleArrays[n.bucketInstanceId];e.invert(t.invProjMatrix,s),t.viewportMatrix=this.collisionIndex.getViewportMatrix();}n.justReloaded=!1;}markUsedJustification(t,i,o,r){let n;n=r===e.WritingMode.vertical?o.verticalPlacedTextSymbolIndex:{left:o.leftJustifiedTextSymbolIndex,center:o.centerJustifiedTextSymbolIndex,right:o.rightJustifiedTextSymbolIndex}[e.getAnchorJustification(i)];const a=[o.leftJustifiedTextSymbolIndex,o.centerJustifiedTextSymbolIndex,o.rightJustifiedTextSymbolIndex,o.verticalPlacedTextSymbolIndex];for(const e of a)e>=0&&(t.text.placedSymbolArray.get(e).crossTileID=n>=0&&e!==n?0:o.crossTileID);}markUsedOrientation(t,i,o){const r=i===e.WritingMode.horizontal||i===e.WritingMode.horizontalOnly?i:0,n=i===e.WritingMode.vertical?i:0,a=[o.leftJustifiedTextSymbolIndex,o.centerJustifiedTextSymbolIndex,o.rightJustifiedTextSymbolIndex];for(const e of a)t.text.placedSymbolArray.get(e).placedOrientation=r;o.verticalPlacedTextSymbolIndex&&(t.text.placedSymbolArray.get(o.verticalPlacedTextSymbolIndex).placedOrientation=n);}commit(e){this.commitTime=e,this.zoomAtLastRecencyCheck=this.transform.zoom;const t=this.prevPlacement;let i=!1;this.prevZoomAdjustment=t?t.zoomAdjustment(this.transform.zoom):0;const o=t?t.symbolFadeChange(e):1,r=t?t.opacities:{},n=t?t.variableOffsets:{},a=t?t.placedOrientations:{};for(const e in this.placements){const t=this.placements[e],n=r[e];n?(this.opacities[e]=new Et(n,o,t.text,t.icon,null,t.clipped),i=i||t.text!==n.text.placed||t.icon!==n.icon.placed):(this.opacities[e]=new Et(null,o,t.text,t.icon,t.skipFade,t.clipped),i=i||t.text||t.icon);}for(const e in r){const t=r[e];if(!this.opacities[e]){const r=new Et(t,o,!1,!1);r.isHidden()||(this.opacities[e]=r,i=i||t.text.placed||t.icon.placed);}}for(const e in n)this.variableOffsets[e]||!this.opacities[e]||this.opacities[e].isHidden()||(this.variableOffsets[e]=n[e]);for(const e in a)this.placedOrientations[e]||!this.opacities[e]||this.opacities[e].isHidden()||(this.placedOrientations[e]=a[e]);i?this.lastPlacementChangeTime=e:"number"!=typeof this.lastPlacementChangeTime&&(this.lastPlacementChangeTime=t?t.lastPlacementChangeTime:e);}updateLayerOpacities(e,t){const i={};for(const o of t){const t=o.getBucket(e);t&&o.latestFeatureIndex&&e.id===t.layerIds[0]&&this.updateBucketOpacities(t,i,o.collisionBoxArray);}}updateBucketOpacities(t,i,o){t.hasTextData()&&t.text.opacityVertexArray.clear(),t.hasIconData()&&t.icon.opacityVertexArray.clear(),t.hasIconCollisionBoxData()&&t.iconCollisionBox.collisionVertexArray.clear(),t.hasTextCollisionBoxData()&&t.textCollisionBox.collisionVertexArray.clear();const r=t.layers[0].layout,n=!!t.layers[0].dynamicFilter(),a=new Et(null,0,!1,!1,!0),s=r.get("text-allow-overlap"),l=r.get("icon-allow-overlap"),c=r.get("text-variable-anchor"),h="map"===r.get("text-rotation-alignment"),u="map"===r.get("text-pitch-alignment"),_="none"!==r.get("icon-text-fit"),d=new Et(null,0,s&&(l||!t.hasIconData()||r.get("icon-optional")),l&&(s||!t.hasTextData()||r.get("text-optional")),!0);!t.collisionArrays&&o&&(t.hasIconCollisionBoxData()||t.hasTextCollisionBoxData())&&t.deserializeCollisionBoxes(o);const p=(e,t,i)=>{for(let o=0;o<t/4;o++)e.opacityVertexArray.emplaceBack(i);};let m=0;for(let o=0;o<t.symbolInstances.length;o++){const r=t.symbolInstances.get(o),{numHorizontalGlyphVertices:s,numVerticalGlyphVertices:l,crossTileID:f}=r;let g=this.opacities[f];i[f]?g=a:g||(g=d,this.opacities[f]=g),i[f]=!0;const v=s>0||l>0,x=r.numIconVertices>0,y=this.placedOrientations[r.crossTileID],b=y===e.WritingMode.vertical,w=y===e.WritingMode.horizontal||y===e.WritingMode.horizontalOnly;if(!v&&!x||g.isHidden()||m++,v){const e=Nt(g.text);p(t.text,s,b?Gt:e),p(t.text,l,w?Gt:e);const i=g.text.isHidden();[r.rightJustifiedTextSymbolIndex,r.centerJustifiedTextSymbolIndex,r.leftJustifiedTextSymbolIndex].forEach((e=>{e>=0&&(t.text.placedSymbolArray.get(e).hidden=i||b?1:0);})),r.verticalPlacedTextSymbolIndex>=0&&(t.text.placedSymbolArray.get(r.verticalPlacedTextSymbolIndex).hidden=i||w?1:0);const o=this.variableOffsets[r.crossTileID];o&&this.markUsedJustification(t,o.anchor,r,y);const n=this.placedOrientations[r.crossTileID];n&&(this.markUsedJustification(t,"left",r,n),this.markUsedOrientation(t,n,r));}if(x){const e=Nt(g.icon);r.placedIconSymbolIndex>=0&&(p(t.icon,r.numIconVertices,b?Gt:e),t.icon.placedSymbolArray.get(r.placedIconSymbolIndex).hidden=g.icon.isHidden()),r.verticalPlacedIconSymbolIndex>=0&&(p(t.icon,r.numVerticalIconVertices,w?Gt:e),t.icon.placedSymbolArray.get(r.verticalPlacedIconSymbolIndex).hidden=g.icon.isHidden());}if(t.hasIconCollisionBoxData()||t.hasTextCollisionBoxData()){const i=t.collisionArrays[o];if(i){let o=new e.pointGeometry(0,0),r=!0;if(i.textBox||i.verticalTextBox){if(c){const e=this.variableOffsets[f];e?(o=zt(e.anchor,e.width,e.height,e.textOffset,e.textScale),h&&o._rotate(u?this.transform.angle:-this.transform.angle)):r=!1;}n&&(r=!g.clipped),i.textBox&&At(t.textCollisionBox.collisionVertexArray,g.text.placed,!r||b,o.x,o.y),i.verticalTextBox&&At(t.textCollisionBox.collisionVertexArray,g.text.placed,!r||w,o.x,o.y);}const a=r&&Boolean(!w&&i.verticalIconBox);i.iconBox&&At(t.iconCollisionBox.collisionVertexArray,g.icon.placed,a,_?o.x:0,_?o.y:0),i.verticalIconBox&&At(t.iconCollisionBox.collisionVertexArray,g.icon.placed,!a,_?o.x:0,_?o.y:0);}}}if(t.fullyClipped=0===m,t.sortFeatures(this.transform.angle),this.retainedQueryData[t.bucketInstanceId]&&(this.retainedQueryData[t.bucketInstanceId].featureSortOrder=t.featureSortOrder),t.hasTextData()&&t.text.opacityVertexBuffer&&t.text.opacityVertexBuffer.updateData(t.text.opacityVertexArray),t.hasIconData()&&t.icon.opacityVertexBuffer&&t.icon.opacityVertexBuffer.updateData(t.icon.opacityVertexArray),t.hasIconCollisionBoxData()&&t.iconCollisionBox.collisionVertexBuffer&&t.iconCollisionBox.collisionVertexBuffer.updateData(t.iconCollisionBox.collisionVertexArray),t.hasTextCollisionBoxData()&&t.textCollisionBox.collisionVertexBuffer&&t.textCollisionBox.collisionVertexBuffer.updateData(t.textCollisionBox.collisionVertexArray),t.bucketInstanceId in this.collisionCircleArrays){const e=this.collisionCircleArrays[t.bucketInstanceId];t.placementInvProjMatrix=e.invProjMatrix,t.placementViewportMatrix=e.viewportMatrix,t.collisionCircleArray=e.circles,delete this.collisionCircleArrays[t.bucketInstanceId];}}symbolFadeChange(e){return 0===this.fadeDuration?1:(e-this.commitTime)/this.fadeDuration+this.prevZoomAdjustment}zoomAdjustment(e){return Math.max(0,(this.transform.zoom-e)/1.5)}hasTransitions(e){return this.stale||e-this.lastPlacementChangeTime<this.fadeDuration}stillRecent(e,t){const i=this.zoomAtLastRecencyCheck===t?1-this.zoomAdjustment(t):1;return this.zoomAtLastRecencyCheck=t,this.commitTime+this.fadeDuration*i>e}setStale(){this.stale=!0;}}function At(e,t,i,o,r){e.emplaceBack(t?1:0,i?1:0,o||0,r||0),e.emplaceBack(t?1:0,i?1:0,o||0,r||0),e.emplaceBack(t?1:0,i?1:0,o||0,r||0),e.emplaceBack(t?1:0,i?1:0,o||0,r||0);}const Lt=Math.pow(2,25),Rt=Math.pow(2,24),Ot=Math.pow(2,17),Bt=Math.pow(2,16),kt=Math.pow(2,9),Ft=Math.pow(2,8),Ut=Math.pow(2,1);function Nt(e){if(0===e.opacity&&!e.placed)return 0;if(1===e.opacity&&e.placed)return 4294967295;const t=e.placed?1:0,i=Math.floor(127*e.opacity);return i*Lt+t*Rt+i*Ot+t*Bt+i*kt+t*Ft+i*Ut+t}const Gt=0;class jt{constructor(e){this._sortAcrossTiles="viewport-y"!==e.layout.get("symbol-z-order")&&void 0!==e.layout.get("symbol-sort-key").constantOr(1),this._currentTileIndex=0,this._currentPartIndex=0,this._seenCrossTileIDs={},this._bucketParts=[];}continuePlacement(e,t,i,o,r){const n=this._bucketParts;for(;this._currentTileIndex<e.length;)if(t.getBucketParts(n,o,e[this._currentTileIndex],this._sortAcrossTiles),this._currentTileIndex++,r())return !0;for(this._sortAcrossTiles&&(this._sortAcrossTiles=!1,n.sort(((e,t)=>e.sortKey-t.sortKey)));this._currentPartIndex<n.length;){const e=n[this._currentPartIndex];if(t.placeLayerBucketPart(e,this._seenCrossTileIDs,i,0===e.symbolInstanceStart),this._currentPartIndex++,r())return !0}return !1}}class Zt{constructor(e,t,i,o,r,n,a,s){this.placement=new Pt(e,r,n,a,s),this._currentPlacementIndex=t.length-1,this._forceFullPlacement=i,this._showCollisionBoxes=o,this._done=!1;}isDone(){return this._done}continuePlacement(t,i,o){const r=e.exported.now(),n=()=>{const t=e.exported.now()-r;return !this._forceFullPlacement&&t>2};for(;this._currentPlacementIndex>=0;){const e=i[t[this._currentPlacementIndex]],r=this.placement.collisionIndex.transform.zoom;if("symbol"===e.type&&(!e.minzoom||e.minzoom<=r)&&(!e.maxzoom||e.maxzoom>r)){if(this._inProgressLayer||(this._inProgressLayer=new jt(e)),this._inProgressLayer.continuePlacement(o[e.source],this.placement,this._showCollisionBoxes,e,n))return;delete this._inProgressLayer;}this._currentPlacementIndex--;}this._done=!0;}commit(e){return this.placement.commit(e),this.placement}}const Vt=512/e.EXTENT/2;class Wt{constructor(e,t,i){this.tileID=e,this.indexedSymbolInstances={},this.bucketInstanceId=i;for(let i=0;i<t.length;i++){const o=t.get(i),r=o.key;this.indexedSymbolInstances[r]||(this.indexedSymbolInstances[r]=[]),this.indexedSymbolInstances[r].push({crossTileID:o.crossTileID,coord:this.getScaledCoordinates(o,e)});}}getScaledCoordinates(t,i){const o=Vt/Math.pow(2,i.canonical.z-this.tileID.canonical.z);return {x:Math.floor((i.canonical.x*e.EXTENT+t.tileAnchorX)*o),y:Math.floor((i.canonical.y*e.EXTENT+t.tileAnchorY)*o)}}findMatches(e,t,i){const o=this.tileID.canonical.z<t.canonical.z?1:Math.pow(2,this.tileID.canonical.z-t.canonical.z);for(let r=0;r<e.length;r++){const n=e.get(r);if(n.crossTileID)continue;const a=this.indexedSymbolInstances[n.key];if(!a)continue;const s=this.getScaledCoordinates(n,t);for(const e of a)if(Math.abs(e.coord.x-s.x)<=o&&Math.abs(e.coord.y-s.y)<=o&&!i[e.crossTileID]){i[e.crossTileID]=!0,n.crossTileID=e.crossTileID;break}}}}class Xt{constructor(){this.maxCrossTileID=0;}generate(){return ++this.maxCrossTileID}}class qt{constructor(){this.indexes={},this.usedCrossTileIDs={},this.lng=0;}handleWrapJump(e){const t=Math.round((e-this.lng)/360);if(0!==t)for(const e in this.indexes){const i=this.indexes[e],o={};for(const e in i){const r=i[e];r.tileID=r.tileID.unwrapTo(r.tileID.wrap+t),o[r.tileID.key]=r;}this.indexes[e]=o;}this.lng=e;}addBucket(e,t,i){if(this.indexes[e.overscaledZ]&&this.indexes[e.overscaledZ][e.key]){if(this.indexes[e.overscaledZ][e.key].bucketInstanceId===t.bucketInstanceId)return !1;this.removeBucketCrossTileIDs(e.overscaledZ,this.indexes[e.overscaledZ][e.key]);}for(let e=0;e<t.symbolInstances.length;e++)t.symbolInstances.get(e).crossTileID=0;this.usedCrossTileIDs[e.overscaledZ]||(this.usedCrossTileIDs[e.overscaledZ]={});const o=this.usedCrossTileIDs[e.overscaledZ];for(const i in this.indexes){const r=this.indexes[i];if(Number(i)>e.overscaledZ)for(const i in r){const n=r[i];n.tileID.isChildOf(e)&&n.findMatches(t.symbolInstances,e,o);}else {const n=r[e.scaledTo(Number(i)).key];n&&n.findMatches(t.symbolInstances,e,o);}}for(let e=0;e<t.symbolInstances.length;e++){const r=t.symbolInstances.get(e);r.crossTileID||(r.crossTileID=i.generate(),o[r.crossTileID]=!0);}return void 0===this.indexes[e.overscaledZ]&&(this.indexes[e.overscaledZ]={}),this.indexes[e.overscaledZ][e.key]=new Wt(e,t.symbolInstances,t.bucketInstanceId),!0}removeBucketCrossTileIDs(e,t){for(const i in t.indexedSymbolInstances)for(const o of t.indexedSymbolInstances[i])delete this.usedCrossTileIDs[e][o.crossTileID];}removeStaleBuckets(e){let t=!1;for(const i in this.indexes){const o=this.indexes[i];for(const r in o)e[o[r].bucketInstanceId]||(this.removeBucketCrossTileIDs(i,o[r]),delete o[r],t=!0);}return t}}class $t{constructor(){this.layerIndexes={},this.crossTileIDs=new Xt,this.maxBucketInstanceId=0,this.bucketsInCurrentPlacement={};}addLayer(e,t,i,o){let r=this.layerIndexes[e.id];void 0===r&&(r=this.layerIndexes[e.id]=new qt);let n=!1;const a={};"globe"!==o.name&&r.handleWrapJump(i);for(const i of t){const t=i.getBucket(e);t&&e.id===t.layerIds[0]&&(t.bucketInstanceId||(t.bucketInstanceId=++this.maxBucketInstanceId),r.addBucket(i.tileID,t,this.crossTileIDs)&&(n=!0),a[t.bucketInstanceId]=!0);}return r.removeStaleBuckets(a)&&(n=!0),n}pruneUnusedLayers(e){const t={};e.forEach((e=>{t[e]=!0;}));for(const e in this.layerIndexes)t[e]||delete this.layerIndexes[e];}}const Ht=(t,i)=>e.emitValidationErrors(t,i&&i.filter((e=>"source.canvas"!==e.identifier))),Yt=e.pick(Ve,["addLayer","removeLayer","setPaintProperty","setLayoutProperty","setFilter","addSource","removeSource","setLayerZoomRange","setLight","setTransition","setGeoJSONSourceData","setTerrain","setFog","setProjection"]),Kt=e.pick(Ve,["setCenter","setZoom","setBearing","setPitch"]),Jt={version:8,layers:[],sources:{}},Qt={fill:!0,line:!0,background:!0,hillshade:!0,raster:!0};class ei extends e.Evented{constructor(t,i={}){super(),this.map=t,this.dispatcher=new A(Ge(),this),this.imageManager=new y,this.imageManager.setEventedParent(this),this.glyphManager=new e.GlyphManager(t._requestManager,i.localFontFamily?e.LocalGlyphMode.all:i.localIdeographFontFamily?e.LocalGlyphMode.ideographs:e.LocalGlyphMode.none,i.localFontFamily||i.localIdeographFontFamily),this.lineAtlas=new e.LineAtlas(256,512),this.crossTileSymbolIndex=new $t,this._layers={},this._num3DLayers=0,this._numSymbolLayers=0,this._numCircleLayers=0,this._serializedLayers={},this._sourceCaches={},this._otherSourceCaches={},this._symbolSourceCaches={},this.zoomHistory=new e.ZoomHistory,this._loaded=!1,this._availableImages=[],this._order=[],this._drapedFirstOrder=[],this._markersNeedUpdate=!1,this._resetUpdates(),this.dispatcher.broadcast("setReferrer",e.getReferrer());const o=this;this._rtlTextPluginCallback=ei.registerForPluginStateChange((t=>{o.dispatcher.broadcast("syncRTLPluginState",{pluginStatus:t.pluginStatus,pluginURL:t.pluginURL},((t,i)=>{if(e.triggerPluginCompletionEvent(t),i&&i.every((e=>e)))for(const e in o._sourceCaches){const t=o._sourceCaches[e],i=t.getSource().type;"vector"!==i&&"geojson"!==i||t.reload();}}));})),this.on("data",(e=>{if("source"!==e.dataType||"metadata"!==e.sourceDataType)return;const t=this.getSource(e.sourceId);if(t&&t.vectorLayerIds)for(const e in this._layers){const i=this._layers[e];i.source===t.id&&this._validateLayer(i);}}));}loadURL(t,i={}){this.fire(new e.Event("dataloading",{dataType:"style"}));const o="boolean"==typeof i.validate?i.validate:!e.isMapboxURL(t);t=this.map._requestManager.normalizeStyleURL(t,i.accessToken);const r=this.map._requestManager.transformRequest(t,e.ResourceType.Style);this._request=e.getJSON(r,((t,i)=>{this._request=null,t?this.fire(new e.ErrorEvent(t)):i&&this._load(i,o);}));}loadJSON(t,i={}){this.fire(new e.Event("dataloading",{dataType:"style"})),this._request=e.exported.frame((()=>{this._request=null,this._load(t,!1!==i.validate);}));}loadEmpty(){this.fire(new e.Event("dataloading",{dataType:"style"})),this._load(Jt,!1);}_updateLayerCount(e,t){const i=t?1:-1;e.is3D()&&(this._num3DLayers+=i),"circle"===e.type&&(this._numCircleLayers+=i),"symbol"===e.type&&(this._numSymbolLayers+=i);}_load(t,i){if(i&&Ht(this,e.validateStyle(t)))return;this._loaded=!0,this.stylesheet=e.clone$1(t),this._updateMapProjection();for(const e in t.sources)this.addSource(e,t.sources[e],{validate:!1});this._changed=!1,t.sprite?this._loadSprite(t.sprite):(this.imageManager.setLoaded(!0),this.dispatcher.broadcast("spriteLoaded",!0)),this.glyphManager.setURL(t.glyphs);const o=Ze(this.stylesheet.layers);this._order=o.map((e=>e.id)),this._layers={},this._serializedLayers={};for(let t of o)t=e.createStyleLayer(t),t.setEventedParent(this,{layer:{id:t.id}}),this._layers[t.id]=t,this._serializedLayers[t.id]=t.serialize(),this._updateLayerCount(t,!0);this.dispatcher.broadcast("setLayers",this._serializeLayers(this._order)),this.light=new T(this.stylesheet.light),this.stylesheet.terrain&&!this.terrainSetForDrapingOnly()&&this._createTerrain(this.stylesheet.terrain,1),this.stylesheet.fog&&this._createFog(this.stylesheet.fog),this._updateDrapeFirstLayers(),this.fire(new e.Event("data",{dataType:"style"})),this.fire(new e.Event("style.load"));}terrainSetForDrapingOnly(){return !!this.terrain&&0===this.terrain.drapeRenderMode}setProjection(e){e?this.stylesheet.projection=e:delete this.stylesheet.projection,this._updateMapProjection();}applyProjectionUpdate(){this._loaded&&(this.dispatcher.broadcast("setProjection",this.map.transform.projectionOptions),this.map.transform.projection.requiresDraping?this.getTerrain()||this.stylesheet.terrain||this.setTerrainForDraping():this.terrainSetForDrapingOnly()&&this.setTerrain(null));}_updateMapProjection(){this.map._useExplicitProjection?this.applyProjectionUpdate():this.map._prioritizeAndUpdateProjection(null,this.stylesheet.projection);}_loadSprite(t){this._spriteRequest=function(t,i,o){let r,n,a;const s=e.exported.devicePixelRatio>1?"@2x":"";let l=e.getJSON(i.transformRequest(i.normalizeSpriteURL(t,s,".json"),e.ResourceType.SpriteJSON),((e,t)=>{l=null,a||(a=e,r=t,h());})),c=e.getImage(i.transformRequest(i.normalizeSpriteURL(t,s,".png"),e.ResourceType.SpriteImage),((e,t)=>{c=null,a||(a=e,n=t,h());}));function h(){if(a)o(a);else if(r&&n){const t=e.exported.getImageData(n),i={};for(const o in r){const{width:n,height:a,x:s,y:l,sdf:c,pixelRatio:h,stretchX:u,stretchY:_,content:d}=r[o],p=new e.RGBAImage({width:n,height:a});e.RGBAImage.copy(t,p,{x:s,y:l},{x:0,y:0},{width:n,height:a}),i[o]={data:p,pixelRatio:h,sdf:c,stretchX:u,stretchY:_,content:d};}o(null,i);}}return {cancel(){l&&(l.cancel(),l=null),c&&(c.cancel(),c=null);}}}(t,this.map._requestManager,((t,i)=>{if(this._spriteRequest=null,t)this.fire(new e.ErrorEvent(t));else if(i)for(const e in i)this.imageManager.addImage(e,i[e]);this.imageManager.setLoaded(!0),this._availableImages=this.imageManager.listImages(),this.dispatcher.broadcast("setImages",this._availableImages),this.dispatcher.broadcast("spriteLoaded",!0),this.fire(new e.Event("data",{dataType:"style"}));}));}_validateLayer(t){const i=this.getSource(t.source);if(!i)return;const o=t.sourceLayer;o&&("geojson"===i.type||i.vectorLayerIds&&-1===i.vectorLayerIds.indexOf(o))&&this.fire(new e.ErrorEvent(new Error(`Source layer "${o}" does not exist on source "${i.id}" as specified by style layer "${t.id}"`)));}loaded(){if(!this._loaded)return !1;if(Object.keys(this._updatedSources).length)return !1;for(const e in this._sourceCaches)if(!this._sourceCaches[e].loaded())return !1;return !!this.imageManager.isLoaded()}_serializeLayers(e){const t=[];for(const i of e){const e=this._layers[i];"custom"!==e.type&&t.push(e.serialize());}return t}hasTransitions(){if(this.light&&this.light.hasTransition())return !0;if(this.fog&&this.fog.hasTransition())return !0;for(const e in this._sourceCaches)if(this._sourceCaches[e].hasTransition())return !0;for(const e in this._layers)if(this._layers[e].hasTransition())return !0;return !1}get order(){return this.map._optimizeForTerrain&&this.terrain?this._drapedFirstOrder:this._order}isLayerDraped(e){return !!this.terrain&&Qt[e.type]}_checkLoaded(){if(!this._loaded)throw new Error("Style is not done loading")}update(t){if(!this._loaded)return;const i=this._changed;if(this._changed){const e=Object.keys(this._updatedLayers),i=Object.keys(this._removedLayers);(e.length||i.length)&&this._updateWorkerLayers(e,i);for(const e in this._updatedSources){const t=this._updatedSources[e];"reload"===t?this._reloadSource(e):"clear"===t&&this._clearSource(e);}this._updateTilesForChangedImages();for(const e in this._updatedPaintProps)this._layers[e].updateTransitions(t);this.light.updateTransitions(t),this.fog&&this.fog.updateTransitions(t),this._resetUpdates();}const o={};for(const e in this._sourceCaches){const t=this._sourceCaches[e];o[e]=t.used,t.used=!1;}for(const e of this._order){const i=this._layers[e];if(i.recalculate(t,this._availableImages),!i.isHidden(t.zoom)){const e=this._getLayerSourceCache(i);e&&(e.used=!0);}const o=this.map.painter;if(o){const e=i.getProgramIds();if(!e)continue;const r=i.getProgramConfiguration(t.zoom);for(const t of e)o.useProgram(t,r);}}for(const t in o){const i=this._sourceCaches[t];o[t]!==i.used&&i.getSource().fire(new e.Event("data",{sourceDataType:"visibility",dataType:"source",sourceId:i.getSource().id}));}this.light.recalculate(t),this.terrain&&this.terrain.recalculate(t),this.fog&&this.fog.recalculate(t),this.z=t.zoom,this._markersNeedUpdate&&(this._updateMarkersOpacity(),this._markersNeedUpdate=!1),i&&this.fire(new e.Event("data",{dataType:"style"}));}_updateTilesForChangedImages(){const e=Object.keys(this._changedImages);if(e.length){for(const t in this._sourceCaches)this._sourceCaches[t].reloadTilesForDependencies(["icons","patterns"],e);this._changedImages={};}}_updateWorkerLayers(e,t){this.dispatcher.broadcast("updateLayers",{layers:this._serializeLayers(e),removedIds:t});}_resetUpdates(){this._changed=!1,this._updatedLayers={},this._removedLayers={},this._updatedSources={},this._updatedPaintProps={},this._changedImages={};}setState(i){if(this._checkLoaded(),Ht(this,e.validateStyle(i)))return !1;(i=e.clone$1(i)).layers=Ze(i.layers);const o=function(e,i){if(!e)return [{command:Ve.setStyle,args:[i]}];let o=[];try{if(!t(e.version,i.version))return [{command:Ve.setStyle,args:[i]}];t(e.center,i.center)||o.push({command:Ve.setCenter,args:[i.center]}),t(e.zoom,i.zoom)||o.push({command:Ve.setZoom,args:[i.zoom]}),t(e.bearing,i.bearing)||o.push({command:Ve.setBearing,args:[i.bearing]}),t(e.pitch,i.pitch)||o.push({command:Ve.setPitch,args:[i.pitch]}),t(e.sprite,i.sprite)||o.push({command:Ve.setSprite,args:[i.sprite]}),t(e.glyphs,i.glyphs)||o.push({command:Ve.setGlyphs,args:[i.glyphs]}),t(e.transition,i.transition)||o.push({command:Ve.setTransition,args:[i.transition]}),t(e.light,i.light)||o.push({command:Ve.setLight,args:[i.light]}),t(e.fog,i.fog)||o.push({command:Ve.setFog,args:[i.fog]}),t(e.projection,i.projection)||o.push({command:Ve.setProjection,args:[i.projection]});const r={},n=[];!function(e,i,o,r){let n;for(n in i=i||{},e=e||{})e.hasOwnProperty(n)&&(i.hasOwnProperty(n)||Xe(n,o,r));for(n in i)i.hasOwnProperty(n)&&(e.hasOwnProperty(n)?t(e[n],i[n])||("geojson"===e[n].type&&"geojson"===i[n].type&&$e(e,i,n)?o.push({command:Ve.setGeoJSONSourceData,args:[n,i[n].data]}):qe(n,i,o,r)):We(n,i,o));}(e.sources,i.sources,n,r);const a=[];e.layers&&e.layers.forEach((e=>{e.source&&r[e.source]?o.push({command:Ve.removeLayer,args:[e.id]}):a.push(e);}));let s=e.terrain;s&&r[s.source]&&(o.push({command:Ve.setTerrain,args:[void 0]}),s=void 0),o=o.concat(n),t(s,i.terrain)||o.push({command:Ve.setTerrain,args:[i.terrain]}),function(e,i,o){i=i||[];const r=(e=e||[]).map(Ye),n=i.map(Ye),a=e.reduce(Ke,{}),s=i.reduce(Ke,{}),l=r.slice(),c=Object.create(null);let h,u,_,d,p,m,f;for(h=0,u=0;h<r.length;h++)_=r[h],s.hasOwnProperty(_)?u++:(o.push({command:Ve.removeLayer,args:[_]}),l.splice(l.indexOf(_,u),1));for(h=0,u=0;h<n.length;h++)_=n[n.length-1-h],l[l.length-1-h]!==_&&(a.hasOwnProperty(_)?(o.push({command:Ve.removeLayer,args:[_]}),l.splice(l.lastIndexOf(_,l.length-u),1)):u++,m=l[l.length-h],o.push({command:Ve.addLayer,args:[s[_],m]}),l.splice(l.length-h,0,_),c[_]=!0);for(h=0;h<n.length;h++)if(_=n[h],d=a[_],p=s[_],!c[_]&&!t(d,p))if(t(d.source,p.source)&&t(d["source-layer"],p["source-layer"])&&t(d.type,p.type)){for(f in He(d.layout,p.layout,o,_,null,Ve.setLayoutProperty),He(d.paint,p.paint,o,_,null,Ve.setPaintProperty),t(d.filter,p.filter)||o.push({command:Ve.setFilter,args:[_,p.filter]}),t(d.minzoom,p.minzoom)&&t(d.maxzoom,p.maxzoom)||o.push({command:Ve.setLayerZoomRange,args:[_,p.minzoom,p.maxzoom]}),d)d.hasOwnProperty(f)&&"layout"!==f&&"paint"!==f&&"filter"!==f&&"metadata"!==f&&"minzoom"!==f&&"maxzoom"!==f&&(0===f.indexOf("paint.")?He(d[f],p[f],o,_,f.slice(6),Ve.setPaintProperty):t(d[f],p[f])||o.push({command:Ve.setLayerProperty,args:[_,f,p[f]]}));for(f in p)p.hasOwnProperty(f)&&!d.hasOwnProperty(f)&&"layout"!==f&&"paint"!==f&&"filter"!==f&&"metadata"!==f&&"minzoom"!==f&&"maxzoom"!==f&&(0===f.indexOf("paint.")?He(d[f],p[f],o,_,f.slice(6),Ve.setPaintProperty):t(d[f],p[f])||o.push({command:Ve.setLayerProperty,args:[_,f,p[f]]}));}else o.push({command:Ve.removeLayer,args:[_]}),m=l[l.lastIndexOf(_)+1],o.push({command:Ve.addLayer,args:[p,m]});}(a,i.layers,o);}catch(e){console.warn("Unable to compute style diff:",e),o=[{command:Ve.setStyle,args:[i]}];}return o}(this.serialize(),i).filter((e=>!(e.command in Kt)));if(0===o.length)return !1;const r=o.filter((e=>!(e.command in Yt)));if(r.length>0)throw new Error(`Unimplemented: ${r.map((e=>e.command)).join(", ")}.`);return o.forEach((e=>{"setTransition"!==e.command&&"setProjection"!==e.command&&this[e.command].apply(this,e.args);})),this.stylesheet=i,this._updateMapProjection(),!0}addImage(t,i){return this.getImage(t)?this.fire(new e.ErrorEvent(new Error("An image with this name already exists."))):(this.imageManager.addImage(t,i),this._afterImageUpdated(t),this)}updateImage(e,t){this.imageManager.updateImage(e,t);}getImage(e){return this.imageManager.getImage(e)}removeImage(t){return this.getImage(t)?(this.imageManager.removeImage(t),this._afterImageUpdated(t),this):this.fire(new e.ErrorEvent(new Error("No image with this name exists.")))}_afterImageUpdated(t){this._availableImages=this.imageManager.listImages(),this._changedImages[t]=!0,this._changed=!0,this.dispatcher.broadcast("setImages",this._availableImages),this.fire(new e.Event("data",{dataType:"style"}));}listImages(){return this._checkLoaded(),this._availableImages.slice()}addSource(t,i,o={}){if(this._checkLoaded(),void 0!==this.getSource(t))throw new Error("There is already a source with this ID");if(!i.type)throw new Error(`The type property must be defined, but only the following properties were given: ${Object.keys(i).join(", ")}.`);if(["vector","raster","geojson","video","image"].indexOf(i.type)>=0&&this._validate(e.validateSource,`sources.${t}`,i,null,o))return;this.map&&this.map._collectResourceTiming&&(i.collectResourceTiming=!0);const r=Ae(t,i,this.dispatcher,this);r.setEventedParent(this,(()=>({isSourceLoaded:this._isSourceCacheLoaded(t),source:r.serialize(),sourceId:t})));const n=i=>{const o=(i?"symbol:":"other:")+t,n=this._sourceCaches[o]=new e.SourceCache(o,r,i);(i?this._symbolSourceCaches:this._otherSourceCaches)[t]=n,n.style=this,n.onAdd(this.map);};n(!1),"vector"!==i.type&&"geojson"!==i.type||n(!0),r.onAdd&&r.onAdd(this.map),this._changed=!0;}removeSource(t){this._checkLoaded();const i=this.getSource(t);if(!i)throw new Error("There is no source with this ID");for(const i in this._layers)if(this._layers[i].source===t)return this.fire(new e.ErrorEvent(new Error(`Source "${t}" cannot be removed while layer "${i}" is using it.`)));if(this.terrain&&this.terrain.get().source===t)return this.fire(new e.ErrorEvent(new Error(`Source "${t}" cannot be removed while terrain is using it.`)));const o=this._getSourceCaches(t);for(const t of o)delete this._sourceCaches[t.id],delete this._updatedSources[t.id],t.fire(new e.Event("data",{sourceDataType:"metadata",dataType:"source",sourceId:t.getSource().id})),t.setEventedParent(null),t.clearTiles();return delete this._otherSourceCaches[t],delete this._symbolSourceCaches[t],i.setEventedParent(null),i.onRemove&&i.onRemove(this.map),this._changed=!0,this}setGeoJSONSourceData(e,t){this._checkLoaded(),this.getSource(e).setData(t),this._changed=!0;}getSource(e){const t=this._getSourceCache(e);return t&&t.getSource()}addLayer(t,i,o={}){this._checkLoaded();const r=t.id;if(this.getLayer(r))return void this.fire(new e.ErrorEvent(new Error(`Layer with id "${r}" already exists on this map`)));let n;if("custom"===t.type){if(Ht(this,e.validateCustomStyleLayer(t)))return;n=e.createStyleLayer(t);}else {if("object"==typeof t.source&&(this.addSource(r,t.source),t=e.clone$1(t),t=e.extend(t,{source:r})),this._validate(e.validateLayer,`layers.${r}`,t,{arrayIndex:-1},o))return;n=e.createStyleLayer(t),this._validateLayer(n),n.setEventedParent(this,{layer:{id:r}}),this._serializedLayers[n.id]=n.serialize(),this._updateLayerCount(n,!0);}const a=i?this._order.indexOf(i):this._order.length;if(i&&-1===a)return void this.fire(new e.ErrorEvent(new Error(`Layer with id "${i}" does not exist on this map.`)));this._order.splice(a,0,r),this._layerOrderChanged=!0,this._layers[r]=n;const s=this._getLayerSourceCache(n);if(this._removedLayers[r]&&n.source&&s&&"custom"!==n.type){const e=this._removedLayers[r];delete this._removedLayers[r],e.type!==n.type?this._updatedSources[n.source]="clear":(this._updatedSources[n.source]="reload",s.pause());}this._updateLayer(n),n.onAdd&&n.onAdd(this.map),this._updateDrapeFirstLayers();}moveLayer(t,i){if(this._checkLoaded(),this._changed=!0,!this._layers[t])return void this.fire(new e.ErrorEvent(new Error(`The layer '${t}' does not exist in the map's style and cannot be moved.`)));if(t===i)return;const o=this._order.indexOf(t);this._order.splice(o,1);const r=i?this._order.indexOf(i):this._order.length;i&&-1===r?this.fire(new e.ErrorEvent(new Error(`Layer with id "${i}" does not exist on this map.`))):(this._order.splice(r,0,t),this._layerOrderChanged=!0,this._updateDrapeFirstLayers());}removeLayer(t){this._checkLoaded();const i=this._layers[t];if(!i)return void this.fire(new e.ErrorEvent(new Error(`The layer '${t}' does not exist in the map's style and cannot be removed.`)));i.setEventedParent(null),this._updateLayerCount(i,!1);const o=this._order.indexOf(t);this._order.splice(o,1),this._layerOrderChanged=!0,this._changed=!0,this._removedLayers[t]=i,delete this._layers[t],delete this._serializedLayers[t],delete this._updatedLayers[t],delete this._updatedPaintProps[t],i.onRemove&&i.onRemove(this.map),this._updateDrapeFirstLayers();}getLayer(e){return this._layers[e]}hasLayer(e){return e in this._layers}hasLayerType(e){for(const t in this._layers)if(this._layers[t].type===e)return !0;return !1}setLayerZoomRange(t,i,o){this._checkLoaded();const r=this.getLayer(t);r?r.minzoom===i&&r.maxzoom===o||(null!=i&&(r.minzoom=i),null!=o&&(r.maxzoom=o),this._updateLayer(r)):this.fire(new e.ErrorEvent(new Error(`The layer '${t}' does not exist in the map's style and cannot have zoom extent.`)));}setFilter(i,o,r={}){this._checkLoaded();const n=this.getLayer(i);if(n){if(!t(n.filter,o))return null==o?(n.filter=void 0,void this._updateLayer(n)):void(this._validate(e.validateFilter,`layers.${n.id}.filter`,o,{layerType:n.type},r)||(n.filter=e.clone$1(o),this._updateLayer(n)))}else this.fire(new e.ErrorEvent(new Error(`The layer '${i}' does not exist in the map's style and cannot be filtered.`)));}getFilter(t){const i=this.getLayer(t);return i&&e.clone$1(i.filter)}setLayoutProperty(i,o,r,n={}){this._checkLoaded();const a=this.getLayer(i);a?t(a.getLayoutProperty(o),r)||(a.setLayoutProperty(o,r,n),this._updateLayer(a)):this.fire(new e.ErrorEvent(new Error(`The layer '${i}' does not exist in the map's style and cannot be styled.`)));}getLayoutProperty(t,i){const o=this.getLayer(t);if(o)return o.getLayoutProperty(i);this.fire(new e.ErrorEvent(new Error(`The layer '${t}' does not exist in the map's style.`)));}setPaintProperty(i,o,r,n={}){this._checkLoaded();const a=this.getLayer(i);a?t(a.getPaintProperty(o),r)||(a.setPaintProperty(o,r,n)&&this._updateLayer(a),this._changed=!0,this._updatedPaintProps[i]=!0):this.fire(new e.ErrorEvent(new Error(`The layer '${i}' does not exist in the map's style and cannot be styled.`)));}getPaintProperty(e,t){const i=this.getLayer(e);return i&&i.getPaintProperty(t)}setFeatureState(t,i){this._checkLoaded();const o=t.source,r=t.sourceLayer,n=this.getSource(o);if(!n)return void this.fire(new e.ErrorEvent(new Error(`The source '${o}' does not exist in the map's style.`)));const a=n.type;if("geojson"===a&&r)return void this.fire(new e.ErrorEvent(new Error("GeoJSON sources cannot have a sourceLayer parameter.")));if("vector"===a&&!r)return void this.fire(new e.ErrorEvent(new Error("The sourceLayer parameter must be provided for vector source types.")));void 0===t.id&&this.fire(new e.ErrorEvent(new Error("The feature id parameter must be provided.")));const s=this._getSourceCaches(o);for(const e of s)e.setFeatureState(r,t.id,i);}removeFeatureState(t,i){this._checkLoaded();const o=t.source,r=this.getSource(o);if(!r)return void this.fire(new e.ErrorEvent(new Error(`The source '${o}' does not exist in the map's style.`)));const n=r.type,a="vector"===n?t.sourceLayer:void 0;if("vector"===n&&!a)return void this.fire(new e.ErrorEvent(new Error("The sourceLayer parameter must be provided for vector source types.")));if(i&&"string"!=typeof t.id&&"number"!=typeof t.id)return void this.fire(new e.ErrorEvent(new Error("A feature id is required to remove its specific state property.")));const s=this._getSourceCaches(o);for(const e of s)e.removeFeatureState(a,t.id,i);}getFeatureState(t){this._checkLoaded();const i=t.source,o=t.sourceLayer,r=this.getSource(i);if(r){if("vector"!==r.type||o)return void 0===t.id&&this.fire(new e.ErrorEvent(new Error("The feature id parameter must be provided."))),this._getSourceCaches(i)[0].getFeatureState(o,t.id);this.fire(new e.ErrorEvent(new Error("The sourceLayer parameter must be provided for vector source types.")));}else this.fire(new e.ErrorEvent(new Error(`The source '${i}' does not exist in the map's style.`)));}getTransition(){return e.extend({duration:300,delay:0},this.stylesheet&&this.stylesheet.transition)}serialize(){const t={};for(const e in this._sourceCaches){const i=this._sourceCaches[e].getSource();t[i.id]||(t[i.id]=i.serialize());}return e.filterObject({version:this.stylesheet.version,name:this.stylesheet.name,metadata:this.stylesheet.metadata,light:this.stylesheet.light,terrain:this.stylesheet.terrain,fog:this.stylesheet.fog,center:this.stylesheet.center,zoom:this.stylesheet.zoom,bearing:this.stylesheet.bearing,pitch:this.stylesheet.pitch,sprite:this.stylesheet.sprite,glyphs:this.stylesheet.glyphs,transition:this.stylesheet.transition,projection:this.stylesheet.projection,sources:t,layers:this._serializeLayers(this._order)},(e=>void 0!==e))}_updateLayer(e){this._updatedLayers[e.id]=!0;const t=this._getLayerSourceCache(e);e.source&&!this._updatedSources[e.source]&&t&&"raster"!==t.getSource().type&&(this._updatedSources[e.source]="reload",t.pause()),this._changed=!0,e.invalidateCompiledFilter();}_flattenAndSortRenderedFeatures(e){const t=e=>"fill-extrusion"===this._layers[e].type,i={},o=[];for(let r=this._order.length-1;r>=0;r--){const n=this._order[r];if(t(n)){i[n]=r;for(const t of e){const e=t[n];if(e)for(const t of e)o.push(t);}}}o.sort(((e,t)=>t.intersectionZ-e.intersectionZ));const r=[];for(let n=this._order.length-1;n>=0;n--){const a=this._order[n];if(t(a))for(let e=o.length-1;e>=0;e--){const t=o[e].feature;if(i[t.layer.id]<n)break;r.push(t),o.pop();}else for(const t of e){const e=t[a];if(e)for(const t of e)r.push(t.feature);}}return r}queryRenderedFeatures(t,i,o){i&&i.filter&&this._validate(e.validateFilter,"queryRenderedFeatures.filter",i.filter,null,i);const r={};if(i&&i.layers){if(!Array.isArray(i.layers))return this.fire(new e.ErrorEvent(new Error("parameters.layers must be an Array."))),[];for(const t of i.layers){const i=this._layers[t];if(!i)return this.fire(new e.ErrorEvent(new Error(`The layer '${t}' does not exist in the map's style and cannot be queried for features.`))),[];r[i.source]=!0;}}const n=[];i.availableImages=this._availableImages;const a=i&&i.layers?i.layers.some((e=>{const t=this.getLayer(e);return t&&t.is3D()})):this.has3DLayers(),s=R.createFromScreenPoints(t,o);for(const e in this._sourceCaches){const t=this._sourceCaches[e].getSource().id;i.layers&&!r[t]||n.push(Re(this._sourceCaches[e],this._layers,this._serializedLayers,s,i,o,a,!!this.map._showQueryGeometry));}return this.placement&&n.push(function(e,t,i,o,r,n,a){const s={},l=n.queryRenderedSymbols(o),c=[];for(const e of Object.keys(l).map(Number))c.push(a[e]);c.sort(Be);for(const i of c){const o=i.featureIndex.lookupSymbolFeatures(l[i.bucketInstanceId],t,i.bucketIndex,i.sourceLayerIndex,r.filter,r.layers,r.availableImages,e);for(const e in o){const t=s[e]=s[e]||[],r=o[e];r.sort(((e,t)=>{const o=i.featureSortOrder;if(o){const i=o.indexOf(e.featureIndex);return o.indexOf(t.featureIndex)-i}return t.featureIndex-e.featureIndex}));for(const e of r)t.push(e);}}for(const t in s)s[t].forEach((o=>{const r=o.feature,n=i(e[t]).getFeatureState(r.layer["source-layer"],r.id);r.source=r.layer.source,r.layer["source-layer"]&&(r.sourceLayer=r.layer["source-layer"]),r.state=n;}));return s}(this._layers,this._serializedLayers,this._getLayerSourceCache.bind(this),s.screenGeometry,i,this.placement.collisionIndex,this.placement.retainedQueryData)),this._flattenAndSortRenderedFeatures(n)}querySourceFeatures(t,i){i&&i.filter&&this._validate(e.validateFilter,"querySourceFeatures.filter",i.filter,null,i);const o=this._getSourceCaches(t);let r=[];for(const e of o)r=r.concat(Oe(e,i));return r}addSourceType(e,t,i){return ei.getSourceType(e)?i(new Error(`A source type called "${e}" already exists.`)):(ei.setSourceType(e,t),t.workerSourceURL?void this.dispatcher.broadcast("loadWorkerSource",{name:e,url:t.workerSourceURL},i):i(null,null))}getLight(){return this.light.getLight()}setLight(e,i={}){this._checkLoaded();const o=this.light.getLight();let r=!1;for(const i in e)if(!t(e[i],o[i])){r=!0;break}if(!r)return;const n=this._setTransitionParameters({duration:300,delay:0});this.light.setLight(e,i),this.light.updateTransitions(n);}getTerrain(){return this.terrain&&1===this.terrain.drapeRenderMode?this.terrain.get():null}setTerrainForDraping(){this.setTerrain({source:"",exaggeration:0},0);}setTerrain(i,o=1){if(this._checkLoaded(),!i)return delete this.terrain,delete this.stylesheet.terrain,this.dispatcher.broadcast("enableTerrain",!1),this._force3DLayerUpdate(),void(this._markersNeedUpdate=!0);if(1===o){if("object"==typeof i.source){const t="terrain-dem-src";this.addSource(t,i.source),i=e.clone$1(i),i=e.extend(i,{source:t});}if(this._validate(e.validateTerrain,"terrain",i))return}if(!this.terrain||this.terrain&&o!==this.terrain.drapeRenderMode)this._createTerrain(i,o);else {const o=this.terrain,r=o.get();for(const t of Object.keys(e.spec.terrain))!i.hasOwnProperty(t)&&e.spec.terrain[t].default&&(i[t]=e.spec.terrain[t].default);for(const e in i)if(!t(i[e],r[e])){o.set(i),this.stylesheet.terrain=i;const e=this._setTransitionParameters({duration:0});o.updateTransitions(e);break}}this._updateDrapeFirstLayers(),this._markersNeedUpdate=!0;}_createFog(e){const t=this.fog=new P(e,this.map.transform);this.stylesheet.fog=e;const i=this._setTransitionParameters({duration:0});t.updateTransitions(i);}_updateMarkersOpacity(){0!==this.map._markers.length&&this.map._requestDomTask((()=>{for(const e of this.map._markers)e._evaluateOpacity();}));}getFog(){return this.fog?this.fog.get():null}setFog(e){if(this._checkLoaded(),!e)return delete this.fog,delete this.stylesheet.fog,void(this._markersNeedUpdate=!0);if(this.fog){const i=this.fog,o=i.get();0===Object.keys(e).length&&i.set(e);for(const r in e)if(!t(e[r],o[r])){i.set(e),this.stylesheet.fog=e;const t=this._setTransitionParameters({duration:0});i.updateTransitions(t);break}}else this._createFog(e);this._markersNeedUpdate=!0;}_setTransitionParameters(t){return {now:e.exported.now(),transition:e.extend(t,this.stylesheet.transition)}}_updateDrapeFirstLayers(){if(!this.map._optimizeForTerrain||!this.terrain)return;const e=this._order.filter((e=>this.isLayerDraped(this._layers[e]))),t=this._order.filter((e=>!this.isLayerDraped(this._layers[e])));this._drapedFirstOrder=[],this._drapedFirstOrder.push(...e),this._drapedFirstOrder.push(...t);}_createTerrain(e,t){const i=this.terrain=new I(e,t);this.stylesheet.terrain=e,this.dispatcher.broadcast("enableTerrain",!this.terrainSetForDrapingOnly()),this._force3DLayerUpdate();const o=this._setTransitionParameters({duration:0});i.updateTransitions(o);}_force3DLayerUpdate(){for(const e in this._layers){const t=this._layers[e];"fill-extrusion"===t.type&&this._updateLayer(t);}}_forceSymbolLayerUpdate(){for(const e in this._layers){const t=this._layers[e];"symbol"===t.type&&this._updateLayer(t);}}_validate(t,i,o,r,n={}){return (!n||!1!==n.validate)&&Ht(this,t.call(e.validateStyle,e.extend({key:i,style:this.serialize(),value:o,styleSpec:e.spec},r)))}_remove(){this._request&&(this._request.cancel(),this._request=null),this._spriteRequest&&(this._spriteRequest.cancel(),this._spriteRequest=null),e.evented.off("pluginStateChange",this._rtlTextPluginCallback);for(const e in this._layers)this._layers[e].setEventedParent(null);for(const e in this._sourceCaches)this._sourceCaches[e].clearTiles(),this._sourceCaches[e].setEventedParent(null);this.imageManager.setEventedParent(null),this.setEventedParent(null),this.dispatcher.remove();}_clearSource(e){const t=this._getSourceCaches(e);for(const e of t)e.clearTiles();}_reloadSource(e){const t=this._getSourceCaches(e);for(const e of t)e.resume(),e.reload();}_updateSources(e){for(const t in this._sourceCaches)this._sourceCaches[t].update(e);}_generateCollisionBoxes(){for(const e in this._sourceCaches){const t=this._sourceCaches[e];t.resume(),t.reload();}}_updatePlacement(t,i,o,r,n=!1){let a=!1,s=!1;const l={};for(const e of this._order){const i=this._layers[e];if("symbol"!==i.type)continue;if(!l[i.source]){const e=this._getLayerSourceCache(i);if(!e)continue;l[i.source]=e.getRenderableIds(!0).map((t=>e.getTileByID(t))).sort(((e,t)=>t.tileID.overscaledZ-e.tileID.overscaledZ||(e.tileID.isLessThan(t.tileID)?-1:1)));}const o=this.crossTileSymbolIndex.addLayer(i,l[i.source],t.center.lng,t.projection);a=a||o;}if(this.crossTileSymbolIndex.pruneUnusedLayers(this._order),n=n||this._layerOrderChanged||0===o,this._layerOrderChanged&&this.fire(new e.Event("neworder")),(n||!this.pauseablePlacement||this.pauseablePlacement.isDone()&&!this.placement.stillRecent(e.exported.now(),t.zoom))&&(this.pauseablePlacement=new Zt(t,this._order,n,i,o,r,this.placement,this.fog&&t.projection.supportsFog?this.fog.state:null),this._layerOrderChanged=!1),this.pauseablePlacement.isDone()?this.placement.setStale():(this.pauseablePlacement.continuePlacement(this._order,this._layers,l),this.pauseablePlacement.isDone()&&(this.placement=this.pauseablePlacement.commit(e.exported.now()),s=!0),a&&this.pauseablePlacement.placement.setStale()),s||a)for(const e of this._order){const t=this._layers[e];"symbol"===t.type&&this.placement.updateLayerOpacities(t,l[t.source]);}return !this.pauseablePlacement.isDone()||this.placement.hasTransitions(e.exported.now())}_releaseSymbolFadeTiles(){for(const e in this._sourceCaches)this._sourceCaches[e].releaseSymbolFadeTiles();}getImages(e,t,i){this.imageManager.getImages(t.icons,i),this._updateTilesForChangedImages();const o=e=>{e&&e.setDependencies(t.tileID.key,t.type,t.icons);};o(this._otherSourceCaches[t.source]),o(this._symbolSourceCaches[t.source]);}getGlyphs(e,t,i){this.glyphManager.getGlyphs(t.stacks,i);}getResource(t,i,o){return e.makeRequest(i,o)}_getSourceCache(e){return this._otherSourceCaches[e]}_getLayerSourceCache(e){return "symbol"===e.type?this._symbolSourceCaches[e.source]:this._otherSourceCaches[e.source]}_getSourceCaches(e){const t=[];return this._otherSourceCaches[e]&&t.push(this._otherSourceCaches[e]),this._symbolSourceCaches[e]&&t.push(this._symbolSourceCaches[e]),t}_isSourceCacheLoaded(t){const i=this._getSourceCaches(t);return 0===i.length?(this.fire(new e.ErrorEvent(new Error(`There is no source with ID '${t}'`))),!1):i.every((e=>e.loaded()))}has3DLayers(){return this._num3DLayers>0}hasSymbolLayers(){return this._numSymbolLayers>0}hasCircleLayers(){return this._numCircleLayers>0}_clearWorkerCaches(){this.dispatcher.broadcast("clearCaches");}destroy(){this._clearWorkerCaches(),this.terrainSetForDrapingOnly()&&(delete this.terrain,delete this.stylesheet.terrain);}}ei.getSourceType=function(e){return Pe[e]},ei.setSourceType=function(e,t){Pe[e]=t;},ei.registerForPluginStateChange=e.registerForPluginStateChange;var ti="\n#define EPSILON 0.0000001\n#define PI 3.141592653589793\n#define EXTENT 8192.0\n#define HALF_PI PI/2.0\n#define QUARTER_PI PI/4.0\n#define RAD_TO_DEG 180.0/PI\n#define DEG_TO_RAD PI/180.0\n#define GLOBE_RADIUS EXTENT/PI/2.0",ii="attribute highp vec3 a_pos_3f;uniform lowp mat4 u_matrix;varying highp vec3 v_uv;void main() {const mat3 half_neg_pi_around_x=mat3(1.0,0.0, 0.0,0.0,0.0,-1.0,0.0,1.0, 0.0);v_uv=half_neg_pi_around_x*a_pos_3f;vec4 pos=u_matrix*vec4(a_pos_3f,1.0);gl_Position=pos.xyww;}",oi="\n#define ELEVATION_SCALE 7.0\n#define ELEVATION_OFFSET 450.0\n#ifdef PROJECTION_GLOBE_VIEW\nuniform vec3 u_tile_tl_up;uniform vec3 u_tile_tr_up;uniform vec3 u_tile_br_up;uniform vec3 u_tile_bl_up;uniform float u_tile_up_scale;vec3 elevationVector(vec2 pos) {vec2 uv=pos/EXTENT;vec3 up=normalize(mix(\nmix(u_tile_tl_up,u_tile_tr_up,uv.xxx),mix(u_tile_bl_up,u_tile_br_up,uv.xxx),uv.yyy));return up*u_tile_up_scale;}\n#else\nvec3 elevationVector(vec2 pos) { return vec3(0,0,1); }\n#endif\n#ifdef TERRAIN\n#ifdef TERRAIN_DEM_FLOAT_FORMAT\nuniform highp sampler2D u_dem;uniform highp sampler2D u_dem_prev;\n#else\nuniform sampler2D u_dem;uniform sampler2D u_dem_prev;\n#endif\nuniform vec4 u_dem_unpack;uniform vec2 u_dem_tl;uniform vec2 u_dem_tl_prev;uniform float u_dem_scale;uniform float u_dem_scale_prev;uniform float u_dem_size;uniform float u_dem_lerp;uniform float u_exaggeration;uniform float u_meter_to_dem;uniform mat4 u_label_plane_matrix_inv;uniform sampler2D u_depth;uniform vec2 u_depth_size_inv;vec4 tileUvToDemSample(vec2 uv,float dem_size,float dem_scale,vec2 dem_tl) {vec2 pos=dem_size*(uv*dem_scale+dem_tl)+1.0;vec2 f=fract(pos);return vec4((pos-f+0.5)/(dem_size+2.0),f);}float decodeElevation(vec4 v) {return dot(vec4(v.xyz*255.0,-1.0),u_dem_unpack);}float currentElevation(vec2 apos) {\n#ifdef TERRAIN_DEM_FLOAT_FORMAT\nvec2 pos=(u_dem_size*(apos/8192.0*u_dem_scale+u_dem_tl)+1.5)/(u_dem_size+2.0);return u_exaggeration*texture2D(u_dem,pos).a;\n#else\nfloat dd=1.0/(u_dem_size+2.0);vec4 r=tileUvToDemSample(apos/8192.0,u_dem_size,u_dem_scale,u_dem_tl);vec2 pos=r.xy;vec2 f=r.zw;float tl=decodeElevation(texture2D(u_dem,pos));\n#ifdef TERRAIN_DEM_NEAREST_FILTER\nreturn u_exaggeration*tl;\n#endif\nfloat tr=decodeElevation(texture2D(u_dem,pos+vec2(dd,0.0)));float bl=decodeElevation(texture2D(u_dem,pos+vec2(0.0,dd)));float br=decodeElevation(texture2D(u_dem,pos+vec2(dd,dd)));return u_exaggeration*mix(mix(tl,tr,f.x),mix(bl,br,f.x),f.y);\n#endif\n}float prevElevation(vec2 apos) {\n#ifdef TERRAIN_DEM_FLOAT_FORMAT\nvec2 pos=(u_dem_size*(apos/8192.0*u_dem_scale_prev+u_dem_tl_prev)+1.5)/(u_dem_size+2.0);return u_exaggeration*texture2D(u_dem_prev,pos).a;\n#else\nfloat dd=1.0/(u_dem_size+2.0);vec4 r=tileUvToDemSample(apos/8192.0,u_dem_size,u_dem_scale_prev,u_dem_tl_prev);vec2 pos=r.xy;vec2 f=r.zw;float tl=decodeElevation(texture2D(u_dem_prev,pos));float tr=decodeElevation(texture2D(u_dem_prev,pos+vec2(dd,0.0)));float bl=decodeElevation(texture2D(u_dem_prev,pos+vec2(0.0,dd)));float br=decodeElevation(texture2D(u_dem_prev,pos+vec2(dd,dd)));return u_exaggeration*mix(mix(tl,tr,f.x),mix(bl,br,f.x),f.y);\n#endif\n}\n#ifdef TERRAIN_VERTEX_MORPHING\nfloat elevation(vec2 apos) {float nextElevation=currentElevation(apos);float prevElevation=prevElevation(apos);return mix(prevElevation,nextElevation,u_dem_lerp);}\n#else\nfloat elevation(vec2 apos) {return currentElevation(apos);}\n#endif\nhighp float unpack_depth(highp vec4 rgba_depth)\n{const highp vec4 bit_shift=vec4(1.0/(255.0*255.0*255.0),1.0/(255.0*255.0),1.0/255.0,1.0);return dot(rgba_depth,bit_shift)*2.0-1.0;}bool isOccluded(vec4 frag) {vec3 coord=frag.xyz/frag.w;float depth=unpack_depth(texture2D(u_depth,(coord.xy+1.0)*0.5));return coord.z > depth+0.0005;}float occlusionFade(vec4 frag) {vec3 coord=frag.xyz/frag.w;vec3 df=vec3(5.0*u_depth_size_inv,0.0);vec2 uv=0.5*coord.xy+0.5;vec4 depth=vec4(\nunpack_depth(texture2D(u_depth,uv-df.xz)),unpack_depth(texture2D(u_depth,uv+df.xz)),unpack_depth(texture2D(u_depth,uv-df.zy)),unpack_depth(texture2D(u_depth,uv+df.zy))\n);return dot(vec4(0.25),vec4(1.0)-clamp(300.0*(vec4(coord.z-0.001)-depth),0.0,1.0));}vec4 fourSample(vec2 pos,vec2 off) {\n#ifdef TERRAIN_DEM_FLOAT_FORMAT\nfloat tl=texture2D(u_dem,pos).a;float tr=texture2D(u_dem,pos+vec2(off.x,0.0)).a;float bl=texture2D(u_dem,pos+vec2(0.0,off.y)).a;float br=texture2D(u_dem,pos+off).a;\n#else\nvec4 demtl=vec4(texture2D(u_dem,pos).xyz*255.0,-1.0);float tl=dot(demtl,u_dem_unpack);vec4 demtr=vec4(texture2D(u_dem,pos+vec2(off.x,0.0)).xyz*255.0,-1.0);float tr=dot(demtr,u_dem_unpack);vec4 dembl=vec4(texture2D(u_dem,pos+vec2(0.0,off.y)).xyz*255.0,-1.0);float bl=dot(dembl,u_dem_unpack);vec4 dembr=vec4(texture2D(u_dem,pos+off).xyz*255.0,-1.0);float br=dot(dembr,u_dem_unpack);\n#endif\nreturn vec4(tl,tr,bl,br);}float flatElevation(vec2 pack) {vec2 apos=floor(pack/8.0);vec2 span=10.0*(pack-apos*8.0);vec2 uvTex=(apos-vec2(1.0,1.0))/8190.0;float size=u_dem_size+2.0;float dd=1.0/size;vec2 pos=u_dem_size*(uvTex*u_dem_scale+u_dem_tl)+1.0;vec2 f=fract(pos);pos=(pos-f+0.5)*dd;vec4 h=fourSample(pos,vec2(dd));float z=mix(mix(h.x,h.y,f.x),mix(h.z,h.w,f.x),f.y);vec2 w=floor(0.5*(span*u_meter_to_dem-1.0));vec2 d=dd*w;vec4 bounds=vec4(d,vec2(1.0)-d);h=fourSample(pos-d,2.0*d+vec2(dd));vec4 diff=abs(h.xzxy-h.ywzw);vec2 slope=min(vec2(0.25),u_meter_to_dem*0.5*(diff.xz+diff.yw)/(2.0*w+vec2(1.0)));vec2 fix=slope*span;float base=z+max(fix.x,fix.y);return u_exaggeration*base;}float elevationFromUint16(float word) {return u_exaggeration*(word/ELEVATION_SCALE-ELEVATION_OFFSET);}\n#else\nfloat elevation(vec2 pos) { return 0.0; }bool isOccluded(vec4 frag) { return false; }float occlusionFade(vec4 frag) { return 1.0; }\n#endif",ri="#ifdef FOG\nuniform mediump vec4 u_fog_color;uniform mediump vec2 u_fog_range;uniform mediump float u_fog_horizon_blend;uniform mediump mat4 u_fog_matrix;varying vec3 v_fog_pos;float fog_range(float depth) {return (depth-u_fog_range[0])/(u_fog_range[1]-u_fog_range[0]);}float fog_horizon_blending(vec3 camera_dir) {float t=max(0.0,camera_dir.z/u_fog_horizon_blend);return u_fog_color.a*exp(-3.0*t*t);}float fog_opacity(float t) {const float decay=6.0;float falloff=1.0-min(1.0,exp(-decay*t));falloff*=falloff*falloff;return u_fog_color.a*min(1.0,1.00747*falloff);}vec3 fog_position(vec3 pos) {return (u_fog_matrix*vec4(pos,1.0)).xyz;}vec3 fog_position(vec2 pos) {return fog_position(vec3(pos,0.0));}float fog(vec3 pos) {float depth=length(pos);float opacity=fog_opacity(fog_range(depth));return opacity*fog_horizon_blending(pos/depth);}\n#endif",ni="#ifdef FOG\nuniform mediump vec4 u_fog_color;uniform mediump vec2 u_fog_range;uniform mediump float u_fog_horizon_blend;uniform mediump float u_fog_temporal_offset;varying vec3 v_fog_pos;uniform highp vec3 u_frustum_tl;uniform highp vec3 u_frustum_tr;uniform highp vec3 u_frustum_br;uniform highp vec3 u_frustum_bl;uniform highp vec3 u_globe_pos;uniform highp float u_globe_radius;uniform highp vec2 u_viewport;uniform float u_globe_transition;uniform int u_is_globe;float fog_range(float depth) {return (depth-u_fog_range[0])/(u_fog_range[1]-u_fog_range[0]);}float fog_horizon_blending(vec3 camera_dir) {float t=max(0.0,camera_dir.z/u_fog_horizon_blend);return u_fog_color.a*exp(-3.0*t*t);}float fog_opacity(float t) {const float decay=6.0;float falloff=1.0-min(1.0,exp(-decay*t));falloff*=falloff*falloff;return u_fog_color.a*min(1.0,1.00747*falloff);}float globe_glow_progress() {highp vec2 uv=gl_FragCoord.xy/u_viewport;highp vec3 ray_dir=mix(\nmix(u_frustum_tl,u_frustum_tr,uv.x),mix(u_frustum_bl,u_frustum_br,uv.x),1.0-uv.y);highp vec3 dir=normalize(ray_dir);highp vec3 closest_point=dot(u_globe_pos,dir)*dir;highp float sdf=length(closest_point-u_globe_pos)/u_globe_radius;return sdf+PI*0.5;}float fog_opacity(vec3 pos) {float depth=length(pos);return fog_opacity(fog_range(depth));}vec3 fog_apply(vec3 color,vec3 pos) {float depth=length(pos);float opacity;if (u_is_globe==1) {float glow_progress=globe_glow_progress();float t=mix(glow_progress,depth,u_globe_transition);opacity=fog_opacity(fog_range(t));} else {opacity=fog_opacity(fog_range(depth));opacity*=fog_horizon_blending(pos/depth);}return mix(color,u_fog_color.rgb,opacity);}vec4 fog_apply_from_vert(vec4 color,float fog_opac) {float alpha=EPSILON+color.a;color.rgb=mix(color.rgb/alpha,u_fog_color.rgb,fog_opac)*alpha;return color;}vec3 fog_apply_sky_gradient(vec3 camera_ray,vec3 sky_color) {float horizon_blend=fog_horizon_blending(normalize(camera_ray));return mix(sky_color,u_fog_color.rgb,horizon_blend);}vec4 fog_apply_premultiplied(vec4 color,vec3 pos) {float alpha=EPSILON+color.a;color.rgb=fog_apply(color.rgb/alpha,pos)*alpha;return color;}vec3 fog_dither(vec3 color) {vec2 dither_seed=gl_FragCoord.xy+u_fog_temporal_offset;return dither(color,dither_seed);}vec4 fog_dither(vec4 color) {return vec4(fog_dither(color.rgb),color.a);}\n#endif";let ai={},si={};const li=[];di(ti,li),di(oi,li),di(ri,li),di(ni,li),ai=pi("",oi),si=pi(ni,ri);const ci=pi("\nhighp vec3 hash(highp vec2 p) {highp vec3 p3=fract(p.xyx*vec3(443.8975,397.2973,491.1871));p3+=dot(p3,p3.yxz+19.19);return fract((p3.xxy+p3.yzz)*p3.zyx);}vec3 dither(vec3 color,highp vec2 seed) {vec3 rnd=hash(seed)+hash(seed+0.59374)-0.5;return color+rnd/255.0;}highp float unpack_depth(highp vec4 rgba_depth)\n{const highp vec4 bit_shift=vec4(1.0/(255.0*255.0*255.0),1.0/(255.0*255.0),1.0/255.0,1.0);return dot(rgba_depth,bit_shift)*2.0-1.0;}highp vec4 pack_depth(highp float ndc_z) {highp float depth=ndc_z*0.5+0.5;const highp vec4 bit_shift=vec4(255.0*255.0*255.0,255.0*255.0,255.0,1.0);const highp vec4 bit_mask =vec4(0.0,1.0/255.0,1.0/255.0,1.0/255.0);highp vec4 res=fract(depth*bit_shift);res-=res.xxyz*bit_mask;return res;}","\nfloat wrap(float n,float min,float max) {float d=max-min;float w=mod(mod(n-min,d)+d,d)+min;return (w==min) ? max : w;}\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 mercator_tile_position(mat4 matrix,vec2 tile_anchor,vec3 tile_id,vec2 mercator_center) {\n#ifndef PROJECTED_POS_ON_VIEWPORT\nfloat tiles=tile_id.z;vec2 mercator=(tile_anchor/EXTENT+tile_id.xy)/tiles;mercator-=mercator_center;mercator.x=wrap(mercator.x,-0.5,0.5);vec4 mercator_tile=vec4(mercator.xy*EXTENT,EXTENT/(2.0*PI),1.0);mercator_tile=matrix*mercator_tile;return mercator_tile.xyz;\n#else\nreturn vec3(0.0);\n#endif\n}vec3 mix_globe_mercator(vec3 globe,vec3 mercator,float t) {return mix(globe,mercator,t);}mat3 globe_mercator_surface_vectors(vec3 pos_normal,vec3 up_dir,float zoom_transition) {vec3 normal=zoom_transition==0.0 ? pos_normal : normalize(mix(pos_normal,up_dir,zoom_transition));vec3 xAxis=normalize(vec3(normal.z,0.0,-normal.x));vec3 yAxis=normalize(cross(normal,xAxis));return mat3(xAxis,yAxis,normal);}\n#endif\nvec2 unpack_float(const float packedValue) {int packedIntValue=int(packedValue);int v0=packedIntValue/256;return vec2(v0,packedIntValue-v0*256);}vec2 unpack_opacity(const float packedOpacity) {int intOpacity=int(packedOpacity)/2;return vec2(float(intOpacity)/127.0,mod(packedOpacity,2.0));}vec4 decode_color(const vec2 encodedColor) {return vec4(\nunpack_float(encodedColor[0])/255.0,unpack_float(encodedColor[1])/255.0\n);}float unpack_mix_vec2(const vec2 packedValue,const float t) {return mix(packedValue[0],packedValue[1],t);}vec4 unpack_mix_color(const vec4 packedColors,const float t) {vec4 minColor=decode_color(vec2(packedColors[0],packedColors[1]));vec4 maxColor=decode_color(vec2(packedColors[2],packedColors[3]));return mix(minColor,maxColor,t);}vec2 get_pattern_pos(const vec2 pixel_coord_upper,const vec2 pixel_coord_lower,const vec2 pattern_size,const float tile_units_to_pixels,const vec2 pos) {vec2 offset=mod(mod(mod(pixel_coord_upper,pattern_size)*256.0,pattern_size)*256.0+pixel_coord_lower,pattern_size);return (tile_units_to_pixels*pos+offset)/pattern_size;}const vec4 AWAY=vec4(-1000.0,-1000.0,-1000.0,1);//Normalized device coordinate that is not rendered."),hi=ti,ui="\n#ifdef GL_ES\nprecision mediump float;\n#else\n\n#if !defined(lowp)\n#define lowp\n#endif\n\n#if !defined(mediump)\n#define mediump\n#endif\n\n#if !defined(highp)\n#define highp\n#endif\n\n#endif";var _i={background:pi("uniform vec4 u_color;uniform float u_opacity;void main() {vec4 out_color=u_color;\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\ngl_FragColor=out_color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","attribute vec2 a_pos;uniform mat4 u_matrix;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}"),backgroundPattern:pi("uniform vec2 u_pattern_tl_a;uniform vec2 u_pattern_br_a;uniform vec2 u_pattern_tl_b;uniform vec2 u_pattern_br_b;uniform vec2 u_texsize;uniform float u_mix;uniform float u_opacity;uniform sampler2D u_image;varying vec2 v_pos_a;varying vec2 v_pos_b;void main() {vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(u_pattern_tl_a/u_texsize,u_pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(u_pattern_tl_b/u_texsize,u_pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);vec4 out_color=mix(color1,color2,u_mix);\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\ngl_FragColor=out_color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","uniform mat4 u_matrix;uniform vec2 u_pattern_size_a;uniform vec2 u_pattern_size_b;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_scale_a;uniform float u_scale_b;uniform float u_tile_units_to_pixels;attribute vec2 a_pos;varying vec2 v_pos_a;varying vec2 v_pos_b;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,u_scale_a*u_pattern_size_a,u_tile_units_to_pixels,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,u_scale_b*u_pattern_size_b,u_tile_units_to_pixels,a_pos);\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}"),circle:pi("varying vec3 v_data;varying float v_visibility;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump float radius\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp vec4 stroke_color\n#pragma mapbox: initialize mediump float stroke_width\n#pragma mapbox: initialize lowp float stroke_opacity\nvec2 extrude=v_data.xy;float extrude_length=length(extrude);lowp float antialiasblur=v_data.z;float antialiased_blur=-max(blur,antialiasblur);float opacity_t=smoothstep(0.0,antialiased_blur,extrude_length-1.0);float color_t=stroke_width < 0.01 ? 0.0 : smoothstep(\nantialiased_blur,0.0,extrude_length-radius/(radius+stroke_width)\n);vec4 out_color=mix(color*opacity,stroke_color*stroke_opacity,color_t);\n#ifdef FOG\nout_color=fog_apply_premultiplied(out_color,v_fog_pos);\n#endif\ngl_FragColor=out_color*(v_visibility*opacity_t);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","#define NUM_VISIBILITY_RINGS 2\n#define INV_SQRT2 0.70710678\n#define ELEVATION_BIAS 0.0001\n#define NUM_SAMPLES_PER_RING 16\nuniform mat4 u_matrix;uniform mat2 u_extrude_scale;uniform lowp float u_device_pixel_ratio;uniform highp float u_camera_to_center_distance;attribute vec2 a_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nattribute vec3 a_pos_3;attribute vec3 a_pos_normal_3;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_tile_id;uniform float u_zoom_transition;uniform vec3 u_up_dir;\n#endif\nvarying vec3 v_data;varying float v_visibility;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\nvec2 calc_offset(vec2 extrusion,float radius,float stroke_width, float view_scale) {return extrusion*(radius+stroke_width)*u_extrude_scale*view_scale;}float cantilevered_elevation(vec2 pos,float radius,float stroke_width,float view_scale) {vec2 c1=pos+calc_offset(vec2(-1,-1),radius,stroke_width,view_scale);vec2 c2=pos+calc_offset(vec2(1,-1),radius,stroke_width,view_scale);vec2 c3=pos+calc_offset(vec2(1,1),radius,stroke_width,view_scale);vec2 c4=pos+calc_offset(vec2(-1,1),radius,stroke_width,view_scale);float h1=elevation(c1)+ELEVATION_BIAS;float h2=elevation(c2)+ELEVATION_BIAS;float h3=elevation(c3)+ELEVATION_BIAS;float h4=elevation(c4)+ELEVATION_BIAS;return max(h4,max(h3,max(h1,h2)));}float circle_elevation(vec2 pos) {\n#if defined(TERRAIN)\nreturn elevation(pos)+ELEVATION_BIAS;\n#else\nreturn 0.0;\n#endif\n}vec4 project_vertex(vec2 extrusion,vec4 world_center,vec4 projected_center,float radius,float stroke_width, float view_scale,mat3 surface_vectors) {vec2 sample_offset=calc_offset(extrusion,radius,stroke_width,view_scale);\n#ifdef PITCH_WITH_MAP\n#ifdef PROJECTION_GLOBE_VIEW\nreturn u_matrix*( world_center+vec4(sample_offset.x*surface_vectors[0]+sample_offset.y*surface_vectors[1],0) );\n#else\nreturn u_matrix*( world_center+vec4(sample_offset,0,0) );\n#endif\n#else\nreturn projected_center+vec4(sample_offset,0,0);\n#endif\n}float get_sample_step() {\n#ifdef PITCH_WITH_MAP\nreturn 2.0*PI/float(NUM_SAMPLES_PER_RING);\n#else\nreturn PI/float(NUM_SAMPLES_PER_RING);\n#endif\n}void main(void) {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump float radius\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp vec4 stroke_color\n#pragma mapbox: initialize mediump float stroke_width\n#pragma mapbox: initialize lowp float stroke_opacity\nvec2 extrude=vec2(mod(a_pos,2.0)*2.0-1.0);vec2 circle_center=floor(a_pos*0.5);\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 pos_normal_3=a_pos_normal_3/16384.0;mat3 surface_vectors=globe_mercator_surface_vectors(pos_normal_3,u_up_dir,u_zoom_transition);vec3 surface_extrusion=extrude.x*surface_vectors[0]+extrude.y*surface_vectors[1];vec3 globe_elevation=elevationVector(circle_center)*circle_elevation(circle_center);vec3 globe_pos=a_pos_3+surface_extrusion+globe_elevation;vec3 mercator_elevation=u_up_dir*u_tile_up_scale*circle_elevation(circle_center);vec3 merc_pos=mercator_tile_position(u_inv_rot_matrix,circle_center,u_tile_id,u_merc_center)+surface_extrusion+mercator_elevation;vec3 pos=mix_globe_mercator(globe_pos,merc_pos,u_zoom_transition);vec4 world_center=vec4(pos,1);\n#else \nmat3 surface_vectors=mat3(1.0);float height=circle_elevation(circle_center);vec4 world_center=vec4(circle_center,height,1);\n#endif\nvec4 projected_center=u_matrix*world_center;float view_scale=0.0;\n#ifdef PITCH_WITH_MAP\n#ifdef SCALE_WITH_MAP\nview_scale=1.0;\n#else\nview_scale=projected_center.w/u_camera_to_center_distance;\n#endif\n#else\n#ifdef SCALE_WITH_MAP\nview_scale=u_camera_to_center_distance;\n#else\nview_scale=projected_center.w;\n#endif\n#endif\ngl_Position=project_vertex(extrude,world_center,projected_center,radius,stroke_width,view_scale,surface_vectors);float visibility=0.0;\n#ifdef TERRAIN\nfloat step=get_sample_step();\n#ifdef PITCH_WITH_MAP\nfloat cantilevered_height=cantilevered_elevation(circle_center,radius,stroke_width,view_scale);vec4 occlusion_world_center=vec4(circle_center,cantilevered_height,1);vec4 occlusion_projected_center=u_matrix*occlusion_world_center;\n#else\nvec4 occlusion_world_center=world_center;vec4 occlusion_projected_center=projected_center;\n#endif\nfor(int ring=0; ring < NUM_VISIBILITY_RINGS; ring++) {float scale=(float(ring)+1.0)/float(NUM_VISIBILITY_RINGS);for(int i=0; i < NUM_SAMPLES_PER_RING; i++) {vec2 extrusion=vec2(cos(step*float(i)),-sin(step*float(i)))*scale;vec4 frag_pos=project_vertex(extrusion,occlusion_world_center,occlusion_projected_center,radius,stroke_width,view_scale,surface_vectors);visibility+=float(!isOccluded(frag_pos));}}visibility/=float(NUM_VISIBILITY_RINGS)*float(NUM_SAMPLES_PER_RING);\n#else\nvisibility=1.0;\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nvisibility=1.0;\n#endif\nv_visibility=visibility;lowp float antialiasblur=1.0/u_device_pixel_ratio/(radius+stroke_width);v_data=vec3(extrude.x,extrude.y,antialiasblur);\n#ifdef FOG\nv_fog_pos=fog_position(world_center.xyz);\n#endif\n}"),clippingMask:pi("void main() {gl_FragColor=vec4(1.0);}","attribute vec2 a_pos;uniform mat4 u_matrix;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);}"),heatmap:pi("uniform highp float u_intensity;varying vec2 v_extrude;\n#pragma mapbox: define highp float weight\n#define GAUSS_COEF 0.3989422804014327\nvoid main() {\n#pragma mapbox: initialize highp float weight\nfloat d=-0.5*3.0*3.0*dot(v_extrude,v_extrude);float val=weight*u_intensity*GAUSS_COEF*exp(d);gl_FragColor=vec4(val,1.0,1.0,1.0);\n#ifdef FOG\nif (u_is_globe==0) {gl_FragColor.r*=pow(1.0-fog_opacity(v_fog_pos),2.0);}\n#endif\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","uniform mat4 u_matrix;uniform float u_extrude_scale;uniform float u_opacity;uniform float u_intensity;attribute vec2 a_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nattribute vec3 a_pos_3;attribute vec3 a_pos_normal_3;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_tile_id;uniform float u_zoom_transition;uniform vec3 u_up_dir;\n#endif\nvarying vec2 v_extrude;\n#pragma mapbox: define highp float weight\n#pragma mapbox: define mediump float radius\nconst highp float ZERO=1.0/255.0/16.0;\n#define GAUSS_COEF 0.3989422804014327\nvoid main(void) {\n#pragma mapbox: initialize highp float weight\n#pragma mapbox: initialize mediump float radius\nvec2 unscaled_extrude=vec2(mod(a_pos,2.0)*2.0-1.0);float S=sqrt(-2.0*log(ZERO/weight/u_intensity/GAUSS_COEF))/3.0;v_extrude=S*unscaled_extrude;vec2 extrude=v_extrude*radius*u_extrude_scale;vec2 tilePos=floor(a_pos*0.5);\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 pos_normal_3=a_pos_normal_3/16384.0;mat3 surface_vectors=globe_mercator_surface_vectors(pos_normal_3,u_up_dir,u_zoom_transition);vec3 surface_extrusion=extrude.x*surface_vectors[0]+extrude.y*surface_vectors[1];vec3 globe_elevation=elevationVector(tilePos)*elevation(tilePos);vec3 globe_pos=a_pos_3+surface_extrusion+globe_elevation;vec3 mercator_elevation=u_up_dir*u_tile_up_scale*elevation(tilePos);vec3 merc_pos=mercator_tile_position(u_inv_rot_matrix,tilePos,u_tile_id,u_merc_center)+surface_extrusion+mercator_elevation;vec3 pos=mix_globe_mercator(globe_pos,merc_pos,u_zoom_transition);\n#else\nvec3 pos=vec3(tilePos+extrude,elevation(tilePos));\n#endif\ngl_Position=u_matrix*vec4(pos,1);\n#ifdef FOG\nv_fog_pos=fog_position(pos);\n#endif\n}"),heatmapTexture:pi("uniform sampler2D u_image;uniform sampler2D u_color_ramp;uniform float u_opacity;varying vec2 v_pos;void main() {float t=texture2D(u_image,v_pos).r;vec4 color=texture2D(u_color_ramp,vec2(t,0.5));gl_FragColor=color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(0.0);\n#endif\n}","attribute vec2 a_pos;varying vec2 v_pos;void main() {gl_Position=vec4(a_pos,0,1);v_pos=a_pos*0.5+0.5;}"),collisionBox:pi("varying float v_placed;varying float v_notUsed;void main() {vec4 red =vec4(1.0,0.0,0.0,1.0);vec4 blue=vec4(0.0,0.0,1.0,0.5);gl_FragColor =mix(red,blue,step(0.5,v_placed))*0.5;gl_FragColor*=mix(1.0,0.1,step(0.5,v_notUsed));}","attribute vec3 a_pos;attribute vec2 a_anchor_pos;attribute vec2 a_extrude;attribute vec2 a_placed;attribute vec2 a_shift;attribute float a_size_scale;attribute vec2 a_padding;uniform mat4 u_matrix;uniform vec2 u_extrude_scale;uniform float u_camera_to_center_distance;varying float v_placed;varying float v_notUsed;void main() {vec4 projectedPoint=u_matrix*vec4(a_pos+elevationVector(a_anchor_pos)*elevation(a_anchor_pos),1);highp float camera_to_anchor_distance=projectedPoint.w;highp float collision_perspective_ratio=clamp(\n0.5+0.5*(u_camera_to_center_distance/camera_to_anchor_distance),0.0,1.5);gl_Position=projectedPoint;gl_Position.xy+=(a_extrude*a_size_scale+a_shift+a_padding)*u_extrude_scale*gl_Position.w*collision_perspective_ratio;v_placed=a_placed.x;v_notUsed=a_placed.y;}"),collisionCircle:pi("varying float v_radius;varying vec2 v_extrude;varying float v_perspective_ratio;varying float v_collision;void main() {float alpha=0.5*min(v_perspective_ratio,1.0);float stroke_radius=0.9*max(v_perspective_ratio,1.0);float distance_to_center=length(v_extrude);float distance_to_edge=abs(distance_to_center-v_radius);float opacity_t=smoothstep(-stroke_radius,0.0,-distance_to_edge);vec4 color=mix(vec4(0.0,0.0,1.0,0.5),vec4(1.0,0.0,0.0,1.0),v_collision);gl_FragColor=color*alpha*opacity_t;}","attribute vec2 a_pos_2f;attribute float a_radius;attribute vec2 a_flags;uniform mat4 u_matrix;uniform mat4 u_inv_matrix;uniform vec2 u_viewport_size;uniform float u_camera_to_center_distance;varying float v_radius;varying vec2 v_extrude;varying float v_perspective_ratio;varying float v_collision;vec3 toTilePosition(vec2 screenPos) {vec4 rayStart=u_inv_matrix*vec4(screenPos,-1.0,1.0);vec4 rayEnd  =u_inv_matrix*vec4(screenPos, 1.0,1.0);rayStart.xyz/=rayStart.w;rayEnd.xyz  /=rayEnd.w;highp float t=(0.0-rayStart.z)/(rayEnd.z-rayStart.z);return mix(rayStart.xyz,rayEnd.xyz,t);}void main() {vec2 quadCenterPos=a_pos_2f;float radius=a_radius;float collision=a_flags.x;float vertexIdx=a_flags.y;vec2 quadVertexOffset=vec2(\nmix(-1.0,1.0,float(vertexIdx >=2.0)),mix(-1.0,1.0,float(vertexIdx >=1.0 && vertexIdx <=2.0)));vec2 quadVertexExtent=quadVertexOffset*radius;vec3 tilePos=toTilePosition(quadCenterPos);vec4 clipPos=u_matrix*vec4(tilePos,1.0);highp float camera_to_anchor_distance=clipPos.w;highp float collision_perspective_ratio=clamp(\n0.5+0.5*(u_camera_to_center_distance/camera_to_anchor_distance),0.0,4.0);float padding_factor=1.2;v_radius=radius;v_extrude=quadVertexExtent*padding_factor;v_perspective_ratio=collision_perspective_ratio;v_collision=collision;gl_Position=vec4(clipPos.xyz/clipPos.w,1.0)+vec4(quadVertexExtent*padding_factor/u_viewport_size*2.0,0.0,0.0);}"),debug:pi("uniform highp vec4 u_color;uniform sampler2D u_overlay;varying vec2 v_uv;void main() {vec4 overlay_color=texture2D(u_overlay,v_uv);gl_FragColor=mix(u_color,overlay_color,overlay_color.a);}","attribute vec2 a_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nattribute vec3 a_pos_3;\n#endif\nvarying vec2 v_uv;uniform mat4 u_matrix;uniform float u_overlay_scale;void main() {float h=elevation(a_pos);v_uv=a_pos/8192.0;\n#ifdef PROJECTION_GLOBE_VIEW\ngl_Position=u_matrix*vec4(a_pos_3+elevationVector(a_pos)*h,1);\n#else\ngl_Position=u_matrix*vec4(a_pos*u_overlay_scale,h,1);\n#endif\n}"),fill:pi("#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float opacity\nvec4 out_color=color;\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\ngl_FragColor=out_color*opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","attribute vec2 a_pos;uniform mat4 u_matrix;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float opacity\ngl_Position=u_matrix*vec4(a_pos,0,1);\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}"),fillOutline:pi("varying vec2 v_pos;\n#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 outline_color\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_pos-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);vec4 out_color=outline_color;\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\ngl_FragColor=out_color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","attribute vec2 a_pos;uniform mat4 u_matrix;uniform vec2 u_world;varying vec2 v_pos;\n#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 outline_color\n#pragma mapbox: initialize lowp float opacity\ngl_Position=u_matrix*vec4(a_pos,0,1);v_pos=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}"),fillOutlinePattern:pi("uniform vec2 u_texsize;uniform sampler2D u_image;uniform float u_fade;varying vec2 v_pos_a;varying vec2 v_pos_b;varying vec2 v_pos;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);float dist=length(v_pos-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);vec4 out_color=mix(color1,color2,u_fade);\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\ngl_FragColor=out_color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","uniform mat4 u_matrix;uniform vec2 u_world;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform vec3 u_scale;attribute vec2 a_pos;varying vec2 v_pos_a;varying vec2 v_pos_b;varying vec2 v_pos;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;gl_Position=u_matrix*vec4(a_pos,0,1);vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileRatio,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileRatio,a_pos);v_pos=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}"),fillPattern:pi("uniform vec2 u_texsize;uniform float u_fade;uniform sampler2D u_image;varying vec2 v_pos_a;varying vec2 v_pos_b;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);vec4 out_color=mix(color1,color2,u_fade);\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\ngl_FragColor=out_color*opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","uniform mat4 u_matrix;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform vec3 u_scale;attribute vec2 a_pos;varying vec2 v_pos_a;varying vec2 v_pos_b;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileZoomRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;gl_Position=u_matrix*vec4(a_pos,0,1);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileZoomRatio,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileZoomRatio,a_pos);\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}"),fillExtrusion:pi("uniform lowp vec3 u_lightpos;varying vec4 v_color;\n#ifdef RENDER_SHADOWS\nvarying highp vec4 v_pos_light_view_0;varying highp vec4 v_pos_light_view_1;varying float v_depth;varying highp vec3 v_normal;\n#endif\n#ifdef FAUX_AO\nuniform lowp vec2 u_ao;varying vec3 v_ao;\n#endif\nvoid main() {vec4 color=v_color;\n#ifdef FAUX_AO\nfloat intensity=u_ao[0];float h=max(0.0,v_ao.z);float h_floors=h/u_ao[1];float y_shade=1.0-0.9*intensity*min(v_ao.y,1.0);float shade=(1.0-0.08*intensity)*(y_shade+(1.0-y_shade)*(1.0-pow(1.0-min(h_floors/16.0,1.0),16.0)))+0.08*intensity*min(h_floors/160.0,1.0);float concave=v_ao.x*v_ao.x;float x_shade=mix(1.0,mix(0.6,0.75,min(h_floors/30.0,1.0)),intensity)+0.1*intensity*min(h,1.0);shade*=mix(1.0,x_shade*x_shade*x_shade,concave);color.rgb=color.rgb*shade;\n#endif\n#ifdef RENDER_SHADOWS\ncolor.xyz=shadowed_color_normal(color.xyz,normalize(v_normal),v_pos_light_view_0,v_pos_light_view_1,v_depth);\n#endif\n#ifdef FOG\ncolor=fog_dither(fog_apply_premultiplied(color,v_fog_pos));\n#endif\ngl_FragColor=color;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","uniform mat4 u_matrix;uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp float u_lightintensity;uniform float u_vertical_gradient;uniform lowp float u_opacity;uniform float u_edge_radius;attribute vec4 a_pos_normal_ed;attribute vec2 a_centroid_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nattribute vec3 a_pos_3;attribute vec3 a_pos_normal_3;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_tile_id;uniform float u_zoom_transition;uniform vec3 u_up_dir;uniform float u_height_lift;\n#endif\nvarying vec4 v_color;\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;varying highp vec4 v_pos_light_view_0;varying highp vec4 v_pos_light_view_1;varying highp vec3 v_normal;varying float v_depth;\n#endif\n#ifdef FAUX_AO\nuniform lowp vec2 u_ao;varying vec3 v_ao;\n#endif\n#pragma mapbox: define highp float base\n#pragma mapbox: define highp float height\n#pragma mapbox: define highp vec4 color\nvoid main() {\n#pragma mapbox: initialize highp float base\n#pragma mapbox: initialize highp float height\n#pragma mapbox: initialize highp vec4 color\nvec4 pos_nx=floor(a_pos_normal_ed*0.5);vec4 top_up_ny_start=a_pos_normal_ed-2.0*pos_nx;vec3 top_up_ny=top_up_ny_start.xyz;float x_normal=pos_nx.z/8192.0;vec3 normal=top_up_ny.y==1.0 ? vec3(0.0,0.0,1.0) : normalize(vec3(x_normal,(2.0*top_up_ny.z-1.0)*(1.0-abs(x_normal)),0.0));base=max(0.0,base);height=max(0.0,top_up_ny.y==0.0 && top_up_ny.x==1.0 ? height-u_edge_radius : height);float t=top_up_ny.x;vec2 centroid_pos=vec2(0.0);\n#if defined(HAS_CENTROID) || defined(TERRAIN)\ncentroid_pos=a_centroid_pos;\n#endif\nfloat ele=0.0;float h=0.0;\n#ifdef TERRAIN\nbool flat_roof=centroid_pos.x !=0.0 && t > 0.0;ele=elevation(pos_nx.xy);float c_ele=flat_roof ? centroid_pos.y==0.0 ? elevationFromUint16(centroid_pos.x) : flatElevation(centroid_pos) : ele;h=flat_roof ? max(c_ele+height,ele+base+2.0) : ele+(t > 0.0 ? height : base==0.0 ?-5.0 : base);vec3 pos=vec3(pos_nx.xy,h);\n#else\nh=t > 0.0 ? height : base;vec3 pos=vec3(pos_nx.xy,h);\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nfloat lift=float((t+base) > 0.0)*u_height_lift;h+=lift;vec3 globe_normal=normalize(mix(a_pos_normal_3/16384.0,u_up_dir,u_zoom_transition));vec3 globe_pos=a_pos_3+globe_normal*(u_tile_up_scale*h);vec3 merc_pos=mercator_tile_position(u_inv_rot_matrix,pos.xy,u_tile_id,u_merc_center)+u_up_dir*u_tile_up_scale*pos.z;pos=mix_globe_mercator(globe_pos,merc_pos,u_zoom_transition);\n#endif\nfloat hidden=float(centroid_pos.x==0.0 && centroid_pos.y==1.0);gl_Position=mix(u_matrix*vec4(pos,1),AWAY,hidden);\n#ifdef RENDER_SHADOWS\nv_pos_light_view_0=u_light_matrix_0*vec4(pos,1);v_pos_light_view_1=u_light_matrix_1*vec4(pos,1);v_normal=normal;v_depth=gl_Position.w;\n#endif\nfloat colorvalue=color.r*0.2126+color.g*0.7152+color.b*0.0722;v_color=vec4(0.0,0.0,0.0,1.0);vec4 ambientlight=vec4(0.03,0.03,0.03,1.0);color+=ambientlight;float directional=clamp(dot(normal,u_lightpos),0.0,1.0);directional=mix((1.0-u_lightintensity),max((1.0-colorvalue+u_lightintensity),1.0),directional);if (normal.y !=0.0) {directional*=(\n(1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),mix(0.7,0.98,1.0-u_lightintensity),1.0)));}\n#ifdef FAUX_AO\nfloat concave=pos_nx.w-floor(pos_nx.w*0.5)*2.0;float start=top_up_ny_start.w;float y_ground=1.0-clamp(t+base,0.0,1.0);float top_height=height;\n#ifdef TERRAIN\ntop_height=mix(max(c_ele+height,ele+base+2.0),ele+height,float(centroid_pos.x==0.0))-ele;y_ground+=y_ground*5.0/max(3.0,top_height);\n#endif\nv_ao=vec3(mix(concave,-concave,start),y_ground,h-ele);directional*=(1.0+0.05*(1.0-top_up_ny.y)*u_ao[0]);\n#ifdef PROJECTION_GLOBE_VIEW\ntop_height+=u_height_lift;\n#endif\ngl_Position.z-=(0.0000006*(min(top_height,500.)+2.0*min(base,500.0)+60.0*concave+3.0*start))*gl_Position.w;\n#endif\nv_color.rgb+=clamp(color.rgb*directional*u_lightcolor,mix(vec3(0.0),vec3(0.3),1.0-u_lightcolor),vec3(1.0));v_color*=u_opacity;\n#ifdef FOG\nv_fog_pos=fog_position(pos);\n#endif\n}"),fillExtrusionPattern:pi("uniform vec2 u_texsize;uniform float u_fade;uniform sampler2D u_image;\n#ifdef FAUX_AO\nuniform lowp vec2 u_ao;varying vec3 v_ao;\n#endif\nvarying vec2 v_pos_a;varying vec2 v_pos_b;varying vec4 v_lighting;\n#pragma mapbox: define lowp float base\n#pragma mapbox: define lowp float height\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float base\n#pragma mapbox: initialize lowp float height\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);vec4 out_color=mix(color1,color2,u_fade);out_color=out_color*v_lighting;\n#ifdef FAUX_AO\nfloat intensity=u_ao[0];float h=max(0.0,v_ao.z);float h_floors=h/u_ao[1];float y_shade=1.0-0.9*intensity*min(v_ao.y,1.0);float shade=(1.0-0.08*intensity)*(y_shade+(1.0-y_shade)*(1.0-pow(1.0-min(h_floors/16.0,1.0),16.0)))+0.08*intensity*min(h_floors/160.0,1.0);float concave=v_ao.x*v_ao.x;float x_shade=mix(1.0,mix(0.6,0.75,min(h_floors/30.0,1.0)),intensity)+0.1*intensity*min(h,1.0);shade*=mix(1.0,x_shade*x_shade*x_shade,concave);out_color.rgb=out_color.rgb*shade;\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\ngl_FragColor=out_color;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","uniform mat4 u_matrix;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_height_factor;uniform vec3 u_scale;uniform float u_vertical_gradient;uniform lowp float u_opacity;uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp float u_lightintensity;attribute vec4 a_pos_normal_ed;attribute vec2 a_centroid_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nattribute vec3 a_pos_3;attribute vec3 a_pos_normal_3;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_tile_id;uniform float u_zoom_transition;uniform vec3 u_up_dir;uniform float u_height_lift;\n#endif\nvarying vec2 v_pos_a;varying vec2 v_pos_b;varying vec4 v_lighting;\n#ifdef FAUX_AO\nuniform lowp vec2 u_ao;varying vec3 v_ao;\n#endif\n#pragma mapbox: define lowp float base\n#pragma mapbox: define lowp float height\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float base\n#pragma mapbox: initialize lowp float height\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec4 pos_nx=floor(a_pos_normal_ed*0.5);mediump vec4 top_up_ny_start=a_pos_normal_ed-2.0*pos_nx;mediump vec3 top_up_ny=top_up_ny_start.xyz;float x_normal=pos_nx.z/8192.0;vec3 normal=top_up_ny.y==1.0 ? vec3(0.0,0.0,1.0) : normalize(vec3(x_normal,(2.0*top_up_ny.z-1.0)*(1.0-abs(x_normal)),0.0));float edgedistance=a_pos_normal_ed.w;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;base=max(0.0,base);height=max(0.0,height);float t=top_up_ny.x;float z=t > 0.0 ? height : base;vec2 centroid_pos=vec2(0.0);\n#if defined(HAS_CENTROID) || defined(TERRAIN)\ncentroid_pos=a_centroid_pos;\n#endif\nfloat ele=0.0;float h=z;\n#ifdef TERRAIN\nbool flat_roof=centroid_pos.x !=0.0 && t > 0.0;ele=elevation(pos_nx.xy);float c_ele=flat_roof ? centroid_pos.y==0.0 ? elevationFromUint16(centroid_pos.x) : flatElevation(centroid_pos) : ele;h=flat_roof ? max(c_ele+height,ele+base+2.0) : ele+(t > 0.0 ? height : base==0.0 ?-5.0 : base);vec3 p=vec3(pos_nx.xy,h);\n#else\nvec3 p=vec3(pos_nx.xy,z);\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nfloat lift=float((t+base) > 0.0)*u_height_lift;h+=lift;vec3 globe_normal=normalize(mix(a_pos_normal_3/16384.0,u_up_dir,u_zoom_transition));vec3 globe_pos=a_pos_3+globe_normal*(u_tile_up_scale*(p.z+lift));vec3 merc_pos=mercator_tile_position(u_inv_rot_matrix,p.xy,u_tile_id,u_merc_center)+u_up_dir*u_tile_up_scale*p.z;p=mix_globe_mercator(globe_pos,merc_pos,u_zoom_transition);\n#endif\nfloat hidden=float(centroid_pos.x==0.0 && centroid_pos.y==1.0);gl_Position=mix(u_matrix*vec4(p,1),AWAY,hidden);vec2 pos=normal.z==1.0\n? pos_nx.xy\n: vec2(edgedistance,z*u_height_factor);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileRatio,pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileRatio,pos);v_lighting=vec4(0.0,0.0,0.0,1.0);float directional=clamp(dot(normal,u_lightpos),0.0,1.0);directional=mix((1.0-u_lightintensity),max((0.5+u_lightintensity),1.0),directional);if (normal.y !=0.0) {directional*=(\n(1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),mix(0.7,0.98,1.0-u_lightintensity),1.0)));}\n#ifdef FAUX_AO\nfloat concave=pos_nx.w-floor(pos_nx.w*0.5)*2.0;float start=top_up_ny_start.w;float y_ground=1.0-clamp(t+base,0.0,1.0);float top_height=height;\n#ifdef TERRAIN\ntop_height=mix(max(c_ele+height,ele+base+2.0),ele+height,float(centroid_pos.x==0.0))-ele;y_ground+=y_ground*5.0/max(3.0,top_height);\n#endif\nv_ao=vec3(mix(concave,-concave,start),y_ground,h-ele);directional*=(1.0+0.05*(1.0-top_up_ny.y)*u_ao[0]);\n#ifdef PROJECTION_GLOBE_VIEW\ntop_height+=u_height_lift;\n#endif\ngl_Position.z-=(0.0000006*(min(top_height,500.)+2.0*min(base,500.0)+60.0*concave+3.0*start))*gl_Position.w;\n#endif\nv_lighting.rgb+=clamp(directional*u_lightcolor,mix(vec3(0.0),vec3(0.3),1.0-u_lightcolor),vec3(1.0));v_lighting*=u_opacity;\n#ifdef FOG\nv_fog_pos=fog_position(p);\n#endif\n}"),hillshadePrepare:pi("#ifdef GL_ES\nprecision highp float;\n#endif\nuniform sampler2D u_image;varying vec2 v_pos;uniform vec2 u_dimension;uniform float u_zoom;uniform vec4 u_unpack;float getElevation(vec2 coord) {\n#ifdef TERRAIN_DEM_FLOAT_FORMAT\nreturn texture2D(u_image,coord).a/4.0;\n#else\nvec4 data=texture2D(u_image,coord)*255.0;data.a=-1.0;return dot(data,u_unpack)/4.0;\n#endif\n}void main() {vec2 epsilon=1.0/u_dimension;float a=getElevation(v_pos+vec2(-epsilon.x,-epsilon.y));float b=getElevation(v_pos+vec2(0,-epsilon.y));float c=getElevation(v_pos+vec2(epsilon.x,-epsilon.y));float d=getElevation(v_pos+vec2(-epsilon.x,0));float e=getElevation(v_pos);float f=getElevation(v_pos+vec2(epsilon.x,0));float g=getElevation(v_pos+vec2(-epsilon.x,epsilon.y));float h=getElevation(v_pos+vec2(0,epsilon.y));float i=getElevation(v_pos+vec2(epsilon.x,epsilon.y));float exaggerationFactor=u_zoom < 2.0 ? 0.4 : u_zoom < 4.5 ? 0.35 : 0.3;float exaggeration=u_zoom < 15.0 ? (u_zoom-15.0)*exaggerationFactor : 0.0;vec2 deriv=vec2(\n(c+f+f+i)-(a+d+d+g),(g+h+h+i)-(a+b+b+c)\n)/pow(2.0,exaggeration+(19.2562-u_zoom));gl_FragColor=clamp(vec4(\nderiv.x/2.0+0.5,deriv.y/2.0+0.5,1.0,1.0),0.0,1.0);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","uniform mat4 u_matrix;uniform vec2 u_dimension;attribute vec2 a_pos;attribute vec2 a_texture_pos;varying vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);highp vec2 epsilon=1.0/u_dimension;float scale=(u_dimension.x-2.0)/u_dimension.x;v_pos=(a_texture_pos/8192.0)*scale+epsilon;}"),hillshade:pi("uniform sampler2D u_image;varying vec2 v_pos;uniform vec2 u_latrange;uniform vec2 u_light;uniform vec4 u_shadow;uniform vec4 u_highlight;uniform vec4 u_accent;void main() {vec4 pixel=texture2D(u_image,v_pos);vec2 deriv=((pixel.rg*2.0)-1.0);float scaleFactor=cos(radians((u_latrange[0]-u_latrange[1])*(1.0-v_pos.y)+u_latrange[1]));float slope=atan(1.25*length(deriv)/scaleFactor);float aspect=deriv.x !=0.0 ? atan(deriv.y,-deriv.x) : PI/2.0*(deriv.y > 0.0 ? 1.0 :-1.0);float intensity=u_light.x;float azimuth=u_light.y+PI;float base=1.875-intensity*1.75;float maxValue=0.5*PI;float scaledSlope=intensity !=0.5 ? ((pow(base,slope)-1.0)/(pow(base,maxValue)-1.0))*maxValue : slope;float accent=cos(scaledSlope);vec4 accent_color=(1.0-accent)*u_accent*clamp(intensity*2.0,0.0,1.0);float shade=abs(mod((aspect+azimuth)/PI+0.5,2.0)-1.0);vec4 shade_color=mix(u_shadow,u_highlight,shade)*sin(scaledSlope)*clamp(intensity*2.0,0.0,1.0);gl_FragColor=accent_color*(1.0-shade_color.a)+shade_color;\n#ifdef FOG\ngl_FragColor=fog_dither(fog_apply_premultiplied(gl_FragColor,v_fog_pos));\n#endif\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","uniform mat4 u_matrix;attribute vec2 a_pos;attribute vec2 a_texture_pos;varying vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos=a_texture_pos/8192.0;\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}"),line:pi("uniform lowp float u_device_pixel_ratio;uniform float u_alpha_discard_threshold;uniform highp vec2 u_trim_offset;varying vec2 v_width2;varying vec2 v_normal;varying float v_gamma_scale;varying highp vec4 v_uv;\n#ifdef RENDER_LINE_DASH\nuniform sampler2D u_dash_image;uniform float u_mix;uniform vec3 u_scale;varying vec2 v_tex_a;varying vec2 v_tex_b;\n#endif\n#ifdef RENDER_LINE_GRADIENT\nuniform sampler2D u_gradient_image;\n#endif\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float floorwidth\n#pragma mapbox: define lowp vec4 dash_from\n#pragma mapbox: define lowp vec4 dash_to\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float floorwidth\n#pragma mapbox: initialize lowp vec4 dash_from\n#pragma mapbox: initialize lowp vec4 dash_to\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);\n#ifdef RENDER_LINE_DASH\nfloat sdfdist_a=texture2D(u_dash_image,v_tex_a).a;float sdfdist_b=texture2D(u_dash_image,v_tex_b).a;float sdfdist=mix(sdfdist_a,sdfdist_b,u_mix);float sdfwidth=min(dash_from.z*u_scale.y,dash_to.z*u_scale.z);float sdfgamma=1.0/(2.0*u_device_pixel_ratio)/sdfwidth;alpha*=smoothstep(0.5-sdfgamma/floorwidth,0.5+sdfgamma/floorwidth,sdfdist);\n#endif\n#ifdef RENDER_LINE_GRADIENT\nhighp vec4 out_color=texture2D(u_gradient_image,v_uv.xy);\n#else\nvec4 out_color=color;\n#endif\n#ifdef RENDER_LINE_TRIM_OFFSET\nhighp float start=v_uv[2];highp float end=v_uv[3];highp float trim_start=u_trim_offset[0];highp float trim_end=u_trim_offset[1];highp float line_progress=(start+(v_uv.x)*(end-start));if (trim_end > trim_start) {if (line_progress <=trim_end && line_progress >=trim_start) {out_color=vec4(0,0,0,0);}}\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\n#ifdef RENDER_LINE_ALPHA_DISCARD\nif (alpha < u_alpha_discard_threshold) {discard;}\n#endif\ngl_FragColor=out_color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","\n#define EXTRUDE_SCALE 0.015873016\nattribute vec2 a_pos_normal;attribute vec4 a_data;\n#if defined(RENDER_LINE_GRADIENT) || defined(RENDER_LINE_TRIM_OFFSET)\nattribute highp vec4 a_packed;\n#endif\n#ifdef RENDER_LINE_DASH\nattribute float a_linesofar;\n#endif\nuniform mat4 u_matrix;uniform mat2 u_pixels_to_tile_units;uniform vec2 u_units_to_pixels;uniform lowp float u_device_pixel_ratio;varying vec2 v_normal;varying vec2 v_width2;varying float v_gamma_scale;varying highp vec4 v_uv;\n#ifdef RENDER_LINE_DASH\nuniform vec2 u_texsize;uniform mediump vec3 u_scale;varying vec2 v_tex_a;varying vec2 v_tex_b;\n#endif\n#ifdef RENDER_LINE_GRADIENT\nuniform float u_image_height;\n#endif\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float floorwidth\n#pragma mapbox: define lowp vec4 dash_from\n#pragma mapbox: define lowp vec4 dash_to\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float floorwidth\n#pragma mapbox: initialize lowp vec4 dash_from\n#pragma mapbox: initialize lowp vec4 dash_to\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*EXTRUDE_SCALE;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*EXTRUDE_SCALE*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist*u_pixels_to_tile_units,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2*u_pixels_to_tile_units,0.0,1.0)+projected_extrude;\n#ifndef RENDER_TO_TEXTURE\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;\n#else\nv_gamma_scale=1.0;\n#endif\n#if defined(RENDER_LINE_GRADIENT) || defined(RENDER_LINE_TRIM_OFFSET)\nfloat a_uv_x=a_packed[0];float a_split_index=a_packed[1];highp float a_clip_start=a_packed[2];highp float a_clip_end=a_packed[3];\n#ifdef RENDER_LINE_GRADIENT\nhighp float texel_height=1.0/u_image_height;highp float half_texel_height=0.5*texel_height;v_uv=vec4(a_uv_x,a_split_index*texel_height-half_texel_height,a_clip_start,a_clip_end);\n#else\nv_uv=vec4(a_uv_x,0.0,a_clip_start,a_clip_end);\n#endif\n#endif\n#ifdef RENDER_LINE_DASH\nfloat tileZoomRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;float scaleA=dash_from.z==0.0 ? 0.0 : tileZoomRatio/(dash_from.z*fromScale);float scaleB=dash_to.z==0.0 ? 0.0 : tileZoomRatio/(dash_to.z*toScale);float heightA=dash_from.y;float heightB=dash_to.y;v_tex_a=vec2(a_linesofar*scaleA/floorwidth,(-normal.y*heightA+dash_from.x+0.5)/u_texsize.y);v_tex_b=vec2(a_linesofar*scaleB/floorwidth,(-normal.y*heightB+dash_to.x+0.5)/u_texsize.y);\n#endif\nv_width2=vec2(outset,inset);\n#ifdef FOG\nv_fog_pos=fog_position(pos);\n#endif\n}"),linePattern:pi("uniform lowp float u_device_pixel_ratio;uniform vec2 u_texsize;uniform float u_fade;uniform mediump vec3 u_scale;uniform sampler2D u_image;varying vec2 v_normal;varying vec2 v_width2;varying float v_linesofar;varying float v_gamma_scale;varying float v_width;\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileZoomRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;vec2 pattern_size_a=vec2(display_size_a.x*fromScale/tileZoomRatio,display_size_a.y);vec2 pattern_size_b=vec2(display_size_b.x*toScale/tileZoomRatio,display_size_b.y);float aspect_a=display_size_a.y/v_width;float aspect_b=display_size_b.y/v_width;float dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);float x_a=mod(v_linesofar/pattern_size_a.x*aspect_a,1.0);float x_b=mod(v_linesofar/pattern_size_b.x*aspect_b,1.0);float y=0.5*v_normal.y+0.5;vec2 texel_size=1.0/u_texsize;vec2 pos_a=mix(pattern_tl_a*texel_size-texel_size,pattern_br_a*texel_size+texel_size,vec2(x_a,y));vec2 pos_b=mix(pattern_tl_b*texel_size-texel_size,pattern_br_b*texel_size+texel_size,vec2(x_b,y));vec4 color=mix(texture2D(u_image,pos_a),texture2D(u_image,pos_b),u_fade);\n#ifdef FOG\ncolor=fog_dither(fog_apply_premultiplied(color,v_fog_pos));\n#endif\ngl_FragColor=color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","\n#define scale 0.015873016\nattribute vec2 a_pos_normal;attribute vec4 a_data;attribute float a_linesofar;uniform mat4 u_matrix;uniform vec2 u_units_to_pixels;uniform mat2 u_pixels_to_tile_units;uniform lowp float u_device_pixel_ratio;varying vec2 v_normal;varying vec2 v_width2;varying float v_linesofar;varying float v_gamma_scale;varying float v_width;\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist*u_pixels_to_tile_units,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2*u_pixels_to_tile_units,0.0,1.0)+projected_extrude;\n#ifndef RENDER_TO_TEXTURE\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;\n#else\nv_gamma_scale=1.0;\n#endif\nv_linesofar=a_linesofar;v_width2=vec2(outset,inset);v_width=floorwidth;\n#ifdef FOG\nv_fog_pos=fog_position(pos);\n#endif\n}"),raster:pi("uniform float u_fade_t;uniform float u_opacity;uniform sampler2D u_image0;uniform sampler2D u_image1;varying vec2 v_pos0;varying vec2 v_pos1;uniform float u_brightness_low;uniform float u_brightness_high;uniform float u_saturation_factor;uniform float u_contrast_factor;uniform vec3 u_spin_weights;void main() {vec4 color0=texture2D(u_image0,v_pos0);vec4 color1=texture2D(u_image1,v_pos1);if (color0.a > 0.0) {color0.rgb=color0.rgb/color0.a;}if (color1.a > 0.0) {color1.rgb=color1.rgb/color1.a;}vec4 color=mix(color0,color1,u_fade_t);color.a*=u_opacity;vec3 rgb=color.rgb;rgb=vec3(\ndot(rgb,u_spin_weights.xyz),dot(rgb,u_spin_weights.zxy),dot(rgb,u_spin_weights.yzx));float average=(color.r+color.g+color.b)/3.0;rgb+=(average-rgb)*u_saturation_factor;rgb=(rgb-0.5)*u_contrast_factor+0.5;vec3 u_high_vec=vec3(u_brightness_low,u_brightness_low,u_brightness_low);vec3 u_low_vec=vec3(u_brightness_high,u_brightness_high,u_brightness_high);vec3 out_color=mix(u_high_vec,u_low_vec,rgb);\n#ifdef FOG\nout_color=fog_dither(fog_apply(out_color,v_fog_pos));\n#endif\ngl_FragColor=vec4(out_color*color.a,color.a);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","uniform mat4 u_matrix;uniform vec2 u_tl_parent;uniform float u_scale_parent;uniform vec2 u_perspective_transform;attribute vec2 a_pos;attribute vec2 a_texture_pos;varying vec2 v_pos0;varying vec2 v_pos1;void main() {float w=1.0+dot(a_texture_pos,u_perspective_transform);gl_Position=u_matrix*vec4(a_pos*w,0,w);v_pos0=a_texture_pos/8192.0;v_pos1=(v_pos0*u_scale_parent)+u_tl_parent;\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}"),symbolIcon:pi("uniform sampler2D u_texture;varying vec2 v_tex;varying float v_fade_opacity;\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\nlowp float alpha=opacity*v_fade_opacity;gl_FragColor=texture2D(u_texture,v_tex)*alpha;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","attribute vec4 a_pos_offset;attribute vec4 a_tex_size;attribute vec4 a_pixeloffset;attribute vec4 a_projected_pos;attribute float a_fade_opacity;\n#ifdef PROJECTION_GLOBE_VIEW\nattribute vec3 a_globe_anchor;attribute vec3 a_globe_normal;\n#endif\nuniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform highp float u_camera_to_center_distance;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform float u_fade_change;uniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform vec2 u_texsize;uniform vec3 u_up_vector;\n#ifdef PROJECTION_GLOBE_VIEW\nuniform vec3 u_tile_id;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_camera_forward;uniform float u_zoom_transition;uniform vec3 u_ecef_origin;uniform mat4 u_tile_matrix;\n#endif\nvarying vec2 v_tex;varying float v_fade_opacity;\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_tex_size.xy;vec2 a_size=a_tex_size.zw;float a_size_min=floor(a_size[0]*0.5);vec2 a_pxoffset=a_pixeloffset.xy;vec2 a_min_font_scale=a_pixeloffset.zw/256.0;highp float segment_angle=-a_projected_pos[3];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec2 tile_anchor=a_pos;vec3 h=elevationVector(tile_anchor)*elevation(tile_anchor);\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 mercator_pos=mercator_tile_position(u_inv_rot_matrix,tile_anchor,u_tile_id,u_merc_center);vec3 world_pos=mix_globe_mercator(a_globe_anchor+h,mercator_pos,u_zoom_transition);vec4 ecef_point=u_tile_matrix*vec4(world_pos,1.0);vec3 origin_to_point=ecef_point.xyz-u_ecef_origin;float globe_occlusion_fade=dot(origin_to_point,u_camera_forward) >=0.0 ? 0.0 : 1.0;\n#else\nvec3 world_pos=vec3(tile_anchor,0)+h;float globe_occlusion_fade=1.0;\n#endif\nvec4 projected_point=u_matrix*vec4(world_pos,1);highp float camera_to_anchor_distance=projected_point.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(\n0.5+0.5*distance_ratio,0.0,1.5);size*=perspective_ratio;float font_scale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 displacement=vec3(a_globe_normal.z,0,-a_globe_normal.x);vec4 offsetProjected_point=u_matrix*vec4(a_globe_anchor+displacement,1);\n#else\nvec4 offsetProjected_point=u_matrix*vec4(tile_anchor+vec2(1,0),0,1);\n#endif\nvec2 a=projected_point.xy/projected_point.w;vec2 b=offsetProjected_point.xy/offsetProjected_point.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 proj_pos=mix_globe_mercator(a_projected_pos.xyz+h,mercator_pos,u_zoom_transition);vec4 projected_pos=u_label_plane_matrix*vec4(proj_pos,1.0);\n#else\nvec4 projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy,h.z,1.0);\n#endif\nhighp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);float z=0.0;vec2 offset=rotation_matrix*(a_offset/32.0*max(a_min_font_scale,font_scale)+a_pxoffset/16.0);\n#ifdef PITCH_WITH_MAP_TERRAIN\nvec4 tile_pos=u_label_plane_matrix_inv*vec4(a_projected_pos.xy+offset,0.0,1.0);z=elevation(tile_pos.xy);\n#endif\nfloat occlusion_fade=occlusionFade(projected_point)*globe_occlusion_fade;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 xAxis=u_pitch_with_map ? normalize(cross(a_globe_normal,u_up_vector)) : vec3(1,0,0);vec3 yAxis=u_pitch_with_map ? normalize(cross(a_globe_normal,xAxis)) : vec3(0,1,0);gl_Position=mix(u_coord_matrix*vec4(projected_pos.xyz/projected_pos.w+xAxis*offset.x+yAxis*offset.y,1.0),AWAY,float(projected_point.w <=0.0 || occlusion_fade==0.0));\n#else\ngl_Position=mix(u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+offset,z,1.0),AWAY,float(projected_point.w <=0.0 || occlusion_fade==0.0));\n#endif\nfloat projection_transition_fade=1.0;\n#if defined(PROJECTED_POS_ON_VIEWPORT) && defined(PROJECTION_GLOBE_VIEW)\nprojection_transition_fade=1.0-step(EPSILON,u_zoom_transition);\n#endif\nv_tex=a_tex/u_texsize;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;v_fade_opacity=max(0.0,min(occlusion_fade,fade_opacity[0]+fade_change))*projection_transition_fade;}"),symbolSDF:pi("#define SDF_PX 8.0\nuniform bool u_is_halo;uniform sampler2D u_texture;uniform highp float u_gamma_scale;uniform lowp float u_device_pixel_ratio;uniform bool u_is_text;varying vec2 v_data0;varying vec3 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nfloat EDGE_GAMMA=0.105/u_device_pixel_ratio;vec2 tex=v_data0.xy;float gamma_scale=v_data1.x;float size=v_data1.y;float fade_opacity=v_data1[2];float fontScale=u_is_text ? size/24.0 : size;lowp vec4 color=fill_color;highp float gamma=EDGE_GAMMA/(fontScale*u_gamma_scale);lowp float buff=(256.0-64.0)/256.0;if (u_is_halo) {color=halo_color;gamma=(halo_blur*1.19/SDF_PX+EDGE_GAMMA)/(fontScale*u_gamma_scale);buff=(6.0-halo_width/fontScale)/SDF_PX;}lowp float dist=texture2D(u_texture,tex).a;highp float gamma_scaled=gamma*gamma_scale;highp float alpha=smoothstep(buff-gamma_scaled,buff+gamma_scaled,dist);gl_FragColor=color*(alpha*opacity*fade_opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","attribute vec4 a_pos_offset;attribute vec4 a_tex_size;attribute vec4 a_pixeloffset;attribute vec4 a_projected_pos;attribute float a_fade_opacity;\n#ifdef PROJECTION_GLOBE_VIEW\nattribute vec3 a_globe_anchor;attribute vec3 a_globe_normal;\n#endif\nuniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform highp float u_camera_to_center_distance;uniform float u_fade_change;uniform vec2 u_texsize;uniform vec3 u_up_vector;\n#ifdef PROJECTION_GLOBE_VIEW\nuniform vec3 u_tile_id;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_camera_forward;uniform float u_zoom_transition;uniform vec3 u_ecef_origin;uniform mat4 u_tile_matrix;\n#endif\nvarying vec2 v_data0;varying vec3 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_tex_size.xy;vec2 a_size=a_tex_size.zw;float a_size_min=floor(a_size[0]*0.5);vec2 a_pxoffset=a_pixeloffset.xy;highp float segment_angle=-a_projected_pos[3];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec2 tile_anchor=a_pos;vec3 h=elevationVector(tile_anchor)*elevation(tile_anchor);\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 mercator_pos=mercator_tile_position(u_inv_rot_matrix,tile_anchor,u_tile_id,u_merc_center);vec3 world_pos=mix_globe_mercator(a_globe_anchor+h,mercator_pos,u_zoom_transition);vec4 ecef_point=u_tile_matrix*vec4(world_pos,1.0);vec3 origin_to_point=ecef_point.xyz-u_ecef_origin;float globe_occlusion_fade=dot(origin_to_point,u_camera_forward) >=0.0 ? 0.0 : 1.0;\n#else\nvec3 world_pos=vec3(tile_anchor,0)+h;float globe_occlusion_fade=1.0;\n#endif\nvec4 projected_point=u_matrix*vec4(world_pos,1);highp float camera_to_anchor_distance=projected_point.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(\n0.5+0.5*distance_ratio,0.0,1.5);size*=perspective_ratio;float fontScale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 displacement=vec3(a_globe_normal.z,0,-a_globe_normal.x);vec4 offsetprojected_point=u_matrix*vec4(a_globe_anchor+displacement,1);\n#else\nvec4 offsetprojected_point=u_matrix*vec4(tile_anchor+vec2(1,0),0,1);\n#endif\nvec2 a=projected_point.xy/projected_point.w;vec2 b=offsetprojected_point.xy/offsetprojected_point.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 proj_pos=mix_globe_mercator(a_projected_pos.xyz+h,mercator_pos,u_zoom_transition);vec4 projected_pos=u_label_plane_matrix*vec4(proj_pos,1.0);\n#else\nvec4 projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy,h.z,1.0);\n#endif\nhighp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);float z=0.0;vec2 offset=rotation_matrix*(a_offset/32.0*fontScale+a_pxoffset);\n#ifdef PITCH_WITH_MAP_TERRAIN\nvec4 tile_pos=u_label_plane_matrix_inv*vec4(a_projected_pos.xy+offset,0.0,1.0);z=elevation(tile_pos.xy);\n#endif\nfloat occlusion_fade=occlusionFade(projected_point)*globe_occlusion_fade;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 xAxis=u_pitch_with_map ? normalize(cross(a_globe_normal,u_up_vector)) : vec3(1,0,0);vec3 yAxis=u_pitch_with_map ? normalize(cross(a_globe_normal,xAxis)) : vec3(0,1,0);gl_Position=mix(u_coord_matrix*vec4(projected_pos.xyz/projected_pos.w+xAxis*offset.x+yAxis*offset.y,1.0),AWAY,float(projected_point.w <=0.0 || occlusion_fade==0.0));\n#else\ngl_Position=mix(u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+offset,z,1.0),AWAY,float(projected_point.w <=0.0 || occlusion_fade==0.0));\n#endif\nfloat gamma_scale=gl_Position.w;float projection_transition_fade=1.0;\n#if defined(PROJECTED_POS_ON_VIEWPORT) && defined(PROJECTION_GLOBE_VIEW)\nprojection_transition_fade=1.0-step(EPSILON,u_zoom_transition);\n#endif\nvec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float interpolated_fade_opacity=max(0.0,min(occlusion_fade,fade_opacity[0]+fade_change));v_data0=a_tex/u_texsize;v_data1=vec3(gamma_scale,size,interpolated_fade_opacity*projection_transition_fade);}"),symbolTextAndIcon:pi("#define SDF_PX 8.0\n#define SDF 1.0\n#define ICON 0.0\nuniform bool u_is_halo;uniform sampler2D u_texture;uniform sampler2D u_texture_icon;uniform highp float u_gamma_scale;uniform lowp float u_device_pixel_ratio;varying vec4 v_data0;varying vec4 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nfloat fade_opacity=v_data1[2];if (v_data1.w==ICON) {vec2 tex_icon=v_data0.zw;lowp float alpha=opacity*fade_opacity;gl_FragColor=texture2D(u_texture_icon,tex_icon)*alpha;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\nreturn;}vec2 tex=v_data0.xy;float EDGE_GAMMA=0.105/u_device_pixel_ratio;float gamma_scale=v_data1.x;float size=v_data1.y;float fontScale=size/24.0;lowp vec4 color=fill_color;highp float gamma=EDGE_GAMMA/(fontScale*u_gamma_scale);lowp float buff=(256.0-64.0)/256.0;if (u_is_halo) {color=halo_color;gamma=(halo_blur*1.19/SDF_PX+EDGE_GAMMA)/(fontScale*u_gamma_scale);buff=(6.0-halo_width/fontScale)/SDF_PX;}lowp float dist=texture2D(u_texture,tex).a;highp float gamma_scaled=gamma*gamma_scale;highp float alpha=smoothstep(buff-gamma_scaled,buff+gamma_scaled,dist);gl_FragColor=color*(alpha*opacity*fade_opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","attribute vec4 a_pos_offset;attribute vec4 a_tex_size;attribute vec4 a_projected_pos;attribute float a_fade_opacity;\n#ifdef PROJECTION_GLOBE_VIEW\nattribute vec3 a_globe_anchor;attribute vec3 a_globe_normal;\n#endif\nuniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform highp float u_camera_to_center_distance;uniform float u_fade_change;uniform vec2 u_texsize;uniform vec3 u_up_vector;uniform vec2 u_texsize_icon;\n#ifdef PROJECTION_GLOBE_VIEW\nuniform vec3 u_tile_id;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_camera_forward;uniform float u_zoom_transition;uniform vec3 u_ecef_origin;uniform mat4 u_tile_matrix;\n#endif\nvarying vec4 v_data0;varying vec4 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_tex_size.xy;vec2 a_size=a_tex_size.zw;float a_size_min=floor(a_size[0]*0.5);float is_sdf=a_size[0]-2.0*a_size_min;highp float segment_angle=-a_projected_pos[3];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec2 tile_anchor=a_pos;vec3 h=elevationVector(tile_anchor)*elevation(tile_anchor);\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 mercator_pos=mercator_tile_position(u_inv_rot_matrix,tile_anchor,u_tile_id,u_merc_center);vec3 world_pos=mix_globe_mercator(a_globe_anchor+h,mercator_pos,u_zoom_transition);vec4 ecef_point=u_tile_matrix*vec4(world_pos,1.0);vec3 origin_to_point=ecef_point.xyz-u_ecef_origin;float globe_occlusion_fade=dot(origin_to_point,u_camera_forward) >=0.0 ? 0.0 : 1.0;\n#else\nvec3 world_pos=vec3(tile_anchor,0)+h;float globe_occlusion_fade=1.0;\n#endif\nvec4 projected_point=u_matrix*vec4(world_pos,1);highp float camera_to_anchor_distance=projected_point.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(\n0.5+0.5*distance_ratio,0.0,1.5);size*=perspective_ratio;float font_scale=size/24.0;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offset_projected_point=u_matrix*vec4(a_pos+vec2(1,0),0,1);vec2 a=projected_point.xy/projected_point.w;vec2 b=offset_projected_point.xy/offset_projected_point.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 proj_pos=mix_globe_mercator(a_projected_pos.xyz+h,mercator_pos,u_zoom_transition);vec4 projected_pos=u_label_plane_matrix*vec4(proj_pos,1.0);\n#else\nvec4 projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy,h.z,1.0);\n#endif\nhighp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);float z=0.0;vec2 offset=rotation_matrix*(a_offset/32.0*font_scale);\n#ifdef PITCH_WITH_MAP_TERRAIN\nvec4 tile_pos=u_label_plane_matrix_inv*vec4(a_projected_pos.xy+offset,0.0,1.0);z=elevation(tile_pos.xy);\n#endif\nfloat occlusion_fade=occlusionFade(projected_point)*globe_occlusion_fade;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 xAxis=u_pitch_with_map ? normalize(cross(a_globe_normal,u_up_vector)) : vec3(1,0,0);vec3 yAxis=u_pitch_with_map ? normalize(cross(a_globe_normal,xAxis)) : vec3(0,1,0);gl_Position=mix(u_coord_matrix*vec4(projected_pos.xyz/projected_pos.w+xAxis*offset.x+yAxis*offset.y,1.0),AWAY,float(projected_point.w <=0.0 || occlusion_fade==0.0));\n#else\ngl_Position=mix(u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+offset,z,1.0),AWAY,float(projected_point.w <=0.0 || occlusion_fade==0.0));\n#endif\nfloat gamma_scale=gl_Position.w;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float interpolated_fade_opacity=max(0.0,min(occlusion_fade,fade_opacity[0]+fade_change));float projection_transition_fade=1.0;\n#if defined(PROJECTED_POS_ON_VIEWPORT) && defined(PROJECTION_GLOBE_VIEW)\nprojection_transition_fade=1.0-step(EPSILON,u_zoom_transition);\n#endif\nv_data0.xy=a_tex/u_texsize;v_data0.zw=a_tex/u_texsize_icon;v_data1=vec4(gamma_scale,size,interpolated_fade_opacity*projection_transition_fade,is_sdf);}"),terrainRaster:pi("uniform sampler2D u_image0;varying vec2 v_pos0;\n#ifdef FOG\nvarying float v_fog_opacity;\n#endif\n#ifdef RENDER_SHADOWS\nvarying vec4 v_pos_light_view_0;varying vec4 v_pos_light_view_1;varying float v_depth;\n#endif\nvoid main() {vec4 color=texture2D(u_image0,v_pos0);\n#ifdef RENDER_SHADOWS\ncolor.xyz=shadowed_color(color.xyz,v_pos_light_view_0,v_pos_light_view_1,v_depth);\n#endif\n#ifdef FOG\ncolor=fog_dither(fog_apply_from_vert(color,v_fog_opacity));\n#endif\ngl_FragColor=color;\n#ifdef TERRAIN_WIREFRAME\ngl_FragColor=vec4(1.0,0.0,0.0,0.8);\n#endif\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","uniform mat4 u_matrix;uniform float u_skirt_height;attribute vec2 a_pos;attribute vec2 a_texture_pos;varying vec2 v_pos0;\n#ifdef FOG\nvarying float v_fog_opacity;\n#endif\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;varying vec4 v_pos_light_view_0;varying vec4 v_pos_light_view_1;varying float v_depth;\n#endif\nconst float skirtOffset=24575.0;const float wireframeOffset=0.00015;void main() {v_pos0=a_texture_pos/8192.0;float skirt=float(a_pos.x >=skirtOffset);float elevation=elevation(a_texture_pos)-skirt*u_skirt_height;\n#ifdef TERRAIN_WIREFRAME\nelevation+=u_skirt_height*u_skirt_height*wireframeOffset;\n#endif\nvec2 decodedPos=a_pos-vec2(skirt*skirtOffset,0.0);gl_Position=u_matrix*vec4(decodedPos,elevation,1.0);\n#ifdef FOG\nv_fog_opacity=fog(fog_position(vec3(decodedPos,elevation)));\n#endif\n#ifdef RENDER_SHADOWS\nvec3 pos=vec3(decodedPos,elevation);v_pos_light_view_0=u_light_matrix_0*vec4(pos,1.);v_pos_light_view_1=u_light_matrix_1*vec4(pos,1.);v_depth=gl_Position.w;\n#endif\n}"),terrainDepth:pi("#ifdef GL_ES\nprecision highp float;\n#endif\nvarying float v_depth;void main() {gl_FragColor=pack_depth(v_depth);}","uniform mat4 u_matrix;attribute vec2 a_pos;attribute vec2 a_texture_pos;varying float v_depth;void main() {float elevation=elevation(a_texture_pos);gl_Position=u_matrix*vec4(a_pos,elevation,1.0);v_depth=gl_Position.z/gl_Position.w;}"),skybox:pi("\nvarying lowp vec3 v_uv;uniform lowp samplerCube u_cubemap;uniform lowp float u_opacity;uniform highp float u_temporal_offset;uniform highp vec3 u_sun_direction;float sun_disk(highp vec3 ray_direction,highp vec3 sun_direction) {highp float cos_angle=dot(normalize(ray_direction),sun_direction);const highp float cos_sun_angular_diameter=0.99996192306;const highp float smoothstep_delta=1e-5;return smoothstep(\ncos_sun_angular_diameter-smoothstep_delta,cos_sun_angular_diameter+smoothstep_delta,cos_angle);}float map(float value,float start,float end,float new_start,float new_end) {return ((value-start)*(new_end-new_start))/(end-start)+new_start;}void main() {vec3 uv=v_uv;const float y_bias=0.015;uv.y+=y_bias;uv.y=pow(abs(uv.y),1.0/5.0);uv.y=map(uv.y,0.0,1.0,-1.0,1.0);vec3 sky_color=textureCube(u_cubemap,uv).rgb;\n#ifdef FOG\nsky_color=fog_apply_sky_gradient(v_uv.xzy,sky_color);\n#endif\nsky_color.rgb=dither(sky_color.rgb,gl_FragCoord.xy+u_temporal_offset);sky_color+=0.1*sun_disk(v_uv,u_sun_direction);gl_FragColor=vec4(sky_color*u_opacity,u_opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}",ii),skyboxGradient:pi("varying highp vec3 v_uv;uniform lowp sampler2D u_color_ramp;uniform highp vec3 u_center_direction;uniform lowp float u_radius;uniform lowp float u_opacity;uniform highp float u_temporal_offset;void main() {float progress=acos(dot(normalize(v_uv),u_center_direction))/u_radius;vec4 color=texture2D(u_color_ramp,vec2(progress,0.5));\n#ifdef FOG\ncolor.rgb=fog_apply_sky_gradient(v_uv.xzy,color.rgb/color.a)*color.a;\n#endif\ncolor*=u_opacity;color.rgb=dither(color.rgb,gl_FragCoord.xy+u_temporal_offset);gl_FragColor=color;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}",ii),skyboxCapture:pi("\nvarying highp vec3 v_position;uniform highp float u_sun_intensity;uniform highp float u_luminance;uniform lowp vec3 u_sun_direction;uniform highp vec4 u_color_tint_r;uniform highp vec4 u_color_tint_m;\n#ifdef GL_ES\nprecision highp float;\n#endif\n#define BETA_R                  vec3(5.5e-6,13.0e-6,22.4e-6)\n#define BETA_M                  vec3(21e-6,21e-6,21e-6)\n#define MIE_G                   0.76\n#define DENSITY_HEIGHT_SCALE_R  8000.0\n#define DENSITY_HEIGHT_SCALE_M  1200.0\n#define PLANET_RADIUS           6360e3\n#define ATMOSPHERE_RADIUS       6420e3\n#define SAMPLE_STEPS            10\n#define DENSITY_STEPS           4\nfloat ray_sphere_exit(vec3 orig,vec3 dir,float radius) {float a=dot(dir,dir);float b=2.0*dot(dir,orig);float c=dot(orig,orig)-radius*radius;float d=sqrt(b*b-4.0*a*c);return (-b+d)/(2.0*a);}vec3 extinction(vec2 density) {return exp(-vec3(BETA_R*u_color_tint_r.a*density.x+BETA_M*u_color_tint_m.a*density.y));}vec2 local_density(vec3 point) {float height=max(length(point)-PLANET_RADIUS,0.0);float exp_r=exp(-height/DENSITY_HEIGHT_SCALE_R);float exp_m=exp(-height/DENSITY_HEIGHT_SCALE_M);return vec2(exp_r,exp_m);}float phase_ray(float cos_angle) {return (3.0/(16.0*PI))*(1.0+cos_angle*cos_angle);}float phase_mie(float cos_angle) {return (3.0/(8.0*PI))*((1.0-MIE_G*MIE_G)*(1.0+cos_angle*cos_angle))/((2.0+MIE_G*MIE_G)*pow(1.0+MIE_G*MIE_G-2.0*MIE_G*cos_angle,1.5));}vec2 density_to_atmosphere(vec3 point,vec3 light_dir) {float ray_len=ray_sphere_exit(point,light_dir,ATMOSPHERE_RADIUS);float step_len=ray_len/float(DENSITY_STEPS);vec2 density_point_to_atmosphere=vec2(0.0);for (int i=0; i < DENSITY_STEPS;++i) {vec3 point_on_ray=point+light_dir*((float(i)+0.5)*step_len);density_point_to_atmosphere+=local_density(point_on_ray)*step_len;;}return density_point_to_atmosphere;}vec3 atmosphere(vec3 ray_dir,vec3 sun_direction,float sun_intensity) {vec2 density_orig_to_point=vec2(0.0);vec3 scatter_r=vec3(0.0);vec3 scatter_m=vec3(0.0);vec3 origin=vec3(0.0,PLANET_RADIUS,0.0);float ray_len=ray_sphere_exit(origin,ray_dir,ATMOSPHERE_RADIUS);float step_len=ray_len/float(SAMPLE_STEPS);for (int i=0; i < SAMPLE_STEPS;++i) {vec3 point_on_ray=origin+ray_dir*((float(i)+0.5)*step_len);vec2 density=local_density(point_on_ray)*step_len;density_orig_to_point+=density;vec2 density_point_to_atmosphere=density_to_atmosphere(point_on_ray,sun_direction);vec2 density_orig_to_atmosphere=density_orig_to_point+density_point_to_atmosphere;vec3 extinction=extinction(density_orig_to_atmosphere);scatter_r+=density.x*extinction;scatter_m+=density.y*extinction;}float cos_angle=dot(ray_dir,sun_direction);float phase_r=phase_ray(cos_angle);float phase_m=phase_mie(cos_angle);vec3 beta_r=BETA_R*u_color_tint_r.rgb*u_color_tint_r.a;vec3 beta_m=BETA_M*u_color_tint_m.rgb*u_color_tint_m.a;return (scatter_r*phase_r*beta_r+scatter_m*phase_m*beta_m)*sun_intensity;}const float A=0.15;const float B=0.50;const float C=0.10;const float D=0.20;const float E=0.02;const float F=0.30;vec3 uncharted2_tonemap(vec3 x) {return ((x*(A*x+C*B)+D*E)/(x*(A*x+B)+D*F))-E/F;}void main() {vec3 ray_direction=v_position;ray_direction.y=pow(ray_direction.y,5.0);const float y_bias=0.015;ray_direction.y+=y_bias;vec3 color=atmosphere(normalize(ray_direction),u_sun_direction,u_sun_intensity);float white_scale=1.0748724675633854;color=uncharted2_tonemap((log2(2.0/pow(u_luminance,4.0)))*color)*white_scale;gl_FragColor=vec4(color,1.0);}","attribute highp vec3 a_pos_3f;uniform mat3 u_matrix_3f;varying highp vec3 v_position;float map(float value,float start,float end,float new_start,float new_end) {return ((value-start)*(new_end-new_start))/(end-start)+new_start;}void main() {vec4 pos=vec4(u_matrix_3f*a_pos_3f,1.0);v_position=pos.xyz;v_position.y*=-1.0;v_position.y=map(v_position.y,-1.0,1.0,0.0,1.0);gl_Position=vec4(a_pos_3f.xy,0.0,1.0);}"),globeRaster:pi("uniform sampler2D u_image0;varying vec2 v_pos0;\n#ifndef FOG\nuniform highp vec3 u_frustum_tl;uniform highp vec3 u_frustum_tr;uniform highp vec3 u_frustum_br;uniform highp vec3 u_frustum_bl;uniform highp vec3 u_globe_pos;uniform highp float u_globe_radius;uniform vec2 u_viewport;\n#endif\nvoid main() {\n#ifdef CUSTOM_ANTIALIASING\nvec2 uv=gl_FragCoord.xy/u_viewport;highp vec3 ray_dir=mix(\nmix(u_frustum_tl,u_frustum_tr,uv.x),mix(u_frustum_bl,u_frustum_br,uv.x),1.0-uv.y);vec3 dir=normalize(ray_dir);vec3 closest_point=dot(u_globe_pos,dir)*dir;float norm_dist_from_center=1.0-length(closest_point-u_globe_pos)/u_globe_radius;const float antialias_pixel=2.0;float antialias_factor=antialias_pixel*fwidth(norm_dist_from_center);float antialias=smoothstep(0.0,antialias_factor,norm_dist_from_center);vec4 raster=texture2D(u_image0,v_pos0);vec4 color=vec4(raster.rgb*antialias,raster.a*antialias);\n#else\nvec4 color=texture2D(u_image0,v_pos0);\n#endif\n#ifdef FOG\ncolor=fog_dither(fog_apply_premultiplied(color,v_fog_pos));\n#endif\ngl_FragColor=color;\n#ifdef TERRAIN_WIREFRAME\ngl_FragColor=vec4(1.0,0.0,0.0,0.8);\n#endif\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","uniform mat4 u_proj_matrix;uniform mat4 u_normalize_matrix;uniform mat4 u_globe_matrix;uniform mat4 u_merc_matrix;uniform float u_zoom_transition;uniform vec2 u_merc_center;uniform mat3 u_grid_matrix;\n#ifdef GLOBE_POLES\nattribute vec3 a_globe_pos;attribute vec2 a_uv;\n#else\nattribute vec2 a_pos;\n#endif\nvarying vec2 v_pos0;const float wireframeOffset=1e3;float mercatorXfromLng(float lng) {return (180.0+lng)/360.0;}float mercatorYfromLat(float lat) {return (180.0-(RAD_TO_DEG*log(tan(QUARTER_PI+lat/2.0*DEG_TO_RAD))))/360.0;}vec3 latLngToECEF(vec2 latLng) {latLng=DEG_TO_RAD*latLng;float cosLat=cos(latLng[0]);float sinLat=sin(latLng[0]);float cosLng=cos(latLng[1]);float sinLng=sin(latLng[1]);float sx=cosLat*sinLng*GLOBE_RADIUS;float sy=-sinLat*GLOBE_RADIUS;float sz=cosLat*cosLng*GLOBE_RADIUS;return vec3(sx,sy,sz);}void main() {\n#ifdef GLOBE_POLES\nvec3 globe_pos=a_globe_pos;vec2 uv=a_uv;\n#else\nfloat tiles=u_grid_matrix[0][2];float idy=u_grid_matrix[1][2];float S=u_grid_matrix[2][2];vec3 latLng=u_grid_matrix*vec3(a_pos,1.0);float mercatorY=mercatorYfromLat(latLng[0]);float uvY=mercatorY*tiles-idy;float mercatorX=mercatorXfromLng(latLng[1]);float uvX=a_pos[0]*S;vec3 globe_pos=latLngToECEF(latLng.xy);vec2 merc_pos=vec2(mercatorX,mercatorY);vec2 uv=vec2(uvX,uvY);\n#endif\nv_pos0=uv;vec2 tile_pos=uv*EXTENT;\n#ifdef GLOBE_POLES\nvec3 up_vector=normalize(globe_pos)*u_tile_up_scale;\n#else\nvec3 up_vector=elevationVector(tile_pos);\n#endif\nfloat height=elevation(tile_pos);\n#ifdef TERRAIN_WIREFRAME\nheight+=wireframeOffset;\n#endif\nglobe_pos+=up_vector*height;\n#ifdef GLOBE_POLES\nvec4 interpolated_pos=u_globe_matrix*vec4(globe_pos,1.0);\n#else\nvec4 globe_world_pos=u_globe_matrix*vec4(globe_pos,1.0);vec4 merc_world_pos=vec4(0.0);if (u_zoom_transition > 0.0) {merc_world_pos=vec4(merc_pos,height,1.0);merc_world_pos.xy-=u_merc_center;merc_world_pos.x=wrap(merc_world_pos.x,-0.5,0.5);merc_world_pos=u_merc_matrix*merc_world_pos;}vec4 interpolated_pos=vec4(mix(globe_world_pos.xyz,merc_world_pos.xyz,u_zoom_transition),1.0);\n#endif\ngl_Position=u_proj_matrix*interpolated_pos;\n#ifdef FOG\nv_fog_pos=fog_position((u_normalize_matrix*vec4(globe_pos,1.0)).xyz);\n#endif\n}"),globeAtmosphere:pi("uniform float u_transition;uniform highp float u_fadeout_range;uniform highp float u_temporal_offset;uniform vec3 u_start_color;uniform vec4 u_color;uniform vec4 u_space_color;uniform vec4 u_high_color;uniform float u_star_intensity;uniform float u_star_size;uniform float u_star_density;uniform float u_horizon_angle;uniform mat4 u_rotation_matrix;varying highp vec3 v_ray_dir;varying highp vec3 v_horizon_dir;highp float random(highp vec3 p) {p=fract(p*vec3(23.2342,97.1231,91.2342));p+=dot(p.zxy,p.yxz+123.1234);return fract(p.x*p.y);}float stars(vec3 p,float scale,vec2 offset) {vec2 uv_scale=(u_viewport/u_star_size)*scale;vec3 position=vec3(p.xy*uv_scale+offset*u_viewport,p.z);vec3 q=fract(position)-0.5;vec3 id=floor(position);float random_visibility=step(random(id),u_star_density);float circle=smoothstep(0.5+u_star_intensity,0.5,length(q));return circle*random_visibility;}void main() {highp vec3 dir=normalize(v_ray_dir);\n#ifdef PROJECTION_GLOBE_VIEW\nfloat globe_pos_dot_dir=dot(u_globe_pos,dir);highp vec3 closest_point_forward=abs(globe_pos_dot_dir)*dir;float norm_dist_from_center=length(closest_point_forward-u_globe_pos)/u_globe_radius;if (norm_dist_from_center < 0.98) {discard;return;}\n#endif\nhighp vec3 horizon_dir=normalize(v_horizon_dir);float horizon_angle_mercator=dir.y < horizon_dir.y ?\n0.0 : max(acos(dot(dir,horizon_dir)),0.0);\n#ifdef PROJECTION_GLOBE_VIEW\nhighp vec3 closest_point=globe_pos_dot_dir*dir;float closest_point_to_center=length(closest_point-u_globe_pos);float theta=asin(clamp(closest_point_to_center/length(u_globe_pos),-1.0,1.0));float horizon_angle=globe_pos_dot_dir < 0.0 ?\nPI-theta-u_horizon_angle : theta-u_horizon_angle;float angle_t=pow(u_transition,10.0);horizon_angle=mix(horizon_angle,horizon_angle_mercator,angle_t);\n#else\nfloat horizon_angle=horizon_angle_mercator;\n#endif\nhorizon_angle/=PI;float t=exp(-horizon_angle/u_fadeout_range);float alpha_0=u_color.a;float alpha_1=u_high_color.a;float alpha_2=u_space_color.a;vec3 color_stop_0=u_color.rgb;vec3 color_stop_1=u_high_color.rgb;vec3 color_stop_2=u_space_color.rgb;vec3 c0=mix(color_stop_2,color_stop_1,alpha_1);vec3 c1=mix(c0,color_stop_0,alpha_0);vec3 c2=mix(c0,c1,t);vec3 c =mix(color_stop_2,c2,t);float a0=mix(alpha_2,1.0,alpha_1);float a1=mix(a0,1.0,alpha_0);float a2=mix(a0,a1,t);float a =mix(alpha_2,a2,t);vec2 uv=gl_FragCoord.xy/u_viewport-0.5;float aspect_ratio=u_viewport.x/u_viewport.y;vec4 uv_dir=vec4(normalize(vec3(uv.x*aspect_ratio,uv.y,1.0)),1.0);uv_dir=u_rotation_matrix*uv_dir;vec3 n=abs(uv_dir.xyz);vec2 uv_remap=(n.x > n.y && n.x > n.z) ? uv_dir.yz/uv_dir.x:\n(n.y > n.x && n.y > n.z) ? uv_dir.zx/uv_dir.y:\nuv_dir.xy/uv_dir.z;uv_remap.x/=aspect_ratio;vec3 D=vec3(uv_remap,1.0);highp float star_field=0.0;if (u_star_intensity > 0.0) {star_field+=stars(D,1.2,vec2(0.0,0.0));star_field+=stars(D,1.0,vec2(1.0,0.0));star_field+=stars(D,0.8,vec2(0.0,1.0));star_field+=stars(D,0.6,vec2(1.0,1.0));star_field*=(1.0-pow(t,0.25+(1.0-u_high_color.a)*0.75));c+=star_field*alpha_2;}c=dither(c,gl_FragCoord.xy+u_temporal_offset);gl_FragColor=vec4(c,a);}","attribute vec3 a_pos;attribute vec2 a_uv;uniform vec3 u_frustum_tl;uniform vec3 u_frustum_tr;uniform vec3 u_frustum_br;uniform vec3 u_frustum_bl;uniform float u_horizon;varying highp vec3 v_ray_dir;varying highp vec3 v_horizon_dir;void main() {v_ray_dir=mix(\nmix(u_frustum_tl,u_frustum_tr,a_uv.x),mix(u_frustum_bl,u_frustum_br,a_uv.x),a_uv.y);v_horizon_dir=mix(\nmix(u_frustum_tl,u_frustum_bl,u_horizon),mix(u_frustum_tr,u_frustum_br,u_horizon),a_uv.x);gl_Position=vec4(a_pos,1.0);}")};function di(e,t){const i=e.replace(/\s*\/\/[^\n]*\n/g,"\n").split("\n");for(let e of i)if(e=e.trim(),"#"===e[0]&&e.includes("if")&&!e.includes("endif")){e=e.replace("#","").replace(/ifdef|ifndef|elif|if/g,"").replace(/!|defined|\(|\)|\|\||&&/g,"").replace(/\s+/g," ").trim();const i=e.split(" ");for(const e of i)t.includes(e)||t.push(e);}}function pi(e,t){const i=/#pragma mapbox: ([\w]+) ([\w]+) ([\w]+) ([\w]+)/g,o=t.match(/attribute (highp |mediump |lowp )?([\w]+) ([\w]+)/g),r={},n=[...li];return di(e,n),di(t,n),{fragmentSource:e=e.replace(i,((e,t,i,o,n)=>(r[n]=!0,"define"===t?`\n#ifndef HAS_UNIFORM_u_${n}\nvarying ${i} ${o} ${n};\n#else\nuniform ${i} ${o} u_${n};\n#endif\n`:`\n#ifdef HAS_UNIFORM_u_${n}\n    ${i} ${o} ${n} = u_${n};\n#endif\n`))),vertexSource:t=t.replace(i,((e,t,i,o,n)=>{const a="float"===o?"vec2":"vec4",s=n.match(/color/)?"color":a;return r[n]?"define"===t?`\n#ifndef HAS_UNIFORM_u_${n}\nuniform lowp float u_${n}_t;\nattribute ${i} ${a} a_${n};\nvarying ${i} ${o} ${n};\n#else\nuniform ${i} ${o} u_${n};\n#endif\n`:"vec4"===s?`\n#ifndef HAS_UNIFORM_u_${n}\n    ${n} = a_${n};\n#else\n    ${i} ${o} ${n} = u_${n};\n#endif\n`:`\n#ifndef HAS_UNIFORM_u_${n}\n    ${n} = unpack_mix_${s}(a_${n}, u_${n}_t);\n#else\n    ${i} ${o} ${n} = u_${n};\n#endif\n`:"define"===t?`\n#ifndef HAS_UNIFORM_u_${n}\nuniform lowp float u_${n}_t;\nattribute ${i} ${a} a_${n};\n#else\nuniform ${i} ${o} u_${n};\n#endif\n`:"vec4"===s?`\n#ifndef HAS_UNIFORM_u_${n}\n    ${i} ${o} ${n} = a_${n};\n#else\n    ${i} ${o} ${n} = u_${n};\n#endif\n`:`\n#ifndef HAS_UNIFORM_u_${n}\n    ${i} ${o} ${n} = unpack_mix_${s}(a_${n}, u_${n}_t);\n#else\n    ${i} ${o} ${n} = u_${n};\n#endif\n`})),staticAttributes:o,usedDefines:n}}class mi{constructor(){this.boundProgram=null,this.boundLayoutVertexBuffer=null,this.boundPaintVertexBuffers=[],this.boundIndexBuffer=null,this.boundVertexOffset=null,this.boundDynamicVertexBuffers=[],this.vao=null;}bind(e,t,i,o,r,n,a){this.context=e;let s=this.boundPaintVertexBuffers.length!==o.length;for(let e=0;!s&&e<o.length;e++)this.boundPaintVertexBuffers[e]!==o[e]&&(s=!0);let l=this.boundDynamicVertexBuffers.length!==a.length;for(let e=0;!l&&e<a.length;e++)this.boundDynamicVertexBuffers[e]!==a[e]&&(l=!0);if(!e.extVertexArrayObject||!this.vao||this.boundProgram!==t||this.boundLayoutVertexBuffer!==i||s||l||this.boundIndexBuffer!==r||this.boundVertexOffset!==n)this.freshBind(t,i,o,r,n,a);else {e.bindVertexArrayOES.set(this.vao);for(const e of a)e&&e.bind();r&&r.dynamicDraw&&r.bind();}}freshBind(e,t,i,o,r,n){let a;const s=e.numAttributes,l=this.context,c=l.gl;if(l.extVertexArrayObject)this.vao&&this.destroy(),this.vao=l.extVertexArrayObject.createVertexArrayOES(),l.bindVertexArrayOES.set(this.vao),a=0,this.boundProgram=e,this.boundLayoutVertexBuffer=t,this.boundPaintVertexBuffers=i,this.boundIndexBuffer=o,this.boundVertexOffset=r,this.boundDynamicVertexBuffers=n;else {a=l.currentNumAttributes||0;for(let e=s;e<a;e++)c.disableVertexAttribArray(e);}t.enableAttributes(c,e),t.bind(),t.setVertexAttribPointers(c,e,r);for(const t of i)t.enableAttributes(c,e),t.bind(),t.setVertexAttribPointers(c,e,r);for(const t of n)t&&(t.enableAttributes(c,e),t.bind(),t.setVertexAttribPointers(c,e,r));o&&o.bind(),l.currentNumAttributes=s;}destroy(){this.vao&&(this.context.extVertexArrayObject.deleteVertexArrayOES(this.vao),this.vao=null);}}function fi(t,i){const o=Math.pow(2,i.canonical.z),r=i.canonical.y;return [new e.MercatorCoordinate(0,r/o).toLngLat().lat,new e.MercatorCoordinate(0,(r+1)/o).toLngLat().lat]}function gi(t,i,o,r,n,a,s){const l=t.context,c=l.gl,h=o.fbo;if(!h)return;t.prepareDrawTile();const u=t.useProgram("hillshade");l.activeTexture.set(c.TEXTURE0),c.bindTexture(c.TEXTURE_2D,h.colorAttachment.get());const _=((e,t,i,o)=>{const r=i.paint.get("hillshade-shadow-color"),n=i.paint.get("hillshade-highlight-color"),a=i.paint.get("hillshade-accent-color");let s=i.paint.get("hillshade-illumination-direction")*(Math.PI/180);"viewport"===i.paint.get("hillshade-illumination-anchor")&&(s-=e.transform.angle);const l=!e.options.moving;return {u_matrix:o||e.transform.calculateProjMatrix(t.tileID.toUnwrapped(),l),u_image:0,u_latrange:fi(0,t.tileID),u_light:[i.paint.get("hillshade-exaggeration"),s],u_shadow:r,u_highlight:n,u_accent:a}})(t,o,r,t.terrain?i.projMatrix:null);t.prepareDrawProgram(l,u,i.toUnwrapped());const{tileBoundsBuffer:d,tileBoundsIndexBuffer:p,tileBoundsSegments:m}=t.getTileBoundsBuffers(o);u.draw(l,c.TRIANGLES,n,a,s,e.CullFaceMode.disabled,_,r.id,d,p,m);}function vi(t,i,o){if(!i.needsDEMTextureUpload)return;const r=t.context,n=r.gl;r.pixelStoreUnpackPremultiplyAlpha.set(!1),i.demTexture=i.demTexture||t.getTileTexture(o.stride);const a=o.getPixels();i.demTexture?i.demTexture.update(a,{premultiply:!1}):i.demTexture=new e.Texture(r,a,n.RGBA,{premultiply:!1}),i.needsDEMTextureUpload=!1;}function xi(t,i,o,r,n,a){const s=t.context,l=s.gl;if(!i.dem)return;const c=i.dem;if(s.activeTexture.set(l.TEXTURE1),vi(t,i,c),!i.demTexture)return;i.demTexture.bind(l.NEAREST,l.CLAMP_TO_EDGE);const h=c.dim;s.activeTexture.set(l.TEXTURE0);let u=i.fbo;if(!u){const t=new e.Texture(s,{width:h,height:h,data:null},l.RGBA);t.bind(l.LINEAR,l.CLAMP_TO_EDGE),u=i.fbo=s.createFramebuffer(h,h,!0),u.colorAttachment.set(t.texture);}s.bindFramebuffer.set(u.framebuffer),s.viewport.set([0,0,h,h]);const{tileBoundsBuffer:_,tileBoundsIndexBuffer:d,tileBoundsSegments:p}=t.getMercatorTileBoundsBuffers();t.useProgram("hillshadePrepare").draw(s,l.TRIANGLES,r,n,a,e.CullFaceMode.disabled,((t,i)=>{const o=i.stride,r=e.create();return e.ortho(r,0,e.EXTENT,-e.EXTENT,0,0,1),e.translate(r,r,[0,-e.EXTENT,0]),{u_matrix:r,u_image:1,u_dimension:[o,o],u_zoom:t.overscaledZ,u_unpack:i.unpackVector}})(i.tileID,c),o.id,_,d,p),i.needsHillshadePrepare=!1;}const yi=t=>({u_matrix:new e.UniformMatrix4f(t),u_image0:new e.Uniform1i(t),u_skirt_height:new e.Uniform1f(t)}),bi=(e,t)=>({u_matrix:e,u_image0:0,u_skirt_height:t}),wi=(e,t,i,o,r,n,a,s,l,c,h,u,_,d)=>({u_proj_matrix:Float32Array.from(e),u_globe_matrix:t,u_normalize_matrix:Float32Array.from(o),u_merc_matrix:i,u_zoom_transition:r,u_merc_center:n,u_image0:0,u_frustum_tl:a,u_frustum_tr:s,u_frustum_br:l,u_frustum_bl:c,u_globe_pos:h,u_globe_radius:u,u_viewport:_,u_grid_matrix:d?Float32Array.from(d):new Float32Array(9)});function Ti(e,t){return null!=e&&null!=t&&!(!e.hasData()||!t.hasData())&&null!=e.demTexture&&null!=t.demTexture&&e.tileID.key!==t.tileID.key}const Ei=new class{constructor(){this.operations={};}newMorphing(e,t,i,o,r){if(e in this.operations){const t=this.operations[e];t.to.tileID.key!==i.tileID.key&&(t.queued=i);}else this.operations[e]={startTime:o,phase:0,duration:r,from:t,to:i,queued:null};}getMorphValuesForProxy(e){if(!(e in this.operations))return null;const t=this.operations[e];return {from:t.from,to:t.to,phase:t.phase}}update(e){for(const t in this.operations){const i=this.operations[t];for(i.phase=(e-i.startTime)/i.duration;i.phase>=1||!this._validOp(i);)if(!this._nextOp(i,e)){delete this.operations[t];break}}}_nextOp(e,t){return !!e.queued&&(e.from=e.to,e.to=e.queued,e.queued=null,e.phase=0,e.startTime=t,!0)}_validOp(e){return e.from.hasData()&&e.to.hasData()}},Ci={0:null,1:"TERRAIN_VERTEX_MORPHING",2:"TERRAIN_WIREFRAME"};function Ii(e,t){const i=1<<e.z;return !t&&(0===e.x||e.x===i-1)||0===e.y||e.y===i-1}const Mi=e=>({u_matrix:e});function Si(t,i,o,r,n){if(n>0){const a=e.exported.now(),s=(a-t.timeAdded)/n,l=i?(a-i.timeAdded)/n:-1,c=o.getSource(),h=r.coveringZoomLevel({tileSize:c.tileSize,roundZoom:c.roundZoom}),u=!i||Math.abs(i.tileID.overscaledZ-h)>Math.abs(t.tileID.overscaledZ-h),_=u&&t.refreshedUponExpiration?1:e.clamp(u?s:1-l,0,1);return t.refreshedUponExpiration&&s>=1&&(t.refreshedUponExpiration=!1),i?{opacity:1,mix:1-_}:{opacity:_,mix:0}}return {opacity:1,mix:0}}class zi extends e.SourceCache{constructor(e){const t={type:"raster-dem",maxzoom:e.transform.maxZoom},i=new A(Ge(),null),o=Ae("mock-dem",t,i,e.style);super("mock-dem",o,!1),o.setEventedParent(this),this._sourceLoaded=!0;}_loadTile(e,t){e.state="loaded",t(null);}}class Di extends e.SourceCache{constructor(e){const t=Ae("proxy",{type:"geojson",maxzoom:e.transform.maxZoom},new A(Ge(),null),e.style);super("proxy",t,!1),t.setEventedParent(this),this.map=this.getSource().map=e,this.used=this._sourceLoaded=!0,this.renderCache=[],this.renderCachePool=[],this.proxyCachedFBO={};}update(t,i,o){if(t.freezeTileCoverage)return;this.transform=t;const r=t.coveringTiles({tileSize:this._source.tileSize,minzoom:this._source.minzoom,maxzoom:this._source.maxzoom,roundZoom:this._source.roundZoom,reparseOverscaled:this._source.reparseOverscaled}).reduce(((i,o)=>{if(i[o.key]="",!this._tiles[o.key]){const i=new e.Tile(o,this._source.tileSize*o.overscaleFactor(),t.tileZoom);i.state="loaded",this._tiles[o.key]=i;}return i}),{});for(const e in this._tiles)e in r||(this.freeFBO(e),this._tiles[e].unloadVectorData(),delete this._tiles[e]);}freeFBO(e){const t=this.proxyCachedFBO[e];if(void 0!==t){const i=Object.values(t);this.renderCachePool.push(...i),delete this.proxyCachedFBO[e];}}deallocRenderCache(){this.renderCache.forEach((e=>e.fb.destroy())),this.renderCache=[],this.renderCachePool=[],this.proxyCachedFBO={};}}class Pi extends e.OverscaledTileID{constructor(e,t,i){super(e.overscaledZ,e.wrap,e.canonical.z,e.canonical.x,e.canonical.y),this.proxyTileKey=t,this.projMatrix=i;}}class Ai extends e.Elevation{constructor(t,i){super(),this.painter=t,this.terrainTileForTile={},this.prevTerrainTileForTile={};const[o,r,n]=function(t){const i=new e.StructArrayLayout4i8,o=new e.StructArrayLayout3ui6,r=131;i.reserve(17161),o.reserve(33800);const n=e.EXTENT/128,a=e.EXTENT+n/2,s=a+n;for(let t=-n;t<s;t+=n)for(let o=-n;o<s;o+=n){const r=o<0||o>a||t<0||t>a?24575:0,n=e.clamp(Math.round(o),0,e.EXTENT),s=e.clamp(Math.round(t),0,e.EXTENT);i.emplaceBack(n+r,s,n,s);}const l=(e,t)=>{const i=t*r+e;o.emplaceBack(i+1,i,i+r),o.emplaceBack(i+r,i+r+1,i+1);};for(let e=1;e<129;e++)for(let t=1;t<129;t++)l(t,e);return [0,129].forEach((e=>{for(let t=0;t<130;t++)l(t,e),l(e,t);})),[i,o,32768]}(),a=t.context;this.gridBuffer=a.createVertexBuffer(o,e.boundsAttributes.members),this.gridIndexBuffer=a.createIndexBuffer(r),this.gridSegments=e.SegmentVector.simpleSegment(0,0,o.length,r.length),this.gridNoSkirtSegments=e.SegmentVector.simpleSegment(0,0,o.length,n),this.proxyCoords=[],this.proxiedCoords={},this._visibleDemTiles=[],this._drapedRenderBatches=[],this._sourceTilesOverlap={},this.proxySourceCache=new Di(i.map),this.orthoMatrix=e.create(),e.ortho(this.orthoMatrix,0,e.EXTENT,0,e.EXTENT,0,1);const s=a.gl;this._overlapStencilMode=new e.StencilMode({func:s.GEQUAL,mask:255},0,255,s.KEEP,s.KEEP,s.REPLACE),this._previousZoom=t.transform.zoom,this.pool=[],this._findCoveringTileCache={},this._tilesDirty={},this.style=i,this._useVertexMorphing=!0,this._exaggeration=1,this._mockSourceCache=new zi(i.map);}set style(e){e.on("data",this._onStyleDataEvent.bind(this)),e.on("neworder",this._checkRenderCacheEfficiency.bind(this)),this._style=e,this._checkRenderCacheEfficiency();}update(t,i,o){if(t&&t.terrain){this._style!==t&&(this.style=t),this.enabled=!0;const r=t.terrain.properties;this.sourceCache=0===t.terrain.drapeRenderMode?this._mockSourceCache:t._getSourceCache(r.get("source")),this._exaggeration=r.get("exaggeration");const n=()=>{this.sourceCache.used&&e.warnOnce(`Raster DEM source '${this.sourceCache.id}' is used both for terrain and as layer source.\nThis leads to lower resolution of hillshade. For full hillshade resolution but higher memory consumption, define another raster DEM source.`);const t=this.getScaledDemTileSize();this.sourceCache.update(i,t,!0),this.resetTileLookupCache(this.sourceCache.id);};this.sourceCache.usedForTerrain||(this.resetTileLookupCache(this.sourceCache.id),this.sourceCache.usedForTerrain=!0,n(),this._initializing=!0),n(),i.updateElevation(!o),this.resetTileLookupCache(this.proxySourceCache.id),this.proxySourceCache.update(i),this._emptyDEMTextureDirty=!0;}else this._disable();}resetTileLookupCache(e){this._findCoveringTileCache[e]={};}getScaledDemTileSize(){return this.sourceCache.getSource().tileSize/128*this.proxySourceCache.getSource().tileSize}_checkRenderCacheEfficiency(){const t=this.renderCacheEfficiency(this._style);this._style.map._optimizeForTerrain||100!==t.efficiency&&e.warnOnce(`Terrain render cache efficiency is not optimal (${t.efficiency}%) and performance\n                may be affected negatively, consider placing all background, fill and line layers before layer\n                with id '${t.firstUndrapedLayer}' or create a map using optimizeForTerrain: true option.`);}_onStyleDataEvent(e){e.coord&&"source"===e.dataType?this._clearRenderCacheForTile(e.sourceCacheId,e.coord):"style"===e.dataType&&(this._invalidateRenderCache=!0);}_disable(){if(this.enabled&&(this.enabled=!1,this._sharedDepthStencil=void 0,this.proxySourceCache.deallocRenderCache(),this._style))for(const e in this._style._sourceCaches)this._style._sourceCaches[e].usedForTerrain=!1;}destroy(){this._disable(),this._emptyDEMTexture&&this._emptyDEMTexture.destroy(),this._emptyDepthBufferTexture&&this._emptyDepthBufferTexture.destroy(),this.pool.forEach((e=>e.fb.destroy())),this.pool=[],this._depthFBO&&(this._depthFBO.destroy(),this._depthFBO=void 0,this._depthTexture=void 0);}_source(){return this.enabled?this.sourceCache:null}exaggeration(){return this._exaggeration}get visibleDemTiles(){return this._visibleDemTiles}get drapeBufferSize(){const e=2*this.proxySourceCache.getSource().tileSize;return [e,e]}set useVertexMorphing(e){this._useVertexMorphing=e;}updateTileBinding(t){if(!this.enabled)return;this.prevTerrainTileForTile=this.terrainTileForTile;const i=this.proxySourceCache,o=this.painter.transform;this._initializing&&(this._initializing=0===o._centerAltitude&&-1===this.getAtPointOrZero(e.MercatorCoordinate.fromLngLat(o.center),-1),this._emptyDEMTextureDirty=!this._initializing);const r=this.proxyCoords=i.getIds().map((e=>{const t=i.getTileByID(e).tileID;return t.projMatrix=o.calculateProjMatrix(t.toUnwrapped()),t}));!function(t,i){const o=i.transform.pointCoordinate(i.transform.getCameraPoint()),r=new e.pointGeometry(o.x,o.y);t.sort(((t,i)=>{if(i.overscaledZ-t.overscaledZ)return i.overscaledZ-t.overscaledZ;const o=new e.pointGeometry(t.canonical.x+(1<<t.canonical.z)*t.wrap,t.canonical.y),n=new e.pointGeometry(i.canonical.x+(1<<i.canonical.z)*i.wrap,i.canonical.y),a=r.mult(1<<t.canonical.z);return a.x-=.5,a.y-=.5,a.distSqr(o)-a.distSqr(n)}));}(r,this.painter),this._previousZoom=o.zoom;const n=this.proxyToSource||{};this.proxyToSource={},r.forEach((e=>{this.proxyToSource[e.key]={};})),this.terrainTileForTile={};const a=this._style._sourceCaches;for(const e in a){const i=a[e];if(!i.used)continue;if(i!==this.sourceCache&&this.resetTileLookupCache(i.id),this._setupProxiedCoordsForOrtho(i,t[e],n),i.usedForTerrain)continue;const o=t[e];i.getSource().reparseOverscaled&&this._assignTerrainTiles(o);}this.proxiedCoords[i.id]=r.map((e=>new Pi(e,e.key,this.orthoMatrix))),this._assignTerrainTiles(r),this._prepareDEMTextures(),this._setupDrapedRenderBatches(),this._initFBOPool(),this._setupRenderCache(n),this.renderingToTexture=!1,this._updateTimestamp=e.exported.now();const s={};this._visibleDemTiles=[];for(const e of this.proxyCoords){const t=this.terrainTileForTile[e.key];if(!t)continue;const i=t.tileID.key;i in s||(this._visibleDemTiles.push(t),s[i]=i);}}_assignTerrainTiles(e){this._initializing||e.forEach((e=>{if(this.terrainTileForTile[e.key])return;const t=this._findTileCoveringTileID(e,this.sourceCache);t&&(this.terrainTileForTile[e.key]=t);}));}_prepareDEMTextures(){const e=this.painter.context,t=e.gl;for(const i in this.terrainTileForTile){const o=this.terrainTileForTile[i],r=o.dem;!r||o.demTexture&&!o.needsDEMTextureUpload||(e.activeTexture.set(t.TEXTURE1),vi(this.painter,o,r));}}_prepareDemTileUniforms(e,t,i,o){if(!t||null==t.demTexture)return !1;const r=e.tileID.canonical,n=Math.pow(2,t.tileID.canonical.z-r.z),a=o||"";return i[`u_dem_tl${a}`]=[r.x*n%1,r.y*n%1],i[`u_dem_scale${a}`]=n,!0}get emptyDEMTexture(){return !this._emptyDEMTextureDirty&&this._emptyDEMTexture?this._emptyDEMTexture:this._updateEmptyDEMTexture()}get emptyDepthBufferTexture(){const t=this.painter.context,i=t.gl;if(!this._emptyDepthBufferTexture){const o=new e.RGBAImage({width:1,height:1},Uint8Array.of(255,255,255,255));this._emptyDepthBufferTexture=new e.Texture(t,o,i.RGBA,{premultiply:!1});}return this._emptyDepthBufferTexture}_getLoadedAreaMinimum(){let e=0;const t=this._visibleDemTiles.reduce(((t,i)=>{if(!i.dem)return t;const o=i.dem.tree.minimums[0];return o>0&&e++,t+o}),0);return e?t/e:0}_updateEmptyDEMTexture(){const t=this.painter.context,i=t.gl;t.activeTexture.set(i.TEXTURE2);const o=this._getLoadedAreaMinimum(),r=new e.RGBAImage({width:1,height:1},new Uint8Array(e.DEMData.pack(o,this.sourceCache.getSource().encoding)));this._emptyDEMTextureDirty=!1;let n=this._emptyDEMTexture;return n?n.update(r,{premultiply:!1}):n=this._emptyDEMTexture=new e.Texture(t,r,i.RGBA,{premultiply:!1}),n}setupElevationDraw(t,i,o){const r=this.painter.context,n=r.gl,a=(s=this.sourceCache.getSource().encoding,{u_dem:2,u_dem_prev:4,u_dem_unpack:e.DEMData.getUnpackVector(s),u_dem_tl:[0,0],u_dem_tl_prev:[0,0],u_dem_scale:0,u_dem_scale_prev:0,u_dem_size:0,u_dem_lerp:1,u_depth:3,u_depth_size_inv:[0,0],u_exaggeration:0,u_tile_tl_up:[0,0,1],u_tile_tr_up:[0,0,1],u_tile_br_up:[0,0,1],u_tile_bl_up:[0,0,1],u_tile_up_scale:1});var s;a.u_dem_size=this.sourceCache.getSource().tileSize,a.u_exaggeration=this.exaggeration();const l=this.painter.transform,c=l.projection,h=t.tileID.canonical;a.u_tile_tl_up=c.upVector(h,0,0),a.u_tile_tr_up=c.upVector(h,e.EXTENT,0),a.u_tile_br_up=c.upVector(h,e.EXTENT,e.EXTENT),a.u_tile_bl_up=c.upVector(h,0,e.EXTENT),a.u_tile_up_scale=o&&o.useDenormalizedUpVectorScale?e.GLOBE_METERS_TO_ECEF:c.upVectorScale(h,l.center.lat,l.worldSize).metersToTile;let u=null,_=null,d=1;if(o&&o.morphing&&this._useVertexMorphing){const e=o.morphing.srcDemTile,i=o.morphing.dstDemTile;d=o.morphing.phase,e&&i&&(this._prepareDemTileUniforms(t,e,a,"_prev")&&(_=e),this._prepareDemTileUniforms(t,i,a)&&(u=i));}if(_&&u?(r.activeTexture.set(n.TEXTURE2),u.demTexture.bind(n.NEAREST,n.CLAMP_TO_EDGE,n.NEAREST),r.activeTexture.set(n.TEXTURE4),_.demTexture.bind(n.NEAREST,n.CLAMP_TO_EDGE,n.NEAREST),a.u_dem_lerp=d):(u=this.terrainTileForTile[t.tileID.key],r.activeTexture.set(n.TEXTURE2),(this._prepareDemTileUniforms(t,u,a)?u.demTexture:this.emptyDEMTexture).bind(n.NEAREST,n.CLAMP_TO_EDGE)),r.activeTexture.set(n.TEXTURE3),o&&o.useDepthForOcclusion?(this._depthTexture&&this._depthTexture.bind(n.NEAREST,n.CLAMP_TO_EDGE),this._depthFBO&&(a.u_depth_size_inv=[1/this._depthFBO.width,1/this._depthFBO.height])):(this.emptyDepthBufferTexture.bind(n.NEAREST,n.CLAMP_TO_EDGE),a.u_depth_size_inv=[1,1]),o&&o.useMeterToDem&&u){const t=(1<<u.tileID.canonical.z)*e.mercatorZfromAltitude(1,this.painter.transform.center.lat)*this.sourceCache.getSource().tileSize;a.u_meter_to_dem=t;}o&&o.labelPlaneMatrixInv&&(a.u_label_plane_matrix_inv=o.labelPlaneMatrixInv),i.setTerrainUniformValues(r,a);}renderToBackBuffer(t){const i=this.painter,o=this.painter.context;0!==t.length&&(o.bindFramebuffer.set(null),o.viewport.set([0,0,i.width,i.height]),i.gpuTimingDeferredRenderStart(),this.renderingToTexture=!1,function(t,i,o,r,n){if("globe"===t.transform.projection.name)!function(t,i,o,r,n){const a=t.context,s=a.gl;let l,c;const h=t.options.showTerrainWireframe?2:0,u=t.transform,_=e.globeUseCustomAntiAliasing(t,a,u),d=(e,i)=>{if(c===e)return;const o=[Ci[e],"PROJECTION_GLOBE_VIEW"];_&&o.push("CUSTOM_ANTIALIASING"),i&&o.push(Ci[h]),l=t.useProgram("globeRaster",null,o),c=e;},p=t.colorModeForRenderPass(),m=new e.DepthMode(s.LEQUAL,e.DepthMode.ReadWrite,t.depthRangeFor3D);Ei.update(n);const f=e.calculateGlobeMercatorMatrix(u),g=[e.mercatorXfromLng(u.center.lng),e.mercatorYfromLat(u.center.lat)],v=h?[!1,!0]:[!1],x=t.globeSharedBuffers,y=[u.width*e.exported.devicePixelRatio,u.height*e.exported.devicePixelRatio],b=Float32Array.from(u.globeMatrix),w={useDenormalizedUpVectorScale:!0};if(v.forEach((h=>{c=-1;const _=h?s.LINES:s.TRIANGLES;for(const c of r){const r=o.getTile(c),v=e.StencilMode.disabled,T=i.prevTerrainTileForTile[c.key],E=i.terrainTileForTile[c.key];Ti(T,E)&&Ei.newMorphing(c.key,T,E,n,250),a.activeTexture.set(s.TEXTURE0),r.texture.bind(s.LINEAR,s.CLAMP_TO_EDGE);const C=Ei.getMorphValuesForProxy(c.key),I=C?1:0;C&&e.extend$1(w,{morphing:{srcDemTile:C.from,dstDemTile:C.to,phase:e.easeCubicInOut(C.phase)}});const M=e.tileCornersToBounds(c.canonical),S=e.getLatitudinalLod(M.getCenter().lat),z=e.getGridMatrix(c.canonical,M,S),D=e.globeNormalizeECEF(e.globeTileBounds(c.canonical)),P=wi(u.projMatrix,b,f,D,e.globeToMercatorTransition(u.zoom),g,u.frustumCorners.TL,u.frustumCorners.TR,u.frustumCorners.BR,u.frustumCorners.BL,u.globeCenterInViewSpace,u.globeRadius,y,z);if(d(I,h),i.setupElevationDraw(r,l,w),t.prepareDrawProgram(a,l,c.toUnwrapped()),x){const[i,o,r]=h?x.getWirefameBuffers(t.context,S):x.getGridBuffers(S);l.draw(a,_,m,v,p,e.CullFaceMode.backCCW,P,"globe_raster",i,o,r);}}})),x){const n=["GLOBE_POLES","PROJECTION_GLOBE_VIEW"];_&&n.push("CUSTOM_ANTIALIASING"),l=t.useProgram("globeRaster",null,n);for(const n of r){const{x:r,y:c,z:h}=n.canonical,_=0===c,d=c===(1<<h)-1,[f,v,b,T]=x.getPoleBuffers(h);if(T&&(_||d)){const c=o.getTile(n);a.activeTexture.set(s.TEXTURE0),c.texture.bind(s.LINEAR,s.CLAMP_TO_EDGE);let x=e.globePoleMatrixForTile(h,r,u);const E=e.globeNormalizeECEF(e.globeTileBounds(n.canonical)),C=(t,i)=>t.draw(a,s.TRIANGLES,m,e.StencilMode.disabled,p,e.CullFaceMode.disabled,wi(u.projMatrix,x,x,E,0,g,u.frustumCorners.TL,u.frustumCorners.TR,u.frustumCorners.BR,u.frustumCorners.BL,u.globeCenterInViewSpace,u.globeRadius,y),"globe_pole_raster",i,b,T);i.setupElevationDraw(c,l,w),t.prepareDrawProgram(a,l,n.toUnwrapped()),_&&C(l,f),d&&(x=e.scale(e.create(),x,[1,-1,1]),C(l,v));}}}}(t,i,o,r,n);else {const a=t.context,s=a.gl;let l,c;const h=t.options.showTerrainWireframe?2:0,u=(e,i)=>{if(c===e)return;const o=[Ci[e]];i&&o.push(Ci[h]),l=t.useProgram("terrainRaster",null,o),c=e;},_=t.colorModeForRenderPass(),d=new e.DepthMode(s.LEQUAL,e.DepthMode.ReadWrite,t.depthRangeFor3D);Ei.update(n);const p=t.transform,m=6*Math.pow(1.5,22-p.zoom)*i.exaggeration();(h?[!1,!0]:[!1]).forEach((h=>{c=-1;const f=h?s.LINES:s.TRIANGLES,[g,v]=h?i.getWirefameBuffer():[i.gridIndexBuffer,i.gridSegments];for(const c of r){const r=o.getTile(c),x=e.StencilMode.disabled,y=i.prevTerrainTileForTile[c.key],b=i.terrainTileForTile[c.key];Ti(y,b)&&Ei.newMorphing(c.key,y,b,n,250),a.activeTexture.set(s.TEXTURE0),r.texture.bind(s.LINEAR,s.CLAMP_TO_EDGE,s.LINEAR_MIPMAP_NEAREST);const w=Ei.getMorphValuesForProxy(c.key),T=w?1:0;let E;w&&(E={morphing:{srcDemTile:w.from,dstDemTile:w.to,phase:e.easeCubicInOut(w.phase)}});const C=bi(c.projMatrix,Ii(c.canonical,p.renderWorldCopies)?m/10:m);u(T,h),i.setupElevationDraw(r,l,E),t.prepareDrawProgram(a,l,c.toUnwrapped()),l.draw(a,f,d,x,_,e.CullFaceMode.backCCW,C,"terrain_raster",i.gridBuffer,g,v);}}));}}(i,this,this.proxySourceCache,t,this._updateTimestamp),this.renderingToTexture=!0,i.gpuTimingDeferredRenderEnd(),t.splice(0,t.length));}renderBatch(t){if(0===this._drapedRenderBatches.length)return t+1;this.renderingToTexture=!0;const i=this.painter,o=this.painter.context,r=this.proxySourceCache,n=this.proxiedCoords[r.id],a=this._drapedRenderBatches.shift(),s=[],l=i.style.order;let c=0;for(const h of n){const n=r.getTileByID(h.proxyTileKey),u=r.proxyCachedFBO[h.key]?r.proxyCachedFBO[h.key][t]:void 0,_=void 0!==u?r.renderCache[u]:this.pool[c++],d=void 0!==u;if(n.texture=_.tex,d&&!_.dirty){s.push(n.tileID);continue}let p;o.bindFramebuffer.set(_.fb.framebuffer),this.renderedToTile=!1,_.dirty&&(o.clear({color:e.Color.transparent,stencil:0}),_.dirty=!1);for(let e=a.start;e<=a.end;++e){const t=i.style._layers[l[e]];if(t.isHidden(i.transform.zoom))continue;const r=i.style._getLayerSourceCache(t),n=r?this.proxyToSource[h.key][r.id]:[h];if(!n)continue;const a=n;o.viewport.set([0,0,_.fb.width,_.fb.height]),p!==(r?r.id:null)&&(this._setupStencil(_,n,t,r),p=r?r.id:null),i.renderLayer(i,r,t,a);}this.renderedToTile?(_.dirty=!0,s.push(n.tileID)):d||--c,5===c&&(c=0,this.renderToBackBuffer(s));}return this.renderToBackBuffer(s),this.renderingToTexture=!1,o.bindFramebuffer.set(null),o.viewport.set([0,0,i.width,i.height]),a.end+1}postRender(){}renderCacheEfficiency(e){const t=e.order.length;if(0===t)return {efficiency:100};let i,o=0,r=0,n=!1;for(let a=0;a<t;++a){const t=e._layers[e.order[a]];this._style.isLayerDraped(t)?(n&&++o,++r):n||(n=!0,i=t.id);}return 0===r?{efficiency:100}:{efficiency:100*(1-o/r),firstUndrapedLayer:i}}getMinElevationBelowMSL(){let e=0;return this._visibleDemTiles.filter((e=>e.dem)).forEach((t=>{e=Math.min(e,t.dem.tree.minimums[0]);})),0===e?e:(e-30)*this._exaggeration}raycast(e,t,i){if(!this._visibleDemTiles)return null;const o=this._visibleDemTiles.filter((e=>e.dem)).map((o=>{const r=o.tileID,n=1<<r.overscaledZ,{x:a,y:s}=r.canonical,l=a/n,c=(a+1)/n,h=s/n,u=(s+1)/n;return {minx:l,miny:h,maxx:c,maxy:u,t:o.dem.tree.raycastRoot(l,h,c,u,e,t,i),tile:o}}));o.sort(((e,t)=>(null!==e.t?e.t:Number.MAX_VALUE)-(null!==t.t?t.t:Number.MAX_VALUE)));for(const r of o){if(null==r.t)return null;const o=r.tile.dem.tree.raycast(r.minx,r.miny,r.maxx,r.maxy,e,t,i);if(null!=o)return o}return null}_createFBO(){const t=this.painter.context,i=t.gl,o=this.drapeBufferSize;t.activeTexture.set(i.TEXTURE0);const r=new e.Texture(t,{width:o[0],height:o[1],data:null},i.RGBA);r.bind(i.LINEAR,i.CLAMP_TO_EDGE);const n=t.createFramebuffer(o[0],o[1],!1);return n.colorAttachment.set(r.texture),n.depthAttachment=new Ee(t,n.framebuffer),void 0===this._sharedDepthStencil?(this._sharedDepthStencil=t.createRenderbuffer(t.gl.DEPTH_STENCIL,o[0],o[1]),this._stencilRef=0,n.depthAttachment.set(this._sharedDepthStencil),t.clear({stencil:0})):n.depthAttachment.set(this._sharedDepthStencil),t.extTextureFilterAnisotropic&&!t.extTextureFilterAnisotropicForceOff&&i.texParameterf(i.TEXTURE_2D,t.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT,t.extTextureFilterAnisotropicMax),{fb:n,tex:r,dirty:!1}}_initFBOPool(){for(;this.pool.length<Math.min(5,this.proxyCoords.length);)this.pool.push(this._createFBO());}_shouldDisableRenderCache(){if(this._style.light&&this._style.light.hasTransition())return !0;for(const e in this._style._sourceCaches)if(this._style._sourceCaches[e].hasTransition())return !0;return this._style.order.some((e=>{const t=this._style._layers[e],i=t.isHidden(this.painter.transform.zoom),o=t.getCrossfadeParameters(),r=!!o&&1!==o.t,n=t.hasTransition();return "custom"!==t.type&&!i&&(r||n)}))}_clearRasterFadeFromRenderCache(){let e=!1;for(const t in this._style._sourceCaches)if(this._style._sourceCaches[t]._source instanceof Me){e=!0;break}if(e)for(let e=0;e<this._style.order.length;++e){const t=this._style._layers[this._style.order[e]],i=t.isHidden(this.painter.transform.zoom),o=this._style._getLayerSourceCache(t);if("raster"!==t.type||i||!o)continue;const r=t.paint.get("raster-fade-duration");for(const e of this.proxyCoords){const t=this.proxyToSource[e.key][o.id];if(t)for(const e of t){const t=Si(o.getTile(e),o.findLoadedParent(e,0),o,this.painter.transform,r);(1!==t.opacity||0!==t.mix)&&this._clearRenderCacheForTile(o.id,e);}}}}_setupDrapedRenderBatches(){const e=this._style.order,t=e.length;if(0===t)return;const i=[];let o,r=0,n=this._style._layers[e[r]];for(;!this._style.isLayerDraped(n)&&n.isHidden(this.painter.transform.zoom)&&++r<t;)n=this._style._layers[e[r]];for(;r<t;++r){const t=this._style._layers[e[r]];t.isHidden(this.painter.transform.zoom)||(this._style.isLayerDraped(t)?void 0===o&&(o=r):void 0!==o&&(i.push({start:o,end:r-1}),o=void 0));}void 0!==o&&i.push({start:o,end:r-1}),this._drapedRenderBatches=i;}_setupRenderCache(e){const t=this.proxySourceCache;if(this._shouldDisableRenderCache()||this._invalidateRenderCache){if(this._invalidateRenderCache=!1,t.renderCache.length>t.renderCachePool.length){const e=Object.values(t.proxyCachedFBO);t.proxyCachedFBO={};for(let i=0;i<e.length;++i){const o=Object.values(e[i]);t.renderCachePool.push(...o);}}return}this._clearRasterFadeFromRenderCache();const i=this.proxyCoords,o=this._tilesDirty;for(let r=i.length-1;r>=0;r--){const n=i[r];if(t.getTileByID(n.key),void 0!==t.proxyCachedFBO[n.key]){const i=e[n.key],r=this.proxyToSource[n.key];let a=0;for(const e in r){const t=r[e],n=i[e];if(!n||n.length!==t.length||t.some(((t,i)=>t!==n[i]||o[e]&&o[e].hasOwnProperty(t.key)))){a=-1;break}++a;}for(const e in t.proxyCachedFBO[n.key])t.renderCache[t.proxyCachedFBO[n.key][e]].dirty=a<0||a!==Object.values(i).length;}}const r=[...this._drapedRenderBatches];r.sort(((e,t)=>t.end-t.start-(e.end-e.start)));for(const e of r)for(const o of i){if(t.proxyCachedFBO[o.key])continue;let i=t.renderCachePool.pop();void 0===i&&t.renderCache.length<50&&(i=t.renderCache.length,t.renderCache.push(this._createFBO())),void 0!==i&&(t.proxyCachedFBO[o.key]={},t.proxyCachedFBO[o.key][e.start]=i,t.renderCache[i].dirty=!0);}this._tilesDirty={};}_setupStencil(e,t,i,o){if(!o||!this._sourceTilesOverlap[o.id])return void(this._overlapStencilType&&(this._overlapStencilType=!1));const r=this.painter.context,n=r.gl;if(t.length<=1)return void(this._overlapStencilType=!1);let a;if(i.isTileClipped())a=t.length,this._overlapStencilMode.test={func:n.EQUAL,mask:255},this._overlapStencilType="Clip";else {if(!(t[0].overscaledZ>t[t.length-1].overscaledZ))return void(this._overlapStencilType=!1);a=1,this._overlapStencilMode.test={func:n.GREATER,mask:255},this._overlapStencilType="Mask";}this._stencilRef+a>255&&(r.clear({stencil:0}),this._stencilRef=0),this._stencilRef+=a,this._overlapStencilMode.ref=this._stencilRef,i.isTileClipped()&&this._renderTileClippingMasks(t,this._overlapStencilMode.ref);}clipOrMaskOverlapStencilType(){return "Clip"===this._overlapStencilType||"Mask"===this._overlapStencilType}stencilModeForRTTOverlap(t){return this.renderingToTexture&&this._overlapStencilType?("Clip"===this._overlapStencilType&&(this._overlapStencilMode.ref=this.painter._tileClippingMaskIDs[t.key]),this._overlapStencilMode):e.StencilMode.disabled}_renderTileClippingMasks(t,i){const o=this.painter,r=this.painter.context,n=r.gl;o._tileClippingMaskIDs={},r.setColorMode(e.ColorMode.disabled),r.setDepthMode(e.DepthMode.disabled);const a=o.useProgram("clippingMask");for(const s of t){const t=o._tileClippingMaskIDs[s.key]=--i;a.draw(r,n.TRIANGLES,e.DepthMode.disabled,new e.StencilMode({func:n.ALWAYS,mask:0},t,255,n.KEEP,n.KEEP,n.REPLACE),e.ColorMode.disabled,e.CullFaceMode.disabled,Mi(s.projMatrix),"$clipping",o.tileExtentBuffer,o.quadTriangleIndexBuffer,o.tileExtentSegments);}}pointCoordinate(t){const i=this.painter.transform;if(t.x<0||t.x>i.width||t.y<0||t.y>i.height)return null;const o=[t.x,t.y,1,1];e.transformMat4$1(o,o,i.pixelMatrixInverse),e.scale$1(o,o,1/o[3]),o[0]/=i.worldSize,o[1]/=i.worldSize;const r=i._camera.position,n=e.mercatorZfromAltitude(1,i.center.lat),a=[r[0],r[1],r[2]/n,0],s=e.subtract([],o.slice(0,3),a);e.normalize(s,s);const l=this.raycast(a,s,this._exaggeration);return null!==l&&l?(e.scaleAndAdd(a,a,s,l),a[3]=a[2],a[2]*=n,a):null}drawDepth(){const t=this.painter,i=t.context,o=this.proxySourceCache,r=Math.ceil(t.width),n=Math.ceil(t.height);if(!this._depthFBO||this._depthFBO.width===r&&this._depthFBO.height===n||(this._depthFBO.destroy(),this._depthFBO=void 0,this._depthTexture=void 0),!this._depthFBO){const t=i.gl,o=i.createFramebuffer(r,n,!0);i.activeTexture.set(t.TEXTURE0);const a=new e.Texture(i,{width:r,height:n,data:null},t.RGBA);a.bind(t.NEAREST,t.CLAMP_TO_EDGE),o.colorAttachment.set(a.texture);const s=i.createRenderbuffer(i.gl.DEPTH_COMPONENT16,r,n);o.depthAttachment.set(s),this._depthFBO=o,this._depthTexture=a;}i.bindFramebuffer.set(this._depthFBO.framebuffer),i.viewport.set([0,0,r,n]),function(t,i,o,r){if("globe"===t.transform.projection.name)return;const n=t.context,a=n.gl;n.clear({depth:1});const s=t.useProgram("terrainDepth"),l=new e.DepthMode(a.LESS,e.DepthMode.ReadWrite,t.depthRangeFor3D);for(const t of r){const r=o.getTile(t),c=bi(t.projMatrix,0);i.setupElevationDraw(r,s),s.draw(n,a.TRIANGLES,l,e.StencilMode.disabled,e.ColorMode.unblended,e.CullFaceMode.backCCW,c,"terrain_depth",i.gridBuffer,i.gridIndexBuffer,i.gridNoSkirtSegments);}}(t,this,o,this.proxyCoords);}_setupProxiedCoordsForOrtho(e,t,i){if(e.getSource()instanceof De)return this._setupProxiedCoordsForImageSource(e,t,i);this._findCoveringTileCache[e.id]=this._findCoveringTileCache[e.id]||{};const o=this.proxiedCoords[e.id]=[],r=this.proxyCoords;for(let t=0;t<r.length;t++){const n=r[t],a=this._findTileCoveringTileID(n,e);if(a){const t=this._createProxiedId(n,a,i[n.key]&&i[n.key][e.id]);o.push(t),this.proxyToSource[n.key][e.id]=[t];}}let n=!1;for(let r=0;r<t.length;r++){const a=e.getTile(t[r]);if(!a||!a.hasData())continue;const s=this._findTileCoveringTileID(a.tileID,this.proxySourceCache);if(s&&s.tileID.canonical.z!==a.tileID.canonical.z){const t=this.proxyToSource[s.tileID.key][e.id],r=this._createProxiedId(s.tileID,a,i[s.tileID.key]&&i[s.tileID.key][e.id]);t?t.splice(t.length-1,0,r):this.proxyToSource[s.tileID.key][e.id]=[r],o.push(r),n=!0;}}this._sourceTilesOverlap[e.id]=n;}_setupProxiedCoordsForImageSource(t,i,o){if(!t.getSource().loaded())return;const r=this.proxiedCoords[t.id]=[],n=this.proxyCoords,a=t.getSource(),s=new e.pointGeometry(a.tileID.x,a.tileID.y)._div(1<<a.tileID.z),l=a.coordinates.map(e.MercatorCoordinate.fromLngLat).reduce(((e,t)=>(e.min.x=Math.min(e.min.x,t.x-s.x),e.min.y=Math.min(e.min.y,t.y-s.y),e.max.x=Math.max(e.max.x,t.x-s.x),e.max.y=Math.max(e.max.y,t.y-s.y),e)),{min:new e.pointGeometry(Number.MAX_VALUE,Number.MAX_VALUE),max:new e.pointGeometry(-Number.MAX_VALUE,-Number.MAX_VALUE)}),c=(t,i)=>{const o=t.wrap+t.canonical.x/(1<<t.canonical.z),r=t.canonical.y/(1<<t.canonical.z),n=e.EXTENT/(1<<t.canonical.z),a=i.wrap+i.canonical.x/(1<<i.canonical.z),s=i.canonical.y/(1<<i.canonical.z);return o+n<a+l.min.x||o>a+l.max.x||r+n<s+l.min.y||r>s+l.max.y};for(let e=0;e<n.length;e++){const a=n[e];for(let e=0;e<i.length;e++){const n=t.getTile(i[e]);if(!n||!n.hasData())continue;if(c(a,n.tileID))continue;const s=this._createProxiedId(a,n,o[a.key]&&o[a.key][t.id]),l=this.proxyToSource[a.key][t.id];l?l.push(s):this.proxyToSource[a.key][t.id]=[s],r.push(s);}}}_createProxiedId(t,i,o){let r=this.orthoMatrix;if(o){const e=o.find((e=>e.key===i.tileID.key));if(e)return e}if(i.tileID.key!==t.key){const o=t.canonical.z-i.tileID.canonical.z;let n,a,s;r=e.create();const l=i.tileID.wrap-t.wrap<<t.overscaledZ;o>0?(n=e.EXTENT>>o,a=n*((i.tileID.canonical.x<<o)-t.canonical.x+l),s=n*((i.tileID.canonical.y<<o)-t.canonical.y)):(n=e.EXTENT<<-o,a=e.EXTENT*(i.tileID.canonical.x-(t.canonical.x+l<<-o)),s=e.EXTENT*(i.tileID.canonical.y-(t.canonical.y<<-o))),e.ortho(r,0,n,0,n,0,1),e.translate(r,r,[a,s,0]);}return new Pi(i.tileID,t.key,r)}_findTileCoveringTileID(t,i){let o=i.getTile(t);if(o&&o.hasData())return o;const r=this._findCoveringTileCache[i.id],n=r[t.key];if(o=n?i.getTileByID(n):null,o&&o.hasData()||null===n)return o;let a=o?o.tileID:t,s=a.overscaledZ;const l=i.getSource().minzoom,c=[];if(!n){const r=i.getSource().maxzoom;if(t.canonical.z>=r){const o=t.canonical.z-r;i.getSource().reparseOverscaled?(s=Math.max(t.canonical.z+2,i.transform.tileZoom),a=new e.OverscaledTileID(s,t.wrap,r,t.canonical.x>>o,t.canonical.y>>o)):0!==o&&(s=r,a=new e.OverscaledTileID(s,t.wrap,r,t.canonical.x>>o,t.canonical.y>>o));}a.key!==t.key&&(c.push(a.key),o=i.getTile(a));}const h=e=>{c.forEach((t=>{r[t]=e;})),c.length=0;};for(s-=1;s>=l&&(!o||!o.hasData());s--){o&&h(o.tileID.key);const e=a.calculateScaledKey(s);if(o=i.getTileByID(e),o&&o.hasData())break;const t=r[e];if(null===t)break;void 0===t?c.push(e):o=i.getTileByID(t);}return h(o?o.tileID.key:null),o&&o.hasData()?o:null}findDEMTileFor(e){return this.enabled?this._findTileCoveringTileID(e,this.sourceCache):null}prepareDrawTile(){this.renderedToTile=!0;}_clearRenderCacheForTile(e,t){let i=this._tilesDirty[e];i||(i=this._tilesDirty[e]={}),i[t.key]=!0;}getWirefameBuffer(){if(!this.wireframeSegments){const t=function(t){let i=0;const o=new e.StructArrayLayout2ui4,r=131;for(let e=1;e<129;e++){for(let t=1;t<129;t++)i=e*r+t,o.emplaceBack(i,i+1),o.emplaceBack(i,i+r),o.emplaceBack(i+1,i+r),128===e&&o.emplaceBack(i+r,i+r+1);o.emplaceBack(i+1,i+1+r);}return o}();this.wireframeIndexBuffer=this.painter.context.createIndexBuffer(t),this.wireframeSegments=e.SegmentVector.simpleSegment(0,0,this.gridBuffer.length,t.length);}return [this.wireframeIndexBuffer,this.wireframeSegments]}}class Li{static cacheKey(e,t,i,o){let r=`${t}${o?o.cacheKey:""}`;for(const t of i)e.usedDefines.includes(t)&&(r+=`/${t}`);return r}constructor(t,i,o,r,n,a){const s=t.gl;this.program=s.createProgram();const l=function(e){const t=[];for(let i=0;i<e.length;i++){if(null===e[i])continue;const o=e[i].split(" ");t.push(o.pop());}return t}(o.staticAttributes),c=r?r.getBinderAttributes():[],h=l.concat(c);let u=r?r.defines():[];u=u.concat(a.map((e=>`#define ${e}`)));const _=u.concat(t.extStandardDerivatives?"#extension GL_OES_standard_derivatives : enable\n".concat(ui):ui,ui,hi,ci.fragmentSource,si.fragmentSource,o.fragmentSource).join("\n"),d=u.concat("\n#ifdef GL_ES\nprecision highp float;\n#else\n\n#if !defined(lowp)\n#define lowp\n#endif\n\n#if !defined(mediump)\n#define mediump\n#endif\n\n#if !defined(highp)\n#define highp\n#endif\n\n#endif",hi,ci.vertexSource,si.vertexSource,ai.vertexSource,o.vertexSource).join("\n"),p=s.createShader(s.FRAGMENT_SHADER);if(s.isContextLost())return void(this.failedToCreate=!0);s.shaderSource(p,_),s.compileShader(p),s.attachShader(this.program,p);const m=s.createShader(s.VERTEX_SHADER);if(s.isContextLost())this.failedToCreate=!0;else {s.shaderSource(m,d),s.compileShader(m),s.attachShader(this.program,m),this.attributes={},this.numAttributes=h.length;for(let e=0;e<this.numAttributes;e++)h[e]&&(s.bindAttribLocation(this.program,e,h[e]),this.attributes[h[e]]=e);s.linkProgram(this.program),s.deleteShader(m),s.deleteShader(p),this.fixedUniforms=n(t),this.binderUniforms=r?r.getUniforms(t):[],-1!==a.indexOf("TERRAIN")&&(this.terrainUniforms=(t=>({u_dem:new e.Uniform1i(t),u_dem_prev:new e.Uniform1i(t),u_dem_unpack:new e.Uniform4f(t),u_dem_tl:new e.Uniform2f(t),u_dem_scale:new e.Uniform1f(t),u_dem_tl_prev:new e.Uniform2f(t),u_dem_scale_prev:new e.Uniform1f(t),u_dem_size:new e.Uniform1f(t),u_dem_lerp:new e.Uniform1f(t),u_exaggeration:new e.Uniform1f(t),u_depth:new e.Uniform1i(t),u_depth_size_inv:new e.Uniform2f(t),u_meter_to_dem:new e.Uniform1f(t),u_label_plane_matrix_inv:new e.UniformMatrix4f(t),u_tile_tl_up:new e.Uniform3f(t),u_tile_tr_up:new e.Uniform3f(t),u_tile_br_up:new e.Uniform3f(t),u_tile_bl_up:new e.Uniform3f(t),u_tile_up_scale:new e.Uniform1f(t)}))(t)),-1!==a.indexOf("FOG")&&(this.fogUniforms=(t=>({u_fog_matrix:new e.UniformMatrix4f(t),u_fog_range:new e.Uniform2f(t),u_fog_color:new e.Uniform4f(t),u_fog_horizon_blend:new e.Uniform1f(t),u_fog_temporal_offset:new e.Uniform1f(t),u_frustum_tl:new e.Uniform3f(t),u_frustum_tr:new e.Uniform3f(t),u_frustum_br:new e.Uniform3f(t),u_frustum_bl:new e.Uniform3f(t),u_globe_pos:new e.Uniform3f(t),u_globe_radius:new e.Uniform1f(t),u_globe_transition:new e.Uniform1f(t),u_is_globe:new e.Uniform1i(t),u_viewport:new e.Uniform2f(t)}))(t));}}setTerrainUniformValues(e,t){if(!this.terrainUniforms)return;const i=this.terrainUniforms;if(!this.failedToCreate){e.program.set(this.program);for(const e in t)i[e].set(this.program,e,t[e]);}}setFogUniformValues(e,t){if(!this.fogUniforms)return;const i=this.fogUniforms;if(!this.failedToCreate){e.program.set(this.program);for(const e in t)i[e].set(this.program,e,t[e]);}}draw(e,t,i,o,r,n,a,s,l,c,h,u,_,d,p){const m=e.gl;if(this.failedToCreate)return;e.program.set(this.program),e.setDepthMode(i),e.setStencilMode(o),e.setColorMode(r),e.setCullFace(n);for(const e of Object.keys(this.fixedUniforms))this.fixedUniforms[e].set(this.program,e,a[e]);d&&d.setUniforms(this.program,e,this.binderUniforms,u,{zoom:_});const f={[m.LINES]:2,[m.TRIANGLES]:3,[m.LINE_STRIP]:1}[t];for(const i of h.get()){const o=i.vaos||(i.vaos={});(o[s]||(o[s]=new mi)).bind(e,this,l,d?d.getPaintVertexBuffers():[],c,i.vertexOffset,p||[]),m.drawElements(t,i.primitiveLength*f,m.UNSIGNED_SHORT,i.primitiveOffset*f*2);}}}function Ri(e,t,i){const o=1/L(i,1,t.transform.tileZoom),r=Math.pow(2,i.tileID.overscaledZ),n=i.tileSize*Math.pow(2,t.transform.tileZoom)/r,a=n*(i.tileID.canonical.x+i.tileID.wrap*r),s=n*i.tileID.canonical.y;return {u_image:0,u_texsize:i.imageAtlasTexture.size,u_scale:[o,e.fromScale,e.toScale],u_fade:e.t,u_pixel_coord_upper:[a>>16,s>>16],u_pixel_coord_lower:[65535&a,65535&s]}}const Oi=e.create(),Bi=(t,i,o,r,n,a,s,l,c,h,u)=>{const _=i.style.light,d=_.properties.get("position"),p=[d.x,d.y,d.z],m=e.create$1();"viewport"===_.properties.get("anchor")&&(e.fromRotation(m,-i.transform.angle),e.transformMat3(p,p,m));const f=_.properties.get("color"),g=i.transform,v={u_matrix:t,u_lightpos:p,u_lightintensity:_.properties.get("intensity"),u_lightcolor:[f.r,f.g,f.b],u_vertical_gradient:+o,u_opacity:r,u_tile_id:[0,0,0],u_zoom_transition:0,u_inv_rot_matrix:Oi,u_merc_center:[0,0],u_up_dir:[0,0,0],u_height_lift:0,u_ao:n,u_edge_radius:a};return "globe"===g.projection.name&&(v.u_tile_id=[s.canonical.x,s.canonical.y,1<<s.canonical.z],v.u_zoom_transition=c,v.u_inv_rot_matrix=u,v.u_merc_center=h,v.u_up_dir=g.projection.upVector(new e.CanonicalTileID(0,0,0),h[0]*e.EXTENT,h[1]*e.EXTENT),v.u_height_lift=l),v},ki=(t,i,o,r,n,a,s,l,c,h,u,_,d)=>{const p=Bi(t,i,o,r,n,a,s,h,u,_,d),m={u_height_factor:-Math.pow(2,s.overscaledZ)/c.tileSize/8};return e.extend(p,Ri(l,i,c),m)},Fi=e=>({u_matrix:e}),Ui=(t,i,o,r)=>e.extend(Fi(t),Ri(o,i,r)),Ni=(e,t)=>({u_matrix:e,u_world:t}),Gi=(t,i,o,r,n)=>e.extend(Ui(t,i,o,r),{u_world:n}),ji=e.create(),Zi=(t,i,o,r,n,a)=>{const s=t.transform,l="globe"===s.projection.name;let c;if("map"===a.paint.get("circle-pitch-alignment"))if(l){const t=e.globePixelsToTileUnits(s.zoom,i.canonical)*s._pixelsPerMercatorPixel;c=Float32Array.from([t,0,0,t]);}else c=s.calculatePixelsToTileUnitsMatrix(o);else c=new Float32Array([s.pixelsToGLUnits[0],0,0,s.pixelsToGLUnits[1]]);const h={u_camera_to_center_distance:s.cameraToCenterDistance,u_matrix:t.translatePosMatrix(i.projMatrix,o,a.paint.get("circle-translate"),a.paint.get("circle-translate-anchor")),u_device_pixel_ratio:e.exported.devicePixelRatio,u_extrude_scale:c,u_inv_rot_matrix:ji,u_merc_center:[0,0],u_tile_id:[0,0,0],u_zoom_transition:0,u_up_dir:[0,0,0]};if(l){h.u_inv_rot_matrix=r,h.u_merc_center=n,h.u_tile_id=[i.canonical.x,i.canonical.y,1<<i.canonical.z],h.u_zoom_transition=e.globeToMercatorTransition(s.zoom);const t=n[0]*e.EXTENT,o=n[1]*e.EXTENT;h.u_up_dir=s.projection.upVector(new e.CanonicalTileID(0,0,0),t,o);}return h},Vi=e=>{const t=[];return "map"===e.paint.get("circle-pitch-alignment")&&t.push("PITCH_WITH_MAP"),"map"===e.paint.get("circle-pitch-scale")&&t.push("SCALE_WITH_MAP"),t},Wi=(t,i,o,r)=>{const n=e.EXTENT/o.tileSize;return {u_matrix:t,u_camera_to_center_distance:i.getCameraToCenterDistance(r),u_extrude_scale:[i.pixelsToGLUnits[0]/n,i.pixelsToGLUnits[1]/n]}},Xi=(e,t,i=1)=>({u_matrix:e,u_color:t,u_overlay:0,u_overlay_scale:i}),qi=e.create(),$i=(t,i,o,r,n,a,s)=>{const l=t.transform,c="globe"===l.projection.name,h=c?e.globePixelsToTileUnits(l.zoom,i.canonical)*l._pixelsPerMercatorPixel:L(o,1,a),u={u_matrix:i.projMatrix,u_extrude_scale:h,u_intensity:s,u_inv_rot_matrix:qi,u_merc_center:[0,0],u_tile_id:[0,0,0],u_zoom_transition:0,u_up_dir:[0,0,0]};if(c){u.u_inv_rot_matrix=r,u.u_merc_center=n,u.u_tile_id=[i.canonical.x,i.canonical.y,1<<i.canonical.z],u.u_zoom_transition=e.globeToMercatorTransition(l.zoom);const t=n[0]*e.EXTENT,o=n[1]*e.EXTENT;u.u_up_dir=l.projection.upVector(new e.CanonicalTileID(0,0,0),t,o);}return u},Hi=(e,t,i,o,r,n,a,s)=>{const l=e.transform,c=l.calculatePixelsToTileUnitsMatrix(t),h={u_matrix:Ji(e,t,i,r),u_pixels_to_tile_units:c,u_device_pixel_ratio:a,u_units_to_pixels:[1/l.pixelsToGLUnits[0],1/l.pixelsToGLUnits[1]],u_dash_image:0,u_gradient_image:1,u_image_height:n,u_texsize:[0,0],u_scale:[0,0,0],u_mix:0,u_alpha_discard_threshold:0,u_trim_offset:s};if(Qi(i)){const i=Ki(t,e.transform);h.u_texsize=t.lineAtlasTexture.size,h.u_scale=[i,o.fromScale,o.toScale],h.u_mix=o.t;}return h},Yi=(e,t,i,o,r,n)=>{const a=e.transform,s=Ki(t,a);return {u_matrix:Ji(e,t,i,r),u_texsize:t.imageAtlasTexture.size,u_pixels_to_tile_units:a.calculatePixelsToTileUnitsMatrix(t),u_device_pixel_ratio:n,u_image:0,u_scale:[s,o.fromScale,o.toScale],u_fade:o.t,u_units_to_pixels:[1/a.pixelsToGLUnits[0],1/a.pixelsToGLUnits[1]],u_alpha_discard_threshold:0}};function Ki(e,t){return 1/L(e,1,t.tileZoom)}function Ji(e,t,i,o){return e.translatePosMatrix(o||t.tileID.projMatrix,t,i.paint.get("line-translate"),i.paint.get("line-translate-anchor"))}function Qi(e){const t=e.paint.get("line-dasharray").value;return t.value||"constant"!==t.kind}const eo=(e,t,i,o,r,n)=>{return {u_matrix:e,u_tl_parent:t,u_scale_parent:i,u_fade_t:o.mix,u_opacity:o.opacity*r.paint.get("raster-opacity"),u_image0:0,u_image1:1,u_brightness_low:r.paint.get("raster-brightness-min"),u_brightness_high:r.paint.get("raster-brightness-max"),u_saturation_factor:(s=r.paint.get("raster-saturation"),s>0?1-1/(1.001-s):-s),u_contrast_factor:(a=r.paint.get("raster-contrast"),a>0?1/(1-a):1+a),u_spin_weights:to(r.paint.get("raster-hue-rotate")),u_perspective_transform:n};var a,s;};function to(e){e*=Math.PI/180;const t=Math.sin(e),i=Math.cos(e);return [(2*i+1)/3,(-Math.sqrt(3)*t-i+1)/3,(Math.sqrt(3)*t-i+1)/3]}const io=e.create(),oo=(t,i,o,r,n,a,s,l,c,h,u,_,d,p,m,f)=>{const g=n.transform,v={u_is_size_zoom_constant:+("constant"===t||"source"===t),u_is_size_feature_constant:+("constant"===t||"camera"===t),u_size_t:i?i.uSizeT:0,u_size:i?i.uSize:0,u_camera_to_center_distance:g.cameraToCenterDistance,u_rotate_symbol:+o,u_aspect_ratio:g.width/g.height,u_fade_change:n.options.fadeDuration?n.symbolFadeChange:1,u_matrix:a,u_label_plane_matrix:s,u_coord_matrix:l,u_is_text:+c,u_pitch_with_map:+r,u_texsize:h,u_texture:0,u_tile_id:[0,0,0],u_zoom_transition:0,u_inv_rot_matrix:io,u_merc_center:[0,0],u_camera_forward:[0,0,0],u_ecef_origin:[0,0,0],u_tile_matrix:io,u_up_vector:[0,-1,0]};return "globe"===f.name&&(v.u_tile_id=[u.canonical.x,u.canonical.y,1<<u.canonical.z],v.u_zoom_transition=_,v.u_inv_rot_matrix=p,v.u_merc_center=d,v.u_camera_forward=g._camera.forward(),v.u_ecef_origin=e.globeECEFOrigin(g.globeMatrix,u.toUnwrapped()),v.u_tile_matrix=Float32Array.from(g.globeMatrix),v.u_up_vector=m),v},ro=(t,i,o,r,n,a,s,l,c,h,u,_,d,p,m,f,g)=>e.extend(oo(t,i,o,r,n,a,s,l,c,h,_,d,p,m,f,g),{u_gamma_scale:r?n.transform.cameraToCenterDistance*Math.cos(n.terrain?0:n.transform._pitch):1,u_device_pixel_ratio:e.exported.devicePixelRatio,u_is_halo:+u}),no=(t,i,o,r,n,a,s,l,c,h,u,_,d,p,m,f)=>e.extend(ro(t,i,o,r,n,a,s,l,!0,c,!0,u,_,d,p,m,f),{u_texsize_icon:h,u_texture_icon:1}),ao=(e,t,i)=>({u_matrix:e,u_opacity:t,u_color:i}),so=(t,i,o,r,n,a)=>e.extend(function(e,t,i,o){const r=i.imageManager.getPattern(e.from.toString()),n=i.imageManager.getPattern(e.to.toString()),{width:a,height:s}=i.imageManager.getPixelSize(),l=Math.pow(2,o.tileID.overscaledZ),c=o.tileSize*Math.pow(2,i.transform.tileZoom)/l,h=c*(o.tileID.canonical.x+o.tileID.wrap*l),u=c*o.tileID.canonical.y;return {u_image:0,u_pattern_tl_a:r.tl,u_pattern_br_a:r.br,u_pattern_tl_b:n.tl,u_pattern_br_b:n.br,u_texsize:[a,s],u_mix:t.t,u_pattern_size_a:r.displaySize,u_pattern_size_b:n.displaySize,u_scale_a:t.fromScale,u_scale_b:t.toScale,u_tile_units_to_pixels:1/L(o,1,i.transform.tileZoom),u_pixel_coord_upper:[h>>16,u>>16],u_pixel_coord_lower:[65535&h,65535&u]}}(r,a,o,n),{u_matrix:t,u_opacity:i}),lo={fillExtrusion:t=>({u_matrix:new e.UniformMatrix4f(t),u_lightpos:new e.Uniform3f(t),u_lightintensity:new e.Uniform1f(t),u_lightcolor:new e.Uniform3f(t),u_vertical_gradient:new e.Uniform1f(t),u_opacity:new e.Uniform1f(t),u_edge_radius:new e.Uniform1f(t),u_ao:new e.Uniform2f(t),u_tile_id:new e.Uniform3f(t),u_zoom_transition:new e.Uniform1f(t),u_inv_rot_matrix:new e.UniformMatrix4f(t),u_merc_center:new e.Uniform2f(t),u_up_dir:new e.Uniform3f(t),u_height_lift:new e.Uniform1f(t)}),fillExtrusionPattern:t=>({u_matrix:new e.UniformMatrix4f(t),u_lightpos:new e.Uniform3f(t),u_lightintensity:new e.Uniform1f(t),u_lightcolor:new e.Uniform3f(t),u_vertical_gradient:new e.Uniform1f(t),u_height_factor:new e.Uniform1f(t),u_edge_radius:new e.Uniform1f(t),u_ao:new e.Uniform2f(t),u_tile_id:new e.Uniform3f(t),u_zoom_transition:new e.Uniform1f(t),u_inv_rot_matrix:new e.UniformMatrix4f(t),u_merc_center:new e.Uniform2f(t),u_up_dir:new e.Uniform3f(t),u_height_lift:new e.Uniform1f(t),u_image:new e.Uniform1i(t),u_texsize:new e.Uniform2f(t),u_pixel_coord_upper:new e.Uniform2f(t),u_pixel_coord_lower:new e.Uniform2f(t),u_scale:new e.Uniform3f(t),u_fade:new e.Uniform1f(t),u_opacity:new e.Uniform1f(t)}),fill:t=>({u_matrix:new e.UniformMatrix4f(t)}),fillPattern:t=>({u_matrix:new e.UniformMatrix4f(t),u_image:new e.Uniform1i(t),u_texsize:new e.Uniform2f(t),u_pixel_coord_upper:new e.Uniform2f(t),u_pixel_coord_lower:new e.Uniform2f(t),u_scale:new e.Uniform3f(t),u_fade:new e.Uniform1f(t)}),fillOutline:t=>({u_matrix:new e.UniformMatrix4f(t),u_world:new e.Uniform2f(t)}),fillOutlinePattern:t=>({u_matrix:new e.UniformMatrix4f(t),u_world:new e.Uniform2f(t),u_image:new e.Uniform1i(t),u_texsize:new e.Uniform2f(t),u_pixel_coord_upper:new e.Uniform2f(t),u_pixel_coord_lower:new e.Uniform2f(t),u_scale:new e.Uniform3f(t),u_fade:new e.Uniform1f(t)}),circle:t=>({u_camera_to_center_distance:new e.Uniform1f(t),u_extrude_scale:new e.UniformMatrix2f(t),u_device_pixel_ratio:new e.Uniform1f(t),u_matrix:new e.UniformMatrix4f(t),u_inv_rot_matrix:new e.UniformMatrix4f(t),u_merc_center:new e.Uniform2f(t),u_tile_id:new e.Uniform3f(t),u_zoom_transition:new e.Uniform1f(t),u_up_dir:new e.Uniform3f(t)}),collisionBox:t=>({u_matrix:new e.UniformMatrix4f(t),u_camera_to_center_distance:new e.Uniform1f(t),u_extrude_scale:new e.Uniform2f(t)}),collisionCircle:t=>({u_matrix:new e.UniformMatrix4f(t),u_inv_matrix:new e.UniformMatrix4f(t),u_camera_to_center_distance:new e.Uniform1f(t),u_viewport_size:new e.Uniform2f(t)}),debug:t=>({u_color:new e.UniformColor(t),u_matrix:new e.UniformMatrix4f(t),u_overlay:new e.Uniform1i(t),u_overlay_scale:new e.Uniform1f(t)}),clippingMask:t=>({u_matrix:new e.UniformMatrix4f(t)}),heatmap:t=>({u_extrude_scale:new e.Uniform1f(t),u_intensity:new e.Uniform1f(t),u_matrix:new e.UniformMatrix4f(t),u_inv_rot_matrix:new e.UniformMatrix4f(t),u_merc_center:new e.Uniform2f(t),u_tile_id:new e.Uniform3f(t),u_zoom_transition:new e.Uniform1f(t),u_up_dir:new e.Uniform3f(t)}),heatmapTexture:t=>({u_image:new e.Uniform1i(t),u_color_ramp:new e.Uniform1i(t),u_opacity:new e.Uniform1f(t)}),hillshade:t=>({u_matrix:new e.UniformMatrix4f(t),u_image:new e.Uniform1i(t),u_latrange:new e.Uniform2f(t),u_light:new e.Uniform2f(t),u_shadow:new e.UniformColor(t),u_highlight:new e.UniformColor(t),u_accent:new e.UniformColor(t)}),hillshadePrepare:t=>({u_matrix:new e.UniformMatrix4f(t),u_image:new e.Uniform1i(t),u_dimension:new e.Uniform2f(t),u_zoom:new e.Uniform1f(t),u_unpack:new e.Uniform4f(t)}),line:t=>({u_matrix:new e.UniformMatrix4f(t),u_pixels_to_tile_units:new e.UniformMatrix2f(t),u_device_pixel_ratio:new e.Uniform1f(t),u_units_to_pixels:new e.Uniform2f(t),u_dash_image:new e.Uniform1i(t),u_gradient_image:new e.Uniform1i(t),u_image_height:new e.Uniform1f(t),u_texsize:new e.Uniform2f(t),u_scale:new e.Uniform3f(t),u_mix:new e.Uniform1f(t),u_alpha_discard_threshold:new e.Uniform1f(t),u_trim_offset:new e.Uniform2f(t)}),linePattern:t=>({u_matrix:new e.UniformMatrix4f(t),u_texsize:new e.Uniform2f(t),u_pixels_to_tile_units:new e.UniformMatrix2f(t),u_device_pixel_ratio:new e.Uniform1f(t),u_image:new e.Uniform1i(t),u_units_to_pixels:new e.Uniform2f(t),u_scale:new e.Uniform3f(t),u_fade:new e.Uniform1f(t),u_alpha_discard_threshold:new e.Uniform1f(t)}),raster:t=>({u_matrix:new e.UniformMatrix4f(t),u_tl_parent:new e.Uniform2f(t),u_scale_parent:new e.Uniform1f(t),u_fade_t:new e.Uniform1f(t),u_opacity:new e.Uniform1f(t),u_image0:new e.Uniform1i(t),u_image1:new e.Uniform1i(t),u_brightness_low:new e.Uniform1f(t),u_brightness_high:new e.Uniform1f(t),u_saturation_factor:new e.Uniform1f(t),u_contrast_factor:new e.Uniform1f(t),u_spin_weights:new e.Uniform3f(t),u_perspective_transform:new e.Uniform2f(t)}),symbolIcon:t=>({u_is_size_zoom_constant:new e.Uniform1i(t),u_is_size_feature_constant:new e.Uniform1i(t),u_size_t:new e.Uniform1f(t),u_size:new e.Uniform1f(t),u_camera_to_center_distance:new e.Uniform1f(t),u_rotate_symbol:new e.Uniform1i(t),u_aspect_ratio:new e.Uniform1f(t),u_fade_change:new e.Uniform1f(t),u_matrix:new e.UniformMatrix4f(t),u_label_plane_matrix:new e.UniformMatrix4f(t),u_coord_matrix:new e.UniformMatrix4f(t),u_is_text:new e.Uniform1i(t),u_pitch_with_map:new e.Uniform1i(t),u_texsize:new e.Uniform2f(t),u_tile_id:new e.Uniform3f(t),u_zoom_transition:new e.Uniform1f(t),u_inv_rot_matrix:new e.UniformMatrix4f(t),u_merc_center:new e.Uniform2f(t),u_camera_forward:new e.Uniform3f(t),u_tile_matrix:new e.UniformMatrix4f(t),u_up_vector:new e.Uniform3f(t),u_ecef_origin:new e.Uniform3f(t),u_texture:new e.Uniform1i(t)}),symbolSDF:t=>({u_is_size_zoom_constant:new e.Uniform1i(t),u_is_size_feature_constant:new e.Uniform1i(t),u_size_t:new e.Uniform1f(t),u_size:new e.Uniform1f(t),u_camera_to_center_distance:new e.Uniform1f(t),u_rotate_symbol:new e.Uniform1i(t),u_aspect_ratio:new e.Uniform1f(t),u_fade_change:new e.Uniform1f(t),u_matrix:new e.UniformMatrix4f(t),u_label_plane_matrix:new e.UniformMatrix4f(t),u_coord_matrix:new e.UniformMatrix4f(t),u_is_text:new e.Uniform1i(t),u_pitch_with_map:new e.Uniform1i(t),u_texsize:new e.Uniform2f(t),u_texture:new e.Uniform1i(t),u_gamma_scale:new e.Uniform1f(t),u_device_pixel_ratio:new e.Uniform1f(t),u_tile_id:new e.Uniform3f(t),u_zoom_transition:new e.Uniform1f(t),u_inv_rot_matrix:new e.UniformMatrix4f(t),u_merc_center:new e.Uniform2f(t),u_camera_forward:new e.Uniform3f(t),u_tile_matrix:new e.UniformMatrix4f(t),u_up_vector:new e.Uniform3f(t),u_ecef_origin:new e.Uniform3f(t),u_is_halo:new e.Uniform1i(t)}),symbolTextAndIcon:t=>({u_is_size_zoom_constant:new e.Uniform1i(t),u_is_size_feature_constant:new e.Uniform1i(t),u_size_t:new e.Uniform1f(t),u_size:new e.Uniform1f(t),u_camera_to_center_distance:new e.Uniform1f(t),u_rotate_symbol:new e.Uniform1i(t),u_aspect_ratio:new e.Uniform1f(t),u_fade_change:new e.Uniform1f(t),u_matrix:new e.UniformMatrix4f(t),u_label_plane_matrix:new e.UniformMatrix4f(t),u_coord_matrix:new e.UniformMatrix4f(t),u_is_text:new e.Uniform1i(t),u_pitch_with_map:new e.Uniform1i(t),u_texsize:new e.Uniform2f(t),u_texsize_icon:new e.Uniform2f(t),u_texture:new e.Uniform1i(t),u_texture_icon:new e.Uniform1i(t),u_gamma_scale:new e.Uniform1f(t),u_device_pixel_ratio:new e.Uniform1f(t),u_is_halo:new e.Uniform1i(t)}),background:t=>({u_matrix:new e.UniformMatrix4f(t),u_opacity:new e.Uniform1f(t),u_color:new e.UniformColor(t)}),backgroundPattern:t=>({u_matrix:new e.UniformMatrix4f(t),u_opacity:new e.Uniform1f(t),u_image:new e.Uniform1i(t),u_pattern_tl_a:new e.Uniform2f(t),u_pattern_br_a:new e.Uniform2f(t),u_pattern_tl_b:new e.Uniform2f(t),u_pattern_br_b:new e.Uniform2f(t),u_texsize:new e.Uniform2f(t),u_mix:new e.Uniform1f(t),u_pattern_size_a:new e.Uniform2f(t),u_pattern_size_b:new e.Uniform2f(t),u_scale_a:new e.Uniform1f(t),u_scale_b:new e.Uniform1f(t),u_pixel_coord_upper:new e.Uniform2f(t),u_pixel_coord_lower:new e.Uniform2f(t),u_tile_units_to_pixels:new e.Uniform1f(t)}),terrainRaster:yi,terrainDepth:yi,skybox:t=>({u_matrix:new e.UniformMatrix4f(t),u_sun_direction:new e.Uniform3f(t),u_cubemap:new e.Uniform1i(t),u_opacity:new e.Uniform1f(t),u_temporal_offset:new e.Uniform1f(t)}),skyboxGradient:t=>({u_matrix:new e.UniformMatrix4f(t),u_color_ramp:new e.Uniform1i(t),u_center_direction:new e.Uniform3f(t),u_radius:new e.Uniform1f(t),u_opacity:new e.Uniform1f(t),u_temporal_offset:new e.Uniform1f(t)}),skyboxCapture:t=>({u_matrix_3f:new e.UniformMatrix3f(t),u_sun_direction:new e.Uniform3f(t),u_sun_intensity:new e.Uniform1f(t),u_color_tint_r:new e.Uniform4f(t),u_color_tint_m:new e.Uniform4f(t),u_luminance:new e.Uniform1f(t)}),globeRaster:t=>({u_proj_matrix:new e.UniformMatrix4f(t),u_globe_matrix:new e.UniformMatrix4f(t),u_normalize_matrix:new e.UniformMatrix4f(t),u_merc_matrix:new e.UniformMatrix4f(t),u_zoom_transition:new e.Uniform1f(t),u_merc_center:new e.Uniform2f(t),u_image0:new e.Uniform1i(t),u_grid_matrix:new e.UniformMatrix3f(t),u_frustum_tl:new e.Uniform3f(t),u_frustum_tr:new e.Uniform3f(t),u_frustum_br:new e.Uniform3f(t),u_frustum_bl:new e.Uniform3f(t),u_globe_pos:new e.Uniform3f(t),u_globe_radius:new e.Uniform1f(t),u_viewport:new e.Uniform2f(t)}),globeAtmosphere:t=>({u_frustum_tl:new e.Uniform3f(t),u_frustum_tr:new e.Uniform3f(t),u_frustum_br:new e.Uniform3f(t),u_frustum_bl:new e.Uniform3f(t),u_horizon:new e.Uniform1f(t),u_transition:new e.Uniform1f(t),u_fadeout_range:new e.Uniform1f(t),u_color:new e.Uniform4f(t),u_high_color:new e.Uniform4f(t),u_space_color:new e.Uniform4f(t),u_star_intensity:new e.Uniform1f(t),u_star_density:new e.Uniform1f(t),u_star_size:new e.Uniform1f(t),u_temporal_offset:new e.Uniform1f(t),u_horizon_angle:new e.Uniform1f(t),u_rotation_matrix:new e.UniformMatrix4f(t)})};let co;function ho(t,i,o,r,n,a,s){const l=t.context,c=l.gl,h=t.transform,u=t.useProgram("collisionBox"),_=[];let d=0,p=0;for(let m=0;m<r.length;m++){const f=r[m],g=i.getTile(f),v=g.getBucket(o);if(!v)continue;const x=bt(f,v,h);let y=x;0===n[0]&&0===n[1]||(y=t.translatePosMatrix(x,g,n,a));const b=s?v.textCollisionBox:v.iconCollisionBox,w=v.collisionCircleArray;if(w.length>0){const t=e.create(),i=y;e.mul(t,v.placementInvProjMatrix,h.glCoordMatrix),e.mul(t,t,v.placementViewportMatrix),_.push({circleArray:w,circleOffset:p,transform:i,invTransform:t,projection:v.getProjection()}),d+=w.length/4,p=d;}b&&(t.terrain&&t.terrain.setupElevationDraw(g,u),u.draw(l,c.LINES,e.DepthMode.disabled,e.StencilMode.disabled,t.colorModeForRenderPass(),e.CullFaceMode.disabled,Wi(y,h,g,v.getProjection()),o.id,b.layoutVertexBuffer,b.indexBuffer,b.segments,null,h.zoom,null,[b.collisionVertexBuffer,b.collisionVertexBufferExt]));}if(!s||!_.length)return;const m=t.useProgram("collisionCircle"),f=new e.StructArrayLayout2f1f2i16;f.resize(4*d),f._trim();let g=0;for(const e of _)for(let t=0;t<e.circleArray.length/4;t++){const i=4*t,o=e.circleArray[i+0],r=e.circleArray[i+1],n=e.circleArray[i+2],a=e.circleArray[i+3];f.emplace(g++,o,r,n,a,0),f.emplace(g++,o,r,n,a,1),f.emplace(g++,o,r,n,a,2),f.emplace(g++,o,r,n,a,3);}(!co||co.length<2*d)&&(co=function(t){const i=2*t,o=new e.StructArrayLayout3ui6;o.resize(i),o._trim();for(let e=0;e<i;e++){const t=6*e;o.uint16[t+0]=4*e+0,o.uint16[t+1]=4*e+1,o.uint16[t+2]=4*e+2,o.uint16[t+3]=4*e+2,o.uint16[t+4]=4*e+3,o.uint16[t+5]=4*e+0;}return o}(d));const v=l.createIndexBuffer(co,!0),x=l.createVertexBuffer(f,e.collisionCircleLayout.members,!0);for(const i of _){const r={u_matrix:i.transform,u_inv_matrix:i.invTransform,u_camera_to_center_distance:(y=h).getCameraToCenterDistance(i.projection),u_viewport_size:[y.width,y.height]};m.draw(l,c.TRIANGLES,e.DepthMode.disabled,e.StencilMode.disabled,t.colorModeForRenderPass(),e.CullFaceMode.disabled,r,o.id,x,v,e.SegmentVector.simpleSegment(0,2*i.circleOffset,i.circleArray.length,i.circleArray.length/2),null,h.zoom);}var y;x.destroy(),v.destroy();}const uo=e.create();function _o(t,i,o,r,n,a){const{horizontalAlign:s,verticalAlign:l}=e.getAnchorAlignment(t),c=-(s-.5)*i,h=-(l-.5)*o,u=e.evaluateVariableOffset(t,r);return new e.pointGeometry((c/n+u[0])*a,(h/n+u[1])*a)}function po(t,i,o,r,n,a,s,l,c,h,u){const _=t.text.placedSymbolArray,d=t.text.dynamicLayoutVertexArray,p=t.icon.dynamicLayoutVertexArray,m={},f=wt(l,t.getProjection(),a),g=a.elevation,v=t.getProjection().upVectorScale(l.canonical,a.center.lat,a.worldSize);d.clear();for(let p=0;p<_.length;p++){const x=_.get(p),y=t.allowVerticalPlacement&&!x.placedOrientation,b=x.hidden||!x.crossTileID||y?null:r[x.crossTileID];if(b){const r=new e.pointGeometry(x.tileAnchorX,x.tileAnchorY),_=t.getProjection().upVector(l.canonical,r.x,r.y),p=g?g.getAtTileOffset(l,r.x,r.y):0,y=nt([x.projectedAnchorX+p*_[0]*v.metersToTile,x.projectedAnchorY+p*_[1]*v.metersToTile,x.projectedAnchorZ+p*_[2]*v.metersToTile],o?f:s),w=at(a.getCameraToCenterDistance(t.getProjection()),y.signedDistanceFromCamera);let T=n.evaluateSizeForFeature(t.textSizeData,h,x)*w/e.ONE_EM;o&&(T*=t.tilePixelRatio/c);const{width:E,height:C,anchor:I,textOffset:M,textScale:S}=b,z=_o(I,E,C,M,S,T);let D;if(o){const e=r.add(z),{x:i,y:o,z:n}=t.getProjection().projectTilePoint(e.x,e.y,l.canonical);D=nt([i+p*_[0]*v.metersToTile,o+p*_[1]*v.metersToTile,n+p*_[2]*v.metersToTile],s).point;}else {const e=i?z.rotate(-a.angle):z;D=[y.point[0]+e.x,y.point[1]+e.y,0];}const P=t.allowVerticalPlacement&&x.placedOrientation===e.WritingMode.vertical?Math.PI/2:0;for(let t=0;t<x.numGlyphs;t++)e.addDynamicAttributes(d,D[0],D[1],D[2],P);u&&x.associatedIconIndex>=0&&(m[x.associatedIconIndex]={shiftedAnchor:D,angle:P});}else ft(x.numGlyphs,d);}if(u){p.clear();const i=t.icon.placedSymbolArray;for(let t=0;t<i.length;t++){const o=i.get(t);if(o.hidden)ft(o.numGlyphs,p);else {const i=m[t];if(i)for(let t=0;t<o.numGlyphs;t++)e.addDynamicAttributes(p,i.shiftedAnchor[0],i.shiftedAnchor[1],i.shiftedAnchor[2],i.angle);else ft(o.numGlyphs,p);}}t.icon.dynamicLayoutVertexBuffer.updateData(p);}t.text.dynamicLayoutVertexBuffer.updateData(d);}function mo(e,t,i){return i.iconsInText&&t?"symbolTextAndIcon":e?"symbolSDF":"symbolIcon"}function fo(t,i,o,r,n,a,s,l,c,h,u,_){const d=t.context,p=d.gl,m=t.transform,f="map"===l,g="map"===c,v=f&&"point"!==o.layout.get("symbol-placement"),x=f&&!g&&!v,y=void 0!==o.layout.get("symbol-sort-key").constantOr(1);let b=!1;const w=t.depthModeForSublayer(0,e.DepthMode.ReadOnly),T=[e.mercatorXfromLng(m.center.lng),e.mercatorYfromLat(m.center.lat)],E=o.layout.get("text-variable-anchor"),C="globe"===m.projection.name,I=[],M=[0,-1,0];let S=M;!C&&!m.mercatorFromTransition||f||(S=function(t){const i=t._camera.getWorldToCamera(t.worldSize,1),o=e.multiply([],i,t.globeMatrix);e.invert(o,o);const r=[0,0,0],n=[0,1,0,0];return e.transformMat4$1(n,n,o),r[0]=n[0],r[1]=n[1],r[2]=n[2],e.normalize(r,r),r}(m));for(const l of r){const r=i.getTile(l),c=r.getBucket(o);if(!c)continue;if("mercator"===c.projection.name&&C)continue;const u=n?c.text:c.icon;if(!u||c.fullyClipped||!u.segments.get().length)continue;const _=u.programConfigurations.get(o.id),d=n||c.sdfIcons,w=n?c.textSizeData:c.iconSizeData,z=g||0!==m.pitch,D=e.evaluateSizeForZoom(w,m.zoom);let P,A,L,R,O=[0,0],B=null;if(n){if(A=r.glyphAtlasTexture,L=p.LINEAR,P=r.glyphAtlasTexture.size,c.iconsInText){O=r.imageAtlasTexture.size,B=r.imageAtlasTexture;const e="composite"===w.kind||"camera"===w.kind;R=z||t.options.rotating||t.options.zooming||e?p.LINEAR:p.NEAREST;}}else {const e=1!==o.layout.get("icon-size").constantOr(0)||c.iconsNeedLinear;A=r.imageAtlasTexture,L=d||t.options.rotating||t.options.zooming||e||z?p.LINEAR:p.NEAREST,P=r.imageAtlasTexture.size;}const k="globe"===c.projection.name,F=k?S:M,U=k?e.globeToMercatorTransition(m.zoom):0,N=wt(l,c.getProjection(),m),G=m.calculatePixelsToTileUnitsMatrix(r),j=tt(N,r.tileID.canonical,g,f,m,c.getProjection(),G),Z=t.terrain&&g&&v?e.invert(e.create(),j):uo,V=ot(N,r.tileID.canonical,g,f,m,c.getProjection(),G),W=E&&c.hasTextData(),X="none"!==o.layout.get("icon-text-fit")&&W&&c.hasIconData();if(v){const e=m.elevation,i=e?e.getAtTileOffsetFunc(l,m.center.lat,m.worldSize,c.getProjection()):e=>[0,0,0],o=it(N,r.tileID.canonical,g,f,m,c.getProjection(),G);lt(c,N,t,n,o,V,g,h,i,l);}const q=v||n&&E||X,$=t.translatePosMatrix(N,r,a,s),H=q?uo:j,Y=t.translatePosMatrix(V,r,a,s,!0),K=c.getProjection().createInversionMatrix(m,l.canonical),J=[];t.terrain&&g&&J.push("PITCH_WITH_MAP_TERRAIN"),k&&J.push("PROJECTION_GLOBE_VIEW"),q&&J.push("PROJECTED_POS_ON_VIEWPORT");const Q=d&&0!==o.paint.get(n?"text-halo-width":"icon-halo-width").constantOr(1);let ee;ee=d?c.iconsInText?no(w.kind,D,x,g,t,$,H,Y,P,O,l,U,T,K,F,c.getProjection()):ro(w.kind,D,x,g,t,$,H,Y,n,P,!0,l,U,T,K,F,c.getProjection()):oo(w.kind,D,x,g,t,$,H,Y,n,P,l,U,T,K,F,c.getProjection());const te={program:t.useProgram(mo(d,n,c),_,J),buffers:u,uniformValues:ee,atlasTexture:A,atlasTextureIcon:B,atlasInterpolation:L,atlasInterpolationIcon:R,isSDF:d,hasHalo:Q,tile:r,labelPlaneMatrixInv:Z};if(y&&c.canOverlap){b=!0;const t=u.segments.get();for(const i of t)I.push({segments:new e.SegmentVector([i]),sortKey:i.sortKey,state:te});}else I.push({segments:u.segments,sortKey:0,state:te});}b&&I.sort(((e,t)=>e.sortKey-t.sortKey));for(const e of I){const i=e.state;if(t.terrain&&t.terrain.setupElevationDraw(i.tile,i.program,{useDepthForOcclusion:!C,labelPlaneMatrixInv:i.labelPlaneMatrixInv}),d.activeTexture.set(p.TEXTURE0),i.atlasTexture.bind(i.atlasInterpolation,p.CLAMP_TO_EDGE),i.atlasTextureIcon&&(d.activeTexture.set(p.TEXTURE1),i.atlasTextureIcon&&i.atlasTextureIcon.bind(i.atlasInterpolationIcon,p.CLAMP_TO_EDGE)),i.isSDF){const r=i.uniformValues;i.hasHalo&&(r.u_is_halo=1,go(i.buffers,e.segments,o,t,i.program,w,u,_,r)),r.u_is_halo=0;}go(i.buffers,e.segments,o,t,i.program,w,u,_,i.uniformValues);}}function go(t,i,o,r,n,a,s,l,c){const h=r.context,u=[t.dynamicLayoutVertexBuffer,t.opacityVertexBuffer,t.globeExtVertexBuffer];n.draw(h,h.gl.TRIANGLES,a,s,l,e.CullFaceMode.disabled,c,o.id,t.layoutVertexBuffer,t.indexBuffer,i,o.paint,r.transform.zoom,t.programConfigurations.get(o.id),u);}function vo(t,i,o,r,n,a,s){const l=t.context.gl,c=o.paint.get("fill-pattern"),h=c&&c.constantOr(1),u=o.getCrossfadeParameters();let _,d,p,m,f;s?(d=h&&!o.getPaintProperty("fill-outline-color")?"fillOutlinePattern":"fillOutline",_=l.LINES):(d=h?"fillPattern":"fill",_=l.TRIANGLES);for(const g of r){const r=i.getTile(g);if(h&&!r.patternsLoaded())continue;const v=r.getBucket(o);if(!v)continue;t.prepareDrawTile();const x=v.programConfigurations.get(o.id),y=t.useProgram(d,x);h&&(t.context.activeTexture.set(l.TEXTURE0),r.imageAtlasTexture.bind(l.LINEAR,l.CLAMP_TO_EDGE),x.updatePaintBuffers(u));const b=c.constantOr(null);if(b&&r.imageAtlas){const e=r.imageAtlas,t=e.patternPositions[b.to.toString()],i=e.patternPositions[b.from.toString()];t&&i&&x.setConstantPatternPositions(t,i);}const w=t.translatePosMatrix(g.projMatrix,r,o.paint.get("fill-translate"),o.paint.get("fill-translate-anchor"));if(s){m=v.indexBuffer2,f=v.segments2;const e=t.terrain&&t.terrain.renderingToTexture?t.terrain.drapeBufferSize:[l.drawingBufferWidth,l.drawingBufferHeight];p="fillOutlinePattern"===d&&h?Gi(w,t,u,r,e):Ni(w,e);}else m=v.indexBuffer,f=v.segments,p=h?Ui(w,t,u,r):Fi(w);t.prepareDrawProgram(t.context,y,g.toUnwrapped()),y.draw(t.context,_,n,t.stencilModeForClipping(g),a,e.CullFaceMode.disabled,p,o.id,v.layoutVertexBuffer,m,f,o.paint,t.transform.zoom,x);}}function xo(t,i,o,r,n,a,s){const l=t.context,c=l.gl,h=t.transform,u=o.paint.get("fill-extrusion-pattern"),_=u.constantOr(1),d=o.getCrossfadeParameters(),p=o.paint.get("fill-extrusion-opacity"),m=[o.paint.get("fill-extrusion-ambient-occlusion-intensity"),o.paint.get("fill-extrusion-ambient-occlusion-radius")],f=o.layout.get("fill-extrusion-edge-radius"),g="globe"===h.projection.name?e.fillExtrusionHeightLift():0,v="globe"===h.projection.name,x=v?e.globeToMercatorTransition(h.zoom):0,y=[e.mercatorXfromLng(h.center.lng),e.mercatorYfromLat(h.center.lat)],b=[];v&&(b.push("PROJECTION_GLOBE_VIEW"),t.style.terrainSetForDrapingOnly()&&b.push("TERRAIN")),m[0]>0&&b.push("FAUX_AO");for(const w of r){const r=i.getTile(w),T=r.getBucket(o);if(!T||T.projection.name!==h.projection.name)continue;const E=T.programConfigurations.get(o.id),C=t.useProgram(_?"fillExtrusionPattern":"fillExtrusion",E,b);if(t.terrain){const e=t.terrain;if(t.style.terrainSetForDrapingOnly())e.setupElevationDraw(r,C,{useMeterToDem:!0});else {if(!T.enableTerrain)continue;if(e.setupElevationDraw(r,C,{useMeterToDem:!0}),yo(l,i,w,T,o,e),!T.centroidVertexBuffer){const e=C.attributes.a_centroid_pos;void 0!==e&&c.vertexAttrib2f(e,0,0);}}}_&&(t.context.activeTexture.set(c.TEXTURE0),r.imageAtlasTexture.bind(c.LINEAR,c.CLAMP_TO_EDGE),E.updatePaintBuffers(d));const I=u.constantOr(null);if(I&&r.imageAtlas){const e=r.imageAtlas,t=e.patternPositions[I.to.toString()],i=e.patternPositions[I.from.toString()];t&&i&&E.setConstantPatternPositions(t,i);}const M=t.translatePosMatrix(w.projMatrix,r,o.paint.get("fill-extrusion-translate"),o.paint.get("fill-extrusion-translate-anchor")),S=h.projection.createInversionMatrix(h,w.canonical),z=o.paint.get("fill-extrusion-vertical-gradient"),D=_?ki(M,t,z,p,m,f,w,d,r,g,x,y,S):Bi(M,t,z,p,m,f,w,g,x,y,S);t.prepareDrawProgram(l,C,w.toUnwrapped());const P=[];t.terrain&&P.push(T.centroidVertexBuffer),v&&P.push(T.layoutVertexExtBuffer),C.draw(l,l.gl.TRIANGLES,n,a,s,e.CullFaceMode.backCCW,D,o.id,T.layoutVertexBuffer,T.indexBuffer,T.segments,o.paint,t.transform.zoom,E,P);}}function yo(t,i,o,r,n,a){const s=[t=>{let i=t.canonical.x-1,o=t.wrap;return i<0&&(i=(1<<t.canonical.z)-1,o--),new e.OverscaledTileID(t.overscaledZ,o,t.canonical.z,i,t.canonical.y)},t=>{let i=t.canonical.x+1,o=t.wrap;return i===1<<t.canonical.z&&(i=0,o++),new e.OverscaledTileID(t.overscaledZ,o,t.canonical.z,i,t.canonical.y)},t=>new e.OverscaledTileID(t.overscaledZ,t.wrap,t.canonical.z,t.canonical.x,(0===t.canonical.y?1<<t.canonical.z:t.canonical.y)-1),t=>new e.OverscaledTileID(t.overscaledZ,t.wrap,t.canonical.z,t.canonical.x,t.canonical.y===(1<<t.canonical.z)-1?0:t.canonical.y+1)],l=e=>{const t=i.getSource().minzoom,o=e=>{const t=i.getTileByID(e);if(t&&t.hasData())return t.getBucket(n)},r=[0,-1,1];for(const i of r){if(e.overscaledZ+i<t)continue;const r=o(e.calculateScaledKey(e.overscaledZ+i));if(r)return r}},c=[0,0,0],h=(t,i)=>(c[0]=Math.min(t.min.y,i.min.y),c[1]=Math.max(t.max.y,i.max.y),c[2]=e.EXTENT-i.min.x>t.max.x?i.min.x-e.EXTENT:t.max.x,c),u=(t,i)=>(c[0]=Math.min(t.min.x,i.min.x),c[1]=Math.max(t.max.x,i.max.x),c[2]=e.EXTENT-i.min.y>t.max.y?i.min.y-e.EXTENT:t.max.y,c),_=[(e,t)=>h(e,t),(e,t)=>h(t,e),(e,t)=>u(e,t),(e,t)=>u(t,e)],d=new e.pointGeometry(0,0);let p,m,f;const g=(t,i,r,n,s)=>{const l=[[n?r:t,n?t:r,0],[n?r:i,n?i:r,0]],c=s<0?e.EXTENT+s:s,h=[n?c:(t+i)/2,n?(t+i)/2:c,0];return 0===r&&s<0||0!==r&&s>0?a.getForTilePoints(f,[h],!0,m):l.push(h),a.getForTilePoints(o,l,!0,p),Math.max(l[0][2],l[1][2],h[2])/a.exaggeration()};for(let t=0;t<4;t++){const i=(t<2?1:5)-t,n=r.borders[t];if(0===n.length)continue;const c=f=s[t](o),h=l(c);if(!(h&&h instanceof e.FillExtrusionBucket&&h.enableTerrain))continue;if(r.borderDoneWithNeighborZ[t]===h.canonical.z&&h.borderDoneWithNeighborZ[i]===r.canonical.z)continue;if(m=a.findDEMTileFor(c),!m||!m.dem)continue;if(!p){const e=a.findDEMTileFor(o);if(!e||!e.dem)return;p=e;}const u=h.borders[i];let v=0;const x=h.borderDoneWithNeighborZ[i]!==r.canonical.z;if(r.canonical.z===h.canonical.z){for(let o=0;o<n.length;o++){const a=r.featuresOnBorder[n[o]],s=a.borders[t];let l;for(;v<u.length&&(l=h.featuresOnBorder[u[v]],!(l.borders[i][1]>s[0]+3));)x&&h.encodeCentroid(void 0,l,!1),v++;if(l&&v<u.length){const o=v;let n=0;for(;!(l.borders[i][0]>s[1]-3)&&(n++,++v!==u.length);)l=h.featuresOnBorder[u[v]];if(l=h.featuresOnBorder[u[o]],a.intersectsCount()>1||l.intersectsCount()>1||1!==n){1!==n&&(v=o),r.encodeCentroid(void 0,a,!1),x&&h.encodeCentroid(void 0,l,!1);continue}const c=_[t](a,l),p=t%2?e.EXTENT-1:0;d.x=g(c[0],Math.min(e.EXTENT-1,c[1]),p,t<2,c[2]),d.y=0,r.encodeCentroid(d,a,!1),x&&h.encodeCentroid(d,l,!1);}else r.encodeCentroid(void 0,a,!1);}r.borderDoneWithNeighborZ[t]=h.canonical.z,r.needsCentroidUpdate=!0,x&&(h.borderDoneWithNeighborZ[i]=r.canonical.z,h.needsCentroidUpdate=!0);}else {for(const e of n)r.encodeCentroid(void 0,r.featuresOnBorder[e],!1);if(x){for(const e of u)h.encodeCentroid(void 0,h.featuresOnBorder[e],!1);h.borderDoneWithNeighborZ[i]=r.canonical.z,h.needsCentroidUpdate=!0;}r.borderDoneWithNeighborZ[t]=h.canonical.z,r.needsCentroidUpdate=!0;}}(r.needsCentroidUpdate||!r.centroidVertexBuffer&&0!==r.centroidVertexArray.length)&&r.uploadCentroid(t);}const bo=new e.Color(1,0,0,1),wo=new e.Color(0,1,0,1),To=new e.Color(0,0,1,1),Eo=new e.Color(1,0,1,1),Co=new e.Color(0,1,1,1);function Io(t,i,o){const r=t.context,n=t.transform,a=r.gl,s="globe"===n.projection.name,l=s?["PROJECTION_GLOBE_VIEW"]:null;let c=o.projMatrix;if(s&&e.globeToMercatorTransition(n.zoom)>0){const t=e.transitionTileAABBinECEF(o.canonical,n),i=e.globeDenormalizeECEF(t);c=e.multiply(new Float32Array(16),n.globeMatrix,i),e.multiply(c,n.projMatrix,c);}const h=t.useProgram("debug",null,l),u=i.getTileByID(o.key);t.terrain&&t.terrain.setupElevationDraw(u,h);const _=e.DepthMode.disabled,d=e.StencilMode.disabled,p=t.colorModeForRenderPass(),m="$debug";r.activeTexture.set(a.TEXTURE0),t.emptyTexture.bind(a.LINEAR,a.CLAMP_TO_EDGE),s?u._makeGlobeTileDebugBuffers(t.context,n):u._makeDebugTileBoundsBuffers(t.context,n.projection);const f=u._tileDebugBuffer||t.debugBuffer,g=u._tileDebugIndexBuffer||t.debugIndexBuffer,v=u._tileDebugSegments||t.debugSegments;h.draw(r,a.LINE_STRIP,_,d,p,e.CullFaceMode.disabled,Xi(c,e.Color.red),m,f,g,v,null,null,null,[u._globeTileDebugBorderBuffer]);const x=u.latestRawTileData,y=Math.floor((x&&x.byteLength||0)/1024),b=i.getTile(o).tileSize,w=512/Math.min(b,512)*(o.overscaledZ/n.zoom)*.5;let T=o.canonical.toString();o.overscaledZ!==o.canonical.z&&(T+=` => ${o.overscaledZ}`),T+=` ${y}kb`,function(e,t){e.initDebugOverlayCanvas();const i=e.debugOverlayCanvas,o=e.context.gl,r=e.debugOverlayCanvas.getContext("2d");r.clearRect(0,0,i.width,i.height),r.shadowColor="white",r.shadowBlur=2,r.lineWidth=1.5,r.strokeStyle="white",r.textBaseline="top",r.font="bold 36px Open Sans, sans-serif",r.fillText(t,5,5),r.strokeText(t,5,5),e.debugOverlayTexture.update(i),e.debugOverlayTexture.bind(o.LINEAR,o.CLAMP_TO_EDGE);}(t,T);const E=u._tileDebugTextBuffer||t.debugBuffer,C=u._tileDebugTextIndexBuffer||t.quadTriangleIndexBuffer,I=u._tileDebugTextSegments||t.debugSegments;h.draw(r,a.TRIANGLES,_,d,e.ColorMode.alphaBlended,e.CullFaceMode.disabled,Xi(c,e.Color.transparent,w),m,E,C,I,null,null,null,[u._globeTileDebugTextBuffer]);}function Mo(e,t,i,o){zo(e,0,t+i/2,e.transform.width,i,o);}function So(e,t,i,o){zo(e,t-i/2,0,i,e.transform.height,o);}function zo(t,i,o,r,n,a){const s=t.context,l=s.gl;l.enable(l.SCISSOR_TEST),l.scissor(i*e.exported.devicePixelRatio,o*e.exported.devicePixelRatio,r*e.exported.devicePixelRatio,n*e.exported.devicePixelRatio),s.clear({color:a}),l.disable(l.SCISSOR_TEST);}const Do=e.createLayout([{name:"a_pos_3f",components:3,type:"Float32"}]),{members:Po}=Do;function Ao(e,t,i,o){e.emplaceBack(t,i,o);}class Lo{constructor(t){this.vertexArray=new e.StructArrayLayout3f12,this.indices=new e.StructArrayLayout3ui6,Ao(this.vertexArray,-1,-1,1),Ao(this.vertexArray,1,-1,1),Ao(this.vertexArray,-1,1,1),Ao(this.vertexArray,1,1,1),Ao(this.vertexArray,-1,-1,-1),Ao(this.vertexArray,1,-1,-1),Ao(this.vertexArray,-1,1,-1),Ao(this.vertexArray,1,1,-1),this.indices.emplaceBack(5,1,3),this.indices.emplaceBack(3,7,5),this.indices.emplaceBack(6,2,0),this.indices.emplaceBack(0,4,6),this.indices.emplaceBack(2,6,7),this.indices.emplaceBack(7,3,2),this.indices.emplaceBack(5,4,0),this.indices.emplaceBack(0,1,5),this.indices.emplaceBack(0,2,3),this.indices.emplaceBack(3,1,0),this.indices.emplaceBack(7,6,4),this.indices.emplaceBack(4,5,7),this.vertexBuffer=t.createVertexBuffer(this.vertexArray,Po),this.indexBuffer=t.createIndexBuffer(this.indices),this.segment=e.SegmentVector.simpleSegment(0,0,36,12);}}function Ro(t,i,o,r,n,a){const s=t.gl,l=i.paint.get("sky-atmosphere-color"),c=i.paint.get("sky-atmosphere-halo-color"),h=i.paint.get("sky-atmosphere-sun-intensity"),u=((e,t,i,o,r)=>({u_matrix_3f:e,u_sun_direction:t,u_sun_intensity:i,u_color_tint_r:[o.r,o.g,o.b,o.a],u_color_tint_m:[r.r,r.g,r.b,r.a],u_luminance:5e-5}))(e.fromMat4(e.create$1(),r),n,h,l,c);s.framebufferTexture2D(s.FRAMEBUFFER,s.COLOR_ATTACHMENT0,s.TEXTURE_CUBE_MAP_POSITIVE_X+a,i.skyboxTexture,0),o.draw(t,s.TRIANGLES,e.DepthMode.disabled,e.StencilMode.disabled,e.ColorMode.unblended,e.CullFaceMode.frontCW,u,"skyboxCapture",i.skyboxGeometry.vertexBuffer,i.skyboxGeometry.indexBuffer,i.skyboxGeometry.segment);}const Oo=e.createLayout([{type:"Float32",name:"a_pos",components:3},{type:"Float32",name:"a_uv",components:2}]);class Bo{constructor(t){const i=new e.StructArrayLayout5f20;i.emplaceBack(-1,1,1,0,0),i.emplaceBack(1,1,1,1,0),i.emplaceBack(1,-1,1,1,1),i.emplaceBack(-1,-1,1,0,1);const o=new e.StructArrayLayout3ui6;o.emplaceBack(0,1,2),o.emplaceBack(2,3,0),this.vertexBuffer=t.createVertexBuffer(i,Oo.members),this.indexBuffer=t.createIndexBuffer(o),this.segments=e.SegmentVector.simpleSegment(0,0,4,2);}destroy(){this.vertexBuffer.destroy(),this.indexBuffer.destroy(),this.segments.destroy();}}const ko={symbol:function(t,i,o,r,n){if("translucent"!==t.renderPass)return;const a=e.StencilMode.disabled,s=t.colorModeForRenderPass();o.layout.get("text-variable-anchor")&&function(t,i,o,r,n,a,s){const l=i.transform,c="map"===n,h="map"===a;for(const i of t){const t=r.getTile(i),n=t.getBucket(o);if(!n||!n.text||!n.text.segments.get().length)continue;const a=e.evaluateSizeForZoom(n.textSizeData,l.zoom),u=wt(i,n.getProjection(),l),_=l.calculatePixelsToTileUnitsMatrix(t),d=tt(u,t.tileID.canonical,h,c,l,n.getProjection(),_),p="none"!==o.layout.get("icon-text-fit")&&n.hasIconData();if(a){const o=Math.pow(2,l.zoom-t.tileID.overscaledZ);po(n,c,h,s,e.symbolSize,l,d,i,o,a,p);}}}(r,t,o,i,o.layout.get("text-rotation-alignment"),o.layout.get("text-pitch-alignment"),n),0!==o.paint.get("icon-opacity").constantOr(1)&&fo(t,i,o,r,!1,o.paint.get("icon-translate"),o.paint.get("icon-translate-anchor"),o.layout.get("icon-rotation-alignment"),o.layout.get("icon-pitch-alignment"),o.layout.get("icon-keep-upright"),a,s),0!==o.paint.get("text-opacity").constantOr(1)&&fo(t,i,o,r,!0,o.paint.get("text-translate"),o.paint.get("text-translate-anchor"),o.layout.get("text-rotation-alignment"),o.layout.get("text-pitch-alignment"),o.layout.get("text-keep-upright"),a,s),i.map.showCollisionBoxes&&(ho(t,i,o,r,o.paint.get("text-translate"),o.paint.get("text-translate-anchor"),!0),ho(t,i,o,r,o.paint.get("icon-translate"),o.paint.get("icon-translate-anchor"),!1));},circle:function(t,i,o,r){if("translucent"!==t.renderPass)return;const n=o.paint.get("circle-opacity"),a=o.paint.get("circle-stroke-width"),s=o.paint.get("circle-stroke-opacity"),l=void 0!==o.layout.get("circle-sort-key").constantOr(1);if(0===n.constantOr(1)&&(0===a.constantOr(1)||0===s.constantOr(1)))return;const c=t.context,h=c.gl,u=t.transform,_=t.depthModeForSublayer(0,e.DepthMode.ReadOnly),d=e.StencilMode.disabled,p=t.colorModeForRenderPass(),m="globe"===u.projection.name,f=[e.mercatorXfromLng(u.center.lng),e.mercatorYfromLat(u.center.lat)],g=[];for(let n=0;n<r.length;n++){const a=r[n],s=i.getTile(a),c=s.getBucket(o);if(!c||c.projection.name!==u.projection.name)continue;const h=c.programConfigurations.get(o.id),_=Vi(o);m&&_.push("PROJECTION_GLOBE_VIEW");const d=t.useProgram("circle",h,_),p=c.layoutVertexBuffer,v=c.globeExtVertexBuffer,x=c.indexBuffer,y=u.projection.createInversionMatrix(u,a.canonical),b={programConfiguration:h,program:d,layoutVertexBuffer:p,globeExtVertexBuffer:v,indexBuffer:x,uniformValues:Zi(t,a,s,y,f,o),tile:s};if(l){const t=c.segments.get();for(const i of t)g.push({segments:new e.SegmentVector([i]),sortKey:i.sortKey,state:b});}else g.push({segments:c.segments,sortKey:0,state:b});}l&&g.sort(((e,t)=>e.sortKey-t.sortKey));const v={useDepthForOcclusion:!m};for(const i of g){const{programConfiguration:r,program:n,layoutVertexBuffer:a,globeExtVertexBuffer:s,indexBuffer:l,uniformValues:m,tile:f}=i.state,g=i.segments;t.terrain&&t.terrain.setupElevationDraw(f,n,v),t.prepareDrawProgram(c,n,f.tileID.toUnwrapped()),n.draw(c,h.TRIANGLES,_,d,p,e.CullFaceMode.disabled,m,o.id,a,l,g,o.paint,u.zoom,r,[s]);}},heatmap:function(t,i,o,r){if(0!==o.paint.get("heatmap-opacity"))if("offscreen"===t.renderPass){const n=t.context,a=n.gl,s=e.StencilMode.disabled,l=new e.ColorMode([a.ONE,a.ONE],e.Color.transparent,[!0,!0,!0,!0]);!function(e,t,i,o){const r=e.gl,n=t.width*o,a=t.height*o;e.activeTexture.set(r.TEXTURE1),e.viewport.set([0,0,n,a]);let s=i.heatmapFbo;if(!s||s&&(s.width!==n||s.height!==a)){s&&s.destroy();const t=r.createTexture();r.bindTexture(r.TEXTURE_2D,t),r.texParameteri(r.TEXTURE_2D,r.TEXTURE_WRAP_S,r.CLAMP_TO_EDGE),r.texParameteri(r.TEXTURE_2D,r.TEXTURE_WRAP_T,r.CLAMP_TO_EDGE),r.texParameteri(r.TEXTURE_2D,r.TEXTURE_MIN_FILTER,r.LINEAR),r.texParameteri(r.TEXTURE_2D,r.TEXTURE_MAG_FILTER,r.LINEAR),s=i.heatmapFbo=e.createFramebuffer(n,a,!1),function(e,t,i,o,r,n){const a=e.gl;a.texImage2D(a.TEXTURE_2D,0,a.RGBA,r,n,0,a.RGBA,e.extRenderToTextureHalfFloat?e.extTextureHalfFloat.HALF_FLOAT_OES:a.UNSIGNED_BYTE,null),o.colorAttachment.set(i);}(e,0,t,s,n,a);}else r.bindTexture(r.TEXTURE_2D,s.colorAttachment.get()),e.bindFramebuffer.set(s.framebuffer);}(n,t,o,"globe"===t.transform.projection.name?.5:.25),n.clear({color:e.Color.transparent});const c=t.transform,h="globe"===c.projection.name,u=h?["PROJECTION_GLOBE_VIEW"]:null,_=h?e.CullFaceMode.frontCCW:e.CullFaceMode.disabled,d=[e.mercatorXfromLng(c.center.lng),e.mercatorYfromLat(c.center.lat)];for(let p=0;p<r.length;p++){const m=r[p];if(i.hasRenderableParent(m))continue;const f=i.getTile(m),g=f.getBucket(o);if(!g||g.projection.name!==c.projection.name)continue;const v=g.programConfigurations.get(o.id),x=t.useProgram("heatmap",v,u),{zoom:y}=t.transform;t.terrain&&t.terrain.setupElevationDraw(f,x),t.prepareDrawProgram(n,x,m.toUnwrapped());const b=c.projection.createInversionMatrix(c,m.canonical);x.draw(n,a.TRIANGLES,e.DepthMode.disabled,s,l,_,$i(t,m,f,b,d,y,o.paint.get("heatmap-intensity")),o.id,g.layoutVertexBuffer,g.indexBuffer,g.segments,o.paint,t.transform.zoom,v,h?[g.globeExtVertexBuffer]:null);}n.viewport.set([0,0,t.width,t.height]);}else "translucent"===t.renderPass&&(t.context.setColorMode(t.colorModeForRenderPass()),function(t,i){const o=t.context,r=o.gl,n=i.heatmapFbo;if(!n)return;o.activeTexture.set(r.TEXTURE0),r.bindTexture(r.TEXTURE_2D,n.colorAttachment.get()),o.activeTexture.set(r.TEXTURE1);let a=i.colorRampTexture;a||(a=i.colorRampTexture=new e.Texture(o,i.colorRamp,r.RGBA)),a.bind(r.LINEAR,r.CLAMP_TO_EDGE),t.useProgram("heatmapTexture").draw(o,r.TRIANGLES,e.DepthMode.disabled,e.StencilMode.disabled,t.colorModeForRenderPass(),e.CullFaceMode.disabled,((e,t,i,o)=>({u_image:0,u_color_ramp:1,u_opacity:t.paint.get("heatmap-opacity")}))(0,i),i.id,t.viewportBuffer,t.quadTriangleIndexBuffer,t.viewportSegments,i.paint,t.transform.zoom);}(t,o));},line:function(t,i,o,r){if("translucent"!==t.renderPass)return;const n=o.paint.get("line-opacity"),a=o.paint.get("line-width");if(0===n.constantOr(1)||0===a.constantOr(1))return;const s=t.depthModeForSublayer(0,e.DepthMode.ReadOnly),l=t.colorModeForRenderPass(),c=t.terrain&&t.terrain.renderingToTexture?1:e.exported.devicePixelRatio,h=o.paint.get("line-dasharray"),u=h.constantOr(1),_=o.layout.get("line-cap"),d=o.paint.get("line-pattern"),p=d.constantOr(1),m=o.paint.get("line-gradient"),f=o.getCrossfadeParameters(),g=p?"linePattern":"line",v=t.context,x=v.gl,y=(e=>{const t=[];Qi(e)&&t.push("RENDER_LINE_DASH"),e.paint.get("line-gradient")&&t.push("RENDER_LINE_GRADIENT");const i=e.paint.get("line-trim-offset");0===i[0]&&0===i[1]||t.push("RENDER_LINE_TRIM_OFFSET");const o=e.paint.get("line-pattern").constantOr(1),r=1!==e.paint.get("line-opacity").constantOr(1);return !o&&r&&t.push("RENDER_LINE_ALPHA_DISCARD"),t})(o);let b=y.includes("RENDER_LINE_ALPHA_DISCARD");t.terrain&&t.terrain.clipOrMaskOverlapStencilType()&&(b=!1);for(const n of r){const r=i.getTile(n);if(p&&!r.patternsLoaded())continue;const a=r.getBucket(o);if(!a)continue;t.prepareDrawTile();const w=a.programConfigurations.get(o.id),T=t.useProgram(g,w,y),E=d.constantOr(null);if(E&&r.imageAtlas){const e=r.imageAtlas,t=e.patternPositions[E.to.toString()],i=e.patternPositions[E.from.toString()];t&&i&&w.setConstantPatternPositions(t,i);}const C=h.constantOr(null),I=_.constantOr(null);if(!p&&C&&I&&r.lineAtlas){const e=r.lineAtlas,t=e.getDash(C.to,I),i=e.getDash(C.from,I);t&&i&&w.setConstantPatternPositions(t,i);}let[M,S]=o.paint.get("line-trim-offset");if("round"===I||"square"===I){const e=1;M!==S&&(0===M&&(M-=e),1===S&&(S+=e));}const z=t.terrain?n.projMatrix:null,D=p?Yi(t,r,o,f,z,c):Hi(t,r,o,f,z,a.lineClipsArray.length,c,[M,S]);if(m){const r=a.gradients[o.id];let s=r.texture;if(o.gradientVersion!==r.version){let l=256;if(o.stepInterpolant){const o=i.getSource().maxzoom,r=n.canonical.z===o?Math.ceil(1<<t.transform.maxZoom-n.canonical.z):1;l=e.clamp(e.nextPowerOfTwo(a.maxLineLength/e.EXTENT*1024*r),256,v.maxTextureSize);}r.gradient=e.renderColorRamp({expression:o.gradientExpression(),evaluationKey:"lineProgress",resolution:l,image:r.gradient||void 0,clips:a.lineClipsArray}),r.texture?r.texture.update(r.gradient):r.texture=new e.Texture(v,r.gradient,x.RGBA),r.version=o.gradientVersion,s=r.texture;}v.activeTexture.set(x.TEXTURE1),s.bind(o.stepInterpolant?x.NEAREST:x.LINEAR,x.CLAMP_TO_EDGE);}u&&(v.activeTexture.set(x.TEXTURE0),r.lineAtlasTexture.bind(x.LINEAR,x.REPEAT),w.updatePaintBuffers(f)),p&&(v.activeTexture.set(x.TEXTURE0),r.imageAtlasTexture.bind(x.LINEAR,x.CLAMP_TO_EDGE),w.updatePaintBuffers(f)),t.prepareDrawProgram(v,T,n.toUnwrapped());const P=i=>{T.draw(v,x.TRIANGLES,s,i,l,e.CullFaceMode.disabled,D,o.id,a.layoutVertexBuffer,a.indexBuffer,a.segments,o.paint,t.transform.zoom,w,[a.layoutVertexBuffer2]);};if(b){const i=t.stencilModeForClipping(n).ref;0===i&&t.terrain&&v.clear({stencil:0});const o={func:x.EQUAL,mask:255};D.u_alpha_discard_threshold=.8,P(new e.StencilMode(o,i,255,x.KEEP,x.KEEP,x.INVERT)),D.u_alpha_discard_threshold=0,P(new e.StencilMode(o,i,255,x.KEEP,x.KEEP,x.KEEP));}else P(t.stencilModeForClipping(n));}b&&(t.resetStencilClippingMasks(),t.terrain&&v.clear({stencil:0}));},fill:function(t,i,o,r){const n=o.paint.get("fill-color"),a=o.paint.get("fill-opacity");if(0===a.constantOr(1))return;const s=t.colorModeForRenderPass(),l=o.paint.get("fill-pattern"),c=t.opaquePassEnabledForLayer()&&!l.constantOr(1)&&1===n.constantOr(e.Color.transparent).a&&1===a.constantOr(0)?"opaque":"translucent";if(t.renderPass===c){const n=t.depthModeForSublayer(1,"opaque"===t.renderPass?e.DepthMode.ReadWrite:e.DepthMode.ReadOnly);vo(t,i,o,r,n,s,!1);}if("translucent"===t.renderPass&&o.paint.get("fill-antialias")){const n=t.depthModeForSublayer(o.getPaintProperty("fill-outline-color")?2:0,e.DepthMode.ReadOnly);vo(t,i,o,r,n,s,!0);}},"fill-extrusion":function(t,i,o,r){const n=o.paint.get("fill-extrusion-opacity");if(0!==n&&"translucent"===t.renderPass){const a=new e.DepthMode(t.context.gl.LEQUAL,e.DepthMode.ReadWrite,t.depthRangeFor3D);if(1!==n||o.paint.get("fill-extrusion-pattern").constantOr(1))xo(t,i,o,r,a,e.StencilMode.disabled,e.ColorMode.disabled),xo(t,i,o,r,a,t.stencilModeFor3D(),t.colorModeForRenderPass()),t.resetStencilClippingMasks();else {const n=t.colorModeForRenderPass();xo(t,i,o,r,a,e.StencilMode.disabled,n);}}},hillshade:function(t,i,o,r){if("offscreen"!==t.renderPass&&"translucent"!==t.renderPass)return;const n=t.context,a=t.depthModeForSublayer(0,e.DepthMode.ReadOnly),s=t.colorModeForRenderPass(),l=t.terrain&&t.terrain.renderingToTexture,[c,h]="translucent"!==t.renderPass||l?[{},r]:t.stencilConfigForOverlap(r);for(const r of h){const n=i.getTile(r);if(n.needsHillshadePrepare&&"offscreen"===t.renderPass)xi(t,n,o,a,e.StencilMode.disabled,s);else if("translucent"===t.renderPass){const e=l&&t.terrain?t.terrain.stencilModeForRTTOverlap(r):c[r.overscaledZ];gi(t,r,n,o,a,e,s);}}n.viewport.set([0,0,t.width,t.height]),t.resetStencilClippingMasks();},raster:function(t,i,o,r,n,a){if("translucent"!==t.renderPass)return;if(0===o.paint.get("raster-opacity"))return;if(!r.length)return;const s=t.context,l=s.gl,c=i.getSource(),h=t.useProgram("raster"),u=t.colorModeForRenderPass(),_=t.terrain&&t.terrain.renderingToTexture,[d,p]=c instanceof De||_?[{},r]:t.stencilConfigForOverlap(r),m=p[p.length-1].overscaledZ,f=!t.options.moving;for(const r of p){const n=_?e.DepthMode.disabled:t.depthModeForSublayer(r.overscaledZ-m,1===o.paint.get("raster-opacity")?e.DepthMode.ReadWrite:e.DepthMode.ReadOnly,l.LESS),p=r.toUnwrapped(),g=i.getTile(r);if(_&&(!g||!g.hasData()))continue;const v=_?r.projMatrix:t.transform.calculateProjMatrix(p,f),x=t.terrain&&_?t.terrain.stencilModeForRTTOverlap(r):d[r.overscaledZ],y=a?0:o.paint.get("raster-fade-duration");g.registerFadeDuration(y);const b=i.findLoadedParent(r,0),w=Si(g,b,i,t.transform,y);let T,E;t.terrain&&t.terrain.prepareDrawTile();const C="nearest"===o.paint.get("raster-resampling")?l.NEAREST:l.LINEAR;s.activeTexture.set(l.TEXTURE0),g.texture.bind(C,l.CLAMP_TO_EDGE),s.activeTexture.set(l.TEXTURE1),b?(b.texture.bind(C,l.CLAMP_TO_EDGE),T=Math.pow(2,b.tileID.overscaledZ-g.tileID.overscaledZ),E=[g.tileID.canonical.x*T%1,g.tileID.canonical.y*T%1]):g.texture.bind(C,l.CLAMP_TO_EDGE);const I=eo(v,E||[0,0],T||1,w,o,c instanceof De?c.perspectiveTransform:[0,0]);if(t.prepareDrawProgram(s,h,p),c instanceof De)c.boundsBuffer&&c.boundsSegments&&h.draw(s,l.TRIANGLES,n,e.StencilMode.disabled,u,e.CullFaceMode.disabled,I,o.id,c.boundsBuffer,t.quadTriangleIndexBuffer,c.boundsSegments);else {const{tileBoundsBuffer:i,tileBoundsIndexBuffer:r,tileBoundsSegments:a}=t.getTileBoundsBuffers(g);h.draw(s,l.TRIANGLES,n,x,u,e.CullFaceMode.disabled,I,o.id,i,r,a);}}t.resetStencilClippingMasks();},background:function(t,i,o,r){const n=o.paint.get("background-color"),a=o.paint.get("background-opacity");if(0===a)return;const s=t.context,l=s.gl,c=t.transform,h=c.tileSize,u=o.paint.get("background-pattern");if(t.isPatternMissing(u))return;const _=!u&&1===n.a&&1===a&&t.opaquePassEnabledForLayer()?"opaque":"translucent";if(t.renderPass!==_)return;const d=e.StencilMode.disabled,p=t.depthModeForSublayer(0,"opaque"===_?e.DepthMode.ReadWrite:e.DepthMode.ReadOnly),m=t.colorModeForRenderPass(),f=t.useProgram(u?"backgroundPattern":"background");let g,v=r;v||(g=t.getBackgroundTiles(),v=Object.values(g).map((e=>e.tileID))),u&&(s.activeTexture.set(l.TEXTURE0),t.imageManager.bind(t.context));const x=o.getCrossfadeParameters();for(const _ of v){const v=_.toUnwrapped(),y=r?_.projMatrix:t.transform.calculateProjMatrix(v);t.prepareDrawTile();const b=i?i.getTile(_):g?g[_.key]:new e.Tile(_,h,c.zoom,t),w=u?so(y,a,t,u,{tileID:_,tileSize:h},x):ao(y,a,n);t.prepareDrawProgram(s,f,v);const{tileBoundsBuffer:T,tileBoundsIndexBuffer:E,tileBoundsSegments:C}=t.getTileBoundsBuffers(b);f.draw(s,l.TRIANGLES,p,d,m,e.CullFaceMode.disabled,w,o.id,T,E,C);}},sky:function(t,i,o){const r=t.transform,n="mercator"===r.projection.name||"globe"===r.projection.name?1:e.smoothstep(7,8,r.zoom),a=o.paint.get("sky-opacity")*n;if(0===a)return;const s=t.context,l=o.paint.get("sky-type"),c=new e.DepthMode(s.gl.LEQUAL,e.DepthMode.ReadOnly,[0,1]),h=t.frameCounter/1e3%1;"atmosphere"===l?"offscreen"===t.renderPass?o.needsSkyboxCapture(t)&&(function(t,i,o,r){const n=t.context,a=n.gl;let s=i.skyboxFbo;if(!s){s=i.skyboxFbo=n.createFramebuffer(32,32,!1),i.skyboxGeometry=new Lo(n),i.skyboxTexture=n.gl.createTexture(),a.bindTexture(a.TEXTURE_CUBE_MAP,i.skyboxTexture),a.texParameteri(a.TEXTURE_CUBE_MAP,a.TEXTURE_WRAP_S,a.CLAMP_TO_EDGE),a.texParameteri(a.TEXTURE_CUBE_MAP,a.TEXTURE_WRAP_T,a.CLAMP_TO_EDGE),a.texParameteri(a.TEXTURE_CUBE_MAP,a.TEXTURE_MIN_FILTER,a.LINEAR),a.texParameteri(a.TEXTURE_CUBE_MAP,a.TEXTURE_MAG_FILTER,a.LINEAR);for(let e=0;e<6;++e)a.texImage2D(a.TEXTURE_CUBE_MAP_POSITIVE_X+e,0,a.RGBA,32,32,0,a.RGBA,a.UNSIGNED_BYTE,null);}n.bindFramebuffer.set(s.framebuffer),n.viewport.set([0,0,32,32]);const l=i.getCenter(t,!0),c=t.useProgram("skyboxCapture"),h=new Float64Array(16);e.identity(h),e.rotateY(h,h,.5*-Math.PI),Ro(n,i,c,h,l,0),e.identity(h),e.rotateY(h,h,.5*Math.PI),Ro(n,i,c,h,l,1),e.identity(h),e.rotateX(h,h,.5*-Math.PI),Ro(n,i,c,h,l,2),e.identity(h),e.rotateX(h,h,.5*Math.PI),Ro(n,i,c,h,l,3),e.identity(h),Ro(n,i,c,h,l,4),e.identity(h),e.rotateY(h,h,Math.PI),Ro(n,i,c,h,l,5),n.viewport.set([0,0,t.width,t.height]);}(t,o),o.markSkyboxValid(t)):"sky"===t.renderPass&&function(t,i,o,r,n){const a=t.context,s=a.gl,l=t.transform,c=t.useProgram("skybox");a.activeTexture.set(s.TEXTURE0),s.bindTexture(s.TEXTURE_CUBE_MAP,i.skyboxTexture);const h=((e,t,i,o,r)=>({u_matrix:e,u_sun_direction:t,u_cubemap:0,u_opacity:o,u_temporal_offset:r}))(l.skyboxMatrix,i.getCenter(t,!1),0,r,n);t.prepareDrawProgram(a,c),c.draw(a,s.TRIANGLES,o,e.StencilMode.disabled,t.colorModeForRenderPass(),e.CullFaceMode.backCW,h,"skybox",i.skyboxGeometry.vertexBuffer,i.skyboxGeometry.indexBuffer,i.skyboxGeometry.segment);}(t,o,c,a,h):"gradient"===l&&"sky"===t.renderPass&&function(t,i,o,r,n){const a=t.context,s=a.gl,l=t.transform,c=t.useProgram("skyboxGradient");i.skyboxGeometry||(i.skyboxGeometry=new Lo(a)),a.activeTexture.set(s.TEXTURE0);let h=i.colorRampTexture;h||(h=i.colorRampTexture=new e.Texture(a,i.colorRamp,s.RGBA)),h.bind(s.LINEAR,s.CLAMP_TO_EDGE);const u=((t,i,o,r,n)=>({u_matrix:t,u_color_ramp:0,u_center_direction:i,u_radius:e.degToRad(o),u_opacity:r,u_temporal_offset:n}))(l.skyboxMatrix,i.getCenter(t,!1),i.paint.get("sky-gradient-radius"),r,n);t.prepareDrawProgram(a,c),c.draw(a,s.TRIANGLES,o,e.StencilMode.disabled,t.colorModeForRenderPass(),e.CullFaceMode.backCW,u,"skyboxGradient",i.skyboxGeometry.vertexBuffer,i.skyboxGeometry.indexBuffer,i.skyboxGeometry.segment);}(t,o,c,a,h);},debug:function(e,t,i){for(let o=0;o<i.length;o++)Io(e,t,i[o]);},custom:function(t,i,o){const r=t.context,n=o.implementation;if(t.transform.projection.unsupportedLayers&&t.transform.projection.unsupportedLayers.includes("custom"))e.warnOnce("Custom layers are not yet supported with non-mercator projections. Use mercator to enable custom layers.");else if("offscreen"===t.renderPass){const e=n.prerender;e&&(t.setCustomLayerDefaults(),r.setColorMode(t.colorModeForRenderPass()),e.call(n,r.gl,t.transform.customLayerMatrix()),r.setDirty(),t.setBaseState());}else if("translucent"===t.renderPass){t.setCustomLayerDefaults(),r.setColorMode(t.colorModeForRenderPass()),r.setStencilMode(e.StencilMode.disabled);const i="3d"===n.renderingMode?new e.DepthMode(t.context.gl.LEQUAL,e.DepthMode.ReadWrite,t.depthRangeFor3D):t.depthModeForSublayer(0,e.DepthMode.ReadOnly);r.setDepthMode(i),n.render(r.gl,t.transform.customLayerMatrix()),r.setDirty(),t.setBaseState(),r.bindFramebuffer.set(null);}}};class Fo{constructor(t,i){this.context=new Ie(t),this.transform=i,this._tileTextures={},this.frameCopies=[],this.loadTimeStamps=[],this.setup(),this.numSublayers=e.SourceCache.maxUnderzooming+e.SourceCache.maxOverzooming+1,this.depthEpsilon=1/Math.pow(2,16),this.crossTileSymbolIndex=new $t,this.deferredRenderGpuTimeQueries=[],this.gpuTimers={},this.frameCounter=0,this._backgroundTiles={};}updateTerrain(e,t){const i=!!e&&!!e.terrain&&this.transform.projection.supportsTerrain;if(!(i||this._terrain&&this._terrain.enabled))return;this._terrain||(this._terrain=new Ai(this,e));const o=this._terrain;this.transform.elevation=i?o:null,o.update(e,this.transform,t);}_updateFog(e){const t=e.fog;if(!t||"globe"===this.transform.projection.name||t.getOpacity(this.transform.pitch)<1||t.properties.get("horizon-blend")<.03)return void(this.transform.fogCullDistSq=null);const[i,o]=t.getFovAdjustedRange(this.transform._fov);if(i>o)return void(this.transform.fogCullDistSq=null);const r=i+.78*(o-i);this.transform.fogCullDistSq=r*r;}get terrain(){return this.transform._terrainEnabled()&&this._terrain&&this._terrain.enabled?this._terrain:null}resize(t,i){if(this.width=t*e.exported.devicePixelRatio,this.height=i*e.exported.devicePixelRatio,this.context.viewport.set([0,0,this.width,this.height]),this.style)for(const e of this.style.order)this.style._layers[e].resize();}setup(){const t=this.context,i=new e.StructArrayLayout2i4;i.emplaceBack(0,0),i.emplaceBack(e.EXTENT,0),i.emplaceBack(0,e.EXTENT),i.emplaceBack(e.EXTENT,e.EXTENT),this.tileExtentBuffer=t.createVertexBuffer(i,e.posAttributes.members),this.tileExtentSegments=e.SegmentVector.simpleSegment(0,0,4,2);const o=new e.StructArrayLayout2i4;o.emplaceBack(0,0),o.emplaceBack(e.EXTENT,0),o.emplaceBack(0,e.EXTENT),o.emplaceBack(e.EXTENT,e.EXTENT),this.debugBuffer=t.createVertexBuffer(o,e.posAttributes.members),this.debugSegments=e.SegmentVector.simpleSegment(0,0,4,5);const r=new e.StructArrayLayout2i4;r.emplaceBack(-1,-1),r.emplaceBack(1,-1),r.emplaceBack(-1,1),r.emplaceBack(1,1),this.viewportBuffer=t.createVertexBuffer(r,e.posAttributes.members),this.viewportSegments=e.SegmentVector.simpleSegment(0,0,4,2);const n=new e.StructArrayLayout4i8;n.emplaceBack(0,0,0,0),n.emplaceBack(e.EXTENT,0,e.EXTENT,0),n.emplaceBack(0,e.EXTENT,0,e.EXTENT),n.emplaceBack(e.EXTENT,e.EXTENT,e.EXTENT,e.EXTENT),this.mercatorBoundsBuffer=t.createVertexBuffer(n,e.boundsAttributes.members),this.mercatorBoundsSegments=e.SegmentVector.simpleSegment(0,0,4,2);const a=new e.StructArrayLayout3ui6;a.emplaceBack(0,1,2),a.emplaceBack(2,1,3),this.quadTriangleIndexBuffer=t.createIndexBuffer(a);const s=new e.StructArrayLayout1ui2;for(const e of [0,1,3,2,0])s.emplaceBack(e);this.debugIndexBuffer=t.createIndexBuffer(s),this.emptyTexture=new e.Texture(t,new e.RGBAImage({width:1,height:1},Uint8Array.of(0,0,0,0)),t.gl.RGBA),this.identityMat=e.create();const l=this.context.gl;this.stencilClearMode=new e.StencilMode({func:l.ALWAYS,mask:0},0,255,l.ZERO,l.ZERO,l.ZERO),this.loadTimeStamps.push(e.window.performance.now()),this.atmosphereBuffer=new Bo(this.context);}getMercatorTileBoundsBuffers(){return {tileBoundsBuffer:this.mercatorBoundsBuffer,tileBoundsIndexBuffer:this.quadTriangleIndexBuffer,tileBoundsSegments:this.mercatorBoundsSegments}}getTileBoundsBuffers(e){return e._makeTileBoundsBuffers(this.context,this.transform.projection),e._tileBoundsBuffer?{tileBoundsBuffer:e._tileBoundsBuffer,tileBoundsIndexBuffer:e._tileBoundsIndexBuffer,tileBoundsSegments:e._tileBoundsSegments}:this.getMercatorTileBoundsBuffers()}clearStencil(){const t=this.context,i=t.gl;this.nextStencilID=1,this.currentStencilSource=void 0,this._tileClippingMaskIDs={},this.useProgram("clippingMask").draw(t,i.TRIANGLES,e.DepthMode.disabled,this.stencilClearMode,e.ColorMode.disabled,e.CullFaceMode.disabled,Mi(this.identityMat),"$clipping",this.viewportBuffer,this.quadTriangleIndexBuffer,this.viewportSegments);}resetStencilClippingMasks(){this.terrain||(this.currentStencilSource=void 0,this._tileClippingMaskIDs={});}_renderTileClippingMasks(t,i,o){if(!i||this.currentStencilSource===i.id||!t.isTileClipped()||!o||0===o.length)return;if(this._tileClippingMaskIDs&&!this.terrain){let e=!1;for(const t of o)if(void 0===this._tileClippingMaskIDs[t.key]){e=!0;break}if(!e)return}this.currentStencilSource=i.id;const r=this.context,n=r.gl;this.nextStencilID+o.length>256&&this.clearStencil(),r.setColorMode(e.ColorMode.disabled),r.setDepthMode(e.DepthMode.disabled);const a=this.useProgram("clippingMask");this._tileClippingMaskIDs={};for(const t of o){const o=i.getTile(t),s=this._tileClippingMaskIDs[t.key]=this.nextStencilID++,{tileBoundsBuffer:l,tileBoundsIndexBuffer:c,tileBoundsSegments:h}=this.getTileBoundsBuffers(o);a.draw(r,n.TRIANGLES,e.DepthMode.disabled,new e.StencilMode({func:n.ALWAYS,mask:0},s,255,n.KEEP,n.KEEP,n.REPLACE),e.ColorMode.disabled,e.CullFaceMode.disabled,Mi(t.projMatrix),"$clipping",l,c,h);}}stencilModeFor3D(){this.currentStencilSource=void 0,this.nextStencilID+1>256&&this.clearStencil();const t=this.nextStencilID++,i=this.context.gl;return new e.StencilMode({func:i.NOTEQUAL,mask:255},t,255,i.KEEP,i.KEEP,i.REPLACE)}stencilModeForClipping(t){if(this.terrain)return this.terrain.stencilModeForRTTOverlap(t);const i=this.context.gl;return new e.StencilMode({func:i.EQUAL,mask:255},this._tileClippingMaskIDs[t.key],0,i.KEEP,i.KEEP,i.REPLACE)}stencilConfigForOverlap(t){const i=this.context.gl,o=t.sort(((e,t)=>t.overscaledZ-e.overscaledZ)),r=o[o.length-1].overscaledZ,n=o[0].overscaledZ-r+1;if(n>1){this.currentStencilSource=void 0,this.nextStencilID+n>256&&this.clearStencil();const t={};for(let o=0;o<n;o++)t[o+r]=new e.StencilMode({func:i.GEQUAL,mask:255},o+this.nextStencilID,255,i.KEEP,i.KEEP,i.REPLACE);return this.nextStencilID+=n,[t,o]}return [{[r]:e.StencilMode.disabled},o]}colorModeForRenderPass(){const t=this.context.gl;if(this._showOverdrawInspector){const i=1/8;return new e.ColorMode([t.CONSTANT_COLOR,t.ONE],new e.Color(i,i,i,0),[!0,!0,!0,!0])}return "opaque"===this.renderPass?e.ColorMode.unblended:e.ColorMode.alphaBlended}depthModeForSublayer(t,i,o){if(!this.opaquePassEnabledForLayer())return e.DepthMode.disabled;const r=1-((1+this.currentLayer)*this.numSublayers+t)*this.depthEpsilon;return new e.DepthMode(o||this.context.gl.LEQUAL,i,[r,r])}opaquePassEnabledForLayer(){return this.currentLayer<this.opaquePassCutoff}render(t,i){this.style=t,this.options=i,this.lineAtlas=t.lineAtlas,this.imageManager=t.imageManager,this.glyphManager=t.glyphManager,this.symbolFadeChange=t.placement.symbolFadeChange(e.exported.now()),this.imageManager.beginFrame();const o=this.style.order,r=this.style._sourceCaches;for(const e in r){const t=r[e];t.used&&t.prepare(this.context);}const n={},a={},s={};for(const e in r){const t=r[e];n[e]=t.getVisibleCoordinates(),a[e]=n[e].slice().reverse(),s[e]=t.getVisibleCoordinates(!0).reverse();}this.opaquePassCutoff=1/0;for(let e=0;e<o.length;e++)if(this.style._layers[o[e]].is3D()){this.opaquePassCutoff=e;break}if(this.terrain&&(this.terrain.updateTileBinding(s),this.opaquePassCutoff=0),"globe"!==this.transform.projection.name||this.globeSharedBuffers||(this.globeSharedBuffers=new e.GlobeSharedBuffers(this.context)),e.isMapAuthenticated(this.context.gl)){this.renderPass="offscreen";for(const e of o){const i=this.style._layers[e],o=t._getLayerSourceCache(i);if(!i.hasOffscreenPass()||i.isHidden(this.transform.zoom))continue;const r=o?a[o.id]:void 0;("custom"===i.type||i.isSky()||r&&r.length)&&this.renderLayer(this,o,i,r);}if(this.depthRangeFor3D=[0,1-(t.order.length+2)*this.numSublayers*this.depthEpsilon],this.terrain&&(this.style.hasSymbolLayers()||this.style.hasCircleLayers())&&this.terrain.drawDepth(),this.context.bindFramebuffer.set(null),this.context.viewport.set([0,0,this.width,this.height]),this.context.clear({color:i.showOverdrawInspector?e.Color.black:e.Color.transparent,depth:1}),this.clearStencil(),this._showOverdrawInspector=i.showOverdrawInspector,this.renderPass="opaque",!this.terrain)for(this.currentLayer=o.length-1;this.currentLayer>=0;this.currentLayer--){const e=this.style._layers[o[this.currentLayer]],i=t._getLayerSourceCache(e);if(e.isSky())continue;const r=i?a[i.id]:void 0;this._renderTileClippingMasks(e,i,r),this.renderLayer(this,i,e,r);}if(this.style.fog&&this.transform.projection.supportsFog&&function(t,i){const o=t.context,r=o.gl,n=t.transform,a=new e.DepthMode(r.LEQUAL,e.DepthMode.ReadOnly,[0,1]),s=t.useProgram("globeAtmosphere",null,"globe"===n.projection.name?["PROJECTION_GLOBE_VIEW","FOG"]:["FOG"]),l=e.globeToMercatorTransition(n.zoom),c=i.properties.get("color").toArray01(),h=i.properties.get("high-color").toArray01(),u=i.properties.get("space-color").toArray01PremultipliedAlpha(),_=e.identity$1([]);e.rotateY$1(_,_,-e.degToRad(n._center.lng)),e.rotateX$1(_,_,e.degToRad(n._center.lat)),e.rotateZ$1(_,_,n.angle),e.rotateX$1(_,_,-n._pitch);const d=e.fromQuat(new Float32Array(16),_),p=e.mapValue(i.properties.get("star-intensity"),0,1,0,.25),m=5e-4,f=e.mapValue(i.properties.get("horizon-blend"),0,1,m,.25),g=e.globeUseCustomAntiAliasing(t,o,n)&&f===m?n.worldSize/(2*Math.PI*1.025)-1:n.globeRadius,v=t.frameCounter/1e3%1,x=e.length(n.globeCenterInViewSpace),y=Math.sqrt(Math.pow(x,2)-Math.pow(g,2)),b=Math.acos(y/x),w=((t,i,o,r,n,a,s,l,c,h,u,_,d,p)=>({u_frustum_tl:t,u_frustum_tr:i,u_frustum_br:o,u_frustum_bl:r,u_horizon:n,u_transition:a,u_fadeout_range:s,u_color:l,u_high_color:c,u_space_color:h,u_star_intensity:u,u_star_size:5*e.exported.devicePixelRatio,u_star_density:0,u_temporal_offset:_,u_horizon_angle:d,u_rotation_matrix:p}))(n.frustumCorners.TL,n.frustumCorners.TR,n.frustumCorners.BR,n.frustumCorners.BL,n.frustumCorners.horizon,l,f,c,h,u,p,v,b,d);t.prepareDrawProgram(o,s);const T=t.atmosphereBuffer;T&&s.draw(o,r.TRIANGLES,a,e.StencilMode.disabled,e.ColorMode.alphaBlended,e.CullFaceMode.backCW,w,"skybox",T.vertexBuffer,T.indexBuffer,T.segments);}(this,this.style.fog),this.renderPass="sky",(e.globeToMercatorTransition(this.transform.zoom)>0||"globe"!==this.transform.projection.name)&&this.transform.isHorizonVisible())for(this.currentLayer=0;this.currentLayer<o.length;this.currentLayer++){const e=this.style._layers[o[this.currentLayer]],i=t._getLayerSourceCache(e);e.isSky()&&this.renderLayer(this,i,e,i?a[i.id]:void 0);}for(this.renderPass="translucent",this.currentLayer=0;this.currentLayer<o.length;){const e=this.style._layers[o[this.currentLayer]],i=t._getLayerSourceCache(e);if(e.isSky()){++this.currentLayer;continue}if(this.terrain&&this.style.isLayerDraped(e)){if(e.isHidden(this.transform.zoom)){++this.currentLayer;continue}this.currentLayer=this.terrain.renderBatch(this.currentLayer);continue}const r=i?("symbol"===e.type?s:a)[i.id]:void 0;this._renderTileClippingMasks(e,i,i?n[i.id]:void 0),this.renderLayer(this,i,e,r),++this.currentLayer;}if(this.terrain&&this.terrain.postRender(),this.options.showTileBoundaries||this.options.showQueryGeometry){let i=null;e.values(this.style._layers).forEach((e=>{const o=t._getLayerSourceCache(e);o&&!e.isHidden(this.transform.zoom)&&(!i||i.getSource().maxzoom<o.getSource().maxzoom)&&(i=o);})),i&&this.options.showTileBoundaries&&ko.debug(this,i,i.getVisibleCoordinates());}this.options.showPadding&&function(e){const t=e.transform.padding;Mo(e,e.transform.height-(t.top||0),3,bo),Mo(e,t.bottom||0,3,wo),So(e,t.left||0,3,To),So(e,e.transform.width-(t.right||0),3,Eo);const i=e.transform.centerPoint;!function(e,t,i,o){zo(e,t-1,i-10,2,20,o),zo(e,t-10,i-1,20,2,o);}(e,i.x,e.transform.height-i.y,Co);}(this),this.context.setDefault(),this.frameCounter=(this.frameCounter+1)%Number.MAX_SAFE_INTEGER,this.tileLoaded&&this.options.speedIndexTiming&&(this.loadTimeStamps.push(e.window.performance.now()),this.saveCanvasCopy());}}renderLayer(e,t,i,o){i.isHidden(this.transform.zoom)||("background"===i.type||"sky"===i.type||"custom"===i.type||o&&o.length)&&(this.id=i.id,this.gpuTimingStart(i),e.transform.projection.unsupportedLayers&&e.transform.projection.unsupportedLayers.includes(i.type)||ko[i.type](e,t,i,o,this.style.placement.variableOffsets,this.options.isInitialLoad),this.gpuTimingEnd());}gpuTimingStart(e){if(!this.options.gpuTiming)return;const t=this.context.extTimerQuery;let i=this.gpuTimers[e.id];i||(i=this.gpuTimers[e.id]={calls:0,cpuTime:0,query:t.createQueryEXT()}),i.calls++,t.beginQueryEXT(t.TIME_ELAPSED_EXT,i.query);}gpuTimingDeferredRenderStart(){if(this.options.gpuTimingDeferredRender){const e=this.context.extTimerQuery,t=e.createQueryEXT();this.deferredRenderGpuTimeQueries.push(t),e.beginQueryEXT(e.TIME_ELAPSED_EXT,t);}}gpuTimingDeferredRenderEnd(){if(!this.options.gpuTimingDeferredRender)return;const e=this.context.extTimerQuery;e.endQueryEXT(e.TIME_ELAPSED_EXT);}gpuTimingEnd(){if(!this.options.gpuTiming)return;const e=this.context.extTimerQuery;e.endQueryEXT(e.TIME_ELAPSED_EXT);}collectGpuTimers(){const e=this.gpuTimers;return this.gpuTimers={},e}collectDeferredRenderGpuQueries(){const e=this.deferredRenderGpuTimeQueries;return this.deferredRenderGpuTimeQueries=[],e}queryGpuTimers(e){const t={};for(const i in e){const o=e[i],r=this.context.extTimerQuery,n=r.getQueryObjectEXT(o.query,r.QUERY_RESULT_EXT)/1e6;r.deleteQueryEXT(o.query),t[i]=n;}return t}queryGpuTimeDeferredRender(e){if(!this.options.gpuTimingDeferredRender)return 0;const t=this.context.extTimerQuery;let i=0;for(const o of e)i+=t.getQueryObjectEXT(o,t.QUERY_RESULT_EXT)/1e6,t.deleteQueryEXT(o);return i}translatePosMatrix(t,i,o,r,n){if(!o[0]&&!o[1])return t;const a=n?"map"===r?this.transform.angle:0:"viewport"===r?-this.transform.angle:0;if(a){const e=Math.sin(a),t=Math.cos(a);o=[o[0]*t-o[1]*e,o[0]*e+o[1]*t];}const s=[n?o[0]:L(i,o[0],this.transform.zoom),n?o[1]:L(i,o[1],this.transform.zoom),0],l=new Float32Array(16);return e.translate(l,t,s),l}saveTileTexture(e){const t=this._tileTextures[e.size[0]];t?t.push(e):this._tileTextures[e.size[0]]=[e];}getTileTexture(e){const t=this._tileTextures[e];return t&&t.length>0?t.pop():null}isPatternMissing(e){if(!e)return !1;if(!e.from||!e.to)return !0;const t=this.imageManager.getPattern(e.from.toString()),i=this.imageManager.getPattern(e.to.toString());return !t||!i}currentGlobalDefines(){const e=this.terrain&&this.terrain.renderingToTexture,t=this.style&&this.style.fog,i=[];return this.terrain&&!this.terrain.renderingToTexture&&i.push("TERRAIN"),t&&!e&&0!==t.getOpacity(this.transform.pitch)&&i.push("FOG"),e&&i.push("RENDER_TO_TEXTURE"),this._showOverdrawInspector&&i.push("OVERDRAW_INSPECTOR"),i}useProgram(e,t,i){this.cache=this.cache||{};const o=i||[],r=this.currentGlobalDefines().concat(o),n=Li.cacheKey(_i[e],e,r,t);return this.cache[n]||(this.cache[n]=new Li(this.context,e,_i[e],t,lo[e],r)),this.cache[n]}setCustomLayerDefaults(){this.context.unbindVAO(),this.context.cullFace.setDefault(),this.context.frontFace.setDefault(),this.context.cullFaceSide.setDefault(),this.context.activeTexture.setDefault(),this.context.pixelStoreUnpack.setDefault(),this.context.pixelStoreUnpackPremultiplyAlpha.setDefault(),this.context.pixelStoreUnpackFlipY.setDefault();}setBaseState(){const e=this.context.gl;this.context.cullFace.set(!1),this.context.viewport.set([0,0,this.width,this.height]),this.context.blendEquation.set(e.FUNC_ADD);}initDebugOverlayCanvas(){null==this.debugOverlayCanvas&&(this.debugOverlayCanvas=e.window.document.createElement("canvas"),this.debugOverlayCanvas.width=512,this.debugOverlayCanvas.height=512,this.debugOverlayTexture=new e.Texture(this.context,this.debugOverlayCanvas,this.context.gl.RGBA));}destroy(){this._terrain&&this._terrain.destroy(),this.globeSharedBuffers&&this.globeSharedBuffers.destroy(),this.emptyTexture.destroy(),this.debugOverlayTexture&&this.debugOverlayTexture.destroy(),this.atmosphereBuffer&&this.atmosphereBuffer.destroy();}prepareDrawTile(){this.terrain&&this.terrain.prepareDrawTile();}prepareDrawProgram(t,i,o){if(this.terrain&&this.terrain.renderingToTexture)return;const r=this.style.fog;if(r){const n=r.getOpacity(this.transform.pitch),a=((t,i,o,r,n,a,s,l,c,h,u)=>{const _=t.transform,d=i.properties.get("color").toArray01();d[3]=r;const p=t.frameCounter/1e3%1;return {u_fog_matrix:o?_.calculateFogTileMatrix(o):t.identityMat,u_fog_range:i.getFovAdjustedRange(_._fov),u_fog_color:d,u_fog_horizon_blend:i.properties.get("horizon-blend"),u_fog_temporal_offset:p,u_frustum_tl:n,u_frustum_tr:a,u_frustum_br:s,u_frustum_bl:l,u_globe_pos:c,u_globe_radius:h,u_viewport:u,u_globe_transition:e.globeToMercatorTransition(_.zoom),u_is_globe:+("globe"===_.projection.name)}})(this,r,o,n,this.transform.frustumCorners.TL,this.transform.frustumCorners.TR,this.transform.frustumCorners.BR,this.transform.frustumCorners.BL,this.transform.globeCenterInViewSpace,this.transform.globeRadius,[this.transform.width*e.exported.devicePixelRatio,this.transform.height*e.exported.devicePixelRatio]);i.setFogUniformValues(t,a);}}setTileLoadedFlag(e){this.tileLoaded=e;}saveCanvasCopy(){this.frameCopies.push(this.canvasCopy()),this.tileLoaded=!1;}canvasCopy(){const e=this.context.gl,t=e.createTexture();return e.bindTexture(e.TEXTURE_2D,t),e.copyTexImage2D(e.TEXTURE_2D,0,e.RGBA,0,0,e.drawingBufferWidth,e.drawingBufferHeight,0),t}getCanvasCopiesAndTimestamps(){return {canvasCopies:this.frameCopies,timeStamps:this.loadTimeStamps}}averageElevationNeedsEasing(){if(!this.transform._elevation)return !1;const e=this.style&&this.style.fog;return !!e&&0!==e.getOpacity(this.transform.pitch)}getBackgroundTiles(){const t=this._backgroundTiles,i=this._backgroundTiles={},o=this.transform.coveringTiles({tileSize:512});for(const r of o)i[r.key]=t[r.key]||new e.Tile(r,512,this.transform.tileZoom,this);return i}clearBackgroundTiles(){this._backgroundTiles={};}}class Uo{constructor(e=0,t=0,i=0,o=0){if(isNaN(e)||e<0||isNaN(t)||t<0||isNaN(i)||i<0||isNaN(o)||o<0)throw new Error("Invalid value for edge-insets, top, bottom, left and right must all be numbers");this.top=e,this.bottom=t,this.left=i,this.right=o;}interpolate(t,i,o){return null!=i.top&&null!=t.top&&(this.top=e.number(t.top,i.top,o)),null!=i.bottom&&null!=t.bottom&&(this.bottom=e.number(t.bottom,i.bottom,o)),null!=i.left&&null!=t.left&&(this.left=e.number(t.left,i.left,o)),null!=i.right&&null!=t.right&&(this.right=e.number(t.right,i.right,o)),this}getCenter(t,i){const o=e.clamp((this.left+t-this.right)/2,0,t),r=e.clamp((this.top+i-this.bottom)/2,0,i);return new e.pointGeometry(o,r)}equals(e){return this.top===e.top&&this.bottom===e.bottom&&this.left===e.left&&this.right===e.right}clone(){return new Uo(this.top,this.bottom,this.left,this.right)}toJSON(){return {top:this.top,bottom:this.bottom,left:this.left,right:this.right}}}function No(t,i){const o=e.getColumn(t,3);e.fromQuat(t,i),e.setColumn(t,3,o);}function Go(t,i){const o=e.identity$1([]);return e.rotateZ$1(o,o,-i),e.rotateX$1(o,o,-t),o}function jo(t,i){const o=[t[0],t[1],0],r=[i[0],i[1],0];if(e.length(o)>=1e-15){const t=e.normalize([],o);e.scale$2(r,t,e.dot(r,t)),i[0]=r[0],i[1]=r[1];}const n=e.cross([],i,t);if(e.len(n)<1e-15)return null;const a=Math.atan2(-n[1],n[0]);return Go(Math.atan2(Math.sqrt(t[0]*t[0]+t[1]*t[1]),-t[2]),a)}class Zo{constructor(e,t){this.position=e,this.orientation=t;}get position(){return this._position}set position(t){if(t){const i=t instanceof e.MercatorCoordinate?t:new e.MercatorCoordinate(t[0],t[1],t[2]);this._renderWorldCopies&&(i.x=e.wrap(i.x,0,1)),this._position=i;}else this._position=null;}lookAtPoint(t,i){if(this.orientation=null,!this.position)return;const o=this._elevation?this._elevation.getAtPointOrZero(e.MercatorCoordinate.fromLngLat(t)):0,r=this.position,n=e.MercatorCoordinate.fromLngLat(t,o),a=[n.x-r.x,n.y-r.y,n.z-r.z];i||(i=[0,0,1]),i[2]=Math.abs(i[2]),this.orientation=jo(a,i);}setPitchBearing(t,i){this.orientation=Go(e.degToRad(t),e.degToRad(-i));}}class Vo{constructor(t,i){this._transform=e.identity([]),this.orientation=i,this.position=t;}get mercatorPosition(){const t=this.position;return new e.MercatorCoordinate(t[0],t[1],t[2])}get position(){const t=e.getColumn(this._transform,3);return [t[0],t[1],t[2]]}set position(t){var i;t&&e.setColumn(this._transform,3,[(i=t)[0],i[1],i[2],1]);}get orientation(){return this._orientation}set orientation(t){this._orientation=t||e.identity$1([]),t&&No(this._transform,this._orientation);}getPitchBearing(){const e=this.forward(),t=this.right();return {bearing:Math.atan2(-t[1],t[0]),pitch:Math.atan2(Math.sqrt(e[0]*e[0]+e[1]*e[1]),-e[2])}}setPitchBearing(e,t){this._orientation=Go(e,t),No(this._transform,this._orientation);}forward(){const t=e.getColumn(this._transform,2);return [-t[0],-t[1],-t[2]]}up(){const t=e.getColumn(this._transform,1);return [-t[0],-t[1],-t[2]]}right(){const t=e.getColumn(this._transform,0);return [t[0],t[1],t[2]]}getCameraToWorld(t,i){const o=new Float64Array(16);return e.invert(o,this.getWorldToCamera(t,i)),o}getWorldToCameraPosition(t,i,o){const r=this.position;e.scale$2(r,r,-t);const n=new Float64Array(16);return e.fromScaling(n,[o,o,o]),e.translate(n,n,r),n[10]*=i,n}getWorldToCamera(t,i){const o=new Float64Array(16),r=new Float64Array(4),n=this.position;return e.conjugate(r,this._orientation),e.scale$2(n,n,-t),e.fromQuat(o,r),e.translate(o,o,n),o[1]*=-1,o[5]*=-1,o[9]*=-1,o[13]*=-1,o[8]*=i,o[9]*=i,o[10]*=i,o[11]*=i,o}getCameraToClipPerspective(t,i,o,r){const n=new Float64Array(16);return e.perspective(n,t,i,o,r),n}getDistanceToElevation(t){const i=0===t?0:e.mercatorZfromAltitude(t,this.position[1]),o=this.forward();return (i-this.position[2])/o[2]}clone(){return new Vo([...this.position],[...this.orientation])}}function Wo(t,i){const o=qo(t.projection,t.zoom,t.width,t.height),r=function(t,i,o,r,n){const a=new e.LngLat(o.lng-180*$o,o.lat),s=new e.LngLat(o.lng+180*$o,o.lat),l=t.project(a.lng,a.lat),c=t.project(s.lng,s.lat),h=-Math.atan2(c.y-l.y,c.x-l.x),u=e.MercatorCoordinate.fromLngLat(o);u.y=e.clamp(u.y,-.999975,.999975);const _=u.toLngLat(),d=t.project(_.lng,_.lat),p=e.MercatorCoordinate.fromLngLat(_);p.x+=$o;const m=p.toLngLat(),f=t.project(m.lng,m.lat),g=Yo(f.x-d.x,f.y-d.y,h),v=e.MercatorCoordinate.fromLngLat(_);v.y+=$o;const x=v.toLngLat(),y=t.project(x.lng,x.lat),b=Yo(y.x-d.x,y.y-d.y,h),w=Math.abs(g.x)/Math.abs(b.y),T=e.identity([]);e.rotateZ(T,T,-h*(1-(n?0:r)));const E=e.identity([]);return e.scale(E,E,[1,1-(1-w)*r,1]),E[4]=-b.x/b.y*r,e.rotateZ(E,E,h),e.multiply(E,T,E),E}(t.projection,0,t.center,o,i),n=Xo(t);return e.scale(r,r,[n,n,1]),r}function Xo(t){const i=t.projection,o=qo(t.projection,t.zoom,t.width,t.height),r=Ho(i,t.center),n=Ho(i,e.LngLat.convert(i.center));return Math.pow(2,r*o+(1-o)*n)}function qo(t,i,o,r,n=1/0){const a=t.range;if(!a)return 0;const s=Math.min(n,Math.max(o,r)),l=Math.log(s/1024)/Math.LN2;return e.smoothstep(a[0]+l,a[1]+l,i)}const $o=1/4e4;function Ho(t,i){const o=e.clamp(i.lat,-e.MAX_MERCATOR_LATITUDE,e.MAX_MERCATOR_LATITUDE),r=new e.LngLat(i.lng-180*$o,o),n=new e.LngLat(i.lng+180*$o,o),a=t.project(r.lng,o),s=t.project(n.lng,o),l=e.MercatorCoordinate.fromLngLat(r),c=e.MercatorCoordinate.fromLngLat(n),h=s.x-a.x,u=s.y-a.y,_=c.x-l.x,d=c.y-l.y,p=Math.sqrt((_*_+d*d)/(h*h+u*u));return Math.log(p)/Math.LN2}function Yo(e,t,i){const o=Math.cos(i),r=Math.sin(i);return {x:e*o-t*r,y:e*r+t*o}}class Ko{constructor(t,i,o,r,n,a,s){this.tileSize=512,this._renderWorldCopies=void 0===n||n,this._minZoom=t||0,this._maxZoom=i||22,this._minPitch=null==o?0:o,this._maxPitch=null==r?60:r,this.setProjection(a),this.setMaxBounds(s),this.width=0,this.height=0,this._center=new e.LngLat(0,0),this.zoom=0,this.angle=0,this._fov=.6435011087932844,this._pitch=0,this._nearZ=0,this._farZ=0,this._unmodified=!0,this._edgeInsets=new Uo,this._projMatrixCache={},this._alignedProjMatrixCache={},this._fogTileMatrixCache={},this._distanceTileDataCache={},this._camera=new Vo,this._centerAltitude=0,this._averageElevation=0,this.cameraElevationReference="ground",this._pixelsPerMercatorPixel=1,this.globeRadius=0,this.globeCenterInViewSpace=[0,0,0],this._horizonShift=.1;}clone(){const e=new Ko(this._minZoom,this._maxZoom,this._minPitch,this.maxPitch,this._renderWorldCopies,this.getProjection());return e._elevation=this._elevation,e._centerAltitude=this._centerAltitude,e._centerAltitudeValidForExaggeration=this._centerAltitudeValidForExaggeration,e.tileSize=this.tileSize,e.width=this.width,e.height=this.height,e.cameraElevationReference=this.cameraElevationReference,e._center=this._center,e._setZoom(this.zoom),e._seaLevelZoom=this._seaLevelZoom,e.angle=this.angle,e._fov=this._fov,e._pitch=this._pitch,e._nearZ=this._nearZ,e._farZ=this._farZ,e._averageElevation=this._averageElevation,e._unmodified=this._unmodified,e._edgeInsets=this._edgeInsets.clone(),e._camera=this._camera.clone(),e._calcMatrices(),e.freezeTileCoverage=this.freezeTileCoverage,e.frustumCorners=this.frustumCorners,e}get elevation(){return this._elevation}set elevation(e){this._elevation!==e&&(this._elevation=e,this._updateCameraOnTerrain(),this._calcMatrices());}updateElevation(e){const t=this._elevation&&this._elevation.exaggeration()!==this._centerAltitudeValidForExaggeration;(null==this._seaLevelZoom||t)&&this._updateCameraOnTerrain(),(e||t)&&this._constrainCameraAltitude(),this._calcMatrices();}getProjection(){return e.pick(this.projection,["name","center","parallels"])}setProjection(i){this.projectionOptions=i||{name:"mercator"};const o=this.projection?this.getProjection():void 0;this.projection=e.getProjection(this.projectionOptions);const r=!t(o,this.getProjection());return r&&this._calcMatrices(),this.mercatorFromTransition=!1,r}setMercatorFromTransition(){const t=this.projection.name;this.mercatorFromTransition=!0,this.projectionOptions={name:"mercator"},this.projection=e.getProjection({name:"mercator"});const i=t!==this.projection.name;return i&&this._calcMatrices(),i}get minZoom(){return this._minZoom}set minZoom(e){this._minZoom!==e&&(this._minZoom=e,this.zoom=Math.max(this.zoom,e));}get maxZoom(){return this._maxZoom}set maxZoom(e){this._maxZoom!==e&&(this._maxZoom=e,this.zoom=Math.min(this.zoom,e));}get minPitch(){return this._minPitch}set minPitch(e){this._minPitch!==e&&(this._minPitch=e,this.pitch=Math.max(this.pitch,e));}get maxPitch(){return this._maxPitch}set maxPitch(e){this._maxPitch!==e&&(this._maxPitch=e,this.pitch=Math.min(this.pitch,e));}get renderWorldCopies(){return this._renderWorldCopies&&!0===this.projection.supportsWorldCopies}set renderWorldCopies(e){void 0===e?e=!0:null===e&&(e=!1),this._renderWorldCopies=e;}get worldSize(){return this.tileSize*this.scale}get cameraWorldSize(){const e=Math.max(this._camera.getDistanceToElevation(this._averageElevation),Number.EPSILON);return this._worldSizeFromZoom(this._zoomFromMercatorZ(e))}get pixelsPerMeter(){return this.projection.pixelsPerMeter(this.center.lat,this.worldSize)}get cameraPixelsPerMeter(){return e.mercatorZfromAltitude(this.center.lat,this.cameraWorldSize)}get centerOffset(){return this.centerPoint._sub(this.size._div(2))}get size(){return new e.pointGeometry(this.width,this.height)}get bearing(){return e.wrap(this.rotation,-180,180)}set bearing(e){this.rotation=e;}get rotation(){return -this.angle/Math.PI*180}set rotation(t){const i=-t*Math.PI/180;var o;this.angle!==i&&(this._unmodified=!1,this.angle=i,this._calcMatrices(),this.rotationMatrix=(o=new e.ARRAY_TYPE(4),e.ARRAY_TYPE!=Float32Array&&(o[1]=0,o[2]=0),o[0]=1,o[3]=1,o),function(e,t,i){var o=t[0],r=t[1],n=t[2],a=t[3],s=Math.sin(i),l=Math.cos(i);e[0]=o*l+n*s,e[1]=r*l+a*s,e[2]=o*-s+n*l,e[3]=r*-s+a*l;}(this.rotationMatrix,this.rotationMatrix,this.angle));}get pitch(){return this._pitch/Math.PI*180}set pitch(t){const i=e.clamp(t,this.minPitch,this.maxPitch)/180*Math.PI;this._pitch!==i&&(this._unmodified=!1,this._pitch=i,this._calcMatrices());}get fov(){return this._fov/Math.PI*180}set fov(e){e=Math.max(.01,Math.min(60,e)),this._fov!==e&&(this._unmodified=!1,this._fov=e/180*Math.PI,this._calcMatrices());}get averageElevation(){return this._averageElevation}set averageElevation(e){this._averageElevation=e,this._calcFogMatrices(),this._distanceTileDataCache={};}get zoom(){return this._zoom}set zoom(e){const t=Math.min(Math.max(e,this.minZoom),this.maxZoom);this._zoom!==t&&(this._unmodified=!1,this._setZoom(t),this._updateSeaLevelZoom(),this._constrain(),this._calcMatrices());}_setZoom(e){this._zoom=e,this.scale=this.zoomScale(e),this.tileZoom=Math.floor(e),this.zoomFraction=e-this.tileZoom;}_updateCameraOnTerrain(){if(!this._elevation||!this._elevation.isDataAvailableAtPoint(this.locationCoordinate(this.center)))return this._centerAltitude=0,this._seaLevelZoom=null,void(this._centerAltitudeValidForExaggeration=void 0);const e=this._elevation;this._centerAltitude=e.getAtPointOrZero(this.locationCoordinate(this.center)),this._centerAltitudeValidForExaggeration=e.exaggeration(),this._updateSeaLevelZoom();}_updateSeaLevelZoom(){void 0!==this._centerAltitudeValidForExaggeration&&(this._seaLevelZoom=this._zoomFromMercatorZ((this.pixelsPerMeter*this._centerAltitude+this.cameraToCenterDistance)/this.worldSize));}sampleAverageElevation(){if(!this._elevation)return 0;const t=this._elevation,i=[[.5,.2],[.3,.5],[.5,.5],[.7,.5],[.5,.8]],o=this.horizonLineFromTop();let r=0,n=0;for(let a=0;a<i.length;a++){const s=new e.pointGeometry(i[a][0]*this.width,o+i[a][1]*(this.height-o)),l=t.pointCoordinate(s);if(!l)continue;const c=1/Math.hypot(l[0]-this._camera.position[0],l[1]-this._camera.position[1]);r+=l[3]*c,n+=c;}return 0===n?NaN:r/n}get center(){return this._center}set center(e){e.lat===this._center.lat&&e.lng===this._center.lng||(this._unmodified=!1,this._center=e,this._terrainEnabled()&&("ground"===this.cameraElevationReference?this._updateCameraOnTerrain():this._updateZoomFromElevation()),this._constrain(),this._calcMatrices());}_updateZoomFromElevation(){if(null==this._seaLevelZoom||!this._elevation)return;const e=this._seaLevelZoom,t=this._elevation.getAtPointOrZero(this.locationCoordinate(this.center)),i=this.pixelsPerMeter/this.worldSize*t,o=this._mercatorZfromZoom(e),r=this._mercatorZfromZoom(this._maxZoom),n=Math.max(o-i,r);this._setZoom(this._zoomFromMercatorZ(n));}get padding(){return this._edgeInsets.toJSON()}set padding(e){this._edgeInsets.equals(e)||(this._unmodified=!1,this._edgeInsets.interpolate(this._edgeInsets,e,1),this._calcMatrices());}computeZoomRelativeTo(t){const i=this.rayIntersectionCoordinate(this.pointRayIntersection(this.centerPoint,t.toAltitude()));let o;o=t.z<this._camera.position[2]?[i.x,i.y,i.z]:[t.x,t.y,t.z];const r=e.length(e.sub([],this._camera.position,o));return e.clamp(this._zoomFromMercatorZ(r),this._minZoom,this._maxZoom)}setFreeCameraOptions(t){if(!this.height)return;if(!t.position&&!t.orientation)return;this._updateCameraState();let i=!1;if(t.orientation&&!e.exactEquals(t.orientation,this._camera.orientation)&&(i=this._setCameraOrientation(t.orientation)),t.position){const o=[t.position.x,t.position.y,t.position.z];e.exactEquals$1(o,this._camera.position)||(this._setCameraPosition(o),i=!0);}i&&(this._updateStateFromCamera(),this.recenterOnTerrain());}getFreeCameraOptions(){this._updateCameraState();const t=this._camera.position,i=new Zo;return i.position=new e.MercatorCoordinate(t[0],t[1],t[2]),i.orientation=this._camera.orientation,i._elevation=this.elevation,i._renderWorldCopies=this.renderWorldCopies,i}_setCameraOrientation(t){if(!e.length$1(t))return !1;e.normalize$1(t,t);const i=e.transformQuat([],[0,0,-1],t),o=e.transformQuat([],[0,-1,0],t);if(o[2]<0)return !1;const r=jo(i,o);return !!r&&(this._camera.orientation=r,!0)}_setCameraPosition(t){const i=this.zoomScale(this.minZoom)*this.tileSize,o=this.zoomScale(this.maxZoom)*this.tileSize,r=this.cameraToCenterDistance;t[2]=e.clamp(t[2],r/o,r/i),this._camera.position=t;}get centerPoint(){return this._edgeInsets.getCenter(this.width,this.height)}get fovAboveCenter(){return this._fov*(.5+this.centerOffset.y/this.height)}isPaddingEqual(e){return this._edgeInsets.equals(e)}interpolatePadding(e,t,i){this._unmodified=!1,this._edgeInsets.interpolate(e,t,i),this._constrain(),this._calcMatrices();}coveringZoomLevel(e){const t=(e.roundZoom?Math.round:Math.floor)(this.zoom+this.scaleZoom(this.tileSize/e.tileSize));return Math.max(0,t)}getVisibleUnwrappedCoordinates(t){const i=[new e.UnwrappedTileID(0,t)];if(this.renderWorldCopies){const o=this.pointCoordinate(new e.pointGeometry(0,0)),r=this.pointCoordinate(new e.pointGeometry(this.width,0)),n=this.pointCoordinate(new e.pointGeometry(this.width,this.height)),a=this.pointCoordinate(new e.pointGeometry(0,this.height)),s=Math.floor(Math.min(o.x,r.x,n.x,a.x)),l=Math.floor(Math.max(o.x,r.x,n.x,a.x)),c=1;for(let o=s-c;o<=l+c;o++)0!==o&&i.push(new e.UnwrappedTileID(o,t));}return i}coveringTiles(t){let i=this.coveringZoomLevel(t);const o=i,r=this.elevation&&!t.isTerrainDEM,n="mercator"===this.projection.name;if(void 0!==t.minzoom&&i<t.minzoom)return [];void 0!==t.maxzoom&&i>t.maxzoom&&(i=t.maxzoom);const a=this.locationCoordinate(this.center),s=this.center.lat,l=1<<i,c=[l*a.x,l*a.y,0],h="globe"===this.projection.name,u=!h,_=e.Frustum.fromInvProjectionMatrix(this.invProjMatrix,this.worldSize,i,u),d=h?this._camera.mercatorPosition:this.pointCoordinate(this.getCameraPoint()),p=l*e.mercatorZfromAltitude(1,this.center.lat),m=this._camera.position[2]/e.mercatorZfromAltitude(1,this.center.lat),f=[l*d.x,l*d.y,m*(u?1:p)],g=this.cameraToCenterDistance/t.tileSize*(t.roundZoom?1:.502),v=this.pitch<=60&&this._edgeInsets.top<=this._edgeInsets.bottom&&!this._elevation&&!this.projection.isReprojectedInTileSpace?i:0,x=t.isTerrainDEM&&this._elevation?1e4*this._elevation.exaggeration():this._centerAltitude,y=t.isTerrainDEM?-x:this._elevation?this._elevation.getMinElevationBelowMSL():0,b=this.projection.isReprojectedInTileSpace?Xo(this):1,w=t=>{const i=1/4e4,o=new e.MercatorCoordinate(t.x+i,t.y,t.z),r=new e.MercatorCoordinate(t.x,t.y+i,t.z),n=t.toLngLat(),a=o.toLngLat(),s=r.toLngLat(),l=this.locationCoordinate(n),c=this.locationCoordinate(a),h=this.locationCoordinate(s),u=Math.hypot(c.x-l.x,c.y-l.y),_=Math.hypot(h.x-l.x,h.y-l.y);return Math.sqrt(u*_)*b/i},T=t=>{const i=x,o=y;return {aabb:e.tileAABB(this,l,0,0,0,t,o,i,this.projection),zoom:0,x:0,y:0,minZ:o,maxZ:i,wrap:t,fullyVisible:!1}},E=[];let C=[];const I=i,M=t.reparseOverscaled?o:i,S=e=>e*e,z=S((m-this._centerAltitude)*p),D=e=>{if(!this._elevation||!e.tileID||!n)return;const t=this._elevation.getMinMaxForTile(e.tileID),i=e.aabb;t?(i.min[2]=t.min,i.max[2]=t.max,i.center[2]=(i.min[2]+i.max[2])/2):(e.shouldSplit=P(e),e.shouldSplit||(i.min[2]=i.max[2]=i.center[2]=this._centerAltitude));},P=t=>{if(t.zoom<v)return !0;if(t.zoom===I)return !1;if(null!=t.shouldSplit)return t.shouldSplit;const i=t.aabb.distanceX(f),n=t.aabb.distanceY(f);let a=z,l=1;if(h){a=S(t.aabb.distanceZ(f));const i=Math.pow(2,t.zoom),o=e.latFromMercatorY((t.y+1)/i),r=e.latFromMercatorY(t.y/i),n=Math.min(Math.max(s,o),r),c=e.circumferenceAtLatitude(n)/e.circumferenceAtLatitude(s);if(l=n===s?1/Math.max(1,this._mercatorScaleRatio-.3):Math.min(1,c/this._mercatorScaleRatio),this.zoom<=e.GLOBE_ZOOM_THRESHOLD_MIN&&t.zoom===I-1&&c>=.9)return !0}else if(r&&(a=S(t.aabb.distanceZ(f)*p)),this.projection.isReprojectedInTileSpace&&o<=5){const i=Math.pow(2,t.zoom),o=w(new e.MercatorCoordinate((t.x+.5)/i,(t.y+.5)/i));l=o>.85?1:o;}const c=i*i+n*n+a;return c<S((1<<I-t.zoom)*g*l*((e,t)=>{if(t*S(.707)<e)return 1;const i=Math.sqrt(t/e);return i/(1.4144271570014144+(Math.pow(1.1,i-1.4144271570014144+1)-1)/(1.1-1)-1)})(Math.max(a,z),c))};if(this.renderWorldCopies)for(let e=1;e<=3;e++)E.push(T(-e)),E.push(T(e));for(E.push(T(0));E.length>0;){const o=E.pop(),a=o.x,s=o.y;let u=o.fullyVisible;if(!u){const e=o.aabb.intersects(_);if(0===e)continue;u=2===e;}if(o.zoom!==I&&P(o))for(let t=0;t<4;t++){const i=(a<<1)+t%2,c=(s<<1)+(t>>1),_={aabb:n?o.aabb.quadrant(t):e.tileAABB(this,l,o.zoom+1,i,c,o.wrap,o.minZ,o.maxZ,this.projection),zoom:o.zoom+1,x:i,y:c,wrap:o.wrap,fullyVisible:u,tileID:void 0,shouldSplit:void 0,minZ:o.minZ,maxZ:o.maxZ};r&&!h&&(_.tileID=new e.OverscaledTileID(o.zoom+1===I?M:o.zoom+1,o.wrap,o.zoom+1,i,c),D(_)),E.push(_);}else {const r=o.zoom===I?M:o.zoom;if(t.minzoom&&t.minzoom>r)continue;const n=c[0]-(.5+a+(o.wrap<<o.zoom))*(1<<i-o.zoom),l=c[1]-.5-s,h=o.tileID?o.tileID:new e.OverscaledTileID(r,o.wrap,o.zoom,a,s);C.push({tileID:h,distanceSq:n*n+l*l});}}if(this.fogCullDistSq){const i=this.fogCullDistSq,o=this.horizonLineFromTop();C=C.filter((r=>{const n=[0,0,0,1],a=[e.EXTENT,e.EXTENT,0,1],s=this.calculateFogTileMatrix(r.tileID.toUnwrapped());e.transformMat4$1(n,n,s),e.transformMat4$1(a,a,s);const l=e.getAABBPointSquareDist(n,a);if(0===l)return !0;let c=!1;const h=this._elevation;if(h&&l>i&&0!==o){const i=this.calculateProjMatrix(r.tileID.toUnwrapped());let n;t.isTerrainDEM||(n=h.getMinMaxForTile(r.tileID)),n||(n={min:y,max:x});const a=e.furthestTileCorner(this.rotation),s=[a[0]*e.EXTENT,a[1]*e.EXTENT,n.max];e.transformMat4(s,s,i),c=(1-s[1])*this.height*.5<o;}return l<i||c}));}return C.sort(((e,t)=>e.distanceSq-t.distanceSq)).map((e=>e.tileID))}resize(e,t){this.width=e,this.height=t,this.pixelsToGLUnits=[2/e,-2/t],this._constrain(),this._calcMatrices();}get unmodified(){return this._unmodified}zoomScale(e){return Math.pow(2,e)}scaleZoom(e){return Math.log(e)/Math.LN2}project(t){const i=e.clamp(t.lat,-e.MAX_MERCATOR_LATITUDE,e.MAX_MERCATOR_LATITUDE),o=this.projection.project(t.lng,i);return new e.pointGeometry(o.x*this.worldSize,o.y*this.worldSize)}unproject(e){return this.projection.unproject(e.x/this.worldSize,e.y/this.worldSize)}get point(){return this.project(this.center)}setLocationAtPoint(t,i){let o,r;const n=this.centerPoint;if("globe"===this.projection.name){const e=this.worldSize;o=(i.x-n.x)/e,r=(i.y-n.y)/e;}else {const e=this.pointCoordinate(i),t=this.pointCoordinate(n);o=e.x-t.x,r=e.y-t.y;}const a=this.locationCoordinate(t);this.setLocation(new e.MercatorCoordinate(a.x-o,a.y-r));}setLocation(e){this.center=this.coordinateLocation(e),this.projection.wrap&&(this.center=this.center.wrap());}locationPoint(e){return this.projection.locationPoint(this,e)}locationPoint3D(e){return this.projection.locationPoint(this,e,!0)}pointLocation(e){return this.coordinateLocation(this.pointCoordinate(e))}pointLocation3D(e){return this.coordinateLocation(this.pointCoordinate3D(e))}locationCoordinate(t,i){const o=i?e.mercatorZfromAltitude(i,t.lat):void 0,r=this.projection.project(t.lng,t.lat);return new e.MercatorCoordinate(r.x,r.y,o)}coordinateLocation(e){return this.projection.unproject(e.x,e.y)}pointRayIntersection(t,i){const o=null!=i?i:this._centerAltitude,r=[t.x,t.y,0,1],n=[t.x,t.y,1,1];e.transformMat4$1(r,r,this.pixelMatrixInverse),e.transformMat4$1(n,n,this.pixelMatrixInverse);const a=n[3];e.scale$1(r,r,1/r[3]),e.scale$1(n,n,1/a);const s=r[2],l=n[2];return {p0:r,p1:n,t:s===l?0:(o-s)/(l-s)}}screenPointToMercatorRay(t){const i=[t.x,t.y,0,1],o=[t.x,t.y,1,1];return e.transformMat4$1(i,i,this.pixelMatrixInverse),e.transformMat4$1(o,o,this.pixelMatrixInverse),e.scale$1(i,i,1/i[3]),e.scale$1(o,o,1/o[3]),i[2]=e.mercatorZfromAltitude(i[2],this._center.lat)*this.worldSize,o[2]=e.mercatorZfromAltitude(o[2],this._center.lat)*this.worldSize,e.scale$1(i,i,1/this.worldSize),e.scale$1(o,o,1/this.worldSize),new e.Ray([i[0],i[1],i[2]],e.normalize([],e.sub([],o,i)))}rayIntersectionCoordinate(t){const{p0:i,p1:o,t:r}=t,n=e.mercatorZfromAltitude(i[2],this._center.lat),a=e.mercatorZfromAltitude(o[2],this._center.lat);return new e.MercatorCoordinate(e.number(i[0],o[0],r)/this.worldSize,e.number(i[1],o[1],r)/this.worldSize,e.number(n,a,r))}pointCoordinate(e,t=this._centerAltitude){return this.projection.pointCoordinate(this,e.x,e.y,t)}pointCoordinate3D(t){if(!this.elevation)return this.pointCoordinate(t);let i=this.projection.pointCoordinate3D(this,t.x,t.y);if(i)return new e.MercatorCoordinate(i[0],i[1],i[2]);let o=0,r=this.horizonLineFromTop();if(t.y>r)return this.pointCoordinate(t);const n=.02*r,a=t.clone();for(let t=0;t<10&&r-o>n;t++){a.y=e.number(o,r,.66);const t=this.projection.pointCoordinate3D(this,a.x,a.y);t?(r=a.y,i=t):o=a.y;}return i?new e.MercatorCoordinate(i[0],i[1],i[2]):this.pointCoordinate(t)}isPointAboveHorizon(e){return this.projection.isPointAboveHorizon(this,e)}_coordinatePoint(t,i){const o=i&&this.elevation?this.elevation.getAtPointOrZero(t,this._centerAltitude):this._centerAltitude,r=[t.x*this.worldSize,t.y*this.worldSize,o+t.toAltitude(),1];return e.transformMat4$1(r,r,this.pixelMatrix),r[3]>0?new e.pointGeometry(r[0]/r[3],r[1]/r[3]):new e.pointGeometry(Number.MAX_VALUE,Number.MAX_VALUE)}_getBounds(t,i){const o=new e.pointGeometry(this._edgeInsets.left,this._edgeInsets.top),r=new e.pointGeometry(this.width-this._edgeInsets.right,this._edgeInsets.top),n=new e.pointGeometry(this.width-this._edgeInsets.right,this.height-this._edgeInsets.bottom),a=new e.pointGeometry(this._edgeInsets.left,this.height-this._edgeInsets.bottom);let s=this.pointCoordinate(o,t),l=this.pointCoordinate(r,t);const c=this.pointCoordinate(n,i),h=this.pointCoordinate(a,i),u=(e,t)=>(t.y-e.y)/(t.x-e.x);return s.y>1&&l.y>=0?s=new e.MercatorCoordinate((1-h.y)/u(h,s)+h.x,1):s.y<0&&l.y<=1&&(s=new e.MercatorCoordinate(-h.y/u(h,s)+h.x,0)),l.y>1&&s.y>=0?l=new e.MercatorCoordinate((1-c.y)/u(c,l)+c.x,1):l.y<0&&s.y<=1&&(l=new e.MercatorCoordinate(-c.y/u(c,l)+c.x,0)),(new e.LngLatBounds).extend(this.coordinateLocation(s)).extend(this.coordinateLocation(l)).extend(this.coordinateLocation(h)).extend(this.coordinateLocation(c))}_getBounds3D(){const e=this.elevation;if(!e.visibleDemTiles.length)return this._getBounds(0,0);const t=e.visibleDemTiles.reduce(((e,t)=>{if(t.dem){const i=t.dem.tree;e.min=Math.min(e.min,i.minimums[0]),e.max=Math.max(e.max,i.maximums[0]);}return e}),{min:Number.MAX_VALUE,max:0});return this._getBounds(t.min*e.exaggeration(),t.max*e.exaggeration())}getBounds(){return this._terrainEnabled()?this._getBounds3D():this._getBounds(0,0)}horizonLineFromTop(e=!0){const t=this.height/2/Math.tan(this._fov/2)/Math.tan(Math.max(this._pitch,.1))+this.centerOffset.y,i=this.height/2-t*(1-this._horizonShift);return e?Math.max(0,i):i}getMaxBounds(){return this.maxBounds}setMaxBounds(t){this.maxBounds=t,this.minLat=-e.MAX_MERCATOR_LATITUDE,this.maxLat=e.MAX_MERCATOR_LATITUDE,this.minLng=-180,this.maxLng=180,t&&(this.minLat=t.getSouth(),this.maxLat=t.getNorth(),this.minLng=t.getWest(),this.maxLng=t.getEast(),this.maxLng<this.minLng&&(this.maxLng+=360)),this.worldMinX=e.mercatorXfromLng(this.minLng)*this.tileSize,this.worldMaxX=e.mercatorXfromLng(this.maxLng)*this.tileSize,this.worldMinY=e.mercatorYfromLat(this.maxLat)*this.tileSize,this.worldMaxY=e.mercatorYfromLat(this.minLat)*this.tileSize,this._constrain();}calculatePosMatrix(e,t){return this.projection.createTileMatrix(this,t,e)}calculateDistanceTileData(t){const i=t.key,o=this._distanceTileDataCache;if(o[i])return o[i];const r=t.canonical,n=1/this.height,a=this.cameraWorldSize/this.zoomScale(r.z),s=(r.x+Math.pow(2,r.z)*t.wrap)*a,l=r.y*a,c=this.point,h=this.angle,u=Math.sin(-h),_=-Math.cos(-h);return o[i]={bearing:[u,_],center:[(c.x-s)*n,(c.y-l)*n],scale:a/e.EXTENT*n},o[i]}calculateFogTileMatrix(t){const i=t.key,o=this._fogTileMatrixCache;if(o[i])return o[i];const r=this.projection.createTileMatrix(this,this.cameraWorldSize,t);return e.multiply(r,this.worldToFogMatrix,r),o[i]=new Float32Array(r),o[i]}calculateProjMatrix(t,i=!1){const o=t.key,r=i?this._alignedProjMatrixCache:this._projMatrixCache;if(r[o])return r[o];const n=this.calculatePosMatrix(t,this.worldSize);return e.multiply(n,this.projection.isReprojectedInTileSpace?this.mercatorMatrix:i?this.alignedProjMatrix:this.projMatrix,n),r[o]=new Float32Array(n),r[o]}calculatePixelsToTileUnitsMatrix(t){const i=t.tileID.key,o=this._pixelsToTileUnitsCache;if(o[i])return o[i];const r=function(t,i){const{scale:o}=t.tileTransform,r=o*e.EXTENT/(t.tileSize*Math.pow(2,i.zoom-t.tileID.overscaledZ+t.tileID.canonical.z));return n=new Float32Array(4),l=(a=i.inverseAdjustmentMatrix)[1],c=a[2],h=a[3],_=(s=[r,r])[1],n[0]=a[0]*(u=s[0]),n[1]=l*u,n[2]=c*_,n[3]=h*_,n;var n,a,s,l,c,h,u,_;}(t,this);return o[i]=r,o[i]}customLayerMatrix(){return this.mercatorMatrix.slice()}recenterOnTerrain(){if(!this._elevation||"globe"===this.projection.name)return;const t=this._elevation;this._updateCameraState();const i=e.mercatorZfromAltitude(1,this._center.lat)*this.worldSize,o=this._computeCameraPosition(i),r=this._camera.forward(),n=e.mercatorZfromAltitude(1,this._center.lat);o[2]/=n,r[2]/=n,e.normalize(r,r);const a=t.raycast(o,r,t.exaggeration());if(a){const t=e.scaleAndAdd([],o,r,a),i=new e.MercatorCoordinate(t[0],t[1],e.mercatorZfromAltitude(t[2],e.latFromMercatorY(t[1]))),s=(i.z+e.length([i.x-o[0],i.y-o[1],i.z-o[2]*n]))*this._pixelsPerMercatorPixel;this._seaLevelZoom=this._zoomFromMercatorZ(s),this._centerAltitude=i.toAltitude(),this._center=this.coordinateLocation(i),this._updateZoomFromElevation(),this._constrain(),this._calcMatrices();}}_constrainCameraAltitude(){if(!this._elevation)return;const t=this._elevation;this._updateCameraState();const i=e.mercatorZfromAltitude(1,this._center.lat)*this.worldSize,o=this._computeCameraPosition(i),r=t.getAtPointOrZero(new e.MercatorCoordinate(...o)),n=this._minimumHeightOverTerrain()*Math.cos(e.degToRad(this._maxPitch)),a=this._camera.position[2]-this.pixelsPerMeter/this.worldSize*r;if(a<n){const t=this.locationCoordinate(this._center,this._centerAltitude),i=[t.x-o[0],t.y-o[1],t.z-o[2]],r=e.length(i);i[2]-=(n-a)/this._pixelsPerMercatorPixel;const s=e.length(i);if(0===s)return;e.scale$2(i,i,r/s*this._pixelsPerMercatorPixel),this._camera.position=[t.x-i[0],t.y-i[1],t.z*this._pixelsPerMercatorPixel-i[2]],this._camera.orientation=jo(i,this._camera.up()),this._updateStateFromCamera();}}_constrain(){if(!this.center||!this.width||!this.height||this._constraining)return;this._constraining=!0;const t="globe"===this.projection.name||this.mercatorFromTransition;if(this.projection.isReprojectedInTileSpace||t){const i=this.center;return i.lat=e.clamp(i.lat,this.minLat,this.maxLat),(this.maxBounds||!this.renderWorldCopies&&!t)&&(i.lng=e.clamp(i.lng,this.minLng,this.maxLng)),this.center=i,void(this._constraining=!1)}const i=this._unmodified,{x:o,y:r}=this.point;let n=0,a=o,s=r;const l=this.width/2,c=this.height/2,h=this.worldMinY*this.scale,u=this.worldMaxY*this.scale;if(r-c<h&&(s=h+c),r+c>u&&(s=u-c),u-h<this.height&&(n=Math.max(n,this.height/(u-h)),s=(u+h)/2),this.maxBounds||!this._renderWorldCopies||!this.projection.wrap){const e=this.worldMinX*this.scale,t=this.worldMaxX*this.scale,i=this.worldSize/2-(e+t)/2;a=(o+i+this.worldSize)%this.worldSize-i,a-l<e&&(a=e+l),a+l>t&&(a=t-l),t-e<this.width&&(n=Math.max(n,this.width/(t-e)),a=(t+e)/2);}a===o&&s===r||(this.center=this.unproject(new e.pointGeometry(a,s))),n&&(this.zoom+=this.scaleZoom(n)),this._constrainCameraAltitude(),this._unmodified=i,this._constraining=!1;}_minZoomForBounds(){let e=Math.max(0,this.scaleZoom(this.height/(this.worldMaxY-this.worldMinY)));return this.maxBounds&&(e=Math.max(e,this.scaleZoom(this.width/(this.worldMaxX-this.worldMinX)))),e}_maxCameraBoundsDistance(){return this._mercatorZfromZoom(this._minZoomForBounds())}_calcMatrices(){if(!this.height)return;const t=this.centerOffset,i=this.pixelsPerMeter;"globe"===this.projection.name&&(this._mercatorScaleRatio=e.mercatorZfromAltitude(1,this.center.lat)/e.mercatorZfromAltitude(1,e.GLOBE_SCALE_MATCH_LATITUDE));const o=qo(this.projection,this.zoom,this.width,this.height,1024);this._pixelsPerMercatorPixel=this.projection.pixelSpaceConversion(this.center.lat,this.worldSize,o),this.cameraToCenterDistance=.5/Math.tan(.5*this._fov)*this.height*this._pixelsPerMercatorPixel,this._updateCameraState(),this._farZ=this.projection.farthestPixelDistance(this),this._nearZ=this.height/50;const r=this._camera.getWorldToCamera(this.worldSize,"meters"===this.projection.zAxisUnit?i:1),n=this._camera.getCameraToClipPerspective(this._fov,this.width/this.height,this._nearZ,this._farZ);n[8]=2*-t.x/this.width,n[9]=2*t.y/this.height;let a=e.mul([],n,r);if(this.projection.isReprojectedInTileSpace){const t=this.locationCoordinate(this.center),i=e.identity([]);e.translate(i,i,[t.x*this.worldSize,t.y*this.worldSize,0]),e.multiply(i,i,Wo(this)),e.translate(i,i,[-t.x*this.worldSize,-t.y*this.worldSize,0]),e.multiply(a,a,i),this.inverseAdjustmentMatrix=function(e){const t=Wo(e,!0);return v([],[t[0],t[1],t[4],t[5]])}(this);}else this.inverseAdjustmentMatrix=[1,0,0,1];this.mercatorMatrix=e.scale([],a,[this.worldSize,this.worldSize,this.worldSize/i,1]),this.projMatrix=a,this.invProjMatrix=e.invert(new Float64Array(16),this.projMatrix);const s=e.invert([],n);this.frustumCorners=e.FrustumCorners.fromInvProjectionMatrix(s,this.horizonLineFromTop(),this.height);const l=new Float32Array(16);e.identity(l),e.scale(l,l,[1,-1,1]),e.rotateX(l,l,this._pitch),e.rotateZ(l,l,this.angle);const c=e.perspective(new Float32Array(16),this._fov,this.width/this.height,this._nearZ,this._farZ),h=(Math.PI/2-this._pitch)*(this.height/this._fov)*this._horizonShift;c[8]=2*-t.x/this.width,c[9]=2*(t.y+h)/this.height,this.skyboxMatrix=e.multiply(l,c,l);const u=this.point,_=u.x,d=u.y,p=this.width%2/2,m=this.height%2/2,f=Math.cos(this.angle),g=Math.sin(this.angle),x=_-Math.round(_)+f*p+g*m,y=d-Math.round(d)+f*m+g*p,b=new Float64Array(a);if(e.translate(b,b,[x>.5?x-1:x,y>.5?y-1:y,0]),this.alignedProjMatrix=b,a=e.create(),e.scale(a,a,[this.width/2,-this.height/2,1]),e.translate(a,a,[1,-1,0]),this.labelPlaneMatrix=a,a=e.create(),e.scale(a,a,[1,-1,1]),e.translate(a,a,[-1,-1,0]),e.scale(a,a,[2/this.width,2/this.height,1]),this.glCoordMatrix=a,this.pixelMatrix=e.multiply(new Float64Array(16),this.labelPlaneMatrix,this.projMatrix),this._calcFogMatrices(),this._distanceTileDataCache={},a=e.invert(new Float64Array(16),this.pixelMatrix),!a)throw new Error("failed to invert matrix");if(this.pixelMatrixInverse=a,"globe"===this.projection.name||this.mercatorFromTransition){this.globeMatrix=e.calculateGlobeMatrix(this);const t=[this.globeMatrix[12],this.globeMatrix[13],this.globeMatrix[14]];this.globeCenterInViewSpace=e.transformMat4(t,t,r),this.globeRadius=this.worldSize/2/Math.PI-1;}else this.globeMatrix=a;this._projMatrixCache={},this._alignedProjMatrixCache={},this._pixelsToTileUnitsCache={};}_calcFogMatrices(){this._fogTileMatrixCache={};const t=this.cameraWorldSize,i=this.cameraPixelsPerMeter,o=this._camera.position,r=1/this.height/this._pixelsPerMercatorPixel,n=[t,t,i];e.scale$2(n,n,r),e.scale$2(o,o,-1),e.multiply$2(o,o,n);const a=e.create();e.translate(a,a,o),e.scale(a,a,n),this.mercatorFogMatrix=a,this.worldToFogMatrix=this._camera.getWorldToCameraPosition(t,i,r);}_computeCameraPosition(e){const t=(e=e||this.pixelsPerMeter)/this.pixelsPerMeter,i=this._camera.forward(),o=this.point,r=this._mercatorZfromZoom(this._seaLevelZoom?this._seaLevelZoom:this._zoom)*t-e/this.worldSize*this._centerAltitude;return [o.x/this.worldSize-i[0]*r,o.y/this.worldSize-i[1]*r,e/this.worldSize*this._centerAltitude-i[2]*r]}_updateCameraState(){this.height&&(this._camera.setPitchBearing(this._pitch,this.angle),this._camera.position=this._computeCameraPosition());}_translateCameraConstrained(t){const i=this._maxCameraBoundsDistance()*Math.cos(this._pitch),o=t[2];let r=1;o>0&&(r=Math.min((i-this._camera.position[2])/o,1)),this._camera.position=e.scaleAndAdd([],this._camera.position,t,r),this._updateStateFromCamera(),this.projection.wrap&&(this.center=this.center.wrap());}_updateStateFromCamera(){const t=this._camera.position,i=this._camera.forward(),{pitch:o,bearing:r}=this._camera.getPitchBearing(),n=e.mercatorZfromAltitude(this._centerAltitude,this.center.lat)*this._pixelsPerMercatorPixel,a=this._mercatorZfromZoom(this._maxZoom)*Math.cos(e.degToRad(this._maxPitch)),s=Math.max((t[2]-n)/Math.cos(o),a),l=this._zoomFromMercatorZ(s);e.scaleAndAdd(t,t,i,s),this._pitch=e.clamp(o,e.degToRad(this.minPitch),e.degToRad(this.maxPitch)),this.angle=e.wrap(r,-Math.PI,Math.PI),this._setZoom(e.clamp(l,this._minZoom,this._maxZoom)),this._updateSeaLevelZoom(),this._center=this.coordinateLocation(new e.MercatorCoordinate(t[0],t[1],t[2])),this._unmodified=!1,this._constrain(),this._calcMatrices();}_worldSizeFromZoom(e){return Math.pow(2,e)*this.tileSize}_mercatorZfromZoom(e){return this.cameraToCenterDistance/this._worldSizeFromZoom(e)}_minimumHeightOverTerrain(){const e=Math.min((null!=this._seaLevelZoom?this._seaLevelZoom:this._zoom)+2,this._maxZoom);return this._mercatorZfromZoom(e)}_zoomFromMercatorZ(e){return this.scaleZoom(this.cameraToCenterDistance/(e*this.tileSize))}_terrainEnabled(){return !(!this._elevation||!this.projection.supportsTerrain&&(e.warnOnce("Terrain is not yet supported with alternate projections. Use mercator or globe to enable terrain."),1))}anyCornerOffEdge(t,i){const o=Math.min(t.x,i.x),r=Math.max(t.x,i.x),n=Math.min(t.y,i.y),a=Math.max(t.y,i.y);if(n<this.horizonLineFromTop(!1))return !0;if("mercator"!==this.projection.name)return !1;const s=[new e.pointGeometry(o,n),new e.pointGeometry(r,a),new e.pointGeometry(o,a),new e.pointGeometry(r,n)],l=this.renderWorldCopies?-3:0,c=this.renderWorldCopies?4:1;for(const e of s){const t=this.pointRayIntersection(e);if(t.t<0)return !0;const i=this.rayIntersectionCoordinate(t);if(i.x<l||i.y<0||i.x>c||i.y>1)return !0}return !1}isHorizonVisible(){return this.pitch+e.radToDeg(this.fovAboveCenter)>88||this.anyCornerOffEdge(new e.pointGeometry(0,0),new e.pointGeometry(this.width,this.height))}zoomDeltaToMovement(t,i){const o=e.length(e.sub([],this._camera.position,t)),r=this._zoomFromMercatorZ(o)+i;return o-this._mercatorZfromZoom(r)}getCameraPoint(){if("globe"===this.projection.name){const t=function(t,i){const o=[t[0],t[1],t[2],1];e.transformMat4$1(o,o,i);const r=Math.max(o[3],1e-6);return [o[0]/r,o[1]/r,o[2]/r,r]}([this.globeMatrix[12],this.globeMatrix[13],this.globeMatrix[14]],this.pixelMatrix);return new e.pointGeometry(t[0],t[1])}{const t=Math.tan(this._pitch)*(this.cameraToCenterDistance||1);return this.centerPoint.add(new e.pointGeometry(0,t))}}getCameraToCenterDistance(e){const t=qo(e,this.zoom,this.width,this.height,1024),i=e.pixelSpaceConversion(this.center.lat,this.worldSize,t);return .5/Math.tan(.5*this._fov)*this.height*i}}function Jo(e,t){let i=!1,o=null;const r=()=>{o=null,i&&(e(),o=setTimeout(r,t),i=!1);};return ()=>(i=!0,o||r(),o)}class Qo{constructor(t){this._hashName=t&&encodeURIComponent(t),e.bindAll(["_getCurrentHash","_onHashChange","_updateHash"],this),this._updateHash=Jo(this._updateHashUnthrottled.bind(this),300);}addTo(t){return this._map=t,e.window.addEventListener("hashchange",this._onHashChange,!1),t.on("moveend",this._updateHash),this}remove(){return this._map?(this._map.off("moveend",this._updateHash),e.window.removeEventListener("hashchange",this._onHashChange,!1),clearTimeout(this._updateHash()),this._map=void 0,this):this}getHashString(){const t=this._map;if(!t)return "";const i=er(t);if(this._hashName){const t=this._hashName;let o=!1;const r=e.window.location.hash.slice(1).split("&").map((e=>{const r=e.split("=")[0];return r===t?(o=!0,`${r}=${i}`):e})).filter((e=>e));return o||r.push(`${t}=${i}`),`#${r.join("&")}`}return `#${i}`}_getCurrentHash(){const t=e.window.location.hash.replace("#","");if(this._hashName){let e;return t.split("&").map((e=>e.split("="))).forEach((t=>{t[0]===this._hashName&&(e=t);})),(e&&e[1]||"").split("/")}return t.split("/")}_onHashChange(){const e=this._map;if(!e)return !1;const t=this._getCurrentHash();if(t.length>=3&&!t.some((e=>isNaN(e)))){const i=e.dragRotate.isEnabled()&&e.touchZoomRotate.isEnabled()?+(t[3]||0):e.getBearing();return e.jumpTo({center:[+t[2],+t[1]],zoom:+t[0],bearing:i,pitch:+(t[4]||0)}),!0}return !1}_updateHashUnthrottled(){const t=e.window.location.href.replace(/(#.+)?$/,this.getHashString());e.window.history.replaceState(e.window.history.state,null,t);}}function er(e,t){const i=e.getCenter(),o=Math.round(100*e.getZoom())/100,r=Math.ceil((o*Math.LN2+Math.log(512/360/.5))/Math.LN10),n=Math.pow(10,r),a=Math.round(i.lng*n)/n,s=Math.round(i.lat*n)/n,l=e.getBearing(),c=e.getPitch();let h=t?`/${a}/${s}/${o}`:`${o}/${s}/${a}`;return (l||c)&&(h+="/"+Math.round(10*l)/10),c&&(h+=`/${Math.round(c)}`),h}const tr={linearity:.3,easing:e.bezier(0,0,.3,1)},ir=e.extend({deceleration:2500,maxSpeed:1400},tr),or=e.extend({deceleration:20,maxSpeed:1400},tr),rr=e.extend({deceleration:1e3,maxSpeed:360},tr),nr=e.extend({deceleration:1e3,maxSpeed:90},tr);class ar{constructor(e){this._map=e,this.clear();}clear(){this._inertiaBuffer=[];}record(t){this._drainInertiaBuffer(),this._inertiaBuffer.push({time:e.exported.now(),settings:t});}_drainInertiaBuffer(){const t=this._inertiaBuffer,i=e.exported.now();for(;t.length>0&&i-t[0].time>160;)t.shift();}_onMoveEnd(t){if(this._drainInertiaBuffer(),this._inertiaBuffer.length<2)return;const i={zoom:0,bearing:0,pitch:0,pan:new e.pointGeometry(0,0),pinchAround:void 0,around:void 0};for(const{settings:e}of this._inertiaBuffer)i.zoom+=e.zoomDelta||0,i.bearing+=e.bearingDelta||0,i.pitch+=e.pitchDelta||0,e.panDelta&&i.pan._add(e.panDelta),e.around&&(i.around=e.around),e.pinchAround&&(i.pinchAround=e.pinchAround);const o=this._inertiaBuffer[this._inertiaBuffer.length-1].time-this._inertiaBuffer[0].time,r={};if(i.pan.mag()){const n=lr(i.pan.mag(),o,e.extend({},ir,t||{}));r.offset=i.pan.mult(n.amount/i.pan.mag()),r.center=this._map.transform.center,sr(r,n);}if(i.zoom){const e=lr(i.zoom,o,or);r.zoom=this._map.transform.zoom+e.amount,sr(r,e);}if(i.bearing){const t=lr(i.bearing,o,rr);r.bearing=this._map.transform.bearing+e.clamp(t.amount,-179,179),sr(r,t);}if(i.pitch){const e=lr(i.pitch,o,nr);r.pitch=this._map.transform.pitch+e.amount,sr(r,e);}if(r.zoom||r.bearing){const e=void 0===i.pinchAround?i.around:i.pinchAround;r.around=e?this._map.unproject(e):this._map.getCenter();}return this.clear(),r.noMoveStart=!0,r}}function sr(e,t){(!e.duration||e.duration<t.duration)&&(e.duration=t.duration,e.easing=t.easing);}function lr(t,i,o){const{maxSpeed:r,linearity:n,deceleration:a}=o,s=e.clamp(t*n/(i/1e3),-r,r),l=Math.abs(s)/(a*n);return {easing:o.easing,duration:1e3*l,amount:s*(l/2)}}class cr extends e.Event{preventDefault(){this._defaultPrevented=!0;}get defaultPrevented(){return this._defaultPrevented}constructor(t,i,o,r={}){const n=p(i.getCanvasContainer(),o),a=i.unproject(n);super(t,e.extend({point:n,lngLat:a,originalEvent:o},r)),this._defaultPrevented=!1,this.target=i;}}class hr extends e.Event{preventDefault(){this._defaultPrevented=!0;}get defaultPrevented(){return this._defaultPrevented}constructor(t,i,o){const r="touchend"===t?o.changedTouches:o.touches,n=m(i.getCanvasContainer(),r),a=n.map((e=>i.unproject(e))),s=n.reduce(((e,t,i,o)=>e.add(t.div(o.length))),new e.pointGeometry(0,0));super(t,{points:n,point:s,lngLats:a,lngLat:i.unproject(s),originalEvent:o}),this._defaultPrevented=!1;}}class ur extends e.Event{preventDefault(){this._defaultPrevented=!0;}get defaultPrevented(){return this._defaultPrevented}constructor(e,t,i){super(e,{originalEvent:i}),this._defaultPrevented=!1;}}class _r{constructor(e,t){this._map=e,this._clickTolerance=t.clickTolerance;}reset(){this._mousedownPos=void 0;}wheel(e){return this._firePreventable(new ur(e.type,this._map,e))}mousedown(e,t){return this._mousedownPos=t,this._firePreventable(new cr(e.type,this._map,e))}mouseup(e){this._map.fire(new cr(e.type,this._map,e));}preclick(t){const i=e.extend({},t);i.type="preclick",this._map.fire(new cr(i.type,this._map,i));}click(e,t){this._mousedownPos&&this._mousedownPos.dist(t)>=this._clickTolerance||(this.preclick(e),this._map.fire(new cr(e.type,this._map,e)));}dblclick(e){return this._firePreventable(new cr(e.type,this._map,e))}mouseover(e){this._map.fire(new cr(e.type,this._map,e));}mouseout(e){this._map.fire(new cr(e.type,this._map,e));}touchstart(e){return this._firePreventable(new hr(e.type,this._map,e))}touchmove(e){this._map.fire(new hr(e.type,this._map,e));}touchend(e){this._map.fire(new hr(e.type,this._map,e));}touchcancel(e){this._map.fire(new hr(e.type,this._map,e));}_firePreventable(e){if(this._map.fire(e),e.defaultPrevented)return {}}isEnabled(){return !0}isActive(){return !1}enable(){}disable(){}}class dr{constructor(e){this._map=e;}reset(){this._delayContextMenu=!1,this._contextMenuEvent=void 0;}mousemove(e){this._map.fire(new cr(e.type,this._map,e));}mousedown(){this._delayContextMenu=!0;}mouseup(){this._delayContextMenu=!1,this._contextMenuEvent&&(this._map.fire(new cr("contextmenu",this._map,this._contextMenuEvent)),delete this._contextMenuEvent);}contextmenu(e){this._delayContextMenu?this._contextMenuEvent=e:this._map.fire(new cr(e.type,this._map,e)),this._map.listens("contextmenu")&&e.preventDefault();}isEnabled(){return !0}isActive(){return !1}enable(){}disable(){}}class pr{constructor(e,t){this._map=e,this._el=e.getCanvasContainer(),this._container=e.getContainer(),this._clickTolerance=t.clickTolerance||1;}isEnabled(){return !!this._enabled}isActive(){return !!this._active}enable(){this.isEnabled()||(this._enabled=!0);}disable(){this.isEnabled()&&(this._enabled=!1);}mousedown(e,t){this.isEnabled()&&e.shiftKey&&0===e.button&&(h(),this._startPos=this._lastPos=t,this._active=!0);}mousemoveWindow(e,t){if(!this._active)return;const i=t;if(this._lastPos.equals(i)||!this._box&&i.dist(this._startPos)<this._clickTolerance)return;const o=this._startPos;this._lastPos=i,this._box||(this._box=n("div","mapboxgl-boxzoom",this._container),this._container.classList.add("mapboxgl-crosshair"),this._fireEvent("boxzoomstart",e));const r=Math.min(o.x,i.x),a=Math.max(o.x,i.x),s=Math.min(o.y,i.y),l=Math.max(o.y,i.y);this._map._requestDomTask((()=>{this._box&&(this._box.style.transform=`translate(${r}px,${s}px)`,this._box.style.width=a-r+"px",this._box.style.height=l-s+"px");}));}mouseupWindow(t,i){if(!this._active)return;if(0!==t.button)return;const o=this._startPos,r=i;if(this.reset(),d(),o.x!==r.x||o.y!==r.y)return this._map.fire(new e.Event("boxzoomend",{originalEvent:t})),{cameraAnimation:e=>e.fitScreenCoordinates(o,r,this._map.getBearing(),{linear:!1})};this._fireEvent("boxzoomcancel",t);}keydown(e){this._active&&27===e.keyCode&&(this.reset(),this._fireEvent("boxzoomcancel",e));}blur(){this.reset();}reset(){this._active=!1,this._container.classList.remove("mapboxgl-crosshair"),this._box&&(this._box.remove(),this._box=null),u(),delete this._startPos,delete this._lastPos;}_fireEvent(t,i){return this._map.fire(new e.Event(t,{originalEvent:i}))}}function mr(e,t){const i={};for(let o=0;o<e.length;o++)i[e[o].identifier]=t[o];return i}class fr{constructor(e){this.reset(),this.numTouches=e.numTouches;}reset(){this.centroid=void 0,this.startTime=0,this.touches={},this.aborted=!1;}touchstart(t,i,o){(this.centroid||o.length>this.numTouches)&&(this.aborted=!0),this.aborted||(0===this.startTime&&(this.startTime=t.timeStamp),o.length===this.numTouches&&(this.centroid=function(t){const i=new e.pointGeometry(0,0);for(const e of t)i._add(e);return i.div(t.length)}(i),this.touches=mr(o,i)));}touchmove(e,t,i){if(this.aborted||!this.centroid)return;const o=mr(i,t);for(const e in this.touches){const t=this.touches[e],i=o[e];(!i||i.dist(t)>30)&&(this.aborted=!0);}}touchend(e,t,i){if((!this.centroid||e.timeStamp-this.startTime>500)&&(this.aborted=!0),0===i.length){const e=!this.aborted&&this.centroid;if(this.reset(),e)return e}}}class gr{constructor(e){this.singleTap=new fr(e),this.numTaps=e.numTaps,this.reset();}reset(){this.lastTime=1/0,this.lastTap=void 0,this.count=0,this.singleTap.reset();}touchstart(e,t,i){this.singleTap.touchstart(e,t,i);}touchmove(e,t,i){this.singleTap.touchmove(e,t,i);}touchend(e,t,i){const o=this.singleTap.touchend(e,t,i);if(o){const t=e.timeStamp-this.lastTime<500,i=!this.lastTap||this.lastTap.dist(o)<30;if(t&&i||this.reset(),this.count++,this.lastTime=e.timeStamp,this.lastTap=o,this.count===this.numTaps)return this.reset(),o}}}class vr{constructor(){this._zoomIn=new gr({numTouches:1,numTaps:2}),this._zoomOut=new gr({numTouches:2,numTaps:1}),this.reset();}reset(){this._active=!1,this._zoomIn.reset(),this._zoomOut.reset();}touchstart(e,t,i){this._zoomIn.touchstart(e,t,i),this._zoomOut.touchstart(e,t,i);}touchmove(e,t,i){this._zoomIn.touchmove(e,t,i),this._zoomOut.touchmove(e,t,i);}touchend(e,t,i){const o=this._zoomIn.touchend(e,t,i),r=this._zoomOut.touchend(e,t,i);return o?(this._active=!0,e.preventDefault(),setTimeout((()=>this.reset()),0),{cameraAnimation:t=>t.easeTo({duration:300,zoom:t.getZoom()+1,around:t.unproject(o)},{originalEvent:e})}):r?(this._active=!0,e.preventDefault(),setTimeout((()=>this.reset()),0),{cameraAnimation:t=>t.easeTo({duration:300,zoom:t.getZoom()-1,around:t.unproject(r)},{originalEvent:e})}):void 0}touchcancel(){this.reset();}enable(){this._enabled=!0;}disable(){this._enabled=!1,this.reset();}isEnabled(){return this._enabled}isActive(){return this._active}}const xr={0:1,2:2};class yr{constructor(e){this.reset(),this._clickTolerance=e.clickTolerance||1;}blur(){this.reset();}reset(){this._active=!1,this._moved=!1,this._lastPoint=void 0,this._eventButton=void 0;}_correctButton(e,t){return !1}_move(e,t){return {}}mousedown(e,t){if(this._lastPoint)return;const i=f(e);this._correctButton(e,i)&&(this._lastPoint=t,this._eventButton=i);}mousemoveWindow(e,t){const i=this._lastPoint;if(i)if(e.preventDefault(),null!=this._eventButton&&function(e,t){const i=xr[t];return void 0===e.buttons||(e.buttons&i)!==i}(e,this._eventButton))this.reset();else if(this._moved||!(t.dist(i)<this._clickTolerance))return this._moved=!0,this._lastPoint=t,this._move(i,t)}mouseupWindow(e){this._lastPoint&&f(e)===this._eventButton&&(this._moved&&d(),this.reset());}enable(){this._enabled=!0;}disable(){this._enabled=!1,this.reset();}isEnabled(){return this._enabled}isActive(){return this._active}}class br extends yr{mousedown(e,t){super.mousedown(e,t),this._lastPoint&&(this._active=!0);}_correctButton(e,t){return 0===t&&!e.ctrlKey}_move(e,t){return {around:t,panDelta:t.sub(e)}}}class wr extends yr{_correctButton(e,t){return 0===t&&e.ctrlKey||2===t}_move(e,t){const i=.8*(t.x-e.x);if(i)return this._active=!0,{bearingDelta:i}}contextmenu(e){e.preventDefault();}}class Tr extends yr{_correctButton(e,t){return 0===t&&e.ctrlKey||2===t}_move(e,t){const i=-.5*(t.y-e.y);if(i)return this._active=!0,{pitchDelta:i}}contextmenu(e){e.preventDefault();}}class Er{constructor(t,i){this._map=t,this._el=t.getCanvasContainer(),this._minTouches=1,this._clickTolerance=i.clickTolerance||1,this.reset(),e.bindAll(["_addTouchPanBlocker","_showTouchPanBlockerAlert"],this);}reset(){this._active=!1,this._touches={},this._sum=new e.pointGeometry(0,0);}touchstart(e,t,i){return this._calculateTransform(e,t,i)}touchmove(t,i,o){if(this._active&&!(o.length<this._minTouches)){if(this._map._cooperativeGestures&&!this._map.isMoving()){if(1===o.length&&!e.isFullscreen())return void this._showTouchPanBlockerAlert();"hidden"!==this._alertContainer.style.visibility&&(this._alertContainer.style.visibility="hidden",clearTimeout(this._alertTimer));}return t.cancelable&&t.preventDefault(),this._calculateTransform(t,i,o)}}touchend(e,t,i){this._calculateTransform(e,t,i),this._active&&i.length<this._minTouches&&this.reset();}touchcancel(){this.reset();}_calculateTransform(t,i,o){o.length>0&&(this._active=!0);const r=mr(o,i),n=new e.pointGeometry(0,0),a=new e.pointGeometry(0,0);let s=0;for(const e in r){const t=r[e],i=this._touches[e];i&&(n._add(t),a._add(t.sub(i)),s++,r[e]=t);}if(this._touches=r,s<this._minTouches||!a.mag())return;const l=a.div(s);return this._sum._add(l),this._sum.mag()<this._clickTolerance?void 0:{around:n.div(s),panDelta:l}}enable(){this._enabled=!0,this._map._cooperativeGestures&&(this._addTouchPanBlocker(),this._el.classList.add("mapboxgl-touch-pan-blocker-override","mapboxgl-scrollable-page"));}disable(){this._enabled=!1,this._map._cooperativeGestures&&(clearTimeout(this._alertTimer),this._alertContainer.remove(),this._el.classList.remove("mapboxgl-touch-pan-blocker-override","mapboxgl-scrollable-page")),this.reset();}isEnabled(){return !!this._enabled}isActive(){return !!this._active}_addTouchPanBlocker(){this._map&&!this._alertContainer&&(this._alertContainer=n("div","mapboxgl-touch-pan-blocker",this._map._container),this._alertContainer.textContent=this._map._getUIString("TouchPanBlocker.Message"),this._alertContainer.style.fontSize=`${Math.max(10,Math.min(24,Math.floor(.05*this._el.clientWidth)))}px`);}_showTouchPanBlockerAlert(){this._alertContainer.style.visibility="visible",this._alertContainer.classList.add("mapboxgl-touch-pan-blocker-show"),this._alertContainer.setAttribute("role","alert"),clearTimeout(this._alertTimer),this._alertTimer=setTimeout((()=>{this._alertContainer.classList.remove("mapboxgl-touch-pan-blocker-show"),this._alertContainer.setAttribute("role","null");}),500);}}class Cr{constructor(){this.reset();}reset(){this._active=!1,this._firstTwoTouches=void 0;}_start(e){}_move(e,t,i){return {}}touchstart(e,t,i){this._firstTwoTouches||i.length<2||(this._firstTwoTouches=[i[0].identifier,i[1].identifier],this._start([t[0],t[1]]));}touchmove(e,t,i){const o=this._firstTwoTouches;if(!o)return;e.preventDefault();const[r,n]=o,a=Ir(i,t,r),s=Ir(i,t,n);if(!a||!s)return;const l=this._aroundCenter?null:a.add(s).div(2);return this._move([a,s],l,e)}touchend(e,t,i){if(!this._firstTwoTouches)return;const[o,r]=this._firstTwoTouches,n=Ir(i,t,o),a=Ir(i,t,r);n&&a||(this._active&&d(),this.reset());}touchcancel(){this.reset();}enable(e){this._enabled=!0,this._aroundCenter=!!e&&"center"===e.around;}disable(){this._enabled=!1,this.reset();}isEnabled(){return this._enabled}isActive(){return this._active}}function Ir(e,t,i){for(let o=0;o<e.length;o++)if(e[o].identifier===i)return t[o]}function Mr(e,t){return Math.log(e/t)/Math.LN2}class Sr extends Cr{reset(){super.reset(),this._distance=0,this._startDistance=0;}_start(e){this._startDistance=this._distance=e[0].dist(e[1]);}_move(e,t){const i=this._distance;if(this._distance=e[0].dist(e[1]),this._active||!(Math.abs(Mr(this._distance,this._startDistance))<.1))return this._active=!0,{zoomDelta:Mr(this._distance,i),pinchAround:t}}}function zr(e,t){return 180*e.angleWith(t)/Math.PI}class Dr extends Cr{reset(){super.reset(),this._minDiameter=0,this._startVector=void 0,this._vector=void 0;}_start(e){this._startVector=this._vector=e[0].sub(e[1]),this._minDiameter=e[0].dist(e[1]);}_move(e,t){const i=this._vector;if(this._vector=e[0].sub(e[1]),this._active||!this._isBelowThreshold(this._vector))return this._active=!0,{bearingDelta:zr(this._vector,i),pinchAround:t}}_isBelowThreshold(e){this._minDiameter=Math.min(this._minDiameter,e.mag());const t=25/(Math.PI*this._minDiameter)*360,i=zr(e,this._startVector);return Math.abs(i)<t}}function Pr(e){return Math.abs(e.y)>Math.abs(e.x)}class Ar extends Cr{constructor(e){super(),this._map=e;}reset(){super.reset(),this._valid=void 0,this._firstMove=void 0,this._lastPoints=void 0;}_start(e){this._lastPoints=e,Pr(e[0].sub(e[1]))&&(this._valid=!1);}_move(e,t,i){const o=this._lastPoints;if(!o)return;const r=e[0].sub(o[0]),n=e[1].sub(o[1]);return this._map._cooperativeGestures&&i.touches.length<3||(this._valid=this.gestureBeginsVertically(r,n,i.timeStamp),!this._valid)?void 0:(this._lastPoints=e,this._active=!0,{pitchDelta:(r.y+n.y)/2*-.5})}gestureBeginsVertically(e,t,i){if(void 0!==this._valid)return this._valid;const o=e.mag()>=2,r=t.mag()>=2;if(!o&&!r)return;if(!o||!r)return null==this._firstMove&&(this._firstMove=i),i-this._firstMove<100&&void 0;const n=e.y>0==t.y>0;return Pr(e)&&Pr(t)&&n}}const Lr={panStep:100,bearingStep:15,pitchStep:10};class Rr{constructor(){const e=Lr;this._panStep=e.panStep,this._bearingStep=e.bearingStep,this._pitchStep=e.pitchStep,this._rotationDisabled=!1;}blur(){this.reset();}reset(){this._active=!1;}keydown(e){if(e.altKey||e.ctrlKey||e.metaKey)return;let t=0,i=0,o=0,r=0,n=0;switch(e.keyCode){case 61:case 107:case 171:case 187:t=1;break;case 189:case 109:case 173:t=-1;break;case 37:e.shiftKey?i=-1:(e.preventDefault(),r=-1);break;case 39:e.shiftKey?i=1:(e.preventDefault(),r=1);break;case 38:e.shiftKey?o=1:(e.preventDefault(),n=-1);break;case 40:e.shiftKey?o=-1:(e.preventDefault(),n=1);break;default:return}return this._rotationDisabled&&(i=0,o=0),{cameraAnimation:a=>{const s=a.getZoom();a.easeTo({duration:300,easeId:"keyboardHandler",easing:Or,zoom:t?Math.round(s)+t*(e.shiftKey?2:1):s,bearing:a.getBearing()+i*this._bearingStep,pitch:a.getPitch()+o*this._pitchStep,offset:[-r*this._panStep,-n*this._panStep],center:a.getCenter()},{originalEvent:e});}}}enable(){this._enabled=!0;}disable(){this._enabled=!1,this.reset();}isEnabled(){return this._enabled}isActive(){return this._active}disableRotation(){this._rotationDisabled=!0;}enableRotation(){this._rotationDisabled=!1;}}function Or(e){return e*(2-e)}const Br=4.000244140625;class kr{constructor(t,i){this._map=t,this._el=t.getCanvasContainer(),this._handler=i,this._delta=0,this._defaultZoomRate=.01,this._wheelZoomRate=.0022222222222222222,e.bindAll(["_onTimeout","_addScrollZoomBlocker","_showBlockerAlert"],this);}setZoomRate(e){this._defaultZoomRate=e;}setWheelZoomRate(e){this._wheelZoomRate=e;}isEnabled(){return !!this._enabled}isActive(){return this._active||void 0!==this._finishTimeout}isZooming(){return !!this._zooming}enable(e){this.isEnabled()||(this._enabled=!0,this._aroundCenter=!!e&&"center"===e.around,this._map._cooperativeGestures&&this._addScrollZoomBlocker());}disable(){this.isEnabled()&&(this._enabled=!1,this._map._cooperativeGestures&&(clearTimeout(this._alertTimer),this._alertContainer.remove()));}wheel(t){if(!this.isEnabled())return;if(this._map._cooperativeGestures){if(!(t.ctrlKey||t.metaKey||this.isZooming()||e.isFullscreen()))return void this._showBlockerAlert();"hidden"!==this._alertContainer.style.visibility&&(this._alertContainer.style.visibility="hidden",clearTimeout(this._alertTimer));}let i=t.deltaMode===e.window.WheelEvent.DOM_DELTA_LINE?40*t.deltaY:t.deltaY;const o=e.exported.now(),r=o-(this._lastWheelEventTime||0);this._lastWheelEventTime=o,0!==i&&i%Br==0?this._type="wheel":0!==i&&Math.abs(i)<4?this._type="trackpad":r>400?(this._type=null,this._lastValue=i,this._timeout=setTimeout(this._onTimeout,40,t)):this._type||(this._type=Math.abs(r*i)<200?"trackpad":"wheel",this._timeout&&(clearTimeout(this._timeout),this._timeout=null,i+=this._lastValue)),t.shiftKey&&i&&(i/=4),this._type&&(this._lastWheelEvent=t,this._delta-=i,this._active||this._start(t)),t.preventDefault();}_onTimeout(e){this._type="wheel",this._delta-=this._lastValue,this._active||this._start(e);}_start(e){if(!this._delta)return;this._frameId&&(this._frameId=null),this._active=!0,this.isZooming()||(this._zooming=!0),this._finishTimeout&&(clearTimeout(this._finishTimeout),delete this._finishTimeout);const t=p(this._el,e);this._aroundPoint=this._aroundCenter?this._map.transform.centerPoint:t,this._aroundCoord=this._map.transform.pointCoordinate3D(this._aroundPoint),this._targetZoom=void 0,this._frameId||(this._frameId=!0,this._handler._triggerRenderFrame());}renderFrame(){if(!this._frameId)return;if(this._frameId=null,!this.isActive())return;const t=this._map.transform,i=()=>t._terrainEnabled()&&this._aroundCoord?t.computeZoomRelativeTo(this._aroundCoord):t.zoom;if(0!==this._delta){const e="wheel"===this._type&&Math.abs(this._delta)>Br?this._wheelZoomRate:this._defaultZoomRate;let o=2/(1+Math.exp(-Math.abs(this._delta*e)));this._delta<0&&0!==o&&(o=1/o);const r=i(),n=Math.pow(2,r),a="number"==typeof this._targetZoom?t.zoomScale(this._targetZoom):n;this._targetZoom=Math.min(t.maxZoom,Math.max(t.minZoom,t.scaleZoom(a*o))),"wheel"===this._type&&(this._startZoom=r,this._easing=this._smoothOutEasing(200)),this._delta=0;}const o="number"==typeof this._targetZoom?this._targetZoom:i(),r=this._startZoom,n=this._easing;let a,s=!1;if("wheel"===this._type&&r&&n){const t=Math.min((e.exported.now()-this._lastWheelEventTime)/200,1),i=n(t);a=e.number(r,o,i),t<1?this._frameId||(this._frameId=!0):s=!0;}else a=o,s=!0;return this._active=!0,s&&(this._active=!1,this._finishTimeout=setTimeout((()=>{this._zooming=!1,this._handler._triggerRenderFrame(),delete this._targetZoom,delete this._finishTimeout;}),200)),{noInertia:!0,needsRenderFrame:!s,zoomDelta:a-i(),around:this._aroundPoint,aroundCoord:this._aroundCoord,originalEvent:this._lastWheelEvent}}_smoothOutEasing(t){let i=e.ease;if(this._prevEase){const t=this._prevEase,o=(e.exported.now()-t.start)/t.duration,r=t.easing(o+.01)-t.easing(o),n=.27/Math.sqrt(r*r+1e-4)*.01,a=Math.sqrt(.0729-n*n);i=e.bezier(n,a,.25,1);}return this._prevEase={start:e.exported.now(),duration:t,easing:i},i}blur(){this.reset();}reset(){this._active=!1;}_addScrollZoomBlocker(){this._map&&!this._alertContainer&&(this._alertContainer=n("div","mapboxgl-scroll-zoom-blocker",this._map._container),this._alertContainer.textContent=/(Mac|iPad)/i.test(e.window.navigator.userAgent)?this._map._getUIString("ScrollZoomBlocker.CmdMessage"):this._map._getUIString("ScrollZoomBlocker.CtrlMessage"),this._alertContainer.style.fontSize=`${Math.max(10,Math.min(24,Math.floor(.05*this._el.clientWidth)))}px`);}_showBlockerAlert(){this._alertContainer.style.visibility="visible",this._alertContainer.classList.add("mapboxgl-scroll-zoom-blocker-show"),this._alertContainer.setAttribute("role","alert"),clearTimeout(this._alertTimer),this._alertTimer=setTimeout((()=>{this._alertContainer.classList.remove("mapboxgl-scroll-zoom-blocker-show"),this._alertContainer.setAttribute("role","null");}),200);}}class Fr{constructor(e,t){this._clickZoom=e,this._tapZoom=t;}enable(){this._clickZoom.enable(),this._tapZoom.enable();}disable(){this._clickZoom.disable(),this._tapZoom.disable();}isEnabled(){return this._clickZoom.isEnabled()&&this._tapZoom.isEnabled()}isActive(){return this._clickZoom.isActive()||this._tapZoom.isActive()}}class Ur{constructor(){this.reset();}reset(){this._active=!1;}blur(){this.reset();}dblclick(e,t){return e.preventDefault(),{cameraAnimation:i=>{i.easeTo({duration:300,zoom:i.getZoom()+(e.shiftKey?-1:1),around:i.unproject(t)},{originalEvent:e});}}}enable(){this._enabled=!0;}disable(){this._enabled=!1,this.reset();}isEnabled(){return this._enabled}isActive(){return this._active}}class Nr{constructor(){this._tap=new gr({numTouches:1,numTaps:1}),this.reset();}reset(){this._active=!1,this._swipePoint=void 0,this._swipeTouch=0,this._tapTime=0,this._tap.reset();}touchstart(e,t,i){this._swipePoint||(this._tapTime&&e.timeStamp-this._tapTime>500&&this.reset(),this._tapTime?i.length>0&&(this._swipePoint=t[0],this._swipeTouch=i[0].identifier):this._tap.touchstart(e,t,i));}touchmove(e,t,i){if(this._tapTime){if(this._swipePoint){if(i[0].identifier!==this._swipeTouch)return;const o=t[0],r=o.y-this._swipePoint.y;return this._swipePoint=o,e.preventDefault(),this._active=!0,{zoomDelta:r/128}}}else this._tap.touchmove(e,t,i);}touchend(e,t,i){this._tapTime?this._swipePoint&&0===i.length&&this.reset():this._tap.touchend(e,t,i)&&(this._tapTime=e.timeStamp);}touchcancel(){this.reset();}enable(){this._enabled=!0;}disable(){this._enabled=!1,this.reset();}isEnabled(){return this._enabled}isActive(){return this._active}}class Gr{constructor(e,t,i){this._el=e,this._mousePan=t,this._touchPan=i;}enable(e){this._inertiaOptions=e||{},this._mousePan.enable(),this._touchPan.enable(),this._el.classList.add("mapboxgl-touch-drag-pan");}disable(){this._mousePan.disable(),this._touchPan.disable(),this._el.classList.remove("mapboxgl-touch-drag-pan");}isEnabled(){return this._mousePan.isEnabled()&&this._touchPan.isEnabled()}isActive(){return this._mousePan.isActive()||this._touchPan.isActive()}}class jr{constructor(e,t,i){this._pitchWithRotate=e.pitchWithRotate,this._mouseRotate=t,this._mousePitch=i;}enable(){this._mouseRotate.enable(),this._pitchWithRotate&&this._mousePitch.enable();}disable(){this._mouseRotate.disable(),this._mousePitch.disable();}isEnabled(){return this._mouseRotate.isEnabled()&&(!this._pitchWithRotate||this._mousePitch.isEnabled())}isActive(){return this._mouseRotate.isActive()||this._mousePitch.isActive()}}class Zr{constructor(e,t,i,o){this._el=e,this._touchZoom=t,this._touchRotate=i,this._tapDragZoom=o,this._rotationDisabled=!1,this._enabled=!0;}enable(e){this._touchZoom.enable(e),this._rotationDisabled||this._touchRotate.enable(e),this._tapDragZoom.enable(),this._el.classList.add("mapboxgl-touch-zoom-rotate");}disable(){this._touchZoom.disable(),this._touchRotate.disable(),this._tapDragZoom.disable(),this._el.classList.remove("mapboxgl-touch-zoom-rotate");}isEnabled(){return this._touchZoom.isEnabled()&&(this._rotationDisabled||this._touchRotate.isEnabled())&&this._tapDragZoom.isEnabled()}isActive(){return this._touchZoom.isActive()||this._touchRotate.isActive()||this._tapDragZoom.isActive()}disableRotation(){this._rotationDisabled=!0,this._touchRotate.disable();}enableRotation(){this._rotationDisabled=!1,this._touchZoom.isEnabled()&&this._touchRotate.enable();}}const Vr=e=>e.zoom||e.drag||e.pitch||e.rotate;class Wr extends e.Event{}class Xr{constructor(){this.constants=[1,1,.01],this.radius=0;}setup(t,i){const o=e.sub([],i,t);this.radius=e.length(o[2]<0?e.div([],o,this.constants):[o[0],o[1],0]);}projectRay(t){e.div(t,t,this.constants),e.normalize(t,t),e.mul$1(t,t,this.constants);const i=e.scale$2([],t,this.radius);if(i[2]>0){const t=e.scale$2([],[0,0,1],e.dot(i,[0,0,1])),o=e.scale$2([],e.normalize([],[i[0],i[1],0]),this.radius),r=e.add([],i,e.scale$2([],e.sub([],e.add([],o,t),i),2));i[0]=r[0],i[1]=r[1];}return i}}function qr(e){return e.panDelta&&e.panDelta.mag()||e.zoomDelta||e.bearingDelta||e.pitchDelta}class $r{constructor(t,i){this._map=t,this._el=this._map.getCanvasContainer(),this._handlers=[],this._handlersById={},this._changes=[],this._inertia=new ar(t),this._bearingSnap=i.bearingSnap,this._previousActiveHandlers={},this._trackingEllipsoid=new Xr,this._dragOrigin=null,this._eventsInProgress={},this._addDefaultHandlers(i),e.bindAll(["handleEvent","handleWindowEvent"],this);const o=this._el;this._listeners=[[o,"touchstart",{passive:!0}],[o,"touchmove",{passive:!1}],[o,"touchend",void 0],[o,"touchcancel",void 0],[o,"mousedown",void 0],[o,"mousemove",void 0],[o,"mouseup",void 0],[e.window.document,"mousemove",{capture:!0}],[e.window.document,"mouseup",void 0],[o,"mouseover",void 0],[o,"mouseout",void 0],[o,"dblclick",void 0],[o,"click",void 0],[o,"keydown",{capture:!1}],[o,"keyup",void 0],[o,"wheel",{passive:!1}],[o,"contextmenu",void 0],[e.window,"blur",void 0]];for(const[t,i,o]of this._listeners)t.addEventListener(i,t===e.window.document?this.handleWindowEvent:this.handleEvent,o);}destroy(){for(const[t,i,o]of this._listeners)t.removeEventListener(i,t===e.window.document?this.handleWindowEvent:this.handleEvent,o);}_addDefaultHandlers(e){const t=this._map,i=t.getCanvasContainer();this._add("mapEvent",new _r(t,e));const o=t.boxZoom=new pr(t,e);this._add("boxZoom",o);const r=new vr,n=new Ur;t.doubleClickZoom=new Fr(n,r),this._add("tapZoom",r),this._add("clickZoom",n);const a=new Nr;this._add("tapDragZoom",a);const s=t.touchPitch=new Ar(t);this._add("touchPitch",s);const l=new wr(e),c=new Tr(e);t.dragRotate=new jr(e,l,c),this._add("mouseRotate",l,["mousePitch"]),this._add("mousePitch",c,["mouseRotate"]);const h=new br(e),u=new Er(t,e);t.dragPan=new Gr(i,h,u),this._add("mousePan",h),this._add("touchPan",u,["touchZoom","touchRotate"]);const _=new Dr,d=new Sr;t.touchZoomRotate=new Zr(i,d,_,a),this._add("touchRotate",_,["touchPan","touchZoom"]),this._add("touchZoom",d,["touchPan","touchRotate"]),this._add("blockableMapEvent",new dr(t));const p=t.scrollZoom=new kr(t,this);this._add("scrollZoom",p,["mousePan"]);const m=t.keyboard=new Rr;this._add("keyboard",m);for(const i of ["boxZoom","doubleClickZoom","tapDragZoom","touchPitch","dragRotate","dragPan","touchZoomRotate","scrollZoom","keyboard"])e.interactive&&e[i]&&t[i].enable(e[i]);}_add(e,t,i){this._handlers.push({handlerName:e,handler:t,allowed:i}),this._handlersById[e]=t;}stop(e){if(!this._updatingCamera){for(const{handler:e}of this._handlers)e.reset();this._inertia.clear(),this._fireEvents({},{},e),this._changes=[];}}isActive(){for(const{handler:e}of this._handlers)if(e.isActive())return !0;return !1}isZooming(){return !!this._eventsInProgress.zoom||this._map.scrollZoom.isZooming()}isRotating(){return !!this._eventsInProgress.rotate}isMoving(){return !!Vr(this._eventsInProgress)||this.isZooming()}_blockedByActive(e,t,i){for(const o in e)if(o!==i&&(!t||t.indexOf(o)<0))return !0;return !1}handleWindowEvent(e){this.handleEvent(e,`${e.type}Window`);}_getMapTouches(e){const t=[];for(const i of e)this._el.contains(i.target)&&t.push(i);return t}handleEvent(e,t){this._updatingCamera=!0;const i="renderFrame"===e.type,o=i?void 0:e,r={needsRenderFrame:!1},n={},a={},s=e.touches?this._getMapTouches(e.touches):void 0,l=s?m(this._el,s):i?void 0:p(this._el,e);for(const{handlerName:i,handler:c,allowed:h}of this._handlers){if(!c.isEnabled())continue;let u;this._blockedByActive(a,h,i)?c.reset():c[t||e.type]&&(u=c[t||e.type](e,l,s),this.mergeHandlerResult(r,n,u,i,o),u&&u.needsRenderFrame&&this._triggerRenderFrame()),(u||c.isActive())&&(a[i]=c);}const c={};for(const e in this._previousActiveHandlers)a[e]||(c[e]=o);this._previousActiveHandlers=a,(Object.keys(c).length||qr(r))&&(this._changes.push([r,n,c]),this._triggerRenderFrame()),(Object.keys(a).length||qr(r))&&this._map._stop(!0),this._updatingCamera=!1;const{cameraAnimation:h}=r;h&&(this._inertia.clear(),this._fireEvents({},{},!0),this._changes=[],h(this._map));}mergeHandlerResult(t,i,o,r,n){if(!o)return;e.extend(t,o);const a={handlerName:r,originalEvent:o.originalEvent||n};void 0!==o.zoomDelta&&(i.zoom=a),void 0!==o.panDelta&&(i.drag=a),void 0!==o.pitchDelta&&(i.pitch=a),void 0!==o.bearingDelta&&(i.rotate=a);}_applyChanges(){const t={},i={},o={};for(const[r,n,a]of this._changes)r.panDelta&&(t.panDelta=(t.panDelta||new e.pointGeometry(0,0))._add(r.panDelta)),r.zoomDelta&&(t.zoomDelta=(t.zoomDelta||0)+r.zoomDelta),r.bearingDelta&&(t.bearingDelta=(t.bearingDelta||0)+r.bearingDelta),r.pitchDelta&&(t.pitchDelta=(t.pitchDelta||0)+r.pitchDelta),void 0!==r.around&&(t.around=r.around),void 0!==r.aroundCoord&&(t.aroundCoord=r.aroundCoord),void 0!==r.pinchAround&&(t.pinchAround=r.pinchAround),r.noInertia&&(t.noInertia=r.noInertia),e.extend(i,n),e.extend(o,a);this._updateMapTransform(t,i,o),this._changes=[];}_updateMapTransform(t,i,o){const r=this._map,n=r.transform,a=e=>[e.x,e.y,e.z];if((e=>{const t=this._eventsInProgress.drag;return t&&!this._handlersById[t.handlerName].isActive()})()&&!qr(t)){const e=n.zoom;n.cameraElevationReference="sea",n.recenterOnTerrain(),n.cameraElevationReference="ground",e!==n.zoom&&this._map._update(!0);}if(!qr(t))return void this._fireEvents(i,o,!0);let{panDelta:s,zoomDelta:l,bearingDelta:c,pitchDelta:h,around:u,aroundCoord:_,pinchAround:d}=t;void 0!==d&&(u=d),(e=>i.drag&&!this._eventsInProgress.drag)()&&u&&(this._dragOrigin=a(n.pointCoordinate3D(u)),this._trackingEllipsoid.setup(n._camera.position,this._dragOrigin)),n.cameraElevationReference="sea",r._stop(!0),u=u||r.transform.centerPoint,c&&(n.bearing+=c),h&&(n.pitch+=h),n._updateCameraState();const p=[0,0,0];if(s)if("mercator"===n.projection.name){const e=this._trackingEllipsoid.projectRay(n.screenPointToMercatorRay(u).dir),t=this._trackingEllipsoid.projectRay(n.screenPointToMercatorRay(u.sub(s)).dir);p[0]=t[0]-e[0],p[1]=t[1]-e[1];}else {const t=n.pointCoordinate(u);if("globe"===n.projection.name){s=s.rotate(-n.angle);const i=n._pixelsPerMercatorPixel/n.worldSize;p[0]=-s.x*e.mercatorScale(e.latFromMercatorY(t.y))*i,p[1]=-s.y*e.mercatorScale(n.center.lat)*i;}else {const e=n.pointCoordinate(u.sub(s));t&&e&&(p[0]=e.x-t.x,p[1]=e.y-t.y);}}const m=n.zoom,f=[0,0,0];if(l){const t=a(_||n.pointCoordinate3D(u)),i={dir:e.normalize([],e.sub([],t,n._camera.position))};if(i.dir[2]<0){const o=n.zoomDeltaToMovement(t,l);e.scale$2(f,i.dir,o);}}const g=e.add(p,p,f);n._translateCameraConstrained(g),l&&Math.abs(n.zoom-m)>1e-4&&n.recenterOnTerrain(),n.cameraElevationReference="ground",this._map._update(),t.noInertia||this._inertia.record(t),this._fireEvents(i,o,!0);}_fireEvents(t,i,o){const r=Vr(this._eventsInProgress),n=Vr(t),a={};for(const e in t){const{originalEvent:i}=t[e];this._eventsInProgress[e]||(a[`${e}start`]=i),this._eventsInProgress[e]=t[e];}!r&&n&&this._fireEvent("movestart",n.originalEvent);for(const e in a)this._fireEvent(e,a[e]);n&&this._fireEvent("move",n.originalEvent);for(const e in t){const{originalEvent:i}=t[e];this._fireEvent(e,i);}const s={};let l;for(const e in this._eventsInProgress){const{handlerName:t,originalEvent:o}=this._eventsInProgress[e];this._handlersById[t].isActive()||(delete this._eventsInProgress[e],l=i[t]||o,s[`${e}end`]=l);}for(const e in s)this._fireEvent(e,s[e]);const c=Vr(this._eventsInProgress);if(o&&(r||n)&&!c){this._updatingCamera=!0;const t=this._inertia._onMoveEnd(this._map.dragPan._inertiaOptions),i=e=>0!==e&&-this._bearingSnap<e&&e<this._bearingSnap;t?(i(t.bearing||this._map.getBearing())&&(t.bearing=0),this._map.easeTo(t,{originalEvent:l})):(this._map.fire(new e.Event("moveend",{originalEvent:l})),i(this._map.getBearing())&&this._map.resetNorth()),this._updatingCamera=!1;}}_fireEvent(t,i){this._map.fire(new e.Event(t,i?{originalEvent:i}:{}));}_requestFrame(){return this._map.triggerRepaint(),this._map._renderTaskQueue.add((e=>{this._frameId=void 0,this.handleEvent(new Wr("renderFrame",{timeStamp:e})),this._applyChanges();}))}_triggerRenderFrame(){void 0===this._frameId&&(this._frameId=this._requestFrame());}}const Hr="map.setFreeCameraOptions(...) and map.getFreeCameraOptions() are not yet supported for non-mercator projections.";class Yr extends e.Evented{constructor(t,i){super(),this._moving=!1,this._zooming=!1,this.transform=t,this._bearingSnap=i.bearingSnap,e.bindAll(["_renderFrameCallback"],this);}getCenter(){return new e.LngLat(this.transform.center.lng,this.transform.center.lat)}setCenter(e,t){return this.jumpTo({center:e},t)}panBy(t,i,o){return t=e.pointGeometry.convert(t).mult(-1),this.panTo(this.transform.center,e.extend({offset:t},i),o)}panTo(t,i,o){return this.easeTo(e.extend({center:t},i),o)}getZoom(){return this.transform.zoom}setZoom(e,t){return this.jumpTo({zoom:e},t),this}zoomTo(t,i,o){return this.easeTo(e.extend({zoom:t},i),o)}zoomIn(e,t){return this.zoomTo(this.getZoom()+1,e,t),this}zoomOut(e,t){return this.zoomTo(this.getZoom()-1,e,t),this}getBearing(){return this.transform.bearing}setBearing(e,t){return this.jumpTo({bearing:e},t),this}getPadding(){return this.transform.padding}setPadding(e,t){return this.jumpTo({padding:e},t),this}rotateTo(t,i,o){return this.easeTo(e.extend({bearing:t},i),o)}resetNorth(t,i){return this.rotateTo(0,e.extend({duration:1e3},t),i),this}resetNorthPitch(t,i){return this.easeTo(e.extend({bearing:0,pitch:0,duration:1e3},t),i),this}snapToNorth(e,t){return Math.abs(this.getBearing())<this._bearingSnap?this.resetNorth(e,t):this}getPitch(){return this.transform.pitch}setPitch(e,t){return this.jumpTo({pitch:e},t),this}cameraForBounds(t,i){"globe"===this.transform.projection.name&&e.warnOnce('Globe projection does not support cameraForBounds API, this API may behave unexpectedly."'),t=e.LngLatBounds.convert(t);const o=i&&i.bearing||0;return this._cameraForBoxAndBearing(t.getNorthWest(),t.getSouthEast(),o,i)}_extendCameraOptions(t){const i={top:0,bottom:0,right:0,left:0};if("number"==typeof(t=e.extend({padding:i,offset:[0,0],maxZoom:this.transform.maxZoom},t)).padding){const e=t.padding;t.padding={top:e,bottom:e,right:e,left:e};}return t.padding=e.extend(i,t.padding),t}_cameraForBoxAndBearing(t,i,o,r){const n=this._extendCameraOptions(r),a=this.transform,s=a.padding,l=a.project(e.LngLat.convert(t)),c=a.project(e.LngLat.convert(i)),h=new e.pointGeometry(l.x,c.y),u=new e.pointGeometry(c.x,l.y),_=-e.degToRad(o),d=l.rotate(_),p=c.rotate(_),m=h.rotate(_),f=u.rotate(_),g=new e.pointGeometry(Math.max(d.x,p.x,m.x,f.x),Math.max(d.y,p.y,m.y,f.y)),v=new e.pointGeometry(Math.min(d.x,p.x,m.x,f.x),Math.min(d.y,p.y,m.y,f.y)),x=g.sub(v),y=(a.width-((s.left||0)+(s.right||0)+n.padding.left+n.padding.right))/x.x,b=(a.height-((s.top||0)+(s.bottom||0)+n.padding.top+n.padding.bottom))/x.y;if(b<0||y<0)return void e.warnOnce("Map cannot fit within canvas with the given bounds, padding, and/or offset.");const w=Math.min(a.scaleZoom(a.scale*Math.min(y,b)),n.maxZoom),T="number"==typeof n.offset.x&&"number"==typeof n.offset.y?new e.pointGeometry(n.offset.x,n.offset.y):e.pointGeometry.convert(n.offset),E=new e.pointGeometry((n.padding.left-n.padding.right)/2,(n.padding.top-n.padding.bottom)/2).rotate(o*Math.PI/180),C=T.add(E).mult(a.scale/a.zoomScale(w));return {center:a.unproject(l.add(c).div(2).sub(C)),zoom:w,bearing:o}}_cameraForBox(t,i,o,r,n){const a=this._extendCameraOptions(n);o=o||0,r=r||0,t=e.LngLat.convert(t),i=e.LngLat.convert(i);const s=this.transform.clone();s.padding=a.padding;const l=this.getFreeCameraOptions(),c=new e.LngLat(.5*(t.lng+i.lng),.5*(t.lat+i.lat)),h=.5*(o+r);if(s._camera.position[2]<e.mercatorZfromAltitude(h,c.lat))return void e.warnOnce("Map cannot fit within canvas with the given bounds, padding, and/or offset.");l.lookAtPoint(c),s.setFreeCameraOptions(l);const u=e.MercatorCoordinate.fromLngLat(t),_=e.MercatorCoordinate.fromLngLat(i),d=s.pointRayIntersection(s.centerPoint,h),p=[(m=s.rayIntersectionCoordinate(d)).x,m.y,m.z];var m;const f=s.screenPointToMercatorRay(s.centerPoint),g="globe"!==s.projection.name;let v,x=0;do{const t=Math.floor(s.zoom),i=1<<t,n=Math.min(i*u.x,i*_.x),a=Math.min(i*u.y,i*_.y),l=Math.max(i*u.x,i*_.x),c=Math.max(i*u.y,i*_.y),h=new e.Aabb([n,a,o],[l,c,r]),d=e.Frustum.fromInvProjectionMatrix(s.invProjMatrix,s.worldSize,t,g);if(2!==h.intersects(d)){v&&(s._camera.position=e.scaleAndAdd([],s._camera.position,f.dir,-v),s._updateStateFromCamera());break}const m=e.sub([],s._camera.position,p);v=.5*e.length(m),s._camera.position=e.scaleAndAdd([],s._camera.position,f.dir,v);try{s._updateStateFromCamera();}catch(t){return void e.warnOnce("Map cannot fit within canvas with the given bounds, padding, and/or offset.")}}while(++x<10);return {center:s.center,zoom:s.zoom,bearing:s.bearing,pitch:s.pitch}}fitBounds(t,i,o){return "globe"===this.transform.projection.name&&e.warnOnce("Globe projection does not support fitBounds API, this API may behave unexpectedly."),this._fitInternal(this.cameraForBounds(t,i),i,o)}_raycastElevationBox(t,i){const o=this.transform.elevation;if(!o)return;const r=new e.pointGeometry(t.x,i.y),n=new e.pointGeometry(i.x,t.y),a=o.pointCoordinate(t);if(!a)return;const s=o.pointCoordinate(i);if(!s)return;const l=o.pointCoordinate(r);if(!l)return;const c=o.pointCoordinate(n);if(!c)return;const h=new e.MercatorCoordinate(a[0],a[1]).toLngLat(),u=new e.MercatorCoordinate(s[0],s[1]).toLngLat(),_=new e.MercatorCoordinate(l[0],l[1]).toLngLat(),d=new e.MercatorCoordinate(c[0],c[1]).toLngLat(),p=Math.min(h.lng,Math.min(u.lng,Math.min(_.lng,d.lng))),m=Math.min(h.lat,Math.min(u.lat,Math.min(_.lat,d.lat))),f=Math.max(h.lng,Math.max(u.lng,Math.max(_.lng,d.lng))),g=Math.max(h.lat,Math.max(u.lat,Math.max(_.lat,d.lat))),v=Math.min(a[3],Math.min(s[3],Math.min(l[3],c[3]))),x=Math.max(a[3],Math.max(s[3],Math.max(l[3],c[3])));return {minLngLat:new e.LngLat(p,m),maxLngLat:new e.LngLat(f,g),minAltitude:v,maxAltitude:x}}fitScreenCoordinates(t,i,o,r,n){let a,s,l,c;"globe"===this.transform.projection.name&&e.warnOnce("Globe projection does not support fitScreenCoordinates API, this API may behave unexpectedly.");const h=e.pointGeometry.convert(t),u=e.pointGeometry.convert(i),_=this._raycastElevationBox(h,u);if(_)a=_.minLngLat,s=_.maxLngLat,l=_.minAltitude,c=_.maxAltitude;else {if(this.transform.anyCornerOffEdge(h,u))return this;a=this.transform.pointLocation(h),s=this.transform.pointLocation(u);}return this._fitInternal(0===this.transform.pitch?this._cameraForBoxAndBearing(this.transform.pointLocation(e.pointGeometry.convert(t)),this.transform.pointLocation(e.pointGeometry.convert(i)),o,r):this._cameraForBox(a,s,l,c,r),r,n)}_fitInternal(t,i,o){return t?(delete(i=e.extend(t,i)).padding,i.linear?this.easeTo(i,o):this.flyTo(i,o)):this}jumpTo(t,i){this.stop();const o=t.preloadOnly?this.transform.clone():this.transform;let r=!1,n=!1,a=!1;return "zoom"in t&&o.zoom!==+t.zoom&&(r=!0,o.zoom=+t.zoom),void 0!==t.center&&(o.center=e.LngLat.convert(t.center)),"bearing"in t&&o.bearing!==+t.bearing&&(n=!0,o.bearing=+t.bearing),"pitch"in t&&o.pitch!==+t.pitch&&(a=!0,o.pitch=+t.pitch),null==t.padding||o.isPaddingEqual(t.padding)||(o.padding=t.padding),t.preloadOnly?(this._preloadTiles(o),this):(this.fire(new e.Event("movestart",i)).fire(new e.Event("move",i)),r&&this.fire(new e.Event("zoomstart",i)).fire(new e.Event("zoom",i)).fire(new e.Event("zoomend",i)),n&&this.fire(new e.Event("rotatestart",i)).fire(new e.Event("rotate",i)).fire(new e.Event("rotateend",i)),a&&this.fire(new e.Event("pitchstart",i)).fire(new e.Event("pitch",i)).fire(new e.Event("pitchend",i)),this.fire(new e.Event("moveend",i)))}getFreeCameraOptions(){return this.transform.projection.supportsFreeCamera||e.warnOnce(Hr),this.transform.getFreeCameraOptions()}setFreeCameraOptions(t,i){const o=this.transform;if(!o.projection.supportsFreeCamera)return e.warnOnce(Hr),this;this.stop();const r=o.zoom,n=o.pitch,a=o.bearing;o.setFreeCameraOptions(t);const s=r!==o.zoom,l=n!==o.pitch,c=a!==o.bearing;return this.fire(new e.Event("movestart",i)).fire(new e.Event("move",i)),s&&this.fire(new e.Event("zoomstart",i)).fire(new e.Event("zoom",i)).fire(new e.Event("zoomend",i)),c&&this.fire(new e.Event("rotatestart",i)).fire(new e.Event("rotate",i)).fire(new e.Event("rotateend",i)),l&&this.fire(new e.Event("pitchstart",i)).fire(new e.Event("pitch",i)).fire(new e.Event("pitchend",i)),this.fire(new e.Event("moveend",i)),this}easeTo(t,i){this._stop(!1,t.easeId),(!1===(t=e.extend({offset:[0,0],duration:500,easing:e.ease},t)).animate||!t.essential&&e.exported.prefersReducedMotion)&&(t.duration=0);const o=this.transform,r=this.getZoom(),n=this.getBearing(),a=this.getPitch(),s=this.getPadding(),l="zoom"in t?+t.zoom:r,c="bearing"in t?this._normalizeBearing(t.bearing,n):n,h="pitch"in t?+t.pitch:a,u="padding"in t?t.padding:o.padding,_=e.pointGeometry.convert(t.offset);let d,p,m;if("globe"===o.projection.name){const i=e.MercatorCoordinate.fromLngLat(o.center),r=_.rotate(-o.angle);i.x+=r.x/o.worldSize,i.y+=r.y/o.worldSize;const n=i.toLngLat(),a=e.LngLat.convert(t.center||n);this._normalizeCenter(a),d=o.centerPoint.add(r),p=new e.pointGeometry(i.x,i.y).mult(o.worldSize),m=new e.pointGeometry(e.mercatorXfromLng(a.lng),e.mercatorYfromLat(a.lat)).mult(o.worldSize).sub(p);}else {d=o.centerPoint.add(_);const i=o.pointLocation(d),r=e.LngLat.convert(t.center||i);this._normalizeCenter(r),p=o.project(i),m=o.project(r).sub(p);}const f=o.zoomScale(l-r);let g,v;t.around&&(g=e.LngLat.convert(t.around),v=o.locationPoint(g));const x=this._zooming||l!==r,y=this._rotating||n!==c,b=this._pitching||h!==a,w=!o.isPaddingEqual(u),T=o=>T=>{if(x&&(o.zoom=e.number(r,l,T)),y&&(o.bearing=e.number(n,c,T)),b&&(o.pitch=e.number(a,h,T)),w&&(o.interpolatePadding(s,u,T),d=o.centerPoint.add(_)),g)o.setLocationAtPoint(g,v);else {const e=o.zoomScale(o.zoom-r),t=l>r?Math.min(2,f):Math.max(.5,f),i=Math.pow(t,1-T),n=o.unproject(p.add(m.mult(T*i)).mult(e));o.setLocationAtPoint(o.renderWorldCopies?n.wrap():n,d);}return t.preloadOnly||this._fireMoveEvents(i),o};if(t.preloadOnly){const e=this._emulate(T,t.duration,o);return this._preloadTiles(e),this}const E={moving:this._moving,zooming:this._zooming,rotating:this._rotating,pitching:this._pitching};return this._zooming=x,this._rotating=y,this._pitching=b,this._padding=w,this._easeId=t.easeId,this._prepareEase(i,t.noMoveStart,E),this._ease(T(o),(e=>{o.recenterOnTerrain(),this._afterEase(i,e);}),t),this}_prepareEase(t,i,o={}){this._moving=!0,this.transform.cameraElevationReference="sea",i||o.moving||this.fire(new e.Event("movestart",t)),this._zooming&&!o.zooming&&this.fire(new e.Event("zoomstart",t)),this._rotating&&!o.rotating&&this.fire(new e.Event("rotatestart",t)),this._pitching&&!o.pitching&&this.fire(new e.Event("pitchstart",t));}_fireMoveEvents(t){this.fire(new e.Event("move",t)),this._zooming&&this.fire(new e.Event("zoom",t)),this._rotating&&this.fire(new e.Event("rotate",t)),this._pitching&&this.fire(new e.Event("pitch",t));}_afterEase(t,i){if(this._easeId&&i&&this._easeId===i)return;this._easeId=void 0,this.transform.cameraElevationReference="ground";const o=this._zooming,r=this._rotating,n=this._pitching;this._moving=!1,this._zooming=!1,this._rotating=!1,this._pitching=!1,this._padding=!1,o&&this.fire(new e.Event("zoomend",t)),r&&this.fire(new e.Event("rotateend",t)),n&&this.fire(new e.Event("pitchend",t)),this.fire(new e.Event("moveend",t));}flyTo(t,i){if(!t.essential&&e.exported.prefersReducedMotion){const o=e.pick(t,["center","zoom","bearing","pitch","around"]);return this.jumpTo(o,i)}this.stop(),t=e.extend({offset:[0,0],speed:1.2,curve:1.42,easing:e.ease},t);const o=this.transform,r=this.getZoom(),n=this.getBearing(),a=this.getPitch(),s=this.getPadding(),l="zoom"in t?e.clamp(+t.zoom,o.minZoom,o.maxZoom):r,c="bearing"in t?this._normalizeBearing(t.bearing,n):n,h="pitch"in t?+t.pitch:a,u="padding"in t?t.padding:o.padding,_=o.zoomScale(l-r),d=e.pointGeometry.convert(t.offset);let p=o.centerPoint.add(d);const m=o.pointLocation(p),f=e.LngLat.convert(t.center||m);this._normalizeCenter(f);const g=o.project(m),v=o.project(f).sub(g);let x=t.curve;const y=Math.max(o.width,o.height),b=y/_,w=v.mag();if("minZoom"in t){const i=e.clamp(Math.min(t.minZoom,r,l),o.minZoom,o.maxZoom),n=y/o.zoomScale(i-r);x=Math.sqrt(n/w*2);}const T=x*x;function E(e){const t=(b*b-y*y+(e?-1:1)*T*T*w*w)/(2*(e?b:y)*T*w);return Math.log(Math.sqrt(t*t+1)-t)}function C(e){return (Math.exp(e)-Math.exp(-e))/2}function I(e){return (Math.exp(e)+Math.exp(-e))/2}const M=E(0);let S=function(e){return I(M)/I(M+x*e)},z=function(e){return y*((I(M)*(C(t=M+x*e)/I(t))-C(M))/T)/w;var t;},D=(E(1)-M)/x;if(Math.abs(w)<1e-6||!isFinite(D)){if(Math.abs(y-b)<1e-6)return this.easeTo(t,i);const e=b<y?-1:1;D=Math.abs(Math.log(b/y))/x,z=function(){return 0},S=function(t){return Math.exp(e*x*t)};}t.duration="duration"in t?+t.duration:1e3*D/("screenSpeed"in t?+t.screenSpeed/x:+t.speed),t.maxDuration&&t.duration>t.maxDuration&&(t.duration=0);const P=n!==c,A=h!==a,L=!o.isPaddingEqual(u),R=o=>_=>{const m=_*D,x=1/S(m);o.zoom=1===_?l:r+o.scaleZoom(x),P&&(o.bearing=e.number(n,c,_)),A&&(o.pitch=e.number(a,h,_)),L&&(o.interpolatePadding(s,u,_),p=o.centerPoint.add(d));const y=1===_?f:o.unproject(g.add(v.mult(z(m))).mult(x));return o.setLocationAtPoint(o.renderWorldCopies?y.wrap():y,p),o._updateCameraOnTerrain(),t.preloadOnly||this._fireMoveEvents(i),o};if(t.preloadOnly){const e=this._emulate(R,t.duration,o);return this._preloadTiles(e),this}return this._zooming=!0,this._rotating=P,this._pitching=A,this._padding=L,this._prepareEase(i,!1),this._ease(R(o),(()=>this._afterEase(i)),t),this}isEasing(){return !!this._easeFrameId}stop(){return this._stop()}_stop(e,t){if(this._easeFrameId&&(this._cancelRenderFrame(this._easeFrameId),this._easeFrameId=void 0,this._onEaseFrame=void 0),this._onEaseEnd){const e=this._onEaseEnd;this._onEaseEnd=void 0,e.call(this,t);}if(!e){const e=this.handlers;e&&e.stop(!1);}return this}_ease(t,i,o){!1===o.animate||0===o.duration?(t(1),i()):(this._easeStart=e.exported.now(),this._easeOptions=o,this._onEaseFrame=t,this._onEaseEnd=i,this._easeFrameId=this._requestRenderFrame(this._renderFrameCallback));}_renderFrameCallback(){const t=Math.min((e.exported.now()-this._easeStart)/this._easeOptions.duration,1),i=this._onEaseFrame;i&&i(this._easeOptions.easing(t)),t<1?this._easeFrameId=this._requestRenderFrame(this._renderFrameCallback):this.stop();}_normalizeBearing(t,i){t=e.wrap(t,-180,180);const o=Math.abs(t-i);return Math.abs(t-360-i)<o&&(t-=360),Math.abs(t+360-i)<o&&(t+=360),t}_normalizeCenter(e){const t=this.transform;if(!t.renderWorldCopies||t.maxBounds)return;const i=e.lng-t.center.lng;e.lng+=i>180?-360:i<-180?360:0;}_emulate(e,t,i){const o=Math.ceil(15*t/1e3),r=[],n=e(i.clone());for(let e=0;e<=o;e++){const t=n(e/o);r.push(t.clone());}return r}}class Kr{constructor(t={}){this.options=t,e.bindAll(["_toggleAttribution","_updateEditLink","_updateData","_updateCompact"],this);}getDefaultPosition(){return "bottom-right"}onAdd(e){const t=this.options&&this.options.compact;return this._map=e,this._container=n("div","mapboxgl-ctrl mapboxgl-ctrl-attrib"),this._compactButton=n("button","mapboxgl-ctrl-attrib-button",this._container),n("span","mapboxgl-ctrl-icon",this._compactButton).setAttribute("aria-hidden","true"),this._compactButton.type="button",this._compactButton.addEventListener("click",this._toggleAttribution),this._setElementTitle(this._compactButton,"ToggleAttribution"),this._innerContainer=n("div","mapboxgl-ctrl-attrib-inner",this._container),this._innerContainer.setAttribute("role","list"),t&&this._container.classList.add("mapboxgl-compact"),this._updateAttributions(),this._updateEditLink(),this._map.on("styledata",this._updateData),this._map.on("sourcedata",this._updateData),this._map.on("moveend",this._updateEditLink),void 0===t&&(this._map.on("resize",this._updateCompact),this._updateCompact()),this._container}onRemove(){this._container.remove(),this._map.off("styledata",this._updateData),this._map.off("sourcedata",this._updateData),this._map.off("moveend",this._updateEditLink),this._map.off("resize",this._updateCompact),this._map=void 0,this._attribHTML=void 0;}_setElementTitle(e,t){const i=this._map._getUIString(`AttributionControl.${t}`);e.setAttribute("aria-label",i),e.removeAttribute("title"),e.firstElementChild&&e.firstElementChild.setAttribute("title",i);}_toggleAttribution(){this._container.classList.contains("mapboxgl-compact-show")?(this._container.classList.remove("mapboxgl-compact-show"),this._compactButton.setAttribute("aria-expanded","false")):(this._container.classList.add("mapboxgl-compact-show"),this._compactButton.setAttribute("aria-expanded","true"));}_updateEditLink(){let t=this._editLink;t||(t=this._editLink=this._container.querySelector(".mapbox-improve-map"));const i=[{key:"owner",value:this.styleOwner},{key:"id",value:this.styleId},{key:"access_token",value:this._map._requestManager._customAccessToken||e.config.ACCESS_TOKEN}];if(t){const o=i.reduce(((e,t,o)=>(t.value&&(e+=`${t.key}=${t.value}${o<i.length-1?"&":""}`),e)),"?");t.href=`${e.config.FEEDBACK_URL}/${o}#${er(this._map,!0)}`,t.rel="noopener nofollow",this._setElementTitle(t,"MapFeedback");}}_updateData(e){!e||"metadata"!==e.sourceDataType&&"visibility"!==e.sourceDataType&&"style"!==e.dataType||(this._updateAttributions(),this._updateEditLink());}_updateAttributions(){if(!this._map.style)return;let e=[];if(this._map.style.stylesheet){const e=this._map.style.stylesheet;this.styleOwner=e.owner,this.styleId=e.id;}const t=this._map.style._sourceCaches;for(const i in t){const o=t[i];if(o.used){const t=o.getSource();t.attribution&&e.indexOf(t.attribution)<0&&e.push(t.attribution);}}e.sort(((e,t)=>e.length-t.length)),e=e.filter(((t,i)=>{for(let o=i+1;o<e.length;o++)if(e[o].indexOf(t)>=0)return !1;return !0})),this.options.customAttribution&&(Array.isArray(this.options.customAttribution)?e=[...this.options.customAttribution,...e]:e.unshift(this.options.customAttribution));const i=e.join(" | ");i!==this._attribHTML&&(this._attribHTML=i,e.length?(this._innerContainer.innerHTML=i,this._container.classList.remove("mapboxgl-attrib-empty")):this._container.classList.add("mapboxgl-attrib-empty"),this._editLink=null);}_updateCompact(){this._map.getCanvasContainer().offsetWidth<=640?this._container.classList.add("mapboxgl-compact"):this._container.classList.remove("mapboxgl-compact","mapboxgl-compact-show");}}class Jr{constructor(){e.bindAll(["_updateLogo","_updateCompact"],this);}onAdd(e){this._map=e,this._container=n("div","mapboxgl-ctrl");const t=n("a","mapboxgl-ctrl-logo");return t.target="_blank",t.rel="noopener nofollow",t.href="https://www.mapbox.com/",t.setAttribute("aria-label",this._map._getUIString("LogoControl.Title")),t.setAttribute("rel","noopener nofollow"),this._container.appendChild(t),this._container.style.display="none",this._map.on("sourcedata",this._updateLogo),this._updateLogo(),this._map.on("resize",this._updateCompact),this._updateCompact(),this._container}onRemove(){this._container.remove(),this._map.off("sourcedata",this._updateLogo),this._map.off("resize",this._updateCompact);}getDefaultPosition(){return "bottom-left"}_updateLogo(e){e&&"metadata"!==e.sourceDataType||(this._container.style.display=this._logoRequired()?"block":"none");}_logoRequired(){if(!this._map.style)return !0;const e=this._map.style._sourceCaches;if(0===Object.entries(e).length)return !0;for(const t in e){const i=e[t].getSource();if(i.hasOwnProperty("mapbox_logo")&&!i.mapbox_logo)return !1}return !0}_updateCompact(){const e=this._container.children;if(e.length){const t=e[0];this._map.getCanvasContainer().offsetWidth<250?t.classList.add("mapboxgl-compact"):t.classList.remove("mapboxgl-compact");}}}class Qr{constructor(){this._queue=[],this._id=0,this._cleared=!1,this._currentlyRunning=!1;}add(e){const t=++this._id;return this._queue.push({callback:e,id:t,cancelled:!1}),t}remove(e){const t=this._currentlyRunning,i=t?this._queue.concat(t):this._queue;for(const t of i)if(t.id===e)return void(t.cancelled=!0)}run(e=0){const t=this._currentlyRunning=this._queue;this._queue=[];for(const i of t)if(!i.cancelled&&(i.callback(e),this._cleared))break;this._cleared=!1,this._currentlyRunning=!1;}clear(){this._currentlyRunning&&(this._cleared=!0),this._queue=[];}}function en(t,i,o){if(t=new e.LngLat(t.lng,t.lat),i){const r=new e.LngLat(t.lng-360,t.lat),n=new e.LngLat(t.lng+360,t.lat),a=360*Math.ceil(Math.abs(t.lng-o.center.lng)/360),s=o.locationPoint(t).distSqr(i),l=i.x<0||i.y<0||i.x>o.width||i.y>o.height;o.locationPoint(r).distSqr(i)<s&&(l||Math.abs(r.lng-o.center.lng)<a)?t=r:o.locationPoint(n).distSqr(i)<s&&(l||Math.abs(n.lng-o.center.lng)<a)&&(t=n);}for(;Math.abs(t.lng-o.center.lng)>180;){const e=o.locationPoint(t);if(e.x>=0&&e.y>=0&&e.x<=o.width&&e.y<=o.height)break;t.lng>o.center.lng?t.lng-=360:t.lng+=360;}return t}const tn={center:"translate(-50%,-50%)",top:"translate(-50%,0)","top-left":"translate(0,0)","top-right":"translate(-100%,0)",bottom:"translate(-50%,-100%)","bottom-left":"translate(0,-100%)","bottom-right":"translate(-100%,-100%)",left:"translate(0,-50%)",right:"translate(-100%,-50%)"};class on extends e.Evented{constructor(t,i){if(super(),(t instanceof e.window.HTMLElement||i)&&(t=e.extend({element:t},i)),e.bindAll(["_update","_onMove","_onUp","_addDragHandler","_onMapClick","_onKeyPress","_clearFadeTimer"],this),this._anchor=t&&t.anchor||"center",this._color=t&&t.color||"#3FB1CE",this._scale=t&&t.scale||1,this._draggable=t&&t.draggable||!1,this._clickTolerance=t&&t.clickTolerance||0,this._isDragging=!1,this._state="inactive",this._rotation=t&&t.rotation||0,this._rotationAlignment=t&&t.rotationAlignment||"auto",this._pitchAlignment=t&&t.pitchAlignment&&t.pitchAlignment||"auto",this._updateMoving=()=>this._update(!0),t&&t.element)this._element=t.element,this._offset=e.pointGeometry.convert(t&&t.offset||[0,0]);else {this._defaultMarker=!0,this._element=n("div");const i=41,o=27,r=a("svg",{display:"block",height:i*this._scale+"px",width:o*this._scale+"px",viewBox:`0 0 ${o} ${i}`},this._element),s=a("radialGradient",{id:"shadowGradient"},a("defs",{},r));a("stop",{offset:"10%","stop-opacity":.4},s),a("stop",{offset:"100%","stop-opacity":.05},s),a("ellipse",{cx:13.5,cy:34.8,rx:10.5,ry:5.25,fill:"url(#shadowGradient)"},r),a("path",{fill:this._color,d:"M27,13.5C27,19.07 20.25,27 14.75,34.5C14.02,35.5 12.98,35.5 12.25,34.5C6.75,27 0,19.22 0,13.5C0,6.04 6.04,0 13.5,0C20.96,0 27,6.04 27,13.5Z"},r),a("path",{opacity:.25,d:"M13.5,0C6.04,0 0,6.04 0,13.5C0,19.22 6.75,27 12.25,34.5C13,35.52 14.02,35.5 14.75,34.5C20.25,27 27,19.07 27,13.5C27,6.04 20.96,0 13.5,0ZM13.5,1C20.42,1 26,6.58 26,13.5C26,15.9 24.5,19.18 22.22,22.74C19.95,26.3 16.71,30.14 13.94,33.91C13.74,34.18 13.61,34.32 13.5,34.44C13.39,34.32 13.26,34.18 13.06,33.91C10.28,30.13 7.41,26.31 5.02,22.77C2.62,19.23 1,15.95 1,13.5C1,6.58 6.58,1 13.5,1Z"},r),a("circle",{fill:"white",cx:13.5,cy:13.5,r:5.5},r),this._offset=e.pointGeometry.convert(t&&t.offset||[0,-14]);}this._element.hasAttribute("aria-label")||this._element.setAttribute("aria-label","Map marker"),this._element.classList.add("mapboxgl-marker"),this._element.addEventListener("dragstart",(e=>{e.preventDefault();})),this._element.addEventListener("mousedown",(e=>{e.preventDefault();}));const o=this._element.classList;for(const e in tn)o.remove(`mapboxgl-marker-anchor-${e}`);o.add(`mapboxgl-marker-anchor-${this._anchor}`),this._popup=null;}addTo(e){return e===this._map||(this.remove(),this._map=e,e.getCanvasContainer().appendChild(this._element),e.on("move",this._updateMoving),e.on("moveend",this._update),e.on("remove",this._clearFadeTimer),e._addMarker(this),this.setDraggable(this._draggable),this._update(),e.on("click",this._onMapClick)),this}remove(){const e=this._map;return e&&(e.off("click",this._onMapClick),e.off("move",this._updateMoving),e.off("moveend",this._update),e.off("mousedown",this._addDragHandler),e.off("touchstart",this._addDragHandler),e.off("mouseup",this._onUp),e.off("touchend",this._onUp),e.off("mousemove",this._onMove),e.off("touchmove",this._onMove),e.off("remove",this._clearFadeTimer),e._removeMarker(this),this._map=void 0),this._clearFadeTimer(),this._element.remove(),this._popup&&this._popup.remove(),this}getLngLat(){return this._lngLat}setLngLat(t){return this._lngLat=e.LngLat.convert(t),this._pos=null,this._popup&&this._popup.setLngLat(this._lngLat),this._update(!0),this}getElement(){return this._element}setPopup(e){if(this._popup&&(this._popup.remove(),this._popup=null,this._element.removeAttribute("role"),this._element.removeEventListener("keypress",this._onKeyPress),this._originalTabIndex||this._element.removeAttribute("tabindex")),e){if(!("offset"in e.options)){const t=38.1,i=13.5,o=Math.sqrt(Math.pow(i,2)/2);e.options.offset=this._defaultMarker?{top:[0,0],"top-left":[0,0],"top-right":[0,0],bottom:[0,-t],"bottom-left":[o,-1*(t-i+o)],"bottom-right":[-o,-1*(t-i+o)],left:[i,-1*(t-i)],right:[-i,-1*(t-i)]}:this._offset;}this._popup=e,e._marker=this,this._lngLat&&this._popup.setLngLat(this._lngLat),this._element.setAttribute("role","button"),this._originalTabIndex=this._element.getAttribute("tabindex"),this._originalTabIndex||this._element.setAttribute("tabindex","0"),this._element.addEventListener("keypress",this._onKeyPress),this._element.setAttribute("aria-expanded","false");}return this}_onKeyPress(e){const t=e.code,i=e.charCode||e.keyCode;"Space"!==t&&"Enter"!==t&&32!==i&&13!==i||this.togglePopup();}_onMapClick(e){const t=e.originalEvent.target,i=this._element;this._popup&&(t===i||i.contains(t))&&this.togglePopup();}getPopup(){return this._popup}togglePopup(){const e=this._popup;return e?(e.isOpen()?(e.remove(),this._element.setAttribute("aria-expanded","false")):this._map&&(e.addTo(this._map),this._element.setAttribute("aria-expanded","true")),this):this}_behindTerrain(){const e=this._map;if(!e)return !1;const t=e.unproject(this._pos),i=e.getFreeCameraOptions();if(!i.position)return !1;const o=i.position.toLngLat();return o.distanceTo(t)<.9*o.distanceTo(this._lngLat)}_evaluateOpacity(){const t=this._map;if(!t)return;const i=this._pos;if(!i||i.x<0||i.x>t.transform.width||i.y<0||i.y>t.transform.height)return void this._clearFadeTimer();const o=t.unproject(i);let r;t._showingGlobe()&&e.isLngLatBehindGlobe(t.transform,this._lngLat)?r=0:(r=1-t._queryFogOpacity(o),t.transform._terrainEnabled()&&t.getTerrain()&&this._behindTerrain()&&(r*=.2)),this._element.style.opacity=`${r}`,this._element.style.pointerEvents=r>0?"auto":"none",this._popup&&this._popup._setOpacity(r),this._fadeTimer=null;}_clearFadeTimer(){this._fadeTimer&&(clearTimeout(this._fadeTimer),this._fadeTimer=null);}_updateDOM(){const e=this._pos;if(!e||!this._map)return;const t=this._offset.mult(this._scale);this._element.style.transform=`\n            translate(${e.x}px,${e.y}px)\n            ${tn[this._anchor]}\n            ${this._calculateXYTransform()} ${this._calculateZTransform()}\n            translate(${t.x}px,${t.y}px)\n        `;}_calculateXYTransform(){const t=this._pos,i=this._map,o=this.getPitchAlignment();if(!i||!t||"map"!==o)return "";if(!i._showingGlobe()){const e=i.getPitch();return e?`rotateX(${e}deg)`:""}const r=e.radToDeg(e.globeTiltAtLngLat(i.transform,this._lngLat)),n=t.sub(e.globeCenterToScreenPoint(i.transform)),a=Math.abs(n.x)+Math.abs(n.y);if(0===a)return "";const s=r/a;return `rotateX(${-n.y*s}deg) rotateY(${n.x*s}deg)`}_calculateZTransform(){const t=this._pos,i=this._map;if(!i||!t)return "";let o=0;const r=this.getRotationAlignment();if("map"===r)if(i._showingGlobe()){const t=i.project(new e.LngLat(this._lngLat.lng,this._lngLat.lat+.001)),r=i.project(new e.LngLat(this._lngLat.lng,this._lngLat.lat-.001)).sub(t);o=e.radToDeg(Math.atan2(r.y,r.x))-90;}else o=-i.getBearing();else if("horizon"===r){const r=e.smoothstep(4,6,i.getZoom()),n=e.globeCenterToScreenPoint(i.transform);n.y+=r*i.transform.height;const a=t.sub(n),s=e.radToDeg(Math.atan2(a.y,a.x));o=(s>90?s-270:s+90)*(1-r);}return o+=this._rotation,o?`rotateZ(${o}deg)`:""}_update(t){e.window.cancelAnimationFrame(this._updateFrameId);const i=this._map;i&&(i.transform.renderWorldCopies&&(this._lngLat=en(this._lngLat,this._pos,i.transform)),this._pos=i.project(this._lngLat),!0===t?this._updateFrameId=e.window.requestAnimationFrame((()=>{this._element&&this._pos&&this._anchor&&(this._pos=this._pos.round(),this._updateDOM());})):this._pos=this._pos.round(),i._requestDomTask((()=>{this._map&&(this._element&&this._pos&&this._anchor&&this._updateDOM(),(i._showingGlobe()||i.getTerrain()||i.getFog())&&!this._fadeTimer&&(this._fadeTimer=setTimeout(this._evaluateOpacity.bind(this),60)));})));}getOffset(){return this._offset}setOffset(t){return this._offset=e.pointGeometry.convert(t),this._update(),this}_onMove(t){const i=this._map;if(i){if(!this._isDragging){const e=this._clickTolerance||i._clickTolerance;this._isDragging=t.point.dist(this._pointerdownPos)>=e;}this._isDragging&&(this._pos=t.point.sub(this._positionDelta),this._lngLat=i.unproject(this._pos),this.setLngLat(this._lngLat),this._element.style.pointerEvents="none","pending"===this._state&&(this._state="active",this.fire(new e.Event("dragstart"))),this.fire(new e.Event("drag")));}}_onUp(){this._element.style.pointerEvents="auto",this._positionDelta=null,this._pointerdownPos=null,this._isDragging=!1;const t=this._map;t&&(t.off("mousemove",this._onMove),t.off("touchmove",this._onMove)),"active"===this._state&&this.fire(new e.Event("dragend")),this._state="inactive";}_addDragHandler(e){const t=this._map;t&&this._element.contains(e.originalEvent.target)&&(e.preventDefault(),this._positionDelta=e.point.sub(this._pos),this._pointerdownPos=e.point,this._state="pending",t.on("mousemove",this._onMove),t.on("touchmove",this._onMove),t.once("mouseup",this._onUp),t.once("touchend",this._onUp));}setDraggable(e){this._draggable=!!e;const t=this._map;return t&&(e?(t.on("mousedown",this._addDragHandler),t.on("touchstart",this._addDragHandler)):(t.off("mousedown",this._addDragHandler),t.off("touchstart",this._addDragHandler))),this}isDraggable(){return this._draggable}setRotation(e){return this._rotation=e||0,this._update(),this}getRotation(){return this._rotation}setRotationAlignment(e){return this._rotationAlignment=e||"auto",this._update(),this}getRotationAlignment(){return "auto"===this._rotationAlignment||"horizon"===this._rotationAlignment&&this._map&&!this._map._showingGlobe()?"viewport":this._rotationAlignment}setPitchAlignment(e){return this._pitchAlignment=e||"auto",this._update(),this}getPitchAlignment(){return "auto"===this._pitchAlignment?this.getRotationAlignment():this._pitchAlignment}}class rn{constructor(e){this.jumpTo(e);}getValue(t){if(t<=this._startTime)return this._start;if(t>=this._endTime)return this._end;const i=e.easeCubicInOut((t-this._startTime)/(this._endTime-this._startTime));return this._start*(1-i)+this._end*i}isEasing(e){return e>=this._startTime&&e<=this._endTime}jumpTo(e){this._startTime=-1/0,this._endTime=-1/0,this._start=e,this._end=e;}easeTo(e,t,i){this._start=this.getValue(t),this._end=e,this._startTime=t,this._endTime=t+i;}}const nn={"AttributionControl.ToggleAttribution":"Toggle attribution","AttributionControl.MapFeedback":"Map feedback","FullscreenControl.Enter":"Enter fullscreen","FullscreenControl.Exit":"Exit fullscreen","GeolocateControl.FindMyLocation":"Find my location","GeolocateControl.LocationNotAvailable":"Location not available","LogoControl.Title":"Mapbox logo","Map.Title":"Map","NavigationControl.ResetBearing":"Reset bearing to north","NavigationControl.ZoomIn":"Zoom in","NavigationControl.ZoomOut":"Zoom out","ScrollZoomBlocker.CtrlMessage":"Use ctrl + scroll to zoom the map","ScrollZoomBlocker.CmdMessage":"Use ⌘ + scroll to zoom the map","TouchPanBlocker.Message":"Use two fingers to move the map"},an={center:[0,0],zoom:0,bearing:0,pitch:0,minZoom:-2,maxZoom:22,minPitch:0,maxPitch:85,interactive:!0,scrollZoom:!0,boxZoom:!0,dragRotate:!0,dragPan:!0,keyboard:!0,doubleClickZoom:!0,touchZoomRotate:!0,touchPitch:!0,cooperativeGestures:!1,bearingSnap:7,clickTolerance:3,pitchWithRotate:!0,hash:!1,attributionControl:!0,failIfMajorPerformanceCaveat:!1,preserveDrawingBuffer:!1,trackResize:!0,optimizeForTerrain:!0,renderWorldCopies:!0,refreshExpiredTiles:!0,minTileCacheSize:null,maxTileCacheSize:null,localIdeographFontFamily:"sans-serif",localFontFamily:null,transformRequest:null,accessToken:null,fadeDuration:300,crossSourceCollisions:!0};function sn(e){e.parentNode&&e.parentNode.removeChild(e);}const ln={showCompass:!0,showZoom:!0,visualizePitch:!1};class cn{constructor(t,i,o=!1){this._clickTolerance=10,this.element=i,this.mouseRotate=new wr({clickTolerance:t.dragRotate._mouseRotate._clickTolerance}),this.map=t,o&&(this.mousePitch=new Tr({clickTolerance:t.dragRotate._mousePitch._clickTolerance})),e.bindAll(["mousedown","mousemove","mouseup","touchstart","touchmove","touchend","reset"],this),i.addEventListener("mousedown",this.mousedown),i.addEventListener("touchstart",this.touchstart,{passive:!1}),i.addEventListener("touchmove",this.touchmove),i.addEventListener("touchend",this.touchend),i.addEventListener("touchcancel",this.reset);}down(e,t){this.mouseRotate.mousedown(e,t),this.mousePitch&&this.mousePitch.mousedown(e,t),h();}move(e,t){const i=this.map,o=this.mouseRotate.mousemoveWindow(e,t),r=o&&o.bearingDelta;if(r&&i.setBearing(i.getBearing()+r),this.mousePitch){const o=this.mousePitch.mousemoveWindow(e,t),r=o&&o.pitchDelta;r&&i.setPitch(i.getPitch()+r);}}off(){const e=this.element;e.removeEventListener("mousedown",this.mousedown),e.removeEventListener("touchstart",this.touchstart,{passive:!1}),e.removeEventListener("touchmove",this.touchmove),e.removeEventListener("touchend",this.touchend),e.removeEventListener("touchcancel",this.reset),this.offTemp();}offTemp(){u(),e.window.removeEventListener("mousemove",this.mousemove),e.window.removeEventListener("mouseup",this.mouseup);}mousedown(t){this.down(e.extend({},t,{ctrlKey:!0,preventDefault:()=>t.preventDefault()}),p(this.element,t)),e.window.addEventListener("mousemove",this.mousemove),e.window.addEventListener("mouseup",this.mouseup);}mousemove(e){this.move(e,p(this.element,e));}mouseup(e){this.mouseRotate.mouseupWindow(e),this.mousePitch&&this.mousePitch.mouseupWindow(e),this.offTemp();}touchstart(e){1!==e.targetTouches.length?this.reset():(this._startPos=this._lastPos=m(this.element,e.targetTouches)[0],this.down({type:"mousedown",button:0,ctrlKey:!0,preventDefault:()=>e.preventDefault()},this._startPos));}touchmove(e){1!==e.targetTouches.length?this.reset():(this._lastPos=m(this.element,e.targetTouches)[0],this.move({preventDefault:()=>e.preventDefault()},this._lastPos));}touchend(e){0===e.targetTouches.length&&this._startPos&&this._lastPos&&this._startPos.dist(this._lastPos)<this._clickTolerance&&this.element.click(),this.reset();}reset(){this.mouseRotate.reset(),this.mousePitch&&this.mousePitch.reset(),delete this._startPos,delete this._lastPos,this.offTemp();}}const hn={positionOptions:{enableHighAccuracy:!1,maximumAge:0,timeout:6e3},fitBoundsOptions:{maxZoom:15},trackUserLocation:!1,showAccuracyCircle:!0,showUserLocation:!0,showUserHeading:!1},un={maxWidth:100,unit:"metric"};function _n(e,t,i){const o=dn(t),r=o/t,n={kilometer:"km",meter:"m",mile:"mi",foot:"ft","nautical-mile":"nm"}[i];this._map._requestDomTask((()=>{this._container.style.width=e*r+"px",this._container.innerHTML=`${o}&nbsp;${n}`;}));}function dn(e){const t=Math.pow(10,`${Math.floor(e)}`.length-1);let i=e/t;return i=i>=10?10:i>=5?5:i>=3?3:i>=2?2:i>=1?1:function(e){const t=Math.pow(10,Math.ceil(-Math.log(e)/Math.LN10));return Math.round(e*t)/t}(i),t*i}const pn={closeButton:!0,closeOnClick:!0,focusAfterOpen:!0,className:"",maxWidth:"240px"},mn=["a[href]","[tabindex]:not([tabindex='-1'])","[contenteditable]:not([contenteditable='false'])","button:not([disabled])","input:not([disabled])","select:not([disabled])","textarea:not([disabled])"].join(", ");function fn(t=new e.pointGeometry(0,0),i="bottom"){if("number"==typeof t){const o=Math.round(Math.sqrt(.5*Math.pow(t,2)));switch(i){case"top":return new e.pointGeometry(0,t);case"top-left":return new e.pointGeometry(o,o);case"top-right":return new e.pointGeometry(-o,o);case"bottom":return new e.pointGeometry(0,-t);case"bottom-left":return new e.pointGeometry(o,-o);case"bottom-right":return new e.pointGeometry(-o,-o);case"left":return new e.pointGeometry(t,0);case"right":return new e.pointGeometry(-t,0)}return new e.pointGeometry(0,0)}return t instanceof e.pointGeometry||Array.isArray(t)?e.pointGeometry.convert(t):e.pointGeometry.convert(t[i]||[0,0])}const gn={version:e.version,supported:i,setRTLTextPlugin:e.setRTLTextPlugin,getRTLTextPluginStatus:e.getRTLTextPluginStatus,Map:class extends Yr{constructor(t){if(null!=(t=e.extend({},an,t)).minZoom&&null!=t.maxZoom&&t.minZoom>t.maxZoom)throw new Error("maxZoom must be greater than or equal to minZoom");if(null!=t.minPitch&&null!=t.maxPitch&&t.minPitch>t.maxPitch)throw new Error("maxPitch must be greater than or equal to minPitch");if(null!=t.minPitch&&t.minPitch<0)throw new Error("minPitch must be greater than or equal to 0");if(null!=t.maxPitch&&t.maxPitch>85)throw new Error("maxPitch must be less than or equal to 85");if(t.antialias&&e.isSafariWithAntialiasingBug(e.window)&&(t.antialias=!1,e.warnOnce("Antialiasing is disabled for this WebGL context to avoid browser bug: https://github.com/mapbox/mapbox-gl-js/issues/11609")),super(new Ko(t.minZoom,t.maxZoom,t.minPitch,t.maxPitch,t.renderWorldCopies),t),this._interactive=t.interactive,this._minTileCacheSize=t.minTileCacheSize,this._maxTileCacheSize=t.maxTileCacheSize,this._failIfMajorPerformanceCaveat=t.failIfMajorPerformanceCaveat,this._preserveDrawingBuffer=t.preserveDrawingBuffer,this._antialias=t.antialias,this._trackResize=t.trackResize,this._bearingSnap=t.bearingSnap,this._refreshExpiredTiles=t.refreshExpiredTiles,this._fadeDuration=t.fadeDuration,this._isInitialLoad=!0,this._crossSourceCollisions=t.crossSourceCollisions,this._crossFadingFactor=1,this._collectResourceTiming=t.collectResourceTiming,this._optimizeForTerrain=t.optimizeForTerrain,this._language="auto"===t.language?e.window.navigator.language:t.language,this._worldview=t.worldview,this._renderTaskQueue=new Qr,this._domRenderTaskQueue=new Qr,this._controls=[],this._markers=[],this._mapId=e.uniqueId(),this._locale=e.extend({},nn,t.locale),this._clickTolerance=t.clickTolerance,this._cooperativeGestures=t.cooperativeGestures,this._containerWidth=0,this._containerHeight=0,this._averageElevationLastSampledAt=-1/0,this._averageElevationExaggeration=0,this._averageElevation=new rn(0),this._useExplicitProjection=!1,this._requestManager=new e.RequestManager(t.transformRequest,t.accessToken,t.testMode),this._silenceAuthErrors=!!t.testMode,"string"==typeof t.container){if(this._container=e.window.document.getElementById(t.container),!this._container)throw new Error(`Container '${t.container}' not found.`)}else {if(!(t.container instanceof e.window.HTMLElement))throw new Error("Invalid type: 'container' must be a String or HTMLElement.");this._container=t.container;}if(this._container.childNodes.length>0&&e.warnOnce("The map container element should be empty, otherwise the map's interactivity will be negatively impacted. If you want to display a message when WebGL is not supported, use the Mapbox GL Supported plugin instead."),t.maxBounds&&this.setMaxBounds(t.maxBounds),e.bindAll(["_onWindowOnline","_onWindowResize","_onMapScroll","_contextLost","_contextRestored"],this),this._setupContainer(),this._setupPainter(),void 0===this.painter)throw new Error("Failed to initialize WebGL.");this.on("move",(()=>this._update(!1))),this.on("moveend",(()=>this._update(!1))),this.on("zoom",(()=>this._update(!0))),void 0!==e.window&&(e.window.addEventListener("online",this._onWindowOnline,!1),e.window.addEventListener("resize",this._onWindowResize,!1),e.window.addEventListener("orientationchange",this._onWindowResize,!1),e.window.addEventListener("webkitfullscreenchange",this._onWindowResize,!1)),this.handlers=new $r(this,t),this._localFontFamily=t.localFontFamily,this._localIdeographFontFamily=t.localIdeographFontFamily,t.style&&this.setStyle(t.style,{localFontFamily:this._localFontFamily,localIdeographFontFamily:this._localIdeographFontFamily}),t.projection&&this.setProjection(t.projection),this._hash=t.hash&&new Qo("string"==typeof t.hash&&t.hash||void 0).addTo(this),this._hash&&this._hash._onHashChange()||(this.jumpTo({center:t.center,zoom:t.zoom,bearing:t.bearing,pitch:t.pitch}),t.bounds&&(this.resize(),this.fitBounds(t.bounds,e.extend({},t.fitBoundsOptions,{duration:0})))),this.resize(),t.attributionControl&&this.addControl(new Kr({customAttribution:t.customAttribution})),this._logoControl=new Jr,this.addControl(this._logoControl,t.logoPosition),this.on("style.load",(()=>{this.transform.unmodified&&this.jumpTo(this.style.stylesheet);})),this.on("data",(t=>{this._update("style"===t.dataType),this.fire(new e.Event(`${t.dataType}data`,t));})),this.on("dataloading",(t=>{this.fire(new e.Event(`${t.dataType}dataloading`,t));}));}_getMapId(){return this._mapId}addControl(t,i){if(void 0===i&&(i=t.getDefaultPosition?t.getDefaultPosition():"top-right"),!t||!t.onAdd)return this.fire(new e.ErrorEvent(new Error("Invalid argument to map.addControl(). Argument must be a control with onAdd and onRemove methods.")));const o=t.onAdd(this);this._controls.push(t);const r=this._controlPositions[i];return -1!==i.indexOf("bottom")?r.insertBefore(o,r.firstChild):r.appendChild(o),this}removeControl(t){if(!t||!t.onRemove)return this.fire(new e.ErrorEvent(new Error("Invalid argument to map.removeControl(). Argument must be a control with onAdd and onRemove methods.")));const i=this._controls.indexOf(t);return i>-1&&this._controls.splice(i,1),t.onRemove(this),this}hasControl(e){return this._controls.indexOf(e)>-1}getContainer(){return this._container}getCanvasContainer(){return this._canvasContainer}getCanvas(){return this._canvas}resize(t){if(this._updateContainerDimensions(),this._containerWidth===this.transform.width&&this._containerHeight===this.transform.height)return this;this._resizeCanvas(this._containerWidth,this._containerHeight),this.transform.resize(this._containerWidth,this._containerHeight),this.painter.resize(Math.ceil(this._containerWidth),Math.ceil(this._containerHeight));const i=!this._moving;return i&&this.fire(new e.Event("movestart",t)).fire(new e.Event("move",t)),this.fire(new e.Event("resize",t)),i&&this.fire(new e.Event("moveend",t)),this}getBounds(){return "globe"===this.transform.projection.name&&e.warnOnce('Globe projection does not support getBounds API, this API may behave unexpectedly."'),this.transform.getBounds()}getMaxBounds(){return this.transform.getMaxBounds()||null}setMaxBounds(t){return this.transform.setMaxBounds(e.LngLatBounds.convert(t)),this._update()}setMinZoom(t){if((t=null==t?-2:t)>=-2&&t<=this.transform.maxZoom)return this.transform.minZoom=t,this._update(),this.getZoom()<t?this.setZoom(t):this.fire(new e.Event("zoomstart")).fire(new e.Event("zoom")).fire(new e.Event("zoomend")),this;throw new Error("minZoom must be between -2 and the current maxZoom, inclusive")}getMinZoom(){return this.transform.minZoom}setMaxZoom(t){if((t=null==t?22:t)>=this.transform.minZoom)return this.transform.maxZoom=t,this._update(),this.getZoom()>t?this.setZoom(t):this.fire(new e.Event("zoomstart")).fire(new e.Event("zoom")).fire(new e.Event("zoomend")),this;throw new Error("maxZoom must be greater than the current minZoom")}getMaxZoom(){return this.transform.maxZoom}setMinPitch(t){if((t=null==t?0:t)<0)throw new Error("minPitch must be greater than or equal to 0");if(t>=0&&t<=this.transform.maxPitch)return this.transform.minPitch=t,this._update(),this.getPitch()<t?this.setPitch(t):this.fire(new e.Event("pitchstart")).fire(new e.Event("pitch")).fire(new e.Event("pitchend")),this;throw new Error("minPitch must be between 0 and the current maxPitch, inclusive")}getMinPitch(){return this.transform.minPitch}setMaxPitch(t){if((t=null==t?85:t)>85)throw new Error("maxPitch must be less than or equal to 85");if(t>=this.transform.minPitch)return this.transform.maxPitch=t,this._update(),this.getPitch()>t?this.setPitch(t):this.fire(new e.Event("pitchstart")).fire(new e.Event("pitch")).fire(new e.Event("pitchend")),this;throw new Error("maxPitch must be greater than or equal to minPitch")}getMaxPitch(){return this.transform.maxPitch}getRenderWorldCopies(){return this.transform.renderWorldCopies}setRenderWorldCopies(e){return this.transform.renderWorldCopies=e,this._update()}getLanguage(){return this._language}setLanguage(t){if(this._language="auto"===t?e.window.navigator.language:t,this.style)for(const e in this.style._sourceCaches){const t=this.style._sourceCaches[e]._source;t._setLanguage&&t._setLanguage(this._language);}for(const e of this._controls)e._setLanguage&&e._setLanguage(this._language);return this}getWorldview(){return this._worldview}setWorldview(e){if(this._worldview=e,this.style)for(const t in this.style._sourceCaches){const i=this.style._sourceCaches[t]._source;i._setWorldview&&i._setWorldview(e);}return this}getProjection(){return this.transform.mercatorFromTransition?{name:"globe",center:[0,0]}:this.transform.getProjection()}_showingGlobe(){return "globe"===this.transform.projection.name}setProjection(e){return this._lazyInitEmptyStyle(),e?"string"==typeof e&&(e={name:e}):e=null,this._useExplicitProjection=!!e,this._prioritizeAndUpdateProjection(e,this.style.stylesheet?this.style.stylesheet.projection:null)}_updateProjectionTransition(){if("globe"!==this.getProjection().name)return;const t=this.transform,i=t.projection.name;let o;"globe"===i&&t.zoom>=e.GLOBE_ZOOM_THRESHOLD_MAX?(t.setMercatorFromTransition(),o=!0):"mercator"===i&&t.zoom<e.GLOBE_ZOOM_THRESHOLD_MAX&&(t.setProjection({name:"globe"}),o=!0),o&&(this.style.applyProjectionUpdate(),this.style._forceSymbolLayerUpdate());}_prioritizeAndUpdateProjection(e,t){return this._updateProjection(e||t||{name:"mercator"})}_updateProjection(t){let i;if(i="globe"===t.name&&this.transform.zoom>=e.GLOBE_ZOOM_THRESHOLD_MAX?this.transform.setMercatorFromTransition():this.transform.setProjection(t),this.style.applyProjectionUpdate(),i){this.painter.clearBackgroundTiles();for(const e in this.style._sourceCaches)this.style._sourceCaches[e].clearTiles();this._update(!0);}return this}project(t){return this.transform.locationPoint3D(e.LngLat.convert(t))}unproject(t){return this.transform.pointLocation3D(e.pointGeometry.convert(t))}isMoving(){return this._moving||this.handlers&&this.handlers.isMoving()||!1}isZooming(){return this._zooming||this.handlers&&this.handlers.isZooming()||!1}isRotating(){return this._rotating||this.handlers&&this.handlers.isRotating()||!1}_createDelegatedListener(e,t,i){if("mouseenter"===e||"mouseover"===e){let o=!1;const r=r=>{const n=t.filter((e=>this.getLayer(e))),a=n.length?this.queryRenderedFeatures(r.point,{layers:n}):[];a.length?o||(o=!0,i.call(this,new cr(e,this,r.originalEvent,{features:a}))):o=!1;},n=()=>{o=!1;};return {layers:new Set(t),listener:i,delegates:{mousemove:r,mouseout:n}}}if("mouseleave"===e||"mouseout"===e){let o=!1;const r=r=>{const n=t.filter((e=>this.getLayer(e)));(n.length?this.queryRenderedFeatures(r.point,{layers:n}):[]).length?o=!0:o&&(o=!1,i.call(this,new cr(e,this,r.originalEvent)));},n=t=>{o&&(o=!1,i.call(this,new cr(e,this,t.originalEvent)));};return {layers:new Set(t),listener:i,delegates:{mousemove:r,mouseout:n}}}{const o=e=>{const o=t.filter((e=>this.getLayer(e))),r=o.length?this.queryRenderedFeatures(e.point,{layers:o}):[];r.length&&(e.features=r,i.call(this,e),delete e.features);};return {layers:new Set(t),listener:i,delegates:{[e]:o}}}}on(e,t,i){if(void 0===i)return super.on(e,t);Array.isArray(t)||(t=[t]);const o=this._createDelegatedListener(e,t,i);this._delegatedListeners=this._delegatedListeners||{},this._delegatedListeners[e]=this._delegatedListeners[e]||[],this._delegatedListeners[e].push(o);for(const e in o.delegates)this.on(e,o.delegates[e]);return this}once(e,t,i){if(void 0===i)return super.once(e,t);Array.isArray(t)||(t=[t]);const o=this._createDelegatedListener(e,t,i);for(const e in o.delegates)this.once(e,o.delegates[e]);return this}off(e,t,i){if(void 0===i)return super.off(e,t);t=new Set(Array.isArray(t)?t:[t]);const o=(e,t)=>{if(e.size!==t.size)return !1;for(const i of e)if(!t.has(i))return !1;return !0},r=this._delegatedListeners?this._delegatedListeners[e]:void 0;return r&&(e=>{for(let r=0;r<e.length;r++){const n=e[r];if(n.listener===i&&o(n.layers,t)){for(const e in n.delegates)this.off(e,n.delegates[e]);return e.splice(r,1),this}}})(r),this}queryRenderedFeatures(t,i){return this.style?(void 0!==i||void 0===t||t instanceof e.pointGeometry||Array.isArray(t)||(i=t,t=void 0),this.style.queryRenderedFeatures(t=t||[[0,0],[this.transform.width,this.transform.height]],i=i||{},this.transform)):[]}querySourceFeatures(e,t){return this.style.querySourceFeatures(e,t)}queryTerrainElevation(t,i){const o=this.transform.elevation;return o?(i=e.extend({},{exaggerated:!0},i),o.getAtPoint(e.MercatorCoordinate.fromLngLat(t),null,i.exaggerated)):null}setStyle(t,i){return !1!==(i=e.extend({},{localIdeographFontFamily:this._localIdeographFontFamily,localFontFamily:this._localFontFamily},i)).diff&&i.localIdeographFontFamily===this._localIdeographFontFamily&&i.localFontFamily===this._localFontFamily&&this.style&&t?(this._diffStyle(t,i),this):(this._localIdeographFontFamily=i.localIdeographFontFamily,this._localFontFamily=i.localFontFamily,this._updateStyle(t,i))}_getUIString(e){const t=this._locale[e];if(null==t)throw new Error(`Missing UI string '${e}'`);return t}_updateStyle(e,t){return this.style&&(this.style.setEventedParent(null),this.style._remove(),this.style=void 0),e&&(this.style=new ei(this,t||{}),this.style.setEventedParent(this,{style:this.style}),"string"==typeof e?this.style.loadURL(e):this.style.loadJSON(e)),this._updateTerrain(),this}_lazyInitEmptyStyle(){this.style||(this.style=new ei(this,{}),this.style.setEventedParent(this,{style:this.style}),this.style.loadEmpty());}_diffStyle(t,i){if("string"==typeof t){const o=this._requestManager.normalizeStyleURL(t),r=this._requestManager.transformRequest(o,e.ResourceType.Style);e.getJSON(r,((t,o)=>{t?this.fire(new e.ErrorEvent(t)):o&&this._updateDiff(o,i);}));}else "object"==typeof t&&this._updateDiff(t,i);}_updateDiff(t,i){try{this.style.setState(t)&&this._update(!0);}catch(o){e.warnOnce(`Unable to perform style diff: ${o.message||o.error||o}.  Rebuilding the style from scratch.`),this._updateStyle(t,i);}}getStyle(){if(this.style)return this.style.serialize()}isStyleLoaded(){return this.style?this.style.loaded():(e.warnOnce("There is no style added to the map."),!1)}addSource(e,t){return this._lazyInitEmptyStyle(),this.style.addSource(e,t),this._update(!0)}isSourceLoaded(e){return !!this.style&&this.style._isSourceCacheLoaded(e)}areTilesLoaded(){const e=this.style&&this.style._sourceCaches;for(const t in e){const i=e[t]._tiles;for(const e in i){const t=i[e];if("loaded"!==t.state&&"errored"!==t.state)return !1}}return !0}addSourceType(e,t,i){this._lazyInitEmptyStyle(),this.style.addSourceType(e,t,i);}removeSource(e){return this.style.removeSource(e),this._updateTerrain(),this._update(!0)}getSource(e){return this.style.getSource(e)}addImage(t,i,{pixelRatio:o=1,sdf:r=!1,stretchX:n,stretchY:a,content:s}={}){if(this._lazyInitEmptyStyle(),i instanceof e.window.HTMLImageElement||e.window.ImageBitmap&&i instanceof e.window.ImageBitmap){const{width:l,height:c,data:h}=e.exported.getImageData(i);this.style.addImage(t,{data:new e.RGBAImage({width:l,height:c},h),pixelRatio:o,stretchX:n,stretchY:a,content:s,sdf:r,version:0});}else if(void 0===i.width||void 0===i.height)this.fire(new e.ErrorEvent(new Error("Invalid arguments to map.addImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`")));else {const{width:l,height:c}=i,h=i;this.style.addImage(t,{data:new e.RGBAImage({width:l,height:c},new Uint8Array(h.data)),pixelRatio:o,stretchX:n,stretchY:a,content:s,sdf:r,version:0,userImage:h}),h.onAdd&&h.onAdd(this,t);}}updateImage(t,i){const o=this.style.getImage(t);if(!o)return void this.fire(new e.ErrorEvent(new Error("The map has no image with that id. If you are adding a new image use `map.addImage(...)` instead.")));const r=i instanceof e.window.HTMLImageElement||e.window.ImageBitmap&&i instanceof e.window.ImageBitmap?e.exported.getImageData(i):i,{width:n,height:a}=r;void 0!==n&&void 0!==a?n===o.data.width&&a===o.data.height?(o.data.replace(r.data,!(i instanceof e.window.HTMLImageElement||e.window.ImageBitmap&&i instanceof e.window.ImageBitmap)),this.style.updateImage(t,o)):this.fire(new e.ErrorEvent(new Error(`The width and height of the updated image (${n}, ${a})\n                must be that same as the previous version of the image\n                (${o.data.width}, ${o.data.height})`))):this.fire(new e.ErrorEvent(new Error("Invalid arguments to map.updateImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`")));}hasImage(t){return t?!!this.style.getImage(t):(this.fire(new e.ErrorEvent(new Error("Missing required image id"))),!1)}removeImage(e){this.style.removeImage(e);}loadImage(t,i){e.getImage(this._requestManager.transformRequest(t,e.ResourceType.Image),((t,o)=>{i(t,o instanceof e.window.HTMLImageElement?e.exported.getImageData(o):o);}));}listImages(){return this.style.listImages()}addLayer(e,t){return this._lazyInitEmptyStyle(),this.style.addLayer(e,t),this._update(!0)}moveLayer(e,t){return this.style.moveLayer(e,t),this._update(!0)}removeLayer(e){return this.style.removeLayer(e),this._update(!0)}getLayer(e){return this.style.getLayer(e)}setLayerZoomRange(e,t,i){return this.style.setLayerZoomRange(e,t,i),this._update(!0)}setFilter(e,t,i={}){return this.style.setFilter(e,t,i),this._update(!0)}getFilter(e){return this.style.getFilter(e)}setPaintProperty(e,t,i,o={}){return this.style.setPaintProperty(e,t,i,o),this._update(!0)}getPaintProperty(e,t){return this.style.getPaintProperty(e,t)}setLayoutProperty(e,t,i,o={}){return this.style.setLayoutProperty(e,t,i,o),this._update(!0)}getLayoutProperty(e,t){return this.style.getLayoutProperty(e,t)}setLight(e,t={}){return this._lazyInitEmptyStyle(),this.style.setLight(e,t),this._update(!0)}getLight(){return this.style.getLight()}setTerrain(e){return this._lazyInitEmptyStyle(),!e&&this.transform.projection.requiresDraping?this.style.setTerrainForDraping():this.style.setTerrain(e),this._averageElevationLastSampledAt=-1/0,this._update(!0)}getTerrain(){return this.style?this.style.getTerrain():null}setFog(e){return this._lazyInitEmptyStyle(),this.style.setFog(e),this._update(!0)}getFog(){return this.style?this.style.getFog():null}_queryFogOpacity(t){return this.style&&this.style.fog?this.style.fog.getOpacityAtLatLng(e.LngLat.convert(t),this.transform):0}setFeatureState(e,t){return this.style.setFeatureState(e,t),this._update()}removeFeatureState(e,t){return this.style.removeFeatureState(e,t),this._update()}getFeatureState(e){return this.style.getFeatureState(e)}_updateContainerDimensions(){if(!this._container)return;const t=this._container.getBoundingClientRect().width||400,i=this._container.getBoundingClientRect().height||300;let o,r,n,a=this._container;for(;a&&(!r||!n);){const t=e.window.getComputedStyle(a).transform;t&&"none"!==t&&(o=t.match(/matrix.*\((.+)\)/)[1].split(", "),o[0]&&"0"!==o[0]&&"1"!==o[0]&&(r=o[0]),o[3]&&"0"!==o[3]&&"1"!==o[3]&&(n=o[3])),a=a.parentElement;}this._containerWidth=r?Math.abs(t/r):t,this._containerHeight=n?Math.abs(i/n):i;}_detectMissingCSS(){"rgb(250, 128, 114)"!==e.window.getComputedStyle(this._missingCSSCanary).getPropertyValue("background-color")&&e.warnOnce("This page appears to be missing CSS declarations for Mapbox GL JS, which may cause the map to display incorrectly. Please ensure your page includes mapbox-gl.css, as described in https://www.mapbox.com/mapbox-gl-js/api/.");}_setupContainer(){const e=this._container;e.classList.add("mapboxgl-map"),(this._missingCSSCanary=n("div","mapboxgl-canary",e)).style.visibility="hidden",this._detectMissingCSS();const t=this._canvasContainer=n("div","mapboxgl-canvas-container",e);this._interactive&&t.classList.add("mapboxgl-interactive"),this._canvas=n("canvas","mapboxgl-canvas",t),this._canvas.addEventListener("webglcontextlost",this._contextLost,!1),this._canvas.addEventListener("webglcontextrestored",this._contextRestored,!1),this._canvas.setAttribute("tabindex","0"),this._canvas.setAttribute("aria-label",this._getUIString("Map.Title")),this._canvas.setAttribute("role","region"),this._updateContainerDimensions(),this._resizeCanvas(this._containerWidth,this._containerHeight);const i=this._controlContainer=n("div","mapboxgl-control-container",e),o=this._controlPositions={};["top-left","top-right","bottom-left","bottom-right"].forEach((e=>{o[e]=n("div",`mapboxgl-ctrl-${e}`,i);})),this._container.addEventListener("scroll",this._onMapScroll,!1);}_resizeCanvas(t,i){const o=e.exported.devicePixelRatio||1;this._canvas.width=o*Math.ceil(t),this._canvas.height=o*Math.ceil(i),this._canvas.style.width=`${t}px`,this._canvas.style.height=`${i}px`;}_addMarker(e){this._markers.push(e);}_removeMarker(e){const t=this._markers.indexOf(e);-1!==t&&this._markers.splice(t,1);}_setupPainter(){const t=e.extend({},i.webGLContextAttributes,{failIfMajorPerformanceCaveat:this._failIfMajorPerformanceCaveat,preserveDrawingBuffer:this._preserveDrawingBuffer,antialias:this._antialias||!1}),o=this._canvas.getContext("webgl",t)||this._canvas.getContext("experimental-webgl",t);o?(e.storeAuthState(o,!0),this.painter=new Fo(o,this.transform),this.on("data",(e=>{"source"===e.dataType&&this.painter.setTileLoadedFlag(!0);})),e.exported$1.testSupport(o)):this.fire(new e.ErrorEvent(new Error("Failed to initialize WebGL")));}_contextLost(t){t.preventDefault(),this._frame&&(this._frame.cancel(),this._frame=null),this.fire(new e.Event("webglcontextlost",{originalEvent:t}));}_contextRestored(t){this._setupPainter(),this.resize(),this._update(),this.fire(new e.Event("webglcontextrestored",{originalEvent:t}));}_onMapScroll(e){if(e.target===this._container)return this._container.scrollTop=0,this._container.scrollLeft=0,!1}loaded(){return !this._styleDirty&&!this._sourcesDirty&&!!this.style&&this.style.loaded()}_update(e){return this.style?(this._styleDirty=this._styleDirty||e,this._sourcesDirty=!0,this.triggerRepaint(),this):this}_requestRenderFrame(e){return this._update(),this._renderTaskQueue.add(e)}_cancelRenderFrame(e){this._renderTaskQueue.remove(e);}_requestDomTask(e){!this.loaded()||this.loaded()&&!this.isMoving()?e():this._domRenderTaskQueue.add(e);}_render(t){let i;const o=this.painter.context.extTimerQuery,r=e.exported.now();if(this.listens("gpu-timing-frame")&&(i=o.createQueryEXT(),o.beginQueryEXT(o.TIME_ELAPSED_EXT,i)),this.painter.context.setDirty(),this.painter.setBaseState(),this._renderTaskQueue.run(t),this._domRenderTaskQueue.run(t),this._removed)return;this._updateProjectionTransition();let n=!1;const a=this._isInitialLoad?0:this._fadeDuration;if(this.style&&this._styleDirty){this._styleDirty=!1;const t=this.transform.zoom,i=this.transform.pitch,o=e.exported.now();this.style.zoomHistory.update(t,o);const r=new e.EvaluationParameters(t,{now:o,fadeDuration:a,pitch:i,zoomHistory:this.style.zoomHistory,transition:this.style.getTransition()}),s=r.crossFadingFactor();1===s&&s===this._crossFadingFactor||(n=!0,this._crossFadingFactor=s),this.style.update(r);}this.style&&this.style.fog&&this.style.fog.hasTransition()&&(this.style._markersNeedUpdate=!0,this._sourcesDirty=!0);let s=!1;if(this.style&&this._sourcesDirty?(this._sourcesDirty=!1,this.painter._updateFog(this.style),this._updateTerrain(),s=this._updateAverageElevation(r),this.style._updateSources(this.transform),this._forceMarkerUpdate()):s=this._updateAverageElevation(r),this._placementDirty=this.style&&this.style._updatePlacement(this.painter.transform,this.showCollisionBoxes,a,this._crossSourceCollisions),this.style&&this.painter.render(this.style,{showTileBoundaries:this.showTileBoundaries,showTerrainWireframe:this.showTerrainWireframe,showOverdrawInspector:this._showOverdrawInspector,showQueryGeometry:!!this._showQueryGeometry,rotating:this.isRotating(),zooming:this.isZooming(),moving:this.isMoving(),fadeDuration:a,isInitialLoad:this._isInitialLoad,showPadding:this.showPadding,gpuTiming:!!this.listens("gpu-timing-layer"),gpuTimingDeferredRender:!!this.listens("gpu-timing-deferred-render"),speedIndexTiming:this.speedIndexTiming}),this.fire(new e.Event("render")),this.loaded()&&!this._loaded&&(this._loaded=!0,this.fire(new e.Event("load"))),this.style&&(this.style.hasTransitions()||n)&&(this._styleDirty=!0),this.style&&!this._placementDirty&&this.style._releaseSymbolFadeTiles(),i){const t=e.exported.now()-r;o.endQueryEXT(o.TIME_ELAPSED_EXT,i),setTimeout((()=>{const n=o.getQueryObjectEXT(i,o.QUERY_RESULT_EXT)/1e6;o.deleteQueryEXT(i),this.fire(new e.Event("gpu-timing-frame",{cpuTime:t,gpuTime:n})),e.window.performance.mark("frame-gpu",{startTime:r,detail:{gpuTime:n}});}),50);}if(this.listens("gpu-timing-layer")){const t=this.painter.collectGpuTimers();setTimeout((()=>{const i=this.painter.queryGpuTimers(t);this.fire(new e.Event("gpu-timing-layer",{layerTimes:i}));}),50);}if(this.listens("gpu-timing-deferred-render")){const t=this.painter.collectDeferredRenderGpuQueries();setTimeout((()=>{const i=this.painter.queryGpuTimeDeferredRender(t);this.fire(new e.Event("gpu-timing-deferred-render",{gpuTime:i}));}),50);}const l=this._sourcesDirty||this._styleDirty||this._placementDirty||s;if(l||this._repaint)this.triggerRepaint();else {const t=!this.isMoving()&&this.loaded();if(t&&(s=this._updateAverageElevation(r,!0)),s)this.triggerRepaint();else if(this._triggerFrame(!1),t&&(this.fire(new e.Event("idle")),this._isInitialLoad=!1,this.speedIndexTiming)){const t=this._calculateSpeedIndex();this.fire(new e.Event("speedindexcompleted",{speedIndex:t})),this.speedIndexTiming=!1;}}!this._loaded||this._fullyLoaded||l||(this._fullyLoaded=!0,this._authenticate());}_forceMarkerUpdate(){for(const e of this._markers)e._update();}_updateAverageElevation(e,t=!1){const i=e=>(this.transform.averageElevation=e,this._update(!1),!0);if(!this.painter.averageElevationNeedsEasing())return 0!==this.transform.averageElevation&&i(0);if((t||e-this._averageElevationLastSampledAt>500)&&!this._averageElevation.isEasing(e)){const t=this.transform.averageElevation;let o=this.transform.sampleAverageElevation(),r=!1;this.transform.elevation&&(r=this.transform.elevation.exaggeration()!==this._averageElevationExaggeration,this._averageElevationExaggeration=this.transform.elevation.exaggeration()),isNaN(o)?o=0:this._averageElevationLastSampledAt=e;const n=Math.abs(t-o);if(n>1){if(this._isInitialLoad||r)return this._averageElevation.jumpTo(o),i(o);this._averageElevation.easeTo(o,e,300);}else if(n>1e-4)return this._averageElevation.jumpTo(o),i(o)}return !!this._averageElevation.isEasing(e)&&i(this._averageElevation.getValue(e))}_authenticate(){e.getMapSessionAPI(this._getMapId(),this._requestManager._skuToken,this._requestManager._customAccessToken,(t=>{if(t&&(t.message===e.AUTH_ERR_MSG||401===t.status)){const t=this.painter.context.gl;e.storeAuthState(t,!1),this._logoControl instanceof Jr&&this._logoControl._updateLogo(),t&&t.clear(t.DEPTH_BUFFER_BIT|t.COLOR_BUFFER_BIT|t.STENCIL_BUFFER_BIT),this._silenceAuthErrors||this.fire(new e.ErrorEvent(new Error("A valid Mapbox access token is required to use Mapbox GL JS. To create an account or a new access token, visit https://account.mapbox.com/")));}})),e.postMapLoadEvent(this._getMapId(),this._requestManager._skuToken,this._requestManager._customAccessToken,(()=>{}));}_updateTerrain(){this.painter.updateTerrain(this.style,this.isMoving()||this.isRotating()||this.isZooming());}_calculateSpeedIndex(){const e=this.painter.canvasCopy(),t=this.painter.getCanvasCopiesAndTimestamps();t.timeStamps.push(performance.now());const i=this.painter.context.gl,o=i.createFramebuffer();function r(e){i.framebufferTexture2D(i.FRAMEBUFFER,i.COLOR_ATTACHMENT0,i.TEXTURE_2D,e,0);const t=new Uint8Array(i.drawingBufferWidth*i.drawingBufferHeight*4);return i.readPixels(0,0,i.drawingBufferWidth,i.drawingBufferHeight,i.RGBA,i.UNSIGNED_BYTE,t),t}return i.bindFramebuffer(i.FRAMEBUFFER,o),this._canvasPixelComparison(r(e),t.canvasCopies.map(r),t.timeStamps)}_canvasPixelComparison(e,t,i){let o=i[1]-i[0];const r=e.length/4;for(let n=0;n<t.length;n++){const a=t[n];let s=0;for(let t=0;t<a.length;t+=4)a[t]===e[t]&&a[t+1]===e[t+1]&&a[t+2]===e[t+2]&&a[t+3]===e[t+3]&&(s+=1);o+=(i[n+2]-i[n+1])*(1-s/r);}return o}remove(){this._hash&&this._hash.remove();for(const e of this._controls)e.onRemove(this);this._controls=[],this._frame&&(this._frame.cancel(),this._frame=null),this._renderTaskQueue.clear(),this._domRenderTaskQueue.clear(),this.style&&this.style.destroy(),this.painter.destroy(),this.handlers&&this.handlers.destroy(),this.handlers=void 0,this.setStyle(null),void 0!==e.window&&(e.window.removeEventListener("resize",this._onWindowResize,!1),e.window.removeEventListener("orientationchange",this._onWindowResize,!1),e.window.removeEventListener("webkitfullscreenchange",this._onWindowResize,!1),e.window.removeEventListener("online",this._onWindowOnline,!1));const t=this.painter.context.gl.getExtension("WEBGL_lose_context");t&&t.loseContext(),sn(this._canvasContainer),sn(this._controlContainer),sn(this._missingCSSCanary),this._container.classList.remove("mapboxgl-map"),e.removeAuthState(this.painter.context.gl),this._removed=!0,this.fire(new e.Event("remove"));}triggerRepaint(){this._triggerFrame(!0);}_triggerFrame(t){this._renderNextFrame=this._renderNextFrame||t,this.style&&!this._frame&&(this._frame=e.exported.frame((e=>{const t=!!this._renderNextFrame;this._frame=null,this._renderNextFrame=null,t&&this._render(e);})));}_preloadTiles(t){const i=this.style?Object.values(this.style._sourceCaches):[];return e.asyncAll(i,((e,i)=>e._preloadTiles(t,i)),(()=>{this.triggerRepaint();})),this}_onWindowOnline(){this._update();}_onWindowResize(e){this._trackResize&&this.resize({originalEvent:e})._update();}get showTileBoundaries(){return !!this._showTileBoundaries}set showTileBoundaries(e){this._showTileBoundaries!==e&&(this._showTileBoundaries=e,this._update());}get showTerrainWireframe(){return !!this._showTerrainWireframe}set showTerrainWireframe(e){this._showTerrainWireframe!==e&&(this._showTerrainWireframe=e,this._update());}get speedIndexTiming(){return !!this._speedIndexTiming}set speedIndexTiming(e){this._speedIndexTiming!==e&&(this._speedIndexTiming=e,this._update());}get showPadding(){return !!this._showPadding}set showPadding(e){this._showPadding!==e&&(this._showPadding=e,this._update());}get showCollisionBoxes(){return !!this._showCollisionBoxes}set showCollisionBoxes(e){this._showCollisionBoxes!==e&&(this._showCollisionBoxes=e,e?this.style._generateCollisionBoxes():this._update());}get showOverdrawInspector(){return !!this._showOverdrawInspector}set showOverdrawInspector(e){this._showOverdrawInspector!==e&&(this._showOverdrawInspector=e,this._update());}get repaint(){return !!this._repaint}set repaint(e){this._repaint!==e&&(this._repaint=e,this.triggerRepaint());}get vertices(){return !!this._vertices}set vertices(e){this._vertices=e,this._update();}_setCacheLimits(t,i){e.setCacheLimits(t,i);}get version(){return e.version}},NavigationControl:class{constructor(t){this.options=e.extend({},ln,t),this._container=n("div","mapboxgl-ctrl mapboxgl-ctrl-group"),this._container.addEventListener("contextmenu",(e=>e.preventDefault())),this.options.showZoom&&(e.bindAll(["_setButtonTitle","_updateZoomButtons"],this),this._zoomInButton=this._createButton("mapboxgl-ctrl-zoom-in",(e=>{this._map&&this._map.zoomIn({},{originalEvent:e});})),n("span","mapboxgl-ctrl-icon",this._zoomInButton).setAttribute("aria-hidden","true"),this._zoomOutButton=this._createButton("mapboxgl-ctrl-zoom-out",(e=>{this._map&&this._map.zoomOut({},{originalEvent:e});})),n("span","mapboxgl-ctrl-icon",this._zoomOutButton).setAttribute("aria-hidden","true")),this.options.showCompass&&(e.bindAll(["_rotateCompassArrow"],this),this._compass=this._createButton("mapboxgl-ctrl-compass",(e=>{const t=this._map;t&&(this.options.visualizePitch?t.resetNorthPitch({},{originalEvent:e}):t.resetNorth({},{originalEvent:e}));})),this._compassIcon=n("span","mapboxgl-ctrl-icon",this._compass),this._compassIcon.setAttribute("aria-hidden","true"));}_updateZoomButtons(){const e=this._map;if(!e)return;const t=e.getZoom(),i=t===e.getMaxZoom(),o=t===e.getMinZoom();this._zoomInButton.disabled=i,this._zoomOutButton.disabled=o,this._zoomInButton.setAttribute("aria-disabled",i.toString()),this._zoomOutButton.setAttribute("aria-disabled",o.toString());}_rotateCompassArrow(){const e=this._map;if(!e)return;const t=this.options.visualizePitch?`scale(${1/Math.pow(Math.cos(e.transform.pitch*(Math.PI/180)),.5)}) rotateX(${e.transform.pitch}deg) rotateZ(${e.transform.angle*(180/Math.PI)}deg)`:`rotate(${e.transform.angle*(180/Math.PI)}deg)`;e._requestDomTask((()=>{this._compassIcon&&(this._compassIcon.style.transform=t);}));}onAdd(e){return this._map=e,this.options.showZoom&&(this._setButtonTitle(this._zoomInButton,"ZoomIn"),this._setButtonTitle(this._zoomOutButton,"ZoomOut"),e.on("zoom",this._updateZoomButtons),this._updateZoomButtons()),this.options.showCompass&&(this._setButtonTitle(this._compass,"ResetBearing"),this.options.visualizePitch&&e.on("pitch",this._rotateCompassArrow),e.on("rotate",this._rotateCompassArrow),this._rotateCompassArrow(),this._handler=new cn(e,this._compass,this.options.visualizePitch)),this._container}onRemove(){const e=this._map;e&&(this._container.remove(),this.options.showZoom&&e.off("zoom",this._updateZoomButtons),this.options.showCompass&&(this.options.visualizePitch&&e.off("pitch",this._rotateCompassArrow),e.off("rotate",this._rotateCompassArrow),this._handler&&this._handler.off(),this._handler=void 0),this._map=void 0);}_createButton(e,t){const i=n("button",e,this._container);return i.type="button",i.addEventListener("click",t),i}_setButtonTitle(e,t){if(!this._map)return;const i=this._map._getUIString(`NavigationControl.${t}`);e.setAttribute("aria-label",i),e.firstElementChild&&e.firstElementChild.setAttribute("title",i);}},GeolocateControl:class extends e.Evented{constructor(t){super(),this.options=e.extend({geolocation:e.window.navigator.geolocation},hn,t),e.bindAll(["_onSuccess","_onError","_onZoom","_finish","_setupUI","_updateCamera","_updateMarker","_updateMarkerRotation","_onDeviceOrientation"],this),this._updateMarkerRotationThrottled=Jo(this._updateMarkerRotation,20),this._numberOfWatches=0;}onAdd(e){return this._map=e,this._container=n("div","mapboxgl-ctrl mapboxgl-ctrl-group"),this._checkGeolocationSupport(this._setupUI),this._container}onRemove(){void 0!==this._geolocationWatchID&&(this.options.geolocation.clearWatch(this._geolocationWatchID),this._geolocationWatchID=void 0),this.options.showUserLocation&&this._userLocationDotMarker&&this._userLocationDotMarker.remove(),this.options.showAccuracyCircle&&this._accuracyCircleMarker&&this._accuracyCircleMarker.remove(),this._container.remove(),this._map.off("zoom",this._onZoom),this._map=void 0,this._numberOfWatches=0,this._noTimeout=!1;}_checkGeolocationSupport(t){void 0!==this._supportsGeolocation?t(this._supportsGeolocation):void 0!==e.window.navigator.permissions?e.window.navigator.permissions.query({name:"geolocation"}).then((e=>{this._supportsGeolocation="denied"!==e.state,t(this._supportsGeolocation);})):(this._supportsGeolocation=!!this.options.geolocation,t(this._supportsGeolocation));}_isOutOfMapMaxBounds(e){const t=this._map.getMaxBounds(),i=e.coords;return !!t&&(i.longitude<t.getWest()||i.longitude>t.getEast()||i.latitude<t.getSouth()||i.latitude>t.getNorth())}_setErrorState(){switch(this._watchState){case"WAITING_ACTIVE":this._watchState="ACTIVE_ERROR",this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"),this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error");break;case"ACTIVE_LOCK":this._watchState="ACTIVE_ERROR",this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"),this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error"),this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting");break;case"BACKGROUND":this._watchState="BACKGROUND_ERROR",this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"),this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background-error"),this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting");}}_onSuccess(t){if(this._map){if(this._isOutOfMapMaxBounds(t))return this._setErrorState(),this.fire(new e.Event("outofmaxbounds",t)),this._updateMarker(),void this._finish();if(this.options.trackUserLocation)switch(this._lastKnownPosition=t,this._watchState){case"WAITING_ACTIVE":case"ACTIVE_LOCK":case"ACTIVE_ERROR":this._watchState="ACTIVE_LOCK",this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"),this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"),this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");break;case"BACKGROUND":case"BACKGROUND_ERROR":this._watchState="BACKGROUND",this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"),this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"),this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background");}this.options.showUserLocation&&"OFF"!==this._watchState&&this._updateMarker(t),this.options.trackUserLocation&&"ACTIVE_LOCK"!==this._watchState||this._updateCamera(t),this.options.showUserLocation&&this._dotElement.classList.remove("mapboxgl-user-location-dot-stale"),this.fire(new e.Event("geolocate",t)),this._finish();}}_updateCamera(t){const i=new e.LngLat(t.coords.longitude,t.coords.latitude),o=t.coords.accuracy,r=this._map.getBearing(),n=e.extend({bearing:r},this.options.fitBoundsOptions);this._map.fitBounds(i.toBounds(o),n,{geolocateSource:!0});}_updateMarker(t){if(t){const i=new e.LngLat(t.coords.longitude,t.coords.latitude);this._accuracyCircleMarker.setLngLat(i).addTo(this._map),this._userLocationDotMarker.setLngLat(i).addTo(this._map),this._accuracy=t.coords.accuracy,this.options.showUserLocation&&this.options.showAccuracyCircle&&this._updateCircleRadius();}else this._userLocationDotMarker.remove(),this._accuracyCircleMarker.remove();}_updateCircleRadius(){const t=this._map.transform,i=e.mercatorZfromAltitude(1,t._center.lat)*t.worldSize,o=Math.ceil(2*this._accuracy*i);this._circleElement.style.width=`${o}px`,this._circleElement.style.height=`${o}px`;}_onZoom(){this.options.showUserLocation&&this.options.showAccuracyCircle&&this._updateCircleRadius();}_updateMarkerRotation(){this._userLocationDotMarker&&"number"==typeof this._heading?(this._userLocationDotMarker.setRotation(this._heading),this._dotElement.classList.add("mapboxgl-user-location-show-heading")):(this._dotElement.classList.remove("mapboxgl-user-location-show-heading"),this._userLocationDotMarker.setRotation(0));}_onError(t){if(this._map){if(this.options.trackUserLocation)if(1===t.code){this._watchState="OFF",this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"),this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"),this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"),this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"),this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"),this._geolocateButton.disabled=!0;const e=this._map._getUIString("GeolocateControl.LocationNotAvailable");this._geolocateButton.setAttribute("aria-label",e),this._geolocateButton.firstElementChild&&this._geolocateButton.firstElementChild.setAttribute("title",e),void 0!==this._geolocationWatchID&&this._clearWatch();}else {if(3===t.code&&this._noTimeout)return;this._setErrorState();}"OFF"!==this._watchState&&this.options.showUserLocation&&this._dotElement.classList.add("mapboxgl-user-location-dot-stale"),this.fire(new e.Event("error",t)),this._finish();}}_finish(){this._timeoutId&&clearTimeout(this._timeoutId),this._timeoutId=void 0;}_setupUI(t){if(this._container.addEventListener("contextmenu",(e=>e.preventDefault())),this._geolocateButton=n("button","mapboxgl-ctrl-geolocate",this._container),n("span","mapboxgl-ctrl-icon",this._geolocateButton).setAttribute("aria-hidden","true"),this._geolocateButton.type="button",!1===t){e.warnOnce("Geolocation support is not available so the GeolocateControl will be disabled.");const t=this._map._getUIString("GeolocateControl.LocationNotAvailable");this._geolocateButton.disabled=!0,this._geolocateButton.setAttribute("aria-label",t),this._geolocateButton.firstElementChild&&this._geolocateButton.firstElementChild.setAttribute("title",t);}else {const e=this._map._getUIString("GeolocateControl.FindMyLocation");this._geolocateButton.setAttribute("aria-label",e),this._geolocateButton.firstElementChild&&this._geolocateButton.firstElementChild.setAttribute("title",e);}this.options.trackUserLocation&&(this._geolocateButton.setAttribute("aria-pressed","false"),this._watchState="OFF"),this.options.showUserLocation&&(this._dotElement=n("div","mapboxgl-user-location"),this._dotElement.appendChild(n("div","mapboxgl-user-location-dot")),this._dotElement.appendChild(n("div","mapboxgl-user-location-heading")),this._userLocationDotMarker=new on({element:this._dotElement,rotationAlignment:"map",pitchAlignment:"map"}),this._circleElement=n("div","mapboxgl-user-location-accuracy-circle"),this._accuracyCircleMarker=new on({element:this._circleElement,pitchAlignment:"map"}),this.options.trackUserLocation&&(this._watchState="OFF"),this._map.on("zoom",this._onZoom)),this._geolocateButton.addEventListener("click",this.trigger.bind(this)),this._setup=!0,this.options.trackUserLocation&&this._map.on("movestart",(t=>{t.geolocateSource||"ACTIVE_LOCK"!==this._watchState||t.originalEvent&&"resize"===t.originalEvent.type||(this._watchState="BACKGROUND",this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background"),this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"),this.fire(new e.Event("trackuserlocationend")));}));}_onDeviceOrientation(e){this._userLocationDotMarker&&(e.webkitCompassHeading?this._heading=e.webkitCompassHeading:!0===e.absolute&&(this._heading=-1*e.alpha),this._updateMarkerRotationThrottled());}trigger(){if(!this._setup)return e.warnOnce("Geolocate control triggered before added to a map"),!1;if(this.options.trackUserLocation){switch(this._watchState){case"OFF":this._watchState="WAITING_ACTIVE",this.fire(new e.Event("trackuserlocationstart"));break;case"WAITING_ACTIVE":case"ACTIVE_LOCK":case"ACTIVE_ERROR":case"BACKGROUND_ERROR":this._numberOfWatches--,this._noTimeout=!1,this._watchState="OFF",this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"),this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"),this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"),this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"),this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"),this.fire(new e.Event("trackuserlocationend"));break;case"BACKGROUND":this._watchState="ACTIVE_LOCK",this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"),this._lastKnownPosition&&this._updateCamera(this._lastKnownPosition),this.fire(new e.Event("trackuserlocationstart"));}switch(this._watchState){case"WAITING_ACTIVE":this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"),this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");break;case"ACTIVE_LOCK":this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");break;case"ACTIVE_ERROR":this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"),this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error");break;case"BACKGROUND":this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background");break;case"BACKGROUND_ERROR":this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"),this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background-error");}if("OFF"===this._watchState&&void 0!==this._geolocationWatchID)this._clearWatch();else if(void 0===this._geolocationWatchID){let e;this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"),this._geolocateButton.setAttribute("aria-pressed","true"),this._numberOfWatches++,this._numberOfWatches>1?(e={maximumAge:6e5,timeout:0},this._noTimeout=!0):(e=this.options.positionOptions,this._noTimeout=!1),this._geolocationWatchID=this.options.geolocation.watchPosition(this._onSuccess,this._onError,e),this.options.showUserHeading&&this._addDeviceOrientationListener();}}else this.options.geolocation.getCurrentPosition(this._onSuccess,this._onError,this.options.positionOptions),this._timeoutId=setTimeout(this._finish,1e4);return !0}_addDeviceOrientationListener(){const t=()=>{e.window.addEventListener("ondeviceorientationabsolute"in e.window?"deviceorientationabsolute":"deviceorientation",this._onDeviceOrientation);};void 0!==e.window.DeviceMotionEvent&&"function"==typeof e.window.DeviceMotionEvent.requestPermission?DeviceOrientationEvent.requestPermission().then((e=>{"granted"===e&&t();})).catch(console.error):t();}_clearWatch(){this.options.geolocation.clearWatch(this._geolocationWatchID),e.window.removeEventListener("deviceorientation",this._onDeviceOrientation),e.window.removeEventListener("deviceorientationabsolute",this._onDeviceOrientation),this._geolocationWatchID=void 0,this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"),this._geolocateButton.setAttribute("aria-pressed","false"),this.options.showUserLocation&&this._updateMarker(null);}},AttributionControl:Kr,ScaleControl:class{constructor(t){this.options=e.extend({},un,t),function(){try{return new Intl.NumberFormat("en",{style:"unit",unitDisplay:"narrow",unit:"meter"}),!0}catch(e){return !1}}()||(this._setScale=_n.bind(this)),e.bindAll(["_update","_setScale","setUnit"],this);}getDefaultPosition(){return "bottom-left"}_update(){const e=this.options.maxWidth||100,t=this._map,i=t._containerHeight/2,o=t._containerWidth/2-e/2,r=t.unproject([o,i]),n=t.unproject([o+e,i]),a=r.distanceTo(n);if("imperial"===this.options.unit){const t=3.2808*a;t>5280?this._setScale(e,t/5280,"mile"):this._setScale(e,t,"foot");}else "nautical"===this.options.unit?this._setScale(e,a/1852,"nautical-mile"):a>=1e3?this._setScale(e,a/1e3,"kilometer"):this._setScale(e,a,"meter");}_setScale(e,t,i){const o=dn(t),r=o/t;this._map._requestDomTask((()=>{this._container.style.width=e*r+"px",this._container.innerHTML="nautical-mile"!==i?new Intl.NumberFormat(this._language,{style:"unit",unitDisplay:"narrow",unit:i}).format(o):`${o}&nbsp;nm`;}));}onAdd(e){return this._map=e,this._language=e.getLanguage(),this._container=n("div","mapboxgl-ctrl mapboxgl-ctrl-scale",e.getContainer()),this._container.dir="auto",this._map.on("move",this._update),this._update(),this._container}onRemove(){this._container.remove(),this._map.off("move",this._update),this._map=void 0;}_setLanguage(e){this._language=e,this._update();}setUnit(e){this.options.unit=e,this._update();}},FullscreenControl:class{constructor(t){this._fullscreen=!1,t&&t.container&&(t.container instanceof e.window.HTMLElement?this._container=t.container:e.warnOnce("Full screen control 'container' must be a DOM element.")),e.bindAll(["_onClickFullscreen","_changeIcon"],this),"onfullscreenchange"in e.window.document?this._fullscreenchange="fullscreenchange":"onwebkitfullscreenchange"in e.window.document&&(this._fullscreenchange="webkitfullscreenchange");}onAdd(t){return this._map=t,this._container||(this._container=this._map.getContainer()),this._controlContainer=n("div","mapboxgl-ctrl mapboxgl-ctrl-group"),this._checkFullscreenSupport()?this._setupUI():(this._controlContainer.style.display="none",e.warnOnce("This device does not support fullscreen mode.")),this._controlContainer}onRemove(){this._controlContainer.remove(),this._map=null,e.window.document.removeEventListener(this._fullscreenchange,this._changeIcon);}_checkFullscreenSupport(){return !(!e.window.document.fullscreenEnabled&&!e.window.document.webkitFullscreenEnabled)}_setupUI(){const t=this._fullscreenButton=n("button","mapboxgl-ctrl-fullscreen",this._controlContainer);n("span","mapboxgl-ctrl-icon",t).setAttribute("aria-hidden","true"),t.type="button",this._updateTitle(),this._fullscreenButton.addEventListener("click",this._onClickFullscreen),e.window.document.addEventListener(this._fullscreenchange,this._changeIcon);}_updateTitle(){const e=this._getTitle();this._fullscreenButton.setAttribute("aria-label",e),this._fullscreenButton.firstElementChild&&this._fullscreenButton.firstElementChild.setAttribute("title",e);}_getTitle(){return this._map._getUIString(this._isFullscreen()?"FullscreenControl.Exit":"FullscreenControl.Enter")}_isFullscreen(){return this._fullscreen}_changeIcon(){(e.window.document.fullscreenElement||e.window.document.webkitFullscreenElement)===this._container!==this._fullscreen&&(this._fullscreen=!this._fullscreen,this._fullscreenButton.classList.toggle("mapboxgl-ctrl-shrink"),this._fullscreenButton.classList.toggle("mapboxgl-ctrl-fullscreen"),this._updateTitle());}_onClickFullscreen(){this._isFullscreen()?e.window.document.exitFullscreen?e.window.document.exitFullscreen():e.window.document.webkitCancelFullScreen&&e.window.document.webkitCancelFullScreen():this._container.requestFullscreen?this._container.requestFullscreen():this._container.webkitRequestFullscreen&&this._container.webkitRequestFullscreen();}},Popup:class extends e.Evented{constructor(t){super(),this.options=e.extend(Object.create(pn),t),e.bindAll(["_update","_onClose","remove","_onMouseEvent"],this),this._classList=new Set(t&&t.className?t.className.trim().split(/\s+/):[]);}addTo(t){return this._map&&this.remove(),this._map=t,this.options.closeOnClick&&t.on("preclick",this._onClose),this.options.closeOnMove&&t.on("move",this._onClose),t.on("remove",this.remove),this._update(),this._focusFirstElement(),this._trackPointer?(t.on("mousemove",this._onMouseEvent),t.on("mouseup",this._onMouseEvent),t._canvasContainer.classList.add("mapboxgl-track-pointer")):t.on("move",this._update),this.fire(new e.Event("open")),this}isOpen(){return !!this._map}remove(){this._content&&this._content.remove(),this._container&&(this._container.remove(),this._container=void 0);const t=this._map;return t&&(t.off("move",this._update),t.off("move",this._onClose),t.off("preclick",this._onClose),t.off("click",this._onClose),t.off("remove",this.remove),t.off("mousemove",this._onMouseEvent),t.off("mouseup",this._onMouseEvent),t.off("drag",this._onMouseEvent),this._map=void 0),this.fire(new e.Event("close")),this}getLngLat(){return this._lngLat}setLngLat(t){this._lngLat=e.LngLat.convert(t),this._pos=null,this._trackPointer=!1,this._update();const i=this._map;return i&&(i.on("move",this._update),i.off("mousemove",this._onMouseEvent),i._canvasContainer.classList.remove("mapboxgl-track-pointer")),this}trackPointer(){this._trackPointer=!0,this._pos=null,this._update();const e=this._map;return e&&(e.off("move",this._update),e.on("mousemove",this._onMouseEvent),e.on("drag",this._onMouseEvent),e._canvasContainer.classList.add("mapboxgl-track-pointer")),this}getElement(){return this._container}setText(t){return this.setDOMContent(e.window.document.createTextNode(t))}setHTML(t){const i=e.window.document.createDocumentFragment(),o=e.window.document.createElement("body");let r;for(o.innerHTML=t;r=o.firstChild,r;)i.appendChild(r);return this.setDOMContent(i)}getMaxWidth(){return this._container&&this._container.style.maxWidth}setMaxWidth(e){return this.options.maxWidth=e,this._update(),this}setDOMContent(e){let t=this._content;if(t)for(;t.hasChildNodes();)t.firstChild&&t.removeChild(t.firstChild);else t=this._content=n("div","mapboxgl-popup-content",this._container||void 0);if(t.appendChild(e),this.options.closeButton){const e=this._closeButton=n("button","mapboxgl-popup-close-button",t);e.type="button",e.setAttribute("aria-label","Close popup"),e.setAttribute("aria-hidden","true"),e.innerHTML="&#215;",e.addEventListener("click",this._onClose);}return this._update(),this._focusFirstElement(),this}addClassName(e){return this._classList.add(e),this._updateClassList(),this}removeClassName(e){return this._classList.delete(e),this._updateClassList(),this}setOffset(e){return this.options.offset=e,this._update(),this}toggleClassName(e){let t;return this._classList.delete(e)?t=!1:(this._classList.add(e),t=!0),this._updateClassList(),t}_onMouseEvent(e){this._update(e.point);}_getAnchor(e){if(this.options.anchor)return this.options.anchor;const t=this._map,i=this._container,o=this._pos;if(!t||!i||!o)return "bottom";const r=i.offsetWidth,n=i.offsetHeight,a=o.x<r/2,s=o.x>t.transform.width-r/2;if(o.y+e<n)return a?"top-left":s?"top-right":"top";if(o.y>t.transform.height-n){if(a)return "bottom-left";if(s)return "bottom-right"}return a?"left":s?"right":"bottom"}_updateClassList(){const e=this._container;if(!e)return;const t=[...this._classList];t.push("mapboxgl-popup"),this._anchor&&t.push(`mapboxgl-popup-anchor-${this._anchor}`),this._trackPointer&&t.push("mapboxgl-popup-track-pointer"),e.className=t.join(" ");}_update(t){const i=this._map,o=this._content;if(!i||!this._lngLat&&!this._trackPointer||!o)return;let r=this._container;if(r||(r=this._container=n("div","mapboxgl-popup",i.getContainer()),this._tip=n("div","mapboxgl-popup-tip",r),r.appendChild(o)),this.options.maxWidth&&r.style.maxWidth!==this.options.maxWidth&&(r.style.maxWidth=this.options.maxWidth),i.transform.renderWorldCopies&&!this._trackPointer&&(this._lngLat=en(this._lngLat,this._pos,i.transform)),!this._trackPointer||t){const e=this._pos=this._trackPointer&&t?t:i.project(this._lngLat),o=fn(this.options.offset),r=this._anchor=this._getAnchor(o.y),n=fn(this.options.offset,r),a=e.add(n).round();i._requestDomTask((()=>{this._container&&r&&(this._container.style.transform=`${tn[r]} translate(${a.x}px,${a.y}px)`);}));}if(!this._marker&&i._showingGlobe()){const t=e.isLngLatBehindGlobe(i.transform,this._lngLat)?0:1;this._setOpacity(t);}this._updateClassList();}_focusFirstElement(){if(!this.options.focusAfterOpen||!this._container)return;const e=this._container.querySelector(mn);e&&e.focus();}_onClose(){this.remove();}_setOpacity(e){this._container&&(this._container.style.opacity=`${e}`),this._content&&(this._content.style.pointerEvents=e?"auto":"none");}},Marker:on,Style:ei,LngLat:e.LngLat,LngLatBounds:e.LngLatBounds,Point:e.pointGeometry,MercatorCoordinate:e.MercatorCoordinate,FreeCameraOptions:Zo,Evented:e.Evented,config:e.config,prewarm:function(){Ge().acquire(Fe);},clearPrewarmedResources:function(){const e=Ne;e&&(e.isPreloaded()&&1===e.numActive()?(e.release(Fe),Ne=null):console.warn("Could not clear WebWorkers since there are active Map instances that still reference it. The pre-warmed WebWorker pool can only be cleared when all map instances have been removed with map.remove()"));},get accessToken(){return e.config.ACCESS_TOKEN},set accessToken(t){e.config.ACCESS_TOKEN=t;},get baseApiUrl(){return e.config.API_URL},set baseApiUrl(t){e.config.API_URL=t;},get workerCount(){return Ue.workerCount},set workerCount(e){Ue.workerCount=e;},get maxParallelImageRequests(){return e.config.MAX_PARALLEL_IMAGE_REQUESTS},set maxParallelImageRequests(t){e.config.MAX_PARALLEL_IMAGE_REQUESTS=t;},clearStorage(t){e.clearTileCache(t);},workerUrl:"",workerClass:null,setNow:e.exported.setNow,restoreNow:e.exported.restoreNow};return gn}));

	//

	var mapboxgl$1 = mapboxgl;

	return mapboxgl$1;

	}));
	
} (mapboxGl));

var mapboxGlExports = mapboxGl.exports;
var mapboxgl = /*@__PURE__*/getDefaultExportFromCjs(mapboxGlExports);

function commonjsRequire(path) {
	throw new Error('Could not dynamically require "' + path + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}

var moment$1 = {exports: {}};

(function (module, exports) {
(function (global, factory) {
	    module.exports = factory() ;
	}(commonjsGlobal, (function () {
	    var hookCallback;

	    function hooks() {
	        return hookCallback.apply(null, arguments);
	    }

	    // This is done to register the method called with moment()
	    // without creating circular dependencies.
	    function setHookCallback(callback) {
	        hookCallback = callback;
	    }

	    function isArray(input) {
	        return (
	            input instanceof Array ||
	            Object.prototype.toString.call(input) === '[object Array]'
	        );
	    }

	    function isObject(input) {
	        // IE8 will treat undefined and null as object if it wasn't for
	        // input != null
	        return (
	            input != null &&
	            Object.prototype.toString.call(input) === '[object Object]'
	        );
	    }

	    function hasOwnProp(a, b) {
	        return Object.prototype.hasOwnProperty.call(a, b);
	    }

	    function isObjectEmpty(obj) {
	        if (Object.getOwnPropertyNames) {
	            return Object.getOwnPropertyNames(obj).length === 0;
	        } else {
	            var k;
	            for (k in obj) {
	                if (hasOwnProp(obj, k)) {
	                    return false;
	                }
	            }
	            return true;
	        }
	    }

	    function isUndefined(input) {
	        return input === void 0;
	    }

	    function isNumber(input) {
	        return (
	            typeof input === 'number' ||
	            Object.prototype.toString.call(input) === '[object Number]'
	        );
	    }

	    function isDate(input) {
	        return (
	            input instanceof Date ||
	            Object.prototype.toString.call(input) === '[object Date]'
	        );
	    }

	    function map(arr, fn) {
	        var res = [],
	            i;
	        for (i = 0; i < arr.length; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }

	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }

	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }

	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }

	        return a;
	    }

	    function createUTC(input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, true).utc();
	    }

	    function defaultParsingFlags() {
	        // We need to deep clone this object.
	        return {
	            empty: false,
	            unusedTokens: [],
	            unusedInput: [],
	            overflow: -2,
	            charsLeftOver: 0,
	            nullInput: false,
	            invalidEra: null,
	            invalidMonth: null,
	            invalidFormat: false,
	            userInvalidated: false,
	            iso: false,
	            parsedDateParts: [],
	            era: null,
	            meridiem: null,
	            rfc2822: false,
	            weekdayMismatch: false,
	        };
	    }

	    function getParsingFlags(m) {
	        if (m._pf == null) {
	            m._pf = defaultParsingFlags();
	        }
	        return m._pf;
	    }

	    var some;
	    if (Array.prototype.some) {
	        some = Array.prototype.some;
	    } else {
	        some = function (fun) {
	            var t = Object(this),
	                len = t.length >>> 0,
	                i;

	            for (i = 0; i < len; i++) {
	                if (i in t && fun.call(this, t[i], i, t)) {
	                    return true;
	                }
	            }

	            return false;
	        };
	    }

	    function isValid(m) {
	        if (m._isValid == null) {
	            var flags = getParsingFlags(m),
	                parsedParts = some.call(flags.parsedDateParts, function (i) {
	                    return i != null;
	                }),
	                isNowValid =
	                    !isNaN(m._d.getTime()) &&
	                    flags.overflow < 0 &&
	                    !flags.empty &&
	                    !flags.invalidEra &&
	                    !flags.invalidMonth &&
	                    !flags.invalidWeekday &&
	                    !flags.weekdayMismatch &&
	                    !flags.nullInput &&
	                    !flags.invalidFormat &&
	                    !flags.userInvalidated &&
	                    (!flags.meridiem || (flags.meridiem && parsedParts));

	            if (m._strict) {
	                isNowValid =
	                    isNowValid &&
	                    flags.charsLeftOver === 0 &&
	                    flags.unusedTokens.length === 0 &&
	                    flags.bigHour === undefined;
	            }

	            if (Object.isFrozen == null || !Object.isFrozen(m)) {
	                m._isValid = isNowValid;
	            } else {
	                return isNowValid;
	            }
	        }
	        return m._isValid;
	    }

	    function createInvalid(flags) {
	        var m = createUTC(NaN);
	        if (flags != null) {
	            extend(getParsingFlags(m), flags);
	        } else {
	            getParsingFlags(m).userInvalidated = true;
	        }

	        return m;
	    }

	    // Plugins that add properties should also add the key here (null value),
	    // so we can properly clone ourselves.
	    var momentProperties = (hooks.momentProperties = []),
	        updateInProgress = false;

	    function copyConfig(to, from) {
	        var i, prop, val;

	        if (!isUndefined(from._isAMomentObject)) {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (!isUndefined(from._i)) {
	            to._i = from._i;
	        }
	        if (!isUndefined(from._f)) {
	            to._f = from._f;
	        }
	        if (!isUndefined(from._l)) {
	            to._l = from._l;
	        }
	        if (!isUndefined(from._strict)) {
	            to._strict = from._strict;
	        }
	        if (!isUndefined(from._tzm)) {
	            to._tzm = from._tzm;
	        }
	        if (!isUndefined(from._isUTC)) {
	            to._isUTC = from._isUTC;
	        }
	        if (!isUndefined(from._offset)) {
	            to._offset = from._offset;
	        }
	        if (!isUndefined(from._pf)) {
	            to._pf = getParsingFlags(from);
	        }
	        if (!isUndefined(from._locale)) {
	            to._locale = from._locale;
	        }

	        if (momentProperties.length > 0) {
	            for (i = 0; i < momentProperties.length; i++) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (!isUndefined(val)) {
	                    to[prop] = val;
	                }
	            }
	        }

	        return to;
	    }

	    // Moment prototype object
	    function Moment(config) {
	        copyConfig(this, config);
	        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	        if (!this.isValid()) {
	            this._d = new Date(NaN);
	        }
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            hooks.updateOffset(this);
	            updateInProgress = false;
	        }
	    }

	    function isMoment(obj) {
	        return (
	            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
	        );
	    }

	    function warn(msg) {
	        if (
	            hooks.suppressDeprecationWarnings === false &&
	            typeof console !== 'undefined' &&
	            console.warn
	        ) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }

	    function deprecate(msg, fn) {
	        var firstTime = true;

	        return extend(function () {
	            if (hooks.deprecationHandler != null) {
	                hooks.deprecationHandler(null, msg);
	            }
	            if (firstTime) {
	                var args = [],
	                    arg,
	                    i,
	                    key;
	                for (i = 0; i < arguments.length; i++) {
	                    arg = '';
	                    if (typeof arguments[i] === 'object') {
	                        arg += '\n[' + i + '] ';
	                        for (key in arguments[0]) {
	                            if (hasOwnProp(arguments[0], key)) {
	                                arg += key + ': ' + arguments[0][key] + ', ';
	                            }
	                        }
	                        arg = arg.slice(0, -2); // Remove trailing comma and space
	                    } else {
	                        arg = arguments[i];
	                    }
	                    args.push(arg);
	                }
	                warn(
	                    msg +
	                        '\nArguments: ' +
	                        Array.prototype.slice.call(args).join('') +
	                        '\n' +
	                        new Error().stack
	                );
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }

	    var deprecations = {};

	    function deprecateSimple(name, msg) {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(name, msg);
	        }
	        if (!deprecations[name]) {
	            warn(msg);
	            deprecations[name] = true;
	        }
	    }

	    hooks.suppressDeprecationWarnings = false;
	    hooks.deprecationHandler = null;

	    function isFunction(input) {
	        return (
	            (typeof Function !== 'undefined' && input instanceof Function) ||
	            Object.prototype.toString.call(input) === '[object Function]'
	        );
	    }

	    function set(config) {
	        var prop, i;
	        for (i in config) {
	            if (hasOwnProp(config, i)) {
	                prop = config[i];
	                if (isFunction(prop)) {
	                    this[i] = prop;
	                } else {
	                    this['_' + i] = prop;
	                }
	            }
	        }
	        this._config = config;
	        // Lenient ordinal parsing accepts just a number in addition to
	        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        this._dayOfMonthOrdinalParseLenient = new RegExp(
	            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	                '|' +
	                /\d{1,2}/.source
	        );
	    }

	    function mergeConfigs(parentConfig, childConfig) {
	        var res = extend({}, parentConfig),
	            prop;
	        for (prop in childConfig) {
	            if (hasOwnProp(childConfig, prop)) {
	                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                    res[prop] = {};
	                    extend(res[prop], parentConfig[prop]);
	                    extend(res[prop], childConfig[prop]);
	                } else if (childConfig[prop] != null) {
	                    res[prop] = childConfig[prop];
	                } else {
	                    delete res[prop];
	                }
	            }
	        }
	        for (prop in parentConfig) {
	            if (
	                hasOwnProp(parentConfig, prop) &&
	                !hasOwnProp(childConfig, prop) &&
	                isObject(parentConfig[prop])
	            ) {
	                // make sure changes to properties don't modify parent config
	                res[prop] = extend({}, res[prop]);
	            }
	        }
	        return res;
	    }

	    function Locale(config) {
	        if (config != null) {
	            this.set(config);
	        }
	    }

	    var keys;

	    if (Object.keys) {
	        keys = Object.keys;
	    } else {
	        keys = function (obj) {
	            var i,
	                res = [];
	            for (i in obj) {
	                if (hasOwnProp(obj, i)) {
	                    res.push(i);
	                }
	            }
	            return res;
	        };
	    }

	    var defaultCalendar = {
	        sameDay: '[Today at] LT',
	        nextDay: '[Tomorrow at] LT',
	        nextWeek: 'dddd [at] LT',
	        lastDay: '[Yesterday at] LT',
	        lastWeek: '[Last] dddd [at] LT',
	        sameElse: 'L',
	    };

	    function calendar(key, mom, now) {
	        var output = this._calendar[key] || this._calendar['sameElse'];
	        return isFunction(output) ? output.call(mom, now) : output;
	    }

	    function zeroFill(number, targetLength, forceSign) {
	        var absNumber = '' + Math.abs(number),
	            zerosToFill = targetLength - absNumber.length,
	            sign = number >= 0;
	        return (
	            (sign ? (forceSign ? '+' : '') : '-') +
	            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
	            absNumber
	        );
	    }

	    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
	        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
	        formatFunctions = {},
	        formatTokenFunctions = {};

	    // token:    'M'
	    // padded:   ['MM', 2]
	    // ordinal:  'Mo'
	    // callback: function () { this.month() + 1 }
	    function addFormatToken(token, padded, ordinal, callback) {
	        var func = callback;
	        if (typeof callback === 'string') {
	            func = function () {
	                return this[callback]();
	            };
	        }
	        if (token) {
	            formatTokenFunctions[token] = func;
	        }
	        if (padded) {
	            formatTokenFunctions[padded[0]] = function () {
	                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	            };
	        }
	        if (ordinal) {
	            formatTokenFunctions[ordinal] = function () {
	                return this.localeData().ordinal(
	                    func.apply(this, arguments),
	                    token
	                );
	            };
	        }
	    }

	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }

	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens),
	            i,
	            length;

	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }

	        return function (mom) {
	            var output = '',
	                i;
	            for (i = 0; i < length; i++) {
	                output += isFunction(array[i])
	                    ? array[i].call(mom, format)
	                    : array[i];
	            }
	            return output;
	        };
	    }

	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }

	        format = expandFormat(format, m.localeData());
	        formatFunctions[format] =
	            formatFunctions[format] || makeFormatFunction(format);

	        return formatFunctions[format](m);
	    }

	    function expandFormat(format, locale) {
	        var i = 5;

	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }

	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(
	                localFormattingTokens,
	                replaceLongDateFormatTokens
	            );
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }

	        return format;
	    }

	    var defaultLongDateFormat = {
	        LTS: 'h:mm:ss A',
	        LT: 'h:mm A',
	        L: 'MM/DD/YYYY',
	        LL: 'MMMM D, YYYY',
	        LLL: 'MMMM D, YYYY h:mm A',
	        LLLL: 'dddd, MMMM D, YYYY h:mm A',
	    };

	    function longDateFormat(key) {
	        var format = this._longDateFormat[key],
	            formatUpper = this._longDateFormat[key.toUpperCase()];

	        if (format || !formatUpper) {
	            return format;
	        }

	        this._longDateFormat[key] = formatUpper
	            .match(formattingTokens)
	            .map(function (tok) {
	                if (
	                    tok === 'MMMM' ||
	                    tok === 'MM' ||
	                    tok === 'DD' ||
	                    tok === 'dddd'
	                ) {
	                    return tok.slice(1);
	                }
	                return tok;
	            })
	            .join('');

	        return this._longDateFormat[key];
	    }

	    var defaultInvalidDate = 'Invalid date';

	    function invalidDate() {
	        return this._invalidDate;
	    }

	    var defaultOrdinal = '%d',
	        defaultDayOfMonthOrdinalParse = /\d{1,2}/;

	    function ordinal(number) {
	        return this._ordinal.replace('%d', number);
	    }

	    var defaultRelativeTime = {
	        future: 'in %s',
	        past: '%s ago',
	        s: 'a few seconds',
	        ss: '%d seconds',
	        m: 'a minute',
	        mm: '%d minutes',
	        h: 'an hour',
	        hh: '%d hours',
	        d: 'a day',
	        dd: '%d days',
	        w: 'a week',
	        ww: '%d weeks',
	        M: 'a month',
	        MM: '%d months',
	        y: 'a year',
	        yy: '%d years',
	    };

	    function relativeTime(number, withoutSuffix, string, isFuture) {
	        var output = this._relativeTime[string];
	        return isFunction(output)
	            ? output(number, withoutSuffix, string, isFuture)
	            : output.replace(/%d/i, number);
	    }

	    function pastFuture(diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	    }

	    var aliases = {};

	    function addUnitAlias(unit, shorthand) {
	        var lowerCase = unit.toLowerCase();
	        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	    }

	    function normalizeUnits(units) {
	        return typeof units === 'string'
	            ? aliases[units] || aliases[units.toLowerCase()]
	            : undefined;
	    }

	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;

	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }

	        return normalizedInput;
	    }

	    var priorities = {};

	    function addUnitPriority(unit, priority) {
	        priorities[unit] = priority;
	    }

	    function getPrioritizedUnits(unitsObj) {
	        var units = [],
	            u;
	        for (u in unitsObj) {
	            if (hasOwnProp(unitsObj, u)) {
	                units.push({ unit: u, priority: priorities[u] });
	            }
	        }
	        units.sort(function (a, b) {
	            return a.priority - b.priority;
	        });
	        return units;
	    }

	    function isLeapYear(year) {
	        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	    }

	    function absFloor(number) {
	        if (number < 0) {
	            // -0 -> 0
	            return Math.ceil(number) || 0;
	        } else {
	            return Math.floor(number);
	        }
	    }

	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;

	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            value = absFloor(coercedNumber);
	        }

	        return value;
	    }

	    function makeGetSet(unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                set$1(this, unit, value);
	                hooks.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return get(this, unit);
	            }
	        };
	    }

	    function get(mom, unit) {
	        return mom.isValid()
	            ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
	            : NaN;
	    }

	    function set$1(mom, unit, value) {
	        if (mom.isValid() && !isNaN(value)) {
	            if (
	                unit === 'FullYear' &&
	                isLeapYear(mom.year()) &&
	                mom.month() === 1 &&
	                mom.date() === 29
	            ) {
	                value = toInt(value);
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
	                    value,
	                    mom.month(),
	                    daysInMonth(value, mom.month())
	                );
	            } else {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	            }
	        }
	    }

	    // MOMENTS

	    function stringGet(units) {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units]();
	        }
	        return this;
	    }

	    function stringSet(units, value) {
	        if (typeof units === 'object') {
	            units = normalizeObjectUnits(units);
	            var prioritized = getPrioritizedUnits(units),
	                i;
	            for (i = 0; i < prioritized.length; i++) {
	                this[prioritized[i].unit](units[prioritized[i].unit]);
	            }
	        } else {
	            units = normalizeUnits(units);
	            if (isFunction(this[units])) {
	                return this[units](value);
	            }
	        }
	        return this;
	    }

	    var match1 = /\d/, //       0 - 9
	        match2 = /\d\d/, //      00 - 99
	        match3 = /\d{3}/, //     000 - 999
	        match4 = /\d{4}/, //    0000 - 9999
	        match6 = /[+-]?\d{6}/, // -999999 - 999999
	        match1to2 = /\d\d?/, //       0 - 99
	        match3to4 = /\d\d\d\d?/, //     999 - 9999
	        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
	        match1to3 = /\d{1,3}/, //       0 - 999
	        match1to4 = /\d{1,4}/, //       0 - 9999
	        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
	        matchUnsigned = /\d+/, //       0 - inf
	        matchSigned = /[+-]?\d+/, //    -inf - inf
	        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
	        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
	        // any word (or two) characters or numbers including two/three word month in arabic.
	        // includes scottish gaelic two word and hyphenated months
	        matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
	        regexes;

	    regexes = {};

	    function addRegexToken(token, regex, strictRegex) {
	        regexes[token] = isFunction(regex)
	            ? regex
	            : function (isStrict, localeData) {
	                  return isStrict && strictRegex ? strictRegex : regex;
	              };
	    }

	    function getParseRegexForToken(token, config) {
	        if (!hasOwnProp(regexes, token)) {
	            return new RegExp(unescapeFormat(token));
	        }

	        return regexes[token](config._strict, config._locale);
	    }

	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function unescapeFormat(s) {
	        return regexEscape(
	            s
	                .replace('\\', '')
	                .replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (
	                    matched,
	                    p1,
	                    p2,
	                    p3,
	                    p4
	                ) {
	                    return p1 || p2 || p3 || p4;
	                })
	        );
	    }

	    function regexEscape(s) {
	        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }

	    var tokens = {};

	    function addParseToken(token, callback) {
	        var i,
	            func = callback;
	        if (typeof token === 'string') {
	            token = [token];
	        }
	        if (isNumber(callback)) {
	            func = function (input, array) {
	                array[callback] = toInt(input);
	            };
	        }
	        for (i = 0; i < token.length; i++) {
	            tokens[token[i]] = func;
	        }
	    }

	    function addWeekParseToken(token, callback) {
	        addParseToken(token, function (input, array, config, token) {
	            config._w = config._w || {};
	            callback(input, config._w, config, token);
	        });
	    }

	    function addTimeToArrayFromToken(token, input, config) {
	        if (input != null && hasOwnProp(tokens, token)) {
	            tokens[token](input, config._a, config, token);
	        }
	    }

	    var YEAR = 0,
	        MONTH = 1,
	        DATE = 2,
	        HOUR = 3,
	        MINUTE = 4,
	        SECOND = 5,
	        MILLISECOND = 6,
	        WEEK = 7,
	        WEEKDAY = 8;

	    function mod(n, x) {
	        return ((n % x) + x) % x;
	    }

	    var indexOf;

	    if (Array.prototype.indexOf) {
	        indexOf = Array.prototype.indexOf;
	    } else {
	        indexOf = function (o) {
	            // I know
	            var i;
	            for (i = 0; i < this.length; ++i) {
	                if (this[i] === o) {
	                    return i;
	                }
	            }
	            return -1;
	        };
	    }

	    function daysInMonth(year, month) {
	        if (isNaN(year) || isNaN(month)) {
	            return NaN;
	        }
	        var modMonth = mod(month, 12);
	        year += (month - modMonth) / 12;
	        return modMonth === 1
	            ? isLeapYear(year)
	                ? 29
	                : 28
	            : 31 - ((modMonth % 7) % 2);
	    }

	    // FORMATTING

	    addFormatToken('M', ['MM', 2], 'Mo', function () {
	        return this.month() + 1;
	    });

	    addFormatToken('MMM', 0, 0, function (format) {
	        return this.localeData().monthsShort(this, format);
	    });

	    addFormatToken('MMMM', 0, 0, function (format) {
	        return this.localeData().months(this, format);
	    });

	    // ALIASES

	    addUnitAlias('month', 'M');

	    // PRIORITY

	    addUnitPriority('month', 8);

	    // PARSING

	    addRegexToken('M', match1to2);
	    addRegexToken('MM', match1to2, match2);
	    addRegexToken('MMM', function (isStrict, locale) {
	        return locale.monthsShortRegex(isStrict);
	    });
	    addRegexToken('MMMM', function (isStrict, locale) {
	        return locale.monthsRegex(isStrict);
	    });

	    addParseToken(['M', 'MM'], function (input, array) {
	        array[MONTH] = toInt(input) - 1;
	    });

	    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	        var month = config._locale.monthsParse(input, token, config._strict);
	        // if we didn't find a month name, mark the date as invalid.
	        if (month != null) {
	            array[MONTH] = month;
	        } else {
	            getParsingFlags(config).invalidMonth = input;
	        }
	    });

	    // LOCALES

	    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split(
	            '_'
	        ),
	        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
	        defaultMonthsShortRegex = matchWord,
	        defaultMonthsRegex = matchWord;

	    function localeMonths(m, format) {
	        if (!m) {
	            return isArray(this._months)
	                ? this._months
	                : this._months['standalone'];
	        }
	        return isArray(this._months)
	            ? this._months[m.month()]
	            : this._months[
	                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
	                      ? 'format'
	                      : 'standalone'
	              ][m.month()];
	    }

	    function localeMonthsShort(m, format) {
	        if (!m) {
	            return isArray(this._monthsShort)
	                ? this._monthsShort
	                : this._monthsShort['standalone'];
	        }
	        return isArray(this._monthsShort)
	            ? this._monthsShort[m.month()]
	            : this._monthsShort[
	                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
	              ][m.month()];
	    }

	    function handleStrictParse(monthName, format, strict) {
	        var i,
	            ii,
	            mom,
	            llc = monthName.toLocaleLowerCase();
	        if (!this._monthsParse) {
	            // this is not used
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	            for (i = 0; i < 12; ++i) {
	                mom = createUTC([2000, i]);
	                this._shortMonthsParse[i] = this.monthsShort(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	            }
	        }

	        if (strict) {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }

	    function localeMonthsParse(monthName, format, strict) {
	        var i, mom, regex;

	        if (this._monthsParseExact) {
	            return handleStrictParse.call(this, monthName, format, strict);
	        }

	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }

	        // TODO: add sorting
	        // Sorting makes sure if one month (or abbr) is a prefix of another
	        // see sorting in computeMonthsParse
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            if (strict && !this._longMonthsParse[i]) {
	                this._longMonthsParse[i] = new RegExp(
	                    '^' + this.months(mom, '').replace('.', '') + '$',
	                    'i'
	                );
	                this._shortMonthsParse[i] = new RegExp(
	                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
	                    'i'
	                );
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex =
	                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (
	                strict &&
	                format === 'MMMM' &&
	                this._longMonthsParse[i].test(monthName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'MMM' &&
	                this._shortMonthsParse[i].test(monthName)
	            ) {
	                return i;
	            } else if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    }

	    // MOMENTS

	    function setMonth(mom, value) {
	        var dayOfMonth;

	        if (!mom.isValid()) {
	            // No op
	            return mom;
	        }

	        if (typeof value === 'string') {
	            if (/^\d+$/.test(value)) {
	                value = toInt(value);
	            } else {
	                value = mom.localeData().monthsParse(value);
	                // TODO: Another silent failure?
	                if (!isNumber(value)) {
	                    return mom;
	                }
	            }
	        }

	        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	        return mom;
	    }

	    function getSetMonth(value) {
	        if (value != null) {
	            setMonth(this, value);
	            hooks.updateOffset(this, true);
	            return this;
	        } else {
	            return get(this, 'Month');
	        }
	    }

	    function getDaysInMonth() {
	        return daysInMonth(this.year(), this.month());
	    }

	    function monthsShortRegex(isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsShortStrictRegex;
	            } else {
	                return this._monthsShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsShortRegex')) {
	                this._monthsShortRegex = defaultMonthsShortRegex;
	            }
	            return this._monthsShortStrictRegex && isStrict
	                ? this._monthsShortStrictRegex
	                : this._monthsShortRegex;
	        }
	    }

	    function monthsRegex(isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsStrictRegex;
	            } else {
	                return this._monthsRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                this._monthsRegex = defaultMonthsRegex;
	            }
	            return this._monthsStrictRegex && isStrict
	                ? this._monthsStrictRegex
	                : this._monthsRegex;
	        }
	    }

	    function computeMonthsParse() {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }

	        var shortPieces = [],
	            longPieces = [],
	            mixedPieces = [],
	            i,
	            mom;
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            shortPieces.push(this.monthsShort(mom, ''));
	            longPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.monthsShort(mom, ''));
	        }
	        // Sorting makes sure if one month (or abbr) is a prefix of another it
	        // will match the longer piece.
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 12; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	        }
	        for (i = 0; i < 24; i++) {
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }

	        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._monthsShortRegex = this._monthsRegex;
	        this._monthsStrictRegex = new RegExp(
	            '^(' + longPieces.join('|') + ')',
	            'i'
	        );
	        this._monthsShortStrictRegex = new RegExp(
	            '^(' + shortPieces.join('|') + ')',
	            'i'
	        );
	    }

	    // FORMATTING

	    addFormatToken('Y', 0, 0, function () {
	        var y = this.year();
	        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
	    });

	    addFormatToken(0, ['YY', 2], 0, function () {
	        return this.year() % 100;
	    });

	    addFormatToken(0, ['YYYY', 4], 0, 'year');
	    addFormatToken(0, ['YYYYY', 5], 0, 'year');
	    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

	    // ALIASES

	    addUnitAlias('year', 'y');

	    // PRIORITIES

	    addUnitPriority('year', 1);

	    // PARSING

	    addRegexToken('Y', matchSigned);
	    addRegexToken('YY', match1to2, match2);
	    addRegexToken('YYYY', match1to4, match4);
	    addRegexToken('YYYYY', match1to6, match6);
	    addRegexToken('YYYYYY', match1to6, match6);

	    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	    addParseToken('YYYY', function (input, array) {
	        array[YEAR] =
	            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	    });
	    addParseToken('YY', function (input, array) {
	        array[YEAR] = hooks.parseTwoDigitYear(input);
	    });
	    addParseToken('Y', function (input, array) {
	        array[YEAR] = parseInt(input, 10);
	    });

	    // HELPERS

	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }

	    // HOOKS

	    hooks.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };

	    // MOMENTS

	    var getSetYear = makeGetSet('FullYear', true);

	    function getIsLeapYear() {
	        return isLeapYear(this.year());
	    }

	    function createDate(y, m, d, h, M, s, ms) {
	        // can't just apply() to create a date:
	        // https://stackoverflow.com/q/181348
	        var date;
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            date = new Date(y + 400, m, d, h, M, s, ms);
	            if (isFinite(date.getFullYear())) {
	                date.setFullYear(y);
	            }
	        } else {
	            date = new Date(y, m, d, h, M, s, ms);
	        }

	        return date;
	    }

	    function createUTCDate(y) {
	        var date, args;
	        // the Date.UTC function remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            args = Array.prototype.slice.call(arguments);
	            // preserve leap years using a full 400 year cycle, then reset
	            args[0] = y + 400;
	            date = new Date(Date.UTC.apply(null, args));
	            if (isFinite(date.getUTCFullYear())) {
	                date.setUTCFullYear(y);
	            }
	        } else {
	            date = new Date(Date.UTC.apply(null, arguments));
	        }

	        return date;
	    }

	    // start-of-first-week - start-of-year
	    function firstWeekOffset(year, dow, doy) {
	        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	            fwd = 7 + dow - doy,
	            // first-week day local weekday -- which local weekday is fwd
	            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

	        return -fwdlw + fwd - 1;
	    }

	    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	        var localWeekday = (7 + weekday - dow) % 7,
	            weekOffset = firstWeekOffset(year, dow, doy),
	            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	            resYear,
	            resDayOfYear;

	        if (dayOfYear <= 0) {
	            resYear = year - 1;
	            resDayOfYear = daysInYear(resYear) + dayOfYear;
	        } else if (dayOfYear > daysInYear(year)) {
	            resYear = year + 1;
	            resDayOfYear = dayOfYear - daysInYear(year);
	        } else {
	            resYear = year;
	            resDayOfYear = dayOfYear;
	        }

	        return {
	            year: resYear,
	            dayOfYear: resDayOfYear,
	        };
	    }

	    function weekOfYear(mom, dow, doy) {
	        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	            resWeek,
	            resYear;

	        if (week < 1) {
	            resYear = mom.year() - 1;
	            resWeek = week + weeksInYear(resYear, dow, doy);
	        } else if (week > weeksInYear(mom.year(), dow, doy)) {
	            resWeek = week - weeksInYear(mom.year(), dow, doy);
	            resYear = mom.year() + 1;
	        } else {
	            resYear = mom.year();
	            resWeek = week;
	        }

	        return {
	            week: resWeek,
	            year: resYear,
	        };
	    }

	    function weeksInYear(year, dow, doy) {
	        var weekOffset = firstWeekOffset(year, dow, doy),
	            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	    }

	    // FORMATTING

	    addFormatToken('w', ['ww', 2], 'wo', 'week');
	    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

	    // ALIASES

	    addUnitAlias('week', 'w');
	    addUnitAlias('isoWeek', 'W');

	    // PRIORITIES

	    addUnitPriority('week', 5);
	    addUnitPriority('isoWeek', 5);

	    // PARSING

	    addRegexToken('w', match1to2);
	    addRegexToken('ww', match1to2, match2);
	    addRegexToken('W', match1to2);
	    addRegexToken('WW', match1to2, match2);

	    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (
	        input,
	        week,
	        config,
	        token
	    ) {
	        week[token.substr(0, 1)] = toInt(input);
	    });

	    // HELPERS

	    // LOCALES

	    function localeWeek(mom) {
	        return weekOfYear(mom, this._week.dow, this._week.doy).week;
	    }

	    var defaultLocaleWeek = {
	        dow: 0, // Sunday is the first day of the week.
	        doy: 6, // The week that contains Jan 6th is the first week of the year.
	    };

	    function localeFirstDayOfWeek() {
	        return this._week.dow;
	    }

	    function localeFirstDayOfYear() {
	        return this._week.doy;
	    }

	    // MOMENTS

	    function getSetWeek(input) {
	        var week = this.localeData().week(this);
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }

	    function getSetISOWeek(input) {
	        var week = weekOfYear(this, 1, 4).week;
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }

	    // FORMATTING

	    addFormatToken('d', 0, 'do', 'day');

	    addFormatToken('dd', 0, 0, function (format) {
	        return this.localeData().weekdaysMin(this, format);
	    });

	    addFormatToken('ddd', 0, 0, function (format) {
	        return this.localeData().weekdaysShort(this, format);
	    });

	    addFormatToken('dddd', 0, 0, function (format) {
	        return this.localeData().weekdays(this, format);
	    });

	    addFormatToken('e', 0, 0, 'weekday');
	    addFormatToken('E', 0, 0, 'isoWeekday');

	    // ALIASES

	    addUnitAlias('day', 'd');
	    addUnitAlias('weekday', 'e');
	    addUnitAlias('isoWeekday', 'E');

	    // PRIORITY
	    addUnitPriority('day', 11);
	    addUnitPriority('weekday', 11);
	    addUnitPriority('isoWeekday', 11);

	    // PARSING

	    addRegexToken('d', match1to2);
	    addRegexToken('e', match1to2);
	    addRegexToken('E', match1to2);
	    addRegexToken('dd', function (isStrict, locale) {
	        return locale.weekdaysMinRegex(isStrict);
	    });
	    addRegexToken('ddd', function (isStrict, locale) {
	        return locale.weekdaysShortRegex(isStrict);
	    });
	    addRegexToken('dddd', function (isStrict, locale) {
	        return locale.weekdaysRegex(isStrict);
	    });

	    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	        var weekday = config._locale.weekdaysParse(input, token, config._strict);
	        // if we didn't get a weekday name, mark the date as invalid
	        if (weekday != null) {
	            week.d = weekday;
	        } else {
	            getParsingFlags(config).invalidWeekday = input;
	        }
	    });

	    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	        week[token] = toInt(input);
	    });

	    // HELPERS

	    function parseWeekday(input, locale) {
	        if (typeof input !== 'string') {
	            return input;
	        }

	        if (!isNaN(input)) {
	            return parseInt(input, 10);
	        }

	        input = locale.weekdaysParse(input);
	        if (typeof input === 'number') {
	            return input;
	        }

	        return null;
	    }

	    function parseIsoWeekday(input, locale) {
	        if (typeof input === 'string') {
	            return locale.weekdaysParse(input) % 7 || 7;
	        }
	        return isNaN(input) ? null : input;
	    }

	    // LOCALES
	    function shiftWeekdays(ws, n) {
	        return ws.slice(n, 7).concat(ws.slice(0, n));
	    }

	    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        defaultWeekdaysRegex = matchWord,
	        defaultWeekdaysShortRegex = matchWord,
	        defaultWeekdaysMinRegex = matchWord;

	    function localeWeekdays(m, format) {
	        var weekdays = isArray(this._weekdays)
	            ? this._weekdays
	            : this._weekdays[
	                  m && m !== true && this._weekdays.isFormat.test(format)
	                      ? 'format'
	                      : 'standalone'
	              ];
	        return m === true
	            ? shiftWeekdays(weekdays, this._week.dow)
	            : m
	            ? weekdays[m.day()]
	            : weekdays;
	    }

	    function localeWeekdaysShort(m) {
	        return m === true
	            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
	            : m
	            ? this._weekdaysShort[m.day()]
	            : this._weekdaysShort;
	    }

	    function localeWeekdaysMin(m) {
	        return m === true
	            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
	            : m
	            ? this._weekdaysMin[m.day()]
	            : this._weekdaysMin;
	    }

	    function handleStrictParse$1(weekdayName, format, strict) {
	        var i,
	            ii,
	            mom,
	            llc = weekdayName.toLocaleLowerCase();
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._minWeekdaysParse = [];

	            for (i = 0; i < 7; ++i) {
	                mom = createUTC([2000, 1]).day(i);
	                this._minWeekdaysParse[i] = this.weekdaysMin(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._shortWeekdaysParse[i] = this.weekdaysShort(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	            }
	        }

	        if (strict) {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }

	    function localeWeekdaysParse(weekdayName, format, strict) {
	        var i, mom, regex;

	        if (this._weekdaysParseExact) {
	            return handleStrictParse$1.call(this, weekdayName, format, strict);
	        }

	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._minWeekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._fullWeekdaysParse = [];
	        }

	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already

	            mom = createUTC([2000, 1]).day(i);
	            if (strict && !this._fullWeekdaysParse[i]) {
	                this._fullWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	                this._shortWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	                this._minWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	            }
	            if (!this._weekdaysParse[i]) {
	                regex =
	                    '^' +
	                    this.weekdays(mom, '') +
	                    '|^' +
	                    this.weekdaysShort(mom, '') +
	                    '|^' +
	                    this.weekdaysMin(mom, '');
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (
	                strict &&
	                format === 'dddd' &&
	                this._fullWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'ddd' &&
	                this._shortWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'dd' &&
	                this._minWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    }

	    // MOMENTS

	    function getSetDayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	        if (input != null) {
	            input = parseWeekday(input, this.localeData());
	            return this.add(input - day, 'd');
	        } else {
	            return day;
	        }
	    }

	    function getSetLocaleDayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	        return input == null ? weekday : this.add(input - weekday, 'd');
	    }

	    function getSetISODayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }

	        // behaves the same as moment#day except
	        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	        // as a setter, sunday should belong to the previous week.

	        if (input != null) {
	            var weekday = parseIsoWeekday(input, this.localeData());
	            return this.day(this.day() % 7 ? weekday : weekday - 7);
	        } else {
	            return this.day() || 7;
	        }
	    }

	    function weekdaysRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysStrictRegex;
	            } else {
	                return this._weekdaysRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                this._weekdaysRegex = defaultWeekdaysRegex;
	            }
	            return this._weekdaysStrictRegex && isStrict
	                ? this._weekdaysStrictRegex
	                : this._weekdaysRegex;
	        }
	    }

	    function weekdaysShortRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysShortStrictRegex;
	            } else {
	                return this._weekdaysShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	            }
	            return this._weekdaysShortStrictRegex && isStrict
	                ? this._weekdaysShortStrictRegex
	                : this._weekdaysShortRegex;
	        }
	    }

	    function weekdaysMinRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysMinStrictRegex;
	            } else {
	                return this._weekdaysMinRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	            }
	            return this._weekdaysMinStrictRegex && isStrict
	                ? this._weekdaysMinStrictRegex
	                : this._weekdaysMinRegex;
	        }
	    }

	    function computeWeekdaysParse() {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }

	        var minPieces = [],
	            shortPieces = [],
	            longPieces = [],
	            mixedPieces = [],
	            i,
	            mom,
	            minp,
	            shortp,
	            longp;
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, 1]).day(i);
	            minp = regexEscape(this.weekdaysMin(mom, ''));
	            shortp = regexEscape(this.weekdaysShort(mom, ''));
	            longp = regexEscape(this.weekdays(mom, ''));
	            minPieces.push(minp);
	            shortPieces.push(shortp);
	            longPieces.push(longp);
	            mixedPieces.push(minp);
	            mixedPieces.push(shortp);
	            mixedPieces.push(longp);
	        }
	        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	        // will match the longer piece.
	        minPieces.sort(cmpLenRev);
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);

	        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._weekdaysShortRegex = this._weekdaysRegex;
	        this._weekdaysMinRegex = this._weekdaysRegex;

	        this._weekdaysStrictRegex = new RegExp(
	            '^(' + longPieces.join('|') + ')',
	            'i'
	        );
	        this._weekdaysShortStrictRegex = new RegExp(
	            '^(' + shortPieces.join('|') + ')',
	            'i'
	        );
	        this._weekdaysMinStrictRegex = new RegExp(
	            '^(' + minPieces.join('|') + ')',
	            'i'
	        );
	    }

	    // FORMATTING

	    function hFormat() {
	        return this.hours() % 12 || 12;
	    }

	    function kFormat() {
	        return this.hours() || 24;
	    }

	    addFormatToken('H', ['HH', 2], 0, 'hour');
	    addFormatToken('h', ['hh', 2], 0, hFormat);
	    addFormatToken('k', ['kk', 2], 0, kFormat);

	    addFormatToken('hmm', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	    });

	    addFormatToken('hmmss', 0, 0, function () {
	        return (
	            '' +
	            hFormat.apply(this) +
	            zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2)
	        );
	    });

	    addFormatToken('Hmm', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2);
	    });

	    addFormatToken('Hmmss', 0, 0, function () {
	        return (
	            '' +
	            this.hours() +
	            zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2)
	        );
	    });

	    function meridiem(token, lowercase) {
	        addFormatToken(token, 0, 0, function () {
	            return this.localeData().meridiem(
	                this.hours(),
	                this.minutes(),
	                lowercase
	            );
	        });
	    }

	    meridiem('a', true);
	    meridiem('A', false);

	    // ALIASES

	    addUnitAlias('hour', 'h');

	    // PRIORITY
	    addUnitPriority('hour', 13);

	    // PARSING

	    function matchMeridiem(isStrict, locale) {
	        return locale._meridiemParse;
	    }

	    addRegexToken('a', matchMeridiem);
	    addRegexToken('A', matchMeridiem);
	    addRegexToken('H', match1to2);
	    addRegexToken('h', match1to2);
	    addRegexToken('k', match1to2);
	    addRegexToken('HH', match1to2, match2);
	    addRegexToken('hh', match1to2, match2);
	    addRegexToken('kk', match1to2, match2);

	    addRegexToken('hmm', match3to4);
	    addRegexToken('hmmss', match5to6);
	    addRegexToken('Hmm', match3to4);
	    addRegexToken('Hmmss', match5to6);

	    addParseToken(['H', 'HH'], HOUR);
	    addParseToken(['k', 'kk'], function (input, array, config) {
	        var kInput = toInt(input);
	        array[HOUR] = kInput === 24 ? 0 : kInput;
	    });
	    addParseToken(['a', 'A'], function (input, array, config) {
	        config._isPm = config._locale.isPM(input);
	        config._meridiem = input;
	    });
	    addParseToken(['h', 'hh'], function (input, array, config) {
	        array[HOUR] = toInt(input);
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmmss', function (input, array, config) {
	        var pos1 = input.length - 4,
	            pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('Hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	    });
	    addParseToken('Hmmss', function (input, array, config) {
	        var pos1 = input.length - 4,
	            pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	    });

	    // LOCALES

	    function localeIsPM(input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return (input + '').toLowerCase().charAt(0) === 'p';
	    }

	    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
	        // Setting the hour should keep the time, because the user explicitly
	        // specified which hour they want. So trying to maintain the same hour (in
	        // a new timezone) makes sense. Adding/subtracting hours does not follow
	        // this rule.
	        getSetHour = makeGetSet('Hours', true);

	    function localeMeridiem(hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        } else {
	            return isLower ? 'am' : 'AM';
	        }
	    }

	    var baseConfig = {
	        calendar: defaultCalendar,
	        longDateFormat: defaultLongDateFormat,
	        invalidDate: defaultInvalidDate,
	        ordinal: defaultOrdinal,
	        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	        relativeTime: defaultRelativeTime,

	        months: defaultLocaleMonths,
	        monthsShort: defaultLocaleMonthsShort,

	        week: defaultLocaleWeek,

	        weekdays: defaultLocaleWeekdays,
	        weekdaysMin: defaultLocaleWeekdaysMin,
	        weekdaysShort: defaultLocaleWeekdaysShort,

	        meridiemParse: defaultLocaleMeridiemParse,
	    };

	    // internal storage for locale config files
	    var locales = {},
	        localeFamilies = {},
	        globalLocale;

	    function commonPrefix(arr1, arr2) {
	        var i,
	            minl = Math.min(arr1.length, arr2.length);
	        for (i = 0; i < minl; i += 1) {
	            if (arr1[i] !== arr2[i]) {
	                return i;
	            }
	        }
	        return minl;
	    }

	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }

	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0,
	            j,
	            next,
	            locale,
	            split;

	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (
	                    next &&
	                    next.length >= j &&
	                    commonPrefix(split, next) >= j - 1
	                ) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return globalLocale;
	    }

	    function loadLocale(name) {
	        var oldLocale = null,
	            aliasedRequire;
	        // TODO: Find a better way to register and load all the locales in Node
	        if (
	            locales[name] === undefined &&
	            'object' !== 'undefined' &&
	            module &&
	            module.exports
	        ) {
	            try {
	                oldLocale = globalLocale._abbr;
	                aliasedRequire = commonjsRequire;
	                aliasedRequire('./locale/' + name);
	                getSetGlobalLocale(oldLocale);
	            } catch (e) {
	                // mark as not found to avoid repeating expensive file require call causing high CPU
	                // when trying to find en-US, en_US, en-us for every format call
	                locales[name] = null; // null means not found
	            }
	        }
	        return locales[name];
	    }

	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    function getSetGlobalLocale(key, values) {
	        var data;
	        if (key) {
	            if (isUndefined(values)) {
	                data = getLocale(key);
	            } else {
	                data = defineLocale(key, values);
	            }

	            if (data) {
	                // moment.duration._locale = moment._locale = data;
	                globalLocale = data;
	            } else {
	                if (typeof console !== 'undefined' && console.warn) {
	                    //warn user if arguments are passed but the locale could not be set
	                    console.warn(
	                        'Locale ' + key + ' not found. Did you forget to load it?'
	                    );
	                }
	            }
	        }

	        return globalLocale._abbr;
	    }

	    function defineLocale(name, config) {
	        if (config !== null) {
	            var locale,
	                parentConfig = baseConfig;
	            config.abbr = name;
	            if (locales[name] != null) {
	                deprecateSimple(
	                    'defineLocaleOverride',
	                    'use moment.updateLocale(localeName, config) to change ' +
	                        'an existing locale. moment.defineLocale(localeName, ' +
	                        'config) should only be used for creating a new locale ' +
	                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
	                );
	                parentConfig = locales[name]._config;
	            } else if (config.parentLocale != null) {
	                if (locales[config.parentLocale] != null) {
	                    parentConfig = locales[config.parentLocale]._config;
	                } else {
	                    locale = loadLocale(config.parentLocale);
	                    if (locale != null) {
	                        parentConfig = locale._config;
	                    } else {
	                        if (!localeFamilies[config.parentLocale]) {
	                            localeFamilies[config.parentLocale] = [];
	                        }
	                        localeFamilies[config.parentLocale].push({
	                            name: name,
	                            config: config,
	                        });
	                        return null;
	                    }
	                }
	            }
	            locales[name] = new Locale(mergeConfigs(parentConfig, config));

	            if (localeFamilies[name]) {
	                localeFamilies[name].forEach(function (x) {
	                    defineLocale(x.name, x.config);
	                });
	            }

	            // backwards compat for now: also set the locale
	            // make sure we set the locale AFTER all child locales have been
	            // created, so we won't end up with the child locale set.
	            getSetGlobalLocale(name);

	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    }

	    function updateLocale(name, config) {
	        if (config != null) {
	            var locale,
	                tmpLocale,
	                parentConfig = baseConfig;

	            if (locales[name] != null && locales[name].parentLocale != null) {
	                // Update existing child locale in-place to avoid memory-leaks
	                locales[name].set(mergeConfigs(locales[name]._config, config));
	            } else {
	                // MERGE
	                tmpLocale = loadLocale(name);
	                if (tmpLocale != null) {
	                    parentConfig = tmpLocale._config;
	                }
	                config = mergeConfigs(parentConfig, config);
	                if (tmpLocale == null) {
	                    // updateLocale is called for creating a new locale
	                    // Set abbr so it will have a name (getters return
	                    // undefined otherwise).
	                    config.abbr = name;
	                }
	                locale = new Locale(config);
	                locale.parentLocale = locales[name];
	                locales[name] = locale;
	            }

	            // backwards compat for now: also set the locale
	            getSetGlobalLocale(name);
	        } else {
	            // pass null for config to unupdate, useful for tests
	            if (locales[name] != null) {
	                if (locales[name].parentLocale != null) {
	                    locales[name] = locales[name].parentLocale;
	                    if (name === getSetGlobalLocale()) {
	                        getSetGlobalLocale(name);
	                    }
	                } else if (locales[name] != null) {
	                    delete locales[name];
	                }
	            }
	        }
	        return locales[name];
	    }

	    // returns locale data
	    function getLocale(key) {
	        var locale;

	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }

	        if (!key) {
	            return globalLocale;
	        }

	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }

	        return chooseLocale(key);
	    }

	    function listLocales() {
	        return keys(locales);
	    }

	    function checkOverflow(m) {
	        var overflow,
	            a = m._a;

	        if (a && getParsingFlags(m).overflow === -2) {
	            overflow =
	                a[MONTH] < 0 || a[MONTH] > 11
	                    ? MONTH
	                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
	                    ? DATE
	                    : a[HOUR] < 0 ||
	                      a[HOUR] > 24 ||
	                      (a[HOUR] === 24 &&
	                          (a[MINUTE] !== 0 ||
	                              a[SECOND] !== 0 ||
	                              a[MILLISECOND] !== 0))
	                    ? HOUR
	                    : a[MINUTE] < 0 || a[MINUTE] > 59
	                    ? MINUTE
	                    : a[SECOND] < 0 || a[SECOND] > 59
	                    ? SECOND
	                    : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
	                    ? MILLISECOND
	                    : -1;

	            if (
	                getParsingFlags(m)._overflowDayOfYear &&
	                (overflow < YEAR || overflow > DATE)
	            ) {
	                overflow = DATE;
	            }
	            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	                overflow = WEEK;
	            }
	            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	                overflow = WEEKDAY;
	            }

	            getParsingFlags(m).overflow = overflow;
	        }

	        return m;
	    }

	    // iso 8601 regex
	    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	        basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
	        isoDates = [
	            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	            ['YYYY-DDD', /\d{4}-\d{3}/],
	            ['YYYY-MM', /\d{4}-\d\d/, false],
	            ['YYYYYYMMDD', /[+-]\d{10}/],
	            ['YYYYMMDD', /\d{8}/],
	            ['GGGG[W]WWE', /\d{4}W\d{3}/],
	            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	            ['YYYYDDD', /\d{7}/],
	            ['YYYYMM', /\d{6}/, false],
	            ['YYYY', /\d{4}/, false],
	        ],
	        // iso time formats and regexes
	        isoTimes = [
	            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	            ['HH:mm', /\d\d:\d\d/],
	            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	            ['HHmmss', /\d\d\d\d\d\d/],
	            ['HHmm', /\d\d\d\d/],
	            ['HH', /\d\d/],
	        ],
	        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
	        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	        rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
	        obsOffsets = {
	            UT: 0,
	            GMT: 0,
	            EDT: -4 * 60,
	            EST: -5 * 60,
	            CDT: -5 * 60,
	            CST: -6 * 60,
	            MDT: -6 * 60,
	            MST: -7 * 60,
	            PDT: -7 * 60,
	            PST: -8 * 60,
	        };

	    // date from iso format
	    function configFromISO(config) {
	        var i,
	            l,
	            string = config._i,
	            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	            allowTime,
	            dateFormat,
	            timeFormat,
	            tzFormat;

	        if (match) {
	            getParsingFlags(config).iso = true;

	            for (i = 0, l = isoDates.length; i < l; i++) {
	                if (isoDates[i][1].exec(match[1])) {
	                    dateFormat = isoDates[i][0];
	                    allowTime = isoDates[i][2] !== false;
	                    break;
	                }
	            }
	            if (dateFormat == null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[3]) {
	                for (i = 0, l = isoTimes.length; i < l; i++) {
	                    if (isoTimes[i][1].exec(match[3])) {
	                        // match[2] should be 'T' or space
	                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                        break;
	                    }
	                }
	                if (timeFormat == null) {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            if (!allowTime && timeFormat != null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[4]) {
	                if (tzRegex.exec(match[4])) {
	                    tzFormat = 'Z';
	                } else {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	            configFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }

	    function extractFromRFC2822Strings(
	        yearStr,
	        monthStr,
	        dayStr,
	        hourStr,
	        minuteStr,
	        secondStr
	    ) {
	        var result = [
	            untruncateYear(yearStr),
	            defaultLocaleMonthsShort.indexOf(monthStr),
	            parseInt(dayStr, 10),
	            parseInt(hourStr, 10),
	            parseInt(minuteStr, 10),
	        ];

	        if (secondStr) {
	            result.push(parseInt(secondStr, 10));
	        }

	        return result;
	    }

	    function untruncateYear(yearStr) {
	        var year = parseInt(yearStr, 10);
	        if (year <= 49) {
	            return 2000 + year;
	        } else if (year <= 999) {
	            return 1900 + year;
	        }
	        return year;
	    }

	    function preprocessRFC2822(s) {
	        // Remove comments and folding whitespace and replace multiple-spaces with a single space
	        return s
	            .replace(/\([^)]*\)|[\n\t]/g, ' ')
	            .replace(/(\s\s+)/g, ' ')
	            .replace(/^\s\s*/, '')
	            .replace(/\s\s*$/, '');
	    }

	    function checkWeekday(weekdayStr, parsedInput, config) {
	        if (weekdayStr) {
	            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
	            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
	                weekdayActual = new Date(
	                    parsedInput[0],
	                    parsedInput[1],
	                    parsedInput[2]
	                ).getDay();
	            if (weekdayProvided !== weekdayActual) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return false;
	            }
	        }
	        return true;
	    }

	    function calculateOffset(obsOffset, militaryOffset, numOffset) {
	        if (obsOffset) {
	            return obsOffsets[obsOffset];
	        } else if (militaryOffset) {
	            // the only allowed military tz is Z
	            return 0;
	        } else {
	            var hm = parseInt(numOffset, 10),
	                m = hm % 100,
	                h = (hm - m) / 100;
	            return h * 60 + m;
	        }
	    }

	    // date and time from ref 2822 format
	    function configFromRFC2822(config) {
	        var match = rfc2822.exec(preprocessRFC2822(config._i)),
	            parsedArray;
	        if (match) {
	            parsedArray = extractFromRFC2822Strings(
	                match[4],
	                match[3],
	                match[2],
	                match[5],
	                match[6],
	                match[7]
	            );
	            if (!checkWeekday(match[1], parsedArray, config)) {
	                return;
	            }

	            config._a = parsedArray;
	            config._tzm = calculateOffset(match[8], match[9], match[10]);

	            config._d = createUTCDate.apply(null, config._a);
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

	            getParsingFlags(config).rfc2822 = true;
	        } else {
	            config._isValid = false;
	        }
	    }

	    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
	    function configFromString(config) {
	        var matched = aspNetJsonRegex.exec(config._i);
	        if (matched !== null) {
	            config._d = new Date(+matched[1]);
	            return;
	        }

	        configFromISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }

	        configFromRFC2822(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }

	        if (config._strict) {
	            config._isValid = false;
	        } else {
	            // Final attempt, use Input Fallback
	            hooks.createFromInputFallback(config);
	        }
	    }

	    hooks.createFromInputFallback = deprecate(
	        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	        function (config) {
	            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	        }
	    );

	    // Pick the first defined of two or three arguments.
	    function defaults(a, b, c) {
	        if (a != null) {
	            return a;
	        }
	        if (b != null) {
	            return b;
	        }
	        return c;
	    }

	    function currentDateArray(config) {
	        // hooks is actually the exported moment object
	        var nowValue = new Date(hooks.now());
	        if (config._useUTC) {
	            return [
	                nowValue.getUTCFullYear(),
	                nowValue.getUTCMonth(),
	                nowValue.getUTCDate(),
	            ];
	        }
	        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	    }

	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function configFromArray(config) {
	        var i,
	            date,
	            input = [],
	            currentDate,
	            expectedWeekday,
	            yearToUse;

	        if (config._d) {
	            return;
	        }

	        currentDate = currentDateArray(config);

	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }

	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear != null) {
	            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

	            if (
	                config._dayOfYear > daysInYear(yearToUse) ||
	                config._dayOfYear === 0
	            ) {
	                getParsingFlags(config)._overflowDayOfYear = true;
	            }

	            date = createUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }

	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }

	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] =
	                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
	        }

	        // Check for 24:00:00.000
	        if (
	            config._a[HOUR] === 24 &&
	            config._a[MINUTE] === 0 &&
	            config._a[SECOND] === 0 &&
	            config._a[MILLISECOND] === 0
	        ) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }

	        config._d = (config._useUTC ? createUTCDate : createDate).apply(
	            null,
	            input
	        );
	        expectedWeekday = config._useUTC
	            ? config._d.getUTCDay()
	            : config._d.getDay();

	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }

	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }

	        // check for mismatching day of week
	        if (
	            config._w &&
	            typeof config._w.d !== 'undefined' &&
	            config._w.d !== expectedWeekday
	        ) {
	            getParsingFlags(config).weekdayMismatch = true;
	        }
	    }

	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;

	            // TODO: We need to take the current isoWeekYear, but that depends on
	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = defaults(
	                w.GG,
	                config._a[YEAR],
	                weekOfYear(createLocal(), 1, 4).year
	            );
	            week = defaults(w.W, 1);
	            weekday = defaults(w.E, 1);
	            if (weekday < 1 || weekday > 7) {
	                weekdayOverflow = true;
	            }
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;

	            curWeek = weekOfYear(createLocal(), dow, doy);

	            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

	            // Default to current week.
	            week = defaults(w.w, curWeek.week);

	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < 0 || weekday > 6) {
	                    weekdayOverflow = true;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from beginning of week
	                weekday = w.e + dow;
	                if (w.e < 0 || w.e > 6) {
	                    weekdayOverflow = true;
	                }
	            } else {
	                // default to beginning of week
	                weekday = dow;
	            }
	        }
	        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	            getParsingFlags(config)._overflowWeeks = true;
	        } else if (weekdayOverflow != null) {
	            getParsingFlags(config)._overflowWeekday = true;
	        } else {
	            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	            config._a[YEAR] = temp.year;
	            config._dayOfYear = temp.dayOfYear;
	        }
	    }

	    // constant that refers to the ISO standard
	    hooks.ISO_8601 = function () {};

	    // constant that refers to the RFC 2822 form
	    hooks.RFC_2822 = function () {};

	    // date from string and format string
	    function configFromStringAndFormat(config) {
	        // TODO: Move this to another part of the creation flow to prevent circular deps
	        if (config._f === hooks.ISO_8601) {
	            configFromISO(config);
	            return;
	        }
	        if (config._f === hooks.RFC_2822) {
	            configFromRFC2822(config);
	            return;
	        }
	        config._a = [];
	        getParsingFlags(config).empty = true;

	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i,
	            parsedInput,
	            tokens,
	            token,
	            skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0,
	            era;

	        tokens =
	            expandFormat(config._f, config._locale).match(formattingTokens) || [];

	        for (i = 0; i < tokens.length; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
	                [])[0];
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    getParsingFlags(config).unusedInput.push(skipped);
	                }
	                string = string.slice(
	                    string.indexOf(parsedInput) + parsedInput.length
	                );
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    getParsingFlags(config).empty = false;
	                } else {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            } else if (config._strict && !parsedInput) {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	        }

	        // add remaining unparsed input length to the string
	        getParsingFlags(config).charsLeftOver =
	            stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            getParsingFlags(config).unusedInput.push(string);
	        }

	        // clear _12h flag if hour is <= 12
	        if (
	            config._a[HOUR] <= 12 &&
	            getParsingFlags(config).bigHour === true &&
	            config._a[HOUR] > 0
	        ) {
	            getParsingFlags(config).bigHour = undefined;
	        }

	        getParsingFlags(config).parsedDateParts = config._a.slice(0);
	        getParsingFlags(config).meridiem = config._meridiem;
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(
	            config._locale,
	            config._a[HOUR],
	            config._meridiem
	        );

	        // handle era
	        era = getParsingFlags(config).era;
	        if (era !== null) {
	            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
	        }

	        configFromArray(config);
	        checkOverflow(config);
	    }

	    function meridiemFixWrap(locale, hour, meridiem) {
	        var isPm;

	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // this is not supposed to happen
	            return hour;
	        }
	    }

	    // date from string and array of format strings
	    function configFromStringAndArray(config) {
	        var tempConfig,
	            bestMoment,
	            scoreToBeat,
	            i,
	            currentScore,
	            validFormatFound,
	            bestFormatIsValid = false;

	        if (config._f.length === 0) {
	            getParsingFlags(config).invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }

	        for (i = 0; i < config._f.length; i++) {
	            currentScore = 0;
	            validFormatFound = false;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._f = config._f[i];
	            configFromStringAndFormat(tempConfig);

	            if (isValid(tempConfig)) {
	                validFormatFound = true;
	            }

	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += getParsingFlags(tempConfig).charsLeftOver;

	            //or tokens
	            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

	            getParsingFlags(tempConfig).score = currentScore;

	            if (!bestFormatIsValid) {
	                if (
	                    scoreToBeat == null ||
	                    currentScore < scoreToBeat ||
	                    validFormatFound
	                ) {
	                    scoreToBeat = currentScore;
	                    bestMoment = tempConfig;
	                    if (validFormatFound) {
	                        bestFormatIsValid = true;
	                    }
	                }
	            } else {
	                if (currentScore < scoreToBeat) {
	                    scoreToBeat = currentScore;
	                    bestMoment = tempConfig;
	                }
	            }
	        }

	        extend(config, bestMoment || tempConfig);
	    }

	    function configFromObject(config) {
	        if (config._d) {
	            return;
	        }

	        var i = normalizeObjectUnits(config._i),
	            dayOrDate = i.day === undefined ? i.date : i.day;
	        config._a = map(
	            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
	            function (obj) {
	                return obj && parseInt(obj, 10);
	            }
	        );

	        configFromArray(config);
	    }

	    function createFromConfig(config) {
	        var res = new Moment(checkOverflow(prepareConfig(config)));
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }

	        return res;
	    }

	    function prepareConfig(config) {
	        var input = config._i,
	            format = config._f;

	        config._locale = config._locale || getLocale(config._l);

	        if (input === null || (format === undefined && input === '')) {
	            return createInvalid({ nullInput: true });
	        }

	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }

	        if (isMoment(input)) {
	            return new Moment(checkOverflow(input));
	        } else if (isDate(input)) {
	            config._d = input;
	        } else if (isArray(format)) {
	            configFromStringAndArray(config);
	        } else if (format) {
	            configFromStringAndFormat(config);
	        } else {
	            configFromInput(config);
	        }

	        if (!isValid(config)) {
	            config._d = null;
	        }

	        return config;
	    }

	    function configFromInput(config) {
	        var input = config._i;
	        if (isUndefined(input)) {
	            config._d = new Date(hooks.now());
	        } else if (isDate(input)) {
	            config._d = new Date(input.valueOf());
	        } else if (typeof input === 'string') {
	            configFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            configFromArray(config);
	        } else if (isObject(input)) {
	            configFromObject(config);
	        } else if (isNumber(input)) {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            hooks.createFromInputFallback(config);
	        }
	    }

	    function createLocalOrUTC(input, format, locale, strict, isUTC) {
	        var c = {};

	        if (format === true || format === false) {
	            strict = format;
	            format = undefined;
	        }

	        if (locale === true || locale === false) {
	            strict = locale;
	            locale = undefined;
	        }

	        if (
	            (isObject(input) && isObjectEmpty(input)) ||
	            (isArray(input) && input.length === 0)
	        ) {
	            input = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c._isAMomentObject = true;
	        c._useUTC = c._isUTC = isUTC;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;

	        return createFromConfig(c);
	    }

	    function createLocal(input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, false);
	    }

	    var prototypeMin = deprecate(
	            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	            function () {
	                var other = createLocal.apply(null, arguments);
	                if (this.isValid() && other.isValid()) {
	                    return other < this ? this : other;
	                } else {
	                    return createInvalid();
	                }
	            }
	        ),
	        prototypeMax = deprecate(
	            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	            function () {
	                var other = createLocal.apply(null, arguments);
	                if (this.isValid() && other.isValid()) {
	                    return other > this ? this : other;
	                } else {
	                    return createInvalid();
	                }
	            }
	        );

	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return createLocal();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (!moments[i].isValid() || moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }

	    // TODO: Use [].sort instead?
	    function min() {
	        var args = [].slice.call(arguments, 0);

	        return pickBy('isBefore', args);
	    }

	    function max() {
	        var args = [].slice.call(arguments, 0);

	        return pickBy('isAfter', args);
	    }

	    var now = function () {
	        return Date.now ? Date.now() : +new Date();
	    };

	    var ordering = [
	        'year',
	        'quarter',
	        'month',
	        'week',
	        'day',
	        'hour',
	        'minute',
	        'second',
	        'millisecond',
	    ];

	    function isDurationValid(m) {
	        var key,
	            unitHasDecimal = false,
	            i;
	        for (key in m) {
	            if (
	                hasOwnProp(m, key) &&
	                !(
	                    indexOf.call(ordering, key) !== -1 &&
	                    (m[key] == null || !isNaN(m[key]))
	                )
	            ) {
	                return false;
	            }
	        }

	        for (i = 0; i < ordering.length; ++i) {
	            if (m[ordering[i]]) {
	                if (unitHasDecimal) {
	                    return false; // only allow non-integers for smallest unit
	                }
	                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                    unitHasDecimal = true;
	                }
	            }
	        }

	        return true;
	    }

	    function isValid$1() {
	        return this._isValid;
	    }

	    function createInvalid$1() {
	        return createDuration(NaN);
	    }

	    function Duration(duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;

	        this._isValid = isDurationValid(normalizedInput);

	        // representation for dateAddRemove
	        this._milliseconds =
	            +milliseconds +
	            seconds * 1e3 + // 1000
	            minutes * 6e4 + // 1000 * 60
	            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days + weeks * 7;
	        // It is impossible to translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months + quarters * 3 + years * 12;

	        this._data = {};

	        this._locale = getLocale();

	        this._bubble();
	    }

	    function isDuration(obj) {
	        return obj instanceof Duration;
	    }

	    function absRound(number) {
	        if (number < 0) {
	            return Math.round(-1 * number) * -1;
	        } else {
	            return Math.round(number);
	        }
	    }

	    // compare two arrays, return the number of differences
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if (
	                (dontConvert && array1[i] !== array2[i]) ||
	                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
	            ) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }

	    // FORMATTING

	    function offset(token, separator) {
	        addFormatToken(token, 0, 0, function () {
	            var offset = this.utcOffset(),
	                sign = '+';
	            if (offset < 0) {
	                offset = -offset;
	                sign = '-';
	            }
	            return (
	                sign +
	                zeroFill(~~(offset / 60), 2) +
	                separator +
	                zeroFill(~~offset % 60, 2)
	            );
	        });
	    }

	    offset('Z', ':');
	    offset('ZZ', '');

	    // PARSING

	    addRegexToken('Z', matchShortOffset);
	    addRegexToken('ZZ', matchShortOffset);
	    addParseToken(['Z', 'ZZ'], function (input, array, config) {
	        config._useUTC = true;
	        config._tzm = offsetFromString(matchShortOffset, input);
	    });

	    // HELPERS

	    // timezone chunker
	    // '+10:00' > ['10',  '00']
	    // '-1530'  > ['-15', '30']
	    var chunkOffset = /([\+\-]|\d\d)/gi;

	    function offsetFromString(matcher, string) {
	        var matches = (string || '').match(matcher),
	            chunk,
	            parts,
	            minutes;

	        if (matches === null) {
	            return null;
	        }

	        chunk = matches[matches.length - 1] || [];
	        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	        minutes = +(parts[1] * 60) + toInt(parts[2]);

	        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
	    }

	    // Return a moment from input, that is local/utc/zone equivalent to model.
	    function cloneWithOffset(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff =
	                (isMoment(input) || isDate(input)
	                    ? input.valueOf()
	                    : createLocal(input).valueOf()) - res.valueOf();
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(res._d.valueOf() + diff);
	            hooks.updateOffset(res, false);
	            return res;
	        } else {
	            return createLocal(input).local();
	        }
	    }

	    function getDateOffset(m) {
	        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	        // https://github.com/moment/moment/pull/1871
	        return -Math.round(m._d.getTimezoneOffset());
	    }

	    // HOOKS

	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    hooks.updateOffset = function () {};

	    // MOMENTS

	    // keepLocalTime = true means only change the timezone, without
	    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	    // +0200, so we adjust the time as needed, to be valid.
	    //
	    // Keeping the time actually adds/subtracts (one hour)
	    // from the actual represented time. That is why we call updateOffset
	    // a second time. In case it wants us to change the offset again
	    // _changeInProgress == true case, then we have to adjust, because
	    // there is no such time in the given timezone.
	    function getSetOffset(input, keepLocalTime, keepMinutes) {
	        var offset = this._offset || 0,
	            localAdjust;
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        if (input != null) {
	            if (typeof input === 'string') {
	                input = offsetFromString(matchShortOffset, input);
	                if (input === null) {
	                    return this;
	                }
	            } else if (Math.abs(input) < 16 && !keepMinutes) {
	                input = input * 60;
	            }
	            if (!this._isUTC && keepLocalTime) {
	                localAdjust = getDateOffset(this);
	            }
	            this._offset = input;
	            this._isUTC = true;
	            if (localAdjust != null) {
	                this.add(localAdjust, 'm');
	            }
	            if (offset !== input) {
	                if (!keepLocalTime || this._changeInProgress) {
	                    addSubtract(
	                        this,
	                        createDuration(input - offset, 'm'),
	                        1,
	                        false
	                    );
	                } else if (!this._changeInProgress) {
	                    this._changeInProgress = true;
	                    hooks.updateOffset(this, true);
	                    this._changeInProgress = null;
	                }
	            }
	            return this;
	        } else {
	            return this._isUTC ? offset : getDateOffset(this);
	        }
	    }

	    function getSetZone(input, keepLocalTime) {
	        if (input != null) {
	            if (typeof input !== 'string') {
	                input = -input;
	            }

	            this.utcOffset(input, keepLocalTime);

	            return this;
	        } else {
	            return -this.utcOffset();
	        }
	    }

	    function setOffsetToUTC(keepLocalTime) {
	        return this.utcOffset(0, keepLocalTime);
	    }

	    function setOffsetToLocal(keepLocalTime) {
	        if (this._isUTC) {
	            this.utcOffset(0, keepLocalTime);
	            this._isUTC = false;

	            if (keepLocalTime) {
	                this.subtract(getDateOffset(this), 'm');
	            }
	        }
	        return this;
	    }

	    function setOffsetToParsedOffset() {
	        if (this._tzm != null) {
	            this.utcOffset(this._tzm, false, true);
	        } else if (typeof this._i === 'string') {
	            var tZone = offsetFromString(matchOffset, this._i);
	            if (tZone != null) {
	                this.utcOffset(tZone);
	            } else {
	                this.utcOffset(0, true);
	            }
	        }
	        return this;
	    }

	    function hasAlignedHourOffset(input) {
	        if (!this.isValid()) {
	            return false;
	        }
	        input = input ? createLocal(input).utcOffset() : 0;

	        return (this.utcOffset() - input) % 60 === 0;
	    }

	    function isDaylightSavingTime() {
	        return (
	            this.utcOffset() > this.clone().month(0).utcOffset() ||
	            this.utcOffset() > this.clone().month(5).utcOffset()
	        );
	    }

	    function isDaylightSavingTimeShifted() {
	        if (!isUndefined(this._isDSTShifted)) {
	            return this._isDSTShifted;
	        }

	        var c = {},
	            other;

	        copyConfig(c, this);
	        c = prepareConfig(c);

	        if (c._a) {
	            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	            this._isDSTShifted =
	                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
	        } else {
	            this._isDSTShifted = false;
	        }

	        return this._isDSTShifted;
	    }

	    function isLocal() {
	        return this.isValid() ? !this._isUTC : false;
	    }

	    function isUtcOffset() {
	        return this.isValid() ? this._isUTC : false;
	    }

	    function isUtc() {
	        return this.isValid() ? this._isUTC && this._offset === 0 : false;
	    }

	    // ASP.NET json date format regex
	    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
	        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	        // and further modified to allow for strings containing both week and day
	        isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

	    function createDuration(input, key) {
	        var duration = input,
	            // matching against regexp is expensive, do it on demand
	            match = null,
	            sign,
	            ret,
	            diffRes;

	        if (isDuration(input)) {
	            duration = {
	                ms: input._milliseconds,
	                d: input._days,
	                M: input._months,
	            };
	        } else if (isNumber(input) || !isNaN(+input)) {
	            duration = {};
	            if (key) {
	                duration[key] = +input;
	            } else {
	                duration.milliseconds = +input;
	            }
	        } else if ((match = aspNetRegex.exec(input))) {
	            sign = match[1] === '-' ? -1 : 1;
	            duration = {
	                y: 0,
	                d: toInt(match[DATE]) * sign,
	                h: toInt(match[HOUR]) * sign,
	                m: toInt(match[MINUTE]) * sign,
	                s: toInt(match[SECOND]) * sign,
	                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
	            };
	        } else if ((match = isoRegex.exec(input))) {
	            sign = match[1] === '-' ? -1 : 1;
	            duration = {
	                y: parseIso(match[2], sign),
	                M: parseIso(match[3], sign),
	                w: parseIso(match[4], sign),
	                d: parseIso(match[5], sign),
	                h: parseIso(match[6], sign),
	                m: parseIso(match[7], sign),
	                s: parseIso(match[8], sign),
	            };
	        } else if (duration == null) {
	            // checks for null or undefined
	            duration = {};
	        } else if (
	            typeof duration === 'object' &&
	            ('from' in duration || 'to' in duration)
	        ) {
	            diffRes = momentsDifference(
	                createLocal(duration.from),
	                createLocal(duration.to)
	            );

	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }

	        ret = new Duration(duration);

	        if (isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }

	        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
	            ret._isValid = input._isValid;
	        }

	        return ret;
	    }

	    createDuration.fn = Duration.prototype;
	    createDuration.invalid = createInvalid$1;

	    function parseIso(inp, sign) {
	        // We'd normally use ~~inp for this, but unfortunately it also
	        // converts floats to ints.
	        // inp may be undefined, so careful calling replace on it.
	        var res = inp && parseFloat(inp.replace(',', '.'));
	        // apply sign while we're at it
	        return (isNaN(res) ? 0 : res) * sign;
	    }

	    function positiveMomentsDifference(base, other) {
	        var res = {};

	        res.months =
	            other.month() - base.month() + (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }

	        res.milliseconds = +other - +base.clone().add(res.months, 'M');

	        return res;
	    }

	    function momentsDifference(base, other) {
	        var res;
	        if (!(base.isValid() && other.isValid())) {
	            return { milliseconds: 0, months: 0 };
	        }

	        other = cloneWithOffset(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }

	        return res;
	    }

	    // TODO: remove 'name' arg after deprecation is removed
	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(
	                    name,
	                    'moment().' +
	                        name +
	                        '(period, number) is deprecated. Please use moment().' +
	                        name +
	                        '(number, period). ' +
	                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
	                );
	                tmp = val;
	                val = period;
	                period = tmp;
	            }

	            dur = createDuration(val, period);
	            addSubtract(this, dur, direction);
	            return this;
	        };
	    }

	    function addSubtract(mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = absRound(duration._days),
	            months = absRound(duration._months);

	        if (!mom.isValid()) {
	            // No op
	            return;
	        }

	        updateOffset = updateOffset == null ? true : updateOffset;

	        if (months) {
	            setMonth(mom, get(mom, 'Month') + months * isAdding);
	        }
	        if (days) {
	            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	        }
	        if (milliseconds) {
	            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	        }
	        if (updateOffset) {
	            hooks.updateOffset(mom, days || months);
	        }
	    }

	    var add = createAdder(1, 'add'),
	        subtract = createAdder(-1, 'subtract');

	    function isString(input) {
	        return typeof input === 'string' || input instanceof String;
	    }

	    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
	    function isMomentInput(input) {
	        return (
	            isMoment(input) ||
	            isDate(input) ||
	            isString(input) ||
	            isNumber(input) ||
	            isNumberOrStringArray(input) ||
	            isMomentInputObject(input) ||
	            input === null ||
	            input === undefined
	        );
	    }

	    function isMomentInputObject(input) {
	        var objectTest = isObject(input) && !isObjectEmpty(input),
	            propertyTest = false,
	            properties = [
	                'years',
	                'year',
	                'y',
	                'months',
	                'month',
	                'M',
	                'days',
	                'day',
	                'd',
	                'dates',
	                'date',
	                'D',
	                'hours',
	                'hour',
	                'h',
	                'minutes',
	                'minute',
	                'm',
	                'seconds',
	                'second',
	                's',
	                'milliseconds',
	                'millisecond',
	                'ms',
	            ],
	            i,
	            property;

	        for (i = 0; i < properties.length; i += 1) {
	            property = properties[i];
	            propertyTest = propertyTest || hasOwnProp(input, property);
	        }

	        return objectTest && propertyTest;
	    }

	    function isNumberOrStringArray(input) {
	        var arrayTest = isArray(input),
	            dataTypeTest = false;
	        if (arrayTest) {
	            dataTypeTest =
	                input.filter(function (item) {
	                    return !isNumber(item) && isString(input);
	                }).length === 0;
	        }
	        return arrayTest && dataTypeTest;
	    }

	    function isCalendarSpec(input) {
	        var objectTest = isObject(input) && !isObjectEmpty(input),
	            propertyTest = false,
	            properties = [
	                'sameDay',
	                'nextDay',
	                'lastDay',
	                'nextWeek',
	                'lastWeek',
	                'sameElse',
	            ],
	            i,
	            property;

	        for (i = 0; i < properties.length; i += 1) {
	            property = properties[i];
	            propertyTest = propertyTest || hasOwnProp(input, property);
	        }

	        return objectTest && propertyTest;
	    }

	    function getCalendarFormat(myMoment, now) {
	        var diff = myMoment.diff(now, 'days', true);
	        return diff < -6
	            ? 'sameElse'
	            : diff < -1
	            ? 'lastWeek'
	            : diff < 0
	            ? 'lastDay'
	            : diff < 1
	            ? 'sameDay'
	            : diff < 2
	            ? 'nextDay'
	            : diff < 7
	            ? 'nextWeek'
	            : 'sameElse';
	    }

	    function calendar$1(time, formats) {
	        // Support for single parameter, formats only overload to the calendar function
	        if (arguments.length === 1) {
	            if (!arguments[0]) {
	                time = undefined;
	                formats = undefined;
	            } else if (isMomentInput(arguments[0])) {
	                time = arguments[0];
	                formats = undefined;
	            } else if (isCalendarSpec(arguments[0])) {
	                formats = arguments[0];
	                time = undefined;
	            }
	        }
	        // We want to compare the start of today, vs this.
	        // Getting start-of-today depends on whether we're local/utc/offset or not.
	        var now = time || createLocal(),
	            sod = cloneWithOffset(now, this).startOf('day'),
	            format = hooks.calendarFormat(this, sod) || 'sameElse',
	            output =
	                formats &&
	                (isFunction(formats[format])
	                    ? formats[format].call(this, now)
	                    : formats[format]);

	        return this.format(
	            output || this.localeData().calendar(format, this, createLocal(now))
	        );
	    }

	    function clone() {
	        return new Moment(this);
	    }

	    function isAfter(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() > localInput.valueOf();
	        } else {
	            return localInput.valueOf() < this.clone().startOf(units).valueOf();
	        }
	    }

	    function isBefore(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() < localInput.valueOf();
	        } else {
	            return this.clone().endOf(units).valueOf() < localInput.valueOf();
	        }
	    }

	    function isBetween(from, to, units, inclusivity) {
	        var localFrom = isMoment(from) ? from : createLocal(from),
	            localTo = isMoment(to) ? to : createLocal(to);
	        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
	            return false;
	        }
	        inclusivity = inclusivity || '()';
	        return (
	            (inclusivity[0] === '('
	                ? this.isAfter(localFrom, units)
	                : !this.isBefore(localFrom, units)) &&
	            (inclusivity[1] === ')'
	                ? this.isBefore(localTo, units)
	                : !this.isAfter(localTo, units))
	        );
	    }

	    function isSame(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input),
	            inputMs;
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() === localInput.valueOf();
	        } else {
	            inputMs = localInput.valueOf();
	            return (
	                this.clone().startOf(units).valueOf() <= inputMs &&
	                inputMs <= this.clone().endOf(units).valueOf()
	            );
	        }
	    }

	    function isSameOrAfter(input, units) {
	        return this.isSame(input, units) || this.isAfter(input, units);
	    }

	    function isSameOrBefore(input, units) {
	        return this.isSame(input, units) || this.isBefore(input, units);
	    }

	    function diff(input, units, asFloat) {
	        var that, zoneDelta, output;

	        if (!this.isValid()) {
	            return NaN;
	        }

	        that = cloneWithOffset(input, this);

	        if (!that.isValid()) {
	            return NaN;
	        }

	        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

	        units = normalizeUnits(units);

	        switch (units) {
	            case 'year':
	                output = monthDiff(this, that) / 12;
	                break;
	            case 'month':
	                output = monthDiff(this, that);
	                break;
	            case 'quarter':
	                output = monthDiff(this, that) / 3;
	                break;
	            case 'second':
	                output = (this - that) / 1e3;
	                break; // 1000
	            case 'minute':
	                output = (this - that) / 6e4;
	                break; // 1000 * 60
	            case 'hour':
	                output = (this - that) / 36e5;
	                break; // 1000 * 60 * 60
	            case 'day':
	                output = (this - that - zoneDelta) / 864e5;
	                break; // 1000 * 60 * 60 * 24, negate dst
	            case 'week':
	                output = (this - that - zoneDelta) / 6048e5;
	                break; // 1000 * 60 * 60 * 24 * 7, negate dst
	            default:
	                output = this - that;
	        }

	        return asFloat ? output : absFloor(output);
	    }

	    function monthDiff(a, b) {
	        if (a.date() < b.date()) {
	            // end-of-month calculations work correct when the start month has more
	            // days than the end month.
	            return -monthDiff(b, a);
	        }
	        // difference in months
	        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
	            // b is in (anchor - 1 month, anchor + 1 month)
	            anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2,
	            adjust;

	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }

	        //check for negative zero, return zero if negative zero
	        return -(wholeMonthDiff + adjust) || 0;
	    }

	    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

	    function toString() {
	        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	    }

	    function toISOString(keepOffset) {
	        if (!this.isValid()) {
	            return null;
	        }
	        var utc = keepOffset !== true,
	            m = utc ? this.clone().utc() : this;
	        if (m.year() < 0 || m.year() > 9999) {
	            return formatMoment(
	                m,
	                utc
	                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
	                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
	            );
	        }
	        if (isFunction(Date.prototype.toISOString)) {
	            // native implementation is ~50x faster, use it when we can
	            if (utc) {
	                return this.toDate().toISOString();
	            } else {
	                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
	                    .toISOString()
	                    .replace('Z', formatMoment(m, 'Z'));
	            }
	        }
	        return formatMoment(
	            m,
	            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
	        );
	    }

	    /**
	     * Return a human readable representation of a moment that can
	     * also be evaluated to get a new moment which is the same
	     *
	     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	     */
	    function inspect() {
	        if (!this.isValid()) {
	            return 'moment.invalid(/* ' + this._i + ' */)';
	        }
	        var func = 'moment',
	            zone = '',
	            prefix,
	            year,
	            datetime,
	            suffix;
	        if (!this.isLocal()) {
	            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	            zone = 'Z';
	        }
	        prefix = '[' + func + '("]';
	        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
	        datetime = '-MM-DD[T]HH:mm:ss.SSS';
	        suffix = zone + '[")]';

	        return this.format(prefix + year + datetime + suffix);
	    }

	    function format(inputString) {
	        if (!inputString) {
	            inputString = this.isUtc()
	                ? hooks.defaultFormatUtc
	                : hooks.defaultFormat;
	        }
	        var output = formatMoment(this, inputString);
	        return this.localeData().postformat(output);
	    }

	    function from(time, withoutSuffix) {
	        if (
	            this.isValid() &&
	            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
	        ) {
	            return createDuration({ to: this, from: time })
	                .locale(this.locale())
	                .humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }

	    function fromNow(withoutSuffix) {
	        return this.from(createLocal(), withoutSuffix);
	    }

	    function to(time, withoutSuffix) {
	        if (
	            this.isValid() &&
	            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
	        ) {
	            return createDuration({ from: this, to: time })
	                .locale(this.locale())
	                .humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }

	    function toNow(withoutSuffix) {
	        return this.to(createLocal(), withoutSuffix);
	    }

	    // If passed a locale key, it will set the locale for this
	    // instance.  Otherwise, it will return the locale configuration
	    // variables for this instance.
	    function locale(key) {
	        var newLocaleData;

	        if (key === undefined) {
	            return this._locale._abbr;
	        } else {
	            newLocaleData = getLocale(key);
	            if (newLocaleData != null) {
	                this._locale = newLocaleData;
	            }
	            return this;
	        }
	    }

	    var lang = deprecate(
	        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	        function (key) {
	            if (key === undefined) {
	                return this.localeData();
	            } else {
	                return this.locale(key);
	            }
	        }
	    );

	    function localeData() {
	        return this._locale;
	    }

	    var MS_PER_SECOND = 1000,
	        MS_PER_MINUTE = 60 * MS_PER_SECOND,
	        MS_PER_HOUR = 60 * MS_PER_MINUTE,
	        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

	    // actual modulo - handles negative numbers (for dates before 1970):
	    function mod$1(dividend, divisor) {
	        return ((dividend % divisor) + divisor) % divisor;
	    }

	    function localStartOfDate(y, m, d) {
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return new Date(y, m, d).valueOf();
	        }
	    }

	    function utcStartOfDate(y, m, d) {
	        // Date.UTC remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return Date.UTC(y, m, d);
	        }
	    }

	    function startOf(units) {
	        var time, startOfDate;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }

	        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year(), 0, 1);
	                break;
	            case 'quarter':
	                time = startOfDate(
	                    this.year(),
	                    this.month() - (this.month() % 3),
	                    1
	                );
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month(), 1);
	                break;
	            case 'week':
	                time = startOfDate(
	                    this.year(),
	                    this.month(),
	                    this.date() - this.weekday()
	                );
	                break;
	            case 'isoWeek':
	                time = startOfDate(
	                    this.year(),
	                    this.month(),
	                    this.date() - (this.isoWeekday() - 1)
	                );
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date());
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time -= mod$1(
	                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
	                    MS_PER_HOUR
	                );
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_MINUTE);
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_SECOND);
	                break;
	        }

	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }

	    function endOf(units) {
	        var time, startOfDate;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }

	        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year() + 1, 0, 1) - 1;
	                break;
	            case 'quarter':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month() - (this.month() % 3) + 3,
	                        1
	                    ) - 1;
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
	                break;
	            case 'week':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month(),
	                        this.date() - this.weekday() + 7
	                    ) - 1;
	                break;
	            case 'isoWeek':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month(),
	                        this.date() - (this.isoWeekday() - 1) + 7
	                    ) - 1;
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time +=
	                    MS_PER_HOUR -
	                    mod$1(
	                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
	                        MS_PER_HOUR
	                    ) -
	                    1;
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
	                break;
	        }

	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }

	    function valueOf() {
	        return this._d.valueOf() - (this._offset || 0) * 60000;
	    }

	    function unix() {
	        return Math.floor(this.valueOf() / 1000);
	    }

	    function toDate() {
	        return new Date(this.valueOf());
	    }

	    function toArray() {
	        var m = this;
	        return [
	            m.year(),
	            m.month(),
	            m.date(),
	            m.hour(),
	            m.minute(),
	            m.second(),
	            m.millisecond(),
	        ];
	    }

	    function toObject() {
	        var m = this;
	        return {
	            years: m.year(),
	            months: m.month(),
	            date: m.date(),
	            hours: m.hours(),
	            minutes: m.minutes(),
	            seconds: m.seconds(),
	            milliseconds: m.milliseconds(),
	        };
	    }

	    function toJSON() {
	        // new Date(NaN).toJSON() === null
	        return this.isValid() ? this.toISOString() : null;
	    }

	    function isValid$2() {
	        return isValid(this);
	    }

	    function parsingFlags() {
	        return extend({}, getParsingFlags(this));
	    }

	    function invalidAt() {
	        return getParsingFlags(this).overflow;
	    }

	    function creationData() {
	        return {
	            input: this._i,
	            format: this._f,
	            locale: this._locale,
	            isUTC: this._isUTC,
	            strict: this._strict,
	        };
	    }

	    addFormatToken('N', 0, 0, 'eraAbbr');
	    addFormatToken('NN', 0, 0, 'eraAbbr');
	    addFormatToken('NNN', 0, 0, 'eraAbbr');
	    addFormatToken('NNNN', 0, 0, 'eraName');
	    addFormatToken('NNNNN', 0, 0, 'eraNarrow');

	    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
	    addFormatToken('y', ['yy', 2], 0, 'eraYear');
	    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
	    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

	    addRegexToken('N', matchEraAbbr);
	    addRegexToken('NN', matchEraAbbr);
	    addRegexToken('NNN', matchEraAbbr);
	    addRegexToken('NNNN', matchEraName);
	    addRegexToken('NNNNN', matchEraNarrow);

	    addParseToken(['N', 'NN', 'NNN', 'NNNN', 'NNNNN'], function (
	        input,
	        array,
	        config,
	        token
	    ) {
	        var era = config._locale.erasParse(input, token, config._strict);
	        if (era) {
	            getParsingFlags(config).era = era;
	        } else {
	            getParsingFlags(config).invalidEra = input;
	        }
	    });

	    addRegexToken('y', matchUnsigned);
	    addRegexToken('yy', matchUnsigned);
	    addRegexToken('yyy', matchUnsigned);
	    addRegexToken('yyyy', matchUnsigned);
	    addRegexToken('yo', matchEraYearOrdinal);

	    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
	    addParseToken(['yo'], function (input, array, config, token) {
	        var match;
	        if (config._locale._eraYearOrdinalRegex) {
	            match = input.match(config._locale._eraYearOrdinalRegex);
	        }

	        if (config._locale.eraYearOrdinalParse) {
	            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
	        } else {
	            array[YEAR] = parseInt(input, 10);
	        }
	    });

	    function localeEras(m, format) {
	        var i,
	            l,
	            date,
	            eras = this._eras || getLocale('en')._eras;
	        for (i = 0, l = eras.length; i < l; ++i) {
	            switch (typeof eras[i].since) {
	                case 'string':
	                    // truncate time
	                    date = hooks(eras[i].since).startOf('day');
	                    eras[i].since = date.valueOf();
	                    break;
	            }

	            switch (typeof eras[i].until) {
	                case 'undefined':
	                    eras[i].until = +Infinity;
	                    break;
	                case 'string':
	                    // truncate time
	                    date = hooks(eras[i].until).startOf('day').valueOf();
	                    eras[i].until = date.valueOf();
	                    break;
	            }
	        }
	        return eras;
	    }

	    function localeErasParse(eraName, format, strict) {
	        var i,
	            l,
	            eras = this.eras(),
	            name,
	            abbr,
	            narrow;
	        eraName = eraName.toUpperCase();

	        for (i = 0, l = eras.length; i < l; ++i) {
	            name = eras[i].name.toUpperCase();
	            abbr = eras[i].abbr.toUpperCase();
	            narrow = eras[i].narrow.toUpperCase();

	            if (strict) {
	                switch (format) {
	                    case 'N':
	                    case 'NN':
	                    case 'NNN':
	                        if (abbr === eraName) {
	                            return eras[i];
	                        }
	                        break;

	                    case 'NNNN':
	                        if (name === eraName) {
	                            return eras[i];
	                        }
	                        break;

	                    case 'NNNNN':
	                        if (narrow === eraName) {
	                            return eras[i];
	                        }
	                        break;
	                }
	            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
	                return eras[i];
	            }
	        }
	    }

	    function localeErasConvertYear(era, year) {
	        var dir = era.since <= era.until ? +1 : -1;
	        if (year === undefined) {
	            return hooks(era.since).year();
	        } else {
	            return hooks(era.since).year() + (year - era.offset) * dir;
	        }
	    }

	    function getEraName() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();

	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].name;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].name;
	            }
	        }

	        return '';
	    }

	    function getEraNarrow() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();

	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].narrow;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].narrow;
	            }
	        }

	        return '';
	    }

	    function getEraAbbr() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();

	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].abbr;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].abbr;
	            }
	        }

	        return '';
	    }

	    function getEraYear() {
	        var i,
	            l,
	            dir,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            dir = eras[i].since <= eras[i].until ? +1 : -1;

	            // truncate time
	            val = this.clone().startOf('day').valueOf();

	            if (
	                (eras[i].since <= val && val <= eras[i].until) ||
	                (eras[i].until <= val && val <= eras[i].since)
	            ) {
	                return (
	                    (this.year() - hooks(eras[i].since).year()) * dir +
	                    eras[i].offset
	                );
	            }
	        }

	        return this.year();
	    }

	    function erasNameRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasNameRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasNameRegex : this._erasRegex;
	    }

	    function erasAbbrRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasAbbrRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasAbbrRegex : this._erasRegex;
	    }

	    function erasNarrowRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasNarrowRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasNarrowRegex : this._erasRegex;
	    }

	    function matchEraAbbr(isStrict, locale) {
	        return locale.erasAbbrRegex(isStrict);
	    }

	    function matchEraName(isStrict, locale) {
	        return locale.erasNameRegex(isStrict);
	    }

	    function matchEraNarrow(isStrict, locale) {
	        return locale.erasNarrowRegex(isStrict);
	    }

	    function matchEraYearOrdinal(isStrict, locale) {
	        return locale._eraYearOrdinalRegex || matchUnsigned;
	    }

	    function computeErasParse() {
	        var abbrPieces = [],
	            namePieces = [],
	            narrowPieces = [],
	            mixedPieces = [],
	            i,
	            l,
	            eras = this.eras();

	        for (i = 0, l = eras.length; i < l; ++i) {
	            namePieces.push(regexEscape(eras[i].name));
	            abbrPieces.push(regexEscape(eras[i].abbr));
	            narrowPieces.push(regexEscape(eras[i].narrow));

	            mixedPieces.push(regexEscape(eras[i].name));
	            mixedPieces.push(regexEscape(eras[i].abbr));
	            mixedPieces.push(regexEscape(eras[i].narrow));
	        }

	        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
	        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
	        this._erasNarrowRegex = new RegExp(
	            '^(' + narrowPieces.join('|') + ')',
	            'i'
	        );
	    }

	    // FORMATTING

	    addFormatToken(0, ['gg', 2], 0, function () {
	        return this.weekYear() % 100;
	    });

	    addFormatToken(0, ['GG', 2], 0, function () {
	        return this.isoWeekYear() % 100;
	    });

	    function addWeekYearFormatToken(token, getter) {
	        addFormatToken(0, [token, token.length], 0, getter);
	    }

	    addWeekYearFormatToken('gggg', 'weekYear');
	    addWeekYearFormatToken('ggggg', 'weekYear');
	    addWeekYearFormatToken('GGGG', 'isoWeekYear');
	    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

	    // ALIASES

	    addUnitAlias('weekYear', 'gg');
	    addUnitAlias('isoWeekYear', 'GG');

	    // PRIORITY

	    addUnitPriority('weekYear', 1);
	    addUnitPriority('isoWeekYear', 1);

	    // PARSING

	    addRegexToken('G', matchSigned);
	    addRegexToken('g', matchSigned);
	    addRegexToken('GG', match1to2, match2);
	    addRegexToken('gg', match1to2, match2);
	    addRegexToken('GGGG', match1to4, match4);
	    addRegexToken('gggg', match1to4, match4);
	    addRegexToken('GGGGG', match1to6, match6);
	    addRegexToken('ggggg', match1to6, match6);

	    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (
	        input,
	        week,
	        config,
	        token
	    ) {
	        week[token.substr(0, 2)] = toInt(input);
	    });

	    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	        week[token] = hooks.parseTwoDigitYear(input);
	    });

	    // MOMENTS

	    function getSetWeekYear(input) {
	        return getSetWeekYearHelper.call(
	            this,
	            input,
	            this.week(),
	            this.weekday(),
	            this.localeData()._week.dow,
	            this.localeData()._week.doy
	        );
	    }

	    function getSetISOWeekYear(input) {
	        return getSetWeekYearHelper.call(
	            this,
	            input,
	            this.isoWeek(),
	            this.isoWeekday(),
	            1,
	            4
	        );
	    }

	    function getISOWeeksInYear() {
	        return weeksInYear(this.year(), 1, 4);
	    }

	    function getISOWeeksInISOWeekYear() {
	        return weeksInYear(this.isoWeekYear(), 1, 4);
	    }

	    function getWeeksInYear() {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	    }

	    function getWeeksInWeekYear() {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
	    }

	    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	        var weeksTarget;
	        if (input == null) {
	            return weekOfYear(this, dow, doy).year;
	        } else {
	            weeksTarget = weeksInYear(input, dow, doy);
	            if (week > weeksTarget) {
	                week = weeksTarget;
	            }
	            return setWeekAll.call(this, input, week, weekday, dow, doy);
	        }
	    }

	    function setWeekAll(weekYear, week, weekday, dow, doy) {
	        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

	        this.year(date.getUTCFullYear());
	        this.month(date.getUTCMonth());
	        this.date(date.getUTCDate());
	        return this;
	    }

	    // FORMATTING

	    addFormatToken('Q', 0, 'Qo', 'quarter');

	    // ALIASES

	    addUnitAlias('quarter', 'Q');

	    // PRIORITY

	    addUnitPriority('quarter', 7);

	    // PARSING

	    addRegexToken('Q', match1);
	    addParseToken('Q', function (input, array) {
	        array[MONTH] = (toInt(input) - 1) * 3;
	    });

	    // MOMENTS

	    function getSetQuarter(input) {
	        return input == null
	            ? Math.ceil((this.month() + 1) / 3)
	            : this.month((input - 1) * 3 + (this.month() % 3));
	    }

	    // FORMATTING

	    addFormatToken('D', ['DD', 2], 'Do', 'date');

	    // ALIASES

	    addUnitAlias('date', 'D');

	    // PRIORITY
	    addUnitPriority('date', 9);

	    // PARSING

	    addRegexToken('D', match1to2);
	    addRegexToken('DD', match1to2, match2);
	    addRegexToken('Do', function (isStrict, locale) {
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        return isStrict
	            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
	            : locale._dayOfMonthOrdinalParseLenient;
	    });

	    addParseToken(['D', 'DD'], DATE);
	    addParseToken('Do', function (input, array) {
	        array[DATE] = toInt(input.match(match1to2)[0]);
	    });

	    // MOMENTS

	    var getSetDayOfMonth = makeGetSet('Date', true);

	    // FORMATTING

	    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

	    // ALIASES

	    addUnitAlias('dayOfYear', 'DDD');

	    // PRIORITY
	    addUnitPriority('dayOfYear', 4);

	    // PARSING

	    addRegexToken('DDD', match1to3);
	    addRegexToken('DDDD', match3);
	    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	        config._dayOfYear = toInt(input);
	    });

	    // HELPERS

	    // MOMENTS

	    function getSetDayOfYear(input) {
	        var dayOfYear =
	            Math.round(
	                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
	            ) + 1;
	        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
	    }

	    // FORMATTING

	    addFormatToken('m', ['mm', 2], 0, 'minute');

	    // ALIASES

	    addUnitAlias('minute', 'm');

	    // PRIORITY

	    addUnitPriority('minute', 14);

	    // PARSING

	    addRegexToken('m', match1to2);
	    addRegexToken('mm', match1to2, match2);
	    addParseToken(['m', 'mm'], MINUTE);

	    // MOMENTS

	    var getSetMinute = makeGetSet('Minutes', false);

	    // FORMATTING

	    addFormatToken('s', ['ss', 2], 0, 'second');

	    // ALIASES

	    addUnitAlias('second', 's');

	    // PRIORITY

	    addUnitPriority('second', 15);

	    // PARSING

	    addRegexToken('s', match1to2);
	    addRegexToken('ss', match1to2, match2);
	    addParseToken(['s', 'ss'], SECOND);

	    // MOMENTS

	    var getSetSecond = makeGetSet('Seconds', false);

	    // FORMATTING

	    addFormatToken('S', 0, 0, function () {
	        return ~~(this.millisecond() / 100);
	    });

	    addFormatToken(0, ['SS', 2], 0, function () {
	        return ~~(this.millisecond() / 10);
	    });

	    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	    addFormatToken(0, ['SSSS', 4], 0, function () {
	        return this.millisecond() * 10;
	    });
	    addFormatToken(0, ['SSSSS', 5], 0, function () {
	        return this.millisecond() * 100;
	    });
	    addFormatToken(0, ['SSSSSS', 6], 0, function () {
	        return this.millisecond() * 1000;
	    });
	    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	        return this.millisecond() * 10000;
	    });
	    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	        return this.millisecond() * 100000;
	    });
	    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	        return this.millisecond() * 1000000;
	    });

	    // ALIASES

	    addUnitAlias('millisecond', 'ms');

	    // PRIORITY

	    addUnitPriority('millisecond', 16);

	    // PARSING

	    addRegexToken('S', match1to3, match1);
	    addRegexToken('SS', match1to3, match2);
	    addRegexToken('SSS', match1to3, match3);

	    var token, getSetMillisecond;
	    for (token = 'SSSS'; token.length <= 9; token += 'S') {
	        addRegexToken(token, matchUnsigned);
	    }

	    function parseMs(input, array) {
	        array[MILLISECOND] = toInt(('0.' + input) * 1000);
	    }

	    for (token = 'S'; token.length <= 9; token += 'S') {
	        addParseToken(token, parseMs);
	    }

	    getSetMillisecond = makeGetSet('Milliseconds', false);

	    // FORMATTING

	    addFormatToken('z', 0, 0, 'zoneAbbr');
	    addFormatToken('zz', 0, 0, 'zoneName');

	    // MOMENTS

	    function getZoneAbbr() {
	        return this._isUTC ? 'UTC' : '';
	    }

	    function getZoneName() {
	        return this._isUTC ? 'Coordinated Universal Time' : '';
	    }

	    var proto = Moment.prototype;

	    proto.add = add;
	    proto.calendar = calendar$1;
	    proto.clone = clone;
	    proto.diff = diff;
	    proto.endOf = endOf;
	    proto.format = format;
	    proto.from = from;
	    proto.fromNow = fromNow;
	    proto.to = to;
	    proto.toNow = toNow;
	    proto.get = stringGet;
	    proto.invalidAt = invalidAt;
	    proto.isAfter = isAfter;
	    proto.isBefore = isBefore;
	    proto.isBetween = isBetween;
	    proto.isSame = isSame;
	    proto.isSameOrAfter = isSameOrAfter;
	    proto.isSameOrBefore = isSameOrBefore;
	    proto.isValid = isValid$2;
	    proto.lang = lang;
	    proto.locale = locale;
	    proto.localeData = localeData;
	    proto.max = prototypeMax;
	    proto.min = prototypeMin;
	    proto.parsingFlags = parsingFlags;
	    proto.set = stringSet;
	    proto.startOf = startOf;
	    proto.subtract = subtract;
	    proto.toArray = toArray;
	    proto.toObject = toObject;
	    proto.toDate = toDate;
	    proto.toISOString = toISOString;
	    proto.inspect = inspect;
	    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
	        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
	            return 'Moment<' + this.format() + '>';
	        };
	    }
	    proto.toJSON = toJSON;
	    proto.toString = toString;
	    proto.unix = unix;
	    proto.valueOf = valueOf;
	    proto.creationData = creationData;
	    proto.eraName = getEraName;
	    proto.eraNarrow = getEraNarrow;
	    proto.eraAbbr = getEraAbbr;
	    proto.eraYear = getEraYear;
	    proto.year = getSetYear;
	    proto.isLeapYear = getIsLeapYear;
	    proto.weekYear = getSetWeekYear;
	    proto.isoWeekYear = getSetISOWeekYear;
	    proto.quarter = proto.quarters = getSetQuarter;
	    proto.month = getSetMonth;
	    proto.daysInMonth = getDaysInMonth;
	    proto.week = proto.weeks = getSetWeek;
	    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
	    proto.weeksInYear = getWeeksInYear;
	    proto.weeksInWeekYear = getWeeksInWeekYear;
	    proto.isoWeeksInYear = getISOWeeksInYear;
	    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
	    proto.date = getSetDayOfMonth;
	    proto.day = proto.days = getSetDayOfWeek;
	    proto.weekday = getSetLocaleDayOfWeek;
	    proto.isoWeekday = getSetISODayOfWeek;
	    proto.dayOfYear = getSetDayOfYear;
	    proto.hour = proto.hours = getSetHour;
	    proto.minute = proto.minutes = getSetMinute;
	    proto.second = proto.seconds = getSetSecond;
	    proto.millisecond = proto.milliseconds = getSetMillisecond;
	    proto.utcOffset = getSetOffset;
	    proto.utc = setOffsetToUTC;
	    proto.local = setOffsetToLocal;
	    proto.parseZone = setOffsetToParsedOffset;
	    proto.hasAlignedHourOffset = hasAlignedHourOffset;
	    proto.isDST = isDaylightSavingTime;
	    proto.isLocal = isLocal;
	    proto.isUtcOffset = isUtcOffset;
	    proto.isUtc = isUtc;
	    proto.isUTC = isUtc;
	    proto.zoneAbbr = getZoneAbbr;
	    proto.zoneName = getZoneName;
	    proto.dates = deprecate(
	        'dates accessor is deprecated. Use date instead.',
	        getSetDayOfMonth
	    );
	    proto.months = deprecate(
	        'months accessor is deprecated. Use month instead',
	        getSetMonth
	    );
	    proto.years = deprecate(
	        'years accessor is deprecated. Use year instead',
	        getSetYear
	    );
	    proto.zone = deprecate(
	        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
	        getSetZone
	    );
	    proto.isDSTShifted = deprecate(
	        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
	        isDaylightSavingTimeShifted
	    );

	    function createUnix(input) {
	        return createLocal(input * 1000);
	    }

	    function createInZone() {
	        return createLocal.apply(null, arguments).parseZone();
	    }

	    function preParsePostFormat(string) {
	        return string;
	    }

	    var proto$1 = Locale.prototype;

	    proto$1.calendar = calendar;
	    proto$1.longDateFormat = longDateFormat;
	    proto$1.invalidDate = invalidDate;
	    proto$1.ordinal = ordinal;
	    proto$1.preparse = preParsePostFormat;
	    proto$1.postformat = preParsePostFormat;
	    proto$1.relativeTime = relativeTime;
	    proto$1.pastFuture = pastFuture;
	    proto$1.set = set;
	    proto$1.eras = localeEras;
	    proto$1.erasParse = localeErasParse;
	    proto$1.erasConvertYear = localeErasConvertYear;
	    proto$1.erasAbbrRegex = erasAbbrRegex;
	    proto$1.erasNameRegex = erasNameRegex;
	    proto$1.erasNarrowRegex = erasNarrowRegex;

	    proto$1.months = localeMonths;
	    proto$1.monthsShort = localeMonthsShort;
	    proto$1.monthsParse = localeMonthsParse;
	    proto$1.monthsRegex = monthsRegex;
	    proto$1.monthsShortRegex = monthsShortRegex;
	    proto$1.week = localeWeek;
	    proto$1.firstDayOfYear = localeFirstDayOfYear;
	    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

	    proto$1.weekdays = localeWeekdays;
	    proto$1.weekdaysMin = localeWeekdaysMin;
	    proto$1.weekdaysShort = localeWeekdaysShort;
	    proto$1.weekdaysParse = localeWeekdaysParse;

	    proto$1.weekdaysRegex = weekdaysRegex;
	    proto$1.weekdaysShortRegex = weekdaysShortRegex;
	    proto$1.weekdaysMinRegex = weekdaysMinRegex;

	    proto$1.isPM = localeIsPM;
	    proto$1.meridiem = localeMeridiem;

	    function get$1(format, index, field, setter) {
	        var locale = getLocale(),
	            utc = createUTC().set(setter, index);
	        return locale[field](utc, format);
	    }

	    function listMonthsImpl(format, index, field) {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }

	        format = format || '';

	        if (index != null) {
	            return get$1(format, index, field, 'month');
	        }

	        var i,
	            out = [];
	        for (i = 0; i < 12; i++) {
	            out[i] = get$1(format, i, field, 'month');
	        }
	        return out;
	    }

	    // ()
	    // (5)
	    // (fmt, 5)
	    // (fmt)
	    // (true)
	    // (true, 5)
	    // (true, fmt, 5)
	    // (true, fmt)
	    function listWeekdaysImpl(localeSorted, format, index, field) {
	        if (typeof localeSorted === 'boolean') {
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }

	            format = format || '';
	        } else {
	            format = localeSorted;
	            index = format;
	            localeSorted = false;

	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }

	            format = format || '';
	        }

	        var locale = getLocale(),
	            shift = localeSorted ? locale._week.dow : 0,
	            i,
	            out = [];

	        if (index != null) {
	            return get$1(format, (index + shift) % 7, field, 'day');
	        }

	        for (i = 0; i < 7; i++) {
	            out[i] = get$1(format, (i + shift) % 7, field, 'day');
	        }
	        return out;
	    }

	    function listMonths(format, index) {
	        return listMonthsImpl(format, index, 'months');
	    }

	    function listMonthsShort(format, index) {
	        return listMonthsImpl(format, index, 'monthsShort');
	    }

	    function listWeekdays(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	    }

	    function listWeekdaysShort(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	    }

	    function listWeekdaysMin(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	    }

	    getSetGlobalLocale('en', {
	        eras: [
	            {
	                since: '0001-01-01',
	                until: +Infinity,
	                offset: 1,
	                name: 'Anno Domini',
	                narrow: 'AD',
	                abbr: 'AD',
	            },
	            {
	                since: '0000-12-31',
	                until: -Infinity,
	                offset: 1,
	                name: 'Before Christ',
	                narrow: 'BC',
	                abbr: 'BC',
	            },
	        ],
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    toInt((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	    });

	    // Side effect imports

	    hooks.lang = deprecate(
	        'moment.lang is deprecated. Use moment.locale instead.',
	        getSetGlobalLocale
	    );
	    hooks.langData = deprecate(
	        'moment.langData is deprecated. Use moment.localeData instead.',
	        getLocale
	    );

	    var mathAbs = Math.abs;

	    function abs() {
	        var data = this._data;

	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days = mathAbs(this._days);
	        this._months = mathAbs(this._months);

	        data.milliseconds = mathAbs(data.milliseconds);
	        data.seconds = mathAbs(data.seconds);
	        data.minutes = mathAbs(data.minutes);
	        data.hours = mathAbs(data.hours);
	        data.months = mathAbs(data.months);
	        data.years = mathAbs(data.years);

	        return this;
	    }

	    function addSubtract$1(duration, input, value, direction) {
	        var other = createDuration(input, value);

	        duration._milliseconds += direction * other._milliseconds;
	        duration._days += direction * other._days;
	        duration._months += direction * other._months;

	        return duration._bubble();
	    }

	    // supports only 2.0-style add(1, 's') or add(duration)
	    function add$1(input, value) {
	        return addSubtract$1(this, input, value, 1);
	    }

	    // supports only 2.0-style subtract(1, 's') or subtract(duration)
	    function subtract$1(input, value) {
	        return addSubtract$1(this, input, value, -1);
	    }

	    function absCeil(number) {
	        if (number < 0) {
	            return Math.floor(number);
	        } else {
	            return Math.ceil(number);
	        }
	    }

	    function bubble() {
	        var milliseconds = this._milliseconds,
	            days = this._days,
	            months = this._months,
	            data = this._data,
	            seconds,
	            minutes,
	            hours,
	            years,
	            monthsFromDays;

	        // if we have a mix of positive and negative values, bubble down first
	        // check: https://github.com/moment/moment/issues/2166
	        if (
	            !(
	                (milliseconds >= 0 && days >= 0 && months >= 0) ||
	                (milliseconds <= 0 && days <= 0 && months <= 0)
	            )
	        ) {
	            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	            days = 0;
	            months = 0;
	        }

	        // The following code bubbles up values, see the tests for
	        // examples of what that means.
	        data.milliseconds = milliseconds % 1000;

	        seconds = absFloor(milliseconds / 1000);
	        data.seconds = seconds % 60;

	        minutes = absFloor(seconds / 60);
	        data.minutes = minutes % 60;

	        hours = absFloor(minutes / 60);
	        data.hours = hours % 24;

	        days += absFloor(hours / 24);

	        // convert days to months
	        monthsFromDays = absFloor(daysToMonths(days));
	        months += monthsFromDays;
	        days -= absCeil(monthsToDays(monthsFromDays));

	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;

	        data.days = days;
	        data.months = months;
	        data.years = years;

	        return this;
	    }

	    function daysToMonths(days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        // 400 years have 12 months === 4800
	        return (days * 4800) / 146097;
	    }

	    function monthsToDays(months) {
	        // the reverse of daysToMonths
	        return (months * 146097) / 4800;
	    }

	    function as(units) {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        var days,
	            months,
	            milliseconds = this._milliseconds;

	        units = normalizeUnits(units);

	        if (units === 'month' || units === 'quarter' || units === 'year') {
	            days = this._days + milliseconds / 864e5;
	            months = this._months + daysToMonths(days);
	            switch (units) {
	                case 'month':
	                    return months;
	                case 'quarter':
	                    return months / 3;
	                case 'year':
	                    return months / 12;
	            }
	        } else {
	            // handle milliseconds separately because of floating point math errors (issue #1867)
	            days = this._days + Math.round(monthsToDays(this._months));
	            switch (units) {
	                case 'week':
	                    return days / 7 + milliseconds / 6048e5;
	                case 'day':
	                    return days + milliseconds / 864e5;
	                case 'hour':
	                    return days * 24 + milliseconds / 36e5;
	                case 'minute':
	                    return days * 1440 + milliseconds / 6e4;
	                case 'second':
	                    return days * 86400 + milliseconds / 1000;
	                // Math.floor prevents floating point math errors here
	                case 'millisecond':
	                    return Math.floor(days * 864e5) + milliseconds;
	                default:
	                    throw new Error('Unknown unit ' + units);
	            }
	        }
	    }

	    // TODO: Use this.as('ms')?
	    function valueOf$1() {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        return (
	            this._milliseconds +
	            this._days * 864e5 +
	            (this._months % 12) * 2592e6 +
	            toInt(this._months / 12) * 31536e6
	        );
	    }

	    function makeAs(alias) {
	        return function () {
	            return this.as(alias);
	        };
	    }

	    var asMilliseconds = makeAs('ms'),
	        asSeconds = makeAs('s'),
	        asMinutes = makeAs('m'),
	        asHours = makeAs('h'),
	        asDays = makeAs('d'),
	        asWeeks = makeAs('w'),
	        asMonths = makeAs('M'),
	        asQuarters = makeAs('Q'),
	        asYears = makeAs('y');

	    function clone$1() {
	        return createDuration(this);
	    }

	    function get$2(units) {
	        units = normalizeUnits(units);
	        return this.isValid() ? this[units + 's']() : NaN;
	    }

	    function makeGetter(name) {
	        return function () {
	            return this.isValid() ? this._data[name] : NaN;
	        };
	    }

	    var milliseconds = makeGetter('milliseconds'),
	        seconds = makeGetter('seconds'),
	        minutes = makeGetter('minutes'),
	        hours = makeGetter('hours'),
	        days = makeGetter('days'),
	        months = makeGetter('months'),
	        years = makeGetter('years');

	    function weeks() {
	        return absFloor(this.days() / 7);
	    }

	    var round = Math.round,
	        thresholds = {
	            ss: 44, // a few seconds to seconds
	            s: 45, // seconds to minute
	            m: 45, // minutes to hour
	            h: 22, // hours to day
	            d: 26, // days to month/week
	            w: null, // weeks to month
	            M: 11, // months to year
	        };

	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }

	    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
	        var duration = createDuration(posNegDuration).abs(),
	            seconds = round(duration.as('s')),
	            minutes = round(duration.as('m')),
	            hours = round(duration.as('h')),
	            days = round(duration.as('d')),
	            months = round(duration.as('M')),
	            weeks = round(duration.as('w')),
	            years = round(duration.as('y')),
	            a =
	                (seconds <= thresholds.ss && ['s', seconds]) ||
	                (seconds < thresholds.s && ['ss', seconds]) ||
	                (minutes <= 1 && ['m']) ||
	                (minutes < thresholds.m && ['mm', minutes]) ||
	                (hours <= 1 && ['h']) ||
	                (hours < thresholds.h && ['hh', hours]) ||
	                (days <= 1 && ['d']) ||
	                (days < thresholds.d && ['dd', days]);

	        if (thresholds.w != null) {
	            a =
	                a ||
	                (weeks <= 1 && ['w']) ||
	                (weeks < thresholds.w && ['ww', weeks]);
	        }
	        a = a ||
	            (months <= 1 && ['M']) ||
	            (months < thresholds.M && ['MM', months]) ||
	            (years <= 1 && ['y']) || ['yy', years];

	        a[2] = withoutSuffix;
	        a[3] = +posNegDuration > 0;
	        a[4] = locale;
	        return substituteTimeAgo.apply(null, a);
	    }

	    // This function allows you to set the rounding function for relative time strings
	    function getSetRelativeTimeRounding(roundingFunction) {
	        if (roundingFunction === undefined) {
	            return round;
	        }
	        if (typeof roundingFunction === 'function') {
	            round = roundingFunction;
	            return true;
	        }
	        return false;
	    }

	    // This function allows you to set a threshold for relative time strings
	    function getSetRelativeTimeThreshold(threshold, limit) {
	        if (thresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return thresholds[threshold];
	        }
	        thresholds[threshold] = limit;
	        if (threshold === 's') {
	            thresholds.ss = limit - 1;
	        }
	        return true;
	    }

	    function humanize(argWithSuffix, argThresholds) {
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }

	        var withSuffix = false,
	            th = thresholds,
	            locale,
	            output;

	        if (typeof argWithSuffix === 'object') {
	            argThresholds = argWithSuffix;
	            argWithSuffix = false;
	        }
	        if (typeof argWithSuffix === 'boolean') {
	            withSuffix = argWithSuffix;
	        }
	        if (typeof argThresholds === 'object') {
	            th = Object.assign({}, thresholds, argThresholds);
	            if (argThresholds.s != null && argThresholds.ss == null) {
	                th.ss = argThresholds.s - 1;
	            }
	        }

	        locale = this.localeData();
	        output = relativeTime$1(this, !withSuffix, th, locale);

	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }

	        return locale.postformat(output);
	    }

	    var abs$1 = Math.abs;

	    function sign(x) {
	        return (x > 0) - (x < 0) || +x;
	    }

	    function toISOString$1() {
	        // for ISO strings we do not use the normal bubbling rules:
	        //  * milliseconds bubble up until they become hours
	        //  * days do not bubble at all
	        //  * months bubble up until they become years
	        // This is because there is no context-free conversion between hours and days
	        // (think of clock changes)
	        // and also not between days and months (28-31 days per month)
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }

	        var seconds = abs$1(this._milliseconds) / 1000,
	            days = abs$1(this._days),
	            months = abs$1(this._months),
	            minutes,
	            hours,
	            years,
	            s,
	            total = this.asSeconds(),
	            totalSign,
	            ymSign,
	            daysSign,
	            hmsSign;

	        if (!total) {
	            // this is the same as C#'s (Noda) and python (isodate)...
	            // but not other JS (goog.date)
	            return 'P0D';
	        }

	        // 3600 seconds -> 60 minutes -> 1 hour
	        minutes = absFloor(seconds / 60);
	        hours = absFloor(minutes / 60);
	        seconds %= 60;
	        minutes %= 60;

	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;

	        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

	        totalSign = total < 0 ? '-' : '';
	        ymSign = sign(this._months) !== sign(total) ? '-' : '';
	        daysSign = sign(this._days) !== sign(total) ? '-' : '';
	        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

	        return (
	            totalSign +
	            'P' +
	            (years ? ymSign + years + 'Y' : '') +
	            (months ? ymSign + months + 'M' : '') +
	            (days ? daysSign + days + 'D' : '') +
	            (hours || minutes || seconds ? 'T' : '') +
	            (hours ? hmsSign + hours + 'H' : '') +
	            (minutes ? hmsSign + minutes + 'M' : '') +
	            (seconds ? hmsSign + s + 'S' : '')
	        );
	    }

	    var proto$2 = Duration.prototype;

	    proto$2.isValid = isValid$1;
	    proto$2.abs = abs;
	    proto$2.add = add$1;
	    proto$2.subtract = subtract$1;
	    proto$2.as = as;
	    proto$2.asMilliseconds = asMilliseconds;
	    proto$2.asSeconds = asSeconds;
	    proto$2.asMinutes = asMinutes;
	    proto$2.asHours = asHours;
	    proto$2.asDays = asDays;
	    proto$2.asWeeks = asWeeks;
	    proto$2.asMonths = asMonths;
	    proto$2.asQuarters = asQuarters;
	    proto$2.asYears = asYears;
	    proto$2.valueOf = valueOf$1;
	    proto$2._bubble = bubble;
	    proto$2.clone = clone$1;
	    proto$2.get = get$2;
	    proto$2.milliseconds = milliseconds;
	    proto$2.seconds = seconds;
	    proto$2.minutes = minutes;
	    proto$2.hours = hours;
	    proto$2.days = days;
	    proto$2.weeks = weeks;
	    proto$2.months = months;
	    proto$2.years = years;
	    proto$2.humanize = humanize;
	    proto$2.toISOString = toISOString$1;
	    proto$2.toString = toISOString$1;
	    proto$2.toJSON = toISOString$1;
	    proto$2.locale = locale;
	    proto$2.localeData = localeData;

	    proto$2.toIsoString = deprecate(
	        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
	        toISOString$1
	    );
	    proto$2.lang = lang;

	    // FORMATTING

	    addFormatToken('X', 0, 0, 'unix');
	    addFormatToken('x', 0, 0, 'valueOf');

	    // PARSING

	    addRegexToken('x', matchSigned);
	    addRegexToken('X', matchTimestamp);
	    addParseToken('X', function (input, array, config) {
	        config._d = new Date(parseFloat(input) * 1000);
	    });
	    addParseToken('x', function (input, array, config) {
	        config._d = new Date(toInt(input));
	    });

	    //! moment.js

	    hooks.version = '2.29.1';

	    setHookCallback(createLocal);

	    hooks.fn = proto;
	    hooks.min = min;
	    hooks.max = max;
	    hooks.now = now;
	    hooks.utc = createUTC;
	    hooks.unix = createUnix;
	    hooks.months = listMonths;
	    hooks.isDate = isDate;
	    hooks.locale = getSetGlobalLocale;
	    hooks.invalid = createInvalid;
	    hooks.duration = createDuration;
	    hooks.isMoment = isMoment;
	    hooks.weekdays = listWeekdays;
	    hooks.parseZone = createInZone;
	    hooks.localeData = getLocale;
	    hooks.isDuration = isDuration;
	    hooks.monthsShort = listMonthsShort;
	    hooks.weekdaysMin = listWeekdaysMin;
	    hooks.defineLocale = defineLocale;
	    hooks.updateLocale = updateLocale;
	    hooks.locales = listLocales;
	    hooks.weekdaysShort = listWeekdaysShort;
	    hooks.normalizeUnits = normalizeUnits;
	    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
	    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	    hooks.calendarFormat = getCalendarFormat;
	    hooks.prototype = proto;

	    // currently HTML5 input type only supports 24-hour formats
	    hooks.HTML5_FMT = {
	        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
	        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
	        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
	        DATE: 'YYYY-MM-DD', // <input type="date" />
	        TIME: 'HH:mm', // <input type="time" />
	        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
	        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
	        WEEK: 'GGGG-[W]WW', // <input type="week" />
	        MONTH: 'YYYY-MM', // <input type="month" />
	    };

	    return hooks;

	}))); 
} (moment$1));

var momentExports = moment$1.exports;
var moment = /*@__PURE__*/getDefaultExportFromCjs(momentExports);

var server_node = {exports: {}};

var reactDomServer_node_production_min = {};

/** @license React v17.0.1
 * react-dom-server.node.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactDomServer_node_production_min;

function requireReactDomServer_node_production_min () {
	if (hasRequiredReactDomServer_node_production_min) return reactDomServer_node_production_min;
	hasRequiredReactDomServer_node_production_min = 1;
var l=objectAssign,n=React__default,aa=require$$2;function p(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return "Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
	var q=60106,r=60107,u=60108,z=60114,B=60109,ba=60110,ca=60112,D=60113,da=60120,ea=60115,fa=60116,ha=60121,ia=60117,ja=60119,ka=60129,la=60131;
	if("function"===typeof Symbol&&Symbol.for){var E=Symbol.for;q=E("react.portal");r=E("react.fragment");u=E("react.strict_mode");z=E("react.profiler");B=E("react.provider");ba=E("react.context");ca=E("react.forward_ref");D=E("react.suspense");da=E("react.suspense_list");ea=E("react.memo");fa=E("react.lazy");ha=E("react.block");ia=E("react.fundamental");ja=E("react.scope");ka=E("react.debug_trace_mode");la=E("react.legacy_hidden");}
	function F(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case r:return "Fragment";case q:return "Portal";case z:return "Profiler";case u:return "StrictMode";case D:return "Suspense";case da:return "SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case ba:return (a.displayName||"Context")+".Consumer";case B:return (a._context.displayName||"Context")+".Provider";case ca:var b=a.render;b=b.displayName||b.name||"";return a.displayName||
	(""!==b?"ForwardRef("+b+")":"ForwardRef");case ea:return F(a.type);case ha:return F(a._render);case fa:b=a._payload;a=a._init;try{return F(a(b))}catch(c){}}return null}var ma=n.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,na={};function I(a,b){for(var c=a._threadCount|0;c<=b;c++)a[c]=a._currentValue2,a._threadCount=c+1;}function oa(a,b,c,d){if(d&&(d=a.contextType,"object"===typeof d&&null!==d))return I(d,c),d[c];if(a=a.contextTypes){c={};for(var f in a)c[f]=b[f];b=c;}else b=na;return b}
	for(var J=new Uint16Array(16),K=0;15>K;K++)J[K]=K+1;J[15]=0;var pa=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,qa=Object.prototype.hasOwnProperty,ra={},sa={};
	function ta(a){if(qa.call(sa,a))return !0;if(qa.call(ra,a))return !1;if(pa.test(a))return sa[a]=!0;ra[a]=!0;return !1}function ua(a,b,c,d){if(null!==c&&0===c.type)return !1;switch(typeof b){case "function":case "symbol":return !0;case "boolean":if(d)return !1;if(null!==c)return !c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return "data-"!==a&&"aria-"!==a;default:return !1}}
	function va(a,b,c,d){if(null===b||"undefined"===typeof b||ua(a,b,c,d))return !0;if(d)return !1;if(null!==c)switch(c.type){case 3:return !b;case 4:return !1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return !1}function M(a,b,c,d,f,h,t){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=f;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=h;this.removeEmptyString=t;}var N={};
	"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){N[a]=new M(a,0,!1,a,null,!1,!1);});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];N[b]=new M(b,1,!1,a[1],null,!1,!1);});["contentEditable","draggable","spellCheck","value"].forEach(function(a){N[a]=new M(a,2,!1,a.toLowerCase(),null,!1,!1);});
	["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){N[a]=new M(a,2,!1,a,null,!1,!1);});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){N[a]=new M(a,3,!1,a.toLowerCase(),null,!1,!1);});
	["checked","multiple","muted","selected"].forEach(function(a){N[a]=new M(a,3,!0,a,null,!1,!1);});["capture","download"].forEach(function(a){N[a]=new M(a,4,!1,a,null,!1,!1);});["cols","rows","size","span"].forEach(function(a){N[a]=new M(a,6,!1,a,null,!1,!1);});["rowSpan","start"].forEach(function(a){N[a]=new M(a,5,!1,a.toLowerCase(),null,!1,!1);});var wa=/[\-:]([a-z])/g;function xa(a){return a[1].toUpperCase()}
	"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(wa,
	xa);N[b]=new M(b,1,!1,a,null,!1,!1);});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(wa,xa);N[b]=new M(b,1,!1,a,"http://www.w3.org/1999/xlink",!1,!1);});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(wa,xa);N[b]=new M(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1,!1);});["tabIndex","crossOrigin"].forEach(function(a){N[a]=new M(a,1,!1,a.toLowerCase(),null,!1,!1);});
	N.xlinkHref=new M("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0,!1);["src","href","action","formAction"].forEach(function(a){N[a]=new M(a,1,!1,a.toLowerCase(),null,!0,!0);});var ya=/["'&<>]/;
	function O(a){if("boolean"===typeof a||"number"===typeof a)return ""+a;a=""+a;var b=ya.exec(a);if(b){var c="",d,f=0;for(d=b.index;d<a.length;d++){switch(a.charCodeAt(d)){case 34:b="&quot;";break;case 38:b="&amp;";break;case 39:b="&#x27;";break;case 60:b="&lt;";break;case 62:b="&gt;";break;default:continue}f!==d&&(c+=a.substring(f,d));f=d+1;c+=b;}a=f!==d?c+a.substring(f,d):c;}return a}
	function za(a,b){var c=N.hasOwnProperty(a)?N[a]:null;var d;if(d="style"!==a)d=null!==c?0===c.type:!(2<a.length)||"o"!==a[0]&&"O"!==a[0]||"n"!==a[1]&&"N"!==a[1]?!1:!0;if(d||va(a,b,c,!1))return "";if(null!==c){a=c.attributeName;d=c.type;if(3===d||4===d&&!0===b)return a+'=""';c.sanitizeURL&&(b=""+b);return a+'="'+(O(b)+'"')}return ta(a)?a+'="'+(O(b)+'"'):""}function Aa(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}
	var Ba="function"===typeof Object.is?Object.is:Aa,P=null,Q=null,R=null,S=!1,T=!1,U=null,V=0;function W(){if(null===P)throw Error(p(321));return P}function Ca(){if(0<V)throw Error(p(312));return {memoizedState:null,queue:null,next:null}}function Da(){null===R?null===Q?(S=!1,Q=R=Ca()):(S=!0,R=Q):null===R.next?(S=!1,R=R.next=Ca()):(S=!0,R=R.next);return R}function Ea(a,b,c,d){for(;T;)T=!1,V+=1,R=null,c=a(b,d);Fa();return c}function Fa(){P=null;T=!1;Q=null;V=0;R=U=null;}
	function Ga(a,b){return "function"===typeof b?b(a):b}function Ha(a,b,c){P=W();R=Da();if(S){var d=R.queue;b=d.dispatch;if(null!==U&&(c=U.get(d),void 0!==c)){U.delete(d);d=R.memoizedState;do d=a(d,c.action),c=c.next;while(null!==c);R.memoizedState=d;return [d,b]}return [R.memoizedState,b]}a=a===Ga?"function"===typeof b?b():b:void 0!==c?c(b):b;R.memoizedState=a;a=R.queue={last:null,dispatch:null};a=a.dispatch=Ia.bind(null,P,a);return [R.memoizedState,a]}
	function Ja(a,b){P=W();R=Da();b=void 0===b?null:b;if(null!==R){var c=R.memoizedState;if(null!==c&&null!==b){var d=c[1];a:if(null===d)d=!1;else {for(var f=0;f<d.length&&f<b.length;f++)if(!Ba(b[f],d[f])){d=!1;break a}d=!0;}if(d)return c[0]}}a=a();R.memoizedState=[a,b];return a}function Ia(a,b,c){if(!(25>V))throw Error(p(301));if(a===P)if(T=!0,a={action:c,next:null},null===U&&(U=new Map),c=U.get(b),void 0===c)U.set(b,a);else {for(b=c;null!==b.next;)b=b.next;b.next=a;}}function Ka(){}
	var X=null,La={readContext:function(a){var b=X.threadID;I(a,b);return a[b]},useContext:function(a){W();var b=X.threadID;I(a,b);return a[b]},useMemo:Ja,useReducer:Ha,useRef:function(a){P=W();R=Da();var b=R.memoizedState;return null===b?(a={current:a},R.memoizedState=a):b},useState:function(a){return Ha(Ga,a)},useLayoutEffect:function(){},useCallback:function(a,b){return Ja(function(){return a},b)},useImperativeHandle:Ka,useEffect:Ka,useDebugValue:Ka,useDeferredValue:function(a){W();return a},useTransition:function(){W();
	return [function(a){a();},!1]},useOpaqueIdentifier:function(){return (X.identifierPrefix||"")+"R:"+(X.uniqueID++).toString(36)},useMutableSource:function(a,b){W();return b(a._source)}},Ma={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};function Na(a){switch(a){case "svg":return "http://www.w3.org/2000/svg";case "math":return "http://www.w3.org/1998/Math/MathML";default:return "http://www.w3.org/1999/xhtml"}}
	var Oa={area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0},Pa=l({menuitem:!0},Oa),Y={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,
	gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},Qa=["Webkit","ms","Moz","O"];Object.keys(Y).forEach(function(a){Qa.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);Y[b]=Y[a];});});
	var Ra=/([A-Z])/g,Sa=/^ms-/,Z=n.Children.toArray,Ta=ma.ReactCurrentDispatcher,Ua={listing:!0,pre:!0,textarea:!0},Va=/^[a-zA-Z][a-zA-Z:_\.\-\d]*$/,Wa={},Xa={};function Ya(a){if(void 0===a||null===a)return a;var b="";n.Children.forEach(a,function(a){null!=a&&(b+=a);});return b}var Za=Object.prototype.hasOwnProperty,$a={children:null,dangerouslySetInnerHTML:null,suppressContentEditableWarning:null,suppressHydrationWarning:null};function ab(a,b){if(void 0===a)throw Error(p(152,F(b)||"Component"));}
	function bb(a,b,c){function d(d,h){var e=h.prototype&&h.prototype.isReactComponent,f=oa(h,b,c,e),t=[],g=!1,m={isMounted:function(){return !1},enqueueForceUpdate:function(){if(null===t)return null},enqueueReplaceState:function(a,b){g=!0;t=[b];},enqueueSetState:function(a,b){if(null===t)return null;t.push(b);}};if(e){if(e=new h(d.props,f,m),"function"===typeof h.getDerivedStateFromProps){var k=h.getDerivedStateFromProps.call(null,d.props,e.state);null!=k&&(e.state=l({},e.state,k));}}else if(P={},e=h(d.props,
	f,m),e=Ea(h,d.props,e,f),null==e||null==e.render){a=e;ab(a,h);return}e.props=d.props;e.context=f;e.updater=m;m=e.state;void 0===m&&(e.state=m=null);if("function"===typeof e.UNSAFE_componentWillMount||"function"===typeof e.componentWillMount)if("function"===typeof e.componentWillMount&&"function"!==typeof h.getDerivedStateFromProps&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&"function"!==typeof h.getDerivedStateFromProps&&e.UNSAFE_componentWillMount(),t.length){m=t;var v=
	g;t=null;g=!1;if(v&&1===m.length)e.state=m[0];else {k=v?m[0]:e.state;var H=!0;for(v=v?1:0;v<m.length;v++){var x=m[v];x="function"===typeof x?x.call(e,k,d.props,f):x;null!=x&&(H?(H=!1,k=l({},k,x)):l(k,x));}e.state=k;}}else t=null;a=e.render();ab(a,h);if("function"===typeof e.getChildContext&&(d=h.childContextTypes,"object"===typeof d)){var y=e.getChildContext();for(var A in y)if(!(A in d))throw Error(p(108,F(h)||"Unknown",A));}y&&(b=l({},b,y));}for(;n.isValidElement(a);){var f=a,h=f.type;if("function"!==
	typeof h)break;d(f,h);}return {child:a,context:b}}
	var cb=function(){function a(a,b,f){n.isValidElement(a)?a.type!==r?a=[a]:(a=a.props.children,a=n.isValidElement(a)?[a]:Z(a)):a=Z(a);a={type:null,domNamespace:Ma.html,children:a,childIndex:0,context:na,footer:""};var c=J[0];if(0===c){var d=J;c=d.length;var g=2*c;if(!(65536>=g))throw Error(p(304));var e=new Uint16Array(g);e.set(d);J=e;J[0]=c+1;for(d=c;d<g-1;d++)J[d]=d+1;J[g-1]=0;}else J[0]=J[c];this.threadID=c;this.stack=[a];this.exhausted=!1;this.currentSelectValue=null;this.previousWasTextNode=!1;
	this.makeStaticMarkup=b;this.suspenseDepth=0;this.contextIndex=-1;this.contextStack=[];this.contextValueStack=[];this.uniqueID=0;this.identifierPrefix=f&&f.identifierPrefix||"";}var b=a.prototype;b.destroy=function(){if(!this.exhausted){this.exhausted=!0;this.clearProviders();var a=this.threadID;J[a]=J[0];J[0]=a;}};b.pushProvider=function(a){var b=++this.contextIndex,c=a.type._context,h=this.threadID;I(c,h);var t=c[h];this.contextStack[b]=c;this.contextValueStack[b]=t;c[h]=a.props.value;};b.popProvider=
	function(){var a=this.contextIndex,b=this.contextStack[a],f=this.contextValueStack[a];this.contextStack[a]=null;this.contextValueStack[a]=null;this.contextIndex--;b[this.threadID]=f;};b.clearProviders=function(){for(var a=this.contextIndex;0<=a;a--)this.contextStack[a][this.threadID]=this.contextValueStack[a];};b.read=function(a){if(this.exhausted)return null;var b=X;X=this;var c=Ta.current;Ta.current=La;try{for(var h=[""],t=!1;h[0].length<a;){if(0===this.stack.length){this.exhausted=!0;var g=this.threadID;
	J[g]=J[0];J[0]=g;break}var e=this.stack[this.stack.length-1];if(t||e.childIndex>=e.children.length){var L=e.footer;""!==L&&(this.previousWasTextNode=!1);this.stack.pop();if("select"===e.type)this.currentSelectValue=null;else if(null!=e.type&&null!=e.type.type&&e.type.type.$$typeof===B)this.popProvider(e.type);else if(e.type===D){this.suspenseDepth--;var G=h.pop();if(t){t=!1;var C=e.fallbackFrame;if(!C)throw Error(p(303));this.stack.push(C);h[this.suspenseDepth]+="\x3c!--$!--\x3e";continue}else h[this.suspenseDepth]+=
	G;}h[this.suspenseDepth]+=L;}else {var m=e.children[e.childIndex++],k="";try{k+=this.render(m,e.context,e.domNamespace);}catch(v){if(null!=v&&"function"===typeof v.then)throw Error(p(294));throw v;}finally{}h.length<=this.suspenseDepth&&h.push("");h[this.suspenseDepth]+=k;}}return h[0]}finally{Ta.current=c,X=b,Fa();}};b.render=function(a,b,f){if("string"===typeof a||"number"===typeof a){f=""+a;if(""===f)return "";if(this.makeStaticMarkup)return O(f);if(this.previousWasTextNode)return "\x3c!-- --\x3e"+O(f);
	this.previousWasTextNode=!0;return O(f)}b=bb(a,b,this.threadID);a=b.child;b=b.context;if(null===a||!1===a)return "";if(!n.isValidElement(a)){if(null!=a&&null!=a.$$typeof){f=a.$$typeof;if(f===q)throw Error(p(257));throw Error(p(258,f.toString()));}a=Z(a);this.stack.push({type:null,domNamespace:f,children:a,childIndex:0,context:b,footer:""});return ""}var c=a.type;if("string"===typeof c)return this.renderDOM(a,b,f);switch(c){case la:case ka:case u:case z:case da:case r:return a=Z(a.props.children),this.stack.push({type:null,
	domNamespace:f,children:a,childIndex:0,context:b,footer:""}),"";case D:throw Error(p(294));case ja:throw Error(p(343));}if("object"===typeof c&&null!==c)switch(c.$$typeof){case ca:P={};var d=c.render(a.props,a.ref);d=Ea(c.render,a.props,d,a.ref);d=Z(d);this.stack.push({type:null,domNamespace:f,children:d,childIndex:0,context:b,footer:""});return "";case ea:return a=[n.createElement(c.type,l({ref:a.ref},a.props))],this.stack.push({type:null,domNamespace:f,children:a,childIndex:0,context:b,footer:""}),
	"";case B:return c=Z(a.props.children),f={type:a,domNamespace:f,children:c,childIndex:0,context:b,footer:""},this.pushProvider(a),this.stack.push(f),"";case ba:c=a.type;d=a.props;var g=this.threadID;I(c,g);c=Z(d.children(c[g]));this.stack.push({type:a,domNamespace:f,children:c,childIndex:0,context:b,footer:""});return "";case ia:throw Error(p(338));case fa:return c=a.type,d=c._init,c=d(c._payload),a=[n.createElement(c,l({ref:a.ref},a.props))],this.stack.push({type:null,domNamespace:f,children:a,childIndex:0,
	context:b,footer:""}),""}throw Error(p(130,null==c?c:typeof c,""));};b.renderDOM=function(a,b,f){var c=a.type.toLowerCase();if(!Wa.hasOwnProperty(c)){if(!Va.test(c))throw Error(p(65,c));Wa[c]=!0;}var d=a.props;if("input"===c)d=l({type:void 0},d,{defaultChecked:void 0,defaultValue:void 0,value:null!=d.value?d.value:d.defaultValue,checked:null!=d.checked?d.checked:d.defaultChecked});else if("textarea"===c){var g=d.value;if(null==g){g=d.defaultValue;var e=d.children;if(null!=e){if(null!=
	g)throw Error(p(92));if(Array.isArray(e)){if(!(1>=e.length))throw Error(p(93));e=e[0];}g=""+e;}null==g&&(g="");}d=l({},d,{value:void 0,children:""+g});}else if("select"===c)this.currentSelectValue=null!=d.value?d.value:d.defaultValue,d=l({},d,{value:void 0});else if("option"===c){e=this.currentSelectValue;var L=Ya(d.children);if(null!=e){var G=null!=d.value?d.value+"":L;g=!1;if(Array.isArray(e))for(var C=0;C<e.length;C++){if(""+e[C]===G){g=!0;break}}else g=""+e===G;d=l({selected:void 0,children:void 0},
	d,{selected:g,children:L});}}if(g=d){if(Pa[c]&&(null!=g.children||null!=g.dangerouslySetInnerHTML))throw Error(p(137,c));if(null!=g.dangerouslySetInnerHTML){if(null!=g.children)throw Error(p(60));if(!("object"===typeof g.dangerouslySetInnerHTML&&"__html"in g.dangerouslySetInnerHTML))throw Error(p(61));}if(null!=g.style&&"object"!==typeof g.style)throw Error(p(62));}g=d;e=this.makeStaticMarkup;L=1===this.stack.length;G="<"+a.type;b:if(-1===c.indexOf("-"))C="string"===typeof g.is;else switch(c){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":C=
	!1;break b;default:C=!0;}for(w in g)if(Za.call(g,w)){var m=g[w];if(null!=m){if("style"===w){var k=void 0,v="",H="";for(k in m)if(m.hasOwnProperty(k)){var x=0===k.indexOf("--"),y=m[k];if(null!=y){if(x)var A=k;else if(A=k,Xa.hasOwnProperty(A))A=Xa[A];else {var eb=A.replace(Ra,"-$1").toLowerCase().replace(Sa,"-ms-");A=Xa[A]=eb;}v+=H+A+":";H=k;x=null==y||"boolean"===typeof y||""===y?"":x||"number"!==typeof y||0===y||Y.hasOwnProperty(H)&&Y[H]?(""+y).trim():y+"px";v+=x;H=";";}}m=v||null;}k=null;C?$a.hasOwnProperty(w)||
	(k=w,k=ta(k)&&null!=m?k+'="'+(O(m)+'"'):""):k=za(w,m);k&&(G+=" "+k);}}e||L&&(G+=' data-reactroot=""');var w=G;g="";Oa.hasOwnProperty(c)?w+="/>":(w+=">",g="</"+a.type+">");a:{e=d.dangerouslySetInnerHTML;if(null!=e){if(null!=e.__html){e=e.__html;break a}}else if(e=d.children,"string"===typeof e||"number"===typeof e){e=O(e);break a}e=null;}null!=e?(d=[],Ua.hasOwnProperty(c)&&"\n"===e.charAt(0)&&(w+="\n"),w+=e):d=Z(d.children);a=a.type;f=null==f||"http://www.w3.org/1999/xhtml"===f?Na(a):"http://www.w3.org/2000/svg"===
	f&&"foreignObject"===a?"http://www.w3.org/1999/xhtml":f;this.stack.push({domNamespace:f,type:c,children:d,childIndex:0,context:b,footer:g});this.previousWasTextNode=!1;return w};return a}();function db(a,b){a.prototype=Object.create(b.prototype);a.prototype.constructor=a;a.__proto__=b;}
	var fb=function(a){function b(b,c,h){var d=a.call(this,{})||this;d.partialRenderer=new cb(b,c,h);return d}db(b,a);var c=b.prototype;c._destroy=function(a,b){this.partialRenderer.destroy();b(a);};c._read=function(a){try{this.push(this.partialRenderer.read(a));}catch(f){this.destroy(f);}};return b}(aa.Readable);reactDomServer_node_production_min.renderToNodeStream=function(a,b){return new fb(a,!1,b)};reactDomServer_node_production_min.renderToStaticMarkup=function(a,b){a=new cb(a,!0,b);try{return a.read(Infinity)}finally{a.destroy();}};
	reactDomServer_node_production_min.renderToStaticNodeStream=function(a,b){return new fb(a,!0,b)};reactDomServer_node_production_min.renderToString=function(a,b){a=new cb(a,!1,b);try{return a.read(Infinity)}finally{a.destroy();}};reactDomServer_node_production_min.version="17.0.1";
	return reactDomServer_node_production_min;
}

var reactDomServer_node_development = {};

/** @license React v17.0.1
 * react-dom-server.node.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactDomServer_node_development;

function requireReactDomServer_node_development () {
	if (hasRequiredReactDomServer_node_development) return reactDomServer_node_development;
	hasRequiredReactDomServer_node_development = 1;

	if (process.env.NODE_ENV !== "production") {
	  (function() {

	var React = React__default;
	var _assign = objectAssign;
	var stream = require$$2;

	// TODO: this is special because it gets imported during build.
	var ReactVersion = '17.0.1';

	// Do not require this module directly! Use normal `invariant` calls with
	// template literal strings. The messages will be replaced with error codes
	// during build.
	function formatProdErrorMessage(code) {
	  var url = 'https://reactjs.org/docs/error-decoder.html?invariant=' + code;

	  for (var i = 1; i < arguments.length; i++) {
	    url += '&args[]=' + encodeURIComponent(arguments[i]);
	  }

	  return "Minified React error #" + code + "; visit " + url + " for the full message or " + 'use the non-minified dev environment for full errors and additional ' + 'helpful warnings.';
	}

	var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;

	// by calls to these methods by a Babel plugin.
	//
	// In PROD (or in packages without access to React internals),
	// they are left as they are instead.

	function warn(format) {
	  {
	    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }

	    printWarning('warn', format, args);
	  }
	}
	function error(format) {
	  {
	    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	      args[_key2 - 1] = arguments[_key2];
	    }

	    printWarning('error', format, args);
	  }
	}

	function printWarning(level, format, args) {
	  // When changing this logic, you might want to also
	  // update consoleWithStackDev.www.js as well.
	  {
	    var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
	    var stack = ReactDebugCurrentFrame.getStackAddendum();

	    if (stack !== '') {
	      format += '%s';
	      args = args.concat([stack]);
	    }

	    var argsWithFormat = args.map(function (item) {
	      return '' + item;
	    }); // Careful: RN currently depends on this prefix

	    argsWithFormat.unshift('Warning: ' + format); // We intentionally don't use spread (or .apply) directly because it
	    // breaks IE9: https://github.com/facebook/react/issues/13610
	    // eslint-disable-next-line react-internal/no-production-logging

	    Function.prototype.apply.call(console[level], console, argsWithFormat);
	  }
	}
	var REACT_PORTAL_TYPE = 0xeaca;
	var REACT_FRAGMENT_TYPE = 0xeacb;
	var REACT_STRICT_MODE_TYPE = 0xeacc;
	var REACT_PROFILER_TYPE = 0xead2;
	var REACT_PROVIDER_TYPE = 0xeacd;
	var REACT_CONTEXT_TYPE = 0xeace;
	var REACT_FORWARD_REF_TYPE = 0xead0;
	var REACT_SUSPENSE_TYPE = 0xead1;
	var REACT_SUSPENSE_LIST_TYPE = 0xead8;
	var REACT_MEMO_TYPE = 0xead3;
	var REACT_LAZY_TYPE = 0xead4;
	var REACT_BLOCK_TYPE = 0xead9;
	var REACT_FUNDAMENTAL_TYPE = 0xead5;
	var REACT_SCOPE_TYPE = 0xead7;
	var REACT_DEBUG_TRACING_MODE_TYPE = 0xeae1;
	var REACT_LEGACY_HIDDEN_TYPE = 0xeae3;

	if (typeof Symbol === 'function' && Symbol.for) {
	  var symbolFor = Symbol.for;
	  symbolFor('react.element');
	  REACT_PORTAL_TYPE = symbolFor('react.portal');
	  REACT_FRAGMENT_TYPE = symbolFor('react.fragment');
	  REACT_STRICT_MODE_TYPE = symbolFor('react.strict_mode');
	  REACT_PROFILER_TYPE = symbolFor('react.profiler');
	  REACT_PROVIDER_TYPE = symbolFor('react.provider');
	  REACT_CONTEXT_TYPE = symbolFor('react.context');
	  REACT_FORWARD_REF_TYPE = symbolFor('react.forward_ref');
	  REACT_SUSPENSE_TYPE = symbolFor('react.suspense');
	  REACT_SUSPENSE_LIST_TYPE = symbolFor('react.suspense_list');
	  REACT_MEMO_TYPE = symbolFor('react.memo');
	  REACT_LAZY_TYPE = symbolFor('react.lazy');
	  REACT_BLOCK_TYPE = symbolFor('react.block');
	  symbolFor('react.server.block');
	  REACT_FUNDAMENTAL_TYPE = symbolFor('react.fundamental');
	  REACT_SCOPE_TYPE = symbolFor('react.scope');
	  symbolFor('react.opaque.id');
	  REACT_DEBUG_TRACING_MODE_TYPE = symbolFor('react.debug_trace_mode');
	  symbolFor('react.offscreen');
	  REACT_LEGACY_HIDDEN_TYPE = symbolFor('react.legacy_hidden');
	}

	function getWrappedName(outerType, innerType, wrapperName) {
	  var functionName = innerType.displayName || innerType.name || '';
	  return outerType.displayName || (functionName !== '' ? wrapperName + "(" + functionName + ")" : wrapperName);
	}

	function getContextName(type) {
	  return type.displayName || 'Context';
	}

	function getComponentName(type) {
	  if (type == null) {
	    // Host root, text node or just invalid type.
	    return null;
	  }

	  {
	    if (typeof type.tag === 'number') {
	      error('Received an unexpected object in getComponentName(). ' + 'This is likely a bug in React. Please file an issue.');
	    }
	  }

	  if (typeof type === 'function') {
	    return type.displayName || type.name || null;
	  }

	  if (typeof type === 'string') {
	    return type;
	  }

	  switch (type) {
	    case REACT_FRAGMENT_TYPE:
	      return 'Fragment';

	    case REACT_PORTAL_TYPE:
	      return 'Portal';

	    case REACT_PROFILER_TYPE:
	      return 'Profiler';

	    case REACT_STRICT_MODE_TYPE:
	      return 'StrictMode';

	    case REACT_SUSPENSE_TYPE:
	      return 'Suspense';

	    case REACT_SUSPENSE_LIST_TYPE:
	      return 'SuspenseList';
	  }

	  if (typeof type === 'object') {
	    switch (type.$$typeof) {
	      case REACT_CONTEXT_TYPE:
	        var context = type;
	        return getContextName(context) + '.Consumer';

	      case REACT_PROVIDER_TYPE:
	        var provider = type;
	        return getContextName(provider._context) + '.Provider';

	      case REACT_FORWARD_REF_TYPE:
	        return getWrappedName(type, type.render, 'ForwardRef');

	      case REACT_MEMO_TYPE:
	        return getComponentName(type.type);

	      case REACT_BLOCK_TYPE:
	        return getComponentName(type._render);

	      case REACT_LAZY_TYPE:
	        {
	          var lazyComponent = type;
	          var payload = lazyComponent._payload;
	          var init = lazyComponent._init;

	          try {
	            return getComponentName(init(payload));
	          } catch (x) {
	            return null;
	          }
	        }
	    }
	  }

	  return null;
	}

	// Filter certain DOM attributes (e.g. src, href) if their values are empty strings.

	var enableSuspenseServerRenderer = false;

	// Helpers to patch console.logs to avoid logging during side-effect free
	// replaying on render function. This currently only patches the object
	// lazily which won't cover if the log function was extracted eagerly.
	// We could also eagerly patch the method.
	var disabledDepth = 0;
	var prevLog;
	var prevInfo;
	var prevWarn;
	var prevError;
	var prevGroup;
	var prevGroupCollapsed;
	var prevGroupEnd;

	function disabledLog() {}

	disabledLog.__reactDisabledLog = true;
	function disableLogs() {
	  {
	    if (disabledDepth === 0) {
	      /* eslint-disable react-internal/no-production-logging */
	      prevLog = console.log;
	      prevInfo = console.info;
	      prevWarn = console.warn;
	      prevError = console.error;
	      prevGroup = console.group;
	      prevGroupCollapsed = console.groupCollapsed;
	      prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099

	      var props = {
	        configurable: true,
	        enumerable: true,
	        value: disabledLog,
	        writable: true
	      }; // $FlowFixMe Flow thinks console is immutable.

	      Object.defineProperties(console, {
	        info: props,
	        log: props,
	        warn: props,
	        error: props,
	        group: props,
	        groupCollapsed: props,
	        groupEnd: props
	      });
	      /* eslint-enable react-internal/no-production-logging */
	    }

	    disabledDepth++;
	  }
	}
	function reenableLogs() {
	  {
	    disabledDepth--;

	    if (disabledDepth === 0) {
	      /* eslint-disable react-internal/no-production-logging */
	      var props = {
	        configurable: true,
	        enumerable: true,
	        writable: true
	      }; // $FlowFixMe Flow thinks console is immutable.

	      Object.defineProperties(console, {
	        log: _assign({}, props, {
	          value: prevLog
	        }),
	        info: _assign({}, props, {
	          value: prevInfo
	        }),
	        warn: _assign({}, props, {
	          value: prevWarn
	        }),
	        error: _assign({}, props, {
	          value: prevError
	        }),
	        group: _assign({}, props, {
	          value: prevGroup
	        }),
	        groupCollapsed: _assign({}, props, {
	          value: prevGroupCollapsed
	        }),
	        groupEnd: _assign({}, props, {
	          value: prevGroupEnd
	        })
	      });
	      /* eslint-enable react-internal/no-production-logging */
	    }

	    if (disabledDepth < 0) {
	      error('disabledDepth fell below zero. ' + 'This is a bug in React. Please file an issue.');
	    }
	  }
	}

	var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
	var prefix;
	function describeBuiltInComponentFrame(name, source, ownerFn) {
	  {
	    if (prefix === undefined) {
	      // Extract the VM specific prefix used by each line.
	      try {
	        throw Error();
	      } catch (x) {
	        var match = x.stack.trim().match(/\n( *(at )?)/);
	        prefix = match && match[1] || '';
	      }
	    } // We use the prefix to ensure our stacks line up with native stack frames.


	    return '\n' + prefix + name;
	  }
	}
	var reentry = false;
	var componentFrameCache;

	{
	  var PossiblyWeakMap = typeof WeakMap === 'function' ? WeakMap : Map;
	  componentFrameCache = new PossiblyWeakMap();
	}

	function describeNativeComponentFrame(fn, construct) {
	  // If something asked for a stack inside a fake render, it should get ignored.
	  if (!fn || reentry) {
	    return '';
	  }

	  {
	    var frame = componentFrameCache.get(fn);

	    if (frame !== undefined) {
	      return frame;
	    }
	  }

	  var control;
	  reentry = true;
	  var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.

	  Error.prepareStackTrace = undefined;
	  var previousDispatcher;

	  {
	    previousDispatcher = ReactCurrentDispatcher.current; // Set the dispatcher in DEV because this might be call in the render function
	    // for warnings.

	    ReactCurrentDispatcher.current = null;
	    disableLogs();
	  }

	  try {
	    // This should throw.
	    if (construct) {
	      // Something should be setting the props in the constructor.
	      var Fake = function () {
	        throw Error();
	      }; // $FlowFixMe


	      Object.defineProperty(Fake.prototype, 'props', {
	        set: function () {
	          // We use a throwing setter instead of frozen or non-writable props
	          // because that won't throw in a non-strict mode function.
	          throw Error();
	        }
	      });

	      if (typeof Reflect === 'object' && Reflect.construct) {
	        // We construct a different control for this case to include any extra
	        // frames added by the construct call.
	        try {
	          Reflect.construct(Fake, []);
	        } catch (x) {
	          control = x;
	        }

	        Reflect.construct(fn, [], Fake);
	      } else {
	        try {
	          Fake.call();
	        } catch (x) {
	          control = x;
	        }

	        fn.call(Fake.prototype);
	      }
	    } else {
	      try {
	        throw Error();
	      } catch (x) {
	        control = x;
	      }

	      fn();
	    }
	  } catch (sample) {
	    // This is inlined manually because closure doesn't do it for us.
	    if (sample && control && typeof sample.stack === 'string') {
	      // This extracts the first frame from the sample that isn't also in the control.
	      // Skipping one frame that we assume is the frame that calls the two.
	      var sampleLines = sample.stack.split('\n');
	      var controlLines = control.stack.split('\n');
	      var s = sampleLines.length - 1;
	      var c = controlLines.length - 1;

	      while (s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c]) {
	        // We expect at least one stack frame to be shared.
	        // Typically this will be the root most one. However, stack frames may be
	        // cut off due to maximum stack limits. In this case, one maybe cut off
	        // earlier than the other. We assume that the sample is longer or the same
	        // and there for cut off earlier. So we should find the root most frame in
	        // the sample somewhere in the control.
	        c--;
	      }

	      for (; s >= 1 && c >= 0; s--, c--) {
	        // Next we find the first one that isn't the same which should be the
	        // frame that called our sample function and the control.
	        if (sampleLines[s] !== controlLines[c]) {
	          // In V8, the first line is describing the message but other VMs don't.
	          // If we're about to return the first line, and the control is also on the same
	          // line, that's a pretty good indicator that our sample threw at same line as
	          // the control. I.e. before we entered the sample frame. So we ignore this result.
	          // This can happen if you passed a class to function component, or non-function.
	          if (s !== 1 || c !== 1) {
	            do {
	              s--;
	              c--; // We may still have similar intermediate frames from the construct call.
	              // The next one that isn't the same should be our match though.

	              if (c < 0 || sampleLines[s] !== controlLines[c]) {
	                // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
	                var _frame = '\n' + sampleLines[s].replace(' at new ', ' at ');

	                {
	                  if (typeof fn === 'function') {
	                    componentFrameCache.set(fn, _frame);
	                  }
	                } // Return the line we found.


	                return _frame;
	              }
	            } while (s >= 1 && c >= 0);
	          }

	          break;
	        }
	      }
	    }
	  } finally {
	    reentry = false;

	    {
	      ReactCurrentDispatcher.current = previousDispatcher;
	      reenableLogs();
	    }

	    Error.prepareStackTrace = previousPrepareStackTrace;
	  } // Fallback to just using the name if we couldn't make it throw.


	  var name = fn ? fn.displayName || fn.name : '';
	  var syntheticFrame = name ? describeBuiltInComponentFrame(name) : '';

	  {
	    if (typeof fn === 'function') {
	      componentFrameCache.set(fn, syntheticFrame);
	    }
	  }

	  return syntheticFrame;
	}
	function describeFunctionComponentFrame(fn, source, ownerFn) {
	  {
	    return describeNativeComponentFrame(fn, false);
	  }
	}

	function shouldConstruct(Component) {
	  var prototype = Component.prototype;
	  return !!(prototype && prototype.isReactComponent);
	}

	function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {

	  if (type == null) {
	    return '';
	  }

	  if (typeof type === 'function') {
	    {
	      return describeNativeComponentFrame(type, shouldConstruct(type));
	    }
	  }

	  if (typeof type === 'string') {
	    return describeBuiltInComponentFrame(type);
	  }

	  switch (type) {
	    case REACT_SUSPENSE_TYPE:
	      return describeBuiltInComponentFrame('Suspense');

	    case REACT_SUSPENSE_LIST_TYPE:
	      return describeBuiltInComponentFrame('SuspenseList');
	  }

	  if (typeof type === 'object') {
	    switch (type.$$typeof) {
	      case REACT_FORWARD_REF_TYPE:
	        return describeFunctionComponentFrame(type.render);

	      case REACT_MEMO_TYPE:
	        // Memo may contain any component type so we recursively resolve it.
	        return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);

	      case REACT_BLOCK_TYPE:
	        return describeFunctionComponentFrame(type._render);

	      case REACT_LAZY_TYPE:
	        {
	          var lazyComponent = type;
	          var payload = lazyComponent._payload;
	          var init = lazyComponent._init;

	          try {
	            // Lazy may contain any component type so we recursively resolve it.
	            return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
	          } catch (x) {}
	        }
	    }
	  }

	  return '';
	}

	var loggedTypeFailures = {};
	var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;

	function setCurrentlyValidatingElement(element) {
	  {
	    if (element) {
	      var owner = element._owner;
	      var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
	      ReactDebugCurrentFrame.setExtraStackFrame(stack);
	    } else {
	      ReactDebugCurrentFrame.setExtraStackFrame(null);
	    }
	  }
	}

	function checkPropTypes(typeSpecs, values, location, componentName, element) {
	  {
	    // $FlowFixMe This is okay but Flow doesn't know it.
	    var has = Function.call.bind(Object.prototype.hasOwnProperty);

	    for (var typeSpecName in typeSpecs) {
	      if (has(typeSpecs, typeSpecName)) {
	        var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.

	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          if (typeof typeSpecs[typeSpecName] !== 'function') {
	            var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
	            err.name = 'Invariant Violation';
	            throw err;
	          }

	          error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
	        } catch (ex) {
	          error$1 = ex;
	        }

	        if (error$1 && !(error$1 instanceof Error)) {
	          setCurrentlyValidatingElement(element);

	          error('%s: type specification of %s' + ' `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error$1);

	          setCurrentlyValidatingElement(null);
	        }

	        if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error$1.message] = true;
	          setCurrentlyValidatingElement(element);

	          error('Failed %s type: %s', location, error$1.message);

	          setCurrentlyValidatingElement(null);
	        }
	      }
	    }
	  }
	}

	var didWarnAboutInvalidateContextType;

	{
	  didWarnAboutInvalidateContextType = new Set();
	}

	var emptyObject = {};

	{
	  Object.freeze(emptyObject);
	}

	function maskContext(type, context) {
	  var contextTypes = type.contextTypes;

	  if (!contextTypes) {
	    return emptyObject;
	  }

	  var maskedContext = {};

	  for (var contextName in contextTypes) {
	    maskedContext[contextName] = context[contextName];
	  }

	  return maskedContext;
	}

	function checkContextTypes(typeSpecs, values, location) {
	  {
	    checkPropTypes(typeSpecs, values, location, 'Component');
	  }
	}

	function validateContextBounds(context, threadID) {
	  // If we don't have enough slots in this context to store this threadID,
	  // fill it in without leaving any holes to ensure that the VM optimizes
	  // this as non-holey index properties.
	  // (Note: If `react` package is < 16.6, _threadCount is undefined.)
	  for (var i = context._threadCount | 0; i <= threadID; i++) {
	    // We assume that this is the same as the defaultValue which might not be
	    // true if we're rendering inside a secondary renderer but they are
	    // secondary because these use cases are very rare.
	    context[i] = context._currentValue2;
	    context._threadCount = i + 1;
	  }
	}
	function processContext(type, context, threadID, isClass) {
	  if (isClass) {
	    var contextType = type.contextType;

	    {
	      if ('contextType' in type) {
	        var isValid = // Allow null for conditional declaration
	        contextType === null || contextType !== undefined && contextType.$$typeof === REACT_CONTEXT_TYPE && contextType._context === undefined; // Not a <Context.Consumer>

	        if (!isValid && !didWarnAboutInvalidateContextType.has(type)) {
	          didWarnAboutInvalidateContextType.add(type);
	          var addendum = '';

	          if (contextType === undefined) {
	            addendum = ' However, it is set to undefined. ' + 'This can be caused by a typo or by mixing up named and default imports. ' + 'This can also happen due to a circular dependency, so ' + 'try moving the createContext() call to a separate file.';
	          } else if (typeof contextType !== 'object') {
	            addendum = ' However, it is set to a ' + typeof contextType + '.';
	          } else if (contextType.$$typeof === REACT_PROVIDER_TYPE) {
	            addendum = ' Did you accidentally pass the Context.Provider instead?';
	          } else if (contextType._context !== undefined) {
	            // <Context.Consumer>
	            addendum = ' Did you accidentally pass the Context.Consumer instead?';
	          } else {
	            addendum = ' However, it is set to an object with keys {' + Object.keys(contextType).join(', ') + '}.';
	          }

	          error('%s defines an invalid contextType. ' + 'contextType should point to the Context object returned by React.createContext().%s', getComponentName(type) || 'Component', addendum);
	        }
	      }
	    }

	    if (typeof contextType === 'object' && contextType !== null) {
	      validateContextBounds(contextType, threadID);
	      return contextType[threadID];
	    }

	    {
	      var maskedContext = maskContext(type, context);

	      {
	        if (type.contextTypes) {
	          checkContextTypes(type.contextTypes, maskedContext, 'context');
	        }
	      }

	      return maskedContext;
	    }
	  } else {
	    {
	      var _maskedContext = maskContext(type, context);

	      {
	        if (type.contextTypes) {
	          checkContextTypes(type.contextTypes, _maskedContext, 'context');
	        }
	      }

	      return _maskedContext;
	    }
	  }
	}

	var nextAvailableThreadIDs = new Uint16Array(16);

	for (var i = 0; i < 15; i++) {
	  nextAvailableThreadIDs[i] = i + 1;
	}

	nextAvailableThreadIDs[15] = 0;

	function growThreadCountAndReturnNextAvailable() {
	  var oldArray = nextAvailableThreadIDs;
	  var oldSize = oldArray.length;
	  var newSize = oldSize * 2;

	  if (!(newSize <= 0x10000)) {
	    {
	      throw Error( "Maximum number of concurrent React renderers exceeded. This can happen if you are not properly destroying the Readable provided by React. Ensure that you call .destroy() on it if you no longer want to read from it, and did not read to the end. If you use .pipe() this should be automatic." );
	    }
	  }

	  var newArray = new Uint16Array(newSize);
	  newArray.set(oldArray);
	  nextAvailableThreadIDs = newArray;
	  nextAvailableThreadIDs[0] = oldSize + 1;

	  for (var _i = oldSize; _i < newSize - 1; _i++) {
	    nextAvailableThreadIDs[_i] = _i + 1;
	  }

	  nextAvailableThreadIDs[newSize - 1] = 0;
	  return oldSize;
	}

	function allocThreadID() {
	  var nextID = nextAvailableThreadIDs[0];

	  if (nextID === 0) {
	    return growThreadCountAndReturnNextAvailable();
	  }

	  nextAvailableThreadIDs[0] = nextAvailableThreadIDs[nextID];
	  return nextID;
	}
	function freeThreadID(id) {
	  nextAvailableThreadIDs[id] = nextAvailableThreadIDs[0];
	  nextAvailableThreadIDs[0] = id;
	}

	// A reserved attribute.
	// It is handled by React separately and shouldn't be written to the DOM.
	var RESERVED = 0; // A simple string attribute.
	// Attributes that aren't in the filter are presumed to have this type.

	var STRING = 1; // A string attribute that accepts booleans in React. In HTML, these are called
	// "enumerated" attributes with "true" and "false" as possible values.
	// When true, it should be set to a "true" string.
	// When false, it should be set to a "false" string.

	var BOOLEANISH_STRING = 2; // A real boolean attribute.
	// When true, it should be present (set either to an empty string or its name).
	// When false, it should be omitted.

	var BOOLEAN = 3; // An attribute that can be used as a flag as well as with a value.
	// When true, it should be present (set either to an empty string or its name).
	// When false, it should be omitted.
	// For any other value, should be present with that value.

	var OVERLOADED_BOOLEAN = 4; // An attribute that must be numeric or parse as a numeric.
	// When falsy, it should be removed.

	var NUMERIC = 5; // An attribute that must be positive numeric or parse as a positive numeric.
	// When falsy, it should be removed.

	var POSITIVE_NUMERIC = 6;

	/* eslint-disable max-len */
	var ATTRIBUTE_NAME_START_CHAR = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD";
	/* eslint-enable max-len */

	var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040";
	var ROOT_ATTRIBUTE_NAME = 'data-reactroot';
	var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + ATTRIBUTE_NAME_START_CHAR + '][' + ATTRIBUTE_NAME_CHAR + ']*$');
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	function isAttributeNameSafe(attributeName) {
	  if (hasOwnProperty.call(validatedAttributeNameCache, attributeName)) {
	    return true;
	  }

	  if (hasOwnProperty.call(illegalAttributeNameCache, attributeName)) {
	    return false;
	  }

	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }

	  illegalAttributeNameCache[attributeName] = true;

	  {
	    error('Invalid attribute name: `%s`', attributeName);
	  }

	  return false;
	}
	function shouldIgnoreAttribute(name, propertyInfo, isCustomComponentTag) {
	  if (propertyInfo !== null) {
	    return propertyInfo.type === RESERVED;
	  }

	  if (isCustomComponentTag) {
	    return false;
	  }

	  if (name.length > 2 && (name[0] === 'o' || name[0] === 'O') && (name[1] === 'n' || name[1] === 'N')) {
	    return true;
	  }

	  return false;
	}
	function shouldRemoveAttributeWithWarning(name, value, propertyInfo, isCustomComponentTag) {
	  if (propertyInfo !== null && propertyInfo.type === RESERVED) {
	    return false;
	  }

	  switch (typeof value) {
	    case 'function': // $FlowIssue symbol is perfectly valid here

	    case 'symbol':
	      // eslint-disable-line
	      return true;

	    case 'boolean':
	      {
	        if (isCustomComponentTag) {
	          return false;
	        }

	        if (propertyInfo !== null) {
	          return !propertyInfo.acceptsBooleans;
	        } else {
	          var prefix = name.toLowerCase().slice(0, 5);
	          return prefix !== 'data-' && prefix !== 'aria-';
	        }
	      }

	    default:
	      return false;
	  }
	}
	function shouldRemoveAttribute(name, value, propertyInfo, isCustomComponentTag) {
	  if (value === null || typeof value === 'undefined') {
	    return true;
	  }

	  if (shouldRemoveAttributeWithWarning(name, value, propertyInfo, isCustomComponentTag)) {
	    return true;
	  }

	  if (isCustomComponentTag) {
	    return false;
	  }

	  if (propertyInfo !== null) {

	    switch (propertyInfo.type) {
	      case BOOLEAN:
	        return !value;

	      case OVERLOADED_BOOLEAN:
	        return value === false;

	      case NUMERIC:
	        return isNaN(value);

	      case POSITIVE_NUMERIC:
	        return isNaN(value) || value < 1;
	    }
	  }

	  return false;
	}
	function getPropertyInfo(name) {
	  return properties.hasOwnProperty(name) ? properties[name] : null;
	}

	function PropertyInfoRecord(name, type, mustUseProperty, attributeName, attributeNamespace, sanitizeURL, removeEmptyString) {
	  this.acceptsBooleans = type === BOOLEANISH_STRING || type === BOOLEAN || type === OVERLOADED_BOOLEAN;
	  this.attributeName = attributeName;
	  this.attributeNamespace = attributeNamespace;
	  this.mustUseProperty = mustUseProperty;
	  this.propertyName = name;
	  this.type = type;
	  this.sanitizeURL = sanitizeURL;
	  this.removeEmptyString = removeEmptyString;
	} // When adding attributes to this list, be sure to also add them to
	// the `possibleStandardNames` module to ensure casing and incorrect
	// name warnings.


	var properties = {}; // These props are reserved by React. They shouldn't be written to the DOM.

	var reservedProps = ['children', 'dangerouslySetInnerHTML', // TODO: This prevents the assignment of defaultValue to regular
	// elements (not just inputs). Now that ReactDOMInput assigns to the
	// defaultValue property -- do we need this?
	'defaultValue', 'defaultChecked', 'innerHTML', 'suppressContentEditableWarning', 'suppressHydrationWarning', 'style'];
	reservedProps.forEach(function (name) {
	  properties[name] = new PropertyInfoRecord(name, RESERVED, false, // mustUseProperty
	  name, // attributeName
	  null, // attributeNamespace
	  false, // sanitizeURL
	  false);
	}); // A few React string attributes have a different name.
	// This is a mapping from React prop names to the attribute names.

	[['acceptCharset', 'accept-charset'], ['className', 'class'], ['htmlFor', 'for'], ['httpEquiv', 'http-equiv']].forEach(function (_ref) {
	  var name = _ref[0],
	      attributeName = _ref[1];
	  properties[name] = new PropertyInfoRecord(name, STRING, false, // mustUseProperty
	  attributeName, // attributeName
	  null, // attributeNamespace
	  false, // sanitizeURL
	  false);
	}); // These are "enumerated" HTML attributes that accept "true" and "false".
	// In React, we let users pass `true` and `false` even though technically
	// these aren't boolean attributes (they are coerced to strings).

	['contentEditable', 'draggable', 'spellCheck', 'value'].forEach(function (name) {
	  properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, // mustUseProperty
	  name.toLowerCase(), // attributeName
	  null, // attributeNamespace
	  false, // sanitizeURL
	  false);
	}); // These are "enumerated" SVG attributes that accept "true" and "false".
	// In React, we let users pass `true` and `false` even though technically
	// these aren't boolean attributes (they are coerced to strings).
	// Since these are SVG attributes, their attribute names are case-sensitive.

	['autoReverse', 'externalResourcesRequired', 'focusable', 'preserveAlpha'].forEach(function (name) {
	  properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, // mustUseProperty
	  name, // attributeName
	  null, // attributeNamespace
	  false, // sanitizeURL
	  false);
	}); // These are HTML boolean attributes.

	['allowFullScreen', 'async', // Note: there is a special case that prevents it from being written to the DOM
	// on the client side because the browsers are inconsistent. Instead we call focus().
	'autoFocus', 'autoPlay', 'controls', 'default', 'defer', 'disabled', 'disablePictureInPicture', 'disableRemotePlayback', 'formNoValidate', 'hidden', 'loop', 'noModule', 'noValidate', 'open', 'playsInline', 'readOnly', 'required', 'reversed', 'scoped', 'seamless', // Microdata
	'itemScope'].forEach(function (name) {
	  properties[name] = new PropertyInfoRecord(name, BOOLEAN, false, // mustUseProperty
	  name.toLowerCase(), // attributeName
	  null, // attributeNamespace
	  false, // sanitizeURL
	  false);
	}); // These are the few React props that we set as DOM properties
	// rather than attributes. These are all booleans.

	['checked', // Note: `option.selected` is not updated if `select.multiple` is
	// disabled with `removeAttribute`. We have special logic for handling this.
	'multiple', 'muted', 'selected' // NOTE: if you add a camelCased prop to this list,
	// you'll need to set attributeName to name.toLowerCase()
	// instead in the assignment below.
	].forEach(function (name) {
	  properties[name] = new PropertyInfoRecord(name, BOOLEAN, true, // mustUseProperty
	  name, // attributeName
	  null, // attributeNamespace
	  false, // sanitizeURL
	  false);
	}); // These are HTML attributes that are "overloaded booleans": they behave like
	// booleans, but can also accept a string value.

	['capture', 'download' // NOTE: if you add a camelCased prop to this list,
	// you'll need to set attributeName to name.toLowerCase()
	// instead in the assignment below.
	].forEach(function (name) {
	  properties[name] = new PropertyInfoRecord(name, OVERLOADED_BOOLEAN, false, // mustUseProperty
	  name, // attributeName
	  null, // attributeNamespace
	  false, // sanitizeURL
	  false);
	}); // These are HTML attributes that must be positive numbers.

	['cols', 'rows', 'size', 'span' // NOTE: if you add a camelCased prop to this list,
	// you'll need to set attributeName to name.toLowerCase()
	// instead in the assignment below.
	].forEach(function (name) {
	  properties[name] = new PropertyInfoRecord(name, POSITIVE_NUMERIC, false, // mustUseProperty
	  name, // attributeName
	  null, // attributeNamespace
	  false, // sanitizeURL
	  false);
	}); // These are HTML attributes that must be numbers.

	['rowSpan', 'start'].forEach(function (name) {
	  properties[name] = new PropertyInfoRecord(name, NUMERIC, false, // mustUseProperty
	  name.toLowerCase(), // attributeName
	  null, // attributeNamespace
	  false, // sanitizeURL
	  false);
	});
	var CAMELIZE = /[\-\:]([a-z])/g;

	var capitalize = function (token) {
	  return token[1].toUpperCase();
	}; // This is a list of all SVG attributes that need special casing, namespacing,
	// or boolean value assignment. Regular attributes that just accept strings
	// and have the same names are omitted, just like in the HTML attribute filter.
	// Some of these attributes can be hard to find. This list was created by
	// scraping the MDN documentation.


	['accent-height', 'alignment-baseline', 'arabic-form', 'baseline-shift', 'cap-height', 'clip-path', 'clip-rule', 'color-interpolation', 'color-interpolation-filters', 'color-profile', 'color-rendering', 'dominant-baseline', 'enable-background', 'fill-opacity', 'fill-rule', 'flood-color', 'flood-opacity', 'font-family', 'font-size', 'font-size-adjust', 'font-stretch', 'font-style', 'font-variant', 'font-weight', 'glyph-name', 'glyph-orientation-horizontal', 'glyph-orientation-vertical', 'horiz-adv-x', 'horiz-origin-x', 'image-rendering', 'letter-spacing', 'lighting-color', 'marker-end', 'marker-mid', 'marker-start', 'overline-position', 'overline-thickness', 'paint-order', 'panose-1', 'pointer-events', 'rendering-intent', 'shape-rendering', 'stop-color', 'stop-opacity', 'strikethrough-position', 'strikethrough-thickness', 'stroke-dasharray', 'stroke-dashoffset', 'stroke-linecap', 'stroke-linejoin', 'stroke-miterlimit', 'stroke-opacity', 'stroke-width', 'text-anchor', 'text-decoration', 'text-rendering', 'underline-position', 'underline-thickness', 'unicode-bidi', 'unicode-range', 'units-per-em', 'v-alphabetic', 'v-hanging', 'v-ideographic', 'v-mathematical', 'vector-effect', 'vert-adv-y', 'vert-origin-x', 'vert-origin-y', 'word-spacing', 'writing-mode', 'xmlns:xlink', 'x-height' // NOTE: if you add a camelCased prop to this list,
	// you'll need to set attributeName to name.toLowerCase()
	// instead in the assignment below.
	].forEach(function (attributeName) {
	  var name = attributeName.replace(CAMELIZE, capitalize);
	  properties[name] = new PropertyInfoRecord(name, STRING, false, // mustUseProperty
	  attributeName, null, // attributeNamespace
	  false, // sanitizeURL
	  false);
	}); // String SVG attributes with the xlink namespace.

	['xlink:actuate', 'xlink:arcrole', 'xlink:role', 'xlink:show', 'xlink:title', 'xlink:type' // NOTE: if you add a camelCased prop to this list,
	// you'll need to set attributeName to name.toLowerCase()
	// instead in the assignment below.
	].forEach(function (attributeName) {
	  var name = attributeName.replace(CAMELIZE, capitalize);
	  properties[name] = new PropertyInfoRecord(name, STRING, false, // mustUseProperty
	  attributeName, 'http://www.w3.org/1999/xlink', false, // sanitizeURL
	  false);
	}); // String SVG attributes with the xml namespace.

	['xml:base', 'xml:lang', 'xml:space' // NOTE: if you add a camelCased prop to this list,
	// you'll need to set attributeName to name.toLowerCase()
	// instead in the assignment below.
	].forEach(function (attributeName) {
	  var name = attributeName.replace(CAMELIZE, capitalize);
	  properties[name] = new PropertyInfoRecord(name, STRING, false, // mustUseProperty
	  attributeName, 'http://www.w3.org/XML/1998/namespace', false, // sanitizeURL
	  false);
	}); // These attribute exists both in HTML and SVG.
	// The attribute name is case-sensitive in SVG so we can't just use
	// the React name like we do for attributes that exist only in HTML.

	['tabIndex', 'crossOrigin'].forEach(function (attributeName) {
	  properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false, // mustUseProperty
	  attributeName.toLowerCase(), // attributeName
	  null, // attributeNamespace
	  false, // sanitizeURL
	  false);
	}); // These attributes accept URLs. These must not allow javascript: URLS.
	// These will also need to accept Trusted Types object in the future.

	var xlinkHref = 'xlinkHref';
	properties[xlinkHref] = new PropertyInfoRecord('xlinkHref', STRING, false, // mustUseProperty
	'xlink:href', 'http://www.w3.org/1999/xlink', true, // sanitizeURL
	false);
	['src', 'href', 'action', 'formAction'].forEach(function (attributeName) {
	  properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false, // mustUseProperty
	  attributeName.toLowerCase(), // attributeName
	  null, // attributeNamespace
	  true, // sanitizeURL
	  true);
	});

	// and any newline or tab are filtered out as if they're not part of the URL.
	// https://url.spec.whatwg.org/#url-parsing
	// Tab or newline are defined as \r\n\t:
	// https://infra.spec.whatwg.org/#ascii-tab-or-newline
	// A C0 control is a code point in the range \u0000 NULL to \u001F
	// INFORMATION SEPARATOR ONE, inclusive:
	// https://infra.spec.whatwg.org/#c0-control-or-space

	/* eslint-disable max-len */

	var isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i;
	var didWarn = false;

	function sanitizeURL(url) {
	  {
	    if (!didWarn && isJavaScriptProtocol.test(url)) {
	      didWarn = true;

	      error('A future version of React will block javascript: URLs as a security precaution. ' + 'Use event handlers instead if you can. If you need to generate unsafe HTML try ' + 'using dangerouslySetInnerHTML instead. React was passed %s.', JSON.stringify(url));
	    }
	  }
	}

	// code copied and modified from escape-html

	/**
	 * Module variables.
	 * @private
	 */
	var matchHtmlRegExp = /["'&<>]/;
	/**
	 * Escapes special characters and HTML entities in a given html string.
	 *
	 * @param  {string} string HTML string to escape for later insertion
	 * @return {string}
	 * @public
	 */

	function escapeHtml(string) {
	  var str = '' + string;
	  var match = matchHtmlRegExp.exec(str);

	  if (!match) {
	    return str;
	  }

	  var escape;
	  var html = '';
	  var index;
	  var lastIndex = 0;

	  for (index = match.index; index < str.length; index++) {
	    switch (str.charCodeAt(index)) {
	      case 34:
	        // "
	        escape = '&quot;';
	        break;

	      case 38:
	        // &
	        escape = '&amp;';
	        break;

	      case 39:
	        // '
	        escape = '&#x27;'; // modified from escape-html; used to be '&#39'

	        break;

	      case 60:
	        // <
	        escape = '&lt;';
	        break;

	      case 62:
	        // >
	        escape = '&gt;';
	        break;

	      default:
	        continue;
	    }

	    if (lastIndex !== index) {
	      html += str.substring(lastIndex, index);
	    }

	    lastIndex = index + 1;
	    html += escape;
	  }

	  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
	} // end code copied and modified from escape-html

	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */


	function escapeTextForBrowser(text) {
	  if (typeof text === 'boolean' || typeof text === 'number') {
	    // this shortcircuit helps perf for types that we know will never have
	    // special characters, especially given that this function is used often
	    // for numeric dom ids.
	    return '' + text;
	  }

	  return escapeHtml(text);
	}

	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */

	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextForBrowser(value) + '"';
	}

	function createMarkupForRoot() {
	  return ROOT_ATTRIBUTE_NAME + '=""';
	}
	/**
	 * Creates markup for a property.
	 *
	 * @param {string} name
	 * @param {*} value
	 * @return {?string} Markup string, or null if the property was invalid.
	 */

	function createMarkupForProperty(name, value) {
	  var propertyInfo = getPropertyInfo(name);

	  if (name !== 'style' && shouldIgnoreAttribute(name, propertyInfo, false)) {
	    return '';
	  }

	  if (shouldRemoveAttribute(name, value, propertyInfo, false)) {
	    return '';
	  }

	  if (propertyInfo !== null) {
	    var attributeName = propertyInfo.attributeName;
	    var type = propertyInfo.type;

	    if (type === BOOLEAN || type === OVERLOADED_BOOLEAN && value === true) {
	      return attributeName + '=""';
	    } else {
	      if (propertyInfo.sanitizeURL) {
	        value = '' + value;
	        sanitizeURL(value);
	      }

	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    }
	  } else if (isAttributeNameSafe(name)) {
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  }

	  return '';
	}
	/**
	 * Creates markup for a custom property.
	 *
	 * @param {string} name
	 * @param {*} value
	 * @return {string} Markup string, or empty string if the property was invalid.
	 */

	function createMarkupForCustomAttribute(name, value) {
	  if (!isAttributeNameSafe(name) || value == null) {
	    return '';
	  }

	  return name + '=' + quoteAttributeValueForBrowser(value);
	}

	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  return x === y && (x !== 0 || 1 / x === 1 / y) || x !== x && y !== y // eslint-disable-line no-self-compare
	  ;
	}

	var objectIs = typeof Object.is === 'function' ? Object.is : is;

	var currentlyRenderingComponent = null;
	var firstWorkInProgressHook = null;
	var workInProgressHook = null; // Whether the work-in-progress hook is a re-rendered hook

	var isReRender = false; // Whether an update was scheduled during the currently executing render pass.

	var didScheduleRenderPhaseUpdate = false; // Lazily created map of render-phase updates

	var renderPhaseUpdates = null; // Counter to prevent infinite loops.

	var numberOfReRenders = 0;
	var RE_RENDER_LIMIT = 25;
	var isInHookUserCodeInDev = false; // In DEV, this is the name of the currently executing primitive hook

	var currentHookNameInDev;

	function resolveCurrentlyRenderingComponent() {
	  if (!(currentlyRenderingComponent !== null)) {
	    {
	      throw Error( "Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem." );
	    }
	  }

	  {
	    if (isInHookUserCodeInDev) {
	      error('Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. ' + 'You can only call Hooks at the top level of your React function. ' + 'For more information, see ' + 'https://reactjs.org/link/rules-of-hooks');
	    }
	  }

	  return currentlyRenderingComponent;
	}

	function areHookInputsEqual(nextDeps, prevDeps) {
	  if (prevDeps === null) {
	    {
	      error('%s received a final argument during this render, but not during ' + 'the previous render. Even though the final argument is optional, ' + 'its type cannot change between renders.', currentHookNameInDev);
	    }

	    return false;
	  }

	  {
	    // Don't bother comparing lengths in prod because these arrays should be
	    // passed inline.
	    if (nextDeps.length !== prevDeps.length) {
	      error('The final argument passed to %s changed size between renders. The ' + 'order and size of this array must remain constant.\n\n' + 'Previous: %s\n' + 'Incoming: %s', currentHookNameInDev, "[" + nextDeps.join(', ') + "]", "[" + prevDeps.join(', ') + "]");
	    }
	  }

	  for (var i = 0; i < prevDeps.length && i < nextDeps.length; i++) {
	    if (objectIs(nextDeps[i], prevDeps[i])) {
	      continue;
	    }

	    return false;
	  }

	  return true;
	}

	function createHook() {
	  if (numberOfReRenders > 0) {
	    {
	      {
	        throw Error( "Rendered more hooks than during the previous render" );
	      }
	    }
	  }

	  return {
	    memoizedState: null,
	    queue: null,
	    next: null
	  };
	}

	function createWorkInProgressHook() {
	  if (workInProgressHook === null) {
	    // This is the first hook in the list
	    if (firstWorkInProgressHook === null) {
	      isReRender = false;
	      firstWorkInProgressHook = workInProgressHook = createHook();
	    } else {
	      // There's already a work-in-progress. Reuse it.
	      isReRender = true;
	      workInProgressHook = firstWorkInProgressHook;
	    }
	  } else {
	    if (workInProgressHook.next === null) {
	      isReRender = false; // Append to the end of the list

	      workInProgressHook = workInProgressHook.next = createHook();
	    } else {
	      // There's already a work-in-progress. Reuse it.
	      isReRender = true;
	      workInProgressHook = workInProgressHook.next;
	    }
	  }

	  return workInProgressHook;
	}

	function prepareToUseHooks(componentIdentity) {
	  currentlyRenderingComponent = componentIdentity;

	  {
	    isInHookUserCodeInDev = false;
	  } // The following should have already been reset
	  // didScheduleRenderPhaseUpdate = false;
	  // firstWorkInProgressHook = null;
	  // numberOfReRenders = 0;
	  // renderPhaseUpdates = null;
	  // workInProgressHook = null;

	}
	function finishHooks(Component, props, children, refOrContext) {
	  // This must be called after every function component to prevent hooks from
	  // being used in classes.
	  while (didScheduleRenderPhaseUpdate) {
	    // Updates were scheduled during the render phase. They are stored in
	    // the `renderPhaseUpdates` map. Call the component again, reusing the
	    // work-in-progress hooks and applying the additional updates on top. Keep
	    // restarting until no more updates are scheduled.
	    didScheduleRenderPhaseUpdate = false;
	    numberOfReRenders += 1; // Start over from the beginning of the list

	    workInProgressHook = null;
	    children = Component(props, refOrContext);
	  }

	  resetHooksState();
	  return children;
	} // Reset the internal hooks state if an error occurs while rendering a component

	function resetHooksState() {
	  {
	    isInHookUserCodeInDev = false;
	  }

	  currentlyRenderingComponent = null;
	  didScheduleRenderPhaseUpdate = false;
	  firstWorkInProgressHook = null;
	  numberOfReRenders = 0;
	  renderPhaseUpdates = null;
	  workInProgressHook = null;
	}

	function readContext(context, observedBits) {
	  var threadID = currentPartialRenderer.threadID;
	  validateContextBounds(context, threadID);

	  {
	    if (isInHookUserCodeInDev) {
	      error('Context can only be read while React is rendering. ' + 'In classes, you can read it in the render method or getDerivedStateFromProps. ' + 'In function components, you can read it directly in the function body, but not ' + 'inside Hooks like useReducer() or useMemo().');
	    }
	  }

	  return context[threadID];
	}

	function useContext(context, observedBits) {
	  {
	    currentHookNameInDev = 'useContext';
	  }

	  resolveCurrentlyRenderingComponent();
	  var threadID = currentPartialRenderer.threadID;
	  validateContextBounds(context, threadID);
	  return context[threadID];
	}

	function basicStateReducer(state, action) {
	  // $FlowFixMe: Flow doesn't like mixed types
	  return typeof action === 'function' ? action(state) : action;
	}

	function useState(initialState) {
	  {
	    currentHookNameInDev = 'useState';
	  }

	  return useReducer(basicStateReducer, // useReducer has a special case to support lazy useState initializers
	  initialState);
	}
	function useReducer(reducer, initialArg, init) {
	  {
	    if (reducer !== basicStateReducer) {
	      currentHookNameInDev = 'useReducer';
	    }
	  }

	  currentlyRenderingComponent = resolveCurrentlyRenderingComponent();
	  workInProgressHook = createWorkInProgressHook();

	  if (isReRender) {
	    // This is a re-render. Apply the new render phase updates to the previous
	    // current hook.
	    var queue = workInProgressHook.queue;
	    var dispatch = queue.dispatch;

	    if (renderPhaseUpdates !== null) {
	      // Render phase updates are stored in a map of queue -> linked list
	      var firstRenderPhaseUpdate = renderPhaseUpdates.get(queue);

	      if (firstRenderPhaseUpdate !== undefined) {
	        renderPhaseUpdates.delete(queue);
	        var newState = workInProgressHook.memoizedState;
	        var update = firstRenderPhaseUpdate;

	        do {
	          // Process this render phase update. We don't have to check the
	          // priority because it will always be the same as the current
	          // render's.
	          var action = update.action;

	          {
	            isInHookUserCodeInDev = true;
	          }

	          newState = reducer(newState, action);

	          {
	            isInHookUserCodeInDev = false;
	          }

	          update = update.next;
	        } while (update !== null);

	        workInProgressHook.memoizedState = newState;
	        return [newState, dispatch];
	      }
	    }

	    return [workInProgressHook.memoizedState, dispatch];
	  } else {
	    {
	      isInHookUserCodeInDev = true;
	    }

	    var initialState;

	    if (reducer === basicStateReducer) {
	      // Special case for `useState`.
	      initialState = typeof initialArg === 'function' ? initialArg() : initialArg;
	    } else {
	      initialState = init !== undefined ? init(initialArg) : initialArg;
	    }

	    {
	      isInHookUserCodeInDev = false;
	    }

	    workInProgressHook.memoizedState = initialState;

	    var _queue = workInProgressHook.queue = {
	      last: null,
	      dispatch: null
	    };

	    var _dispatch = _queue.dispatch = dispatchAction.bind(null, currentlyRenderingComponent, _queue);

	    return [workInProgressHook.memoizedState, _dispatch];
	  }
	}

	function useMemo(nextCreate, deps) {
	  currentlyRenderingComponent = resolveCurrentlyRenderingComponent();
	  workInProgressHook = createWorkInProgressHook();
	  var nextDeps = deps === undefined ? null : deps;

	  if (workInProgressHook !== null) {
	    var prevState = workInProgressHook.memoizedState;

	    if (prevState !== null) {
	      if (nextDeps !== null) {
	        var prevDeps = prevState[1];

	        if (areHookInputsEqual(nextDeps, prevDeps)) {
	          return prevState[0];
	        }
	      }
	    }
	  }

	  {
	    isInHookUserCodeInDev = true;
	  }

	  var nextValue = nextCreate();

	  {
	    isInHookUserCodeInDev = false;
	  }

	  workInProgressHook.memoizedState = [nextValue, nextDeps];
	  return nextValue;
	}

	function useRef(initialValue) {
	  currentlyRenderingComponent = resolveCurrentlyRenderingComponent();
	  workInProgressHook = createWorkInProgressHook();
	  var previousRef = workInProgressHook.memoizedState;

	  if (previousRef === null) {
	    var ref = {
	      current: initialValue
	    };

	    {
	      Object.seal(ref);
	    }

	    workInProgressHook.memoizedState = ref;
	    return ref;
	  } else {
	    return previousRef;
	  }
	}

	function useLayoutEffect(create, inputs) {
	  {
	    currentHookNameInDev = 'useLayoutEffect';

	    error('useLayoutEffect does nothing on the server, because its effect cannot ' + "be encoded into the server renderer's output format. This will lead " + 'to a mismatch between the initial, non-hydrated UI and the intended ' + 'UI. To avoid this, useLayoutEffect should only be used in ' + 'components that render exclusively on the client. ' + 'See https://reactjs.org/link/uselayouteffect-ssr for common fixes.');
	  }
	}

	function dispatchAction(componentIdentity, queue, action) {
	  if (!(numberOfReRenders < RE_RENDER_LIMIT)) {
	    {
	      throw Error( "Too many re-renders. React limits the number of renders to prevent an infinite loop." );
	    }
	  }

	  if (componentIdentity === currentlyRenderingComponent) {
	    // This is a render phase update. Stash it in a lazily-created map of
	    // queue -> linked list of updates. After this render pass, we'll restart
	    // and apply the stashed updates on top of the work-in-progress hook.
	    didScheduleRenderPhaseUpdate = true;
	    var update = {
	      action: action,
	      next: null
	    };

	    if (renderPhaseUpdates === null) {
	      renderPhaseUpdates = new Map();
	    }

	    var firstRenderPhaseUpdate = renderPhaseUpdates.get(queue);

	    if (firstRenderPhaseUpdate === undefined) {
	      renderPhaseUpdates.set(queue, update);
	    } else {
	      // Append the update to the end of the list.
	      var lastRenderPhaseUpdate = firstRenderPhaseUpdate;

	      while (lastRenderPhaseUpdate.next !== null) {
	        lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
	      }

	      lastRenderPhaseUpdate.next = update;
	    }
	  }
	}

	function useCallback(callback, deps) {
	  return useMemo(function () {
	    return callback;
	  }, deps);
	} // TODO Decide on how to implement this hook for server rendering.
	// If a mutation occurs during render, consider triggering a Suspense boundary
	// and falling back to client rendering.

	function useMutableSource(source, getSnapshot, subscribe) {
	  resolveCurrentlyRenderingComponent();
	  return getSnapshot(source._source);
	}

	function useDeferredValue(value) {
	  resolveCurrentlyRenderingComponent();
	  return value;
	}

	function useTransition() {
	  resolveCurrentlyRenderingComponent();

	  var startTransition = function (callback) {
	    callback();
	  };

	  return [startTransition, false];
	}

	function useOpaqueIdentifier() {
	  return (currentPartialRenderer.identifierPrefix || '') + 'R:' + (currentPartialRenderer.uniqueID++).toString(36);
	}

	function noop() {}

	var currentPartialRenderer = null;
	function setCurrentPartialRenderer(renderer) {
	  currentPartialRenderer = renderer;
	}
	var Dispatcher = {
	  readContext: readContext,
	  useContext: useContext,
	  useMemo: useMemo,
	  useReducer: useReducer,
	  useRef: useRef,
	  useState: useState,
	  useLayoutEffect: useLayoutEffect,
	  useCallback: useCallback,
	  // useImperativeHandle is not run in the server environment
	  useImperativeHandle: noop,
	  // Effects are not run in the server environment.
	  useEffect: noop,
	  // Debugging effect
	  useDebugValue: noop,
	  useDeferredValue: useDeferredValue,
	  useTransition: useTransition,
	  useOpaqueIdentifier: useOpaqueIdentifier,
	  // Subscriptions are not setup in a server environment.
	  useMutableSource: useMutableSource
	};

	var HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
	var MATH_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
	var SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
	var Namespaces = {
	  html: HTML_NAMESPACE,
	  mathml: MATH_NAMESPACE,
	  svg: SVG_NAMESPACE
	}; // Assumes there is no parent namespace.

	function getIntrinsicNamespace(type) {
	  switch (type) {
	    case 'svg':
	      return SVG_NAMESPACE;

	    case 'math':
	      return MATH_NAMESPACE;

	    default:
	      return HTML_NAMESPACE;
	  }
	}
	function getChildNamespace(parentNamespace, type) {
	  if (parentNamespace == null || parentNamespace === HTML_NAMESPACE) {
	    // No (or default) parent namespace: potential entry point.
	    return getIntrinsicNamespace(type);
	  }

	  if (parentNamespace === SVG_NAMESPACE && type === 'foreignObject') {
	    // We're leaving SVG.
	    return HTML_NAMESPACE;
	  } // By default, pass namespace below.


	  return parentNamespace;
	}

	var hasReadOnlyValue = {
	  button: true,
	  checkbox: true,
	  image: true,
	  hidden: true,
	  radio: true,
	  reset: true,
	  submit: true
	};
	function checkControlledValueProps(tagName, props) {
	  {
	    if (!(hasReadOnlyValue[props.type] || props.onChange || props.onInput || props.readOnly || props.disabled || props.value == null)) {
	      error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	    }

	    if (!(props.onChange || props.readOnly || props.disabled || props.checked == null)) {
	      error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	    }
	  }
	}

	// For HTML, certain tags should omit their close tag. We keep a list for
	// those special-case tags.
	var omittedCloseTags = {
	  area: true,
	  base: true,
	  br: true,
	  col: true,
	  embed: true,
	  hr: true,
	  img: true,
	  input: true,
	  keygen: true,
	  link: true,
	  meta: true,
	  param: true,
	  source: true,
	  track: true,
	  wbr: true // NOTE: menuitem's close tag should be omitted, but that causes problems.

	};

	// `omittedCloseTags` except that `menuitem` should still have its closing tag.

	var voidElementTags = _assign({
	  menuitem: true
	}, omittedCloseTags);

	var HTML = '__html';

	function assertValidProps(tag, props) {
	  if (!props) {
	    return;
	  } // Note the use of `==` which checks for null or undefined.


	  if (voidElementTags[tag]) {
	    if (!(props.children == null && props.dangerouslySetInnerHTML == null)) {
	      {
	        throw Error( tag + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`." );
	      }
	    }
	  }

	  if (props.dangerouslySetInnerHTML != null) {
	    if (!(props.children == null)) {
	      {
	        throw Error( "Can only set one of `children` or `props.dangerouslySetInnerHTML`." );
	      }
	    }

	    if (!(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML)) {
	      {
	        throw Error( "`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information." );
	      }
	    }
	  }

	  {
	    if (!props.suppressContentEditableWarning && props.contentEditable && props.children != null) {
	      error('A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.');
	    }
	  }

	  if (!(props.style == null || typeof props.style === 'object')) {
	    {
	      throw Error( "The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX." );
	    }
	  }
	}

	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  columns: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridArea: true,
	  gridRow: true,
	  gridRowEnd: true,
	  gridRowSpan: true,
	  gridRowStart: true,
	  gridColumn: true,
	  gridColumnEnd: true,
	  gridColumnSpan: true,
	  gridColumnStart: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */

	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */


	var prefixes = ['Webkit', 'ms', 'Moz', 'O']; // Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.

	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});

	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @return {string} Normalized style value with dimensions applied.
	 */

	function dangerousStyleValue(name, value, isCustomProperty) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';

	  if (isEmpty) {
	    return '';
	  }

	  if (!isCustomProperty && typeof value === 'number' && value !== 0 && !(isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name])) {
	    return value + 'px'; // Presumes implicit 'px' suffix for unitless numbers
	  }

	  return ('' + value).trim();
	}

	var uppercasePattern = /([A-Z])/g;
	var msPattern = /^ms-/;
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 */

	function hyphenateStyleName(name) {
	  return name.replace(uppercasePattern, '-$1').toLowerCase().replace(msPattern, '-ms-');
	}

	function isCustomComponent(tagName, props) {
	  if (tagName.indexOf('-') === -1) {
	    return typeof props.is === 'string';
	  }

	  switch (tagName) {
	    // These are reserved SVG and MathML elements.
	    // We don't mind this list too much because we expect it to never grow.
	    // The alternative is to track the namespace in a few places which is convoluted.
	    // https://w3c.github.io/webcomponents/spec/custom/#custom-elements-core-concepts
	    case 'annotation-xml':
	    case 'color-profile':
	    case 'font-face':
	    case 'font-face-src':
	    case 'font-face-uri':
	    case 'font-face-format':
	    case 'font-face-name':
	    case 'missing-glyph':
	      return false;

	    default:
	      return true;
	  }
	}

	var warnValidStyle = function () {};

	{
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	  var msPattern$1 = /^-ms-/;
	  var hyphenPattern = /-(.)/g; // style values shouldn't contain a semicolon

	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	  var warnedForInfinityValue = false;

	  var camelize = function (string) {
	    return string.replace(hyphenPattern, function (_, character) {
	      return character.toUpperCase();
	    });
	  };

	  var warnHyphenatedStyleName = function (name) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }

	    warnedStyleNames[name] = true;

	    error('Unsupported style property %s. Did you mean %s?', name, // As Andi Smith suggests
	    // (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	    // is converted to lowercase `ms`.
	    camelize(name.replace(msPattern$1, 'ms-')));
	  };

	  var warnBadVendoredStyleName = function (name) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }

	    warnedStyleNames[name] = true;

	    error('Unsupported vendor-prefixed style property %s. Did you mean %s?', name, name.charAt(0).toUpperCase() + name.slice(1));
	  };

	  var warnStyleValueWithSemicolon = function (name, value) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }

	    warnedStyleValues[value] = true;

	    error("Style property values shouldn't contain a semicolon. " + 'Try "%s: %s" instead.', name, value.replace(badStyleValueWithSemicolonPattern, ''));
	  };

	  var warnStyleValueIsNaN = function (name, value) {
	    if (warnedForNaNValue) {
	      return;
	    }

	    warnedForNaNValue = true;

	    error('`NaN` is an invalid value for the `%s` css style property.', name);
	  };

	  var warnStyleValueIsInfinity = function (name, value) {
	    if (warnedForInfinityValue) {
	      return;
	    }

	    warnedForInfinityValue = true;

	    error('`Infinity` is an invalid value for the `%s` css style property.', name);
	  };

	  warnValidStyle = function (name, value) {
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value);
	    }

	    if (typeof value === 'number') {
	      if (isNaN(value)) {
	        warnStyleValueIsNaN(name, value);
	      } else if (!isFinite(value)) {
	        warnStyleValueIsInfinity(name, value);
	      }
	    }
	  };
	}

	var warnValidStyle$1 = warnValidStyle;

	var ariaProperties = {
	  'aria-current': 0,
	  // state
	  'aria-details': 0,
	  'aria-disabled': 0,
	  // state
	  'aria-hidden': 0,
	  // state
	  'aria-invalid': 0,
	  // state
	  'aria-keyshortcuts': 0,
	  'aria-label': 0,
	  'aria-roledescription': 0,
	  // Widget Attributes
	  'aria-autocomplete': 0,
	  'aria-checked': 0,
	  'aria-expanded': 0,
	  'aria-haspopup': 0,
	  'aria-level': 0,
	  'aria-modal': 0,
	  'aria-multiline': 0,
	  'aria-multiselectable': 0,
	  'aria-orientation': 0,
	  'aria-placeholder': 0,
	  'aria-pressed': 0,
	  'aria-readonly': 0,
	  'aria-required': 0,
	  'aria-selected': 0,
	  'aria-sort': 0,
	  'aria-valuemax': 0,
	  'aria-valuemin': 0,
	  'aria-valuenow': 0,
	  'aria-valuetext': 0,
	  // Live Region Attributes
	  'aria-atomic': 0,
	  'aria-busy': 0,
	  'aria-live': 0,
	  'aria-relevant': 0,
	  // Drag-and-Drop Attributes
	  'aria-dropeffect': 0,
	  'aria-grabbed': 0,
	  // Relationship Attributes
	  'aria-activedescendant': 0,
	  'aria-colcount': 0,
	  'aria-colindex': 0,
	  'aria-colspan': 0,
	  'aria-controls': 0,
	  'aria-describedby': 0,
	  'aria-errormessage': 0,
	  'aria-flowto': 0,
	  'aria-labelledby': 0,
	  'aria-owns': 0,
	  'aria-posinset': 0,
	  'aria-rowcount': 0,
	  'aria-rowindex': 0,
	  'aria-rowspan': 0,
	  'aria-setsize': 0
	};

	var warnedProperties = {};
	var rARIA = new RegExp('^(aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$');
	var rARIACamel = new RegExp('^(aria)[A-Z][' + ATTRIBUTE_NAME_CHAR + ']*$');
	var hasOwnProperty$1 = Object.prototype.hasOwnProperty;

	function validateProperty(tagName, name) {
	  {
	    if (hasOwnProperty$1.call(warnedProperties, name) && warnedProperties[name]) {
	      return true;
	    }

	    if (rARIACamel.test(name)) {
	      var ariaName = 'aria-' + name.slice(4).toLowerCase();
	      var correctName = ariaProperties.hasOwnProperty(ariaName) ? ariaName : null; // If this is an aria-* attribute, but is not listed in the known DOM
	      // DOM properties, then it is an invalid aria-* attribute.

	      if (correctName == null) {
	        error('Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.', name);

	        warnedProperties[name] = true;
	        return true;
	      } // aria-* attributes should be lowercase; suggest the lowercase version.


	      if (name !== correctName) {
	        error('Invalid ARIA attribute `%s`. Did you mean `%s`?', name, correctName);

	        warnedProperties[name] = true;
	        return true;
	      }
	    }

	    if (rARIA.test(name)) {
	      var lowerCasedName = name.toLowerCase();
	      var standardName = ariaProperties.hasOwnProperty(lowerCasedName) ? lowerCasedName : null; // If this is an aria-* attribute, but is not listed in the known DOM
	      // DOM properties, then it is an invalid aria-* attribute.

	      if (standardName == null) {
	        warnedProperties[name] = true;
	        return false;
	      } // aria-* attributes should be lowercase; suggest the lowercase version.


	      if (name !== standardName) {
	        error('Unknown ARIA attribute `%s`. Did you mean `%s`?', name, standardName);

	        warnedProperties[name] = true;
	        return true;
	      }
	    }
	  }

	  return true;
	}

	function warnInvalidARIAProps(type, props) {
	  {
	    var invalidProps = [];

	    for (var key in props) {
	      var isValid = validateProperty(type, key);

	      if (!isValid) {
	        invalidProps.push(key);
	      }
	    }

	    var unknownPropString = invalidProps.map(function (prop) {
	      return '`' + prop + '`';
	    }).join(', ');

	    if (invalidProps.length === 1) {
	      error('Invalid aria prop %s on <%s> tag. ' + 'For details, see https://reactjs.org/link/invalid-aria-props', unknownPropString, type);
	    } else if (invalidProps.length > 1) {
	      error('Invalid aria props %s on <%s> tag. ' + 'For details, see https://reactjs.org/link/invalid-aria-props', unknownPropString, type);
	    }
	  }
	}

	function validateProperties(type, props) {
	  if (isCustomComponent(type, props)) {
	    return;
	  }

	  warnInvalidARIAProps(type, props);
	}

	var didWarnValueNull = false;
	function validateProperties$1(type, props) {
	  {
	    if (type !== 'input' && type !== 'textarea' && type !== 'select') {
	      return;
	    }

	    if (props != null && props.value === null && !didWarnValueNull) {
	      didWarnValueNull = true;

	      if (type === 'select' && props.multiple) {
	        error('`value` prop on `%s` should not be null. ' + 'Consider using an empty array when `multiple` is set to `true` ' + 'to clear the component or `undefined` for uncontrolled components.', type);
	      } else {
	        error('`value` prop on `%s` should not be null. ' + 'Consider using an empty string to clear the component or `undefined` ' + 'for uncontrolled components.', type);
	      }
	    }
	  }
	}

	// When adding attributes to the HTML or SVG allowed attribute list, be sure to
	// also add them to this module to ensure casing and incorrect name
	// warnings.
	var possibleStandardNames = {
	  // HTML
	  accept: 'accept',
	  acceptcharset: 'acceptCharset',
	  'accept-charset': 'acceptCharset',
	  accesskey: 'accessKey',
	  action: 'action',
	  allowfullscreen: 'allowFullScreen',
	  alt: 'alt',
	  as: 'as',
	  async: 'async',
	  autocapitalize: 'autoCapitalize',
	  autocomplete: 'autoComplete',
	  autocorrect: 'autoCorrect',
	  autofocus: 'autoFocus',
	  autoplay: 'autoPlay',
	  autosave: 'autoSave',
	  capture: 'capture',
	  cellpadding: 'cellPadding',
	  cellspacing: 'cellSpacing',
	  challenge: 'challenge',
	  charset: 'charSet',
	  checked: 'checked',
	  children: 'children',
	  cite: 'cite',
	  class: 'className',
	  classid: 'classID',
	  classname: 'className',
	  cols: 'cols',
	  colspan: 'colSpan',
	  content: 'content',
	  contenteditable: 'contentEditable',
	  contextmenu: 'contextMenu',
	  controls: 'controls',
	  controlslist: 'controlsList',
	  coords: 'coords',
	  crossorigin: 'crossOrigin',
	  dangerouslysetinnerhtml: 'dangerouslySetInnerHTML',
	  data: 'data',
	  datetime: 'dateTime',
	  default: 'default',
	  defaultchecked: 'defaultChecked',
	  defaultvalue: 'defaultValue',
	  defer: 'defer',
	  dir: 'dir',
	  disabled: 'disabled',
	  disablepictureinpicture: 'disablePictureInPicture',
	  disableremoteplayback: 'disableRemotePlayback',
	  download: 'download',
	  draggable: 'draggable',
	  enctype: 'encType',
	  enterkeyhint: 'enterKeyHint',
	  for: 'htmlFor',
	  form: 'form',
	  formmethod: 'formMethod',
	  formaction: 'formAction',
	  formenctype: 'formEncType',
	  formnovalidate: 'formNoValidate',
	  formtarget: 'formTarget',
	  frameborder: 'frameBorder',
	  headers: 'headers',
	  height: 'height',
	  hidden: 'hidden',
	  high: 'high',
	  href: 'href',
	  hreflang: 'hrefLang',
	  htmlfor: 'htmlFor',
	  httpequiv: 'httpEquiv',
	  'http-equiv': 'httpEquiv',
	  icon: 'icon',
	  id: 'id',
	  innerhtml: 'innerHTML',
	  inputmode: 'inputMode',
	  integrity: 'integrity',
	  is: 'is',
	  itemid: 'itemID',
	  itemprop: 'itemProp',
	  itemref: 'itemRef',
	  itemscope: 'itemScope',
	  itemtype: 'itemType',
	  keyparams: 'keyParams',
	  keytype: 'keyType',
	  kind: 'kind',
	  label: 'label',
	  lang: 'lang',
	  list: 'list',
	  loop: 'loop',
	  low: 'low',
	  manifest: 'manifest',
	  marginwidth: 'marginWidth',
	  marginheight: 'marginHeight',
	  max: 'max',
	  maxlength: 'maxLength',
	  media: 'media',
	  mediagroup: 'mediaGroup',
	  method: 'method',
	  min: 'min',
	  minlength: 'minLength',
	  multiple: 'multiple',
	  muted: 'muted',
	  name: 'name',
	  nomodule: 'noModule',
	  nonce: 'nonce',
	  novalidate: 'noValidate',
	  open: 'open',
	  optimum: 'optimum',
	  pattern: 'pattern',
	  placeholder: 'placeholder',
	  playsinline: 'playsInline',
	  poster: 'poster',
	  preload: 'preload',
	  profile: 'profile',
	  radiogroup: 'radioGroup',
	  readonly: 'readOnly',
	  referrerpolicy: 'referrerPolicy',
	  rel: 'rel',
	  required: 'required',
	  reversed: 'reversed',
	  role: 'role',
	  rows: 'rows',
	  rowspan: 'rowSpan',
	  sandbox: 'sandbox',
	  scope: 'scope',
	  scoped: 'scoped',
	  scrolling: 'scrolling',
	  seamless: 'seamless',
	  selected: 'selected',
	  shape: 'shape',
	  size: 'size',
	  sizes: 'sizes',
	  span: 'span',
	  spellcheck: 'spellCheck',
	  src: 'src',
	  srcdoc: 'srcDoc',
	  srclang: 'srcLang',
	  srcset: 'srcSet',
	  start: 'start',
	  step: 'step',
	  style: 'style',
	  summary: 'summary',
	  tabindex: 'tabIndex',
	  target: 'target',
	  title: 'title',
	  type: 'type',
	  usemap: 'useMap',
	  value: 'value',
	  width: 'width',
	  wmode: 'wmode',
	  wrap: 'wrap',
	  // SVG
	  about: 'about',
	  accentheight: 'accentHeight',
	  'accent-height': 'accentHeight',
	  accumulate: 'accumulate',
	  additive: 'additive',
	  alignmentbaseline: 'alignmentBaseline',
	  'alignment-baseline': 'alignmentBaseline',
	  allowreorder: 'allowReorder',
	  alphabetic: 'alphabetic',
	  amplitude: 'amplitude',
	  arabicform: 'arabicForm',
	  'arabic-form': 'arabicForm',
	  ascent: 'ascent',
	  attributename: 'attributeName',
	  attributetype: 'attributeType',
	  autoreverse: 'autoReverse',
	  azimuth: 'azimuth',
	  basefrequency: 'baseFrequency',
	  baselineshift: 'baselineShift',
	  'baseline-shift': 'baselineShift',
	  baseprofile: 'baseProfile',
	  bbox: 'bbox',
	  begin: 'begin',
	  bias: 'bias',
	  by: 'by',
	  calcmode: 'calcMode',
	  capheight: 'capHeight',
	  'cap-height': 'capHeight',
	  clip: 'clip',
	  clippath: 'clipPath',
	  'clip-path': 'clipPath',
	  clippathunits: 'clipPathUnits',
	  cliprule: 'clipRule',
	  'clip-rule': 'clipRule',
	  color: 'color',
	  colorinterpolation: 'colorInterpolation',
	  'color-interpolation': 'colorInterpolation',
	  colorinterpolationfilters: 'colorInterpolationFilters',
	  'color-interpolation-filters': 'colorInterpolationFilters',
	  colorprofile: 'colorProfile',
	  'color-profile': 'colorProfile',
	  colorrendering: 'colorRendering',
	  'color-rendering': 'colorRendering',
	  contentscripttype: 'contentScriptType',
	  contentstyletype: 'contentStyleType',
	  cursor: 'cursor',
	  cx: 'cx',
	  cy: 'cy',
	  d: 'd',
	  datatype: 'datatype',
	  decelerate: 'decelerate',
	  descent: 'descent',
	  diffuseconstant: 'diffuseConstant',
	  direction: 'direction',
	  display: 'display',
	  divisor: 'divisor',
	  dominantbaseline: 'dominantBaseline',
	  'dominant-baseline': 'dominantBaseline',
	  dur: 'dur',
	  dx: 'dx',
	  dy: 'dy',
	  edgemode: 'edgeMode',
	  elevation: 'elevation',
	  enablebackground: 'enableBackground',
	  'enable-background': 'enableBackground',
	  end: 'end',
	  exponent: 'exponent',
	  externalresourcesrequired: 'externalResourcesRequired',
	  fill: 'fill',
	  fillopacity: 'fillOpacity',
	  'fill-opacity': 'fillOpacity',
	  fillrule: 'fillRule',
	  'fill-rule': 'fillRule',
	  filter: 'filter',
	  filterres: 'filterRes',
	  filterunits: 'filterUnits',
	  floodopacity: 'floodOpacity',
	  'flood-opacity': 'floodOpacity',
	  floodcolor: 'floodColor',
	  'flood-color': 'floodColor',
	  focusable: 'focusable',
	  fontfamily: 'fontFamily',
	  'font-family': 'fontFamily',
	  fontsize: 'fontSize',
	  'font-size': 'fontSize',
	  fontsizeadjust: 'fontSizeAdjust',
	  'font-size-adjust': 'fontSizeAdjust',
	  fontstretch: 'fontStretch',
	  'font-stretch': 'fontStretch',
	  fontstyle: 'fontStyle',
	  'font-style': 'fontStyle',
	  fontvariant: 'fontVariant',
	  'font-variant': 'fontVariant',
	  fontweight: 'fontWeight',
	  'font-weight': 'fontWeight',
	  format: 'format',
	  from: 'from',
	  fx: 'fx',
	  fy: 'fy',
	  g1: 'g1',
	  g2: 'g2',
	  glyphname: 'glyphName',
	  'glyph-name': 'glyphName',
	  glyphorientationhorizontal: 'glyphOrientationHorizontal',
	  'glyph-orientation-horizontal': 'glyphOrientationHorizontal',
	  glyphorientationvertical: 'glyphOrientationVertical',
	  'glyph-orientation-vertical': 'glyphOrientationVertical',
	  glyphref: 'glyphRef',
	  gradienttransform: 'gradientTransform',
	  gradientunits: 'gradientUnits',
	  hanging: 'hanging',
	  horizadvx: 'horizAdvX',
	  'horiz-adv-x': 'horizAdvX',
	  horizoriginx: 'horizOriginX',
	  'horiz-origin-x': 'horizOriginX',
	  ideographic: 'ideographic',
	  imagerendering: 'imageRendering',
	  'image-rendering': 'imageRendering',
	  in2: 'in2',
	  in: 'in',
	  inlist: 'inlist',
	  intercept: 'intercept',
	  k1: 'k1',
	  k2: 'k2',
	  k3: 'k3',
	  k4: 'k4',
	  k: 'k',
	  kernelmatrix: 'kernelMatrix',
	  kernelunitlength: 'kernelUnitLength',
	  kerning: 'kerning',
	  keypoints: 'keyPoints',
	  keysplines: 'keySplines',
	  keytimes: 'keyTimes',
	  lengthadjust: 'lengthAdjust',
	  letterspacing: 'letterSpacing',
	  'letter-spacing': 'letterSpacing',
	  lightingcolor: 'lightingColor',
	  'lighting-color': 'lightingColor',
	  limitingconeangle: 'limitingConeAngle',
	  local: 'local',
	  markerend: 'markerEnd',
	  'marker-end': 'markerEnd',
	  markerheight: 'markerHeight',
	  markermid: 'markerMid',
	  'marker-mid': 'markerMid',
	  markerstart: 'markerStart',
	  'marker-start': 'markerStart',
	  markerunits: 'markerUnits',
	  markerwidth: 'markerWidth',
	  mask: 'mask',
	  maskcontentunits: 'maskContentUnits',
	  maskunits: 'maskUnits',
	  mathematical: 'mathematical',
	  mode: 'mode',
	  numoctaves: 'numOctaves',
	  offset: 'offset',
	  opacity: 'opacity',
	  operator: 'operator',
	  order: 'order',
	  orient: 'orient',
	  orientation: 'orientation',
	  origin: 'origin',
	  overflow: 'overflow',
	  overlineposition: 'overlinePosition',
	  'overline-position': 'overlinePosition',
	  overlinethickness: 'overlineThickness',
	  'overline-thickness': 'overlineThickness',
	  paintorder: 'paintOrder',
	  'paint-order': 'paintOrder',
	  panose1: 'panose1',
	  'panose-1': 'panose1',
	  pathlength: 'pathLength',
	  patterncontentunits: 'patternContentUnits',
	  patterntransform: 'patternTransform',
	  patternunits: 'patternUnits',
	  pointerevents: 'pointerEvents',
	  'pointer-events': 'pointerEvents',
	  points: 'points',
	  pointsatx: 'pointsAtX',
	  pointsaty: 'pointsAtY',
	  pointsatz: 'pointsAtZ',
	  prefix: 'prefix',
	  preservealpha: 'preserveAlpha',
	  preserveaspectratio: 'preserveAspectRatio',
	  primitiveunits: 'primitiveUnits',
	  property: 'property',
	  r: 'r',
	  radius: 'radius',
	  refx: 'refX',
	  refy: 'refY',
	  renderingintent: 'renderingIntent',
	  'rendering-intent': 'renderingIntent',
	  repeatcount: 'repeatCount',
	  repeatdur: 'repeatDur',
	  requiredextensions: 'requiredExtensions',
	  requiredfeatures: 'requiredFeatures',
	  resource: 'resource',
	  restart: 'restart',
	  result: 'result',
	  results: 'results',
	  rotate: 'rotate',
	  rx: 'rx',
	  ry: 'ry',
	  scale: 'scale',
	  security: 'security',
	  seed: 'seed',
	  shaperendering: 'shapeRendering',
	  'shape-rendering': 'shapeRendering',
	  slope: 'slope',
	  spacing: 'spacing',
	  specularconstant: 'specularConstant',
	  specularexponent: 'specularExponent',
	  speed: 'speed',
	  spreadmethod: 'spreadMethod',
	  startoffset: 'startOffset',
	  stddeviation: 'stdDeviation',
	  stemh: 'stemh',
	  stemv: 'stemv',
	  stitchtiles: 'stitchTiles',
	  stopcolor: 'stopColor',
	  'stop-color': 'stopColor',
	  stopopacity: 'stopOpacity',
	  'stop-opacity': 'stopOpacity',
	  strikethroughposition: 'strikethroughPosition',
	  'strikethrough-position': 'strikethroughPosition',
	  strikethroughthickness: 'strikethroughThickness',
	  'strikethrough-thickness': 'strikethroughThickness',
	  string: 'string',
	  stroke: 'stroke',
	  strokedasharray: 'strokeDasharray',
	  'stroke-dasharray': 'strokeDasharray',
	  strokedashoffset: 'strokeDashoffset',
	  'stroke-dashoffset': 'strokeDashoffset',
	  strokelinecap: 'strokeLinecap',
	  'stroke-linecap': 'strokeLinecap',
	  strokelinejoin: 'strokeLinejoin',
	  'stroke-linejoin': 'strokeLinejoin',
	  strokemiterlimit: 'strokeMiterlimit',
	  'stroke-miterlimit': 'strokeMiterlimit',
	  strokewidth: 'strokeWidth',
	  'stroke-width': 'strokeWidth',
	  strokeopacity: 'strokeOpacity',
	  'stroke-opacity': 'strokeOpacity',
	  suppresscontenteditablewarning: 'suppressContentEditableWarning',
	  suppresshydrationwarning: 'suppressHydrationWarning',
	  surfacescale: 'surfaceScale',
	  systemlanguage: 'systemLanguage',
	  tablevalues: 'tableValues',
	  targetx: 'targetX',
	  targety: 'targetY',
	  textanchor: 'textAnchor',
	  'text-anchor': 'textAnchor',
	  textdecoration: 'textDecoration',
	  'text-decoration': 'textDecoration',
	  textlength: 'textLength',
	  textrendering: 'textRendering',
	  'text-rendering': 'textRendering',
	  to: 'to',
	  transform: 'transform',
	  typeof: 'typeof',
	  u1: 'u1',
	  u2: 'u2',
	  underlineposition: 'underlinePosition',
	  'underline-position': 'underlinePosition',
	  underlinethickness: 'underlineThickness',
	  'underline-thickness': 'underlineThickness',
	  unicode: 'unicode',
	  unicodebidi: 'unicodeBidi',
	  'unicode-bidi': 'unicodeBidi',
	  unicoderange: 'unicodeRange',
	  'unicode-range': 'unicodeRange',
	  unitsperem: 'unitsPerEm',
	  'units-per-em': 'unitsPerEm',
	  unselectable: 'unselectable',
	  valphabetic: 'vAlphabetic',
	  'v-alphabetic': 'vAlphabetic',
	  values: 'values',
	  vectoreffect: 'vectorEffect',
	  'vector-effect': 'vectorEffect',
	  version: 'version',
	  vertadvy: 'vertAdvY',
	  'vert-adv-y': 'vertAdvY',
	  vertoriginx: 'vertOriginX',
	  'vert-origin-x': 'vertOriginX',
	  vertoriginy: 'vertOriginY',
	  'vert-origin-y': 'vertOriginY',
	  vhanging: 'vHanging',
	  'v-hanging': 'vHanging',
	  videographic: 'vIdeographic',
	  'v-ideographic': 'vIdeographic',
	  viewbox: 'viewBox',
	  viewtarget: 'viewTarget',
	  visibility: 'visibility',
	  vmathematical: 'vMathematical',
	  'v-mathematical': 'vMathematical',
	  vocab: 'vocab',
	  widths: 'widths',
	  wordspacing: 'wordSpacing',
	  'word-spacing': 'wordSpacing',
	  writingmode: 'writingMode',
	  'writing-mode': 'writingMode',
	  x1: 'x1',
	  x2: 'x2',
	  x: 'x',
	  xchannelselector: 'xChannelSelector',
	  xheight: 'xHeight',
	  'x-height': 'xHeight',
	  xlinkactuate: 'xlinkActuate',
	  'xlink:actuate': 'xlinkActuate',
	  xlinkarcrole: 'xlinkArcrole',
	  'xlink:arcrole': 'xlinkArcrole',
	  xlinkhref: 'xlinkHref',
	  'xlink:href': 'xlinkHref',
	  xlinkrole: 'xlinkRole',
	  'xlink:role': 'xlinkRole',
	  xlinkshow: 'xlinkShow',
	  'xlink:show': 'xlinkShow',
	  xlinktitle: 'xlinkTitle',
	  'xlink:title': 'xlinkTitle',
	  xlinktype: 'xlinkType',
	  'xlink:type': 'xlinkType',
	  xmlbase: 'xmlBase',
	  'xml:base': 'xmlBase',
	  xmllang: 'xmlLang',
	  'xml:lang': 'xmlLang',
	  xmlns: 'xmlns',
	  'xml:space': 'xmlSpace',
	  xmlnsxlink: 'xmlnsXlink',
	  'xmlns:xlink': 'xmlnsXlink',
	  xmlspace: 'xmlSpace',
	  y1: 'y1',
	  y2: 'y2',
	  y: 'y',
	  ychannelselector: 'yChannelSelector',
	  z: 'z',
	  zoomandpan: 'zoomAndPan'
	};

	var validateProperty$1 = function () {};

	{
	  var warnedProperties$1 = {};
	  var _hasOwnProperty = Object.prototype.hasOwnProperty;
	  var EVENT_NAME_REGEX = /^on./;
	  var INVALID_EVENT_NAME_REGEX = /^on[^A-Z]/;
	  var rARIA$1 = new RegExp('^(aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$');
	  var rARIACamel$1 = new RegExp('^(aria)[A-Z][' + ATTRIBUTE_NAME_CHAR + ']*$');

	  validateProperty$1 = function (tagName, name, value, eventRegistry) {
	    if (_hasOwnProperty.call(warnedProperties$1, name) && warnedProperties$1[name]) {
	      return true;
	    }

	    var lowerCasedName = name.toLowerCase();

	    if (lowerCasedName === 'onfocusin' || lowerCasedName === 'onfocusout') {
	      error('React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.');

	      warnedProperties$1[name] = true;
	      return true;
	    } // We can't rely on the event system being injected on the server.


	    if (eventRegistry != null) {
	      var registrationNameDependencies = eventRegistry.registrationNameDependencies,
	          possibleRegistrationNames = eventRegistry.possibleRegistrationNames;

	      if (registrationNameDependencies.hasOwnProperty(name)) {
	        return true;
	      }

	      var registrationName = possibleRegistrationNames.hasOwnProperty(lowerCasedName) ? possibleRegistrationNames[lowerCasedName] : null;

	      if (registrationName != null) {
	        error('Invalid event handler property `%s`. Did you mean `%s`?', name, registrationName);

	        warnedProperties$1[name] = true;
	        return true;
	      }

	      if (EVENT_NAME_REGEX.test(name)) {
	        error('Unknown event handler property `%s`. It will be ignored.', name);

	        warnedProperties$1[name] = true;
	        return true;
	      }
	    } else if (EVENT_NAME_REGEX.test(name)) {
	      // If no event plugins have been injected, we are in a server environment.
	      // So we can't tell if the event name is correct for sure, but we can filter
	      // out known bad ones like `onclick`. We can't suggest a specific replacement though.
	      if (INVALID_EVENT_NAME_REGEX.test(name)) {
	        error('Invalid event handler property `%s`. ' + 'React events use the camelCase naming convention, for example `onClick`.', name);
	      }

	      warnedProperties$1[name] = true;
	      return true;
	    } // Let the ARIA attribute hook validate ARIA attributes


	    if (rARIA$1.test(name) || rARIACamel$1.test(name)) {
	      return true;
	    }

	    if (lowerCasedName === 'innerhtml') {
	      error('Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.');

	      warnedProperties$1[name] = true;
	      return true;
	    }

	    if (lowerCasedName === 'aria') {
	      error('The `aria` attribute is reserved for future use in React. ' + 'Pass individual `aria-` attributes instead.');

	      warnedProperties$1[name] = true;
	      return true;
	    }

	    if (lowerCasedName === 'is' && value !== null && value !== undefined && typeof value !== 'string') {
	      error('Received a `%s` for a string attribute `is`. If this is expected, cast ' + 'the value to a string.', typeof value);

	      warnedProperties$1[name] = true;
	      return true;
	    }

	    if (typeof value === 'number' && isNaN(value)) {
	      error('Received NaN for the `%s` attribute. If this is expected, cast ' + 'the value to a string.', name);

	      warnedProperties$1[name] = true;
	      return true;
	    }

	    var propertyInfo = getPropertyInfo(name);
	    var isReserved = propertyInfo !== null && propertyInfo.type === RESERVED; // Known attributes should match the casing specified in the property config.

	    if (possibleStandardNames.hasOwnProperty(lowerCasedName)) {
	      var standardName = possibleStandardNames[lowerCasedName];

	      if (standardName !== name) {
	        error('Invalid DOM property `%s`. Did you mean `%s`?', name, standardName);

	        warnedProperties$1[name] = true;
	        return true;
	      }
	    } else if (!isReserved && name !== lowerCasedName) {
	      // Unknown attributes should have lowercase casing since that's how they
	      // will be cased anyway with server rendering.
	      error('React does not recognize the `%s` prop on a DOM element. If you ' + 'intentionally want it to appear in the DOM as a custom ' + 'attribute, spell it as lowercase `%s` instead. ' + 'If you accidentally passed it from a parent component, remove ' + 'it from the DOM element.', name, lowerCasedName);

	      warnedProperties$1[name] = true;
	      return true;
	    }

	    if (typeof value === 'boolean' && shouldRemoveAttributeWithWarning(name, value, propertyInfo, false)) {
	      if (value) {
	        error('Received `%s` for a non-boolean attribute `%s`.\n\n' + 'If you want to write it to the DOM, pass a string instead: ' + '%s="%s" or %s={value.toString()}.', value, name, name, value, name);
	      } else {
	        error('Received `%s` for a non-boolean attribute `%s`.\n\n' + 'If you want to write it to the DOM, pass a string instead: ' + '%s="%s" or %s={value.toString()}.\n\n' + 'If you used to conditionally omit it with %s={condition && value}, ' + 'pass %s={condition ? value : undefined} instead.', value, name, name, value, name, name, name);
	      }

	      warnedProperties$1[name] = true;
	      return true;
	    } // Now that we've validated casing, do not validate
	    // data types for reserved props


	    if (isReserved) {
	      return true;
	    } // Warn when a known attribute is a bad type


	    if (shouldRemoveAttributeWithWarning(name, value, propertyInfo, false)) {
	      warnedProperties$1[name] = true;
	      return false;
	    } // Warn when passing the strings 'false' or 'true' into a boolean prop


	    if ((value === 'false' || value === 'true') && propertyInfo !== null && propertyInfo.type === BOOLEAN) {
	      error('Received the string `%s` for the boolean attribute `%s`. ' + '%s ' + 'Did you mean %s={%s}?', value, name, value === 'false' ? 'The browser will interpret it as a truthy value.' : 'Although this works, it will not work as expected if you pass the string "false".', name, value);

	      warnedProperties$1[name] = true;
	      return true;
	    }

	    return true;
	  };
	}

	var warnUnknownProperties = function (type, props, eventRegistry) {
	  {
	    var unknownProps = [];

	    for (var key in props) {
	      var isValid = validateProperty$1(type, key, props[key], eventRegistry);

	      if (!isValid) {
	        unknownProps.push(key);
	      }
	    }

	    var unknownPropString = unknownProps.map(function (prop) {
	      return '`' + prop + '`';
	    }).join(', ');

	    if (unknownProps.length === 1) {
	      error('Invalid value for prop %s on <%s> tag. Either remove it from the element, ' + 'or pass a string or number value to keep it in the DOM. ' + 'For details, see https://reactjs.org/link/attribute-behavior ', unknownPropString, type);
	    } else if (unknownProps.length > 1) {
	      error('Invalid values for props %s on <%s> tag. Either remove them from the element, ' + 'or pass a string or number value to keep them in the DOM. ' + 'For details, see https://reactjs.org/link/attribute-behavior ', unknownPropString, type);
	    }
	  }
	};

	function validateProperties$2(type, props, eventRegistry) {
	  if (isCustomComponent(type, props)) {
	    return;
	  }

	  warnUnknownProperties(type, props, eventRegistry);
	}

	var toArray = React.Children.toArray; // This is only used in DEV.
	// Each entry is `this.stack` from a currently executing renderer instance.
	// (There may be more than one because ReactDOMServer is reentrant).
	// Each stack is an array of frames which may contain nested stacks of elements.

	var currentDebugStacks = [];
	var ReactCurrentDispatcher$1 = ReactSharedInternals.ReactCurrentDispatcher;
	var ReactDebugCurrentFrame$1;
	var prevGetCurrentStackImpl = null;

	var getCurrentServerStackImpl = function () {
	  return '';
	};

	var describeStackFrame = function (element) {
	  return '';
	};

	var validatePropertiesInDevelopment = function (type, props) {};

	var pushCurrentDebugStack = function (stack) {};

	var pushElementToDebugStack = function (element) {};

	var popCurrentDebugStack = function () {};

	var hasWarnedAboutUsingContextAsConsumer = false;

	{
	  ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;

	  validatePropertiesInDevelopment = function (type, props) {
	    validateProperties(type, props);
	    validateProperties$1(type, props);
	    validateProperties$2(type, props, null);
	  };

	  describeStackFrame = function (element) {
	    return describeUnknownElementTypeFrameInDEV(element.type, element._source, null);
	  };

	  pushCurrentDebugStack = function (stack) {
	    currentDebugStacks.push(stack);

	    if (currentDebugStacks.length === 1) {
	      // We are entering a server renderer.
	      // Remember the previous (e.g. client) global stack implementation.
	      prevGetCurrentStackImpl = ReactDebugCurrentFrame$1.getCurrentStack;
	      ReactDebugCurrentFrame$1.getCurrentStack = getCurrentServerStackImpl;
	    }
	  };

	  pushElementToDebugStack = function (element) {
	    // For the innermost executing ReactDOMServer call,
	    var stack = currentDebugStacks[currentDebugStacks.length - 1]; // Take the innermost executing frame (e.g. <Foo>),

	    var frame = stack[stack.length - 1]; // and record that it has one more element associated with it.

	    frame.debugElementStack.push(element); // We only need this because we tail-optimize single-element
	    // children and directly handle them in an inner loop instead of
	    // creating separate frames for them.
	  };

	  popCurrentDebugStack = function () {
	    currentDebugStacks.pop();

	    if (currentDebugStacks.length === 0) {
	      // We are exiting the server renderer.
	      // Restore the previous (e.g. client) global stack implementation.
	      ReactDebugCurrentFrame$1.getCurrentStack = prevGetCurrentStackImpl;
	      prevGetCurrentStackImpl = null;
	    }
	  };

	  getCurrentServerStackImpl = function () {
	    if (currentDebugStacks.length === 0) {
	      // Nothing is currently rendering.
	      return '';
	    } // ReactDOMServer is reentrant so there may be multiple calls at the same time.
	    // Take the frames from the innermost call which is the last in the array.


	    var frames = currentDebugStacks[currentDebugStacks.length - 1];
	    var stack = ''; // Go through every frame in the stack from the innermost one.

	    for (var i = frames.length - 1; i >= 0; i--) {
	      var frame = frames[i]; // Every frame might have more than one debug element stack entry associated with it.
	      // This is because single-child nesting doesn't create materialized frames.
	      // Instead it would push them through `pushElementToDebugStack()`.

	      var debugElementStack = frame.debugElementStack;

	      for (var ii = debugElementStack.length - 1; ii >= 0; ii--) {
	        stack += describeStackFrame(debugElementStack[ii]);
	      }
	    }

	    return stack;
	  };
	}

	var didWarnDefaultInputValue = false;
	var didWarnDefaultChecked = false;
	var didWarnDefaultSelectValue = false;
	var didWarnDefaultTextareaValue = false;
	var didWarnInvalidOptionChildren = false;
	var didWarnAboutNoopUpdateForComponent = {};
	var didWarnAboutBadClass = {};
	var didWarnAboutModulePatternComponent = {};
	var didWarnAboutDeprecatedWillMount = {};
	var didWarnAboutUndefinedDerivedState = {};
	var didWarnAboutUninitializedState = {};
	var valuePropNames = ['value', 'defaultValue'];
	var newlineEatingTags = {
	  listing: true,
	  pre: true,
	  textarea: true
	}; // We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name

	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset

	var validatedTagCache = {};

	function validateDangerousTag(tag) {
	  if (!validatedTagCache.hasOwnProperty(tag)) {
	    if (!VALID_TAG_REGEX.test(tag)) {
	      {
	        throw Error( "Invalid tag: " + tag );
	      }
	    }

	    validatedTagCache[tag] = true;
	  }
	}

	var styleNameCache = {};

	var processStyleName = function (styleName) {
	  if (styleNameCache.hasOwnProperty(styleName)) {
	    return styleNameCache[styleName];
	  }

	  var result = hyphenateStyleName(styleName);
	  styleNameCache[styleName] = result;
	  return result;
	};

	function createMarkupForStyles(styles) {
	  var serialized = '';
	  var delimiter = '';

	  for (var styleName in styles) {
	    if (!styles.hasOwnProperty(styleName)) {
	      continue;
	    }

	    var isCustomProperty = styleName.indexOf('--') === 0;
	    var styleValue = styles[styleName];

	    {
	      if (!isCustomProperty) {
	        warnValidStyle$1(styleName, styleValue);
	      }
	    }

	    if (styleValue != null) {
	      serialized += delimiter + (isCustomProperty ? styleName : processStyleName(styleName)) + ':';
	      serialized += dangerousStyleValue(styleName, styleValue, isCustomProperty);
	      delimiter = ';';
	    }
	  }

	  return serialized || null;
	}

	function warnNoop(publicInstance, callerName) {
	  {
	    var _constructor = publicInstance.constructor;
	    var componentName = _constructor && getComponentName(_constructor) || 'ReactClass';
	    var warningKey = componentName + '.' + callerName;

	    if (didWarnAboutNoopUpdateForComponent[warningKey]) {
	      return;
	    }

	    error('%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op.\n\nPlease check the code for the %s component.', callerName, callerName, componentName);

	    didWarnAboutNoopUpdateForComponent[warningKey] = true;
	  }
	}

	function shouldConstruct$1(Component) {
	  return Component.prototype && Component.prototype.isReactComponent;
	}

	function getNonChildrenInnerMarkup(props) {
	  var innerHTML = props.dangerouslySetInnerHTML;

	  if (innerHTML != null) {
	    if (innerHTML.__html != null) {
	      return innerHTML.__html;
	    }
	  } else {
	    var content = props.children;

	    if (typeof content === 'string' || typeof content === 'number') {
	      return escapeTextForBrowser(content);
	    }
	  }

	  return null;
	}

	function flattenTopLevelChildren(children) {
	  if (!React.isValidElement(children)) {
	    return toArray(children);
	  }

	  var element = children;

	  if (element.type !== REACT_FRAGMENT_TYPE) {
	    return [element];
	  }

	  var fragmentChildren = element.props.children;

	  if (!React.isValidElement(fragmentChildren)) {
	    return toArray(fragmentChildren);
	  }

	  var fragmentChildElement = fragmentChildren;
	  return [fragmentChildElement];
	}

	function flattenOptionChildren(children) {
	  if (children === undefined || children === null) {
	    return children;
	  }

	  var content = ''; // Flatten children and warn if they aren't strings or numbers;
	  // invalid types are ignored.

	  React.Children.forEach(children, function (child) {
	    if (child == null) {
	      return;
	    }

	    content += child;

	    {
	      if (!didWarnInvalidOptionChildren && typeof child !== 'string' && typeof child !== 'number') {
	        didWarnInvalidOptionChildren = true;

	        error('Only strings and numbers are supported as <option> children.');
	      }
	    }
	  });
	  return content;
	}

	var hasOwnProperty$2 = Object.prototype.hasOwnProperty;
	var STYLE = 'style';
	var RESERVED_PROPS = {
	  children: null,
	  dangerouslySetInnerHTML: null,
	  suppressContentEditableWarning: null,
	  suppressHydrationWarning: null
	};

	function createOpenTagMarkup(tagVerbatim, tagLowercase, props, namespace, makeStaticMarkup, isRootElement) {
	  var ret = '<' + tagVerbatim;
	  var isCustomComponent$1 = isCustomComponent(tagLowercase, props);

	  for (var propKey in props) {
	    if (!hasOwnProperty$2.call(props, propKey)) {
	      continue;
	    }

	    var propValue = props[propKey];

	    if (propValue == null) {
	      continue;
	    }

	    if (propKey === STYLE) {
	      propValue = createMarkupForStyles(propValue);
	    }

	    var markup = null;

	    if (isCustomComponent$1) {
	      if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	        markup = createMarkupForCustomAttribute(propKey, propValue);
	      }
	    } else {
	      markup = createMarkupForProperty(propKey, propValue);
	    }

	    if (markup) {
	      ret += ' ' + markup;
	    }
	  } // For static pages, no need to put React ID and checksum. Saves lots of
	  // bytes.


	  if (makeStaticMarkup) {
	    return ret;
	  }

	  if (isRootElement) {
	    ret += ' ' + createMarkupForRoot();
	  }

	  return ret;
	}

	function validateRenderResult(child, type) {
	  if (child === undefined) {
	    {
	      {
	        throw Error( (getComponentName(type) || 'Component') + "(...): Nothing was returned from render. This usually means a return statement is missing. Or, to render nothing, return null." );
	      }
	    }
	  }
	}

	function resolve(child, context, threadID) {
	  while (React.isValidElement(child)) {
	    // Safe because we just checked it's an element.
	    var element = child;
	    var Component = element.type;

	    {
	      pushElementToDebugStack(element);
	    }

	    if (typeof Component !== 'function') {
	      break;
	    }

	    processChild(element, Component);
	  } // Extra closure so queue and replace can be captured properly


	  function processChild(element, Component) {
	    var isClass = shouldConstruct$1(Component);
	    var publicContext = processContext(Component, context, threadID, isClass);
	    var queue = [];
	    var replace = false;
	    var updater = {
	      isMounted: function (publicInstance) {
	        return false;
	      },
	      enqueueForceUpdate: function (publicInstance) {
	        if (queue === null) {
	          warnNoop(publicInstance, 'forceUpdate');
	          return null;
	        }
	      },
	      enqueueReplaceState: function (publicInstance, completeState) {
	        replace = true;
	        queue = [completeState];
	      },
	      enqueueSetState: function (publicInstance, currentPartialState) {
	        if (queue === null) {
	          warnNoop(publicInstance, 'setState');
	          return null;
	        }

	        queue.push(currentPartialState);
	      }
	    };
	    var inst;

	    if (isClass) {
	      inst = new Component(element.props, publicContext, updater);

	      if (typeof Component.getDerivedStateFromProps === 'function') {
	        {
	          if (inst.state === null || inst.state === undefined) {
	            var componentName = getComponentName(Component) || 'Unknown';

	            if (!didWarnAboutUninitializedState[componentName]) {
	              error('`%s` uses `getDerivedStateFromProps` but its initial state is ' + '%s. This is not recommended. Instead, define the initial state by ' + 'assigning an object to `this.state` in the constructor of `%s`. ' + 'This ensures that `getDerivedStateFromProps` arguments have a consistent shape.', componentName, inst.state === null ? 'null' : 'undefined', componentName);

	              didWarnAboutUninitializedState[componentName] = true;
	            }
	          }
	        }

	        var partialState = Component.getDerivedStateFromProps.call(null, element.props, inst.state);

	        {
	          if (partialState === undefined) {
	            var _componentName = getComponentName(Component) || 'Unknown';

	            if (!didWarnAboutUndefinedDerivedState[_componentName]) {
	              error('%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. ' + 'You have returned undefined.', _componentName);

	              didWarnAboutUndefinedDerivedState[_componentName] = true;
	            }
	          }
	        }

	        if (partialState != null) {
	          inst.state = _assign({}, inst.state, partialState);
	        }
	      }
	    } else {
	      {
	        if (Component.prototype && typeof Component.prototype.render === 'function') {
	          var _componentName2 = getComponentName(Component) || 'Unknown';

	          if (!didWarnAboutBadClass[_componentName2]) {
	            error("The <%s /> component appears to have a render method, but doesn't extend React.Component. " + 'This is likely to cause errors. Change %s to extend React.Component instead.', _componentName2, _componentName2);

	            didWarnAboutBadClass[_componentName2] = true;
	          }
	        }
	      }

	      var componentIdentity = {};
	      prepareToUseHooks(componentIdentity);
	      inst = Component(element.props, publicContext, updater);
	      inst = finishHooks(Component, element.props, inst, publicContext);

	      {
	        // Support for module components is deprecated and is removed behind a flag.
	        // Whether or not it would crash later, we want to show a good message in DEV first.
	        if (inst != null && inst.render != null) {
	          var _componentName3 = getComponentName(Component) || 'Unknown';

	          if (!didWarnAboutModulePatternComponent[_componentName3]) {
	            error('The <%s /> component appears to be a function component that returns a class instance. ' + 'Change %s to a class that extends React.Component instead. ' + "If you can't use a class try assigning the prototype on the function as a workaround. " + "`%s.prototype = React.Component.prototype`. Don't use an arrow function since it " + 'cannot be called with `new` by React.', _componentName3, _componentName3, _componentName3);

	            didWarnAboutModulePatternComponent[_componentName3] = true;
	          }
	        }
	      } // If the flag is on, everything is assumed to be a function component.
	      // Otherwise, we also do the unfortunate dynamic checks.


	      if ( inst == null || inst.render == null) {
	        child = inst;
	        validateRenderResult(child, Component);
	        return;
	      }
	    }

	    inst.props = element.props;
	    inst.context = publicContext;
	    inst.updater = updater;
	    var initialState = inst.state;

	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }

	    if (typeof inst.UNSAFE_componentWillMount === 'function' || typeof inst.componentWillMount === 'function') {
	      if (typeof inst.componentWillMount === 'function') {
	        {
	          if ( inst.componentWillMount.__suppressDeprecationWarning !== true) {
	            var _componentName4 = getComponentName(Component) || 'Unknown';

	            if (!didWarnAboutDeprecatedWillMount[_componentName4]) {
	              warn( // keep this warning in sync with ReactStrictModeWarning.js
	              'componentWillMount has been renamed, and is not recommended for use. ' + 'See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n' + '* Move code from componentWillMount to componentDidMount (preferred in most cases) ' + 'or the constructor.\n' + '\nPlease update the following components: %s', _componentName4);

	              didWarnAboutDeprecatedWillMount[_componentName4] = true;
	            }
	          }
	        } // In order to support react-lifecycles-compat polyfilled components,
	        // Unsafe lifecycles should not be invoked for any component with the new gDSFP.


	        if (typeof Component.getDerivedStateFromProps !== 'function') {
	          inst.componentWillMount();
	        }
	      }

	      if (typeof inst.UNSAFE_componentWillMount === 'function' && typeof Component.getDerivedStateFromProps !== 'function') {
	        // In order to support react-lifecycles-compat polyfilled components,
	        // Unsafe lifecycles should not be invoked for any component with the new gDSFP.
	        inst.UNSAFE_componentWillMount();
	      }

	      if (queue.length) {
	        var oldQueue = queue;
	        var oldReplace = replace;
	        queue = null;
	        replace = false;

	        if (oldReplace && oldQueue.length === 1) {
	          inst.state = oldQueue[0];
	        } else {
	          var nextState = oldReplace ? oldQueue[0] : inst.state;
	          var dontMutate = true;

	          for (var i = oldReplace ? 1 : 0; i < oldQueue.length; i++) {
	            var partial = oldQueue[i];

	            var _partialState = typeof partial === 'function' ? partial.call(inst, nextState, element.props, publicContext) : partial;

	            if (_partialState != null) {
	              if (dontMutate) {
	                dontMutate = false;
	                nextState = _assign({}, nextState, _partialState);
	              } else {
	                _assign(nextState, _partialState);
	              }
	            }
	          }

	          inst.state = nextState;
	        }
	      } else {
	        queue = null;
	      }
	    }

	    child = inst.render();

	    {
	      if (child === undefined && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        child = null;
	      }
	    }

	    validateRenderResult(child, Component);
	    var childContext;

	    {
	      if (typeof inst.getChildContext === 'function') {
	        var _childContextTypes = Component.childContextTypes;

	        if (typeof _childContextTypes === 'object') {
	          childContext = inst.getChildContext();

	          for (var contextKey in childContext) {
	            if (!(contextKey in _childContextTypes)) {
	              {
	                throw Error( (getComponentName(Component) || 'Unknown') + ".getChildContext(): key \"" + contextKey + "\" is not defined in childContextTypes." );
	              }
	            }
	          }
	        } else {
	          {
	            error('%s.getChildContext(): childContextTypes must be defined in order to ' + 'use getChildContext().', getComponentName(Component) || 'Unknown');
	          }
	        }
	      }

	      if (childContext) {
	        context = _assign({}, context, childContext);
	      }
	    }
	  }

	  return {
	    child: child,
	    context: context
	  };
	}

	var ReactDOMServerRenderer = /*#__PURE__*/function () {
	  // TODO: type this more strictly:
	  // DEV-only
	  function ReactDOMServerRenderer(children, makeStaticMarkup, options) {
	    var flatChildren = flattenTopLevelChildren(children);
	    var topFrame = {
	      type: null,
	      // Assume all trees start in the HTML namespace (not totally true, but
	      // this is what we did historically)
	      domNamespace: Namespaces.html,
	      children: flatChildren,
	      childIndex: 0,
	      context: emptyObject,
	      footer: ''
	    };

	    {
	      topFrame.debugElementStack = [];
	    }

	    this.threadID = allocThreadID();
	    this.stack = [topFrame];
	    this.exhausted = false;
	    this.currentSelectValue = null;
	    this.previousWasTextNode = false;
	    this.makeStaticMarkup = makeStaticMarkup;
	    this.suspenseDepth = 0; // Context (new API)

	    this.contextIndex = -1;
	    this.contextStack = [];
	    this.contextValueStack = []; // useOpaqueIdentifier ID

	    this.uniqueID = 0;
	    this.identifierPrefix = options && options.identifierPrefix || '';

	    {
	      this.contextProviderStack = [];
	    }
	  }

	  var _proto = ReactDOMServerRenderer.prototype;

	  _proto.destroy = function destroy() {
	    if (!this.exhausted) {
	      this.exhausted = true;
	      this.clearProviders();
	      freeThreadID(this.threadID);
	    }
	  }
	  /**
	   * Note: We use just two stacks regardless of how many context providers you have.
	   * Providers are always popped in the reverse order to how they were pushed
	   * so we always know on the way down which provider you'll encounter next on the way up.
	   * On the way down, we push the current provider, and its context value *before*
	   * we mutated it, onto the stacks. Therefore, on the way up, we always know which
	   * provider needs to be "restored" to which value.
	   * https://github.com/facebook/react/pull/12985#issuecomment-396301248
	   */
	  ;

	  _proto.pushProvider = function pushProvider(provider) {
	    var index = ++this.contextIndex;
	    var context = provider.type._context;
	    var threadID = this.threadID;
	    validateContextBounds(context, threadID);
	    var previousValue = context[threadID]; // Remember which value to restore this context to on our way up.

	    this.contextStack[index] = context;
	    this.contextValueStack[index] = previousValue;

	    {
	      // Only used for push/pop mismatch warnings.
	      this.contextProviderStack[index] = provider;
	    } // Mutate the current value.


	    context[threadID] = provider.props.value;
	  };

	  _proto.popProvider = function popProvider(provider) {
	    var index = this.contextIndex;

	    {
	      if (index < 0 || provider !== this.contextProviderStack[index]) {
	        error('Unexpected pop.');
	      }
	    }

	    var context = this.contextStack[index];
	    var previousValue = this.contextValueStack[index]; // "Hide" these null assignments from Flow by using `any`
	    // because conceptually they are deletions--as long as we
	    // promise to never access values beyond `this.contextIndex`.

	    this.contextStack[index] = null;
	    this.contextValueStack[index] = null;

	    {
	      this.contextProviderStack[index] = null;
	    }

	    this.contextIndex--; // Restore to the previous value we stored as we were walking down.
	    // We've already verified that this context has been expanded to accommodate
	    // this thread id, so we don't need to do it again.

	    context[this.threadID] = previousValue;
	  };

	  _proto.clearProviders = function clearProviders() {
	    // Restore any remaining providers on the stack to previous values
	    for (var index = this.contextIndex; index >= 0; index--) {
	      var context = this.contextStack[index];
	      var previousValue = this.contextValueStack[index];
	      context[this.threadID] = previousValue;
	    }
	  };

	  _proto.read = function read(bytes) {
	    if (this.exhausted) {
	      return null;
	    }

	    var prevPartialRenderer = currentPartialRenderer;
	    setCurrentPartialRenderer(this);
	    var prevDispatcher = ReactCurrentDispatcher$1.current;
	    ReactCurrentDispatcher$1.current = Dispatcher;

	    try {
	      // Markup generated within <Suspense> ends up buffered until we know
	      // nothing in that boundary suspended
	      var out = [''];
	      var suspended = false;

	      while (out[0].length < bytes) {
	        if (this.stack.length === 0) {
	          this.exhausted = true;
	          freeThreadID(this.threadID);
	          break;
	        }

	        var frame = this.stack[this.stack.length - 1];

	        if (suspended || frame.childIndex >= frame.children.length) {
	          var footer = frame.footer;

	          if (footer !== '') {
	            this.previousWasTextNode = false;
	          }

	          this.stack.pop();

	          if (frame.type === 'select') {
	            this.currentSelectValue = null;
	          } else if (frame.type != null && frame.type.type != null && frame.type.type.$$typeof === REACT_PROVIDER_TYPE) {
	            var provider = frame.type;
	            this.popProvider(provider);
	          } else if (frame.type === REACT_SUSPENSE_TYPE) {
	            this.suspenseDepth--;
	            var buffered = out.pop();

	            if (suspended) {
	              suspended = false; // If rendering was suspended at this boundary, render the fallbackFrame

	              var fallbackFrame = frame.fallbackFrame;

	              if (!fallbackFrame) {
	                {
	                  throw Error(true ? "ReactDOMServer did not find an internal fallback frame for Suspense. This is a bug in React. Please file an issue." : formatProdErrorMessage(303));
	                }
	              }

	              this.stack.push(fallbackFrame);
	              out[this.suspenseDepth] += '<!--$!-->'; // Skip flushing output since we're switching to the fallback

	              continue;
	            } else {
	              out[this.suspenseDepth] += buffered;
	            }
	          } // Flush output


	          out[this.suspenseDepth] += footer;
	          continue;
	        }

	        var child = frame.children[frame.childIndex++];
	        var outBuffer = '';

	        if (true) {
	          pushCurrentDebugStack(this.stack); // We're starting work on this frame, so reset its inner stack.

	          frame.debugElementStack.length = 0;
	        }

	        try {
	          outBuffer += this.render(child, frame.context, frame.domNamespace);
	        } catch (err) {
	          if (err != null && typeof err.then === 'function') {
	            if (enableSuspenseServerRenderer) ; else {
	              if (!false) {
	                {
	                  throw Error(true ? "ReactDOMServer does not yet support Suspense." : formatProdErrorMessage(294));
	                }
	              }
	            }
	          } else {
	            throw err;
	          }
	        } finally {
	          if (true) {
	            popCurrentDebugStack();
	          }
	        }

	        if (out.length <= this.suspenseDepth) {
	          out.push('');
	        }

	        out[this.suspenseDepth] += outBuffer;
	      }

	      return out[0];
	    } finally {
	      ReactCurrentDispatcher$1.current = prevDispatcher;
	      setCurrentPartialRenderer(prevPartialRenderer);
	      resetHooksState();
	    }
	  };

	  _proto.render = function render(child, context, parentNamespace) {
	    if (typeof child === 'string' || typeof child === 'number') {
	      var text = '' + child;

	      if (text === '') {
	        return '';
	      }

	      if (this.makeStaticMarkup) {
	        return escapeTextForBrowser(text);
	      }

	      if (this.previousWasTextNode) {
	        return '<!-- -->' + escapeTextForBrowser(text);
	      }

	      this.previousWasTextNode = true;
	      return escapeTextForBrowser(text);
	    } else {
	      var nextChild;

	      var _resolve = resolve(child, context, this.threadID);

	      nextChild = _resolve.child;
	      context = _resolve.context;

	      if (nextChild === null || nextChild === false) {
	        return '';
	      } else if (!React.isValidElement(nextChild)) {
	        if (nextChild != null && nextChild.$$typeof != null) {
	          // Catch unexpected special types early.
	          var $$typeof = nextChild.$$typeof;

	          if (!($$typeof !== REACT_PORTAL_TYPE)) {
	            {
	              throw Error( "Portals are not currently supported by the server renderer. Render them conditionally so that they only appear on the client render." );
	            }
	          } // Catch-all to prevent an infinite loop if React.Children.toArray() supports some new type.


	          {
	            {
	              throw Error( "Unknown element-like object type: " + $$typeof.toString() + ". This is likely a bug in React. Please file an issue." );
	            }
	          }
	        }

	        var nextChildren = toArray(nextChild);
	        var frame = {
	          type: null,
	          domNamespace: parentNamespace,
	          children: nextChildren,
	          childIndex: 0,
	          context: context,
	          footer: ''
	        };

	        {
	          frame.debugElementStack = [];
	        }

	        this.stack.push(frame);
	        return '';
	      } // Safe because we just checked it's an element.


	      var nextElement = nextChild;
	      var elementType = nextElement.type;

	      if (typeof elementType === 'string') {
	        return this.renderDOM(nextElement, context, parentNamespace);
	      }

	      switch (elementType) {
	        // TODO: LegacyHidden acts the same as a fragment. This only works
	        // because we currently assume that every instance of LegacyHidden is
	        // accompanied by a host component wrapper. In the hidden mode, the host
	        // component is given a `hidden` attribute, which ensures that the
	        // initial HTML is not visible. To support the use of LegacyHidden as a
	        // true fragment, without an extra DOM node, we would have to hide the
	        // initial HTML in some other way.
	        case REACT_LEGACY_HIDDEN_TYPE:
	        case REACT_DEBUG_TRACING_MODE_TYPE:
	        case REACT_STRICT_MODE_TYPE:
	        case REACT_PROFILER_TYPE:
	        case REACT_SUSPENSE_LIST_TYPE:
	        case REACT_FRAGMENT_TYPE:
	          {
	            var _nextChildren = toArray(nextChild.props.children);

	            var _frame = {
	              type: null,
	              domNamespace: parentNamespace,
	              children: _nextChildren,
	              childIndex: 0,
	              context: context,
	              footer: ''
	            };

	            {
	              _frame.debugElementStack = [];
	            }

	            this.stack.push(_frame);
	            return '';
	          }

	        case REACT_SUSPENSE_TYPE:
	          {
	            {
	              {
	                {
	                  throw Error( "ReactDOMServer does not yet support Suspense." );
	                }
	              }
	            }
	          }
	        // eslint-disable-next-line-no-fallthrough

	        case REACT_SCOPE_TYPE:
	          {

	            {
	              {
	                throw Error( "ReactDOMServer does not yet support scope components." );
	              }
	            }
	          }
	      }

	      if (typeof elementType === 'object' && elementType !== null) {
	        switch (elementType.$$typeof) {
	          case REACT_FORWARD_REF_TYPE:
	            {
	              var element = nextChild;

	              var _nextChildren5;

	              var componentIdentity = {};
	              prepareToUseHooks(componentIdentity);
	              _nextChildren5 = elementType.render(element.props, element.ref);
	              _nextChildren5 = finishHooks(elementType.render, element.props, _nextChildren5, element.ref);
	              _nextChildren5 = toArray(_nextChildren5);
	              var _frame5 = {
	                type: null,
	                domNamespace: parentNamespace,
	                children: _nextChildren5,
	                childIndex: 0,
	                context: context,
	                footer: ''
	              };

	              {
	                _frame5.debugElementStack = [];
	              }

	              this.stack.push(_frame5);
	              return '';
	            }

	          case REACT_MEMO_TYPE:
	            {
	              var _element = nextChild;
	              var _nextChildren6 = [React.createElement(elementType.type, _assign({
	                ref: _element.ref
	              }, _element.props))];
	              var _frame6 = {
	                type: null,
	                domNamespace: parentNamespace,
	                children: _nextChildren6,
	                childIndex: 0,
	                context: context,
	                footer: ''
	              };

	              {
	                _frame6.debugElementStack = [];
	              }

	              this.stack.push(_frame6);
	              return '';
	            }

	          case REACT_PROVIDER_TYPE:
	            {
	              var provider = nextChild;
	              var nextProps = provider.props;

	              var _nextChildren7 = toArray(nextProps.children);

	              var _frame7 = {
	                type: provider,
	                domNamespace: parentNamespace,
	                children: _nextChildren7,
	                childIndex: 0,
	                context: context,
	                footer: ''
	              };

	              {
	                _frame7.debugElementStack = [];
	              }

	              this.pushProvider(provider);
	              this.stack.push(_frame7);
	              return '';
	            }

	          case REACT_CONTEXT_TYPE:
	            {
	              var reactContext = nextChild.type; // The logic below for Context differs depending on PROD or DEV mode. In
	              // DEV mode, we create a separate object for Context.Consumer that acts
	              // like a proxy to Context. This proxy object adds unnecessary code in PROD
	              // so we use the old behaviour (Context.Consumer references Context) to
	              // reduce size and overhead. The separate object references context via
	              // a property called "_context", which also gives us the ability to check
	              // in DEV mode if this property exists or not and warn if it does not.

	              {
	                if (reactContext._context === undefined) {
	                  // This may be because it's a Context (rather than a Consumer).
	                  // Or it may be because it's older React where they're the same thing.
	                  // We only want to warn if we're sure it's a new React.
	                  if (reactContext !== reactContext.Consumer) {
	                    if (!hasWarnedAboutUsingContextAsConsumer) {
	                      hasWarnedAboutUsingContextAsConsumer = true;

	                      error('Rendering <Context> directly is not supported and will be removed in ' + 'a future major release. Did you mean to render <Context.Consumer> instead?');
	                    }
	                  }
	                } else {
	                  reactContext = reactContext._context;
	                }
	              }

	              var _nextProps = nextChild.props;
	              var threadID = this.threadID;
	              validateContextBounds(reactContext, threadID);
	              var nextValue = reactContext[threadID];

	              var _nextChildren8 = toArray(_nextProps.children(nextValue));

	              var _frame8 = {
	                type: nextChild,
	                domNamespace: parentNamespace,
	                children: _nextChildren8,
	                childIndex: 0,
	                context: context,
	                footer: ''
	              };

	              {
	                _frame8.debugElementStack = [];
	              }

	              this.stack.push(_frame8);
	              return '';
	            }
	          // eslint-disable-next-line-no-fallthrough

	          case REACT_FUNDAMENTAL_TYPE:
	            {

	              {
	                {
	                  throw Error( "ReactDOMServer does not yet support the fundamental API." );
	                }
	              }
	            }
	          // eslint-disable-next-line-no-fallthrough

	          case REACT_LAZY_TYPE:
	            {
	              var _element2 = nextChild;
	              var lazyComponent = nextChild.type; // Attempt to initialize lazy component regardless of whether the
	              // suspense server-side renderer is enabled so synchronously
	              // resolved constructors are supported.

	              var payload = lazyComponent._payload;
	              var init = lazyComponent._init;
	              var result = init(payload);
	              var _nextChildren10 = [React.createElement(result, _assign({
	                ref: _element2.ref
	              }, _element2.props))];
	              var _frame10 = {
	                type: null,
	                domNamespace: parentNamespace,
	                children: _nextChildren10,
	                childIndex: 0,
	                context: context,
	                footer: ''
	              };

	              {
	                _frame10.debugElementStack = [];
	              }

	              this.stack.push(_frame10);
	              return '';
	            }
	        }
	      }

	      var info = '';

	      {
	        var owner = nextElement._owner;

	        if (elementType === undefined || typeof elementType === 'object' && elementType !== null && Object.keys(elementType).length === 0) {
	          info += ' You likely forgot to export your component from the file ' + "it's defined in, or you might have mixed up default and " + 'named imports.';
	        }

	        var ownerName = owner ? getComponentName(owner) : null;

	        if (ownerName) {
	          info += '\n\nCheck the render method of `' + ownerName + '`.';
	        }
	      }

	      {
	        {
	          throw Error( "Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: " + (elementType == null ? elementType : typeof elementType) + "." + info );
	        }
	      }
	    }
	  };

	  _proto.renderDOM = function renderDOM(element, context, parentNamespace) {
	    var tag = element.type.toLowerCase();
	    var namespace = parentNamespace;

	    if (parentNamespace === Namespaces.html) {
	      namespace = getIntrinsicNamespace(tag);
	    }

	    {
	      if (namespace === Namespaces.html) {
	        // Should this check be gated by parent namespace? Not sure we want to
	        // allow <SVG> or <mATH>.
	        if (tag !== element.type) {
	          error('<%s /> is using incorrect casing. ' + 'Use PascalCase for React components, ' + 'or lowercase for HTML elements.', element.type);
	        }
	      }
	    }

	    validateDangerousTag(tag);
	    var props = element.props;

	    if (tag === 'input') {
	      {
	        checkControlledValueProps('input', props);

	        if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnDefaultChecked) {
	          error('%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://reactjs.org/link/controlled-components', 'A component', props.type);

	          didWarnDefaultChecked = true;
	        }

	        if (props.value !== undefined && props.defaultValue !== undefined && !didWarnDefaultInputValue) {
	          error('%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://reactjs.org/link/controlled-components', 'A component', props.type);

	          didWarnDefaultInputValue = true;
	        }
	      }

	      props = _assign({
	        type: undefined
	      }, props, {
	        defaultChecked: undefined,
	        defaultValue: undefined,
	        value: props.value != null ? props.value : props.defaultValue,
	        checked: props.checked != null ? props.checked : props.defaultChecked
	      });
	    } else if (tag === 'textarea') {
	      {
	        checkControlledValueProps('textarea', props);

	        if (props.value !== undefined && props.defaultValue !== undefined && !didWarnDefaultTextareaValue) {
	          error('Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://reactjs.org/link/controlled-components');

	          didWarnDefaultTextareaValue = true;
	        }
	      }

	      var initialValue = props.value;

	      if (initialValue == null) {
	        var defaultValue = props.defaultValue; // TODO (yungsters): Remove support for children content in <textarea>.

	        var textareaChildren = props.children;

	        if (textareaChildren != null) {
	          {
	            error('Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.');
	          }

	          if (!(defaultValue == null)) {
	            {
	              throw Error( "If you supply `defaultValue` on a <textarea>, do not pass children." );
	            }
	          }

	          if (Array.isArray(textareaChildren)) {
	            if (!(textareaChildren.length <= 1)) {
	              {
	                throw Error( "<textarea> can only have at most one child." );
	              }
	            }

	            textareaChildren = textareaChildren[0];
	          }

	          defaultValue = '' + textareaChildren;
	        }

	        if (defaultValue == null) {
	          defaultValue = '';
	        }

	        initialValue = defaultValue;
	      }

	      props = _assign({}, props, {
	        value: undefined,
	        children: '' + initialValue
	      });
	    } else if (tag === 'select') {
	      {
	        checkControlledValueProps('select', props);

	        for (var i = 0; i < valuePropNames.length; i++) {
	          var propName = valuePropNames[i];

	          if (props[propName] == null) {
	            continue;
	          }

	          var isArray = Array.isArray(props[propName]);

	          if (props.multiple && !isArray) {
	            error('The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.', propName);
	          } else if (!props.multiple && isArray) {
	            error('The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.', propName);
	          }
	        }

	        if (props.value !== undefined && props.defaultValue !== undefined && !didWarnDefaultSelectValue) {
	          error('Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://reactjs.org/link/controlled-components');

	          didWarnDefaultSelectValue = true;
	        }
	      }

	      this.currentSelectValue = props.value != null ? props.value : props.defaultValue;
	      props = _assign({}, props, {
	        value: undefined
	      });
	    } else if (tag === 'option') {
	      var selected = null;
	      var selectValue = this.currentSelectValue;
	      var optionChildren = flattenOptionChildren(props.children);

	      if (selectValue != null) {
	        var value;

	        if (props.value != null) {
	          value = props.value + '';
	        } else {
	          value = optionChildren;
	        }

	        selected = false;

	        if (Array.isArray(selectValue)) {
	          // multiple
	          for (var j = 0; j < selectValue.length; j++) {
	            if ('' + selectValue[j] === value) {
	              selected = true;
	              break;
	            }
	          }
	        } else {
	          selected = '' + selectValue === value;
	        }

	        props = _assign({
	          selected: undefined,
	          children: undefined
	        }, props, {
	          selected: selected,
	          children: optionChildren
	        });
	      }
	    }

	    {
	      validatePropertiesInDevelopment(tag, props);
	    }

	    assertValidProps(tag, props);
	    var out = createOpenTagMarkup(element.type, tag, props, namespace, this.makeStaticMarkup, this.stack.length === 1);
	    var footer = '';

	    if (omittedCloseTags.hasOwnProperty(tag)) {
	      out += '/>';
	    } else {
	      out += '>';
	      footer = '</' + element.type + '>';
	    }

	    var children;
	    var innerMarkup = getNonChildrenInnerMarkup(props);

	    if (innerMarkup != null) {
	      children = [];

	      if (newlineEatingTags.hasOwnProperty(tag) && innerMarkup.charAt(0) === '\n') {
	        // text/html ignores the first character in these tags if it's a newline
	        // Prefer to break application/xml over text/html (for now) by adding
	        // a newline specifically to get eaten by the parser. (Alternately for
	        // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	        // \r is normalized out by HTMLTextAreaElement#value.)
	        // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	        // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	        // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	        // See: Parsing of "textarea" "listing" and "pre" elements
	        //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	        out += '\n';
	      }

	      out += innerMarkup;
	    } else {
	      children = toArray(props.children);
	    }

	    var frame = {
	      domNamespace: getChildNamespace(parentNamespace, element.type),
	      type: tag,
	      children: children,
	      childIndex: 0,
	      context: context,
	      footer: footer
	    };

	    {
	      frame.debugElementStack = [];
	    }

	    this.stack.push(frame);
	    this.previousWasTextNode = false;
	    return out;
	  };

	  return ReactDOMServerRenderer;
	}();

	/**
	 * Render a ReactElement to its initial HTML. This should only be used on the
	 * server.
	 * See https://reactjs.org/docs/react-dom-server.html#rendertostring
	 */

	function renderToString(element, options) {
	  var renderer = new ReactDOMServerRenderer(element, false, options);

	  try {
	    var markup = renderer.read(Infinity);
	    return markup;
	  } finally {
	    renderer.destroy();
	  }
	}
	/**
	 * Similar to renderToString, except this doesn't create extra DOM attributes
	 * such as data-react-id that React uses internally.
	 * See https://reactjs.org/docs/react-dom-server.html#rendertostaticmarkup
	 */

	function renderToStaticMarkup(element, options) {
	  var renderer = new ReactDOMServerRenderer(element, true, options);

	  try {
	    var markup = renderer.read(Infinity);
	    return markup;
	  } finally {
	    renderer.destroy();
	  }
	}

	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  subClass.__proto__ = superClass;
	}

	var ReactMarkupReadableStream = /*#__PURE__*/function (_Readable) {
	  _inheritsLoose(ReactMarkupReadableStream, _Readable);

	  function ReactMarkupReadableStream(element, makeStaticMarkup, options) {
	    var _this;

	    // Calls the stream.Readable(options) constructor. Consider exposing built-in
	    // features like highWaterMark in the future.
	    _this = _Readable.call(this, {}) || this;
	    _this.partialRenderer = new ReactDOMServerRenderer(element, makeStaticMarkup, options);
	    return _this;
	  }

	  var _proto = ReactMarkupReadableStream.prototype;

	  _proto._destroy = function _destroy(err, callback) {
	    this.partialRenderer.destroy();
	    callback(err);
	  };

	  _proto._read = function _read(size) {
	    try {
	      this.push(this.partialRenderer.read(size));
	    } catch (err) {
	      this.destroy(err);
	    }
	  };

	  return ReactMarkupReadableStream;
	}(stream.Readable);
	/**
	 * Render a ReactElement to its initial HTML. This should only be used on the
	 * server.
	 * See https://reactjs.org/docs/react-dom-server.html#rendertonodestream
	 */


	function renderToNodeStream(element, options) {
	  return new ReactMarkupReadableStream(element, false, options);
	}
	/**
	 * Similar to renderToNodeStream, except this doesn't create extra DOM attributes
	 * such as data-react-id that React uses internally.
	 * See https://reactjs.org/docs/react-dom-server.html#rendertostaticnodestream
	 */

	function renderToStaticNodeStream(element, options) {
	  return new ReactMarkupReadableStream(element, true, options);
	}

	reactDomServer_node_development.renderToNodeStream = renderToNodeStream;
	reactDomServer_node_development.renderToStaticMarkup = renderToStaticMarkup;
	reactDomServer_node_development.renderToStaticNodeStream = renderToStaticNodeStream;
	reactDomServer_node_development.renderToString = renderToString;
	reactDomServer_node_development.version = ReactVersion;
	  })();
	}
	return reactDomServer_node_development;
}

if (process.env.NODE_ENV === 'production') {
  server_node.exports = requireReactDomServer_node_production_min();
} else {
  server_node.exports = requireReactDomServer_node_development();
}

var server_nodeExports = server_node.exports;

var server = server_nodeExports;

var ReactDOMServer = /*@__PURE__*/getDefaultExportFromCjs(server);

var NORMAL_ICON = function (colors) { return "<svg width=\"56\" height=\"20\" viewBox=\"0 0 56 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<rect width=\"56\" height=\"20\" rx=\"10\" fill=\"".concat(colors.primary['0'], "\"/>\n<path d=\"M15.8594 5.46875V14H14.3887L10.5625 7.88867V14H9.0918V5.46875H10.5625L14.4004 11.5918V5.46875H15.8594ZM17.2012 10.9004V10.7656C17.2012 10.3086 17.2676 9.88477 17.4004 9.49414C17.5332 9.09961 17.7246 8.75781 17.9746 8.46875C18.2285 8.17578 18.5371 7.94922 18.9004 7.78906C19.2676 7.625 19.6816 7.54297 20.1426 7.54297C20.6074 7.54297 21.0215 7.625 21.3848 7.78906C21.752 7.94922 22.0625 8.17578 22.3164 8.46875C22.5703 8.75781 22.7637 9.09961 22.8965 9.49414C23.0293 9.88477 23.0957 10.3086 23.0957 10.7656V10.9004C23.0957 11.3574 23.0293 11.7812 22.8965 12.1719C22.7637 12.5625 22.5703 12.9043 22.3164 13.1973C22.0625 13.4863 21.7539 13.7129 21.3906 13.877C21.0273 14.0371 20.6152 14.1172 20.1543 14.1172C19.6895 14.1172 19.2734 14.0371 18.9062 13.877C18.543 13.7129 18.2344 13.4863 17.9805 13.1973C17.7266 12.9043 17.5332 12.5625 17.4004 12.1719C17.2676 11.7812 17.2012 11.3574 17.2012 10.9004ZM18.6133 10.7656V10.9004C18.6133 11.1855 18.6426 11.4551 18.7012 11.709C18.7598 11.9629 18.8516 12.1855 18.9766 12.377C19.1016 12.5684 19.2617 12.7188 19.457 12.8281C19.6523 12.9375 19.8848 12.9922 20.1543 12.9922C20.416 12.9922 20.6426 12.9375 20.834 12.8281C21.0293 12.7188 21.1895 12.5684 21.3145 12.377C21.4395 12.1855 21.5312 11.9629 21.5898 11.709C21.6523 11.4551 21.6836 11.1855 21.6836 10.9004V10.7656C21.6836 10.4844 21.6523 10.2188 21.5898 9.96875C21.5312 9.71484 21.4375 9.49023 21.3086 9.29492C21.1836 9.09961 21.0234 8.94727 20.8281 8.83789C20.6367 8.72461 20.4082 8.66797 20.1426 8.66797C19.877 8.66797 19.6465 8.72461 19.4512 8.83789C19.2598 8.94727 19.1016 9.09961 18.9766 9.29492C18.8516 9.49023 18.7598 9.71484 18.7012 9.96875C18.6426 10.2188 18.6133 10.4844 18.6133 10.7656ZM25.6973 8.86719V14H24.2852V7.66016H25.6328L25.6973 8.86719ZM27.6367 7.61914L27.625 8.93164C27.5391 8.91602 27.4453 8.9043 27.3438 8.89648C27.2461 8.88867 27.1484 8.88477 27.0508 8.88477C26.8086 8.88477 26.5957 8.91992 26.4121 8.99023C26.2285 9.05664 26.0742 9.1543 25.9492 9.2832C25.8281 9.4082 25.7344 9.56055 25.668 9.74023C25.6016 9.91992 25.5625 10.1211 25.5508 10.3438L25.2285 10.3672C25.2285 9.96875 25.2676 9.59961 25.3457 9.25977C25.4238 8.91992 25.541 8.62109 25.6973 8.36328C25.8574 8.10547 26.0566 7.9043 26.2949 7.75977C26.5371 7.61523 26.8164 7.54297 27.1328 7.54297C27.2188 7.54297 27.3105 7.55078 27.4082 7.56641C27.5098 7.58203 27.5859 7.59961 27.6367 7.61914ZM29.9336 8.94922V14H28.5215V7.66016H29.8516L29.9336 8.94922ZM29.7051 10.5957L29.2246 10.5898C29.2246 10.1523 29.2793 9.74805 29.3887 9.37695C29.498 9.00586 29.6582 8.68359 29.8691 8.41016C30.0801 8.13281 30.3418 7.91992 30.6543 7.77148C30.9707 7.61914 31.3359 7.54297 31.75 7.54297C32.0391 7.54297 32.3027 7.58594 32.541 7.67188C32.7832 7.75391 32.9922 7.88477 33.168 8.06445C33.3477 8.24414 33.4844 8.47461 33.5781 8.75586C33.6758 9.03711 33.7246 9.37695 33.7246 9.77539V14H32.3125V9.89844C32.3125 9.58984 32.2656 9.34766 32.1719 9.17188C32.082 8.99609 31.9512 8.87109 31.7793 8.79688C31.6113 8.71875 31.4102 8.67969 31.1758 8.67969C30.9102 8.67969 30.6836 8.73047 30.4961 8.83203C30.3125 8.93359 30.1621 9.07227 30.0449 9.24805C29.9277 9.42383 29.8418 9.62695 29.7871 9.85742C29.7324 10.0879 29.7051 10.334 29.7051 10.5957ZM33.6367 10.2207L32.9746 10.3672C32.9746 9.98438 33.0273 9.62305 33.1328 9.2832C33.2422 8.93945 33.4004 8.63867 33.6074 8.38086C33.8184 8.11914 34.0781 7.91406 34.3867 7.76562C34.6953 7.61719 35.0488 7.54297 35.4473 7.54297C35.7715 7.54297 36.0605 7.58789 36.3145 7.67773C36.5723 7.76367 36.791 7.90039 36.9707 8.08789C37.1504 8.27539 37.2871 8.51953 37.3809 8.82031C37.4746 9.11719 37.5215 9.47656 37.5215 9.89844V14H36.1035V9.89258C36.1035 9.57227 36.0566 9.32422 35.9629 9.14844C35.873 8.97266 35.7441 8.85156 35.5762 8.78516C35.4082 8.71484 35.207 8.67969 34.9727 8.67969C34.7539 8.67969 34.5605 8.7207 34.3926 8.80273C34.2285 8.88086 34.0898 8.99219 33.9766 9.13672C33.8633 9.27734 33.7773 9.43945 33.7188 9.62305C33.6641 9.80664 33.6367 10.0059 33.6367 10.2207ZM42.5488 12.7285V9.70508C42.5488 9.47852 42.5078 9.2832 42.4258 9.11914C42.3438 8.95508 42.2188 8.82812 42.0508 8.73828C41.8867 8.64844 41.6797 8.60352 41.4297 8.60352C41.1992 8.60352 41 8.64258 40.832 8.7207C40.6641 8.79883 40.5332 8.9043 40.4395 9.03711C40.3457 9.16992 40.2988 9.32031 40.2988 9.48828H38.8926C38.8926 9.23828 38.9531 8.99609 39.0742 8.76172C39.1953 8.52734 39.3711 8.31836 39.6016 8.13477C39.832 7.95117 40.1074 7.80664 40.4277 7.70117C40.748 7.5957 41.1074 7.54297 41.5059 7.54297C41.9824 7.54297 42.4043 7.62305 42.7715 7.7832C43.1426 7.94336 43.4336 8.18555 43.6445 8.50977C43.8594 8.83008 43.9668 9.23242 43.9668 9.7168V12.5352C43.9668 12.8242 43.9863 13.084 44.0254 13.3145C44.0684 13.541 44.1289 13.7383 44.207 13.9062V14H42.7598C42.6934 13.8477 42.6406 13.6543 42.6016 13.4199C42.5664 13.1816 42.5488 12.9512 42.5488 12.7285ZM42.7539 10.1445L42.7656 11.0176H41.752C41.4902 11.0176 41.2598 11.043 41.0605 11.0938C40.8613 11.1406 40.6953 11.2109 40.5625 11.3047C40.4297 11.3984 40.3301 11.5117 40.2637 11.6445C40.1973 11.7773 40.1641 11.9277 40.1641 12.0957C40.1641 12.2637 40.2031 12.418 40.2812 12.5586C40.3594 12.6953 40.4727 12.8027 40.6211 12.8809C40.7734 12.959 40.957 12.998 41.1719 12.998C41.4609 12.998 41.7129 12.9395 41.9277 12.8223C42.1465 12.7012 42.3184 12.5547 42.4434 12.3828C42.5684 12.207 42.6348 12.041 42.6426 11.8848L43.0996 12.5117C43.0527 12.6719 42.9727 12.8438 42.8594 13.0273C42.7461 13.2109 42.5977 13.3867 42.4141 13.5547C42.2344 13.7188 42.0176 13.8535 41.7637 13.959C41.5137 14.0645 41.2246 14.1172 40.8965 14.1172C40.4824 14.1172 40.1133 14.0352 39.7891 13.8711C39.4648 13.7031 39.2109 13.4785 39.0273 13.1973C38.8438 12.9121 38.752 12.5898 38.752 12.2305C38.752 11.8945 38.8145 11.5977 38.9395 11.3398C39.0684 11.0781 39.2559 10.8594 39.502 10.6836C39.752 10.5078 40.0566 10.375 40.416 10.2852C40.7754 10.1914 41.1855 10.1445 41.6465 10.1445H42.7539ZM46.9551 5V14H45.5371V5H46.9551Z\" fill=\"").concat(colors.primary['8'], "\"/>\n<rect x=\"0.5\" y=\"0.5\" width=\"55\" height=\"19\" rx=\"9.5\" stroke=\"").concat(colors.primary['8'], "\" stroke-opacity=\"0.35\"/>\n</svg>"); };
var MANUAL_ICON = function (colors) { return "<svg width=\"56\" height=\"20\" viewBox=\"0 0 56 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<rect width=\"56\" height=\"20\" rx=\"10\" fill=\"".concat(colors.primary['0'], "\"/>\n<path d=\"M9.53711 5.46875H10.8496L13.3164 12.0488L15.7773 5.46875H17.0898L13.832 14H12.7891L9.53711 5.46875ZM8.93945 5.46875H10.1875L10.4043 11.1641V14H8.93945V5.46875ZM16.4395 5.46875H17.6934V14H16.2227V11.1641L16.4395 5.46875ZM22.873 12.7285V9.70508C22.873 9.47852 22.832 9.2832 22.75 9.11914C22.668 8.95508 22.543 8.82812 22.375 8.73828C22.2109 8.64844 22.0039 8.60352 21.7539 8.60352C21.5234 8.60352 21.3242 8.64258 21.1562 8.7207C20.9883 8.79883 20.8574 8.9043 20.7637 9.03711C20.6699 9.16992 20.623 9.32031 20.623 9.48828H19.2168C19.2168 9.23828 19.2773 8.99609 19.3984 8.76172C19.5195 8.52734 19.6953 8.31836 19.9258 8.13477C20.1562 7.95117 20.4316 7.80664 20.752 7.70117C21.0723 7.5957 21.4316 7.54297 21.8301 7.54297C22.3066 7.54297 22.7285 7.62305 23.0957 7.7832C23.4668 7.94336 23.7578 8.18555 23.9688 8.50977C24.1836 8.83008 24.291 9.23242 24.291 9.7168V12.5352C24.291 12.8242 24.3105 13.084 24.3496 13.3145C24.3926 13.541 24.4531 13.7383 24.5312 13.9062V14H23.084C23.0176 13.8477 22.9648 13.6543 22.9258 13.4199C22.8906 13.1816 22.873 12.9512 22.873 12.7285ZM23.0781 10.1445L23.0898 11.0176H22.0762C21.8145 11.0176 21.584 11.043 21.3848 11.0938C21.1855 11.1406 21.0195 11.2109 20.8867 11.3047C20.7539 11.3984 20.6543 11.5117 20.5879 11.6445C20.5215 11.7773 20.4883 11.9277 20.4883 12.0957C20.4883 12.2637 20.5273 12.418 20.6055 12.5586C20.6836 12.6953 20.7969 12.8027 20.9453 12.8809C21.0977 12.959 21.2812 12.998 21.4961 12.998C21.7852 12.998 22.0371 12.9395 22.252 12.8223C22.4707 12.7012 22.6426 12.5547 22.7676 12.3828C22.8926 12.207 22.959 12.041 22.9668 11.8848L23.4238 12.5117C23.377 12.6719 23.2969 12.8438 23.1836 13.0273C23.0703 13.2109 22.9219 13.3867 22.7383 13.5547C22.5586 13.7188 22.3418 13.8535 22.0879 13.959C21.8379 14.0645 21.5488 14.1172 21.2207 14.1172C20.8066 14.1172 20.4375 14.0352 20.1133 13.8711C19.7891 13.7031 19.5352 13.4785 19.3516 13.1973C19.168 12.9121 19.0762 12.5898 19.0762 12.2305C19.0762 11.8945 19.1387 11.5977 19.2637 11.3398C19.3926 11.0781 19.5801 10.8594 19.8262 10.6836C20.0762 10.5078 20.3809 10.375 20.7402 10.2852C21.0996 10.1914 21.5098 10.1445 21.9707 10.1445H23.0781ZM27.168 9.01367V14H25.7559V7.66016H27.0859L27.168 9.01367ZM26.916 10.5957L26.459 10.5898C26.4629 10.1406 26.5254 9.72852 26.6465 9.35352C26.7715 8.97852 26.9434 8.65625 27.1621 8.38672C27.3848 8.11719 27.6504 7.91016 27.959 7.76562C28.2676 7.61719 28.6113 7.54297 28.9902 7.54297C29.2949 7.54297 29.5703 7.58594 29.8164 7.67188C30.0664 7.75391 30.2793 7.88867 30.4551 8.07617C30.6348 8.26367 30.7715 8.50781 30.8652 8.80859C30.959 9.10547 31.0059 9.4707 31.0059 9.9043V14H29.5879V9.89844C29.5879 9.59375 29.543 9.35352 29.4531 9.17773C29.3672 8.99805 29.2402 8.87109 29.0723 8.79688C28.9082 8.71875 28.7031 8.67969 28.457 8.67969C28.2148 8.67969 27.998 8.73047 27.8066 8.83203C27.6152 8.93359 27.4531 9.07227 27.3203 9.24805C27.1914 9.42383 27.0918 9.62695 27.0215 9.85742C26.9512 10.0879 26.916 10.334 26.916 10.5957ZM36.2617 12.5059V7.66016H37.6797V14H36.3438L36.2617 12.5059ZM36.4609 11.1875L36.9355 11.1758C36.9355 11.6016 36.8887 11.9941 36.7949 12.3535C36.7012 12.709 36.5566 13.0195 36.3613 13.2852C36.166 13.5469 35.916 13.752 35.6113 13.9004C35.3066 14.0449 34.9414 14.1172 34.5156 14.1172C34.207 14.1172 33.9238 14.0723 33.666 13.9824C33.4082 13.8926 33.1855 13.7539 32.998 13.5664C32.8145 13.3789 32.6719 13.1348 32.5703 12.834C32.4688 12.5332 32.418 12.1738 32.418 11.7559V7.66016H33.8301V11.7676C33.8301 11.998 33.8574 12.1914 33.9121 12.3477C33.9668 12.5 34.041 12.623 34.1348 12.7168C34.2285 12.8105 34.3379 12.877 34.4629 12.916C34.5879 12.9551 34.7207 12.9746 34.8613 12.9746C35.2637 12.9746 35.5801 12.8965 35.8105 12.7402C36.0449 12.5801 36.2109 12.3652 36.3086 12.0957C36.4102 11.8262 36.4609 11.5234 36.4609 11.1875ZM42.7012 12.7285V9.70508C42.7012 9.47852 42.6602 9.2832 42.5781 9.11914C42.4961 8.95508 42.3711 8.82812 42.2031 8.73828C42.0391 8.64844 41.832 8.60352 41.582 8.60352C41.3516 8.60352 41.1523 8.64258 40.9844 8.7207C40.8164 8.79883 40.6855 8.9043 40.5918 9.03711C40.498 9.16992 40.4512 9.32031 40.4512 9.48828H39.0449C39.0449 9.23828 39.1055 8.99609 39.2266 8.76172C39.3477 8.52734 39.5234 8.31836 39.7539 8.13477C39.9844 7.95117 40.2598 7.80664 40.5801 7.70117C40.9004 7.5957 41.2598 7.54297 41.6582 7.54297C42.1348 7.54297 42.5566 7.62305 42.9238 7.7832C43.2949 7.94336 43.5859 8.18555 43.7969 8.50977C44.0117 8.83008 44.1191 9.23242 44.1191 9.7168V12.5352C44.1191 12.8242 44.1387 13.084 44.1777 13.3145C44.2207 13.541 44.2812 13.7383 44.3594 13.9062V14H42.9121C42.8457 13.8477 42.793 13.6543 42.7539 13.4199C42.7188 13.1816 42.7012 12.9512 42.7012 12.7285ZM42.9062 10.1445L42.918 11.0176H41.9043C41.6426 11.0176 41.4121 11.043 41.2129 11.0938C41.0137 11.1406 40.8477 11.2109 40.7148 11.3047C40.582 11.3984 40.4824 11.5117 40.416 11.6445C40.3496 11.7773 40.3164 11.9277 40.3164 12.0957C40.3164 12.2637 40.3555 12.418 40.4336 12.5586C40.5117 12.6953 40.625 12.8027 40.7734 12.8809C40.9258 12.959 41.1094 12.998 41.3242 12.998C41.6133 12.998 41.8652 12.9395 42.0801 12.8223C42.2988 12.7012 42.4707 12.5547 42.5957 12.3828C42.7207 12.207 42.7871 12.041 42.7949 11.8848L43.252 12.5117C43.2051 12.6719 43.125 12.8438 43.0117 13.0273C42.8984 13.2109 42.75 13.3867 42.5664 13.5547C42.3867 13.7188 42.1699 13.8535 41.916 13.959C41.666 14.0645 41.377 14.1172 41.0488 14.1172C40.6348 14.1172 40.2656 14.0352 39.9414 13.8711C39.6172 13.7031 39.3633 13.4785 39.1797 13.1973C38.9961 12.9121 38.9043 12.5898 38.9043 12.2305C38.9043 11.8945 38.9668 11.5977 39.0918 11.3398C39.2207 11.0781 39.4082 10.8594 39.6543 10.6836C39.9043 10.5078 40.209 10.375 40.5684 10.2852C40.9277 10.1914 41.3379 10.1445 41.7988 10.1445H42.9062ZM47.1074 5V14H45.6895V5H47.1074Z\" fill=\"").concat(colors.secondary['17'], "\"/>\n<rect x=\"0.5\" y=\"0.5\" width=\"55\" height=\"19\" rx=\"9.5\" stroke=\"").concat(colors.secondary['17'], "\" stroke-opacity=\"0.35\"/>\n</svg>"); };
var EVENT_ICON = function (colors) { return "<svg width=\"46\" height=\"20\" viewBox=\"0 0 46 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<rect width=\"46\" height=\"20\" rx=\"10\" fill=\"".concat(colors.primary['0'], "\"/>\n<path d=\"M14.6445 12.834V14H10.1152V12.834H14.6445ZM10.5312 5.46875V14H9.06055V5.46875H10.5312ZM14.0527 9.03125V10.1797H10.1152V9.03125H14.0527ZM14.6152 5.46875V6.64062H10.1152V5.46875H14.6152ZM17.6152 12.8809L19.168 7.66016H20.6328L18.4297 14H17.5156L17.6152 12.8809ZM16.4258 7.66016L18.0078 12.9043L18.084 14H17.1699L14.9551 7.66016H16.4258ZM24.2188 14.1172C23.75 14.1172 23.3262 14.041 22.9473 13.8887C22.5723 13.7324 22.252 13.5156 21.9863 13.2383C21.7246 12.9609 21.5234 12.6348 21.3828 12.2598C21.2422 11.8848 21.1719 11.4805 21.1719 11.0469V10.8125C21.1719 10.3164 21.2441 9.86719 21.3887 9.46484C21.5332 9.0625 21.7344 8.71875 21.9922 8.43359C22.25 8.14453 22.5547 7.92383 22.9062 7.77148C23.2578 7.61914 23.6387 7.54297 24.0488 7.54297C24.502 7.54297 24.8984 7.61914 25.2383 7.77148C25.5781 7.92383 25.8594 8.13867 26.082 8.41602C26.3086 8.68945 26.4766 9.01562 26.5859 9.39453C26.6992 9.77344 26.7559 10.1914 26.7559 10.6484V11.252H21.8574V10.2383H25.3613V10.127C25.3535 9.87305 25.3027 9.63477 25.209 9.41211C25.1191 9.18945 24.9805 9.00977 24.793 8.87305C24.6055 8.73633 24.3555 8.66797 24.043 8.66797C23.8086 8.66797 23.5996 8.71875 23.416 8.82031C23.2363 8.91797 23.0859 9.06055 22.9648 9.24805C22.8438 9.43555 22.75 9.66211 22.6836 9.92773C22.6211 10.1895 22.5898 10.4844 22.5898 10.8125V11.0469C22.5898 11.3242 22.627 11.582 22.7012 11.8203C22.7793 12.0547 22.8926 12.2598 23.041 12.4355C23.1895 12.6113 23.3691 12.75 23.5801 12.8516C23.791 12.9492 24.0312 12.998 24.3008 12.998C24.6406 12.998 24.9434 12.9297 25.209 12.793C25.4746 12.6562 25.7051 12.4629 25.9004 12.2129L26.6445 12.9336C26.5078 13.1328 26.3301 13.3242 26.1113 13.5078C25.8926 13.6875 25.625 13.834 25.3086 13.9473C24.9961 14.0605 24.6328 14.1172 24.2188 14.1172ZM29.2578 9.01367V14H27.8457V7.66016H29.1758L29.2578 9.01367ZM29.0059 10.5957L28.5488 10.5898C28.5527 10.1406 28.6152 9.72852 28.7363 9.35352C28.8613 8.97852 29.0332 8.65625 29.252 8.38672C29.4746 8.11719 29.7402 7.91016 30.0488 7.76562C30.3574 7.61719 30.7012 7.54297 31.0801 7.54297C31.3848 7.54297 31.6602 7.58594 31.9062 7.67188C32.1562 7.75391 32.3691 7.88867 32.5449 8.07617C32.7246 8.26367 32.8613 8.50781 32.9551 8.80859C33.0488 9.10547 33.0957 9.4707 33.0957 9.9043V14H31.6777V9.89844C31.6777 9.59375 31.6328 9.35352 31.543 9.17773C31.457 8.99805 31.3301 8.87109 31.1621 8.79688C30.998 8.71875 30.793 8.67969 30.5469 8.67969C30.3047 8.67969 30.0879 8.73047 29.8965 8.83203C29.7051 8.93359 29.543 9.07227 29.4102 9.24805C29.2812 9.42383 29.1816 9.62695 29.1113 9.85742C29.041 10.0879 29.0059 10.334 29.0059 10.5957ZM37.4434 7.66016V8.69141H33.8691V7.66016H37.4434ZM34.9004 6.10742H36.3125V12.248C36.3125 12.4434 36.3398 12.5938 36.3945 12.6992C36.4531 12.8008 36.5332 12.8691 36.6348 12.9043C36.7363 12.9395 36.8555 12.957 36.9922 12.957C37.0898 12.957 37.1836 12.9512 37.2734 12.9395C37.3633 12.9277 37.4355 12.916 37.4902 12.9043L37.4961 13.9824C37.3789 14.0176 37.2422 14.0488 37.0859 14.0762C36.9336 14.1035 36.7578 14.1172 36.5586 14.1172C36.2344 14.1172 35.9473 14.0605 35.6973 13.9473C35.4473 13.8301 35.252 13.6406 35.1113 13.3789C34.9707 13.1172 34.9004 12.7695 34.9004 12.3359V6.10742Z\" fill=\"").concat(colors.secondary['11'], "\"/>\n<rect x=\"0.5\" y=\"0.5\" width=\"45\" height=\"19\" rx=\"9.5\" stroke=\"").concat(colors.secondary['11'], "\" stroke-opacity=\"0.35\"/>\n</svg>"); };
var EVENT_AI_ICON = function (colors) { return "<svg width=\"50\" height=\"25\" viewBox=\"0 0 50 25\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<rect y=\"5\" width=\"46\" height=\"20\" rx=\"10\" fill=\"".concat(colors.primary['0'], "\"/>\n<path d=\"M14.6445 17.834V19H10.1152V17.834H14.6445ZM10.5312 10.4688V19H9.06055V10.4688H10.5312ZM14.0527 14.0312V15.1797H10.1152V14.0312H14.0527ZM14.6152 10.4688V11.6406H10.1152V10.4688H14.6152ZM17.6152 17.8809L19.168 12.6602H20.6328L18.4297 19H17.5156L17.6152 17.8809ZM16.4258 12.6602L18.0078 17.9043L18.084 19H17.1699L14.9551 12.6602H16.4258ZM24.2188 19.1172C23.75 19.1172 23.3262 19.041 22.9473 18.8887C22.5723 18.7324 22.252 18.5156 21.9863 18.2383C21.7246 17.9609 21.5234 17.6348 21.3828 17.2598C21.2422 16.8848 21.1719 16.4805 21.1719 16.0469V15.8125C21.1719 15.3164 21.2441 14.8672 21.3887 14.4648C21.5332 14.0625 21.7344 13.7188 21.9922 13.4336C22.25 13.1445 22.5547 12.9238 22.9062 12.7715C23.2578 12.6191 23.6387 12.543 24.0488 12.543C24.502 12.543 24.8984 12.6191 25.2383 12.7715C25.5781 12.9238 25.8594 13.1387 26.082 13.416C26.3086 13.6895 26.4766 14.0156 26.5859 14.3945C26.6992 14.7734 26.7559 15.1914 26.7559 15.6484V16.252H21.8574V15.2383H25.3613V15.127C25.3535 14.873 25.3027 14.6348 25.209 14.4121C25.1191 14.1895 24.9805 14.0098 24.793 13.873C24.6055 13.7363 24.3555 13.668 24.043 13.668C23.8086 13.668 23.5996 13.7188 23.416 13.8203C23.2363 13.918 23.0859 14.0605 22.9648 14.248C22.8438 14.4355 22.75 14.6621 22.6836 14.9277C22.6211 15.1895 22.5898 15.4844 22.5898 15.8125V16.0469C22.5898 16.3242 22.627 16.582 22.7012 16.8203C22.7793 17.0547 22.8926 17.2598 23.041 17.4355C23.1895 17.6113 23.3691 17.75 23.5801 17.8516C23.791 17.9492 24.0312 17.998 24.3008 17.998C24.6406 17.998 24.9434 17.9297 25.209 17.793C25.4746 17.6562 25.7051 17.4629 25.9004 17.2129L26.6445 17.9336C26.5078 18.1328 26.3301 18.3242 26.1113 18.5078C25.8926 18.6875 25.625 18.834 25.3086 18.9473C24.9961 19.0605 24.6328 19.1172 24.2188 19.1172ZM29.2578 14.0137V19H27.8457V12.6602H29.1758L29.2578 14.0137ZM29.0059 15.5957L28.5488 15.5898C28.5527 15.1406 28.6152 14.7285 28.7363 14.3535C28.8613 13.9785 29.0332 13.6562 29.252 13.3867C29.4746 13.1172 29.7402 12.9102 30.0488 12.7656C30.3574 12.6172 30.7012 12.543 31.0801 12.543C31.3848 12.543 31.6602 12.5859 31.9062 12.6719C32.1562 12.7539 32.3691 12.8887 32.5449 13.0762C32.7246 13.2637 32.8613 13.5078 32.9551 13.8086C33.0488 14.1055 33.0957 14.4707 33.0957 14.9043V19H31.6777V14.8984C31.6777 14.5938 31.6328 14.3535 31.543 14.1777C31.457 13.998 31.3301 13.8711 31.1621 13.7969C30.998 13.7188 30.793 13.6797 30.5469 13.6797C30.3047 13.6797 30.0879 13.7305 29.8965 13.832C29.7051 13.9336 29.543 14.0723 29.4102 14.248C29.2812 14.4238 29.1816 14.627 29.1113 14.8574C29.041 15.0879 29.0059 15.334 29.0059 15.5957ZM37.4434 12.6602V13.6914H33.8691V12.6602H37.4434ZM34.9004 11.1074H36.3125V17.248C36.3125 17.4434 36.3398 17.5938 36.3945 17.6992C36.4531 17.8008 36.5332 17.8691 36.6348 17.9043C36.7363 17.9395 36.8555 17.957 36.9922 17.957C37.0898 17.957 37.1836 17.9512 37.2734 17.9395C37.3633 17.9277 37.4355 17.916 37.4902 17.9043L37.4961 18.9824C37.3789 19.0176 37.2422 19.0488 37.0859 19.0762C36.9336 19.1035 36.7578 19.1172 36.5586 19.1172C36.2344 19.1172 35.9473 19.0605 35.6973 18.9473C35.4473 18.8301 35.252 18.6406 35.1113 18.3789C34.9707 18.1172 34.9004 17.7695 34.9004 17.3359V11.1074Z\" fill=\"").concat(colors.secondary['11'], "\"/>\n<path d=\"M43.925 9.66992H41.3362L40.8259 11.0073H39.51L42.0398 4.75H43.2375L45.7566 11.0073H44.4353L43.925 9.66992ZM41.7175 8.67627H43.5437L42.6306 6.30225L41.7175 8.67627Z\" fill=\"").concat(colors.primary['7'], "\"/>\n<path d=\"M47.8245 11.0073H46.5247V4.75H47.8245V11.0073Z\" fill=\"").concat(colors.primary['7'], "\"/>\n<path d=\"M43.925 9.66992H41.3362L40.8259 11.0073H39.51L42.0398 4.75H43.2375L45.7566 11.0073H44.4353L43.925 9.66992ZM41.7175 8.67627H43.5437L42.6306 6.30225L41.7175 8.67627Z\" stroke=\"").concat(colors.primary['0'], "\" stroke-width=\"4\" stroke-linejoin=\"round\"/>\n<path d=\"M47.8245 11.0073H46.5247V4.75H47.8245V11.0073Z\" stroke=\"").concat(colors.primary['0'], "\" stroke-width=\"4\" stroke-linejoin=\"round\"/>\n<path d=\"M47.2372 12.0073H47.8245H48.8245V11.0073V4.75V3.75H47.8245H46.5247H45.5247V4.75V7.75346L44.1652 4.37655L43.913 3.75H43.2375H42.7204L42.6306 3.51657L42.5408 3.75H42.0398H41.3655L41.1127 4.37518L38.5829 10.6325L38.0271 12.0073H39.51H40.8259H41.5147L41.7602 11.3638L42.025 10.6699H43.2363L43.501 11.3638L43.7465 12.0073H44.4353H45.5247H45.7566H46.5247H47.2372Z\" fill=\"").concat(colors.primary['7'], "\" stroke=\"white\" stroke-width=\"2\"/>\n<rect x=\"0.5\" y=\"5.5\" width=\"45\" height=\"19\" rx=\"9.5\" stroke=\"").concat(colors.secondary['11'], "\" stroke-opacity=\"0.35\"/>\n</svg>"); };
var PARKING_ICON = function (colors) { return "<svg width=\"58\" height=\"20\" viewBox=\"0 0 58 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<rect width=\"58\" height=\"20\" rx=\"10\" fill=\"".concat(colors.primary['0'], "\"/>\n<path d=\"M12.5527 10.8184H10.332V9.65234H12.5527C12.9395 9.65234 13.252 9.58984 13.4902 9.46484C13.7285 9.33984 13.9023 9.16797 14.0117 8.94922C14.125 8.72656 14.1816 8.47266 14.1816 8.1875C14.1816 7.91797 14.125 7.66602 14.0117 7.43164C13.9023 7.19336 13.7285 7.00195 13.4902 6.85742C13.252 6.71289 12.9395 6.64062 12.5527 6.64062H10.7832V14H9.3125V5.46875H12.5527C13.2129 5.46875 13.7734 5.58594 14.2344 5.82031C14.6992 6.05078 15.0527 6.37109 15.2949 6.78125C15.5371 7.1875 15.6582 7.65234 15.6582 8.17578C15.6582 8.72656 15.5371 9.19922 15.2949 9.59375C15.0527 9.98828 14.6992 10.291 14.2344 10.502C13.7734 10.7129 13.2129 10.8184 12.5527 10.8184ZM20.3398 12.7285V9.70508C20.3398 9.47852 20.2988 9.2832 20.2168 9.11914C20.1348 8.95508 20.0098 8.82812 19.8418 8.73828C19.6777 8.64844 19.4707 8.60352 19.2207 8.60352C18.9902 8.60352 18.791 8.64258 18.623 8.7207C18.4551 8.79883 18.3242 8.9043 18.2305 9.03711C18.1367 9.16992 18.0898 9.32031 18.0898 9.48828H16.6836C16.6836 9.23828 16.7441 8.99609 16.8652 8.76172C16.9863 8.52734 17.1621 8.31836 17.3926 8.13477C17.623 7.95117 17.8984 7.80664 18.2188 7.70117C18.5391 7.5957 18.8984 7.54297 19.2969 7.54297C19.7734 7.54297 20.1953 7.62305 20.5625 7.7832C20.9336 7.94336 21.2246 8.18555 21.4355 8.50977C21.6504 8.83008 21.7578 9.23242 21.7578 9.7168V12.5352C21.7578 12.8242 21.7773 13.084 21.8164 13.3145C21.8594 13.541 21.9199 13.7383 21.998 13.9062V14H20.5508C20.4844 13.8477 20.4316 13.6543 20.3926 13.4199C20.3574 13.1816 20.3398 12.9512 20.3398 12.7285ZM20.5449 10.1445L20.5566 11.0176H19.543C19.2812 11.0176 19.0508 11.043 18.8516 11.0938C18.6523 11.1406 18.4863 11.2109 18.3535 11.3047C18.2207 11.3984 18.1211 11.5117 18.0547 11.6445C17.9883 11.7773 17.9551 11.9277 17.9551 12.0957C17.9551 12.2637 17.9941 12.418 18.0723 12.5586C18.1504 12.6953 18.2637 12.8027 18.4121 12.8809C18.5645 12.959 18.748 12.998 18.9629 12.998C19.252 12.998 19.5039 12.9395 19.7188 12.8223C19.9375 12.7012 20.1094 12.5547 20.2344 12.3828C20.3594 12.207 20.4258 12.041 20.4336 11.8848L20.8906 12.5117C20.8438 12.6719 20.7637 12.8438 20.6504 13.0273C20.5371 13.2109 20.3887 13.3867 20.2051 13.5547C20.0254 13.7188 19.8086 13.8535 19.5547 13.959C19.3047 14.0645 19.0156 14.1172 18.6875 14.1172C18.2734 14.1172 17.9043 14.0352 17.5801 13.8711C17.2559 13.7031 17.002 13.4785 16.8184 13.1973C16.6348 12.9121 16.543 12.5898 16.543 12.2305C16.543 11.8945 16.6055 11.5977 16.7305 11.3398C16.8594 11.0781 17.0469 10.8594 17.293 10.6836C17.543 10.5078 17.8477 10.375 18.207 10.2852C18.5664 10.1914 18.9766 10.1445 19.4375 10.1445H20.5449ZM24.6523 8.86719V14H23.2402V7.66016H24.5879L24.6523 8.86719ZM26.5918 7.61914L26.5801 8.93164C26.4941 8.91602 26.4004 8.9043 26.2988 8.89648C26.2012 8.88867 26.1035 8.88477 26.0059 8.88477C25.7637 8.88477 25.5508 8.91992 25.3672 8.99023C25.1836 9.05664 25.0293 9.1543 24.9043 9.2832C24.7832 9.4082 24.6895 9.56055 24.623 9.74023C24.5566 9.91992 24.5176 10.1211 24.5059 10.3438L24.1836 10.3672C24.1836 9.96875 24.2227 9.59961 24.3008 9.25977C24.3789 8.91992 24.4961 8.62109 24.6523 8.36328C24.8125 8.10547 25.0117 7.9043 25.25 7.75977C25.4922 7.61523 25.7715 7.54297 26.0879 7.54297C26.1738 7.54297 26.2656 7.55078 26.3633 7.56641C26.4648 7.58203 26.541 7.59961 26.5918 7.61914ZM28.9004 5V14H27.4824V5H28.9004ZM32.8379 7.66016L30.0781 10.7188L28.5664 12.2656L28.1973 11.0703L29.3398 9.6582L31.1328 7.66016H32.8379ZM31.4375 14L29.3809 11.0234L30.2715 10.0332L33.0723 14H31.4375ZM35.2461 7.66016V14H33.8281V7.66016H35.2461ZM33.7344 5.99609C33.7344 5.78125 33.8047 5.60352 33.9453 5.46289C34.0898 5.31836 34.2891 5.24609 34.543 5.24609C34.793 5.24609 34.9902 5.31836 35.1348 5.46289C35.2793 5.60352 35.3516 5.78125 35.3516 5.99609C35.3516 6.20703 35.2793 6.38281 35.1348 6.52344C34.9902 6.66406 34.793 6.73438 34.543 6.73438C34.2891 6.73438 34.0898 6.66406 33.9453 6.52344C33.8047 6.38281 33.7344 6.20703 33.7344 5.99609ZM38.1934 9.01367V14H36.7812V7.66016H38.1113L38.1934 9.01367ZM37.9414 10.5957L37.4844 10.5898C37.4883 10.1406 37.5508 9.72852 37.6719 9.35352C37.7969 8.97852 37.9688 8.65625 38.1875 8.38672C38.4102 8.11719 38.6758 7.91016 38.9844 7.76562C39.293 7.61719 39.6367 7.54297 40.0156 7.54297C40.3203 7.54297 40.5957 7.58594 40.8418 7.67188C41.0918 7.75391 41.3047 7.88867 41.4805 8.07617C41.6602 8.26367 41.7969 8.50781 41.8906 8.80859C41.9844 9.10547 42.0312 9.4707 42.0312 9.9043V14H40.6133V9.89844C40.6133 9.59375 40.5684 9.35352 40.4785 9.17773C40.3926 8.99805 40.2656 8.87109 40.0977 8.79688C39.9336 8.71875 39.7285 8.67969 39.4824 8.67969C39.2402 8.67969 39.0234 8.73047 38.832 8.83203C38.6406 8.93359 38.4785 9.07227 38.3457 9.24805C38.2168 9.42383 38.1172 9.62695 38.0469 9.85742C37.9766 10.0879 37.9414 10.334 37.9414 10.5957ZM47.5332 7.66016H48.8164V13.8242C48.8164 14.3945 48.6953 14.8789 48.4531 15.2773C48.2109 15.6758 47.873 15.9785 47.4395 16.1855C47.0059 16.3965 46.5039 16.502 45.9336 16.502C45.6914 16.502 45.4219 16.4668 45.125 16.3965C44.832 16.3262 44.5469 16.2129 44.2695 16.0566C43.9961 15.9043 43.7676 15.7031 43.584 15.4531L44.2461 14.6211C44.4727 14.8906 44.7227 15.0879 44.9961 15.2129C45.2695 15.3379 45.5566 15.4004 45.8574 15.4004C46.1816 15.4004 46.457 15.3398 46.6836 15.2188C46.9141 15.1016 47.0918 14.9277 47.2168 14.6973C47.3418 14.4668 47.4043 14.1855 47.4043 13.8535V9.0957L47.5332 7.66016ZM43.2266 10.9004V10.7773C43.2266 10.2969 43.2852 9.85938 43.4023 9.46484C43.5195 9.06641 43.6875 8.72461 43.9062 8.43945C44.125 8.15039 44.3906 7.92969 44.7031 7.77734C45.0156 7.62109 45.3691 7.54297 45.7637 7.54297C46.1738 7.54297 46.5234 7.61719 46.8125 7.76562C47.1055 7.91406 47.3496 8.12695 47.5449 8.4043C47.7402 8.67773 47.8926 9.00586 48.002 9.38867C48.1152 9.76758 48.1992 10.1895 48.2539 10.6543V11.0469C48.2031 11.5 48.1172 11.9141 47.9961 12.2891C47.875 12.6641 47.7148 12.9883 47.5156 13.2617C47.3164 13.5352 47.0703 13.7461 46.7773 13.8945C46.4883 14.043 46.1465 14.1172 45.752 14.1172C45.3652 14.1172 45.0156 14.0371 44.7031 13.877C44.3945 13.7168 44.1289 13.4922 43.9062 13.2031C43.6875 12.9141 43.5195 12.5742 43.4023 12.1836C43.2852 11.7891 43.2266 11.3613 43.2266 10.9004ZM44.6387 10.7773V10.9004C44.6387 11.1895 44.666 11.459 44.7207 11.709C44.7793 11.959 44.8672 12.1797 44.9844 12.3711C45.1055 12.5586 45.2578 12.707 45.4414 12.8164C45.6289 12.9219 45.8496 12.9746 46.1035 12.9746C46.4355 12.9746 46.707 12.9043 46.918 12.7637C47.1328 12.623 47.2969 12.4336 47.4102 12.1953C47.5273 11.9531 47.6094 11.6836 47.6562 11.3867V10.3262C47.6328 10.0957 47.584 9.88086 47.5098 9.68164C47.4395 9.48242 47.3438 9.30859 47.2227 9.16016C47.1016 9.00781 46.9492 8.89062 46.7656 8.80859C46.582 8.72266 46.3652 8.67969 46.1152 8.67969C45.8613 8.67969 45.6406 8.73438 45.4531 8.84375C45.2656 8.95312 45.1113 9.10352 44.9902 9.29492C44.873 9.48633 44.7852 9.70898 44.7266 9.96289C44.668 10.2168 44.6387 10.4883 44.6387 10.7773Z\" fill=\"").concat(colors.primary['2'], "\"/>\n<rect x=\"0.5\" y=\"0.5\" width=\"57\" height=\"19\" rx=\"9.5\" stroke=\"").concat(colors.primary['2'], "\" stroke-opacity=\"0.35\"/>\n</svg>"); };
var makeGPSTrackingInfoItem = function (map, track, t, options) {
    var _a;
    var c = (_a = options === null || options === void 0 ? void 0 : options.colors) !== null && _a !== void 0 ? _a : LightColors;
    var eventString = '';
    if (track.mode === 'E' || track.mode === 'S') {
        // if (parkingMode) {
        //   eventString = "Parking impact";
        // } else {
        //   eventString = MCODE_TO_TEXT[data.mtype];
        // }
        eventString = MCODE_TO_TEXT[track.mtype];
    }
    var isAI = (track.mtype >= 6 && track.mtype <= 12) || track.mtype === 17;
    var iconMarkup = NORMAL_ICON(c);
    if (track.mode === 'M') {
        iconMarkup = MANUAL_ICON(c);
    }
    if (track.mode === 'P') {
        iconMarkup = PARKING_ICON(c);
    }
    if (track.mode === 'E' || track.mode === 'S') {
        if (isAI) {
            iconMarkup = EVENT_AI_ICON(c);
        }
        else {
            iconMarkup = EVENT_ICON(c);
        }
    }
    //@ts-ignore
    var loc = typeof track.loc === 'string' ? JSON.parse(track.loc) : track.loc;
    var playable = track.front_playable || track.rear_playable || track.sub3_playable;
    var thumbnail = track.thm;
    var thumbDiv;
    if (_.isEmpty(thumbnail)) {
        thumbnail = undefined;
    }
    else if (!playable) {
        thumbnail = undefined;
    }
    var speedText = (options === null || options === void 0 ? void 0 : options.speedUnit) === '0'
        ? "".concat(Math.floor(track.avg_speed * 1.852), " km/h")
        : "".concat(Math.floor(track.avg_speed * 1.150779), " MPH");
    var infoDivTextCSS = "  \n  /* Latin, Cyrillic/Caption */\n  \n  font-family: 'Roboto';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 16px;\n  /* identical to box height, or 133% */  \n  \n  /* Light mode/#68686E \u2027 2 */  \n  color: #68686E;  \n  ";
    var contentDivCss = "\n  box-sizing: border-box;  \n  /* Auto layout */  \n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  padding: 8px 16px;\n  gap: 8px;";
    var contentDiv = document.createElement('div');
    contentDiv.setAttribute('style', contentDivCss);
    var titleCSS = "/* Auto layout */\n\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  justify-content: space-between;\n  padding: 0px;\n  gap: 8px;\n  \n  width: 268px;\n  height: 16px;\n  \n  \n  /* Inside auto layout */\n  \n  flex: none;\n  order: 0;\n  align-self: stretch;\n  flex-grow: 0;";
    // console.log(
    //   moment(((track.vdate as unknown) as number) * 1000).format(
    //     "MMM DD YYYY, HH:mm:ss"
    //   )
    // );
    var titleDiv = document.createElement('div');
    titleDiv.setAttribute('style', "".concat(titleCSS, " ").concat(infoDivTextCSS));
    titleDiv.style.color = '#13131C';
    titleDiv.innerHTML = "\n    <div>".concat(moment(track.vdate * 1000)
        .utc()
        .format('YYYY-MM-DD h:mm:ss A'), "</div>\n    <div>").concat(speedText, "</div>");
    var itemDivCSS = "/* Auto layout */\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  padding: 0px;\n  gap: 8px;\n  \n  width: 268px;\n  \n  /* Inside auto layout */\n  \n  flex: none;\n  order: 1;\n  align-self: stretch;\n  flex-grow: 0;";
    var itemDiv = document.createElement('div');
    itemDiv.setAttribute('style', itemDivCSS);
    var thumbDivCSS = "/* media */\n  width: 80px;\n  height: 80px;\n  \n  /* Light mode/#13131C \u2027 1  \n  Body text, toasts, tooltips, icons\n  */\n  background: #13131C;\n  \n  /* Inside auto layout */  \n  flex: none;\n  order: 0;\n  flex-grow: 0;";
    if (track.mode === 'E' || track.mode === 'M') {
        thumbDiv = document.createElement('div');
        thumbDiv.setAttribute('style', thumbDivCSS);
        thumbDiv.style.position = 'relative';
        var thumbImg = "<svg focusable=\"false\" viewBox=\"0 0 80 80\" aria-hidden=\"true\" fill=\"none\" preserveAspectRatio=\"none\" style=\"color: rgba(0, 0, 0, 0.87);\n    box-sizing: inherit;\n    fill: currentColor;\n    display: inline-block;\n    font-size: 1.5rem;\n\n    width: 80px;\n    height: 80px;\">\n    <rect x=\"0.5\" y=\"0.5\" width=\"79\" height=\"79\" fill=\"white\" stroke=\"#D0EBF9\"></rect>\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M56.9259 21.4C56.4074 19.9455 55 19 53.3333 19H26.7037C25 19 23.6296 19.9455 23.0741 21.4L19.9688 30.1628H16.8519C15.8291 30.1628 15 30.9957 15 32.0233V32.9535C15 33.981 15.8291 34.814 16.8519 34.814H17.4816L15.9259 36.3455V56.2093C15.9259 57.5911 17.1111 59 18.5185 59H20.8148C22.2222 59 23.3333 57.6182 23.3333 56.2364V51.5581H56.6667V56.2364C56.6667 57.6182 57.8148 59 59.2222 59H61.4815C62.8889 59 64.0741 57.5911 64.0741 56.2093V36.3455L62.5184 34.814H63.1481C64.1709 34.814 65 33.981 65 32.9535V32.0233C65 30.9957 64.1709 30.1628 63.1481 30.1628H60.0312L56.9259 21.4ZM26.7037 22.6364H53.3333L57.1481 33.5455H22.8889L26.7037 22.6364ZM25.1852 44.4545C23.1481 44.4545 21.4815 42.8182 21.4815 40.8182C21.4815 38.8182 23.1481 37.1818 25.1852 37.1818C27.2222 37.1818 28.8889 38.8182 28.8889 40.8182C28.8889 42.8182 27.2222 44.4545 25.1852 44.4545ZM54.8148 44.4545C52.7778 44.4545 51.1111 42.8182 51.1111 40.8182C51.1111 38.8182 52.7778 37.1818 54.8148 37.1818C56.8519 37.1818 58.5185 38.8182 58.5185 40.8182C58.5185 42.8182 56.8519 44.4545 54.8148 44.4545Z\" fill=\"#D0EBF9\"></path>\n    <path d=\"M14 59L0 74\" stroke=\"#D0EBF9\" stroke-linejoin=\"round\"></path>\n    <path d=\"M66 59L80 74\" stroke=\"#D0EBF9\" stroke-linejoin=\"round\"></path>\n  </svg>";
        if (thumbnail) {
            thumbImg = "<img src=\"".concat(thumbnail, "\" alt=\"Thumbnail Image\" style=\"width: 100%; height: 100%;\">");
        }
        thumbDiv.innerHTML = thumbImg;
    }
    if (playable) {
        var thumbPlayBtnCSS = "position: absolute;\n    width: 36px;\n    height: 36px;\n    left: calc(50% - 36px/2);\n    top: calc(50% - 36px/2);\n  \n    border-radius:50%;\n    \n    background: rgba(19, 19, 28, 0.45);\n    \n    display:flex;\n    align-items:center;\n    justify-content:center;\n    ";
        var thumbPlayBtn_1 = document.createElement('div');
        thumbPlayBtn_1.setAttribute('style', thumbPlayBtnCSS);
        thumbPlayBtn_1.style.fill = 'white';
        thumbPlayBtn_1.style.cursor = 'pointer';
        thumbPlayBtn_1.innerHTML = "<svg width=\"17\" height=\"20\" viewBox=\"0 0 17 20\"  xmlns=\"http://www.w3.org/2000/svg\">\n    <g filter=\"url(#filter0_ddd_353_3753)\">\n    <path d=\"M3.01562 3.01562L13.9844 10L3.01562 16.9844V3.01562Z\" />\n    </g>\n    <defs>\n    <filter id=\"filter0_ddd_353_3753\" x=\"0.015625\" y=\"0.015625\" width=\"16.9688\" height=\"19.9688\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\">\n    <feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"/>\n    <feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\"/>\n    <feOffset/>\n    <feGaussianBlur stdDeviation=\"1.5\"/>\n    <feColorMatrix type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0\"/>\n    <feBlend mode=\"normal\" in2=\"BackgroundImageFix\" result=\"effect1_dropShadow_353_3753\"/>\n    <feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\"/>\n    <feOffset dy=\"1\"/>\n    <feGaussianBlur stdDeviation=\"0.5\"/>\n    <feColorMatrix type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0\"/>\n    <feBlend mode=\"normal\" in2=\"effect1_dropShadow_353_3753\" result=\"effect2_dropShadow_353_3753\"/>\n    <feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\"/>\n    <feOffset/>\n    <feGaussianBlur stdDeviation=\"0.5\"/>\n    <feColorMatrix type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0\"/>\n    <feBlend mode=\"normal\" in2=\"effect2_dropShadow_353_3753\" result=\"effect3_dropShadow_353_3753\"/>\n    <feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"effect3_dropShadow_353_3753\" result=\"shape\"/>\n    </filter>\n    </defs>\n    </svg>\n    ";
        // 웹에서 마커 팝업 썸네일 클릭시 비디오모달 출력 (Leehj)
        thumbPlayBtn_1.addEventListener('click', function () {
            var _a;
            (_a = options === null || options === void 0 ? void 0 : options.onPlay) === null || _a === void 0 ? void 0 : _a.call(options, track);
        });
        thumbPlayBtn_1.addEventListener('mouseover', function () {
            thumbPlayBtn_1.style.fill = '#13131C';
        });
        thumbPlayBtn_1.addEventListener('mouseout', function () {
            thumbPlayBtn_1.style.fill = 'white';
        });
        if (thumbDiv)
            thumbDiv.appendChild(thumbPlayBtn_1);
    }
    var infoDivCss = "display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  padding: 0px;\n  gap: 4px;\n  \n  \n  \n  /* Inside auto layout */\n  \n  flex: none;\n  order: 1;\n  flex-grow: 1;";
    var infoDiv = document.createElement('div');
    infoDiv.setAttribute('style', infoDivCss);
    var info1DivCSS = "display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0px;\n  gap: 16px;\n  \n  \n  /* Inside auto layout */\n  \n  flex: none;\n  order: 0;\n  align-self: stretch;\n  flex-grow: 0;";
    var infoDiv1 = document.createElement('div');
    infoDiv1.setAttribute('style', info1DivCSS);
    infoDiv1.innerHTML = "".concat(iconMarkup);
    var btnDivCss = "display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  align-items: center;\n  padding: 0px;\n  gap: 16px;\n\n  height:20px;\n  \n  \n  /* Inside auto layout */\n  \n  flex: none;\n  order: 1;\n  flex-grow: 1;";
    var btnDiv = document.createElement('div');
    btnDiv.setAttribute('style', btnDivCss);
    var tooltipCSS = "display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 4px 8px;\n  gap: 10px;\n  \n  position: absolute;\n  top: -24px;\n  left:50%;\n  transform: translate(-50%, 0);\n\n  visibility: hidden;\n  \n  /* Light mode/#13131C \u2027 1\n  \n  Body text, toasts, tooltips, icons\n  */\n  background: #13131C;\n  /* Shadow 2 \u2027 Small UI elements */\n  \n  box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.14), 0px 1px 1px rgba(0, 0, 0, 0.12), 0px 0px 3px rgba(0, 0, 0, 0.2);\n  border-radius: 4px;\n  \n  /* Latin, Cyrillic/Caption */\n\n  font-family: 'Roboto';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 16px;\n  /* identical to box height, or 133% */\n\n\n  /* Light mode/#FFFFFF \u2027 0 */\n\n  color: #FFFFFF;\n\n  white-space: nowrap;\n\n  ";
    var downloadBtnDiv = document.createElement('div');
    var downloadTooltip = document.createElement('div');
    downloadTooltip.setAttribute('style', tooltipCSS);
    downloadTooltip.innerHTML = t('Download');
    downloadBtnDiv.addEventListener('click', function () {
        var _a;
        (_a = options === null || options === void 0 ? void 0 : options.onDownload) === null || _a === void 0 ? void 0 : _a.call(options, track);
    });
    downloadBtnDiv.addEventListener('mouseover', function () {
        downloadBtnDiv.style.fill = '#13131C';
        downloadTooltip.style.visibility = 'visible';
    });
    downloadBtnDiv.addEventListener('mouseout', function () {
        downloadBtnDiv.style.fill = '#7E7E83';
        downloadTooltip.style.visibility = 'hidden';
    });
    downloadBtnDiv.style.cursor = 'pointer';
    downloadBtnDiv.style.fill = '#7E7E83';
    downloadBtnDiv.style.position = 'relative';
    downloadBtnDiv.innerHTML = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\"  xmlns=\"http://www.w3.org/2000/svg\" style=\"display:block\">\n  <g clip-path=\"url(#clip0_353_3761)\">\n  <path d=\"M12.9844 12.6562L15.6094 10.0781L17.0156 11.4844L12 16.5L6.98438 11.4844L8.39062 10.0781L11.0156 12.6562V3H12.9844V12.6562ZM18.9844 12H21V18.9844C21 19.5156 20.7969 19.9844 20.3906 20.3906C19.9844 20.7969 19.5156 21 18.9844 21H5.01562C4.48438 21 4.01562 20.7969 3.60938 20.3906C3.20312 19.9844 3 19.5156 3 18.9844V12H5.01562V18.9844H18.9844V12Z\" />\n  </g>\n  <defs>\n  <clipPath id=\"clip0_353_3761\">\n  <rect width=\"24\" height=\"24\" fill=\"white\"/>\n  </clipPath>\n  </defs>\n  </svg>\n  ";
    downloadBtnDiv.appendChild(downloadTooltip);
    var zoomInBtn = document.createElement('div');
    var zoomInTooltip = document.createElement('div');
    zoomInTooltip.setAttribute('style', tooltipCSS);
    zoomInTooltip.innerHTML = t('Zoom in');
    zoomInBtn.addEventListener('click', function () {
        var zoom = map.getZoom();
        var flyTo = {
            center: loc,
        };
        if (zoom < 17) {
            flyTo = {
                center: loc,
                zoom: 17,
            };
        }
        map.flyTo(flyTo);
    });
    zoomInBtn.addEventListener('mouseover', function () {
        zoomInBtn.style.fill = '#13131C';
        zoomInTooltip.style.visibility = 'visible';
    });
    zoomInBtn.addEventListener('mouseout', function () {
        zoomInBtn.style.fill = '#7E7E83';
        zoomInTooltip.style.visibility = 'hidden';
    });
    zoomInBtn.style.cursor = 'pointer';
    zoomInBtn.style.fill = '#7E7E83';
    zoomInBtn.style.position = 'relative';
    zoomInBtn.innerHTML = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" style=\"display:block\">\n  <g clip-path=\"url(#clip0_353_3766)\">\n  <path d=\"M6.32812 17.6719C7.92188 19.2344 9.8125 20.0156 12 20.0156C14.1875 20.0156 16.0625 19.2344 17.625 17.6719C19.2188 16.0781 20.0156 14.1875 20.0156 12C20.0156 9.8125 19.2188 7.9375 17.625 6.375C16.0625 4.78125 14.1875 3.98438 12 3.98438C9.8125 3.98438 7.92188 4.78125 6.32812 6.375C4.76562 7.9375 3.98438 9.8125 3.98438 12C3.98438 14.1875 4.76562 16.0781 6.32812 17.6719ZM4.92188 4.96875C6.89062 3 9.25 2.01562 12 2.01562C14.75 2.01562 17.0938 3 19.0312 4.96875C21 6.90625 21.9844 9.25 21.9844 12V20.0156C21.9844 20.5469 21.7812 21.0156 21.375 21.4219C21 21.7969 20.5469 21.9844 20.0156 21.9844H12C9.25 21.9844 6.89062 21.0156 4.92188 19.0781C2.98438 17.1094 2.01562 14.75 2.01562 12C2.01562 9.25 2.98438 6.90625 4.92188 4.96875ZM12.9844 6.98438V11.0156H17.0156V12.9844H12.9844V17.0156H11.0156V12.9844H6.98438V11.0156H11.0156V6.98438H12.9844Z\"/>\n  </g>\n  <defs>\n  <clipPath id=\"clip0_353_3766\">\n  <rect width=\"24\" height=\"24\" fill=\"white\"/>\n  </clipPath>\n  </defs>\n  </svg> \n  ";
    zoomInBtn.appendChild(zoomInTooltip);
    if (playable) {
        btnDiv.appendChild(downloadBtnDiv);
    }
    btnDiv.appendChild(zoomInBtn);
    infoDiv1.appendChild(btnDiv);
    var infoDiv11 = document.createElement('div');
    infoDiv11.setAttribute('style', infoDivTextCSS);
    infoDiv11.style.color = '#13131C';
    infoDiv11.innerHTML = "".concat(t(eventString));
    var infoDiv2 = document.createElement('div');
    infoDiv2.setAttribute('style', infoDivTextCSS);
    if (track.mode !== 'S')
        infoDiv2.innerHTML = "".concat(t('Altitude :'), " ").concat(track.alt, "m"); // Speed Alert 아니면 추가 (hongcs 24.06.11)
    var infoDiv3 = document.createElement('div');
    infoDiv3.setAttribute('style', infoDivTextCSS);
    infoDiv3.innerHTML = "".concat(loc[1].toFixed(6), ", ").concat(loc[0].toFixed(6)); // 소수점 6자리까지
    infoDiv.appendChild(infoDiv1);
    infoDiv.appendChild(infoDiv11);
    infoDiv.appendChild(infoDiv2);
    infoDiv.appendChild(infoDiv3);
    if (thumbDiv) {
        itemDiv.appendChild(thumbDiv);
    }
    itemDiv.appendChild(infoDiv);
    contentDiv.appendChild(titleDiv);
    contentDiv.appendChild(itemDiv);
    return contentDiv;
};
var makeAppGPSTrackingInfoItem = function (map, track, t, options) {
    var _a;
    var c = (_a = options === null || options === void 0 ? void 0 : options.colors) !== null && _a !== void 0 ? _a : LightColors;
    var eventString = '';
    if (track.mode === 'E' || track.mode === 'S') {
        // if (parkingMode) {
        //   eventString = "Parking impact";
        // } else {
        //   eventString = MCODE_TO_TEXT[data.mtype];
        // }
        eventString = MCODE_TO_TEXT[track.mtype];
    }
    var isAI = (track.mtype >= 6 && track.mtype <= 12) || track.mtype === 17;
    var iconMarkup = NORMAL_ICON(c);
    if (track.mode === 'M') {
        iconMarkup = MANUAL_ICON(c);
    }
    if (track.mode === 'P') {
        iconMarkup = PARKING_ICON(c);
    }
    if (track.mode === 'E' || track.mode === 'S') {
        if (isAI) {
            iconMarkup = EVENT_AI_ICON(c);
        }
        else {
            iconMarkup = EVENT_ICON(c);
        }
    }
    //@ts-ignore
    var loc = typeof track.loc === 'string' ? JSON.parse(track.loc) : track.loc;
    var playable = track.front_playable || track.rear_playable || track.sub3_playable;
    var thumbnail = track.thm;
    var thumbDiv;
    if (_.isEmpty(thumbnail)) {
        thumbnail = undefined;
    }
    else if (!playable) {
        thumbnail = undefined;
    }
    // Speed 이벤트 예외 처리
    var speedText = (options === null || options === void 0 ? void 0 : options.speedUnit) === '0'
        ? "".concat(track.mode === 'J' || track.mtype === 1
            ? Math.floor(track.speed * 1.852)
            : Math.floor(track.avg_speed * 1.852), " km/h")
        : "".concat(track.mode === 'J' || track.mtype === 1
            ? Math.floor(track.speed * 1.150779)
            : Math.floor(track.avg_speed * 1.150779), " MPH");
    var infoDivTextCSS = "  \n  /* Latin, Cyrillic/Caption */\n  \n  font-family: 'Roboto';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 16px;\n  /* identical to box height, or 133% */  \n  \n  /* Light mode/#68686E \u2027 2 */  \n  color: ".concat(c.primary['2'], ";  \n  ");
    var infoDivEventTextCSS = "  \n  /* Latin, Cyrillic/Caption */\n  \n  font-family: 'Roboto';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 16px;\n  /* identical to box height, or 133% */  \n  \n  /* Light mode/#68686E \u2027 2 */  \n  color: ".concat(c.primary['2'], ";  \n  ");
    var titleTextCSS = "  \n  /* Latin, Cyrillic/Caption */\n  \n  font-family: 'Roboto';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 16px;\n  /* identical to box height, or 133% */  \n  \n  /* Light mode/#68686E \u2027 2 */  \n  color: ".concat(c.primary['2'], ";  \n  ");
    var contentDivCss = "\n  box-sizing: border-box;  \n  /* Auto layout */  \n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  padding: ".concat(thumbnail ? '18px 16px 10px 12px' : '18px 11px 10px 12px', ";\n  gap: 8px;");
    var contentDiv = document.createElement('div');
    contentDiv.setAttribute('style', contentDivCss);
    var titleCSS = "/* Auto layout */\n\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  padding: 0px;\n\n  align-items : center;\n  height: 16px;\n  margin-bottom: 4px;\n  justify-content: space-between;\n  \n  \n  /* Inside auto layout */\n  \n  flex: none;\n  order: 0;\n  align-self: stretch;\n  flex-grow: 0;";
    var infoDivCss = "display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  padding: 0px;\n  \n  \n  \n  /* Inside auto layout */\n  \n  flex: none;\n  order: 1;\n  flex-grow: 1;";
    var infoDiv = document.createElement('div');
    infoDiv.setAttribute('style', infoDivCss);
    var info1DivCSS = "display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0px;\n  gap: 16px;\n  \n  \n  /* Inside auto layout */\n  \n  flex: none;\n  order: 0;\n  align-self: stretch;\n  flex-grow: 0;";
    var infoDiv1 = document.createElement('div');
    infoDiv1.setAttribute('style', info1DivCSS);
    var btnDivCss = "display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  align-items: center;\n  padding: 0px;\n  gap: 16px;\n  margin-right: ".concat(thumbnail ? '0px' : '5px', ";\n\n  height:20px;\n  \n  \n  /* Inside auto layout */\n  \n  flex: none;\n  order: 1;\n  flex-grow: 1;");
    var btnDiv = document.createElement('div');
    btnDiv.setAttribute('style', btnDivCss);
    var tooltipCSS = "display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 4px 8px;\n  gap: 10px;\n  \n  position: absolute;\n  top: -24px;\n  left:50%;\n  transform: translate(-50%, 0);\n\n  visibility: hidden;\n  \n  /* Light mode/#13131C \u2027 1\n  \n  Body text, toasts, tooltips, icons\n  */\n  background: ".concat(c.primary['1'], ";\n  /* Shadow 2 \u2027 Small UI elements */\n  \n  box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.14), 0px 1px 1px rgba(0, 0, 0, 0.12), 0px 0px 3px rgba(0, 0, 0, 0.2);\n  border-radius: 4px;\n  \n  /* Latin, Cyrillic/Caption */\n\n  font-family: 'Roboto';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 16px;\n  /* identical to box height, or 133% */\n\n\n  /* Light mode/#FFFFFF \u2027 0 */\n\n  color: ").concat(c.primary['0'], ";\n\n  white-space: nowrap;\n\n  ");
    var downloadBtnDiv = document.createElement('div');
    var downloadTooltip = document.createElement('div');
    downloadTooltip.setAttribute('style', tooltipCSS);
    downloadTooltip.innerHTML = t('Download');
    downloadBtnDiv.addEventListener('click', function () {
        var _a;
        (_a = options === null || options === void 0 ? void 0 : options.onDownload) === null || _a === void 0 ? void 0 : _a.call(options, track);
    });
    downloadBtnDiv.addEventListener('mouseover', function () {
        downloadBtnDiv.style.fill = c.primary['1'];
        downloadTooltip.style.visibility = 'visible';
    });
    downloadBtnDiv.addEventListener('mouseout', function () {
        downloadBtnDiv.style.fill = c.primary['3'];
        downloadTooltip.style.visibility = 'hidden';
    });
    downloadBtnDiv.style.cursor = 'pointer';
    downloadBtnDiv.style.fill = c.primary['3'];
    downloadBtnDiv.style.position = 'relative';
    downloadBtnDiv.innerHTML = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\"  xmlns=\"http://www.w3.org/2000/svg\" style=\"display:block\">\n  <g clip-path=\"url(#clip0_353_3761)\">\n  <path d=\"M12.9844 12.6562L15.6094 10.0781L17.0156 11.4844L12 16.5L6.98438 11.4844L8.39062 10.0781L11.0156 12.6562V3H12.9844V12.6562ZM18.9844 12H21V18.9844C21 19.5156 20.7969 19.9844 20.3906 20.3906C19.9844 20.7969 19.5156 21 18.9844 21H5.01562C4.48438 21 4.01562 20.7969 3.60938 20.3906C3.20312 19.9844 3 19.5156 3 18.9844V12H5.01562V18.9844H18.9844V12Z\" />\n  </g>\n  <defs>\n  <clipPath id=\"clip0_353_3761\">\n  <rect width=\"24\" height=\"24\" fill=\"white\"/>\n  </clipPath>\n  </defs>\n  </svg>\n  ";
    downloadBtnDiv.appendChild(downloadTooltip);
    var zoomInBtn = document.createElement('div');
    var zoomInTooltip = document.createElement('div');
    zoomInTooltip.setAttribute('style', tooltipCSS);
    zoomInTooltip.innerHTML = t('Zoom in');
    zoomInBtn.addEventListener('click', function () {
        var zoom = map.getZoom();
        var flyTo = {
            center: { lat: loc[1], lng: loc[0] },
            zoom: zoom < 17 ? 17 : zoom,
        };
        // console.log("MapboxGPSTrackingMap", "zoomIn", flyTo);
        map.flyTo(flyTo);
    });
    zoomInBtn.addEventListener('mouseover', function () {
        zoomInBtn.style.fill = c.primary['1'];
        zoomInTooltip.style.visibility = 'visible';
    });
    zoomInBtn.addEventListener('mouseout', function () {
        zoomInBtn.style.fill = c.primary['3'];
        zoomInTooltip.style.visibility = 'hidden';
    });
    zoomInBtn.style.cursor = 'pointer';
    zoomInBtn.style.fill = c.primary['3'];
    zoomInBtn.style.position = 'relative';
    zoomInBtn.innerHTML = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" style=\"display:block\">\n  <g clip-path=\"url(#clip0_353_3766)\">\n  <path d=\"M6.32812 17.6719C7.92188 19.2344 9.8125 20.0156 12 20.0156C14.1875 20.0156 16.0625 19.2344 17.625 17.6719C19.2188 16.0781 20.0156 14.1875 20.0156 12C20.0156 9.8125 19.2188 7.9375 17.625 6.375C16.0625 4.78125 14.1875 3.98438 12 3.98438C9.8125 3.98438 7.92188 4.78125 6.32812 6.375C4.76562 7.9375 3.98438 9.8125 3.98438 12C3.98438 14.1875 4.76562 16.0781 6.32812 17.6719ZM4.92188 4.96875C6.89062 3 9.25 2.01562 12 2.01562C14.75 2.01562 17.0938 3 19.0312 4.96875C21 6.90625 21.9844 9.25 21.9844 12V20.0156C21.9844 20.5469 21.7812 21.0156 21.375 21.4219C21 21.7969 20.5469 21.9844 20.0156 21.9844H12C9.25 21.9844 6.89062 21.0156 4.92188 19.0781C2.98438 17.1094 2.01562 14.75 2.01562 12C2.01562 9.25 2.98438 6.90625 4.92188 4.96875ZM12.9844 6.98438V11.0156H17.0156V12.9844H12.9844V17.0156H11.0156V12.9844H6.98438V11.0156H11.0156V6.98438H12.9844Z\"/>\n  </g>\n  <defs>\n  <clipPath id=\"clip0_353_3766\">\n  <rect width=\"24\" height=\"24\" fill=\"white\"/>\n  </clipPath>\n  </defs>\n  </svg> \n  ";
    zoomInBtn.appendChild(zoomInTooltip);
    if (playable) {
        btnDiv.appendChild(downloadBtnDiv);
    }
    btnDiv.appendChild(zoomInBtn);
    infoDiv1.appendChild(btnDiv);
    var titleDiv = document.createElement('div');
    titleDiv.setAttribute('style', "".concat(titleCSS, " ").concat(titleTextCSS));
    titleDiv.style.color = c.primary['1'];
    titleDiv.innerHTML = "<div style=\"display:flex; align-items:center\">\n    <div style=\"height:20px; margin-right:4px;\">".concat(iconMarkup, "</div>\n    <div>").concat(moment
        .unix(track.vdate)
        .utc(false)
        .format('YYYY-MM-DD h:mm:ss A'), "</div></div>\n   ");
    // console.log(
    //   "makeAppGPSTrackingInfoItem",
    //   track.vdate,
    //   //@ts-ignore
    //   moment.unix(track.vdate).utc(false).format("YYYY-MM-DD h:mm:ss A")
    // );
    var itemDivCSS = "/* Auto layout */\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  padding: 0px;\n  gap: 8px;\n\n  padding-left:2px;\n  \n  /* Inside auto layout */\n  \n  flex: none;\n  order: 1;\n  align-self: stretch;\n  flex-grow: 0;";
    var itemDiv = document.createElement('div');
    if (thumbnail) {
        itemDiv.setAttribute('style', itemDivCSS);
    }
    else {
        itemDiv.setAttribute('style', "".concat(itemDivCSS, " gap:0px; padding: 0px;"));
    }
    var thumbDivCSS = "/* media */\n  width: 107px;\n  height: 61px;\n  border-radius: 12px;\n  \n  /* Light mode/#13131C \u2027 1  \n  Body text, toasts, tooltips, icons\n  */\n \n  background: c.primary[\"1\"];\n  \n  /* Inside auto layout */  \n  flex: none;\n  order: 0;\n  flex-grow: 0;";
    if (track.mode === 'E' || track.mode === 'M') {
        thumbDiv = document.createElement('div');
        thumbDiv.setAttribute('style', thumbnail ? thumbDivCSS : '');
        thumbDiv.style.position = 'relative';
        var thumbImg = "";
        if (thumbnail) {
            thumbImg = "<img src=\"".concat(thumbnail, "\" alt=\"Thumbnail Image\" style=\"width: 100%; height: 100%; border-radius:12px;\">");
        }
        thumbDiv.innerHTML = thumbImg;
    }
    if (playable) {
        var thumbPlayBtnCSS = "position: absolute;\n    width: 36px;\n    height: 36px;\n    left: calc(50% - 36px/2);\n    top: calc(50% - 36px/2);\n  \n    border-radius:50%;\n    \n    background: rgba(19, 19, 28, 0.45);\n    \n    display:flex;\n    align-items:center;\n    justify-content:center;\n    ";
        var thumbPlayBtn_2 = document.createElement('div');
        thumbPlayBtn_2.setAttribute('style', thumbPlayBtnCSS);
        thumbPlayBtn_2.style.fill = 'white';
        thumbPlayBtn_2.style.cursor = 'pointer';
        thumbPlayBtn_2.innerHTML = "<svg\n    style=\"fill:white\"\n    width=\"17\" height=\"20\" viewBox=\"0 0 17 20\"  xmlns=\"http://www.w3.org/2000/svg\">\n    <g filter=\"url(#filter0_ddd_353_3753)\">\n    <path d=\"M3.01562 3.01562L13.9844 10L3.01562 16.9844V3.01562Z\" />\n    </g>\n    <defs>\n    <filter id=\"filter0_ddd_353_3753\" x=\"0.015625\" y=\"0.015625\" width=\"16.9688\" height=\"19.9688\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\">\n    <feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"/>\n    <feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\"/>\n    <feOffset/>\n    <feGaussianBlur stdDeviation=\"1.5\"/>\n    <feColorMatrix type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0\"/>\n    <feBlend mode=\"normal\" in2=\"BackgroundImageFix\" result=\"effect1_dropShadow_353_3753\"/>\n    <feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\"/>\n    <feOffset dy=\"1\"/>\n    <feGaussianBlur stdDeviation=\"0.5\"/>\n    <feColorMatrix type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0\"/>\n    <feBlend mode=\"normal\" in2=\"effect1_dropShadow_353_3753\" result=\"effect2_dropShadow_353_3753\"/>\n    <feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\"/>\n    <feOffset/>\n    <feGaussianBlur stdDeviation=\"0.5\"/>\n    <feColorMatrix type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0\"/>\n    <feBlend mode=\"normal\" in2=\"effect2_dropShadow_353_3753\" result=\"effect3_dropShadow_353_3753\"/>\n    <feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"effect3_dropShadow_353_3753\" result=\"shape\"/>\n    </filter>\n    </defs>\n    </svg>\n    ";
        // 마커 팝업 썸네일 클릭시 비디오모달 출력 (Leehj)
        thumbPlayBtn_2.addEventListener('click', function () {
            var _a;
            (_a = options === null || options === void 0 ? void 0 : options.onPlay) === null || _a === void 0 ? void 0 : _a.call(options, track);
        });
        thumbPlayBtn_2.addEventListener('mouseover', function () {
            thumbPlayBtn_2.style.fill = c.primary['1'];
        });
        thumbPlayBtn_2.addEventListener('mouseout', function () {
            thumbPlayBtn_2.style.fill = c.primary['0'];
        });
        if (thumbDiv)
            thumbDiv.appendChild(thumbPlayBtn_2);
    }
    var infoDiv11 = document.createElement('div');
    infoDiv11.setAttribute('style', infoDivEventTextCSS);
    infoDiv11.style.color = c.primary['1'];
    infoDiv11.innerHTML = "".concat(t(eventString));
    var infoDiv2 = document.createElement('div');
    infoDiv2.setAttribute('style', infoDivTextCSS);
    infoDiv2.innerHTML = "".concat(speedText);
    var infoDiv34 = document.createElement('div');
    if (thumbnail) {
        infoDiv34.setAttribute('style', "".concat(infoDivTextCSS, " display:flex; flex-direction: column;"));
    }
    else {
        infoDiv34.setAttribute('style', "".concat(infoDivTextCSS, " display:flex; justify-content:space-between; width:100%; margin-top:4px;"));
    }
    var infoDiv3 = document.createElement('div');
    infoDiv3.setAttribute('style', infoDivTextCSS);
    if (track.mode !== 'S')
        infoDiv3.innerHTML = "".concat(t('Altitude :'), " ").concat(track.alt, "m"); // Speed Alert 아니면 추가 (hongcs 24.06.11)
    var infoDiv4 = document.createElement('div');
    infoDiv4.setAttribute('style', infoDivTextCSS);
    infoDiv4.innerHTML = "".concat(loc[1].toFixed(6), ", ").concat(loc[0].toFixed(6)); // 소수점 6자리까지
    infoDiv34.appendChild(infoDiv3);
    infoDiv34.appendChild(infoDiv4);
    titleDiv.appendChild(infoDiv1);
    infoDiv.appendChild(infoDiv11);
    infoDiv.appendChild(infoDiv2);
    infoDiv.appendChild(infoDiv34);
    if (thumbDiv) {
        itemDiv.appendChild(thumbDiv);
    }
    itemDiv.appendChild(infoDiv);
    contentDiv.appendChild(titleDiv);
    contentDiv.appendChild(itemDiv);
    return contentDiv;
};
var makeGPSTrackingInfoPanel = function (map, track, t, options) {
    console.log('MapboxGPSTrakingMap', 'track', track);
    //@ts-ignore
    var loc = typeof track.loc === 'string' ? JSON.parse(track.loc) : track.loc;
    var elCSS = "/* gps tracking/hovercard */  \n  width: 300px;\n  \n  /* Light mode/#FFFFFF \u2027 0\n  \n  Background\n  */\n  background: #FFFFFF;\n  /* Light mode/#D4D4D5 \u2027 5\n  \n  Modals, menus\n  */\n  border: 1px solid #D4D4D5;\n  /* Shadow 1 \u2027 Modals, menus\n  \n  For modals. menus\n  */\n  box-shadow: 0px 6px 20px rgba(0, 0, 0, 0.05), 0px 3px 15px rgba(0, 0, 0, 0.1), 0px 0px 8px rgba(0, 0, 0, 0.08);\n  border-radius: 12px;";
    var el = document.createElement('div');
    el.className = 'marker';
    el.setAttribute('style', elCSS);
    if (track.mode === 'P' && track.pevents) {
        //@ts-ignore
        var pevents = typeof track.pevents === 'string'
            ? JSON.parse(track.pevents)
            : track.pevents;
        if (pevents.length > 0) {
            console.log('MapboxGPSTrakingMap', 'pevents', pevents);
            var peventTitleCSS = "display: flex;\n      flex-direction: row;\n      align-items: flex-start;\n      padding: 8px 16px;      \n      \n      height: 37px;\n\n      border-bottom: 1px solid #E9E9EA;\n      \n      ";
            el.innerHTML = "<div style=\"".concat(peventTitleCSS, "\">").concat(t('Parking Events'), " \u00B7 ").concat(pevents.length, "</div>");
            var contentListDiv = document.createElement('div');
            for (var _i = 0, pevents_1 = pevents; _i < pevents_1.length; _i++) {
                var tr = pevents_1[_i];
                contentListDiv.appendChild(makeGPSTrackingInfoItem(map, tr, t, options));
            }
            el.appendChild(contentListDiv);
            // 웹에서 parking 팝업창 출력안되는 이슈 수정(Leehj)
        }
        else {
            var contentDiv = makeGPSTrackingInfoItem(map, track, t, options);
            el.appendChild(contentDiv);
        }
    }
    else {
        var contentDiv = makeGPSTrackingInfoItem(map, track, t, options);
        el.appendChild(contentDiv);
    }
    el.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
    });
    var offset = [0, -15];
    if (track.mode === 'E' || track.first || track.last || track.mode === 'P') {
        offset = [0, -45];
    }
    // Add markers to the map.
    var marker = new mapboxgl.Marker(el, {
        // anchor: "bottom",
        anchor: 'bottom',
        offset: offset,
    })
        .setLngLat(loc)
        .addTo(map);
    return Object.assign(marker);
};
var makeAppGPSTrackingInfoPanel = function (map, track, t, options) {
    var _a;
    console.log('MapboxGPSTrakingMapApp', 'track', track, options);
    //@ts-ignore
    var loc = typeof track.loc === 'string' ? JSON.parse(track.loc) : track.loc;
    var c = (_a = options === null || options === void 0 ? void 0 : options.colors) !== null && _a !== void 0 ? _a : LightColors;
    var elCSS = "/* gps tracking/hovercard */  \n  width: 305px;\n  \n  /* Light mode/#FFFFFF \u2027 0\n  \n  Background\n  */\n  background: ".concat(c.primary['0'], ";\n  /* Light mode/#D4D4D5 \u2027 5\n  \n  Modals, menus\n  */\n  border: 1px solid ").concat(c.primary['5'], ";\n  /* Shadow 1 \u2027 Modals, menus\n  \n  For modals. menus\n  */\n  box-shadow: 0px 6px 20px rgba(0, 0, 0, 0.05), 0px 3px 15px rgba(0, 0, 0, 0.1), 0px 0px 8px rgba(0, 0, 0, 0.08);\n  border-radius: 12px;");
    var el = document.createElement('div');
    el.className = 'marker';
    el.setAttribute('style', elCSS);
    if (track.mode === 'P' && track.pevents) {
        //@ts-ignore
        var pevents = typeof track.pevents === 'string'
            ? JSON.parse(track.pevents)
            : track.pevents;
        if (pevents.length > 0) {
            console.log('MapboxGPSTrakingMapApp', 'pevents', pevents);
            var peventTitleCSS = "display: flex;\n      flex-direction: row;\n      align-items: flex-start;\n      padding: 8px 16px;      \n      \n      height: 37px;\n\n      border-bottom: 1px solid ".concat(c.primary['6'], ";\n      \n      ");
            el.innerHTML = "<div style=\"".concat(peventTitleCSS, "\">").concat(t('Parking Events'), " \u00B7 ").concat(pevents.length, "</div>");
            var contentListDiv = document.createElement('div');
            console.log('pevents', pevents);
            for (var _i = 0, pevents_2 = pevents; _i < pevents_2.length; _i++) {
                var tr = pevents_2[_i];
                contentListDiv.appendChild(makeAppGPSTrackingInfoItem(map, tr, t, options));
            }
            el.appendChild(contentListDiv);
            // 앱에서 parking 팝업 안나오는 이슈 수정(Leehj)
        }
        else {
            var contentDiv = makeAppGPSTrackingInfoItem(map, track, t, options);
            el.appendChild(contentDiv);
        }
    }
    else {
        var contentDiv = makeAppGPSTrackingInfoItem(map, track, t, options);
        el.appendChild(contentDiv);
    }
    el.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
    });
    var offset = [0, -15];
    if (track.mode === 'E' || track.first || track.last || track.mode === 'P') {
        offset = [0, -45];
    }
    // Add markers to the map.
    var marker = new mapboxgl.Marker(el, {
        // anchor: "bottom",
        anchor: 'bottom',
        offset: offset,
    })
        .setLngLat(loc)
        .addTo(map);
    return Object.assign(marker);
};
var makeClusterMarker = function (map, zone) {
    var el = document.createElement('div');
    el.className = 'marker';
    var contentDiv = document.createElement('div');
    var point = Math.floor(Math.log10(parseInt(zone.count)));
    // if(parseInt(zone.count) > 9999) {
    //   size = ""
    // }
    var size = "".concat(24 + 4 * (point - 1), "px");
    // console.log("zone.count", zone.count, "point", point, "size", size);
    // const size = parseInt(zone.count) > 99 ? "28px" : "24px";
    contentDiv.style.filter =
        'drop-shadow(0px 6px 2px rgba(0, 0, 0, 0.01)) drop-shadow(0px 3px 2px rgba(0, 0, 0, 0.05)) drop-shadow(0px 1px 1px rgba(0, 0, 0, 0.09)) drop-shadow(0px 0px 1px rgba(0, 0, 0, 0.1)) drop-shadow(0px 0px 0px rgba(0, 0, 0, 0.1))';
    contentDiv.style.display = 'flex';
    contentDiv.style.justifyContent = 'center';
    contentDiv.style.alignItems = 'center';
    contentDiv.style.width = size;
    contentDiv.style.height = size;
    //@ts-ignore
    contentDiv.style.backgroundColor = zone.myzone ? '#0095E0' : '#FFFFFF';
    contentDiv.style.borderRadius = '50%';
    contentDiv.style.borderWidth = '1px';
    contentDiv.style.borderStyle = 'solid';
    //@ts-ignore
    contentDiv.style.borderColor = zone.myzone ? '#FFFFFF' : '#0095E0';
    contentDiv.style.fontSize = '12px';
    contentDiv.style.lineHeight = '16px';
    //@ts-ignore
    contentDiv.style.color = zone.myzone ? '#FFFFFF' : '#0095E0';
    contentDiv.innerText = "".concat(zone.count);
    el.appendChild(contentDiv);
    el.addEventListener('click', function () {
        map.flyTo({
            center: [parseFloat(zone.lng), parseFloat(zone.lat)],
            zoom: map.getZoom() + 1,
        });
    });
    // Add markers to the map.
    var marker = new mapboxgl.Marker(el, {
        // anchor: "bottom",
        anchor: 'bottom',
        offset: [0, 0],
    })
        .setLngLat([parseFloat(zone.lng), parseFloat(zone.lat)])
        .addTo(map);
    return Object.assign(marker, { zone: zone });
};
var makeLiveviewMarker = function (map, loc, options) {
    var _a, _b, _c, _d, _e, _f, _g;
    var isParking = loc.active === 'on' && loc.mode === '1';
    var showSpeed = loc.speed !== undefined && loc.mode === '0' && loc.active === 'on';
    var el = document.createElement('div');
    el.className = 'marker';
    var contentDiv = document.createElement('div');
    contentDiv.style.position = 'relative';
    contentDiv.style.filter =
        'drop-shadow(0px 6px 2px rgba(0, 0, 0, 0.01)) drop-shadow(0px 3px 2px rgba(0, 0, 0, 0.05)) drop-shadow(0px 1px 1px rgba(0, 0, 0, 0.09)) drop-shadow(0px 0px 1px rgba(0, 0, 0, 0.1)) drop-shadow(0px 0px 0px rgba(0, 0, 0, 0.1))';
    var markerDiv = document.createElement('div');
    markerDiv.style.display = 'flex';
    var camMarker = "<rect x=\"20.8235\" y=\"2.64726\" width=\"18.1176\" height=\"11.5294\" rx=\"4.11765\" fill=\"#3C3C3C\" stroke=\"white\" stroke-width=\"1.64706\"/>\n  <circle cx=\"26.5878\" cy=\"8.41199\" r=\"1.64706\" stroke=\"white\" stroke-width=\"1.64706\"/>\n  <circle cx=\"38.1183\" cy=\"4.29412\" r=\"2.47059\" fill=\"#DF434D\" stroke=\"white\" stroke-width=\"1.64706\"/>";
    var statusMarker = "<path d=\"M17 28.4284C17 27.1294 17.5268 25.8836 18.4645 24.9651C19.4021 24.0465 20.6739 23.5305 22 23.5305C23.3261 23.5305 24.5979 24.0465 25.5355 24.9651C26.4732 25.8836 27 27.1294 27 28.4284H17ZM22 22.9182C19.9281 22.9182 18.25 21.2743 18.25 19.2448C18.25 17.2152 19.9281 15.5713 22 15.5713C24.0719 15.5713 25.75 17.2152 25.75 19.2448C25.75 21.2743 24.0719 22.9182 22 22.9182Z\" fill=\"white\"/>";
    var directionMark = "<div \n      style=\"position:absolute;top:-17px;left:0;right:0;display:flex;justify-content:center;align-items:center;transform-origin:bottom;transform:rotate(".concat((_a = loc.heading) !== null && _a !== void 0 ? _a : 0, "deg);z-index:0;\">\n    <svg width=\"38\" height=\"40\" viewBox=\"0 0 38 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" style=\"display:block;\">\n    <path opacity=\"0.85\" d=\"M19 40L9.00003 34.5L3.01998e-05 4.30733e-06L38 3.8147e-06L29 34.5L19 40Z\" fill=\"url(#paint0_linear_59_58793)\"/>\n    <defs>\n    <linearGradient id=\"paint0_linear_59_58793\" x1=\"19\" y1=\"40\" x2=\"19\" y2=\"-6.66667\" gradientUnits=\"userSpaceOnUse\">\n    <stop offset=\"0.238239\" stop-color=\"#0095E0\"/>\n    <stop offset=\"0.833168\" stop-color=\"#0095E0\" stop-opacity=\"0\"/>\n    </linearGradient>\n    </defs>\n    </svg>\n  </div>");
    var strokeColor = 'white';
    var fillColor = '#0095E0';
    if (loc.isEvent) {
        fillColor = '#D81A26';
    }
    var speed = parseFloat((_b = loc.speed) !== null && _b !== void 0 ? _b : '0');
    if (speed === 0) {
        directionMark = '';
    }
    if (isParking) {
        statusMarker = "<path d=\"M18 17H22.8462C23.9478 17 25.0044 17.4064 25.7834 18.1297C26.5624 18.8531 27 19.8342 27 20.8571C27 21.8801 26.5624 22.8612 25.7834 23.5846C25.0044 24.3079 23.9478 24.7143 22.8462 24.7143H20.7692V28.5714H18V17ZM20.7692 19.5714V22.1429H22.8462C23.2134 22.1429 23.5656 22.0074 23.8252 21.7663C24.0849 21.5252 24.2308 21.1981 24.2308 20.8571C24.2308 20.5161 24.0849 20.1891 23.8252 19.948C23.5656 19.7069 23.2134 19.5714 22.8462 19.5714H20.7692Z\" fill=\"white\"/>";
        directionMark = '';
    }
    if (loc.isPublic) {
        statusMarker = '';
        fillColor = '#E9E9EA';
        camMarker = '';
        if (loc.share_video === 'on') {
            strokeColor = '#D81A26';
        }
    }
    markerDiv.innerHTML = "<div style=\"position:relative\">\n  <svg width=\"44\" height=\"44\" viewBox=\"0 0 44 44\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" style=\"position:relative;z-index:1;\" >\n    <circle cx=\"22\" cy=\"22\" r=\"13.16\" fill=\"white\" stroke=\"".concat(strokeColor, "\" stroke-width=\"1.68\"/>\n    <mask id=\"mask0_59_59169\" style=\"mask-type:alpha\" maskUnits=\"userSpaceOnUse\" x=\"10\" y=\"10\" width=\"24\" height=\"24\">\n    <circle cx=\"22\" cy=\"22\" r=\"11.16\" fill=\"#B1BBDE\" stroke=\"#BEBEC1\" stroke-width=\"1.68\"/>\n    </mask>\n    <g mask=\"url(#mask0_59_59169)\">\n    <circle cx=\"22\" cy=\"22\" r=\"12\" fill=\"").concat(fillColor, "\"/>\n    ").concat(statusMarker, "\n    </g>\n    ").concat(camMarker, "\n    </svg>\n    ").concat(directionMark, "\n    </div>\n  ");
    contentDiv.appendChild(markerDiv);
    if (loc.isPublic) {
        var imageDiv = document.createElement('div');
        imageDiv.style.position = 'absolute';
        imageDiv.style.top = '10px';
        // imageDiv.style.right = '0';
        imageDiv.style.left = '10px';
        imageDiv.style.display = 'flex';
        imageDiv.style.justifyContent = 'center';
        imageDiv.style.zIndex = '3';
        var basicSvg = "\n      <svg width=\"24\" height=\"24\" viewBox=\"0 0 44 44\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n      <g clip-path=\"url(#clip0_11889_121452)\">\n      <circle cx=\"22\" cy=\"22\" r=\"22\" fill=\"#E9E9EA\"/>\n      <g clip-path=\"url(#clip1_11889_121452)\">\n      <g opacity=\"0.85\">\n      <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M21.9289 11.0664C27.9635 11.0664 32.8598 15.9799 32.8598 22.0356C32.8598 28.0913 27.9635 33.0047 21.9289 33.0047C15.8944 32.9866 10.998 28.0913 10.998 22.0356C10.998 15.9617 15.8944 11.0664 21.9289 11.0664Z\" fill=\"#030303\"/>\n      <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M21.9303 31.6091C16.6546 31.6091 12.3906 27.3121 12.3906 22.036C12.3906 16.7418 16.6546 12.4629 21.9303 12.4629C27.206 12.4629 31.4699 16.7418 31.4699 22.036C31.4699 27.3121 27.1879 31.6091 21.9303 31.6091Z\" fill=\"white\"/>\n      <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M21.9272 14.3682C17.7175 14.3682 14.3027 17.7949 14.3027 22.0194C14.3027 26.2439 17.7175 29.6887 21.9272 29.6887C26.137 29.6887 29.5698 26.262 29.5698 22.0194C29.5517 17.7949 26.137 14.3682 21.9272 14.3682Z\" fill=\"#030303\"/>\n      <path d=\"M20.7922 22.5989C20.6477 14.9114 17.6846 12.5725 14.3241 10.9951C14.3241 10.9951 13.8543 17.8123 20.7922 22.5989Z\" fill=\"#678D2A\"/>\n      <path d=\"M20.6475 22.2907C20.5391 15.3466 17.5399 12.6814 14.4504 11.249C14.4504 11.249 14.3239 17.8487 20.6475 22.2907Z\" fill=\"#8BC126\"/>\n      <path d=\"M20.5386 23.0711C17.0877 18.629 14.3234 18.5202 11.6855 19.0823C11.6855 19.0823 14.3415 23.2886 20.5386 23.0711Z\" fill=\"#3576AE\"/>\n      <path d=\"M20.1573 22.908C16.9774 18.8286 14.1588 18.7017 11.9004 19.1731C11.9004 19.1731 14.7731 23.0531 20.1573 22.908Z\" fill=\"#569DD2\"/>\n      <path d=\"M22.6877 26.6406L19.2549 26.8763C19.2549 26.8763 19.9957 23.5765 21.3146 22.7243V22.6699C21.2784 21.1832 21.152 19.914 20.881 18.8262L23.0491 21.8359C23.0491 21.8359 25.163 20.3129 27.566 21.8359C27.566 21.8359 29.7883 21.8903 32.5345 22.5611C32.5345 22.5611 29.3004 22.3798 27.3672 23.2864C27.3672 23.2682 26.8613 26.0423 22.6877 26.6406Z\" fill=\"#E2AF00\"/>\n      <path d=\"M22.654 26.496L19.4561 26.7135C19.4561 26.7135 20.1788 23.4681 21.4796 22.7791L21.4254 22.7066C21.4073 21.4375 21.3351 20.4584 21.1183 19.3887L22.9612 22.0176C22.9612 22.0176 25.2919 20.4765 27.4419 21.9814C27.4419 21.9814 29.0499 21.8907 31.3806 22.4528C31.3806 22.4528 29.3029 22.2352 27.2432 23.1418C27.2612 23.1418 26.8095 25.952 22.654 26.496Z\" fill=\"#F2B42E\"/>\n      <path d=\"M18.6033 25.626C18.6033 25.626 19.8681 29.8867 21.0063 30.3219C20.1752 30.612 18.7117 31.3191 17.7361 32.3707C17.6819 32.4613 17.2302 28.2006 18.6033 25.626Z\" fill=\"#A60C1C\"/>\n      <path d=\"M18.55 25.8984C18.55 25.8984 19.7424 29.9235 20.7181 30.2861C20.0134 30.5218 18.6222 31.1926 17.7911 32.0992C17.755 32.1898 17.4659 28.4368 18.55 25.8984Z\" fill=\"#D76049\"/>\n      </g>\n      </g>\n      </g>\n      </svg>\n    ";
        if (loc.share_dev_name === 'on') {
            imageDiv.innerHTML = ((_c = loc.profile_img_v2) === null || _c === void 0 ? void 0 : _c.includes('json'))
                ? basicSvg
                : "\n    <div style=\"position:absolute;top:0px;left:12px;right:0;display:flex;justify-content:center;\">\n  <img style=\"width:24px;height:24px;border-radius:50%;object-fit:cover;\" src=\"".concat(loc.profile_img_v2, "\"  />\n  </div>\n    ");
        }
        else {
            imageDiv.innerHTML = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n      <circle cx=\"12\" cy=\"12\" r=\"12\" fill=\"#E9E9EA\"/>\n      <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11.9562 5.49756C15.5453 5.49756 18.4574 8.41985 18.4574 12.0215C18.4574 15.6231 15.5453 18.5454 11.9562 18.5454C8.36717 18.5346 5.45508 15.6231 5.45508 12.0215C5.45508 8.40907 8.36717 5.49756 11.9562 5.49756Z\" fill=\"#030303\"/>\n      <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11.9569 17.7154C8.81919 17.7154 6.2832 15.1597 6.2832 12.0217C6.2832 8.873 8.81919 6.32812 11.9569 6.32812C15.0947 6.32812 17.6307 8.873 17.6307 12.0217C17.6307 15.1597 15.0839 17.7154 11.9569 17.7154Z\" fill=\"white\"/>\n      <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11.9566 7.46045C9.45282 7.46045 7.42188 9.49851 7.42188 12.011C7.42188 14.5236 9.45282 16.5724 11.9566 16.5724C14.4603 16.5724 16.502 14.5343 16.502 12.011C16.4913 9.49851 14.4603 7.46045 11.9566 7.46045Z\" fill=\"#030303\"/>\n      <path d=\"M11.2787 12.3559C11.1927 7.7838 9.43041 6.39274 7.43171 5.45459C7.43171 5.45459 7.15232 9.50914 11.2787 12.3559Z\" fill=\"#678D2A\"/>\n      <path d=\"M11.1937 12.1725C11.1292 8.04251 9.34544 6.45735 7.50792 5.60547C7.50792 5.60547 7.4327 9.53061 11.1937 12.1725Z\" fill=\"url(#paint0_linear_59_59285)\"/>\n      <path d=\"M11.1287 12.6363C9.07625 9.99436 7.43216 9.92966 5.86328 10.2639C5.86328 10.2639 7.4429 12.7657 11.1287 12.6363Z\" fill=\"#3576AE\"/>\n      <path d=\"M10.903 12.5393C9.01173 10.113 7.3354 10.0375 5.99219 10.3179C5.99219 10.3179 7.70076 12.6255 10.903 12.5393Z\" fill=\"url(#paint1_linear_59_59285)\"/>\n      <path d=\"M12.4069 14.7604L10.3652 14.9006C10.3652 14.9006 10.8058 12.938 11.5902 12.4312V12.3989C11.5688 11.5146 11.4935 10.7598 11.3323 10.1128L12.6218 11.9028C12.6218 11.9028 13.8791 10.997 15.3083 11.9028C15.3083 11.9028 16.63 11.9352 18.2633 12.3342C18.2633 12.3342 16.3399 12.2263 15.1901 12.7655C15.1901 12.7547 14.8892 14.4046 12.4069 14.7604Z\" fill=\"#E2AF00\"/>\n      <path d=\"M12.3864 14.6743L10.4844 14.8037C10.4844 14.8037 10.9142 12.8735 11.6879 12.4638L11.6557 12.4206C11.6449 11.6658 11.6019 11.0835 11.473 10.4473L12.569 12.0109C12.569 12.0109 13.9552 11.0943 15.234 11.9893C15.234 11.9893 16.1903 11.9354 17.5765 12.2697C17.5765 12.2697 16.3408 12.1403 15.1158 12.6794C15.1265 12.6794 14.8579 14.3508 12.3864 14.6743Z\" fill=\"url(#paint2_linear_59_59285)\"/>\n      <path d=\"M9.97814 14.1567C9.97814 14.1567 10.7303 16.6908 11.4073 16.9496C10.913 17.1222 10.0426 17.5427 9.46235 18.1682C9.43011 18.2221 9.16147 15.688 9.97814 14.1567Z\" fill=\"#A60C1C\"/>\n      <path d=\"M9.94696 14.3184C9.94696 14.3184 10.6562 16.7123 11.2364 16.9279C10.8174 17.0681 9.98994 17.4671 9.49564 18.0063C9.47415 18.0602 9.30222 15.828 9.94696 14.3184Z\" fill=\"url(#paint3_linear_59_59285)\"/>\n      <defs>\n      <linearGradient id=\"paint0_linear_59_59285\" x1=\"8.25013\" y1=\"5.65274\" x2=\"10.7847\" y2=\"12.294\" gradientUnits=\"userSpaceOnUse\">\n      <stop stop-color=\"#8BC126\"/>\n      <stop offset=\"1\" stop-color=\"#8CC125\"/>\n      </linearGradient>\n      <linearGradient id=\"paint1_linear_59_59285\" x1=\"6.28101\" y1=\"10.4338\" x2=\"10.8491\" y2=\"12.2426\" gradientUnits=\"userSpaceOnUse\">\n      <stop stop-color=\"#569DD2\"/>\n      <stop offset=\"1\" stop-color=\"#5FA8E0\"/>\n      </linearGradient>\n      <linearGradient id=\"paint2_linear_59_59285\" x1=\"13.425\" y1=\"10.3058\" x2=\"14.1542\" y2=\"14.1268\" gradientUnits=\"userSpaceOnUse\">\n      <stop stop-color=\"#FADDA2\"/>\n      <stop offset=\"0.0756794\" stop-color=\"#F9D793\"/>\n      <stop offset=\"0.4002\" stop-color=\"#F5C35B\"/>\n      <stop offset=\"0.6735\" stop-color=\"#F2B42E\"/>\n      <stop offset=\"0.8816\" stop-color=\"#F0AC0C\"/>\n      <stop offset=\"1\" stop-color=\"#F0A900\"/>\n      </linearGradient>\n      <linearGradient id=\"paint3_linear_59_59285\" x1=\"10.7107\" y1=\"14.4326\" x2=\"10.1275\" y2=\"18.0149\" gradientUnits=\"userSpaceOnUse\">\n      <stop stop-color=\"#D76049\"/>\n      <stop offset=\"0.3211\" stop-color=\"#D34635\"/>\n      <stop offset=\"0.7666\" stop-color=\"#CE2223\"/>\n      <stop offset=\"1\" stop-color=\"#CC0B1E\"/>\n      </linearGradient>\n      </defs>\n      </svg>      \n      ";
        }
        contentDiv.appendChild(imageDiv);
    }
    if (!isParking) {
        var labelDiv = document.createElement('div');
        labelDiv.style.position = 'absolute';
        labelDiv.style.bottom = showSpeed ? '2px' : '-8px';
        labelDiv.style.right = '50%';
        labelDiv.style.transform = 'translate(50%,0)';
        labelDiv.style.textAlign = 'center';
        labelDiv.style.zIndex = '4';
        var speedValue = getSpeedValue(loc, options === null || options === void 0 ? void 0 : options.speedUnit);
        labelDiv.innerHTML = ReactDOMServer.renderToString(React__default.createElement(ThemeProvider, { theme: theme({
                fontFamily: (_d = options === null || options === void 0 ? void 0 : options.fontFamily) !== null && _d !== void 0 ? _d : 'Roboto',
                dir: (_e = options === null || options === void 0 ? void 0 : options.direction) !== null && _e !== void 0 ? _e : 'ltr',
                Colors: LightColors,
                breakpoints: {
                    values: { xs: 0, sm: 662, md: 960, lg: 1280, xl: 1920 },
                },
            }) },
            React__default.createElement("div", { style: {
                    maxWidth: 110,
                    backgroundColor: 'white',
                    borderRadius: 4,
                    padding: '3px 6px',
                    display: 'flex',
                    flexDirection: 'column',
                } }, showSpeed && (React__default.createElement(Typography$1
            // style={{ lineHeight: 1, whiteSpace: "nowrap" }}
            // ={LightColors.primary["2"]}
            , { 
                // style={{ lineHeight: 1, whiteSpace: "nowrap" }}
                // ={LightColors.primary["2"]}
                style: {
                    lineHeight: 1,
                    whiteSpace: 'nowrap',
                    color: LightColors.primary['2'],
                    fontSize: 10,
                } }, speedValue)))));
        contentDiv.appendChild(labelDiv);
    }
    else if (loc.isPublic) {
        var labelDiv = document.createElement('div');
        labelDiv.style.position = 'absolute';
        labelDiv.style.bottom = '4px';
        labelDiv.style.right = '50%';
        labelDiv.style.transform = 'translate(50%,0)';
        labelDiv.style.textAlign = 'center';
        labelDiv.style.zIndex = '4';
        var devText = (React__default.createElement("div", { style: {
                // height: 16,
                display: 'flex',
            } },
            React__default.createElement("div", { style: { display: 'flex', alignItems: 'center' } },
                React__default.createElement("svg", { width: '8', height: '10', viewBox: '0 0 8 10', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', style: { display: 'block' } },
                    React__default.createElement("path", { d: 'M0.5 0.5H4.26923C5.12608 0.5 5.94784 0.816071 6.55373 1.37868C7.15962 1.94129 7.5 2.70435 7.5 3.5C7.5 4.29565 7.15962 5.05871 6.55373 5.62132C5.94784 6.18393 5.12608 6.5 4.26923 6.5H2.65385V9.5H0.5V0.5ZM2.65385 2.5V4.5H4.26923C4.55485 4.5 4.82877 4.39464 5.03073 4.20711C5.23269 4.01957 5.34615 3.76522 5.34615 3.5C5.34615 3.23478 5.23269 2.98043 5.03073 2.79289C4.82877 2.60536 4.55485 2.5 4.26923 2.5H2.65385Z', fill: '#2EA8E5' })))));
        labelDiv.innerHTML = ReactDOMServer.renderToString(React__default.createElement(ThemeProvider, { theme: theme({
                fontFamily: (_f = options === null || options === void 0 ? void 0 : options.fontFamily) !== null && _f !== void 0 ? _f : 'Roboto',
                dir: (_g = options === null || options === void 0 ? void 0 : options.direction) !== null && _g !== void 0 ? _g : 'ltr',
                Colors: LightColors,
                breakpoints: {
                    values: { xs: 0, sm: 662, md: 960, lg: 1280, xl: 1920 },
                },
            }) },
            React__default.createElement("div", { style: {
                    maxWidth: 110,
                    backgroundColor: 'white',
                    borderRadius: 4,
                    padding: '3px 9px',
                    display: 'flex',
                    flexDirection: 'column',
                } }, devText)));
        contentDiv.appendChild(labelDiv);
    }
    el.appendChild(contentDiv);
    // Add markers to the map.
    var marker = new mapboxgl.Marker(el, {
        // anchor: "bottom",
        anchor: 'bottom',
        offset: [0, 0],
    })
        .setLngLat([loc.lng, loc.lat])
        .addTo(map);
    return Object.assign(marker, { psn: loc.psn, loc: loc });
};
var makeLocationMarker = function (map, loc, options) {
    var _a, _b;
    var isParking = loc.active === 'on' && loc.mode === '1';
    var showSpeed = loc.speed !== undefined && loc.mode === '0' && loc.active === 'on';
    var el = document.createElement('div');
    el.className = 'marker';
    var contentDiv = document.createElement('div');
    contentDiv.style.position = 'relative';
    contentDiv.style.filter =
        'drop-shadow(0px 6px 2px rgba(0, 0, 0, 0.01)) drop-shadow(0px 3px 2px rgba(0, 0, 0, 0.05)) drop-shadow(0px 1px 1px rgba(0, 0, 0, 0.09)) drop-shadow(0px 0px 1px rgba(0, 0, 0, 0.1)) drop-shadow(0px 0px 0px rgba(0, 0, 0, 0.1))';
    var markerDiv = document.createElement('div');
    markerDiv.style.display = 'flex';
    markerDiv.style.cursor = 'pointer';
    var strokeColor = 'white';
    var fillColor = '#0095E0';
    var statusFill = '#E9E9EA';
    var camMarker = "<rect x=\"32\" y=\"2\" width=\"22\" height=\"14\" rx=\"5\" fill=\"#3C3C3C\" stroke=\"white\" stroke-width=\"2\"/>\n  <circle cx=\"39\" cy=\"9\" r=\"2\" stroke=\"white\" stroke-width=\"2\"/>\n  <circle cx=\"53\" cy=\"4\" r=\"3\" fill=\"#DF434D\" stroke=\"white\" stroke-width=\"2\"/>\n  ";
    var statusMarker = "<path d=\"M22 35.2466C22 33.403 22.7375 31.635 24.0503 30.3314C25.363 29.0278 27.1435 28.2955 29 28.2955C30.8565 28.2955 32.637 29.0278 33.9497 30.3314C35.2625 31.635 36 33.403 36 35.2466H22ZM29 27.4266C26.0994 27.4266 23.75 25.0937 23.75 22.2133C23.75 19.333 26.0994 17 29 17C31.9006 17 34.25 19.333 34.25 22.2133C34.25 25.0937 31.9006 27.4266 29 27.4266Z\" fill=\"white\"/>";
    if (isParking) {
        statusMarker = "<path d=\"M29.6869 29.4248H25.7016V26.9111H29.6869C30.3028 26.9111 30.8041 26.8109 31.1908 26.6104C31.5776 26.4027 31.8604 26.1162 32.0395 25.751C32.2185 25.3857 32.308 24.974 32.308 24.5156C32.308 24.0501 32.2185 23.6169 32.0395 23.2158C31.8604 22.8148 31.5776 22.4925 31.1908 22.249C30.8041 22.0055 30.3028 21.8838 29.6869 21.8838H26.8188V35H23.5961V19.3594H29.6869C30.9115 19.3594 31.9607 19.5814 32.8344 20.0254C33.7153 20.4622 34.3884 21.0674 34.8539 21.8408C35.3194 22.6143 35.5522 23.4987 35.5522 24.4941C35.5522 25.5039 35.3194 26.3776 34.8539 27.1152C34.3884 27.8529 33.7153 28.4222 32.8344 28.8232C31.9607 29.2243 30.9115 29.4248 29.6869 29.4248Z\" fill=\"white\"/>";
    }
    if (loc.isEvent) {
        fillColor = '#D81A26';
        statusFill = '#E9E9EA';
    }
    if (loc.active === 'off') {
        fillColor = '#68686E';
        camMarker = '';
        statusMarker = "<path d=\"M22 35.2466C22 33.403 22.7375 31.635 24.0503 30.3314C25.363 29.0278 27.1435 28.2955 29 28.2955C30.8565 28.2955 32.637 29.0278 33.9497 30.3314C35.2625 31.635 36 33.403 36 35.2466H22ZM29 27.4266C26.0994 27.4266 23.75 25.0937 23.75 22.2133C23.75 19.333 26.0994 17 29 17C31.9006 17 34.25 19.333 34.25 22.2133C34.25 25.0937 31.9006 27.4266 29 27.4266Z\" fill=\"white\"/>";
    }
    if (loc.isPublic) {
        statusMarker = '';
        fillColor = '#E9E9EA';
        camMarker = '';
        if (loc.share_video === 'on') {
            strokeColor = '#D81A26';
            statusFill = '#D81A26';
            fillColor = '#D81A26';
        }
    }
    console.log('makeLocationMarker', 'loc', loc, 'isParking', isParking, 'options?.showProfile', options === null || options === void 0 ? void 0 : options.showProfile);
    if ((options === null || options === void 0 ? void 0 : options.showProfile) && (!isParking || loc.isPublic)) {
        var imageDiv = document.createElement('div');
        var basicSvg_1 = "\n      <svg style=\"position:absolute;top:4px;left:7px;\" width=\"44\" height=\"44\" viewBox=\"0 0 44 44\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n      <g clip-path=\"url(#clip0_11889_121452)\">\n      <circle cx=\"22\" cy=\"22\" r=\"22\" fill=\"#E9E9EA\"/>\n      <g clip-path=\"url(#clip1_11889_121452)\">\n      <g opacity=\"0.85\">\n      <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M21.9289 11.0664C27.9635 11.0664 32.8598 15.9799 32.8598 22.0356C32.8598 28.0913 27.9635 33.0047 21.9289 33.0047C15.8944 32.9866 10.998 28.0913 10.998 22.0356C10.998 15.9617 15.8944 11.0664 21.9289 11.0664Z\" fill=\"#030303\"/>\n      <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M21.9303 31.6091C16.6546 31.6091 12.3906 27.3121 12.3906 22.036C12.3906 16.7418 16.6546 12.4629 21.9303 12.4629C27.206 12.4629 31.4699 16.7418 31.4699 22.036C31.4699 27.3121 27.1879 31.6091 21.9303 31.6091Z\" fill=\"white\"/>\n      <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M21.9272 14.3682C17.7175 14.3682 14.3027 17.7949 14.3027 22.0194C14.3027 26.2439 17.7175 29.6887 21.9272 29.6887C26.137 29.6887 29.5698 26.262 29.5698 22.0194C29.5517 17.7949 26.137 14.3682 21.9272 14.3682Z\" fill=\"#030303\"/>\n      <path d=\"M20.7922 22.5989C20.6477 14.9114 17.6846 12.5725 14.3241 10.9951C14.3241 10.9951 13.8543 17.8123 20.7922 22.5989Z\" fill=\"#678D2A\"/>\n      <path d=\"M20.6475 22.2907C20.5391 15.3466 17.5399 12.6814 14.4504 11.249C14.4504 11.249 14.3239 17.8487 20.6475 22.2907Z\" fill=\"#8BC126\"/>\n      <path d=\"M20.5386 23.0711C17.0877 18.629 14.3234 18.5202 11.6855 19.0823C11.6855 19.0823 14.3415 23.2886 20.5386 23.0711Z\" fill=\"#3576AE\"/>\n      <path d=\"M20.1573 22.908C16.9774 18.8286 14.1588 18.7017 11.9004 19.1731C11.9004 19.1731 14.7731 23.0531 20.1573 22.908Z\" fill=\"#569DD2\"/>\n      <path d=\"M22.6877 26.6406L19.2549 26.8763C19.2549 26.8763 19.9957 23.5765 21.3146 22.7243V22.6699C21.2784 21.1832 21.152 19.914 20.881 18.8262L23.0491 21.8359C23.0491 21.8359 25.163 20.3129 27.566 21.8359C27.566 21.8359 29.7883 21.8903 32.5345 22.5611C32.5345 22.5611 29.3004 22.3798 27.3672 23.2864C27.3672 23.2682 26.8613 26.0423 22.6877 26.6406Z\" fill=\"#E2AF00\"/>\n      <path d=\"M22.654 26.496L19.4561 26.7135C19.4561 26.7135 20.1788 23.4681 21.4796 22.7791L21.4254 22.7066C21.4073 21.4375 21.3351 20.4584 21.1183 19.3887L22.9612 22.0176C22.9612 22.0176 25.2919 20.4765 27.4419 21.9814C27.4419 21.9814 29.0499 21.8907 31.3806 22.4528C31.3806 22.4528 29.3029 22.2352 27.2432 23.1418C27.2612 23.1418 26.8095 25.952 22.654 26.496Z\" fill=\"#F2B42E\"/>\n      <path d=\"M18.6033 25.626C18.6033 25.626 19.8681 29.8867 21.0063 30.3219C20.1752 30.612 18.7117 31.3191 17.7361 32.3707C17.6819 32.4613 17.2302 28.2006 18.6033 25.626Z\" fill=\"#A60C1C\"/>\n      <path d=\"M18.55 25.8984C18.55 25.8984 19.7424 29.9235 20.7181 30.2861C20.0134 30.5218 18.6222 31.1926 17.7911 32.0992C17.755 32.1898 17.4659 28.4368 18.55 25.8984Z\" fill=\"#D76049\"/>\n      </g>\n      </g>\n      </g>\n      </svg>\n    ";
        var renderBasicSvg = function () {
            var _a;
            if (loc.isEvent) {
                return basicSvg_1;
            }
            else if ((_a = loc.profile_img_v2) === null || _a === void 0 ? void 0 : _a.includes('json')) {
                return basicSvg_1;
            }
            else {
                return "<div style=\"position:absolute;top:4px;left:0;right:0;display:flex;justify-content:center;\">\n        <img style=\"width:44px;height:44px;border-radius:50%;object-fit:cover;\" src=\"".concat(loc.profile_img_v2, "\" />\n        </div>");
            }
        };
        if (loc.active === 'off') {
            imageDiv.setAttribute('style', 'filter:grayscale(1)');
        }
        imageDiv.innerHTML = "<div>\n    <svg width=\"58\" height=\"58\" viewBox=\"0 0 58 58\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" >\n    <path d=\"M34.3886 49.4957L34.1502 49.5487L34.0455 49.7694C34.0326 49.7965 34.0182 49.8219 34.0016 49.8461L34.0002 49.8481L29.6423 56.2631C29.4277 56.579 28.9568 56.579 28.7422 56.2631C28.7422 56.2631 28.7422 56.2631 28.7422 56.2631L24.3843 49.8481L24.3843 49.848L24.3804 49.8424C24.3764 49.8367 24.3733 49.8318 24.3709 49.8276L24.2585 49.6315L24.0371 49.5863C12.8824 47.3111 4.5 37.5196 4.5 25.7925C4.5 12.38 15.465 1.5 29 1.5C42.535 1.5 53.5 12.38 53.5 25.7925C53.5 37.3701 45.3299 47.0611 34.3886 49.4957Z\" \n    fill=\"".concat(strokeColor, "\" stroke=\"").concat(statusFill, "\"/>\n    </svg>\n    ").concat(renderBasicSvg(), "\n    <svg style=\"position:absolute;top:0px;left:0px;\" width=\"58\" height=\"58\" viewBox=\"0 0 58 58\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" >\n    ").concat(camMarker, "\n    </svg>\n    </div>\n    ");
        contentDiv.appendChild(imageDiv);
    }
    else {
        markerDiv.innerHTML = "<svg width=\"58\" height=\"58\" viewBox=\"0 0 58 58\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" >\n    <path d=\"M34.3886 49.4957L34.1502 49.5487L34.0455 49.7694C34.0326 49.7965 34.0182 49.8219 34.0016 49.8461L34.0002 49.8481L29.6423 56.2631C29.4277 56.579 28.9568 56.579 28.7422 56.2631C28.7422 56.2631 28.7422 56.2631 28.7422 56.2631L24.3843 49.8481L24.3843 49.848L24.3804 49.8424C24.3764 49.8367 24.3733 49.8318 24.3709 49.8276L24.2585 49.6315L24.0371 49.5863C12.8824 47.3111 4.5 37.5196 4.5 25.7925C4.5 12.38 15.465 1.5 29 1.5C42.535 1.5 53.5 12.38 53.5 25.7925C53.5 37.3701 45.3299 47.0611 34.3886 49.4957Z\" \n    fill=\"".concat(strokeColor, "\" stroke=\"").concat(statusFill, "\"/>\n    <ellipse cx=\"29\" cy=\"25.7925\" rx=\"21.875\" ry=\"21.6934\" fill=\"").concat(fillColor, "\"/>\n    ").concat(statusMarker, "\n    ").concat(camMarker, "\n    </svg>\n    ");
    }
    contentDiv.appendChild(markerDiv);
    // public인경우 이미지
    if (loc.isPublic) {
        var imageDiv = document.createElement('div');
        imageDiv.style.position = 'absolute';
        imageDiv.style.cursor = 'pointer';
        imageDiv.style.top = '4px';
        imageDiv.style.right = '0';
        imageDiv.style.left = '0';
        imageDiv.style.display = 'flex';
        imageDiv.style.justifyContent = 'center';
        if (loc.share_dev_name === 'on' &&
            loc.profile_img_v2 &&
            !loc.profile_img_v2.includes('json')) {
            console.log('makeLocationMarker', 'loc', loc);
            imageDiv.innerHTML = "<img style=\"width:44px;height:44px;border-radius:50%;object-fit:cover;\" src=\"".concat(loc.profile_img_v2, "\" />");
        }
        else {
            // imageDiv.style.top = "0";
            imageDiv.innerHTML = "<svg width=\"44\" height=\"44\" viewBox=\"0 0 44 44\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n      <circle cx=\"22\" cy=\"22\" r=\"22\" fill=\"#E9E9EA\"/>\n      <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M21.9188 10.0791C28.4987 10.0791 33.8376 15.4366 33.8376 22.0397C33.8376 28.6427 28.4987 34.0002 21.9188 34.0002C15.3388 33.9804 10 28.6427 10 22.0397C10 15.4169 15.3388 10.0791 21.9188 10.0791Z\" fill=\"#030303\"/>\n      <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M21.9194 32.4782C16.1669 32.4782 11.5176 27.7928 11.5176 22.0399C11.5176 16.2672 16.1669 11.6016 21.9194 11.6016C27.672 11.6016 32.3213 16.2672 32.3213 22.0399C32.3213 27.7928 27.6523 32.4782 21.9194 32.4782Z\" fill=\"white\"/>\n      <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M21.9191 13.6772C17.3289 13.6772 13.6055 17.4137 13.6055 22.02C13.6055 26.6263 17.3289 30.3825 21.9191 30.3825C26.5093 30.3825 30.2524 26.646 30.2524 22.02C30.2327 17.4137 26.5093 13.6772 21.9191 13.6772Z\" fill=\"#030303\"/>\n      <path d=\"M20.6772 22.6525C20.5196 14.2702 17.2888 11.7199 13.6245 10C13.6245 10 13.1123 17.4333 20.6772 22.6525Z\" fill=\"#678D2A\"/>\n      <path d=\"M20.5192 22.3165C20.401 14.7448 17.1307 11.8386 13.7619 10.2769C13.7619 10.2769 13.624 17.473 20.5192 22.3165Z\" fill=\"#8BC126\"/>\n      <path d=\"M20.4013 23.1665C16.6385 18.323 13.6243 18.2044 10.748 18.8172C10.748 18.8172 13.644 23.4037 20.4013 23.1665Z\" fill=\"#3576AE\"/>\n      <path d=\"M19.9875 22.9883C16.5202 18.5402 13.4469 18.4018 10.9844 18.9158C10.9844 18.9158 14.1168 23.1465 19.9875 22.9883Z\" fill=\"#569DD2\"/>\n      <path d=\"M22.747 27.0612L19.0039 27.3182C19.0039 27.3182 19.8116 23.7201 21.2498 22.791V22.7317C21.2104 21.1106 21.0725 19.7267 20.7769 18.5405L23.141 21.8223C23.141 21.8223 25.446 20.1616 28.0661 21.8223C28.0661 21.8223 30.4893 21.8816 33.4838 22.613C33.4838 22.613 29.9574 22.4154 27.8494 23.4038C27.8494 23.3841 27.2978 26.4088 22.747 27.0612Z\" fill=\"#E2AF00\"/>\n      <path d=\"M22.7077 26.903L19.2207 27.1402C19.2207 27.1402 20.0087 23.6015 21.4272 22.8502L21.3681 22.7711C21.3484 21.3873 21.2696 20.3197 21.0331 19.1533L23.0426 22.0199C23.0426 22.0199 25.584 20.3395 27.9283 21.9804C27.9283 21.9804 29.6817 21.8815 32.223 22.4944C32.223 22.4944 29.9575 22.2571 27.7116 23.2456C27.7313 23.2456 27.2388 26.3099 22.7077 26.903Z\" fill=\"#F2B42E\"/>\n      <path d=\"M18.2946 25.9541C18.2946 25.9541 19.6736 30.5999 20.9147 31.0744C20.0085 31.3907 18.4128 32.1617 17.3489 33.3084C17.2898 33.4072 16.7973 28.7614 18.2946 25.9541Z\" fill=\"#A60C1C\"/>\n      <path d=\"M18.2345 26.2505C18.2345 26.2505 19.5347 30.6393 20.5985 31.0347C19.8302 31.2917 18.3133 32.0232 17.407 33.0117C17.3676 33.1105 17.0524 29.0182 18.2345 26.2505Z\" fill=\"#D76049\"/>      \n      </svg>\n           \n      ";
        }
        contentDiv.appendChild(imageDiv);
    }
    var arrowStroke = '#E9E9EA';
    var arrowFill = 'white';
    if (loc.isPublic && loc.share_video === 'on') {
        arrowStroke = '#D81A26';
        arrowFill = '#D81A26';
    }
    var arrowDiv = document.createElement('div');
    arrowDiv.style.position = 'absolute';
    arrowDiv.style.display = 'block';
    arrowDiv.style.right = '50%';
    arrowDiv.style.transform = 'translate(50%, 6px)';
    if (showSpeed) {
        if (loc.share_dev_name === 'on') {
            arrowDiv.style.bottom = '-10px';
        }
        else {
            arrowDiv.style.bottom = '-2px';
        }
    }
    else if (isParking) {
        if (loc.share_dev_name === 'on') {
            arrowDiv.style.bottom = '3px';
        }
        else {
            arrowDiv.style.bottom = '-4px';
        }
    }
    else {
        arrowDiv.style.bottom = '3px';
    }
    arrowDiv.innerHTML = "<svg width=\"10\" height=\"9\" viewBox=\"0 0 10 9\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" style=\"display:block\">\n  <path d=\"M4.61816 8.28883L0.584191 2.14163C0.357954 1.79687 0.614798 1.37305 0.966028 1.37305L9.03397 1.37305C9.3852 1.37305 9.64205 1.79687 9.41581 2.14162L5.38184 8.28883C5.19704 8.57043 4.80295 8.57043 4.61816 8.28883Z\" fill=\"".concat(arrowFill, "\" stroke=\"").concat(arrowStroke, "\"/>\n  </svg>\n  ");
    if (loc.isPublic) {
        if (loc.share_dev_name !== 'on') {
            arrowDiv.style.transform = 'translate(50%,2px)';
        }
        else {
            arrowDiv.style.transform = 'translate(50%, 7px)';
        }
    }
    contentDiv.appendChild(arrowDiv);
    // 라벨
    var labelDiv = document.createElement('div');
    labelDiv.style.position = 'absolute';
    // labelDiv.style.bottom = showSpeed ? "-19px" : "-8px";
    labelDiv.style.bottom = showSpeed ? '-9px' : '3px';
    labelDiv.style.right = '50%';
    labelDiv.style.transform = 'translate(50%,0)';
    labelDiv.style.textAlign = 'center';
    var speedValue = getSpeedValue(loc, options === null || options === void 0 ? void 0 : options.speedUnit);
    var devText = (React__default.createElement("div", { style: {
            // height: 16,
            display: 'flex',
        } },
        React__default.createElement("div", { style: {
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
            } },
            React__default.createElement(Typography$1
            // category="Default"
            // variant="caption"
            , { 
                // category="Default"
                // variant="caption"
                style: {
                    lineHeight: 1,
                    fontSize: 11,
                    // width: 80,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                } }, loc.name)),
        isParking && (React__default.createElement("div", { style: { paddingLeft: 4, display: 'flex', alignItems: 'center' } },
            React__default.createElement("svg", { width: '8', height: '10', viewBox: '0 0 8 10', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', style: { display: 'block' } },
                React__default.createElement("path", { d: 'M0.5 0.5H4.26923C5.12608 0.5 5.94784 0.816071 6.55373 1.37868C7.15962 1.94129 7.5 2.70435 7.5 3.5C7.5 4.29565 7.15962 5.05871 6.55373 5.62132C5.94784 6.18393 5.12608 6.5 4.26923 6.5H2.65385V9.5H0.5V0.5ZM2.65385 2.5V4.5H4.26923C4.55485 4.5 4.82877 4.39464 5.03073 4.20711C5.23269 4.01957 5.34615 3.76522 5.34615 3.5C5.34615 3.23478 5.23269 2.98043 5.03073 2.79289C4.82877 2.60536 4.55485 2.5 4.26923 2.5H2.65385Z', fill: '#2EA8E5' }))))));
    if (loc.isPublic) {
        if (loc.share_dev_name !== 'on') {
            if (isParking) {
                devText = (React__default.createElement("div", { style: { padding: '1.5px 3px' } },
                    React__default.createElement("svg", { width: '8', height: '10', viewBox: '0 0 8 10', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', style: { display: 'block' } },
                        React__default.createElement("path", { d: 'M0.5 0.5H4.26923C5.12608 0.5 5.94784 0.816071 6.55373 1.37868C7.15962 1.94129 7.5 2.70435 7.5 3.5C7.5 4.29565 7.15962 5.05871 6.55373 5.62132C5.94784 6.18393 5.12608 6.5 4.26923 6.5H2.65385V9.5H0.5V0.5ZM2.65385 2.5V4.5H4.26923C4.55485 4.5 4.82877 4.39464 5.03073 4.20711C5.23269 4.01957 5.34615 3.76522 5.34615 3.5C5.34615 3.23478 5.23269 2.98043 5.03073 2.79289C4.82877 2.60536 4.55485 2.5 4.26923 2.5H2.65385Z', fill: '#2EA8E5' }))));
                labelDiv.style.bottom = '0px';
            }
            else {
                devText = React__default.createElement(React__default.Fragment, null);
                labelDiv.style.bottom = '4px';
            }
        }
        else if (!isParking) {
            labelDiv.style.bottom = '-10px';
        }
    }
    labelDiv.innerHTML = ReactDOMServer.renderToString(React__default.createElement(ThemeProvider, { theme: theme({
            fontFamily: (_a = options === null || options === void 0 ? void 0 : options.fontFamily) !== null && _a !== void 0 ? _a : 'Roboto',
            dir: (_b = options === null || options === void 0 ? void 0 : options.direction) !== null && _b !== void 0 ? _b : 'ltr',
            Colors: LightColors,
            breakpoints: {
                values: { xs: 0, sm: 662, md: 960, lg: 1280, xl: 1920 },
            },
        }) },
        React__default.createElement("div", { style: {
                maxWidth: 110,
                backgroundColor: 'white',
                borderRadius: 4,
                padding: showSpeed ? '2px 6px 4px' : '2px 6px',
                display: 'flex',
                flexDirection: 'column',
            } },
            devText,
            showSpeed && (React__default.createElement(Typography$1
            // category="Default"
            // variant="Caption"
            // style={{ lineHeight: 1, whiteSpace: "nowrap" }}
            // htmlColor={LightColors.primary["2"]}
            , { 
                // category="Default"
                // variant="Caption"
                // style={{ lineHeight: 1, whiteSpace: "nowrap" }}
                // htmlColor={LightColors.primary["2"]}
                style: {
                    lineHeight: 1,
                    whiteSpace: 'nowrap',
                    color: LightColors.primary['2'],
                    fontSize: 8,
                } }, speedValue)))));
    contentDiv.appendChild(labelDiv);
    // 내 대시캠 zIndex 2x
    if (loc.active === 'off') {
        el.style.zIndex = '20';
    }
    else {
        el.style.zIndex = '21';
    }
    // 공유 대시캠 zIndex 1x
    if (loc.isPublic) {
        if (loc.share_video === 'on') {
            el.style.zIndex = '11';
        }
        else {
            el.style.zIndex = '10';
        }
    }
    el.appendChild(contentDiv);
    // Add markers to the map.
    var marker = new mapboxgl.Marker(el, {
        // anchor: "bottom",
        anchor: 'bottom',
        offset: [0, 0],
    })
        .setLngLat([loc.lng, loc.lat])
        .addTo(map);
    return Object.assign(marker, { psn: loc.psn, loc: loc });
};
var makeLocationOnlyLabel = function (map, loc, t) {
    var el = document.createElement('div');
    el.className = 'marker';
    el.style.zIndex = '50';
    var contentDiv = document.createElement('div');
    contentDiv.style.width = '160px';
    contentDiv.style.padding = '12px 8px';
    contentDiv.style.backgroundColor = LightColors.primary['0'];
    contentDiv.style.borderRadius = '4px';
    contentDiv.style.border = "1px sloid ".concat(LightColors.primary['6']);
    contentDiv.style.display = 'flex';
    contentDiv.style.alignItems = 'center';
    contentDiv.style.lineHeight = '1.2';
    contentDiv.innerText = t('This camera is publicly_');
    el.appendChild(contentDiv);
    // Add markers to the map.
    var marker = new mapboxgl.Marker(el, {
        // anchor: "bottom",
        anchor: 'bottom',
        offset: [0, -64],
    })
        .setLngLat([loc.lng, loc.lat])
        .addTo(map);
    return Object.assign(marker, { psn: loc.psn, loc: loc });
};

var mapboxGlDraw = {exports: {}};

(function (module, exports) {
	!function(t,e){module.exports=e();}(commonjsGlobal,(function(){var t=function(t,e){var n={drag:[],click:[],mousemove:[],mousedown:[],mouseup:[],mouseout:[],keydown:[],keyup:[],touchstart:[],touchmove:[],touchend:[],tap:[]},o={on:function(t,e,o){if(void 0===n[t])throw new Error("Invalid event type: "+t);n[t].push({selector:e,fn:o});},render:function(t){e.store.featureChanged(t);}},r=function(t,r){for(var i=n[t],a=i.length;a--;){var s=i[a];if(s.selector(r)){s.fn.call(o,r)||e.store.render(),e.ui.updateMapClasses();break}}};return t.start.call(o),{render:t.render,stop:function(){t.stop&&t.stop();},trash:function(){t.trash&&(t.trash(),e.store.render());},combineFeatures:function(){t.combineFeatures&&t.combineFeatures();},uncombineFeatures:function(){t.uncombineFeatures&&t.uncombineFeatures();},drag:function(t){r("drag",t);},click:function(t){r("click",t);},mousemove:function(t){r("mousemove",t);},mousedown:function(t){r("mousedown",t);},mouseup:function(t){r("mouseup",t);},mouseout:function(t){r("mouseout",t);},keydown:function(t){r("keydown",t);},keyup:function(t){r("keyup",t);},touchstart:function(t){r("touchstart",t);},touchmove:function(t){r("touchmove",t);},touchend:function(t){r("touchend",t);},tap:function(t){r("tap",t);}}};function e(t){return t&&t.__esModule&&Object.prototype.hasOwnProperty.call(t,"default")?t.default:t}function n(t){if(t.__esModule)return t;var e=t.default;if("function"==typeof e){var n=function t(){if(this instanceof t){var n=[null];n.push.apply(n,arguments);var o=Function.bind.apply(e,n);return new o}return e.apply(this,arguments)};n.prototype=e.prototype;}else n={};return Object.defineProperty(n,"__esModule",{value:!0}),Object.keys(t).forEach((function(e){var o=Object.getOwnPropertyDescriptor(t,e);Object.defineProperty(n,e,o.get?o:{enumerable:!0,get:function(){return t[e]}});})),n}var o={},r={RADIUS:6378137,FLATTENING:1/298.257223563,POLAR_RADIUS:6356752.3142},i=r;function a(t){var e=0;if(t&&t.length>0){e+=Math.abs(s(t[0]));for(var n=1;n<t.length;n++)e-=Math.abs(s(t[n]));}return e}function s(t){var e,n,o,r,a,s,c=0,l=t.length;if(l>2){for(s=0;s<l;s++)s===l-2?(o=l-2,r=l-1,a=0):s===l-1?(o=l-1,r=0,a=1):(o=s,r=s+1,a=s+2),e=t[o],n=t[r],c+=(u(t[a][0])-u(e[0]))*Math.sin(u(n[1]));c=c*i.RADIUS*i.RADIUS/2;}return c}function u(t){return t*Math.PI/180}o.geometry=function t(e){var n,o=0;switch(e.type){case"Polygon":return a(e.coordinates);case"MultiPolygon":for(n=0;n<e.coordinates.length;n++)o+=a(e.coordinates[n]);return o;case"Point":case"MultiPoint":case"LineString":case"MultiLineString":return 0;case"GeometryCollection":for(n=0;n<e.geometries.length;n++)o+=t(e.geometries[n]);return o}},o.ring=s;var c={CONTROL_BASE:"mapboxgl-ctrl",CONTROL_PREFIX:"mapboxgl-ctrl-",CONTROL_BUTTON:"mapbox-gl-draw_ctrl-draw-btn",CONTROL_BUTTON_LINE:"mapbox-gl-draw_line",CONTROL_BUTTON_POLYGON:"mapbox-gl-draw_polygon",CONTROL_BUTTON_POINT:"mapbox-gl-draw_point",CONTROL_BUTTON_TRASH:"mapbox-gl-draw_trash",CONTROL_BUTTON_COMBINE_FEATURES:"mapbox-gl-draw_combine",CONTROL_BUTTON_UNCOMBINE_FEATURES:"mapbox-gl-draw_uncombine",CONTROL_GROUP:"mapboxgl-ctrl-group",ATTRIBUTION:"mapboxgl-ctrl-attrib",ACTIVE_BUTTON:"active",BOX_SELECT:"mapbox-gl-draw_boxselect"},l={HOT:"mapbox-gl-draw-hot",COLD:"mapbox-gl-draw-cold"},d={ADD:"add",MOVE:"move",DRAG:"drag",POINTER:"pointer",NONE:"none"},p={POLYGON:"polygon",LINE:"line_string",POINT:"point"},f={FEATURE:"Feature",POLYGON:"Polygon",LINE_STRING:"LineString",POINT:"Point",FEATURE_COLLECTION:"FeatureCollection",MULTI_PREFIX:"Multi",MULTI_POINT:"MultiPoint",MULTI_LINE_STRING:"MultiLineString",MULTI_POLYGON:"MultiPolygon"},h={DRAW_LINE_STRING:"draw_line_string",DRAW_POLYGON:"draw_polygon",DRAW_POINT:"draw_point",SIMPLE_SELECT:"simple_select",DIRECT_SELECT:"direct_select",STATIC:"static"},g={CREATE:"draw.create",DELETE:"draw.delete",UPDATE:"draw.update",SELECTION_CHANGE:"draw.selectionchange",MODE_CHANGE:"draw.modechange",ACTIONABLE:"draw.actionable",RENDER:"draw.render",COMBINE_FEATURES:"draw.combine",UNCOMBINE_FEATURES:"draw.uncombine"},y={MOVE:"move",CHANGE_COORDINATES:"change_coordinates"},v={FEATURE:"feature",MIDPOINT:"midpoint",VERTEX:"vertex"},m={ACTIVE:"true",INACTIVE:"false"},_=["scrollZoom","boxZoom","dragRotate","dragPan","keyboard","doubleClickZoom","touchZoomRotate"],b=-85,E=Object.freeze({__proto__:null,classes:c,sources:l,cursors:d,types:p,geojsonTypes:f,modes:h,events:g,updateActions:y,meta:v,activeStates:m,interactions:_,LAT_MIN:-90,LAT_RENDERED_MIN:b,LAT_MAX:90,LAT_RENDERED_MAX:85,LNG_MIN:-270,LNG_MAX:270}),T={Point:0,LineString:1,MultiLineString:1,Polygon:2};function C(t,e){var n=T[t.geometry.type]-T[e.geometry.type];return 0===n&&t.geometry.type===f.POLYGON?t.area-e.area:n}function O(t){return t.map((function(t){return t.geometry.type===f.POLYGON&&(t.area=o.geometry({type:f.FEATURE,property:{},geometry:t.geometry})),t})).sort(C).map((function(t){return delete t.area,t}))}function S(t,e){return void 0===e&&(e=0),[[t.point.x-e,t.point.y-e],[t.point.x+e,t.point.y+e]]}function I(t){if(this._items={},this._nums={},this._length=t?t.length:0,t)for(var e=0,n=t.length;e<n;e++)this.add(t[e]),void 0!==t[e]&&("string"==typeof t[e]?this._items[t[e]]=e:this._nums[t[e]]=e);}I.prototype.add=function(t){return this.has(t)||(this._length++,"string"==typeof t?this._items[t]=this._length:this._nums[t]=this._length),this},I.prototype.delete=function(t){return !1===this.has(t)||(this._length--,delete this._items[t],delete this._nums[t]),this},I.prototype.has=function(t){return ("string"==typeof t||"number"==typeof t)&&(void 0!==this._items[t]||void 0!==this._nums[t])},I.prototype.values=function(){var t=this,e=[];return Object.keys(this._items).forEach((function(n){e.push({k:n,v:t._items[n]});})),Object.keys(this._nums).forEach((function(n){e.push({k:JSON.parse(n),v:t._nums[n]});})),e.sort((function(t,e){return t.v-e.v})).map((function(t){return t.k}))},I.prototype.clear=function(){return this._length=0,this._items={},this._nums={},this};var x=[v.FEATURE,v.MIDPOINT,v.VERTEX],M={click:function(t,e,n){return L(t,e,n,n.options.clickBuffer)},touch:function(t,e,n){return L(t,e,n,n.options.touchBuffer)}};function L(t,e,n,o){if(null===n.map)return [];var r=t?S(t,o):e,i={};n.options.styles&&(i.layers=n.options.styles.map((function(t){return t.id})).filter((function(t){return null!=n.map.getLayer(t)})));var a=n.map.queryRenderedFeatures(r,i).filter((function(t){return -1!==x.indexOf(t.properties.meta)})),s=new I,u=[];return a.forEach((function(t){var e=t.properties.id;s.has(e)||(s.add(e),u.push(t));})),O(u)}function N(t,e){var n=M.click(t,null,e),o={mouse:d.NONE};return n[0]&&(o.mouse=n[0].properties.active===m.ACTIVE?d.MOVE:d.POINTER,o.feature=n[0].properties.meta),-1!==e.events.currentModeName().indexOf("draw")&&(o.mouse=d.ADD),e.ui.queueMapClasses(o),e.ui.updateMapClasses(),n[0]}function A(t,e){var n=t.x-e.x,o=t.y-e.y;return Math.sqrt(n*n+o*o)}function P(t,e,n){void 0===n&&(n={});var o=null!=n.fineTolerance?n.fineTolerance:4,r=null!=n.grossTolerance?n.grossTolerance:12,i=null!=n.interval?n.interval:500;t.point=t.point||e.point,t.time=t.time||e.time;var a=A(t.point,e.point);return a<o||a<r&&e.time-t.time<i}function F(t,e,n){void 0===n&&(n={});var o=null!=n.tolerance?n.tolerance:25,r=null!=n.interval?n.interval:250;return t.point=t.point||e.point,t.time=t.time||e.time,A(t.point,e.point)<o&&e.time-t.time<r}var w={exports:{}},R=w.exports=function(t,e){if(e||(e=16),void 0===t&&(t=128),t<=0)return "0";for(var n=Math.log(Math.pow(2,t))/Math.log(e),o=2;n===1/0;o*=2)n=Math.log(Math.pow(2,t/o))/Math.log(e)*o;var r=n-Math.floor(n),i="";for(o=0;o<Math.floor(n);o++){i=Math.floor(Math.random()*e).toString(e)+i;}if(r){var a=Math.pow(e,r);i=Math.floor(Math.random()*a).toString(e)+i;}var s=parseInt(i,e);return s!==1/0&&s>=Math.pow(2,t)?R(t,e):i};R.rack=function(t,e,n){var o=function(o){var i=0;do{if(i++>10){if(!n)throw new Error("too many ID collisions, use more bits");t+=n;}var a=R(t,e);}while(Object.hasOwnProperty.call(r,a));return r[a]=o,a},r=o.hats={};return o.get=function(t){return o.hats[t]},o.set=function(t,e){return o.hats[t]=e,o},o.bits=t||128,o.base=e||16,o};var k=e(w.exports),D=function(t,e){this.ctx=t,this.properties=e.properties||{},this.coordinates=e.geometry.coordinates,this.id=e.id||k(),this.type=e.geometry.type;};D.prototype.changed=function(){this.ctx.store.featureChanged(this.id);},D.prototype.incomingCoords=function(t){this.setCoordinates(t);},D.prototype.setCoordinates=function(t){this.coordinates=t,this.changed();},D.prototype.getCoordinates=function(){return JSON.parse(JSON.stringify(this.coordinates))},D.prototype.setProperty=function(t,e){this.properties[t]=e;},D.prototype.toGeoJSON=function(){return JSON.parse(JSON.stringify({id:this.id,type:f.FEATURE,properties:this.properties,geometry:{coordinates:this.getCoordinates(),type:this.type}}))},D.prototype.internal=function(t){var e={id:this.id,meta:v.FEATURE,"meta:type":this.type,active:m.INACTIVE,mode:t};if(this.ctx.options.userProperties)for(var n in this.properties)e["user_"+n]=this.properties[n];return {type:f.FEATURE,properties:e,geometry:{coordinates:this.getCoordinates(),type:this.type}}};var U=function(t,e){D.call(this,t,e);};(U.prototype=Object.create(D.prototype)).isValid=function(){return "number"==typeof this.coordinates[0]&&"number"==typeof this.coordinates[1]},U.prototype.updateCoordinate=function(t,e,n){this.coordinates=3===arguments.length?[e,n]:[t,e],this.changed();},U.prototype.getCoordinate=function(){return this.getCoordinates()};var j=function(t,e){D.call(this,t,e);};(j.prototype=Object.create(D.prototype)).isValid=function(){return this.coordinates.length>1},j.prototype.addCoordinate=function(t,e,n){this.changed();var o=parseInt(t,10);this.coordinates.splice(o,0,[e,n]);},j.prototype.getCoordinate=function(t){var e=parseInt(t,10);return JSON.parse(JSON.stringify(this.coordinates[e]))},j.prototype.removeCoordinate=function(t){this.changed(),this.coordinates.splice(parseInt(t,10),1);},j.prototype.updateCoordinate=function(t,e,n){var o=parseInt(t,10);this.coordinates[o]=[e,n],this.changed();};var V=function(t,e){D.call(this,t,e),this.coordinates=this.coordinates.map((function(t){return t.slice(0,-1)}));};(V.prototype=Object.create(D.prototype)).isValid=function(){return 0!==this.coordinates.length&&this.coordinates.every((function(t){return t.length>2}))},V.prototype.incomingCoords=function(t){this.coordinates=t.map((function(t){return t.slice(0,-1)})),this.changed();},V.prototype.setCoordinates=function(t){this.coordinates=t,this.changed();},V.prototype.addCoordinate=function(t,e,n){this.changed();var o=t.split(".").map((function(t){return parseInt(t,10)}));this.coordinates[o[0]].splice(o[1],0,[e,n]);},V.prototype.removeCoordinate=function(t){this.changed();var e=t.split(".").map((function(t){return parseInt(t,10)})),n=this.coordinates[e[0]];n&&(n.splice(e[1],1),n.length<3&&this.coordinates.splice(e[0],1));},V.prototype.getCoordinate=function(t){var e=t.split(".").map((function(t){return parseInt(t,10)})),n=this.coordinates[e[0]];return JSON.parse(JSON.stringify(n[e[1]]))},V.prototype.getCoordinates=function(){return this.coordinates.map((function(t){return t.concat([t[0]])}))},V.prototype.updateCoordinate=function(t,e,n){this.changed();var o=t.split("."),r=parseInt(o[0],10),i=parseInt(o[1],10);void 0===this.coordinates[r]&&(this.coordinates[r]=[]),this.coordinates[r][i]=[e,n];};var B={MultiPoint:U,MultiLineString:j,MultiPolygon:V},G=function(t,e,n,o,r){var i=n.split("."),a=parseInt(i[0],10),s=i[1]?i.slice(1).join("."):null;return t[a][e](s,o,r)},J=function(t,e){if(D.call(this,t,e),delete this.coordinates,this.model=B[e.geometry.type],void 0===this.model)throw new TypeError(e.geometry.type+" is not a valid type");this.features=this._coordinatesToFeatures(e.geometry.coordinates);};function z(t){this.map=t.map,this.drawConfig=JSON.parse(JSON.stringify(t.options||{})),this._ctx=t;}(J.prototype=Object.create(D.prototype))._coordinatesToFeatures=function(t){var e=this,n=this.model.bind(this);return t.map((function(t){return new n(e.ctx,{id:k(),type:f.FEATURE,properties:{},geometry:{coordinates:t,type:e.type.replace("Multi","")}})}))},J.prototype.isValid=function(){return this.features.every((function(t){return t.isValid()}))},J.prototype.setCoordinates=function(t){this.features=this._coordinatesToFeatures(t),this.changed();},J.prototype.getCoordinate=function(t){return G(this.features,"getCoordinate",t)},J.prototype.getCoordinates=function(){return JSON.parse(JSON.stringify(this.features.map((function(t){return t.type===f.POLYGON?t.getCoordinates():t.coordinates}))))},J.prototype.updateCoordinate=function(t,e,n){G(this.features,"updateCoordinate",t,e,n),this.changed();},J.prototype.addCoordinate=function(t,e,n){G(this.features,"addCoordinate",t,e,n),this.changed();},J.prototype.removeCoordinate=function(t){G(this.features,"removeCoordinate",t),this.changed();},J.prototype.getFeatures=function(){return this.features},z.prototype.setSelected=function(t){return this._ctx.store.setSelected(t)},z.prototype.setSelectedCoordinates=function(t){var e=this;this._ctx.store.setSelectedCoordinates(t),t.reduce((function(t,n){return void 0===t[n.feature_id]&&(t[n.feature_id]=!0,e._ctx.store.get(n.feature_id).changed()),t}),{});},z.prototype.getSelected=function(){return this._ctx.store.getSelected()},z.prototype.getSelectedIds=function(){return this._ctx.store.getSelectedIds()},z.prototype.isSelected=function(t){return this._ctx.store.isSelected(t)},z.prototype.getFeature=function(t){return this._ctx.store.get(t)},z.prototype.select=function(t){return this._ctx.store.select(t)},z.prototype.deselect=function(t){return this._ctx.store.deselect(t)},z.prototype.deleteFeature=function(t,e){return void 0===e&&(e={}),this._ctx.store.delete(t,e)},z.prototype.addFeature=function(t){return this._ctx.store.add(t)},z.prototype.clearSelectedFeatures=function(){return this._ctx.store.clearSelected()},z.prototype.clearSelectedCoordinates=function(){return this._ctx.store.clearSelectedCoordinates()},z.prototype.setActionableState=function(t){void 0===t&&(t={});var e={trash:t.trash||!1,combineFeatures:t.combineFeatures||!1,uncombineFeatures:t.uncombineFeatures||!1};return this._ctx.events.actionable(e)},z.prototype.changeMode=function(t,e,n){return void 0===e&&(e={}),void 0===n&&(n={}),this._ctx.events.changeMode(t,e,n)},z.prototype.updateUIClasses=function(t){return this._ctx.ui.queueMapClasses(t)},z.prototype.activateUIButton=function(t){return this._ctx.ui.setActiveButton(t)},z.prototype.featuresAt=function(t,e,n){if(void 0===n&&(n="click"),"click"!==n&&"touch"!==n)throw new Error("invalid buffer type");return M[n](t,e,this._ctx)},z.prototype.newFeature=function(t){var e=t.geometry.type;return e===f.POINT?new U(this._ctx,t):e===f.LINE_STRING?new j(this._ctx,t):e===f.POLYGON?new V(this._ctx,t):new J(this._ctx,t)},z.prototype.isInstanceOf=function(t,e){if(t===f.POINT)return e instanceof U;if(t===f.LINE_STRING)return e instanceof j;if(t===f.POLYGON)return e instanceof V;if("MultiFeature"===t)return e instanceof J;throw new Error("Unknown feature class: "+t)},z.prototype.doRender=function(t){return this._ctx.store.featureChanged(t)},z.prototype.onSetup=function(){},z.prototype.onDrag=function(){},z.prototype.onClick=function(){},z.prototype.onMouseMove=function(){},z.prototype.onMouseDown=function(){},z.prototype.onMouseUp=function(){},z.prototype.onMouseOut=function(){},z.prototype.onKeyUp=function(){},z.prototype.onKeyDown=function(){},z.prototype.onTouchStart=function(){},z.prototype.onTouchMove=function(){},z.prototype.onTouchEnd=function(){},z.prototype.onTap=function(){},z.prototype.onStop=function(){},z.prototype.onTrash=function(){},z.prototype.onCombineFeature=function(){},z.prototype.onUncombineFeature=function(){},z.prototype.toDisplayFeatures=function(){throw new Error("You must overwrite toDisplayFeatures")};var Y={drag:"onDrag",click:"onClick",mousemove:"onMouseMove",mousedown:"onMouseDown",mouseup:"onMouseUp",mouseout:"onMouseOut",keyup:"onKeyUp",keydown:"onKeyDown",touchstart:"onTouchStart",touchmove:"onTouchMove",touchend:"onTouchEnd",tap:"onTap"},$=Object.keys(Y);function q(t){var e=Object.keys(t);return function(n,o){void 0===o&&(o={});var r={},i=e.reduce((function(e,n){return e[n]=t[n],e}),new z(n));return {start:function(){var e=this;r=i.onSetup(o),$.forEach((function(n){var o,a=Y[n],s=function(){return !1};t[a]&&(s=function(){return !0}),e.on(n,s,(o=a,function(t){return i[o](r,t)}));}));},stop:function(){i.onStop(r);},trash:function(){i.onTrash(r);},combineFeatures:function(){i.onCombineFeatures(r);},uncombineFeatures:function(){i.onUncombineFeatures(r);},render:function(t,e){i.toDisplayFeatures(r,t,e);}}}}function H(t){return [].concat(t).filter((function(t){return void 0!==t}))}function X(){var t=this;if(!(t.ctx.map&&void 0!==t.ctx.map.getSource(l.HOT)))return u();var e=t.ctx.events.currentModeName();t.ctx.ui.queueMapClasses({mode:e});var n=[],o=[];t.isDirty?o=t.getAllIds():(n=t.getChangedIds().filter((function(e){return void 0!==t.get(e)})),o=t.sources.hot.filter((function(e){return e.properties.id&&-1===n.indexOf(e.properties.id)&&void 0!==t.get(e.properties.id)})).map((function(t){return t.properties.id}))),t.sources.hot=[];var r=t.sources.cold.length;t.sources.cold=t.isDirty?[]:t.sources.cold.filter((function(t){var e=t.properties.id||t.properties.parent;return -1===n.indexOf(e)}));var i=r!==t.sources.cold.length||o.length>0;function a(n,o){var r=t.get(n).internal(e);t.ctx.events.currentModeRender(r,(function(e){t.sources[o].push(e);}));}if(n.forEach((function(t){return a(t,"hot")})),o.forEach((function(t){return a(t,"cold")})),i&&t.ctx.map.getSource(l.COLD).setData({type:f.FEATURE_COLLECTION,features:t.sources.cold}),t.ctx.map.getSource(l.HOT).setData({type:f.FEATURE_COLLECTION,features:t.sources.hot}),t._emitSelectionChange&&(t.ctx.map.fire(g.SELECTION_CHANGE,{features:t.getSelected().map((function(t){return t.toGeoJSON()})),points:t.getSelectedCoordinates().map((function(t){return {type:f.FEATURE,properties:{},geometry:{type:f.POINT,coordinates:t.coordinates}}}))}),t._emitSelectionChange=!1),t._deletedFeaturesToEmit.length){var s=t._deletedFeaturesToEmit.map((function(t){return t.toGeoJSON()}));t._deletedFeaturesToEmit=[],t.ctx.map.fire(g.DELETE,{features:s});}function u(){t.isDirty=!1,t.clearChangedIds();}u(),t.ctx.map.fire(g.RENDER,{});}function Z(t){var e,n=this;this._features={},this._featureIds=new I,this._selectedFeatureIds=new I,this._selectedCoordinates=[],this._changedFeatureIds=new I,this._deletedFeaturesToEmit=[],this._emitSelectionChange=!1,this._mapInitialConfig={},this.ctx=t,this.sources={hot:[],cold:[]},this.render=function(){e||(e=requestAnimationFrame((function(){e=null,X.call(n);})));},this.isDirty=!1;}function W(t,e){var n=t._selectedCoordinates.filter((function(e){return t._selectedFeatureIds.has(e.feature_id)}));t._selectedCoordinates.length===n.length||e.silent||(t._emitSelectionChange=!0),t._selectedCoordinates=n;}Z.prototype.createRenderBatch=function(){var t=this,e=this.render,n=0;return this.render=function(){n++;},function(){t.render=e,n>0&&t.render();}},Z.prototype.setDirty=function(){return this.isDirty=!0,this},Z.prototype.featureChanged=function(t){return this._changedFeatureIds.add(t),this},Z.prototype.getChangedIds=function(){return this._changedFeatureIds.values()},Z.prototype.clearChangedIds=function(){return this._changedFeatureIds.clear(),this},Z.prototype.getAllIds=function(){return this._featureIds.values()},Z.prototype.add=function(t){return this.featureChanged(t.id),this._features[t.id]=t,this._featureIds.add(t.id),this},Z.prototype.delete=function(t,e){var n=this;return void 0===e&&(e={}),H(t).forEach((function(t){n._featureIds.has(t)&&(n._featureIds.delete(t),n._selectedFeatureIds.delete(t),e.silent||-1===n._deletedFeaturesToEmit.indexOf(n._features[t])&&n._deletedFeaturesToEmit.push(n._features[t]),delete n._features[t],n.isDirty=!0);})),W(this,e),this},Z.prototype.get=function(t){return this._features[t]},Z.prototype.getAll=function(){var t=this;return Object.keys(this._features).map((function(e){return t._features[e]}))},Z.prototype.select=function(t,e){var n=this;return void 0===e&&(e={}),H(t).forEach((function(t){n._selectedFeatureIds.has(t)||(n._selectedFeatureIds.add(t),n._changedFeatureIds.add(t),e.silent||(n._emitSelectionChange=!0));})),this},Z.prototype.deselect=function(t,e){var n=this;return void 0===e&&(e={}),H(t).forEach((function(t){n._selectedFeatureIds.has(t)&&(n._selectedFeatureIds.delete(t),n._changedFeatureIds.add(t),e.silent||(n._emitSelectionChange=!0));})),W(this,e),this},Z.prototype.clearSelected=function(t){return void 0===t&&(t={}),this.deselect(this._selectedFeatureIds.values(),{silent:t.silent}),this},Z.prototype.setSelected=function(t,e){var n=this;return void 0===e&&(e={}),t=H(t),this.deselect(this._selectedFeatureIds.values().filter((function(e){return -1===t.indexOf(e)})),{silent:e.silent}),this.select(t.filter((function(t){return !n._selectedFeatureIds.has(t)})),{silent:e.silent}),this},Z.prototype.setSelectedCoordinates=function(t){return this._selectedCoordinates=t,this._emitSelectionChange=!0,this},Z.prototype.clearSelectedCoordinates=function(){return this._selectedCoordinates=[],this._emitSelectionChange=!0,this},Z.prototype.getSelectedIds=function(){return this._selectedFeatureIds.values()},Z.prototype.getSelected=function(){var t=this;return this._selectedFeatureIds.values().map((function(e){return t.get(e)}))},Z.prototype.getSelectedCoordinates=function(){var t=this;return this._selectedCoordinates.map((function(e){return {coordinates:t.get(e.feature_id).getCoordinate(e.coord_path)}}))},Z.prototype.isSelected=function(t){return this._selectedFeatureIds.has(t)},Z.prototype.setFeatureProperty=function(t,e,n){this.get(t).setProperty(e,n),this.featureChanged(t);},Z.prototype.storeMapConfig=function(){var t=this;_.forEach((function(e){t.ctx.map[e]&&(t._mapInitialConfig[e]=t.ctx.map[e].isEnabled());}));},Z.prototype.restoreMapConfig=function(){var t=this;Object.keys(this._mapInitialConfig).forEach((function(e){t._mapInitialConfig[e]?t.ctx.map[e].enable():t.ctx.map[e].disable();}));},Z.prototype.getInitialConfigValue=function(t){return void 0===this._mapInitialConfig[t]||this._mapInitialConfig[t]};var K=function(){for(var t=arguments,e={},n=0;n<arguments.length;n++){var o=t[n];for(var r in o)Q.call(o,r)&&(e[r]=o[r]);}return e},Q=Object.prototype.hasOwnProperty;var tt=e(K),et=["mode","feature","mouse"];function nt(e){var n=null,o=null,r={onRemove:function(){return e.map.off("load",r.connect),clearInterval(o),r.removeLayers(),e.store.restoreMapConfig(),e.ui.removeButtons(),e.events.removeEventListeners(),e.ui.clearMapClasses(),e.boxZoomInitial&&e.map.boxZoom.enable(),e.map=null,e.container=null,e.store=null,n&&n.parentNode&&n.parentNode.removeChild(n),n=null,this},connect:function(){e.map.off("load",r.connect),clearInterval(o),r.addLayers(),e.store.storeMapConfig(),e.events.addEventListeners();},onAdd:function(i){var a=i.fire;return i.fire=function(t,e){var n=arguments;return 1===a.length&&1!==arguments.length&&(n=[tt({},{type:t},e)]),a.apply(i,n)},e.map=i,e.events=function(e){var n=Object.keys(e.options.modes).reduce((function(t,n){return t[n]=q(e.options.modes[n]),t}),{}),o={},r={},i={},a=null,s=null;i.drag=function(t,n){n({point:t.point,time:(new Date).getTime()})?(e.ui.queueMapClasses({mouse:d.DRAG}),s.drag(t)):t.originalEvent.stopPropagation();},i.mousedrag=function(t){i.drag(t,(function(t){return !P(o,t)}));},i.touchdrag=function(t){i.drag(t,(function(t){return !F(r,t)}));},i.mousemove=function(t){if(1===(void 0!==t.originalEvent.buttons?t.originalEvent.buttons:t.originalEvent.which))return i.mousedrag(t);var n=N(t,e);t.featureTarget=n,s.mousemove(t);},i.mousedown=function(t){o={time:(new Date).getTime(),point:t.point};var n=N(t,e);t.featureTarget=n,s.mousedown(t);},i.mouseup=function(t){var n=N(t,e);t.featureTarget=n,P(o,{point:t.point,time:(new Date).getTime()})?s.click(t):s.mouseup(t);},i.mouseout=function(t){s.mouseout(t);},i.touchstart=function(t){if(e.options.touchEnabled){r={time:(new Date).getTime(),point:t.point};var n=M.touch(t,null,e)[0];t.featureTarget=n,s.touchstart(t);}},i.touchmove=function(t){if(e.options.touchEnabled)return s.touchmove(t),i.touchdrag(t)},i.touchend=function(t){if(t.originalEvent.preventDefault(),e.options.touchEnabled){var n=M.touch(t,null,e)[0];t.featureTarget=n,F(r,{time:(new Date).getTime(),point:t.point})?s.tap(t):s.touchend(t);}};var u=function(t){return !(8===t||46===t||t>=48&&t<=57)};function c(o,r,i){void 0===i&&(i={}),s.stop();var u=n[o];if(void 0===u)throw new Error(o+" is not valid");a=o;var c=u(e,r);s=t(c,e),i.silent||e.map.fire(g.MODE_CHANGE,{mode:o}),e.store.setDirty(),e.store.render();}i.keydown=function(t){(t.srcElement||t.target).classList.contains("mapboxgl-canvas")&&(8!==t.keyCode&&46!==t.keyCode||!e.options.controls.trash?u(t.keyCode)?s.keydown(t):49===t.keyCode&&e.options.controls.point?c(h.DRAW_POINT):50===t.keyCode&&e.options.controls.line_string?c(h.DRAW_LINE_STRING):51===t.keyCode&&e.options.controls.polygon&&c(h.DRAW_POLYGON):(t.preventDefault(),s.trash()));},i.keyup=function(t){u(t.keyCode)&&s.keyup(t);},i.zoomend=function(){e.store.changeZoom();},i.data=function(t){if("style"===t.dataType){var n=e.setup,o=e.map,r=e.options,i=e.store;r.styles.some((function(t){return o.getLayer(t.id)}))||(n.addLayers(),i.setDirty(),i.render());}};var l={trash:!1,combineFeatures:!1,uncombineFeatures:!1};return {start:function(){a=e.options.defaultMode,s=t(n[a](e),e);},changeMode:c,actionable:function(t){var n=!1;Object.keys(t).forEach((function(e){if(void 0===l[e])throw new Error("Invalid action type");l[e]!==t[e]&&(n=!0),l[e]=t[e];})),n&&e.map.fire(g.ACTIONABLE,{actions:l});},currentModeName:function(){return a},currentModeRender:function(t,e){return s.render(t,e)},fire:function(t,e){i[t]&&i[t](e);},addEventListeners:function(){e.map.on("mousemove",i.mousemove),e.map.on("mousedown",i.mousedown),e.map.on("mouseup",i.mouseup),e.map.on("data",i.data),e.map.on("touchmove",i.touchmove),e.map.on("touchstart",i.touchstart),e.map.on("touchend",i.touchend),e.container.addEventListener("mouseout",i.mouseout),e.options.keybindings&&(e.container.addEventListener("keydown",i.keydown),e.container.addEventListener("keyup",i.keyup));},removeEventListeners:function(){e.map.off("mousemove",i.mousemove),e.map.off("mousedown",i.mousedown),e.map.off("mouseup",i.mouseup),e.map.off("data",i.data),e.map.off("touchmove",i.touchmove),e.map.off("touchstart",i.touchstart),e.map.off("touchend",i.touchend),e.container.removeEventListener("mouseout",i.mouseout),e.options.keybindings&&(e.container.removeEventListener("keydown",i.keydown),e.container.removeEventListener("keyup",i.keyup));},trash:function(t){s.trash(t);},combineFeatures:function(){s.combineFeatures();},uncombineFeatures:function(){s.uncombineFeatures();},getMode:function(){return a}}}(e),e.ui=function(t){var e={},n=null,o={mode:null,feature:null,mouse:null},r={mode:null,feature:null,mouse:null};function i(t){r=tt(r,t);}function a(){var e,n;if(t.container){var i=[],a=[];et.forEach((function(t){r[t]!==o[t]&&(i.push(t+"-"+o[t]),null!==r[t]&&a.push(t+"-"+r[t]));})),i.length>0&&(e=t.container.classList).remove.apply(e,i),a.length>0&&(n=t.container.classList).add.apply(n,a),o=tt(o,r);}}function s(t,e){void 0===e&&(e={});var o=document.createElement("button");return o.className=c.CONTROL_BUTTON+" "+e.className,o.setAttribute("title",e.title),e.container.appendChild(o),o.addEventListener("click",(function(o){if(o.preventDefault(),o.stopPropagation(),o.target===n)return u(),void e.onDeactivate();l(t),e.onActivate();}),!0),o}function u(){n&&(n.classList.remove(c.ACTIVE_BUTTON),n=null);}function l(t){u();var o=e[t];o&&o&&"trash"!==t&&(o.classList.add(c.ACTIVE_BUTTON),n=o);}return {setActiveButton:l,queueMapClasses:i,updateMapClasses:a,clearMapClasses:function(){i({mode:null,feature:null,mouse:null}),a();},addButtons:function(){var n=t.options.controls,o=document.createElement("div");return o.className=c.CONTROL_GROUP+" "+c.CONTROL_BASE,n?(n[p.LINE]&&(e[p.LINE]=s(p.LINE,{container:o,className:c.CONTROL_BUTTON_LINE,title:"LineString tool "+(t.options.keybindings?"(l)":""),onActivate:function(){return t.events.changeMode(h.DRAW_LINE_STRING)},onDeactivate:function(){return t.events.trash()}})),n[p.POLYGON]&&(e[p.POLYGON]=s(p.POLYGON,{container:o,className:c.CONTROL_BUTTON_POLYGON,title:"Polygon tool "+(t.options.keybindings?"(p)":""),onActivate:function(){return t.events.changeMode(h.DRAW_POLYGON)},onDeactivate:function(){return t.events.trash()}})),n[p.POINT]&&(e[p.POINT]=s(p.POINT,{container:o,className:c.CONTROL_BUTTON_POINT,title:"Marker tool "+(t.options.keybindings?"(m)":""),onActivate:function(){return t.events.changeMode(h.DRAW_POINT)},onDeactivate:function(){return t.events.trash()}})),n.trash&&(e.trash=s("trash",{container:o,className:c.CONTROL_BUTTON_TRASH,title:"Delete",onActivate:function(){t.events.trash();}})),n.combine_features&&(e.combine_features=s("combineFeatures",{container:o,className:c.CONTROL_BUTTON_COMBINE_FEATURES,title:"Combine",onActivate:function(){t.events.combineFeatures();}})),n.uncombine_features&&(e.uncombine_features=s("uncombineFeatures",{container:o,className:c.CONTROL_BUTTON_UNCOMBINE_FEATURES,title:"Uncombine",onActivate:function(){t.events.uncombineFeatures();}})),o):o},removeButtons:function(){Object.keys(e).forEach((function(t){var n=e[t];n.parentNode&&n.parentNode.removeChild(n),delete e[t];}));}}}(e),e.container=i.getContainer(),e.store=new Z(e),n=e.ui.addButtons(),e.options.boxSelect&&(e.boxZoomInitial=i.boxZoom.isEnabled(),i.boxZoom.disable(),i.dragPan.disable(),i.dragPan.enable()),i.loaded()?r.connect():(i.on("load",r.connect),o=setInterval((function(){i.loaded()&&r.connect();}),16)),e.events.start(),n},addLayers:function(){e.map.addSource(l.COLD,{data:{type:f.FEATURE_COLLECTION,features:[]},type:"geojson"}),e.map.addSource(l.HOT,{data:{type:f.FEATURE_COLLECTION,features:[]},type:"geojson"}),e.options.styles.forEach((function(t){e.map.addLayer(t);})),e.store.setDirty(!0),e.store.render();},removeLayers:function(){e.options.styles.forEach((function(t){e.map.getLayer(t.id)&&e.map.removeLayer(t.id);})),e.map.getSource(l.COLD)&&e.map.removeSource(l.COLD),e.map.getSource(l.HOT)&&e.map.removeSource(l.HOT);}};return e.setup=r,r}var ot=[{id:"gl-draw-polygon-fill-inactive",type:"fill",filter:["all",["==","active","false"],["==","$type","Polygon"],["!=","mode","static"]],paint:{"fill-color":"#3bb2d0","fill-outline-color":"#3bb2d0","fill-opacity":.1}},{id:"gl-draw-polygon-fill-active",type:"fill",filter:["all",["==","active","true"],["==","$type","Polygon"]],paint:{"fill-color":"#fbb03b","fill-outline-color":"#fbb03b","fill-opacity":.1}},{id:"gl-draw-polygon-midpoint",type:"circle",filter:["all",["==","$type","Point"],["==","meta","midpoint"]],paint:{"circle-radius":3,"circle-color":"#fbb03b"}},{id:"gl-draw-polygon-stroke-inactive",type:"line",filter:["all",["==","active","false"],["==","$type","Polygon"],["!=","mode","static"]],layout:{"line-cap":"round","line-join":"round"},paint:{"line-color":"#3bb2d0","line-width":2}},{id:"gl-draw-polygon-stroke-active",type:"line",filter:["all",["==","active","true"],["==","$type","Polygon"]],layout:{"line-cap":"round","line-join":"round"},paint:{"line-color":"#fbb03b","line-dasharray":[.2,2],"line-width":2}},{id:"gl-draw-line-inactive",type:"line",filter:["all",["==","active","false"],["==","$type","LineString"],["!=","mode","static"]],layout:{"line-cap":"round","line-join":"round"},paint:{"line-color":"#3bb2d0","line-width":2}},{id:"gl-draw-line-active",type:"line",filter:["all",["==","$type","LineString"],["==","active","true"]],layout:{"line-cap":"round","line-join":"round"},paint:{"line-color":"#fbb03b","line-dasharray":[.2,2],"line-width":2}},{id:"gl-draw-polygon-and-line-vertex-stroke-inactive",type:"circle",filter:["all",["==","meta","vertex"],["==","$type","Point"],["!=","mode","static"]],paint:{"circle-radius":5,"circle-color":"#fff"}},{id:"gl-draw-polygon-and-line-vertex-inactive",type:"circle",filter:["all",["==","meta","vertex"],["==","$type","Point"],["!=","mode","static"]],paint:{"circle-radius":3,"circle-color":"#fbb03b"}},{id:"gl-draw-point-point-stroke-inactive",type:"circle",filter:["all",["==","active","false"],["==","$type","Point"],["==","meta","feature"],["!=","mode","static"]],paint:{"circle-radius":5,"circle-opacity":1,"circle-color":"#fff"}},{id:"gl-draw-point-inactive",type:"circle",filter:["all",["==","active","false"],["==","$type","Point"],["==","meta","feature"],["!=","mode","static"]],paint:{"circle-radius":3,"circle-color":"#3bb2d0"}},{id:"gl-draw-point-stroke-active",type:"circle",filter:["all",["==","$type","Point"],["==","active","true"],["!=","meta","midpoint"]],paint:{"circle-radius":7,"circle-color":"#fff"}},{id:"gl-draw-point-active",type:"circle",filter:["all",["==","$type","Point"],["!=","meta","midpoint"],["==","active","true"]],paint:{"circle-radius":5,"circle-color":"#fbb03b"}},{id:"gl-draw-polygon-fill-static",type:"fill",filter:["all",["==","mode","static"],["==","$type","Polygon"]],paint:{"fill-color":"#404040","fill-outline-color":"#404040","fill-opacity":.1}},{id:"gl-draw-polygon-stroke-static",type:"line",filter:["all",["==","mode","static"],["==","$type","Polygon"]],layout:{"line-cap":"round","line-join":"round"},paint:{"line-color":"#404040","line-width":2}},{id:"gl-draw-line-static",type:"line",filter:["all",["==","mode","static"],["==","$type","LineString"]],layout:{"line-cap":"round","line-join":"round"},paint:{"line-color":"#404040","line-width":2}},{id:"gl-draw-point-static",type:"circle",filter:["all",["==","mode","static"],["==","$type","Point"]],paint:{"circle-radius":5,"circle-color":"#404040"}}];function rt(t){return function(e){var n=e.featureTarget;return !!n&&(!!n.properties&&n.properties.meta===t)}}function it(t){return !!t.originalEvent&&(!!t.originalEvent.shiftKey&&0===t.originalEvent.button)}function at(t){return !!t.featureTarget&&(!!t.featureTarget.properties&&(t.featureTarget.properties.active===m.ACTIVE&&t.featureTarget.properties.meta===v.FEATURE))}function st(t){return !!t.featureTarget&&(!!t.featureTarget.properties&&(t.featureTarget.properties.active===m.INACTIVE&&t.featureTarget.properties.meta===v.FEATURE))}function ut(t){return void 0===t.featureTarget}function ct(t){return !!t.featureTarget&&(!!t.featureTarget.properties&&t.featureTarget.properties.meta===v.FEATURE)}function lt(t){var e=t.featureTarget;return !!e&&(!!e.properties&&e.properties.meta===v.VERTEX)}function dt(t){return !!t.originalEvent&&!0===t.originalEvent.shiftKey}function pt(t){return 27===t.keyCode}function ft(t){return 13===t.keyCode}var ht=Object.freeze({__proto__:null,isOfMetaType:rt,isShiftMousedown:it,isActiveFeature:at,isInactiveFeature:st,noTarget:ut,isFeature:ct,isVertex:lt,isShiftDown:dt,isEscapeKey:pt,isEnterKey:ft,isTrue:function(){return !0}}),gt=yt;function yt(t,e){this.x=t,this.y=e;}yt.prototype={clone:function(){return new yt(this.x,this.y)},add:function(t){return this.clone()._add(t)},sub:function(t){return this.clone()._sub(t)},multByPoint:function(t){return this.clone()._multByPoint(t)},divByPoint:function(t){return this.clone()._divByPoint(t)},mult:function(t){return this.clone()._mult(t)},div:function(t){return this.clone()._div(t)},rotate:function(t){return this.clone()._rotate(t)},rotateAround:function(t,e){return this.clone()._rotateAround(t,e)},matMult:function(t){return this.clone()._matMult(t)},unit:function(){return this.clone()._unit()},perp:function(){return this.clone()._perp()},round:function(){return this.clone()._round()},mag:function(){return Math.sqrt(this.x*this.x+this.y*this.y)},equals:function(t){return this.x===t.x&&this.y===t.y},dist:function(t){return Math.sqrt(this.distSqr(t))},distSqr:function(t){var e=t.x-this.x,n=t.y-this.y;return e*e+n*n},angle:function(){return Math.atan2(this.y,this.x)},angleTo:function(t){return Math.atan2(this.y-t.y,this.x-t.x)},angleWith:function(t){return this.angleWithSep(t.x,t.y)},angleWithSep:function(t,e){return Math.atan2(this.x*e-this.y*t,this.x*t+this.y*e)},_matMult:function(t){var e=t[0]*this.x+t[1]*this.y,n=t[2]*this.x+t[3]*this.y;return this.x=e,this.y=n,this},_add:function(t){return this.x+=t.x,this.y+=t.y,this},_sub:function(t){return this.x-=t.x,this.y-=t.y,this},_mult:function(t){return this.x*=t,this.y*=t,this},_div:function(t){return this.x/=t,this.y/=t,this},_multByPoint:function(t){return this.x*=t.x,this.y*=t.y,this},_divByPoint:function(t){return this.x/=t.x,this.y/=t.y,this},_unit:function(){return this._div(this.mag()),this},_perp:function(){var t=this.y;return this.y=this.x,this.x=-t,this},_rotate:function(t){var e=Math.cos(t),n=Math.sin(t),o=e*this.x-n*this.y,r=n*this.x+e*this.y;return this.x=o,this.y=r,this},_rotateAround:function(t,e){var n=Math.cos(t),o=Math.sin(t),r=e.x+n*(this.x-e.x)-o*(this.y-e.y),i=e.y+o*(this.x-e.x)+n*(this.y-e.y);return this.x=r,this.y=i,this},_round:function(){return this.x=Math.round(this.x),this.y=Math.round(this.y),this}},yt.convert=function(t){return t instanceof yt?t:Array.isArray(t)?new yt(t[0],t[1]):t};var vt=e(gt);function mt(t,e){var n=e.getBoundingClientRect();return new vt(t.clientX-n.left-(e.clientLeft||0),t.clientY-n.top-(e.clientTop||0))}function _t(t,e,n,o){return {type:f.FEATURE,properties:{meta:v.VERTEX,parent:t,coord_path:n,active:o?m.ACTIVE:m.INACTIVE},geometry:{type:f.POINT,coordinates:e}}}function bt(t,e,n){var o=e.geometry.coordinates,r=n.geometry.coordinates;if(o[1]>85||o[1]<b||r[1]>85||r[1]<b)return null;var i={lng:(o[0]+r[0])/2,lat:(o[1]+r[1])/2};return {type:f.FEATURE,properties:{meta:v.MIDPOINT,parent:t,lng:i.lng,lat:i.lat,coord_path:n.properties.coord_path},geometry:{type:f.POINT,coordinates:[i.lng,i.lat]}}}function Et(t,e,n){void 0===e&&(e={}),void 0===n&&(n=null);var o,r=t.geometry,i=r.type,a=r.coordinates,s=t.properties&&t.properties.id,u=[];function c(t,n){var o="",r=null;t.forEach((function(t,i){var a=null!=n?n+"."+i:String(i),c=_t(s,t,a,l(a));if(e.midpoints&&r){var d=bt(s,r,c);d&&u.push(d);}r=c;var p=JSON.stringify(t);o!==p&&u.push(c),0===i&&(o=p);}));}function l(t){return !!e.selectedPaths&&-1!==e.selectedPaths.indexOf(t)}return i===f.POINT?u.push(_t(s,a,n,l(n))):i===f.POLYGON?a.forEach((function(t,e){c(t,null!==n?n+"."+e:String(e));})):i===f.LINE_STRING?c(a,n):0===i.indexOf(f.MULTI_PREFIX)&&(o=i.replace(f.MULTI_PREFIX,""),a.forEach((function(n,r){var i={type:f.FEATURE,properties:t.properties,geometry:{type:o,coordinates:n}};u=u.concat(Et(i,e,r));}))),u}var Tt={enable:function(t){setTimeout((function(){t.map&&t.map.doubleClickZoom&&t._ctx&&t._ctx.store&&t._ctx.store.getInitialConfigValue&&t._ctx.store.getInitialConfigValue("doubleClickZoom")&&t.map.doubleClickZoom.enable();}),0);},disable:function(t){setTimeout((function(){t.map&&t.map.doubleClickZoom&&t.map.doubleClickZoom.disable();}),0);}},Ct={exports:{}},Ot=function(t){if(!t||!t.type)return null;var e=St[t.type];if(!e)return null;if("geometry"===e)return {type:"FeatureCollection",features:[{type:"Feature",properties:{},geometry:t}]};if("feature"===e)return {type:"FeatureCollection",features:[t]};if("featurecollection"===e)return t},St={Point:"geometry",MultiPoint:"geometry",LineString:"geometry",MultiLineString:"geometry",Polygon:"geometry",MultiPolygon:"geometry",GeometryCollection:"geometry",Feature:"feature",FeatureCollection:"featurecollection"};var It=e(Ot);var xt=Object.freeze({__proto__:null,default:function t(e){switch(e&&e.type||null){case"FeatureCollection":return e.features=e.features.reduce((function(e,n){return e.concat(t(n))}),[]),e;case"Feature":return e.geometry?t(e.geometry).map((function(t){var n={type:"Feature",properties:JSON.parse(JSON.stringify(e.properties)),geometry:t};return void 0!==e.id&&(n.id=e.id),n})):[e];case"MultiPoint":return e.coordinates.map((function(t){return {type:"Point",coordinates:t}}));case"MultiPolygon":return e.coordinates.map((function(t){return {type:"Polygon",coordinates:t}}));case"MultiLineString":return e.coordinates.map((function(t){return {type:"LineString",coordinates:t}}));case"GeometryCollection":return e.geometries.map(t).reduce((function(t,e){return t.concat(e)}),[]);case"Point":case"Polygon":case"LineString":return [e]}}}),Mt=Ot,Lt=n(xt),Nt=function(t){return function t(e){if(Array.isArray(e)&&e.length&&"number"==typeof e[0])return [e];return e.reduce((function(e,n){return Array.isArray(n)&&Array.isArray(n[0])?e.concat(t(n)):(e.push(n),e)}),[])}(t)};Lt instanceof Function||(Lt=Lt.default);var At={exports:{}},Pt=At.exports=function(t){return new Ft(t)};function Ft(t){this.value=t;}function wt(t,e,n){var o=[],r=[],i=!0;return function t(a){var s=n?Rt(a):a,u={},c=!0,l={node:s,node_:a,path:[].concat(o),parent:r[r.length-1],parents:r,key:o.slice(-1)[0],isRoot:0===o.length,level:o.length,circular:null,update:function(t,e){l.isRoot||(l.parent.node[l.key]=t),l.node=t,e&&(c=!1);},delete:function(t){delete l.parent.node[l.key],t&&(c=!1);},remove:function(t){Ut(l.parent.node)?l.parent.node.splice(l.key,1):delete l.parent.node[l.key],t&&(c=!1);},keys:null,before:function(t){u.before=t;},after:function(t){u.after=t;},pre:function(t){u.pre=t;},post:function(t){u.post=t;},stop:function(){i=!1;},block:function(){c=!1;}};if(!i)return l;function d(){if("object"==typeof l.node&&null!==l.node){l.keys&&l.node_===l.node||(l.keys=kt(l.node)),l.isLeaf=0==l.keys.length;for(var t=0;t<r.length;t++)if(r[t].node_===a){l.circular=r[t];break}}else l.isLeaf=!0,l.keys=null;l.notLeaf=!l.isLeaf,l.notRoot=!l.isRoot;}d();var p=e.call(l,l.node);return void 0!==p&&l.update&&l.update(p),u.before&&u.before.call(l,l.node),c?("object"!=typeof l.node||null===l.node||l.circular||(r.push(l),d(),jt(l.keys,(function(e,r){o.push(e),u.pre&&u.pre.call(l,l.node[e],e);var i=t(l.node[e]);n&&Vt.call(l.node,e)&&(l.node[e]=i.node),i.isLast=r==l.keys.length-1,i.isFirst=0==r,u.post&&u.post.call(l,i),o.pop();})),r.pop()),u.after&&u.after.call(l,l.node),l):l}(t).node}function Rt(t){if("object"==typeof t&&null!==t){var e;if(Ut(t))e=[];else if("[object Date]"===Dt(t))e=new Date(t.getTime?t.getTime():t);else if(function(t){return "[object RegExp]"===Dt(t)}(t))e=new RegExp(t);else if(function(t){return "[object Error]"===Dt(t)}(t))e={message:t.message};else if(function(t){return "[object Boolean]"===Dt(t)}(t))e=new Boolean(t);else if(function(t){return "[object Number]"===Dt(t)}(t))e=new Number(t);else if(function(t){return "[object String]"===Dt(t)}(t))e=new String(t);else if(Object.create&&Object.getPrototypeOf)e=Object.create(Object.getPrototypeOf(t));else if(t.constructor===Object)e={};else {var n=t.constructor&&t.constructor.prototype||t.__proto__||{},o=function(){};o.prototype=n,e=new o;}return jt(kt(t),(function(n){e[n]=t[n];})),e}return t}Ft.prototype.get=function(t){for(var e=this.value,n=0;n<t.length;n++){var o=t[n];if(!e||!Vt.call(e,o)){e=void 0;break}e=e[o];}return e},Ft.prototype.has=function(t){for(var e=this.value,n=0;n<t.length;n++){var o=t[n];if(!e||!Vt.call(e,o))return !1;e=e[o];}return !0},Ft.prototype.set=function(t,e){for(var n=this.value,o=0;o<t.length-1;o++){var r=t[o];Vt.call(n,r)||(n[r]={}),n=n[r];}return n[t[o]]=e,e},Ft.prototype.map=function(t){return wt(this.value,t,!0)},Ft.prototype.forEach=function(t){return this.value=wt(this.value,t,!1),this.value},Ft.prototype.reduce=function(t,e){var n=1===arguments.length,o=n?this.value:e;return this.forEach((function(e){this.isRoot&&n||(o=t.call(this,o,e));})),o},Ft.prototype.paths=function(){var t=[];return this.forEach((function(e){t.push(this.path);})),t},Ft.prototype.nodes=function(){var t=[];return this.forEach((function(e){t.push(this.node);})),t},Ft.prototype.clone=function(){var t=[],e=[];return function n(o){for(var r=0;r<t.length;r++)if(t[r]===o)return e[r];if("object"==typeof o&&null!==o){var i=Rt(o);return t.push(o),e.push(i),jt(kt(o),(function(t){i[t]=n(o[t]);})),t.pop(),e.pop(),i}return o}(this.value)};var kt=Object.keys||function(t){var e=[];for(var n in t)e.push(n);return e};function Dt(t){return Object.prototype.toString.call(t)}var Ut=Array.isArray||function(t){return "[object Array]"===Object.prototype.toString.call(t)},jt=function(t,e){if(t.forEach)return t.forEach(e);for(var n=0;n<t.length;n++)e(t[n],n,t);};jt(kt(Ft.prototype),(function(t){Pt[t]=function(e){var n=[].slice.call(arguments,1),o=new Ft(e);return o[t].apply(o,n)};}));var Vt=Object.hasOwnProperty||function(t,e){return e in t},Bt=At.exports,Gt=Jt;function Jt(t){if(!(this instanceof Jt))return new Jt(t);this._bbox=t||[1/0,1/0,-1/0,-1/0],this._valid=!!t;}Jt.prototype.include=function(t){return this._valid=!0,this._bbox[0]=Math.min(this._bbox[0],t[0]),this._bbox[1]=Math.min(this._bbox[1],t[1]),this._bbox[2]=Math.max(this._bbox[2],t[0]),this._bbox[3]=Math.max(this._bbox[3],t[1]),this},Jt.prototype.equals=function(t){var e;return e=t instanceof Jt?t.bbox():t,this._bbox[0]==e[0]&&this._bbox[1]==e[1]&&this._bbox[2]==e[2]&&this._bbox[3]==e[3]},Jt.prototype.center=function(t){return this._valid?[(this._bbox[0]+this._bbox[2])/2,(this._bbox[1]+this._bbox[3])/2]:null},Jt.prototype.union=function(t){var e;return this._valid=!0,e=t instanceof Jt?t.bbox():t,this._bbox[0]=Math.min(this._bbox[0],e[0]),this._bbox[1]=Math.min(this._bbox[1],e[1]),this._bbox[2]=Math.max(this._bbox[2],e[2]),this._bbox[3]=Math.max(this._bbox[3],e[3]),this},Jt.prototype.bbox=function(){return this._valid?this._bbox:null},Jt.prototype.contains=function(t){if(!t)return this._fastContains();if(!this._valid)return null;var e=t[0],n=t[1];return this._bbox[0]<=e&&this._bbox[1]<=n&&this._bbox[2]>=e&&this._bbox[3]>=n},Jt.prototype.intersect=function(t){return this._valid?(e=t instanceof Jt?t.bbox():t,!(this._bbox[0]>e[2]||this._bbox[2]<e[0]||this._bbox[3]<e[1]||this._bbox[1]>e[3])):null;var e;},Jt.prototype._fastContains=function(){if(!this._valid)return new Function("return null;");var t="return "+this._bbox[0]+"<= ll[0] &&"+this._bbox[1]+"<= ll[1] &&"+this._bbox[2]+">= ll[0] &&"+this._bbox[3]+">= ll[1]";return new Function("ll",t)},Jt.prototype.polygon=function(){return this._valid?{type:"Polygon",coordinates:[[[this._bbox[0],this._bbox[1]],[this._bbox[2],this._bbox[1]],[this._bbox[2],this._bbox[3]],[this._bbox[0],this._bbox[3]],[this._bbox[0],this._bbox[1]]]]}:null};var zt=function(t){if(!t)return [];var e=Lt(Mt(t)),n=[];return e.features.forEach((function(t){t.geometry&&(n=n.concat(Nt(t.geometry.coordinates)));})),n},Yt=Bt,$t=Gt,qt={features:["FeatureCollection"],coordinates:["Point","MultiPoint","LineString","MultiLineString","Polygon","MultiPolygon"],geometry:["Feature"],geometries:["GeometryCollection"]},Ht=Object.keys(qt);function Xt(t){for(var e=$t(),n=zt(t),o=0;o<n.length;o++)e.include(n[o]);return e}Ct.exports=function(t){return Xt(t).bbox()},Ct.exports.polygon=function(t){return Xt(t).polygon()},Ct.exports.bboxify=function(t){return Yt(t).map((function(t){t&&(Ht.some((function(e){return !!t[e]&&-1!==qt[e].indexOf(t.type)}))&&(t.bbox=Xt(t).bbox(),this.update(t)));}))};var Zt=e(Ct.exports),Wt=-90;function Kt(t,e){var n=Wt,o=90,r=Wt,i=90,a=270,s=-270;t.forEach((function(t){var e=Zt(t),u=e[1],c=e[3],l=e[0],d=e[2];u>n&&(n=u),c<o&&(o=c),c>r&&(r=c),u<i&&(i=u),l<a&&(a=l),d>s&&(s=d);}));var u=e;return n+u.lat>85&&(u.lat=85-n),r+u.lat>90&&(u.lat=90-r),o+u.lat<-85&&(u.lat=-85-o),i+u.lat<Wt&&(u.lat=Wt-i),a+u.lng<=-270&&(u.lng+=360*Math.ceil(Math.abs(u.lng)/360)),s+u.lng>=270&&(u.lng-=360*Math.ceil(Math.abs(u.lng)/360)),u}function Qt(t,e){var n=Kt(t.map((function(t){return t.toGeoJSON()})),e);t.forEach((function(t){var e,o=t.getCoordinates(),r=function(t){var e={lng:t[0]+n.lng,lat:t[1]+n.lat};return [e.lng,e.lat]},i=function(t){return t.map((function(t){return r(t)}))};t.type===f.POINT?e=r(o):t.type===f.LINE_STRING||t.type===f.MULTI_POINT?e=o.map(r):t.type===f.POLYGON||t.type===f.MULTI_LINE_STRING?e=o.map(i):t.type===f.MULTI_POLYGON&&(e=o.map((function(t){return t.map((function(t){return i(t)}))}))),t.incomingCoords(e);}));}var te={onSetup:function(t){var e=this,n={dragMoveLocation:null,boxSelectStartLocation:null,boxSelectElement:void 0,boxSelecting:!1,canBoxSelect:!1,dragMoving:!1,canDragMove:!1,initiallySelectedFeatureIds:t.featureIds||[]};return this.setSelected(n.initiallySelectedFeatureIds.filter((function(t){return void 0!==e.getFeature(t)}))),this.fireActionable(),this.setActionableState({combineFeatures:!0,uncombineFeatures:!0,trash:!0}),n},fireUpdate:function(){this.map.fire(g.UPDATE,{action:y.MOVE,features:this.getSelected().map((function(t){return t.toGeoJSON()}))});},fireActionable:function(){var t=this,e=this.getSelected(),n=e.filter((function(e){return t.isInstanceOf("MultiFeature",e)})),o=!1;if(e.length>1){o=!0;var r=e[0].type.replace("Multi","");e.forEach((function(t){t.type.replace("Multi","")!==r&&(o=!1);}));}var i=n.length>0,a=e.length>0;this.setActionableState({combineFeatures:o,uncombineFeatures:i,trash:a});},getUniqueIds:function(t){return t.length?t.map((function(t){return t.properties.id})).filter((function(t){return void 0!==t})).reduce((function(t,e){return t.add(e),t}),new I).values():[]},stopExtendedInteractions:function(t){t.boxSelectElement&&(t.boxSelectElement.parentNode&&t.boxSelectElement.parentNode.removeChild(t.boxSelectElement),t.boxSelectElement=null),this.map.dragPan.enable(),t.boxSelecting=!1,t.canBoxSelect=!1,t.dragMoving=!1,t.canDragMove=!1;},onStop:function(){Tt.enable(this);},onMouseMove:function(t,e){return ct(e)&&t.dragMoving&&this.fireUpdate(),this.stopExtendedInteractions(t),!0},onMouseOut:function(t){return !t.dragMoving||this.fireUpdate()}};te.onTap=te.onClick=function(t,e){return ut(e)?this.clickAnywhere(t,e):rt(v.VERTEX)(e)?this.clickOnVertex(t,e):ct(e)?this.clickOnFeature(t,e):void 0},te.clickAnywhere=function(t){var e=this,n=this.getSelectedIds();n.length&&(this.clearSelectedFeatures(),n.forEach((function(t){return e.doRender(t)}))),Tt.enable(this),this.stopExtendedInteractions(t);},te.clickOnVertex=function(t,e){this.changeMode(h.DIRECT_SELECT,{featureId:e.featureTarget.properties.parent,coordPath:e.featureTarget.properties.coord_path,startPos:e.lngLat}),this.updateUIClasses({mouse:d.MOVE});},te.startOnActiveFeature=function(t,e){this.stopExtendedInteractions(t),this.map.dragPan.disable(),this.doRender(e.featureTarget.properties.id),t.canDragMove=!0,t.dragMoveLocation=e.lngLat;},te.clickOnFeature=function(t,e){var n=this;Tt.disable(this),this.stopExtendedInteractions(t);var o=dt(e),r=this.getSelectedIds(),i=e.featureTarget.properties.id,a=this.isSelected(i);if(!o&&a&&this.getFeature(i).type!==f.POINT)return this.changeMode(h.DIRECT_SELECT,{featureId:i});a&&o?(this.deselect(i),this.updateUIClasses({mouse:d.POINTER}),1===r.length&&Tt.enable(this)):!a&&o?(this.select(i),this.updateUIClasses({mouse:d.MOVE})):a||o||(r.forEach((function(t){return n.doRender(t)})),this.setSelected(i),this.updateUIClasses({mouse:d.MOVE})),this.doRender(i);},te.onMouseDown=function(t,e){return at(e)?this.startOnActiveFeature(t,e):this.drawConfig.boxSelect&&it(e)?this.startBoxSelect(t,e):void 0},te.startBoxSelect=function(t,e){this.stopExtendedInteractions(t),this.map.dragPan.disable(),t.boxSelectStartLocation=mt(e.originalEvent,this.map.getContainer()),t.canBoxSelect=!0;},te.onTouchStart=function(t,e){if(at(e))return this.startOnActiveFeature(t,e)},te.onDrag=function(t,e){return t.canDragMove?this.dragMove(t,e):this.drawConfig.boxSelect&&t.canBoxSelect?this.whileBoxSelect(t,e):void 0},te.whileBoxSelect=function(t,e){t.boxSelecting=!0,this.updateUIClasses({mouse:d.ADD}),t.boxSelectElement||(t.boxSelectElement=document.createElement("div"),t.boxSelectElement.classList.add(c.BOX_SELECT),this.map.getContainer().appendChild(t.boxSelectElement));var n=mt(e.originalEvent,this.map.getContainer()),o=Math.min(t.boxSelectStartLocation.x,n.x),r=Math.max(t.boxSelectStartLocation.x,n.x),i=Math.min(t.boxSelectStartLocation.y,n.y),a=Math.max(t.boxSelectStartLocation.y,n.y),s="translate("+o+"px, "+i+"px)";t.boxSelectElement.style.transform=s,t.boxSelectElement.style.WebkitTransform=s,t.boxSelectElement.style.width=r-o+"px",t.boxSelectElement.style.height=a-i+"px";},te.dragMove=function(t,e){t.dragMoving=!0,e.originalEvent.stopPropagation();var n={lng:e.lngLat.lng-t.dragMoveLocation.lng,lat:e.lngLat.lat-t.dragMoveLocation.lat};Qt(this.getSelected(),n),t.dragMoveLocation=e.lngLat;},te.onTouchEnd=te.onMouseUp=function(t,e){var n=this;if(t.dragMoving)this.fireUpdate();else if(t.boxSelecting){var o=[t.boxSelectStartLocation,mt(e.originalEvent,this.map.getContainer())],r=this.featuresAt(null,o,"click"),i=this.getUniqueIds(r).filter((function(t){return !n.isSelected(t)}));i.length&&(this.select(i),i.forEach((function(t){return n.doRender(t)})),this.updateUIClasses({mouse:d.MOVE}));}this.stopExtendedInteractions(t);},te.toDisplayFeatures=function(t,e,n){e.properties.active=this.isSelected(e.properties.id)?m.ACTIVE:m.INACTIVE,n(e),this.fireActionable(),e.properties.active===m.ACTIVE&&e.geometry.type!==f.POINT&&Et(e).forEach(n);},te.onTrash=function(){this.deleteFeature(this.getSelectedIds()),this.fireActionable();},te.onCombineFeatures=function(){var t=this.getSelected();if(!(0===t.length||t.length<2)){for(var e=[],n=[],o=t[0].type.replace("Multi",""),r=0;r<t.length;r++){var i=t[r];if(i.type.replace("Multi","")!==o)return;i.type.includes("Multi")?i.getCoordinates().forEach((function(t){e.push(t);})):e.push(i.getCoordinates()),n.push(i.toGeoJSON());}if(n.length>1){var a=this.newFeature({type:f.FEATURE,properties:n[0].properties,geometry:{type:"Multi"+o,coordinates:e}});this.addFeature(a),this.deleteFeature(this.getSelectedIds(),{silent:!0}),this.setSelected([a.id]),this.map.fire(g.COMBINE_FEATURES,{createdFeatures:[a.toGeoJSON()],deletedFeatures:n});}this.fireActionable();}},te.onUncombineFeatures=function(){var t=this,e=this.getSelected();if(0!==e.length){for(var n=[],o=[],r=function(r){var i=e[r];t.isInstanceOf("MultiFeature",i)&&(i.getFeatures().forEach((function(e){t.addFeature(e),e.properties=i.properties,n.push(e.toGeoJSON()),t.select([e.id]);})),t.deleteFeature(i.id,{silent:!0}),o.push(i.toGeoJSON()));},i=0;i<e.length;i++)r(i);n.length>1&&this.map.fire(g.UNCOMBINE_FEATURES,{createdFeatures:n,deletedFeatures:o}),this.fireActionable();}};var ee=rt(v.VERTEX),ne=rt(v.MIDPOINT),oe={fireUpdate:function(){this.map.fire(g.UPDATE,{action:y.CHANGE_COORDINATES,features:this.getSelected().map((function(t){return t.toGeoJSON()}))});},fireActionable:function(t){this.setActionableState({combineFeatures:!1,uncombineFeatures:!1,trash:t.selectedCoordPaths.length>0});},startDragging:function(t,e){this.map.dragPan.disable(),t.canDragMove=!0,t.dragMoveLocation=e.lngLat;},stopDragging:function(t){this.map.dragPan.enable(),t.dragMoving=!1,t.canDragMove=!1,t.dragMoveLocation=null;},onVertex:function(t,e){this.startDragging(t,e);var n=e.featureTarget.properties,o=t.selectedCoordPaths.indexOf(n.coord_path);dt(e)||-1!==o?dt(e)&&-1===o&&t.selectedCoordPaths.push(n.coord_path):t.selectedCoordPaths=[n.coord_path];var r=this.pathsToCoordinates(t.featureId,t.selectedCoordPaths);this.setSelectedCoordinates(r);},onMidpoint:function(t,e){this.startDragging(t,e);var n=e.featureTarget.properties;t.feature.addCoordinate(n.coord_path,n.lng,n.lat),this.fireUpdate(),t.selectedCoordPaths=[n.coord_path];},pathsToCoordinates:function(t,e){return e.map((function(e){return {feature_id:t,coord_path:e}}))},onFeature:function(t,e){0===t.selectedCoordPaths.length?this.startDragging(t,e):this.stopDragging(t);},dragFeature:function(t,e,n){Qt(this.getSelected(),n),t.dragMoveLocation=e.lngLat;},dragVertex:function(t,e,n){for(var o=t.selectedCoordPaths.map((function(e){return t.feature.getCoordinate(e)})),r=Kt(o.map((function(t){return {type:f.FEATURE,properties:{},geometry:{type:f.POINT,coordinates:t}}})),n),i=0;i<o.length;i++){var a=o[i];t.feature.updateCoordinate(t.selectedCoordPaths[i],a[0]+r.lng,a[1]+r.lat);}},clickNoTarget:function(){this.changeMode(h.SIMPLE_SELECT);},clickInactive:function(){this.changeMode(h.SIMPLE_SELECT);},clickActiveFeature:function(t){t.selectedCoordPaths=[],this.clearSelectedCoordinates(),t.feature.changed();},onSetup:function(t){var e=t.featureId,n=this.getFeature(e);if(!n)throw new Error("You must provide a featureId to enter direct_select mode");if(n.type===f.POINT)throw new TypeError("direct_select mode doesn't handle point features");var o={featureId:e,feature:n,dragMoveLocation:t.startPos||null,dragMoving:!1,canDragMove:!1,selectedCoordPaths:t.coordPath?[t.coordPath]:[]};return this.setSelectedCoordinates(this.pathsToCoordinates(e,o.selectedCoordPaths)),this.setSelected(e),Tt.disable(this),this.setActionableState({trash:!0}),o},onStop:function(){Tt.enable(this),this.clearSelectedCoordinates();},toDisplayFeatures:function(t,e,n){t.featureId===e.properties.id?(e.properties.active=m.ACTIVE,n(e),Et(e,{map:this.map,midpoints:!0,selectedPaths:t.selectedCoordPaths}).forEach(n)):(e.properties.active=m.INACTIVE,n(e)),this.fireActionable(t);},onTrash:function(t){t.selectedCoordPaths.sort((function(t,e){return e.localeCompare(t,"en",{numeric:!0})})).forEach((function(e){return t.feature.removeCoordinate(e)})),this.fireUpdate(),t.selectedCoordPaths=[],this.clearSelectedCoordinates(),this.fireActionable(t),!1===t.feature.isValid()&&(this.deleteFeature([t.featureId]),this.changeMode(h.SIMPLE_SELECT,{}));},onMouseMove:function(t,e){var n=at(e),o=ee(e),r=ne(e),i=0===t.selectedCoordPaths.length;return n&&i||o&&!i?this.updateUIClasses({mouse:d.MOVE}):this.updateUIClasses({mouse:d.NONE}),(o||n||r)&&t.dragMoving&&this.fireUpdate(),this.stopDragging(t),!0},onMouseOut:function(t){return t.dragMoving&&this.fireUpdate(),!0}};oe.onTouchStart=oe.onMouseDown=function(t,e){return ee(e)?this.onVertex(t,e):at(e)?this.onFeature(t,e):ne(e)?this.onMidpoint(t,e):void 0},oe.onDrag=function(t,e){if(!0===t.canDragMove){t.dragMoving=!0,e.originalEvent.stopPropagation();var n={lng:e.lngLat.lng-t.dragMoveLocation.lng,lat:e.lngLat.lat-t.dragMoveLocation.lat};t.selectedCoordPaths.length>0?this.dragVertex(t,e,n):this.dragFeature(t,e,n),t.dragMoveLocation=e.lngLat;}},oe.onClick=function(t,e){return ut(e)?this.clickNoTarget(t,e):at(e)?this.clickActiveFeature(t,e):st(e)?this.clickInactive(t,e):void this.stopDragging(t)},oe.onTap=function(t,e){return ut(e)?this.clickNoTarget(t,e):at(e)?this.clickActiveFeature(t,e):st(e)?this.clickInactive(t,e):void 0},oe.onTouchEnd=oe.onMouseUp=function(t){t.dragMoving&&this.fireUpdate(),this.stopDragging(t);};var re={};function ie(t,e){return !!t.lngLat&&(t.lngLat.lng===e[0]&&t.lngLat.lat===e[1])}re.onSetup=function(){var t=this.newFeature({type:f.FEATURE,properties:{},geometry:{type:f.POINT,coordinates:[]}});return this.addFeature(t),this.clearSelectedFeatures(),this.updateUIClasses({mouse:d.ADD}),this.activateUIButton(p.POINT),this.setActionableState({trash:!0}),{point:t}},re.stopDrawingAndRemove=function(t){this.deleteFeature([t.point.id],{silent:!0}),this.changeMode(h.SIMPLE_SELECT);},re.onTap=re.onClick=function(t,e){this.updateUIClasses({mouse:d.MOVE}),t.point.updateCoordinate("",e.lngLat.lng,e.lngLat.lat),this.map.fire(g.CREATE,{features:[t.point.toGeoJSON()]}),this.changeMode(h.SIMPLE_SELECT,{featureIds:[t.point.id]});},re.onStop=function(t){this.activateUIButton(),t.point.getCoordinate().length||this.deleteFeature([t.point.id],{silent:!0});},re.toDisplayFeatures=function(t,e,n){var o=e.properties.id===t.point.id;if(e.properties.active=o?m.ACTIVE:m.INACTIVE,!o)return n(e)},re.onTrash=re.stopDrawingAndRemove,re.onKeyUp=function(t,e){if(pt(e)||ft(e))return this.stopDrawingAndRemove(t,e)};var ae={onSetup:function(){var t=this.newFeature({type:f.FEATURE,properties:{},geometry:{type:f.POLYGON,coordinates:[[]]}});return this.addFeature(t),this.clearSelectedFeatures(),Tt.disable(this),this.updateUIClasses({mouse:d.ADD}),this.activateUIButton(p.POLYGON),this.setActionableState({trash:!0}),{polygon:t,currentVertexPosition:0}},clickAnywhere:function(t,e){if(t.currentVertexPosition>0&&ie(e,t.polygon.coordinates[0][t.currentVertexPosition-1]))return this.changeMode(h.SIMPLE_SELECT,{featureIds:[t.polygon.id]});this.updateUIClasses({mouse:d.ADD}),t.polygon.updateCoordinate("0."+t.currentVertexPosition,e.lngLat.lng,e.lngLat.lat),t.currentVertexPosition++,t.polygon.updateCoordinate("0."+t.currentVertexPosition,e.lngLat.lng,e.lngLat.lat);},clickOnVertex:function(t){return this.changeMode(h.SIMPLE_SELECT,{featureIds:[t.polygon.id]})},onMouseMove:function(t,e){t.polygon.updateCoordinate("0."+t.currentVertexPosition,e.lngLat.lng,e.lngLat.lat),lt(e)&&this.updateUIClasses({mouse:d.POINTER});}};ae.onTap=ae.onClick=function(t,e){return lt(e)?this.clickOnVertex(t,e):this.clickAnywhere(t,e)},ae.onKeyUp=function(t,e){pt(e)?(this.deleteFeature([t.polygon.id],{silent:!0}),this.changeMode(h.SIMPLE_SELECT)):ft(e)&&this.changeMode(h.SIMPLE_SELECT,{featureIds:[t.polygon.id]});},ae.onStop=function(t){this.updateUIClasses({mouse:d.NONE}),Tt.enable(this),this.activateUIButton(),void 0!==this.getFeature(t.polygon.id)&&(t.polygon.removeCoordinate("0."+t.currentVertexPosition),t.polygon.isValid()?this.map.fire(g.CREATE,{features:[t.polygon.toGeoJSON()]}):(this.deleteFeature([t.polygon.id],{silent:!0}),this.changeMode(h.SIMPLE_SELECT,{},{silent:!0})));},ae.toDisplayFeatures=function(t,e,n){var o=e.properties.id===t.polygon.id;if(e.properties.active=o?m.ACTIVE:m.INACTIVE,!o)return n(e);if(0!==e.geometry.coordinates.length){var r=e.geometry.coordinates[0].length;if(!(r<3)){if(e.properties.meta=v.FEATURE,n(_t(t.polygon.id,e.geometry.coordinates[0][0],"0.0",!1)),r>3){var i=e.geometry.coordinates[0].length-3;n(_t(t.polygon.id,e.geometry.coordinates[0][i],"0."+i,!1));}if(r<=4){var a=[[e.geometry.coordinates[0][0][0],e.geometry.coordinates[0][0][1]],[e.geometry.coordinates[0][1][0],e.geometry.coordinates[0][1][1]]];if(n({type:f.FEATURE,properties:e.properties,geometry:{coordinates:a,type:f.LINE_STRING}}),3===r)return}return n(e)}}},ae.onTrash=function(t){this.deleteFeature([t.polygon.id],{silent:!0}),this.changeMode(h.SIMPLE_SELECT);};var se={onSetup:function(t){var e,n,o=(t=t||{}).featureId,r="forward";if(o){if(!(e=this.getFeature(o)))throw new Error("Could not find a feature with the provided featureId");var i=t.from;if(i&&"Feature"===i.type&&i.geometry&&"Point"===i.geometry.type&&(i=i.geometry),i&&"Point"===i.type&&i.coordinates&&2===i.coordinates.length&&(i=i.coordinates),!i||!Array.isArray(i))throw new Error("Please use the `from` property to indicate which point to continue the line from");var a=e.coordinates.length-1;if(e.coordinates[a][0]===i[0]&&e.coordinates[a][1]===i[1])n=a+1,e.addCoordinate.apply(e,[n].concat(e.coordinates[a]));else {if(e.coordinates[0][0]!==i[0]||e.coordinates[0][1]!==i[1])throw new Error("`from` should match the point at either the start or the end of the provided LineString");r="backwards",n=0,e.addCoordinate.apply(e,[n].concat(e.coordinates[0]));}}else e=this.newFeature({type:f.FEATURE,properties:{},geometry:{type:f.LINE_STRING,coordinates:[]}}),n=0,this.addFeature(e);return this.clearSelectedFeatures(),Tt.disable(this),this.updateUIClasses({mouse:d.ADD}),this.activateUIButton(p.LINE),this.setActionableState({trash:!0}),{line:e,currentVertexPosition:n,direction:r}},clickAnywhere:function(t,e){if(t.currentVertexPosition>0&&ie(e,t.line.coordinates[t.currentVertexPosition-1])||"backwards"===t.direction&&ie(e,t.line.coordinates[t.currentVertexPosition+1]))return this.changeMode(h.SIMPLE_SELECT,{featureIds:[t.line.id]});this.updateUIClasses({mouse:d.ADD}),t.line.updateCoordinate(t.currentVertexPosition,e.lngLat.lng,e.lngLat.lat),"forward"===t.direction?(t.currentVertexPosition++,t.line.updateCoordinate(t.currentVertexPosition,e.lngLat.lng,e.lngLat.lat)):t.line.addCoordinate(0,e.lngLat.lng,e.lngLat.lat);},clickOnVertex:function(t){return this.changeMode(h.SIMPLE_SELECT,{featureIds:[t.line.id]})},onMouseMove:function(t,e){t.line.updateCoordinate(t.currentVertexPosition,e.lngLat.lng,e.lngLat.lat),lt(e)&&this.updateUIClasses({mouse:d.POINTER});}};se.onTap=se.onClick=function(t,e){if(lt(e))return this.clickOnVertex(t,e);this.clickAnywhere(t,e);},se.onKeyUp=function(t,e){ft(e)?this.changeMode(h.SIMPLE_SELECT,{featureIds:[t.line.id]}):pt(e)&&(this.deleteFeature([t.line.id],{silent:!0}),this.changeMode(h.SIMPLE_SELECT));},se.onStop=function(t){Tt.enable(this),this.activateUIButton(),void 0!==this.getFeature(t.line.id)&&(t.line.removeCoordinate(""+t.currentVertexPosition),t.line.isValid()?this.map.fire(g.CREATE,{features:[t.line.toGeoJSON()]}):(this.deleteFeature([t.line.id],{silent:!0}),this.changeMode(h.SIMPLE_SELECT,{},{silent:!0})));},se.onTrash=function(t){this.deleteFeature([t.line.id],{silent:!0}),this.changeMode(h.SIMPLE_SELECT);},se.toDisplayFeatures=function(t,e,n){var o=e.properties.id===t.line.id;if(e.properties.active=o?m.ACTIVE:m.INACTIVE,!o)return n(e);e.geometry.coordinates.length<2||(e.properties.meta=v.FEATURE,n(_t(t.line.id,e.geometry.coordinates["forward"===t.direction?e.geometry.coordinates.length-2:1],""+("forward"===t.direction?e.geometry.coordinates.length-2:1),!1)),n(e));};var ue={simple_select:te,direct_select:oe,draw_point:re,draw_polygon:ae,draw_line_string:se},ce={defaultMode:h.SIMPLE_SELECT,keybindings:!0,touchEnabled:!0,clickBuffer:2,touchBuffer:25,boxSelect:!0,displayControlsDefault:!0,styles:ot,modes:ue,controls:{},userProperties:!1},le={point:!0,line_string:!0,polygon:!0,trash:!0,combine_features:!0,uncombine_features:!0},de={point:!1,line_string:!1,polygon:!1,trash:!1,combine_features:!1,uncombine_features:!1};function pe(t,e){return t.map((function(t){return t.source?t:tt(t,{id:t.id+"."+e,source:"hot"===e?l.HOT:l.COLD})}))}var fe={exports:{}};!function(t,e){var n="__lodash_hash_undefined__",o=9007199254740991,r="[object Arguments]",i="[object Array]",a="[object Boolean]",s="[object Date]",u="[object Error]",c="[object Function]",l="[object Map]",d="[object Number]",p="[object Object]",f="[object Promise]",h="[object RegExp]",g="[object Set]",y="[object String]",v="[object Symbol]",m="[object WeakMap]",_="[object ArrayBuffer]",b="[object DataView]",E=/^\[object .+?Constructor\]$/,T=/^(?:0|[1-9]\d*)$/,C={};C["[object Float32Array]"]=C["[object Float64Array]"]=C["[object Int8Array]"]=C["[object Int16Array]"]=C["[object Int32Array]"]=C["[object Uint8Array]"]=C["[object Uint8ClampedArray]"]=C["[object Uint16Array]"]=C["[object Uint32Array]"]=!0,C[r]=C[i]=C[_]=C[a]=C[b]=C[s]=C[u]=C[c]=C[l]=C[d]=C[p]=C[h]=C[g]=C[y]=C[m]=!1;var O="object"==typeof commonjsGlobal&&commonjsGlobal&&commonjsGlobal.Object===Object&&commonjsGlobal,S="object"==typeof self&&self&&self.Object===Object&&self,I=O||S||Function("return this")(),x=e&&!e.nodeType&&e,M=x&&t&&!t.nodeType&&t,L=M&&M.exports===x,N=L&&O.process,A=function(){try{return N&&N.binding&&N.binding("util")}catch(t){}}(),P=A&&A.isTypedArray;function F(t,e){for(var n=-1,o=null==t?0:t.length;++n<o;)if(e(t[n],n,t))return !0;return !1}function w(t){var e=-1,n=Array(t.size);return t.forEach((function(t,o){n[++e]=[o,t];})),n}function R(t){var e=-1,n=Array(t.size);return t.forEach((function(t){n[++e]=t;})),n}var k,D,U,j=Array.prototype,V=Function.prototype,B=Object.prototype,G=I["__core-js_shared__"],J=V.toString,z=B.hasOwnProperty,Y=(k=/[^.]+$/.exec(G&&G.keys&&G.keys.IE_PROTO||""))?"Symbol(src)_1."+k:"",$=B.toString,q=RegExp("^"+J.call(z).replace(/[\\^$.*+?()[\]{}|]/g,"\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,"$1.*?")+"$"),H=L?I.Buffer:void 0,X=I.Symbol,Z=I.Uint8Array,W=B.propertyIsEnumerable,K=j.splice,Q=X?X.toStringTag:void 0,tt=Object.getOwnPropertySymbols,et=H?H.isBuffer:void 0,nt=(D=Object.keys,U=Object,function(t){return D(U(t))}),ot=At(I,"DataView"),rt=At(I,"Map"),it=At(I,"Promise"),at=At(I,"Set"),st=At(I,"WeakMap"),ut=At(Object,"create"),ct=Rt(ot),lt=Rt(rt),dt=Rt(it),pt=Rt(at),ft=Rt(st),ht=X?X.prototype:void 0,gt=ht?ht.valueOf:void 0;function yt(t){var e=-1,n=null==t?0:t.length;for(this.clear();++e<n;){var o=t[e];this.set(o[0],o[1]);}}function vt(t){var e=-1,n=null==t?0:t.length;for(this.clear();++e<n;){var o=t[e];this.set(o[0],o[1]);}}function mt(t){var e=-1,n=null==t?0:t.length;for(this.clear();++e<n;){var o=t[e];this.set(o[0],o[1]);}}function _t(t){var e=-1,n=null==t?0:t.length;for(this.__data__=new mt;++e<n;)this.add(t[e]);}function bt(t){var e=this.__data__=new vt(t);this.size=e.size;}function Et(t,e){var n=Ut(t),o=!n&&Dt(t),r=!n&&!o&&jt(t),i=!n&&!o&&!r&&zt(t),a=n||o||r||i,s=a?function(t,e){for(var n=-1,o=Array(t);++n<t;)o[n]=e(n);return o}(t.length,String):[],u=s.length;for(var c in t)!e&&!z.call(t,c)||a&&("length"==c||r&&("offset"==c||"parent"==c)||i&&("buffer"==c||"byteLength"==c||"byteOffset"==c)||wt(c,u))||s.push(c);return s}function Tt(t,e){for(var n=t.length;n--;)if(kt(t[n][0],e))return n;return -1}function Ct(t){return null==t?void 0===t?"[object Undefined]":"[object Null]":Q&&Q in Object(t)?function(t){var e=z.call(t,Q),n=t[Q];try{t[Q]=void 0;var o=!0;}catch(t){}var r=$.call(t);o&&(e?t[Q]=n:delete t[Q]);return r}(t):function(t){return $.call(t)}(t)}function Ot(t){return Jt(t)&&Ct(t)==r}function St(t,e,n,o,c){return t===e||(null==t||null==e||!Jt(t)&&!Jt(e)?t!=t&&e!=e:function(t,e,n,o,c,f){var m=Ut(t),E=Ut(e),T=m?i:Ft(t),C=E?i:Ft(e),O=(T=T==r?p:T)==p,S=(C=C==r?p:C)==p,I=T==C;if(I&&jt(t)){if(!jt(e))return !1;m=!0,O=!1;}if(I&&!O)return f||(f=new bt),m||zt(t)?Mt(t,e,n,o,c,f):function(t,e,n,o,r,i,c){switch(n){case b:if(t.byteLength!=e.byteLength||t.byteOffset!=e.byteOffset)return !1;t=t.buffer,e=e.buffer;case _:return !(t.byteLength!=e.byteLength||!i(new Z(t),new Z(e)));case a:case s:case d:return kt(+t,+e);case u:return t.name==e.name&&t.message==e.message;case h:case y:return t==e+"";case l:var p=w;case g:var f=1&o;if(p||(p=R),t.size!=e.size&&!f)return !1;var m=c.get(t);if(m)return m==e;o|=2,c.set(t,e);var E=Mt(p(t),p(e),o,r,i,c);return c.delete(t),E;case v:if(gt)return gt.call(t)==gt.call(e)}return !1}(t,e,T,n,o,c,f);if(!(1&n)){var x=O&&z.call(t,"__wrapped__"),M=S&&z.call(e,"__wrapped__");if(x||M){var L=x?t.value():t,N=M?e.value():e;return f||(f=new bt),c(L,N,n,o,f)}}if(!I)return !1;return f||(f=new bt),function(t,e,n,o,r,i){var a=1&n,s=Lt(t),u=s.length,c=Lt(e).length;if(u!=c&&!a)return !1;var l=u;for(;l--;){var d=s[l];if(!(a?d in e:z.call(e,d)))return !1}var p=i.get(t);if(p&&i.get(e))return p==e;var f=!0;i.set(t,e),i.set(e,t);var h=a;for(;++l<u;){var g=t[d=s[l]],y=e[d];if(o)var v=a?o(y,g,d,e,t,i):o(g,y,d,t,e,i);if(!(void 0===v?g===y||r(g,y,n,o,i):v)){f=!1;break}h||(h="constructor"==d);}if(f&&!h){var m=t.constructor,_=e.constructor;m==_||!("constructor"in t)||!("constructor"in e)||"function"==typeof m&&m instanceof m&&"function"==typeof _&&_ instanceof _||(f=!1);}return i.delete(t),i.delete(e),f}(t,e,n,o,c,f)}(t,e,n,o,St,c))}function It(t){return !(!Gt(t)||function(t){return !!Y&&Y in t}(t))&&(Vt(t)?q:E).test(Rt(t))}function xt(t){if(n=(e=t)&&e.constructor,o="function"==typeof n&&n.prototype||B,e!==o)return nt(t);var e,n,o,r=[];for(var i in Object(t))z.call(t,i)&&"constructor"!=i&&r.push(i);return r}function Mt(t,e,n,o,r,i){var a=1&n,s=t.length,u=e.length;if(s!=u&&!(a&&u>s))return !1;var c=i.get(t);if(c&&i.get(e))return c==e;var l=-1,d=!0,p=2&n?new _t:void 0;for(i.set(t,e),i.set(e,t);++l<s;){var f=t[l],h=e[l];if(o)var g=a?o(h,f,l,e,t,i):o(f,h,l,t,e,i);if(void 0!==g){if(g)continue;d=!1;break}if(p){if(!F(e,(function(t,e){if(a=e,!p.has(a)&&(f===t||r(f,t,n,o,i)))return p.push(e);var a;}))){d=!1;break}}else if(f!==h&&!r(f,h,n,o,i)){d=!1;break}}return i.delete(t),i.delete(e),d}function Lt(t){return function(t,e,n){var o=e(t);return Ut(t)?o:function(t,e){for(var n=-1,o=e.length,r=t.length;++n<o;)t[r+n]=e[n];return t}(o,n(t))}(t,Yt,Pt)}function Nt(t,e){var n,o,r=t.__data__;return ("string"==(o=typeof(n=e))||"number"==o||"symbol"==o||"boolean"==o?"__proto__"!==n:null===n)?r["string"==typeof e?"string":"hash"]:r.map}function At(t,e){var n=function(t,e){return null==t?void 0:t[e]}(t,e);return It(n)?n:void 0}yt.prototype.clear=function(){this.__data__=ut?ut(null):{},this.size=0;},yt.prototype.delete=function(t){var e=this.has(t)&&delete this.__data__[t];return this.size-=e?1:0,e},yt.prototype.get=function(t){var e=this.__data__;if(ut){var o=e[t];return o===n?void 0:o}return z.call(e,t)?e[t]:void 0},yt.prototype.has=function(t){var e=this.__data__;return ut?void 0!==e[t]:z.call(e,t)},yt.prototype.set=function(t,e){var o=this.__data__;return this.size+=this.has(t)?0:1,o[t]=ut&&void 0===e?n:e,this},vt.prototype.clear=function(){this.__data__=[],this.size=0;},vt.prototype.delete=function(t){var e=this.__data__,n=Tt(e,t);return !(n<0)&&(n==e.length-1?e.pop():K.call(e,n,1),--this.size,!0)},vt.prototype.get=function(t){var e=this.__data__,n=Tt(e,t);return n<0?void 0:e[n][1]},vt.prototype.has=function(t){return Tt(this.__data__,t)>-1},vt.prototype.set=function(t,e){var n=this.__data__,o=Tt(n,t);return o<0?(++this.size,n.push([t,e])):n[o][1]=e,this},mt.prototype.clear=function(){this.size=0,this.__data__={hash:new yt,map:new(rt||vt),string:new yt};},mt.prototype.delete=function(t){var e=Nt(this,t).delete(t);return this.size-=e?1:0,e},mt.prototype.get=function(t){return Nt(this,t).get(t)},mt.prototype.has=function(t){return Nt(this,t).has(t)},mt.prototype.set=function(t,e){var n=Nt(this,t),o=n.size;return n.set(t,e),this.size+=n.size==o?0:1,this},_t.prototype.add=_t.prototype.push=function(t){return this.__data__.set(t,n),this},_t.prototype.has=function(t){return this.__data__.has(t)},bt.prototype.clear=function(){this.__data__=new vt,this.size=0;},bt.prototype.delete=function(t){var e=this.__data__,n=e.delete(t);return this.size=e.size,n},bt.prototype.get=function(t){return this.__data__.get(t)},bt.prototype.has=function(t){return this.__data__.has(t)},bt.prototype.set=function(t,e){var n=this.__data__;if(n instanceof vt){var o=n.__data__;if(!rt||o.length<199)return o.push([t,e]),this.size=++n.size,this;n=this.__data__=new mt(o);}return n.set(t,e),this.size=n.size,this};var Pt=tt?function(t){return null==t?[]:(t=Object(t),function(t,e){for(var n=-1,o=null==t?0:t.length,r=0,i=[];++n<o;){var a=t[n];e(a,n,t)&&(i[r++]=a);}return i}(tt(t),(function(e){return W.call(t,e)})))}:function(){return []},Ft=Ct;function wt(t,e){return !!(e=null==e?o:e)&&("number"==typeof t||T.test(t))&&t>-1&&t%1==0&&t<e}function Rt(t){if(null!=t){try{return J.call(t)}catch(t){}try{return t+""}catch(t){}}return ""}function kt(t,e){return t===e||t!=t&&e!=e}(ot&&Ft(new ot(new ArrayBuffer(1)))!=b||rt&&Ft(new rt)!=l||it&&Ft(it.resolve())!=f||at&&Ft(new at)!=g||st&&Ft(new st)!=m)&&(Ft=function(t){var e=Ct(t),n=e==p?t.constructor:void 0,o=n?Rt(n):"";if(o)switch(o){case ct:return b;case lt:return l;case dt:return f;case pt:return g;case ft:return m}return e});var Dt=Ot(function(){return arguments}())?Ot:function(t){return Jt(t)&&z.call(t,"callee")&&!W.call(t,"callee")},Ut=Array.isArray;var jt=et||function(){return !1};function Vt(t){if(!Gt(t))return !1;var e=Ct(t);return e==c||"[object GeneratorFunction]"==e||"[object AsyncFunction]"==e||"[object Proxy]"==e}function Bt(t){return "number"==typeof t&&t>-1&&t%1==0&&t<=o}function Gt(t){var e=typeof t;return null!=t&&("object"==e||"function"==e)}function Jt(t){return null!=t&&"object"==typeof t}var zt=P?function(t){return function(e){return t(e)}}(P):function(t){return Jt(t)&&Bt(t.length)&&!!C[Ct(t)]};function Yt(t){return null!=(e=t)&&Bt(e.length)&&!Vt(e)?Et(t):xt(t);var e;}t.exports=function(t,e){return St(t,e)};}(fe,fe.exports);var he=e(fe.exports);function ge(t,e){return t.length===e.length&&JSON.stringify(t.map((function(t){return t})).sort())===JSON.stringify(e.map((function(t){return t})).sort())}var ye={Polygon:V,LineString:j,Point:U,MultiPolygon:J,MultiLineString:J,MultiPoint:J};var ve=Object.freeze({__proto__:null,CommonSelectors:ht,constrainFeatureMovement:Kt,createMidPoint:bt,createSupplementaryPoints:Et,createVertex:_t,doubleClickZoom:Tt,euclideanDistance:A,featuresAt:M,getFeatureAtAndSetCursors:N,isClick:P,isEventAtCoordinates:ie,isTap:F,mapEventToBoundingBox:S,ModeHandler:t,moveFeatures:Qt,sortFeatures:O,stringSetsAreEqual:ge,StringSet:I,theme:ot,toDenseArray:H}),me=function(t,e){var n={options:t=function(t){void 0===t&&(t={});var e=tt(t);return t.controls||(e.controls={}),!1===t.displayControlsDefault?e.controls=tt(de,t.controls):e.controls=tt(le,t.controls),(e=tt(ce,e)).styles=pe(e.styles,"cold").concat(pe(e.styles,"hot")),e}(t)};e=function(t,e){return e.modes=h,e.getFeatureIdsAt=function(e){return M.click({point:e},null,t).map((function(t){return t.properties.id}))},e.getSelectedIds=function(){return t.store.getSelectedIds()},e.getSelected=function(){return {type:f.FEATURE_COLLECTION,features:t.store.getSelectedIds().map((function(e){return t.store.get(e)})).map((function(t){return t.toGeoJSON()}))}},e.getSelectedPoints=function(){return {type:f.FEATURE_COLLECTION,features:t.store.getSelectedCoordinates().map((function(t){return {type:f.FEATURE,properties:{},geometry:{type:f.POINT,coordinates:t.coordinates}}}))}},e.set=function(n){if(void 0===n.type||n.type!==f.FEATURE_COLLECTION||!Array.isArray(n.features))throw new Error("Invalid FeatureCollection");var o=t.store.createRenderBatch(),r=t.store.getAllIds().slice(),i=e.add(n),a=new I(i);return (r=r.filter((function(t){return !a.has(t)}))).length&&e.delete(r),o(),i},e.add=function(e){var n=JSON.parse(JSON.stringify(It(e))).features.map((function(e){if(e.id=e.id||k(),null===e.geometry)throw new Error("Invalid geometry: null");if(void 0===t.store.get(e.id)||t.store.get(e.id).type!==e.geometry.type){var n=ye[e.geometry.type];if(void 0===n)throw new Error("Invalid geometry type: "+e.geometry.type+".");var o=new n(t,e);t.store.add(o);}else {var r=t.store.get(e.id);r.properties=e.properties,he(r.properties,e.properties)||t.store.featureChanged(r.id),he(r.getCoordinates(),e.geometry.coordinates)||r.incomingCoords(e.geometry.coordinates);}return e.id}));return t.store.render(),n},e.get=function(e){var n=t.store.get(e);if(n)return n.toGeoJSON()},e.getAll=function(){return {type:f.FEATURE_COLLECTION,features:t.store.getAll().map((function(t){return t.toGeoJSON()}))}},e.delete=function(n){return t.store.delete(n,{silent:!0}),e.getMode()!==h.DIRECT_SELECT||t.store.getSelectedIds().length?t.store.render():t.events.changeMode(h.SIMPLE_SELECT,void 0,{silent:!0}),e},e.deleteAll=function(){return t.store.delete(t.store.getAllIds(),{silent:!0}),e.getMode()===h.DIRECT_SELECT?t.events.changeMode(h.SIMPLE_SELECT,void 0,{silent:!0}):t.store.render(),e},e.changeMode=function(n,o){return void 0===o&&(o={}),n===h.SIMPLE_SELECT&&e.getMode()===h.SIMPLE_SELECT?(ge(o.featureIds||[],t.store.getSelectedIds())||(t.store.setSelected(o.featureIds,{silent:!0}),t.store.render()),e):(n===h.DIRECT_SELECT&&e.getMode()===h.DIRECT_SELECT&&o.featureId===t.store.getSelectedIds()[0]||t.events.changeMode(n,o,{silent:!0}),e)},e.getMode=function(){return t.events.getMode()},e.trash=function(){return t.events.trash({silent:!0}),e},e.combineFeatures=function(){return t.events.combineFeatures({silent:!0}),e},e.uncombineFeatures=function(){return t.events.uncombineFeatures({silent:!0}),e},e.setFeatureProperty=function(n,o,r){return t.store.setFeatureProperty(n,o,r),e},e}(n,e),n.api=e;var o=nt(n);return e.onAdd=o.onAdd,e.onRemove=o.onRemove,e.types=p,e.options=t,e};function _e(t){me(t,this);}return _e.modes=ue,_e.constants=E,_e.lib=ve,_e}));
	
} (mapboxGlDraw));

var mapboxGlDrawExports = mapboxGlDraw.exports;
var MapboxDraw = /*@__PURE__*/getDefaultExportFromCjs(mapboxGlDrawExports);

var doubleClickZoom$1 = {
    enable: function (ctx) {
        setTimeout(function () {
            // First check we've got a map and some context.
            if (!ctx.map ||
                !ctx.map.doubleClickZoom ||
                !ctx._ctx ||
                !ctx._ctx.store ||
                !ctx._ctx.store.getInitialConfigValue)
                return;
            // Now check initial state wasn't false (we leave it disabled if so)
            if (!ctx._ctx.store.getInitialConfigValue("doubleClickZoom"))
                return;
            ctx.map.doubleClickZoom.enable();
        }, 0);
    },
    disable: function (ctx) {
        setTimeout(function () {
            // First check we've got a map and some context.
            if (!ctx.map ||
                !ctx.map.doubleClickZoom ||
                !ctx._ctx ||
                !ctx._ctx.store ||
                !ctx._ctx.store.getInitialConfigValue)
                return;
            // Now check initial state wasn't false (we leave it disabled if so)
            if (!ctx._ctx.store.getInitialConfigValue("doubleClickZoom"))
                return;
            ctx.map.doubleClickZoom.disable();
        }, 0);
    },
};
var CircleMode = __assign(__assign({}, MapboxDraw.modes.draw_polygon), { onSetup: function (opts) {
        var polygon = this.newFeature({
            type: "Feature",
            properties: {
                isCircle: true,
                center: [],
                radiusInKm: 0,
            },
            geometry: {
                type: "Polygon",
                coordinates: [[]],
            },
        });
        this.addFeature(polygon);
        this.clearSelectedFeatures();
        doubleClickZoom$1.disable(this);
        //   this.updateUIClasses({ mouse: Constants.cursors.ADD });
        //   this.activateUIButton(Constants.types.POLYGON);
        //   this.setActionableState({
        //     trash: true,
        //   });
        return {
            polygon: polygon,
            drawing: false,
            self: this,
        };
    }, onMouseDown: function (state, e) {
        if (!state.drawing) {
            var center = [e.lngLat.lng, e.lngLat.lat];
            state.polygon.properties.center = center;
            state.drawing = !state.drawing;
        }
        else {
            return state.self.changeMode("simple_select", {
                featureIds: [state.polygon.id],
            });
        }
    }, onMouseMove: function (state, e) {
        if (state.drawing) {
            var target = [e.lngLat.lng, e.lngLat.lat];
            var center = state.polygon.properties.center;
            var p1 = point(target);
            var p2 = point(center);
            var radius = distance$1(p1, p2, { units: "kilometers" });
            var circleFeature = circle$1(center, radius, {
                units: "kilometers",
            });
            state.polygon.incomingCoords(circleFeature.geometry.coordinates);
            state.polygon.properties.radiusInKm = radius;
        }
    } });

const classes = {
    CONTROL_BASE: 'mapboxgl-ctrl',
    CONTROL_PREFIX: 'mapboxgl-ctrl-',
    CONTROL_BUTTON: 'mapbox-gl-draw_ctrl-draw-btn',
    CONTROL_BUTTON_LINE: 'mapbox-gl-draw_line',
    CONTROL_BUTTON_POLYGON: 'mapbox-gl-draw_polygon',
    CONTROL_BUTTON_POINT: 'mapbox-gl-draw_point',
    CONTROL_BUTTON_TRASH: 'mapbox-gl-draw_trash',
    CONTROL_BUTTON_COMBINE_FEATURES: 'mapbox-gl-draw_combine',
    CONTROL_BUTTON_UNCOMBINE_FEATURES: 'mapbox-gl-draw_uncombine',
    CONTROL_GROUP: 'mapboxgl-ctrl-group',
    ATTRIBUTION: 'mapboxgl-ctrl-attrib',
    ACTIVE_BUTTON: 'active',
    BOX_SELECT: 'mapbox-gl-draw_boxselect'
};

const sources = {
    HOT: 'mapbox-gl-draw-hot',
    COLD: 'mapbox-gl-draw-cold'
};

const cursors = {
    ADD: 'add',
    MOVE: 'move',
    DRAG: 'drag',
    POINTER: 'pointer',
    NONE: 'none'
};

const types$1 = {
    POLYGON: 'polygon',
    LINE: 'line_string',
    POINT: 'point'
};

const geojsonTypes = {
    FEATURE: 'Feature',
    POLYGON: 'Polygon',
    LINE_STRING: 'LineString',
    POINT: 'Point',
    FEATURE_COLLECTION: 'FeatureCollection',
    MULTI_PREFIX: 'Multi',
    MULTI_POINT: 'MultiPoint',
    MULTI_LINE_STRING: 'MultiLineString',
    MULTI_POLYGON: 'MultiPolygon'
};

const modes = {
    DRAW_LINE_STRING: 'draw_line_string',
    DRAW_POLYGON: 'draw_polygon',
    DRAW_POINT: 'draw_point',
    SIMPLE_SELECT: 'simple_select',
    DIRECT_SELECT: 'direct_select',
    STATIC: 'static'
};

const events = {
    CREATE: 'draw.create',
    DELETE: 'draw.delete',
    UPDATE: 'draw.update',
    SELECTION_CHANGE: 'draw.selectionchange',
    MODE_CHANGE: 'draw.modechange',
    ACTIONABLE: 'draw.actionable',
    RENDER: 'draw.render',
    COMBINE_FEATURES: 'draw.combine',
    UNCOMBINE_FEATURES: 'draw.uncombine'
};

const updateActions = {
    MOVE: 'move',
    CHANGE_COORDINATES: 'change_coordinates'
};

const meta = {
    FEATURE: 'feature',
    MIDPOINT: 'midpoint',
    VERTEX: 'vertex'
};

const activeStates = {
    ACTIVE: 'true',
    INACTIVE: 'false'
};

const interactions = [
    'scrollZoom',
    'boxZoom',
    'dragRotate',
    'dragPan',
    'keyboard',
    'doubleClickZoom',
    'touchZoomRotate'
];

const LAT_MIN$1 = -90;
const LAT_RENDERED_MIN$1 = -85;
const LAT_MAX$1 = 90;
const LAT_RENDERED_MAX$1 = 85;
const LNG_MIN$1 = -270;
const LNG_MAX$1 = 270;

var Constants = /*#__PURE__*/Object.freeze({
    __proto__: null,
    LAT_MAX: LAT_MAX$1,
    LAT_MIN: LAT_MIN$1,
    LAT_RENDERED_MAX: LAT_RENDERED_MAX$1,
    LAT_RENDERED_MIN: LAT_RENDERED_MIN$1,
    LNG_MAX: LNG_MAX$1,
    LNG_MIN: LNG_MIN$1,
    activeStates: activeStates,
    classes: classes,
    cursors: cursors,
    events: events,
    geojsonTypes: geojsonTypes,
    interactions: interactions,
    meta: meta,
    modes: modes,
    sources: sources,
    types: types$1,
    updateActions: updateActions
});

/**
 * Returns GeoJSON for a Point representing the
 * vertex of another feature.
 *
 * @param {string} parentId
 * @param {Array<number>} coordinates
 * @param {string} path - Dot-separated numbers indicating exactly
 *   where the point exists within its parent feature's coordinates.
 * @param {boolean} selected
 * @return {GeoJSON} Point
 */

function createVertex(parentId, coordinates, path, selected) {
    return {
        type: geojsonTypes.FEATURE,
        properties: {
            meta: meta.VERTEX,
            parent: parentId,
            coord_path: path,
            active: (selected) ? activeStates.ACTIVE : activeStates.INACTIVE
        },
        geometry: {
            type: geojsonTypes.POINT,
            coordinates
        }
    };
}

function createSupplementaryPointsForCircle(geojson) {
    const { properties, geometry } = geojson;

    if (!properties.user_isCircle) return null;

    const supplementaryPoints = [];
    const vertices = geometry.coordinates[0].slice(0, -1);
    for (let index = 0; index < vertices.length; index += Math.round((vertices.length / 4))) {
        supplementaryPoints.push(createVertex(properties.id, vertices[index], `0.${index}`, false));
    }
    return supplementaryPoints;
}

function createMidpoint(parent, startVertex, endVertex) {
    const startCoord = startVertex.geometry.coordinates;
    const endCoord = endVertex.geometry.coordinates;

    // If a coordinate exceeds the projection, we can't calculate a midpoint,
    // so run away
    if (startCoord[1] > LAT_RENDERED_MAX$1 ||
        startCoord[1] < LAT_RENDERED_MIN$1 ||
        endCoord[1] > LAT_RENDERED_MAX$1 ||
        endCoord[1] < LAT_RENDERED_MIN$1) {
        return null;
    }

    const mid = {
        lng: (startCoord[0] + endCoord[0]) / 2,
        lat: (startCoord[1] + endCoord[1]) / 2
    };

    return {
        type: geojsonTypes.FEATURE,
        properties: {
            meta: meta.MIDPOINT,
            parent,
            lng: mid.lng,
            lat: mid.lat,
            coord_path: endVertex.properties.coord_path
        },
        geometry: {
            type: geojsonTypes.POINT,
            coordinates: [mid.lng, mid.lat]
        }
    };
}

function createSupplementaryPoints(geojson, options = {}, basePath = null) {
  const { type, coordinates } = geojson.geometry;
  const featureId = geojson.properties && geojson.properties.id;

  let supplementaryPoints = [];

  if (type === geojsonTypes.POINT) {
    // For points, just create a vertex
    supplementaryPoints.push(createVertex(featureId, coordinates, basePath, isSelectedPath(basePath)));
  } else if (type === geojsonTypes.POLYGON) {
    // Cycle through a Polygon's rings and
    // process each line
    coordinates.forEach((line, lineIndex) => {
      processLine(line, (basePath !== null) ? `${basePath}.${lineIndex}` : String(lineIndex));
    });
  } else if (type === geojsonTypes.LINE_STRING) {
    processLine(coordinates, basePath);
  } else if (type.indexOf(geojsonTypes.MULTI_PREFIX) === 0) {
    processMultiGeometry();
  }

  function processLine(line, lineBasePath) {
    let firstPointString = '';
    let lastVertex = null;
    line.forEach((point, pointIndex) => {
      const pointPath = (lineBasePath !== undefined && lineBasePath !== null) ? `${lineBasePath}.${pointIndex}` : String(pointIndex);
      const vertex = createVertex(featureId, point, pointPath, isSelectedPath(pointPath));

      // If we're creating midpoints, check if there was a
      // vertex before this one. If so, add a midpoint
      // between that vertex and this one.
      if (options.midpoints && lastVertex) {
        const midpoint = createMidpoint(featureId, lastVertex, vertex);
        if (midpoint) {
          supplementaryPoints.push(midpoint);
        }
      }
      lastVertex = vertex;

      // A Polygon line's last point is the same as the first point. If we're on the last
      // point, we want to draw a midpoint before it but not another vertex on it
      // (since we already a vertex there, from the first point).
      const stringifiedPoint = JSON.stringify(point);
      if (firstPointString !== stringifiedPoint) {
        supplementaryPoints.push(vertex);
      }
      if (pointIndex === 0) {
        firstPointString = stringifiedPoint;
      }
    });
  }

  function isSelectedPath(path) {
    if (!options.selectedPaths) return false;
    return options.selectedPaths.indexOf(path) !== -1;
  }

  // Split a multi-geometry into constituent
  // geometries, and accumulate the supplementary points
  // for each of those constituents
  function processMultiGeometry() {
    const subType = type.replace(geojsonTypes.MULTI_PREFIX, '');
    coordinates.forEach((subCoordinates, index) => {
      const subFeature = {
        type: geojsonTypes.FEATURE,
        properties: geojson.properties,
        geometry: {
          type: subType,
          coordinates: subCoordinates
        }
      };
      supplementaryPoints = supplementaryPoints.concat(createSupplementaryPoints(subFeature, options, index));
    });
  }

  return supplementaryPoints;
}

var geojsonExtent = {exports: {}};

var geojsonNormalize$1 = normalize;

var types = {
    Point: 'geometry',
    MultiPoint: 'geometry',
    LineString: 'geometry',
    MultiLineString: 'geometry',
    Polygon: 'geometry',
    MultiPolygon: 'geometry',
    GeometryCollection: 'geometry',
    Feature: 'feature',
    FeatureCollection: 'featurecollection'
};

/**
 * Normalize a GeoJSON feature into a FeatureCollection.
 *
 * @param {object} gj geojson data
 * @returns {object} normalized geojson data
 */
function normalize(gj) {
    if (!gj || !gj.type) return null;
    var type = types[gj.type];
    if (!type) return null;

    if (type === 'geometry') {
        return {
            type: 'FeatureCollection',
            features: [{
                type: 'Feature',
                properties: {},
                geometry: gj
            }]
        };
    } else if (type === 'feature') {
        return {
            type: 'FeatureCollection',
            features: [gj]
        };
    } else if (type === 'featurecollection') {
        return gj;
    }
}

function e(t){switch(t&&t.type||null){case"FeatureCollection":return t.features=t.features.reduce(function(t,r){return t.concat(e(r))},[]),t;case"Feature":return t.geometry?e(t.geometry).map(function(e){var r={type:"Feature",properties:JSON.parse(JSON.stringify(t.properties)),geometry:e};return void 0!==t.id&&(r.id=t.id),r}):[t];case"MultiPoint":return t.coordinates.map(function(e){return {type:"Point",coordinates:e}});case"MultiPolygon":return t.coordinates.map(function(e){return {type:"Polygon",coordinates:e}});case"MultiLineString":return t.coordinates.map(function(e){return {type:"LineString",coordinates:e}});case"GeometryCollection":return t.geometries.map(e).reduce(function(e,t){return e.concat(t)},[]);case"Point":case"Polygon":case"LineString":return [t]}}

var index_es = /*#__PURE__*/Object.freeze({
    __proto__: null,
    default: e
});

var require$$1 = /*@__PURE__*/getAugmentedNamespace(index_es);

var flatten$1 = function flatten(list) {
    return _flatten(list);

    function _flatten(list) {
        if (Array.isArray(list) && list.length &&
            typeof list[0] === 'number') {
            return [list];
        }
        return list.reduce(function (acc, item) {
            if (Array.isArray(item) && Array.isArray(item[0])) {
                return acc.concat(_flatten(item));
            } else {
                acc.push(item);
                return acc;
            }
        }, []);
    }
};

var geojsonNormalize = geojsonNormalize$1,
    geojsonFlatten = require$$1,
    flatten = flatten$1;

if (!(geojsonFlatten instanceof Function)) geojsonFlatten = geojsonFlatten.default;

var geojsonCoords$1 = function(_) {
    if (!_) return [];
    var normalized = geojsonFlatten(geojsonNormalize(_)),
        coordinates = [];
    normalized.features.forEach(function(feature) {
        if (!feature.geometry) return;
        coordinates = coordinates.concat(flatten(feature.geometry.coordinates));
    });
    return coordinates;
};

// TODO: use call-bind, is-date, is-regex, is-string, is-boolean-object, is-number-object
function toS(obj) { return Object.prototype.toString.call(obj); }
function isDate$1(obj) { return toS(obj) === '[object Date]'; }
function isRegExp$2(obj) { return toS(obj) === '[object RegExp]'; }
function isError$1(obj) { return toS(obj) === '[object Error]'; }
function isBoolean$1(obj) { return toS(obj) === '[object Boolean]'; }
function isNumber$1(obj) { return toS(obj) === '[object Number]'; }
function isString$1(obj) { return toS(obj) === '[object String]'; }

// TODO: use isarray
var isArray$4 = Array.isArray || function isArray(xs) {
	return Object.prototype.toString.call(xs) === '[object Array]';
};

// TODO: use for-each?
function forEach(xs, fn) {
	if (xs.forEach) { return xs.forEach(fn); }
	for (var i = 0; i < xs.length; i++) {
		fn(xs[i], i, xs);
	}
	return void undefined;
}

// TODO: use object-keys
var objectKeys = Object.keys || function keys(obj) {
	var res = [];
	for (var key in obj) { res.push(key); } // eslint-disable-line no-restricted-syntax
	return res;
};

// TODO: use object.hasown
var hasOwnProperty = Object.prototype.hasOwnProperty || function (obj, key) {
	return key in obj;
};

function copy$1(src) {
	if (typeof src === 'object' && src !== null) {
		var dst;

		if (isArray$4(src)) {
			dst = [];
		} else if (isDate$1(src)) {
			dst = new Date(src.getTime ? src.getTime() : src);
		} else if (isRegExp$2(src)) {
			dst = new RegExp(src);
		} else if (isError$1(src)) {
			dst = { message: src.message };
		} else if (isBoolean$1(src) || isNumber$1(src) || isString$1(src)) {
			dst = Object(src);
		} else if (Object.create && Object.getPrototypeOf) {
			dst = Object.create(Object.getPrototypeOf(src));
		} else if (src.constructor === Object) {
			dst = {};
		} else {
			var proto = (src.constructor && src.constructor.prototype)
                || src.__proto__
                || {};
			var T = function T() {}; // eslint-disable-line func-style, func-name-matching
			T.prototype = proto;
			dst = new T();
		}

		forEach(objectKeys(src), function (key) {
			dst[key] = src[key];
		});
		return dst;
	}
	return src;
}

function walk(root, cb, immutable) {
	var path = [];
	var parents = [];
	var alive = true;

	return (function walker(node_) {
		var node = immutable ? copy$1(node_) : node_;
		var modifiers = {};

		var keepGoing = true;

		var state = {
			node: node,
			node_: node_,
			path: [].concat(path),
			parent: parents[parents.length - 1],
			parents: parents,
			key: path[path.length - 1],
			isRoot: path.length === 0,
			level: path.length,
			circular: null,
			update: function (x, stopHere) {
				if (!state.isRoot) {
					state.parent.node[state.key] = x;
				}
				state.node = x;
				if (stopHere) { keepGoing = false; }
			},
			delete: function (stopHere) {
				delete state.parent.node[state.key];
				if (stopHere) { keepGoing = false; }
			},
			remove: function (stopHere) {
				if (isArray$4(state.parent.node)) {
					state.parent.node.splice(state.key, 1);
				} else {
					delete state.parent.node[state.key];
				}
				if (stopHere) { keepGoing = false; }
			},
			keys: null,
			before: function (f) { modifiers.before = f; },
			after: function (f) { modifiers.after = f; },
			pre: function (f) { modifiers.pre = f; },
			post: function (f) { modifiers.post = f; },
			stop: function () { alive = false; },
			block: function () { keepGoing = false; },
		};

		if (!alive) { return state; }

		function updateState() {
			if (typeof state.node === 'object' && state.node !== null) {
				if (!state.keys || state.node_ !== state.node) {
					state.keys = objectKeys(state.node);
				}

				state.isLeaf = state.keys.length === 0;

				for (var i = 0; i < parents.length; i++) {
					if (parents[i].node_ === node_) {
						state.circular = parents[i];
						break; // eslint-disable-line no-restricted-syntax
					}
				}
			} else {
				state.isLeaf = true;
				state.keys = null;
			}

			state.notLeaf = !state.isLeaf;
			state.notRoot = !state.isRoot;
		}

		updateState();

		// use return values to update if defined
		var ret = cb.call(state, state.node);
		if (ret !== undefined && state.update) { state.update(ret); }

		if (modifiers.before) { modifiers.before.call(state, state.node); }

		if (!keepGoing) { return state; }

		if (
			typeof state.node === 'object'
			&& state.node !== null
			&& !state.circular
		) {
			parents.push(state);

			updateState();

			forEach(state.keys, function (key, i) {
				path.push(key);

				if (modifiers.pre) { modifiers.pre.call(state, state.node[key], key); }

				var child = walker(state.node[key]);
				if (immutable && hasOwnProperty.call(state.node, key)) {
					state.node[key] = child.node;
				}

				child.isLast = i === state.keys.length - 1;
				child.isFirst = i === 0;

				if (modifiers.post) { modifiers.post.call(state, child); }

				path.pop();
			});
			parents.pop();
		}

		if (modifiers.after) { modifiers.after.call(state, state.node); }

		return state;
	}(root)).node;
}

function Traverse(obj) {
	this.value = obj;
}

Traverse.prototype.get = function (ps) {
	var node = this.value;
	for (var i = 0; i < ps.length; i++) {
		var key = ps[i];
		if (!node || !hasOwnProperty.call(node, key)) {
			return void undefined;
		}
		node = node[key];
	}
	return node;
};

Traverse.prototype.has = function (ps) {
	var node = this.value;
	for (var i = 0; i < ps.length; i++) {
		var key = ps[i];
		if (!node || !hasOwnProperty.call(node, key)) {
			return false;
		}
		node = node[key];
	}
	return true;
};

Traverse.prototype.set = function (ps, value) {
	var node = this.value;
	for (var i = 0; i < ps.length - 1; i++) {
		var key = ps[i];
		if (!hasOwnProperty.call(node, key)) { node[key] = {}; }
		node = node[key];
	}
	node[ps[i]] = value;
	return value;
};

Traverse.prototype.map = function (cb) {
	return walk(this.value, cb, true);
};

Traverse.prototype.forEach = function (cb) {
	this.value = walk(this.value, cb, false);
	return this.value;
};

Traverse.prototype.reduce = function (cb, init) {
	var skip = arguments.length === 1;
	var acc = skip ? this.value : init;
	this.forEach(function (x) {
		if (!this.isRoot || !skip) {
			acc = cb.call(this, acc, x);
		}
	});
	return acc;
};

Traverse.prototype.paths = function () {
	var acc = [];
	this.forEach(function () {
		acc.push(this.path);
	});
	return acc;
};

Traverse.prototype.nodes = function () {
	var acc = [];
	this.forEach(function () {
		acc.push(this.node);
	});
	return acc;
};

Traverse.prototype.clone = function () {
	var parents = [];
	var nodes = [];

	return (function clone(src) {
		for (var i = 0; i < parents.length; i++) {
			if (parents[i] === src) {
				return nodes[i];
			}
		}

		if (typeof src === 'object' && src !== null) {
			var dst = copy$1(src);

			parents.push(src);
			nodes.push(dst);

			forEach(objectKeys(src), function (key) {
				dst[key] = clone(src[key]);
			});

			parents.pop();
			nodes.pop();
			return dst;
		}

		return src;

	}(this.value));
};

function traverse$1(obj) {
	return new Traverse(obj);
}

// TODO: replace with object.assign?
forEach(objectKeys(Traverse.prototype), function (key) {
	traverse$1[key] = function (obj) {
		var args = [].slice.call(arguments, 1);
		var t = new Traverse(obj);
		return t[key].apply(t, args);
	};
});

var traverse_1 = traverse$1;

var extent$2 = Extent;

function Extent(bbox) {
    if (!(this instanceof Extent)) {
        return new Extent(bbox);
    }
    this._bbox = bbox || [Infinity, Infinity, -Infinity, -Infinity];
    this._valid = !!bbox;
}

Extent.prototype.include = function(ll) {
    this._valid = true;
    this._bbox[0] = Math.min(this._bbox[0], ll[0]);
    this._bbox[1] = Math.min(this._bbox[1], ll[1]);
    this._bbox[2] = Math.max(this._bbox[2], ll[0]);
    this._bbox[3] = Math.max(this._bbox[3], ll[1]);
    return this;
};

Extent.prototype.equals = function(_) {
    var other;
    if (_ instanceof Extent) { other = _.bbox(); } else { other = _; }
    return this._bbox[0] == other[0] &&
        this._bbox[1] == other[1] &&
        this._bbox[2] == other[2] &&
        this._bbox[3] == other[3];
};

Extent.prototype.center = function(_) {
    if (!this._valid) return null;
    return [
        (this._bbox[0] + this._bbox[2]) / 2,
        (this._bbox[1] + this._bbox[3]) / 2]
};

Extent.prototype.union = function(_) {
    this._valid = true;
    var other;
    if (_ instanceof Extent) { other = _.bbox(); } else { other = _; }
    this._bbox[0] = Math.min(this._bbox[0], other[0]);
    this._bbox[1] = Math.min(this._bbox[1], other[1]);
    this._bbox[2] = Math.max(this._bbox[2], other[2]);
    this._bbox[3] = Math.max(this._bbox[3], other[3]);
    return this;
};

Extent.prototype.bbox = function() {
    if (!this._valid) return null;
    return this._bbox;
};

Extent.prototype.contains = function(ll) {
    if (!ll) return this._fastContains();
    if (!this._valid) return null;
    var lon = ll[0], lat = ll[1];
    return this._bbox[0] <= lon &&
        this._bbox[1] <= lat &&
        this._bbox[2] >= lon &&
        this._bbox[3] >= lat;
};

Extent.prototype.intersect = function(_) {
    if (!this._valid) return null;

    var other;
    if (_ instanceof Extent) { other = _.bbox(); } else { other = _; }

    return !(
      this._bbox[0] > other[2] ||
      this._bbox[2] < other[0] ||
      this._bbox[3] < other[1] ||
      this._bbox[1] > other[3]
    );
};

Extent.prototype._fastContains = function() {
    if (!this._valid) return new Function('return null;');
    var body = 'return ' +
        this._bbox[0] + '<= ll[0] &&' +
        this._bbox[1] + '<= ll[1] &&' +
        this._bbox[2] + '>= ll[0] &&' +
        this._bbox[3] + '>= ll[1]';
    return new Function('ll', body);
};

Extent.prototype.polygon = function() {
    if (!this._valid) return null;
    return {
        type: 'Polygon',
        coordinates: [
            [
                // W, S
                [this._bbox[0], this._bbox[1]],
                // E, S
                [this._bbox[2], this._bbox[1]],
                // E, N
                [this._bbox[2], this._bbox[3]],
                // W, N
                [this._bbox[0], this._bbox[3]],
                // W, S
                [this._bbox[0], this._bbox[1]]
            ]
        ]
    };
};

var geojsonCoords = geojsonCoords$1,
    traverse = traverse_1,
    extent = extent$2;

var geojsonTypesByDataAttributes = {
    features: ['FeatureCollection'],
    coordinates: ['Point', 'MultiPoint', 'LineString', 'MultiLineString', 'Polygon', 'MultiPolygon'],
    geometry: ['Feature'],
    geometries: ['GeometryCollection']
};

var dataAttributes = Object.keys(geojsonTypesByDataAttributes);

geojsonExtent.exports = function(_) {
    return getExtent(_).bbox();
};

geojsonExtent.exports.polygon = function(_) {
    return getExtent(_).polygon();
};

geojsonExtent.exports.bboxify = function(_) {
    return traverse(_).map(function(value) {
        if (!value) return ;

        var isValid = dataAttributes.some(function(attribute){
            if(value[attribute]) {
                return geojsonTypesByDataAttributes[attribute].indexOf(value.type) !== -1;
            }
            return false;
        });

        if(isValid){
            value.bbox = getExtent(value).bbox();
            this.update(value);
        }

    });
};

function getExtent(_) {
    var ext = extent(),
        coords = geojsonCoords(_);
    for (var i = 0; i < coords.length; i++) ext.include(coords[i]);
    return ext;
}

var geojsonExtentExports = geojsonExtent.exports;
var extent$1 = /*@__PURE__*/getDefaultExportFromCjs(geojsonExtentExports);

const {
    LAT_MIN,
    LAT_MAX,
    LAT_RENDERED_MIN,
    LAT_RENDERED_MAX,
    LNG_MIN,
    LNG_MAX
} = Constants;

// Ensure that we do not drag north-south far enough for
// - any part of any feature to exceed the poles
// - any feature to be completely lost in the space between the projection's
//   edge and the poles, such that it couldn't be re-selected and moved back
function constrainFeatureMovement(geojsonFeatures, delta) {
    // "inner edge" = a feature's latitude closest to the equator
    let northInnerEdge = LAT_MIN;
    let southInnerEdge = LAT_MAX;
    // "outer edge" = a feature's latitude furthest from the equator
    let northOuterEdge = LAT_MIN;
    let southOuterEdge = LAT_MAX;

    let westEdge = LNG_MAX;
    let eastEdge = LNG_MIN;

    geojsonFeatures.forEach((feature) => {
        const bounds = extent$1(feature);
        const featureSouthEdge = bounds[1];
        const featureNorthEdge = bounds[3];
        const featureWestEdge = bounds[0];
        const featureEastEdge = bounds[2];
        if (featureSouthEdge > northInnerEdge) northInnerEdge = featureSouthEdge;
        if (featureNorthEdge < southInnerEdge) southInnerEdge = featureNorthEdge;
        if (featureNorthEdge > northOuterEdge) northOuterEdge = featureNorthEdge;
        if (featureSouthEdge < southOuterEdge) southOuterEdge = featureSouthEdge;
        if (featureWestEdge < westEdge) westEdge = featureWestEdge;
        if (featureEastEdge > eastEdge) eastEdge = featureEastEdge;
    });


    // These changes are not mutually exclusive: we might hit the inner
    // edge but also have hit the outer edge and therefore need
    // another readjustment
    const constrainedDelta = delta;
    if (northInnerEdge + constrainedDelta.lat > LAT_RENDERED_MAX) {
        constrainedDelta.lat = LAT_RENDERED_MAX - northInnerEdge;
    }
    if (northOuterEdge + constrainedDelta.lat > LAT_MAX) {
        constrainedDelta.lat = LAT_MAX - northOuterEdge;
    }
    if (southInnerEdge + constrainedDelta.lat < LAT_RENDERED_MIN) {
        constrainedDelta.lat = LAT_RENDERED_MIN - southInnerEdge;
    }
    if (southOuterEdge + constrainedDelta.lat < LAT_MIN) {
        constrainedDelta.lat = LAT_MIN - southOuterEdge;
    }
    if (westEdge + constrainedDelta.lng <= LNG_MIN) {
        constrainedDelta.lng += Math.ceil(Math.abs(constrainedDelta.lng) / 360) * 360;
    }
    if (eastEdge + constrainedDelta.lng >= LNG_MAX) {
        constrainedDelta.lng -= Math.ceil(Math.abs(constrainedDelta.lng) / 360) * 360;
    }

    return constrainedDelta;
}

function moveFeatures(features, delta) {
    const constrainedDelta = constrainFeatureMovement(features.map(feature => feature.toGeoJSON()), delta);

    features.forEach((feature) => {
        const currentCoordinates = feature.getCoordinates();

        const moveCoordinate = (coord) => {
            const point = {
                lng: coord[0] + constrainedDelta.lng,
                lat: coord[1] + constrainedDelta.lat
            };
            return [point.lng, point.lat];
        };
        const moveRing = ring => ring.map(coord => moveCoordinate(coord));
        const moveMultiPolygon = multi => multi.map(ring => moveRing(ring));

        let nextCoordinates;
        if (feature.type === geojsonTypes.POINT) {
            nextCoordinates = moveCoordinate(currentCoordinates);
        } else if (feature.type === geojsonTypes.LINE_STRING || feature.type === geojsonTypes.MULTI_POINT) {
            nextCoordinates = currentCoordinates.map(moveCoordinate);
        } else if (feature.type === geojsonTypes.POLYGON || feature.type === geojsonTypes.MULTI_LINE_STRING) {
            nextCoordinates = currentCoordinates.map(moveRing);
        } else if (feature.type === geojsonTypes.MULTI_POLYGON) {
            nextCoordinates = currentCoordinates.map(moveMultiPolygon);
        }

        feature.incomingCoords(nextCoordinates);
    });
}

//@ts-nocheck
var distance = distance$1;
var turfHelpers = index$1;
var circle = circle$1;
var DirectMode = MapboxDraw.modes.direct_select;
DirectMode.dragFeature = function (state, e, delta) {
    moveFeatures(this.getSelected(), delta);
    this.getSelected()
        .filter(function (feature) { return feature.properties.isCircle; })
        .map(function (circle) { return circle.properties.center; })
        .forEach(function (center) {
        center[0] += delta.lng;
        center[1] += delta.lat;
    });
    state.dragMoveLocation = e.lngLat;
};
DirectMode.dragVertex = function (state, e, delta) {
    if (state.feature.properties.isCircle) {
        var center = state.feature.properties.center;
        var movedVertex = [e.lngLat.lng, e.lngLat.lat];
        var radius = distance(turfHelpers.point(center), turfHelpers.point(movedVertex), { units: "kilometers" });
        var circleFeature = circle(center, radius);
        state.feature.incomingCoords(circleFeature.geometry.coordinates);
        state.feature.properties.radiusInKm = radius;
    }
    else if (state.feature.properties.isRectangle) {
        var selectedCoordPath = state.selectedCoordPaths[0];
        var selectedCoord = state.feature.getCoordinate(selectedCoordPath);
        var selectedCoordPoint = {
            type: geojsonTypes.FEATURE,
            properties: {},
            geometry: {
                type: geojsonTypes.POINT,
                coordinates: selectedCoord,
            },
        };
        var constrainedDelta = constrainFeatureMovement([selectedCoordPoint], delta);
        if (selectedCoordPath === "0.0") {
            state.feature.updateCoordinate("0.1", state.feature.coordinates[0][1][0], state.feature.coordinates[0][1][1] + constrainedDelta.lat);
            state.feature.updateCoordinate("0.7", state.feature.coordinates[0][7][0], state.feature.coordinates[0][7][1] + constrainedDelta.lat);
        }
        else if (selectedCoordPath === "0.1") {
            state.feature.updateCoordinate("0.1", selectedCoord[0] + constrainedDelta.lng, selectedCoord[1] + constrainedDelta.lat);
            state.feature.updateCoordinate("0.3", state.feature.coordinates[0][3][0] + constrainedDelta.lng, state.feature.coordinates[0][3][1]);
            state.feature.updateCoordinate("0.7", state.feature.coordinates[0][7][0], state.feature.coordinates[0][7][1] + constrainedDelta.lat);
        }
        else if (selectedCoordPath === "0.2") {
            state.feature.updateCoordinate("0.1", state.feature.coordinates[0][1][0] + constrainedDelta.lng, state.feature.coordinates[0][1][1]);
            state.feature.updateCoordinate("0.3", state.feature.coordinates[0][3][0] + constrainedDelta.lng, state.feature.coordinates[0][3][1]);
        }
        else if (selectedCoordPath === "0.3") {
            state.feature.updateCoordinate("0.3", selectedCoord[0] + constrainedDelta.lng, selectedCoord[1] + constrainedDelta.lat);
            state.feature.updateCoordinate("0.1", state.feature.coordinates[0][1][0] + constrainedDelta.lng, state.feature.coordinates[0][1][1]);
            state.feature.updateCoordinate("0.5", state.feature.coordinates[0][5][0], state.feature.coordinates[0][5][1] + constrainedDelta.lat);
        }
        else if (selectedCoordPath === "0.4") {
            state.feature.updateCoordinate("0.3", state.feature.coordinates[0][3][0], state.feature.coordinates[0][3][1] + constrainedDelta.lat);
            state.feature.updateCoordinate("0.5", state.feature.coordinates[0][5][0], state.feature.coordinates[0][5][1] + constrainedDelta.lat);
        }
        else if (selectedCoordPath === "0.5") {
            state.feature.updateCoordinate("0.5", selectedCoord[0] + constrainedDelta.lng, selectedCoord[1] + constrainedDelta.lat);
            state.feature.updateCoordinate("0.7", state.feature.coordinates[0][7][0] + constrainedDelta.lng, state.feature.coordinates[0][7][1]);
            state.feature.updateCoordinate("0.3", state.feature.coordinates[0][3][0], state.feature.coordinates[0][3][1] + constrainedDelta.lat);
        }
        else if (selectedCoordPath === "0.6") {
            state.feature.updateCoordinate("0.5", state.feature.coordinates[0][5][0] + constrainedDelta.lng, state.feature.coordinates[0][5][1]);
            state.feature.updateCoordinate("0.7", state.feature.coordinates[0][7][0] + constrainedDelta.lng, state.feature.coordinates[0][7][1]);
        }
        else if (selectedCoordPath === "0.7") {
            state.feature.updateCoordinate("0.7", selectedCoord[0] + constrainedDelta.lng, selectedCoord[1] + constrainedDelta.lat);
            state.feature.updateCoordinate("0.5", state.feature.coordinates[0][5][0] + constrainedDelta.lng, state.feature.coordinates[0][5][1]);
            state.feature.updateCoordinate("0.1", state.feature.coordinates[0][1][0], state.feature.coordinates[0][1][1] + constrainedDelta.lat);
        }
        state.feature.updateCoordinate("0.0", (state.feature.coordinates[0][1][0] +
            state.feature.coordinates[0][7][0]) /
            2, (state.feature.coordinates[0][1][1] +
            state.feature.coordinates[0][7][1]) /
            2);
        state.feature.updateCoordinate("0.2", (state.feature.coordinates[0][1][0] +
            state.feature.coordinates[0][3][0]) /
            2, (state.feature.coordinates[0][1][1] +
            state.feature.coordinates[0][3][1]) /
            2);
        state.feature.updateCoordinate("0.4", (state.feature.coordinates[0][3][0] +
            state.feature.coordinates[0][5][0]) /
            2, (state.feature.coordinates[0][3][1] +
            state.feature.coordinates[0][5][1]) /
            2);
        state.feature.updateCoordinate("0.6", (state.feature.coordinates[0][5][0] +
            state.feature.coordinates[0][7][0]) /
            2, (state.feature.coordinates[0][5][1] +
            state.feature.coordinates[0][7][1]) /
            2);
    }
    else {
        var selectedCoords = state.selectedCoordPaths.map(function (coord_path) {
            return state.feature.getCoordinate(coord_path);
        });
        var selectedCoordPoints = selectedCoords.map(function (coords) { return ({
            type: geojsonTypes.FEATURE,
            properties: {},
            geometry: {
                type: geojsonTypes.POINT,
                coordinates: coords,
            },
        }); });
        var constrainedDelta = constrainFeatureMovement(selectedCoordPoints, delta);
        for (var i = 0; i < selectedCoords.length; i++) {
            var coord = selectedCoords[i];
            state.feature.updateCoordinate(state.selectedCoordPaths[i], coord[0] + constrainedDelta.lng, coord[1] + constrainedDelta.lat);
        }
    }
};
DirectMode.toDisplayFeatures = function (state, geojson, push) {
    if (state.featureId === geojson.properties.id) {
        geojson.properties.active = activeStates.ACTIVE;
        push(geojson);
        var supplementaryPoints = createSupplementaryPoints(geojson, {
            map: this.map,
            midpoints: true,
            selectedPaths: state.selectedCoordPaths,
        });
        if (geojson.properties.user_isCircle) {
            supplementaryPoints = createSupplementaryPointsForCircle(geojson);
        }
        if (geojson.properties.user_isRectangle) {
            supplementaryPoints = createSupplementaryPoints(geojson, {
                map: this.map,
                midpoints: false,
                selectedPaths: state.selectedCoordPaths,
            });
        }
        supplementaryPoints.forEach(push);
    }
    else {
        geojson.properties.active = activeStates.INACTIVE;
        push(geojson);
    }
    this.fireActionable(state);
};

var doubleClickZoom = {
    enable: function (ctx) {
        setTimeout(function () {
            // First check we've got a map and some context.
            if (!ctx.map ||
                !ctx.map.doubleClickZoom ||
                !ctx._ctx ||
                !ctx._ctx.store ||
                !ctx._ctx.store.getInitialConfigValue)
                return;
            // Now check initial state wasn't false (we leave it disabled if so)
            if (!ctx._ctx.store.getInitialConfigValue("doubleClickZoom"))
                return;
            ctx.map.doubleClickZoom.enable();
        }, 0);
    },
    disable: function (ctx) {
        setTimeout(function () {
            if (!ctx.map || !ctx.map.doubleClickZoom)
                return;
            // Always disable here, as it's necessary in some cases.
            ctx.map.doubleClickZoom.disable();
        }, 0);
    },
};
var DrawRectangle = __assign(__assign({}, MapboxDraw.modes.draw_polygon), { 
    // When the mode starts this function will be called.
    onSetup: function (opts) {
        var polygon = this.newFeature({
            type: "Feature",
            properties: {
                isRectangle: true,
            },
            geometry: {
                type: "Polygon",
                coordinates: [[]],
            },
        });
        this.addFeature(polygon);
        this.clearSelectedFeatures();
        doubleClickZoom.disable(this);
        // this.updateUIClasses({ mouse: "add" });
        // this.setActionableState({
        //   trash: true,
        // });
        return {
            polygon: polygon,
        };
    }, 
    // // support mobile taps
    // onTap: function (state, e) {
    //   // emulate 'move mouse' to update feature coords
    //   if (state.startPoint) this.onMouseMove(state, e);
    //   // emulate onClick
    //   this.onClick(state, e);
    // },
    // Whenever a user clicks on the map, Draw will call `onClick`
    onClick: function (state, e) {
        // if state.startPoint exist, means its second click
        //change to  simple_select mode
        if (state.startPoint &&
            state.startPoint[0] !== e.lngLat.lng &&
            state.startPoint[1] !== e.lngLat.lat) {
            this.updateUIClasses({ mouse: "pointer" });
            state.endPoint = [e.lngLat.lng, e.lngLat.lat];
            this.changeMode("simple_select", { featureIds: [state.polygon.id] });
        }
        // on first click, save clicked point coords as starting for  rectangle
        var startPoint = [e.lngLat.lng, e.lngLat.lat];
        state.startPoint = startPoint;
    }, onMouseMove: function (state, e) {
        // if startPoint, update the feature coordinates, using the bounding box concept
        // we are simply using the startingPoint coordinates and the current Mouse Position
        // coordinates to calculate the bounding box on the fly, which will be our rectangle
        if (state.startPoint) {
            state.polygon.updateCoordinate("0.0", state.startPoint[0], state.startPoint[1]); //minX, minY - the starting point
            state.polygon.updateCoordinate("0.1", (state.startPoint[0] + e.lngLat.lng) / 2, state.startPoint[1]); // midpoint
            state.polygon.updateCoordinate("0.2", e.lngLat.lng, state.startPoint[1]); // maxX, minY
            state.polygon.updateCoordinate("0.3", e.lngLat.lng, (state.startPoint[1] + e.lngLat.lat) / 2); // midpoint
            state.polygon.updateCoordinate("0.4", e.lngLat.lng, e.lngLat.lat); // maxX, maxY3
            state.polygon.updateCoordinate("0.5", (e.lngLat.lng + state.startPoint[0]) / 2, e.lngLat.lat); // midpoint
            state.polygon.updateCoordinate("0.6", state.startPoint[0], e.lngLat.lat); // minX,maxY
            state.polygon.updateCoordinate("0.7", state.startPoint[0], (e.lngLat.lat + state.startPoint[1]) / 2); // midpoint
            state.polygon.updateCoordinate("0.8", state.startPoint[0], state.startPoint[1]); //minX,minY - ending point (equals to starting point)
        }
    } });

var getPlanFromServiceID = function (id) {
    if (id === 1) {
        return "Free plan";
    }
    else if (id >= 1001 && id <= 1003) {
        return "Fleet plan";
    }
    else if (id === 1004) {
        return "Basic plan";
    }
    else if (id === 1005) {
        return "Smart plan";
    }
    else if (id === 1998 || id === 1999) {
        return "Fleet plan";
    }
    else if (id >= 4001 && id <= 4029) {
        return "Fleet plan";
        // mantis - 12319,12316 스마트계정 요금제 추가 (Leehj)
    }
    else if (id >= 10001 && id <= 10015) {
        return "Smart plan";
    }
    else if (id >= 20001 && id <= 20999) {
        return "Fleet plan";
    }
    else if (id >= 30001 && id <= 30999) {
        return "Fleet plan";
    }
    else if (id >= 50001 && id <= 50999) {
        return "Plus plan";
        // mantis - 12311, 12312, 12313,12314, 12320 lite계정 요금제 추가 (Leehj)
    }
    else if (id >= 11001 && id <= 11015) {
        return "Lite plan";
    }
    return "";
};

var download = function (url) { return __awaiter(void 0, void 0, void 0, function () {
    var browser, a;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                browser = detect();
                a = document.createElement("a");
                a.download = "";
                a.href = url;
                if ((browser === null || browser === void 0 ? void 0 : browser.name) !== "ios") {
                    a.target = "_blank";
                }
                a.style.display = "none";
                document.body.append(a);
                a.click();
                // Chrome requires the timeout
                return [4 /*yield*/, delay(100)];
            case 1:
                // Chrome requires the timeout
                _a.sent();
                a.remove();
                return [2 /*return*/];
        }
    });
}); };
var delay = function (milliseconds) {
    return new Promise(function (resolve) {
        setTimeout(resolve, milliseconds);
    });
};
var multiDownload = function (urls) { return __awaiter(void 0, void 0, void 0, function () {
    var browser, timeout;
    return __generator(this, function (_a) {
        browser = detect();
        timeout = 1000;
        if ((browser === null || browser === void 0 ? void 0 : browser.name) === "ios") {
            timeout = 3000;
        }
        _.forEach(urls, function (url, index) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, delay(index * timeout)];
                    case 1:
                        _a.sent();
                        download(url);
                        return [2 /*return*/];
                }
            });
        }); });
        return [2 /*return*/];
    });
}); };
var doDownload = function (linkUrl, filename) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        console.log("doDownload", linkUrl);
        return [2 /*return*/, new Promise(function (resolve, reject) {
                var browser = detect();
                if ((browser === null || browser === void 0 ? void 0 : browser.name) === "ios" || (browser === null || browser === void 0 ? void 0 : browser.name) === "crios") {
                    console.log("safari");
                    window.location.href = linkUrl;
                }
                else {
                    var link_1 = document.createElement("a");
                    link_1.href = linkUrl;
                    if (filename) {
                        link_1.download = filename;
                    }
                    link_1.target = "_blank";
                    document.body.appendChild(link_1);
                    setTimeout(function () {
                        link_1.click();
                        // document.body.removeChild(link);
                        resolve();
                    }, 0);
                }
            })];
    });
}); };
var getDirectionString = function (dir, model) {
    // if (_.includes(MODELS_2CH, model) && dir === "Interior") {
    //   return "Rear";
    // } else {
    //   return dir;
    // }
    return dir;
};
var getDirection = function (dir, isOptionModel) {
    if (dir === 2) {
        return "Rear";
    }
    else if (dir === 3) {
        if (isOptionModel) {
            return "Option";
        }
        return "Interior";
    }
    return "Front";
};
var getFileRes = function (filename) {
    var fs = filename.split("_")[2];
    var fs2 = fs.split(".")[0];
    return fs2[2] === "S" ? "S" : "M";
};
var getOriginalFilename = function (filename) {
    var fs = filename.split("_");
    var fs2 = fs[2].split(".");
    return fs2[0][2] === "S"
        ? "".concat(fs[0], "_").concat(fs[1], "_").concat(fs2[0][0]).concat(fs2[0][1], ".").concat(fs2[1])
        : filename;
};
// export const getDirection = (dir: Direction, isOptionModel: boolean) => {
//   if (dir === 2) {
//     return "Rear";
//   } else if (dir === 3) {
//     if (isOptionModel) {
//       return "Option";
//     }
//     return "Interior";
//   }
//   return "Front";
// };
var downloadBlob = function (data, fileName, mimeType) {
    var blob = new Blob([data], {
        type: mimeType,
    });
    var url = window.URL.createObjectURL(blob);
    downloadURL(url, fileName);
    setTimeout(function () {
        return window.URL.revokeObjectURL(url);
    }, 1000);
};
var downloadURL = function (data, fileName) {
    var a = document.createElement("a");
    a.href = data;
    a.download = fileName;
    a.style.display = "none";
    document.body.appendChild(a);
    a.click();
    a.remove();
};
// 해시태그가 없는 Parking, Normal 공유영상인 경우 Parking, Normal로 출력(Leehj)
var eventToText = function (mode, type) {
    var cType = typeof type === "string" ? parseInt(type) : type;
    console.log("event");
    if (mode === "M") {
        return "Manual";
    }
    if (mode === "P" && cType === 0) {
        return "Parking";
    }
    if (mode === "P") {
        return "Parking impact";
    }
    if (mode === "N") {
        return "Normal";
    }
    return MCODE_TO_TEXT[cType];
};
var parseNMEA = function (nmea, playback, camera) {
    var _a, _b;
    var locations = [];
    var nmeaStrings = [];
    //@ts-ignore
    var matches = nmea.matchAll(/(\[[0-9]{13}\]\$(GNRMC|GPRMC){1}[A-Z0-9,.*]+)/g);
    var next;
    while ((next = matches.next().value)) {
        // console.log("next", next);
        nmeaStrings.push(next[0]);
    }
    //console.log("nmeaStrings", decoder.decode(data), nmeaStrings);
    locations = _.chain(nmeaStrings)
        .filter(function (s) { return s.indexOf("$GNRMC") !== -1 || s.indexOf("$GPRMC") !== -1; })
        .map(function (s) {
        var nmeas = s.split(",");
        // console.log("nmeas", nmeas, nmeas.length);
        if (nmeas.length === 13 || nmeas.length === 14) {
            var dur = moment.duration("".concat(nmeas[1].slice(0, 2), ":").concat(nmeas[1].slice(2, 4), ":").concat(nmeas[1].slice(4)));
            var time = dur.asSeconds();
            // 미국/중국 gps location 잘못 나오는 문제 수정
            var lat = (nmeas[4] === "N" ? 1 : -1) * DMStoDegree(parseFloat(nmeas[3]));
            var lng = (nmeas[6] === "E" ? 1 : -1) * DMStoDegree(parseFloat(nmeas[5]));
            var speed = nmeas[7];
            var heading = parseFloat(nmeas[8]);
            if (!(isNaN(time) || isNaN(lat) || isNaN(lng))) {
                return {
                    time: time,
                    lat: lat,
                    lng: lng,
                    heading: heading,
                    name: camera === null || camera === void 0 ? void 0 : camera.dev_name,
                    mode: "0",
                    speed: speed,
                    // mantis - 8561, playback에서 비디오 실행하는 경우 active 무조건 on (속도출력위함)
                    active: playback && "on",
                };
            }
        }
        return undefined;
    })
        .compact()
        .sortBy("time")
        .value();
    var baseTime = (_b = (_a = _.first(locations)) === null || _a === void 0 ? void 0 : _a.time) !== null && _b !== void 0 ? _b : 0;
    locations = _.map(locations, function (loc) {
        var _a;
        return (__assign(__assign({}, loc), { time: ((_a = loc.time) !== null && _a !== void 0 ? _a : baseTime) - baseTime }));
    });
    return locations;
};
var convertLowFilenameToOrignal = function (filename) {
    var f1 = filename.split(".");
    var fnames = f1[0].split("_");
    return "".concat(fnames[0], "_").concat(fnames[1], "_").concat(fnames[2].substring(0, 2), ".").concat(f1[1]);
};
var getDirectionVOD = function (c) {
    if (c === "R") {
        return "Rear";
    }
    else if (c === "I") {
        return "Interior";
    }
    else if (c === "O") {
        // 7 BOX option카메라 관련 추가 (8489)
        return "Option";
    }
    return "Front";
};
var getEvent = function (c) {
    if (_.includes(["E", "I", "O", "A", "T", "B", "R", "X", "G", "F", "D", "L", "C", "S", "Y", "J"], c)) {
        return "Event";
    }
    else if (c === "M") {
        return "Manual";
    }
    else if (c === "P") {
        return "Parking";
    }
    return "Normal";
};

var eventmapAxiosInst = axios$1.create({
    baseURL: EVENTMAP_REV_API_SERVER_URI,
    timeout: 30 * 1000,
});
var eventmapJwtAxiosInst = axios$1.create({
    baseURL: EVENTMAP_REV_API_SERVER_URI,
    timeout: 30 * 1000,
});
var jwtAxiosInst = axios$1.create({
    baseURL: API_GATEWAY_URI,
    timeout: 30 * 1000,
});
var axiosInst = axios$1.create({
    baseURL: API_SERVER_URI,
    timeout: 30 * 1000,
});
var sleep = function (ms) {
    return new Promise(function (resolve) { return setTimeout(resolve, ms); });
};

var util_inspect = requireUtil$1().inspect;

var hasMap = typeof Map === 'function' && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
var mapForEach = hasMap && Map.prototype.forEach;
var hasSet = typeof Set === 'function' && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
var setForEach = hasSet && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString = Object.prototype.toString;
var functionToString = Function.prototype.toString;
var $match = String.prototype.match;
var $slice = String.prototype.slice;
var $replace = String.prototype.replace;
var $toUpperCase = String.prototype.toUpperCase;
var $toLowerCase = String.prototype.toLowerCase;
var $test = RegExp.prototype.test;
var $concat = Array.prototype.concat;
var $join = Array.prototype.join;
var $arrSlice = Array.prototype.slice;
var $floor = Math.floor;
var bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var gOPS = Object.getOwnPropertySymbols;
var symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? 'object' : 'symbol')
    ? Symbol.toStringTag
    : null;
var isEnumerable = Object.prototype.propertyIsEnumerable;

var gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || (
    [].__proto__ === Array.prototype // eslint-disable-line no-proto
        ? function (O) {
            return O.__proto__; // eslint-disable-line no-proto
        }
        : null
);

function addNumericSeparator(num, str) {
    if (
        num === Infinity
        || num === -Infinity
        || num !== num
        || (num && num > -1000 && num < 1000)
        || $test.call(/e/, str)
    ) {
        return str;
    }
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$floor(-num) : $floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $slice.call(str, intStr.length + 1);
            return $replace.call(intStr, sepRegex, '$&_') + '.' + $replace.call($replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $replace.call(str, sepRegex, '$&_');
}

var utilInspect = util_inspect;
var inspectCustom = utilInspect.custom;
var inspectSymbol = isSymbol(inspectCustom) ? inspectCustom : null;

var objectInspect = function inspect_(obj, options, depth, seen) {
    var opts = options || {};

    if (has$3(opts, 'quoteStyle') && (opts.quoteStyle !== 'single' && opts.quoteStyle !== 'double')) {
        throw new TypeError('option "quoteStyle" must be "single" or "double"');
    }
    if (
        has$3(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number'
            ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity
            : opts.maxStringLength !== null
        )
    ) {
        throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    }
    var customInspect = has$3(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') {
        throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    }

    if (
        has$3(opts, 'indent')
        && opts.indent !== null
        && opts.indent !== '\t'
        && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)
    ) {
        throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    }
    if (has$3(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') {
        throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    }
    var numericSeparator = opts.numericSeparator;

    if (typeof obj === 'undefined') {
        return 'undefined';
    }
    if (obj === null) {
        return 'null';
    }
    if (typeof obj === 'boolean') {
        return obj ? 'true' : 'false';
    }

    if (typeof obj === 'string') {
        return inspectString(obj, opts);
    }
    if (typeof obj === 'number') {
        if (obj === 0) {
            return Infinity / obj > 0 ? '0' : '-0';
        }
        var str = String(obj);
        return numericSeparator ? addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }

    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') { depth = 0; }
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') {
        return isArray$3(obj) ? '[Array]' : '[Object]';
    }

    var indent = getIndent(opts, depth);

    if (typeof seen === 'undefined') {
        seen = [];
    } else if (indexOf(seen, obj) >= 0) {
        return '[Circular]';
    }

    function inspect(value, from, noIndent) {
        if (from) {
            seen = $arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if (has$3(opts, 'quoteStyle')) {
                newOpts.quoteStyle = opts.quoteStyle;
            }
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }

    if (typeof obj === 'function' && !isRegExp$1(obj)) { // in older engines, regexes are callable
        var name = nameOf(obj);
        var keys = arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $join.call(keys, ', ') + ' }' : '');
    }
    if (isSymbol(obj)) {
        var symString = hasShammedSymbols ? $replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : symToString.call(obj);
        return typeof obj === 'object' && !hasShammedSymbols ? markBoxed(symString) : symString;
    }
    if (isElement(obj)) {
        var s = '<' + $toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for (var i = 0; i < attrs.length; i++) {
            s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
        }
        s += '>';
        if (obj.childNodes && obj.childNodes.length) { s += '...'; }
        s += '</' + $toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if (isArray$3(obj)) {
        if (obj.length === 0) { return '[]'; }
        var xs = arrObjKeys(obj, inspect);
        if (indent && !singleLineValues(xs)) {
            return '[' + indentedJoin(xs, indent) + ']';
        }
        return '[ ' + $join.call(xs, ', ') + ' ]';
    }
    if (isError(obj)) {
        var parts = arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !isEnumerable.call(obj, 'cause')) {
            return '{ [' + String(obj) + '] ' + $join.call($concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        }
        if (parts.length === 0) { return '[' + String(obj) + ']'; }
        return '{ [' + String(obj) + '] ' + $join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if (inspectSymbol && typeof obj[inspectSymbol] === 'function' && utilInspect) {
            return utilInspect(obj, { depth: maxDepth - depth });
        } else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') {
            return obj.inspect();
        }
    }
    if (isMap(obj)) {
        var mapParts = [];
        if (mapForEach) {
            mapForEach.call(obj, function (value, key) {
                mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
            });
        }
        return collectionOf('Map', mapSize.call(obj), mapParts, indent);
    }
    if (isSet(obj)) {
        var setParts = [];
        if (setForEach) {
            setForEach.call(obj, function (value) {
                setParts.push(inspect(value, obj));
            });
        }
        return collectionOf('Set', setSize.call(obj), setParts, indent);
    }
    if (isWeakMap(obj)) {
        return weakCollectionOf('WeakMap');
    }
    if (isWeakSet(obj)) {
        return weakCollectionOf('WeakSet');
    }
    if (isWeakRef(obj)) {
        return weakCollectionOf('WeakRef');
    }
    if (isNumber(obj)) {
        return markBoxed(inspect(Number(obj)));
    }
    if (isBigInt(obj)) {
        return markBoxed(inspect(bigIntValueOf.call(obj)));
    }
    if (isBoolean(obj)) {
        return markBoxed(booleanValueOf.call(obj));
    }
    if (isString(obj)) {
        return markBoxed(inspect(String(obj)));
    }
    if (!isDate(obj) && !isRegExp$1(obj)) {
        var ys = arrObjKeys(obj, inspect);
        var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $join.call($concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) { return tag + '{}'; }
        if (indent) {
            return tag + '{' + indentedJoin(ys, indent) + '}';
        }
        return tag + '{ ' + $join.call(ys, ', ') + ' }';
    }
    return String(obj);
};

function wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = (opts.quoteStyle || defaultStyle) === 'double' ? '"' : "'";
    return quoteChar + s + quoteChar;
}

function quote(s) {
    return $replace.call(String(s), /"/g, '&quot;');
}

function isArray$3(obj) { return toStr(obj) === '[object Array]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isDate(obj) { return toStr(obj) === '[object Date]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isRegExp$1(obj) { return toStr(obj) === '[object RegExp]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isError(obj) { return toStr(obj) === '[object Error]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isString(obj) { return toStr(obj) === '[object String]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isNumber(obj) { return toStr(obj) === '[object Number]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isBoolean(obj) { return toStr(obj) === '[object Boolean]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }

// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function isSymbol(obj) {
    if (hasShammedSymbols) {
        return obj && typeof obj === 'object' && obj instanceof Symbol;
    }
    if (typeof obj === 'symbol') {
        return true;
    }
    if (!obj || typeof obj !== 'object' || !symToString) {
        return false;
    }
    try {
        symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}

function isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !bigIntValueOf) {
        return false;
    }
    try {
        bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}

var hasOwn = Object.prototype.hasOwnProperty || function (key) { return key in this; };
function has$3(obj, key) {
    return hasOwn.call(obj, key);
}

function toStr(obj) {
    return objectToString.call(obj);
}

function nameOf(f) {
    if (f.name) { return f.name; }
    var m = $match.call(functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) { return m[1]; }
    return null;
}

function indexOf(xs, x) {
    if (xs.indexOf) { return xs.indexOf(x); }
    for (var i = 0, l = xs.length; i < l; i++) {
        if (xs[i] === x) { return i; }
    }
    return -1;
}

function isMap(x) {
    if (!mapSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        mapSize.call(x);
        try {
            setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakMap(x) {
    if (!weakMapHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakMapHas.call(x, weakMapHas);
        try {
            weakSetHas.call(x, weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakRef(x) {
    if (!weakRefDeref || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}

function isSet(x) {
    if (!setSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        setSize.call(x);
        try {
            mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakSet(x) {
    if (!weakSetHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakSetHas.call(x, weakSetHas);
        try {
            weakMapHas.call(x, weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isElement(x) {
    if (!x || typeof x !== 'object') { return false; }
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) {
        return true;
    }
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}

function inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    // eslint-disable-next-line no-control-regex
    var s = $replace.call($replace.call(str, /(['\\])/g, '\\$1'), /[\x00-\x1f]/g, lowbyte);
    return wrapQuotes(s, 'single', opts);
}

function lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) { return '\\' + x; }
    return '\\x' + (n < 0x10 ? '0' : '') + $toUpperCase.call(n.toString(16));
}

function markBoxed(str) {
    return 'Object(' + str + ')';
}

function weakCollectionOf(type) {
    return type + ' { ? }';
}

function collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}

function singleLineValues(xs) {
    for (var i = 0; i < xs.length; i++) {
        if (indexOf(xs[i], '\n') >= 0) {
            return false;
        }
    }
    return true;
}

function getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') {
        baseIndent = '\t';
    } else if (typeof opts.indent === 'number' && opts.indent > 0) {
        baseIndent = $join.call(Array(opts.indent + 1), ' ');
    } else {
        return null;
    }
    return {
        base: baseIndent,
        prev: $join.call(Array(depth + 1), baseIndent)
    };
}

function indentedJoin(xs, indent) {
    if (xs.length === 0) { return ''; }
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}

function arrObjKeys(obj, inspect) {
    var isArr = isArray$3(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for (var i = 0; i < obj.length; i++) {
            xs[i] = has$3(obj, i) ? inspect(obj[i], obj) : '';
        }
    }
    var syms = typeof gOPS === 'function' ? gOPS(obj) : [];
    var symMap;
    if (hasShammedSymbols) {
        symMap = {};
        for (var k = 0; k < syms.length; k++) {
            symMap['$' + syms[k]] = syms[k];
        }
    }

    for (var key in obj) { // eslint-disable-line no-restricted-syntax
        if (!has$3(obj, key)) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (hasShammedSymbols && symMap['$' + key] instanceof Symbol) {
            // this is to prevent shammed Symbols, which are stored as strings, from being included in the string key section
            continue; // eslint-disable-line no-restricted-syntax, no-continue
        } else if ($test.call(/[^\w$]/, key)) {
            xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        } else {
            xs.push(key + ': ' + inspect(obj[key], obj));
        }
    }
    if (typeof gOPS === 'function') {
        for (var j = 0; j < syms.length; j++) {
            if (isEnumerable.call(obj, syms[j])) {
                xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
            }
        }
    }
    return xs;
}

var GetIntrinsic = getIntrinsic;
var callBound = callBound$1;
var inspect = objectInspect;

var $TypeError = GetIntrinsic('%TypeError%');
var $WeakMap = GetIntrinsic('%WeakMap%', true);
var $Map = GetIntrinsic('%Map%', true);

var $weakMapGet = callBound('WeakMap.prototype.get', true);
var $weakMapSet = callBound('WeakMap.prototype.set', true);
var $weakMapHas = callBound('WeakMap.prototype.has', true);
var $mapGet = callBound('Map.prototype.get', true);
var $mapSet = callBound('Map.prototype.set', true);
var $mapHas = callBound('Map.prototype.has', true);

/*
 * This function traverses the list returning the node corresponding to the
 * given key.
 *
 * That node is also moved to the head of the list, so that if it's accessed
 * again we don't need to traverse the whole list. By doing so, all the recently
 * used nodes can be accessed relatively quickly.
 */
var listGetNode = function (list, key) { // eslint-disable-line consistent-return
	for (var prev = list, curr; (curr = prev.next) !== null; prev = curr) {
		if (curr.key === key) {
			prev.next = curr.next;
			curr.next = list.next;
			list.next = curr; // eslint-disable-line no-param-reassign
			return curr;
		}
	}
};

var listGet = function (objects, key) {
	var node = listGetNode(objects, key);
	return node && node.value;
};
var listSet = function (objects, key, value) {
	var node = listGetNode(objects, key);
	if (node) {
		node.value = value;
	} else {
		// Prepend the new node to the beginning of the list
		objects.next = { // eslint-disable-line no-param-reassign
			key: key,
			next: objects.next,
			value: value
		};
	}
};
var listHas = function (objects, key) {
	return !!listGetNode(objects, key);
};

var sideChannel = function getSideChannel() {
	var $wm;
	var $m;
	var $o;
	var channel = {
		assert: function (key) {
			if (!channel.has(key)) {
				throw new $TypeError('Side channel does not contain ' + inspect(key));
			}
		},
		get: function (key) { // eslint-disable-line consistent-return
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if ($wm) {
					return $weakMapGet($wm, key);
				}
			} else if ($Map) {
				if ($m) {
					return $mapGet($m, key);
				}
			} else {
				if ($o) { // eslint-disable-line no-lonely-if
					return listGet($o, key);
				}
			}
		},
		has: function (key) {
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if ($wm) {
					return $weakMapHas($wm, key);
				}
			} else if ($Map) {
				if ($m) {
					return $mapHas($m, key);
				}
			} else {
				if ($o) { // eslint-disable-line no-lonely-if
					return listHas($o, key);
				}
			}
			return false;
		},
		set: function (key, value) {
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if (!$wm) {
					$wm = new $WeakMap();
				}
				$weakMapSet($wm, key, value);
			} else if ($Map) {
				if (!$m) {
					$m = new $Map();
				}
				$mapSet($m, key, value);
			} else {
				if (!$o) {
					/*
					 * Initialize the linked list as an empty node, so that we don't have
					 * to special-case handling of the first node: we can always refer to
					 * it as (previous node).next, instead of something like (list).head
					 */
					$o = { key: {}, next: null };
				}
				listSet($o, key, value);
			}
		}
	};
	return channel;
};

var replace = String.prototype.replace;
var percentTwenties = /%20/g;

var Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};

var formats$3 = {
    'default': Format.RFC3986,
    formatters: {
        RFC1738: function (value) {
            return replace.call(value, percentTwenties, '+');
        },
        RFC3986: function (value) {
            return String(value);
        }
    },
    RFC1738: Format.RFC1738,
    RFC3986: Format.RFC3986
};

var formats$2 = formats$3;

var has$2 = Object.prototype.hasOwnProperty;
var isArray$2 = Array.isArray;

var hexTable = (function () {
    var array = [];
    for (var i = 0; i < 256; ++i) {
        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    }

    return array;
}());

var compactQueue = function compactQueue(queue) {
    while (queue.length > 1) {
        var item = queue.pop();
        var obj = item.obj[item.prop];

        if (isArray$2(obj)) {
            var compacted = [];

            for (var j = 0; j < obj.length; ++j) {
                if (typeof obj[j] !== 'undefined') {
                    compacted.push(obj[j]);
                }
            }

            item.obj[item.prop] = compacted;
        }
    }
};

var arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for (var i = 0; i < source.length; ++i) {
        if (typeof source[i] !== 'undefined') {
            obj[i] = source[i];
        }
    }

    return obj;
};

var merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */
    if (!source) {
        return target;
    }

    if (typeof source !== 'object') {
        if (isArray$2(target)) {
            target.push(source);
        } else if (target && typeof target === 'object') {
            if ((options && (options.plainObjects || options.allowPrototypes)) || !has$2.call(Object.prototype, source)) {
                target[source] = true;
            }
        } else {
            return [target, source];
        }

        return target;
    }

    if (!target || typeof target !== 'object') {
        return [target].concat(source);
    }

    var mergeTarget = target;
    if (isArray$2(target) && !isArray$2(source)) {
        mergeTarget = arrayToObject(target, options);
    }

    if (isArray$2(target) && isArray$2(source)) {
        source.forEach(function (item, i) {
            if (has$2.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') {
                    target[i] = merge(targetItem, item, options);
                } else {
                    target.push(item);
                }
            } else {
                target[i] = item;
            }
        });
        return target;
    }

    return Object.keys(source).reduce(function (acc, key) {
        var value = source[key];

        if (has$2.call(acc, key)) {
            acc[key] = merge(acc[key], value, options);
        } else {
            acc[key] = value;
        }
        return acc;
    }, mergeTarget);
};

var assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function (acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};

var decode = function (str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') {
        // unescape never throws, no try...catch needed:
        return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    }
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};

var encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    var string = str;
    if (typeof str === 'symbol') {
        string = Symbol.prototype.toString.call(str);
    } else if (typeof str !== 'string') {
        string = String(str);
    }

    if (charset === 'iso-8859-1') {
        return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
            return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
        });
    }

    var out = '';
    for (var i = 0; i < string.length; ++i) {
        var c = string.charCodeAt(i);

        if (
            c === 0x2D // -
            || c === 0x2E // .
            || c === 0x5F // _
            || c === 0x7E // ~
            || (c >= 0x30 && c <= 0x39) // 0-9
            || (c >= 0x41 && c <= 0x5A) // a-z
            || (c >= 0x61 && c <= 0x7A) // A-Z
            || (format === formats$2.RFC1738 && (c === 0x28 || c === 0x29)) // ( )
        ) {
            out += string.charAt(i);
            continue;
        }

        if (c < 0x80) {
            out = out + hexTable[c];
            continue;
        }

        if (c < 0x800) {
            out = out + (hexTable[0xC0 | (c >> 6)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        if (c < 0xD800 || c >= 0xE000) {
            out = out + (hexTable[0xE0 | (c >> 12)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        i += 1;
        c = 0x10000 + (((c & 0x3FF) << 10) | (string.charCodeAt(i) & 0x3FF));
        /* eslint operator-linebreak: [2, "before"] */
        out += hexTable[0xF0 | (c >> 18)]
            + hexTable[0x80 | ((c >> 12) & 0x3F)]
            + hexTable[0x80 | ((c >> 6) & 0x3F)]
            + hexTable[0x80 | (c & 0x3F)];
    }

    return out;
};

var compact = function compact(value) {
    var queue = [{ obj: { o: value }, prop: 'o' }];
    var refs = [];

    for (var i = 0; i < queue.length; ++i) {
        var item = queue[i];
        var obj = item.obj[item.prop];

        var keys = Object.keys(obj);
        for (var j = 0; j < keys.length; ++j) {
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({ obj: obj, prop: key });
                refs.push(val);
            }
        }
    }

    compactQueue(queue);

    return value;
};

var isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};

var isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') {
        return false;
    }

    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};

var combine = function combine(a, b) {
    return [].concat(a, b);
};

var maybeMap = function maybeMap(val, fn) {
    if (isArray$2(val)) {
        var mapped = [];
        for (var i = 0; i < val.length; i += 1) {
            mapped.push(fn(val[i]));
        }
        return mapped;
    }
    return fn(val);
};

var utils$2 = {
    arrayToObject: arrayToObject,
    assign: assign,
    combine: combine,
    compact: compact,
    decode: decode,
    encode: encode,
    isBuffer: isBuffer,
    isRegExp: isRegExp,
    maybeMap: maybeMap,
    merge: merge
};

var getSideChannel = sideChannel;
var utils$1 = utils$2;
var formats$1 = formats$3;
var has$1 = Object.prototype.hasOwnProperty;

var arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};

var isArray$1 = Array.isArray;
var split = String.prototype.split;
var push = Array.prototype.push;
var pushToArray = function (arr, valueOrArray) {
    push.apply(arr, isArray$1(valueOrArray) ? valueOrArray : [valueOrArray]);
};

var toISO = Date.prototype.toISOString;

var defaultFormat = formats$1['default'];
var defaults$1 = {
    addQueryPrefix: false,
    allowDots: false,
    charset: 'utf-8',
    charsetSentinel: false,
    delimiter: '&',
    encode: true,
    encoder: utils$1.encode,
    encodeValuesOnly: false,
    format: defaultFormat,
    formatter: formats$1.formatters[defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};

var isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string'
        || typeof v === 'number'
        || typeof v === 'boolean'
        || typeof v === 'symbol'
        || typeof v === 'bigint';
};

var sentinel = {};

var stringify$1 = function stringify(
    object,
    prefix,
    generateArrayPrefix,
    commaRoundTrip,
    strictNullHandling,
    skipNulls,
    encoder,
    filter,
    sort,
    allowDots,
    serializeDate,
    format,
    formatter,
    encodeValuesOnly,
    charset,
    sideChannel
) {
    var obj = object;

    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while ((tmpSc = tmpSc.get(sentinel)) !== void undefined && !findFlag) {
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== 'undefined') {
            if (pos === step) {
                throw new RangeError('Cyclic object value');
            } else {
                findFlag = true; // Break while
            }
        }
        if (typeof tmpSc.get(sentinel) === 'undefined') {
            step = 0;
        }
    }

    if (typeof filter === 'function') {
        obj = filter(prefix, obj);
    } else if (obj instanceof Date) {
        obj = serializeDate(obj);
    } else if (generateArrayPrefix === 'comma' && isArray$1(obj)) {
        obj = utils$1.maybeMap(obj, function (value) {
            if (value instanceof Date) {
                return serializeDate(value);
            }
            return value;
        });
    }

    if (obj === null) {
        if (strictNullHandling) {
            return encoder && !encodeValuesOnly ? encoder(prefix, defaults$1.encoder, charset, 'key', format) : prefix;
        }

        obj = '';
    }

    if (isNonNullishPrimitive(obj) || utils$1.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults$1.encoder, charset, 'key', format);
            if (generateArrayPrefix === 'comma' && encodeValuesOnly) {
                var valuesArray = split.call(String(obj), ',');
                var valuesJoined = '';
                for (var i = 0; i < valuesArray.length; ++i) {
                    valuesJoined += (i === 0 ? '' : ',') + formatter(encoder(valuesArray[i], defaults$1.encoder, charset, 'value', format));
                }
                return [formatter(keyValue) + (commaRoundTrip && isArray$1(obj) && valuesArray.length === 1 ? '[]' : '') + '=' + valuesJoined];
            }
            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults$1.encoder, charset, 'value', format))];
        }
        return [formatter(prefix) + '=' + formatter(String(obj))];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys;
    if (generateArrayPrefix === 'comma' && isArray$1(obj)) {
        // we need to join elements in
        objKeys = [{ value: obj.length > 0 ? obj.join(',') || null : void undefined }];
    } else if (isArray$1(filter)) {
        objKeys = filter;
    } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }

    var adjustedPrefix = commaRoundTrip && isArray$1(obj) && obj.length === 1 ? prefix + '[]' : prefix;

    for (var j = 0; j < objKeys.length; ++j) {
        var key = objKeys[j];
        var value = typeof key === 'object' && typeof key.value !== 'undefined' ? key.value : obj[key];

        if (skipNulls && value === null) {
            continue;
        }

        var keyPrefix = isArray$1(obj)
            ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(adjustedPrefix, key) : adjustedPrefix
            : adjustedPrefix + (allowDots ? '.' + key : '[' + key + ']');

        sideChannel.set(object, step);
        var valueSideChannel = getSideChannel();
        valueSideChannel.set(sentinel, sideChannel);
        pushToArray(values, stringify(
            value,
            keyPrefix,
            generateArrayPrefix,
            commaRoundTrip,
            strictNullHandling,
            skipNulls,
            encoder,
            filter,
            sort,
            allowDots,
            serializeDate,
            format,
            formatter,
            encodeValuesOnly,
            charset,
            valueSideChannel
        ));
    }

    return values;
};

var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) {
        return defaults$1;
    }

    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') {
        throw new TypeError('Encoder has to be a function.');
    }

    var charset = opts.charset || defaults$1.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }

    var format = formats$1['default'];
    if (typeof opts.format !== 'undefined') {
        if (!has$1.call(formats$1.formatters, opts.format)) {
            throw new TypeError('Unknown format option provided.');
        }
        format = opts.format;
    }
    var formatter = formats$1.formatters[format];

    var filter = defaults$1.filter;
    if (typeof opts.filter === 'function' || isArray$1(opts.filter)) {
        filter = opts.filter;
    }

    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : defaults$1.addQueryPrefix,
        allowDots: typeof opts.allowDots === 'undefined' ? defaults$1.allowDots : !!opts.allowDots,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults$1.charsetSentinel,
        delimiter: typeof opts.delimiter === 'undefined' ? defaults$1.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : defaults$1.encode,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : defaults$1.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : defaults$1.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : defaults$1.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : defaults$1.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults$1.strictNullHandling
    };
};

var stringify_1 = function (object, opts) {
    var obj = object;
    var options = normalizeStringifyOptions(opts);

    var objKeys;
    var filter;

    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if (isArray$1(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }

    var keys = [];

    if (typeof obj !== 'object' || obj === null) {
        return '';
    }

    var arrayFormat;
    if (opts && opts.arrayFormat in arrayPrefixGenerators) {
        arrayFormat = opts.arrayFormat;
    } else if (opts && 'indices' in opts) {
        arrayFormat = opts.indices ? 'indices' : 'repeat';
    } else {
        arrayFormat = 'indices';
    }

    var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];
    if (opts && 'commaRoundTrip' in opts && typeof opts.commaRoundTrip !== 'boolean') {
        throw new TypeError('`commaRoundTrip` must be a boolean, or absent');
    }
    var commaRoundTrip = generateArrayPrefix === 'comma' && opts && opts.commaRoundTrip;

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    if (options.sort) {
        objKeys.sort(options.sort);
    }

    var sideChannel = getSideChannel();
    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (options.skipNulls && obj[key] === null) {
            continue;
        }
        pushToArray(keys, stringify$1(
            obj[key],
            key,
            generateArrayPrefix,
            commaRoundTrip,
            options.strictNullHandling,
            options.skipNulls,
            options.encode ? options.encoder : null,
            options.filter,
            options.sort,
            options.allowDots,
            options.serializeDate,
            options.format,
            options.formatter,
            options.encodeValuesOnly,
            options.charset,
            sideChannel
        ));
    }

    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';

    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') {
            // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
            prefix += 'utf8=%26%2310003%3B&';
        } else {
            // encodeURIComponent('✓')
            prefix += 'utf8=%E2%9C%93&';
        }
    }

    return joined.length > 0 ? prefix + joined : '';
};

var utils = utils$2;

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var defaults = {
    allowDots: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decoder: utils.decode,
    delimiter: '&',
    depth: 5,
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictNullHandling: false
};

var interpretNumericEntities = function (str) {
    return str.replace(/&#(\d+);/g, function ($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};

var parseArrayValue = function (val, options) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) {
        return val.split(',');
    }

    return val;
};

// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')

// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')

var parseValues = function parseQueryStringValues(str, options) {
    var obj = {};
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;

    var charset = options.charset;
    if (options.charsetSentinel) {
        for (i = 0; i < parts.length; ++i) {
            if (parts[i].indexOf('utf8=') === 0) {
                if (parts[i] === charsetSentinel) {
                    charset = 'utf-8';
                } else if (parts[i] === isoSentinel) {
                    charset = 'iso-8859-1';
                }
                skipIndex = i;
                i = parts.length; // The eslint settings do not allow break;
            }
        }
    }

    for (i = 0; i < parts.length; ++i) {
        if (i === skipIndex) {
            continue;
        }
        var part = parts[i];

        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;

        var key, val;
        if (pos === -1) {
            key = options.decoder(part, defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), defaults.decoder, charset, 'key');
            val = utils.maybeMap(
                parseArrayValue(part.slice(pos + 1), options),
                function (encodedVal) {
                    return options.decoder(encodedVal, defaults.decoder, charset, 'value');
                }
            );
        }

        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
            val = interpretNumericEntities(val);
        }

        if (part.indexOf('[]=') > -1) {
            val = isArray(val) ? [val] : val;
        }

        if (has.call(obj, key)) {
            obj[key] = utils.combine(obj[key], val);
        } else {
            obj[key] = val;
        }
    }

    return obj;
};

var parseObject = function (chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : parseArrayValue(val, options);

    for (var i = chain.length - 1; i >= 0; --i) {
        var obj;
        var root = chain[i];

        if (root === '[]' && options.parseArrays) {
            obj = [].concat(leaf);
        } else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var index = parseInt(cleanRoot, 10);
            if (!options.parseArrays && cleanRoot === '') {
                obj = { 0: leaf };
            } else if (
                !isNaN(index)
                && root !== cleanRoot
                && String(index) === cleanRoot
                && index >= 0
                && (options.parseArrays && index <= options.arrayLimit)
            ) {
                obj = [];
                obj[index] = leaf;
            } else if (cleanRoot !== '__proto__') {
                obj[cleanRoot] = leaf;
            }
        }

        leaf = obj;
    }

    return leaf;
};

var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) {
        return;
    }

    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;

    // The regex chunks

    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;

    // Get the parent

    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;

    // Stash the parent if it exists

    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        keys.push(parent);
    }

    // Loop through children appending to the array until we hit depth

    var i = 0;
    while (options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth) {
        i += 1;
        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) {
                return;
            }
        }
        keys.push(segment[1]);
    }

    // If there's a remainder, just add whatever is left

    if (segment) {
        keys.push('[' + key.slice(segment.index) + ']');
    }

    return parseObject(keys, val, options, valuesParsed);
};

var normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (opts.decoder !== null && opts.decoder !== undefined && typeof opts.decoder !== 'function') {
        throw new TypeError('Decoder has to be a function.');
    }

    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }
    var charset = typeof opts.charset === 'undefined' ? defaults.charset : opts.charset;

    return {
        allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : defaults.comma,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: (typeof opts.depth === 'number' || opts.depth === false) ? +opts.depth : defaults.depth,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : defaults.plainObjects,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

var parse$1 = function (str, opts) {
    var options = normalizeParseOptions(opts);

    if (str === '' || str === null || typeof str === 'undefined') {
        return options.plainObjects ? Object.create(null) : {};
    }

    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = utils.merge(obj, newObj, options);
    }

    if (options.allowSparse === true) {
        return obj;
    }

    return utils.compact(obj);
};

var stringify = stringify_1;
var parse = parse$1;
var formats = formats$3;

var lib = {
    formats: formats,
    parse: parse,
    stringify: stringify
};

var qs = /*@__PURE__*/getDefaultExportFromCjs(lib);

var getCamList = function (email, userToken, tokenType, keyword, startIndex, endIndex) {
    return jwtAxiosInst.get("/DashCam/DeviceList?email=".concat(email, "&userToken=").concat(userToken, "&keyword=").concat(keyword !== null && keyword !== void 0 ? keyword : "", "&startIndex=").concat(startIndex !== null && startIndex !== void 0 ? startIndex : "", "&endIndex=").concat(endIndex !== null && endIndex !== void 0 ? endIndex : "", "&tokenType=").concat(tokenType));
};
// export const checkCamReg = (
//   email: string,
//   userToken: string,
//   tokenType: string
// ) => {
//   return axiosInst.get(
//     `${API_SERVER_URI}/BCS/chkCamReg.php?email=${email}&user_token=${userToken}&tokenType=${tokenType}`
//   );
// };
var getCamInfo = function (email, userToken, psn, tokenType) {
    return jwtAxiosInst.get("/BCS/deviceInfo.php?email=".concat(email, "&user_token=").concat(userToken, "&psn=").concat(psn, "&token_type=").concat(tokenType));
};
var addCamera = function (email, userToken, payload, tokenType) {
    var data = qs.stringify(__assign(__assign({ email: email, user_token: userToken, tokenType: tokenType }, payload), { share_leu_bigdata: payload.agree_eventmap }));
    return jwtAxiosInst.post("/BCS/deviceRegister.php", data, {
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
    });
};
// 이제 사용하지 않는 api (Leehj)
// export const renameCamera = (
//   email: string,
//   userToken: string,
//   psn: string,
//   devName: string
// ) => {
//   return jwtAxiosInst.get(
//     `/BCS/deviceChangeName.php?email=${email}&user_token=${userToken}&psn=${psn}&dev_name=${encodeURIComponent(
//       devName
//     )}&token_type=web`
//   );
// };
// mantis - 11277, 31.4 API로 변경(Leehj)
var renameCamera = function (email, psn, devName, regCategory) {
    return jwtAxiosInst.put("/DashCam/DeviceList", {
        email: email,
        psn: psn,
        dev_name: devName,
        regCategory: regCategory,
    });
};
var deleteCamera = function (email, userToken, psn) {
    return jwtAxiosInst.get("/BCS/deviceDelete.php?email=".concat(email, "&user_token=").concat(userToken, "&psn=").concat(psn, "&token_type=web"));
};
var updatePrivacy = function (email, userToken, psn, agree_gps, share_gps, share_audio, share_video, share_dev_name, share_leu_bigdata) {
    return jwtAxiosInst.get("/BCS/openGpsSet.php?email=".concat(email, "&user_token=").concat(userToken, "&psn=").concat(psn, "&share_video=").concat(share_video, "&share_audio=").concat(share_audio, "&share_dev_name=").concat(share_dev_name, "&share_gps=").concat(share_gps, "&agree_gps=").concat(agree_gps, "&share_leu_bigdata=").concat(share_leu_bigdata, "&tokenType=web"));
};
var getFotaStatus = function (email, userToken, psn) {
    return jwtAxiosInst.get("/BCS/fotaAstatusGet.php?email=".concat(email, "&user_token=").concat(userToken, "&token_type=web").concat(psn ? "&psn=".concat(psn) : ""));
};
var getNotification = function (email, userToken, psn, tokenType) {
    return axiosInst.get("/DashCam/GetNotificationSettings?email=".concat(email, "&user_token=").concat(userToken, "&psn=").concat(psn, "&tokenType=").concat(tokenType));
};
var updateNotification = function (email, userToken, psn, setType, settings, send, tokenType) {
    return axiosInst.post("/DashCam/SetNotificationSettings", __assign(__assign({ email: email, user_token: userToken, psn: psn, tokenType: tokenType, setType: setType }, (setType === "email"
        ? { emailSettings: settings }
        : { phoneSettings: settings })), (setType === "email"
        ? {
            emailSend: send,
        }
        : { phoneSend: send })));
};
var getLiveEventSettings = function (email, userToken, psn) {
    return axiosInst.get("/DashCam/GetLiveEventUploadSettings?email=".concat(email, "&userToken=").concat(userToken, "&psn=").concat(psn, "&tokenType=web"));
};
var updateCNLiveEventSettings = function (email, psn, settings) {
    return jwtAxiosInst.post("/IoT/liveEventUploadSet", {
        email: email,
        psn: psn,
        settings: settings,
    });
};
var updateLiveEventSettings = function (email, userToken, psn, setting) {
    return axiosInst.put("/DashCam/SetLiveEventUploadSettings", {
        email: email,
        userToken: userToken,
        tokenType: "web",
        psn: psn,
        setting: setting,
    });
};
var getFwInfos = function () {
    return axiosInst.get("".concat(FIRMWARE_INFO_URI));
};
var getFirmwareSettings = function (email, user_token, psn, tokenType) {
    return axiosInst.get("/CloudSetting/GetCloudHTTPFirmwareSetting?email=".concat(email, "&user_token=").concat(user_token, "&psn=").concat(psn, "&tokenType=").concat(tokenType));
};
var updateCNFirmwareSettings = function (firmware) {
    return jwtAxiosInst.post("/IoT/transferCS", __assign({ tokenType: "web" }, firmware));
};
var updateFirmwareSettings = function (firmware, user_token) {
    return axiosInst.put("/CloudSetting/UpdateCloudHTTPFirmwareSetting", __assign({ user_token: user_token, tokenType: "web" }, firmware));
};
var getNotificationEmail = function (email, user_token, psn, tokenType) {
    return axiosInst.get("/DashCam/GetNotificationEmail?email=".concat(email, "&user_token=").concat(user_token, "&psn=").concat(psn, "&tokenType=").concat(tokenType));
};
var inviteEmail = function (email, user_token, psn, guestEmail, companyID, tokenType) {
    return axiosInst.post("/DashCam/PostNotificationEmail", {
        email: email,
        user_token: user_token,
        tokenType: tokenType,
        psn: psn,
        guestEmail: guestEmail,
        companyID: companyID,
    });
};
var FixMasterEmailNotification = function (email, user_token, psn, guestEmail, mailStatus, tokenType) {
    return axiosInst.put("/DashCam/PutNotificationEmail", {
        email: email,
        user_token: user_token,
        tokenType: tokenType,
        psn: psn,
        guestEmail: guestEmail,
        mailStatus: mailStatus,
    });
};
var deleteEmail = function (email, user_token, psn, guestEmail, tokenType) {
    return axiosInst.delete("/DashCam/DeleteNotificationEmail", {
        data: {
            email: email,
            user_token: user_token,
            tokenType: tokenType,
            psn: psn,
            guestEmail: guestEmail,
        },
    });
};
var getFotaID = function (email, user_token, payload) {
    var data = qs.stringify(__assign(__assign({ email: email, user_token: user_token, token_type: "web" }, payload), { fota_url: encodeURIComponent(Buffer.from(payload.fota_url).toString("base64")), file_size: payload.file_size.toString() }));
    return jwtAxiosInst.post("/BCS/fotaAidGet.php", data);
};
var getCNFotaStart = function (email, user_token, fotaid, payload) {
    return jwtAxiosInst.post("/IoT/devicecommand", {
        email: email,
        user_token: user_token,
        psn: payload.psn,
        tokenType: "web",
        command: "FotaStart",
        fw_model: payload.fw_model,
        fw_version: payload.now_fw_version,
        fota_url: encodeURIComponent(Buffer.from(payload.fota_url).toString("base64")),
        file_size: payload.file_size,
        fota_lang: payload.lang,
        checksum: payload.checksum,
        fotaid: fotaid,
    });
};
var getFotaStart = function (email, user_token, lb_server_name, lb_http_port, fotaid, payload) {
    var url = getLbURI(lb_server_name, lb_http_port);
    var params = new URLSearchParams();
    params.append("email", email);
    params.append("user_token", user_token);
    params.append("tokenType", "web");
    params.append("psn", payload.psn);
    params.append("fw_model", payload.fw_model);
    params.append("fw_version", payload.now_fw_version);
    params.append("fota_url", Buffer.from(payload.fota_url).toString("base64"));
    params.append("file_size", payload.file_size.toString());
    params.append("fota_lang", payload.lang);
    params.append("checksum", payload.checksum);
    return axiosInst.get("".concat(url, "/proc/fota_start?").concat(params.toString(), "&fotaid=").concat(fotaid));
};
var rebootCNCamera = function (email, user_token, psn) {
    return jwtAxiosInst.post("/IoT/devicecommand", {
        email: email,
        user_token: user_token,
        psn: psn,
        tokenType: "web",
        command: "RebootDevice",
    });
};
var rebootCamera = function (lb_server_name, lb_http_port, email, user_token, psn) {
    return axiosInst.get("https://".concat(lb_server_name, ":").concat(lb_http_port, "/proc/device_reboot?email=").concat(email, "&psn=").concat(psn, "&user_token=").concat(user_token, "&tokenType=web"));
};
var updateLiveviewUsage = function (email, user_token, psn, usage, tokenType) {
    return axiosInst.post("/Account/PostUserInfo", {
        email: email,
        user_token: user_token,
        psn: psn,
        usage: usage,
        tokenType: tokenType,
        div: 1,
    });
};
var loadPrivacy = function (email, psn, user_token) {
    return jwtAxiosInst.get("/BCS/openGpsGet.php?email=".concat(email, "&user_token=").concat(user_token, "&psn=").concat(psn, "&tokenType=web"));
};
var setShareingEventamp = function (email, user_token, sharedEventMap) {
    return axiosInst.post("/BigData/SetFirstSharedEventMap", {
        email: email,
        userToken: user_token,
        tokenType: "web",
        sharedEventMap: sharedEventMap,
    });
};

var getLatestEvents = function (email, userToken, psn) {
    var now = moment();
    return axiosInst.post("/DashCam/AlarmLatestEvents", {
        email: email,
        user_token: userToken,
        tokenType: "web",
        psn: psn,
        msg_code: ["ALARM_EVENT", "ALARM_PARK_EVENT"],
        limit: "5",
        startDate: moment(now).startOf("d").utc(true).unix().toString(),
        endDate: moment(now).endOf("d").utc(true).unix().toString(),
    });
};
var getEvents = function (email, userToken, psn, msg_code, startDate, endDate) {
    return axiosInst.post("/DashCam/AlarmLatestEvents", {
        email: email,
        user_token: userToken,
        tokenType: "web",
        psn: psn,
        msg_code: msg_code,
        startDate: startDate,
        endDate: endDate,
    });
};

var getGeofences = function (email, userToken, tokenType) {
    return jwtAxiosInst.post("/geofence/getFenceList.php", {
        email: email,
        user_token: userToken,
        tokenType: tokenType,
    });
};
var addGeofence = function (server, port, email, userToken, body) {
    return jwtAxiosInst.post("/geofence/updateGeoFence.php", __assign({ email: email, user_token: userToken, tokenType: "web" }, body));
};
var deleteGeofence = function (server, port, email, userToken, fenceId, fenceName) {
    return jwtAxiosInst.post("/geofence/deleteGeoFence.php", {
        email: email,
        user_token: userToken,
        tokenType: "web",
        fenceId: fenceId,
        fenceName: fenceName,
    });
};

var getMyCameraLocations = function (gpsServer, gpsPort, email, userToken, tokenType, cancel, bounds) {
    var url = "https://".concat(gpsServer, ":").concat(gpsPort, "/BCS/gps_zone.php?email=").concat(email, "&user_token=").concat(userToken, "&tokenType=").concat(tokenType);
    if (bounds) {
        url += "&sw=".concat(bounds.south, "_").concat(bounds.west, "5&ne=").concat(bounds.north, "_").concat(bounds.east);
    }
    return fetch(url, { signal: cancel.signal });
};
var getPublicCameraLocations = function (gpsServer, gpsPort, bounds, cancel) {
    return fetch("https://".concat(gpsServer, ":").concat(gpsPort, "/BCS/free_gps_zone.php?sw=").concat(bounds.south, "_").concat(bounds.west, "5&ne=").concat(bounds.north, "_").concat(bounds.east), { signal: cancel.signal });
};
var getPublicCameraLocation = function (gpsServer, gpsPort, email, psn, userToken, tokenType, cancel) {
    return fetch("https://".concat(gpsServer, ":").concat(gpsPort, "/BCS/gps_zone.php?email=").concat(email, "&user_token=").concat(userToken, "&psn=").concat(psn, "&tokenType=").concat(tokenType), { signal: cancel.signal });
};
var getFreeCamLocation = function (lb_server_name, lb_http_port, email, psn, userToken, tokenType, cancel) {
    return fetch("https://".concat(lb_server_name, ":").concat(lb_http_port, "/proc/gps_data?email=").concat(email, "&user_token=").concat(userToken, "&psn=").concat(psn, "&interval=5&tokenType=").concat(tokenType), { signal: cancel.signal });
};
var getMultiCamLocations = function (gpsServer, gpsPort, email, psns, userToken, cancel) {
    return fetch("https://".concat(gpsServer, ":").concat(gpsPort, "/BCS/gps_psns.php"), {
        method: "POST",
        body: JSON.stringify({
            email: email,
            user_token: userToken,
            tokenType: "web",
            psns: psns,
        }),
        signal: cancel.signal,
    });
};
var getGPSDriveData = function (email, userToken, psn) {
    return jwtAxiosInst.get("/BCS/getDriveData.php?email=".concat(email, "&user_token=").concat(userToken, "&psn=").concat(psn, "&token_type=web"));
};
var getGPSTrackingData = function (email, userToken, jwt, psn, drive_no_list, cancel, bounds) {
    var sw = bounds ? "".concat(bounds.west, "_").concat(bounds.south) : undefined;
    var ne = bounds ? "".concat(bounds.east, "_").concat(bounds.north) : undefined;
    var params = new URLSearchParams();
    params.append("email", email);
    params.append("user_token", userToken);
    params.append("psn", psn);
    params.append("token_type", "web");
    if (sw) {
        params.append("sw", sw);
    }
    if (ne) {
        params.append("ne", ne);
    }
    params.append("drive_no_list", _.join(drive_no_list, ","));
    return fetch("".concat(API_GATEWAY_URI, "/BCS/getTrackData.php"), {
        method: "POST",
        headers: {
            Authorization: "Bearer ".concat(jwt),
            "Content-Type": "application/x-www-form-urlencoded",
        },
        signal: cancel === null || cancel === void 0 ? void 0 : cancel.signal,
        body: params.toString(),
    });
};
var getGeofenceAlerts = function (email, userToken, psn, drive_no_list) {
    var params = new URLSearchParams();
    params.append("email", email);
    params.append("user_token", userToken);
    params.append("psn", psn);
    params.append("token_type", "web");
    params.append("drive_no_list", _.join(drive_no_list, ","));
    return jwtAxiosInst.post("/BCS/getFenceLogData.php", params.toString(), {
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
    });
};

var addGroup = function (email, user_token, groupData) {
    return axiosInst.post("/Account/UserGroupAdd", {
        groupNameList: [groupData.groupNameList],
        email: email,
        user_token: user_token,
        tokenType: "web",
    });
};
var getGroupsList = function (email, user_token, tokenType) {
    return axiosInst.get("/DashCam/GetAllocationDashCamList?Email=".concat(email, "&UserToken=").concat(user_token, "&TokenType=").concat(tokenType));
};
var getGroupsListPaging = function (email, user_token, paging) {
    var _a, _b, _c, _d;
    return axiosInst.get("/DashCam/GetGroupList?email=".concat(email, "&userToken=").concat(user_token, "&keyword=").concat((_a = paging === null || paging === void 0 ? void 0 : paging.searchKey) !== null && _a !== void 0 ? _a : "", "&startIndex=").concat((_b = paging === null || paging === void 0 ? void 0 : paging.startIndex) !== null && _b !== void 0 ? _b : "", "&endIndex=").concat((_c = paging === null || paging === void 0 ? void 0 : paging.endIndex) !== null && _c !== void 0 ? _c : "", "&ordering=").concat((_d = paging === null || paging === void 0 ? void 0 : paging.ordering) !== null && _d !== void 0 ? _d : "0", "&tokenType=web"));
};
var changeGroupName = function (email, user_token, groupRenameList) {
    return axiosInst.post("/Account/UserGroupRename", {
        email: email,
        user_token: user_token,
        tokenType: "web",
        groupRenameList: [groupRenameList],
    });
};
var deleteGroup = function (email, user_token, groups) {
    return axiosInst.post("/Account/UserGroupDelete", {
        email: email,
        user_token: user_token,
        groupDeleteIDList: groups,
        tokenType: "web",
    });
};
var addCam = function (email, user_token, add) {
    return axiosInst.put("/DashCam/PushMasterGroup\n  ", {
        Email: email,
        UserToken: user_token,
        Add: add,
        TokenType: "web",
    });
};
var getUserList = function (email, user_token) {
    return axiosInst.get("/DashCam/GetAllocationUserList?Email=".concat(email, "&UserToken=").concat(user_token, "&TokenType=web"));
};
var deleteCam = function (email, user_token, del) {
    return axiosInst.delete("/DashCam/PopMasterGroup", {
        data: {
            Email: email,
            UserToken: user_token,
            Del: del,
            TokenType: "web",
        },
    });
};
var addUserFromCam = function (email, user_token, addUser) {
    return axiosInst.put("/DashCam/AllocateUser\n  ", {
        Email: email,
        UserToken: user_token,
        GroupID: addUser.GroupID,
        PSN: addUser.PSN,
        UserEmail: addUser.UserEmail,
        TokenType: "web",
    });
};
var deleteUser = function (email, user_token, delUser) {
    return axiosInst.delete("/DashCam/DeallocateUser", {
        data: {
            Email: email,
            UserToken: user_token,
            GroupID: delUser.GroupID,
            PSN: delUser.PSN,
            UserEmail: delUser.UserEmail,
            TokenType: "web",
        },
    });
};
var addAdmin = function (email, user_token, addAdmin) {
    return axiosInst.post("/Account/AssignSubMasterToGroup\n  ", {
        email: email,
        user_Token: user_token,
        guestEmail: addAdmin.guestEmail,
        groupManagementID: addAdmin.groupManagementID,
        tokenType: "web",
    });
};
var deleteAdmin = function (email, user_token, delAdmin) {
    return axiosInst.delete("/Account/DecoupleSubMasterFromGroup", {
        data: {
            email: email,
            user_token: user_token,
            guestEmail: delAdmin.guestEmail,
            groupManagementID: delAdmin.groupManagementID,
            tokenType: "web",
        },
    });
};

var inviteMember = function (member) {
    return axiosInst.post("/Account/InviteMember", __assign(__assign({}, member), { tokenType: "web" }));
};
var getMemberList = function (email, user_token, tokenType, paging) {
    var _a, _b, _c, _d;
    return axiosInst.get("/Account/UserInviteMemberInfo?email=".concat(email, "&user_token=").concat(user_token, "&searchKey=").concat((_a = paging === null || paging === void 0 ? void 0 : paging.searchKey) !== null && _a !== void 0 ? _a : "", "&startIndex=").concat((_b = paging === null || paging === void 0 ? void 0 : paging.startIndex) !== null && _b !== void 0 ? _b : "", "&endIndex=").concat((_c = paging === null || paging === void 0 ? void 0 : paging.endIndex) !== null && _c !== void 0 ? _c : "", "&ordering=").concat((_d = paging === null || paging === void 0 ? void 0 : paging.ordering) !== null && _d !== void 0 ? _d : "0", "&tokenType=").concat(tokenType));
};
var removeMember = function (deleteEmail, deleteEmailUserType, email, user_token) {
    return axiosInst.post("/Account/UserInviteMemberDelete", {
        deleteEmail: deleteEmail,
        deleteEmailUserType: deleteEmailUserType,
        email: email,
        user_token: user_token,
        tokenType: "web",
    });
};
var getUserRole = function (email, userToken) {
    return axiosInst.get("/Account/UserRole?email?=".concat(email, "&user_token=").concat(userToken, "&tokenType=web"));
};

var getSubscription = function (email, userToken, tokenType) {
    return axiosInst.get("/Payment/GetSubscrInfo?email=".concat(email, "&user_token=").concat(userToken, "&tokenType=").concat(tokenType));
};
var getWebSubscription = function (email, user_token, tokenType) {
    return axiosInst.get("/Payment/GetInWebSubscrCustomer?email=".concat(email, "&user_token=").concat(user_token, "&tokenType=").concat(tokenType, "&ostype=").concat(STRIPE_OS_TYPE));
};
var getTransactionHistory = function (email, user_token, tokenType) {
    return axiosInst.get("/Payment/GetInWebSubscrTransactions?email=".concat(email, "&user_token=").concat(user_token, "&tokenType=").concat(tokenType, "&ostype=").concat(STRIPE_OS_TYPE));
};
var getFreetrialState = function (email, user_token) {
    return axiosInst.get("/Payment/GetCheckSubscrTrial?email=".concat(email, "&user_token=").concat(user_token, "&tokenType=web"));
};
var requestCancelSubscription = function (email, user_token, ostype, reason) {
    return axiosInst.post("/Payment/WebSubscribeCancelUpdate", {
        email: email,
        user_token: user_token,
        ostype: ostype,
        reason: reason,
        tokenType: "web",
    });
};
// export const doWebSubscribe = (
//   email: string,
//   user_token: string,
//   body: Payment
// ) => {
//   return axiosInst.post(`//Payment/WebSubscribe`, {
//     email,
//     user_token,
//     ...body,
//     osType: STRIPE_OS_TYPE,
//   });
// };

var uaParser = {exports: {}};

/*!@license
 * UAParser.js v0.7.28
 * Lightweight JavaScript-based User-Agent string parser
 * https://github.com/faisalman/ua-parser-js
 *
 * Copyright © 2012-2021 Faisal Salman <f@faisalman.com>
 * Licensed under MIT License
 */

(function (module, exports) {
	(function (window, undefined$1) {

	    //////////////
	    // Constants
	    /////////////


	    var LIBVERSION  = '0.7.28',
	        EMPTY       = '',
	        UNKNOWN     = '?',
	        FUNC_TYPE   = 'function',
	        UNDEF_TYPE  = 'undefined',
	        OBJ_TYPE    = 'object',
	        STR_TYPE    = 'string',
	        MAJOR       = 'major', // deprecated
	        MODEL       = 'model',
	        NAME        = 'name',
	        TYPE        = 'type',
	        VENDOR      = 'vendor',
	        VERSION     = 'version',
	        ARCHITECTURE= 'architecture',
	        CONSOLE     = 'console',
	        MOBILE      = 'mobile',
	        TABLET      = 'tablet',
	        SMARTTV     = 'smarttv',
	        WEARABLE    = 'wearable',
	        EMBEDDED    = 'embedded',
	        UA_MAX_LENGTH = 255;


	    ///////////
	    // Helper
	    //////////


	    var util = {
	        extend : function (regexes, extensions) {
	            var mergedRegexes = {};
	            for (var i in regexes) {
	                if (extensions[i] && extensions[i].length % 2 === 0) {
	                    mergedRegexes[i] = extensions[i].concat(regexes[i]);
	                } else {
	                    mergedRegexes[i] = regexes[i];
	                }
	            }
	            return mergedRegexes;
	        },
	        has : function (str1, str2) {
	            return typeof str1 === STR_TYPE ? str2.toLowerCase().indexOf(str1.toLowerCase()) !== -1 : false;
	        },
	        lowerize : function (str) {
	            return str.toLowerCase();
	        },
	        major : function (version) {
	            return typeof(version) === STR_TYPE ? version.replace(/[^\d\.]/g,'').split(".")[0] : undefined$1;
	        },
	        trim : function (str, len) {
	            str = str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
	            return typeof(len) === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
	        }
	    };


	    ///////////////
	    // Map helper
	    //////////////


	    var mapper = {

	        rgx : function (ua, arrays) {

	            var i = 0, j, k, p, q, matches, match;

	            // loop through all regexes maps
	            while (i < arrays.length && !matches) {

	                var regex = arrays[i],       // even sequence (0,2,4,..)
	                    props = arrays[i + 1];   // odd sequence (1,3,5,..)
	                j = k = 0;

	                // try matching uastring with regexes
	                while (j < regex.length && !matches) {

	                    matches = regex[j++].exec(ua);

	                    if (!!matches) {
	                        for (p = 0; p < props.length; p++) {
	                            match = matches[++k];
	                            q = props[p];
	                            // check if given property is actually array
	                            if (typeof q === OBJ_TYPE && q.length > 0) {
	                                if (q.length == 2) {
	                                    if (typeof q[1] == FUNC_TYPE) {
	                                        // assign modified match
	                                        this[q[0]] = q[1].call(this, match);
	                                    } else {
	                                        // assign given value, ignore regex match
	                                        this[q[0]] = q[1];
	                                    }
	                                } else if (q.length == 3) {
	                                    // check whether function or regex
	                                    if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) {
	                                        // call function (usually string mapper)
	                                        this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined$1;
	                                    } else {
	                                        // sanitize match using given regex
	                                        this[q[0]] = match ? match.replace(q[1], q[2]) : undefined$1;
	                                    }
	                                } else if (q.length == 4) {
	                                        this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined$1;
	                                }
	                            } else {
	                                this[q] = match ? match : undefined$1;
	                            }
	                        }
	                    }
	                }
	                i += 2;
	            }
	        },

	        str : function (str, map) {

	            for (var i in map) {
	                // check if array
	                if (typeof map[i] === OBJ_TYPE && map[i].length > 0) {
	                    for (var j = 0; j < map[i].length; j++) {
	                        if (util.has(map[i][j], str)) {
	                            return (i === UNKNOWN) ? undefined$1 : i;
	                        }
	                    }
	                } else if (util.has(map[i], str)) {
	                    return (i === UNKNOWN) ? undefined$1 : i;
	                }
	            }
	            return str;
	        }
	    };


	    ///////////////
	    // String map
	    //////////////


	    var maps = {

	        browser : {
	            // Safari < 3.0
	            oldSafari : {
	                version : {
	                    '1.0'   : '/8',
	                    '1.2'   : '/1',
	                    '1.3'   : '/3',
	                    '2.0'   : '/412',
	                    '2.0.2' : '/416',
	                    '2.0.3' : '/417',
	                    '2.0.4' : '/419',
	                    '?'     : '/'
	                }
	            },
	            oldEdge : {
	                version : {
	                    '0.1'   : '12.',
	                    '21'    : '13.',
	                    '31'    : '14.',
	                    '39'    : '15.',
	                    '41'    : '16.',
	                    '42'    : '17.',
	                    '44'    : '18.'
	                }
	            }
	        },

	        os : {
	            windows : {
	                version : {
	                    'ME'        : '4.90',
	                    'NT 3.11'   : 'NT3.51',
	                    'NT 4.0'    : 'NT4.0',
	                    '2000'      : 'NT 5.0',
	                    'XP'        : ['NT 5.1', 'NT 5.2'],
	                    'Vista'     : 'NT 6.0',
	                    '7'         : 'NT 6.1',
	                    '8'         : 'NT 6.2',
	                    '8.1'       : 'NT 6.3',
	                    '10'        : ['NT 6.4', 'NT 10.0'],
	                    'RT'        : 'ARM'
	                }
	            }
	        }
	    };


	    //////////////
	    // Regex map
	    /////////////


	    var regexes = {

	        browser : [[

	            /\b(?:crmo|crios)\/([\w\.]+)/i                                      // Chrome for Android/iOS
	            ], [VERSION, [NAME, 'Chrome']], [
	            /edg(?:e|ios|a)?\/([\w\.]+)/i                                       // Microsoft Edge
	            ], [VERSION, [NAME, 'Edge']], [
	            // breaking change (reserved for next major release):
	            ///edge\/([\w\.]+)/i                                                  // Old Edge (Trident)
	            //], [[VERSION, mapper.str, maps.browser.oldEdge.version], [NAME, 'Edge']], [

	            // Presto based
	            /(opera\smini)\/([\w\.-]+)/i,                                       // Opera Mini
	            /(opera\s[mobiletab]{3,6})\b.+version\/([\w\.-]+)/i,                // Opera Mobi/Tablet
	            /(opera)(?:.+version\/|[\/\s]+)([\w\.]+)/i,                         // Opera
	            ], [NAME, VERSION], [
	            /opios[\/\s]+([\w\.]+)/i                                            // Opera mini on iphone >= 8.0
	            ], [VERSION, [NAME, 'Opera Mini']], [
	            /\sopr\/([\w\.]+)/i                                                 // Opera Webkit
	            ], [VERSION, [NAME, 'Opera']], [

	            // Mixed
	            /(kindle)\/([\w\.]+)/i,                                             // Kindle
	            /(lunascape|maxthon|netfront|jasmine|blazer)[\/\s]?([\w\.]*)/i,     // Lunascape/Maxthon/Netfront/Jasmine/Blazer
	            // Trident based
	            /(avant\s|iemobile|slim)(?:browser)?[\/\s]?([\w\.]*)/i,             // Avant/IEMobile/SlimBrowser
	            /(ba?idubrowser)[\/\s]?([\w\.]+)/i,                                 // Baidu Browser
	            /(?:ms|\()(ie)\s([\w\.]+)/i,                                        // Internet Explorer

	            // Webkit/KHTML based
	            /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon)\/([\w\.-]+)/i,
	                                                                                // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
	            /(rekonq|puffin|brave|whale|qqbrowserlite|qq)\/([\w\.]+)/i,         // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ, aka ShouQ
	            /(weibo)__([\d\.]+)/i                                               // Weibo
	            ], [NAME, VERSION], [
	            /(?:[\s\/]uc?\s?browser|(?:juc.+)ucweb)[\/\s]?([\w\.]+)/i           // UCBrowser
	            ], [VERSION, [NAME, 'UCBrowser']], [
	            /(?:windowswechat)?\sqbcore\/([\w\.]+)\b.*(?:windowswechat)?/i      // WeChat Desktop for Windows Built-in Browser
	            ], [VERSION, [NAME, 'WeChat(Win) Desktop']], [
	            /micromessenger\/([\w\.]+)/i                                        // WeChat
	            ], [VERSION, [NAME, 'WeChat']], [
	            /konqueror\/([\w\.]+)/i                                             // Konqueror
	            ], [VERSION, [NAME, 'Konqueror']], [
	            /trident.+rv[:\s]([\w\.]{1,9})\b.+like\sgecko/i                     // IE11
	            ], [VERSION, [NAME, 'IE']], [
	            /yabrowser\/([\w\.]+)/i                                             // Yandex
	            ], [VERSION, [NAME, 'Yandex']], [
	            /(avast|avg)\/([\w\.]+)/i                                           // Avast/AVG Secure Browser
	            ], [[NAME, /(.+)/, '$1 Secure Browser'], VERSION], [
	            /focus\/([\w\.]+)/i                                                 // Firefox Focus
	            ], [VERSION, [NAME, 'Firefox Focus']], [
	            /opt\/([\w\.]+)/i                                                   // Opera Touch
	            ], [VERSION, [NAME, 'Opera Touch']], [
	            /coc_coc_browser\/([\w\.]+)/i                                       // Coc Coc Browser
	            ], [VERSION, [NAME, 'Coc Coc']], [
	            /dolfin\/([\w\.]+)/i                                                // Dolphin
	            ], [VERSION, [NAME, 'Dolphin']], [
	            /coast\/([\w\.]+)/i                                                 // Opera Coast
	            ], [VERSION, [NAME, 'Opera Coast']],
	            [/xiaomi\/miuibrowser\/([\w\.]+)/i                                  // MIUI Browser
	            ], [VERSION, [NAME, 'MIUI Browser']], [
	            /fxios\/([\w\.-]+)/i                                                // Firefox for iOS
	            ], [VERSION, [NAME, 'Firefox']], [
	            /(qihu|qhbrowser|qihoobrowser|360browser)/i                         // 360
	            ], [[NAME, '360 Browser']], [
	            /(oculus|samsung|sailfish)browser\/([\w\.]+)/i
	            ], [[NAME, /(.+)/, '$1 Browser'], VERSION], [                       // Oculus/Samsung/Sailfish Browser
	            /(comodo_dragon)\/([\w\.]+)/i                                       // Comodo Dragon
	            ], [[NAME, /_/g, ' '], VERSION], [
	            /\s(electron)\/([\w\.]+)\ssafari/i,                                 // Electron-based App
	            /(tesla)(?:\sqtcarbrowser|\/(20[12]\d\.[\w\.-]+))/i,                // Tesla
	            /m?(qqbrowser|baiduboxapp|2345Explorer)[\/\s]?([\w\.]+)/i           // QQBrowser/Baidu App/2345 Browser
	            ], [NAME, VERSION], [
	            /(MetaSr)[\/\s]?([\w\.]+)/i,                                        // SouGouBrowser
	            /(LBBROWSER)/i                                                      // LieBao Browser
	            ], [NAME], [

	            // WebView
	            /;fbav\/([\w\.]+);/i                                                // Facebook App for iOS & Android with version
	            ], [VERSION, [NAME, 'Facebook']], [
	            /FBAN\/FBIOS|FB_IAB\/FB4A/i                                         // Facebook App for iOS & Android without version
	            ], [[NAME, 'Facebook']], [
	            /safari\s(line)\/([\w\.]+)/i,                                       // Line App for iOS
	            /\b(line)\/([\w\.]+)\/iab/i,                                        // Line App for Android
	            /(chromium|instagram)[\/\s]([\w\.-]+)/i                             // Chromium/Instagram
	            ], [NAME, VERSION], [
	            /\bgsa\/([\w\.]+)\s.*safari\//i                                     // Google Search Appliance on iOS
	            ], [VERSION, [NAME, 'GSA']], [

	            /headlesschrome(?:\/([\w\.]+)|\s)/i                                 // Chrome Headless
	            ], [VERSION, [NAME, 'Chrome Headless']], [

	            /\swv\).+(chrome)\/([\w\.]+)/i                                      // Chrome WebView
	            ], [[NAME, 'Chrome WebView'], VERSION], [

	            /droid.+\sversion\/([\w\.]+)\b.+(?:mobile\ssafari|safari)/i         // Android Browser
	            ], [VERSION, [NAME, 'Android Browser']], [

	            /(chrome|omniweb|arora|[tizenoka]{5}\s?browser)\/v?([\w\.]+)/i      // Chrome/OmniWeb/Arora/Tizen/Nokia
	            ], [NAME, VERSION], [

	            /version\/([\w\.]+)\s.*mobile\/\w+\s(safari)/i                      // Mobile Safari
	            ], [VERSION, [NAME, 'Mobile Safari']], [
	            /version\/([\w\.]+)\s.*(mobile\s?safari|safari)/i                   // Safari & Safari Mobile
	            ], [VERSION, NAME], [
	            /webkit.+?(mobile\s?safari|safari)(\/[\w\.]+)/i                     // Safari < 3.0
	            ], [NAME, [VERSION, mapper.str, maps.browser.oldSafari.version]], [

	            /(webkit|khtml)\/([\w\.]+)/i
	            ], [NAME, VERSION], [

	            // Gecko based
	            /(navigator|netscape)\/([\w\.-]+)/i                                 // Netscape
	            ], [[NAME, 'Netscape'], VERSION], [
	            /ile\svr;\srv:([\w\.]+)\).+firefox/i                                // Firefox Reality
	            ], [VERSION, [NAME, 'Firefox Reality']], [
	            /ekiohf.+(flow)\/([\w\.]+)/i,                                       // Flow
	            /(swiftfox)/i,                                                      // Swiftfox
	            /(icedragon|iceweasel|camino|chimera|fennec|maemo\sbrowser|minimo|conkeror)[\/\s]?([\w\.\+]+)/i,
	                                                                                // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror
	            /(firefox|seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([\w\.-]+)$/i,
	                                                                                // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
	            /(firefox)\/([\w\.]+)\s[\w\s\-]+\/[\w\.]+$/i,                       // Other Firefox-based
	            /(mozilla)\/([\w\.]+)\s.+rv\:.+gecko\/\d+/i,                        // Mozilla

	            // Other
	            /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir)[\/\s]?([\w\.]+)/i,
	                                                                                // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir
	            /(links)\s\(([\w\.]+)/i,                                            // Links
	            /(gobrowser)\/?([\w\.]*)/i,                                         // GoBrowser
	            /(ice\s?browser)\/v?([\w\._]+)/i,                                   // ICE Browser
	            /(mosaic)[\/\s]([\w\.]+)/i                                          // Mosaic
	            ], [NAME, VERSION]
	        ],

	        cpu : [[

	            /(?:(amd|x(?:(?:86|64)[_-])?|wow|win)64)[;\)]/i                     // AMD64 (x64)
	            ], [[ARCHITECTURE, 'amd64']], [

	            /(ia32(?=;))/i                                                      // IA32 (quicktime)
	            ], [[ARCHITECTURE, util.lowerize]], [

	            /((?:i[346]|x)86)[;\)]/i                                            // IA32 (x86)
	            ], [[ARCHITECTURE, 'ia32']], [

	            /\b(aarch64|armv?8e?l?)\b/i                                         // ARM64
	            ], [[ARCHITECTURE, 'arm64']], [

	            /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i                                   // ARMHF
	            ], [[ARCHITECTURE, 'armhf']], [

	            // PocketPC mistakenly identified as PowerPC
	            /windows\s(ce|mobile);\sppc;/i
	            ], [[ARCHITECTURE, 'arm']], [

	            /((?:ppc|powerpc)(?:64)?)(?:\smac|;|\))/i                           // PowerPC
	            ], [[ARCHITECTURE, /ower/, '', util.lowerize]], [

	            /(sun4\w)[;\)]/i                                                    // SPARC
	            ], [[ARCHITECTURE, 'sparc']], [

	            /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?:64|(?=v(?:[1-7]|[5-7]1)l?|;|eabi))|(?=atmel\s)avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
	                                                                                // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
	            ], [[ARCHITECTURE, util.lowerize]]
	        ],

	        device : [[

	            //////////////////////////
	            // MOBILES & TABLETS
	            // Ordered by popularity
	            /////////////////////////

	            // Samsung
	            /\b(sch-i[89]0\d|shw-m380s|sm-[pt]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus\s10)/i
	            ], [MODEL, [VENDOR, 'Samsung'], [TYPE, TABLET]], [
	            /\b((?:s[cgp]h|gt|sm)-\w+|galaxy\snexus)/i,
	            /\ssamsung[\s-]([\w-]+)/i,
	            /sec-(sgh\w+)/i
	            ], [MODEL, [VENDOR, 'Samsung'], [TYPE, MOBILE]], [

	            // Apple
	            /\((ip(?:hone|od)[\s\w]*);/i                                        // iPod/iPhone
	            ], [MODEL, [VENDOR, 'Apple'], [TYPE, MOBILE]], [
	            /\((ipad);[\w\s\),;-]+apple/i,                                      // iPad
	            /applecoremedia\/[\w\.]+\s\((ipad)/i,
	            /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
	            ], [MODEL, [VENDOR, 'Apple'], [TYPE, TABLET]], [

	            // Huawei
	            /\b((?:agr|ags[23]|bah2?|sht?)-a?[lw]\d{2})/i,
	            ], [MODEL, [VENDOR, 'Huawei'], [TYPE, TABLET]], [
	            /d\/huawei([\w\s-]+)[;\)]/i,
	            /\b(nexus\s6p|vog-[at]?l\d\d|ane-[at]?l[x\d]\d|eml-a?l\d\da?|lya-[at]?l\d[\dc]|clt-a?l\d\di?|ele-l\d\d)/i,
	            /\b(\w{2,4}-[atu][ln][01259][019])[;\)\s]/i
	            ], [MODEL, [VENDOR, 'Huawei'], [TYPE, MOBILE]], [

	            // Xiaomi
	            /\b(poco[\s\w]+)(?:\sbuild|\))/i,                                   // Xiaomi POCO
	            /\b;\s(\w+)\sbuild\/hm\1/i,                                         // Xiaomi Hongmi 'numeric' models
	            /\b(hm[\s\-_]?note?[\s_]?(?:\d\w)?)\sbuild/i,                       // Xiaomi Hongmi
	            /\b(redmi[\s\-_]?(?:note|k)?[\w\s_]+)(?:\sbuild|\))/i,              // Xiaomi Redmi
	            /\b(mi[\s\-_]?(?:a\d|one|one[\s_]plus|note lte)?[\s_]?(?:\d?\w?)[\s_]?(?:plus)?)\sbuild/i  // Xiaomi Mi
	            ], [[MODEL, /_/g, ' '], [VENDOR, 'Xiaomi'], [TYPE, MOBILE]], [
	            /\b(mi[\s\-_]?(?:pad)(?:[\w\s_]+))(?:\sbuild|\))/i                  // Mi Pad tablets
	            ],[[MODEL, /_/g, ' '], [VENDOR, 'Xiaomi'], [TYPE, TABLET]], [

	            // OPPO
	            /;\s(\w+)\sbuild.+\soppo/i,
	            /\s(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007)\b/i
	            ], [MODEL, [VENDOR, 'OPPO'], [TYPE, MOBILE]], [

	            // Vivo
	            /\svivo\s(\w+)(?:\sbuild|\))/i,
	            /\s(v[12]\d{3}\w?[at])(?:\sbuild|;)/i
	            ], [MODEL, [VENDOR, 'Vivo'], [TYPE, MOBILE]], [

	            // Realme
	            /\s(rmx[12]\d{3})(?:\sbuild|;)/i
	            ], [MODEL, [VENDOR, 'Realme'], [TYPE, MOBILE]], [

	            // Motorola
	            /\s(milestone|droid(?:[2-4x]|\s(?:bionic|x2|pro|razr))?:?(\s4g)?)\b[\w\s]+build\//i,
	            /\smot(?:orola)?[\s-](\w*)/i,
	            /((?:moto[\s\w\(\)]+|xt\d{3,4}|nexus\s6)(?=\sbuild|\)))/i
	            ], [MODEL, [VENDOR, 'Motorola'], [TYPE, MOBILE]], [
	            /\s(mz60\d|xoom[\s2]{0,2})\sbuild\//i
	            ], [MODEL, [VENDOR, 'Motorola'], [TYPE, TABLET]], [

	            // LG
	            /((?=lg)?[vl]k\-?\d{3})\sbuild|\s3\.[\s\w;-]{10}lg?-([06cv9]{3,4})/i
	            ], [MODEL, [VENDOR, 'LG'], [TYPE, TABLET]], [
	            /(lm-?f100[nv]?|nexus\s[45])/i,
	            /lg[e;\s\/-]+((?!browser|netcast)\w+)/i,
	            /\blg(\-?[\d\w]+)\sbuild/i
	            ], [MODEL, [VENDOR, 'LG'], [TYPE, MOBILE]], [

	            // Lenovo
	            /(ideatab[\w\-\s]+)/i,
	            /lenovo\s?(s(?:5000|6000)(?:[\w-]+)|tab(?:[\s\w]+)|yt[\d\w-]{6}|tb[\d\w-]{6})/i        // Lenovo tablets
	            ], [MODEL, [VENDOR, 'Lenovo'], [TYPE, TABLET]], [

	            // Nokia
	            /(?:maemo|nokia).*(n900|lumia\s\d+)/i,
	            /nokia[\s_-]?([\w\.-]*)/i
	            ], [[MODEL, /_/g, ' '], [VENDOR, 'Nokia'], [TYPE, MOBILE]], [

	            // Google
	            /droid.+;\s(pixel\sc)[\s)]/i                                        // Google Pixel C
	            ], [MODEL, [VENDOR, 'Google'], [TYPE, TABLET]], [
	            /droid.+;\s(pixel[\s\daxl]{0,6})(?:\sbuild|\))/i                    // Google Pixel
	            ], [MODEL, [VENDOR, 'Google'], [TYPE, MOBILE]], [

	            // Sony
	            /droid.+\s([c-g]\d{4}|so[-l]\w+|xq-a\w[4-7][12])(?=\sbuild\/|\).+chrome\/(?![1-6]{0,1}\d\.))/i
	            ], [MODEL, [VENDOR, 'Sony'], [TYPE, MOBILE]], [
	            /sony\stablet\s[ps]\sbuild\//i,
	            /(?:sony)?sgp\w+(?:\sbuild\/|\))/i
	            ], [[MODEL, 'Xperia Tablet'], [VENDOR, 'Sony'], [TYPE, TABLET]], [

	            // OnePlus
	            /\s(kb2005|in20[12]5|be20[12][59])\b/i,
	            /\ba000(1)\sbuild/i,                                                // OnePlus
	            /\boneplus\s(a\d{4})[\s)]/i
	            ], [MODEL, [VENDOR, 'OnePlus'], [TYPE, MOBILE]], [

	            // Amazon
	            /(alexa)webm/i,
	            /(kf[a-z]{2}wi)(\sbuild\/|\))/i,                                    // Kindle Fire without Silk
	            /(kf[a-z]+)(\sbuild\/|\)).+silk\//i                                 // Kindle Fire HD
	            ], [MODEL, [VENDOR, 'Amazon'], [TYPE, TABLET]], [
	            /(sd|kf)[0349hijorstuw]+(\sbuild\/|\)).+silk\//i                    // Fire Phone
	            ], [[MODEL, 'Fire Phone'], [VENDOR, 'Amazon'], [TYPE, MOBILE]], [

	            // BlackBerry
	            /\((playbook);[\w\s\),;-]+(rim)/i                                   // BlackBerry PlayBook
	            ], [MODEL, VENDOR, [TYPE, TABLET]], [
	            /((?:bb[a-f]|st[hv])100-\d)/i,
	            /\(bb10;\s(\w+)/i                                                   // BlackBerry 10
	            ], [MODEL, [VENDOR, 'BlackBerry'], [TYPE, MOBILE]], [

	            // Asus
	            /(?:\b|asus_)(transfo[prime\s]{4,10}\s\w+|eeepc|slider\s\w+|nexus\s7|padfone|p00[cj])/i
	            ], [MODEL, [VENDOR, 'ASUS'], [TYPE, TABLET]], [
	            /\s(z[es]6[027][01][km][ls]|zenfone\s\d\w?)\b/i
	            ], [MODEL, [VENDOR, 'ASUS'], [TYPE, MOBILE]], [

	            // HTC
	            /(nexus\s9)/i                                                       // HTC Nexus 9
	            ], [MODEL, [VENDOR, 'HTC'], [TYPE, TABLET]], [
	            /(htc)[;_\s-]{1,2}([\w\s]+(?=\)|\sbuild)|\w+)/i,                    // HTC

	            // ZTE
	            /(zte)-(\w*)/i,
	            /(alcatel|geeksphone|nexian|panasonic|(?=;\s)sony)[_\s-]?([\w-]*)/i // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
	            ], [VENDOR, [MODEL, /_/g, ' '], [TYPE, MOBILE]], [

	            // Acer
	            /droid[x\d\.\s;]+\s([ab][1-7]\-?[0178a]\d\d?)/i
	            ], [MODEL, [VENDOR, 'Acer'], [TYPE, TABLET]], [

	            // Meizu
	            /droid.+;\s(m[1-5]\snote)\sbuild/i,
	            /\bmz-([\w-]{2,})/i
	            ], [MODEL, [VENDOR, 'Meizu'], [TYPE, MOBILE]], [

	            // MIXED
	            /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[\s_-]?([\w-]*)/i,
	                                                                                // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
	            /(hp)\s([\w\s]+\w)/i,                                               // HP iPAQ
	            /(asus)-?(\w+)/i,                                                   // Asus
	            /(microsoft);\s(lumia[\s\w]+)/i,                                    // Microsoft Lumia
	            /(lenovo)[_\s-]?([\w-]+)/i,                                         // Lenovo
	            /linux;.+(jolla);/i,                                                // Jolla
	            /droid.+;\s(oppo)\s?([\w\s]+)\sbuild/i                              // OPPO
	            ], [VENDOR, MODEL, [TYPE, MOBILE]], [

	            /(archos)\s(gamepad2?)/i,                                           // Archos
	            /(hp).+(touchpad(?!.+tablet)|tablet)/i,                             // HP TouchPad
	            /(kindle)\/([\w\.]+)/i,                                             // Kindle
	            /\s(nook)[\w\s]+build\/(\w+)/i,                                     // Nook
	            /(dell)\s(strea[kpr\s\d]*[\dko])/i,                                 // Dell Streak
	            /[;\/]\s?(le[\s\-]+pan)[\s\-]+(\w{1,9})\sbuild/i,                   // Le Pan Tablets
	            /[;\/]\s?(trinity)[\-\s]*(t\d{3})\sbuild/i,                         // Trinity Tablets
	            /\b(gigaset)[\s\-]+(q\w{1,9})\sbuild/i,                             // Gigaset Tablets
	            /\b(vodafone)\s([\w\s]+)(?:\)|\sbuild)/i                            // Vodafone
	            ], [VENDOR, MODEL, [TYPE, TABLET]], [

	            /\s(surface\sduo)\s/i                                               // Surface Duo
	            ], [MODEL, [VENDOR, 'Microsoft'], [TYPE, TABLET]], [
	            /droid\s[\d\.]+;\s(fp\du?)\sbuild/i
	            ], [MODEL, [VENDOR, 'Fairphone'], [TYPE, MOBILE]], [
	            /\s(u304aa)\sbuild/i                                                // AT&T
	            ], [MODEL, [VENDOR, 'AT&T'], [TYPE, MOBILE]], [
	            /sie-(\w*)/i                                                        // Siemens
	            ], [MODEL, [VENDOR, 'Siemens'], [TYPE, MOBILE]], [
	            /[;\/]\s?(rct\w+)\sbuild/i                                          // RCA Tablets
	            ], [MODEL, [VENDOR, 'RCA'], [TYPE, TABLET]], [
	            /[;\/\s](venue[\d\s]{2,7})\sbuild/i                                 // Dell Venue Tablets
	            ], [MODEL, [VENDOR, 'Dell'], [TYPE, TABLET]], [
	            /[;\/]\s?(q(?:mv|ta)\w+)\sbuild/i                                   // Verizon Tablet
	            ], [MODEL, [VENDOR, 'Verizon'], [TYPE, TABLET]], [
	            /[;\/]\s(?:barnes[&\s]+noble\s|bn[rt])([\w\s\+]*)\sbuild/i          // Barnes & Noble Tablet
	            ], [MODEL, [VENDOR, 'Barnes & Noble'], [TYPE, TABLET]], [
	            /[;\/]\s(tm\d{3}\w+)\sbuild/i
	            ], [MODEL, [VENDOR, 'NuVision'], [TYPE, TABLET]], [
	            /;\s(k88)\sbuild/i                                                  // ZTE K Series Tablet
	            ], [MODEL, [VENDOR, 'ZTE'], [TYPE, TABLET]], [
	            /;\s(nx\d{3}j)\sbuild/i                                             // ZTE Nubia
	            ], [MODEL, [VENDOR, 'ZTE'], [TYPE, MOBILE]], [
	            /[;\/]\s?(gen\d{3})\sbuild.*49h/i                                   // Swiss GEN Mobile
	            ], [MODEL, [VENDOR, 'Swiss'], [TYPE, MOBILE]], [
	            /[;\/]\s?(zur\d{3})\sbuild/i                                        // Swiss ZUR Tablet
	            ], [MODEL, [VENDOR, 'Swiss'], [TYPE, TABLET]], [
	            /[;\/]\s?((zeki)?tb.*\b)\sbuild/i                                   // Zeki Tablets
	            ], [MODEL, [VENDOR, 'Zeki'], [TYPE, TABLET]], [
	            /[;\/]\s([yr]\d{2})\sbuild/i,
	            /[;\/]\s(dragon[\-\s]+touch\s|dt)(\w{5})\sbuild/i                   // Dragon Touch Tablet
	            ], [[VENDOR, 'Dragon Touch'], MODEL, [TYPE, TABLET]], [
	            /[;\/]\s?(ns-?\w{0,9})\sbuild/i                                     // Insignia Tablets
	            ], [MODEL, [VENDOR, 'Insignia'], [TYPE, TABLET]], [
	            /[;\/]\s?((nxa|Next)-?\w{0,9})\sbuild/i                             // NextBook Tablets
	            ], [MODEL, [VENDOR, 'NextBook'], [TYPE, TABLET]], [
	            /[;\/]\s?(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05]))\sbuild/i
	            ], [[VENDOR, 'Voice'], MODEL, [TYPE, MOBILE]], [                    // Voice Xtreme Phones
	            /[;\/]\s?(lvtel\-)?(v1[12])\sbuild/i                                // LvTel Phones
	            ], [[VENDOR, 'LvTel'], MODEL, [TYPE, MOBILE]], [
	            /;\s(ph-1)\s/i
	            ], [MODEL, [VENDOR, 'Essential'], [TYPE, MOBILE]], [                // Essential PH-1
	            /[;\/]\s?(v(100md|700na|7011|917g).*\b)\sbuild/i                    // Envizen Tablets
	            ], [MODEL, [VENDOR, 'Envizen'], [TYPE, TABLET]], [
	            /[;\/]\s?(trio[\s\w\-\.]+)\sbuild/i                                 // MachSpeed Tablets
	            ], [MODEL, [VENDOR, 'MachSpeed'], [TYPE, TABLET]], [
	            /[;\/]\s?tu_(1491)\sbuild/i                                         // Rotor Tablets
	            ], [MODEL, [VENDOR, 'Rotor'], [TYPE, TABLET]], [
	            /(shield[\w\s]+)\sbuild/i                                           // Nvidia Shield Tablets
	            ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, TABLET]], [
	            /(sprint)\s(\w+)/i                                                  // Sprint Phones
	            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
	            /(kin\.[onetw]{3})/i                                                // Microsoft Kin
	            ], [[MODEL, /\./g, ' '], [VENDOR, 'Microsoft'], [TYPE, MOBILE]], [
	            /droid\s[\d\.]+;\s(cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i     // Zebra
	            ], [MODEL, [VENDOR, 'Zebra'], [TYPE, TABLET]], [
	            /droid\s[\d\.]+;\s(ec30|ps20|tc[2-8]\d[kx])\)/i
	            ], [MODEL, [VENDOR, 'Zebra'], [TYPE, MOBILE]], [

	            ///////////////////
	            // CONSOLES
	            ///////////////////

	            /\s(ouya)\s/i,                                                      // Ouya
	            /(nintendo)\s([wids3utch]+)/i                                       // Nintendo
	            ], [VENDOR, MODEL, [TYPE, CONSOLE]], [
	            /droid.+;\s(shield)\sbuild/i                                        // Nvidia
	            ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, CONSOLE]], [
	            /(playstation\s[345portablevi]+)/i                                  // Playstation
	            ], [MODEL, [VENDOR, 'Sony'], [TYPE, CONSOLE]], [
	            /[\s\(;](xbox(?:\sone)?(?!;\sxbox))[\s\);]/i                        // Microsoft Xbox
	            ], [MODEL, [VENDOR, 'Microsoft'], [TYPE, CONSOLE]], [

	            ///////////////////
	            // SMARTTVS
	            ///////////////////

	            /smart-tv.+(samsung)/i                                              // Samsung
	            ], [VENDOR, [TYPE, SMARTTV]], [
	            /hbbtv.+maple;(\d+)/i
	            ], [[MODEL, /^/, 'SmartTV'], [VENDOR, 'Samsung'], [TYPE, SMARTTV]], [
	            /(?:linux;\snetcast.+smarttv|lg\snetcast\.tv-201\d)/i,              // LG SmartTV
	            ], [[VENDOR, 'LG'], [TYPE, SMARTTV]], [
	            /(apple)\s?tv/i                                                     // Apple TV
	            ], [VENDOR, [MODEL, 'Apple TV'], [TYPE, SMARTTV]], [
	            /crkey/i                                                            // Google Chromecast
	            ], [[MODEL, 'Chromecast'], [VENDOR, 'Google'], [TYPE, SMARTTV]], [
	            /droid.+aft([\w])(\sbuild\/|\))/i                                   // Fire TV
	            ], [MODEL, [VENDOR, 'Amazon'], [TYPE, SMARTTV]], [
	            /\(dtv[\);].+(aquos)/i                                              // Sharp
	            ], [MODEL, [VENDOR, 'Sharp'], [TYPE, SMARTTV]], [
	            /hbbtv\/\d+\.\d+\.\d+\s+\([\w\s]*;\s*(\w[^;]*);([^;]*)/i            // HbbTV devices
	            ], [[VENDOR, util.trim], [MODEL, util.trim], [TYPE, SMARTTV]], [
	            /[\s\/\(](android\s|smart[-\s]?|opera\s)tv[;\)\s]/i                 // SmartTV from Unidentified Vendors
	            ], [[TYPE, SMARTTV]], [

	            ///////////////////
	            // WEARABLES
	            ///////////////////

	            /((pebble))app\/[\d\.]+\s/i                                         // Pebble
	            ], [VENDOR, MODEL, [TYPE, WEARABLE]], [
	            /droid.+;\s(glass)\s\d/i                                            // Google Glass
	            ], [MODEL, [VENDOR, 'Google'], [TYPE, WEARABLE]], [
	            /droid\s[\d\.]+;\s(wt63?0{2,3})\)/i
	            ], [MODEL, [VENDOR, 'Zebra'], [TYPE, WEARABLE]], [

	            ///////////////////
	            // EMBEDDED
	            ///////////////////

	            /(tesla)(?:\sqtcarbrowser|\/20[12]\d\.[\w\.-]+)/i                   // Tesla
	            ], [VENDOR, [TYPE, EMBEDDED]], [

	            ////////////////////
	            // MIXED (GENERIC)
	            ///////////////////

	            /droid .+?; ([^;]+?)(?: build|\) applewebkit).+? mobile safari/i    // Android Phones from Unidentified Vendors
	            ], [MODEL, [TYPE, MOBILE]], [
	            /droid .+?;\s([^;]+?)(?: build|\) applewebkit).+?(?! mobile) safari/i  // Android Tablets from Unidentified Vendors
	            ], [MODEL, [TYPE, TABLET]], [
	            /\s(tablet|tab)[;\/]/i,                                             // Unidentifiable Tablet
	            /\s(mobile)(?:[;\/]|\ssafari)/i                                     // Unidentifiable Mobile
	            ], [[TYPE, util.lowerize]], [
	            /(android[\w\.\s\-]{0,9});.+build/i                                 // Generic Android Device
	            ], [MODEL, [VENDOR, 'Generic']], [
	            /(phone)/i
	            ], [[TYPE, MOBILE]]
	        ],

	        engine : [[

	            /windows.+\sedge\/([\w\.]+)/i                                       // EdgeHTML
	            ], [VERSION, [NAME, 'EdgeHTML']], [

	            /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i                         // Blink
	            ], [VERSION, [NAME, 'Blink']], [

	            /(presto)\/([\w\.]+)/i,                                             // Presto
	            /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i, // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m/Goanna
	            /ekioh(flow)\/([\w\.]+)/i,                                          // Flow
	            /(khtml|tasman|links)[\/\s]\(?([\w\.]+)/i,                          // KHTML/Tasman/Links
	            /(icab)[\/\s]([23]\.[\d\.]+)/i                                      // iCab
	            ], [NAME, VERSION], [

	            /rv\:([\w\.]{1,9})\b.+(gecko)/i                                     // Gecko
	            ], [VERSION, NAME]
	        ],

	        os : [[

	            // Windows
	            /microsoft\s(windows)\s(vista|xp)/i                                 // Windows (iTunes)
	            ], [NAME, VERSION], [
	            /(windows)\snt\s6\.2;\s(arm)/i,                                     // Windows RT
	            /(windows\sphone(?:\sos)*)[\s\/]?([\d\.\s\w]*)/i,                   // Windows Phone
	            /(windows\smobile|windows)[\s\/]?([ntce\d\.\s]+\w)(?!.+xbox)/i
	            ], [NAME, [VERSION, mapper.str, maps.os.windows.version]], [
	            /(win(?=3|9|n)|win\s9x\s)([nt\d\.]+)/i
	            ], [[NAME, 'Windows'], [VERSION, mapper.str, maps.os.windows.version]], [

	            // iOS/macOS
	            /ip[honead]{2,4}\b(?:.*os\s([\w]+)\slike\smac|;\sopera)/i,          // iOS
	            /cfnetwork\/.+darwin/i
	            ], [[VERSION, /_/g, '.'], [NAME, 'iOS']], [
	            /(mac\sos\sx)\s?([\w\s\.]*)/i,
	            /(macintosh|mac(?=_powerpc)\s)(?!.+haiku)/i                         // Mac OS
	            ], [[NAME, 'Mac OS'], [VERSION, /_/g, '.']], [

	            // Mobile OSes                                                      // Android/WebOS/Palm/QNX/Bada/RIM/MeeGo/Contiki/Sailfish OS
	            /(android|webos|palm\sos|qnx|bada|rim\stablet\sos|meego|sailfish|contiki)[\/\s-]?([\w\.]*)/i,
	            /(blackberry)\w*\/([\w\.]*)/i,                                      // Blackberry
	            /(tizen|kaios)[\/\s]([\w\.]+)/i,                                    // Tizen/KaiOS
	            /\((series40);/i                                                    // Series 40
	            ], [NAME, VERSION], [
	            /\(bb(10);/i                                                        // BlackBerry 10
	            ], [VERSION, [NAME, 'BlackBerry']], [
	            /(?:symbian\s?os|symbos|s60(?=;)|series60)[\/\s-]?([\w\.]*)/i       // Symbian
	            ], [VERSION, [NAME, 'Symbian']], [
	            /mozilla.+\(mobile;.+gecko.+firefox/i                               // Firefox OS
	            ], [[NAME, 'Firefox OS']], [
	            /web0s;.+rt(tv)/i,
	            /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i                              // WebOS
	            ], [VERSION, [NAME, 'webOS']], [

	            // Google Chromecast
	            /crkey\/([\d\.]+)/i                                                 // Google Chromecast
	            ], [VERSION, [NAME, 'Chromecast']], [
	            /(cros)\s[\w]+\s([\w\.]+\w)/i                                       // Chromium OS
	            ], [[NAME, 'Chromium OS'], VERSION],[

	            // Console
	            /(nintendo|playstation)\s([wids345portablevuch]+)/i,                // Nintendo/Playstation
	            /(xbox);\s+xbox\s([^\);]+)/i,                                       // Microsoft Xbox (360, One, X, S, Series X, Series S)

	            // GNU/Linux based
	            /(mint)[\/\s\(\)]?(\w*)/i,                                          // Mint
	            /(mageia|vectorlinux)[;\s]/i,                                       // Mageia/VectorLinux
	            /(joli|[kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?=\slinux)|slackware|fedora|mandriva|centos|pclinuxos|redhat|zenwalk|linpus|raspbian)(?:\sgnu\/linux)?(?:\slinux)?[\/\s-]?(?!chrom|package)([\w\.-]*)/i,
	                                                                                // Joli/Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware
	                                                                                // Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus
	            /(hurd|linux)\s?([\w\.]*)/i,                                        // Hurd/Linux
	            /(gnu)\s?([\w\.]*)/i,                                               // GNU

	            // BSD based
	            /\s([frentopc-]{0,4}bsd|dragonfly)\s?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,  // FreeBSD/NetBSD/OpenBSD/PC-BSD/DragonFly
	            /(haiku)\s(\w+)/i                                                   // Haiku
	            ], [NAME, VERSION], [

	            // Other
	            /(sunos)\s?([\w\.\d]*)/i                                            // Solaris
	            ], [[NAME, 'Solaris'], VERSION], [
	            /((?:open)?solaris)[\/\s-]?([\w\.]*)/i,                             // Solaris
	            /(aix)\s((\d)(?=\.|\)|\s)[\w\.])*/i,                                // AIX
	            /(plan\s9|minix|beos|os\/2|amigaos|morphos|risc\sos|openvms|fuchsia)/i,  // Plan9/Minix/BeOS/OS2/AmigaOS/MorphOS/RISCOS/OpenVMS/Fuchsia
	            /(unix)\s?([\w\.]*)/i                                               // UNIX
	            ], [NAME, VERSION]
	        ]
	    };


	    /////////////////
	    // Constructor
	    ////////////////
	    var UAParser = function (ua, extensions) {

	        if (typeof ua === 'object') {
	            extensions = ua;
	            ua = undefined$1;
	        }

	        if (!(this instanceof UAParser)) {
	            return new UAParser(ua, extensions).getResult();
	        }

	        var _ua = ua || ((typeof window !== 'undefined' && window.navigator && window.navigator.userAgent) ? window.navigator.userAgent : EMPTY);
	        var _rgxmap = extensions ? util.extend(regexes, extensions) : regexes;

	        this.getBrowser = function () {
	            var _browser = { name: undefined$1, version: undefined$1 };
	            mapper.rgx.call(_browser, _ua, _rgxmap.browser);
	            _browser.major = util.major(_browser.version); // deprecated
	            return _browser;
	        };
	        this.getCPU = function () {
	            var _cpu = { architecture: undefined$1 };
	            mapper.rgx.call(_cpu, _ua, _rgxmap.cpu);
	            return _cpu;
	        };
	        this.getDevice = function () {
	            var _device = { vendor: undefined$1, model: undefined$1, type: undefined$1 };
	            mapper.rgx.call(_device, _ua, _rgxmap.device);
	            return _device;
	        };
	        this.getEngine = function () {
	            var _engine = { name: undefined$1, version: undefined$1 };
	            mapper.rgx.call(_engine, _ua, _rgxmap.engine);
	            return _engine;
	        };
	        this.getOS = function () {
	            var _os = { name: undefined$1, version: undefined$1 };
	            mapper.rgx.call(_os, _ua, _rgxmap.os);
	            return _os;
	        };
	        this.getResult = function () {
	            return {
	                ua      : this.getUA(),
	                browser : this.getBrowser(),
	                engine  : this.getEngine(),
	                os      : this.getOS(),
	                device  : this.getDevice(),
	                cpu     : this.getCPU()
	            };
	        };
	        this.getUA = function () {
	            return _ua;
	        };
	        this.setUA = function (ua) {
	            _ua = (typeof ua === STR_TYPE && ua.length > UA_MAX_LENGTH) ? util.trim(ua, UA_MAX_LENGTH) : ua;
	            return this;
	        };
	        this.setUA(_ua);
	        return this;
	    };

	    UAParser.VERSION = LIBVERSION;
	    UAParser.BROWSER = {
	        NAME    : NAME,
	        MAJOR   : MAJOR, // deprecated
	        VERSION : VERSION
	    };
	    UAParser.CPU = {
	        ARCHITECTURE : ARCHITECTURE
	    };
	    UAParser.DEVICE = {
	        MODEL   : MODEL,
	        VENDOR  : VENDOR,
	        TYPE    : TYPE,
	        CONSOLE : CONSOLE,
	        MOBILE  : MOBILE,
	        SMARTTV : SMARTTV,
	        TABLET  : TABLET,
	        WEARABLE: WEARABLE,
	        EMBEDDED: EMBEDDED
	    };
	    UAParser.ENGINE = {
	        NAME    : NAME,
	        VERSION : VERSION
	    };
	    UAParser.OS = {
	        NAME    : NAME,
	        VERSION : VERSION
	    };

	    ///////////
	    // Export
	    //////////


	    // check js environment
	    {
	        // nodejs env
	        if (module.exports) {
	            exports = module.exports = UAParser;
	        }
	        exports.UAParser = UAParser;
	    }

	    // jQuery/Zepto specific (optional)
	    // Note:
	    //   In AMD env the global scope should be kept clean, but jQuery is an exception.
	    //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
	    //   and we should catch that.
	    var $ = typeof window !== 'undefined' && (window.jQuery || window.Zepto);
	    if ($ && !$.ua) {
	        var parser = new UAParser();
	        $.ua = parser.getResult();
	        $.ua.get = function () {
	            return parser.getUA();
	        };
	        $.ua.set = function (uastring) {
	            parser.setUA(uastring);
	            var result = parser.getResult();
	            for (var prop in result) {
	                $.ua[prop] = result[prop];
	            }
	        };
	    }

	})(typeof window === 'object' ? window : commonjsGlobal); 
} (uaParser, uaParser.exports));

var uaParserExports = uaParser.exports;
var parser = /*@__PURE__*/getDefaultExportFromCjs(uaParserExports);

var getPushToken = function (email, userToken, mobile_uuid, mobile_lang) {
    var ua = parser(navigator.userAgent);
    return jwtAxiosInst.get("/BCS/alarmRegister.php?email=".concat(email, "&user_token=").concat(userToken, "&tokenType=web&mobile_os_type=web&mobile_uuid=").concat(mobile_uuid, "&mobile_lang=").concat(mobile_lang, "&mobile_os_ver=1.00&mobile_name=").concat(ua.browser.name, "&mobile_model=blackvueweb"));
};

var getMonthlyReport = function (email, userToken, psn, startTime, endTime) {
    return axiosInst.get("/Stats/GetDrivingAvgPerDay?email=".concat(email, "&userToken=").concat(userToken, "&tokenType=web&psn=").concat(psn, "&startTime=").concat(startTime, "&endTime=").concat(endTime));
};
var getDailyReport = function (email, userToken, psn, startTime, endTime) {
    return axiosInst.get("/Stats/GetDrivingAvgPerHour?email=".concat(email, "&userToken=").concat(userToken, "&tokenType=web&psn=").concat(psn, "&startTime=").concat(startTime, "&endTime=").concat(endTime));
};
var getMonthlyScore = function (email, userToken, psn, month) {
    return axiosInst.get("/Stats/GetDrivingMonthlyReport?email=".concat(email, "&userToken=").concat(userToken, "&tokenType=web&psn=").concat(psn, "&month=").concat(month));
};
var getDailyLog = function (email, userToken, psn, startTime, endTime) {
    return jwtAxiosInst.get("/BCS/dailyLogGet.php?email=".concat(email, "&user_token=").concat(userToken, "&psn_list=").concat(psn, "&start_date=").concat(startTime, "&end_date=").concat(endTime, "&token_type=web&date_type=utc"));
};

var getGoogleUserInfo = function (accessToken) {
    return axios$1.get("https://www.googleapis.com/oauth2/v2/userinfo", {
        headers: {
            Authorization: "Bearer ".concat(accessToken),
        },
    });
};

var logout = function (email, userToken) {
    return jwtAxiosInst.get("/BCS/userLogout.php?email=".concat(email, "&user_token=").concat(userToken, "&tokenType=web"));
};
var userLogin = function (body) {
    var data = qs.stringify(body);
    return jwtAxiosInst.post("/BCS/userLogin.php", data, {
        headers: {
            "Content-type": "application/x-www-form-urlencoded",
        },
    });
};
var getProfile = function (email, userToken, tokenType) {
    return axiosInst.get("/Account/GetProfile?email=".concat(email, "&userToken=").concat(userToken, "&tokenType=").concat(tokenType !== null && tokenType !== void 0 ? tokenType : "web"));
};
var getMailAddress = function (email, lang) {
    return jwtAxiosInst.get("/BCS/initPasswd.php?email=".concat(email, "&mobile_lang=").concat(lang));
};
var createUser = function (user) {
    return axiosInst.post("/Account/UserAdd", user);
};
var userConfirm = function (user) {
    return axiosInst.post("/Account/UserConfirm", user);
};
var uploadImage = function (email, userToken, tokenType, payload) {
    var params = new FormData();
    params.append("email", email);
    params.append("userToken", userToken);
    params.append("tokenType", tokenType);
    params.append("file", payload.file);
    params.append("fileName", crypto.createHash("md5").update(payload.fileName).digest("hex"));
    return axiosInst.post("/Account/UploadProfile", params, {
        headers: {
            "Content-type": "multipart/form-data",
        },
    });
};
var changeName = function (email, user_token, body) {
    return axiosInst.post("/Account/ChangeUserName", __assign(__assign({}, body), { email: email, user_token: user_token, tokenType: "web" }));
};
var changePasswd = function (email, old_passwd, new_passwd) {
    var data = qs.stringify({
        email: email,
        old_passwd: old_passwd,
        new_passwd: new_passwd,
        tokenType: "web",
    });
    return jwtAxiosInst.post("/BCS/userChangePasswd.php", data, {
        headers: {
            "Content-type": "application/x-www-form-urlencoded",
        },
    });
};
// export const deleteAccountMail = (
//   email: string,
//   user_token: string,
//   passwd: string,
//   tokenType: string
// ) => {
//   const data = qs.stringify({ email, user_token, passwd, tokenType });
//   return jwtAxiosInst.post(`/BCS/accountDelete.php`, data, {
//     headers: {
//       "Content-type": "application/x-www-form-urlencoded",
//     },
//   });
// };
var userUsage = function (email, userToken, tokenType) {
    return axiosInst.get("/Account/UserUsageInfo?email=".concat(email, "&user_token=").concat(userToken, "&tokenType=").concat(tokenType));
};
var getUserSetting = function (email, userToken, tokenType) {
    return axiosInst.get("/Account/GetUserSettings?email=".concat(email, "&user_token=").concat(userToken, "&tokenType=").concat(tokenType));
};
var updateUserSetting = function (email, userToken, mapType, velocityUnit) {
    return axiosInst.post("/Account/PostUserSettings", {
        email: email,
        user_token: userToken,
        tokenType: "web",
        mapType: mapType,
        velocityUnit: velocityUnit,
    });
};
var setUserNotification = function (email, userToken, mobile_uuid, body) {
    return jwtAxiosInst.get("/BCS/alarmDetailSet.php?email=".concat(email, "&user_token=").concat(userToken, "&mobile_uuid=").concat(mobile_uuid, "&device_alarm=").concat(body.device_alarm, "&notice_alarm=").concat(body.notice_alarm, "&system_alarm=").concat(body.system_alarm, "&tokenType=web"));
};
var getUserNotification = function (email, userToken, mobile_uuid) {
    return jwtAxiosInst.get("/BCS/alarmDetailGet.php?email=".concat(email, "&user_token=").concat(userToken, "&mobile_uuid=").concat(mobile_uuid, "&tokenType=web"));
};
var getUserPermissions = function (email, userToken, targetEmail) {
    return axiosInst.get("/Account/UserRoleTargetInfo?email=".concat(email, "&user_token=").concat(userToken, "&tokenType=web&targetEmail=").concat(targetEmail));
};
var updateUserPermissions = function (email, user_token, roleSetEmail, permissions) {
    return axiosInst.post("/Account/UserRoleSet", {
        email: email,
        user_token: user_token,
        roleSetEmail: roleSetEmail,
        permissions: permissions,
        tokenType: "web",
    });
};
var linkSocialAccount = function (email, passwd, oauthToken, signupType) {
    return axiosInst.put("/Account/PutUserLinkage", {
        email: email,
        passwd: passwd,
        oauthToken: oauthToken,
        signupType: signupType,
    });
};
var doDeleteUser = function (email, user_token) {
    return axiosInst.post("/Account/PostUserDeleteWithEmail", {
        email: email,
        user_token: user_token,
        tokenType: "web",
    });
};
var loadUserPermissions = function (email, user_token, tokenType) {
    return axiosInst.get("/Account/UserRole?email=".concat(email, "&user_token=").concat(user_token, "&tokenType=").concat(tokenType));
};
// export const getAccountSubscription = (email: string, userToken: string) => {
//   return axiosInst.get(
//     `/Payment/GetSubscrInfo?email=${email}&user_token=${userToken}&tokenType=web`
//   );
// };

var getVODList = function (lb_server_name, lb_http_port, email, userToken, psn, tokenType) {
    return axiosInst.get("https://".concat(lb_server_name, ":").concat(lb_http_port, "/proc/vod_list?email=").concat(email, "&user_token=").concat(userToken, "&psn=").concat(psn, "&tokenType=").concat(tokenType));
};
var getVODToken = function (email, userToken, psn, filename) {
    return jwtAxiosInst.post("/Media/vodTokenReq", {
        email: email,
        user_token: userToken,
        psn: psn,
        filename: filename,
        tokenType: "web",
    });
};
var getCNThumbnail = function (email, user_token, psn, filename, types, tokenType) {
    return jwtAxiosInst.post("/IoT/devicecommand", {
        command: "Metadata",
        email: email,
        user_token: user_token,
        tokenType: tokenType,
        psn: psn,
        param1: filename,
        param2: types,
    });
};
var getThumbnail = function (lb_server_name, lb_http_port, email, userToken, psn, filename) {
    return axiosInst.get("https://".concat(lb_server_name, ":").concat(lb_http_port, "/proc/vod_file?email=").concat(email, "&user_token=").concat(userToken, "&psn=").concat(psn, "&filename=").concat(filename, "&tokenType=web"), { responseType: "arraybuffer" });
};
var getVOD = function (lb_server_name, lb_http_port, email, userToken, psn, filename, vod_token) {
    return axiosInst.get("https://".concat(lb_server_name, ":").concat(lb_http_port, "/proc/vod_file?email=").concat(email, "&user_token=").concat(userToken, "&psn=").concat(psn, "&filename=").concat(filename, "&vod_token=").concat(vod_token, "&tokenType=web"), { responseType: "arraybuffer" });
};
var getCloudVODList = function (email, userToken, psn) {
    return jwtAxiosInst.get("/BCS/s3FileList.php?email=".concat(email, "&user_token=").concat(userToken, "&psn=").concat(psn, "&tokenType=web"));
};
var getCloudVODFile = function (email, userToken, psn, filename, tokenType) {
    return jwtAxiosInst.get("/BCS/userS3PresignedUrl.php?email=".concat(email, "&user_token=").concat(userToken, "&psn=").concat(psn, "&filename=").concat(filename, "&tokenType=").concat(tokenType));
};
var deleteCloudVODFile = function (email, userToken, psn, filenames, vodCount) {
    return jwtAxiosInst.post("/BCS/multiDcf.php", {
        email: email,
        user_token: userToken,
        psn: psn,
        s3_mfd_info: {
            type: "select",
            filelist: filenames,
        },
        tokenType: "web",
        vodCount: vodCount,
    });
};
var getEventVODList = function (email, userToken, psn) {
    return jwtAxiosInst.get("/BCS/evtLrGetList.php?email=".concat(email, "&user_token=").concat(userToken, "&psn=").concat(psn, "&tokenType=web"));
};
var getEventVODFile = function (email, userToken, psn, rid, tokenType) {
    return jwtAxiosInst.get("/BCS/evtLrGetFileUrl.php?email=".concat(email, "&user_token=").concat(userToken, "&psn=").concat(psn, "&rid=").concat(rid, "&token_type=web"));
};
var deleteEventVODFile = function (email, userToken, psn, rids) {
    // return axiosInst.get(
    //   `${API_SERVER_URI}/BCS/evtLrDelFile.php?email=${email}&user_token=${userToken}&psn=${psn}&rid=${rid}&token_type=web`
    // );
    return axiosInst.delete("/CloudService/DeleteEventUpload", {
        data: {
            email: email,
            userToken: userToken,
            tokenType: "web",
            psn: psn,
            rid: rids,
        },
    });
};
var moveEventVODFile = function (email, userToken, psn, rids) {
    // return axiosInst.put(`/CloudService/MoveEventUpload`, {
    //   email,
    //   userToken,
    //   psn,
    //   rid: rids,
    //   tokenType: "web",
    // });
    return axiosInst.put("/CloudService/MoveEventUpload", {
        email: email,
        userToken: userToken,
        tokenType: "web",
        psn: psn,
        rid: rids,
    });
};
var uploadCNVODFile = function (email, psn, filename) {
    return jwtAxiosInst.post("/IoT/uploadReq", {
        email: email,
        psn: psn,
        filename: filename,
    }, {
        headers: {
            "Content-Type": "application/json",
        },
    });
};
var uploadVODFile = function (upload_server, upload_port, email, userToken, psn, filename) {
    return axiosInst.post("https://".concat(upload_server, ":").concat(upload_port, "/BCS/upload_req"), {
        email: email,
        user_token: userToken,
        psn: psn,
        filename: filename,
        token_type: "web",
    }, {
        headers: {
            "Content-Type": "application/json",
        },
    });
};
var getCNVODUploadList = function (email, psn) {
    return jwtAxiosInst.post("/IoT/queueList", {
        email: email,
        psn: psn,
    }, {
        headers: {
            "Content-Type": "application/json",
        },
    });
};
var getVODUploadList = function (upload_server, upload_port, email, userToken, psn) {
    // if (process.env.NODE_ENV === "development") {
    //   return axiosInst.post(
    //     `/upload/BCS/queue_list`,
    //     {
    //       email,
    //       user_token: userToken,
    //       psn,
    //       token_type: "web",
    //     },
    //     {
    //       headers: {
    //         "Content-Type": "application/json",
    //       },
    //     }
    //   );
    // }
    return axiosInst.post("https://".concat(upload_server, ":").concat(upload_port, "/BCS/queue_list"), {
        email: email,
        user_token: userToken,
        psn: psn,
        token_type: "web",
    }, {
        headers: {
            "Content-Type": "application/json",
        },
    });
};
var deleteCNVODUploadList = function (email, psn, removelist) {
    return jwtAxiosInst.post("/IoT/queueDelete", {
        email: email,
        psn: psn,
        removelist: removelist,
    }, {
        headers: {
            "Content-Type": "application/json",
        },
    });
};
var deleteVODUploadList = function (upload_server, upload_port, email, userToken, psn, removelist) {
    return axiosInst.post("https://".concat(upload_server, ":").concat(upload_port, "/BCS/queue_delete"), {
        email: email,
        user_token: userToken,
        psn: psn,
        token_type: "web",
        removelist: removelist,
    }, {
        headers: {
            "Content-Type": "application/json",
        },
    });
};
var getHashtags = function (email, userToken, tokenType) {
    return eventmapAxiosInst.get("/hashtags");
};
var getEventLink = function (email, userToken, psn, rid) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, jwtAxiosInst.get("/BCS/evtLrGetFileUrl.php?email=".concat(email, "&user_token=").concat(userToken, "&psn=").concat(psn, "&rid=").concat(rid, "&token_type=web"))];
    });
}); };
var getCloudLink = function (email, userToken, psn, fname) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, jwtAxiosInst.get("/BCS/userS3PresignedUrl.php?email=".concat(email, "&user_token=").concat(userToken, "&psn=").concat(psn, "&filename=").concat(fname, "&tokenType=web"))];
    });
}); };
var getLink = function (camera, email, userToken, vod, token, vodQuality) {
    var lb_server_name = camera.lb_server_name, lb_http_port = camera.lb_http_port, psn = camera.psn;
    var filename = vod.filename, lowFilename = vod.lowFilename;
    var vod_token = token.vod_token;
    var fname = filename;
    if (vodQuality === "low" && lowFilename) {
        fname = lowFilename;
    }
    return "".concat(getLbURI(lb_server_name, lb_http_port), "/proc/vod_file?email=").concat(email, "&user_token=").concat(userToken, "&psn=").concat(psn, "&filename=").concat(fname, "&vod_token=").concat(vod_token, "&tokenType=web");
};

var index = /*#__PURE__*/Object.freeze({
    __proto__: null,
    FixMasterEmailNotification: FixMasterEmailNotification,
    addAdmin: addAdmin,
    addCam: addCam,
    addCamera: addCamera,
    addGeofence: addGeofence,
    addGroup: addGroup,
    addUserFromCam: addUserFromCam,
    changeGroupName: changeGroupName,
    changeName: changeName,
    changePasswd: changePasswd,
    createUser: createUser,
    deleteAdmin: deleteAdmin,
    deleteCNVODUploadList: deleteCNVODUploadList,
    deleteCam: deleteCam,
    deleteCamera: deleteCamera,
    deleteCloudVODFile: deleteCloudVODFile,
    deleteEmail: deleteEmail,
    deleteEventVODFile: deleteEventVODFile,
    deleteGeofence: deleteGeofence,
    deleteGroup: deleteGroup,
    deleteUser: deleteUser,
    deleteVODUploadList: deleteVODUploadList,
    doDeleteUser: doDeleteUser,
    getCNFotaStart: getCNFotaStart,
    getCNThumbnail: getCNThumbnail,
    getCNVODUploadList: getCNVODUploadList,
    getCamInfo: getCamInfo,
    getCamList: getCamList,
    getCloudLink: getCloudLink,
    getCloudVODFile: getCloudVODFile,
    getCloudVODList: getCloudVODList,
    getDailyLog: getDailyLog,
    getDailyReport: getDailyReport,
    getEventLink: getEventLink,
    getEventVODFile: getEventVODFile,
    getEventVODList: getEventVODList,
    getEvents: getEvents,
    getFirmwareSettings: getFirmwareSettings,
    getFotaID: getFotaID,
    getFotaStart: getFotaStart,
    getFotaStatus: getFotaStatus,
    getFreeCamLocation: getFreeCamLocation,
    getFreetrialState: getFreetrialState,
    getFwInfos: getFwInfos,
    getGPSDriveData: getGPSDriveData,
    getGPSTrackingData: getGPSTrackingData,
    getGeofenceAlerts: getGeofenceAlerts,
    getGeofences: getGeofences,
    getGoogleUserInfo: getGoogleUserInfo,
    getGroupsList: getGroupsList,
    getGroupsListPaging: getGroupsListPaging,
    getHashtags: getHashtags,
    getLatestEvents: getLatestEvents,
    getLink: getLink,
    getLiveEventSettings: getLiveEventSettings,
    getMailAddress: getMailAddress,
    getMemberList: getMemberList,
    getMonthlyReport: getMonthlyReport,
    getMonthlyScore: getMonthlyScore,
    getMultiCamLocations: getMultiCamLocations,
    getMyCameraLocations: getMyCameraLocations,
    getNotification: getNotification,
    getNotificationEmail: getNotificationEmail,
    getProfile: getProfile,
    getPublicCameraLocation: getPublicCameraLocation,
    getPublicCameraLocations: getPublicCameraLocations,
    getPushToken: getPushToken,
    getSubscription: getSubscription,
    getThumbnail: getThumbnail,
    getTransactionHistory: getTransactionHistory,
    getUserList: getUserList,
    getUserNotification: getUserNotification,
    getUserPermissions: getUserPermissions,
    getUserRole: getUserRole,
    getUserSetting: getUserSetting,
    getVOD: getVOD,
    getVODList: getVODList,
    getVODToken: getVODToken,
    getVODUploadList: getVODUploadList,
    getWebSubscription: getWebSubscription,
    inviteEmail: inviteEmail,
    inviteMember: inviteMember,
    linkSocialAccount: linkSocialAccount,
    loadPrivacy: loadPrivacy,
    loadUserPermissions: loadUserPermissions,
    logout: logout,
    moveEventVODFile: moveEventVODFile,
    rebootCNCamera: rebootCNCamera,
    rebootCamera: rebootCamera,
    removeMember: removeMember,
    renameCamera: renameCamera,
    requestCancelSubscription: requestCancelSubscription,
    setShareingEventamp: setShareingEventamp,
    setUserNotification: setUserNotification,
    updateCNFirmwareSettings: updateCNFirmwareSettings,
    updateCNLiveEventSettings: updateCNLiveEventSettings,
    updateFirmwareSettings: updateFirmwareSettings,
    updateLiveEventSettings: updateLiveEventSettings,
    updateLiveviewUsage: updateLiveviewUsage,
    updateNotification: updateNotification,
    updatePrivacy: updatePrivacy,
    updateUserPermissions: updateUserPermissions,
    updateUserSetting: updateUserSetting,
    uploadCNVODFile: uploadCNVODFile,
    uploadImage: uploadImage,
    uploadVODFile: uploadVODFile,
    userConfirm: userConfirm,
    userLogin: userLogin,
    userUsage: userUsage
});

function _objectSpread$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? Object(arguments[i]) : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }
  return target;
}

var consoleLogger = {
  type: 'logger',
  log: function log(args) {
    this.output('log', args);
  },
  warn: function warn(args) {
    this.output('warn', args);
  },
  error: function error(args) {
    this.output('error', args);
  },
  output: function output(type, args) {
    if (console && console[type]) console[type].apply(console, args);
  }
};

var Logger = function () {
  function Logger(concreteLogger) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Logger);

    this.init(concreteLogger, options);
  }

  _createClass(Logger, [{
    key: "init",
    value: function init(concreteLogger) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.prefix = options.prefix || 'i18next:';
      this.logger = concreteLogger || consoleLogger;
      this.options = options;
      this.debug = options.debug;
    }
  }, {
    key: "setDebug",
    value: function setDebug(bool) {
      this.debug = bool;
    }
  }, {
    key: "log",
    value: function log() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return this.forward(args, 'log', '', true);
    }
  }, {
    key: "warn",
    value: function warn() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return this.forward(args, 'warn', '', true);
    }
  }, {
    key: "error",
    value: function error() {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return this.forward(args, 'error', '');
    }
  }, {
    key: "deprecate",
    value: function deprecate() {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
    }
  }, {
    key: "forward",
    value: function forward(args, lvl, prefix, debugOnly) {
      if (debugOnly && !this.debug) return null;
      if (typeof args[0] === 'string') args[0] = "".concat(prefix).concat(this.prefix, " ").concat(args[0]);
      return this.logger[lvl](args);
    }
  }, {
    key: "create",
    value: function create(moduleName) {
      return new Logger(this.logger, _objectSpread$1({}, {
        prefix: "".concat(this.prefix, ":").concat(moduleName, ":")
      }, this.options));
    }
  }]);

  return Logger;
}();

var baseLogger = new Logger();

var EventEmitter = function () {
  function EventEmitter() {
    _classCallCheck(this, EventEmitter);

    this.observers = {};
  }

  _createClass(EventEmitter, [{
    key: "on",
    value: function on(events, listener) {
      var _this = this;

      events.split(' ').forEach(function (event) {
        _this.observers[event] = _this.observers[event] || [];

        _this.observers[event].push(listener);
      });
      return this;
    }
  }, {
    key: "off",
    value: function off(event, listener) {
      if (!this.observers[event]) return;

      if (!listener) {
        delete this.observers[event];
        return;
      }

      this.observers[event] = this.observers[event].filter(function (l) {
        return l !== listener;
      });
    }
  }, {
    key: "emit",
    value: function emit(event) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      if (this.observers[event]) {
        var cloned = [].concat(this.observers[event]);
        cloned.forEach(function (observer) {
          observer.apply(void 0, args);
        });
      }

      if (this.observers['*']) {
        var _cloned = [].concat(this.observers['*']);

        _cloned.forEach(function (observer) {
          observer.apply(observer, [event].concat(args));
        });
      }
    }
  }]);

  return EventEmitter;
}();

function defer() {
  var res;
  var rej;
  var promise = new Promise(function (resolve, reject) {
    res = resolve;
    rej = reject;
  });
  promise.resolve = res;
  promise.reject = rej;
  return promise;
}
function makeString(object) {
  if (object == null) return '';
  return '' + object;
}
function copy(a, s, t) {
  a.forEach(function (m) {
    if (s[m]) t[m] = s[m];
  });
}

function getLastOfPath(object, path, Empty) {
  function cleanKey(key) {
    return key && key.indexOf('###') > -1 ? key.replace(/###/g, '.') : key;
  }

  function canNotTraverseDeeper() {
    return !object || typeof object === 'string';
  }

  var stack = typeof path !== 'string' ? [].concat(path) : path.split('.');

  while (stack.length > 1) {
    if (canNotTraverseDeeper()) return {};
    var key = cleanKey(stack.shift());
    if (!object[key] && Empty) object[key] = new Empty();
    if (object.hasOwnProperty(key)) object = object[key];
  }

  if (canNotTraverseDeeper()) return {};
  return {
    obj: object,
    k: cleanKey(stack.shift())
  };
}

function setPath(object, path, newValue) {
  var _getLastOfPath = getLastOfPath(object, path, Object),
      obj = _getLastOfPath.obj,
      k = _getLastOfPath.k;

  obj[k] = newValue;
}
function pushPath(object, path, newValue, concat) {
  var _getLastOfPath2 = getLastOfPath(object, path, Object),
      obj = _getLastOfPath2.obj,
      k = _getLastOfPath2.k;

  obj[k] = obj[k] || [];
  if (concat) obj[k] = obj[k].concat(newValue);
  if (!concat) obj[k].push(newValue);
}
function getPath(object, path) {
  var _getLastOfPath3 = getLastOfPath(object, path),
      obj = _getLastOfPath3.obj,
      k = _getLastOfPath3.k;

  if (!obj) return undefined;
  return obj[k];
}
function getPathWithDefaults(data, defaultData, key) {
  var value = getPath(data, key);

  if (value !== undefined) {
    return value;
  }

  return getPath(defaultData, key);
}
function deepExtend(target, source, overwrite) {
  for (var prop in source) {
    if (prop !== '__proto__' && prop !== 'constructor') {
      if (prop in target) {
        if (typeof target[prop] === 'string' || target[prop] instanceof String || typeof source[prop] === 'string' || source[prop] instanceof String) {
          if (overwrite) target[prop] = source[prop];
        } else {
          deepExtend(target[prop], source[prop], overwrite);
        }
      } else {
        target[prop] = source[prop];
      }
    }
  }

  return target;
}
function regexEscape(str) {
  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
}
var _entityMap = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
  '/': '&#x2F;'
};
function escape$1(data) {
  if (typeof data === 'string') {
    return data.replace(/[&<>"'\/]/g, function (s) {
      return _entityMap[s];
    });
  }

  return data;
}
var isIE10 = typeof window !== 'undefined' && window.navigator && window.navigator.userAgent && window.navigator.userAgent.indexOf('MSIE') > -1;

var ResourceStore = function (_EventEmitter) {
  _inherits(ResourceStore, _EventEmitter);

  function ResourceStore(data) {
    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      ns: ['translation'],
      defaultNS: 'translation'
    };

    _classCallCheck(this, ResourceStore);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ResourceStore).call(this));

    if (isIE10) {
      EventEmitter.call(_assertThisInitialized(_this));
    }

    _this.data = data || {};
    _this.options = options;

    if (_this.options.keySeparator === undefined) {
      _this.options.keySeparator = '.';
    }

    return _this;
  }

  _createClass(ResourceStore, [{
    key: "addNamespaces",
    value: function addNamespaces(ns) {
      if (this.options.ns.indexOf(ns) < 0) {
        this.options.ns.push(ns);
      }
    }
  }, {
    key: "removeNamespaces",
    value: function removeNamespaces(ns) {
      var index = this.options.ns.indexOf(ns);

      if (index > -1) {
        this.options.ns.splice(index, 1);
      }
    }
  }, {
    key: "getResource",
    value: function getResource(lng, ns, key) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
      var path = [lng, ns];
      if (key && typeof key !== 'string') path = path.concat(key);
      if (key && typeof key === 'string') path = path.concat(keySeparator ? key.split(keySeparator) : key);

      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
      }

      return getPath(this.data, path);
    }
  }, {
    key: "addResource",
    value: function addResource(lng, ns, key, value) {
      var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
        silent: false
      };
      var keySeparator = this.options.keySeparator;
      if (keySeparator === undefined) keySeparator = '.';
      var path = [lng, ns];
      if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);

      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
        value = ns;
        ns = path[1];
      }

      this.addNamespaces(ns);
      setPath(this.data, path, value);
      if (!options.silent) this.emit('added', lng, ns, key, value);
    }
  }, {
    key: "addResources",
    value: function addResources(lng, ns, resources) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
        silent: false
      };

      for (var m in resources) {
        if (typeof resources[m] === 'string' || Object.prototype.toString.apply(resources[m]) === '[object Array]') this.addResource(lng, ns, m, resources[m], {
          silent: true
        });
      }

      if (!options.silent) this.emit('added', lng, ns, resources);
    }
  }, {
    key: "addResourceBundle",
    value: function addResourceBundle(lng, ns, resources, deep, overwrite) {
      var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
        silent: false
      };
      var path = [lng, ns];

      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
        deep = resources;
        resources = ns;
        ns = path[1];
      }

      this.addNamespaces(ns);
      var pack = getPath(this.data, path) || {};

      if (deep) {
        deepExtend(pack, resources, overwrite);
      } else {
        pack = _objectSpread$1({}, pack, resources);
      }

      setPath(this.data, path, pack);
      if (!options.silent) this.emit('added', lng, ns, resources);
    }
  }, {
    key: "removeResourceBundle",
    value: function removeResourceBundle(lng, ns) {
      if (this.hasResourceBundle(lng, ns)) {
        delete this.data[lng][ns];
      }

      this.removeNamespaces(ns);
      this.emit('removed', lng, ns);
    }
  }, {
    key: "hasResourceBundle",
    value: function hasResourceBundle(lng, ns) {
      return this.getResource(lng, ns) !== undefined;
    }
  }, {
    key: "getResourceBundle",
    value: function getResourceBundle(lng, ns) {
      if (!ns) ns = this.options.defaultNS;
      if (this.options.compatibilityAPI === 'v1') return _objectSpread$1({}, {}, this.getResource(lng, ns));
      return this.getResource(lng, ns);
    }
  }, {
    key: "getDataByLanguage",
    value: function getDataByLanguage(lng) {
      return this.data[lng];
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return this.data;
    }
  }]);

  return ResourceStore;
}(EventEmitter);

var postProcessor = {
  processors: {},
  addPostProcessor: function addPostProcessor(module) {
    this.processors[module.name] = module;
  },
  handle: function handle(processors, value, key, options, translator) {
    var _this = this;

    processors.forEach(function (processor) {
      if (_this.processors[processor]) value = _this.processors[processor].process(value, key, options, translator);
    });
    return value;
  }
};

var checkedLoadedFor = {};

var Translator = function (_EventEmitter) {
  _inherits(Translator, _EventEmitter);

  function Translator(services) {
    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Translator);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Translator).call(this));

    if (isIE10) {
      EventEmitter.call(_assertThisInitialized(_this));
    }

    copy(['resourceStore', 'languageUtils', 'pluralResolver', 'interpolator', 'backendConnector', 'i18nFormat', 'utils'], services, _assertThisInitialized(_this));
    _this.options = options;

    if (_this.options.keySeparator === undefined) {
      _this.options.keySeparator = '.';
    }

    _this.logger = baseLogger.create('translator');
    return _this;
  }

  _createClass(Translator, [{
    key: "changeLanguage",
    value: function changeLanguage(lng) {
      if (lng) this.language = lng;
    }
  }, {
    key: "exists",
    value: function exists(key) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        interpolation: {}
      };
      var resolved = this.resolve(key, options);
      return resolved && resolved.res !== undefined;
    }
  }, {
    key: "extractFromKey",
    value: function extractFromKey(key, options) {
      var nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
      if (nsSeparator === undefined) nsSeparator = ':';
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
      var namespaces = options.ns || this.options.defaultNS;

      if (nsSeparator && key.indexOf(nsSeparator) > -1) {
        var m = key.match(this.interpolator.nestingRegexp);

        if (m && m.length > 0) {
          return {
            key: key,
            namespaces: namespaces
          };
        }

        var parts = key.split(nsSeparator);
        if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
        key = parts.join(keySeparator);
      }

      if (typeof namespaces === 'string') namespaces = [namespaces];
      return {
        key: key,
        namespaces: namespaces
      };
    }
  }, {
    key: "translate",
    value: function translate(keys, options, lastKey) {
      var _this2 = this;

      if (_typeof$1(options) !== 'object' && this.options.overloadTranslationOptionHandler) {
        options = this.options.overloadTranslationOptionHandler(arguments);
      }

      if (!options) options = {};
      if (keys === undefined || keys === null) return '';
      if (!Array.isArray(keys)) keys = [String(keys)];
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;

      var _this$extractFromKey = this.extractFromKey(keys[keys.length - 1], options),
          key = _this$extractFromKey.key,
          namespaces = _this$extractFromKey.namespaces;

      var namespace = namespaces[namespaces.length - 1];
      var lng = options.lng || this.language;
      var appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;

      if (lng && lng.toLowerCase() === 'cimode') {
        if (appendNamespaceToCIMode) {
          var nsSeparator = options.nsSeparator || this.options.nsSeparator;
          return namespace + nsSeparator + key;
        }

        return key;
      }

      var resolved = this.resolve(keys, options);
      var res = resolved && resolved.res;
      var resUsedKey = resolved && resolved.usedKey || key;
      var resExactUsedKey = resolved && resolved.exactUsedKey || key;
      var resType = Object.prototype.toString.apply(res);
      var noObject = ['[object Number]', '[object Function]', '[object RegExp]'];
      var joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
      var handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
      var handleAsObject = typeof res !== 'string' && typeof res !== 'boolean' && typeof res !== 'number';

      if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(typeof joinArrays === 'string' && resType === '[object Array]')) {
        if (!options.returnObjects && !this.options.returnObjects) {
          this.logger.warn('accessing an object - but returnObjects options is not enabled!');
          return this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, options) : "key '".concat(key, " (").concat(this.language, ")' returned an object instead of string.");
        }

        if (keySeparator) {
          var resTypeIsArray = resType === '[object Array]';
          var copy = resTypeIsArray ? [] : {};
          var newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;

          for (var m in res) {
            if (Object.prototype.hasOwnProperty.call(res, m)) {
              var deepKey = "".concat(newKeyToUse).concat(keySeparator).concat(m);
              copy[m] = this.translate(deepKey, _objectSpread$1({}, options, {
                joinArrays: false,
                ns: namespaces
              }));
              if (copy[m] === deepKey) copy[m] = res[m];
            }
          }

          res = copy;
        }
      } else if (handleAsObjectInI18nFormat && typeof joinArrays === 'string' && resType === '[object Array]') {
        res = res.join(joinArrays);
        if (res) res = this.extendTranslation(res, keys, options, lastKey);
      } else {
        var usedDefault = false;
        var usedKey = false;

        if (!this.isValidLookup(res) && options.defaultValue !== undefined) {
          usedDefault = true;

          if (options.count !== undefined) {
            var suffix = this.pluralResolver.getSuffix(lng, options.count);
            res = options["defaultValue".concat(suffix)];
          }

          if (!res) res = options.defaultValue;
        }

        if (!this.isValidLookup(res)) {
          usedKey = true;
          res = key;
        }

        var updateMissing = options.defaultValue && options.defaultValue !== res && this.options.updateMissing;

        if (usedKey || usedDefault || updateMissing) {
          this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? options.defaultValue : res);

          if (keySeparator) {
            var fk = this.resolve(key, _objectSpread$1({}, options, {
              keySeparator: false
            }));
            if (fk && fk.res) this.logger.warn('Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.');
          }

          var lngs = [];
          var fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);

          if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) {
            for (var i = 0; i < fallbackLngs.length; i++) {
              lngs.push(fallbackLngs[i]);
            }
          } else if (this.options.saveMissingTo === 'all') {
            lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
          } else {
            lngs.push(options.lng || this.language);
          }

          var send = function send(l, k) {
            if (_this2.options.missingKeyHandler) {
              _this2.options.missingKeyHandler(l, namespace, k, updateMissing ? options.defaultValue : res, updateMissing, options);
            } else if (_this2.backendConnector && _this2.backendConnector.saveMissing) {
              _this2.backendConnector.saveMissing(l, namespace, k, updateMissing ? options.defaultValue : res, updateMissing, options);
            }

            _this2.emit('missingKey', l, namespace, k, res);
          };

          if (this.options.saveMissing) {
            var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';

            if (this.options.saveMissingPlurals && needsPluralHandling) {
              lngs.forEach(function (l) {
                var plurals = _this2.pluralResolver.getPluralFormsOfKey(l, key);

                plurals.forEach(function (p) {
                  return send([l], p);
                });
              });
            } else {
              send(lngs, key);
            }
          }
        }

        res = this.extendTranslation(res, keys, options, resolved, lastKey);
        if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = "".concat(namespace, ":").concat(key);
        if (usedKey && this.options.parseMissingKeyHandler) res = this.options.parseMissingKeyHandler(res);
      }

      return res;
    }
  }, {
    key: "extendTranslation",
    value: function extendTranslation(res, key, options, resolved, lastKey) {
      var _this3 = this;

      if (this.i18nFormat && this.i18nFormat.parse) {
        res = this.i18nFormat.parse(res, options, resolved.usedLng, resolved.usedNS, resolved.usedKey, {
          resolved: resolved
        });
      } else if (!options.skipInterpolation) {
        if (options.interpolation) this.interpolator.init(_objectSpread$1({}, options, {
          interpolation: _objectSpread$1({}, this.options.interpolation, options.interpolation)
        }));
        var skipOnVariables = options.interpolation && options.interpolation.skipOnVariables || this.options.interpolation.skipOnVariables;
        var nestBef;

        if (skipOnVariables) {
          var nb = res.match(this.interpolator.nestingRegexp);
          nestBef = nb && nb.length;
        }

        var data = options.replace && typeof options.replace !== 'string' ? options.replace : options;
        if (this.options.interpolation.defaultVariables) data = _objectSpread$1({}, this.options.interpolation.defaultVariables, data);
        res = this.interpolator.interpolate(res, data, options.lng || this.language, options);

        if (skipOnVariables) {
          var na = res.match(this.interpolator.nestingRegexp);
          var nestAft = na && na.length;
          if (nestBef < nestAft) options.nest = false;
        }

        if (options.nest !== false) res = this.interpolator.nest(res, function () {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          if (lastKey && lastKey[0] === args[0] && !options.context) {
            _this3.logger.warn("It seems you are nesting recursively key: ".concat(args[0], " in key: ").concat(key[0]));

            return null;
          }

          return _this3.translate.apply(_this3, args.concat([key]));
        }, options);
        if (options.interpolation) this.interpolator.reset();
      }

      var postProcess = options.postProcess || this.options.postProcess;
      var postProcessorNames = typeof postProcess === 'string' ? [postProcess] : postProcess;

      if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) {
        res = postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? _objectSpread$1({
          i18nResolved: resolved
        }, options) : options, this);
      }

      return res;
    }
  }, {
    key: "resolve",
    value: function resolve(keys) {
      var _this4 = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var found;
      var usedKey;
      var exactUsedKey;
      var usedLng;
      var usedNS;
      if (typeof keys === 'string') keys = [keys];
      keys.forEach(function (k) {
        if (_this4.isValidLookup(found)) return;

        var extracted = _this4.extractFromKey(k, options);

        var key = extracted.key;
        usedKey = key;
        var namespaces = extracted.namespaces;
        if (_this4.options.fallbackNS) namespaces = namespaces.concat(_this4.options.fallbackNS);
        var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
        var needsContextHandling = options.context !== undefined && typeof options.context === 'string' && options.context !== '';
        var codes = options.lngs ? options.lngs : _this4.languageUtils.toResolveHierarchy(options.lng || _this4.language, options.fallbackLng);
        namespaces.forEach(function (ns) {
          if (_this4.isValidLookup(found)) return;
          usedNS = ns;

          if (!checkedLoadedFor["".concat(codes[0], "-").concat(ns)] && _this4.utils && _this4.utils.hasLoadedNamespace && !_this4.utils.hasLoadedNamespace(usedNS)) {
            checkedLoadedFor["".concat(codes[0], "-").concat(ns)] = true;

            _this4.logger.warn("key \"".concat(usedKey, "\" for languages \"").concat(codes.join(', '), "\" won't get resolved as namespace \"").concat(usedNS, "\" was not yet loaded"), 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
          }

          codes.forEach(function (code) {
            if (_this4.isValidLookup(found)) return;
            usedLng = code;
            var finalKey = key;
            var finalKeys = [finalKey];

            if (_this4.i18nFormat && _this4.i18nFormat.addLookupKeys) {
              _this4.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
            } else {
              var pluralSuffix;
              if (needsPluralHandling) pluralSuffix = _this4.pluralResolver.getSuffix(code, options.count);
              if (needsPluralHandling && needsContextHandling) finalKeys.push(finalKey + pluralSuffix);
              if (needsContextHandling) finalKeys.push(finalKey += "".concat(_this4.options.contextSeparator).concat(options.context));
              if (needsPluralHandling) finalKeys.push(finalKey += pluralSuffix);
            }

            var possibleKey;

            while (possibleKey = finalKeys.pop()) {
              if (!_this4.isValidLookup(found)) {
                exactUsedKey = possibleKey;
                found = _this4.getResource(code, ns, possibleKey, options);
              }
            }
          });
        });
      });
      return {
        res: found,
        usedKey: usedKey,
        exactUsedKey: exactUsedKey,
        usedLng: usedLng,
        usedNS: usedNS
      };
    }
  }, {
    key: "isValidLookup",
    value: function isValidLookup(res) {
      return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
    }
  }, {
    key: "getResource",
    value: function getResource(code, ns, key) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
      return this.resourceStore.getResource(code, ns, key, options);
    }
  }]);

  return Translator;
}(EventEmitter);

function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

var LanguageUtil = function () {
  function LanguageUtil(options) {
    _classCallCheck(this, LanguageUtil);

    this.options = options;
    this.whitelist = this.options.supportedLngs || false;
    this.supportedLngs = this.options.supportedLngs || false;
    this.logger = baseLogger.create('languageUtils');
  }

  _createClass(LanguageUtil, [{
    key: "getScriptPartFromCode",
    value: function getScriptPartFromCode(code) {
      if (!code || code.indexOf('-') < 0) return null;
      var p = code.split('-');
      if (p.length === 2) return null;
      p.pop();
      if (p[p.length - 1].toLowerCase() === 'x') return null;
      return this.formatLanguageCode(p.join('-'));
    }
  }, {
    key: "getLanguagePartFromCode",
    value: function getLanguagePartFromCode(code) {
      if (!code || code.indexOf('-') < 0) return code;
      var p = code.split('-');
      return this.formatLanguageCode(p[0]);
    }
  }, {
    key: "formatLanguageCode",
    value: function formatLanguageCode(code) {
      if (typeof code === 'string' && code.indexOf('-') > -1) {
        var specialCases = ['hans', 'hant', 'latn', 'cyrl', 'cans', 'mong', 'arab'];
        var p = code.split('-');

        if (this.options.lowerCaseLng) {
          p = p.map(function (part) {
            return part.toLowerCase();
          });
        } else if (p.length === 2) {
          p[0] = p[0].toLowerCase();
          p[1] = p[1].toUpperCase();
          if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
        } else if (p.length === 3) {
          p[0] = p[0].toLowerCase();
          if (p[1].length === 2) p[1] = p[1].toUpperCase();
          if (p[0] !== 'sgn' && p[2].length === 2) p[2] = p[2].toUpperCase();
          if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
          if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = capitalize(p[2].toLowerCase());
        }

        return p.join('-');
      }

      return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
    }
  }, {
    key: "isWhitelisted",
    value: function isWhitelisted(code) {
      this.logger.deprecate('languageUtils.isWhitelisted', 'function "isWhitelisted" will be renamed to "isSupportedCode" in the next major - please make sure to rename it\'s usage asap.');
      return this.isSupportedCode(code);
    }
  }, {
    key: "isSupportedCode",
    value: function isSupportedCode(code) {
      if (this.options.load === 'languageOnly' || this.options.nonExplicitSupportedLngs) {
        code = this.getLanguagePartFromCode(code);
      }

      return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
    }
  }, {
    key: "getBestMatchFromCodes",
    value: function getBestMatchFromCodes(codes) {
      var _this = this;

      if (!codes) return null;
      var found;
      codes.forEach(function (code) {
        if (found) return;

        var cleanedLng = _this.formatLanguageCode(code);

        if (!_this.options.supportedLngs || _this.isSupportedCode(cleanedLng)) found = cleanedLng;
      });

      if (!found && this.options.supportedLngs) {
        codes.forEach(function (code) {
          if (found) return;

          var lngOnly = _this.getLanguagePartFromCode(code);

          if (_this.isSupportedCode(lngOnly)) return found = lngOnly;
          found = _this.options.supportedLngs.find(function (supportedLng) {
            if (supportedLng.indexOf(lngOnly) === 0) return supportedLng;
          });
        });
      }

      if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
      return found;
    }
  }, {
    key: "getFallbackCodes",
    value: function getFallbackCodes(fallbacks, code) {
      if (!fallbacks) return [];
      if (typeof fallbacks === 'function') fallbacks = fallbacks(code);
      if (typeof fallbacks === 'string') fallbacks = [fallbacks];
      if (Object.prototype.toString.apply(fallbacks) === '[object Array]') return fallbacks;
      if (!code) return fallbacks["default"] || [];
      var found = fallbacks[code];
      if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
      if (!found) found = fallbacks[this.formatLanguageCode(code)];
      if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
      if (!found) found = fallbacks["default"];
      return found || [];
    }
  }, {
    key: "toResolveHierarchy",
    value: function toResolveHierarchy(code, fallbackCode) {
      var _this2 = this;

      var fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
      var codes = [];

      var addCode = function addCode(c) {
        if (!c) return;

        if (_this2.isSupportedCode(c)) {
          codes.push(c);
        } else {
          _this2.logger.warn("rejecting language code not found in supportedLngs: ".concat(c));
        }
      };

      if (typeof code === 'string' && code.indexOf('-') > -1) {
        if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
        if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
        if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
      } else if (typeof code === 'string') {
        addCode(this.formatLanguageCode(code));
      }

      fallbackCodes.forEach(function (fc) {
        if (codes.indexOf(fc) < 0) addCode(_this2.formatLanguageCode(fc));
      });
      return codes;
    }
  }]);

  return LanguageUtil;
}();

var sets = [{
  lngs: ['ach', 'ak', 'am', 'arn', 'br', 'fil', 'gun', 'ln', 'mfe', 'mg', 'mi', 'oc', 'pt', 'pt-BR', 'tg', 'ti', 'tr', 'uz', 'wa'],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ['af', 'an', 'ast', 'az', 'bg', 'bn', 'ca', 'da', 'de', 'dev', 'el', 'en', 'eo', 'es', 'et', 'eu', 'fi', 'fo', 'fur', 'fy', 'gl', 'gu', 'ha', 'hi', 'hu', 'hy', 'ia', 'it', 'kn', 'ku', 'lb', 'mai', 'ml', 'mn', 'mr', 'nah', 'nap', 'nb', 'ne', 'nl', 'nn', 'no', 'nso', 'pa', 'pap', 'pms', 'ps', 'pt-PT', 'rm', 'sco', 'se', 'si', 'so', 'son', 'sq', 'sv', 'sw', 'ta', 'te', 'tk', 'ur', 'yo'],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ['ay', 'bo', 'cgg', 'fa', 'ht', 'id', 'ja', 'jbo', 'ka', 'kk', 'km', 'ko', 'ky', 'lo', 'ms', 'sah', 'su', 'th', 'tt', 'ug', 'vi', 'wo', 'zh'],
  nr: [1],
  fc: 3
}, {
  lngs: ['be', 'bs', 'cnr', 'dz', 'hr', 'ru', 'sr', 'uk'],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ['ar'],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ['cs', 'sk'],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ['csb', 'pl'],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ['cy'],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ['fr'],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ['ga'],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ['gd'],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ['is'],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ['jv'],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ['kw'],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ['lt'],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ['lv'],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ['mk'],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ['mnk'],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ['mt'],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ['or'],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ['ro'],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ['sl'],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ['he', 'iw'],
  nr: [1, 2, 20, 21],
  fc: 22
}];
var _rulesPluralsTypes = {
  1: function _(n) {
    return Number(n > 1);
  },
  2: function _(n) {
    return Number(n != 1);
  },
  3: function _(n) {
    return 0;
  },
  4: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  5: function _(n) {
    return Number(n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
  },
  6: function _(n) {
    return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
  },
  7: function _(n) {
    return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  8: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
  },
  9: function _(n) {
    return Number(n >= 2);
  },
  10: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
  },
  11: function _(n) {
    return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
  },
  12: function _(n) {
    return Number(n % 10 != 1 || n % 100 == 11);
  },
  13: function _(n) {
    return Number(n !== 0);
  },
  14: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
  },
  15: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  16: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
  },
  17: function _(n) {
    return Number(n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1);
  },
  18: function _(n) {
    return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
  },
  19: function _(n) {
    return Number(n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
  },
  20: function _(n) {
    return Number(n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
  },
  21: function _(n) {
    return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
  },
  22: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3);
  }
};

function createRules() {
  var rules = {};
  sets.forEach(function (set) {
    set.lngs.forEach(function (l) {
      rules[l] = {
        numbers: set.nr,
        plurals: _rulesPluralsTypes[set.fc]
      };
    });
  });
  return rules;
}

var PluralResolver = function () {
  function PluralResolver(languageUtils) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, PluralResolver);

    this.languageUtils = languageUtils;
    this.options = options;
    this.logger = baseLogger.create('pluralResolver');
    this.rules = createRules();
  }

  _createClass(PluralResolver, [{
    key: "addRule",
    value: function addRule(lng, obj) {
      this.rules[lng] = obj;
    }
  }, {
    key: "getRule",
    value: function getRule(code) {
      return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
    }
  }, {
    key: "needsPlural",
    value: function needsPlural(code) {
      var rule = this.getRule(code);
      return rule && rule.numbers.length > 1;
    }
  }, {
    key: "getPluralFormsOfKey",
    value: function getPluralFormsOfKey(code, key) {
      var _this = this;

      var ret = [];
      var rule = this.getRule(code);
      if (!rule) return ret;
      rule.numbers.forEach(function (n) {
        var suffix = _this.getSuffix(code, n);

        ret.push("".concat(key).concat(suffix));
      });
      return ret;
    }
  }, {
    key: "getSuffix",
    value: function getSuffix(code, count) {
      var _this2 = this;

      var rule = this.getRule(code);

      if (rule) {
        var idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
        var suffix = rule.numbers[idx];

        if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
          if (suffix === 2) {
            suffix = 'plural';
          } else if (suffix === 1) {
            suffix = '';
          }
        }

        var returnSuffix = function returnSuffix() {
          return _this2.options.prepend && suffix.toString() ? _this2.options.prepend + suffix.toString() : suffix.toString();
        };

        if (this.options.compatibilityJSON === 'v1') {
          if (suffix === 1) return '';
          if (typeof suffix === 'number') return "_plural_".concat(suffix.toString());
          return returnSuffix();
        } else if (this.options.compatibilityJSON === 'v2') {
          return returnSuffix();
        } else if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
          return returnSuffix();
        }

        return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
      }

      this.logger.warn("no plural rule found for: ".concat(code));
      return '';
    }
  }]);

  return PluralResolver;
}();

var Interpolator = function () {
  function Interpolator() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Interpolator);

    this.logger = baseLogger.create('interpolator');
    this.options = options;

    this.format = options.interpolation && options.interpolation.format || function (value) {
      return value;
    };

    this.init(options);
  }

  _createClass(Interpolator, [{
    key: "init",
    value: function init() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (!options.interpolation) options.interpolation = {
        escapeValue: true
      };
      var iOpts = options.interpolation;
      this.escape = iOpts.escape !== undefined ? iOpts.escape : escape$1;
      this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;
      this.useRawValueToEscape = iOpts.useRawValueToEscape !== undefined ? iOpts.useRawValueToEscape : false;
      this.prefix = iOpts.prefix ? regexEscape(iOpts.prefix) : iOpts.prefixEscaped || '{{';
      this.suffix = iOpts.suffix ? regexEscape(iOpts.suffix) : iOpts.suffixEscaped || '}}';
      this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';
      this.unescapePrefix = iOpts.unescapeSuffix ? '' : iOpts.unescapePrefix || '-';
      this.unescapeSuffix = this.unescapePrefix ? '' : iOpts.unescapeSuffix || '';
      this.nestingPrefix = iOpts.nestingPrefix ? regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || regexEscape('$t(');
      this.nestingSuffix = iOpts.nestingSuffix ? regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || regexEscape(')');
      this.nestingOptionsSeparator = iOpts.nestingOptionsSeparator ? iOpts.nestingOptionsSeparator : iOpts.nestingOptionsSeparator || ',';
      this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000;
      this.alwaysFormat = iOpts.alwaysFormat !== undefined ? iOpts.alwaysFormat : false;
      this.resetRegExp();
    }
  }, {
    key: "reset",
    value: function reset() {
      if (this.options) this.init(this.options);
    }
  }, {
    key: "resetRegExp",
    value: function resetRegExp() {
      var regexpStr = "".concat(this.prefix, "(.+?)").concat(this.suffix);
      this.regexp = new RegExp(regexpStr, 'g');
      var regexpUnescapeStr = "".concat(this.prefix).concat(this.unescapePrefix, "(.+?)").concat(this.unescapeSuffix).concat(this.suffix);
      this.regexpUnescape = new RegExp(regexpUnescapeStr, 'g');
      var nestingRegexpStr = "".concat(this.nestingPrefix, "(.+?)").concat(this.nestingSuffix);
      this.nestingRegexp = new RegExp(nestingRegexpStr, 'g');
    }
  }, {
    key: "interpolate",
    value: function interpolate(str, data, lng, options) {
      var _this = this;

      var match;
      var value;
      var replaces;
      var defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};

      function regexSafe(val) {
        return val.replace(/\$/g, '$$$$');
      }

      var handleFormat = function handleFormat(key) {
        if (key.indexOf(_this.formatSeparator) < 0) {
          var path = getPathWithDefaults(data, defaultData, key);
          return _this.alwaysFormat ? _this.format(path, undefined, lng) : path;
        }

        var p = key.split(_this.formatSeparator);
        var k = p.shift().trim();
        var f = p.join(_this.formatSeparator).trim();
        return _this.format(getPathWithDefaults(data, defaultData, k), f, lng, options);
      };

      this.resetRegExp();
      var missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
      var skipOnVariables = options && options.interpolation && options.interpolation.skipOnVariables || this.options.interpolation.skipOnVariables;
      var todos = [{
        regex: this.regexpUnescape,
        safeValue: function safeValue(val) {
          return regexSafe(val);
        }
      }, {
        regex: this.regexp,
        safeValue: function safeValue(val) {
          return _this.escapeValue ? regexSafe(_this.escape(val)) : regexSafe(val);
        }
      }];
      todos.forEach(function (todo) {
        replaces = 0;

        while (match = todo.regex.exec(str)) {
          value = handleFormat(match[1].trim());

          if (value === undefined) {
            if (typeof missingInterpolationHandler === 'function') {
              var temp = missingInterpolationHandler(str, match, options);
              value = typeof temp === 'string' ? temp : '';
            } else if (skipOnVariables) {
              value = match[0];
              continue;
            } else {
              _this.logger.warn("missed to pass in variable ".concat(match[1], " for interpolating ").concat(str));

              value = '';
            }
          } else if (typeof value !== 'string' && !_this.useRawValueToEscape) {
            value = makeString(value);
          }

          str = str.replace(match[0], todo.safeValue(value));
          todo.regex.lastIndex = 0;
          replaces++;

          if (replaces >= _this.maxReplaces) {
            break;
          }
        }
      });
      return str;
    }
  }, {
    key: "nest",
    value: function nest(str, fc) {
      var _this2 = this;

      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var match;
      var value;

      var clonedOptions = _objectSpread$1({}, options);

      clonedOptions.applyPostProcessor = false;
      delete clonedOptions.defaultValue;

      function handleHasOptions(key, inheritedOptions) {
        var sep = this.nestingOptionsSeparator;
        if (key.indexOf(sep) < 0) return key;
        var c = key.split(new RegExp("".concat(sep, "[ ]*{")));
        var optionsString = "{".concat(c[1]);
        key = c[0];
        optionsString = this.interpolate(optionsString, clonedOptions);
        optionsString = optionsString.replace(/'/g, '"');

        try {
          clonedOptions = JSON.parse(optionsString);
          if (inheritedOptions) clonedOptions = _objectSpread$1({}, inheritedOptions, clonedOptions);
        } catch (e) {
          this.logger.warn("failed parsing options string in nesting for key ".concat(key), e);
          return "".concat(key).concat(sep).concat(optionsString);
        }

        delete clonedOptions.defaultValue;
        return key;
      }

      while (match = this.nestingRegexp.exec(str)) {
        var formatters = [];
        var doReduce = false;

        if (match[0].includes(this.formatSeparator) && !/{.*}/.test(match[1])) {
          var r = match[1].split(this.formatSeparator).map(function (elem) {
            return elem.trim();
          });
          match[1] = r.shift();
          formatters = r;
          doReduce = true;
        }

        value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
        if (value && match[0] === str && typeof value !== 'string') return value;
        if (typeof value !== 'string') value = makeString(value);

        if (!value) {
          this.logger.warn("missed to resolve ".concat(match[1], " for nesting ").concat(str));
          value = '';
        }

        if (doReduce) {
          value = formatters.reduce(function (v, f) {
            return _this2.format(v, f, options.lng, options);
          }, value.trim());
        }

        str = str.replace(match[0], value);
        this.regexp.lastIndex = 0;
      }

      return str;
    }
  }]);

  return Interpolator;
}();

function remove(arr, what) {
  var found = arr.indexOf(what);

  while (found !== -1) {
    arr.splice(found, 1);
    found = arr.indexOf(what);
  }
}

var Connector = function (_EventEmitter) {
  _inherits(Connector, _EventEmitter);

  function Connector(backend, store, services) {
    var _this;

    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    _classCallCheck(this, Connector);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Connector).call(this));

    if (isIE10) {
      EventEmitter.call(_assertThisInitialized(_this));
    }

    _this.backend = backend;
    _this.store = store;
    _this.services = services;
    _this.languageUtils = services.languageUtils;
    _this.options = options;
    _this.logger = baseLogger.create('backendConnector');
    _this.state = {};
    _this.queue = [];

    if (_this.backend && _this.backend.init) {
      _this.backend.init(services, options.backend, options);
    }

    return _this;
  }

  _createClass(Connector, [{
    key: "queueLoad",
    value: function queueLoad(languages, namespaces, options, callback) {
      var _this2 = this;

      var toLoad = [];
      var pending = [];
      var toLoadLanguages = [];
      var toLoadNamespaces = [];
      languages.forEach(function (lng) {
        var hasAllNamespaces = true;
        namespaces.forEach(function (ns) {
          var name = "".concat(lng, "|").concat(ns);

          if (!options.reload && _this2.store.hasResourceBundle(lng, ns)) {
            _this2.state[name] = 2;
          } else if (_this2.state[name] < 0) ; else if (_this2.state[name] === 1) {
            if (pending.indexOf(name) < 0) pending.push(name);
          } else {
            _this2.state[name] = 1;
            hasAllNamespaces = false;
            if (pending.indexOf(name) < 0) pending.push(name);
            if (toLoad.indexOf(name) < 0) toLoad.push(name);
            if (toLoadNamespaces.indexOf(ns) < 0) toLoadNamespaces.push(ns);
          }
        });
        if (!hasAllNamespaces) toLoadLanguages.push(lng);
      });

      if (toLoad.length || pending.length) {
        this.queue.push({
          pending: pending,
          loaded: {},
          errors: [],
          callback: callback
        });
      }

      return {
        toLoad: toLoad,
        pending: pending,
        toLoadLanguages: toLoadLanguages,
        toLoadNamespaces: toLoadNamespaces
      };
    }
  }, {
    key: "loaded",
    value: function loaded(name, err, data) {
      var s = name.split('|');
      var lng = s[0];
      var ns = s[1];
      if (err) this.emit('failedLoading', lng, ns, err);

      if (data) {
        this.store.addResourceBundle(lng, ns, data);
      }

      this.state[name] = err ? -1 : 2;
      var loaded = {};
      this.queue.forEach(function (q) {
        pushPath(q.loaded, [lng], ns);
        remove(q.pending, name);
        if (err) q.errors.push(err);

        if (q.pending.length === 0 && !q.done) {
          Object.keys(q.loaded).forEach(function (l) {
            if (!loaded[l]) loaded[l] = [];

            if (q.loaded[l].length) {
              q.loaded[l].forEach(function (ns) {
                if (loaded[l].indexOf(ns) < 0) loaded[l].push(ns);
              });
            }
          });
          q.done = true;

          if (q.errors.length) {
            q.callback(q.errors);
          } else {
            q.callback();
          }
        }
      });
      this.emit('loaded', loaded);
      this.queue = this.queue.filter(function (q) {
        return !q.done;
      });
    }
  }, {
    key: "read",
    value: function read(lng, ns, fcName) {
      var _this3 = this;

      var tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      var wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 350;
      var callback = arguments.length > 5 ? arguments[5] : undefined;
      if (!lng.length) return callback(null, {});
      return this.backend[fcName](lng, ns, function (err, data) {
        if (err && data && tried < 5) {
          setTimeout(function () {
            _this3.read.call(_this3, lng, ns, fcName, tried + 1, wait * 2, callback);
          }, wait);
          return;
        }

        callback(err, data);
      });
    }
  }, {
    key: "prepareLoading",
    value: function prepareLoading(languages, namespaces) {
      var _this4 = this;

      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var callback = arguments.length > 3 ? arguments[3] : undefined;

      if (!this.backend) {
        this.logger.warn('No backend was added via i18next.use. Will not load resources.');
        return callback && callback();
      }

      if (typeof languages === 'string') languages = this.languageUtils.toResolveHierarchy(languages);
      if (typeof namespaces === 'string') namespaces = [namespaces];
      var toLoad = this.queueLoad(languages, namespaces, options, callback);

      if (!toLoad.toLoad.length) {
        if (!toLoad.pending.length) callback();
        return null;
      }

      toLoad.toLoad.forEach(function (name) {
        _this4.loadOne(name);
      });
    }
  }, {
    key: "load",
    value: function load(languages, namespaces, callback) {
      this.prepareLoading(languages, namespaces, {}, callback);
    }
  }, {
    key: "reload",
    value: function reload(languages, namespaces, callback) {
      this.prepareLoading(languages, namespaces, {
        reload: true
      }, callback);
    }
  }, {
    key: "loadOne",
    value: function loadOne(name) {
      var _this5 = this;

      var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var s = name.split('|');
      var lng = s[0];
      var ns = s[1];
      this.read(lng, ns, 'read', undefined, undefined, function (err, data) {
        if (err) _this5.logger.warn("".concat(prefix, "loading namespace ").concat(ns, " for language ").concat(lng, " failed"), err);
        if (!err && data) _this5.logger.log("".concat(prefix, "loaded namespace ").concat(ns, " for language ").concat(lng), data);

        _this5.loaded(name, err, data);
      });
    }
  }, {
    key: "saveMissing",
    value: function saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
      var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};

      if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
        this.logger.warn("did not save key \"".concat(key, "\" as the namespace \"").concat(namespace, "\" was not yet loaded"), 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
        return;
      }

      if (key === undefined || key === null || key === '') return;

      if (this.backend && this.backend.create) {
        this.backend.create(languages, namespace, key, fallbackValue, null, _objectSpread$1({}, options, {
          isUpdate: isUpdate
        }));
      }

      if (!languages || !languages[0]) return;
      this.store.addResource(languages[0], namespace, key, fallbackValue);
    }
  }]);

  return Connector;
}(EventEmitter);

function get() {
  return {
    debug: false,
    initImmediate: true,
    ns: ['translation'],
    defaultNS: ['translation'],
    fallbackLng: ['dev'],
    fallbackNS: false,
    whitelist: false,
    nonExplicitWhitelist: false,
    supportedLngs: false,
    nonExplicitSupportedLngs: false,
    load: 'all',
    preload: false,
    simplifyPluralSuffix: true,
    keySeparator: '.',
    nsSeparator: ':',
    pluralSeparator: '_',
    contextSeparator: '_',
    partialBundledLanguages: false,
    saveMissing: false,
    updateMissing: false,
    saveMissingTo: 'fallback',
    saveMissingPlurals: true,
    missingKeyHandler: false,
    missingInterpolationHandler: false,
    postProcess: false,
    postProcessPassResolved: false,
    returnNull: true,
    returnEmptyString: true,
    returnObjects: false,
    joinArrays: false,
    returnedObjectHandler: false,
    parseMissingKeyHandler: false,
    appendNamespaceToMissingKey: false,
    appendNamespaceToCIMode: false,
    overloadTranslationOptionHandler: function handle(args) {
      var ret = {};
      if (_typeof$1(args[1]) === 'object') ret = args[1];
      if (typeof args[1] === 'string') ret.defaultValue = args[1];
      if (typeof args[2] === 'string') ret.tDescription = args[2];

      if (_typeof$1(args[2]) === 'object' || _typeof$1(args[3]) === 'object') {
        var options = args[3] || args[2];
        Object.keys(options).forEach(function (key) {
          ret[key] = options[key];
        });
      }

      return ret;
    },
    interpolation: {
      escapeValue: true,
      format: function format(value, _format, lng, options) {
        return value;
      },
      prefix: '{{',
      suffix: '}}',
      formatSeparator: ',',
      unescapePrefix: '-',
      nestingPrefix: '$t(',
      nestingSuffix: ')',
      nestingOptionsSeparator: ',',
      maxReplaces: 1000,
      skipOnVariables: false
    }
  };
}
function transformOptions(options) {
  if (typeof options.ns === 'string') options.ns = [options.ns];
  if (typeof options.fallbackLng === 'string') options.fallbackLng = [options.fallbackLng];
  if (typeof options.fallbackNS === 'string') options.fallbackNS = [options.fallbackNS];

  if (options.whitelist) {
    if (options.whitelist && options.whitelist.indexOf('cimode') < 0) {
      options.whitelist = options.whitelist.concat(['cimode']);
    }

    options.supportedLngs = options.whitelist;
  }

  if (options.nonExplicitWhitelist) {
    options.nonExplicitSupportedLngs = options.nonExplicitWhitelist;
  }

  if (options.supportedLngs && options.supportedLngs.indexOf('cimode') < 0) {
    options.supportedLngs = options.supportedLngs.concat(['cimode']);
  }

  return options;
}

function noop() {}

var I18n = function (_EventEmitter) {
  _inherits(I18n, _EventEmitter);

  function I18n() {
    var _this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments.length > 1 ? arguments[1] : undefined;

    _classCallCheck(this, I18n);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(I18n).call(this));

    if (isIE10) {
      EventEmitter.call(_assertThisInitialized(_this));
    }

    _this.options = transformOptions(options);
    _this.services = {};
    _this.logger = baseLogger;
    _this.modules = {
      external: []
    };

    if (callback && !_this.isInitialized && !options.isClone) {
      if (!_this.options.initImmediate) {
        _this.init(options, callback);

        return _possibleConstructorReturn(_this, _assertThisInitialized(_this));
      }

      setTimeout(function () {
        _this.init(options, callback);
      }, 0);
    }

    return _this;
  }

  _createClass(I18n, [{
    key: "init",
    value: function init() {
      var _this2 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 ? arguments[1] : undefined;

      if (typeof options === 'function') {
        callback = options;
        options = {};
      }

      if (options.whitelist && !options.supportedLngs) {
        this.logger.deprecate('whitelist', 'option "whitelist" will be renamed to "supportedLngs" in the next major - please make sure to rename this option asap.');
      }

      if (options.nonExplicitWhitelist && !options.nonExplicitSupportedLngs) {
        this.logger.deprecate('whitelist', 'options "nonExplicitWhitelist" will be renamed to "nonExplicitSupportedLngs" in the next major - please make sure to rename this option asap.');
      }

      this.options = _objectSpread$1({}, get(), this.options, transformOptions(options));
      this.format = this.options.interpolation.format;
      if (!callback) callback = noop;

      function createClassOnDemand(ClassOrObject) {
        if (!ClassOrObject) return null;
        if (typeof ClassOrObject === 'function') return new ClassOrObject();
        return ClassOrObject;
      }

      if (!this.options.isClone) {
        if (this.modules.logger) {
          baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
        } else {
          baseLogger.init(null, this.options);
        }

        var lu = new LanguageUtil(this.options);
        this.store = new ResourceStore(this.options.resources, this.options);
        var s = this.services;
        s.logger = baseLogger;
        s.resourceStore = this.store;
        s.languageUtils = lu;
        s.pluralResolver = new PluralResolver(lu, {
          prepend: this.options.pluralSeparator,
          compatibilityJSON: this.options.compatibilityJSON,
          simplifyPluralSuffix: this.options.simplifyPluralSuffix
        });
        s.interpolator = new Interpolator(this.options);
        s.utils = {
          hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
        };
        s.backendConnector = new Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
        s.backendConnector.on('*', function (event) {
          for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }

          _this2.emit.apply(_this2, [event].concat(args));
        });

        if (this.modules.languageDetector) {
          s.languageDetector = createClassOnDemand(this.modules.languageDetector);
          s.languageDetector.init(s, this.options.detection, this.options);
        }

        if (this.modules.i18nFormat) {
          s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
          if (s.i18nFormat.init) s.i18nFormat.init(this);
        }

        this.translator = new Translator(this.services, this.options);
        this.translator.on('*', function (event) {
          for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }

          _this2.emit.apply(_this2, [event].concat(args));
        });
        this.modules.external.forEach(function (m) {
          if (m.init) m.init(_this2);
        });
      }

      if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
        var codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
        if (codes.length > 0 && codes[0] !== 'dev') this.options.lng = codes[0];
      }

      if (!this.services.languageDetector && !this.options.lng) {
        this.logger.warn('init: no languageDetector is used and no lng is defined');
      }

      var storeApi = ['getResource', 'hasResourceBundle', 'getResourceBundle', 'getDataByLanguage'];
      storeApi.forEach(function (fcName) {
        _this2[fcName] = function () {
          var _this2$store;

          return (_this2$store = _this2.store)[fcName].apply(_this2$store, arguments);
        };
      });
      var storeApiChained = ['addResource', 'addResources', 'addResourceBundle', 'removeResourceBundle'];
      storeApiChained.forEach(function (fcName) {
        _this2[fcName] = function () {
          var _this2$store2;

          (_this2$store2 = _this2.store)[fcName].apply(_this2$store2, arguments);

          return _this2;
        };
      });
      var deferred = defer();

      var load = function load() {
        _this2.changeLanguage(_this2.options.lng, function (err, t) {
          _this2.isInitialized = true;
          if (!_this2.options.isClone) _this2.logger.log('initialized', _this2.options);

          _this2.emit('initialized', _this2.options);

          deferred.resolve(t);
          callback(err, t);
        });
      };

      if (this.options.resources || !this.options.initImmediate) {
        load();
      } else {
        setTimeout(load, 0);
      }

      return deferred;
    }
  }, {
    key: "loadResources",
    value: function loadResources(language) {
      var _this3 = this;

      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
      var usedCallback = callback;
      var usedLng = typeof language === 'string' ? language : this.language;
      if (typeof language === 'function') usedCallback = language;

      if (!this.options.resources || this.options.partialBundledLanguages) {
        if (usedLng && usedLng.toLowerCase() === 'cimode') return usedCallback();
        var toLoad = [];

        var append = function append(lng) {
          if (!lng) return;

          var lngs = _this3.services.languageUtils.toResolveHierarchy(lng);

          lngs.forEach(function (l) {
            if (toLoad.indexOf(l) < 0) toLoad.push(l);
          });
        };

        if (!usedLng) {
          var fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
          fallbacks.forEach(function (l) {
            return append(l);
          });
        } else {
          append(usedLng);
        }

        if (this.options.preload) {
          this.options.preload.forEach(function (l) {
            return append(l);
          });
        }

        this.services.backendConnector.load(toLoad, this.options.ns, usedCallback);
      } else {
        usedCallback(null);
      }
    }
  }, {
    key: "reloadResources",
    value: function reloadResources(lngs, ns, callback) {
      var deferred = defer();
      if (!lngs) lngs = this.languages;
      if (!ns) ns = this.options.ns;
      if (!callback) callback = noop;
      this.services.backendConnector.reload(lngs, ns, function (err) {
        deferred.resolve();
        callback(err);
      });
      return deferred;
    }
  }, {
    key: "use",
    value: function use(module) {
      if (!module) throw new Error('You are passing an undefined module! Please check the object you are passing to i18next.use()');
      if (!module.type) throw new Error('You are passing a wrong module! Please check the object you are passing to i18next.use()');

      if (module.type === 'backend') {
        this.modules.backend = module;
      }

      if (module.type === 'logger' || module.log && module.warn && module.error) {
        this.modules.logger = module;
      }

      if (module.type === 'languageDetector') {
        this.modules.languageDetector = module;
      }

      if (module.type === 'i18nFormat') {
        this.modules.i18nFormat = module;
      }

      if (module.type === 'postProcessor') {
        postProcessor.addPostProcessor(module);
      }

      if (module.type === '3rdParty') {
        this.modules.external.push(module);
      }

      return this;
    }
  }, {
    key: "changeLanguage",
    value: function changeLanguage(lng, callback) {
      var _this4 = this;

      this.isLanguageChangingTo = lng;
      var deferred = defer();
      this.emit('languageChanging', lng);

      var done = function done(err, l) {
        if (l) {
          _this4.language = l;
          _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);

          _this4.translator.changeLanguage(l);

          _this4.isLanguageChangingTo = undefined;

          _this4.emit('languageChanged', l);

          _this4.logger.log('languageChanged', l);
        } else {
          _this4.isLanguageChangingTo = undefined;
        }

        deferred.resolve(function () {
          return _this4.t.apply(_this4, arguments);
        });
        if (callback) callback(err, function () {
          return _this4.t.apply(_this4, arguments);
        });
      };

      var setLng = function setLng(lngs) {
        var l = typeof lngs === 'string' ? lngs : _this4.services.languageUtils.getBestMatchFromCodes(lngs);

        if (l) {
          if (!_this4.language) {
            _this4.language = l;
            _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);
          }

          if (!_this4.translator.language) _this4.translator.changeLanguage(l);
          if (_this4.services.languageDetector) _this4.services.languageDetector.cacheUserLanguage(l);
        }

        _this4.loadResources(l, function (err) {
          done(err, l);
        });
      };

      if (!lng && this.services.languageDetector && !this.services.languageDetector.async) {
        setLng(this.services.languageDetector.detect());
      } else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
        this.services.languageDetector.detect(setLng);
      } else {
        setLng(lng);
      }

      return deferred;
    }
  }, {
    key: "getFixedT",
    value: function getFixedT(lng, ns) {
      var _this5 = this;

      var fixedT = function fixedT(key, opts) {
        var options;

        if (_typeof$1(opts) !== 'object') {
          for (var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
            rest[_key3 - 2] = arguments[_key3];
          }

          options = _this5.options.overloadTranslationOptionHandler([key, opts].concat(rest));
        } else {
          options = _objectSpread$1({}, opts);
        }

        options.lng = options.lng || fixedT.lng;
        options.lngs = options.lngs || fixedT.lngs;
        options.ns = options.ns || fixedT.ns;
        return _this5.t(key, options);
      };

      if (typeof lng === 'string') {
        fixedT.lng = lng;
      } else {
        fixedT.lngs = lng;
      }

      fixedT.ns = ns;
      return fixedT;
    }
  }, {
    key: "t",
    value: function t() {
      var _this$translator;

      return this.translator && (_this$translator = this.translator).translate.apply(_this$translator, arguments);
    }
  }, {
    key: "exists",
    value: function exists() {
      var _this$translator2;

      return this.translator && (_this$translator2 = this.translator).exists.apply(_this$translator2, arguments);
    }
  }, {
    key: "setDefaultNamespace",
    value: function setDefaultNamespace(ns) {
      this.options.defaultNS = ns;
    }
  }, {
    key: "hasLoadedNamespace",
    value: function hasLoadedNamespace(ns) {
      var _this6 = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (!this.isInitialized) {
        this.logger.warn('hasLoadedNamespace: i18next was not initialized', this.languages);
        return false;
      }

      if (!this.languages || !this.languages.length) {
        this.logger.warn('hasLoadedNamespace: i18n.languages were undefined or empty', this.languages);
        return false;
      }

      var lng = this.languages[0];
      var fallbackLng = this.options ? this.options.fallbackLng : false;
      var lastLng = this.languages[this.languages.length - 1];
      if (lng.toLowerCase() === 'cimode') return true;

      var loadNotPending = function loadNotPending(l, n) {
        var loadState = _this6.services.backendConnector.state["".concat(l, "|").concat(n)];

        return loadState === -1 || loadState === 2;
      };

      if (options.precheck) {
        var preResult = options.precheck(this, loadNotPending);
        if (preResult !== undefined) return preResult;
      }

      if (this.hasResourceBundle(lng, ns)) return true;
      if (!this.services.backendConnector.backend) return true;
      if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
      return false;
    }
  }, {
    key: "loadNamespaces",
    value: function loadNamespaces(ns, callback) {
      var _this7 = this;

      var deferred = defer();

      if (!this.options.ns) {
        callback && callback();
        return Promise.resolve();
      }

      if (typeof ns === 'string') ns = [ns];
      ns.forEach(function (n) {
        if (_this7.options.ns.indexOf(n) < 0) _this7.options.ns.push(n);
      });
      this.loadResources(function (err) {
        deferred.resolve();
        if (callback) callback(err);
      });
      return deferred;
    }
  }, {
    key: "loadLanguages",
    value: function loadLanguages(lngs, callback) {
      var deferred = defer();
      if (typeof lngs === 'string') lngs = [lngs];
      var preloaded = this.options.preload || [];
      var newLngs = lngs.filter(function (lng) {
        return preloaded.indexOf(lng) < 0;
      });

      if (!newLngs.length) {
        if (callback) callback();
        return Promise.resolve();
      }

      this.options.preload = preloaded.concat(newLngs);
      this.loadResources(function (err) {
        deferred.resolve();
        if (callback) callback(err);
      });
      return deferred;
    }
  }, {
    key: "dir",
    value: function dir(lng) {
      if (!lng) lng = this.languages && this.languages.length > 0 ? this.languages[0] : this.language;
      if (!lng) return 'rtl';
      var rtlLngs = ['ar', 'shu', 'sqr', 'ssh', 'xaa', 'yhd', 'yud', 'aao', 'abh', 'abv', 'acm', 'acq', 'acw', 'acx', 'acy', 'adf', 'ads', 'aeb', 'aec', 'afb', 'ajp', 'apc', 'apd', 'arb', 'arq', 'ars', 'ary', 'arz', 'auz', 'avl', 'ayh', 'ayl', 'ayn', 'ayp', 'bbz', 'pga', 'he', 'iw', 'ps', 'pbt', 'pbu', 'pst', 'prp', 'prd', 'ug', 'ur', 'ydd', 'yds', 'yih', 'ji', 'yi', 'hbo', 'men', 'xmn', 'fa', 'jpr', 'peo', 'pes', 'prs', 'dv', 'sam'];
      return rtlLngs.indexOf(this.services.languageUtils.getLanguagePartFromCode(lng)) >= 0 ? 'rtl' : 'ltr';
    }
  }, {
    key: "createInstance",
    value: function createInstance() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 ? arguments[1] : undefined;
      return new I18n(options, callback);
    }
  }, {
    key: "cloneInstance",
    value: function cloneInstance() {
      var _this8 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;

      var mergedOptions = _objectSpread$1({}, this.options, options, {
        isClone: true
      });

      var clone = new I18n(mergedOptions);
      var membersToCopy = ['store', 'services', 'language'];
      membersToCopy.forEach(function (m) {
        clone[m] = _this8[m];
      });
      clone.services = _objectSpread$1({}, this.services);
      clone.services.utils = {
        hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
      };
      clone.translator = new Translator(clone.services, clone.options);
      clone.translator.on('*', function (event) {
        for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
          args[_key4 - 1] = arguments[_key4];
        }

        clone.emit.apply(clone, [event].concat(args));
      });
      clone.init(mergedOptions, callback);
      clone.translator.options = clone.options;
      clone.translator.backendConnector.services.utils = {
        hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
      };
      return clone;
    }
  }]);

  return I18n;
}(EventEmitter);

var i18next = new I18n();

var matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
var htmlEntities = {
  '&amp;': '&',
  '&#38;': '&',
  '&lt;': '<',
  '&#60;': '<',
  '&gt;': '>',
  '&#62;': '>',
  '&apos;': "'",
  '&#39;': "'",
  '&quot;': '"',
  '&#34;': '"',
  '&nbsp;': ' ',
  '&#160;': ' ',
  '&copy;': '©',
  '&#169;': '©',
  '&reg;': '®',
  '&#174;': '®',
  '&hellip;': '…',
  '&#8230;': '…',
  '&#x2F;': '/',
  '&#47;': '/'
};

var unescapeHtmlEntity = function unescapeHtmlEntity(m) {
  return htmlEntities[m];
};

var unescape$1 = function unescape(text) {
  return text.replace(matchHtmlEntity, unescapeHtmlEntity);
};

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var defaultOptions = {
  bindI18n: 'languageChanged',
  bindI18nStore: '',
  transEmptyNodeValue: '',
  transSupportBasicHtmlNodes: true,
  transWrapTextNodes: '',
  transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p'],
  useSuspense: true,
  unescape: unescape$1
};
createContext();
function setDefaults() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  defaultOptions = _objectSpread(_objectSpread({}, defaultOptions), options);
}
(function () {
  function ReportNamespaces() {
    _classCallCheck(this, ReportNamespaces);

    this.usedNamespaces = {};
  }

  _createClass(ReportNamespaces, [{
    key: "addUsedNamespaces",
    value: function addUsedNamespaces(namespaces) {
      var _this = this;

      namespaces.forEach(function (ns) {
        if (!_this.usedNamespaces[ns]) _this.usedNamespaces[ns] = true;
      });
    }
  }, {
    key: "getUsedNamespaces",
    value: function getUsedNamespaces() {
      return Object.keys(this.usedNamespaces);
    }
  }]);

  return ReportNamespaces;
})();
var initReactI18next = {
  type: '3rdParty',
  init: function init(instance) {
    setDefaults(instance.options.react);
  }
};

var Dashboard$g = "لوحة المعلومات";
var Account$g = "الحساب";
var Help$g = "تعليمات";
var Mac$g = "Mac";
var Windows$g = "Windows";
var Admin$g = "المسؤول";
var Driver$g = "السائق";
var Cameras$g = "الكاميرات";
var Manage$g = "إدارة";
var Clear$g = "مسح";
var Show$g = "إظهار";
var GB$g = "{{a}}GB";
var _section$g = ".";
var Name$g = "الاسم";
var Password$g = "كلمة المرور";
var Cancel$g = "إلغاء";
var Members$g = "الأعضاء";
var Groups$g = "المجموعات";
var Role$g = "الدور";
var Group$g = "المجموعة";
var Status$g = "الحالة";
var nPM$g = "‎{{a}}‎ صباحًا";
var nAM$g = "‎{{a}}‎ مساءً";
var Newest$g = "الأحدث";
var Oldest$g = "الأقدم";
var Accepted$g = "تم القبول";
var Pending$g = "معلق";
var Expired$g = "انتهت الصلاحية";
var All$g = "الكل";
var Delete_$g = "حذف ‎{{a}}‎";
var Delete$g = "حذف";
var Rename$g = "تغيير الاسم";
var Add$g = "إضافة";
var OK$g = "OK";
var Remove$g = "إزالة";
var Files$g = "الملفات";
var Features$g = "الميزات";
var Settings$g = "الإعدادات";
var Upload$g = "تحميل";
var Privacy$g = "الخصوصية";
var Done$g = "تم";
var Subscription$g = "الاشتراك";
var Submasters$g = "المسؤولون";
var Users$g = "السائقون";
var Change$g = "تغيير";
var Method$g = "الطريقة";
var Details$g = "معلومات الكاميرا";
var Confirm$g = "تأكيد";
var Address$g = "العنوان";
var Country$g = "الدولة";
var State$g = "الولاية";
var ZIP$g = "الرمز البريدي";
var Pricing$g = "الأسعار";
var Free$g = "Free";
var Smart$g = "Smart";
var Fleet$g = "Fleet";
var Subscrubed$g = "تم الاشتراك";
var January$g = "يناير";
var February$g = "فبراير";
var March$g = "مارس";
var April$g = "أبريل";
var May$g = "مايو";
var June$g = "يونيو";
var July$g = "يوليو";
var August$g = "أغسطس";
var September$g = "سبتمبر";
var October$g = "أكتوبر";
var November$g = "نوفمبر";
var December$g = "ديسمبر";
var Blackvuecloud_$g = "www.blackvuecloud.com";
var Support$g = "Support";
var Community$g = "Community";
var FAQ$g = "FAQ";
var Developers$g = "Developers";
var Facebook$g = "Facebook";
var Twitter$g = "Twitter";
var Instagram$g = "Instagram";
var Youtube$g = "Youtube";
var Linkedin$g = "Linkedin";
var Downloads$g = "التنزيلات";
var Unauthorized$g = "غير معتمد";
var none$g = "لا يوجد";
var Email$g = "البريد الإلكتروني";
var Customers$g = "Customers";
var Home$g = "Home";
var Plan$g = "Plan";
var New$g = "New";
var Unsubscribed$g = "Unsubscribed";
var Edit$g = "Edit";
var month$g = "month";
var months$g = "months";
var Continue$g = "Continue";
var Back$g = "خلف";
var Master$g = "Owner";
var Develop$g = "Developers";
var $9$g = "$9";
var $15$g = "$15";
var $10$g = "$10";
var mo$g = "شهر";
var City$g = "المدينة";
var Charge$g = "التحصيل";
var subscribe$g = "اشتراك";
var search$g = "بحث";
var invalid_number$g = "رقم البطاقة ليس رقم بطاقة ائتمان صالحًا";
var invalid_expiry_month$g = "شهر انتهاء صلاحية البطاقة غير صالح";
var invalid_expiry_year$g = "سنة انتهاء صلاحية البطاقة غير صالحة";
var invalid_cvc$g = "رمز أمان البطاقة غير صالح";
var incorrect_number$g = "رقم البطاقة غير صحيح";
var incomplete_number$g = "رقم البطاقة غير مكتمل";
var incomplete_cvc$g = "رمز أمان البطاقة غير مكتمل";
var incomplete_expiry$g = "تاريخ انتهاء صلاحية البطاقة غير مكتمل";
var expired_card$g = "انتهت صلاحية البطاقة";
var incorrect_cvc$g = "رمز أمان البطاقة غير صحيح";
var incorrect_zip$g = "فشل التحقق من صحة الرمز البريدي للبطاقة";
var invalid_expiry_year_past$g = "سنة انتهاء صلاحية البطاقة في السابق";
var card_declined$g = "تم رفض البطاقة";
var missing$g = "لم يتم شحن بطاقة للعميل";
var processing_error$g = "حدث خطأ في أثناء معالجة البطاقة";
var Paypal$g = "Paypal";
var iOS$g = "iOS";
var Android$g = "Android";
var Total$g = "الإجمالي";
var And$g = "و";
var Camera$g = "Camera";
var Yes$g = "نعم";
var No$g = "لا";
var News$g = "الأخبار";
var Notifications$g = "إشعارات";
var MPH$g = "MPH";
var Firmware$g = "البرنامج الثابت";
var Basic$g = "أساسي";
var Resolution$g = "الدقة";
var Brightness$g = "السطوع";
var Recording$g = "التسجيل";
var Highest$g = "الأعلى";
var High$g = "عالٍ";
var Normal$g = "عادي";
var Sensitivity$g = "الحساسية";
var Volume$g = "مستوى الصوت";
var Close$g = "إغلاق";
var Cloud$g = "Cloud";
var Public$g = "عام";
var Front$g = "أمامية";
var Rear$g = "خلفية";
var Play$g = "تشغيل";
var Stop$g = "إيقاف";
var Pause$g = "إيقاف مؤقت";
var Time$g = "Time";
var System$g = "النظام";
var Event$g = "الحدث";
var Parking$g = "إيقاف السيارة";
var Color$g = "اللون";
var Exit$g = "خروج";
var Save$g = "حفظ";
var Impact$g = "التصادم";
var Unlimited$g = "غير محدود";
var Default$g = "افتراضي";
var Version$g = "الإصدار";
var Language$g = "اللغة";
var Notification$g = "Notification";
var Multiple$g = "متعدد";
var Range$g = "النطاق";
var Download$g = "تنزيل";
var Manual$g = "يدوي";
var Satellite$g = "القمر الصناعي";
var Tutorials$g = "البرامج التعليمية";
var Filter$g = "تصفية";
var Sun$g = "الأحد";
var Mon$g = "الاثنين";
var Tue$g = "الثلاثاء";
var Wed$g = "الأربعاء";
var Thu$g = "الخميس";
var Fri$g = "الجمعة";
var Sat$g = "السبت";
var Dates$g = "التواريخ";
var Routes$g = "المسار (المسارات)";
var Opacity$g = "معدل الشفافية";
var Entry$g = "إدخال";
var Owner$g = "Owner";
var Undetected$g = "غير مكتشف";
var Distracted$g = "مشتت الذهن";
var Drowsy$g = "Drowsy";
var Calling$g = "Calling";
var Smoking$g = "Smoking";
var Permissions$g = "الأذونات";
var Private$g = "خاص";
var Entering$g = "دخول";
var Exiting$g = "خروج";
var Acceleration$g = "تسارع";
var Passing$g = "مرور";
var Overspeed$g = "سرعة زائدة";
var Recipients$g = "المستلمون";
var Send$g = "إرسال";
var Note$g = "ملاحظة";
var Video$g = "الفيديو";
var Advanced$g = "متقدم";
var Voice$g = "الصوت";
var Days_$g = "أيام";
var Mute$g = "كتم";
var UnMute$g = "إلغاء الكتم";
var Discard$g = "تجاهل";
var Report$g = "Report";
var Individual$g = "هل أنت سائق فردي يبحث عن راحة البال؟ هل أنت صاحب عمل يحتاج إلى حل بسيط يتعلق بأمن المركبات وتتبعها؟";
var Subscribed$g = "تم الاشتراك";
var Geofence$g = "السياج الجغرافي";
var Driving$g = "القيادة";
var Idling$g = "وضع الخمول";
var Distance$g = "المسافة";
var Parked$g = "Parked";
var Speed$g = "السرعة";
var Highest_2$g = "الأعلى";
var Average$g = "المتوسط";
var Geofences$g = "السياجات الجغرافية";
var Move$g = "نقل";
var Connected$g = "تم الاتصال";
var Individual_$g = "فردي";
var Always$g = "دائم";
var Low$g = "منخفض";
var Medium$g = "متوسط";
var High_2$g = "عالٍ";
var Flip$g = "قلب";
var Previous$g = "الإطار السابق";
var Next$g = "التالي";
var Expand$g = "توسيع";
var Collapse$g = "طي";
var More$g = "المزيد";
var Multi$g = "متعدد";
var Safe$g = "آمن";
var Reckless$g = "طائش";
var Inattentive$g = "شارد";
var List$g = "القائمة";
var Usage$g = "الاستخدام";
var Profile$g = "ملف التعريف";
var Fullscreen$g = "الشاشة الكاملة";
var Upgrade$g = "ترقية";
var Management$g = "الإدارة";
var Day$g = "يوم";
var Month$g = "شهر";
var Later$g = "لاحقًا";
var ICCID$g = "ICCID";
var Resubscribe$g = "إعادة الاشتراك";
var plan$g = "الخطة";
var USD$g = "دولارات أمريكية";
var etc_$g = "أخرى:";
var Available$g = "متوفر";
var Used$g = "مستخدَم";
var Cancelled$g = "تم الإلغاء";
var Terminated$g = "تم الإنهاء";
var Sort$g = "فرز";
var Bonus$g = "مكافأة";
var incomplete_zip$g = "فشل التحقق من صحة الرمز البريدي للبطاقة";
var Upgrades$g = "التحديثات";
var OR$g = "أو";
var Undo$g = "يلغي";
var Invoice$g = "فاتورة";
var data$g = "بيانات";
var Popular$g = "Popular";
var Mask$g = "بدون قناع";
var DMS$g = "مراقبة حالة السائق (DMS)";
var Extreme$g = "إكستريم";
var OFF$g = "OFF";
var Threshold$g = "الحد";
var Drowsiness$g = "نعاس";
var Direct$g = "مباشر";
var Remote$g = "عن بُعد";
var Update$g = "تحديث";
var Option$g = "اختياري";
var Required$g = "مطلوب";
var Optional$g = "اختياري";
var Others$g = "أخرى";
var Stay$g = "البقاء";
var Mask_2$g = "Mask";
var Low_2$g = "Low";
var Medium_2$g = "Medium";
var High_3$g = "High";
var Highest_3$g = "Highest";
var Extreme_2$g = "Extreme";
var Private_2$g = "Private";
var Lite$g = "Lite";
var Bitrate$g = "معدل البت";
var hours$g = "ساعات";
var Expires$g = "ستنتهي الصلاحية";
var Check$g = "تحقق";
var Saving$g = "الحفظ";
var Now$g = "الآن";
var Beep$g = "صوت التحذير";
var Unpair$g = "فك الزوجية";
var Detected$g = "مكتشف";
var Promotion$g = "ترويج";
var Notice$g = "التحديثات";
var Explore$g = "يستكشف";
var Deactivate$f = "إلغاء التنشيط";
var Compliance$g = "الامتثال";
var Manufacturing$f = "التصنيع";
var Emergency$f = "الطوارئ";
var Security$f = "الأمن";
var Important$f = "مهم";
var or$f = "أو";
var Subscribe$f = "يشترك";
var Vehicle$f = "مركبة";
var ar = {
	Dashboard: Dashboard$g,
	"Payment & Subscriptions": "الدفع والاشتراكات",
	"Fleet Management": "إدارة الأسطول",
	"Available to master": "متوفر للمسؤول",
	"Available to Fleet_": "متوفر لمستخدمي خطة الأسطول",
	Account: Account$g,
	"Log out": "تسجيل الخروج",
	"© 2019 Pittasoft_": "© 2019 Pittasoft Co. Ltd",
	"Privacy policy": "سياسة الخصوصية",
	"Terms of service": "شروط الخدمة",
	Help: Help$g,
	"App store": "App store",
	"Google Play": "Google Play",
	Mac: Mac$g,
	Windows: Windows$g,
	"Free Plan": "Free Plan",
	"Basic Plan": "Basic Plan",
	"Smart Plan": "Smart Plan",
	Admin: Admin$g,
	Driver: Driver$g,
	"Period : December 3, 2024 ~ May 31, 2025": "الفترة: 3 ديسمبر 2024 - 31 مايو 2025",
	Cameras: Cameras$g,
	"n of n": "{{a}} من {{b}}",
	Manage: Manage$g,
	"Upgrade Plan": "ترقية الخطة",
	"Add more cameras_": "إضافة المزيد من الكاميرات وإدارة أسطولك والمزيد...",
	"Usage statistics": "إحصائيات الاستخدام",
	"All cameras": "جميع الكاميرات",
	Clear: Clear$g,
	Show: Show$g,
	"Live views": "العرض المباشر عن بُعد",
	"nh:nm:ns": "{{a}}h:{{b}}m:{{c}}s",
	"Video plays and_": "تشغيلات الفيديو وتنزيلاته",
	"Space available": "المساحة المتوفرة",
	GB: GB$g,
	"n%": "{{a}}%",
	"BlackVue app for_": "تطبيق BlackVue لنظامي iOS وAndroid",
	"BlackVue viewer for_": "عارض BlackVue لنظامي Mac وWindows",
	"Welcome to fleet": "مرحبًا بك في الأسطول",
	"A few things_": "إليك بعض الأمور التي يمكنك توقعها على طول الطريق:",
	"You can watch_": "يمكنك مشاهدة مقاطع الفيديو عبر الكاميرات التي تمعيينها لك في تطبيق BlackVue أو عارض سطح المكتب.",
	"If the master_deletes": "إذا حذف المسؤول حسابه، فسيتم حذف حسابك أيضًا.",
	"If the masters_Fleet": "إذا انتهت صلاحية اشتراك المسؤول في خطة الأسطول، فستظل قادرًا على الوصول إلى حسابك في وضع القراءة فقط.",
	"You have to_": "يجب أن تسجل حسابًا آخر لإضافة كاميرا شخصية.",
	"The Payments &_": "يتوفر قسما المدفوعات والاشتراكات وإدارة الأسطول للمسؤول فقط.",
	"You can manage_": "يمكنك إدارة مجموعة الأسطول في قسم",
	"_Fleet management": "إدارة الأسطول",
	_section: _section$g,
	"The Payments_section-": "يتوفر قسم المدفوعات والاشتراكات للمسؤول فقط.",
	"Youre almost there": "أنت على وشك الانتهاء",
	"Finish account setup": "إنهاء إعداد الحساب",
	"Install and log_": "تثبيت تطبيق BlackVue أو عارض سطح المكتب وتسجيل الدخول إليه",
	"Download on the_": "التنزيل من ‎App‎ Store",
	"GET IT ON_": "الحصول عليه من Google ‎Play",
	"Download for Mac": "التنزيل لنظام Mac",
	"Download for Windows": "التنزيل لنظام Windows",
	"Add your camera_": "إضافة الكاميرا إلى تطبيق BlackVue أو عارض سطح المكتب",
	"Start managing your_": "ابدأ إدارة أسطولك ومتابعة إحصائيات الاستخدام هنا",
	"Cancelled Fleet Plan_": "تم إلغاء خطة الأسطول في ‎{{date}}‎",
	"The new plan_": "ستسري الخطة الجديدة في نهاية دورة الفوترة الحالية.",
	"Profile photo": "صورة ملف التعريف",
	Name: Name$g,
	"E-mail address": "عنوان البريد الإلكتروني",
	Password: Password$g,
	"Last changed_": "آخر تغيير ‎{{a}}‎",
	"Change password": "تغيير كلمة المرور",
	"Delete account": "حذف الحساب",
	Cancel: Cancel$g,
	"Current password": "كلمة المرور الحالية",
	"New password": "كلمة المرور الجديدة",
	"Confirm new password": "تأكيد كلمة المرور الجديدة",
	"Password changed": "تم تغيير كلمة المرور",
	"Reason for deletion_": "سبب الحذف (اختياري)",
	"Account password": "كلمة مرور الحساب",
	Members: Members$g,
	Groups: Groups$g,
	"+ Invite member": "+ دعوة عضو",
	"Name, Email": "الاسم، البريد الإلكتروني",
	Role: Role$g,
	Group: Group$g,
	"Date invited": "تاريخ الدعوة",
	Status: Status$g,
	"Group n": "المجموعة ‎{{a}}‎",
	nPM: nPM$g,
	nAM: nAM$g,
	Newest: Newest$g,
	Oldest: Oldest$g,
	"Name, email or_": "الاسم أو البريد الإلكتروني أو المجموعة",
	Accepted: Accepted$g,
	Pending: Pending$g,
	Expired: Expired$g,
	All: All$g,
	"No results": "لا توجد نتائج",
	"Try different keywords": "جرب كلمات رئيسية أخرى",
	"Try changing or_": "حاول تغيير عوامل التصفية أو إزالتها",
	"Remove all filters": "قم بإزالة جميع عوامل التصفية",
	"Invite member": "قم بدعوة عضو",
	"Send invite": "إرسال دعوة",
	"You have reached_": "لقد وصلت إلى الحد الأقصى البالغ 10 مستخدمين تابعين. يمكنك الاستمرار في دعوة المستخدمين.",
	Delete_: Delete_$g,
	"Are you sure_delete": "هل تريد بالتأكيد حذف هذا العضو وحسابه؟",
	Delete: Delete$g,
	Rename: Rename$g,
	"No submaster yet": "لا يوجد مستخدم تابع حتى الآن",
	"You can add_": "يمكنك إضافة مستخدم تابع واحد لكل مجموعة",
	"No cameras yet": "لا توجد كاميرات حتى الآن",
	"Add cameras first_": "أضف الكاميرات أولاً، ثم قم بتعيين المستخدمين",
	"Name or email": "الاسم أو البريد الإلكتروني",
	"Add submaster": "إضافة مستخدم تابع",
	Add: Add$g,
	"Add camera": "إضافة كاميرا",
	"n of n selected": "تم تحديد ‎{{a}}‎ من ‎{{b}}‎",
	"No cameras available": "لا تتوفر كاميرات",
	"Most likely reasons_": "إليك أرجح الأسباب لذلك:",
	"All cameras were_": "تمت إضافة جميع الكاميرات إلى مجموعات أخرى.",
	"You can remove_": "يمكنك إزالة الكاميرات من المجموعات الأخرى وإضافتها إلى هذه المجموعة.",
	"No cameras were_": "لم تتم إضافة كاميرات إلى حسابك.",
	"You can add_cameras": "يمكنك إضافة كاميرات إلى تطبيق BlackVue أو عارض سطح المكتب.",
	OK: OK$g,
	"Rename group": "إعادة تسمية المجموعة",
	"Are you sure_group": "هل تريد بالتأكيد حذف هذه المجموعة؟",
	"Edit Mobile app_": "تحرير أذونات تطبيق الهاتف المحمول/عارض سطح المكتب",
	Remove: Remove$g,
	"n of n users": "‎{{a}}‎ من ‎{{b}}‎ من المستخدمين",
	"Youve reached the_": "لقد وصلت إلى حد المستخدمين لكل كاميرا",
	"Remove user": "إزالة مستخدم",
	"Add user": "إضافة مستخدم",
	"+ Add group": "+ إضافة مجموعة",
	"Add group": "إضافة مجموعة",
	"Group or submaster": "المجموعة أو المستخدم التابع",
	"+ Add": "+ إضافة",
	"of max selected": "تم تحديد ‎{{a}}‎ من ‎{{b}}‎ بحد أقصى",
	"Mobile app/desktop_": "أذونات تطبيق الهاتف المحمول/عارض سطح المكتب",
	Files: Files$g,
	Features: Features$g,
	Settings: Settings$g,
	Upload: Upload$g,
	"Download and Playback_Cloud": "التنزيل والتشغيل من التخزين السحابي",
	"Download and Playback_SD": "التنزيل والتشغيل من بطاقة SD",
	"Live view": "العرض المباشر",
	"Geo Fencing": "السياجات الجغرافية",
	"Drive Reports": "تقارير القيادة",
	"Firmware Settings": "إعدادات البرنامج الثابت",
	"Push Notifications": "الإشعارات المنبثقة",
	"Event Auto Upload": "التحميل التلقائي المباشر للحدث",
	Privacy: Privacy$g,
	Done: Done$g,
	"Payment method": "طريقة الدفع",
	"Change payment method": "تغيير طريقة الدفع",
	Subscription: Subscription$g,
	"Space used": "المساحة المستخدمة",
	"Next billing_": "الفوترة التالية",
	"You manage_available": "أنت تدير ‎{{a}}‎ من ‎{{b}}‎ المتوفرة في خطتك",
	Submasters: Submasters$g,
	Users: Users$g,
	Change: Change$g,
	"No transactions yet_": "أنت مشترك في الخطة المجانية. لا توجد معاملات حتى الآن",
	"No transactions to_": "لا توجد معاملات لإظهارها.</br> إذا كنت تبحث عن سجل معاملات أنظمة أساسية أخرى (مثل iOS،‏ Android،‏ PayPal)، يمكنك العثور على السجل في صفحة الاشتراك على النظام الأساسي.",
	"of nGB_": "‎{{a}}‎ من ‎{{b}}‎ جيجابايت ‎({{c}}‎%)‎",
	"Smart Plan users_": "يمكن لمستخدمي الخطة الذكية تغيير خطة الاشتراك أو عدد الكاميرات عبر تطبيق BlackVue للهواتف المحمولة",
	"Transaction history": "محفوظات المعاملة",
	"Date": "التاريخ",
	"Amount, USD": "المبلغ بالدولار الأمريكي",
	Method: Method$g,
	Details: Details$g,
	"iOS in-app_": "iOS in-app purchase/Android in-app purchase",
	"Change the number_": "تغيير عدد الكاميرات",
	"You manage_cameras": "You manage {{a}} cameras of {{b}} available on your plan",
	"Extra cameras": "كاميرات إضافية",
	"Total due_": "إجمالي المبلغ المستحق",
	"available on your_": "من {{a}} متوافر في خطتك",
	"Cancel Fleet Plan": "إلغاء Fleet Plan",
	"This will cancel_": "سيؤدي ذلك إلى إلغاء اشتراك خطة الأسطول الخاصة بك. سترجع إلى إصدار أقدم من الخطة المجانية في نهاية دورة الفوترة الخاصة بك.",
	"Reason for cancellation_": "سبب الإلغاء (اختياري)",
	"Not now": "ليس الآن",
	Confirm: Confirm$g,
	"Cardholder name": "اسم حامل البطاقة",
	"Card name": "اسم البطاقة",
	"MM/YY": "شهر/سنة",
	Address: Address$g,
	Country: Country$g,
	State: State$g,
	ZIP: ZIP$g,
	Pricing: Pricing$g,
	"You are subscribed_": "أنت مشترك في الخطة المجانية.",
	"With Alert Push_": "تتضمن إشعارات التنبيه المنبثقة والعرض المباشر عن بعد المحدود والتخزين السحابي.",
	Free: Free$g,
	Smart: Smart$g,
	Fleet: Fleet$g,
	"Get started for_": "ابدأ مجانًا، دون الحاجة إلى بطاقة ائتمان. \n تتضمن إشعارات التنبيه المنبثقة والعرض المباشر عن بعد المحدود والتخزين السحابي.",
	Subscrubed: Subscrubed$g,
	"Features included:": "الميزات المضمنة:",
	"Get unlimited Remote_": "الحصول على عرض مباشر عن بعد غير محدود وتشغيل السحابة وإدارة ما يصل إلى {{a}} كاميرات.",
	"BlackVue Fleet Tracking_": "ميزات تتبع الأسطول الحصرية من BlackVue للمستخدمين المحترفين والشركات المحترفة على حد سواء (العديد من المستخدمين والكاميرات، والسياج الجغرافي، وغير ذلك)",
	"Try 1 Month Free": "جرب شهرًا مجانًا",
	"Log in": "تسجيل الدخول",
	"Remember me": "تذكر بياناتي",
	"Forgot password?": "هل نسيت كلمة المرور؟",
	"Reset password": "إعادة تعيين كلمة المرور",
	"Enter email address_": "أدخل عنوان البريد الإلكتروني المستخدم أثناء التسجيل \n وسنرسل إليك رابطًا لإعادة تعيين كلمة المرور.",
	"Send reset password_": "إرسال بريد إلكتروني لإعادة تعيين كلمة المرور",
	"Back to login": "العودة إلى تسجيل الدخول",
	"Check your email": "تحقق من بريدك الإلكتروني",
	"Weve sent an_": "لقد أرسلنا بريدًا إلكترونيًا إلى {{a}} يحتوي على رابط لتأكيد\n عنوان بريدك الإلكتروني.",
	"Resend email": "إعادة إرسال البريد الإلكتروني",
	January: January$g,
	February: February$g,
	March: March$g,
	April: April$g,
	May: May$g,
	June: June$g,
	July: July$g,
	August: August$g,
	September: September$g,
	October: October$g,
	November: November$g,
	December: December$g,
	"Sign up": "إنشاء حساب",
	"First name": "الاسم الأول",
	"Last name": "الاسم الأخير",
	"Create a password": "إنشاء كلمة مرور",
	"5 or more_": "5 رموز أو أكثر",
	"Sign up and_": "التسجيل والمتابعة",
	"I agree to_": "أوافق على ‎%@‎ و‎%@‎ و‎%@‎ و‎%@‎.",
	"Subscribe to newsletter": "اشتراك في الرسالة الإخبارية",
	"1 month free trial_": "فترة تجريبية مجانية لمدة شهر",
	"Dont have an_": "ليس لديك حساب؟",
	"Thank you for_": "شكرًا لك على التسجيل في ‎BlackVue Cloud‎. يُرجى تأكيد عنوان البريد الإلكتروني.",
	"Confirm email": "تأكيد البريد الإلكتروني",
	"If you didnt_": "إذا لم تسجل بهذا الحساب، يمكنك تجاهل هذا البريد الإلكتروني.",
	Blackvuecloud_: Blackvuecloud_$g,
	"invited you to_": "لقد دعاك ‎{{a}}‎ إلى الانضمام إلى أسطوله كمستخدم تابع.",
	"Accept invitation": "قبول الدعوة",
	"Invite expires on_": "تنتهي صلاحية الدعوة في ي‏ي، ش‏ش، ‏س‏س.",
	"Your Fleet Management_": "تم حذف حساب إدارة الأسطول المسجل باستخدام ‎{{a}}‎ بواسطة ‎%@‎.",
	"If you believe_": "إذا كنت تعتقد أن هذا خطأ، يُرجى الاتصال بقسم دعم العملاء على‏: ‎cs@blackvue.com‎.",
	Support: Support$g,
	"Help center": "مركز التعليمات",
	Community: Community$g,
	"Getting started": "البدء",
	FAQ: FAQ$g,
	Developers: Developers$g,
	"Cloud API": "Cloud API",
	"Fleet SDK": "Fleet SDK",
	"Follow us": "Follow us",
	Facebook: Facebook$g,
	Twitter: Twitter$g,
	Instagram: Instagram$g,
	Youtube: Youtube$g,
	Linkedin: Linkedin$g,
	"BlackVue apps": "BlackVue apps",
	"Camera registraiton": "تسجيل الكاميرا",
	"Two-way voice_": "اتصال صوتي ثنائي الاتجاه",
	"Live GPS": "GPS مباشر",
	"Event live auto_": "التحميل التلقائي المباشر للحدث",
	"Event file auto_": "التحميل التلقائي لملف الحدث",
	"Compatible with_": "متوافق مع الطرازين DR650GW وDR650S",
	"Not compatible with_": "غير متوافق مع الطرازين DR650GW وDR650S",
	"More cameras": "مزيد من الكاميرات",
	"More users": "More users",
	"Roles and permissions": "Roles and permissions",
	"More Cloud Storage": "مزيد من التخزين السحابي",
	"Multi Live view_": "Multi Live View (Web)",
	"Longer GPS Tracking": "Longer GPS Tracking",
	"Geo Fence setup_": "Geo Fence setup (PC viewer) and alerts (PC viewer and app)",
	"Changes saved": "تم حفظ التغييرات",
	"Group added": "تمت إضافة مجموعة",
	"Member added": "تمت إضافة عضو",
	"Group deleted": "تم حذف المجموعة",
	"Member deleted": "تم حذف العضو",
	"Group renamed": "تمت إعادة تسمية المجموعة",
	"Submaster added": "تمت إضافة مستخدم تابع",
	"Camera added": "تمت إضافة كاميرا",
	"User added": "تمت إضافة مستخدم",
	"Users added": "تمت إضافة مستخدمين",
	Downloads: Downloads$g,
	"The BlackVue App_": "The BlackVue App and Viewer let you use your BlackVue camera to its full potential. Whether on mobile or on home computer, BlackVue gives you the tools to fully enjoy your dashcam's functions.",
	"Compatible with all_": "Compatible with all Wi-Fi enabled BlackVue models.",
	"Supports all BlackVue_": "Supports all BlackVue models to date.",
	"confirm new password": "تأكيد كلمة المرور الجديدة",
	"Your password is_": "كلمة المرور التي أدخلتها غير صحيحة",
	"Confirm password does_": "كلمة المرور غير مطابقة",
	"Please enter_email": "يرجى إدخال عنوان بريد إلكتروني صالح.",
	"Please enter_password": "كلمة المرور التي أدخلتها غير صحيحة",
	"Internal server error_": "خطأ في الخادم الداخلي. يُرجى المحاولة مرة أخرى.",
	"New password is_": "يجب أن يكون هناك رمز واحد على الأقل مختلفًا لكلمة المرور الحالية",
	"It should be_": "يجب أن تتكون كلمة المرور من 5 رموز أو أكثر",
	"Invalid permission": "إذن غير صالح.",
	"Input data isnt_": "بيانات الإدخال غير متوفرة.",
	Unauthorized: Unauthorized$g,
	"Already have subsciption": "لديك اشتراك بالفعل",
	"Already uses": "يستخدم بالفعل",
	"Already logged in": "تم تسجيل الدخول بالفعل",
	"Already sent e-mail": "تم إرسال بريد إلكتروني بالفعل.",
	"Please wait": "يُرجى الانتظار.",
	"E-mail is not_": "لم يتم التحقق من البريد الإلكتروني حتى الآن.",
	"Update your subscription_": "تحديث اشتراكك",
	"Account was deleted": "تم حذف الحساب.",
	"5 ~ 30_": "5 ~ 30 characters",
	"It has exceeded_": "تم تجاوز الحد الأقصى البالغ 9 مسؤولين.",
	"Billing information": "معلومات الفوترة",
	"Please enter cardName": "أدخل اسم البطاقة",
	"Please enter_card": "أدخل رقم بطاقة صالحًا",
	"Please enter address": "أدخل العنوان",
	"Please select country": "تحديد بلد",
	"Please enter city": "أدخل المدينة",
	none: none$g,
	"Due today": "مستحق اليوم",
	"Today after 1_": "اليوم بعد فترة تجريبية لمدة شهر",
	"An error occurred_": "حدث خطأ في أثناء محاولة تغيير كلمة المرور. حاول مرة أخرى.",
	"Your account is_": "حسابك نشط الآن",
	"You can now_": "يمكنك تسجيل الدخول الآن إلى حسابك باستخدام عنوان البريد الإلكتروني المستخدم في أثناء التسجيل.",
	Email: Email$g,
	"Don’t have an account?": "ليس لديك حساب؟",
	"Already have an account?": "هل لديك حساب؟",
	"Cloud service": "Cloud service",
	"for your BlackVue": "for your BlackVue",
	"See what your_": "See what your camera sees remotely.",
	"Receive impact alert_": "Receive Impact alert push notifications.",
	"Save footage to_": "Save footage to the cloud and do much more...",
	"Free plan included_": "Free plan included · Easy setup · Cancel anytime",
	"Taking advantage of_": "Taking advantage of a mobile or car-embedded Internet connection and a BlackVue camera, BlackVue Cloud connects you to your car from anywhere, anytime. Using the BlackVue App on your smartphone or tablet, you see in real time where your car is located and what is happening around it.",
	"Get notifications to_": "Get notifications to your phone when your parked car is hit. Check remotely what is happening around your car.",
	"Monitor your commercial_": "Monitor your commercial vehicles on a map in real time. Talk to your drivers anytime through the BlackVue App or Viewer.",
	"With BlackVue Fleet_": "With BlackVue Fleet Tracking, track in real time up to 100 vehicles from the palm of your hand or with the dedicated BlackVue Viewer.",
	"Get started now_": "Get started now with a Free plan. For unlimited video playback or Remote Live View, upgrade to Lite or Smart plan from the BlackVue App. <br/>Business and power users can unlock the power of the Fleet plan exclusively through this website.",
	"Remote Video Playback_": "Remote Video Playback and Download",
	"Compatible with DR650GW_": "Compatible with DR650GW, DR650S models",
	"Unlimited remote video_": "Unlimited remote video playback and download",
	"Longer cloud storage_": "Longer cloud storage file expiration period",
	"Longer storage period_live": "Longer storage period for Event live auto upload",
	"Longer storage period_file": "Longer storage period for Event file auto upload",
	"Goefence setup (PC_": "Geo-fence setup (PC viewer) and alerts (Windows viewer and app)",
	"App Store": "App Store",
	"Send reset password email": "إرسال بريد إلكتروني لإعادة تعيين كلمة المرور",
	Customers: Customers$g,
	Home: Home$g,
	"Pick a plan": "Pick a plan",
	"No customers yet": "No customers yet",
	"Customers will_": "Customers will show up here as they become available",
	"Add customer": "Add customer",
	"Report(PDF)": "Report(PDF)",
	"Subscription Period": "Subscription Period",
	Plan: Plan$g,
	New: New$g,
	Unsubscribed: Unsubscribed$g,
	"Subscription ends soon": "Subscription ends soon",
	Edit: Edit$g,
	"1 month trial": "1 month trial",
	"Edit customer details": "Edit customer details",
	"Customer name": "Customer name",
	"of 999 available_": "of 999 available on Fleet Plan",
	"Subscription starts": "Subscription starts",
	"Subscription period": "Subscription period",
	month: month$g,
	months: months$g,
	"Cloud storage": "Cloud Storage",
	"Subscription plan": "نوع الاشتراك",
	"Check email address": "Check email address",
	"Add customer details": "Add customer details",
	Continue: Continue$g,
	Back: Back$g,
	"An error occured": "An error occured",
	"Customer added": "Customer added",
	"Last changed": "Last changed",
	"Company name": "Company name",
	"Company address": "Company address",
	"Alert Push Notifications": "Alert Push Notifications",
	"Receive notifications on_": "Receive notifications on your phone when preset Events occur. Great in combination with BlackVue’s Parking Mode.",
	"Remote Live View": "عرض مباشر عن بعد",
	"Remotely monitor your_": "Remotely monitor your car in real time from anywhere, anytime.",
	"Video Backup/Auto Upload": "Video Backup/Auto Upload",
	"Back up videos_": "Back up videos to your phone or Cloud storage.",
	"Two-way Voice Communication": "Two-way Voice Communication",
	"Talk with people_": "Talk with people in the car from your smartphone. The driver can speak while keeping hands on the wheel.",
	"View your car’s_": "View your car’s location and speed on a map. With BlackVue Fleet Tracking, access 90-days’ worth of GPS data.",
	"Remote Video Playback": "Remote Video Playback",
	"Play videos stored_": "Play videos stored in the Cloud or in your dashcam anytime on your smartphone or tablet.",
	"Event Live Auto Upload": "Event Live Auto Upload",
	"Save a video stream_": "Save a video stream in real time to the Cloud. Protect yourself from break-ins and theft.",
	"Event File Auto Upload": "Event File Auto Upload",
	"Save Event videos_": "Save Event videos to the Cloud—including seconds before trigger—after they happen.",
	"Firmware-Over-the-Air (FOTA)": "Firmware-Over-the-Air (FOTA)",
	"Upgrade your dashcam’s": "Update your dashcam over the cloud",
	"When an Event_": "When an Event is created (Impact detected or manually triggered), Event Live Auto-upload lets your Cloud-compatible BlackVue save a live video stream from a camera of your choice (front or rear/interior) to the Cloud server",
	"Event File Auto-upload_": "Event File Auto-upload lets your dashcam automatically upload low-resolution versions of Event files to the Cloud.",
	Master: Master$g,
	"per Camera": "per Camera",
	"Event live auto upload_": "Event live auto upload compatible with all cloud cameras",
	"Drive report": "Drive report",
	"USA/Canada Toll Free": "USA/Canada Toll Free",
	"Monday–Saturday_": "Monday to Friday 8am-7pm / Saturday 9am-6pm (PST).",
	"Please agree to_": "You must accept Terms of Service",
	"Mac or Windows PC": "Mac or Windows PC",
	Develop: Develop$g,
	"Sign out": "Sign out",
	"Referral code": "رمز الإحالة",
	"Total after 1 month trial": "الإجمالي بعد فترة تجريبية لمدة شهر",
	"Already Use Stripe Token": "رمز Stripe المميز مستخدم بالفعل",
	"Select period": "تحديد فترة",
	"State/Region": "الولاية/المنطقة (اختياري)",
	"ZIP/Postal": "ZIP/الرمز البريدي",
	"$0.00": "$0.00",
	"$11.99": "$11.99",
	"$24.99": "$24.99",
	$9: $9$g,
	$15: $15$g,
	$10: $10$g,
	"mo + for_": "/mo + {{a}} per extra camera",
	mo: mo$g,
	"This e-mail address_": "هذا البريد الإلكتروني له حساب مسجل بالفعل.",
	"1 month": "شهر",
	"Limit is reset daily": "تتم إعادة تعيين الحد يوميًا",
	"Limit is reset monthly": "تتم إعادة تعيين الحد شهريًا",
	"Video plays and downloads": "تشغيلات الفيديو وتنزيلاته",
	"Your master": "Your owner",
	"Youre 1 step_": "أنت على بعد خطوة من إنهاء الاشتراك في خطة الأسطول",
	"Finish signing up": "إنهاء التسجيل",
	"Enter billing information": "أدخل معلومات الفوترة",
	"Proceed to billing": "انتقل إلى الفوترة",
	City: City$g,
	Charge: Charge$g,
	"User already invited_": "تمت دعوة المستخدم بالفعل بواسطة المسؤول",
	"n% consumed": "‎{{a}}‎%‎ مستخدَم",
	"E-mail already exists": "البريد الإلكتروني موجود بالفعل",
	"Cancel your inapp_": "إلغاء اشتراكك داخل التطبيق",
	"You have cancel_": "يجب إلغاء اشتراكك داخل التطبيق للترقية إلى خطة الأسطول: 1. قم بإلغاء اشتراكك الحالي في ‎App Store‎ أو متجر ‎Google Play‎. سترجع إلى إصدار أقدم من الخطة المجانية في نهاية دورة الفوترة الحالية. ستظل جميع بياناتك سليمة. 2. قم بتسجيل الدخول إلى حسابك على ‎blackvuecloud.com‎، ثم قم بالترقية إلى خطة الأسطول.",
	"Edit permissions": "تحرير الأذونات",
	"See permissions": "عرض الأذونات",
	"Submaster removed": "تمت إزالة المستخدم التابع",
	"Camera removed": "تمت إزالة الكاميرا",
	"User removed": "تمت إزالة المستخدم",
	"Users removed": "تمت إزالة المستخدمين",
	subscribe: subscribe$g,
	search: search$g,
	"permission can be_": "يمكن إعداد الإذن بعد قبول المستخدم التابع الدعوة.",
	"The confirmation link_": "لم يعد رابط التأكيد صالحًا",
	"Possible reasons:_": "الأسباب المحتملة:\n • لقد قمت بتأكيد عنوان بريدك الإلكتروني بالفعل\n • انتهت صلاحية الرابط أو تم إلغاؤه",
	"Failed to register_": "فشل التسجيل في ‎BlackVue Cloud‎",
	"There was an_": "حدث خطأ في أثناء عملية التسجيل. إذا استمرت المشكلة، فحاول التسجيل في ‎BlackVue Cloud‎ مرة أخرى. إذا احتجت إلى المزيد من المساعدة، يُرجى الاتصال بقسم دعم العملاء على:",
	"Upgrade to Fleet_": "الترقية إلى خطة الأسطول",
	"Subscription is Canceled": "تم إلغاء الاشتراك",
	"No members yet": "لا يوجد أعضاء حتى الآن",
	"Please enter_group name": "أدخل اسم مجموعة صالحًا",
	"Group Name": "اسم المجموعة",
	invalid_number: invalid_number$g,
	invalid_expiry_month: invalid_expiry_month$g,
	invalid_expiry_year: invalid_expiry_year$g,
	invalid_cvc: invalid_cvc$g,
	incorrect_number: incorrect_number$g,
	incomplete_number: incomplete_number$g,
	incomplete_cvc: incomplete_cvc$g,
	incomplete_expiry: incomplete_expiry$g,
	expired_card: expired_card$g,
	incorrect_cvc: incorrect_cvc$g,
	incorrect_zip: incorrect_zip$g,
	invalid_expiry_year_past: invalid_expiry_year_past$g,
	card_declined: card_declined$g,
	missing: missing$g,
	processing_error: processing_error$g,
	"no groups yet": "لا توجد مجموعات حتى الآن",
	"groups will show_": "ستظهر المجموعات هنا عند توفرها",
	"Fleet members will_": "سيظهر أعضاء الأسطول هنا عند توفرهم",
	"service provider": "مزود الخدمة",
	Paypal: Paypal$g,
	iOS: iOS$g,
	Android: Android$g,
	"Enter email": "Please enter a email address",
	"Enter password": "يرجى إدخال كلمة المرور.",
	"Enter first name": "أدخل الاسم الأول",
	"Enter last name": "أدخل الاسم الأخير",
	"Enter the current_": "أدخل كلمة المرور الحالية",
	"Enter a new_": "أدخل كلمة مرور جديدة",
	"There isnt an_": "لا يوجد حساب مرتبط بعنوان البريد الإلكتروني هذا",
	"Fleet Plan": "Fleet Plan",
	Total: Total$g,
	"Password you entered_": "كلمة المرور التي أدخلتها غير صحيحة",
	"Incorrect email or_": "البريد الإلكتروني غير صحيح أو كلمة المرور غير صحيحة",
	"Available to Masters": "متوفر للمالك",
	"Blackvue url": "https://www.blackvue.com",
	"Information We Collect_": "المعلومات التي نجمعها وسبب جمعها",
	And: And$g,
	"Terms of Location-Based_": "شروط استخدام الخدمة القائمة على الموقع.",
	"I agree to the_": "أوافق على",
	"Password Reset_": "لقد أرسلنا بريدًا إلكترونيًا إلى ‎{{a}}‎ يحتوي على تعليمات إعادة تعيين كلمة المرور.",
	"You have already_": "تمت دعوتك بالفعل، تحقق من بريدك الإلكتروني.",
	"No data available_": "لا تتوفر بيانات في الجدول",
	Camera: Camera$g,
	"You no longer_": "لم يعد لديك إذن لاستخدام خدمة الأسطول.",
	"Please contact your_": "يرجى الاتصال بالمسؤول للأسطول لحل المشكلة.",
	"You can still_": "لا يزال بإمكانك الوصول إلى",
	"account information": "معلومات حسابك.",
	"If the issue_": "إذا لم يتم حل المشكلة وقررت الاستمرار في استخدام خدمة ‎BlackVue Cloud‎ باستخدام عنوان البريد الإلكتروني المسجل، فسيتعين عليك حذف حسابك والتسجيل مرة أخرى.",
	"If the problem_": "إذا استمرت المشكلة، فاتصل بقسم دعم العملاء:",
	"Web subscription only": "اشتراك الويب فقط",
	"AppStore url": "‎https://apps.apple.com/kr‎",
	"We no longer_": "لم نعد نعالج المدفوعات من خلال PayPal. يجب عليك تحديث اشتراكك لتغيير عدد الكاميرات: 1. قم بتسجيل الدخول إلى حسابك على ‎paypal.com‎، وإلغاء اشتراكك الحالي في خطة الأسطول لتغيير عدد الكاميرات: 2. قم بتسجيل الدخول إلى حسابك على ‎blackvuecloud.com‎، ثم قم بالترقية إلى خطة الأسطول.",
	Yes: Yes$g,
	No: No$g,
	"Serial number": "الرقم التسلسلي",
	"Cloud code": "رمز السحابة",
	"Terms & Policies": "الشروط والسياسات",
	News: News$g,
	Notifications: Notifications$g,
	"km/h": "km/h",
	MPH: MPH$g,
	"Baidu Maps": "Baidu Maps (الصين فقط)",
	"Google Maps": "‎Google Maps‎",
	Firmware: Firmware$g,
	Basic: Basic$g,
	"Time Zone": "المنطقة الزمنية",
	Resolution: Resolution$g,
	"Image quality": "جودة الصورة",
	Brightness: Brightness$g,
	Recording: Recording$g,
	"Normal recording": "التسجيل العادي",
	"Voice recording": "التسجيل الصوتي",
	"Video segment length": "طول مقطع الفيديو",
	"Rear camera recording": "تسجيل الكاميرا الخلفية",
	Highest: Highest$g,
	High: High$g,
	Normal: Normal$g,
	"1 min": "دقيقة",
	"2 min": "دقيقتان",
	"3 min": "3 دقائق",
	Sensitivity: Sensitivity$g,
	"Motion detection": "اكتشاف الحركة",
	"Speed alert": "تنبيه السرعة",
	"Voice guidance": "الإرشاد الصوتي",
	"Power on": "تشغيل",
	"Power off": "إيقاف التشغيل",
	"Starting normal recording": "جارٍ بدء التسجيل العادي",
	"Changing recording mode": "وضع تسجيل التغييرات",
	"Speed alert (beep)": "تنبيه السرعة (صفير)",
	"Cloud related": "مرتبط بالسحابة",
	Volume: Volume$g,
	"User text overlay": "تراكب نص المستخدم",
	"A-Z, a-z_": "A-‏Z‏، a‏-z‏، 0‏-9، :;’//+-_()$#‏‎\nأقل من 20 رمزًا.",
	"Wi-Fi auto turn off": "إيقاف التشغيل التلقائي لشبكة Wi-Fi",
	"Login credentials": "بيانات اعتماد تسجيل الدخول",
	"Manual recording": "التسجيل اليدوي",
	"By sharing your_": "من خلال مشاركة العرض المباشر، يمكنك السماح للمستخدمين الآخرين بتجربة إثارة القيادة ومتعتها بشكل غير مباشر في جميع أنحاء العالم.",
	"However, as persona_": "لكن نظرًا إلى أنه قد يتم إرسال مقطع فيديو شخصي، يجب أن تنتبه جيدًا عند تحديد المعلومات التي تشاركها.",
	"Please enter_email_2": "يرجى إدخال عنوان بريد إلكتروني صالح. قد لا يُسمح بالبريد الإلكتروني مع بعض الأحرف الخاصة. على سبيل المثال) +، &",
	"Password is incorrect": "كلمة المرور غير صحيحة.",
	"This camera is already_": "تم تسجيل الكاميرا بالفعل لحساب BlackVue.",
	"Camera name must_": "يجب أن يحتوي اسم الكاميرا على 5 إلى 32 رمزًا.",
	"Failed to save_": "فشل حفظ إعدادات الكاميرا.",
	"Unallowed character detected": "تم اكتشاف رمز غير مسموح به.",
	"File(s) queued for_": "تم وضع الملف (الملفات) في قائمة الانتظار لتحميل السحابة.",
	"Exceeded video play_": "تم تجاوز حد تشغيل الفيديو وتنزيله.",
	"Playback Failed": "فشلت إعادة التشغيل.",
	"Exceeded your Live_": "تم تجاوز حد وقت العرض المباشر.",
	"The camera is not_": "الكاميرا غير متصلة بالخادم.",
	"Please check the connection_": "يرجى التحقق من حالة اتصال الكاميرا المحددة.",
	Close: Close$g,
	"Map": "الخريطة",
	Cloud: Cloud$g,
	Public: Public$g,
	"Flip horizontally": "القلب أفقيًا",
	Front: Front$g,
	Rear: Rear$g,
	Play: Play$g,
	Stop: Stop$g,
	Pause: Pause$g,
	"Next frame": "الإطار التالي",
	"Previous frame": "الإطار السابق",
	"Proximity sensor": "مستشعر القرب",
	"Voice recording on/off": "تشغيل/إيقاف تشغيل التسجيل الصوتي",
	"The BlackVue dashcam_": "كاميرا لوحة القيادة BlackVue غير متوافقة مع الشبكات اللاسلكية سعة ‎5GHz.",
	Time: Time$g,
	"Daylight saving time": "التوقيت الصيفي",
	System: System$g,
	"Incorrect camera serial_": "الرقم التسلسلي للكاميرا غير صحيح.",
	"Lock event files": "تأمين ملفات الحدث",
	"Overwrite locked event_": "استبدال ملفات الحدث المؤمّنة عند اكتمالها",
	"Camera settings saved_": "تم حفظ إعدادات الكاميرا بنجاح.",
	"Front camera": "الكاميرا الأمامية",
	"Rear camera": "الكاميرا الخلفية",
	Event: Event$g,
	Parking: Parking$g,
	"GPS tracking": "تعقب GPS",
	"G-force detected": "قوة الجاذبية المكتشفة",
	"Impact detected in_": "تم اكتشاف التأثير في وضع الإيقاف",
	"Scheduled reboot": "إعادة التشغيل المجدولة",
	"Recording status": "حالة التسجيل",
	"Rear security": "الأمان الخلفي",
	"Time lapse": "لقطات متتابعة",
	"Sync with GPS_": "مزامنة مع وقت GPS",
	"Overwrite locked event3_": "استبدال الملفات المؤمّنة بملفات الحدث الجديدة عند امتلاء وحدة التخزين",
	"Video codec": "برنامج ترميز الفيديو",
	"Tracking logs": "سجلات التتبع",
	"Geofence alerts": "تنبيه السياج الجغرافي",
	Color: Color$g,
	Exit: Exit$g,
	Save: Save$g,
	Impact: Impact$g,
	Unlimited: Unlimited$g,
	"Parking mode recording": "تسجيل وضع إيقاف السيارة",
	"Battery protection": "حماية البطارية",
	"Cut-off timer": "مؤقت إيقاف",
	"Low voltage cut-off": "إيقاف الجهد المنخفض",
	"Rear camera orientation": "توجيه الكاميرا الخلفية",
	Default: Default$g,
	"Rotate video 180°": "تدوير الفيديو 180 درجة",
	"Mirror video": "النسخ المتطابق للفيديو",
	"Wi-Fi band": "نطاق شبكة Wi-Fi",
	"Driving report": "تقرير القيادة",
	"Unsupported video codec_": "برنامج ترميز الفيديو غير مدعوم(H.265).",
	"Rear camera recording_": "تسجيل الكاميرا الخلفية في وضع إيقاف السيارة",
	"Front and rear_": "تسجل الكاميرا الأمامية والخلفية معًا",
	"Rear camera stops_": "توقفت الكاميرا الخلفية عن التسجيل مدة 5 دقائق بعد الدخول في وضع إيقاف السيارة. يبدأ التسجيل عند الدخول في الوضع العادي.",
	"Remote firmware update": "تحديث البرنامج الثابت عن بعد",
	"Firmware is up-to-date": "البرنامج الثابت محدث",
	"New firmware available": "يوجد برنامج ثابت جديد متوفر.",
	Version: Version$g,
	"Release date": "تاريخ الإصدار",
	Language: Language$g,
	"File size": "حجم الملف",
	"What’s new": "ما الجديد",
	"Updating may take_": "قد يستغرق التحديث عدة دقائق.",
	"The update process_": "لا يمكن إلغاء عملية التحديث.",
	"Do not disconnect the_": "لا تفصل كابل الطاقة حتى يُعاد تشغيل التسجيل العادي.",
	"Downloading firmware": "جارٍ تنزيل البرنامج الثابت",
	"Once download is_": "بمجرد اكتمال التنزيل، سيُعاد تشغيل كاميرا BlackVue تلقائيًا لتطبيق البرنامج الثابت الجديد.",
	"If not allowed_": "إذا لم يتم السماح، فلن يكون موقع سيارتك وسرعتها قابلين للوصول إليهما عبر السحابة.",
	"Unable to initiate update because_": "تعذر بدء التحديث، لأن كاميرا لوحة القيادة متصلة بجهاز عبر شبكة Wi-Fi مباشرة.",
	Notification: Notification$g,
	Multiple: Multiple$g,
	Range: Range$g,
	"HDR night vision": "رؤية ليلية بدقة HDR",
	Download: Download$g,
	"G-sensor": "G-Sensor",
	Manual: Manual$g,
	"Low voltage warning": "تحذير الجهد المنخفض",
	Satellite: Satellite$g,
	"Data usage": "استخدام البيانات",
	"Select video download quality": "Select video download quality",
	"Quick play file_": "Quick play file (low resolution)",
	"Original file": "Original file",
	"You do not have permission_": "You do not have permission to run this function.\nPlease contact your account owner.",
	"Interior camera recording_": "تسجيل الكاميرا الداخلية في وضع إيقاف السيارة",
	"Interior security": "الأمان الداخلي",
	"Interior camera rotation": "تدوير الكاميرا الداخلية",
	"Multi View": "العرض المتعدد",
	Tutorials: Tutorials$g,
	"Upgrade now": "الترقية الآن",
	"Members will show_": "سيظهر الأعضاء هنا عندما يصبحون متاحين",
	"Are you sure_delete members": "هل تريد بالتأكيد حذف الأعضاء نهائيًا؟",
	"Some members may_": "قد يتم إخفاء بعض الأعضاء بسبب عوامل التصفية المستخدمة.",
	"Invited on_": "تمت الدعوة في ‎ {{Invited Date} بواسطتك. المالك",
	Filter: Filter$g,
	"Date created": "تاريخ الإنشاء",
	"No admin yet": "لا يوجد مسؤول حتى الآن",
	"You can add_admin": "يمكنك إضافة مسؤول واحد لكل مجموعة",
	"Collapse all": "طي الكل",
	"Expand all": "توسيع الكل",
	"Download and playback_cloud": "التنزيل والتشغيل من التخزين السحابي",
	"Are you sure_2": "هل تريد بالتأكيد حذف المجموعة ‎{Group ‎name}‎؟",
	"Are you sure_groups": "هل تريد بالتأكيد حذف المجموعات؟",
	"Add cameras first_drivers": "أضف الكاميرات أولاً، ثم قم بتعيين السائقين",
	"Flip vertically": "العكس رأسيًا",
	Sun: Sun$g,
	Mon: Mon$g,
	Tue: Tue$g,
	Wed: Wed$g,
	Thu: Thu$g,
	Fri: Fri$g,
	Sat: Sat$g,
	Dates: Dates$g,
	Routes: Routes$g,
	Opacity: Opacity$g,
	"Color and opacity": "اللون ومعدل الشفافية",
	"Geofences will show_": "ستظهر السياجات الجغرافية هنا عند توفرها",
	"Start drawing a shape_": "بدء رسم الشكل على الخريطة",
	"Add geofence": "إضافة سياج جغرافي",
	Entry: Entry$g,
	"Show all members": "إظهار جميع الأعضاء",
	"Me and my_": "أنا وسيارتي. تم الاتصال",
	"add-on service for_": "خدمة Blackvue إضافية متوافقة مع السحابة",
	"Continue with Google": "المتابعة باستخدام Google",
	"An account with_": "يوجد حساب بعنوان البريد الإلكتروني هذا بالفعل، ولكن لم يتم التحقق منه. أدخل كلمة مرور ‎BlackVue Cloud‎ الحالية لتسجيل الدخول.",
	"Account does not_": "الحساب غير موجود. أو حاول تسجيل الدخول باستخدام حساب Apple أو Google الخاص بك.",
	"Continue with Apple": "المتابعة باستخدام Apple",
	"Get started": "البدء",
	"P subscription only": "<b>{{a}}</b> الاشتراك فقط",
	"+N USD for extra camera_": "+{{a}} USD for extra camera up to {{b}} Cameras",
	"Unlimited Live view": "Unlimited Live View",
	"Cameras per Account": "Cameras per Account",
	"Users per Account": "Users per Account",
	Owner: Owner$g,
	"Live View per Day": "Live View per Day",
	"Remote Video Playback_2": "Remote Video Playback and Download per Month",
	"N days": "{{a}} Days",
	"Video On Map": "Video On Map",
	Undetected: Undetected$g,
	Distracted: Distracted$g,
	Drowsy: Drowsy$g,
	"Whether on mobile_": "Whether on mobile or your computer, BlackVue gives you the tools to fully enjoy your dashcam’s functions. Download the latest <a1>firmware</a1>, <a2>mobile</a2> and <a3>desktop</a3> applications, or use <a4>BlackVue web app</a4> in your browser.",
	"Compatible with most_": "Compatible with most Wi-Fi BlackVue models. Cloud support for all Cloud-compatible dashcam models down to DR650GW Series with <b>Cloud Firmware</b>.",
	"Supports most recent BlackVue_": "Supports most recent BlackVue models and compatible with BlackVue Cloud.<br/>\nThis Viewer contains <b>two applications in one</b>: the SD Card Viewer lets you view recorded videos from your SD card and modify the settings of your BlackVue, as well as format the SD card; the <b>Cloud Viewer</b> lets you enjoy BlackVue Cloud.",
	"Contact us": "Contact us",
	"6 characters with": "6 رموز تشمل مزيجًا من الأحرف والأرقام والرموز",
	"Apps and more...": "Apps and more...",
	"Cameras will show_": "Cameras will show up here as they become available.",
	"Keep this page_": "اترك هذه الصفحة مفتوحة في أثناء التحقق من رمز التأكيد. جرب مجلد البريد العشوائي إذا لم تتمكن من العثور على البريد الإلكتروني في صندوق الوارد.",
	"n cameras": "{{n}} من الكاميرات",
	"n slots": "{{n}} من الفتحات",
	"Calculate your Fleet_": "حساب سعر خطة الأسطول الخاصة بك",
	"Code you entered_": "الرمز الذي أدخلته غير صحيح/انتهت صلاحيته",
	Calling: Calling$g,
	Smoking: Smoking$g,
	"Smoking has been_": "تم اكتشاف التدخين أثناء القيادة.",
	"Email is already_": "البريد الإلكتروني موجود بالفعل.",
	"Serial number and_": "الرقم التسلسلي ورمز السحابة مطبوعان على الكاميرا",
	"Allow GPS access": "السماح بالوصول إلى GPS",
	"Used to access_": "يُستخدم للوصول إلى موقع سيارتك وسرعتها. يمكنك تغيير إعدادات GPS لاحقًا في إعدادات خصوصية الكاميرا.",
	"Incorrect cloud code": "رمز سحابة غير صحيح",
	"An account is_": "تم تسجيل حساب بالفعل باستخدام عنوان البريد الإلكتروني هذا.",
	"Live event upload": "تحميل الحدث المباشر",
	Permissions: Permissions$g,
	"Assign in": "تعيين في",
	"Are you sure_camera": "هل أنت متأكد أنك تريد حذف هذه الكاميرا؟",
	"Uploading videos:": "تحميل فيديوهات:",
	"GPS location recording": "تسجيل موقع GPS",
	"When OFF, GPS_": "عند إيقاف التشغيل (OFF)، لا يتم تسجيل موقع GPS أو إرساله إلى خادم السحابة.",
	"As personal video_": "نظرًا إلى أنه قد يتم إرسال مقطع فيديو شخصي، يجب أن تنتبه جيدًا عند تحديد المعلومات التي تشاركها.",
	"Share location": "مشاركة الموقع",
	Private: Private$g,
	"Used to access_2": "يُستخدم للوصول إلى موقع سيارتك وسرعتها.",
	"Share live view": "مشاركة فيديو العرض المباشر",
	"Share live audio": "مشاركة صوت العرض المباشر",
	"Share camera’s name": "مشاركة اسم كاميرا لوحة القيادة",
	"Impact detection": "اكتشاف تصادم",
	Entering: Entering$g,
	Exiting: Exiting$g,
	"Normal event recording": "تسجيل الحدث العادي",
	"Harsh braking": "كبح شديد",
	Acceleration: Acceleration$g,
	"Sharp turn": "انعطاف حاد",
	"Parking event recording": "تسجيل حدث وقوف السيارات",
	Passing: Passing$g,
	"Video source": "مصدر الفيديو",
	Overspeed: Overspeed$g,
	"Are you sure_video": "هل تريد بالتأكيد حذف مقطع الفيديو هذا؟",
	"Add camera to_": "إضافة كاميرا إلى العرض المباشر",
	"No routes to_": "لا توجد مسارات لإظهارها",
	"Start by adding_": "ابدأ بإضافة التواريخ.",
	"invite sent": "تم إرسال الدعوة",
	Recipients: Recipients$g,
	Send: Send$g,
	"Routes selected_": "المسارات التي تم تحديدها: {{n}} من {{total}}",
	"Map service": "خدمة الخرائط",
	"Speed units": "وحدات السرعة",
	Note: Note$g,
	"Release notes": "ملحوظات الإصدار",
	"The name must_": "يجب أن يتراوح طول الاسم بين 1 و30 حرفًا.",
	Video: Video$g,
	Advanced: Advanced$g,
	"Firmware language": "لغة البرنامج الثابت",
	"Wi-Fi": "شبكة Wi-‎Fi",
	Voice: Voice$g,
	"Show date and_": "إظهار التاريخ والوقت",
	"Show speed": "إظهار السرعة",
	"Front camera rotation": "دوران الكاميرا الأمامية",
	"Manual time settings": "إعدادات الوقت اليدوية",
	"Recommended for better_": "يوصى به لتحسين الضغط وتقليل حجم الملف ودقة ‎4K UHD‎.",
	"For full compatibility_": "من أجل التوافق التام مع أجهزة سطح المكتب والأجهزة المحمولة الأقدم.",
	"Up and down": "لأعلى ولأسفل",
	"Side to side": "من جانب إلى جانب",
	"Front and back": "من الأمام والخلف",
	"Detection region": "منطقة الاكتشاف",
	"Hotspot 1": "نقطة الاتصال 1",
	"Hotspot 2": "نقطة الاتصال 2",
	"Hotspot 3": "نقطة الاتصال 3",
	"Enter/exit": "دخول/خروج",
	"Event recording": "تسجيل الحدث",
	"Front security (Normal)": "الأمان الأمامي (عادي)",
	"Front security (Parking)": "الأمان الأمامي (إيقاف السيارة)",
	"LTE (Parking)": "LTE (إيقاف السيارة)",
	"Wi-Fi (Parking)": "شبكة Wi-Fi (إيقاف السيارة)",
	"Turn on at startup": "تشغيل عند بدء التشغيل",
	"Turn off after_": "إيقاف التشغيل بعد 10 دقائق من عدم النشاط",
	"Your firmware is_": "البرنامج الثابت محدث",
	"Add admin": "إضافة مسؤول",
	"Remove All/n": "إزالة الكل/{{a}}",
	"Are you sure_remove": "هل تريد بالتأكيد حذف الكاميرات من هذه المجموعة؟",
	"This will cancel_2": "سيؤدي ذلك إلى إلغاء اشتراك خطة الأسطول الخاصة بك. سترجع إلى إصدار أقدم من الخطة المجانية في نهاية دورة الفوترة الحالية.",
	"You’ve reached_": "لقد وصلت إلى حد السائقين المسموح به لكل كاميرا",
	"Are you sure_remove admin": "هل تريد بالتأكيد إزالة المسؤول {{a}{{b}} من هذه المجموعة؟",
	"Fleet Plan · Owner": "Fleet Plan · Owner",
	"Manage cameras": "إدارة الكاميرات",
	"Are you sure_delete zone": "هل تريد بالتأكيد حذف المنطقة \"{{zone}}\"؟",
	"available on your_2": "{{a}}/{{b}} متوفر في خطتك",
	"The new plan_2": "ستسري الخطة الجديدة في نهاية دورة الفوترة الحالية ({{a}}).",
	"Canceled Fleet Plan_": "تم إلغاء خطة الأسطول في {{a}}",
	"Hard braking alert (beep)": "تنبيه الكبح الشديد (صفير)",
	"Hard acceleration alert (beep)": "تنبيه التسارع الشديد (صفير)",
	"Hard cornering alert (beep)": "تنبيه الانعطاف الشديد (صفير)",
	"SSID must be_": "يجب ألا يقل طول SSID عن 5 رموز.",
	"Password must be_": "يجب ألا يقل طول كلمة المرور عن 8 رموز.",
	"5 to 32 characters long": "من 5 إلى 32 رمزًا",
	"8 to 32 characters long": "من 8 إلى 32 رمزًا",
	"Longer storage period_event": "فترة تخزين أطول لتحميل الحدث المباشر",
	"Requires latest firmware_": "يتطلب أحدث برنامج ثابت. غير متوافق مع الطرازين DR650S وDR650GW",
	"After Blackvue is_": "بعد توصيل Blackvue بالسحابة، سيتم حفظ الإعدادات.",
	"This is an_": "هذا البريد الإلكتروني غير مسجل. هل ترغب في تسجيل حساب جديد؟",
	"This feature is_": "هذه الميزة متاحة لمشتركي خطة الأسطول فقط.",
	"Please return to_": "الحساب غير موجود. أو حاول تسجيل الدخول باستخدام حساب Apple أو Google الخاص بك.",
	"Adjusting the cut-off voltage_": "Adjusting the cut-off voltage to a lower setting may result in your dash cam draining more power from your battery.\nThis could result in warning messages of battery drain or affect other vehicle functions.\nPlease consult with your dealership before lowering the voltage.",
	"Your videos will_": "ستظهر فيديوهاتك هنا عندما تصبح متوافرة.",
	"You drove:_": "لقد قدت: {{distance}}،‏ {{time}}",
	"Event count per_": "عدد الأحداث لكل ساعة قيادة",
	"Are you sure_recipient": "هل تريد بالتأكيد حذف هذا المستلم؟",
	"(You)": "{{a}} (أنت)",
	"All events": "كل الأحداث",
	Days_: Days_$g,
	"Requires DMC 200_": "يتطلب كاميرا DMC 200",
	"A DMS and compatible_": "يتطلب نظام مراقبة السائق وكاميرا لوحة قيادة متوافقة لعرض هذا التقرير.",
	"Notifications will show_": "ستظهر الإشعارات هنا عند توفرها.",
	"Try changing your_": "حاول تغيير التاريخ أو إزالة عوامل التصفية.",
	Mute: Mute$g,
	UnMute: UnMute$g,
	"Calling and smoking_": "يتم اكتشاف المكالمات والتدخين بواسطة جهاز DMC 200 فقط",
	"You need a DMS_": "تحتاج إلى DMS لعرض هذا التقرير.",
	"Try BlackVue Cloud": "جرب BlackVue Cloud اليوم",
	"Individual driver looking_": "هل أنت سائق فردي يبحث عن راحة البال؟ هل أنت صاحب عمل يحتاج إلى حل بسيط يتعلق بأمن المركبات وتتبعها؟",
	"Whoever you are_": "مهما كانت صفتك، ومهما كانت احتياجاتك، هناك خطة سحابة تناسبك!",
	"It is the account that_Driver": "هذا هو الحساب الذي انضم إلى أسطولك على سحابة BlackVue cloud بعد قبول دعوة بالبريد الإلكتروني من المالك أو المسؤول. قد يتم تعيين سائق لكاميرا واحدة فقط مع قدرة محدودة على عرض ملف تعريف حسابه أو حسابها؛ أو العرض المباشر والتشغيل الخاص بالكاميرا التي تم تعيينها له أو لها.",
	"It is the account that_Admin": "هذا هو الحساب الذي انضم إلى أسطولك على سحابة BlackVue cloud بعد قبول دعوة بالبريد الإلكتروني من المالك. قد يتم منح حسابات المسؤول الحقوق التي يتيحها المالك لذلك المسؤول.",
	"Video deleted": "تم حذف مقطع الفيديو",
	"Video delete_plural": "تم حذف مقاطع الفيديو",
	"Driver removed from_": "تمت إزالة السائق من المجموعة",
	"Admin removed from_": "تمت إزالة المسؤول من المجموعة",
	"Camera removed from_": "تمت إزالة الكاميرا من المجموعة",
	"Are you sure_videos": "هل تريد حذف الملف (الملفات) المحدد؟",
	"You have to cancel_fleet": "يجب عليك إلغاء اشتراكك داخل التطبيق لتغيير عدد الكاميرات:\n \n 1. قم بإلغاء اشتراكك الحالي في ‎App Store‎ أو متجر ‎Google Play‎. سترجع إلى إصدار أقدم من الخطة المجانية في نهاية دورة الفوترة الحالية. ستظل جميع بياناتك سليمة. 2. قم بتسجيل الدخول إلى حسابك على ‎blackvuecloud.com‎، ثم قم بالترقية إلى خطة الأسطول.",
	Discard: Discard$g,
	"Discard unsaved changes?": "هل تريد تجاهل التغييرات غير المحفوظة؟",
	"Incorrect serial number": "الرقم التسلسلي غير صحيح",
	"An error occurred_again": "حدث خطأ. يرجى إعادة المحاولة.",
	"You are subscribed_free": "أنت مشترك في الخطة المجانية لـ BlackVue Cloud.",
	"When an event_": "عند إنشاء حدث (تم اكتشاف التصادم أو تشغيله يدويًا)، يتيح تحميل الحدث المباشر لـ BlackVue حفظ بث فيديو مباشر من الكاميرا التي تختارها إلى خادم السحابة بما يشمل 5 ثوانٍ قبل الحدث.",
	Report: Report$g,
	"How it work": "كيف يعمل؟",
	"Cloud Camera": "كاميرا السحابة",
	"Internet Connection": "اتصال الإنترنت",
	"BlackVue App/Viewer": "BlackVue App/Viewer",
	"All you need_": "كل ما تحتاج إليه هو",
	"Cloud-compatible BlackVue": "BlackVue المتوافق مع السحابة",
	"and a cellular_": "وخطة بيانات خلوية. تتصل بعض النماذج بالسحابة عبر نقطة اتصال Wi-Fi تابعة لطرف آخر. ويوفر البعض الآخر قارئ بطاقة SIM صغيرًا جدًا مدمجًا أو دعم وحدة توصيل المكون الإضافي.",
	"Cloud features at_": "ميزات السحابة بين يديك",
	"Enjoy peace of_": "تمتع براحة البال وأنت تعرف أن BlackVue يراقب سيارتك. إذا حدث خطأ ما، فإن كاميرا لوحة القيادة ترسل إليك رسالة على الفور.",
	"Let your BlackVue_": "دع BlackVue يراقب سيارتك وينبهك عند وقوع حوادث. في اللحظة التي يتم فيها اكتشاف التصادم، سيرسل BlackVue إشعارًا إلى هاتفك أو متصفح الويب الخاص بك، مصحوبًا بلقطة.",
	"Check on your_": "تفقد سيارتك من أي مكان باستخدام العرض المباشر عن بعد. سواء من خلال متصفح الويب أو الهاتف، يمكنك الوصول إلى موجز الفيديو في الوقت الفعلي من كاميرا لوحة القيادة المتصلة بالسحابة والتبديل بسهولة بين الكاميرات الأمامية أو الخلفية أو الداخلية.",
	"Your BlackVue may_": "قد لا يمنع BlackVue حوادث الاصطدام والفرار ولكن إذا حدث ذلك، فهناك احتمال كبير أن يتم التقاط أدلة مصورّة مهمة. استعرض جميع مقاطع الفيديو التي سجلتها كاميرا لوحة القيادة من الهاتف المحمول أو متصفح الويب.",
	"Worried about eating_": "هل أنت قلق من نفاد خطة بياناتك؟ تتيح لك تقنية البث الفرعي من BlackVue الوصول إلى إصدارات خفيفة للغاية من مقاطع الفيديو الخاصة بك لتصفح سريع وعرض بدون تخزين مؤقت.",
	"Move files from_": "انقل الملفات من BlackVue إلى السحابة. احفظ مقطع فيديو واحدًا أو حدد عدة مقاطع للتحميل المجمع. يمكن الوصول إلى الفيديو الذي تم تنزيله على هاتفك باستخدام تطبيق BlackVue ومشاركته من قائمة الذاكرة الداخلية.",
	"View your vehicle’s_": "اعرض موقع مركبتك وسرعة السير في الوقت الفعلي. قم بالترقية إلى خطة ذكية للوصول إلى بيانات التتبع بنظام GPS في الأيام السبعة الماضية.",
	"Get more with_": "احصل على المزيد عن الخطة الذكية",
	"Unlimited Remote Live_": "عرض مباشر عن بعد غير محدود",
	"Up to 3 dashcams_": "ما يصل إلى 3 كاميرات لوحة قيادة ضمن حساب واحد",
	"Want to track_": "هل تريد تتبع أسطول كامل؟ الترقية إلى خطة الأسطول",
	"BlackVue Fleet Tracking_2": "يعد تتبع الأسطول من BlackVue حلاً شاملاً لحماية أسطولك وتتبعه. تتدرج الميزات والأسعار بمرونة لتلبية احتياجات عملك.",
	"Stream real-time video_": "بث مقطع الفيديو في الوقت الفعلي دون حدود. معدل البت: 600 كيلوبت في الثانية",
	"Up to 999 Dashcams": "ما يصل إلى 999 كاميرا لوحة قيادة",
	"Register up to_": "سجل ما يصل إلى 999 كاميرا لوحة قيادة لكل حساب.",
	"15GB of Cloud_": "15 جيجابايت من التخزين السحابي",
	"15GB per additional_": "15 جيجابايت لكل كاميرا لوحة قيادة إضافية. تخزين تحميل تلقائي غير محدود للحدث.",
	"90-days GPS_": "سجلات تتبع بنظام GPS لمدة 90 يومًا",
	"High accuracy: 15_": "دقة عالية: 15 ثانية، فيديو على الخريطة، تصدير البيانات بسهولة.",
	"Unique fleet management_": "تضيف ميزات إدارة الأسطول الفريدة القيمة والراحة",
	"Create geofences and_": "أنشئ سياجات جغرافية واستقبل إشعارات في الوقت الفعلي على الهاتف أو جهاز الكمبيوتر.",
	"View at a_": "اعرض إجمالي المسافة المقطوعة ووقت الخمول وأحداث السرعة وغيرها سريعًا في الجداول التي يمكن طباعتها أو تصديرها.",
	"Multi Live View": "عرض مباشر متعدد",
	"Monitor up to_": "مراقبة ما يصل إلى 4 كاميرات لوحة قيادة في الوقت نفسه",
	"Benefits for you": "مزايا من أجلك",
	Individual: Individual$g,
	"Get notifications to_2": "استقبل إشعارات على هاتفك عند اصطدام سيارتك المتوقفة. تحقق مما يحدث حول سيارتك عن بعد. متوفر على الويب والهاتف المحمول ونظام التشغيل Mac وWindows.",
	"Small business owner": "صاحب عمل صغير",
	"Monitor your commercial_2": "راقب مركباتك التجارية على الخريطة في الوقت الفعلي. تحدث إلى السائقين في أي وقت من خلال المتصفح أو تطبيق BlackVue للهواتف المحمولة أو عارض نظام التشغيل Mac أو Windows.",
	"Company with large_": "شركة ذات أسطول كبير",
	"With BlackVue Fleet_2": "باستخدام تتبع الأسطول من BlackVue، تتبع ما يصل إلى 999 مركبة في الوقت الفعلي من خلال المتصفح أو تطبيق BlackVue للهواتف المحمولة أو عارض نظام التشغيل Mac أو Windows.",
	Subscribed: Subscribed$g,
	"The video was_": "تم تحميل الفيديو بالفعل.",
	Geofence: Geofence$g,
	"500: Internal server error": "500: خطأ بالخادم الداخلي",
	"404: Page not found": "404: لم يتم العثور على الصفحة",
	"Check the web address_": "تحقق من عنوان الويب أو عُد إلى صفحة BlackVue Cloud الرئيسية",
	"home page": "Home page",
	"There isn’t an_": "لا يوجد حساب مرتبط بعنوان البريد الإلكتروني هذا",
	"You can now_password": "يمكنك الآن تسجيل الدخول باستخدام كلمة المرور الجديدة",
	"Are you sure_remove admin2": "هل تريد بالتأكيد حذف المسؤول بشكل نهائي",
	"Admin deleted": "تم حذف المسؤول",
	"Members deleted": "تم حذف الأعضاء",
	"Are you sure_groupName": "هل تريد بالتأكيد حذف المجموعة {{a}}؟",
	"Requires latest firmware": "يتطلب أحدث برنامج ثابت",
	"Selected file(s) moved_": "تم نقل الملف (الملفات) المحدد بنجاح",
	"Are you sure_remove driver2": "هل تريد بالتأكيد إزالة السائق {{a}} ({{b}}) من هذه المجموعة؟",
	"Invite sent": "تم إرسال الدعوة",
	"Safe driving": "قيادة آمنة",
	"Reckless driving": "قيادة متهورة",
	"Inattentive driving": "قيادة غير يقظة",
	"Driving events trend": "اتجاه أحداث القيادة",
	"Driving details": "تفاصيل القيادة",
	Driving: Driving$g,
	Idling: Idling$g,
	Distance: Distance$g,
	"Parking sessions": "جلسات إيقاف السيارة",
	"Parked time": "Parked time",
	"Idle stops": "مصدات الخمول",
	"Idle time": "وقت الخمول",
	"Impact events": "Impact Events",
	Parked: Parked$g,
	Speed: Speed$g,
	"Overspeeding alerts": "تنبيهات تجاوز السرعة",
	Highest_2: Highest_2$g,
	Average: Average$g,
	Geofences: Geofences$g,
	"Entries into a_": "مداخل منطقة",
	"Exits from a_": "مخارج منطقة",
	"No data": "لا توجد بيانات",
	"Hard acceleration": "تسارع",
	"Hard braking": "كبح شديد",
	"Hard cornering": "انعطاف حاد",
	"The number within the brackets_": "يشير الرقم الموجود داخل القوسين إلى متوسط عدد الأحداث لكل ساعة قيادة. إذا قدت لفترة تقل عن ساعة واحدة في اليوم، فسيتم عرض إجمالي عدد الأحداث.",
	"Did you insert_": "هل أدخلت بطاقة SIM؟",
	"Click here for_": "<a>انقر هنا</a> للحصول على توجيهات أكثر تفصيلاً.",
	"Back up all_": "<b>انسخ جميع التسجيلات المهمة احتياطيًا قبل حفظ هذه الإعدادات.</b><br/>عند حفظ الإعدادات، ستتم إعادة تهيئة بطاقة microSD وسيتم حذف جميع التسجيلات لضمان استقرار التشغيل.",
	"Not connected to_": "غير متصل بالسحابة. تم تعطيل بعض الوظائف مؤقتًا.",
	"GPS Location recording off": "تم إيقاف تسجيل موقع GPS",
	"n Videos deleted": "تم حذف {{count}} من مقاطع الفيديو",
	Move: Move$g,
	"Driver Monitoring System (DMS) will_": "سيتم تشغيل نظام مراقبة السائق (DMS) قريبًا.",
	"An error occured while_": "حدث خطأ أثناء محاولة تغيير عدد الكاميرات. حاول مجددًا",
	"Reached the limit_": "تم الوصول إلى الحد: {{a}}",
	"An invitation was_": "تم إرسال دعوة بالفعل إلى عنوان البريد الإلكتروني هذا.",
	"To use the_": "لاستخدام ميزة السحابة. يرجى إدخال بطاقة SIM.",
	"Last updated": "آخر تحديث {{date}}",
	"Try changing your date": "حاول تغيير التاريخ.",
	"No event data_": "لم يتم جمع بيانات الحدث للوقت المحدد",
	"Please select another_": "يرجى تحديد يوم أو شهر آخر لعرض تقرير كامل.",
	"more than 6_": "يتطلب أكثر من 6 رموز",
	"Sign up free": "التسجيل مجانًا",
	"Cloud storage warning": "تحذير بشأن التخزين عبر السحابة",
	"Cloud Storage Full": "التخزين عبر السحابة ممتلئ",
	"Cloud storage usage_100": "وصل استخدام التخزين عبر السحابة إلى 100%. يرجى تحرير جزء من مساحة التخزين لتتمكن من استخدام تحميل الحدث المباشر",
	"Cloud storage usage_": "وصل استخدام التخزين عبر السحابة إلى <b>({{a}}%)</b>. \nنظِّم تخزينك عبر السحابة.‎\nلا تتوافر خدمة تحميل الحدث المباشر إذا كان التخزين عبر السحابة ممتلئًا.",
	"Are you sure_delete_zone": "هل تريد بالفعل حذف؟",
	"Search Name or email": "البحث عن الاسم أو البريد الإلكتروني",
	"Search group name": "البحث عن اسم المجموعة",
	"Please note that_": "يرجى ملاحظة أنه سيتم إيقاف تسجيل الفيديو مؤقتًا لبضع ثوان لتطبيق الإعدادات الجديدة.",
	"Currently connected Hotspot": "نقطة اتصال متصلة حاليًا",
	"Enhanced night vision": "رؤية ليلية محسنة",
	"To access the_": "للوصول إلى الكاميرا، يرجى تحديث خطة اشتراكك.",
	"Restarting the Blackvue_": "جارٍ إعادة تشغيل كاميرا BlackVue لتطبيق الإعدادات.",
	"Hard acceleration event_": "يقع حدث التسارع الشديد عندما يكون معدل الزيادة في الثانية أعلى من {{kmh}} كم/ساعة ({{mph}} أميال في الساعة)",
	"Hard braking event_": "يقع حدث الكبح الشديد عندما يكون معدل الانخفاض في \nالثانية أعلى من {{kmh}} كم/ساعة ({{mph}} أميال في الساعة)",
	"Hard cornering event_": "يقع حدث الانعطاف الشديد عند حدوث أكثر من 60 درجة من الدوران خلال ثانيتين من القيادة بسرعة أعلى من \n{{kmh}} كم/ساعة ({{mph}} أميال في الساعة)",
	"Changes you made_": "قد لا يتم حفظ التغييرات التي قمت بإجرائها.",
	"My location": "موقعي",
	"Hotspot name (SSID)": "اسم نقطة الاتصال (SSID)",
	Connected: Connected$g,
	"Camera will be rebooted_": "ستتم إعادة تشغيل الكاميرا. أما زلت تريد المتابعة؟",
	"Restarting the BlackVue_": "إعادة تشغيل BlackVue. يرجى الانتظار قليلاً.",
	"Failed to reboot_": "فشلت إعادة تشغيل الكاميرا",
	"Bluetooth (Parking mode)": "BT (وضع إيقاف السيارة)",
	"Front and interior camera_": "تسجل الكاميرا الأمامية والكاميرا الداخلية معًا.",
	"Interior camera stops_": "توقفت الكاميرا الداخلية عن التسجيل لمدة 5 دقائق بعد الدخول في وضع إيقاف السيارة. يبدأ التسجيل عند الدخول في الوضع العادي.",
	Individual_: Individual_$g,
	"Driver detection": "الكشف عن السائق",
	"During driving only": "أثناء القيادة فقط",
	Always: Always$g,
	"Driver detection box": "مربع الكشف عن السائق",
	"DMS camera rotation": "تدوير كاميرا DSM",
	Low: Low$g,
	Medium: Medium$g,
	High_2: High_2$g,
	"Reboot Camera": "إعادة تشغيل الكاميرا",
	"Latest events": "الأحداث الأخيرة",
	"G-Sensor": "G-Sensor",
	"Playback speed": "سرعة التشغيل",
	Flip: Flip$g,
	Previous: Previous$g,
	Next: Next$g,
	"Map type": "نوع الخريطة",
	"Zoom in": "تكبير",
	"Zoom out": "تصغير",
	"Move to Cloud": "انتقال إلى السحابة",
	"Please recognize that_": "يرجى إدراك أنَّ تسجيل الفيديو سيتوقف مؤقتًا لمدة ثوانٍ لتطبيق الإعدادات.",
	"6 characters with_": "6 رموز تشمل مزيجًا من الأحرف والأرقام والرموز",
	"Updating firmware": "تحديث البرنامج الثابت",
	"Overspeed event occurs_": "يقع حدث تجاوز السرعة عندما تحذر كاميرا لوحة القيادة السائق من تجاوز حد السرعة. يمكنك تغييره من البرنامج الثابت > النظام > مستوى الصوت",
	"Enter group name": "أدخل اسم المجموعة",
	"Live view failed": "فشل العرض المباشر.",
	"Parking mode enter_": "الدخول/الخروج من وضع وقوف السيارات",
	"Cloud connectivity": "اتصال السحابة",
	Expand: Expand$g,
	Collapse: Collapse$g,
	"all day": "طوال اليوم",
	"Driving style": "أسلوب القيادة",
	"Driving impact": "تصادم عند القيادة",
	More: More$g,
	"No cameras to_": "لا توجد كاميرات لإضافتها",
	"You have added_": "لقد أضفت جميع الكاميرات المتوفرة.",
	Multi: Multi$g,
	"Report video": "الإبلاغ عن مقطع فيديو",
	"Sexually explicit content": "محتوى جنسي",
	"Graphic violence": "عنيف أو مثير للاشمئزاز",
	"Hateful speech": "بغيض أو بذيء",
	"Harassment or bullying": "مضايقة أو تنمر",
	"Spam or advertisement": "بريد عشوائي أو إعلان",
	"Infringement of my_": "ينتهك حقوقي",
	"Other reason": "أخرى",
	"Reason for reporting": "سبب الإبلاغ",
	"Reported videos will_": "سيتم فحص مقاطع الفيديو التي تم الإبلاغ عنها في غضون 72 ساعة. لن يتم عرض مقطع الفيديو على خريطة الأحداث حتى يتم التأكيد على أن الفيديو مناسب للنشر على خريطة الأحداث.",
	"Touch sensor": "مستشعر اللمس",
	"Motion and impact detection": "اكتشاف الحركة والتصادم",
	"Settings have been changed": "تم تغيير الإعدادات",
	"Start event recording (beep)": "بدء تسجيل الحدث (صفير)",
	"Scheduled reboots": "عمليات إعادة التشغيل المجدولة",
	Safe: Safe$g,
	Reckless: Reckless$g,
	Inattentive: Inattentive$g,
	"Highest(Extreme)": "الأعلى (شديد)",
	"Public cameras": "الكاميرات العامة",
	List: List$g,
	Usage: Usage$g,
	"Video playbacks and downloads": "عمليات تشغيل الفيديو وتنزيله",
	"of 100 times": "100 مرة",
	"of 10 minutes": "لمدة 10 دقائق",
	Profile: Profile$g,
	"Search geofences": "البحث عن السياجات الجغرافية",
	"Export CSV": "تصدير بصيغة CSV",
	"Exit fullscreen": "الخروج من الشاشة الكاملة",
	Fullscreen: Fullscreen$g,
	Upgrade: Upgrade$g,
	"Email address": "عنوان البريد الإلكتروني",
	"of Unlimited": "غير محدود",
	"No notifications yet": "لم يتم استلام الإخطارات في آخر 7 أيام.",
	"No videos yet": "لا توجد مقاطع فيديو حتى الآن",
	Management: Management$g,
	Day: Day$g,
	Month: Month$g,
	"Welcome to the BlackVue_": "مرحبًا بك في عارض BlackVue Cloud",
	"You can access BlackVue_": "يمكنك الوصول إلى BlackVue Cloud من الويب في أي وقت وفي أي مكان!",
	"Start tour": "بدء جولة",
	"Map view": "عرض الخريطة",
	"Check the current_": "تحقق من موقع GPS الحالي وسرعة الكاميرات والكاميرات العامة.",
	"Camera’s features": "ميزات الكامير",
	"Take a look_": "ألقِ نظرة على الميزات المتنوعة المتعلقة بالسحابة التي توفرها كاميرا BlackVue.",
	"Visualize your vehicle’s_": "تصوّر مسار القيادة لمركبتك بمرور الوقت.",
	"Smart plan_": "الخطة الذكية: 90 أيام، خطة الأسطول: 90 يومًا",
	"Create geofences and2_": "أنشئ سياجات جغرافية واستقبل الإشعارات في الوقت الفعلي.",
	"Got it": "واضح",
	"Manage Fleet members": "إدارة أعضاء الأسطول",
	"Invite fleet members_": "قم بدعوة أعضاء الأسطول وقم بتعيينهم في مجموعات.",
	"The moment the_": "في اللحظة التي تكتشف فيها الكاميرا التصادمات، سيتم إدراج الإشعارات هنا.",
	"Geofence Setup (Web)_": "إعداد السياج الجغرافي (الويب/سطح المكتب) والتنبيهات",
	"Original file play_": "تشغيل الملف الأصلي متاح للتنزيل فقط",
	"To get most_": "لتحقيق أقصى استفادة من عارض BlackVue Cloud، يجب توصيل الكاميرا بالسحابة. قم بتنزيل تطبيق BlackVue وجرب الاقتران السلس، من إضافة الكاميرا إلى الاتصال بالسحابة مرة واحدة!",
	"You haven’t driven_Today": "لم تقم بقيادة سيارتك اليوم حتى الآن. جرب قيادة سيارتك باستخدام BlackVue للتحقق من تقرير القيادة.",
	"You haven’t driven_Month": "لم تقم بقيادة سيارتك هذا الشهر حتى الآن. جرب قيادة سيارتك باستخدام BlackVue للتحقق من تقرير القيادة.",
	"Fleet Plan only_": "تتوفر خطة الأسطول فقط",
	"Overwrite locked event2_": "استبدال ملفات الحدث المؤمّنة عند امتلاء وحدة التخزين",
	"DMS’s New firmware_": "يتوفر برنامج ثابت جديد لـ DMS",
	"Highest speed_report": "<b>أعلى سرعة</b>\nأكبر قيمة لبيانات السرعة المجمعة والتي يتم جمعها بوحدات القياس ، بالتحويل إلى وحدتَي كم/ساعة وميل في الساعة\n<b>متوسط السرعة</b>\n\n(المسافة/ ساعات القيادة) *يبلغ متوسط السرعة 3600. مثال (2622 / 1208) *3600 = 7814.907\nكم/ساعة: عدد صحيح فقط، تصل النقطة الأساسية للميل في الساعة إلى رقمين تحت عدد صحيح",
	"Choose a cloud_": "اختر طريقة للاتصال بالسحابة",
	"You need an_": "يلزمك الاتصال بالإنترنت للاتصال بالسحابة. حدد الجهاز الذي تستخدمه للاتصال بالسحابة.",
	"BlackVue SIM card": "بطاقة SIM من BlackVue",
	"Support model_": "الطراز المدعوم: DR750X-2CH LTE Plus (NA)",
	"3rd party SIM_": "بطاقة SIM من جهة أخرى",
	"Support model_SIM": "الطراز المدعوم: DR750X-2CH LTE Plus وDR750-2CH LTE وCM100 LTE",
	"Wi-fi hotspot": "نقطة اتصال Wi-fi",
	"Support model_Wifi": "الطراز المدعوم: جميع طرز BlackVue",
	"How to connect_": "كيفية الاتصال بالسحابة",
	"Download BlackVue application": "قم بتنزيل تطبيق BlackVue.",
	"*If you are_": "*إذا كنت ستستخدم بطاقة SIM من BlackVue للاتصال بالسحابة، فانتقل إلى {{a}} {{b}}.",
	"Place your phone_": "ضع هاتفك في نطاق BT الخاص بالكاميرا. ابدأ الاقتران السلس عن طريق {{a}}.",
	"Back to camera_": "الرجوع إلى قائمة الكاميرات",
	"Upgrade for more_": "قم بالترقية للتمتع بمزيد من الميزات!",
	"Upgrading the cloud_": "تتيح لك ترقية خطة السحابة التمتع بمزيد من الميزات وإدارة عدة كاميرات. هل تود تحديث خطة السحابة؟",
	"Explore cloud plans": "استكشف خطط السحابة",
	Later: Later$g,
	"Successfully subscribed": "تم الاشتراك بنجاح!",
	"1GB data plan": "خطة بيانات 1 جيجابايت",
	"First month free_": "أول شهر مجانًا، <a>ثم 10.99 دولارات أمريكية/شهر</a>",
	"Next billing date": "تاريخ الفوترة القادمة",
	"Once SIM card_": "بمجرد إدخال بطاقة SIM في الكاميرا، يمكنك تشغيل ميزات BlackVue Cloud على الفور.",
	"Go to SIM_": "انتقل إلى إدارة بطاقة SIM",
	"Manage your BlackVue_": "قم بإدارة بطاقة BlackVue SIM هنا!",
	"Recommended for BlackVue_": "يوصى به لحاملي بطاقة SIM من BlackVue",
	"Connect to cloud": "الاتصال بالسحابة",
	"Enter BlackVue SIM_": "أدخل رقم ICCID لبطاقة SIM من BlackVue",
	"ICCID number is_": "تتم طباعة رقم ICCID على عبوة بطاقة SIM. يرجى إدخال آخر 14 رقمًا من رقم ICCID.",
	ICCID: ICCID$g,
	"SIM information": "معلومات بطاقة SIM",
	"Start your free_": "ابدأ الفترة التجريبية المجانية الآن",
	"SIM card activate_": "تاريخ تنشيط بطاقة SIM",
	"Based on the_": "بناءً على تاريخ إدخال بطاقة SIM في الكاميرا وتنشيطها عند توصيل الطاقة",
	"Upgrade to 3GB_": "الترقية إلى خطة 3 جيجابايت/ 5 جيجابايت في أي وقت",
	"Cancel your plan_": "إلغاء خطتك في أي وقت",
	"No Commitment": "دون التزامات",
	"Precautions for using_": "احتياطات استخدام الخدمة",
	"After 1GB is_": "بعد نفاد 1 جيجابايت، لا يتوفر إنترنت إضافي.",
	"If you have_": "إذا كنت قد أدخلت بطاقة SIM في الكاميرا وكنت تستخدمها بالفعل، فستبدأ الفترة التجريبية المجانية من وقت بدء استخدامها.",
	"This content is_": "يتم تحديد هذا المحتوى في عبوة بطاقة SIM. لا ندعم التعويض عن الفترات المجانية التي لم يتم توفيرها.",
	"If you have_2": "إذا كان لديك المزيد من الأسئلة، يرجى الاتصال بـ <a>فريق دعم العملاء</a>",
	"When OFF, connecting_": "عند إيقاف التشغيل، يتم تعطيل توصيل الكاميرا عن طريق الاقتران السلس.",
	"1 month free": "فترة تجريبية مجانية لمدة شهر",
	"No commitment. Cancel_": "دون التزامات. قم بالإلغاء في أي وقت.",
	"The video has been reported_": "تم الإبلاغ عن مقطع الفيديو بنجاح",
	"Free for 1 month": "مجانًا لمدة شهر",
	"Start your free_2": "ابدأ الفترة التجريبية المجانية",
	"1GB free for_": "1 جيجابايت مجانًا لمدة {{a}} من الأيام",
	"1GB data": "بيانات 1 جيجابايت",
	"1 month free_2": "ستبدأ الفترة التجريبية المجانية لمدة شهر من {{a}}، بما في ذلك بيانات بمقدار 1 جيجابايت لبطاقة SIM من Blackvue.",
	"Your next billing_": "تاريخ الفوترة القادم هو {{a}}",
	"SIM card": "بطاقة SIM",
	"SIM guide": "دليل بطاقة SIM",
	"SIM card list": "قائمة بطاقة SIM",
	"Add SIM card": "إضافة بطاقة SIM",
	"No SIM card_": "لا توجد بطاقة SIM حتى الآن",
	"Search SIM ICCID_": "ابحث عن ICCID أو اسم لبطاقة SIM",
	"Cloud disconnected. Failed_": "تم قطع اتصال السحابة. فشل تشغيل الفيديو",
	"This sim card_": "بطاقة sim هذه مسجلة بالفعل في حساب آخر.",
	"Incorrect BlackVue SIM_": "ICCID لبطاقة SIM من BlackVue غير صحيح",
	"My shared videos": "مقاطع الفيديو الخاصة بي التي تمت مشاركتها",
	"Number of events": "عدد الأحداث",
	"Added to Event Map": "تمت الإضافة إلى خريطة الأحداث",
	"Successfully added video(s)_": "تمت إضافة مقطع (مقاطع) الفيديو بنجاح لمشاركته على \"خريطة الأحداث\"! إذا كنت ترغب في التحقق من الحالة وإدارة مقاطع الفيديو التي تمت مشاركتها، فانتقل إلى خريطة الأحداث > مقاطع الفيديو الخاصة بي التي تمت مشاركتها.",
	"Already added to_": "تمت الإضافة بالفعل إلى خريطة الأحداث",
	"This video(s) is already added_": "تمت إضافة مقطع (مقاطع) الفيديو هذا بالفعل إلى خريطة الأحداث! إذا كنت ترغب في التحقق من الحالة وإدارة مقاطع الفيديو التي تمت مشاركتها، فانتقل إلى خريطة الأحداث > مقاطع الفيديو الخاصة بي التي تمت مشاركتها.",
	"BlackVue’s firmware is up_": "البرنامج الثابت من BlackVue محدث",
	"Service end": "نهاية الخدمة",
	Resubscribe: Resubscribe$g,
	"Sort ascending": "فرز تصاعدي",
	"Sort descending": "فرز تنازلي",
	plan: plan$g,
	USD: USD$g,
	"Are you sure_Cancel": "هل تريد بالتأكيد إلغاء اشتراكك؟ يرجى العلم بما يلي والتأكيد أدناه.",
	"Your current SIM_": "ينتهي اشتراك بطاقة SIM الحالي في {{a}}، ولن يتم تحصيل رسوم منك بعد ذلك.",
	"After canceling your_": "بعد إلغاء اشتراك بطاقة SIM، ستستمر في استخدام بيانات بطاقة SIM حتى تاريخ انتهاء اشتراكك.",
	"You can resubscribe_": "يمكنك إعادة الاشتراك في غضون شهر بعد انتهاء اشتراكك الحالي. إذا كنت ترغب في إعادة الاشتراك، ي\"رجى النقر فوق الزر إعادة الاشتراك\" في قائمة بطاقة SIM عن طريق {{a}} لإعادة الاشتراك.",
	"Reason to cancel_": "سبب إلغاء الاشتراك",
	"Found an alternative": "تم العثور على بديل",
	"Too expensive": "غالٍ جدًا",
	"Not required anymore": "غير مطلوب بعد الآن",
	"Quality issue": "مشكلة بالجودة",
	etc_: etc_$g,
	"Please describe in_": "يرجى الوصف بالتفصيل",
	"SIM card cannot_": "لا يمكن حذف بطاقة SIM لأن بطاقة SIM هذه قيد الاشتراك. إذا كنت تريد حذف بطاقة SIM هذه، يرجى إلغاء اشتراكك أولاً.",
	"SIM card cannot_2": "لا يمكن حذف بطاقة SIM لأن الاشتراك في بطاقة SIM هذه لم ينته بعد. يرجى المحاولة مرة أخرى بعد انتهاء اشتراكك.",
	"Are you sure_deleteSIM": "هل تريد بالتأكيد حذف بطاقة SIM هذه؟<br/>\n<b>تحذير: يتعذر التراجع عن هذا الإجراء. سيتم حذف جميع معلومات بطاقة SIM الخاصة بك على الفور.</b>",
	"ICCID number": "رقم ICCID",
	"Activation date": "تاريخ التنشيط",
	"Current plan": "الخطة الحالية",
	"Manage Plan": "إدارة الخطة",
	"Next billing on": "الفوترة التالية في",
	"View Invoices": "عرض الفواتير",
	"Choose best plan_": "اختر أفضل خطة لك",
	"Plan summary": "ملخص الخطة",
	"Ends on_": "تنتهي في {{a}}",
	"Start from_": "تبدأ من {{a}}",
	"Your subscription will_": "ستتم ترقية اشتراكك في {{a}} عندما تنتهي خطتك الحالية.",
	"Resubscribe plan": "إعادة الاشتراك في الخطة",
	"Your subscription will2_": "سيبدأ اشتراكك في {{a}} عندما تنتهي خطتك الحالية.",
	"Usage is estimated_": "يقدَّر الاستخدام اعتبارًا من {{a}}",
	"Days left_": "تبقى {{a}} من الأيام",
	"Data usage cycle": "دورة استخدام البيانات",
	Available: Available$g,
	Used: Used$g,
	"Data used": "البيانات المستخدمة",
	"Subscribe to n_": "اشترك في خطة بيانات {{a}} المطبقة <b>من {{b}} إلى ‎{{c}}</b>‎ وخطة بيانات {{d}} المطبقة من {{e}}",
	"Will be charged_": "سيتم تحصيل الرسوم في {{a}}",
	"Monthly usage": "الاستخدام الشهري",
	"You have fewer_": "لديك بيانات أقل متبقية لهذا الشهر!",
	"Get more data": "احصل على المزيد من البيانات!",
	"This video cannot be shared": "لا يمكن مشاركة مقطع الفيديو هذا",
	"This is a video cannot be shared_": "هذا مقطع فيديو لا يمكن مشاركته لأنه لا يمكن العثور على معلومات القيادة في ذلك الوقت.",
	Cancelled: Cancelled$g,
	Terminated: Terminated$g,
	"Edit name": "تحرير الاسم",
	"Not connected to_2": "غير متصل بالسحابة. تحقق مما إذا كانت الكاميرا قيد التشغيل ومما إذا تم تمكين وحدة الاتصال بالإنترنت.",
	"Some functionality is disabled_": "تم تعطيل بعض الوظائف لأن الكاميرا غير متصلة بالسحابة. اتصل بالسحابة <a>هنا</a>.",
	"If you want to cancel_": "إذا كنت تريد إلغاء خطتك، فانقر فوق <a>إلغاء الاشتراك</a>.",
	"Select plan": "تحديد خطة",
	"Event map collects_": "تجمع خريطة الأحداث معلومات أحداث BlackVue وتصورها لتوفير ظروف الطرق المحيطة.",
	"Share your Live_": "قم بمشاركة ملف تحميل الحدث المباشر. يمكنك مشاركة مقاطع فيديو الحدث الخاص بك مع مستخدمين آخرين من حولك.",
	"You can check_": "يمكنك التحقق من مقاطع الفيديو الخاصة بالحدث والتي شاركها الآخرون.",
	"Service end_": "نهاية الخدمة: {{a}}",
	"DMS camera recording_": "تسجيل كاميرا DMS في وضع إيقاف السيارة",
	Sort: Sort$g,
	"Are you sure you want_": "هل تريد بالتأكيد إزالة مقطع الفيديو الذي تمت مشاركته من خريطة الأحداث؟",
	"Remove shared video": "إزالة مقطع الفيديو الذي تمت مشاركته",
	"Explore event map": "استكشف خريطة الأحداث",
	"Event map": "خريطة الأحداث",
	"Explore the graphic_": "استكشف الإحصائيات الرسومية لأحداث BlackVue التي تجري من حولك.",
	"You can filter_": "يمكنك تصفية وعرض الأحداث التي تريد عرضها.",
	"This video was removed by_": "تم الإبلاغ عن مقطع الفيديو هذا وإزالته من قِبل المسؤول.",
	Bonus: Bonus$g,
	"Your subscription plan": "خطة الاشتراك الخاصة بك",
	"Your free trial will_": "ستبدأ الفترة التجريبية المجانية من {{a}}،</br> <strong>حتى</strong> {{b}}.",
	"Total after free trial": "الإجمالي بعد الفترة التجريبية المجانية",
	"This sim card is_": "بطاقة sim هذه لم تعُد نشطة.",
	"Firmware is up_": "تحديث البرنامج الثابت",
	"Keep in mind": "ضع ما يلي في اعتبارك",
	"Once 1GB of_": "بمجرد استخدام 1 جيجابايت من البيانات، لن تكون الخدمة متاحة حتى تاريخ إعادة تعيين البيانات التالي [أو بعد ترقية خطتك إلى مستوى أعلى].",
	"After the SIM_": "بعد إدخال بطاقة SIM في الكاميرا، تبدأ الفترة التجريبية المجانية عند بدء استخدام البيانات.",
	"If you have_questions": "إذا كان لديك أي أسئلة، يرجى الاتصال بـ <a>دعم العملاء.</a>",
	"Data reset date": "تاريخ إعادة تعيين البيانات",
	"To use SIM card_": "لاستخدام بطاقة SIM، يرجى الاتصال بـ <a>فريق دعم العملاء</a> لدى BlackVue",
	"Go to Subscription": "انتقل إلى الاشتراك",
	"An error occurred_subscription": "حدث خطأ أثناء الاشتراك في الخطة المحددة.",
	"Please try again": "يرجى إعادة المحاولة",
	"Failed to subscribe": "فشل الاشتراك",
	"Go to Pricing": "انتقل إلى الأسعار",
	"SIM cards will_": "ستظهر بطاقات SIM هنا عند توفرها.",
	"1GB for 1_": "1 جيجابايت لمدة شهر",
	"Pricing Data": "بيانات الأسعار",
	"If you would like to check_": "إذا كنت ترغب في التحقق من الحالة وإدارة مقاطع الفيديو التي تمت مشاركتها، فانتقل إلى خريطة الأحداث > مقاطع الفيديو الخاصة بي التي تمت مشاركتها.",
	"Connect to Cloud": "الاتصال بالسحابة",
	"Completed!": "اكتمل!",
	"Back to App": "عودة إلى التطبيق",
	"iOS in-app purchase": "شراء داخل التطبيق على iOS",
	"Android in-app_": "شراء داخل التطبيق على Android",
	"bonus n days": "{{a}} من الأيام الإضافية",
	"Want to contribute your_": "هل تسمح بالمشاركة التلقائية لملفات التحميل التلقائي للحدث على خريطة الأحداث؟",
	"With event map_": "يمكنك مشاركة فيديو التحميل التلقائي للحدث مع السائقين القريبين من خلال خريطة الأحداث.",
	"You can edit_3": "يمكنك تحرير ملفات التحميل التلقائي لحدث المشاركة التلقائية إلى إعدادات خريطة الأحداث في أي وقت بالانتقال إلى BLACKVUE CLOUD > إعدادات الكاميرا > إعدادات الخصوصية.",
	"If you want to remove videos_": "نظرًا إلى أنه قد يتم إرسال مقطع فيديو شخصي، يجب أن تنتبه جيدًا عند تحديد المعلومات التي تشاركها.",
	"Total events": "إجمالي الأحداث",
	"Automatically add Live Event_": "ملفات التحميل التلقائي لحدث المشاركة التلقائية إلى خريطة الأحداث",
	"This camera is publicly_": "هذه الكاميرا مفتوحة للعامة لموقعها فقط.",
	incomplete_zip: incomplete_zip$g,
	"Live Event Upload_": "تحميل الحدث المباشر (فترة التخزين: 7 أيام)\nتتطلب أحدث برنامج ثابت",
	"Thank you for_2": "شكرًا لكم على صبركم.",
	"Start Web viewer": "تشغيل عارض الويب",
	"Are you sure_remove driver": "هل تريد بالتأكيد حذف السائق بشكل نهائي",
	"An error occurred_sim": "حدث خطأ في أثناء محاولة الاشتراك.",
	"Click the ADD SIM": "انقر فوق الزر إضافة بطاقة SIM في صفحة قائمة بطاقات SIM، ثم انتقل عبر عملية إضافة بطاقة sim مرة أخرى.",
	"Set download options": "تعيين خيارات التنزيل",
	"Information may be_": "Information may be transmitted with a delay and may not reflect actual balances.",
	"Swipe left and right to move": "تمرير لليسار واليمين للتحرك",
	"Scheduled maintenance Notice": "إخطار بالصيانة المجدولة",
	"Our Cloud server_": "سيخضع الخادم السحابي للصيانة المجدولة.",
	"During that time_": "خلال ذلك الوقت، قد لا تتوفر ميزات السحابة.",
	"Expected maintenance start_": "وقت بدء الصيانة المتوقع:",
	"Expected duration_": "المدة المتوقعة: {{a}} من الساعات.",
	"For more information_": "لمزيد من المعلومات، يرجى الرجوع إلى <a>[إخطار بصيانة الخادم]</a>",
	"Do not remind_": "لا تذكرني مرة أخرى",
	"Cloud Server Maintenance": "صيانة الخادم السحابي",
	"BlackVue Cloud Service_": "خدمة BlackVue Cloud غير متاحة مؤقتًا",
	"We are currently_": "نُجري حاليًا الصيانة.",
	"We apologize for_": "نعتذر عن الإزعاج.",
	"Driver Monitoring System (DMS)": "نظام مراقبة السائق (DMS)",
	"Distracted occurs_": "يحدث عندما تكون رأس السائق أكثر من 50 درجة بعيدا عن الجهة الأمامية.",
	"Hand distraction event occurs_": "يحدث عندما يتم اكتشاف يد السائق بالقرب من رأسه لمدة طويلة (مثل التدخين أو حمل الهاتف وما إلى ذلك).",
	"Mask off event occurs_": "يحدث عندما يدخل السائق إلى المركبة بدون كمامة أو عندما يزيل السائق كمامته.\n",
	"DMS setting": "إعداد DMS",
	"The DMS system has_": "تجمع نظام DMS صندوق كشف الوجه للحالات \"تم الكشف عنه\", \"لم يتم الكشف عنه\", \"مشتت\", \"نعاس\", \"بدون قناع\" وصندوق كشف الحركة لحالة \"التشتيت باليد\".",
	"DMS detection": "كشف DMS\n",
	"There are detection criteria for_": "هناك معايير الكشف لكل حدث. يرجى الاطلاع على الدليل أدناه.",
	"DMS camera recording_onoff": "تشغيل: تسجل كاميرا DMS في وضع الوقوف طالما أن الطاقة مُتيحة. <br/> إيقاف: تُطفئ كاميرا DMS بعد فترة قصيرة من دخول وضع الوقوف.",
	"LED lighting for each event_": "ستؤدي مؤشر LED على كاميرا مراقبة السائق إلى إشارة في كل حدث اكتشاف (تشتيت، نعاس، إلخ).\n",
	"Drowsy and Distracted each have_": "يشتمل حدثا نعسان ومشتت على ثلاث حالات للحساسية.\n \n يرجى الرجوع إلى الواجهة الإرشادية أدناه.",
	"DMS event detection sensitivity": "حساسية اكتشاف حدث DMS",
	"Only drowsy and distracted include_": "يشتمل حدثا نعسان ومشتت فقط على إعدادات الحساسية. تطبق أيضًا الحساسية المعيّنة الحساسية نفسها على حدثين من خلال إعداد واحد.",
	"When driver’s eyes close_": "يحدث عندما يغلق السائق كلا العينين أثناء القيادة لأكثر من 1 ثانية أو يثاؤب لمدة 2 ثانية.\n",
	"n digit": "{{a}} أرقام",
	"You are subscribed_free_Smart": "أنت مشترك في الخطة الذكية لـ BlackVue Cloud.",
	"Wi-Fi auto turn on": "التشغيل التلقائي لشبكة Wi-Fi",
	"Video on a map": "Video on a map",
	"This feature is only_vom": "This feature is only available to users with a Fleet Plan subscription.<br/>Please subscribe to a plan to unlock this feature.",
	"Total n days_": "إجمالي {{a}} يومًا من الإصدار التجريبي المجاني",
	"Every events of DMC200_": "ميزات اكتشاف DMS نشطة فقط في الوضع العادي. إذا تم تشغيله في وضع وقوف السيارة ، فإن كاميرا DMS تسجل فقط فيديو.",
	"An undetected event occurs_": "يحدث عندما لا يتم اكتشاف السائق أمام الكاميرا لمدة دقيقة واحدة.",
	"A detected event occurs_": "A detected Event occurs when the driver is gazing in front since the power is set in the beginning.",
	"Drowsy sensitivity_": "High : When the driver closes their eyes for more than 1 second, it is considered drowsy driving.<br/><br/>Medium : When the driver closes their eyes for more than 1.5 second, it is considered drowsy driving.<br/><br/>Low : When the driver closes their eyes for more than 2 second, it is considered drowsy driving.",
	"Distracted sensitivity_": "High : If the angle of the head is more than 50 degrees away from the front for 3 seconds, it is detected as Distracted.<br/><br/>Medium : If the angle of the head is more than 50 degrees away from the front for 5 seconds, it is detected as Distracted.<br/><br/>Low : If the angle of the head is more than 50 degrees away from the front for 7 seconds, it is detected as Distracted.",
	"Start your subscription now": "ابدأ اشتراكك الآن",
	"Free trial period has expired": "انتهت صلاحية الفترة التجريبية المجانية",
	"1 data plan will start from_": "ستبدأ خطة البيانات من ‎{{a}}‎، بما في ذلك بيانات بمقدار 1 جيجابايت لبطاقة SIM من Blackvue.",
	"Allow the BlackVue_": "هل تريد السماح لتطبيق BlackVue بالوصول إلى بيانات GPS لكاميرا لوحة القيادة؟",
	"We use this_": "نستخدم هذا لنتيح لك تعقب موقع سيارتك وسرعتها.",
	"You can edit_": "يمكنك تحرير إعدادات الوصول إلى GPS في أي وقت بالذهاب إلى ‎BLACKVUE CLOUD‎ > إعدادات الكاميرا > إعدادات الخصوصية.",
	"SIM cards": "بطاقات SIM",
	"Subscription status": "حالة الاشتراك",
	Upgrades: Upgrades$g,
	"Upgrade plan": "ترقية الخطة",
	"Manage plan": "إدارة خطة الاشتراك",
	"Next plan": "خطة الاشتراك للشهر القادم",
	OR: OR$g,
	"Cancel subscription": "إلغاء الاشتراك",
	Undo: Undo$g,
	Invoice: Invoice$g,
	"Daily usage": "الاستخدام اليومي للبيانات",
	"Delete SIM": "حذف SIM",
	"New card": "بطاقة ائتمان جديدة",
	data: data$g,
	"SIM card data_": "يمكن إلغاء الاشتراك في خطة بيانات بطاقة SIM على ‎<a>sim.blackvuecloud.com</a>‎.",
	"Your plan from_": "تبدأ خطتك من اليوم إلى تاريخ الفوترة التالي",
	"Applied during_": "يتم التطبيق خلال ‎{{a}} ~ {{b}}‎",
	"From today until_": "بدءًا من اليوم وحتى تاريخ الدفع التالي، يمكنك فقط الاشتراك في خطة الشهر السابق نفسها. ستصدر اليوم فاتورة بالمدفوعات لهذه الفترة. ‎<a>‎تُحتسب الرسوم على أساس تناسبي.‎</a>‎",
	"Choose your next plan": "اختر خطتك التالية",
	"Applied from_": "يتم التطبيق بدءًا من ‎{{a}}‎",
	"Payment for this_": "سيتم تحصيل الدفعة لهذه الخطة في ‎{{a}}‎.",
	"By sharing your_2": "من خلال مشاركة العرض المباشر، يمكنك السماح للمستخدمين الآخرين بتجربة إثارة القيادة ومتعتها بشكل غير مباشر في جميع أنحاء العالم. لكن نظرًا إلى أنه قد يتم إرسال مقطع فيديو شخصي، يجب أن تنتبه جيدًا عند تحديد المعلومات التي تشاركها.",
	"Option camera recording_": "تسجيل الكاميرا الاختيارية في وضع إيقاف السيارة",
	"Front and option camera_": "تسجل الكاميرا الأمامية والكاميرا الاختيارية معًا.",
	"Option camera stops_": "توقفت الكاميرا الاختيارية عن التسجيل مدة 5 دقائق بعد الدخول في وضع إيقاف السيارة. يبدأ التسجيل عند الدخول في الوضع العادي.",
	"Option camera rotation": "تدوير الكاميرا الاختيارية",
	"Option camera": "الكاميرا الاختيارية",
	"Option camera security": "أمان الكاميرا الاختيارية",
	"Resubscribe until_": "إعادة الاشتراك حتى: ‎{{a}}‎",
	"Firmware Update Caution": "تنبيه تحديث البرنامج الثابت",
	"Please check below_": "يرجى التحقق من الحالة التالية قبل تحديث البرنامج الثابت لـ DMC200:",
	"The camera's Wi-Fi_": "يجب تشغيل شبكة ‎Wi-Fi‎ للكاميرا.",
	"Check if your_": "تحقق مما إذا كانت شبكة ‎WI-FI‎ للكاميرا قيد التشغيل.",
	"DO NOT disconnect_": "لا تفصل الكابل المحوري أثناء تحديث البرنامج الثابت.",
	"The camera and_": "قد تتعطل الكاميرا وDMC200.",
	"DO NOT try_": "لا تحاول استخدام ميزات أخرى حتى تنتهي إعادة تشغيل الكاميرا.",
	"Expecially Reboot camera_": "إعادة تشغيل الكاميرا بشكل خاص، قد تكون تهيئة بطاقة SD السبب في تعطل الجهازين.",
	"Update anyway": "التحديث على أي حال",
	"Invited on_2": "تمت الدعوة في ‎ {{Invited Date} بواسطتك. المالك",
	"BlackVue’s New firmware_": "يتوفر برنامج ثابت جديد لـ BlackVue",
	"valid thru_": "صالح خلال: ‎{{a}}‎",
	"Billed monthly": "Billed monthly",
	"90 minutes Live_": "90 minutes Live View / Live Event Upload*",
	"or 2+ videos_": "or 2+ videos in full resolution*",
	"1GB Free Month_": "1GB Free Month Trial",
	"Cancel anytime": "Cancel anytime",
	"8+ hours Live_": "8+ hours Live View / Live Event Upload*",
	"or 12+ videos_": "or 12+ videos in full resolution*",
	"15+ hours Live_": "15+ hours Live View / Live Event Upload*",
	"or 23+ videos_": "or 23+ videos in full resolution*",
	Popular: Popular$g,
	"For Power Users": "For Power Users",
	"Estimates based on_": "* Estimates based on 4.5MB per minute of Live View, Quick View remote playback, or Live Event Upload file, and 190MB per full original resolution video download or playback (at 25Mbps bitrate). Daily idle Cloud connection data usage: 20MB per 24 hours. Data usage is shared among all types of services (Live View, Live Event Upload, etc.).",
	"Balanced Plan": "Balanced Plan",
	"For Light Cloud_": "For Light Cloud Use",
	"Front security (Normal mode)": "الأمان الأمامي (الوضع العادي)",
	"Front security (Parking mode)": "الأمان الأمامي (وضع إيقاف السيارة)",
	"BT (Parking mode)": "BT (وضع إيقاف السيارة)",
	"LTE (Parking mode)": "LTE (وضع إيقاف السيارة)",
	"Wi-Fi (Parking mode)": "شبكة ‎Wi-Fi‎ (وضع إيقاف السيارة)",
	"Hand distraction": "تشتت اليد",
	Mask: Mask$g,
	"Second drowsy is_": "حدث نعسان الثاني هو حدث نعسان الذي وقع في غضون 30 ثانية من حدث نعسان الأول الذي بدأ تسجيل تحميل حدث مباشر.",
	"Second drowsy alert": "تنبيه نعسان الثاني",
	"BlackVue sim card_": "لا يمكن استخدام بطاقة sim من BlackVue إلا في كندا والولايات المتحدة.",
	"Global support is coming soon.": "سيتوفر الدعم العالمي قريبًا.",
	"The video file not found_": "لم يتم العثور على ملف الفيديو، أو حدثت مشكلة أثناء التشغيل. تُرجى إعادة المحاولة.",
	"Start Voice Call": "بدء المكالمة الصوتية",
	"End Voice Call": "إنهاء المكالمة الصوتية",
	"Voice call in use": "المكالمة الصوتية قيد الاستخدام",
	"Enable microphone access_": "قم بتمكين الوصول إلى الميكروفون لاستخدام وظيفة الاتصال الصوتي ثنائي الاتجاه. انتقل إلى صفحة إعداد المستعرض للوصول إلى الميكروفون.",
	"You may need to_": "قد تلزمك إعادة تحميل هذه الصفحة حتى يتم تفعيل الإعدادات الجديدة.",
	"Eye status": "حالة العين",
	"Start time of live event upload video": "وقت بدء فيديو تحميل الحدث المباشر",
	"Left eye": "العين اليسرى",
	"Right eye": "العين اليمنى",
	"Drowsy is occured when the driver close his/her eyes more then 1sec": "يقع حدث نعسان عندما يغلق السائق عيناه أكثر من ثانية",
	"Driver's Left eye movements with blinking count and period": "حركات العين اليسرى للسائق مع عدد الرمشات وعدد الفترات والفترة",
	"Driver's Right eye movements with blinking count and period": "حركات العين اليمنى للسائق مع عدد الرمشات والفترة",
	"Drowsy big data of the driver and after a Drowsy event occurs": "البيانات الضخمة لرمشات عين السائق بعد وقوع حدث نعسان",
	"Sharing video to Event Map": "مشاركة الفيديو على خريطة الأحداث",
	"Want to use a Voice call?": "هل تريد استخدام مكالمة صوتية؟",
	"To use a voice call_": "لاستخدام مكالمة صوتية، أعد تشغيل العرض المباشر وانقر فوق \"سماح\"",
	"There is no_": "لا توجد مقاطع فيديو تمت مشاركتها حتى الآن. \nستظهر القائمة عند مشاركتها.",
	"Microphone blocked": "تم حظر الميكروفون",
	"Want to center the map on your location?": "تريد أن تركز الخريطة على موقعك؟",
	"To let the app access your location_": "للسماح للتطبيق بالوصول إلى موقعك ، أعد تشغيل Event Map وحدد \"موافق\" عندما يُطلب منك ذلك.",
	"Location access permission required": "مطلوب إذن الوصول إلى الموقع.",
	"Are you sure you want_2": "هل أنت متأكد أنك تريد إزالة هذا الفيديو من Event Map؟",
	"Two-way voice_2": "Two-way voice communication / Voice Call",
	"Not supported by DR650GW and DR650S_": "Not supported by DR650GW and DR650S",
	"DR650S Series only_": "DR650S Series only",
	"Cancel download?": "هل تريد إلغاء التنزيل؟",
	"Your download is not_": "لم يكتمل التنزيل. هل ترغب في إلغاء التنزيل؟",
	"Continue download": "متابعة التنزيل",
	"Cancel download": "إلغاء التنزيل",
	"Share your video to the Event Map?": "هل تريد مشاركة الفيديو إلى خريطة الأحداث؟",
	"Afterwards, according to the reaction to the video_": "بعد ذلك، وفقًا للتفاعل على الفيديو، يمكن تصنيفه على أنه فيديو شائع وتقديمه في قائمة المحتويات الرائجة الآن على الخريطة.",
	"Add hashtags and a brief description to describe your video.": "إضافة علامات الكلمات الرئيسية ووصف موجز لوصف الفيديو.",
	"Would you like_": "هل تريد المشاركة إلى خريطة الأحداث؟",
	"Successfully added video_": "تمت إضافة الفيديو بنجاح لمشاركته إلى خريطة الأحداث!",
	"This video cannot_": "تتعذر مشاركة هذا الفيديو لأنه يفتقد إلى بيانات موقع GPS لتثبيته على الخريطة.",
	"This video is_": "تمت إضافة هذا الفيديو بالفعل إلى خريطة الأحداث.",
	"Share to Event Map": "مشاركة إلى خريطة الأحداث",
	"Describe in more_": "صِف بمزيد من التفصيل ما يحدث في الفيديو (اختياري)",
	"Description(optional)": "الوصف (اختياري)",
	"Recording mode": "وضع التسجيل",
	"Event triggers": "مشغلات الأحداث",
	DMS: DMS$g,
	"Camera connectivity": "إمكانية الاتصال بالكاميرا",
	"If not allowed_2": "إذا لم يتم السماح بذلك، فسيتعذر الوصول إلى موقع سيارتك وسرعتها عبر السحابة.",
	"Share Live View_": "مشاركة فيديو العرض المباشر",
	"Share Live View_2": "مشاركة صوت العرض المباشر",
	"Share camera profile": "مشاركة ملف تعريف الكاميرا",
	"Parking impact": "تصادم عند وقوف السيارات",
	"Parking events": "Parking Events",
	"Audio recording": "تسجيل الصوت",
	"Toggle the mic_": "قم بتبديل الميكروفون إلى وضع التشغيل/إيقاف التشغيل",
	"Full HD_": "Full HD @ 60fps + Full HD @ 30fps",
	"Video quality": "جودة الفيديو",
	Extreme: Extreme$g,
	"More video files": "مزيد من ملفات التسجيل",
	"Fewer video files": "ملفات تسجيل أقل",
	"Camera rotation": "تدوير الكاميرا الخلفية",
	"Video overlay": "تراكب الفيديو",
	"Date & time display": "عرض التاريخ والوقت",
	"Speed unit": "وحدة السرعة",
	"Check the orientation_": "تحقق من اتجاه الكاميرا الأمامية المثبتة في المركبة. حدد خيار المطابقة لتسجيل مقاطع الفيديو في اتجاه رأسي.",
	"Rotate 180º": "تدوير بمقدار 180 درجة",
	"Rear camera rotation": "تدوير الكاميرا الخلفية",
	"Check the orientation_rear": "تحقق من اتجاه الكاميرا الخلفية المثبتة في المركبة. حدد خيار المطابقة لتسجيل مقاطع الفيديو في اتجاه رأسي.",
	"Mirror View": "طريقة العرض المعكوسة",
	"Select Mirror View_": "حدد ميزة طريقة العرض المعكوسة لتمكين انعكاس الفيديو أفقيًا.",
	"Check the orientation_interior": "تحقق من اتجاه الكاميرا الاختيارية المثبتة في المركبة. حدد خيار المطابقة لتسجيل مقاطع الفيديو في اتجاه رأسي.",
	"Display off": "إيقاف تشغيل جهاز العرض",
	"Explore crowd-sourced Events_": "استكشف الأحداث التي تشاركها الجماهير (التأثير، استخدام المكابح بقوة، وما إلى ذلك) على الخريطة، واعرض مقاطع الفيديو التي يشاركها المجتمع وساهم بأحداثك.",
	OFF: OFF$g,
	"Reboots once-a-day_": "يعيد التشغيل مرة واحدة يوميًا في الوقت المحدد إذا كان في وضع إيقاف السيارة لتحسين الاستقرار.",
	"Set time": "Set Time",
	"FW language": "Firmware Language",
	"Rear security_2": "الأمان الخلفي",
	"Bluetooth (Parking mode)_2": "Bluetooth (وضع إيقاف السيارة)",
	"Failed to save_2": "فشل حفظ إعداد تحميل الحدث المباشر",
	"Event file will_": "سيتم حفظ ملف الحدث تلقائيًا في مساحة تخزين تحميل الحدث المباشر.",
	"An impact was_": "An Impact was detected during Parking Mode.",
	"When exiting Parking_": "عند الخروج من وضع إيقاف المركبة، يُرسل BlackVue تنبيهًا إذا تم اكتشاف تأثير في أثناء تشغيل وضع إيقاف المركبة. ‎\n\n ملحوظات: ‎\n تؤدي التأثيرات إلى إنشاء مقاطع فيديو الأحداث. يتم تجاهل التأثيرات المنشأة خلال 3 دقائق من الخروج من وضع إيقاف المركبة.",
	"Protect event files": "حماية ملفات الأحداث",
	"Turning on this_": "قم بالتشغيل لحماية ‎{{a}} من ملفات الأحداث الأخيرة من الاستبدال بواسطة ملفات التسجيل العادية أو التسجيل في وضع إيقاف المركبة.",
	"Impact Events in_": "Impact Events in Normal(E) and Parking Mode(I)",
	"Manual Events_": "Manual Events (M)",
	"Once 50 Events_": "تشمل الملفات المحمية ما يأتي: ‎\n\nأحداث التأثير في الوضع العادي ‎(E)‎ ووضع إيقاف المركبة ‎(I)‎ ‏‎\nالأحداث اليدوية ‎(M)‎ ‏‎\n\nبمجرد تسجيل ‎{{a}} من الأحداث، سيتم استبدال الأحداث الأقدم بالأحداث الجديدة.",
	"Reckless driving unit": "وحدة القيادة المتهورة",
	"Hard acceleration Event": "حدث التسارع الشديد",
	Threshold: Threshold$g,
	"Triggers when the_": "يتم تشغيله عندما تكتشف الكاميرا معدل تسارع في الثانية أعلى من قيمة الحد التي تم تعيينها.",
	"Triggers when the_2": "يتم تشغيله عندما تكتشف الكاميرا انخفاض السرعة بمعدل أكثر من قيمة الحد التي تم تعيينها.",
	"Hard braking Event": "حدث استخدام المكابح بقوة",
	"Triggers when more_": "يتم تشغيله عندما يتم اكتشاف أكثر من 60 درجة خلال ثانيتين في أثناء القيادة بمعدل أعلى من قيمة الحد التي تم تعيينها.",
	"Every event of DMC200_2": "ميزات كشف DMS نشطة فقط في وضع الطبيعي. إذا تم تشغيلها في وضع الوقوف، ستقوم كاميرا DMS بتسجيل الفيديو فقط.",
	"The DMS system has_2": "تجمع نظام DMS صندوق كشف الوجه للحالات ”تم الكشف عنه“, ”لم يتم الكشف عنه“, ”مشتت“, ”نعاس“, ”بدون قناع“ وصندوق كشف الحركة لحالة ”التشتيت باليد”.",
	"One for face_": "One for face detection : Detected, Undetected, Distracted, Drowsy",
	"The other for_": "The other for motion detection",
	"On: Normal recording_": "On: Normal recording works while power is maintained in Parking Mode",
	"Off: DMS power_": "Off: DMS power off after 5 minutes when entering Parking Mode, Normal recording works until just before off",
	"Drowsy and Distracted_": "Drowsy and Distracted each have three sensitivity conditions.",
	"Please refer to_": "Please refer to the guide interface below.",
	Drowsiness: Drowsiness$g,
	"Drowsiness occurs when_": "يحدث النعاس عندما يغلق السائق كلا العينين أثناء القيادة لأكثر من ثانية واحدة ويتثاؤب لمدة 2 ثانية.",
	"Distracted occurs when_": "يحدث عندما تكون رأس السائق أكثر من 50 درجة بعيدا عن الجهة الأمامية.",
	"A hand distraction_": "A hand distraction occurs when the driver removes one hand from the steering wheel. [*Smoking and phone calls may be suspected.]",
	"Mask off event_": "Mask-off event occurs in two ways. First is when the driver gets in the car without a mask. Second is when the driver takes their mask off",
	"High When the_": "High : When the driver closes their eyes for more than 1 second, it is considered drowsy driving.",
	"Middle When the_": "Medium : When the driver closes their eyes for more than 1.5 second, it is considered drowsy driving.",
	"Low When the_": "Low : When the driver closes their eyes for more than 2 second, it is considered drowsy driving.",
	"High If the_": "High : If the angle of the head is more than 50 degrees away from the front for 3 seconds, it is detected as Distracted.",
	"Middle If the_": "Medium : If the angle of the head is more than 50 degrees away from the front for 5 seconds, it is detected as Distracted.",
	"Low If the_": "Low : If the angle of the head is more than 50 degrees away from the front for 7 seconds, it is detected as Distracted.",
	Direct: Direct$g,
	"Camera Wi-Fi credentials": "بيانات اعتماد شبكة Wi-Fi الخاصة بالكاميرا",
	"Network name(SSID)": "اسم الشبكة (SSID)",
	"Seamless pairing": "Seamless Pairing",
	Remote: Remote$g,
	"Hotspot settings": "إعدادات نقطة الاتصال",
	"Hotspot name": "اسم نقطة الاتصال (SSID)",
	"Hotspot name must_": "Hotspot name must be at least 5 characters long",
	"Public cameras may_": "قد تظهر الكاميرات العامة على علامة التبويب استكشاف أو خريطة العالم.",
	"Hard Cornering Event": "حدث المنعطفات الصعبة",
	"Over speed_2": "السرعة الزائدة",
	"Second drawiness alert": "تنبيه النعاس للحظات",
	"Low Voltage Warning_2": "إلهاء اليدين",
	"(You)_2": "‎{{a}}‎ ( أنت )",
	"This video has been reported_": "قام المسؤول بالإبلاغ بهذا الفيديو وإزالته.",
	"Normal Mode recording": "تسجيل الوضع العادي",
	"ON : the camera_": "التشغيل: تُسجل الكاميرا باستمرار في تكرار حلقي.",
	"OFF : the camera_": "إيقاف التشغيل: تُسجل الكاميرا مقاطع فيديو الأحداث فقط في أثناء القيادة.",
	"In both modes_": "في كلا الوضعين، تؤدي التأثيرات المكتشفة إلى تشغيل تسجيلات الفيديو للأحداث.",
	"Continuously records_": "يُسجل باستمرار مقاطع فيديو مدتها دقيقة واحدة بمعدل إطار واحد في الثانية تغطي 30 دقيقة من الحركة.",
	"Choose detection regions_": "اختيار مناطق الاكتشاف لتقليل خطر تشغيل تسجيلات الحركة غير المرغوب فيها بسبب تمايل الأشجار في مهب الرياح والكائنات البعيدة المتحركة، وما إلى ذلك.",
	"Your previous plan is expired.": "انتهت صلاحية خطتك السابقة.",
	"Upgrade the plan to restore the camera": "ترقية الخطة لاستعادة الكاميرا‎\n ‏‎(%@)‎",
	"Remove from cloud": "إزالة من السحابة",
	"Are you sure you want to Remove_": "هل أنت متأكد من أنك تريد إزالة هذه الكاميرا من منفذ السحابة؟",
	"Remove: It doesn’t mean_": "الإزالة: لا تعني حذف بيانات الكاميرا بل توفير منفذ احتياطي لعدد الكاميرات المتصلة بالسحابة.",
	"Now the camera is removed from cloud slot": "تمت إزالة الكاميرا من منفذ السحابة.",
	"How to delete camera list": "طريقة حذف كاميرا من القائمة",
	Update: Update$g,
	"Camrea setting": "إعداد الكاميرا",
	"Notification setting": "إعدادات الإشعارات المنبثقة",
	"Driving reports": "تقرير القيادة",
	"Cloud connection steps": "خطوات الاتصال بالسحابة",
	"Download the BlackVue app to add a camera": "تنزيل تطبيق BlackVue لإضافة كاميرا",
	"To see your camera in the BlackVue cloud viewer_": "لرؤية الكاميرا الخاصة بك في عارض ‎BlackVue cloud‎، يجب عليك توصيلها بالسحابة أولاً. قم بإعداد كاميرا BlackVue وتوصيلها بسهولة\n \n بالسحابة مع تطبيق BlackVue لنظامي iOS وAndroid.",
	"Download the BlackVue app to see a Wi-Fi connected camera": "قم بتنزيل تطبيق BlackVue لرؤية الكاميرا المتصلة بشبكة ‎Wi-Fi‎",
	"BlackVue Cloud web viewer only supports_": "يدعم عارض الويب ‎BlackVue Cloud‎ فقط كاميرا لوحة القيادة (داش كام) المتصلة بالسحابة. يُرجى تنزيل تطبيق BlackVue لرؤية كاميرا لوحة القيادة (داش كام) المتصلة بشبكة ‎Wi-Fi‎.",
	"You can restore the data if_": "يمكنك استعادة البيانات إذا سجلت هذه الكاميرا على الحساب نفسه مرة أخرى. ولكن إذا تم حذف الحساب، فستفقد جميع ملفاتك.",
	"How to add camera": "طريقة إضافة كاميرا",
	"Try to wait 2-3 minutes if you just registered the camera.": "حاول الانتظار لمدة 2-3 دقائق إذا سجلت الكاميرا للتو.",
	"Try to check the Cloud Connection Settings again_": "حاول التحقق من إعدادات الاتصال بالسحابة مرة أخرى، إذا كانت الكاميرا لا تزال غير متصلة بالسحابة.",
	"Motion Detection": "اكتشاف الحركة",
	"Parking recordings occur_": "يتم تشغيل التسجيلات في وضع إيقاف المركبة عند اكتشاف حركة مرئية.",
	"Motion Sensitivity": "الحساسية للحركة",
	"Motion Detection Sensitivity": "حساسية كشف الحركة",
	"Select Detection Region": "تحديد منطقة الاكتشاف",
	"Speed alert_2": "تنبيه السرعة",
	"Live Event Upload_2": "Live Event Upload",
	"Beep Alert": "التنبيه الصوتي",
	"Parking Impact History_": "تنبيه محفوظات التأثيرات في وضع إيقاف المركبة",
	"To register your_": "لتسجيل زر الطوارئ الخاص بك ، يجب عليك استخدام تطبيق BlackVue.\n\n\n",
	"SOS button on/off": "حالة زر SOS",
	"File sharing to Event Map is_": "مشاركة الملف إلى \"خريطة الأحداث\" غير متاحة حاليًا. يرجى التحقق مرة أخرى في وقت لاحق.",
	"Email Notifications": "إشعارات البريد الإلكتروني",
	"Push Notifications_2": "الإشعارات المنبثقة",
	"Optional Camera Rotation": "اتجاه الكاميرا الاختيارية",
	"Optional Camera Security": "أمان الكاميرا الاختيارية",
	Option: Option$g,
	"(Owner)": "{{a}} (المالك)",
	"SOS button": "زر SOS",
	"This video has been reported_bold": "قام المسؤول بالإبلاغ بهذا الفيديو ‎<b>‎وإزالته.‎</b>‎",
	"Number of events_2": "عدد الأحداث",
	"My Shared Videos": "مقاطع الفيديو التي قمتُ بمشاركتها",
	"No Hashtags": "لا توجد علامات للكلمات الرئيسية",
	"I have read and agree_": "I have read and agree to all",
	"14 years old_": "يجب أن يكون العمر 14 عامًا أو أكثر",
	Required: Required$g,
	Optional: Optional$g,
	"Profile information_": "يمكن تحرير معلومات ملف التعريف من صفحة إعدادات الحساب.",
	"Automatically Add Live_": "ملفات التحميل التلقائي لحدث المشاركة التلقائية إلى خريطة الأحداث",
	"You must be 14 years_": "يجب أن يكون عمرك 14 عامًا أو أكثر لإنشاء حساب على BlackVue",
	"Use 8 or more characters_": "استخدم 8 أحرف أو أكثر تتضمن مزيجًا من الأحرف أو الأرقام أو الرموز",
	"Protected files include_": "تشمل الملفات المحمية ما يأتي: ‎<br/>ㆍأحداث التأثير في الوضع العادي ‎(E)‎ ووضع إيقاف المركبة ‎(I)‎ ‏<br/>ㆍالأحداث اليدوية ‎(M)‎ ‏‎<br/><br/>بمجرد تسجيل ‎{{a}} من الأحداث، سيتم استبدال الأحداث الأقدم بالأحداث الجديدة.",
	"Protected files include": "Protected files include",
	"If you turn_": "إذا قمت بإيقاف الإرشادات الصوتية ، فسيتم إيقاف القوائم التالية أيضًا.",
	"Live Event Upload_success": "تم حفظ إعدادات تحميل الحدث المباشر بنجاح.",
	"Video type": "أنواع الفيديو",
	"Notify the Owner": "إخطار المالك",
	"Adjusting the cut-off voltage_2": "Adjusting the cut-off voltage to a lower setting may result in your dash cam draining more power from your battery. This could result in warning messages of battery drain or affect other vehicle functions.\nPlease consult with your dealership before lowering the voltage.",
	Others: Others$g,
	"This video has been removed.": "تمت إزالة هذا الفيديو.",
	"Please assign cameras_": "يُرجى تعيين كاميرات لهذه المجموعة.",
	"Are you running_": "هل تنفد فُرصُك في مشاهدة التشغيل؟",
	"Upgrade your plan_": "قم بترقية خطتك إلى خطة الأسطول للتشغيل غير المحدود وغيرها من الميزات الحصرية على السحابة.",
	"Are you running_Liveview": "هل ينفد منك الوقت لمشاهدة العرض المباشر؟",
	"Upgrade your plan_Liveview": "قم بترقية خطتك إلى خطة الأسطول للعرض المباشر غير المحدود وغيرها من الميزات الحصرية على السحابة.",
	Stay: Stay$g,
	"Go to Fleet Plan": "الانتقال إلى خطة الأسطول",
	"It looks like the video file is being prepared. please try again later.": "يبدو أن ملف الفيديو قيد التحضير. الرجاء معاودة المحاولة في وقت لاحق.",
	"Oops!": "أُووبس!",
	"Please back up_": "يرجى إجراء نسخ احتياطي لكافة التسجيلات المهمة قبل تغيير هذا الإعداد.",
	"When you save_": "عند حفظ الإعدادات ، سيتم تنسيق بطاقة microSD وحذف جميع التسجيلات لضمان التشغيل المستقر.",
	"This is an unregistered_": "هذا بريد إلكتروني غير مسجل. هل ترغب في الذهاب إلى صفحة إنشاء حساب؟",
	"Camera name must_2": "يجب أن يحتوي اسم الكاميرا على 5 إلى 32 رمزًا.",
	"G-sensor (Normal mode)": "مقياس السرعة (الوضع العادي)",
	"G-sensor (Parking mode)": "مقياس السرعة (وضع إيقاف السيارة)",
	"Up & down": "أعلى وأسفل",
	"Front & back": "الأمام والخلف",
	"Rotate Video 180º": "Rotate Video 180º",
	Mask_2: Mask_2$g,
	"Priority event": "Priority Event",
	"There is no_camera": "There is no camera that your owner assigned to you.",
	"Camera SSID": "Camera SSID",
	"The BlackVue dashcam_2": "The BlackVue dashcam is not compatible with 5GHz wireless networks",
	"Driver detection box_2": "Driver Detection Box",
	"DMS camera recording_2": "DMS Camera Recording in Parking Mode",
	Low_2: Low_2$g,
	Medium_2: Medium_2$g,
	High_3: High_3$g,
	"Live Event Upload_3": "Live Event Upload",
	"Driving Impact": "Driving Impact",
	"Video source_2": "Video Source",
	"Front camera_2": "Front Camera",
	"Rear camera_2": "Rear Camera",
	"Optional Camera": "Optional Camera",
	"Motion Detection_2": "Motion Detection",
	"Rear camera stops_2": "Rear camera stops recording 5 minutes after entering Parking Mode. Recording restarts when entering normal mode.",
	"Passenger vehicle": "Passenger Vehicle",
	"Heavy vehicle": "Heavy Vehicle",
	Highest_3: Highest_3$g,
	Extreme_2: Extreme_2$g,
	"Less recording files": "Fewer Recording Files",
	"Camera rotation_2": "Camera Rotation",
	"Share camera profile_2": "Share Camera Profile",
	Private_2: Private_2$g,
	"BlackVue Live": "BlackVue Live",
	"Important All saved_": "Important! All saved videos are about to be deleted. Tap Cancel and back up important files if needed.",
	"Whenever saving settings_": "Whenever saving settings after changing the time zone, the SD card is initialized and all stored files are deleted.",
	"Do you want_": "Do you want to save your changes?",
	"No groups": "No groups",
	Lite: Lite$g,
	"USD per Camera": "USD per extra Camera",
	"up to Cameras": "up to Cameras",
	"All the P Plan_": "جميع ميزات خطة <b>{{a}}</b>، بالإضافة إلى:",
	"User Roles and Permissions": "أدوار المستخدمين والأذونات",
	"Geofence Setup (Web) and alerts": "Geofence Setup (Web) and alerts",
	"N Times": "{{a}} مرات",
	"N Minutes": "{{a}} دقائق",
	"Emergency Alarm": "إنذار الطوارئ",
	"Playback, Live View": "تشغيل، عرض مباشر",
	"Your driving record : Daily, Monthly": "سجل القيادة الخاص بك: يوميًا، شهريًا",
	"Real-time Conversation": "محادثة في الوقت الحقيقي",
	"Initiate a conversation_": "ابدأ محادثة مع السائق من خلال مكبر الصوت والميكروفون في DashCam.",
	"Remote Voice Communication": "الاتصال الصوتي عن بعد",
	"See the last location_": "شاهد آخر موقع للكاميرا",
	"Check your cars_": "تحقق من بيانات GPS في الوقت الفعلي لسيارتك على خريطة لتحديد موقع سيارتك والحصول على معلومات حول حالتها ، مثل ما إذا كانت تقود أو متوقفة ، وسرعتها.",
	"Supported models_": "* النماذج المدعومة: S و Sister Series Early",
	"GPS Tracking &_": "GPS Tracking والفيديو على الخريطة (Smart/Fleet)",
	"Track your cars_": "تتبع موقع سيارتك وسرعة على الخريطة!",
	"GPS Tracking: visualize_": "تتبع GPS: تصور سجل القيادة الخاص بك على الخريطة.\nالفيديو على الخريطة: عرض المعلومات السياقية (السرعة ، نوع الحدث) وتشغيل مقاطع الفيديو ذات الصلة مباشرة من الخريطة.",
	"Visualize your cars_": "قم بتصور موقع سيارتك وسرعتها على الخريطة!",
	"The feature enables_": "تتيح هذه الميزة رفع لقطات الفيديو إلى السحابة، بما في ذلك 5 ثوانٍ قبل وقوع حادث.",
	"Camera profile setting": "Camera profile setting",
	"Are you running_Download": "Are you running out of chance to Download Video?",
	"Upgrade your plan_Download": "Upgrade your plan to Fleet Plan for Unlimited Download, and other Cloud -Exclusive features.",
	"This feature is available for Smart and Fleet_": "This feature is available for Smart and Fleet Plan subscribers only.",
	"Rear camera will keep_": "تتوقف الكاميرا الخلفية عن التسجيل في وضع وقوف السيارة عندما يتم تغيير حالة حرارة كاميرا السيارة إلى \"حرارة عالية\". ستبدأ الكاميرا الخلفية في التسجيل مرة أخرى بعد تغيير حالة حرارة كاميرا السيارة إلى \"حرارة عادية\". (تنبيه: من أجل حماية الإلكترونيات، قد تُغلق Blackvue بسبب ارتفاع درجة الحرارة الخارجية.)",
	"Get Unlimited Cloud_": "احصل على تشغيل سحابي غير محدود وإدارة ما يصل إلى {{a}} كاميرا.",
	"Up to N cameras_": "Up to {{a}} cameras (+ {{b}} USD Extra charge)",
	"N Minutes per Day": "{{a}} دقائق في اليوم",
	"Drowsiness sensitivity is_": "يتم تعيين حساسية نعسان عن طريق فترة رمش العين باستخدام خوارزمية BlackVue الموثوق بها. <br> <br> يتم تعيين حساسية مشتت من خلال زاوية وضعية رأس السائق من الأمام والوقت الذي يستغرقه في هذه الوضعية.",
	"Not available with this plan": "Not available with this plan",
	"The optional camera records_": "تسجل الكاميرا الاختيارية في وضع الوقوف",
	"Smart and Fleet_": "Smart and Fleet Plan<br/>subscribers only",
	"This feature is_smart": "This feature is available for Smart and Fleet Plan subscribers only.",
	"Camera Registration": "تسجيل الكاميرا",
	"Voice Call": "Voice Call",
	"N times per Month": "{{a}} times per Month",
	"Recommended for higher bitrate_": "موصى به لبيع البت العالي وجودة فيديو أفضل.",
	"Recommended for for better compatibility_": "موصى به لتحسين التوافق مع أجهزة سطح المكتب والأجهزة المحمولة",
	"A minute of front camera_": "حجم الملف المقدر لمقطع فيديو دقيقة واحدة (الكاميرا الأمامية)",
	"Extreme(N Mbps): N MB_": "Extreme ({{ex1}}Mbps) : {{ex2}}MB\nHighest ({{ht1}}Mbps) : {{ht2}}MB\nHigh ({{hi1}}Mbps) : {{hi2}}MB\nNormal ({{no1}}Mbps) : {{no2}}MB",
	"File size information reflects_": "تعكس معلومات حجم الملف الحد الأقصى المحتمل للحجم وقد تختلف أحجام الملفات الفعلية على شروط التسجيل.",
	Bitrate: Bitrate$g,
	"Connection has been_": "لقد فقد الاتصال.\nإعادة إنشاء الاتصال ...",
	"Unable to establish_": "غير قادر على إنشاء اتصال مع الكاميرا.\nيرجى التأكد من توصيل جهازك بشكل صحيح ومحاولة مرة أخرى.",
	"Purchased by Payment Service": "تم الشراء عبر خدمة الدفع",
	"Up to N Cameras": "حتى {{a}} كاميرات",
	"Unlimited Live View": "عرض مباشر غير محدود",
	"N Days GPS Tracking": "تتبع GPS لمدة {{a}} يومًا",
	"Unlimited Playback and Download": "التشغيل والتنزيل غير محدودين",
	hours: hours$g,
	"Live Event Upload or_": "رفع الحدث المباشر أو 12+ فيديو بدقة كاملة",
	"During the usage period of the One Plan_": "خلال فترة استخدام خدمة One Plan، لا يمكن تغيير خطط الاشتراك. للتبديل إلى خطة مختلفة، يرجى التواصل مع دعم عملاء BlackVue لإلغاء اشتراك One Plan.",
	"Service Period (Include SIM Data)": "فترة الخدمة (تشمل بيانات SIM)",
	"Purchase the BlackVue One Package_": "قم بشراء حزمة BlackVue One لفتح One Plan مجانًا لمدة عام واحد.",
	"3GB SIM Data Plan": "خطة بيانات SIM سعة 3 جيجابايت",
	"Unlimited Live View, Playback and Download": "عرض مباشر غير محدود، تشغيل وتنزيل",
	"within data availability": "داخل توافر البيانات",
	"The BlackVue One Plan is a 1-year_": "BlackVue One Plan هو خطة خدمة سحابية لمدة عام واحد يمكن الوصول إليها حصريًا من خلال شراء حزمة BlackVue One، والتي تتضمن كاميرا لوحة القيادة، خطة بيانات سنوية سعة 3 جيجابايت/شهر (للولايات المتحدة وكندا) وخطة خدمة سحابية لمدة عام.",
	"The BlackVue One Package is available_": "حزمة BlackVue One متاحة حصريًا في متجر BlackVue عبر الإنترنت.",
	"Go to BlackVue Shop": "انتقل إلى متجر BlackVue",
	"Anonymous Cam": "كاميرا مجهولة",
	"App only": "فقط في التطبيق",
	Expires: Expires$g,
	"N days remaining": "{{a}} أيام متبقية",
	"No action needed_": "<b>لا يلزم أي إجراء.</b> سيتم تطبيق السعر المخفض الجديد تلقائياً ابتداءً من الدفعة القادمة بعد 13 سبتمبر.",
	"The new reduced price_": "السعر المخفض الجديد سيُطبق تلقائياً على حسابك.",
	"Smart Plan Subscriber?": "هل أنت مشترك في خطة Smart Plan؟",
	"Fleet Plan Subscriber?": "هل أنت مشترك في خطة Fleet Plan؟",
	"Please take a moment to_": "يرجى أن تأخذ لحظة لتفويضنا بنقل حسابك.",
	"Starting from now and_": "<b>ابتداءً من الآن وحتى 31 أكتوبر</b>، يمكنك السماح لنا بإجراء التغيير لك عبر <a href=\"https://form.jotform.com/232411253056041\" target=\"_blank\">النقر على.يرجى منحنا بعض الوقت لمعالجة التغيير. بديلًا، ستتمكن من إلغاء حسابك الحالي وإعادة الاشتراك بالسعر الجديد ابتداءً من 13 سبتمبر. هذا الرابط</a> وإدخال بريدك الإلكتروني لحساب Fleet الخاص بك.",
	"Once activated_": "بمجرد تفعيله، لا يمكن إيقاف One Plan أو إلغاء تنشيطه.",
	"Once the One Plan is activated_": "بمجرد تفعيل One Plan، لا يمكن استرداد One Package.",
	"Up to N Cloud Camera Slot": "تصل إلى {{a}} فتحة كاميرا سحابية",
	"nGB of Cloud Storage": "{{a}} غيغابايت من التخزين السحابي",
	"Get started for free_": "Get started for free, no credit card required. Includes Alert Push Notifications, limited Remote Live View and cloud storage.",
	"The BlackVue One Plan is exclusively_": "The BlackVue One Plan is exclusively available through the purchase of a BlackVue One Package. 3GB/mo data plan is for US and Canada only. BlackVue Cloud’s Free Plan, Lite Plan (1~3) and Smart Plan (1~3) accounts can upgrade to One Plan. However, Lite Plan (4~15), Smart Plan (4~15) and Fleet Plan accounts can not be upgraded to One Plan.",
	"For N year": "For {{a}} year",
	"Included in the One Package": "Included in the One Package",
	"3GB SIM Data Plan for N year": "3GB SIM Data Plan for {{a}} year",
	"One Plan Cloud Service for N year": "One Plan Cloud Service for {{a}} year",
	"The BlackVue One Package includes_": "The BlackVue One Package includes all you need to enjoy BlackVue Cloud for a whole year!",
	"4K LTE Dash Cam_": "4K LTE Dash Cam, Cloud Service and Data Plan",
	"nGB included": "{{a}}GB included",
	"nGB per camera": "{{a}}GB per camera",
	"N Days Live Event Upload": "{{a}} Days Live Event Upload",
	"Up to N Dash Cameras": "Up to {{a}} Dash Cameras",
	"Step N/N": "خطوة {{a}}/{{b}}",
	"Cloud Connection": "اتصال بالسحابة",
	"To pair your dashcam": "لربط كاميرا السيارة بالبطارية الخاصة بك، يرجى توصيلها بالسحابة.",
	Check: Check$g,
	"Unpair Battery": "فصل البطارية",
	"Are you sure you want to unpair": "هل أنت متأكد أنك تريد فصل هذه البطارية (s%) من الكاميرا؟",
	"Unpair: It doesn't mean": "إلغاء الزوجية: هذا لا يعني حذف بيانات البطارية.",
	"*The paired battery will": "*سيتم إزالة البطارية المقترنة معًا أيضًا.",
	"Would you like to pair this": "هل ترغب في تزويج هذه البطارية؟",
	"Battery successfully paired": "تم إقران البطارية بنجاح.",
	"Now you can directly connect to": "الآن يمكنك الاتصال مباشرة بالبطارية من قائمة الكاميرا.",
	"Pairing failed": "فشل الزوج. يرجى المحاولة مرة أخرى.",
	"Battery Name": "اسم البطارية",
	"Capacity History": "تاريخ السعة",
	"The graph displays capacity": "يعرض الرسم البياني مستوى تقريبي للبطارية باستخدام البيانات من اتصال السحابة\n قد تختلف سعة البطارية اعتمادًا على درجة الحرارة وإعدادات كاميرا الرصد وتكرار حدوث الأحداث المؤدي\n\n\n\n\n",
	"Last 24 Hours": "الـ24 ساعة الأخيرة",
	"Last 7 Days": "الـ7 أيام الأخيرة",
	"Battery Level": "مستوى البطارية",
	"Temperature History": "سجل درجات الحرارة",
	"The graph displays temperature": "يعرض الرسم البياني مستوى الحرارة التقريبي باستخدام بيانات من اتصال السحابة.",
	"Temperature Level": "مستوى الحرارة",
	"Connecting alert": "[ جارِ الاتِّصال ]\nالبيانات التي تعرض عند الاتصال.",
	"Low Output power Alert": "[ فصل الطاقة الناتجة ]\nالجهد الناتج منخفض جدًا، مما يقيد تزويد الطاقة للجهاز المتصل به.",
	"High temp Alert": "[ قطع التيار الوارد ]\nدرجة حرارة البطارية مرتفعة جدًا، مما يقيد الشحن.",
	"Remaining time": "الوقت المتبقي",
	"Remaining time estimate": "الوقت المتبقي هو تقدير يستند إلى الاستهلاك الكلي للطاقة للأجهزة المتصلة.\n يتم إعادة حسابه كل 30 ثانية بعد الاتصال بالبطارية.",
	"Setting changed": "تغيير الإعداد",
	"Setting change failed": "فشل تغيير الإعداد",
	"Low Input power Alert": "[ قطع التيار الوارد ]\nالجهد الكهربائي للشحن منخفض للغاية، مما يقيد عملية الشحن.",
	"High Input power Alert": "[ قطع التيار الوارد ]\nالجهد الكهربائي للشحن مرتفع جدًا، مما يقيد الشحن.",
	"Low temp_Cut off Alert": "[ قطع التيار الوارد ]\nدرجة حرارة البطارية منخفضة جدًا، مما يقيد الشحن والوقت الاستخدام.",
	"Low temp Alert": "[ درجة حرارة منخفضة ]\nدرجة حرارة البطارية منخفضة جدًا، مما يحد من الوقت الذي يستغرقه التشغيل وسرعة الشحن.",
	"Low capacity Alert": "[ السعة المنخفضة ]\nسعة البطارية منخفضة جدًا.\nاقود السيارة لشحنها.",
	"Back to list": "العودة إلى القائمة",
	Saving: Saving$g,
	Now: Now$g,
	"Power supplying is limited": "توفير الطاقة <b>محدود</b>",
	"This battery is already paired": "هذه البطارية مقترنة بالفعل.",
	"Connecting to Battery": "الاتصال بالبطارية",
	"Paired battery": "البطارية المقترنة",
	"Battery unpairing failed": "فشل إلغاء إقران البطارية. يرجى المحاولة مرة أخرى.",
	"A connection is already active": "الاتصال نشط بالفعل. يرجى المحاولة مرة أخرى لاحقًا.",
	"Searching for battery": "البحث عن البطارية",
	"Select battery to pair with your camera": "اختر البطارية لإقرانها بكاميرتك.",
	"Unable to connect": "غير قادر على الاتصال",
	"A connection error has occurred": "حدث خطأ في الاتصال. يرجى المحاولة مرة أخرى.",
	"The paired dashcam has been disconnected": "تم فصل كاميرا السيارة المقترنة عن السحابة.\nالرجاء التحقق من الشروط أدناه.",
	"Check if the battery is not fully discharged": "تحقق مما إذا كانت البطارية لم تفرغ تمامًا",
	"Check the Cloud connection of the paired dashcam": "تحقق من اتصال السحابة لكاميرا السيارة المقترنة",
	"Connection lost": "تم فقدان الاتصال",
	"A connection error has occurred shortly": "حدث خطأ في الاتصال. يرجى المحاولة الاتصال في وقت قريب.",
	"Charging is limited": "الشحن <b>محدود</b>",
	"Cannot connect to the battery": "لا يمكن الاتصال بالبطارية.",
	"Please check the Cloud connection of the camera": "يُرجى التحقق من اتصال الكاميرا بالسحابة.",
	"Charging complete in": "يكتمل الشحن خلال ‎%@",
	"Current Capacity": "السعة الحالية",
	"Output Voltage": "جهد الإخراج",
	"Charging Voltage": "جهد الشحن",
	Beep: Beep$g,
	"Battery Capacity": "سعة البطارية",
	"Battery connection failed": "فشل اتصال البطارية",
	"Expansion battery": "بطارية احتياطية",
	"Make sure it is switched on and within range": "• تأكد من أنها قيد التشغيل وأنها ضمن نطاق هاتفك المحمول.",
	"Make sure it is not wirelessly connected to another device": "• تأكد من أنها غير متصلة لاسلكيًا بجهاز آخر.",
	"Detected batteries": "البطاريات التي تم اكتشافها",
	"Can't see your battery": "هل تتعذر عليك رؤية البطارية؟",
	"Download the Blackvue app to check": "قم بتنزيل تطبيق BlackVue للتحقق من بطاريتك عن بعد",
	"By Using the app": "باستخدام التطبيق، يمكنك إقران كاميرا السيارة الخاصة بك بالبطارية ومراقبة سعة البطارية عبر السحابة. بعد الإقران، يمكنك التحقق من البطارية في مشاهد السحابة لـ BlackVue.",
	Unpair: Unpair$g,
	"Occurs when the driver closes_": "يحدث عندما يُغلق السائق كلتا العينين أثناء القيادة",
	"Occurs when the driver's head_": "يحدث عندما يكون رأس السائق أكثر من 50 درجة بعيدًا عن الأمام.",
	"Only detects distraction above_": "يكتشت فوق القيمة المحددة فقط. يمكنك تغيير الوحدة في 'إعدادات الكاميرا > مشغلات الأحداث > وحدة القيادة المتهورة'.",
	"Occurs when the driver is not wearing_": "يحدث عندما لا يرتدي السائق حزام الأمان.",
	"Overlays a face detection box_": "وضع مربع كشف الوجه على اللقطات الحية والمسجلة من كاميرا DMS.",
	"Seat Belt": "حزام الأمان",
	Detected: Detected$g,
	"No Seat Belt": "لا توجد حزام الأمان",
	"Fatigue Risk Alert": "تنبيه خطر التعب",
	"The time is synchronized_Email": "الوقت متزامن مع الوقت في إشعارات البريد الإلكتروني الخاصة بك.",
	"Sends an alert when drowsiness is_": "يُرسل تنبيه عند اكتشاف النعاس بعد النعاس الأولي.",
	"Data updates upon connection": "تحديث البيانات عند الاتصال.",
	"Sends a notification if_": "يُرسل إشعارًا إذا تجاوزت 'تعيين الوقت' أثناء القيادة.",
	"Data updates Alert": "[ جارِ الاتِّصال ]\nتحديث البيانات عند الاتصال.",
	"Cannot save settings": "لا يمكن حفظ الإعدادات",
	"The time is synchronized_Push": "الوقت متزامن مع الوقت في الإشعارات المنبثقة الخاصة بك.",
	"The file has been overwritten or deleted": "تم استبدال الملف أو حذفه.",
	"Box Pro Models Settings": "إعدادات نماذج Box Pro",
	"Push notifications can be configured_": "يمكن تكوين الإشعارات الفورية في إعدادات إشعارات الكاميرا.",
	"Recording Video": "تسجيل الفيديو",
	"Cameras settings": "إعدادات الكاميرات",
	"Please configure the settings": "يرجى تكوين الإعدادات",
	"Speed Priorities": "أولويات السرعة",
	"Set Speed Priority": "ضبط أولوية السرعة",
	"Geofence-enter": "السياج الجغرافي - دخول",
	"Geofence-exit": "السياج الجغرافي - خروج",
	"Geofence-pass": "السياج الجغرافي - مرور",
	"Geofence-speed alert": "السياج الجغرافي - تنبيه السرعة",
	"Drive Position": "موضع القيادة",
	"Left-Hand Drive": "القيادة باليد اليسرى",
	"Right-Hand Drive": "القيادة باليد اليمنى",
	"Please configure this setting_": "يرجى تغيير هذا الإعداد إذا لم يتم اكتشاف السائق بشكل صحيح.",
	"A new feature in the BlackVue settings_": "تمت إضافة ميزة جديدة في إعدادات BlackVue لمزامنة وقت الكاميرا. يجب عليك مزامنة وقت الكاميرا مرة واحدة لتسجيل الوقت بدقة.",
	"Feature location_": "موقع الميزة:\nإعدادات الكاميرا > النظام > مزامنة الوقت",
	"Time Sync": "مزامنة الوقت",
	"You can sync the time between_": "يمكنك مزامنة الوقت بين جهازك وكاميرا BlackVue. يتطلب تنسيق بطاقة SD للمزامنة. قبل المتابعة، يرجى نسخ أي مقاطع فيديو ضرورية احتياطياً.",
	"Voice Alert": "تنبيه صوتي",
	"Provides a voice alert_": "يوفر تنبيهًا صوتيًا من الكاميرا ويرسل إشعارًا إذا تجاوزت الوقت المحدد أثناء القيادة.",
	"Please enter a value": "Please enter a value.",
	"Notices & Notifications": "الأخبار والإشعارات",
	"Only detects drowsiness above_": "يكتشت فوق القيمة المحددة فقط. يمكنك تغيير الوحدة في 'إعدادات الكاميرا > مشغلات الأحداث > وحدة القيادة المتهورة'.",
	Promotion: Promotion$g,
	Notice: Notice$g,
	"View More": "عرض المزيد",
	"Read More": "اقرأ المزيد",
	"Detection Box": "صندوق الكشف",
	"Seatbelt Detection Box": "صندوق كشف حزام الأمان",
	"Drive Position Detection Box": "صندوق كشف وضع القيادة",
	"Fleet Subscription Promotion (50%)": "عرض اشتراك الأسطول (50%)",
	"BlackVue Fleet Tracking exclusive features_": "ميزات BlackVue Fleet Tracking الحصرية للمستخدمين المتميزين والشركات على حدٍ سواء (تعدد المستخدمين والكاميرات، والسياج الجغرافي، وعارض الويب، وما إلى ذلك).",
	"Special Discount (50% off)": "خصم خاص (50% خصم)",
	"*Promotion applied for 12 months": "*يسري العرض لمدة 12 شهرًا",
	"*Payment will be made starting next month.": "* سيتم السداد ابتداءً من الشهر القادم.",
	"[About using promotions]": "[حول استخدام العروض الترويجية]",
	"The promotion is free for the first month_": "العرض الترويجي مجاني للشهر الأول، ثم تتم محاسبته لمدة 12 شهرًا بدءًا من الشهر التالي.",
	"For users with an existing Lite/Smart subscription_": "بالنسبة للمستخدمين الذين لديهم اشتراك Lite/Smart حالي، يجب عليك إلغاء اشتراك التطبيق الحالي الخاص بك بشكل منفصل، وإلا فقد يتم تحميل اشتراك التطبيق الحالي على حسابك.",
	"Please be sure to cancel your app subscription_": "يرجى التأكد من إلغاء اشتراكك في التطبيق خلال الفترة المجانية. لن يتم رد المبالغ المدفوعة المزدوجة.",
	"You will be changed to Fleet Plan immediately_": "سيتم تغييرك إلى Fleet Plan على الفور، حتى لو لم تنته مدة الاشتراك المتبقية في Lite/Smart Plan الموجودة لديك.",
	"You can cancel Fleet Plan any time.": "يمكنك إلغاء خطة الأسطول في أي وقت.",
	"From February 2025, please go to the Fleeta service and use it.": "بمجرد إلغاء العرض الترويجي، لن يتم إعادة تطبيق العرض الترويجي.",
	"After promotion expires_": "بعد انتهاء العرض الترويجي، سيتم تجديد اشتراكك تلقائيًا برسوم الاشتراك الحالية في خطة الأسطول.",
	"(Required) I have read the promotion instructions_": "(مطلوب) لقد قرأت تعليمات العرض الترويجي وأوافق على الدفع.",
	"Upgrade to Fleet Plan immediately": "قم بالترقية إلى خطة الأسطول على الفور",
	"Important Notice:": "ملاحظة هامة:",
	"Switch of BlackVue Web Viewer to Fleeta Web Viewer": "تبديل BlackVue Web Viewer إلى Fleeta Web Viewer",
	"To provide better features and quality_": "لتوفير ميزات وجودة أفضل، ستتحول خدمة عارض الويب BlackVue قريبًا إلى خدمة عارض ويب جديدة للأسطول تسمى Fleeta. ستكون خدمات Fleeta حصرية لمستخدمي خطة الأسطول فقط. سيتم إطلاق خدمة Fleeta في مارس 2025، مع تطبيق Fleeta الحصري الجديد. يرجى زيارة <a href=\"https://www.fleeta.io\" target=\"_blank\">fleeta.io</a> لمعرفة المزيد.",
	"We kindly ask for your understanding_": "نرجو تفهمكم، حيث أن هذا التغيير يهدف إلى تقديم خدمة محسنة. إذا كانت لديك أية أسئلة بخصوص هذا النقل، فلا تتردد في الاتصال بمركز علوم الكمبيوتر لدينا.",
	"Don’t show this again for this month": "لا تظهر هذا مرة أخرى لهذا الشهر",
	"Fleet Plan Subscription Promotion": "الترويج للاشتراك في خطة الأسطول",
	"Period : December 2, 2024 ~ May 31, 2025": "الفترة: 2 ديسمبر 2024 - 31 مايو 2025",
	"See more details": "رؤية المزيد من التفاصيل",
	"To continue improve quality and provide better service_": "لمواصلة تحسين الجودة وتقديم خدمة أفضل، ستتحول خدمة BlackVue Web Viewer الخاصة بنا قريبًا إلى خدمة Fleet Plan الحصرية. ولن يكون متاحًا مجانًا أو من خلال خطط أخرى بدءًا من أواخر مارس 2025.",
	"We have prepared special discount offers for_": "لقد قمنا بإعداد عروض خصم خاصة لمستخدمي Web Viewer الحاليين لدينا. يرجى التحقق من التفاصيل أدناه! نرجو تفهمكم ودعمكم بينما نقوم بتنفيذ هذا التغيير لتقديم خدمة أفضل.\n",
	"*If you are subscribed in-app_": "*إذا كنت مشتركًا داخل التطبيق، فيرجى التأكد من إلغاء اشتراكك داخل التطبيق.",
	"Enjoy your BlackVue Cloud service with your dashcam.": "استمتع بخدمة BlackVue Cloud الخاصة بك مع كاميرا لوحة القيادة الخاصة بك.",
	"Available Cloud Camera slot(s)_": "فتحة (فتحات) الكاميرا السحابية المتوفرة : {{d}}",
	"Not eligible for the promotion.": "غير مؤهل للترقية.",
	"You have already used_": "لقد استخدمت هذا العرض الترويجي بالفعل. بمجرد إلغاء العرض الترويجي، لا يمكن إعادة تطبيقه.",
	"Go to Cameras": "اذهب إلى الكاميرات",
	"Congratulations !": "Congratulations !",
	"Fleet Plan user": "Fleet Plan user",
	"Let your BlackVue monitor_": "دع جهاز BlackVue يراقب سيارتك وينبهك بالحوادث. في اللحظة التي يتم فيها اكتشاف التأثير، سيرسل جهاز BlackVue الخاص بك إشعارًا إلى هاتفك، مصحوبًا بلقطة.\n",
	"Live Event Upload feature automatically_": "تعمل ميزة تحميل الأحداث المباشرة على تحميل لقطات الفيديو تلقائيًا، بما في ذلك لقطات ما قبل الحادث، إلى BlackVue Cloud Storage للحفاظ على أمان مقاطع الفيديو الخاصة بك!",
	"*Buffer time varies by model.": "* يختلف وقت التخزين المؤقت حسب الطراز.",
	Explore: Explore$g,
	"Cloud Storage": "التخزين السحابي",
	"My Cloud Cameras": "كاميراتي السحابية",
	"My Cloud Cameras Only": "كاميراتي السحابية فقط",
	"BlackVue Live Camera": "كاميرا بلاك فيو الحية",
	"*For BlackVue Live Cameras_": "*بالنسبة لكاميرات BlackVue Live، يمكن فقط عرض الكاميرات المشتركة كعامة في إعدادات الكاميرا على الخريطة.",
	"*Share Method_": "*طريقة المشاركة: إعداد الكاميرا>الخصوصية",
	"Once the promotion is canceled_": "بمجرد إلغاء العرض الترويجي، لن يتم إعادة تطبيق العرض الترويجي.",
	"It will show_": "سوف تظهر هنا عند توفرها.",
	"Deactivate Cloud": "قم بإلغاء تنشيط السحابة",
	"Are you sure you want to deactivate_": "هل أنت متأكد أنك تريد إلغاء تنشيط السحابة لهذه الكاميرا؟",
	"Deactivate : It doesn’t_": "يمكنك دائمًا تفعيل السحابة في أي وقت. يمكن حذف الكاميرا بعد اكتمال التعطيل.",
	Deactivate: Deactivate$f,
	"*If you made the payment through_": "*إذا قمت بالدفع من خلال التطبيق، يرجى إعادة تشغيل التطبيق.",
	"Connect Dashcam Locally (Wi-Fi)": "توصيل Dashcam محليًا (Wi-Fi)",
	"Cloud Connection Setting": "إعداد الاتصال السحابي",
	"Camera Profile": "ملف تعريف الكاميرا",
	"Camera Settings": "إعدادات الكاميرا",
	"Format MicroSD Card": "تهيئة بطاقة microSD",
	"Remote Firmware Update": "تحديث البرامج الثابتة عن بعد",
	"Remove from Cloud": "إزالة من السحابة",
	"The location may not be accurate_": "قد لا يكون الموقع دقيقًا لأن الكاميرا غير متصلة بالسحابة.",
	"The location of the camera cannot be found_": "لا يمكن العثور على موقع الكاميرا. يرجى التحقق من إعدادات الاتصال السحابي.",
	"Manage\nFLEETA Drive": "إدارة\nFLEETA درايف",
	"Cloud\nConnection": "الاتصال\nالسحابي",
	"Available on FLEETA App": "متوفر على تطبيق FLEETA",
	"Available for Cloud dashcam OR on FLEETA App.": "متوفر لكاميرا الداش السحابية أو على تطبيق FLEETA.",
	"Get started with_": "ابدأ بتجربة مجانية لمدة شهر واحد",
	"Experience all of_": "تجربة جميع ميزات FLEETA المميزة مجانًا خلال فترة التجربة المجانية لمدة شهر واحد.\n\nبدون التزام—الإلغاء في أي وقت",
	"Welcome to FLEETA Webviewer.": "مرحبًا بكم في FLEETA Webviewer.",
	"Let FLEETA get_": "دع FLEETA يتعرف عليك",
	"Help improve your_": "ساعد في تحسين تجربتك من خلال مشاركة بعض التفاصيل",
	"Business Industry": "مجال العمل",
	"Vehicle & Cargo": "المركبات والبضائع",
	Compliance: Compliance$g,
	"Would you like to skip?": "هل ترغب في تخطي؟",
	"What is your business industry?": "ما هو مجال عمل شركتك؟",
	"Transportation & Logistics": "النقل والخدمات اللوجستية",
	"Rental & Leasing": "الإيجار والتأجير",
	"Construction & Building": "البناء والتشييد",
	"Government & Public": "الحكومة والعامة",
	"Facility & Utility Management": "إدارة المنشآت والمرافق العامة",
	Manufacturing: Manufacturing$f,
	"Retail & Wholesale": "البيع بالتجزئة والجملة",
	Emergency: Emergency$f,
	Security: Security$f,
	"How many employees do you need to manage?": "كم عدد الموظفين الذين تحتاج لإدارتهم؟",
	"How many vehicles does your company operate?": "كم عدد المركبات التي تشغلها شركتك؟",
	"Why do you use a fleet tracking service?": "لماذا تستخدم خدمة تتبع الأسطول؟",
	"Route Tracking": "تتبع الطريق",
	"Real-time Monitoring": "المراقبة في الوقت الفعلي",
	"Incident Detection & Check video": "كشف الحوادث وفحص الفيديو",
	"Behavior Monitoring & Analysis": "مراقبة السلوك والتحليل",
	"Evaluation & Management": "التقييم والإدارة",
	"Theft Prevention": "منع السرقة",
	"Monitoring & Maintenance": "المراقبة والصيانة",
	"Verification & Management": "التحقق والإدارة",
	"BlackVue App Use Only": "استخدام تطبيق BlackVue فقط",
	"Your current plan allow_": "خطتك الحالية تسمح باستخدام تطبيق BlackVue. لاستخدام مشاهد الويب، يرجى الاشتراك في خطة الأسطول (FLEETA).",
	"Learn more about the Fleet_": "تعرف أكثر على خطة الأسطول (FLEETA)",
	"Special Offer": "عرض خاص",
	"For a limited time_": "لفترة محدودة، استمتع بخصم 50% على اشتراكك في خطة الأسطول.",
	"See Discount Details": "اطلع على تفاصيل الخصم",
	"To subscribe to the Fleet_": "للاشتراك في خطة الأسطول، يرجى إلغاء اشتراكك في BlackVue داخل التطبيق أولاً لتجنب الرسوم المكررة.",
	"Skip tour": "تخطي الجولة",
	"In the cloud_": "في بيئة السحابة، يمكنك الوصول إلى تشغيل، مشاهدة مباشرة (بما في ذلك العرض المتعدد)، GPS مباشر، والتقارير، كل ذلك من خلال مشاهد ويب FLEETA.",
	"Cloud Storage is_": "التخزين السحابي هو المكان الذي يتم فيه تخزين مقاطع الفيديو التي قمت بتحميلها بأمان في السحاب. قم بتحميل مقاطع الفيديو الخاصة بك للحفاظ عليها آمنة لفترة طويلة.",
	"Toggle to switch_": "تبديل للتحويل بين الخريطة / القائمة",
	"In List View_": "في طريقة عرض القائمة، يمكنك بسهولة عرض وإدارة المجموعات والأعضاء ومعلومات البرنامج الثابت دفعة واحدة.",
	"What is Cloud Storage?": "ما هو التخزين السحابي؟",
	"Cloud Storage Overview": "نظرة عامة على التخزين السحابي",
	"Difference Between FLEETA_": "الفرق بين FLEETA درايف وتحميل الحدث المباشر",
	"FLEETA Drive stores_": "FLEETA درايف يخزن الفيديوهات التي قمت بتحميلها يدويًا",
	"Live Event Upload automatically_": "تحميل الحدث المباشر يخزن الفيديوهات تلقائيًا عند وقوع حدث.",
	"Live Event Upload videos_": "تحميل الحدث المباشر للفيديوهات له فترة انتهاء. إذا كنت ترغب في الاحتفاظ بها لفترة طويلة، انقلها إلى FLEETA درايف.",
	"Note: SD Card_": "ملاحظة: فيديوهات بطاقة SD في تشغيل",
	"Videos stored on_": "يمكن الوصول إلى الفيديوهات المخزنة على بطاقة SD الخاصة بك من خلال قائمة تشغيل.",
	"Set your image_": "قم بضبط صورتك باستخدام الإطار المقدم. بمجرد حفظ الصورة، سيتم عرضها في بطاقة الكاميرا وأيقونة عرض الخريطة.",
	"*Only jpg and_": "*يتم دعم ملفات jpg و png فقط.",
	"Set as default image": "تعيين كصورة افتراضية",
	"Camera Details": "تفاصيل الكاميرا",
	"IT & Telecommunications": "تكنولوجيا المعلومات والاتصالات",
	"The name must_32": "يجب أن يتراوح طول الاسم بين 1 و32 حرفًا.",
	"Unable to display the map.": "لا يمكن عرض الخريطة.",
	"The camera location cannot be found_": "لا يمكن العثور على موقع الكاميرا بسبب ضعف اتصال GPS.",
	"Cloud Cameras": "كاميرات السحاب",
	"Want to unlock_": "هل تريد فتح ميزات إدارة الأسطول؟",
	"*Web subscription only": "*الاشتراك عبر الويب فقط",
	"Uploads event_": "يقوم بتحميل لقطات الحدث إلى التخزين السحابي فور وقوع الحدث.",
	"Starts a conversation_": "يبدأ محادثة مع السائق باستخدام مكبر الصوت والميكروفون في كاميرا الطبلون.",
	"Remotely check_": "تحقق من مستوى البطارية وحالتها عن بعد عبر السحاب.",
	"Receive a voice_": "تلقي تنبيه صوتي وإشعارات إذا تجاوز وقت القيادة الحد.",
	"View your_": "اعرض سجل القيادة الخاص بك على الخريطة.",
	"View speed, event_": "شاهد السرعة ونوع الحدث وشغّل الفيديوهات ذات الصلة مباشرةً على الخريطة.",
	"FLEETA Tracking exclusive_": "يقدم FLEETA Tracking ميزات حصرية لكل من المستخدمين المتقدمين والأعمال (مستخدمون وكاميرات متعددة، التسييج الجغرافي، إلخ).",
	"Cloud Cameras per Account": "كاميرات السحاب لكل حساب",
	"Connect Dashcam Locally_": "توصيل كاميرا السيارة محليًا (Wi-Fi) (تشغيل, تنزيل, مشاهدة مباشرة)",
	"Available with_": "متوفر مع بطارية BlackVue",
	"Cloud Battery": "بطارية السحابة",
	"Driving Reports": "تقارير القيادة",
	"Video on Map": "فيديو على الخريطة",
	"Multi Live View (Fleeta Web Viewer)": "عرض مباشر متعدد (مشاهد ويب FLEETA)",
	"Enter a number": "أدخل رقمًا",
	"Permission required.": "مطلوب إذن.",
	"Please contact_": "يرجى الاتصال بالمالك للحصول على المساعدة.",
	"Access not available": "الوصول غير متاح.",
	"This file cannot be deleted now.": "لا يمكن حذف هذا الملف الآن.",
	"Please try again later.": "يرجى المحاولة مرة أخرى لاحقًا.",
	"Permission required.\nPlease_": "مطلوب إذن.\nيرجى الاتصال بالمالك للحصول على المساعدة.",
	"Cloud Storage is disconnected_": "التخزين السحابي مقطوع. الرجاء التحقق من الاتصال.",
	"Manage the plan_": "إدارة الخطة لاستعادة الكاميرا",
	"Notify the owner_": "أخطر المالك لإدارة الخطة",
	"Access Restricted:_": "الوصول مقيد: انتهاء الاشتراك",
	"Access is currently_": "الوصول غير متاح حاليًا بسبب انتهاء الاشتراك.",
	"Please contact your owner_": "يرجى الاتصال بالمالك لحل هذه المشكلة.",
	"Access will be_": "سيتم استعادة الوصول بمجرد تجديد الاشتراك",
	"Cloud is disconnected_": "التخزين السحابي مفصول. \nيرجى التحقق من الاتصال.",
	"Connect to Cloud with_": "اتصل بـ التخزين السحابي باستخدام FLEETA APP",
	"Using Wi-Fi Hotspot": "استخدام نقطة اتصال Wi-Fi",
	Important: Important$f,
	"Pre-Event buffer_": "تم تعطيل تسجيل البافر قبل الحدث في هذا الوضع.",
	"connectivity is_": "الاتصال مقيد في هذا الوضع.",
	"video upload starts_": "يبدأ تحميل الفيديو بعد اكتمال التسجيل.",
	"Power Saving": "توفير الطاقة",
	"In all modes_": "في جميع الأوضاع، تؤدي الصدمات المكتشفة إلى تشغيل تسجيلات فيديو الحدث.",
	"Battery Protection setting _": "يجب أن يكون إعداد حماية البطارية مفعلًا.",
	"At least one of_": "يجب تفعيل واحدة على الأقل من الإعدادات التالية",
	or: or$f,
	"For BlackVue battery users": "لمستخدمي بطارية BlackVue",
	"we recommend setting_": "نوصي بضبط قطع الجهد إلى القيمة الدنيا للاستفادة القصوى من البطارية.",
	"No videos were found.": "لم يتم العثور على مقاطع فيديو.",
	"Try different filter_": "جرب فلترًا مختلفًا أو أعد تعيين الفلتر.",
	"Not avaliable with_": "غير متوفر مع الكاميرا الحالية",
	"Overlays a detection_": "يضع صندوق الكشف على اللقطات المباشرة والمسجلة لكاميرا DMS.",
	"A minute of_": "دقيقة من فيديو الكاميرا الأمامية ستكون تقريبًا",
	"System voice guidance": "إرشاد الصوت النظام",
	"Recording trigger": "مشغل التسجيل",
	"Remote Button (Optional)": "زر التحكم عن بعد (اختياري)",
	"Remote button settings_": "لا يمكن تغيير إعدادات الأزرار عن بُعد عبر الاتصال السحابي. لتعديل هذه الإعدادات، انتقل إلى الكاميرا > الاتصال المحلي > إعدادات الكاميرا.",
	"No Registered Device": "لا يوجد جهاز مسجل",
	"Subscription process is complete": "اكتمل عملية الاشتراك",
	"Now, go back to_": "الآن، عد إلى تطبيق FLEETA، سجل الدخول إلى حسابك، وابدأ في الاستمتاع بالخدمة.",
	"You can check the upload progress": "يمكنك التحقق من تقدم التحميل في التخزين السحابي > علامة تبويب FLEETA درايف.",
	"SIM card must be inserted in_": "يجب إدخال بطاقة SIM في الكاميرا لبدء استخدام السحابة.",
	"Active until:": "نشط حتى:",
	Subscribe: Subscribe$f,
	"Camera PSN": "كاميرا بي اس ان",
	"BlackVue Sim Free Trial Started!": "بدأت النسخة التجريبية المجانية لـ BlackVue Sim!",
	"Enjoy a free period to use your SIM_": "استمتع بفترة مجانية لاستخدام بطاقة SIM الخاصة بك دون اشتراك!",
	"You can stay connected during the trial_": "يمكنك البقاء على اتصال أثناء الفترة التجريبية، ولكن تذكر:",
	"Complete your subscription before the trial_": "أكمل اشتراكك قبل انتهاء الفترة التجريبية لمواصلة استخدام بطاقة SIM.",
	"If you don't subscribe by the end of the trial_": "إذا لم تقم بالاشتراك بحلول نهاية الفترة التجريبية، فسيتم إلغاء تنشيط خدمة SIM الخاصة بك.",
	"Save Event Videos_": "احفظ مقاطع فيديو الأحداث على التخزين السحابي في الوقت الفعلي!",
	"Note: Deleting your account doesn’t cancel": "ملاحظة: حذف حسابك لا يلغي اشتراكك. للإلغاء، اذهب إلى الحساب > الاشتراك في مشاهد FLEETA الويب.",
	"Available only on FLEETA App for_": "متوفر فقط على تطبيق FLEETA لهذا الطراز.",
	"The cloud is deactivated": "تم إلغاء تنشيط السحابة.",
	"Please add a camera with FLEETA_": "يرجى إضافة كاميرا مع تطبيق FLEETA لاستخدام هذه الميزة.",
	"Upload videos to FLEETA_": "قم بتحميل الفيديوهات إلى FLEETA درايف واحفظها بأمان!",
	"You have no assigned camera_": "ليس لديك كاميرا معينة.\nيرجى الاتصال بالمالك لطلب التعيين.",
	"Camera notification settings": "إعدادات إشعارات الكاميرا",
	Vehicle: Vehicle$f,
	"App Download": "تحميل التطبيق",
	"Have a problem with_": "هل تواجه مشكلة مع الاشتراك؟",
	"Restore Purchase": "استعادة الشراء",
	"Battery Pairing": "اقتران البطارية",
	"Playback\nLive View": "التشغيل/\nالعرض المباشر",
	"Remote Playback": "التشغيل عن بعد",
	"Cloud connection settings": "إعدادات الاتصال بالسحابة",
	"Go to settings": "انتقل إلى الإعدادات",
	"Only cloud cameras that_": "تُعرض على الخريطة فقط الداش كام السحابية التي وافق أصحابها على مشاركتها علنًا، بينما تظل الداش كام الخاصة غير مرئية حفاظًا على خصوصية المستخدمين.",
	"Live Broadcast Cameras": "كاميرات البث المباشر",
	"*Live Broadcast Cameras_": "*كاميرات البث المباشر هي كاميرات سحابية تم ضبطها للبث بواسطة المستخدمين.",
	"Only cloud cameras_": "فقط كاميرات السحابة التي يختار المستخدمون بثها تظهر على الخريطة."
};

var Dashboard$f = "Dashboard";
var Account$f = "Konto";
var Help$f = "Hilfe";
var Mac$f = "Mac";
var Windows$f = "Windows";
var Admin$f = "Administrator";
var Driver$f = "Fahrer";
var Cameras$f = "Kameras";
var Manage$f = "Verwalten";
var Clear$f = "klar";
var Show$f = "Show";
var GB$f = "{{a}}GB";
var _section$f = "verwalten.";
var Name$f = "Name";
var Password$f = "Passwort";
var Cancel$f = "Abbrechen";
var Members$f = "Mitglieder";
var Groups$f = "Gruppen";
var Role$f = "Rolle";
var Group$f = "Gruppe";
var Status$f = "Status";
var nPM$f = "{{a}} Nachmittag";
var nAM$f = "{{a}} Vormittag";
var Newest$f = "Neueste";
var Oldest$f = "Älteste";
var Accepted$f = "Akzeptiert";
var Pending$f = "Ausstehend";
var Expired$f = "Abgelaufen";
var All$f = "Alle";
var Delete_$f = "{{a}} löschen";
var Delete$f = "Löschen";
var Rename$f = "Name ändern";
var Add$f = "Zufügen";
var OK$f = "OK";
var Remove$f = "Entfernen";
var Files$f = "Dateien";
var Features$f = "Funktionen";
var Settings$f = "Einstellungen";
var Upload$f = "Hochladen";
var Privacy$f = "Datenschutz";
var Done$f = "Fertig";
var Subscription$f = "Abonnement";
var Submasters$f = "Administratoren";
var Users$f = "Fahrer";
var Change$f = "Ändern";
var Method$f = "Methode";
var Details$f = "Kamera-Info";
var Confirm$f = "Bestätigen";
var Address$f = "Adresse";
var Country$f = "Land";
var State$f = "Staat";
var ZIP$f = "PLZ";
var Pricing$f = "Preis";
var Free$f = "Free";
var Smart$f = "Smart";
var Fleet$f = "Fleet";
var Subscrubed$f = "Abonniert";
var January$f = "Januar";
var February$f = "Februar";
var March$f = "März";
var April$f = "April";
var May$f = "Kann";
var June$f = "Juni";
var July$f = "Juli";
var August$f = "August";
var September$f = "September";
var October$f = "Oktober";
var November$f = "November";
var December$f = "Dezember";
var Blackvuecloud_$f = "www.blackvuecloud.com";
var Support$f = "Support";
var Community$f = "Community";
var FAQ$f = "FAQ";
var Developers$f = "Developers";
var Facebook$f = "Facebook";
var Twitter$f = "Twitter";
var Instagram$f = "Instagram";
var Youtube$f = "Youtube";
var Linkedin$f = "Linkedin";
var Downloads$f = "Downloads";
var Unauthorized$f = "Nicht autorisiert";
var none$f = "None";
var Email$f = "E-Mail";
var Customers$f = "Customers";
var Home$f = "Home";
var Plan$f = "Plan";
var New$f = "New";
var Unsubscribed$f = "Unsubscribed";
var Edit$f = "Edit";
var month$f = "month";
var months$f = "months";
var Continue$f = "Continue";
var Back$f = "Zurück";
var Master$f = "Owner";
var Develop$f = "Developers";
var $9$f = "$9";
var $15$f = "$15";
var $10$f = "$10";
var mo$f = "Monat";
var City$f = "Stadt";
var Charge$f = "Belasten";
var subscribe$f = "Abonnieren";
var search$f = "Suchen";
var invalid_number$f = "Die Kartennummer ist keine gültige Kreditkartennummer";
var invalid_expiry_month$f = "Der Ablaufmonat der Karte ist ungültig";
var invalid_expiry_year$f = "Das Ablaufjahr der Karte ist ungültig";
var invalid_cvc$f = "Der Sicherheitscode der Karte ist ungültig";
var incorrect_number$f = "Die Kartennummer ist falsch";
var incomplete_number$f = "Die Kartennummer ist unvollständig";
var incomplete_cvc$f = "Der Sicherheitscode der Karte ist unvollständig";
var incomplete_expiry$f = "Das Ablaufdatum der Karte ist unvollständig";
var expired_card$f = "Die Karte ist abgelaufen";
var incorrect_cvc$f = "Der Sicherheitscode der Karte ist falsch";
var incorrect_zip$f = "Die Postleitzahl der Karte konnte nicht bestätigt werden";
var invalid_expiry_year_past$f = "Das Ablaufjahr der Karte liegt in der Vergangenheit";
var card_declined$f = "Die Karte wurde abgelehnt";
var missing$f = "Bei einem Kunden gibt es keine zu belastende Karte";
var processing_error$f = "Bei der Verarbeitung der Karte ist ein Fehler aufgetreten";
var Paypal$f = "Paypal";
var iOS$f = "iOS";
var Android$f = "Android";
var Total$f = "Gesamt";
var And$f = "und";
var Camera$f = "Camera";
var Yes$f = "OK";
var No$f = "Nein";
var News$f = "News";
var Notifications$f = "Benachrichtigungen";
var MPH$f = "MPH";
var Firmware$f = "Firmware";
var Basic$f = "Grundeinst.";
var Resolution$f = "Auflösung";
var Brightness$f = "Helligkeit";
var Recording$f = "Aufzeichnung";
var Highest$f = "Höchste";
var High$f = "Hoch";
var Normal$f = "Normal";
var Sensitivity$f = "Empfindlichkeit";
var Volume$f = "Lautstärke";
var Close$f = "Close";
var Cloud$f = "Cloud";
var Public$f = "Public";
var Front$f = "Vorn";
var Rear$f = "Hinten";
var Play$f = "Abspielen";
var Stop$f = "Stopp";
var Pause$f = "Pause";
var Time$f = "Time";
var System$f = "System";
var Event$f = "Ereignis";
var Parking$f = "Parkplatz";
var Color$f = "Farbe";
var Exit$f = "Beenden";
var Save$f = "Speichern";
var Impact$f = "Aufprall";
var Unlimited$f = "Unbegrenzt";
var Default$f = "Standard";
var Version$f = "Version";
var Language$f = "Sprache";
var Notification$f = "Benachrichtigung";
var Multiple$f = "Multi";
var Range$f = "Bereich";
var Download$f = "Herunterladen";
var Manual$f = "Handbuch";
var Satellite$f = "Satellit";
var Tutorials$f = "Anleitungen";
var Filter$f = "Filtern";
var Sun$f = "So";
var Mon$f = "Mo";
var Tue$f = "Di";
var Wed$f = "Mi";
var Thu$f = "Do";
var Fri$f = "Fr";
var Sat$f = "Sa";
var Dates$f = "Daten";
var Routes$f = "Routen";
var Opacity$f = "Transparenz";
var Entry$f = "Eintrag";
var Owner$f = "Owner";
var Undetected$f = "unentdeckt";
var Distracted$f = "Abgelenkt";
var Drowsy$f = "Drowsy";
var Calling$f = "Calling";
var Smoking$f = "Smoking";
var Permissions$f = "Berechtigungen";
var Private$f = "Privat";
var Entering$f = "Einfahrt";
var Exiting$f = "Ausfahrt";
var Acceleration$f = "Beschleunigung";
var Passing$f = "Passieren";
var Overspeed$f = "Überhöhte Geschwindigkeit";
var Recipients$f = "Empfänger";
var Send$f = "Senden";
var Note$f = "Hinweis";
var Video$f = "Video";
var Advanced$f = "Erweitert";
var Voice$f = "Sprache";
var Days_$f = "Tage";
var Mute$f = "Audio aus";
var UnMute$f = "Audio ein";
var Discard$f = "Verwerfen";
var Report$f = "Report";
var Individual$f = "Möchten Sie als Einzelfahrer auf Nummer sicher gehen? Benötigen Sie als Unternehmensinhaber eine einfache Lösung für die Fahrzeugsicherheit und -verfolgung?";
var Subscribed$f = "Abonniert";
var Geofence$f = "Geozaun";
var Driving$f = "Fahr-";
var Idling$f = "Stillstand";
var Distance$f = "strecke";
var Parked$f = "Parked";
var Speed$f = "Geschwindigkeit";
var Highest_2$f = "Höchste";
var Average$f = "Durchschnitt";
var Geofences$f = "Geozäune";
var Move$f = "Verschieben";
var Connected$f = "Verbunden";
var Individual_$f = "Einzelperson";
var Always$f = "Immer";
var Low$f = "Niedrig";
var Medium$f = "Mittel";
var High_2$f = "Hoch";
var Flip$f = "Ausklappen";
var Previous$f = "Voriges Bild";
var Next$f = "Weiter";
var Expand$f = "Erweitern";
var Collapse$f = "Einklappen";
var More$f = "Mehr";
var Multi$f = "Multi";
var Safe$f = "Sicher";
var Reckless$f = "Rücksichtslos";
var Inattentive$f = "Unaufmerksam";
var List$f = "Liste";
var Usage$f = "Verwendung";
var Profile$f = "Profil";
var Fullscreen$f = "Vollbild";
var Upgrade$f = "Aktualisieren";
var Management$f = "Verwaltung";
var Day$f = "Tag";
var Month$f = "Monat";
var Later$f = "Später";
var ICCID$f = "ICCID";
var Resubscribe$f = "Neu abonnieren";
var plan$f = "Plan";
var USD$f = "USD";
var etc_$f = "usw.:";
var Available$f = "Verfügbar";
var Used$f = "Genutzt";
var Cancelled$f = "Abgebrochen";
var Terminated$f = "Gekündigt";
var Sort$f = "Sortieren";
var Bonus$f = "Bonus";
var incomplete_zip$f = "Die Postleitzahl der Karte konnte nicht bestätigt werden";
var Upgrades$f = "Aktualisierung";
var OR$f = "ODER";
var Undo$f = "Stornieren";
var Invoice$f = "Rechnung";
var data$f = "Daten";
var Popular$f = "Popular";
var Mask$f = "Ohne Maske";
var DMS$f = "Überwachung des Fahrerstatus (DMS)";
var Extreme$f = "Extrem";
var OFF$f = "Aus";
var Threshold$f = "Schwellenwert";
var Drowsiness$f = "Müdigkeit";
var Direct$f = "Direkt";
var Remote$f = "Remote";
var Update$f = "Update";
var Option$f = "Option";
var Required$f = "Erforderlich";
var Optional$f = "Optional";
var Others$f = "Sonstiges";
var Stay$f = "Anwesend";
var Mask_2$f = "Mask";
var Low_2$f = "Low";
var Medium_2$f = "Medium";
var High_3$f = "High";
var Highest_3$f = "Highest";
var Extreme_2$f = "Extreme";
var Private_2$f = "Private";
var Lite$f = "Lite";
var Bitrate$f = "Bitrate";
var hours$f = "Stunden";
var Expires$f = "Läuft ab";
var Check$f = "Überprüfen";
var Saving$f = "Speichern";
var Now$f = "Jetzt";
var Beep$f = "Warnsignal";
var Unpair$f = "Trennen";
var Detected$f = "Erkannt";
var Promotion$f = "Werbung";
var Notice$f = "Updates";
var Explore$f = "Erkunden";
var Deactivate$e = "Deaktivieren";
var Compliance$f = "Compliance";
var Manufacturing$e = "Fertigung";
var Emergency$e = "Notfall";
var Security$e = "Sicherheit";
var Important$e = "Wichtig";
var or$e = "oder";
var Subscribe$e = "Abonnieren";
var Vehicle$e = "Fahrzeug";
var de = {
	Dashboard: Dashboard$f,
	"Payment & Subscriptions": "Bezahlung und Abonnements",
	"Fleet Management": "Flottenmanagement",
	"Available to master": "Für Master verfügbar",
	"Available to Fleet_": "Für Benutzer mit Flottentarifplan verfügbar",
	Account: Account$f,
	"Log out": "Abmelden",
	"© 2019 Pittasoft_": "© 2019 Pittasoft Co. Ltd",
	"Privacy policy": "Datenschutzbedingungen",
	"Terms of service": "Nutzungsbedingungen",
	Help: Help$f,
	"App store": "App store",
	"Google Play": "Google Play",
	Mac: Mac$f,
	Windows: Windows$f,
	"Free Plan": "Free Plan",
	"Basic Plan": "Basic Plan",
	"Smart Plan": "Smart Plan",
	Admin: Admin$f,
	Driver: Driver$f,
	"Period : December 3, 2024 ~ May 31, 2025": "Zeitraum: 3. Dezember 2024 bis 31. Mai 2025",
	Cameras: Cameras$f,
	"n of n": "{{a}} von {{b}}",
	Manage: Manage$f,
	"Upgrade Plan": "Aktualisierungszeitplan",
	"Add more cameras_": "Weitere Kameras hinzufügen, Flotte verwalten und mehr …",
	"Usage statistics": "Nutzungsstatistik",
	"All cameras": "Alle Kameras",
	Clear: Clear$f,
	Show: Show$f,
	"Live views": "Remote-Live-Ansicht",
	"nh:nm:ns": "{{a}}h:{{b}}m:{{c}}s",
	"Video plays and_": "Video wird abgespielt und heruntergeladen",
	"Space available": "Verfügbare Kapazität",
	GB: GB$f,
	"n%": "{{a}}%",
	"BlackVue app for_": "BlackVue App für iOS und Android",
	"BlackVue viewer for_": "BlackVue Viewer für Mac und Windows",
	"Welcome to fleet": "Willkommen bei der Flotte",
	"A few things_": "Einige Besonderheiten die Sie unterwegs erwarten können:",
	"You can watch_": "Sie können Videos von Kameras ansehen, denen Sie in der BlackVue App oder im Desktop-Viewer zugeordnet sind.",
	"If the master_deletes": "Wenn das Master-Konto gelöscht wird, wird auch Ihr Konto gelöscht.",
	"If the masters_Fleet": "Wenn das Master-Flottentarif-Abonnement ausläuft, können Sie weiterhin im Lese-Modus auf Ihr Konto zugreifen.",
	"You have to_": "Sie müssen ein anderes Konto registrieren, um eine persönliche Kamera hinzuzufügen.",
	"The Payments &_": "Die Abschnitte Zahlungen und Abonnements sowie Flottenmanagement sind nur für den Master verfügbar.",
	"You can manage_": "Sie können Ihre Flottengruppe im Abschnitt",
	"_Fleet management": "Flottenmanagement",
	_section: _section$f,
	"The Payments_section-": "Der Abschnitt Zahlungen und Abonnements ist nur für den Master verfügbar.",
	"Youre almost there": "Sie haben es fast geschafft",
	"Finish account setup": "Kontoeinrichtung abschließen",
	"Install and log_": "BlackVue App oder Desktop Viewer installieren und daran anmelden",
	"Download on the_": "Vom App Store herunterladen",
	"GET IT ON_": "ÜBER Google Play BESCHAFFEN",
	"Download for Mac": "Für Mac herunterladen",
	"Download for Windows": "Für Windows herunterladen",
	"Add your camera_": "Fügen Sie Ihre Kamera in der BlackVue App oder im Desktop Viewer hinzu",
	"Start managing your_": "Beginnen Sie hier mit der Verwaltung Ihrer Flotte und der Verfolgung der Nutzungsstatistiken",
	"Cancelled Fleet Plan_": "Flottentarifplan annulliert am {{date}}",
	"The new plan_": "Der neue Tarifplan tritt am Ende Ihrer aktuellen Abrechnungsperiode in Kraft.",
	"Profile photo": "Profilfoto",
	Name: Name$f,
	"E-mail address": "E-Mail-Adresse",
	Password: Password$f,
	"Last changed_": "Letzte Änderung {{a}}",
	"Change password": "Passwort ändern",
	"Delete account": "Konto löschen",
	Cancel: Cancel$f,
	"Current password": "Bisheriges Passwort",
	"New password": "Neues Passwort",
	"Confirm new password": "Neues Passwort bestätigen",
	"Password changed": "Passwort geändert.",
	"Reason for deletion_": "Grund für die Löschung (optional)",
	"Account password": "Kontopasswort",
	Members: Members$f,
	Groups: Groups$f,
	"+ Invite member": "+ Mitglied einladen",
	"Name, Email": "Name, E-Mail-Adresse",
	Role: Role$f,
	Group: Group$f,
	"Date invited": "Datum der Einladung",
	Status: Status$f,
	"Group n": "Gruppe {{a}}",
	nPM: nPM$f,
	nAM: nAM$f,
	Newest: Newest$f,
	Oldest: Oldest$f,
	"Name, email or_": "Name, E-Mail-Adresse oder Gruppe",
	Accepted: Accepted$f,
	Pending: Pending$f,
	Expired: Expired$f,
	All: All$f,
	"No results": "Keine Ergebnisse",
	"Try different keywords": "Versuchen Sie es mit anderen Stichwörtern",
	"Try changing or_": "Versuchen Sie, Filter zu ändern oder zu entfernen",
	"Remove all filters": "Alle Filter entfernen",
	"Invite member": "Mitglied einladen",
	"Send invite": "Einladung senden",
	"You have reached_": "Sie haben die Obergrenze von 10 Submastern erreicht. Sie können weiterhin Benutzer einladen.",
	Delete_: Delete_$f,
	"Are you sure_delete": "Möchten Sie dieses Mitglied und sein Konto wirklich löschen?",
	Delete: Delete$f,
	Rename: Rename$f,
	"No submaster yet": "Noch kein Submaster",
	"You can add_": "Sie können 1 Submaster pro Gruppe hinzufügen",
	"No cameras yet": "Noch keine Kameras",
	"Add cameras first_": "Zuerst Kameras hinzufügen, danach Benutzer zuweisen",
	"Name or email": "Name oder E-Mail-Adresse",
	"Add submaster": "Submaster hinzufügen",
	Add: Add$f,
	"Add camera": "Kamera hinzufügen",
	"n of n selected": "{{a}} von {{b}} ausgewählt",
	"No cameras available": "Keine Kameras verfügbar",
	"Most likely reasons_": "Wahrscheinliche Gründe dafür:",
	"All cameras were_": "Alle Kameras wurden anderen Gruppen hinzugefügt.",
	"You can remove_": "Sie können Kameras aus anderen Gruppen entfernen und dieser Gruppe hinzufügen.",
	"No cameras were_": "Ihrem Konto wurden keine Kameras hinzugefügt.",
	"You can add_cameras": "Sie können Kameras in der BlackVue App oder im Desktop Viewer hinzufügen.",
	OK: OK$f,
	"Rename group": "Gruppe umbenennen",
	"Are you sure_group": "Möchten Sie diese Gruppe wirklich löschen?",
	"Edit Mobile app_": "Berechtigungen für Mobilapp/Desktop Viewer bearbeiten",
	Remove: Remove$f,
	"n of n users": "{{a} von {{b}} Benutzern",
	"Youve reached the_": "Sie haben das Benutzerlimit pro Kamera erreicht",
	"Remove user": "Benutzer entfernen",
	"Add user": "Benutzer hinzufügen",
	"+ Add group": "+ Gruppe hinzufügen",
	"Add group": "Gruppe hinzufügen",
	"Group or submaster": "Gruppe oder Submaster",
	"+ Add": "+ Hinzufügen",
	"of max selected": "{{a}} von max. {{b}} ausgewählt",
	"Mobile app/desktop_": "Berechtigungen für Mobilapp/Desktop Viewer",
	Files: Files$f,
	Features: Features$f,
	Settings: Settings$f,
	Upload: Upload$f,
	"Download and Playback_Cloud": "Vom Cloudspeicher herunterladen und wiedergeben",
	"Download and Playback_SD": "Von SD-Karte herunterladen und wiedergeben",
	"Live view": "Live View",
	"Geo Fencing": "Geofencing",
	"Drive Reports": "Fahrberichte",
	"Firmware Settings": "Firmware-Einstellungen",
	"Push Notifications": "Push-Benachrichtigungen",
	"Event Auto Upload": "Echtzeit-Auto-Upload bei Ereignis",
	Privacy: Privacy$f,
	Done: Done$f,
	"Payment method": "Zahlungsweise",
	"Change payment method": "Zahlungsweise ändern",
	Subscription: Subscription$f,
	"Space used": "Belegter Speicherplatz",
	"Next billing_": "Nächste Rechnung {{a}} {{b}}",
	"You manage_available": "Sie verwalten {{a} von {{b}} in Ihrem verfügbaren Tarifplan.",
	Submasters: Submasters$f,
	Users: Users$f,
	Change: Change$f,
	"No transactions yet_": "Sie haben den kostenlosen Tarifplan abonniert. Noch keine Transaktionen",
	"No transactions to_": "Keine Transaktionen zur Anzeige vorhanden.<br/>Wenn Sie die Transaktionshistorie für andere Plattformen (z. B. iOS, Android, PayPal) suchen, können Sie sie auf der Abonnementsseite Ihrer eigenen Plattform finden.",
	"of nGB_": "{{a}} von {{b}} GB ({{c}} %)",
	"Smart Plan users_": "Smart-Tarif-Benutzer können den Abonnement-Tarif oder die Anzahl der Kameras über die BlackVue-Mobilapp ändern",
	"Transaction history": "Transaktionsverlauf",
	"Date": "Datum",
	"Amount, USD": "Betrag, USD",
	Method: Method$f,
	Details: Details$f,
	"iOS in-app_": "iOS in-app purchase/Android in-app purchase",
	"Change the number_": "Anzahl von Kameras ändern",
	"You manage_cameras": "You manage {{a}} cameras of {{b}} available on your plan",
	"Extra cameras": "Zusätzliche Kameras",
	"Total due_": "Fälliger Gesamtbetrag",
	"available on your_": "von {{a}} in Ihrem Tarif verfügbaren",
	"Cancel Fleet Plan": "Abbrechen Fleet Plan",
	"This will cancel_": "Hierdurch wird Ihr Flottentarif-Abonnement gekündigt. Das Downgrade auf den kostenlosen Tarif erfolgt am Ende Ihrer Abrechnungsperiode.",
	"Reason for cancellation_": "Grund für die Kündigung (optional)",
	"Not now": "Nicht jetzt",
	Confirm: Confirm$f,
	"Cardholder name": "Name des Karteninhabers",
	"Card name": "Name der Karte",
	"MM/YY": "MM/JJ",
	Address: Address$f,
	Country: Country$f,
	State: State$f,
	ZIP: ZIP$f,
	Pricing: Pricing$f,
	"You are subscribed_": "Sie haben den kostenlosen Tarif abonniert.",
	"With Alert Push_": "Mit Push-Benachrichtigungen, eingeschränkter Remote-Live-Ansicht und Cloud-Speicherung.",
	Free: Free$f,
	Smart: Smart$f,
	Fleet: Fleet$f,
	"Get started for_": "Der Einstieg ist kostenlos, keine Kreditkarte erforderlich. \n Mit Push-Benachrichtigungen, eingeschränkter Remote-Live-Ansicht und Cloud-Speicherung.",
	Subscrubed: Subscrubed$f,
	"Features included:": "Enthaltene Funktionen:",
	"Get unlimited Remote_": "Unbegrenzte Remote-Live-Ansicht und Cloud-Wiedergabe, Verwaltung von bis zu {{a}} Kameras.",
	"BlackVue Fleet Tracking_": "BlackVue-Flottenverfolgung bietet exklusive Funktionen für Power-User und Unternehmen (mehrere Benutzer und Kameras, Geofencing usw.)",
	"Try 1 Month Free": "1 Monat kostenlos testen",
	"Log in": "Anmelden",
	"Remember me": "Erinnern Sie sich an mich",
	"Forgot password?": "Passwort vergessen?",
	"Reset password": "Passwort zurücksetzen",
	"Enter email address_": "Geben Sie die bei der Registrierung verwendete E-Mail-Adresse ein und \n wir senden Ihnen einen Link zum Zurücksetzen Ihres Passworts.",
	"Send reset password_": "E-Mail zum Zurücksetzen des Passworts senden",
	"Back to login": "Zurück zur Anmeldung",
	"Check your email": "Sehen Sie in Ihren E-Mail-Posteingang",
	"Weve sent an_": "Wir haben eine E-Mail an {{a}} mit einem Link zur Bestätigung \n Ihrer E-Mail-Adresse gesendet.",
	"Resend email": "E-Mail erneut senden",
	January: January$f,
	February: February$f,
	March: March$f,
	April: April$f,
	May: May$f,
	June: June$f,
	July: July$f,
	August: August$f,
	September: September$f,
	October: October$f,
	November: November$f,
	December: December$f,
	"Sign up": "Konto erstellen",
	"First name": "Vorname",
	"Last name": "Nachname",
	"Create a password": "Ein Passwort erstellen",
	"5 or more_": "5 oder mehr Zeichen",
	"Sign up and_": "Registrieren und fortfahren",
	"I agree to_": "Ich akzeptiere die %@, %@, %@ und die %@.",
	"Subscribe to newsletter": "Newsletter abonnieren",
	"1 month free trial_": "1 Monat kostenlos testen",
	"Dont have an_": "Haben Sie kein Konto?",
	"Thank you for_": "Vielen Dank, dass Sie sich bei BlackVue Cloud angemeldet haben. Bestätigen Sie bitte Ihre E-Mail-Adresse.",
	"Confirm email": "E-Mail-Adresse bestätigen",
	"If you didnt_": "Wenn Sie sich nicht für dieses Konto angemeldet haben, können Sie diese E-Mail ignorieren.",
	Blackvuecloud_: Blackvuecloud_$f,
	"invited you to_": "{{a}} hat Sie eingeladen, seiner Flotte als ein Submaster beizutreten.",
	"Accept invitation": "Einladung annehmen",
	"Invite expires on_": "Die Einladung läuft am TT.MM.JJ ab.",
	"Your Fleet Management_": "Ihr mit {{a}} registriertes Flottenmanagementkonto wurde von %@ gelöscht.",
	"If you believe_": "Wenn Sie glauben, dass es sich um einen Fehler handelt, wenden Sie sich bitte an unseren Kundendienst: cs@blackvue.com.",
	Support: Support$f,
	"Help center": "Hilfecenter",
	Community: Community$f,
	"Getting started": "Los geht's",
	FAQ: FAQ$f,
	Developers: Developers$f,
	"Cloud API": "Cloud API",
	"Fleet SDK": "Fleet SDK",
	"Follow us": "Follow us",
	Facebook: Facebook$f,
	Twitter: Twitter$f,
	Instagram: Instagram$f,
	Youtube: Youtube$f,
	Linkedin: Linkedin$f,
	"BlackVue apps": "BlackVue apps",
	"Camera registraiton": "Kameraregistrierung",
	"Two-way voice_": "Gegensprechfunktion",
	"Live GPS": "Live-GPS",
	"Event live auto_": "Echtzeit-Auto-Upload bei Ereignis",
	"Event file auto_": "Auto-Upload Ereignisdatei",
	"Compatible with_": "Mit den Modellen DR650GW, DR650S kompatibel",
	"Not compatible with_": "Nicht mit den Modellen DR650GW, DR650S kompatibel",
	"More cameras": "Mehr Kameras",
	"More users": "More users",
	"Roles and permissions": "Roles and permissions",
	"More Cloud Storage": "Mehr Cloud-Speicher",
	"Multi Live view_": "Multi Live View (Web)",
	"Longer GPS Tracking": "Longer GPS Tracking",
	"Geo Fence setup_": "Geo Fence setup (PC viewer) and alerts (PC viewer and app)",
	"Changes saved": "Änderungen gespeichert",
	"Group added": "Gruppe hinzugefügt",
	"Member added": "Mitglied hinzugefügt",
	"Group deleted": "Gruppe gelöscht",
	"Member deleted": "Mitglied gelöscht",
	"Group renamed": "Gruppe umbenannt",
	"Submaster added": "Submaster hinzugefügt",
	"Camera added": "Kamera hinzugefügt",
	"User added": "Benutzer hinzugefügt",
	"Users added": "Benutzer hinzugefügt",
	Downloads: Downloads$f,
	"The BlackVue App_": "The BlackVue App and Viewer let you use your BlackVue camera to its full potential. Whether on mobile or on home computer, BlackVue gives you the tools to fully enjoy your dashcam's functions.",
	"Compatible with all_": "Compatible with all Wi-Fi enabled BlackVue models.",
	"Supports all BlackVue_": "Supports all BlackVue models to date.",
	"confirm new password": "Neues Passwort bestätigen",
	"Your password is_": "Das eingegebene Passwort ist falsch",
	"Confirm password does_": "Passwort falsch",
	"Please enter_email": "Geben Sie eine gültige E-Mail-Adresse ein.",
	"Please enter_password": "Das eingegebene Passwort ist falsch",
	"Internal server error_": "Interner Serverfehler. Bitte versuchen Sie es erneut.",
	"New password is_": "Sie müssen mindestens 1 Zeichen Ihres aktuellen Passwortes ändern",
	"It should be_": "Das Passwort muss aus mindestens 5 Zeichen bestehen",
	"Invalid permission": "Ungültige Berechtigung.",
	"Input data isnt_": "Keine Eingabedaten verfügbar.",
	Unauthorized: Unauthorized$f,
	"Already have subsciption": "Sie haben bereits ein Abonnement",
	"Already uses": "Verwendet bereits",
	"Already logged in": "Bereits angemeldet",
	"Already sent e-mail": "E-Mail bereits versendet.",
	"Please wait": "Bitte warten Sie.",
	"E-mail is not_": "E-Mail-Adresse noch nicht bestätigt.",
	"Update your subscription_": "Aktualisieren Sie Ihr Abonnement",
	"Account was deleted": "Konto gelöscht.",
	"5 ~ 30_": "5 ~ 30 characters",
	"It has exceeded_": "Die Höchstzahl von 9 Administratoren ist überschritten.",
	"Billing information": "Rechnungsinformationen",
	"Please enter cardName": "Geben Sie einen Kartennamen ein",
	"Please enter_card": "Geben Sie eine gültige Kartennummer ein",
	"Please enter address": "Geben Sie eine Adresse ein",
	"Please select country": "Land auswählen",
	"Please enter city": "Geben Sie die Stadt ein",
	none: none$f,
	"Due today": "Heute fällig",
	"Today after 1_": "Heute nach 1-monatigem Test",
	"An error occurred_": "Beim Versuch, das Passwort zu ändern, ist ein Fehler aufgetreten. Versuchen Sie es erneut.",
	"Your account is_": "Ihr Konto ist jetzt aktiv.",
	"You can now_": "Sie können sich jetzt mit der E-Mail-Adresse bei Ihrem Konto anmelden, die Sie bei der Registrierung verwendet haben.",
	Email: Email$f,
	"Don’t have an account?": "Haben Sie kein Konto?",
	"Already have an account?": "Haben Sie bereits ein Konto?",
	"Cloud service": "Cloud service",
	"for your BlackVue": "for your BlackVue",
	"See what your_": "See what your camera sees remotely.",
	"Receive impact alert_": "Receive Impact alert push notifications.",
	"Save footage to_": "Save footage to the cloud and do much more...",
	"Free plan included_": "Free plan included · Easy setup · Cancel anytime",
	"Taking advantage of_": "Taking advantage of a mobile or car-embedded Internet connection and a BlackVue camera, BlackVue Cloud connects you to your car from anywhere, anytime. Using the BlackVue App on your smartphone or tablet, you see in real time where your car is located and what is happening around it.",
	"Get notifications to_": "Get notifications to your phone when your parked car is hit. Check remotely what is happening around your car.",
	"Monitor your commercial_": "Monitor your commercial vehicles on a map in real time. Talk to your drivers anytime through the BlackVue App or Viewer.",
	"With BlackVue Fleet_": "With BlackVue Fleet Tracking, track in real time up to 100 vehicles from the palm of your hand or with the dedicated BlackVue Viewer.",
	"Get started now_": "Get started now with a Free plan. For unlimited video playback or Remote Live View, upgrade to Lite or Smart plan from the BlackVue App. <br/>Business and power users can unlock the power of the Fleet plan exclusively through this website.",
	"Remote Video Playback_": "Remote Video Playback and Download",
	"Compatible with DR650GW_": "Compatible with DR650GW, DR650S models",
	"Unlimited remote video_": "Unlimited remote video playback and download",
	"Longer cloud storage_": "Longer cloud storage file expiration period",
	"Longer storage period_live": "Longer storage period for Event live auto upload",
	"Longer storage period_file": "Longer storage period for Event file auto upload",
	"Goefence setup (PC_": "Geo-fence setup (PC viewer) and alerts (Windows viewer and app)",
	"App Store": "App Store",
	"Send reset password email": "E-Mail zum Zurücksetzen des Passworts senden",
	Customers: Customers$f,
	Home: Home$f,
	"Pick a plan": "Pick a plan",
	"No customers yet": "No customers yet",
	"Customers will_": "Customers will show up here as they become available",
	"Add customer": "Add customer",
	"Report(PDF)": "Report(PDF)",
	"Subscription Period": "Subscription Period",
	Plan: Plan$f,
	New: New$f,
	Unsubscribed: Unsubscribed$f,
	"Subscription ends soon": "Subscription ends soon",
	Edit: Edit$f,
	"1 month trial": "1 month trial",
	"Edit customer details": "Edit customer details",
	"Customer name": "Customer name",
	"of 999 available_": "of 999 available on Fleet Plan",
	"Subscription starts": "Subscription starts",
	"Subscription period": "Subscription period",
	month: month$f,
	months: months$f,
	"Cloud storage": "Cloud Storage",
	"Subscription plan": "Abonnementtyp",
	"Check email address": "Check email address",
	"Add customer details": "Add customer details",
	Continue: Continue$f,
	Back: Back$f,
	"An error occured": "An error occured",
	"Customer added": "Customer added",
	"Last changed": "Last changed",
	"Company name": "Company name",
	"Company address": "Company address",
	"Alert Push Notifications": "Alert Push Notifications",
	"Receive notifications on_": "Receive notifications on your phone when preset Events occur. Great in combination with BlackVue’s Parking Mode.",
	"Remote Live View": "Remote-Live-Ansicht",
	"Remotely monitor your_": "Remotely monitor your car in real time from anywhere, anytime.",
	"Video Backup/Auto Upload": "Video Backup/Auto Upload",
	"Back up videos_": "Back up videos to your phone or Cloud storage.",
	"Two-way Voice Communication": "Two-way Voice Communication",
	"Talk with people_": "Talk with people in the car from your smartphone. The driver can speak while keeping hands on the wheel.",
	"View your car’s_": "View your car’s location and speed on a map. With BlackVue Fleet Tracking, access 90-days’ worth of GPS data.",
	"Remote Video Playback": "Remote Video Playback",
	"Play videos stored_": "Play videos stored in the Cloud or in your dashcam anytime on your smartphone or tablet.",
	"Event Live Auto Upload": "Event Live Auto Upload",
	"Save a video stream_": "Save a video stream in real time to the Cloud. Protect yourself from break-ins and theft.",
	"Event File Auto Upload": "Event File Auto Upload",
	"Save Event videos_": "Save Event videos to the Cloud—including seconds before trigger—after they happen.",
	"Firmware-Over-the-Air (FOTA)": "Firmware-Over-the-Air (FOTA)",
	"Upgrade your dashcam’s": "Update your dashcam over the cloud",
	"When an Event_": "When an Event is created (Impact detected or manually triggered), Event Live Auto-upload lets your Cloud-compatible BlackVue save a live video stream from a camera of your choice (front or rear/interior) to the Cloud server",
	"Event File Auto-upload_": "Event File Auto-upload lets your dashcam automatically upload low-resolution versions of Event files to the Cloud.",
	Master: Master$f,
	"per Camera": "per Camera",
	"Event live auto upload_": "Event live auto upload compatible with all cloud cameras",
	"Drive report": "Drive report",
	"USA/Canada Toll Free": "USA/Canada Toll Free",
	"Monday–Saturday_": "Monday to Friday 8am-7pm / Saturday 9am-6pm (PST).",
	"Please agree to_": "You must accept Terms of Service",
	"Mac or Windows PC": "Mac or Windows PC",
	Develop: Develop$f,
	"Sign out": "Sign out",
	"Referral code": "Empfehlungscode",
	"Total after 1 month trial": "Gesamt nach 1-monatigem Test",
	"Already Use Stripe Token": "Sie verwenden bereits Stripe-Token",
	"Select period": "Zeitraum auswählen",
	"State/Region": "Land/Region (optional)",
	"ZIP/Postal": "PLZ/Postleitzahl",
	"$0.00": "$0.00",
	"$11.99": "$11.99",
	"$24.99": "$24.99",
	$9: $9$f,
	$15: $15$f,
	$10: $10$f,
	"mo + for_": "/mo + {{a}} per extra camera",
	mo: mo$f,
	"This e-mail address_": "Für diese E-Mail-Adresse ist bereits ein Konto vorhanden.",
	"1 month": "1 Monat",
	"Limit is reset daily": "Limit wird täglich zurückgesetzt",
	"Limit is reset monthly": "Limit wird monatlich zurückgesetzt",
	"Video plays and downloads": "Video wird abgespielt und heruntergeladen",
	"Your master": "Your owner",
	"Youre 1 step_": "Noch 1 Schritt bis zum Abschluss Ihres Flottentarif-Abonnements",
	"Finish signing up": "Anmeldung abschließen",
	"Enter billing information": "Rechnungsinformationen eingeben",
	"Proceed to billing": "Weiter zur Rechnungsstellung",
	City: City$f,
	Charge: Charge$f,
	"User already invited_": "Benutzer bereits vom Leiter eingeladen",
	"n% consumed": "{{a}}% verwendet",
	"E-mail already exists": "E-Mail-Adresse bereits vorhanden",
	"Cancel your inapp_": "In-App-Abonnement kündigen",
	"You have cancel_": "Für ein Upgrade zum Flottentarif müssen Sie Ihr In-App-Abonnement kündigen: 1. Kündigen Sie Ihr aktuelles Abonnement im App Store oder im Google Play Store. Das Downgrade auf den kostenlosen Tarif erfolgt am Ende Ihrer aktuellen Abrechnungsperiode. Ihre Daten bleiben erhalten. 2. Melden Sie sich bei Ihrem blackvuecloud.com-Konto an und führen Sie ein Upgrade auf den Flottentarif durch.",
	"Edit permissions": "Berechtigungen bearbeiten",
	"See permissions": "Berechtigungen anzeigen",
	"Submaster removed": "Submaster entfernt",
	"Camera removed": "Kamera entfernt",
	"User removed": "Benutzer entfernt",
	"Users removed": "Benutzer entfernt",
	subscribe: subscribe$f,
	search: search$f,
	"permission can be_": "Die Berechtigung kann konfiguriert werden, nachdem der Unterleiter die Einladung angenommen hat.",
	"The confirmation link_": "Der Bestätigungslink ist nicht mehr gültig",
	"Possible reasons:_": "Mögliche Gründe: \n • Sie haben Ihre E-Mail-Adresse bereits bestätigt\n • Der Link ist abgelaufen oder wurde storniert",
	"Failed to register_": "Registrierung bei BlackVue Cloud fehlgeschlagen",
	"There was an_": "Während des Registrierungsvorgangs ist ein Fehler aufgetreten. Wenn das Problem weiterhin besteht, versuchen Sie erneut, sich bei BlackVue Cloud zu registrieren. Wenn Sie weitere Unterstützung benötigen, wenden Sie sich bitte an unseren Kundendienst:",
	"Upgrade to Fleet_": "Upgrade zum Flottentarif",
	"Subscription is Canceled": "Abonnement ist gekündigt",
	"No members yet": "Noch keine Mitglieder",
	"Please enter_group name": "Geben Sie einen gültigen Gruppennamen ein",
	"Group Name": "Name der Gruppe",
	invalid_number: invalid_number$f,
	invalid_expiry_month: invalid_expiry_month$f,
	invalid_expiry_year: invalid_expiry_year$f,
	invalid_cvc: invalid_cvc$f,
	incorrect_number: incorrect_number$f,
	incomplete_number: incomplete_number$f,
	incomplete_cvc: incomplete_cvc$f,
	incomplete_expiry: incomplete_expiry$f,
	expired_card: expired_card$f,
	incorrect_cvc: incorrect_cvc$f,
	incorrect_zip: incorrect_zip$f,
	invalid_expiry_year_past: invalid_expiry_year_past$f,
	card_declined: card_declined$f,
	missing: missing$f,
	processing_error: processing_error$f,
	"no groups yet": "Noch keine Gruppen",
	"groups will show_": "Gruppen werden hier angezeigt, sobald sie verfügbar sind",
	"Fleet members will_": "Flottenmitglieder werden hier angezeigt, sobald sie verfügbar sind",
	"service provider": "Dienstleister",
	Paypal: Paypal$f,
	iOS: iOS$f,
	Android: Android$f,
	"Enter email": "Please enter a email address",
	"Enter password": "Bitte Passwort eingeben.",
	"Enter first name": "Geben Sie den Vornamen ein",
	"Enter last name": "Geben Sie den Nachnamen ein",
	"Enter the current_": "Geben Sie das aktuelle Passwort ein",
	"Enter a new_": "Geben Sie ein neues Passwort ein",
	"There isnt an_": "Es ist kein Konto mit dieser E-Mail-Adresse verbunden",
	"Fleet Plan": "Fleet Plan",
	Total: Total$f,
	"Password you entered_": "Das eingegebene Passwort ist falsch",
	"Incorrect email or_": "E-Mail-Adresse oder Passwort falsch",
	"Available to Masters": "Für den Besitzer verfügbar",
	"Blackvue url": "https://www.blackvue.com",
	"Information We Collect_": "Daten, die wir erfassen, und die Gründe dafür",
	And: And$f,
	"Terms of Location-Based_": "Nutzungsbedingungen standortbasierter Dienst.",
	"I agree to the_": "Ich erkläre mich mit der",
	"Password Reset_": "Wir haben eine E-Mail mit Anweisungen zum Zurücksetzen \n des Passworts an {{a}} geschickt.",
	"You have already_": "Sie wurden bereits eingeladen, bitte überprüfen Sie Ihren Posteingang.",
	"No data available_": "Keine Daten in Tabelle verfügbar",
	Camera: Camera$f,
	"You no longer_": "Sie sind nicht mehr berechtigt, den Flottendienst zu nutzen.",
	"Please contact your_": "Wenden Sie sich an Ihren Flottenleiter, um das Problem zu lösen.",
	"You can still_": "Sie können weiterhin auf Ihre",
	"account information": "Kontoinformationen zugreifen.",
	"If the issue_": "Wenn das Problem nicht gelöst wird und Sie beschließen, den BlackVue Cloud-Service weiterhin mit der registrierten E-Mail-Adresse zu nutzen, müssen Sie Ihr Konto löschen und sich erneut registrieren.",
	"If the problem_": "Wenn das Problem weiterhin besteht, wenden Sie sich an unseren Kundendienst:",
	"Web subscription only": "Nur Web-Abonnement",
	"AppStore url": "https://apps.apple.com/kr",
	"We no longer_": "Wir verarbeiten keine Zahlungen über PayPal mehr. Sie müssen Ihr Abonnement aktualisieren, um die Anzahl der Kameras zu ändern: 1. Melden Sie sich bei Ihrem paypal.com-Konto an und kündigen Sie Ihr aktuelles Flottentarif-Abonnement, um die Anzahl der Kameras zu ändern: 2. Melden Sie sich bei Ihrem blackvuecloud.com-Konto an und führen Sie ein Upgrade auf den Flottentarif durch.",
	Yes: Yes$f,
	No: No$f,
	"Serial number": "Seriennummer",
	"Cloud code": "Cloud-Code",
	"Terms & Policies": "Geschäftsbedingungen",
	News: News$f,
	Notifications: Notifications$f,
	"km/h": "km/h",
	MPH: MPH$f,
	"Baidu Maps": "Baidu Maps (nur China)",
	"Google Maps": "Google Maps",
	Firmware: Firmware$f,
	Basic: Basic$f,
	"Time Zone": "Zeitzone",
	Resolution: Resolution$f,
	"Image quality": "Bildqualität",
	Brightness: Brightness$f,
	Recording: Recording$f,
	"Normal recording": "Normale Aufzeichnung",
	"Voice recording": "Sprachaufzeichnung",
	"Video segment length": "Videoabschnittslänge",
	"Rear camera recording": "Rückseitige Kamera nimmt auf",
	Highest: Highest$f,
	High: High$f,
	Normal: Normal$f,
	"1 min": "1 Minute",
	"2 min": "2 Minute",
	"3 min": "3 Minute",
	Sensitivity: Sensitivity$f,
	"Motion detection": "Bewegungserkennung",
	"Speed alert": "Geschwindigkeitsalarm",
	"Voice guidance": "Sprachanweisungen",
	"Power on": "Einschalten",
	"Power off": "Ausschalten",
	"Starting normal recording": "Normale Aufzeichnung starten",
	"Changing recording mode": "Aufzeichnungsmodus ändern",
	"Speed alert (beep)": "Geschwindigkeitsalarm (Piepton)",
	"Cloud related": "Cloud-bezogen",
	Volume: Volume$f,
	"User text overlay": "Nutzertext Überblendung",
	"A-Z, a-z_": "A-Z, a-z, 0-9, :;’/\\+-_()$#\nweniger als 20 Zeichen.",
	"Wi-Fi auto turn off": "WLAN Auto-Abschaltung",
	"Login credentials": "Zugangsdaten",
	"Manual recording": "Manuelle Aufzeichnung",
	"By sharing your_": "Durch Freigabe Ihres Livebildes lassen Sie andere Nutzer stellvertretend die Spannung und das Vergnügen des Fahrens in der ganzen Welt erleben.",
	"However, as persona_": "Da jedoch ein persönliches Video übertragen wird, sollten Sie mit Bedacht wählen, welche Informationen Sie freigeben.",
	"Please enter_email_2": "Bitte geben Sie eine gültige E-Mail-Adresse ein. E -Mails mit einigen Sonderzeichen sind möglicherweise nicht zulässig. Ex) +, &",
	"Password is incorrect": "Das Passwort ist falsch.",
	"This camera is already_": "Diese Kamera ist bereits in einem BlackVue-Konto registriert.",
	"Camera name must_": "Kameraname muss 5-32 Zeichen lang sein.",
	"Failed to save_": "Kameraeinstellungen speichern fehlgeschlagen.",
	"Unallowed character detected": "Nicht erlaubtes Zeichen erkannt.",
	"File(s) queued for_": "Dateien für Cloud-Upload in Warteschlange.",
	"Exceeded video play_": "Videowiedergabe- und Download-Limit überschritten.",
	"Playback Failed": "Wiedergabe fehlgeschl.",
	"Exceeded your Live_": "Live View-Zeitlimit überschritten.",
	"The camera is not_": "Die Kamera ist nicht mit dem Server verbunden.",
	"Please check the connection_": "Überprüfen Sie den Verbindungsstatus der ausgewählten Kamera.",
	Close: Close$f,
	"Map": "Karte",
	Cloud: Cloud$f,
	Public: Public$f,
	"Flip horizontally": "Horizontal spiegeln",
	Front: Front$f,
	Rear: Rear$f,
	Play: Play$f,
	Stop: Stop$f,
	Pause: Pause$f,
	"Next frame": "Nächstes Bild",
	"Previous frame": "Voriges Bild",
	"Proximity sensor": "Näherungssensor",
	"Voice recording on/off": "Sprachaufzeichnung ein/aus",
	"The BlackVue dashcam_": "Die BlackVue Dashcam ist nicht mit 5-GHz-Drahtlosnetzwerken kompatibel.",
	Time: Time$f,
	"Daylight saving time": "Sommerzeit",
	System: System$f,
	"Incorrect camera serial_": "Kameraseriennummer falsch.",
	"Lock event files": "Ereignisdateien sperren",
	"Overwrite locked event_": "Gesperrte Ereignisdateien überschreiben, wenn voll",
	"Camera settings saved_": "Kameraeinstellungen erfolgreich gespeichert.",
	"Front camera": "Frontkamera",
	"Rear camera": "Heckkamera",
	Event: Event$f,
	Parking: Parking$f,
	"GPS tracking": "GPS-Tracking",
	"G-force detected": "G-Force erkannt",
	"Impact detected in_": "Aufprall im Parkmodus erkannt",
	"Scheduled reboot": "Geplanter Neustart",
	"Recording status": "Aufnahmestatus",
	"Rear security": "Überwachung hinten",
	"Time lapse": "Zeitspanne",
	"Sync with GPS_": "Mit GPS-Zeit synchronisieren",
	"Overwrite locked event3_": "Gesperrte Dateien mit neuen Ereignisdateien überschreiben, wenn Speicher voll ist",
	"Video codec": "Video-Codec",
	"Tracking logs": "Verfolgungsprotokolle",
	"Geofence alerts": "Geo-Fencing-Alarm",
	Color: Color$f,
	Exit: Exit$f,
	Save: Save$f,
	Impact: Impact$f,
	Unlimited: Unlimited$f,
	"Parking mode recording": "Parkmodus-Aufnahme",
	"Battery protection": "Batterieschutz",
	"Cut-off timer": "Abschalttimer",
	"Low voltage cut-off": "Niederspannungsabschaltung",
	"Rear camera orientation": "Ausrichtung Rückfahrkamera",
	Default: Default$f,
	"Rotate video 180°": "Video um 180° drehen",
	"Mirror video": "Video spiegeln",
	"Wi-Fi band": "WLAN-Band",
	"Driving report": "Fahrbericht",
	"Unsupported video codec_": "Nicht unterstützter Video-Codec (H.265).",
	"Rear camera recording_": "Heckkamera nimmt im Parkmodus auf",
	"Front and rear_": "Front- und Heckkamera nehmen zusammen auf",
	"Rear camera stops_": "Heckkamera beendet die Aufnahme 5 Minuten nach Beginn des Parkmodus. Aufnahme startet neu, wenn der Normalmodus beginnt.",
	"Remote firmware update": "Remote-Firmware-Aktualisierung",
	"Firmware is up-to-date": "Firmware ist aktuell",
	"New firmware available": "Neue Firmware verfügbar.",
	Version: Version$f,
	"Release date": "Freigabedatum",
	Language: Language$f,
	"File size": "Dateigröße",
	"What’s new": "Was ist neu?",
	"Updating may take_": "Die Aktualisierung kann einige Minuten dauern.",
	"The update process_": "Die Aktualisierung kann nicht abgebrochen werden.",
	"Do not disconnect the_": "Ziehen Sie das Stromkabel erst ab, wenn die normale Aufnahme beginnt.",
	"Downloading firmware": "Firmware wird heruntergeladen",
	"Once download is_": "Nach Abschluss des Downloads startet die BlackVue automatisch neu, um die neue Firmware zu installieren.",
	"If not allowed_": "Wenn nicht erlaubt, sind die Position und Geschwindigkeit Ihres Autos über die Cloud nicht abrufbar.",
	"Unable to initiate update because_": "Aktualisierung kann nicht gestartet werden, da die Dashcam über Direkt-WLAN mit einem Gerät verbunden ist.",
	Notification: Notification$f,
	Multiple: Multiple$f,
	Range: Range$f,
	"HDR night vision": "HDR-Nachtsicht",
	Download: Download$f,
	"G-sensor": "G-Sensor",
	Manual: Manual$f,
	"Low voltage warning": "Unterspannungswarnung",
	Satellite: Satellite$f,
	"Data usage": "Datennutzung",
	"Select video download quality": "Wählen Sie die Qualität des Video-Downloads",
	"Quick play file_": "Schnellwiedergabedatei (niedrige Auflösung)",
	"Original file": "Originaldatei",
	"You do not have permission_": "Sie haben keine Berechtigung, diese Funktion auszuführen. Bitte wenden Sie sich an Ihren Hauptkontoinhaber.",
	"Interior camera recording_": "Innenkamera nimmt im Parkmodus auf",
	"Interior security": "Überwachung des Innenraums",
	"Interior camera rotation": "Drehung Innenkamera",
	"Multi View": "Mehrfachansicht",
	Tutorials: Tutorials$f,
	"Upgrade now": "Jetzt upgraden",
	"Members will show_": "Mitglieder werden hier angezeigt, sobald sie verfügbar sind",
	"Are you sure_delete members": "Möchten Sie Mitglieder wirklich dauerhaft löschen?",
	"Some members may_": "Einige Mitglieder sind aufgrund der angewandten Filter möglicherweise ausgeblendet.",
	"Invited on_": "am {{Invited Date}} von Ihnen eingeladen. Halter",
	Filter: Filter$f,
	"Date created": "Erstellungsdatum",
	"No admin yet": "Noch kein Administrator",
	"You can add_admin": "Sie können 1 Administrator pro Gruppe hinzufügen",
	"Collapse all": "Alle einklappen",
	"Expand all": "Alle erweitern",
	"Download and playback_cloud": "Vom Cloudspeicher herunterladen und wiedergeben",
	"Are you sure_2": "Möchten Sie Gruppe {Group name} wirklich löschen?",
	"Are you sure_groups": "Möchten Sie Gruppen wirklich löschen?",
	"Add cameras first_drivers": "Zuerst Kameras hinzufügen, danach Fahrer zuweisen",
	"Flip vertically": "Vertikal umklappen",
	Sun: Sun$f,
	Mon: Mon$f,
	Tue: Tue$f,
	Wed: Wed$f,
	Thu: Thu$f,
	Fri: Fri$f,
	Sat: Sat$f,
	Dates: Dates$f,
	Routes: Routes$f,
	Opacity: Opacity$f,
	"Color and opacity": "Farbe und Transparenz",
	"Geofences will show_": "Geozäune werden hier angezeigt, sobald sie verfügbar sind",
	"Start drawing a shape_": "Beginnen Sie, indem Sie eine Form auf der Karte zeichnen",
	"Add geofence": "Geozaun hinzufügen",
	Entry: Entry$f,
	"Show all members": "Alle Mitglieder anzeigen",
	"Me and my_": "Ich und mein Wagen. Verbunden",
	"add-on service for_": "Zusatzdienst für cloud-kompatible BlackVue",
	"Continue with Google": "Weiter mit Google",
	"An account with_": "Ein Konto mit dieser E-Mail-Adresse ist bereits vorhanden, aber nicht verifiziert. Geben Sie Ihr bestehendes BlackVue Cloud-Passwort ein, um sich anzumelden.",
	"Account does not_": "Konto existiert nicht. Oder versuchen Sie, sich mit Ihrem Apple- oder Google-Konto anzumelden.",
	"Continue with Apple": "Weiter mit Apple",
	"Get started": "Los geht's",
	"P subscription only": "Nur <b>{{a}}</b>-Abonnement",
	"+N USD for extra camera_": "+{{a}} USD for extra camera up to {{b}} Cameras",
	"Unlimited Live view": "Unlimited Live View",
	"Cameras per Account": "Cameras per Account",
	"Users per Account": "Users per Account",
	Owner: Owner$f,
	"Live View per Day": "Live View per Day",
	"Remote Video Playback_2": "Remote Video Playback and Download per Month",
	"N days": "{{a}} Days",
	"Video On Map": "Video On Map",
	Undetected: Undetected$f,
	Distracted: Distracted$f,
	Drowsy: Drowsy$f,
	"Whether on mobile_": "Whether on mobile or your computer, BlackVue gives you the tools to fully enjoy your dashcam’s functions. Download the latest <a1>firmware</a1>, <a2>mobile</a2> and <a3>desktop</a3> applications, or use <a4>BlackVue web app</a4> in your browser.",
	"Compatible with most_": "Compatible with most Wi-Fi BlackVue models. Cloud support for all Cloud-compatible dashcam models down to DR650GW Series with <b>Cloud Firmware</b>.",
	"Supports most recent BlackVue_": "Supports most recent BlackVue models and compatible with BlackVue Cloud.<br/>\nThis Viewer contains <b>two applications in one</b>: the SD Card Viewer lets you view recorded videos from your SD card and modify the settings of your BlackVue, as well as format the SD card; the <b>Cloud Viewer</b> lets you enjoy BlackVue Cloud.",
	"Contact us": "Contact us",
	"6 characters with": "6 Zeichen, Buchstaben, Ziffern und Sonderzeichen",
	"Apps and more...": "Apps and more...",
	"Cameras will show_": "Cameras will show up here as they become available.",
	"Keep this page_": "Lassen Sie diese Seite geöffnet, während Sie den Bestätigungscode prüfen. Sehen Sie in Ihrem Spamordner nach, wenn Sie die E-Mail nicht in Ihrem Posteingang finden.",
	"n cameras": "{{n}} Kameras",
	"n slots": "{{n}} Steckplätze",
	"Calculate your Fleet_": "Berechnen Sie den Preis Ihres Flottentarifs",
	"Code you entered_": "Der eingegebene Code ist falsch/abgelaufen",
	Calling: Calling$f,
	Smoking: Smoking$f,
	"Smoking has been_": "Der Fahrer raucht während der Fahrt.",
	"Email is already_": "E-Mail-Adresse bereits vorhanden.",
	"Serial number and_": "Seriennummer und Cloud-Code sind auf Ihrer Kamera aufgedruckt",
	"Allow GPS access": "GPS-Zugriff erlauben",
	"Used to access_": "Dient zum Zugriff auf den Standort und die Geschwindigkeit Ihres Fahrzeugs. Sie können die GPS-Einstellungen später in den Datenschutzeinstellungen Ihrer Kamera ändern.",
	"Incorrect cloud code": "Falscher Cloud-Code.",
	"An account is_": "Es ist bereits ein Konto mit dieser E-Mail-Adresse registriert.",
	"Live event upload": "Live-Ereignis-Upload",
	Permissions: Permissions$f,
	"Assign in": "Zuweisen in",
	"Are you sure_camera": "Möchten Sie diese Kamera wirklich löschen?",
	"Uploading videos:": "Videos herunterladen:",
	"GPS location recording": "GPS-Standortaufzeichnung",
	"When OFF, GPS_": "Bei AUS wird der GPS-Standort nicht aufgezeichnet oder an den Cloud-Server gesendet.",
	"As personal video_": "Da möglicherweise persönliche Videoaufnahmen übertragen werden, sollten Sie mit Bedacht wählen, welche Informationen Sie freigeben.",
	"Share location": "Standort teilen",
	Private: Private$f,
	"Used to access_2": "Dient zum Zugriff auf den Standort und die Geschwindigkeit Ihres Fahrzeugs.",
	"Share live view": "Live-View-Video teilen",
	"Share live audio": "Live-View-Audio teilen",
	"Share camera’s name": "Dashcam-Name teilen",
	"Impact detection": "Aufprallerkennung",
	Entering: Entering$f,
	Exiting: Exiting$f,
	"Normal event recording": "Normale Ereignisaufzeichnung",
	"Harsh braking": "Vollbremsung",
	Acceleration: Acceleration$f,
	"Sharp turn": "Scharfe Kurve",
	"Parking event recording": "Parkereignisaufzeichnung",
	Passing: Passing$f,
	"Video source": "Videoquelle",
	Overspeed: Overspeed$f,
	"Are you sure_video": "Möchten Sie dieses Video wirklich löschen?",
	"Add camera to_": "Kamera zur Live-Ansicht hinzufügen",
	"No routes to_": "Keine Routen anzuzeigen",
	"Start by adding_": "Mit dem Hinzufügen von Daten starten.",
	"invite sent": "Einladung versendet",
	Recipients: Recipients$f,
	Send: Send$f,
	"Routes selected_": "Ausgewählte Routen: {{n}} von {{total}}",
	"Map service": "Kartendienst",
	"Speed units": "Geschwindigkeitseinheiten",
	Note: Note$f,
	"Release notes": "Versionshinweise",
	"The name must_": "Der Name muss zwischen 1 und 30 Zeichen lang sein.",
	Video: Video$f,
	Advanced: Advanced$f,
	"Firmware language": "Sprache der Firmware",
	"Wi-Fi": "WLAN",
	Voice: Voice$f,
	"Show date and_": "Datum und Uhrzeit anzeigen",
	"Show speed": "Geschwindigkeit anzeigen",
	"Front camera rotation": "Drehung der Kamera an Vorderseite",
	"Manual time settings": "Manuelle Zeiteinstellungen",
	"Recommended for better_": "Empfohlen für bessere Komprimierung, geringere Dateigröße und 4K UHD.",
	"For full compatibility_": "Für volle Kompatibilität mit älteren Desktop- und Mobilgeräten.",
	"Up and down": "Aufwärts und abwärts",
	"Side to side": "Seite zu Seite",
	"Front and back": "Vorder- und Rückseite",
	"Detection region": "Erkennungsbereich",
	"Hotspot 1": "Hotspot 1",
	"Hotspot 2": "Hotspot 2",
	"Hotspot 3": "Hotspot 3",
	"Enter/exit": "Betreten/Verlassen",
	"Event recording": "Ereignisaufnahme",
	"Front security (Normal)": "Sicherheit vorne (Normal)",
	"Front security (Parking)": "Sicherheit hinten (Parken)",
	"LTE (Parking)": "LTE (Parken)",
	"Wi-Fi (Parking)": "WLAN (Parken)",
	"Turn on at startup": "Beim Start einschalten",
	"Turn off after_": "Nach 10 Minuten Inaktivität ausschalten",
	"Your firmware is_": "Ihre Firmware ist auf dem neuesten Stand",
	"Add admin": "Administrator hinzufügen",
	"Remove All/n": "Alle/{{a}} entfernen",
	"Are you sure_remove": "Möchten Sie wirklich Kameras aus dieser Gruppe entfernen?",
	"This will cancel_2": "Hierdurch wird Ihr Flottentarif-Abonnement gekündigt. Das Downgrade auf den kostenlosen Tarif erfolgt am Ende Ihrer aktuellen Abrechnungsperiode.",
	"You’ve reached_": "Sie haben das Fahrerlimit pro Kamera erreicht",
	"Are you sure_remove admin": "Möchten Sie wirklich Administrator {{a}}{{b}} aus dieser Gruppe entfernen?",
	"Fleet Plan · Owner": "Fleet Plan · Owner",
	"Manage cameras": "Kameras verwalten",
	"Are you sure_delete zone": "Möchten Sie wirklich Zone „{{zone}}“ löschen?",
	"available on your_2": "{{a}}/{{b}} in Ihrem Tarif verfügbar",
	"The new plan_2": "Der neue Tarif tritt am Ende Ihrer aktuellen Abrechnungsperiode ({{a}}) in Kraft.",
	"Canceled Fleet Plan_": "Flottentarif gekündigt am {{a}}",
	"Hard braking alert (beep)": "Starke-Bremsung-Alarm (Piepton)",
	"Hard acceleration alert (beep)": "Starke-Beschleunigung-Alarm (Piepton)",
	"Hard cornering alert (beep)": "Schnelle-Kurvenfahrt-Alarm (Piepton)",
	"SSID must be_": "Die SSID muss aus mindestens 5 Zeichen bestehen.",
	"Password must be_": "Das Passwort muss aus mindestens 8 Zeichen bestehen.",
	"5 to 32 characters long": "5 bis 32 Zeichen",
	"8 to 32 characters long": "8 bis 32 Zeichen",
	"Longer storage period_event": "Längerer Speicherzeitraum für Live-Ereignis-Upload",
	"Requires latest firmware_": "Erfordert die neueste Firmware. Nicht mit den Modellen DR650S, DR650GW kompatibel",
	"After Blackvue is_": "Nachdem die Blackvue mit der Cloud verbunden wurde, werden die Einstellungen gespeichert.",
	"This is an_": "Diese E-Mail-Adresse ist nicht registriert. Möchten Sie ein neues Konto registrieren?",
	"This feature is_": "Diese Funktion ist nur für Abonnenten des Flottentarifs verfügbar.",
	"Please return to_": "Konto existiert nicht. Oder versuchen Sie, sich mit Ihrem Apple- oder Google-Konto anzumelden.",
	"Adjusting the cut-off voltage_": "Adjusting the cut-off voltage to a lower setting may result in your dash cam draining more power from your battery.\nThis could result in warning messages of battery drain or affect other vehicle functions.\nPlease consult with your dealership before lowering the voltage.",
	"Your videos will_": "Ihre Videos werden hier angezeigt, sobald sie verfügbar sind.",
	"You drove:_": "Sie fuhren: {{distance}}, {{time}}",
	"Event count per_": "Ereigniszahl pro Fahrstunde",
	"Are you sure_recipient": "Möchten Sie diesen Empfänger wirklich löschen?",
	"(You)": "{{a}} (Sie)",
	"All events": "Alle Ereignisse",
	Days_: Days_$f,
	"Requires DMC 200_": "Erfordert eine DMC 200-Kamera",
	"A DMS and compatible_": "Für die Anzeige dieses Berichts sind DMS und eine kompatible Dashcam erforderlich.",
	"Notifications will show_": "Benachrichtigungen werden hier angezeigt, sobald sie verfügbar sind.",
	"Try changing your_": "Versuchen Sie, das Datum zu ändern oder Filter zu entfernen.",
	Mute: Mute$f,
	UnMute: UnMute$f,
	"Calling and smoking_": "Telefonieren und rauchen wird nur vom DMC 200-Gerät erkannt",
	"You need a DMS_": "Sie benötigen ein DMS, um diesen Bericht anzuzeigen.",
	"Try BlackVue Cloud": "Testen Sie BlackVue Cloud noch heute",
	"Individual driver looking_": "Möchten Sie als Einzelfahrer auf Nummer sicher gehen? Benötigen Sie als Unternehmensinhaber eine einfache Lösung für die Fahrzeugsicherheit und -verfolgung?",
	"Whoever you are_": "Wer Sie auch sein und welche Anforderungen Sie haben mögen, wir haben einen Cloud-Tarif für Sie!",
	"It is the account that_Driver": "Es ist das Konto, das Ihrer Flotte in der BlackVue Cloud beigetreten ist, nachdem es eine E-Mail-Einladung des Halters oder Administrators angenommen hat. Ein Fahrer kann nur einer Kamera zugewiesen werden, wobei er nur sein eigenes Kontoprofil sowie die Live-Ansicht und die Wiedergabe der ihm zugewiesenen Kamera ansehen kann.",
	"It is the account that_Admin": "Es ist das Konto, das Ihrer Flotte in der BlackVue Cloud beigetreten ist, nachdem es eine E-Mail-Einladung des Halters angenommen hat. Administratorkonten können die Rechte erhalten, die der Halter für diesen Administrator zulässt.",
	"Video deleted": "Video gelöscht",
	"Video delete_plural": "Videos gelöscht",
	"Driver removed from_": "Fahrer aus der Gruppe entfernt",
	"Admin removed from_": "Administrator aus der Gruppe entfernt",
	"Camera removed from_": "Kamera aus der Gruppe entfernt",
	"Are you sure_videos": "Die ausgewählte(n) Datei(en) löschen?",
	"You have to cancel_fleet": "Sie müssen Ihr In-App-Abonnement kündigen, um die Anzahl der Kameras zu ändern: 1. Kündigen Sie Ihr aktuelles Abonnement im App Store oder im Google Play Store. Das Downgrade auf den kostenlosen Tarif erfolgt am Ende Ihrer aktuellen Abrechnungsperiode. Ihre Daten bleiben erhalten. 2. Melden Sie sich bei Ihrem blackvuecloud.com-Konto an und führen Sie ein Upgrade auf den Flottentarif durch.",
	Discard: Discard$f,
	"Discard unsaved changes?": "Nicht gespeicherte Änderungen verwerfen?",
	"Incorrect serial number": "Falsche Seriennummer",
	"An error occurred_again": "Es ist ein Fehler aufgetreten. Versuchen Sie es erneut.",
	"You are subscribed_free": "Sie haben den kostenlosen BlackVue Cloud-Tarif abonniert.",
	"When an event_": "Wenn ein Ereignis erstellt wird (durch erkannten Aufprall oder manuell ausgelöst), kann die BlackVue per Live-Ereignis-Upload einen Live-Videostream einschließlich 5 Sekunden vor dem Ereignis von einer Kamera Ihrer Wahl auf dem Cloud-Server speichern.",
	Report: Report$f,
	"How it work": "So funktioniert es",
	"Cloud Camera": "Cloud-Kamera",
	"Internet Connection": "Internetverbindung",
	"BlackVue App/Viewer": "BlackVue App/Viewer",
	"All you need_": "Sie benötigen lediglich eine",
	"Cloud-compatible BlackVue": "Cloud-kompatible BlackVue",
	"and a cellular_": "und einen Mobilfunkdatentarif. Einige Modelle stellen die Verbindung zur Cloud über einen WLAN-Hotspot eines Drittanbieters her. Andere bieten einen eingebauten Nano-SIM-Kartenleser oder unterstützen ein Plug-in-Konnektivitätsmodul.",
	"Cloud features at_": "Cloud-Funktionen auf Knopfdruck",
	"Enjoy peace of_": "Genießen Sie die Gewissheit, dass BlackVue über Ihr Auto wacht. Wenn etwas nicht in Ordnung ist, informiert Sie Ihre Dashcam sofort.",
	"Let your BlackVue_": "Lassen Sie Ihr Auto von BlackVue überwachen und sich über Zwischenfälle informieren. Wenn ein Aufprall erkannt wird, sendet die BlackVue eine Benachrichtigung zusammen mit einem Foto an Ihr Mobiltelefon oder Ihren Webbrowser.",
	"Check on your_": "Überprüfen Sie Ihr Auto von jedem beliebigen Ort aus mit Remote Live View. Greifen Sie über einen Webbrowser oder Ihr Mobiltelefon auf die Echtzeit-Videobilder Ihrer mit der Cloud verbundenen Dashcam zu und schalten Sie ganz einfach zwischen Front-, Heck- und Innenkamera um.",
	"Your BlackVue may_": "Ihre BlackVue kann zwar keine Fahrerflucht verhindern, aber wenn sie geschieht, ist die Wahrscheinlichkeit groß, dass die Kamera wichtige Videobeweise aufnimmt. Durchsuchen Sie alle Videos, die Ihre Dashcam aufgenommen hat, über Ihr Mobiltelefon oder einen Webbrowser.",
	"Worried about eating_": "Fürchten Sie, Ihren Datentarif zu verbrauchen? Mit der Sub-Stream-Technologie von BlackVue können Sie auf sehr schlanke Versionen Ihrer Videos zugreifen, die schnelles Durchsuchen und pufferfreies Ansehen ermöglichen.",
	"Move files from_": "Verschieben Sie Dateien von Ihrer BlackVue in die Cloud. Speichern Sie ein einzelnes Video oder wählen Sie mehrere Clips für einen Massenupload aus. Mit der BlackVue-App auf Ihr Mobiltelefon heruntergeladene Videos können über das Menü „Interner Speicher“ aufgerufen und geteilt werden.",
	"View your vehicle’s_": "Zeigen Sie den Standort und die Fahrgeschwindigkeit Ihres Fahrzeugs in Echtzeit an. Mit einem Upgrade auf einen Smart-Tarif erhalten Sie Zugriff auf die GPS-Tracking-Daten der letzten 7 Tage.",
	"Get more with_": "Mit dem Smart-Tarif haben Sie mehr",
	"Unlimited Remote Live_": "Unbegrenzte Remote-Live-Ansicht",
	"Up to 3 dashcams_": "Bis zu 3 Dashcams in einem einzigen Konto",
	"Want to track_": "Möchten Sie einen ganzen Fuhrpark verfolgen? Upgrade zum Flottentarif",
	"BlackVue Fleet Tracking_2": "BlackVue-Flottenverfolgung ist eine All-in-one-Lösung zum Schutz und zur Verfolgung Ihres Fuhrparks. Funktionen und Preise lassen sich flexibel an die Anforderungen Ihres Unternehmens anpassen.",
	"Stream real-time video_": "Unbegrenztes Echtzeitvideo-Streaming. Bitrate: 600 Kbps",
	"Up to 999 Dashcams": "Bis zu 999 Dashcams",
	"Register up to_": "Registrieren Sie bis zu 999 Dashcams pro Konto.",
	"15GB of Cloud_": "15 GB Cloud-Speicher",
	"15GB per additional_": "15 GB pro zusätzlicher Dashcam. Unbegrenzter Speicher für den Ereignis-Autoupload.",
	"90-days GPS_": "Protokolle von 90 Tagen GPS-Tracking",
	"High accuracy: 15_": "Hohe Genauigkeit: 15 Sekunden, Video auf einer Karte, einfacher Datenexport.",
	"Unique fleet management_": "Einzigartige Flottenmanagement-Funktionen bieten Mehrwert und Komfort",
	"Create geofences and_": "Erstellen Sie Geozäune und erhalten Sie Echtzeit-Benachrichtigungen auf Ihrem Mobiltelefon oder Computer.",
	"View at a_": "Zeigen Sie übersichtlich die Gesamtfahrstrecke, Stillstandszeiten, Geschwindigkeitsüberschreitungen usw. in Tabellen an, die ausgedruckt oder exportiert werden können.",
	"Multi Live View": "Mehrfach-Live-Ansicht",
	"Monitor up to_": "Überwachen Sie bis zu 4 Dashcams gleichzeitig",
	"Benefits for you": "Ihre Vorteile",
	Individual: Individual$f,
	"Get notifications to_2": "Sie erhalten Benachrichtigungen auf Ihr Mobiltelefon, wenn Ihr geparktes Auto gerammt wird. Sehen Sie sich aus der Ferne an, was um Ihr Auto herum geschieht. Im Internet, auf dem Mobiltelefon, auf dem Mac und unter Windows verfügbar.",
	"Small business owner": "Inhaber eines Kleinunternehmens",
	"Monitor your commercial_2": "Überwachen Sie Ihre Nutzfahrzeuge in Echtzeit auf einer Karte. Sprechen Sie jederzeit über Ihren Browser, die BlackVue-Mobilapp, einen Mac- oder Windows-Viewer mit Ihren Fahrern.",
	"Company with large_": "Unternehmen mit großem Fuhrpark",
	"With BlackVue Fleet_2": "Mit BlackVue-Flottenverfolgung können Sie über Ihren Browser, die BlackVue-Mobilapp, einen Mac- oder Windows-Viewer bis zu 999 Fahrzeuge in Echtzeit verfolgen.",
	Subscribed: Subscribed$f,
	"The video was_": "Das Video wurde bereits hochgeladen.",
	Geofence: Geofence$f,
	"500: Internal server error": "500: Interner Serverfehler",
	"404: Page not found": "404: Seite nicht gefunden",
	"Check the web address_": "Überprüfen Sie die Webadresse oder gehen Sie zurück zur BlackVue Cloud-Homepage",
	"home page": "Home page",
	"There isn’t an_": "Es ist kein Konto mit dieser E-Mail-Adresse verbunden",
	"You can now_password": "Sie können sich jetzt mit Ihrem neuen Passwort anmelden",
	"Are you sure_remove admin2": "Möchten Sie den Administrator wirklich dauerhaft löschen?",
	"Admin deleted": "Administrator gelöscht",
	"Members deleted": "Mitglieder gelöscht",
	"Are you sure_groupName": "Möchten Sie wirklich Gruppe {{a}} löschen?",
	"Requires latest firmware": "Erfordert die neueste Firmware",
	"Selected file(s) moved_": "Ausgewählte Datei(en) erfolgreich verschoben",
	"Are you sure_remove driver2": "Möchten Sie wirklich Fahrer {{a}} ({{b}}) aus dieser Gruppe entfernen?",
	"Invite sent": "Einladung versendet",
	"Safe driving": "Sicheres Fahren",
	"Reckless driving": "Rücksichtsloses Fahren",
	"Inattentive driving": "Unaufmerksames Fahren",
	"Driving events trend": "Trends bei Fahrtereignissen",
	"Driving details": "Fahrdetails",
	Driving: Driving$f,
	Idling: Idling$f,
	Distance: Distance$f,
	"Parking sessions": "Parksitzungen",
	"Parked time": "Parked time",
	"Idle stops": "Stopps für Stillstand",
	"Idle time": "Stillstandzeit",
	"Impact events": "Impact Events",
	Parked: Parked$f,
	Speed: Speed$f,
	"Overspeeding alerts": "Geschwindigkeitsüberschreitungsalarme",
	Highest_2: Highest_2$f,
	Average: Average$f,
	Geofences: Geofences$f,
	"Entries into a_": "Einfahrten in eine Zone",
	"Exits from a_": "Ausfahrten aus einer Zone",
	"No data": "Keine Daten",
	"Hard acceleration": "Beschleunigung",
	"Hard braking": "Vollbremsung",
	"Hard cornering": "Scharfe Kurve",
	"The number within the brackets_": "Die Zahl in Klammern gibt die durchschnittliche Anzahl der Ereignisse pro Fahrstunde an. Wenn Sie weniger als eine Stunde pro Tag gefahren sind, wird die Gesamtzahl der Ereignisse angezeigt.",
	"Did you insert_": "Haben Sie eine SIM-Karte eingesetzt?",
	"Click here for_": "Für eine detaillierte Anleitung <a>hier klicken</a>.",
	"Back up all_": "<b>Sichern Sie alle wichtigen Aufnahmen, bevor Sie diese Einstellungen speichern.</b><br/>Wenn Sie die Einstellungen speichern, wird die microSD-Karte zur Gewährleistung eines stabilen Betriebs neu initialisiert und alle Aufzeichnungen werden gelöscht.",
	"Not connected to_": "Nicht mit der Cloud verbunden. Einige Funktionen wurden vorübergehend deaktiviert.",
	"GPS Location recording off": "GPS-Standortaufzeichnung aus",
	"n Videos deleted": "{{count}} Videos gelöscht",
	Move: Move$f,
	"Driver Monitoring System (DMS) will_": "Das Fahrerüberwachungssystem (Driver Monitoring System, DMS) wird demnächst auf dem Markt eingeführt.",
	"An error occured while_": "Bei dem Versuch, die Anzahl der Kameras zu ändern, ist ein Fehler aufgetreten. Erneut versuchen",
	"Reached the limit_": "Obergrenze erreicht: {{a}}",
	"An invitation was_": "Es wurde bereits eine Einladung an diese E-Mail-Adresse geschickt.",
	"To use the_": "So verwenden Sie die Cloud-Funktion. Bitte setzen Sie Ihre SIM-Karte ein.",
	"Last updated": "Letzte Aktualisierung {{date}}",
	"Try changing your date": "Versuchen Sie, das Datum zu ändern.",
	"No event data_": "Für die ausgewählte Zeit wurden keine Ereignisdaten erfasst",
	"Please select another_": "Wählen Sie einen anderen Tag oder Monat aus, um einen vollständigen Bericht anzuzeigen.",
	"more than 6_": "mehr als 6 Zeichen erforderlich",
	"Sign up free": "Kostenlos anmelden",
	"Cloud storage warning": "Cloudspeicher-Warnung",
	"Cloud Storage Full": "Cloudspeicher voll",
	"Cloud storage usage_100": "Die Nutzung des Cloud-Speichers hat 100% erreicht. Schaffen Sie Speicherplatz, um Live-Ereignis-Upload nutzen zu können",
	"Cloud storage usage_": "Die Nutzung des Cloud-Speichers hat <b>({{a}}%)</b> erreicht. \nOrganisieren Sie Ihren Cloud-Speicher.\nDer Live-Ereignis-Upload-Dienst ist nicht verfügbar, wenn der Cloud-Speicher voll ist.",
	"Are you sure_delete_zone": "Möchten Sie wirklich löschen?",
	"Search Name or email": "Name oder E-Mail-Adresse suchen",
	"Search group name": "Gruppenname suchen",
	"Please note that_": "Die Videoaufzeichnung wird für einige Sekunden unterbrochen, um die neuen Einstellungen zu übernehmen.",
	"Currently connected Hotspot": "Aktuell verbundener Hotspot",
	"Enhanced night vision": "Verbesserte Nachtsicht",
	"To access the_": "Aktualisieren Sie bitte Ihr Abonnement, um auf die Kamera zuzugreifen.",
	"Restarting the Blackvue_": "BlackVue startet neu, um Einstellungen zu übernehmen.",
	"Hard acceleration event_": "Eine starke Beschleunigung wird festgestellt, wenn der Geschwindigkeitszuwachs pro Sekunde über {{kmh}} km/h liegt.",
	"Hard braking event_": "Eine starke Bremsung wird festgestellt, wenn die Verringerung der Geschwindigkeit pro \nSekunde über {{kmh}} km/h liegt.",
	"Hard cornering event_": "Eine schnelle Kurvenfahrt wird festgestellt, wenn innerhalb von 2 Sekunden bei einer Geschwindigkeit von mehr als \n{{kmh}} km/h eine Drehung von mehr als 60 Grad erfolgt",
	"Changes you made_": "Ihre Änderungen wurden möglicherweise nicht gespeichert",
	"My location": "Mein Standort",
	"Hotspot name (SSID)": "Name des Hotspots (SSID)",
	Connected: Connected$f,
	"Camera will be rebooted_": "Kamera wird neu gestartet. Möchten Sie trotzdem fortfahren?",
	"Restarting the BlackVue_": "Die BlackVue wird neu gestartet. Bitte warten Sie einen Moment.",
	"Failed to reboot_": "Neustart der Kamera fehlgeschlagen",
	"Bluetooth (Parking mode)": "BT (Parkmodus)",
	"Front and interior camera_": "Front- und Innenkamera nehmen zusammen auf.",
	"Interior camera stops_": "Die Innenkamera beendet die Aufnahme 5 Min. nach Beginn des Parkmodus. Aufnahme startet neu, wenn der Normalmodus beginnt.",
	Individual_: Individual_$f,
	"Driver detection": "Fahrererkennung",
	"During driving only": "Nur während der Fahrt",
	Always: Always$f,
	"Driver detection box": "Fahrererkennungsbox",
	"DMS camera rotation": "Drehung der DSM-Kamera",
	Low: Low$f,
	Medium: Medium$f,
	High_2: High_2$f,
	"Reboot Camera": "Kamera neu starten",
	"Latest events": "Neueste Ereignisse",
	"G-Sensor": "G-Sensor",
	"Playback speed": "Wiedergabegeschwindigkeit",
	Flip: Flip$f,
	Previous: Previous$f,
	Next: Next$f,
	"Map type": "Kartentyp",
	"Zoom in": "Vergrößern",
	"Zoom out": "Verkleinern",
	"Move to Cloud": "In die Cloud verschieben",
	"Please recognize that_": "Beachten Sie bitte, dass die Videoaufzeichnung für einige Sekunden unterbrochen wird, um die Einstellungen zu übernehmen.",
	"6 characters with_": "6 Zeichen, Buchstaben, Ziffern und Sonderzeichen",
	"Updating firmware": "Firmware aktualisieren",
	"Overspeed event occurs_": "Eine Geschwindigkeitsüberschreitung wird festgestellt, wenn die Dashcam den Fahrer warnt, dass die zulässige Geschwindigkeit überschritten wird. Sie können sie unter „Firmware > System > Lautstärke“ ändern",
	"Enter group name": "Gruppenname eingeben",
	"Live view failed": "Fehler bei Live View.",
	"Parking mode enter_": "Parkmodus Anfang/Ende",
	"Cloud connectivity": "Cloud-Verbindung",
	Expand: Expand$f,
	Collapse: Collapse$f,
	"all day": "den ganzen Tag",
	"Driving style": "Fahrstil",
	"Driving impact": "Aufprall während der Fahrt",
	More: More$f,
	"No cameras to_": "Keine Kameras hinzuzufügen",
	"You have added_": "Sie haben alle verfügbaren Kameras hinzugefügt.",
	Multi: Multi$f,
	"Report video": "Video melden",
	"Sexually explicit content": "Sexueller Inhalt",
	"Graphic violence": "Gewalttätig oder abstoßend",
	"Hateful speech": "Hasserfüllt oder beleidigend",
	"Harassment or bullying": "Belästigung oder Mobbing",
	"Spam or advertisement": "Spam oder Werbung",
	"Infringement of my_": "Verstößt gegen meine Rechte",
	"Other reason": "usw.",
	"Reason for reporting": "Grund für die Meldung",
	"Reported videos will_": "Gemeldete Videos werden innerhalb von 72 Stunden überprüft. Das Video wird erst dann auf der Ereigniskarte angezeigt, wenn bestätigt wird, dass es für die Veröffentlichung auf der Ereigniskarte geeignet ist.",
	"Touch sensor": "Berührungssensor",
	"Motion and impact detection": "Bewegungs- und Aufprallerkennung",
	"Settings have been changed": "Einstellungen wurden geändert",
	"Start event recording (beep)": "Ereignisaufnahme starten (Signalton)",
	"Scheduled reboots": "Geplante Neustarts",
	Safe: Safe$f,
	Reckless: Reckless$f,
	Inattentive: Inattentive$f,
	"Highest(Extreme)": "Höchst (extrem)",
	"Public cameras": "Öffentliche Kameras",
	List: List$f,
	Usage: Usage$f,
	"Video playbacks and downloads": "Videowiedergaben und Download",
	"of 100 times": "von 100 Mal",
	"of 10 minutes": "von 10 Minuten",
	Profile: Profile$f,
	"Search geofences": "Geofences suchen",
	"Export CSV": "CSV exportieren",
	"Exit fullscreen": "Vollbild verlassen",
	Fullscreen: Fullscreen$f,
	Upgrade: Upgrade$f,
	"Email address": "E-Mail-Adresse",
	"of Unlimited": "von unbegrenzt",
	"No notifications yet": "Keine Benachrichtigungen in den letzten 7 Tagen erhalten.",
	"No videos yet": "Noch keine Videos",
	Management: Management$f,
	Day: Day$f,
	Month: Month$f,
	"Welcome to the BlackVue_": "Willkommen beim BlackVue Cloud Viewer",
	"You can access BlackVue_": "Sie können jederzeit und überall über das Internet auf die BlackVue Cloud zugreifen!",
	"Start tour": "Tour starten",
	"Map view": "Kartenansicht",
	"Check the current_": "Prüfen Sie den aktuellen GPS-Standort und die Geschwindigkeit Ihrer Kameras und öffentlicher Kameras.",
	"Camera’s features": "Kamerafunktionen",
	"Take a look_": "Werfen Sie einen Blick auf die verschiedenen Cloud-bezogenen Funktionen der BlackVue-Kamera.",
	"Visualize your vehicle’s_": "Visualisieren Sie die Fahrtroute Ihres Fahrzeugs im Verlauf der Zeit.",
	"Smart plan_": "Smart-Plan: 90 Tage, Flottenplan: 90 Tage",
	"Create geofences and2_": "Erstellen Sie Geofences und erhalten Sie Benachrichtigungen in Echtzeit.",
	"Got it": "Habe es verstanden",
	"Manage Fleet members": "Flottenmitglieder verwalten",
	"Invite fleet members_": "Laden Sie Flottenmitglieder ein und ordnen Sie sie Gruppen zu.",
	"The moment the_": "In dem Moment, in dem die Kamera den Aufprall erkennt, werden hier Benachrichtigungen aufgelistet.",
	"Geofence Setup (Web)_": "Geofence-Einrichtung (Web/Desktop) und Warnungen",
	"Original file play_": "Die Wiedergabe der Originaldatei ist nur als Download verfügbar",
	"To get most_": "Um den BlackVue Cloud Viewer optimal nutzen zu können, muss Ihre Kamera mit der Cloud verbunden sein. Laden Sie die BlackVue-App herunter und erleben Sie nahtloses Koppeln, vom Hinzufügen der Kamera bis zur Cloud-Verbindung – alles auf einmal!",
	"You haven’t driven_Today": "Sie sind heute noch nicht mit Ihrem Auto gefahren. Versuchen Sie, Ihr Auto mit BlackVue zu fahren, um Ihren Fahrbericht zu überprüfen.",
	"You haven’t driven_Month": "Sie sind diesen Monat noch nicht mit Ihrem Auto gefahren. Versuchen Sie, Ihr Auto mit BlackVue zu fahren, um Ihren Fahrbericht zu überprüfen.",
	"Fleet Plan only_": "Nur im Flottenplan verfügbar",
	"Overwrite locked event2_": "Überschreiben von gesperrten Ereignisdateien, wenn der Speicher voll ist",
	"DMS’s New firmware_": "Neue DMS-Firmware verfügbar",
	"Highest speed_report": "<b>Höchstgeschwindigkeit</b>\nGrößter Wert der gesammelten Geschwindigkeitsdaten, die in Meternerfasst werden; Umrechnung in km/h und MPH\n\n<b>Durchschnittsgeschwindigkeit<b/>\n(Distanz/gefahrene Stunden) x 3600 Durchschnittsgeschwindigkeit. Beispiel (2622 / 1208) x 3600 = 7814,907\nkm/h: Nur Ganzzahl, \nder Radixpunkt von MPH liegt bis zu 2 Stellen unter der Ganzzahl",
	"Choose a cloud_": "Wählen Sie eine Methode für die Verbindung mit der Cloud aus",
	"You need an_": "Sie benötigen eine Internetverbindung, um sich mit der Cloud zu verbinden. Wählen Sie das Gerät, das Sie für die Verbindung mit der Cloud verwenden.",
	"BlackVue SIM card": "BlackVue SIM-Karte",
	"Support model_": "Unterstützt das Modell: DR750X-2CH LTE Plus (NA)",
	"3rd party SIM_": "SIM-Karte eines Drittanbieters",
	"Support model_SIM": "Unterstützt das Modell: DR750X-2CH LTE Plus, DR750-2CH LTE, CM100 LTE",
	"Wi-fi hotspot": "WLAN-Hotspot",
	"Support model_Wifi": "Unterstützt das Modell: Alle BlackVue-Modelle",
	"How to connect_": "Mit der Cloud verbinden",
	"Download BlackVue application": "Laden Sie die BlackVue-App herunter.",
	"*If you are_": "*Wenn Sie die BlackVue SIM-Karte für Ihre Cloud-Verbindung verwenden möchten, gehen Sie zu {{a}} {{b}}.",
	"Place your phone_": "Bringen Sie Ihr Handy in BT-Reichweite der Kamera. Starten Sie die Nahtlos-Kopplung mit {{a}}.",
	"Back to camera_": "Zurück zur Kameraliste",
	"Upgrade for more_": "Aktualisieren Sie für mehr Funktionen!",
	"Upgrading the cloud_": "Mit einer Aktualisierung des Cloud-Plans können Sie mehr Funktionen nutzen und mehrere Kameras verwalten. Möchten Sie Ihren Cloud-Plan aktualisieren?",
	"Explore cloud plans": "Cloud-Pläne erkunden",
	Later: Later$f,
	"Successfully subscribed": "Erfolgreich abonniert!",
	"1GB data plan": "1 GB Datenplan",
	"First month free_": "Erster Monat kostenlos, <a>dann 10,99 USD/Monat</a>",
	"Next billing date": "Nächster Abrechnungstermin",
	"Once SIM card_": "Sobald die SIM-Karte in die Kamera eingesetzt ist, können Sie die BlackVue Cloud-Funktionen sofort nutzen.",
	"Go to SIM_": "Gehen Sie zur SIM-Verwaltung",
	"Manage your BlackVue_": "Verwalten Sie Ihre BlackVue SIM-Karte hier!",
	"Recommended for BlackVue_": "Empfohlen für BlackVue SIM-Besitzer",
	"Connect to cloud": "Mit Cloud verbinden",
	"Enter BlackVue SIM_": "BlackVue SIM ICCID-Nummer eingeben",
	"ICCID number is_": "Die ICCID-Nummer ist auf der Verpackung der SIM-Karte aufgedruckt. Bitte geben Sie die letzten 14 Ziffern der ICCID-Nummer ein.",
	ICCID: ICCID$f,
	"SIM information": "SIM-Daten",
	"Start your free_": "Starten Sie jetzt Ihre kostenlose Testphase",
	"SIM card activate_": "Aktivierungsdatum der SIM-Karte",
	"Based on the_": "Basierend auf dem Datum, an dem die SIM-Karte in die Kamera eingesetzt und beim Einschalten der Kamera aktiviert wurde",
	"Upgrade to 3GB_": "Sie können jederzeit auf einen 3 GB/5 GB Tarif umsteigen.",
	"Cancel your plan_": "Sie können Ihren Plan jederzeit kündigen",
	"No Commitment": "Keine Verpflichtung.",
	"Precautions for using_": "Sicherheitshinweise zur Nutzung des Dienstes",
	"After 1GB is_": "Nachdem 1 GB aufgebraucht ist, ist das Internet nicht weiter verfügbar.",
	"If you have_": "Wenn Sie bereits eine SIM-Karte in die Kamera gefügt haben und diese nutzen, beginnt die kostenlose Testphase ab dem Zeitpunkt, zu dem Sie die Kamera nutzen.",
	"This content is_": "Dieser Inhalt ist im SIM-Paket angegeben. Wir bieten keine Entschädigung nicht gewährte Zeitspannen.",
	"If you have_2": "Wenn Sie weitere Fragen haben, wenden Sie sich bitte an das <a>CS Team</a>",
	"When OFF, connecting_": "Im Aus-Modus ist die Verbindung der Kamera durch Nahtlos-Kopplung deaktiviert.",
	"1 month free": "1 Monat kostenlos",
	"No commitment. Cancel_": "Keine Verpflichtung. Jederzeit kündbar.",
	"The video has been reported_": "Das Video wurde erfolgreich gemeldet",
	"Free for 1 month": "1 Monat kostenlos",
	"Start your free_2": "Starten Sie Ihre kostenlose Testversion",
	"1GB free for_": "1 GB kostenlos für {{a}} Tage",
	"1GB data": "1 GB Daten",
	"1 month free_2": "Die 1-monatige kostenlose Testphase beginnt ab {{a}} und umfasst 1 GB Datenvolumen für die Blackvue SIM-Karte.",
	"Your next billing_": "Ihr nächster Abrechnungstermin ist {{a}}",
	"SIM card": "SIM-Karte",
	"SIM guide": "SIM-Leitfaden",
	"SIM card list": "SIM-Kartenliste",
	"Add SIM card": "SIM-Karte hinzufügen",
	"No SIM card_": "Noch keine SIM-Karte",
	"Search SIM ICCID_": "SIM ICCID oder Namen suchen",
	"Cloud disconnected. Failed_": "Cloud getrennt. Video abspielen fehlgeschlagen",
	"This sim card_": "Diese SIM-Karte ist bereits für ein anderes Konto registriert.",
	"Incorrect BlackVue SIM_": "Falsche BlackVue SIM ICCID",
	"My shared videos": "Meine freigegebenen Videos",
	"Number of events": "Anzahl der Ereignisse",
	"Added to Event Map": "Zur Ereigniskarte hinzugefügt",
	"Successfully added video(s)_": "Video(s) erfolgreich zur Freigabe für Ereignisplan hinzugefügt! Wenn Sie den Status überprüfen und die freigegebenen Videos verwalten möchten, gehen Sie zu Ereigniskarte > Meine freigegebenen Videos.",
	"Already added to_": "Bereits zum Ereignisplan hinzugefügt",
	"This video(s) is already added_": "Diese(s) Video(s) wurde(n) bereits zum Ereignisplan hinzugefügt! Wenn Sie den Status überprüfen und die freigegebenen Videos verwalten möchten, gehen Sie zu Ereigniskarte > Meine freigegebenen Videos.",
	"BlackVue’s firmware is up_": "Die Firmware von BlackVue ist auf dem neuesten Stand",
	"Service end": "Dienstende",
	Resubscribe: Resubscribe$f,
	"Sort ascending": "Aufsteigend sortieren",
	"Sort descending": "Absteigend sortieren",
	plan: plan$f,
	USD: USD$f,
	"Are you sure_Cancel": "Möchten Sie Ihr Abonnement wirklich kündigen? Bitte beachten Sie Folgendes und bestätigen Sie es unten.",
	"Your current SIM_": "Ihr aktuelles SIM-Karten-Abonnement endet am {{a}} und wird Ihnen nicht mehr in Rechnung gestellt.",
	"After canceling your_": "Nachdem Sie Ihr SIM-Karten-Abonnement gekündigt haben, können Sie die SIM-Daten bis zum Enddatum Ihres Abonnements weiter nutzen.",
	"You can resubscribe_": "Sie können innerhalb von 1 Monat nach Ablauf Ihres aktuellen Abonnements ein neues Abonnement abschließen. Wenn Sie das Abonnement erneut abschließen möchten, tippen Sie bitte auf „Erneut abonnieren“ in der SIM-Kartenliste bei {{a}}.",
	"Reason to cancel_": "Grund für die Kündigung des Abonnements",
	"Found an alternative": "Alternative gefunden",
	"Too expensive": "Zu teuer",
	"Not required anymore": "Nicht mehr benötigt",
	"Quality issue": "Qualitätsproblem",
	etc_: etc_$f,
	"Please describe in_": "Bitte beschreiben Sie den Grund im Detail",
	"SIM card cannot_": "Die SIM-Karte kann nicht gelöscht werden, da diese SIM-Karte abonniert ist. Wenn Sie diese SIM-Karte löschen möchten, kündigen Sie bitte zuerst Ihr Abonnement.",
	"SIM card cannot_2": "Die SIM-Karte kann nicht gelöscht werden, weil das Abonnement für diese SIM-Karte noch nicht abgelaufen ist. Bitte versuchen Sie es nach Ablauf Ihres Abonnements erneut.",
	"Are you sure_deleteSIM": "Möchten Sie diese SIM-Karte wirklich löschen?<br/>\n<b>Warnung: Sie können diese Aktion nicht rückgängig machen. Alle Daten Ihrer SIM-Karte werden sofort gelöscht.</b>",
	"ICCID number": "ICCID-Nummer",
	"Activation date": "Aktivierungsdatum",
	"Current plan": "Aktueller Plan",
	"Manage Plan": "Plan verwalten",
	"Next billing on": "Nächste Abrechnung am",
	"View Invoices": "Rechnungen anzeigen",
	"Choose best plan_": "Wählen Sie den besten Plan für sich",
	"Plan summary": "Plan-Zusammenfassung",
	"Ends on_": "Endet am {{a}}",
	"Start from_": "Beginnt ab {{a}}",
	"Your subscription will_": "Ihr Abonnement wird am {{a}} hochgestuft, wenn Ihr aktueller Plan endet.",
	"Resubscribe plan": "Plan neu abonnieren",
	"Your subscription will2_": "Ihr Abonnement beginnt am {{a}}, wenn Ihr aktueller Plan ausläuft.",
	"Usage is estimated_": "Die Nutzung wird ab {{a}} geschätzt.",
	"Days left_": "{{a}} Verbleibende Tage",
	"Data usage cycle": "Datennutzungszyklus",
	Available: Available$f,
	Used: Used$f,
	"Data used": "Genutzte Daten",
	"Subscribe to n_": "Abonnieren Sie den {{a}} Datenplan, der <b>von {{b}} bis {{c}}</b> gilt und den {{d}} Datenplan, der ab {{e}} gilt",
	"Will be charged_": "Wird am {{a}} berechnet",
	"Monthly usage": "Monatliche Nutzung",
	"You have fewer_": "Ihnen verbleiben in diesen Monat weniger Daten!",
	"Get more data": "Erhalten Sie mehr Daten!",
	"This video cannot be shared": "Dieses Video kann nicht freigegeben werden",
	"This is a video cannot be shared_": "Dieses Video kann nicht freigegeben werden, da zu diesem Zeitpunkt keine Fahrdaten gefunden werden können.",
	Cancelled: Cancelled$f,
	Terminated: Terminated$f,
	"Edit name": "Name bearbeiten",
	"Not connected to_2": "Nicht mit der Cloud verbunden. Überprüfen Sie, ob Ihre Kamera eingeschaltet und das Internetverbindungsmodul aktiviert ist.",
	"Some functionality is disabled_": "Einige Funktionen sind deaktiviert, weil die Kamera nicht mit der Cloud verbunden ist. Verbinden Sie sich <a>hier</a> mit der Cloud.",
	"If you want to cancel_": "Wenn Sie Ihren Plan kündigen möchten, klicken Sie auf <a>Abonnement kündigen</a>.",
	"Select plan": "Plan auswählen",
	"Event map collects_": "Die Ereigniskarte sammelt und visualisiert BlackVue-Ereignisdaten, um Situationen auf den umliegenden Straßen darzustellen.",
	"Share your Live_": "Geben Sie Ihre Live-Ereignis-Upload-Datei frei. Sie können Ihre Ereignisvideos für andere Nutzer in Ihrer Umgebung freigeben.",
	"You can check_": "Sie können sich die von anderen freigegebenen Ereignisvideos ansehen.",
	"Service end_": "Dienstende: {{a}}",
	"DMS camera recording_": "DMS-Kameraaufnahme im Parkmodus",
	Sort: Sort$f,
	"Are you sure you want_": "Möchten Sie das freigegebene Video wirklich aus der Ereigniskarte entfernen?",
	"Remove shared video": "Freigegebenes Video entfernen",
	"Explore event map": "Ereigniskarte erkunden",
	"Event map": "Ereigniskarte",
	"Explore the graphic_": "Erkunden Sie die grafischen Statistiken der BlackVue-Ereignisse in Ihrer Umgebung.",
	"You can filter_": "Sie können die Ereignisse, die Sie anzeigen möchten, filtern und anzeigen.",
	"This video was removed by_": "Dieses Video wurde einem Administrator gemeldet und entfernt.",
	Bonus: Bonus$f,
	"Your subscription plan": "Ihr Abonnementplan",
	"Your free trial will_": "Ihre kostenlose Testversion läuft ab {{a}},</br> <strong>bis</strong> {{b}}.",
	"Total after free trial": "Summe nach kostenloser Testphase",
	"This sim card is_": "Diese SIM-Karte ist nicht mehr aktiv.",
	"Firmware is up_": "Firmware ist auf dem neuesten Stand",
	"Keep in mind": "Bitte beachten",
	"Once 1GB of_": "Sobald 1 GB Datenvolumen verbraucht ist, steht der Dienst bis zum nächsten Rücksetzdatum für Daten [oder nachdem Sie Ihren Plan auf eine höhere Stufe erweitert haben] nicht mehr zur Verfügung].",
	"After the SIM_": "Nachdem die SIM-Karte in die Kamera eingesetzt wurde, beginnt die kostenlose Testphase, sobald Sie die Daten nutzen.",
	"If you have_questions": "Wenn Sie Fragen haben, wenden Sie sich bitte an unseren <a>Kundendienst.</a>",
	"Data reset date": "Datum der Datenrücksetzung",
	"To use SIM card_": "Um eine SIM-Karte zu verwenden, wenden Sie sich bitte an das BlackVue <a>CS Team</a>",
	"Go to Subscription": "Gehen Sie zu Abonnement",
	"An error occurred_subscription": "Beim Abonnieren des ausgewählten Plans ist ein Fehler aufgetreten.",
	"Please try again": "Bitte versuchen Sie es erneut",
	"Failed to subscribe": "Abonnieren fehlgeschlagen",
	"Go to Pricing": "Gehen Sie zu Preisgestaltung",
	"SIM cards will_": "SIM-Karten werden hier angezeigt, sobald sie verfügbar sind.",
	"1GB for 1_": "1 GB für 1 Monat",
	"Pricing Data": "Preisgestaltungsdaten",
	"If you would like to check_": "Wenn Sie den Status überprüfen und die freigegebenen Videos verwalten möchten, gehen Sie zu Ereigniskarte > Meine freigegebenen Videos.",
	"Connect to Cloud": "Mit Cloud verbinden",
	"Completed!": "Abgeschlossen!",
	"Back to App": "Zurück zur App",
	"iOS in-app purchase": "iOS In-App-Kauf",
	"Android in-app_": "Android In-App-Kauf",
	"bonus n days": "Bonus {{a}} Tage",
	"Want to contribute your_": "Erlauben Sie die automatische Freigabe von automatischen Ereignis-Upload-Dateien zur Ereigniskarte?",
	"With event map_": "Sie können das automatische Ereignis-Upload-Video über die Ereigniskarte für Fahrer in der Nähe freigeben.",
	"You can edit_3": "Sie können die Einstellungen für die automatische Freigabe von automatischen Ereignis-Upload-Dateien auf der Ereigniskarte jederzeit bearbeiten, indem Sie zu BLACKVUE CLOUD > Kameraeinstellungen > Datenschutzeinstellungen gehen.",
	"If you want to remove videos_": "Da möglicherweise persönliche Videoaufnahmen übertragen, sollten Sie mit Bedacht wählen, welche Informationen Sie freigeben.",
	"Total events": "Ereignisse insgesamt",
	"Automatically add Live Event_": "Automatisch Ereignis-Upload-Dateien zur Ereigniskarte freigeben",
	"This camera is publicly_": "Diese Kamera ist nur für ihren Standort öffentlich zugänglich.",
	incomplete_zip: incomplete_zip$f,
	"Live Event Upload_": "Live-Ereignis-Upload (Speicherdauer: 7 Tage)\nErfordert die neueste Firmware",
	"Thank you for_2": "Vielen Dank für Ihre Geduld.",
	"Start Web viewer": "Web Viewer starten",
	"Are you sure_remove driver": "Möchten Sie den Treiber wirklich dauerhaft löschen?",
	"An error occurred_sim": "Beim Versuch, zu abonnieren, ist ein Fehler aufgetreten.",
	"Click the ADD SIM": "Tippen Sie auf der Seite mit der SIM-Kartenliste auf SIM HINZUFÜGEN und gehen Sie dann den Vorgang SIM-Karte hinzufügen noch einmal durch.",
	"Set download options": "Download-Optionen einstellen",
	"Information may be_": "Information may be transmitted with a delay and may not reflect actual balances.",
	"Swipe left and right to move": "Wischen Sie zum Verschieben nach links und rechts",
	"Scheduled maintenance Notice": "Ankündigung geplanter Wartungsarbeiten",
	"Our Cloud server_": "Unser Cloud-Server wird einer planmäßigen Wartung unterzogen.",
	"During that time_": "Während dieser Zeit stehen die Cloud-Funktionen möglicherweise nicht zur Verfügung.",
	"Expected maintenance start_": "Voraussichtliche Startzeit der Wartung:",
	"Expected duration_": "Voraussichtliche Dauer: {{a}} Stunden.",
	"For more information_": "Weitere Informationen finden Sie in der <a>[Mitteilung zur Serverwartung]</a>.",
	"Do not remind_": "Mich nicht mehr erinnern",
	"Cloud Server Maintenance": "Cloud Server-Wartung",
	"BlackVue Cloud Service_": "Der BlackVue Cloud-Dienst ist vorübergehend nicht verfügbar",
	"We are currently_": "Wir führen derzeit Wartungsarbeiten durch.",
	"We apologize for_": "Wir entschuldigen uns für die Unannehmlichkeiten.",
	"Driver Monitoring System (DMS)": "Fahrerüberwachungssystem (DMS)",
	"Distracted occurs_": "Tritt auf, wenn der Kopf des Fahrers mehr als 50 Grad von der Vorderseite entfernt ist.",
	"Hand distraction event occurs_": "Tritt auf, wenn die Hand des Fahrers über einen längeren Zeitraum in der Nähe seines Kopfes erkannt wird (z. B. beim Rauchen, Telefonieren usw.).",
	"Mask off event occurs_": "Tritt auf, wenn der Fahrer ohne Maske in das Fahrzeug einsteigt oder wenn der Fahrer die Maske abnimmt.",
	"DMS setting": "DMS-Einstellungen",
	"The DMS system has_": "Das DMS kombiniert eine Gesichtserkennungsbox für die Zustände \"Erkannt\", \"Nicht erkannt\", \"Abgelenkt\", \"Schläfrig\", \"Maske ab\" und eine Bewegungserkennungsbox für den Zustand \"Ablenkung durch Hand\".",
	"DMS detection": "DMS-Erkennung",
	"There are detection criteria for_": "Für jedes Ereignis gibt es Erkennungskriterien. Bitte beachten Sie die nachstehende Anleitung.",
	"DMS camera recording_onoff": "An: Die DMS-Kamera zeichnet im Parkmodus auf, solange die Stromversorgung aufrechterhalten wird. <br/> Aus: Die DMS-Kamera schaltet sich kurz nach dem Eintritt in den Parkmodus aus.",
	"LED lighting for each event_": "Die LED an der Fahrerüberwachungskamera signalisiert jedes Erkennungsereignis (Ablenkung, Müdigkeit usw.).\n",
	"Drowsy and Distracted each have_": "Schläfrig und Abgelenkt haben jeweils drei Empfindlichkeitsstufen. Bitte beachten Sie folgende Anleitung.",
	"DMS event detection sensitivity": "Empfindlichkeit der DMS-Ereigniserkennung",
	"Only drowsy and distracted include_": "Nur bei Schläfrigkeit und Ablenkung wird die Empfindlichkeit eingestellt. Außerdem wendet die eingestellte Empfindlichkeit die gleiche Empfindlichkeit auf zwei Ereignisse mit einer Einstellung an.",
	"When driver’s eyes close_": "Tritt auf, wenn der Fahrer beide Augen länger als 1 Sekunde geschlossen hält oder für 2 Sekunden gähnt.\n",
	"n digit": "{{a}}-stelligen",
	"You are subscribed_free_Smart": "Sie haben den Smart Plan von BlackVue Cloud abonniert.",
	"Wi-Fi auto turn on": "WLAN automatisch einschalten",
	"Video on a map": "Video on a map",
	"This feature is only_vom": "This feature is only available to users with a Fleet Plan subscription.<br/>Please subscribe to a plan to unlock this feature.",
	"Total n days_": "{{a}}Tage kostenlose Erfahrung",
	"Every events of DMC200_": "Die DMS-Erkennungsfunktionen sind nur im Normalmodus aktiv. Im Parkmodus zeichnet die DMS-Kamera nur Videos auf.",
	"An undetected event occurs_": "Tritt auf, wenn der Fahrer 1 Minute lang nicht vor der Kamera erkannt wird.",
	"A detected event occurs_": "A detected Event occurs when the driver is gazing in front since the power is set in the beginning.",
	"Drowsy sensitivity_": "High : When the driver closes their eyes for more than 1 second, it is considered drowsy driving.<br/><br/>Medium : When the driver closes their eyes for more than 1.5 second, it is considered drowsy driving.<br/><br/>Low : When the driver closes their eyes for more than 2 second, it is considered drowsy driving.",
	"Distracted sensitivity_": "High : If the angle of the head is more than 50 degrees away from the front for 3 seconds, it is detected as Distracted.<br/><br/>Medium : If the angle of the head is more than 50 degrees away from the front for 5 seconds, it is detected as Distracted.<br/><br/>Low : If the angle of the head is more than 50 degrees away from the front for 7 seconds, it is detected as Distracted.",
	"Start your subscription now": "Starten Sie Ihr Abonnement jetzt",
	"Free trial period has expired": "Die kostenlose Testphase ist abgelaufen",
	"1 data plan will start from_": "Der Datentarif beginnt ab {{a}} einschließlich 1 GB Daten für die Blackvue SIM-Karte.",
	"Allow the BlackVue_": "Der BlackVue App den Zugriff auf GPS-Daten Ihrer Dashcam erlauben?",
	"We use this_": "Hiermit können Sie die Position und Geschwindigkeit Ihres Autos verfolgen.",
	"You can edit_": "Sie können die GPS-Einstellungen jederzeit bearbeiten, indem Sie zu BLACKVUE CLOUD > Kameraeinstellungen > Datenschutzeinstellungen gehen.",
	"SIM cards": "SIM-Karten",
	"Subscription status": "Abonnementstatus",
	Upgrades: Upgrades$f,
	"Upgrade plan": "Aktualisierungszeitplan",
	"Manage plan": "Abonnementplan verwalten",
	"Next plan": "Abonnementplan für den nächsten Monat",
	OR: OR$f,
	"Cancel subscription": "Abonnement beenden",
	Undo: Undo$f,
	Invoice: Invoice$f,
	"Daily usage": "Tägliche Datennutzung",
	"Delete SIM": "SIM Löschen",
	"New card": "Neue Kreditkarte",
	data: data$f,
	"SIM card data_": "Das Abonnement des SIM-Karten-Datenplans kann unter <a>sim.blackvuecloud.com</a> gekündigt werden.",
	"Your plan from_": "Ihr Plan von heute bis zum nächsten Abrechnungsdatum",
	"Applied during_": "Angewandt während {{a}} - {{b}}",
	"From today until_": "Von heute an bis zum nächsten Zahlungstermin können Sie nur den gleichen Plan wie im Vormonat abonnieren. Die Zahlungen für diesen Zeitraum werden heute in Rechnung gestellt. <a>Die Gebühren werden anteilig berechnet.</a>",
	"Choose your next plan": "Wählen Sie Ihren nächsten Plan",
	"Applied from_": "Angewandt ab {{a}}",
	"Payment for this_": "Die Zahlung für diesen Plan wird am {{a}} abgerechnet.",
	"By sharing your_2": "Durch Freigabe Ihres Livebildes lassen Sie andere Nutzer stellvertretend die Spannung und das Vergnügen des Fahrens in der ganzen Welt erleben. Da jedoch ein persönliches Video übertragen wird, sollten Sie mit Bedacht wählen, welche Informationen Sie freigeben.",
	"Option camera recording_": "Option Kameraaufnahme im Parkmodus",
	"Front and option camera_": "Front- und optionale Kamera nehmen gemeinsam auf.",
	"Option camera stops_": "Die optionale Kamera stoppt die Aufnahme 5 Minuten nach dem Wechsel in den Parkmodus. Aufnahme startet neu, wenn der Normalmodus beginnt.",
	"Option camera rotation": "Option Kamerarotation",
	"Option camera": "Optionale Kamera",
	"Option camera security": "Option Kamerasicherheit",
	"Resubscribe until_": "Erneut abonnieren bis: {{a}}",
	"Firmware Update Caution": "Sicherheitshinweis für Firmware-Update",
	"Please check below_": "Bitte überprüfen Sie die folgenden Bedingungen, bevor Sie die Firmware für DMC200 aktualisieren:",
	"The camera's Wi-Fi_": "Das WLAN der Kamera muss eingeschaltet sein.",
	"Check if your_": "Überprüfen Sie, ob das WLAN Ihrer Kamera eingeschaltet ist.",
	"DO NOT disconnect_": "Ziehen Sie während des Firmware-Updates das Koaxialkabel NICHT ab.",
	"The camera and_": "Kamera und DMC200 können beschädigt werden.",
	"DO NOT try_": "Versuchen Sie NICHT, andere Funktionen zu verwenden, bevor der Neustart der Kamera abgeschlossen ist.",
	"Expecially Reboot camera_": "Insbesondere der Neustart der Kamera und das Format der SD-Karte können entscheidend sein, um zwei Geräte zu trennen.",
	"Update anyway": "Trotzdem aktualisieren",
	"Invited on_2": "am {{Invited Date}} von Ihnen eingeladen. Halter",
	"BlackVue’s New firmware_": "Neue BlackVue-Firmware verfügbar",
	"valid thru_": "gültig bis: {{a}}",
	"Billed monthly": "Billed monthly",
	"90 minutes Live_": "90 minutes Live View / Live Event Upload*",
	"or 2+ videos_": "or 2+ videos in full resolution*",
	"1GB Free Month_": "1GB Free Month Trial",
	"Cancel anytime": "Cancel anytime",
	"8+ hours Live_": "8+ hours Live View / Live Event Upload*",
	"or 12+ videos_": "or 12+ videos in full resolution*",
	"15+ hours Live_": "15+ hours Live View / Live Event Upload*",
	"or 23+ videos_": "or 23+ videos in full resolution*",
	Popular: Popular$f,
	"For Power Users": "For Power Users",
	"Estimates based on_": "* Estimates based on 4.5MB per minute of Live View, Quick View remote playback, or Live Event Upload file, and 190MB per full original resolution video download or playback (at 25Mbps bitrate). Daily idle Cloud connection data usage: 20MB per 24 hours. Data usage is shared among all types of services (Live View, Live Event Upload, etc.).",
	"Balanced Plan": "Balanced Plan",
	"For Light Cloud_": "For Light Cloud Use",
	"Front security (Normal mode)": "Überwachung vorn (Normalmodus)",
	"Front security (Parking mode)": "Überwachung vorn (Parkmodus)",
	"BT (Parking mode)": "BT (Parkmodus)",
	"LTE (Parking mode)": "LTE (Parkmodus)",
	"Wi-Fi (Parking mode)": "WLAN (Parkmodus)",
	"Hand distraction": "Handablenkung",
	Mask: Mask$f,
	"Second drowsy is_": "Sekundenschlaf ist eine Schläfrigkeit, die innerhalb von 30 Sekunden nach der ersten Schläfrigkeit auftritt, die die Aufzeichnung des Live-Ereignis-Uploads gestartet hat.",
	"Second drowsy alert": "Sekundenschlaf-Alarm",
	"BlackVue sim card_": "Die BlackVue-Simkarte kann nur in Kanada und den USA verwendet werden.",
	"Global support is coming soon.": "Globale Unterstützung folgt in Kürze.",
	"The video file not found_": "Die Videodatei wurde nicht gefunden oder es gab ein Problem beim Abspielen. Bitte versuchen Sie es erneut.",
	"Start Voice Call": "Sprachanruf starten",
	"End Voice Call": "Sprachanruf beenden",
	"Voice call in use": "Sprachanruf läuft",
	"Enable microphone access_": "Aktivieren Sie den Zugriff auf das Mikrofon, um die Gegensprechfunktion zu nutzen. Rufen Sie die Seite mit den Browsereinstellungen auf, um auf Ihr Mikrofon zuzugreifen.",
	"You may need to_": "Möglicherweise müssen Sie diese Seite neu laden, damit die neuen Einstellungen wirksam werden.",
	"Eye status": "Augenstatus",
	"Start time of live event upload video": "Startzeit des Live-Ereignisses Video hochladen",
	"Left eye": "Linkes Auge",
	"Right eye": "Rechtes Auge",
	"Drowsy is occured when the driver close his/her eyes more then 1sec": "Schläfrigkeit liegt vor, wenn der Fahrer seine Augen länger als 1 Sekunde schließt.",
	"Driver's Left eye movements with blinking count and period": "Linke Augenbewegungen des Fahrers mit Blinzelzählung und Zeitraumzählung und Zeitraum",
	"Driver's Right eye movements with blinking count and period": "Rechte Augenbewegungen des Fahrers mit Blinzelzählung und Zeitraum",
	"Drowsy big data of the driver and after a Drowsy event occurs": "Big Data des Augenblinzelns des Fahrers nach dem Auftreten eines Schläfrigkeitsereignisses",
	"Sharing video to Event Map": "Video an die Ereigniskarte weitergeben",
	"Want to use a Voice call?": "Möchten Sie einen Sprachanruf verwenden?",
	"To use a voice call_": "Um einen Sprachanruf zu verwenden, starten Sie die Live-Ansicht neu und tippen Sie auf „Zulassen“.",
	"There is no_": "Es gibt noch keine freigegebenen Videos. \nDie Liste wird angezeigt, wenn sie freigegeben wird.",
	"Microphone blocked": "Mikrofon blockiert",
	"Want to center the map on your location?": "Möchten Sie die Karte auf Ihren Standort zentrieren?",
	"To let the app access your location_": "Damit die App auf Ihren Standort zugreifen kann, starten Sie Event Map neu und wählen Sie „OK“, wenn Sie dazu aufgefordert werden.",
	"Location access permission required": "Die Berechtigung zum Standortzugriff ist erforderlich.",
	"Are you sure you want_2": "Möchten Sie dieses Video wirklich aus der EREIGNISKARTE entfernen?",
	"Two-way voice_2": "Two-way voice communication / Voice Call",
	"Not supported by DR650GW and DR650S_": "Not supported by DR650GW and DR650S",
	"DR650S Series only_": "DR650S Series only",
	"Cancel download?": "Download abbrechen?",
	"Your download is not_": "Ihr Download ist nicht abgeschlossen. Möchten Sie den Download abbrechen?",
	"Continue download": "Download fortsetzen",
	"Cancel download": "Download abbrechen",
	"Share your video to the Event Map?": "Möchten Sie Ihr Video für die Ereigniskarte freigeben?",
	"Afterwards, according to the reaction to the video_": "Je nach Reaktion auf das Video kann es anschließend als beliebtes Video eingestuft und unter Beliebte Videos vorgestellt werden.",
	"Add hashtags and a brief description to describe your video.": "Fügen Sie Hashtags und eine kurze Beschreibung Ihres Videos hinzu.",
	"Would you like_": "Möchten Sie das Video für die Ereigniskarte freigeben?",
	"Successfully added video_": "Video erfolgreich zum Freigeben für die Ereigniskarte hinzugefügt!",
	"This video cannot_": "Dieses Video kann nicht freigegeben werden, da die GPS-Standortdaten für die Anzeige auf der Karte fehlen.",
	"This video is_": "Dieses Video wurde bereits zur Ereigniskarte hinzugefügt.",
	"Share to Event Map": "Für Ereigniskarte freigeben",
	"Describe in more_": "Beschreiben Sie ausführlicher, was in Ihrem Video geschieht (optional).",
	"Description(optional)": "Beschreibung (optional)",
	"Recording mode": "Aufnahmemodus",
	"Event triggers": "Ereignisauslöser",
	DMS: DMS$f,
	"Camera connectivity": "Kamera-Konnektivität",
	"If not allowed_2": "Wenn es nicht erlaubt ist, sind die Position und Geschwindigkeit Ihres Autos über die Cloud nicht abrufbar.",
	"Share Live View_": "Live-View-Video teilen",
	"Share Live View_2": "Live-View-Audio teilen",
	"Share camera profile": "Kameraprofil freigeben",
	"Parking impact": "Aufprall während des Parkens",
	"Parking events": "Parking Events",
	"Audio recording": "Audioaufnahme",
	"Toggle the mic_": "Mikrofon an-/ausschalten",
	"Full HD_": "Full HD @ 60fps + Full HD @ 30fps",
	"Video quality": "Videoqualität",
	Extreme: Extreme$f,
	"More video files": "Mehr Aufnahmedateien",
	"Fewer video files": "Weniger Aufnahmedateien",
	"Camera rotation": "Drehung Heckkamera",
	"Video overlay": "Videoüberlagerung",
	"Date & time display": "Datums- & Zeitanzeige",
	"Speed unit": "Geschwindigkeitseinheit",
	"Check the orientation_": "Überprüfen Sie die Ausrichtung der im Fahrzeug installierten Frontkamera. Wählen Sie die entsprechende Option, um die Videos in aufrechter Ausrichtung aufzunehmen.",
	"Rotate 180º": "Um 180º drehen",
	"Rear camera rotation": "Drehung Heckkamera",
	"Check the orientation_rear": "Überprüfen Sie die Ausrichtung der im Fahrzeug installierten Heckkamera. Wählen Sie die entsprechende Option, um die Videos in aufrechter Ausrichtung aufzunehmen.",
	"Mirror View": "Spiegelbildliche Ansicht",
	"Select Mirror View_": "Wählen Sie Spiegelbildliche Ansicht, um das Video horizontal zu spiegeln.",
	"Check the orientation_interior": "Überprüfen Sie die Ausrichtung der im Fahrzeug installierten optionalen Kamera. Wählen Sie die entsprechende Option, um die Videos in aufrechter Ausrichtung aufzunehmen.",
	"Display off": "Anzeige aus",
	"Explore crowd-sourced Events_": "Entdecken Sie auf der Karte von der Crowd bereitgestellte Ereignisse (Aufprall, Vollbremsung usw.), sehen Sie sich von der Community freigegebene Videos an und fügen Sie Ihre eigenen Ereignisse hinzu.",
	OFF: OFF$f,
	"Reboots once-a-day_": "Startet einmal täglich zur festgelegten Zeit im Parkmodus neu, um die Stabilität zu erhöhen.",
	"Set time": "Zeit einst.",
	"FW language": "Firmwaresprache",
	"Rear security_2": "Überwachung hinten",
	"Bluetooth (Parking mode)_2": "Bluetooth (Parkmodus)",
	"Failed to save_2": "Einstellung für Live-Ereignis-Upload konnte nicht gespeichert werden",
	"Event file will_": "Die Ereignisdatei wird automatisch unter Live-Ereignis-Upload gespeichert.",
	"An impact was_": "An Impact was detected during Parking Mode.",
	"When exiting Parking_": "Beim Beenden des Parkmodus meldet es die BlackVue, wenn im Parkmodus ein Aufprall erkannt wurde. \n\n Hinweise: \n Aufpralle lösen Ereignisvideos aus. Aufpralle innerhalb von 3 Minuten vor und nach Verlassen des Parkmodus werden ignoriert.",
	"Protect event files": "Ereignisdateien schützen",
	"Turning on this_": "Schalten Sie diese Option ein, um die letzten {{a}} Ereignisdateien vor dem Überschreiben durch Normalaufnahme- oder Parkaufnahme-Dateien zu schützen.",
	"Impact Events in_": "Impact Events in Normal(E) and Parking Mode(I)",
	"Manual Events_": "Manual Events (M)",
	"Once 50 Events_": "Zu den geschützten Dateien gehören: \n\nAufprallereignisse im Normal- (E) und Parkmodus (I) \nManuelle Ereignisse (M) \n\nNachdem {{a}} Ereignisse aufgezeichnet wurden, überschreiben neue Ereignisse die ältesten.",
	"Reckless driving unit": "Einheit für rücksichtsloses Fahren",
	"Hard acceleration Event": "Starke-Beschleunigung",
	Threshold: Threshold$f,
	"Triggers when the_": "Löst aus, wenn die Kamera eine Beschleunigung pro Sekunde feststellt, die über dem eingestellten Schwellenwert liegt.",
	"Triggers when the_2": "Löst aus, wenn die Kamera eine Geschwindigkeitsreduzierung feststellt, die über dem eingestellten Schwellenwert liegt.",
	"Hard braking Event": "Vollbremsung",
	"Triggers when more_": "Löst aus, wenn während der Fahrt eine Richtungsänderung von mindestens 60 Grad über dem eingestellten Schwellenwert innerhalb von 2 Sekunden festgestellt wird.",
	"Every event of DMC200_2": "Die DMS-Erkennungsfunktionen sind nur im Normalmodus aktiv. Wenn sie im Parkmodus mit Strom versorgt wird, zeichnet die DMS-Kamera nur Videos auf.",
	"The DMS system has_2": "Das DMS kombiniert eine Gesichtserkennungsbox für die Zustände “Erkannt”, “Nicht erkannt”, “Abgelenkt”, “Schläfrig”, “Maske ab” und eine Bewegungserkennungsbox für den Zustand “Ablenkung durch Hand”.",
	"One for face_": "One for face detection : Detected, Undetected, Distracted, Drowsy",
	"The other for_": "The other for motion detection",
	"On: Normal recording_": "On: Normal recording works while power is maintained in Parking Mode",
	"Off: DMS power_": "Off: DMS power off after 5 minutes when entering Parking Mode, Normal recording works until just before off",
	"Drowsy and Distracted_": "Drowsy and Distracted each have three sensitivity conditions.",
	"Please refer to_": "Please refer to the guide interface below.",
	Drowsiness: Drowsiness$f,
	"Drowsiness occurs when_": "Schläfrigkeit tritt auf, wenn der Fahrer beim Fahren beide Augen länger als 1 Sekunde schließt und 2 Sekunden lang gähnt.",
	"Distracted occurs when_": "Tritt auf, wenn der Kopf des Fahrers mehr als 50 Grad von der Vorderseite entfernt ist.",
	"A hand distraction_": "A hand distraction occurs when the driver removes one hand from the steering wheel. [*Smoking and phone calls may be suspected.]",
	"Mask off event_": "Mask-off event occurs in two ways. First is when the driver gets in the car without a mask. Second is when the driver takes their mask off",
	"High When the_": "High : When the driver closes their eyes for more than 1 second, it is considered drowsy driving.",
	"Middle When the_": "Medium : When the driver closes their eyes for more than 1.5 second, it is considered drowsy driving.",
	"Low When the_": "Low : When the driver closes their eyes for more than 2 second, it is considered drowsy driving.",
	"High If the_": "High : If the angle of the head is more than 50 degrees away from the front for 3 seconds, it is detected as Distracted.",
	"Middle If the_": "Medium : If the angle of the head is more than 50 degrees away from the front for 5 seconds, it is detected as Distracted.",
	"Low If the_": "Low : If the angle of the head is more than 50 degrees away from the front for 7 seconds, it is detected as Distracted.",
	Direct: Direct$f,
	"Camera Wi-Fi credentials": "WLAN-Zugangsdaten der Kamera",
	"Network name(SSID)": "Netzwerkname (SSID)",
	"Seamless pairing": "Seamless Pairing",
	Remote: Remote$f,
	"Hotspot settings": "Hotspot-Einstellungen",
	"Hotspot name": "Name des Hotspots (SSID)",
	"Hotspot name must_": "Hotspot name must be at least 5 characters long",
	"Public cameras may_": "Öffentliche Kameras können auf der Erkunden-Registerkarte oder der Weltkarte angezeigt werden.",
	"Hard Cornering Event": "Schnelle Kurvenfahrt",
	"Over speed_2": "Zu schnell",
	"Second drawiness alert": "Zweite Müdigkeitswarnung",
	"Low Voltage Warning_2": "Handablenkung",
	"(You)_2": "{{a}} (Sie)",
	"This video has been reported_": "Dieses Video wurde gemeldet und vom Administrator entfernt.",
	"Normal Mode recording": "Aufnahme im Normalmodus",
	"ON : the camera_": "AN: Die Kamera zeichnet kontinuierlich in einer Schleife auf.",
	"OFF : the camera_": "AUS: Die Kamera zeichnet während der Fahrt nur Ereignisvideos auf.",
	"In both modes_": "In beiden Modi löst die Erkennung eines Aufpralls die Aufzeichnung eines Ereignisvideos aus.",
	"Continuously records_": "Zeichnet kontinuierlich 1-Bild-pro-Sekunde-Videos von 1 Minute Länge auf, die einen Zeitraum von 30 Minuten abdecken.",
	"Choose detection regions_": "Sie können die Erfassungsbereiche auch so wählen, dass eine geringere Gefahr der Auslösung unerwünschter Bewegungsaufzeichnungen durch im Wind schwankende Bäume, weit entfernte bewegte Objekte usw. besteht.",
	"Your previous plan is expired.": "Ihr vorheriger Tarif ist abgelaufen.",
	"Upgrade the plan to restore the camera": "Upgraden Sie den Tarif, um die Kamera wiederherzustellen\n(%@)",
	"Remove from cloud": "Aus der Cloud entfernen",
	"Are you sure you want to Remove_": "Möchten Sie wirklich diese Kamera aus dem Cloud-Slot entfernen?",
	"Remove: It doesn’t mean_": "Entfernen: Das bedeutet nicht, dass die Daten der Kamera gelöscht werden, sondern dass ein zusätzlicher Slot für die Anzahl der Cloud-Kameras geschaffen wird.",
	"Now the camera is removed from cloud slot": "Die Kamera wurde aus dem Cloud-Slot entfernt.",
	"How to delete camera list": "So löschen Sie eine Kamera aus der Liste",
	Update: Update$f,
	"Camrea setting": "Kamera-Einstellung",
	"Notification setting": "Push-Benachrichtigungseinstellungen",
	"Driving reports": "Fahrbericht",
	"Cloud connection steps": "Vorgehen zur Cloud-Verbindung",
	"Download the BlackVue app to add a camera": "Laden Sie die BlackVue App herunter, um eine Kamera hinzuzufügen",
	"To see your camera in the BlackVue cloud viewer_": "Um Ihre Kamera auf dem BlackVue Cloud Viewer anzuzeigen, müssen Sie sie zuerst mit der Cloud verbinden. Richten Sie Ihre BlackVue-Kamera einfach ein und verbinden Sie sie mit der BlackVue App für iOS und Android mit der Cloud.",
	"Download the BlackVue app to see a Wi-Fi connected camera": "Laden Sie die BlackVue App herunter, um eine mit dem WLAN verbundene Kamera anzuzeigen",
	"BlackVue Cloud web viewer only supports_": "BlackVue Cloud Web Viewer unterstützt nur mit der Cloud verbundene Dashcams. Bitte laden Sie die BlackVue App herunter, um Ihre mit dem WLAN verbundene Dashcam anzuzeigen.",
	"You can restore the data if_": "Sie können die Daten wiederherstellen, wenn Sie die Kamera erneut unter demselben Konto registrieren. Wenn das Konto gelöscht wurde, sind Ihre Dateien verloren.",
	"How to add camera": "So fügen Sie eine Kamera hinzu",
	"Try to wait 2-3 minutes if you just registered the camera.": "Warten Sie 2-3 Minuten, wenn Sie die Kamera eben erst registriert haben.",
	"Try to check the Cloud Connection Settings again_": "Überprüfen Sie die Cloud-Verbindungseinstellungen erneut, wenn die Kamera immer noch nicht mit der Cloud verbunden ist.",
	"Motion Detection": "Bewegungserkennung",
	"Parking recordings occur_": "Parkaufzeichnungen werden ausgelöst, wenn eine sichtbare Bewegung erkannt wird.",
	"Motion Sensitivity": "Bewegungsempfindlichkeit",
	"Motion Detection Sensitivity": "Bewegungserkennungsempfindlichkeit",
	"Select Detection Region": "Erkennungsbereich wählen",
	"Speed alert_2": "Geschwindigkeitsalarm",
	"Live Event Upload_2": "Live Event Upload",
	"Beep Alert": "Signalton-Alarm",
	"Parking Impact History_": "Parkaufprallverlaufsalarm",
	"To register your_": "Um Ihre SOS-Taste zu registrieren, müssen Sie die BlackVue-App verwenden.",
	"SOS button on/off": "Status SOS-Taste",
	"File sharing to Event Map is_": "Die Dateifreigabe für Event Map ist derzeit nicht verfügbar. Bitte schauen Sie später noch einmal vorbei.",
	"Email Notifications": "email-Benachrichtigungen",
	"Push Notifications_2": "Push-Benachrichtigungen",
	"Optional Camera Rotation": "Option Kameraausrichtung",
	"Optional Camera Security": "Option Kamerasicherheit",
	Option: Option$f,
	"(Owner)": "{{a}} (Halter)",
	"SOS button": "SOS-Taste",
	"This video has been reported_bold": "Dieses Video wurde gemeldet und <b>vom Administrator entfernt.</b>",
	"Number of events_2": "Anzahl der Ereignisse",
	"My Shared Videos": "Meine freigegebenen Videos",
	"No Hashtags": "Keine Hashtags",
	"I have read and agree_": "Ich habe die Geschäftsbedingungen gelesen und stimme allen zu",
	"14 years old_": "Mindestens 14 Jahre alt",
	Required: Required$f,
	Optional: Optional$f,
	"Profile information_": "Die Profilinformationen können auf der Seite Kontoeinstellungen bearbeitet werden.",
	"Automatically Add Live_": "Automatisch Ereignis-Upload-Dateien zur Ereigniskarte freigeben",
	"You must be 14 years_": "Sie müssen mindestens 14 Jahre alt sein, um ein BlackVue-Konto zu erstellen",
	"Use 8 or more characters_": "Verwenden Sie mindestens 8 Zeichen und kombinieren Sie Buchstaben, Ziffern und Symbole",
	"Protected files include_": "Zu den geschützten Dateien gehören: <br/>ㆍAufprallereignisse im Normal- (E) und Parkmodus (I) <br/>ㆍManuelle Ereignisse (M) <br/><br/>Nachdem {{a}} Ereignisse aufgezeichnet wurden, überschreiben neue Ereignisse die ältesten.",
	"Protected files include": "Protected files include",
	"If you turn_": "Wenn Sie die Sprachführung ausschalten, sind auch die folgenden Listen ausgeschaltet.",
	"Live Event Upload_success": "Die Einstellungen für den Live-Ereignis-Upload wurden erfolgreich gespeichert.",
	"Video type": "Arten an Videos",
	"Notify the Owner": "Den Eigentümer zu benachrichtigen",
	"Adjusting the cut-off voltage_2": "Adjusting the cut-off voltage to a lower setting may result in your dash cam draining more power from your battery. This could result in warning messages of battery drain or affect other vehicle functions.\nPlease consult with your dealership before lowering the voltage.",
	Others: Others$f,
	"This video has been removed.": "Dieses Video wurde entfernt.",
	"Please assign cameras_": "Bitte weisen Sie dieser Gruppe Kameras zu.",
	"Are you running_": "Haben Sie keine Möglichkeit mehr, Wiedergaben anzusehen?",
	"Upgrade your plan_": "Upgraden Sie Ihren Tarif auf den Flottentarif, um unbegrenzte Wiedergabe und andere Funktionen, die nur in der Cloud verfügbar sind, zu genießen.",
	"Are you running_Liveview": "Haben Sie keine Zeit mehr, die Echtzeitanzeige anzusehen?",
	"Upgrade your plan_Liveview": "Upgraden Sie Ihren Tarif auf den Flottentarif, um unbegrenzte Echtzeitanzeige und andere Funktionen, die nur in der Cloud verfügbar sind, zu genießen.",
	Stay: Stay$f,
	"Go to Fleet Plan": "Zum Flottentarif",
	"It looks like the video file is being prepared. please try again later.": "Es sieht so aus, als ob die Videodatei vorbereitet wird. Bitte versuchen Sie es später erneut.",
	"Oops!": "Hoppla!",
	"Please back up_": "Bitte sichern Sie alle wichtigen Aufzeichnungen, bevor Sie diese Einstellung ändern.",
	"When you save_": "Wenn Sie die Einstellungen speichern, wird die microSD-Karte formatiert und alle Aufzeichnungen werden gelöscht, um einen stabilen Betrieb zu gewährleisten.",
	"This is an unregistered_": "Dies ist eine nicht registrierte E-Mail. Möchten Sie zur Seite Konto erstellen gehen?",
	"Camera name must_2": "Der Kameraname muss zwischen 5 und 32 Zeichen lang sein.",
	"G-sensor (Normal mode)": "G-Sensor (Normalmodus)",
	"G-sensor (Parking mode)": "G-Sensor (Parkmodus)",
	"Up & down": "Auf und ab",
	"Front & back": "Vorder- und Rückseite",
	"Rotate Video 180º": "Rotate Video 180º",
	Mask_2: Mask_2$f,
	"Priority event": "Priority Event",
	"There is no_camera": "There is no camera that your owner assigned to you.",
	"Camera SSID": "Camera SSID",
	"The BlackVue dashcam_2": "The BlackVue dashcam is not compatible with 5GHz wireless networks",
	"Driver detection box_2": "Driver Detection Box",
	"DMS camera recording_2": "DMS Camera Recording in Parking Mode",
	Low_2: Low_2$f,
	Medium_2: Medium_2$f,
	High_3: High_3$f,
	"Live Event Upload_3": "Live Event Upload",
	"Driving Impact": "Driving Impact",
	"Video source_2": "Video Source",
	"Front camera_2": "Front Camera",
	"Rear camera_2": "Rear Camera",
	"Optional Camera": "Optional Camera",
	"Motion Detection_2": "Motion Detection",
	"Rear camera stops_2": "Rear camera stops recording 5 minutes after entering Parking Mode. Recording restarts when entering normal mode.",
	"Passenger vehicle": "Passenger Vehicle",
	"Heavy vehicle": "Heavy Vehicle",
	Highest_3: Highest_3$f,
	Extreme_2: Extreme_2$f,
	"Less recording files": "Fewer Recording Files",
	"Camera rotation_2": "Camera Rotation",
	"Share camera profile_2": "Share Camera Profile",
	Private_2: Private_2$f,
	"BlackVue Live": "BlackVue Live",
	"Important All saved_": "Important! All saved videos are about to be deleted. Tap Cancel and back up important files if needed.",
	"Whenever saving settings_": "Whenever saving settings after changing the time zone, the SD card is initialized and all stored files are deleted.",
	"Do you want_": "Do you want to save your changes?",
	"No groups": "No groups",
	Lite: Lite$f,
	"USD per Camera": "USD per extra Camera",
	"up to Cameras": "up to Cameras",
	"All the P Plan_": "Alle Funktionen des <b>{{a}}</b>-Plans sowie:",
	"User Roles and Permissions": "Benutzerrollen und Berechtigungen",
	"Geofence Setup (Web) and alerts": "Geofence Setup (Web) and alerts",
	"N Times": "{{a}} Mal",
	"N Minutes": "{{a}} Minuten",
	"Emergency Alarm": "Notalarm",
	"Playback, Live View": "Wiedergabe, Live View",
	"Your driving record : Daily, Monthly": "Täglich, Monatlich",
	"Real-time Conversation": "Echtzeitgespräch",
	"Initiate a conversation_": "Initiieren Sie ein Gespräch mit dem Fahrer durch den Sprecher und das Mikrofon des Dashcam.",
	"Remote Voice Communication": "Remote -Sprachkommunikation",
	"See the last location_": "Sehen Sie sich den letzten Standort Ihrer Kamera an",
	"Check your cars_": "Überprüfen Sie die Echtzeit-GPS-Daten Ihres Autos auf einer Karte, um Ihr Fahrzeug zu lokalisieren und Informationen über den Status zu erhalten, z. B. ob Sie fahren oder geparkt sind, und der Geschwindigkeit.",
	"Supported models_": "* Unterstützte Modelle: S und frühe X -Serien -Modelle",
	"GPS Tracking &_": "GPS -Tracking und Video auf der Karte (Smart/Flotte)",
	"Track your cars_": "Verfolgen Sie den Standort und die Geschwindigkeit Ihres Autos auf der Karte!",
	"GPS Tracking: visualize_": "GPS -Tracking: Visualisieren Sie Ihr Fahrprotokoll auf der Karte.\nVideo auf Karte: Kontextinformationen anzeigen (Geschwindigkeit, Ereignistyp) und spielen Sie verwandte Videos direkt von der Karte ab.",
	"Visualize your cars_": "Visualisieren Sie die Position und Geschwindigkeit Ihres Autos auf der Karte!\n",
	"The feature enables_": "Die Funktion ermöglicht das Hochladen von Videoaufnahmen in die Cloud, einschließlich der 5 Sekunden vor einem Unfall.\n",
	"Camera profile setting": "Camera profile setting",
	"Are you running_Download": "Are you running out of chance to Download Video?",
	"Upgrade your plan_Download": "Upgrade your plan to Fleet Plan for Unlimited Download, and other Cloud -Exclusive features.",
	"This feature is available for Smart and Fleet_": "This feature is available for Smart and Fleet Plan subscribers only.",
	"Rear camera will keep_": "Die rückseitige Kamera stoppt die Aufnahme im Parkmodus, wenn der Temperaturstatus des Dashcams auf \"Hohe Temperatur\" geändert wird. Die rückseitige Kamera wird die Aufnahme wieder starten, nachdem der Temperaturstatus des Dashcams auf \"Normale Temperatur\" geändert wurde. (Achtung: Um die Elektronik zu schützen, könnte Blackvue aufgrund hoher Außentemperaturen herunterfahren.)",
	"Get Unlimited Cloud_": "Erhalten Sie unbegrenzte Cloud-Wiedergabe und verwalten Sie bis zu {{a}} Kameras.",
	"Up to N cameras_": "Up to {{a}} cameras (+ {{b}} USD Extra charge)",
	"N Minutes per Day": "{{a}} Minuten pro Tag",
	"Drowsiness sensitivity is_": "Die Schläfrigkeitsempfindlichkeit wird mit dem zuverlässigen BlackVue-Algorithmus über die Dauer des Augenblinzelns eingestellt. <br> <br> Die Empfindlichkeit für Abgelenktheit wird durch den Winkel der Kopfposition des Fahrers von der Blickrichtung nach vorn und die Dauer der Ablenkung bestimmt.",
	"Not available with this plan": "Not available with this plan",
	"The optional camera records_": "Die optionale Kamera zeichnet im Parkmodus auf",
	"Smart and Fleet_": "Smart and Fleet Plan<br/>subscribers only",
	"This feature is_smart": "This feature is available for Smart and Fleet Plan subscribers only.",
	"Camera Registration": "Kameraregistrierung",
	"Voice Call": "Voice Call",
	"N times per Month": "{{a}} times per Month",
	"Recommended for higher bitrate_": "Empfohlen für höhere Bitrate und bessere Videoqualität.",
	"Recommended for for better compatibility_": "Empfohlen für eine bessere Kompatibilität mit Desktop- und Mobilgeräten",
	"A minute of front camera_": "Geschätzte Dateigröße für 1 Minute Video (Frontkamera)",
	"Extreme(N Mbps): N MB_": "Extreme ({{ex1}}Mbps) : {{ex2}}MB\nHighest ({{ht1}}Mbps) : {{ht2}}MB\nHigh ({{hi1}}Mbps) : {{hi2}}MB\nNormal ({{no1}}Mbps) : {{no2}}MB",
	"File size information reflects_": "Die Dateigrößeninformationen spiegeln die maximal mögliche Größe wider, und die tatsächlichen Dateigrößen können von den Aufzeichnungsbedingungen abhängen.",
	Bitrate: Bitrate$f,
	"Connection has been_": "Die Verbindung ist verloren gegangen.\nWiederherstellung der Verbindung ...",
	"Unable to establish_": "Keine Verbindung mit der Kamera herstellen.\nBitte stellen Sie sicher, dass Ihr Gerät ordnungsgemäß verbunden ist, und versuchen Sie es erneut.",
	"Purchased by Payment Service": "Gekauft durch Zahlungsdienst",
	"Up to N Cameras": "Bis zu {{a}} Kameras",
	"Unlimited Live View": "Unbegrenzte Echtzeitanzeige",
	"N Days GPS Tracking": "{{a}} Tage GPS-Tracking",
	"Unlimited Playback and Download": "Unbegrenzte Wiedergabe und Download",
	hours: hours$f,
	"Live Event Upload or_": "Live-Event-Upload oder 12+ Videos in voller Auflösung",
	"During the usage period of the One Plan_": "Während der Nutzungsdauer des One Plan-Dienstes sind keine Änderungen am Abonnementplan möglich. Um zu einem anderen Plan zu wechseln, kontaktieren Sie bitte den BlackVue-Kundensupport, um das One Plan-Abonnement zu kündigen.",
	"Service Period (Include SIM Data)": "Servicezeitraum (inklusive SIM-Daten)",
	"Purchase the BlackVue One Package_": "Kaufen Sie das BlackVue One Package, um das One Plan ein Jahr lang kostenlos freizuschalten.",
	"3GB SIM Data Plan": "3GB SIM-Datenplan",
	"Unlimited Live View, Playback and Download": "Unbegrenzte Live-Ansicht, Wiedergabe und Download",
	"within data availability": "innerhalb der Datenverfügbarkeit",
	"The BlackVue One Plan is a 1-year_": "Das BlackVue One Plan ist ein einjähriger Cloud-Serviceplan, der ausschließlich beim Kauf eines BlackVue One Package erhältlich ist. Dieses Bundle enthält eine Dashcam, einen 1-Jahres-3GB/mo-Datenplan (für USA und Kanada) und einen 1-Jahres-Cloud-Serviceplan.",
	"The BlackVue One Package is available_": "Das BlackVue One Package ist ausschließlich im BlackVue Online-Shop erhältlich.",
	"Go to BlackVue Shop": "Zum BlackVue-Shop gehen",
	"Anonymous Cam": "Anonyme Kamera",
	"App only": "nur in der App",
	Expires: Expires$f,
	"N days remaining": "Noch {{a}} Tage übrig",
	"No action needed_": "<b>Keine Aktion erforderlich.</b> Der neue reduzierte Preis wird automatisch ab Ihrer nächsten Zahlung nach dem 13. September angewendet.",
	"The new reduced price_": "Der neue reduzierte Preis wird automatisch auf Ihr Konto angewendet.",
	"Smart Plan Subscriber?": "Smart Plan Abonnent?",
	"Fleet Plan Subscriber?": "Fleet Plan Abonnent?",
	"Please take a moment to_": "Bitte nehmen Sie sich einen Moment Zeit, um uns zu autorisieren, Ihr Konto zu migrieren.",
	"Starting from now and_": "<b>Ab sofort und bis zum 31. Oktober</b> können Sie uns durch <a href=\"https://form.jotform.com/232411253056041\" target=\"_blank\">Klicken dieses Links</a> und Eingabe Ihrer Fleet-Konto-E-Mail die Änderung für Sie vornehmen lassen. Bitte erlauben Sie uns etwas Zeit, um die Änderung zu bearbeiten. Alternativ können Sie Ihr bestehendes Konto kündigen und ab dem 13. September zu dem neuen Preis erneut abonnieren.",
	"Once activated_": "Einmal aktiviert, kann der One Plan nicht pausiert oder deaktiviert werden.",
	"Once the One Plan is activated_": "Nach Aktivierung des One Plans kann das One Package nicht erstattet werden.",
	"Up to N Cloud Camera Slot": "Bis zu {{a}} Cloud-Kamera-Steckplatz",
	"nGB of Cloud Storage": "{{a}}GB Cloud-Speicher",
	"Get started for free_": "Get started for free, no credit card required. Includes Alert Push Notifications, limited Remote Live View and cloud storage.",
	"The BlackVue One Plan is exclusively_": "The BlackVue One Plan is exclusively available through the purchase of a BlackVue One Package. 3GB/mo data plan is for US and Canada only. BlackVue Cloud’s Free Plan, Lite Plan (1~3) and Smart Plan (1~3) accounts can upgrade to One Plan. However, Lite Plan (4~15), Smart Plan (4~15) and Fleet Plan accounts can not be upgraded to One Plan.",
	"For N year": "For {{a}} year",
	"Included in the One Package": "Included in the One Package",
	"3GB SIM Data Plan for N year": "3GB SIM Data Plan for {{a}} year",
	"One Plan Cloud Service for N year": "One Plan Cloud Service for {{a}} year",
	"The BlackVue One Package includes_": "The BlackVue One Package includes all you need to enjoy BlackVue Cloud for a whole year!",
	"4K LTE Dash Cam_": "4K LTE Dash Cam, Cloud Service and Data Plan",
	"nGB included": "{{a}}GB included",
	"nGB per camera": "{{a}}GB per camera",
	"N Days Live Event Upload": "{{a}} Days Live Event Upload",
	"Up to N Dash Cameras": "Up to {{a}} Dash Cameras",
	"Step N/N": "Schritt {{a}}/{{b}}",
	"Cloud Connection": "Cloud-Verbindung",
	"To pair your dashcam": "Um Ihre Dashcam mit dem Akku zu koppeln, verbinden Sie sie bitte mit der Cloud.",
	Check: Check$f,
	"Unpair Battery": "Batterie entkoppeln",
	"Are you sure you want to unpair": "Möchten Sie diese Akku (%@) wirklich vom Kamera entkoppeln?",
	"Unpair: It doesn't mean": "Trennen: Es bedeutet nicht, dass die Daten des Akkus gelöscht werden.",
	"*The paired battery will": "*Der gepaarte Akku wird ebenfalls zusammen entfernt.",
	"Would you like to pair this": "Möchten Sie diese Batterie koppeln?",
	"Battery successfully paired": "Batterie erfolgreich verbunden.",
	"Now you can directly connect to": "Jetzt können Sie sich direkt von der Kamerliste mit dem Akku verbinden.",
	"Pairing failed": "Die Kopplung ist fehlgeschlagen. Bitte versuchen Sie es erneut.",
	"Battery Name": "Batteriename",
	"Capacity History": "Kapazitätsverlauf",
	"The graph displays capacity": "Das Diagramm zeigt einen ungefähren Batteriestand unter Verwendung von Daten aus der Cloud-Verbindung an.\n Die Batteriekapazität kann je nach Temperatur, Dashcam-Einstellungen und Häufigkeit der Auslösereignisse variieren.",
	"Last 24 Hours": "Letzte 24 Stunden",
	"Last 7 Days": "Letzte 7 Tage",
	"Battery Level": "Ladezustand",
	"Temperature History": "Temperaturverlauf",
	"The graph displays temperature": "Das Diagramm zeigt einen ungefähren Temperaturverlauf anhand von Daten aus der Cloud-Verbindung.",
	"Temperature Level": "Temperaturniveau",
	"Connecting alert": "[ Verbinden ]\nDaten angezeigt bei Verbindung.",
	"Low Output power Alert": "[ Abschaltung der Ausgangsleistung ]\nDie Ausgangsspannung ist zu niedrig und begrenzt die Stromversorgung des angeschlossenen Geräts.",
	"High temp Alert": "[ Eingangsspannung abgeschnitten ]\nDie Batterietemperatur ist zu hoch und begrenzt das Laden.",
	"Remaining time": "Verbleibende Zeit",
	"Remaining time estimate": "Die verbleibende Zeit ist eine Schätzung basierend auf dem Gesamtstromverbrauch der angeschlossenen Geräte.\n Sie wird alle 30 Sekunden nach dem Anschließen an die Batterie neu berechnet.",
	"Setting changed": "Einstellungsänderung",
	"Setting change failed": "Einstellungsänderung fehlgeschlagen",
	"Low Input power Alert": "[ Eingangsspannung abgeschnitten ]\nDie Ladespannung ist zu niedrig und begrenzt das Laden.",
	"High Input power Alert": "[ Eingangsspannung abgeschnitten ]\nDie Ladespannung ist zu hoch und begrenzt das Laden.",
	"Low temp_Cut off Alert": "[ Eingangsspannung abgeschnitten ]\nDie Batterietemperatur ist zu niedrig, was das Laden und die Betriebsdauer einschränkt.",
	"Low temp Alert": "[ Niedrige Temperatur ]\nDie Batterietemperatur ist zu niedrig, was die Betriebsdauer und die Ladegeschwindigkeit einschränkt.",
	"Low capacity Alert": "[ Niedrige Kapazität ]\nDie Batteriekapazität ist zu niedrig.\nFahren Sie das Auto, um es aufzuladen.",
	"Back to list": "Zurück zur Liste",
	Saving: Saving$f,
	Now: Now$f,
	"Power supplying is limited": "Die Stromversorgung ist <b>begrenzt</b>",
	"This battery is already paired": "Diese Batterie ist bereits gekoppelt.",
	"Connecting to Battery": "Verbindung zum Akku",
	"Paired battery": "Gekoppelte Batterie",
	"Battery unpairing failed": "Batterieentpaarung fehlgeschlagen. Bitte versuchen Sie es erneut.",
	"A connection is already active": "Eine Verbindung ist bereits aktiv. Bitte versuchen Sie es später erneut.",
	"Searching for battery": "Suche nach Batterie",
	"Select battery to pair with your camera": "Wählen Sie den Akku aus, der mit Ihrer Kamera gekoppelt werden soll.",
	"Unable to connect": "Verbindung nicht möglich",
	"A connection error has occurred": "Es ist ein Verbindungsfehler aufgetreten. Bitte versuchen Sie es erneut.",
	"The paired dashcam has been disconnected": "Die gepaarte Dashcam wurde von der Cloud getrennt.\nBitte überprüfen Sie die unten stehenden Bedingungen.",
	"Check if the battery is not fully discharged": "Überprüfen Sie, ob der Akku nicht vollständig entladen ist.",
	"Check the Cloud connection of the paired dashcam": "Überprüfen Sie die Cloud-Verbindung der gekoppelten Dashcam.",
	"Connection lost": "Verbindung verloren",
	"A connection error has occurred shortly": "Ein Verbindungsfehler ist aufgetreten. Bitte versuchen Sie in Kürze erneut zu verbinden.",
	"Charging is limited": "Das Laden ist <b>begrenzt</b>",
	"Cannot connect to the battery": "Kann keine Verbindung zur Batterie herstellen.",
	"Please check the Cloud connection of the camera": "Bitte überprüfen Sie die Cloud-Verbindung der Kamera.",
	"Charging complete in": "Laden abgeschlossen in %@",
	"Current Capacity": "Aktuelle Kapazität",
	"Output Voltage": "Ausgangsspannung",
	"Charging Voltage": "Ladespannung",
	Beep: Beep$f,
	"Battery Capacity": "Akkukapazität",
	"Battery connection failed": "Akku anschließen fehlgeschlagen",
	"Expansion battery": "Ersatzakku",
	"Make sure it is switched on and within range": "• Stellen Sie sicher, dass sie eingeschaltet ist und sich in Reichweite Ihres Handys befindet.",
	"Make sure it is not wirelessly connected to another device": "• Stellen Sie sicher, dass sie nicht drahtlos mit einem anderen Gerät verbunden ist.",
	"Detected batteries": "Erkannte Akkus",
	"Can't see your battery": "Können Sie Ihre Batterie nicht sehen?",
	"Download the Blackvue app to check": "Laden Sie die BlackVue-App herunter um Ihren Akku fernüberwachen zu können",
	"By Using the app": "Mit der App können Sie Ihr Armaturenbrett mit dem Akku verbinden und die Batteriekapazität über die Cloud überwachen. Nach dem Pairing können Sie die Batterie im BlackVue Cloud Viewer überprüfen.",
	Unpair: Unpair$f,
	"Occurs when the driver closes_": "Tritt auf, wenn der Fahrer beim Fahren beide Augen schließt",
	"Occurs when the driver's head_": "Tritt auf, wenn der Kopf des Fahrers mehr als 50 Grad von vorne entfernt ist.",
	"Only detects distraction above_": "Erkennt nur Ablenkungen über dem eingestellten Wert. Sie können die Einheit in 'Kameraeinstellungen > Ereignisauslöser > Einheit für rücksichtsloses Fahren' ändern.",
	"Occurs when the driver is not wearing_": "Tritt auf, wenn der Fahrer keinen Sicherheitsgurt trägt.",
	"Overlays a face detection box_": "Überlagert eine Gesichtserkennungsbox auf Live- und aufgezeichnete Aufnahmen der DMS-Kamera.",
	"Seat Belt": "Sicherheitsgurt",
	Detected: Detected$f,
	"No Seat Belt": "Kein Sicherheitsgurt",
	"Fatigue Risk Alert": "Ermüdungsrisiko-Warnung",
	"The time is synchronized_Email": "Die Zeit ist mit der Zeit in Ihren E-Mail-Benachrichtigungen synchronisiert.",
	"Sends an alert when drowsiness is_": "Sendet eine Warnung, wenn Schläfrigkeit nach der anfänglichen Schläfrigkeit erkannt wird.",
	"Data updates upon connection": "Daten werden bei Verbindung aktualisiert.",
	"Sends a notification if_": "Sendet eine Benachrichtigung, wenn Sie die 'Zeit einstellen' während der Fahrt überschreiten.",
	"Data updates Alert": "[ Verbinden ]\nDaten werden bei Verbindung aktualisiert.",
	"Cannot save settings": "Die Einstellungen können nicht gespeichert werden",
	"The time is synchronized_Push": "Die Zeit ist mit der Zeit in Ihren Push-Benachrichtigungen synchronisiert.",
	"The file has been overwritten or deleted": "Die Datei wurde überschrieben oder gelöscht.",
	"Box Pro Models Settings": "Box Pro Modelleinstellungen",
	"Push notifications can be configured_": "Push-Benachrichtigungen können in den Benachrichtigungseinstellungen der Kamera konfiguriert werden.",
	"Recording Video": "Videoaufnahme",
	"Cameras settings": "Kameraeinstellungen",
	"Please configure the settings": "Bitte konfigurieren Sie die Einstellungen",
	"Speed Priorities": "Geschwindigkeitsprioritäten",
	"Set Speed Priority": "Geschwindigkeitspriorität festlegen",
	"Geofence-enter": "Geozaun-Einfahrt",
	"Geofence-exit": "Geozaun-Ausfahrt",
	"Geofence-pass": "Geozaun-Vorbeifahrt",
	"Geofence-speed alert": "Geozaun-Geschwindigkeitsalarm",
	"Drive Position": "Fahrersitzposition",
	"Left-Hand Drive": "Linkslenker",
	"Right-Hand Drive": "Rechtslenker",
	"Please configure this setting_": "Bitte ändern Sie diese Einstellung, wenn der Fahrer nicht korrekt erkannt wird.",
	"A new feature in the BlackVue settings_": "In den BlackVue-Einstellungen wurde eine neue Funktion zum Synchronisieren der Kamerazeit hinzugefügt. Für eine genaue Zeiterfassung sollten Sie die Zeit Ihrer Kamera einmal synchronisieren.",
	"Feature location_": "Standort der Funktion:\nKameraeinstellungen > System > Zeitsynchronisierung",
	"Time Sync": "Zeitsynchronisierung",
	"You can sync the time between_": "Sie können die Zeit zwischen Ihrem Gerät und der BlackVue-Kamera synchronisieren. Zum Synchronisieren ist das Formatieren der SD-Karte erforderlich. Bitte sichern Sie vorab alle notwendigen Videos.",
	"Voice Alert": "Sprachalarm",
	"Provides a voice alert_": "Gibt eine Sprachanzeige von der Kamera aus und sendet eine Benachrichtigung, wenn Sie die festgelegte Zeit während der Fahrt überschreiten.",
	"Please enter a value": "Please enter a value.",
	"Notices & Notifications": "Nachrichten & Benachrichtigungen",
	"Only detects drowsiness above_": "Erkennt nur Müdigkeit über dem eingestellten Wert. Sie können die Einheit in 'Kameraeinstellungen > Ereignisauslöser > Einheit für rücksichtsloses Fahren' ändern.",
	Promotion: Promotion$f,
	Notice: Notice$f,
	"View More": "Mehr anzeigen",
	"Read More": "Weiterlesen",
	"Detection Box": "Erkennungsbox",
	"Seatbelt Detection Box": "Sicherheitsgurt-Erkennungsbox",
	"Drive Position Detection Box": "Fahrpositions-Erkennungsbox",
	"Fleet Subscription Promotion (50%)": "Flottenabonnement-Aktion (50 %)",
	"BlackVue Fleet Tracking exclusive features_": "Exklusive Funktionen von BlackVue Fleet Tracking für Power-User und Unternehmen (mehrere Benutzer und Kameras, Geofencing, Web Viewer usw.).",
	"Special Discount (50% off)": "Sonderrabatt (50 % Rabatt)",
	"*Promotion applied for 12 months": "*Die Aktion gilt für 12 Monate",
	"*Payment will be made starting next month.": "*Die Zahlung erfolgt ab nächstem Monat.",
	"[About using promotions]": "[Über die Verwendung von Werbeaktionen]",
	"The promotion is free for the first month_": "Die Aktion ist im ersten Monat kostenlos und wird dann ab dem Folgemonat für 12 Monate in Rechnung gestellt.",
	"For users with an existing Lite/Smart subscription_": "Für Benutzer mit einem bestehenden Lite/Smart-Abonnement müssen Sie Ihr bestehendes App-Abonnement separat kündigen, andernfalls kann es sein, dass Ihr bestehendes App-Abonnement Ihrem Konto belastet wird.",
	"Please be sure to cancel your app subscription_": "Bitte kündigen Sie Ihr App-Abonnement unbedingt innerhalb des kostenlosen Zeitraums. Doppelte Zahlungen werden nicht erstattet.",
	"You will be changed to Fleet Plan immediately_": "Sie werden sofort zum Flottenplan gewechselt, auch wenn die verbleibende Abonnementlaufzeit Ihres bestehenden Lite/Smart-Plans noch nicht abgelaufen ist.",
	"You can cancel Fleet Plan any time.": "Sie können den Flottenplan jederzeit kündigen.",
	"From February 2025, please go to the Fleeta service and use it.": "Sobald die Aktion storniert wird, wird sie nicht erneut angewendet.",
	"After promotion expires_": "Nach Ablauf der Aktion wird Ihr Abonnement automatisch mit der bestehenden Flottenplan-Abonnementgebühr verlängert.",
	"(Required) I have read the promotion instructions_": "(Erforderlich) Ich habe die Aktionsanweisungen gelesen und bin mit der Zahlung einverstanden.",
	"Upgrade to Fleet Plan immediately": "Steigen Sie sofort auf den Flottenplan um",
	"Important Notice:": "Wichtiger Hinweis:",
	"Switch of BlackVue Web Viewer to Fleeta Web Viewer": "Umstellung von BlackVue Web Viewer auf Fleeta Web Viewer",
	"To provide better features and quality_": "Um bessere Funktionen und Qualität zu bieten, wird der BlackVue-Webviewer-Dienst bald auf einen neuen Flotten-Webviewer-Dienst namens Fleeta umgestellt. Fleeta-Dienste stehen ausschließlich Fleet-Plan-Nutzern zur Verfügung. Der Fleeta-Dienst wird im März 2025 mit einer neuen exklusiven Fleeta-App eingeführt. Bitte besuchen Sie <a href=\"https://www.fleeta.io\" target=\"_blank\">fleeta.io</a>, um mehr zu erfahren.",
	"We kindly ask for your understanding_": "Wir bitten um Ihr Verständnis, da diese Änderung einem verbesserten Service dienen soll. Bei Fragen zu diesem Übergang können Sie sich gerne an unser CS-Center wenden.",
	"Don’t show this again for this month": "Diesen Monat nicht mehr anzeigen",
	"Fleet Plan Subscription Promotion": "Aktion für Flottenplan-Abonnements",
	"Period : December 2, 2024 ~ May 31, 2025": "Zeitraum: 2. Dezember 2024 bis 31. Mai 2025",
	"See more details": "Weitere Details anzeigen",
	"To continue improve quality and provide better service_": "Um die Qualität weiter zu verbessern und einen besseren Service zu bieten, wird unser BlackVue Web Viewer-Service bald auf einen exklusiven Flottenplan-Service umgestellt. Ab Ende März 2025 wird es nicht mehr kostenlos oder über andere Pläne verfügbar sein.",
	"We have prepared special discount offers for_": "Wir haben spezielle Rabattangebote für unsere bestehenden Web Viewer-Benutzer vorbereitet. Bitte überprüfen Sie die Details unten! Wir bitten Sie um Ihr Verständnis und Ihre Unterstützung bei der Umsetzung dieser Änderung, um einen besseren Service bieten zu können.\n",
	"*If you are subscribed in-app_": "*Wenn Sie ein In-App-Abonnement haben, stellen Sie bitte sicher, dass Sie Ihr In-App-Abonnement kündigen.",
	"Enjoy your BlackVue Cloud service with your dashcam.": "Genießen Sie Ihren BlackVue Cloud-Dienst mit Ihrer Dashcam.",
	"Available Cloud Camera slot(s)_": "Verfügbare Cloud-Kamera-Steckplätze: {{d}}",
	"Not eligible for the promotion.": "Nicht für die Aktion berechtigt.",
	"You have already used_": "Sie haben diese Aktion bereits genutzt. Sobald die Aktion storniert wurde, kann sie nicht erneut angewendet werden.",
	"Go to Cameras": "Gehen Sie zu Kameras",
	"Congratulations !": "Congratulations !",
	"Fleet Plan user": "Fleet Plan user",
	"Let your BlackVue monitor_": "Lassen Sie Ihr BlackVue Ihr Auto überwachen und Sie über Vorfälle informieren. Sobald ein Aufprall erkannt wird, sendet Ihr BlackVue eine Benachrichtigung zusammen mit einem Schnappschuss an Ihr Telefon.\n",
	"Live Event Upload feature automatically_": "Die Live-Event-Upload-Funktion lädt automatisch Videomaterial, einschließlich Aufnahmen aus der Zeit vor dem Unfall, in den BlackVue Cloud Storage hoch, um Ihre Videos sicher aufzubewahren!",
	"*Buffer time varies by model.": "*Pufferzeit variiert je nach Modell.",
	Explore: Explore$f,
	"Cloud Storage": "Cloud-Speicher",
	"My Cloud Cameras": "Meine Cloud-Kameras",
	"My Cloud Cameras Only": "Nur meine Cloud-Kameras",
	"BlackVue Live Camera": "BlackVue Live-Kamera",
	"*For BlackVue Live Cameras_": "*Für BlackVue Live-Kameras können nur Kameras, die in den Kameraeinstellungen als öffentlich freigegeben wurden, auf der Karte angezeigt werden.",
	"*Share Method_": "*Teilungsmethode: Kameraeinstellung > Datenschutz",
	"Once the promotion is canceled_": "Sobald die Aktion storniert wird, wird sie nicht erneut angewendet.",
	"It will show_": "Es wird hier auftauchen, sobald sie verfügbar sind.",
	"Deactivate Cloud": "Cloud deaktivieren",
	"Are you sure you want to deactivate_": "Sind Sie sicher, dass Sie Cloud für diese Kamera deaktivieren möchten?",
	"Deactivate : It doesn’t_": "Sie können die Cloud jederzeit aktivieren. Nach Abschluss der Deaktivierung kann die Kamera gelöscht werden.",
	Deactivate: Deactivate$e,
	"*If you made the payment through_": "*Wenn Sie die Zahlung über die App getätigt haben, starten Sie die App bitte neu.",
	"Connect Dashcam Locally (Wi-Fi)": "Dashcam lokal verbinden (WLAN)",
	"Cloud Connection Setting": "Cloud-Verbindungseinstellung",
	"Camera Profile": "Kameraprofil",
	"Camera Settings": "Kameraeinstellungen",
	"Format MicroSD Card": "microSD-Karte formatieren",
	"Remote Firmware Update": "Remote-Firmware-Update",
	"Remove from Cloud": "Aus der Cloud entfernen",
	"The location may not be accurate_": "Der Standort ist möglicherweise nicht genau, da die Kamera nicht mit der Cloud verbunden ist.",
	"The location of the camera cannot be found_": "Der Standort der Kamera kann nicht gefunden werden. Bitte überprüfen Sie die Cloud-Verbindungseinstellungen.",
	"Manage\nFLEETA Drive": "Verwalten\nFLEETA Speicher",
	"Cloud\nConnection": "Cloud\nVerbindung",
	"Available on FLEETA App": "Verfügbar in der FLEETA App",
	"Available for Cloud dashcam OR on FLEETA App.": "Verfügbar für Cloud-Dashcam ODER in der FLEETA-App.",
	"Get started with_": "Starten Sie mit einem kostenlosen 1-Monats-Test",
	"Experience all of_": "Erleben Sie alle Premium-Funktionen von FLEETA kostenlos während Ihrer 1-monatigen Testphase.\n\nKeine Verpflichtung—jederzeit kündbar",
	"Welcome to FLEETA Webviewer.": "Willkommen im FLEETA Webviewer.",
	"Let FLEETA get_": "Lassen Sie FLEETA Sie kennenlernen",
	"Help improve your_": "Helfen Sie, Ihre Erfahrung zu verbessern, indem Sie einige Details teilen",
	"Business Industry": "Geschäftszweig",
	"Vehicle & Cargo": "Fahrzeug & Fracht",
	Compliance: Compliance$f,
	"Would you like to skip?": "Möchten Sie überspringen?",
	"What is your business industry?": "In welcher Branche ist Ihr Unternehmen tätig?",
	"Transportation & Logistics": "Transport und Logistik",
	"Rental & Leasing": "Vermietung und Leasing",
	"Construction & Building": "Bau und Gebäude",
	"Government & Public": "Regierung und Öffentlichkeit",
	"Facility & Utility Management": "Anlagen- und Versorgungsmanagement",
	Manufacturing: Manufacturing$e,
	"Retail & Wholesale": "Einzelhandel und Großhandel",
	Emergency: Emergency$e,
	Security: Security$e,
	"How many employees do you need to manage?": "Wie viele Mitarbeiter müssen Sie verwalten?",
	"How many vehicles does your company operate?": "Wie viele Fahrzeuge betreibt Ihr Unternehmen?",
	"Why do you use a fleet tracking service?": "Warum nutzen Sie einen Flottenverfolgungsdienst?",
	"Route Tracking": "Routenverfolgung",
	"Real-time Monitoring": "Echtzeit-Überwachung",
	"Incident Detection & Check video": "Erkennung von Vorfällen und Videoüberprüfung",
	"Behavior Monitoring & Analysis": "Verhaltensüberwachung und Analyse",
	"Evaluation & Management": "Bewertung und Management",
	"Theft Prevention": "Diebstahlprävention",
	"Monitoring & Maintenance": "Überwachung und Wartung",
	"Verification & Management": "Verifikation und Management",
	"BlackVue App Use Only": "Nur für die Nutzung der BlackVue-App",
	"Your current plan allow_": "Ihr aktueller Tarif erlaubt die Nutzung der BlackVue-App. Um den Web Viewer zu nutzen, abonnieren Sie bitte den Flotten-Tarif (FLEETA).",
	"Learn more about the Fleet_": "Erfahren Sie mehr über den Flottenplan (FLEETA)",
	"Special Offer": "Sonderangebot",
	"For a limited time_": "Für kurze Zeit genießen Sie 50% Rabatt auf Ihr Flottenplan-Abonnement.",
	"See Discount Details": "Rabattdetails ansehen",
	"To subscribe to the Fleet_": "Um den Flottenplan zu abonnieren, bitte zuerst Ihr BlackVue-Abonnement in der App kündigen, um doppelte Gebühren zu vermeiden.",
	"Skip tour": "Tour überspringen",
	"In the cloud_": "In der Cloud-Umgebung können Sie über den FLEETA Web Viewer auf Wiedergabe, Live-Ansicht (einschließlich Multiansicht), Live-GPS und Berichte zugreifen.",
	"Cloud Storage is_": "Cloudspeicher ist der Ort, an dem Ihre hochgeladenen Videos sicher in der Cloud gespeichert werden. Laden Sie Ihre Videos hoch, um sie lange sicher aufzubewahren.",
	"Toggle to switch_": "Umschalten zwischen Karte / Liste",
	"In List View_": "In der Listenansicht können Sie Gruppen, Mitglieder und Firmware-Informationen auf einen Blick leicht einsehen und verwalten.",
	"What is Cloud Storage?": "Was ist Cloudspeicher?",
	"Cloud Storage Overview": "Übersicht über den Cloudspeicher",
	"Difference Between FLEETA_": "Unterschied zwischen FLEETA Speicher und Live-Event-Upload",
	"FLEETA Drive stores_": "FLEETA Speicher speichert Videos, die Sie manuell hochgeladen haben",
	"Live Event Upload automatically_": "Live-Event-Upload speichert automatisch Videos, wenn ein Ereignis eintritt.",
	"Live Event Upload videos_": "Videos von Live-Event-Upload haben eine Ablauffrist. Wenn Sie sie lange behalten möchten, verschieben Sie sie auf FLEETA Speicher.",
	"Note: SD Card_": "Hinweis: SD-Karten-Videos in Wiedergabe",
	"Videos stored on_": "Videos, die auf Ihrer SD-Karte gespeichert sind, können über das Wiedergabe-Menü aufgerufen werden.",
	"Set your image_": "Stellen Sie Ihr Bild mit dem bereitgestellten Rahmen ein. Sobald das Bild gespeichert ist, wird es auf der Kamerakarte und dem Kartenansichtssymbol angezeigt.",
	"*Only jpg and_": "*Nur jpg- und png-Dateien werden unterstützt.",
	"Set as default image": "Als Standardbild festlegen",
	"Camera Details": "Kameradetails",
	"IT & Telecommunications": "IT und Telekommunikation",
	"The name must_32": "Der Name muss zwischen 1 und 32 Zeichen lang sein.",
	"Unable to display the map.": "Karte kann nicht angezeigt werden.",
	"The camera location cannot be found_": "Der Kamerastandort kann aufgrund einer schlechten GPS-Verbindung nicht gefunden werden.",
	"Cloud Cameras": "Cloud-Kameras",
	"Want to unlock_": "Möchten Sie Flottenmanagement-Funktionen freischalten?",
	"*Web subscription only": "*Nur Web-Abonnement",
	"Uploads event_": "Lädt Ereignisvideos sofort beim Eintreten des Ereignisses in den Cloudspeicher hoch.",
	"Starts a conversation_": "Startet ein Gespräch mit dem Fahrer über den Lautsprecher und das Mikrofon der Dashcam.",
	"Remotely check_": "Überprüfen Sie den Batteriestatus und den Ladestand remote über die Cloud.",
	"Receive a voice_": "Erhalten Sie eine Sprachwarnung und Benachrichtigungen, wenn die Fahrzeit das Limit überschreitet.",
	"View your_": "Sehen Sie Ihr Fahrtenbuch auf der Karte an.",
	"View speed, event_": "Sehen Sie Geschwindigkeit, Ereignistyp und spielen Sie zugehörige Videos direkt auf der Karte ab.",
	"FLEETA Tracking exclusive_": "FLEETA Tracking bietet exklusive Funktionen sowohl für Power-User als auch für Unternehmen (Mehrere Benutzer und Kameras, Geofencing usw.).",
	"Cloud Cameras per Account": "Cloud-Kameras pro Konto",
	"Connect Dashcam Locally_": "Dashcam lokal verbinden (Wi-Fi) (Wiedergabe, Download, Live-Ansicht)",
	"Available with_": "Verfügbar mit BlackVue-Batterie",
	"Cloud Battery": "Cloud-Batterie",
	"Driving Reports": "Fahrberichte",
	"Video on Map": "Video auf der Karte",
	"Multi Live View (Fleeta Web Viewer)": "Multi Live-Ansicht (FLEETA Web Viewer)",
	"Enter a number": "Geben Sie eine Zahl ein",
	"Permission required.": "Berechtigung erforderlich.",
	"Please contact_": "Bitte kontaktieren Sie den Halter für Unterstützung.",
	"Access not available": "Zugriff nicht verfügbar.",
	"This file cannot be deleted now.": "Diese Datei kann jetzt nicht gelöscht werden.",
	"Please try again later.": "Bitte versuchen Sie es später noch einmal.",
	"Permission required.\nPlease_": "Berechtigung erforderlich.\nBitte kontaktieren Sie den Halter für Unterstützung.",
	"Cloud Storage is disconnected_": "Cloudspeicher ist getrennt. Bitte überprüfen Sie die Verbindung.",
	"Manage the plan_": "Den Plan zur Wiederherstellung der Kamera verwalten",
	"Notify the owner_": "Benachrichtigen Sie den Halter, um den Plan zu verwalten",
	"Access Restricted:_": "Zugriff Eingeschränkt: Abonnement Abgelaufen",
	"Access is currently_": "Der Zugriff ist derzeit aufgrund eines abgelaufenen Abonnements nicht verfügbar.",
	"Please contact your owner_": "Bitte kontaktieren Sie Ihren Halter, um dieses Problem zu lösen.",
	"Access will be_": "Der Zugang wird wiederhergestellt, sobald das Abonnement erneuert wird",
	"Cloud is disconnected_": "Cloudspeicher ist getrennt. \nBitte überprüfen Sie die Verbindung.",
	"Connect to Cloud with_": "Verbinden Sie sich mit Cloudspeicher über die FLEETA APP",
	"Using Wi-Fi Hotspot": "Nutzung des Wi-Fi-Hotspots",
	Important: Important$e,
	"Pre-Event buffer_": "Die Vor-Ereignis-Pufferaufzeichnung ist in diesem Modus deaktiviert.",
	"connectivity is_": "Die Konnektivität ist in diesem Modus eingeschränkt.",
	"video upload starts_": "Das Hochladen des Videos beginnt, nachdem die Aufnahme abgeschlossen ist.",
	"Power Saving": "Energieeinsparung",
	"In all modes_": "In allen Modi lösen erkannte Stöße Ereignisvideoaufzeichnungen aus.",
	"Battery Protection setting _": "Die Einstellung für Batterieschutz muss EINGESCHALTET sein.",
	"At least one of_": "Mindestens eine der folgenden Einstellungen muss aktiviert sein",
	or: or$e,
	"For BlackVue battery users": "Für BlackVue-Batterienutzer",
	"we recommend setting_": "Wir empfehlen, die Spannungsabschaltung auf den minimalen Wert einzustellen, um die Batterienutzung zu maximieren.",
	"No videos were found.": "Es wurden keine Videos gefunden.",
	"Try different filter_": "Versuchen Sie einen anderen Filter oder setzen Sie den Filter zurück.",
	"Not avaliable with_": "Nicht verfügbar mit der aktuellen Kamera",
	"Overlays a detection_": "Legt ein Erkennungsfeld über das Live- und aufgezeichnete Bildmaterial der DMS-Kamera.",
	"A minute of_": "Eine Minute Frontkamera-Video wird ungefähr",
	"System voice guidance": "System-Sprachführung",
	"Recording trigger": "Aufzeichnungsauslöser",
	"Remote Button (Optional)": "Fernbedienungsknopf (Optional)",
	"Remote button settings_": "Einstellungen für die Fernbedienungstasten können nicht über eine Cloud-Verbindung geändert werden. Um diese Einstellungen zu ändern, navigieren Sie zu Kamera > Lokal verbinden > Kameraeinstellungen.",
	"No Registered Device": "Kein registriertes Gerät",
	"Subscription process is complete": "Der Abonnementprozess ist abgeschlossen",
	"Now, go back to_": "Kehren Sie jetzt zur FLEETA-App zurück, loggen Sie sich in Ihr Konto ein und beginnen Sie, den Service zu genießen.",
	"You can check the upload progress": "Sie können den Upload-Fortschritt im Cloudspeicher > FLEETA Speicher Tab überprüfen.",
	"SIM card must be inserted in_": "Um die Cloud nutzen zu können, muss die SIM-Karte in die Kamera eingelegt sein.",
	"Active until:": "Aktiv bis:",
	Subscribe: Subscribe$e,
	"Camera PSN": "Kamera PSN",
	"BlackVue Sim Free Trial Started!": "Kostenlose Testversion von BlackVue Sim gestartet!",
	"Enjoy a free period to use your SIM_": "Genießen Sie einen kostenlosen Zeitraum, um Ihre SIM-Karte ohne Abonnement zu nutzen!",
	"You can stay connected during the trial_": "Sie können während der Testphase in Verbindung bleiben, aber denken Sie daran:",
	"Complete your subscription before the trial_": "Schließen Sie Ihr Abonnement ab, bevor die Testphase endet, um die SIM-Karte weiterhin nutzen zu können.",
	"If you don't subscribe by the end of the trial_": "Wenn Sie bis zum Ende der Testphase kein Abonnement abschließen, wird Ihr SIM-Dienst deaktiviert.",
	"Save Event Videos_": "Speichern Sie Veranstaltungsvideos in Echtzeit im Cloud-Speicher!",
	"Note: Deleting your account doesn’t cancel": "Hinweis: Das Löschen Ihres Kontos kündigt Ihr Abonnement nicht. Um zu kündigen, gehen Sie zu Konto > Abonnement im FLEETA Web-Viewer.",
	"Available only on FLEETA App for_": "Nur in der FLEETA App für dieses Modell verfügbar.",
	"The cloud is deactivated": "Die Cloud ist deaktiviert.",
	"Please add a camera with FLEETA_": "Bitte fügen Sie eine Kamera zur FLEETA APP hinzu, um diese Funktion zu nutzen.",
	"Upload videos to FLEETA_": "Laden Sie Videos auf FLEETA Speicher hoch und halten Sie sie sicher!",
	"You have no assigned camera_": "Sie haben keine zugewiesene Kamera.\nBitte kontaktieren Sie den Eigentümer, um eine Zuweisung anzufordern.",
	"Camera notification settings": "Kamera-Benachrichtigungseinstellungen",
	Vehicle: Vehicle$e,
	"App Download": "App herunterladen",
	"Have a problem with_": "Haben Sie ein Problem mit dem Abonnement?",
	"Restore Purchase": "Kauf wiederherstellen",
	"Battery Pairing": "Batteriekopplung",
	"Playback\nLive View": "Wiedergabe/\nLive-Ansicht",
	"Remote Playback": "Remote-Wiedergabe",
	"Cloud connection settings": "Cloud-Verbindungseinstellungen",
	"Go to settings": "Navigieren Sie zu Einstellungen",
	"Only cloud cameras that_": "Nur Cloud-Kameras, die Benutzer öffentlich teilen möchten, werden auf der Karte angezeigt.",
	"Live Broadcast Cameras": "Live-Übertragungskameras",
	"*Live Broadcast Cameras_": "*Live-Übertragungskameras sind Cloud-Kameras, die von Benutzern zur Übertragung eingestellt wurden.",
	"Only cloud cameras_": "Nur Cloud-Kameras, die Nutzer zur Übertragung auswählen, werden auf der Karte angezeigt."
};

var Dashboard$e = "Dashboard";
var Account$e = "Account";
var Help$e = "Help";
var Mac$e = "Mac";
var Windows$e = "Windows";
var Admin$e = "Admin";
var Driver$e = "Driver";
var Cameras$e = "Cameras";
var Manage$e = "Manage";
var Clear$e = "Clear";
var Show$e = "Show";
var GB$e = "{{a}}GB";
var _section$e = "section.";
var Name$e = "Name";
var Password$e = "Password";
var Cancel$e = "Cancel";
var Members$e = "Members";
var Groups$e = "Groups";
var Role$e = "Role";
var Group$e = "Group";
var Status$e = "Status";
var nPM$e = "{{a}}PM";
var nAM$e = "{{a}}AM";
var Newest$e = "Newest";
var Oldest$e = "Oldest";
var Accepted$e = "Accepted";
var Pending$e = "Pending";
var Expired$e = "Expired";
var All$e = "All";
var Delete_$e = "Delete {{a}}";
var Delete$e = "Delete";
var Rename$e = "Rename";
var Add$e = "Add";
var OK$e = "OK";
var Remove$e = "Remove";
var Files$e = "Files";
var Features$e = "Features";
var Settings$e = "Settings";
var Upload$e = "Upload";
var Privacy$e = "Privacy";
var Done$e = "Done";
var Subscription$e = "Subscription";
var Submasters$e = "admins";
var Users$e = "drivers";
var Change$e = "Change";
var Method$e = "Method";
var Details$e = "Details";
var Confirm$e = "Confirm";
var Address$e = "Address";
var Country$e = "Country";
var State$e = "State";
var ZIP$e = "ZIP";
var Pricing$e = "Pricing";
var Free$e = "Free";
var Smart$e = "Smart";
var Fleet$e = "Fleet";
var Subscrubed$e = "Subscribed";
var January$e = "January";
var February$e = "February";
var March$e = "March";
var April$e = "April";
var May$e = "May";
var June$e = "June";
var July$e = "July";
var August$e = "August";
var September$e = "September";
var October$e = "October";
var November$e = "November";
var December$e = "December";
var Blackvuecloud_$e = "www.blackvuecloud.com";
var Support$e = "Support";
var Community$e = "Community";
var FAQ$e = "FAQ";
var Developers$e = "Developers";
var Facebook$e = "Facebook";
var Twitter$e = "Twitter";
var Instagram$e = "Instagram";
var Youtube$e = "Youtube";
var Linkedin$e = "Linkedin";
var Downloads$e = "Downloads";
var Unauthorized$e = "Unauthorized";
var none$e = "none";
var Email$e = "Email";
var Customers$e = "Customers";
var Home$e = "Home";
var Plan$e = "Plan";
var New$e = "New";
var Unsubscribed$e = "Unsubscribed";
var Edit$e = "Edit";
var month$e = "month";
var months$e = "months";
var Continue$e = "Continue";
var Back$e = "Back";
var Master$e = "Owner";
var Develop$e = "Developers";
var $9$e = "$9";
var $15$e = "$15";
var $10$e = "$10";
var mo$e = "mo";
var City$e = "City";
var Charge$e = "Charge";
var subscribe$e = "Subscribe";
var search$e = "Search";
var invalid_number$e = "The card number is not a valid credit card number";
var invalid_expiry_month$e = "The card’s expiration month is invalid";
var invalid_expiry_year$e = "The card’s expiration year is invalid";
var invalid_cvc$e = "The card’s security code is invalid";
var incorrect_number$e = "The card number is incorrect";
var incomplete_number$e = "The card number is incomplete";
var incomplete_cvc$e = "The card’s security code is incomplete";
var incomplete_expiry$e = "The card’s expiration date is incomplete";
var expired_card$e = "The card has expired";
var incorrect_cvc$e = "The card’s security code is incorrect";
var incorrect_zip$e = "The card’s zip code failed validation";
var invalid_expiry_year_past$e = "The card’s expiration year is in the past";
var card_declined$e = "The card was declined";
var missing$e = "There is no card on a customer that is being charged";
var processing_error$e = "An error occurred while processing the card";
var Paypal$e = "Paypal";
var iOS$e = "iOS";
var Android$e = "Android";
var Total$e = "Total";
var And$e = "and";
var Camera$e = "Camera";
var Yes$e = "Yes";
var No$e = "No";
var News$e = "News";
var Notifications$e = "Notifications";
var MPH$e = "MPH";
var Firmware$e = "Firmware";
var Basic$e = "Basic";
var Resolution$e = "Resolution";
var Brightness$e = "Brightness";
var Recording$e = "Recording";
var Highest$e = "Highest";
var High$e = "High";
var Normal$e = "Normal";
var Sensitivity$e = "Sensitivity";
var Volume$e = "Volume";
var Close$e = "Close";
var Cloud$e = "Cloud";
var Public$e = "Public";
var Front$e = "Front";
var Rear$e = "Rear";
var Play$e = "Play";
var Stop$e = "Stop";
var Pause$e = "Pause";
var Time$e = "Time";
var System$e = "System";
var Event$e = "Event";
var Parking$e = "Parking";
var Color$e = "Color";
var Exit$e = "Exit";
var Save$e = "Save";
var Impact$e = "Impact";
var Unlimited$e = "Unlimited";
var Default$e = "Default";
var Version$e = "Version";
var Language$e = "Language";
var Notification$e = "Notification";
var Multiple$e = "Multiple";
var Range$e = "Range";
var Download$e = "Download";
var Manual$e = "Manual";
var Satellite$e = "Satellite";
var Tutorials$e = "Tutorials";
var Filter$e = "Filter";
var Sun$e = "Sun";
var Mon$e = "Mon";
var Tue$e = "Tue";
var Wed$e = "Wed";
var Thu$e = "Thu";
var Fri$e = "Fri";
var Sat$e = "Sat";
var Dates$e = "Dates";
var Routes$e = "Routes";
var Opacity$e = "Opacity";
var Entry$e = "Entry";
var Owner$e = "Owner";
var Undetected$e = "Undetected";
var Distracted$e = "Distraction";
var Drowsy$e = "Drowsy";
var Calling$e = "Calling";
var Smoking$e = "Smoking";
var Permissions$e = "Permissions";
var Private$e = "Private";
var Entering$e = "Entering";
var Exiting$e = "Exiting";
var Acceleration$e = "Hard Acceleration";
var Passing$e = "Passing";
var Overspeed$e = "Overspeed";
var Recipients$e = "Recipients";
var Send$e = "Send";
var Note$e = "Note";
var Video$e = "Video";
var Advanced$e = "Advanced";
var Voice$e = "Voice";
var Days_$e = "Days";
var Mute$e = "Mute";
var UnMute$e = "UnMute";
var Discard$e = "Discard";
var Report$e = "Report";
var Individual$e = "Individual driver looking for peace of mind? Business owner in need of a simple vehicle security and tracking solution?";
var Subscribed$e = "Subscribed";
var Geofence$e = "Geofences";
var Driving$e = "Driving";
var Idling$e = "Idling";
var Distance$e = "Distance";
var Parked$e = "Parked";
var Speed$e = "Speed";
var Highest_2$e = "Highest";
var Average$e = "Average";
var Geofences$e = "Geofences";
var Move$e = "Move";
var Connected$e = "Connected";
var Individual_$e = "Individual";
var Always$e = "Always";
var Low$e = "Low";
var Medium$e = "Medium";
var High_2$e = "High";
var Flip$e = "Flip";
var Previous$e = "Previous";
var Next$e = "Next";
var Expand$e = "Expand";
var Collapse$e = "Collapse";
var More$e = "More";
var Multi$e = "Multi";
var Safe$e = "Safe";
var Reckless$e = "Reckless";
var Inattentive$e = "Inattentive";
var List$e = "List";
var Usage$e = "Usage";
var Profile$e = "Profile";
var Fullscreen$e = "Fullscreen";
var Upgrade$e = "Upgrade";
var Management$e = "Management";
var Day$e = "Day";
var Month$e = "Month";
var Later$e = "Later";
var ICCID$e = "ICCID";
var Resubscribe$e = "Resubscribe";
var plan$e = "plan";
var USD$e = "USD";
var etc_$e = "etc :";
var Available$e = "Available";
var Used$e = "Used";
var Cancelled$e = "Cancelled";
var Terminated$e = "Terminated";
var Sort$e = "Sort";
var Bonus$e = "Bonus";
var incomplete_zip$e = "The card's zip code failed validation";
var Upgrades$e = "Upgrades";
var OR$e = "OR";
var Undo$e = "Undo";
var Invoice$e = "Invoice";
var data$e = "data";
var Popular$e = "Popular";
var Mask$e = "Mask Off";
var DMS$e = "Driver Monitoring System (DMS)";
var Extreme$e = "Extreme";
var OFF$e = "OFF";
var Threshold$e = "Threshold";
var Drowsiness$e = "Drowsiness";
var Direct$e = "Direct";
var Remote$e = "Remote";
var Update$e = "Update";
var Option$e = "Option";
var Required$e = "Required";
var Optional$e = "Optional";
var Others$e = "Others";
var Stay$e = "Stay";
var Mask_2$e = "Mask";
var Low_2$e = "Low";
var Medium_2$e = "Medium";
var High_3$e = "High";
var Highest_3$e = "Highest";
var Extreme_2$e = "Extreme";
var Private_2$e = "Private";
var Lite$e = "Lite";
var Bitrate$e = "Bitrate";
var hours$e = "hours";
var Expires$e = "Expires";
var Check$e = "Check";
var Saving$e = "Saving";
var Now$e = "Now";
var Beep$e = "Beep";
var Unpair$e = "Unpair";
var Detected$e = "Detected";
var Compliance$e = "Compliance";
var Promotion$e = "Promotion";
var Notice$e = "Updates";
var Explore$e = "Explore";
var en = {
	Dashboard: Dashboard$e,
	"Payment & Subscriptions": "Payment & Subscriptions",
	"Fleet Management": "Fleet Management",
	"Available to master": "Available to Owner",
	"Available to Fleet_": "Available to Fleet Plan users",
	Account: Account$e,
	"Log out": "Log out",
	"© 2019 Pittasoft_": "© 2019 Pittasoft Co. Ltd",
	"Privacy policy": "Privacy policy",
	"Terms of service": "Terms of service",
	Help: Help$e,
	"App store": "App Store",
	"Google Play": "Google Play",
	Mac: Mac$e,
	Windows: Windows$e,
	"Free Plan": "Free Plan",
	"Basic Plan": "Basic Plan",
	"Smart Plan": "Smart Plan",
	Admin: Admin$e,
	Driver: Driver$e,
	"Period : December 3, 2024 ~ May 31, 2025": "Period : December 3, 2024 ~ May 31, 2025",
	Cameras: Cameras$e,
	"n of n": "{{a}} of {{b}}",
	Manage: Manage$e,
	"Upgrade Plan": "Upgrade Plan",
	"Add more cameras_": "Add more cameras, manage your fleet, and more…",
	"Usage statistics": "Usage statistics",
	"All cameras": "All cameras",
	Clear: Clear$e,
	Show: Show$e,
	"Live views": "Remote Live View",
	"nh:nm:ns": "{{a}}h:{{b}}m:{{c}}s",
	"Video plays and_": "Video plays and downloads",
	"Space available": "Space available",
	GB: GB$e,
	"n%": "{{a}}%",
	"BlackVue app for_": "BlackVue app for iOS and Android",
	"BlackVue viewer for_": "BlackVue viewer for Mac and Windows",
	"Welcome to fleet": "Welcome to fleet",
	"A few things_": "A few things you can expect along the way:",
	"You can watch_": "You can watch videos from the cameras you were assigned to in the BlackVue app or desktop viewer.",
	"If the master_deletes": "If the owner deletes his account, your account will be deleted as well.",
	"If the masters_Fleet": "If the owner's Fleet Plan subscription expires, you'll still be able to access your account in read-only mode.",
	"You have to_": "You have to register a different account to add a personal camera.",
	"The Payments &_": "The Payments & Subscriptions and Fleet Management sections are only available to the owner.",
	"You can manage_": "You can manage your fleet group in the",
	"_Fleet management": "Fleet Management",
	_section: _section$e,
	"The Payments_section-": "The Payments & Subscriptions section is only available to the owner.",
	"Youre almost there": "You're almost there",
	"Finish account setup": "Finish account setup",
	"Install and log_": "Install and log in to BlackVue App or Desktop Viewer",
	"Download on the_": "Download on the App Store",
	"GET IT ON_": "GET IT ON Google Play",
	"Download for Mac": "Download for Mac",
	"Download for Windows": "Download for Windows",
	"Add your camera_": "Add your camera in the BlackVue App or Desktop Viewer",
	"Start managing your_": "Start managing your fleet and following usage stats here",
	"Cancelled Fleet Plan_": "Cancelled Fleet Plan on {{date}}",
	"The new plan_": "The new plan will be effective at the end of your current billing cycle.",
	"Profile photo": "Profile photo",
	Name: Name$e,
	"E-mail address": "Email address",
	Password: Password$e,
	"Last changed_": "Last changed {{a}}",
	"Change password": "Change password",
	"Delete account": "Delete account",
	Cancel: Cancel$e,
	"Current password": "Current password",
	"New password": "New password",
	"Confirm new password": "Confirm new password",
	"Password changed": "Password changed",
	"Reason for deletion_": "Reason for deletion (optional)",
	"Account password": "Account password",
	Members: Members$e,
	Groups: Groups$e,
	"+ Invite member": "+ Invite member",
	"Name, Email": "Name, Email",
	Role: Role$e,
	Group: Group$e,
	"Date invited": "Date invited",
	Status: Status$e,
	"Group n": "Group {{a}}",
	nPM: nPM$e,
	nAM: nAM$e,
	Newest: Newest$e,
	Oldest: Oldest$e,
	"Name, email or_": "Name, email or group",
	Accepted: Accepted$e,
	Pending: Pending$e,
	Expired: Expired$e,
	All: All$e,
	"No results": "No results",
	"Try different keywords": "Try different keywords",
	"Try changing or_": "Try changing or removing filters",
	"Remove all filters": "Remove all filters",
	"Invite member": "Invite member",
	"Send invite": "Send invite",
	"You have reached_": "You have reached the 10 admin limit. You can continue inviting drivers.",
	Delete_: Delete_$e,
	"Are you sure_delete": "Are you sure you want to delete this member and his account?",
	Delete: Delete$e,
	Rename: Rename$e,
	"No submaster yet": "No admin yet",
	"You can add_": "You can add 1 admin per group",
	"No cameras yet": "No cameras yet",
	"Add cameras first_": "Add cameras first, assign drivers afterwards",
	"Name or email": "Name or email",
	"Add submaster": "Add admin",
	Add: Add$e,
	"Add camera": "Add camera",
	"n of n selected": "{{a}} of {{b}} selected",
	"No cameras available": "No cameras available",
	"Most likely reasons_": "Most likely reasons for that:",
	"All cameras were_": "All cameras were added to other groups.",
	"You can remove_": "You can remove cameras from other gorups and add them to this group.",
	"No cameras were_": "No cameras were added to your account.",
	"You can add_cameras": "You can add cameras in the BlackVue app or desktop viewer.",
	OK: OK$e,
	"Rename group": "Rename group",
	"Are you sure_group": "Are you sure you want to delete this group?",
	"Edit Mobile app_": "Edit Mobile app/desktop viewer Permissions",
	Remove: Remove$e,
	"n of n users": "{{a}} of {{b}} drivers",
	"Youve reached the_": "You've reached the driver limit per camera",
	"Remove user": "Remove driver",
	"Add user": "Add driver",
	"+ Add group": "+ Add group",
	"Add group": "Add group",
	"Group or submaster": "Group or admin",
	"+ Add": "+ Add",
	"of max selected": "{{a}} of max {{b}} selected",
	"Mobile app/desktop_": "Mobile app/desktop viewer Permissions",
	Files: Files$e,
	Features: Features$e,
	Settings: Settings$e,
	Upload: Upload$e,
	"Download and Playback_Cloud": "Download and playback from Cloud storage",
	"Download and Playback_SD": "Download and Playback from SD Card",
	"Live view": "Live View",
	"Geo Fencing": "Geofencing",
	"Drive Reports": "Drive reports",
	"Firmware Settings": "Firmware settings",
	"Push Notifications": "Push notifications",
	"Event Auto Upload": "Live auto upload",
	Privacy: Privacy$e,
	Done: Done$e,
	"Payment method": "Payment method",
	"Change payment method": "Change payment method",
	Subscription: Subscription$e,
	"Space used": "Space used",
	"Next billing_": "Next billing {{a}} {{b}}",
	"You manage_available": "You manage {{a}} of {{b}} available on your plan",
	Submasters: Submasters$e,
	Users: Users$e,
	Change: Change$e,
	"No transactions yet_": "You are subscribed to the Free Plan. No transactions yet",
	"No transactions to_": "No transactions to show.<br/>If you are looking for other platforms (ex. iOS, Android, PayPal) transaction history, You can find the history at your own platform’s subscription page.",
	"of nGB_": "{{a}} of {{b}}GB ({{c}}%)",
	"Smart Plan users_": "Smart Plan users can change the subscription plan or the number of cameras via BlackVue mobile app",
	"Transaction history": "Transaction history",
	"Date": "Date",
	"Amount, USD": "Amount, USD",
	Method: Method$e,
	Details: Details$e,
	"iOS in-app_": "iOS in-app purchase/Android in-app purchase",
	"Change the number_": "Change the number of cameras",
	"You manage_cameras": "You manage {{a}} cameras of {{b}} available on your plan",
	"Extra cameras": "Extra cameras",
	"Total due_": "Total due",
	"available on your_": "of {{a}} available on your plan",
	"Cancel Fleet Plan": "Cancel Fleet Plan",
	"This will cancel_": "This will cancel your Fleet Plan subscription. You will downgrade to the Free Plan at the end of your billing cycle.",
	"Reason for cancellation_": "Reason for cancellation (optional)",
	"Not now": "Not now",
	Confirm: Confirm$e,
	"Cardholder name": "Cardholder name",
	"Card name": "Card name",
	"MM/YY": "MM/YY",
	Address: Address$e,
	Country: Country$e,
	State: State$e,
	ZIP: ZIP$e,
	Pricing: Pricing$e,
	"You are subscribed_": "You are subscribed to the Free Plan.",
	"With Alert Push_": "With Alert Push Notifications, limited Remote Live View and cloud storage.",
	Free: Free$e,
	Smart: Smart$e,
	Fleet: Fleet$e,
	"Get started for_": "Get started for free, no credit card required. \n Includes Alert Push Notifications, limited Remote Live View and cloud storage.",
	Subscrubed: Subscrubed$e,
	"Features included:": "Features included:",
	"Get unlimited Remote_": "Get unlimited Remote Live View and Cloud playback and manage up to {{a}} cameras.",
	"BlackVue Fleet Tracking_": "BlackVue Fleet Tracking exclusive features for power users and businesses alike (Multiple users and cameras, geofencing, etc.)",
	"Try 1 Month Free": "Try 1 Month Free",
	"Log in": "Log in",
	"Remember me": "Remember me",
	"Forgot password?": "Forgot password?",
	"Reset password": "Reset Password",
	"Enter email address_": "Enter email address used during registration and \nwe will send you a link to reset your password.",
	"Send reset password_": "Send reset password email",
	"Back to login": "Back to login",
	"Check your email": "Check your email",
	"Weve sent an_": "We've sent an email to {{a}} with a link to confirm\nyour email address. For security reasons, the link in the email will expire after one hour.",
	"Resend email": "Resend email",
	January: January$e,
	February: February$e,
	March: March$e,
	April: April$e,
	May: May$e,
	June: June$e,
	July: July$e,
	August: August$e,
	September: September$e,
	October: October$e,
	November: November$e,
	December: December$e,
	"Sign up": "Create account",
	"First name": "First name",
	"Last name": "Last name",
	"Create a password": "Create a password",
	"5 or more_": "5 or more characters",
	"Sign up and_": "Sign up and continue",
	"I agree to_": "I agree to the %@, %@, %@ and %@.",
	"Subscribe to newsletter": "Keep me posted on the latest BlackVue news, product features and software updates.",
	"1 month free trial_": "1 month free trial",
	"Dont have an_": "Don't have an account?",
	"Thank you for_": "Thank you for signing up to BlackVue Cloud. Please confirm your email address.",
	"Confirm email": "Confirm email",
	"If you didnt_": "If you didn't sign up for this account you can ignore this email.",
	Blackvuecloud_: Blackvuecloud_$e,
	"invited you to_": "{{a}} invited you to join his fleet as a admin.",
	"Accept invitation": "Accept invitation",
	"Invite expires on_": "Invite expires on mm dd, yy.",
	"Your Fleet Management_": "Your Fleet Management account registered with {{a}} was deleted by %@.",
	"If you believe_": "If you believe this is an error, please contact our customer support: cs@blackvue.com.",
	Support: Support$e,
	"Help center": "Help center",
	Community: Community$e,
	"Getting started": "Getting started",
	FAQ: FAQ$e,
	Developers: Developers$e,
	"Cloud API": "Cloud API",
	"Fleet SDK": "Fleet SDK",
	"Follow us": "Follow us",
	Facebook: Facebook$e,
	Twitter: Twitter$e,
	Instagram: Instagram$e,
	Youtube: Youtube$e,
	Linkedin: Linkedin$e,
	"BlackVue apps": "BlackVue apps",
	"Camera registraiton": "Camera registraiton",
	"Two-way voice_": "Two-way Voice Communication",
	"Live GPS": "Live GPS",
	"Event live auto_": "Event live auto upload",
	"Event file auto_": "Event file auto upload",
	"Compatible with_": "Compatible with DR650GW, DR650S models",
	"Not compatible with_": "Not compatible with DR650GW, DR650S models",
	"More cameras": "More cameras",
	"More users": "More users",
	"Roles and permissions": "Roles and permissions",
	"More Cloud Storage": "More Cloud Storage",
	"Multi Live view_": "Multi Live View (Web)",
	"Longer GPS Tracking": "Longer GPS Tracking",
	"Geo Fence setup_": "Geo Fence setup (PC viewer) and alerts (PC viewer and app)",
	"Changes saved": "Changes saved",
	"Group added": "Group added",
	"Member added": "Member added",
	"Group deleted": "Group deleted",
	"Member deleted": "Member deleted",
	"Group renamed": "Group renamed",
	"Submaster added": "Admin added",
	"Camera added": "Camera added",
	"User added": "Driver added",
	"Users added": "Drivers added",
	Downloads: Downloads$e,
	"The BlackVue App_": "The BlackVue App and Viewer let you use your BlackVue camera to its full potential. Whether on mobile or on home computer, BlackVue gives you the tools to fully enjoy your dashcam's functions.",
	"Compatible with all_": "Compatible with all Wi-Fi enabled BlackVue models.",
	"Supports all BlackVue_": "Supports all BlackVue models to date.",
	"confirm new password": "Confirm new password",
	"Your password is_": "Password you entered is incorrect",
	"Confirm password does_": "Password doesn’t match",
	"Please enter_email": "Please enter a valid email address.",
	"Please enter_password": "Password you entered is incorrect",
	"Internal server error_": "Internal server error. please try again.",
	"New password is_": "At least 1 character should be different from your current password",
	"It should be_": "Password should be 5 or more characters",
	"Invalid permission": "Invalid permission.",
	"Input data isnt_": "Input data isn't available.",
	Unauthorized: Unauthorized$e,
	"Already have subsciption": "Already have subscription",
	"Already uses": "Already uses",
	"Already logged in": "Already logged in",
	"Already sent e-mail": "Already sent email.",
	"Please wait": "Please wait.",
	"E-mail is not_": "Email is not verified yet.",
	"Update your subscription_": "Update your subscription",
	"Account was deleted": "Account was deleted.",
	"5 ~ 30_": "5 ~ 30 characters",
	"It has exceeded_": "It has exceeded the maximum 9 Admins.",
	"Billing information": "Billing information",
	"Please enter cardName": "Enter card name",
	"Please enter_card": "Enter a valid card number",
	"Please enter address": "Enter address",
	"Please select country": "Select country",
	"Please enter city": "Enter the city",
	none: none$e,
	"Due today": "Due today",
	"Today after 1_": "Today after 1 month trial",
	"An error occurred_": "An error occurred while trying to change the password. Try again.",
	"Your account is_": "Your account is now active",
	"You can now_": "You can now log into your account with the email address used during registration.",
	Email: Email$e,
	"Don’t have an account?": "Don’t have an account?",
	"Already have an account?": "Already have an account?",
	"Cloud service": "Cloud service",
	"for your BlackVue": "for your BlackVue",
	"See what your_": "See what your camera sees remotely.",
	"Receive impact alert_": "Receive Impact alert push notifications.",
	"Save footage to_": "Save footage to the cloud and do much more...",
	"Free plan included_": "Free plan included · Easy setup · Cancel anytime",
	"Taking advantage of_": "Taking advantage of a mobile or car-embedded Internet connection and a BlackVue camera, BlackVue Cloud connects you to your car from anywhere, anytime. Using the BlackVue App on your smartphone or tablet, you see in real time where your car is located and what is happening around it.",
	"Get notifications to_": "Get notifications to your phone when your parked car is hit. Check remotely what is happening around your car.",
	"Monitor your commercial_": "Monitor your commercial vehicles on a map in real time. Talk to your drivers anytime through the BlackVue App or Viewer.",
	"With BlackVue Fleet_": "With BlackVue Fleet Tracking, track in real time up to 100 vehicles from the palm of your hand or with the dedicated BlackVue Viewer.",
	"Get started now_": "Get started now with a Free plan. For unlimited video playback or Remote Live View, upgrade to Lite or Smart plan from the BlackVue App. <br/>Business and power users can unlock the power of the Fleet plan exclusively through this website.",
	"Remote Video Playback_": "Remote Video Playback and Download",
	"Compatible with DR650GW_": "Compatible with DR650GW, DR650S models",
	"Unlimited remote video_": "Unlimited remote video playback and download",
	"Longer cloud storage_": "Longer cloud storage file expiration period",
	"Longer storage period_live": "Longer storage period for Event live auto upload",
	"Longer storage period_file": "Longer storage period for Event file auto upload",
	"Goefence setup (PC_": "Geo-fence setup (PC viewer) and alerts (Windows viewer and app)",
	"App Store": "App Store",
	"Send reset password email": "Send reset password email",
	Customers: Customers$e,
	Home: Home$e,
	"Pick a plan": "Pick a plan",
	"No customers yet": "No customers yet",
	"Customers will_": "Customers will show up here as they become available",
	"Add customer": "Add customer",
	"Report(PDF)": "Report(PDF)",
	"Subscription Period": "Subscription Period",
	Plan: Plan$e,
	New: New$e,
	Unsubscribed: Unsubscribed$e,
	"Subscription ends soon": "Subscription ends soon",
	Edit: Edit$e,
	"1 month trial": "1 month trial",
	"Edit customer details": "Edit customer details",
	"Customer name": "Customer name",
	"of 999 available_": "of 999 available on Fleet Plan",
	"Subscription starts": "Subscription starts",
	"Subscription period": "Subscription period",
	month: month$e,
	months: months$e,
	"Cloud storage": "Cloud Storage",
	"Subscription plan": "Subscription Plan",
	"Check email address": "Check email address",
	"Add customer details": "Add customer details",
	Continue: Continue$e,
	Back: Back$e,
	"An error occured": "An error occured",
	"Customer added": "Customer added",
	"Last changed": "Last changed",
	"Company name": "Company name",
	"Company address": "Company address",
	"Alert Push Notifications": "Alert Push Notifications",
	"Receive notifications on_": "Receive notifications on your phone when preset Events occur. Great in combination with BlackVue’s Parking Mode.",
	"Remote Live View": "Remote Live View",
	"Remotely monitor your_": "Remotely monitor your car in real time from anywhere, anytime.",
	"Video Backup/Auto Upload": "Video Backup/Auto Upload",
	"Back up videos_": "Back up videos to your phone or Cloud storage.",
	"Two-way Voice Communication": "Two-way Voice Communication",
	"Talk with people_": "Talk with people in the car from your smartphone. The driver can speak while keeping hands on the wheel.",
	"View your car’s_": "View your car’s location and speed on a map. With BlackVue Fleet Tracking, access 90-days’ worth of GPS data.",
	"Remote Video Playback": "Remote Video Playback",
	"Play videos stored_": "Play videos stored in the Cloud or in your dashcam anytime on your smartphone or tablet.",
	"Event Live Auto Upload": "Event Live Auto Upload",
	"Save a video stream_": "Save a video stream in real time to the Cloud. Protect yourself from break-ins and theft.",
	"Event File Auto Upload": "Event File Auto Upload",
	"Save Event videos_": "Save Event videos to the Cloud—including seconds before trigger—after they happen.",
	"Firmware-Over-the-Air (FOTA)": "Firmware-Over-the-Air (FOTA)",
	"Upgrade your dashcam’s": "Update your dashcam over the cloud",
	"When an Event_": "When an Event is created (Impact detected or manually triggered), Event Live Auto-upload lets your Cloud-compatible BlackVue save a live video stream from a camera of your choice (front or rear/interior) to the Cloud server",
	"Event File Auto-upload_": "Event File Auto-upload lets your dashcam automatically upload low-resolution versions of Event files to the Cloud.",
	Master: Master$e,
	"per Camera": "per Camera",
	"Event live auto upload_": "Event live auto upload compatible with all cloud cameras",
	"Drive report": "Drive report",
	"USA/Canada Toll Free": "USA/Canada Toll Free",
	"Monday–Saturday_": "Monday to Friday 8am-7pm / Saturday 9am-6pm (PST).",
	"Please agree to_": "You must accept Terms of Service",
	"Mac or Windows PC": "Mac or Windows PC",
	Develop: Develop$e,
	"Sign out": "Sign out",
	"Referral code": "Referral code",
	"Total after 1 month trial": "Total after 1 month trial",
	"Already Use Stripe Token": "Already Use Stripe Token",
	"Select period": "Select period",
	"State/Region": "State/Region (optional)",
	"ZIP/Postal": "ZIP/Postal code",
	"$0.00": "$0.00",
	"$11.99": "$11.99",
	"$24.99": "$24.99",
	$9: $9$e,
	$15: $15$e,
	$10: $10$e,
	"mo + for_": "/mo + {{a}} per extra camera",
	mo: mo$e,
	"This e-mail address_": "This email address already has a registered account.",
	"1 month": "1 month",
	"Limit is reset daily": "Limit is reset daily",
	"Limit is reset monthly": "Limit is reset monthly",
	"Video plays and downloads": "Video plays and downloads",
	"Your master": "Your owner",
	"Youre 1 step_": "You’re 1 step away from finishing Fleet Plan subscription",
	"Finish signing up": "Finish signing up",
	"Enter billing information": "Enter billing information",
	"Proceed to billing": "Proceed to billing",
	City: City$e,
	Charge: Charge$e,
	"User already invited_": "driver already invited from owner",
	"n% consumed": "{{a}}% used",
	"E-mail already exists": "Email already exists",
	"Cancel your inapp_": "Cancel your in-app subscription",
	"You have cancel_": "You have to cancel your in-app subscription to upgrade to Fleet Plan: \n\n1. Cancel your current subscription in the App Store or Google Play Store. You will downgrade to Free Plan at the end of your current billing cycle. All your data will remain intact. \n2. Log in to your blackvuecloud.com account and upgrade to Fleet Plan.",
	"Edit permissions": "Edit permissions",
	"See permissions": "See permissions",
	"Submaster removed": "admin removed",
	"Camera removed": "Camera removed",
	"User removed": "driver removed",
	"Users removed": "drivers removed",
	subscribe: subscribe$e,
	search: search$e,
	"permission can be_": "Permission can be setup after admin accept the invitation.",
	"The confirmation link_": "The confirmation link is no longer valid",
	"Possible reasons:_": "Possible reasons:\n• You have already confirmed your email address\n• The link has expired or has been canceled",
	"Failed to register_": "Failed to register to BlackVue Cloud",
	"There was an_": "There was an error during the sign-up process.\nIf the problem persists, try signing up to BlackVue Cloud again.\n\nIf you need further assistance, please contact our customer support:",
	"Upgrade to Fleet_": "Upgrade to Fleet Plan",
	"Subscription is Canceled": "Subscription is Canceled",
	"No members yet": "No members yet",
	"Please enter_group name": "Enter a valid group name",
	"Group Name": "Group Name",
	invalid_number: invalid_number$e,
	invalid_expiry_month: invalid_expiry_month$e,
	invalid_expiry_year: invalid_expiry_year$e,
	invalid_cvc: invalid_cvc$e,
	incorrect_number: incorrect_number$e,
	incomplete_number: incomplete_number$e,
	incomplete_cvc: incomplete_cvc$e,
	incomplete_expiry: incomplete_expiry$e,
	expired_card: expired_card$e,
	incorrect_cvc: incorrect_cvc$e,
	incorrect_zip: incorrect_zip$e,
	invalid_expiry_year_past: invalid_expiry_year_past$e,
	card_declined: card_declined$e,
	missing: missing$e,
	processing_error: processing_error$e,
	"no groups yet": "No groups yet",
	"groups will show_": "Groups will show up here as they become available",
	"Fleet members will_": "Fleet members will show up here as they become available",
	"service provider": "Service provider",
	Paypal: Paypal$e,
	iOS: iOS$e,
	Android: Android$e,
	"Enter email": "Please enter a email address",
	"Enter password": "Please enter a password",
	"Enter first name": "Please enter a first name",
	"Enter last name": "Please enter a last name",
	"Enter the current_": "Please enter current password.",
	"Enter a new_": "Please enter new password.",
	"There isnt an_": "There isn't an account associated with this email address",
	"Fleet Plan": "Fleet Plan",
	Total: Total$e,
	"Password you entered_": "Password you entered is incorrect",
	"Incorrect email or_": "Incorrect email or password",
	"Available to Masters": "Available to Owner",
	"Blackvue url": "https://www.blackvue.com",
	"Information We Collect_": "Information We Collect and Why",
	And: And$e,
	"Terms of Location-Based_": "Terms of Location-Based Service Use.",
	"I agree to the_": "I agree to the",
	"Password Reset_": "We've sent an email to {{a}} with password reset \ninstructions.",
	"You have already_": "You have already been invited, check your email.",
	"No data available_": "No data available in table",
	Camera: Camera$e,
	"You no longer_": "You no longer have permission to use fleet service.",
	"Please contact your_": "Please contact your Fleet owner to resolve the issue.",
	"You can still_": "You can still access your",
	"account information": "account information.",
	"If the issue_": "If the issue is not resolved and you decide to continue using the BlackVue Cloud service with the registered email address, you'll have to delete your account and sign up again.",
	"If the problem_": "If the problem persists, contact our customer support:",
	"Web subscription only": "Web subscription only",
	"AppStore url": "https://apps.apple.com/kr",
	"We no longer_": "We no longer process payments through PayPal. You have to update your subscription to change the number of cameras:\n \n1. Log in to your paypal.com account and cancel your current Fleet Plan subscription to change the number of cameras: \n\n2. Log in to your blackvuecloud.com account and upgrade to Fleet Plan.",
	Yes: Yes$e,
	No: No$e,
	"Serial number": "Serial number",
	"Cloud code": "Cloud code",
	"Terms & Policies": "Terms & Policies",
	News: News$e,
	Notifications: Notifications$e,
	"km/h": "km/h",
	MPH: MPH$e,
	"Baidu Maps": "Baidu Maps (China only)",
	"Google Maps": "Google Maps",
	Firmware: Firmware$e,
	Basic: Basic$e,
	"Time Zone": "Time Zone",
	Resolution: Resolution$e,
	"Image quality": "Image quality",
	Brightness: Brightness$e,
	Recording: Recording$e,
	"Normal recording": "Normal Recording",
	"Voice recording": "Voice Recording",
	"Video segment length": "Video Segment Length",
	"Rear camera recording": "Rear Camera Recording",
	Highest: Highest$e,
	High: High$e,
	Normal: Normal$e,
	"1 min": "1 min",
	"2 min": "2 min",
	"3 min": "3 min",
	Sensitivity: Sensitivity$e,
	"Motion detection": "Motion detection",
	"Speed alert": "Speed alert",
	"Voice guidance": "Voice Guidance",
	"Power on": "Power On",
	"Power off": "Power Off",
	"Starting normal recording": "Starting Normal Recording",
	"Changing recording mode": "Changing Recording Mode",
	"Speed alert (beep)": "Speed Alert (Beep)",
	"Cloud related": "Cloud Related",
	Volume: Volume$e,
	"User text overlay": "User Text Overlay",
	"A-Z, a-z_": "A-Z, a-z, 0-9, :;’/\\+-_()$# under 20 characters.",
	"Wi-Fi auto turn off": "Wi-Fi auto turn off",
	"Login credentials": "Login Credentials",
	"Manual recording": "Manual Recording",
	"By sharing your_": "By sharing your Live View you can let other users vicariously experience the excitement and pleasure of driving all over the world.",
	"However, as persona_": "However, as personal video may be transmitted you should take special care in deciding what information you share.",
	"Please enter_email_2": "Please enter a valid email address. Email with some special characters may not be allowed. ex) +, &",
	"Password is incorrect": "Password is incorrect.",
	"This camera is already_": "This camera is already registered to a BlackVue account.",
	"Camera name must_": "Camera name must contain 5 to 32 characters.",
	"Failed to save_": "Failed to save camera settings.",
	"Unallowed character detected": "Unallowed character detected.",
	"File(s) queued for_": "File(s) queued for Cloud upload.",
	"Exceeded video play_": "Exceeded video play & download limit.",
	"Playback Failed": "Playback failed.",
	"Exceeded your Live_": "Exceeded your Live View time limit.",
	"The camera is not_": "The camera is not connected to the server.",
	"Please check the connection_": "Please check the connection status of the selected camera.",
	Close: Close$e,
	"Map": "Map",
	Cloud: Cloud$e,
	Public: Public$e,
	"Flip horizontally": "Flip horizontally",
	Front: Front$e,
	Rear: Rear$e,
	Play: Play$e,
	Stop: Stop$e,
	Pause: Pause$e,
	"Next frame": "Next frame",
	"Previous frame": "Previous frame",
	"Proximity sensor": "Proximity sensor",
	"Voice recording on/off": "Voice recording on/off",
	"The BlackVue dashcam_": "The BlackVue dashcam is not compatible with 5GHz wireless networks",
	Time: Time$e,
	"Daylight saving time": "Daylight Saving Time",
	System: System$e,
	"Incorrect camera serial_": "Incorrect camera serial number.",
	"Lock event files": "Lock Event files",
	"Overwrite locked event_": "Overwrite locked Event files when full",
	"Camera settings saved_": "Camera settings saved successfully.",
	"Front camera": "Front camera",
	"Rear camera": "Rear camera",
	Event: Event$e,
	Parking: Parking$e,
	"GPS tracking": "GPS Tracking",
	"G-force detected": "G-force detected",
	"Impact detected in_": "Impact Detected in Parking Mode",
	"Scheduled reboot": "Scheduled Reboot",
	"Recording status": "Recording status",
	"Rear security": "Rear Security",
	"Time lapse": "Time Lapse",
	"Sync with GPS_": "Sync with GPS time",
	"Overwrite locked event3_": "Overwrite locked files with new Event files when storage is full",
	"Video codec": "Video Codec",
	"Tracking logs": "Tracking logs",
	"Geofence alerts": "Geofence alert",
	Color: Color$e,
	Exit: Exit$e,
	Save: Save$e,
	Impact: Impact$e,
	Unlimited: Unlimited$e,
	"Parking mode recording": "Parking Mode Recording",
	"Battery protection": "Battery Protection",
	"Cut-off timer": "Cut-off Timer",
	"Low voltage cut-off": "Low Voltage Cut-off",
	"Rear camera orientation": "Rear Camera Orientation",
	Default: Default$e,
	"Rotate video 180°": "Rotate video 180°",
	"Mirror video": "Mirror video",
	"Wi-Fi band": "Wi-Fi band",
	"Driving report": "Driving report",
	"Unsupported video codec_": "Unsupported video codec (H.265).",
	"Rear camera recording_": "Rear camera recording in Parking Mode",
	"Front and rear_": "Front and rear camera record together",
	"Rear camera stops_": "Rear camera stops recording 5 minutes after entering parking mode. Recording restarts when entering normal mode.",
	"Remote firmware update": "Remote firmware update",
	"Firmware is up-to-date": "Firmware is up-to-date",
	"New firmware available": "New firmware available.",
	Version: Version$e,
	"Release date": "Release date",
	Language: Language$e,
	"File size": "File size",
	"What’s new": "What’s new",
	"Updating may take_": "Updating may take several minutes.",
	"The update process_": "The update process cannot be canceled.",
	"Do not disconnect the_": "Do not disconnect the power cable until normal recording restarts.",
	"Downloading firmware": "Downloading firmware",
	"Once download is_": "Once download is complete the BlackVue will automatically reboot to apply the new firmware. Do not disconnect the power cable until normal recording starts.",
	"If not allowed_": "If not allowed, your car's location and speed will not be accessible over the Cloud.",
	"Unable to initiate update because_": "Unable to initiate update because the dashcam is connected to a device via direct Wi-Fi.",
	Notification: Notification$e,
	Multiple: Multiple$e,
	Range: Range$e,
	"HDR night vision": "HDR Night Vision",
	Download: Download$e,
	"G-sensor": "G-Sensor",
	Manual: Manual$e,
	"Low voltage warning": "Low Voltage Warning",
	Satellite: Satellite$e,
	"Data usage": "Data usage",
	"Select video download quality": "Select video download quality",
	"Quick play file_": "Quick play file (low resolution)",
	"Original file": "Original file",
	"You do not have permission_": "You do not have permission to run this function.\nPlease contact your account owner.",
	"Interior camera recording_": "Interior camera recording in Parking Mode",
	"Interior security": "Interior Security",
	"Interior camera rotation": "Interior camera rotation",
	"Multi View": "Multi View",
	Tutorials: Tutorials$e,
	"Upgrade now": "Upgrade now",
	"Members will show_": "Members will show up here as they become available.",
	"Are you sure_delete members": "Are you sure you want to permanently delete members?",
	"Some members may_": "Some members may be hidden because of the filters applied.",
	"Invited on_": "Invited on {{Invited Date}} by {{user}} · {{role}}",
	Filter: Filter$e,
	"Date created": "Date created",
	"No admin yet": "No admin yet",
	"You can add_admin": "You can add 1 admin per group",
	"Collapse all": "Collapse all",
	"Expand all": "Expand all",
	"Download and playback_cloud": "Download and playback from cloud storage",
	"Are you sure_2": "Are you sure you want to delete group {Group name} ?",
	"Are you sure_groups": "Are you sure you want to delete groups?",
	"Add cameras first_drivers": "Add cameras first, assign drivers afterwards",
	"Flip vertically": "Flip vertically",
	Sun: Sun$e,
	Mon: Mon$e,
	Tue: Tue$e,
	Wed: Wed$e,
	Thu: Thu$e,
	Fri: Fri$e,
	Sat: Sat$e,
	Dates: Dates$e,
	Routes: Routes$e,
	Opacity: Opacity$e,
	"Color and opacity": "Color and Opacity",
	"Geofences will show_": "Geofences will show up here as they become available.",
	"Start drawing a shape_": "Start drawing a shape on the map",
	"Add geofence": "Add Geofence",
	Entry: Entry$e,
	"Show all members": "Show all members",
	"Me and my_": "Me and my car. Connected",
	"add-on service for_": "Add-on service for cloud-compatible BlackVue",
	"Continue with Google": "Continue with Google",
	"An account with_": "An account with that email address already exists, but isn't verified. Enter your existing BlackVue Cloud password to log in.",
	"Account does not_": "Account does not exist. Or try logging in with your Apple or Google account.",
	"Continue with Apple": "Continue with Apple",
	"Get started": "Get started",
	"P subscription only": "<b>{{a}}</b> subscription only",
	"+N USD for extra camera_": "+{{a}} USD for extra camera up to {{b}} Cameras",
	"Unlimited Live view": "Unlimited Live View",
	"Cameras per Account": "Cameras per Account",
	"Users per Account": "Users per Account",
	Owner: Owner$e,
	"Live View per Day": "Live View per Day",
	"Remote Video Playback_2": "Remote Video Playback and Download per Month",
	"N days": "{{a}} Days",
	"Video On Map": "Video On Map",
	Undetected: Undetected$e,
	Distracted: Distracted$e,
	Drowsy: Drowsy$e,
	"Whether on mobile_": "Whether on mobile or your computer, BlackVue gives you the tools to fully enjoy your dashcam’s functions. Download the latest <a1>firmware</a1>, <a2>mobile</a2> and <a3>desktop</a3> applications, or use <a4>BlackVue web app</a4> in your browser.",
	"Compatible with most_": "Compatible with most Wi-Fi BlackVue models. Cloud support for all Cloud-compatible dashcam models down to DR650GW Series with <b>Cloud Firmware</b>.",
	"Supports most recent BlackVue_": "Supports most recent BlackVue models and compatible with BlackVue Cloud.<br/>\nThis Viewer contains <b>two applications in one</b>: the SD Card Viewer lets you view recorded videos from your SD card and modify the settings of your BlackVue, as well as format the SD card; the <b>Cloud Viewer</b> lets you enjoy BlackVue Cloud.",
	"Contact us": "Contact us",
	"6 characters with": "6 characters with a mix of letters, numbers and symbols",
	"Apps and more...": "Apps and more...",
	"Cameras will show_": "Cameras will show up here as they become available.",
	"Keep this page_": "Keep this page open while checking the confirmation code. Try your spam folder if you can’t find the email in your inbox.",
	"n cameras": "{{n}} cameras",
	"n slots": "{{n}} slots",
	"Calculate your Fleet_": "Calculate your Fleet plan price",
	"Code you entered_": "Code you entered is incorrect/has expired",
	Calling: Calling$e,
	Smoking: Smoking$e,
	"Smoking has been_": "Smoking has been detected.",
	"Email is already_": "Email already exist.",
	"Serial number and_": "Serial number (S/N) and cloud code are printed on your camera.",
	"Allow GPS access": "Allow GPS Access",
	"Used to access_": "Used to access your vehicle’s location and speed. You can change GPS settings later in your camera’s privacy settings.",
	"Incorrect cloud code": "Incorrect cloud code",
	"An account is_": "An account is already registered with this email address.",
	"Live event upload": "Live Event Upload",
	Permissions: Permissions$e,
	"Assign in": "Assign in",
	"Are you sure_camera": "Are you sure you want to delete this camera?",
	"Uploading videos:": "Uploading videos:",
	"GPS location recording": "GPS Location Recording",
	"When OFF, GPS_": "When OFF, GPS location is not recorded or sent to the cloud server.",
	"As personal video_": "As personal video may be transmitted, you should take special care in deciding what information you share.",
	"Share location": "Share Location",
	Private: Private$e,
	"Used to access_2": "Used to access your vehicle’s location and speed.",
	"Share live view": "Share Live View",
	"Share live audio": "Share live audio",
	"Share camera’s name": "Share camera’s name",
	"Impact detection": "Impact detection",
	Entering: Entering$e,
	Exiting: Exiting$e,
	"Normal event recording": "Normal Event Recording",
	"Harsh braking": "Hard Braking",
	Acceleration: Acceleration$e,
	"Sharp turn": "Hard Cornering",
	"Parking event recording": "Parking Event Recording",
	Passing: Passing$e,
	"Video source": "Video Source",
	Overspeed: Overspeed$e,
	"Are you sure_video": "Are you sure you want to delete this video?",
	"Add camera to_": "Add camera to Live View",
	"No routes to_": "No routes to show",
	"Start by adding_": "Start by adding dates.",
	"invite sent": "Invite sent",
	Recipients: Recipients$e,
	Send: Send$e,
	"Routes selected_": "Routes selected: {{n}} of {{total}}",
	"Map service": "Map service",
	"Speed units": "Speed units",
	Note: Note$e,
	"Release notes": "Release notes",
	"The name must_": "The name must be between 1 to 30 characters.",
	Video: Video$e,
	Advanced: Advanced$e,
	"Firmware language": "Firmware language",
	"Wi-Fi": "Wi-Fi",
	Voice: Voice$e,
	"Show date and_": "Show date and time",
	"Show speed": "Show speed",
	"Front camera rotation": "Front Camera Rotation",
	"Manual time settings": "Manual time settings",
	"Recommended for better_": "Recommended for better compression, reduced file size and 4K UHD.",
	"For full compatibility_": "For full compatibility with older desktop and mobile devices.",
	"Up and down": "Up and down",
	"Side to side": "Side to side",
	"Front and back": "Front and back",
	"Detection region": "Detection region",
	"Hotspot 1": "Hotspot 1",
	"Hotspot 2": "Hotspot 2",
	"Hotspot 3": "Hotspot 3",
	"Enter/exit": "Enter/exit",
	"Event recording": "Event recording",
	"Front security (Normal)": "Front security (Normal)",
	"Front security (Parking)": "Front security (Parking)",
	"LTE (Parking)": "LTE (Parking)",
	"Wi-Fi (Parking)": "Wi-Fi (Parking)",
	"Turn on at startup": "Turn on at startup",
	"Turn off after_": "Turn off after 10 min of inactivity",
	"Your firmware is_": "Your firmware is up to date",
	"Add admin": "Add admin",
	"Remove All/n": "Remove All/{{a}}",
	"Are you sure_remove": "Are you sure you want to remove cameras from this group?",
	"This will cancel_2": "This will cancel your Fleet Plan subscription. You will downgrade to the Free Plan at the end of your current billing cycle.",
	"You’ve reached_": "You’ve reached the driver limit per camera",
	"Are you sure_remove admin": "Are you sure you want to remove admin {{a}}{{b}} from this group?",
	"Fleet Plan · Owner": "Fleet Plan · Owner",
	"Manage cameras": "Manage cameras",
	"Are you sure_delete zone": "Are you sure you want to delete zone \"{{zone}}\"?",
	"available on your_2": "{{a}}/{{b}} available on your plan",
	"The new plan_2": "The new plan will be effective at the end of your current billing cycle ({{a}}).",
	"Canceled Fleet Plan_": "Canceled Fleet Plan on {{a}}",
	"Hard braking alert (beep)": "Hard Braking Alert (Beep)",
	"Hard acceleration alert (beep)": "Hard Acceleration Alert (Beep)",
	"Hard cornering alert (beep)": "Hard Cornering Alert (Beep)",
	"SSID must be_": "SSID must be at least 5 characters long.",
	"Password must be_": "Password must be at least 8 characters long.",
	"5 to 32 characters long": "5 to 32 characters long",
	"8 to 32 characters long": "8 to 32 characters long",
	"Longer storage period_event": "Longer storage period for Live Event Upload",
	"Requires latest firmware_": "Requires latest firmware. Not compatible with DR650S, DR650GW models",
	"After Blackvue is_": "After Blackvue is connected to the cloud, the settings will be saved.",
	"This is an_": "This is an unregistered Email. Would you like to sign up a new account?",
	"This feature is_": "This feature is available for Fleet Plan subscribers only.",
	"Please return to_": "Account does not exist. Or try logging in with your Apple or Google account.",
	"Adjusting the cut-off voltage_": "Adjusting the cut-off voltage to a lower setting may result in your dash cam draining more power from your battery.\nThis could result in warning messages of battery drain or affect other vehicle functions.\nPlease consult with your dealership before lowering the voltage.",
	"Your videos will_": "Your videos will show up here as they become available.",
	"You drove:_": "You drove: {{distance}}, {{time}}",
	"Event count per_": "Event count per driving hour",
	"Are you sure_recipient": "Are you sure you want to delete this recipient?",
	"(You)": "{{a}} (You)",
	"All events": "All Events",
	Days_: Days_$e,
	"Requires DMC 200_": "Requires DMC 200 camera",
	"A DMS and compatible_": "A DMS and compatible dash cam is required to view this report.",
	"Notifications will show_": "Notifications will show up here as they become available.",
	"Try changing your_": "Try changing your date or removing filters.",
	Mute: Mute$e,
	UnMute: UnMute$e,
	"Calling and smoking_": "Calling and smoking is detected by DMC 200 device only",
	"You need a DMS_": "You need a DMS to view this report.",
	"Try BlackVue Cloud": "Try BlackVue Cloud today",
	"Individual driver looking_": "Individual driver looking for peace of mind? Business owner in need of a simple vehicle security and tracking solution?",
	"Whoever you are_": "Whoever you are, whatever your needs, there is a Cloud plan for you!",
	"It is the account that_Driver": "It is the account that joined your fleet on BlackVue cloud after accepting an email invitation from the Owner or Admin. A driver may be assigned to only one camera with the limited ability to view his or her own account profile; his or her assigned camera’s Live View and playback.",
	"It is the account that_Admin": "It is the account that joined your fleet on BlackVue cloud after accepting an email invitation from the Owner. Admin accounts may be given the rights which the Owner permits for that Admin.",
	"Video deleted": "Video deleted",
	"Video delete_plural": "Videos deleted",
	"Driver removed from_": "Driver removed from group",
	"Admin removed from_": "Admin removed from group",
	"Camera removed from_": "Camera removed from group",
	"Are you sure_videos": "Are you sure you want to delete these videos?",
	"You have to cancel_fleet": "You have to cancel your in-app subscription to change the number of cameras: \n\n1. Cancel your current subscription in the App Store or Google Play Store. You will downgrade to Free Plan at the end of your current billing cycle. All your data will remain intact. \n2. Log in to your blackvuecloud.com account and upgrade to Fleet Plan.",
	Discard: Discard$e,
	"Discard unsaved changes?": "Discard unsaved changes?",
	"Incorrect serial number": "Incorrect serial number",
	"An error occurred_again": "An error occurred. Please try again.",
	"You are subscribed_free": "You are subscribed to the Free plan of BlackVue Cloud.",
	"When an event_": "When an Event is created (Impact detected or manually triggered), Live Event Upload lets your BlackVue save a live video stream from a camera of your choice to the Cloud server including 5 seconds before the Event.",
	Report: Report$e,
	"How it work": "How it work",
	"Cloud Camera": "Cloud Camera",
	"Internet Connection": "Internet Connection",
	"BlackVue App/Viewer": "BlackVue App/Viewer",
	"All you need_": "All you need is a",
	"Cloud-compatible BlackVue": "Cloud-compatible BlackVue",
	"and a cellular_": "and a cellular data plan. Some models connect to the Cloud via a third-party Wi-Fi hotspot. Others offer built-in Nano SIM card reader or plug-in connectivity module support.",
	"Cloud features at_": "Cloud features at your fingertips",
	"Enjoy peace of_": "Enjoy peace of mind knowing BlackVue is watching over your car. If anything goes wrong, your dashcam messages you instantly.",
	"Let your BlackVue_": "Let your BlackVue monitor your car and alert you of incidents. The moment an Impact is detected, your BlackVue will send a notification to your phone or your web browser, accompanied by a snapshot.",
	"Check on your_": "Check on your car from anywhere with Remote Live View. Whether through a web browser or your phone, access a real-time video feed from your Cloud-connected dashcam and swap easily between the front, rear or interior cameras.",
	"Your BlackVue may_": "Your BlackVue may not prEvent hit-and-runs but if they happen, there is a good chance it will capture crucial video evidence. Browse all the videos recorded by your dashcam from your mobile phone or a web browser.",
	"Worried about eating_": "Worried about eating through your data plan? BlackVue's Sub-stream technology lets you access extra-light versions of your videos for fast browsing and buffer-free viewing.",
	"Move files from_": "Move files from your BlackVue to the Cloud. Save a single video or select multiple clips for bulk upload. Video downloaded to your phone with the BlackVue app can be accessed and shared from the Downloaded Videos menu.",
	"View your vehicle’s_": "View your vehicle’s location and traveling speed in real time. Upgrade to a Smart Plan for access to the past 7 days of GPS Tracking data.",
	"Get more with_": "Get more with Smart Plan",
	"Unlimited Remote Live_": "Unlimited Remote Live View",
	"Up to 3 dashcams_": "Up to 3 dashcams under a single account",
	"Want to track_": "Want to track a whole fleet? Upgrade to Fleet Plan",
	"BlackVue Fleet Tracking_2": "BlackVue Fleet Tracking is an all-in-one solution to protect and track your fleet. Features and pricing scale flexibly to meet the needs of your business.",
	"Stream real-time video_": "Stream real-time video without limit. Bitrate: 600kbps",
	"Up to 999 Dashcams": "Up to 999 Dashcams",
	"Register up to_": "Register up to 999 dashcams per account.",
	"15GB of Cloud_": "15GB of Cloud Storage",
	"15GB per additional_": "15GB per additional dashcam. Unlimited Event Auto-upload storage.",
	"90-days GPS_": "90-days GPS Tracking Logs",
	"High accuracy: 15_": "High accuracy: 15 seconds, Video On a Map, easy data export.",
	"Unique fleet management_": "Unique fleet management features add value and convenience",
	"Create geofences and_": "Create geofences and receive real-time notifications on your phone or computer.",
	"View at a_": "View at a glance total distance driven, idle time, speeding Events, etc., in tables that can be printed or exported.",
	"Multi Live View": "Multi Live View",
	"Monitor up to_": "Monitor up to 4 dashcams simultaneously",
	"Benefits for you": "Benefits for you",
	Individual: Individual$e,
	"Get notifications to_2": "Get notifications to your phone when your parked car is hit. Check remotely what is happening around your car. Available on the web, mobile, Mac and Windows.",
	"Small business owner": "Small business owner",
	"Monitor your commercial_2": "Monitor your commercial vehicles on a map in real time. Talk to your drivers anytime through your browser, BlackVue mobile app, Mac or Windows viewer.",
	"Company with large_": "Company with large fleet",
	"With BlackVue Fleet_2": "With BlackVue Fleet Tracking, track up to 999 vehicles in real time through your browser, BlackVue mobile app, Mac or Windows viewer.",
	Subscribed: Subscribed$e,
	"The video was_": "The video was already uploaded.",
	Geofence: Geofence$e,
	"500: Internal server error": "500: Internal server error",
	"404: Page not found": "404: Page not found",
	"Check the web address_": "Check the web address or get back to the BlackVue Cloud",
	"home page": "Home page",
	"There isn’t an_": "There isn’t an account associated with this email address",
	"You can now_password": "You can now log in with your new password",
	"Are you sure_remove admin2": "Are you sure you want to permanently delete admin",
	"Admin deleted": "Admin deleted",
	"Members deleted": "Members deleted",
	"Are you sure_groupName": "Are you sure you want to delete group {{a}}?",
	"Requires latest firmware": "Requires latest firmware",
	"Selected file(s) moved_": "Selected file(s) moved successfully",
	"Are you sure_remove driver2": "Are you sure you want to remove driver {{a}} ({{b}}) from this group?",
	"Invite sent": "Invite sent",
	"Safe driving": "Safe driving",
	"Reckless driving": "Reckless Driving",
	"Inattentive driving": "Inattentive driving",
	"Driving events trend": "Driving events trend",
	"Driving details": "Driving details",
	Driving: Driving$e,
	Idling: Idling$e,
	Distance: Distance$e,
	"Parking sessions": "Parking sessions",
	"Parked time": "Parked time",
	"Idle stops": "Idle stops",
	"Idle time": "Idle time",
	"Impact events": "Impact Events",
	Parked: Parked$e,
	Speed: Speed$e,
	"Overspeeding alerts": "Over speeding alerts",
	Highest_2: Highest_2$e,
	Average: Average$e,
	Geofences: Geofences$e,
	"Entries into a_": "Entries into a zone",
	"Exits from a_": "Exits from a zone",
	"No data": "No data",
	"Hard acceleration": "Hard Acceleration",
	"Hard braking": "Hard Braking",
	"Hard cornering": "Hard Cornering",
	"The number within the brackets_": "The number within the brackets indicates the average number of Events per hour driving. If you drove less than one hour a day, the total number of Events is shown.",
	"Did you insert_": "Did you insert a SIM card?",
	"Click here for_": "<a>Click here</a> for more detailed guides.",
	"Back up all_": "<b>Back up all important recordings before saving these settings.</b><br/>When you save the settings the microSD card will be reinitialized and all recordings will be deleted to ensure stable operation.",
	"Not connected to_": "Not connected to cloud. Some functionality has been temporarily disabled.",
	"GPS Location recording off": "GPS location recording off.",
	"n Videos deleted": "{{count}} Videos deleted",
	Move: Move$e,
	"Driver Monitoring System (DMS) will_": "Driver Monitoring System (DMS) will be launched soon.",
	"An error occured while_": "An error occured while trying to change the number of cameras. Try again",
	"Reached the limit_": "Reached the limit: {{a}}",
	"An invitation was_": "An invitation was already sent to this email address.",
	"To use the_": "To use the cloud feature, please insert your SIM card.",
	"Last updated": "Last updated {{date}}",
	"Try changing your date": "Try changing your date.",
	"No event data_": "No Event data collected for the selected time",
	"Please select another_": "Please select another day or month to view a whole report.",
	"more than 6_": "more than 6 characters required",
	"Sign up free": "Sign up free",
	"Cloud storage warning": "Cloud storage warning",
	"Cloud Storage Full": "Cloud Storage full",
	"Cloud storage usage_100": "Cloud storage usage reached 100%. \nOrganize your cloud storage. \nLive Event Upload service is not being available if cloud storage is full.",
	"Cloud storage usage_": "Cloud storage usage reached <b>({{a}}%)</b>. \nOrganize your cloud storage.\nLive Event Upload service is not being available if cloud storage is full.",
	"Are you sure_delete_zone": "Are you sure you want to delete?",
	"Search Name or email": "Search Name or email",
	"Search group name": "Search group name",
	"Please note that_": "Please note that video recording will be paused for a few seconds to apply the new settings.",
	"Currently connected Hotspot": "Currently connected Hotspot",
	"Enhanced night vision": "Enhanced night vision",
	"To access the_": "To access the camera, please update your subscription plan.",
	"Restarting the Blackvue_": "Restarting the Blackvue to apply settings.",
	"Hard acceleration event_": "Hard acceleration Event occurs when rate growth per second is above {{kmh}} km/h ({{mph}} MPH)",
	"Hard braking event_": "Hard Braking Event occurs when rate reduction per \nsecond is above {{kmh}} km/h ({{mph}} MPH)",
	"Hard cornering event_": "Hard Cornering Event occurs when more than 60 degrees of rotation occurs within 2 seconds of driving above \n{{kmh}} km/h ({{mph}} MPH)",
	"Changes you made_": "Changes you made may not be saved.",
	"My location": "My Location",
	"Hotspot name (SSID)": "Hotspot name (SSID)",
	Connected: Connected$e,
	"Camera will be rebooted_": "Camera will be rebooted. Do you still want to proceed?",
	"Restarting the BlackVue_": "Restarting the BlackVue. Please wait a moment.",
	"Failed to reboot_": "Failed to reboot camera",
	"Bluetooth (Parking mode)": "BT (Parking Mode)",
	"Front and interior camera_": "Front and interior camera record together.",
	"Interior camera stops_": "Interior camera stops recording 5 min. after entering Parking Mode. Recording restarts when entering normal mode.",
	Individual_: Individual_$e,
	"Driver detection": "Driver Detection",
	"During driving only": "During driving only",
	Always: Always$e,
	"Driver detection box": "Driver detection box",
	"DMS camera rotation": "DMS camera rotation",
	Low: Low$e,
	Medium: Medium$e,
	High_2: High_2$e,
	"Reboot Camera": "Reboot Camera",
	"Latest events": "Latest Events",
	"G-Sensor": "G-Sensor",
	"Playback speed": "Playback speed",
	Flip: Flip$e,
	Previous: Previous$e,
	Next: Next$e,
	"Map type": "Map type",
	"Zoom in": "Zoom in",
	"Zoom out": "Zoom out",
	"Move to Cloud": "Move to Cloud",
	"Please recognize that_": "Please recognize that Video recording will pause for seconds to apply the settings.",
	"6 characters with_": "6 characters with a mix of letters, numbers and symbols",
	"Updating firmware": "Updating firmware",
	"Overspeed event occurs_": "Overspeed Event occurs when the dashcam warns the driver that the speed limit was exceeded.",
	"Enter group name": "Enter group name",
	"Live view failed": "Live View failed",
	"Parking mode enter_": "Parking Mode Enter/Exit",
	"Cloud connectivity": "Cloud Connectivity",
	Expand: Expand$e,
	Collapse: Collapse$e,
	"all day": "all day",
	"Driving style": "Driving style",
	"Driving impact": "Driving Impact",
	More: More$e,
	"No cameras to_": "No cameras to add",
	"You have added_": "You have added all available cameras.",
	Multi: Multi$e,
	"Report video": "Report Video",
	"Sexually explicit content": "Sexually Explicit Content",
	"Graphic violence": "Graphic Violence",
	"Hateful speech": "Hateful speech",
	"Harassment or bullying": "Harassment or Bullying",
	"Spam or advertisement": "Spam or Advertisement",
	"Infringement of my_": "Infringement of my rights",
	"Other reason": "Other Reason",
	"Reason for reporting": "Reason for reporting",
	"Reported videos will_": "Reported videos will be checked within 72 hours. The video will not be displayed on the Event Map until it is confirmed that the video is suitable for posting on the Event Map.",
	"Touch sensor": "Touch Sensor",
	"Motion and impact detection": "Motion and Impact Detection",
	"Settings have been changed": "Setting Have Been Changed",
	"Start event recording (beep)": "Starting Event Recording (Beep)",
	"Scheduled reboots": "Scheduled reboots",
	Safe: Safe$e,
	Reckless: Reckless$e,
	Inattentive: Inattentive$e,
	"Highest(Extreme)": "Highest(Extreme)",
	"Public cameras": "Public cameras",
	List: List$e,
	Usage: Usage$e,
	"Video playbacks and downloads": "Video playbacks and download",
	"of 100 times": "of 100 times",
	"of 10 minutes": "of 10 minutes",
	Profile: Profile$e,
	"Search geofences": "Search geofences",
	"Export CSV": "Export CSV",
	"Exit fullscreen": "Exit fullscreen",
	Fullscreen: Fullscreen$e,
	Upgrade: Upgrade$e,
	"Email address": "Email address",
	"of Unlimited": "of Unlimited",
	"No notifications yet": "No notifications received in the last 7 days.",
	"No videos yet": "No videos yet",
	Management: Management$e,
	Day: Day$e,
	Month: Month$e,
	"Welcome to the BlackVue_": "Welcome to the BlackVue Cloud Viewer",
	"You can access BlackVue_": "You can access BlackVue Cloud from the web anytime, anywhere!",
	"Start tour": "Start tour",
	"Map view": "Map view",
	"Check the current_": "Check the current GPS location and speed of your cameras and public cameras.",
	"Camera’s features": "Camera’s features",
	"Take a look_": "Take a look at the various Cloud related features provided by BlackVue Camera.",
	"Visualize your vehicle’s_": "Visualize your vehicle’s driving route over time.",
	"Smart plan_": "Smart plan : 90 days, Fleet plan : 90 days",
	"Create geofences and2_": "Create geofences and receive real-time notifications.",
	"Got it": "Got it",
	"Manage Fleet members": "Manage Fleet members",
	"Invite fleet members_": "Invite fleet members and assign them to groups.",
	"The moment the_": "The moment the camera detects the Impacts, notifications will be list up here.",
	"Geofence Setup (Web)_": "Geofence setup (Web) and alerts",
	"Original file play_": "Original file play is only available for download",
	"To get most_": "To get the most out of the BlackVue Cloud viewer, your camera must be connected to Cloud. Download the BlackVue application and experience Seamless pairing, from camera addition to Cloud connection all at once!",
	"You haven’t driven_Today": "You haven’t driven your car yet Today. Try drive your car with BlackVue to check your drive report.",
	"You haven’t driven_Month": "You haven’t driven your car yet this Month. Try drive your car with BlackVue to check your drive report.",
	"Fleet Plan only_": "Fleet Plan only available",
	"Overwrite locked event2_": "Overwrite locked Event files when storage is full",
	"DMS’s New firmware_": "DMS’s New firmware available",
	"Highest speed_report": "<b>Highest speed</b>\nLargest value of collected velocity data\nwhich is collected in Meter units, Converting to Km/h and MPH units\n\n<b>Average speed</b>\n(Distance/ hours driven) *3600 average speed. Ex (2622 / 1208 ) *3600 = 7814.907\nKm/h : Integer only,\nMPH’s radix point is up to 2 digits under integer",
	"Choose a cloud_": "Choose a cloud connection method",
	"You need an_": "You need an internet connection to connect to the cloud. Select the device you are using to connect to cloud.",
	"BlackVue SIM card": "BlackVue SIM card",
	"Support model_": "Supported model : DR750X-2CH LTE Plus (NA)",
	"3rd party SIM_": "3rd party SIM card",
	"Support model_SIM": "Support model : DR750X-2CH LTE Plus, DR750-2CH LTE, CM100 LTE",
	"Wi-fi hotspot": "Wi-fi hotspot",
	"Support model_Wifi": "Support model : All BlackVue models",
	"How to connect_": "How to connect to Cloud",
	"Download BlackVue application": "Download BlackVue application.",
	"*If you are_": "*If you are going to use BlackVue SIM card for your Cloud connection, go to {{a}} {{b}}.",
	"Place your phone_": "Place your phone in BT range of the camera. Start your Seamless pairing by {{a}}.",
	"Back to camera_": "Back to camera list",
	"Upgrade for more_": "Upgrade for more featrues!",
	"Upgrading the cloud_": "Upgrading the cloud plan allows you to enjoy more features and manage multiple cameras. Would you like to upgrade your cloud plan?",
	"Explore cloud plans": "Explore cloud plans",
	Later: Later$e,
	"Successfully subscribed": "Successfully subscribed!",
	"1GB data plan": "1GB data plan",
	"First month free_": "First month free, <a>then 10.99 USD/mo</a>",
	"Next billing date": "Next billing date",
	"Once SIM card_": "Once SIM card is inserted in the camera, you can start using BlackVue Cloud features immediately.",
	"Go to SIM_": "Go to SIM management",
	"Manage your BlackVue_": "Manage your BlackVue SIM card here!",
	"Recommended for BlackVue_": "Recommended for BlackVue SIM holders",
	"Connect to cloud": "Connect to cloud",
	"Enter BlackVue SIM_": "Enter BlackVue SIM ICCID number",
	"ICCID number is_": "ICCID number is printed on the SIM card package. Please enter the last 14 digits of the ICCID number.",
	ICCID: ICCID$e,
	"SIM information": "SIM information",
	"Start your free_": "Start your free trial now",
	"SIM card activate_": "SIM card activation date",
	"Based on the_": "Based on the date the SIM card is inserted into the camera and activated when power is applied",
	"Upgrade to 3GB_": "Upgrade to 3GB/5GB plan anytime",
	"Cancel your plan_": "Cancel your plan anytime",
	"No Commitment": "No commitment",
	"Precautions for using_": "Precautions for using the service",
	"After 1GB is_": "After 1GB is exhausted, additional internet is not available.",
	"If you have_": "If you have already inserted a SIM card into the camera and have been using it, the free trial period starts from when you start using it.",
	"This content is_": "This content is specified in the SIM package. We do not support compensation for free periods that have not been provided.",
	"If you have_2": "If you have more questions please contact to <a>CS Team</a>",
	"When OFF, connecting_": "When Off, connecting camera by Seamless pairing is disabled.",
	"1 month free": "1 month free",
	"No commitment. Cancel_": "No commitment. Cancel anytime.",
	"The video has been reported_": "The video has been reported successfully",
	"Free for 1 month": "Free for 1 month",
	"Start your free_2": "Start your free trial",
	"1GB free for_": "1GB free for {{a}} days",
	"1GB data": "1GB data",
	"1 month free_2": "1 month free trial will start from {{a}} including 1GB data for Blackvue SIM card.",
	"Your next billing_": "Your next billing date is {{a}}",
	"SIM card": "SIM card",
	"SIM guide": "SIM guide",
	"SIM card list": "SIM card list",
	"Add SIM card": "Add SIM card",
	"No SIM card_": "No SIM card yet",
	"Search SIM ICCID_": "Search SIM ICCID or name",
	"Cloud disconnected. Failed_": "Cloud disconnected. Failed to play the video",
	"This sim card_": "This sim card is already registered in another account.",
	"Incorrect BlackVue SIM_": "Incorrect BlackVue SIM ICCID",
	"My shared videos": "My shared videos",
	"Number of events": "Number of Events",
	"Added to Event Map": "Added to Event Map",
	"Successfully added video(s)_": "Successfully added video to Event Map!\nIf you would like to check the status and manage shared videos, go to Event Map > My shared videos.",
	"Already added to_": "Already added to Event Map",
	"This video(s) is already added_": "This video is already added to Event Map!\nIf you would like to check the status and manage shared videos, go to Event Map > My shared videos.",
	"BlackVue’s firmware is up_": "BlackVue’s firmware is up to date",
	"Service end": "Service end",
	Resubscribe: Resubscribe$e,
	"Sort ascending": "Sort ascending",
	"Sort descending": "Sort descending",
	plan: plan$e,
	USD: USD$e,
	"Are you sure_Cancel": "Are you sure you want to cancel your subscription? Please note the following and confirm below.",
	"Your current SIM_": "Your current SIM card subscription ends on {{a}} and you will no longer be charged.",
	"After canceling your_": "After canceling your SIM card subscription, you will continue to use SIM data until the end date of your subscription.",
	"You can resubscribe_": "You can resubscribe within 1 month after your current subscription ends. If you would like to resubscribe, please click the ‘Resubscribe’ button in the SIM card list by {{a}} to resubscribe.",
	"Reason to cancel_": "Reason to cancel subscription",
	"Found an alternative": "Found an alternative",
	"Too expensive": "Too expensive",
	"Not required anymore": "Not required anymore",
	"Quality issue": "Quality issue",
	etc_: etc_$e,
	"Please describe in_": "Please describe in detail",
	"SIM card cannot_": "SIM card cannot be deleted because this SIM card is under subscription. If you want to delete this SIM card, please cancel your subscription first.",
	"SIM card cannot_2": "SIM card cannot be deleted because the subscription for this SIM card has not ended yet. Please try again after your subscription ends.",
	"Are you sure_deleteSIM": "Are you sure you want to delete this SIM card?<br/>\n<b>Warning: You can’t undo this action. All of your SIM card information will be deleted immediately.</b>",
	"ICCID number": "ICCID number",
	"Activation date": "Activation date",
	"Current plan": "Current plan",
	"Manage Plan": "Manage Plan",
	"Next billing on": "Next billing on",
	"View Invoices": "View Invoices",
	"Choose best plan_": "Choose best plan for you",
	"Plan summary": "Plan summary",
	"Ends on_": "Ends on {{a}}",
	"Start from_": "Start from {{a}}",
	"Your subscription will_": "Your subscription will be upgraded on {{a}}, when your current plan ends.",
	"Resubscribe plan": "Resubscribe to plan",
	"Your subscription will2_": "Your subscription will start on {{a}}, when your current plan ends.",
	"Usage is estimated_": "Usage estimate as of {{a}}",
	"Days left_": "{{a}} Days left",
	"Data usage cycle": "Data usage cycle",
	Available: Available$e,
	Used: Used$e,
	"Data used": "Data used",
	"Subscribe to n_": "Subscribe to {{a}} data plan applied <b>from {{b}} to {{c}}</b> and {{d}} data plan applied from {{e}}",
	"Will be charged_": "Will be charged on {{a}}",
	"Monthly usage": "Monthly usage",
	"You have fewer_": "You have fewer data remaining for this month!",
	"Get more data": "Get more data!",
	"This video cannot be shared": "This video cannot be shared",
	"This is a video cannot be shared_": "This video cannot be shared because it is missing GPS location data to pin it on the map.",
	Cancelled: Cancelled$e,
	Terminated: Terminated$e,
	"Edit name": "Edit name",
	"Not connected to_2": "Not connected to cloud. Check if your camera is on and internet connectivity module is enabled.",
	"Some functionality is disabled_": "Some functionality is disabled because the camera is not connected to Cloud. Connect to the cloud <a>here</a>.",
	"If you want to cancel_": "If you want to cancel your plan, click <a>Cancel subscription</a>.",
	"Select plan": "Select plan",
	"Event map collects_": "Event Map is a visual representation of the BlackVue Events (Impact, Manual Events, etc.) generated by the community, with a goal to provide insights on road conditions.",
	"Share your Live_": "You can contribute your Live Event Upload files manually or automatically to help populate the Event Map.",
	"You can check_": "You can check out Event videos contributed by the BlackVue community.",
	"Service end_": "Service end : {{a}}",
	"DMS camera recording_": "DMS camera recording in Parking Mode",
	Sort: Sort$e,
	"Are you sure you want_": "Are you sure you want to remove this shared video from Event Map?\n",
	"Remove shared video": "Remove shared video",
	"Explore event map": "Explore Event Map",
	"Event map": "Event Map",
	"Explore the graphic_": "Explore crowd-sourced Events (Impact, Hard Braking, etc.) on the map, view videos shared by the community and contribute your own Events.",
	"You can filter_": "You can toggle between Satellite and Map view and filter the types of Event to display.",
	"This video was removed by_": "This video was removed by an administrator after being reported.\n",
	Bonus: Bonus$e,
	"Your subscription plan": "Your subscription plan",
	"Your free trial will_": "Your free trial will start from {{a}},</br> <strong>until</strong> {{b}}.",
	"Total after free trial": "Total after free trial",
	"This sim card is_": "This sim card is no longer active. Please contact the CS team to receive a new sim card.",
	"Firmware is up_": "Firmware is up to date",
	"Keep in mind": "Keep in mind",
	"Once 1GB of_": "Once 1GB of data is used, the service will not be available until the next Data reset date [or after you upgrade your plan to a higher tier].",
	"After the SIM_": "Once the SIM card is inserted into the camera, the free trial period begins when you start using data.",
	"If you have_questions": "If you have any questions, please contact our <a>Customer Support.</a>",
	"Data reset date": "Data reset date",
	"To use SIM card_": "To use SIM card, please contact BlackVue <a>CS Team</a>",
	"Go to Subscription": "Go to Subscription",
	"An error occurred_subscription": "An error occurred while subscribe to selected plan.",
	"Please try again": "Please try again",
	"Failed to subscribe": "Failed to subscribe",
	"Go to Pricing": "Go to Pricing",
	"SIM cards will_": "SIM cards will show up here as they become available.",
	"1GB for 1_": "1GB for 1 month",
	"Pricing Data": "Pricing Data",
	"If you would like to check_": "If you would like to check the status and manage shared videos, go to Event Map > My shared videos.",
	"Connect to Cloud": "Connect to Cloud",
	"Completed!": "Completed!",
	"Back to App": "Back to App",
	"iOS in-app purchase": "iOS in-app purchase",
	"Android in-app_": "Android in-app purchase",
	"bonus n days": "bonus {{a}} days",
	"Want to contribute your_": "Want to contribute your Live Event Upload videos to the Event Map?",
	"With event map_": "With Event Map, you can visualize crowd-sourced Events (Impact, Hard Braking, etc.) on the map and view videos contributed by the community.",
	"You can edit_3": "You can edit the setting at any time by going to BLACKVUE CLOUD > Camera settings > Privacy Settings.",
	"If you want to remove videos_": "If you want to remove videos from the Event Map, go to Event Map > My shared videos.",
	"Total events": "Total Events",
	"Automatically add Live Event_": "Automatically add Live Event Upload Files to Event Map\n",
	"This camera is publicly_": "This camera is publicly opened for its location only.",
	incomplete_zip: incomplete_zip$e,
	"Live Event Upload_": "Live Event Upload (Storage period: 7 days)\nRequires latest firmware",
	"Thank you for_2": "Thank you for your patience.",
	"Start Web viewer": "Start Web viewer",
	"Are you sure_remove driver": "Are you sure you want to permanently delete driver",
	"An error occurred_sim": "An error occurred while trying to subscribe.",
	"Click the ADD SIM": "Click the ADD SIM button on the SIM Card list page, and then walkthrough the adding sim process again.",
	"Set download options": "Set download options",
	"Information may be_": "Information may be transmitted with a delay and may not reflect actual balances.",
	"Swipe left and right to move": "Swipe left and right to move",
	"Scheduled maintenance Notice": "Scheduled Maintenance Notice",
	"Our Cloud server_": "Our Cloud server will be undergoing scheduled maintenance.",
	"During that time_": "During that time the Cloud features may be unavailable.",
	"Expected maintenance start_": "Expected maintenance start time:",
	"Expected duration_": "Expected duration: {{a}} hours.\n",
	"For more information_": "For more information, please refer to the <a>[Server Maintenance Notice]</a>",
	"Do not remind_": "Do not remind me again",
	"Cloud Server Maintenance": "Cloud Server Maintenance",
	"BlackVue Cloud Service_": "BlackVue Cloud Service is temporarily unavailable",
	"We are currently_": "We are currently performing maintenance.",
	"We apologize for_": "We apologize for the inconvenience.\n",
	"Driver Monitoring System (DMS)": "Driver Monitoring System (DMS)",
	"Distracted occurs_": "Occurs when the driver’s head is more than 50 degrees away from the front. \n",
	"Hand distraction event occurs_": "Occurs when the driver’s hand is detected near their head for an extended period of time (such as when smoking, holding a phone, etc.).",
	"Mask off event occurs_": "Occurs when the driver gets in the vehicle without a mask or when the driver takes his or her mask off.",
	"DMS setting": "DMS Setting",
	"The DMS system has_": "The DMS combines a face detection box for the Detected, Undetected, Distracted, Drowsiness, Mask Off statuses and a movement detection box for the Hand Distraction status.",
	"DMS detection": "DMS detection",
	"There are detection criteria for_": "There are detection criteria for each event. Please refer to the guide below.",
	"DMS camera recording_onoff": "On: the DMS camera records in Parking Mode as long as power is maintained. <br/> Off: the DMS camera powers off soon after entering Parking Mode.",
	"LED lighting for each event_": "The LED one the Driver Monitoring Camera will signal every detection event (Distracted, Drowsiness, etc.).",
	"Drowsy and Distracted each have_": "Drowsiness and Distracted each have three sensitivity conditions.\nPlease refer to the guide interface below.",
	"DMS event detection sensitivity": "DMS Event detection sensitivity",
	"Only drowsy and distracted include_": "Only drowsiness and distracted include sensitivity settings. Also, the set sensitivity applies the same sensitivity to two Events by one setting.",
	"When driver’s eyes close_": "Occurs when the driver closes both eyes while driving for more than 1 second or yawn for 2 seconds.",
	"n digit": "{{a}} digit",
	"You are subscribed_free_Smart": "You are subscribed to the Smart plan of BlackVue Cloud.",
	"Wi-Fi auto turn on": "Wi-Fi auto turn on",
	"Video on a map": "Video on a map",
	"This feature is only_vom": "This feature is only available to users with a Fleet Plan subscription.<br/>Please subscribe to a plan to unlock this feature.",
	"Total n days_": "Total {{a}} days of free trial",
	"Every events of DMC200_": "Every Events of DMC200 occurs in normal mode [not in parking mode]",
	"An undetected event occurs_": "Occurs when the driver is not detected in front of the camera for 1 minute.",
	"A detected event occurs_": "A detected Event occurs when the driver is gazing in front since the power is set in the beginning.",
	"Drowsy sensitivity_": "High : When the driver closes their eyes for more than 1 second, it is considered drowsy driving.<br/><br/>Medium : When the driver closes their eyes for more than 1.5 second, it is considered drowsy driving.<br/><br/>Low : When the driver closes their eyes for more than 2 second, it is considered drowsy driving.",
	"Distracted sensitivity_": "High : If the angle of the head is more than 50 degrees away from the front for 3 seconds, it is detected as Distracted.<br/><br/>Medium : If the angle of the head is more than 50 degrees away from the front for 5 seconds, it is detected as Distracted.<br/><br/>Low : If the angle of the head is more than 50 degrees away from the front for 7 seconds, it is detected as Distracted.",
	"Start your subscription now": "Start your subscription now",
	"Free trial period has expired": "Free trial period has expired",
	"1 data plan will start from_": "Data plan will start from {{a}} including 1GB data for Blackvue SIM card.",
	"Allow the BlackVue_": "Allow the BlackVue app to access your dashcam's GPS data?",
	"We use this_": "We use this to let you track your car's location and speed.",
	"You can edit_": "You can edit the GPS access settings at any time by going to BLACKVUE CLOUD > Camera settings > Privacy settings.",
	"SIM cards": "SIM cards",
	"Subscription status": "Subscription status",
	Upgrades: Upgrades$e,
	"Upgrade plan": "Upgrade plan",
	"Manage plan": "Manage plan",
	"Next plan": "Next plan",
	OR: OR$e,
	"Cancel subscription": "Cancel subscription",
	Undo: Undo$e,
	Invoice: Invoice$e,
	"Daily usage": "Daily usage",
	"Delete SIM": "Delete SIM",
	"New card": "New card",
	data: data$e,
	"SIM card data_": "SIM card data plan subscription can be canceled at <a>sim.blackvuecloud.com</a>.",
	"Your plan from_": "Your plan from today to the next billing date",
	"Applied during_": "Applied during {{a}} ~ {{b}}",
	"From today until_": "The new plan conditions will be applied from the next billing date. Payments for this period will be billed today. <a>Fees are calculated on a prorated basis.</a>",
	"Choose your next plan": "Choose your next plan",
	"Applied from_": "Applied from {{a}}",
	"Payment for this_": "Payment for this plan will be charged on {{a}}.",
	"By sharing your_2": "By sharing your Live View you can let other users vicariously experience the excitement and pleasure of driving all over the world. However, as the personal video may be transmitted you should take special care in deciding what information you share.",
	"Option camera recording_": "Optional camera recording in Parking Mode",
	"Front and option camera_": "Front and Optional camera record together.",
	"Option camera stops_": "Optional camera stops recording 5 min. after entering parking mode. Recording restarts when entering normal mode.",
	"Option camera rotation": "Optional camera rotation",
	"Option camera": "Optional camera",
	"Option camera security": "Optional camera security",
	"Resubscribe until_": "Resubscribe until : {{a}}",
	"Firmware Update Caution": "Firmware Update Caution",
	"Please check below_": "Please check below condition before firmware update for DMC200:",
	"The camera's Wi-Fi_": "The camera's Wi-Fi must be turned on.",
	"Check if your_": "Check if your camera’s WI-FI is on.",
	"DO NOT disconnect_": "DO NOT disconnect coaxial cable during firmware update.",
	"The camera and_": "The camera and DMC200 can be broken down.",
	"DO NOT try_": "DO NOT try to use other features until the camera rebooting finished.",
	"Expecially Reboot camera_": "Especially Reboot camera, SD card format can be critical to breaking down two devices.",
	"Update anyway": "Update Anyway",
	"Invited on_2": "Invited on {{Invited Date}} by <a>{{user}} · {{role}}</a>",
	"BlackVue’s New firmware_": "BlackVue’s New firmware available",
	"valid thru_": "valid thru: {{a}}",
	"Billed monthly": "Billed monthly",
	"90 minutes Live_": "90 minutes Live View / Live Event Upload*",
	"or 2+ videos_": "or 2+ videos in full resolution*",
	"1GB Free Month_": "1GB Free Month Trial",
	"Cancel anytime": "Cancel anytime",
	"8+ hours Live_": "8+ hours Live View / Live Event Upload*",
	"or 12+ videos_": "or 12+ videos in full resolution*",
	"15+ hours Live_": "15+ hours Live View / Live Event Upload*",
	"or 23+ videos_": "or 23+ videos in full resolution*",
	Popular: Popular$e,
	"For Power Users": "For Power Users",
	"Estimates based on_": "* Estimates based on 4.5MB per minute of Live View, Quick View remote playback, or Live Event Upload file, and 190MB per full original resolution video download or playback (at 25Mbps bitrate). Daily idle Cloud connection data usage: 20MB per 24 hours. Data usage is shared among all types of services (Live View, Live Event Upload, etc.).",
	"Balanced Plan": "Balanced Plan",
	"For Light Cloud_": "For Light Cloud Use",
	"Front security (Normal mode)": "Front security (Normal Mode)",
	"Front security (Parking mode)": "Front security (Parking Mode)",
	"BT (Parking mode)": "BT (Parking Mode)",
	"LTE (Parking mode)": "LTE (Parking Mode)",
	"Wi-Fi (Parking mode)": "Wi-Fi (Parking Mode)",
	"Hand distraction": "Hand distraction",
	Mask: Mask$e,
	"Second drowsy is_": "Second drowsy is a drowsy that occurred within 30 seconds of the first drowsy that started Live Event Upload recording.",
	"Second drowsy alert": "Second Drowsiness alert",
	"BlackVue sim card_": "BlackVue sim card can only be used in Canada and US.",
	"Global support is coming soon.": "Global support is coming soon.",
	"The video file not found_": "The video file not found, or there was a problem while playing. Please Try again.",
	"Start Voice Call": "Start Voice Call",
	"End Voice Call": "End Voice Call",
	"Voice call in use": "Voice Call in use",
	"Enable microphone access_": "Enable microphone access to use the Voice Call function. Go to the browser settings page to access your microphone.",
	"You may need to_": "You may need to reload this page for the new settings to take effect.",
	"Eye status": "-",
	"Start time of live event upload video": "Video start",
	"Left eye": "Left eye",
	"Right eye": "Right eye",
	"Drowsy is occured when the driver close his/her eyes more then 1sec": "Drowsy status triggers when the driver's eyes are closed for over 1 second.",
	"Driver's Left eye movements with blinking count and period": "Driver's left eye openness level over time",
	"Driver's Right eye movements with blinking count and period": "Driver's right eye openness level over time",
	"Drowsy big data of the driver and after a Drowsy event occurs": "The graph displays the drowsiness data for the Live Event Upload file and the minute before.",
	"Sharing video to Event Map": "Sharing video to Event Map",
	"Want to use a Voice call?": "Want to use Voice Call?",
	"To use a voice call_": "To use Voice Call, restart Live View and click “Allow”",
	"There is no_": "There is no shared videos yet. \nList will appear when it is shared.",
	"Microphone blocked": "Microphone blocked",
	"Want to center the map on your location?": "Want to center the map on your location?",
	"To let the app access your location_": "To let the app access your location, restart Event Map and select \"OK\" when prompted.",
	"Location access permission required": "Location access permission required",
	"Are you sure you want_2": "Are you sure you want to remove this video from Event Map?",
	"Two-way voice_2": "Two-way voice communication / Voice Call",
	"Not supported by DR650GW and DR650S_": "Not supported by DR650GW and DR650S",
	"DR650S Series only_": "DR650S Series only",
	"Cancel download?": "Cancel download?",
	"Your download is not_": "Your download is not complete. Would you like to cancel the download?",
	"Continue download": "Continue download",
	"Cancel download": "Cancel download",
	"Share your video to the Event Map?": "Share your video to the Event Map?",
	"Afterwards, according to the reaction to the video_": "Afterwards, according to the reaction to the video, it can be classified as a popular video and introduced on the Popular Videos.",
	"Add hashtags and a brief description to describe your video.": "Add hashtags and a brief description to describe your video.",
	"Would you like_": "Would you like to share to Event Map?",
	"Successfully added video_": "Successfully added video to share to Event Map!",
	"This video cannot_": "This video cannot be shared because it is missing GPS location data to pin it on the map.",
	"This video is_": "This video is already added to Event Map.",
	"Share to Event Map": "Share to Event Map",
	"Describe in more_": "Describe in more detail what happens in your video (optional)",
	"Description(optional)": "Description(optional)",
	"Recording mode": "Recording Mode",
	"Event triggers": "Event Triggers",
	DMS: DMS$e,
	"Camera connectivity": "Camera Connectivity",
	"If not allowed_2": "If not allowed, your car’s location and speed will not be accessible over the Cloud.",
	"Share Live View_": "Share Live View Video",
	"Share Live View_2": "Share Live View Audio",
	"Share camera profile": "Share Camera Profile",
	"Parking impact": "Parking Impact",
	"Parking events": "Parking Events",
	"Audio recording": "Audio Recording",
	"Toggle the mic_": "Toggle the mic ON/OFF",
	"Full HD_": "Full HD @ 60fps + Full HD @ 30fps",
	"Video quality": "Video Quality",
	Extreme: Extreme$e,
	"More video files": "More Recording Files",
	"Fewer video files": "Fewer Recording Files",
	"Camera rotation": "Camera Rotation",
	"Video overlay": "Video Overlay",
	"Date & time display": "Date & Time Display",
	"Speed unit": "Speed Unit",
	"Check the orientation_": "Check the orientation of the front camera installed in the vehicle. Select the matching option to record the videos in an upright orientation.",
	"Rotate 180º": "Rotate 180º",
	"Rear camera rotation": "Rear Camera Rotation",
	"Check the orientation_rear": "Check the orientation of the rear camera installed in the vehicle. Select the matching option to record the videos in an upright orientation.",
	"Mirror View": "Mirror View",
	"Select Mirror View_": "Select Mirror View to flip the video horizontally.",
	"Check the orientation_interior": "Check the orientation of the optional camera installed in the vehicle. Select the matching option to record the videos in an upright orientation.",
	"Display off": "Display off",
	"Explore crowd-sourced Events_": "Explore crowd-sourced Events (Impact, Hard Braking, etc.) on the map, view videos shared by the community and contribute your own Events.",
	OFF: OFF$e,
	"Reboots once-a-day_": "Reboots once-a-day at the set time if in Parking Mode for improved stability",
	"Set time": "Set Time",
	"FW language": "Firmware Language",
	"Rear security_2": "Rear Security",
	"Bluetooth (Parking mode)_2": "BT (Parking Mode)",
	"Failed to save_2": "Failed to save Live Event Upload setting.",
	"Event file will_": "Event file will be automatically saved in Live Event Upload storages.",
	"An impact was_": "An Impact was detected during Parking Mode.",
	"When exiting Parking_": "When exiting Parking Mode, your BlackVue announces if an Impact was detected while in Parking Mode. <br/><br/>Notes: <br/>Impacts generate Event videos. Impacts generated within 3 minutes of exiting Parking Mode are ignored.",
	"Protect event files": "Protect Event Files",
	"Turning on this_": "Turn on to protect the last {{a}} Event files from overwriting by Normal or Parking recording files.",
	"Impact Events in_": "Impact Events in Normal(E) and Parking Mode(I)",
	"Manual Events_": "Manual Events (M)",
	"Once 50 Events_": "Once 50 Events are recorded, new Events will overwrite the oldest ones.",
	"Reckless driving unit": "Reckless Driving Unit",
	"Hard acceleration Event": "Hard Acceleration Event",
	Threshold: Threshold$e,
	"Triggers when the_": "Triggers when the camera detects a rate of acceleration per second above the set threshold value.",
	"Triggers when the_2": "Triggers when the camera detects a speed reduction of more than the set threshold value.",
	"Hard braking Event": "Hard Braking Event",
	"Triggers when more_": "Triggers when more than 60 degrees is detected within 2 seconds while driving above the set threshold value.",
	"Every event of DMC200_2": "DMS detection features are only active in Normal Mode. If powered in Parking Mode, the DMS camera only records video.",
	"The DMS system has_2": "The DMS combines a face detection box for the Detected, Undetected, Distracted, Drowsiness, Mask Off statuses and a movement detection box for the Hand Distraction status.",
	"One for face_": "One for face detection : Detected, Undetected, Distracted, Drowsy",
	"The other for_": "The other for motion detection",
	"On: Normal recording_": "On: Normal recording works while power is maintained in Parking Mode",
	"Off: DMS power_": "Off: DMS power off after 5 minutes when entering Parking Mode, Normal recording works until just before off",
	"Drowsy and Distracted_": "Drowsy and Distracted each have three sensitivity conditions.",
	"Please refer to_": "Please refer to the guide interface below.",
	Drowsiness: Drowsiness$e,
	"Drowsiness occurs when_": "Drowsiness occurs when the driver closes both eyes while driving for more than 1 second and yawn for 2 seconds.",
	"Distracted occurs when_": "Occurs when the driver’s head is more than 50 degrees away from the front.",
	"A hand distraction_": "A hand distraction occurs when the driver removes one hand from the steering wheel. [*Smoking and phone calls may be suspected.]",
	"Mask off event_": "Mask-off event occurs in two ways. First is when the driver gets in the car without a mask. Second is when the driver takes their mask off",
	"High When the_": "High : When the driver closes their eyes for more than 1 second, it is considered drowsy driving.",
	"Middle When the_": "Medium : When the driver closes their eyes for more than 1.5 second, it is considered drowsy driving.",
	"Low When the_": "Low : When the driver closes their eyes for more than 2 second, it is considered drowsy driving.",
	"High If the_": "High : If the angle of the head is more than 50 degrees away from the front for 3 seconds, it is detected as Distracted.",
	"Middle If the_": "Medium : If the angle of the head is more than 50 degrees away from the front for 5 seconds, it is detected as Distracted.",
	"Low If the_": "Low : If the angle of the head is more than 50 degrees away from the front for 7 seconds, it is detected as Distracted.",
	Direct: Direct$e,
	"Camera Wi-Fi credentials": "Camera Wi-Fi Credentials",
	"Network name(SSID)": "Network Name(SSID)",
	"Seamless pairing": "Seamless Pairing",
	Remote: Remote$e,
	"Hotspot settings": "Hotspot Settings",
	"Hotspot name": "Hotspot Name",
	"Hotspot name must_": "Hotspot name must be at least 5 characters long",
	"Public cameras may_": "Public cameras may appear on the Explore tab or the World map.",
	"Hard Cornering Event": "Hard Cornering Event",
	"Over speed_2": "Over Speed",
	"Second drawiness alert": "Second Drowsiness Alert",
	"Low Voltage Warning_2": "Hand Distraction",
	"(You)_2": "{{a}} ( You )",
	"This video has been reported_": "This video has been reported and removed by administrator.",
	"Normal Mode recording": "Normal Mode Recording",
	"ON : the camera_": "ON : The camera records continuously in a loop.",
	"OFF : the camera_": "OFF : The camera records only Event videos while driving.",
	"In both modes_": "In both modes, detected Impacts trigger Event video recordings",
	"Continuously records_": "Continuously records 1-frame-per-second 1-minute videos that cover 30 minutes of action.",
	"Choose detection regions_": "Choose detection regions to reduce the risk of triggering unwanted motion recordings due to trees swaying in the wind, far-away moving objects, etc.",
	"Your previous plan is expired.": "Your previous plan is expired.",
	"Upgrade the plan to restore the camera": "Upgrade the plan to restore the camera",
	"Are you sure you want to Remove_": "Are you sure you want to Remove this from Cloud slot?",
	"Remove: It doesn’t mean_": "Remove: It doesn’t mean deleting the camera’s data but making a spare slot for the number of cloud cameras.",
	"Now the camera is removed from cloud slot": "The camera was removed from the Cloud slot.",
	"How to delete camera list": "How to delete a camera from the list",
	Update: Update$e,
	"Camrea setting": "Camrea setting",
	"Notification setting": "Notification setting",
	"Driving reports": "Driving reports",
	"Cloud connection steps": "Cloud Connection Step",
	"Download the BlackVue app to add a camera": "Download the BlackVue app to add a camera",
	"To see your camera in the BlackVue cloud viewer_": "To see your camera in the BlackVue cloud viewer, you must first connect it to the cloud. Easily set up and connect your BlackVue camera to the Cloud with the BlackVue app for iOS and Android.",
	"Download the BlackVue app to see a Wi-Fi connected camera": "Download the BlackVue app to see a \n Wi-Fi connected camera",
	"BlackVue Cloud web viewer only supports_": "BlackVue Cloud web viewer only supports the cloud connected dashcam. Please download the BlackVue app to see your Wi-Fi connected dashcam.",
	"You can restore the data if_": "You can restore the data if you register this camera to the same account again. but if the account has been deleted all your files will be lost.",
	"How to add camera": "How to add camera",
	"Try to wait 2-3 minutes if you just registered the camera.": "Try to wait 2-3 minutes if you just registered the camera.",
	"Try to check the Cloud Connection Settings again_": "Try to check the Cloud Connection Settings again, if the camera still does not connect to the Cloud.",
	"Motion Detection": "Motion Detection",
	"Parking recordings occur_": "Parking recordings occur when visible movement is detected.",
	"Motion Sensitivity": "Motion Sensitivity",
	"Motion Detection Sensitivity": "Motion Detection Sensitivity",
	"Select Detection Region": "Select Detection Region",
	"Speed alert_2": "Speed Alert",
	"Live Event Upload_2": "Live Event Upload",
	"Beep Alert": "Beep Alert",
	"Parking Impact History_": "Parking Impact History Alert",
	"To register your_": "To register your SOS Button, you must use the BlackVue App",
	"SOS button on/off": "SOS button on/off",
	"File sharing to Event Map is_": "File sharing to Event Map is currently not available. Please check back later.",
	"Email Notifications": "Email Notifications",
	"Push Notifications_2": "Push Notifications",
	"Optional Camera Rotation": "Optional Camera Orientation",
	"Optional Camera Security": "Optional Camera Security",
	Option: Option$e,
	"(Owner)": "{{a}} (Owner)",
	"SOS button": "SOS Button",
	"This video has been reported_bold": "This video has been reported and <b>removed by administrator.</b>",
	"Number of events_2": "Number of events",
	"My Shared Videos": "My Shared Videos",
	"No Hashtags": "No Hashtags",
	"I have read and agree_": "I have read and agree to all",
	"14 years old_": "14 years old or older",
	Required: Required$e,
	Optional: Optional$e,
	"Profile information_": "Profile information can be edited on the Account Settings page.",
	"Automatically Add Live_": "Automatically Add Live Event Upload Files to Event Map",
	"You must be 14 years_": "You must be 14 years old or older to create BlackVue account",
	"Use 8 or more characters_": "Use 8 or more characters with a mix of either letters, numbers, or symbols",
	"Protected files include_": "Protected files include: <br/>ㆍ Impact Events in Normal(E) and Parking Mode(I)<br/>ㆍ Manual Events (M)<br/><br/>Once {{a}} Events are recorded, new Events will overwrite the oldest ones.",
	"Protected files include": "Protected files include",
	"If you turn_": "If you turn off Voice Guidance, the following lists are off",
	"Live Event Upload_success": "Live Event Upload settings saved successfully.",
	"Video type": "Video type",
	"Notify the Owner": "Notify the Owner",
	"Adjusting the cut-off voltage_2": "Adjusting the cut-off voltage to a lower setting may result in your dash cam draining more power from your battery. This could result in warning messages of battery drain or affect other vehicle functions.\nPlease consult with your dealership before lowering the voltage.",
	Others: Others$e,
	"This video has been removed.": "This video has been removed.",
	"Please assign cameras_": "Please assign cameras to this group.",
	"Are you running_": "Are you running out of chance to watch Playback?",
	"Upgrade your plan_": "Upgrade your plan to Fleet Plan for Unlimited Playback, and other Cloud -Exclusive features.",
	"Are you running_Liveview": "Are you running out of time to watch Live View?",
	"Upgrade your plan_Liveview": "Upgrade your plan to Fleet Plan for Unlimited Live View, and other Cloud -Exclusive features.",
	Stay: Stay$e,
	"Go to Fleet Plan": "Go to Fleet Plan",
	"It looks like the video file is being prepared. please try again later.": "It looks like the video file is being prepared. please try again later.",
	"Oops!": "Oops!",
	"Please back up_": "Please back up all important recordings before changing this setting.",
	"When you save_": "When you save the settings the microSD card will be formatted and all recordings will be deleted to ensure stable operation.",
	"This is an unregistered_": "This is an unregistered email. Would you like to go to the Create account page?",
	"Camera name must_2": "Camera name must be between 5 to 32 characters.",
	"G-sensor (Normal mode)": "G-sensor (Normal mode)",
	"G-sensor (Parking mode)": "G-sensor (Parking mode)",
	"Up & down": "Up & down",
	"Front & back": "Front & back",
	"Rotate Video 180º": "Rotate Video 180º",
	Mask_2: Mask_2$e,
	"Priority event": "Priority Event",
	"There is no_camera": "There is no camera that your owner assigned to you.",
	"Camera SSID": "Camera SSID",
	"The BlackVue dashcam_2": "The BlackVue dashcam is not compatible with 5GHz wireless networks",
	"Driver detection box_2": "Driver Detection Box",
	"DMS camera recording_2": "DMS Camera Recording in Parking Mode",
	Low_2: Low_2$e,
	Medium_2: Medium_2$e,
	High_3: High_3$e,
	"Live Event Upload_3": "Live Event Upload",
	"Driving Impact": "Driving Impact",
	"Video source_2": "Video Source",
	"Front camera_2": "Front Camera",
	"Rear camera_2": "Rear Camera",
	"Optional Camera": "Optional Camera",
	"Motion Detection_2": "Motion Detection",
	"Rear camera stops_2": "Rear camera stops recording 5 minutes after entering Parking Mode. Recording restarts when entering normal mode.",
	"Passenger vehicle": "Passenger Vehicle",
	"Heavy vehicle": "Heavy Vehicle",
	Highest_3: Highest_3$e,
	Extreme_2: Extreme_2$e,
	"Less recording files": "Fewer Recording Files",
	"Camera rotation_2": "Camera Rotation",
	"Share camera profile_2": "Share Camera Profile",
	Private_2: Private_2$e,
	"BlackVue Live": "BlackVue Live",
	"Important All saved_": "Important! All saved videos are about to be deleted. Tap Cancel and back up important files if needed.",
	"Whenever saving settings_": "Whenever saving settings after changing the time zone, the SD card is initialized and all stored files are deleted.",
	"Do you want_": "Do you want to save your changes?",
	"No groups": "No groups",
	Lite: Lite$e,
	"USD per Camera": "USD per extra Camera",
	"up to Cameras": "up to Cameras",
	"All the P Plan_": "All the <b>{{a}}</b> Plan features, plus:",
	"User Roles and Permissions": "User Roles and Permissions",
	"Geofence Setup (Web) and alerts": "Geofence Setup (Web) and alerts",
	"N Times": "{{a}} Times",
	"N Minutes": "{{a}} Minutes",
	"Emergency Alarm": "Emergency Alarm",
	"Playback, Live View": "Playback, Live View",
	"Your driving record : Daily, Monthly": "Your driving record : Daily, Monthly",
	"Real-time Conversation": "Real-time Conversation",
	"Initiate a conversation_": "Initiate a conversation with the driver through the dashcam's speaker and microphone.",
	"Remote Voice Communication": "Remote Voice Communication",
	"See the last location_": "See the last location of your camera",
	"Check your cars_": "Check your car's real-time GPS data on a map to locate your vehicle and obtain information on its status, such as whether it's driving or parked, and its speed.",
	"Supported models_": "* Supported models: S and early X Series models",
	"GPS Tracking &_": "GPS Tracking & Video On Map (Smart/Fleet)",
	"Track your cars_": "Track your car’s location and speed on the map!",
	"GPS Tracking: visualize_": "GPS Tracking: visualize your driving log on the map.\nVideo On Map: view contextual info (Speed, Event type) and play related videos right from the map.",
	"Visualize your cars_": "Visualize your car’s location and speed on the map!",
	"The feature enables_": "The feature enables uploading of video footage to the cloud, including 5 seconds prior to an accident.",
	"Camera profile setting": "Camera profile setting",
	"Are you running_Download": "Are you running out of chance to Download Video?",
	"Upgrade your plan_Download": "Upgrade your plan to Fleet Plan for Unlimited Download, and other Cloud -Exclusive features.",
	"This feature is available for Smart and Fleet_": "This feature is available for Smart and Fleet Plan subscribers only.",
	"Rear camera will keep_": "Rear camera will keep recording until high temperature status on dashcam after turning into parking mode. Rear camera will stop recording automatically when the the high temperature arrives. Rear camera will start recording again after front camera's temperature recovery to normal status. (Caution: Considering of protecting dashcam, Blackvue is possible to shut down due to external temperature.)",
	"Get Unlimited Cloud_": "Get Unlimited Cloud playback and manage up to {{a}} cameras.",
	"Up to N cameras_": "Up to {{a}} cameras (+ {{b}} USD Extra charge)",
	"N Minutes per Day": "{{a}} minutes per Day",
	"Drowsiness sensitivity is_": "Drowsiness sensitivity is set by eye blinking period with reliable BlackVue algorithm. <br> <br> Distracted sensitivity is set by driver’s head position angle from the front and its lasting time.",
	"Not available with this plan": "Not available with this plan",
	"The optional camera records_": "Optional camera records in Parking Mode",
	"Smart and Fleet_": "Smart and Fleet Plan<br/>subscribers only",
	"This feature is_smart": "This feature is available for Smart and Fleet Plan subscribers only.",
	"Camera Registration": "Camera Registration",
	"Voice Call": "Voice Call",
	"N times per Month": "{{a}} times per Month",
	"Recommended for higher bitrate_": "Recommended for higher bitrate and better video quality.",
	"Recommended for for better compatibility_": "Recommended for better compatibility with desktop and mobile devices.",
	"A minute of front camera_": "Estimated file size for 1 minute video (Front Camera)",
	"Extreme(N Mbps): N MB_": "Extreme ({{ex1}}Mbps) : {{ex2}}MB\nHighest ({{ht1}}Mbps) : {{ht2}}MB\nHigh ({{hi1}}Mbps) : {{hi2}}MB\nNormal ({{no1}}Mbps) : {{no2}}MB",
	"File size information reflects_": "File size information reflects the maximum possible size and actual file sizes may vary depend on recording conditions.",
	Bitrate: Bitrate$e,
	"Connection has been_": "Connection has been lost. \nRe-establishing connection...",
	"Unable to establish_": "Unable to establish a connection with the camera. \nPlease ensure your device is properly connected and try again.",
	"Purchased by Payment Service": "Purchased by Payment Service",
	"Up to N Cameras": "Up to {{a}} Cameras",
	"Unlimited Live View": "Unlimited Live View",
	"N Days GPS Tracking": "{{a}} Days GPS Tracking",
	"Unlimited Playback and Download": "Unlimited Playback and Download",
	hours: hours$e,
	"Live Event Upload or_": "Live Event Upload or 12+ videos in full resolution",
	"During the usage period of the One Plan_": "During the usage period of the One Plan service, subscription plan changes are not possible. To switch to a different plan, please contact BlackVue Customer Support to cancel the One Plan subscription",
	"Service Period (Include SIM Data)": "Service Period (Include SIM Data)",
	"Purchase the BlackVue One Package_": "Purchase the BlackVue One Package to unlock the One Plan free for 1 year.",
	"3GB SIM Data Plan": "3GB SIM Data Plan",
	"Unlimited Live View, Playback and Download": "Unlimited Live View, Playback and Download",
	"within data availability": "within data availability",
	"The BlackVue One Plan is a 1-year_": "The BlackVue One Plan is a 1-year Cloud service plan accessible exclusively through the purchase of a BlackVue One Package, which is a bundle including dash cam, 1-year 3GB/mo data plan (for US and Canada) and 1-year Cloud service plan.",
	"The BlackVue One Package is available_": "The BlackVue One Package is available exclusively at the BlackVue Online Store.",
	"Go to BlackVue Shop": "Go to BlackVue Shop",
	"Anonymous Cam": "Anonymous Cam",
	"App only": "App only",
	Expires: Expires$e,
	"N days remaining": "{{a}} days remaining",
	"No action needed_": "<b>No action needed.</b> The new reduced price will be applied automatically starting from your next payment after September 13.",
	"The new reduced price_": "The new reduced price will apply to your account automatically.",
	"Smart Plan Subscriber?": "Smart Plan Subscriber?",
	"Fleet Plan Subscriber?": "Fleet Plan Subscriber?",
	"Please take a moment to_": "Please take a moment to authorize us to migrate your account.",
	"Starting from now and_": "<b>Starting from now and until October 31</b>, you can let us make the change for you by <a href=\"https://form.jotform.com/232411253056041\" target=\"_blank\">Clicking this link</a> and entering your Fleet account email.\n\nPlease allow us some time to process the change. Alternatively, you will be able to cancel your existing account and resubscribe at the new price from September 13.",
	"Once activated_": "Once activated, the One Plan cannot be paused or deactivated.",
	"Once the One Plan is activated_": "Once the One Plan is activated, the One Package cannot be refunded.",
	"Up to N Cloud Camera Slot": "Up to {{a}} Cloud Camera Slot",
	"nGB of Cloud Storage": "{{a}}GB of Cloud Storage",
	"Get started for free_": "Get started for free, no credit card required. Includes Alert Push Notifications, limited Remote Live View and cloud storage.",
	"The BlackVue One Plan is exclusively_": "The BlackVue One Plan is exclusively available through the purchase of a BlackVue One Package. 3GB/mo data plan is for US and Canada only. BlackVue Cloud’s Free Plan, Lite Plan (1~3) and Smart Plan (1~3) accounts can upgrade to One Plan. However, Lite Plan (4~15), Smart Plan (4~15) and Fleet Plan accounts can not be upgraded to One Plan.",
	"For N year": "For {{a}} year",
	"Included in the One Package": "Included in the One Package",
	"3GB SIM Data Plan for N year": "3GB SIM Data Plan for {{a}} year",
	"One Plan Cloud Service for N year": "One Plan Cloud Service for {{a}} year",
	"The BlackVue One Package includes_": "The BlackVue One Package includes all you need to enjoy BlackVue Cloud for a whole year!",
	"4K LTE Dash Cam_": "4K LTE Dash Cam, Cloud Service and Data Plan",
	"nGB included": "{{a}}GB included",
	"nGB per camera": "{{a}}GB per camera",
	"N Days Live Event Upload": "{{a}} Days Live Event Upload",
	"Up to N Dash Cameras": "Up to {{a}} Dash Cameras",
	"Step N/N": "Step {{a}}/{{b}}",
	"Cloud Connection": "Cloud Connection",
	"To pair your dashcam": "To pair your dashcam with the battery, please connect it to the Cloud.",
	Check: Check$e,
	"Unpair Battery": "Unpair Battery",
	"Are you sure you want to unpair": "Are you sure you want to unpair this battery (%@) from the camera?",
	"Unpair: It doesn't mean": "Unpair: It doesn’t mean deleting the battery’s data.",
	"*The paired battery will": "*The paired battery will also be removed together.",
	"Would you like to pair this": "Would you like to pair this battery?",
	"Battery successfully paired": "Battery successfully paired.",
	"Now you can directly connect to": "Now you can directly connect to the battery from the camera list.",
	"Pairing failed": "Pairing failed. Please try again.",
	"Battery Name": "Battery Name",
	"Capacity History": "Capacity History",
	"The graph displays capacity": "The graph displays an approximate battery level using data from the cloud connection.\n The battery capacity may vary depending on temperature, dashcam settings and frequency of triggering events.",
	"Last 24 Hours": "Last 24 Hours",
	"Last 7 Days": "Last 7 Days",
	"Battery Level": "Battery Level",
	"Temperature History": "Temperature History",
	"The graph displays temperature": "The graph displays an approximate temperature level using data from the cloud connection.",
	"Temperature Level": "Temperature Level",
	"Connecting alert": "[ Connecting ]\nData displayed upon connection.",
	"Low Output power Alert": "[ Output power cut-off ]\nThe output voltage is too low, limiting the connected device’s power supplying.",
	"High temp Alert": "[ Input power cut-off ]\nThe battery temperature is too high, limiting charging.",
	"Remaining time": "Remaining time",
	"Remaining time estimate": "Remaining time is an estimate based on the total power consumption of the connected devices.\n It is recalculated every 30 seconds after connecting to the battery.",
	"Setting changed": "Setting changed",
	"Setting change failed": "Setting change failed",
	"Low Input power Alert": "[ Input power cut-off ]\nThe charging voltage is too low, limiting charging.",
	"High Input power Alert": "[ Input power cut-off ]\nThe charging voltage is too high, limiting charging.",
	"Low temp_Cut off Alert": "[ Input power cut-off ]\nThe battery temperature is too low, limiting charging and lasting time.",
	"Low temp Alert": "[ Low temperature ]\nThe battery temperature is too low, limiting lasting time and charging speed.",
	"Low capacity Alert": "[ Low capacity ]\nThe battery capacity is too low.\nDrive the car to charge it.",
	"Back to list": "Back to list",
	Saving: Saving$e,
	Now: Now$e,
	"Power supplying is limited": "Power supplying is <b>limited</b>",
	"This battery is already paired": "This battery is already paired.",
	"Connecting to Battery": "Connecting to Battery",
	"Paired battery": "Paired battery",
	"Battery unpairing failed": "Battery unpairing failed. Please try again.",
	"A connection is already active": "A connection is already active. Please try again later.",
	"Searching for battery": "Searching for battery",
	"Select battery to pair with your camera": "Select battery to pair with your camera.",
	"Unable to connect": "Unable to connect",
	"A connection error has occurred": "A connection error has occurred. Please try again.",
	"The paired dashcam has been disconnected": "The paired dashcam has been disconnected from the Cloud.\nPlease check below conditions.",
	"Check if the battery is not fully discharged": "Check if the battery is not fully discharged",
	"Check the Cloud connection of the paired dashcam": "Check the Cloud connection of the paired dashcam",
	"Connection lost": "Connection lost",
	"A connection error has occurred shortly": "A connection error has occurred. Please try to connect shortly.",
	"Charging is limited": "Charging is <b>limited</b>",
	"Cannot connect to the battery": "Cannot connect to the battery.",
	"Please check the Cloud connection of the camera": "Please check the Cloud connection of the camera.",
	"Charging complete in": "Charging complete in %@",
	"Current Capacity": "Current Capacity",
	"Output Voltage": "Output Voltage",
	"Charging Voltage": "Charging Voltage",
	Beep: Beep$e,
	"Battery Capacity": "Battery Capacity",
	"Battery connection failed": "Battery connection failed",
	"Expansion battery": "Expansion Battery",
	"Make sure it is switched on and within range": "• Make sure it is switched on and within range of your mobile.",
	"Make sure it is not wirelessly connected to another device": "• Make sure it is not wirelessly connected to another device.",
	"Detected batteries": "Detected batteries",
	"Can't see your battery": "Can't see your battery?",
	"Download the Blackvue app to check": "Download the BlackVue app to check your battery remotely",
	"By Using the app": "By using the app, you can pair your dashcam with the battery and monitor the battery’s capacity over the Cloud. After pairing, you can check the battery in the BlackVue Cloud Viewer.",
	Unpair: Unpair$e,
	"Occurs when the driver closes_": "Occurs when the driver closes both eyes while driving",
	"Occurs when the driver's head_": "Occurs when the driver's head is more than 50 degrees away from the front.",
	"Only detects distraction above_": "Only detects distraction above the set value. You can change the unit in ‘Camera Settings > Event Triggers > Reckless Driving Unit’.",
	"Occurs when the driver is not wearing_": "Occurs when the driver is not wearing a seat belt.",
	"Overlays a face detection box_": "Overlays a face detection box on DMS camera live and recorded footage.",
	"Seat Belt": "Seat Belt",
	Detected: Detected$e,
	"No Seat Belt": "No Seat Belt",
	"Fatigue Risk Alert": "Fatigue Risk Alert",
	"The time is synchronized_Email": "The time is synchronized with the time in your Email Notifications.",
	"Sends an alert when drowsiness is_": "Sends an alert when drowsiness is detected after the initial drowsiness.",
	"Data updates upon connection": "Data updates upon connection.",
	"Sends a notification if_": "Sends a notification if you exceed the 'Set Time' during your drive.",
	"Data updates Alert": "[ Connecting ]\nData updates upon connection.",
	"Cannot save settings": "Cannot save settings",
	"The time is synchronized_Push": "The time is synchronized with the time in your Push Notifications.",
	"The file has been overwritten or deleted": "The file has been overwritten or deleted.",
	"Box Pro Models Settings": "Box Pro Models Settings",
	"Push notifications can be configured_": "Push notifications can be configured in the notification settings of the camera.",
	"Recording Video": "Recording Video",
	"Cameras settings": "Cameras settings",
	"Please configure the settings": "Please configure the settings",
	"Speed Priorities": "Speed Priorities",
	"Set Speed Priority": "Set Speed Priority",
	"Geofence-enter": "Geofence-enter",
	"Geofence-exit": "Geofence-exit",
	"Geofence-pass": "Geofence-pass",
	"Geofence-speed alert": "Geofence-speed alert",
	"Drive Position": "Drive Position",
	"Left-Hand Drive": "Left-Hand Drive",
	"Right-Hand Drive": "Right-Hand Drive",
	"Please configure this setting_": "Please configure this setting if the driver is not detected correctly.",
	"A new feature in the BlackVue settings_": "A new feature in the BlackVue settings has been added to sync the camera time. You should sync your camera time once for accurate time recording.",
	"Feature location_": "Feature location:\nCamera settings> System > Time sync",
	"Time Sync": "Time Sync",
	"You can sync the time between_": "You can sync the time between your device and the BlackVue camera. Formatting the SD card is required for synchronization. Before you proceed, please back up any necessary videos.",
	"Get started with_": "Get started with a free 1-month trial",
	"Experience all of_": "Experience all of FLEETA's premium features for free during your 1-month trial.\n\nNo commitment—cancel anytime",
	"Agree to all": "Agree to all",
	"Welcome to FLEETA Webviewer.": "Welcome to FLEETA Webviewer.",
	"Let FLEETA get_": "Let FLEETA get to know you",
	"Help improve your_": "Help improve your experience by sharing a few details",
	"What is you_": "What is you business industry?",
	"Business Industry": "Business Industry",
	"How many employees_": "How many employees do you need to manage?",
	"How many vehicles_": "How many vehicles does your company operate?",
	"Why do you_": "Why do you use a fleet tracking service?",
	"Vehicle & Cargo": "Vehicle & Cargo",
	Compliance: Compliance$e,
	"Skip tour": "Skip tour",
	"In the cloud_": "In the cloud environment, you can access playback, live view (including multiview), live GPS, and reports, all through the FLEETA Web Viewer.",
	"Toggle to switch_": "Toggle to switch Map / List",
	"In List View_": "In List View, you can easily view and manage groups, members, and firmware information at a glance.",
	"Download the Blackvue_": "Download the BlackVue app to add a camera",
	"Set your image_": "Set your image using the provided frame. Once the image is saved, it will be displayed in the camera card and map view icon.",
	"*Only jpg and_": "*Only jpg and png files are supported.",
	"Leave without saving": "Leave without saving",
	"Cloud Storage is_": "Cloud Storage is where your uploaded videos are stored securely in the cloud. Upload your videos to keep them safe for a long time.",
	"Difference Between FLEETA_": "Difference Between FLEETA Drive and Live Event Upload",
	"FLEETA Drive stores_": "FLEETA Drive stores videos that you’ve uploaded manually",
	"Live Event Upload automatically_": "Live Event Upload automatically stores videos when an event occurs.",
	"Live Event Upload videos_": "Live Event Upload videos have an expiration period. If you wish to keep them long, move them to FLEETA Drive.",
	"Note: SD Card_": "Note: SD Card Videos in Playback",
	"Videos stored on_": "Videos stored on your SD card can be accessed through the Playback menu.",
	"Voice Alert": "Voice Alert",
	"Provides a voice alert_": "Provides a voice alert from the camera and sends a notification if you exceed the set time during your drive.",
	"Please enter a value": "Please enter a value.",
	"Notices & Notifications": "News & Notifications",
	"Only detects drowsiness above_": "Only detects drowsiness above the set value. You can change the unit in ‘Camera Settings > Event Triggers > Reckless Driving Unit’.",
	Promotion: Promotion$e,
	Notice: Notice$e,
	"View More": "View More",
	"Read More": "Read More",
	"Detection Box": "Detection Box",
	"Seatbelt Detection Box": "Seatbelt Detection Box",
	"Drive Position Detection Box": "Drive Position Detection Box",
	"Fleet Subscription Promotion (50%)": "Fleet Subscription Promotion (50%)",
	"BlackVue Fleet Tracking exclusive features_": "BlackVue Fleet Tracking exclusive features for power users and businesses alike (Multiple users and cameras, geofencing, Web Viewer etc.).",
	"Special Discount (50% off)": "Special Discount (50% off)",
	"*Promotion applied for 12 months": "*Promotion applied for 12 months",
	"*Payment will be made starting next month.": "*Payment will be made starting next month.",
	"[About using promotions]": "[About using promotions]",
	"The promotion is free for the first month_": "The promotion is free for the first month and then billed for 12 months starting the following month.",
	"For users with an existing Lite/Smart subscription_": "For users with an existing Lite/Smart subscription, you must cancel your existing app subscription separately, otherwise your existing app subscription may be charged to your account.",
	"Please be sure to cancel your app subscription_": "Please be sure to cancel your app subscription within the free period. Double payments will not be refunded.",
	"You will be changed to Fleet Plan immediately_": "You will be changed to Fleet Plan immediately, even if the remaining subscription term of your existing Lite/Smart Plan has not expired.",
	"You can cancel Fleet Plan any time.": "You can cancel Fleet Plan any time.",
	"From February 2025, please go to the Fleeta service and use it.": "From February 2025, please go to the Fleeta service and use it.",
	"After promotion expires_": "After promotion expires, you'll be automatically renewed with existing Fleet Plan subscription fee.",
	"(Required) I have read the promotion instructions_": "(Required) I have read the promotion instructions and agree to payment.",
	"Upgrade to Fleet Plan immediately": "Upgrade to Fleet Plan immediately",
	"Important Notice:": "Important Notice:",
	"Switch of BlackVue Web Viewer to Fleeta Web Viewer": "Switch of BlackVue Web Viewer to Fleeta Web Viewer",
	"To provide better features and quality_": "To provide better features and quality, BlackVue web viewer service will soon switch to a new fleet web viewer service called Fleeta. Fleeta services will be exclusive only for Fleet Plan users. Fleeta service will be launched in March 2025, with a new Fleeta exclusive App. Please visit <a href=\"https://www.fleeta.io\" target=\"_blank\">fleeta.io</a> to find out more.",
	"We kindly ask for your understanding_": "We kindly ask for your understanding, as this change is intended to deliver an improved service. For any questions regarding this transition, please feel free to contact our CS center.",
	"Don’t show this again for this month": "Don’t show this again for this month",
	"Fleet Plan Subscription Promotion": "Fleet Plan Subscription Promotion",
	"Period : December 2, 2024 ~ May 31, 2025": "Period : December 2, 2024 ~ May 31, 2025",
	"See more details": "See more details",
	"To continue improve quality and provide better service_": "To continue improve quality and provide better service, our BlackVue Web Viewer service will soon switch to a Fleet Plan exclusive service. It will no longer be available for free or through other plans starting late March, 2025.",
	"We have prepared special discount offers for_": "We have prepared special discount offers for our existing Web Viewer users. Please check the details below! We kindly ask for your understanding and support as we implement this change to provide a better service.\n",
	"*If you are subscribed in-app_": "*If you are subscribed in-app, please make sure to cancel your in-app subscription.",
	"Enjoy your BlackVue Cloud service with your dashcam.": "Enjoy your BlackVue Cloud service with your dashcam.",
	"Available Cloud Camera slot(s)_": "Available Cloud Camera slot(s) : {{d}}",
	"Not eligible for the promotion.": "Not eligible for the promotion.",
	"You have already used_": "You have already used this promotion. Once the promotion is canceled, it cannot be reapplied.",
	"Go to Cameras": "Go to Cameras",
	"Congratulations !": "Congratulations !",
	"Fleet Plan user": "Fleet Plan user",
	"Let your BlackVue monitor_": "Let your BlackVue monitor your car and alert you of incidents. The moment an Impact is detected, your BlackVue will send a notification to your phone, accompanied by a snapshot.\n",
	"Live Event Upload feature automatically_": "Live Event Upload feature automatically uploads video footage, including pre-accident footage, to BlackVue Cloud Storage to keep your videos safe!",
	"*Buffer time varies by model.": "*Buffer time varies by model.",
	Explore: Explore$e,
	"Cloud Storage": "Cloud Storage",
	"My Cloud Cameras": "My Cloud Cameras",
	"My Cloud Cameras Only": "My Cloud Cameras Only",
	"BlackVue Live Camera": "BlackVue Live Camera",
	"*For BlackVue Live Cameras_": "*For BlackVue Live Cameras, only cameras shared as public in the camera settings can be viewed on the map.",
	"*Share Method_": "*Share Method: Camera Setting>Privacy",
	"Once the promotion is canceled_": "Once the promotion is canceled, the promotion will not be re-applied.",
	"For BlackVue Live Cameras_": "For BlackVue Live Cameras, only cameras shared as public in the camera settings can be viewed on the map. Share method: Camera Setting>Privacy",
	"Cloud Connection Setting": "Cloud Connection Setting",
	"Camera Profile": "Camera Profile",
	"Camera Settings": "Camera Settings",
	"Format MicroSD Card": "Format MicroSD Card",
	"Remote Firmware Update": "Remote Firmware Update",
	"The location may not be accurate_": "The location may not be accurate because the camera is not connected to the cloud.",
	"The location of the camera cannot be found_": "The location of the camera cannot be found. Please check the Cloud Connection Settings.",
	"To learn more about FLEETA_": "To learn more about FLEETA,<br/>please visit <a href=\"https://fleeta.io\" target=\"_blank\">www.fleeta.io</a>.",
	"From December 2nd, please access_": "From December 2nd,<br/>please access our service at<br/><a href=\"https://fleeta.io\" target=\"_blank\">www.fleeta.io</a>.",
	"Starting December 2nd, our service will launch_": "Starting December 2nd, our service will launch to a new platform. Please make sure to access it via <a href=\"https://fleeta.io\" target=\"_blank\">www.fleeta.io</a> after this date.",
	"*If you made the payment through_": "*If you made the payment through the app, please restart the app.",
	"Looking for the Fleeta Free Trial?": "Looking for the Fleeta Free Trial?",
	"BlackVue Fleet Tracking will become_": "BlackVue Fleet Tracking will become Fleeta soon. Sign up now and get started. All your account details will automatically be transferred to the Fleeta service upon launch.",
	"*Fleeta Fleet Service requires_": "*Fleeta Fleet Service requires Cloud-compatible BlackVue dashcams.",
	"The camera location cannot be found_": "The camera location cannot be found due to poor GPS connection.",
	"Unable to display the map.": "Unable to display the map.",
	"Deactivate Cloud": "Deactivate Cloud",
	"Center your location_": "Center your location on the map",
	"Please agree to allow location_": "Please agree to allow location access to enable features based on your current location.",
	"Go to settings": "Go to Settings",
	"It will show_": "It will show up here as they become available.",
	"Only cloud cameras that_": "Only cloud cameras that users choose to share publicly are shown on the map.",
	"Live Broadcast Cameras": "Live Broadcast Cameras",
	"*Live Broadcast Cameras_": "*Live Broadcast Cameras are cloud cameras set to broadcast by users.",
	"Only cloud cameras_": "Only cloud cameras users choose to broadcast are shown on the map."
};

var Dashboard$d = "Panel de control";
var Account$d = "Cuenta";
var Help$d = "Ayuda";
var Mac$d = "Mac";
var Windows$d = "Windows";
var Admin$d = "Administrador";
var Driver$d = "Conductor";
var Cameras$d = "Cámaras";
var Manage$d = "Gestionar";
var Clear$d = "Claro";
var Show$d = "mostrar";
var GB$d = "{{a}}GB";
var _section$d = ".";
var Name$d = "Nombre";
var Password$d = "Contraseña";
var Cancel$d = "Cancelar";
var Members$d = "Miembros";
var Groups$d = "Grupos";
var Role$d = "Rol";
var Group$d = "Grupo";
var Status$d = "Estado";
var nPM$d = "{{a}}PM";
var nAM$d = "{{a}}AM";
var Newest$d = "Más reciente";
var Oldest$d = "Más antiguo";
var Accepted$d = "Aceptado";
var Pending$d = "Pendiente";
var Expired$d = "Caducado";
var All$d = "Todo";
var Delete_$d = "Eliminar {{a}}";
var Delete$d = "Eliminar";
var Rename$d = "Cambiar nombre";
var Add$d = "Añadir";
var OK$d = "OK";
var Remove$d = "Eliminar";
var Files$d = "Archivos";
var Features$d = "Funciones";
var Settings$d = "Configuración";
var Upload$d = "Subir";
var Privacy$d = "Privacidad";
var Done$d = "Hecho";
var Subscription$d = "Suscripción";
var Submasters$d = "administradores";
var Users$d = "conductores";
var Change$d = "Cambiar";
var Method$d = "Método";
var Details$d = "Información de la cámara";
var Confirm$d = "Confirmar";
var Address$d = "Dirección";
var Country$d = "País";
var State$d = "Estado";
var ZIP$d = "Código postal";
var Pricing$d = "Precio";
var Free$d = "Free";
var Smart$d = "Smart";
var Fleet$d = "Fleet";
var Subscrubed$d = "Suscrito";
var January$d = "enero";
var February$d = "Febrero";
var March$d = "marzo";
var April$d = "abril";
var May$d = "Mayo";
var June$d = "junio";
var July$d = "julio";
var August$d = "agosto";
var September$d = "septiembre";
var October$d = "octubre";
var November$d = "noviembre";
var December$d = "diciembre";
var Blackvuecloud_$d = "www.blackvuecloud.com";
var Support$d = "Support";
var Community$d = "Community";
var FAQ$d = "FAQ";
var Developers$d = "Developers";
var Facebook$d = "Facebook";
var Twitter$d = "Twitter";
var Instagram$d = "Instagram";
var Youtube$d = "Youtube";
var Linkedin$d = "Linkedin";
var Downloads$d = "Descargas";
var Unauthorized$d = "No autorizado";
var none$d = "Ninguno";
var Email$d = "Correo electrónico";
var Customers$d = "Customers";
var Home$d = "Home";
var Plan$d = "Plan";
var New$d = "New";
var Unsubscribed$d = "Unsubscribed";
var Edit$d = "Edit";
var month$d = "month";
var months$d = "months";
var Continue$d = "Continue";
var Back$d = "Atrás";
var Master$d = "Owner";
var Develop$d = "Developers";
var $9$d = "$9";
var $15$d = "$15";
var $10$d = "$10";
var mo$d = "Mes";
var City$d = "Ciudad";
var Charge$d = "Cobro";
var subscribe$d = "Suscribirse";
var search$d = "Buscar";
var invalid_number$d = "El número de tarjeta no es un número de tarjeta de crédito válido";
var invalid_expiry_month$d = "El mes de caducidad de la tarjeta no es válido";
var invalid_expiry_year$d = "El año de caducidad de la tarjeta no es válido";
var invalid_cvc$d = "El código de seguridad de la tarjeta no es válido";
var incorrect_number$d = "El número de la tarjeta es incorrecto";
var incomplete_number$d = "El número de la tarjeta está incompleto";
var incomplete_cvc$d = "El código de seguridad de la tarjeta está incompleto";
var incomplete_expiry$d = "La fecha de caducidad de la tarjeta está incompleta";
var expired_card$d = "La tarjeta ha caducado";
var incorrect_cvc$d = "El código de seguridad de la tarjeta es incorrecto";
var incorrect_zip$d = "La validación del código postal de la tarjeta ha fallado";
var invalid_expiry_year_past$d = "El año de caducidad de la tarjeta está en el pasado";
var card_declined$d = "La tarjeta ha sido rechazada";
var missing$d = "No hay ninguna tarjeta en un cliente al que se está cobrando";
var processing_error$d = "Ha ocurrido un error al procesar la tarjeta";
var Paypal$d = "Paypal";
var iOS$d = "iOS";
var Android$d = "Android";
var Total$d = "Total";
var And$d = "y";
var Camera$d = "Camera";
var Yes$d = "Si";
var No$d = "No";
var News$d = "Noticias";
var Notifications$d = "Notificaciones";
var MPH$d = "MPH";
var Firmware$d = "Firmware";
var Basic$d = "Básico";
var Resolution$d = "Resolución";
var Brightness$d = "Luminosidad";
var Recording$d = "Grabación";
var Highest$d = "Máximo";
var High$d = "Alto";
var Normal$d = "Normal";
var Sensitivity$d = "Sensibilidad";
var Volume$d = "Volumen";
var Close$d = "Close";
var Cloud$d = "Cloud";
var Public$d = "Public";
var Front$d = "Frontal";
var Rear$d = "Trasera";
var Play$d = "Reproducir";
var Stop$d = "Detener";
var Pause$d = "Pausar";
var Time$d = "Time";
var System$d = "Sistema";
var Event$d = "Evento";
var Parking$d = "Estacionamiento";
var Color$d = "Color";
var Exit$d = "Salir";
var Save$d = "Guardar";
var Impact$d = "Impacto";
var Unlimited$d = "Ilimitado";
var Default$d = "Predeterminado";
var Version$d = "Versión";
var Language$d = "Idioma";
var Notification$d = "Notificación";
var Multiple$d = "Multi";
var Range$d = "Rango";
var Download$d = "Descargar";
var Manual$d = "Manual";
var Satellite$d = "Satélite";
var Tutorials$d = "Tutoriales";
var Filter$d = "Filtro";
var Sun$d = "Dom";
var Mon$d = "Lun";
var Tue$d = "Mar";
var Wed$d = "Mié";
var Thu$d = "Jue";
var Fri$d = "Vie";
var Sat$d = "Sáb";
var Dates$d = "Fechas";
var Routes$d = "Rutas";
var Opacity$d = "opacidad";
var Entry$d = "Entrada";
var Owner$d = "Owner";
var Undetected$d = "sin ser detectado";
var Distracted$d = "Distraído";
var Drowsy$d = "Drowsy";
var Calling$d = "Calling";
var Smoking$d = "Smoking";
var Permissions$d = "Permisos";
var Private$d = "Privado";
var Entering$d = "Entrando";
var Exiting$d = "Saliendo";
var Acceleration$d = "Aceleración";
var Passing$d = "Pasando";
var Overspeed$d = "Exceso de velocidad";
var Recipients$d = "Destinatarios";
var Send$d = "enviar";
var Note$d = "Nota";
var Video$d = "Vídeo";
var Advanced$d = "Avanzado";
var Voice$d = "Voz";
var Days_$d = "Días";
var Mute$d = "Silenciar";
var UnMute$d = "Activar sonido";
var Discard$d = "Descartar";
var Report$d = "Report";
var Individual$d = "¿Es un conductor que busca tranquilidad? ¿Un propietario de un negocio que necesita una solución de seguridad y seguimiento de vehículos?";
var Subscribed$d = "Suscrito";
var Geofence$d = "Geovalla";
var Driving$d = "Conducción";
var Idling$d = "Ralentí";
var Distance$d = "Distancia";
var Parked$d = "Parked";
var Speed$d = "Velocidad";
var Highest_2$d = "Más alta";
var Average$d = "Media";
var Geofences$d = "Geovallas";
var Move$d = "Mover";
var Connected$d = "Conectado";
var Individual_$d = "Individual";
var Always$d = "Siempre";
var Low$d = "Baja";
var Medium$d = "Media";
var High_2$d = "Alta";
var Flip$d = "Voltear";
var Previous$d = "Marco anterior";
var Next$d = "Siguiente";
var Expand$d = "Expandir";
var Collapse$d = "Contraer";
var More$d = "Más";
var Multi$d = "Multi";
var Safe$d = "Seguro";
var Reckless$d = "Temerario";
var Inattentive$d = "Distraído";
var List$d = "Lista";
var Usage$d = "Uso";
var Profile$d = "Perfil";
var Fullscreen$d = "Pantalla completa";
var Upgrade$d = "Actualizar";
var Management$d = "Gestión";
var Day$d = "Día";
var Month$d = "Mes";
var Later$d = "Más tarde";
var ICCID$d = "ICCID";
var Resubscribe$d = "Volver a suscribirse";
var plan$d = "plan";
var USD$d = "USD";
var etc_$d = "Etc.:";
var Available$d = "Disponible";
var Used$d = "Usado";
var Cancelled$d = "Cancelado";
var Terminated$d = "Terminado";
var Sort$d = "Ordenar";
var Bonus$d = "Bonificación";
var incomplete_zip$d = "La validación del código postal de la tarjeta ha fallado";
var Upgrades$d = "Actualizaciones";
var OR$d = "O";
var Undo$d = "Deshacer";
var Invoice$d = "Factura";
var data$d = "Datos";
var Popular$d = "Popular";
var Mask$d = "Máscarilla quitada";
var DMS$d = "supervisión de estado del conductor (DMS)";
var Extreme$d = "Extremo";
var OFF$d = "Apagar";
var Threshold$d = "Límite";
var Drowsiness$d = "Somnolencia";
var Direct$d = "Directo";
var Remote$d = "Remoto";
var Update$d = "Actualizar";
var Option$d = "Opción";
var Required$d = "Necesario";
var Optional$d = "Opcional";
var Others$d = "Otros";
var Stay$d = "Permanecer";
var Mask_2$d = "Mask";
var Low_2$d = "Low";
var Medium_2$d = "Medium";
var High_3$d = "High";
var Highest_3$d = "Highest";
var Extreme_2$d = "Extreme";
var Private_2$d = "Private";
var Lite$d = "Lite";
var Bitrate$d = "Tasa de bits";
var hours$d = "horas";
var Expires$d = "Expira";
var Check$d = "Revisar";
var Saving$d = "Guardando";
var Now$d = "Ahora";
var Beep$d = "Sonido de advertencia";
var Unpair$d = "Desvincular";
var Detected$d = "Detectado";
var Promotion$d = "Promoción";
var Notice$d = "Actualizaciones";
var Explore$d = "Explorar";
var Deactivate$d = "Desactivar";
var Compliance$d = "Cumplimiento";
var Manufacturing$d = "Manufactura";
var Emergency$d = "Emergencias";
var Security$d = "Seguridad";
var Important$d = "Importante";
var or$d = "o";
var Subscribe$d = "Suscribir";
var Vehicle$d = "vehículo";
var es = {
	Dashboard: Dashboard$d,
	"Payment & Subscriptions": "Pago y suscripciones",
	"Fleet Management": "Gestión de flota",
	"Available to master": "Disponible para maestro",
	"Available to Fleet_": "Disponible para usuarios de plan de Flota",
	Account: Account$d,
	"Log out": "Cerrar sesión",
	"© 2019 Pittasoft_": "© 2019 Pittasoft Co. Ltd",
	"Privacy policy": "Política de Privacidad",
	"Terms of service": "Términos del Servicio",
	Help: Help$d,
	"App store": "App store",
	"Google Play": "Google Play",
	Mac: Mac$d,
	Windows: Windows$d,
	"Free Plan": "Free Plan",
	"Basic Plan": "Basic Plan",
	"Smart Plan": "Smart Plan",
	Admin: Admin$d,
	Driver: Driver$d,
	"Period : December 3, 2024 ~ May 31, 2025": "Período : 3 de diciembre de 2024 ~ 31 de mayo de 2025",
	Cameras: Cameras$d,
	"n of n": "{{a}} de {{b}}",
	Manage: Manage$d,
	"Upgrade Plan": "Cambiar de plan",
	"Add more cameras_": "Añadir más cámaras, gestionar su flota y más...",
	"Usage statistics": "Estadísticas de uso",
	"All cameras": "Todas las cámaras",
	Clear: Clear$d,
	Show: Show$d,
	"Live views": "Vista en directo remota",
	"nh:nm:ns": "{{a}}h:{{b}}m:{{c}}s",
	"Video plays and_": "Reproducciones de vídeo y descargas",
	"Space available": "Espacio disponible",
	GB: GB$d,
	"n%": "{{a}}%",
	"BlackVue app for_": "Aplicación BlackVue para iOS y Android",
	"BlackVue viewer for_": "BlackVue Viewer para Mac y Windows",
	"Welcome to fleet": "Bienvenido a la flota",
	"A few things_": "Estas son algunas cosas que puede esperar encontrarse:",
	"You can watch_": "Puede ver vídeos de las cámaras que se le han asignado en la aplicación BlackVue o en el visor de escritorio.",
	"If the master_deletes": "Si el maestro elimina su cuenta, también se eliminará la de usted.",
	"If the masters_Fleet": "Si la suscripción del plan de Flota del maestro caduca, usted todavía podrá acceder a su cuenta en modo de solo lectura.",
	"You have to_": "Debe registrar una cuenta diferente para añadir una cámara personal.",
	"The Payments &_": "Las secciones de Pagos y suscripciones y Gestión de flota solo están disponibles para el maestro.",
	"You can manage_": "Puede gestionar su grupo de flota en la sección",
	"_Fleet management": "Gestión de flota",
	_section: _section$d,
	"The Payments_section-": "La sección de Pagos y suscripciones solo está disponible para el maestro.",
	"Youre almost there": "Casi ha terminado",
	"Finish account setup": "Complete la configuración de cuenta",
	"Install and log_": "Instale e inicie sesión en la aplicación BlackVue o el visor de escritorio",
	"Download on the_": "Descargar de la App Store",
	"GET IT ON_": "CONSÍGALA en Google Play",
	"Download for Mac": "Descargar para Mac",
	"Download for Windows": "Descargar para Windows",
	"Add your camera_": "Añada su cámara en la aplicación BlackVue o el visor de escritorio",
	"Start managing your_": "Empiece a gestionar su flota y seguir las estadísticas de uso aquí",
	"Cancelled Fleet Plan_": "Plan de flota cancelado el {{date}}",
	"The new plan_": "El plan nuevo entrará en vigor al final de su ciclo de facturación actual.",
	"Profile photo": "Foto de perfil",
	Name: Name$d,
	"E-mail address": "Dirección de correo electrónico",
	Password: Password$d,
	"Last changed_": "Último cambio {{a}}",
	"Change password": "Cambiar contraseña",
	"Delete account": "Eliminar cuenta",
	Cancel: Cancel$d,
	"Current password": "Contraseña actual",
	"New password": "Contraseña nueva",
	"Confirm new password": "Confirmar contraseña nueva",
	"Password changed": "Contraseña cambiada",
	"Reason for deletion_": "Motivo de la eliminación (opcional)",
	"Account password": "Contraseña de cuenta",
	Members: Members$d,
	Groups: Groups$d,
	"+ Invite member": "+ Invitar a un miembro",
	"Name, Email": "Nombre, correo electrónico",
	Role: Role$d,
	Group: Group$d,
	"Date invited": "Fecha de invitación",
	Status: Status$d,
	"Group n": "Grupo {{a}}",
	nPM: nPM$d,
	nAM: nAM$d,
	Newest: Newest$d,
	Oldest: Oldest$d,
	"Name, email or_": "Nombre, correo electrónico o grupo",
	Accepted: Accepted$d,
	Pending: Pending$d,
	Expired: Expired$d,
	All: All$d,
	"No results": "No hay resultados",
	"Try different keywords": "Pruebe otras palabras clave",
	"Try changing or_": "Pruebe a cambiar o eliminar filtros",
	"Remove all filters": "Eliminar todos los filtros",
	"Invite member": "Invitar a un miembro",
	"Send invite": "Enviar invitación",
	"You have reached_": "Ha alcanzado el límite de 10 submaestros. Puede seguir invitando a usuarios.",
	Delete_: Delete_$d,
	"Are you sure_delete": "¿Seguro que desea eliminar este miembro y su cuenta?",
	Delete: Delete$d,
	Rename: Rename$d,
	"No submaster yet": "Todavía no hay ningún submaestro",
	"You can add_": "Puede añadir 1 submaestro por grupo",
	"No cameras yet": "Todavía no hay cámaras",
	"Add cameras first_": "Añada cámaras primero y después asigne usuarios",
	"Name or email": "Nombre o correo electrónico",
	"Add submaster": "Añadir submaestro",
	Add: Add$d,
	"Add camera": "Añadir cámara",
	"n of n selected": "{{a}} de {{b}} seleccionado(s)",
	"No cameras available": "No hay cámaras disponibles",
	"Most likely reasons_": "Los motivos más probables son:",
	"All cameras were_": "Todas las cámaras se han añadido a otros grupos.",
	"You can remove_": "Puede eliminar cámaras de otros grupos y añadirlas a este grupo.",
	"No cameras were_": "No se han añadido cámaras a su cuenta.",
	"You can add_cameras": "Puede añadir cámaras en la aplicación BlackVue o en el visor de escritorio.",
	OK: OK$d,
	"Rename group": "Cambiar nombre de grupo",
	"Are you sure_group": "¿Seguro que desea eliminar este grupo?",
	"Edit Mobile app_": "Editar permisos de la aplicación móvil/visor de escritorio",
	Remove: Remove$d,
	"n of n users": "{{a}} de {{b}} usuarios",
	"Youve reached the_": "Ha alcanzado el límite de usuarios por cámara",
	"Remove user": "Eliminar usuario",
	"Add user": "Añadir usuario",
	"+ Add group": "+ Añadir grupo",
	"Add group": "Añadir grupo",
	"Group or submaster": "Grupo o submaestro",
	"+ Add": "+ Añadir",
	"of max selected": "{{a}} de un máximo de {{b}} seleccionado(s)",
	"Mobile app/desktop_": "Permisos de la aplicación móvil/visor de escritorio",
	Files: Files$d,
	Features: Features$d,
	Settings: Settings$d,
	Upload: Upload$d,
	"Download and Playback_Cloud": "Descargar y reproducir desde el almacenamiento en la nube",
	"Download and Playback_SD": "Descargar y reproducir desde la tarjeta SD",
	"Live view": "Live View",
	"Geo Fencing": "Geovallado",
	"Drive Reports": "Informes de conducción",
	"Firmware Settings": "Configuración del firmware",
	"Push Notifications": "Notificaciones automáticas",
	"Event Auto Upload": "Subida automática del evento en directo",
	Privacy: Privacy$d,
	Done: Done$d,
	"Payment method": "Método de pago",
	"Change payment method": "Cambiar el método de pago",
	Subscription: Subscription$d,
	"Space used": "Espacio usado",
	"Next billing_": "Siguiente facturación {{a}} {{b}}",
	"You manage_available": "Gestiona {{a}} de {{b}} disponible(s) en su plan",
	Submasters: Submasters$d,
	Users: Users$d,
	Change: Change$d,
	"No transactions yet_": "Está suscrito al plan gratuito. Todavía no hay transacciones",
	"No transactions to_": "No hay transacciones para mostrar.<br/>Si busca el historial de transacciones de otras plataformas (p. ej. iOS, Android, PayPal), puede encontrarlo en la página de suscripciones de su propia plataforma.",
	"of nGB_": "{{a}} de {{b}} GB ({{c}}%)",
	"Smart Plan users_": "Los usuarios del Plan Inteligente pueden cambiar el plan de suscripción o el número de cámaras mediante la aplicación para móviles BlackVue",
	"Transaction history": "Historial de transacciones",
	"Date": "Fecha",
	"Amount, USD": "Cantidad, USD",
	Method: Method$d,
	Details: Details$d,
	"iOS in-app_": "Compras en la aplicación iOS/Compras en la aplicación Android",
	"Change the number_": "Cambiar el número de cámaras",
	"You manage_cameras": "Gestiona {{a}} cámaras de {{b}} disponible(s) en su plan",
	"Extra cameras": "Cámaras adicionales",
	"Total due_": "Total a pagar",
	"available on your_": "de {{a}} disponibles en su plan",
	"Cancel Fleet Plan": "Cancelar Fleet Plan",
	"This will cancel_": "Con esto se cancelará su suscripción al Plan de Flota. Cambiará al plan gratuito al final de su ciclo de facturación.",
	"Reason for cancellation_": "Motivo de cancelación (opcional)",
	"Not now": "Ahora no",
	Confirm: Confirm$d,
	"Cardholder name": "Nombre del titular de la tarjeta",
	"Card name": "Nombre de la tarjeta",
	"MM/YY": "MM/YY",
	Address: Address$d,
	Country: Country$d,
	State: State$d,
	ZIP: ZIP$d,
	Pricing: Pricing$d,
	"You are subscribed_": "Está suscrito al plan Gratuito.",
	"With Alert Push_": "Incluye notificaciones push, vista en directo remota limitada y almacenamiento en la nube.",
	Free: Free$d,
	Smart: Smart$d,
	Fleet: Fleet$d,
	"Get started for_": "Empiece a usarlo gratis, no se requiere tarjeta de crédito. \n Incluye notificaciones push, vista en directo remota limitada y almacenamiento en la nube.",
	Subscrubed: Subscrubed$d,
	"Features included:": "Funciones incluidas:",
	"Get unlimited Remote_": "Utilice el servicio de vista en directo remota y reproducción desde la nube de forma ilimitada y gestión de hasta {{a}} cámaras.",
	"BlackVue Fleet Tracking_": "Funciones exclusivas de seguimiento de flota BlackVue para usuarios expertos y negocios (múltiples usuarios y cámaras, geovallado, etc.)",
	"Try 1 Month Free": "Pruebe 1 mes gratis",
	"Log in": "Iniciar sesión",
	"Remember me": "Recordarme",
	"Forgot password?": "¿Ha olvidado la contraseña?",
	"Reset password": "Restablecer contraseña",
	"Enter email address_": "Introduzca la dirección de correo electrónico usada durante el registro y le enviaremos un enlace para restablecer su contraseña.",
	"Send reset password_": "Enviar correo electrónico para restablecer la contraseña",
	"Back to login": "Volver al inicio de sesión",
	"Check your email": "Consulte su correo electrónico",
	"Weve sent an_": "Hemos enviado un correo electrónico a {{a}} con un enlace para que confirme\n su dirección de correo electrónico.",
	"Resend email": "Reenviar correo electrónico",
	January: January$d,
	February: February$d,
	March: March$d,
	April: April$d,
	May: May$d,
	June: June$d,
	July: July$d,
	August: August$d,
	September: September$d,
	October: October$d,
	November: November$d,
	December: December$d,
	"Sign up": "Crear cuenta",
	"First name": "Nombre",
	"Last name": "Apellido",
	"Create a password": "Crear una contraseña",
	"5 or more_": "5 o más caracteres",
	"Sign up and_": "Registrarse y continuar",
	"I agree to_": "Acepto %@, %@, %@ y %@.",
	"Subscribe to newsletter": "Suscribirse al boletín de noticias",
	"1 month free trial_": "1 mes de prueba gratuita",
	"Dont have an_": "¿No tiene una cuenta?",
	"Thank you for_": "Gracias por registrarse en BlackVue Cloud. Confirme su dirección de correo electrónico.",
	"Confirm email": "Confirmar correo electrónico",
	"If you didnt_": "Si usted no ha registrado esta cuenta, puede ignorar este correo electrónico.",
	Blackvuecloud_: Blackvuecloud_$d,
	"invited you to_": "{{a}} le ha invitado a unirse a esta flota como Submaestro.",
	"Accept invitation": "Aceptar invitación",
	"Invite expires on_": "La invitación caduca el dd del mm del aa.",
	"Your Fleet Management_": "%@ ha eliminado su cuenta de gestión de flota registrada con {{a}}.",
	"If you believe_": "Si cree que es un error, póngase en contacto con nuestro servicio de atención al cliente: cs@blackvue.com.",
	Support: Support$d,
	"Help center": "Centro de ayuda",
	Community: Community$d,
	"Getting started": "Empezar",
	FAQ: FAQ$d,
	Developers: Developers$d,
	"Cloud API": "Cloud API",
	"Fleet SDK": "Fleet SDK",
	"Follow us": "Síguenos",
	Facebook: Facebook$d,
	Twitter: Twitter$d,
	Instagram: Instagram$d,
	Youtube: Youtube$d,
	Linkedin: Linkedin$d,
	"BlackVue apps": "BlackVue apps",
	"Camera registraiton": "Registro de cámara",
	"Two-way voice_": "Comunicación por voz bidireccional",
	"Live GPS": "GPS en directo",
	"Event live auto_": "Subida automática del evento en directo",
	"Event file auto_": "Subida auto. de archivo de evento",
	"Compatible with_": "Compatible con los modelos DR650GW y DR650S",
	"Not compatible with_": "No compatible con los modelos DR650GW y DR650S",
	"More cameras": "Más cámaras",
	"More users": "More users",
	"Roles and permissions": "Roles and permissions",
	"More Cloud Storage": "Más almacenamiento en la nube",
	"Multi Live view_": "Multi Live View (Web)",
	"Longer GPS Tracking": "Longer GPS Tracking",
	"Geo Fence setup_": "Geo Fence setup (PC viewer) and alerts (PC viewer and app)",
	"Changes saved": "Cambios guardados",
	"Group added": "Grupo añadido",
	"Member added": "Miembro añadido",
	"Group deleted": "Grupo eliminado",
	"Member deleted": "Miembro eliminado",
	"Group renamed": "Nombre de grupo cambiado",
	"Submaster added": "Submaestro añadido",
	"Camera added": "Cámara añadida",
	"User added": "Usuario añadido",
	"Users added": "Usuarios añadidos",
	Downloads: Downloads$d,
	"The BlackVue App_": "The BlackVue App and Viewer let you use your BlackVue camera to its full potential. Whether on mobile or on home computer, BlackVue gives you the tools to fully enjoy your dashcam's functions.",
	"Compatible with all_": "Compatible with all Wi-Fi enabled BlackVue models.",
	"Supports all BlackVue_": "Supports all BlackVue models to date.",
	"confirm new password": "Confirmar contraseña nueva",
	"Your password is_": "La contraseña introducida es incorrecta",
	"Confirm password does_": "La contraseña no coincide",
	"Please enter_email": "Introduzca una dirección de correo electrónico válida.",
	"Please enter_password": "La contraseña introducida es incorrecta",
	"Internal server error_": "Error interno del servidor, vuelva a intentarlo.",
	"New password is_": "Al menos 1 carácter de su contraseña actual debe ser diferente",
	"It should be_": "La contraseña debe tener al menos 5 caracteres",
	"Invalid permission": "Permiso no válido.",
	"Input data isnt_": "Los datos de entrada no están disponibles.",
	Unauthorized: Unauthorized$d,
	"Already have subsciption": "Ya tiene una suscripción",
	"Already uses": "Ya lo utiliza",
	"Already logged in": "Ya ha iniciado sesión",
	"Already sent e-mail": "Ya ha enviado un correo electrónico.",
	"Please wait": "Por favor, espere.",
	"E-mail is not_": "Todavía no se ha verificado el correo electrónico.",
	"Update your subscription_": "Actualice su suscripción",
	"Account was deleted": "Se ha eliminado la cuenta.",
	"5 ~ 30_": "5 ~ 30 characters",
	"It has exceeded_": "Ha superado el máximo de 9 administradores.",
	"Billing information": "Información de facturación",
	"Please enter cardName": "Introduzca un nombre de tarjeta",
	"Please enter_card": "Introduzca un número de tarjeta válido",
	"Please enter address": "Introduzca la dirección",
	"Please select country": "Seleccione el país",
	"Please enter city": "Introduzca la ciudad",
	none: none$d,
	"Due today": "Vence hoy",
	"Today after 1_": "Hoy tras una prueba de 1 mes",
	"An error occurred_": "Ha ocurrido un error al intentar cambiar la contraseña. Vuelva a intentarlo.",
	"Your account is_": "La cuenta está ahora activa",
	"You can now_": "Ahora puede iniciar sesión en su cuenta con la dirección de correo electrónico usada durante el registro.",
	Email: Email$d,
	"Don’t have an account?": "¿No tiene una cuenta?",
	"Already have an account?": "¿Ya tiene una cuenta?",
	"Cloud service": "Cloud service",
	"for your BlackVue": "for your BlackVue",
	"See what your_": "See what your camera sees remotely.",
	"Receive impact alert_": "Receive Impact alert push notifications.",
	"Save footage to_": "Save footage to the cloud and do much more...",
	"Free plan included_": "Free plan included · Easy setup · Cancel anytime",
	"Taking advantage of_": "Taking advantage of a mobile or car-embedded Internet connection and a BlackVue camera, BlackVue Cloud connects you to your car from anywhere, anytime. Using the BlackVue App on your smartphone or tablet, you see in real time where your car is located and what is happening around it.",
	"Get notifications to_": "Get notifications to your phone when your parked car is hit. Check remotely what is happening around your car.",
	"Monitor your commercial_": "Monitor your commercial vehicles on a map in real time. Talk to your drivers anytime through the BlackVue App or Viewer.",
	"With BlackVue Fleet_": "With BlackVue Fleet Tracking, track in real time up to 100 vehicles from the palm of your hand or with the dedicated BlackVue Viewer.",
	"Get started now_": "Get started now with a Free plan. For unlimited video playback or Remote Live View, upgrade to Lite or Smart plan from the BlackVue App. <br/>Business and power users can unlock the power of the Fleet plan exclusively through this website.",
	"Remote Video Playback_": "Remote Video Playback and Download",
	"Compatible with DR650GW_": "Compatible with DR650GW, DR650S models",
	"Unlimited remote video_": "Unlimited remote video playback and download",
	"Longer cloud storage_": "Longer cloud storage file expiration period",
	"Longer storage period_live": "Longer storage period for Event live auto upload",
	"Longer storage period_file": "Longer storage period for Event file auto upload",
	"Goefence setup (PC_": "Geo-fence setup (PC viewer) and alerts (Windows viewer and app)",
	"App Store": "App Store",
	"Send reset password email": "Enviar correo electrónico para restablecer la contraseña",
	Customers: Customers$d,
	Home: Home$d,
	"Pick a plan": "Pick a plan",
	"No customers yet": "No customers yet",
	"Customers will_": "Customers will show up here as they become available",
	"Add customer": "Add customer",
	"Report(PDF)": "Report(PDF)",
	"Subscription Period": "Subscription Period",
	Plan: Plan$d,
	New: New$d,
	Unsubscribed: Unsubscribed$d,
	"Subscription ends soon": "Subscription ends soon",
	Edit: Edit$d,
	"1 month trial": "1 month trial",
	"Edit customer details": "Edit customer details",
	"Customer name": "Customer name",
	"of 999 available_": "of 999 available on Fleet Plan",
	"Subscription starts": "Subscription starts",
	"Subscription period": "Subscription period",
	month: month$d,
	months: months$d,
	"Cloud storage": "Cloud Storage",
	"Subscription plan": "Tipo de suscripción",
	"Check email address": "Check email address",
	"Add customer details": "Add customer details",
	Continue: Continue$d,
	Back: Back$d,
	"An error occured": "An error occured",
	"Customer added": "Customer added",
	"Last changed": "Last changed",
	"Company name": "Company name",
	"Company address": "Company address",
	"Alert Push Notifications": "Alert Push Notifications",
	"Receive notifications on_": "Receive notifications on your phone when preset Events occur. Great in combination with BlackVue’s Parking Mode.",
	"Remote Live View": "Vista remota en vivo",
	"Remotely monitor your_": "Remotely monitor your car in real time from anywhere, anytime.",
	"Video Backup/Auto Upload": "Video Backup/Auto Upload",
	"Back up videos_": "Back up videos to your phone or Cloud storage.",
	"Two-way Voice Communication": "Two-way Voice Communication",
	"Talk with people_": "Talk with people in the car from your smartphone. The driver can speak while keeping hands on the wheel.",
	"View your car’s_": "View your car’s location and speed on a map. With BlackVue Fleet Tracking, access 90-days’ worth of GPS data.",
	"Remote Video Playback": "Remote Video Playback",
	"Play videos stored_": "Play videos stored in the Cloud or in your dashcam anytime on your smartphone or tablet.",
	"Event Live Auto Upload": "Event Live Auto Upload",
	"Save a video stream_": "Save a video stream in real time to the Cloud. Protect yourself from break-ins and theft.",
	"Event File Auto Upload": "Event File Auto Upload",
	"Save Event videos_": "Save Event videos to the Cloud—including seconds before trigger—after they happen.",
	"Firmware-Over-the-Air (FOTA)": "Firmware-Over-the-Air (FOTA)",
	"Upgrade your dashcam’s": "Update your dashcam over the cloud",
	"When an Event_": "When an Event is created (Impact detected or manually triggered), Event Live Auto-upload lets your Cloud-compatible BlackVue save a live video stream from a camera of your choice (front or rear/interior) to the Cloud server",
	"Event File Auto-upload_": "Event File Auto-upload lets your dashcam automatically upload low-resolution versions of Event files to the Cloud.",
	Master: Master$d,
	"per Camera": "per Camera",
	"Event live auto upload_": "Event live auto upload compatible with all cloud cameras",
	"Drive report": "Drive report",
	"USA/Canada Toll Free": "USA/Canada Toll Free",
	"Monday–Saturday_": "Monday to Friday 8am-7pm / Saturday 9am-6pm (PST).",
	"Please agree to_": "You must accept Terms of Service",
	"Mac or Windows PC": "Mac or Windows PC",
	Develop: Develop$d,
	"Sign out": "Sign out",
	"Referral code": "Código de referencia",
	"Total after 1 month trial": "Total tras prueba de 1 mes",
	"Already Use Stripe Token": "Ya usa un token stripe",
	"Select period": "Seleccione el periodo",
	"State/Region": "Estado/región (opcional)",
	"ZIP/Postal": "Código postal",
	"$0.00": "$0.00",
	"$11.99": "$11.99",
	"$24.99": "$24.99",
	$9: $9$d,
	$15: $15$d,
	$10: $10$d,
	"mo + for_": "/mo + {{a}} per extra camera",
	mo: mo$d,
	"This e-mail address_": "Esta dirección de Internet ya tiene una cuenta registrada.",
	"1 month": "1 mes",
	"Limit is reset daily": "El límite se restablece cada día",
	"Limit is reset monthly": "El límite se restablece cada mes",
	"Video plays and downloads": "Reproducciones de vídeo y descargas",
	"Your master": "Your owner",
	"Youre 1 step_": "Queda un paso para terminar la suscripción del plan de Flota",
	"Finish signing up": "Finalice el registro",
	"Enter billing information": "Introduzca la información de facturación",
	"Proceed to billing": "Ir a facturación",
	City: City$d,
	Charge: Charge$d,
	"User already invited_": "El Maestro ya ha invitado al usuario",
	"n% consumed": "{{a}}% usado",
	"E-mail already exists": "El correo electrónico ya existe",
	"Cancel your inapp_": "Cancele su suscripción desde la aplicación",
	"You have cancel_": "Debe cancelar la suscripción desde la aplicación para cambiar al plan de Flota: 1. Cancele su suscripción actual desde la App Store o Google Play Store. Cambiará al plan gratuito al final de su ciclo de facturación actual. Todos sus datos se mantendrán intactos. 2. Inicie sesión en su cuenta de blackvuecloud.com y cámbiese al plan de Flota.",
	"Edit permissions": "Editar permisos",
	"See permissions": "Ver permisos",
	"Submaster removed": "Submaestro eliminado",
	"Camera removed": "Cámara eliminada",
	"User removed": "Usuario eliminado",
	"Users removed": "Usuarios eliminados",
	subscribe: subscribe$d,
	search: search$d,
	"permission can be_": "Es posible configurar el permiso después de que el submaestro acepte la invitación.",
	"The confirmation link_": "El enlace de confirmación ya no es válido",
	"Possible reasons:_": "Motivos posibles:\n • Ya ha confirmado su dirección de correo electrónico\n • El enlace ha caducado o ha sido cancelado",
	"Failed to register_": "Fallo al registrarse en BlackVue Cloud",
	"There was an_": "Hubo un error durante el proceso de registro. Si el problema persiste, vuelva a intentar registrarse en BlackVue Cloud. Si necesita más asistencia, póngase en contacto con nuestro servicio de atención al cliente:",
	"Upgrade to Fleet_": "Cambiar al plan de Flota",
	"Subscription is Canceled": "Se ha cancelado la suscripción",
	"No members yet": "Todavía no hay miembros",
	"Please enter_group name": "Introduzca un nombre de grupo válido",
	"Group Name": "Nombre de grupo",
	invalid_number: invalid_number$d,
	invalid_expiry_month: invalid_expiry_month$d,
	invalid_expiry_year: invalid_expiry_year$d,
	invalid_cvc: invalid_cvc$d,
	incorrect_number: incorrect_number$d,
	incomplete_number: incomplete_number$d,
	incomplete_cvc: incomplete_cvc$d,
	incomplete_expiry: incomplete_expiry$d,
	expired_card: expired_card$d,
	incorrect_cvc: incorrect_cvc$d,
	incorrect_zip: incorrect_zip$d,
	invalid_expiry_year_past: invalid_expiry_year_past$d,
	card_declined: card_declined$d,
	missing: missing$d,
	processing_error: processing_error$d,
	"no groups yet": "Todavía no hay grupos",
	"groups will show_": "Los grupos aparecerán aquí a medida que estén disponibles",
	"Fleet members will_": "Los miembros de la flota aparecerán aquí a medida que estén disponibles",
	"service provider": "Proveedor del servicio",
	Paypal: Paypal$d,
	iOS: iOS$d,
	Android: Android$d,
	"Enter email": "Introduzca el correo electrónico",
	"Enter password": "Introduzca la contraseña.",
	"Enter first name": "Introduzca el nombre",
	"Enter last name": "Introduzca el apellido",
	"Enter the current_": "Introduzca la contraseña actual",
	"Enter a new_": "Introduzca una contraseña nueva",
	"There isnt an_": "No hay cuentas asociadas con esta dirección de correo electrónico",
	"Fleet Plan": "Fleet Plan",
	Total: Total$d,
	"Password you entered_": "La contraseña introducida es incorrecta",
	"Incorrect email or_": "Correo electrónico o contraseña incorrectos",
	"Available to Masters": "Disponible para propietario",
	"Blackvue url": "https://www.blackvue.com",
	"Information We Collect_": "Información que recopilamos y por qué",
	And: And$d,
	"Terms of Location-Based_": "Términos de Uso del Servicio Basados en la Ubicación.",
	"I agree to the_": "Acepto los",
	"Password Reset_": "Hemos enviado un correo electrónico a {{a}} con las instrucciones para \n restablecer la contraseña.",
	"You have already_": "Ya ha sido invitado, consulte su correo electrónico.",
	"No data available_": "No hay datos disponibles en la tabla",
	Camera: Camera$d,
	"You no longer_": "Ya no tiene permiso para usar el servicio de flota.",
	"Please contact your_": "Póngase en contacto con su maestro de flota para resolver el problema.",
	"You can still_": "Todavía puede acceder a la",
	"account information": "información de su cuenta.",
	"If the issue_": "Si no se ha resuelto el problema y decide seguir usando el servicio de BlackVue Cloud con la dirección de correo electrónico registrada, deberá eliminar su cuenta y volver a registrarse.",
	"If the problem_": "Si el problema persiste, póngase en contacto con nuestro servicio de atención al cliente:",
	"Web subscription only": "Solo suscripción web",
	"AppStore url": "https://apps.apple.com/kr",
	"We no longer_": "Ya no procesamos pagos a través de PayPal. Debe actualizar su suscripción para cambiar el número de cámaras: 1. Inicie sesión en su cuenta de paypal.com y cancele su suscripción de plan de Flota actual para cambiar el número de cámaras: 2. Inicie sesión en su cuenta de blackvuecloud.com y cámbiese al plan de Flota.",
	Yes: Yes$d,
	No: No$d,
	"Serial number": "Número de serie",
	"Cloud code": "Código de nube",
	"Terms & Policies": "Términos y Políticas",
	News: News$d,
	Notifications: Notifications$d,
	"km/h": "km/h",
	MPH: MPH$d,
	"Baidu Maps": "Mapas Baidu (solo en China)",
	"Google Maps": "Google Maps",
	Firmware: Firmware$d,
	Basic: Basic$d,
	"Time Zone": "Zona horaria",
	Resolution: Resolution$d,
	"Image quality": "Calidad de imagen",
	Brightness: Brightness$d,
	Recording: Recording$d,
	"Normal recording": "Grabación normal",
	"Voice recording": "Grabación de voz",
	"Video segment length": "Longitud de segmento de vídeo",
	"Rear camera recording": "Grabación cámara trasera",
	Highest: Highest$d,
	High: High$d,
	Normal: Normal$d,
	"1 min": "1 min",
	"2 min": "2 min",
	"3 min": "3 min",
	Sensitivity: Sensitivity$d,
	"Motion detection": "Detector de movimiento",
	"Speed alert": "Alerta de velocidad",
	"Voice guidance": "Guía por voz",
	"Power on": "Encendido",
	"Power off": "Apagado",
	"Starting normal recording": "Iniciando grabación normal",
	"Changing recording mode": "Cambiando el modo de grabación",
	"Speed alert (beep)": "Alerta de velocidad (pitido)",
	"Cloud related": "Relacionado con la nube",
	Volume: Volume$d,
	"User text overlay": "Sobreponer texto de usuario",
	"A-Z, a-z_": "A~Z, a~z, 0~9, :;’/\\+-_()$#\ninferor a 20 caracteres.",
	"Wi-Fi auto turn off": "Apagar Wi-Fi automáticamente",
	"Login credentials": "Credenciales de acceso",
	"Manual recording": "Grabación manual",
	"By sharing your_": "Al compartir su Vista en Director, podrá permitir a otros usuarios experimentar indirectamente la emoción y el placer de conducir por todo el mundo.",
	"However, as persona_": "Sin embargo, como es posible que transmita vídeos personales, debe tener mucho cuidado al decidir qué información comparte.",
	"Please enter_email_2": "Por favor, introduce una dirección de correo electrónico válida. El correo electrónico con algunos caracteres especiales puede no estar permitido. ex) +, ＆",
	"Password is incorrect": "La contraseña no es correcta.",
	"This camera is already_": "Esta cámara ya está registrada en una cuenta BlackVue.",
	"Camera name must_": "El nombre de la cámara debe tener entre 5 y 32 caracteres.",
	"Failed to save_": "Error al guardar la configuración de la cámara.",
	"Unallowed character detected": "Se detectaron caracteres no permitidos.",
	"File(s) queued for_": "Archivos en cola para cargar en la nube.",
	"Exceeded video play_": "Límite de reproducción y descarga de vídeos excedido.",
	"Playback Failed": "Error de reproducción.",
	"Exceeded your Live_": "Superado su límite de tiempo de Vista en directo.",
	"The camera is not_": "La cámara no está conectada al servidor.",
	"Please check the connection_": "Compruebe el estado de la conexión de la cámara seleccionada.",
	Close: Close$d,
	"Map": "Mapa",
	Cloud: Cloud$d,
	Public: Public$d,
	"Flip horizontally": "Voltear horizontalmente",
	Front: Front$d,
	Rear: Rear$d,
	Play: Play$d,
	Stop: Stop$d,
	Pause: Pause$d,
	"Next frame": "Siguiente marco",
	"Previous frame": "Marco anterior",
	"Proximity sensor": "Sensor de proximidad",
	"Voice recording on/off": "Activar/desactivar grabación de voz",
	"The BlackVue dashcam_": "La cámara para salpicadero BlackVue no es compatible con redes inalámbricas de 5 GHz.",
	Time: Time$d,
	"Daylight saving time": "Horario de verano",
	System: System$d,
	"Incorrect camera serial_": "Número de serie de cámara incorrecto.",
	"Lock event files": "Bloquear archivos de evento",
	"Overwrite locked event_": "Sobreescribir los archivos de evento bloqueados cuando esté llena",
	"Camera settings saved_": "La configuración de la cámara se guardó correctamente.",
	"Front camera": "Cámara frontal",
	"Rear camera": "Cámara posterior",
	Event: Event$d,
	Parking: Parking$d,
	"GPS tracking": "Seguimiento GPS",
	"G-force detected": "Fuerza de gravedad detectada",
	"Impact detected in_": "Detectado Impacto en modo estacionamiento",
	"Scheduled reboot": "Reinicio programado",
	"Recording status": "Estado de grabación",
	"Rear security": "Seguridad trasera",
	"Time lapse": "Periodo transcurrido",
	"Sync with GPS_": "Sincronizar con la hora GPS",
	"Overwrite locked event3_": "Sobreescribir los archivos bloqueados con archivos de evento nuevos cuando el almacenamiento está lleno",
	"Video codec": "Códec de vídeo",
	"Tracking logs": "Registros de seguimiento",
	"Geofence alerts": "Alerta de geodefensa",
	Color: Color$d,
	Exit: Exit$d,
	Save: Save$d,
	Impact: Impact$d,
	Unlimited: Unlimited$d,
	"Parking mode recording": "Grabación en modo de estacionamiento",
	"Battery protection": "Protección de batería",
	"Cut-off timer": "Temporizador de apagado",
	"Low voltage cut-off": "Apagado por batería baja",
	"Rear camera orientation": "Orientación de la cámara trasera",
	Default: Default$d,
	"Rotate video 180°": "Girar vídeo 180º",
	"Mirror video": "Invertir vídeo",
	"Wi-Fi band": "Banda Wi-Fi",
	"Driving report": "Informe de conducción",
	"Unsupported video codec_": "Códec de vídeo no compatible (H.265)",
	"Rear camera recording_": "Cámara trasera grabando en modo estacionamiento.",
	"Front and rear_": "Cámaras delantera y trasera grabando a la vez",
	"Rear camera stops_": "La cámara trasera deja de grabar 5 minutos después de entrar en modo estacionamiento. La grabación se reinicia al entrar en modo normal.",
	"Remote firmware update": "Actualización de firmware remota",
	"Firmware is up-to-date": "El firmware está actualizado",
	"New firmware available": "Firmware nuevo disponible.",
	Version: Version$d,
	"Release date": "Fecha de publicación",
	Language: Language$d,
	"File size": "Tamaño del archivo",
	"What’s new": "Novedades",
	"Updating may take_": "La actualización puede tardar varios minutos.",
	"The update process_": "No se puede cancelar el proceso de actualización.",
	"Do not disconnect the_": "No desconecte el cable de alimentación hasta que se reinicie la grabación normal.",
	"Downloading firmware": "Descargando el firmware",
	"Once download is_": "Una vez completada la descarga, la BlackVue se reiniciará automáticamente para aplicar el firmware nuevo.",
	"If not allowed_": "Si no tiene los permisos, no podrá acceder desde la nube a la ubicación y velocidad de su coche.",
	"Unable to initiate update because_": "No se pudo iniciar la actualización porque la cámara de salpicadero está conectada a un dispositivo por Wi-Fi directo.",
	Notification: Notification$d,
	Multiple: Multiple$d,
	Range: Range$d,
	"HDR night vision": "Visión nocturna HDR",
	Download: Download$d,
	"G-sensor": "G-Sensor",
	Manual: Manual$d,
	"Low voltage warning": "Advertencia de baja tensión",
	Satellite: Satellite$d,
	"Data usage": "Uso de datos",
	"Select video download quality": "Seleccionar calidad de descarga de video",
	"Quick play file_": "Archivo de reproducción rápida (baja resolución)",
	"Original file": "Archivo original",
	"You do not have permission_": "No tiene permiso para ejecutar esta función. Póngase en contacto con el propietario de su cuenta maestra.",
	"Interior camera recording_": "Cámara interior grabando en modo estacionamiento",
	"Interior security": "Seguridad interior",
	"Interior camera rotation": "Rotación de la cámara interior",
	"Multi View": "Vista múltiple",
	Tutorials: Tutorials$d,
	"Upgrade now": "Cambiar ahora",
	"Members will show_": "Los miembros aparecerán aquí a medida que estén disponibles",
	"Are you sure_delete members": "¿Seguro que desea eliminar permanentemente a los miembros?",
	"Some members may_": "Algunos miembros podrían estar ocultos por los filtros aplicados.",
	"Invited on_": "invitado el {{Invited Date}} por usted. Propietario",
	Filter: Filter$d,
	"Date created": "Fecha de creación",
	"No admin yet": "Todavía no hay administradores",
	"You can add_admin": "Puede añadir 1 administrador por grupo",
	"Collapse all": "Contraer todo",
	"Expand all": "Ampliar todo",
	"Download and playback_cloud": "Descargar y reproducir desde el almacenamiento en la nube",
	"Are you sure_2": "¿Seguro que desea eliminar el grupo {Group name}?",
	"Are you sure_groups": "¿Seguro que desea eliminar los grupos?",
	"Add cameras first_drivers": "Añada cámaras primero y después asigne conductores",
	"Flip vertically": "Voltear verticalmente",
	Sun: Sun$d,
	Mon: Mon$d,
	Tue: Tue$d,
	Wed: Wed$d,
	Thu: Thu$d,
	Fri: Fri$d,
	Sat: Sat$d,
	Dates: Dates$d,
	Routes: Routes$d,
	Opacity: Opacity$d,
	"Color and opacity": "color y opacidad",
	"Geofences will show_": "el geovallado aparecerá aquí a medida que esté disponible",
	"Start drawing a shape_": "empiece a dibujar una forma en el mapa",
	"Add geofence": "Añadir geovalla",
	Entry: Entry$d,
	"Show all members": "Mostrar todos los miembros",
	"Me and my_": "Yo y mi coche. Conectado",
	"add-on service for_": "servicio de complemento para BlackVue compatible con la nube",
	"Continue with Google": "Continuar con Google",
	"An account with_": "Ya existe una cuenta con esta dirección de correo electrónico, pero no está verificada. Introduzca su contraseña de BlackVue Cloud.",
	"Account does not_": "La cuenta no existe. O intente iniciar sesión con su cuenta de Apple o Google.",
	"Continue with Apple": "Continuar con Apple",
	"Get started": "Empezar",
	"P subscription only": "<b>{{a}}</b> Solo suscripción",
	"+N USD for extra camera_": "+{{a}} USD for extra camera up to {{b}} Cameras",
	"Unlimited Live view": "Unlimited Live View",
	"Cameras per Account": "Cameras per Account",
	"Users per Account": "Users per Account",
	Owner: Owner$d,
	"Live View per Day": "Live View per Day",
	"Remote Video Playback_2": "Remote Video Playback and Download per Month",
	"N days": "{{a}} Days",
	"Video On Map": "Video On Map",
	Undetected: Undetected$d,
	Distracted: Distracted$d,
	Drowsy: Drowsy$d,
	"Whether on mobile_": "Whether on mobile or your computer, BlackVue gives you the tools to fully enjoy your dashcam’s functions. Download the latest <a1>firmware</a1>, <a2>mobile</a2> and <a3>desktop</a3> applications, or use <a4>BlackVue web app</a4> in your browser.",
	"Compatible with most_": "Compatible with most Wi-Fi BlackVue models. Cloud support for all Cloud-compatible dashcam models down to DR650GW Series with <b>Cloud Firmware</b>.",
	"Supports most recent BlackVue_": "Supports most recent BlackVue models and compatible with BlackVue Cloud.<br/>\nThis Viewer contains <b>two applications in one</b>: the SD Card Viewer lets you view recorded videos from your SD card and modify the settings of your BlackVue, as well as format the SD card; the <b>Cloud Viewer</b> lets you enjoy BlackVue Cloud.",
	"Contact us": "Contact us",
	"6 characters with": "6 caracteres con una combinación de letras, números y símbolos",
	"Apps and more...": "Apps and more...",
	"Cameras will show_": "Cameras will show up here as they become available.",
	"Keep this page_": "Mantenga esta página abierta mientras consulta el código de confirmación. Mire su carpeta de correo no deseado si no encuentra el correo electrónico en la bandeja de entrada.",
	"n cameras": "{{n}} cámaras",
	"n slots": "{{n}} ranuras",
	"Calculate your Fleet_": "Calcule el precio del plan para su Flota",
	"Code you entered_": "El código que ha introducido es incorrecto/ha caducado",
	Calling: Calling$d,
	Smoking: Smoking$d,
	"Smoking has been_": "Se ha detectado fumando durante la conducción.",
	"Email is already_": "El correo electrónico ya existe.",
	"Serial number and_": "El número de serie y el código de la nube están impresos en su cámara",
	"Allow GPS access": "Permitir acceso a GPS",
	"Used to access_": "Se usa para acceder a la ubicación y velocidad de su vehículo. Puede cambiar los ajustes de GPS más tarde desde los ajustes de privacidad de su cámara.",
	"Incorrect cloud code": "Código de nube incorrecto",
	"An account is_": "Ya hay una cuenta registrada con esta dirección de correo electrónico.",
	"Live event upload": "Cargar evento en directo",
	Permissions: Permissions$d,
	"Assign in": "Asignar en",
	"Are you sure_camera": "¿Estás segura de que quieres eliminar esta cámara?",
	"Uploading videos:": "Subiendo videos:",
	"GPS location recording": "Grabación de ubicación GPS",
	"When OFF, GPS_": "Si la ubicación GPS está desactivada, no se grabará ni enviará al servidor en la nube.",
	"As personal video_": "Como podría transmitirse algún vídeo personal, debe tener especial cuidado cuando decida qué información comparte.",
	"Share location": "Compartir ubicación",
	Private: Private$d,
	"Used to access_2": "Se usa para acceder a la ubicación y velocidad de su vehículo.",
	"Share live view": "Compartir vídeo de Vista en directo",
	"Share live audio": "Compartir audio de Vista en directo",
	"Share camera’s name": "Compartir nombre de cámara para salpicadero",
	"Impact detection": "Detección de Impacto",
	Entering: Entering$d,
	Exiting: Exiting$d,
	"Normal event recording": "Grabación de evento normal",
	"Harsh braking": "Frenada brusca",
	Acceleration: Acceleration$d,
	"Sharp turn": "Giro brusco",
	"Parking event recording": "Grabación de evento de estacionamiento",
	Passing: Passing$d,
	"Video source": "Fuente de vídeo",
	Overspeed: Overspeed$d,
	"Are you sure_video": "¿Seguro que desea eliminar este vídeo?",
	"Add camera to_": "Añadir cámara a la vista en directo",
	"No routes to_": "No hay rutas para mostrar",
	"Start by adding_": "Empezar añadiendo fechas.",
	"invite sent": "Invitación enviada",
	Recipients: Recipients$d,
	Send: Send$d,
	"Routes selected_": "Rutas seleccionadas: {{n}} de {{total}}",
	"Map service": "Servicio de mapa",
	"Speed units": "Unidades de velocidad",
	Note: Note$d,
	"Release notes": "Notas de publicación",
	"The name must_": "El nombre debe tener entre 1 y 30 caracteres.",
	Video: Video$d,
	Advanced: Advanced$d,
	"Firmware language": "Idioma de firmware",
	"Wi-Fi": "Wi-Fi",
	Voice: Voice$d,
	"Show date and_": "Mostrar fecha y hora",
	"Show speed": "Mostrar velocidad",
	"Front camera rotation": "Rotación de la cámara frontal",
	"Manual time settings": "Ajuste manual de la hora",
	"Recommended for better_": "Recomendado para una compresión mejor, un tamaño de archivo reducido y 4K UHD.",
	"For full compatibility_": "Para compatibilidad total con dispositivos de mesa y móviles antiguos.",
	"Up and down": "Arriba y abajo",
	"Side to side": "Lado a lado",
	"Front and back": "Delante y detrás",
	"Detection region": "Región de detección",
	"Hotspot 1": "Punto de acceso 1",
	"Hotspot 2": "Punto de acceso 2",
	"Hotspot 3": "Punto de acceso 3",
	"Enter/exit": "Entrar/salir",
	"Event recording": "Grabación de eventos",
	"Front security (Normal)": "Seguridad frontal (Normal)",
	"Front security (Parking)": "Seguridad frontal (Estacionamiento)",
	"LTE (Parking)": "LTE (Estacionamiento)",
	"Wi-Fi (Parking)": "Wi-Fi (Estacionamiento)",
	"Turn on at startup": "Activar al iniciar",
	"Turn off after_": "Apagar tras 10 min de inactividad",
	"Your firmware is_": "El firmware está actualizado",
	"Add admin": "Añadir administrador",
	"Remove All/n": "Eliminar todo/{{a}}",
	"Are you sure_remove": "¿Seguro que desea eliminar las cámaras de este grupo?",
	"This will cancel_2": "Con esto se cancelará su suscripción al Plan de Flota. Cambiará al plan gratuito al final de su ciclo de facturación actual.",
	"You’ve reached_": "Ha alcanzado el límite de conductores por cámara",
	"Are you sure_remove admin": "¿Seguro que desea eliminar al {{a}}{{b}} administrador de este grupo?",
	"Fleet Plan · Owner": "Fleet Plan · Owner",
	"Manage cameras": "Gestionar cámaras",
	"Are you sure_delete zone": "¿Seguro que desea eliminar la zona \"{{zone}}\"?",
	"available on your_2": "{{a}}/{{b}} disponible en su plan",
	"The new plan_2": "El plan nuevo entrará en vigor al final de su ciclo de facturación actual ({{a}}).",
	"Canceled Fleet Plan_": "Plan de flota cancelado el {{a}}",
	"Hard braking alert (beep)": "Alerta de frenada brusca (pitido)",
	"Hard acceleration alert (beep)": "Alerta de aceleración brusca (pitido)",
	"Hard cornering alert (beep)": "Alerta de giro brusco (pitido)",
	"SSID must be_": "El SSID debe tener al menos 5 caracteres.",
	"Password must be_": "La contraseña debe tener al menos 8 caracteres.",
	"5 to 32 characters long": "Entre 5 y 32 caracteres",
	"8 to 32 characters long": "Entre 8 y 32 caracteres",
	"Longer storage period_event": "Periodo de almacenamiento más largo para la subida de eventos en directo",
	"Requires latest firmware_": "Requiere el último firmware. No compatible con los modelos DR650S y DR650GW",
	"After Blackvue is_": "Los ajustes se guardarán una vez la BlackVue se haya conectado a la nube.",
	"This is an_": "Este correo electrónico no está registrado. ¿Quiere registrar una cuenta nueva?",
	"This feature is_": "Esta función solo está disponible para suscriptores del plan de flota.",
	"Please return to_": "La cuenta no existe. O intente iniciar sesión con su cuenta de Apple o Google.",
	"Adjusting the cut-off voltage_": "Adjusting the cut-off voltage to a lower setting may result in your dash cam draining more power from your battery.\nThis could result in warning messages of battery drain or affect other vehicle functions.\nPlease consult with your dealership before lowering the voltage.",
	"Your videos will_": "Sus vídeos aparecerán aquí a medida que estén disponibles.",
	"You drove:_": "Ha conducido: {{distance}}, {{time}}",
	"Event count per_": "Número de eventos por hora de conducción",
	"Are you sure_recipient": "¿Seguro que desea eliminar este destinatario?",
	"(You)": "{{a}} (Usted)",
	"All events": "Todos los eventos",
	Days_: Days_$d,
	"Requires DMC 200_": "Requiere una cámara DMC 200",
	"A DMS and compatible_": "Se necesita un DMS y una cámara para salpicadero compatible para ver este informe.",
	"Notifications will show_": "Las notificaciones aparecerán aquí a medida que estén disponibles.",
	"Try changing your_": "Pruebe a cambiar la fecha o eliminar filtros.",
	Mute: Mute$d,
	UnMute: UnMute$d,
	"Calling and smoking_": "Solo el dispositivo DMC 200 detecta cuando se usa el teléfono y se fuma",
	"You need a DMS_": "Necesita un DMS para ver este informe.",
	"Try BlackVue Cloud": "Pruebe BlackVue Cloud hoy",
	"Individual driver looking_": "¿Es un conductor que busca tranquilidad? ¿Un propietario de un negocio que necesita una solución de seguridad y seguimiento de vehículos?",
	"Whoever you are_": "Sea cual sea su caso o sus necesidades, ¡hay un plan en la nube para usted!",
	"It is the account that_Driver": "Es la cuenta que se ha unido a su flota en BlackVue Cloud después de aceptar una invitación por correo electrónico del Propietario o Administrador. Un conductor puede asignarse únicamente a una cámara con la capacidad limitada de ver el perfil de su propia cuenta, la vista en directo y la reproducción de su cámara asignada.",
	"It is the account that_Admin": "Es la cuenta que se ha unido a su flota en BlackVue Cloud después de aceptar una invitación por correo electrónico del Propietario. Las cuentas de administrador pueden recibir los derechos que el Propietario permite para ese administrador.",
	"Video deleted": "Vídeo borrado",
	"Video delete_plural": "Vídeos borrados",
	"Driver removed from_": "Conductor eliminado del grupo",
	"Admin removed from_": "Administrador eliminado del grupo",
	"Camera removed from_": "Cámara eliminada del grupo",
	"Are you sure_videos": "¿Desea eliminar los archivos seleccionados?",
	"You have to cancel_fleet": "Debe cancelar su suscripción en la aplicación para cambiar el número de cámaras: 1. Cancele su suscripción actual desde la App Store o Google Play Store. Cambiará al plan gratuito al final de su ciclo de facturación actual. Todos sus datos se mantendrán intactos. 2. Inicie sesión en su cuenta de blackvuecloud.com y cámbiese al plan de Flota.",
	Discard: Discard$d,
	"Discard unsaved changes?": "¿Descartar los cambios no guardados?",
	"Incorrect serial number": "Número de serie incorrecto",
	"An error occurred_again": "Ha ocurrido un error. Inténtelo otra vez.",
	"You are subscribed_free": "Está suscrito al plan Gratuito de BlackVue Cloud.",
	"When an event_": "Cuando se crea un evento (Impacto detectado o disparado manualmente), la subida de eventos en directo permite que su BlackVue guarde la transmisión de vídeo en directo desde una cámara que usted elija en el servidor de la nube, incluidos los 5 segundos previos al evento.",
	Report: Report$d,
	"How it work": "Cómo funciona",
	"Cloud Camera": "Cámara en la nube",
	"Internet Connection": "Conexión a Internet",
	"BlackVue App/Viewer": "BlackVue App/Viewer",
	"All you need_": "Todo lo que necesita es una",
	"Cloud-compatible BlackVue": "BlackVue compatible con la nube",
	"and a cellular_": "y un plan de datos móviles. Algunos modelos se conectan a la nube a través de puntos de acceso Wi-Fi de terceros. Otras disponen de un lector de tarjetas Nano SIM integrado o son compatibles con módulos de conectividad integrados.",
	"Cloud features at_": "Funciones de la nube en la punta de los dedos",
	"Enjoy peace of_": "Disfrute de la tranquilidad de saber que BlackVue vigila su coche. Si algo va mal, su cámara para salpicadero le enviará un mensaje al instante.",
	"Let your BlackVue_": "Deje que su BlackVue vigile su coche y le alerte de los incidentes. En cuanto se detecta un Impacto, la BlackVue enviará una notificación a su teléfono o navegador web junto con una captura.",
	"Check on your_": "Eche un vistazo a su coche desde cualquier lugar con la vista en directo remota. Tanto si usa un navegador web o su teléfono, podrá acceder a una transmisión de vídeo en tiempo real desde su cámara para salpicadero conectada a la nube y alternar fácilmente entre las cámaras frontal, trasera o interior.",
	"Your BlackVue may_": "Es posible que la BlackVue no pueda evitar que alguien choque con su coche y se dé a la fuga, pero si sucede, es muy probable que capture pruebas en vídeo cruciales. Busque entre lo vídeos grabados por su cámara para salpicadero desde su teléfono móvil o un navegador web.",
	"Worried about eating_": "¿Le preocupa consumir todos los megas de su plan de datos? La tecnología Sub-stream de BlackVue le permite acceder a versiones extra ligeras de sus vídeos para buscar más rápido y verlos sin búfer.",
	"Move files from_": "Transfiera archivos de su BlackVue a la nube. Guarde un solo vídeo o seleccione múltiples clips para subirlos por lotes. Puede acceder a los vídeos descargados a su teléfono con la aplicación BlackVue y compartidos desde el menú de memoria interna.",
	"View your vehicle’s_": "Vea la ubicación de su vehículo y la velocidad de viaje en tiempo real. Actualice a un plan Inteligente para acceder a los últimos 7 días de datos de seguimiento por GPS.",
	"Get more with_": "Consiga más con el plan Inteligente.",
	"Unlimited Remote Live_": "Vista en directo remota ilimitada",
	"Up to 3 dashcams_": "Hasta 3 cámaras para salpicadero en una sola cuenta",
	"Want to track_": "¿Quiere rastrear una flota entera? Cambiar al plan de Flota",
	"BlackVue Fleet Tracking_2": "El seguimiento de flota de BlackVue es una solución integral para proteger y rastrear su flota. Las funciones y precios se adaptan flexiblemente para satisfacer las necesidades de su negocio.",
	"Stream real-time video_": "Transmita vídeo en tiempo real sin límite. Tasa de bit: 600 kbps",
	"Up to 999 Dashcams": "Hasta 999 cámaras para salpicadero",
	"Register up to_": "Registre hasta 999 cámaras para salpicadero por cuenta.",
	"15GB of Cloud_": "15 GB de almacenamiento en la nube",
	"15GB per additional_": "15 GB por cámara para salpicadero adicional. Almacenamiento para subida automática de eventos ilimitada.",
	"90-days GPS_": "Registros de seguimiento por GPS de 90 días",
	"High accuracy: 15_": "Alta precisión: 15 segundos, vídeo en un mapa, exportación de datos sencilla.",
	"Unique fleet management_": "Las funciones de gestión de flota únicas añaden valor y practicidad",
	"Create geofences and_": "Cree geovallas y reciba notificaciones en tiempo real en su teléfono u ordenador.",
	"View at a_": "Vea de un vistazo la distancia total recorrida, el tiempo en ralentí, los eventos de exceso de velocidad, etc., en tablas que puede imprimir o exportar.",
	"Multi Live View": "Vista en directo múltiple",
	"Monitor up to_": "Monitorice hasta 4 cámaras para salpicadero simultáneamente",
	"Benefits for you": "Beneficios para usted",
	Individual: Individual$d,
	"Get notifications to_2": "Reciba notificaciones en su teléfono si alguien golpea su coche aparcado. Compruebe en remoto qué sucede alrededor de su coche. Disponible en web, móvil, Mac y Windows.",
	"Small business owner": "Propietario de negocios pequeños",
	"Monitor your commercial_2": "Monitorice sus vehículos comerciales en un mapa en tiempo real. Hable con sus conductores en cualquier momento a través de su navegador, aplicación móvil BlackVue, visor de Mac o de Windows.",
	"Company with large_": "Empresa con una gran flota",
	"With BlackVue Fleet_2": "Con el seguimiento de flota de BlackVue, puede rastrear hasta 999 vehículos en tiempo real a través de su navegador, aplicación móvil BlackVue o visor de Mac o de Windows.",
	Subscribed: Subscribed$d,
	"The video was_": "El vídeo ya se ha subido.",
	Geofence: Geofence$d,
	"500: Internal server error": "500: Error de servidor interno",
	"404: Page not found": "404: Página no encontrada",
	"Check the web address_": "Consulte la dirección web o vuelva a la página de inicio de BlackVue Cloud",
	"home page": "Home page",
	"There isn’t an_": "No hay cuentas asociadas con esta dirección de correo electrónico",
	"You can now_password": "Ahora puede iniciar sesión con su contraseña nueva",
	"Are you sure_remove admin2": "Seguro que desea eliminar permanentemente al administrador",
	"Admin deleted": "Administrador eliminado",
	"Members deleted": "Miembros eliminados",
	"Are you sure_groupName": "¿Seguro que desea eliminar los grupos {{a}}?",
	"Requires latest firmware": "Requiere el último firmware",
	"Selected file(s) moved_": "Archivo(s) seleccionado(s) movido(s) correctamente.",
	"Are you sure_remove driver2": "¿Seguro que desea eliminar al conductor {{a}} ({{b}}) de este grupo?",
	"Invite sent": "Invitación enviada",
	"Safe driving": "Conducción segura",
	"Reckless driving": "Conducción temeraria",
	"Inattentive driving": "Conducción distraída",
	"Driving events trend": "Tendencia de eventos de conducción",
	"Driving details": "Información de la conducción",
	Driving: Driving$d,
	Idling: Idling$d,
	Distance: Distance$d,
	"Parking sessions": "Sesiones de estacionamiento",
	"Parked time": "Parked time",
	"Idle stops": "Paradas en ralentí",
	"Idle time": "Tiempo en ralentí",
	"Impact events": "Impact Events",
	Parked: Parked$d,
	Speed: Speed$d,
	"Overspeeding alerts": "Alertas de exceso de velocidad",
	Highest_2: Highest_2$d,
	Average: Average$d,
	Geofences: Geofences$d,
	"Entries into a_": "Entradas a una zona",
	"Exits from a_": "Salidas de una zona",
	"No data": "Sin datos",
	"Hard acceleration": "Aceleración",
	"Hard braking": "Frenada brusca",
	"Hard cornering": "Giro brusco",
	"The number within the brackets_": "El número entre corchetes indica el promedio de eventos por hora de conducción. Si ha conducido menos de una hora al día, se mostrará el número total de eventos.",
	"Did you insert_": "¿Ha insertado una tarjeta SIM?",
	"Click here for_": "<a>Haga clic aquí</a> para ver más guías detalladas.",
	"Back up all_": "<b>Haga una copia de seguridad de todas las grabaciones importantes antes de guardar estos ajustes.</b><br/>Cuando guarde los ajustes, la tarjeta microSD se reinicializará y se eliminarán todas las grabaciones para garantizar un funcionamiento estable.",
	"Not connected to_": "No conectado a la nube. Algunas funcionalidades se han desactivado temporalmente.",
	"GPS Location recording off": "Grabación de ubicación GPS desactivada",
	"n Videos deleted": "{{count}} Vídeos eliminados",
	Move: Move$d,
	"Driver Monitoring System (DMS) will_": "El sistema de monitorización del conductor (Driver Monitoring System, DMS) se lanzará en breve.",
	"An error occured while_": "Ha ocurrido un error al intentar cambiar el número de cámaras. Vuelva a intentarlo",
	"Reached the limit_": "Límite alcanzado: {{a}}",
	"An invitation was_": "Ya se ha enviado una invitación a esta dirección de correo electrónico.",
	"To use the_": "Para usar la función de la nube. Inserte su tarjeta SIM.",
	"Last updated": "Última actualización {{date}}",
	"Try changing your date": "Intente cambiar la fecha.",
	"No event data_": "No se ha recopilado ningún dato de evento de la hora seleccionada",
	"Please select another_": "Seleccione otro día o mes para ver un informe completo.",
	"more than 6_": "se requieren más de 6 caracteres",
	"Sign up free": "Registro gratuito",
	"Cloud storage warning": "Aviso de almacenamiento en la nube",
	"Cloud Storage Full": "Almacenamiento en la nube lleno",
	"Cloud storage usage_100": "El uso de almacenamiento en la nube ha alcanzado 100%. Libere algo de espacio para poder usar la subida de evento en directo",
	"Cloud storage usage_": "El uso de almacenamiento en la nube ha alcanzado <b>({{a}}%)</b>. \nOrganice su almacenamiento en la nube.\nEl servicio de subida de eventos en directo no está disponible si el almacenamiento en la nube está lleno.",
	"Are you sure_delete_zone": "¿Seguro que desea eliminar?",
	"Search Name or email": "Buscar nombre o correo electrónico",
	"Search group name": "Buscar nombre de grupo",
	"Please note that_": "Tenga en cuenta que la grabación de vídeo se pausará unos segundos para aplicar los nuevos ajustes.",
	"Currently connected Hotspot": "Punto de acceso conectado actualmente",
	"Enhanced night vision": "Visión nocturna mejorada",
	"To access the_": "Para acceder a la cámara, actualice su plan de suscripción.",
	"Restarting the Blackvue_": "Reiniciando la BlackVue para aplicar configuración.",
	"Hard acceleration event_": "Un evento de aceleración brusca ocurre cuando la tasa de incremento por segundo es superior a {{kmh}} km/h ({{mph}} mph)",
	"Hard braking event_": "Un evento de frenada brusca ocurre cuando la deceleración \nes superior a {{kmh}} km/h ({{mph}} mph) por segundo.",
	"Hard cornering event_": "Un evento de giro brusco ocurre cuando hay un giro de más de 60 grados en menos de 2 segundos de conducción a una velocidad superior a \n{{kmh}} km/h (9 mph)",
	"Changes you made_": "Es posible que no se guarden los cambios que ha realizado.",
	"My location": "Mi ubicación",
	"Hotspot name (SSID)": "Nombre del punto de acceso (SSID)",
	Connected: Connected$d,
	"Camera will be rebooted_": "La cámara se reiniciará. ¿Quiere continuar?",
	"Restarting the BlackVue_": "Reiniciando la BlackVue. Espere un momento.",
	"Failed to reboot_": "Fallo al reiniciar la cámara",
	"Bluetooth (Parking mode)": "BT (modo de estacionamiento)",
	"Front and interior camera_": "Cámaras delantera e interior grabando a la vez",
	"Interior camera stops_": "La cámara interior deja de grabar 5 minutos después de entrar en modo estacionamiento. La grabación se reinicia al entrar en modo normal.",
	Individual_: Individual_$d,
	"Driver detection": "Detección del conductor",
	"During driving only": "Solo durante la conducción",
	Always: Always$d,
	"Driver detection box": "Cuadro de detección del conductor",
	"DMS camera rotation": "Rotación de la cámara DSM",
	Low: Low$d,
	Medium: Medium$d,
	High_2: High_2$d,
	"Reboot Camera": "Reiniciar cámara",
	"Latest events": "Últimos eventos",
	"G-Sensor": "G-Sensor",
	"Playback speed": "Velocidad de reproducción",
	Flip: Flip$d,
	Previous: Previous$d,
	Next: Next$d,
	"Map type": "Tipo de mapa",
	"Zoom in": "Ampliar imagen",
	"Zoom out": "Reducir imagen",
	"Move to Cloud": "Mover a la nube",
	"Please recognize that_": "Tenga en cuenta que la grabación de vídeo se pausará unos segundos para aplicar los ajustes.",
	"6 characters with_": "6 caracteres con una combinación de letras, números y símbolos",
	"Updating firmware": "Actualizando firmware",
	"Overspeed event occurs_": "Un evento de exceso de velocidad ocurre cuando la cámara para salpicadero advierte al conductor de que se ha superado el límite de velocidad. Puede cambiarlo en Firmware > Sistema > Volumen",
	"Enter group name": "Introducir el nombre del grupo",
	"Live view failed": "Error en la Vista en directo.",
	"Parking mode enter_": "Entrar/salir de modo de estacionamiento",
	"Cloud connectivity": "Conectividad de la nube",
	Expand: Expand$d,
	Collapse: Collapse$d,
	"all day": "Todo el día",
	"Driving style": "Estilo de conducción",
	"Driving impact": "Impacto durante la conducción",
	More: More$d,
	"No cameras to_": "No hay cámaras para añadir",
	"You have added_": "Ha añadido todas las cámaras disponibles.",
	Multi: Multi$d,
	"Report video": "Denunciar vídeo",
	"Sexually explicit content": "Contenido sexual",
	"Graphic violence": "Violento o repulsivo",
	"Hateful speech": "Fomenta el odio o abusivo",
	"Harassment or bullying": "Acoso o intimidación",
	"Spam or advertisement": "Correo basura o publicidad",
	"Infringement of my_": "Infringe mis derechos",
	"Other reason": "Etc.",
	"Reason for reporting": "Motivo de la denuncia",
	"Reported videos will_": "Los vídeos denunciados serán analizados en 72 horas El vídeo no aparecerá en el mapa de eventos hasta que se confirme que el vídeo es apto para publicarse en el mapa de eventos.",
	"Touch sensor": "Sensor táctil",
	"Motion and impact detection": "Detección de movimiento e Impactos",
	"Settings have been changed": "Se han cambiado los ajustes",
	"Start event recording (beep)": "Iniciar grabación de evento (pitido)",
	"Scheduled reboots": "Reinicios programados",
	Safe: Safe$d,
	Reckless: Reckless$d,
	Inattentive: Inattentive$d,
	"Highest(Extreme)": "La más alta (Extrema)",
	"Public cameras": "Cámaras públicas",
	List: List$d,
	Usage: Usage$d,
	"Video playbacks and downloads": "Reproducciones y descarga de vídeos",
	"of 100 times": "de 100 veces",
	"of 10 minutes": "de 10 minutos",
	Profile: Profile$d,
	"Search geofences": "Buscar geovallas",
	"Export CSV": "Exportar CSV",
	"Exit fullscreen": "Salir de la pantalla completa",
	Fullscreen: Fullscreen$d,
	Upgrade: Upgrade$d,
	"Email address": "Dirección de correo electrónico",
	"of Unlimited": "de ilimitado",
	"No notifications yet": "No se recibieron notificaciones en los últimos 7 días.",
	"No videos yet": "Todavía no hay vídeos",
	Management: Management$d,
	Day: Day$d,
	Month: Month$d,
	"Welcome to the BlackVue_": "Bienvenido al visor BlackVue Cloud",
	"You can access BlackVue_": "¡Puede acceder a BlackVue Cloud desde Internet en cualquier momento y desde cualquier lugar!",
	"Start tour": "Iniciar recorrido",
	"Map view": "Vista de mapa",
	"Check the current_": "Compruebe la ubicación GPS y la velocidad actual de sus cámaras y cámaras públicas.",
	"Camera’s features": "Funciones de la cámara",
	"Take a look_": "Eche un vistazo a las diferentes funciones relacionadas con la nube proporcionadas por la cámara BlackVue.",
	"Visualize your vehicle’s_": "Visualice la ruta de conducción de su vehículo a lo largo del tiempo.",
	"Smart plan_": "Plan inteligente: 90 días, plan de Flota: 90 días",
	"Create geofences and2_": "Cree geovallas y reciba notificaciones en tiempo real.",
	"Got it": "Lo tengo",
	"Manage Fleet members": "Gestionar miembros de la flota",
	"Invite fleet members_": "Invite a miembros de la flota y asígnelos a grupos.",
	"The moment the_": "En cuanto su cámara detecte los Impactos, aquí se enumerarán las notificaciones.",
	"Geofence Setup (Web)_": "Configuración de geovallas (navegador/escritorio) y alertas",
	"Original file play_": "La reproducción del archivo original solo está disponible para descargar",
	"To get most_": "Para sacar el máximo partido del visor BlackVue Cloud, su cámara debe estar conectada a la nube. ¡Descargue la aplicación BlackVue y experimente una vinculación ininterrumpida, desde la adición de cámaras hasta la conexión a la nube, todo a la vez!",
	"You haven’t driven_Today": "Hoy todavía no ha conducido su coche. Pruebe a conducir su coche con BlackVue para comprobar su informe de conducción.",
	"You haven’t driven_Month": "Este mes todavía no ha conducido su coche. Pruebe a conducir su coche con BlackVue para comprobar su informe de conducción.",
	"Fleet Plan only_": "Solo plan de flota disponible",
	"Overwrite locked event2_": "Sobrescribir los archivos de evento bloqueados cuando el almacenamiento esté lleno",
	"DMS’s New firmware_": "Nuevo firmware de DMS disponible",
	"Highest speed_report": "<b>Velocidad más alta</b>\bMayor valor de datos de velocidad recogidos en unidades métricas Convertir a unidades km/h y MPH\n\n<b>Velocidad promedio</b>\n(Distancia/horas conducidas) x 3600 velocidad promedio. Ej. (2622 / 1208 ) x 3600 = 7814,907\nkm/h: Solo enteros, \nel separador decimal de las MPH es de hasta 2 dígitos bajo el entero",
	"Choose a cloud_": "Elija un método de conexión a la nube",
	"You need an_": "Necesita una conexión a Internet para conectarse a la nube. Seleccione el dispositivo que usa para conectarse a la nube.",
	"BlackVue SIM card": "Tarjeta SIM BlackVue",
	"Support model_": "Modelo compatible: DR750X-2CH LTE Plus (NA)",
	"3rd party SIM_": "Tarjeta SIM de terceros",
	"Support model_SIM": "Modelo compatible: DR750X-2CH LTE Plus, DR750-2CH LTE, CM100 LTE",
	"Wi-fi hotspot": "Punto de acceso Wi-Fi",
	"Support model_Wifi": "Modelo compatible: Todos los modelos BlackVue",
	"How to connect_": "Cómo conectarse a la nube",
	"Download BlackVue application": "Descargar la aplicación BlackVue.",
	"*If you are_": "*Si va a utilizar una tarjeta SIM BlackVue para conectarse a la nube, vaya a {{a}} {{b}}.",
	"Place your phone_": "Coloque su teléfono dentro del alcance BT de la cámara. Inicie la vinculación ininterrumpida con {{a}}.",
	"Back to camera_": "Volver a la lista de cámaras",
	"Upgrade for more_": "¡Actualice para ver más funciones!",
	"Upgrading the cloud_": "Actualizar el plan de nube le permite disfrutar de más funciones y gestionar múltiples cámaras. ¿Quiere actualizar su plan de nube?",
	"Explore cloud plans": "Examinar planes de nube",
	Later: Later$d,
	"Successfully subscribed": "¡Suscrito correctamente!",
	"1GB data plan": "Plan de datos de 1 GB",
	"First month free_": "Primer mes gratuito, <a>después 10,99 USD/mes</a>",
	"Next billing date": "Siguiente fecha de facturación",
	"Once SIM card_": "Una vez insertada la tarjeta SIM en la cámara, puede empezar a usar las funciones de BlackVue Cloud inmediatamente.",
	"Go to SIM_": "Ir a gestión de la SIM",
	"Manage your BlackVue_": "¡Gestione su tarjeta SIM BlackVue aquí!",
	"Recommended for BlackVue_": "Recomendado para usuarios de SIM BlackVue",
	"Connect to cloud": "Conectarse a la nube",
	"Enter BlackVue SIM_": "Introduzca el número ICCID de la SIM BlackVue",
	"ICCID number is_": "El número ICCID está impreso en el paquete de la tarjeta SIM. Introduzca los últimos 14 dígitos del número ICCID.",
	ICCID: ICCID$d,
	"SIM information": "Información de SIM",
	"Start your free_": "Empiece su prueba gratuita ahora",
	"SIM card activate_": "Fecha de activación de la tarjeta SIM",
	"Based on the_": "Basada en la fecha en que la tarjeta SIM se inserta en la cámara y se activa cuando se enciende",
	"Upgrade to 3GB_": "Actualice al plan de 3 GB/5 GB en cualquier momento",
	"Cancel your plan_": "Cancele su plan en cualquier momento",
	"No Commitment": "Sin compromisos",
	"Precautions for using_": "Precauciones para usar el servicio",
	"After 1GB is_": "Una vez usado el 1 GB, Internet ya no estará disponible.",
	"If you have_": "Si ya ha insertado una tarjeta SIM en la cámara y la ha usado, el periodo de prueba gratuita empiezó cuando comienzó a usarla.",
	"This content is_": "Este contenido se especifica en el paquete de la SIM. No ofrecemos compensación por los periodos gratuitos no disfrutados.",
	"If you have_2": "Si tiene más preguntas, póngase en contacto con el <a>Equipo CS</a>",
	"When OFF, connecting_": "Cuando esté apagada, la conexión de la cámara por vinculación ininterrumpida está desactivada.",
	"1 month free": "1 mes gratis",
	"No commitment. Cancel_": "Sin compromisos. Cancele en cualquier momento.",
	"The video has been reported_": "Se ha denunciado el vídeo correctamente",
	"Free for 1 month": "Gratis durante 1 mes",
	"Start your free_2": "Empiece su prueba gratuita",
	"1GB free for_": "1 GB gratis durante {{a}} días",
	"1GB data": "1 GB de datos",
	"1 month free_2": "La prueba gratuita de 1 mes empezará el {{a}} con 1 GB para la tarjeta SIM BlackVue.",
	"Your next billing_": "Su siguiente fecha de facturación es el {{a}}",
	"SIM card": "Tarjeta SIM",
	"SIM guide": "Guía de la SIM",
	"SIM card list": "Lista de tarjetas SIM",
	"Add SIM card": "Añadir tarjeta SIM",
	"No SIM card_": "Todavía no hay tarjeta SIM",
	"Search SIM ICCID_": "Busque el ICCID o nombre de la tarjeta SIM",
	"Cloud disconnected. Failed_": "Nube desconectada. No se pudo reproducir el vídeo",
	"This sim card_": "Esta tarjeta SIM ya está registrada en otra cuenta.",
	"Incorrect BlackVue SIM_": "ICCID de SIM BlackVue incorrecto",
	"My shared videos": "Mis vídeos compartidos",
	"Number of events": "Número de eventos",
	"Added to Event Map": "Añadido a mapa de eventos",
	"Successfully added video(s)_": "¡Vídeo(s) añadido(s) correctamente para compartir en el mapa de eventos! Si quiere comprobar el estado y gestionar los vídeos compartidos, vaya a Mapa de eventos > Mis vídeos compartidos.",
	"Already added to_": "Ya está añadido al mapa de eventos",
	"This video(s) is already added_": "¡Este vídeo ya está añadido al mapa de eventos! Si quiere comprobar el estado y gestionar los vídeos compartidos, vaya a Mapa de eventos > Mis vídeos compartidos.",
	"BlackVue’s firmware is up_": "El firmware de BlackVue está actualizado",
	"Service end": "Fin del servicio",
	Resubscribe: Resubscribe$d,
	"Sort ascending": "Orden ascendente",
	"Sort descending": "Orden descendente",
	plan: plan$d,
	USD: USD$d,
	"Are you sure_Cancel": "¿Seguro que quiere cancelar su suscripción? Tenga en cuenta los puntos siguientes y confirme a continuación.",
	"Your current SIM_": "La suscripción de su tarjeta SIM actual termina el {{a}} y ya no volverá a cargarse.",
	"After canceling your_": "Después de cancelar su suscripción de tarjeta SIM, continuará usando los datos de la SIM hasta la fecha de fin de su suscripción.",
	"You can resubscribe_": "Puede volver a suscribirse durante el mes siguiente a la finalización de su suscripción actual. Si quiere volver a suscribirse, haga clic en el botón ‘Volver a suscribirse’ en la lista de tarjetas SIM antes de {{a}} para volver a suscribirse.",
	"Reason to cancel_": "Motivo para cancelar la suscripción",
	"Found an alternative": "He encontrado una alternativa",
	"Too expensive": "Demasiado cara",
	"Not required anymore": "Ya no la necesito",
	"Quality issue": "Problema de calidad",
	etc_: etc_$d,
	"Please describe in_": "Descríbala en detalle",
	"SIM card cannot_": "La tarjeta SIM no se puede eliminar porque esta tarjeta SIM tiene una suscripción. Si quiere eliminar esta tarjeta SIM, cancele primero su suscripción.",
	"SIM card cannot_2": "La tarjeta SIM no se puede eliminar porque la suscripción de esta tarjeta SIM no ha terminado aún. Vuelva a intentarlo después de que finalice su suscripción.",
	"Are you sure_deleteSIM": "¿Seguro que quiere eliminar esta tarjeta SIM?<br/>\n<b>Advertencia: No podrá deshacer esta acción. Toda la información de su tarjeta SIM se eliminará inmediatamente.</b>",
	"ICCID number": "Número de ICCID",
	"Activation date": "Fecha de activación",
	"Current plan": "Plan actual",
	"Manage Plan": "Gestionar el plan",
	"Next billing on": "Siguiente facturación el",
	"View Invoices": "Ver facturas",
	"Choose best plan_": "Elija el mejor plan para usted",
	"Plan summary": "Resumen del plan",
	"Ends on_": "Finaliza el {{a}}",
	"Start from_": "Empieza el {{a}}",
	"Your subscription will_": "Su suscripción se actualizará el {{a}}, cuando su plan actual finalice.",
	"Resubscribe plan": "Volver a suscribirse al plan",
	"Your subscription will2_": "Su suscripción empezará el {{a}}, cuando su plan actual finalice.",
	"Usage is estimated_": "El uso estimado a fecha de {{a}}",
	"Days left_": "{{a}} días restantes",
	"Data usage cycle": "Ciclo de uso de datos",
	Available: Available$d,
	Used: Used$d,
	"Data used": "Datos usados",
	"Subscribe to n_": "Suscripción al plan de datos {{a}} aplicado <b>desde {{b}} hasta el {{c}}</b> y al plan de datos {{d}} aplicado desde el {{e}}",
	"Will be charged_": "Se cargará el {{a}}",
	"Monthly usage": "Uso mensual",
	"You have fewer_": "¡Este mes le quedan menos datos!",
	"Get more data": "¡Obtenga más datos!",
	"This video cannot be shared": "Este vídeo no se puede compartir",
	"This is a video cannot be shared_": "Este vídeo no se puede compartir porque no se ha encontrado información de conducción en el momento.",
	Cancelled: Cancelled$d,
	Terminated: Terminated$d,
	"Edit name": "Editar nombre",
	"Not connected to_2": "No conectado a la nube. Compruebe si su cámara está encendida y si el módulo de conectividad a Internet está habilitado.",
	"Some functionality is disabled_": "Algunas funcionalidades están desactivadas porque la cámara no está conectada a la nube. Conéctese a la nube <a>aquí</a>.",
	"If you want to cancel_": "Si quiere cancelar su plan, haga clic en <a>Cancelar suscripción</a>.",
	"Select plan": "Seleccionar plan",
	"Event map collects_": "El mapa de eventos recopila y visualiza información de eventos de la BlackVue para proporcionar situaciones en las carreteras circundantes.",
	"Share your Live_": "Comparta su archivo de subida de evento en directo. Puede compartir sus vídeos de eventos con otros usuarios de su entorno.",
	"You can check_": "Puede comprobar los vídeos de eventos compartidos por otros.",
	"Service end_": "Fin del servicio: {{a}}",
	"DMS camera recording_": "Cámara DMS grabando en modo estacionamiento",
	Sort: Sort$d,
	"Are you sure you want_": "¿Seguro que desea eliminar los vídeos compartidos del mapa de eventos?",
	"Remove shared video": "Eliminar vídeo compartido",
	"Explore event map": "Explorar el mapa de eventos",
	"Event map": "Mapa de eventos",
	"Explore the graphic_": "Explore las estadísticas gráficas de los eventos BlackVue que han ocurrido a su alrededor.",
	"You can filter_": "Puede filtrar y ver los eventos que quiere mostrar.",
	"This video was removed by_": "Este vídeo ha sido denunciado y eliminado por el administrador.",
	Bonus: Bonus$d,
	"Your subscription plan": "Su plan de suscripción",
	"Your free trial will_": "Su prueba gratuita empezará desde el {{a}},</br> <strong>hasta el</strong> {{b}}.",
	"Total after free trial": "Total tras la prueba gratuita",
	"This sim card is_": "Esta tarjeta SIM ya no está activa.",
	"Firmware is up_": "El firmware está actualizado",
	"Keep in mind": "Lo tendré en cuenta",
	"Once 1GB of_": "Una vez usado 1 GB de datos, el servicio no estará disponible hasta la siguiente fecha de restablecimiento de los datos [o hasta que actualice su plan a nivel superior.]",
	"After the SIM_": "Después de insertar la tarjeta SIM en la cámara, el periodo de prueba gratuita empezará cuando empiece a usar los datos.",
	"If you have_questions": "Si tiene más preguntas, póngase en contacto con nuestro <a>equipo de Atención al cliente</a>",
	"Data reset date": "Fecha de restablecimiento de los datos",
	"To use SIM card_": "Para utilizar la tarjeta SIM, póngase en contacto con el <a>Equipo CS</a> de BlackVue.",
	"Go to Subscription": "Ir a la suscripción",
	"An error occurred_subscription": "Ha ocurrido un error al suscribirse al plan seleccionado.",
	"Please try again": "Vuelva a intentarlo",
	"Failed to subscribe": "Fallo al suscribirse",
	"Go to Pricing": "Ver los precios",
	"SIM cards will_": "Las tarjetas SIM aparecerán aquí a medida que estén disponibles.",
	"1GB for 1_": "1 GB durante 1 mes",
	"Pricing Data": "Datos de precios",
	"If you would like to check_": "Si quiere comprobar el estado y gestionar los vídeos compartidos, vaya a Mapa de eventos > Mis vídeos compartidos.",
	"Connect to Cloud": "Conectarse a la nube",
	"Completed!": "Completado!",
	"Back to App": "Volver a la aplicación",
	"iOS in-app purchase": "Compras en la aplicación iOS",
	"Android in-app_": "Compras en la aplicación Android",
	"bonus n days": "bonificación de {{a}} días",
	"Want to contribute your_": "¿Permite que los archivos de subida automática de evento se compartan automáticamente en el mapa de eventos?",
	"With event map_": "Puede compartir el vídeo de subida automática de eventos con conductores cercanos a través del mapa de eventos.",
	"You can edit_3": "Puede editar los archivos de subida automática de eventos en los ajustes del mapa de eventos en cualquier momento desde BLACKVUE CLOUD > Ajustes de cámara > Ajustes de privacidad.",
	"If you want to remove videos_": "Como podría transmitirse algún vídeo personal, debe tener especial cuidado cuando decida qué información comparte.",
	"Total events": "Eventos totales",
	"Automatically add Live Event_": "Compartir automáticamente archivos de subida automática de evento en el mapa de eventos",
	"This camera is publicly_": "Esta cámara está abierta públicamente solo para su ubicación.",
	incomplete_zip: incomplete_zip$d,
	"Live Event Upload_": "Subida de evento en directo (periodo de almacenamiento: 7 días)\nRequiere el último firmware",
	"Thank you for_2": "Gracias por su paciencia.",
	"Start Web viewer": "Iniciar visor web",
	"Are you sure_remove driver": "Seguro que desea eliminar permanentemente al conductor",
	"An error occurred_sim": "Ha ocurrido un error al intentar suscribirse.",
	"Click the ADD SIM": "Haga clic en el botón añadir SIM de la página de lista de tarjetas SIM y siga el proceso para volver a añadir la SIM.",
	"Set download options": "Establecer opciones de descarga",
	"Information may be_": "Information may be transmitted with a delay and may not reflect actual balances.",
	"Swipe left and right to move": "Deslice a izquierda y derecha para moverse",
	"Scheduled maintenance Notice": "Aviso de mantenimiento programado",
	"Our Cloud server_": "Nuestro servidor de la nube estará en mantenimiento programado.",
	"During that time_": "Durante ese tiempo las funciones de la nube pueden no estar disponibles.",
	"Expected maintenance start_": "Tiempo de inicio del mantenimiento previsto:",
	"Expected duration_": "Duración prevista: {{a}} horas.",
	"For more information_": "Para ver más información, consulte el <a>[Aviso de mantenimiento del servidor]</a>.",
	"Do not remind_": "No volver a recordármelo",
	"Cloud Server Maintenance": "Mantenimiento del servidor de la nube",
	"BlackVue Cloud Service_": "El servicio de BlackVue Cloud está temporalmente no disponible",
	"We are currently_": "Actualmente estamos realizando tareas de mantenimiento.",
	"We apologize for_": "Pedimos disculpas por los inconvenientes.",
	"Driver Monitoring System (DMS)": "Sistema de monitorización del conductor (DMS)",
	"Distracted occurs_": "Ocurre cuando la cabeza del conductor está más de 50 grados alejada de la parte frontal.",
	"Hand distraction event occurs_": "Ocurre cuando se detecta la mano del conductor cerca de su cabeza durante un período prolongado de tiempo (como cuando fuma, sostiene un teléfono, etc.).\n",
	"Mask off event occurs_": "Ocurre cuando el conductor entra al vehículo sin mascarilla o cuando el conductor se quita la mascarilla.",
	"DMS setting": "Configuración del DMS",
	"The DMS system has_": "El DMS combina una caja de detección facial para los estados \"Detectado\", \"No detectado\", \"Distracción\", \"Somnolencia\" y \"Sin mascarilla\", y una caja de detección de movimiento para el estado de \"Distracción con la mano\".",
	"DMS detection": "Detección de DMS",
	"There are detection criteria for_": "Existen criterios de detección para cada evento. Por favor, consulte la guía a continuación.",
	"DMS camera recording_onoff": "Encendido: La cámara DMS graba en Modo de Estacionamiento mientras se mantenga la alimentación. <br/> Apagado: La cámara DMS se apaga poco después de entrar en el Modo de Estacionamiento.",
	"LED lighting for each event_": "El LED de la cámara de monitoreo del conductor señalará cada evento de detección (Distracción, Somnolencia, etc.).",
	"Drowsy and Distracted each have_": "La somnolencia y la distracción tiene tres condiciones de sensibilidad.\n Consulte la siguiente interfaz de guía.",
	"DMS event detection sensitivity": "Sensibilidad de detección de eventos DMS",
	"Only drowsy and distracted include_": "Solo la somnolencia y la distracción incluyen ajustes de sensibilidad. Además, con un solo ajuste realizado se aplica la misma sensibilidad a los dos eventos.",
	"When driver’s eyes close_": "Ocurre cuando el conductor cierra ambos ojos mientras conduce durante más de 1 segundo o bosteza durante 2 segundos.\n",
	"n digit": "{{a}} dígitos",
	"You are subscribed_free_Smart": "Está suscrito al plan Inteligente de BlackVue Cloud.",
	"Wi-Fi auto turn on": "Encendido Wi-Fi automático",
	"Video on a map": "Video on a map",
	"This feature is only_vom": "This feature is only available to users with a Fleet Plan subscription.<br/>Please subscribe to a plan to unlock this feature.",
	"Total n days_": "Total {{a}} días de ensayo gratuito",
	"Every events of DMC200_": "Las funciones de detección DMS solo están activas en el Modo Normal. Si se activa el Modo de Estacionamiento, la cámara DMS solo grabará video.",
	"An undetected event occurs_": "Ocurre cuando el conductor no es detectado frente a la cámara durante 1 minuto.",
	"A detected event occurs_": "A detected Event occurs when the driver is gazing in front since the power is set in the beginning.",
	"Drowsy sensitivity_": "High : When the driver closes their eyes for more than 1 second, it is considered drowsy driving.<br/><br/>Medium : When the driver closes their eyes for more than 1.5 second, it is considered drowsy driving.<br/><br/>Low : When the driver closes their eyes for more than 2 second, it is considered drowsy driving.",
	"Distracted sensitivity_": "High : If the angle of the head is more than 50 degrees away from the front for 3 seconds, it is detected as Distracted.<br/><br/>Medium : If the angle of the head is more than 50 degrees away from the front for 5 seconds, it is detected as Distracted.<br/><br/>Low : If the angle of the head is more than 50 degrees away from the front for 7 seconds, it is detected as Distracted.",
	"Start your subscription now": "Inicie su suscripción ahora",
	"Free trial period has expired": "El periodo gratuito de prueba ha caducado",
	"1 data plan will start from_": "El plan de datos empezará el {{a}} con 1 GB de datos para la tarjeta SIM BlackVue.",
	"Allow the BlackVue_": "¿Autorizar a la aplicación “BlackVue” para acceder a los datos GPS de su cámara de salpicadero?",
	"We use this_": "Utilizamos esto para rastrear la ubicación y velocidad de su coche.",
	"You can edit_": "Puede editar los ajustes de acceso a GPS en cualquier momento desde BLACKVUE CLOUD > Ajustes de cámara > Ajustes de privacidad.",
	"SIM cards": "tarjetas SIM",
	"Subscription status": "Estado de suscripción",
	Upgrades: Upgrades$d,
	"Upgrade plan": "Cambiar de plan",
	"Manage plan": "Administrar plan de suscripción",
	"Next plan": "Plan de suscripción del próximo mes",
	OR: OR$d,
	"Cancel subscription": "Cancelar suscripción",
	Undo: Undo$d,
	Invoice: Invoice$d,
	"Daily usage": "Uso diario de datos",
	"Delete SIM": "SIM card Eliminar",
	"New card": "nueva tarjeta de credito",
	data: data$d,
	"SIM card data_": "Puede cancelar la suscripción al plan de datos de la tarjeta SIM en <a>sim.blackvuecloud.com</a>.",
	"Your plan from_": "Su plan desde hoy hasta la siguiente fecha de facturación",
	"Applied during_": "Aplicado durante {{a}} ~ {{b}}",
	"From today until_": "A partir de hoy y hasta la próxima fecha de pago, solo podrá suscribirse al mismo plan del mes anterior. Los pagos para este periodo se facturarán hoy. <a>Las tasas se calculan por prorrateo.</a>",
	"Choose your next plan": "Elija su plan siguiente",
	"Applied from_": "Se aplica desde {{a}}",
	"Payment for this_": "El pago para este plan se cargará el {{a}}.",
	"By sharing your_2": "Al compartir su Vista en Director, podrá permitir a otros usuarios experimentar indirectamente la emoción y el placer de conducir por todo el mundo. Sin embargo, como es posible que transmita vídeos personales, debe tener mucho cuidado al decidir qué información comparte.",
	"Option camera recording_": "Cámara opcional grabando en modo estacionamiento.",
	"Front and option camera_": "La cámara frontal y la opcional graban juntas.",
	"Option camera stops_": "La cámara opcional deja de grabar 5 min, después de entrar en el modo de estacionamiento. La grabación se reinicia al entrar en modo normal.",
	"Option camera rotation": "Giro de la cámara opcional",
	"Option camera": "Cámara opcional",
	"Option camera security": "Seguridad de la cámara opcional",
	"Resubscribe until_": "Volver a suscribirse hasta: {{a}}",
	"Firmware Update Caution": "Precaución por actualización de firmware",
	"Please check below_": "Compruebe la siguiente condición antes de actualizar el software para el DMC200:",
	"The camera's Wi-Fi_": "El wifi de la cámara debe estar encendido.",
	"Check if your_": "Compruebe si el wifi de su cámara está activado.",
	"DO NOT disconnect_": "NO desconecte el cable coaxial durante la actualización del firmware.",
	"The camera and_": "La cámara y el DMC200 se podrían averiar.",
	"DO NOT try_": "NO intente utilizar otras funciones hasta que finalice el reinicio de la cámara.",
	"Expecially Reboot camera_": "Especialmente al reiniciar la cámara, el formato de la tarjeta SD puede ser crítico para averiar los dos dispositivos.",
	"Update anyway": "Actualizar de todos modos",
	"Invited on_2": "invitado el {{Invited Date}} por usted. Propietario",
	"BlackVue’s New firmware_": "Hay un nuevo firmware de BlackVue disponible",
	"valid thru_": "válido hasta: {{a}}",
	"Billed monthly": "Billed monthly",
	"90 minutes Live_": "90 minutes Live View / Live Event Upload*",
	"or 2+ videos_": "or 2+ videos in full resolution*",
	"1GB Free Month_": "1GB Free Month Trial",
	"Cancel anytime": "Cancel anytime",
	"8+ hours Live_": "8+ hours Live View / Live Event Upload*",
	"or 12+ videos_": "or 12+ videos in full resolution*",
	"15+ hours Live_": "15+ hours Live View / Live Event Upload*",
	"or 23+ videos_": "or 23+ videos in full resolution*",
	Popular: Popular$d,
	"For Power Users": "For Power Users",
	"Estimates based on_": "* Estimates based on 4.5MB per minute of Live View, Quick View remote playback, or Live Event Upload file, and 190MB per full original resolution video download or playback (at 25Mbps bitrate). Daily idle Cloud connection data usage: 20MB per 24 hours. Data usage is shared among all types of services (Live View, Live Event Upload, etc.).",
	"Balanced Plan": "Balanced Plan",
	"For Light Cloud_": "For Light Cloud Use",
	"Front security (Normal mode)": "Seguridad frontal (modo normal)",
	"Front security (Parking mode)": "Seguridad frontal (modo de estacionamiento)",
	"BT (Parking mode)": "BT (modo de estacionamiento)",
	"LTE (Parking mode)": "LTE (modo de estacionamiento)",
	"Wi-Fi (Parking mode)": "Wi-Fi (modo de estacionamiento)",
	"Hand distraction": "Distracción de mano",
	Mask: Mask$d,
	"Second drowsy is_": "Segunda somnolencia es un evento que ocurre antes de los 30 segundos del primer evento de somnolencia y que inicia la grabación del evento cargado en directo.",
	"Second drowsy alert": "Segunda alerta de somnolencia",
	"BlackVue sim card_": "La tarjeta SIM BlackVue solo se puede utilizar en Canadá y EE. UU.",
	"Global support is coming soon.": "El soporte mundial está próximo.",
	"The video file not found_": "No se ha encontrado el archivo de vídeo o hubo un problema durante la reproducción. Inténtelo de nuevo.",
	"Start Voice Call": "Iniciar la llamada de voz",
	"End Voice Call": "Terminar la llamada de voz",
	"Voice call in use": "Llamada de voz en uso",
	"Enable microphone access_": "Habilite el acceso al micrófono para usar la función de comunicación de voz bidireccional. Entre en la página de configuración del navegador para acceder a su micrófono.",
	"You may need to_": "Puede ser necesario recargar esta página para que los nuevos ajustes surtan efecto.",
	"Eye status": "Estado de los ojos",
	"Start time of live event upload video": "La hora de inicio del vídeo de carga del evento en directo",
	"Left eye": "Ojo izquierdo",
	"Right eye": "Ojo derecho",
	"Drowsy is occured when the driver close his/her eyes more then 1sec": "La somnolencia se produce cuando el conductor/conductora cierra los ojos más de 1 s",
	"Driver's Left eye movements with blinking count and period": "Los movimientos del ojo izquierdo del conductor con recuento de parpadeos y el periodo",
	"Driver's Right eye movements with blinking count and period": "Los movimientos del ojo derecho del conductor con recuento de parpadeos y el periodo",
	"Drowsy big data of the driver and after a Drowsy event occurs": "Los macrodatos de parpadeo del conductor tras un evento de somnolencia",
	"Sharing video to Event Map": "Compartir vídeo en el mapa de eventos",
	"Want to use a Voice call?": "¿Desea usar una llamada de voz?",
	"To use a voice call_": "Para usar una llamada de voz, reinicie la vista en directa y haga clic en «Permitir»",
	"There is no_": "Aún no hay vídeos compartidos. \nLa lista aparecerá cuando se haya compartido.",
	"Microphone blocked": "Micrófono bloqueado",
	"Want to center the map on your location?": "¿Quieres centrar el mapa en tu ubicación?",
	"To let the app access your location_": "Para permitir que la aplicación acceda a su ubicación, reinicie Event Map y seleccione \"OK\" cuando se le solicite.",
	"Location access permission required": "Se requiere permiso de acceso a la ubicación.",
	"Are you sure you want_2": "¿Seguro que quieres eliminar este vídeo del MAPA DE EVENTOS?",
	"Two-way voice_2": "Two-way voice communication / Voice Call",
	"Not supported by DR650GW and DR650S_": "Not supported by DR650GW and DR650S",
	"DR650S Series only_": "DR650S Series only",
	"Cancel download?": "¿Cancelar descarga?",
	"Your download is not_": "La descarga no se ha completado. ¿Quiere cancelar la descarga?",
	"Continue download": "Continuar la descarga",
	"Cancel download": "Cancelar la descarga",
	"Share your video to the Event Map?": "¿Quiere compartir su vídeo en el mapa de eventos?",
	"Afterwards, according to the reaction to the video_": "Después, según la reacción al vídeo, puede clasificarse como un vídeo popular e introducirse en el mapa de vídeos populares.",
	"Add hashtags and a brief description to describe your video.": "Añada etiquetas y una breve descripción para describir su vídeo.",
	"Would you like_": "¿Quiere compartirlo en el mapa de eventos?",
	"Successfully added video_": "¡Vídeo añadido correctamente para compartir en el mapa de eventos!",
	"This video cannot_": "Este vídeo no se puede compartir porque le faltan datos de localización GPS para fijarlo en el mapa.",
	"This video is_": "Este vídeo ya está añadido al mapa de eventos.",
	"Share to Event Map": "Compartir en mapa de eventos",
	"Describe in more_": "Describa con más detalle lo que ocurre en su vídeo (opcional)",
	"Description(optional)": "Descripción (opcional)",
	"Recording mode": "Modo de grabación",
	"Event triggers": "Activadores de evento",
	DMS: DMS$d,
	"Camera connectivity": "Conectividad de la cámara",
	"If not allowed_2": "Si no tiene los permisos, no podrá acceder desde la nube a la ubicación y velocidad de su coche.",
	"Share Live View_": "Compartir vídeo de Vista en directo",
	"Share Live View_2": "Compartir audio de Vista en directo",
	"Share camera profile": "Compartir perfil de cámara",
	"Parking impact": "Impacto durante el estacionamiento",
	"Parking events": "Parking Events",
	"Audio recording": "Grabación de audio",
	"Toggle the mic_": "Activar/desactivar el micrófono",
	"Full HD_": "Full HD @ 60fps + Full HD @ 30fps",
	"Video quality": "Calidad de vídeo",
	Extreme: Extreme$d,
	"More video files": "Más archivos de grabación",
	"Fewer video files": "Menos archivos de grabación",
	"Camera rotation": "Rotación de cámara trasera",
	"Video overlay": "Superposición de vídeo",
	"Date & time display": "Mostrar fecha y hora",
	"Speed unit": "Unidad de velocidad",
	"Check the orientation_": "Compruebe la orientación de la cámara frontal instalada en el vehículo. Seleccione la opción coincidente para grabar los vídeos en orientación vertical.",
	"Rotate 180º": "Girar 180º",
	"Rear camera rotation": "Rotación de cámara trasera",
	"Check the orientation_rear": "Compruebe la orientación de la cámara trasera instalada en el vehículo. Seleccione la opción coincidente para grabar los vídeos en orientación vertical.",
	"Mirror View": "Vista invertida",
	"Select Mirror View_": "Seleccione Vista invertida para voltear el vídeo horizontalmente.",
	"Check the orientation_interior": "Compruebe la orientación de la cámara opcional instalada en el vehículo. Seleccione la opción coincidente para grabar los vídeos en orientación vertical.",
	"Display off": "Apagar pantalla",
	"Explore crowd-sourced Events_": "Explore los eventos creados públicamente (impactos, frenadas bruscas, etc.) en el mapa, vea los vídeos compartidos por la comunidad y contribuya con sus propios eventos.",
	OFF: OFF$d,
	"Reboots once-a-day_": "Se reinicia una vez al día a la hora establecida si está en modo de estacionamiento para una estabilidad mejorada.",
	"Set time": "Ajustar hora",
	"FW language": "El idioma del firmware",
	"Rear security_2": "Seguridad trasera",
	"Bluetooth (Parking mode)_2": "Bluetooth (modo de estacionamiento)",
	"Failed to save_2": "Error al guardar la configuración de carga de eventos en directo",
	"Event file will_": "El archivo del evento se guardará automáticamente en el almacenamiento de carga de eventos en directo.",
	"An impact was_": "An Impact was detected during Parking Mode.",
	"When exiting Parking_": "Al salir del modo estacionamiento, su BlackVue anuncia si se detectó un impacto mientras estaba en modo estacionamiento. \n\n Notas: \n Los impactos generan vídeos de eventos. Se ignoran los impactos generados en los 3 minutos anteriores y siguientes a la salida del modo estacionamiento.",
	"Protect event files": "Proteger archivos de eventos",
	"Turning on this_": "Actívelo para proteger los últimos {{a}} archivos de Eventos de la sobrescritura por archivos de grabación Normal o en Estacionamiento.",
	"Impact Events in_": "Los archivos protegidos incluyen: \n\nEventos de impacto en Modo Normal(E) y Estacionamiento(I)",
	"Manual Events_": "Manual Events (M)",
	"Once 50 Events_": "Los archivos protegidos incluyen: \n\nEventos de impacto en Modo Normal(E) y Estacionamiento(I) \nEventos Manuales (M) \n\nUna vez registrados {{a}} eventos, los nuevos sobrescribirán los más antiguos.",
	"Reckless driving unit": "La unidad de conducción temeraria es",
	"Hard acceleration Event": "Evento de aceleración brusca",
	Threshold: Threshold$d,
	"Triggers when the_": "Se dispara cuando la cámara detecta una tasa de aceleración por segundo superior al valor umbral establecido.",
	"Triggers when the_2": "Se dispara cuando la cámara detecta una reducción de velocidad superior al valor umbral establecido.",
	"Hard braking Event": "Evento de frenado brusco",
	"Triggers when more_": "Se dispara cuando se detectan más de 60 grados en 2 segundos durante la conducción por encima del valor umbral establecido.",
	"Every event of DMC200_2": "Las funciones de detección de DMS solo están activas en el modo normal. Si se alimenta en el modo de estacionamiento, la cámara DMS solo grabará video.",
	"The DMS system has_2": "El DMS combina una caja de detección facial para los estados “Detectado”, “No detectado”, “Distracción”, “Somnolencia” y “Sin mascarilla”, y una caja de detección de movimiento para el estado de “Distracción con la mano”.",
	"One for face_": "One for face detection : Detected, Undetected, Distracted, Drowsy",
	"The other for_": "The other for motion detection",
	"On: Normal recording_": "On: Normal recording works while power is maintained in Parking Mode",
	"Off: DMS power_": "Off: DMS power off after 5 minutes when entering Parking Mode, Normal recording works until just before off",
	"Drowsy and Distracted_": "Drowsy and Distracted each have three sensitivity conditions.",
	"Please refer to_": "Please refer to the guide interface below.",
	Drowsiness: Drowsiness$d,
	"Drowsiness occurs when_": "El cansancio ocurre cuando el conductor cierra ambos ojos mientras conduce durante más de 1 segundo y bosteza durante 2 segundos.",
	"Distracted occurs when_": "Ocurre cuando la cabeza del conductor está más de 50 grados alejada de la parte frontal.",
	"A hand distraction_": "A hand distraction occurs when the driver removes one hand from the steering wheel. [*Smoking and phone calls may be suspected.]",
	"Mask off event_": "Mask-off event occurs in two ways. First is when the driver gets in the car without a mask. Second is when the driver takes their mask off",
	"High When the_": "High : When the driver closes their eyes for more than 1 second, it is considered drowsy driving.",
	"Middle When the_": "Medium : When the driver closes their eyes for more than 1.5 second, it is considered drowsy driving.",
	"Low When the_": "Low : When the driver closes their eyes for more than 2 second, it is considered drowsy driving.",
	"High If the_": "High : If the angle of the head is more than 50 degrees away from the front for 3 seconds, it is detected as Distracted.",
	"Middle If the_": "Medium : If the angle of the head is more than 50 degrees away from the front for 5 seconds, it is detected as Distracted.",
	"Low If the_": "Low : If the angle of the head is more than 50 degrees away from the front for 7 seconds, it is detected as Distracted.",
	Direct: Direct$d,
	"Camera Wi-Fi credentials": "Credenciales Wi-Fi de la cámara",
	"Network name(SSID)": "Nombre de red (SSID)",
	"Seamless pairing": "Seamless Pairing",
	Remote: Remote$d,
	"Hotspot settings": "Ajustes de punto de acceso",
	"Hotspot name": "Nombre del punto de acceso (SSID)",
	"Hotspot name must_": "Hotspot name must be at least 5 characters long",
	"Public cameras may_": "Las cámaras públicas pueden aparecer en la pestaña Explorar o en el mapa del mundo.",
	"Hard Cornering Event": "Evento de curvas cerradas",
	"Over speed_2": "Velocidad excesiva",
	"Second drawiness alert": "Segunda alerta de somnolencia",
	"Low Voltage Warning_2": "Distracción de mano",
	"(You)_2": "{{a}} (Usted)",
	"This video has been reported_": "Este vídeo ha sido denunciado y eliminado por el administrador.",
	"Normal Mode recording": "Grabación en modo normal",
	"ON : the camera_": "Activado: la cámara graba continuamente en bucle.",
	"OFF : the camera_": "Desactivado: la cámara solo graba vídeos de eventos durante la conducción.",
	"In both modes_": "En ambos modos, los impactos detectados activan grabaciones de vídeo de Eventos.",
	"Continuously records_": "Graba continuamente vídeos de 1 fotograma por segundo y 1 minuto de duración que cubren 30 minutos de acción.",
	"Choose detection regions_": "Elija las zonas de detección para reducir el riesgo de grabaciones no deseadas activadas por el movimiento de árboles que se mueven con el viento, objetos lejanos, etc.",
	"Your previous plan is expired.": "Su plan anterior ha caducado.",
	"Upgrade the plan to restore the camera": "Actualice el plan para restaurar la cámara\n(%@)",
	"Remove from cloud": "Eliminar de la nube",
	"Are you sure you want to Remove_": "¿Seguro que quiere eliminarla de la ranura de la nube?",
	"Remove: It doesn’t mean_": "Eliminar: No significa borrar los datos de la cámara, sino crear una ranura de repuesto para el número de cámaras en la nube.",
	"Now the camera is removed from cloud slot": "Se ha eliminado la cámara de la ranura de la nube.",
	"How to delete camera list": "Cómo eliminar una cámara de la lista",
	Update: Update$d,
	"Camrea setting": "Ajuste de cámara",
	"Notification setting": "Ajustes de notificación automática",
	"Driving reports": "Informe de conducción",
	"Cloud connection steps": "Paso de Conexión a la Nube",
	"Download the BlackVue app to add a camera": "Descargue la aplicación BlackVue para añadir una cámara",
	"To see your camera in the BlackVue cloud viewer_": "Para ver su cámara en el visor en la nube BlackVue, primero debe conectarla a la nube. Configure y conecte fácilmente su cámara BlackVue a la nube con la aplicación BlackVue para iOS y Android.",
	"Download the BlackVue app to see a Wi-Fi connected camera": "Descargue la aplicación BlackVue para ver una cámara conectada por Wi-Fi",
	"BlackVue Cloud web viewer only supports_": "El visor web BlackVue Cloud solo es compatible con la cámara para salpicadero conectada a la nube. Descargue la aplicación BlackVue para ver su cámara para salpicadero conectada por Wi-Fi.",
	"You can restore the data if_": "Puede restaurar los datos si registra de nuevo la cámara en la misma cuenta, pero si se ha eliminado la cuenta, se perderán todos sus archivos.",
	"How to add camera": "Cómo añadir una cámara",
	"Try to wait 2-3 minutes if you just registered the camera.": "Espere 2-3 minutos si acaba de registrar la cámara.",
	"Try to check the Cloud Connection Settings again_": "Compruebe otra vez los ajustes de conexión a la nube si la cámara sigue sin estar conectada a la nube.",
	"Motion Detection": "Detector de movimiento",
	"Parking recordings occur_": "Las grabaciones durante el estacionamiento se producen cuando se detecta movimiento visible.",
	"Motion Sensitivity": "Sensibilidad al movimiento",
	"Motion Detection Sensitivity": "Sensibilidad de detección de movimiento",
	"Select Detection Region": "Seleccione la región de detección",
	"Speed alert_2": "Alerta de velocidad",
	"Live Event Upload_2": "Live Event Upload",
	"Beep Alert": "Pitido de alerta",
	"Parking Impact History_": "Alerta de impactos durante el estacionamiento",
	"To register your_": "Para registrar su botón SOS, debe usar la aplicación BlackVue.",
	"SOS button on/off": "Estado del botón SOS",
	"File sharing to Event Map is_": "El uso compartido de archivos en Event Map no está disponible actualmente. Por favor, vuelva más tarde.",
	"Email Notifications": "Notificaciones por correo-e",
	"Push Notifications_2": "Notificaciones automáticas",
	"Optional Camera Rotation": "Orientación de la cámara opcional",
	"Optional Camera Security": "Seguridad de la cámara opcional",
	Option: Option$d,
	"(Owner)": "{{a}} (Propietario)",
	"SOS button": "Botón SOS",
	"This video has been reported_bold": "Este vídeo ha sido denunciado y <b> eliminado por el administrador.</b>",
	"Number of events_2": "Número de eventos",
	"My Shared Videos": "Mis vídeos compartidos",
	"No Hashtags": "No hay etiquetas",
	"I have read and agree_": "He leído y acepto todos los Términos y Políticas",
	"14 years old_": "14 años o más",
	Required: Required$d,
	Optional: Optional$d,
	"Profile information_": "La información del perfil puede editarse en la página Ajustes de la cuenta.",
	"Automatically Add Live_": "Compartir automáticamente archivos de subida automática de evento en el mapa de eventos",
	"You must be 14 years_": "Debe tener 14 años o más para crear una cuenta BlackVue",
	"Use 8 or more characters_": "Utilice 8 o más caracteres con una mezcla de letras, números o símbolos",
	"Protected files include_": "Los archivos protegidos incluyen: <br/>ㆍEventos de impacto en Modo Normal(E) y Estacionamiento(I) <br/>ㆍEventos Manuales (M) <br/><br/>Una vez registrados {{a}} eventos, los nuevos sobrescribirán los más antiguos.",
	"Protected files include": "Protected files include",
	"If you turn_": "Si desactiva la guía de voz, también se desactivan las siguientes listas.",
	"Live Event Upload_success": "Los ajustes de carga de eventos en directo se han guardado correctamente.",
	"Video type": "Tipos de vídeo",
	"Notify the Owner": "Notificar al propietario",
	"Adjusting the cut-off voltage_2": "Adjusting the cut-off voltage to a lower setting may result in your dash cam draining more power from your battery. This could result in warning messages of battery drain or affect other vehicle functions.\nPlease consult with your dealership before lowering the voltage.",
	Others: Others$d,
	"This video has been removed.": "Se ha eliminado este vídeo.",
	"Please assign cameras_": "Asigne cámaras a este grupo.",
	"Are you running_": "¿No tiene oportunidad de ver la reproducción?",
	"Upgrade your plan_": "Actualice su plan al plan de Flota para disfrutar de reproducción ilimitada y otras funciones exclusivas de la nube.",
	"Are you running_Liveview": "¿No tiene tiempo para ver la vista en directo?",
	"Upgrade your plan_Liveview": "Actualice su plan al plan de Flota para disfrutar de vista en directo ilimitada y otras funciones exclusivas de la nube.",
	Stay: Stay$d,
	"Go to Fleet Plan": "Ir al plan de Flota",
	"It looks like the video file is being prepared. please try again later.": "Parece que el archivo de video se está preparando. Por favor, inténtelo de nuevo más tarde.",
	"Oops!": "¡Ups!",
	"Please back up_": "Realice una copia de seguridad de todas las grabaciones importantes antes de cambiar esta configuración.",
	"When you save_": "Cuando guarde la configuración, la tarjeta microSD se formateará y todas las grabaciones se eliminarán para garantizar un funcionamiento estable.",
	"This is an unregistered_": "Este es un correo electrónico no registrado. ¿Le gustaría ir a la página Crear cuenta?",
	"Camera name must_2": "El nombre de la cámara debe tener entre 5 y 32 caracteres.",
	"G-sensor (Normal mode)": "Sensor G (Modo Normal)",
	"G-sensor (Parking mode)": "Sensor G (Modo Estacionamiento)",
	"Up & down": "Arriba y abajo",
	"Front & back": "Vista frontal y trasera",
	"Rotate Video 180º": "Rotate Video 180º",
	Mask_2: Mask_2$d,
	"Priority event": "Priority Event",
	"There is no_camera": "There is no camera that your owner assigned to you.",
	"Camera SSID": "Camera SSID",
	"The BlackVue dashcam_2": "The BlackVue dashcam is not compatible with 5GHz wireless networks",
	"Driver detection box_2": "Driver Detection Box",
	"DMS camera recording_2": "DMS Camera Recording in Parking Mode",
	Low_2: Low_2$d,
	Medium_2: Medium_2$d,
	High_3: High_3$d,
	"Live Event Upload_3": "Live Event Upload",
	"Driving Impact": "Driving Impact",
	"Video source_2": "Video Source",
	"Front camera_2": "Front Camera",
	"Rear camera_2": "Rear Camera",
	"Optional Camera": "Optional Camera",
	"Motion Detection_2": "Motion Detection",
	"Rear camera stops_2": "Rear camera stops recording 5 minutes after entering Parking Mode. Recording restarts when entering normal mode.",
	"Passenger vehicle": "Passenger Vehicle",
	"Heavy vehicle": "Heavy Vehicle",
	Highest_3: Highest_3$d,
	Extreme_2: Extreme_2$d,
	"Less recording files": "Fewer Recording Files",
	"Camera rotation_2": "Camera Rotation",
	"Share camera profile_2": "Share Camera Profile",
	Private_2: Private_2$d,
	"BlackVue Live": "BlackVue Live",
	"Important All saved_": "Important! All saved videos are about to be deleted. Tap Cancel and back up important files if needed.",
	"Whenever saving settings_": "Whenever saving settings after changing the time zone, the SD card is initialized and all stored files are deleted.",
	"Do you want_": "Do you want to save your changes?",
	"No groups": "No groups",
	Lite: Lite$d,
	"USD per Camera": "USD per extra Camera",
	"up to Cameras": "up to Cameras",
	"All the P Plan_": "Todas las funciones del plan <b>{{a}}</b>, más:",
	"User Roles and Permissions": "Roles y Permisos de Usuario",
	"Geofence Setup (Web) and alerts": "Geofence Setup (Web) and alerts",
	"N Times": "{{a}} Veces",
	"N Minutes": "{{a}} Minutos",
	"Emergency Alarm": "Alarma de emergencia",
	"Playback, Live View": "Reproducción, Live View",
	"Your driving record : Daily, Monthly": "Tu historial de conducción: Diario, Mensual",
	"Real-time Conversation": "Conversación en tiempo real",
	"Initiate a conversation_": "Inicie una conversación con el conductor a través del altavoz y el micrófono de Dashcam.",
	"Remote Voice Communication": "Comunicación de voz remota",
	"See the last location_": "Vea la última ubicación de su cámara",
	"Check your cars_": "Consulte los datos GPS en tiempo real de su automóvil en un mapa para localizar su vehículo y obtener información sobre su estado, como si está conduciendo o estacionado, y su velocidad.",
	"Supported models_": "* Modelos compatibles: modelos S y Early X Series",
	"GPS Tracking &_": "Seguimiento de GPS y Video en el mapa (Smart/Fleet)",
	"Track your cars_": "¡Rastree la ubicación y la velocidad de su automóvil en el mapa!",
	"GPS Tracking: visualize_": "Seguimiento del GPS: visualice su registro de conducción en el mapa.\nVideo en el mapa: Ver información contextual (velocidad, tipo de evento) y reproducir videos relacionados desde el mapa.",
	"Visualize your cars_": "¡Visualiza la ubicación y velocidad de tu coche en el mapa!\n",
	"The feature enables_": "La función permite cargar grabaciones de video a la nube, incluyendo los 5 segundos previos a un accidente.\n",
	"Camera profile setting": "Camera profile setting",
	"Are you running_Download": "Are you running out of chance to Download Video?",
	"Upgrade your plan_Download": "Upgrade your plan to Fleet Plan for Unlimited Download, and other Cloud -Exclusive features.",
	"This feature is available for Smart and Fleet_": "This feature is available for Smart and Fleet Plan subscribers only.",
	"Rear camera will keep_": "La cámara trasera seguirá grabando hasta que la cámara del tablero alcance el estado de alta temperatura después de pasar al modo de estacionamiento. La cámara trasera dejará de grabar automáticamente cuando llegue la temperatura alta. La cámara trasera comenzará a grabar nuevamente después de que la temperatura de la cámara frontal recupere su estado normal. (Precaución: teniendo en cuenta la protección de la cámara para salpicadero, es posible que Blackvue se apague debido a la temperatura externa).",
	"Get Unlimited Cloud_": "Obtén reproducción ilimitada en la nube y gestiona hasta {{a}} cámaras.",
	"Up to N cameras_": "Up to {{a}} cameras (+ {{b}} USD Extra charge)",
	"N Minutes per Day": "{{a}} minutos por día",
	"Drowsiness sensitivity is_": "La sensibilidad a la somnolencia se ajusta por el periodo de parpadeo de los ojos mediante el fiable algoritmo BlackVue. <br> <br> La sensibilidad de la distracción se ajusta por la posición de la cabeza del conductor delante de la cámara y la duración de dicha posición.",
	"Not available with this plan": "Not available with this plan",
	"The optional camera records_": "La cámara opcional graba en Modo de Estacionamiento",
	"Smart and Fleet_": "Smart and Fleet Plan<br/>subscribers only",
	"This feature is_smart": "This feature is available for Smart and Fleet Plan subscribers only.",
	"Camera Registration": "Registro de cámara",
	"Voice Call": "Voice Call",
	"N times per Month": "{{a}} times per Month",
	"Recommended for higher bitrate_": "Recomendado para una tasa de bits más alta y una mejor calidad de video.",
	"Recommended for for better compatibility_": "Recomendado para una mejor compatibilidad con dispositivos de escritorio y móviles",
	"A minute of front camera_": "Tamaño de archivo estimado para un video de 1 minuto (cámara frontal)",
	"Extreme(N Mbps): N MB_": "Extreme ({{ex1}}Mbps) : {{ex2}}MB\nHighest ({{ht1}}Mbps) : {{ht2}}MB\nHigh ({{hi1}}Mbps) : {{hi2}}MB\nNormal ({{no1}}Mbps) : {{no2}}MB",
	"File size information reflects_": "La información del tamaño del archivo refleja el tamaño máximo posible y los tamaños de archivo reales pueden variar dependiendo de las condiciones de grabación.",
	Bitrate: Bitrate$d,
	"Connection has been_": "La conexión se ha perdido.\nRestablecimiento de conexión ...",
	"Unable to establish_": "No se puede establecer una conexión con la cámara.\nAsegúrese de que su dispositivo esté conectado correctamente y vuelva a intentarlo.",
	"Purchased by Payment Service": "Comprado por Servicio de Pago",
	"Up to N Cameras": "Hasta {{a}} cámaras",
	"Unlimited Live View": "Vista en directo ilimitada",
	"N Days GPS Tracking": "Seguimiento GPS durante {{a}} días",
	"Unlimited Playback and Download": "Reproducción y descarga ilimitadas",
	hours: hours$d,
	"Live Event Upload or_": "Live Event Upload o 12+ videos en resolución completa",
	"During the usage period of the One Plan_": "Durante el período de uso del servicio One Plan, no es posible realizar cambios en el plan de suscripción. Para cambiar a un plan diferente, contacta al Soporte al Cliente de BlackVue para cancelar la suscripción de One Plan.",
	"Service Period (Include SIM Data)": "Período de servicio (Incluye datos SIM)",
	"Purchase the BlackVue One Package_": "Compra el paquete BlackVue One para desbloquear el One Plan gratis durante 1 año.",
	"3GB SIM Data Plan": "Plan de datos SIM de 3 GB",
	"Unlimited Live View, Playback and Download": "Vista, reproducción y descarga ilimitadas en vivo",
	"within data availability": "dentro de la disponibilidad de datos",
	"The BlackVue One Plan is a 1-year_": "El BlackVue One Plan es un plan de servicio en la nube de 1 año accesible exclusivamente mediante la compra de un paquete BlackVue One, que incluye una cámara de tablero, un plan de datos de 3GB/mes por 1 año (para EE. UU. y Canadá) y un plan de servicio en la nube por 1 año.",
	"The BlackVue One Package is available_": "El paquete BlackVue One está disponible exclusivamente en la tienda en línea de BlackVue.",
	"Go to BlackVue Shop": "Ir a la tienda BlackVue",
	"Anonymous Cam": "Cámara anónima",
	"App only": "solo en la aplicación",
	Expires: Expires$d,
	"N days remaining": "{{a}} días restantes",
	"No action needed_": "<b>No se requiere ninguna acción.</b> El nuevo precio reducido se aplicará automáticamente a partir de su próximo pago después del 13 de septiembre.",
	"The new reduced price_": "El nuevo precio reducido se aplicará automáticamente a su cuenta.",
	"Smart Plan Subscriber?": "¿Suscriptor del Plan Smart?",
	"Fleet Plan Subscriber?": "¿Suscriptor del Plan Fleet?",
	"Please take a moment to_": "Por favor, tómese un momento para autorizarnos a migrar su cuenta.",
	"Starting from now and_": "<b>Desde ahora hasta el 31 de octubre</b>, puede permitirnos realizar el cambio por usted <a href=\"https://form.jotform.com/232411253056041\" target=\"_blank\">haciendo clic en este enlace</a> e ingresando su correo electrónico de la cuenta Fleet. Por favor, permita que tengamos algo de tiempo para procesar el cambio. Alternativamente, podrá cancelar su cuenta existente y suscribirse nuevamente al nuevo precio a partir del 13 de septiembre.",
	"Once activated_": "Una vez activado, el One Plan no se puede pausar ni desactivar.",
	"Once the One Plan is activated_": "Una vez que se activa el One Plan, no se puede reembolsar el One Package.",
	"Up to N Cloud Camera Slot": "Hasta {{a}} ranura(s) de cámara en la nube",
	"nGB of Cloud Storage": "{{a}}GB de almacenamiento en la nube",
	"Get started for free_": "Get started for free, no credit card required. Includes Alert Push Notifications, limited Remote Live View and cloud storage.",
	"The BlackVue One Plan is exclusively_": "The BlackVue One Plan is exclusively available through the purchase of a BlackVue One Package. 3GB/mo data plan is for US and Canada only. BlackVue Cloud’s Free Plan, Lite Plan (1~3) and Smart Plan (1~3) accounts can upgrade to One Plan. However, Lite Plan (4~15), Smart Plan (4~15) and Fleet Plan accounts can not be upgraded to One Plan.",
	"For N year": "For {{a}} year",
	"Included in the One Package": "Included in the One Package",
	"3GB SIM Data Plan for N year": "3GB SIM Data Plan for {{a}} year",
	"One Plan Cloud Service for N year": "One Plan Cloud Service for {{a}} year",
	"The BlackVue One Package includes_": "The BlackVue One Package includes all you need to enjoy BlackVue Cloud for a whole year!",
	"4K LTE Dash Cam_": "4K LTE Dash Cam, Cloud Service and Data Plan",
	"nGB included": "{{a}}GB included",
	"nGB per camera": "{{a}}GB per camera",
	"N Days Live Event Upload": "{{a}} Days Live Event Upload",
	"Up to N Dash Cameras": "Up to {{a}} Dash Cameras",
	"Step N/N": "Paso {{a}}/{{b}}",
	"Cloud Connection": "Conexión a la nube",
	"To pair your dashcam": "Para emparejar su dashcam con la batería, conéctela a la nube.",
	Check: Check$d,
	"Unpair Battery": "Desvincular batería",
	"Are you sure you want to unpair": "¿Estás seguro de que quieres desvincular esta batería (%@) de la cámara?",
	"Unpair: It doesn't mean": "Desemparejar: No significa eliminar los datos de la batería.",
	"*The paired battery will": "*La batería emparejada también se eliminará junto con ella.",
	"Would you like to pair this": "¿Te gustaría emparejar esta batería?",
	"Battery successfully paired": "Batería emparejada con éxito.",
	"Now you can directly connect to": "Ahora puedes conectarte directamente a la batería desde la lista de cámaras.",
	"Pairing failed": "Fallo al emparejar. Por favor, inténtalo de nuevo.",
	"Battery Name": "Nombre de la batería",
	"Capacity History": "Historial de capacidad",
	"The graph displays capacity": "El gráfico muestra un nivel de batería aproximado utilizando datos de la conexión en la nube.\n La capacidad de la batería puede variar según la temperatura, la configuración de la cámara de tablero y la frecuencia de los eventos de activación.",
	"Last 24 Hours": "Últimas 24 horas",
	"Last 7 Days": "Últimos 7 días",
	"Battery Level": "Nivel de batería",
	"Temperature History": "Historial de temperatura",
	"The graph displays temperature": "El gráfico muestra un nivel de temperatura aproximado utilizando datos de la conexión en la nube.",
	"Temperature Level": "Nivel de temperatura",
	"Connecting alert": "[ Conectando ]\nDatos mostrados al conectarse.",
	"Low Output power Alert": "[ Corte de alimentación de salida ]\nEl voltaje de salida es demasiado bajo, limitando el suministro de energía del dispositivo conectado.",
	"High temp Alert": "[ Corte de alimentación de entrada ]\nLa temperatura de la batería es demasiado alta, limitando la carga.",
	"Remaining time": "Tiempo restante",
	"Remaining time estimate": "El tiempo restante es una estimación basada en el consumo total de energía de los dispositivos conectados.\n Se recalcula cada 30 segundos después de conectarse a la batería.",
	"Setting changed": "Cambio de configuración",
	"Setting change failed": "Error al cambiar la configuración",
	"Low Input power Alert": "[ Corte de alimentación de entrada ]\nEl voltaje de carga es demasiado bajo, limitando la carga.",
	"High Input power Alert": "[ Corte de alimentación de entrada ]\nEl voltaje de carga es demasiado alto, lo que limita la carga.",
	"Low temp_Cut off Alert": "[ Corte de alimentación de entrada ]\nLa temperatura de la batería es demasiado baja, limitando la carga y el tiempo de duración.",
	"Low temp Alert": "[ Temperatura baja ]\nLa temperatura de la batería es demasiado baja, lo que limita el tiempo de duración y la velocidad de carga.",
	"Low capacity Alert": "[ Capacidad baja ]\nLa capacidad de la batería es demasiado baja.\nConduce el coche para cargarlo.",
	"Back to list": "Volver a la lista",
	Saving: Saving$d,
	Now: Now$d,
	"Power supplying is limited": "El suministro de energía está <b>limitado</b>",
	"This battery is already paired": "Esta batería ya está emparejada.",
	"Connecting to Battery": "Conectando a la batería",
	"Paired battery": "Batería emparejada",
	"Battery unpairing failed": "Fallo al desemparejar la batería. Por favor, inténtalo de nuevo.",
	"A connection is already active": "Ya hay una conexión activa. Por favor, inténtalo de nuevo más tarde.",
	"Searching for battery": "Buscando la batería",
	"Select battery to pair with your camera": "Seleccione la batería para emparejar con su cámara.",
	"Unable to connect": "No se puede conectar",
	"A connection error has occurred": "Se ha producido un error de conexión. Por favor, inténtelo de nuevo.",
	"The paired dashcam has been disconnected": "La cámara de tablero emparejada se ha desconectado de la nube.\nPor favor, verifique las condiciones a continuación.",
	"Check if the battery is not fully discharged": "Compruebe si la batería no está completamente descargada",
	"Check the Cloud connection of the paired dashcam": "Compruebe la conexión a la nube de la cámara de salpicadero emparejada",
	"Connection lost": "Conexión perdida",
	"A connection error has occurred shortly": "Se ha producido un error de conexión. Por favor, intenta conectarte pronto.",
	"Charging is limited": "La carga está <b>limitada</b>",
	"Cannot connect to the battery": "No se puede conectar a la batería.",
	"Please check the Cloud connection of the camera": "Por favor, compruebe la conexión a la nube de la cámara.",
	"Charging complete in": "Carga completa en %@",
	"Current Capacity": "Capacidad Actual",
	"Output Voltage": "Tensión de Salida",
	"Charging Voltage": "Tensión de Carga",
	Beep: Beep$d,
	"Battery Capacity": "Capacidad de batería",
	"Battery connection failed": "Fallo de conexión de la batería",
	"Expansion battery": "Batería de reserva",
	"Make sure it is switched on and within range": "• Asegúrese de que está encendida y dentro del alcance de su móvil.",
	"Make sure it is not wirelessly connected to another device": "• Asegúrese de que no está conectada de forma inalámbrica a otro dispositivo.",
	"Detected batteries": "Baterías detectadas",
	"Can't see your battery": "¿No puede ver su batería?",
	"Download the Blackvue app to check": "Descarga la aplicación BlackVue para verificar tu batería de forma remota",
	"By Using the app": "Utilizando la aplicación, puedes emparejar tu cámara para el coche con la batería y monitorizar la capacidad de la batería a través de la nube. Después del emparejamiento, puedes comprobar la batería en el visor de la nube de BlackVue.",
	Unpair: Unpair$d,
	"Occurs when the driver closes_": "Ocurre cuando el conductor cierra ambos ojos mientras conduce",
	"Occurs when the driver's head_": "Ocurre cuando la cabeza del conductor está más de 50 grados alejada de la parte delantera.",
	"Only detects distraction above_": "Solo detecta distracción por encima del valor establecido. Puedes cambiar la unidad en 'Configuración de la cámara > Activadores de evento > La unidad de conducción temeraria es'.",
	"Occurs when the driver is not wearing_": "Ocurre cuando el conductor no lleva puesto el cinturón de seguridad.",
	"Overlays a face detection box_": "Superpone un cuadro de detección de rostros en imágenes en vivo y grabadas de la cámara DMS.",
	"Seat Belt": "Cinturón de seguridad",
	Detected: Detected$d,
	"No Seat Belt": "Sin cinturón de seguridad",
	"Fatigue Risk Alert": "Alerta de riesgo de fatiga",
	"The time is synchronized_Email": "El tiempo está sincronizado con el tiempo en sus notificaciones por correo electrónico.",
	"Sends an alert when drowsiness is_": "Envía una alerta cuando se detecta somnolencia después de la somnolencia inicial.",
	"Data updates upon connection": "Los datos se actualizan al conectar.",
	"Sends a notification if_": "Envía una notificación si se excede la 'Hora Establecida' durante la conducción.",
	"Data updates Alert": "[ Conectando ]\nLos datos se actualizan al conectar.",
	"Cannot save settings": "No se pueden guardar los ajustes",
	"The time is synchronized_Push": "La hora está sincronizada con la hora de sus notificaciones automáticas.",
	"The file has been overwritten or deleted": "Se ha sobrescrito o eliminado el archivo.",
	"Box Pro Models Settings": "Configuración de Modelos Box Pro",
	"Push notifications can be configured_": "Las notificaciones push se pueden configurar en la configuración de notificaciones de la cámara.",
	"Recording Video": "Grabación de Video",
	"Cameras settings": "Configuración de cámaras",
	"Please configure the settings": "Por favor, configura los ajustes",
	"Speed Priorities": "Prioridades de velocidad",
	"Set Speed Priority": "Establecer prioridad de velocidad",
	"Geofence-enter": "Geovallado: entrar",
	"Geofence-exit": "Geovallado: salir",
	"Geofence-pass": "Geovallado: pasar",
	"Geofence-speed alert": "Geovallado:Alerta de velocidad",
	"Drive Position": "Posición del Conductor",
	"Left-Hand Drive": "Conducción a la Izquierda",
	"Right-Hand Drive": "Conducción a la Derecha",
	"Please configure this setting_": "Configure esta opción si el conductor no se detecta correctamente.",
	"A new feature in the BlackVue settings_": "Se ha agregado una nueva función en la configuración de BlackVue para sincronizar la hora de la cámara. Debes sincronizar la hora de tu cámara una vez para grabar la hora con precisión.",
	"Feature location_": "Ubicación de la característica:\nConfiguración de la cámara> Sistema> Sincronización de hora",
	"Time Sync": "Sincronización de tiempo",
	"You can sync the time between_": "Puede sincronizar la hora entre su dispositivo y la cámara BlackVue. Se requiere formatear la tarjeta SD para la sincronización. Antes de continuar, haga una copia de seguridad de cualquier video necesario.",
	"Voice Alert": "Alerta de voz",
	"Provides a voice alert_": "Proporciona una alerta de voz desde la cámara y envía una notificación si excedes el tiempo establecido durante tu conducción.",
	"Please enter a value": "Please enter a value.",
	"Notices & Notifications": "Noticias y Notificaciones",
	"Only detects drowsiness above_": "Solo detecta somnolencia por encima del valor establecido. Puedes cambiar la unidad en 'Configuración de la cámara > Activadores de evento > La unidad de conducción temeraria es'.",
	Promotion: Promotion$d,
	Notice: Notice$d,
	"View More": "Ver más",
	"Read More": "Leer más",
	"Detection Box": "Caja de Detección",
	"Seatbelt Detection Box": "Caja de Detección de Cinturón de Seguridad",
	"Drive Position Detection Box": "Caja de Detección de Posición de Conducción",
	"Fleet Subscription Promotion (50%)": "Promoción Suscripción a Flota (50%)",
	"BlackVue Fleet Tracking exclusive features_": "Funciones exclusivas de BlackVue Fleet Tracking para usuarios avanzados y empresas por igual (múltiples usuarios y cámaras, geocercas, visor web, etc.).",
	"Special Discount (50% off)": "Descuento especial (50% de descuento)",
	"*Promotion applied for 12 months": "*Promoción aplicada por 12 meses",
	"*Payment will be made starting next month.": "*El pago se realizará a partir del próximo mes.",
	"[About using promotions]": "[Acerca del uso de promociones]",
	"The promotion is free for the first month_": "La promoción es gratuita durante el primer mes y luego se factura por 12 meses a partir del mes siguiente.",
	"For users with an existing Lite/Smart subscription_": "Para los usuarios con una suscripción Lite/Smart existente, deben cancelar su suscripción a la aplicación existente por separado; de lo contrario, es posible que la suscripción a la aplicación existente se cargue a su cuenta.",
	"Please be sure to cancel your app subscription_": "Asegúrese de cancelar la suscripción a su aplicación dentro del período gratuito. Los pagos dobles no serán reembolsados.",
	"You will be changed to Fleet Plan immediately_": "Se le cambiará al Plan Flota inmediatamente, incluso si el plazo de suscripción restante de su Plan Lite/Smart existente no ha expirado.",
	"You can cancel Fleet Plan any time.": "Puedes cancelar el Plan de Flota en cualquier momento.",
	"From February 2025, please go to the Fleeta service and use it.": "Una vez cancelada la promoción, la promoción no se volverá a aplicar.",
	"After promotion expires_": "Una vez que expire la promoción, se le renovará automáticamente con la tarifa de suscripción del Plan de flota existente.",
	"(Required) I have read the promotion instructions_": "(Obligatorio) He leído las instrucciones de la promoción y acepto el pago.",
	"Upgrade to Fleet Plan immediately": "Actualice al plan de flota inmediatamente",
	"Important Notice:": "Aviso importante:",
	"Switch of BlackVue Web Viewer to Fleeta Web Viewer": "Cambio de BlackVue Web Viewer a Fleeta Web Viewer",
	"To provide better features and quality_": "Para ofrecer mejores funciones y calidad, el servicio de visor web BlackVue pronto cambiará a un nuevo servicio de visor web de flota llamado Fleeta. Los servicios de Fleeta serán exclusivos únicamente para los usuarios del Plan Fleet. El servicio Fleeta se lanzará en marzo de 2025, con una nueva aplicación exclusiva de Fleeta. Visite <a href=\"https://www.fleeta.io\" target=\"_blank\">fleeta.io</a> para obtener más información.",
	"We kindly ask for your understanding_": "Le pedimos amablemente su comprensión, ya que este cambio tiene como objetivo brindar un servicio mejorado. Si tiene alguna pregunta sobre esta transición, no dude en comunicarse con nuestro centro de informática.",
	"Don’t show this again for this month": "No volver a mostrar esto durante este mes.",
	"Fleet Plan Subscription Promotion": "Promoción de suscripción al plan de flota",
	"Period : December 2, 2024 ~ May 31, 2025": "Período : 2 de diciembre de 2024 ~ 31 de mayo de 2025",
	"See more details": "Ver más detalles",
	"To continue improve quality and provide better service_": "Para seguir mejorando la calidad y brindar un mejor servicio, nuestro servicio BlackVue Web Viewer pronto cambiará a un servicio exclusivo del Plan Flota. Ya no estará disponible de forma gratuita ni mediante otros planes a partir de finales de marzo de 2025.",
	"We have prepared special discount offers for_": "Hemos preparado ofertas de descuento especiales para nuestros usuarios actuales de Web Viewer. ¡Por favor verifique los detalles a continuación! Le pedimos amablemente su comprensión y apoyo mientras implementamos este cambio para brindar un mejor servicio.\n",
	"*If you are subscribed in-app_": "*Si está suscrito a la aplicación, asegúrese de cancelar su suscripción a la aplicación.",
	"Enjoy your BlackVue Cloud service with your dashcam.": "Disfrute de su servicio BlackVue Cloud con su cámara para salpicadero.",
	"Available Cloud Camera slot(s)_": "Ranuras disponibles para cámara en la nube: {{d}}",
	"Not eligible for the promotion.": "No elegible para la promoción.",
	"You have already used_": "Ya has utilizado esta promoción. Una vez cancelada la promoción no se podrá volver a aplicar.",
	"Go to Cameras": "Ir a cámaras",
	"Congratulations !": "Congratulations !",
	"Fleet Plan user": "Fleet Plan user",
	"Let your BlackVue monitor_": "Deja que tu BlackVue monitorice tu coche y te avise de incidencias. En el momento en que se detecte un Impacto, su BlackVue enviará una notificación a su teléfono, acompañada de una instantánea.\n",
	"Live Event Upload feature automatically_": "La función de carga de eventos en vivo carga automáticamente secuencias de video, incluidas imágenes previas al accidente, a BlackVue Cloud Storage para mantener sus videos seguros.",
	"*Buffer time varies by model.": "*El tiempo de búfer varía según el modelo.",
	Explore: Explore$d,
	"Cloud Storage": "Almacenamiento en la nube",
	"My Cloud Cameras": "Mis cámaras en la nube",
	"My Cloud Cameras Only": "Solo mis cámaras en la nube",
	"BlackVue Live Camera": "Cámara en vivo BlackVue",
	"*For BlackVue Live Cameras_": "*Para las cámaras BlackVue Live, solo las cámaras compartidas como públicas en la configuración de la cámara se pueden ver en el mapa.",
	"*Share Method_": "*Método de compartir: Configuración de la cámara>Privacidad",
	"Once the promotion is canceled_": "Una vez cancelada la promoción, la promoción no se volverá a aplicar.",
	"It will show_": "Aparecerá aquí a medida que estén disponibles.",
	"Deactivate Cloud": "Desactivar la nube",
	"Are you sure you want to deactivate_": "¿Estás seguro de que deseas desactivar la nube para esta cámara?",
	"Deactivate : It doesn’t_": "Siempre puedes activar la nube en cualquier momento. La cámara se puede eliminar una vez completada la desactivación.",
	Deactivate: Deactivate$d,
	"*If you made the payment through_": "*Si realizó el pago a través de la aplicación, reiníciela.",
	"Connect Dashcam Locally (Wi-Fi)": "Conecte Dashcam localmente (Wi-Fi)",
	"Cloud Connection Setting": "Configuración de conexión a la nube",
	"Camera Profile": "Perfil de la cámara",
	"Camera Settings": "Configuración de la cámara",
	"Format MicroSD Card": "Formatear la tarjeta microSD",
	"Remote Firmware Update": "Actualización remota de firmware",
	"Remove from Cloud": "Quitar de la nube",
	"The location may not be accurate_": "Es posible que la ubicación no sea precisa porque la cámara no está conectada a la nube.",
	"The location of the camera cannot be found_": "No se puede encontrar la ubicación de la cámara. Verifique la configuración de conexión a la nube.",
	"Manage\nFLEETA Drive": "Gestionar\nFLEETA Almacenamiento",
	"Cloud\nConnection": "Conexión\nen la nube",
	"Available on FLEETA App": "Disponible en la aplicación FLEETA",
	"Available for Cloud dashcam OR on FLEETA App.": "Disponible para dashcam en la nube O en la aplicación FLEETA.",
	"Get started with_": "Comienza con una prueba gratuita de 1 mes",
	"Experience all of_": "Experimenta todas las características premium de FLEETA gratis durante tu prueba de 1 mes.\n\nSin compromiso—cancela en cualquier momento",
	"Welcome to FLEETA Webviewer.": "Bienvenido a FLEETA Webviewer.",
	"Let FLEETA get_": "Deja que FLEETA te conozca",
	"Help improve your_": "Ayuda a mejorar tu experiencia compartiendo algunos detalles",
	"Business Industry": "Industria empresarial",
	"Vehicle & Cargo": "Vehículo y Carga",
	Compliance: Compliance$d,
	"Would you like to skip?": "¿Te gustaría omitirlo?",
	"What is your business industry?": "¿En qué industria opera su negocio?",
	"Transportation & Logistics": "Transporte y Logística",
	"Rental & Leasing": "Alquiler y Arrendamiento",
	"Construction & Building": "Construcción y Edificación",
	"Government & Public": "Gobierno y Público",
	"Facility & Utility Management": "Gestión de Instalaciones y Servicios",
	Manufacturing: Manufacturing$d,
	"Retail & Wholesale": "Venta Minorista y Mayorista",
	Emergency: Emergency$d,
	Security: Security$d,
	"How many employees do you need to manage?": "¿Cuántos empleados necesita gestionar?",
	"How many vehicles does your company operate?": "¿Cuántos vehículos opera su empresa?",
	"Why do you use a fleet tracking service?": "¿Por qué utiliza un servicio de seguimiento de flotas?",
	"Route Tracking": "Rastreo de ruta",
	"Real-time Monitoring": "Monitoreo en tiempo real",
	"Incident Detection & Check video": "Detección de incidentes y verificación de video",
	"Behavior Monitoring & Analysis": "Monitoreo y análisis de comportamiento",
	"Evaluation & Management": "Evaluación y Gestión",
	"Theft Prevention": "Prevención de robos",
	"Monitoring & Maintenance": "Monitoreo y Mantenimiento",
	"Verification & Management": "Verificación y Gestión",
	"BlackVue App Use Only": "Uso exclusivo de la app BlackVue",
	"Your current plan allow_": "Tu plan actual permite el uso de la aplicación BlackVue. Para usar el Visor Web, suscríbete al Plan de Flota (FLEETA).",
	"Learn more about the Fleet_": "Aprende más sobre el Plan de Flota (FLEETA)",
	"Special Offer": "Oferta Especial",
	"For a limited time_": "Por tiempo limitado, disfruta de un 50% de descuento en tu suscripción al Plan de Flota.",
	"See Discount Details": "Ver detalles del descuento",
	"To subscribe to the Fleet_": "Para suscribirte al Plan de Flota, por favor cancela primero tu suscripción de BlackVue en la aplicación para evitar cargos duplicados.",
	"Skip tour": "Omitir recorrido",
	"In the cloud_": "En el entorno en la nube, puedes acceder a reproducción, ver en directo (incluyendo multivista), GPS en vivo y reportes, todo a través del Visor Web de FLEETA.",
	"Cloud Storage is_": "Almacenamiento en la nube es donde tus videos subidos se almacenan de manera segura en la nube. Sube tus videos para mantenerlos seguros por mucho tiempo.",
	"Toggle to switch_": "Alternar para cambiar entre Mapa / Lista",
	"In List View_": "En la Vista de Lista, puedes ver y gestionar fácilmente grupos, miembros e información de firmware de un vistazo.",
	"What is Cloud Storage?": "¿Qué es el Almacenamiento en la nube?",
	"Cloud Storage Overview": "Resumen del Almacenamiento en la nube",
	"Difference Between FLEETA_": "Diferencia entre FLEETA Drive y Carga de eventos en vivo",
	"FLEETA Drive stores_": "FLEETA Almacenamiento guarda los videos que has subido manualmente",
	"Live Event Upload automatically_": "Carga de eventos en vivo almacena automáticamente los videos cuando ocurre un evento.",
	"Live Event Upload videos_": "Los videos de Carga de eventos en vivo tienen un período de expiración. Si deseas conservarlos por más tiempo, muévelos a FLEETA Almacenamiento.",
	"Note: SD Card_": "Nota: Videos de tarjeta SD en Reproducción",
	"Videos stored on_": "Los vídeos almacenados en tu tarjeta SD se pueden acceder a través del menú de Reproducción.",
	"Set your image_": "Establece tu imagen utilizando el marco proporcionado. Una vez que la imagen esté guardada, se mostrará en la tarjeta de la cámara y en el icono de vista de mapa.",
	"*Only jpg and_": "*Solo se admiten archivos jpg y png.",
	"Set as default image": "Establecer como imagen predeterminada",
	"Camera Details": "Detalles de la cámara",
	"IT & Telecommunications": "TI y Telecomunicaciones",
	"The name must_32": "El nombre debe tener entre 1 y 32 caracteres.",
	"Unable to display the map.": "No se puede mostrar el mapa.",
	"The camera location cannot be found_": "No se puede encontrar la ubicación de la cámara debido a una mala conexión GPS.",
	"Cloud Cameras": "Cámaras en la nube",
	"Want to unlock_": "¿Desea desbloquear las funciones de gestión de flotas?",
	"*Web subscription only": "*Solo suscripción web",
	"Uploads event_": "Carga las grabaciones del evento al Almacenamiento en la nube de inmediato cuando ocurre el evento.",
	"Starts a conversation_": "Inicia una conversación con el conductor utilizando el altavoz y el micrófono de la cámara del tablero.",
	"Remotely check_": "Verifique de forma remota el nivel y el estado de la batería a través de la nube.",
	"Receive a voice_": "Recibe una alerta de voz y notificaciones si el tiempo de conducción supera el límite.",
	"View your_": "Mira tu registro de conducción en el mapa.",
	"View speed, event_": "Vea la velocidad, el tipo de evento y reproduzca videos relacionados directamente en el mapa.",
	"FLEETA Tracking exclusive_": "FLEETA Tracking ofrece características exclusivas tanto para usuarios avanzados como para empresas (Varios usuarios y cámaras, geovallado, etc.).",
	"Cloud Cameras per Account": "Cámaras en la nube por cuenta",
	"Connect Dashcam Locally_": "Conectar Dashcam localmente (Wi-Fi) (Reproducción, Descarga, Ver en directo)",
	"Available with_": "Disponible con batería BlackVue",
	"Cloud Battery": "Batería en la nube",
	"Driving Reports": "Informes de conducción",
	"Video on Map": "Video en el mapa",
	"Multi Live View (Fleeta Web Viewer)": "Vista en Vivo Múltiple (Visor Web de FLEETA)",
	"Enter a number": "Introduce un número",
	"Permission required.": "Se requiere permiso.",
	"Please contact_": "Por favor, contacte con el propietario para obtener ayuda.",
	"Access not available": "Acceso no disponible.",
	"This file cannot be deleted now.": "Este archivo no puede ser eliminado ahora.",
	"Please try again later.": "Por favor, inténtelo de nuevo más tarde.",
	"Permission required.\nPlease_": "Se requiere permiso.\nPor favor, contacte con el propietario para obtener ayuda.",
	"Cloud Storage is disconnected_": "Almacenamiento en la nube está desconectado. Por favor, verifica la conexión.",
	"Manage the plan_": "Gestionar el plan para restaurar la cámara",
	"Notify the owner_": "Notifica al propietario para que gestione el plan",
	"Access Restricted:_": "Acceso Restringido: Suscripción Expirada",
	"Access is currently_": "El acceso no está disponible actualmente debido a una suscripción vencida.",
	"Please contact your owner_": "Por favor, contacta a tu propietario para resolver este problema.",
	"Access will be_": "El acceso se restaurará una vez que se renueve la suscripción",
	"Cloud is disconnected_": "Almacenamiento en la nube está desconectado. \nPor favor, revise la conexión.",
	"Connect to Cloud with_": "Conéctate al Almacenamiento en la nube con la APP FLEETA",
	"Using Wi-Fi Hotspot": "Uso de punto de acceso Wi-Fi",
	Important: Important$d,
	"Pre-Event buffer_": "La grabación de buffer de pre-evento está deshabilitada en este modo.",
	"connectivity is_": "La conectividad está restringida en este modo.",
	"video upload starts_": "La carga de videos comienza después de que la grabación esté completa.",
	"Power Saving": "Ahorro de energía",
	"In all modes_": "En todos los modos, los impactos detectados activan las grabaciones de video de Eventos.",
	"Battery Protection setting _": "La configuración de Protección de Batería debe estar ACTIVADA.",
	"At least one of_": "Al menos uno de los siguientes ajustes debe estar habilitado",
	or: or$d,
	"For BlackVue battery users": "Para usuarios de baterías BlackVue",
	"we recommend setting_": "Recomendamos configurar el corte de voltaje al valor mínimo para maximizar el uso de la batería.",
	"No videos were found.": "No se encontraron videos.",
	"Try different filter_": "Prueba un filtro diferente o restablece el filtro.",
	"Not avaliable with_": "No disponible con la cámara actual",
	"Overlays a detection_": "Superpone un cuadro de detección en las grabaciones y transmisiones en vivo de la cámara DMS.",
	"A minute of_": "Un minuto de vídeo de la cámara frontal será aproximadamente",
	"System voice guidance": "Guía de voz del sistema",
	"Recording trigger": "Disparador de grabación",
	"Remote Button (Optional)": "Botón remoto (Opcional)",
	"Remote button settings_": "No se pueden cambiar los ajustes de los botones remotos mediante conexión en la nube. Para modificar estos ajustes, navega a Cámara > Conectar Localmente > Configuración de la Cámara.",
	"No Registered Device": "No hay dispositivo registrado",
	"Subscription process is complete": "El proceso de suscripción está completo",
	"Now, go back to_": "Ahora, regresa a la aplicación FLEETA, inicia sesión en tu cuenta y comienza a disfrutar del servicio.",
	"You can check the upload progress": "Puedes verificar el progreso de la carga en la pestaña de Almacenamiento en la nube > FLEETA Drive.",
	"SIM card must be inserted in_": "Se debe insertar la tarjeta SIM en la cámara para comenzar a usar la nube.",
	"Active until:": "Activo hasta:",
	Subscribe: Subscribe$d,
	"Camera PSN": "Cámara PSN",
	"BlackVue Sim Free Trial Started!": "¡Comenzó la prueba gratuita de BlackVue Sim!",
	"Enjoy a free period to use your SIM_": "¡Disfruta de un periodo gratuito para utilizar tu SIM sin suscripción!",
	"You can stay connected during the trial_": "Puedes permanecer conectado durante la prueba, pero recuerda:",
	"Complete your subscription before the trial_": "Completa tu suscripción antes de que finalice la prueba para seguir usando la SIM.",
	"If you don't subscribe by the end of the trial_": "Si no se suscribe al final de la prueba, su servicio SIM se desactivará.",
	"Save Event Videos_": "¡Guarde videos de eventos en el almacenamiento en la nube en tiempo real!",
	"Note: Deleting your account doesn’t cancel": "Nota: Eliminar tu cuenta no cancela tu suscripción. Para cancelar, ve a Cuenta > Suscripción en el visor web de FLEETA.",
	"Available only on FLEETA App for_": "Disponible solo en la aplicación FLEETA para este modelo.",
	"The cloud is deactivated": "La nube está desactivada.",
	"Please add a camera with FLEETA_": "Por favor, añade una cámara con la APP FLEETA para usar esta función.",
	"Upload videos to FLEETA_": "¡Sube videos a FLEETA Almacenamiento y mantenlos seguros!",
	"You have no assigned camera_": "No tienes ninguna cámara asignada.\nPor favor, contacta al propietario para solicitar asignación.",
	"Camera notification settings": "Configuración de notificaciones de cámara",
	Vehicle: Vehicle$d,
	"App Download": "Descarga de la aplicación",
	"Have a problem with_": "¿Tiene un problema con la suscripción?",
	"Restore Purchase": "Restaurar compra",
	"Battery Pairing": "Emparejamiento de batería",
	"Playback\nLive View": "Reproducción/\nVista en vivo",
	"Remote Playback": "Reproducción remota",
	"Cloud connection settings": "Ajustes de conexión a la nube",
	"Go to settings": "Entrar en ajustes",
	"Only cloud cameras that_": "Solo las cámaras en la nube que los usuarios eligen compartir públicamente se muestran en el mapa.",
	"Live Broadcast Cameras": "Cámaras de transmisión en vivo",
	"*Live Broadcast Cameras_": "*Las cámaras de transmisión en vivo son cámaras en la nube configuradas para transmitir por los usuarios.",
	"Only cloud cameras_": "En el mapa solo se muestran las cámaras en la nube que los usuarios eligen transmitir."
};

var Dashboard$c = "Hallintanäkymä";
var Account$c = "Tili";
var Help$c = "Ohje";
var Mac$c = "Mac";
var Windows$c = "Windows";
var Admin$c = "Järjestelmänvalvoja";
var Driver$c = "Ajaja";
var Cameras$c = "Kamerat";
var Manage$c = "Hallinnoi";
var Clear$c = "Asia selvä";
var Show$c = "Näytä";
var GB$c = "{{a}}GB";
var _section$c = "-osiossa.";
var Name$c = "Nimi";
var Password$c = "Salasana";
var Cancel$c = "Peruuta";
var Members$c = "Jäsenet";
var Groups$c = "Ryhmät";
var Role$c = "Rooli";
var Group$c = "Ryhmä";
var Status$c = "Tila";
var nPM$c = "{{a}} ip.";
var nAM$c = "{{a}} ap.";
var Newest$c = "Uusin";
var Oldest$c = "Vanhin";
var Accepted$c = "Hyväksytty";
var Pending$c = "Odottaa";
var Expired$c = "Vanhentunut";
var All$c = "Kaikki";
var Delete_$c = "Poista {{a}}";
var Delete$c = "Poista";
var Rename$c = "Vaihda nimi";
var Add$c = "Lisää";
var OK$c = "OK";
var Remove$c = "Poista";
var Files$c = "Tiedostot";
var Features$c = "Ominaisuudet";
var Settings$c = "Asetukset";
var Upload$c = "upload";
var Privacy$c = "Tietosuoja";
var Done$c = "Valmis";
var Subscription$c = "Tilaus";
var Submasters$c = "järjestelmänvalvojat";
var Users$c = "ajajat";
var Change$c = "Vaihda";
var Method$c = "Tapa";
var Details$c = "Kameran tiedot.";
var Confirm$c = "Vahvista";
var Address$c = "Osoite";
var Country$c = "Maa";
var State$c = "Osavaltio";
var ZIP$c = "Postinumero";
var Pricing$c = "Hinnoittelu";
var Free$c = "Free";
var Smart$c = "Smart";
var Fleet$c = "Fleet";
var Subscrubed$c = "Tilattu";
var January$c = "tammikuu";
var February$c = "Feburary";
var March$c = "maaliskuu";
var April$c = "huhtikuu";
var May$c = "saattaa";
var June$c = "kesäkuu";
var July$c = "heinäkuu";
var August$c = "elokuu";
var September$c = "syyskuu";
var October$c = "lokakuu";
var November$c = "marraskuu";
var December$c = "joulukuu";
var Blackvuecloud_$c = "www.blackvuecloud.com";
var Support$c = "Support";
var Community$c = "Community";
var FAQ$c = "FAQ";
var Developers$c = "Developers";
var Facebook$c = "Facebook";
var Twitter$c = "Twitter";
var Instagram$c = "Instagram";
var Youtube$c = "Youtube";
var Linkedin$c = "Linkedin";
var Downloads$c = "Lataukset";
var Unauthorized$c = "Valtuuttamaton";
var none$c = "Ei mitään";
var Email$c = "Sähköposti";
var Customers$c = "Customers";
var Home$c = "Home";
var Plan$c = "Plan";
var New$c = "New";
var Unsubscribed$c = "Unsubscribed";
var Edit$c = "Edit";
var month$c = "month";
var months$c = "months";
var Continue$c = "Continue";
var Back$c = "Takaisin";
var Master$c = "Owner";
var Develop$c = "Developers";
var $9$c = "$9";
var $15$c = "$15";
var $10$c = "$10";
var mo$c = "Kuukausi";
var City$c = "Kaupunki";
var Charge$c = "Veloitus";
var subscribe$c = "Tilaa";
var search$c = "Haku";
var invalid_number$c = "Kortin numero ei ole kelvollinen luottokortin numero";
var invalid_expiry_month$c = "Kortin vanhentumiskuukausi on virheellinen";
var invalid_expiry_year$c = "Kortin vanhentumisvuosi on virheellinen";
var invalid_cvc$c = "Kortin turvakoodi on virheellinen";
var incorrect_number$c = "Kortin numero on väärä";
var incomplete_number$c = "Kortin numero on puutteellinen";
var incomplete_cvc$c = "Kortin turvakoodi on puutteellinen";
var incomplete_expiry$c = "Kortin vanhentumispäivä on puutteellinen";
var expired_card$c = "Kortti on vanhentunut";
var incorrect_cvc$c = "Kortin turvakoodi on väärä";
var incorrect_zip$c = "Kortin postinumeron vahvistus epäonnistui";
var invalid_expiry_year_past$c = "Kortin viimeinen voimassaolovuosi on mennyt";
var card_declined$c = "Kortti hylättiin";
var missing$c = "Asiakkaalla ei ole korttia, jota veloitetaan";
var processing_error$c = "Kortin käsittelyssä tapahtui virhe";
var Paypal$c = "Paypal";
var iOS$c = "iOS";
var Android$c = "Android";
var Total$c = "Yhteensä";
var And$c = "ja";
var Camera$c = "Camera";
var Yes$c = "Kyllä";
var No$c = "En";
var News$c = "Uutiset";
var Notifications$c = "Ilmoitukset";
var MPH$c = "MPH";
var Firmware$c = "Laiteohjelmisto";
var Basic$c = "Perusasetukset";
var Resolution$c = "Tarkkuus";
var Brightness$c = "Kirkkaus";
var Recording$c = "Tallennus";
var Highest$c = "Paras";
var High$c = "Korkea";
var Normal$c = "Normaali";
var Sensitivity$c = "Herkkyys";
var Volume$c = "Äänenvoimakkuus";
var Close$c = "Close";
var Cloud$c = "Cloud";
var Public$c = "Public";
var Front$c = "Etu";
var Rear$c = "Taka";
var Play$c = "Toista";
var Stop$c = "Pysäytä";
var Pause$c = "Tauko";
var Time$c = "Time";
var System$c = "Järjestelmä";
var Event$c = "Tapahtuma";
var Parking$c = "Pysäköinti";
var Color$c = "Väri";
var Exit$c = "Poistu";
var Save$c = "Tallenna";
var Impact$c = "Isku";
var Unlimited$c = "Rajaton";
var Default$c = "Oletus";
var Version$c = "Versio";
var Language$c = "Kieli";
var Notification$c = "Ilmoitus";
var Multiple$c = "Moni";
var Range$c = "Alue";
var Download$c = "ladata";
var Manual$c = "manuaalinen";
var Satellite$c = "Satelliitti";
var Tutorials$c = "Oppaat";
var Filter$c = "Suodata";
var Sun$c = "Su";
var Mon$c = "Ma";
var Tue$c = "Ti";
var Wed$c = "Ke";
var Thu$c = "To";
var Fri$c = "Pe";
var Sat$c = "La";
var Dates$c = "Päivämäärät";
var Routes$c = "Reitit";
var Opacity$c = "läpinäkymättömyys";
var Entry$c = "MerkintäSaapuminen";
var Owner$c = "Owner";
var Undetected$c = "huomaamaton";
var Distracted$c = "Häiriintynyt";
var Drowsy$c = "Drowsy";
var Calling$c = "Calling";
var Smoking$c = "Smoking";
var Permissions$c = "Käyttöoikeudet";
var Private$c = "Yksityinen";
var Entering$c = "Saapuminen";
var Exiting$c = "Poistuminen";
var Acceleration$c = "Kiihdytys";
var Passing$c = "Ohittaminen";
var Overspeed$c = "Ylinopeus";
var Recipients$c = "Vastaanottajat";
var Send$c = "Lähetä";
var Note$c = "Huomautus";
var Video$c = "Video";
var Advanced$c = "Lisäasetukset";
var Voice$c = "Ääni";
var Days_$c = "Päivät";
var Mute$c = "Mykistä";
var UnMute$c = "Poista mykistys";
var Discard$c = "Hylkää";
var Report$c = "Report";
var Individual$c = "Yksittäinen kuljettaja, joka haluaa mielenrauhan? Yrittäjä, joka tarvitsee helpon ajoneuvojen turvallisuus- ja seurantaratkaisun?";
var Subscribed$c = "Tilattu";
var Geofence$c = "Aluerajaus";
var Driving$c = "Ajaminen";
var Idling$c = "Tyhjäkäynti";
var Distance$c = "Etäisyys";
var Parked$c = "Parked";
var Speed$c = "Nopeus";
var Highest_2$c = "Korkein";
var Average$c = "Keskimääräinen";
var Geofences$c = "Aluerajaukset";
var Move$c = "Siirrä";
var Connected$c = "Yhdistetty";
var Individual_$c = "Yksittäinen";
var Always$c = "Aina";
var Low$c = "Alhainen";
var Medium$c = "Keskitaso";
var High_2$c = "Korkea";
var Flip$c = "Käännä";
var Previous$c = "Edellinen kuva";
var Next$c = "Seuraava";
var Expand$c = "Laajenna";
var Collapse$c = "Kutista";
var More$c = "Enemmän";
var Multi$c = "Moni";
var Safe$c = "Turvallinen";
var Reckless$c = "Holtiton";
var Inattentive$c = "Tarkkaamaton";
var List$c = "Luettelo";
var Usage$c = "Käyttö";
var Profile$c = "Profiili";
var Fullscreen$c = "Koko näyttö";
var Upgrade$c = "Päivitä";
var Management$c = "Hallinta";
var Day$c = "Päivä";
var Month$c = "Kuukausi";
var Later$c = "Myöhemmin";
var ICCID$c = "ICCID";
var Resubscribe$c = "Tilaa uudelleen";
var plan$c = "tilaus";
var USD$c = "USD";
var etc_$c = "jne.:";
var Available$c = "Saatavilla";
var Used$c = "Käytetty";
var Cancelled$c = "Peruutettu";
var Terminated$c = "Päätetty";
var Sort$c = "Lajittele";
var Bonus$c = "Bonus";
var incomplete_zip$c = "Kortin postinumeron vahvistus epäonnistui";
var Upgrades$c = "Päivitykset";
var OR$c = "TAI";
var Undo$c = "Peruuttaa";
var Invoice$c = "Lasku";
var data$c = "Data";
var Popular$c = "Popular";
var Mask$c = "Maski pois";
var DMS$c = "kuljettajan tilan seuranta (DMS)";
var Extreme$c = "Äärimmäinen";
var OFF$c = "Pois päältä";
var Threshold$c = "Raja-arvo";
var Drowsiness$c = "Uneliaisuus";
var Direct$c = "Suora";
var Remote$c = "Etä";
var Update$c = "Päivitä";
var Option$c = "Lisävaruste";
var Required$c = "Pakollinen";
var Optional$c = "Valinnainen";
var Others$c = "Muu";
var Stay$c = "Jää";
var Mask_2$c = "Mask";
var Low_2$c = "Low";
var Medium_2$c = "Medium";
var High_3$c = "High";
var Highest_3$c = "Highest";
var Extreme_2$c = "Extreme";
var Private_2$c = "Private";
var Lite$c = "Lite";
var Bitrate$c = "Bittinopeus";
var hours$c = "Tunnit";
var Expires$c = "Vanhenee";
var Check$c = "Tarkistaa";
var Saving$c = "Tallennetaan";
var Now$c = "Nyt";
var Beep$c = "Varoitusääni";
var Unpair$c = "Irrota";
var Detected$c = "Tunnistettu";
var Promotion$c = "Kampanja";
var Notice$c = "Päivitykset";
var Explore$c = "Tutkia";
var Deactivate$c = "Poista käytöstä";
var Compliance$c = "Säännösten noudattaminen";
var Manufacturing$c = "Valmistus";
var Emergency$c = "Hätätilanne";
var Security$c = "Turvallisuus";
var Important$c = "Tärkeä";
var or$c = "tai";
var Subscribe$c = "Tilaa";
var Vehicle$c = "ajoneuvo";
var fi = {
	Dashboard: Dashboard$c,
	"Payment & Subscriptions": "Maksut ja tilaukset",
	"Fleet Management": "Kaluston hallinta",
	"Available to master": "Saatavilla pääkäyttäjälle",
	"Available to Fleet_": "Saatavilla Fleet Plan -käyttäjille",
	Account: Account$c,
	"Log out": "Kirjaudu ulos",
	"© 2019 Pittasoft_": "© 2019 Pittasoft Co. Ltd",
	"Privacy policy": "Tietosuojakäytäntö",
	"Terms of service": "Käyttöehdot",
	Help: Help$c,
	"App store": "App store",
	"Google Play": "Google Play",
	Mac: Mac$c,
	Windows: Windows$c,
	"Free Plan": "Free Plan",
	"Basic Plan": "Basic Plan",
	"Smart Plan": "Smart Plan",
	Admin: Admin$c,
	Driver: Driver$c,
	"Period : December 3, 2024 ~ May 31, 2025": "Aika: 3. joulukuuta 2024 - 31. toukokuuta 2025",
	Cameras: Cameras$c,
	"n of n": "{{a}}/{{b}}",
	Manage: Manage$c,
	"Upgrade Plan": "Päivitä ohjelma",
	"Add more cameras_": "Lisää kameroita, hallinnoi kalustoa ja muuta…",
	"Usage statistics": "Käyttötilastot",
	"All cameras": "Kaikki kamerat",
	Clear: Clear$c,
	Show: Show$c,
	"Live views": "Live-etäkatselu",
	"nh:nm:ns": "{{a}}h:{{b}}m:{{c}}s",
	"Video plays and_": "Videon toistot ja lataukset",
	"Space available": "Tilaa käytettävissä",
	GB: GB$c,
	"n%": "{{a}}%",
	"BlackVue app for_": "BlackVue-sovellus iOS- ja Android-laitteille",
	"BlackVue viewer for_": "BlackVue Viewer Mac- ja Windows-laitteille",
	"Welcome to fleet": "Tervetuloa Fleet-ohjelmaan",
	"A few things_": "Muutamia asioita, joita on odotettavissa:",
	"You can watch_": "Voit katsella videoita kameroista, jotka sinulle on määritetty BlackVue-sovelluksessa tai Desktop Viewer -ohjelmassa.",
	"If the master_deletes": "Jos pääkäyttäjä poistaa tilinsä, myös sinun tilisi poistetaan.",
	"If the masters_Fleet": "Jos pääkäyttäjän Fleet Plan -tilaus vanhenee, voit silti käyttää tiliäsi vain luku -tilassa.",
	"You have to_": "Sinun on rekisteröitävä toinen tili henkilökohtaisen kameran lisäämiseksi.",
	"The Payments &_": "Maksut ja tilaukset sekä Kaluston hallinta ovat vain pääkäyttäjän käytettävissä.",
	"You can manage_": "Voit hallita kalustoryhmää",
	"_Fleet management": "Kaluston hallinta",
	_section: _section$c,
	"The Payments_section-": "Maksut ja tilaukset -osio on vain pääkäyttäjän käytettävissä.",
	"Youre almost there": "Olet melkein valmis",
	"Finish account setup": "Viimeistele tilin asetukset",
	"Install and log_": "Asenna BlackVue -sovellus tai Desktop Viewer -ohjelma ja kirjaudu sisään",
	"Download on the_": "Lataa App Storesta",
	"GET IT ON_": "HANKI Google Playsta",
	"Download for Mac": "Lataa Mac-laitteeseen",
	"Download for Windows": "Lataa Windows-laitteeseen",
	"Add your camera_": "Lisää kamerasi BlackVue-sovellukseen tai Desktop Viewer -ohjelmaan",
	"Start managing your_": "Aloita kaluston hallinta ja käyttötilastojen seuraaminen tästä",
	"Cancelled Fleet Plan_": "Fleet Plan peruutettu {{date}}",
	"The new plan_": "Uusi jakso tulee voimaan nykyisen laskutusjakson lopussa.",
	"Profile photo": "Profiilikuva",
	Name: Name$c,
	"E-mail address": "Sähköpostiosoite",
	Password: Password$c,
	"Last changed_": "Viimeksi vaihdettu {{a}}",
	"Change password": "Vaihda salasana",
	"Delete account": "Poista tili",
	Cancel: Cancel$c,
	"Current password": "Nykyinen salasana",
	"New password": "Uusi salasana",
	"Confirm new password": "Vahvista uusi salasana",
	"Password changed": "Salasana vaihdettu",
	"Reason for deletion_": "Poistamisen syy (valinnainen)",
	"Account password": "Tilin salasana",
	Members: Members$c,
	Groups: Groups$c,
	"+ Invite member": "+ Kutsu jäsen",
	"Name, Email": "Nimi, sähköposti",
	Role: Role$c,
	Group: Group$c,
	"Date invited": "Kutsumispäivä",
	Status: Status$c,
	"Group n": "Ryhmä {{a}}",
	nPM: nPM$c,
	nAM: nAM$c,
	Newest: Newest$c,
	Oldest: Oldest$c,
	"Name, email or_": "Nimi, sähköposti tai ryhmä",
	Accepted: Accepted$c,
	Pending: Pending$c,
	Expired: Expired$c,
	All: All$c,
	"No results": "Ei tuloksia",
	"Try different keywords": "Kokeile erilaisia hakusanoja",
	"Try changing or_": "Kokeile vaihtaa tai poistaa suodattimia",
	"Remove all filters": "Poista kaikki suodattimet",
	"Invite member": "Kutsu jäsen",
	"Send invite": "Lähetä kutsu",
	"You have reached_": "Olet saavuttanut 10 apupääkäyttäjän rajan. Voit jatkaa käyttäjien kutsumista.",
	Delete_: Delete_$c,
	"Are you sure_delete": "Haluatko varmasti poistaa tämän jäsenen ja hänen tilinsä?",
	Delete: Delete$c,
	Rename: Rename$c,
	"No submaster yet": "Ei vielä apupääkäyttäjää",
	"You can add_": "Voit lisätä 1 apupääkäyttäjän ryhmää kohti",
	"No cameras yet": "Ei vielä kameroita",
	"Add cameras first_": "Lisää kamerat ensin, määritä käyttäjät jälkeenpäin",
	"Name or email": "Nimi tai sähköposti",
	"Add submaster": "Lisää apupääkäyttäjä",
	Add: Add$c,
	"Add camera": "Lisää kamera",
	"n of n selected": "{{a}}/{{b}} valittuna",
	"No cameras available": "Ei kameroita käytettävissä",
	"Most likely reasons_": "Todennäköisimmät syyt:",
	"All cameras were_": "Kaikki kamerat lisättiin muihin ryhmiin.",
	"You can remove_": "Voit poistaa kamerat muista ryhmistä ja lisätä ne tähän ryhmään.",
	"No cameras were_": "Tiliisi ei lisätty kameroita.",
	"You can add_cameras": "Voit lisätä kameroita BlackVue-sovelluksessa tai Desktop Viewer -ohjelmassa.",
	OK: OK$c,
	"Rename group": "Nimeä ryhmä uudelleen",
	"Are you sure_group": "Haluatko varmasti poistaa tämän ryhmän?",
	"Edit Mobile app_": "Muokkaa mobiilisovelluksen / Desktop Viewer -ohjelman käyttöoikeuksia",
	Remove: Remove$c,
	"n of n users": "{{a}}/{{b}} käyttäjää",
	"Youve reached the_": "Olet saavuttanut kamerakohtaisen käyttäjärajan",
	"Remove user": "Poista käyttäjä",
	"Add user": "Lisää käyttäjä",
	"+ Add group": "+ Lisää ryhmä",
	"Add group": "Lisää ryhmä",
	"Group or submaster": "Ryhmä tai apupääkäyttäjä",
	"+ Add": "+ Lisää",
	"of max selected": "{{a}} / enint. {{b}} valittuna",
	"Mobile app/desktop_": "Mobiilisovelluksen / Desktop Viewer -ohjelman käyttöoikeudet",
	Files: Files$c,
	Features: Features$c,
	Settings: Settings$c,
	Upload: Upload$c,
	"Download and Playback_Cloud": "Lataa ja toista pilvitallennustilasta",
	"Download and Playback_SD": "Lataa ja toista SD-kortilta",
	"Live view": "Live View",
	"Geo Fencing": "Aluerajaus",
	"Drive Reports": "Ajoraportit",
	"Firmware Settings": "Laiteohjelmiston asetukset",
	"Push Notifications": "Pikailmoitukset",
	"Event Auto Upload": "Tapahtuman automaattinen live-lataus",
	Privacy: Privacy$c,
	Done: Done$c,
	"Payment method": "Maksutapa",
	"Change payment method": "Muuta maksutapa",
	Subscription: Subscription$c,
	"Space used": "Käytetty tila",
	"Next billing_": "Seuraava laskutus {{a}} {{b}}",
	"You manage_available": "Hallitset {{a}}/{{b}}, jotka ovat käytettävissä ohjelmassa",
	Submasters: Submasters$c,
	Users: Users$c,
	Change: Change$c,
	"No transactions yet_": "Sinulla on Free Plan -tilaus. Ei tapahtumia vielä",
	"No transactions to_": "Ei näytettäviä tapahtumia.<br/>Jos etsit muiden alustojen (esim. IOS, Android, PayPal) tapahtumahistoriaa, löydät historian oman alustasi tilaussivulta.",
	"of nGB_": "{{a}}/{{b}} Gt ({{c}} %)",
	"Smart Plan users_": "Smart Plan -käyttäjät voivat muuttaa tilausohjelmaa tai kameroiden määrää BlackVue-mobiilisovelluksen kautta",
	"Transaction history": "Tapahtumahistoria",
	"Date": "Päivämäärä",
	"Amount, USD": "Määrä, USD",
	Method: Method$c,
	Details: Details$c,
	"iOS in-app_": "iOS in-app purchase/Android in-app purchase",
	"Change the number_": "Muuta numeroiden määrä",
	"You manage_cameras": "You manage {{a}} cameras of {{b}} available on your plan",
	"Extra cameras": "Lisäkamerat",
	"Total due_": "Maksettava yhteensä",
	"available on your_": "{{a}} ohjelmassa käytettävissä olevasta",
	"Cancel Fleet Plan": "Peruuta Fleet Plan",
	"This will cancel_": "Tämä peruuttaa Fleet Plan -tilauksesi. Siirryt Free Plan -ohjelmaan laskutusjakson lopussa.",
	"Reason for cancellation_": "Peruuttamisen syy (valinnainen)",
	"Not now": "Ei nyt",
	Confirm: Confirm$c,
	"Cardholder name": "Kortinhaltijan nimi",
	"Card name": "Kortin nimi",
	"MM/YY": "KK/VV",
	Address: Address$c,
	Country: Country$c,
	State: State$c,
	ZIP: ZIP$c,
	Pricing: Pricing$c,
	"You are subscribed_": "Sinulla on Free Plan -tilaus.",
	"With Alert Push_": "Sisältää hälytysten push-ilmoitukset, rajoitetun live-etänäkymän ja pilvitallennustilan.",
	Free: Free$c,
	Smart: Smart$c,
	Fleet: Fleet$c,
	"Get started for_": "Aloita ilmaiseksi, luottokorttia ei vaadita. \n Sisältää hälytysten push-ilmoitukset, rajoitetun live-etänäkymän ja pilvitallennustilan.",
	Subscrubed: Subscrubed$c,
	"Features included:": "Sisältyvät ominaisuudet:",
	"Get unlimited Remote_": "Saat rajattoman live-etänäkymän, pilvitoiston ja enintään {{a}} kameran hallinnan.",
	"BlackVue Fleet Tracking_": "BlackVue-kalustonseurannan ainutlaatuiset ominaisuudet tehokäyttäjille ja yrityksille (useita käyttäjiä ja kameroita, aluerajaus jne.)",
	"Try 1 Month Free": "Kokeile yksi kuukausi ilmaiseksi",
	"Log in": "Kirjaudu sisään",
	"Remember me": "Muista minut",
	"Forgot password?": "Unohditko salasanan?",
	"Reset password": "Salasanan palautus",
	"Enter email address_": "Anna rekisteröinnin yhteydessä käyttämäsi sähköpostiosoite, \n niin lähetämme sinulle linkin salasanan vaihtamiseksi.",
	"Send reset password_": "Lähetä salasanan palautusviesti",
	"Back to login": "Takaisin kirjautumiseen",
	"Check your email": "Tarkista sähköpostisi",
	"Weve sent an_": "Olemme lähettäneet viestin osoitteeseen {{a}}, jossa on linkki\n sähköpostiosoitteen vahvistamiseen.",
	"Resend email": "Lähetä sähköposti uudelleen",
	January: January$c,
	February: February$c,
	March: March$c,
	April: April$c,
	May: May$c,
	June: June$c,
	July: July$c,
	August: August$c,
	September: September$c,
	October: October$c,
	November: November$c,
	December: December$c,
	"Sign up": "Luo tili",
	"First name": "Etunimi",
	"Last name": "Sukunimi",
	"Create a password": "Luo salasana",
	"5 or more_": "Vähintään 5 merkkiä",
	"Sign up and_": "Rekisteröidy ja jatka",
	"I agree to_": "Hyväksyn seuraavat: %@, %@, %@ ja %@.",
	"Subscribe to newsletter": "Tilaa uutiskirje",
	"1 month free trial_": "1 kuukauden ilmainen kokeilu",
	"Dont have an_": "Eikö sinulla ole tiliä?",
	"Thank you for_": "Kiitos, että rekisteröidyit BlackVue Cloud -palveluun. Vahvista sähköpostiosoitteesi.",
	"Confirm email": "Vahvista sähköposti",
	"If you didnt_": "Jos et ole rekisteröitynyt tälle tilille, voit ohittaa tämän sähköpostiviestin.",
	Blackvuecloud_: Blackvuecloud_$c,
	"invited you to_": "{{a}} kutsui sinut kalustonsa apupääkäyttäjäksi.",
	"Accept invitation": "Hyväksy kutsu",
	"Invite expires on_": "Kutsu vanhenee kk pp, vv.",
	"Your Fleet Management_": "%@ poisti kaluston hallintatilisi, joka oli rekisteröity menetelmällä {{a}}.",
	"If you believe_": "Jos uskot, että kyseessä on virhe, ota yhteyttä asiakaspalveluumme: cs@blackvue.com.",
	Support: Support$c,
	"Help center": "Ohjekeskus",
	Community: Community$c,
	"Getting started": "Aloitusopas",
	FAQ: FAQ$c,
	Developers: Developers$c,
	"Cloud API": "Cloud API",
	"Fleet SDK": "Fleet SDK",
	"Follow us": "Follow us",
	Facebook: Facebook$c,
	Twitter: Twitter$c,
	Instagram: Instagram$c,
	Youtube: Youtube$c,
	Linkedin: Linkedin$c,
	"BlackVue apps": "BlackVue apps",
	"Camera registraiton": "Kameran rekisteröinti",
	"Two-way voice_": "Kaksisuuntainen ääniviestintä",
	"Live GPS": "Live-GPS",
	"Event live auto_": "Tapahtuman automaattinen live-lataus",
	"Event file auto_": "Tapahtumatiedoston automaattinen lataus",
	"Compatible with_": "Yhteensopiva mallien DR650GW ja DR650S kanssa",
	"Not compatible with_": "Ei yhteensopiva mallien DR650GW ja DR650S kanssa",
	"More cameras": "Useampia kameroita",
	"More users": "More users",
	"Roles and permissions": "Roles and permissions",
	"More Cloud Storage": "Enemmän pilvitallennustilaa",
	"Multi Live view_": "Multi Live View (Web)",
	"Longer GPS Tracking": "Longer GPS Tracking",
	"Geo Fence setup_": "Geo Fence setup (PC viewer) and alerts (PC viewer and app)",
	"Changes saved": "Muutokset tallennettu",
	"Group added": "Ryhmä lisätty",
	"Member added": "Jäsen lisätty",
	"Group deleted": "Ryhmä poistettu",
	"Member deleted": "Jäsen poistettu",
	"Group renamed": "Ryhmä nimetty uudelleen",
	"Submaster added": "Apupääkäyttäjä lisätty",
	"Camera added": "Kamera lisätty",
	"User added": "Käyttäjä lisätty",
	"Users added": "Käyttäjät lisätty",
	Downloads: Downloads$c,
	"The BlackVue App_": "The BlackVue App and Viewer let you use your BlackVue camera to its full potential. Whether on mobile or on home computer, BlackVue gives you the tools to fully enjoy your dashcam's functions.",
	"Compatible with all_": "Compatible with all Wi-Fi enabled BlackVue models.",
	"Supports all BlackVue_": "Supports all BlackVue models to date.",
	"confirm new password": "Vahvista uusi salasana",
	"Your password is_": "Antamasi salasana on väärä",
	"Confirm password does_": "Salasana ei täsmää",
	"Please enter_email": "Kirjoita kelvollinen sähköpostiosoite.",
	"Please enter_password": "Antamasi salasana on väärä",
	"Internal server error_": "Sisäinen palvelinvirhe. Yritä uudelleen.",
	"New password is_": "Vähintään 1 merkin pitää olla erilainen nykyisessä salasanassa",
	"It should be_": "Salasanassa on oltava vähintään 5 merkkiä",
	"Invalid permission": "Virheellinen käyttöoikeus.",
	"Input data isnt_": "Syöttötiedot eivät ole käytettävissä.",
	Unauthorized: Unauthorized$c,
	"Already have subsciption": "Tilaus on jo olemassa",
	"Already uses": "Käyttää jo",
	"Already logged in": "On kirjautunut jo",
	"Already sent e-mail": "Sähköposti on jo lähetetty.",
	"Please wait": "Odota.",
	"E-mail is not_": "Sähköpostia ei ole vielä vahvistettu.",
	"Update your subscription_": "Päivitä tilauksesi",
	"Account was deleted": "Tili poistettiin.",
	"5 ~ 30_": "5 ~ 30 characters",
	"It has exceeded_": "Se on ylittänyt 9 järjestelmänvalvojan ylärajan.",
	"Billing information": "Laskutustiedot",
	"Please enter cardName": "Anna kortin nimi",
	"Please enter_card": "Anna kelvollinen kortin numero",
	"Please enter address": "Anna osoite",
	"Please select country": "Valitse maa",
	"Please enter city": "Anna kaupunki",
	none: none$c,
	"Due today": "Eräpäivä",
	"Today after 1_": "Tänään 1 kuukauden kokeilun jälkeen",
	"An error occurred_": "Virhe yritettäessä vaihtaa salasanaa. Yritä uudelleen.",
	"Your account is_": "Tilisi on nyt aktiivinen",
	"You can now_": "Voit nyt kirjautua tilillesi rekisteröinnin aikana käyttämälläsi sähköpostiosoitteella.",
	Email: Email$c,
	"Don’t have an account?": "Eikö sinulla ole tiliä?",
	"Already have an account?": "Onko sinulla jo tili?",
	"Cloud service": "Cloud service",
	"for your BlackVue": "for your BlackVue",
	"See what your_": "See what your camera sees remotely.",
	"Receive impact alert_": "Receive Impact alert push notifications.",
	"Save footage to_": "Save footage to the cloud and do much more...",
	"Free plan included_": "Free plan included · Easy setup · Cancel anytime",
	"Taking advantage of_": "Taking advantage of a mobile or car-embedded Internet connection and a BlackVue camera, BlackVue Cloud connects you to your car from anywhere, anytime. Using the BlackVue App on your smartphone or tablet, you see in real time where your car is located and what is happening around it.",
	"Get notifications to_": "Get notifications to your phone when your parked car is hit. Check remotely what is happening around your car.",
	"Monitor your commercial_": "Monitor your commercial vehicles on a map in real time. Talk to your drivers anytime through the BlackVue App or Viewer.",
	"With BlackVue Fleet_": "With BlackVue Fleet Tracking, track in real time up to 100 vehicles from the palm of your hand or with the dedicated BlackVue Viewer.",
	"Get started now_": "Get started now with a Free plan. For unlimited video playback or Remote Live View, upgrade to Lite or Smart plan from the BlackVue App. <br/>Business and power users can unlock the power of the Fleet plan exclusively through this website.",
	"Remote Video Playback_": "Remote Video Playback and Download",
	"Compatible with DR650GW_": "Compatible with DR650GW, DR650S models",
	"Unlimited remote video_": "Unlimited remote video playback and download",
	"Longer cloud storage_": "Longer cloud storage file expiration period",
	"Longer storage period_live": "Longer storage period for Event live auto upload",
	"Longer storage period_file": "Longer storage period for Event file auto upload",
	"Goefence setup (PC_": "Geo-fence setup (PC viewer) and alerts (Windows viewer and app)",
	"App Store": "App Store",
	"Send reset password email": "Lähetä salasanan palautusviesti",
	Customers: Customers$c,
	Home: Home$c,
	"Pick a plan": "Pick a plan",
	"No customers yet": "No customers yet",
	"Customers will_": "Customers will show up here as they become available",
	"Add customer": "Add customer",
	"Report(PDF)": "Report(PDF)",
	"Subscription Period": "Subscription Period",
	Plan: Plan$c,
	New: New$c,
	Unsubscribed: Unsubscribed$c,
	"Subscription ends soon": "Subscription ends soon",
	Edit: Edit$c,
	"1 month trial": "1 month trial",
	"Edit customer details": "Edit customer details",
	"Customer name": "Customer name",
	"of 999 available_": "of 999 available on Fleet Plan",
	"Subscription starts": "Subscription starts",
	"Subscription period": "Subscription period",
	month: month$c,
	months: months$c,
	"Cloud storage": "Cloud Storage",
	"Subscription plan": "Tilauksen tyyppi",
	"Check email address": "Check email address",
	"Add customer details": "Add customer details",
	Continue: Continue$c,
	Back: Back$c,
	"An error occured": "An error occured",
	"Customer added": "Customer added",
	"Last changed": "Last changed",
	"Company name": "Company name",
	"Company address": "Company address",
	"Alert Push Notifications": "Alert Push Notifications",
	"Receive notifications on_": "Receive notifications on your phone when preset Events occur. Great in combination with BlackVue’s Parking Mode.",
	"Remote Live View": "Etä Live View",
	"Remotely monitor your_": "Remotely monitor your car in real time from anywhere, anytime.",
	"Video Backup/Auto Upload": "Video Backup/Auto Upload",
	"Back up videos_": "Back up videos to your phone or Cloud storage.",
	"Two-way Voice Communication": "Two-way Voice Communication",
	"Talk with people_": "Talk with people in the car from your smartphone. The driver can speak while keeping hands on the wheel.",
	"View your car’s_": "View your car’s location and speed on a map. With BlackVue Fleet Tracking, access 90-days’ worth of GPS data.",
	"Remote Video Playback": "Remote Video Playback",
	"Play videos stored_": "Play videos stored in the Cloud or in your dashcam anytime on your smartphone or tablet.",
	"Event Live Auto Upload": "Event Live Auto Upload",
	"Save a video stream_": "Save a video stream in real time to the Cloud. Protect yourself from break-ins and theft.",
	"Event File Auto Upload": "Event File Auto Upload",
	"Save Event videos_": "Save Event videos to the Cloud—including seconds before trigger—after they happen.",
	"Firmware-Over-the-Air (FOTA)": "Firmware-Over-the-Air (FOTA)",
	"Upgrade your dashcam’s": "Update your dashcam over the cloud",
	"When an Event_": "When an Event is created (Impact detected or manually triggered), Event Live Auto-upload lets your Cloud-compatible BlackVue save a live video stream from a camera of your choice (front or rear/interior) to the Cloud server",
	"Event File Auto-upload_": "Event File Auto-upload lets your dashcam automatically upload low-resolution versions of Event files to the Cloud.",
	Master: Master$c,
	"per Camera": "per Camera",
	"Event live auto upload_": "Event live auto upload compatible with all cloud cameras",
	"Drive report": "Drive report",
	"USA/Canada Toll Free": "USA/Canada Toll Free",
	"Monday–Saturday_": "Monday to Friday 8am-7pm / Saturday 9am-6pm (PST).",
	"Please agree to_": "You must accept Terms of Service",
	"Mac or Windows PC": "Mac or Windows PC",
	Develop: Develop$c,
	"Sign out": "Sign out",
	"Referral code": "Viitekoodi",
	"Total after 1 month trial": "Yhteensä 1 kuukauden kokeilun jälkeen",
	"Already Use Stripe Token": "Käyttää jo Stripe-tunnistetta",
	"Select period": "Valitse ajanjakso",
	"State/Region": "Maa/alue (valinnainen)",
	"ZIP/Postal": "Postinumero",
	"$0.00": "$0.00",
	"$11.99": "$11.99",
	"$24.99": "$24.99",
	$9: $9$c,
	$15: $15$c,
	$10: $10$c,
	"mo + for_": "/mo + {{a}} per extra camera",
	mo: mo$c,
	"This e-mail address_": "Tämä sähköpostiosoite on jo käytössä rekisteröidyllä tilillä.",
	"1 month": "1 kuukausi",
	"Limit is reset daily": "Raja nollataan päivittäin",
	"Limit is reset monthly": "Raja nollataan kuukausittain",
	"Video plays and downloads": "Videon toistot ja lataukset",
	"Your master": "Your owner",
	"Youre 1 step_": "Olet 1 askeleen päässä Fleet Plan -tilauksen viimeistelystä",
	"Finish signing up": "Viimeistele rekisteröityminen",
	"Enter billing information": "Anna laskutustiedot",
	"Proceed to billing": "Jatka laskutukseen",
	City: City$c,
	Charge: Charge$c,
	"User already invited_": "Pääkäyttäjä on jo kutsunut käyttäjän",
	"n% consumed": "{{a}}% käytetty",
	"E-mail already exists": "Sähköposti on jo olemassa",
	"Cancel your inapp_": "Peruuta sovelluksen sisäinen tilauksesi",
	"You have cancel_": "Sinun on peruutettava sovelluksen sisäinen tilauksesi päivittääksesi Fleet Plan -ohjelmaan: 1. Peruuta nykyinen tilauksesi App Storessa tai Google Play -kaupassa. Siirryt Free Plan -ohjelmaan nykyisen laskutusjakson lopussa. Kaikki tietosi pysyvät ennallaan. 2. Kirjaudu sisään blackvuecloud.com-tilille ja päivitä Fleet Plan -tilaukseen.",
	"Edit permissions": "Muokkaa käyttöoikeuksia",
	"See permissions": "Katso käyttöoikeudet",
	"Submaster removed": "Apupääkäyttäjä poistettu",
	"Camera removed": "Kamera poistettu",
	"User removed": "Käyttäjä poistettu",
	"Users removed": "Käyttäjät poistettu",
	subscribe: subscribe$c,
	search: search$c,
	"permission can be_": "Käyttöoikeus voidaan määrittää sen jälkeen, kun apupääkäyttäjä on hyväksynyt kutsun.",
	"The confirmation link_": "Vahvistuslinkki ei ole enää voimassa",
	"Possible reasons:_": "Mahdolliset syyt:\n • Olet jo vahvistanut sähköpostiosoitteesi\n • Linkki on vanhentunut tai se on peruutettu",
	"Failed to register_": "Rekisteröityminen BlackVue Cloud -palveluun epäonnistui",
	"There was an_": "Virhe rekisteröitymisprosessin aikana. Jos ongelma toistuu, yritä rekisteröityä BlackVue Cloud -palveluun uudelleen. Jos tarvitset lisäapua, ota yhteyttä asiakastukeemme:",
	"Upgrade to Fleet_": "Päivitä Fleet Plan -ohjelmaan",
	"Subscription is Canceled": "Tilaus on peruutettu",
	"No members yet": "Ei vielä jäseniä",
	"Please enter_group name": "Anna kelvollinen ryhmän nimi",
	"Group Name": "Ryhmän nimi",
	invalid_number: invalid_number$c,
	invalid_expiry_month: invalid_expiry_month$c,
	invalid_expiry_year: invalid_expiry_year$c,
	invalid_cvc: invalid_cvc$c,
	incorrect_number: incorrect_number$c,
	incomplete_number: incomplete_number$c,
	incomplete_cvc: incomplete_cvc$c,
	incomplete_expiry: incomplete_expiry$c,
	expired_card: expired_card$c,
	incorrect_cvc: incorrect_cvc$c,
	incorrect_zip: incorrect_zip$c,
	invalid_expiry_year_past: invalid_expiry_year_past$c,
	card_declined: card_declined$c,
	missing: missing$c,
	processing_error: processing_error$c,
	"no groups yet": "Ei vielä ryhmiä",
	"groups will show_": "Ryhmät näkyvät täällä, kun ne tulevat saataville",
	"Fleet members will_": "Fleet-ohjelman jäsenet näkyvät täällä, kun ne tulevat saataville",
	"service provider": "Palveluntarjoaja",
	Paypal: Paypal$c,
	iOS: iOS$c,
	Android: Android$c,
	"Enter email": "Please enter a email address",
	"Enter password": "Syötä salasana.",
	"Enter first name": "Anna etunimi",
	"Enter last name": "Anna sukunimi",
	"Enter the current_": "Anna nykyinen salasana",
	"Enter a new_": "Anna uusi salasana",
	"There isnt an_": "Tähän sähköpostiosoitteeseen ei ole liitetty tiliä",
	"Fleet Plan": "Fleet Plan",
	Total: Total$c,
	"Password you entered_": "Antamasi salasana on väärä",
	"Incorrect email or_": "Väärä sähköpostiosoite tai salasana",
	"Available to Masters": "Saatavilla omistajalle",
	"Blackvue url": "https://www.blackvue.com",
	"Information We Collect_": "Keräämämme tiedot ja keräämisen syyt",
	And: And$c,
	"Terms of Location-Based_": "Sijaintiin perustuvan palvelun käyttöehdot.",
	"I agree to the_": "Hyväksyn",
	"Password Reset_": "Olemme lähettäneet sähköpostiosoitteeseen {{a}} salasanan \n vaihtamisohjeet.",
	"You have already_": "Sinut on jo kutsuttu, tarkista sähköpostisi.",
	"No data available_": "Taulukossa ei ole tietoja",
	Camera: Camera$c,
	"You no longer_": "Sinulla ei ole enää lupaa käyttää kalustopalvelua.",
	"Please contact your_": "Ota yhteyttä Fleet-pääkäyttäjään ongelman ratkaisemiseksi.",
	"You can still_": "Pääset kuitenkin",
	"account information": "tilitietoihisi.",
	"If the issue_": "Jos ongelmaa ei ole ratkaistu ja päätät jatkaa BlackVue Cloud -palvelun käyttöä rekisteröidyllä sähköpostiosoitteella, sinun on poistettava tilisi ja kirjauduttava uudelleen.",
	"If the problem_": "Jos ongelma ei poistu, ota yhteyttä asiakastukeen:",
	"Web subscription only": "Vain verkkotilaus",
	"AppStore url": "https://apps.apple.com/kr",
	"We no longer_": "Emme enää käsittele maksuja PayPalin kautta. Sinun on päivitettävä tilauksesi muuttaaksesi kameroiden määrää: 1. Kirjaudu sisään paypal.com-tilillesi ja peruuta nykyinen Fleet Plan -tilauksesi muuttaaksesi kameroiden määrää: 2. Kirjaudu sisään blackvuecloud.com-tilille ja päivitä Fleet Plan -tilaukseen.",
	Yes: Yes$c,
	No: No$c,
	"Serial number": "Sarjanumero",
	"Cloud code": "Pilvikoodi",
	"Terms & Policies": "Ehdot ja käytännöt",
	News: News$c,
	Notifications: Notifications$c,
	"km/h": "km/h",
	MPH: MPH$c,
	"Baidu Maps": "Baidu Maps (vain Kiina)",
	"Google Maps": "Google Maps",
	Firmware: Firmware$c,
	Basic: Basic$c,
	"Time Zone": "Aikavyöhyke",
	Resolution: Resolution$c,
	"Image quality": "Kuvanlaatu",
	Brightness: Brightness$c,
	Recording: Recording$c,
	"Normal recording": "Normaali tallennus",
	"Voice recording": "Äänitallennus",
	"Video segment length": "Videosegmentin pituus",
	"Rear camera recording": "Takakameran tallennus",
	Highest: Highest$c,
	High: High$c,
	Normal: Normal$c,
	"1 min": "1 min",
	"2 min": "2 min",
	"3 min": "3 min",
	Sensitivity: Sensitivity$c,
	"Motion detection": "Liikkeentunnistus",
	"Speed alert": "Nopeusvaroitus",
	"Voice guidance": "Ääniopastus",
	"Power on": "Virran kytkeminen päälle",
	"Power off": "Virran kytkeminen pois päältä",
	"Starting normal recording": "Normaalin tallennuksen aloittaminen",
	"Changing recording mode": "Tallennustilan vaihtuminen",
	"Speed alert (beep)": "Nopeusvaroitus (merkkiääni)",
	"Cloud related": "Pilvipalveluun liittyvät toiminnot",
	Volume: Volume$c,
	"User text overlay": "Käyttäjän näyttöteksti",
	"A-Z, a-z_": "A–Z, a–z, 0–9, :;’/\\+-_()$#\nalle 20 merkkiä.",
	"Wi-Fi auto turn off": "Wi-Fi-yhteyden automaattinen sammutus",
	"Login credentials": "Kirjautumistiedot",
	"Manual recording": "Manuaalinen tallennus",
	"By sharing your_": "Live-katselun avulla voit jakaa ajokokemuksesi muiden kaikkialla maailmassa olevien käyttäjien kanssa.",
	"However, as persona_": "Koska jakamisen yhteydessä saatetaan lähettää henkilökohtaisia tietoja, sinun tulee päättää erityisen huolellisesti, mitä tietoja haluat jakaa.",
	"Please enter_email_2": "Ole hyvä ja syötä toimiva sähköpostiosoite. Sähköposti, jossa on joitain erikoismerkkejä, ei välttämättä ole sallittua. ex) +, &",
	"Password is incorrect": "Salasana on väärä.",
	"This camera is already_": "Tämä kamera on jo rekisteröity BlackVue-tilille.",
	"Camera name must_": "Kameran nimessä on oltava 5–32 merkkiä.",
	"Failed to save_": "Kamera-asetusten tallennus epäonnistui.",
	"Unallowed character detected": "Ei sallittu merkki havaittu.",
	"File(s) queued for_": "Pilvipalveluun latausta jonottavat tiedostot.",
	"Exceeded video play_": "Videon toisto- ja latausraja ylitetty.",
	"Playback Failed": "Toisto epäonnistui.",
	"Exceeded your Live_": "Live-katselun aikaraja ylitetty.",
	"The camera is not_": "Kameraa ei ole yhdistetty palvelimeen.",
	"Please check the connection_": "Tarkista valitun kameran yhteyden tila.",
	Close: Close$c,
	"Map": "Kartta",
	Cloud: Cloud$c,
	Public: Public$c,
	"Flip horizontally": "Käännä vaakasuunnassa",
	Front: Front$c,
	Rear: Rear$c,
	Play: Play$c,
	Stop: Stop$c,
	Pause: Pause$c,
	"Next frame": "Seuraava kuva",
	"Previous frame": "Edellinen kuva",
	"Proximity sensor": "Läheisyysanturi",
	"Voice recording on/off": "Äänen tallennus päälle/pois",
	"The BlackVue dashcam_": "BlackVue-autokamera ei ole yhteensopiva 5 GHz:n langattomien verkkojen kanssa.",
	Time: Time$c,
	"Daylight saving time": "Kesäaika",
	System: System$c,
	"Incorrect camera serial_": "Virheellinen kameran sarjanumero.",
	"Lock event files": "Lukitse tapahtumatiedostot",
	"Overwrite locked event_": "Korvaa lukitut tapahtumatiedostot, kun tallennustila on täynnä",
	"Camera settings saved_": "Kamera-asetukset on tallennettu onnistuneesti.",
	"Front camera": "Etukamera",
	"Rear camera": "Takakamera",
	Event: Event$c,
	Parking: Parking$c,
	"GPS tracking": "GPS-seuranta",
	"G-force detected": "G-voima havaittu",
	"Impact detected in_": "Isku havaittu pysäköintitilassa",
	"Scheduled reboot": "Ajastettu uudelleenkäynnistys",
	"Recording status": "Tallennustila",
	"Rear security": "Takaosan turvallisuus",
	"Time lapse": "Intervallikuvaus",
	"Sync with GPS_": "Synkronointi GPS-ajan kanssa",
	"Overwrite locked event3_": "Korvaa lukitut tiedostot uusilla tapahtumatiedostoilla, kun tallennustila on täynnä",
	"Video codec": "Videokoodekki",
	"Tracking logs": "Seurantalokit",
	"Geofence alerts": "Paikannusrajan hälytys",
	Color: Color$c,
	Exit: Exit$c,
	Save: Save$c,
	Impact: Impact$c,
	Unlimited: Unlimited$c,
	"Parking mode recording": "Pysäköintitilan tallennus",
	"Battery protection": "Akun suojaus",
	"Cut-off timer": "Katkaisuajastin",
	"Low voltage cut-off": "Alhaisen jännitteen katkaisu",
	"Rear camera orientation": "Takakameran suunta",
	Default: Default$c,
	"Rotate video 180°": "Kierrä videota 180°",
	"Mirror video": "Peilaa video",
	"Wi-Fi band": "Wi-Fi-kaista",
	"Driving report": "Ajoraportti",
	"Unsupported video codec_": "Ei tuettu videokoodekki (H.265).",
	"Rear camera recording_": "Takakamera tallentaa pysäköintitilassa",
	"Front and rear_": "Etu- ja takakamera tallentavat yhdessä",
	"Rear camera stops_": "Takakamera lopettaa tallentamisen 5 minuutin kuluttua pysäköintitilaan siirtymisestä. Tallennus alkaa, kun siirrytään normaalitilaan.",
	"Remote firmware update": "Laiteohjelmiston etäpäivitys",
	"Firmware is up-to-date": "Laiteohjelmisto on ajan tasalla",
	"New firmware available": "Uusi laiteohjelmisto saatavilla.",
	Version: Version$c,
	"Release date": "Julkaisupäivämäärä",
	Language: Language$c,
	"File size": "Tiedostokoko",
	"What’s new": "Uudet ominaisuudet",
	"Updating may take_": "Päivitys saattaa kestää useita minuutteja.",
	"The update process_": "Päivitysprosessia ei voi peruuttaa.",
	"Do not disconnect the_": "Älä irrota virtajohtoa ennen kuin normaali tallennus käynnistyy uudelleen.",
	"Downloading firmware": "Ladataan laiteohjelmistoa",
	"Once download is_": "Kun lataus on valmis, BlackVue käynnistyy automaattisesti uudelleen, jotta uusi laiteohjelmisto otetaan käyttöön.",
	"If not allowed_": "Jos tätä ei sallita, ajoneuvosi sijainti ja nopeus eivät ole käytettävissä pilvipalvelun kautta.",
	"Unable to initiate update because_": "Päivityksen aloittaminen epäonnistui, koska autokameraa ei ole yhdistetty laitteeseen suoran Wi-Fi-yhteyden kautta.",
	Notification: Notification$c,
	Multiple: Multiple$c,
	Range: Range$c,
	"HDR night vision": "HDR-yökuvaus",
	Download: Download$c,
	"G-sensor": "G-Sensor",
	Manual: Manual$c,
	"Low voltage warning": "Varoitus matalajännitteestä",
	Satellite: Satellite$c,
	"Data usage": "Datankäyttö",
	"Select video download quality": "Valitse videon latauslaatu",
	"Quick play file_": "Pikatoistotiedosto (matala resoluutio)",
	"Original file": "Alkuperäinen tiedosto",
	"You do not have permission_": "Sinulla ei ole lupaa tämän toiminnon suorittamiseen. Ota yhteyttä päätilin omistajaan.",
	"Interior camera recording_": "Sisäkameran tallennus pysäköintitilassa",
	"Interior security": "Sisätilan suojaus",
	"Interior camera rotation": "Sisätilan kameran kierto",
	"Multi View": "Moninäkymä",
	Tutorials: Tutorials$c,
	"Upgrade now": "Päivitä nyt",
	"Members will show_": "Jäsenet näkyvät täällä, kun ne tulevat saataville",
	"Are you sure_delete members": "Haluatko varmasti poistaa jäsenet pysyvästi?",
	"Some members may_": "Jotkut jäsenet voivat olla piilotettuja käytettyjen suodattimien takia.",
	"Invited on_": "olet kutsunut {{Invited Date}}. Omistaja",
	Filter: Filter$c,
	"Date created": "Luomispäivämäärä",
	"No admin yet": "Ei vielä järjestelmänvalvojaa",
	"You can add_admin": "Voit lisätä 1 järjestelmänvalvojan ryhmää kohti",
	"Collapse all": "Tiivistä kaikki",
	"Expand all": "Laajenna kaikki",
	"Download and playback_cloud": "Lataa ja toista pilvitallennustilasta",
	"Are you sure_2": "Haluatko varmasti poistaa ryhmän {Group name}?",
	"Are you sure_groups": "Haluatko varmasti poistaa ryhmät?",
	"Add cameras first_drivers": "Lisää kamerat ensin, määritä ajajat jälkeenpäin",
	"Flip vertically": "Käännä pystysuunnassa",
	Sun: Sun$c,
	Mon: Mon$c,
	Tue: Tue$c,
	Wed: Wed$c,
	Thu: Thu$c,
	Fri: Fri$c,
	Sat: Sat$c,
	Dates: Dates$c,
	Routes: Routes$c,
	Opacity: Opacity$c,
	"Color and opacity": "väri ja läpinäkymättömyys",
	"Geofences will show_": "aluerajaukset näkyvät täällä, kun ne tulevat saataville",
	"Start drawing a shape_": "aloita kuvion piirtäminen karttaan",
	"Add geofence": "Lisää aluerajaus",
	Entry: Entry$c,
	"Show all members": "Näytä kaikki jäsenet",
	"Me and my_": "Minä ja autoni. Yhdistetty",
	"add-on service for_": "lisäpalvelu pilviyhteensopivalle Blackvue-ohjelmalle",
	"Continue with Google": "Jatka Googlella",
	"An account with_": "Tällä sähköpostiosoitteella on jo tili, mutta sitä ei ole vahvistettu. Anna nykyinen BlackVue Cloud -salasanasi kirjautumisessa.",
	"Account does not_": "Tiliä ei ole olemassa. Tai yritä kirjautua sisään Apple- tai Google-tililläsi.",
	"Continue with Apple": "Jatka Applella",
	"Get started": "Aloitusopas",
	"P subscription only": "Vain tilaus <b>{{a}}</b>",
	"+N USD for extra camera_": "+{{a}} USD for extra camera up to {{b}} Cameras",
	"Unlimited Live view": "Unlimited Live View",
	"Cameras per Account": "Cameras per Account",
	"Users per Account": "Users per Account",
	Owner: Owner$c,
	"Live View per Day": "Live View per Day",
	"Remote Video Playback_2": "Remote Video Playback and Download per Month",
	"N days": "{{a}} Days",
	"Video On Map": "Video On Map",
	Undetected: Undetected$c,
	Distracted: Distracted$c,
	Drowsy: Drowsy$c,
	"Whether on mobile_": "Whether on mobile or your computer, BlackVue gives you the tools to fully enjoy your dashcam’s functions. Download the latest <a1>firmware</a1>, <a2>mobile</a2> and <a3>desktop</a3> applications, or use <a4>BlackVue web app</a4> in your browser.",
	"Compatible with most_": "Compatible with most Wi-Fi BlackVue models. Cloud support for all Cloud-compatible dashcam models down to DR650GW Series with <b>Cloud Firmware</b>.",
	"Supports most recent BlackVue_": "Supports most recent BlackVue models and compatible with BlackVue Cloud.<br/>\nThis Viewer contains <b>two applications in one</b>: the SD Card Viewer lets you view recorded videos from your SD card and modify the settings of your BlackVue, as well as format the SD card; the <b>Cloud Viewer</b> lets you enjoy BlackVue Cloud.",
	"Contact us": "Contact us",
	"6 characters with": "6 merkkiä, joka on yhdistelmä kirjaimia, numeroita ja erikoismerkkejä",
	"Apps and more...": "Apps and more...",
	"Cameras will show_": "Cameras will show up here as they become available.",
	"Keep this page_": "Pidä tämä sivu avoinna tarkistaessasi vahvistuskoodia. Tarkista roskapostikansio, jos et löydä sähköpostia postilaatikostasi.",
	"n cameras": "{{n}} kameraa",
	"n slots": "{{n}} paikkaa",
	"Calculate your Fleet_": "Laske Fleet Plan -hinta",
	"Code you entered_": "Antamasi koodi on väärä/vanhentunut",
	Calling: Calling$c,
	Smoking: Smoking$c,
	"Smoking has been_": "Tupakointia on havaittu ajon aikana.",
	"Email is already_": "Sähköpostiosoite on jo olemassa.",
	"Serial number and_": "Sarjanumero ja pilvikoodi on painettu kameraan",
	"Allow GPS access": "Salli GPS-yhteys",
	"Used to access_": "Käytetään ajoneuvon sijainnin ja nopeuden tarkistamiseen. Voit muuttaa GPS-asetuksia myöhemmin kameran tietosuoja-asetuksista.",
	"Incorrect cloud code": "Virheellinen pilvikoodi",
	"An account is_": "Tällä sähköpostiosoitteella on jo rekisteröity tili.",
	"Live event upload": "Live-tapahtuman lataus",
	Permissions: Permissions$c,
	"Assign in": "Määritä sisään",
	"Are you sure_camera": "Haluatko varmasti poistaa tämän kameran?",
	"Uploading videos:": "Ladata videoita:",
	"GPS location recording": "GPS-sijainnin tallennus",
	"When OFF, GPS_": "Kun POIS PÄÄLTÄ, GPS-sijaintia ei tallenneta eikä lähetetä pilvipalvelimelle.",
	"As personal video_": "Jakamisen yhteydessä saatetaan lähettää henkilökohtaisia videoita, joten päätä huolellisesti, mitä tietoja jaat.",
	"Share location": "Jaa sijainti",
	Private: Private$c,
	"Used to access_2": "Käytetään ajoneuvon sijainnin ja nopeuden tarkistamiseen.",
	"Share live view": "Jaa live-näkymän video",
	"Share live audio": "Jaa liven-näkymän ääni",
	"Share camera’s name": "Jaa autokameran nimi",
	"Impact detection": "Iskun tunnistus",
	Entering: Entering$c,
	Exiting: Exiting$c,
	"Normal event recording": "Normaali tapahtuman tallennus",
	"Harsh braking": "Voimakas jarrutus",
	Acceleration: Acceleration$c,
	"Sharp turn": "Terävä kääntö",
	"Parking event recording": "Pysäköintitapahtuman tallennus",
	Passing: Passing$c,
	"Video source": "Videolähde",
	Overspeed: Overspeed$c,
	"Are you sure_video": "Haluatko varmasti poistaa tämän videon?",
	"Add camera to_": "Lisää kamera live-näkymään",
	"No routes to_": "Ei näytettäviä reittejä",
	"Start by adding_": "Aloita lisäämällä päivämääriä.",
	"invite sent": "Kutsu lähetetty",
	Recipients: Recipients$c,
	Send: Send$c,
	"Routes selected_": "Valitut reitit: {{n}}/{{total}}",
	"Map service": "Karttapalvelu",
	"Speed units": "Nopeusyksiköt",
	Note: Note$c,
	"Release notes": "Versiohistoria",
	"The name must_": "Nimen on oltava 1–30 merkkiä.",
	Video: Video$c,
	Advanced: Advanced$c,
	"Firmware language": "Laiteohjelmiston kieli",
	"Wi-Fi": "Wi-Fi",
	Voice: Voice$c,
	"Show date and_": "Näytä päivämäärä ja aika",
	"Show speed": "Näytä nopeus",
	"Front camera rotation": "Etukameran kierto",
	"Manual time settings": "Manuaaliset aika-asetukset",
	"Recommended for better_": "Suositellaan parempaa pakkausta, pienempää tiedostokokoa ja 4K UHD -tarkkuutta varten.",
	"For full compatibility_": "Jotta voidaan varmistaa täysi yhteensopivuus vanhempien pöytäkoneiden ja mobiililaitteiden kanssa.",
	"Up and down": "Ylös ja alas",
	"Side to side": "Sivulta sivulle",
	"Front and back": "Etuosa ja takaosa",
	"Detection region": "Tunnistusalue",
	"Hotspot 1": "Yhteyspiste 1",
	"Hotspot 2": "Yhteyspiste 2",
	"Hotspot 3": "Yhteyspiste 3",
	"Enter/exit": "Syötä/poistu",
	"Event recording": "Tapahtumien tallennus",
	"Front security (Normal)": "Etupuolen turvallisuus (normaali)",
	"Front security (Parking)": "Etupuolen turvallisuus (pysäköinti)",
	"LTE (Parking)": "LTE (pysäköinti)",
	"Wi-Fi (Parking)": "Wi-Fi (pysäköinti)",
	"Turn on at startup": "Ota käyttöön käynnistyksen yhteydessä",
	"Turn off after_": "Poista käytöstä 10 minuutin käyttämättömyyden jälkeen",
	"Your firmware is_": "Laiteohjelmistosi on ajan tasalla",
	"Add admin": "Lisää järjestelmänvalvoja",
	"Remove All/n": "Poista kaikki/{{a}}",
	"Are you sure_remove": "Haluatko varmasti poistaa kamerat tästä ryhmästä?",
	"This will cancel_2": "Tämä peruuttaa Fleet Plan -tilauksesi. Siirryt Free Plan -ohjelmaan nykyisen laskutusjakson lopussa.",
	"You’ve reached_": "Olet saavuttanut kamerakohtaisen kuljettajarajan",
	"Are you sure_remove admin": "Haluatko varmasti poistaa järjestelmänvalvojan {{a}}{{b}} tästä ryhmästä?",
	"Fleet Plan · Owner": "Fleet Plan · Owner",
	"Manage cameras": "Hallinnoi kameroita",
	"Are you sure_delete zone": "Haluatko varmasti poistaa vyöhykkeen ”{{zone}}”?",
	"available on your_2": "{{a}}/{{b}} käytettävissä ohjelmassasi",
	"The new plan_2": "Ohjelma astuu voimaan nykyisen laskutusjaksosi lopussa ({{a}}).",
	"Canceled Fleet Plan_": "Fleet Plan peruutettu {{a}}",
	"Hard braking alert (beep)": "Voimakkaan jarrutuksen hälytys (merkkiääni)",
	"Hard acceleration alert (beep)": "Voimakkaan kiihdytyksen hälytys (merkkiääni)",
	"Hard cornering alert (beep)": "Voimakkaan kääntymisen hälytys (merkkiääni)",
	"SSID must be_": "SSID:n täytyy olla vähintään 5 merkkiä pitkä.",
	"Password must be_": "Salasanan täytyy olla vähintään 8 merkkiä pitkä.",
	"5 to 32 characters long": "5–32 merkkiä pitkä",
	"8 to 32 characters long": "8–32 merkkiä pitkä",
	"Longer storage period_event": "Pidempi tallennusjakso tapahtuman live-lähetykselle",
	"Requires latest firmware_": "Vaatii uusimman laiteohjelmiston. Ei yhteensopiva mallien DR650S, DR650GW kanssa",
	"After Blackvue is_": "Kun Blackvue on yhdistetty pilveen, asetukset tallennetaan.",
	"This is an_": "Tätä sähköpostiosoitetta ei ole rekisteröity. Haluatko rekisteröidä uuden tilin?",
	"This feature is_": "Tämä toiminto on vain Fleet Plan -tilaajien käytettävissä.",
	"Please return to_": "Tiliä ei ole olemassa. Tai yritä kirjautua sisään Apple- tai Google-tililläsi.",
	"Adjusting the cut-off voltage_": "Adjusting the cut-off voltage to a lower setting may result in your dash cam draining more power from your battery.\nThis could result in warning messages of battery drain or affect other vehicle functions.\nPlease consult with your dealership before lowering the voltage.",
	"Your videos will_": "Videosi näkyvät täällä, kun ne tulevat saataville.",
	"You drove:_": "Sinä ajoit: {{distance}}, {{time}}",
	"Event count per_": "Tapahtumamäärä ajotuntia kohden",
	"Are you sure_recipient": "Haluatko varmasti poistaa tämän vastaanottajan?",
	"(You)": "{{a}} (sinä)",
	"All events": "Kaikki tapahtumat",
	Days_: Days_$c,
	"Requires DMC 200_": "Vaatii DMC 200 -kameran",
	"A DMS and compatible_": "Tämän raportin katsomiseen tarvitaan DMS ja yhteensopiva autokamera.",
	"Notifications will show_": "Ilmoitukset näkyvät täällä, kun ne tulevat saataville.",
	"Try changing your_": "Kokeile vaihtaa päivämäärä tai poistaa suodattimet.",
	Mute: Mute$c,
	UnMute: UnMute$c,
	"Calling and smoking_": "Vain DMC 200 -laite tunnistaa soittamisen ja tupakoinnin",
	"You need a DMS_": "Raportin katsominen vaatii DMS:n.",
	"Try BlackVue Cloud": "Kokeile BlackVue Cloud -palvelua",
	"Individual driver looking_": "Yksittäinen kuljettaja, joka haluaa mielenrauhan? Yrittäjä, joka tarvitsee helpon ajoneuvojen turvallisuus- ja seurantaratkaisun?",
	"Whoever you are_": "Kuka tahansa oletkin, mitkä tahansa tarpeesi ovatkin, meillä on Cloud-palvelu sinulle!",
	"It is the account that_Driver": "Se on tili, joka liittää kalustosi BlackVue Cloud -palveluun sen jälkeen, kun olet hyväksynyt sähköpostikutsun omistajalta tai järjestelmänvalvojalta. Kuljettaja voidaan määrittää vain yhteen kameraan ja hänellä on rajoitettu mahdollisuus tarkastella omaa tiliprofiiliaan tai hänelle määritetyn kameran liven-näkymää ja toistoa.",
	"It is the account that_Admin": "Se on tili, joka liittää kalustosi BlackVue Cloud -palveluun, kun olet hyväksynyt sähköpostikutsun omistajalta. Järjestelmänvalvojatileille voidaan antaa ne oikeudet, jotka omistaja sallii kyseiselle järjestelmänvalvojalle.",
	"Video deleted": "Video poistettu",
	"Video delete_plural": "Videot poistettu",
	"Driver removed from_": "Kuljettaja poistettu ryhmästä",
	"Admin removed from_": "Järjestelmänvalvoja poistettu ryhmästä",
	"Camera removed from_": "Kamera poistettu ryhmästä",
	"Are you sure_videos": "Haluatko poistaa valitut tiedostot?",
	"You have to cancel_fleet": "Sinun on peruutettava sovelluksen sisäinen tilauksesi muuttaaksesi kameroiden määrää: \n \n 1. Peruuta nykyinen tilauksesi App Storessa tai Google Play -kaupassa. Siirryt Free Plan -ohjelmaan nykyisen laskutusjakson lopussa. Kaikki tietosi pysyvät ennallaan. 2. Kirjaudu sisään blackvuecloud.com-tilille ja päivitä Fleet Plan -tilaukseen.",
	Discard: Discard$c,
	"Discard unsaved changes?": "Hylätäänkö tallentamattomat muutokset?",
	"Incorrect serial number": "Virheellinen sarjanumero",
	"An error occurred_again": "Tapahtui virhe. Yritä uudelleen.",
	"You are subscribed_free": "Sinulla on BlackVue Cloud -palvelun Free Plan -tilaus.",
	"When an event_": "Kun tapahtuma luodaan (törmäys havaitaan tai se käynnistetään manuaalisesti), BlackVue tallentaa live-videovirran valitsemastasi kamerasta pilvipalvelimelle 5 sekuntia ennen tapahtumaa Live -tapahtuman lähetyksen kautta.",
	Report: Report$c,
	"How it work": "Näin se toimii",
	"Cloud Camera": "Pilvikamera",
	"Internet Connection": "Internet-yhteys",
	"BlackVue App/Viewer": "BlackVue App/Viewer",
	"All you need_": "Kaikki, mitä tarvitset",
	"Cloud-compatible BlackVue": "Pilviyhteensopiva BlackVue",
	"and a cellular_": "ja datayhteys matkapuhelimessa. Jotkin mallit muodostavat yhteyden pilveen kolmannen osapuolen Wi-Fi-tukiaseman kautta. Toiset tarjoavat sisäänrakennetun nano-SIM-kortinlukijan tai liitettävän yhteysmoduulin tuen.",
	"Cloud features at_": "Pilviominaisuudet käden ulottuvilla",
	"Enjoy peace of_": "Saat mielenrauhan tietäessäsi, että BlackVue valvoo autoasi. Jos jokin menee pieleen, autokamerasi lähettää sinulle heti viestejä.",
	"Let your BlackVue_": "Anna BlackVuen valvoa autoasi ja varoittaa sinua tapahtumista. Heti kun isku havaitaan, BlackVue lähettää ilmoituksen ja tilannekuvan puhelimeesi tai verkkoselaimeesi.",
	"Check on your_": "Tarkista autosi missä tahansa Live-etänäkymän avulla. Voit käyttää reaaliaikaista videosyötettä pilveen kytketystä autokamerasta joko verkkoselaimen tai puhelimen kautta ja vaihtaa helposti etu-, taka- tai sisäkameroiden välillä.",
	"Your BlackVue may_": "BlackVue ei estä törmäyksiä, mutta niiden tapahtuessa on mahdollista tallentaa ratkaisevia videotodisteita. Selaa kaikkia autokameran tallentamia videoita matkapuhelimestasi tai verkkoselaimestasi.",
	"Worried about eating_": "Oletko huolissasi datankäyttösopimuksen ylittymisestä? BlackVuen alisyötetekniikka mahdollistaa videoiden kevytversioiden käyttämisen nopeaa selaamista ja puskuroimatonta katselua varten.",
	"Move files from_": "Siirrä tiedostot BlackVuesta pilveen. Tallenna yksi video tai valitse useita videoleikkeitä joukkolähetystä varten. BlackVue-sovelluksella puhelimeesi ladattua videota voi käyttää ja jakaa sisäisen muistin valikosta.",
	"View your vehicle’s_": "Tarkastele autosi sijaintia ja matkanopeutta reaaliajassa. Päivitä Smart Plan -ohjelmaan saadaksesi viimeisten 7 päivän GPS-seurantatiedot.",
	"Get more with_": "Saat enemmän Smart Plan -ohjelmalla",
	"Unlimited Remote Live_": "Rajoittamaton live-etäkatselu",
	"Up to 3 dashcams_": "Jopa 3 autokameraa yhdellä tilillä",
	"Want to track_": "Haluatko seurata koko kalustoa? Päivitä Fleet Plan -ohjelmaan",
	"BlackVue Fleet Tracking_2": "BlackVue-kalustonseuranta on kokonaisvaltainen ratkaisu kalustosi suojaamiseen ja seurantaan. Ominaisuudet ja hinnoittelujärjestelmä vastaavat joustavasti yrityksesi tarpeita.",
	"Stream real-time video_": "Suoratoista reaaliaikaista videota ilman rajoituksia. Bittinopeus: 600 kt/s",
	"Up to 999 Dashcams": "Enintään 999 autokameraa",
	"Register up to_": "Rekisteröi enintään 999 autokameraa tiliä kohden.",
	"15GB of Cloud_": "15 Gt:n pilvitallennustila",
	"15GB per additional_": "15 Gt lisäautokameraa kohden. Rajoittamaton tapahtumien automaattinen lataustallennustila.",
	"90-days GPS_": "90 päivän GPS-seurantalokit",
	"High accuracy: 15_": "Suuri tarkkuus: 15 sekuntia, video kartalla, helppo tietojen vienti.",
	"Unique fleet management_": "Ainutlaatuiset kalustonhallintaominaisuudet tuovat lisäarvoa ja mukavuutta",
	"Create geofences and_": "Luo aluerajauksia ja vastaanota reaaliaikaisia ilmoituksia puhelimeesi tai tietokoneellesi.",
	"View at a_": "Tarkastele yhdellä silmäyksellä ajettua kokonaismatkaa, tyhjäkäyntiaikaa, nopeustapahtumia jne. taulukoista, jotka voidaan tulostaa tai viedä.",
	"Multi Live View": "Multi Live -katselu",
	"Monitor up to_": "Seuraa jopa 4 autokameraa samanaikaisesti",
	"Benefits for you": "Hyödyt sinulle",
	Individual: Individual$c,
	"Get notifications to_2": "Saat ilmoituksia puhelimeesi, kun pysäköimääsi autoon osutaan. Tarkista etänä, mitä auton ympärillä tapahtuu. Saatavana verkossa, mobiililaitteissa, Mac- ja Windows-järjestelmissä.",
	"Small business owner": "Pienyrittäjä",
	"Monitor your commercial_2": "Seuraa hyötyajoneuvojasi kartalla reaaliajassa. Puhu kuljettajillesi milloin tahansa selaimen, BlackVue-mobiilisovelluksen, Mac- tai Windows-katseluohjelman kautta.",
	"Company with large_": "Yritys, jolla on paljon ajoneuvoja",
	"With BlackVue Fleet_2": "BlackVue-kalustoseurannan kautta voit seurata jopa 999 ajoneuvoa reaaliaikaisesti selaimen, BlackVue-mobiilisovelluksen, Mac- tai Windows-katseluohjelman kautta.",
	Subscribed: Subscribed$c,
	"The video was_": "Video on jo lähetetty.",
	Geofence: Geofence$c,
	"500: Internal server error": "500: Sisäinen palvelinvirhe",
	"404: Page not found": "404: Sivua ei löydy",
	"Check the web address_": "Tarkista web-osoite tai palaa BlackVue Cloud -kotisivulle",
	"home page": "Home page",
	"There isn’t an_": "Tähän sähköpostiosoitteeseen ei ole liitetty tiliä",
	"You can now_password": "Voit nyt kirjautua uudella salasanallasi",
	"Are you sure_remove admin2": "Haluatko varmasti poistaa järjestelmänvalvojan pysyvästi?",
	"Admin deleted": "Järjestelmänvalvoja poistettu",
	"Members deleted": "Jäsenet poistettu",
	"Are you sure_groupName": "Haluatko varmasti poistaa ryhmän {{a}}?",
	"Requires latest firmware": "Vaatii uusimman laiteohjelmiston",
	"Selected file(s) moved_": "Valittujen tiedostojen siirto onnistui",
	"Are you sure_remove driver2": "Haluatko varmasti poistaa kuljettajan {{a}} ({{b}}) tästä ryhmästä?",
	"Invite sent": "Kutsu lähetetty",
	"Safe driving": "Turvallinen ajo",
	"Reckless driving": "Holtiton ajaminen",
	"Inattentive driving": "Huolimaton ajaminen",
	"Driving events trend": "Ajotapahtumien trendi",
	"Driving details": "Ajotiedot",
	Driving: Driving$c,
	Idling: Idling$c,
	Distance: Distance$c,
	"Parking sessions": "Pysäköinnit",
	"Parked time": "Parked time",
	"Idle stops": "Tyhjäkäynti päättyy",
	"Idle time": "Tyhjäkäyntiaika",
	"Impact events": "Impact Events",
	Parked: Parked$c,
	Speed: Speed$c,
	"Overspeeding alerts": "Ylinopeushälytykset",
	Highest_2: Highest_2$c,
	Average: Average$c,
	Geofences: Geofences$c,
	"Entries into a_": "Saapumiset vyöhykkeelle",
	"Exits from a_": "Poistumiset vyöhykkeeltä",
	"No data": "Ei tietoja",
	"Hard acceleration": "Kiihdytys",
	"Hard braking": "Voimakas jarrutus",
	"Hard cornering": "Terävä kääntö",
	"The number within the brackets_": "Suluissa oleva luku ilmaisee keskimääräisen tapahtumamäärän ajotuntia kohden. Jos ajoit vähemmän kuin tunnin päivässä, näytetään tapahtumien kokonaismäärä.",
	"Did you insert_": "Asetitko SIM-kortin?",
	"Click here for_": "<a>Napsauta tätä</a> saadaksesi tarkempia ohjeita.",
	"Back up all_": "<b>Varmuuskopioi kaikki tärkeät tallenteet ennen näiden asetusten tallentamista.</b><br/>Kun tallennat asetukset, microSD-kortti alustetaan uudelleen ja kaikki tallenteet poistetaan, jotta voidaan varmistaa vakaa toiminta.",
	"Not connected to_": "Ei yhdistetty pilveen. Jotkin toiminnot on poistettu tilapäisesti käytöstä.",
	"GPS Location recording off": "GPS-sijainnin tallennus pois päältä",
	"n Videos deleted": "{{count}} videota poistettu",
	Move: Move$c,
	"Driver Monitoring System (DMS) will_": "Kuljettajan valvontajärjestelmä (DMS) käynnistetään pian.",
	"An error occured while_": "Virhe tapahtui yritettäessä muuttaa kameroiden määrää. Yritä uudelleen",
	"Reached the limit_": "Saavutti rajan: {{a}}",
	"An invitation was_": "Kutsu on jo lähetetty tähän sähköpostiosoitteeseen.",
	"To use the_": "Pilvitoiminnon käyttäminen. Aseta SIM-korttisi.",
	"Last updated": "Viimeksi päivitetty {{date}}",
	"Try changing your date": "Yritä vaihtaa päivämäärä.",
	"No event data_": "Tapahtumatietoja ei kerätty valitulta ajalta",
	"Please select another_": "Valitse toinen päivä tai kuukausi nähdäksesi koko raportin.",
	"more than 6_": "vaaditaan yli 6 merkkiä",
	"Sign up free": "Rekisteröidy ilmaiseksi",
	"Cloud storage warning": "Pilvitallennustilan varoitus",
	"Cloud Storage Full": "Pilvitallennustila täynnä",
	"Cloud storage usage_100": "Pilvitallennustilan käyttö saavutti 100%. Tyhjennä tallennustilaa, jotta voit käyttää live-tapahtumien latausta",
	"Cloud storage usage_": "Pilvitallennustilan käyttö saavutti <b>({{a}}%)</b>. \nJärjestä pilvitallennustilaa.\nLive-tapahtumien palvelimeen lataaminen ei ole käytettävissä, jos pilvitallennustila on täynnä.",
	"Are you sure_delete_zone": "Haluatko varmasti poistaa kohteen?",
	"Search Name or email": "Hae nimeä tai sähköpostia",
	"Search group name": "Hae ryhmän nimeä",
	"Please note that_": "Huomaa, että videotallennus keskeytyy muutamaksi sekunniksi, kun uudet asetukset otetaan käyttöön.",
	"Currently connected Hotspot": "Tällä hetkellä yhdistetty tukiasema",
	"Enhanced night vision": "Tehostettu yökuvaus",
	"To access the_": "Voit käyttää kameraa päivittämällä tilausohjelman.",
	"Restarting the Blackvue_": "BlackVue käynnistetään uudelleen, jotta asetukset voidaan ottaa käyttöön.",
	"Hard acceleration event_": "Voimakas kiihdytystapahtuma tapahtuu, kun nopeuden nousu sekunnissa on yli {{kmh}} km/h ({{mph}} MPH)",
	"Hard braking event_": "Voimakas jarrutustapahtuma tapahtuu, kun nopeuden lasku \nsekunnissa on yli {{kmh}} km/h ({{mph}} MPH)",
	"Hard cornering event_": "Voimakas kääntyminen tapahtuu, kun käännät yli 60 astetta 2 sekunnin sisällä ajaessasi yli \n{{kmh}} km/h ({{mph}} MPH)",
	"Changes you made_": "Tekemiäsi muutoksia ei ehkä tallenneta.",
	"My location": "Sijaintini",
	"Hotspot name (SSID)": "Tukiaseman nimi (SSID)",
	Connected: Connected$c,
	"Camera will be rebooted_": "Kamera käynnistetään uudelleen. Haluatko silti jatkaa?",
	"Restarting the BlackVue_": "BlackVuen käynnistäminen uudelleen. Odota hetki.",
	"Failed to reboot_": "Kameran uudelleenkäynnistys epäonnistui",
	"Bluetooth (Parking mode)": "BT (pysäköintitila)",
	"Front and interior camera_": "Etukamera ja sisäkamera tallentavat yhdessä.",
	"Interior camera stops_": "Sisäkamera lopettaa tallentamisen 5 min kuluttua pysäköintitilaan siirtymisestä. Tallennus alkaa, kun siirrytään normaalitilaan.",
	Individual_: Individual_$c,
	"Driver detection": "Kuljettajan tunnistus",
	"During driving only": "Vain käytön aikana",
	Always: Always$c,
	"Driver detection box": "Kuljettajan tunnistuslaatikko",
	"DMS camera rotation": "DSM-kameran kierto",
	Low: Low$c,
	Medium: Medium$c,
	High_2: High_2$c,
	"Reboot Camera": "Käynnistä kamera uudestaan",
	"Latest events": "Viimeisimmät tapahtumat",
	"G-Sensor": "G-Sensor",
	"Playback speed": "Toistonopeus",
	Flip: Flip$c,
	Previous: Previous$c,
	Next: Next$c,
	"Map type": "Kartan tyyppi",
	"Zoom in": "Lähennä",
	"Zoom out": "Loitonna",
	"Move to Cloud": "Siirry pilveen",
	"Please recognize that_": "Huomaa, että videotallennus keskeytyy muutamaksi sekunniksi, kun asetukset otetaan käyttöön.",
	"6 characters with_": "6 merkkiä, joka on yhdistelmä kirjaimia, numeroita ja erikoismerkkejä",
	"Updating firmware": "Laiteohjelmistoa päivitetään",
	"Overspeed event occurs_": "Ylinopeustapahtuma tapahtuu, kun autokamera varoittaa kuljettajaa nopeusrajoituksen ylittymisestä. Voit muuttaa sitä kohdassa Laiteohjelmisto > Järjestelmä > Voimakkuus",
	"Enter group name": "Anna ryhmän nimi",
	"Live view failed": "Live-katselun virhe.",
	"Parking mode enter_": "Pysäköintitilan käynnistäminen/sulkeminen",
	"Cloud connectivity": "Pilviyhteys",
	Expand: Expand$c,
	Collapse: Collapse$c,
	"all day": "Koko päivä",
	"Driving style": "Ajotyyli",
	"Driving impact": "Isku ajettaessa",
	More: More$c,
	"No cameras to_": "Ei lisättäviä kameroita",
	"You have added_": "Olet lisännyt kaikki saatavilla olevat kamerat.",
	Multi: Multi$c,
	"Report video": "Ilmoita videosta",
	"Sexually explicit content": "Seksuaalinen sisältö",
	"Graphic violence": "Väkivaltainen tai vastenmielinen",
	"Hateful speech": "Vihaan yllyttävä tai solvaava",
	"Harassment or bullying": "Häirintä tai kiusaaminen",
	"Spam or advertisement": "Roskaposti tai mainos",
	"Infringement of my_": "Oikeuksiani loukkaava",
	"Other reason": "jne.",
	"Reason for reporting": "Ilmoittamissyy",
	"Reported videos will_": "Ilmoitetut videot tarkistetaan 72 tunnin aikana. Video ei näy tapahtumakartalla ennen kuin sen soveltuvuus tapahtumakartalla julkaisua varten on vahvistettu.",
	"Touch sensor": "Kosketustunnistin",
	"Motion and impact detection": "Liikkeen- ja iskuntunnistus",
	"Settings have been changed": "Asetukset on muutettu.",
	"Start event recording (beep)": "Aloita tapahtuman tallennus (äänimerkki)",
	"Scheduled reboots": "Aikataulutetut uudelleenkäynnistykset",
	Safe: Safe$c,
	Reckless: Reckless$c,
	Inattentive: Inattentive$c,
	"Highest(Extreme)": "Paras (äärimmäinen)",
	"Public cameras": "Julkiset kamerat",
	List: List$c,
	Usage: Usage$c,
	"Video playbacks and downloads": "Videon toistot ja lataus",
	"of 100 times": "100 kerrasta",
	"of 10 minutes": "10 minuutista",
	Profile: Profile$c,
	"Search geofences": "Hae aluerajauksia",
	"Export CSV": "Vie CSV",
	"Exit fullscreen": "Poistu koko näytön tilasta",
	Fullscreen: Fullscreen$c,
	Upgrade: Upgrade$c,
	"Email address": "Sähköpostiosoite",
	"of Unlimited": "rajoittamattomasta",
	"No notifications yet": "Viimeisen 7 päivän aikana ei saatu ilmoituksia.",
	"No videos yet": "Ei vielä videoita",
	Management: Management$c,
	Day: Day$c,
	Month: Month$c,
	"Welcome to the BlackVue_": "Tervetuloa BlackVue Cloud Viewer -ohjelmaan",
	"You can access BlackVue_": "Voit käyttää BlackVue Cloud -palvelua verkossa milloin ja missä tahansa!",
	"Start tour": "Aloita kierros",
	"Map view": "Karttanäkymä",
	"Check the current_": "Tarkista kameroiden ja julkisten kameroiden tämänhetkinen GPS-sijainti ja nopeus.",
	"Camera’s features": "Kameran ominaisuudet",
	"Take a look_": "Tutustu erilaisiin BlackVue-kameraan liittyviin pilviominaisuuksiin.",
	"Visualize your vehicle’s_": "Visualisoi ajoneuvosi ajoreitti ajan myötä.",
	"Smart plan_": "Smart Plan: 90 päivää, Fleet Plan: 90 päivää",
	"Create geofences and2_": "Luo aluerajauksia ja vastaanota reaaliaikaisia ilmoituksia.",
	"Got it": "Selvä",
	"Manage Fleet members": "Hallinnoi Fleet-ohjelman jäseniä",
	"Invite fleet members_": "Kutsu Fleet-ohjelman jäseniä ja määritä jäsenet ryhmiin.",
	"The moment the_": "Kun kamera havaitsee iskun, ilmoitukset näkyvät luettelona tässä.",
	"Geofence Setup (Web)_": "Aluerajauksen asetukset (verkko/työpöytä) ja hälytykset",
	"Original file play_": "Alkuperäisen tiedoston toisto on saatavilla vain ladattavaksi",
	"To get most_": "Jotta saat kaiken irti BlackVue Cloud Viewer -ohjelmistosta, kameran on oltava yhteydessä pilveen. Lataa BlackVue-sovellus ja koe saumaton pariliitäntä, kameran lisääminen ja pilviyhteys yhdellä kertaa!",
	"You haven’t driven_Today": "Et ole vielä ajanut autoasi tänään. Aja autoasi BlackVuen kanssa, jotta voit tarkistaa ajoraportin.",
	"You haven’t driven_Month": "Et ole ajanut autoasi vielä tässä kuussa. Aja autoasi BlackVuen kanssa, jotta voit tarkistaa ajoraportin.",
	"Fleet Plan only_": "Fleet Plan vain saatavilla",
	"Overwrite locked event2_": "Korvaa lukitut tapahtumatiedostot, kun tallennustila on täynnä",
	"DMS’s New firmware_": "DMS:n uusi laiteohjelmisto on saatavilla",
	"Highest speed_report": "<b>Suurin nopeus</b>\nSuurin kerättyjen nopeustietojen arvo metriyksikköinä kerättynä , muunnettuna yksiköihin km/t ja mph\n\n<b>Keskinopeus</b>\n(matka / ajetut tunnit) x 3600 keskinopeus. Esim. (2622/1208) x 3600 = 7814,907\nkm/t: Vain kokonaisluku, \nmph-arvon kantalukupiste on korkeintaan 2 lukua kokonaisluvun alapuolella",
	"Choose a cloud_": "Valitse pilvipalveluun yhdistämistapa",
	"You need an_": "Pilveen yhdistäminen vaatii Internet-yhteyden. Valitse laite, jota käytät pilviyhteyteen.",
	"BlackVue SIM card": "BlackVue SIM -kortti",
	"Support model_": "Tuettu malli: DR750X-2CH LTE Plus (NA)",
	"3rd party SIM_": "Kolmannen osapuolen SIM-kortti",
	"Support model_SIM": "Tuettu malli: DR750X-2CH LTE Plus, DR750-2CH LTE, CM100 LTE",
	"Wi-fi hotspot": "Wi-Fi-yhteyspiste",
	"Support model_Wifi": "Tuettu malli: Kaikki BlackVue-mallit",
	"How to connect_": "Pilveen yhdistäminen",
	"Download BlackVue application": "Lataa BlackVue-sovellus.",
	"*If you are_": "*Jos BlackVue SIM -korttia käytetään pilviyhteyteen, siirry kohtaan {{a}} {{b}}.",
	"Place your phone_": "Aseta puhelin kameran BT-alueelle. Aloita saumaton pariliitäntä kohdassa {{a}}.",
	"Back to camera_": "Takaisin kameraluetteloon",
	"Upgrade for more_": "Päivitä ja saat enemmän ominaisuuksia!",
	"Upgrading the cloud_": "Pilvipalvelun päivittäminen tarjoaa enemmän ominaisuuksia ja monien kameroiden hallinnan. Haluatko päivittää pilvitilauksesi?",
	"Explore cloud plans": "Tutustu pilvitilauksiin",
	Later: Later$c,
	"Successfully subscribed": "Tilaus onnistui!",
	"1GB data plan": "1 Gt:n datapaketti",
	"First month free_": "Ensimmäinen kuukausi on ilmainen, <a>sen jälkeen 10,99 USD/kk</a>",
	"Next billing date": "Seuraava laskutuspäivä",
	"Once SIM card_": "Kun SIM-kortti on asetettu kameraan, voit aloittaa BlackVue Cloud -ominaisuuksien käyttämisen heti.",
	"Go to SIM_": "Siirry SIM-korttien hallintaan",
	"Manage your BlackVue_": "Hallinnoi BlackVue SIM -korttia täällä!",
	"Recommended for BlackVue_": "Suositellaan BlackVue SIM -pidikkeisiin",
	"Connect to cloud": "Yhdistä pilveen",
	"Enter BlackVue SIM_": "Syötä BlackVue SIM -kortin ICCID-numero",
	"ICCID number is_": "ICCID-numero on painettu SIM-kortin pakkaukseen. Syötä ICCID-numeron viimeiset 14 numeroa.",
	ICCID: ICCID$c,
	"SIM information": "SIM-kortin tiedot",
	"Start your free_": "Aloita ilmainen kokeilu heti",
	"SIM card activate_": "SIM-kortin aktivointipäivä",
	"Based on the_": "Perustuu päivämäärään, jolloin SIM-kortti asetetaan kameraan ja aktivoidaan, kun virta käynnistetään",
	"Upgrade to 3GB_": "Päivitä 3 Gt:n / 5 Gt:n tilaukseen milloin tahansa",
	"Cancel your plan_": "Peruuta tilauksesi milloin tahansa",
	"No Commitment": "Ei vaadi sitoutumista",
	"Precautions for using_": "Palvelun käyttöä koskevat varotoimet",
	"After 1GB is_": "Kun 1 Gt:n tila on käytetty, Internet ei ole enää käytettävissä.",
	"If you have_": "Jos olet jo asettanut SIM-kortin kameraan ja käyttänyt sitä, ilmainen kokeilu alkaa siitä, kun aloit käyttää sitä.",
	"This content is_": "Tämä sisältö on määritetty SIM-pakkauksessa. Emme hyvitä ilmaisjaksoja, joita ei ole käytetty.",
	"If you have_2": "Jos sinulla on muita kysymyksiä, ota yhteyttä <a>asiakaspalvelutiimiin</a>",
	"When OFF, connecting_": "Kun se on pois käytöstä, kameraa ei voi yhdistää saumattomalla pariliitännällä.",
	"1 month free": "1 ilmainen kuukausi",
	"No commitment. Cancel_": "Ei vaadi sitoutumista. Peruuta milloin tahansa.",
	"The video has been reported_": "Videosta on tehty onnistunut ilmoitus",
	"Free for 1 month": "Ilmainen 1 kuukauden ajan",
	"Start your free_2": "Aloita ilmainen kokeilusi",
	"1GB free for_": "1 Gt ilmaiseksi {{a}} päivän ajan",
	"1GB data": "1 Gt dataa",
	"1 month free_2": "1 kuukauden ilmainen kokeilu alkaa {{a}} ja sisältää 1 Gt dataa BlackVue SIM -kortille.",
	"Your next billing_": "Seuraava laskutuspäivä on {{a}}",
	"SIM card": "SIM-kortti",
	"SIM guide": "SIM-kortin opas",
	"SIM card list": "SIM-korttiluettelo",
	"Add SIM card": "Lisää SIM-kortti",
	"No SIM card_": "Ei vielä SIM-korttia",
	"Search SIM ICCID_": "Hae SIM-korttia ICCID-numerolla tai nimellä",
	"Cloud disconnected. Failed_": "Pilviyhteys katkaistu. Videon toistaminen epäonnistui",
	"This sim card_": "Tämä SIM-kortti on jo rekisteröity toiseen tiliin.",
	"Incorrect BlackVue SIM_": "Virheellinen BlackVue SIM -kortin ICCID-numero",
	"My shared videos": "Jaetut videoni",
	"Number of events": "Tapahtumien määrä",
	"Added to Event Map": "Lisätty tapahtumakarttaan",
	"Successfully added video(s)_": "Videot on lisätty onnistuneesti jaettaviksi tapahtumakarttaan! Jos haluat tarkistaa jaettujen videoiden tilan ja hallinnoida niitä, siirry kohtaan Tapahtumakartta > Jaetut videoni.",
	"Already added to_": "Lisätty jo tapahtumakarttaan",
	"This video(s) is already added_": "Nämä videot on jo lisätty tapahtumakarttaan! Jos haluat tarkistaa jaettujen videoiden tilan ja hallinnoida niitä, siirry kohtaan Tapahtumakartta > Jaetut videoni.",
	"BlackVue’s firmware is up_": "BlackVue-laiteohjelmisto on ajan tasalla",
	"Service end": "Palvelu päättyy",
	Resubscribe: Resubscribe$c,
	"Sort ascending": "Nouseva järjestys",
	"Sort descending": "Laskeva järjestys",
	plan: plan$c,
	USD: USD$c,
	"Are you sure_Cancel": "Oletko varma, että haluat perua tilauksesi? Huomaa seuraavat asiat ja vahvista alla.",
	"Your current SIM_": "Nykyinen SIM-korttitilauksesi päättyy {{a}} eikä sinua enää veloiteta sen jälkeen.",
	"After canceling your_": "Kun peruutat SIM-korttitilauksesi, voit käyttää SIM-kortin dataa tilauksen päättymispäivämäärään asti.",
	"You can resubscribe_": "Voit uusia tilauksen 1 kuukauden kuluessa siitä, kun nykyinen tilauksesi päättyy. Jos haluat uusia tilauksen, napsauta Tilaa uudelleen -painiketta SIM-korttiluettelossa kohdassa {{a}}.",
	"Reason to cancel_": "Tilauksen peruuttamissyy",
	"Found an alternative": "Löysin toisen vaihtoehdon",
	"Too expensive": "Liian kallis",
	"Not required anymore": "En tarvitse enää",
	"Quality issue": "Ongelma laadun suhteen",
	etc_: etc_$c,
	"Please describe in_": "Kuvaile tarkemmin",
	"SIM card cannot_": "SIM-korttia ei voida poistaa, koska tämä SIM-kortti on osa tilausta. Jos haluat poistaa tämän SIM-kortin, peruuta ensin tilauksesi.",
	"SIM card cannot_2": "SIM-korttia ei voida poistaa, koska tämän SIM-kortin tilaus ei ole vielä päättynyt. Yritä uudelleen, kun tilauksesi on päättynyt.",
	"Are you sure_deleteSIM": "Haluatko varmasti poistaa tämän SIM-kortin?<br/>\n<b>Varoitus: et voi peruuttaa tätä toimintoa. Kaikki SIM-korttisi tiedot poistetaan heti.</b>",
	"ICCID number": "ICCID-numero",
	"Activation date": "Aktivointipäivä",
	"Current plan": "Nykyinen tilaus",
	"Manage Plan": "Hallinnoi tilausta",
	"Next billing on": "Seuraava laskutuspäivä",
	"View Invoices": "Tarkastele laskuja",
	"Choose best plan_": "Valitse sinulle sopiva tilaus",
	"Plan summary": "Tilauksen yhteenveto",
	"Ends on_": "Päättyy {{a}}",
	"Start from_": "Alkaa {{a}}",
	"Your subscription will_": "Tilauksesi päivitetään {{a}}, kun nykyinen tilauksesi päättyy.",
	"Resubscribe plan": "Tee tilaus uudelleen",
	"Your subscription will2_": "Tilauksesi alkaa {{a}}, kun nykyinen tilauksesi päättyy.",
	"Usage is estimated_": "Käyttö arvioidaan alkaen {{a}}",
	"Days left_": "{{a}} päivää jäljellä",
	"Data usage cycle": "Datan käyttöjakso",
	Available: Available$c,
	Used: Used$c,
	"Data used": "Dataa käytetty",
	"Subscribe to n_": "Tilaa datatilaus {{a}}, joka on voimassa <b>{{b}}–{{c}}</b> ja datatilaus {{d}} alkaa {{e}}",
	"Will be charged_": "Veloitetaan {{a}}",
	"Monthly usage": "Kuukausittainen käyttö",
	"You have fewer_": "Sinulla on vähemmän dataa jäljellä tässä kuussa!",
	"Get more data": "Hanki lisää dataa!",
	"This video cannot be shared": "Tätä videota ei voida jakaa",
	"This is a video cannot be shared_": "Tätä videota ei voida jakaa, koska kyseiseltä ajalta ei löydy ajotietoja.",
	Cancelled: Cancelled$c,
	Terminated: Terminated$c,
	"Edit name": "Muokkaa nimeä",
	"Not connected to_2": "Ei yhdistetty pilveen. Tarkista, että kamera on päällä ja sen Internet-yhteysmoduuli on käytössä.",
	"Some functionality is disabled_": "Jotkin toiminnot on poistettu käytöstä, koska kamera ei ole yhteydessä pilveen. Yhdistä pilveen <a>täällä</a>.",
	"If you want to cancel_": "Jos haluat peruuttaa tilauksesi, napsauta <a>Peruuta tilaus</a>.",
	"Select plan": "Valitse tilaus",
	"Event map collects_": "Tapahtumakartta kerää ja visualisoi BlackVue-tapahtumatiedot ja osoittaa tilanteen ympäröivillä teillä.",
	"Share your Live_": "Jaa live-tapahtuman lähetystiedostosi. Voit jakaa tapahtumavideosi muiden lähelläsi olevien käyttäjien kanssa.",
	"You can check_": "Voit katsoa muiden jakamia tapahtumavideoita.",
	"Service end_": "Palvelu päättyy: {{a}}",
	"DMS camera recording_": "DMS-kameran tallennus pysäköintitilassa",
	Sort: Sort$c,
	"Are you sure you want_": "Haluatko varmasti poistaa jaetun videon tapahtumakartalta?",
	"Remove shared video": "Poista jaettu video",
	"Explore event map": "Tutustu tapahtumakarttaan",
	"Event map": "Tapahtumakartta",
	"Explore the graphic_": "Tutustu lähelläsi olevien BlackVue-tapahtumien graafisiin tilastoihin.",
	"You can filter_": "Voit suodattaa ja tarkastella tapahtumia, jotka haluat näyttää.",
	"This video was removed by_": "Tästä videosta on tehty ilmoitus ja järjestelmänvalvoja on poistanut sen.",
	Bonus: Bonus$c,
	"Your subscription plan": "Tilauksesi tyyppi",
	"Your free trial will_": "Ilmainen kokeilusi alkaa {{a}}</br> ja <strong>päättyy</strong> {{b}}.",
	"Total after free trial": "Yhteensä ilmaisen kokeilun jälkeen",
	"This sim card is_": "Tämä SIM-kortti ei ole enää aktiivinen.",
	"Firmware is up_": "Laiteohjelmisto on ajan tasalla",
	"Keep in mind": "Muista",
	"Once 1GB of_": "Kun 1 Gt on käytetty, palvelu ei ole enää käytettävissä ennen seuraavaa datan nollauspäivää [tai kunnes päivität tilauksesi seuraavalle tasolle].",
	"After the SIM_": "Kun SIM-kortti on asetettu kameraan, ilmainen kokeilujakso alkaa, kun aloitat datan käytön.",
	"If you have_questions": "Jos sinulla on kysyttävää, ota yhteyttä <a>asiakastukeen.</a>",
	"Data reset date": "Datan nollauspäivä",
	"To use SIM card_": "Ota yhteyttä BlackVue-<a>asiakaspalvelutiimiin</a>, jotta voit käyttää SIM-korttia",
	"Go to Subscription": "Siirry tilaukseen",
	"An error occurred_subscription": "Valitun tilauksen tekemisen aikana tapahtui virhe.",
	"Please try again": "Yritä uudelleen",
	"Failed to subscribe": "Tilauksen tekeminen epäonnistui",
	"Go to Pricing": "Siirry hinnoitteluun",
	"SIM cards will_": "SIM-kortit näkyvät täällä, kun ne tulevat saataville.",
	"1GB for 1_": "1 Gt 1 kuukauden aikana",
	"Pricing Data": "Datahinnoittelu",
	"If you would like to check_": "Jos haluat tarkistaa jaettujen videoiden tilan ja hallinnoida niitä, siirry kohtaan Tapahtumakartta > Jaetut videoni.",
	"Connect to Cloud": "Yhdistä pilveen",
	"Completed!": "Valmis!",
	"Back to App": "Takaisin sovellukseen",
	"iOS in-app purchase": "iOS-sovelluksen sisäinen osto",
	"Android in-app_": "Android-sovelluksen sisäinen osto",
	"bonus n days": "{{a}} bonuspäivää",
	"Want to contribute your_": "Sallitaanko automaattinen tapahtumien lähetystiedostojen jakaminen tapahtumakarttaan?",
	"With event map_": "Voit jakaa tapahtuman automaattisen lähetysvideon lähellä olevien kuljettajien kanssa tapahtumakartan kautta.",
	"You can edit_3": "Voit muokata automaattisesti tapahtumakarttaan jaettavien tapahtumien lähetystiedostojen asetuksia milloin tahansa kohdassa BLACKVUE CLOUD > Kameran asetukset > Tietosuoja-asetukset.",
	"If you want to remove videos_": "Jakamisen yhteydessä saatetaan lähettää henkilökohtaisia videoita, joten päätä mitä tietoja jaat.",
	"Total events": "Tapahtumia yhteensä",
	"Automatically add Live Event_": "Automaattinen tapahtumien lähetystiedostojen jakaminen tapahtumakarttaan",
	"This camera is publicly_": "Tämä kamera on julkisesti avoin vain sijainnin osalta.",
	incomplete_zip: incomplete_zip$c,
	"Live Event Upload_": "Live-tapahtuman lähetys (säilytysaika: 7 päivää)\nVaatii uusimman laiteohjelmiston",
	"Thank you for_2": "Kiitos kärsivällisyydestäsi.",
	"Start Web viewer": "Käynnistä Web Viewer",
	"Are you sure_remove driver": "Haluatko varmasti poistaa pysyvästi kuljettajan",
	"An error occurred_sim": "Tilauksen tekemisen yhteydessä tapahtui virhe.",
	"Click the ADD SIM": "Napsauta SIM-korttiluettelosivulla LISÄÄ SIM -painiketta ja suorita SIM-kortin lisäysprosessin vaiheet uudelleen.",
	"Set download options": "Määritä latausvalinnat",
	"Information may be_": "Information may be transmitted with a delay and may not reflect actual balances.",
	"Swipe left and right to move": "Liiku pyyhkäisemällä vasemmalle tai oikealle",
	"Scheduled maintenance Notice": "Ilmoitus aikataulun mukaisesta huollosta",
	"Our Cloud server_": "Pilvipalvelimellemme suoritetaan aikataulun mukainen huolto.",
	"During that time_": "Huollon aikana pilviominaisuudet eivät ehkä ole käytettävissä.",
	"Expected maintenance start_": "Huollon arvioitu alkamisaika:",
	"Expected duration_": "Arvioitu kesto: {{a}} tuntia.",
	"For more information_": "Lisätietoja on kohdassa <a>[Palvelimen huoltoilmoitus]</a>",
	"Do not remind_": "Älä muistuta uudelleen",
	"Cloud Server Maintenance": "Pilvipalvelimen huolto",
	"BlackVue Cloud Service_": "BlackVue Cloud -palvelu on väliaikaisesti pois käytöstä",
	"We are currently_": "Huolto on juuri nyt käynnissä.",
	"We apologize for_": "Pahoittelemme häiriötä.",
	"Driver Monitoring System (DMS)": "Kuljettajan seurantajärjestelmä (DMS)",
	"Distracted occurs_": "Tapahtuu, kun kuljettajan pää on yli 50 astetta eteenpäin.",
	"Hand distraction event occurs_": "Tapahtuu, kun kuljettajan käsi havaitaan pidemmän aikaa pään lähellä (kuten tupakoidessa, puhelimen pitämisessä jne.).",
	"Mask off event occurs_": "Tapahtuu, kun kuljettaja astuu ajoneuvoon ilman maskia tai kun kuljettaja ottaa maskin pois päältä.",
	"DMS setting": "DMS-asetus",
	"The DMS system has_": "DMS yhdistää kasvojen tunnistusrasian tiloihin \"Tunnistettu\", \"Tunnistamaton\", \"Häiriintynyt\", \"Uneliaisuus\", \"Maski pois\" ja liikkeen tunnistusrasian tilaan \"Käden häiriö\".",
	"DMS detection": "DMS-tunnistus",
	"There are detection criteria for_": "Jokaiselle tapahtumalle on omat havaitsemiskriteerit. Katso ohjeet alta.",
	"DMS camera recording_onoff": "Päällä: DMS-kamera tallentaa Pysäköintitilassa niin kauan kuin virta on kytketty päälle. <br/> Pois päältä: DMS-kamera sammuu pian Pysäköintitilaan siirtymisen jälkeen.",
	"LED lighting for each event_": "Kuljettajan valvontakameran LED ilmaisee jokaisen havaitsemistapahtuman (Häiriö, Uneliaisuus jne.).",
	"Drowsy and Distracted each have_": "Unelias- ja Häiritty-tunnistuksia varten on olemassa kolme herkkyystasoa.\n \n Katso ohjenäyttö alta.",
	"DMS event detection sensitivity": "DMS-tapahtuman tunnistuksen herkkyys",
	"Only drowsy and distracted include_": "Vain unelias- ja häiritty-tunnistuksille on määritetty herkkyystasot. Lisäksi asetettu herkkyys on sama kahdelle tapahtumalle, joilla on sama asetus.",
	"When driver’s eyes close_": "Tapahtuu, kun kuljettaja sulkee molemmat silmät ajon aikana yli 1 sekunnin ajan tai haukottelee 2 sekunnin ajan.\n",
	"n digit": "{{a}} numeroa",
	"You are subscribed_free_Smart": "Sinulla on BlackVue Cloud -palvelun Smart Plan.",
	"Wi-Fi auto turn on": "Wi-Fi-yhteyden automaattinen käynnistys",
	"Video on a map": "Video on a map",
	"This feature is only_vom": "This feature is only available to users with a Fleet Plan subscription.<br/>Please subscribe to a plan to unlock this feature.",
	"Total n days_": "Yhteensä {{a}}päivää ilmaista kokeilua",
	"Every events of DMC200_": "DMS-havaitsemistoiminnot ovat aktiivisia vain Normaalitilassa. Jos se on kytketty Pysäköintitilaan, DMS-kamera tallentaa vain videon.",
	"An undetected event occurs_": "Tapahtuu, kun kuljettajaa ei havaita kameran edessä 1 minuutin ajan.",
	"A detected event occurs_": "A detected Event occurs when the driver is gazing in front since the power is set in the beginning.",
	"Drowsy sensitivity_": "High : When the driver closes their eyes for more than 1 second, it is considered drowsy driving.<br/><br/>Medium : When the driver closes their eyes for more than 1.5 second, it is considered drowsy driving.<br/><br/>Low : When the driver closes their eyes for more than 2 second, it is considered drowsy driving.",
	"Distracted sensitivity_": "High : If the angle of the head is more than 50 degrees away from the front for 3 seconds, it is detected as Distracted.<br/><br/>Medium : If the angle of the head is more than 50 degrees away from the front for 5 seconds, it is detected as Distracted.<br/><br/>Low : If the angle of the head is more than 50 degrees away from the front for 7 seconds, it is detected as Distracted.",
	"Start your subscription now": "Aloita tilauksesi nyt",
	"Free trial period has expired": "Ilmainen kokeilujakso on päättynyt",
	"1 data plan will start from_": "Tietosuunnitelma alkaa kohdasta {{a}} sisältäen 1 Gt tietoja Blackvue SIM-korttia varten.",
	"Allow the BlackVue_": "Sallitko, että BlackVue-sovellus käyttää autokamerasi GPS-tietoja?",
	"We use this_": "Käytämme tätä ajoneuvon nopeuden ja sijainnin seurantaan.",
	"You can edit_": "Voit muokata GPS-käyttöasetuksia milloin tahansa kohdasta BLACKVUE CLOUD > Kamera-asetukset > Tietosuoja-asetukset.",
	"SIM cards": "SIM-kortit",
	"Subscription status": "Tilauksen tila",
	Upgrades: Upgrades$c,
	"Upgrade plan": "Päivitä ohjelma",
	"Manage plan": "Hallinnoi tilaussuunnitelmaa",
	"Next plan": "tilaussuunnitelma seuraavalle kuukaudelle",
	OR: OR$c,
	"Cancel subscription": "Peruuta tilaus",
	Undo: Undo$c,
	Invoice: Invoice$c,
	"Daily usage": "Päivittäinen tiedonsiirto",
	"Delete SIM": "SIM Poista",
	"New card": "Uusi luottokortti",
	data: data$c,
	"SIM card data_": "SIM-kortin datatilaus voidaan peruuttaa osoitteessa <a>sim.blackvuecloud.com</a>.",
	"Your plan from_": "Aikataulusi tästä päivästä seuraavaan veloituspäivään",
	"Applied during_": "Käytössä välillä {{a}} ~ {{b}}",
	"From today until_": "Tästä päivästä seuraavaan maksupäivään voit tilata vain edellisen kuukauden suunnitelmaa vastaavan suunnitelman. Tämän jakson maksut veloitetaan tänään <a>Maksut lasketaan tuottojen osituksen pohjalta.</a>",
	"Choose your next plan": "Valitse seuraava suunnitelma",
	"Applied from_": "Käytössä alkaen {{a}}",
	"Payment for this_": "Tämän suunnitelman maksu veloitetaan {{a}}.",
	"By sharing your_2": "Live-katselun avulla voit jakaa ajokokemuksesi muiden kaikkialla maailmassa olevien käyttäjien kanssa. Koska jakamisen yhteydessä saatetaan lähettää henkilökohtaisia tietoja, sinun tulee päättää erityisen huolellisesti, mitä tietoja haluat jakaa.",
	"Option camera recording_": "Valinnaisen kameran tallennus pysäköintitilassa",
	"Front and option camera_": "Etukamera ja valinnainen kamera tallentavat yhdessä.",
	"Option camera stops_": "Valinnainen kamera lopettaa tallentamisen 5 min kuluttua pysäköintitilaan siirtymisestä. Tallennus alkaa, kun siirrytään normaalitilaan.",
	"Option camera rotation": "Valinnaisen kameran kierto",
	"Option camera": "Valinnainen kamera",
	"Option camera security": "Valinnaisen kameran turvallisuus",
	"Resubscribe until_": "Tilaa uudelleen seuraavaan asti: {{a}}",
	"Firmware Update Caution": "Laiteohjelmiston päivityksen varoitus",
	"Please check below_": "Tarkista alla olevat olosuhteet ennen DMC200:n laiteohjelmiston päivitystä:",
	"The camera's Wi-Fi_": "Kameran Wi-Fi-yhteyden on oltava päällä.",
	"Check if your_": "Tarkista, että kameran WI-FI-yhteys on päällä.",
	"DO NOT disconnect_": "ÄLÄ irrota koaksiaalikaapelia laiteohjelmiston päivityksen aikana.",
	"The camera and_": "Kamera ja DMC200 voivat rikkoutua.",
	"DO NOT try_": "ÄLÄ yritä käyttää muita toimintoja, ennen kuin kamera on käynnistynyt uudelleen.",
	"Expecially Reboot camera_": "Erityisesti kameran uudelleenkäynnistys ja SD-kortin alustus voivat olla kriittisiä ja rikkoa kaksi laitetta.",
	"Update anyway": "Päivitä kuitenkin",
	"Invited on_2": "olet kutsunut {{Invited Date}}. Omistaja",
	"BlackVue’s New firmware_": "BlackVuen uusi laiteohjelmisto on saatavilla",
	"valid thru_": "voimassaolo päättyy: {{a}}",
	"Billed monthly": "Billed monthly",
	"90 minutes Live_": "90 minutes Live View / Live Event Upload*",
	"or 2+ videos_": "or 2+ videos in full resolution*",
	"1GB Free Month_": "1GB Free Month Trial",
	"Cancel anytime": "Cancel anytime",
	"8+ hours Live_": "8+ hours Live View / Live Event Upload*",
	"or 12+ videos_": "or 12+ videos in full resolution*",
	"15+ hours Live_": "15+ hours Live View / Live Event Upload*",
	"or 23+ videos_": "or 23+ videos in full resolution*",
	Popular: Popular$c,
	"For Power Users": "For Power Users",
	"Estimates based on_": "* Estimates based on 4.5MB per minute of Live View, Quick View remote playback, or Live Event Upload file, and 190MB per full original resolution video download or playback (at 25Mbps bitrate). Daily idle Cloud connection data usage: 20MB per 24 hours. Data usage is shared among all types of services (Live View, Live Event Upload, etc.).",
	"Balanced Plan": "Balanced Plan",
	"For Light Cloud_": "For Light Cloud Use",
	"Front security (Normal mode)": "Etupuolen turvavalo (normaali tila)",
	"Front security (Parking mode)": "Etupuolen turvavalo (pysäköintitila)",
	"BT (Parking mode)": "BT (pysäköintitila)",
	"LTE (Parking mode)": "LTE (pysäköintitila)",
	"Wi-Fi (Parking mode)": "Wi-Fi (pysäköintitila)",
	"Hand distraction": "Häiritsevä käsi",
	Mask: Mask$c,
	"Second drowsy is_": "Toinen uneliaisuushälytys annetaan, kun uneliaisuus esiintyy 30 sekunnin kuluessa ensimmäisestä uneliaisuuden tunnistuksesta, joka aloitti tapahtuman tallennuksen.",
	"Second drowsy alert": "Toinen uneliaisuushälytys",
	"BlackVue sim card_": "BlackVuen sim-korttia voidaan käyttää vain Kanadassa ja Yhdysvalloissa.",
	"Global support is coming soon.": "Maailmanlaajuinen kattavuus on tulossa pian.",
	"The video file not found_": "Videotiedostoa ei löydy tai toistossa tapahtui virhe. Yritä uudelleen.",
	"Start Voice Call": "Aloita äänipuhelu",
	"End Voice Call": "Lopeta äänipuhelu",
	"Voice call in use": "Äänipuhelu käytössä",
	"Enable microphone access_": "Ota mikrofoni käyttöön käyttääksesi kaksisuuntaista kommunikaatiotoimintoa. Siirry selaimen asetussivulle mikrofonin käyttämiseksi.",
	"You may need to_": "Tämä sivu on ehkä ladattava uudelleen, jotta uudet asetukset tulevat voimaan.",
	"Eye status": "Silmien tila",
	"Start time of live event upload video": "Reaaliaikaisen tapahtuman videon latauksen aloitusaika",
	"Left eye": "Vasen silmä",
	"Right eye": "Oikea silmä",
	"Drowsy is occured when the driver close his/her eyes more then 1sec": "Uneliaisuus esiintyi, kun kuljettaja sulki silmänsä yli 1 sekunnin ajaksi",
	"Driver's Left eye movements with blinking count and period": "Kuljettajan vasemman silmän liikkeet ja silmänräpäytysten määrä, jaksojen määrä ja jakso",
	"Driver's Right eye movements with blinking count and period": "Kuljettajan oikean silmän liikkeet ja silmänräpäytysten määrä ja jakso",
	"Drowsy big data of the driver and after a Drowsy event occurs": "Kuljettajan silmänräpäytystiedot uneliaisuus-tapahtuman esiintymisen jälkeen",
	"Sharing video to Event Map": "Videon jakaminen tapahtumakarttaan",
	"Want to use a Voice call?": "Haluatko käyttää äänipuhelua?",
	"To use a voice call_": "Kun haluat käyttää äänipuhelua, käynnistä Live-näkymä uudelleen ja napsauta “Salli”",
	"There is no_": "Jaettuja videoita ei vielä ole. \nLuettelo tulee esiin, kun se on jaettu.",
	"Microphone blocked": "Mikrofoni estetty",
	"Want to center the map on your location?": "Haluatko keskittää kartan sijaintiisi?",
	"To let the app access your location_": "Anna sovellukselle pääsy sijaintiisi käynnistämällä Event Map uudelleen ja valitsemalla \"OK\" pyydettäessä.",
	"Location access permission required": "Sijainnin käyttöoikeus vaaditaan.",
	"Are you sure you want_2": "Haluatko varmasti poistaa tämän videon Event Mapista?",
	"Two-way voice_2": "Two-way voice communication / Voice Call",
	"Not supported by DR650GW and DR650S_": "Not supported by DR650GW and DR650S",
	"DR650S Series only_": "DR650S Series only",
	"Cancel download?": "Peruutetaanko lataus?",
	"Your download is not_": "Latauksesi ei ole valmis. Haluatko peruuttaa latauksen?",
	"Continue download": "Jatka lataamista",
	"Cancel download": "Peruuta lataus",
	"Share your video to the Event Map?": "Jaetaanko videosi tapahtumakarttaan?",
	"Afterwards, according to the reaction to the video_": "Jälkeenpäin video voidaan luokitella reaktion perusteella suosituksi videoksi ja näyttää kartan Suositut videot -luettelossa.",
	"Add hashtags and a brief description to describe your video.": "Lisää videoon hashtageja ja lyhyt kuvaus.",
	"Would you like_": "Haluatko jakaa tapahtumakarttaan?",
	"Successfully added video_": "Video on lisätty onnistuneesti jaettaviksi tapahtumakarttaan!",
	"This video cannot_": "Tätä videota ei voi jakaa, koska siitä puuttuvat GPS-sijaintitiedot, jotta se voitaisiin sijoittaa kartalle.",
	"This video is_": "Tämä video on jo lisätty tapahtumakarttaan.",
	"Share to Event Map": "Jaa tapahtumakarttaan",
	"Describe in more_": "Kuvaile tarkemmin, mitä videossasi tapahtuu (valinnainen)",
	"Description(optional)": "Kuvaus (valinnainen)",
	"Recording mode": "Tallennustilat",
	"Event triggers": "Tapahtumakäynnistimet",
	DMS: DMS$c,
	"Camera connectivity": "Kameran liitettävyys",
	"If not allowed_2": "Jos tätä ei sallita, autosi sijainti ja nopeus eivät ole käytettävissä pilvipalvelun kautta.",
	"Share Live View_": "Jaa live-näkymän video",
	"Share Live View_2": "Jaa liven-näkymän ääni",
	"Share camera profile": "Jaa kameraprofiili",
	"Parking impact": "Isku pysäköitynä",
	"Parking events": "Parking Events",
	"Audio recording": "Äänen tallennus",
	"Toggle the mic_": "Kytke mikrofoni PÄÄLLE / POIS PÄÄLTÄ",
	"Full HD_": "Full HD @ 60fps + Full HD @ 30fps",
	"Video quality": "Videon laatu",
	Extreme: Extreme$c,
	"More video files": "Lisää tallennustiedostoja",
	"Fewer video files": "Vähemmän tallennustiedostoja",
	"Camera rotation": "Takakameran kierto",
	"Video overlay": "Videon peittokuva",
	"Date & time display": "Päivämäärän ja ajan näyttäminen",
	"Speed unit": "Nopeuden yksikkö",
	"Check the orientation_": "Tarkista ajoneuvoon asennetun etukameran asento. Valitse vastaava vaihtoehto tallentaaksesi videoita pystysuunnassa.",
	"Rotate 180º": "Kierrä 180º",
	"Rear camera rotation": "Takakameran kierto",
	"Check the orientation_rear": "Tarkista ajoneuvoon asennetun takakameran asento. Valitse vastaava vaihtoehto tallentaaksesi videoita pystysuunnassa.",
	"Mirror View": "Peilinäkymä",
	"Select Mirror View_": "Valitse Peilikuva kääntääksesi videon vaakatasossa.",
	"Check the orientation_interior": "Tarkista ajoneuvoon asennetun valinnaisen kameran asento. Valitse vastaava vaihtoehto tallentaaksesi videoita pystysuunnassa.",
	"Display off": "Näyttö pois päältä",
	"Explore crowd-sourced Events_": "Tutustu yleisölähtöisiin tapahtumiin (isku, kova jarrutus jne.) kartalla, katso yhteisön jakamia videoita ja jaa omia tapahtumiasi.",
	OFF: OFF$c,
	"Reboots once-a-day_": "Käynnistyy uudelleen kerran päivässä samaan aikaan vakauden parantamiseksi, jos laite on pysäköintitilassa.",
	"Set time": "Aseta aika",
	"FW language": "Laiteohjelmiston kieli",
	"Rear security_2": "Takaosan turvallisuus",
	"Bluetooth (Parking mode)_2": "Bluetooth (pysäköintitila)",
	"Failed to save_2": "Live-tapahtumien latausasetusten tallennus epäonnistui",
	"Event file will_": "Tapahtumatiedosto tallennetaan automaattisesti live-tapahtumien lataustallennustilaan.",
	"An impact was_": "An Impact was detected during Parking Mode.",
	"When exiting Parking_": "Pysäköintitilasta poistuttaessa BlackVue ilmoittaa, jos pysäköintitilassa havaittiin isku. \n\n Huomautuksia: \n Iskuista luodaan tapahtumavideoita. Iskut, jotka havaitaan 3 minuuttia ennen pysäköintitilasta poistumista tai sen jälkeen, jätetään huomiotta.",
	"Protect event files": "Suojaa tapahtumatiedostot",
	"Turning on this_": "Ota käyttöön suojataksesi {{a}} viimeisintä tapahtumatiedostoa korvaamiselta normaaleilla tallennustiedostoilla tai pysäköintitallennustiedostoilla.",
	"Impact Events in_": "Impact Events in Normal(E) and Parking Mode(I)",
	"Manual Events_": "Manual Events (M)",
	"Once 50 Events_": "Suojattuihin tiedostoihin sisältyvät seuraavat: \n\nIskutapahtumat normaalissa tilassa (E) ja pysäköintitilassa (I) \nManuaaliset tapahtumat (M) \n\n{{a}} tapahtuman tallennuksen jälkeen uudet tapahtumat korvaavat vanhimmat tapahtumat.",
	"Reckless driving unit": "Holtittoman ajamisen yksikkö",
	"Hard acceleration Event": "Kova kiihtyvyys -tapahtuma",
	Threshold: Threshold$c,
	"Triggers when the_": "Käynnistyy, kun kamera havaitsee kiihtyvyyden ylittävän asetetun raja-arvon sekunnissa.",
	"Triggers when the_2": "Käynnistyy, kun kamera havaitsee nopeuden laskevan asetettua raja-arvoa enemmän.",
	"Hard braking Event": "Kova jarrutus -tapahtuma",
	"Triggers when more_": "Käynnistyy, kun yli 60 astetta havaitaan 2 sekunnin kuluessa ajettaessa yli asetetun raja-arvon.",
	"Every event of DMC200_2": "DMS-havaitsemistoiminnot ovat aktiivisia vain Normaalitilassa. Jos se on kytketty Pysäköintitilaan, DMS-kamera tallentaa vain videota.",
	"The DMS system has_2": "DMS yhdistää kasvojen tunnistusrasian tiloihin “Tunnistettu”, “Tunnistamaton”, “Häiriintynyt”, “Uneliaisuus”, “Maski pois” ja liikkeen tunnistusrasian tilaan “Käden häiriö”.",
	"One for face_": "One for face detection : Detected, Undetected, Distracted, Drowsy",
	"The other for_": "The other for motion detection",
	"On: Normal recording_": "On: Normal recording works while power is maintained in Parking Mode",
	"Off: DMS power_": "Off: DMS power off after 5 minutes when entering Parking Mode, Normal recording works until just before off",
	"Drowsy and Distracted_": "Drowsy and Distracted each have three sensitivity conditions.",
	"Please refer to_": "Please refer to the guide interface below.",
	Drowsiness: Drowsiness$c,
	"Drowsiness occurs when_": "Uneliaisuus ilmenee, kun kuljettaja sulkee molemmat silmänsä ajon aikana yli 1 sekunniksi ja haukottelee 2 sekunnin ajan.",
	"Distracted occurs when_": "Tapahtuu, kun kuljettajan pää on yli 50 astetta eteenpäin.",
	"A hand distraction_": "A hand distraction occurs when the driver removes one hand from the steering wheel. [*Smoking and phone calls may be suspected.]",
	"Mask off event_": "Mask-off event occurs in two ways. First is when the driver gets in the car without a mask. Second is when the driver takes their mask off",
	"High When the_": "High : When the driver closes their eyes for more than 1 second, it is considered drowsy driving.",
	"Middle When the_": "Medium : When the driver closes their eyes for more than 1.5 second, it is considered drowsy driving.",
	"Low When the_": "Low : When the driver closes their eyes for more than 2 second, it is considered drowsy driving.",
	"High If the_": "High : If the angle of the head is more than 50 degrees away from the front for 3 seconds, it is detected as Distracted.",
	"Middle If the_": "Medium : If the angle of the head is more than 50 degrees away from the front for 5 seconds, it is detected as Distracted.",
	"Low If the_": "Low : If the angle of the head is more than 50 degrees away from the front for 7 seconds, it is detected as Distracted.",
	Direct: Direct$c,
	"Camera Wi-Fi credentials": "Kameran Wi-Fi-tunnistetiedot",
	"Network name(SSID)": "Verkon nimi (SSID)",
	"Seamless pairing": "Seamless Pairing",
	Remote: Remote$c,
	"Hotspot settings": "Tukiasema-asetukset",
	"Hotspot name": "Tukiaseman nimi (SSID)",
	"Hotspot name must_": "Hotspot name must be at least 5 characters long",
	"Public cameras may_": "Julkinen kameroita saattaa näkyä Tutustu-välilehdellä tai maailmankartassa.",
	"Hard Cornering Event": "Kova kaarre -tapahtuma",
	"Over speed_2": "Ylinopeus",
	"Second drawiness alert": "Toinen uneliaisuushälytys",
	"Low Voltage Warning_2": "Häiritsevä käsi",
	"(You)_2": "{{a}} (sinä)",
	"This video has been reported_": "Tästä videosta on tehty ilmoitus ja järjestelmänvalvoja on poistanut sen.",
	"Normal Mode recording": "Normaalitila tallennus",
	"ON : the camera_": "PÄÄLLÄ: kamera tallentaa jatkuvasti silmukkatallennuksena.",
	"OFF : the camera_": "POIS PÄÄLTÄ: kamera tallentaa vain tapahtumavideoita ajon aikana.",
	"In both modes_": "Tunnistetut iskut käynnistävät kummassakin tilassa tapahtumavideon tallennuksen.",
	"Continuously records_": "Tallentaa jatkuvasti minuutin mittaisia videoita, joissa on yksi kuva sekunnissa ja jotka kattavat 30 minuuttia toimintaa.",
	"Choose detection regions_": "Valitse tunnistusalueet vähentääksesi tuulessa heiluvien puiden, kaukana liikkuvien kohteiden jne. aiheuttamien ei-toivottujen liiketallenteiden riskiä.",
	"Your previous plan is expired.": "Edellinen tilausohjelmasi on vanhentunut.",
	"Upgrade the plan to restore the camera": "Päivitä ohjelma palauttaaksesi kameran\n(%@)",
	"Remove from cloud": "Poista pilvestä",
	"Are you sure you want to Remove_": "Haluatko varmasti poistaa tämän pilvipaikasta?",
	"Remove: It doesn’t mean_": "Poista: se ei tarkoita kameran tietojen poistamista, vaan vapaan paikan luomista pilvikameroita varten.",
	"Now the camera is removed from cloud slot": "Kamera poistettiin pilvipaikasta.",
	"How to delete camera list": "Kameran poistaminen luettelosta",
	Update: Update$c,
	"Camrea setting": "Kameran asetukset",
	"Notification setting": "Pikailmoitusten asetukset",
	"Driving reports": "Ajoraportti",
	"Cloud connection steps": "Pilviyhteyden vaihe",
	"Download the BlackVue app to add a camera": "Lisää kamera lataamalla BlackVue-sovellus",
	"To see your camera in the BlackVue cloud viewer_": "Jos haluat nähdä kamerasi BlackVue Cloud Viewer -ohjelmassa, sinun on ensin yhdistettävä se pilvitallennustilaan. Määritä helposti BlackVue kamerasi ja yhdistä se pilvitallennustilaan iOS:lle ja Androidille julkaistulla BlackVue-sovelluksella.",
	"Download the BlackVue app to see a Wi-Fi connected camera": "Lataa BlackVue-sovellus nähdäksesi Wi-Fi-verkkoon yhdistetyn kameran",
	"BlackVue Cloud web viewer only supports_": "BlackVue Cloud Web Viewer tukee vain pilvipohjaisia autokameroita. Lataa BlackVue-sovellus nähdäksesi Wi-Fi-verkkoon yhdistetyn autokamerasi.",
	"You can restore the data if_": "Voit palauttaa tiedot, jos rekisteröit kameran uudelleen samalle tilille, mutta jos tili on poistettu, kaikki tiedostot menetetään.",
	"How to add camera": "Kameran lisääminen",
	"Try to wait 2-3 minutes if you just registered the camera.": "Odota 2–3 minuuttia, jos olet juuri rekisteröinyt kameran.",
	"Try to check the Cloud Connection Settings again_": "Yritä tarkistaa Pilviyhteyden asetukset uudelleen, jos kamera ei vieläkään muodosta yhteyttä pilvitallennustilaan.",
	"Motion Detection": "Liikkeentunnistus",
	"Parking recordings occur_": "Pysäköintitallenteita tallennetaan, kun näkyvää liikettä havaitaan.",
	"Motion Sensitivity": "Liikeherkkyys",
	"Motion Detection Sensitivity": "Liiketunnistimen herkkyys",
	"Select Detection Region": "Valitse havaitsemisalue",
	"Speed alert_2": "Nopeusvaroitus",
	"Live Event Upload_2": "Live Event Upload",
	"Beep Alert": "Merkkiäänihälytys",
	"Parking Impact History_": "Pysäköinnin iskuhistoriahälytys",
	"To register your_": "Rekisteröidäksesi SOS-painikkeen, sinun on käytettävä BlackVue-sovellusta.",
	"SOS button on/off": "SOS-painikkeen tila",
	"File sharing to Event Map is_": "Tiedostojen jakaminen Tapahtumakarttaan ei ole tällä hetkellä käytettävissä. Tarkista myöhemmin uudelleen.",
	"Email Notifications": "Sähköposti-ilmoitukset",
	"Push Notifications_2": "Pikailmoitukset",
	"Optional Camera Rotation": "Valinnaisen kameran suunta",
	"Optional Camera Security": "Valinnaisen kameran turvallisuus",
	Option: Option$c,
	"(Owner)": "{{a}} (Omistaja)",
	"SOS button": "SOS-painike",
	"This video has been reported_bold": "Tästä videosta on tehty ilmoitus ja <b>järjestelmänvalvoja on poistanut sen.</b>",
	"Number of events_2": "Tapahtumien määrä",
	"My Shared Videos": "Jaetut videoni",
	"No Hashtags": "Ei hashtageja",
	"I have read and agree_": "Olen lukenut kaikki ehdot sekä käytännöt ja hyväksyn ne",
	"14 years old_": "14-vuotias tai vanhempi",
	Required: Required$c,
	Optional: Optional$c,
	"Profile information_": "Profiilin tietoja voi muokata Tiliasetukset-sivulla.",
	"Automatically Add Live_": "Automaattinen tapahtumien lähetystiedostojen jakaminen tapahtumakarttaan",
	"You must be 14 years_": "Sinun on oltava vähintään 14-vuotias luodaksesi BlackVue-tilin",
	"Use 8 or more characters_": "Käytä vähintään kahdeksaa merkkiä, joihin sisältyy kirjaimia, numeroita tai symboleita",
	"Protected files include_": "Suojattuihin tiedostoihin sisältyvät seuraavat: <br/>ㆍIskutapahtumat normaalissa tilassa (E) ja pysäköintitilassa (I) <br/>ㆍManuaaliset tapahtumat (M) <br/><br/>{{a}} tapahtuman tallennuksen jälkeen uudet tapahtumat korvaavat vanhimmat tapahtumat.",
	"Protected files include": "Protected files include",
	"If you turn_": "Jos poistat ääniohjauksen käytöstä, seuraavat luettelot ovat pois käytöstä.",
	"Live Event Upload_success": "Live-tapahtumien latausasetukset tallennettu onnistuneesti.",
	"Video type": "Videotyypit",
	"Notify the Owner": "Ilmoita omistajalle",
	"Adjusting the cut-off voltage_2": "Adjusting the cut-off voltage to a lower setting may result in your dash cam draining more power from your battery. This could result in warning messages of battery drain or affect other vehicle functions.\nPlease consult with your dealership before lowering the voltage.",
	Others: Others$c,
	"This video has been removed.": "Tämä video on poistettu.",
	"Please assign cameras_": "Määritä kameroita tähän ryhmään.",
	"Are you running_": "Onko sinulta loppumassa mahdollisuus katsoa toistoa?",
	"Upgrade your plan_": "Päivitä tilauksesi Fleet Plan -ohjelmaan rajoittamatonta toistoa ja muita pilvipalvelun yksinomaisia ominaisuuksia varten.",
	"Are you running_Liveview": "Onko sinulta loppumassa aika live-katseluun?",
	"Upgrade your plan_Liveview": "Päivitä tilauksesi Fleet Plan -ohjelmaan rajoittamatonta live-katselua ja muita pilvipalvelun yksinomaisia ominaisuuksia varten.",
	Stay: Stay$c,
	"Go to Fleet Plan": "Siirry Fleet Plan -ohjelmaan",
	"It looks like the video file is being prepared. please try again later.": "Näyttää siltä, että videotiedostoa valmistellaan. yritä uudelleen myöhemmin.",
	"Oops!": "Oho!",
	"Please back up_": "Varmuuskopioi kaikki tärkeät tallenteet ennen tämän asetuksen muuttamista.",
	"When you save_": "Kun tallennat asetukset, microSD-kortti alustetaan ja kaikki tallenteet poistetaan vakaan toiminnan varmistamiseksi.",
	"This is an unregistered_": "Tämä on rekisteröimätön sähköposti. Haluatko siirtyä Luo tili -sivulle?",
	"Camera name must_2": "Kameran nimen on oltava 5–32 merkkiä.",
	"G-sensor (Normal mode)": "G-anturi (normaalitila)",
	"G-sensor (Parking mode)": "G-anturi (pysäköintitila)",
	"Up & down": "Ylös ja alas",
	"Front & back": "Eteen ja taakse",
	"Rotate Video 180º": "Rotate Video 180º",
	Mask_2: Mask_2$c,
	"Priority event": "Priority Event",
	"There is no_camera": "There is no camera that your owner assigned to you.",
	"Camera SSID": "Camera SSID",
	"The BlackVue dashcam_2": "The BlackVue dashcam is not compatible with 5GHz wireless networks",
	"Driver detection box_2": "Driver Detection Box",
	"DMS camera recording_2": "DMS Camera Recording in Parking Mode",
	Low_2: Low_2$c,
	Medium_2: Medium_2$c,
	High_3: High_3$c,
	"Live Event Upload_3": "Live Event Upload",
	"Driving Impact": "Driving Impact",
	"Video source_2": "Video Source",
	"Front camera_2": "Front Camera",
	"Rear camera_2": "Rear Camera",
	"Optional Camera": "Optional Camera",
	"Motion Detection_2": "Motion Detection",
	"Rear camera stops_2": "Rear camera stops recording 5 minutes after entering Parking Mode. Recording restarts when entering normal mode.",
	"Passenger vehicle": "Passenger Vehicle",
	"Heavy vehicle": "Heavy Vehicle",
	Highest_3: Highest_3$c,
	Extreme_2: Extreme_2$c,
	"Less recording files": "Fewer Recording Files",
	"Camera rotation_2": "Camera Rotation",
	"Share camera profile_2": "Share Camera Profile",
	Private_2: Private_2$c,
	"BlackVue Live": "BlackVue Live",
	"Important All saved_": "Important! All saved videos are about to be deleted. Tap Cancel and back up important files if needed.",
	"Whenever saving settings_": "Whenever saving settings after changing the time zone, the SD card is initialized and all stored files are deleted.",
	"Do you want_": "Do you want to save your changes?",
	"No groups": "No groups",
	Lite: Lite$c,
	"USD per Camera": "USD per extra Camera",
	"up to Cameras": "up to Cameras",
	"All the P Plan_": "Kaikki <b>{{a}}</b> -suunnitelman ominaisuudet, lisäksi:",
	"User Roles and Permissions": "Käyttäjäroolit ja oikeudet",
	"Geofence Setup (Web) and alerts": "Geofence Setup (Web) and alerts",
	"N Times": "{{a}} Kertaa",
	"N Minutes": "{{a}} Minuuttia",
	"Emergency Alarm": "Hätähälytys",
	"Playback, Live View": "Toisto, Live View",
	"Your driving record : Daily, Monthly": "Ajohistoriasi: Päivittäin, Kuukausittain",
	"Real-time Conversation": "Reaaliaikainen keskustelu",
	"Initiate a conversation_": "Aloita keskustelu kuljettajan kanssa Dashcamin kaiuttimen ja mikrofonin kautta.",
	"Remote Voice Communication": "Etäviestintä",
	"See the last location_": "Katso kameran viimeinen sijainti",
	"Check your cars_": "Tarkista autosi reaaliaikaiset GPS-tiedot kartalla paikantaaksesi ajoneuvosi ja saadaksesi tietoa sen tilasta, kuten se ajaa vai pysäköityjä, ja nopeuden.",
	"Supported models_": "* Tuetut mallit: S ja varhaiset X -sarjan mallit",
	"GPS Tracking &_": "GPS -seuranta ja video kartalla (älykäs/laivasto)",
	"Track your cars_": "Seuraa auton sijaintia ja nopeutta kartalla!",
	"GPS Tracking: visualize_": "GPS -seuranta: Visualisoi ajo loki kartalla.\nVideo kartalla: Näytä asiayhteystiedot (nopeus, tapahtumatyyppi) ja toista niihin liittyviä videoita suoraan kartalta.",
	"Visualize your cars_": "Visualisoi autosi sijainti ja nopeus kartalla!",
	"The feature enables_": "Tämä ominaisuus mahdollistaa videomateriaalin lataamisen pilveen, mukaan lukien 5 sekuntia ennen onnettomuutta.",
	"Camera profile setting": "Camera profile setting",
	"Are you running_Download": "Are you running out of chance to Download Video?",
	"Upgrade your plan_Download": "Upgrade your plan to Fleet Plan for Unlimited Download, and other Cloud -Exclusive features.",
	"This feature is available for Smart and Fleet_": "This feature is available for Smart and Fleet Plan subscribers only.",
	"Rear camera will keep_": "Takakamera lopettaa tallentamisen pysäköintitilassa, kun dashcamin lämpötilatila vaihdetaan \"Korkeaan lämpötilaan\". Takakamera aloittaa tallentamisen uudelleen sen jälkeen, kun dashcamin lämpötilatila on vaihdettu \"Normaaliin lämpötilaan\". (Huomio: Elektroniikan suojelemiseksi Blackvue saattaa sammua korkean ulkolämpötilan vuoksi.)",
	"Get Unlimited Cloud_": "Saat rajattoman pilvitoiston ja hallinnoi jopa {{a}} kameraa.",
	"Up to N cameras_": "Up to {{a}} cameras (+ {{b}} USD Extra charge)",
	"N Minutes per Day": "{{a}} minuuttia päivässä",
	"Drowsiness sensitivity is_": "Uneliaisuuden herkkyys asetetaan silmänräpäytyksen ajan mukaan BlackVue-algoritmin avulla. <br> <br> Häiritty-tilanteen herkkyys asetetaan etupuolelta määritetyn kuljettajan pään kulma-asennon mukaan ja tämän asennon keston mukaan.",
	"Not available with this plan": "Not available with this plan",
	"The optional camera records_": "Valinnainen kamera tallentaa pysäköintitilassa",
	"Smart and Fleet_": "Smart and Fleet Plan<br/>subscribers only",
	"This feature is_smart": "This feature is available for Smart and Fleet Plan subscribers only.",
	"Camera Registration": "Kameran rekisteröinti",
	"Voice Call": "Voice Call",
	"N times per Month": "{{a}} times per Month",
	"Recommended for higher bitrate_": "Suositellaan korkeammalle bittinopeudelle ja paremmalle videon laatulle.",
	"Recommended for for better compatibility_": "Suositellaan parempaa yhteensopivuutta työpöydän ja mobiililaitteiden kanssa",
	"A minute of front camera_": "Arvioitu tiedostokoko 1 minuutin videolle (etukamera)",
	"Extreme(N Mbps): N MB_": "Extreme ({{ex1}}Mbps) : {{ex2}}MB\nHighest ({{ht1}}Mbps) : {{ht2}}MB\nHigh ({{hi1}}Mbps) : {{hi2}}MB\nNormal ({{no1}}Mbps) : {{no2}}MB",
	"File size information reflects_": "Tiedostokokotiedot heijastavat mahdollisen suurimman koon ja todelliset tiedostokoot riippuvat tallennusolosuhteista.",
	Bitrate: Bitrate$c,
	"Connection has been_": "Yhteys on kadonnut.\nYhteyden luominen ...",
	"Unable to establish_": "Ei voi luoda yhteyttä kameraan.\nVarmista, että laite on kytketty oikein ja yritä uudelleen.",
	"Purchased by Payment Service": "Ostettu maksupalvelun kautta",
	"Up to N Cameras": "Enintään {{a}} kameraa",
	"Unlimited Live View": "Rajoittamaton Live-katselu",
	"N Days GPS Tracking": "{{a}} päivän GPS-seuranta",
	"Unlimited Playback and Download": "Rajaton toisto ja lataus",
	hours: hours$c,
	"Live Event Upload or_": "Live Event Upload tai 12+ videota täydellisessä resoluutiossa",
	"During the usage period of the One Plan_": "One Plan -palvelun käyttökauden aikana tilausmuutokset eivät ole mahdollisia. Vaihtaaksesi toiseen suunnitelmaan, ole hyvä ja ota yhteyttä BlackVue asiakastukeen peruaksesi One Plan -tilauksesi.",
	"Service Period (Include SIM Data)": "Palvelujakso (Sisältää SIM-tiedot)",
	"Purchase the BlackVue One Package_": "Osta BlackVue One -paketti avataksesi One Planin ilmaiseksi vuodeksi.",
	"3GB SIM Data Plan": "3GB SIM-tiedot",
	"Unlimited Live View, Playback and Download": "Rajaton Live View, Toisto ja Lataus",
	"within data availability": "datan saatavuuden puitteissa",
	"The BlackVue One Plan is a 1-year_": "BlackVue One Plan on 1-vuotinen pilvipalvelusuunnitelma, joka on saatavilla yksinomaan BlackVue One -paketin ostamisen kautta. Paketti sisältää kojelautakameran, 1-vuotisen 3GB/kk datatarjouksen (USA:han ja Kanadaan) sekä 1-vuotisen pilvipalvelusuunnitelman.",
	"The BlackVue One Package is available_": "BlackVue One -paketti on saatavilla yksinomaan BlackVue-verkkokaupassa.",
	"Go to BlackVue Shop": "Siirry BlackVue-kauppaan",
	"Anonymous Cam": "Anonyymi kamera",
	"App only": "vain sovelluksessa",
	Expires: Expires$c,
	"N days remaining": "Jäljellä {{a}} päivää",
	"No action needed_": "<b>Ei tarvita toimenpidettä.</b> Uusi alennettu hinta otetaan käyttöön automaattisesti seuraavasta maksustasi 13. syyskuuta jälkeen.",
	"The new reduced price_": "Uusi alennettu hinta päivitetään tilillesi automaattisesti.",
	"Smart Plan Subscriber?": "Oletko Smart Plan -tilaaja?",
	"Fleet Plan Subscriber?": "Oletko Fleet Plan -tilaaja?",
	"Please take a moment to_": "Ole hyvä ja anna hetki aikaa valtuuttaaksesi meitä siirtämään tilisi.",
	"Starting from now and_": "<b>Aloittaen nyt ja lokakuun 31. päivään asti</b>, voit antaa meidän tehdä muutoksen puolestasi <a href=\"https://form.jotform.com/232411253056041\" target=\"_blank\">klikkaamalla tätä linkkiä</a> ja syöttämällä Fleet-tilisi sähköpostiosoitteen. Ole hyvä ja anna meille aikaa käsitellä muutosta. Vaihtoehtoisesti voit peruuttaa nykyisen tilisi ja uudelleen tilata uuteen hintaan 13. syyskuuta alkaen.",
	"Once activated_": "Kun aktivoidtu, One Plania ei voi keskeyttää tai poistaa käytöstä.",
	"Once the One Plan is activated_": "Kun One Plan on aktivoitu, One Packagea ei voi palauttaa.\"",
	"Up to N Cloud Camera Slot": "Enintään {{a}} pilvikamerapaikkaa",
	"nGB of Cloud Storage": "{{a}} Gt pilvitallennustilaa",
	"Get started for free_": "Get started for free, no credit card required. Includes Alert Push Notifications, limited Remote Live View and cloud storage.",
	"The BlackVue One Plan is exclusively_": "The BlackVue One Plan is exclusively available through the purchase of a BlackVue One Package. 3GB/mo data plan is for US and Canada only. BlackVue Cloud’s Free Plan, Lite Plan (1~3) and Smart Plan (1~3) accounts can upgrade to One Plan. However, Lite Plan (4~15), Smart Plan (4~15) and Fleet Plan accounts can not be upgraded to One Plan.",
	"For N year": "For {{a}} year",
	"Included in the One Package": "Included in the One Package",
	"3GB SIM Data Plan for N year": "3GB SIM Data Plan for {{a}} year",
	"One Plan Cloud Service for N year": "One Plan Cloud Service for {{a}} year",
	"The BlackVue One Package includes_": "The BlackVue One Package includes all you need to enjoy BlackVue Cloud for a whole year!",
	"4K LTE Dash Cam_": "4K LTE Dash Cam, Cloud Service and Data Plan",
	"nGB included": "{{a}}GB included",
	"nGB per camera": "{{a}}GB per camera",
	"N Days Live Event Upload": "{{a}} Days Live Event Upload",
	"Up to N Dash Cameras": "Up to {{a}} Dash Cameras",
	"Step N/N": "Askel {{a}}/{{b}}",
	"Cloud Connection": "Pilviliitäntä",
	"To pair your dashcam": "Yhdistääksesi autokameran akun kanssa, liitä se pilveen.",
	Check: Check$c,
	"Unpair Battery": "Irrota akku",
	"Are you sure you want to unpair": "Haluatko varmasti irrottaa tämän akun (%@) kamerasta?",
	"Unpair: It doesn't mean": "Poista paritus: Tämä ei tarkoita akun tietojen poistamista.",
	"*The paired battery will": "*Pariliitetty akku poistetaan myös yhdessä.",
	"Would you like to pair this": "Haluatko parittaa tämän akun?",
	"Battery successfully paired": "Akku onnistuneesti pariliitetty.",
	"Now you can directly connect to": "Nyt voit liittää suoraan akkuun kameraluettelosta.",
	"Pairing failed": "Pariliikenne epäonnistui. Yritä uudelleen.",
	"Battery Name": "Akun nimi",
	"Capacity History": "Kapasiteetin historia",
	"The graph displays capacity": "Kaavio näyttää likimääräisen akkutasotietojen käyttäen tietoja pilviliitännästä.\n Akun kapasiteetti voi vaihdella lämpötilan, kojelautakameran asetusten ja laukaisutapahtumien taajuuden mukaan.",
	"Last 24 Hours": "Viimeiset 24 tuntia",
	"Last 7 Days": "Viimeiset 7 päivää",
	"Battery Level": "Akun taso",
	"Temperature History": "Lämpötilahistoria",
	"The graph displays temperature": "Kaavio näyttää likimääräisen lämpötilatason käyttäen dataa pilviliitännästä.",
	"Temperature Level": "Lämpötilataso",
	"Connecting alert": "[ Yhdistetään ]\nTiedot näkyvät yhteyden muodostamisen yhteydessä.",
	"Low Output power Alert": "[ Ulostulotehon katkaisu ]\nLähtöjännite on liian alhainen, mikä rajoittaa kytketyn laitteen virtalähdettä.",
	"High temp Alert": "[ Lähtötehon katkaisu ]\nAkun lämpötila on liian korkea, mikä rajoittaa latausta.",
	"Remaining time": "Jäljellä oleva aika",
	"Remaining time estimate": "Jäljellä oleva aika on arvio, joka perustuu kytkettyjen laitteiden kokonaisvirrankulutukseen.\n Se lasketaan uudelleen joka 30. sekunti akun kytkemisen jälkeen.",
	"Setting changed": "Asetus muuttunut",
	"Setting change failed": "Asetuksen muuttaminen epäonnistui",
	"Low Input power Alert": "[ Lähtötehon katkaisu ]\nLatausjännite on liian alhainen, mikä rajoittaa lataamista.",
	"High Input power Alert": "[ Lähtötehon katkaisu ]\nLatausjännite on liian korkea, mikä rajoittaa latausta.",
	"Low temp_Cut off Alert": "[ Lähtötehon katkaisu ]\nAkun lämpötila on liian alhainen, mikä rajoittaa latausta ja kestoa.",
	"Low temp Alert": "[ Alhainen lämpötila ]\nAkun lämpötila on liian alhainen, mikä rajoittaa käyttöaikaa ja latausnopeutta.",
	"Low capacity Alert": "[ Pieni kapasiteetti ]\nAkun kapasiteetti on liian alhainen.\nAja autoa ladataksesi sen.",
	"Back to list": "Takaisin luetteloon",
	Saving: Saving$c,
	Now: Now$c,
	"Power supplying is limited": "Virtalähteet ovat <b>rajalliset</b>",
	"This battery is already paired": "Tämä akku on jo liitetty.",
	"Connecting to Battery": "Liittäminen akkuun",
	"Paired battery": "Parret batteri",
	"Battery unpairing failed": "Akun pairing gagal dilepaskan. Silakan coba lagi.",
	"A connection is already active": "Yhteys on jo aktiivinen. Yritä uudelleen myöhemmin.",
	"Searching for battery": "Etsitään akkua",
	"Select battery to pair with your camera": "Valitse kameraasi liitettävä akku.",
	"Unable to connect": "Yhteys ei onnistu",
	"A connection error has occurred": "Yhteysvirhe. Yritä uudelleen.",
	"The paired dashcam has been disconnected": "Pariliitetty ajoneuvokamera on irrotettu pilvestä.\nOle hyvä tarkista alla olevat ehdot.",
	"Check if the battery is not fully discharged": "Tarkista, ettei akku ole täysin tyhjentynyt",
	"Check the Cloud connection of the paired dashcam": "Tarkista paritetun kojelautakameran pilvipalvelun yhteys.",
	"Connection lost": "Yhteys katkesi",
	"A connection error has occurred shortly": "Yhteysvirhe tapahtui. Yritä yhdistää pian uudelleen.",
	"Charging is limited": "Lataus on <b>rajoitettu</b>",
	"Cannot connect to the battery": "Ei voida muodostaa yhteyttä akkuun.",
	"Please check the Cloud connection of the camera": "Tarkista kameran pilviliitäntä.",
	"Charging complete in": "Lataus valmis %@",
	"Current Capacity": "Nykyinen Kapasiteetti",
	"Output Voltage": "Lähtöjännite",
	"Charging Voltage": "Latausjännite",
	Beep: Beep$c,
	"Battery Capacity": "Akun kapasiteetti",
	"Battery connection failed": "Akun liittäminen epäonnistui",
	"Expansion battery": "Vara-akku",
	"Make sure it is switched on and within range": "• Varmista, että se on päällä ja matkapuhelimesi kantaman sisällä.",
	"Make sure it is not wirelessly connected to another device": "• Varmista, että sitä ei ole yhdistetty langattomasti toiseen laitteeseen.",
	"Detected batteries": "Tunnistetut akut",
	"Can't see your battery": "Etkö näe akkua?",
	"Download the Blackvue app to check": "Lataa BlackVue-sovellus ja tarkista akkusi etänä",
	"By Using the app": "Sovelluksen avulla voit liittää kojetaulukameran akkuun ja seurata akun kapasiteettia pilven kautta. Parittamisen jälkeen voit tarkistaa akun BlackVue-pilvessä.",
	Unpair: Unpair$c,
	"Occurs when the driver closes_": "Tapauksessa kuljettaja sulkee molemmat silmänsä ajon aikana",
	"Occurs when the driver's head_": "Tapauksessa kuljettajan pää on yli 50 astetta etääntynyt etuosasta.",
	"Only detects distraction above_": "Havaitsee vain häiriöt yli asetetun arvon. Voit muuttaa yksikköä kohdassa \"Kameran asetukset > Tapahtumakäynnistimet > Holtittoman ajamisen yksikkö\".",
	"Occurs when the driver is not wearing_": "Tapauksessa kuljettaja ei käytä turvavyötä.",
	"Overlays a face detection box_": "Päällekkäin kasvontunnistusruutu DMS-kameran suorassa ja tallennetussa kuvamateriaalissa.",
	"Seat Belt": "Turvavyö",
	Detected: Detected$c,
	"No Seat Belt": "Ei turvavyötä",
	"Fatigue Risk Alert": "Väsymysriski-ilmoitus",
	"The time is synchronized_Email": "Aika on synkronoitu sähköposti-ilmoituksissa olevan ajan kanssa.",
	"Sends an alert when drowsiness is_": "Lähettää varoituksen, kun uneliaisuus havaitaan ensimmäisen uneliaisuuden jälkeen.",
	"Data updates upon connection": "Tiedot päivittyvät yhteyden muodostamisen yhteydessä.",
	"Sends a notification if_": "Lähettää ilmoituksen, jos ylität 'Aseta aika' ajon aikana.",
	"Data updates Alert": "[ Yhdistetään ]\nTiedot päivittyvät yhteyden muodostamisen yhteydessä.",
	"Cannot save settings": "Asetuksia ei voi tallentaa",
	"The time is synchronized_Push": "Aika on synkronoitu pikailmoitustesi aikaan.",
	"The file has been overwritten or deleted": "Tiedosto on korvattu tai poistettu.",
	"Box Pro Models Settings": "Box Pro -mallien asetukset",
	"Push notifications can be configured_": "Push-ilmoitukset voidaan määrittää kameran ilmoitusasetuksissa.",
	"Recording Video": "Videonauhoitus",
	"Cameras settings": "Kameran asetukset",
	"Please configure the settings": "Ole hyvä ja määritä asetukset",
	"Speed Priorities": "Nopeusprioriteetit",
	"Set Speed Priority": "Aseta nopeusprioriteetti",
	"Geofence-enter": "Aluerajaus - sisäänmeno",
	"Geofence-exit": "Aluerajaus - ulosmeno",
	"Geofence-pass": "Aluerajaus - läpikulku",
	"Geofence-speed alert": "Aluerajaus - Nopeusvaroitus",
	"Drive Position": "Ajosijainti",
	"Left-Hand Drive": "Vasemmanpuoleinen ohjaus",
	"Right-Hand Drive": "Oikeanpuoleinen ohjaus",
	"Please configure this setting_": "Muokkaa tätä asetusta, jos kuljettajaa ei havaita oikein.",
	"A new feature in the BlackVue settings_": "BlackVue-asetuksiin on lisätty uusi ominaisuus kameran ajan synkronoimiseksi. Sinun tulee synkronoida kameran aika kerran tarkkaa ajan tallennusta varten.",
	"Feature location_": "Ominaisuuden sijainti:\nKameran asetukset > Järjestelmä > Aikasynkronointi",
	"Time Sync": "Aika synkronointi",
	"You can sync the time between_": "Voit synkronoida ajan laitteesi ja BlackVue-kameran välillä. Synkronointia varten SD-kortti on alustettava. Ennen kuin jatkat, varmuuskopioi tarvittavat videot.",
	"Voice Alert": "Äänivaroitus",
	"Provides a voice alert_": "Antaa äänihälytyksen kamerasta ja lähettää ilmoituksen, jos ylität asetetun ajan ajon aikana.",
	"Please enter a value": "Please enter a value.",
	"Notices & Notifications": "Uutiset ja Ilmoitukset",
	"Only detects drowsiness above_": "Havaitsee vain uneliaisuus yli asetetun arvon. Voit muuttaa yksikköä kohdassa \"Kameran asetukset > Tapahtumakäynnistimet > Holtittoman ajamisen yksikkö\".",
	Promotion: Promotion$c,
	Notice: Notice$c,
	"View More": "Näytä lisää",
	"Read More": "Lue lisää",
	"Detection Box": "Tunnistuslaatikko",
	"Seatbelt Detection Box": "Turvavyön Tunnistuslaatikko",
	"Drive Position Detection Box": "Ajonasennon Tunnistuslaatikko",
	"Fleet Subscription Promotion (50%)": "Laivaston tilauskampanja (50 %)",
	"BlackVue Fleet Tracking exclusive features_": "BlackVue Fleet Tracking -yleisiä ominaisuuksia tehokäyttäjille ja yrityksille (useita käyttäjiä ja kameroita, geoaidat, Web Viewer jne.).",
	"Special Discount (50% off)": "Erikoisalennus (50% alennus)",
	"*Promotion applied for 12 months": "*Tarjous voimassa 12 kuukautta",
	"*Payment will be made starting next month.": "*Maksu suoritetaan ensi kuusta alkaen.",
	"[About using promotions]": "[Tietoja tarjousten käyttämisestä]",
	"The promotion is free for the first month_": "Kampanja on ilmainen ensimmäisen kuukauden ja sen jälkeen laskutetaan 12 kuukauden ajan seuraavasta kuukaudesta alkaen.",
	"For users with an existing Lite/Smart subscription_": "Käyttäjien, joilla on olemassa Lite/Smart-tilaus, sinun on peruutettava nykyinen sovellustilauksesi erikseen, muuten olemassa oleva sovellustilauksesi voidaan veloittaa tililtäsi.",
	"Please be sure to cancel your app subscription_": "Muista peruuttaa sovellustilauksesi ilmaisen jakson aikana. Tuplamaksuja ei palauteta.",
	"You will be changed to Fleet Plan immediately_": "Sinut vaihdetaan Fleet Planiin välittömästi, vaikka nykyisen Lite/Smart-suunnitelmasi jäljellä oleva tilauskausi ei olisi umpeutunut.",
	"You can cancel Fleet Plan any time.": "Voit peruuttaa Fleet Planin milloin tahansa.",
	"From February 2025, please go to the Fleeta service and use it.": "Kun kampanja on peruutettu, sitä ei sovelleta uudelleen.",
	"After promotion expires_": "Kun kampanja päättyy, sinut uusitaan automaattisesti nykyisellä Fleet Plan -tilausmaksulla.",
	"(Required) I have read the promotion instructions_": "(Pakollinen) Olen lukenut kampanjaohjeet ja hyväksyn maksun.",
	"Upgrade to Fleet Plan immediately": "Päivitä Fleet Planiin välittömästi",
	"Important Notice:": "Tärkeä huomautus:",
	"Switch of BlackVue Web Viewer to Fleeta Web Viewer": "Vaihda BlackVue Web Viewerista Fleeta Web Vieweriin",
	"To provide better features and quality_": "Parempien ominaisuuksien ja laadun tarjoamiseksi BlackVue-verkkokatselupalvelu siirtyy pian uuteen Fleeta-verkkokatselupalveluun. Fleeta-palvelut ovat yksinoikeudella vain Fleet Plan -käyttäjille. Fleeta-palvelu lanseerataan maaliskuussa 2025 uudella Fleetan eksklusiivisella sovelluksella. Saat lisätietoja osoitteesta <a href=\"https://www.fleeta.io\" target=\"_blank\">fleeta.io</a>.",
	"We kindly ask for your understanding_": "Pyydämme ystävällisesti ymmärrystäsi, sillä tämän muutoksen tarkoituksena on parantaa palvelua. Jos sinulla on kysyttävää tästä siirrosta, ota rohkeasti yhteyttä CS-keskukseemme.",
	"Don’t show this again for this month": "Älä näytä tätä uudelleen tässä kuussa",
	"Fleet Plan Subscription Promotion": "Laivastosuunnitelman tilauskampanja",
	"Period : December 2, 2024 ~ May 31, 2025": "Aika: 2. joulukuuta 2024 - 31. toukokuuta 2025",
	"See more details": "Katso lisätietoja",
	"To continue improve quality and provide better service_": "Laadun parantamiseksi ja paremman palvelun tarjoamiseksi BlackVue Web Viewer -palvelumme siirtyy pian Fleet Plan -yleispalveluun. Se ei ole enää saatavilla ilmaiseksi tai muiden pakettien kautta maaliskuun 2025 lopusta alkaen.",
	"We have prepared special discount offers for_": "Olemme laatineet erikoisalennustarjouksia nykyisille Web Viewer -käyttäjillemme. Tarkista tiedot alta! Pyydämme ystävällisesti ymmärrystäsi ja tukeasi toteuttaessamme tätä muutosta tarjotaksemme parempaa palvelua.\n",
	"*If you are subscribed in-app_": "*Jos olet tilannut sovelluksen sisäisen tilauksen, muista peruuttaa sovelluksen sisäinen tilauksesi.",
	"Enjoy your BlackVue Cloud service with your dashcam.": "Nauti BlackVue Cloud -palvelustasi kojelautakamerallasi.",
	"Available Cloud Camera slot(s)_": "Saatavilla olevat pilvikamerapaikat: {{d}}",
	"Not eligible for the promotion.": "Ei oikeutettu kampanjaan.",
	"You have already used_": "Olet jo käyttänyt tämän tarjouksen. Kun kampanja on peruutettu, sitä ei voi hakea uudelleen.",
	"Go to Cameras": "Siirry kohtaan Kamerat",
	"Congratulations !": "Congratulations !",
	"Fleet Plan user": "Fleet Plan user",
	"Let your BlackVue monitor_": "Anna BlackVue-laitteen tarkkailla autoasi ja varoittaa sinua tapahtumista. Heti kun törmäys havaitaan, BlackVue lähettää ilmoituksen puhelimeesi ja mukana tilannekuvan.\n",
	"Live Event Upload feature automatically_": "Live-tapahtuman latausominaisuus lataa automaattisesti videomateriaalia, mukaan lukien onnettomuutta edeltävät materiaalit, BlackVue Cloud Storageen pitääkseen videosi turvassa!",
	"*Buffer time varies by model.": "*Puskuriaika vaihtelee mallin mukaan.",
	Explore: Explore$c,
	"Cloud Storage": "Pilvitallennus",
	"My Cloud Cameras": "Omat pilvikamerani",
	"My Cloud Cameras Only": "Vain pilvikamerani",
	"BlackVue Live Camera": "BlackVue Live -kamera",
	"*For BlackVue Live Cameras_": "*BlackVue Live -kameroissa vain kameraasetuksissa julkisina jaetut kamerat näkyvät kartalla.",
	"*Share Method_": "*Jakotapa: Kameran asetukset> Yksityisyys",
	"Once the promotion is canceled_": "Kun kampanja on peruutettu, sitä ei sovelleta uudelleen.",
	"It will show_": "Se näkyy täällä, kun ne tulevat saataville.",
	"Deactivate Cloud": "Poista Cloud käytöstä",
	"Are you sure you want to deactivate_": "Haluatko varmasti poistaa Cloudin käytöstä tässä kamerassa?",
	"Deactivate : It doesn’t_": "Voit aina aktivoida pilven milloin tahansa. Kamera voidaan poistaa, kun deaktivointi on valmis.",
	Deactivate: Deactivate$c,
	"*If you made the payment through_": "*Jos maksoit sovelluksen kautta, käynnistä sovellus uudelleen.",
	"Connect Dashcam Locally (Wi-Fi)": "Liitä Dashcam paikallisesti (Wi-Fi)",
	"Cloud Connection Setting": "Pilviyhteysasetus",
	"Camera Profile": "Kameraprofiili",
	"Camera Settings": "Kameran asetukset",
	"Format MicroSD Card": "Alusta microSD-kortti",
	"Remote Firmware Update": "Laiteohjelmiston etäpäivitys",
	"Remove from Cloud": "Poista pilvestä",
	"The location may not be accurate_": "Sijainti ei ehkä ole tarkka, koska kameraa ei ole yhdistetty pilveen.",
	"The location of the camera cannot be found_": "Kameran sijaintia ei löydy. Tarkista pilviyhteysasetukset.",
	"Manage\nFLEETA Drive": "Hallitse\nFLEETA Levy",
	"Cloud\nConnection": "Pilvi\nyhteys",
	"Available on FLEETA App": "Saatavilla FLEETA-sovelluksessa",
	"Available for Cloud dashcam OR on FLEETA App.": "Saatavilla pilvidashcamille TAI FLEETA-sovelluksessa.",
	"Get started with_": "Aloita ilmainen 1 kuukauden kokeilu",
	"Experience all of_": "Kokeile FLEETA:n premium-ominaisuuksia ilmaiseksi yhden kuukauden kokeilujakson ajan.\n\nEi sitoutumista—peruuta milloin tahansa",
	"Welcome to FLEETA Webviewer.": "Tervetuloa FLEETA Webvieweriin.",
	"Let FLEETA get_": "Anna FLEETA tutustua sinuun",
	"Help improve your_": "Auta parantamaan kokemustasi jakamalla muutamia yksityiskohtia",
	"Business Industry": "Toimiala",
	"Vehicle & Cargo": "Ajoneuvot & Kuorma",
	Compliance: Compliance$c,
	"Would you like to skip?": "Haluatko ohittaa?",
	"What is your business industry?": "Millä toimialalla yrityksesi toimii?",
	"Transportation & Logistics": "Kuljetus ja logistiikka",
	"Rental & Leasing": "Vuokraus ja leasing",
	"Construction & Building": "Rakentaminen",
	"Government & Public": "Julkinen sektori",
	"Facility & Utility Management": "Kiinteistö- ja laitospalvelut",
	Manufacturing: Manufacturing$c,
	"Retail & Wholesale": "Vähittäis- ja tukkukauppa",
	Emergency: Emergency$c,
	Security: Security$c,
	"How many employees do you need to manage?": "Kuinka monta työntekijää sinun on hallittava?",
	"How many vehicles does your company operate?": "Kuinka monta ajoneuvoa yrityksesi käyttää?",
	"Why do you use a fleet tracking service?": "Miksi käytät ajoneuvoseurantapalvelua?",
	"Route Tracking": "Reittiseuranta",
	"Real-time Monitoring": "Reaaliaikainen valvonta",
	"Incident Detection & Check video": "Havaitseminen ja videon tarkistus",
	"Behavior Monitoring & Analysis": "Käyttäytymisen seuranta ja analysointi",
	"Evaluation & Management": "Arviointi ja hallinta",
	"Theft Prevention": "Varkauksien ehkäisy",
	"Monitoring & Maintenance": "Seuranta ja huolto",
	"Verification & Management": "Vahvistus ja hallinta",
	"BlackVue App Use Only": "Vain BlackVue-sovelluksen käyttöön",
	"Your current plan allow_": "Nykyinen suunnitelmasi sallii BlackVue-sovelluksen käytön. Web-katselijan käyttämiseksi tilaa Fleet-suunnitelma (FLEETA).",
	"Learn more about the Fleet_": "Lue lisää Laivue-suunnitelmasta (FLEETA)",
	"Special Offer": "Erikoistarjous",
	"For a limited time_": "Rajoitetun ajan nauti 50% alennuksesta Fleet-suunnitelmasi tilauksesta.",
	"See Discount Details": "Katso alennustiedot",
	"To subscribe to the Fleet_": "Tilataksesi Laivue-suunnitelman, peruuta ensin BlackVue-tilauksesi sovelluksessa välttääksesi päällekkäiset maksut.",
	"Skip tour": "Ohita kierros",
	"In the cloud_": "Pilviympäristössä voit käyttää toistoa, katsoa livenä (mukaan lukien moninäkymä), live-GPS:ää ja raportteja, kaikki FLEETA Web Viewerin kautta.",
	"Cloud Storage is_": "Pilvitallennustila on paikka, jossa lataamasi videot säilytetään turvallisesti pilvessä. Lataa videosi pitääksesi ne turvassa pitkään.",
	"Toggle to switch_": "Vaihda kartan ja listan välillä",
	"In List View_": "Luettelotilassa voit helposti tarkastella ja hallita ryhmiä, jäseniä ja laiteohjelmiston tietoja yhdellä silmäyksellä.",
	"What is Cloud Storage?": "Mikä on Pilvitallennustila?",
	"Cloud Storage Overview": "Pilvitallennustilan yleiskatsaus",
	"Difference Between FLEETA_": "Ero FLEETA Levy ja Live-tapahtuman latauksen välillä",
	"FLEETA Drive stores_": "FLEETA Levy tallentaa videot, jotka olet ladannut manuaalisesti",
	"Live Event Upload automatically_": "Live-tapahtuman lataus tallentaa automaattisesti videot, kun tapahtuma sattuu.",
	"Live Event Upload videos_": "Live-tapahtuman lataus -videoiden säilytysaika on rajallinen. Jos haluat säilyttää ne pitkään, siirrä ne FLEETA Levy.",
	"Note: SD Card_": "Huomautus: SD-kortin videot Toistossa",
	"Videos stored on_": "SD-kortilla tallennetut videot ovat saatavilla Toisto-valikon kautta.",
	"Set your image_": "Aseta kuvasi käyttäen tarjottua kehystä. Kun kuva on tallennettu, se näkyy kamerakortissa ja karttanäkymän kuvakkeessa.",
	"*Only jpg and_": "*Vain jpg- ja png-tiedostot ovat tuettuja.",
	"Set as default image": "Aseta oletuskuvaksi",
	"Camera Details": "Kameran tiedot",
	"IT & Telecommunications": "IT ja telekommunikaatio",
	"The name must_32": "Nimen on oltava 1–32 merkkiä.",
	"Unable to display the map.": "Karttaa ei voi näyttää.",
	"The camera location cannot be found_": "Kameran sijaintia ei voida löytää huonon GPS-yhteyden vuoksi.",
	"Cloud Cameras": "Pilvikamerat",
	"Want to unlock_": "Haluatko avata ajoneuvokaluston hallinnan ominaisuuksia?",
	"*Web subscription only": "*Vain web-tilaus",
	"Uploads event_": "Lataa tapahtuman kuvamateriaalin Pilvitallennustilaan välittömästi, kun tapahtuma sattuu.",
	"Starts a conversation_": "Aloittaa keskustelun kuljettajan kanssa käyttäen kojelautakameran kaiutinta ja mikrofonia.",
	"Remotely check_": "Tarkista akun taso ja tila etänä pilven kautta.",
	"Receive a voice_": "Saat äänihälytyksen ja ilmoitukset, jos ajonaika ylittää rajan.",
	"View your_": "Katso ajopäiväkirjasi kartalla.",
	"View speed, event_": "Katso nopeus, tapahtumatyyppi ja toista liittyvät videot suoraan kartalla.",
	"FLEETA Tracking exclusive_": "FLEETA Tracking tarjoaa eksklusiivisia ominaisuuksia sekä tehokäyttäjille että yrityksille (Useita käyttäjiä ja kameroita, geofencing, ym.).",
	"Cloud Cameras per Account": "Pilvikamerat per tili",
	"Connect Dashcam Locally_": "Yhdistä kojelautakamera paikallisesti (Wi-Fi) (Toisto, Lataus, Katso livenä)",
	"Available with_": "Saatavilla BlackVue-akulla",
	"Cloud Battery": "Pilviparisto",
	"Driving Reports": "Ajoraportit",
	"Video on Map": "Video kartalla",
	"Multi Live View (Fleeta Web Viewer)": "Moninäkymä Live (FLEETA Web-katselin)",
	"Enter a number": "Syötä numero",
	"Permission required.": "Lupa vaaditaan.",
	"Please contact_": "Ota yhteyttä omistajaan saadaksesi apua.",
	"Access not available": "Pääsy ei saatavilla.",
	"This file cannot be deleted now.": "Tätä tiedostoa ei voi poistaa nyt.",
	"Please try again later.": "Yritä myöhemmin uudelleen.",
	"Permission required.\nPlease_": "Lupa vaaditaan.\nOta yhteyttä omistajaan saadaksesi apua.",
	"Cloud Storage is disconnected_": "Pilvitallennustila on katkaistu. Tarkista yhteys.",
	"Manage the plan_": "Hallitse suunnitelmaa kameran palauttamiseksi",
	"Notify the owner_": "Ilmoita omistajalle suunnitelman hallinnasta",
	"Access Restricted:_": "Pääsy Rajoitettu: Tilaus Vanhentunut",
	"Access is currently_": "Pääsy ei ole tällä hetkellä mahdollista vanhentuneen tilauksen vuoksi.",
	"Please contact your owner_": "Ota yhteyttä omistajaasi ratkaistaksesi tämän ongelman.",
	"Access will be_": "Pääsy palautetaan, kun tilaus uusitaan",
	"Cloud is disconnected_": "Pilvitallennustila on katkaistu. \nTarkista yhteys.",
	"Connect to Cloud with_": "Yhdistä Pilvitallennustilaan FLEETA APP:n kautta",
	"Using Wi-Fi Hotspot": "Wi-Fi-yhteyspisteen käyttö",
	Important: Important$c,
	"Pre-Event buffer_": "Tapahtumaa edeltävä puskurointitallennus on poistettu käytöstä tässä tilassa.",
	"connectivity is_": "Yhteydet ovat rajoitettuja tässä tilassa.",
	"video upload starts_": "Videon lataaminen alkaa tallennuksen päätyttyä.",
	"Power Saving": "Energiansäästö",
	"In all modes_": "Kaikissa tiloissa havaitut iskut laukaisevat Tapahtuma-videotallenteet.",
	"Battery Protection setting _": "Akun suojauksen asetus on oltava PÄÄLLÄ.",
	"At least one of_": "Vähintään yksi seuraavista asetuksista on oltava käytössä",
	or: or$c,
	"For BlackVue battery users": "BlackVue-akun käyttäjille",
	"we recommend setting_": "Suosittelemme asettamaan jännitteen katkaisun minimiarvoon maksimaalisen akun käytön saavuttamiseksi.",
	"No videos were found.": "Videoita ei löytynyt.",
	"Try different filter_": "Kokeile eri suodatinta tai nollaa suodatin.",
	"Not avaliable with_": "Ei saatavilla nykyisen kameran kanssa",
	"Overlays a detection_": "Lisää havaitsemislaatikon DMS-kameran suoraan ja tallennettuun kuvaan.",
	"A minute of_": "Minuutti etukameran videota on suunnilleen",
	"System voice guidance": "Järjestelmän ääniopastus",
	"Recording trigger": "Tallennuksen laukaisin",
	"Remote Button (Optional)": "Kaukosäädin nappi (Valinnainen)",
	"Remote button settings_": "Kaukosäätimen painikkeiden asetuksia ei voi muuttaa pilviyhteyden kautta. Muuttaaksesi näitä asetuksia, siirry kohtaan Kamera > Yhdistä paikallisesti > Kamera-asetukset.",
	"No Registered Device": "Ei rekisteröityä laitetta",
	"Subscription process is complete": "Tilausprosessi on valmis",
	"Now, go back to_": "Palaa nyt FLEETA-sovellukseen, kirjaudu tilillesi ja aloita palvelun käyttö.",
	"You can check the upload progress": "Voit tarkistaa latauksen etenemisen Pilvitallennustila > FLEETA Levy -välilehdeltä.",
	"SIM card must be inserted in_": "SIM-kortti on asetettava kameraan, jotta voit aloittaa pilven käytön.",
	"Active until:": "Aktiivinen asti:",
	Subscribe: Subscribe$c,
	"Camera PSN": "Kamera PSN",
	"BlackVue Sim Free Trial Started!": "BlackVue Sim -ilmainen kokeilujakso alkanut!",
	"Enjoy a free period to use your SIM_": "Nauti ilmaisesta SIM-kortin käytöstä ilman tilausta!",
	"You can stay connected during the trial_": "Voit pysyä yhteydessä kokeilun aikana, mutta muista:",
	"Complete your subscription before the trial_": "Suorita tilauksesi ennen kokeilujakson päättymistä jatkaaksesi SIM-kortin käyttöä.",
	"If you don't subscribe by the end of the trial_": "Jos et tee tilausta kokeilujakson loppuun mennessä, SIM-palvelusi poistetaan käytöstä.",
	"Save Event Videos_": "Tallenna tapahtumavideot pilvitallennustilaan reaaliajassa!",
	"Note: Deleting your account doesn’t cancel": "Huomio: Tilisi poistaminen ei peruuta tilaustasi. Peruuttaaksesi, siirry kohtaan Tili > Tilaukset FLEETA-verkkonäkymässä.",
	"Available only on FLEETA App for_": "Saatavilla vain FLEETA-sovelluksessa tälle mallille.",
	"The cloud is deactivated": "Pilvi on poistettu käytöstä.",
	"Please add a camera with FLEETA_": "Lisää kamera FLEETA-sovellukseen käyttääksesi tätä ominaisuutta.",
	"Upload videos to FLEETA_": "Lataa videot FLEETA Levyyn ja pidä ne turvassa!",
	"You have no assigned camera_": "Sinulla ei ole määritettyä kameraa.\nOta yhteyttä omistajaan pyytääksesi määritystä.",
	"Camera notification settings": "Kameran ilmoitusasetukset",
	Vehicle: Vehicle$c,
	"App Download": "Lataa sovellus",
	"Have a problem with_": "Onko tilauksessa ongelma?",
	"Restore Purchase": "Palauta ostos",
	"Battery Pairing": "Akun pariliitos",
	"Playback\nLive View": "Toisto/\nSuora näkymä",
	"Remote Playback": "Kaukotoisto",
	"Cloud connection settings": "Pilviyhteyden asetukset",
	"Go to settings": "Siirry asetuksiin",
	"Only cloud cameras that_": "Vain ne pilvikamerat, jotka käyttäjät valitsevat jakaa julkisesti, näytetään kartalla.",
	"Live Broadcast Cameras": "Suoralähetyskamerat",
	"*Live Broadcast Cameras_": "*Suoralähetyskamerat ovat pilvikameroita, jotka käyttäjät ovat asettaneet lähettämään.",
	"Only cloud cameras_": "Kartalla näkyvät vain ne pilvikamerat, jotka käyttäjät ovat valinneet lähetettäviksi."
};

var Dashboard$b = "Tableau de bord";
var Account$b = "Compte";
var Help$b = "Aide";
var Mac$b = "Mac";
var Windows$b = "Windows";
var Admin$b = "Administrateur";
var Driver$b = "Conducteur";
var Cameras$b = "Caméras";
var Manage$b = "Gérer";
var Clear$b = "Clair";
var Show$b = "Spectacle";
var GB$b = "{{a}}GB";
var _section$b = ".";
var Name$b = "Nom";
var Password$b = "Mot de passe";
var Cancel$b = "Annuler";
var Members$b = "Membres";
var Groups$b = "Groupes";
var Role$b = "Rôle";
var Group$b = "Groupe";
var Status$b = "État";
var nPM$b = "{{a}}PM";
var nAM$b = "{{a}}AM";
var Newest$b = "Le plus récent";
var Oldest$b = "Le plus ancien";
var Accepted$b = "Accepté";
var Pending$b = "En attente";
var Expired$b = "Expiré";
var All$b = "Tout";
var Delete_$b = "Supprimer {{a}}";
var Delete$b = "Supprimer";
var Rename$b = "Changer le nom";
var Add$b = "Ajouter";
var OK$b = "OK";
var Remove$b = "Supprimer";
var Files$b = "Fichiers";
var Features$b = "Caractéristiques";
var Settings$b = "Paramètres";
var Upload$b = "Télécharger";
var Privacy$b = "Confidentialité";
var Done$b = "Fini";
var Subscription$b = "Abonnement";
var Submasters$b = "admins";
var Users$b = "chauffeurs";
var Change$b = "Modifier";
var Method$b = "Mode";
var Details$b = "Infos de la dashcam";
var Confirm$b = "Confirmer";
var Address$b = "Adresse";
var Country$b = "Pays";
var State$b = "Région";
var ZIP$b = "Code postal";
var Pricing$b = "Tarification";
var Free$b = "Free";
var Smart$b = "Smart";
var Fleet$b = "Fleet";
var Subscrubed$b = "Abonné";
var January$b = "janvier";
var February$b = "Février";
var March$b = "Mars";
var April$b = "avril";
var May$b = "Mai";
var June$b = "juin";
var July$b = "juillet";
var August$b = "août";
var September$b = "septembre";
var October$b = "octobre";
var November$b = "novembre";
var December$b = "décembre";
var Blackvuecloud_$b = "www.blackvuecloud.com";
var Support$b = "Support";
var Community$b = "Community";
var FAQ$b = "FAQ";
var Developers$b = "Developers";
var Facebook$b = "Facebook";
var Twitter$b = "Twitter";
var Instagram$b = "Instagram";
var Youtube$b = "Youtube";
var Linkedin$b = "Linkedin";
var Downloads$b = "Téléchargements";
var Unauthorized$b = "Non autorisé";
var none$b = "None";
var Email$b = "Adresse électronique";
var Customers$b = "Customers";
var Home$b = "Home";
var Plan$b = "Plan";
var New$b = "New";
var Unsubscribed$b = "Unsubscribed";
var Edit$b = "Edit";
var month$b = "month";
var months$b = "months";
var Continue$b = "Continue";
var Back$b = "Arrière";
var Master$b = "Owner";
var Develop$b = "Developers";
var $9$b = "$9";
var $15$b = "$15";
var $10$b = "$10";
var mo$b = "Mois";
var City$b = "Ville";
var Charge$b = "Facturer";
var subscribe$b = "S'abonner";
var search$b = "Chercher";
var invalid_number$b = "Le numéro de carte saisi n’est pas un numéro de carte de crédit valide";
var invalid_expiry_month$b = "Le mois d’expiration de la carte n’est pas valide";
var invalid_expiry_year$b = "L’année d’expiration de la carte n’est pas valide";
var invalid_cvc$b = "Le code de sécurité de la carte n’est pas valide";
var incorrect_number$b = "Le numéro de la carte est incorrect";
var incomplete_number$b = "Le numéro de la carte est incomplet";
var incomplete_cvc$b = "Le code de sécurité de la carte est incomplet";
var incomplete_expiry$b = "La date d’expiration de la carte est incomplète";
var expired_card$b = "La carte a expiré";
var incorrect_cvc$b = "Le code de sécurité de la carte est incorrect";
var incorrect_zip$b = "Le code postal de la carte n’a pas pu être validé";
var invalid_expiry_year_past$b = "L’année d’expiration de la carte est passée";
var card_declined$b = "La carte a été refusée";
var missing$b = "Il n’y a pas de carte sur un client qui est facturé";
var processing_error$b = "Une erreur s’est produite lors du traitement de la carte";
var Paypal$b = "Paypal";
var iOS$b = "iOS";
var Android$b = "Android";
var Total$b = "Total";
var And$b = "et";
var Camera$b = "Dashcam";
var Yes$b = "Oui";
var No$b = "Non";
var News$b = "Nouvelles";
var Notifications$b = "Notifications";
var MPH$b = "MPH";
var Firmware$b = "Firmware";
var Basic$b = "Basique";
var Resolution$b = "Résolution";
var Brightness$b = "Luminosité";
var Recording$b = "Enregistrement";
var Highest$b = "La plus élevée";
var High$b = "Élevée";
var Normal$b = "Normal";
var Sensitivity$b = "Sensibilité";
var Volume$b = "Volume";
var Close$b = "Close";
var Cloud$b = "Cloud";
var Public$b = "Public";
var Front$b = "Avant";
var Rear$b = "Arrière";
var Play$b = "Lecture";
var Stop$b = "Arrêter";
var Pause$b = "Interrompre";
var Time$b = "Time";
var System$b = "Système";
var Event$b = "Événement";
var Parking$b = "Parking";
var Color$b = "Couleur";
var Exit$b = "Sortir";
var Save$b = "Sauvegarder";
var Impact$b = "Impact";
var Unlimited$b = "Illimité";
var Default$b = "Défaut";
var Version$b = "Version";
var Language$b = "Langue";
var Notification$b = "Notification";
var Multiple$b = "Multi";
var Range$b = "Plage";
var Download$b = "Télécharger";
var Manual$b = "Manuel";
var Satellite$b = "Satellite";
var Tutorials$b = "Tutoriels";
var Filter$b = "Filtre";
var Sun$b = "Dim";
var Mon$b = "Lun";
var Tue$b = "Mar";
var Wed$b = "Mer";
var Thu$b = "Jeu";
var Fri$b = "Ven";
var Sat$b = "Sam";
var Dates$b = "Dates";
var Routes$b = "Itinéraires";
var Opacity$b = "opacité";
var Entry$b = "Entrée";
var Owner$b = "Owner";
var Undetected$b = "non détecté";
var Distracted$b = "Distrait";
var Drowsy$b = "Drowsy";
var Calling$b = "Calling";
var Smoking$b = "Smoking";
var Permissions$b = "Autorisations";
var Private$b = "Privé";
var Entering$b = "Entrée";
var Exiting$b = "Sortie";
var Acceleration$b = "Accélération";
var Passing$b = "Franchissement";
var Overspeed$b = "Excès de vitesse";
var Recipients$b = "Destinataires";
var Send$b = "Envoyer";
var Note$b = "Remarque";
var Video$b = "Vidéo";
var Advanced$b = "Avancé";
var Voice$b = "Voix";
var Days_$b = "Jours";
var Mute$b = "Couper le son";
var UnMute$b = "Remettre le son";
var Discard$b = "Abandonner";
var Report$b = "Report";
var Individual$b = "Chauffeur individuel à la recherche de tranquillité d’esprit ? Propriétaire d’entreprise qui a besoin d’une solution simple de sécurité et de suivi des véhicules ?";
var Subscribed$b = "Abonné";
var Geofence$b = "Géofence";
var Driving$b = "Conduite";
var Idling$b = "Ralenti";
var Distance$b = "Distance";
var Parked$b = "Parked";
var Speed$b = "Vitesse";
var Highest_2$b = "Très élevée";
var Average$b = "Moyenne";
var Geofences$b = "Géofences";
var Move$b = "Déplacer";
var Connected$b = "Connecté";
var Individual_$b = "Individu";
var Always$b = "Toujours";
var Low$b = "Basse";
var Medium$b = "Moyenne";
var High_2$b = "Élevée";
var Flip$b = "Retourner";
var Previous$b = "Image précédente";
var Next$b = "Prochain";
var Expand$b = "Développer";
var Collapse$b = "Réduire";
var More$b = "Plus";
var Multi$b = "Multi";
var Safe$b = "Prudent";
var Reckless$b = "Imprudent";
var Inattentive$b = "Inattentif";
var List$b = "Liste";
var Usage$b = "Utilisation";
var Profile$b = "Profil";
var Fullscreen$b = "Plein écran";
var Upgrade$b = "Mise à niveau";
var Management$b = "Gestion";
var Day$b = "Jour";
var Month$b = "Mois";
var Later$b = "Plus tard";
var ICCID$b = "ICCID";
var Resubscribe$b = "Se réabonner";
var plan$b = "forfait";
var USD$b = "USD";
var etc_$b = "etc. :";
var Available$b = "Disponible";
var Used$b = "Utilisé";
var Cancelled$b = "Annulé";
var Terminated$b = "Terminé";
var Sort$b = "Trier";
var Bonus$b = "Bonus";
var incomplete_zip$b = "Le code postal de la carte n’a pas pu être validé";
var Upgrades$b = "Mises à jour";
var OR$b = "OU";
var Undo$b = "Annuler";
var Invoice$b = "Facturer";
var data$b = "Données";
var Popular$b = "Popular";
var Mask$b = "Masque enlevé";
var DMS$b = "surveillance du statut du conducteur (DMS)";
var Extreme$b = "Extrême";
var OFF$b = "OFF";
var Threshold$b = "Seuil";
var Drowsiness$b = "Somnolence";
var Direct$b = "Direct";
var Remote$b = "Distant";
var Update$b = "Mise à jour";
var Option$b = "Option";
var Required$b = "Requis";
var Optional$b = "Facultatif";
var Others$b = "Autre";
var Stay$b = "Rester";
var Mask_2$b = "Mask";
var Low_2$b = "Low";
var Medium_2$b = "Medium";
var High_3$b = "High";
var Highest_3$b = "Highest";
var Extreme_2$b = "Extreme";
var Private_2$b = "Private";
var Lite$b = "Lite";
var Bitrate$b = "Débiter";
var hours$b = "Heures";
var Expires$b = "Expire";
var Check$b = "Vérifier";
var Saving$b = "Enregistrement";
var Now$b = "Maintenant";
var Beep$b = "Son d'avertissement";
var Unpair$b = "Dissocier";
var Detected$b = "Détecté";
var Promotion$b = "Promotion";
var Notice$b = "Mises à jour";
var Explore$b = "Explorer";
var Deactivate$b = "Désactiver";
var Compliance$b = "Conformité";
var Manufacturing$b = "Fabrication";
var Emergency$b = "Urgences";
var Security$b = "Sécurité";
var Important$b = "Important";
var or$b = "ou";
var Subscribe$b = "S'abonner";
var Vehicle$b = "véhicule";
var fr = {
	Dashboard: Dashboard$b,
	"Payment & Subscriptions": "Paiement et abonnements",
	"Fleet Management": "Gestion de la flotte",
	"Available to master": "Disponible au maître",
	"Available to Fleet_": "Disponible aux utilisateurs de l’abonnement Fleet Plan",
	Account: Account$b,
	"Log out": "Déconnexion",
	"© 2019 Pittasoft_": "© 2019 Pittasoft Co. Ltd",
	"Privacy policy": "Politique de confidentialité",
	"Terms of service": "Termes et Conditions de Service",
	Help: Help$b,
	"App store": "App store",
	"Google Play": "Google Play",
	Mac: Mac$b,
	Windows: Windows$b,
	"Free Plan": "Free Plan",
	"Basic Plan": "Basic Plan",
	"Smart Plan": "Smart Plan",
	Admin: Admin$b,
	Driver: Driver$b,
	"Period : December 3, 2024 ~ May 31, 2025": "Période : 3 décembre 2024 ~ 31 mai 2025",
	Cameras: Cameras$b,
	"n of n": "{{a}} de {{b}}",
	Manage: Manage$b,
	"Upgrade Plan": "Mettre à niveau l’abonnement",
	"Add more cameras_": "Ajoutez plus de caméras, gérez votre flotte, et plus encore...",
	"Usage statistics": "Statistiques d’utilisation",
	"All cameras": "Toutes les caméras",
	Clear: Clear$b,
	Show: Show$b,
	"Live views": "Vue en direct à distance",
	"nh:nm:ns": "{{a}}h:{{b}}m:{{c}}s",
	"Video plays and_": "Lectures et téléchargements de vidéos",
	"Space available": "Espace disponible",
	GB: GB$b,
	"n%": "{{a}}%",
	"BlackVue app for_": "Appli BlackVue pour iOS et Android",
	"BlackVue viewer for_": "BlackVue Viewer pour Mac et Windows",
	"Welcome to fleet": "Bienvenue dans la flotte",
	"A few things_": "Plusieurs choses auxquelles vous pouvez vous attendre :",
	"You can watch_": "Vous pouvez regarder les vidéos des caméras qui vous ont été assignées dans l’application BlackVue ou dans la visionneuse de bureau.",
	"If the master_deletes": "Si le maître supprime son compte, votre compte sera également supprimé.",
	"If the masters_Fleet": "Si l’abonnement Fleet Plan du maître expire, vous pourrez toujours accéder à votre compte en mode lecture seule.",
	"You have to_": "Vous devez enregistrer un autre compte pour ajouter une caméra personnelle.",
	"The Payments &_": "Les sections Paiements et abonnements et Gestion de la flotte ne sont accessibles qu’au maître.",
	"You can manage_": "Vous pouvez gérer le groupe de votre flotte dans la section",
	"_Fleet management": "Gestion de la flotte",
	_section: _section$b,
	"The Payments_section-": "La section Paiements et abonnements n’est accessible qu’au maître.",
	"Youre almost there": "Vous y êtes presque",
	"Finish account setup": "Terminer la configuration du compte",
	"Install and log_": "Installer et se connecter à l’application BlackVue ou à la visionneuse de bureau",
	"Download on the_": "Télécharger sur l’App Store",
	"GET IT ON_": "OBTENIR L’APPLICATION SUR Google Play",
	"Download for Mac": "Télécharger pour Mac",
	"Download for Windows": "Télécharger pour Windows",
	"Add your camera_": "Ajoutez votre caméra dans l’application BlackVue ou la visionneuse de bureau",
	"Start managing your_": "Commencez à gérer votre flotte et suivez les statistiques d’utilisation ici",
	"Cancelled Fleet Plan_": "Abonnement Fleet Plan annulé le {{date}}",
	"The new plan_": "Le nouvel abonnement prendra effet à la fin de votre cycle de facturation actuel.",
	"Profile photo": "Photo de profil",
	Name: Name$b,
	"E-mail address": "Adresse électronique",
	Password: Password$b,
	"Last changed_": "Dernière modification {{a}}",
	"Change password": "Changer le mot de passe",
	"Delete account": "Supprimer le compte",
	Cancel: Cancel$b,
	"Current password": "Mot de passe actuel",
	"New password": "Nouveau mot de passe",
	"Confirm new password": "Confirmer le nouveau mot de passe",
	"Password changed": "Mot de passe modifié",
	"Reason for deletion_": "Motif de la suppression (facultatif)",
	"Account password": "Mot de passe du compte",
	Members: Members$b,
	Groups: Groups$b,
	"+ Invite member": "+ Inviter un membre",
	"Name, Email": "Nom, adresse électronique",
	Role: Role$b,
	Group: Group$b,
	"Date invited": "Date de l’invitation",
	Status: Status$b,
	"Group n": "Groupe {{a}}",
	nPM: nPM$b,
	nAM: nAM$b,
	Newest: Newest$b,
	Oldest: Oldest$b,
	"Name, email or_": "Nom, adresse électronique ou groupe",
	Accepted: Accepted$b,
	Pending: Pending$b,
	Expired: Expired$b,
	All: All$b,
	"No results": "Aucun résultat",
	"Try different keywords": "Essayer différents mots-clés",
	"Try changing or_": "Essayer de changer ou de supprimer des filtres",
	"Remove all filters": "Supprimer tous les filtres",
	"Invite member": "Inviter un membre",
	"Send invite": "Envoyer une invitation",
	"You have reached_": "Vous avez atteint la limite de 10 sous-membres. Vous pouvez continuer à inviter des membres.",
	Delete_: Delete_$b,
	"Are you sure_delete": "Souhaitez-vous vraiment supprimer ce membre et son compte ?",
	Delete: Delete$b,
	Rename: Rename$b,
	"No submaster yet": "Pas encore de sous-maître",
	"You can add_": "Vous pouvez ajouter 1 sous-maître par groupe",
	"No cameras yet": "Pas encore de caméras",
	"Add cameras first_": "Ajouter d’abord des caméras, puis affecter les utilisateurs",
	"Name or email": "Nom ou adresse électronique",
	"Add submaster": "Ajouter un sous-maître",
	Add: Add$b,
	"Add camera": "Ajouter une caméra",
	"n of n selected": "{{a}} sur {{b}} sélectionné(s)",
	"No cameras available": "Pas de caméras disponibles",
	"Most likely reasons_": "Raisons les plus probables :",
	"All cameras were_": "Toutes les caméras ont été ajoutées à d’autres groupes.",
	"You can remove_": "Vous pouvez retirer des caméras d’autres groupes et les ajouter à ce groupe.",
	"No cameras were_": "Aucune caméra n’a été ajoutée à votre compte.",
	"You can add_cameras": "Vous pouvez ajouter des caméras dans l’application BlackVue ou dans la visionneuse de bureau.",
	OK: OK$b,
	"Rename group": "Renommer le groupe",
	"Are you sure_group": "Souhaitez-vous vraiment supprimer ce groupe ?",
	"Edit Mobile app_": "Modifier les autorisations de l’application mobile/de la visionneuse de bureau",
	Remove: Remove$b,
	"n of n users": "{{a}} sur {{b}} utilisateurs",
	"Youve reached the_": "Vous avez atteint la limite d’utilisateurs par caméra",
	"Remove user": "Supprimer un utilisateur",
	"Add user": "Ajouter un utilisateur",
	"+ Add group": "+ Ajouter un groupe",
	"Add group": "Ajouter un groupe",
	"Group or submaster": "Groupe ou sous-maître",
	"+ Add": "+ Ajouter",
	"of max selected": "{{a}} sur {{b}} max. sélectionné(s)",
	"Mobile app/desktop_": "Autorisations de l’application mobile/de la visionneuse de bureau",
	Files: Files$b,
	Features: Features$b,
	Settings: Settings$b,
	Upload: Upload$b,
	"Download and Playback_Cloud": "Télécharger et lire à partir du stockage cloud",
	"Download and Playback_SD": "Télécharger et lire à partir de la carte SD",
	"Live view": "Live View",
	"Geo Fencing": "Géofencing",
	"Drive Reports": "Rapports de conduite",
	"Firmware Settings": "Paramètres du firmware",
	"Push Notifications": "Notifications Push",
	"Event Auto Upload": "Upload automatique des événements en direct",
	Privacy: Privacy$b,
	Done: Done$b,
	"Payment method": "Mode de paiement",
	"Change payment method": "Modifier le mode de paiement",
	Subscription: Subscription$b,
	"Space used": "Espace utilisé",
	"Next billing_": "Prochaine facturation {{a}} {{b}}",
	"You manage_available": "Vous gérez {{a}} sur {{b}} disponibles sur votre abonnement",
	Submasters: Submasters$b,
	Users: Users$b,
	Change: Change$b,
	"No transactions yet_": "Vous disposez d’un abonnement gratuit. Pas encore de transactions.",
	"No transactions to_": "Aucune transaction à afficher.<br/>Si vous recherchez l’historique des transactions d’autres plateformes (par ex. : iOS, Android, PayPal), vous trouverez l’historique sur la page d’abonnement de votre propre plateforme.",
	"of nGB_": "{{a}} sur {{b}} Go ({{c}}%)",
	"Smart Plan users_": "Les utilisateurs de Smart Plan peuvent modifier le plan d’abonnement ou le nombre de caméras via l’application mobile BlackVue",
	"Transaction history": "Historique des transactions",
	"Date": "Date",
	"Amount, USD": "Montant en dollars américains",
	Method: Method$b,
	Details: Details$b,
	"iOS in-app_": "iOS in-app purchase/Android in-app purchase",
	"Change the number_": "Modifier le nombre de caméras",
	"You manage_cameras": "You manage {{a}} cameras of {{b}} available on your plan",
	"Extra cameras": "Caméras supplémentaires",
	"Total due_": "Total dû",
	"available on your_": "de {{a}} disponibles dans votre plan",
	"Cancel Fleet Plan": "Annuler Fleet Plan",
	"This will cancel_": "Cela annulera votre abonnement Fleet Plan. Vous passerez à l’abonnement Free Plan à la fin de votre cycle de facturation.",
	"Reason for cancellation_": "Motif de l’annulation (facultatif)",
	"Not now": "Plus tard",
	Confirm: Confirm$b,
	"Cardholder name": "Nom du titulaire de la carte",
	"Card name": "Numéro de la carte",
	"MM/YY": "MM/AA",
	Address: Address$b,
	Country: Country$b,
	State: State$b,
	ZIP: ZIP$b,
	Pricing: Pricing$b,
	"You are subscribed_": "Vous avez un abonnement à Free Plan.",
	"With Alert Push_": "Comprend les notifications d’alerte push, Remote Live View limitée et le stockage cloud.",
	Free: Free$b,
	Smart: Smart$b,
	Fleet: Fleet$b,
	"Get started for_": "Démarrez gratuitement, sans carte de crédit. \n Comprend les notifications d’alerte push, Remote Live View limitée et le stockage cloud.",
	Subscrubed: Subscrubed$b,
	"Features included:": "Fonctionnalités incluses :",
	"Get unlimited Remote_": "Procurez-vous Remote Live View illimitée et bénéficiez de la lecture sur le cloud et gérez jusqu’à {{a}} caméras.",
	"BlackVue Fleet Tracking_": "fonctionnalités exclusives de BlackVue Fleet Tracking pour les utilisateurs avertis et les entreprises (utilisateurs et caméras multiples, géofence, etc.)",
	"Try 1 Month Free": "Essayer gratuitement pendant un mois",
	"Log in": "Connexion",
	"Remember me": "Se souvenir de moi",
	"Forgot password?": "Mot de passe oublié ?",
	"Reset password": "Réinitialisation du mot de passe",
	"Enter email address_": "Saisissez l’adresse électronique utilisée lors de l’inscription et \n nous vous enverrons un lien pour réinitialiser votre mot de passe.",
	"Send reset password_": "Envoyer l’e-mail de réinitialisation du mot de passe",
	"Back to login": "Retour à la connexion",
	"Check your email": "Vérifiez votre messagerie électronique",
	"Weve sent an_": "Nous avons envoyé un e-mail à {{a}} avec un lien pour confirmer\n votre adresse électronique.",
	"Resend email": "Renvoyer l’e-mail",
	January: January$b,
	February: February$b,
	March: March$b,
	April: April$b,
	May: May$b,
	June: June$b,
	July: July$b,
	August: August$b,
	September: September$b,
	October: October$b,
	November: November$b,
	December: December$b,
	"Sign up": "Créer un compte",
	"First name": "Prénom",
	"Last name": "Nom de famille",
	"Create a password": "Créer un mot de passe",
	"5 or more_": "5 caractères ou plus",
	"Sign up and_": "S’inscrire et continuer",
	"I agree to_": "J’accepte les %@, %@, %@ et %@.",
	"Subscribe to newsletter": "S’abonner à la newsletter",
	"1 month free trial_": "1 mois d’essai gratuit",
	"Dont have an_": "Vous n’avez pas de compte ?",
	"Thank you for_": "Merci de vous être inscrit à BlackVue Cloud. Veuillez confirmer votre adresse électronique.",
	"Confirm email": "Confirmer l’adresse électronique",
	"If you didnt_": "Si vous n’avez pas créé ce compte, vous pouvez ignorer cet e-mail.",
	Blackvuecloud_: Blackvuecloud_$b,
	"invited you to_": "{{a}} vous a invité(e) à rejoindre sa flotte en tant que sous-maître.",
	"Accept invitation": "Accepter l’invitation",
	"Invite expires on_": "L’invitation expire le mm jj, aa.",
	"Your Fleet Management_": "Votre compte de gestion de flotte enregistré sur {{a}} a été supprimé par %@.",
	"If you believe_": "Si vous pensez qu’il s’agit d’une erreur, veuillez contacter notre service client : cs@blackvue.com.",
	Support: Support$b,
	"Help center": "Centre d'aide",
	Community: Community$b,
	"Getting started": "Commencer",
	FAQ: FAQ$b,
	Developers: Developers$b,
	"Cloud API": "Cloud API",
	"Fleet SDK": "Fleet SDK",
	"Follow us": "Suivez nous",
	Facebook: Facebook$b,
	Twitter: Twitter$b,
	Instagram: Instagram$b,
	Youtube: Youtube$b,
	Linkedin: Linkedin$b,
	"BlackVue apps": "BlackVue apps",
	"Camera registraiton": "Enregistrement de caméra",
	"Two-way voice_": "Communication vocale bidirectionnelle",
	"Live GPS": "GPS en direct",
	"Event live auto_": "Upload automatique des événements en direct",
	"Event file auto_": "Upload automatique du fichier d’événement",
	"Compatible with_": "Compatible avec les modèles DR650GW, DR650S",
	"Not compatible with_": "Non compatible avec les modèles DR650GW, DR650S",
	"More cameras": "Plus de caméras",
	"More users": "More users",
	"Roles and permissions": "Roles and permissions",
	"More Cloud Storage": "Plus de stockage cloud",
	"Multi Live view_": "Multi Live View (Web)",
	"Longer GPS Tracking": "Longer GPS Tracking",
	"Geo Fence setup_": "Geo Fence setup (PC viewer) and alerts (PC viewer and app)",
	"Changes saved": "Modifications enregistrées",
	"Group added": "Groupe ajouté",
	"Member added": "Membre ajouté",
	"Group deleted": "Groupe supprimé",
	"Member deleted": "Membre supprimé",
	"Group renamed": "Groupe renommé",
	"Submaster added": "Sous-maître ajouté",
	"Camera added": "Caméra ajoutée",
	"User added": "Utilisateur ajouté",
	"Users added": "Utilisateurs ajoutés",
	Downloads: Downloads$b,
	"The BlackVue App_": "The BlackVue App and Viewer let you use your BlackVue camera to its full potential. Whether on mobile or on home computer, BlackVue gives you the tools to fully enjoy your dashcam's functions.",
	"Compatible with all_": "Compatible with all Wi-Fi enabled BlackVue models.",
	"Supports all BlackVue_": "Supports all BlackVue models to date.",
	"confirm new password": "Confirmer le nouveau mot de passe",
	"Your password is_": "Le mot de passe que vous avez saisi est incorrect",
	"Confirm password does_": "Le mot de passe ne correspond pas",
	"Please enter_email": "Veuillez entrer une adresse e-mail valide.",
	"Please enter_password": "Le mot de passe que vous avez saisi est incorrect",
	"Internal server error_": "Erreur interne du serveur, veuillez réessayez.",
	"New password is_": "Au moins 1 caractère doit être différent de votre mot de passe actuel",
	"It should be_": "Le mot de passe doit comporter au moins 5 caractères",
	"Invalid permission": "Autorisation non valide.",
	"Input data isnt_": "Les données d’entrée ne sont pas disponibles.",
	Unauthorized: Unauthorized$b,
	"Already have subsciption": "Déjà abonné",
	"Already uses": "Déjà utilisé",
	"Already logged in": "Déjà connecté",
	"Already sent e-mail": "Déjà envoyé par e-mail.",
	"Please wait": "Veuillez patienter.",
	"E-mail is not_": "L’adresse électronique n’a pas encore été vérifiée.",
	"Update your subscription_": "Mettre à jour votre abonnement",
	"Account was deleted": "Le compte a été supprimé.",
	"5 ~ 30_": "5 ~ 30 characters",
	"It has exceeded_": "Il a dépassé le maximum de 9 administrateurs.",
	"Billing information": "Informations de facturation",
	"Please enter cardName": "Saisir le nom de la carte",
	"Please enter_card": "Saisir un numéro de carte valide",
	"Please enter address": "Saisir l’adresse",
	"Please select country": "Sélectionner le pays",
	"Please enter city": "Saisir la ville",
	none: none$b,
	"Due today": "Dû aujourd’hui",
	"Today after 1_": "Aujourd’hui après 1 mois d’essai",
	"An error occurred_": "Une erreur s’est produite lors de la tentative de modification du mot de passe. Veuillez réessayer.",
	"Your account is_": "Votre compte est maintenant actif",
	"You can now_": "Vous pouvez maintenant vous connecter à votre compte avec l’adresse électronique utilisée lors de l’inscription.",
	Email: Email$b,
	"Don’t have an account?": "Vous n’avez pas de compte ?",
	"Already have an account?": "Vous avez déjà un compte ?",
	"Cloud service": "Cloud service",
	"for your BlackVue": "for your BlackVue",
	"See what your_": "See what your camera sees remotely.",
	"Receive impact alert_": "Receive Impact alert push notifications.",
	"Save footage to_": "Save footage to the cloud and do much more...",
	"Free plan included_": "Free plan included · Easy setup · Cancel anytime",
	"Taking advantage of_": "Taking advantage of a mobile or car-embedded Internet connection and a BlackVue camera, BlackVue Cloud connects you to your car from anywhere, anytime. Using the BlackVue App on your smartphone or tablet, you see in real time where your car is located and what is happening around it.",
	"Get notifications to_": "Get notifications to your phone when your parked car is hit. Check remotely what is happening around your car.",
	"Monitor your commercial_": "Monitor your commercial vehicles on a map in real time. Talk to your drivers anytime through the BlackVue App or Viewer.",
	"With BlackVue Fleet_": "With BlackVue Fleet Tracking, track in real time up to 100 vehicles from the palm of your hand or with the dedicated BlackVue Viewer.",
	"Get started now_": "Get started now with a Free plan. For unlimited video playback or Remote Live View, upgrade to Lite or Smart plan from the BlackVue App. <br/>Business and power users can unlock the power of the Fleet plan exclusively through this website.",
	"Remote Video Playback_": "Remote Video Playback and Download",
	"Compatible with DR650GW_": "Compatible with DR650GW, DR650S models",
	"Unlimited remote video_": "Unlimited remote video playback and download",
	"Longer cloud storage_": "Longer cloud storage file expiration period",
	"Longer storage period_live": "Longer storage period for Event live auto upload",
	"Longer storage period_file": "Longer storage period for Event file auto upload",
	"Goefence setup (PC_": "Geo-fence setup (PC viewer) and alerts (Windows viewer and app)",
	"App Store": "App Store",
	"Send reset password email": "Envoyer l’e-mail de réinitialisation du mot de passe",
	Customers: Customers$b,
	Home: Home$b,
	"Pick a plan": "Pick a plan",
	"No customers yet": "No customers yet",
	"Customers will_": "Customers will show up here as they become available",
	"Add customer": "Add customer",
	"Report(PDF)": "Report(PDF)",
	"Subscription Period": "Subscription Period",
	Plan: Plan$b,
	New: New$b,
	Unsubscribed: Unsubscribed$b,
	"Subscription ends soon": "Subscription ends soon",
	Edit: Edit$b,
	"1 month trial": "1 month trial",
	"Edit customer details": "Edit customer details",
	"Customer name": "Customer name",
	"of 999 available_": "of 999 available on Fleet Plan",
	"Subscription starts": "Subscription starts",
	"Subscription period": "Subscription period",
	month: month$b,
	months: months$b,
	"Cloud storage": "Cloud Storage",
	"Subscription plan": "Type d'abonnement",
	"Check email address": "Check email address",
	"Add customer details": "Add customer details",
	Continue: Continue$b,
	Back: Back$b,
	"An error occured": "An error occured",
	"Customer added": "Customer added",
	"Last changed": "Last changed",
	"Company name": "Company name",
	"Company address": "Company address",
	"Alert Push Notifications": "Alert Push Notifications",
	"Receive notifications on_": "Receive notifications on your phone when preset Events occur. Great in combination with BlackVue’s Parking Mode.",
	"Remote Live View": "Affichage en direct à distance",
	"Remotely monitor your_": "Remotely monitor your car in real time from anywhere, anytime.",
	"Video Backup/Auto Upload": "Video Backup/Auto Upload",
	"Back up videos_": "Back up videos to your phone or Cloud storage.",
	"Two-way Voice Communication": "Two-way Voice Communication",
	"Talk with people_": "Talk with people in the car from your smartphone. The driver can speak while keeping hands on the wheel.",
	"View your car’s_": "View your car’s location and speed on a map. With BlackVue Fleet Tracking, access 90-days’ worth of GPS data.",
	"Remote Video Playback": "Remote Video Playback",
	"Play videos stored_": "Play videos stored in the Cloud or in your dashcam anytime on your smartphone or tablet.",
	"Event Live Auto Upload": "Event Live Auto Upload",
	"Save a video stream_": "Save a video stream in real time to the Cloud. Protect yourself from break-ins and theft.",
	"Event File Auto Upload": "Event File Auto Upload",
	"Save Event videos_": "Save Event videos to the Cloud—including seconds before trigger—after they happen.",
	"Firmware-Over-the-Air (FOTA)": "Firmware-Over-the-Air (FOTA)",
	"Upgrade your dashcam’s": "Update your dashcam over the cloud",
	"When an Event_": "When an Event is created (Impact detected or manually triggered), Event Live Auto-upload lets your Cloud-compatible BlackVue save a live video stream from a camera of your choice (front or rear/interior) to the Cloud server",
	"Event File Auto-upload_": "Event File Auto-upload lets your dashcam automatically upload low-resolution versions of Event files to the Cloud.",
	Master: Master$b,
	"per Camera": "per Camera",
	"Event live auto upload_": "Event live auto upload compatible with all cloud cameras",
	"Drive report": "Drive report",
	"USA/Canada Toll Free": "USA/Canada Toll Free",
	"Monday–Saturday_": "Monday to Friday 8am-7pm / Saturday 9am-6pm (PST).",
	"Please agree to_": "You must accept Terms of Service",
	"Mac or Windows PC": "Mac or Windows PC",
	Develop: Develop$b,
	"Sign out": "Sign out",
	"Referral code": "Code de référence",
	"Total after 1 month trial": "Total après 1 mois d’essai",
	"Already Use Stripe Token": "Utilise déjà un jeton Stripe",
	"Select period": "Sélectionner la période",
	"State/Region": "État/Région (facultatif)",
	"ZIP/Postal": "Code postal",
	"$0.00": "$0.00",
	"$11.99": "$11.99",
	"$24.99": "$24.99",
	$9: $9$b,
	$15: $15$b,
	$10: $10$b,
	"mo + for_": "/mo + {{a}} per extra camera",
	mo: mo$b,
	"This e-mail address_": "Cette adresse e-mail est déjà liée à un compte.",
	"1 month": "1 mois",
	"Limit is reset daily": "La limite est remise à zéro chaque jour",
	"Limit is reset monthly": "La limite est remise à zéro tous les mois",
	"Video plays and downloads": "Lectures et téléchargements de vidéos",
	"Your master": "Your owner",
	"Youre 1 step_": "Vous avez presque terminé votre inscription à l’abonnement Fleet Plan",
	"Finish signing up": "Terminer l’inscription",
	"Enter billing information": "Saisir les informations de facturation",
	"Proceed to billing": "Aller à la facturation",
	City: City$b,
	Charge: Charge$b,
	"User already invited_": "Utilisateur déjà invité par le maître",
	"n% consumed": "{{a}}% utilisés",
	"E-mail already exists": "L’adresse électronique existe déjà",
	"Cancel your inapp_": "Annuler votre abonnement dans l’application",
	"You have cancel_": "Vous devez annuler votre abonnement dans l’application pour souscrire à l’abonnement Fleet Plan : 1. Annulez votre abonnement actuel dans l’App Store ou le Google Play Store. Vous passerez à l’abonnement gratuit à la fin de votre cycle de facturation actuel. Toutes vos données seront conservées. 2. Connectez-vous à votre compte sur blackvuecloud.com et choisissez la mise à niveau vers l’abonnement Fleet Plan.",
	"Edit permissions": "Modifier les autorisations",
	"See permissions": "Voir les autorisations",
	"Submaster removed": "Sous-maître supprimé",
	"Camera removed": "Caméra supprimée",
	"User removed": "Utilisateur supprimé",
	"Users removed": "Utilisateurs supprimés",
	subscribe: subscribe$b,
	search: search$b,
	"permission can be_": "L’autorisation peut être configurée après que le sous-maître ait accepté l’invitation.",
	"The confirmation link_": "Le lien de confirmation n’est plus valide",
	"Possible reasons:_": "Raisons possibles :\n • Vous avez déjà confirmé votre adresse électronique\n • Le lien a expiré ou a été annulé",
	"Failed to register_": "Échec de l’inscription sur BlackVue Cloud",
	"There was an_": "Une erreur s’est produite lors de la procédure d’inscription. Si le problème persiste, essayez de vous inscrire à nouveau sur BlackVue Cloud. Si vous avez besoin d’une aide supplémentaire, veuillez contacter notre service client :",
	"Upgrade to Fleet_": "Mise à niveau vers l’abonnement Fleet Plan",
	"Subscription is Canceled": "L’abonnement est annulé",
	"No members yet": "Pas encore de membres",
	"Please enter_group name": "Saisir un nom de groupe valide",
	"Group Name": "Nom du groupe",
	invalid_number: invalid_number$b,
	invalid_expiry_month: invalid_expiry_month$b,
	invalid_expiry_year: invalid_expiry_year$b,
	invalid_cvc: invalid_cvc$b,
	incorrect_number: incorrect_number$b,
	incomplete_number: incomplete_number$b,
	incomplete_cvc: incomplete_cvc$b,
	incomplete_expiry: incomplete_expiry$b,
	expired_card: expired_card$b,
	incorrect_cvc: incorrect_cvc$b,
	incorrect_zip: incorrect_zip$b,
	invalid_expiry_year_past: invalid_expiry_year_past$b,
	card_declined: card_declined$b,
	missing: missing$b,
	processing_error: processing_error$b,
	"no groups yet": "Pas encore de groupes",
	"groups will show_": "Les groupes apparaîtront ici dès qu’ils seront disponibles",
	"Fleet members will_": "Les membres de la flotte apparaîtront ici dès qu’ils seront disponibles",
	"service provider": "Prestataire de services",
	Paypal: Paypal$b,
	iOS: iOS$b,
	Android: Android$b,
	"Enter email": "Please enter a email address",
	"Enter password": "Veuillez entrer le mot de passe.",
	"Enter first name": "Saisir le prénom",
	"Enter last name": "Saisir le nom de famille",
	"Enter the current_": "Saisir le mot de passe actuel",
	"Enter a new_": "Saisir le nouveau mot de passe",
	"There isnt an_": "Il n’y a pas de compte associé à cette adresse électronique",
	"Fleet Plan": "Fleet Plan",
	Total: Total$b,
	"Password you entered_": "Le mot de passe que vous avez saisi est incorrect",
	"Incorrect email or_": "Adresse électronique ou mot de passe incorrect",
	"Available to Masters": "Disponible pour le propriétaire",
	"Blackvue url": "https://www.blackvue.com",
	"Information We Collect_": "Informations que nous recueillons et objectif",
	And: And$b,
	"Terms of Location-Based_": "Conditions d’utilisation des services géolocalisés.",
	"I agree to the_": "J’accepte les",
	"Password Reset_": "Nous avons envoyé un e-mail à {{a}} avec des instructions de réinitialisation du \n mot de passe.",
	"You have already_": "Vous avez déjà été invité(e), vérifiez votre messagerie électronique.",
	"No data available_": "Pas de données disponibles dans le tableau",
	Camera: Camera$b,
	"You no longer_": "Vous n’avez plus l’autorisation d’utiliser le service de la flotte.",
	"Please contact your_": "Veuillez contacter votre maître de flotte pour résoudre le problème.",
	"You can still_": "Vous pouvez toujours accéder aux",
	"account information": "informations de votre compte.",
	"If the issue_": "Si le problème n’est pas résolu et que vous décidez de continuer à utiliser le service BlackVue Cloud avec l’adresse électronique enregistrée, vous devrez supprimer votre compte et vous inscrire à nouveau.",
	"If the problem_": "Si le problème persiste, contactez notre service client :",
	"Web subscription only": "Abonnement Web uniquement",
	"AppStore url": "https://apps.apple.com/kr",
	"We no longer_": "Nous ne traitons plus les paiements via PayPal. Vous devez mettre à jour votre abonnement pour changer le nombre de caméras : 1. Connectez-vous à votre compte paypal.com et annulez votre abonnement Fleet Plan actuel pour modifier le nombre de caméras : 2. Connectez-vous à votre compte sur blackvuecloud.com et choisissez la mise à niveau vers l’abonnement Fleet Plan.",
	Yes: Yes$b,
	No: No$b,
	"Serial number": "Numéro de série",
	"Cloud code": "Code du Cloud",
	"Terms & Policies": "Conditions et politiques",
	News: News$b,
	Notifications: Notifications$b,
	"km/h": "km/h",
	MPH: MPH$b,
	"Baidu Maps": "Baidu Maps (Chine seulement)",
	"Google Maps": "Google Maps",
	Firmware: Firmware$b,
	Basic: Basic$b,
	"Time Zone": "Fuseau horaire",
	Resolution: Resolution$b,
	"Image quality": "Qualité de l’image",
	Brightness: Brightness$b,
	Recording: Recording$b,
	"Normal recording": "Enregistrement Normal",
	"Voice recording": "Enregistrement vocal",
	"Video segment length": "Longueur du segment vidéo",
	"Rear camera recording": "Enregistrement caméra arrière",
	Highest: Highest$b,
	High: High$b,
	Normal: Normal$b,
	"1 min": "1 minute",
	"2 min": "2 minute",
	"3 min": "3 minute",
	Sensitivity: Sensitivity$b,
	"Motion detection": "Détection des mouvements",
	"Speed alert": "Alerte de vitesse",
	"Voice guidance": "Guide vocal",
	"Power on": "Mise sous tension",
	"Power off": "Mise hors tension",
	"Starting normal recording": "Démarrage de l'enregistrement en Mode Normal",
	"Changing recording mode": "Changement du mode d'enregistrement",
	"Speed alert (beep)": "Alerte de vitesse (bip)",
	"Cloud related": "Info Cloud",
	Volume: Volume$b,
	"User text overlay": "Superposition du texte utilisateur",
	"A-Z, a-z_": "A~Z, a~z, 0~9, :;’/\\+-_()$#\nmoins de 20 caractères.",
	"Wi-Fi auto turn off": "Arrêt automatique du Wi-Fi",
	"Login credentials": "Identifiants de connexion",
	"Manual recording": "Enregistrement Manuel",
	"By sharing your_": "En partageant votre Live View, vous pouvez laisser indirectement d’autres utilisateurs faire l’expérience de la passion et du plaisir de la conduite partout dans le monde.",
	"However, as persona_": "Cependant, comme les vidéos personnelles peuvent être transmises, vous devriez faire particulièrement attention en choisissant les informations que vous partagez.",
	"Please enter_email_2": "S'il vous plaît, mettez une adresse email valide. Le courrier électronique avec des caractères spéciaux peut ne pas être autorisé. ex) +, &",
	"Password is incorrect": "Mot de passe incorrect.",
	"This camera is already_": "Cette caméra est déjà enregistrée dans un compte BlackVue.",
	"Camera name must_": "Le nom de caméra doit contenir 5 à 32 caractères.",
	"Failed to save_": "Echec de la sauvegarde des paramètres de la dashcam.",
	"Unallowed character detected": "Caractère interdit détecté.",
	"File(s) queued for_": "Fichiers en attente de téléversement.",
	"Exceeded video play_": "Limite de téléchargement et de lecture vidéo excédée",
	"Playback Failed": "Echec de la lecture.",
	"Exceeded your Live_": "Limite de temps de Live View excédée.",
	"The camera is not_": "La dashcam n'est pas connectée au serveur.",
	"Please check the connection_": "Veuillez vérifier le statut de connexion de la dashcam sélectionnée.",
	Close: Close$b,
	"Map": "Carte",
	Cloud: Cloud$b,
	Public: Public$b,
	"Flip horizontally": "Retourner horizontalement",
	Front: Front$b,
	Rear: Rear$b,
	Play: Play$b,
	Stop: Stop$b,
	Pause: Pause$b,
	"Next frame": "Image suivante",
	"Previous frame": "Image précédente",
	"Proximity sensor": "Capteur de proximité",
	"Voice recording on/off": "Enregistrement vocal actif/inactif",
	"The BlackVue dashcam_": "La dashcam BlackVue n’est pas compatible avec les réseaux sans fil à 5 GHz.",
	Time: Time$b,
	"Daylight saving time": "Heure d’été",
	System: System$b,
	"Incorrect camera serial_": "Numéro de série incorrect de la dashcam.",
	"Lock event files": "Verrouiller les fichiers d’événements",
	"Overwrite locked event_": "Écraser les fichiers d’événements verrouillés lorsqu’ils sont pleins",
	"Camera settings saved_": "Paramètres de la dashcam sauvegardés avec succès.",
	"Front camera": "Caméra avant",
	"Rear camera": "Caméra arrière",
	Event: Event$b,
	Parking: Parking$b,
	"GPS tracking": "Suivi GPS",
	"G-force detected": "Force d’accélération détectée",
	"Impact detected in_": "Impact détecté en mode parking",
	"Scheduled reboot": "Redémarrage programmé",
	"Recording status": "Témoin d'enregistrement",
	"Rear security": "Sécurité arrière",
	"Time lapse": "Time Lapse",
	"Sync with GPS_": "Synchronisation avec l’heure GPS",
	"Overwrite locked event3_": "Écraser les fichiers verrouillés avec de nouveaux fichiers d’événement lorsque le stockage est plein",
	"Video codec": "Codec vidéo",
	"Tracking logs": "Suivi des journaux",
	"Geofence alerts": "Alerte de géorepérage",
	Color: Color$b,
	Exit: Exit$b,
	Save: Save$b,
	Impact: Impact$b,
	Unlimited: Unlimited$b,
	"Parking mode recording": "Enregistrement en mode parking",
	"Battery protection": "Protection de la batterie",
	"Cut-off timer": "Minuterie d’arrêt",
	"Low voltage cut-off": "Coupure de basse tension",
	"Rear camera orientation": "Orientation de la caméra arrière",
	Default: Default$b,
	"Rotate video 180°": "Faire pivoter la vidéo de 180°",
	"Mirror video": "Vidéo miroir",
	"Wi-Fi band": "Bande Wi-Fi",
	"Driving report": "Rapport de conduite",
	"Unsupported video codec_": "Codec vidéo non pris en charge(H.265).",
	"Rear camera recording_": "Enregistrement de la caméra arrière en mode parking",
	"Front and rear_": "Les caméras avant et arrière enregistrent simultanément",
	"Rear camera stops_": "La caméra arrière arrête l’enregistrement 5 minutes après le passage en mode parking. L’enregistrement redémarre lors du passage en mode normal.",
	"Remote firmware update": "Mise à jour à distance du micrologiciel",
	"Firmware is up-to-date": "Le micrologiciel est à jour",
	"New firmware available": "Nouveau firmware disponible.",
	Version: Version$b,
	"Release date": "Date de sortie",
	Language: Language$b,
	"File size": "Taille du fichier",
	"What’s new": "Quoi de neuf",
	"Updating may take_": "La mise à jour peut prendre plusieurs minutes.",
	"The update process_": "Le processus de mise à jour ne peut pas être annulé.",
	"Do not disconnect the_": "Ne débranchez pas le câble d’alimentation avant que l’enregistrement normal ne redémarre.",
	"Downloading firmware": "Firmware en cours de téléchargement",
	"Once download is_": "Une fois le téléchargement terminé, la dashcam BlackVue redémarrera automatiquement pour appliquer le nouveau micrologiciel.",
	"If not allowed_": "Si ce n’est pas autorisé, l’emplacement et la vitesse de votre voiture ne seront pas accessibles sur le cloud.",
	"Unable to initiate update because_": "Impossible de démarrer la mise à jour, car la dashcam est connectée à un appareil via Wi-Fi direct.",
	Notification: Notification$b,
	Multiple: Multiple$b,
	Range: Range$b,
	"HDR night vision": "Vision nocturne HDR",
	Download: Download$b,
	"G-sensor": "G-Sensor",
	Manual: Manual$b,
	"Low voltage warning": "Avertissement de basse tension",
	Satellite: Satellite$b,
	"Data usage": "Utilisation des données",
	"Select video download quality": "Sélectionnez la qualité de téléchargement vidéo",
	"Quick play file_": "Fichier de lecture rapide (basse résolution)",
	"Original file": "Fichier d'origine",
	"You do not have permission_": "Vous n'êtes pas autorisé à exécuter cette fonction. Veuillez contacter le propriétaire de votre compte principal.",
	"Interior camera recording_": "Enregistrement de la caméra d’intérieur en mode parking",
	"Interior security": "Sécurité d’intérieur",
	"Interior camera rotation": "Rotation de la caméra d’intérieur",
	"Multi View": "Vue multiple",
	Tutorials: Tutorials$b,
	"Upgrade now": "Mettre à niveau maintenant",
	"Members will show_": "Les membres apparaîtront ici dès qu’ils seront disponibles",
	"Are you sure_delete members": "Souhaitez-vous vraiment supprimer définitivement les membres ?",
	"Some members may_": "Certains membres peuvent être masqués en raison des filtres appliqués.",
	"Invited on_": "invité le {{Invited Date}} par vous. Propriétaire",
	Filter: Filter$b,
	"Date created": "Date de création",
	"No admin yet": "Pas encore d’administrateur",
	"You can add_admin": "Vous pouvez ajouter 1 administrateur par groupe",
	"Collapse all": "Réduire tout",
	"Expand all": "Tout développer",
	"Download and playback_cloud": "Télécharger et lire à partir du stockage cloud",
	"Are you sure_2": "Souhaitez-vous vraiment supprimer le groupe {Group name} ?",
	"Are you sure_groups": "Souhaitez-vous vraiment supprimer les groupes ?",
	"Add cameras first_drivers": "Ajouter d’abord des caméras, puis affecter les conducteurs",
	"Flip vertically": "Retourner verticalement",
	Sun: Sun$b,
	Mon: Mon$b,
	Tue: Tue$b,
	Wed: Wed$b,
	Thu: Thu$b,
	Fri: Fri$b,
	Sat: Sat$b,
	Dates: Dates$b,
	Routes: Routes$b,
	Opacity: Opacity$b,
	"Color and opacity": "couleur et opacité",
	"Geofences will show_": "Les géofences apparaîtront ici dès qu’elles seront disponibles",
	"Start drawing a shape_": "commencer à tracer une forme sur la carte",
	"Add geofence": "Ajouter une génofence",
	Entry: Entry$b,
	"Show all members": "Afficher tous les membres",
	"Me and my_": "Moi et ma voiture. Connecté",
	"add-on service for_": "service complémentaire pour BlackVue compatible cloud",
	"Continue with Google": "Continuer avec Google",
	"An account with_": "Un compte utilisant cette adresse électronique existe déjà, mais celle-ci n’est pas vérifiée. Saisissez votre mot de passe BlackVue Cloud existant pour vous connecter.",
	"Account does not_": "Le compte n'existe pas. Ou essayez de vous connecter avec votre compte Apple ou Google.",
	"Continue with Apple": "Continuer avec Apple",
	"Get started": "Commencer",
	"P subscription only": "Abonnement <b>{{a}}</b> uniquement",
	"+N USD for extra camera_": "+{{a}} USD for extra camera up to {{b}} Cameras",
	"Unlimited Live view": "Unlimited Live View",
	"Cameras per Account": "Cameras per Account",
	"Users per Account": "Users per Account",
	Owner: Owner$b,
	"Live View per Day": "Live View per Day",
	"Remote Video Playback_2": "Remote Video Playback and Download per Month",
	"N days": "{{a}} Days",
	"Video On Map": "Video On Map",
	Undetected: Undetected$b,
	Distracted: Distracted$b,
	Drowsy: Drowsy$b,
	"Whether on mobile_": "Whether on mobile or your computer, BlackVue gives you the tools to fully enjoy your dashcam’s functions. Download the latest <a1>firmware</a1>, <a2>mobile</a2> and <a3>desktop</a3> applications, or use <a4>BlackVue web app</a4> in your browser.",
	"Compatible with most_": "Compatible with most Wi-Fi BlackVue models. Cloud support for all Cloud-compatible dashcam models down to DR650GW Series with <b>Cloud Firmware</b>.",
	"Supports most recent BlackVue_": "Supports most recent BlackVue models and compatible with BlackVue Cloud.<br/>\nThis Viewer contains <b>two applications in one</b>: the SD Card Viewer lets you view recorded videos from your SD card and modify the settings of your BlackVue, as well as format the SD card; the <b>Cloud Viewer</b> lets you enjoy BlackVue Cloud.",
	"Contact us": "Contact us",
	"6 characters with": "6 caractères avec un mélange de lettres, de chiffres et de symboles",
	"Apps and more...": "Apps and more...",
	"Cameras will show_": "Cameras will show up here as they become available.",
	"Keep this page_": "Gardez cette page ouverte le temps de vérifier le code de confirmation. Vérifiez votre dossier de courrier indésirable si vous ne trouvez pas l’e-mail dans votre boîte de réception.",
	"n cameras": "{{n}} caméras",
	"n slots": "{{n}} emplacements",
	"Calculate your Fleet_": "Calculez le prix de votre abonnement Fleet Plan",
	"Code you entered_": "Le code que vous avez saisi est erroné/a expiré.",
	Calling: Calling$b,
	Smoking: Smoking$b,
	"Smoking has been_": "Fumeur détecté au volant.",
	"Email is already_": "L’e-mail existe déjà.",
	"Serial number and_": "Le numéro de série et le code cloud sont imprimés sur votre caméra",
	"Allow GPS access": "Autoriser l’accès au GPS",
	"Used to access_": "Permet d’accéder à l’emplacement et à la vitesse de votre véhicule. Vous pouvez modifier les réglages GPS plus tard dans les réglages de confidentialité de votre caméra.",
	"Incorrect cloud code": "Code cloud incorrect",
	"An account is_": "Un compte est déjà enregistré avec cette adresse e-mail.",
	"Live event upload": "Téléchargement d’événements en direct",
	Permissions: Permissions$b,
	"Assign in": "Attribuer dans",
	"Are you sure_camera": "Voulez-vous vraiment supprimer cette caméra ?",
	"Uploading videos:": "Téléchargement de vidéos :",
	"GPS location recording": "Enregistrement de la position GPS",
	"When OFF, GPS_": "Lorsqu’elle est désactivée, la position GPS n’est pas enregistrée ni envoyée au serveur cloud.",
	"As personal video_": "Comme les vidéos personnelles peuvent être transmises, vous devriez faire particulièrement attention en choisissant les informations que vous partagez.",
	"Share location": "Partager l’emplacement",
	Private: Private$b,
	"Used to access_2": "Permet d’accéder à l’emplacement et à la vitesse de votre véhicule.",
	"Share live view": "Partager la vidéo de la vue en direct",
	"Share live audio": "Partager le son de la vue en direct",
	"Share camera’s name": "Partager le nom de la dashcam",
	"Impact detection": "Détection d’Impact",
	Entering: Entering$b,
	Exiting: Exiting$b,
	"Normal event recording": "Enregistrement d’événement normal",
	"Harsh braking": "Freinage abrupt",
	Acceleration: Acceleration$b,
	"Sharp turn": "Virage serré",
	"Parking event recording": "Enregistrement d’événement de parking",
	Passing: Passing$b,
	"Video source": "Source de la vidéo",
	Overspeed: Overspeed$b,
	"Are you sure_video": "Souhaitez-vous vraiment supprimer cette vidéo ?",
	"Add camera to_": "Ajouter la dashcam à Live View",
	"No routes to_": "Aucun itinéraire à afficher",
	"Start by adding_": "Commencez par ajouter des dates.",
	"invite sent": "Invitation envoyée",
	Recipients: Recipients$b,
	Send: Send$b,
	"Routes selected_": "Itinéraires sélectionnés : {{n}} sur {{total}}",
	"Map service": "Service de carte",
	"Speed units": "Unités de vitesse",
	Note: Note$b,
	"Release notes": "Notes de version",
	"The name must_": "Le nom doit comporter de 1 à 30 caractères.",
	Video: Video$b,
	Advanced: Advanced$b,
	"Firmware language": "Langue du firmware",
	"Wi-Fi": "Wi-Fi",
	Voice: Voice$b,
	"Show date and_": "Afficher la date et l’heure",
	"Show speed": "Afficher la vitesse",
	"Front camera rotation": "Rotation de la dashcam avant",
	"Manual time settings": "Réglages manuels de l’heure",
	"Recommended for better_": "Recommandé pour une meilleure compression, une taille de fichier réduite et 4K UHD.",
	"For full compatibility_": "Pour une compatibilité totale avec les anciens appareils de bureau et mobiles.",
	"Up and down": "Haut et bas",
	"Side to side": "D’un côté à l’autre",
	"Front and back": "Avant et arrière",
	"Detection region": "Région de détection",
	"Hotspot 1": "Borne 1",
	"Hotspot 2": "Borne 2",
	"Hotspot 3": "Borne 3",
	"Enter/exit": "Entrer/quitter",
	"Event recording": "Enregistrement d’événements",
	"Front security (Normal)": "Sécurité avant (normal)",
	"Front security (Parking)": "Sécurité avant (parking)",
	"LTE (Parking)": "LTE (parking)",
	"Wi-Fi (Parking)": "Wi-Fi (parking)",
	"Turn on at startup": "Allumer au démarrage",
	"Turn off after_": "Éteindre après 10 min d’inactivité",
	"Your firmware is_": "Votre firmware est à jour",
	"Add admin": "Ajouter un administrateur",
	"Remove All/n": "Supprimer tout/{{a}}",
	"Are you sure_remove": "Souhaitez-vous vraiment supprimer les caméras de ce groupe ?",
	"This will cancel_2": "Cela annulera votre abonnement Fleet Plan. Vous passerez à l’abonnement Free Plan à la fin de votre cycle de facturation actuel.",
	"You’ve reached_": "Vous avez atteint la limite de chauffeurs par caméra",
	"Are you sure_remove admin": "Souhaitez-vous vraiment supprimer l’administrateur {{a}}{{b}} de ce groupe ?",
	"Fleet Plan · Owner": "Fleet Plan · Owner",
	"Manage cameras": "Gérer les caméras",
	"Are you sure_delete zone": "Souhaitez-vous vraiment supprimer la zone « {{zone}} » ?",
	"available on your_2": "{{a}}/{{b}} disponible sur votre plan",
	"The new plan_2": "Le nouveau plan prendra effet à la fin de votre cycle de facturation actuel ({{a}}).",
	"Canceled Fleet Plan_": "Abonnement Fleet Plan annulé le {{a}}",
	"Hard braking alert (beep)": "Alerte de freinage brusque (bip)",
	"Hard acceleration alert (beep)": "Alerte de forte accélération (bip)",
	"Hard cornering alert (beep)": "Alerte de virage serré (bip)",
	"SSID must be_": "Le SSID doit comporter au moins 5 caractères.",
	"Password must be_": "Le mot de passe doit comporter au moins 8 caractères.",
	"5 to 32 characters long": "Comporte 5 à 32 caractères",
	"8 to 32 characters long": "Comporte 8 à 32 caractères",
	"Longer storage period_event": "Période de stockage plus longue pour le téléchargement d’événements en direct",
	"Requires latest firmware_": "Nécessite le dernier firmware. Non compatible avec les modèles DR650S et DR650GW",
	"After Blackvue is_": "Une fois que Blackvue est connecté au cloud, les réglages seront enregistrés.",
	"This is an_": "Cette adresse électronique n’est pas enregistrée. Souhaitez-vous créer un nouveau compte ?",
	"This feature is_": "Cette fonctionnalité est uniquement disponible pour les abonnés de Fleet Plan.",
	"Please return to_": "Le compte n'existe pas. Ou essayez de vous connecter avec votre compte Apple ou Google.",
	"Adjusting the cut-off voltage_": "Adjusting the cut-off voltage to a lower setting may result in your dash cam draining more power from your battery.\nThis could result in warning messages of battery drain or affect other vehicle functions.\nPlease consult with your dealership before lowering the voltage.",
	"Your videos will_": "Vos vidéos apparaîtront ici dès qu’elles deviendront disponibles.",
	"You drove:_": "Vous avez conduit : {{distance}}, {{time}}",
	"Event count per_": "Nombre d’événements par heure de conduite",
	"Are you sure_recipient": "Souhaitez-vous vraiment supprimer ce destinataire ?",
	"(You)": "{{a}} (vous)",
	"All events": "Tous les événements",
	Days_: Days_$b,
	"Requires DMC 200_": "Nécessite une caméra DMC 200",
	"A DMS and compatible_": "Un DMS et une dashcam compatible sont nécessaires pour afficher ce rapport.",
	"Notifications will show_": "Les notifications s’afficheront ici dès qu’elles seront disponibles",
	"Try changing your_": "Essayez de modifier votre date ou de supprimer les filtres.",
	Mute: Mute$b,
	UnMute: UnMute$b,
	"Calling and smoking_": "Les appels et les fumeurs sont détectés uniquement par l’appareil DMC 200",
	"You need a DMS_": "Vous avez besoin d’un DMS pour afficher ce rapport.",
	"Try BlackVue Cloud": "Essayez BlackVue Cloud aujourd’hui",
	"Individual driver looking_": "Chauffeur individuel à la recherche de tranquillité d’esprit ? Propriétaire d’entreprise qui a besoin d’une solution simple de sécurité et de suivi des véhicules ?",
	"Whoever you are_": "Qui que vous soyez, quels que soient vos besoins, il y a un plan Cloud qui vous convient !",
	"It is the account that_Driver": "C’est le compte qui a rejoint votre flotte sur le cloud BlackVue après l’acceptation d’une invitation par e-mail du Propriétaire ou de l’Administrateur. Un chauffeur ne peut être affecté qu’à une seule caméra avec la possibilité limitée de visualiser son propre profil de compte, la vue en direct et la lecture de la caméra qui lui a été affectée.",
	"It is the account that_Admin": "C’est le compte qui a rejoint votre flotte sur le cloud BlackVue après l’acceptation d’une invitation par e-mail du Propriétaire. Les comptes d’administrateur peuvent se voir accorder les droits que le Propriétaire autorise pour cet Administrateur.",
	"Video deleted": "Vidéo supprimée",
	"Video delete_plural": "Vidéos supprimées",
	"Driver removed from_": "Chauffeur supprimé du groupe",
	"Admin removed from_": "Administrateur supprimé du groupe",
	"Camera removed from_": "Caméra supprimée du groupe",
	"Are you sure_videos": "Supprimer le fichier sélectionné ?",
	"You have to cancel_fleet": "Vous devez annuler votre abonnement dans l’application pour modifier le nombre de caméras :\n \n 1. Annulez votre abonnement actuel dans l’App Store ou le Google Play Store. Vous passerez à l’abonnement gratuit à la fin de votre cycle de facturation actuel. Toutes vos données seront conservées. 2. Connectez-vous à votre compte sur blackvuecloud.com et choisissez la mise à niveau vers l’abonnement Fleet Plan.",
	Discard: Discard$b,
	"Discard unsaved changes?": "Abandonner les modifications non enregistrées ?",
	"Incorrect serial number": "Numéro de série incorrect",
	"An error occurred_again": "Une erreur est survenue. Veuillez réessayer.",
	"You are subscribed_free": "Vous disposez d’un abonnement Free Plan de BlackVue Cloud.",
	"When an event_": "Lorsqu’un événement est créé (Impact détecté ou déclenché manuellement), le téléchargement d’événement en direct permet à votre BlackVue d’enregistrer un flux vidéo en direct d’une caméra de votre choix sur le serveur cloud, y compris 5 secondes avant l’événement.",
	Report: Report$b,
	"How it work": "Comment ça fonctionne",
	"Cloud Camera": "Caméra cloud",
	"Internet Connection": "Connexion à Internet",
	"BlackVue App/Viewer": "BlackVue App/Viewer",
	"All you need_": "Tout ce dont vous avez besoin est une",
	"Cloud-compatible BlackVue": "BlackVue compatible avec le cloud",
	"and a cellular_": "et un forfait de données cellulaires. Certains modèles se connectent au cloud via une borne Wi-Fi tierce. D’autres proposent un lecteur de carte nano-SIM intégré ou un module de connectivité enfichable.",
	"Cloud features at_": "Des fonctionnalités cloud à portée de main",
	"Enjoy peace of_": "Ayez l’esprit tranquille en sachant que BlackVue veille sur votre voiture. En cas de problème, votre caméra de tableau de bord vous envoie un message instantanément.",
	"Let your BlackVue_": "Laissez votre BlackVue surveiller votre voiture et vous alerter des incidents. Dès qu’un Impact est détecté, votre BlackVue envoie une notification à votre téléphone ou à votre navigateur Web, accompagnée d’un instantané.",
	"Check on your_": "Surveillez votre voiture de n’importe où avec Remote Live View. Que ce soit via un navigateur Web ou votre téléphone, accédez à un flux vidéo en temps réel à partir de votre dashcam connectée au cloud et alternez facilement les caméras avant, arrière ou intérieures.",
	"Your BlackVue may_": "Votre BlackVue n’empêche peut-être pas les délits de fuite, mais s’ils se produisent, il y a de fortes chances qu’elle capture des preuves vidéo cruciales. Parcourez toutes les vidéos enregistrées par votre caméra de tableau de bord à partir de votre téléphone portable ou d’un navigateur Web.",
	"Worried about eating_": "Vous avez peur de gaspiller votre forfait de données ? La technologie de flux secondaire de BlackVue vous permet d’accéder à des versions ultralégères de vos vidéos pour une navigation rapide et une visualisation sans tampon.",
	"Move files from_": "Déplacez des fichiers de votre BlackVue vers le cloud. Enregistrez une seule vidéo ou sélectionnez plusieurs clips pour un téléchargement groupé. La vidéo téléchargée sur votre téléphone avec l’application BlackVue peut être consultée et partagée à partir du menu Mémoire interne.",
	"View your vehicle’s_": "Affichez l’emplacement et la vitesse de déplacement de votre véhicule en temps réel. Passez à l’abonnement Smart Plan pour accéder aux 7 derniers jours de données de suivi GPS.",
	"Get more with_": "Obtenez plus avec l’abonnement Smart Plan",
	"Unlimited Remote Live_": "Remote Live View illimité",
	"Up to 3 dashcams_": "Jusqu’à 3 dashcams par compte",
	"Want to track_": "Vous voulez suivre une flotte entière ? Mise à niveau vers l’abonnement Fleet Plan",
	"BlackVue Fleet Tracking_2": "BlackVue Fleet Tracking est une solution tout-en-un pour protéger et suivre votre flotte. Les fonctionnalités et la tarification évoluent de manière flexible pour répondre aux besoins de votre entreprise.",
	"Stream real-time video_": "Diffusez de la vidéo en temps réel sans limites. Débit binaire : 600 kbit/s",
	"Up to 999 Dashcams": "Jusqu’à 999 dashcams",
	"Register up to_": "Enregistrez jusqu’à 999 dashcams par compte",
	"15GB of Cloud_": "15 Go de stockage cloud",
	"15GB per additional_": "15 Go par dashcam supplémentaire. Stockage d’upload automatique d’événements illimité.",
	"90-days GPS_": "Journaux de suivi GPS de 90 jours",
	"High accuracy: 15_": "Haute précision : 15 secondes, Vidéo sur une carte, exportation facile des données.",
	"Unique fleet management_": "Des fonctionnalités uniques de gestion de flotte ajoutent de la valeur et de la commodité",
	"Create geofences and_": "Créez des géofences et recevez des notifications en temps réel sur votre téléphone ou votre ordinateur.",
	"View at a_": "Affichez en un coup d’œil la distance totale parcourue, le temps d’inactivité, les excès de vitesse, etc., dans des tableaux qui peuvent être imprimés ou exportés.",
	"Multi Live View": "Live View multiple",
	"Monitor up to_": "Surveillez jusqu’à 4 dahscams simultanément",
	"Benefits for you": "Avantages pour vous",
	Individual: Individual$b,
	"Get notifications to_2": "Recevez des notifications sur votre téléphone lorsque votre voiture stationnée est heurtée. Vérifiez à distance ce qui se passe autour de votre voiture. Disponible sur le Web, les mobiles, Mac et Windows.",
	"Small business owner": "Propriétaire de petite entreprise",
	"Monitor your commercial_2": "Surveillez vos véhicules utilitaires sur une carte en temps réel. Parlez à vos chauffeurs à tout moment à l’aide de votre navigateur, l’application mobile BlackVue, la visionneuse Mac ou Windows.",
	"Company with large_": "Entreprise avec une grande flotte",
	"With BlackVue Fleet_2": "Avec BlackVue Fleet Tracking, suivez jusqu’à 999 véhicules en temps réel via votre navigateur, l’application mobile BlackVue, la visionneuse Mac ou Windows.",
	Subscribed: Subscribed$b,
	"The video was_": "La vidéo a déjà été téléchargée.",
	Geofence: Geofence$b,
	"500: Internal server error": "500 : Erreur interne du serveur",
	"404: Page not found": "404 : Page introuvable",
	"Check the web address_": "Vérifiez l’adresse Web ou revenez à la page d’accueil de BlackVue Cloud",
	"home page": "Home page",
	"There isn’t an_": "Il n’y a pas de compte associé à cette adresse électronique",
	"You can now_password": "Vous pouvez désormais vous connecter avec votre nouveau mot de passe",
	"Are you sure_remove admin2": "Souhaitez-vous vraiment supprimer définitivement l’administrateur ,",
	"Admin deleted": "Administrateur supprimé",
	"Members deleted": "Membres supprimés",
	"Are you sure_groupName": "Souhaitez-vous vraiment supprimer le groupe {{a}} ?",
	"Requires latest firmware": "Nécessite le dernier firmware",
	"Selected file(s) moved_": "Déplacement réussi des fichier(s) sélectionné(s)",
	"Are you sure_remove driver2": "Souhaitez-vous supprimer le chauffeur {{a}} ({{b}}) de ce groupe ?",
	"Invite sent": "Invitation envoyée",
	"Safe driving": "Conduite prudente",
	"Reckless driving": "Conduite imprudente",
	"Inattentive driving": "Conduite inattentive",
	"Driving events trend": "Évolution des événements de conduite",
	"Driving details": "Détails de conduite",
	Driving: Driving$b,
	Idling: Idling$b,
	Distance: Distance$b,
	"Parking sessions": "Sessions de parking",
	"Parked time": "Parked time",
	"Idle stops": "Arrêts au ralenti",
	"Idle time": "Temps de ralenti",
	"Impact events": "Impact Events",
	Parked: Parked$b,
	Speed: Speed$b,
	"Overspeeding alerts": "Alertes d’excès de vitesse",
	Highest_2: Highest_2$b,
	Average: Average$b,
	Geofences: Geofences$b,
	"Entries into a_": "Entrées dans une zone",
	"Exits from a_": "Sorties d’une zone",
	"No data": "Pas de données",
	"Hard acceleration": "Accélération",
	"Hard braking": "Freinage abrupt",
	"Hard cornering": "Virage serré",
	"The number within the brackets_": "Le nombre entre parenthèses indique le nombre moyen d’événements par heure de conduite. Si vous conduisez moins d’une heure par jour, le nombre total d’événements s’affiche.",
	"Did you insert_": "Avez-vous inséré une carte SIM ?",
	"Click here for_": "<a>Cliquez ici</a> pour accéder à des guides plus détaillés.",
	"Back up all_": "<b>Sauvegardez tous les enregistrements importants avant d’enregistrer ces réglages.</b><br/>Lorsque vous sauvegardez les paramètres, la carte microSD est réinitialisée et tous les enregistrements sont supprimés pour assurer un fonctionnement stable.",
	"Not connected to_": "Non connecté au cloud. Certaines fonctionnalités ont été temporairement désactivées.",
	"GPS Location recording off": "Enregistrement de la position GPS désactivé",
	"n Videos deleted": "{{count}} vidéos supprimées",
	Move: Move$b,
	"Driver Monitoring System (DMS) will_": "Le système de surveillance des chauffeurs (DMS) sera lancé prochainement.",
	"An error occured while_": "Une erreur s’est produite lors de la tentative de modification du nombre de caméras. Réessayer",
	"Reached the limit_": "Limite atteinte : {{a}}",
	"An invitation was_": "Une invitation a déjà été envoyée à cette adresse e-mail.",
	"To use the_": "Pour utiliser la fonctionnalité cloud. Veuillez insérer votre carte SIM.",
	"Last updated": "Dernière mise à jour {{date}}",
	"Try changing your date": "Essayez de changer votre date.",
	"No event data_": "Aucune donnée d’événement collectée pour l’heure sélectionnée",
	"Please select another_": "Veuillez sélectionner un autre jour ou mois pour afficher l’intégralité du rapport.",
	"more than 6_": "plus de 6 caractères requis",
	"Sign up free": "Inscription gratuite",
	"Cloud storage warning": "Avertissement du stockage cloud",
	"Cloud Storage Full": "Stockage cloud plein",
	"Cloud storage usage_100": "L’usage du stockage cloud a atteint 100%. Veuillez effacer une partie du stockage pour pouvoir utiliser le téléchargement d’événements en direct",
	"Cloud storage usage_": "L’usage du stockage cloud a atteint <b>({{a}}%)</b>. \nOrganisez votre stockage cloud.\nLe service de téléchargement d’événements en direct n’est pas disponible si le stockage cloud est plein.",
	"Are you sure_delete_zone": "Voulez-vous vraiment supprimer?",
	"Search Name or email": "Rechercher un nom ou un e-mail",
	"Search group name": "Rechercher le nom du groupe",
	"Please note that_": "Veuillez noter que l’enregistrement vidéo s’arrête pendant quelques secondes pour appliquer les nouveaux réglages.",
	"Currently connected Hotspot": "Borne actuellement connectée",
	"Enhanced night vision": "Vision nocturne améliorée",
	"To access the_": "Pour accéder à la caméra, veuillez mettre à jour votre abonnement.",
	"Restarting the Blackvue_": "Redémarrage de la BlackVue pour appliquer les paramètres.",
	"Hard acceleration event_": "Un événement de forte accélération se produit lorsque la croissance du taux par seconde est supérieure à {{kmh}} km/h",
	"Hard braking event_": "L’événement de freinage brusque se produit lorsque la réduction du taux par \nseconde est supérieure à {{kmh}} km/h",
	"Hard cornering event_": "L’événement de virage serré se produit lorsque plus de 60 degrés de rotation se produisent dans les 2 secondes suivant une conduite à plus de\n{{kmh}} km/h",
	"Changes you made_": "Les modifications que vous avez apportées peuvent ne pas être enregistrées.",
	"My location": "Ma position",
	"Hotspot name (SSID)": "Nom de la borne (SSID)",
	Connected: Connected$b,
	"Camera will be rebooted_": "La caméra sera redémarrée. Voulez-vous quand même continuer ?",
	"Restarting the BlackVue_": "Redémarrage de la BlackVue. Veuillez patienter un instant.",
	"Failed to reboot_": "Échec du redémarrage de la caméra",
	"Bluetooth (Parking mode)": "BT (mode parking)",
	"Front and interior camera_": "La caméra avant et la caméra intérieure enregistrent en même temps.",
	"Interior camera stops_": "La caméra intérieure arrête l’enregistrement 5 minutes après le passage en mode parking. L’enregistrement redémarre lors du passage en mode normal.",
	Individual_: Individual_$b,
	"Driver detection": "Détection du conducteur",
	"During driving only": "Au volant uniquement",
	Always: Always$b,
	"Driver detection box": "Boîte de détection du conducteur",
	"DMS camera rotation": "Rotation de la caméra DSM",
	Low: Low$b,
	Medium: Medium$b,
	High_2: High_2$b,
	"Reboot Camera": "Redémarrer la caméra",
	"Latest events": "Derniers événements",
	"G-Sensor": "G-Sensor",
	"Playback speed": "Vitesse de lecture",
	Flip: Flip$b,
	Previous: Previous$b,
	Next: Next$b,
	"Map type": "Type de carte",
	"Zoom in": "Zoom avant",
	"Zoom out": "Zoom arrière",
	"Move to Cloud": "Déplacer vers le cloud",
	"Please recognize that_": "Veuillez tenir compte du fait que l’enregistrement vidéo s’arrête pendant quelques secondes pour appliquer les réglages.",
	"6 characters with_": "6 caractères avec un mélange de lettres, de chiffres et de symboles",
	"Updating firmware": "Mettre à jour le firmware",
	"Overspeed event occurs_": "L’événement de l’excès de vitesse se produit lorsque la dashcam avertit le conducteur que la limite de vitesse a été dépassée. Vous pouvez le modifier dans Firmware > Système > Volume",
	"Enter group name": "Saisir le nom de groupe",
	"Live view failed": "Echec du Live View.",
	"Parking mode enter_": "Entrée/sortie du mode parking",
	"Cloud connectivity": "Connectivité cloud",
	Expand: Expand$b,
	Collapse: Collapse$b,
	"all day": "Toute la journée",
	"Driving style": "Style de conduite",
	"Driving impact": "Impact de conduite",
	More: More$b,
	"No cameras to_": "Aucune dashcam à ajouter",
	"You have added_": "Vous avez ajouté toutes les dashcams disponibles.",
	Multi: Multi$b,
	"Report video": "Signaler la vidéo",
	"Sexually explicit content": "Contenu sexuel",
	"Graphic violence": "Violente ou répulsive",
	"Hateful speech": "Haineuse ou abusive",
	"Harassment or bullying": "Harcèlement ou intimidation",
	"Spam or advertisement": "Spam ou publicité",
	"Infringement of my_": "Porte atteinte à mes droits",
	"Other reason": "Etc.",
	"Reason for reporting": "Raisons du signalement",
	"Reported videos will_": "Les vidéos signalées seront vérifiées dans les 72 heures. La vidéo ne sera pas affichée sur la carte des événements tant qu’il n’aura pas été confirmé qu’elle peut y être publiée.",
	"Touch sensor": "Capteur tactile",
	"Motion and impact detection": "Détection de mouvement et d’Impact",
	"Settings have been changed": "Les paramètres ont été modifiés",
	"Start event recording (beep)": "Démarrer l’enregistrement d’événement (bip)",
	"Scheduled reboots": "Redémarrages programmés",
	Safe: Safe$b,
	Reckless: Reckless$b,
	Inattentive: Inattentive$b,
	"Highest(Extreme)": "Très élevée (Extrême)",
	"Public cameras": "Dashcams publiques",
	List: List$b,
	Usage: Usage$b,
	"Video playbacks and downloads": "Lectures vidéo et téléchargement",
	"of 100 times": "de 100 fois",
	"of 10 minutes": "de 10 minutes",
	Profile: Profile$b,
	"Search geofences": "Rechercher des géofences",
	"Export CSV": "Exporter au format CSV",
	"Exit fullscreen": "Quitter le plein écran",
	Fullscreen: Fullscreen$b,
	Upgrade: Upgrade$b,
	"Email address": "Adresse e-mail",
	"of Unlimited": "d’Illimité",
	"No notifications yet": "Aucune notification reçue au cours des 7 derniers jours.",
	"No videos yet": "Pas encore de vidéos",
	Management: Management$b,
	Day: Day$b,
	Month: Month$b,
	"Welcome to the BlackVue_": "Bienvenue dans BlackVue Cloud Viewer",
	"You can access BlackVue_": "Vous pouvez accéder à BlackVue Cloud depuis le Web à tout moment, de n’importe où !",
	"Start tour": "Visite guidée",
	"Map view": "Vue cartographique",
	"Check the current_": "Vérifiez la position GPS actuelle et la vitesse de vos dashcams et de vos dashcams publiques.",
	"Camera’s features": "Caractéristiques de la dashcam",
	"Take a look_": "Jetez un coup d’œil aux différentes fonctionnalités liées au cloud fournies par la dashcam BlackVue.",
	"Visualize your vehicle’s_": "Affichez l’itinéraire de conduite de votre véhicule au fil du temps.",
	"Smart plan_": "Smart Plan : 90 jours, Fleet Plan : 90 jours",
	"Create geofences and2_": "Créez des géofences et recevez des notifications en temps réel.",
	"Got it": "Compris",
	"Manage Fleet members": "Gérer les membres de la flotte",
	"Invite fleet members_": "Invitez les membres de la flotte et affectez-les à des groupes.",
	"The moment the_": "Au moment où la dashcam détecte les Impacts, les notifications seront répertoriées ici.",
	"Geofence Setup (Web)_": "Configuration de la géofence (Web/bureau) et alertes",
	"Original file play_": "La lecture des fichiers originaux n’est disponible qu’au téléchargement",
	"To get most_": "Pour tirer le meilleur parti du BlackVue Cloud Viewer, votre dashcam doit être connectée au cloud. Téléchargez l’application BlackVue et découvrez l’association transparente, de l’ajout de la dashcam à la connexion au cloud en une seule fois !",
	"You haven’t driven_Today": "Vous n’avez pas encore conduit votre voiture aujourd’hui. Essayez de conduire votre voiture avec BlackVue pour consulter votre rapport de conduite.",
	"You haven’t driven_Month": "Vous n’avez pas encore conduit votre voiture ce mois-ci. Essayez de conduire votre voiture avec BlackVue pour consulter votre rapport de conduite.",
	"Fleet Plan only_": "Uniquement Fleet Plan est disponible",
	"Overwrite locked event2_": "Écraser les fichiers d’événements verrouillés lorsque le stockage est plein",
	"DMS’s New firmware_": "Nouveau firmware de DMS disponible",
	"Highest speed_report": "<b>Vitesse la plus élevée</b>\nPlus grande valeur des données de vitesse collectées qui est collectée en mètres, Conversion en km/h et MPH \n\n<b>Vitesse moyenne Vitesse </b>\nmoyenne de (distance/heures de conduite) * 3 600. Ex. (2622/1208)*3600 = 7 814,907\nkm/h : Entier uniquement, \nle séparateur fractionnaire des MPH est jusqu’à 2 chiffres après la valeur entière",
	"Choose a cloud_": "Choisir une méthode de connexion au cloud",
	"You need an_": "Vous avez besoin d’une connexion Internet pour vous connecter au cloud. Sélectionnez l’appareil que vous utilisez pour vous connecter au cloud.",
	"BlackVue SIM card": "Carte SIM Blackvue",
	"Support model_": "Modèle pris en charge : DR750X-2CH LTE Plus (NA)",
	"3rd party SIM_": "Carte SIM de tiers",
	"Support model_SIM": "Modèle pris en charge : DR750X-2CH LTE Plus, DR750-2CH LTE, CM100 LTE",
	"Wi-fi hotspot": "Borne Wi-Fi",
	"Support model_Wifi": "Modèle pris en charge : Tous les modèles BlackVue",
	"How to connect_": "Comment se connecter au cloud",
	"Download BlackVue application": "Téléchargez l’application BlackVue.",
	"*If you are_": "*Si vous envisagez d’utiliser la carte SIM BlackVue pour votre connexion au cloud, accédez à {{a}} {{b}}.",
	"Place your phone_": "Assurez-vous que votre téléphone est à portée Bluetooth de la dashcam. Démarrez votre association transparente par {{a}}.",
	"Back to camera_": "Retour à la liste des caméras",
	"Upgrade for more_": "Mettez à niveau pour plus de fonctionnalités !",
	"Upgrading the cloud_": "La mise à niveau du forfait cloud vous permet de profiter de plus de fonctionnalités et de gérer plusieurs dashcams. Souhaitez-vous mettre à niveau votre forfait cloud ?",
	"Explore cloud plans": "Explorer les forfaits cloud",
	Later: Later$b,
	"Successfully subscribed": "Vous êtes bien inscrit !",
	"1GB data plan": "Forfait de données de 1 Go",
	"First month free_": "Premier mois gratuit, <a>puis 10,99 USD/mois</a>",
	"Next billing date": "Prochaine date de facturation",
	"Once SIM card_": "Une fois la carte SIM insérée dans la dashcam, vous pouvez lancer immédiatement les fonctionnalités du BlackVue Cloud.",
	"Go to SIM_": "Accéder à la gestion de la carte SIM",
	"Manage your BlackVue_": "Gérez votre carte SIM BlackVue ici !",
	"Recommended for BlackVue_": "Recommandé pour les détenteurs de carte SIM BlackVue",
	"Connect to cloud": "Se connecter au cloud",
	"Enter BlackVue SIM_": "Saisir le numéro ICCID de la carte SIM BlackVue",
	"ICCID number is_": "Le numéro ICCID est imprimé sur l’emballage de la carte SIM. Veuillez saisir les 14 derniers chiffres du numéro ICCID.",
	ICCID: ICCID$b,
	"SIM information": "Informations SIM",
	"Start your free_": "Commencer votre essai gratuit",
	"SIM card activate_": "Date d’activation de la carte SIM",
	"Based on the_": "En fonction de la date à laquelle la carte SIM est insérée dans la dashcam et activée lors de la mise sous tension",
	"Upgrade to 3GB_": "Passez à un forfait de 3 Go/5 Go à tout moment",
	"Cancel your plan_": "Annulez votre forfait à tout moment",
	"No Commitment": "Aucun engagement",
	"Precautions for using_": "Précautions d’utilisation du service",
	"After 1GB is_": "1 Go Une fois le Go utilisé, l’Internet ne sera plus disponible.",
	"If you have_": "Si vous avez déjà inséré une carte SIM dans la dashcam et que vous l’utilisez, la période d’essai gratuite commence à partir du moment où vous commencez à l’utiliser.",
	"This content is_": "Ce contenu est spécifié dans l’emballage de la carte SIM. Nous ne prenons pas en charge la compensation des périodes gratuites qui n’ont pas été fournies.",
	"If you have_2": "Si vous avez d’autres questions, veuillez contacter <a>l’équipe du service client</a>",
	"When OFF, connecting_": "Lorsque la dashcam est éteinte, sa connexion par association transparente est désactivée.",
	"1 month free": "1 mois gratuit",
	"No commitment. Cancel_": "Aucun engagement. Vous pouvez annuler à tout moment.",
	"The video has been reported_": "La vidéo a été signalée avec succès",
	"Free for 1 month": "Gratuit pendant un mois",
	"Start your free_2": "Démarrez votre essai gratuit",
	"1GB free for_": "1 Go gratuit pour {{a}} jours",
	"1GB data": "1 Go de données",
	"1 month free_2": "Le mois d’essai gratuit commencera à partir de {{a}}, en incluant 1 Go de données pour la carte SIM Blackvue.",
	"Your next billing_": "Votre prochaine date de facturation est le {{a}}",
	"SIM card": "Carte SIM",
	"SIM guide": "Guide de la carte SIM",
	"SIM card list": "Liste de la carte SIM",
	"Add SIM card": "Ajouter la carte SIM",
	"No SIM card_": "Pas encore de carte SIM",
	"Search SIM ICCID_": "Rechercher l’ICCID ou le nom de la carte SIM",
	"Cloud disconnected. Failed_": "Cloud déconnecté. Impossible de lire la vidéo",
	"This sim card_": "Cette carte SIM est déjà enregistrée dans un autre compte.",
	"Incorrect BlackVue SIM_": "ICCID incorrect de la carte SIM BlackVue",
	"My shared videos": "Mes vidéos partagées",
	"Number of events": "Nombre d’événements",
	"Added to Event Map": "Ajouté à la carte des événements",
	"Successfully added video(s)_": "Ajout réussi de vidéos à partager sur la carte des événements ! Si vous souhaitez vérifier l’état et gérer les vidéos partagées, accédez à Carte des événements > Mes vidéos partagées.",
	"Already added to_": "Déjà ajouté à la carte des événements",
	"This video(s) is already added_": "Cette vidéo est déjà ajoutée à la carte des événements ! Si vous souhaitez vérifier l’état et gérer les vidéos partagées, accédez à Carte des événements > Mes vidéos partagées.",
	"BlackVue’s firmware is up_": "Le firmware de BlackVue est à jour",
	"Service end": "Fin du service",
	Resubscribe: Resubscribe$b,
	"Sort ascending": "Trier par ordre croissant",
	"Sort descending": "Trier par ordre descendant",
	plan: plan$b,
	USD: USD$b,
	"Are you sure_Cancel": "Voulez-vous vraiment supprimer votre compte ? Veuillez noter ce qui suit et confirmer ci-dessous.",
	"Your current SIM_": "Votre abonnement actuel à la carte SIM se termine le {{a}} et vous ne serez plus facturé.",
	"After canceling your_": "Après avoir annulé votre abonnement à la carte SIM, vous continuerez à utiliser les données SIM jusqu’à la date de fin de votre abonnement.",
	"You can resubscribe_": "Vous pouvez vous réabonner dans un délai de 1 mois après la fin de votre abonnement actuel. Si vous souhaitez vous réabonner, veuillez cliquer sur le bouton « Se réabonner » dans la liste des cartes SIM avant le {{a}} pour vous réabonner.",
	"Reason to cancel_": "Raison d’annuler l’abonnement",
	"Found an alternative": "Une alternative a été trouvée",
	"Too expensive": "Trop cher",
	"Not required anymore": "N’est plus nécessaire",
	"Quality issue": "Problème de qualité",
	etc_: etc_$b,
	"Please describe in_": "Veuillez fournir une description détaillée.",
	"SIM card cannot_": "La carte SIM ne peut pas être supprimée, car elle est utilisée dans un abonnement. Si vous souhaitez supprimer cette carte SIM, veuillez d’abord annuler votre abonnement.",
	"SIM card cannot_2": "La carte SIM ne peut pas être supprimée, car l’abonnement à cette carte SIM n’est pas encore terminé. Veuillez réessayer après la fin de votre abonnement.",
	"Are you sure_deleteSIM": "Voulez-vous vraiment supprimer cette carte SIM ?<br>\n<b>Avertissement : Vous ne pouvez pas annuler cette action. Toutes les informations de votre carte SIM seront immédiatement supprimées.</b>",
	"ICCID number": "Numéro ICCID",
	"Activation date": "Date d’activation",
	"Current plan": "Forfait actuel",
	"Manage Plan": "Gérer le forfait",
	"Next billing on": "Prochaine facture le",
	"View Invoices": "Voir les factures",
	"Choose best plan_": "Choisissez le meilleur forfait pour vous",
	"Plan summary": "Résumé des forfaits",
	"Ends on_": "Se termine le {{a}}",
	"Start from_": "Démarre le {{a}}",
	"Your subscription will_": "Votre abonnement sera mis à niveau le {{a}}, lorsque votre forfait actuel prendra fin.",
	"Resubscribe plan": "Se réabonner à un forfait",
	"Your subscription will2_": "Votre abonnement commencera le {{a}}, lorsque votre forfait actuel prendra fin.",
	"Usage is estimated_": "L’utilisation est estimée à partir du {{a}}",
	"Days left_": "{{a}} jours restants",
	"Data usage cycle": "Cycle d’utilisation des données",
	Available: Available$b,
	Used: Used$b,
	"Data used": "Données utilisées",
	"Subscribe to n_": "Abonnez-vous au forfait de données {{a}} appliqué <b>du {{b}} à {{c}}</b> et au forfait de données {{d}} appliqué à partir du {{e}}",
	"Will be charged_": "Sera facturé le {{a}}",
	"Monthly usage": "Utilisation mensuelle",
	"You have fewer_": "Il vous reste moins de données pour ce mois-ci !",
	"Get more data": "Obtenez plus de données !",
	"This video cannot be shared": "Cette vidéo ne peut pas être partagée",
	"This is a video cannot be shared_": "Il s’agit d’une vidéo qui ne peut pas être partagée, car les informations de conduite ne peuvent pas être trouvées à ce moment-là.",
	Cancelled: Cancelled$b,
	Terminated: Terminated$b,
	"Edit name": "Modifier le nom",
	"Not connected to_2": "Non connecté au cloud. Vérifiez si votre dashcam est allumée et si le module de connectivité Internet est activé.",
	"Some functionality is disabled_": "Certaines fonctionnalités sont désactivées, car la dashcam n’est pas connectée au cloud. Connectez-vous au cloud <a>ici</a>.",
	"If you want to cancel_": "Si vous souhaitez annuler votre forfait, cliquez sur <a>Annuler l’abonnement</a>.",
	"Select plan": "Sélectionner un forfait",
	"Event map collects_": "La carte des événements recueille et visualise les informations sur les événements BlackVue pour fournir les situations des routes environnantes.",
	"Share your Live_": "Partagez votre fichier de téléchargement des événements en direct. Vous pouvez partager vos vidéos d’événement avec d’autres utilisateurs autour de vous.",
	"You can check_": "Vous pouvez consulter les vidéos d’événement partagées par d’autres.",
	"Service end_": "Fin du service : {{a}}",
	"DMS camera recording_": "Enregistrement de la dashcam DMS en mode parking",
	Sort: Sort$b,
	"Are you sure you want_": "Voulez-vous vraiment supprimer la vidéo partagée de la carte des événements ?",
	"Remove shared video": "Supprimer la vidéo partagée",
	"Explore event map": "Explorer la carte des événements",
	"Event map": "Carte des événements",
	"Explore the graphic_": "Explorez les statistiques graphiques des événements BlackVue qui se passent autour de vous.",
	"You can filter_": "Vous pouvez filtrer et afficher les événements que vous souhaitez afficher.",
	"This video was removed by_": "Cette vidéo a été signalée et supprimée par l’administrateur.",
	Bonus: Bonus$b,
	"Your subscription plan": "Votre forfait d’abonnement",
	"Your free trial will_": "Votre essai gratuit commencera à partir du {{a}},<br><strong>jusqu’au</strong> {{b}}.",
	"Total after free trial": "Total après l’essai gratuit",
	"This sim card is_": "Cette carte SIM n’est plus active.",
	"Firmware is up_": "Le firmware est à jour",
	"Keep in mind": "À retenir",
	"Once 1GB of_": "Une fois que 1 Go de données a été utilisé, le service ne sera pas disponible avant la prochaine date de réinitialisation des données [ou après la mise à niveau de votre forfait vers un niveau supérieur].",
	"After the SIM_": "Une fois la carte SIM insérée dans la dashcam, la période d’essai gratuite commence lorsque vous commencez à utiliser des données.",
	"If you have_questions": "Si vous avez des questions, veuillez contacter notre <a>service client.</a>",
	"Data reset date": "Date de réinitialisation des données",
	"To use SIM card_": "Pour utiliser la carte SIM, veuillez contacter <a>l’équipe de service client</a> de BlackVue",
	"Go to Subscription": "Accédez à Abonnement",
	"An error occurred_subscription": "Une erreur s’est produite lors de l’abonnement au forfait sélectionné.",
	"Please try again": "Veuillez réessayer",
	"Failed to subscribe": "L’abonnement n’a pas abouti",
	"Go to Pricing": "Accéder à Tarification",
	"SIM cards will_": "Vos cartes SIM apparaîtront ici dès qu’elles deviendront disponibles.",
	"1GB for 1_": "1 Go pendant 1 mois",
	"Pricing Data": "Données de tarification",
	"If you would like to check_": "Si vous souhaitez vérifier l’état et gérer les vidéos partagées, accédez à Carte des événements > Mes vidéos partagées.",
	"Connect to Cloud": "Se connecter au cloud",
	"Completed!": "Terminé!",
	"Back to App": "Retour à l’application",
	"iOS in-app purchase": "Achat intégré pour iOS",
	"Android in-app_": "Achat intégré pour Android",
	"bonus n days": "bonus de {{a}} jours",
	"Want to contribute your_": "Autoriser le partage automatique des fichiers à téléchargement automatique des événements vers la carte des événements ?",
	"With event map_": "Vous pouvez partager la vidéo de téléchargement automatique des événements avec les conducteurs à proximité via la carte des événements.",
	"You can edit_3": "Vous pouvez modifier à tout moment le partage automatique des fichiers à téléchargement automatique des événements dans les paramètres de la carte des événements en accédant à BLACKVUE CLOUD >Paramètres de la dashcam > Paramètres de confidentialité.",
	"If you want to remove videos_": "Comme les vidéos personnelles peuvent être transmises, vous devriez faire particulièrement attention en choisissant les informations que vous partagez.",
	"Total events": "Nombre total d’événements",
	"Automatically add Live Event_": "Partage automatique des fichiers à téléchargement automatique des événements vers la carte des événements",
	"This camera is publicly_": "Cette dashcam est ouverte publiquement pour son emplacement uniquement.",
	incomplete_zip: incomplete_zip$b,
	"Live Event Upload_": "Téléchargement d’événements en direct (période de stockage : 7 jours)\nNécessite le dernier firmware",
	"Thank you for_2": "Merci pour votre patience.",
	"Start Web viewer": "Lancer le visualiseur Web",
	"Are you sure_remove driver": "Souhaitez-vous vraiment supprimer définitivement le conducteur",
	"An error occurred_sim": "Une erreur s’est produite pendant la tentative d’abonnement.",
	"Click the ADD SIM": "Appuyez sur le bouton AJOUTER UNE CARTE SIM sur la page de la liste des cartes SIM, puis suivez à nouveau le processus d’ajout de carte SIM.",
	"Set download options": "Définir les options de téléchargement",
	"Information may be_": "Information may be transmitted with a delay and may not reflect actual balances.",
	"Swipe left and right to move": "Balayez vers la gauche et la droite pour déplacer",
	"Scheduled maintenance Notice": "Avis de maintenance planifiée",
	"Our Cloud server_": "Notre serveur cloud fera l’objet d’une maintenance programmée.",
	"During that time_": "Pendant ce temps, les fonctionnalités cloud peuvent ne pas être disponibles.",
	"Expected maintenance start_": "Heure de début de la maintenance prévue :",
	"Expected duration_": "Durée prévue : {{a}} heures.",
	"For more information_": "Pour plus d’informations, reportez-vous à l’<a>[Avis de maintenance des serveurs]</a>",
	"Do not remind_": "Ne plus me le rappeler",
	"Cloud Server Maintenance": "Maintenance des serveurs cloud",
	"BlackVue Cloud Service_": "Le service BlackVue Cloud est temporairement indisponible",
	"We are currently_": "Nous effectuons actuellement une maintenance.",
	"We apologize for_": "Nous nous excusons pour ce désagrément.",
	"Driver Monitoring System (DMS)": "Système de surveillance des conducteurs (DMS)",
	"Distracted occurs_": "Se produit lorsque la tête du conducteur est à plus de 50 degrés de l'avant.",
	"Hand distraction event occurs_": "Se produit lorsque la main du conducteur est détectée près de sa tête pendant une période prolongée (comme lorsqu'il fume, tient un téléphone, etc.).",
	"Mask off event occurs_": "Se produit lorsque le conducteur monte dans le véhicule sans masque ou lorsque le conducteur retire son masque.",
	"DMS setting": "Paramètre DMS",
	"The DMS system has_": "Le DMS combine une boîte de détection faciale pour les états \"Détecté\", \"Non détecté\", \"Distrait\", \"Somnolent\", \"Masque retiré\" et une boîte de détection de mouvement pour l'état \"Distraction avec la main\".",
	"DMS detection": "Détection du DMS",
	"There are detection criteria for_": "Il y a des critères de détection pour chaque événement. Veuillez vous référer au guide ci-dessous.",
	"DMS camera recording_onoff": "Activé : La caméra DMS enregistre en mode Parking tant que l'alimentation est maintenue. <br/> Désactivé : La caméra DMS s'éteint peu de temps après avoir activé le mode Parking.",
	"LED lighting for each event_": "Le voyant LED de la caméra de surveillance du conducteur signalera chaque événement de détection (Distraction, Somnolence, etc.).\n",
	"Drowsy and Distracted each have_": "Les états Somnolent et Distrait ont chacune trois conditions de sensibilité.\n Veuillez vous reporter à l’interface du guide ci-dessous.",
	"DMS event detection sensitivity": "Sensibilité de détection des événements DMS",
	"Only drowsy and distracted include_": "Seuls les paramètres de sensibilité sont inclus dans les états Somnolent et Distrait. De plus, la sensibilité définie applique la même sensibilité à deux événements avec un paramètre.",
	"When driver’s eyes close_": "Se produit lorsque le conducteur ferme les deux yeux pendant plus d'une seconde ou baille pendant 2 secondes.\n",
	"n digit": "{{a}} chiffres",
	"You are subscribed_free_Smart": "Vous disposez d’un abonnement Smart Plan de BlackVue Cloud.",
	"Wi-Fi auto turn on": "Activation automatique Wi-Fi",
	"Video on a map": "Video on a map",
	"This feature is only_vom": "This feature is only available to users with a Fleet Plan subscription.<br/>Please subscribe to a plan to unlock this feature.",
	"Total n days_": "{{a}}jours d'expérience gratuite",
	"Every events of DMC200_": "Les fonctionnalités de détection DMS ne sont actives que en mode normal. Si le mode parking est activé, la caméra DMS enregistre uniquement la vidéo.",
	"An undetected event occurs_": "Se produit lorsque le conducteur n'est pas détecté devant la caméra pendant 1 minute.",
	"A detected event occurs_": "A detected Event occurs when the driver is gazing in front since the power is set in the beginning.",
	"Drowsy sensitivity_": "High : When the driver closes their eyes for more than 1 second, it is considered drowsy driving.<br/><br/>Medium : When the driver closes their eyes for more than 1.5 second, it is considered drowsy driving.<br/><br/>Low : When the driver closes their eyes for more than 2 second, it is considered drowsy driving.",
	"Distracted sensitivity_": "High : If the angle of the head is more than 50 degrees away from the front for 3 seconds, it is detected as Distracted.<br/><br/>Medium : If the angle of the head is more than 50 degrees away from the front for 5 seconds, it is detected as Distracted.<br/><br/>Low : If the angle of the head is more than 50 degrees away from the front for 7 seconds, it is detected as Distracted.",
	"Start your subscription now": "Commencez votre abonnement dès maintenant",
	"Free trial period has expired": "La période d’essai gratuite a expiré",
	"1 data plan will start from_": "Le forfait de données commencera à partir dur {{a}}, y compris 1 Go de données pour la carte SIM Blackvue.",
	"Allow the BlackVue_": "Autoriser l’application BlackVue à accéder aux données GPS de votre caméra ?",
	"We use this_": "Nous utilisons cette fonction pour vous permettre de suivre l’emplacement et la vitesse de votre voiture.",
	"You can edit_": "Vous pouvez modifier les paramètres d’accès du GPS à tout moment en vous rendant dans BLACKVUE CLOUD > Paramètres caméra > Paramètres de confidentialité.",
	"SIM cards": "Cartes SIM",
	"Subscription status": "État de l'abonnement",
	Upgrades: Upgrades$b,
	"Upgrade plan": "Mettre à niveau l’abonnement",
	"Manage plan": "Gérer le plan d'abonnement",
	"Next plan": "Plan d'abonnement pour le mois prochain",
	OR: OR$b,
	"Cancel subscription": "Annuler l'abonnement",
	Undo: Undo$b,
	Invoice: Invoice$b,
	"Daily usage": "Utilisation quotidienne des données",
	"Delete SIM": "SIM Supprimer",
	"New card": "Nouvelle carte de crédit",
	data: data$b,
	"SIM card data_": "L’abonnement au forfait de données de la carte SIM peut être annulé sur <a>sim.blackvuecloud.com</a>.",
	"Your plan from_": "Votre forfait d’aujourd’hui à la prochaine date de facturation",
	"Applied during_": "Appliqué pendant {{a}} ~ {{b}}",
	"From today until_": "À partir d’aujourd’hui et jusqu’à la prochaine date de paiement, vous ne pouvez souscrire qu’au même forfait que le mois précédent. Les paiements pour cette période seront facturés aujourd’hui. <a>Les frais sont calculés au prorata.</a>",
	"Choose your next plan": "Choisir votre prochain forfait",
	"Applied from_": "Appliqué à partir de {{a}}",
	"Payment for this_": "Le paiement de ce forfait sera facturé le {{a}}.",
	"By sharing your_2": "En partageant votre Live View, vous pouvez laisser indirectement d’autres utilisateurs faire l’expérience de la passion et du plaisir de la conduite partout dans le monde. Cependant, comme les vidéos personnelles peuvent être transmises, vous devriez faire particulièrement attention en choisissant les informations que vous partagez.",
	"Option camera recording_": "Enregistrement de la caméra optionnelle en mode parking",
	"Front and option camera_": "La caméra avant et la caméra optionnelle enregistrent en même temps.",
	"Option camera stops_": "La caméra optionnelle arrête l’enregistrement 5 minutes après le passage en mode parking. L’enregistrement redémarre lors du passage en mode normal.",
	"Option camera rotation": "Rotation de la caméra optionnelle",
	"Option camera": "Caméra optionnelle",
	"Option camera security": "Sécurité de la caméra optionnelle",
	"Resubscribe until_": "Se réabonner jusqu’au : {{a}}",
	"Firmware Update Caution": "Mise en garde sur la mise à jour du firmware",
	"Please check below_": "Veuillez vérifier la condition ci-dessous avant la mise à jour du firmware pour la DMC200 :",
	"The camera's Wi-Fi_": "Le Wi-Fi de la caméra doit être activé.",
	"Check if your_": "Vérifiez si le Wi-Fi de votre caméra est activé.",
	"DO NOT disconnect_": "NE DÉCONNECTEZ PAS le câble coaxial lors de la mise à jour du firmware.",
	"The camera and_": "La caméra et la DMC200 peuvent être séparées.",
	"DO NOT try_": "N’essayez PAS d’utiliser d’autres fonctionnalités tant que la caméra n’a pas fini de redémarrer.",
	"Expecially Reboot camera_": "En particulier pour le redémarrage de la caméra, le format de carte SD peut être critique pour séparer deux appareils.",
	"Update anyway": "Mettre à jour quand même",
	"Invited on_2": "invité le {{Invited Date}} par vous. Propriétaire",
	"BlackVue’s New firmware_": "Nouveau firmware disponible de BlackVue",
	"valid thru_": "valide jusqu’au : {{a}}",
	"Billed monthly": "Billed monthly",
	"90 minutes Live_": "90 minutes Live View / Live Event Upload*",
	"or 2+ videos_": "or 2+ videos in full resolution*",
	"1GB Free Month_": "1GB Free Month Trial",
	"Cancel anytime": "Cancel anytime",
	"8+ hours Live_": "8+ hours Live View / Live Event Upload*",
	"or 12+ videos_": "or 12+ videos in full resolution*",
	"15+ hours Live_": "15+ hours Live View / Live Event Upload*",
	"or 23+ videos_": "or 23+ videos in full resolution*",
	Popular: Popular$b,
	"For Power Users": "For Power Users",
	"Estimates based on_": "* Estimates based on 4.5MB per minute of Live View, Quick View remote playback, or Live Event Upload file, and 190MB per full original resolution video download or playback (at 25Mbps bitrate). Daily idle Cloud connection data usage: 20MB per 24 hours. Data usage is shared among all types of services (Live View, Live Event Upload, etc.).",
	"Balanced Plan": "Balanced Plan",
	"For Light Cloud_": "For Light Cloud Use",
	"Front security (Normal mode)": "Sécurité avant (mode normal)",
	"Front security (Parking mode)": "Sécurité avant (mode parking)",
	"BT (Parking mode)": "BT (mode parking)",
	"LTE (Parking mode)": "LTE (mode parking)",
	"Wi-Fi (Parking mode)": "Wi-Fi (mode parking)",
	"Hand distraction": "Mouvement des mains",
	Mask: Mask$b,
	"Second drowsy is_": "Une deuxième somnolence est une somnolence qui se produit dans les 30 secondes suivant la première somnolence qui a initié l’enregistrement du chargement de l’événement en direct.",
	"Second drowsy alert": "Alerte de deuxième somnolence",
	"BlackVue sim card_": "La carte SIM BlackVue ne peut être utilisée qu’au Canada et aux États-Unis.",
	"Global support is coming soon.": "Le support mondial sera bientôt disponible.",
	"The video file not found_": "Le fichier vidéo n’a pas été trouvé, ou il y a eu un problème pendant la lecture. Veuillez réessayer.",
	"Start Voice Call": "Démarrer l’appel vocal",
	"End Voice Call": "Terminer l’appel vocal",
	"Voice call in use": "Appel vocal utilisé",
	"Enable microphone access_": "Activez l’accès au microphone pour utiliser la fonction de communication vocale bidirectionnelle. Accédez à la page de paramétrage du navigateur pour accéder à votre microphone.",
	"You may need to_": "Vous devrez peut-être actualiser cette page pour que les nouveaux paramètres prennent effet.",
	"Eye status": "État des yeux",
	"Start time of live event upload video": "Heure de début du téléchargement de la vidéo de l’événement en direct",
	"Left eye": "Œil gauche",
	"Right eye": "Œil droit",
	"Drowsy is occured when the driver close his/her eyes more then 1sec": "La somnolence survient lorsque le conducteur ferme les yeux plus d’une seconde",
	"Driver's Left eye movements with blinking count and period": "Mouvements de l’œil gauche du conducteur avec nombre de clignements d’yeux, nombre de périodes et période",
	"Driver's Right eye movements with blinking count and period": "Mouvements de l’œil droit du conducteur avec le nombre de clignements d’yeux et la période",
	"Drowsy big data of the driver and after a Drowsy event occurs": "Big data du clignement de l’œil du conducteur après un événement de somnolence",
	"Sharing video to Event Map": "Partager la vidéo sur la carte des événements",
	"Want to use a Voice call?": "Vous voulez utiliser un appel vocal ?",
	"To use a voice call_": "Pour utiliser un appel vocal, redémarrez Live View et cliquez sur « Autoriser »",
	"There is no_": "Il n’y a pas encore de vidéos partagées. \nLa liste s’affichera lorsqu’elle sera partagée.",
	"Microphone blocked": "Microphone bloqué",
	"Want to center the map on your location?": "Vous souhaitez centrer la carte sur votre emplacement ?",
	"To let the app access your location_": "Pour permettre à l'application d'accéder à votre emplacement, redémarrez Event Map et sélectionnez \"OK\" lorsque vous y êtes invité.",
	"Location access permission required": "Une autorisation d'accès à l'emplacement est requise.",
	"Are you sure you want_2": "Êtes-vous sûr de vouloir supprimer cette vidéo d'Event Map ?",
	"Two-way voice_2": "Two-way voice communication / Voice Call",
	"Not supported by DR650GW and DR650S_": "Not supported by DR650GW and DR650S",
	"DR650S Series only_": "DR650S Series only",
	"Cancel download?": "Annuler le téléchargement ?",
	"Your download is not_": "Votre téléchargement n’est pas terminé. Voulez-vous annuler le téléchargement ?",
	"Continue download": "Continuer le téléchargement",
	"Cancel download": "Annuler le téléchargement",
	"Share your video to the Event Map?": "Partager votre vidéo sur la carte des événements ?",
	"Afterwards, according to the reaction to the video_": "Ensuite, en fonction de la réaction à la vidéo, celle-ci peut être classée comme une vidéo populaire et introduite dans Vidéos populaires.",
	"Add hashtags and a brief description to describe your video.": "Ajoutez des hashtags et une brève description pour décrire votre vidéo.",
	"Would you like_": "Voulez-vous partager la carte des événements ?",
	"Successfully added video_": "Ajout réussi de la vidéo à partager sur la carte des événements !",
	"This video cannot_": "Cette vidéo ne peut pas être partagée, car il manque des données de localisation GPS pour l’épingler sur la carte.",
	"This video is_": "Cette vidéo est déjà ajoutée à la carte des événements.",
	"Share to Event Map": "Partager sur la carte des événements",
	"Describe in more_": "Décrivez plus en détail ce qui se passe dans votre vidéo (facultatif)",
	"Description(optional)": "Description (facultatif)",
	"Recording mode": "Mode d’enregistrement",
	"Event triggers": "Déclencheurs d’événements",
	DMS: DMS$b,
	"Camera connectivity": "Connectivité de la caméra",
	"If not allowed_2": "Si ce n’est pas autorisé, l’emplacement et la vitesse de votre voiture ne seront pas accessibles dans le cloud.",
	"Share Live View_": "Partager la vidéo de la vue en direct",
	"Share Live View_2": "Partager le son de la vue en direct",
	"Share camera profile": "Partager le profil de caméra",
	"Parking impact": "Impact de stationnement",
	"Parking events": "Parking Events",
	"Audio recording": "Enregistrement audio",
	"Toggle the mic_": "Activer/désactiver le micro",
	"Full HD_": "Full HD @ 60fps + Full HD @ 30fps",
	"Video quality": "Qualité vidéo",
	Extreme: Extreme$b,
	"More video files": "Plus de fichiers d’enregistrement",
	"Fewer video files": "Moins de fichiers d’enregistrement",
	"Camera rotation": "Rotation de la dashcam arrière",
	"Video overlay": "Superposition vidéo",
	"Date & time display": "Affichage de la date et de l’heure",
	"Speed unit": "Unité de vitesse",
	"Check the orientation_": "Vérifiez l’orientation de la caméra avant installée dans le véhicule. Sélectionnez l’option correspondante pour enregistrer les vidéos dans une orientation verticale.",
	"Rotate 180º": "Tourner de 180°",
	"Rear camera rotation": "Rotation de la dashcam arrière",
	"Check the orientation_rear": "Vérifiez l’orientation de la caméra arrière installée dans le véhicule. Sélectionnez l’option correspondante pour enregistrer les vidéos dans une orientation verticale.",
	"Mirror View": "Vue en miroir",
	"Select Mirror View_": "Sélectionnez Vue en miroir pour retourner la vidéo horizontalement.",
	"Check the orientation_interior": "Vérifiez l’orientation de la caméra facultative installée dans le véhicule. Sélectionnez l’option correspondante pour enregistrer les vidéos dans une orientation verticale.",
	"Display off": "Affichage desactive",
	"Explore crowd-sourced Events_": "Découvrez les événements participatifs (impact, freinage brusque, etc.) sur la carte, regardez les vidéos partagées par la communauté et contribuez à vos propres événements.",
	OFF: OFF$b,
	"Reboots once-a-day_": "Redémarre une fois par jour à l’heure préréglée en mode parking pour une meilleure stabilité.",
	"Set time": "Régler l’heure",
	"FW language": "La langue du firmware",
	"Rear security_2": "Sécurité arrière",
	"Bluetooth (Parking mode)_2": "Bluetooth (mode parking)",
	"Failed to save_2": "Échec de l’enregistrement du paramètre d’upload des événements en direct",
	"Event file will_": "Le fichier de l’événement sera automatiquement enregistré dans le stockage dédié à l’upload des événements en direct.",
	"An impact was_": "An Impact was detected during Parking Mode.",
	"When exiting Parking_": "Lorsque vous quittez le mode Parking, votre BlackVue annonce si un impact a été détecté dans ce mode. \n\n Remarques : \n Les impacts génèrent des vidéos d’événements. Les impacts générés dans les 3 minutes avant et après la sortie du mode parking sont ignorés.",
	"Protect event files": "Protéger les fichiers d’événements",
	"Turning on this_": "Activez cette option pour protéger les derniers {{a}} fichiers d’événements contre l’écrasement par les fichiers d’enregistrement en mode Normal ou Parking.",
	"Impact Events in_": "Impact Events in Normal(E) and Parking Mode(I)",
	"Manual Events_": "Manual Events (M)",
	"Once 50 Events_": "Les fichiers protégés comprennent : \n\nÉvénements d’impact en mode Normal(E) et Parking(I) \nÉvénements manuels (M) \n\nUne fois que {{a}} événements ont été enregistrés, les nouveaux événements écrasent les plus anciens.",
	"Reckless driving unit": "Unité de conduite imprudente",
	"Hard acceleration Event": "Événement d’accélération brutale",
	Threshold: Threshold$b,
	"Triggers when the_": "Se déclenche lorsque la caméra détecte un taux d’accélération par seconde supérieur à la valeur seuil définie.",
	"Triggers when the_2": "Se déclenche lorsque la caméra détecte une réduction de vitesse supérieure à la valeur seuil définie.",
	"Hard braking Event": "Événement de freinage brusque",
	"Triggers when more_": "Se déclenche lorsque plus de 60 degrés sont détectés dans les 2 secondes lors d’une conduite au-dessus de la valeur seuil définie.",
	"Every event of DMC200_2": "Les fonctionnalités de détection du DMS ne sont actives que en mode normal. Si elle est alimentée en mode parking, la caméra DMS enregistrera uniquement des vidéos.",
	"The DMS system has_2": "Le DMS combine une boîte de détection faciale pour les états “Détecté”, “Non détecté”, “Distrait”, “Somnolent”, “Masque retiré” et une boîte de détection de mouvement pour l'état “Distraction avec la main”.",
	"One for face_": "One for face detection : Detected, Undetected, Distracted, Drowsy",
	"The other for_": "The other for motion detection",
	"On: Normal recording_": "On: Normal recording works while power is maintained in Parking Mode",
	"Off: DMS power_": "Off: DMS power off after 5 minutes when entering Parking Mode, Normal recording works until just before off",
	"Drowsy and Distracted_": "Drowsy and Distracted each have three sensitivity conditions.",
	"Please refer to_": "Please refer to the guide interface below.",
	Drowsiness: Drowsiness$b,
	"Drowsiness occurs when_": "La somnolence survient lorsque le conducteur ferme les deux yeux pendant plus d'une seconde en conduisant et baille pendant 2 secondes.",
	"Distracted occurs when_": "Se produit lorsque la tête du conducteur est à plus de 50 degrés de l'avant.",
	"A hand distraction_": "A hand distraction occurs when the driver removes one hand from the steering wheel. [*Smoking and phone calls may be suspected.]",
	"Mask off event_": "Mask-off event occurs in two ways. First is when the driver gets in the car without a mask. Second is when the driver takes their mask off",
	"High When the_": "High : When the driver closes their eyes for more than 1 second, it is considered drowsy driving.",
	"Middle When the_": "Medium : When the driver closes their eyes for more than 1.5 second, it is considered drowsy driving.",
	"Low When the_": "Low : When the driver closes their eyes for more than 2 second, it is considered drowsy driving.",
	"High If the_": "High : If the angle of the head is more than 50 degrees away from the front for 3 seconds, it is detected as Distracted.",
	"Middle If the_": "Medium : If the angle of the head is more than 50 degrees away from the front for 5 seconds, it is detected as Distracted.",
	"Low If the_": "Low : If the angle of the head is more than 50 degrees away from the front for 7 seconds, it is detected as Distracted.",
	Direct: Direct$b,
	"Camera Wi-Fi credentials": "Informations d’identification Wi-Fi de la caméra",
	"Network name(SSID)": "Nom du réseau (SSID)",
	"Seamless pairing": "Seamless Pairing",
	Remote: Remote$b,
	"Hotspot settings": "Paramètres de la borne",
	"Hotspot name": "Nom de la borne (SSID)",
	"Hotspot name must_": "Hotspot name must be at least 5 characters long",
	"Public cameras may_": "Les caméras publiques peuvent apparaître dans l'onglet Explorer ou sur la carte du monde.",
	"Hard Cornering Event": "Événement de virage brusque",
	"Over speed_2": "Vitesse excessive",
	"Second drawiness alert": "Deuxième alerte de somnolence",
	"Low Voltage Warning_2": "Mouvement des mains",
	"(You)_2": "{{a}} (Vous)",
	"This video has been reported_": "Cette vidéo a été signalée et supprimée par l’administrateur.",
	"Normal Mode recording": "Enregistrement en mode normal",
	"ON : the camera_": "ACTIVÉ : la caméra enregistre en continu en boucle.",
	"OFF : the camera_": "DÉSACTIVÉ : la caméra enregistre uniquement des vidéos événementielles pendant la conduite.",
	"In both modes_": "Dans les deux modes, les impacts détectés déclenchent des enregistrements vidéo d’événements.",
	"Continuously records_": "Enregistre en continu des vidéos d’une minute, à raison d’une image par seconde, qui couvrent 30 minutes d’action.",
	"Choose detection regions_": "Choisissez les zones de détection afin de réduire le risque de déclencher des enregistrements de mouvements indésirables dus à des arbres se balançant au vent, des objets en mouvement lointains, etc.",
	"Your previous plan is expired.": "Votre plan précédent a expiré.",
	"Upgrade the plan to restore the camera": "Mettre à niveau le plan pour restaurer la caméra\n(%@)",
	"Remove from cloud": "Supprimer du cloud",
	"Are you sure you want to Remove_": "Souhaitez-vous vraiment la supprimer de cet emplacement pour le cloud ?",
	"Remove: It doesn’t mean_": "Supprimer : Il ne s’agit pas de supprimer les données de la caméra, mais de créer un emplacement de rechange pour le nombre de caméras cloud.",
	"Now the camera is removed from cloud slot": "La caméra a été retirée de l’emplacement pour le cloud.",
	"How to delete camera list": "Comment supprimer une caméra de la liste",
	Update: Update$b,
	"Camrea setting": "Réglage de la caméra",
	"Notification setting": "Paramètres de notification push",
	"Driving reports": "Rapport de conduite",
	"Cloud connection steps": "Étape de Connexion au Cloud",
	"Download the BlackVue app to add a camera": "Téléchargez l’application BlackVue pour ajouter une caméra",
	"To see your camera in the BlackVue cloud viewer_": "Pour voir votre caméra dans le BlackVue Cloud Viewer, vous devez d’abord la connecter au cloud. Installez et connectez facilement votre caméra BlackVue au cloud avec l’application BlackVue pour iOS et Android.",
	"Download the BlackVue app to see a Wi-Fi connected camera": "Télécharger l’application BlackVue pour voir une caméra connectée par Wi-Fi",
	"BlackVue Cloud web viewer only supports_": "La visionneuse Web BlackVue Cloud ne prend en charge que la dashcam connectée au cloud. Veuillez télécharger l’application BlackVue pour voir votre dashcam connectée en Wi-Fi.",
	"You can restore the data if_": "Vous pouvez restaurer les données si vous enregistrez à nouveau cette caméra sur le même compte. Mais s’il est supprimé, tous vos fichiers seront perdus.",
	"How to add camera": "Comment ajouter une caméra",
	"Try to wait 2-3 minutes if you just registered the camera.": "Essayez d’attendre 2 à 3 minutes si vous venez d’enregistrer la caméra.",
	"Try to check the Cloud Connection Settings again_": "Essayez de vérifier à nouveau les paramètres de connexion au cloud, si la caméra ne se connecte toujours pas au cloud.",
	"Motion Detection": "Détection de mouvement",
	"Parking recordings occur_": "Les enregistrements en mode parking ont lieu lorsqu’un mouvement visible est détecté.",
	"Motion Sensitivity": "Sensibilité au mouvement",
	"Motion Detection Sensitivity": "Sensibilité de détection de mouvement",
	"Select Detection Region": "Sélectionnez la région de détection",
	"Speed alert_2": "Alerte de vitesse",
	"Live Event Upload_2": "Live Event Upload",
	"Beep Alert": "Avertissement sonore",
	"Parking Impact History_": "Alerte sur l’historique des impacts en mode parking",
	"To register your_": "Pour enregistrer votre bouton SOS, vous devez utiliser l'application BlackVue.",
	"SOS button on/off": "État du bouton SOS",
	"File sharing to Event Map is_": "Le partage de fichiers vers Event Map n'est actuellement pas disponible. Veuillez revenir plus tard.",
	"Email Notifications": "Notifications par email",
	"Push Notifications_2": "Notifications Push",
	"Optional Camera Rotation": "Orientation de la dashcam optionnelle",
	"Optional Camera Security": "Sécurité de la caméra optionnelle",
	Option: Option$b,
	"(Owner)": "{{a}} (Propriétaire)",
	"SOS button": "Bouton SOS",
	"This video has been reported_bold": "Cette vidéo a été signalée et <b>supprimée par l’administrateur.</b>",
	"Number of events_2": "Nombre d’événements",
	"My Shared Videos": "Mes vidéos partagées",
	"No Hashtags": "Pas de hashtags",
	"I have read and agree_": "J’ai lu et j’accepte toutes les conditions et politiques",
	"14 years old_": "14 ans ou plus",
	Required: Required$b,
	Optional: Optional$b,
	"Profile information_": "Les informations du profil peuvent être modifiées sur la page Paramètres du compte.",
	"Automatically Add Live_": "Partage automatique des fichiers à téléchargement automatique des événements vers la carte des événements",
	"You must be 14 years_": "Vous devez avoir 14 ans ou plus pour créer un compte BlackVue",
	"Use 8 or more characters_": "Utilisez 8 caractères ou plus avec un mélange de lettres, de chiffres ou de symboles.",
	"Protected files include_": "Les fichiers protégés comprennent : <br/>ㆍÉvénements d’impact en mode Normal(E) et Parking(I) <br/>ㆍÉvénements manuels (M)<br/><br/>Une fois que {{a}} événements ont été enregistrés, les nouveaux événements écrasent les plus anciens.",
	"Protected files include": "Protected files include",
	"If you turn_": "Si vous désactivez le guidage vocal, les listes suivantes sont également désactivées.",
	"Live Event Upload_success": "Les paramètres d’upload des événements en direct ont été enregistrés avec succès.",
	"Video type": "Types de vidéos",
	"Notify the Owner": "Notifier le propriétaire",
	"Adjusting the cut-off voltage_2": "Adjusting the cut-off voltage to a lower setting may result in your dash cam draining more power from your battery. This could result in warning messages of battery drain or affect other vehicle functions.\nPlease consult with your dealership before lowering the voltage.",
	Others: Others$b,
	"This video has been removed.": "Cette vidéo a été supprimée.",
	"Please assign cameras_": "Veuillez affecter des caméras à ce groupe.",
	"Are you running_": "Vous n’avez plus de possibilités d’effectuer de lecture ?",
	"Upgrade your plan_": "Passez à la formule Fleet Plan pour bénéficier de la lecture illimitée et d’autres fonctions exclusives au cloud.",
	"Are you running_Liveview": "Vous manquez de temps pour regarder Live View ?",
	"Upgrade your plan_Liveview": "Passez à la formule Fleet Plan pour bénéficier du Live View illimité et d’autres fonctionnalités exclusives au cloud.",
	Stay: Stay$b,
	"Go to Fleet Plan": "Passer à l’abonnement Fleet Plan",
	"It looks like the video file is being prepared. please try again later.": "Il semble que le fichier vidéo est en cours de préparation. Veuillez réessayer plus tard.",
	"Oops!": "Oops!",
	"Please back up_": "Veuillez sauvegarder tous les enregistrements importants avant de modifier ce paramètre.",
	"When you save_": "Lorsque vous enregistrez les paramètres, la carte microSD sera formatée et tous les enregistrements seront supprimés pour assurer un fonctionnement stable.",
	"This is an unregistered_": "Il s'agit d'un e-mail non enregistré. Souhaitez-vous accéder à la page Créer un compte ?",
	"Camera name must_2": "Le nom de la caméra doit comprendre entre 5 et 32 caractères.",
	"G-sensor (Normal mode)": "Capteur G (Mode Normal)",
	"G-sensor (Parking mode)": "Capteur G (Mode Parking)",
	"Up & down": "Haut-bas",
	"Front & back": "Avant et arrière",
	"Rotate Video 180º": "Rotate Video 180º",
	Mask_2: Mask_2$b,
	"Priority event": "Priority Event",
	"There is no_camera": "There is no camera that your owner assigned to you.",
	"Camera SSID": "Camera SSID",
	"The BlackVue dashcam_2": "The BlackVue dashcam is not compatible with 5GHz wireless networks",
	"Driver detection box_2": "Driver Detection Box",
	"DMS camera recording_2": "DMS Camera Recording in Parking Mode",
	Low_2: Low_2$b,
	Medium_2: Medium_2$b,
	High_3: High_3$b,
	"Live Event Upload_3": "Live Event Upload",
	"Driving Impact": "Driving Impact",
	"Video source_2": "Video Source",
	"Front camera_2": "Front Camera",
	"Rear camera_2": "Rear Camera",
	"Optional Camera": "Optional Camera",
	"Motion Detection_2": "Motion Detection",
	"Rear camera stops_2": "Rear camera stops recording 5 minutes after entering Parking Mode. Recording restarts when entering normal mode.",
	"Passenger vehicle": "Passenger Vehicle",
	"Heavy vehicle": "Heavy Vehicle",
	Highest_3: Highest_3$b,
	Extreme_2: Extreme_2$b,
	"Less recording files": "Fewer Recording Files",
	"Camera rotation_2": "Camera Rotation",
	"Share camera profile_2": "Share Camera Profile",
	Private_2: Private_2$b,
	"BlackVue Live": "BlackVue Live",
	"Important All saved_": "Important! All saved videos are about to be deleted. Tap Cancel and back up important files if needed.",
	"Whenever saving settings_": "Whenever saving settings after changing the time zone, the SD card is initialized and all stored files are deleted.",
	"Do you want_": "Do you want to save your changes?",
	"No groups": "No groups",
	Lite: Lite$b,
	"USD per Camera": "USD per extra Camera",
	"up to Cameras": "up to Cameras",
	"All the P Plan_": "Toutes les fonctionnalités du plan <b>{{a}}</b>, plus :",
	"User Roles and Permissions": "Rôles et autorisations utilisateur",
	"Geofence Setup (Web) and alerts": "Geofence Setup (Web) and alerts",
	"N Times": "{{a}} Fois",
	"N Minutes": "{{a}} Minutes",
	"Emergency Alarm": "Alarme d'urgence",
	"Playback, Live View": "Lecture, Live View",
	"Your driving record : Daily, Monthly": "Votre dossier de conduite : Quotidien, Mensuel",
	"Real-time Conversation": "Conversation en temps réel",
	"Initiate a conversation_": "Initiez une conversation avec le pilote via le haut-parleur et le microphone du dashcam.",
	"Remote Voice Communication": "Communication vocale à distance",
	"See the last location_": "Voir le dernier emplacement de votre appareil photo",
	"Check your cars_": "Vérifiez les données GPS en temps réel de votre voiture sur une carte pour localiser votre véhicule et obtenir des informations sur son statut, par exemple s'il est en conduite ou en stationnement, et sa vitesse.",
	"Supported models_": "* Modèles pris en charge: modèles S de la série S et Early X",
	"GPS Tracking &_": "Suivi GPS et vidéo sur la carte (intelligent / flotte)",
	"Track your cars_": "Suivez l'emplacement et la vitesse de votre voiture sur la carte!",
	"GPS Tracking: visualize_": "Suivi GPS: Visualisez votre journal de conduite sur la carte.\nVidéo sur la carte: afficher les informations contextuelles (vitesse, type d'événement) et lire des vidéos connexes directement à partir de la carte.",
	"Visualize your cars_": "Visualisez la position et la vitesse de votre voiture sur la carte !",
	"The feature enables_": "Cette fonctionnalité permet de télécharger des vidéos dans le cloud, y compris les 5 secondes précédant un accident.",
	"Camera profile setting": "Camera profile setting",
	"Are you running_Download": "Are you running out of chance to Download Video?",
	"Upgrade your plan_Download": "Upgrade your plan to Fleet Plan for Unlimited Download, and other Cloud -Exclusive features.",
	"This feature is available for Smart and Fleet_": "This feature is available for Smart and Fleet Plan subscribers only.",
	"Rear camera will keep_": "La caméra arrière cesse d'enregistrer en mode stationnement lorsque l'état de température du dashcam est changé en \"Température élevée\". La caméra arrière reprendra l'enregistrement après que l'état de température du dashcam soit revenu à \"Température normale\". (Attention : Pour protéger l'électronique, Blackvue pourrait s'éteindre en raison de températures extérieures élevées).",
	"Get Unlimited Cloud_": "Obtenez une lecture infinie en cloud et gérez jusqu'à {{a}} caméras.",
	"Up to N cameras_": "Up to {{a}} cameras (+ {{b}} USD Extra charge)",
	"N Minutes per Day": "{{a}} minutes par jour",
	"Drowsiness sensitivity is_": "La sensibilité à la somnolence est définie par la période de clignotement des yeux avec un algorithme fiable BlackVue. <br> <br> Lasensibilité à la distraction est définie par l’angle de la position de la tête du conducteur par rapport à l’avant et le temps passé dans cette position.",
	"Not available with this plan": "Not available with this plan",
	"The optional camera records_": "La caméra optionnelle enregistre en mode de stationnement",
	"Smart and Fleet_": "Smart and Fleet Plan<br/>subscribers only",
	"This feature is_smart": "This feature is available for Smart and Fleet Plan subscribers only.",
	"Camera Registration": "Enregistrement de caméra",
	"Voice Call": "Voice Call",
	"N times per Month": "{{a}} times per Month",
	"Recommended for higher bitrate_": "Recommandé pour un débit binaire plus élevé et une meilleure qualité vidéo.",
	"Recommended for for better compatibility_": "Recommandé pour une meilleure compatibilité avec les appareils de bureau et mobiles",
	"A minute of front camera_": "Taille du fichier estimé pour une vidéo de 1 minute (caméra frontale)",
	"Extreme(N Mbps): N MB_": "Extreme ({{ex1}}Mbps) : {{ex2}}MB\nHighest ({{ht1}}Mbps) : {{ht2}}MB\nHigh ({{hi1}}Mbps) : {{hi2}}MB\nNormal ({{no1}}Mbps) : {{no2}}MB",
	"File size information reflects_": "Les informations sur la taille du fichier reflètent la taille maximale possible et les tailles de fichiers réelles peuvent varier en fonction des conditions d'enregistrement.",
	Bitrate: Bitrate$b,
	"Connection has been_": "La connexion a été perdue.\nRétablir la connexion ...",
	"Unable to establish_": "Impossible d'établir une connexion avec la caméra.\nVeuillez vous assurer que votre appareil est correctement connecté et réessayer.",
	"Purchased by Payment Service": "Acheté par Service de Paiement",
	"Up to N Cameras": "Jusqu'à {{a}} caméras",
	"Unlimited Live View": "Live View illimité",
	"N Days GPS Tracking": "Suivi GPS pendant {{a}} jours",
	"Unlimited Playback and Download": "Lecture et téléchargement illimités",
	hours: hours$b,
	"Live Event Upload or_": "Live Event Upload ou 12+ vidéos en résolution complète",
	"During the usage period of the One Plan_": "Pendant la période d'utilisation du service One Plan, les changements de plan d'abonnement ne sont pas possibles. Pour passer à un plan différent, veuillez contacter le support client de BlackVue pour annuler l'abonnement One Plan.",
	"Service Period (Include SIM Data)": "Période de service (Inclut les données SIM)",
	"Purchase the BlackVue One Package_": "Achetez le package BlackVue One pour débloquer gratuitement le One Plan pendant 1 an.",
	"3GB SIM Data Plan": "Forfait données SIM de 3 Go",
	"Unlimited Live View, Playback and Download": "Vue en direct, lecture et téléchargement illimités",
	"within data availability": "dans la disponibilité des données",
	"The BlackVue One Plan is a 1-year_": "Le BlackVue One Plan est un plan de service cloud d'un an accessible exclusivement à l'achat d'un package BlackVue One, qui inclut un tableau de bord, un forfait de données de 3 Go/mois pour 1 an (pour les États-Unis et le Canada) et un plan de service cloud pour 1 an.",
	"The BlackVue One Package is available_": "Le package BlackVue One est disponible exclusivement sur la boutique en ligne BlackVue.",
	"Go to BlackVue Shop": "Aller à la boutique BlackVue",
	"Anonymous Cam": "Caméra anonyme",
	"App only": "uniquement dans l'application",
	Expires: Expires$b,
	"N days remaining": "{{a}} jours restants",
	"No action needed_": "<b>Aucune action requise.</b> Le nouveau prix réduit sera appliqué automatiquement à partir de votre prochain paiement après le 13 septembre.",
	"The new reduced price_": "Le nouveau prix réduit sera appliqué automatiquement à votre compte.",
	"Smart Plan Subscriber?": "Abonné au Plan Smart ?",
	"Fleet Plan Subscriber?": "Abonné au Plan Fleet ?",
	"Please take a moment to_": "Veuillez prendre un moment pour nous autoriser à migrer votre compte.",
	"Starting from now and_": "<b>À partir de maintenant et jusqu'au 31 octobre</b>, vous pouvez nous laisser effectuer le changement pour vous en <a href=\"https://form.jotform.com/232411253056041\" target=\"_blank\">cliquant sur ce lien</a> et en saisissant votre email de compte Fleet. Veuillez nous accorder un peu de temps pour traiter le changement. Alternativement, vous pourrez annuler votre compte existant et vous réabonner au nouveau tarif à partir du 13 septembre.",
	"Once activated_": "Une fois activé, le One Plan ne peut pas être mis en pause ou désactivé.",
	"Once the One Plan is activated_": "Une fois que le One Plan est activé, le One Package ne peut pas être remboursé.",
	"Up to N Cloud Camera Slot": "Jusqu'à {{a}} emplacement(s) de caméra cloud",
	"nGB of Cloud Storage": "{{a}} Go d'espace de stockage cloud",
	"Get started for free_": "Get started for free, no credit card required. Includes Alert Push Notifications, limited Remote Live View and cloud storage.",
	"The BlackVue One Plan is exclusively_": "The BlackVue One Plan is exclusively available through the purchase of a BlackVue One Package. 3GB/mo data plan is for US and Canada only. BlackVue Cloud’s Free Plan, Lite Plan (1~3) and Smart Plan (1~3) accounts can upgrade to One Plan. However, Lite Plan (4~15), Smart Plan (4~15) and Fleet Plan accounts can not be upgraded to One Plan.",
	"For N year": "For {{a}} year",
	"Included in the One Package": "Included in the One Package",
	"3GB SIM Data Plan for N year": "3GB SIM Data Plan for {{a}} year",
	"One Plan Cloud Service for N year": "One Plan Cloud Service for {{a}} year",
	"The BlackVue One Package includes_": "The BlackVue One Package includes all you need to enjoy BlackVue Cloud for a whole year!",
	"4K LTE Dash Cam_": "4K LTE Dash Cam, Cloud Service and Data Plan",
	"nGB included": "{{a}}GB included",
	"nGB per camera": "{{a}}GB per camera",
	"N Days Live Event Upload": "{{a}} Days Live Event Upload",
	"Up to N Dash Cameras": "Up to {{a}} Dash Cameras",
	"Step N/N": "Étape {{a}}/{{b}}",
	"Cloud Connection": "Connexion au Cloud",
	"To pair your dashcam": "Pour associer votre dashcam avec la batterie, veuillez la connecter au Cloud.",
	Check: Check$b,
	"Unpair Battery": "Dissocier la batterie",
	"Are you sure you want to unpair": "Êtes-vous sûr de vouloir dissocier cette batterie (%@) de l'appareil photo ?",
	"Unpair: It doesn't mean": "Dissocier : Cela ne signifie pas supprimer les données de la batterie.",
	"*The paired battery will": "*La batterie appariée sera également retirée ensemble.",
	"Would you like to pair this": "Souhaitez-vous apparier cette batterie ?",
	"Battery successfully paired": "Batterie associée avec succès.",
	"Now you can directly connect to": "Désormais, vous pouvez vous connecter directement à la batterie depuis la liste des caméras.",
	"Pairing failed": "L'appairage a échoué. Veuillez réessayer.",
	"Battery Name": "Nom de la batterie",
	"Capacity History": "Historique de capacité",
	"The graph displays capacity": "Le graphique affiche un niveau de batterie approximatif à l'aide des données de la connexion cloud.\n La capacité de la batterie peut varier en fonction de la température, des paramètres du tableau de bord et de la fréquence des événements de déclenchement.",
	"Last 24 Hours": "Les dernières 24 heures",
	"Last 7 Days": "Les 7 derniers jours",
	"Battery Level": "Niveau de batterie",
	"Temperature History": "Historique de température",
	"The graph displays temperature": "Le graphique affiche un niveau de température approximatif à l'aide des données de la connexion cloud.",
	"Temperature Level": "Niveau de température",
	"Connecting alert": "[ Connexion ]\nDonnées affichées lors de la connexion.",
	"Low Output power Alert": "[ Coupe de l'alimentation de sortie ]\nLa tension de sortie est trop basse, limitant l'alimentation électrique de l'appareil connecté.",
	"High temp Alert": "[ Coupe d'alimentation d'entrée ]\nLa température de la batterie est trop élevée, ce qui limite la charge.",
	"Remaining time": "Temps restant",
	"Remaining time estimate": "Le temps restant est une estimation basée sur la consommation totale d'énergie des appareils connectés.\n Il est recalculé toutes les 30 secondes après la connexion à la batterie.",
	"Setting changed": "Changement de paramètre",
	"Setting change failed": "Échec de la modification du réglage",
	"Low Input power Alert": "[ Coupe d'alimentation d'entrée ]\nLa tension de charge est trop faible, limitant la charge.",
	"High Input power Alert": "[ Coupe d'alimentation d'entrée ]\nLa tension de charge est trop élevée, ce qui limite la charge.",
	"Low temp_Cut off Alert": "[ Coupe d'alimentation d'entrée ]\nLa température de la batterie est trop basse, limitant la charge et la durée.",
	"Low temp Alert": "[ Basse température ]\nLa température de la batterie est trop basse, ce qui limite le temps de fonctionnement et la vitesse de charge.",
	"Low capacity Alert": "[ Faible capacité ]\nLa capacité de la batterie est trop faible.\nConduisez la voiture pour la charger.",
	"Back to list": "Retour à la liste",
	Saving: Saving$b,
	Now: Now$b,
	"Power supplying is limited": "L'alimentation électrique est <b>limitée</b>",
	"This battery is already paired": "Cette batterie est déjà jumelée.",
	"Connecting to Battery": "Connexion à la batterie",
	"Paired battery": "Batterie jumelée",
	"Battery unpairing failed": "Échec de la suppression du jumelage de la batterie. Veuillez réessayer.",
	"A connection is already active": "Une connexion est déjà active. Veuillez réessayer plus tard.",
	"Searching for battery": "Recherche de la batterie",
	"Select battery to pair with your camera": "Sélectionnez la batterie à associer à votre appareil photo.",
	"Unable to connect": "Impossible de se connecter",
	"A connection error has occurred": "Une erreur de connexion s'est produite. Veuillez réessayer.",
	"The paired dashcam has been disconnected": "La dashcam jumelée a été déconnectée du Cloud.\nVeuillez vérifier les conditions ci-dessous.",
	"Check if the battery is not fully discharged": "Vérifiez si la batterie n'est pas complètement déchargée.",
	"Check the Cloud connection of the paired dashcam": "Vérifiez la connexion Cloud de la dashcam appariée.",
	"Connection lost": "Connexion perdue",
	"A connection error has occurred shortly": "Une erreur de connexion s'est produite. Veuillez essayer de vous connecter bientôt.",
	"Charging is limited": "La charge est <b>limitée</b>",
	"Cannot connect to the battery": "Impossible de se connecter à la batterie.",
	"Please check the Cloud connection of the camera": "Veuillez vérifier la connexion Cloud de la caméra.",
	"Charging complete in": "Charge terminée dans %@",
	"Current Capacity": "Capacité Actuelle",
	"Output Voltage": "Tension de Sortie",
	"Charging Voltage": "Tension de Charge",
	Beep: Beep$b,
	"Battery Capacity": "Capacité de la batterie",
	"Battery connection failed": "La connexion à la batterie a échoué",
	"Expansion battery": "Batterie de rechange",
	"Make sure it is switched on and within range": "• Assurez-vous qu’elle est allumée et qu’elle se trouve à portée de votre téléphone portable.",
	"Make sure it is not wirelessly connected to another device": "• Assurez-vous qu’elle n’est pas connectée sans fil à un autre appareil.",
	"Detected batteries": "Batteries détectées",
	"Can't see your battery": "Vous ne voyez pas votre batterie ?",
	"Download the Blackvue app to check": "Téléchargez l'application BlackVue pour vérifier votre batterie à distance",
	"By Using the app": "En utilisant l'application, vous pouvez associer votre caméra de tableau de bord avec la batterie et surveiller la capacité de la batterie sur le Cloud. Après l'association, vous pouvez vérifier la batterie dans le visualiseur de Cloud BlackVue.",
	Unpair: Unpair$b,
	"Occurs when the driver closes_": "Se produit lorsque le conducteur ferme les deux yeux pendant la conduite",
	"Occurs when the driver's head_": "Se produit lorsque la tête du conducteur est à plus de 50 degrés de l'avant.",
	"Only detects distraction above_": "Détecte uniquement les distractions au-dessus de la valeur définie. Vous pouvez changer l'unité dans 'Paramètres de dashcam > Déclencheurs d’événements > Unité de conduite imprudente'.",
	"Occurs when the driver is not wearing_": "Se produit lorsque le conducteur ne porte pas de ceinture de sécurité.",
	"Overlays a face detection box_": "Superpose une boîte de détection de visage sur les images en direct et enregistrées de la caméra DMS.",
	"Seat Belt": "Ceinture de sécurité",
	Detected: Detected$b,
	"No Seat Belt": "Pas de ceinture de sécurité",
	"Fatigue Risk Alert": "Alerte de risque de fatigue",
	"The time is synchronized_Email": "L'heure est synchronisée avec l'heure dans vos notifications par e-mail.",
	"Sends an alert when drowsiness is_": "Envoie une alerte lorsque la somnolence est détectée après la somnolence initiale.",
	"Data updates upon connection": "Les données sont mises à jour lors de la connexion.",
	"Sends a notification if_": "Envoie une notification si vous dépassez l' 'Heure Définie' pendant votre trajet.",
	"Data updates Alert": "[ Connexion ]\nLes données sont mises à jour lors de la connexion.",
	"Cannot save settings": "Impossible d'enregistrer les paramètres",
	"The time is synchronized_Push": "L'heure est synchronisée avec l'heure dans vos Notifications Push.",
	"The file has been overwritten or deleted": "Le fichier a été écrasé ou supprimé.",
	"Box Pro Models Settings": "Paramètres des Modèles Box Pro",
	"Push notifications can be configured_": "Les notifications push peuvent être configurées dans les paramètres de notification de la caméra.",
	"Recording Video": "Enregistrement Vidéo",
	"Cameras settings": "Paramètres des caméras",
	"Please configure the settings": "Veuillez configurer les paramètres",
	"Speed Priorities": "Priorités de vitesse",
	"Set Speed Priority": "Définir la priorité de vitesse",
	"Geofence-enter": "Géofence-entrée",
	"Geofence-exit": "Géofence-sortie",
	"Geofence-pass": "Géofence-franchissement",
	"Geofence-speed alert": "Géofence-Alerte de vitesse",
	"Drive Position": "Position de Conduite",
	"Left-Hand Drive": "Conduite à Gauche",
	"Right-Hand Drive": "Conduite à Droite",
	"Please configure this setting_": "Veuillez modifier ce paramètre si le conducteur n'est pas détecté correctement.",
	"A new feature in the BlackVue settings_": "Une nouvelle fonctionnalité dans les paramètres BlackVue a été ajoutée pour synchroniser l'heure de la caméra. Vous devez synchroniser l'heure de votre appareil photo une fois pour un enregistrement précis de l'heure.",
	"Feature location_": "Emplacement de la fonctionnalité :\nParamètres de la caméra> Système > Synchronisation de l'heure",
	"Time Sync": "Synchronisation du temps",
	"You can sync the time between_": "Vous pouvez synchroniser l'heure entre votre appareil et la caméra BlackVue. Le formatage de la carte SD est nécessaire pour la synchronisation. Avant de continuer, veuillez sauvegarder toutes les vidéos nécessaires.",
	"Voice Alert": "Alerte vocale",
	"Provides a voice alert_": "Fournit une alerte vocale depuis la caméra et envoie une notification si vous dépassez le temps réglé pendant votre conduite.",
	"Please enter a value": "Please enter a value.",
	"Notices & Notifications": "Nouvelles & Notifications",
	"Only detects drowsiness above_": "Détecte uniquement la somnolence au-dessus de la valeur définie. Vous pouvez changer l'unité dans 'Paramètres de dashcam > Déclencheurs d’événements > Unité de conduite imprudente'.",
	Promotion: Promotion$b,
	Notice: Notice$b,
	"View More": "Voir plus",
	"Read More": "Lire la suite",
	"Detection Box": "Boîte de Détection",
	"Seatbelt Detection Box": "Boîte de Détection de Ceinture de Sécurité",
	"Drive Position Detection Box": "Boîte de Détection de Position de Conduite",
	"Fleet Subscription Promotion (50%)": "Promotion d'abonnement à la flotte (50 %)",
	"BlackVue Fleet Tracking exclusive features_": "Fonctionnalités exclusives de BlackVue Fleet Tracking pour les utilisateurs expérimentés et les entreprises (utilisateurs et caméras multiples, géorepérage, visionneuse Web, etc.).",
	"Special Discount (50% off)": "Remise spéciale (50 % de réduction)",
	"*Promotion applied for 12 months": "*Promotion appliquée pendant 12 mois",
	"*Payment will be made starting next month.": "*Le paiement sera effectué à partir du mois prochain.",
	"[About using promotions]": "[À propos de l'utilisation des promotions]",
	"The promotion is free for the first month_": "La promotion est gratuite le premier mois puis facturée pendant 12 mois à compter du mois suivant.",
	"For users with an existing Lite/Smart subscription_": "Pour les utilisateurs disposant d'un abonnement Lite/Smart existant, vous devez annuler votre abonnement à l'application existant séparément, sinon votre abonnement à l'application existant pourrait être facturé sur votre compte.",
	"Please be sure to cancel your app subscription_": "Assurez-vous d'annuler votre abonnement à l'application pendant la période gratuite. Les doubles paiements ne seront pas remboursés.",
	"You will be changed to Fleet Plan immediately_": "Vous passerez immédiatement au plan de flotte, même si la durée d'abonnement restante de votre plan Lite/Smart existant n'a pas expiré.",
	"You can cancel Fleet Plan any time.": "Vous pouvez annuler le Plan de flotte à tout moment.",
	"From February 2025, please go to the Fleeta service and use it.": "Une fois la promotion annulée, elle ne sera pas réappliquée.",
	"After promotion expires_": "Une fois la promotion expirée, vous serez automatiquement renouvelé avec les frais d'abonnement au plan de flotte existant.",
	"(Required) I have read the promotion instructions_": "(Obligatoire) J'ai lu les instructions de la promotion et j'accepte le paiement.",
	"Upgrade to Fleet Plan immediately": "Passez immédiatement au plan de flotte",
	"Important Notice:": "Avis important :",
	"Switch of BlackVue Web Viewer to Fleeta Web Viewer": "Passer de BlackVue Web Viewer à Fleeta Web Viewer",
	"To provide better features and quality_": "Pour offrir de meilleures fonctionnalités et une meilleure qualité, le service de visualisation Web BlackVue passera bientôt à un nouveau service de visualisation Web de flotte appelé Fleeta. Les services Fleeta seront exclusifs uniquement aux utilisateurs du plan Fleet. Le service Fleeta sera lancé en mars 2025, avec une nouvelle application exclusive Fleeta. Veuillez visiter <a href=\"https://www.fleeta.io\" target=\"_blank\">fleeta.io</a> pour en savoir plus.",
	"We kindly ask for your understanding_": "Nous vous prions de bien vouloir faire preuve de compréhension, car ce changement vise à offrir un service amélioré. Pour toute question concernant cette transition, n'hésitez pas à contacter notre centre CS.",
	"Don’t show this again for this month": "Ne plus montrer ça ce mois-ci",
	"Fleet Plan Subscription Promotion": "Promotion d'abonnement au plan de flotte",
	"Period : December 2, 2024 ~ May 31, 2025": "Période : 2 décembre 2024 ~ 31 mai 2025",
	"See more details": "Voir plus de détails",
	"To continue improve quality and provide better service_": "Afin de continuer à améliorer la qualité et à fournir un meilleur service, notre service BlackVue Web Viewer passera bientôt à un service exclusif Fleet Plan. Il ne sera plus disponible gratuitement ou via d'autres forfaits à partir de fin mars 2025.",
	"We have prepared special discount offers for_": "Nous avons préparé des offres de réduction spéciales pour nos utilisateurs existants de Web Viewer. Veuillez vérifier les détails ci-dessous ! Nous sollicitons votre compréhension et votre soutien alors que nous mettons en œuvre ce changement afin de fournir un meilleur service.\n",
	"*If you are subscribed in-app_": "*Si vous êtes abonné à l'application, assurez-vous d'annuler votre abonnement à l'application.",
	"Enjoy your BlackVue Cloud service with your dashcam.": "Profitez de votre service BlackVue Cloud avec votre dashcam.",
	"Available Cloud Camera slot(s)_": "Emplacement(s) Cloud Camera disponible(s) : {{d}}",
	"Not eligible for the promotion.": "Non éligible à la promotion.",
	"You have already used_": "Vous avez déjà utilisé cette promotion. Une fois la promotion annulée, elle ne peut plus être réappliquée.",
	"Go to Cameras": "Aller aux caméras",
	"Congratulations !": "Congratulations !",
	"Fleet Plan user": "Fleet Plan user",
	"Let your BlackVue monitor_": "Laissez votre BlackVue surveiller votre voiture et vous alerter des incidents. Dès qu'un impact est détecté, votre BlackVue enverra une notification sur votre téléphone, accompagnée d'un instantané.\n",
	"Live Event Upload feature automatically_": "La fonction de téléchargement d'événements en direct télécharge automatiquement les séquences vidéo, y compris les séquences antérieures à l'accident, sur BlackVue Cloud Storage pour protéger vos vidéos !",
	"*Buffer time varies by model.": "*La durée du tampon varie selon le modèle.",
	Explore: Explore$b,
	"Cloud Storage": "Stockage en nuage",
	"My Cloud Cameras": "Mes caméras cloud",
	"My Cloud Cameras Only": "Mes caméras Cloud uniquement",
	"BlackVue Live Camera": "Caméra en direct BlackVue",
	"*For BlackVue Live Cameras_": "*Pour les caméras BlackVue Live, seules les caméras partagées comme publiques dans les paramètres de la caméra peuvent être visualisées sur la carte.",
	"*Share Method_": "*Méthode de partage : Paramètres de la caméra > Confidentialité",
	"Once the promotion is canceled_": "Une fois la promotion annulée, elle ne sera pas réappliquée.",
	"It will show_": "Il apparaîtra ici à mesure qu'ils seront disponibles.",
	"Deactivate Cloud": "Désactiver le cloud",
	"Are you sure you want to deactivate_": "Êtes-vous sûr de vouloir désactiver Cloud pour cette caméra ?",
	"Deactivate : It doesn’t_": "Vous pouvez toujours activer le cloud à tout moment. La caméra peut être supprimée une fois la désactivation terminée.",
	Deactivate: Deactivate$b,
	"*If you made the payment through_": "*Si vous avez effectué le paiement via l'application, veuillez redémarrer l'application.",
	"Connect Dashcam Locally (Wi-Fi)": "Connectez la Dashcam localement (Wi-Fi)",
	"Cloud Connection Setting": "Paramètres de connexion au cloud",
	"Camera Profile": "Profil de la caméra",
	"Camera Settings": "Paramètres de dashcam",
	"Format MicroSD Card": "Formater la carte microSD",
	"Remote Firmware Update": "Mise à jour du micrologiciel à distance",
	"Remove from Cloud": "Supprimer du cloud",
	"The location may not be accurate_": "L'emplacement peut ne pas être précis car la caméra n'est pas connectée au cloud.",
	"The location of the camera cannot be found_": "L'emplacement de la caméra est introuvable. Veuillez vérifier les paramètres de connexion au cloud.",
	"Manage\nFLEETA Drive": "Gérer\nFLEETA Disque",
	"Cloud\nConnection": "Connexion\ncloud",
	"Available on FLEETA App": "Disponible sur l'application FLEETA",
	"Available for Cloud dashcam OR on FLEETA App.": "Disponible pour le dashcam Cloud OU sur l'application FLEETA.",
	"Get started with_": "Commencez avec un essai gratuit de 1 mois",
	"Experience all of_": "Profitez de toutes les fonctionnalités premium de FLEETA gratuitement pendant votre essai de 1 mois.\n\nAucun engagement—annulation à tout moment",
	"Welcome to FLEETA Webviewer.": "Bienvenue sur FLEETA Webviewer.",
	"Let FLEETA get_": "Laissez FLEETA vous connaître",
	"Help improve your_": "Aidez à améliorer votre expérience en partageant quelques détails",
	"Business Industry": "Secteur d'activité",
	"Vehicle & Cargo": "Véhicules et Cargaison",
	Compliance: Compliance$b,
	"Would you like to skip?": "Voulez-vous passer ?",
	"What is your business industry?": "Quel est le secteur d'activité de votre entreprise ?",
	"Transportation & Logistics": "Transport et Logistique",
	"Rental & Leasing": "Location et Crédit-bail",
	"Construction & Building": "Construction et Bâtiment",
	"Government & Public": "Gouvernement et Public",
	"Facility & Utility Management": "Gestion des Installations et des Services",
	Manufacturing: Manufacturing$b,
	"Retail & Wholesale": "Vente au Détail et en Gros",
	Emergency: Emergency$b,
	Security: Security$b,
	"How many employees do you need to manage?": "Combien d'employés devez-vous gérer ?",
	"How many vehicles does your company operate?": "Combien de véhicules votre entreprise exploite-t-elle ?",
	"Why do you use a fleet tracking service?": "Pourquoi utilisez-vous un service de suivi de flotte ?",
	"Route Tracking": "Suivi de l'itinéraire",
	"Real-time Monitoring": "Surveillance en temps réel",
	"Incident Detection & Check video": "Détection d'incidents et vérification vidéo",
	"Behavior Monitoring & Analysis": "Surveillance et analyse du comportement",
	"Evaluation & Management": "Évaluation et gestion",
	"Theft Prevention": "Prévention du vol",
	"Monitoring & Maintenance": "Surveillance et entretien",
	"Verification & Management": "Vérification et gestion",
	"BlackVue App Use Only": "Utilisation uniquement sur l'appli BlackVue",
	"Your current plan allow_": "Votre plan actuel permet l'utilisation de l'application BlackVue. Pour utiliser le Visualiseur Web, veuillez vous abonner au Plan Flotte (FLEETA).",
	"Learn more about the Fleet_": "En savoir plus sur le Plan Flotte (FLEETA)",
	"Special Offer": "Offre Spéciale",
	"For a limited time_": "Pour une durée limitée, profitez de 50% de réduction sur votre abonnement au Plan Flotte.",
	"See Discount Details": "Voir les détails de la remise",
	"To subscribe to the Fleet_": "Pour souscrire au Plan Flotte, veuillez d'abord annuler votre abonnement BlackVue dans l'application pour éviter les frais doubles.",
	"Skip tour": "Passer la visite",
	"In the cloud_": "Dans l'environnement cloud, vous pouvez accéder à la lecture, regarder en direct (y compris le multivue), le GPS en direct et les rapports, le tout via le Visualiseur Web FLEETA.",
	"Cloud Storage is_": "Le Stockage cloud est l'endroit où vos vidéos téléchargées sont stockées en toute sécurité dans le cloud. Téléchargez vos vidéos pour les garder en sécurité longtemps.",
	"Toggle to switch_": "Basculer pour passer de Carte / Liste",
	"In List View_": "En vue Liste, vous pouvez facilement visualiser et gérer les groupes, les membres et les informations sur le firmware en un coup d'œil.",
	"What is Cloud Storage?": "Qu'est-ce que le Stockage cloud?",
	"Cloud Storage Overview": "Vue d'ensemble du Stockage cloud",
	"Difference Between FLEETA_": "Différence entre FLEETA Disque et Téléchargement d’événements en direct",
	"FLEETA Drive stores_": "FLEETA Disque stocke les vidéos que vous avez téléchargées manuellement",
	"Live Event Upload automatically_": "Téléchargement d’événements en direct stocke automatiquement les vidéos lorsqu'un événement se produit.",
	"Live Event Upload videos_": "Les vidéos de Téléchargement d’événements en direct ont une période d'expiration. Si vous souhaitez les conserver longtemps, déplacez-les sur FLEETA Disque.",
	"Note: SD Card_": "Note : Vidéos sur carte SD en Lecture",
	"Videos stored on_": "Les vidéos stockées sur votre carte SD peuvent être consultées via le menu Lecture.",
	"Set your image_": "Configurez votre image à l'aide du cadre fourni. Une fois l'image enregistrée, elle sera affichée dans la carte de la caméra et l'icône de vue de la carte.",
	"*Only jpg and_": "*Seuls les fichiers jpg et png sont pris en charge.",
	"Set as default image": "Définir comme image par défaut",
	"Camera Details": "Détails de la caméra",
	"IT & Telecommunications": "Informatique et télécommunications",
	"The name must_32": "Le nom doit comporter de 1 à 32 caractères.",
	"Unable to display the map.": "Impossible d'afficher la carte.",
	"The camera location cannot be found_": "L'emplacement de la caméra ne peut pas être trouvé en raison d'une mauvaise connexion GPS.",
	"Cloud Cameras": "Caméras cloud",
	"Want to unlock_": "Voulez-vous débloquer les fonctionnalités de gestion de flotte?",
	"*Web subscription only": "*Abonnement Web uniquement",
	"Uploads event_": "Télécharge instantanément les vidéos des événements sur le Stockage cloud dès qu'ils se produisent.",
	"Starts a conversation_": "Démarre une conversation avec le conducteur en utilisant le haut-parleur et le microphone de la caméra embarquée.",
	"Remotely check_": "Vérifiez à distance le niveau et l'état de la batterie via le cloud.",
	"Receive a voice_": "Recevez une alerte vocale et des notifications si le temps de conduite dépasse la limite.",
	"View your_": "Consultez votre journal de conduite sur la carte.",
	"View speed, event_": "Visualisez la vitesse, le type d'événement et lisez les vidéos associées directement sur la carte.",
	"FLEETA Tracking exclusive_": "FLEETA Tracking offre des fonctionnalités exclusives pour les utilisateurs avancés et les entreprises (Plusieurs utilisateurs et caméras, géorepérage, etc.).",
	"Cloud Cameras per Account": "Caméras cloud par compte",
	"Connect Dashcam Locally_": "Connecter la Dashcam localement (Wi-Fi) (Lecture, Téléchargement, Regarder en direct)",
	"Available with_": "Disponible avec la batterie BlackVue",
	"Cloud Battery": "Batterie cloud",
	"Driving Reports": "Rapports de conduite",
	"Video on Map": "Vidéo sur la carte",
	"Multi Live View (Fleeta Web Viewer)": "Vue en Direct Multiple (Visionneuse Web FLEETA)",
	"Enter a number": "Entrez un nombre",
	"Permission required.": "Autorisation requise.",
	"Please contact_": "Veuillez contacter le propriétaire pour obtenir de l'aide.",
	"Access not available": "Accès non disponible.",
	"This file cannot be deleted now.": "Ce fichier ne peut pas être supprimé maintenant.",
	"Please try again later.": "Veuillez réessayer plus tard.",
	"Permission required.\nPlease_": "Autorisation requise.\nVeuillez contacter le propriétaire pour obtenir de l'aide.",
	"Cloud Storage is disconnected_": "Stockage cloud est déconnecté. Veuillez vérifier la connexion.",
	"Manage the plan_": "Gérer le plan pour restaurer la caméra",
	"Notify the owner_": "Informez le propriétaire de gérer le plan",
	"Access Restricted:_": "Accès Restreint : Abonnement Expiré",
	"Access is currently_": "L'accès est actuellement indisponible en raison d'un abonnement expiré.",
	"Please contact your owner_": "Veuillez contacter votre propriétaire pour résoudre ce problème.",
	"Access will be_": "L'accès sera rétabli une fois l'abonnement renouvelé",
	"Cloud is disconnected_": "Stockage cloud est déconnecté. \nVeuillez vérifier la connexion.",
	"Connect to Cloud with_": "Connectez-vous au Stockage cloud avec l'APP FLEETA",
	"Using Wi-Fi Hotspot": "Utilisation du point d'accès Wi-Fi",
	Important: Important$b,
	"Pre-Event buffer_": "L'enregistrement du buffer pré-événement est désactivé dans ce mode.",
	"connectivity is_": "La connectivité est restreinte dans ce mode.",
	"video upload starts_": "Le téléchargement de la vidéo commence après que l'enregistrement soit terminé.",
	"Power Saving": "Économie d'énergie",
	"In all modes_": "Dans tous les modes, les impacts détectés déclenchent des enregistrements vidéo d'Événements.",
	"Battery Protection setting _": "Le réglage de Protection de la Batterie doit être ACTIVÉ.",
	"At least one of_": "Au moins l'un des paramètres suivants doit être activé",
	or: or$b,
	"For BlackVue battery users": "Pour les utilisateurs de batterie BlackVue",
	"we recommend setting_": "Nous recommandons de régler la coupure de tension à la valeur minimale pour une utilisation maximale de la batterie.",
	"No videos were found.": "Aucune vidéo n'a été trouvée.",
	"Try different filter_": "Essayez un autre filtre ou réinitialisez le filtre.",
	"Not avaliable with_": "Non disponible avec la caméra actuelle",
	"Overlays a detection_": "Superpose un cadre de détection sur les images en direct et enregistrées de la caméra DMS.",
	"A minute of_": "Une minute de vidéo de la caméra frontale sera approximativement",
	"System voice guidance": "Guidance vocale du système",
	"Recording trigger": "Déclencheur d'enregistrement",
	"Remote Button (Optional)": "Bouton à distance (Optionnel)",
	"Remote button settings_": "Les paramètres des boutons à distance ne peuvent pas être modifiés via une connexion cloud. Pour modifier ces paramètres, naviguez vers Caméra > Connecter localement > Paramètres de la caméra.",
	"No Registered Device": "Aucun appareil enregistré",
	"Subscription process is complete": "Le processus d'abonnement est terminé",
	"Now, go back to_": "Maintenant, retournez à l'application FLEETA, connectez-vous à votre compte et commencez à profiter du service.",
	"You can check the upload progress": "Vous pouvez vérifier la progression du téléchargement dans l'onglet Stockage cloud > FLEETA Disque.",
	"SIM card must be inserted in_": "La carte SIM doit être insérée dans la caméra pour commencer à utiliser Cloud.",
	"Active until:": "Actif jusqu'à :",
	Subscribe: Subscribe$b,
	"Camera PSN": "Caméra PSN",
	"BlackVue Sim Free Trial Started!": "L'essai gratuit de BlackVue Sim a commencé !",
	"Enjoy a free period to use your SIM_": "Profitez d'une période gratuite pour utiliser votre SIM sans abonnement !",
	"You can stay connected during the trial_": "Vous pouvez rester connecté pendant l'essai, mais n'oubliez pas :",
	"Complete your subscription before the trial_": "Terminez votre abonnement avant la fin de la période d'essai pour continuer à utiliser la carte SIM.",
	"If you don't subscribe by the end of the trial_": "Si vous ne vous abonnez pas à la fin de l'essai, votre service SIM sera désactivé.",
	"Save Event Videos_": "Enregistrez les vidéos d'événements sur le stockage cloud en temps réel !",
	"Note: Deleting your account doesn’t cancel": "Remarque : Supprimer votre compte n'annule pas votre abonnement. Pour annuler, rendez-vous dans Compte > Abonnement sur le visualiseur web FLEETA.",
	"Available only on FLEETA App for_": "Disponible uniquement sur l'application FLEETA pour ce modèle.",
	"The cloud is deactivated": "Le cloud est désactivé.",
	"Please add a camera with FLEETA_": "Veuillez ajouter une caméra avec l'APP FLEETA pour utiliser cette fonctionnalité.",
	"Upload videos to FLEETA_": "Téléchargez des vidéos sur FLEETA Disque et gardez-les en sécurité !",
	"You have no assigned camera_": "Vous n'avez pas de caméra assignée.\nVeuillez contacter le propriétaire pour demander l'attribution.",
	"Camera notification settings": "Paramètres de notification de la caméra",
	Vehicle: Vehicle$b,
	"App Download": "Téléchargement de l'application",
	"Have a problem with_": "Vous avez un problème avec l'abonnement ?",
	"Restore Purchase": "Restaurer l'achat",
	"Battery Pairing": "Appairage de la batterie",
	"Playback\nLive View": "Lecture/\nVue en direct",
	"Remote Playback": "Lecture à distance",
	"Cloud connection settings": "Réglages de connexion au cloud",
	"Go to settings": "Accédez aux réglages",
	"Only cloud cameras that_": "Seules les caméras cloud que les utilisateurs choisissent de partager publiquement sont affichées sur la carte.",
	"Live Broadcast Cameras": "Caméras de diffusion en direct",
	"*Live Broadcast Cameras_": "*Les caméras de diffusion en direct sont des caméras cloud configurées pour être diffusées par les utilisateurs.",
	"Only cloud cameras_": "Seules les caméras cloud que les utilisateurs choisissent de diffuser sont affichées sur la carte."
};

var Dashboard$a = "Dasbor";
var Account$a = "Akun";
var Help$a = "Bantuan";
var Mac$a = "Mac";
var Windows$a = "Windows";
var Admin$a = "Admin";
var Driver$a = "Pengemudi";
var Cameras$a = "Kamera";
var Manage$a = "Kelola";
var Clear$a = "Bersih";
var Show$a = "Menunjukkan";
var GB$a = "{{a}}GB";
var _section$a = ".";
var Name$a = "Nama";
var Password$a = "Kata Sandi";
var Cancel$a = "Batal";
var Members$a = "Anggota";
var Groups$a = "Grup";
var Role$a = "Peran";
var Group$a = "Grup";
var Status$a = "Status";
var nPM$a = "{{a}}PM";
var nAM$a = "{{a}}AM";
var Newest$a = "Terbaru";
var Oldest$a = "Terlama";
var Accepted$a = "Diterima";
var Pending$a = "Menunggu";
var Expired$a = "Berakhir";
var All$a = "Semua";
var Delete_$a = "Hapus {{a}}";
var Delete$a = "Hapus";
var Rename$a = "Ubah nama";
var Add$a = "Tambah";
var OK$a = "OK";
var Remove$a = "Hapus";
var Files$a = "File";
var Features$a = "Fitur";
var Settings$a = "Pengaturan";
var Upload$a = "Unggah";
var Privacy$a = "Privasi";
var Done$a = "Selesai";
var Subscription$a = "Berlangganan";
var Submasters$a = "admin";
var Users$a = "pengemudi";
var Change$a = "Ubah";
var Method$a = "Metode";
var Details$a = "Info kamera.";
var Confirm$a = "Konfirmasi";
var Address$a = "Alamat";
var Country$a = "Negara";
var State$a = "Provinsi";
var ZIP$a = "Kode Pos";
var Pricing$a = "Harga";
var Free$a = "Free";
var Smart$a = "Smart";
var Fleet$a = "Fleet";
var Subscrubed$a = "Sudah Berlangganan";
var January$a = "Januari";
var February$a = "Feburary";
var March$a = "Maret";
var April$a = "April";
var May$a = "Mungkin";
var June$a = "Juni";
var July$a = "Juli";
var August$a = "Agustus";
var September$a = "September";
var October$a = "Oktober";
var November$a = "November";
var December$a = "Desember";
var Blackvuecloud_$a = "www.blackvuecloud.com";
var Support$a = "Support";
var Community$a = "Community";
var FAQ$a = "FAQ";
var Developers$a = "Developers";
var Facebook$a = "Facebook";
var Twitter$a = "Twitter";
var Instagram$a = "Instagram";
var Youtube$a = "Youtube";
var Linkedin$a = "Linkedin";
var Downloads$a = "Pengunduhan";
var Unauthorized$a = "Tidak berwenang";
var none$a = "Tidak ada";
var Email$a = "Email";
var Customers$a = "Customers";
var Home$a = "Home";
var Plan$a = "Plan";
var New$a = "New";
var Unsubscribed$a = "Unsubscribed";
var Edit$a = "Edit";
var month$a = "month";
var months$a = "months";
var Continue$a = "Continue";
var Back$a = "Kembali";
var Master$a = "Owner";
var Develop$a = "Developers";
var $9$a = "$9";
var $15$a = "$15";
var $10$a = "$10";
var mo$a = "Bulan";
var City$a = "Kota";
var Charge$a = "Kenakan biaya";
var subscribe$a = "Ikut Berlangganan";
var search$a = "Pencarian";
var invalid_number$a = "Nomor kartu bukan merupakan nomor kartu kredit yang valid";
var invalid_expiry_month$a = "Bulan berakhirnya kartu tidak valid";
var invalid_expiry_year$a = "Tahun berakhirnya kartu tidak valid";
var invalid_cvc$a = "Kode keamanan kartu tidak valid";
var incorrect_number$a = "Nomor kartu salah";
var incomplete_number$a = "Nomor kartu tidak lengkap";
var incomplete_cvc$a = "Kode keamanan kartu tidak lengkap";
var incomplete_expiry$a = "Tanggal berakhirnya kartu tidak lengkap";
var expired_card$a = "Masa berlaku kartu sudah habis";
var incorrect_cvc$a = "Kode keamanan kartu salah";
var incorrect_zip$a = "Kode pos kartu gagal divalidasi";
var invalid_expiry_year_past$a = "Tahun berakhirnya kartu sudah berlalu";
var card_declined$a = "Kartu ditolak";
var missing$a = "Tidak ada kartu pada pelanggan yang dibebani biaya";
var processing_error$a = "Terjadi kesalahan saat memproses kartu";
var Paypal$a = "Paypal";
var iOS$a = "iOS";
var Android$a = "Android";
var Total$a = "Total";
var And$a = "dan";
var Camera$a = "Camera";
var Yes$a = "Ok";
var No$a = "Tidak";
var News$a = "Berita";
var Notifications$a = "Pemberitahuan";
var MPH$a = "MPH";
var Firmware$a = "Firmware";
var Basic$a = "Dasar";
var Resolution$a = "Resolusi";
var Brightness$a = "Kecerahan";
var Recording$a = "Perekaman";
var Highest$a = "Tertinggi";
var High$a = "Tinggi";
var Normal$a = "Normal";
var Sensitivity$a = "Sensitivitas";
var Volume$a = "Volume";
var Close$a = "Close";
var Cloud$a = "Cloud";
var Public$a = "Public";
var Front$a = "Depan";
var Rear$a = "Belakang";
var Play$a = "Putar";
var Stop$a = "Berhenti";
var Pause$a = "Jeda";
var Time$a = "Time";
var System$a = "Sistem";
var Event$a = "Kejadian";
var Parking$a = "Parkir";
var Color$a = "Warna";
var Exit$a = "Keluar";
var Save$a = "Simpan";
var Impact$a = "Benturan";
var Unlimited$a = "Tidak Terbatas";
var Default$a = "Default";
var Version$a = "Versi";
var Language$a = "Bahasa";
var Notification$a = "Notifikasi";
var Multiple$a = "Multi";
var Range$a = "Rentang";
var Download$a = "Unduh";
var Manual$a = "Manual";
var Satellite$a = "Satelit";
var Tutorials$a = "Tutorial";
var Filter$a = "Filter";
var Sun$a = "Mgu";
var Mon$a = "Sen";
var Tue$a = "Sel";
var Wed$a = "Rab";
var Thu$a = "Kam";
var Fri$a = "Jum";
var Sat$a = "Sab";
var Dates$a = "Tanggal";
var Routes$a = "Rute";
var Opacity$a = "keburaman";
var Entry$a = "Entri";
var Owner$a = "Owner";
var Undetected$a = "tanpa diketahui";
var Distracted$a = "Terganggu";
var Drowsy$a = "Drowsy";
var Calling$a = "Calling";
var Smoking$a = "Smoking";
var Permissions$a = "Izin";
var Private$a = "Privat";
var Entering$a = "Memasuki";
var Exiting$a = "Keluar";
var Acceleration$a = "Akselerasi";
var Passing$a = "Melintasi";
var Overspeed$a = "Mengebut";
var Recipients$a = "Penerima";
var Send$a = "Kirim";
var Note$a = "Catatan";
var Video$a = "Video";
var Advanced$a = "Lanjut";
var Voice$a = "Suara";
var Days_$a = "Hari";
var Mute$a = "Hening";
var UnMute$a = "Bersuara";
var Discard$a = "Buang";
var Report$a = "Report";
var Individual$a = "Pengemudi perorangan mencari ketenangan pikiran? Pemilik bisnis membutuhkan solusi keamanan dan pelacakan kendaraan yang sederhana?";
var Subscribed$a = "Sudah Berlangganan";
var Geofence$a = "Perimeter";
var Driving$a = "Mengemudi";
var Idling$a = "Idle";
var Distance$a = "Jarak";
var Parked$a = "Parked";
var Speed$a = "Kecepatan";
var Highest_2$a = "Tertinggi";
var Average$a = "Rata-rata";
var Geofences$a = "Perimeter";
var Move$a = "Pindahkan";
var Connected$a = "Tersambung";
var Individual_$a = "Individu";
var Always$a = "Selalu";
var Low$a = "Rendah";
var Medium$a = "Sedang";
var High_2$a = "Tinggi";
var Flip$a = "Balik";
var Previous$a = "Bingkai sebelumnya";
var Next$a = "Selanjutnya";
var Expand$a = "Bentangkan";
var Collapse$a = "Ciutkan";
var More$a = "Lainnya";
var Multi$a = "Multi";
var Safe$a = "Aman";
var Reckless$a = "Ceroboh";
var Inattentive$a = "Tidak memperhatikan";
var List$a = "Daftar";
var Usage$a = "Penggunaan";
var Profile$a = "Profil";
var Fullscreen$a = "Layar penuh";
var Upgrade$a = "Tingkatkan";
var Management$a = "Manajemen";
var Day$a = "Hari";
var Month$a = "Bulan";
var Later$a = "Nanti";
var ICCID$a = "ICCID";
var Resubscribe$a = "Perpanjang langganan";
var plan$a = "paket";
var USD$a = "USD";
var etc_$a = "dll:";
var Available$a = "Tersedia";
var Used$a = "Digunakan";
var Cancelled$a = "Dibatalkan";
var Terminated$a = "Diakhiri";
var Sort$a = "Pilah";
var Bonus$a = "Bonus";
var incomplete_zip$a = "Kode pos kartu gagal divalidasi";
var Upgrades$a = "Pembaruan";
var OR$a = "ATAU";
var Undo$a = "Membatalkan";
var Invoice$a = "Faktur";
var data$a = "Data";
var Popular$a = "Popular";
var Mask$a = "Masker dilepas";
var DMS$a = "Pemonitoran Status Pengemudi (DMS)";
var Extreme$a = "Ekstrem";
var OFF$a = "Tidak aktif";
var Threshold$a = "Ambang";
var Drowsiness$a = "Kegemukan";
var Direct$a = "Langsung";
var Remote$a = "Jarak Jauh";
var Update$a = "Perbarui";
var Option$a = "Opsi";
var Required$a = "Diperlukan";
var Optional$a = "Opsional";
var Others$a = "Lainnya";
var Stay$a = "Tetap Di Sini";
var Mask_2$a = "Mask";
var Low_2$a = "Low";
var Medium_2$a = "Medium";
var High_3$a = "High";
var Highest_3$a = "Highest";
var Extreme_2$a = "Extreme";
var Private_2$a = "Private";
var Lite$a = "Lite";
var Bitrate$a = "Bitrate";
var hours$a = "Jam";
var Expires$a = "Berakhir";
var Check$a = "Periksa";
var Saving$a = "Menyimpan";
var Now$a = "Sekarang";
var Beep$a = "Bunyi peringatan";
var Unpair$a = "Melepaskan";
var Detected$a = "Terdeteksi";
var Promotion$a = "Promosi";
var Notice$a = "Pembaruan";
var Explore$a = "Mengeksplorasi";
var Deactivate$a = "Menonaktifkan";
var Compliance$a = "Kepatuhan";
var Manufacturing$a = "Manufaktur";
var Emergency$a = "Darurat";
var Security$a = "Keamanan";
var Important$a = "Penting";
var or$a = "atau";
var Subscribe$a = "Berlangganan";
var Vehicle$a = "kendaraan";
var id = {
	Dashboard: Dashboard$a,
	"Payment & Subscriptions": "Pembayaran & Berlangganan",
	"Fleet Management": "Manajemen Armada",
	"Available to master": "Tersedia untuk master",
	"Available to Fleet_": "Tersedia untuk pengguna Paket Armada",
	Account: Account$a,
	"Log out": "Logout",
	"© 2019 Pittasoft_": "© 2019 Pittasoft Co. Ltd",
	"Privacy policy": "Kebijakan Privasi",
	"Terms of service": "Syarat Layanan",
	Help: Help$a,
	"App store": "App store",
	"Google Play": "Google Play",
	Mac: Mac$a,
	Windows: Windows$a,
	"Free Plan": "Free Plan",
	"Basic Plan": "Basic Plan",
	"Smart Plan": "Smart Plan",
	Admin: Admin$a,
	Driver: Driver$a,
	"Period : December 3, 2024 ~ May 31, 2025": "Periode : 3 Desember 2024 ~ 31 Mei 2025",
	Cameras: Cameras$a,
	"n of n": "{{a}} dari {{b}}",
	Manage: Manage$a,
	"Upgrade Plan": "Tingkatkan paket",
	"Add more cameras_": "Tambah lebih banyak kamera, kelola armada Anda, dan banyak lagi...",
	"Usage statistics": "Statistik penggunaan",
	"All cameras": "Semua kamera",
	Clear: Clear$a,
	Show: Show$a,
	"Live views": "Tayangan Langsung Jarak Jauh",
	"nh:nm:ns": "{{a}}h:{{b}}m:{{c}}s",
	"Video plays and_": "Pemutaran dan pengunduhan video",
	"Space available": "Kapasitas tersedia",
	GB: GB$a,
	"n%": "{{a}}%",
	"BlackVue app for_": "Aplikasi BlackVue untuk iOS dan Android",
	"BlackVue viewer for_": "Penampil BlackVue untuk Mac dan Windows",
	"Welcome to fleet": "Selamat datang di armada",
	"A few things_": "Beberapa hal yang bisa Anda peroleh selama penggunaannya:",
	"You can watch_": "Anda dapat menyaksikan video dari kamera yang ditetapkan untuk Anda melalui aplikasi BlackVue atau penampil desktop.",
	"If the master_deletes": "Jika master menghapus akunnya, akun Anda juga akan dihapus.",
	"If the masters_Fleet": "Jika langganan Paket Armada master berakhir, Anda tetap dapat mengakses akun Anda dalam mode baca-saja.",
	"You have to_": "Anda harus meregistrasi akun lain untuk menambahkan kamera pribadi.",
	"The Payments &_": "Bagian Pembayaran & Berlangganan serta Manajemen Armada hanya tersedia untuk master.",
	"You can manage_": "Anda dapat mengelola grup armada Anda di bagian",
	"_Fleet management": "Manajemen Armada",
	_section: _section$a,
	"The Payments_section-": "Bagian Pembayaran & Berlangganan hanya tersedia untuk master.",
	"Youre almost there": "Anda hampir selesai",
	"Finish account setup": "Selesaikan penyetelan akun",
	"Install and log_": "Instal dan masuk ke Aplikasi BlackVue atau Penampil Desktop",
	"Download on the_": "Unduh di App Store",
	"GET IT ON_": "DAPATKAN DI Google Play",
	"Download for Mac": "Unduh untuk Mac",
	"Download for Windows": "Unduh untuk Windows",
	"Add your camera_": "Tambah kamera Anda dalam Aplikasi BlackVue atau Penampil Desktop",
	"Start managing your_": "Mulailah mengelola armada Anda dan memantau statistik penggunaan di sini",
	"Cancelled Fleet Plan_": "Membatalkan Paket Armada pada {{date}}",
	"The new plan_": "Paket yang baru akan berlaku di akhir siklus penagihan berjalan Anda.",
	"Profile photo": "Foto profil",
	Name: Name$a,
	"E-mail address": "Alamat email",
	Password: Password$a,
	"Last changed_": "Terakhir diubah {{a}}",
	"Change password": "Ubah kata sandi",
	"Delete account": "Hapus akun",
	Cancel: Cancel$a,
	"Current password": "Kata sandi sekarang",
	"New password": "Kata sandi baru",
	"Confirm new password": "Konfirmasi kata sandi baru",
	"Password changed": "Kata sandi diubah",
	"Reason for deletion_": "Alasan dihapus (opsional)",
	"Account password": "Kata sandi akun",
	Members: Members$a,
	Groups: Groups$a,
	"+ Invite member": "+ Undang anggota",
	"Name, Email": "Nama, Email",
	Role: Role$a,
	Group: Group$a,
	"Date invited": "Tanggal diundang",
	Status: Status$a,
	"Group n": "Grup {{a}}",
	nPM: nPM$a,
	nAM: nAM$a,
	Newest: Newest$a,
	Oldest: Oldest$a,
	"Name, email or_": "Nama, email, atau grup",
	Accepted: Accepted$a,
	Pending: Pending$a,
	Expired: Expired$a,
	All: All$a,
	"No results": "Tidak ada hasil",
	"Try different keywords": "Cobalah kata sandi lain",
	"Try changing or_": "Cobalah mengganti atau menghapus filter",
	"Remove all filters": "Hapus semua filter",
	"Invite member": "Undang anggota",
	"Send invite": "Kirim undangan",
	"You have reached_": "Anda telah mencapai 10 batas submaster. Anda dapat terus mengundang pengguna.",
	Delete_: Delete_$a,
	"Are you sure_delete": "Anda yakin ingin menghapus anggota ini beserta akunnya?",
	Delete: Delete$a,
	Rename: Rename$a,
	"No submaster yet": "Belum ada submaster",
	"You can add_": "Anda dapat menambahkan 1 submaster per grup",
	"No cameras yet": "Belum ada kamera",
	"Add cameras first_": "Tambah kamera terlebih dahulu, tetapkan pengguna sesudahnya",
	"Name or email": "Nama atau email",
	"Add submaster": "Tambah submaster",
	Add: Add$a,
	"Add camera": "Tambahkan kamera",
	"n of n selected": "{{a}} dari {{b}} dipilih",
	"No cameras available": "Tidak ada kamera yang tersedia",
	"Most likely reasons_": "Kemungkinan alasannya adalah:",
	"All cameras were_": "Semua kamera ditambahkan ke grup lain.",
	"You can remove_": "Anda dapat menghapus kamera dari grup lain dan menambahkannya ke grup ini.",
	"No cameras were_": "Tidak ada kamera yang ditambahkan ke akun Anda.",
	"You can add_cameras": "Anda dapat menambahkan kamera dalam aplikasi BlackVue atau penampil desktop.",
	OK: OK$a,
	"Rename group": "Ubah nama grup",
	"Are you sure_group": "Anda yakin ingin menghapus grup ini?",
	"Edit Mobile app_": "Edit Izin Aplikasi seluler/penampil desktop",
	Remove: Remove$a,
	"n of n users": "{{a}} dari {{b}} pengguna",
	"Youve reached the_": "Anda telah mencapai batas pengguna per kamera",
	"Remove user": "Hapus pengguna",
	"Add user": "Tambah pengguna",
	"+ Add group": "+ Tambah grup",
	"Add group": "Tambah grup",
	"Group or submaster": "Grup atau submaster",
	"+ Add": "+ Tambah",
	"of max selected": "{{a}} dari maks {{b}} yang dipilih",
	"Mobile app/desktop_": "Izin aplikasi seluler/penampil desktop",
	Files: Files$a,
	Features: Features$a,
	Settings: Settings$a,
	Upload: Upload$a,
	"Download and Playback_Cloud": "Unduh dan putar dari penyimpanan awan",
	"Download and Playback_SD": "Unduh dan Putar dari Kartu SD",
	"Live view": "Live View",
	"Geo Fencing": "Geofencing",
	"Drive Reports": "Laporan mengemudi",
	"Firmware Settings": "Pengaturan Firmware",
	"Push Notifications": "Notifikasi dorong",
	"Event Auto Upload": "Unggahan otomatis acara langsung",
	Privacy: Privacy$a,
	Done: Done$a,
	"Payment method": "Metode pembayaran",
	"Change payment method": "Ubah metode pembayaran",
	Subscription: Subscription$a,
	"Space used": "Ruang terpakai",
	"Next billing_": "Tagihan berikutnya {{a}} {{b}}",
	"You manage_available": "Anda mengelola {{a}} dari {{b}} yang tersedia pada paket Anda",
	Submasters: Submasters$a,
	Users: Users$a,
	Change: Change$a,
	"No transactions yet_": "Anda berlangganan Paket Armada. Belum ada transaksi",
	"No transactions to_": "Tidak ada transaksi yang dapat ditampilkan.<br/>Jika Anda mencari riwayat transaksi platform lain (misalnya iOS, Android, PayPal), Anda bisa menemukan riwayatnya di halaman berlangganan pada platform Anda sendiri.",
	"of nGB_": "{{a}} dari {{b}}GB ({{c}}%)",
	"Smart Plan users_": "Pengguna Paket Pintar dapat mengubah paket langganan atau jumlah kamera via aplikasi seluler BlackVue",
	"Transaction history": "Riwayat transaksi",
	"Date": "Tanggal",
	"Amount, USD": "Jumlah, USD",
	Method: Method$a,
	Details: Details$a,
	"iOS in-app_": "iOS in-app purchase/Android in-app purchase",
	"Change the number_": "Ubah jumlah kamera",
	"You manage_cameras": "You manage {{a}} cameras of {{b}} available on your plan",
	"Extra cameras": "Kamera tambahan",
	"Total due_": "Total tagihan",
	"available on your_": "{{a}} tersedia pada paket Anda",
	"Cancel Fleet Plan": "Batal Fleet Plan",
	"This will cancel_": "Ini akan membatalkan langganan Paket Armada Anda. Anda akan turun ke Paket Gratis pada akhir siklus penagihan.",
	"Reason for cancellation_": "Alasan pembatalan (opsional)",
	"Not now": "Jangan sekarang",
	Confirm: Confirm$a,
	"Cardholder name": "Nama pemegang kartu",
	"Card name": "Nama kartu",
	"MM/YY": "BB/TT",
	Address: Address$a,
	Country: Country$a,
	State: State$a,
	ZIP: ZIP$a,
	Pricing: Pricing$a,
	"You are subscribed_": "Anda berlangganan paket Gratis.",
	"With Alert Push_": "Dengan Notifikasi Dorong Pengingat, tampilan Langsung Jarak Jauh dan penyimpanan awan yang terbatas.",
	Free: Free$a,
	Smart: Smart$a,
	Fleet: Fleet$a,
	"Get started for_": "Mulailah dengan gratis tanpa menggunakan kartu kredit. \n Termasuk Notifikasi Dorong Pengingat, Tampilan Langsung Jarak Jauh dan penyimpanan awan yang terbatas.",
	Subscrubed: Subscrubed$a,
	"Features included:": "Termasuk fitur:",
	"Get unlimited Remote_": "Dapatkan Tampilan Langsung Jarak Jauh dan pemutaran di Awan tanpa batas serta kelola hingga {{a}} kamera.",
	"BlackVue Fleet Tracking_": "Fitur eksklusif Pelacakan Armada BlackVue untuk pengguna skala besar dan bisnis (Lebih dari satu pengguna dan kamera, pembuatan perimeter, dll.)",
	"Try 1 Month Free": "Coba 1 bulan gratis",
	"Log in": "Login",
	"Remember me": "Ingat saya",
	"Forgot password?": "Lupa kata sandi?",
	"Reset password": "Reset kata sandi",
	"Enter email address_": "Masukkan alamat email yang digunakan selama registrasi guna menerima tautan yang akan dikirimkan untuk mereset kata sandi Anda.",
	"Send reset password_": "Kirim email reset kata sandi",
	"Back to login": "Kembali ke login",
	"Check your email": "Periksa email Anda",
	"Weve sent an_": "Kami telah mengirim email ke {{a}} dengan tautan untuk mengonfirmasi\n alamat email Anda.",
	"Resend email": "Kirim ulang email",
	January: January$a,
	February: February$a,
	March: March$a,
	April: April$a,
	May: May$a,
	June: June$a,
	July: July$a,
	August: August$a,
	September: September$a,
	October: October$a,
	November: November$a,
	December: December$a,
	"Sign up": "Buat akun",
	"First name": "Nama depan",
	"Last name": "Nama belakang",
	"Create a password": "Buat kata sandi",
	"5 or more_": "5 karakter atau lebih",
	"Sign up and_": "Daftar dan lanjutkan",
	"I agree to_": "Saya setuju dengan %@, %@, %@ dan %@.",
	"Subscribe to newsletter": "Berlangganan buletin",
	"1 month free trial_": "Coba gratis 1 bulan",
	"Dont have an_": "Tidak memiliki akun?",
	"Thank you for_": "Terima kasih telah mendaftar di BlackVue Cloud. Harap konfirmasikan alamat email Anda.",
	"Confirm email": "Konfirmasikan email",
	"If you didnt_": "Jika Anda tidak mendaftar untuk akun ini, abaikan email ini.",
	Blackvuecloud_: Blackvuecloud_$a,
	"invited you to_": "{{a}} mengundang Anda untuk bergabung dengan armadanya sebagai Submaster.",
	"Accept invitation": "Terima undangan",
	"Invite expires on_": "Undangan berakhir pada hh bb, tt.",
	"Your Fleet Management_": "Akun Manajemen Armada Anda yang didaftarkan dengan {{a}} dihapus oleh %@.",
	"If you believe_": "Jika Anda yakin ini terjadi karena kesalahan, silakan hubungi dukungan pelanggan kami: cs@blackvue.com.",
	Support: Support$a,
	"Help center": "Pusat bantuan",
	Community: Community$a,
	"Getting started": "Memulai",
	FAQ: FAQ$a,
	Developers: Developers$a,
	"Cloud API": "Cloud API",
	"Fleet SDK": "Fleet SDK",
	"Follow us": "Follow us",
	Facebook: Facebook$a,
	Twitter: Twitter$a,
	Instagram: Instagram$a,
	Youtube: Youtube$a,
	Linkedin: Linkedin$a,
	"BlackVue apps": "BlackVue apps",
	"Camera registraiton": "Registrasi kamera",
	"Two-way voice_": "Komunikasi suara dua arah",
	"Live GPS": "GPS Langsung",
	"Event live auto_": "Unggahan otomatis acara langsung",
	"Event file auto_": "Unggahan otomatis fail kejadian",
	"Compatible with_": "Kompatibel dengan model DR650GW, DR650S",
	"Not compatible with_": "Tidak kompatibel dengan model DR650GW, DR650S",
	"More cameras": "Lebih banyak kamera",
	"More users": "More users",
	"Roles and permissions": "Roles and permissions",
	"More Cloud Storage": "Lebih banyak penyimpanan awan",
	"Multi Live view_": "Multi Live View (Web)",
	"Longer GPS Tracking": "Longer GPS Tracking",
	"Geo Fence setup_": "Geo Fence setup (PC viewer) and alerts (PC viewer and app)",
	"Changes saved": "Perubahan disimpan",
	"Group added": "Grup ditambahkan",
	"Member added": "Anggota ditambahkan",
	"Group deleted": "Grup dihapus",
	"Member deleted": "Anggota dihapus",
	"Group renamed": "Nama grup diubah",
	"Submaster added": "Submaster ditambahkan",
	"Camera added": "Kamera ditambahkan",
	"User added": "Pengguna ditambahkan",
	"Users added": "Pengguna ditambahkan",
	Downloads: Downloads$a,
	"The BlackVue App_": "The BlackVue App and Viewer let you use your BlackVue camera to its full potential. Whether on mobile or on home computer, BlackVue gives you the tools to fully enjoy your dashcam's functions.",
	"Compatible with all_": "Compatible with all Wi-Fi enabled BlackVue models.",
	"Supports all BlackVue_": "Supports all BlackVue models to date.",
	"confirm new password": "Konfirmasi kata sandi baru",
	"Your password is_": "Kata sandi yang Anda masukkan salah",
	"Confirm password does_": "Kata sandi tidak cocok",
	"Please enter_email": "Mohon masukkan alamat e-mail yang valid.",
	"Please enter_password": "Kata sandi yang Anda masukkan salah",
	"Internal server error_": "Kesalahan server internal, silakan coba lagi.",
	"New password is_": "Setidaknya 1 karakter harus berbeda untuk kata sandi Anda saat ini",
	"It should be_": "Kata sandi harus berisi 5 karakter atau lebih",
	"Invalid permission": "Izin tidak valid.",
	"Input data isnt_": "Data masukan tidak tersedia.",
	Unauthorized: Unauthorized$a,
	"Already have subsciption": "Sudah berlangganan",
	"Already uses": "Sudah menggunakan",
	"Already logged in": "Sudah masuk",
	"Already sent e-mail": "Sudah mengirimkan email.",
	"Please wait": "Mohon Tunggu.",
	"E-mail is not_": "Email belum diverifikasi.",
	"Update your subscription_": "Perbarui langganan Anda",
	"Account was deleted": "Akun dihapus.",
	"5 ~ 30_": "5 ~ 30 characters",
	"It has exceeded_": "Ini sudah melampaui maksimum 9 Admin.",
	"Billing information": "Informasi tagihan",
	"Please enter cardName": "Masukkan nama kartu",
	"Please enter_card": "Masukkan nomor kartu yang valid",
	"Please enter address": "Masukkan alamat",
	"Please select country": "Pilih Negara",
	"Please enter city": "Masukkan kota",
	none: none$a,
	"Due today": "Jatuh tempo hari ini",
	"Today after 1_": "Hari ini setelah uji coba 1 bulan",
	"An error occurred_": "Terjadi kesalahan saat berusaha mengubah kata sandi. Coba lagi.",
	"Your account is_": "Akun Anda sudah aktif",
	"You can now_": "Sekarang Anda bisa masuk ke akun Anda dengan alamat email yang digunakan saat registrasi.",
	Email: Email$a,
	"Don’t have an account?": "Tidak memiliki akun?",
	"Already have an account?": "Sudah memiliki akun?",
	"Cloud service": "Cloud service",
	"for your BlackVue": "for your BlackVue",
	"See what your_": "See what your camera sees remotely.",
	"Receive impact alert_": "Receive Impact alert push notifications.",
	"Save footage to_": "Save footage to the cloud and do much more...",
	"Free plan included_": "Free plan included · Easy setup · Cancel anytime",
	"Taking advantage of_": "Taking advantage of a mobile or car-embedded Internet connection and a BlackVue camera, BlackVue Cloud connects you to your car from anywhere, anytime. Using the BlackVue App on your smartphone or tablet, you see in real time where your car is located and what is happening around it.",
	"Get notifications to_": "Get notifications to your phone when your parked car is hit. Check remotely what is happening around your car.",
	"Monitor your commercial_": "Monitor your commercial vehicles on a map in real time. Talk to your drivers anytime through the BlackVue App or Viewer.",
	"With BlackVue Fleet_": "With BlackVue Fleet Tracking, track in real time up to 100 vehicles from the palm of your hand or with the dedicated BlackVue Viewer.",
	"Get started now_": "Get started now with a Free plan. For unlimited video playback or Remote Live View, upgrade to Lite or Smart plan from the BlackVue App. <br/>Business and power users can unlock the power of the Fleet plan exclusively through this website.",
	"Remote Video Playback_": "Remote Video Playback and Download",
	"Compatible with DR650GW_": "Compatible with DR650GW, DR650S models",
	"Unlimited remote video_": "Unlimited remote video playback and download",
	"Longer cloud storage_": "Longer cloud storage file expiration period",
	"Longer storage period_live": "Longer storage period for Event live auto upload",
	"Longer storage period_file": "Longer storage period for Event file auto upload",
	"Goefence setup (PC_": "Geo-fence setup (PC viewer) and alerts (Windows viewer and app)",
	"App Store": "App Store",
	"Send reset password email": "Kirim email reset kata sandi",
	Customers: Customers$a,
	Home: Home$a,
	"Pick a plan": "Pick a plan",
	"No customers yet": "No customers yet",
	"Customers will_": "Customers will show up here as they become available",
	"Add customer": "Add customer",
	"Report(PDF)": "Report(PDF)",
	"Subscription Period": "Subscription Period",
	Plan: Plan$a,
	New: New$a,
	Unsubscribed: Unsubscribed$a,
	"Subscription ends soon": "Subscription ends soon",
	Edit: Edit$a,
	"1 month trial": "1 month trial",
	"Edit customer details": "Edit customer details",
	"Customer name": "Customer name",
	"of 999 available_": "of 999 available on Fleet Plan",
	"Subscription starts": "Subscription starts",
	"Subscription period": "Subscription period",
	month: month$a,
	months: months$a,
	"Cloud storage": "Cloud Storage",
	"Subscription plan": "Jenis langganan",
	"Check email address": "Check email address",
	"Add customer details": "Add customer details",
	Continue: Continue$a,
	Back: Back$a,
	"An error occured": "An error occured",
	"Customer added": "Customer added",
	"Last changed": "Last changed",
	"Company name": "Company name",
	"Company address": "Company address",
	"Alert Push Notifications": "Alert Push Notifications",
	"Receive notifications on_": "Receive notifications on your phone when preset Events occur. Great in combination with BlackVue’s Parking Mode.",
	"Remote Live View": "Tampilan Langsung Jarak Jauh",
	"Remotely monitor your_": "Remotely monitor your car in real time from anywhere, anytime.",
	"Video Backup/Auto Upload": "Video Backup/Auto Upload",
	"Back up videos_": "Back up videos to your phone or Cloud storage.",
	"Two-way Voice Communication": "Two-way Voice Communication",
	"Talk with people_": "Talk with people in the car from your smartphone. The driver can speak while keeping hands on the wheel.",
	"View your car’s_": "View your car’s location and speed on a map. With BlackVue Fleet Tracking, access 90-days’ worth of GPS data.",
	"Remote Video Playback": "Remote Video Playback",
	"Play videos stored_": "Play videos stored in the Cloud or in your dashcam anytime on your smartphone or tablet.",
	"Event Live Auto Upload": "Event Live Auto Upload",
	"Save a video stream_": "Save a video stream in real time to the Cloud. Protect yourself from break-ins and theft.",
	"Event File Auto Upload": "Event File Auto Upload",
	"Save Event videos_": "Save Event videos to the Cloud—including seconds before trigger—after they happen.",
	"Firmware-Over-the-Air (FOTA)": "Firmware-Over-the-Air (FOTA)",
	"Upgrade your dashcam’s": "Update your dashcam over the cloud",
	"When an Event_": "When an Event is created (Impact detected or manually triggered), Event Live Auto-upload lets your Cloud-compatible BlackVue save a live video stream from a camera of your choice (front or rear/interior) to the Cloud server",
	"Event File Auto-upload_": "Event File Auto-upload lets your dashcam automatically upload low-resolution versions of Event files to the Cloud.",
	Master: Master$a,
	"per Camera": "per Camera",
	"Event live auto upload_": "Event live auto upload compatible with all cloud cameras",
	"Drive report": "Drive report",
	"USA/Canada Toll Free": "USA/Canada Toll Free",
	"Monday–Saturday_": "Monday to Friday 8am-7pm / Saturday 9am-6pm (PST).",
	"Please agree to_": "You must accept Terms of Service",
	"Mac or Windows PC": "Mac or Windows PC",
	Develop: Develop$a,
	"Sign out": "Sign out",
	"Referral code": "Kode rujukan",
	"Total after 1 month trial": "Total setelah uji coba 1 bulan",
	"Already Use Stripe Token": "Sudah Menggunakan Token Stripe",
	"Select period": "Pilih periode",
	"State/Region": "Negara Bagian/Wilayah (opsional)",
	"ZIP/Postal": "Kode Pos",
	"$0.00": "$0.00",
	"$11.99": "$11.99",
	"$24.99": "$24.99",
	$9: $9$a,
	$15: $15$a,
	$10: $10$a,
	"mo + for_": "/mo + {{a}} per extra camera",
	mo: mo$a,
	"This e-mail address_": "Alamat email ini sudah memiliki akun terdaftar.",
	"1 month": "1 bulan",
	"Limit is reset daily": "Batas direset setiap hari",
	"Limit is reset monthly": "Batas direset setiap bulan",
	"Video plays and downloads": "Pemutaran dan pengunduhan video",
	"Your master": "Your owner",
	"Youre 1 step_": "Tinggal 1 langkah lagi untuk menyelesaikan langganan Paket Armada Anda",
	"Finish signing up": "Selesaikan pendaftaran",
	"Enter billing information": "Masukkan informasi tagihan",
	"Proceed to billing": "Lanjutkan ke tagihan",
	City: City$a,
	Charge: Charge$a,
	"User already invited_": "Pengguna yang sudah diundang dari Master",
	"n% consumed": "{{a}}% terpakai",
	"E-mail already exists": "Email sudah ada",
	"Cancel your inapp_": "Batalkan langganan di dalam aplikasi",
	"You have cancel_": "Anda harus membatalkan langganan di dalam aplikasi untuk meningkatkan Paket Armada: 1. Batalkan langganan Anda saat ini di App Store atau Google Play Store. Anda akan menurunkan Paket Armada Anda di akhir siklus tagihan berjalan Anda. Semua data Anda akan tetap utuh. 2. Masuk ke akun Anda di blackvuecloud.com dan tingkatkan ke Paket Armada.",
	"Edit permissions": "Edit izin",
	"See permissions": "Lihat izin",
	"Submaster removed": "Submaster dihapus",
	"Camera removed": "Kamera dihapus",
	"User removed": "Pengguna dihapus",
	"Users removed": "Pengguna dihapus",
	subscribe: subscribe$a,
	search: search$a,
	"permission can be_": "Izin dapat disetel setelah submaster menerima undangan.",
	"The confirmation link_": "Tautan konfirmasi sudah tidak berlaku",
	"Possible reasons:_": "Alasan yang mungkin:\n • Anda sudah mengonfirmasi alamat email Anda\n • Tautan sudah berakhir atau sudah dibatalkan",
	"Failed to register_": "Gagal untuk mendaftar ke BlackVue Cloud",
	"There was an_": "Terjadi kesalahan selama proses pendaftaran. Jika masalah berlanjut, cobalah mendaftar ke BlackVue Cloud kembali. Jika membutuhkan bantuan lebih lanjut, silakan hubungi dukungan pelanggan kami:",
	"Upgrade to Fleet_": "Tingkatkan ke Paket Armada",
	"Subscription is Canceled": "Langganan Dibatalkan",
	"No members yet": "Belum ada anggota",
	"Please enter_group name": "Masukkan nama grup yang valid",
	"Group Name": "Nama Grup",
	invalid_number: invalid_number$a,
	invalid_expiry_month: invalid_expiry_month$a,
	invalid_expiry_year: invalid_expiry_year$a,
	invalid_cvc: invalid_cvc$a,
	incorrect_number: incorrect_number$a,
	incomplete_number: incomplete_number$a,
	incomplete_cvc: incomplete_cvc$a,
	incomplete_expiry: incomplete_expiry$a,
	expired_card: expired_card$a,
	incorrect_cvc: incorrect_cvc$a,
	incorrect_zip: incorrect_zip$a,
	invalid_expiry_year_past: invalid_expiry_year_past$a,
	card_declined: card_declined$a,
	missing: missing$a,
	processing_error: processing_error$a,
	"no groups yet": "Belum ada grup",
	"groups will show_": "Grup akan muncul di sini jika sudah tersedia",
	"Fleet members will_": "Anggota armada akan muncul di sini jika sudah tersedia",
	"service provider": "Penyedia layanan",
	Paypal: Paypal$a,
	iOS: iOS$a,
	Android: Android$a,
	"Enter email": "Please enter a email address",
	"Enter password": "Mohon masukkan kata sandi.",
	"Enter first name": "Masukkan nama depan",
	"Enter last name": "Masukkan nama belakang",
	"Enter the current_": "Masukkan kata sandi saat ini",
	"Enter a new_": "Masukkan kata sandi baru",
	"There isnt an_": "Tidak ada akun yang terkait dengan alamat email ini",
	"Fleet Plan": "Fleet Plan",
	Total: Total$a,
	"Password you entered_": "Kata sandi yang Anda masukkan salah",
	"Incorrect email or_": "Email atau kata sandi salah",
	"Available to Masters": "Tersedia untuk Pemilik",
	"Blackvue url": "https://www.blackvue.com",
	"Information We Collect_": "Informasi yang Kami Kumpulkan dan Alasannya",
	And: And$a,
	"Terms of Location-Based_": "Syarat Penggunaan Layanan Berbasis Lokasi.",
	"I agree to the_": "Saya menyetujui",
	"Password Reset_": "Kami sudah mengirimkan email kepada {{a}} berisi petunjuk untuk \n mereset kata sandi.",
	"You have already_": "Anda sudah diundang, periksa email Anda.",
	"No data available_": "Tidak ada data yang tersedia pada tabel",
	Camera: Camera$a,
	"You no longer_": "Anda tidak lagi memiliki izin untuk menggunakan layanan armada.",
	"Please contact your_": "Silakan hubungi master Armada Anda untuk mengatasi masalah.",
	"You can still_": "Anda tetap dapat mengakses",
	"account information": "informasi akun Anda.",
	"If the issue_": "Jika masalahnya tidak teratasi dan Anda memutuskan untuk melanjutkan penggunaan layanan BlackVue Cloud dengan alamat email yang terdaftar, Anda harus menghapus akun Anda dan mendaftar kembali.",
	"If the problem_": "Jika masalah berlanjut, hubungi dukungan pelanggan kami:",
	"Web subscription only": "Khusus langganan lewat web",
	"AppStore url": "https://apps.apple.com/kr",
	"We no longer_": "Kami tidak memproses lagi pembayaran melalui PayPal. Anda harus memperbarui langganan Anda untuk mengubah jumlah kamera: 1. Masuklah ke akun paypal.com Anda dan batalkan langganan Paket Armada saat ini untuk mengubah jumlah kamera: 2. Masuk ke akun Anda di blackvuecloud.com dan tingkatkan ke Paket Armada.",
	Yes: Yes$a,
	No: No$a,
	"Serial number": "Nomor seri",
	"Cloud code": "Kode Cloud",
	"Terms & Policies": "Syarat & Kebijakan",
	News: News$a,
	Notifications: Notifications$a,
	"km/h": "km/h",
	MPH: MPH$a,
	"Baidu Maps": "Baidu Maps (khusus Tiongkok)",
	"Google Maps": "Google Maps",
	Firmware: Firmware$a,
	Basic: Basic$a,
	"Time Zone": "Zona Waktu",
	Resolution: Resolution$a,
	"Image quality": "Kualitas gambar",
	Brightness: Brightness$a,
	Recording: Recording$a,
	"Normal recording": "Perekaman normal",
	"Voice recording": "Perekaman suara",
	"Video segment length": "Panjang segmen video",
	"Rear camera recording": "Perekaman kamera belakang",
	Highest: Highest$a,
	High: High$a,
	Normal: Normal$a,
	"1 min": "1 min",
	"2 min": "2 min",
	"3 min": "3 min",
	Sensitivity: Sensitivity$a,
	"Motion detection": "Pendeteksian Gerakan",
	"Speed alert": "Peringatan Kecepatan",
	"Voice guidance": "Panduan suara",
	"Power on": "Nyalakan",
	"Power off": "Daya dimatikan",
	"Starting normal recording": "Mulai Rekaman Normal",
	"Changing recording mode": "Mengubah mode rekaman",
	"Speed alert (beep)": "Tanda peringatan kecepatan (bip)",
	"Cloud related": "Terkait Cloud",
	Volume: Volume$a,
	"User text overlay": "Hamparan teks pengguna",
	"A-Z, a-z_": "A~Z, a~z, 0~9, :;’/\\+-_()$#\nkurang dari 20 karakter.",
	"Wi-Fi auto turn off": "Wi-Fi dimatikan secara otomatis",
	"Login credentials": "Kredensial login",
	"Manual recording": "Perekaman manual",
	"By sharing your_": "Dengan membagi Tampilan Langsung, Anda membantu pengguna lain ikut mengalami gairah dan kenikmatan berkendara di seluruh dunia.",
	"However, as persona_": "Akan tetapi, karena video pribadi bisa saja ikut terkirim, mohon sangat berhati-hati dengan informasi apa yang Anda ingin bagikan.",
	"Please enter_email_2": "Silakan isi alamat email. Email dengan beberapa karakter khusus mungkin tidak diizinkan. Ex) +, &",
	"Password is incorrect": "Kata sandi salah.",
	"This camera is already_": "Kamera ini sudah terdaftar ke sebuah akun BlackVue.",
	"Camera name must_": "Panjang nama kamera harus 5 hingga 32 karakter.",
	"Failed to save_": "Gagal menyimpan pengaturan kamera.",
	"Unallowed character detected": "Mengandung karakter yang tidak dibolehkan.",
	"File(s) queued for_": "Antrean file untuk diunggah ke Cloud.",
	"Exceeded video play_": "Batas pemutaran & unduhan video terlampaui.",
	"Playback Failed": "Gagal memutar.",
	"Exceeded your Live_": "Melampaui batas durasi Live View Anda.",
	"The camera is not_": "Kamera tidak terhubung ke server.",
	"Please check the connection_": "Mohon periksa status koneksi kamera yang dipilih.",
	Close: Close$a,
	"Map": "Peta",
	Cloud: Cloud$a,
	Public: Public$a,
	"Flip horizontally": "Balik menyamping",
	Front: Front$a,
	Rear: Rear$a,
	Play: Play$a,
	Stop: Stop$a,
	Pause: Pause$a,
	"Next frame": "Bingkai selanjutnya",
	"Previous frame": "Bingkai sebelumnya",
	"Proximity sensor": "Sensor proksimitas",
	"Voice recording on/off": "Perekaman suara aktif/tidak aktif",
	"The BlackVue dashcam_": "Kamera dasbor BlackVue tidak kompatibel dengan jaringan nirkabel 5GHz.",
	Time: Time$a,
	"Daylight saving time": "Waktu musim panas",
	System: System$a,
	"Incorrect camera serial_": "Nomor seri kamera salah.",
	"Lock event files": "Kunci fail acara",
	"Overwrite locked event_": "Timpa fail acara terkunci saat penuh",
	"Camera settings saved_": "Pengaturan kamera berhasil disimpan.",
	"Front camera": "Kamera depan",
	"Rear camera": "Kamera belakang",
	Event: Event$a,
	Parking: Parking$a,
	"GPS tracking": "Pelacakan GPS",
	"G-force detected": "Gaya gravitasi terdeteksi",
	"Impact detected in_": "Benturan terdeteksi dalam mode parkir",
	"Scheduled reboot": "Penyalaan ulang terjadwal",
	"Recording status": "Status perekaman",
	"Rear security": "Pengaman belakang",
	"Time lapse": "Lalu waktu",
	"Sync with GPS_": "Sinkronisasi dengan jam GPS",
	"Overwrite locked event3_": "Timpa fail terkunci dengan fail kejadian baru saat penyimpanan penuh",
	"Video codec": "Codec Video",
	"Tracking logs": "Lacak log",
	"Geofence alerts": "Pengingat Geo-Fencing",
	Color: Color$a,
	Exit: Exit$a,
	Save: Save$a,
	Impact: Impact$a,
	Unlimited: Unlimited$a,
	"Parking mode recording": "Perekaman mode parkir",
	"Battery protection": "Perlindungan baterai",
	"Cut-off timer": "Timer pemutus",
	"Low voltage cut-off": "Pemutus voltase rendah",
	"Rear camera orientation": "Arah kamera belakang",
	Default: Default$a,
	"Rotate video 180°": "Putar video 180°",
	"Mirror video": "Cerminkan video",
	"Wi-Fi band": "Pita Wi-Fi",
	"Driving report": "Laporan mengemudi",
	"Unsupported video codec_": "Kodek video tidak didukung (H.265).",
	"Rear camera recording_": "Rekaman kamera belakang dalam mode parkir",
	"Front and rear_": "Kamera depan dan belakang sama-sama merekam",
	"Rear camera stops_": "Kamera belakang menghentikan rekaman 5 menit setelah masuk ke mode parkir. Rekaman dimulai kembali saat memasuki mode normal.",
	"Remote firmware update": "Pembaruan firmware jarak jauh",
	"Firmware is up-to-date": "Firmware sudah diperbarui",
	"New firmware available": "Firmware yang baru sudah ada.",
	Version: Version$a,
	"Release date": "Tanggal rilis",
	Language: Language$a,
	"File size": "Ukuran File",
	"What’s new": "Informasi terbaru",
	"Updating may take_": "Memperbarui membutuhkan waktu beberapa menit.",
	"The update process_": "Proses pembaruan tidak dapat dibatalkan.",
	"Do not disconnect the_": "Jangan mencabut kabel daya hingga perekaman normal dimulai kembali.",
	"Downloading firmware": "Mengunduh firmware",
	"Once download is_": "Setelah pengunduhan selesai, BlackVue akan otomatis melakukan boot ulang untuk mengaplikasikan firmware yang baru.",
	"If not allowed_": "Jika tidak dibolehkan, maka lokasi dan kecepatan kendaraan Anda tidak dapat diakses melalui Cloud.",
	"Unable to initiate update because_": "Tidak dapat memulai pembaruan karena kamera dasbor tersambung ke perangkat melalui Wi-Fi langsung.",
	Notification: Notification$a,
	Multiple: Multiple$a,
	Range: Range$a,
	"HDR night vision": "Mata Malam HDR",
	Download: Download$a,
	"G-sensor": "G-Sensor",
	Manual: Manual$a,
	"Low voltage warning": "Peringatan tegangan rendah",
	Satellite: Satellite$a,
	"Data usage": "Penggunaan data",
	"Select video download quality": "Pilih kualitas unduhan video",
	"Quick play file_": "File putar cepat (resolusi rendah)",
	"Original file": "File asli",
	"You do not have permission_": "Anda tidak memiliki izin untuk menjalankan fungsi ini. Silakan hubungi pemilik akun master Anda.",
	"Interior camera recording_": "Rekaman kamera dalam dengan mode parkir",
	"Interior security": "Keamanan Dalam",
	"Interior camera rotation": "Putaran kamera dalam",
	"Multi View": "Multi Tampilan",
	Tutorials: Tutorials$a,
	"Upgrade now": "Tingkatkan sekarang",
	"Members will show_": "Anggota akan muncul di sini jika sudah tersedia",
	"Are you sure_delete members": "Anda yakin ingin menghapus anggota secara permanen?",
	"Some members may_": "Beberapa anggota mungkin disembunyikan akibat filter yang diterapkan.",
	"Invited on_": "Diundang pada {{Invited Date}} oleh Anda. Pemilik",
	Filter: Filter$a,
	"Date created": "Tanggal dibuat",
	"No admin yet": "Belum ada admin",
	"You can add_admin": "Anda dapat menambahkan 1 admin per grup",
	"Collapse all": "Tutup semua",
	"Expand all": "Bentangkan semua",
	"Download and playback_cloud": "Unduh dan putar dari penyimpanan awan",
	"Are you sure_2": "Anda yakin ingin menghapus grup {Group name}?",
	"Are you sure_groups": "Anda yakin ingin menghapus grup?",
	"Add cameras first_drivers": "Tambah kamera terlebih dahulu, tetapkan pengemudi sesudahnya",
	"Flip vertically": "Balik secara vertikal",
	Sun: Sun$a,
	Mon: Mon$a,
	Tue: Tue$a,
	Wed: Wed$a,
	Thu: Thu$a,
	Fri: Fri$a,
	Sat: Sat$a,
	Dates: Dates$a,
	Routes: Routes$a,
	Opacity: Opacity$a,
	"Color and opacity": "warna dan keburaman",
	"Geofences will show_": "Geofence akan muncul di sini jika sudah tersedia",
	"Start drawing a shape_": "mulai menggambar bentuk pada peta",
	"Add geofence": "Tambah geofence",
	Entry: Entry$a,
	"Show all members": "Tampilkan semua anggota",
	"Me and my_": "Saya dan mobil saya. Tersambung",
	"add-on service for_": "layanan tambahan untuk BlackVue yang kompatibel dengan awan",
	"Continue with Google": "Lanjutkan dengan Google",
	"An account with_": "Akun dengan alamat email itu sudah ada, tetapi belum diverifikasi. Masukkan kata sandi BlackVue Cloud yang Anda miliki untuk masuk.",
	"Account does not_": "Akun tidak ada. Atau coba masuk dengan akun Apple atau Google Anda.",
	"Continue with Apple": "Lanjutkan dengan Apple",
	"Get started": "Memulai",
	"P subscription only": "<b>{{a}}</b> Hanya berlangganan",
	"+N USD for extra camera_": "+{{a}} USD for extra camera up to {{b}} Cameras",
	"Unlimited Live view": "Unlimited Live View",
	"Cameras per Account": "Cameras per Account",
	"Users per Account": "Users per Account",
	Owner: Owner$a,
	"Live View per Day": "Live View per Day",
	"Remote Video Playback_2": "Remote Video Playback and Download per Month",
	"N days": "{{a}} Days",
	"Video On Map": "Video On Map",
	Undetected: Undetected$a,
	Distracted: Distracted$a,
	Drowsy: Drowsy$a,
	"Whether on mobile_": "Whether on mobile or your computer, BlackVue gives you the tools to fully enjoy your dashcam’s functions. Download the latest <a1>firmware</a1>, <a2>mobile</a2> and <a3>desktop</a3> applications, or use <a4>BlackVue web app</a4> in your browser.",
	"Compatible with most_": "Compatible with most Wi-Fi BlackVue models. Cloud support for all Cloud-compatible dashcam models down to DR650GW Series with <b>Cloud Firmware</b>.",
	"Supports most recent BlackVue_": "Supports most recent BlackVue models and compatible with BlackVue Cloud.<br/>\nThis Viewer contains <b>two applications in one</b>: the SD Card Viewer lets you view recorded videos from your SD card and modify the settings of your BlackVue, as well as format the SD card; the <b>Cloud Viewer</b> lets you enjoy BlackVue Cloud.",
	"Contact us": "Contact us",
	"6 characters with": "6 karakter dengan perpaduan huruf, angka, dan simbol",
	"Apps and more...": "Apps and more...",
	"Cameras will show_": "Cameras will show up here as they become available.",
	"Keep this page_": "Biarkan halaman ini tetap terbuka sambil memeriksa kode konfirmasi. Periksalah folder spam Anda jika Anda tidak dapat menemukan email dalam kotak masuk.",
	"n cameras": "{{n}} kamera",
	"n slots": "{{n}} slot",
	"Calculate your Fleet_": "Hitung harga paket Armada Anda",
	"Code you entered_": "Kode yang Anda masukkan salah/kedaluwarsa",
	Calling: Calling$a,
	Smoking: Smoking$a,
	"Smoking has been_": "Terdeteksi merokok saat mengemudi.",
	"Email is already_": "Email sudah ada.",
	"Serial number and_": "Nomor seri dan kode awan dicetak pada kamera Anda",
	"Allow GPS access": "Izinkan akses GPS",
	"Used to access_": "Digunakan untuk mengakses lokasi dan kecepatan kendaraan Anda. Anda dapat mengubah pengaturan GPS nanti dalam pengaturan privasi kamera.",
	"Incorrect cloud code": "Kode awan salah",
	"An account is_": "Sebuah akun sudah terdaftar dengan alamat email ini.",
	"Live event upload": "Unggahan kejadian langsung",
	Permissions: Permissions$a,
	"Assign in": "Tetapkan",
	"Are you sure_camera": "Anda yakin ingin menghapus kamera ini?",
	"Uploading videos:": "Unduh video:",
	"GPS location recording": "Rekaman lokasi GPS",
	"When OFF, GPS_": "Jika Mati, lokasi GPS tidak direkam atau dikirim ke server awan.",
	"As personal video_": "Karena video pribadi dapat terkirim, hati-hati saat memutuskan informasi apa yang akan Anda bagi.",
	"Share location": "Bagikan lokasi",
	Private: Private$a,
	"Used to access_2": "Digunakan untuk mengakses lokasi dan kecepatan kendaraan Anda.",
	"Share live view": "Bagikan video Tayangan Langsung",
	"Share live audio": "Berbagi audio Tayangan Langsung",
	"Share camera’s name": "Bagikan nama kamera dasbor",
	"Impact detection": "Deteksi benturan",
	Entering: Entering$a,
	Exiting: Exiting$a,
	"Normal event recording": "Rekaman kejadian normal",
	"Harsh braking": "Mengerem kasar",
	Acceleration: Acceleration$a,
	"Sharp turn": "Membelok tajam",
	"Parking event recording": "Rekaman kejadian parkir",
	Passing: Passing$a,
	"Video source": "Sumber Video",
	Overspeed: Overspeed$a,
	"Are you sure_video": "Anda yakin ingin menghapus video ini?",
	"Add camera to_": "Tambahkan kamera ke tampilan langsung",
	"No routes to_": "Tidak ada rute untuk ditampilkan",
	"Start by adding_": "Mulai dengan menambahkan tanggal.",
	"invite sent": "Undangan terkirim",
	Recipients: Recipients$a,
	Send: Send$a,
	"Routes selected_": "Rute yang dipilih: {{n}} dari {{total}}",
	"Map service": "Layanan peta",
	"Speed units": "Satuan kecepatan",
	Note: Note$a,
	"Release notes": "Catatan rilis",
	"The name must_": "Nama harus antara 1 hingga 30 karakter.",
	Video: Video$a,
	Advanced: Advanced$a,
	"Firmware language": "Bahasa firmware",
	"Wi-Fi": "Wi-Fi",
	Voice: Voice$a,
	"Show date and_": "Tampilkan tanggal dan waktu",
	"Show speed": "Tampilkan kecepatan",
	"Front camera rotation": "Rotasi kamera depan",
	"Manual time settings": "Pengaturan waktu manual",
	"Recommended for better_": "Direkomendasikan untuk kompresi lebih baik, ukuran file lebih kecil, dan 4K UHD.",
	"For full compatibility_": "Untuk kompatibilitas sempurna dengan desktop lama dan perangkat bergerak.",
	"Up and down": "Naik dan turun",
	"Side to side": "Sisi ke sisi",
	"Front and back": "Depan dan belakang",
	"Detection region": "Kawasan deteksi",
	"Hotspot 1": "Hotspot 1",
	"Hotspot 2": "Hotspot 2",
	"Hotspot 3": "Hotspot 3",
	"Enter/exit": "Masuk/keluar",
	"Event recording": "Perekaman kejadian",
	"Front security (Normal)": "Pengaman depan (Normal)",
	"Front security (Parking)": "Pengaman depan (Parkir)",
	"LTE (Parking)": "LTE (Parkir)",
	"Wi-Fi (Parking)": "Wi-Fi (Parkir)",
	"Turn on at startup": "Nyalakan saat penyalaan",
	"Turn off after_": "Matikan jika tidak dioperasikan selama 10 mnt",
	"Your firmware is_": "Firmware sudah versi terbaru",
	"Add admin": "Tambah admin",
	"Remove All/n": "Hapus Semua/{{a}}",
	"Are you sure_remove": "Anda yakin ingin menghapus kamera dari grup ini?",
	"This will cancel_2": "Ini akan membatalkan langganan Paket Armada Anda. Anda akan turun ke Paket Gratis pada akhir siklus penagihan saat ini.",
	"You’ve reached_": "Anda telah mencapai batas pengemudi per kamera",
	"Are you sure_remove admin": "Anda yakin ingin menghapus admin {{a}}{{b}} dari grup ini?",
	"Fleet Plan · Owner": "Fleet Plan · Owner",
	"Manage cameras": "Kelola kamera",
	"Are you sure_delete zone": "Anda yakin ingin menghapus zona \"{{zone}}\"?",
	"available on your_2": "{{a}}/{{b}} tersedia untuk paket Anda",
	"The new plan_2": "Paket baru akan berlaku pada akhir siklus penagihan Anda saat ini ({{a}}).",
	"Canceled Fleet Plan_": "Membatalkan Paket Armada pada {{a}}",
	"Hard braking alert (beep)": "Pengingat pengereman darurat (bip)",
	"Hard acceleration alert (beep)": "Pengingat akselerasi mendadak (bip)",
	"Hard cornering alert (beep)": "Pengingat menikung mendadak (bip)",
	"SSID must be_": "Panjang SSID harus minimal 5 karakter.",
	"Password must be_": "Panjang kata sandi harus minimal 8 karakter.",
	"5 to 32 characters long": "panjang 5 hingga 32 karakter",
	"8 to 32 characters long": "panjang 8 hingga 32 karakter",
	"Longer storage period_event": "Periode penyimpanan lebih lama untuk unggahan kejadian langsung",
	"Requires latest firmware_": "Mensyaratkan firmware terbaru. Tidak kompatibel dengan model DR650S dan DR650GW",
	"After Blackvue is_": "Setelah BlackVue tersambung ke awan, pengaturan akan disimpan.",
	"This is an_": "Ini adalah Email tidak terdaftar. Anda ingin mendaftarkan akun baru?",
	"This feature is_": "Fitur ini hanya tersedia untuk pelanggan Paket Armada.",
	"Please return to_": "Akun tidak ada. Atau coba masuk dengan akun Apple atau Google Anda.",
	"Adjusting the cut-off voltage_": "Adjusting the cut-off voltage to a lower setting may result in your dash cam draining more power from your battery.\nThis could result in warning messages of battery drain or affect other vehicle functions.\nPlease consult with your dealership before lowering the voltage.",
	"Your videos will_": "Video Anda akan muncul di sini jika sudah tersedia.",
	"You drove:_": "Anda mengemudi: {{distance}}, {{time}}",
	"Event count per_": "Jumlah kejadian per jam mengemudi",
	"Are you sure_recipient": "Anda yakin ingin menghapus penerima ini?",
	"(You)": "{{a}} (Anda)",
	"All events": "Semua kejadian",
	Days_: Days_$a,
	"Requires DMC 200_": "Perlu kamera DMC 200",
	"A DMS and compatible_": "Dibutuhkan DMS dan kamera dasbor yang kompatibel untuk melihat laporan ini.",
	"Notifications will show_": "Notifikasi akan muncul di sini saat tersedia.",
	"Try changing your_": "Coba ubah tanggal atau hapus filter.",
	Mute: Mute$a,
	UnMute: UnMute$a,
	"Calling and smoking_": "Bertelepon dan merokok hanya terdeteksi oleh perangkat DMC 200",
	"You need a DMS_": "Anda perlu DMS untuk melihat laporan ini.",
	"Try BlackVue Cloud": "Cobalah BlackVue Cloud hari ini",
	"Individual driver looking_": "Pengemudi perorangan mencari ketenangan pikiran? Pemilik bisnis membutuhkan solusi keamanan dan pelacakan kendaraan yang sederhana?",
	"Whoever you are_": "Siapa pun Anda, apa pun kebutuhan Anda, tersedia paket Awan untuk Anda!",
	"It is the account that_Driver": "Inilah akun yang membawa Armada Anda bergabung ke BlackVue cloud setelah menerima undangan via email dari Pemilik atau Admin. Seorang pengemudi hanya dapat diberi satu kamera dengan kemampuan terbatas untuk melihat profil akun mereka; tampilan langsung dan pemutaran kamera yang diberikan kepada mereka.",
	"It is the account that_Admin": "Inilah akun yang membawa Armada Anda bergabung ke BlackVue cloud setelah menerima undangan via email dari Pemilik. Akun admin dapat diberi hak yang Pemilik izinkan untuk Admin tersebut.",
	"Video deleted": "Video dihapus",
	"Video delete_plural": "Video dihapus",
	"Driver removed from_": "Pengemudi dihapus dari grup",
	"Admin removed from_": "Admin dihapus dari grup",
	"Camera removed from_": "Kamera dihapus dari grup",
	"Are you sure_videos": "Anda ingin menghapus file yang dipilih?",
	"You have to cancel_fleet": "Batalkan langganan dalam aplikasi Anda untuk mengubah jumlah kamera: \n \n 1. Batalkan langganan Anda saat ini di App Store atau Google Play Store. Anda akan menurunkan Paket Armada Anda di akhir siklus tagihan berjalan Anda. Semua data Anda akan tetap utuh. 2. Masuk ke akun Anda di blackvuecloud.com dan tingkatkan ke Paket Armada.",
	Discard: Discard$a,
	"Discard unsaved changes?": "Buang gambar yang tidak disimpan?",
	"Incorrect serial number": "Nomor seri salah",
	"An error occurred_again": "Terjadi kesalahan. Mohon coba lagi.",
	"You are subscribed_free": "Anda berlangganan paket Gratis BlackVue Cloud.",
	"When an event_": "Saat sebuah peristiwa terjadi (benturan terdeteksi atau terpicu secara manual), unggahan kejadian Langsung mengizinkan BlackVue menyimpan stream video langsung dari salah satu kamera yang Anda pilih ke server Awan termasuk 5 detik sebelum kejadian.",
	Report: Report$a,
	"How it work": "Cara kerjanya",
	"Cloud Camera": "Kamera Awan",
	"Internet Connection": "Koneksi Internet",
	"BlackVue App/Viewer": "BlackVue App/Viewer",
	"All you need_": "Yang Anda butuhkan adalah",
	"Cloud-compatible BlackVue": "BlackVue yang kompatibel dengan Awan",
	"and a cellular_": "dan paket data seluler. Beberapa model tersambung ke Awan via hotspot Wi-Fi pihak ketiga. Model lainnya menawarkan pembaca kartu SIM Nano terintegrasi atau dukungan modul konektivitas plug-in.",
	"Cloud features at_": "Fitur Awan dalam jangkauan Anda",
	"Enjoy peace of_": "Nikmati ketenangan pikiran karena BlackVue mengawasi kendaraan Anda. Jika ada yang salah, kamera dasbor akan mengirimi Anda pesan seketika.",
	"Let your BlackVue_": "Biarkan BlackVue memantau kendaraan dan mengingatkan Anda jika terjadi insiden. Saat benturan terdeteksi, BlackVue akan mengirim notifikasi ke ponsel atau peramban web Anda, disertai sebuah foto spontan.",
	"Check on your_": "Cek kendaraan Anda dari mana saja dengan Tampilan Langsung Jarak Jauh. Dari peramban web atau ponsel, Anda dapat mengakses rekaman video real-time dari kamera dasbor yang tersambung ke Awan dan beralih antara kamera depan, belakang atau dalam dengan mudah.",
	"Your BlackVue may_": "Meski mungkin tidak dapat mencegah tabrak lari, tapi jika hal ini terjadi, BlackVue Anda berpeluang besar merekam video bukti yang sangat penting. Jelajahi semua video yang terekam oleh kamera dasbor Anda lewat ponsel atau peramban web.",
	"Worried about eating_": "Khawatir paket data Anda boros? Teknologi Sub-stream BlackVue memungkinkan Anda mengakses video dalam versi ekstra ringan untuk mempercepat penjelajahan dan melihatnya tanpa harus menunggu.",
	"Move files from_": "Pindahkan berkas Anda dari BlackVue ke Awan. Simpan satu video atau pilih beberapa klip untuk unggahan dalam jumlah besar. Video yang diunduh ke ponsel lewat aplikasi BlackVue dapat diakses dan dibagikan dari menu Memori Internal.",
	"View your vehicle’s_": "Lihat lokasi dan kecepatan berjalan kendaraan Anda secara real time. Tingkatkan ke Paket Pintar untuk akses data pelacakan GPS hingga 7 hari terakhir.",
	"Get more with_": "Dapatkan lebih banyak dengan Paket Pintar",
	"Unlimited Remote Live_": "Tampilan Langsung Jarak Jauh Tanpa Batas",
	"Up to 3 dashcams_": "Hingga 3 kamera dasbor dalam satu akun",
	"Want to track_": "Ingin melacak seluruh armada? Tingkatkan ke Paket Armada",
	"BlackVue Fleet Tracking_2": "Pelacakan Armada BlackVue adalah solusi lengkap untuk melindungi dan melacak armada Anda. Fitur dan harganya sangat berimbang guna memenuhi kebutuhan bisnis Anda.",
	"Stream real-time video_": "Siarkan video real-time tanpa batas. Laju bit: 600kbps",
	"Up to 999 Dashcams": "Hingga 999 Kamera Dasbor",
	"Register up to_": "Daftarkan hingga 999 kamera dasbor per akun.",
	"15GB of Cloud_": "Penyimpanan Awan 15GB",
	"15GB per additional_": "15GB per kamera dasbor tambahan. Penyimpanan Unggahan Otomatis Kejadian Tanpa Batas.",
	"90-days GPS_": "Log Pelacakan GPS 90-hari",
	"High accuracy: 15_": "Akurasi tinggi: 15 detik, Video pada Peta, ekspor data mudah.",
	"Unique fleet management_": "Fitur manajemen armada unik menambah nilai dan kenyamanan",
	"Create geofences and_": "Buat perimeter dan terima notifikasi real-time pada ponsel atau komputer Anda.",
	"View at a_": "Lihat sekilas jarak tempuh total, waktu idle, kejadian ngebut, dll, dalam bentuk tabel yang dapat dicetak atau diekspor.",
	"Multi Live View": "Multi Tampilan Langsung",
	"Monitor up to_": "Pantau hingga 4 kamera dasbor secara simultan",
	"Benefits for you": "Keuntungan bagi Anda",
	Individual: Individual$a,
	"Get notifications to_2": "Dapatkan notifikasi di ponsel saat kendaraan yang Anda parkir ditabrak. Cek kejadian di sekitar kendaraan Anda dari jauh. Tersedia di web, ponsel, Mac, dan Windows.",
	"Small business owner": "Pemilik usaha kecil",
	"Monitor your commercial_2": "Pantau kendaraan niaga Anda pada peta secara real time. Bicara ke pengemudi Anda kapan saja lewat peramban, aplikasi seluler BlackVue, atau penampil di Mac atau Windows.",
	"Company with large_": "Perusahaan dengan armada besar",
	"With BlackVue Fleet_2": "Dengan Pelacakan Armada BlackVue, Anda dapat melacak hingga 999 kendaraan secara real time lewat peramban, aplikasi seluler BlackVue, atau penampil di Mac atau Windows.",
	Subscribed: Subscribed$a,
	"The video was_": "Video sudah diunggah.",
	Geofence: Geofence$a,
	"500: Internal server error": "500: Kesalahan internal server",
	"404: Page not found": "404: Halaman tidak ditemukan",
	"Check the web address_": "Cek alamat web atau kembali ke halaman beranda BlackVue Cloud",
	"home page": "Home page",
	"There isn’t an_": "Tidak ada akun yang terkait dengan alamat email ini",
	"You can now_password": "Sekarang Anda dapat masuk dengan kata sandi baru",
	"Are you sure_remove admin2": "Anda yakin ingin menghapus admin secara permanen?",
	"Admin deleted": "Admin dihapus",
	"Members deleted": "Anggota dihapus",
	"Are you sure_groupName": "Anda yakin ingin menghapus grup {{a}}?",
	"Requires latest firmware": "Mensyaratkan firmware terbaru",
	"Selected file(s) moved_": "Berkas terpilih berhasil dipindahkan",
	"Are you sure_remove driver2": "Anda yakin ingin menghapus pengemudi {{a}} ({{b}}) dari grup ini?",
	"Invite sent": "Undangan terkirim",
	"Safe driving": "Mengemudi aman",
	"Reckless driving": "Mengemudi ceroboh",
	"Inattentive driving": "Mengemudi kurang perhatian",
	"Driving events trend": "Tren kejadian mengemudi",
	"Driving details": "Detail mengemudi",
	Driving: Driving$a,
	Idling: Idling$a,
	Distance: Distance$a,
	"Parking sessions": "Sesi parkir",
	"Parked time": "Parked time",
	"Idle stops": "Berhenti idle",
	"Idle time": "Waktu idle",
	"Impact events": "Impact Events",
	Parked: Parked$a,
	Speed: Speed$a,
	"Overspeeding alerts": "Pengingat mengebut",
	Highest_2: Highest_2$a,
	Average: Average$a,
	Geofences: Geofences$a,
	"Entries into a_": "Masuk sebuah zona",
	"Exits from a_": "Keluar sebuah zona",
	"No data": "Tidak ada data",
	"Hard acceleration": "Akselerasi",
	"Hard braking": "Mengerem kasar",
	"Hard cornering": "Membelok tajam",
	"The number within the brackets_": "Angka dalam kurung menunjukkan jumlah rata-rata kejadian per jam mengemudi. Jika Anda mengemudi kurang dari satu jam sehari, jumlah total kejadian ditampilkan.",
	"Did you insert_": "Sudahkah Anda memasang kartu SIM?",
	"Click here for_": "<a>Klik di sini</a> untuk panduan lebih terperinci.",
	"Back up all_": "<b>Cadangkan semua rekaman penting sebelum menyimpan pengaturan ini.</b><br/>Saat Anda menyimpan pengaturan, kartu microSD akan diinisialisasi ulang dan semua rekaman akan dihapus untuk memastikan stabilitas pengoperasian.",
	"Not connected to_": "Tidak tersambung ke awan. Beberapa fungsi untuk sementara dinonaktifkan.",
	"GPS Location recording off": "Rekaman lokasi GPS nonaktif",
	"n Videos deleted": "{{count}} Video dihapus",
	Move: Move$a,
	"Driver Monitoring System (DMS) will_": "Sistem Pemantauan Pengemudi (DMS) akan segera diluncurkan.",
	"An error occured while_": "Terjadi kesalahan saat berusaha mengubah jumlah kamera. Coba lagi",
	"Reached the limit_": "Batas tercapai: {{a}}",
	"An invitation was_": "Undangan sudah dikirim ke alamat email ini.",
	"To use the_": "Untuk menggunakan fitur awan. Pasang kartu SIM.",
	"Last updated": "Terakhir diperbarui {{date}}",
	"Try changing your date": "Coba ubah tanggal.",
	"No event data_": "Tidak ada data kejadian dikumpulkan selama waktu yang dipilih",
	"Please select another_": "Pilih hari atau bulan lain untuk melihat seluruh laporan.",
	"more than 6_": "gunakan lebih dari 6 karakter",
	"Sign up free": "Daftar gratis",
	"Cloud storage warning": "Peringatan penyimpanan awan",
	"Cloud Storage Full": "Penyimpanan awan penuh",
	"Cloud storage usage_100": "Penggunaan penyimpanan awan mencapai 100%. Bebaskan ruang penyimpanan agar dapat menggunakan Unggahan kejadian langsung",
	"Cloud storage usage_": "Pengunaan penyimpanan awan mencapai <b>({{a}}%)</b>. \nAtur penyimpanan awan Anda.\nLayanan unggahan kejadian langsung tidak tersedia jika penyimpanan awan penuh.",
	"Are you sure_delete_zone": "Anda benar-benar ingin menghapus?",
	"Search Name or email": "Cari Nama atau email",
	"Search group name": "Cari nama grup",
	"Please note that_": "Perhatikan bahwa rekaman video akan dijeda selama beberapa detik untuk menerapkan pengaturan baru.",
	"Currently connected Hotspot": "Hotspot tersambung saat ini",
	"Enhanced night vision": "Peningkatan Mata Malam",
	"To access the_": "Untuk mengakses kamera, harap perbarui paket berlangganan Anda.",
	"Restarting the Blackvue_": "Merestart BlackVue untuk menerapkan pengaturan.",
	"Hard acceleration event_": "Kejadian akselerasi mendadak terjadi saat kenaikan laju per detik melebihi {{kmh}} km/j ({{mph}} MPJ)",
	"Hard braking event_": "Kejadian pengereman darurat terjadi saat penurunan laju per \ndetik melebihi {{kmh}} km/j ({{mph}} MPJ)",
	"Hard cornering event_": "Kejadian menikung mendadak terjadi saat putaran lebih dari 60 derajat terjadi dalam 2 detik saat mengemudi di atas \n{{kmh}} km/j ({{mph}} MPJ)",
	"Changes you made_": "Perubahan yang Anda buat mungkin belum disimpan.",
	"My location": "Lokasi saya",
	"Hotspot name (SSID)": "Nama hotspot (SSID)",
	Connected: Connected$a,
	"Camera will be rebooted_": "Kamera akan dimuat ulang. Anda masih ingin melanjutkan?",
	"Restarting the BlackVue_": "Memulai kembali BlackVue. Tunggu sebentar.",
	"Failed to reboot_": "Gagal memuat ulang kamera",
	"Bluetooth (Parking mode)": "BT (mode Parkir)",
	"Front and interior camera_": "Kamera depan dan dalam merekam bersama.",
	"Interior camera stops_": "Kamera dalam berhenti merekam 5 menit setelah memasuki mode parkir. Rekaman dimulai kembali saat memasuki mode normal.",
	Individual_: Individual_$a,
	"Driver detection": "Deteksi pengemudi",
	"During driving only": "Hanya selama mengemudi",
	Always: Always$a,
	"Driver detection box": "Kotak deteksi pengemudi",
	"DMS camera rotation": "Putaran kamera DSM",
	Low: Low$a,
	Medium: Medium$a,
	High_2: High_2$a,
	"Reboot Camera": "Muat ulang kamera",
	"Latest events": "Kejadian terbaru",
	"G-Sensor": "G-Sensor",
	"Playback speed": "Kecepatan pemutaran",
	Flip: Flip$a,
	Previous: Previous$a,
	Next: Next$a,
	"Map type": "Jenis peta",
	"Zoom in": "Perbesar",
	"Zoom out": "Perkecil",
	"Move to Cloud": "Alihkan ke Awan",
	"Please recognize that_": "Perhatikan bahwa perekaman Video akan dijeda beberapa detik untuk menerapkan pengaturan.",
	"6 characters with_": "6 karakter dengan perpaduan huruf, angka, dan simbol",
	"Updating firmware": "Memperbarui firmware",
	"Overspeed event occurs_": "Kejadian mengebut terjadi saat kamera dasbor memperingatkan pengemudi batas kecepatan terlampaui. Anda dapat mengubahnya di Firmware > Sistem > Volume",
	"Enter group name": "Masukkan nama grup",
	"Live view failed": "Live View gagal.",
	"Parking mode enter_": "Masuk/Keluar mode parkir",
	"Cloud connectivity": "Konektivitas awan",
	Expand: Expand$a,
	Collapse: Collapse$a,
	"all day": "Seharian",
	"Driving style": "Gaya mengemudi",
	"Driving impact": "Benturan saat mengemudi",
	More: More$a,
	"No cameras to_": "Tidak ada kamera untuk ditambahkan",
	"You have added_": "Anda sudah menambahkan semua kamera yang tersedia.",
	Multi: Multi$a,
	"Report video": "Laporkan video",
	"Sexually explicit content": "Konten seksual",
	"Graphic violence": "Kekerasan atau menjijikkan",
	"Hateful speech": "Penuh kebencian atau menindas",
	"Harassment or bullying": "Melecehkan atau merundung",
	"Spam or advertisement": "Spam atau iklan",
	"Infringement of my_": "Melanggar hak-hak saya",
	"Other reason": "Dll",
	"Reason for reporting": "Alasan melaporkan",
	"Reported videos will_": "Video yang dilaporkan akan diperiksa dalam waktu 72 jam. Video tidak akan muncul di peta kejadian hingga dipastikan sesuai untuk ditampilkan di sana.",
	"Touch sensor": "Sensor sentuh",
	"Motion and impact detection": "Deteksi gerak & benturan",
	"Settings have been changed": "Pengaturan telah diubah",
	"Start event recording (beep)": "Mulai perekaman kejadian (bip)",
	"Scheduled reboots": "Penyalaan ulang terjadwal",
	Safe: Safe$a,
	Reckless: Reckless$a,
	Inattentive: Inattentive$a,
	"Highest(Extreme)": "Tertinggi (Ekstrem)",
	"Public cameras": "Kamera publik",
	List: List$a,
	Usage: Usage$a,
	"Video playbacks and downloads": "Pemutaran dan pengunduhan video",
	"of 100 times": "100 kali",
	"of 10 minutes": "10 menit",
	Profile: Profile$a,
	"Search geofences": "Cari perimeter",
	"Export CSV": "Ekspor CSV",
	"Exit fullscreen": "Tutup layar penuh",
	Fullscreen: Fullscreen$a,
	Upgrade: Upgrade$a,
	"Email address": "Alamat email",
	"of Unlimited": "Tidak terbatas",
	"No notifications yet": "Tidak ada pemberitahuan yang diterima dalam 7 hari terakhir.",
	"No videos yet": "Belum ada video",
	Management: Management$a,
	Day: Day$a,
	Month: Month$a,
	"Welcome to the BlackVue_": "Selamat datang di BlackVue Cloud Viewer",
	"You can access BlackVue_": "Anda dapat mengakses BlackVue Cloud dari web kapan saja, dari mana saja!",
	"Start tour": "Mulai tur",
	"Map view": "Tampilan peta",
	"Check the current_": "Cek lokasi GPS saat ini serta kecepatan kamera Anda dan kamera publik.",
	"Camera’s features": "Fitur kamera",
	"Take a look_": "Lihat aneka fitur terkait Cloud yang disediakan oleh Kamera BlackVue.",
	"Visualize your vehicle’s_": "Visualisasikan rute yang sering Anda lewati saat membawa kendaraan.",
	"Smart plan_": "Paket pintar: 90 hari, paket Armada: 90 hari",
	"Create geofences and2_": "Buat perimeter dan terima notifikasi real-time.",
	"Got it": "Mengerti",
	"Manage Fleet members": "Kelola anggota Armada",
	"Invite fleet members_": "Undang anggota armada dan kelompokkan mereka dalam grup.",
	"The moment the_": "Saat kamera mendeteksi benturan, notifikasi akan muncul di sini.",
	"Geofence Setup (Web)_": "Pengaturan perimeter (web/desktop) dan pengingat",
	"Original file play_": "Pemutaran berkas asli hanya tersedia untuk diunduh",
	"To get most_": "Untuk menggunakan BlackVue Cloud Viewer secara maksimal, sambungkan kamera ke Cloud. Unduh aplikasi BlackVue dan nikmati Perpasangan yang mulus, mulai dari menambahkan kamera ke koneksi Cloud sekaligus!",
	"You haven’t driven_Today": "Anda belum mengemudikan mobil Hari Ini. Cobalah mengemudi mobil dengan BlackVue untuk mengecek laporan mengemudi Anda.",
	"You haven’t driven_Month": "Anda belum mengemudikan mobil Bulan Ini. Cobalah mengemudi mobil dengan BlackVue untuk mengecek laporan mengemudi Anda.",
	"Fleet Plan only_": "Paket Armada hanya tersedia",
	"Overwrite locked event2_": "Timpa berkas kejadian terkunci saat penyimpanan penuh",
	"DMS’s New firmware_": "Firmware baru DMS tersedia",
	"Highest speed_report": "<b>Kecepatan tertinggi</b>\nNilai terbesar dari data kecepatan yang terkumpul dalam satuan Meter, mengonversi ke satuan Km/j dan MPJ\n\n<b>Kecepatan rata-rata</b>\n(Jarak/jam mengemudi) *3600 kecepatan rata-rata. Misalnya (2622 / 1208 ) *3600 = 7814.907\nKm/j : Bilangan bulat saja, \ntitik desimal MPH maksimal 2 angka di bawah bilangan bulat",
	"Choose a cloud_": "Pilih metode koneksi Awan",
	"You need an_": "Dibutuhkan koneksi internet untuk tersambung ke cloud. Pilih perangkat yang Anda gunakan untuk menyambung ke cloud.",
	"BlackVue SIM card": "Kartu SIM BlackVue",
	"Support model_": "Mendukung model : DR750X-2CH LTE Plus (NA)",
	"3rd party SIM_": "Kartu SIM pihak ke-3",
	"Support model_SIM": "Mendukung model : DR750X-2CH LTE Plus, DR750-2CH LTE, CM100 LTE",
	"Wi-fi hotspot": "Hotspot Wi-fi",
	"Support model_Wifi": "Mendukung model : Semua model BlackVue",
	"How to connect_": "Cara menyambung ke Cloud",
	"Download BlackVue application": "Unduh aplikasi BlackVue.",
	"*If you are_": "*Jika akan menggunakan kartu SIM BlackVue untuk koneksi Cloud, buka {{a}} {{b}}.",
	"Place your phone_": "Posisikan ponsel dalam jangkauan BT kamera. Mulai Perpasangan yang mulus dengan {{a}}.",
	"Back to camera_": "Kembali ke daftar kamera",
	"Upgrade for more_": "Tingkatkan untuk lebih banyak fitur lainnya!",
	"Upgrading the cloud_": "Dengan meningkatkan paket cloud, Anda dapat menikmati berbagai fitur lain dan mengelola lebih banyak kamera. Ingin meningkatkan paket cloud Anda?",
	"Explore cloud plans": "Jelajahi paket cloud",
	Later: Later$a,
	"Successfully subscribed": "Berhasil berlangganan!",
	"1GB data plan": "Paket data 1GB",
	"First month free_": "Gratis bulan pertama, <a>selanjutnya 10,99 USD/bulan</a>",
	"Next billing date": "Tanggal tagihan berikutnya",
	"Once SIM card_": "Setelah memasukkan kartu SIM ke kamera, Anda dapat langsung menggunakan fitur-fitur BlackVue Cloud.",
	"Go to SIM_": "Buka manajemen SIM",
	"Manage your BlackVue_": "Kelola kartu SIM BlackVue Anda di sini!",
	"Recommended for BlackVue_": "Direkomendasikan untuk pengguna SIM BlackVue",
	"Connect to cloud": "Sambungkan ke cloud",
	"Enter BlackVue SIM_": "Masukkan nomor ICCID SIM BlackVue",
	"ICCID number is_": "Nomor ICCID tercetak pada kemasan kartu SIM. Masukkan 14 angka terakhir nomor ICCID.",
	ICCID: ICCID$a,
	"SIM information": "Informasi SIM",
	"Start your free_": "Mulai coba gratis sekarang",
	"SIM card activate_": "Tanggal aktivasi kartu SIM",
	"Based on the_": "Berdasarkan tanggal kartu SIM dipasang ke kamera dan diaktifkan saat daya dinyalakan",
	"Upgrade to 3GB_": "Tingkatkan ke paket 3GB/5GB kapan saja",
	"Cancel your plan_": "Batalkan paket kapan saja",
	"No Commitment": "Tanpa Komitmen",
	"Precautions for using_": "Perhatikan sebelum menggunakan layanan",
	"After 1GB is_": "Setelah 1GB habis, tidak ada tambahan internet.",
	"If you have_": "Masa coba gratis dimulai sejak kartu SIM dipasang ke kamera dan menggunakannya.",
	"This content is_": "Ketentuan ini disebutkan dalam paket SIM. Kami tidak menyediakan kompensasi untuk masa coba gratis yang belum digunakan.",
	"If you have_2": "Untuk pertanyaan lain, hubungi <a>Tim CS</a>",
	"When OFF, connecting_": "Jika diatur Off, kamera tidak dapat disambungkan dengan Seamless pairing (Perpasangan mulus).",
	"1 month free": "1 bulan gratis",
	"No commitment. Cancel_": "Tanpa komitmen. Batalkan kapan saja.",
	"The video has been reported_": "Video berhasil dilaporkan",
	"Free for 1 month": "Gratis selama 1 bulan",
	"Start your free_2": "Mulai coba gratis",
	"1GB free for_": "1GB gratis selama {{a}} hari",
	"1GB data": "1GB data",
	"1 month free_2": "Coba gratis 1 bulan akan dimulai dari {{a}} termasuk 1GB untuk kartu SIM Blackvue.",
	"Your next billing_": "Tanggal tagihan Anda selanjutnya adalah {{a}}",
	"SIM card": "Kartu SIM",
	"SIM guide": "Panduan SIM",
	"SIM card list": "Daftar kartu SIM",
	"Add SIM card": "Tambahkan kartu SIM",
	"No SIM card_": "Belum ada kartu SIM",
	"Search SIM ICCID_": "Cari ICCID atau nama SIM",
	"Cloud disconnected. Failed_": "Awan terputus. Gagal memutar video",
	"This sim card_": "Kartu sim ini sudah terdaftar untuk akun lain.",
	"Incorrect BlackVue SIM_": "ICCID SIM BlackVue salah",
	"My shared videos": "Video yang saya bagikan",
	"Number of events": "Jumlah kejadian",
	"Added to Event Map": "Ditambahkan ke Peta Kejadian",
	"Successfully added video(s)_": "Berhasil menambahkan video untuk dibagikan ke Peta Kejadian! Untuk memeriksa status dan mengelola video yang dibagikan, buka Peta Kejadian > Video yang saya bagikan.",
	"Already added to_": "Sudah ditambahkan ke Peta Kejadian",
	"This video(s) is already added_": "Video ini sudah ditambahkan ke Peta Kejadian! Untuk memeriksa status dan mengelola video yang dibagikan, buka Peta Kejadian > Video yang saya bagikan.",
	"BlackVue’s firmware is up_": "BlackVue sudah menggunakan firmware versi terbaru",
	"Service end": "Akhir layanan",
	Resubscribe: Resubscribe$a,
	"Sort ascending": "Pilah naik",
	"Sort descending": "Pilah turun",
	plan: plan$a,
	USD: USD$a,
	"Are you sure_Cancel": "Anda yakin ingin membatalkan langganan? Baca dan konfirmasi pernyataan berikut.",
	"Your current SIM_": "Langganan kartu SIM Anda saat ini berakhir pada tanggal {{a}} dan Anda tidak dikenai tagihan lagi.",
	"After canceling your_": "Setelah membatalkan langganan kartu SIM, Anda dapat terus menggunakan data SIM Anda hingga tanggal berakhirnya langganan Anda.",
	"You can resubscribe_": "Anda dapat memperpanjang langganan dalam waktu 1 bulan setelah langganan Anda saat ini berakhir. Jika ingin memperpanjang langganan, klik tombol ‘Perpanjang langganan’ dalam daftar kartu SIM di sebelah {{a}}.",
	"Reason to cancel_": "Alasan membatalkan langganan",
	"Found an alternative": "Menemukan pengganti",
	"Too expensive": "Terlalu mahal",
	"Not required anymore": "Sudah tidak membutuhkan",
	"Quality issue": "Masalah kualitas",
	etc_: etc_$a,
	"Please describe in_": "Jelaskan secara terperinci",
	"SIM card cannot_": "Kartu SIM ini tidak dapat dihapus karena sedang dalam masa langganan. Jika Anda ingin menghapus kartu SIM ini, batalkan langganan terlebih dahulu.",
	"SIM card cannot_2": "Kartu SIM tidak dapat dihapus karena periode langganan belum berakhir. Coba lagi setelah periode langganan selesai.",
	"Are you sure_deleteSIM": "Anda yakin ingin menghapus kartu SIM ini?<br/>\n<b>Peringatan: Anda tidak dapat mengurungkan tindakan ini. Semua informasi kartu SIM Anda akan dihapus seketika.</b>",
	"ICCID number": "Nomor ICCID",
	"Activation date": "Tanggal aktivasi",
	"Current plan": "Paket saat ini",
	"Manage Plan": "Kelola Paket",
	"Next billing on": "Tagihan berikutnya tanggal",
	"View Invoices": "Lihat Tagihan",
	"Choose best plan_": "Pilih paket terbaik untuk Anda",
	"Plan summary": "Ringkasan paket",
	"Ends on_": "Berakhir tanggal {{a}}",
	"Start from_": "Mulai sejak {{a}}",
	"Your subscription will_": "Langganan Anda akan ditingkatkan pada tanggal {{a}}, saat paket saat ini berakhir.",
	"Resubscribe plan": "Perpanjang langganan paket",
	"Your subscription will2_": "Langganan Anda akan dimulai pada tanggal {{a}}, saat paket saat ini berakhir.",
	"Usage is estimated_": "Estimasi penggunaan sejak {{a}}",
	"Days left_": "{{a}} Hari lagi",
	"Data usage cycle": "Siklus penggunaan data",
	Available: Available$a,
	Used: Used$a,
	"Data used": "Data digunakan",
	"Subscribe to n_": "Langganan paket data {{a}} berlaku <b>mulai {{b}} hingga {{c}}</b> dan paket data {{d}} berlaku mulai {{e}}",
	"Will be charged_": "Akan ditagihkan pada tanggal {{a}}",
	"Monthly usage": "Penggunaan bulanan",
	"You have fewer_": "Data Anda tersisa sedikit untuk bulan ini!",
	"Get more data": "Dapatkan tambahan data!",
	"This video cannot be shared": "Video ini tidak dapat dibagikan",
	"This is a video cannot be shared_": "Video ini tidak dapat dibagikan karena informasi mengemudi tidak dapat ditemukan saat itu.",
	Cancelled: Cancelled$a,
	Terminated: Terminated$a,
	"Edit name": "Edit nama",
	"Not connected to_2": "Tidak tersambung ke awan. Pastikan kamera hidup dan modul koneksi internet diaktifkan.",
	"Some functionality is disabled_": "Fungsi tertentu dinonaktifkan karena kamera tidak tersambung ke Cloud. Menyambung ke cloud <a>di sini</a>.",
	"If you want to cancel_": "Untuk membatalkan paket, klik <a>Batalkan langganan</a>.",
	"Select plan": "Pilih paket",
	"Event map collects_": "Peta kejadian mengumpulkan dan menampilkan informasi kejadian BlackVue untuk memberitahukan situasi jalanan sekitar.",
	"Share your Live_": "Bagikan berkas unggahan kejadian Langsung Anda. Anda dapat membagikan video kejadian ke pengguna lain di dekat Anda.",
	"You can check_": "Anda dapat melihat video kejadian yang dibagikan oleh pengguna lain.",
	"Service end_": "Akhir layanan: {{a}}",
	"DMS camera recording_": "Kamera DMS merekam dalam mode parkir",
	Sort: Sort$a,
	"Are you sure you want_": "Anda yakin ingin menghapus video yang dibagikan dari Peta Kejadian?",
	"Remove shared video": "Hapus video yang dibagikan",
	"Explore event map": "Jelajahi peta kejadian",
	"Event map": "Peta kejadian",
	"Explore the graphic_": "Jelajahi statistik grafis kejadian BlackVue yang terjadi di sekitar Anda.",
	"You can filter_": "Anda dapat memfilter dan melihat kejadian yang Anda ingin tampilkan.",
	"This video was removed by_": "Video ini telah dilaporkan dan dihapus oleh administrator.",
	Bonus: Bonus$a,
	"Your subscription plan": "Paket langganan Anda",
	"Your free trial will_": "Coba gratis Anda akan dimulai sejak {{a}},</br> <strong>hingga</strong> {{b}}.",
	"Total after free trial": "Total setelah coba gratis",
	"This sim card is_": "Kartu sim ini sudah tidak aktif.",
	"Firmware is up_": "Firmware sudah versi terbaru",
	"Keep in mind": "Perhatikan",
	"Once 1GB of_": "Setelah 1GB data terpakai, layanan tidak akan tersedia hingga tanggal reset Data berikutnya [atau setelah Anda meningkatkan paket ke versi yang lebih tinggi].",
	"After the SIM_": "Setelah kartu SIM dipasang ke kamera, periode coba gratis dimulai saat Anda mulai menggunakan data.",
	"If you have_questions": "Untuk pertanyaan, hubungi <a>Dukungan Pelanggan.</a>",
	"Data reset date": "Tanggal reset data",
	"To use SIM card_": "Untuk menggunakan kartu SIM, hubungi <a>Tim CS</a> BlackVue",
	"Go to Subscription": "Buka Langganan",
	"An error occurred_subscription": "Terjadi kesalahan saat berlangganan paket yang dipilih",
	"Please try again": "Coba lagi",
	"Failed to subscribe": "Gagal berlangganan",
	"Go to Pricing": "Buka Harga",
	"SIM cards will_": "Kartu SIM akan muncul di sini jika sudah tersedia.",
	"1GB for 1_": "1GB selama 1 bulan",
	"Pricing Data": "Info Harga",
	"If you would like to check_": "Untuk memeriksa status dan mengelola video yang dibagikan, buka Peta Kejadian > Video yang saya bagikan.",
	"Connect to Cloud": "Sambungkan ke Cloud",
	"Completed!": "Selesai!",
	"Back to App": "Kembali ke Aplikasi",
	"iOS in-app purchase": "Pembelian dalam aplikasi iOS",
	"Android in-app_": "Pembelian dalam aplikasi Android",
	"bonus n days": "bonus {{a}} hari",
	"Want to contribute your_": "Izinkan berbagi berkas unggahan otomatis Kejadian ke Peta Kejadian secara otomatis?",
	"With event map_": "Anda dapat berbagi video unggahan otomatis Kejadian dengan pengemudi di dekat Anda lewat peta kejadian.",
	"You can edit_3": "Anda dapat mengedit berkas unggahan otomatis Kejadian yang dibagikan secara otomatis berdasarkan pengaturan Peta Kejadian kapan saja dengan membuka BLACKVUE CLOUD > Pengaturan kamera > Pengaturan Privasi.",
	"If you want to remove videos_": "Karena video pribadi dapat terkirim, hati-hati saat memutuskan informasi apa yang akan Anda bagi.",
	"Total events": "Jumlah kejadian",
	"Automatically add Live Event_": "Bagikan berkas unggahan otomatis Kejadian ke Peta Kejadian secara otomatis",
	"This camera is publicly_": "Kamera ini terbuka untuk publik di lokasinya saja.",
	incomplete_zip: incomplete_zip$a,
	"Live Event Upload_": "Unggahan Kejadian Langsung (Periode penyimpanan: 7 hari)\nMensyaratkan firmware terbaru",
	"Thank you for_2": "Terima kasih atas kesabaran Anda.",
	"Start Web viewer": "Mulai penampil Web",
	"Are you sure_remove driver": "Anda yakin ingin menghapus pengemudi secara permanen?",
	"An error occurred_sim": "Terjadi kesalahan saat mencoba berlangganan.",
	"Click the ADD SIM": "Klik tombol TAMBAHKAN SIM pada halaman daftar Kartu SIM, lalu ulangi proses menambahkan sim.",
	"Set download options": "Atur opsi unduhan",
	"Information may be_": "Information may be transmitted with a delay and may not reflect actual balances.",
	"Swipe left and right to move": "Usap ke kiri dan kanan untuk beralih",
	"Scheduled maintenance Notice": "Pengumuman Pemeliharaan Terjadwal",
	"Our Cloud server_": "Server Cloud kami akan menjalani pemeliharaan terjadwal.",
	"During that time_": "Selama masa itu, fitur-fitur Cloud mungkin tidak tersedia.",
	"Expected maintenance start_": "Estimasi waktu dimulainya pemeliharaan:",
	"Expected duration_": "Estimasi durasi: {{a}} jam.",
	"For more information_": "Untuk informasi lain, lihat <a>[Pengumuman Pemeliharaan Server]</a>",
	"Do not remind_": "Jangan ingatkan lagi",
	"Cloud Server Maintenance": "Pemeliharaan Server Cloud",
	"BlackVue Cloud Service_": "Layanan BlackVue Cloud untuk sementara tidak tersedia",
	"We are currently_": "Kami sedang melakukan pemeliharaan.",
	"We apologize for_": "Mohon maaf atas ketidaknyamanannya.",
	"Driver Monitoring System (DMS)": "Sistem pemantauan driver (DMS)",
	"Distracted occurs_": "Terjadi ketika kepala pengemudi berada lebih dari 50 derajat dari depan.",
	"Hand distraction event occurs_": "Terjadi ketika tangan pengemudi terdeteksi di dekat kepala mereka selama periode waktu tertentu (seperti saat merokok, memegang ponsel, dll.).",
	"Mask off event occurs_": "Terjadi ketika pengemudi masuk ke dalam kendaraan tanpa memakai masker atau ketika pengemudi melepaskan maskernya.",
	"DMS setting": "Pengaturan DMS",
	"The DMS system has_": "DMS menggabungkan kotak deteksi wajah untuk status \"Terdeteksi\", \"Tidak Terdeteksi\", \"Terdistraksi\", \"Kantuk\", \"Masker Tidak Pakai\", dan kotak deteksi gerakan untuk status \"Gangguan Tangan\".",
	"DMS detection": "Deteksi DMS",
	"There are detection criteria for_": "Terdapat kriteria deteksi untuk setiap kejadian. Silakan merujuk pada panduan di bawah ini.",
	"DMS camera recording_onoff": "Hidup: Kamera DMS merekam dalam Mode Parkir selama daya dijaga. <br/> Mati: Kamera DMS mati segera setelah masuk ke Mode Parkir.",
	"LED lighting for each event_": "LED pada Kamera Pemantauan Pengemudi akan menunjukkan setiap kejadian deteksi (Gangguan, Kegantungan, dll.).",
	"Drowsy and Distracted each have_": "Mengantuk dan Tidak Fokus masing-masing memiliki tiga kondisi sensitivitas.\n \n Lihat antarmuka panduan di bawah ini.",
	"DMS event detection sensitivity": "Sensitivitas deteksi kejadian DMS",
	"Only drowsy and distracted include_": "Hanya mengantuk dan tidak fokus yang menyertakan pengaturan sensitivitas. Selain itu, sensitivitas yang diatur menerapkan sensitivitas yang sama dengan dua kejadian oleh satu pengaturan.",
	"When driver’s eyes close_": "Terjadi ketika pengemudi menutup kedua mata saat mengemudi selama lebih dari 1 detik atau menguap selama 2 detik.\n",
	"n digit": "{{a}} digit",
	"You are subscribed_free_Smart": "Anda berlangganan paket Pintar BlackVue Cloud.",
	"Wi-Fi auto turn on": "Wi-Fi aktif otomatis",
	"Video on a map": "Video on a map",
	"This feature is only_vom": "This feature is only available to users with a Fleet Plan subscription.<br/>Please subscribe to a plan to unlock this feature.",
	"Total n days_": "Pengalaman gratis selama {{a}} hari.",
	"Every events of DMC200_": "Fitur deteksi DMS hanya aktif dalam Mode Normal. Jika ditenagai dalam Mode Parkir, kamera DMS hanya merekam video.",
	"An undetected event occurs_": "Terjadi ketika pengemudi tidak terdeteksi di depan kamera selama 1 menit.",
	"A detected event occurs_": "A detected Event occurs when the driver is gazing in front since the power is set in the beginning.",
	"Drowsy sensitivity_": "High : When the driver closes their eyes for more than 1 second, it is considered drowsy driving.<br/><br/>Medium : When the driver closes their eyes for more than 1.5 second, it is considered drowsy driving.<br/><br/>Low : When the driver closes their eyes for more than 2 second, it is considered drowsy driving.",
	"Distracted sensitivity_": "High : If the angle of the head is more than 50 degrees away from the front for 3 seconds, it is detected as Distracted.<br/><br/>Medium : If the angle of the head is more than 50 degrees away from the front for 5 seconds, it is detected as Distracted.<br/><br/>Low : If the angle of the head is more than 50 degrees away from the front for 7 seconds, it is detected as Distracted.",
	"Start your subscription now": "Mulai langganan Anda sekarang",
	"Free trial period has expired": "Periode uji coba gratis telah kedaluwarsa",
	"1 data plan will start from_": "Paket data akan dimulai dari {{a}} termasuk 1GB data untuk kartu SIM Blackvue.",
	"Allow the BlackVue_": "Bolehkan aplikasi BlackVue mengakses data GPS kamera dasbor Anda?",
	"We use this_": "Kami menggunakan ini agar Anda dapat melacak lokasi dan kecepatan mobil Anda.",
	"You can edit_": "Anda dapat mengedit pengaturan akses GPS kapan saja dengan masuk ke CLOUD BLACKVUE > Pengaturan kamera > Pengaturan privasi.",
	"SIM cards": "kartu SIM",
	"Subscription status": "Status berlangganan",
	Upgrades: Upgrades$a,
	"Upgrade plan": "Tingkatkan paket",
	"Manage plan": "Kelola Paket berlangganan",
	"Next plan": "paket berlangganan untuk bulan depan",
	OR: OR$a,
	"Cancel subscription": "Batalkan Berlangganan",
	Undo: Undo$a,
	Invoice: Invoice$a,
	"Daily usage": "Penggunaan data harian",
	"Delete SIM": "SIM Hapus",
	"New card": "Kartu kredit baru",
	data: data$a,
	"SIM card data_": "Langganan paket data kartu SIM dapat dibatalkan di <a>sim.blackvuecloud.com</a>.",
	"Your plan from_": "Paket Anda mulai hari ini hingga tanggal penagihan berikutnya",
	"Applied during_": "Berlaku selama {{a}} ~ {{b}}",
	"From today until_": "Mulai hari ini hingga tanggal pembayaran berikutnya, Anda hanya dapat berlangganan paket yang sama dengan bulan sebelumnya. Pembayaran untuk periode ini akan ditagihkan hari ini. <a>Biaya dihitung secara prorata.</a>",
	"Choose your next plan": "Pilih paket berikutnya",
	"Applied from_": "Berlaku dari {{a}}",
	"Payment for this_": "Pembayaran untuk paket ini akan dibebankan pada {{a}}.",
	"By sharing your_2": "Dengan membagi Tampilan Langsung, Anda membantu pengguna lain ikut mengalami gairah dan kenikmatan berkendara di seluruh dunia. Akan tetapi, karena video pribadi bisa saja ikut terkirim, mohon sangat berhati-hati dengan informasi apa yang Anda ingin bagikan.",
	"Option camera recording_": "Kamera opsi merekam dalam mode parkir",
	"Front and option camera_": "Kamera depan dan opsi merekam bersama.",
	"Option camera stops_": "Kamera opsi berhenti merekam 5 menit setelah masuk ke mode parkir. Rekaman dimulai kembali saat memasuki mode normal.",
	"Option camera rotation": "Rotasi kamera opsi",
	"Option camera": "Kamera opsi",
	"Option camera security": "Keamanan kamera opsi",
	"Resubscribe until_": "Berlangganan kembali hingga: {{a}}",
	"Firmware Update Caution": "Peringatan Pembaruan Firmware",
	"Please check below_": "Periksa kondisi di bawah sebelum pembaruan firmware untuk DMC200:",
	"The camera's Wi-Fi_": "Wi-Fi kamera harus diaktifkan.",
	"Check if your_": "Pastikan WI-FI Anda aktif.",
	"DO NOT disconnect_": "JANGAN lepaskan kabel koaksial selama pembaruan firmware.",
	"The camera and_": "Kamera dan DMC200 dapat rusak.",
	"DO NOT try_": "JANGAN mencoba menggunakan fitur lain hingga kamera selesai dinyalakan ulang.",
	"Expecially Reboot camera_": "Terutama saat menyalakan ulang kamera, berhati-hatilah dengan format kartu SD karena dapat merusak kedua perangkat.",
	"Update anyway": "Perbarui saja",
	"Invited on_2": "Diundang pada {{Invited Date}} oleh Anda. Pemilik",
	"BlackVue’s New firmware_": "Firmware baru BlackVue tersedia",
	"valid thru_": "berlaku hingga: {{a}}",
	"Billed monthly": "Billed monthly",
	"90 minutes Live_": "90 minutes Live View / Live Event Upload*",
	"or 2+ videos_": "or 2+ videos in full resolution*",
	"1GB Free Month_": "1GB Free Month Trial",
	"Cancel anytime": "Cancel anytime",
	"8+ hours Live_": "8+ hours Live View / Live Event Upload*",
	"or 12+ videos_": "or 12+ videos in full resolution*",
	"15+ hours Live_": "15+ hours Live View / Live Event Upload*",
	"or 23+ videos_": "or 23+ videos in full resolution*",
	Popular: Popular$a,
	"For Power Users": "For Power Users",
	"Estimates based on_": "* Estimates based on 4.5MB per minute of Live View, Quick View remote playback, or Live Event Upload file, and 190MB per full original resolution video download or playback (at 25Mbps bitrate). Daily idle Cloud connection data usage: 20MB per 24 hours. Data usage is shared among all types of services (Live View, Live Event Upload, etc.).",
	"Balanced Plan": "Balanced Plan",
	"For Light Cloud_": "For Light Cloud Use",
	"Front security (Normal mode)": "Pengaman depan (Mode normal)",
	"Front security (Parking mode)": "Pengaman depan (Mode parkir)",
	"BT (Parking mode)": "BT (Mode parkir)",
	"LTE (Parking mode)": "LTE (Mode parkir)",
	"Wi-Fi (Parking mode)": "Wi-Fi (Mode parkir)",
	"Hand distraction": "Tangan menghalangi",
	Mask: Mask$a,
	"Second drowsy is_": "Mengantuk kedua adalah mengantuk yang terjadi dalam waktu 30 detik sejak mengantuk pertama yang memulai perekaman unggahan kejadian langsung.",
	"Second drowsy alert": "Peringatan mengantuk kedua",
	"BlackVue sim card_": "Kartu SIM BlackVue hanya dapat digunakan di Kanada dan AS.",
	"Global support is coming soon.": "Dukungan global segera hadir.",
	"The video file not found_": "Berkas video tidak ditemukan, atau ada masalah saat memutar. Coba lagi.",
	"Start Voice Call": "Mulai Panggilan Suara",
	"End Voice Call": "Akhiri Panggilan Suara",
	"Voice call in use": "Panggilan suara sedang digunakan",
	"Enable microphone access_": "Aktifkan akses mikrofon untuk menggunakan fungsi komunikasi suara dua arah. Masuk ke halaman pengaturan browser untuk mengakses mikrofon Anda.",
	"You may need to_": "Anda mungkin perlu memuat ulang halaman ini agar pengaturan baru dapat berlaku.",
	"Eye status": "Status mata",
	"Start time of live event upload video": "Waktu mulai video unggahan kejadian langsung",
	"Left eye": "Mata kiri",
	"Right eye": "Mata kanan",
	"Drowsy is occured when the driver close his/her eyes more then 1sec": "Mengantuk terjadi ketika pengemudi menutup matanya selama lebih dari 1 detik",
	"Driver's Left eye movements with blinking count and period": "Gerakan mata Kiri pengemudi dengan jumlah kedipan dan jumlah periode serta periode",
	"Driver's Right eye movements with blinking count and period": "Gerakan mata Kanan pengemudi dengan jumlah kedipan dan periode",
	"Drowsy big data of the driver and after a Drowsy event occurs": "Data besar mata berkedip pengemudi setelah kejadian Mengantuk terjadi",
	"Sharing video to Event Map": "Membagikan video ke Peta Kejadian",
	"Want to use a Voice call?": "Ingin menggunakan Panggilan suara?",
	"To use a voice call_": "Untuk menggunakan panggilan suara, mulai ulang Tampilan Langsung dan klik “Izinkan”",
	"There is no_": "Belum ada video bersama. \nDaftar akan muncul saat dibagikan.",
	"Microphone blocked": "Mikrofon diblokir",
	"Want to center the map on your location?": "Ingin memusatkan peta di lokasi Anda?",
	"To let the app access your location_": "Untuk mengizinkan aplikasi mengakses lokasi Anda, mulai ulang PETA ACARA dan pilih \"OK\" saat diminta.",
	"Location access permission required": "Izin akses lokasi diperlukan.",
	"Are you sure you want_2": "Yakin ingin menghapus video ini dari Event Map?",
	"Two-way voice_2": "Two-way voice communication / Voice Call",
	"Not supported by DR650GW and DR650S_": "Not supported by DR650GW and DR650S",
	"DR650S Series only_": "DR650S Series only",
	"Cancel download?": "Batalkan unduhan?",
	"Your download is not_": "Unduhan Anda belum selesai. Anda ingin membatalkan unduhan?",
	"Continue download": "Lanjutkan unduhan",
	"Cancel download": "Batalkan unduhan",
	"Share your video to the Event Map?": "Bagikan video ke Peta Kejadian?",
	"Afterwards, according to the reaction to the video_": "Selanjutnya, berdasarkan reaksi yang diterima, video dapat diklasifikasikan sebagai video populer dan diperkenalkan sebagai Sedang tren di peta.",
	"Add hashtags and a brief description to describe your video.": "Tambahkan tagar dan keterangan singkat untuk mendeskripsikan video Anda.",
	"Would you like_": "Anda ingin membagikannya ke Peta Kejadian?",
	"Successfully added video_": "Berhasil menambahkan video untuk dibagikan ke Peta Kejadian!",
	"This video cannot_": "Video ini tidak dapat dibagikan karena tidak berisi data lokasi GPS untuk disematkan pada peta.",
	"This video is_": "Video ini sudah ditambahkan ke Peta Kejadian.",
	"Share to Event Map": "Bagikan ke Peta Kejadian",
	"Describe in more_": "Jelaskan secara lebih mendetail apa yang terjadi dalam video Anda (opsional)",
	"Description(optional)": "Deskripsi (opsional)",
	"Recording mode": "Mode Perekaman",
	"Event triggers": "Pemicu Kejadian",
	DMS: DMS$a,
	"Camera connectivity": "Konektivitas Kamera",
	"If not allowed_2": "Jika tidak dibolehkan, lokasi dan kecepatan kendaraan Anda tidak dapat diakses melalui Cloud.",
	"Share Live View_": "Bagikan video Tayangan Langsung",
	"Share Live View_2": "Berbagi audio Tayangan Langsung",
	"Share camera profile": "Bagikan Profil Kamera",
	"Parking impact": "Benturan saat parkir",
	"Parking events": "Parking Events",
	"Audio recording": "Perekaman Audio",
	"Toggle the mic_": "Geser mik ke HIDUP/MATI",
	"Full HD_": "Full HD @ 60fps + Full HD @ 30fps",
	"Video quality": "Kualitas video",
	Extreme: Extreme$a,
	"More video files": "Lebih Banyak Berkas Rekaman",
	"Fewer video files": "Lebih Sedikit Berkas Rekaman",
	"Camera rotation": "Rotasi kamera belakang",
	"Video overlay": "Hamparan Video",
	"Date & time display": "Tampilan tanggal & jam",
	"Speed unit": "Satuan Kecepatan",
	"Check the orientation_": "Cek orientasi kamera depan yang terpasang pada kendaraan. Pilih opsi yang cocok untuk merekam video dalam orientasi vertikal.",
	"Rotate 180º": "Putar 180º",
	"Rear camera rotation": "Rotasi kamera belakang",
	"Check the orientation_rear": "Cek orientasi kamera belakang yang terpasang pada kendaraan. Pilih opsi yang cocok untuk merekam video dalam orientasi vertikal.",
	"Mirror View": "Tampilan Cermin",
	"Select Mirror View_": "Pilih Tampilan Cermin untuk membalik video secara horizontal.",
	"Check the orientation_interior": "Cek orientasi kamera opsional yang terpasang pada kendaraan. Pilih opsi yang cocok untuk merekam video dalam orientasi vertikal.",
	"Display off": "Tampilan Tidak Aktif",
	"Explore crowd-sourced Events_": "Eksplorasi Kejadian dari banyak orang (Benturan, Pengereman Mendadak, dll.) pada peta, lihat video yang dibagikan oleh komunitas dan kontribusikan Kejadian yang Anda rekam sendiri.",
	OFF: OFF$a,
	"Reboots once-a-day_": "Nyalakan ulang sekali setiap hari pada jam tertentu jika dalam mode parkir untuk meningkatkan stabilitas.",
	"Set time": "Atur jam",
	"FW language": "Bahasa firmware",
	"Rear security_2": "Pengaman belakang",
	"Bluetooth (Parking mode)_2": "Bluetooth (mode Parkir)",
	"Failed to save_2": "Gagal menyimpan pengaturan Unggahan Kejadian Langsung",
	"Event file will_": "Berkas kejadian akan disimpan secara otomatis dalam penyimpanan Unggahan Kejadian Langsung.",
	"An impact was_": "An Impact was detected during Parking Mode.",
	"When exiting Parking_": "Saat Anda menutup Mode Parkir, BlackVue akan memberitahukan Benturan yang terdeteksi selama dalam Mode Parkir, jika ada. \n\n Catatan: \n Benturan menghasilkan video Kejadian. Benturan yang terjadi dalam 3 menit sejak Anda menutup Mode Parkir diabaikan.",
	"Protect event files": "Lindungi Berkas Kejadian",
	"Turning on this_": "Aktifkan untuk melindungi {{a}} berkas Kejadian terakhir agar tidak ditimpa oleh berkas perekaman Normal atau Parkir.",
	"Impact Events in_": "Impact Events in Normal(E) and Parking Mode(I)",
	"Manual Events_": "Manual Events (M)",
	"Once 50 Events_": "Berkas yang dilindungi mencakup: \n\nKejadian Benturan dalam Mode Normal (E) dan Parkir (I) \nKejadian Manual (M) \n\nSetelah rekaman Kejadian mencapai {{a}}, Kejadian baru akan menimpa kejadian paling lama.",
	"Reckless driving unit": "Unit mengemudi ceroboh",
	"Hard acceleration Event": "Kejadian Akselerasi Mendadak",
	Threshold: Threshold$a,
	"Triggers when the_": "Terpicu saat kamera mendeteksi kecepatan akselerasi di atas nilai ambang yang ditetapkan",
	"Triggers when the_2": "Terpicu saat kamera mendeteksi penurunan kecepatan di atas nilai ambang yang ditetapkan",
	"Hard braking Event": "Kejadian Pengereman Mendadak",
	"Triggers when more_": "Terpicu saat perubahan lintasan di atas 60 derajat dalam 2 detik terdeteksi saat kendaraan dikemudikan di atas nilai ambang yang ditentukan.",
	"Every event of DMC200_2": "Fitur deteksi DMS hanya aktif dalam Mode Normal. Jika diberi daya dalam Mode Parkir, kamera DMS hanya merekam video.",
	"The DMS system has_2": "DMS menggabungkan kotak deteksi wajah untuk status “Terdeteksi”, “Tidak Terdeteksi”, “Terdistraksi”, “Kantuk”, “Masker Tidak Pakai”, dan kotak deteksi gerakan untuk status “Gangguan Tangan”.",
	"One for face_": "One for face detection : Detected, Undetected, Distracted, Drowsy",
	"The other for_": "The other for motion detection",
	"On: Normal recording_": "On: Normal recording works while power is maintained in Parking Mode",
	"Off: DMS power_": "Off: DMS power off after 5 minutes when entering Parking Mode, Normal recording works until just before off",
	"Drowsy and Distracted_": "Drowsy and Distracted each have three sensitivity conditions.",
	"Please refer to_": "Please refer to the guide interface below.",
	Drowsiness: Drowsiness$a,
	"Drowsiness occurs when_": "Kegemukan terjadi ketika pengemudi menutup kedua mata saat mengemudi selama lebih dari 1 detik dan menguap selama 2 detik.",
	"Distracted occurs when_": "Terjadi ketika kepala pengemudi berada lebih dari 50 derajat dari depan.",
	"A hand distraction_": "A hand distraction occurs when the driver removes one hand from the steering wheel. [*Smoking and phone calls may be suspected.]",
	"Mask off event_": "Mask-off event occurs in two ways. First is when the driver gets in the car without a mask. Second is when the driver takes their mask off",
	"High When the_": "High : When the driver closes their eyes for more than 1 second, it is considered drowsy driving.",
	"Middle When the_": "Medium : When the driver closes their eyes for more than 1.5 second, it is considered drowsy driving.",
	"Low When the_": "Low : When the driver closes their eyes for more than 2 second, it is considered drowsy driving.",
	"High If the_": "High : If the angle of the head is more than 50 degrees away from the front for 3 seconds, it is detected as Distracted.",
	"Middle If the_": "Medium : If the angle of the head is more than 50 degrees away from the front for 5 seconds, it is detected as Distracted.",
	"Low If the_": "Low : If the angle of the head is more than 50 degrees away from the front for 7 seconds, it is detected as Distracted.",
	Direct: Direct$a,
	"Camera Wi-Fi credentials": "Kredensial Wi-Fi Kamera.",
	"Network name(SSID)": "Nama jaringan (SSID)",
	"Seamless pairing": "Seamless Pairing",
	Remote: Remote$a,
	"Hotspot settings": "Pengaturan Hotspot",
	"Hotspot name": "Nama hotspot (SSID)",
	"Hotspot name must_": "Hotspot name must be at least 5 characters long",
	"Public cameras may_": "Kamera publik mungkin muncul di tab Jelajahi atau peta Dunia.",
	"Hard Cornering Event": "Kejadian Berbelok Mendadak",
	"Over speed_2": "Mengebut",
	"Second drawiness alert": "Pengingat Mengantuk Kedua",
	"Low Voltage Warning_2": "Tangan Melakukan Hal Lain",
	"(You)_2": "{{a}} ( Anda )",
	"This video has been reported_": "Video ini telah dilaporkan dan dihapus oleh administrator.",
	"Normal Mode recording": "Perekaman Mode Normal",
	"ON : the camera_": "HIDUP : kamera merekam secara kontinu seluruhnya.",
	"OFF : the camera_": "MATI : kamera hanya merekam video Kejadian selama kendaraan berjalan.",
	"In both modes_": "Dalam kedua mode, Benturan yang terdeteksi memicu perekaman video Kejadian.",
	"Continuously records_": "Secara kontinu merekam video 1 menit 1 bingkai per detik untuk kejadian 30 menit",
	"Choose detection regions_": "Pilih kawasan deteksi untuk mengurangi risiko terpicunya perekaman gerakan yang tidak diinginkan akibat pohon yang bergoyang tertiup angin, objek bergerak di kejauhan, dll.",
	"Your previous plan is expired.": "Paket Anda sebelumnya kedaluwarsa.",
	"Upgrade the plan to restore the camera": "Tingkatkan paket untuk memulihkan kamera\n(%@)",
	"Remove from cloud": "Hapus dari cloud",
	"Are you sure you want to Remove_": "Anda yakin ingin Menghapus kamera ini dari slot Cloud?",
	"Remove: It doesn’t mean_": "Hapus: Tindakan ini tidak menghapus data kamera tetapi menyediakan slot cadangan untuk jumlah kamera cloud tersebut.",
	"Now the camera is removed from cloud slot": "Kamera dihapus dari slot Cloud.",
	"How to delete camera list": "Cara menghapus kamera dari daftar",
	Update: Update$a,
	"Camrea setting": "Pengaturan kamera",
	"Notification setting": "Pengaturan notifikasi dorong",
	"Driving reports": "Laporan mengemudi",
	"Cloud connection steps": "Langkah Koneksi Cloud",
	"Download the BlackVue app to add a camera": "Unduh aplikasi BlackVue untuk menambahkan kamera",
	"To see your camera in the BlackVue cloud viewer_": "Untuk melihat kamera Anda di BlackVue cloud viewer, pertama-tama, lakukan koneksi ke cloud. Cukup siapkan dan sambungkan kamera BlackVue Anda ke Cloud dengan aplikasi BlackVue untuk iOS dan Android.",
	"Download the BlackVue app to see a Wi-Fi connected camera": "Unduh aplikasi BlackVue untuk melihat kamera yang tersambung via Wi-Fi",
	"BlackVue Cloud web viewer only supports_": "BlackVue Cloud web viewer hanya mendukung kamera dasbor yang tersambung via cloud. Unduh aplikasi BlackVue untuk melihat kamera dasbor milik Anda yang tersambung via Wi-Fi.",
	"You can restore the data if_": "Data dapat dipulihkan jika Anda mendaftarkan lagi kamera ini ke akun yang sama. Akan tetapi, jika akun sudah dihapus, semua berkas Anda akan hilang.",
	"How to add camera": "Cara menambahkan kamera",
	"Try to wait 2-3 minutes if you just registered the camera.": "Coba tunggu 2-3 menit jika Anda baru saja mendaftarkan kamera.",
	"Try to check the Cloud Connection Settings again_": "Cek lagi Pengaturan Koneksi Cloud jika kamera masih belum menyambung ke Cloud.",
	"Motion Detection": "Deteksi Gerakan",
	"Parking recordings occur_": "Perekaman parkir terjadi saat gerakan terlihat terdeteksi.",
	"Motion Sensitivity": "Sensitivitas Gerakan",
	"Motion Detection Sensitivity": "Sensitivitas Deteksi Gerakan",
	"Select Detection Region": "Pilih kawasan deteksi",
	"Speed alert_2": "Peringatan Kecepatan",
	"Live Event Upload_2": "Live Event Upload",
	"Beep Alert": "Pengingat Bip",
	"Parking Impact History_": "Pengingat Riwayat Benturan Parkir",
	"To register your_": "Untuk mendaftarkan tombol SOS Anda, Anda harus menggunakan aplikasi BlackVue.",
	"SOS button on/off": "Status Tombol SOS",
	"File sharing to Event Map is_": "Berbagi file ke Peta Acara saat ini tidak tersedia. Periksa kembali nanti.",
	"Email Notifications": "Notifikasi email",
	"Push Notifications_2": "Notifikasi dorong",
	"Optional Camera Rotation": "Orientasi kamera opsi",
	"Optional Camera Security": "Keamanan kamera opsi",
	Option: Option$a,
	"(Owner)": "{{a}} (Pemilik)",
	"SOS button": "Tombol SOS",
	"This video has been reported_bold": "Video ini telah dilaporkan dan <b>dihapus oleh administrator.</b>",
	"Number of events_2": "Jumlah kejadian",
	"My Shared Videos": "Video yang Saya Bagikan",
	"No Hashtags": "Tanpa Tagar",
	"I have read and agree_": "Saya telah membaca dan menyetujui semua Syarat & Kebijakan",
	"14 years old_": "14 tahun ke atas",
	Required: Required$a,
	Optional: Optional$a,
	"Profile information_": "Informasi profil dapat diedit pada halaman Pengaturan Akun.",
	"Automatically Add Live_": "Bagikan berkas unggahan otomatis Kejadian ke Peta kejadian secara otomatis",
	"You must be 14 years_": "Anda wajib berumur 14 tahun ke atas untuk membuat akun BlackVue",
	"Use 8 or more characters_": "Gunakan 8 karakter atau lebih dengan kombinasi huruf, angka, atau simbol",
	"Protected files include_": "Berkas yang dilindungi mencakup: <br/>ㆍKejadian Benturan dalam Mode Normal (E) dan Parkir (I) <br/>ㆍKejadian Manual (M) <br/><br/>Setelah rekaman Kejadian mencapai {{a}}, Kejadian baru akan menimpa kejadian paling lama.",
	"Protected files include": "Protected files include",
	"If you turn_": "Jika Anda mematikan Panduan Suara, daftar berikut juga dimatikan.",
	"Live Event Upload_success": "Pengaturan Unggahan Kejadian Langsung berhasil disimpan.",
	"Video type": "Tipe video",
	"Notify the Owner": "Beri tahu Pemilik",
	"Adjusting the cut-off voltage_2": "Adjusting the cut-off voltage to a lower setting may result in your dash cam draining more power from your battery. This could result in warning messages of battery drain or affect other vehicle functions.\nPlease consult with your dealership before lowering the voltage.",
	Others: Others$a,
	"This video has been removed.": "Video ini telah dihapus.",
	"Please assign cameras_": "Tetapkan kamera untuk grup ini.",
	"Are you running_": "Kehabisan kesempatan untuk menyaksikan Pemutaran?",
	"Upgrade your plan_": "Tingkatkan paket Anda ke Paket Armada untuk Pemutaran Tanpa Batas dan aneka fitur Eksklusif Cloud lainnya.",
	"Are you running_Liveview": "Kehabisan waktu untuk menyaksikan Tampilan Langsung?",
	"Upgrade your plan_Liveview": "Tingkatkan paket Anda ke Paket Armada untuk Tampilan Langsung Tanpa Batas dan aneka fitur Eksklusif Cloud lainnya.",
	Stay: Stay$a,
	"Go to Fleet Plan": "Tingkatkan ke Paket Armada",
	"It looks like the video file is being prepared. please try again later.": "Sepertinya file video sedang disiapkan. silakan coba lagi nanti.",
	"Oops!": "Ups!",
	"Please back up_": "Harap cadangkan semua rekaman penting sebelum mengubah setelan ini.",
	"When you save_": "Saat Anda menyimpan pengaturan, kartu microSD akan diformat dan semua rekaman akan dihapus untuk memastikan pengoperasian yang stabil.",
	"This is an unregistered_": "Ini adalah email yang tidak terdaftar. Apakah Anda ingin pergi ke halaman Buat akun?",
	"Camera name must_2": "Nama kamera harus antara 5 dan 32 karakter.",
	"G-sensor (Normal mode)": "Sensor G (mode Normal)",
	"G-sensor (Parking mode)": "Sensor G (mode Parkir)",
	"Up & down": "Naik & turun",
	"Front & back": "Depan & belakang",
	"Rotate Video 180º": "Rotate Video 180º",
	Mask_2: Mask_2$a,
	"Priority event": "Priority Event",
	"There is no_camera": "There is no camera that your owner assigned to you.",
	"Camera SSID": "Camera SSID",
	"The BlackVue dashcam_2": "The BlackVue dashcam is not compatible with 5GHz wireless networks",
	"Driver detection box_2": "Driver Detection Box",
	"DMS camera recording_2": "DMS Camera Recording in Parking Mode",
	Low_2: Low_2$a,
	Medium_2: Medium_2$a,
	High_3: High_3$a,
	"Live Event Upload_3": "Live Event Upload",
	"Driving Impact": "Driving Impact",
	"Video source_2": "Video Source",
	"Front camera_2": "Front Camera",
	"Rear camera_2": "Rear Camera",
	"Optional Camera": "Optional Camera",
	"Motion Detection_2": "Motion Detection",
	"Rear camera stops_2": "Rear camera stops recording 5 minutes after entering Parking Mode. Recording restarts when entering normal mode.",
	"Passenger vehicle": "Passenger Vehicle",
	"Heavy vehicle": "Heavy Vehicle",
	Highest_3: Highest_3$a,
	Extreme_2: Extreme_2$a,
	"Less recording files": "Fewer Recording Files",
	"Camera rotation_2": "Camera Rotation",
	"Share camera profile_2": "Share Camera Profile",
	Private_2: Private_2$a,
	"BlackVue Live": "BlackVue Live",
	"Important All saved_": "Important! All saved videos are about to be deleted. Tap Cancel and back up important files if needed.",
	"Whenever saving settings_": "Whenever saving settings after changing the time zone, the SD card is initialized and all stored files are deleted.",
	"Do you want_": "Do you want to save your changes?",
	"No groups": "No groups",
	Lite: Lite$a,
	"USD per Camera": "USD per extra Camera",
	"up to Cameras": "up to Cameras",
	"All the P Plan_": "Semua fitur rencana <b>{{a}}</b>, ditambah:",
	"User Roles and Permissions": "Peran Pengguna dan Izin",
	"Geofence Setup (Web) and alerts": "Geofence Setup (Web) and alerts",
	"N Times": "{{a}} Kali",
	"N Minutes": "{{a}} Menit",
	"Emergency Alarm": "Alarm darurat",
	"Playback, Live View": "Putar, Live View",
	"Your driving record : Daily, Monthly": "Catatan mengemudi Anda: Harian, Bulanan",
	"Real-time Conversation": "Percakapan real-time",
	"Initiate a conversation_": "Memulai percakapan dengan pengemudi melalui speaker dan mikrofon Dashcam.",
	"Remote Voice Communication": "Komunikasi suara jarak jauh",
	"See the last location_": "Lihat lokasi terakhir kamera Anda",
	"Check your cars_": "Periksa data GPS real-time mobil Anda di peta untuk menemukan kendaraan Anda dan mendapatkan informasi tentang statusnya, seperti apakah itu mengemudi atau diparkir, dan kecepatannya.",
	"Supported models_": "* Model yang Didukung: Seri S dan Seri Awal X",
	"GPS Tracking &_": "Pelacakan GPS & Video di Peta (Smart/Fleet)",
	"Track your cars_": "Lacak lokasi mobil Anda dan kecepatan di peta!",
	"GPS Tracking: visualize_": "Pelacakan GPS: Visualisasikan log mengemudi Anda di peta.\nVideo di peta: Lihat info kontekstual (kecepatan, jenis acara) dan putar video terkait langsung dari peta.",
	"Visualize your cars_": "Visualisasikan lokasi dan kecepatan mobil Anda di peta!",
	"The feature enables_": "คุณลักษณะช่วยให้อัปโหลดวิดีโอลงคลาวด์ได้ รวมถึง 5 วินาทีก่อนเกิดอุบัติเหตุ",
	"Camera profile setting": "Camera profile setting",
	"Are you running_Download": "Are you running out of chance to Download Video?",
	"Upgrade your plan_Download": "Upgrade your plan to Fleet Plan for Unlimited Download, and other Cloud -Exclusive features.",
	"This feature is available for Smart and Fleet_": "This feature is available for Smart and Fleet Plan subscribers only.",
	"Rear camera will keep_": "Kamera belakang akan berhenti merekam dalam mode Parkir ketika status suhu dashcam diubah menjadi \"Suhu Tinggi\". Kamera belakang akan mulai merekam lagi setelah status suhu dashcam diubah menjadi \"Suhu Normal\". (Perhatian: Untuk melindungi elektroniknya, Blackvue mungkin akan mati karena suhu eksternal yang tinggi.)",
	"Get Unlimited Cloud_": "Dapatkan Putar Balik Awan Tanpa Had dan mengurus sehingga {{a}} kamera.",
	"Up to N cameras_": "Up to {{a}} cameras (+ {{b}} USD Extra charge)",
	"N Minutes per Day": "{{a}} menit per hari",
	"Drowsiness sensitivity is_": "Sensitivitas mengantuk diatur oleh periode berkedip mata dengan algoritme BlackVue yang dapat diandalkan. <br> <br> Sensitivitas Tidak Fokus diatur oleh sudut posisi kepala pengemudi dari depan dan durasinya.",
	"Not available with this plan": "Not available with this plan",
	"The optional camera records_": "Kamera Opsional merekam dalam Mode Parkir",
	"Smart and Fleet_": "Smart and Fleet Plan<br/>subscribers only",
	"This feature is_smart": "This feature is available for Smart and Fleet Plan subscribers only.",
	"Camera Registration": "Registrasi kamera",
	"Voice Call": "Voice Call",
	"N times per Month": "{{a}} times per Month",
	"Recommended for higher bitrate_": "Direkomendasikan untuk bitrate yang lebih tinggi dan kualitas video yang lebih baik.",
	"Recommended for for better compatibility_": "Direkomendasikan untuk kompatibilitas yang lebih baik dengan desktop dan perangkat seluler",
	"A minute of front camera_": "Diperkirakan ukuran file untuk video 1 menit (kamera depan)",
	"Extreme(N Mbps): N MB_": "Extreme ({{ex1}}Mbps) : {{ex2}}MB\nHighest ({{ht1}}Mbps) : {{ht2}}MB\nHigh ({{hi1}}Mbps) : {{hi2}}MB\nNormal ({{no1}}Mbps) : {{no2}}MB",
	"File size information reflects_": "Informasi ukuran file mencerminkan ukuran maksimum yang mungkin dan ukuran file aktual dapat bervariasi tergantung pada kondisi perekaman.",
	Bitrate: Bitrate$a,
	"Connection has been_": "Koneksi telah hilang.\nMembangun kembali koneksi ...",
	"Unable to establish_": "Tidak dapat membuat koneksi dengan kamera.\nHarap pastikan perangkat Anda terhubung dengan benar dan coba lagi.",
	"Purchased by Payment Service": "Dibeli oleh Layanan Pembayaran",
	"Up to N Cameras": "Hingga {{a}} Kamera",
	"Unlimited Live View": "Live View Tidak Terbatas",
	"N Days GPS Tracking": "Pelacakan GPS selama {{a}} hari",
	"Unlimited Playback and Download": "Pemutaran dan Unduhan tanpa batas",
	hours: hours$a,
	"Live Event Upload or_": "Live Event Upload atau 12+ video dalam resolusi penuh",
	"During the usage period of the One Plan_": "Selama periode penggunaan layanan One Plan, perubahan rencana langganan tidak mungkin. Untuk beralih ke rencana yang berbeda, silakan hubungi Dukungan Pelanggan BlackVue untuk membatalkan langganan One Plan.",
	"Service Period (Include SIM Data)": "Periode Layanan (Termasuk Data SIM)",
	"Purchase the BlackVue One Package_": "Beli Paket BlackVue One untuk membuka One Plan gratis selama 1 tahun.",
	"3GB SIM Data Plan": "Rencana Data SIM 3GB",
	"Unlimited Live View, Playback and Download": "Tampilan Langsung, Putar dan Unduh tanpa batas",
	"within data availability": "dalam ketersediaan data",
	"The BlackVue One Plan is a 1-year_": "BlackVue One Plan adalah rencana layanan cloud selama 1 tahun yang dapat diakses secara eksklusif melalui pembelian Paket BlackVue One, yang mencakup kamera dashboard, rencana data 3GB/bulan selama 1 tahun (untuk AS dan Kanada) dan rencana layanan cloud selama 1 tahun.\n",
	"The BlackVue One Package is available_": "Paket BlackVue One tersedia secara eksklusif di BlackVue Online Store.",
	"Go to BlackVue Shop": "Menuju BlackVue Shop",
	"Anonymous Cam": "Kamera anonim",
	"App only": "hanya di aplikasi",
	Expires: Expires$a,
	"N days remaining": "Sisa {{a}} hari",
	"No action needed_": "<b>Tidak perlu tindakan apa pun.</b> Harga baru yang telah diturunkan akan diterapkan secara otomatis mulai dari pembayaran Anda berikutnya setelah tanggal 13 September.",
	"The new reduced price_": "Harga baru yang telah diturunkan akan diterapkan secara otomatis ke akun Anda.",
	"Smart Plan Subscriber?": "Pelanggan Rencana Smart?",
	"Fleet Plan Subscriber?": "Pelanggan Rencana Fleet?",
	"Please take a moment to_": "Mohon sebentar untuk memberikan izin kepada kami untuk memindahkan akun Anda.",
	"Starting from now and_": "<b>Mulai sekarang hingga 31 Oktober</b>, Anda dapat membiarkan kami melakukan perubahan untuk Anda dengan <a href=\"https://form.jotform.com/232411253056041\" target=\"_blank\">Klik link ini</a> dan masukkan email akun Fleet Anda. Mohon berikan waktu kepada kami untuk memproses perubahan. Atau sebagai alternatif, Anda dapat membatalkan akun Anda yang sudah ada dan berlangganan kembali dengan harga baru mulai dari tanggal 13 September.",
	"Once activated_": "Setelah diaktifkan, One Plan tidak dapat dijeda atau dinonaktifkan.",
	"Once the One Plan is activated_": "Setelah One Plan diaktifkan, One Package tidak dapat dikembalikan.",
	"Up to N Cloud Camera Slot": "Hingga {{a}} slot kamera cloud",
	"nGB of Cloud Storage": "{{a}}GB penyimpanan cloud",
	"Get started for free_": "Get started for free, no credit card required. Includes Alert Push Notifications, limited Remote Live View and cloud storage.",
	"The BlackVue One Plan is exclusively_": "The BlackVue One Plan is exclusively available through the purchase of a BlackVue One Package. 3GB/mo data plan is for US and Canada only. BlackVue Cloud’s Free Plan, Lite Plan (1~3) and Smart Plan (1~3) accounts can upgrade to One Plan. However, Lite Plan (4~15), Smart Plan (4~15) and Fleet Plan accounts can not be upgraded to One Plan.",
	"For N year": "For {{a}} year",
	"Included in the One Package": "Included in the One Package",
	"3GB SIM Data Plan for N year": "3GB SIM Data Plan for {{a}} year",
	"One Plan Cloud Service for N year": "One Plan Cloud Service for {{a}} year",
	"The BlackVue One Package includes_": "The BlackVue One Package includes all you need to enjoy BlackVue Cloud for a whole year!",
	"4K LTE Dash Cam_": "4K LTE Dash Cam, Cloud Service and Data Plan",
	"nGB included": "{{a}}GB included",
	"nGB per camera": "{{a}}GB per camera",
	"N Days Live Event Upload": "{{a}} Days Live Event Upload",
	"Up to N Dash Cameras": "Up to {{a}} Dash Cameras",
	"Step N/N": "Langkah {{a}}/{{b}}",
	"Cloud Connection": "Koneksi ke Cloud",
	"To pair your dashcam": "Untuk menghubungkan dashcam Anda dengan baterai, silakan hubungkan ke Cloud.",
	Check: Check$a,
	"Unpair Battery": "Membatalkan penjodohan baterai",
	"Are you sure you want to unpair": "Apakah Anda yakin ingin membatalkan penjodohan baterai (%@) ini dari kamera?",
	"Unpair: It doesn't mean": "Batal Mengaitkan: Ini tidak berarti menghapus data baterai.",
	"*The paired battery will": "*Baterai yang dipasangkan juga akan dihapus bersama.",
	"Would you like to pair this": "Apakah Anda ingin memasangkan baterai ini?",
	"Battery successfully paired": "Baterai berhasil dipasangkan.",
	"Now you can directly connect to": "Sekarang Anda dapat terhubung langsung ke baterai dari daftar kamera.",
	"Pairing failed": "Gagal melakukan pairing. Silakan coba lagi.",
	"Battery Name": "Nama baterai",
	"Capacity History": "Riwayat Kapasitas",
	"The graph displays capacity": "Graf menampilkan tingkat daya baterai perkiraan menggunakan data dari koneksi cloud.\n Kapasitas baterai dapat bervariasi tergantung pada suhu, pengaturan dashcam, dan frekuensi peristiwa pemicu.",
	"Last 24 Hours": "24 Jam Terakhir",
	"Last 7 Days": "7 Hari Terakhir",
	"Battery Level": "Tingkat Baterai",
	"Temperature History": "Riwayat Suhu",
	"The graph displays temperature": "Grafik menampilkan tingkat suhu perkiraan menggunakan data dari koneksi cloud.",
	"Temperature Level": "Tingkat Suhu",
	"Connecting alert": "[ Menghubungkan ]\nData ditampilkan saat koneksi.",
	"Low Output power Alert": "[ Pemutusan daya keluaran ]\nTegangan keluaran terlalu rendah, membatasi penyediaan daya perangkat yang terhubung.",
	"High temp Alert": "[ Pemotongan daya masukan ]\nSuhu baterai terlalu tinggi, membatasi pengisian daya.",
	"Remaining time": "Waktu tersisa",
	"Remaining time estimate": "Sisa waktu adalah perkiraan berdasarkan konsumsi daya total perangkat yang terhubung.\n Ini dihitung ulang setiap 30 detik setelah terhubung ke baterai.",
	"Setting changed": "Pengaturan berubah",
	"Setting change failed": "Pengaturan gagal diubah",
	"Low Input power Alert": "[ Pemotongan daya masukan ]\nTegangan pengisian terlalu rendah, membatasi pengisian.",
	"High Input power Alert": "[ Pemotongan daya masukan ]\nTegangan pengisian terlalu tinggi, membatasi pengisian daya.",
	"Low temp_Cut off Alert": "[ Pemotongan daya masukan ]\nSuhu baterai terlalu rendah, membatasi pengisian dan waktu tahan.",
	"Low temp Alert": "[ Suhu rendah ]\nSuhu baterai terlalu rendah, membatasi waktu bertahan dan kecepatan pengisian.",
	"Low capacity Alert": "[ Kapasitas rendah ]\nKapasitas baterai terlalu rendah.\nMengemudi mobil untuk mengisi daya.",
	"Back to list": "Kembali ke daftar",
	Saving: Saving$a,
	Now: Now$a,
	"Power supplying is limited": "Penyediaan daya <b>terbatas</b>",
	"This battery is already paired": "Baterai ini sudah dipasangkan.",
	"Connecting to Battery": "Sedang menghubungkan ke baterai",
	"Paired battery": "Baterai Dipasangkan",
	"Battery unpairing failed": "Gagal membatalkan pairing baterai. Silakan coba lagi.",
	"A connection is already active": "Koneksi sudah aktif. Silakan coba lagi nanti.",
	"Searching for battery": "Mencari baterai",
	"Select battery to pair with your camera": "Pilih baterai untuk dipasangkan dengan kamera Anda.",
	"Unable to connect": "Tidak dapat terhubung",
	"A connection error has occurred": "Telah terjadi kesalahan koneksi. Silakan coba lagi.",
	"The paired dashcam has been disconnected": "Kamera dashboard yang dipasangkan telah terputus dari Cloud.\nSilakan periksa kondisi di bawah ini.",
	"Check if the battery is not fully discharged": "Periksa apakah baterai tidak sepenuhnya habis",
	"Check the Cloud connection of the paired dashcam": "Periksa koneksi Cloud dari dashcam yang dipasangkan.",
	"Connection lost": "Koneksi terputus",
	"A connection error has occurred shortly": "Terjadi kesalahan koneksi. Silakan coba untuk terhubung dalam waktu dekat.",
	"Charging is limited": "Pengisian <b>terbatas</b>",
	"Cannot connect to the battery": "Tidak dapat terhubung ke baterai.",
	"Please check the Cloud connection of the camera": "Harap periksa koneksi Cloud dari kamera.",
	"Charging complete in": "Pengisian daya selesai dalam %@",
	"Current Capacity": "Kapasitas Saat Ini",
	"Output Voltage": "Tegangan Keluaran",
	"Charging Voltage": "Tegangan Pengisian",
	Beep: Beep$a,
	"Battery Capacity": "Kapasitas Baterai",
	"Battery connection failed": "Koneksi baterai gagal",
	"Expansion battery": "Baterai cadangan",
	"Make sure it is switched on and within range": "• Pastikan kamera diaktifkan dan berada dalam jangkauan ponsel Anda.",
	"Make sure it is not wirelessly connected to another device": "• Pastikan kamera tidak tersambung secara nirkabel ke perangkat lain.",
	"Detected batteries": "Baterai terdeteksi",
	"Can't see your battery": "Tidak melihat baterai Anda?",
	"Download the Blackvue app to check": "Unduh aplikasi BlackVue untuk memeriksa baterai Anda dari jarak jauh",
	"By Using the app": "Dengan menggunakan aplikasi, Anda dapat memasangkan kamera mobil Anda dengan baterai dan memantau kapasitas baterai melalui Cloud. Setelah dipasangkan, Anda dapat memeriksa baterai di BlackVue Cloud Viewer.",
	Unpair: Unpair$a,
	"Occurs when the driver closes_": "Terjadi ketika pengemudi menutup kedua matanya saat mengemudi",
	"Occurs when the driver's head_": "Terjadi ketika kepala pengemudi lebih dari 50 derajat menjauh dari depan.",
	"Only detects distraction above_": "Disetel oleh distraksi di atas nilai yang ditetapkan. Anda dapat mengubah unit di 'Pengaturan kamera > Pemicu Kejadian > Unit mengemudi ceroboh'.",
	"Occurs when the driver is not wearing_": "Terjadi ketika pengemudi tidak mengenakan sabuk pengaman.",
	"Overlays a face detection box_": "Melapisi kotak deteksi wajah pada rekaman langsung dan rekaman kamera DMS.",
	"Seat Belt": "Sabuk pengaman",
	Detected: Detected$a,
	"No Seat Belt": "Tanpa sabuk pengaman",
	"Fatigue Risk Alert": "Peringatan Risiko Kelelahan",
	"The time is synchronized_Email": "Waktu disinkronkan dengan waktu di Notifikasi Email Anda.",
	"Sends an alert when drowsiness is_": "Mengirimkan peringatan ketika kantuk terdeteksi setelah kantuk awal.",
	"Data updates upon connection": "Data akan diperbarui saat terhubung.",
	"Sends a notification if_": "Mengirim notifikasi jika Anda melebihi 'Atur jam' selama mengemudi.",
	"Data updates Alert": "[ Menghubungkan ]\nData akan diperbarui saat terhubung.",
	"Cannot save settings": "Tidak dapat menyimpan pengaturan",
	"The time is synchronized_Push": "Waktu disinkronkan dengan waktu di Notifikasi dorong Anda.",
	"The file has been overwritten or deleted": "File telah ditimpa atau dihapus.",
	"Box Pro Models Settings": "Pengaturan Model Box Pro",
	"Push notifications can be configured_": "Pemberitahuan push dapat dikonfigurasi dalam pengaturan notifikasi kamera.",
	"Recording Video": "Merekam Video",
	"Cameras settings": "Pengaturan kamera",
	"Please configure the settings": "Silakan konfigurasi pengaturan",
	"Speed Priorities": "Prioritas kecepatan",
	"Set Speed Priority": "Tetapkan prioritas kecepatan",
	"Geofence-enter": "Masuk ke Geofence",
	"Geofence-exit": "Keluar dari Geofence",
	"Geofence-pass": "Melintasi Geofence",
	"Geofence-speed alert": "Pelanggaran Kecepatan Geofence",
	"Drive Position": "Posisi Pengemudi",
	"Left-Hand Drive": "Stir Kiri",
	"Right-Hand Drive": "Stir Kanan",
	"Please configure this setting_": "Harap ubah pengaturan ini jika pengemudi tidak terdeteksi dengan benar.",
	"A new feature in the BlackVue settings_": "Fitur baru di pengaturan BlackVue telah ditambahkan untuk menyinkronkan waktu kamera. Anda harus menyinkronkan waktu kamera Anda satu kali untuk perekaman waktu yang akurat.",
	"Feature location_": "Lokasi fitur:\nPengaturan kamera> Sistem > Sinkronisasi waktu",
	"Time Sync": "Sinkronisasi Waktu",
	"You can sync the time between_": "Anda dapat menyinkronkan waktu antara perangkat Anda dan kamera BlackVue. Memformat kartu SD diperlukan untuk sinkronisasi. Sebelum melanjutkan, harap cadangkan video yang diperlukan.",
	"Voice Alert": "Peringatan Suara",
	"Provides a voice alert_": "Memberikan pemberitahuan suara dari kamera dan mengirim notifikasi jika Anda melebihi waktu yang ditetapkan selama berkendara.",
	"Please enter a value": "Please enter a value.",
	"Notices & Notifications": "Berita & Notifikasi",
	"Only detects drowsiness above_": "Disetel oleh mengantuk di atas nilai yang ditetapkan. Anda dapat mengubah unit di 'Pengaturan kamera > Pemicu Kejadian > Unit mengemudi ceroboh'.",
	Promotion: Promotion$a,
	Notice: Notice$a,
	"View More": "Lihat lebih banyak",
	"Read More": "Baca selengkapnya",
	"Detection Box": "Kotak Deteksi",
	"Seatbelt Detection Box": "Kotak Deteksi Sabuk Pengaman",
	"Drive Position Detection Box": "Kotak Deteksi Posisi Mengemudi",
	"Fleet Subscription Promotion (50%)": "Promosi Berlangganan Armada (50%)",
	"BlackVue Fleet Tracking exclusive features_": "Fitur eksklusif Pelacakan Armada BlackVue untuk pengguna tingkat lanjut dan bisnis (Banyak pengguna dan kamera, pembatasan wilayah, Penampil Web, dll.).",
	"Special Discount (50% off)": "Diskon Spesial (diskon 50%)",
	"*Promotion applied for 12 months": "*Promosi berlaku selama 12 bulan",
	"*Payment will be made starting next month.": "*Pembayaran akan dilakukan mulai bulan depan.",
	"[About using promotions]": "[Tentang penggunaan promosi]",
	"The promotion is free for the first month_": "Promosi ini gratis untuk bulan pertama dan kemudian ditagih selama 12 bulan mulai bulan berikutnya.",
	"For users with an existing Lite/Smart subscription_": "Untuk pengguna yang sudah memiliki langganan Lite/Smart, Anda harus membatalkan langganan aplikasi yang ada secara terpisah, jika tidak, langganan aplikasi yang ada mungkin akan dibebankan ke akun Anda.",
	"Please be sure to cancel your app subscription_": "Pastikan untuk membatalkan langganan aplikasi Anda dalam periode gratis. Pembayaran ganda tidak akan dikembalikan.",
	"You will be changed to Fleet Plan immediately_": "Anda akan segera diubah ke Paket Armada, meskipun sisa masa berlangganan Paket Lite/Smart Anda yang ada belum kedaluwarsa.",
	"You can cancel Fleet Plan any time.": "Anda dapat membatalkan Fleet Plan kapan saja.",
	"From February 2025, please go to the Fleeta service and use it.": "Setelah promosi dibatalkan, promosi tidak akan diterapkan kembali.",
	"After promotion expires_": "Setelah promosi berakhir, Anda akan otomatis diperpanjang dengan biaya berlangganan Fleet Plan yang ada.",
	"(Required) I have read the promotion instructions_": "(Wajib) Saya telah membaca instruksi promosi dan menyetujui pembayaran.",
	"Upgrade to Fleet Plan immediately": "Segera tingkatkan ke Paket Armada",
	"Important Notice:": "Pemberitahuan Penting:",
	"Switch of BlackVue Web Viewer to Fleeta Web Viewer": "Beralih dari Penampil Web BlackVue ke Penampil Web Fleeta",
	"To provide better features and quality_": "Untuk memberikan fitur dan kualitas yang lebih baik, layanan penampil web BlackVue akan segera beralih ke layanan penampil web armada baru yang disebut Fleeta. Layanan Fleeta akan eksklusif hanya untuk pengguna Fleet Plan. Layanan Fleeta akan diluncurkan pada Maret 2025, dengan Aplikasi eksklusif Fleeta baru. Silakan kunjungi <a href=\"https://www.fleeta.io\" target=\"_blank\">fleeta.io</a> untuk mengetahui lebih lanjut.",
	"We kindly ask for your understanding_": "Kami mohon pengertian Anda, karena perubahan ini dimaksudkan untuk memberikan layanan yang lebih baik. Untuk pertanyaan apa pun mengenai transisi ini, silakan menghubungi pusat CS kami.",
	"Don’t show this again for this month": "Jangan tampilkan ini lagi untuk bulan ini",
	"Fleet Plan Subscription Promotion": "Promosi Berlangganan Fleet Plan",
	"Period : December 2, 2024 ~ May 31, 2025": "Periode : 2 Desember 2024 ~ 31 Mei 2025",
	"See more details": "Lihat lebih detail",
	"To continue improve quality and provide better service_": "Untuk terus meningkatkan kualitas dan memberikan layanan yang lebih baik, layanan BlackVue Web Viewer kami akan segera beralih ke layanan eksklusif Fleet Plan. Ini tidak lagi tersedia secara gratis atau melalui paket lain mulai akhir Maret 2025.",
	"We have prepared special discount offers for_": "Kami telah menyiapkan penawaran diskon khusus untuk pengguna Web Viewer kami yang sudah ada. Silakan periksa detailnya di bawah ini! Kami dengan hormat meminta pengertian dan dukungan Anda saat kami menerapkan perubahan ini untuk memberikan layanan yang lebih baik.\n",
	"*If you are subscribed in-app_": "*Jika Anda berlangganan dalam aplikasi, pastikan untuk membatalkan langganan dalam aplikasi Anda.",
	"Enjoy your BlackVue Cloud service with your dashcam.": "Nikmati layanan BlackVue Cloud Anda dengan kamera dasbor Anda.",
	"Available Cloud Camera slot(s)_": "Slot Kamera Cloud yang tersedia : {{d}}",
	"Not eligible for the promotion.": "Tidak memenuhi syarat untuk promosi.",
	"You have already used_": "Anda sudah menggunakan promosi ini. Setelah promosi dibatalkan, promosi tidak dapat diterapkan kembali.",
	"Go to Cameras": "Buka Kamera",
	"Congratulations !": "Congratulations !",
	"Fleet Plan user": "Fleet Plan user",
	"Let your BlackVue monitor_": "Biarkan BlackVue memantau mobil Anda dan memperingatkan Anda jika terjadi insiden. Saat Dampak terdeteksi, BlackVue Anda akan mengirimkan pemberitahuan ke ponsel Anda, disertai dengan snapshot.\n",
	"Live Event Upload feature automatically_": "Fitur Unggah Acara Langsung secara otomatis mengunggah rekaman video, termasuk rekaman sebelum kecelakaan, ke BlackVue Cloud Storage untuk menjaga keamanan video Anda!",
	"*Buffer time varies by model.": "*Waktu buffer bervariasi tergantung model.",
	Explore: Explore$a,
	"Cloud Storage": "Penyimpanan Awan",
	"My Cloud Cameras": "Kamera Cloud Saya",
	"My Cloud Cameras Only": "Hanya Kamera Cloud Saya",
	"BlackVue Live Camera": "Kamera Langsung BlackVue",
	"*For BlackVue Live Cameras_": "*Untuk BlackVue Live Cameras, hanya kamera yang dibagikan sebagai publik di pengaturan kamera yang dapat dilihat di peta.",
	"*Share Method_": "*Metode Berbagi: Pengaturan Kamera>Privasi",
	"Once the promotion is canceled_": "Setelah promosi dibatalkan, promosi tidak akan diterapkan kembali.",
	"It will show_": "Ini akan muncul di sini saat tersedia.",
	"Deactivate Cloud": "Nonaktifkan Awan",
	"Are you sure you want to deactivate_": "Apakah Anda yakin ingin menonaktifkan Cloud untuk kamera ini?",
	"Deactivate : It doesn’t_": "Anda selalu dapat mengaktifkan cloud kapan saja. Kamera dapat dihapus setelah penonaktifan selesai.",
	Deactivate: Deactivate$a,
	"*If you made the payment through_": "*Jika Anda melakukan pembayaran melalui aplikasi, silakan restart aplikasi.",
	"Connect Dashcam Locally (Wi-Fi)": "Hubungkan Dashcam Secara Lokal (Wi-Fi)",
	"Cloud Connection Setting": "Pengaturan Koneksi Cloud",
	"Camera Profile": "Profil kamera",
	"Camera Settings": "Pengaturan kamera",
	"Format MicroSD Card": "Format kartu microSD",
	"Remote Firmware Update": "Pembaruan Firmware Jarak Jauh",
	"Remove from Cloud": "Hapus dari Awan",
	"The location may not be accurate_": "Lokasinya mungkin tidak akurat karena kamera tidak terhubung ke cloud.",
	"The location of the camera cannot be found_": "Lokasi kamera tidak dapat ditemukan. Silakan periksa Pengaturan Koneksi Cloud.",
	"Manage\nFLEETA Drive": "Kelola\nFLEETA Penyimpanan",
	"Cloud\nConnection": "Koneksi\ncloud",
	"Available on FLEETA App": "Tersedia di Aplikasi FLEETA",
	"Available for Cloud dashcam OR on FLEETA App.": "Tersedia untuk dashcam Cloud ATAU di Aplikasi FLEETA.",
	"Get started with_": "Mulai dengan percobaan gratis 1 bulan",
	"Experience all of_": "Rasakan semua fitur premium FLEETA secara gratis selama masa percobaan 1 bulan Anda.\n\nTanpa komitmen—bisa dibatalkan kapan saja",
	"Welcome to FLEETA Webviewer.": "Selamat datang di FLEETA Webviewer.",
	"Let FLEETA get_": "Biarkan FLEETA mengenal Anda",
	"Help improve your_": "Bantu tingkatkan pengalaman Anda dengan berbagi beberapa detail",
	"Business Industry": "Industri Bisnis",
	"Vehicle & Cargo": "Kendaraan & Muatan",
	Compliance: Compliance$a,
	"Would you like to skip?": "Apakah Anda ingin melewati?",
	"What is your business industry?": "Apa industri bisnis Anda?",
	"Transportation & Logistics": "Transportasi & Logistik",
	"Rental & Leasing": "Penyewaan & Leasing",
	"Construction & Building": "Konstruksi & Bangunan",
	"Government & Public": "Pemerintah & Publik",
	"Facility & Utility Management": "Manajemen Fasilitas & Utilitas",
	Manufacturing: Manufacturing$a,
	"Retail & Wholesale": "Ritel & Grosir",
	Emergency: Emergency$a,
	Security: Security$a,
	"How many employees do you need to manage?": "Berapa banyak karyawan yang perlu Anda kelola?",
	"How many vehicles does your company operate?": "Berapa banyak kendaraan yang dioperasikan perusahaan Anda?",
	"Why do you use a fleet tracking service?": "Mengapa Anda menggunakan layanan pelacakan armada?",
	"Route Tracking": "Pelacakan rute",
	"Real-time Monitoring": "Pemantauan waktu nyata",
	"Incident Detection & Check video": "Deteksi insiden & Periksa video",
	"Behavior Monitoring & Analysis": "Pemantauan & Analisis Perilaku",
	"Evaluation & Management": "Evaluasi & Manajemen",
	"Theft Prevention": "Pencegahan Pencurian",
	"Monitoring & Maintenance": "Pemantauan & Pemeliharaan",
	"Verification & Management": "Verifikasi & Manajemen",
	"BlackVue App Use Only": "Hanya untuk Penggunaan Aplikasi BlackVue",
	"Your current plan allow_": "Rencana saat ini Anda memungkinkan penggunaan aplikasi BlackVue. Untuk menggunakan Web Viewer, silakan berlangganan Rencana Fleet (FLEETA).",
	"Learn more about the Fleet_": "Pelajari lebih lanjut tentang Rencana Armada (FLEETA)",
	"Special Offer": "Penawaran Khusus",
	"For a limited time_": "Untuk waktu terbatas, nikmati diskon 50% untuk langganan Rencana Armada Anda.",
	"See Discount Details": "Lihat Detail Diskon",
	"To subscribe to the Fleet_": "Untuk berlangganan Rencana Armada, silakan batalkan langganan BlackVue di aplikasi terlebih dahulu untuk menghindari biaya ganda.",
	"Skip tour": "Lewati tur",
	"In the cloud_": "Dalam lingkungan cloud, Anda dapat mengakses putar, tayangan langsung (termasuk tampilan multi), GPS langsung, dan laporan, semuanya melalui FLEETA Web Viewer.",
	"Cloud Storage is_": "Penyimpanan cloud adalah tempat video yang Anda unggah disimpan dengan aman di cloud. Unggah video Anda untuk menjaga keamanannya dalam waktu yang lama.",
	"Toggle to switch_": "Beralih untuk mengganti Peta / Daftar",
	"In List View_": "Dalam Tampilan Daftar, Anda dapat dengan mudah melihat dan mengelola grup, anggota, dan informasi firmware secara sekilas.",
	"What is Cloud Storage?": "Apa itu Penyimpanan cloud?",
	"Cloud Storage Overview": "Ikhtisar Penyimpanan cloud",
	"Difference Between FLEETA_": "Perbedaan antara FLEETA Penyimpanan dan Unggah Acara Langsung",
	"FLEETA Drive stores_": "FLEETA Penyimpanan menyimpan video yang Anda unggah secara manual",
	"Live Event Upload automatically_": "Unggah Acara Langsung secara otomatis menyimpan video ketika terjadi suatu peristiwa.",
	"Live Event Upload videos_": "Video Unggah Acara Langsung memiliki periode kedaluwarsa. Jika Anda ingin menyimpannya lebih lama, pindahkan ke FLEETA Penyimpanan.",
	"Note: SD Card_": "Catatan: Video di SD Card dalam Putar",
	"Videos stored on_": "Video yang disimpan di kartu SD Anda dapat diakses melalui menu Putar.",
	"Set your image_": "Atur gambar Anda menggunakan bingkai yang disediakan. Setelah gambar disimpan, gambar tersebut akan ditampilkan di kartu kamera dan ikon tampilan peta.",
	"*Only jpg and_": "*Hanya file jpg dan png yang didukung.",
	"Set as default image": "Tetapkan sebagai gambar default",
	"Camera Details": "Detail Kamera",
	"IT & Telecommunications": "TI & Telekomunikasi",
	"The name must_32": "Nama harus antara 1 hingga 32 karakter.",
	"Unable to display the map.": "Tidak dapat menampilkan peta.",
	"The camera location cannot be found_": "Lokasi kamera tidak dapat ditemukan karena koneksi GPS yang buruk.",
	"Cloud Cameras": "Kamera cloud",
	"Want to unlock_": "Ingin membuka fitur manajemen armada?",
	"*Web subscription only": "*Hanya berlangganan web",
	"Uploads event_": "Mengunggah rekaman acara ke Penyimpanan cloud secara instan saat acara terjadi.",
	"Starts a conversation_": "Memulai percakapan dengan pengemudi menggunakan speaker dan mikrofon dari dashcam.",
	"Remotely check_": "Periksa tingkat dan status baterai dari jarak jauh melalui cloud.",
	"Receive a voice_": "Terima peringatan suara dan notifikasi jika waktu mengemudi melebihi batas.",
	"View your_": "Lihat catatan mengemudi Anda di peta.",
	"View speed, event_": "Lihat kecepatan, tipe event, dan putar video terkait langsung di peta.",
	"FLEETA Tracking exclusive_": "FLEETA Tracking menawarkan fitur eksklusif untuk pengguna berdaya dan bisnis (Pengguna dan kamera berganda, geofencing, dll.).",
	"Cloud Cameras per Account": "Kamera Cloud per Akun",
	"Connect Dashcam Locally_": "Sambungkan Dashcam Secara Lokal (Wi-Fi) (Putar, Unduh, Tayangan Langsung)",
	"Available with_": "Tersedia dengan baterai BlackVue",
	"Cloud Battery": "Baterai cloud",
	"Driving Reports": "Laporan Mengemudi",
	"Video on Map": "Video di Peta",
	"Multi Live View (Fleeta Web Viewer)": "Tampilan Langsung Multi (Penampil Web FLEETA)",
	"Enter a number": "Masukkan angka",
	"Permission required.": "Izin diperlukan.",
	"Please contact_": "Silakan hubungi pemilik untuk bantuan.",
	"Access not available": "Akses tidak tersedia.",
	"This file cannot be deleted now.": "Berkas ini tidak dapat dihapus sekarang.",
	"Please try again later.": "Silakan coba lagi nanti.",
	"Permission required.\nPlease_": "Izin diperlukan.\nSilakan hubungi pemilik untuk bantuan.",
	"Cloud Storage is disconnected_": "Penyimpanan cloud terputus. Silakan periksa koneksi.",
	"Manage the plan_": "Kelola rencana untuk mengembalikan kamera",
	"Notify the owner_": "Beritahu pemilik untuk mengelola rencana",
	"Access Restricted:_": "Akses Dibatasi: Langganan Berakhir",
	"Access is currently_": "Akses saat ini tidak tersedia karena langganan telah kedaluwarsa.",
	"Please contact your owner_": "Silakan hubungi pemilik Anda untuk menyelesaikan masalah ini.",
	"Access will be_": "Akses akan dipulihkan setelah langganan diperbarui",
	"Cloud is disconnected_": "Penyimpanan cloud terputus. \nSilakan periksa koneksi.",
	"Connect to Cloud with_": "Sambungkan ke Penyimpanan cloud dengan FLEETA APP",
	"Using Wi-Fi Hotspot": "Menggunakan Hotspot Wi-Fi",
	Important: Important$a,
	"Pre-Event buffer_": "Perekaman buffer pra-acara dinonaktifkan dalam mode ini.",
	"connectivity is_": "Konektivitas dibatasi dalam mode ini.",
	"video upload starts_": "Pengunggahan video dimulai setelah perekaman selesai.",
	"Power Saving": "Penghematan Energi",
	"In all modes_": "Dalam semua mode, dampak yang terdeteksi memicu perekaman video Event.",
	"Battery Protection setting _": "Pengaturan Perlindungan Baterai harus diaktifkan.",
	"At least one of_": "Setidaknya salah satu pengaturan berikut harus diaktifkan",
	or: or$a,
	"For BlackVue battery users": "Untuk pengguna baterai BlackVue",
	"we recommend setting_": "Kami merekomendasikan mengatur pemutusan tegangan ke nilai minimum untuk penggunaan baterai maksimal.",
	"No videos were found.": "Tidak ada video yang ditemukan.",
	"Try different filter_": "Coba filter lain atau reset filter.",
	"Not avaliable with_": "Tidak tersedia dengan kamera saat ini",
	"Overlays a detection_": "Menambahkan kotak deteksi pada rekaman langsung dan yang telah direkam dari kamera DMS.",
	"A minute of_": "Satu menit video kamera depan akan sekitar",
	"System voice guidance": "Panduan Suara Sistem",
	"Recording trigger": "Pemicu Perekaman",
	"Remote Button (Optional)": "Tombol Jarak Jauh (Opsional)",
	"Remote button settings_": "Pengaturan tombol jarak jauh tidak dapat diubah melalui koneksi cloud. Untuk memodifikasi pengaturan ini, navigasikan ke Kamera > Sambungkan Secara Lokal > Pengaturan Kamera.",
	"No Registered Device": "Tidak Ada Perangkat Terdaftar",
	"Subscription process is complete": "Proses berlangganan telah selesai",
	"Now, go back to_": "Sekarang, kembali ke aplikasi FLEETA, masuk ke akun Anda, dan mulai menikmati layanan tersebut.",
	"You can check the upload progress": "Anda dapat memeriksa kemajuan unggahan di tab Penyimpanan cloud > FLEETA Penyimpanan.",
	"SIM card must be inserted in_": "Kartu SIM harus dimasukkan ke dalam kamera untuk mulai menggunakan Cloud.",
	"Active until:": "Aktif sampai:",
	Subscribe: Subscribe$a,
	"Camera PSN": "Kamera PSN",
	"BlackVue Sim Free Trial Started!": "Uji Coba Gratis BlackVue Sim Dimulai!",
	"Enjoy a free period to use your SIM_": "Nikmati periode gratis untuk menggunakan SIM Anda tanpa berlangganan!",
	"You can stay connected during the trial_": "Anda dapat tetap terhubung selama uji coba, namun ingat:",
	"Complete your subscription before the trial_": "Selesaikan langganan Anda sebelum uji coba berakhir untuk terus menggunakan SIM.",
	"If you don't subscribe by the end of the trial_": "Jika Anda tidak berlangganan pada akhir uji coba, layanan SIM Anda akan dinonaktifkan.",
	"Save Event Videos_": "Simpan Video Acara ke Cloud Storage secara real time!",
	"Note: Deleting your account doesn’t cancel": "Catatan: Menghapus akun Anda tidak membatalkan langganan Anda. Untuk membatalkan, pergi ke Akun > Langganan di penampil web FLEETA.",
	"Available only on FLEETA App for_": "Tersedia hanya di Aplikasi FLEETA untuk model ini.",
	"The cloud is deactivated": "Awan dinonaktifkan.",
	"Please add a camera with FLEETA_": "Silakan tambahkan kamera dengan APP FLEETA untuk menggunakan fitur ini.",
	"Upload videos to FLEETA_": "Unggah video ke FLEETA Penyimpanan dan jaga keamanannya!",
	"You have no assigned camera_": "Anda tidak memiliki kamera yang ditugaskan.\nSilakan hubungi pemilik untuk meminta penugasan.",
	"Camera notification settings": "Pengaturan notifikasi kamera",
	Vehicle: Vehicle$a,
	"App Download": "Unduh Aplikasi",
	"Have a problem with_": "Ada masalah dengan langganan?",
	"Restore Purchase": "Pulihkan Pembelian",
	"Battery Pairing": "Pemasangan Baterai",
	"Playback\nLive View": "Pemutaran/\nTampilan Langsung",
	"Remote Playback": "Pemutaran Jarak Jauh",
	"Cloud connection settings": "Pengaturan koneksi awan",
	"Go to settings": "Buka pengaturan",
	"Only cloud cameras that_": "Hanya kamera cloud yang dipilih pengguna untuk dibagikan secara publik yang ditampilkan di peta.",
	"Live Broadcast Cameras": "Kamera Siaran Langsung",
	"*Live Broadcast Cameras_": "*Kamera Siaran Langsung adalah kamera cloud yang diatur untuk disiarkan oleh pengguna.",
	"Only cloud cameras_": "Hanya kamera cloud yang dipilih pengguna untuk disiarkan yang ditampilkan di peta."
};

var Dashboard$9 = "Pannello di controllo";
var Account$9 = "Account";
var Help$9 = "Guida";
var Mac$9 = "Mac";
var Windows$9 = "Windows";
var Admin$9 = "Ammin.";
var Driver$9 = "Autista";
var Cameras$9 = "Telecamere";
var Manage$9 = "Gestisci";
var Clear$9 = "Chiaro";
var Show$9 = "Mostrare";
var GB$9 = "{{a}}GB";
var _section$9 = ".";
var Name$9 = "Nome";
var Password$9 = "Password";
var Cancel$9 = "Annulla";
var Members$9 = "Membri";
var Groups$9 = "Gruppi";
var Role$9 = "Ruolo";
var Group$9 = "Gruppo";
var Status$9 = "Stato";
var nPM$9 = "{{a}} PM";
var nAM$9 = "{{a}} AM";
var Newest$9 = "Più recente";
var Oldest$9 = "Più vecchio";
var Accepted$9 = "Accettato";
var Pending$9 = "In sospeso";
var Expired$9 = "Scaduto";
var All$9 = "Tutto";
var Delete_$9 = "Elimina {{a}}";
var Delete$9 = "Elimina";
var Rename$9 = "Cambiare nome";
var Add$9 = "Aggiungi";
var OK$9 = "OK";
var Remove$9 = "Elimina";
var Files$9 = "File";
var Features$9 = "Caratteristiche";
var Settings$9 = "Impostaz.";
var Upload$9 = "Caricare";
var Privacy$9 = "Privacy";
var Done$9 = "Fatto";
var Subscription$9 = "Abbonamento";
var Submasters$9 = "amministratori";
var Users$9 = "conducenti";
var Change$9 = "Cambia";
var Method$9 = "Metodo";
var Details$9 = "Info telecamera.";
var Confirm$9 = "Conferma";
var Address$9 = "Indirizzo";
var Country$9 = "Paese";
var State$9 = "Stato";
var ZIP$9 = "CAP";
var Pricing$9 = "Prezzi";
var Free$9 = "Free";
var Smart$9 = "Smart";
var Fleet$9 = "Fleet";
var Subscrubed$9 = "Abbonato";
var January$9 = "gennaio";
var February$9 = "Feburary";
var March$9 = "marzo";
var April$9 = "aprile";
var May$9 = "Maggio";
var June$9 = "giugno";
var July$9 = "luglio";
var August$9 = "agosto";
var September$9 = "settembre";
var October$9 = "ottobre";
var November$9 = "novembre";
var December$9 = "dicembre";
var Blackvuecloud_$9 = "www.blackvuecloud.com";
var Support$9 = "Support";
var Community$9 = "Community";
var FAQ$9 = "FAQ";
var Developers$9 = "Developers";
var Facebook$9 = "Facebook";
var Twitter$9 = "Twitter";
var Instagram$9 = "Instagram";
var Youtube$9 = "Youtube";
var Linkedin$9 = "Linkedin";
var Downloads$9 = "Download";
var Unauthorized$9 = "Operazione non autorizzata";
var none$9 = "Nessuno";
var Email$9 = "E-mail";
var Customers$9 = "Customers";
var Home$9 = "Home";
var Plan$9 = "Plan";
var New$9 = "New";
var Unsubscribed$9 = "Unsubscribed";
var Edit$9 = "Edit";
var month$9 = "month";
var months$9 = "months";
var Continue$9 = "Continue";
var Back$9 = "Di ritorno";
var Master$9 = "Owner";
var Develop$9 = "Developers";
var $9$9 = "$9";
var $15$9 = "$15";
var $10$9 = "$10";
var mo$9 = "Mese";
var City$9 = "Città";
var Charge$9 = "Addebito";
var subscribe$9 = "Abbonati";
var search$9 = "Cercare";
var invalid_number$9 = "Il numero della carta non è un numero di carta di credito valido";
var invalid_expiry_month$9 = "Il mese di scadenza della carta non è valido";
var invalid_expiry_year$9 = "L'anno di scadenza della carta non è valido";
var invalid_cvc$9 = "Il codice di sicurezza della carta non è valido";
var incorrect_number$9 = "Il numero della carta è errato";
var incomplete_number$9 = "Il numero della carta è incompleto";
var incomplete_cvc$9 = "Il codice di sicurezza della carta è incompleto";
var incomplete_expiry$9 = "La data di scadenza della carta è incompleta";
var expired_card$9 = "La carta è scaduta";
var incorrect_cvc$9 = "Il codice di sicurezza della carta è errato";
var incorrect_zip$9 = "La convalida del CAP della carta non è riuscita";
var invalid_expiry_year_past$9 = "L'anno di scadenza della carta è nel passato";
var card_declined$9 = "La carta è stata rifiutata";
var missing$9 = "Non c'è nessuna carta di un cliente addebitata";
var processing_error$9 = "Si è verificato un errore durante l'elaborazione della carta";
var Paypal$9 = "Paypal";
var iOS$9 = "iOS";
var Android$9 = "Android";
var Total$9 = "Totale";
var And$9 = "e";
var Camera$9 = "Camera";
var Yes$9 = "Sì";
var No$9 = "No";
var News$9 = "Notizie";
var Notifications$9 = "Notifiche";
var MPH$9 = "MPH";
var Firmware$9 = "Firmware";
var Basic$9 = "Base";
var Resolution$9 = "Risoluzione";
var Brightness$9 = "Luminosità";
var Recording$9 = "Registrazione in corso";
var Highest$9 = "Molto alta";
var High$9 = "Elevata";
var Normal$9 = "Normale";
var Sensitivity$9 = "Sensibilità";
var Volume$9 = "Volume";
var Close$9 = "Close";
var Cloud$9 = "Cloud";
var Public$9 = "Public";
var Front$9 = "Anteriore";
var Rear$9 = "Posteriore";
var Play$9 = "Esegui";
var Stop$9 = "Arresta";
var Pause$9 = "Pausa";
var Time$9 = "Time";
var System$9 = "Sistema";
var Event$9 = "Evento";
var Parking$9 = "Parcheggio";
var Color$9 = "Colore";
var Exit$9 = "Uscire";
var Save$9 = "Salva";
var Impact$9 = "Impatto";
var Unlimited$9 = "Illimitata";
var Default$9 = "Predefinito";
var Version$9 = "Versione";
var Language$9 = "Lingua";
var Notification$9 = "Notifica";
var Multiple$9 = "Multiplo";
var Range$9 = "Intervallo";
var Download$9 = "Scarica";
var Manual$9 = "Manuale";
var Satellite$9 = "Satellitare";
var Tutorials$9 = "Tutorial";
var Filter$9 = "Filtra";
var Sun$9 = "Dom";
var Mon$9 = "Lun";
var Tue$9 = "Mar";
var Wed$9 = "Mer";
var Thu$9 = "Gio";
var Fri$9 = "Ven";
var Sat$9 = "Sab";
var Dates$9 = "Date";
var Routes$9 = "Percorsoi";
var Opacity$9 = "Opacità";
var Entry$9 = "Voce";
var Owner$9 = "Owner";
var Undetected$9 = "Partenza";
var Distracted$9 = "Distrauto";
var Drowsy$9 = "Drowsy";
var Calling$9 = "Calling";
var Smoking$9 = "Smoking";
var Permissions$9 = "Autorizzazioni";
var Private$9 = "Privato";
var Entering$9 = "In entrata";
var Exiting$9 = "In uscita";
var Acceleration$9 = "Accelerazione";
var Passing$9 = "Attraversamento";
var Overspeed$9 = "Velocità eccessiva";
var Recipients$9 = "Destinatari";
var Send$9 = "Invia";
var Note$9 = "Nota";
var Video$9 = "Video";
var Advanced$9 = "Avanzate";
var Voice$9 = "Voce";
var Days_$9 = "Giorni";
var Mute$9 = "Disattiva audio";
var UnMute$9 = "Riattiva audio";
var Discard$9 = "Annulla";
var Report$9 = "Report";
var Individual$9 = "Sei un conducente in cerca di tranquillità? Sei un titolare di azienda che ha bisogno di una soluzione semplice per gestire la sicurezza e il monitoraggio dei suoi veicoli?";
var Subscribed$9 = "Abbonato";
var Geofence$9 = "Recinto virtuale";
var Driving$9 = "Guida";
var Idling$9 = "Inattività";
var Distance$9 = "Distanza";
var Parked$9 = "Parked";
var Speed$9 = "Velocità";
var Highest_2$9 = "Massima";
var Average$9 = "Media";
var Geofences$9 = "Recinti virtuali";
var Move$9 = "Sposta";
var Connected$9 = "Collegato";
var Individual_$9 = "Singolo";
var Always$9 = "Sempre";
var Low$9 = "Basso";
var Medium$9 = "Medio";
var High_2$9 = "Alto";
var Flip$9 = "Capovolgi";
var Previous$9 = "Fotogramma prec.";
var Next$9 = "Succ.";
var Expand$9 = "Espandi";
var Collapse$9 = "Comprimi";
var More$9 = "Altro";
var Multi$9 = "Multiplo";
var Safe$9 = "Sicuro";
var Reckless$9 = "Spericolato";
var Inattentive$9 = "Disattento";
var List$9 = "Elenco";
var Usage$9 = "Utilizzo";
var Profile$9 = "Profilo";
var Fullscreen$9 = "Schermo intero";
var Upgrade$9 = "Aggiornamento";
var Management$9 = "Gestione";
var Day$9 = "Giorno";
var Month$9 = "Mese";
var Later$9 = "Più tardi";
var ICCID$9 = "ICCID";
var Resubscribe$9 = "Rinnova abbonamento";
var plan$9 = "piano";
var USD$9 = "USD";
var etc_$9 = "Altro:";
var Available$9 = "Disponibile";
var Used$9 = "Utilizzato";
var Cancelled$9 = "Annullato";
var Terminated$9 = "Terminato";
var Sort$9 = "Ordinamento";
var Bonus$9 = "Bonus";
var incomplete_zip$9 = "La convalida del CAP della carta non è riuscita";
var Upgrades$9 = "Aggiornamenti";
var OR$9 = "OPPURE";
var Undo$9 = "Annulla";
var Invoice$9 = "Fattura";
var data$9 = "Dati";
var Popular$9 = "Popular";
var Mask$9 = "Assenza di mascherina";
var DMS$9 = "stato di monitoraggio del conducente (DMS)";
var Extreme$9 = "Estremo";
var OFF$9 = "Disattivato";
var Threshold$9 = "Soglia";
var Drowsiness$9 = "Sonnolenza";
var Direct$9 = "Diretto";
var Remote$9 = "Telecomando";
var Update$9 = "Aggiornare";
var Option$9 = "Opzione";
var Required$9 = "Richiesto";
var Optional$9 = "Opzionale";
var Others$9 = "Altro";
var Stay$9 = "Inserimento parziale";
var Mask_2$9 = "Mask";
var Low_2$9 = "Low";
var Medium_2$9 = "Medium";
var High_3$9 = "High";
var Highest_3$9 = "Highest";
var Extreme_2$9 = "Extreme";
var Private_2$9 = "Private";
var Lite$9 = "Lite";
var Bitrate$9 = "Bitrate";
var hours$9 = "Ore";
var Expires$9 = "Scadenza";
var Check$9 = "Controllare";
var Saving$9 = "Salvataggio";
var Now$9 = "Ora";
var Beep$9 = "Segnale di avvertimento";
var Unpair$9 = "Scollegare";
var Detected$9 = "Rilevato";
var Promotion$9 = "Promozione";
var Notice$9 = "Aggiornamenti";
var Explore$9 = "Esplorare";
var Deactivate$9 = "Disattivare";
var Compliance$9 = "Conformità";
var Manufacturing$9 = "Produzione";
var Emergency$9 = "Emergenza";
var Security$9 = "Sicurezza";
var Important$9 = "Importante";
var or$9 = "o";
var Subscribe$9 = "Iscriviti";
var Vehicle$9 = "veicolo";
var it = {
	Dashboard: Dashboard$9,
	"Payment & Subscriptions": "Pagamento e abbonamenti",
	"Fleet Management": "Gestione Flotta",
	"Available to master": "Disponibile all'amministratore",
	"Available to Fleet_": "Disponibile agli utenti del piano Fleet",
	Account: Account$9,
	"Log out": "Esci",
	"© 2019 Pittasoft_": "© 2019 Pittasoft Co. Ltd",
	"Privacy policy": "Informativa sulla privacy",
	"Terms of service": "Condizioni per l'utilizzo del Servizio",
	Help: Help$9,
	"App store": "App store",
	"Google Play": "Google Play",
	Mac: Mac$9,
	Windows: Windows$9,
	"Free Plan": "Free Plan",
	"Basic Plan": "Basic Plan",
	"Smart Plan": "Smart Plan",
	Admin: Admin$9,
	Driver: Driver$9,
	"Period : December 3, 2024 ~ May 31, 2025": "Periodo: 3 dicembre 2024 ~ 31 maggio 2025",
	Cameras: Cameras$9,
	"n of n": "{{a}} di {{b}}",
	Manage: Manage$9,
	"Upgrade Plan": "Aggiorna il piano",
	"Add more cameras_": "Aggiungi più telecamere, gestisci la tua flotta e molto altro ancora.",
	"Usage statistics": "Statistiche di utilizzo",
	"All cameras": "Tutte le telecamere",
	Clear: Clear$9,
	Show: Show$9,
	"Live views": "Vista live da remoto",
	"nh:nm:ns": "{{a}}h:{{b}}m:{{c}}s",
	"Video plays and_": "Riproduzione e download video",
	"Space available": "Spazio disponibile.",
	GB: GB$9,
	"n%": "{{a}}%",
	"BlackVue app for_": "App BlackVue per iOS e Android",
	"BlackVue viewer for_": "BlackVue Viewer per Mac e Windows",
	"Welcome to fleet": "Benvenuti a Fleet",
	"A few things_": "Di seguito alcune delle funzionalità disponibili:",
	"You can watch_": "È possibile guardare i video dalle telecamere assegnate all'utente nell'applicazione BlackVue o nel viewer per desktop.",
	"If the master_deletes": "Se l'amministratore cancella il proprio account, anche l'account dell'utente verrà cancellato.",
	"If the masters_Fleet": "Se l'abbonamento al piano Fleet dell'amministratore scade, l'utente potrà comunque accedere al proprio account in modalità di sola lettura.",
	"You have to_": "È necessario registrare un account diverso per aggiungere una telecamera personale.",
	"The Payments &_": "Le sezioni Pagamenti e abbonamenti e Gestione della flotta sono disponibili solo all'amministratore.",
	"You can manage_": "È possibile gestire il gruppo flotta nella sezione",
	"_Fleet management": "Gestione Flotta",
	_section: _section$9,
	"The Payments_section-": "La sezione Pagamenti e abbonamenti è disponibile solo all'amministratore.",
	"Youre almost there": "Hai quasi finito",
	"Finish account setup": "Completa la configurazione dell'account",
	"Install and log_": "Installa e accedi all'app BlackVue o a Desktop Viewer",
	"Download on the_": "Scarica dall'App Store",
	"GET IT ON_": "SCARICA da Google Play",
	"Download for Mac": "Scarica per Mac",
	"Download for Windows": "Scarica per Windows",
	"Add your camera_": "Aggiungi la telecamera nell'app BlackVue o in Desktop Viewer",
	"Start managing your_": "Comincia a gestire la tua flotta e a seguire le statistiche sull'utilizzo qui",
	"Cancelled Fleet Plan_": "Piano Fleet annullato il {{date}}",
	"The new plan_": "Il nuovo piano entrerà in vigore alla fine del corrente ciclo di fatturazione.",
	"Profile photo": "Foto del profilo",
	Name: Name$9,
	"E-mail address": "Indirizzo e-mail",
	Password: Password$9,
	"Last changed_": "Ultima modifica {{a}}",
	"Change password": "Modifica password",
	"Delete account": "Elimina account",
	Cancel: Cancel$9,
	"Current password": "Password attuale",
	"New password": "Nuova password",
	"Confirm new password": "Conferma nuova password",
	"Password changed": "Password modificata.",
	"Reason for deletion_": "Motivo della cancellazione (facoltativo)",
	"Account password": "Password dell'account",
	Members: Members$9,
	Groups: Groups$9,
	"+ Invite member": "+ Invita un membro",
	"Name, Email": "Nome, e-mail",
	Role: Role$9,
	Group: Group$9,
	"Date invited": "Data di invito",
	Status: Status$9,
	"Group n": "Gruppo {{a}}",
	nPM: nPM$9,
	nAM: nAM$9,
	Newest: Newest$9,
	Oldest: Oldest$9,
	"Name, email or_": "Nome, e-mail o gruppo",
	Accepted: Accepted$9,
	Pending: Pending$9,
	Expired: Expired$9,
	All: All$9,
	"No results": "Nessun risultato.",
	"Try different keywords": "Prova parole chiave diverse",
	"Try changing or_": "Prova a modificare o eliminare i filtri",
	"Remove all filters": "Rimuovi tutti i filtri",
	"Invite member": "Invita un membro",
	"Send invite": "Invia invito",
	"You have reached_": "Hai raggiunto il limite di 10 amministratori secondari. Puoi continuare a invitare utenti.",
	Delete_: Delete_$9,
	"Are you sure_delete": "Eliminare questo membro e il suo account?",
	Delete: Delete$9,
	Rename: Rename$9,
	"No submaster yet": "Nessun amministratore secondario",
	"You can add_": "È possibile aggiungere un amministratore secondario per gruppo",
	"No cameras yet": "Nessuna telecamera",
	"Add cameras first_": "Aggiungere prima le telecamere, quindi assegnare gli utenti",
	"Name or email": "Nome o e-mail",
	"Add submaster": "Aggiungi amministratore secondario",
	Add: Add$9,
	"Add camera": "Aggiungi telecamera",
	"n of n selected": "{{a}} di {{b}} selezionati",
	"No cameras available": "Non ci sono telecamere disponibili",
	"Most likely reasons_": "Possibili cause:",
	"All cameras were_": "tutte le telecamere disponibili sono state aggiunte ad altri gruppi.",
	"You can remove_": "È possibile rimuovere telecamere dagli altri gruppi e aggiungerle a questo gruppo.",
	"No cameras were_": "Non è stata aggiunta alcuna telecamera al tuo account.",
	"You can add_cameras": "È possibile aggiungere telecamere nell'app BlackVue o in Desktop Viewer.",
	OK: OK$9,
	"Rename group": "Rinomina gruppo",
	"Are you sure_group": "Eliminare questo gruppo?",
	"Edit Mobile app_": "Modifica le autorizzazioni dell'app mobile/di Desktop Viewer",
	Remove: Remove$9,
	"n of n users": "{{a}} di {{b}} utenti",
	"Youve reached the_": "È stato raggiunto il limite massimo di utenti per telecamera",
	"Remove user": "Rimuovi utente",
	"Add user": "Aggiungi utente",
	"+ Add group": "+ Aggiungi gruppo",
	"Add group": "Aggiungi gruppo",
	"Group or submaster": "Gruppo o amministratore secondario",
	"+ Add": "+ Aggiungi",
	"of max selected": "{{a}} di max {{b}} selezionati",
	"Mobile app/desktop_": "Autorizzazioni dell'app mobile/di Desktop Viewer",
	Files: Files$9,
	Features: Features$9,
	Settings: Settings$9,
	Upload: Upload$9,
	"Download and Playback_Cloud": "Scarica e riproduci dalla memoria cloud",
	"Download and Playback_SD": "Scarica e riproduci dalla scheda SD",
	"Live view": "Live View",
	"Geo Fencing": "Recinto virtuale",
	"Drive Reports": "Report di guida",
	"Firmware Settings": "Impostazioni firmware",
	"Push Notifications": "Notifiche Push",
	"Event Auto Upload": "Caricamento automatico evento live",
	Privacy: Privacy$9,
	Done: Done$9,
	"Payment method": "Metodo di pagamento",
	"Change payment method": "Cambia metodo di pagamento",
	Subscription: Subscription$9,
	"Space used": "Spazio utilizzato",
	"Next billing_": "Prossima fattura {{a}} {{b}}",
	"You manage_available": "Stai gestendo {{a}} di {{b}} disponibili con il tuo piano",
	Submasters: Submasters$9,
	Users: Users$9,
	Change: Change$9,
	"No transactions yet_": "Sei abbonato al piano gratuito Free Plan. Non sono presenti transazioni",
	"No transactions to_": "Nessuna transazione da visualizzare.<br/>Se stai cercando la cronologia delle transazioni di altre piattaforme (ad es. iOS, Android, PayPal), la puoi trovare nella pagina di abbonamento della tua piattaforma.",
	"of nGB_": "{{a}} di {{b}}GB ({{c}}%)",
	"Smart Plan users_": "Gli utilizzatori del Piano Smart possono cambiare il piano di abbonamento o il numero di telecamere tramite l'app BlackVue per dispositivi mobili",
	"Transaction history": "Storico transazioni",
	"Date": "Data",
	"Amount, USD": "Importo, USD",
	Method: Method$9,
	Details: Details$9,
	"iOS in-app_": "iOS in-app purchase/Android in-app purchase",
	"Change the number_": "Modifica il numero di telecamere",
	"You manage_cameras": "You manage {{a}} cameras of {{b}} available on your plan",
	"Extra cameras": "Telecamere addizionali",
	"Total due_": "Totale dovuto",
	"available on your_": "di {{a}} disponibili con il tuo piano",
	"Cancel Fleet Plan": "Annulla Fleet Plan",
	"This will cancel_": "In questo modo, l'abbonamento al Piano Fleet verrà cancellato. Al termine del ciclo di fatturazione in corso, verrà effettuato il downgrade al piano gratuito.",
	"Reason for cancellation_": "Motivo della cancellazione (facoltativo)",
	"Not now": "Non adesso",
	Confirm: Confirm$9,
	"Cardholder name": "Nome titolare",
	"Card name": "Nome carta",
	"MM/YY": "MM/AA",
	Address: Address$9,
	Country: Country$9,
	State: State$9,
	ZIP: ZIP$9,
	Pricing: Pricing$9,
	"You are subscribed_": "Sei abbonato al piano gratuito.",
	"With Alert Push_": "Con notifiche push, vista live da remoto limitata e memoria cloud.",
	Free: Free$9,
	Smart: Smart$9,
	Fleet: Fleet$9,
	"Get started for_": "Comincia gratuitamente, non è necessaria la carta di credito. \n Comprende notifiche push, vista live da remoto limitata e memoria cloud.",
	Subscrubed: Subscrubed$9,
	"Features included:": "Funzionalità incluse:",
	"Get unlimited Remote_": "Ottieni vista live da remoto e riproduzione cloud senza limiti e gestisci fino a {{a}} telecamere.",
	"BlackVue Fleet Tracking_": "Funzionalità esclusive BlackVue Fleet Tracking per utenti esperti e imprese (telecamere e utenti multipli, recinto virtuale ecc.)",
	"Try 1 Month Free": "Prova gratuitamente per 1 mese",
	"Log in": "Accesso",
	"Remember me": "Ricordami",
	"Forgot password?": "Hai dimenticato la password?",
	"Reset password": "Reimpostazione password",
	"Enter email address_": "Inserisci l'indirizzo e-mail utilizzato durante la registrazione e \n ti invieremo un link per reimpostare la password.",
	"Send reset password_": "Invio e-mail per il ripristino della password",
	"Back to login": "Torna all'accesso",
	"Check your email": "Controlla la posta in arrivo",
	"Weve sent an_": "Abbiamo inviato un'e-mail a {{a}} con un link per confermare\n il tuo indirizzo e-mail.",
	"Resend email": "Reinvia l'e-mail",
	January: January$9,
	February: February$9,
	March: March$9,
	April: April$9,
	May: May$9,
	June: June$9,
	July: July$9,
	August: August$9,
	September: September$9,
	October: October$9,
	November: November$9,
	December: December$9,
	"Sign up": "Crea account",
	"First name": "Nome",
	"Last name": "Cognome",
	"Create a password": "Crea una password",
	"5 or more_": "5 o più caratteri",
	"Sign up and_": "Registrati e continua",
	"I agree to_": "Accetto %@, %@, %@ e %@.",
	"Subscribe to newsletter": "Abbonamento alla newsletter",
	"1 month free trial_": "Prova gratuita di un mese",
	"Dont have an_": "Non hai un account?",
	"Thank you for_": "Grazie per esserti registrato/a a BlackVue Cloud. Conferma il tuo indirizzo e-mail.",
	"Confirm email": "Conferma e-mail",
	"If you didnt_": "Se non ti sei registrato per questo account puoi ignorare questa e-mail.",
	Blackvuecloud_: Blackvuecloud_$9,
	"invited you to_": "{{a}} ti ha invitato a unirti alla sua flotta come amministratore secondario.",
	"Accept invitation": "Accetta l'invito",
	"Invite expires on_": "Invito scaduto il gg mm aa.",
	"Your Fleet Management_": "Il tuo account di Gestione Flotta registrato con {{a}} è stato eliminato da %@.",
	"If you believe_": "Se ritieni che si tratti di un errore, contatta il nostro servizio di assistenza clienti: cs@blackvue.com.",
	Support: Support$9,
	"Help center": "Centro assistenza",
	Community: Community$9,
	"Getting started": "Operazioni preliminari",
	FAQ: FAQ$9,
	Developers: Developers$9,
	"Cloud API": "Cloud API",
	"Fleet SDK": "Fleet SDK",
	"Follow us": "Follow us",
	Facebook: Facebook$9,
	Twitter: Twitter$9,
	Instagram: Instagram$9,
	Youtube: Youtube$9,
	Linkedin: Linkedin$9,
	"BlackVue apps": "BlackVue apps",
	"Camera registraiton": "Registrazione telecamera",
	"Two-way voice_": "Comunicazione vocale bidirezionale",
	"Live GPS": "GPS live",
	"Event live auto_": "Caricamento automatico evento live",
	"Event file auto_": "Caricamento automatico file di evento",
	"Compatible with_": "Compatibile con i modelli DR650GW, DR650S",
	"Not compatible with_": "Non compatibile con i modelli DR650GW, DR650S",
	"More cameras": "Più telecamere",
	"More users": "More users",
	"Roles and permissions": "Roles and permissions",
	"More Cloud Storage": "Più spazio di archiviazione su cloud",
	"Multi Live view_": "Multi Live View (Web)",
	"Longer GPS Tracking": "Longer GPS Tracking",
	"Geo Fence setup_": "Geo Fence setup (PC viewer) and alerts (PC viewer and app)",
	"Changes saved": "Modifiche salvate",
	"Group added": "Gruppo aggiunto",
	"Member added": "Membro aggiunto",
	"Group deleted": "Gruppo eliminato",
	"Member deleted": "Membro eliminato",
	"Group renamed": "Gruppo rinominato",
	"Submaster added": "Amministratore secondario aggiunto",
	"Camera added": "Telecamera aggiunta",
	"User added": "Utente aggiunto",
	"Users added": "Utenti aggiunti",
	Downloads: Downloads$9,
	"The BlackVue App_": "The BlackVue App and Viewer let you use your BlackVue camera to its full potential. Whether on mobile or on home computer, BlackVue gives you the tools to fully enjoy your dashcam's functions.",
	"Compatible with all_": "Compatible with all Wi-Fi enabled BlackVue models.",
	"Supports all BlackVue_": "Supports all BlackVue models to date.",
	"confirm new password": "Conferma nuova password",
	"Your password is_": "Password errata",
	"Confirm password does_": "La password non corrisponde",
	"Please enter_email": "Inserire un indirizzo e-mail valido.",
	"Please enter_password": "Password errata",
	"Internal server error_": "Errore interno del server, riprova.",
	"New password is_": "La password attuale deve contenere almeno un carattere differente",
	"It should be_": "La password deve contenere almeno 5 caratteri",
	"Invalid permission": "Autorizzazione non valida.",
	"Input data isnt_": "Dati di input non disponibili.",
	Unauthorized: Unauthorized$9,
	"Already have subsciption": "Abbonamento già attivo",
	"Already uses": "Già in uso",
	"Already logged in": "Accesso già effettuato",
	"Already sent e-mail": "E-mail già inviata.",
	"Please wait": "Attendere.",
	"E-mail is not_": "E-mail non ancora verificata.",
	"Update your subscription_": "Aggiorna l'abbonamento",
	"Account was deleted": "Account eliminato.",
	"5 ~ 30_": "5 ~ 30 characters",
	"It has exceeded_": "Ha superato il limite massimo di 9 amministratori.",
	"Billing information": "Informazioni di fatturazione",
	"Please enter cardName": "Immettere il nome della carta",
	"Please enter_card": "Immettere un numero di carta valido",
	"Please enter address": "Immettere l'indirizzo",
	"Please select country": "Selezionare un paese",
	"Please enter city": "Immettere la città",
	none: none$9,
	"Due today": "In scadenza oggi",
	"Today after 1_": "Oggi, dopo un mese di prova",
	"An error occurred_": "Si è verificato un errore durante la modifica della password. Riprova.",
	"Your account is_": "Il tuo account è ora attivo",
	"You can now_": "Puoi accedere al tuo account con l'indirizzo e-mail utilizzato durante la registrazione.",
	Email: Email$9,
	"Don’t have an account?": "Non hai un account?",
	"Already have an account?": "Hai già un account?",
	"Cloud service": "Cloud service",
	"for your BlackVue": "for your BlackVue",
	"See what your_": "See what your camera sees remotely.",
	"Receive impact alert_": "Receive Impact alert push notifications.",
	"Save footage to_": "Save footage to the cloud and do much more...",
	"Free plan included_": "Free plan included · Easy setup · Cancel anytime",
	"Taking advantage of_": "Taking advantage of a mobile or car-embedded Internet connection and a BlackVue camera, BlackVue Cloud connects you to your car from anywhere, anytime. Using the BlackVue App on your smartphone or tablet, you see in real time where your car is located and what is happening around it.",
	"Get notifications to_": "Get notifications to your phone when your parked car is hit. Check remotely what is happening around your car.",
	"Monitor your commercial_": "Monitor your commercial vehicles on a map in real time. Talk to your drivers anytime through the BlackVue App or Viewer.",
	"With BlackVue Fleet_": "With BlackVue Fleet Tracking, track in real time up to 100 vehicles from the palm of your hand or with the dedicated BlackVue Viewer.",
	"Get started now_": "Get started now with a Free plan. For unlimited video playback or Remote Live View, upgrade to Lite or Smart plan from the BlackVue App. <br/>Business and power users can unlock the power of the Fleet plan exclusively through this website.",
	"Remote Video Playback_": "Remote Video Playback and Download",
	"Compatible with DR650GW_": "Compatible with DR650GW, DR650S models",
	"Unlimited remote video_": "Unlimited remote video playback and download",
	"Longer cloud storage_": "Longer cloud storage file expiration period",
	"Longer storage period_live": "Longer storage period for Event live auto upload",
	"Longer storage period_file": "Longer storage period for Event file auto upload",
	"Goefence setup (PC_": "Geo-fence setup (PC viewer) and alerts (Windows viewer and app)",
	"App Store": "App Store",
	"Send reset password email": "Invio e-mail per il ripristino della password",
	Customers: Customers$9,
	Home: Home$9,
	"Pick a plan": "Pick a plan",
	"No customers yet": "No customers yet",
	"Customers will_": "Customers will show up here as they become available",
	"Add customer": "Add customer",
	"Report(PDF)": "Report(PDF)",
	"Subscription Period": "Subscription Period",
	Plan: Plan$9,
	New: New$9,
	Unsubscribed: Unsubscribed$9,
	"Subscription ends soon": "Subscription ends soon",
	Edit: Edit$9,
	"1 month trial": "1 month trial",
	"Edit customer details": "Edit customer details",
	"Customer name": "Customer name",
	"of 999 available_": "of 999 available on Fleet Plan",
	"Subscription starts": "Subscription starts",
	"Subscription period": "Subscription period",
	month: month$9,
	months: months$9,
	"Cloud storage": "Cloud Storage",
	"Subscription plan": "Tipo di abbonamento",
	"Check email address": "Check email address",
	"Add customer details": "Add customer details",
	Continue: Continue$9,
	Back: Back$9,
	"An error occured": "An error occured",
	"Customer added": "Customer added",
	"Last changed": "Last changed",
	"Company name": "Company name",
	"Company address": "Company address",
	"Alert Push Notifications": "Alert Push Notifications",
	"Receive notifications on_": "Receive notifications on your phone when preset Events occur. Great in combination with BlackVue’s Parking Mode.",
	"Remote Live View": "Visualizzazione dal vivo remota",
	"Remotely monitor your_": "Remotely monitor your car in real time from anywhere, anytime.",
	"Video Backup/Auto Upload": "Video Backup/Auto Upload",
	"Back up videos_": "Back up videos to your phone or Cloud storage.",
	"Two-way Voice Communication": "Two-way Voice Communication",
	"Talk with people_": "Talk with people in the car from your smartphone. The driver can speak while keeping hands on the wheel.",
	"View your car’s_": "View your car’s location and speed on a map. With BlackVue Fleet Tracking, access 90-days’ worth of GPS data.",
	"Remote Video Playback": "Remote Video Playback",
	"Play videos stored_": "Play videos stored in the Cloud or in your dashcam anytime on your smartphone or tablet.",
	"Event Live Auto Upload": "Event Live Auto Upload",
	"Save a video stream_": "Save a video stream in real time to the Cloud. Protect yourself from break-ins and theft.",
	"Event File Auto Upload": "Event File Auto Upload",
	"Save Event videos_": "Save Event videos to the Cloud—including seconds before trigger—after they happen.",
	"Firmware-Over-the-Air (FOTA)": "Firmware-Over-the-Air (FOTA)",
	"Upgrade your dashcam’s": "Update your dashcam over the cloud",
	"When an Event_": "When an Event is created (Impact detected or manually triggered), Event Live Auto-upload lets your Cloud-compatible BlackVue save a live video stream from a camera of your choice (front or rear/interior) to the Cloud server",
	"Event File Auto-upload_": "Event File Auto-upload lets your dashcam automatically upload low-resolution versions of Event files to the Cloud.",
	Master: Master$9,
	"per Camera": "per Camera",
	"Event live auto upload_": "Event live auto upload compatible with all cloud cameras",
	"Drive report": "Drive report",
	"USA/Canada Toll Free": "USA/Canada Toll Free",
	"Monday–Saturday_": "Monday to Friday 8am-7pm / Saturday 9am-6pm (PST).",
	"Please agree to_": "You must accept Terms of Service",
	"Mac or Windows PC": "Mac or Windows PC",
	Develop: Develop$9,
	"Sign out": "Sign out",
	"Referral code": "Codice di presentazione",
	"Total after 1 month trial": "Totale dopo un mese di prova",
	"Already Use Stripe Token": "Token Stripe già utilizzato",
	"Select period": "Seleziona un intervallo",
	"State/Region": "Stato/Regione (facoltativo)",
	"ZIP/Postal": "Codice postale/CAP",
	"$0.00": "$0.00",
	"$11.99": "$11.99",
	"$24.99": "$24.99",
	$9: $9$9,
	$15: $15$9,
	$10: $10$9,
	"mo + for_": "/mo + {{a}} per extra camera",
	mo: mo$9,
	"This e-mail address_": "Questo indirizzo email ha già un account registrato.",
	"1 month": "1 mese",
	"Limit is reset daily": "Il limite viene azzerato ogni giorno",
	"Limit is reset monthly": "Il limite viene azzerato ogni mese",
	"Video plays and downloads": "Riproduzione e download video",
	"Your master": "Your owner",
	"Youre 1 step_": "Manca un solo passaggio al completamento dell'abbonamento al Piano Fleet",
	"Finish signing up": "Termina la registrazione",
	"Enter billing information": "Inserisci le informazioni di fatturazione",
	"Proceed to billing": "Procedi con la fatturazione",
	City: City$9,
	Charge: Charge$9,
	"User already invited_": "Utente già invitato dall'amministratore",
	"n% consumed": "{{a}}% utilizzato",
	"E-mail already exists": "L'e-mail esiste già",
	"Cancel your inapp_": "Annulla il tuo abbonamento in-app",
	"You have cancel_": "Devi annullare il tuo abbonamento in-app per effettuare l'aggiornamento al Piano Fleet: 1. Annulla il tuo abbonamento attuale nell'App Store o in Google Play Store. Al termine del ciclo di fatturazione in corso verrà effettuato il downgrade al piano gratuito. Tutti i tuoi dati resteranno intatti. 2. Accedi al tuo account su blackvuecloud.com e effettua l'aggiornamento al Piano Fleet.",
	"Edit permissions": "Modifica le autorizzazioni",
	"See permissions": "Visualizza le autorizzazioni",
	"Submaster removed": "Amministratore secondario rimosso",
	"Camera removed": "Telecamera rimossa",
	"User removed": "Utente rimosso",
	"Users removed": "Utenti rimossi",
	subscribe: subscribe$9,
	search: search$9,
	"permission can be_": "È possibile impostare le autorizzazioni dopo che l'amministratore secondario ha accettato l'invito.",
	"The confirmation link_": "Il link di conferma non è più valido",
	"Possible reasons:_": "Possibili cause:\n • Hai già confermato il tuo indirizzo e-mail\n • Il link è scaduto o è stato annullato",
	"Failed to register_": "Registrazione a BlackVue Cloud non riuscita",
	"There was an_": "Si è verificato un errore durante il processo di iscrizione. Se il problema persiste, prova ad iscriverti di nuovo a BlackVue Cloud. Se hai bisogno di ulteriore assistenza, contatta il nostro servizio di assistenza clienti:",
	"Upgrade to Fleet_": "Aggiornamento al Piano Fleet",
	"Subscription is Canceled": "L'abbonamento è stato annullato",
	"No members yet": "Nessun membro ancora",
	"Please enter_group name": "Inserisci un nome gruppo valido",
	"Group Name": "Nome gruppo",
	invalid_number: invalid_number$9,
	invalid_expiry_month: invalid_expiry_month$9,
	invalid_expiry_year: invalid_expiry_year$9,
	invalid_cvc: invalid_cvc$9,
	incorrect_number: incorrect_number$9,
	incomplete_number: incomplete_number$9,
	incomplete_cvc: incomplete_cvc$9,
	incomplete_expiry: incomplete_expiry$9,
	expired_card: expired_card$9,
	incorrect_cvc: incorrect_cvc$9,
	incorrect_zip: incorrect_zip$9,
	invalid_expiry_year_past: invalid_expiry_year_past$9,
	card_declined: card_declined$9,
	missing: missing$9,
	processing_error: processing_error$9,
	"no groups yet": "Nessun gruppo",
	"groups will show_": "I gruppi appariranno qui non appena saranno disponibili",
	"Fleet members will_": "I membri della flotta appariranno qui non appena saranno disponibili",
	"service provider": "Fornitore di servizi",
	Paypal: Paypal$9,
	iOS: iOS$9,
	Android: Android$9,
	"Enter email": "Please enter a email address",
	"Enter password": "Inserire password.",
	"Enter first name": "Inserire il nome",
	"Enter last name": "Inserire il cognome",
	"Enter the current_": "Inserire la password corrente",
	"Enter a new_": "Immettere una nuova password.",
	"There isnt an_": "Non c'è alcun account associato a questo indirizzo e-mail",
	"Fleet Plan": "Fleet Plan",
	Total: Total$9,
	"Password you entered_": "Password errata",
	"Incorrect email or_": "E-mail o password errata",
	"Available to Masters": "Disponibile al proprietario",
	"Blackvue url": "https://www.blackvue.com",
	"Information We Collect_": "Che informazioni raccogliamo e con quali finalità",
	And: And$9,
	"Terms of Location-Based_": "Condizioni per l'utilizzo del servizio localizzato.",
	"I agree to the_": "Accetto il",
	"Password Reset_": "Abbiamo inviato un'email a {{a}} con le istruzioni per la reimpostazione \n della password.",
	"You have already_": "Hai già ricevuto un invito, controlla la tua casella di posta elettronica.",
	"No data available_": "Nessun dato disponibile nella tabella",
	Camera: Camera$9,
	"You no longer_": "Non possiedi più l'autorizzazione per utilizzare il servizio di flotta.",
	"Please contact your_": "Contatta il tuo amministratore Fleet per risolvere il problema.",
	"You can still_": "Puoi ancora accedere alle",
	"account information": "informazioni sul tuo account.",
	"If the issue_": "Se il problema persiste e decidi di continuare a utilizzare il servizio BlackVue Cloud con l'indirizzo email registrato, dovrai cancellare il tuo account e iscriverti di nuovo.",
	"If the problem_": "Se il problema persiste, contatta il servizio di assistenza clienti:",
	"Web subscription only": "solo abbonamento Web",
	"AppStore url": "https://apps.apple.com/kr",
	"We no longer_": "Non gestiamo più i pagamenti tramite PayPal. È necessario aggiornare l'abbonamento per modificare il numero di telecamere: 1. Accedi al tuo account su paypal.com e annulla il tuo Piano Flotta attuale per modificare il numero di telecamere: 2. Accedi al tuo account su blackvuecloud.com e effettua l'aggiornamento al Piano Fleet.",
	Yes: Yes$9,
	No: No$9,
	"Serial number": "Numero di serie",
	"Cloud code": "Codice Cloud",
	"Terms & Policies": "Termini e condizioni",
	News: News$9,
	Notifications: Notifications$9,
	"km/h": "km/h",
	MPH: MPH$9,
	"Baidu Maps": "Baidu Maps (solo Cina)",
	"Google Maps": "Google Maps",
	Firmware: Firmware$9,
	Basic: Basic$9,
	"Time Zone": "Fuso orario",
	Resolution: Resolution$9,
	"Image quality": "Qualità immagine",
	Brightness: Brightness$9,
	Recording: Recording$9,
	"Normal recording": "Registrazione normale",
	"Voice recording": "Registr. vocale",
	"Video segment length": "Lunghezza segmento video",
	"Rear camera recording": "Registrazione telec. posteriore",
	Highest: Highest$9,
	High: High$9,
	Normal: Normal$9,
	"1 min": "1 min",
	"2 min": "2 min",
	"3 min": "3 min",
	Sensitivity: Sensitivity$9,
	"Motion detection": "Individuaz. movimento",
	"Speed alert": "Indicatore velocità",
	"Voice guidance": "Guida audio",
	"Power on": "Accensione",
	"Power off": "Spegnimento",
	"Starting normal recording": "Avvio registr. normale",
	"Changing recording mode": "Modifica modalita registrazione",
	"Speed alert (beep)": "Avviso velocità (segnale acustico)",
	"Cloud related": "Relativo a cloud",
	Volume: Volume$9,
	"User text overlay": "Sovrimpressione testo utente",
	"A-Z, a-z_": "A-Z, a-z, 0-9, :;’/\\+-_()$#\nmeno di 20 caratteri",
	"Wi-Fi auto turn off": "Spegnimento auto Wi-Fi",
	"Login credentials": "Credenziali accesso",
	"Manual recording": "Registrazione manuale",
	"By sharing your_": "La condivisione della vista live permette ad altri utenti di vivere indirettamente il piacere e l'eccitazione di guidare in tutto il mondo.",
	"However, as persona_": "Dato che possono essere trasmessi video di natura privata, è importante decidere con cura quale informazione condividere.",
	"Please enter_email_2": "Si prega di inserire un indirizzo email valido. L'e -mail con alcuni personaggi speciali potrebbe non essere consentito. ex) +, &",
	"Password is incorrect": "Password errata.",
	"This camera is already_": "Questa telecamera è già stata registrata per un account BlackVue.",
	"Camera name must_": "Il nome della telecamera deve contenere da 5 a 32 caratteri.",
	"Failed to save_": "Impostazioni telecam. non salvate.",
	"Unallowed character detected": "Ci sono caratteri non consentiti.",
	"File(s) queued for_": "File in coda per il caricamento su cloud.",
	"Exceeded video play_": "Limite superato riprod. e scaricam. video.",
	"Playback Failed": "Riproduzione non riuscita.",
	"Exceeded your Live_": "Limite tempo vista live superato.",
	"The camera is not_": "La telecamera non è collegata al server.",
	"Please check the connection_": "Verificare lo stato di connessione della telecamera selezionata.",
	Close: Close$9,
	"Map": "Mappa",
	Cloud: Cloud$9,
	Public: Public$9,
	"Flip horizontally": "Capovolgere orizzontalmente",
	Front: Front$9,
	Rear: Rear$9,
	Play: Play$9,
	Stop: Stop$9,
	Pause: Pause$9,
	"Next frame": "Fotogramma succ.",
	"Previous frame": "Fotogramma prec.",
	"Proximity sensor": "Sensore di prossimità",
	"Voice recording on/off": "Registr. vocale attiva/disattiva",
	"The BlackVue dashcam_": "La dash cam BlackVue non è compatibile con le reti wireless da 5 GHz.",
	Time: Time$9,
	"Daylight saving time": "Ora legale",
	System: System$9,
	"Incorrect camera serial_": "Numero di serie della telecamera errato.",
	"Lock event files": "Blocca file evento",
	"Overwrite locked event_": "Sovrascrivere file evento bloccati quando lo spazio è esaurito.",
	"Camera settings saved_": "Impostazioni telecamera salvate.",
	"Front camera": "Telecamera anteriore",
	"Rear camera": "Telecamera posteriore",
	Event: Event$9,
	Parking: Parking$9,
	"GPS tracking": "Monitoraggio GPS",
	"G-force detected": "G-force rilevato",
	"Impact detected in_": "Rilevamento impatto modalità parcheggio",
	"Scheduled reboot": "Riavvio programmato",
	"Recording status": "Stato della registrazione",
	"Rear security": "Sicurezza posteriore",
	"Time lapse": "Tempo trascorso",
	"Sync with GPS_": "Sincronizza con orario GPS",
	"Overwrite locked event3_": "Sovrascrivere i file bloccati con nuovi file di evento quando lo spazio di archiviazione è pieno",
	"Video codec": "Video Codec",
	"Tracking logs": "Traccia registri",
	"Geofence alerts": "Allarme geografico-di attraversamento della recinzione",
	Color: Color$9,
	Exit: Exit$9,
	Save: Save$9,
	Impact: Impact$9,
	Unlimited: Unlimited$9,
	"Parking mode recording": "Registrazione in modalità parcheggio",
	"Battery protection": "Protezione della batteria",
	"Cut-off timer": "Timer di interruzione",
	"Low voltage cut-off": "Interruzione in caso di bassa tensione",
	"Rear camera orientation": "Orientamento videocamera posteriore",
	Default: Default$9,
	"Rotate video 180°": "Ruota video di 180°",
	"Mirror video": "Video specchietto",
	"Wi-Fi band": "Banda Wi-Fi",
	"Driving report": "Report di guida",
	"Unsupported video codec_": "Codec video non supportato (H.265).",
	"Rear camera recording_": "Registrazione telecamera posteriore in modalità parcheggio",
	"Front and rear_": "La telecamera anteriore e quella posteriore registrano contemporaneamente",
	"Rear camera stops_": "La telecamera posteriore smette di registrare 5 minuti dopo che è entrata in modalità parcheggio. La registrazione riprende tornando alla modalità normale.",
	"Remote firmware update": "Aggiornamento firmware remoto",
	"Firmware is up-to-date": "Firmware aggiornato",
	"New firmware available": "Nuovo firmware disponibile.",
	Version: Version$9,
	"Release date": "Data rilascio",
	Language: Language$9,
	"File size": "Dimensioni file",
	"What’s new": "Novità",
	"Updating may take_": "L’aggiornamento può richiedere alcuni minuti.",
	"The update process_": "La procedura di aggiornamento non può essere annullata.",
	"Do not disconnect the_": "Non scollegare il cavo di alimentazione fino al riavvio della normale registrazione.",
	"Downloading firmware": "Download firmware in corso",
	"Once download is_": "Una volta completato il download, BlackVue si riattiverà automaticamente per applicare il nuovo firmware.",
	"If not allowed_": "Se ciò non è possibile, la posizione e la velocità del proprio veicolo non saranno accessibili attraverso il Cloud.",
	"Unable to initiate update because_": "Impossibile avviare l'aggiornamento, poiché la dash cam è collegata ad un dispositivo tramite connessione Wi-Fi.",
	Notification: Notification$9,
	Multiple: Multiple$9,
	Range: Range$9,
	"HDR night vision": "Visione notturna HDR",
	Download: Download$9,
	"G-sensor": "G-Sensor",
	Manual: Manual$9,
	"Low voltage warning": "Avviso di bassa tensione",
	Satellite: Satellite$9,
	"Data usage": "Utilizzo dei dati",
	"Select video download quality": "Seleziona la qualità di download del video",
	"Quick play file_": "File di riproduzione rapida (bassa risoluzione)",
	"Original file": "File originale",
	"You do not have permission_": "Non hai i permessi per eseguire questa funzione. Contatta il proprietario dell'account principale.",
	"Interior camera recording_": "Registrazione telecamera Interna in modalità parcheggio",
	"Interior security": "Sicurezza interni",
	"Interior camera rotation": "Rotazione telecamera interna",
	"Multi View": "Vista multipla",
	Tutorials: Tutorials$9,
	"Upgrade now": "Aggiorna adesso",
	"Members will show_": "I membri appariranno qui non appena saranno disponibili",
	"Are you sure_delete members": "Eliminare in modo permanente i membri?",
	"Some members may_": "Alcuni membri potrebbero non essere visibili a causa dei filtri applicati.",
	"Invited on_": "invitato il {{Invited Date}} da te. Proprietario",
	Filter: Filter$9,
	"Date created": "Data di creazione",
	"No admin yet": "Nessun amministratore",
	"You can add_admin": "È possibile aggiungere un amministratore per gruppo",
	"Collapse all": "Comprimi tutto",
	"Expand all": "Espandi tutto",
	"Download and playback_cloud": "Scarica e riproduci dall'archivio su cloud",
	"Are you sure_2": "Eliminare il gruppo {Group name}?",
	"Are you sure_groups": "Eliminare i gruppi?",
	"Add cameras first_drivers": "Aggiungere prima le telecamere, quindi assegnare gli autisti",
	"Flip vertically": "Capovolgere verticalmente",
	Sun: Sun$9,
	Mon: Mon$9,
	Tue: Tue$9,
	Wed: Wed$9,
	Thu: Thu$9,
	Fri: Fri$9,
	Sat: Sat$9,
	Dates: Dates$9,
	Routes: Routes$9,
	Opacity: Opacity$9,
	"Color and opacity": "Colore e opacità",
	"Geofences will show_": "I recinti virtuali appariranno qui non appena saranno disponibili",
	"Start drawing a shape_": "Comincia a disegnare una sagoma sulla mappa",
	"Add geofence": "Aggiungi recinto virtuale",
	Entry: Entry$9,
	"Show all members": "Mostra tutti i membri",
	"Me and my_": "Io e il mio veicolo. Collegato",
	"add-on service for_": "Servizio add-on per Blackvue compatibile con il cloud",
	"Continue with Google": "Continua con Google",
	"An account with_": "Esiste già un account con questo indirizzo e-mail, ma non è stato verificato. Immettere la password esistente per BlackVue Cloud.",
	"Account does not_": "L'account non esiste. Oppure prova ad accedere con il tuo account Apple o Google.",
	"Continue with Apple": "Continua con Apple",
	"Get started": "Operazioni preliminari",
	"P subscription only": "solo abbonamento <b>{{a}}</b>",
	"+N USD for extra camera_": "+{{a}} USD for extra camera up to {{b}} Cameras",
	"Unlimited Live view": "Unlimited Live View",
	"Cameras per Account": "Cameras per Account",
	"Users per Account": "Users per Account",
	Owner: Owner$9,
	"Live View per Day": "Live View per Day",
	"Remote Video Playback_2": "Remote Video Playback and Download per Month",
	"N days": "{{a}} Days",
	"Video On Map": "Video On Map",
	Undetected: Undetected$9,
	Distracted: Distracted$9,
	Drowsy: Drowsy$9,
	"Whether on mobile_": "Whether on mobile or your computer, BlackVue gives you the tools to fully enjoy your dashcam’s functions. Download the latest <a1>firmware</a1>, <a2>mobile</a2> and <a3>desktop</a3> applications, or use <a4>BlackVue web app</a4> in your browser.",
	"Compatible with most_": "Compatible with most Wi-Fi BlackVue models. Cloud support for all Cloud-compatible dashcam models down to DR650GW Series with <b>Cloud Firmware</b>.",
	"Supports most recent BlackVue_": "Supports most recent BlackVue models and compatible with BlackVue Cloud.<br/>\nThis Viewer contains <b>two applications in one</b>: the SD Card Viewer lets you view recorded videos from your SD card and modify the settings of your BlackVue, as well as format the SD card; the <b>Cloud Viewer</b> lets you enjoy BlackVue Cloud.",
	"Contact us": "Contact us",
	"6 characters with": "6 caratteri con una combinazione di lettere, cifre e simboli",
	"Apps and more...": "Apps and more...",
	"Cameras will show_": "Cameras will show up here as they become available.",
	"Keep this page_": "Lascia questa pagina aperta durante la verifica del codice di conferma. Prova nella cartella di posta indesiderata se non trovi l'e-mail nella tua casella di posta in arrivo.",
	"n cameras": "{{n}} telecamere",
	"n slots": "{{n}} slot",
	"Calculate your Fleet_": "Calcola il costo del Piano Fleet",
	"Code you entered_": "Il codice digitato è errato/scaduto",
	Calling: Calling$9,
	Smoking: Smoking$9,
	"Smoking has been_": "È stato rilevato fumo durante la guida.",
	"Email is already_": "L'indirizzo e-mail esiste già.",
	"Serial number and_": "Il numero di serie e il codice cloud sono stampati sulla telecamera",
	"Allow GPS access": "Consentire l'accesso al GPS",
	"Used to access_": "Utilizzato per controllare la posizione e la velocità del veicolo. Dal menu delle impostazioni privacy della telecamera è possibile modificare in seguito le impostazioni GPS .",
	"Incorrect cloud code": "Codice cloud errato",
	"An account is_": "Esiste già un account registrato con questo indirizzo e-mail.",
	"Live event upload": "Caricamento evento live",
	Permissions: Permissions$9,
	"Assign in": "Assegna in",
	"Are you sure_camera": "Sei sicuro di voler eliminare questa videocamera?",
	"Uploading videos:": "Scaricare video:",
	"GPS location recording": "Registrazione posizione GPS",
	"When OFF, GPS_": "Se la funzione è disattivata, la posizione GPS non viene registrata o inviata al server cloud.",
	"As personal video_": "Dato che possono essere trasmessi video di natura privata, è importante decidere con cura quali informazioni condividere.",
	"Share location": "Condividi la posizione",
	Private: Private$9,
	"Used to access_2": "Utilizzato per controllare la posizione e la velocità del veicolo.",
	"Share live view": "Condividi il video della vista live",
	"Share live audio": "Condividi l'audio della vista live",
	"Share camera’s name": "Condividi il nome della dash cam",
	"Impact detection": "Rilevamento urto.",
	Entering: Entering$9,
	Exiting: Exiting$9,
	"Normal event recording": "Registrazione evento normale",
	"Harsh braking": "Frenata improvvisa",
	Acceleration: Acceleration$9,
	"Sharp turn": "Virata brusca",
	"Parking event recording": "Registrazione evento parcheggio",
	Passing: Passing$9,
	"Video source": "Sorgente video",
	Overspeed: Overspeed$9,
	"Are you sure_video": "Eliminare questo video?",
	"Add camera to_": "Aggiungi telecamera alla vista live",
	"No routes to_": "Nessun percorso da mostrare",
	"Start by adding_": "Iniziare aggiungendo le date.",
	"invite sent": "Invito inviato",
	Recipients: Recipients$9,
	Send: Send$9,
	"Routes selected_": "Percorsi selezionati: {{n}} di {{total}}",
	"Map service": "Servizio mappa",
	"Speed units": "Unità di misura velocità",
	Note: Note$9,
	"Release notes": "Note sulla versione",
	"The name must_": "Il nome deve avere una lunghezza compresa fra 1 e 30 caratteri.",
	Video: Video$9,
	Advanced: Advanced$9,
	"Firmware language": "Lingua del firmware",
	"Wi-Fi": "Wi-Fi",
	Voice: Voice$9,
	"Show date and_": "Mostra data e ora",
	"Show speed": "Mostra velocità",
	"Front camera rotation": "Rotazione telecamera anteriore",
	"Manual time settings": "Impostazioni orario manuali",
	"Recommended for better_": "Suggerito per una migliore compressione dei file e 4K UHD.",
	"For full compatibility_": "Per una piena compatibilità con i computer è i dispositivi mobili più vecchi.",
	"Up and down": "Dall'alto in basso",
	"Side to side": "Da lato a lato",
	"Front and back": "Davanti e dietro",
	"Detection region": "Area di rilevamento",
	"Hotspot 1": "Hotspot 1",
	"Hotspot 2": "Hotspot 2",
	"Hotspot 3": "Hotspot 3",
	"Enter/exit": "Ingresso/Uscita",
	"Event recording": "Registrazione evento",
	"Front security (Normal)": "Sicurezza frontale (Normale)",
	"Front security (Parking)": "Sicurezza frontale (Parcheggio)",
	"LTE (Parking)": "LTE (Parcheggio)",
	"Wi-Fi (Parking)": "Wi-Fi (Parcheggio)",
	"Turn on at startup": "Attivazione all'avvio",
	"Turn off after_": "Disattiva dopo 10 minuti di inattività",
	"Your firmware is_": "Il firmware è aggiornato",
	"Add admin": "Aggiungi ammin.",
	"Remove All/n": "Rimuovi tutto/{{a}}",
	"Are you sure_remove": "Rimuovere le telecamere da questo gruppo?",
	"This will cancel_2": "In questo modo, l'abbonamento al Piano Fleet verrà cancellato. Al termine del ciclo di fatturazione in corso verrà effettuato il downgrade al piano gratuito.",
	"You’ve reached_": "È stato raggiunto il limite massimo di conducenti per telecamera",
	"Are you sure_remove admin": "Rimuovere l'ammin. {{a}}{{b}} da questo gruppo?",
	"Fleet Plan · Owner": "Fleet Plan · Owner",
	"Manage cameras": "Gestisci telecamere",
	"Are you sure_delete zone": "Eliminare la zona \"{{zone}}\"?",
	"available on your_2": "{{a}}/{{b}} disponibili con il tuo piano",
	"The new plan_2": "Il nuovo piano entrerà in vigore alla fine del ciclo di fatturazione corrente ({{a}}).",
	"Canceled Fleet Plan_": "Piano Fleet annullato in data {{a}}",
	"Hard braking alert (beep)": "Notifica (bip) frenata brusca",
	"Hard acceleration alert (beep)": "Notifica (bip) accelerazione brusca",
	"Hard cornering alert (beep)": "Notifica (bip) curva veloce",
	"SSID must be_": "Il nome SSID deve essere lungo almeno 5 caratteri.",
	"Password must be_": "La password deve essere lunga almeno 8 caratteri.",
	"5 to 32 characters long": "Lunghezza compresa fra 5 e 32 caratteri",
	"8 to 32 characters long": "Lunghezza compresa fra 8 e 32 caratteri",
	"Longer storage period_event": "Maggiore durata di archiviazione per gli eventi live caricati",
	"Requires latest firmware_": "È necessaria l'ultima versione del firmware. Non compatibile con i modelli DR650S e DR650GW",
	"After Blackvue is_": "Le impostazioni verranno salvate quando BlackVue si connetterà al cloud.",
	"This is an_": "E-mail non registrata. Registrare un nuovo account?",
	"This feature is_": "Questa funzione è disponibile solamente per gli abbonati al Piano Fleet.",
	"Please return to_": "L'account non esiste. Oppure prova ad accedere con il tuo account Apple o Google.",
	"Adjusting the cut-off voltage_": "Adjusting the cut-off voltage to a lower setting may result in your dash cam draining more power from your battery.\nThis could result in warning messages of battery drain or affect other vehicle functions.\nPlease consult with your dealership before lowering the voltage.",
	"Your videos will_": "I video appariranno qui non appena saranno disponibili.",
	"You drove:_": "Hai guidato: {{distance}}, {{time}}",
	"Event count per_": "Conteggio eventi per ora di guida",
	"Are you sure_recipient": "Eliminare questo destinatario?",
	"(You)": "{{a}} (Tu)",
	"All events": "Tutti gli eventi",
	Days_: Days_$9,
	"Requires DMC 200_": "È necessaria una telecamera DMC 200",
	"A DMS and compatible_": "Per visualizzare questo rapporto, sono necessari un DMS e una dash cam compatibile.",
	"Notifications will show_": "Le notifiche appariranno qui non appena saranno disponibili.",
	"Try changing your_": "Prova a modificare la data o a rimuovere i filtri.",
	Mute: Mute$9,
	UnMute: UnMute$9,
	"Calling and smoking_": "Le telefonate e la presenza di fumo sono rilevati solo dal dispositivo DMC 200",
	"You need a DMS_": "Per vedere questo rapporto è necessario un DMS.",
	"Try BlackVue Cloud": "Prova subito BlackVue Cloud",
	"Individual driver looking_": "Sei un conducente in cerca di tranquillità? Sei un titolare di azienda che ha bisogno di una soluzione semplice per gestire la sicurezza e il monitoraggio dei suoi veicoli?",
	"Whoever you are_": "Qualunque ruolo tu svolga, qualsiasi siano le tue esigenze, c'è un piano cloud pensato per te!",
	"It is the account that_Driver": "È l'account che si è unito alla tua flotta su BlackVue Cloud dopo aver accettato un invito tramite e-mail da parte del proprietario o dell'amministratore. Un conducente può essere assegnato solo a una telecamera e può visualizzare unicamente il profilo del suo account, la vista live e i video riprodotti dalla sua telecamera.",
	"It is the account that_Admin": "È l'account che si è unito alla tua flotta su BlackVue Cloud dopo aver accettato un invito tramite e-mail da parte del proprietario. Gli account da amministratore possiedono le autorizzazioni che vengono assegnate loro dal proprietario.",
	"Video deleted": "Video eliminato",
	"Video delete_plural": "Video eliminati",
	"Driver removed from_": "Conducente rimosso dal gruppo",
	"Admin removed from_": "Ammin. rimosso dal gruppo",
	"Camera removed from_": "Telecamera rimossa dal gruppo",
	"Are you sure_videos": "Eliminare i(l) file selezionati(o)?",
	"You have to cancel_fleet": "È necessario annullare l'abbonamento in-app per modificare il numero di telecamere: \n \n 1. Annulla il tuo abbonamento attuale nell'App Store o nel Play Store di Google. Al termine del ciclo di fatturazione in corso verrà effettuato il downgrade al piano gratuito. Tutti i tuoi dati resteranno intatti.\n 2. Accedi al tuo account su blackvuecloud.com e effettua l'aggiornamento al Piano Fleet.",
	Discard: Discard$9,
	"Discard unsaved changes?": "Annullare le modifiche non salvate?",
	"Incorrect serial number": "Numero di serie errato",
	"An error occurred_again": "Si è verificato un errore. Riprovare.",
	"You are subscribed_free": "Sei abbonato al piano gratuito di BlackVue Cloud.",
	"When an event_": "Quando viene creato un evento (impatto rilevato o attivato manualmente), la funzione di caricamento di un evento live consente a BlackVue di salvare sul server cloud il flusso video live di una telecamera a scelta, insieme ai 5 secondi che precedono l'evento.",
	Report: Report$9,
	"How it work": "Come funziona",
	"Cloud Camera": "Telecamera cloud",
	"Internet Connection": "Connessione Internet",
	"BlackVue App/Viewer": "BlackVue App/Viewer",
	"All you need_": "Servono solamente",
	"Cloud-compatible BlackVue": "un BlackVue con compatibilità cloud",
	"and a cellular_": "e un piano dati cellulare. Alcuni modelli si collegano al servizio cloud tramite un hotspot Wi-Fi di terze parti. Altri offrono un lettore di schede nano SIM integrato o il supporto di un modulo di connessione aggiuntivo.",
	"Cloud features at_": "Le funzionalità cloud a portata di mano",
	"Enjoy peace of_": "Rilassati sapendo che BlackVue sorveglia tua auto. In caso di problemi, la dash cam ti invierà immediatamente un messaggio.",
	"Let your BlackVue_": "Lascia che BlackVue sorvegli la tua auto e ti avvisi in caso di incidenti. Nel momento in cui viene rilevato un impatto, BlackVue invia una notifica con un'istantanea al tuo telefono o al tuo browser web.",
	"Check on your_": "Sorveglia la tua auto ovunque ti trovi, grazie alla vista live remota. Puoi accedere al flusso video in tempo reale proveniente dalla tua dash cam con connessione cloud usando un browser web o il telefono e passare con semplicità dalla telecamera anteriore a quella posteriore o interna.",
	"Your BlackVue may_": "Se si verifica un incidente con omissione di soccorso, è molto probabile che BlackVue riesca a registrare delle prove video di importanza cruciale. Sfoglia tutti i video registrati dalla tua dash cam usando il cellulare o un browser web.",
	"Worried about eating_": "Hai paura di consumare troppi dati? La tecnologia per la gestione del flusso secondario di BlackVue ti consente di accedere a video in versioni ultraleggere, consentendoti di sfogliarli rapidamente e riprodurli senza buffer.",
	"Move files from_": "Sposta i file da BlackVue al cloud. Salva un video o selezionane più d'uno per caricarli in blocco. È possibile accedere ai video scaricati sul telefono con l'app BlackVue e condividerli dal menu Memoria interna.",
	"View your vehicle’s_": "Visualizza la posizione e la velocità di crociera del tuo veicolo in tempo reale. Per accedere ai dati del monitoraggio GPS degli ultimi 7 giorni, eseguire l'aggiornamento al Piano Smart.",
	"Get more with_": "Ottieni di più con il Piano Smart",
	"Unlimited Remote Live_": "Vista live da remoto illimitata",
	"Up to 3 dashcams_": "Fino a 3 dash cam gestite con un solo account",
	"Want to track_": "Desideri monitorare un'intera flotta di veicoli? Aggiornamento al Piano Fleet",
	"BlackVue Fleet Tracking_2": "BlackVue Fleet Tracking è una soluzione completa pensata per proteggere e monitorare la tua flotta. Le funzionalità e i costi sono scalabili e flessibili per andare incontro alle esigenze del tuo business.",
	"Stream real-time video_": "Streaming video in tempo reale illimitato. Velocità in bit: 600 kbps",
	"Up to 999 Dashcams": "Fino a 999 dash cam",
	"Register up to_": "Registra fino a 999 dash cam per account.",
	"15GB of Cloud_": "15 GB di memoria cloud",
	"15GB per additional_": "15 GB per dash cam aggiuntiva. Archiviazione illimitata per il caricamento automatico degli eventi.",
	"90-days GPS_": "Registri del monitoraggio GPS disponibili per 90 giorni",
	"High accuracy: 15_": "Precisione elevata: 15 secondi, video su mappa, esportazione dei dati semplice.",
	"Unique fleet management_": "Le funzionalità uniche per la gestione della flotta assicurano un valore e un risparmio maggiori",
	"Create geofences and_": "Crea recinto virtuale e ricevi notifiche in tempo reale sul telefono o sul computer.",
	"View at a_": "Visualizza a colpo d'occhio, in tabelle esportabili e stampabili, la distanza totale percorsa, il tempo di inattività, i superamenti dei limiti di velocità e molto altro.",
	"Multi Live View": "Vista live multipla",
	"Monitor up to_": "Monitora fino a 4 dash cam contemporaneamente",
	"Benefits for you": "Vantaggi",
	Individual: Individual$9,
	"Get notifications to_2": "Ricevi notifiche sul telefono se vengono rilevate collisioni alla tua auto mentre è parcheggiata. Verifica da remoto cosa succede alla tua auto. Disponibile in versione web e mobile, per Mac e Windows.",
	"Small business owner": "Proprietario di una piccola azienda",
	"Monitor your commercial_2": "Monitora i tuoi veicoli commerciali in tempo reale su una mappa. Parla ai tuoi conducenti quando vuoi usando un browser, l'app BlackVue per dispositivi mobili oppure il Viewer su Mac o Windows.",
	"Company with large_": "Azienda con una flotta di grandi dimensioni",
	"With BlackVue Fleet_2": "Con BlackVue Fleet Tracking puoi monitorare fino a 999 veicoli in tempo reale usando un browser, l'app BlackVue per dispositivi mobili oppure il Viewer su Mac o Windows.",
	Subscribed: Subscribed$9,
	"The video was_": "Il video è già stato caricato.",
	Geofence: Geofence$9,
	"500: Internal server error": "500: errore server interno",
	"404: Page not found": "404: pagina non trovata",
	"Check the web address_": "Verifica l’indirizzo internet o torna alla home page BlackVue Cloud",
	"home page": "Home page",
	"There isn’t an_": "Non c'è alcun account associato a questo indirizzo e-mail",
	"You can now_password": "Ora puoi accedere usando la tua nuova password",
	"Are you sure_remove admin2": "Eliminare in modo permanente l'amministratore?",
	"Admin deleted": "Ammin. eliminato",
	"Members deleted": "Membri eliminati",
	"Are you sure_groupName": "Eliminare il gruppo {{a}}?",
	"Requires latest firmware": "È necessaria l'ultima versione del firmware",
	"Selected file(s) moved_": "I file selezionati sono stati spostati",
	"Are you sure_remove driver2": "Rimuovere il conducente {{a}} ({{b}}) da questo gruppo?",
	"Invite sent": "Invito inviato",
	"Safe driving": "Guida sicura",
	"Reckless driving": "Guida incauta",
	"Inattentive driving": "Conducente disattento",
	"Driving events trend": "Andamento eventi guida",
	"Driving details": "Dettagli guida",
	Driving: Driving$9,
	Idling: Idling$9,
	Distance: Distance$9,
	"Parking sessions": "Sessioni parcheggio",
	"Parked time": "Parked time",
	"Idle stops": "Soste con inattività",
	"Idle time": "Tempo di inattività",
	"Impact events": "Impact Events",
	Parked: Parked$9,
	Speed: Speed$9,
	"Overspeeding alerts": "Allarmi velocità elevata",
	Highest_2: Highest_2$9,
	Average: Average$9,
	Geofences: Geofences$9,
	"Entries into a_": "Ingressi in una zona",
	"Exits from a_": "Uscite da una zona",
	"No data": "Dati non disponibili",
	"Hard acceleration": "Accelerazione",
	"Hard braking": "Frenata improvvisa",
	"Hard cornering": "Virata brusca",
	"The number within the brackets_": "Il numero fra parentesi indica il numero medio di eventi per ora di guida. Se hai guidato per meno di un'ora al giorno, viene mostrato il numero totale di eventi.",
	"Did you insert_": "La scheda SIM è stata inserita?",
	"Click here for_": "<a>Cliccare qui</a> per una guida più dettagliata.",
	"Back up all_": "<b>Esegui un backup delle registrazioni importanti prima di salvare queste impostazioni.</b><br/>Quando salvi le impostazioni, la scheda microSD viene reinizializzata e tutte le registrazioni vengono cancellate per garantire un funzionamento stabile.",
	"Not connected to_": "Non connesso al cloud. Alcune funzionalità sono state temporaneamente disabilitate.",
	"GPS Location recording off": "Registrazione posizione GPS disattivata",
	"n Videos deleted": "{{count}} video eliminati",
	Move: Move$9,
	"Driver Monitoring System (DMS) will_": "DMS (Driver Monitoring System) verrà lanciato presto.",
	"An error occured while_": "Si è verificato un errore durante la modifica del numero di telecamere. Riprova",
	"Reached the limit_": "È stato raggiunto il limite: {{a}}",
	"An invitation was_": "È già stato inviato un invito a questo indirizzo e-mail.",
	"To use the_": "Usare la funzione cloud. Inserire la scheda SIM.",
	"Last updated": "Ultimo aggiornamento: {{date}}",
	"Try changing your date": "Provare a modificare la data.",
	"No event data_": "Nessun dato evento raccolto per l'ora selezionata",
	"Please select another_": "Selezionare un giorno o un mese diversi per visualizzare un rapporto completo.",
	"more than 6_": "Sono richiesti più di 6 caratteri",
	"Sign up free": "Registrazione gratuita",
	"Cloud storage warning": "Avviso memoria cloud",
	"Cloud Storage Full": "Memoria cloud piena",
	"Cloud storage usage_100": "Memoria cloud usata: 100%. Liberare dello spazio di archiviazione per usare il caricamento degli eventi live",
	"Cloud storage usage_": "L'uso della memoria cloud ha raggiunto il <b>({{a}}%)</b>. \nOrganizza la tua memoria cloud.\nIl servizio di caricamento degli eventi live non sarà disponibile se la memoria cloud è piena.",
	"Are you sure_delete_zone": "Sicuri di voler eliminare?",
	"Search Name or email": "Cerca nome o e-mail",
	"Search group name": "Cerca nome gruppo",
	"Please note that_": "Nota: la registrazione video sarà messa in pausa per alcuni secondi mentre vengono applicate le nuove impostazioni.",
	"Currently connected Hotspot": "Hotspot attualmente connesso",
	"Enhanced night vision": "Visione notturna estesa",
	"To access the_": "Per accedere alla telecamera, aggiornare il piano di abbonamento.",
	"Restarting the Blackvue_": "Riavvio BlackVue per abilitare impostazioni.",
	"Hard acceleration event_": "Un evento di accelerazione brusca si verifica quando il tasso di incremento della velocità è superiore a {{kmh}} km/h ({{mph}} MPH) per secondo",
	"Hard braking event_": "Un evento di frenata brusca si verifica quando il tasso di diminuzione della velocità è superiore a {{kmh}} km/h ({{mph}} MPH) per \nsecondo",
	"Hard cornering event_": "Un evento di curva veloce si verifica quando viene rilevata una rotazione superiore a 60 gradi dopo 2 secondi di guida a più di \n{{kmh}} km/h ({{mph}} MPH)",
	"Changes you made_": "È possibile che le modifiche apportate non vengano salvate.",
	"My location": "La mia posizione",
	"Hotspot name (SSID)": "Nome hotspot (SSID)",
	Connected: Connected$9,
	"Camera will be rebooted_": "La telecamera verrà riavviata. Procedere ugualmente?",
	"Restarting the BlackVue_": "Riavvio BlackVue in corso. Attendere un momento.",
	"Failed to reboot_": "Riavvio telecamera non riuscito",
	"Bluetooth (Parking mode)": "BT (modalità parcheggio)",
	"Front and interior camera_": "La telecamera anteriore e quella interna registrano contemporaneamente.",
	"Interior camera stops_": "La telecamera interna interrompe la registrazione 5 minuti dopo essere entrata in modalità parcheggio. La registrazione riprende tornando alla modalità normale.",
	Individual_: Individual_$9,
	"Driver detection": "Rilevamento conducente",
	"During driving only": "Solo durante la guida",
	Always: Always$9,
	"Driver detection box": "Casella rilevamento conducente",
	"DMS camera rotation": "Rotazione telecamera DSM",
	Low: Low$9,
	Medium: Medium$9,
	High_2: High_2$9,
	"Reboot Camera": "Riavvia telecamera",
	"Latest events": "Eventi più recenti",
	"G-Sensor": "G-Sensor",
	"Playback speed": "Velocità di riproduzione",
	Flip: Flip$9,
	Previous: Previous$9,
	Next: Next$9,
	"Map type": "Tipo di mappa",
	"Zoom in": "Zoom avanti",
	"Zoom out": "Zoom indietro",
	"Move to Cloud": "Sposta su cloud",
	"Please recognize that_": "Nota: la registrazione video si interromperà per alcuni secondi per applicare le impostazioni.",
	"6 characters with_": "6 caratteri con una combinazione di lettere, cifre e simboli",
	"Updating firmware": "Aggiornamento firmware",
	"Overspeed event occurs_": "Un evento di eccesso di velocità si verifica quando la dash cam avvisa il conducente che ha superato il limite di velocità. Puoi modificarlo dal menu Firmware > Sistema > Volume",
	"Enter group name": "Inserisci nome gruppo",
	"Live view failed": "Vista live non riuscita.",
	"Parking mode enter_": "Entrata/Uscita modalità parcheggio",
	"Cloud connectivity": "Connettività cloud",
	Expand: Expand$9,
	Collapse: Collapse$9,
	"all day": "Tutto il giorno",
	"Driving style": "Stile di guida",
	"Driving impact": "Urto durante la guida",
	More: More$9,
	"No cameras to_": "Nessuna telecamera da aggiungere",
	"You have added_": "Hai aggiunto tutte le telecamere disponibili.",
	Multi: Multi$9,
	"Report video": "Segnala video",
	"Sexually explicit content": "Contenuti espliciti",
	"Graphic violence": "Contenuti violenti o inquietanti",
	"Hateful speech": "Odio e offese",
	"Harassment or bullying": "Molestie o bullismo",
	"Spam or advertisement": "Spam o pubblicità",
	"Infringement of my_": "Viola i miei diritti",
	"Other reason": "Altro",
	"Reason for reporting": "Motivo di segnalazione",
	"Reported videos will_": "I video segnalati saranno analizzati entro 72 ore. Il video non sarà mostrato sulla mappa degli eventi fino alla conferma che sia adatto alla pubblicazione sulla mappa eventi.",
	"Touch sensor": "Sensore tattile",
	"Motion and impact detection": "Rilevamento movimenti e impatti",
	"Settings have been changed": "Le impostazioni sono state modificate",
	"Start event recording (beep)": "Avvio della registrazione evento (bip)",
	"Scheduled reboots": "Riavvii programmati",
	Safe: Safe$9,
	Reckless: Reckless$9,
	Inattentive: Inattentive$9,
	"Highest(Extreme)": "Più alto (Estremo)",
	"Public cameras": "Telecamere pubbliche",
	List: List$9,
	Usage: Usage$9,
	"Video playbacks and downloads": "Riproduzione e download video",
	"of 100 times": "di 100 volte",
	"of 10 minutes": "di 10 minuti",
	Profile: Profile$9,
	"Search geofences": "Cerca recinti virtuali",
	"Export CSV": "Esporta CSV",
	"Exit fullscreen": "Esci da schermo intero",
	Fullscreen: Fullscreen$9,
	Upgrade: Upgrade$9,
	"Email address": "Indirizzo e-mail",
	"of Unlimited": "Illimitati",
	"No notifications yet": "Nessuna notifica ricevuta negli ultimi 7 giorni.",
	"No videos yet": "Ancora nessun video",
	Management: Management$9,
	Day: Day$9,
	Month: Month$9,
	"Welcome to the BlackVue_": "BlackVue Cloud Viewer ti dà il benvenuto",
	"You can access BlackVue_": "Puoi accedere sempre e dovunque a BlackVue Cloud da web.",
	"Start tour": "Inizia tour",
	"Map view": "Vista mappa",
	"Check the current_": "Controllare l'attuale posizione GPS e velocità delle tue telecamere e di quelle pubbliche.",
	"Camera’s features": "Funzionalità telecamera",
	"Take a look_": "Dai un'occhiata alle varie funzionalità relative al cloud offerte da BlackVue Camera.",
	"Visualize your vehicle’s_": "Visualizzazione del percorso di guida del veicolo nel tempo.",
	"Smart plan_": "Piano Smart: 90 giorni, Piano Flotta: 90 giorni",
	"Create geofences and2_": "Crea recinti virtuali e ricevi notifiche in tempo reale.",
	"Got it": "Fatto",
	"Manage Fleet members": "Gestione membri della flotta",
	"Invite fleet members_": "Invita i membri della flotta e dividili in gruppi.",
	"The moment the_": "Quando la telecamera rileva degli impatti, le relative notifiche saranno elencate qui.",
	"Geofence Setup (Web)_": "Configurazione recinto virtuale (web/desktop) e avvisi",
	"Original file play_": "File originale di riproduzione disponibile solo per download",
	"To get most_": "Per ottenere il massimo da BlackVue Cloud Viewer, la telecamera deve essere connessa al cloud. Scarica l'applicazione BlackVue e sperimenta subito la funzione di abbinamento Continuo, dall'aggiunta delle telecamere alla connessione al cloud.",
	"You haven’t driven_Today": "Oggi non hai ancora guidato la tua auto. Prova a guidare la tua auto con BlackVue per scoprire i report di guida.",
	"You haven’t driven_Month": "Questo mese non hai ancora guidato la tua auto. Prova a guidare la tua auto con BlackVue per scoprire i report di guida.",
	"Fleet Plan only_": "Disponibile solo per il Piano Flotta",
	"Overwrite locked event2_": "Sovrascrivere file evento bloccati quando lo spazio è esaurito",
	"DMS’s New firmware_": "Nuovo firmware DMS disponibile",
	"Highest speed_report": "<b>Velocità massima</b> \nValore massimo dei dati di velocità raccolti espressi in metri Conversione in Km/h e MPH\n<b>Velocità media</b> (Distanza/Ore di guida) *3600 velocità media. Es. (2622/1208 ) *3600 = 7814,907\nKm/h: Solo interi, \nil punto di arrotondamento del valore MPH è fino a 2 cifre dopo la parte intera",
	"Choose a cloud_": "Scegli un metodo di connessione al cloud",
	"You need an_": "L'accesso al cloud richiede una connessione a Internet. Scegli il dispositivo in uso per la connessione al cloud.",
	"BlackVue SIM card": "Scheda SIM BlackVue",
	"Support model_": "Modello supportato: DR750X-2CH LTE Plus (NA)",
	"3rd party SIM_": "Scheda SIM di terzi",
	"Support model_SIM": "Modello supportato: DR750X-2CH LTE Plus, DR750-2CH LTE, CM100 LTE",
	"Wi-fi hotspot": "Hotspot Wi-Fi",
	"Support model_Wifi": "Modello supportato: Tutti i modelli BlackVue",
	"How to connect_": "Connessione al cloud",
	"Download BlackVue application": "Scaricare l'applicazione BlackVue.",
	"*If you are_": "*Se si utilizzerà la scheda SIM BlackVue per la connessione al cloud, accedere a {{a}} {{b}}.",
	"Place your phone_": "Collocare il telefono entro la portata del Bluetooth della telecamera. Avviare la funzionalità di abbinamento Continuo entro {{a}}.",
	"Back to camera_": "Torna all'elenco delle telecamere",
	"Upgrade for more_": "Eseguire l'aggiornamento per usufruire di altre funzionalità.",
	"Upgrading the cloud_": "L'aggiornamento del piano cloud permette di usufruire di altre funzionalità e di gestire più telecamere. Procedere all'aggiornamento del piano cloud?",
	"Explore cloud plans": "Scopri i piani cloud",
	Later: Later$9,
	"Successfully subscribed": "Abbonamento riuscito!",
	"1GB data plan": "Piano dati da 1 GB",
	"First month free_": "Primo mese gratis, <a>poi 10,99 USD/mese</a>",
	"Next billing date": "Data prossima fattura",
	"Once SIM card_": "Dopo aver inserito la scheda SIM nella telecamera, sarà possibile usare immediatamente le funzionalità di BlackVue Cloud.",
	"Go to SIM_": "Vai alla gestione SIM",
	"Manage your BlackVue_": "Qui è possibile gestire la scheda SIM BlackVue.",
	"Recommended for BlackVue_": "Consigliato ai proprietari di SIM BlackVue",
	"Connect to cloud": "Connessione al cloud",
	"Enter BlackVue SIM_": "Inserire il numero ICCID della SIM BlackVue",
	"ICCID number is_": "Numero ICCID stampato sulla confezione della scheda SIM. Inserire le ultime 14 cifre del numero ICCID.",
	ICCID: ICCID$9,
	"SIM information": "Informazioni SIM",
	"Start your free_": "Inizia subito la prova gratuita",
	"SIM card activate_": "Data di attivazione scheda SIM",
	"Based on the_": "Si basa sulla data di inserimento della scheda SIM nella telecamera e della sua attivazione dopo l'accensione",
	"Upgrade to 3GB_": "Passa al piano da 3 GB/5 GB in qualsiasi momento",
	"Cancel your plan_": "Annulla il tuo abbonamento in qualsiasi momento",
	"No Commitment": "Senza alcun impegno",
	"Precautions for using_": "Precauzioni per l'uso del servizio",
	"After 1GB is_": "Dopo aver esaurito 1 GB, la connessione a Internet non sarà più disponibile.",
	"If you have_": "Dopo aver inserito la scheda SIM in una telecamera, il periodo di prova inizia dal momento di inizio dell'utilizzo.",
	"This content is_": "Questi dettagli sono indicati sulla confezione della scheda SIM. Non si prevedono rimborsi per periodi di prova gratuiti non effettivamente forniti.",
	"If you have_2": "In caso di dubbi, puoi contattare <a>il Team CS</a>",
	"When OFF, connecting_": "Quando l'opzione è disattivata, la connessione della telecamera tramite Abbinamento continuo è disabilitata.",
	"1 month free": "1 mese gratis",
	"No commitment. Cancel_": "Senza alcun impegno. Puoi annullare questa scelta in qualsiasi momento.",
	"The video has been reported_": "La segnalazione del video è andata a buon fine",
	"Free for 1 month": "Gratis per 1 mese",
	"Start your free_2": "Inizia la prova gratuita",
	"1GB free for_": "1 GB gratis per {{a}} giorni",
	"1GB data": "1 GB di dati",
	"1 month free_2": "1 mese gratis inizierà dal {{a}} e includerà 1 GB di dati per la scheda SIM BlackVue.",
	"Your next billing_": "La data della prossima fattura è {{a}}",
	"SIM card": "Scheda SIM",
	"SIM guide": "Guida SIM",
	"SIM card list": "Elenco scheda SIM",
	"Add SIM card": "Aggiungi scheda SIM",
	"No SIM card_": "Ancora nessuna scheda SIM",
	"Search SIM ICCID_": "Cerca nome o ICCID della SIM",
	"Cloud disconnected. Failed_": "Connessione cloud attiva. Impossibile riprodurre video",
	"This sim card_": "Scheda SIM già registrata per un altro account.",
	"Incorrect BlackVue SIM_": "ICCID SIM BlackVue errato",
	"My shared videos": "I miei video condivisi",
	"Number of events": "Numero di eventi",
	"Added to Event Map": "Aggiunto a Mappa eventi",
	"Successfully added video(s)_": "Aggiunta di video da condividere in Mappa eventi riuscita. Per controllare lo stato dei video condivisi e gestirli, accedere a Mappa eventi > I miei video condivisi.",
	"Already added to_": "Già aggiunto alla Mappa eventi",
	"This video(s) is already added_": "Questo video è già stato aggiunto alla Mappa eventi. Per controllare lo stato dei video condivisi e gestirli, accedere a Mappa eventi > I miei video condivisi.",
	"BlackVue’s firmware is up_": "Firmware BlackVue aggiornato",
	"Service end": "Fine servizio",
	Resubscribe: Resubscribe$9,
	"Sort ascending": "Ordine crescente",
	"Sort descending": "Ordine decrescente",
	plan: plan$9,
	USD: USD$9,
	"Are you sure_Cancel": "Annullare l'abbonamento? Prendere visione delle seguenti informazioni e confermare qui sotto.",
	"Your current SIM_": "L'attuale abbonamento della scheda SIM scade il {{a}} e i relativi pagamenti non saranno più addebitati.",
	"After canceling your_": "Dopo aver annullato l'abbonamento della scheda SIM, potrai continuare a usare i dati della SIM fino alla data di scadenza dell'abbonamento.",
	"You can resubscribe_": "Puoi rinnovare l'abbonamento entro 1 mese dalla fine dello stesso. Per rinnovare l'abbonamento, fai clic sul pulsante \"Rinnova abbonamento\" nell'elenco delle schede SIM entro il {{a}}.",
	"Reason to cancel_": "Motivo di annullamento dell'abbonamento",
	"Found an alternative": "Ho trovato un'alternativa",
	"Too expensive": "Troppo costoso",
	"Not required anymore": "Non mi serve più",
	"Quality issue": "Problema di qualità",
	etc_: etc_$9,
	"Please describe in_": "Indicare i dettagli",
	"SIM card cannot_": "Questa scheda SIM non può essere eliminata perché ha un abbonamento attivo. Per eliminare la scheda SIM, annullare prima il rispettivo abbonamento.",
	"SIM card cannot_2": "Questa scheda SIM non può essere eliminata perché l'abbonamento correlato non è ancora terminato. Riprova al termine dell'abbonamento.",
	"Are you sure_deleteSIM": "Eliminare questa scheda SIM?<br/>\n<b>Attenzione: questa azione non può essere annullata. Tutte le informazioni della scheda SIM saranno immediatamente cancellate.</b>",
	"ICCID number": "Numero ICCID",
	"Activation date": "Data di attivazione",
	"Current plan": "Piano attuale",
	"Manage Plan": "Gestisci piano",
	"Next billing on": "Data prossima fattura",
	"View Invoices": "Vedi fatture",
	"Choose best plan_": "Scegli il piano più adatto a te",
	"Plan summary": "Riepilogo del piano",
	"Ends on_": "Termina il {{a}}",
	"Start from_": "Inizia il {{a}}",
	"Your subscription will_": "L'abbonamento sarà aggiornato il {{a}}, al termine del piano attuale.",
	"Resubscribe plan": "Rinnova abbonamento al piano",
	"Your subscription will2_": "L'abbonamento inizierà il {{a}}, al termine del piano attuale.",
	"Usage is estimated_": "Utilizzo stimato al {{a}}",
	"Days left_": "{{a}} Giorni rimanenti",
	"Data usage cycle": "Ciclo di utilizzo dati",
	Available: Available$9,
	Used: Used$9,
	"Data used": "Dati utilizzati",
	"Subscribe to n_": "Abbonati al piano dati {{a}} applicato <b>dal {{b}} al {{c}}</b> e al piano dati {{d}} applicato dal {{e}}",
	"Will be charged_": "Il costo sarà addebitato il {{a}}",
	"Monthly usage": "Uso mensile",
	"You have fewer_": "Hai pochi dati rimanenti questo mese.",
	"Get more data": "Richiedi altri dati!",
	"This video cannot be shared": "Impossibile condividere questo video",
	"This is a video cannot be shared_": "Impossibile condividere questo video perché le relative informazioni di guida non sono state trovate al momento.",
	Cancelled: Cancelled$9,
	Terminated: Terminated$9,
	"Edit name": "Modifica nome",
	"Not connected to_2": "Non connesso al cloud. Controllare che la telecamera sia accesa e il modulo di connessione a Internet sia abilitato.",
	"Some functionality is disabled_": "Alcune funzionalità sono disabilitate perché la telecamera non è connessa al cloud. Effettuare la connessione al cloud <a>qui</a>.",
	"If you want to cancel_": "Se vuoi annullare il tuo piano, clicca <a>Annulla abbonamento</a>.",
	"Select plan": "Scegli piano",
	"Event map collects_": "La mappa eventi raccoglie e visualizza le informazioni relative agli eventi BlackVue per descrivere la situazione delle strade circostanti.",
	"Share your Live_": "Condividi il file di caricamento degli eventi Live. Puoi condividere i video dei tuoi eventi con altri utenti intorno a te.",
	"You can check_": "Puoi controllare i video di eventi condivisi da altri.",
	"Service end_": "Fine servizio: {{a}}",
	"DMS camera recording_": "Registrazione telecamera DMS in modalità parcheggio",
	Sort: Sort$9,
	"Are you sure you want_": "Rimuovere il video condiviso dalla Mappa eventi?",
	"Remove shared video": "Rimuovi video condiviso",
	"Explore event map": "Esplora mappa eventi",
	"Event map": "Mappa eventi",
	"Explore the graphic_": "Esplora il grafico delle statistiche degli eventi BlackVue che avvengono intorno a te.",
	"You can filter_": "Puoi filtrare e visualizzare gli eventi che vuoi guardare.",
	"This video was removed by_": "Video segnalato e rimosso dall'amministratore.",
	Bonus: Bonus$9,
	"Your subscription plan": "Il tuo piano di abbonamento",
	"Your free trial will_": "La tua prova gratuita inizierà a partire dal {{a}},</br> <strong>fino al</strong> {{b}}.",
	"Total after free trial": "Totale dopo la prova gratuita",
	"This sim card is_": "La scheda SIM non è più attiva.",
	"Firmware is up_": "Il firmware è aggiornato",
	"Keep in mind": "Ricorda",
	"Once 1GB of_": "Dopo aver utilizzato 1 GB di dati, il servizio non sarà più disponibile fino alla successiva data di azzeramento del conteggio Dati [o dopo il passaggio a un piano di livello superiore].",
	"After the SIM_": "Dopo aver inserito la scheda SIM in una telecamera, il periodo di prova gratuita inizia dal momento di inizio dell'utilizzo dati.",
	"If you have_questions": "In caso di dubbi,è possibile contattare <a>l'Assistenza clienti.</a>",
	"Data reset date": "Data di azzeramento conteggio dati",
	"To use SIM card_": "Per usare la scheda SIM, è possibile contattare il <a>Team CS</a> di BlackVue",
	"Go to Subscription": "Vai all'abbonamento",
	"An error occurred_subscription": "Si è verificato un errore durante l'abbonamento al piano selezionato.",
	"Please try again": "Riprova",
	"Failed to subscribe": "Abbonamento non riuscito",
	"Go to Pricing": "Vai ai prezzi",
	"SIM cards will_": "Le schede SIM appariranno qui non appena saranno disponibili.",
	"1GB for 1_": "1 GB per 1 mese",
	"Pricing Data": "Dati di prezzo",
	"If you would like to check_": "Per controllare lo stato dei video condivisi e gestirli, accedere a Mappa eventi > I miei video condivisi.",
	"Connect to Cloud": "Connessione al Cloud",
	"Completed!": "Completato!",
	"Back to App": "Torna all'App",
	"iOS in-app purchase": "Acquisto iOS in-app",
	"Android in-app_": "Acquisto Android in-app",
	"bonus n days": "{{a}} giorni bonus",
	"Want to contribute your_": "Consentire la condivisione automatica dei file di eventi a caricamento automatico con la Mappa eventi?",
	"With event map_": "Puoi condividere i video di eventi a caricamento automatico con i conducenti nelle vicinanze tramite la mappa eventi.",
	"You can edit_3": "Puoi sempre modificare le impostazioni di condivisione automatica con la Mappa eventi dei video di eventi a caricamento automatico accedendo a BLACKVUE CLOUD > Impostazioni telecamera > Impostazioni di privacy.",
	"If you want to remove videos_": "Dato che possono essere trasmessi video di natura privata, è importante decidere con cura quali informazioni condividere.",
	"Total events": "Eventi totali",
	"Automatically add Live Event_": "Condivisione automatica dei file di eventi a caricamento automatico con la Mappa eventi",
	"This camera is publicly_": "Questa telecamera è aperta al pubblico solo in relazione alla sua posizione.",
	incomplete_zip: incomplete_zip$9,
	"Live Event Upload_": "Caricamento eventi live (periodo di archiviazione: 7 giorni)\nRichiede l'ultima versione firmware",
	"Thank you for_2": "Grazie per la pazienza.",
	"Start Web viewer": "Avvia visualizzatore web",
	"Are you sure_remove driver": "Eliminare definitivamente questo conducente?",
	"An error occurred_sim": "Si è verificato un errore durante il tentativo di abbonamento.",
	"Click the ADD SIM": "Cliccare il pulsante AGGIUNGI SIM nella pagina dell'elenco schede SIM e ripeti i passi della procedura di aggiunta della SIM.",
	"Set download options": "Imposta opzioni di download",
	"Information may be_": "Information may be transmitted with a delay and may not reflect actual balances.",
	"Swipe left and right to move": "Scorri a sinistra e a destra per spostarti",
	"Scheduled maintenance Notice": "Avviso di Manutenzione Programmata",
	"Our Cloud server_": "Il nostro server cloud sarà soggetto a una manutenzione programmata.",
	"During that time_": "In questo periodo delle funzionalità cloud potrebbero non essere disponibili.",
	"Expected maintenance start_": "Orario di inizio previsto della manutenzione:",
	"Expected duration_": "Durata prevista: {{a}} ore.",
	"For more information_": "Per altre informazioni, consultare l'<a>[Avviso di Manutenzione Programmata]</a>",
	"Do not remind_": "Non ricordarmelo più",
	"Cloud Server Maintenance": "Manutenzione server cloud",
	"BlackVue Cloud Service_": "Servizio BlackVue Cloud temporaneamente non disponibile",
	"We are currently_": "Siamo attualmente in manutenzione.",
	"We apologize for_": "Ci scusiamo per eventuali inconvenienti.",
	"Driver Monitoring System (DMS)": "Sistema di monitoraggio conducente (DMS)",
	"Distracted occurs_": "Si verifica quando la testa del conducente si trova a oltre 50 gradi rispetto al davanti.",
	"Hand distraction event occurs_": "Si verifica quando la mano del conducente viene rilevata vicino alla testa per un periodo prolungato (ad esempio quando fuma, tiene un telefono, ecc.).",
	"Mask off event occurs_": "Si verifica quando il conducente sale in auto senza mascherina o quando il conducente toglie la mascherina.",
	"DMS setting": "Impostazioni DMS",
	"The DMS system has_": "Il DMS combina una casella di rilevamento del volto per gli stati \"Rilevato\", \"Non rilevato\", \"Distrazione\", \"Sonnolenza\", \"Maschera rimossa\" e una casella di rilevamento dei movimenti per lo stato di \"Distrazione della mano\".",
	"DMS detection": "Rilevamento DMS",
	"There are detection criteria for_": "Ci sono criteri di rilevamento per ogni evento. Si prega di fare riferimento alla guida qui sotto.",
	"DMS camera recording_onoff": "Acceso: La telecamera DMS registra in modalità di parcheggio fintanto che è presente l'alimentazione. <br/> Spento: La telecamera DMS si spegne poco dopo l'ingresso in modalità di parcheggio.",
	"LED lighting for each event_": "Il LED sulla telecamera di monitoraggio del conducente segnalerà ogni evento di rilevamento (Distrazione, Sonnolenza, ecc.).",
	"Drowsy and Distracted each have_": "La guida in stato di Sonnolenza e la guida Distratta hanno ognuna tre stati di sensibilità.\n Fare riferimento all'interfaccia della guida qui di seguito.",
	"DMS event detection sensitivity": "Sensibilità di rilevamento evento DMS",
	"Only drowsy and distracted include_": "Solo le modalità guida in stato di Sonnolenza e guida Distratta includono le impostazioni di sensibilità. Parimenti la sensibilità impostata applica la stessa sensibilità ai due eventi per una impostazione.",
	"When driver’s eyes close_": "Si verifica quando il conducente chiude entrambi gli occhi per più di 1 secondo o sbadiglia per 2 secondi.\n",
	"n digit": "{{a}} cifre",
	"You are subscribed_free_Smart": "Sei abbonato al piano Smart di BlackVue Cloud.",
	"Wi-Fi auto turn on": "Attivazione automatica Wi-Fi",
	"Video on a map": "Video on a map",
	"This feature is only_vom": "This feature is only available to users with a Fleet Plan subscription.<br/>Please subscribe to a plan to unlock this feature.",
	"Total n days_": "un totale di {{a}} giorni di prova gratuita.",
	"Every events of DMC200_": "Le funzioni di rilevamento DMS sono attive solo in Modalità Normale. Se alimentato in Modalità Parcheggio, la telecamera DMS registra solo video.",
	"An undetected event occurs_": "Si verifica quando il conducente non viene rilevato davanti alla telecamera per 1 minuto.",
	"A detected event occurs_": "A detected Event occurs when the driver is gazing in front since the power is set in the beginning.",
	"Drowsy sensitivity_": "High : When the driver closes their eyes for more than 1 second, it is considered drowsy driving.<br/><br/>Medium : When the driver closes their eyes for more than 1.5 second, it is considered drowsy driving.<br/><br/>Low : When the driver closes their eyes for more than 2 second, it is considered drowsy driving.",
	"Distracted sensitivity_": "High : If the angle of the head is more than 50 degrees away from the front for 3 seconds, it is detected as Distracted.<br/><br/>Medium : If the angle of the head is more than 50 degrees away from the front for 5 seconds, it is detected as Distracted.<br/><br/>Low : If the angle of the head is more than 50 degrees away from the front for 7 seconds, it is detected as Distracted.",
	"Start your subscription now": "Sottoscrivi l'abbonamento ora",
	"Free trial period has expired": "Il periodo di prova gratuito è scaduto",
	"1 data plan will start from_": "L'abbonamento al piano dati inizierà dal {{a}} e includerà 1 GB di dati per la scheda SIM BlackVue.",
	"Allow the BlackVue_": "Permettere all'app BlackVue di accedere ai dati GPS della dash cam?",
	"We use this_": "Questa funzione viene utilizzata per tracciare la posizione e la velocità del proprio veicolo.",
	"You can edit_": "È possibile modificare le impostazioni di accesso GPS in qualunque momento andando alla voce CLOUD BLACKVUE > Impostazioni telecamera > Impostazioni della privacy.",
	"SIM cards": "Schede SIM",
	"Subscription status": "Stato dell'abbonamento",
	Upgrades: Upgrades$9,
	"Upgrade plan": "Aggiorna il piano",
	"Manage plan": "Gestisci il piano di abbonamento",
	"Next plan": "Piano di abbonamento per il prossimo mese",
	OR: OR$9,
	"Cancel subscription": "Annullare l'iscrizione",
	Undo: Undo$9,
	Invoice: Invoice$9,
	"Daily usage": "Utilizzo quotidiano dei dati",
	"Delete SIM": "SIM Elimina",
	"New card": "Nuova carta di credito",
	data: data$9,
	"SIM card data_": "L'abbonamento al piano dati della scheda SIM può essere annullato alla pagina <a>sim.blackvuecloud.com</a>.",
	"Your plan from_": "Piano dati a partire da oggi fino alla prossima data di fatturazione",
	"Applied during_": "Valido da {{a}} a {{b}}",
	"From today until_": "Da oggi fino alla prossima data di pagamento, potrai sottoscrivere solo lo stesso abbonamento del mese precedente. Gli importi dovuti per questo periodo saranno fatturati oggi. <a>Le tariffe sono calcolate su base proporzionale.</a>",
	"Choose your next plan": "Scegli il tuo prossimo piano",
	"Applied from_": "Valido dal {{a}}",
	"Payment for this_": "Il pagamento per questo piano sarà addebitato il {{a}}.",
	"By sharing your_2": "La condivisione della vista live permette ad altri utenti di vivere indirettamente il piacere e l'eccitazione di guidare in tutto il mondo. Dato che possono essere trasmessi video di natura privata, è importante decidere con cura quale informazione condividere.",
	"Option camera recording_": "Opzione di registrazione telecamera in modalità parcheggio",
	"Front and option camera_": "La videocamera anteriore e quella opzionale registrano contemporaneamente.",
	"Option camera stops_": "La videocamera opzionale interrompe la registrazione 5 minuti dopo essere entrata in modalità parcheggio. La registrazione riprende tornando alla modalità normale.",
	"Option camera rotation": "Rotazione della videocamera opzionale",
	"Option camera": "Videocamera opzionale",
	"Option camera security": "Opzione di sicurezza telecamera",
	"Resubscribe until_": "Rinnova il piano fino: {{a}}",
	"Firmware Update Caution": "Attenzione aggiornamento firmware",
	"Please check below_": "Controllare quanto segue prima dell'aggiornamento firmware per DMC200:",
	"The camera's Wi-Fi_": "Il WiFi della videocamera deve essere acceso.",
	"Check if your_": "Controllare che il WiFi della videocamera sia acceso.",
	"DO NOT disconnect_": "NON scollegare il cavo coassiale durante l'aggiornamento firmware.",
	"The camera and_": "La videocamera e il DMC200 possono essere guasti.",
	"DO NOT try_": "NON cercare di utilizzare altre funzioni fino al termine del riavvio della videocamera.",
	"Expecially Reboot camera_": "Specialmente il Riavvio della videocamera, il formato della scheda SD possono essere fondamentali nella rottura dei due dispositivi.",
	"Update anyway": "Aggiorna comunque",
	"Invited on_2": "invitato il {{Invited Date}} da te. Proprietario",
	"BlackVue’s New firmware_": "Nuovo firmware BlackVue disponibile",
	"valid thru_": "valido fino: {{a}}",
	"Billed monthly": "Billed monthly",
	"90 minutes Live_": "90 minutes Live View / Live Event Upload*",
	"or 2+ videos_": "or 2+ videos in full resolution*",
	"1GB Free Month_": "1GB Free Month Trial",
	"Cancel anytime": "Cancel anytime",
	"8+ hours Live_": "8+ hours Live View / Live Event Upload*",
	"or 12+ videos_": "or 12+ videos in full resolution*",
	"15+ hours Live_": "15+ hours Live View / Live Event Upload*",
	"or 23+ videos_": "or 23+ videos in full resolution*",
	Popular: Popular$9,
	"For Power Users": "For Power Users",
	"Estimates based on_": "* Estimates based on 4.5MB per minute of Live View, Quick View remote playback, or Live Event Upload file, and 190MB per full original resolution video download or playback (at 25Mbps bitrate). Daily idle Cloud connection data usage: 20MB per 24 hours. Data usage is shared among all types of services (Live View, Live Event Upload, etc.).",
	"Balanced Plan": "Balanced Plan",
	"For Light Cloud_": "For Light Cloud Use",
	"Front security (Normal mode)": "Sicurezza frontale (modalità normale)",
	"Front security (Parking mode)": "Sicurezza frontale (modalità parcheggio)",
	"BT (Parking mode)": "BT (modalità parcheggio)",
	"LTE (Parking mode)": "LTE (modalità parcheggio)",
	"Wi-Fi (Parking mode)": "Wi-Fi (modalità parcheggio)",
	"Hand distraction": "Distrazione manuale",
	Mask: Mask$9,
	"Second drowsy is_": "La seconda segnalazione di guida in stato di Sonnolenza scatta entro 30 secondi dalla prima segnalazione che ha avviato la registrazione dell'evento in diretta.",
	"Second drowsy alert": "Seconda segnalazione di guida in stato di Sonnolenza.",
	"BlackVue sim card_": "La scheda SIM BlackVue può essere usata solo in Canada e negli Stati Uniti.",
	"Global support is coming soon.": "L'assistenza a livello globale sarà presto disponibile.",
	"The video file not found_": "Il file video non è stato trovato o si è verificato un problema durante la riproduzione. Riprovare.",
	"Start Voice Call": "Inizia chiamata vocale",
	"End Voice Call": "Termina chiamata vocale",
	"Voice call in use": "Chiamata vocale in uso",
	"Enable microphone access_": "Abilita l'accesso al microfono per usare la funzione della comunicazione vocale bidirezionale. Vai alla pagina di impostazioni del browser per accedere al microfono.",
	"You may need to_": "Potrebbe essere necessario ricaricare questa pagina per attivare le nuove impostazioni.",
	"Eye status": "Condizione oculare",
	"Start time of live event upload video": "Orario di avvio del video dell'evento in diretta",
	"Left eye": "Occhio sinistro",
	"Right eye": "Occhio destro",
	"Drowsy is occured when the driver close his/her eyes more then 1sec": "Quando gli occhi del conducente si chiudono per più di 1 secondo si attiva lo stato di Sonnolenza",
	"Driver's Left eye movements with blinking count and period": "Movimenti dell'occhio sinistro del conducente con conteggio del periodo e del numero dei battiti dell'occhio",
	"Driver's Right eye movements with blinking count and period": "Movimenti dell'occhio destro del conducente con conteggio del periodo e del numero dei battiti dell'occhio",
	"Drowsy big data of the driver and after a Drowsy event occurs": "Big data sui battiti degli occhi del conducente dopo la guida in stato di Sonnolenza",
	"Sharing video to Event Map": "Condivisione video in Mappa eventi",
	"Want to use a Voice call?": "Vuoi usare una chiamata vocale?",
	"To use a voice call_": "Per usare una chiamata vocale, riavviare la Visualizzazione live e fare clic su \"Autorizza\"",
	"There is no_": "Non ci sono ancora video condivisi. \nSarà visualizzato un elenco se condiviso.",
	"Microphone blocked": "Microfono bloccato",
	"Want to center the map on your location?": "Vuoi centrare la mappa sulla tua posizione?",
	"To let the app access your location_": "Per consentire all'app di accedere alla tua posizione, riavvia MAPPA EVENTI e seleziona \"OK\" quando richiesto.",
	"Location access permission required": "È richiesta l'autorizzazione di accesso alla posizione.",
	"Are you sure you want_2": "Sei sicuro di voler rimuovere questo video dalla MAPPA EVENTI?",
	"Two-way voice_2": "Two-way voice communication / Voice Call",
	"Not supported by DR650GW and DR650S_": "Not supported by DR650GW and DR650S",
	"DR650S Series only_": "DR650S Series only",
	"Cancel download?": "Annullare il download?",
	"Your download is not_": "Il download non è stato completato. Desiderate annullare il download?",
	"Continue download": "Continua il download",
	"Cancel download": "Annulla il download",
	"Share your video to the Event Map?": "Condividere il video nella mappa eventi?",
	"Afterwards, according to the reaction to the video_": "In seguito, in base alle reazioni ottenute, il video può essere classificato come popolare e inserito nelle tendenze attuali della mappa.",
	"Add hashtags and a brief description to describe your video.": "Aggiungere l’hashtag e una breve descrizione per presentare il video.",
	"Would you like_": "Desiderate condividere la mappa eventi?",
	"Successfully added video_": "Video da condividere nella mappa eventi aggiunto con successo.",
	"This video cannot_": "Questo video non può essere condiviso, perché mancano i dati di localizzazione GPS necessari per poterlo posizionare sulla mappa.",
	"This video is_": "Questo video è già stato aggiunto alla mappa eventi.",
	"Share to Event Map": "Condividi nella mappa eventi",
	"Describe in more_": "Descrivere in modo più dettagliato cosa accade nel video (opzionale)",
	"Description(optional)": "Descrizione (opzionale)",
	"Recording mode": "Modalità di registrazione",
	"Event triggers": "Attivazione evento",
	DMS: DMS$9,
	"Camera connectivity": "Connettività telecamera",
	"If not allowed_2": "Se ciò non è possibile, la posizione e la velocità del veicolo non saranno accessibili attraverso il Cloud.",
	"Share Live View_": "Condividi il video della vista live",
	"Share Live View_2": "Condividi l'audio della vista live",
	"Share camera profile": "Condividi profilo telecamera",
	"Parking impact": "Urto durante il parcheggio",
	"Parking events": "Parking Events",
	"Audio recording": "Registrazione audio",
	"Toggle the mic_": "Attivare/disattivare il microfono",
	"Full HD_": "Full HD @ 60fps + Full HD @ 30fps",
	"Video quality": "Qualità video",
	Extreme: Extreme$9,
	"More video files": "Più file di registrazione",
	"Fewer video files": "Meno file di registrazione",
	"Camera rotation": "Rotazione telec. posteriore",
	"Video overlay": "Sovrapposizione video",
	"Date & time display": "Visualiz. data e ora",
	"Speed unit": "Unità di misura della velocità",
	"Check the orientation_": "Controllare l'orientamento della telecamera anteriore installata nel veicolo. Selezionare l'opzione corrispondente per registrare i video con orientamento verticale.",
	"Rotate 180º": "Ruotare di 180º",
	"Rear camera rotation": "Rotazione telec. posteriore",
	"Check the orientation_rear": "Controllare l'orientamento della telecamera posteriore installata nel veicolo. Selezionare l'opzione corrispondente per registrare i video con orientamento verticale.",
	"Mirror View": "Visualizzazione allo specchio",
	"Select Mirror View_": "Selezionare Visualizzazione a specchio per capovolgere il video in orizzontale.",
	"Check the orientation_interior": "Controllare l'orientamento della telecamera opzionale installata nel veicolo. Selezionare l'opzione corrispondente per registrare i video con orientamento verticale.",
	"Display off": "Schermo spento",
	"Explore crowd-sourced Events_": "Sulla mappa, è possibile esplorare gli eventi ottenuti da diverse fonti (impatto, frenata improvvisa, ecc.), guardare i video condivisi dalla comunità e contribuire con i propri eventi.",
	OFF: OFF$9,
	"Reboots once-a-day_": "Per una maggiore stabilità, viene riavviata una volta al giorno all'ora impostata, se in modalità parcheggio.",
	"Set time": "Imposta ora",
	"FW language": "Lingua firmware",
	"Rear security_2": "Sicurezza posteriore",
	"Bluetooth (Parking mode)_2": "Bluetooth (modalità parcheggio)",
	"Failed to save_2": "Impossibile salvare le impostazioni di caricamento degli eventi live",
	"Event file will_": "Il file dell'evento verrà salvato automaticamente nella memoria di caricamento degli eventi live.",
	"An impact was_": "An Impact was detected during Parking Mode.",
	"When exiting Parking_": "Uscendo dalla modalità di parcheggio, il BlackVue annuncia se è stato rilevato un impatto durante la registrazione in modalità parcheggio. \n\n Note: \n Gli impatti generano eventi video. Gli impatti generati entro 3 minuti dall'uscita dalla modalità di parcheggio vengono ignorati.",
	"Protect event files": "Protezione file evento",
	"Turning on this_": "Attivare per proteggere gli ultimi {{a}} file di eventi dalla sovrascrittura da parte di file di registrazione in modalità normale o in modalità parcheggio.",
	"Impact Events in_": "Impact Events in Normal(E) and Parking Mode(I)",
	"Manual Events_": "Manual Events (M)",
	"Once 50 Events_": "I file protetti includono: \n\nEventi di impatto in modalità normale (E) e in modalità parcheggio (I) \nEventi manuali (M) \n\nUna volta registrati {{a}} eventi, i nuovi eventi verranno sovrascritti a quelli meno recenti.",
	"Reckless driving unit": "Modulo Guida pericolosa",
	"Hard acceleration Event": "Evento di forte accelerazione",
	Threshold: Threshold$9,
	"Triggers when the_": "Si attiva quando la telecamera rileva una velocità di accelerazione superiore al valore di soglia impostato.",
	"Triggers when the_2": "Si attiva quando la telecamera rileva una riduzione della velocità superiore al valore di soglia impostato.",
	"Hard braking Event": "Evento di frenata improvvisa",
	"Triggers when more_": "Si attiva quando vengono rilevati più di 60 gradi entro 2 secondi durante la guida, oltre il valore di soglia impostato.",
	"Every event of DMC200_2": "Le funzioni di rilevamento del DMS sono attive solo in modalità normale. Se alimentata in modalità parcheggio, la telecamera DMS registra solo video.",
	"The DMS system has_2": "Il DMS combina una casella di rilevamento del volto per gli stati “Rilevato”, “Non rilevato”, “Distrazione”, “Sonnolenza”, “Maschera rimossa” e una casella di rilevamento dei movimenti per lo stato di “Distrazione della mano”.",
	"One for face_": "One for face detection : Detected, Undetected, Distracted, Drowsy",
	"The other for_": "The other for motion detection",
	"On: Normal recording_": "On: Normal recording works while power is maintained in Parking Mode",
	"Off: DMS power_": "Off: DMS power off after 5 minutes when entering Parking Mode, Normal recording works until just before off",
	"Drowsy and Distracted_": "Drowsy and Distracted each have three sensitivity conditions.",
	"Please refer to_": "Please refer to the guide interface below.",
	Drowsiness: Drowsiness$9,
	"Drowsiness occurs when_": "La sonnolenza si verifica quando il conducente chiude entrambi gli occhi mentre guida per più di 1 secondo e sbadiglia per 2 secondi.",
	"Distracted occurs when_": "Si verifica quando la testa del conducente si trova a oltre 50 gradi rispetto al davanti.",
	"A hand distraction_": "A hand distraction occurs when the driver removes one hand from the steering wheel. [*Smoking and phone calls may be suspected.]",
	"Mask off event_": "Mask-off event occurs in two ways. First is when the driver gets in the car without a mask. Second is when the driver takes their mask off",
	"High When the_": "High : When the driver closes their eyes for more than 1 second, it is considered drowsy driving.",
	"Middle When the_": "Medium : When the driver closes their eyes for more than 1.5 second, it is considered drowsy driving.",
	"Low When the_": "Low : When the driver closes their eyes for more than 2 second, it is considered drowsy driving.",
	"High If the_": "High : If the angle of the head is more than 50 degrees away from the front for 3 seconds, it is detected as Distracted.",
	"Middle If the_": "Medium : If the angle of the head is more than 50 degrees away from the front for 5 seconds, it is detected as Distracted.",
	"Low If the_": "Low : If the angle of the head is more than 50 degrees away from the front for 7 seconds, it is detected as Distracted.",
	Direct: Direct$9,
	"Camera Wi-Fi credentials": "Credenziali Wi-Fi telecamera",
	"Network name(SSID)": "Nome della rete (SSID)",
	"Seamless pairing": "Seamless Pairing",
	Remote: Remote$9,
	"Hotspot settings": "Impostazioni hotspot",
	"Hotspot name": "Nome hotspot (SSID)",
	"Hotspot name must_": "Hotspot name must be at least 5 characters long",
	"Public cameras may_": "Le telecamere pubbliche possono apparire sulla scheda Esplora o sulla mappa del mondo.",
	"Hard Cornering Event": "Evento di curva pericolosa",
	"Over speed_2": "Velocità eccessiva",
	"Second drawiness alert": "Seconda segnalazione di guida in stato di sonnolenza.",
	"Low Voltage Warning_2": "Posizione errata delle mani",
	"(You)_2": "{{a}} (Tu)",
	"This video has been reported_": "Video segnalato e rimosso dall'amministratore.",
	"Normal Mode recording": "Registrazione in modalità normale",
	"ON : the camera_": "ATTIVO: la telecamera registra continuamente in loop.",
	"OFF : the camera_": "DISATTIVATO: la telecamera registra solo i video degli eventi durante la guida.",
	"In both modes_": "In entrambe le modalità, gli impatti rilevati attivano le registrazioni video degli eventi.",
	"Continuously records_": "Registra continuamente video di 1 minuto a 1 fotogramma al secondo che coprono 30 minuti di azione.",
	"Choose detection regions_": "Scegliere le aree di rilevamento per ridurre il rischio di attivare registrazioni di movimenti indesiderate dovute ad alberi che ondeggiano al vento, oggetti lontani che si muovono ecc.",
	"Your previous plan is expired.": "Il piano precedente è scaduto.",
	"Upgrade the plan to restore the camera": "Aggiornare il piano per ripristinare la telecamera\n(%@)",
	"Remove from cloud": "Rimuovere dal Cloud",
	"Are you sure you want to Remove_": "Rimuovere dallo slot Cloud?",
	"Remove: It doesn’t mean_": "Rimuovere: non significa cancellare i dati della telecamera, ma creare uno slot di riserva per il numero di telecamere nel Cloud.",
	"Now the camera is removed from cloud slot": "La telecamera è stata rimossa dallo slot Cloud.",
	"How to delete camera list": "Come eliminare una telecamera dall’elenco",
	Update: Update$9,
	"Camrea setting": "Impostazione telecamera",
	"Notification setting": "Impostaz. notifiche push",
	"Driving reports": "Report di guida",
	"Cloud connection steps": "Procedura di connessione al Cloud",
	"Download the BlackVue app to add a camera": "Scaricare l'app BlackVue per aggiungere una telecamera",
	"To see your camera in the BlackVue cloud viewer_": "Per visualizzare la telecamera nel Cloud del BlackVue Viewer, occorre prima collegarla al Cloud. Configurare e collegare facilmente la telecamera BlackVue al Cloud tramite l’app BlackVue per dispositivi iOS e Android.",
	"Download the BlackVue app to see a Wi-Fi connected camera": "Scaricare l'app BlackVue per visualizzare una telecamera connessa tramite Wi-Fi",
	"BlackVue Cloud web viewer only supports_": "Il visualizzatore web BlackVue Cloud supporta solo le dash cam collegate al Cloud. Scaricare l'app BlackVue per visualizzare la dash cam connessa tramite Wi-Fi.",
	"You can restore the data if_": "È possibile ripristinare i dati se si registra nuovamente la telecamera con lo stesso account; tuttavia, se l'account è stato cancellato tutti i file andranno persi.",
	"How to add camera": "Come aggiungere la telecamera",
	"Try to wait 2-3 minutes if you just registered the camera.": "Attendere 2-3 minuti se la telecamera è appena stata registrata.",
	"Try to check the Cloud Connection Settings again_": "Se la telecamera continua a non connettersi al Cloud, provare a controllare nuovamente le impostazioni di connessione al Cloud.",
	"Motion Detection": "Rilevamento movimenti",
	"Parking recordings occur_": "Le registrazioni in modalità parcheggio vengono effettuate quando viene rilevato un movimento visibile.",
	"Motion Sensitivity": "Sensibilità di rilevamento movimenti",
	"Motion Detection Sensitivity": "Sensibilità del rilevamento del movimento",
	"Select Detection Region": "Seleziona regione di rilevamento",
	"Speed alert_2": "Indicatore velocità",
	"Live Event Upload_2": "Live Event Upload",
	"Beep Alert": "Segnale acustico",
	"Parking Impact History_": "Storico allarmi impatti in modalità parcheggio",
	"To register your_": "Per registrare il tuo pulsante SOS, devi utilizzare l'applicazione BlackVue.",
	"SOS button on/off": "Stato Pulsante SOS",
	"File sharing to Event Map is_": "La condivisione di file su Event Map non è attualmente disponibile. Per favore controllare più tardi.",
	"Email Notifications": "Notifiche email",
	"Push Notifications_2": "Notifiche Push",
	"Optional Camera Rotation": "Opzione di orientamento telecamera",
	"Optional Camera Security": "Opzione di sicurezza telecamera",
	Option: Option$9,
	"(Owner)": "{{a}} (Proprietario)",
	"SOS button": "Pulsante SOS",
	"This video has been reported_bold": "Questo video è stato segnalato e <b>rimosso dall'amministratore.</b>",
	"Number of events_2": "Numero di eventi",
	"My Shared Videos": "I miei video condivisi preferiti",
	"No Hashtags": "Nessun hashtag",
	"I have read and agree_": "Ho letto e accetto tutti i termini e le politiche",
	"14 years old_": "14 anni o più",
	Required: Required$9,
	Optional: Optional$9,
	"Profile information_": "Le informazioni sul profilo possono essere modificate nella pagina delle impostazioni dell’account.",
	"Automatically Add Live_": "Condivisione automatica dei file di eventi a caricamento automatico con la Mappa eventi",
	"You must be 14 years_": "Per creare un account BlackVue è necessario avere almeno 14 anni",
	"Use 8 or more characters_": "Usare da 8 o più caratteri con una combinazione di lettere, cifre e simboli",
	"Protected files include_": "I file protetti includono: <br/>ㆍEventi di impatto in modalità normale (E) e in modalità parcheggio (I) <br/>ㆍEventi manuali (M)<br/><br/>Una volta registrati {{a}} eventi, i nuovi eventi verranno sovrascritti a quelli meno recenti.",
	"Protected files include": "Protected files include",
	"If you turn_": "Se disattivi la guida vocale, anche i seguenti elenchi saranno disattivati.",
	"Live Event Upload_success": "Le impostazioni di caricamento dell'evento live sono state salvate con successo.",
	"Video type": "Tipi di video",
	"Notify the Owner": "Inviare una notifica al proprietario",
	"Adjusting the cut-off voltage_2": "Adjusting the cut-off voltage to a lower setting may result in your dash cam draining more power from your battery. This could result in warning messages of battery drain or affect other vehicle functions.\nPlease consult with your dealership before lowering the voltage.",
	Others: Others$9,
	"This video has been removed.": "Questo video è stato rimosso.",
	"Please assign cameras_": "Assegnare le telecamere a questo gruppo.",
	"Are you running_": "Avete difficoltà a guardare la riproduzione?",
	"Upgrade your plan_": "Aggiornare l’abbonamento al Piano Fleet per ottenere la riproduzione illimitata e altre funzioni esclusive del Cloud.",
	"Are you running_Liveview": "Non riuscite più a guardare la visualizzazione live?",
	"Upgrade your plan_Liveview": "Aggiornare l’abbonamento al Piano Fleet per ottenere la visualizzazione live illimitata e altre funzioni esclusive del Cloud.",
	Stay: Stay$9,
	"Go to Fleet Plan": "Aggiornamento al Piano Fleet",
	"It looks like the video file is being prepared. please try again later.": "Sembra che il file video sia in fase di preparazione. per favore riprova più tardi.",
	"Oops!": "Ops!",
	"Please back up_": "Eseguire il backup di tutte le registrazioni importanti prima di modificare questa impostazione.",
	"When you save_": "Quando si salvano le impostazioni, la scheda microSD verrà formattata e tutte le registrazioni verranno eliminate per garantire un funzionamento stabile.",
	"This is an unregistered_": "Questa è un'e-mail non registrata. Vuoi andare alla pagina Crea account?",
	"Camera name must_2": "Il nome della telecamera deve contenere da 5 a 32 caratteri.",
	"G-sensor (Normal mode)": "Sensore G (modalità normale)",
	"G-sensor (Parking mode)": "Sensore G (modalità parcheggio)",
	"Up & down": "Su e giù",
	"Front & back": "Avanti e dietro",
	"Rotate Video 180º": "Rotate Video 180º",
	Mask_2: Mask_2$9,
	"Priority event": "Priority Event",
	"There is no_camera": "There is no camera that your owner assigned to you.",
	"Camera SSID": "Camera SSID",
	"The BlackVue dashcam_2": "The BlackVue dashcam is not compatible with 5GHz wireless networks",
	"Driver detection box_2": "Driver Detection Box",
	"DMS camera recording_2": "DMS Camera Recording in Parking Mode",
	Low_2: Low_2$9,
	Medium_2: Medium_2$9,
	High_3: High_3$9,
	"Live Event Upload_3": "Live Event Upload",
	"Driving Impact": "Driving Impact",
	"Video source_2": "Video Source",
	"Front camera_2": "Front Camera",
	"Rear camera_2": "Rear Camera",
	"Optional Camera": "Optional Camera",
	"Motion Detection_2": "Motion Detection",
	"Rear camera stops_2": "Rear camera stops recording 5 minutes after entering Parking Mode. Recording restarts when entering normal mode.",
	"Passenger vehicle": "Passenger Vehicle",
	"Heavy vehicle": "Heavy Vehicle",
	Highest_3: Highest_3$9,
	Extreme_2: Extreme_2$9,
	"Less recording files": "Fewer Recording Files",
	"Camera rotation_2": "Camera Rotation",
	"Share camera profile_2": "Share Camera Profile",
	Private_2: Private_2$9,
	"BlackVue Live": "BlackVue Live",
	"Important All saved_": "Important! All saved videos are about to be deleted. Tap Cancel and back up important files if needed.",
	"Whenever saving settings_": "Whenever saving settings after changing the time zone, the SD card is initialized and all stored files are deleted.",
	"Do you want_": "Do you want to save your changes?",
	"No groups": "No groups",
	Lite: Lite$9,
	"USD per Camera": "USD per extra Camera",
	"up to Cameras": "up to Cameras",
	"All the P Plan_": "Tutte le funzionalità del piano <b>{{a}}</b>, oltre a:",
	"User Roles and Permissions": "Ruoli e autorizzazioni utente",
	"Geofence Setup (Web) and alerts": "Geofence Setup (Web) and alerts",
	"N Times": "{{a}} Volte",
	"N Minutes": "{{a}} Minuti",
	"Emergency Alarm": "Allarme di emergenza",
	"Playback, Live View": "Riproduzione, Live View",
	"Your driving record : Daily, Monthly": "Il tuo registro di guida: Giornaliero, Mensile",
	"Real-time Conversation": "Conversazione in tempo reale",
	"Initiate a conversation_": "Inizia una conversazione con il driver attraverso l'altoparlante e il microfono di Dashcam.",
	"Remote Voice Communication": "Comunicazione vocale remota",
	"See the last location_": "Vedi l'ultima posizione della tua fotocamera",
	"Check your cars_": "Controlla i dati GPS in tempo reale della tua auto su una mappa per individuare il veicolo e ottenere informazioni sul suo stato, ad esempio se sta guidando o parcheggiato e la sua velocità.",
	"Supported models_": "* Modelli supportati: S e primi modelli di serie X",
	"GPS Tracking &_": "Tracciamento GPS e video sulla mappa (smart/flotta)",
	"Track your cars_": "Tieni traccia della posizione e della velocità della tua auto sulla mappa!",
	"GPS Tracking: visualize_": "Tracciamento GPS: visualizza il registro di guida sulla mappa.\nVideo sulla mappa: visualizzare le informazioni contestuali (velocità, tipo di evento) e riprodurre video correlati direttamente dalla mappa.",
	"Visualize your cars_": "Visualizza la posizione e la velocità della tua auto sulla mappa!",
	"The feature enables_": "La funzione consente di caricare le riprese video su cloud, compresi i 5 secondi precedenti a un incidente.",
	"Camera profile setting": "Camera profile setting",
	"Are you running_Download": "Are you running out of chance to Download Video?",
	"Upgrade your plan_Download": "Upgrade your plan to Fleet Plan for Unlimited Download, and other Cloud -Exclusive features.",
	"This feature is available for Smart and Fleet_": "This feature is available for Smart and Fleet Plan subscribers only.",
	"Rear camera will keep_": "La telecamera posteriore smette di registrare in modalità parcheggio quando lo stato di temperatura del dashcam viene cambiato a \"Temperatura elevata\". La telecamera posteriore riprenderà a registrare dopo che lo stato di temperatura del dashcam viene cambiato a \"Temperatura normale\". (Attenzione: Al fine di proteggere l'elettronica, Blackvue potrebbe spegnersi a causa di temperature esterne elevate.)",
	"Get Unlimited Cloud_": "Ottieni la riproduzione cloud illimitata e gestisci fino a {{a}} telecamere.",
	"Up to N cameras_": "Up to {{a}} cameras (+ {{b}} USD Extra charge)",
	"N Minutes per Day": "{{a}} minuti al giorno",
	"Drowsiness sensitivity is_": "La sensibilità della guida in stato di Sonnolenza viene impostata sul battito degli occhi con un algoritmo BlackVue affidabile. <br> <br> La sensibilità della guida Distratta viene impostata in base all'angolo della posizione del capo del conducente rispetto al campo di visione e alla sua durata.",
	"Not available with this plan": "Not available with this plan",
	"The optional camera records_": "La videocamera opzionale registra in modalità parcheggio",
	"Smart and Fleet_": "Smart and Fleet Plan<br/>subscribers only",
	"This feature is_smart": "This feature is available for Smart and Fleet Plan subscribers only.",
	"Camera Registration": "Registrazione telecamera",
	"Voice Call": "Voice Call",
	"N times per Month": "{{a}} times per Month",
	"Recommended for higher bitrate_": "Consigliato per bitrate più elevato e migliore qualità video.",
	"Recommended for for better compatibility_": "Consigliato per una migliore compatibilità con i dispositivi desktop e mobili",
	"A minute of front camera_": "Dimensione del file stimata per video di 1 minuto (fotocamera frontale)",
	"Extreme(N Mbps): N MB_": "Extreme ({{ex1}}Mbps) : {{ex2}}MB\nHighest ({{ht1}}Mbps) : {{ht2}}MB\nHigh ({{hi1}}Mbps) : {{hi2}}MB\nNormal ({{no1}}Mbps) : {{no2}}MB",
	"File size information reflects_": "Le informazioni sulla dimensione del file riflettono la dimensione massima possibile e le dimensioni dei file effettive possono variare a dipendere dalle condizioni di registrazione.",
	Bitrate: Bitrate$9,
	"Connection has been_": "La connessione è stata persa.\nConnessione di ristabilizzazione ...",
	"Unable to establish_": "Impossibile stabilire una connessione con la fotocamera.\nAssicurati che il dispositivo sia correttamente collegato e riprova.",
	"Purchased by Payment Service": "Acquistato dal Servizio di Pagamento",
	"Up to N Cameras": "Fino a {{a}} telecamere",
	"Unlimited Live View": "Visualizzazione live illimitata",
	"N Days GPS Tracking": "Tracciamento GPS per {{a}} giorni",
	"Unlimited Playback and Download": "Riproduzione e download illimitati",
	hours: hours$9,
	"Live Event Upload or_": "Live Event Upload o 12+ video in risoluzione completa",
	"During the usage period of the One Plan_": "Durante il periodo di utilizzo del servizio One Plan, non sono possibili modifiche al piano di abbonamento. Per passare a un piano diverso, contattare l'assistenza clienti di BlackVue per cancellare l'abbonamento a One Plan.",
	"Service Period (Include SIM Data)": "Periodo di servizio (Include dati SIM)",
	"Purchase the BlackVue One Package_": "Acquista il pacchetto BlackVue One per sbloccare gratuitamente One Plan per 1 anno.",
	"3GB SIM Data Plan": "Piano dati SIM da 3GB",
	"Unlimited Live View, Playback and Download": "Visualizzazione, riproduzione e download illimitati",
	"within data availability": "all'interno della disponibilità dei dati",
	"The BlackVue One Plan is a 1-year_": "Il BlackVue One Plan è un piano di servizio cloud di 1 anno accessibile esclusivamente attraverso l'acquisto di un pacchetto BlackVue One, che include una dash cam, un piano dati da 3GB/mese per 1 anno (per USA e Canada) e un piano di servizio cloud per 1 anno.",
	"The BlackVue One Package is available_": "Il pacchetto BlackVue One è disponibile esclusivamente presso il BlackVue Online Store.",
	"Go to BlackVue Shop": "Vai al negozio BlackVue",
	"Anonymous Cam": "Fotocamera anonima",
	"App only": "solo nell'app",
	Expires: Expires$9,
	"N days remaining": "{{a}} giorni rimanenti",
	"No action needed_": "<b>Nessuna azione richiesta.</b> Il nuovo prezzo ridotto sarà applicato automaticamente a partire dal vostro prossimo pagamento dopo il 13 settembre.",
	"The new reduced price_": "Il nuovo prezzo ridotto sarà applicato automaticamente al vostro account.",
	"Smart Plan Subscriber?": "Abbonato al Piano Smart?",
	"Fleet Plan Subscriber?": "Abbonato al Piano Fleet?",
	"Please take a moment to_": "Si prega di prendersi un momento per autorizzarci a migrare il vostro account.",
	"Starting from now and_": "<b>Da ora fino al 31 ottobre</b>, è possibile farci effettuare il cambio per voi <a href=\"https://form.jotform.com/232411253056041\" target=\"_blank\">Cliccando su questo link</a> e inserendo la vostra email dell'account Fleet. Si prega di concederci del tempo per elaborare il cambiamento. In alternativa, sarà possibile annullare il vostro account esistente e riabbonarsi al nuovo prezzo a partire dal 13 settembre.",
	"Once activated_": "Una volta attivato, il One Plan non può essere messo in pausa o disattivato.",
	"Once the One Plan is activated_": "Una volta attivato il One Plan, il One Package non può essere rimborsato.",
	"Up to N Cloud Camera Slot": "Fino a {{a}} slot per telecamera cloud",
	"nGB of Cloud Storage": "{{a}}GB di archiviazione cloud",
	"Get started for free_": "Get started for free, no credit card required. Includes Alert Push Notifications, limited Remote Live View and cloud storage.",
	"The BlackVue One Plan is exclusively_": "The BlackVue One Plan is exclusively available through the purchase of a BlackVue One Package. 3GB/mo data plan is for US and Canada only. BlackVue Cloud’s Free Plan, Lite Plan (1~3) and Smart Plan (1~3) accounts can upgrade to One Plan. However, Lite Plan (4~15), Smart Plan (4~15) and Fleet Plan accounts can not be upgraded to One Plan.",
	"For N year": "For {{a}} year",
	"Included in the One Package": "Included in the One Package",
	"3GB SIM Data Plan for N year": "3GB SIM Data Plan for {{a}} year",
	"One Plan Cloud Service for N year": "One Plan Cloud Service for {{a}} year",
	"The BlackVue One Package includes_": "The BlackVue One Package includes all you need to enjoy BlackVue Cloud for a whole year!",
	"4K LTE Dash Cam_": "4K LTE Dash Cam, Cloud Service and Data Plan",
	"nGB included": "{{a}}GB included",
	"nGB per camera": "{{a}}GB per camera",
	"N Days Live Event Upload": "{{a}} Days Live Event Upload",
	"Up to N Dash Cameras": "Up to {{a}} Dash Cameras",
	"Step N/N": "Passo {{a}}/{{b}}",
	"Cloud Connection": "Connessione al Cloud",
	"To pair your dashcam": "Per abbinare la tua dashcam alla batteria, collegala al Cloud.",
	Check: Check$9,
	"Unpair Battery": "Scollegare la batteria",
	"Are you sure you want to unpair": "Sei sicuro di voler scollegare questa batteria (%@) dalla fotocamera?",
	"Unpair: It doesn't mean": "Scollegare: Non significa eliminare i dati della batteria.",
	"*The paired battery will": "*La batteria abbinata verrà rimossa insieme.",
	"Would you like to pair this": "Vorresti abbinare questa batteria?",
	"Battery successfully paired": "Batteria abbinata con successo.",
	"Now you can directly connect to": "Ora puoi connetterti direttamente alla batteria dall'elenco delle telecamere.",
	"Pairing failed": "L'associazione non è riuscita. Riprova.",
	"Battery Name": "Nome della batteria",
	"Capacity History": "Storico della capacità",
	"The graph displays capacity": "Il grafico mostra un livello approssimativo della batteria utilizzando i dati dalla connessione cloud.\n La capacità della batteria può variare a seconda della temperatura, delle impostazioni della telecamera per cruscotto e della frequenza degli eventi di attivazione.",
	"Last 24 Hours": "Ultime 24 ore",
	"Last 7 Days": "Ultimi 7 giorni",
	"Battery Level": "Livello della batteria",
	"Temperature History": "Cronologia delle temperature",
	"The graph displays temperature": "Il grafico visualizza un livello di temperatura approssimativo utilizzando i dati della connessione cloud.",
	"Temperature Level": "Livello di temperatura",
	"Connecting alert": "[ Connessione ]\nDati visualizzati alla connessione.",
	"Low Output power Alert": "[ Taglio dell'alimentazione in uscita ]\nLa tensione di uscita è troppo bassa, limitando l'alimentazione del dispositivo connesso.",
	"High temp Alert": "[ Taglio di alimentazione in ingresso ]\nLa temperatura della batteria è troppo alta, limitando la ricarica.",
	"Remaining time": "Tempo rimanente",
	"Remaining time estimate": "Il tempo rimanente è una stima basata sul consumo totale di energia dei dispositivi collegati.\n Viene ricalcolato ogni 30 secondi dopo il collegamento alla batteria.",
	"Setting changed": "Modifica impostazione",
	"Setting change failed": "Modifica impostazione fallita",
	"Low Input power Alert": "[ Taglio di alimentazione in ingresso ]\nLa tensione di ricarica è troppo bassa, limitando la ricarica.",
	"High Input power Alert": "[ Taglio di alimentazione in ingresso ]\nLa tensione di carica è troppo alta, limitando la ricarica.",
	"Low temp_Cut off Alert": "[ Taglio di alimentazione in ingresso ]\nLa temperatura della batteria è troppo bassa, limitando la carica e la durata.",
	"Low temp Alert": "[ Bassa temperatura ]\nLa temperatura della batteria è troppo bassa, limitando il tempo di durata e la velocità di ricarica.",
	"Low capacity Alert": "[ Bassa capacità ]\nLa capacità della batteria è troppo bassa.\nGuida l'auto per caricarla.",
	"Back to list": "Torna alla lista",
	Saving: Saving$9,
	Now: Now$9,
	"Power supplying is limited": "L'alimentazione è <b>limitata</b>",
	"This battery is already paired": "Questa batteria è già accoppiata.",
	"Connecting to Battery": "Collegamento alla batteria",
	"Paired battery": "Batteria abbinata",
	"Battery unpairing failed": "Impossibile annullare l'associazione della batteria. Riprova.",
	"A connection is already active": "Una connessione è già attiva. Si prega di riprovare più tardi.",
	"Searching for battery": "Ricerca della batteria",
	"Select battery to pair with your camera": "Seleziona la batteria da abbinare alla tua fotocamera.",
	"Unable to connect": "Impossibile connettersi",
	"A connection error has occurred": "Si è verificato un errore di connessione. Si prega di riprovare.",
	"The paired dashcam has been disconnected": "La dashcam abbinata è stata disconnessa dal Cloud.\nSi prega di controllare le seguenti condizioni.",
	"Check if the battery is not fully discharged": "Controlla se la batteria non è completamente scarica.",
	"Check the Cloud connection of the paired dashcam": "Controlla la connessione Cloud della dashcam abbinata.",
	"Connection lost": "Connessione persa",
	"A connection error has occurred shortly": "Si è verificato un errore di connessione. Si prega di provare a connettersi a breve.",
	"Charging is limited": "La ricarica è <b>limitata</b>",
	"Cannot connect to the battery": "Impossibile connettersi alla batteria.",
	"Please check the Cloud connection of the camera": "Si prega di controllare la connessione Cloud della fotocamera.",
	"Charging complete in": "Carica completa al %@",
	"Current Capacity": "Capacità Attuale",
	"Output Voltage": "Tensione in Uscita",
	"Charging Voltage": "Tensione di Carica",
	Beep: Beep$9,
	"Battery Capacity": "Capacità della batteria",
	"Battery connection failed": "Connessione della batteria non riuscita",
	"Expansion battery": "Batteria di ricambio",
	"Make sure it is switched on and within range": "• Assicurarsi che sia acceso e che si trovi nel raggio d'azione del telefono cellulare.",
	"Make sure it is not wirelessly connected to another device": "• Assicurarsi che non sia collegato in modalità wireless a un altro dispositivo.",
	"Detected batteries": "Rilevate batterie",
	"Can't see your battery": "Non è possibile vedere la batteria?",
	"Download the Blackvue app to check": "Scarica l'app BlackVue per controllare la tua batteria da remoto",
	"By Using the app": "Utilizzando l'app, puoi abbinare la tua telecamera per auto con la batteria e monitorare la capacità della batteria tramite il Cloud. Dopo l'abbinamento, puoi controllare la batteria nel visualizzatore cloud di BlackVue.",
	Unpair: Unpair$9,
	"Occurs when the driver closes_": "Si verifica quando il conducente chiude entrambi gli occhi mentre guida",
	"Occurs when the driver's head_": "Si verifica quando la testa del conducente è più di 50 gradi lontana dalla parte anteriore.",
	"Only detects distraction above_": "Rileva solo distrazione al di sopra del valore impostato. È possibile modificare l'unità in 'Impostazioni videocamera > Attivazione evento > Modulo Guida pericolosa'.",
	"Occurs when the driver is not wearing_": "Si verifica quando il conducente non indossa la cintura di sicurezza.",
	"Overlays a face detection box_": "Sovrapponi una scatola di rilevamento del viso sulle riprese dal vivo e registrate della telecamera DMS.",
	"Seat Belt": "Cintura di sicurezza",
	Detected: Detected$9,
	"No Seat Belt": "Senza cintura di sicurezza",
	"Fatigue Risk Alert": "Avviso di rischio di affaticamento",
	"The time is synchronized_Email": "L'ora è sincronizzata con l'ora nelle tue notifiche via email.",
	"Sends an alert when drowsiness is_": "Invia un avviso quando viene rilevata sonnolenza dopo la sonnolenza iniziale.",
	"Data updates upon connection": "I dati vengono aggiornati alla connessione.",
	"Sends a notification if_": "Invia una notifica se si supera l' 'Imposta ora' durante la guida.",
	"Data updates Alert": "[ Connessione ]\nI dati vengono aggiornati alla connessione.",
	"Cannot save settings": "Impossibile salvare le impostazioni",
	"The time is synchronized_Push": "L'ora è sincronizzata con l'ora nelle tue notifiche Push.",
	"The file has been overwritten or deleted": "Il file è stato sovrascritto o cancellato.",
	"Box Pro Models Settings": "Impostazioni Modelli Box Pro",
	"Push notifications can be configured_": "Le notifiche push possono essere configurate nelle impostazioni di notifica della fotocamera.",
	"Recording Video": "Registrazione Video",
	"Cameras settings": "Impostazioni delle fotocamere",
	"Please configure the settings": "Si prega di configurare le impostazioni",
	"Speed Priorities": "Priorità di velocità",
	"Set Speed Priority": "Impostare la priorità di velocità",
	"Geofence-enter": "Recinto virtuale-entrata",
	"Geofence-exit": "Recinto virtuale-uscita",
	"Geofence-pass": "Recinto virtuale-passaggio",
	"Geofence-speed alert": "Recinto virtuale-Allarme velocità",
	"Drive Position": "Posizione di Guida",
	"Left-Hand Drive": "Guida a Sinistra",
	"Right-Hand Drive": "Guida a Destra",
	"Please configure this setting_": "Modifica questa impostazione se il conducente non viene rilevato correttamente.",
	"A new feature in the BlackVue settings_": "È stata aggiunta una nuova funzionalità nelle impostazioni di BlackVue per sincronizzare l'ora della fotocamera. È necessario sincronizzare l'ora della fotocamera una volta per una registrazione precisa dell'ora.",
	"Feature location_": "Posizione della caratteristica:\nImpostazioni della fotocamera> Sistema> Sincronizzazione dell'ora",
	"Time Sync": "Sincronizzazione temporale",
	"You can sync the time between_": "Puoi sincronizzare l'ora tra il tuo dispositivo e la fotocamera BlackVue. Per la sincronizzazione è necessaria la formattazione della scheda SD. Prima di procedere, eseguire il backup di eventuali video necessari.",
	"Voice Alert": "Avviso vocale",
	"Provides a voice alert_": "Fornisce un avviso vocale dalla telecamera e invia una notifica se superi il tempo impostato durante la guida.",
	"Please enter a value": "Please enter a value.",
	"Notices & Notifications": "Notizie & Notifiche",
	"Only detects drowsiness above_": "Rileva solo sonnolenza al di sopra del valore impostato. È possibile modificare l'unità in 'Impostazioni videocamera > Attivazione evento > Modulo Guida pericolosa'.",
	Promotion: Promotion$9,
	Notice: Notice$9,
	"View More": "Vedi altro",
	"Read More": "Leggi di più",
	"Detection Box": "Scatola di Rilevamento",
	"Seatbelt Detection Box": "Scatola di Rilevamento della Cintura di Sicurezza",
	"Drive Position Detection Box": "Scatola di Rilevamento della Posizione di Guida",
	"Fleet Subscription Promotion (50%)": "Promozione abbonamento flotta (50%)",
	"BlackVue Fleet Tracking exclusive features_": "Funzionalità esclusive di BlackVue Fleet Tracking per utenti esperti e aziende (utenti multipli e telecamere, geofencing, visualizzatore Web ecc.).",
	"Special Discount (50% off)": "Sconto speciale (50% di sconto)",
	"*Promotion applied for 12 months": "*Promozione applicata per 12 mesi",
	"*Payment will be made starting next month.": "*Il pagamento verrà effettuato a partire dal mese prossimo.",
	"[About using promotions]": "[Informazioni sull'utilizzo delle promozioni]",
	"The promotion is free for the first month_": "La promozione è gratuita per il primo mese e poi fatturata per 12 mesi a partire dal mese successivo.",
	"For users with an existing Lite/Smart subscription_": "Per gli utenti con un abbonamento Lite/Smart esistente, è necessario annullare l'abbonamento all'app esistente separatamente, altrimenti l'abbonamento all'app esistente potrebbe essere addebitato sul tuo account.",
	"Please be sure to cancel your app subscription_": "Assicurati di annullare l'abbonamento all'app entro il periodo gratuito. I pagamenti doppi non verranno rimborsati.",
	"You will be changed to Fleet Plan immediately_": "Passerai immediatamente al piano Fleet, anche se il periodo di abbonamento rimanente del tuo piano Lite/Smart esistente non è scaduto.",
	"You can cancel Fleet Plan any time.": "Puoi annullare il piano flotta in qualsiasi momento.",
	"From February 2025, please go to the Fleeta service and use it.": "Una volta annullata la promozione, la promozione non verrà più applicata.",
	"After promotion expires_": "Una volta scaduta la promozione, ti verrà rinnovato automaticamente con la quota di abbonamento al Piano Fleet esistente.",
	"(Required) I have read the promotion instructions_": "(Obbligatorio) Ho letto le istruzioni della promozione e accetto il pagamento.",
	"Upgrade to Fleet Plan immediately": "Passa immediatamente al piano flotta",
	"Important Notice:": "Avviso importante:",
	"Switch of BlackVue Web Viewer to Fleeta Web Viewer": "Passaggio da BlackVue Web Viewer a Fleeta Web Viewer",
	"To provide better features and quality_": "Per fornire funzionalità e qualità migliori, il servizio di visualizzazione web BlackVue passerà presto a un nuovo servizio di visualizzazione web della flotta chiamato Fleeta. I servizi Fleeta saranno esclusivi solo per gli utenti del Piano Fleet. Il servizio Fleeta sarà lanciato a marzo 2025, con una nuova App esclusiva Fleeta. Visita <a href=\"https://www.fleeta.io\" target=\"_blank\">fleeta.io</a> per saperne di più.",
	"We kindly ask for your understanding_": "Chiediamo gentilmente la vostra comprensione, poiché questa modifica ha lo scopo di fornire un servizio migliore. Per qualsiasi domanda riguardante questa transizione, non esitate a contattare il nostro centro CS.",
	"Don’t show this again for this month": "Non mostrarlo più per questo mese",
	"Fleet Plan Subscription Promotion": "Promozione dell'abbonamento al piano flotta",
	"Period : December 2, 2024 ~ May 31, 2025": "Periodo: 2 dicembre 2024 ~ 31 maggio 2025",
	"See more details": "Vedi maggiori dettagli",
	"To continue improve quality and provide better service_": "Per continuare a migliorare la qualità e fornire un servizio migliore, il nostro servizio BlackVue Web Viewer passerà presto a un servizio esclusivo Fleet Plan. Non sarà più disponibile gratuitamente o tramite altri piani a partire dalla fine di marzo 2025.",
	"We have prepared special discount offers for_": "Abbiamo preparato offerte di sconti speciali per i nostri utenti Web Viewer esistenti. Si prega di controllare i dettagli qui sotto! Chiediamo gentilmente la vostra comprensione e supporto mentre implementiamo questa modifica per fornire un servizio migliore.\n",
	"*If you are subscribed in-app_": "*Se sei iscritto in-app, assicurati di annullare l'abbonamento in-app.",
	"Enjoy your BlackVue Cloud service with your dashcam.": "Goditi il ​​tuo servizio BlackVue Cloud con la tua dash cam.",
	"Available Cloud Camera slot(s)_": "Slot per fotocamera cloud disponibili: {{d}}",
	"Not eligible for the promotion.": "Non idoneo alla promozione.",
	"You have already used_": "Hai già utilizzato questa promozione. Una volta annullata, la promozione non può essere riapplicata.",
	"Go to Cameras": "Vai a Fotocamere",
	"Congratulations !": "Congratulations !",
	"Fleet Plan user": "Fleet Plan user",
	"Let your BlackVue monitor_": "Lascia che il tuo BlackVue monitori la tua auto e ti avvisi in caso di incidenti. Nel momento in cui viene rilevato un impatto, il tuo BlackVue invierà una notifica al tuo telefono, accompagnata da un'istantanea.\n",
	"Live Event Upload feature automatically_": "La funzione di caricamento degli eventi dal vivo carica automaticamente le riprese video, comprese le riprese pre-incidente, su BlackVue Cloud Storage per mantenere i tuoi video al sicuro!",
	"*Buffer time varies by model.": "*Il tempo di buffer varia in base al modello.",
	Explore: Explore$9,
	"Cloud Storage": "Archiviazione nel cloud",
	"My Cloud Cameras": "Le mie fotocamere cloud",
	"My Cloud Cameras Only": "Solo le mie fotocamere cloud",
	"BlackVue Live Camera": "Telecamera live BlackVue",
	"*For BlackVue Live Cameras_": "*Per le telecamere BlackVue Live, è possibile visualizzare sulla mappa solo le telecamere condivise come pubbliche nelle impostazioni della telecamera.",
	"*Share Method_": "*Metodo di condivisione: Impostazioni fotocamera>Privacy",
	"Once the promotion is canceled_": "Una volta annullata la promozione, la promozione non verrà più applicata.",
	"It will show_": "Si presenterà qui man mano che diventano disponibili.",
	"Deactivate Cloud": "Disattiva il cloud",
	"Are you sure you want to deactivate_": "Sei sicuro di voler disattivare il Cloud per questa fotocamera?",
	"Deactivate : It doesn’t_": "Puoi sempre attivare il cloud in qualsiasi momento. La fotocamera può essere eliminata una volta completata la disattivazione.",
	Deactivate: Deactivate$9,
	"*If you made the payment through_": "*Se hai effettuato il pagamento tramite l'app, riavvia l'app.",
	"Connect Dashcam Locally (Wi-Fi)": "Connetti la Dashcam localmente (Wi-Fi)",
	"Cloud Connection Setting": "Impostazione della connessione cloud",
	"Camera Profile": "Profilo della telecamera",
	"Camera Settings": "Impostazioni videocamera",
	"Format MicroSD Card": "Formattazione scheda microSD",
	"Remote Firmware Update": "Aggiornamento firmware remoto",
	"Remove from Cloud": "Rimuovi dal cloud",
	"The location may not be accurate_": "La posizione potrebbe non essere precisa perché la fotocamera non è connessa al cloud.",
	"The location of the camera cannot be found_": "Impossibile trovare la posizione della telecamera. Controlla le impostazioni della connessione cloud.",
	"Manage\nFLEETA Drive": "Gestisci\nFLEETA Archivio",
	"Cloud\nConnection": "Connessione\ncloud",
	"Available on FLEETA App": "Disponibile sull'app FLEETA",
	"Available for Cloud dashcam OR on FLEETA App.": "Disponibile per la dashcam Cloud O sull'app FLEETA.",
	"Get started with_": "Inizia con una prova gratuita di 1 mese",
	"Experience all of_": "Prova tutte le funzionalità premium di FLEETA gratuitamente durante il tuo periodo di prova di 1 mese.\n\nNessun impegno—cancella in qualsiasi momento",
	"Welcome to FLEETA Webviewer.": "Benvenuto in FLEETA Webviewer.",
	"Let FLEETA get_": "Lascia che FLEETA ti conosca",
	"Help improve your_": "Aiuta a migliorare la tua esperienza condividendo alcuni dettagli",
	"Business Industry": "Settore aziendale",
	"Vehicle & Cargo": "Veicoli e Carico",
	Compliance: Compliance$9,
	"Would you like to skip?": "Vuoi saltare?",
	"What is your business industry?": "Qual è il settore della tua attività?",
	"Transportation & Logistics": "Trasporto e Logistica",
	"Rental & Leasing": "Noleggio e Leasing",
	"Construction & Building": "Costruzione e Edilizia",
	"Government & Public": "Governo e Pubblico",
	"Facility & Utility Management": "Gestione delle Strutture e Servizi",
	Manufacturing: Manufacturing$9,
	"Retail & Wholesale": "Vendita al Dettaglio e all’Ingrosso",
	Emergency: Emergency$9,
	Security: Security$9,
	"How many employees do you need to manage?": "Quanti dipendenti devi gestire?",
	"How many vehicles does your company operate?": "Quanti veicoli opera la tua azienda?",
	"Why do you use a fleet tracking service?": "Perché utilizzi un servizio di tracciamento flotte?",
	"Route Tracking": "Tracciamento percorso",
	"Real-time Monitoring": "Monitoraggio in tempo reale",
	"Incident Detection & Check video": "Rilevamento incidenti e verifica video",
	"Behavior Monitoring & Analysis": "Monitoraggio e analisi del comportamento",
	"Evaluation & Management": "Valutazione e gestione",
	"Theft Prevention": "Prevenzione dei furti",
	"Monitoring & Maintenance": "Monitoraggio e manutenzione",
	"Verification & Management": "Verifica e gestione",
	"BlackVue App Use Only": "Uso esclusivo per l'app BlackVue",
	"Your current plan allow_": "Il tuo piano attuale consente l'uso dell'app BlackVue. Per utilizzare il Visualizzatore Web, iscriviti al Piano Flotta (FLEETA).",
	"Learn more about the Fleet_": "Scopri di più sul Piano Flotta (FLEETA)",
	"Special Offer": "Offerta Speciale",
	"For a limited time_": "Per un periodo limitato, goditi il 50% di sconto sul tuo abbonamento al Piano Flotta.",
	"See Discount Details": "Vedi dettagli dello sconto",
	"To subscribe to the Fleet_": "Per sottoscrivere il Piano Flotta, si prega di cancellare prima l'abbonamento BlackVue nell'app per evitare addebiti duplicati.",
	"Skip tour": "Salta tour",
	"In the cloud_": "Nell'ambiente cloud, puoi accedere a riproduzione, guarda in diretta (inclusa la multivisualizzazione), GPS in diretta e rapporti, tutto tramite il Visualizzatore Web FLEETA.",
	"Cloud Storage is_": "L'Archiviazione cloud è il luogo dove i tuoi video caricati sono conservati in modo sicuro nel cloud. Carica i tuoi video per mantenerli al sicuro per lungo tempo.",
	"Toggle to switch_": "Attiva per passare da Mappa / Lista",
	"In List View_": "Nella vista elenco, puoi visualizzare e gestire facilmente gruppi, membri e informazioni sul firmware a colpo d'occhio.",
	"What is Cloud Storage?": "Cos'è l'Archiviazione cloud?",
	"Cloud Storage Overview": "Panoramica dell'Archiviazione cloud",
	"Difference Between FLEETA_": "Differenza tra FLEETA Archivio e Caricamento di eventi dal vivo",
	"FLEETA Drive stores_": "FLEETA Archivio memorizza i video che hai caricato manualmente",
	"Live Event Upload automatically_": "Caricamento di eventi dal vivo memorizza automaticamente i video quando si verifica un evento.",
	"Live Event Upload videos_": "I video di Caricamento di eventi dal vivo hanno un periodo di scadenza. Se desideri conservarli a lungo, spostali su FLEETA Archivio.",
	"Note: SD Card_": "Nota: Video su scheda SD in Riproduzione",
	"Videos stored on_": "I video memorizzati sulla tua scheda SD possono essere accessibili tramite il menu Riproduzione.",
	"Set your image_": "Imposta la tua immagine utilizzando la cornice fornita. Una volta salvata l'immagine, verrà visualizzata nella scheda della fotocamera e nell'icona della vista mappa.",
	"*Only jpg and_": "*Sono supportati solo file jpg e png.",
	"Set as default image": "Imposta come immagine predefinita",
	"Camera Details": "Dettagli della telecamera",
	"IT & Telecommunications": "IT e Telecomunicazioni",
	"The name must_32": "Il nome deve avere una lunghezza compresa fra 1 e 32 caratteri.",
	"Unable to display the map.": "Impossibile visualizzare la mappa.",
	"The camera location cannot be found_": "La posizione della telecamera non può essere trovata a causa di una cattiva connessione GPS.",
	"Cloud Cameras": "Telecamere cloud",
	"Want to unlock_": "Vuoi sbloccare le funzionalità di gestione flotta?",
	"*Web subscription only": "*Solo abbonamento Web",
	"Uploads event_": "Carica immediatamente le riprese dell'evento sull'Archiviazione cloud non appena si verifica l'evento.",
	"Starts a conversation_": "Avvia una conversazione con il conducente utilizzando l'altoparlante e il microfono della dashcam.",
	"Remotely check_": "Controlla da remoto il livello e lo stato della batteria tramite il cloud.",
	"Receive a voice_": "Ricevi un avviso vocale e notifiche se il tempo di guida supera il limite.",
	"View your_": "Visualizza il tuo registro di guida sulla mappa.",
	"View speed, event_": "Visualizza velocità, tipo di evento e riproduci video correlati direttamente sulla mappa.",
	"FLEETA Tracking exclusive_": "FLEETA Tracking offre funzionalità esclusive sia per utenti avanzati che per aziende (Più utenti e telecamere, geofencing, ecc.).",
	"Cloud Cameras per Account": "Telecamere cloud per account",
	"Connect Dashcam Locally_": "Collegare la Dashcam localmente (Wi-Fi) (Riproduzione, Download, Guarda in diretta)",
	"Available with_": "Disponibile con batteria BlackVue",
	"Cloud Battery": "Batteria cloud",
	"Driving Reports": "Rapporti di guida",
	"Video on Map": "Video sulla mappa",
	"Multi Live View (Fleeta Web Viewer)": "Vista Live Multipla (Visualizzatore Web FLEETA)",
	"Enter a number": "Inserisci un numero",
	"Permission required.": "Autorizzazione richiesta.",
	"Please contact_": "Si prega di contattare il proprietario per assistenza.",
	"Access not available": "Accesso non disponibile.",
	"This file cannot be deleted now.": "Questo file non può essere cancellato ora.",
	"Please try again later.": "Si prega di riprovare più tardi.",
	"Permission required.\nPlease_": "Autorizzazione richiesta.\nSi prega di contattare il proprietario per assistenza.",
	"Cloud Storage is disconnected_": "Archiviazione cloud è disconnessa. Si prega di controllare la connessione.",
	"Manage the plan_": "Gestire il piano per ripristinare la telecamera",
	"Notify the owner_": "Notifica al proprietario di gestire il piano",
	"Access Restricted:_": "Accesso Limitato: Abbonamento Scaduto",
	"Access is currently_": "L'accesso non è attualmente disponibile a causa di un abbonamento scaduto.",
	"Please contact your owner_": "Si prega di contattare il proprio proprietario per risolvere questo problema.",
	"Access will be_": "L'accesso verrà ripristinato una volta rinnovato l'abbonamento",
	"Cloud is disconnected_": "Archiviazione cloud è disconnessa. \nSi prega di controllare la connessione.",
	"Connect to Cloud with_": "Connettiti all'Archiviazione cloud con l'APP FLEETA",
	"Using Wi-Fi Hotspot": "Utilizzo del hotspot Wi-Fi",
	Important: Important$9,
	"Pre-Event buffer_": "La registrazione del buffer pre-evento è disabilitata in questa modalità.",
	"connectivity is_": "La connettività è limitata in questa modalità.",
	"video upload starts_": "Il caricamento del video inizia dopo il completamento della registrazione.",
	"Power Saving": "Risparmio energetico",
	"In all modes_": "In tutte le modalità, gli impatti rilevati attivano le registrazioni video degli Eventi.",
	"Battery Protection setting _": "L'impostazione di Protezione della Batteria deve essere ATTIVA.",
	"At least one of_": "Almeno una delle seguenti impostazioni deve essere abilitata",
	or: or$9,
	"For BlackVue battery users": "Per gli utenti della batteria BlackVue",
	"we recommend setting_": "Consigliamo di impostare il taglio della tensione al valore minimo per massimizzare l'uso della batteria.",
	"No videos were found.": "Non sono stati trovati video.",
	"Try different filter_": "Prova un filtro diverso o reimposta il filtro.",
	"Not avaliable with_": "Non disponibile con la telecamera corrente",
	"Overlays a detection_": "Sovrappone un riquadro di rilevamento sulle riprese dal vivo e registrate della telecamera DMS.",
	"A minute of_": "Un minuto di video dalla telecamera frontale sarà approssimativamente",
	"System voice guidance": "Guida vocale del sistema",
	"Recording trigger": "Trigger di registrazione",
	"Remote Button (Optional)": "Pulsante remoto (Opzionale)",
	"Remote button settings_": "Le impostazioni dei pulsanti remoti non possono essere modificate tramite connessione cloud. Per modificare queste impostazioni, naviga in Fotocamera > Connetti localmente > Impostazioni fotocamera.",
	"No Registered Device": "Nessun dispositivo registrato",
	"Subscription process is complete": "Il processo di sottoscrizione è completo",
	"Now, go back to_": "Ora, torna all'app FLEETA, accedi al tuo account e inizia a goderti il servizio.",
	"You can check the upload progress": "Puoi controllare il progresso dell'upload nella scheda Archiviazione cloud > FLEETA Archivio.",
	"SIM card must be inserted in_": "La scheda SIM deve essere inserita nella fotocamera per iniziare a utilizzare Cloud.",
	"Active until:": "Attivo fino al:",
	Subscribe: Subscribe$9,
	"Camera PSN": "PSN della fotocamera",
	"BlackVue Sim Free Trial Started!": "Iniziata la prova gratuita di BlackVue Sim!",
	"Enjoy a free period to use your SIM_": "Goditi un periodo gratuito per utilizzare la tua SIM senza abbonamento!",
	"You can stay connected during the trial_": "Puoi restare connesso durante la prova, ma ricorda:",
	"Complete your subscription before the trial_": "Completa l'abbonamento prima della fine del periodo di prova per continuare a utilizzare la SIM.",
	"If you don't subscribe by the end of the trial_": "Se non ti abboni entro la fine del periodo di prova, il servizio SIM verrà disattivato.",
	"Save Event Videos_": "Salva i video degli eventi nel cloud storage in tempo reale!",
	"Note: Deleting your account doesn’t cancel": "Nota: Cancellare il tuo account non annulla il tuo abbonamento. Per annullare, vai su Account > Abbonamento sul visualizzatore web di FLEETA.",
	"Available only on FLEETA App for_": "Disponibile solo sull'app FLEETA per questo modello.",
	"The cloud is deactivated": "Il cloud è disattivato.",
	"Please add a camera with FLEETA_": "Si prega di aggiungere una telecamera con l'APP FLEETA per utilizzare questa funzione.",
	"Upload videos to FLEETA_": "Carica i video su FLEETA Archivio e tienili al sicuro!",
	"You have no assigned camera_": "Non hai nessuna telecamera assegnata.\nContatta il proprietario per richiedere l'assegnazione.",
	"Camera notification settings": "Impostazioni di notifica della telecamera",
	Vehicle: Vehicle$9,
	"App Download": "Scarica l'app",
	"Have a problem with_": "Hai un problema con l'abbonamento?",
	"Restore Purchase": "Ripristina acquisto",
	"Battery Pairing": "Accoppiamento batteria",
	"Playback\nLive View": "Riproduzione/\nVista dal vivo",
	"Remote Playback": "Riproduzione remota",
	"Cloud connection settings": "Impostazioni connessione cloud",
	"Go to settings": "Accedere a impostazioni",
	"Only cloud cameras that_": "Solo le telecamere cloud che gli utenti scelgono di condividere pubblicamente vengono mostrate sulla mappa.",
	"Live Broadcast Cameras": "Telecamere per la trasmissione in diretta",
	"*Live Broadcast Cameras_": "*Le telecamere di trasmissione in diretta sono telecamere cloud impostate per la trasmissione dagli utenti.",
	"Only cloud cameras_": "Sulla mappa vengono mostrate solo le telecamere cloud che gli utenti scelgono di trasmettere."
};

var Dashboard$8 = "ダッシュボード";
var Account$8 = "アカウント";
var Help$8 = "お知らせ";
var Mac$8 = "Mac";
var Windows$8 = "Windows";
var Admin$8 = "サブマスター";
var Driver$8 = "ユーザー";
var Cameras$8 = "カメラ";
var Manage$8 = "管理";
var Clear$8 = "初期化";
var Show$8 = "表示";
var GB$8 = "{{a}}GB";
var _section$8 = "で可能となります。";
var Name$8 = "名前";
var Password$8 = "パスワード";
var Cancel$8 = "キャンセル";
var Members$8 = "メンバーズ";
var Groups$8 = "グループ";
var Role$8 = "役割";
var Group$8 = "グループ";
var Status$8 = "ステータス";
var nPM$8 = "%@ {{a}}, {{a}} {{a}}:{{a}} PM";
var nAM$8 = "%@ {{a}}, {{a}} {{a}}:{{a}} AM";
var Newest$8 = "最新";
var Oldest$8 = "最も古い";
var Accepted$8 = "受け入れ";
var Pending$8 = "保留";
var Expired$8 = "期限切れ";
var All$8 = "すべて";
var Delete_$8 = "{{b}}削除";
var Delete$8 = "削除";
var Rename$8 = "名前の変更";
var Add$8 = "追加";
var OK$8 = "OK";
var Remove$8 = "除去";
var Files$8 = "ファイル";
var Features$8 = "特徴";
var Settings$8 = "設定";
var Upload$8 = "アップロード";
var Privacy$8 = "プライバシー設定";
var Done$8 = "終了";
var Subscription$8 = "申請";
var Submasters$8 = "サブマスター";
var Users$8 = "ユーザー";
var Change$8 = "変更";
var Method$8 = "方法";
var Details$8 = "カメラ情報";
var Confirm$8 = "確認";
var Address$8 = "住所";
var Country$8 = "国";
var State$8 = "状態";
var ZIP$8 = "ジッパー";
var Pricing$8 = "プライス";
var Free$8 = "Free";
var Smart$8 = "Smart";
var Fleet$8 = "Fleet";
var Subscrubed$8 = "サブスクリプション済み";
var January$8 = "1月";
var February$8 = "2月";
var March$8 = "3月";
var April$8 = "4月";
var May$8 = "5月";
var June$8 = "6月";
var July$8 = "7月";
var August$8 = "8月";
var September$8 = "9月";
var October$8 = "10月";
var November$8 = "11月";
var December$8 = "12月";
var Blackvuecloud_$8 = "Blackvuecloud.com";
var Support$8 = "サポート";
var Community$8 = "コミュニティ";
var FAQ$8 = "FAQ";
var Developers$8 = "デベロッパー";
var Facebook$8 = "Facebook";
var Twitter$8 = "ツイッター";
var Instagram$8 = "インスタグラム";
var Youtube$8 = "YouTube";
var Linkedin$8 = "リンクトイン";
var Downloads$8 = "ダウンロード";
var Unauthorized$8 = "承認されませんでした。";
var none$8 = "None";
var Email$8 = "メールアドレス";
var Customers$8 = "カスタマー";
var Home$8 = "ホーム";
var Plan$8 = "プラン";
var New$8 = "新規";
var Unsubscribed$8 = "サブスクリプション解除";
var Edit$8 = "編集";
var month$8 = "月";
var months$8 = "月";
var Continue$8 = "続き";
var Back$8 = "以前";
var Master$8 = "管理者";
var Develop$8 = "開発";
var $9$8 = "9ドル";
var $15$8 = "15ドル";
var $10$8 = "10ドル";
var mo$8 = "月";
var City$8 = "都市";
var Charge$8 = "クラウド使用量のチャージ";
var subscribe$8 = "サブスクリプション";
var search$8 = "検索";
var invalid_number$8 = "クレジットカードのナンバーが有効ではありません";
var invalid_expiry_month$8 = "クレジットカードの月の期限が有効ではありません";
var invalid_expiry_year$8 = "クレジットカードの年の期限が有効ではありません";
var invalid_cvc$8 = "クレジットカードのセキュリティコードが有効ではありません";
var incorrect_number$8 = "クレジットカードのナンバーが間違っています";
var incomplete_number$8 = "クレジットカードのナンバーが不完全になっています";
var incomplete_cvc$8 = "クレジットカードのセキュリティコードが不完全になっています";
var incomplete_expiry$8 = "クレジットカードの有効期限を不完全になっています";
var expired_card$8 = "クレジットカードの有効期限が切れました";
var incorrect_cvc$8 = "クレジットカードのセキュリティコードが正しくありません";
var incorrect_zip$8 = "クレジットカードの郵便番号が確認に失敗しました";
var invalid_expiry_year_past$8 = "クレジットカードの有効期限が過去になっています";
var card_declined$8 = "クレジットカードの承認に拒否されました";
var missing$8 = "お客様に課金されているカードがありません";
var processing_error$8 = "クレジットカードの処理中にエラーが発生しました";
var Paypal$8 = "Paypal";
var iOS$8 = "iOS";
var Android$8 = "Android";
var Total$8 = "合計";
var And$8 = "そして";
var Camera$8 = "カメラ";
var Yes$8 = "はい";
var No$8 = "いいえ";
var News$8 = "ニュース";
var Notifications$8 = "通知";
var MPH$8 = "MPH";
var Firmware$8 = "ファームウェア";
var Basic$8 = "基本";
var Resolution$8 = "解像度";
var Brightness$8 = "明るさ";
var Recording$8 = "録画";
var Highest$8 = "最高";
var High$8 = "高";
var Normal$8 = "普通";
var Sensitivity$8 = "感度";
var Volume$8 = "ガイダンス音量";
var Close$8 = "閉じる";
var Cloud$8 = "Cloud";
var Public$8 = "公開設定";
var Front$8 = "フロント";
var Rear$8 = "リア";
var Play$8 = "再生";
var Stop$8 = "停止";
var Pause$8 = "一時停止";
var Time$8 = "時間";
var System$8 = "システム";
var Event$8 = "イベント録画";
var Parking$8 = "駐車録画";
var Color$8 = "色";
var Exit$8 = "終了";
var Save$8 = "保存";
var Impact$8 = "衝撃";
var Unlimited$8 = "無制限";
var Default$8 = "初期設定";
var Version$8 = "バージョン";
var Language$8 = "言語";
var Notification$8 = "お知らせ";
var Multiple$8 = "多種選択";
var Range$8 = "GPSトラッキング範囲";
var Download$8 = "ダウンロード";
var Manual$8 = "手動録画";
var Satellite$8 = "人工衛星";
var Tutorials$8 = "チュートリアル";
var Filter$8 = "フィルタ";
var Sun$8 = "日";
var Mon$8 = "月";
var Tue$8 = "火";
var Wed$8 = "水";
var Thu$8 = "木";
var Fri$8 = "金";
var Sat$8 = "土";
var Dates$8 = "日付";
var Routes$8 = "Routes";
var Opacity$8 = "不透明度";
var Entry$8 = "エントリ";
var Owner$8 = "オーナー";
var Undetected$8 = "運転者未感知";
var Distracted$8 = "注意散漫";
var Drowsy$8 = "居眠り運転";
var Calling$8 = "通話";
var Smoking$8 = "喫煙";
var Permissions$8 = "権限";
var Private$8 = "非公開";
var Entering$8 = "進入";
var Exiting$8 = "退出";
var Acceleration$8 = "急加速";
var Passing$8 = "通過";
var Overspeed$8 = "速度超過";
var Recipients$8 = "受信者";
var Send$8 = "送信";
var Note$8 = "お知らせ";
var Video$8 = "映像";
var Advanced$8 = "詳細";
var Voice$8 = "音声";
var Days_$8 = "日";
var Mute$8 = "ミュート";
var UnMute$8 = "ミュート解除";
var Discard$8 = "破棄";
var Report$8 = "レポート";
var Individual$8 = "運転中のご安心をお探しの個人のお客様ですか。それともシンプルな車両セキュリティと管理ソリューションをお探しの法人のお客様でしょうか。";
var Subscribed$8 = "購入済み";
var Geofence$8 = "ジオフェンス";
var Driving$8 = "走行";
var Idling$8 = "停車";
var Distance$8 = "距離";
var Parked$8 = "駐車";
var Speed$8 = "速度";
var Highest_2$8 = "最高";
var Average$8 = "平均";
var Geofences$8 = "ジオフェンス";
var Move$8 = "移動";
var Connected$8 = "接続";
var Individual_$8 = "個人";
var Always$8 = "常時録画と駐車録画";
var Low$8 = "低";
var Medium$8 = "中";
var High_2$8 = "高";
var Flip$8 = "反転";
var Previous$8 = "前のフレーム";
var Next$8 = "次";
var Expand$8 = "展開する";
var Collapse$8 = "折りたたむ";
var More$8 = "追加";
var Multi$8 = "マルチ";
var Safe$8 = "安全";
var Reckless$8 = "危険";
var Inattentive$8 = "不注意";
var List$8 = "リスト";
var Usage$8 = "使用方法";
var Profile$8 = "プロファイル";
var Fullscreen$8 = "全画面";
var Upgrade$8 = "アップグレード";
var Management$8 = "管理";
var Day$8 = "日";
var Month$8 = "月";
var Later$8 = "後ほど";
var ICCID$8 = "ICCID";
var Resubscribe$8 = "再購読";
var plan$8 = "プラン";
var USD$8 = "米ドル";
var etc_$8 = "その他：";
var Available$8 = "利用可能";
var Used$8 = "使用中";
var Cancelled$8 = "キャンセル済み";
var Terminated$8 = "削除済み";
var Sort$8 = "並べ替え";
var Bonus$8 = "ボーナス";
var incomplete_zip$8 = "クレジットカードの郵便番号が確認に失敗しました";
var Upgrades$8 = "更新";
var OR$8 = "または";
var Undo$8 = "キャンセル";
var Invoice$8 = "請求書";
var data$8 = "データ";
var Popular$8 = "Popular";
var Mask$8 = "マスクオフ";
var DMS$8 = "DMS（ドライバーモニタリングシステム）";
var Extreme$8 = "エクストリーム";
var OFF$8 = "オフ";
var Threshold$8 = "しきい値";
var Drowsiness$8 = "眠気";
var Direct$8 = "ダイレクト";
var Remote$8 = "リモート";
var Update$8 = "アップデート";
var Option$8 = "オプション";
var Required$8 = "必須";
var Optional$8 = "オプション";
var Others$8 = "その他";
var Stay$8 = "保持";
var Mask_2$8 = "Mask";
var Low_2$8 = "Low";
var Medium_2$8 = "Medium";
var High_3$8 = "High";
var Highest_3$8 = "Highest";
var Extreme_2$8 = "Extreme";
var Private_2$8 = "Private";
var Lite$8 = "Lite";
var Bitrate$8 = "ビットレート";
var hours$8 = "時間";
var Expires$8 = "有効期限";
var Check$8 = "チェック";
var Saving$8 = "保存中";
var Now$8 = "今";
var Beep$8 = "警告音";
var Unpair$8 = "ペア解除";
var Detected$8 = "運転者検知";
var Promotion$8 = "プロモーション";
var Notice$8 = "アップデート";
var Explore$8 = "探検する";
var Deactivate$8 = "非アクティブ化";
var Compliance$8 = "法令遵守";
var Manufacturing$8 = "製造業";
var Emergency$8 = "緊急";
var Security$8 = "セキュリティ";
var Important$8 = "重要";
var or$8 = "または";
var Subscribe$8 = "購読する";
var Vehicle$8 = "車両";
var ja = {
	Dashboard: Dashboard$8,
	"Payment & Subscriptions": "決済&サブスクリプション",
	"Fleet Management": "フリートマネジメント",
	"Available to master": "マスタのみ使用可能",
	"Available to Fleet_": "フリートプランユーザのみ使用可能",
	Account: Account$8,
	"Log out": "ログアウト",
	"© 2019 Pittasoft_": "© 2019 Pittasoft Co. Ltd",
	"Privacy policy": "プライバシーポリシー",
	"Terms of service": "利用規約",
	Help: Help$8,
	"App store": "App Store",
	"Google Play": "Google Play",
	Mac: Mac$8,
	Windows: Windows$8,
	"Free Plan": "Free Plan",
	"Basic Plan": "Basic Plan",
	"Smart Plan": "Smart Plan",
	Admin: Admin$8,
	Driver: Driver$8,
	"Period : December 3, 2024 ~ May 31, 2025": "期間：2024年12月3日～2025年5月31日",
	Cameras: Cameras$8,
	"n of n": "{{a}} / {{b}}",
	Manage: Manage$8,
	"Upgrade Plan": "アップグレード予定",
	"Add more cameras_": "カメラ追加、フリートの管理、その他…",
	"Usage statistics": "使用合計",
	"All cameras": "すべてのカメラ",
	Clear: Clear$8,
	Show: Show$8,
	"Live views": "ライブビュー",
	"nh:nm:ns": "{{a}}h:{{b}}m:{{c}}s",
	"Video plays and_": "ビデオ再生およびダウンロード",
	"Space available": "空き領域",
	GB: GB$8,
	"n%": "{{a}}%",
	"BlackVue app for_": "iOSとAndroid用のBlackVueアプリ",
	"BlackVue viewer for_": "MacとWindows用のBlackVueビューアー",
	"Welcome to fleet": "ようこそ、フリートマネジメントへ",
	"A few things_": "その過程で期待できるいくつかの事項:",
	"You can watch_": "ブラックビューアプリやPCビューアから\n 割り当てられたカメラのビデオを見ることができます。",
	"If the master_deletes": "マスターがアカウントを削除すると、あなたのアカウントも\n 削除されます。",
	"If the masters_Fleet": "マスターのフリートプランが満了しても、変わりなく\n 読み込み専用モードでアカウントにアクセスできます。",
	"You have to_": "個人のカメラを追加するには、別のアカウントを作成の上、登録しなければ\n いけません。",
	"The Payments &_": "決済およびサブスクリプション、フリート管理セクションは\n マスターのみ利用できます。",
	"You can manage_": "フリートグループを管理するには",
	"_Fleet management": "フリート管理セクション",
	_section: _section$8,
	"The Payments_section-": "決済およびサブスクリプションセクションはマスターのみ\n 利用できます。",
	"Youre almost there": "後少しで設定完了となります。",
	"Finish account setup": "アカウント設定完了",
	"Install and log_": "BlackVueアプリまたはPCビューアーのインストール\n およびログイン",
	"Download on the_": "App Storeからダウンロード",
	"GET IT ON_": "Google Playストアからダウンロード",
	"Download for Mac": "Mac用でダウンロード",
	"Download for Windows": "Windows用でダウンロード",
	"Add your camera_": "BlackVueアプリまたはPCビューアでカメラを追加する。",
	"Start managing your_": "フリート管理の開始および使用状況の確認",
	"Cancelled Fleet Plan_": "{{a}}にフリートプランがキャンセルされました。",
	"The new plan_": "新しいプランは現在のプランの請求期間が終わった後から有効となります",
	"Profile photo": "プロフィール写真",
	Name: Name$8,
	"E-mail address": "メールアドレス",
	Password: Password$8,
	"Last changed_": "最後に変更された{{a}}",
	"Change password": "パスワード変更",
	"Delete account": "アカウントの削除",
	Cancel: Cancel$8,
	"Current password": "現在のパスワード",
	"New password": "新しいパスワード",
	"Confirm new password": "新しいパスワードを確認する",
	"Password changed": "パスワードの変更完了",
	"Reason for deletion_": "削除理由(オプション)",
	"Account password": "アカウントのパスワード",
	Members: Members$8,
	Groups: Groups$8,
	"+ Invite member": "+メンバーを招待する",
	"Name, Email": "お名前、メールアドレス",
	Role: Role$8,
	Group: Group$8,
	"Date invited": "招待された日付",
	Status: Status$8,
	"Group n": "グループ{{a}}",
	nPM: nPM$8,
	nAM: nAM$8,
	Newest: Newest$8,
	Oldest: Oldest$8,
	"Name, email or_": "名前、メールアドレスまたはグループ",
	Accepted: Accepted$8,
	Pending: Pending$8,
	Expired: Expired$8,
	All: All$8,
	"No results": "結果なし",
	"Try different keywords": "他のキーワードで試してみてください。",
	"Try changing or_": "フィルター変更または削除",
	"Remove all filters": "すべてのフィルター削除",
	"Invite member": "メンバーを招待する。",
	"Send invite": "招待状の送信",
	"You have reached_": "あなたは10個のサブマスター限度に到達しました。\n 続いてユーザーを招待できます。",
	Delete_: Delete_$8,
	"Are you sure_delete": "このメンバーとアカウントを削除しますか?",
	Delete: Delete$8,
	Rename: Rename$8,
	"No submaster yet": "まだサブマスターが登録されていません。",
	"You can add_": "グループ当たり1つのサブマスターが追加できます。",
	"No cameras yet": "まだカメラが登録されていません。",
	"Add cameras first_": "まずはカメラを追加、その後のユーザー割り当て",
	"Name or email": "名前またはメールアドレス",
	"Add submaster": "サブマスターの追加",
	Add: Add$8,
	"Add camera": "カメラ追加",
	"n of n selected": "{{b}}個の中から{{a}}個選択されました",
	"No cameras available": "使用できるカメラがありません。",
	"Most likely reasons_": "もっともらしい理由は:",
	"All cameras were_": "全てのカメラが他のグループに追加されたことであります。",
	"You can remove_": "他のグループのカメラを削除してからこのグループに追加できます。",
	"No cameras were_": "現在、あなたのアカウントにカメラが追加されていません。",
	"You can add_cameras": "BlackVueアプリやPCビューアからカメラを追加できる。",
	OK: OK$8,
	"Rename group": "グループ名の変更",
	"Are you sure_group": "このグループを削除しますか?",
	"Edit Mobile app_": "モバイルアプリ/PCビューア使用の権限編集",
	Remove: Remove$8,
	"n of n users": "{{a}}名のユーザー",
	"Youve reached the_": "カメラ別ユーザー制限に達しました。",
	"Remove user": "ユーザー削除",
	"Add user": "ユーザー追加",
	"+ Add group": "+グループの追加",
	"Add group": "グループの追加",
	"Group or submaster": "グループまたはサブマスター",
	"+ Add": "+追加",
	"of max selected": "最大{{a}}個の中から{{b}}個選択可能",
	"Mobile app/desktop_": "モバイルアプリ/PCビューア使用権限",
	Files: Files$8,
	Features: Features$8,
	Settings: Settings$8,
	Upload: Upload$8,
	"Download and Playback_Cloud": "クラウドストレージからダウンロード・ビデオ再生",
	"Download and Playback_SD": "SDカードからダウンロード・ビデオ再生",
	"Live view": "ライブビュー",
	"Geo Fencing": "ジオフェンシング",
	"Drive Reports": "ドライブレポート",
	"Firmware Settings": "ファームウェアの設定",
	"Push Notifications": "プッシュ通知",
	"Event Auto Upload": "イベント自動アップロード",
	Privacy: Privacy$8,
	Done: Done$8,
	"Payment method": "決済方法",
	"Change payment method": "お支払方法を変更する",
	Subscription: Subscription$8,
	"Space used": "使用されたストレージ",
	"Next billing_": "次の請求書{{a}} {{b}}",
	"You manage_available": "お持ちのプランで{{a}}個/{{b}}個を使用可能となっています。",
	Submasters: Submasters$8,
	Users: Users$8,
	Change: Change$8,
	"No transactions yet_": "お客様はすでにフリープランに登録されています。取引がまだありません",
	"No transactions to_": "表示する取引がありません。<br/>他のプラットフォーム（iOS、Android、PayPalなど）の取引履歴をお探しの場合は、ご利用のプラットフォームのサブスクリプションページで履歴を確認できます。",
	"of nGB_": "{{a}}/{{b}}GB({{c}}%)",
	"Smart Plan users_": "スマートプランのユーザーは、BlackVueモバイルアプリで\n プラン変更およびカメラ台数を変更できます。",
	"Transaction history": "取引履歴",
	"Date": "日付",
	"Amount, USD": "金額、USD",
	Method: Method$8,
	Details: Details$8,
	"iOS in-app_": "iOSインアプリ購入/Androidインアプリ購入",
	"Change the number_": "カメラ台数変更",
	"You manage_cameras": "登録可能な{{b}}台のカメラの中で、{{a}}台を使用しています。",
	"Extra cameras": "追加カメラ登録 +$9",
	"Total due_": "使用可能な期限",
	"available on your_": "使用可能なカメラ台数{{a}}台",
	"Cancel Fleet Plan": "フリートプランをキャンセルする。",
	"This will cancel_": "フリートプランへの登録が取り消される。 \n 請求周期が終わったら無料プランにダウングレードされます。",
	"Reason for cancellation_": "キャンセル理由(オプション)",
	"Not now": "キャンセル",
	Confirm: Confirm$8,
	"Cardholder name": "カードホルダー名",
	"Card name": "カード名",
	"MM/YY": "MM/YY",
	Address: Address$8,
	Country: Country$8,
	State: State$8,
	ZIP: ZIP$8,
	Pricing: Pricing$8,
	"You are subscribed_": "BlacVue Cloudの無料プランにご登録しました。",
	"With Alert Push_": "プッシュ通知、制限されたリモートライブビュー\n およびクラウドストレージ",
	Free: Free$8,
	Smart: Smart$8,
	Fleet: Fleet$8,
	"Get started for_": "クレジットカードなしで無料で体験してください。 \n \nプッシュ通知、制限されたリモートライブビューおよびクラウドストレージを含む。",
	Subscrubed: Subscrubed$8,
	"Features included:": "含まれた機能:",
	"Get unlimited Remote_": "リモートライブビュー、クラウド再生を無制限に利用し、\n 最大{{a}}台のカメラを管理してください。 \n \n In-appのサブスクリプションのみ",
	"BlackVue Fleet Tracking_": "BlackVueフリートトラッキングはプレミアムユーザーとフリート管理者のための機能であり、(マルチユーザーとカメラ、ジオフェンシングなど)ウェブサイトでサブスクリプションの申し込みすることができです。",
	"Try 1 Month Free": "1ヵ月間無料体験",
	"Log in": "ログイン",
	"Remember me": "ログイン情報を保存する",
	"Forgot password?": "パスワードをお忘れでしょうか？",
	"Reset password": "パスワードのリセット",
	"Enter email address_": "登録時に入力したメールアドレスを入力するとパスワード再設定ができるリンクが送信されます。",
	"Send reset password_": "パスワード再設定のメール伝送",
	"Back to login": "ログインに戻る",
	"Check your email": "メールをチェックする",
	"Weve sent an_": "We've sent an email to {{a}} with a link to confirm\nyour email address. For security reasons, the link in the email will expire after one hour.",
	"Resend email": "メールを再送信する。",
	January: January$8,
	February: February$8,
	March: March$8,
	April: April$8,
	May: May$8,
	June: June$8,
	July: July$8,
	August: August$8,
	September: September$8,
	October: October$8,
	November: November$8,
	December: December$8,
	"Sign up": "アカウントの作成",
	"First name": "ファーストネーム",
	"Last name": "ラストネーム",
	"Create a password": "パスワードの作成",
	"5 or more_": "５文字以上",
	"Sign up and_": "登録後継続",
	"I agree to_": "%@, %@, %@および%@に同意します。",
	"Subscribe to newsletter": "ニュースレターを購読する",
	"1 month free trial_": "フリートプラン-1ヵ月間の無料体験版",
	"Dont have an_": "アカウントをお持ちでないでしょうか？",
	"Thank you for_": "BlackVue Cloudにご登録いただきありがとうございます。\n メールアドレスをご確認ください。",
	"Confirm email": "メールアドレスの確認",
	"If you didnt_": "もしあなたがこのアカウントを登録していなかった場合、\n あなたはこのメールを無視しても構いません。。",
	Blackvuecloud_: Blackvuecloud_$8,
	"invited you to_": "{{a}}があなたをフリート管理のサブマスターとして招待しました。",
	"Accept invitation": "招待に応じる。",
	"Invite expires on_": "招待の期限切れはmm dd、yyです。",
	"Your Fleet Management_": "{{a}}に登録されたあなたのフリートマネジメント\n のアカウントが%@によって削除されました。",
	"If you believe_": "こちらがエラーだと思うと、当社のお客様サポート\n (cs@blackvue.com)に問い合わせてください。",
	Support: Support$8,
	"Help center": "お客様サポートセンター",
	Community: Community$8,
	"Getting started": "ユーザーマニュアル",
	FAQ: FAQ$8,
	Developers: Developers$8,
	"Cloud API": "クラウドAPI",
	"Fleet SDK": "フリートSDK",
	"Follow us": "フォローする",
	Facebook: Facebook$8,
	Twitter: Twitter$8,
	Instagram: Instagram$8,
	Youtube: Youtube$8,
	Linkedin: Linkedin$8,
	"BlackVue apps": "BlackVueアプリ",
	"Camera registraiton": "カメラ登録",
	"Two-way voice_": "双方向音声通信",
	"Live GPS": "ライブGPS",
	"Event live auto_": "イベントライブを自動アップロード",
	"Event file auto_": "イベントファイルの自動アップロード",
	"Compatible with_": "DR650GW、DR650Sモデルと互換",
	"Not compatible with_": "DR650S、DR650GWモデルと互換されません",
	"More cameras": "より多くのカメラ",
	"More users": "より多くのユーザー",
	"Roles and permissions": "役割と使用権限",
	"More Cloud Storage": "より多くのクラウドストレージ",
	"Multi Live view_": "マルチライブを見る(PCビューア)",
	"Longer GPS Tracking": "さらに長いGPSトラッキング",
	"Geo Fence setup_": "Geo Fence設定(PCビューア)および通知(PCビューアおよびアプリ)",
	"Changes saved": "変更内容を保存します。",
	"Group added": "グループを追加しました。",
	"Member added": "メンバーを追加しました。",
	"Group deleted": "グループを削除しました。",
	"Member deleted": "メンバーを削除しました。",
	"Group renamed": "グループ名を変更しました。",
	"Submaster added": "サブマスターを追加しました。",
	"Camera added": "カメラを追加しました。",
	"User added": "ユーザーを追加しました。",
	"Users added": "ユーザーが追加されました。",
	Downloads: Downloads$8,
	"The BlackVue App_": "BlackVueのアプリおよびPCビューアを通じてBlackVueカメラを最大限に活用できる。 モバイルであるか、パソコンでであるか、BlackVueはドライブレコーダーダッシュカムの機能を十分に楽しめるツールを提供する。",
	"Compatible with all_": "すべてのWi-Fi対応BlackVueモデルと互換可能。",
	"Supports all BlackVue_": "すべてのBlackVueモデルを最新の状態にサポート",
	"confirm new password": "新しいパスワードを確認する",
	"Your password is_": "パスワードが間違っています。",
	"Confirm password does_": "パスワードを確認してください。",
	"Please enter_email": "有効なメールアドレスを入力してください。",
	"Please enter_password": "有効なパスワードを入力して下さい。",
	"Internal server error_": "サーバーエラー。後でもう一度試してください。",
	"New password is_": "新しいパスワードが現在のパスワードと同じです。",
	"It should be_": "5文字以上、30文字以下で入力して下さい",
	"Invalid permission": "権限が与えられていません。",
	"Input data isnt_": "入力したデータを再び確認してください。",
	Unauthorized: Unauthorized$8,
	"Already have subsciption": "すでにご利用中のサブスクリプションを保有しています。",
	"Already uses": "すでにご利用しています。",
	"Already logged in": "すでにログインしています。",
	"Already sent e-mail": "すでにメールが送信されています。",
	"Please wait": "少々お待ちください。",
	"E-mail is not_": "確認されていないメールアドレスです。",
	"Update your subscription_": "サブスクリプションをアップグレードする",
	"Account was deleted": "登録情報が削除されました",
	"5 ~ 30_": "5文字以上、30文字以下",
	"It has exceeded_": "最大登録可能なサブマスター(9個)をうわまっています。",
	"Billing information": "請求情報",
	"Please enter cardName": "Enter card name",
	"Please enter_card": "カード番号を入力してください。",
	"Please enter address": "住所を入力してください。",
	"Please select country": "国家選択",
	"Please enter city": "都市を入力してください。",
	none: none$8,
	"Due today": "本日",
	"Today after 1_": "1カ月間の無料試用",
	"An error occurred_": "パスワード変更中にエラーが発生しました。もう1度試してください。",
	"Your account is_": "アカウントが有効になります。",
	"You can now_": "登録時に入力したメールアドレスでログインできます。",
	Email: Email$8,
	"Don’t have an account?": "アカウントを登録していませんか？",
	"Already have an account?": "すでにアカウントをお持ちでしょうか？",
	"Cloud service": "BlackVue",
	"for your BlackVue": "クラウドサービス",
	"See what your_": "遠隔であなたのカメラを確認できます。",
	"Receive impact alert_": "衝撃検知プッシュ通知を受信します。",
	"Save footage to_": "クラウドにビデオを保存でき、多様な機能をご利用できます",
	"Free plan included_": "フリープランのご利用・楽なセットアップ・キャンセルはいつでもOK",
	"Taking advantage of_": "スマホおよび車に用意されたインターネットを利用してBlackVueカメラに接続します。BlackVueドラレコを通じてどこでも、いつでも車とあなたはつながっています。スマホやタブレットにある BlackVueアプリで車の位置情報や周辺の状態をリアルタイムで確認できます。",
	"Get notifications to_": "駐車中の車が衝撃を受けるとあなたのスマホにプッシュ通知が受信されます。車の周辺状態を遠隔で確認できます。",
	"Monitor your commercial_": "マップ上の商用車両をリアルタイムでモニタリングしてください。BlackVueアプリおよびビューアでいつでもドライバーと会話できます。",
	"With BlackVue Fleet_": "BlackVueフリートトラッキング機能を利用してアプリとビューアで最大100台の車両をリアルタイムでトラッキングできます。",
	"Get started now_": "只今、フリープランでご利用ください。ライブビューおよびビデオ再生を無制限で使うにはサブスクリプションをスマートにアップグレードしてください。<br/>フリートプランをご希望とする管理者はこちらのウェブサイトでフリートプランをサブスクリプションしてください。",
	"Remote Video Playback_": "遠隔映像ファイル再生およびダウンロード",
	"Compatible with DR650GW_": "DR650GW、DR650Sモデルと互換",
	"Unlimited remote video_": "無制限で遠隔ライブビューおよびクラウド再生",
	"Longer cloud storage_": "より長くのストレージ有効期限",
	"Longer storage period_live": "イベントライブ自動アップロードの保存時間が追加されます",
	"Longer storage period_file": "イベントファイル自動アップデートのためのより長くの保存期限",
	"Goefence setup (PC_": "ジオフェンス設定(PC viewer)および通知(PC viewer、アプリ)",
	"App Store": "App Store",
	"Send reset password email": "パスワード再設定のメール伝送",
	Customers: Customers$8,
	Home: Home$8,
	"Pick a plan": "プランを選ぶ",
	"No customers yet": "登録されたカメラがありません。",
	"Customers will_": "カメラが使用可能になるとこちらにリストが現れます。",
	"Add customer": "カスタマーの追加",
	"Report(PDF)": "レポート(PDF)",
	"Subscription Period": "サブスクリプション期限",
	Plan: Plan$8,
	New: New$8,
	Unsubscribed: Unsubscribed$8,
	"Subscription ends soon": "サブスクリプション近いうちに終了になります",
	Edit: Edit$8,
	"1 month trial": "1カ月間の無料試用",
	"Edit customer details": "カスタマー情報を変更",
	"Customer name": "カスタマーのお名前",
	"of 999 available_": "/ 999のフリートプランで利用可能",
	"Subscription starts": "サブスクリプション開始",
	"Subscription period": "サブスクリプション期限",
	month: month$8,
	months: months$8,
	"Cloud storage": "クラウドストレージ",
	"Subscription plan": "ご利用中のプラン",
	"Check email address": "メールアドレスを確認してください",
	"Add customer details": "カスタマー情報を追加",
	Continue: Continue$8,
	Back: Back$8,
	"An error occured": "エラー発生",
	"Customer added": "カスタマー追加",
	"Last changed": "前回の変更",
	"Company name": "会社名",
	"Company address": "会社住所",
	"Alert Push Notifications": "プッシュ通知",
	"Receive notifications on_": "すでに設定されたイベントが発生するとスマートにお知らせをもらいます。BlackVueの駐車録画モードど一緒に利用するのをおすすめします。",
	"Remote Live View": "リモートライブビュー",
	"Remotely monitor your_": "リアルタイムでどこでも、いつでもマイカーのモニタリングができます。",
	"Video Backup/Auto Upload": "ビデオのバックアップ・自動アップロード",
	"Back up videos_": "ビデオをお客様のスマホとクラウドストレージにバックアップします。",
	"Two-way Voice Communication": "双方向音声通信",
	"Talk with people_": "アプリを通じてドライバーと会話できます。ドライバーは運転しながらお互いに会話できます。",
	"View your car’s_": "マップ上の車の位置情報と速度を確認してください。BlackVueフリートトラッキング機能を通じて90日分のGPSデータを検索し、自分のトラッキングルートを一覧できます。",
	"Remote Video Playback": "遠隔ビデオ再生",
	"Play videos stored_": "スマホやタブレットでいつでもクラウドおよびドライブレコーダーに保存された映像が再生できます。",
	"Event Live Auto Upload": "イベントライブを自動アップロード",
	"Save a video stream_": "リアルタイムでクラウドに衝撃映像が保存されます。車両に進入するしたり泥棒からくるまを保護することができます。",
	"Event File Auto Upload": "イベントファイルの自動アップロード",
	"Save Event videos_": "イベントビデオをクラウドに保存します。衝撃発生の前後5秒",
	"Firmware-Over-the-Air (FOTA)": "ファームウェア・オーバー・ザ・エア (FOTA)",
	"Upgrade your dashcam’s": "ドライブレコーダーをアップグレードします。",
	"When an Event_": "イベントが検知されると（衝撃検知およびマニュアル録画）イベントライブ自動アップロードを通じてクラウドサーバーでリアルタイムビデオストリームが保存できます。フロントとリアどちらかを選択できます。",
	"Event File Auto-upload_": "イベントファイル自動アップロードを使用すると、ドライブレコーダーで低解像度のイベントファイルを自動的にクラウドにアップロードできます。",
	Master: Master$8,
	"per Camera": "カメラ当たり",
	"Event live auto upload_": "イベントライブ自動アップロードは全てのクラウドカメラに対応します。",
	"Drive report": "ドライブレポート",
	"USA/Canada Toll Free": "アメリカ・カナダはフリーコール",
	"Monday–Saturday_": "月曜日から金曜日の午前8時から午後7時 / 土曜日の午前9時から午後6時(PST)",
	"Please agree to_": "サービス規約に同意してください。",
	"Mac or Windows PC": "MACまたはWindows PC",
	Develop: Develop$8,
	"Sign out": "サインアウト",
	"Referral code": "おすすめコード",
	"Total after 1 month trial": "1ヶ月の無料試用終了の後のお値段",
	"Already Use Stripe Token": "すでにストライプトークンを使用しています",
	"Select period": "期限を選択してください",
	"State/Region": "州",
	"ZIP/Postal": "郵便番号",
	"$0.00": "0.00ドル",
	"$11.99": "11.99ドル",
	"$24.99": "24.99ドル",
	$9: $9$8,
	$15: $15$8,
	$10: $10$8,
	"mo + for_": "/mo + {{a}} 追加カメラ用",
	mo: mo$8,
	"This e-mail address_": "このメールアドレスはすでに登録済みのアカウントです。",
	"1 month": "1ヶ月",
	"Limit is reset daily": "毎日制限がリセットされます。",
	"Limit is reset monthly": "毎月制限がリセットされます。",
	"Video plays and downloads": "ビデオ再生およびダウンロード",
	"Your master": "管理者",
	"Youre 1 step_": "フリートプランのサブスクリプション終了まであと1ステップ残っています",
	"Finish signing up": "登録完了",
	"Enter billing information": "決裁情報入力",
	"Proceed to billing": "決裁信仰",
	City: City$8,
	Charge: Charge$8,
	"User already invited_": "管理者からすでに招待されています。",
	"n% consumed": "{{a}}% 使用中です",
	"E-mail already exists": "すでに登録されたメールアドレスです。",
	"Cancel your inapp_": "アプリ内のサブスクリプションをキャンセル",
	"You have cancel_": "1. App StoreまたはGoogle Play Storeで現在のサブスクリプションをキャンセルします。 現在の請求サイクル終了の際、自動でフリープランに切り替えします。 すべてのデータはそのまま維持されます。\n 2.BlackVueクラウドのアカウントにログインし、フリートプランにアップグレードしてください。 \"",
	"Edit permissions": "権限の変更",
	"See permissions": "権限のご覧",
	"Submaster removed": "サブマスターの削除完了",
	"Camera removed": "カメラの削除完了",
	"User removed": "ユーザー削除完了",
	"Users removed": "ユーザー (達) 削除完了",
	subscribe: subscribe$8,
	search: search$8,
	"permission can be_": "サブマスターが招待に応じた以後、権限の変更ができます。",
	"The confirmation link_": "確認のリンクが無効になりました",
	"Possible reasons:_": "可能な理由:\n • すでにメールアドレスを確認しました\n • リンクが無効になったか、キャンセルされた",
	"Failed to register_": "BlackVue Cloudに登録不可能",
	"There was an_": "アカウント登録中にエラーが発生しました。\n このエラーが続いて発生する場合、BlackVueにもう1度試してください。\n \n より詳しいサポートが必要な方はお客様サポートにお問い合わせください。",
	"Upgrade to Fleet_": "フリートプランへのアップグレード",
	"Subscription is Canceled": "サブスクリプションがキャンセルされました",
	"No members yet": "まだユーザーが存在していません",
	"Please enter_group name": "有効なグループ名を入力してください",
	"Group Name": "グループ名",
	invalid_number: invalid_number$8,
	invalid_expiry_month: invalid_expiry_month$8,
	invalid_expiry_year: invalid_expiry_year$8,
	invalid_cvc: invalid_cvc$8,
	incorrect_number: incorrect_number$8,
	incomplete_number: incomplete_number$8,
	incomplete_cvc: incomplete_cvc$8,
	incomplete_expiry: incomplete_expiry$8,
	expired_card: expired_card$8,
	incorrect_cvc: incorrect_cvc$8,
	incorrect_zip: incorrect_zip$8,
	invalid_expiry_year_past: invalid_expiry_year_past$8,
	card_declined: card_declined$8,
	missing: missing$8,
	processing_error: processing_error$8,
	"no groups yet": "まだグループが存在していません",
	"groups will show_": "グループが使用可能になると、ここにグループが表示されます。",
	"Fleet members will_": "フリートユーザーが使用可能になると、ここにユーザーが表示されます。",
	"service provider": "サービス提供者",
	Paypal: Paypal$8,
	iOS: iOS$8,
	Android: Android$8,
	"Enter email": "メールアドレスを入力してください",
	"Enter password": "パスワードを入力してください。",
	"Enter first name": "ファーストネームを入力してください",
	"Enter last name": "ラストネームを入力してください",
	"Enter the current_": "現在のパスワードを入力してください",
	"Enter a new_": "新しいパスワードを入力してください",
	"There isnt an_": "すでに登録されているメールアドレスです",
	"Fleet Plan": "Fleet Plan",
	Total: Total$8,
	"Password you entered_": "入力したパスワードが正しくありません",
	"Incorrect email or_": "メールアドレスもしくはパスワードが正しくありません",
	"Available to Masters": "管理者のみ使用可能です",
	"Blackvue url": "https://www.blackvue.com/jp",
	"Information We Collect_": "個人情報の収集範囲と利用目的について",
	And: And$8,
	"Terms of Location-Based_": "位置基盤サービス使用規約に",
	"I agree to the_": "同意します",
	"Password Reset_": "BlackVueは{{a}}にパスワードの再設定方法をメールを送信しました。",
	"You have already_": "すでに招待されています。メールを確認してください。",
	"No data available_": "データ無し",
	Camera: Camera$8,
	"You no longer_": "フリートサービスを利用する権限を失いました。",
	"Please contact your_": "フリートマスターに連絡して問題を解決してください。",
	"You can still_": "アカウント情報には",
	"account information": "アクセスできます。",
	"If the issue_": "問題が解決せず、登録済みのメールアドレスでBlackVue Cloudサービスの利用を継続したい場合は、一旦アカウントを削除してから再度登録する必要があります。",
	"If the problem_": "問題が解決しない場合は、カスタマーサポートにお問い合わせください。",
	"Web subscription only": "Web登録のみ",
	"AppStore url": "https://apps.apple.com/jp",
	"We no longer_": "BlackVueはこれ以上PayPalの決済システムを提供しません。カメラを追加する場合はサブスクリプションの方式を変更しなければなりません。\n \n 1. Paypalアカウントにログインし、現在のフリートプランをキャンセルしてからカメラ台数を変更してください。\n \n 2. BlackVuecloudアカウントにログインし、フリートプランにアップグレードしてください。",
	Yes: Yes$8,
	No: No$8,
	"Serial number": "製造番号",
	"Cloud code": "Cloudコード",
	"Terms & Policies": "利用規約",
	News: News$8,
	Notifications: Notifications$8,
	"km/h": "km/h",
	MPH: MPH$8,
	"Baidu Maps": "Baiduマップ (中国のみ)",
	"Google Maps": "Google マップ",
	Firmware: Firmware$8,
	Basic: Basic$8,
	"Time Zone": "時刻設定（時間帯）",
	Resolution: Resolution$8,
	"Image quality": "画質",
	Brightness: Brightness$8,
	Recording: Recording$8,
	"Normal recording": "常時録画",
	"Voice recording": "録音",
	"Video segment length": "録画ファイルの長さ",
	"Rear camera recording": "リアカメラの録画",
	Highest: Highest$8,
	High: High$8,
	Normal: Normal$8,
	"1 min": "1 分",
	"2 min": "2 分",
	"3 min": "3 分",
	Sensitivity: Sensitivity$8,
	"Motion detection": "モーション検知",
	"Speed alert": "速度警告",
	"Voice guidance": "音声ガイダンス",
	"Power on": "起動",
	"Power off": "シャットダウン",
	"Starting normal recording": "常時録画の開始",
	"Changing recording mode": "録画モードの切り替え",
	"Speed alert (beep)": "速度警告(ビープ音)",
	"Cloud related": "クラウド関連案内",
	Volume: Volume$8,
	"User text overlay": "ユーザー情報登録",
	"A-Z, a-z_": "A～Z、a～z、0～9、 :、;’/\\+-_()$#\n20文字以下。",
	"Wi-Fi auto turn off": "Wi-Fi自動オフ",
	"Login credentials": "ログイン設定",
	"Manual recording": "手動録画",
	"By sharing your_": "公開設定されたデータは、サービス提供者および他のユーザーに露出・利用される可能性があります。",
	"However, as persona_": "公開することを希望しない方は公開設定のチェックを外してください。",
	"Please enter_email_2": "有効なメールアドレスを入力してください。一部の特殊文字を含むメールは許可されていない場合があります。 ex） +、＆",
	"Password is incorrect": "パスワードが間違っています。",
	"This camera is already_": "このカメラはすでにBlackVueアカウントに登録されています。",
	"Camera name must_": "カメラ名は5～32字でなければなりません。",
	"Failed to save_": "カメラ設定の保存に失敗しました。",
	"Unallowed character detected": "認識できない文字を入力しました。",
	"File(s) queued for_": "Cloudへのファイルアップロードキューに追加完了",
	"Exceeded video play_": "動画の再生およびダウンロードの制限を超えました。",
	"Playback Failed": "ファイルが再生できません。",
	"Exceeded your Live_": "ライブビュー視聴時間の上限に達しました。",
	"The camera is not_": "カメラがサーバーに接続されていません。",
	"Please check the connection_": "選択されたカメラの接続状態を確認してください。",
	Close: Close$8,
	"Map": "マップ",
	Cloud: Cloud$8,
	Public: Public$8,
	"Flip horizontally": "左右反転",
	Front: Front$8,
	Rear: Rear$8,
	Play: Play$8,
	Stop: Stop$8,
	Pause: Pause$8,
	"Next frame": "次のフレーム",
	"Previous frame": "前のフレーム",
	"Proximity sensor": "近接センサー",
	"Voice recording on/off": "録音オン/オフ",
	"The BlackVue dashcam_": "BlackVueドライブレコーダーは、5 GHz ワイヤレスネットワークには対応していません。",
	Time: Time$8,
	"Daylight saving time": "夏時間",
	System: System$8,
	"Incorrect camera serial_": "カメラの製造番号が正しくありません。",
	"Lock event files": "イベントファイルをロックする",
	"Overwrite locked event_": "空き容量がない場合は、最新のイベントファイル50件が残るように上書きする",
	"Camera settings saved_": "カメラの設定が保存されました。",
	"Front camera": "フロントカメラ",
	"Rear camera": "リアカメラ",
	Event: Event$8,
	Parking: Parking$8,
	"GPS tracking": "GPSトラッキング",
	"G-force detected": "衝撃検知",
	"Impact detected in_": "駐車モード中の衝撃について報告",
	"Scheduled reboot": "オートリフレッシュ",
	"Recording status": "録画ステータス",
	"Rear security": "リアセキュリティ",
	"Time lapse": "タイムラプス",
	"Sync with GPS_": "GPS時刻と同期",
	"Overwrite locked event3_": "空き容量がない場合は、最新のイベントファイル50件が残るように上書きする",
	"Video codec": "ビデオコーデック",
	"Tracking logs": "トラッキングログ",
	"Geofence alerts": "ジオフェンシングアラート",
	Color: Color$8,
	Exit: Exit$8,
	Save: Save$8,
	Impact: Impact$8,
	Unlimited: Unlimited$8,
	"Parking mode recording": "駐車録画モード",
	"Battery protection": "バッテリー保護",
	"Cut-off timer": "カットオフタイマー",
	"Low voltage cut-off": "低電圧カットオフ",
	"Rear camera orientation": "リア映像の回転と反転",
	Default: Default$8,
	"Rotate video 180°": "映像の180°回転",
	"Mirror video": "左右反転",
	"Wi-Fi band": "Wi-Fi周波数帯",
	"Driving report": "運転レポート",
	"Unsupported video codec_": "対応しないビデオコーデックです。",
	"Rear camera recording_": "駐車録画でのリアカメラ録画",
	"Front and rear_": "フロントとリアカメラを同時に録画する",
	"Rear camera stops_": "駐車モードに入り、5分経過したら、リアカメラの録画を中止します。常時モードになったら、録画を再開します。",
	"Remote firmware update": "リモートファームウェアアップデート",
	"Firmware is up-to-date": "最新ファームウェアになっています。",
	"New firmware available": "最新ファームウェアがあります。",
	Version: Version$8,
	"Release date": "リリース情報",
	Language: Language$8,
	"File size": "ファイルのサイズ",
	"What’s new": "新しいニュース",
	"Updating may take_": "アップデートには数分かかることがあります。",
	"The update process_": "アップデートプロセスは取り消しできません。",
	"Do not disconnect the_": "常時録画が再開するまで電源を切らないでください。",
	"Downloading firmware": "ファームウェアをダウンロードしています。",
	"Once download is_": "ダウンロードを完了すると、BlackVueが自動的に再起動して新しいファームウェアに更新します。",
	"If not allowed_": "許可しないとクラウドを通じて車の位置や速度にアクセスできません。",
	"Unable to initiate update because_": "ドライブレコーダーが直接Wi-Fiを介してスマートフォンに接続されているので、アップデートが開始できません。",
	Notification: Notification$8,
	Multiple: Multiple$8,
	Range: Range$8,
	"HDR night vision": "HDRナイトビジョン",
	Download: Download$8,
	"G-sensor": "G-Sensor",
	Manual: Manual$8,
	"Low voltage warning": "低電圧警告",
	Satellite: Satellite$8,
	"Data usage": "データ使用量",
	"Select video download quality": "ダウンロード画質の選択",
	"Quick play file_": "クイックプレイファイル（最適化した解像度）",
	"Original file": "オリジナルファイル",
	"You do not have permission_": "この機能を実行する権限がありません。\n 管理者にお問い合わせください。",
	"Interior camera recording_": "駐車モード中の車内カメラの録画",
	"Interior security": "車内セキュリティ",
	"Interior camera rotation": "車内映像の180°回転",
	"Multi View": "マルチビュー",
	Tutorials: Tutorials$8,
	"Upgrade now": "今すぐアップグレード",
	"Members will show_": "メンバーが利用可能になるとここに表示されます",
	"Are you sure_delete members": "メンバーを完全に削除してもよろしいですか。",
	"Some members may_": "フィルターが適用されているので、一部のメンバーが非表示になっています。",
	"Invited on_": "あなたによって{{Invited Date}}に招待されました。オーナー",
	Filter: Filter$8,
	"Date created": "作成日",
	"No admin yet": "管理者なし",
	"You can add_admin": "グループごとに1人の管理者を追加できます",
	"Collapse all": "すべて縮小",
	"Expand all": "すべて拡張する",
	"Download and playback_cloud": "クラウドストレージからダウンロードして再生する",
	"Are you sure_2": "グループ{Group name}を削除してもよろしいですか。",
	"Are you sure_groups": "グループを削除してもよろしいですか？",
	"Add cameras first_drivers": "まずカメラを追加してからドライバーを割り当ててください",
	"Flip vertically": "垂直に反転",
	Sun: Sun$8,
	Mon: Mon$8,
	Tue: Tue$8,
	Wed: Wed$8,
	Thu: Thu$8,
	Fri: Fri$8,
	Sat: Sat$8,
	Dates: Dates$8,
	Routes: Routes$8,
	Opacity: Opacity$8,
	"Color and opacity": "色と不透明度",
	"Geofences will show_": "ジオフェンスが利用可能になるとここに表示されます",
	"Start drawing a shape_": "マップ上に形状を描き始める",
	"Add geofence": "ジオフェンスを追加する",
	Entry: Entry$8,
	"Show all members": "メンバーを全員表示する",
	"Me and my_": "私と愛車。接続",
	"add-on service for_": "クラウド互換Blackvueのアドオンサービス",
	"Continue with Google": "Googleで続行する",
	"An account with_": "このメールアドレスのあるアカウントはすでに存在しますが、検証されていません。既存のBlackVue Cloudパスワードを使ってログインしてください。",
	"Account does not_": "アカウントが存在しません。または、Apple または Google アカウントでログインしてみてください。",
	"Continue with Apple": "Appleで続行する",
	"Get started": "開始",
	"P subscription only": "<b>{{a}}</b> 登録のみ",
	"+N USD for extra camera_": "追加カメラ{{b}}台当たり+{{a}} USD",
	"Unlimited Live view": "ライブビュー：使い放題",
	"Cameras per Account": "1アカウント当たり登録可能カメラ台数",
	"Users per Account": "1アカウント当たり登録可能ドライバー数",
	Owner: Owner$8,
	"Live View per Day": "毎日ライブビュー可能時間",
	"Remote Video Playback_2": "毎月遠隔動画再生とダウンロード回数",
	"N days": "{{a}} 日",
	"Video On Map": "マップ上で直接動画確認",
	Undetected: Undetected$8,
	Distracted: Distracted$8,
	Drowsy: Drowsy$8,
	"Whether on mobile_": "モバイル、PCを問わず、BlackVueはドラレコの機能を十全にお楽しみいただけるようにツールをご提供しております。最新ファームウェア、モバイルとデスクトップのアプリをダウンロードしてください。または、お使いのブラウザーからBlackVueウエブアプリをお使いください。",
	"Compatible with most_": "ほとんどのWi-Fi BlackVueドラレコに対応します。DR650GWシリーズまでのCloud対応BlackVueドラレコではCloudサービスがご利用いただけます。",
	"Supports most recent BlackVue_": "最新BlackVueモデルとBlackVue Cloudに対応します.\n このビューアは二つのアプリケーションが一つになっています。SDカードビューアからは、SDカード内の動画確認、設定変更、フォーマットが可能で、CloudビューアからはBlackVue Cloudが楽しめます。",
	"Contact us": "お問い合わせ",
	"6 characters with": "英文字、数字、記号の組み合わせで6文字",
	"Apps and more...": "アプリ以外にも盛沢山",
	"Cameras will show_": "カメラが費用可能になったら、こちらに表示されます。",
	"Keep this page_": "認証コードをチェックしていますので、このページを開いたままにしてください。受信トレイにメールが見つからない場合は迷惑メールを確認してみてください。",
	"n cameras": "カメラ {{n}}台",
	"n slots": "スロット {{n}}個",
	"Calculate your Fleet_": "フリートプラン費用を計算してみてください。",
	"Code you entered_": "入力されたコードは正しくないか、有効期限が切れています。",
	Calling: Calling$8,
	Smoking: Smoking$8,
	"Smoking has been_": "走行中の喫煙が検知されました。",
	"Email is already_": "メールがすでに存在しています。",
	"Serial number and_": "製品番号とクラウドコードがカメラにプリントされます。",
	"Allow GPS access": "GPSアクセスを許可する",
	"Used to access_": "お客様の車両位置と速度データにアクセスするために使用されます。後でドラレコのプライバシー設定から変更することができます。",
	"Incorrect cloud code": "Cloudコードが正しくありません。",
	"An account is_": "このメールアドレスで登録したアカウントがすでに存在します。",
	"Live event upload": "ライブイベントアップロード",
	Permissions: Permissions$8,
	"Assign in": "割り当てる",
	"Are you sure_camera": "このカメラを削除しますか？",
	"Uploading videos:": "アップロート映像：",
	"GPS location recording": "GPS位置情報の記録",
	"When OFF, GPS_": "オフの場合、GPS位置情報は記録されず、クラウドサーバーにも送信されません。",
	"As personal video_": "個人動画が送信されるので、どの情報を共有させるか十分注意してください。",
	"Share location": "位置情報の共有",
	Private: Private$8,
	"Used to access_2": "お客様の車両位置と速度データにアクセスするために使用されます。",
	"Share live view": "ライブビュー共有",
	"Share live audio": "ライブビューオーディオ共有",
	"Share camera’s name": "カメラ名共有",
	"Impact detection": "衝撃検知",
	Entering: Entering$8,
	Exiting: Exiting$8,
	"Normal event recording": "常時イベント録画",
	"Harsh braking": "急ブレーキ",
	Acceleration: Acceleration$8,
	"Sharp turn": "急ハンドル",
	"Parking event recording": "駐車中のイベント録画",
	Passing: Passing$8,
	"Video source": "映像ソース",
	Overspeed: Overspeed$8,
	"Are you sure_video": "このファイルを削除しますか？",
	"Add camera to_": "ライブビューにカメラを追加してください。",
	"No routes to_": "表示できる走行ルートはございません。",
	"Start by adding_": "期間を選択してください。",
	"invite sent": "送信済み招待状",
	Recipients: Recipients$8,
	Send: Send$8,
	"Routes selected_": "選択された走行ルート： {{total}} 中 {{n}}",
	"Map service": "マップサービス",
	"Speed units": "速度単位",
	Note: Note$8,
	"Release notes": "リリースノート",
	"The name must_": "名前は2-30文字以内でなければなりません。",
	Video: Video$8,
	Advanced: Advanced$8,
	"Firmware language": "ファームウェア言語",
	"Wi-Fi": "Wi-Fi",
	Voice: Voice$8,
	"Show date and_": "日付と時間表示",
	"Show speed": "速度表示",
	"Front camera rotation": "フロント映像の180°回転",
	"Manual time settings": "手動時刻設定",
	"Recommended for better_": "4K UHDファイル圧縮および容量を減らすのにお勧め",
	"For full compatibility_": "古いPCやモバイルデバイスに完璧対応",
	"Up and down": "上下",
	"Side to side": "左右",
	"Front and back": "前後",
	"Detection region": "検知領域",
	"Hotspot 1": "ホットスポット1",
	"Hotspot 2": "ホットスポット2",
	"Hotspot 3": "ホットスポット3",
	"Enter/exit": "進入/退出",
	"Event recording": "イベント録画",
	"Front security (Normal)": "フロントセキュリティ（常時）",
	"Front security (Parking)": "フロントセキュリティ（駐車）",
	"LTE (Parking)": "LTE（駐車）",
	"Wi-Fi (Parking)": "Wi-Fi（駐車）",
	"Turn on at startup": "起動時にON",
	"Turn off after_": "10分間操作がない場合OFF",
	"Your firmware is_": "このファームウェアは最新です。",
	"Add admin": "管理者追加",
	"Remove All/n": "すべて除去/{{a}}",
	"Are you sure_remove": "このグループからカメラを除去しますか？",
	"This will cancel_2": "フリートプランのサブスクを止めることになります。現在の請求周期の最後の日から無料プランに変わります。",
	"You’ve reached_": "1ドラレコ当たりのドライバー数の上限に達しました。",
	"Are you sure_remove admin": "このグループから管理者 {{a}}{{b}}を除去しますか？",
	"Fleet Plan · Owner": "フリートプラン · オーナー",
	"Manage cameras": "カメラ管理",
	"Are you sure_delete zone": "\"{{zone}}\"ゾーンを削除しますか？",
	"available on your_2": "現在のプランで利用可能なカメラ{{a}}/{{b}}",
	"The new plan_2": "新しいプランは現在の請求周期({{a}})の最後の日から適用されます。",
	"Canceled Fleet Plan_": "{{a}}のフリートプラン中止",
	"Hard braking alert (beep)": "急ブレーキアラート(ビープ音)",
	"Hard acceleration alert (beep)": "急加速アラート(ビープ音)",
	"Hard cornering alert (beep)": "急ハンドルアラート(ビープ音)",
	"SSID must be_": "SSIDは5文字以上でなければなりません。",
	"Password must be_": "パスワードは8文字以上でなければなりません。",
	"5 to 32 characters long": "5文字以上32文字以内",
	"8 to 32 characters long": "8文字以上32文字以内",
	"Longer storage period_event": "ライブ自動アップロードのより長い保存期間",
	"Requires latest firmware_": "最新ファームウェア必要。DR650S、DR650GWモデルには非対応。",
	"After Blackvue is_": "BlackVueドラレコがCloudに接続したら、調整した設定が保存されます。",
	"This is an_": "登録されていないメールアドレスです。新しいアカウントを作成しますか？",
	"This feature is_": "この機能はフリートプランでのみ利用可能です。",
	"Please return to_": "アカウントが存在しません。または、Apple または Google アカウントでログインしてみてください。",
	"Adjusting the cut-off voltage_": "低電圧カットオフ設定で電圧を下げる行為は、車のバッテリーからより多くの電源を取ることを意味し、バッテリー上がりにつながる恐れがあります。\n この行為により、バッテリーランプ（充電警告灯）の点灯や車のその他の機能に影響を及ぼす恐れがあります。\n 電圧を下げる前に購入先や専門家に相談してください。",
	"Your videos will_": "映像ファイルが利用可能になったら、こちらに表示されます。",
	"You drove:_": "走行履歴：{{distance}}, {{time}}",
	"Event count per_": "走行1時間当たりイベント発生回数",
	"Are you sure_recipient": "この受信者を削除しますか？",
	"(You)": "{{a}} (お客様)",
	"All events": "すべてのイベント",
	Days_: Days_$8,
	"Requires DMC 200_": "DMC200カメラが必要です。",
	"A DMS and compatible_": "こちらのレポートを確認するためにはDMSおよび対応するドラレコが必要です。",
	"Notifications will show_": "通知が来たら、こちらに表示されます。",
	"Try changing your_": "日付を変えたり、フィルターを外してみてください。",
	Mute: Mute$8,
	UnMute: UnMute$8,
	"Calling and smoking_": "通話と喫煙の検知にはDMC200が必要です。",
	"You need a DMS_": "このレポートを見るためにはDMSカメラが必要です。",
	"Try BlackVue Cloud": "今日BlackVue Cloudをお試しください。",
	"Individual driver looking_": "運転中のご安心をお探しの個人のお客様ですか。それともシンプルな車両セキュリティと管理ソリューションをお探しの法人のお客様でしょうか。",
	"Whoever you are_": "どのニーズを持ったどのお客様にもピッタリのCloudプランをご用意しております。",
	"It is the account that_Driver": "このアカウントはオーナーまたは管理者の招待メールに受諾して、お客様のBlackVue Cloudフリートに加入したドライバーアカウントです。ドライバーは制限された権限、つまり、本人のアカウントプロフィールおよび割り当てられたカメラのライブビューと動画再生のみ可能で、1個のドラレコのみ割り当てられます。",
	"It is the account that_Admin": "このアカウントはオーナーの招待メールに受諾して、お客様のBlackVue Cloudフリートに加入した管理者アカウントです。管理者はオーナーから与えられた権限を持ちます。",
	"Video deleted": "動画が削除されました。",
	"Video delete_plural": "複数の動画が削除されました。",
	"Driver removed from_": "グループからドライバーを外しました。",
	"Admin removed from_": "グループから管理者を外しました。",
	"Camera removed from_": "グループからカメラを外しました。",
	"Are you sure_videos": "選択されたファイルを削除しますか？",
	"You have to cancel_fleet": "登録カメラ台数を増やすためにはアプリ内で購入したプランを中止しなければなりません。 \n \n 1. App StoreやGoogle Play Storeから現在ご利用のプランを中止します。 現在の請求周期の最終日に自動で無料プランに切り変わります。すべてのデータはそのまま維持されます。 \n 2. blackvuecloud.comでログインし、フリートプランにアップグレードしてください。",
	Discard: Discard$8,
	"Discard unsaved changes?": "保存していない変更内容を破棄しますか？",
	"Incorrect serial number": "間違ったシリアルナンバー",
	"An error occurred_again": "エラーが発生しました。再度お試しください。",
	"You are subscribed_free": "お客様は現在BlackVue Cloudサービスの無料プランをご利用中です。",
	"When an event_": "イベントが発生（衝撃検知または手動録画）したら、BlackVueドラレコはイベント発生5秒前からの映像をクラウドに保存します。",
	Report: Report$8,
	"How it work": "作動の仕組み",
	"Cloud Camera": "クラウドカメラ",
	"Internet Connection": "インターネット接続",
	"BlackVue App/Viewer": "BlackVueアプリ/ビューア",
	"All you need_": "お客様に必要なのは、",
	"Cloud-compatible BlackVue": "クラウド対応BlackVueドラレコと",
	"and a cellular_": "モバイルデータプランです。サードパーティWi-Fiホットスポット経由でBlackVue Cloudにつながるモデルもございますが、ナノSIMカードリーダーを搭載したBlackVueドラレコやBlackVue外付け通信モジュールもございます。",
	"Cloud features at_": "様々なCloud機能が手の中に。",
	"Enjoy peace of_": "BlackVueドラレコがお客様の車を見守っているので、どこにいても安心です。もし車に何かが起きたら、ドラレコがすぐに知らせてくれます。",
	"Let your BlackVue_": "フリートマネジメントにもBlackVueドラレコを使って、車両監視と事故通知を任せてください。衝撃が検知されたら、その瞬間のスナップショットとともに直ちにお客様のスマホやウエブブラウザに通知してくれます。",
	"Check on your_": "どこからでもリモートライブビューで車を確認することができます。ウエブブラウザまたはスマホを通じてCloudに接続されているドラレコから送られるリアルタイム映像を、フロントカメラ、リアカメラ、車内カメラを簡単にスワップしながら確認してください。",
	"Your BlackVue may_": "BlackVueドラレコで当て逃げを防ぐことはできませんが、決定的な証拠映像は残せるでしょう。スマホやウエブブラウザから今すぐBlackVueドラレコが録画したすべての映像を確認してください。",
	"Worried about eating_": "データ通信量がお気になりますか？BlackVueサブストリーム技術でオリジナル映像の軽量バージョンにアクセスできますので、早い検索とバッファリングのない映像確認が可能です。",
	"Move files from_": "BlackVueドラレコからCloudにファイルを移してください。一個のファイルでも、複数のファイルでも一気にアップロード可能です。BlackVueアプリからスマホにダウンロードした録画映像は、内蔵メモリメニューから閲覧やシェアもできます。",
	"View your vehicle’s_": "お客様の車の位置と走行速度をリアルタイムで確認してください。スマートプランにアップグレードしたら、過去7日間のGPS走行履歴データも確認できます。",
	"Get more with_": "スマートプランでもっと楽しんでください。",
	"Unlimited Remote Live_": "リモートライブビューの制限なし",
	"Up to 3 dashcams_": "1個のアカウントにドラレコ3台まで登録可能",
	"Want to track_": "より多くの車両を管理したいですか？フリートプランにアップグレードしてください。",
	"BlackVue Fleet Tracking_2": "BlackVueフリートトラッキングは、お客様のフリートを守り、追跡できる一体型ソリューションです。",
	"Stream real-time video_": "無制限でリアルタイム映像をストリーミングできます (ビットレート: 600 kbps)。",
	"Up to 999 Dashcams": "999台まで登録可能",
	"Register up to_": "1個のアカウントにドラレコ999台まで登録可能",
	"15GB of Cloud_": "15GBのクラウドストレージ",
	"15GB per additional_": "ドラレコを1台追加するたびに15GBずつ追加。ライブイベントアップロードは無制限にアップロード可能。",
	"90-days GPS_": "90日間分のGPS走行履歴ログ",
	"High accuracy: 15_": "高い精度：毎15秒、マップ上から直接動画確認、簡単なデータエクスポート",
	"Unique fleet management_": "ユニークなフリートマネジメント機能は、ビジネスに新しい価値と利便性をもたらします。",
	"Create geofences and_": "スマホとPCでジオフェンスを作成し、独自のリアルタイム通知を受けましょう。",
	"View at a_": "総走行距離、停車時間、速度超過イベント回数などを一目で確認できます。必要に応じてプリントアウト・エクスポートしてください。",
	"Multi Live View": "マルチライブビュー",
	"Monitor up to_": "最大4台のドラレコのリアルタイム映像を同時にモニタリングできます。",
	"Benefits for you": "BlackVueユーザーのお得なポイント",
	Individual: Individual$8,
	"Get notifications to_2": "駐車中の車が衝撃を受けるとお客様のスマホにプッシュ通知を送ります。車から離れていても車の周りにどんなことが起きているか確認してください。ウエブとモバイル、MacやWindowsでも確認できます。",
	"Small business owner": "小規模の事業主様",
	"Monitor your commercial_2": "リアルタイムでマップからお持ちの車両をモニタリングできます。ウエブブラウザ、BlackVueアプリ、MacやWindowsのビューアを使って、ドライバーといつでも会話も可能です。",
	"Company with large_": "大規模のフリートをお持ちの法人様",
	"With BlackVue Fleet_2": "ウエブブラウザ、BlackVueアプリ、MacやWindowsのビューアでBlackVueトラッキング機能を使うと、999台まで車両のトラッキングができます。",
	Subscribed: Subscribed$8,
	"The video was_": "この動画はすでにアップロード済みです。",
	Geofence: Geofence$8,
	"500: Internal server error": "500: サーバーの内部エラー",
	"404: Page not found": "404: ページが見つかりません。",
	"Check the web address_": "ウエブアドレスを確認するか、BlackVue Cloudに戻ってください。",
	"home page": "ホームページ",
	"There isn’t an_": "このメールアドレスに関連したアカウントはございません。",
	"You can now_password": "これから新しいパスワードでログインできます。",
	"Are you sure_remove admin2": "管理者を完全に削除してよろしいですか？",
	"Admin deleted": "管理者を削除しました。",
	"Members deleted": "メンバーを削除しました。",
	"Are you sure_groupName": "グループ{{a}}を削除しますか？",
	"Requires latest firmware": "最新ファームウェアが必要です。",
	"Selected file(s) moved_": "選択されたファイルを移動させました。",
	"Are you sure_remove driver2": "Are you sure you want to remove driver {{a}} ({{b}}) from this group?",
	"Invite sent": "Invite sent",
	"Safe driving": "安全運転",
	"Reckless driving": "乱暴運転",
	"Inattentive driving": "前方不注意運転",
	"Driving events trend": "走行イベントの傾向",
	"Driving details": "運転情報",
	Driving: Driving$8,
	Idling: Idling$8,
	Distance: Distance$8,
	"Parking sessions": "駐車回数",
	"Parked time": "駐車時間",
	"Idle stops": "停車回数",
	"Idle time": "停車時間",
	"Impact events": "衝撃イベント",
	Parked: Parked$8,
	Speed: Speed$8,
	"Overspeeding alerts": "速度超過アラート回数",
	Highest_2: Highest_2$8,
	Average: Average$8,
	Geofences: Geofences$8,
	"Entries into a_": "ゾーンへの進入",
	"Exits from a_": "ゾーンからの退出",
	"No data": "データなし",
	"Hard acceleration": "加速",
	"Hard braking": "急ブレーキ",
	"Hard cornering": "急カーブ",
	"The number within the brackets_": "括弧内の数字は、1時間の運転あたりの平均イベント数を示しています。1日1時間未満の運転の場合は、イベントの総数が表示されます。",
	"Did you insert_": "SIMカードを挿入しましたか。",
	"Click here for_": "さらに詳しいガイドを見るには<a>ここをクリック</a>",
	"Back up all_": "<b>これらの設定を保存する前に、重要な録画をすべてバックアップしておいてください。</b><br/>設定を保存すると、microSDカードが再度初期化され、操作が安全に行なえるように、録画がすべて削除されます。",
	"Not connected to_": "クラウドに接続されていません。一部の機能が一時的に無効になっています。",
	"GPS Location recording off": "GPS位置情報の記録オフ",
	"n Videos deleted": "{{count}} 個の動画が削除されました",
	Move: Move$8,
	"Driver Monitoring System (DMS) will_": "ドライバーモニタリングシステム(DMS)がまもなく発売されます。",
	"An error occured while_": "カメラの数を変更しようとしたときにエラーが発生しました。再試行してください",
	"Reached the limit_": "上限に達しました:{{a}}",
	"An invitation was_": "このメールアドレスにはすでに招待状が送信されています。",
	"To use the_": "クラウド機能を使用するには。SIMカードを挿入してください。",
	"Last updated": "前回のアップデート日 {{date}}",
	"Try changing your date": "日付を変更してください。",
	"No event data_": "選択した時間のイベントデータは収集されません",
	"Please select another_": "レポート全体を表示するには、別の日または月を選択してください。",
	"more than 6_": "6文字以上が必要です",
	"Sign up free": "無料登録",
	"Cloud storage warning": "クラウドストレージ警告",
	"Cloud Storage Full": "クラウドストレージが一杯です",
	"Cloud storage usage_100": "クラウドストレージの使用率が 100% に達しました。ライブイベントがアップロードできるように、ストレージをクリアしてください",
	"Cloud storage usage_": "クラウドストレージの使用率が <b>({{a}}%)</b> に達しました。\nクラウドストレージを整理してください。\nクラウドストレージが一杯の場合、ライブイベント・アップロードサービスは利用できません。",
	"Are you sure_delete_zone": "ファイルを削除しますか？",
	"Search Name or email": "名前またはメールアドレスを検索",
	"Search group name": "グループ名を検索",
	"Please note that_": "新しい設定を適用する間、録画が数秒間停止することに注意してください。",
	"Currently connected Hotspot": "現在接続されているホットスポット",
	"Enhanced night vision": "ナイトビジョン",
	"To access the_": "カメラにアクセスするには、サービスプランを更新してください。",
	"Restarting the Blackvue_": "設定を適用するためにBlackVueを再起動しています。",
	"Hard acceleration event_": "1秒あたりの速度増加量が{{kmh}} km/hを超えると、急加速イベントとなります。",
	"Hard braking event_": "\n1秒あたりの速度低下量が{{kmh}} km/hを超えると、急ブレーキイベントとなります。",
	"Hard cornering event_": "\n{{kmh}} km/h以上の速度で2秒以内に60度以上回転すると、ハードコーナリングイベントとなります。",
	"Changes you made_": "変更した内容は保存されない場合があります。",
	"My location": "現在地",
	"Hotspot name (SSID)": "ホットスポット名(SSID)",
	Connected: Connected$8,
	"Camera will be rebooted_": "カメラが再起動します。続行しますか?",
	"Restarting the BlackVue_": "BlackVueの再起動中です。お待ちください。",
	"Failed to reboot_": "カメラの再起動に失敗しました",
	"Bluetooth (Parking mode)": "BT (駐車モード)",
	"Front and interior camera_": "フロントカメラと車内カメラで同時に録画されます。",
	"Interior camera stops_": "駐車モードになると、5分後に車内カメラの録画が停止します。通常モードになると録画が再開されます。",
	Individual_: Individual_$8,
	"Driver detection": "ドライバー検知",
	"During driving only": "運転中のみ",
	Always: Always$8,
	"Driver detection box": "ドライバー検知ボックス",
	"DMS camera rotation": "DSMカメラの回転",
	Low: Low$8,
	Medium: Medium$8,
	High_2: High_2$8,
	"Reboot Camera": "カメラを再起動",
	"Latest events": "最新のイベント",
	"G-Sensor": "G-Sensor",
	"Playback speed": "再生速度",
	Flip: Flip$8,
	Previous: Previous$8,
	Next: Next$8,
	"Map type": "マップタイプ",
	"Zoom in": "ズームイン",
	"Zoom out": "ズームアウト",
	"Move to Cloud": "Cloudストレージに保存",
	"Please recognize that_": "設定を適用する間、録画が数秒間停止することに注意してください。",
	"6 characters with_": "文字、数字、記号を混ぜて6文字",
	"Updating firmware": "ファームウェアをアップデートしています",
	"Overspeed event occurs_": "速度を超過したドライバーにアラートを鳴らしたら、速度超過イベントが発生します。この設定はファームウェア > システムから変更できます。",
	"Enter group name": "グループ名を入力する",
	"Live view failed": "ライブビューの再生に失敗しました。",
	"Parking mode enter_": "駐車モードの起動/解除",
	"Cloud connectivity": "クラウド接続性",
	Expand: Expand$8,
	Collapse: Collapse$8,
	"all day": "終日",
	"Driving style": "運転スタイル",
	"Driving impact": "運転中の衝撃",
	More: More$8,
	"No cameras to_": "追加できるカメラがありません",
	"You have added_": "使用可能なカメラがすべて追加されました。",
	Multi: Multi$8,
	"Report video": "ビデオを報告する",
	"Sexually explicit content": "性的な内容",
	"Graphic violence": "暴力的または不快",
	"Hateful speech": "憎悪的または虐待的",
	"Harassment or bullying": "迷惑行為またはいじめ",
	"Spam or advertisement": "スパムまたは広告",
	"Infringement of my_": "個人の権利の侵害",
	"Other reason": "その他",
	"Reason for reporting": "報告する理由",
	"Reported videos will_": "報告されたビデオは72時間以内に確認されます。Event Map への投稿に適していることが確認されるまで、ビデオはEvent Map に表示されません。",
	"Touch sensor": "センサーに触れる",
	"Motion and impact detection": "動体と衝撃の検知",
	"Settings have been changed": "設定が変更されました",
	"Start event recording (beep)": "イベント録画を開始 (ビープ音)",
	"Scheduled reboots": "オートリフレッシュ",
	Safe: Safe$8,
	Reckless: Reckless$8,
	Inattentive: Inattentive$8,
	"Highest(Extreme)": "最高 (エクストリーム)",
	"Public cameras": "パブリックカメラ",
	List: List$8,
	Usage: Usage$8,
	"Video playbacks and downloads": "ビデオの再生とダウンロード",
	"of 100 times": "100回中",
	"of 10 minutes": "10分中",
	Profile: Profile$8,
	"Search geofences": "ジオフェンスを検索する",
	"Export CSV": "CSVをエクスポートする",
	"Exit fullscreen": "全画面を終了する",
	Fullscreen: Fullscreen$8,
	Upgrade: Upgrade$8,
	"Email address": "電子メールアドレス",
	"of Unlimited": "無制限の",
	"No notifications yet": "過去7日間に受け取った通知はありません。",
	"No videos yet": "まだ録画映像がありません",
	Management: Management$8,
	Day: Day$8,
	Month: Month$8,
	"Welcome to the BlackVue_": "BlackVue Cloudビューワーへようこそ",
	"You can access BlackVue_": "ウェブから BlackVue Cloudに、いつでもどこでもアクセスできます！",
	"Start tour": "ツアーを開始する",
	"Map view": "マップビュー",
	"Check the current_": "現在の GPS 位置と、自分のカメラおよびパブリックカメラの速度を確認してください。",
	"Camera’s features": "カメラの機能",
	"Take a look_": "BlackVue カメラが提供する、様々な Cloud 関連の機能をご覧ください。",
	"Visualize your vehicle’s_": "時間の経過とともに車が走行する運転ルートを思い描いてください。",
	"Smart plan_": "スマートプラン：90日間、フリートプラン：90日",
	"Create geofences and2_": "ジオフェンスを作成して、リアルタイム通知を受信しましょう。",
	"Got it": "了解",
	"Manage Fleet members": "フリートメンバーを管理する",
	"Invite fleet members_": "フリートメンバーを招待し、グループに割り当てます。",
	"The moment the_": "カメラが衝撃を検知した瞬間、ここに通知がリストアップされます。",
	"Geofence Setup (Web)_": "ジオフェンスの設定（ウェブ/デスクトップ）とアラート",
	"Original file play_": "オリジナルのファイル再生はダウンロードのみ可能です",
	"To get most_": "BlackVue Cloud ビューアーを最大限に活用するには、カメラが Cloud に接続されている必要があります。BlackVue アプリケーションをダウンロードして、カメラの追加から Cloud 接続までが同時に可能な、シームレスペアリングを体験しましょう！",
	"You haven’t driven_Today": "今日はまだ車を運転していません。ドライブレポートを確認するには、BlackVue を車に搭載し、運転してください。",
	"You haven’t driven_Month": "今月はまだ車を運転していません。ドライブレポートを確認するには、BlackVue を車に搭載し、運転してください。",
	"Fleet Plan only_": "フリートプランのみが選択可能です",
	"Overwrite locked event2_": "ストレージが一杯になったらロックされたイベントファイルを上書きします",
	"DMS’s New firmware_": "DMS の新しいファームウェアが利用可能です",
	"Highest speed_report": "<b>最高速度</b>\nメートル単位で収集された速度データの最大値 がKm/h および MPH 単位に変換されたもの\n\n<b>平均速度</b>（距離／運転時間）× 3600＝平均速度。例（2622／1208）× 3600＝7814.907\nKm／h：整数のみ、\nMPH の小数点は整数以下最大2桁",
	"Choose a cloud_": "クラウド接続方法を選択する",
	"You need an_": "Cloud に接続するには、インターネット接続が必要です。使用しているデバイスを選択して Cloud に接続してください。",
	"BlackVue SIM card": "BlackVue SIM カード",
	"Support model_": "サポートしているモデル：DR750X-2CH LTE Plus（NA）",
	"3rd party SIM_": "サードパーティ製 SIM カード",
	"Support model_SIM": "サポートしているモデル：DR750X-2CH LTE Plus、DR750-2CH LTE、CM100 LTE",
	"Wi-fi hotspot": "Wi-Fi ホットスポット",
	"Support model_Wifi": "サポートしているモデル：すべての BlackVue モデル",
	"How to connect_": "Cloud に接続する方法",
	"Download BlackVue application": "BlackVue アプリをダウンロード",
	"*If you are_": "*BlackVue の SIM カードを使用して Cloud に接続する場合は、{{a}} {{b}}.にアクセスしてください。",
	"Place your phone_": "携帯電話をカメラの Bluetooth 範囲内に置きます。{{A}} によるシームレスペアリングを開始します。",
	"Back to camera_": "カメラリストに戻る",
	"Upgrade for more_": "アップグレードしてもっと他の機能を楽しみましょう！",
	"Upgrading the cloud_": "Cloud プランをアップグレードすると、他の様々な機能が楽しめるほか、複数のカメラを管理できます。Cloud プランをアップグレードしますか？",
	"Explore cloud plans": "Cloud プランを調査する",
	Later: Later$8,
	"Successfully subscribed": "サブスクライブに成功しました！",
	"1GB data plan": "1GB データプラン",
	"First month free_": "最初の月は無料で、<a>その後は毎月10.99 米ドル</a>",
	"Next billing date": "次回の請求日",
	"Once SIM card_": "カメラに SIM カード が挿入されたらすぐ、 BlackVue Cloud の機能をお使いいただけます",
	"Go to SIM_": "SIM 管理画面に移動する",
	"Manage your BlackVue_": "ここで BlackVue SIM カードを管理できます！",
	"Recommended for BlackVue_": "BlackVue SIM 所有者にお薦め！",
	"Connect to cloud": "Ｃloud に接続する",
	"Enter BlackVue SIM_": "BlackVue SIM ICCID ナンバーを入力する",
	"ICCID number is_": "ICCID ナンバーは、SIM カード・パッケージの箱に印刷してある番号です。ICCID ナンバーの下14桁を入力してください。",
	ICCID: ICCID$8,
	"SIM information": "SIM 情報",
	"Start your free_": "無料トライアルを今すぐ開始する",
	"SIM card activate_": "SIM カードの有効日",
	"Based on the_": "SIM カードがカメラに挿入され、電源が入った日を基準にしています。",
	"Upgrade to 3GB_": "3GB／5GB プランにはいつでもアップグレードできます",
	"Cancel your plan_": "プランはいつでもキャンセルできます",
	"No Commitment": "契約は不要です",
	"Precautions for using_": "サービスを利用する際の注意点",
	"After 1GB is_": "１GB を超えると、それ以上インターネットが使えなくなります。",
	"If you have_": "すでに SIM カードをカメラに挿入している場合、無料トライアル期間は SIM カードを利用し始めた日から有効になっています。",
	"This content is_": "このコンテンツは SIM パッケージ内で指定されています。提供されていない期間の無料トライアルに関しては、補償は出来かねます。",
	"If you have_2": "さらに質問がある場合は<a>CS チーム</a>にお問い合わせください</a>。",
	"When OFF, connecting_": "電源が入っていないと、シームレスペアリングによる接続は無効になります。",
	"1 month free": "無料1ヶ月",
	"No commitment. Cancel_": "契約は不要。いつでもキャンセル可能。",
	"The video has been reported_": "ビデオの報告に成功しました",
	"Free for 1 month": "1ヶ月間無料",
	"Start your free_2": "無料トライアルを開始する",
	"1GB free for_": "１GB が {{a}} 日間無料",
	"1GB data": "1GB のデータ",
	"1 month free_2": "1ヶ月間の無料トライアルは {{a}} から開始され、BlackVue SIM カードのデータ １GB 分が含まれています。",
	"Your next billing_": "お客様の次の請求日は {{a}} です",
	"SIM card": "SIMカード",
	"SIM guide": "SIM ガイド",
	"SIM card list": "SIM カードリスト",
	"Add SIM card": "SIM カードを追加する",
	"No SIM card_": "SIM カードが見つかりません",
	"Search SIM ICCID_": "SIM ICCID または名前で検索してください",
	"Cloud disconnected. Failed_": "クラウドが切断されました。ビデオの再生に失敗しました",
	"This sim card_": "この SIM カードはすでに他のアカウントに登録されています。",
	"Incorrect BlackVue SIM_": "BlackVue SIM ICCID が正しくありません",
	"My shared videos": "共有ビデオ",
	"Number of events": "イベント数",
	"Added to Event Map": "Event Map に追加されました",
	"Successfully added video(s)_": "Event Map への、共有するビデオの追加が成功しました！共有ビデオのステータス確認や管理を行いたい場合は、Event Map ＞共有ビデオにアクセスします。",
	"Already added to_": "すでに Event Map に追加されています",
	"This video(s) is already added_": "このビデオはすでに Event Map に追加されています！共有ビデオのステータス確認や管理を行いたい場合は、Event Map ＞共有ビデオにアクセスします。",
	"BlackVue’s firmware is up_": "BlackVue のファームウェアは最新です",
	"Service end": "サービス終了",
	Resubscribe: Resubscribe$8,
	"Sort ascending": "昇順に並び替える",
	"Sort descending": "降順に並び替える",
	plan: plan$8,
	USD: USD$8,
	"Are you sure_Cancel": "本当にサブスクリプションをキャンセルしてもよろしいですか？以下の文章を確認し、承諾してください。",
	"Your current SIM_": "現在の SIM カードのサブスクリプションは{{a}}に終了し、それ以降課金されることはありません。",
	"After canceling your_": "SIM カードのサブスクリプションをキャンセルしても、サブスクリプションの最終日までは SIM カードを使うことができます。",
	"You can resubscribe_": "現在のサブスクリプションが終了したら、一ヶ月以内に再購読することができます。再購読をしたい場合、SIM カードリストの「再購読」ボタンを、{{a}}までにクリックしてください。",
	"Reason to cancel_": "サブスクリプションをキャンセルする理由",
	"Found an alternative": "他の方法を見つけた",
	"Too expensive": "値段が高すぎる",
	"Not required anymore": "必要ではなくなった",
	"Quality issue": "クオリティーに不満があった",
	etc_: etc_$8,
	"Please describe in_": "詳しく説明してください",
	"SIM card cannot_": "SIM カードはサブスクリプションの契約中のため、 SIM カードを削除できません。この SIM カードを削除したい場合は、先にサブスクリプションをキャンセルして下さい",
	"SIM card cannot_2": "この SIM カードのサブスクリションがまだ終了していないため、SIM カードを削除できません。サブスクリプションが終了してからもう一度お試しください。",
	"Are you sure_deleteSIM": "本当にこの SIM カードを削除しますか？<br/>\n<b>ご注意:このアクションを元に戻すことはできません。SIM カード情報はすべて瞬時に消去されます。</b>",
	"ICCID number": "ICCID 番号",
	"Activation date": "有効日",
	"Current plan": "現在のプラン",
	"Manage Plan": "プランの管理",
	"Next billing on": "次の請求書発行日",
	"View Invoices": "請求書を見る",
	"Choose best plan_": "ベストなプランを選択する",
	"Plan summary": "プランの概要",
	"Ends on_": "{{a}} 日に終了",
	"Start from_": "{{a}} 日より開始",
	"Your subscription will_": "お客様のサブスクリプションは、現在のプランが終了した後にアップグレードされます{{a}}。",
	"Resubscribe plan": "プランを再購読する",
	"Your subscription will2_": "お客様のサブスクリプションは、現在のプランが終了した後 {{a}} に始まります。",
	"Usage is estimated_": "使用量の見積は {{a}} 現在のものです",
	"Days left_": "終了まであと {{a}} 日",
	"Data usage cycle": "データ使用量のサイクル",
	Available: Available$8,
	Used: Used$8,
	"Data used": "データ使用量",
	"Subscribe to n_": "<b> {{b}}から{{c}}まで</b>に適用される {{a} データプラン、そして {{e}} から適用される {{d}} プランをサブスクライブしてください",
	"Will be charged_": "{{a}} に課金されます",
	"Monthly usage": "毎月の使用量",
	"You have fewer_": "今月は残りデータが少なくなっています！",
	"Get more data": "データを追加しましょう！",
	"This video cannot be shared": "このビデオは共有できません",
	"This is a video cannot be shared_": "現時点で運転情報が見つからないため、このビデオは共有できません。",
	Cancelled: Cancelled$8,
	Terminated: Terminated$8,
	"Edit name": "名前を編集する",
	"Not connected to_2": "クラウドに接続されていません。カメラの電源が入っていて、インターネット接続モジュールが有効になっているか確認してください。",
	"Some functionality is disabled_": "カメラが Cloud に接続されていないため、幾つかの機能は無効になっています。<a>ここ</a>から Cloud に接続します。",
	"If you want to cancel_": "プランをキャンセルしたい場合、<a>サブスクリプションのキャンセル</a>をクリックします。",
	"Select plan": "プランを選択する",
	"Event map collects_": "Event Map は、BlackVue イベント情報を収集・可視化し、周囲の道路の状況を提供します。",
	"Share your Live_": "ライブイベントアップロードファイルを共有する。イベントビデオは、周囲の他のユーザーと共有できます。",
	"You can check_": "他のユーザーが共有しているイベントビデオを確認することもできます。",
	"Service end_": "サービス終了：{{a}}",
	"DMS camera recording_": "駐車モードでの DMS カメラ録画",
	Sort: Sort$8,
	"Are you sure you want_": "本当に Event Map から共有ビデオを削除してもよろしいですか?",
	"Remove shared video": "共有ビデオを削除する",
	"Explore event map": "Event Map を確認する",
	"Event map": "Event Map",
	"Explore the graphic_": "周囲で起きている BlackVue イベントのグラフィック統計を確認する。",
	"You can filter_": "表示させたいイベントをフィルタリングして閲覧することができます。",
	"This video was removed by_": "このビデオは報告されており、管理者によって削除されました。.",
	Bonus: Bonus$8,
	"Your subscription plan": "お客様のサブスクリプション・プラン",
	"Your free trial will_": "お客様の無料トライアル期間は {{a}}から </br><strong>まで</strong> {{b}} です。",
	"Total after free trial": "無料トライアル終了後の合計",
	"This sim card is_": "この SIM カードは有効ではありません。",
	"Firmware is up_": "ファームウェアは最新の状態になっています",
	"Keep in mind": "ご注意ください",
	"Once 1GB of_": "データ使用量が１GBを超えると、次のデータリセット日まで（または上位プランにアップグレートされるまで）サービスは利用できなくなります。",
	"After the SIM_": "カメラに SIM カードが挿入され、データ使用が始まると、無料トライアル期間が開始されます。",
	"If you have_questions": "質問がある場合は、<a>カスタマーサポート</a>までお問い合わせ下さい。",
	"Data reset date": "データリセット日",
	"To use SIM card_": "SIM カードを使用するには、BlackVue <a>CS チーム</a>にお問い合わせください。",
	"Go to Subscription": "サブスクリプションに移動",
	"An error occurred_subscription": "選択されたプランの購読手続き中にエラーが発生しました。",
	"Please try again": "再試行してください",
	"Failed to subscribe": "サブスクライブに失敗しました",
	"Go to Pricing": "価格決定に移動する",
	"SIM cards will_": "利用可能になった SIM カードはここに表示されます。",
	"1GB for 1_": "1ヶ月につき1GB",
	"Pricing Data": "価格データ",
	"If you would like to check_": "共有ビデオのステータス確認や管理を行いたい場合は、Event Map ＞共有ビデオにアクセスします。",
	"Connect to Cloud": "Ｃloud に接続する",
	"Completed!": "完了！",
	"Back to App": "アプリに戻る",
	"iOS in-app purchase": "iOS アプリ内購入",
	"Android in-app_": "Android アプリ内購入",
	"bonus n days": "{{a}}日間のボーナス",
	"Want to contribute your_": "Event Map への自動イベントアップロードファイルの共有を許可しますか？",
	"With event map_": "Event Map を通して、イベントの自動アップロードビデオを近くのドライバーと共有できます。",
	"You can edit_3": "[BLACKVUE CLOUD] > [カメラ設定] > [プライバシー設定] と移動すれば、Event Map へのイベント自動アップロードファイルの自動共有設定をいつでも編集できます。",
	"If you want to remove videos_": "個人動画が送信されるので、どの情報を共有させるか十分注意してください。",
	"Total events": "イベントの合計",
	"Automatically add Live Event_": "Event Map へのイベント自動アップロードファイルの自動共有",
	"This camera is publicly_": "このカメラはこの場所に限り公開されています。",
	incomplete_zip: incomplete_zip$8,
	"Live Event Upload_": "ライブイベントアップロード（ストレージ期間:7日間）\n最新のファームウェアが必要",
	"Thank you for_2": "お待ちいただきありがとうございます。",
	"Start Web viewer": "ウェブビューアの開始",
	"Are you sure_remove driver": "ドライバーを完全に削除してもよろしいですか",
	"An error occurred_sim": "サブスクライブの試行中にエラーが発生しました。",
	"Click the ADD SIM": "SIM カードリストページにある「SIM カードの追加」ボタンをクリックし、SIM の追加プロセスをもう一度検証してください。",
	"Set download options": "ダウンロードオプションを設定する",
	"Information may be_": "Information may be transmitted with a delay and may not reflect actual balances.",
	"Swipe left and right to move": "左右にスワイプして移動します",
	"Scheduled maintenance Notice": "定期メンテナンス通知",
	"Our Cloud server_": "当社の Cloud サーバーは定期メンテナンスを行います。",
	"During that time_": "その間、Cloud 機能は利用できない可能性があります。",
	"Expected maintenance start_": "メンテナンス推定開始時間：",
	"Expected duration_": "予想所要時間：{{a}}時間。",
	"For more information_": "さらに詳しい情報については、<a>「サーバーメンテナンス通知」</a>をご参照下さい。",
	"Do not remind_": "今後は通知を希望しない",
	"Cloud Server Maintenance": "Cloud サーバーメンテナンス",
	"BlackVue Cloud Service_": "BlackVue Cloud サーバーは一時的に利用できません",
	"We are currently_": "現在メンテナンス中です",
	"We apologize for_": "ご不便をおかけしていることをお詫びいたします。",
	"Driver Monitoring System (DMS)": "ドライバーモニタリングシステム（ DMS ）",
	"Distracted occurs_": "運転者の頭が前方から50度以上離れた場合に発生します。",
	"Hand distraction event occurs_": "運転者の手が長時間にわたって頭の近くで検出される場合に発生します（たばこを吸ったり、携帯電話を持ったりするときなど）。",
	"Mask off event occurs_": "運転手がマスクを着用せずに車に乗るか、マスクを外すときに発生します。",
	"DMS setting": "DMS 設定",
	"The DMS system has_": "DMSは、「検出済み」、「未検出」、「注意散漫」、「居眠り」、「マスクなし」ステータスのための顔検出ボックスと「手の注意散漫」ステータスのための動き検出ボックスを組み合わせます。",
	"DMS detection": "DMS 検知",
	"There are detection criteria for_": "各イベントには検出基準があります。以下のガイドを参照してください。",
	"DMS camera recording_onoff": "オン：DMSカメラは電源が維持されている限り、パーキングモードで録画を続けます。 <br/> オフ：DMSカメラはパーキングモードに入ってすぐに電源が切れます。",
	"LED lighting for each event_": "ドライバーモニタリングカメラのLEDは、各検知イベント（注意散漫、居眠りなど）ごとに信号を示します。",
	"Drowsy and Distracted each have_": "居眠り運転と脇見運転には、それぞれ3つの感度条件があります。以下のガイドインターフェイスを参照してください。",
	"DMS event detection sensitivity": "DMSイベント検出感度",
	"Only drowsy and distracted include_": "居眠り運転と脇見運転にのみ、感度設定が含まれます。また設定された感度は、一度設定されると2つのイベントに同じ感度が適用されます。",
	"When driver’s eyes close_": "運転中に運転者が両目を1秒以上閉じるか、2秒以上あくびをすると発生します。\n",
	"n digit": "{{a}} 桁の",
	"You are subscribed_free_Smart": "BlackVue Cloud のスマートプランにサブスクライブしています。",
	"Wi-Fi auto turn on": "Wi-Fi自動起動",
	"Video on a map": "Video on a map",
	"This feature is only_vom": "This feature is only available to users with a Fleet Plan subscription.<br/>Please subscribe to a plan to unlock this feature.",
	"Total n days_": "計 {{a}}日間の無料体験",
	"Every events of DMC200_": "DMS検知機能は通常モードでのみ有効です。駐車モードで電源が入っている場合、DMSカメラはビデオのみを記録します。",
	"An undetected event occurs_": "運転者がカメラの前に1分間検出されない場合に発生します。",
	"A detected event occurs_": "A detected Event occurs when the driver is gazing in front since the power is set in the beginning.",
	"Drowsy sensitivity_": "High : When the driver closes their eyes for more than 1 second, it is considered drowsy driving.<br/><br/>Medium : When the driver closes their eyes for more than 1.5 second, it is considered drowsy driving.<br/><br/>Low : When the driver closes their eyes for more than 2 second, it is considered drowsy driving.",
	"Distracted sensitivity_": "High : If the angle of the head is more than 50 degrees away from the front for 3 seconds, it is detected as Distracted.<br/><br/>Medium : If the angle of the head is more than 50 degrees away from the front for 5 seconds, it is detected as Distracted.<br/><br/>Low : If the angle of the head is more than 50 degrees away from the front for 7 seconds, it is detected as Distracted.",
	"Start your subscription now": "今すぐサブスクリプションを開始しましょう",
	"Free trial period has expired": "無料お試し期間が終了しました",
	"1 data plan will start from_": "Blackvue SIMカード用の1GBデータを含むデータプランは{{a}}より開始になります。",
	"Allow the BlackVue_": "BlackVueアプリが車載カメラのGPSデータにアクセスすることを許可しますか?",
	"We use this_": "これを利用してお客様の車の位置や速度が追跡されます。",
	"You can edit_": "[BLACKVUE CLOUD] > [カメラ設定] > [プライバシー設定] の順にクリックすると、いつでもGPSアクセス設定を編集することができます。",
	"SIM cards": "SIMカード",
	"Subscription status": "サブスクリプションステータス",
	Upgrades: Upgrades$8,
	"Upgrade plan": "プランをアップグレード",
	"Manage plan": "サブスクリプションプランの管理",
	"Next plan": "来月のサブスクリプションプラン",
	OR: OR$8,
	"Cancel subscription": "サブスクリプションをキャンセルする",
	Undo: Undo$8,
	Invoice: Invoice$8,
	"Daily usage": "毎日のデータ使用量",
	"Delete SIM": "SIM 削除",
	"New card": "新しいクレジットカード",
	data: data$8,
	"SIM card data_": "SIM カードデータプランのサブスクリプションは <a>sim.blackvuecloud.com</a> からキャンセルできます。",
	"Your plan from_": "本日より次の支払日までのプラン",
	"Applied during_": "有効期間： {{a}} ~ {{b}}",
	"From today until_": "本日より次の支払日までは、前月と同じプランのみがサブスクライブできます。この期間の支払いは本日請求されます。<a>料金は按分ベースで計算されます。</a>",
	"Choose your next plan": "お客様のプランを選択してください",
	"Applied from_": "{{a}}から有効",
	"Payment for this_": "このプランの支払いは{{a}}に請求されます。",
	"By sharing your_2": "Live Viewを共有すると、他のユーザーに、間接的に世界中の運転の興奮と楽しみを体験させることができます。ただし、個人動画が送信されるので、どの情報を共有させるか十分注意してください。",
	"Option camera recording_": "駐車モードでのオプションカメラ録画",
	"Front and option camera_": "フロントカメラとオプションカメラは一緒に録画を行います。",
	"Option camera stops_": "オプションのカメラは、駐車モードに入った後、5分後に録画を停止します。通常モードになると録画が再開されます。",
	"Option camera rotation": "オプションのカメラ回転",
	"Option camera": "オプションカメラ",
	"Option camera security": "オプションカメラのセキュリティ",
	"Resubscribe until_": "再サブスクライブ終了日：{{a}}",
	"Firmware Update Caution": "ファームウェアアップデートの注意事項",
	"Please check below_": "DMC200のファームウェアをアップデートする前に、次の状態を確認してください：",
	"The camera's Wi-Fi_": "カメラのWi-Fiがオンになっていること。",
	"Check if your_": "カメラのWi-Fiがオンになっているか確認してください。",
	"DO NOT disconnect_": "ファームウェアのアップデート中は、同軸ケーブルを抜かないでください。",
	"The camera and_": "カメラとDMC200は分離できます。",
	"DO NOT try_": "カメラの再起動が完了するまで、他の機能を使用しないでください。",
	"Expecially Reboot camera_": "特にカメラを再起動する際のSDカードのフォーマットは、2つのデバイスを分離する上で重要です。",
	"Update anyway": "アップデートする",
	"Invited on_2": "あなたによって{{Invited Date}}に招待されました。オーナー",
	"BlackVue’s New firmware_": "BlackVueの新しいファームウェアが利用可能です",
	"valid thru_": "有効期限：{{a}}",
	"Billed monthly": "Billed monthly",
	"90 minutes Live_": "90 minutes Live View / Live Event Upload*",
	"or 2+ videos_": "or 2+ videos in full resolution*",
	"1GB Free Month_": "1GB Free Month Trial",
	"Cancel anytime": "Cancel anytime",
	"8+ hours Live_": "8+ hours Live View / Live Event Upload*",
	"or 12+ videos_": "or 12+ videos in full resolution*",
	"15+ hours Live_": "15+ hours Live View / Live Event Upload*",
	"or 23+ videos_": "or 23+ videos in full resolution*",
	Popular: Popular$8,
	"For Power Users": "For Power Users",
	"Estimates based on_": "* Estimates based on 4.5MB per minute of Live View, Quick View remote playback, or Live Event Upload file, and 190MB per full original resolution video download or playback (at 25Mbps bitrate). Daily idle Cloud connection data usage: 20MB per 24 hours. Data usage is shared among all types of services (Live View, Live Event Upload, etc.).",
	"Balanced Plan": "Balanced Plan",
	"For Light Cloud_": "For Light Cloud Use",
	"Front security (Normal mode)": "フロントセキュリティ (通常モード)",
	"Front security (Parking mode)": "フロントセキュリティ (駐車モード)",
	"BT (Parking mode)": "BT（駐車モード）",
	"LTE (Parking mode)": "LTE（駐車モード）",
	"Wi-Fi (Parking mode)": "Wi-Fi (駐車モード)",
	"Hand distraction": "手の注意逸散",
	Mask: Mask$8,
	"Second drowsy is_": "2度目の居眠り運転は、ライブイベントのアップロード録画を開始して、最初の居眠り運転から30秒以内に発生した居眠り運転です。",
	"Second drowsy alert": "2度目の居眠り運転警告",
	"BlackVue sim card_": "BlackVue SIMカードはカナダと米国でのみ使用できます。",
	"Global support is coming soon.": "グローバルサポートがまもなく利用可能になります。",
	"The video file not found_": "動画ファイルが見つからない、または再生中に問題が発生しました。再度お試しください。",
	"Start Voice Call": "音声通話を開始する",
	"End Voice Call": "音声通話を終了する",
	"Voice call in use": "音声通話が進行中です",
	"Enable microphone access_": "双方向音声通信機能を使用するには、マイクへのアクセスを有効にします。マイクにアクセスするには、ブラウザーの設定ページに進みます。",
	"You may need to_": "新しい設定を有効にするために、このページの再読み込みが必要になる場合があります。",
	"Eye status": "目の状態",
	"Start time of live event upload video": "ライブイベント アップロード動画の開始時刻",
	"Left eye": "左目",
	"Right eye": "右目",
	"Drowsy is occured when the driver close his/her eyes more then 1sec": "居眠り運転イベントは、運転者が1秒以上目を閉じた時に発生します",
	"Driver's Left eye movements with blinking count and period": "まばたきの頻度と時間を含む、運転者の左目の動き",
	"Driver's Right eye movements with blinking count and period": "まばたきの頻度と時間を含む、運転者の右目の動き",
	"Drowsy big data of the driver and after a Drowsy event occurs": "居眠り運転イベントが発生した後、運転者のまばたきのビッグデータが使用されます",
	"Sharing video to Event Map": "イベントマップに動画を共有",
	"Want to use a Voice call?": "音声通話を使用しますか？",
	"To use a voice call_": "音声通話を使用するには、Live Viewを再起動して[許可]をクリックします。",
	"There is no_": "まだ共有された動画がありません。\nリストが共有されていれば表示されます。",
	"Microphone blocked": "マイクがブロックされています",
	"Want to center the map on your location?": "現在地を中心に地図を表示したいですか?",
	"To let the app access your location_": "アプリが現在地にアクセスできるようにするには、Event Map を再起動し、プロンプトが表示されたら [OK] を選択します。",
	"Location access permission required": "位置情報へのアクセス許可が必要です。",
	"Are you sure you want_2": "このビデオを Event Map から削除してもよろしいですか?",
	"Two-way voice_2": "Two-way voice communication / Voice Call",
	"Not supported by DR650GW and DR650S_": "Not supported by DR650GW and DR650S",
	"DR650S Series only_": "DR650S Series only",
	"Cancel download?": "ダウンロードをキャンセルしますか?",
	"Your download is not_": "ダウンロードが完了していません。ダウンロードをキャンセルしますか?",
	"Continue download": "ダウンロードを続行",
	"Cancel download": "ダウンロードをキャンセル",
	"Share your video to the Event Map?": "ビデオをEvent Mapと共有しますか?",
	"Afterwards, according to the reaction to the video_": "その後、ビデオへの反応に応じて、人気ビデオに分類され、地図の人気ビデオで紹介されることがあります。",
	"Add hashtags and a brief description to describe your video.": "ハッシュタグと簡単なビデオの説明を追加してください。",
	"Would you like_": "Event Mapと共有しますか?",
	"Successfully added video_": "Event Mapと共有するビデオが無事追加されました!",
	"This video cannot_": "このビデオは、マップにピン留めするためのGPS位置データが不足しているため、共有できません。",
	"This video is_": "このビデオはすでにEvent Mapに追加されています。",
	"Share to Event Map": "Event Map に共有する",
	"Describe in more_": "ビデオでの状況を詳細に説明(オプション)",
	"Description(optional)": "説明（オプション）",
	"Recording mode": "録画モード",
	"Event triggers": "イベントトリガー",
	DMS: DMS$8,
	"Camera connectivity": "カメラの接続",
	"If not allowed_2": "許可されない場合、お客様の車の位置や速度は、クラウドからアクセスできません。",
	"Share Live View_": "ライブビュー映像の共有",
	"Share Live View_2": "ライブビューオーディオの共有",
	"Share camera profile": "カメラプロファイルを共有",
	"Parking impact": "駐車中の衝撃",
	"Parking events": "駐車中のイベント",
	"Audio recording": "録音",
	"Toggle the mic_": "マイクのオン/オフを切り替える",
	"Full HD_": "Full HD @ 60fps + Full HD @ 30fps",
	"Video quality": "映像画質",
	Extreme: Extreme$8,
	"More video files": "録音ファイルを増やす",
	"Fewer video files": "録音ファイルを減らす",
	"Camera rotation": "リアカメラ左右反転",
	"Video overlay": "ビデオオーバーレイ",
	"Date & time display": "日時表示",
	"Speed unit": "速度単位",
	"Check the orientation_": "車両に取り付けられたフロントカメラの向きを確認します。一致するオプションを選択して、ビデオを縦向きで録画します。",
	"Rotate 180º": "180º回転",
	"Rear camera rotation": "リアカメラ左右反転",
	"Check the orientation_rear": "車両に取り付けられたリアカメラの向きを確認します。一致するオプションを選択して、ビデオを縦向きで録画します。",
	"Mirror View": "ミラービュー",
	"Select Mirror View_": "[ミラービュー]を選択して、ビデオを横向きに反転します。",
	"Check the orientation_interior": "車両に搭載されているオプションカメラの向きを確認します。一致するオプションを選択して、ビデオを縦向きで録画します。",
	"Display off": "表示オフ",
	"Explore crowd-sourced Events_": "クラウドソースのイベント(衝撃、急ブレーキなど)をマップ上で検索したり、コミュニティで共有されているビデオを見たり、独自のイベントを投稿したりできます。",
	OFF: OFF$8,
	"Reboots once-a-day_": "製品の安定性を高めるため、1日に1回設定した時刻に駐車モードである場合再起動を行います。",
	"Set time": "時刻設定",
	"FW language": "ファームウェア言語",
	"Rear security_2": "リアセキュリティ",
	"Bluetooth (Parking mode)_2": "Bluetooth（駐車モード）",
	"Failed to save_2": "ライブイベントのアップロード設定の保存に失敗しました",
	"Event file will_": "イベントファイルは、ライブイベントアップロードストレージに自動的に保存されます。",
	"An impact was_": "An Impact was detected during Parking Mode.",
	"When exiting Parking_": "駐車モードを終了すると、BlackVue は、駐車モード中に衝撃が検出されたかどうかを通知します。\n\n注意:\n衝撃によってイベントビデオが生成されます。駐車モードの開始前と終了後の3分間に発生した衝撃は無視されます。",
	"Protect event files": "イベントファイルを保護",
	"Turning on this_": "オンにすると、最後の{{a}}個のイベントファイルが通常または駐車録画ファイルによって上書きされないように保護されます。",
	"Impact Events in_": "Impact Events in Normal(E) and Parking Mode(I)",
	"Manual Events_": "Manual Events (M)",
	"Once 50 Events_": "保護されるファイルは次のとおりです:\n\n通常(E)および駐車モード(I)での衝撃イベント \n手動イベント (M) \n\n{{a}}イベントが録画されると、新しいイベントが最も古いイベントを上書きします。",
	"Reckless driving unit": "車速が300 km/hまたは200 mphの",
	"Hard acceleration Event": "急加速イベント",
	Threshold: Threshold$8,
	"Triggers when the_": "カメラが、1秒当たりの加速度が設定したしきい値より速く上昇したことを検出するとトリガーされます。",
	"Triggers when the_2": "カメラが、速度が設定したしきい値より速く低下したことを検出すると、トリガーされます。",
	"Hard braking Event": "急ブレーキイベント",
	"Triggers when more_": "設定したしきい値を超えて走行している間に、2 秒以内に角度が 60 度を超えたことが検出されると、トリガーされます。",
	"Every event of DMC200_2": "DMSの検知機能は通常モードでのみ有効です。パーキングモードで電源を入れた場合、DMSカメラはビデオのみを記録します。",
	"The DMS system has_2": "DMSは、「検出済み」、「未検出」、「注意散漫」、「居眠り」、「マスクなし」ステータスのための顔検出ボックスと「手の注意散漫」ステータスのための動き検出ボックスを組み合わせます。",
	"One for face_": "One for face detection : Detected, Undetected, Distracted, Drowsy",
	"The other for_": "The other for motion detection",
	"On: Normal recording_": "On: Normal recording works while power is maintained in Parking Mode",
	"Off: DMS power_": "Off: DMS power off after 5 minutes when entering Parking Mode, Normal recording works until just before off",
	"Drowsy and Distracted_": "Drowsy and Distracted each have three sensitivity conditions.",
	"Please refer to_": "Please refer to the guide interface below.",
	Drowsiness: Drowsiness$8,
	"Drowsiness occurs when_": "眠気は、運転中に運転手が1秒以上両眼を閉じて2秒間あくびをすると発生します。",
	"Distracted occurs when_": "運転者の頭が前方から50度以上離れた場合に発生します。",
	"A hand distraction_": "A hand distraction occurs when the driver removes one hand from the steering wheel. [*Smoking and phone calls may be suspected.]",
	"Mask off event_": "Mask-off event occurs in two ways. First is when the driver gets in the car without a mask. Second is when the driver takes their mask off",
	"High When the_": "High : When the driver closes their eyes for more than 1 second, it is considered drowsy driving.",
	"Middle When the_": "Medium : When the driver closes their eyes for more than 1.5 second, it is considered drowsy driving.",
	"Low When the_": "Low : When the driver closes their eyes for more than 2 second, it is considered drowsy driving.",
	"High If the_": "High : If the angle of the head is more than 50 degrees away from the front for 3 seconds, it is detected as Distracted.",
	"Middle If the_": "Medium : If the angle of the head is more than 50 degrees away from the front for 5 seconds, it is detected as Distracted.",
	"Low If the_": "Low : If the angle of the head is more than 50 degrees away from the front for 7 seconds, it is detected as Distracted.",
	Direct: Direct$8,
	"Camera Wi-Fi credentials": "カメラWi-Fi認証情報",
	"Network name(SSID)": "ネットワーク名（SSID）",
	"Seamless pairing": "Seamless Pairing",
	Remote: Remote$8,
	"Hotspot settings": "ホットスポット設定",
	"Hotspot name": "ホットスポット名（SSID）",
	"Hotspot name must_": "Hotspot name must be at least 5 characters long",
	"Public cameras may_": "公共カメラは、エクスプローラータブまたはワールドマップに表示される場合があります。",
	"Hard Cornering Event": "ハードコーナリングイベント",
	"Over speed_2": "速度超過",
	"Second drawiness alert": "2度目の眠気アラート",
	"Low Voltage Warning_2": "手の注意逸散",
	"(You)_2": "{{a}} ( ユーザー )",
	"This video has been reported_": "このビデオは報告されており、管理者によって削除されました。",
	"Normal Mode recording": "通常モード録音",
	"ON : the camera_": "オン: カメラはループで連続的に録画します。",
	"OFF : the camera_": "オフ: カメラは運転中にイベントビデオのみを録画します。",
	"In both modes_": "どちらのモードでも、検出された衝撃によってイベントのビデオ録画がトリガーされます。",
	"Continuously records_": "1秒あたり1フレームの速度の1分ビデオで、30分間のアクションを連続録画します。",
	"Choose detection regions_": "風に揺れる樹木や遠い場所にある移動物体によって不要な録画がされないように、検知領域を選択することができます。",
	"Your previous plan is expired.": "以前のプランは期限切れです。",
	"Upgrade the plan to restore the camera": "プランをアップグレードしてカメラを復元します\n(%@)",
	"Remove from cloud": "クラウドから削除",
	"Are you sure you want to Remove_": "Cloudスロットから取り外してもよろしいですか?",
	"Remove: It doesn’t mean_": "取り外し:これは、カメラのデータを削除するのではなく、クラウドカメラの数だけ予備のスロットを作成することを意味しています。",
	"Now the camera is removed from cloud slot": "カメラがCloudスロットから取り外されました。",
	"How to delete camera list": "リストからカメラを削除する方法",
	Update: Update$8,
	"Camrea setting": "カメラ設定",
	"Notification setting": "プッシュ通知設定",
	"Driving reports": "運転レポート",
	"Cloud connection steps": "クラウド接続ステップ",
	"Download the BlackVue app to add a camera": "BlackVueアプリをダウンロードしてカメラを追加",
	"To see your camera in the BlackVue cloud viewer_": "BlackVue Cloudビューアでカメラを表示するには、まずカメラをクラウドに接続する必要があります。iOSおよびAndroid用のBlackVueアプリを使用して、BlackVueカメラを簡単にセットアップしてクラウドに接続します。",
	"Download the BlackVue app to see a Wi-Fi connected camera": "BlackVueアプリをダウンロードして、Wi-Fi接続されたカメラを表示します",
	"BlackVue Cloud web viewer only supports_": "BlackVue Cloud Webビューアは、クラウド接続のドライブレコーダーのみをサポートします。BlackVueアプリをダウンロードして、Wi-Fi接続されたドライブレコーダーを表示します。",
	"You can restore the data if_": "このカメラを再度同じアカウントに登録すると、データを復元できます。ただし、アカウントが削除されると、すべてのファイルが失われます。",
	"How to add camera": "カメラの追加方法",
	"Try to wait 2-3 minutes if you just registered the camera.": "カメラを登録したばかりの場合は、2～3分待ちます。",
	"Try to check the Cloud Connection Settings again_": "それでもカメラがクラウドに接続しない場合は、クラウド接続設定をもう一度確認してください。",
	"Motion Detection": "モーション検知",
	"Parking recordings occur_": "目に見える動きが検出されると、駐車録画が行われます。",
	"Motion Sensitivity": "モーション感度",
	"Motion Detection Sensitivity": "モーション検出感度",
	"Select Detection Region": "モーション検知領域を設定する",
	"Speed alert_2": "速度警告",
	"Live Event Upload_2": "Live Event Upload",
	"Beep Alert": "ビープ音",
	"Parking Impact History_": "駐車中に発生したイベント履歴のアラート",
	"To register your_": "SOSボタンを登録するには、BlackVueアプリを使用する必要があります。",
	"SOS button on/off": "SOS ボタンのステータス",
	"File sharing to Event Map is_": "Event Map へのファイル共有は現在利用できません。 後でもう一度確認してください。",
	"Email Notifications": "メール通知",
	"Push Notifications_2": "プッシュ通知",
	"Optional Camera Rotation": "オプションカメラの向き",
	"Optional Camera Security": "オプションカメラのセキュリティ",
	Option: Option$8,
	"(Owner)": "{{a}} (オーナー)",
	"SOS button": "SOS ボタン",
	"This video has been reported_bold": "このビデオは報告されており、<b>管理者によって削除されました。</b>",
	"Number of events_2": "イベント数",
	"My Shared Videos": "マイ共有ビデオ",
	"No Hashtags": "ハッシュタグなし",
	"I have read and agree_": "利用規約を読み同意しました。",
	"14 years old_": "14歳以上",
	Required: Required$8,
	Optional: Optional$8,
	"Profile information_": "プロファイル情報は、[アカウント設定]ページで編集できます。",
	"Automatically Add Live_": "Event Map へのイベント自動アップロードファイルの自動共有",
	"You must be 14 years_": "BlackVueアカウントを作成するには、14歳以上である必要があります",
	"Use 8 or more characters_": "文字、数字、記号のいずれかを組み合わせた8文字以上を使用してください",
	"Protected files include_": "保護されるファイルは次のとおりです:<br/>ㆍ通常(E)および駐車モード(I)での衝撃イベント <br/>ㆍ手動イベント (M) <br/><br/>{{a}}イベントが録画されると、新しいイベントが最も古いイベントを上書きします。",
	"Protected files include": "Protected files include",
	"If you turn_": "ボイスガイダンスをオフにすると、以下のリストもオフになります。",
	"Live Event Upload_success": "ライブイベントのアップロード設定が正常に保存されました。",
	"Video type": "録画映像タイプ",
	"Notify the Owner": "オーナーに通知する",
	"Adjusting the cut-off voltage_2": "Adjusting the cut-off voltage to a lower setting may result in your dash cam draining more power from your battery. This could result in warning messages of battery drain or affect other vehicle functions.\nPlease consult with your dealership before lowering the voltage.",
	Others: Others$8,
	"This video has been removed.": "このビデオが削除されました。",
	"Please assign cameras_": "このグループにカメラを割り当ててください。",
	"Are you running_": "再生が見れませんか?",
	"Upgrade your plan_": "プランを無制限再生のフリートプランやその他のクラウド限定機能にアップグレードしてください。",
	"Are you running_Liveview": "ライブビューが見れませんか?",
	"Upgrade your plan_Liveview": "プランを無制限ライブビューのフリートプランやその他のクラウド専用機能にアップグレードしてください。",
	Stay: Stay$8,
	"Go to Fleet Plan": "フリートプランに移動",
	"It looks like the video file is being prepared. please try again later.": "動画ファイルを準備中のようです。 後でもう一度試してください。",
	"Oops!": "おっとっと！",
	"Please back up_": "この設定を変更する前に、すべての重要な記録をバックアップしてください。",
	"When you save_": "設定を保存すると、安定した動作を確保するために、microSD カードがフォーマットされ、すべての記録が削除されます。",
	"This is an unregistered_": "未登録メールです。 アカウントの作成ページに移動しますか?",
	"Camera name must_2": "カメラ名は5～30文字でなければなりません。",
	"G-sensor (Normal mode)": "Gセンサー (常時録画モード)",
	"G-sensor (Parking mode)": "Gセンサー (駐車録画モード)",
	"Up & down": "上下",
	"Front & back": "前後",
	"Rotate Video 180º": "Rotate Video 180º",
	Mask_2: Mask_2$8,
	"Priority event": "Priority Event",
	"There is no_camera": "There is no camera that your owner assigned to you.",
	"Camera SSID": "Camera SSID",
	"The BlackVue dashcam_2": "The BlackVue dashcam is not compatible with 5GHz wireless networks",
	"Driver detection box_2": "Driver Detection Box",
	"DMS camera recording_2": "DMS Camera Recording in Parking Mode",
	Low_2: Low_2$8,
	Medium_2: Medium_2$8,
	High_3: High_3$8,
	"Live Event Upload_3": "Live Event Upload",
	"Driving Impact": "Driving Impact",
	"Video source_2": "Video Source",
	"Front camera_2": "Front Camera",
	"Rear camera_2": "Rear Camera",
	"Optional Camera": "Optional Camera",
	"Motion Detection_2": "Motion Detection",
	"Rear camera stops_2": "Rear camera stops recording 5 minutes after entering Parking Mode. Recording restarts when entering normal mode.",
	"Passenger vehicle": "Passenger Vehicle",
	"Heavy vehicle": "Heavy Vehicle",
	Highest_3: Highest_3$8,
	Extreme_2: Extreme_2$8,
	"Less recording files": "Fewer Recording Files",
	"Camera rotation_2": "Camera Rotation",
	"Share camera profile_2": "Share Camera Profile",
	Private_2: Private_2$8,
	"BlackVue Live": "BlackVue Live",
	"Important All saved_": "Important! All saved videos are about to be deleted. Tap Cancel and back up important files if needed.",
	"Whenever saving settings_": "Whenever saving settings after changing the time zone, the SD card is initialized and all stored files are deleted.",
	"Do you want_": "Do you want to save your changes?",
	"No groups": "No groups",
	Lite: Lite$8,
	"USD per Camera": "USD per extra Camera",
	"up to Cameras": "up to Cameras",
	"All the P Plan_": "すべての <b>{{a}}</b> プランの機能に加えて:",
	"User Roles and Permissions": "ユーザーの役割と権限",
	"Geofence Setup (Web) and alerts": "Geofence Setup (Web) and alerts",
	"N Times": "{{a}} 回",
	"N Minutes": "{{a}} 分",
	"Emergency Alarm": "緊急アラーム",
	"Playback, Live View": "再生、ライブビュー",
	"Your driving record : Daily, Monthly": "運転記録：日次、月次",
	"Real-time Conversation": "リアルタイムの会話",
	"Initiate a conversation_": "Dashcamのスピーカーとマイクを介してドライバーとの会話を開始します。",
	"Remote Voice Communication": "リモート音声通信",
	"See the last location_": "カメラの最後の場所をご覧ください",
	"Check your cars_": "地図上の車のリアルタイムGPSデータを確認して、車両を見つけて、運転や駐車など、そのステータスに関する情報を取得します。",
	"Supported models_": "*サポートされているモデル：Sおよび初期Xシリーズモデル",
	"GPS Tracking &_": "GPSトラッキングとマップ上のビデオ（スマート/フリート）",
	"Track your cars_": "地図上の車の位置と速度を追跡してください！",
	"GPS Tracking: visualize_": "GPSトラッキング：マップ上の運転ログを視覚化します。\nマップ上のビデオ：コンテキスト情報（速度、イベントタイプ）を表示し、関連するビデオをマップから再生します。",
	"Visualize your cars_": "地図上で車の位置と速度を可視化！",
	"The feature enables_": "この機能は事故前の5秒間を含むビデオ映像のクラウドへのアップロードを可能にします。\n",
	"Camera profile setting": "Camera profile setting",
	"Are you running_Download": "Are you running out of chance to Download Video?",
	"Upgrade your plan_Download": "Upgrade your plan to Fleet Plan for Unlimited Download, and other Cloud -Exclusive features.",
	"This feature is available for Smart and Fleet_": "This feature is available for Smart and Fleet Plan subscribers only.",
	"Rear camera will keep_": "リアカメラは、ドライブレコーダーの温度ステータスが「高温」に変更されたとき、駐車モードでの録画を停止します。リアカメラは、ドライブレコーダーの温度ステータスが「通常温度」に変更された後、再び録画を開始します。注意: 電子機器を保護するため、高い外部温度のためにBlackvueはシャットダウンする可能性があります。",
	"Get Unlimited Cloud_": "無制限のクラウド再生と最大{{a}}台のカメラの管理が可能です。",
	"Up to N cameras_": "Up to {{a}} cameras (+ {{b}} USD Extra charge)",
	"N Minutes per Day": "1日{{a}}分",
	"Drowsiness sensitivity is_": "居眠り運転の感度は、まばたきの時間を基に信頼性の高いBlackVueアルゴリズムを使用して設定されます。 <br> <br> 脇見運転の感度は、前方からの運転者の頭部の角度と、その持続時間によって設定されます。",
	"Not available with this plan": "Not available with this plan",
	"The optional camera records_": "オプションカメラは駐車モードで録画します。",
	"Smart and Fleet_": "Smart and Fleet Plan<br/>subscribers only",
	"This feature is_smart": "This feature is available for Smart and Fleet Plan subscribers only.",
	"Camera Registration": "カメラ登録",
	"Voice Call": "Voice Call",
	"N times per Month": "{{a}} times per Month",
	"Recommended for higher bitrate_": "より高いビットレートとより良いビデオ品質に推奨されます。",
	"Recommended for for better compatibility_": "デスクトップおよびモバイルデバイスとの互換性を向上させるために推奨されます",
	"A minute of front camera_": "1分間のビデオ（フロントカメラ）の推定ファイルサイズ",
	"Extreme(N Mbps): N MB_": "Extreme ({{ex1}}Mbps) : {{ex2}}MB\nHighest ({{ht1}}Mbps) : {{ht2}}MB\nHigh ({{hi1}}Mbps) : {{hi2}}MB\nNormal ({{no1}}Mbps) : {{no2}}MB",
	"File size information reflects_": "ファイルサイズ情報は可能な最大サイズを反映し、実際のファイルサイズは記録条件によって異なる場合があります。",
	Bitrate: Bitrate$8,
	"Connection has been_": "接続が失われました。\n接続の再確立...",
	"Unable to establish_": "カメラとの接続を確立できません。\nデバイスが適切に接続されていることを確認し、再試行してください。",
	"Purchased by Payment Service": "支払いサービスによって購入されました",
	"Up to N Cameras": "最大{{a}}台のカメラ",
	"Unlimited Live View": "ライブビュー：使い放題",
	"N Days GPS Tracking": "{{a}}日間のGPSトラッキング\n",
	"Unlimited Playback and Download": "無制限の再生とダウンロード",
	hours: hours$8,
	"Live Event Upload or_": "Live Event Uploadまたはフル解像度の12以上のビデオ",
	"During the usage period of the One Plan_": "One Planサービスの利用期間中は、サブスクリプションプランの変更はできません。別のプランに切り替えるには、BlackVueカスタマーサポートに連絡してOne Planのサブスクリプションをキャンセルしてください。",
	"Service Period (Include SIM Data)": "サービス期間（SIMデータを含む）",
	"Purchase the BlackVue One Package_": "One Planを1年間無料で利用するには、BlackVue One Packageを購入してください。",
	"3GB SIM Data Plan": "3GBのSIMデータプラン",
	"Unlimited Live View, Playback and Download": "無制限のライブビュー、再生、ダウンロード",
	"within data availability": "データ利用可能範囲内で",
	"The BlackVue One Plan is a 1-year_": "BlackVue One Planは、BlackVue One Packageの購入によってのみ利用可能な1年間のクラウドサービスプランであり、ダッシュカメラ、1年間の3GB/月のデータプラン（米国とカナダ向け）、および1年間のクラウドサービスプランがバンドルされています。",
	"The BlackVue One Package is available_": "BlackVue One Packageは、BlackVueオンラインストアでのみ提供されています。",
	"Go to BlackVue Shop": "BlackVueショップに行く",
	"Anonymous Cam": "匿名カメラ",
	"App only": "アプリのみ",
	Expires: Expires$8,
	"N days remaining": "{{a}}日残っています",
	"No action needed_": "<b>何もする必要はありません。</b> 新しい割引価格は、9月13日以降の次回支払いから自動的に適用されます。",
	"The new reduced price_": "新しい割引価格は自動的にあなたのアカウントに適用されます。",
	"Smart Plan Subscriber?": "Smartプランの購読者ですか？",
	"Fleet Plan Subscriber?": "Fleetプランの購読者ですか？",
	"Please take a moment to_": "弊社にアカウントの移行を許可するための時間を取ってください。",
	"Starting from now and_": "<b>現在から10月31日まで</b>、<a href=\"https://form.jotform.com/232411253056041\" target=\"_blank\">このリンクをクリックして</a> Fleetアカウントのメールアドレスを入力することで、変更をお手伝いいたします。変更を処理するために少々お時間をいただきます。また、9月13日から新しい価格で既存のアカウントをキャンセルし、再度購読することができます。",
	"Once activated_": "一度アクティブにされると、One Planは一時停止または非アクティブにできません。",
	"Once the One Plan is activated_": "One Planがアクティブになると、One Packageは返金できません。",
	"Up to N Cloud Camera Slot": "{{a}}までのクラウドカメラスロット",
	"nGB of Cloud Storage": "{{a}}GBのクラウドストレージ",
	"Get started for free_": "Get started for free, no credit card required. Includes Alert Push Notifications, limited Remote Live View and cloud storage.",
	"The BlackVue One Plan is exclusively_": "The BlackVue One Plan is exclusively available through the purchase of a BlackVue One Package. 3GB/mo data plan is for US and Canada only. BlackVue Cloud’s Free Plan, Lite Plan (1~3) and Smart Plan (1~3) accounts can upgrade to One Plan. However, Lite Plan (4~15), Smart Plan (4~15) and Fleet Plan accounts can not be upgraded to One Plan.",
	"For N year": "For {{a}} year",
	"Included in the One Package": "Included in the One Package",
	"3GB SIM Data Plan for N year": "3GB SIM Data Plan for {{a}} year",
	"One Plan Cloud Service for N year": "One Plan Cloud Service for {{a}} year",
	"The BlackVue One Package includes_": "The BlackVue One Package includes all you need to enjoy BlackVue Cloud for a whole year!",
	"4K LTE Dash Cam_": "4K LTE Dash Cam, Cloud Service and Data Plan",
	"nGB included": "{{a}}GB included",
	"nGB per camera": "{{a}}GB per camera",
	"N Days Live Event Upload": "{{a}} Days Live Event Upload",
	"Up to N Dash Cameras": "Up to {{a}} Dash Cameras",
	"Step N/N": "ステップ {{a}}/{{b}}",
	"Cloud Connection": "クラウド接続",
	"To pair your dashcam": "ダッシュカメラをバッテリーにペアリングするには、クラウドに接続してください。",
	Check: Check$8,
	"Unpair Battery": "バッテリーのペア解除",
	"Are you sure you want to unpair": "このバッテリー(%@)をカメラからペア解除してもよろしいですか？",
	"Unpair: It doesn't mean": "解除ペアリング：これはバッテリーのデータを削除することを意味しません。",
	"*The paired battery will": "*ペアリングされたバッテリーも一緒に削除されます。",
	"Would you like to pair this": "このバッテリーをペアリングしますか？",
	"Battery successfully paired": "バッテリーが正常にペアリングされました。",
	"Now you can directly connect to": "カメラリストからバッテリに直接接続できます。",
	"Pairing failed": "ペアリングに失敗しました。もう一度やり直してください。",
	"Battery Name": "バッテリー名",
	"Capacity History": "容量履歴",
	"The graph displays capacity": "グラフは、クラウド接続からのデータを使用しておおよそのバッテリーレベルを表示します。\n バッテリー容量は、温度、ドライブレコーダーの設定、およびイベントのトリガ頻度によって異なる場合があります。",
	"Last 24 Hours": "過去24時間",
	"Last 7 Days": "過去7日間",
	"Battery Level": "バッテリーレベル",
	"Temperature History": "温度履歴",
	"The graph displays temperature": "グラフはクラウド接続からのデータを使用して、おおよその温度レベルを表示します。",
	"Temperature Level": "温度レベル",
	"Connecting alert": "[ 接続中 ]\n接続時にデータが表示されます。",
	"Low Output power Alert": "[ 出力電源遮断 ]\n出力電圧が低すぎて、接続されたデバイスの電力供給が制限されています。",
	"High temp Alert": "[ 入力電源が切断されました ]\nバッテリー温度が高すぎて、充電が制限されています。",
	"Remaining time": "残り時間",
	"Remaining time estimate": "接続されたデバイスの総消費電力に基づく推定値です。\n バッテリーに接続した後、30秒ごとに再計算されます。",
	"Setting changed": "設定が変更されました",
	"Setting change failed": "設定の変更に失敗しました",
	"Low Input power Alert": "[ 入力電源が切断されました ]\n充電電圧が低すぎて、充電が制限されています。",
	"High Input power Alert": "[ 入力電源が切断されました ]\n充電電圧が高すぎて、充電が制限されています。",
	"Low temp_Cut off Alert": "[ 入力電源が切断されました ]\nバッテリー温度が低すぎて、充電と持続時間が制限されます。",
	"Low temp Alert": "[ 低温 ]\nバッテリー温度が低すぎて、持続時間と充電速度が制限されます。",
	"Low capacity Alert": "[ 低容量 ]\nバッテリー容量が低すぎます。\n車を運転して充電してください。",
	"Back to list": "リストに戻る",
	Saving: Saving$8,
	Now: Now$8,
	"Power supplying is limited": "電源供給が <b>制限されています</b>",
	"This battery is already paired": "このバッテリーはすでにペアリングされています。",
	"Connecting to Battery": "バッテリーに接続中",
	"Paired battery": "ペアリングされたバッテリー",
	"Battery unpairing failed": "バッテリーのペアリング解除に失敗しました。もう一度やり直してください。",
	"A connection is already active": "接続は既にアクティブです。後で再度お試しください。",
	"Searching for battery": "バッテリーを検索中",
	"Select battery to pair with your camera": "カメラとペアにするバッテリーを選択してください。",
	"Unable to connect": "接続できません",
	"A connection error has occurred": "接続エラーが発生しました。もう一度やり直してください。",
	"The paired dashcam has been disconnected": "ペアリングされたダッシュカムがクラウドから切断されました。\n以下の条件を確認してください。",
	"Check if the battery is not fully discharged": "バッテリーが完全に放電されていないかどうかを確認してください。",
	"Check the Cloud connection of the paired dashcam": "ペアリングされたダッシュカムのクラウド接続を確認してください。",
	"Connection lost": "接続が切断されました",
	"A connection error has occurred shortly": "接続エラーが発生しました。しばらくしてから再接続してください。",
	"Charging is limited": "充電が<b>制限されています</b>",
	"Cannot connect to the battery": "バッテリーに接続できません。",
	"Please check the Cloud connection of the camera": "カメラのクラウド接続をチェックしてください。",
	"Charging complete in": "充電完了まであと %@",
	"Current Capacity": "現在の容量",
	"Output Voltage": "出力電圧",
	"Charging Voltage": "充電電圧",
	Beep: Beep$8,
	"Battery Capacity": "バッテリーの容量",
	"Battery connection failed": "バッテリーの接続に失敗しました",
	"Expansion battery": "スペアバッテリー",
	"Make sure it is switched on and within range": "• 電源が入っていて、携帯電話の通信圏内にあることを確認してください。",
	"Make sure it is not wirelessly connected to another device": "• 別のデバイスにワイヤレスで接続されていないことを確認します。",
	"Detected batteries": "バッテリーが検出されました",
	"Can't see your battery": "バッテリーが表示されませんか?",
	"Download the Blackvue app to check": "バッテリーをリモートでチェックするには、BlackVueアプリをダウンロードしてください",
	"By Using the app": "アプリを使用することで、ダッシュカムをバッテリーとペアリングし、クラウド上でバッテリーの容量を監視することができます。ペアリング後は、BlackVueクラウドビューアでバッテリーを確認できます。",
	Unpair: Unpair$8,
	"Occurs when the driver closes_": "運転中に運転手が両目を閉じると発生します",
	"Occurs when the driver's head_": "運転手の頭部が正面から 50 度以上離れた場合に発生します。",
	"Only detects distraction above_": "設定された値以上の脇見運転のみを検出します。カメラ設定 > イベントトリガー > 無謀な運転ユニット'で単位を変更できます。",
	"Occurs when the driver is not wearing_": "運転手がシートベルトを着用していない場合に発生します。",
	"Overlays a face detection box_": "DMS カメラのライブおよび記録された映像に顔検出ボックスを重ねる。",
	"Seat Belt": "シートベルト",
	Detected: Detected$8,
	"No Seat Belt": "シートベルトなし",
	"Fatigue Risk Alert": "疲労リスク警報",
	"The time is synchronized_Email": "時間は電子メール通知の時間と同期されます。",
	"Sends an alert when drowsiness is_": "初期の眠気の後に眠気が検知されるとアラートを送信します。",
	"Data updates upon connection": "接続時にデータが更新されます。",
	"Sends a notification if_": "ドライブ中に '時刻設定' を超過した場合、通知を送信します。",
	"Data updates Alert": "[ 接続中 ]\n接続時にデータが更新されます。",
	"Cannot save settings": "設定を保存できません",
	"The time is synchronized_Push": "時間はプッシュ通知の時間と同期されます。",
	"The file has been overwritten or deleted": "ファイルが上書きされたか、削除されました。",
	"Box Pro Models Settings": "Box Proモデル設定",
	"Push notifications can be configured_": "プッシュ通知はカメラの通知設定で構成できます。",
	"Recording Video": "ビデオ録画",
	"Cameras settings": "カメラ設定",
	"Please configure the settings": "設定を行ってください",
	"Speed Priorities": "スピード優先順位",
	"Set Speed Priority": "スピード優先順位を設定",
	"Geofence-enter": "ジオフェンス-進入",
	"Geofence-exit": "ジオフェンス-退出",
	"Geofence-pass": "ジオフェンス-通過",
	"Geofence-speed alert": "ジオフェンス-速度警告",
	"Drive Position": "運転席の位置",
	"Left-Hand Drive": "左ハンドル",
	"Right-Hand Drive": "右ハンドル",
	"Please configure this setting_": "ドライバーが正しく検出されない場合は、この設定を変更してください。",
	"A new feature in the BlackVue settings_": "BlackVue 設定にカメラ時間を同期するための新機能が追加されました。正確な時間を記録するには、カメラの時間を一度同期する必要があります。",
	"Feature location_": "機能の場所:\nカメラ設定>システム>時刻同期",
	"Time Sync": "時刻同期",
	"You can sync the time between_": "デバイスとBlackVueカメラの間で時間を同期できます。同期にはSDカードのフォーマットが必要です。進む前に、必要なビデオをバックアップしてください。",
	"Voice Alert": "音声警告",
	"Provides a voice alert_": "運転中に設定時間を超えると、カメラから音声アラートが提供され、通知が送信されます。",
	"Please enter a value": "Please enter a value.",
	"Notices & Notifications": "ニュースと通知",
	"Only detects drowsiness above_": "設定された値以上の居眠りのみを検出します。カメラ設定 > イベントトリガー > 無謀な運転ユニット'で単位を変更できます。",
	Promotion: Promotion$8,
	Notice: Notice$8,
	"View More": "もっと見る",
	"Read More": "続きを読む",
	"Detection Box": "検出ボックス",
	"Seatbelt Detection Box": "シートベルト検出ボックス",
	"Drive Position Detection Box": "ドライブ位置検出ボックス",
	"Fleet Subscription Promotion (50%)": "フリート サブスクリプション プロモーション (50%)",
	"BlackVue Fleet Tracking exclusive features_": "BlackVue Fleet Tracking は、パワー ユーザーと企業の両方を対象とした独自の機能 (複数のユーザーとカメラ、ジオフェンシング、Web ビューアなど)。",
	"Special Discount (50% off)": "特別割引（50％オフ）",
	"*Promotion applied for 12 months": "※プロモーションは12ヶ月間適用されます",
	"*Payment will be made starting next month.": "※お支払いは翌月からとなります。",
	"[About using promotions]": "【キャンペーンのご利用について】",
	"The promotion is free for the first month_": "このプロモーションは最初の 1 か月間無料で、翌月から 12 か月間課金されます。",
	"For users with an existing Lite/Smart subscription_": "既存の Lite/Smart サブスクリプションを持つユーザーの場合は、既存のアプリのサブスクリプションを個別にキャンセルする必要があります。キャンセルしないと、既存のアプリのサブスクリプションがアカウントに請求される可能性があります。",
	"Please be sure to cancel your app subscription_": "必ず無料期間内にアプリの解約を行ってください。二重支払いは返金されません。",
	"You will be changed to Fleet Plan immediately_": "既存のライト/スマート プランの残りのサブスクリプション期間が期限切れになっていない場合でも、すぐにフリート プランに変更されます。",
	"You can cancel Fleet Plan any time.": "フリート プランはいつでもキャンセルできます。",
	"From February 2025, please go to the Fleeta service and use it.": "プロモーションがキャンセルされると、プロモーションは再適用されません。",
	"After promotion expires_": "プロモーションの有効期限が切れると、既存のフリート プランのサブスクリプション料金で自動的に更新されます。",
	"(Required) I have read the promotion instructions_": "(必須) プロモーションの説明を読み、支払いに同意します。",
	"Upgrade to Fleet Plan immediately": "フリート プランに今すぐアップグレードする",
	"Important Notice:": "重要なお知らせ:",
	"Switch of BlackVue Web Viewer to Fleeta Web Viewer": "BlackVue Web ビューアから Fleeta Web ビューアへの切り替え",
	"To provide better features and quality_": "より優れた機能と品質を提供するために、BlackVue Web ビューア サービスは間もなく Fleeta と呼ばれる新しいフリート Web ビューア サービスに切り替わります。 Fleeta サービスはフリート プラン ユーザーのみが利用できるようになります。 Fleeta サービスは、新しい Fleeta 専用アプリとともに 2025 年 3 月に開始されます。詳細については、<a href=\"https://www.fleeta.io\" target=\"_blank\">fleeta.io</a> にアクセスしてください。",
	"We kindly ask for your understanding_": "サービス向上を目的とした変更となりますので、何卒ご理解賜りますようお願い申し上げます。この移行に関するご質問は、CS センターまでお気軽にお問い合わせください。",
	"Don’t show this again for this month": "今月はこれを再度表示しないでください",
	"Fleet Plan Subscription Promotion": "フリートプランのサブスクリプションプロモーション",
	"Period : December 2, 2024 ~ May 31, 2025": "期間：2024年12月2日～2025年5月31日",
	"See more details": "詳細を見る",
	"To continue improve quality and provide better service_": "引き続き品質を向上させ、より良いサービスを提供するために、BlackVue Web Viewer サービスは間もなくフリート プラン専用サービスに切り替わります。 2025 年 3 月下旬以降、無料または他のプランでは利用できなくなります。",
	"We have prepared special discount offers for_": "既存の Web Viewer ユーザー向けに特別な割引オファーを用意しました。詳細は下記よりご確認ください！より良いサービスをご提供するため、この変更を実施するにあたり、ご理解とご支援を賜りますようお願い申し上げます。\n",
	"*If you are subscribed in-app_": "※アプリ内購読を行っている場合は、必ずアプリ内購読を解除してください。",
	"Enjoy your BlackVue Cloud service with your dashcam.": "車載カメラで BlackVue Cloud サービスをお楽しみください。",
	"Available Cloud Camera slot(s)_": "利用可能なクラウド カメラ スロット : {{d}}",
	"Not eligible for the promotion.": "プロモーションの対象外です。",
	"You have already used_": "あなたはすでにこのプロモーションを利用しています。プロモーションがキャンセルされると、再適用することはできません。",
	"Go to Cameras": "カメラに移動",
	"Congratulations !": "Congratulations !",
	"Fleet Plan user": "Fleet Plan user",
	"Let your BlackVue monitor_": "BlackVue で車を監視し、事故を警告します。衝撃が検出されるとすぐに、BlackVue はスナップショットを伴う通知を携帯電話に送信します。\n",
	"Live Event Upload feature automatically_": "ライブ イベント アップロード機能は、事故前の映像を含むビデオ映像を BlackVue クラウド ストレージに自動的にアップロードし、ビデオを安全に保ちます。",
	"*Buffer time varies by model.": "※バッファ時間はモデルにより異なります。",
	Explore: Explore$8,
	"Cloud Storage": "クラウドストレージ",
	"My Cloud Cameras": "私のクラウドカメラ",
	"My Cloud Cameras Only": "私のクラウドカメラのみ",
	"BlackVue Live Camera": "BlackVue ライブカメラ",
	"*For BlackVue Live Cameras_": "*BlackVue ライブ カメラの場合、カメラ設定でパブリックとして共有されているカメラのみがマップ上に表示されます。",
	"*Share Method_": "※共有方法：カメラ設定＞プライバシー",
	"Once the promotion is canceled_": "プロモーションがキャンセルされると、プロモーションは再適用されません。",
	"It will show_": "それらが利用可能になるとここに表示されます。",
	"Deactivate Cloud": "クラウドを非アクティブ化する",
	"Are you sure you want to deactivate_": "このカメラのクラウドを無効にしてもよろしいですか?",
	"Deactivate : It doesn’t_": "いつでもクラウドをアクティブ化できます。カメラは、非アクティブ化が完了した後に削除できます。",
	Deactivate: Deactivate$8,
	"*If you made the payment through_": "※アプリで決済した場合はアプリを再起動してください。",
	"Connect Dashcam Locally (Wi-Fi)": "ドライブレコーダーをローカルに接続 (Wi-Fi)",
	"Cloud Connection Setting": "クラウド接続設定",
	"Camera Profile": "カメラプロファイル",
	"Camera Settings": "カメラ設定",
	"Format MicroSD Card": "microSDカードのフォーマット",
	"Remote Firmware Update": "リモートファームウェアアップデート",
	"Remove from Cloud": "クラウドから削除",
	"The location may not be accurate_": "カメラがクラウドに接続されていないため、位置が正確ではない可能性があります。",
	"The location of the camera cannot be found_": "カメラの位置が見つかりません。クラウド接続設定を確認してください。",
	"Manage\nFLEETA Drive": "管理\nFLEETA ドライブ",
	"Cloud\nConnection": "クラウド\n接続",
	"Available on FLEETA App": "FLEETAアプリで利用可能",
	"Available for Cloud dashcam OR on FLEETA App.": "クラウドダッシュカムまたはFLEETAアプリで利用可能です。",
	"Get started with_": "無料1ヶ月トライアルを始める",
	"Experience all of_": "FLEETAのプレミアム機能を1か月の試用期間中無料で体験してください。\n\nいつでもキャンセル可能—約束は不要です",
	"Welcome to FLEETA Webviewer.": "FLEETA Webviewerへようこそ。",
	"Let FLEETA get_": "FLEETAにあなたを知ってもらいましょう",
	"Help improve your_": "詳細を共有して、体験を改善するのを手伝ってください",
	"Business Industry": "事業業界",
	"Vehicle & Cargo": "車両と貨物",
	Compliance: Compliance$8,
	"Would you like to skip?": "スキップしますか？",
	"What is your business industry?": "あなたの事業業界は何ですか？",
	"Transportation & Logistics": "輸送・物流",
	"Rental & Leasing": "レンタル・リース",
	"Construction & Building": "建設・建築",
	"Government & Public": "政府・公共",
	"Facility & Utility Management": "施設・ユーティリティ管理",
	Manufacturing: Manufacturing$8,
	"Retail & Wholesale": "小売・卸売",
	Emergency: Emergency$8,
	Security: Security$8,
	"How many employees do you need to manage?": "管理が必要な従業員は何人ですか？",
	"How many vehicles does your company operate?": "御社が運用している車両は何台ですか？",
	"Why do you use a fleet tracking service?": "車両追跡サービスを利用する理由は何ですか？",
	"Route Tracking": "ルート追跡",
	"Real-time Monitoring": "リアルタイム監視",
	"Incident Detection & Check video": "インシデント検出とビデオ確認",
	"Behavior Monitoring & Analysis": "行動監視と分析",
	"Evaluation & Management": "評価と管理",
	"Theft Prevention": "盗難防止",
	"Monitoring & Maintenance": "監視とメンテナンス",
	"Verification & Management": "検証と管理",
	"BlackVue App Use Only": "BlackVueアプリ専用",
	"Your current plan allow_": "現在のプランではBlackVueアプリの使用が可能です。Webビューアを使用するには、フリートプラン（FLEETA）にご加入ください。",
	"Learn more about the Fleet_": "FLEETAのフリートプランについてもっと知る",
	"Special Offer": "特別オファー",
	"For a limited time_": "期間限定で、フリートプランのサブスクリプションが50％オフになります。",
	"See Discount Details": "割引の詳細を見る",
	"To subscribe to the Fleet_": "フリートプランに加入するには、重複した請求を避けるために、まずアプリ内のBlackVueのサブスクリプションをキャンセルしてください。",
	"Skip tour": "ツアーをスキップ",
	"In the cloud_": "クラウド環境では、FLEETA Web Viewerを通じて再生、ライブビュー（マルチビューを含む）、ライブGPS、レポートにアクセスできます。",
	"Cloud Storage is_": "クラウドストレージは、アップロードしたビデオがクラウド内で安全に保存される場所です。ビデオをアップロードして、長期間安全に保管してください。",
	"Toggle to switch_": "マップ / リストを切り替えるトグル",
	"In List View_": "リストビューでは、グループ、メンバー、ファームウェア情報を一目で簡単に確認し管理できます。",
	"What is Cloud Storage?": "クラウドストレージとは何ですか？",
	"Cloud Storage Overview": "クラウドストレージの概要",
	"Difference Between FLEETA_": "FLEETA ドライブとライブイベントアップロードの違い",
	"FLEETA Drive stores_": "FLEETA ドライブは手動でアップロードしたビデオを保存します",
	"Live Event Upload automatically_": "ライブイベントアップロードはイベント発生時に自動的にビデオを保存します。",
	"Live Event Upload videos_": "ライブイベントアップロードのビデオには有効期限があります。長く保持したい場合は、FLEETA ドライブに移動してください。",
	"Note: SD Card_": "注意：再生中の SD カードビデオ",
	"Videos stored on_": "SDカードに保存されたビデオは、再生メニューからアクセスできます。",
	"Set your image_": "提供されたフレームを使用して画像を設定してください。画像が保存されると、カメラカードとマップビューアイコンに表示されます。",
	"*Only jpg and_": "*jpgとpngのファイルのみがサポートされています。",
	"Set as default image": "デフォルト画像に設定",
	"Camera Details": "カメラの詳細",
	"IT & Telecommunications": "ITおよび通信",
	"The name must_32": "名前は1-32文字以内でなければなりません。",
	"Unable to display the map.": "地図を表示できません。",
	"The camera location cannot be found_": "GPS接続が悪いため、カメラの位置を特定できません。",
	"Cloud Cameras": "クラウドカメラ",
	"Want to unlock_": "フリート管理機能を解除しますか？",
	"*Web subscription only": "*ウェブサブスクリプションのみ",
	"Uploads event_": "イベントが発生すると同時に、クラウドストレージにイベント映像をアップロードします。",
	"Starts a conversation_": "ダッシュカムのスピーカーとマイクを使用してドライバーと会話を開始します。",
	"Remotely check_": "クラウドを通じてバッテリーのレベルと状態を遠隔で確認してください。",
	"Receive a voice_": "運転時間が制限を超えた場合、音声アラートと通知を受け取ります。",
	"View your_": "地図上で運転ログを確認してください。",
	"View speed, event_": "地図上で速度、イベントタイプを表示し、関連するビデオを直接再生します。",
	"FLEETA Tracking exclusive_": "FLEETA トラッキングは、パワーユーザーとビジネスの両方に独占的な機能を提供します（複数ユーザーおよびカメラ、ジオフェンシングなど）。",
	"Cloud Cameras per Account": "アカウントごとのクラウドカメラ",
	"Connect Dashcam Locally_": "ダッシュカムをローカルに接続 (Wi-Fi) (再生, ダウンロード, ライブビュー)",
	"Available with_": "BlackVueバッテリーで利用可能",
	"Cloud Battery": "クラウドバッテリー",
	"Driving Reports": "運転レポート",
	"Video on Map": "マップ上のビデオ",
	"Multi Live View (Fleeta Web Viewer)": "マルチライブビュー (FLEETA ウェブビューア)",
	"Enter a number": "数字を入力してください",
	"Permission required.": "許可が必要です。",
	"Please contact_": "オーナーに連絡してサポートを受けてください。",
	"Access not available": "アクセスできません。",
	"This file cannot be deleted now.": "このファイルは現在削除できません。",
	"Please try again later.": "後で再試行してください。",
	"Permission required.\nPlease_": "許可が必要です。\nオーナーに連絡して支援を求めてください。",
	"Cloud Storage is disconnected_": "クラウドストレージが切断されました。接続を確認してください。",
	"Manage the plan_": "カメラを復元するためのプランを管理する",
	"Notify the owner_": "オーナーにプランの管理を依頼する",
	"Access Restricted:_": "アクセス制限：サブスクリプションの期限切れ",
	"Access is currently_": "現在、サブスクリプションの期限が切れているためアクセスできません。",
	"Please contact your owner_": "この問題を解決するためにオーナーに連絡してください。",
	"Access will be_": "サブスクリプションを更新するとアクセスが復元されます",
	"Cloud is disconnected_": "クラウドストレージが切断されました。 \n接続を確認してください。",
	"Connect to Cloud with_": "FLEETA APPでクラウドストレージに接続",
	"Using Wi-Fi Hotspot": "Wi-Fi ホットスポットの使用",
	Important: Important$8,
	"Pre-Event buffer_": "このモードでは事前イベントバッファの録画が無効になっています。",
	"connectivity is_": "このモードでは接続が制限されます。",
	"video upload starts_": "録画が完了した後にビデオのアップロードが開始されます。",
	"Power Saving": "省エネ",
	"In all modes_": "すべてのモードで検出された衝撃はイベントビデオの録画を開始します。",
	"Battery Protection setting _": "バッテリー保護設定はONに設定する必要があります。",
	"At least one of_": "次の設定のうち少なくとも1つを有効にする必要があります",
	or: or$8,
	"For BlackVue battery users": "BlackVueバッテリーのユーザーのために",
	"we recommend setting_": "バッテリーの使用を最大化するために、電圧カットオフを最小値に設定することをお勧めします。",
	"No videos were found.": "ビデオが見つかりませんでした。",
	"Try different filter_": "別のフィルターを試すか、フィルターをリセットしてください。",
	"Not avaliable with_": "現在のカメラでは利用できません",
	"Overlays a detection_": "DMSカメラのライブおよび録画された映像に検出ボックスをオーバーレイします。",
	"A minute of_": "フロントカメラのビデオ1分はおおよそ",
	"System voice guidance": "システム音声ガイダンス",
	"Recording trigger": "録画トリガー",
	"Remote Button (Optional)": "リモートボタン（オプション）",
	"Remote button settings_": "リモートボタンの設定はクラウド接続を通じて変更できません。これらの設定を変更するには、カメラ > ローカル接続 > カメラ設定に移動してください。",
	"No Registered Device": "登録されたデバイスがありません",
	"Subscription process is complete": "サブスクリプションプロセスが完了しました",
	"Now, go back to_": "さあ、FLEETAアプリに戻って、アカウントにログインし、サービスを楽しんでください。",
	"You can check the upload progress": "クラウドストレージ > FLEETA ドライブ タブでアップロードの進行状況を確認できます。",
	"SIM card must be inserted in_": "クラウドの利用を開始するには、カメラに SIM カードを挿入する必要があります。",
	"Active until:": "以下の期間まで有効です:",
	Subscribe: Subscribe$8,
	"Camera PSN": "カメラPSN",
	"BlackVue Sim Free Trial Started!": "BlackVue Simの無料トライアルが開始されました!",
	"Enjoy a free period to use your SIM_": "無料期間を利用すれば、SIM を契約せずに使用できます。",
	"You can stay connected during the trial_": "試用中は接続を維持できますが、次の点に注意してください。",
	"Complete your subscription before the trial_": "SIM を引き続き使用するには、トライアルが終了する前にサブスクリプションを完了してください。",
	"If you don't subscribe by the end of the trial_": "トライアル終了日までに加入しない場合、SIM サービスは無効になります。",
	"Save Event Videos_": "イベント動画をリアルタイムでクラウドストレージに保存！",
	"Note: Deleting your account doesn’t cancel": "注意：アカウントを削除しても、サブスクリプションはキャンセルされません。キャンセルするには、FLEETAウェブビューアでアカウント > サブスクリプションに移動してください。",
	"Available only on FLEETA App for_": "このモデルはFLEETAアプリでのみ利用可能です。",
	"The cloud is deactivated": "クラウドは無効化されています。",
	"Please add a camera with FLEETA_": "この機能を使用するには、FLEETAアプリにカメラを追加してください。",
	"Upload videos to FLEETA_": "ビデオをFLEETA ドライブにアップロードして、安全に保管しましょう！",
	"You have no assigned camera_": "割り当てられたカメラがありません。\n割り当てをリクエストするために所有者に連絡してください。",
	"Camera notification settings": "カメラ通知設定",
	Vehicle: Vehicle$8,
	"App Download": "アプリダウンロード",
	"Have a problem with_": "サブスクリプションに問題がありますか？",
	"Restore Purchase": "購入の復元",
	"Battery Pairing": "バッテリーのペアリング",
	"Playback\nLive View": "再生/\nライブ ビュー",
	"Remote Playback": "リモート再生",
	"Cloud connection settings": "Cloud接続設定",
	"Go to settings": "設定に進む",
	"Only cloud cameras that_": "ユーザーが公開共有することを選択したクラウドカメラのみが地図に表示されます。",
	"Live Broadcast Cameras": "ライブ放送カメラ",
	"*Live Broadcast Cameras_": "*ライブ放送カメラは、ユーザーが放送するように設定したクラウドカメラです。",
	"Only cloud cameras_": "ユーザーがブロードキャストを選択したクラウドカメラのみがマップに表示されます。"
};

var Dashboard$7 = "대시보드";
var Account$7 = "계정";
var Help$7 = "이용안내";
var Mac$7 = "Mac";
var Windows$7 = "Windows";
var Admin$7 = "관리자";
var Driver$7 = "운전자";
var Cameras$7 = "블랙박스";
var Manage$7 = "변경";
var Clear$7 = "선택 지우기";
var Show$7 = "보기";
var GB$7 = "{{a}}GB";
var _section$7 = "섹션";
var Name$7 = "이름";
var Password$7 = "비밀번호";
var Cancel$7 = "취소";
var Members$7 = "Members";
var Groups$7 = "Groups";
var Role$7 = "역할";
var Group$7 = "그룹";
var Status$7 = "상태";
var nPM$7 = "{{a}}오후";
var nAM$7 = "{{a}}오전";
var Newest$7 = "가장 최근";
var Oldest$7 = "가장 이전";
var Accepted$7 = "수락됨";
var Pending$7 = "수락 여부 미정";
var Expired$7 = "유효 기간 만료";
var All$7 = "모두";
var Delete_$7 = "{{a}} 삭제";
var Delete$7 = "삭제";
var Rename$7 = "이름 변경";
var Add$7 = "추가하기";
var OK$7 = "확인";
var Remove$7 = "제거";
var Files$7 = "파일";
var Features$7 = "기능";
var Settings$7 = "설정";
var Upload$7 = "업로드";
var Privacy$7 = "공개 설정";
var Done$7 = "확인";
var Subscription$7 = "구독";
var Submasters$7 = "관리자";
var Users$7 = "운전자";
var Change$7 = "변경";
var Method$7 = "방식";
var Details$7 = "상세정보";
var Confirm$7 = "확인";
var Address$7 = "주소";
var Country$7 = "국가";
var State$7 = "시/도";
var ZIP$7 = "우편번호";
var Pricing$7 = "요금제";
var Free$7 = "Free";
var Smart$7 = "Smart";
var Fleet$7 = "Fleet";
var Subscrubed$7 = "구독중";
var January$7 = "1월";
var February$7 = "2월";
var March$7 = "3월";
var April$7 = "4월";
var May$7 = "5월";
var June$7 = "6월";
var July$7 = "7월";
var August$7 = "8월";
var September$7 = "9월";
var October$7 = "10월";
var November$7 = "11월";
var December$7 = "12월";
var Blackvuecloud_$7 = "www.blackvuecloud.com";
var Support$7 = "고객 지원";
var Community$7 = "커뮤니티";
var FAQ$7 = "FAQ";
var Developers$7 = "개발자";
var Facebook$7 = "Facebook";
var Twitter$7 = "Twitter";
var Instagram$7 = "Instagram";
var Youtube$7 = "Youtube";
var Linkedin$7 = "Linkedin";
var Downloads$7 = "다운로드";
var Unauthorized$7 = "권한이 없습니다";
var none$7 = "없음";
var Email$7 = "이메일";
var Customers$7 = "고객";
var Home$7 = "홈";
var Plan$7 = "플랜";
var New$7 = "신규";
var Unsubscribed$7 = "구독 취소됨";
var Edit$7 = "수정";
var month$7 = "개월";
var months$7 = "개월";
var Continue$7 = "계속";
var Back$7 = "뒤로";
var Master$7 = "오너";
var Develop$7 = "개발자";
var $9$7 = "$9";
var $15$7 = "$15";
var $10$7 = "$10";
var mo$7 = "한달";
var City$7 = "도시";
var Charge$7 = "요금";
var subscribe$7 = "구독";
var search$7 = "검색";
var invalid_number$7 = "카드 번호가 유효한 신용카드 번호가 아닙니다";
var invalid_expiry_month$7 = "카드 만료월이 유효하지 않습니다";
var invalid_expiry_year$7 = "카드 만료 연도가 유효하지 않습니다";
var invalid_cvc$7 = "카드 보안코드가 유효하지 않습니다";
var incorrect_number$7 = "카드 번호가 올바르지 않습니다";
var incomplete_number$7 = "카드 번호가 미완성되었습니다";
var incomplete_cvc$7 = "카드 보안 코드가 미완성되었습니다";
var incomplete_expiry$7 = "카드 만료일이 미완성되었습니다";
var expired_card$7 = "카드가 만료되었습니다";
var incorrect_cvc$7 = "카드 보안 코드가 올바르지 않습니다";
var incorrect_zip$7 = "카드 zip code가 유효하지 않습니다";
var invalid_expiry_year_past$7 = "카드 만료년이 과거로 입력되었습니다";
var card_declined$7 = "카드가 거절되었습니다";
var missing$7 = "청구될 고객 이름으로 발행된 카드가 없습니다";
var processing_error$7 = "카드 처리중 에러가 발생하였습니다";
var Paypal$7 = "페이팔";
var iOS$7 = "iOS";
var Android$7 = "Android";
var Total$7 = "합계";
var And$7 = "그리고";
var Camera$7 = "블랙박스";
var Yes$7 = "예";
var No$7 = "아니오";
var News$7 = "뉴스";
var Notifications$7 = "서비스 알림";
var MPH$7 = "MPH";
var Firmware$7 = "펌웨어";
var Basic$7 = "기본";
var Resolution$7 = "해상도";
var Brightness$7 = "밝기";
var Recording$7 = "녹화";
var Highest$7 = "초고화질";
var High$7 = "고화질";
var Normal$7 = "일반화질";
var Sensitivity$7 = "민감도";
var Volume$7 = "볼륨";
var Close$7 = "닫기";
var Cloud$7 = "Cloud";
var Public$7 = "공개";
var Front$7 = "전방";
var Rear$7 = "후방";
var Play$7 = "재생";
var Stop$7 = "정지";
var Pause$7 = "정지";
var Time$7 = "시간";
var System$7 = "시스템";
var Event$7 = "이벤트";
var Parking$7 = "주차";
var Color$7 = "색상";
var Exit$7 = "진출";
var Save$7 = "저장";
var Impact$7 = "충격";
var Unlimited$7 = "무제한";
var Default$7 = "디폴트";
var Version$7 = "버전";
var Language$7 = "언어";
var Notification$7 = "알림";
var Multiple$7 = "멀티";
var Range$7 = "범위";
var Download$7 = "다운로드";
var Manual$7 = "수동";
var Satellite$7 = "위성";
var Tutorials$7 = "튜토리얼";
var Filter$7 = "필터";
var Sun$7 = "일";
var Mon$7 = "월";
var Tue$7 = "화";
var Wed$7 = "수";
var Thu$7 = "목";
var Fri$7 = "금";
var Sat$7 = "토";
var Dates$7 = "날짜";
var Routes$7 = "경로";
var Opacity$7 = "투명도";
var Entry$7 = "진입";
var Owner$7 = "오너";
var Undetected$7 = "운전자 미감지";
var Distracted$7 = "주의산만";
var Drowsy$7 = "졸음";
var Calling$7 = "통화";
var Smoking$7 = "흡연";
var Permissions$7 = "권한";
var Private$7 = "공개 설정";
var Entering$7 = "진입";
var Exiting$7 = "진출";
var Acceleration$7 = "급가속";
var Passing$7 = "통과";
var Overspeed$7 = "과속";
var Recipients$7 = "수신자";
var Send$7 = "전송";
var Note$7 = "알림";
var Video$7 = "영상";
var Advanced$7 = "고급";
var Voice$7 = "음성";
var Days_$7 = "일";
var Mute$7 = "음소거";
var UnMute$7 = "음소거 해제";
var Discard$7 = "버리기";
var Report$7 = "Report";
var Individual$7 = "개인과 사업자 모두, 누구나 안전한 주행과 간편한 차량 보안, 차량 추적 솔루션을 추구합니다.";
var Subscribed$7 = "구독중";
var Geofence$7 = "지오펜스";
var Driving$7 = "주행";
var Idling$7 = "정차";
var Distance$7 = "거리";
var Parked$7 = "주차";
var Speed$7 = "속도";
var Highest_2$7 = "최고";
var Average$7 = "평균";
var Geofences$7 = "지오펜스";
var Move$7 = "이동";
var Connected$7 = "연결됨";
var Individual_$7 = "개인";
var Always$7 = "항상";
var Low$7 = "낮음";
var Medium$7 = "중간";
var High_2$7 = "높음";
var Flip$7 = "화면반전";
var Previous$7 = "이전";
var Next$7 = "다음";
var Expand$7 = "펼치기";
var Collapse$7 = "접기";
var More$7 = "추가 기능";
var Multi$7 = "멀티";
var Safe$7 = "안전운전";
var Reckless$7 = "위험운전";
var Inattentive$7 = "부주의운전";
var List$7 = "카메라 목록";
var Usage$7 = "기능사용 현황";
var Profile$7 = "프로파일";
var Fullscreen$7 = "전체 화면";
var Upgrade$7 = "업그레이드";
var Management$7 = "관리";
var Day$7 = "일간";
var Month$7 = "월간";
var Later$7 = "나중에";
var ICCID$7 = "ICCID";
var Resubscribe$7 = "재구독";
var plan$7 = "요금제";
var USD$7 = "USD";
var etc_$7 = "기타 :";
var Available$7 = "사용 가능량";
var Used$7 = "사용 완료량";
var Cancelled$7 = "해지됨";
var Terminated$7 = "만료됨";
var Sort$7 = "분류";
var Bonus$7 = "보너스 기간";
var incomplete_zip$7 = "카드 zip code가 유효하지 않습니다";
var Upgrades$7 = "업그레이드";
var OR$7 = "또는";
var Undo$7 = "실행 취소";
var Invoice$7 = "송장";
var data$7 = "데이터";
var Popular$7 = "인기 있는";
var Mask$7 = "마스크 미착용";
var DMS$7 = "운전자 감시 시스템 (DMS)";
var Extreme$7 = "극심한";
var OFF$7 = "끄다";
var Threshold$7 = "임계값";
var Drowsiness$7 = "졸음";
var Direct$7 = "다이렉트";
var Remote$7 = "원격";
var Update$7 = "업데이트";
var Option$7 = "옵션";
var Required$7 = "필수";
var Optional$7 = "선택";
var Others$7 = "기타";
var Stay$7 = "머무르기";
var Mask_2$7 = "Mask";
var Low_2$7 = "Low";
var Medium_2$7 = "Medium";
var High_3$7 = "High";
var Highest_3$7 = "최고화질";
var Extreme_2$7 = "최고화질 (Extreme)";
var Private_2$7 = "비공개";
var Lite$7 = "Lite";
var Bitrate$7 = "비트 레이트";
var hours$7 = "시간";
var Expires$7 = "만료";
var Check$7 = "점검";
var Saving$7 = "저장 중";
var Now$7 = "지금";
var Beep$7 = "경고음";
var Unpair$7 = "페어링 해제";
var Detected$7 = "운전자 감지";
var Promotion$7 = "프로모션";
var Notice$7 = "업데이트";
var Explore$7 = "홈";
var Deactivate$7 = "비활성화";
var Compliance$7 = "법규 준수";
var Manufacturing$7 = "제조업";
var Emergency$7 = "응급";
var Security$7 = "보안";
var Important$7 = "중요";
var or$7 = "또는";
var Subscribe$7 = "구독하다";
var Vehicle$7 = "차량";
var ko = {
	Dashboard: Dashboard$7,
	"Payment & Subscriptions": "결재 및 구독",
	"Fleet Management": "Fleet 관리",
	"Available to master": "오너 사용 가능",
	"Available to Fleet_": "Fleet Plan 유저 사용 가능",
	Account: Account$7,
	"Log out": "로그아웃",
	"© 2019 Pittasoft_": "© 2019 Pittasoft Co. Ltd",
	"Privacy policy": "개인정보 처리방침",
	"Terms of service": "서비스 이용 약관",
	Help: Help$7,
	"App store": "앱스토어",
	"Google Play": "구글 플레이",
	Mac: Mac$7,
	Windows: Windows$7,
	"Free Plan": "Free Plan",
	"Basic Plan": "Basic Plan",
	"Smart Plan": "Smart Plan",
	Admin: Admin$7,
	Driver: Driver$7,
	Cameras: Cameras$7,
	"n of n": "{{b}}개 중 {{a}}개",
	Manage: Manage$7,
	"Upgrade Plan": "요금제 업그레이드",
	"Add more cameras_": "블랙박스 추가, Fleet 관리 등...",
	"Usage statistics": "사용 통계",
	"All cameras": "블랙박스 필터 Combo Box",
	Clear: Clear$7,
	Show: Show$7,
	"Live views": "원격 라이브뷰",
	"nh:nm:ns": "{{a}}시:{{b}}분:{{c}}초",
	"Video plays and_": "비디오 재생 및 다운로드",
	"Space available": "사용 가능 공간",
	GB: GB$7,
	"n%": "{{a}}%",
	"BlackVue app for_": "아이폰 / 안드로이드용 BlackVue 앱",
	"BlackVue viewer for_": "Mac / Windows용 BlackVue 뷰어",
	"Welcome to fleet": "Free Plan을 이용을 환영합니다.",
	"A few things_": "사용 전 몇 가지 안내해드리겠습니다.",
	"You can watch_": "BlackVue 앱이나 뷰어를 이용하여 할당된 블랙박스가 녹화한 영상을 확인하실 수 있습니다.",
	"If the master_deletes": "오너의 계정이 삭제될 경우 오너 계정에 속한 운전자의 계정 또한 사라집니다.",
	"If the masters_Fleet": "오너의 Fleet Plan 구독이 만료될 경우 해당 계정은 읽기 모드로만 사용이 가능합니다.",
	"You have to_": "개인용 블랙박스를 추가하려면 별도의 계정을 등록해야 합니다.",
	"The Payments &_": "결제 및 구독, Fleet 매니지먼트 섹션은 오너만 이용할 수 있습니다.",
	"You can manage_": "에서 Fleet groups을 관리할 수 있습니다.",
	"_Fleet management": "Fleet 관리",
	_section: _section$7,
	"The Payments_section-": "결제 및 구독 섹션은 마스터만 이용할 수 있습니다.",
	"Youre almost there": "거의 마무리되어갑니다.",
	"Finish account setup": "계정 설정 종료",
	"Install and log_": "BlackVue 앱이나 뷰어를 설치 후 로그인해 주세요.",
	"Download on the_": "앱 스토어에서 다운로드해주세요.",
	"GET IT ON_": "구글 플레이에서 다운로드해주세요.",
	"Download for Mac": "Mac 전용 뷰어 다운로드",
	"Download for Windows": "Windows 전용 뷰어 다운로드",
	"Add your camera_": "BlackVue 앱이나 뷰어로 블랙박스를 추가하세요.",
	"Start managing your_": "Fleet 관리를 시작하세요. 여기서 사용량을 확인하실 수 있습니다.",
	"Cancelled Fleet Plan_": "{{date}}에 Fleet Plan 이 취소되었습니다.",
	"The new plan_": "새로운 요금제는 이전 요금제가 끝나는 순간 부터 적용 되어집니다.",
	"Profile photo": "프로필 사진",
	Name: Name$7,
	"E-mail address": "이메일 주소",
	Password: Password$7,
	"Last changed_": "최근 변경일 {{a}}",
	"Change password": "비밀번호 변경",
	"Delete account": "계정 삭제 하기",
	Cancel: Cancel$7,
	"Current password": "현재 비밀번호",
	"New password": "새로운 비밀번호",
	"Confirm new password": "새로운 비밀번호 확인",
	"Password changed": "비밀번호가 변경되었습니다.",
	"Reason for deletion_": "삭제 사유 (선택)",
	"Account password": "계정 비밀번호",
	Members: Members$7,
	Groups: Groups$7,
	"+ Invite member": "+ 멤버 초대",
	"Name, Email": "이름, 이메일",
	Role: Role$7,
	Group: Group$7,
	"Date invited": "초대된 날짜",
	Status: Status$7,
	"Group n": "그룹 {{a}}",
	nPM: nPM$7,
	nAM: nAM$7,
	Newest: Newest$7,
	Oldest: Oldest$7,
	"Name, email or_": "이름 및 이메일 혹은 그룹",
	Accepted: Accepted$7,
	Pending: Pending$7,
	Expired: Expired$7,
	All: All$7,
	"No results": "결과가 없습니다.",
	"Try different keywords": "다른 키워드를 사용해보세요.",
	"Try changing or_": "필터를 변경하거나 제거해보세요.",
	"Remove all filters": "모든 필터 제거",
	"Invite member": "멤버 초대",
	"Send invite": "초대장 보내기",
	"You have reached_": "이미 최대 10명의 관리자를 모두 등록하였습니다. 하지만 운전자 초대는 가능합니다.",
	Delete_: Delete_$7,
	"Are you sure_delete": "해당 멤버와 계정 모두 삭제를 원하십니까?",
	Delete: Delete$7,
	Rename: Rename$7,
	"No submaster yet": "등록된 관리자가 없습니다.",
	"You can add_": "그룹별로 관리자는 1명만 추가할 수 있습니다.",
	"No cameras yet": "등록된 블랙박스가 없습니다.",
	"Add cameras first_": "블랙박스 추가 후에 블랙박스에 운전자를 할당하세요.",
	"Name or email": "이름이나 이메일",
	"Add submaster": "관리자 추가",
	Add: Add$7,
	"Add camera": "블랙박스 추가",
	"n of n selected": "{{b}}개 중에 {{a}}개가 선택됨",
	"No cameras available": "이용 가능한 블랙박스가 없습니다.",
	"Most likely reasons_": "가장 근접한 원인:",
	"All cameras were_": "이미 모든 블랙박스가 타 그룹에 추가되었습니다.",
	"You can remove_": "해당 블랙박스 기기가 추가된 타 그룹에서 제거 후 해당 그룹에 추가해 주세요.",
	"No cameras were_": "해당 계정에 등록된 블랙박스가 없습니다.",
	"You can add_cameras": "BlackVue 앱이나 웹뷰어를 사용하여 블랙박스를 추가해 주세요.",
	OK: OK$7,
	"Rename group": "그룹 이름 변경",
	"Are you sure_group": "해당 그룹을 삭제합니까?",
	"Edit Mobile app_": "모바일앱/데스트탑 뷰어 권한 수정",
	Remove: Remove$7,
	"n of n users": "{{b}} 중에 {{a}} 명의 운전자",
	"Youve reached the_": "블랙박스별 제한된 운전자 수를 초과하였습니다.",
	"Remove user": "운전자 제거",
	"Add user": "운전자 추가",
	"+ Add group": "+ 그룹 만들기",
	"Add group": "그룹 만들기",
	"Group or submaster": "그룹이나 관리자",
	"+ Add": "+ 추가",
	"of max selected": "최대 {{b}}개 중 {{a}}개가 선택됨",
	"Mobile app/desktop_": "모바일앱/데스크탑 뷰어 권한",
	Files: Files$7,
	Features: Features$7,
	Settings: Settings$7,
	Upload: Upload$7,
	"Download and Playback_Cloud": "Cloud 저장공간으로부터 다운로드 및 영상재생",
	"Download and Playback_SD": "SD 카드로부터 다운로드 및 Playback",
	"Live view": "Live View",
	"Geo Fencing": "지오펜스",
	"Drive Reports": "주행 reports",
	"Firmware Settings": "펌웨어 설정",
	"Push Notifications": "푸시 알림",
	"Event Auto Upload": "이벤트 자동 업로드",
	Privacy: Privacy$7,
	Done: Done$7,
	"Payment method": "결제 방법",
	"Change payment method": "결제 방법 변경",
	Subscription: Subscription$7,
	"Space used": "공간 사용",
	"Next billing_": "다음 청구일 {{a}} {{b}}",
	"You manage_available": "현재 사용 가능한 블랙박스 {{b}}개 중 {{a}}개를 사용중입니다.",
	Submasters: Submasters$7,
	Users: Users$7,
	Change: Change$7,
	"No transactions yet_": "현재 Free Plan 을 구독중이며, 현재까지 결제 내역은 없습니다.",
	"No transactions to_": "보여줄 결제 내역이 없습니다.<br/>iOS나 Android 같은 타 플랫폼의 결제 내역을 확인하려면, 사용중인 플랫폼에서 구독 페이지를 확인해 주세요.",
	"of nGB_": "{{b}}중 {{a}}GB ({{c}}%)",
	"Smart Plan users_": "Smart Plan 유저는 BlackVue 모바일앱을 이용하여 구독 플랜 및 블랙박스수를 변경할 수 있습니다.",
	"Transaction history": "결제 내역",
	"Date": "날짜",
	"Amount, USD": "금액, 원",
	Method: Method$7,
	Details: Details$7,
	"iOS in-app_": "iOS 인앱 구매/Android 인앱 구매",
	"Change the number_": "등록 가능한 블랙박스 수 변경",
	"You manage_cameras": "현재 플랜으로 사용 가능한 {{b}}개 중 {{a}}개의 블랙박스를 사용중입니다.",
	"Extra cameras": "추가 블랙박스",
	"Total due_": "결제 날짜",
	"available on your_": "현재 플랜으로 사용 가능한 블랙박스 {{a}}개 중",
	"Cancel Fleet Plan": "Fleet Plan 취소",
	"This will cancel_": "Fleet Plan 구독을 취소합니다. 다음 결제일부터 Free Plan 으로 변경됩니다.",
	"Reason for cancellation_": "취소 사유 (선택)",
	"Not now": "나중에",
	Confirm: Confirm$7,
	"Cardholder name": "카드 소유자 이름",
	"Card name": "카드 이름",
	"MM/YY": "월/년도",
	Address: Address$7,
	Country: Country$7,
	State: State$7,
	ZIP: ZIP$7,
	Pricing: Pricing$7,
	"You are subscribed_": "현재 Free Plan 을 구독중입니다.",
	"With Alert Push_": "푸시알림 기능과 제한적 Remote Live View와 Cloud 저장공간을 제공합니다.",
	Free: Free$7,
	Smart: Smart$7,
	Fleet: Fleet$7,
	"Get started for_": "신용카드 등록 없이 무료로 시작해보세요. \n Free 이용자에게도 알림 기능과 제한적 Remote Live View와 Cloud 저장공간을 제공합니다.",
	Subscrubed: Subscrubed$7,
	"Features included:": "포함 기능:",
	"Get unlimited Remote_": "최대 블랙박스 {{a}}대까지 등록하여 사용해보시고 무제한으로 Remote Live View와 Cloud Playback 기능을 이용할 기회를 놓치지 마세요.",
	"BlackVue Fleet Tracking_": "BlackVue Fleet Tracking은 Fleet 사업자의 요구사항들을 충족시킬 수 있는 기능입니다. (다수의 유저와 블랙박스 등록 가능, 지오펜스 지원 등)",
	"Try 1 Month Free": "1달간 무료 사용",
	"Log in": "로그인",
	"Remember me": "로그인 상태 유지",
	"Forgot password?": "비밀번호를 잊으셨나요?",
	"Reset password": "비밀번호 재설정",
	"Enter email address_": "블랙뷰 회원가입시 입력했던 이메일 주소를 입력해주세요.\n등록된 이메일 주소로 비밀번호를 재설정할 수 있는 링크를 보내드립니다.",
	"Send reset password_": "비밀번호 재설정하기",
	"Back to login": "다시 로그인하기",
	"Check your email": "이메일을 확인해 주세요",
	"Weve sent an_": "{{a}}(으)로 비밀번호 재설정 링크가 발송되었습니다. \n",
	"Resend email": "이메일 재전송",
	January: January$7,
	February: February$7,
	March: March$7,
	April: April$7,
	May: May$7,
	June: June$7,
	July: July$7,
	August: August$7,
	September: September$7,
	October: October$7,
	November: November$7,
	December: December$7,
	"Sign up": "가입하기",
	"First name": "이름",
	"Last name": "성",
	"Create a password": "비밀번호 생성하기",
	"5 or more_": "5글자 이상",
	"Sign up and_": "가입하고 계속하기",
	"I agree to_": "%@와 %@, %@, %@에 동의합니다.",
	"Subscribe to newsletter": "뉴스레터 구독하기",
	"1 month free trial_": "1달간 무료 사용",
	"Dont have an_": "계정이 없으신가요?",
	"Thank you for_": "BlackVue Cloud에 가입해주셔서 감사합니다. 이메일 주소를 확인해주세요.",
	"Confirm email": "이메일 확인",
	"If you didnt_": "이 계정으로 가입한 적이 없으면 해당 이메일은 무시하셔도 좋습니다.",
	Blackvuecloud_: Blackvuecloud_$7,
	"invited you to_": "{{a}}님이 귀하를 관리자로 초대하였습니다.",
	"Accept invitation": "초대 수락",
	"Invite expires on_": "월, 일, 년도.에 초대장이 만료됩니다.",
	"Your Fleet Management_": "%@님이 {{a}}님 이름으로 등록된 Fleet 관리 계정을 삭제하였습니다.",
	"If you believe_": "에러 발견 시, 고객지원팀으로 문의 부탁드립니다: cs@blackvue.com",
	Support: Support$7,
	"Help center": "헬프 센터",
	Community: Community$7,
	"Getting started": "시작하기",
	FAQ: FAQ$7,
	Developers: Developers$7,
	"Cloud API": "Cloud API",
	"Fleet SDK": "Fleet SDK",
	"Follow us": "SNS",
	Facebook: Facebook$7,
	Twitter: Twitter$7,
	Instagram: Instagram$7,
	Youtube: Youtube$7,
	Linkedin: Linkedin$7,
	"BlackVue apps": "BlackVue 어플",
	"Camera registraiton": "블랙박스 등록",
	"Two-way voice_": "양방향 음성 통신",
	"Live GPS": "라이브 GPS",
	"Event live auto_": "라이브 이벤트 업로드",
	"Event file auto_": "라이브 이벤트 업로드",
	"Compatible with_": "DR650GW, DR650S 모델과 호환 가능",
	"Not compatible with_": "DR650GW, DR650S 모델과 호환 불가",
	"More cameras": "추가 블랙박스",
	"More users": "추가 유저",
	"Roles and permissions": "역할 및 권한",
	"More Cloud Storage": "더 큰 Cloud 저장공간",
	"Multi Live view_": "Multi Live View",
	"Longer GPS Tracking": "더 오랜 기간의 GPS Tracking",
	"Geo Fence setup_": "지오펜스 설정 (PC 뷰어) 및 알람 (PC 뷰어 및 앱)",
	"Changes saved": "변경사항 저장 완료",
	"Group added": "그룹 추가 완료",
	"Member added": "멤버 추가 완료",
	"Group deleted": "그룹 삭제 완료",
	"Member deleted": "멤버 삭제 완료",
	"Group renamed": "그룹 이름 변경 완료",
	"Submaster added": "부관리자 추가 완료",
	"Camera added": "블랙박스 추가 완료",
	"User added": "운전자 추가 완료",
	"Users added": "운전자들 추가 완료",
	Downloads: Downloads$7,
	"The BlackVue App_": "BlackVue 블랙박스를 제대로 사용하기 위해서 BlackVue 앱과 뷰어를 최대한 활용해보세요. BlackVue 앱과 뷰어는 최적의 BlackVue 블랙박스 사용 환경을 제공하는 도구입니다.",
	"Compatible with all_": "Wi-Fi 연결이 가능한 모든 BlackVue 모델과 호환 가능",
	"Supports all BlackVue_": "현재까지 출시된 모든 BlackVue 모델 지원",
	"confirm new password": "신규 비밀번호 확인",
	"Your password is_": "잘못된 비밀번호를 입력하셨습니다",
	"Confirm password does_": "비밀번호가 맞지 않습니다",
	"Please enter_email": "이메일 형식이 잘못되어 있습니다. 다시 입력해 주세요.",
	"Please enter_password": "잘못된 비밀번호를 입력하셨습니다",
	"Internal server error_": "내부 서버 에러, 다시 시도해주세요.",
	"New password is_": "최소한 1개 글자는 현재 비밀번호와 달라야 합니다",
	"It should be_": "비밀번호는 5자 이상이어야 합니다",
	"Invalid permission": "권한이 없습니다",
	"Input data isnt_": "입력한 데이터를 사용할 수 없습니다",
	Unauthorized: Unauthorized$7,
	"Already have subsciption": "이미 결제 내역이 있습니다",
	"Already uses": "이미 사용하고있습니다",
	"Already logged in": "이미 로그인 하였습니다",
	"Already sent e-mail": "이미 이메일을 전송하였습니다.",
	"Please wait": "잠시만 기다려주세요",
	"E-mail is not_": "확인되지 않은 이메일 입니다.",
	"Update your subscription_": "구독 요금제를 업데이트해주세요.",
	"Account was deleted": "계정이 삭제되었습니다.",
	"5 ~ 30_": "5 ~ 30자 사이",
	"It has exceeded_": "최대 관리자 9명을 초과하였습니다.",
	"Billing information": "청구 정보",
	"Please enter cardName": "카드 이름을 입력해주세요",
	"Please enter_card": "유효한 카드 번호를 입력해주세요",
	"Please enter address": "주소를 입력해주세요",
	"Please select country": "국가를 선택해주세요",
	"Please enter city": "도시를 선택해주세요",
	none: none$7,
	"Due today": "금일",
	"Today after 1_": "한달 동안의 무료 체험이 끝난 날짜",
	"An error occurred_": "비밀번호 변경 시도 중 에러가 발생하였습니다. 다시 시도해 주세요.",
	"Your account is_": "계정이 활성화되었습니다.",
	"You can now_": "활성화된 이메일 주소를 사용하여 로그인할 수 있습니다.",
	Email: Email$7,
	"Don’t have an account?": "아직 계정을 생성하지 않았습니까?",
	"Already have an account?": "이미 생성한 계정이 있으십니까?",
	"Cloud service": "BlackVue",
	"for your BlackVue": "Cloud 서비스",
	"See what your_": "이제 어디서나 BlackVue 영상을 확인해보세요.",
	"Receive impact alert_": "충격 알람 푸시알림을 받아보세요.",
	"Save footage to_": "단순히 Cloud에 영상저장을 넘어서 더 많은 것들을 경험해보세요...",
	"Free plan included_": "Free Plan 포함, 쉬운 설치, 간편한 취소",
	"Taking advantage of_": "모바일 데이터 또는 차량공급 인터넷과 BlackVue을 접목하면 언제 어디서든 여러분은 BlackVue Cloud를 이용할 수 있습니다. 스마트폰 또는 태블릿을 통해 BlackVue 앱을 이용하면 자동차 위치와 주변 상황을 실시간으로 확인할 수 있습니다.",
	"Get notifications to_": "주차된 차량에 충격이 가해지면 핸드폰으로 알림이 전송됩니다. 덕분에 먼 곳에서도 차량 주변 상황을 파악할 수 있습니다.",
	"Monitor your commercial_": "지도를 통해 상용 차량들을 실시간으로 모니터링해보세요. BlackVue 앱이나 뷰어를 통해 언제든지 운전자와 대화해보세요.",
	"With BlackVue Fleet_": "BlackVue Fleet Tracking 기능을 장착한 BlackVue 앱과 뷰어를 이용해 최대 100대의 차량을 실시간으로 추적할 수 있습니다.",
	"Get started now_": "Free Plan 으로 시작해보세요. 무제한 Live View와 비디오 Playback이 필요하면, BlackVue 앱에서 Smart Plan으로 업그레이드하세요.<br/>파워 유저나 Fleet Plan 을 원하는 사업자는 해당 웹사이트에서만 Fleet Plan 을 구독할 수 있습니다.",
	"Remote Video Playback_": "원격 비디오 Playback 및 다운로드",
	"Compatible with DR650GW_": "DR650GW, DR650S 모델과 호환 가능",
	"Unlimited remote video_": "무제한 원격 비디오 Playback 및 다운로드",
	"Longer cloud storage_": "더 큰 Cloud 저장공간과 파일 유효 기간",
	"Longer storage period_live": "더 오랜 기간 동안 유효한 라이브 이벤트 업로드용 Cloud 저장공간",
	"Longer storage period_file": "더 오랜 기간 동안 유효한 이벤트 파일 오토 업로드용 Cloud 저장공간",
	"Goefence setup (PC_": "지오펜스 설정 (PC 뷰어) 및 알람 (PC 뷰어 및 앱)",
	"App Store": "앱스토어",
	"Send reset password email": "비밀번호 재설정 이메일 전송",
	Customers: Customers$7,
	Home: Home$7,
	"Pick a plan": "요금제 고르기",
	"No customers yet": "등록된 유저 없음",
	"Customers will_": "고객을 사용할 수있게되면 여기에 고객이 나타납니다",
	"Add customer": "고객 추가",
	"Report(PDF)": "Report (PDF)",
	"Subscription Period": "구독 기간",
	Plan: Plan$7,
	New: New$7,
	Unsubscribed: Unsubscribed$7,
	"Subscription ends soon": "구독 만료 임박함",
	Edit: Edit$7,
	"1 month trial": "1달간 무료 체험",
	"Edit customer details": "고객 세부사항 수정",
	"Customer name": "고객 이름",
	"of 999 available_": "Fleet Plan 으로 이용 가능한 999개 중",
	"Subscription starts": "구독 시작",
	"Subscription period": "구독 기간",
	month: month$7,
	months: months$7,
	"Cloud storage": "Cloud 저장공간",
	"Subscription plan": "구독중인 요금제",
	"Check email address": "이메일 주소 확인",
	"Add customer details": "고객 세부사항 추가",
	Continue: Continue$7,
	Back: Back$7,
	"An error occured": "에러 발생",
	"Customer added": "고객 추가됨",
	"Last changed": "최근 변경일",
	"Company name": "회사 이름",
	"Company address": "회사 주소",
	"Alert Push Notifications": "알람 푸시 알림",
	"Receive notifications on_": "미리 세팅한 이벤트 발생 시 핸드폰으로 알림을 수신합니다. BlackVue 주차모드와 결합되면 가장 좋습니다.",
	"Remotely monitor your_": "언제 어디서나 먼 곳에서도 실시간으로 차량 모니터링을 해보세요.",
	"Video Backup/Auto Upload": "비디오 저장/자동 업로드",
	"Back up videos_": "핸드폰 또는 Cloud 저장공간에 영상을 저장합니다.",
	"Two-way Voice Communication": "양방향 음성통신",
	"Talk with people_": "어플을 통해 운전자와 대화를 할 수 있습니다. 운전자는 핸들을 잡으면서 말 할 수 있습니다.",
	"View your car’s_": "지도에서 차량의 위치랑 속도를 확인해주세요. BlackVue Fleet Tracking 기능을 통해 90일 분량의 GPS 데이터를 검색하여 자신의 주행 루트를 볼 수 있습니다.",
	"Remote Video Playback": "원격 비디오 재생",
	"Play videos stored_": "스마트폰이나 태블릿에서 언제든지 Cloud 또는 블랙박스에 저장된 비디오를 재생할 수 있습니다.",
	"Event Live Auto Upload": "라이브 이벤트 업로드",
	"Save a video stream_": "실시간으로 Cloud에 충격 영상이 저장됩니다. 차량을 침입하거나 절도하는 자로 부터 보호할 수 있습니다.",
	"Event File Auto Upload": "라이브 이벤트 업로드",
	"Save Event videos_": "이벤트 비디오를 Cloud에 저장합니다. 충격 발생후 5초전 포함하여",
	"Firmware-Over-the-Air (FOTA)": "펌웨어 업데이트 (FOTA)",
	"Upgrade your dashcam’s": "귀하의 BlackVue 블랙박스를 업그레이드 합니다.",
	"When an Event_": "(충격 감지 또는 수동으로) 이벤트가 생성되면, 라이브 이벤트 업로드를 통해 Cloud 서버로 실시간 비디오 스트림을 저장할 수 있습니다. 전면 또는 후면의 블랙박스는 유저가 설정할 수 있습니다.",
	"Event File Auto-upload_": "이벤트 파일 자동 업로드를 통해 블랙박스는 자동으로 저해상도 버전의 이벤트 파일을 Cloud에 업로드한다.",
	Master: Master$7,
	"per Camera": "블랙박스 별",
	"Event live auto upload_": "모든 Cloud 블랙박스와 호환되는 라이브 이벤트 업로드 기능",
	"Drive report": "주행 리포트",
	"USA/Canada Toll Free": "미국/캐나다 무료 요금",
	"Monday–Saturday_": "월-금, 오전 8시부터 오후 7시까지 / 토요일 오전 9시부터 오후 6시까지 (PST)",
	"Please agree to_": "서비스 약관에 동의해야 합니다.",
	"Mac or Windows PC": "Mac 또는 Windows PC",
	Develop: Develop$7,
	"Sign out": "로그아웃",
	"Referral code": "추천 코드",
	"Total after 1 month trial": "한달 동안의 무료체험 이후 유료 전환 시 지불할 총 금액",
	"Already Use Stripe Token": "Stripe Token 이미 사용중",
	"Select period": "기간 선택",
	"State/Region": "도시/지역 (선택)",
	"ZIP/Postal": "ZIP/우편번호",
	"$0.00": "$0.00",
	"$11.99": "$11.99",
	"$24.99": "$24.99",
	$9: $9$7,
	$15: $15$7,
	$10: $10$7,
	"mo + for_": "월별 + 추가 블랙박스당 {{a}}",
	mo: mo$7,
	"This e-mail address_": "이미 등록되어 있는 e-mail 입니다.",
	"1 month": "한 달",
	"Limit is reset daily": "제한은 일별로 재설정됨",
	"Limit is reset monthly": "제한은 월별로 재설정됨",
	"Video plays and downloads": "비디오 재생 및 다운로드",
	"Your master": "귀하의 대표",
	"Youre 1 step_": "Fleet Plan 구독 완료까지 1단계밖에 안남았습니다",
	"Finish signing up": "가입 완료",
	"Enter billing information": "청구 정보 입력",
	"Proceed to billing": "청구까지 계속",
	City: City$7,
	Charge: Charge$7,
	"User already invited_": "오너가 이미 초대한 운전자",
	"n% consumed": "{{a}}% 사용됨",
	"E-mail already exists": "이메일 이미 존재함",
	"Cancel your inapp_": "인앱 구독을 취소합니다.",
	"You have cancel_": "Fleet Plan 으로 업그레이드하려면 인앱 구독을 취소해야 합니다:",
	"Edit permissions": "권한 수정",
	"See permissions": "권한 보기",
	"Submaster removed": "관리자 제거됨",
	"Camera removed": "블랙박스 제거됨",
	"User removed": "운전자 제거됨",
	"Users removed": "운전자들 제거됨",
	subscribe: subscribe$7,
	search: search$7,
	"permission can be_": "관리자가 초대장을 수락한 이후, 권한을 설정할 수 있습니다.",
	"The confirmation link_": "The confirmation link is no longer valid",
	"Possible reasons:_": "가능한 사유:\n• 이메일 주소를 이미 확인함.\n• 해당 링크 유효기간이 지났거나 삭제됨.",
	"Failed to register_": "BlackVue Cloud로 등록 실패함",
	"There was an_": "가입 과정에서 에러가 발생하였습니다. 만약 이와 같은 문제가 지속된다면 BlackVue Cloud 가입을 재시도해보세요. \n\n더 많은 도움이 필요하시다면 고객센터로 문의해주세요.",
	"Upgrade to Fleet_": "Fleet Plan 으로 업그레이드",
	"Subscription is Canceled": "구독 취소됨",
	"No members yet": "멤버가 없습니다",
	"Please enter_group name": "유효한 그룹 이름을 입력하세요",
	"Group Name": "그룹 이름",
	invalid_number: invalid_number$7,
	invalid_expiry_month: invalid_expiry_month$7,
	invalid_expiry_year: invalid_expiry_year$7,
	invalid_cvc: invalid_cvc$7,
	incorrect_number: incorrect_number$7,
	incomplete_number: incomplete_number$7,
	incomplete_cvc: incomplete_cvc$7,
	incomplete_expiry: incomplete_expiry$7,
	expired_card: expired_card$7,
	incorrect_cvc: incorrect_cvc$7,
	incorrect_zip: incorrect_zip$7,
	invalid_expiry_year_past: invalid_expiry_year_past$7,
	card_declined: card_declined$7,
	missing: missing$7,
	processing_error: processing_error$7,
	"no groups yet": "등록된 그룹 없음",
	"groups will show_": "그룹을 사용할 수있게되면 여기에 그룹이 나타납니다",
	"Fleet members will_": "Fleet 멤버를 사용할 수있게되면 여기에 Fleet 멤버가 나타납니다",
	"service provider": "서비스 제공자",
	Paypal: Paypal$7,
	iOS: iOS$7,
	Android: Android$7,
	"Enter email": "이메일을 입력해주세요",
	"Enter password": "비밀번호를 입력해주세요",
	"Enter first name": "이름을 입력해주세요",
	"Enter last name": "성을 입력해주세요",
	"Enter the current_": "현재 비밀번호를 입력하세요",
	"Enter a new_": "신규 비밀번호를 입력하세요",
	"There isnt an_": "해당 이메일 주소와 연결된 계정이 없습니다",
	"Fleet Plan": "Fleet Plan",
	Total: Total$7,
	"Password you entered_": "입력한 비밀번호가 올바르지 않습니다",
	"Incorrect email or_": "올바르지 않은 이메일 또는 비밀번호",
	"Available to Masters": "오너에게만 이용 가능함",
	"Blackvue url": "https://www.blackvue.com",
	"Information We Collect_": "개인위치정보 사용 동의 확인서",
	And: And$7,
	"Terms of Location-Based_": "위치기반서비스 이용약관",
	"I agree to the_": "다음 약관에 동의합니다",
	"Password Reset_": "비밀번호 재설정 설명 이메일을 {{a}}로 전송하였습니다.",
	"You have already_": "이미 초대되었습니다. 이메일을 확인해보세요.",
	"No data available_": "데이터 없음",
	Camera: Camera$7,
	"You no longer_": "Fleet 서비스 이용권한이 없습니다.",
	"Please contact your_": "Fleet 오너에게 연락하여 해당 이슈를 해결할 수 있도록 해보세요.",
	"You can still_": "아직 접근 가능한 페이지:",
	"account information": "계정 정보",
	"If the issue_": "해당 이슈가 해결되지 않았음에도 불구하고 등록된 이메일 주소로 BlackVue Cloud 서비스를 사용하려면, 해당 계정 삭제 후 재가입해야 합니다.",
	"If the problem_": "해당 문제가 지속될 경우 고객 센터로 연락 부탁드립니다:",
	"Web subscription only": "웹 구독만 가능",
	"AppStore url": "https://apps.apple.com/kr",
	"We no longer_": "페이팔 결제는 더 이상 지원되지 않습니다. 블랙박스 수를 변경하려면 구독 업데이트를 해야합니다:",
	Yes: Yes$7,
	No: No$7,
	"Serial number": "시리얼 번호",
	"Cloud code": "Cloud 번호",
	"Terms & Policies": "이용약관",
	News: News$7,
	Notifications: Notifications$7,
	"km/h": "km/h",
	MPH: MPH$7,
	"Baidu Maps": "Baidu Maps (중국 전용)",
	"Google Maps": "Google Maps",
	Firmware: Firmware$7,
	Basic: Basic$7,
	"Time Zone": "시간대설정",
	Resolution: Resolution$7,
	"Image quality": "영상 품질",
	Brightness: Brightness$7,
	Recording: Recording$7,
	"Normal recording": "상시녹화",
	"Voice recording": "음성 녹음",
	"Video segment length": "파일저장단위",
	"Rear camera recording": "후방 블랙박스 녹화 설정",
	Highest: Highest$7,
	High: High$7,
	Normal: Normal$7,
	"1 min": "1 분",
	"2 min": "2 분",
	"3 min": "3 분",
	Sensitivity: Sensitivity$7,
	"Motion detection": "모션 감지",
	"Speed alert": "속도 경고",
	"Voice guidance": "음성 안내",
	"Power on": "시작 안내",
	"Power off": "종료 안내",
	"Starting normal recording": "상시녹화 시작",
	"Changing recording mode": "녹화모드 변경",
	"Speed alert (beep)": "속도 경고음",
	"Cloud related": "Cloud 관련 안내",
	Volume: Volume$7,
	"User text overlay": "유저 정보 등록",
	"A-Z, a-z_": "A~Z, a~z, 0~9, :;’/\\+-_()$#\n20자 이하",
	"Wi-Fi auto turn off": "Wi-Fi 자동꺼짐",
	"Login credentials": "로그인 설정",
	"Manual recording": "긴급녹화",
	"By sharing your_": "공개 설정된 데이터는 서비스 제공자 및 제 3자에게 노출 및 사용 될 수 있습니다. 블랙박스 위치가 공개되는 설정이니, 설정 변경 시 신중한 판단이 필요합니다.",
	"However, as persona_": "원하지 않으시면 정보 공개설정을 하지 마시기 바랍니다.",
	"Please enter_email_2": "이메일 형식이 잘못되어 있습니다. 다시 입력해 주세요. 일부 특수문자가 포함된 이메일은 허용되지 않습니다 ex) +, &",
	"Password is incorrect": "비밀번호가 일치하지 않습니다.",
	"This camera is already_": "이미 등록된 BlackVue입니다.",
	"Camera name must_": "BlackVue 이름은 한글 5~32자까지 입력 가능 합니다.",
	"Failed to save_": "BlackVue 설정 정보를 저장하는데 실패하였습니다.",
	"Unallowed character detected": "허용되지 않는 문자를 입력 하셨습니다.",
	"File(s) queued for_": "Cloud로 파일 업로드 요청 완료",
	"Exceeded video play_": "영상 재생 및 다운로드 사용량이 초과되었습니다.",
	"Playback Failed": "파일을 재생할 수 없습니다.",
	"Exceeded your Live_": "Live View 사용량을 초과 하였습니다.",
	"The camera is not_": "BlackVue와 서버가 연결되어 있지 않습니다.",
	"Please check the connection_": "선택한 BlackVue의 연결 상태를 확인해 주세요.",
	Close: Close$7,
	"Map": "지도",
	Cloud: Cloud$7,
	Public: Public$7,
	"Flip horizontally": "좌우 반전",
	Front: Front$7,
	Rear: Rear$7,
	Play: Play$7,
	Stop: Stop$7,
	Pause: Pause$7,
	"Next frame": "다음 프레임",
	"Previous frame": "이전 프레임",
	"Proximity sensor": "근접 센서",
	"Voice recording on/off": "음성 녹음 껴기/끄기",
	"The BlackVue dashcam_": "BlackVue 블랙박스는 5GHz 대역 무선 네트워크와 호환되지 않습니다.",
	Time: Time$7,
	"Daylight saving time": "써머타임 적용",
	System: System$7,
	"Incorrect camera serial_": "잘못된 블랙박스 시리얼 번호",
	"Lock event files": "이벤트파일 보호",
	"Overwrite locked event_": "보호된 이벤트 파일의 덮어쓰기",
	"Camera settings saved_": "성공적으로 저장되었습니다.",
	"Front camera": "전방 블랙박스",
	"Rear camera": "후방 블랙박스",
	Event: Event$7,
	Parking: Parking$7,
	"GPS tracking": "GPS Tracking",
	"G-force detected": "충격감지",
	"Impact detected in_": "주차중 충격알림",
	"Scheduled reboot": "자동 재부팅",
	"Recording status": "녹화상태",
	"Rear security": "후방 보안",
	"Time lapse": "타임랩스",
	"Sync with GPS_": "GPS 시간 적용",
	"Overwrite locked event3_": "보호된 이벤트 파일의 덮어쓰기",
	"Video codec": "비디오 코덱",
	"Tracking logs": "운행 기록",
	"Geofence alerts": "Geofence 알림",
	Color: Color$7,
	Exit: Exit$7,
	Save: Save$7,
	Impact: Impact$7,
	Unlimited: Unlimited$7,
	"Parking mode recording": "주차모드 녹화",
	"Battery protection": "배터리 보호",
	"Cut-off timer": "타이머 설정",
	"Low voltage cut-off": "차단전압 설정",
	"Rear camera orientation": "후방 블랙박스 화면전환",
	Default: Default$7,
	"Rotate video 180°": "180° 영상 반전",
	"Mirror video": "영상 미러링",
	"Wi-Fi band": "Wi-Fi 대역",
	"Driving report": "주행 리포트",
	"Unsupported video codec_": "H.265는 Web viewer에서 지원되지 않는 비디오 코덱입니다.",
	"Rear camera recording_": "주차모드 중 후방 블랙박스 녹화",
	"Front and rear_": "전후방 블랙박스 동시 녹화",
	"Rear camera stops_": "주차 모드 진입 5분 후 후방 블랙박스 녹화는 정지됩니다. 상시 모드 진입 후 녹화가 재시작됩니다.",
	"Remote firmware update": "원격 펌웨어 업데이트",
	"Firmware is up-to-date": "현재 최신 펌웨어 버전을 사용중입니다.",
	"New firmware available": "새로운 펌웨어가 있습니다.",
	Version: Version$7,
	"Release date": "배포 일자",
	Language: Language$7,
	"File size": "파일크기",
	"What’s new": "새로운 기능",
	"Updating may take_": "업데이트에 몇 분 정도 소요될 수 있습니다.",
	"The update process_": "업데이트 과정에서 업데이트 취소를 할 수 없습니다.",
	"Do not disconnect the_": "일반 녹화 모드가 시작할 때까지 전원을 끊지 마세요.",
	"Downloading firmware": "펌웨어 다운로드",
	"Once download is_": "다운로드 완료 시, BlackVue에서 자동으로 신규 펌웨어를 업데이트합니다. 일반 녹화모드가 시작할 때까지 전원을 뽑지 마세요.",
	"If not allowed_": "허용하지 않으면 Cloud를 통해 차량의 위치와 속도에 접근할 수 없습니다.",
	"Unable to initiate update because_": "BlackVue 블랙박스가 다이렉트 Wi-Fi 를 통해 연결되어 있어 업데이트를 시작할 수 없습니다.",
	Notification: Notification$7,
	Multiple: Multiple$7,
	Range: Range$7,
	"HDR night vision": "HDR 나이트 비전",
	Download: Download$7,
	"G-sensor": "G-Sensor",
	Manual: Manual$7,
	"Low voltage warning": "저전압경고",
	Satellite: Satellite$7,
	"Data usage": "데이터 사용량",
	"Select video download quality": "다운로드 영상 화질 선택",
	"Quick play file_": "빠른 재생 파일",
	"Original file": "원본화질 파일",
	"You do not have permission_": "권한이 없어 해당 기능을 실행할 수 없습니다.\n관리자에게 문의하시기 바랍니다.",
	"Interior camera recording_": "주차모드 중 실내 블랙박스 녹화",
	"Interior security": "실내 보안",
	"Interior camera rotation": "실내 블랙박스 녹화 반전",
	"Multi View": "멀티뷰",
	Tutorials: Tutorials$7,
	"Upgrade now": "지금 업그레이드",
	"Members will show_": "멤버 초대 기능을 사용할 수있게 되면 여기에 일원 목록이 나타납니다",
	"Are you sure_delete members": "멤버 영구 삭제를 진행하시겠습니까?",
	"Some members may_": "필터 적용으로 인해 몇몇 멤버들이 감춰져 보일 수도 있습니다.",
	"Invited on_": "{{Invited Date}}에 초대됨 (초대자: {{role}})",
	Filter: Filter$7,
	"Date created": "생성된 날짜",
	"No admin yet": "관리자 없음",
	"You can add_admin": "그룹별 1명의 관리자를 동록할 수 있습니다.",
	"Collapse all": "모두 숨기기",
	"Expand all": "모두 보이기",
	"Download and playback_cloud": "Cloud 저장공간에서 다운로드 및 Playback",
	"Are you sure_2": "그룹 {Group name}을 삭제하시겠습니까?",
	"Are you sure_groups": "그룹들을 삭제하시겠습니까?",
	"Add cameras first_drivers": "블랙박스를 먼저 추가하고 운전자를 할당하세요.",
	"Flip vertically": "수직 뒤집기",
	Sun: Sun$7,
	Mon: Mon$7,
	Tue: Tue$7,
	Wed: Wed$7,
	Thu: Thu$7,
	Fri: Fri$7,
	Sat: Sat$7,
	Dates: Dates$7,
	Routes: Routes$7,
	Opacity: Opacity$7,
	"Color and opacity": "색상과 투명도",
	"Geofences will show_": "Geofence를 사용할 수있게되면 여기에 나타납니다.",
	"Start drawing a shape_": "지도 위에 도형을 그려보세요.",
	"Add geofence": "지오펜스 추가",
	Entry: Entry$7,
	"Show all members": "모든 멤버 보이기",
	"Me and my_": "나와 내 차. 연결됨",
	"add-on service for_": "Cloud 호환 BlackVue 블랙박스를 위한 추가 서비스",
	"Continue with Google": "구글 계정으로 로그인",
	"An account with_": "해당 이메일 주소로 미인증 계정이 이미 있습니다. 로그인하려면 BlackVue Cloud 비밀번호를 입력하세요.",
	"Account does not_": "계정이 존재하지 않습니다. 또는 Apple 또는 Google 계정으로 로그인해 보세요.",
	"Continue with Apple": "애플 계정으로 로그인",
	"Get started": "시작하기",
	"P subscription only": "<b>{{a}}</b> 구독만 가능",
	"+N USD for extra camera_": "+{{a}} USD 추가 블랙박스 1대",
	"Unlimited Live view": "무제한 Live View",
	"Cameras per Account": "계정당 블랙박스수",
	"Users per Account": "계정당 운전자수",
	Owner: Owner$7,
	"Live View per Day": "일별 Live View 시간",
	"Remote Video Playback_2": "월별 원격 영상재생 및 다운로드",
	"N days": "{{a}} 일",
	"Video On Map": "지도 위 영상표시",
	Undetected: Undetected$7,
	Distracted: Distracted$7,
	Drowsy: Drowsy$7,
	"Whether on mobile_": "모바일 또는 컴퓨터로 BlackVue 블랙박스의 모든 기능을 BlackVue 하나로 즐겨보세요. 최신 <a1>펌웨어</a1>를 설치한 후 <a2>어플</a2>이나 <a3>데스크톱</a3> 뷰어를 다운받으세요. 또는 브라우저에서도 <a4>BlackVue 웹 뷰어</a4>를 사용하실 수 있습니다.",
	"Compatible with most_": "대부분의 BlackVue Wi-Fi 모델과 호환이 가능합니다. DR650GW 시리즈까지 Cloud 호환 BlackVue 모델에 대해 Cloud 지원이 가능합니다.",
	"Supports most recent BlackVue_": "최신 BlackVue 모델을 지원하며 BlackVue Cloud와의 호환도 가능합니다.<br/>\n해당 뷰어는 <b>두 가지 기능을 한번</b>에 제공합니다. SD카드 뷰어를 이용하여 귀하의 SD카드에 저장된 영상을 열람할 수 있고, SD카드를 포맷 또는 BlackVue 세팅을 변경할 수 있습니다. <b>Cloud 뷰어</b>를 통해 Cloud 서비스를 체험해보세요.",
	"Contact us": "문의하기",
	"6 characters with": "글자와 숫자, 특수문자를 포함한 6 문자",
	"Apps and more...": "어플 외 더 많이...",
	"Cameras will show_": "블랙박스를 사용할 수있게되면 여기에 블랙박스가 나타납니다",
	"Keep this page_": "인증 코드를 확인하는 동안 이 페이지를 닫지 마세요. 만약 이메일을 받지 못하였다면 스팸폴더를 확인해주세요.",
	"n cameras": "블랙박스 {{n}}대",
	"n slots": "슬롯 {{n}}개",
	"Calculate your Fleet_": "Fleet Plan 가격을 계산해보세요.",
	"Code you entered_": "기입하신 코드가 정확하지 않거나 만료되었습니다.",
	Calling: Calling$7,
	Smoking: Smoking$7,
	"Smoking has been_": "주행중 흡연이 감지되었습니다.",
	"Email is already_": "이메일이 이미 존재합니다.",
	"Serial number and_": "일련 번호 및 Cloud 코드가 카메라에 인쇄되어 있습니다.",
	"Allow GPS access": "GPS 접근 허용",
	"Used to access_": "귀하의 차량 위치와 속도 데이터 접근 허용에 사용됩니다. 나중에 블랙박스 공개 설정에서 GPS 접근 설정을 변경할 수 있습니다.",
	"Incorrect cloud code": "올바르지 않은 Cloud 코드",
	"An account is_": "해당 이메일 주소로 이미 등록된 계정이 존재합니다.",
	"Live event upload": "라이브 이벤트 업로드",
	Permissions: Permissions$7,
	"Assign in": "할당하기",
	"Are you sure_camera": "이 블랙박스를 삭제하시겠습니까?",
	"Uploading videos:": "영상 업로드:",
	"GPS location recording": "GPS 위치 녹화",
	"When OFF, GPS_": "끄기 설정 시, GPS 위치정보는 Cloud 서버에 전송 및 기록이 되지 않습니다.",
	"As personal video_": "개인적인 영상이 전송되므로, 어떤 정보를 공유할지 신중히 결정하시기 바랍니다.",
	"Share location": "위치 공유",
	Private: Private$7,
	"Used to access_2": "귀하의 차량 위치와 속도 데이터 접근 허용에 사용됩니다.",
	"Share live view": "Live View 공유",
	"Share live audio": "Live View 음성 공유",
	"Share camera’s name": "블랙박스 이름 공유",
	"Impact detection": "충격 감지",
	Entering: Entering$7,
	Exiting: Exiting$7,
	"Normal event recording": "상시 이벤트 녹화",
	"Harsh braking": "급감속",
	Acceleration: Acceleration$7,
	"Sharp turn": "급회전",
	"Parking event recording": "주차 이벤트 녹화",
	Passing: Passing$7,
	"Video source": "영상 소스",
	Overspeed: Overspeed$7,
	"Are you sure_video": "해당 영상을 삭제하시겠습니까?",
	"Add camera to_": "Live View에 블랙박스를 추가하세요",
	"No routes to_": "열람 가능한 경로가 없습니다.",
	"Start by adding_": "날짜를 선택하세요.",
	"invite sent": "초대 전송",
	Recipients: Recipients$7,
	Send: Send$7,
	"Routes selected_": "경로 선택됨: {{total}} 중 {{n}}",
	"Map service": "지도 서비스",
	"Speed units": "속도 단위",
	Note: Note$7,
	"Release notes": "출시 노트",
	"The name must_": "이름은 반드시 1에서 30글자 사이로 입력하세요.",
	Video: Video$7,
	Advanced: Advanced$7,
	"Firmware language": "펌웨어 언어",
	"Wi-Fi": "Wi-Fi",
	Voice: Voice$7,
	"Show date and_": "데이터와 시간 보여주기",
	"Show speed": "속도 보여주기",
	"Front camera rotation": "전면 블랙박스 회전",
	"Manual time settings": "직접 시간 설정",
	"Recommended for better_": "4K UHD 파일 압축 및 용량 줄이기에 적합",
	"For full compatibility_": "이전 데스트톱 및 모바일 기기에 완벽 호환",
	"Up and down": "상하",
	"Side to side": "좌우",
	"Front and back": "앞뒤",
	"Detection region": "감지 구역",
	"Hotspot 1": "핫스팟 1",
	"Hotspot 2": "핫스팟 2",
	"Hotspot 3": "핫스팟 3",
	"Enter/exit": "진입/진출",
	"Event recording": "이벤트 녹화",
	"Front security (Normal)": "전방 보안 (상시)",
	"Front security (Parking)": "전방 보안 (주차)",
	"LTE (Parking)": "LTE (주차)",
	"Wi-Fi (Parking)": "Wi-Fi (주차)",
	"Turn on at startup": "시작할 때 전원켜기",
	"Turn off after_": "10분 간 비활성화 이후 전원끄기",
	"Your firmware is_": "귀하의 펌웨어는 최신입니다.",
	"Add admin": "관리자 추가",
	"Remove All/n": "모두 지우기/{{a}}",
	"Are you sure_remove": "해당 그룹에서 블랙박스를 지우시겠습니까?",
	"This will cancel_2": "Fleet Plan 구독이 취소될 예정입니다. 현재 청구주기 마지막날부터 Free Plan 으로 변경됩니다.",
	"You’ve reached_": "블랙박스별 제한된 운전자 수를 초과하였습니다.",
	"Are you sure_remove admin": "해당 그룹에서 관리자 {{a}}{{b}}를 지우시겠습니까?",
	"Fleet Plan · Owner": "Fleet Plan · 오너",
	"Manage cameras": "블랙박스 관리",
	"Are you sure_delete zone": "\"{{zone}}\" 존을 삭제하시겠습니까?",
	"available on your_2": "현재 플랜으로 사용 가능한 블랙박스 {{a}}대 중",
	"The new plan_2": "신규 플랜은 현재 청구 주기 ({{a}})의 마지막날부터 적용될 예정입니다.",
	"Canceled Fleet Plan_": "{{a}}에 Fleet Plan 삭제됨",
	"Hard braking alert (beep)": "급감속 알람 (경고음)",
	"Hard acceleration alert (beep)": "급가속 알람 (경고음)",
	"Hard cornering alert (beep)": "급회전 알람 (경고음)",
	"SSID must be_": "SSID는 반드시 최소 5글자 이상이어야 합니다.",
	"Password must be_": "비밀번호는 반드시 최소 8글자 이상이어야 합니다.",
	"5 to 32 characters long": "5에서 32글자 사이",
	"8 to 32 characters long": "8에서 32글자 사이",
	"Longer storage period_event": "더 오랜 기간 동안 라이브 이벤트 업로드 저장",
	"Requires latest firmware_": "최신 펌웨어 필수. DR650S과 DR650GW 모델과는 호환 불가",
	"After Blackvue is_": "BlackVue가 Cloud에 연결된 이후 설정이 저장됩니다.",
	"This is an_": "등록되지 않은 이메일입니다. 신규 계정으로 가입하시겠습니까?",
	"This feature is_": "동 기능은 Fleet Plan 구독자에게만 이용이 제한된 기능입니다.",
	"Please return to_": "계정이 존재하지 않습니다. 또는 Apple 또는 Google 계정으로 로그인해 보세요.",
	"Adjusting the cut-off voltage_": "저전압 차단 설정에서 전압을 낮추는 행위가 배터리 방전의 원인이 될 수도 있습니다. 이러한 행위가 배터리 방전 또는 기타 차량 기능에 영향을 미칠 수 있는 만큼 전압을 낮추기 전에 반드시 전문가와 상의하시기 바랍니다.",
	"Your videos will_": "영상을 사용할 수 있게 되면 영상이 여기에 나타날 것입니다.",
	"You drove:_": "주행 이력: {{distance}}, {{time}}",
	"Event count per_": "주행 시간당 이벤트 발생 횟수",
	"Are you sure_recipient": "이 수신자를 정말로 삭제하시겠습니까?",
	"(You)": "{{a}} (귀하)",
	"All events": "전체",
	Days_: Days_$7,
	"Requires DMC 200_": "DMC200 블랙박스가 있어야 합니다.",
	"A DMS and compatible_": "이 리포트를 보려면 DMS 블랙박스 및 호환 블랙박스가 함께 필요합니다.",
	"Notifications will show_": "알림을 사용할 수 있게 되면 알림이 여기에 나타날 것입니다.",
	"Try changing your_": "데이터를 변경하거나 필터를 제거해보세요.",
	Mute: Mute$7,
	UnMute: UnMute$7,
	"Calling and smoking_": "DMC200 블랙박스가 있어야 통화 및 흡연을 감지할 수 있습니다.",
	"You need a DMS_": "이 리포트를 보려면 DMS 블랙박스가 필요합니다.",
	"Try BlackVue Cloud": "오늘 BlackVue Cloud를 체험해보세요.",
	"Individual driver looking_": "개인과 사업자 모두 누구나 안전한 주행과 간편한 차량 보안, 그리고 차량 추적 솔루션을 추구합니다.",
	"Whoever you are_": "귀하가 필요한 모든 것이 무엇이든 Cloud 플랜에서 필요한 것을 찾아보세요.",
	"It is the account that_Driver": "이 계정은 오너 또는 관리자가 보낸 이메일 초대장을 수락하여 귀하의 BlackVue Cloud Fleet에 가입한 계정입니다. 운전자는 제한된 권한, 즉 본인 계정 프로필 및 할당 받은 블랙박스 Live View와 Playback 권한만 부여받으며, 오로지 한 대의 블랙박스에만 할당이 가능합니다.",
	"It is the account that_Admin": "이 계정은 오너가 보낸 이메일 초대장을 수락하여 귀하의 BlackVue Cloud Fleet에 가입한 계정입니다. 관리자 계정은 오너가 해당 관리자에게 허용한 권한을 부여받을 수 있습니다.",
	"Video deleted": "영상 삭제됨",
	"Video delete_plural": "1개 이상의 영상 삭제됨",
	"Driver removed from_": "그룹에서 운전자 제거됨",
	"Admin removed from_": "그룹에서 관리자 제거됨",
	"Camera removed from_": "그룹에서 블랙박스 제거됨",
	"Are you sure_videos": "해당 영상들을 정말로 삭제하시겠습니까?",
	"You have to cancel_fleet": "블랙박스 숫자를 변경하기 위해서 앱 내 구독을 취소해야 합니다.",
	Discard: Discard$7,
	"Discard unsaved changes?": "저장되지 않은 수정 사항을 버리겠습니까?",
	"Incorrect serial number": "잘못된 시리얼 넘버 (SN)",
	"An error occurred_again": "에러가 발생하였습니다. 다시 시도해 주세요.",
	"You are subscribed_free": "귀하의 현재 플랜은 BlackVue Cloud Free Plan 입니다.",
	"When an event_": "이벤트가 발생하면 (충격 감지 또는 매뉴얼 이벤트), 귀하가 선택한 BlackVue 블랙박스에서 이벤트 발생 5초 전 시점부터 라이브 비디오 스트림을 Cloud에 저장합니다.",
	Report: Report$7,
	"How it work": "작동 방식",
	"Cloud Camera": "Cloud 블랙박스",
	"Internet Connection": "인터넷 연결",
	"BlackVue App/Viewer": "BlackVue 앱/뷰어",
	"All you need_": "최적의 BlackVue 사용 환경은",
	"Cloud-compatible BlackVue": "Cloud와 호환되는 BlackVue 블랙박스와",
	"and a cellular_": "모바일 데이터 요금제 준비입니다. 몇몇 모델은 서드파티 Wi-Fi 핫스팟을 통해서만 Cloud에 연결됩니다. 이외 모델은 내장 나노 심카드 리더 또는 플러그-인 연결 모듈 지원을 제공합니다.",
	"Cloud features at_": "손 안에 Cloud 기능",
	"Enjoy peace of_": "어디서든 안심하셔도 좋습니다. BlackVue가 항상 지켜보고 있으니까요. 차량에 무슨 일이 일어나면 BlackVue 블랙박스에서 즉시 메시지를 받아볼 수 있습니다.",
	"Let your BlackVue_": "BlackVue는 차량 감시 뿐만 아니라 알림 전송도 합니다. 충격이 감지되는 순간, BlackVue에서 찰나의 스냅샷과 함께 귀하의 휴대폰이나 웹브라우저로 알림을 전송합니다.",
	"Check on your_": "이제는 어디에 있든 Remote Live View로 차량을 확인하세요. 웹 브라우저 또는 휴대폰을 통해 Cloud 연결 블랙박스에서 전송되는 실시간 영상 피드를 확인하고, 쉬운 블랙박스 방향 전환 기능으로 전후방, 내부 블랙박스에서 보내오는 피드를 실시간으로 확인해보세요.",
	"Your BlackVue may_": "BlackVue로 뺑소니를 방지할 수는 없지만, 그런 일이 생기더라도 BlackVue에서 중대한 영상 증거를 캡쳐할 것입니다. 휴대폰과 웹 브라우저를 사용하여 BlackVue 블랙박스에서 녹화한 모든 영상을 찾아보세요.",
	"Worried about eating_": "데이터 소모 걱정이되시나요? BlackVue는 빠른 검색과 버퍼링 없는 영상 열람을 가능하게 만들기 위해 섭스트림 기술을 도입하여 사용자들이 원본 영상의 가벼운 버전을 사용할 수 있도록 하였습니다.",
	"Move files from_": "BlackVue에서 Cloud로 파일을 이동시키세요. 하나의 파일만 저장할 수도 있고 여러 개의 비디오 클립을 대량으로 선택하여 업로드할 수도 있습니다. BlackVue 어플을 이용하여 휴대폰으로 다운로드한 영상은 내부 저장 메뉴에서 확인 및 공유가 가능합니다.",
	"View your vehicle’s_": "귀하의 차량 위치 및 주행 속도를 실시간으로 확인하세요. Smart Plan 으로 업그레이드하여 지난 7일간의 GPS Tracking 데이터를 확인해보세요.",
	"Get more with_": "Smart Plan 으로 더 많은 혜택을 누리세요.",
	"Unlimited Remote Live_": "무제한 Remote Live View",
	"Up to 3 dashcams_": "단일 계정당 3개의 블랙박스까지 등록 가능",
	"Want to track_": "Fleet 전체를 추적하고 싶으신가요? Fleet Plan으로 업그레이드해보세요.",
	"BlackVue Fleet Tracking_2": "BlackVue Fleet Tracking은 귀하의 Fleet을 보호하고 Tracking할 수 있는 일체형 솔루션입니다.",
	"Stream real-time video_": "무제한으로 실시간 영상을 스트림해보세요. (Bitrate: 600 kbps)",
	"Up to 999 Dashcams": "999개 블랙박스까지 등록 가능",
	"Register up to_": "단일 계정당 999개 블랙박스까지 등록 가능",
	"15GB of Cloud_": "15GB의 Cloud 저장공간",
	"15GB per additional_": "블랙박스 1대 추가 시 15GB 추가. 무제한 라이브 이벤트 업로드 저장공간.",
	"90-days GPS_": "90일 간의 GPS Tracking 로그",
	"High accuracy: 15_": "높은 정확도: 매 15초, 지도 위 영상 (Video On the Map), 손쉬운 데이터 익스포트",
	"Unique fleet management_": "특유의 Fleet 관리 기능이 가치와 편리함을 더합니다.",
	"Create geofences and_": "휴대폰과 컴퓨터에서 지오펜스를 만들고 실시간 알림을 받아보세요.",
	"View at a_": "한눈에 전체 주행 거리, 정차 시간, 속도 이벤트 등을 확인하실 수 있습니다. 필요하면 이러한 테이블을 출력도 할 수 있습니다.",
	"Multi Live View": "멀티 Live View",
	"Monitor up to_": "최대 4대의 블랙박스 영상을 동시에 모니터링할 수 있습니다.",
	"Benefits for you": "BlackVue 사용자를 위한 혜택",
	Individual: Individual$7,
	"Get notifications to_2": "주차되어 있는 차량에 충격이 가해지는 즉시 휴대폰 알림이 도착합니다. 차량 주위에 어떤 일이 벌어지고 있는지 멀리서도 확인할 수 있습니다. 웹과 모바일, Mac과 Windows에서도 확인하실 수 있습니다.",
	"Small business owner": "소규모 사업자",
	"Monitor your commercial_2": "실시간으로 지도 상에 상업용 차량을 모니터링 하세요. 웹 브라우저, BlackVue 모바일앱, Mac 또는 Windows 뷰어를 이용해 운전자에게 어느때나 이야기해보세요.",
	"Company with large_": "대규모 Fleet를 보유한 회사",
	"With BlackVue Fleet_2": "웹 브라우저, BlackVue 모바일앱, Mac 또는 Windows 뷰어로 BlackVue Fleet Tracking기능을 사용해보세요. 실시간으로 999대의 차량까지 Tracking이 가능합니다.",
	Subscribed: Subscribed$7,
	"The video was_": "영상이 이미 업로드되었습니다.",
	Geofence: Geofence$7,
	"500: Internal server error": "500: 내부 서버 오류",
	"404: Page not found": "404: 페이지를 찾을 수 없습니다.",
	"Check the web address_": "웹 주소를 확인하거나 또는 BlackVue Cloud로 돌아가세요.",
	"home page": "홈페이지",
	"There isn’t an_": "이 이메일 주소와 연관된 계정이 없습니다.",
	"You can now_password": "이제 신규 비밀번호로 로그인할 수 있습니다.",
	"Are you sure_remove admin2": "관리자를 정말로 영구 삭제하시겠습니까?",
	"Admin deleted": "관리자 삭제됨",
	"Members deleted": "멤버 삭제됨",
	"Are you sure_groupName": "group {{a}}를 정말로 삭제하시겠습니까?",
	"Requires latest firmware": "최신 펌웨어가 필요합니다.",
	"Selected file(s) moved_": "선택하신 파일이 성공적으로 이동되었습니다",
	"Are you sure_remove driver2": "이 그룹에서 운전자 {{a}} ({{b}})를 정말로 제거하시겠습니까?",
	"Invite sent": "초대장 전송됨",
	"Safe driving": "안전 운전 지수",
	"Reckless driving": "위험운전",
	"Inattentive driving": "부주의운전",
	"Driving events trend": "주행 이벤트 발생 추세",
	"Driving details": "주행 상세 정보",
	Driving: Driving$7,
	Idling: Idling$7,
	Distance: Distance$7,
	"Parking sessions": "주차 횟수",
	"Parked time": "주차 시간",
	"Idle stops": "정차 횟수",
	"Idle time": "정차 시간",
	"Impact events": "충격 이벤트",
	Parked: Parked$7,
	Speed: Speed$7,
	"Overspeeding alerts": "과속 알람",
	Highest_2: Highest_2$7,
	Average: Average$7,
	Geofences: Geofences$7,
	"Entries into a_": "존으로 진입",
	"Exits from a_": "존에서 진출",
	"No data": "데이터 없음",
	"Hard acceleration": "급가속",
	"Hard braking": "급감속",
	"Hard cornering": "급회전",
	"The number within the brackets_": "괄호 안에 있는 숫자는 주행 시간별 평균 이벤트 발생 횟수를 의미합니다. 단, 한 시간 미만으로 주행한 경우 검색 기간동안 발생한 전체 이벤트 횟수가 나타납니다.",
	"Did you insert_": "SIM 카드를 삽입하였습니까?",
	"Click here for_": "더 필요한 정보가 있으시면<a>여기를 클릭하세요.</a>",
	"Back up all_": "<b>설정 저장 전에 중요한 녹화 영상을 모두 백업하세요.</b><br/>설정을 저장할 때 SD카드가 다시 초기화되며 안정적 작동을 위해 모든 녹화 영상이 삭제됩니다.",
	"Not connected to_": "클라우드에 연결되지 않아 몇 가지 기능이 일시적으로 사용 불가해집니다.",
	"GPS Location recording off": "GPS 위치 기록 중단",
	"n Videos deleted": "{{count}} 영상 삭제됨",
	Move: Move$7,
	"Driver Monitoring System (DMS) will_": "운전자 감지 시스템(DMS)가 곧 출시될 예정입니다.",
	"An error occured while_": "블랙박스 수를 변경하는 도중에 에러가 발생하였습니다. 다시 시도해 주세요.",
	"Reached the limit_": "한계에 도달하였습니다: {{a}}",
	"An invitation was_": "이 이메일 주소로 이메 초대장이 발송되었습니다.",
	"To use the_": "클라우드 기능을 사용하려면 SIM 카드를 삽입해주세요.",
	"Last updated": "최근에 업데이트한 날짜 {{date}}",
	"Try changing your date": "날짜 변경을 시도해보세요.",
	"No event data_": "선택하신 기간 동안 수집된 데이터가 없습니다.",
	"Please select another_": "전체 리포트를 열람하시려면 다른 날짜 또는 월을 선택하세요.",
	"more than 6_": "6글자 이상 입력해주세요.",
	"Sign up free": "무료로 가입하기",
	"Cloud storage warning": "클라우드 저장공간 주의",
	"Cloud Storage Full": "클라우드 저장공간 가득참",
	"Cloud storage usage_100": "클라우드 저장공간 사용량이 100%에 달하였습니다. \n클라우드 저장공간을 정리하세요. \n클라우드 저장공간이 가득찬 상태에서 라이브 이벤트 업로드 서비스는 사용이 불가합니다.",
	"Cloud storage usage_": "클라우드 저장공간이 <b>({{a}}%)</b>에 달하였습니다. \n클라우드 저장공간을 정리하세요. \n클라우드 저장공간이 가득찬 상태에서 라이브 이벤트 업로드 서비스는 사용이 불가합니다.",
	"Are you sure_delete_zone": "정말로 삭제하시겠습니까?",
	"Search Name or email": "이름 또는 이메일을 검색해보세요",
	"Search group name": "그룹 이름을 검색해보세요",
	"Please note that_": "신규 설정을 적용하려면 영상 녹화가 몇 초 동안 중단될 것이니 양해 부탁드립니다.",
	"Currently connected Hotspot": "현재 핫스팟에 연결되어 있음",
	"Enhanced night vision": "향상된 나이트 비전",
	"To access the_": "블랙박스를 이용하려면 구독 중인 플랜을 업데이트해주세요.",
	"Restarting the Blackvue_": "설정적용을 위해 블랙뷰 블랙박스를 재시작합니다.",
	"Hard acceleration event_": "초당 속도 증가율이 시속 {{kmh}}km/h ({{mph}} MPH) 이상일 때 급가속 이벤트가 발생합니다.",
	"Hard braking event_": "초당 속도 감속률이 시속 {{kmh}}km/h ({{mph}} MPH) 이상일 때 \n급감속 이벤트가 발생합니다.",
	"Hard cornering event_": "시속 {{kmh}} km/h ({{mph}} MPH) 이상일 때 주행 도중 2초 이내에 60도 이상 회전하는 경우 급회전 \n이벤트가 발생합니다.",
	"Changes you made_": "변경사항이 저장되지 않을 수 있습니다.",
	"My location": "내 위치",
	"Hotspot name (SSID)": "핫스팟 이름 (SSID)",
	Connected: Connected$7,
	"Camera will be rebooted_": "블랙박스가 재시작 됩니다. 계속 진행하시겠습니까?",
	"Restarting the BlackVue_": "BlackVue를 재시작 중입니다. 기다려주세요.",
	"Failed to reboot_": "블랙박스 재시작을 실패했습니다.",
	"Bluetooth (Parking mode)": "블루투스 (주차 모드)",
	"Front and interior camera_": "전/후방 블랙박스가 동시 녹화됩니다.",
	"Interior camera stops_": "주차모드 진입 후 5분이 지나면 실내 블랙박스의 녹화를 멈춥니다. 상시 모드로 다시 진입하면 실내 블랙박스 녹화를 다시 시작합니다.",
	Individual_: Individual_$7,
	"Driver detection": "운전자 감지",
	"During driving only": "주행 중 일시에 만",
	Always: Always$7,
	"Driver detection box": "운전자 감지 박스",
	"DMS camera rotation": "DMS 블랙박스 회전",
	Low: Low$7,
	Medium: Medium$7,
	High_2: High_2$7,
	"Reboot Camera": "블랙박스 재시작",
	"Latest events": "최신 이벤트",
	"G-Sensor": "충격 감도",
	"Playback speed": "재생속도",
	Flip: Flip$7,
	Previous: Previous$7,
	Next: Next$7,
	"Map type": "지도 타입",
	"Zoom in": "확대",
	"Zoom out": "축소",
	"Move to Cloud": "클라우드로 이동",
	"Please recognize that_": "설정 적용 시 영상녹화가 몇 초간 중단될 예정입니다.",
	"6 characters with_": "글자와 숫자, 특수문자를 포함한 6자",
	"Updating firmware": "펌웨어 업데이트",
	"Overspeed event occurs_": "과속 이벤트는 블랙박스가 제한 속도를 초과했음을 운전자에게 경고할 때 발생합니다. 펌웨어 > 시스템 > 위험운전 에서 변경할 수 있습니다.",
	"Enter group name": "그룹 이름을 기입해 주세요.",
	"Live view failed": "Live View 실패됨.",
	"Parking mode enter_": "주차 모드 진입/진출",
	"Cloud connectivity": "Cloud 연결",
	Expand: Expand$7,
	Collapse: Collapse$7,
	"all day": "종일",
	"Driving style": "주행 일지",
	"Driving impact": "충격감지",
	More: More$7,
	"No cameras to_": "추가할 카메라가 없습니다.",
	"You have added_": "추가 가능한 카메라를 모두 추가하였습니다.",
	Multi: Multi$7,
	"Report video": "Report 영상",
	"Sexually explicit content": "선정적인 콘텐츠",
	"Graphic violence": "폭력적이거나 혐오스러운",
	"Hateful speech": "증오 또는 모욕적인",
	"Harassment or bullying": "괴롭힘 또는 따돌림",
	"Spam or advertisement": "스팸/ 광고성이 짖은",
	"Infringement of my_": "나의 권리를 침해하는",
	"Other reason": "기타",
	"Reason for reporting": "해당 영상을 신고하시는 이유를 선택해 주세요.",
	"Reported videos will_": "신고되어진 영상의 경우 보통 72시간 이내에 BlackVue CS팀에서 검수되어집니다.",
	"Touch sensor": "터치 센서",
	"Motion and impact detection": "동작및 충격 감지",
	"Settings have been changed": "설정 변경 완료 안내 음성",
	"Start event recording (beep)": "이벤트 시작 녹화 안내 (경고음)",
	"Scheduled reboots": "예약된 재시작 시간",
	Safe: Safe$7,
	Reckless: Reckless$7,
	Inattentive: Inattentive$7,
	"Highest(Extreme)": "최고화질 (익스트림)",
	"Public cameras": "공유되고 있는 카메라",
	List: List$7,
	Usage: Usage$7,
	"Video playbacks and downloads": "영상 재생과 다운로드",
	"of 100 times": "100회 중",
	"of 10 minutes": "10분 중",
	Profile: Profile$7,
	"Search geofences": "Geofences 검색",
	"Export CSV": "CSV로 다운",
	"Exit fullscreen": "전체 화면 나가기",
	Fullscreen: Fullscreen$7,
	Upgrade: Upgrade$7,
	"Email address": "이메일 주소",
	"of Unlimited": "제한 없는 용량 중",
	"No notifications yet": "최근 7일간 수신된 알림이 없습니다.",
	"No videos yet": "녹화된 영상이 아직 없습니다.",
	Management: Management$7,
	Day: Day$7,
	Month: Month$7,
	"Welcome to the BlackVue_": "BlackVue가 제공하는 Cloud viewer에 오신걸 환영합니다.",
	"You can access BlackVue_": "어디서든, 언제든 BlackVue Cloud는 여러분이 쉽게 접근할 수 있습니다.",
	"Start tour": "둘러보기 시작",
	"Map view": "맵뷰",
	"Check the current_": "본인과 다른 사용자 [ 공유 허용 시 ]의 카메라에 대한 최근 GPS위치와 속도를 확인 해보세요.",
	"Camera’s features": "블랙박스의 기능들",
	"Take a look_": "BlackVue Cloud만이 제공 할 수있는 다양한 기능들을 둘러보세요.",
	"Visualize your vehicle’s_": "시시각각 그려지는 자동차의 이동경로를 볼 수 있어요.",
	"Smart plan_": "Smart plan : 90일, Fleet plan : 90일",
	"Create geofences and2_": "Geofences [ *자신이 지정한 구역 ] 설정 및 Event감지에 대한 실시간 알림을 받아보세요.",
	"Got it": "이해했습니다.",
	"Manage Fleet members": "Fleet plan member 관리하기",
	"Invite fleet members_": "Fleet plan에 member들을 초대 하고 그들을 그룹에 가입켜 보세요.",
	"The moment the_": "BlackVue가 충격을 감지한 순간, 알림이 이곳에 나타납니다.",
	"Geofence Setup (Web)_": "Geofences 설정[ web.desktop ] 그리고 경고 알림",
	"Original file play_": "원본 파일 재생은 다운로드 한 영상으로만 가능합니다.",
	"To get most_": "Blackvue Cloud가 제공하는 최상의 서비스를 이용하려면, 블랙박스가 Cloud에 연결 되야 합니다. BlackVue 어플리케이션을 다운받고 Seamless paring을 통해 블랙박스 등록과 Cloud연결을 한번에 해결하세요.",
	"You haven’t driven_Today": "오늘은 아직 운전을 하지 않으셨습니다. BlackVue와 운전을 한 뒤에 Drive report를 조회해 보세요.",
	"You haven’t driven_Month": "이번 달은 아직 운전을 하지 않으셨습니다. BlackVue와 운전을 한 뒤에 Drive report를 조회해 보세요.",
	"Fleet Plan only_": "해당 기능 및 페이지는 Fleet plan 사용자만 이용 가능합니다.",
	"Overwrite locked event2_": "Overwrite locked Event files when storage is full",
	"DMS’s New firmware_": "DMS’s New firmware available",
	"Highest speed_report": "<b>최고 속도<b/>\n수집된 속도 Data 중 가장 큰 값 출력,\n[미터 단위로 속도 수집,Km/h 및 MPH 단위로 변환 >출력]\n\n<b>평균 주행 속도</b>\n(운행 거리/ 운행 시간) *3600로 평균 주행 속도 계산. Ex (2622 / 1208 ) *3600 = 7814.907\nKm/h :정수만 출력,\nMPH 소수점 2자리까지 출력",
	"Choose a cloud_": "클라우드 연결 수단을 선택하세요",
	"You need an_": "클라우드 서비스를 사용하기 위해서는 인터넷 연결이 필요합니다. 갖고 계신 디바이스를 확인하여 연결 방법을 선택해주세요.",
	"BlackVue SIM card": "블랙뷰 심 카드",
	"Support model_": "지원 모델 : DR750X-2CH LTE Plus (NA)",
	"3rd party SIM_": "타사 심 카드",
	"Support model_SIM": "지원 모델 : DR750X-2CH LTE Plus, DR750-2CH LTE, CM100 LTE",
	"Wi-fi hotspot": "와이파이 핫스팟",
	"Support model_Wifi": "지원 모델 : 블랙뷰 모든 모델",
	"How to connect_": "클라우드에 연결하는 방법",
	"Download BlackVue application": "블랙뷰 앱 다운",
	"*If you are_": "만약 블랙뷰 심 카드를 사용하여 클라우드 연결을 시도하신다면, {{a}} {{b}}로 이동해주세요.",
	"Place your phone_": "블랙박스와 스마트폰의 범위를 최대한 가까이 하여 블루투스를 사용 할 수 있게 준비하세요. 그리고 간단한 페어링 {{a}} 방법으로 연결을 시도하세요.",
	"Back to camera_": "카메라 리스트로 돌아가기",
	"Upgrade for more_": "다른 혜택을 위해 업그레이드!",
	"Upgrading the cloud_": "클라우드 요금제를 업그레이드하면 더 많은 기능을 사용 할 수 있고 여러 대의 카메라를 관리할 수 있습니다. 클라우드 요금제를 업그레이드하시겠습니까?",
	"Explore cloud plans": "클라우드 계획 살펴보기",
	Later: Later$7,
	"Successfully subscribed": "성공적으로 구독을 완료하였습니다.",
	"1GB data plan": "1GB 데이터 요금제",
	"First month free_": "첫 한달 무료, <a> 이후로 10.99 USD가 매월 결제됩니다.",
	"Next billing date": "다음 결제일",
	"Once SIM card_": "유심카드가 블랙박스에 삽입되어있으면, 자동으로 개통되어 블랙뷰 클라우드 서비스를 바로 사용하실 수 있습니다.",
	"Go to SIM_": "유심 관리 바로가기",
	"Manage your BlackVue_": "여기서 블랙뷰 유심을 관리하세요!",
	"Recommended for BlackVue_": "블랙뷰 심 홀더에 권장합니다.",
	"Connect to cloud": "클라우드에 연결",
	"Enter BlackVue SIM_": "블랙뷰 유심 ICCID 번호 입력",
	"ICCID number is_": "ICCID 번호는 유심 카드 하단에 표시되어 있습니다. 894642 다음 숫자 14자리를 입력해주시기 바랍니다.",
	ICCID: ICCID$7,
	"SIM information": "유심 정보",
	"Start your free_": "지금 시작하고 무료 체험 혜택을 받으세요!",
	"SIM card activate_": "심카드 활성화 일자",
	"Based on the_": "카메라에 심카드가 삽입되어 전원이 인가되면 심카드가 활성화됩니다.",
	"Upgrade to 3GB_": "언제든 3GB/5GB로 데이터 요금제 업그레이드 가능",
	"Cancel your plan_": "언제든 요금제 해지 가능",
	"No Commitment": "약정 없음",
	"Precautions for using_": "꼭 읽어주세요",
	"After 1GB is_": "한 달 1GB가 소진되면 추가 데이터를 사용 할 수 없습니다.",
	"If you have_": "블랙박스에 심 카드를 삽입하여 사용하는 시점부터 무료 체험 기간이 시작됩니다.",
	"This content is_": "해당 내용은 심 카드 패키지에 명시되어 있습니다. 이미 지난 무료 기간에 대한 보상은 지원하지 않습니다.",
	"If you have_2": "질문이 더 있으시면 <a>고객 센터</a>로 문의 주시기 바랍니다.",
	"When OFF, connecting_": "Off로 설정 시, Seamless pairing을 이용하여 블랙박스를 연결할 수 없습니다.",
	"1 month free": "한 달 무료",
	"No commitment. Cancel_": "약정 없음. 언제나 해지 가능.",
	"The video has been reported_": "영상이 성공적으로 관리자에게 보고되었습니다.",
	"Free for 1 month": "한 달간 무료",
	"Start your free_2": "무료 체험을 시작합니다.",
	"1GB free for_": "{{a}}일 동안 1GB 무료",
	"1GB data": "1GB 데이터",
	"1 month free_2": "{{a}}부터 1GB 데이터를 사용 할 수 있는 블랙뷰 심 무료 체험 기간이 시작됩니다.",
	"Your next billing_": "다음 결제 예정일 {{a}}",
	"SIM card": "심 카드",
	"SIM guide": "심 가이드",
	"SIM card list": "심 카드 리스트",
	"Add SIM card": "심 카드 추가",
	"No SIM card_": "등록된 심 카드 없음",
	"Search SIM ICCID_": "ICCID 또는 이름 검색",
	"Cloud disconnected. Failed_": "클라우드 연결 끊김. 영상 재생을 실패하였습니다.",
	"This sim card_": "해당 심 카드는 이미 다른 계정에 등록되어 있습니다.",
	"Incorrect BlackVue SIM_": "알맞지 않은 블랙뷰 심 ICCID 번호 입니다.",
	"My shared videos": "공유된 영상들",
	"Number of events": "이벤트 횟수",
	"Added to Event Map": "이벤트맵에 영상이 공유되었습니다.",
	"Successfully added video(s)_": "성공적으로 이벤트맵에 영상이 공유되었습니다. 공유된 영상의 목록을 보시거나 편집하시려면 이벤트맵 > 공유된 영상들에서 확인하실 수 있습니다.",
	"Already added to_": "이벤트맵에 이미 공유된 영상입니다.",
	"This video(s) is already added_": "해당영상은 이미 이벤트맵에 공유된 영상입니다. 공유된 영상의 목록을 보시거나 편집하시려면 이벤트맵 > 공유된 영상들에서 확인하실 수 있습니다.",
	"BlackVue’s firmware is up_": "블랙뷰 펌웨어가 최신상태입니다",
	"Service end": "서비스 종료일",
	Resubscribe: Resubscribe$7,
	"Sort ascending": "오름차순 정렬",
	"Sort descending": "내림차순 정렬",
	plan: plan$7,
	USD: USD$7,
	"Are you sure_Cancel": "구독을 취소하시겠습니까? 아래 내용을 확인하시기 바랍니다.",
	"Your current SIM_": "현재 구독중인 서비스는 {{a}}에 종료되며 더 이상 요금이 청구되지 않습니다.",
	"After canceling your_": "심 카드 구독을 해지하신 후에도 결제 주기가 종료될 때까지는 블랙뷰 서비스를 계속 이용 할 수 있습니다.",
	"You can resubscribe_": "구독이 종료된 30일 이내에만 다시 구독 가능합니다. 재구독을 원하시면 {{a}}까지 '재구독' 버튼을 클릭하여 구독하시기 바랍니다.",
	"Reason to cancel_": "가입 취소 이유",
	"Found an alternative": "다른 대안 서비스를 찾음",
	"Too expensive": "너무 비쌈",
	"Not required anymore": "더 이상 필요 없음",
	"Quality issue": "품질 문제",
	etc_: etc_$7,
	"Please describe in_": "자세히 설명해 주세요",
	"SIM card cannot_": "해당 심 카드는 구독중으로 삭제 할 수 없습니다. 삭제하고 싶으시면 구독을 먼저 해지하세요.",
	"SIM card cannot_2": "해당 심 카드는 사용 기간이 남아있어 삭제 할 수 없습니다. 서비스 기간이 종료되고 삭제하시기 바랍니다.",
	"Are you sure_deleteSIM": "심 카드를 삭제하시겠습니까? <br/>\n<b>경고: 이 작업은 취소 할 수 없습니다. 모든 심 정보가 즉시 삭제됩니다.",
	"ICCID number": "ICCID 번호",
	"Activation date": "활성화 일자",
	"Current plan": "구독중인 요금제",
	"Manage Plan": "요금제 관리",
	"Next billing on": "다음 결제일",
	"View Invoices": "영수증 보기",
	"Choose best plan_": "원하는 요금제를 선택해주세요",
	"Plan summary": "요금제 요약",
	"Ends on_": "{{a}} 만료",
	"Start from_": "{{a}} 시작",
	"Your subscription will_": "현재 구독중인 요금제 기간이 끝나면 선택된 요금제로 {{a}}에 업그레이드 됩니다.",
	"Resubscribe plan": "요금제 재구독",
	"Your subscription will2_": "구독중인 요금제 기간이 끝나면 선택된 구독이 {{a}}에 시작됩니다.",
	"Usage is estimated_": "사용량은 {{a}}를 기준으로 측정됩니다.",
	"Days left_": "{{a}}일 남았습니다.",
	"Data usage cycle": "데이터 제공 주기",
	Available: Available$7,
	Used: Used$7,
	"Data used": "사용된 데이터양",
	"Subscribe to n_": "<b>{{b}}에서 {{c}}</b> 기간동안 {{a}} 요금제가 제공되고 재구독한 {{d}} 요금제는 {{e}}부터 적용됩니다.",
	"Will be charged_": "{{a}}에 요금이 부과됩니다.",
	"Monthly usage": "월별 사용량",
	"You have fewer_": "이번 달에 남은 데이터가 없습니다.",
	"Get more data": "더 많은 데이터를 사용하세요!",
	"This video cannot be shared": "해당 영상은 공유될 수 없습니다.",
	"This is a video cannot be shared_": "영상의 위치정보 기록이 확인되지 않아 이벤트맵에 공유될 수 없습니다.",
	Cancelled: Cancelled$7,
	Terminated: Terminated$7,
	"Edit name": "이름 수정",
	"Not connected to_2": "클라우드에 연결되지 않았습니다. 카메라가 활성화 상태 및 인터넷 연결 모듈이 활성화되어 있는지 확인합니다.",
	"Some functionality is disabled_": "카메라가 클라우드에 연결되어 있지 않기 때문에 일부 기능이 비활성화되었습니다. <a>여기에서</a> 클라우드에 연결하십시오.",
	"If you want to cancel_": "만약 구독을 취소하시려면, <a>구독 취소</a>를 누르세요.",
	"Select plan": "요금제 선택",
	"Event map collects_": "이벤트맵은 주변 도로의 상황을 확인하기 위한 블랙뷰 사용자들의 이벤트정보 분포를 보여줍니다.",
	"Share your Live_": "당신의 라이브 이벤트업로드 파일을 공유하세요. 이벤트맵에서는 이벤트 영상을 당신의 주변 사용자들에게 공유할 수 있습니다.",
	"You can check_": "다른 사용자들이 공유한 주변 이벤트 영상을 확인하실 수 있습니다.",
	"Service end_": "서비스 만료 : {{a}}",
	"DMS camera recording_": "DMS 카메라가 주차모드에서 영상녹화를 시작했습니다.",
	Sort: Sort$7,
	"Are you sure you want_": "해당 공유 영상을 이벤트맵에서 제거하시겠습니까?",
	"Remove shared video": "공유영상 제거",
	"Explore event map": "이벤트맵 둘러보기",
	"Event map": "이벤트맵",
	"Explore the graphic_": "당신의 주변에서 일어나고 있는 블랙뷰 이벤트 통계를 확인해보세요.",
	"You can filter_": "확인하고 싶은 이벤트를 골라서 필터를 적용하여 볼 수 있습니다.",
	"This video was removed by_": "해당 영상은 사용자 신고로 관리자에 의해 제거되었습니다.",
	Bonus: Bonus$7,
	"Your subscription plan": "자동 결제 정보",
	"Your free trial will_": "무료 체험 기간 시작일 {{a}},</br> <strong>until</strong> {{b}}.",
	"Total after free trial": "무료기간 이후 총 결제 금액",
	"This sim card is_": "해당 심카드는 사용 불가합니다.",
	"Firmware is up_": "최신 펌웨어입니다.",
	"Keep in mind": "꼭 읽어주세요",
	"Once 1GB of_": "1GB의 데이터가 모두 소진되면 다음 데이터 초기화 날짜까지 서비스를 이용 할 수 없습니다(요금제를 업그레이드해도 다음 달에 업그레이드된 요금제로 적용됩니다.)",
	"After the SIM_": "블랙박스에 심카드를 삽입하여 전력을 인가하면 데이터가 사용되어 무료 체험 기간이 시작됩니다.",
	"If you have_questions": "문의 사항이 있으면 <a>고객 지원 센터</a>로 연락주시기 바랍니다.",
	"Data reset date": "데이터 초기화 일자",
	"To use SIM card_": "심 카드를 사용하기 위해서 블랙뷰 CS 팀으로 문의 주시기 바랍니다.",
	"Go to Subscription": "구독 상태 바로가기",
	"An error occurred_subscription": "구독 진행 중에 오류가 발생하였습니다.",
	"Please try again": "다시 시도해주세요",
	"Failed to subscribe": "구독 실패",
	"Go to Pricing": "요금제표 바로가기",
	"SIM cards will_": "심 카드가 등록되면 여기에 표시됩니다.",
	"1GB for 1_": "한 달 1GB 제공",
	"Pricing Data": "데이터 요금",
	"If you would like to check_": "공유된 영상의 목록을 보시거나 편집하시려면 이벤트맵 > 공유된 영상들에서 확인하실 수 있습니다.",
	"Connect to Cloud": "클라우드 연결",
	"Completed!": "완료!",
	"Back to App": "앱으로 돌아가기",
	"iOS in-app purchase": "iOS 인앱 구매",
	"Android in-app_": "안드로이드 인앱 구매",
	"bonus n days": "보너스 {{a}}일",
	"Want to contribute your_": "이벤트업로드 파일들에 대한 이벤트맵 자동공유를 허용하시겠습니까?",
	"With event map_": "이벤트맵에서는 이벤트 업로드 영상들을 주변 블랙뷰 사용자들에게 공유할 수 있습니다.",
	"You can edit_3": "이벤트맵 자동공유 설정은 언제든지 블랙뷰 클라우드>카메라 설정>프라이버시 설정에서 수정하실 수 있습니다.",
	"If you want to remove videos_": "개인정보가 담긴 영상이 공유될 수 있으므로 공유하시는 영상에 대한 특별한 주의를 부탁드립니다.",
	"Total events": "전체 이벤트 수",
	"Automatically add Live Event_": "이벤트맵 이벤트업로드파일 자동공유",
	"This camera is publicly_": "해당 카메라는 위치만 공개됩니다.",
	incomplete_zip: incomplete_zip$7,
	"Live Event Upload_": "라이브 이벤트 업로드(저장기간:7일)\n최신 펌웨어 필요",
	"Thank you for_2": "양해해 주셔서 감사합니다.",
	"Start Web viewer": "웹 뷰어 시작하기",
	"Are you sure_remove driver": "해당 운전자를 영구적으로 삭제하시겠습니까?",
	"An error occurred_sim": "구독을 시도하는 동안 오류가 발생했습니다.",
	"Click the ADD SIM": "심카드 목록 페이지에서 심 추가 버튼을 클릭하여 프로세스를 진행합니다.",
	"Set download options": "다운로드 옵션 설정",
	"Information may be_": "해당 정보는 시간 지연이 발생하여 실제 사용량을 빠르게 반영하지 못할 수 있습니다.",
	"Swipe left and right to move": "왼쪽 오른쪽으로 이동 가능",
	"Scheduled maintenance Notice": "서버 점검 예정 안내",
	"Our Cloud server_": "계획된 클라우드 서버 점검 진행중입니다.",
	"During that time_": "서버 점검 진행중에는 클라우드 기능이 작동하지 않습니다.",
	"Expected maintenance start_": "예상 점검 일시:",
	"Expected duration_": "예상 소요시간:",
	"For more information_": "더 많은 정보를 원하시면, <a>[Server Maintenance Notice]</a>를 클릭하세요",
	"Do not remind_": "다시 보지 않기",
	"Cloud Server Maintenance": "클라우드 서버 유지보수",
	"BlackVue Cloud Service_": "블랙뷰 클라우드 서비스를 일시적으로 사용 할 수 없습니다.",
	"We are currently_": "블랙뷰는 현재 유지보수 중입니다.",
	"We apologize for_": "불편을 끼쳐드려 죄송합니다.",
	"Driver Monitoring System (DMS)": "DMS (운전자 감지 시스템)",
	"Distracted occurs_": "운전자의 머리가 전면에서 50도 이상 벗어날 때 발생합니다.",
	"Hand distraction event occurs_": "운전자의 손이 머리 근처에서 오랜 기간 감지되는 경우 발생합니다 (예: 흡연, 휴대폰 사용 등).",
	"Mask off event occurs_": "운전자가 마스크를 착용하지 않고 차량에 탑승할 때 또는 운전자가 마스크를 벗을 때 발생합니다.",
	"DMS setting": "DMS (운전자 감지 시스템) 설정",
	"The DMS system has_": "DMS는 인식된, 인식되지 않은, 산만한, 졸음, 마스크 미착용 상태를 위한 얼굴 인식 상자와 손 산만 상태를 위한 움직임 감지 상자를 결합합니다.",
	"DMS detection": "DMS 감지",
	"There are detection criteria for_": "각 이벤트에 대한 감지 기준이 있습니다. 아래 가이드를 참조해주세요.",
	"DMS camera recording_onoff": "켜기: 전원이 유지되는 한 DMS 카메라는 주차 모드에서 계속해서 녹화됩니다. <br/> 끄기: DMS 카메라는 주차 모드 진입 후 곧바로 전원이 꺼집니다.",
	"LED lighting for each event_": "운전자 모니터링 카메라의 LED는 각각의 감지 이벤트(산만함, 졸음 등)마다 신호를 표시합니다.",
	"Drowsy and Distracted each have_": "졸음과 산만함은 각각 세 가지 민감도 조건을 가집니다.\n아래 가이드 인터페이스를 참조하십시오.",
	"DMS event detection sensitivity": "\"졸음\"이벤트 감지에 대한 민감도",
	"Only drowsy and distracted include_": "오직 \"졸음\"과 \"부주의\" 이벤트에서만 민감도 설정이 가능합니다. 설정된 민감도는 2가지 옵션에 하나의 설정으로 일괄 적용됩니다.",
	"When driver’s eyes close_": "운전 중에 운전자가 양쪽 눈을 모두 1초 이상 감거나 2초간 하품을 한 경우 발생합니다.",
	"n digit": "{{a}} 자리",
	"You are subscribed_free_Smart": "BlackVue Cloud 스마트 요금제에 가입하셨습니다.",
	"Wi-Fi auto turn on": "Wi-Fi 자동 켜기",
	"Video on a map": "지도상의 비디오",
	"This feature is only_vom": "이 기능은 플릿 요금제에 가입한 사용자만 사용할 수 있습니다.<br/>이 기능을 사용하려면 요금제에 가입하세요.",
	"Total n days_": "총 {{a}}일의 무료 서비스 제공 기간\n",
	"Every events of DMC200_": "DMS 감지 기능은 일반 모드에서만 활성화됩니다. 주차 모드에서 전원을 공급하면 DMS 카메라는 비디오만 녹화합니다.",
	"An undetected event occurs_": "운전자가 카메라 앞에서 1분 동안 감지되지 않을 때 발생합니다.",
	"A detected event occurs_": "운전자 감지의 경우 운전자가 DMC200 카메라 정면을 응시할 경우 감지 됩니다.",
	"Drowsy sensitivity_": "민감도 높음: 운전자의 양쪽눈이 1초 간 감겨있을때 졸음운전이 감지 됩니다.<br/><br/> 민감도 중간: 운전자의 양쪽눈이 1.5초 간 감겨있을때 졸음운전이 감지 됩니다. <br/><br/>민감도 낮음: 운전자의 양쪽눈이 2초 간 감겨있을때 졸음운전이 감지 됩니다.",
	"Distracted sensitivity_": "민감도 높음: 운전자의 고개각도가 50도 이상 정면으로 부터 3초간 이탈 할 경우 감지됩니다.<br/><br/>민감도 중간: 운전자의 고개각도가 50도 이상 정면으로 부터 5초 간 이탈 할 경우 감지됩니다.<br/><br/>민감도 높음: 운전자의 고개각도가 50도 이상 정면으로 부터 7초 간 이탈 할 경우 감지됩니다.",
	"Start your subscription now": "블랙뷰 유심 구독 하기",
	"Free trial period has expired": "무료 체험 기간이 만료되었습니다.",
	"1 data plan will start from_": "데이터 요금제는 {{a}}부터 시작되며 1GB 데이터가 포함됩니다.",
	"Allow the BlackVue_": "BlackVue 앱이 대시캠의 GPS 데이터에 접근하도록 허용하시겠습니까?",
	"We use this_": "자동차의 위치와 속도를 추적할 수 있습니다.",
	"You can edit_": "BlackVue Cloud > 카메라 설정 > 개인정보 설정에서 언제든지 GPS 접근 설정을 수정할 수 있습니다.",
	"SIM cards": "SIM 카드",
	"Subscription status": "구독 상태",
	Upgrades: Upgrades$7,
	"Upgrade plan": "요금제 업그레이드",
	"Manage plan": "요금제 관리",
	"Next plan": "다음 달 요금제",
	OR: OR$7,
	"Cancel subscription": "구독 취소",
	Undo: Undo$7,
	Invoice: Invoice$7,
	"Daily usage": "일일 데이터 사용량",
	"Delete SIM": "SIM 삭제",
	"New card": "신규 카드",
	data: data$7,
	"SIM card data_": "SIM 카드 데이터 요금제 가입은 <a>sim.blackvuecloud.com</a>에서 취소할 수 있습니다.",
	"Your plan from_": "오늘부터 다음 결제일까지의 요금제",
	"Applied during_": "{{a}} ~ {{b}} 동안 적용됨",
	"From today until_": "새로운 요금제 조건은 다음 결제일부터 적용됩니다. 이 기간에 대한 결제는 오늘 청구됩니다. <a>요금은 일할 계산됩니다.</a>",
	"Choose your next plan": "다음 달부터 적용될 요금제를 선택하세요",
	"Applied from_": "{{a}}부터 적용됨",
	"Payment for this_": "이 요금제에 대한 결제는 {{a}}에 청구됩니다.",
	"By sharing your_2": "라이브 뷰를 공유하면 다른 사용자가 전 세계를 운전하는 즐거움을 대리 경험할 수 있습니다. 단, 개인 영상이 전송될 수 있으므로 어떤 정보를 공유할지 결정에 특별한 주의를 기울여야 합니다.",
	"Option camera recording_": "주차모드에서 옵션 카메라 녹화",
	"Front and option camera_": "전면 및 옵션 카메라는 함께 녹화합니다.",
	"Option camera stops_": "옵션 카메라는 5분 동안 녹화를 중지합니다. 주차모드 진입 후 일반 모드로 들어가면 녹화가 다시 시작됩니다.",
	"Option camera rotation": "옵션 카메라 회전",
	"Option camera": "옵션 카메라",
	"Option camera security": "옵션 카메라 보안",
	"Resubscribe until_": "재구독 기한: {{a}}",
	"Firmware Update Caution": "펌웨어 업데이트 주의사항",
	"Please check below_": "DMC200에 대한 펌웨어 업데이트 전에 아래 조건을 확인해주세요:",
	"The camera's Wi-Fi_": "카메라의 와이파이가 켜져 있어야 합니다.",
	"Check if your_": "카메라의 Wi-Fi가 켜져 있는지 확인합니다.",
	"DO NOT disconnect_": "펌웨어 업데이트 중에 케이블을 분리하지 마십시오.",
	"The camera and_": "카메라와 DMC200은 고장날 수 있습니다.",
	"DO NOT try_": "카메라 재부팅이 완료될 때까지 다른 기능을 사용하지 마십시오.",
	"Expecially Reboot camera_": "특히 카메라 재부팅, SD 카드 포맷은 두 장치를 분해하는 데 중요할 수 있다.",
	"Update anyway": "업데이트 진행하기",
	"Invited on_2": "{{Invited Date}}에 초대됨 (초대자: {{role}})",
	"BlackVue’s New firmware_": "새로운 펌웨어 업데이트 가능",
	"valid thru_": "유효 기간: {{a}}",
	"Billed monthly": "매월 청구",
	"90 minutes Live_": "90분 라이브 뷰 / 라이브 이벤트 업로드*",
	"or 2+ videos_": "또는 전체 해상도의 동영상 2개 이상*",
	"1GB Free Month_": "1GB 무료 월 평가판",
	"Cancel anytime": "언제든지 취소",
	"8+ hours Live_": "8시간 이상 라이브 뷰 / 라이브 이벤트 업로드*",
	"or 12+ videos_": "또는 전체 해상도의 12개 이상의 동영상*",
	"15+ hours Live_": "15시간 이상 라이브 뷰 / 라이브 이벤트 업로드*",
	"or 23+ videos_": "또는 전체 해상도의 23개 이상의 동영상*",
	Popular: Popular$7,
	"For Power Users": "고급 사용자용",
	"Estimates based on_": "* 라이브 뷰, 빠른 보기 원격 재생 또는 라이브 이벤트 업로드 파일의 경우 분당 4.5MB, 전체 원본 해상도 비디오 다운로드 또는 재생(25Mbps 비트레이트에서)당 190MB를 기준으로 한 추정치입니다. 일일 유휴 클라우드 연결 데이터 사용량: 24시간당 20MB. 데이터 사용량은 모든 유형의 서비스(라이브 뷰, 라이브 이벤트 업로드 등)에서 공유됩니다.",
	"Balanced Plan": "추천 플랜",
	"For Light Cloud_": "라이트 클라우드용",
	"Front security (Normal mode)": "전면 보안(일반 모드)",
	"Front security (Parking mode)": "전방보안(주차모드)",
	"BT (Parking mode)": "BT (주차모드)",
	"LTE (Parking mode)": "LTE (주차모드)",
	"Wi-Fi (Parking mode)": "와이파이(주차모드)",
	"Hand distraction": "손동작 감지",
	Mask: Mask$7,
	"Second drowsy is_": "연속 졸음은 졸음 이벤트 이후 30초 이내에 감지됩니다.",
	"Second drowsy alert": "연속 졸음 감지 알림",
	"BlackVue sim card_": "블랙뷰 유심은 케나다와 미국에서만 사용 가능합니다.",
	"Global support is coming soon.": "글로벌 지원은 곧 출시될 예정입니다.",
	"The video file not found_": "비디오 파일을 찾을 수 없거나 재생 중에 문제가 발생했습니다. 다시 시도하십시오.",
	"Start Voice Call": "보이스콜 시작",
	"End Voice Call": "보이스콜 종료",
	"Voice call in use": "보이스콜 사용중",
	"Enable microphone access_": "보이스콜 기능을 사용하려면 브라우저 설정 페이지로 이동하여 마이크 엑세스를 활성화해야합니다.",
	"You may need to_": "새 설정을 적용하려면 새로고침이 필요 합니다.",
	"Eye status": "-",
	"Start time of live event upload video": "Video start",
	"Left eye": "오른 눈",
	"Right eye": "왼 눈",
	"Drowsy is occured when the driver close his/her eyes more then 1sec": "졸음운전은 운전자가 자신의 눈을 1초 이상 감았을때 감지 됩니다.",
	"Driver's Left eye movements with blinking count and period": "운전자의 왼 눈을 감은 횟수 및 정도 수치화",
	"Driver's Right eye movements with blinking count and period": "운전자의 오른 눈을 감은 횟수 및 정도 수치화",
	"Drowsy big data of the driver and after a Drowsy event occurs": "졸음운전 발생 이후 운전자 눈 깜빡임에 대한 빅데이터 수치화",
	"Sharing video to Event Map": "Sharing video to Event Map",
	"Want to use a Voice call?": "보이스 콜을 사용하시겠습니까?",
	"To use a voice call_": "보이스콜을 사용하시려면 라이브뷰를 재실행하고 \"허용\"을 누르세요.",
	"There is no_": "아직 공유된 동영상이 없습니다. \n공유하면 목록이 나타납니다.",
	"Microphone blocked": "마이크가 차단됨",
	"Want to center the map on your location?": "현재 위치로 지도를 이동하고 싶으신가요?",
	"To let the app access your location_": "To let the app access your location, restart Event Map and select \"OK\" when prompted.",
	"Location access permission required": "위치접근권한이 필요합니다",
	"Are you sure you want_2": "이벤트맵에서 해당 영상을 제거하시겠습니까?",
	"Two-way voice_2": "양방향 음성통화 / 음성통화",
	"Not supported by DR650GW and DR650S_": "DR650GW 및 DR650S에서는 지원되지 않음",
	"DR650S Series only_": "DR650S 시리즈 전용",
	"Cancel download?": "다운로드를 취소하시겠습니까?",
	"Your download is not_": "다운로드가 완료되지 않았습니다. 다운로드를 취소하시겠습니까?",
	"Continue download": "계속 다운로드",
	"Cancel download": "다운로드 취소",
	"Share your video to the Event Map?": "영상을 이벤트 맵에 공유하시겠습니까?",
	"Afterwards, according to the reaction to the video_": "이후 해당 영상에 대한 반응에 따라 인기 영상으로 분류되어 인기 영상 목록에 소개될 수 있습니다.",
	"Add hashtags and a brief description to describe your video.": "동영상을 설명하는 해시태그와 간단한 설명을 추가해주세요.",
	"Would you like_": "이벤트 맵에 공유하시겠습니까?",
	"Successfully added video_": "이벤트 맵에 성공적으로 공유가되었습니다!",
	"This video cannot_": "이 영상은 지도에 고정할 GPS 위치 데이터가 없기 때문에 공유할 수 없습니다.",
	"This video is_": "이미 이벤트 맵에 공유된 영상입니다.",
	"Share to Event Map": "이벤트맵에 공유하기",
	"Describe in more_": "영상의 상황에 대해 간단한 설명을 추가해주세요(선택사항).",
	"Description(optional)": "설명(선택사항)",
	"Recording mode": "녹화 모드",
	"Event triggers": "이벤트 종류",
	DMS: DMS$7,
	"Camera connectivity": "카메라 통신 연결",
	"If not allowed_2": "허용하지 않으면 Cloud를 통해 차량의 위치와 속도에 액세스할 수 없습니다.",
	"Share Live View_": "라이브 뷰 영상 공유",
	"Share Live View_2": "라이브 뷰 음성 공유",
	"Share camera profile": "카메라 프로필 공유",
	"Parking impact": "주차중 충격",
	"Parking events": "주차 이벤트",
	"Audio recording": "음성 녹음",
	"Toggle the mic_": "마이크 켜기/끄기 전환",
	"Full HD_": "풀 HD @ 60fps + 풀 HD @ 30fps",
	"Video quality": "영상 품질",
	Extreme: Extreme$7,
	"More video files": "많은 녹화 파일",
	"Fewer video files": "더 적은 녹음 파일",
	"Camera rotation": "카메라 회전",
	"Video overlay": "영상 문구 표기",
	"Date & time display": "날짜 및 시간 표시",
	"Speed unit": "속도 단위",
	"Check the orientation_": "차량에 장착된 전방 카메라의 방향을 확인하세요. 수직 방향으로 비디오를 녹화하려면 일치하는 옵션을 선택하십시오.",
	"Rotate 180º": "180º 회전",
	"Rear camera rotation": "후면 카메라 회전",
	"Check the orientation_rear": "차량에 장착된 후방카메라의 방향을 확인하세요. 수직 방향으로 비디오를 녹화하려면 일치하는 옵션을 선택하십시오.",
	"Mirror View": "미러 뷰",
	"Select Mirror View_": "비디오를 가로로 뒤집으려면 미러 보기를 선택합니다.",
	"Check the orientation_interior": "차량에 장착된 옵션 카메라의 방향을 확인하세요. 수직 방향으로 비디오를 녹화하려면 일치하는 옵션을 선택하십시오.",
	"Display off": "디스플레이 끄기",
	"Explore crowd-sourced Events_": "지도에서 크라우드 소싱 이벤트(Impact, Hard Braking 등)를 탐색하고 커뮤니티에서 공유한 비디오를 보고 자신의 이벤트를 제공하십시오.",
	OFF: OFF$7,
	"Reboots once-a-day_": "주차모드 시 설정한 시간에 1일 1회 재부팅하여 안정성 향상",
	"Set time": "시간 설정",
	"FW language": "펌웨어 언어",
	"Rear security_2": "후방 보안",
	"Bluetooth (Parking mode)_2": "블루투스(주차모드)",
	"Failed to save_2": "라이브 이벤트 업로드 설정을 저장하지 못했습니다.",
	"Event file will_": "이벤트 파일은 라이브 이벤트 업로드 저장소에 자동으로 저장됩니다.",
	"An impact was_": "주차모드에서 충격이 감지되었습니다.",
	"When exiting Parking_": "주차 모드에서 나갈 때 BlackVue는 주차 모드에서 충격이 감지되면 알려줍니다. <br/><br/>참고: <br/>충격은 이벤트 비디오를 생성합니다. 주차모드 해제 후 3분 이내에 발생한 충격은 무시됩니다.",
	"Protect event files": "이벤트 파일 보호",
	"Turning on this_": "상시녹화, 주차녹화 파일이 마지막 {{a}}개 이벤트 파일을 덮어쓰지 않도록 보호합니다.",
	"Impact Events in_": "일반(E) 및 주차 모드(I)의 충격 이벤트",
	"Manual Events_": "긴급 녹화(M)",
	"Once 50 Events_": "50개의 이벤트가 기록되면 새 이벤트 파일이 가장 오래된 이벤트를 덮어씁니다.",
	"Reckless driving unit": "위험 운전 단위",
	"Hard acceleration Event": "급가속 이벤트",
	Threshold: Threshold$7,
	"Triggers when the_": "카메라가 설정된 임계값을 초과하는 초당 가속도를 감지하면 발생됩니다.",
	"Triggers when the_2": "카메라가 설정된 임계값 이상의 속도 감소를 감지하면 발생됩니다.",
	"Hard braking Event": "급정거 이벤트",
	"Triggers when more_": "설정된 임계값 이상으로 주행 중 2초 이내에 60도 이상 감지되면 발생됩니다.",
	"Every event of DMC200_2": "DMS 감지 기능은 일반 모드에서만 활성화됩니다. 주차 모드에서 전원을 공급하면 DMS 카메라는 비디오만 녹화합니다.",
	"The DMS system has_2": "DMS는 인식된, 인식되지 않은, 산만한, 졸음, 마스크 미착용 상태를 위한 얼굴 인식 상자와 손 산만 상태를 위한 움직임 감지 상자를 결합합니다.",
	"One for face_": "얼굴 감지 시스템:\n운전자 감지, 운전자 이탈 감지, 부주의, 졸음",
	"The other for_": "모션 감지 시스템:",
	"On: Normal recording_": "On: 주차모드 진입 시에도 DMC200 카메라는 전원이 꺼지기 직전까지 상시 녹화를 진행합니다.",
	"Off: DMS power_": "Off: 주차모드 진입 후 5분 전까지는 상시 녹화 진행하다가, 해당 시간 경과 이후에는 전원이 종료됩니다.",
	"Drowsy and Distracted_": "졸음운전과 부주의 운전은 3단계의 민감도 설정에 따른 조건을 가집니다.",
	"Please refer to_": "아래의 가이드를 확인해 주세요.",
	Drowsiness: Drowsiness$7,
	"Drowsiness occurs when_": "졸음은 운전자가 1초 이상 두 눈을 감고 2초 동안 하품할 때 발생합니다.",
	"Distracted occurs when_": "운전자의 머리가 전면에서 50도 이상 벗어날 때 발생합니다.",
	"A hand distraction_": "손동작 감지는 운전자의 손이 운전대로 부터 떨어질 경우 감지됩니다.",
	"Mask off event_": "마스크 미착용의 경우 두가지 감지 방식을 가집니다. 첫째의 겨우 드라이버가 마스크 미착용 상태로 차량에 탑승했을시. 둘째 운전자가 운전중 마스크를 탈의 했을경우.",
	"High When the_": "민감도 높음: 운전자의 양쪽눈이 1초 간 감겨있을때 졸음운전이 감지 됩니다.",
	"Middle When the_": "민감도 중간: 운전자의 양쪽눈이 1.5초 간 감겨있을때 졸음운전이 감지 됩니다.",
	"Low When the_": "민감도 낮음: 운전자의 양쪽눈이 2초 간 감겨있을때 졸음운전이 감지 됩니다.",
	"High If the_": "민감도 높음: 운전자의 고개각도가 50도 이상 정면으로 부터 3초간 이탈 할 경우 감지됩니다.",
	"Middle If the_": "민감도 중간: 운전자의 고개각도가 50도 이상 정면으로 부터 5초 간 이탈 할 경우 감지됩니다.",
	"Low If the_": "민감도 높음: 운전자의 고개각도가 50도 이상 정면으로 부터 7초 간 이탈 할 경우 감지됩니다.",
	Direct: Direct$7,
	"Camera Wi-Fi credentials": "카메라 Wi-Fi",
	"Network name(SSID)": "네트워크 이름(SSID)",
	"Seamless pairing": "Seamless Pairing",
	Remote: Remote$7,
	"Hotspot settings": "핫스팟 설정",
	"Hotspot name": "핫스팟 이름",
	"Hotspot name must_": "핫스팟 이름은 5자 이상이어야 합니다.",
	"Public cameras may_": "공용 카메라는 Explore 탭이나 세계 지도에 나타날 수 있습니다.",
	"Hard Cornering Event": "하드 코너링 이벤트",
	"Over speed_2": "과속",
	"Second drawiness alert": "연속 졸음 감지 알림",
	"Low Voltage Warning_2": "손동작 감지",
	"(You)_2": "{{a}} ( You )",
	"This video has been reported_": "이 영상은 관리자에 의해 신고 및 삭제되었습니다.",
	"Normal Mode recording": "상시모드 녹화",
	"ON : the camera_": "켜짐 : 카메라가 반복적으로 계속 녹화합니다.",
	"OFF : the camera_": "꺼짐 : 주행 중 이벤트 영상만 녹화합니다.\n",
	"In both modes_": "충격이 감지되는 모드와 관계없이 이벤트 영상 녹화를 시작합니다.",
	"Continuously records_": "30분간의 동작을 다루는 1분짜리 동영상을 초당 1프레임으로 연속 녹화합니다.",
	"Choose detection regions_": "모션 감지 영역을 선택해 바람에 흔들리는 나무, 멀리서 움직이는 물체 등으로 인한 원치 않는 모션 녹화를 줄일 수 있습니다.",
	"Your previous plan is expired.": "구독 중이던 플랜이 만료되었습니다.",
	"Upgrade the plan to restore the camera": "카메라의 복구를 위해 플랜을 업그레이드하시겠습니까?",
	"Remove from cloud": "클라우드 연동 제거",
	"Are you sure you want to Remove_": "해당 카메라를 클라우드 슬롯으로부터 제거 하시겠습니까?",
	"Remove: It doesn’t mean_": "제거: 카메라와 데이터를 삭제하는것이 아닌 이용가능한 클라우드 슬롯을 만들기위한 '클라우드 연동 해제' 개념입니다.",
	"Now the camera is removed from cloud slot": "이 카메라는 클라우드 슬롯으로부터 제거되었습니다.",
	"How to delete camera list": "어떻게 카메라를 리스트에서 '삭제'할 수 있나요?",
	Update: Update$7,
	"Camrea setting": "카메라 설정",
	"Notification setting": "알림 설정",
	"Driving reports": "운전 레포트",
	"Cloud connection steps": "클라우드 연결 단계",
	"Download the BlackVue app to add a camera": "카메라를 추가하려면 BlackVue 앱을 다운로드하세요.",
	"To see your camera in the BlackVue cloud viewer_": "BlackVue 클라우드 뷰어에서 카메라를 보려면 먼저 클라우드에 연결해야 합니다. iOS와 Android용 BlackVue 앱을 이용하여 BlackVue 카메라를 쉽게 설정하고 연결할 수 있습니다.",
	"Download the BlackVue app to see a Wi-Fi connected camera": "Wi-Fi에 연결된 카메라를 보려면 BlackVue 앱을 다운로드하세요.",
	"BlackVue Cloud web viewer only supports_": "BlackVue Cloud 웹 뷰어는 클라우드에 연결된 대시캠만 지원합니다. Wi-Fi에 연결된 블랙박스를 보려면 BlackVue 앱을 다운로드하세요.",
	"You can restore the data if_": "이 카메라를 동일한 계정에 다시 등록하면 데이터를 복원할 수 있습니다. 계정이 삭제될때 모든 파일이 삭제됩니다.",
	"How to add camera": "카메라 추가 방법",
	"Try to wait 2-3 minutes if you just registered the camera.": "방금 카메라를 등록한 경우 2-3분 정도 기다리십시오.",
	"Try to check the Cloud Connection Settings again_": "카메라가 여전히 클라우드에 연결되지 않으면 클라우드 연결 설정을 다시 확인하십시오.",
	"Motion Detection": "움직임 감지",
	"Parking recordings occur_": "눈에 보이는 움직임이 감지되면 주차 녹화가 발생합니다.",
	"Motion Sensitivity": "모션 민감도",
	"Motion Detection Sensitivity": "움직임 감지 민감도",
	"Select Detection Region": "감지 영역 선택",
	"Speed alert_2": "속도 경고",
	"Live Event Upload_2": "라이브 이벤트 업로드",
	"Beep Alert": "비프음",
	"Parking Impact History_": "주차중 충격 알림",
	"To register your_": "SOS 버튼을 등록하려면 BlackVue 앱을 사용해야 합니다.",
	"SOS button on/off": "SOS 버튼 켜기/끄기",
	"File sharing to Event Map is_": "현재는 이벤트맵 영상공유기능을 사용할 수 없습니다. 나중에 다시 확인하십시오.",
	"Email Notifications": "이메일 알림",
	"Push Notifications_2": "푸시 알림",
	"Optional Camera Rotation": "옵션 카메라 회전",
	"Optional Camera Security": "옵션 카메라 시큐리티",
	Option: Option$7,
	"(Owner)": "{{a}} (Owner)",
	"SOS button": "SOS 버튼",
	"This video has been reported_bold": "이 동영상은 신고되어 <b>관리자에 의해 삭제되었습니다.</b>",
	"Number of events_2": "이벤트 수",
	"My Shared Videos": "내 공유 동영상",
	"No Hashtags": "해시태그 없음",
	"I have read and agree_": "전체동의",
	"14 years old_": "만 14세 이상입니다.",
	Required: Required$7,
	Optional: Optional$7,
	"Profile information_": "프로필정보는 추후 계정 설정페이지에서 수정하실 수 있습니다.",
	"Automatically Add Live_": "이벤트맵 이벤트업로드파일 자동공유",
	"You must be 14 years_": "만 14세 이상이어야 블랙뷰 계정을 생성할 수 있습니다.",
	"Use 8 or more characters_": "최소 8자 이상 문자,숫자,특수문자중 2가지를 사용해야 합니다.",
	"Protected files include_": "보호되는 파일은 다음과 같습니다.<br/>ㆍ일반(E) 및 주차 모드(I)의 충격 이벤트 <br/>ㆍ수동 이벤트(M) <br/><br/>{{a}}개의 이벤트가 기록되면 새 이벤트가 가장 오래된 이벤트를 덮어씁니다.",
	"Protected files include": "보호된 파일에는 다음이 포함됩니다.",
	"If you turn_": "음성 안내를 끄면 다음 목록이 꺼집니다.",
	"Live Event Upload_success": "라이브 이벤트 업로드 설정이 성공적으로 저장되었습니다.",
	"Video type": "비디오 유형",
	"Notify the Owner": "오너에게 이 상황을 알리기",
	"Adjusting the cut-off voltage_2": "차단 전압을 더 낮은 설정으로 조정하면 대시 캠이 배터리에서 더 많은 전력을 소모할 수 있습니다. 이로 인해 배터리 방전 경고 메시지가 표시되거나 다른 차량 기능에 영향을 줄 수 있습니다. \n전압을 낮추기 전에 딜러점에 문의하십시오.",
	Others: Others$7,
	"This video has been removed.": "해당 비디오는 제거되었습니다.",
	"Please assign cameras_": "해당 그룹에 카메라를 할당해 주세요.",
	"Are you running_": "플레이백을 볼수있는 기회를 모두 소진했나요?",
	"Upgrade your plan_": "귀하의 Plan을 Fleet Plan으로 업그레이드해보세요. 무제한 영상 재생을 포함하는 클라우드만의 기능들이 있습니다.",
	"Are you running_Liveview": "라이브뷰를 볼수있는 기회를 모두 소진했나요?",
	"Upgrade your plan_Liveview": "귀하의 Plan을 Fleet Plan으로 업그레이드해보세요. 무제한 라이브뷰 재생을 포함하는 클라우드만의 기능들이 있습니다.",
	Stay: Stay$7,
	"Go to Fleet Plan": "Fleet Plan 보러가기",
	"It looks like the video file is being prepared. please try again later.": "영상이 준비되고 있습니다. 잠시후에 다시 시도해주세요.",
	"Oops!": "이런!",
	"Please back up_": "이 설정을 변경하기 전에 중요한 녹음을 모두 백업하십시오.",
	"When you save_": "설정을 저장하면 안정적인 작동을 위해 microSD 카드가 포맷되고 모든 녹음이 삭제됩니다.",
	"This is an unregistered_": "등록되지 않은 이메일입니다. 회원가입 페이지로 이동하시겠습니까?",
	"Camera name must_2": "블랙박스 이름은 5~32 글자여야 합니다.",
	"G-sensor (Normal mode)": "G 센서 (상시모드)",
	"G-sensor (Parking mode)": "G 센서 (주차모드)",
	"Up & down": "상하",
	"Front & back": "앞뒤",
	"Rotate Video 180º": "Rotate Video 180º",
	Mask_2: Mask_2$7,
	"Priority event": "Priority Event",
	"There is no_camera": "There is no camera that your owner assigned to you.",
	"Camera SSID": "카메라 SSID",
	"The BlackVue dashcam_2": "해당 블랙박스는 5GHz 무선 네트워크와 호환되지 않습니다.",
	"Driver detection box_2": "운전자 감지 기능 표기",
	"DMS camera recording_2": "주차모드 중 DMS 카메라 녹화",
	Low_2: Low_2$7,
	Medium_2: Medium_2$7,
	High_3: High_3$7,
	"Live Event Upload_3": "Live Event Upload",
	"Driving Impact": "주행중 충격",
	"Video source_2": "비디오 소스",
	"Front camera_2": "전방 카메라",
	"Rear camera_2": "후방 카메라",
	"Optional Camera": "옵션 카메라",
	"Motion Detection_2": "모션 감지",
	"Rear camera stops_2": "주차모드 진입 후 5분이 지나면 후방 카메라의 녹화를 멈춥니다. 상시 모드로 다시 진입하면 후방 카메라 녹화를 다시 시작합니다.",
	"Passenger vehicle": "승용차",
	"Heavy vehicle": "상용차",
	Highest_3: Highest_3$7,
	Extreme_2: Extreme_2$7,
	"Less recording files": "적은 녹화 파일",
	"Camera rotation_2": "카메라 녹화 반전",
	"Share camera profile_2": "Blackvue 블랙박스 이름 공유",
	Private_2: Private_2$7,
	"BlackVue Live": "BlackVue Live",
	"Important All saved_": "Important! All saved videos are about to be deleted. Tap Cancel and back up important files if needed.",
	"Whenever saving settings_": "Whenever saving settings after changing the time zone, the SD card is initialized and all stored files are deleted.",
	"Do you want_": "Do you want to save your changes?",
	"No groups": "No groups",
	Lite: Lite$7,
	"USD per Camera": "USD per extra Camera",
	"up to Cameras": "up to Cameras",
	"All the P Plan_": "<b>{{a}}</b> 이 제공하는 기능과 함께:",
	"User Roles and Permissions": "사용자 역할 및 권한",
	"Geofence Setup (Web) and alerts": "Geofence Setup (Web) and alerts",
	"N Times": "{{a}} 회",
	"N Minutes": "{{a}} 분",
	"Emergency Alarm": "비상 경보",
	"Playback, Live View": "재생, 라이브 뷰",
	"Your driving record : Daily, Monthly": "운전 기록 : 일일, 월간",
	"Real-time Conversation": "실시간 대화",
	"Initiate a conversation_": "Dashcam의 스피커 및 마이크를 통해 운전자와 대화를 시작하십시오.",
	"Remote Voice Communication": "원격 음성 통신",
	"See the last location_": "카메라의 마지막 위치를 참조하십시오",
	"Check your cars_": "차량의 실시간 GPS 데이터를 맵에서 확인하여 차량을 찾아서 운전 중이거나 주차 여부 및 속도와 같은 상태에 대한 정보를 얻으십시오.",
	"Supported models_": "* 지원되는 모델 : S 및 초기 X 시리즈 모델",
	"GPS Tracking &_": "GPS 추적 및 맵의 비디오 (Smart/Fleet Plan)",
	"Track your cars_": "지도에서 자동차의 위치와 속도를 추적하십시오!",
	"GPS Tracking: visualize_": "GPS 추적 :지도에서 주행 로그를 시각화하십시오.\n맵의 비디오 : 컨텍스트 정보 (속도, 이벤트 유형)를보고 맵에서 바로 관련 비디오를 재생합니다.",
	"Visualize your cars_": "지도에서 자동차의 위치와 속도를 시각화해보세요!",
	"The feature enables_": "이 기능을 사용하면 사고 발생 5초 전의 영상을 클라우드에 업로드할 수 있습니다.",
	"Camera profile setting": "카메라 프로필 설정",
	"Are you running_Download": "비디오 다운로드 수가 부족한 상황인가요?",
	"Upgrade your plan_Download": "무제한 다운로드를 위해 Fleet Plan으로 업그레이드하고 클라우드 전용 기능을 이용하세요.",
	"This feature is available for Smart and Fleet_": "이 기능은 Smart 및 Fleet 플랜 가입자에게만 제공됩니다.",
	"Rear camera will keep_": "주차 모드로 변경된 후, 전방 카메라의 온도가 높아지기 전까지 후방 카메라는 계속해서 녹화를 진행할 것입니다. 온도가 높아질 때 후방 카메라는 자동으로 녹화를 중지할 것입니다. 전방 카메라의 온도가 정상 상태로 회복될 때, 후방 카메라는 다시 녹화를 시작할 것입니다. (주의: 대시캠을 보호하기 위해 Blackvue는 외부 온도가 높을 경우 종료될 수 있습니다.)",
	"Get Unlimited Cloud_": "무제한 클라우드 재생 및 최대 {{a}} 대의 카메라 관리 가능합니다.",
	"Up to N cameras_": "Up to {{a}} cameras (+ {{b}} USD Extra charge)",
	"N Minutes per Day": "하루 {{a}}분",
	"Drowsiness sensitivity is_": "\"졸음\" 이벤트에 대한 민감도 설정 기준은 BlackVue 자사의 신뢰성 있는 알고리즘을 기반의 눈 깜박임 데이터에 의해 설정됩니다. <br> <br> 전방에서 운전자의 머리 위치 각도와 지속 시간에 따라 산만한 감도가 결정됩니다.",
	"Not available with this plan": "Not available with this plan",
	"The optional camera records_": "주차 모드에서 옵션 카메라를 녹화합니다.",
	"Smart and Fleet_": "Smart and Fleet Plan<br/>subscribers only",
	"This feature is_smart": "This feature is available for Smart and Fleet Plan subscribers only.",
	"Camera Registration": "블랙박스 등록",
	"Voice Call": "Voice Call",
	"N times per Month": "{{a}} times per Month",
	"Recommended for higher bitrate_": "더 높은 비트레이트와 더 나은 비디오 품질을 위해 권장합니다.",
	"Recommended for for better compatibility_": "데스크톱 및 모바일 장치와의 더 나은 호환성을 위해 권장합니다.",
	"A minute of front camera_": "1 분 비디오의 예상 파일 크기 (전방 카메라)",
	"Extreme(N Mbps): N MB_": "Extreme (60Mbps) : 450MB \nHighest (25Mbps) : 193MB \nHigh (12Mbps) : 98MB\nNormal (8Mbps) : 69 MB",
	"File size information reflects_": "해당 정보는 생성 가능한 최대 용량을 기반으로 표시되었습니다. 실제 녹화 상황에 따라 파일 크기가 다를 수 있습니다.",
	Bitrate: Bitrate$7,
	"Connection has been_": "연결에 실패하였습니다.\n다시 연결 시도중입니다...",
	"Unable to establish_": "카메라와 연결할 수 없습니다.\n장치가 올바르게 연결되어 있는지 확인하고 다시 시도하십시오.",
	"Purchased by Payment Service": "결제 서비스에 의해 구매됨",
	"Up to N Cameras": "최대 {{a}}대의 카메라\n",
	"Unlimited Live View": "무제한 라이브뷰",
	"N Days GPS Tracking": "{{a}}일간의 GPS 추적",
	"Unlimited Playback and Download": "무제한 재생 및 다운로드",
	hours: hours$7,
	"Live Event Upload or_": "실시간 이벤트 업로드 또는 12개 이상의 높은 해상도 비디오",
	"During the usage period of the One Plan_": "원 플랜 서비스 이용 기간 동안 구독 요금제 변경 불가능합니다. 다른 요금제로 변경하려면 원 플랜 구독을 취소하기 위해 블랙뷰 고객 지원팀에 문의하십시오.",
	"Service Period (Include SIM Data)": "서비스 기간 (SIM 데이터 포함)",
	"Purchase the BlackVue One Package_": "1년 동안 원 플랜 무료로 잠금 해제하려면 BlackVue One 패키지를 구매하십시오.",
	"3GB SIM Data Plan": "3GB SIM 데이터 요금제",
	"Unlimited Live View, Playback and Download": "무제한 라이브 뷰, 재생 및 다운로드",
	"within data availability": "데이터 이용 가능 범위 내",
	"The BlackVue One Plan is a 1-year_": "BlackVue One Plan은 블랙뷰 원 패키지 구매를 통해 독점적으로 이용할 수 있는 1년짜리 클라우드 서비스 요금제로, 대시캠, 1년 3GB/mo 데이터 요금제(미국 및 캐나다용) 및 1년 클라우드 서비스 요금제가 포함된 번들입니다.",
	"The BlackVue One Package is available_": "BlackVue One 패키지는 블랙뷰 온라인 스토어에서 독점적으로 구매 가능합니다.",
	"Go to BlackVue Shop": "BlackVue 쇼핑몰로 이동하기",
	"Anonymous Cam": "익명 카메라",
	"App only": "앱 전용",
	Expires: Expires$7,
	"N days remaining": "{{a}}일 남음",
	"No action needed_": "<b>조치가 필요하지 않습니다.</b> 9월 13일 이후 다음 결제부터 자동으로 새로운 할인된 가격이 적용됩니다.",
	"The new reduced price_": "새로운 할인된 가격은 자동으로 귀하의 계정에 적용됩니다.",
	"Smart Plan Subscriber?": "Smart Plan 구독자입니까?",
	"Fleet Plan Subscriber?": "Fleet Plan 구독자입니까?",
	"Please take a moment to_": "계정을 이관할 수 있도록 허가해 주십시오.",
	"Starting from now and_": "<b>지금부터 10월 31일까지</b>, <a href=\"https://form.jotform.com/232411253056041\" target=\"_blank\">이 링크를 클릭하여</a> Fleet 계정 이메일을 입력하면 저희가 변경을 진행해 드릴 수 있습니다. 변경 사항을 처리하는 데 시간이 필요합니다. 또는 9월 13일부터 기존 계정을 취소하고 새로운 가격으로 다시 구독할 수 있습니다.",
	"Once activated_": "일단 활성화되면 One Plan은 일시 중지되거나 비활성화될 수 없습니다.",
	"Once the One Plan is activated_": "One Plan이 활성화되면 One Package는 환불할 수 없습니다.",
	"Up to N Cloud Camera Slot": "{{a}}개의 클라우드 카메라 슬롯까지",
	"nGB of Cloud Storage": "{{a}}GB의 클라우드 저장 공간",
	"Get started for free_": "Get started for free, no credit card required. Includes Alert Push Notifications, limited Remote Live View and cloud storage.",
	"The BlackVue One Plan is exclusively_": "The BlackVue One Plan is exclusively available through the purchase of a BlackVue One Package. 3GB/mo data plan is for US and Canada only. BlackVue Cloud’s Free Plan, Lite Plan (1~3) and Smart Plan (1~3) accounts can upgrade to One Plan. However, Lite Plan (4~15), Smart Plan (4~15) and Fleet Plan accounts can not be upgraded to One Plan.",
	"For N year": "For {{a}} year",
	"Included in the One Package": "Included in the One Package",
	"3GB SIM Data Plan for N year": "3GB SIM Data Plan for {{a}} year",
	"One Plan Cloud Service for N year": "One Plan Cloud Service for {{a}} year",
	"The BlackVue One Package includes_": "The BlackVue One Package includes all you need to enjoy BlackVue Cloud for a whole year!",
	"4K LTE Dash Cam_": "4K LTE Dash Cam, Cloud Service and Data Plan",
	"nGB included": "{{a}}GB included",
	"nGB per camera": "{{a}}GB per camera",
	"N Days Live Event Upload": "{{a}} Days Live Event Upload",
	"Up to N Dash Cameras": "Up to {{a}} Dash Cameras",
	"Step N/N": "단계 {{a}}/{{b}}",
	"Cloud Connection": "클라우드 연결",
	"To pair your dashcam": "대시캠을 배터리와 페어링하려면 클라우드에 연결하세요.",
	Check: Check$7,
	"Unpair Battery": "배터리 페어링 해제",
	"Are you sure you want to unpair": "이 배터리 (%@)를 카메라에서 해제하시겠습니까?",
	"Unpair: It doesn't mean": "연결 해제: 배터리 데이터를 삭제하는 것은 아닙니다.",
	"*The paired battery will": "*페어링된 배터리도 함께 제거됩니다.",
	"Would you like to pair this": "이 배터리를 페어링하시겠습니까?",
	"Battery successfully paired": "배터리가 성공적으로 페어링되었습니다.",
	"Now you can directly connect to": "이제 카메라 목록에서 배터리에 직접 연결할 수 있습니다.",
	"Pairing failed": "페어링에 실패했습니다. 다시 시도해주세요.",
	"Battery Name": "배터리 이름",
	"Capacity History": "용량 이력",
	"The graph displays capacity": "그래프는 클라우드 연결을 통해 수집한 데이터를 사용하여 대략적인 배터리 수준을 표시합니다.\n 배터리 용량은 온도, 대시캠 설정 및 이벤트 발생 빈도에 따라 다를 수 있습니다.",
	"Last 24 Hours": "지난 24시간",
	"Last 7 Days": "지난 7일",
	"Battery Level": "배터리 수준",
	"Temperature History": "온도 이력",
	"The graph displays temperature": "그래프는 클라우드 연결에서 가져온 데이터를 사용하여 대략적인 온도 수준을 표시합니다.",
	"Temperature Level": "온도 수준",
	"Connecting alert": "[ 연결 중 ]\n연결 시 데이터가 표시됩니다.",
	"Low Output power Alert": "[ 출력 전력 차단 ]\n출력 전압이 너무 낮아 연결된 장치의 전원 공급이 제한됩니다.",
	"High temp Alert": "[ 입력 전력 차단 ]\n배터리 온도가 너무 높아 충전이 제한됩니다.",
	"Remaining time": "남은 시간",
	"Remaining time estimate": "연결된 장치의 총 전력 소비를 기반으로한 추정입니다.\n 배터리에 연결된 후 30초마다 재계산됩니다.",
	"Setting changed": "설정 변경됨",
	"Setting change failed": "설정 변경 실패",
	"Low Input power Alert": "[ 입력 전력 차단 ]\n충전 전압이 너무 낮아 충전이 제한됩니다.",
	"High Input power Alert": "[ 입력 전력 차단 ]\n충전 전압이 너무 높아 충전이 제한됩니다.",
	"Low temp_Cut off Alert": "[ 입력 전력 차단 ]\n배터리 온도가 너무 낮아 충전과 지속 시간이 제한됩니다.",
	"Low temp Alert": "[ 저온 ]\n배터리 온도가 너무 낮아서 지속 시간과 충전 속도가 제한됩니다.",
	"Low capacity Alert": "[ 저용량 ]\n배터리 용량이 너무 낮습니다.\n차를 운전하여 충전하십시오.",
	"Back to list": "목록으로 돌아가기",
	Saving: Saving$7,
	Now: Now$7,
	"Power supplying is limited": "전원 공급이 <b>제한됩니다</b>",
	"This battery is already paired": "이 배터리는 이미 페어링되어 있습니다.",
	"Connecting to Battery": "배터리에 연결 중",
	"Paired battery": "페어링된 배터리",
	"Battery unpairing failed": "배터리 페어링 해제에 실패했습니다. 다시 시도해주세요.",
	"A connection is already active": "이미 연결되어 있습니다. 나중에 다시 시도해주세요.",
	"Searching for battery": "배터리 검색 중",
	"Select battery to pair with your camera": "카메라와 페어링할 배터리를 선택하세요.",
	"Unable to connect": "연결할 수 없습니다",
	"A connection error has occurred": "연결 오류가 발생했습니다. 다시 시도해주세요.",
	"The paired dashcam has been disconnected": "페어링된 대시캠의 클라우드 연결이 해제되었습니다.\n아래 조건을 확인해주세요.",
	"Check if the battery is not fully discharged": "배터리가 완전히 방전되지 않았는지 확인하세요.",
	"Check the Cloud connection of the paired dashcam": "페어링된 대시캠의 클라우드 연결을 확인하세요.",
	"Connection lost": "연결이 끊어졌습니다",
	"A connection error has occurred shortly": "연결 오류가 발생했습니다. 잠시 후 다시 연결해주세요.",
	"Charging is limited": "충전이 <b>제한됩니다</b>",
	"Cannot connect to the battery": "배터리에 연결할 수 없습니다.",
	"Please check the Cloud connection of the camera": "카메라의 클라우드 연결을 확인해주세요.",
	"Charging complete in": "충전이 완료됩니다 %@",
	"Current Capacity": "현재 용량",
	"Output Voltage": "출력 전압",
	"Charging Voltage": "충전 전압",
	Beep: Beep$7,
	"Battery Capacity": "배터리 용량",
	"Battery connection failed": "배터리 연결 실패",
	"Expansion battery": "추가 배터리",
	"Make sure it is switched on and within range": "• 배터리의 전원상태와 연결 가능거리(2m)를 확인해주세요.",
	"Make sure it is not wirelessly connected to another device": "• 배터리가 다른 모바일과 연동중이라면, 스캔이 불가능해요.",
	"Detected batteries": "주변 감지된 배터리",
	"Can't see your battery": "배터리가 표시되지 않습니까?",
	"Download the Blackvue app to check": "배터리를 원격으로 확인하려면 블랙뷰 앱을 다운로드하세요",
	"By Using the app": "앱을 사용하여 대시캠을 배터리와 연결하고 클라우드에서 배터리 용량을 모니터링할 수 있습니다. 페어링 후에는 BlackVue 클라우드 뷰어에서 배터리를 확인할 수 있습니다.",
	Unpair: Unpair$7,
	"Occurs when the driver closes_": "운전자가 운전 중 양쪽 눈을 감으면 발생합니다.",
	"Occurs when the driver's head_": "운전자의 머리가 앞으로부터 50도 이상 벗어날 때 발생합니다.",
	"Only detects distraction above_": "설정된 값 이상의 전방 미주시만 감지합니다. 카메라 설정 > 이벤트 트리거 > 위험운전 속도 단위'에서 단위를 변경할 수 있습니다.",
	"Occurs when the driver is not wearing_": "운전자가 안전벨트를 착용하지 않은 경우 발생합니다.",
	"Overlays a face detection box_": "DMS의 실시간 및 녹화 영상에 얼굴 인식 영역을 표시합니다.",
	"Seat Belt": "안전벨트",
	Detected: Detected$7,
	"No Seat Belt": "안전벨트 미착용",
	"Fatigue Risk Alert": "피로 위험 경보",
	"The time is synchronized_Email": "시간은 이메일 알림의 시간과 동기화됩니다.",
	"Sends an alert when drowsiness is_": "최초의 졸음 이후에 졸음이 감지되면 경보를 보냅니다.",
	"Data updates upon connection": "연결 시 데이터가 업데이트 됩니다.",
	"Sends a notification if_": "운전 중 '시간 설정'을 초과하면 알림을 전송합니다.",
	"Data updates Alert": "[ 연결 중 ]\n연결 시 데이터가 업데이트 됩니다.",
	"Cannot save settings": "설정을 저장할 수 없습니다",
	"The time is synchronized_Push": "시간은 푸시 알림의 시간과 동기화됩니다.",
	"The file has been overwritten or deleted": "파일이 덮어쓰기되었거나 삭제되었습니다.",
	"Box Pro Models Settings": "Box Pro 모델 설정",
	"Push notifications can be configured_": "푸시 알림은 카메라의 알림 설정에서 설정할 수 있습니다.",
	"Recording Video": "영상 녹화",
	"Cameras settings": "블랙박스 설정",
	"Please configure the settings": "설정을 완료해 주세요",
	"Speed Priorities": "속도 우선순위",
	"Set Speed Priority": "속도 우선순위 설정",
	"Geofence-enter": "지오펜스-진입",
	"Geofence-exit": "지오펜스-진출",
	"Geofence-pass": "지오펜스-통과",
	"Geofence-speed alert": "지오펜스-속도 경고",
	"Drive Position": "운전석 위치",
	"Left-Hand Drive": "좌측 핸들",
	"Right-Hand Drive": "우측 핸들",
	"Please configure this setting_": "운전자가 정확히 감지되지 않는 경우 이 설정을 변경해 주세요.",
	"A new feature in the BlackVue settings_": "BlackVue 설정에 카메라 시간을 동기화하는 새로운 기능이 추가되었습니다. 정확한 시간 녹화를 위해서는 카메라 시간을 한 번만 동기화해야 합니다.",
	"Feature location_": "기능 위치:\n카메라 설정> 시스템> 시간 동기화",
	"Time Sync": "시간 보정",
	"You can sync the time between_": "기기와 블랙뷰 카메라 간의 시간을 동기화할 수 있습니다. 동기화를 위해 SD 카드를 포맷해야 합니다. 진행하기 전에 필요한 비디오를 백업해 주세요.",
	"Voice Alert": "음성 안내",
	"Provides a voice alert_": "주행 중 설정 시간을 초과하면 카메라에서 음성 안내를 제공하고, 알림을 보냅니다.",
	"Please enter a value": "Please enter a value.",
	"Notices & Notifications": "뉴스 및 알림",
	"Only detects drowsiness above_": "설정된 값 이상의 졸음만 감지합니다. 카메라 설정 > 이벤트 트리거 > 위험운전 속도 단위'에서 단위를 변경할 수 있습니다.",
	Promotion: Promotion$7,
	Notice: Notice$7,
	"View More": "더 보기",
	"Read More": "더 읽기",
	"Detection Box": "감지 박스",
	"Seatbelt Detection Box": "안전벨트 감지 박스",
	"Drive Position Detection Box": "운전자 위치 감지 박스",
	"Fleet Subscription Promotion (50%)": "함대 구독 프로모션 (50%)",
	"BlackVue Fleet Tracking exclusive features_": "BlackVue Fleet Tracking은 고급 사용자와 기업 모두를 위한 독점 기능입니다(다중 사용자 및 카메라, 지오펜싱, 웹 뷰어 등).",
	"Special Discount (50% off)": "특별 할인(50% 할인)",
	"*Promotion applied for 12 months": "*12개월 동안 적용되는 프로모션",
	"*Payment will be made starting next month.": "*다음달부터 지급됩니다.",
	"[About using promotions]": "[프로모션 이용 안내]",
	"The promotion is free for the first month_": "프로모션은 첫 달 동안 무료이며 다음 달부터 12개월 동안 요금이 청구됩니다.",
	"For users with an existing Lite/Smart subscription_": "기존 Lite/Smart 구독을 보유한 사용자의 경우 기존 앱 구독을 별도로 취소해야 합니다. 그렇지 않으면 기존 앱 구독 요금이 계정에 청구될 수 있습니다.",
	"Please be sure to cancel your app subscription_": "무료 기간 내에 반드시 앱 구독을 취소하시기 바랍니다. 이중 결제 금액은 환불되지 않습니다.",
	"You will be changed to Fleet Plan immediately_": "기존 Lite/Smart Plan의 남은 가입 기간이 만료되지 않았더라도 즉시 Fleet Plan으로 변경됩니다.",
	"You can cancel Fleet Plan any time.": "언제든지 Fleet Plan을 취소할 수 있습니다.",
	"From February 2025, please go to the Fleeta service and use it.": "프로모션이 취소되면 프로모션이 다시 적용되지 않습니다.",
	"After promotion expires_": "프로모션이 만료되면 기존 Fleet Plan 가입비가 자동으로 갱신됩니다.",
	"(Required) I have read the promotion instructions_": "(필수) 프로모션 안내사항을 모두 읽었으며, 결제에 동의합니다.",
	"Upgrade to Fleet Plan immediately": "즉시 Fleet Plan으로 업그레이드하세요",
	"Important Notice:": "중요한 공지:",
	"Switch of BlackVue Web Viewer to Fleeta Web Viewer": "BlackVue Web Viewer를 Fleeta Web Viewer로 전환",
	"To provide better features and quality_": "더 나은 기능과 품질을 제공하기 위해 BlackVue 웹 뷰어 서비스는 곧 Fleeta라는 새로운 제품군 웹 뷰어 서비스로 전환될 예정입니다. Fleeta 서비스는 Fleet Plan 사용자에게만 제공됩니다. Fleeta 서비스는 새로운 Fleeta 전용 앱과 함께 2025년 3월에 출시될 예정입니다. 자세한 내용을 알아보려면 <a href=\"https://www.fleeta.io\" target=\"_blank\">fleeta.io</a>를 방문하세요.",
	"We kindly ask for your understanding_": "이번 변경은 보다 나은 서비스 제공을 위한 조치이므로 고객 여러분의 넓은 양해 부탁드립니다. 이번 전환과 관련하여 문의사항이 있으시면 언제든지 당사 CS센터로 연락주시기 바랍니다.",
	"Don’t show this again for this month": "이번 달 동안 이 항목을 다시 표시하지 않음",
	"Fleet Plan Subscription Promotion": "Fleet Plan 구독 프로모션",
	"Period : December 2, 2024 ~ May 31, 2025": "기간 : 2024년 12월 2일 ~ 2025년 5월 31일",
	"See more details": "자세한 내용 보기",
	"To continue improve quality and provide better service_": "지속적인 품질 개선과 더 나은 서비스 제공을 위해 BlackVue Web Viewer 서비스가 곧 Fleet Plan 전용 서비스로 전환될 예정입니다. 2025년 3월 말부터 더 이상 무료로 제공되거나 다른 요금제를 통해 제공되지 않습니다.",
	"We have prepared special discount offers for_": "기존 웹뷰어 사용자들을 위해 특별 할인 혜택을 준비했습니다. 자세한 내용은 아래를 확인해 주세요! 더 나은 서비스 제공을 위해 이번 변경 사항을 시행하게 되므로 고객 여러분의 많은 이해와 협조를 부탁드립니다.\n",
	"*If you are subscribed in-app_": "*인앱 구독을 하고 계시다면 반드시 인앱 구독을 취소해 주시기 바랍니다.",
	"Enjoy your BlackVue Cloud service with your dashcam.": "BlackVue Cloud 서비스를 대시캠으로 즐겨보세요.",
	"Available Cloud Camera slot(s)_": "사용 가능한 클라우드 카메라 슬롯: {{d}}",
	"Not eligible for the promotion.": "프로모션 대상이 아닙니다.",
	"You have already used_": "이미 이 프로모션을 사용하셨습니다. 프로모션이 취소되면 다시 적용할 수 없습니다.",
	"Go to Cameras": "카메라로 이동",
	"Congratulations !": "Congratulations !",
	"Fleet Plan user": "Fleet Plan user",
	"Let your BlackVue monitor_": "BlackVue로 차량을 모니터링하고 사고를 알려주세요. 충격이 감지되는 순간 BlackVue는 스냅샷과 함께 휴대폰으로 알림을 보냅니다.\n",
	"Live Event Upload feature automatically_": "라이브 이벤트 업로드 기능은 사고 발생 전 영상을 포함한 영상을 BlackVue Cloud Storage에 자동으로 업로드하여 영상을 안전하게 보호합니다!",
	"*Buffer time varies by model.": "*버퍼 시간은 모델에 따라 다릅니다.",
	Explore: Explore$7,
	"Cloud Storage": "클라우드 스토리지",
	"My Cloud Cameras": "내 클라우드 카메라",
	"My Cloud Cameras Only": "내 클라우드 카메라만 해당",
	"BlackVue Live Camera": "BlackVue 라이브 카메라",
	"*For BlackVue Live Cameras_": "*BlackVue 라이브 카메라의 경우 카메라 설정에서 공개로 공유된 카메라만 지도에서 볼 수 있습니다.",
	"*Share Method_": "*공유방법 : 카메라 설정>개인정보",
	"Once the promotion is canceled_": "프로모션이 취소되면 프로모션이 다시 적용되지 않습니다.",
	"Cloud Connection Setting": "클라우드 연결 설정",
	"Camera Profile": "카메라 프로필",
	"Camera Settings": "카메라 설정",
	"Format MicroSD Card": "MicroSD 카드 포맷",
	"Remote Firmware Update": "원격 펌웨어 업데이트",
	"The location may not be accurate_": "카메라가 클라우드에 연결되어 있지 않아 위치가 정확하지 않을 수 있습니다.",
	"The location of the camera cannot be found_": "카메라 위치를 찾을 수 없습니다. 클라우드 연결 설정을 확인하세요.",
	"Period : December 3, 2024 ~ May 31, 2025": "기간 : 2024년 12월 3일 ~ 2025년 5월 31일",
	"It will show_": "사용할 수있게되면 여기에 나타날 것입니다.",
	"Deactivate Cloud": "클라우드 비활성화",
	"Are you sure you want to deactivate_": "이 카메라에 대해 클라우드를 비활성화하시겠습니까?",
	"Deactivate : It doesn’t_": "언제든지 클라우드를 활성화할 수 있습니다. 카메라는 비활성화가 완료된 후 삭제할 수 있습니다.",
	Deactivate: Deactivate$7,
	"*If you made the payment through_": "*앱을 통해 결제하신 경우, 앱을 다시 시작해주세요.",
	"Connect Dashcam Locally (Wi-Fi)": "Dashcam을 로컬로 연결(Wi-Fi)",
	"Remove from Cloud": "클라우드에서 제거",
	"Manage\nFLEETA Drive": "관리\nFLEETA 드라이브",
	"Cloud\nConnection": "클라우드\n연결",
	"Available on FLEETA App": "FLEETA 앱에서 사용 가능합니다.",
	"Available for Cloud dashcam OR on FLEETA App.": "클라우드 대시캠 또는 FLEETA 앱에서 사용 가능합니다.",
	"Get started with_": "무료 1개월 체험 시작하기",
	"Experience all of_": "FLEETA의 프리미엄 기능을 1개월 동안 무료로 체험하세요.\n\n언제든지 취소 가능—의무 사용 기간 없음",
	"Welcome to FLEETA Webviewer.": "FLEETA 웹뷰어에 오신 것을 환영합니다.",
	"Let FLEETA get_": "FLEETA가 당신을 알 수 있도록 도와주세요",
	"Help improve your_": "사용 경험 개선을 위해 몇 가지 정보를 공유해 주세요",
	"Business Industry": "사업 분야",
	"Vehicle & Cargo": "차량 및 화물",
	Compliance: Compliance$7,
	"Would you like to skip?": "건너뛰시겠습니까?",
	"What is your business industry?": "사업 분야는 무엇입니까?",
	"Transportation & Logistics": "운송 및 물류",
	"Rental & Leasing": "대여 및 리스",
	"Construction & Building": "건설 및 빌딩",
	"Government & Public": "정부 및 공공",
	"Facility & Utility Management": "시설 및 유틸리티 관리",
	Manufacturing: Manufacturing$7,
	"Retail & Wholesale": "소매 및 도매",
	Emergency: Emergency$7,
	Security: Security$7,
	"How many employees do you need to manage?": "관리해야 할 직원 수는 몇 명입니까?",
	"How many vehicles does your company operate?": "회사에서 운영하는 차량 대수는 몇 대입니까?",
	"Why do you use a fleet tracking service?": "차량 추적 서비스를 사용하는 이유는 무엇입니까?",
	"Route Tracking": "경로 추적",
	"Real-time Monitoring": "실시간 모니터링",
	"Incident Detection & Check video": "사고 감지 및 영상 확인",
	"Behavior Monitoring & Analysis": "행동 모니터링 및 분석",
	"Evaluation & Management": "평가 및 관리",
	"Theft Prevention": "도난 방지",
	"Monitoring & Maintenance": "모니터링 및 유지보수",
	"Verification & Management": "검증 및 관리",
	"BlackVue App Use Only": "BlackVue 앱 전용",
	"Your current plan allow_": "현재 요금제는 BlackVue 앱 사용을 허용합니다. 웹 뷰어를 사용하려면 FLEETA 요금제에 가입해 주세요.",
	"Learn more about the Fleet_": "FLEETA 요금제에 대해 더 알아보세요",
	"Special Offer": "특별 제안",
	"For a limited time_": "한정된 시간 동안, 요금제 구독에 50% 할인을 즐기세요.",
	"See Discount Details": "할인 세부사항 보기",
	"To subscribe to the Fleet_": "플릿 요금제를 구독하려면 중복 청구를 피하기 위해 먼저 앱 내 BlackVue 구독을 취소해 주세요.",
	"Skip tour": "투어 건너뛰기",
	"In the cloud_": "클라우드 환경에서는 FLEETA 웹 뷰어를 통해 재생, 라이브 뷰(멀티뷰 포함), 라이브 GPS 및 보고서에 모두 접근할 수 있습니다.",
	"Cloud Storage is_": "클라우드 스토리지는 업로드한 비디오가 클라우드에 안전하게 저장되는 곳입니다. 비디오를 업로드하여 오랫동안 안전하게 보관하세요.",
	"Toggle to switch_": "맵 / 리스트 전환 토글",
	"In List View_": "목록 보기에서는 그룹, 멤버 및 펌웨어 정보를 한눈에 쉽게 볼 수 있고 관리할 수 있습니다.",
	"What is Cloud Storage?": "클라우드 스토리지는 무엇인가요?",
	"Cloud Storage Overview": "클라우드 스토리지 개요",
	"Difference Between FLEETA_": "FLEETA 드라이브와 라이브 이벤트 업로드의 차이점",
	"FLEETA Drive stores_": "FLEETA 드라이브는 수동으로 업로드한 비디오를 저장합니다",
	"Live Event Upload automatically_": "라이브 이벤트 업로드는 이벤트가 발생할 때 자동으로 비디오를 저장합니다.",
	"Live Event Upload videos_": "라이브 이벤트 업로드 비디오는 유효 기간이 있습니다. 오래 보관하고 싶다면 FLEETA 드라이브로 옮기세요.",
	"Note: SD Card_": "참고: 재생 중인 SD 카드 비디오",
	"Videos stored on_": "SD 카드에 저장된 비디오는 재생 메뉴를 통해 접근할 수 있습니다.",
	"Set your image_": "제공된 프레임을 사용하여 이미지를 설정하세요. 이미지가 저장되면 카메라 카드와 지도 보기 아이콘에 표시됩니다.",
	"*Only jpg and_": "*jpg 및 png 파일만 지원됩니다.",
	"Set as default image": "기본 이미지로 설정",
	"Camera Details": "카메라 세부 정보",
	"IT & Telecommunications": "IT 및 통신",
	"The name must_32": "이름은 반드시 1에서 32글자 사이로 입력하세요.",
	"Unable to display the map.": "지도를 표시할 수 없습니다.",
	"The camera location cannot be found_": "GPS 연결이 좋지 않아 카메라 위치를 찾을 수 없습니다.",
	"Cloud Cameras": "클라우드 카메라",
	"Want to unlock_": "차량 관리 기능을 사용하고 싶으신가요?",
	"*Web subscription only": "*웹 구독만 해당",
	"Uploads event_": "사건이 발생하는 즉시 클라우드 스토리지에 사건 영상을 업로드합니다.",
	"Starts a conversation_": "대시캠의 스피커와 마이크를 사용하여 운전자와 대화를 시작합니다.",
	"Remotely check_": "클라우드를 통해 원격으로 배터리 수준과 상태를 확인하세요.",
	"Receive a voice_": "운전 시간이 제한을 초과하면 음성 경고 및 알림을 받습니다.",
	"View your_": "지도에서 운전 기록을 확인하세요.",
	"View speed, event_": "지도에서 속도, 이벤트 유형 및 관련 비디오를 직접 재생합니다.",
	"FLEETA Tracking exclusive_": "FLEETA 추적은 파워 유저와 비즈니스 모두를 위한 독점 기능을 제공합니다 (다중 사용자 및 카메라, 지오펜싱 등).",
	"Cloud Cameras per Account": "계정당 클라우드 카메라",
	"Connect Dashcam Locally_": "대시캠을 로컬로 연결하기 (Wi-Fi) (재생, 다운로드, 라이브 뷰)",
	"Available with_": "BlackVue 배터리와 함께 사용 가능합니다",
	"Cloud Battery": "클라우드 배터리",
	"Driving Reports": "운전 보고서",
	"Video on Map": "지도에서 비디오",
	"Multi Live View (Fleeta Web Viewer)": "멀티 라이브 뷰 (FLEETA 웹 뷰어)",
	"Enter a number": "숫자를 입력하세요",
	"Permission required.": "허가 필요.",
	"Please contact_": "도움이 필요하시면 최고 관리자에게 연락해 주세요.",
	"Access not available": "접근 불가능합니다.",
	"This file cannot be deleted now.": "이 파일은 지금 삭제할 수 없습니다.",
	"Please try again later.": "나중에 다시 시도해 주세요.",
	"Permission required.\nPlease_": "권한이 필요합니다.\n최고 관리자에게 문의하십시오.",
	"Cloud Storage is disconnected_": "클라우드 스토리지가 연결되어 있지 않습니다. 연결 상태를 확인하십시오.",
	"Manage the plan_": "카메라를 복원하기 위한 요금제 관리",
	"Notify the owner_": "최고 관리자에게 요금제를 관리하도록 알리세요",
	"Access Restricted:_": "접근 제한: 구독 만료",
	"Access is currently_": "현재 요금제가 만료되어 접근이 불가능합니다.",
	"Please contact your owner_": "이 문제를 해결하려면 최고 관리자에게 연락하십시오.",
	"Access will be_": "구독을 갱신하면 접근이 복원됩니다",
	"Cloud is disconnected_": "클라우드 스토리지가 연결되어 있지 않습니다. \n연결 상태를 확인하세요.",
	"Connect to Cloud with_": "FLEETA 앱으로 클라우드 스토리지에 연결하세요",
	"Using Wi-Fi Hotspot": "Wi-Fi 핫스팟 사용",
	Important: Important$7,
	"Pre-Event buffer_": "이 모드에서는 사전 이벤트 버퍼 녹화가 비활성화되어 있습니다.",
	"connectivity is_": "이 모드에서는 연결성이 제한됩니다.",
	"video upload starts_": "녹화가 완료된 후 비디오 업로드가 시작됩니다.",
	"Power Saving": "전력 절약",
	"In all modes_": "모든 모드에서 감지된 충격은 이벤트 비디오 녹화를 시작합니다.",
	"Battery Protection setting _": "배터리 보호 설정은 켜져 있어야 합니다.",
	"At least one of_": "다음 설정 중 적어도 하나는 활성화되어야 합니다",
	or: or$7,
	"For BlackVue battery users": "BlackVue 배터리 사용자를 위해",
	"we recommend setting_": "배터리 사용을 최대화하기 위해 전압 차단을 최소값으로 설정하는 것을 추천합니다.",
	"No videos were found.": "비디오를 찾을 수 없습니다.",
	"Try different filter_": "필터를 변경하거나 필터를 재설정하세요.",
	"Not avaliable with_": "현재 카메라로 사용할 수 없습니다",
	"Overlays a detection_": "DMS 카메라 라이브 및 녹화된 영상에 감지 상자를 오버레이합니다.",
	"A minute of_": "전면 카메라 비디오의 1분은 대략",
	"System voice guidance": "시스템 음성 안내",
	"Recording trigger": "녹화 트리거",
	"Remote Button (Optional)": "원격 버튼 (선택 사항)",
	"Remote button settings_": "원격 버튼 설정은 클라우드 연결을 통해 변경할 수 없습니다. 이 설정을 수정하려면 카메라 > 로컬 연결 > 카메라 설정으로 이동하십시오.",
	"No Registered Device": "등록된 장치 없음",
	"Subscription process is complete": "구독 절차가 완료되었습니다",
	"Now, go back to_": "이제 FLEETA 앱으로 돌아가서 계정에 로그인하고 서비스를 즐기기 시작하세요.",
	"You can check the upload progress": "클라우드 스토리지 > FLEETA 드라이브 탭에서 업로드 진행 상황을 확인할 수 있습니다.",
	"SIM card must be inserted in_": "클라우드를 사용하려면 SIM 카드를 카메라에 삽입해야 합니다.",
	"Active until:": "활성 기간:",
	Subscribe: Subscribe$7,
	"Camera PSN": "카메라 PSN",
	"BlackVue Sim Free Trial Started!": "BlackVue Sim 무료 평가판이 시작되었습니다!",
	"Enjoy a free period to use your SIM_": "구독 없이 SIM을 무료로 사용할 수 있는 기간을 즐겨보세요!",
	"You can stay connected during the trial_": "평가판 기간 동안 연결 상태를 유지할 수 있지만 다음 사항을 기억하세요.",
	"Complete your subscription before the trial_": "SIM을 계속 사용하려면 평가판이 종료되기 전에 구독을 완료하세요.",
	"If you don't subscribe by the end of the trial_": "평가판이 끝날 때까지 구독하지 않으면 SIM 서비스가 비활성화됩니다.",
	"Save Event Videos_": "이벤트 영상을 클라우드 스토리지에 실시간으로 저장해보세요!",
	"Note: Deleting your account doesn’t cancel": "참고: 계정을 삭제해도 요금제가 취소되지 않습니다. 취소하려면 FLEETA 웹 뷰어에서 계정 > 요금제로 이동하세요.",
	"Available only on FLEETA App for_": "이 모델에서는 FLEETA 앱에서만 사용할 수 있습니다.",
	"The cloud is deactivated": "클라우드가 비활성화되었습니다.",
	"Please add a camera with FLEETA_": "이 기능을 사용하려면 FLEETA 앱에서 카메라를 추가하세요.",
	"Upload videos to FLEETA_": "비디오를 FLEETA 드라이브에 업로드하고 안전하게 보관하세요!",
	"You have no assigned camera_": "할당된 카메라가 없습니다.\n할당 요청을 위해 최고 관리자에게 문의하십시오.",
	"Camera notification settings": "카메라 알림 설정",
	Vehicle: Vehicle$7,
	"App Download": "앱 다운로드",
	"Have a problem with_": "구독에 문제가 있나요?",
	"Restore Purchase": "구매 복원",
	"Battery Pairing": "배터리 페어링",
	"Playback\nLive View": "재생/\n라이브 뷰",
	"Remote Playback": "원격 재생",
	"Remote Live View": "원격 라이브 뷰",
	"Cloud connection settings": "클라우드 연결 설정하기",
	"Go to settings": "설정으로 이동",
	"Only cloud cameras that_": "사용자가 공개적으로 공유하기로 선택한 클라우드 카메라만 지도에 표시됩니다.",
	"Live Broadcast Cameras": "생방송 카메라",
	"*Live Broadcast Cameras_": "*라이브 방송 카메라는 사용자가 방송하도록 설정한 클라우드 카메라입니다.",
	"Only cloud cameras_": "사용자가 방송하기로 선택한 클라우드 카메라만 지도에 표시됩니다."
};

var Dashboard$6 = "Dashbord";
var Account$6 = "Konto";
var Help$6 = "Hjelp";
var Mac$6 = "Mac";
var Windows$6 = "Windows";
var Admin$6 = "Admin";
var Driver$6 = "Sjåfør";
var Cameras$6 = "Kameraer";
var Manage$6 = "Administrer";
var Clear$6 = "Klar";
var Show$6 = "Forestilling";
var GB$6 = "{{a}}GB";
var _section$6 = "-delen.";
var Name$6 = "Navn";
var Password$6 = "Passord";
var Cancel$6 = "Avbryt";
var Members$6 = "Medlemmer";
var Groups$6 = "Grupper";
var Role$6 = "Rolle";
var Group$6 = "Gruppe";
var Status$6 = "Status";
var nPM$6 = "{{a}} PM";
var nAM$6 = "{{a}} AM";
var Newest$6 = "Nyest";
var Oldest$6 = "Eldst";
var Accepted$6 = "Godtatt";
var Pending$6 = "Pågår";
var Expired$6 = "Utløpt";
var All$6 = "Alle";
var Delete_$6 = "Slett {{a}}";
var Delete$6 = "Slette";
var Rename$6 = "Endre navn";
var Add$6 = "Legg til";
var OK$6 = "OK";
var Remove$6 = "Fjern";
var Files$6 = "Filer";
var Features$6 = "Funksjoner";
var Settings$6 = "Innstillinger";
var Upload$6 = "Laste opp";
var Privacy$6 = "Personvern";
var Done$6 = "Ferdig";
var Subscription$6 = "Abonnement";
var Submasters$6 = "administratorer";
var Users$6 = "sjåfører";
var Change$6 = "Endre";
var Method$6 = "Metode";
var Details$6 = "Kamerainfo.";
var Confirm$6 = "Bekreft";
var Address$6 = "Adresse";
var Country$6 = "Land";
var State$6 = "Stat";
var ZIP$6 = "Postnummer";
var Pricing$6 = "Priser";
var Free$6 = "Free";
var Smart$6 = "Smart";
var Fleet$6 = "Fleet";
var Subscrubed$6 = "Abonnerer";
var January$6 = "januar";
var February$6 = "Feburary";
var March$6 = "mars";
var April$6 = "april";
var May$6 = "Kan";
var June$6 = "juni";
var July$6 = "juli";
var August$6 = "august";
var September$6 = "september";
var October$6 = "oktober";
var November$6 = "november";
var December$6 = "desember";
var Blackvuecloud_$6 = "www.blackvuecloud.com";
var Support$6 = "Support";
var Community$6 = "Community";
var FAQ$6 = "FAQ";
var Developers$6 = "Developers";
var Facebook$6 = "Facebook";
var Twitter$6 = "Twitter";
var Instagram$6 = "Instagram";
var Youtube$6 = "Youtube";
var Linkedin$6 = "Linkedin";
var Downloads$6 = "Nedlastinger";
var Unauthorized$6 = "Ikke autorisert";
var none$6 = "Ingen";
var Email$6 = "E-post";
var Customers$6 = "Customers";
var Home$6 = "Home";
var Plan$6 = "Plan";
var New$6 = "New";
var Unsubscribed$6 = "Unsubscribed";
var Edit$6 = "Edit";
var month$6 = "month";
var months$6 = "months";
var Continue$6 = "Continue";
var Back$6 = "Tilbake";
var Master$6 = "Owner";
var Develop$6 = "Developers";
var $9$6 = "$9";
var $15$6 = "$15";
var $10$6 = "$10";
var mo$6 = "Måned";
var City$6 = "By";
var Charge$6 = "Belast";
var subscribe$6 = "Abonner";
var search$6 = "Søk";
var invalid_number$6 = "Kortnummeret er ikke et gyldig kredittkortnummer";
var invalid_expiry_month$6 = "Kortets utløpsmåned er ugyldig";
var invalid_expiry_year$6 = "Kortets utløpsår er ugyldig";
var invalid_cvc$6 = "Kortets sikkerhetskode er ugyldig";
var incorrect_number$6 = "Kortnummeret er feil";
var incomplete_number$6 = "Kortnummeret er ufullstendig";
var incomplete_cvc$6 = "Kortets sikkerhetskode er ufullstendig";
var incomplete_expiry$6 = "Kortets utløpsdato er ufullstendig";
var expired_card$6 = "Kortet er utløpt";
var incorrect_cvc$6 = "Kortets sikkerhetskode er feil";
var incorrect_zip$6 = "Kortets postnummer ble ikke godkjent";
var invalid_expiry_year_past$6 = "Kortets utløpsår er i fortiden";
var card_declined$6 = "Kortet ble avvist";
var missing$6 = "Det er ingen kort registrert på en kunde som belastes";
var processing_error$6 = "Det oppstod en feil under behandling av kortet";
var Paypal$6 = "Paypal";
var iOS$6 = "iOS";
var Android$6 = "Android";
var Total$6 = "Totalt";
var And$6 = "og";
var Camera$6 = "Camera";
var Yes$6 = "Ja";
var No$6 = "Nei";
var News$6 = "Nyheter";
var Notifications$6 = "Varsler";
var MPH$6 = "MPH";
var Firmware$6 = "Fastvare";
var Basic$6 = "Grunnleggende";
var Resolution$6 = "Oppløsning";
var Brightness$6 = "Lysstyrke";
var Recording$6 = "Opptak";
var Highest$6 = "Høyest";
var High$6 = "Høy";
var Normal$6 = "Normal";
var Sensitivity$6 = "Følsomhet";
var Volume$6 = "Volum";
var Close$6 = "Close";
var Cloud$6 = "Cloud";
var Public$6 = "Public";
var Front$6 = "Front";
var Rear$6 = "Bak";
var Play$6 = "Spill";
var Stop$6 = "Stopp";
var Pause$6 = "Pause";
var Time$6 = "Time";
var System$6 = "System";
var Event$6 = "Hendelse";
var Parking$6 = "Parkering";
var Color$6 = "Farge";
var Exit$6 = "Gå ut";
var Save$6 = "Lagre";
var Impact$6 = "Kollisjon";
var Unlimited$6 = "Ubegrenset";
var Default$6 = "Standard";
var Version$6 = "Versjon";
var Language$6 = "Språk";
var Notification$6 = "Varsel";
var Multiple$6 = "Multi";
var Range$6 = "Rekkevidde";
var Download$6 = "nedlasting";
var Manual$6 = "Håndbok";
var Satellite$6 = "Satellitt";
var Tutorials$6 = "Opplæringer";
var Filter$6 = "Filter";
var Sun$6 = "Søn";
var Mon$6 = "Man";
var Tue$6 = "Tir";
var Wed$6 = "Ons";
var Thu$6 = "Tor";
var Fri$6 = "Fre";
var Sat$6 = "Lør";
var Dates$6 = "Datoer";
var Routes$6 = "Ruter";
var Opacity$6 = "opasitet";
var Entry$6 = "Oppføring";
var Owner$6 = "Owner";
var Undetected$6 = "uoppdaget";
var Distracted$6 = "Forstyrret";
var Drowsy$6 = "Drowsy";
var Calling$6 = "Calling";
var Smoking$6 = "Smoking";
var Permissions$6 = "Tillatelser";
var Private$6 = "Privat";
var Entering$6 = "Entrer";
var Exiting$6 = "Forlater";
var Acceleration$6 = "Akselerering";
var Passing$6 = "Passerer";
var Overspeed$6 = "Overhastighet";
var Recipients$6 = "Mottakere";
var Send$6 = "Send";
var Note$6 = "Merknad";
var Video$6 = "Video";
var Advanced$6 = "Avansert";
var Voice$6 = "Tale";
var Days_$6 = "Dager";
var Mute$6 = "Demp";
var UnMute$6 = "Opphev demping";
var Discard$6 = "Forkaste";
var Report$6 = "Report";
var Individual$6 = "Individuell sjåfør som ønsker ro? Forretningseier som trenger en enkel løsning for bilsikkerhet og -sporing?";
var Subscribed$6 = "Abonnerer";
var Geofence$6 = "Geogjerde";
var Driving$6 = "Kjøring";
var Idling$6 = "Tomgang";
var Distance$6 = "Distanse";
var Parked$6 = "Parked";
var Speed$6 = "Hastighet";
var Highest_2$6 = "Høyest";
var Average$6 = "Gjennomsnittlig";
var Geofences$6 = "Geogjerder";
var Move$6 = "Flytt";
var Connected$6 = "Tilkoblet";
var Individual_$6 = "Individ";
var Always$6 = "Alttid";
var Low$6 = "Lav";
var Medium$6 = "Middels";
var High_2$6 = "Høy";
var Flip$6 = "Snu";
var Previous$6 = "Forrige bilde";
var Next$6 = "Neste";
var Expand$6 = "Ekspander";
var Collapse$6 = "Trekk sammen";
var More$6 = "Mer";
var Multi$6 = "Multi";
var Safe$6 = "Trygg";
var Reckless$6 = "Uforsvarlig";
var Inattentive$6 = "Uoppmerksom";
var List$6 = "Liste";
var Usage$6 = "Bruk";
var Profile$6 = "Profil";
var Fullscreen$6 = "Fullskjerm";
var Upgrade$6 = "Oppgrader";
var Management$6 = "Administrasjon";
var Day$6 = "Dag";
var Month$6 = "Måned";
var Later$6 = "Senere";
var ICCID$6 = "ICCID";
var Resubscribe$6 = "Abonner på nytt";
var plan$6 = "plan";
var USD$6 = "USD";
var etc_$6 = "osv.:";
var Available$6 = "Tilgjengelig";
var Used$6 = "Brukt";
var Cancelled$6 = "Kansellert";
var Terminated$6 = "Avsluttet";
var Sort$6 = "Sortere";
var Bonus$6 = "Bonus";
var incomplete_zip$6 = "Kortets postnummer ble ikke godkjent";
var Upgrades$6 = "Oppdateringer";
var OR$6 = "ELLER";
var Undo$6 = "Avbryt";
var Invoice$6 = "Faktura";
var data$6 = "Data";
var Popular$6 = "Popular";
var Mask$6 = "Maske av";
var DMS$6 = "Driver Monitoring System (DMS)";
var Extreme$6 = "Ekstrem";
var OFF$6 = "Av";
var Threshold$6 = "Terskel";
var Drowsiness$6 = "Døsighet";
var Direct$6 = "Direkte";
var Remote$6 = "Ekstern";
var Update$6 = "Oppdater";
var Option$6 = "Alternativ";
var Required$6 = "Påkrevet";
var Optional$6 = "Valgfritt";
var Others$6 = "Annet";
var Stay$6 = "Bli";
var Mask_2$6 = "Mask";
var Low_2$6 = "Low";
var Medium_2$6 = "Medium";
var High_3$6 = "High";
var Highest_3$6 = "Highest";
var Extreme_2$6 = "Extreme";
var Private_2$6 = "Private";
var Lite$6 = "Lite";
var Bitrate$6 = "Bithastighet";
var hours$6 = "Timer";
var Expires$6 = "Utløper";
var Check$6 = "Sjekk";
var Saving$6 = "Lagrer";
var Now$6 = "Nå";
var Beep$6 = "Advarselslyd";
var Unpair$6 = "Koble fra";
var Detected$6 = "Detektert";
var Promotion$6 = "Kampanje";
var Notice$6 = "Oppdateringer";
var Explore$6 = "Utforske";
var Deactivate$6 = "Deaktiver";
var Compliance$6 = "Overholdelse";
var Manufacturing$6 = "Produksjon";
var Emergency$6 = "Nødsituasjon";
var Security$6 = "Sikkerhet";
var Important$6 = "Viktig";
var or$6 = "eller";
var Subscribe$6 = "Abonner";
var Vehicle$6 = "kjøretøy";
var nb = {
	Dashboard: Dashboard$6,
	"Payment & Subscriptions": "Betaling og abonnementer",
	"Fleet Management": "Flåteadministrasjon",
	"Available to master": "Tilgjengelig for master",
	"Available to Fleet_": "Tilgjengelig for brukere med Flåte-abonnement",
	Account: Account$6,
	"Log out": "Logg ut",
	"© 2019 Pittasoft_": "© 2019 Pittasoft Co. Ltd",
	"Privacy policy": "Retningslinjer for personvern",
	"Terms of service": "Brukerbetingelser",
	Help: Help$6,
	"App store": "App store",
	"Google Play": "Google Play",
	Mac: Mac$6,
	Windows: Windows$6,
	"Free Plan": "Free Plan",
	"Basic Plan": "Basic Plan",
	"Smart Plan": "Smart Plan",
	Admin: Admin$6,
	Driver: Driver$6,
	"Period : December 3, 2024 ~ May 31, 2025": "Periode: 3. desember 2024 ~ 31. mai 2025",
	Cameras: Cameras$6,
	"n of n": "{{a}} av {{b}}",
	Manage: Manage$6,
	"Upgrade Plan": "Oppgrader abonnement",
	"Add more cameras_": "Legg til flere kameraer, administrer flåten og mer …",
	"Usage statistics": "Bruksstatistikk",
	"All cameras": "Alle kameraer",
	Clear: Clear$6,
	Show: Show$6,
	"Live views": "Ekstern direktevisning",
	"nh:nm:ns": "{{a}}h:{{b}}m:{{c}}s",
	"Video plays and_": "Video spiller av og lastes ned",
	"Space available": "Ledig plass",
	GB: GB$6,
	"n%": "{{a}}%",
	"BlackVue app for_": "BlackVue-appen for iOS og Android",
	"BlackVue viewer for_": "BlackVue Viewer for Mac og Windows",
	"Welcome to fleet": "Velkommen til flåten",
	"A few things_": "Ting du kan forvente underveis:",
	"You can watch_": "Du kan se på videoer fra kameraene du er tilordnet i BlackVue-appen eller visningsprogrammet for skrivebord.",
	"If the master_deletes": "Hvis master-brukeren sletter kontoen sin, blir også din konto slettet.",
	"If the masters_Fleet": "Hvis master-brukerens Flåte-abonnement utløper, får du fortsatt tilgang til kontoen din, men i skrivebeskyttet modus.",
	"You have to_": "Du må registrere en annen konto for å legge til et personlig kamera.",
	"The Payments &_": "Betalinger og abonnementer- og Flåte-delene er kun tilgjengelige for master-brukeren.",
	"You can manage_": "Du kan administrere flåtegruppen din i",
	"_Fleet management": "Flåteadministrasjon",
	_section: _section$6,
	"The Payments_section-": "Betalinger og abonnementer er kun tilgjengelige for master-brukeren.",
	"Youre almost there": "Du er nesten i mål",
	"Finish account setup": "Fullfør kontooppsettet",
	"Install and log_": "Installer og logg inn på BlackVue-appen eller visningsprogrammet for skrivebord",
	"Download on the_": "Last ned fra App Store",
	"GET IT ON_": "SKAFF DET FRA Google Play",
	"Download for Mac": "Last ned for Mac",
	"Download for Windows": "Last ned for Windows",
	"Add your camera_": "Legg til kameraet i BlackVue-appen eller visningsprogrammet for skrivebord",
	"Start managing your_": "Begynn å administrere flåten din og følge bruksstatistikk her",
	"Cancelled Fleet Plan_": "Flåte-abonnementet ble kansellert {{date}}",
	"The new plan_": "Det nye abonnementet trer i kraft når den inneværende betalingsperioden er over.",
	"Profile photo": "Profilbilde",
	Name: Name$6,
	"E-mail address": "E-postadresse",
	Password: Password$6,
	"Last changed_": "Sist endret {{a}}",
	"Change password": "Endre passord",
	"Delete account": "Slett konto",
	Cancel: Cancel$6,
	"Current password": "Nåværende passord",
	"New password": "Nytt passord",
	"Confirm new password": "Bekreft nytt passord",
	"Password changed": "Passord endret",
	"Reason for deletion_": "Årsak til sletting (valgfritt)",
	"Account password": "Kontopassord",
	Members: Members$6,
	Groups: Groups$6,
	"+ Invite member": "+ Inviter medlem",
	"Name, Email": "Navn, e-postadresse",
	Role: Role$6,
	Group: Group$6,
	"Date invited": "Dato for invitasjon",
	Status: Status$6,
	"Group n": "Gruppe {{a}}",
	nPM: nPM$6,
	nAM: nAM$6,
	Newest: Newest$6,
	Oldest: Oldest$6,
	"Name, email or_": "Navn, e-postadresse eller gruppe",
	Accepted: Accepted$6,
	Pending: Pending$6,
	Expired: Expired$6,
	All: All$6,
	"No results": "Ingen resultater",
	"Try different keywords": "Prøv andre nøkkelord",
	"Try changing or_": "Prøv å endre eller fjerne filtre",
	"Remove all filters": "Fjern alle filtre",
	"Invite member": "Inviter medlem",
	"Send invite": "Send invitasjon",
	"You have reached_": "Du har nådd grensen på 10 sekundær-mastere. Du kan fortsatt invitere brukere.",
	Delete_: Delete_$6,
	"Are you sure_delete": "Vil du virkelig slette dette medlemmet og kontoen til vedkommende?",
	Delete: Delete$6,
	Rename: Rename$6,
	"No submaster yet": "Ingen sekundær-master ennå",
	"You can add_": "Du kan legge til 1 sekundær-master per gruppe",
	"No cameras yet": "Ingen kameraer ennå",
	"Add cameras first_": "Legg til kameraer først, tilordne brukere etterpå",
	"Name or email": "Navn eller e-postadresse",
	"Add submaster": "Legg til sekundær-master",
	Add: Add$6,
	"Add camera": "Legg til kamera",
	"n of n selected": "{{a}} av {{b}} valgt",
	"No cameras available": "Ingen tilgjengelige kameraer",
	"Most likely reasons_": "Sannsynlige årsaker til dette:",
	"All cameras were_": "Alle kameraer er lagt til i andre grupper.",
	"You can remove_": "Du kan fjerne kameraer fra andre grupper og legge dem til i denne gruppen.",
	"No cameras were_": "Ingen kameraer er lagt til på kontoen din.",
	"You can add_cameras": "Du kan legge til kameraer i BlackVue-appen eller visningsprogrammet for skrivebord.",
	OK: OK$6,
	"Rename group": "Gi nytt navn til gruppe",
	"Are you sure_group": "Vil du virkelig slette denne gruppen?",
	"Edit Mobile app_": "Rediger tillatelser for mobilapp / visningsprogram for skrivebord",
	Remove: Remove$6,
	"n of n users": "{{a}} av {{b}} brukere",
	"Youve reached the_": "Du har nådd grensen for brukere per kamera",
	"Remove user": "Fjern bruker",
	"Add user": "Legg til bruker",
	"+ Add group": "+ Legg til gruppe",
	"Add group": "Legg til gruppe",
	"Group or submaster": "Gruppe eller sekundær-master",
	"+ Add": "+ Legg til",
	"of max selected": "{{a}} av maks {{b}} valgt",
	"Mobile app/desktop_": "Tillatelser for mobilapp / visningsprogram for skrivebord",
	Files: Files$6,
	Features: Features$6,
	Settings: Settings$6,
	Upload: Upload$6,
	"Download and Playback_Cloud": "Last ned og spill av fra skylagring",
	"Download and Playback_SD": "Last ned og spill av fra SD-kort",
	"Live view": "Live View",
	"Geo Fencing": "Geogjerder",
	"Drive Reports": "Kjørerapporter",
	"Firmware Settings": "Fastvareinnstillinger",
	"Push Notifications": "Push-varsler",
	"Event Auto Upload": "Automatisk live-opplasting av hendelse",
	Privacy: Privacy$6,
	Done: Done$6,
	"Payment method": "Betalingsmetode",
	"Change payment method": "Endre betalingsmetode",
	Subscription: Subscription$6,
	"Space used": "Benyttet plass",
	"Next billing_": "Neste fakturering {{a}} {{b}}",
	"You manage_available": "Du administrerer {{a}} av {{b}} tilgjengelige i abonnementet",
	Submasters: Submasters$6,
	Users: Users$6,
	Change: Change$6,
	"No transactions yet_": "Du abonnerer på gratisabonnementet. Ingen transaksjoner ennå",
	"No transactions to_": "Ingen transaksjoner kan vises.<br/>Hvis du leter etter transaksjonshistorikken for andre plattformer (f.eks. iOS, Android, PayPal), finner du historikken på abonnementssiden til den aktuelle plattformen.",
	"of nGB_": "{{a}} av {{b}} GB ({{c}}%)",
	"Smart Plan users_": "Smart-abonnement-brukere kan endre abonnementet eller antall kameraer via BlackVue-mobilappen",
	"Transaction history": "Transaksjonshistorikk",
	"Date": "Dato",
	"Amount, USD": "Beløp, USD",
	Method: Method$6,
	Details: Details$6,
	"iOS in-app_": "iOS in-app purchase/Android in-app purchase",
	"Change the number_": "Endre antallet kameraer",
	"You manage_cameras": "You manage {{a}} cameras of {{b}} available on your plan",
	"Extra cameras": "Ekstra kameraer",
	"Total due_": "Å betale",
	"available on your_": "av {{a}} tilgjengelig i ditt abonnement",
	"Cancel Fleet Plan": "Avbryt Fleet Plan",
	"This will cancel_": "Dette sier opp ditt Flåte-abonnement-abonnement. Du nedgraderes til Gratis-abonnement ved slutten av faktureringssyklusen.",
	"Reason for cancellation_": "Årsak for kansellering (valgfritt)",
	"Not now": "Ikke nå",
	Confirm: Confirm$6,
	"Cardholder name": "Kortholders navn",
	"Card name": "Kortnavn",
	"MM/YY": "MM/ÅÅ",
	Address: Address$6,
	Country: Country$6,
	State: State$6,
	ZIP: ZIP$6,
	Pricing: Pricing$6,
	"You are subscribed_": "Du abonnerer på Gratis-abonnement.",
	"With Alert Push_": "Med push-varslinger, begrenset ekstern sanntidsvisning og skylagring.",
	Free: Free$6,
	Smart: Smart$6,
	Fleet: Fleet$6,
	"Get started for_": "Kom i gang gratis, kredittkort ikke påkrevd. \n Inkluderer push-varslinger, begrenset ekstern live-visning og skylagring.",
	Subscrubed: Subscrubed$6,
	"Features included:": "Inkluderte funksjoner:",
	"Get unlimited Remote_": "Få ubegrenset ekstern live-visning, avspilling fra sky og administrasjon av opptil {{a}} kameraer.",
	"BlackVue Fleet Tracking_": "BlackVues flåtesporing har eksklusive funksjoner for både storbrukere og virksomheter (med flere brukere, geogjerder osv.)",
	"Try 1 Month Free": "Prøv 1 måned gratis",
	"Log in": "Pålogging",
	"Remember me": "Husk meg",
	"Forgot password?": "Har du glemt passordet?",
	"Reset password": "Passordnullstilling",
	"Enter email address_": "Oppgi e-postadressen brukt ved registreringen, så\n sender vi deg en lenke for tilbakestilling av passordet.",
	"Send reset password_": "Send e-post for tilbakestilling av passord",
	"Back to login": "Tilbake til innlogging",
	"Check your email": "Sjekk e-posten din",
	"Weve sent an_": "Vi har sendt en e-post til {{a}} med en lenke for å\n bekrefte e-postadressen din.",
	"Resend email": "Send e-post på nytt",
	January: January$6,
	February: February$6,
	March: March$6,
	April: April$6,
	May: May$6,
	June: June$6,
	July: July$6,
	August: August$6,
	September: September$6,
	October: October$6,
	November: November$6,
	December: December$6,
	"Sign up": "Opprett konto",
	"First name": "Fornavn",
	"Last name": "Etternavn",
	"Create a password": "Opprett et passord",
	"5 or more_": "Minst 5 tegn",
	"Sign up and_": "Registrer og fortsett",
	"I agree to_": "Jeg godtar %@, %@, %@ og %@.",
	"Subscribe to newsletter": "Abonner på nyhetsbrev",
	"1 month free trial_": "1 måned gratis prøveversjon",
	"Dont have an_": "Har du ikke en konto?",
	"Thank you for_": "Takk for at du registrerer deg for BlackVue Cloud. Bekreft e-postadressen din.",
	"Confirm email": "Bekreft e-postadressen",
	"If you didnt_": "Hvis du ikke har registrert denne kontoen, kan du ignorere e-posten.",
	Blackvuecloud_: Blackvuecloud_$6,
	"invited you to_": "{{a}} inviterte deg til å bli med flåten sin som sekundær-master.",
	"Accept invitation": "Godta invitasjon",
	"Invite expires on_": "Invitasjonen utløper dd, mm, åå.",
	"Your Fleet Management_": "Flåte-administrasjonskontoen din som er registrert hos {{a}}, ble slettet av %@.",
	"If you believe_": "Hvis du tror dette er en feil, kan du kontakte kundestøtte: cs@blackvue.com.",
	Support: Support$6,
	"Help center": "Hjelpesenter",
	Community: Community$6,
	"Getting started": "Komme i gang",
	FAQ: FAQ$6,
	Developers: Developers$6,
	"Cloud API": "Cloud API",
	"Fleet SDK": "Fleet SDK",
	"Follow us": "Follow us",
	Facebook: Facebook$6,
	Twitter: Twitter$6,
	Instagram: Instagram$6,
	Youtube: Youtube$6,
	Linkedin: Linkedin$6,
	"BlackVue apps": "BlackVue apps",
	"Camera registraiton": "Kameraregistrering",
	"Two-way voice_": "Toveis talekommunikasjon",
	"Live GPS": "Live GPS",
	"Event live auto_": "Automatisk live-opplasting av hendelse",
	"Event file auto_": "Automatisk opplasting av hendelsesfil",
	"Compatible with_": "Kompatibelt med modell DR650GW og DR650S",
	"Not compatible with_": "Ikke kompatibelt med modell DR650GW og DR650S",
	"More cameras": "Flere kameraer",
	"More users": "More users",
	"Roles and permissions": "Roles and permissions",
	"More Cloud Storage": "Mer lagringsplass i skyen",
	"Multi Live view_": "Multi Live View (Web)",
	"Longer GPS Tracking": "Longer GPS Tracking",
	"Geo Fence setup_": "Geo Fence setup (PC viewer) and alerts (PC viewer and app)",
	"Changes saved": "Endringer lagret",
	"Group added": "Gruppe lagt til",
	"Member added": "Medlem lagt til",
	"Group deleted": "Gruppe slettet",
	"Member deleted": "Medlem slettet",
	"Group renamed": "Gruppe fikk nytt navn",
	"Submaster added": "Sekundær-master lagt til",
	"Camera added": "Kamera lagt til",
	"User added": "Bruker lagt til",
	"Users added": "Brukere lagt til",
	Downloads: Downloads$6,
	"The BlackVue App_": "The BlackVue App and Viewer let you use your BlackVue camera to its full potential. Whether on mobile or on home computer, BlackVue gives you the tools to fully enjoy your dashcam's functions.",
	"Compatible with all_": "Compatible with all Wi-Fi enabled BlackVue models.",
	"Supports all BlackVue_": "Supports all BlackVue models to date.",
	"confirm new password": "Bekreft nytt passord",
	"Your password is_": "Passordet du oppga, er feil",
	"Confirm password does_": "Passordene matcher ikke",
	"Please enter_email": "Oppgi en gyldig e-postadresse.",
	"Please enter_password": "Passordet du oppga, er feil",
	"Internal server error_": "Intern serverfeil. Prøv på nytt.",
	"New password is_": "Minst 1 tegn skal være annerledes for det gjeldende passordet",
	"It should be_": "Passord skal bestå av minst 5 tegn",
	"Invalid permission": "Ugyldig tillatelse.",
	"Input data isnt_": "Input-data er ikke tilgjengelig.",
	Unauthorized: Unauthorized$6,
	"Already have subsciption": "Har allerede abonnement",
	"Already uses": "Bruker allerede",
	"Already logged in": "Allerede logget inn",
	"Already sent e-mail": "E-post allerede sendt.",
	"Please wait": "Vennligst vent.",
	"E-mail is not_": "E-posten er ikke bekreftet ennå.",
	"Update your subscription_": "Oppdater abonnementet",
	"Account was deleted": "Kontoen ble slettet.",
	"5 ~ 30_": "5 ~ 30 characters",
	"It has exceeded_": "Maksgrensen på 9 administratorer er overskredet.",
	"Billing information": "Fakturainformasjon",
	"Please enter cardName": "Oppgi kortnavn",
	"Please enter_card": "Oppgi et gyldig kortnummer",
	"Please enter address": "Oppgi adresse",
	"Please select country": "Velg land",
	"Please enter city": "Oppgi by",
	none: none$6,
	"Due today": "Forfaller i dag",
	"Today after 1_": "I dag etter 1 måneds prøve",
	"An error occurred_": "Det oppsto en feil under endring av passordet. Prøv på nytt.",
	"Your account is_": "Kontoen din er nå aktiv",
	"You can now_": "Du kan nå logge inn på kontoen med e-postadressen som ble brukt under registreringen.",
	Email: Email$6,
	"Don’t have an account?": "Har du ikke en konto?",
	"Already have an account?": "Har du allerede en konto?",
	"Cloud service": "Cloud service",
	"for your BlackVue": "for your BlackVue",
	"See what your_": "See what your camera sees remotely.",
	"Receive impact alert_": "Receive Impact alert push notifications.",
	"Save footage to_": "Save footage to the cloud and do much more...",
	"Free plan included_": "Free plan included · Easy setup · Cancel anytime",
	"Taking advantage of_": "Taking advantage of a mobile or car-embedded Internet connection and a BlackVue camera, BlackVue Cloud connects you to your car from anywhere, anytime. Using the BlackVue App on your smartphone or tablet, you see in real time where your car is located and what is happening around it.",
	"Get notifications to_": "Get notifications to your phone when your parked car is hit. Check remotely what is happening around your car.",
	"Monitor your commercial_": "Monitor your commercial vehicles on a map in real time. Talk to your drivers anytime through the BlackVue App or Viewer.",
	"With BlackVue Fleet_": "With BlackVue Fleet Tracking, track in real time up to 100 vehicles from the palm of your hand or with the dedicated BlackVue Viewer.",
	"Get started now_": "Get started now with a Free plan. For unlimited video playback or Remote Live View, upgrade to Lite or Smart plan from the BlackVue App. <br/>Business and power users can unlock the power of the Fleet plan exclusively through this website.",
	"Remote Video Playback_": "Remote Video Playback and Download",
	"Compatible with DR650GW_": "Compatible with DR650GW, DR650S models",
	"Unlimited remote video_": "Unlimited remote video playback and download",
	"Longer cloud storage_": "Longer cloud storage file expiration period",
	"Longer storage period_live": "Longer storage period for Event live auto upload",
	"Longer storage period_file": "Longer storage period for Event file auto upload",
	"Goefence setup (PC_": "Geo-fence setup (PC viewer) and alerts (Windows viewer and app)",
	"App Store": "App Store",
	"Send reset password email": "Send e-post for tilbakestilling av passord",
	Customers: Customers$6,
	Home: Home$6,
	"Pick a plan": "Pick a plan",
	"No customers yet": "No customers yet",
	"Customers will_": "Customers will show up here as they become available",
	"Add customer": "Add customer",
	"Report(PDF)": "Report(PDF)",
	"Subscription Period": "Subscription Period",
	Plan: Plan$6,
	New: New$6,
	Unsubscribed: Unsubscribed$6,
	"Subscription ends soon": "Subscription ends soon",
	Edit: Edit$6,
	"1 month trial": "1 month trial",
	"Edit customer details": "Edit customer details",
	"Customer name": "Customer name",
	"of 999 available_": "of 999 available on Fleet Plan",
	"Subscription starts": "Subscription starts",
	"Subscription period": "Subscription period",
	month: month$6,
	months: months$6,
	"Cloud storage": "Cloud Storage",
	"Subscription plan": "Abonnementstype",
	"Check email address": "Check email address",
	"Add customer details": "Add customer details",
	Continue: Continue$6,
	Back: Back$6,
	"An error occured": "An error occured",
	"Customer added": "Customer added",
	"Last changed": "Last changed",
	"Company name": "Company name",
	"Company address": "Company address",
	"Alert Push Notifications": "Alert Push Notifications",
	"Receive notifications on_": "Receive notifications on your phone when preset Events occur. Great in combination with BlackVue’s Parking Mode.",
	"Remote Live View": "Ekstern Live View",
	"Remotely monitor your_": "Remotely monitor your car in real time from anywhere, anytime.",
	"Video Backup/Auto Upload": "Video Backup/Auto Upload",
	"Back up videos_": "Back up videos to your phone or Cloud storage.",
	"Two-way Voice Communication": "Two-way Voice Communication",
	"Talk with people_": "Talk with people in the car from your smartphone. The driver can speak while keeping hands on the wheel.",
	"View your car’s_": "View your car’s location and speed on a map. With BlackVue Fleet Tracking, access 90-days’ worth of GPS data.",
	"Remote Video Playback": "Remote Video Playback",
	"Play videos stored_": "Play videos stored in the Cloud or in your dashcam anytime on your smartphone or tablet.",
	"Event Live Auto Upload": "Event Live Auto Upload",
	"Save a video stream_": "Save a video stream in real time to the Cloud. Protect yourself from break-ins and theft.",
	"Event File Auto Upload": "Event File Auto Upload",
	"Save Event videos_": "Save Event videos to the Cloud—including seconds before trigger—after they happen.",
	"Firmware-Over-the-Air (FOTA)": "Firmware-Over-the-Air (FOTA)",
	"Upgrade your dashcam’s": "Update your dashcam over the cloud",
	"When an Event_": "When an Event is created (Impact detected or manually triggered), Event Live Auto-upload lets your Cloud-compatible BlackVue save a live video stream from a camera of your choice (front or rear/interior) to the Cloud server",
	"Event File Auto-upload_": "Event File Auto-upload lets your dashcam automatically upload low-resolution versions of Event files to the Cloud.",
	Master: Master$6,
	"per Camera": "per Camera",
	"Event live auto upload_": "Event live auto upload compatible with all cloud cameras",
	"Drive report": "Drive report",
	"USA/Canada Toll Free": "USA/Canada Toll Free",
	"Monday–Saturday_": "Monday to Friday 8am-7pm / Saturday 9am-6pm (PST).",
	"Please agree to_": "You must accept Terms of Service",
	"Mac or Windows PC": "Mac or Windows PC",
	Develop: Develop$6,
	"Sign out": "Sign out",
	"Referral code": "Referansekode",
	"Total after 1 month trial": "Totalt etter 1 måneds prøve",
	"Already Use Stripe Token": "Bruker allerede Stripe-token",
	"Select period": "Velg periode",
	"State/Region": "Delstat/region (valgfritt)",
	"ZIP/Postal": "Postnummer",
	"$0.00": "$0.00",
	"$11.99": "$11.99",
	"$24.99": "$24.99",
	$9: $9$6,
	$15: $15$6,
	$10: $10$6,
	"mo + for_": "/mo + {{a}} per extra camera",
	mo: mo$6,
	"This e-mail address_": "Denne e-postadressen har allerede en registrert konto.",
	"1 month": "1 måned",
	"Limit is reset daily": "Grensen nullstilles daglig",
	"Limit is reset monthly": "Grensen nullstilles månedlig",
	"Video plays and downloads": "Video spiller av og lastes ned",
	"Your master": "Your owner",
	"Youre 1 step_": "Du er 1 steg unna å fullføre Flåte-abonnementet",
	"Finish signing up": "Fullfør registreringen",
	"Enter billing information": "Oppgi fakturainformasjon",
	"Proceed to billing": "Videre til faktura",
	City: City$6,
	Charge: Charge$6,
	"User already invited_": "Brukeren er allerede invitert av master",
	"n% consumed": "{{a}}% brukt",
	"E-mail already exists": "E-postadressen finnes allerede",
	"Cancel your inapp_": "Kanseller abonnementet i appen",
	"You have cancel_": "Du må kansellere abonnementet i appen for å oppgradere til Flåte-abonnement: 1. Kanseller det gjeldende abonnementet i App Store eller Google Play Store. Du blir nedgradert til gratisabonnementet ved utgangen av denne betalingsperioden. Alle dataene dine forblir intakte. 2. Logg inn på din blackvuecloud.com-konto og oppgrader til Flåte-abonnement.",
	"Edit permissions": "Rediger tillatelser",
	"See permissions": "Vis tillatelser",
	"Submaster removed": "Sekundær-master fjernet",
	"Camera removed": "Kamera fjernet",
	"User removed": "Bruker fjernet",
	"Users removed": "Brukere fjernet",
	subscribe: subscribe$6,
	search: search$6,
	"permission can be_": "Tillatelser kan kun konfigureres etter at sekundær-masteren godtar invitasjonen.",
	"The confirmation link_": "Bekreftelseslenken er ikke lenger gyldig",
	"Possible reasons:_": "Mulige årsaker:\n • Du har allerede bekreftet e-postadressen\n • Lenken er utløpt eller har blitt kansellert",
	"Failed to register_": "Kunne ikke registrere for BlackVue Cloud",
	"There was an_": "Det oppsto en feil under registreringsprosessen. Hvis problemer vedvarer, prøv å registrere BlackVue Cloud på nytt. Hvis du trenger mer hjelp, kan du kontakte kundestøtte:",
	"Upgrade to Fleet_": "Oppgrader til Flåte-abonnement",
	"Subscription is Canceled": "Abonnementet er kansellert",
	"No members yet": "Ingen medlemmer ennå",
	"Please enter_group name": "Oppgi et gyldig gruppenavn",
	"Group Name": "Gruppenavn",
	invalid_number: invalid_number$6,
	invalid_expiry_month: invalid_expiry_month$6,
	invalid_expiry_year: invalid_expiry_year$6,
	invalid_cvc: invalid_cvc$6,
	incorrect_number: incorrect_number$6,
	incomplete_number: incomplete_number$6,
	incomplete_cvc: incomplete_cvc$6,
	incomplete_expiry: incomplete_expiry$6,
	expired_card: expired_card$6,
	incorrect_cvc: incorrect_cvc$6,
	incorrect_zip: incorrect_zip$6,
	invalid_expiry_year_past: invalid_expiry_year_past$6,
	card_declined: card_declined$6,
	missing: missing$6,
	processing_error: processing_error$6,
	"no groups yet": "Ingen grupper ennå",
	"groups will show_": "Grupper vises her så snart de blir tilgjengelige",
	"Fleet members will_": "Flåtemedlemmer vises her så snart de blir tilgjengelige",
	"service provider": "Tjenesteleverandør",
	Paypal: Paypal$6,
	iOS: iOS$6,
	Android: Android$6,
	"Enter email": "Please enter a email address",
	"Enter password": "Legg inn passord.",
	"Enter first name": "Oppgi fornavn",
	"Enter last name": "Oppgi etternavn",
	"Enter the current_": "Oppgi gjeldende passord",
	"Enter a new_": "Oppgi nytt passord",
	"There isnt an_": "Det finnes ingen kontoer tilknyttet denne e-postadressen",
	"Fleet Plan": "Fleet Plan",
	Total: Total$6,
	"Password you entered_": "Passordet du oppga, er feil",
	"Incorrect email or_": "Feil e-post eller passord",
	"Available to Masters": "Tilgjengelig for eier",
	"Blackvue url": "https://www.blackvue.com",
	"Information We Collect_": "Informasjon vi innhenter og hvorfor",
	And: And$6,
	"Terms of Location-Based_": "Betingelser for plasseringsbasert servicebruk.",
	"I agree to the_": "Jeg godtar",
	"Password Reset_": "Vi har sendt en e-post til {{a}} med instruksjoner for \n gjenoppretting av passord.",
	"You have already_": "Du er allerede invitert, sjekk e-posten din.",
	"No data available_": "Ingen data tilgjengelig i tabellen",
	Camera: Camera$6,
	"You no longer_": "Du har ikke lenger tillatelse til å bruke Flåte-tjenesten.",
	"Please contact your_": "Kontakt master-brukeren for flåten for å løse problemet.",
	"You can still_": "Du har fremdeles tilgang til",
	"account information": "kontoinformasjonen din.",
	"If the issue_": "Hvis problemet ikke blir løst, og du velger å fortsette å bruke BlackVue Cloud-tjenesten med den registrerte e-postadressen, må du slette kontoen og registrere deg på nytt.",
	"If the problem_": "Ta kontakt med kundeservice hvis problemet vedvarer:",
	"Web subscription only": "Kun nettabonnement",
	"AppStore url": "https://apps.apple.com/kr",
	"We no longer_": "Vi behandler ikke lenger betalinger via PayPal. Du må oppdatere abonnementet for å endre antallet kameraer: 1. Logg inn på paypal.com-kontoen din og kanseller det gjeldende Flåte-abonnementet for å endre antallet kameraer: 2. Logg inn på din blackvuecloud.com-konto og oppgrader til Flåte-abonnement.",
	Yes: Yes$6,
	No: No$6,
	"Serial number": "Serienummer",
	"Cloud code": "Skykode",
	"Terms & Policies": "Vilkår og retningslinjer",
	News: News$6,
	Notifications: Notifications$6,
	"km/h": "km/h",
	MPH: MPH$6,
	"Baidu Maps": "Baidu Maps (kun Kina)",
	"Google Maps": "Google Maps",
	Firmware: Firmware$6,
	Basic: Basic$6,
	"Time Zone": "Tidssone",
	Resolution: Resolution$6,
	"Image quality": "Bildekvalitet",
	Brightness: Brightness$6,
	Recording: Recording$6,
	"Normal recording": "Normalt opptak",
	"Voice recording": "Taleopptak",
	"Video segment length": "Videosegmentenes lengde",
	"Rear camera recording": "Opptak med bakkameraet",
	Highest: Highest$6,
	High: High$6,
	Normal: Normal$6,
	"1 min": "1 min",
	"2 min": "2 min",
	"3 min": "3 min",
	Sensitivity: Sensitivity$6,
	"Motion detection": "Bevegelsesdeteksjon",
	"Speed alert": "Hastighetsvarsel",
	"Voice guidance": "Talemeldinger",
	"Power on": "Kamera slås på",
	"Power off": "Kamera slås av",
	"Starting normal recording": "Starter normalmodus-opptak",
	"Changing recording mode": "Bytter opptaksmodus",
	"Speed alert (beep)": "Hastighetsvarsel (pip)",
	"Cloud related": "Skyrelatert",
	Volume: Volume$6,
	"User text overlay": "Brukertekst",
	"A-Z, a-z_": "A-Z, a-z, 0-9, :;’/\\+-_()$#\nunder 20 tegn.",
	"Wi-Fi auto turn off": "Wi-Fi automatisk av",
	"Login credentials": "Påloggingsinformasjon",
	"Manual recording": "Manuell innspilling",
	"By sharing your_": "Ved å dele din Live View kan du la andre brukere oppleve spenningen og nytelsen ved å kjøre over hele verden.",
	"However, as persona_": "Men siden personlig video kan sendes bør du passe ekstra på når du avgjør hva slags informasjon du deler.",
	"Please enter_email_2": "Vennligst skriv inn en gyldig e-post adresse. E -post med noen spesialtegn er kanskje ikke tillatt. Eks) +, &",
	"Password is incorrect": "Passord er feil.",
	"This camera is already_": "Dette kameraet er allerede registrert til en BlackVue-kontro.",
	"Camera name must_": "Kameranavnet må være mellom 5 og 32 tegn langt.",
	"Failed to save_": "Kunne ikke lagre kamerainnstillinger.",
	"Unallowed character detected": "Ikke tillatte tegn oppdaget.",
	"File(s) queued for_": "Fil(er) i kø for opplasting til Cloud.",
	"Exceeded video play_": "Overskred grense for videoavspilling og -nedlasting.",
	"Playback Failed": "Avspilling mislyktes.",
	"Exceeded your Live_": "Overskred Live View-tiden din.",
	"The camera is not_": "Kameraet er ikke koblet til serveren.",
	"Please check the connection_": "Kontroller tilkoblingsstatusen til valgt kamera.",
	Close: Close$6,
	"Map": "Kart",
	Cloud: Cloud$6,
	Public: Public$6,
	"Flip horizontally": "Snu horisontalt",
	Front: Front$6,
	Rear: Rear$6,
	Play: Play$6,
	Stop: Stop$6,
	Pause: Pause$6,
	"Next frame": "Neste bilde",
	"Previous frame": "Forrige bilde",
	"Proximity sensor": "Nærhetssensor",
	"Voice recording on/off": "Taleopptak av/på",
	"The BlackVue dashcam_": "BlackVue-dashbordkameraet er ikke kompatibelt med trådløse nettverk på 5Ghz.",
	Time: Time$6,
	"Daylight saving time": "Sommertid",
	System: System$6,
	"Incorrect camera serial_": "Uriktig serienummer til kameraet.",
	"Lock event files": "Låse hendelsesfiler",
	"Overwrite locked event_": "Overskriv låste hendelsesfiler når fulle",
	"Camera settings saved_": "Kamerainnstillinger lagret.",
	"Front camera": "Frontkamera",
	"Rear camera": "Bakkamera",
	Event: Event$6,
	Parking: Parking$6,
	"GPS tracking": "GPS-sporing",
	"G-force detected": "G-kraft oppdaget",
	"Impact detected in_": "Støt registrert i parkeringsmodus",
	"Scheduled reboot": "Planlagt restart",
	"Recording status": "Opptaksstatus",
	"Rear security": "Baksikkerhet",
	"Time lapse": "Tidsforløp",
	"Sync with GPS_": "Synkroniser med GPS-tid",
	"Overwrite locked event3_": "Overskriv låste filer med nye hendelsesfiler når lagringen er full",
	"Video codec": "Video Codec",
	"Tracking logs": "Spore loggfiler",
	"Geofence alerts": "Geo-Fencing-varsel",
	Color: Color$6,
	Exit: Exit$6,
	Save: Save$6,
	Impact: Impact$6,
	Unlimited: Unlimited$6,
	"Parking mode recording": "Opptak i parkeringsmodus",
	"Battery protection": "Beskyttelse av batteriet",
	"Cut-off timer": "Tidtaker for avstenging",
	"Low voltage cut-off": "Avstenging ved lav spenning",
	"Rear camera orientation": "Orientering til bakkamera",
	Default: Default$6,
	"Rotate video 180°": "Roter video 180°",
	"Mirror video": "Speil video",
	"Wi-Fi band": "Wi-Fi-bånd",
	"Driving report": "Kjørerapport",
	"Unsupported video codec_": "Ikke støttet videokodeks (H.265).",
	"Rear camera recording_": "Bakkameraet tatt opp i parkeringsmodus",
	"Front and rear_": "Front- og bakkamera tar opp sammen",
	"Rear camera stops_": "Bakkameraet stopper opptaket 5 minutter etter at det har gått inn i parkeringsmodus. Opptak starter på nytt etter å ha gått inn i normal modus.",
	"Remote firmware update": "Ekstern firmwareoppdatering",
	"Firmware is up-to-date": "Firmwaren er oppdatert",
	"New firmware available": "Ny firmware tilgjengelig.",
	Version: Version$6,
	"Release date": "Utgivelsesdato",
	Language: Language$6,
	"File size": "Filstørrelse",
	"What’s new": "Hva er nytt",
	"Updating may take_": "Oppdateringen kan ta flere minutter.",
	"The update process_": "Oppdateringsprosessen kan ikke avbrytes.",
	"Do not disconnect the_": "Ikke koble fra strømkabelen før vanlig opptak begynner på nytt.",
	"Downloading firmware": "Laster ned firmware",
	"Once download is_": "Når nedlastingen er fullført vil BlackVue automatisk starte på nytt for å ta i bruk den nye firmwaren.",
	"If not allowed_": "Hvis det ikke er tillatt, vil ikke din bils plassering og hastighet være tilgjengelig på Cloud.",
	"Unable to initiate update because_": "Kunne ikke initialisere oppdateringen siden dashcam er tilkoblet en enhet via direkte Wi-Fi.",
	Notification: Notification$6,
	Multiple: Multiple$6,
	Range: Range$6,
	"HDR night vision": "HDR nattsyn",
	Download: Download$6,
	"G-sensor": "G-Sensor",
	Manual: Manual$6,
	"Low voltage warning": "Lavspenningsvarsel",
	Satellite: Satellite$6,
	"Data usage": "Databruk",
	"Select video download quality": "Velg videoklipp for nedlasting",
	"Quick play file_": "Raskt spillfil (lav oppløsning)",
	"Original file": "Original fil",
	"You do not have permission_": "Du har ikke tillatelse til å kjøre denne funksjonen. Kontakt eieren av hovedkontoen din.",
	"Interior camera recording_": "Interiørkamera tar opp i parkeringsmodus",
	"Interior security": "Interiør-sikkerhet",
	"Interior camera rotation": "Interiørkamera rotasjon",
	"Multi View": "Multivisning",
	Tutorials: Tutorials$6,
	"Upgrade now": "Oppgrader nå",
	"Members will show_": "Medlemmer vises her så snart de blir tilgjengelige",
	"Are you sure_delete members": "Vil du virkelig slette medlemmer permanent?",
	"Some members may_": "Enkelte medlemmer kan være skjult på grunn av filtrene som er valgt.",
	"Invited on_": "invitert {{Invited Date}} av deg. Eier",
	Filter: Filter$6,
	"Date created": "Opprettelsesdato",
	"No admin yet": "Ingen admin ennå",
	"You can add_admin": "Du kan legge til 1 admin per gruppe",
	"Collapse all": "Skjul alt",
	"Expand all": "Utvid alle",
	"Download and playback_cloud": "Last ned og spill av fra skylagring",
	"Are you sure_2": "Vil du virkelig slette gruppen {Group name}?",
	"Are you sure_groups": "Vil du virkelig slette grupper?",
	"Add cameras first_drivers": "Legg til kameraer først, tilordne sjåfører etterpå",
	"Flip vertically": "Snu vertikalt",
	Sun: Sun$6,
	Mon: Mon$6,
	Tue: Tue$6,
	Wed: Wed$6,
	Thu: Thu$6,
	Fri: Fri$6,
	Sat: Sat$6,
	Dates: Dates$6,
	Routes: Routes$6,
	Opacity: Opacity$6,
	"Color and opacity": "farge og opasitet",
	"Geofences will show_": "geogjerder vises her når de blir tilgjengelige",
	"Start drawing a shape_": "begynn å tegne en form på kartet",
	"Add geofence": "Legg til geogjerde",
	Entry: Entry$6,
	"Show all members": "Vis alle medlemmer",
	"Me and my_": "Jeg og bilen min. Tilkoblet",
	"add-on service for_": "tilleggstjeneste for skykompatibel Blackvue",
	"Continue with Google": "Fortsett med Google",
	"An account with_": "Det finnes allerede en konto med den e-postadressen, men den er ikke bekreftet. Må du oppgi ditt eksisterende BlackVue Cloud-passord.",
	"Account does not_": "Konto eksisterer ikke. Eller prøv å logge på med Apple- eller Google-kontoen din.",
	"Continue with Apple": "Fortsett med Apple",
	"Get started": "Komme i gang",
	"P subscription only": "Bare <b>{{a}}</b> abonnement",
	"+N USD for extra camera_": "+{{a}} USD for extra camera up to {{b}} Cameras",
	"Unlimited Live view": "Unlimited Live View",
	"Cameras per Account": "Cameras per Account",
	"Users per Account": "Users per Account",
	Owner: Owner$6,
	"Live View per Day": "Live View per Day",
	"Remote Video Playback_2": "Remote Video Playback and Download per Month",
	"N days": "{{a}} Days",
	"Video On Map": "Video On Map",
	Undetected: Undetected$6,
	Distracted: Distracted$6,
	Drowsy: Drowsy$6,
	"Whether on mobile_": "Whether on mobile or your computer, BlackVue gives you the tools to fully enjoy your dashcam’s functions. Download the latest <a1>firmware</a1>, <a2>mobile</a2> and <a3>desktop</a3> applications, or use <a4>BlackVue web app</a4> in your browser.",
	"Compatible with most_": "Compatible with most Wi-Fi BlackVue models. Cloud support for all Cloud-compatible dashcam models down to DR650GW Series with <b>Cloud Firmware</b>.",
	"Supports most recent BlackVue_": "Supports most recent BlackVue models and compatible with BlackVue Cloud.<br/>\nThis Viewer contains <b>two applications in one</b>: the SD Card Viewer lets you view recorded videos from your SD card and modify the settings of your BlackVue, as well as format the SD card; the <b>Cloud Viewer</b> lets you enjoy BlackVue Cloud.",
	"Contact us": "Contact us",
	"6 characters with": "6 tegn og en blanding av bokstaver, tall og symboler",
	"Apps and more...": "Apps and more...",
	"Cameras will show_": "Cameras will show up here as they become available.",
	"Keep this page_": "Ha denne siden åpen mens du sjekker bekreftelseskoden. Sjekk mappen for søppelpost hvis du ikke finner e-posten i innboksen.",
	"n cameras": "{{n}} kameraer",
	"n slots": "{{n}} spor",
	"Calculate your Fleet_": "Beregne prisen på ditt Flåte-abonnement",
	"Code you entered_": "Koden du har oppgitt er feil / har utløpt",
	Calling: Calling$6,
	Smoking: Smoking$6,
	"Smoking has been_": "Røyking har blitt oppdaget under kjøring.",
	"Email is already_": "E-posten eksisterer allerede.",
	"Serial number and_": "Serienummer og skykode er trykt på kameraet",
	"Allow GPS access": "Tillat tilgang til GPS",
	"Used to access_": "Brukes for å få tilgang til kjøretøyets posisjon og hastighet. Du kan endre GPS-innstillingene senere i kameraets personverninnstillinger.",
	"Incorrect cloud code": "Feil skykode",
	"An account is_": "En konto med denne e-postadressen eksisterer allerede.",
	"Live event upload": "Direkteopplasting av hendelse",
	Permissions: Permissions$6,
	"Assign in": "Tilordne",
	"Are you sure_camera": "Er du sikker på at du vil slette dette kameraet?",
	"Uploading videos:": "Last ned videoer:",
	"GPS location recording": "GPS-lokasjonen registreres",
	"When OFF, GPS_": "Når dette er AV, blir ikke GPS-lokasjonen registrert eller sendt til skyserveren.",
	"As personal video_": "Siden personlige videoer kan overføres, bør du være spesielt forsiktig når du bestemmer hvilken informasjon du deler.",
	"Share location": "Del lokasjon",
	Private: Private$6,
	"Used to access_2": "Brukes for å få tilgang til kjøretøyets posisjon og hastighet.",
	"Share live view": "Del direktevist video",
	"Share live audio": "Del direktesendt lyd",
	"Share camera’s name": "Del dashcam-navn",
	"Impact detection": "Støtdeteksjon",
	Entering: Entering$6,
	Exiting: Exiting$6,
	"Normal event recording": "Normalt hendelsesopptak",
	"Harsh braking": "Bråbremsing",
	Acceleration: Acceleration$6,
	"Sharp turn": "Skarp sving",
	"Parking event recording": "Parkering-hendelsesopptak",
	Passing: Passing$6,
	"Video source": "Videokilde",
	Overspeed: Overspeed$6,
	"Are you sure_video": "Er du sikker på at du vil slette denne videoen?",
	"Add camera to_": "Legg til kamera til sanntidsvisningen",
	"No routes to_": "Ingen ruter kan vises",
	"Start by adding_": "Start med å legge til datoer.",
	"invite sent": "Invitasjon sendt",
	Recipients: Recipients$6,
	Send: Send$6,
	"Routes selected_": "Valgte ruter: {{n}} av {{total}}",
	"Map service": "Karttjeneste",
	"Speed units": "Hastighetsenheter",
	Note: Note$6,
	"Release notes": "Lanseringsmerknader",
	"The name must_": "Navnet må være mellom 1 til 30 tegn.",
	Video: Video$6,
	Advanced: Advanced$6,
	"Firmware language": "Fastvarespråk",
	"Wi-Fi": "Wi-Fi",
	Voice: Voice$6,
	"Show date and_": "Vis dato og tid",
	"Show speed": "Vis hastighet",
	"Front camera rotation": "Rotasjon av frontkamera",
	"Manual time settings": "Manuell tidsinnstilling",
	"Recommended for better_": "Anbefales for bedre komprimering, redusert filstørrelse og 4K UHD.",
	"For full compatibility_": "For full kompatibilitet med eldre stasjonære PC-er og mobile enheter.",
	"Up and down": "Opp og ned",
	"Side to side": "Side til side",
	"Front and back": "Foran og bak",
	"Detection region": "Deteksjonsområde",
	"Hotspot 1": "Tilkoblingspunkt 1",
	"Hotspot 2": "Tilkoblingspunkt 2",
	"Hotspot 3": "Tilkoblingspunkt 3",
	"Enter/exit": "Åpne/avslutt",
	"Event recording": "Hendelsesopptak",
	"Front security (Normal)": "Frontsikkerhet (normal)",
	"Front security (Parking)": "Frontsikkerhet (parkering)",
	"LTE (Parking)": "LTE (parkering)",
	"Wi-Fi (Parking)": "Wi-Fi (parkering)",
	"Turn on at startup": "Slå på ved oppstart",
	"Turn off after_": "Slå av etter 10 minutter uten aktivitet",
	"Your firmware is_": "Fastvaren din er oppdatert",
	"Add admin": "Legg til admin",
	"Remove All/n": "Fjern alle / {{a}}",
	"Are you sure_remove": "Vil du virkelig fjerne kameraer fra denne gruppen?",
	"This will cancel_2": "Dette sier opp ditt Flåte-abonnement-abonnement. Du nedgraderes til Gratis-abonnement ved slutten av de nåværende faktureringssyklusen.",
	"You’ve reached_": "Du har nådd sjåførgrensen per kamera",
	"Are you sure_remove admin": "Er du sikker på at du vil fjerne admin {{a}}{{b}} fra denne gruppen?",
	"Fleet Plan · Owner": "Fleet Plan · Owner",
	"Manage cameras": "Administrer kameraer",
	"Are you sure_delete zone": "Er du sikker på at du vil slette sone \"{{zone}}\"?",
	"available on your_2": "{{a}}/{{b}} tilgjengelig med ditt abonnement",
	"The new plan_2": "Det nye abonnementet gjelder fra slutten av din nåværende faktureringssyklus ({{a}}).",
	"Canceled Fleet Plan_": "Kansellert Flåte-abonnement den {{a}}",
	"Hard braking alert (beep)": "Varsel om kraftig oppbremsing (pip)",
	"Hard acceleration alert (beep)": "Varsel om kraftig akselerering (pip)",
	"Hard cornering alert (beep)": "Varsel om kraftig svinging (pip)",
	"SSID must be_": "SSID må ha minst 5 tegn.",
	"Password must be_": "Passordet må ha minst 8 tegn.",
	"5 to 32 characters long": "5 til 32 tegn langt",
	"8 to 32 characters long": "8 til 32 tegn langt",
	"Longer storage period_event": "Lengre lagringsperiode for opplasting av live-hendelse",
	"Requires latest firmware_": "Krever nyeste fastvare. Ikke kompatibel med DR650S- og DR650GW-modellene",
	"After Blackvue is_": "Innstillingene lagres etter at Blackvue er koblet til skyen.",
	"This is an_": "Dette er en uregistrert e-postadresse. Ønsker du å registrere deg for en ny konto?",
	"This feature is_": "Denne funksjonen er kun tilgjengelig for Flåte-abonnenter.",
	"Please return to_": "Konto eksisterer ikke. Eller prøv å logge på med Apple- eller Google-kontoen din.",
	"Adjusting the cut-off voltage_": "Adjusting the cut-off voltage to a lower setting may result in your dash cam draining more power from your battery.\nThis could result in warning messages of battery drain or affect other vehicle functions.\nPlease consult with your dealership before lowering the voltage.",
	"Your videos will_": "Videoene dine vises her når de blir tilgjengelige.",
	"You drove:_": "Du kjørte: {{distance}}, {{time}}",
	"Event count per_": "Hendelsesantall per kjøretime",
	"Are you sure_recipient": "Er du sikker på at du vil slette denne mottakeren?",
	"(You)": "{{a}} (deg)",
	"All events": "Alle hendelser",
	Days_: Days_$6,
	"Requires DMC 200_": "Krever DMC 200-kamera",
	"A DMS and compatible_": "En DMS og et kompatibelt dashbordkamera er nødvendig for å vise denne rapporten.",
	"Notifications will show_": "Varslingene vises her ettersom de blir tilgjengelige.",
	"Try changing your_": "Forsøk å endre datoen din eller fjerne filtre.",
	Mute: Mute$6,
	UnMute: UnMute$6,
	"Calling and smoking_": "Ringing og røyking detekteres kun av DMC 200-enheten",
	"You need a DMS_": "Du trenger en DMS for å vise denne rapporten.",
	"Try BlackVue Cloud": "Prøv BlackVue Cloud i dag",
	"Individual driver looking_": "Individuell sjåfør som ønsker ro? Forretningseier som trenger en enkel løsning for bilsikkerhet og -sporing?",
	"Whoever you are_": "Uansett hvem du er, uansett hvor du er, så har vi en skyabonnement til deg.",
	"It is the account that_Driver": "Det er kontoen som ble med i flåten din hos BlackVue Cloud etter å ha godtatt en e-postinvitasjon fra eieren eller admin. En sjåfør kan kun tildeles ett kamera med begrenset emne til å vise sjåførens egen kontoprofil, samt sjåførens tildelte kamera med live-visning og avspilling.",
	"It is the account that_Admin": "Det er kontoen som ble med i flåten din hos BlackVue Cloud etter å ha godtatt en e-postinvitasjon fra eieren. Admin-kontoer kan få tildelt rettighetene eieren tillater for administratoren.",
	"Video deleted": "Video slettet",
	"Video delete_plural": "Videoer slettet",
	"Driver removed from_": "Sjåfør fjernet fra gruppe",
	"Admin removed from_": "Admin fjernet fra gruppe",
	"Camera removed from_": "Kamera fjernet fra gruppe",
	"Are you sure_videos": "Vil du slette valgt fil/valgte filer?",
	"You have to cancel_fleet": "Du må kansellere abonnementet ditt i appen for å endre antall kameraer: 1. Kanseller det gjeldende abonnementet i App Store eller Google Play Store. Du blir nedgradert til gratisabonnementet ved utgangen av denne betalingsperioden. Alle dataene dine forblir intakte. 2. Logg inn på blackvuecloud.com-kontoen din og oppgrader til Flåte-abonnement.",
	Discard: Discard$6,
	"Discard unsaved changes?": "Forkaste ulagrede endringer?",
	"Incorrect serial number": "Feil serienummer",
	"An error occurred_again": "En feil oppstod. Prøv på nytt.",
	"You are subscribed_free": "Du abonnerer på Gratis-abonnement hos BlackVue Cloud.",
	"When an event_": "Når en hendelse opprettes (sammenstøt detekteres eller aktiveres manuelt), lagrer BlackVue en live videostream fra et kamera gjennom opplasting av live-hendelser. Det gjøres til en skyserver du har valgt, og inkluderer 5 sekunder før hendelsen.",
	Report: Report$6,
	"How it work": "Slik fungerer det",
	"Cloud Camera": "Skykamera",
	"Internet Connection": "Internett-tilkobling",
	"BlackVue App/Viewer": "BlackVue App/Viewer",
	"All you need_": "Du trenger bare et",
	"Cloud-compatible BlackVue": "skykompatibelt BlackVue-",
	"and a cellular_": "og mobiltelefonabonnement. Noen modeller er koblet til skyen gjennom en tredjeparts Wi-Fi-tilkoblingspunkt. Andre tilbyr innebygde Nano SIM-kortleser eller støtte for plug-in-tilkoblingsmodul.",
	"Cloud features at_": "Skyfunksjoner rett foran fingertuppene dine",
	"Enjoy peace of_": "Nyt roen, vel vitende om at BlackVue passer på bilen din. Dersom noe skjer, får du umiddelbart melding fra dashbordkameraet.",
	"Let your BlackVue_": "La din BlackVue overvåke bilen din og varsle deg om hendelser. Det øyeblikket et sammenstøt inntreffer, sender BlackVue deg et varsel med et øyeblikksbilde til telefonen eller nettleseren din.",
	"Check on your_": "Kontroller bilen din fra hvor som helst med ekstern live-visning. Enten det gjøres gjennom en nettleser eller mobilen din, får du enkelt tilgang til en videofeed i sanntid fra ditt skytilkoblede dashbordkamera. Du kan enkelt bytte mellom kameraer foran, bak eller på innsiden.",
	"Your BlackVue may_": "Din BlackVue forhindrer ikke påkjørsler, men dersom de skjer, har du gode sjanser for at det blir tatt opp som viktig videobevis. Bla gjennom alle videoene dashbordkameraet ditt har tatt opp, fra mobiltelefonen eller en nettleser.",
	"Worried about eating_": "Er du bekymret for at du bruker opp dataabonnementet ditt? BlackVue har en teknologi for under-streaming som lar deg få tilgang til ekstra små versjoner av videoene dine, for rask gjennomgang og bufferfri visning.",
	"Move files from_": "Flytt filer fra BlackVue til skyen. Lagre én enkelt video eller velg flere klipp for masseopplasting. Video lastet ned til telefonen din med BlackVue-appen er tilgjengelig og kan deles fra internminnemenyen.",
	"View your vehicle’s_": "Vis kjøretøyets posisjon og hastighet i sanntid. Oppgrader til et Smart-abonnement for tilgang til de 7 siste dagene med GPS-sporing.",
	"Get more with_": "Få mer med Smart-abonnement",
	"Unlimited Remote Live_": "Ubegrenset ekstern live-visning",
	"Up to 3 dashcams_": "Opptil 3 dashbordkameraer med en enkelt konto",
	"Want to track_": "Vil du spore en hel flåte? Oppgrader til Flåte-abonnement",
	"BlackVue Fleet Tracking_2": "BlackVue-flåtesporing er en komplett løsning for å beskytte og spore flåten din. Funksjoner og prisfleksibiliteten som dekker behovene til firmaet ditt.",
	"Stream real-time video_": "Stream videoer i sanntid uten grenser. Bithastighet: 600 kbps",
	"Up to 999 Dashcams": "Opptil 999 dashbordkameraer",
	"Register up to_": "Registrer opptil 999 dashbordkameraer per konto.",
	"15GB of Cloud_": "15 GB med skylagring",
	"15GB per additional_": "15 GB per ytterligere dashbordkamera. Ubegrenset lagring for automatisk opplasting av hendelser.",
	"90-days GPS_": "90-dagers GPS-sporingslogger",
	"High accuracy: 15_": "Høy nøyaktighet: 15 sekunder, video på et kart, enkel dataeksport.",
	"Unique fleet management_": "Unike flåtestyringsfunksjoner for økt verdi og bekvemmelighet",
	"Create geofences and_": "Opprett geogjerder og motta sanntidsvarsler på telefonen eller datamaskinen din.",
	"View at a_": "Se umiddelbart total kjøredistanse, tomgang, hastighetshendelser osv. i tabeller som kan skrives ut eller eksporteres.",
	"Multi Live View": "Multi-sanntidsvisning",
	"Monitor up to_": "Overvåk opptil 4 dashbordkameraer samtidig",
	"Benefits for you": "Dine fordeler",
	Individual: Individual$6,
	"Get notifications to_2": "Bli varslet på telefonen din dersom din parkerte bil blir truffet. Kontroller eksternt hva som skjer rundt bilen din. Tilgjengelig på nett, mobil, Mac og Windows.",
	"Small business owner": "Eier av liten bedrift",
	"Monitor your commercial_2": "Overvåk kjøretøyene dine på et kart i sanntid. Snakk med sjåførene når som helst gjennom nettleseren, BlackVue-mobilappen, Mac- eller Windows-visning.",
	"Company with large_": "Bedrift med stor flåte",
	"With BlackVue Fleet_2": "Med BlackVue-flåtesporing, kan du spore opptil 999 kjøretøy i sanntid gjennom nettleseren, BlackVue-mobilappen, Mac- eller Windows-visning.",
	Subscribed: Subscribed$6,
	"The video was_": "Videoen var allerede lastet opp.",
	Geofence: Geofence$6,
	"500: Internal server error": "500: Intern serverfeil",
	"404: Page not found": "404: Side ikke funnet",
	"Check the web address_": "Kontroller nettadressen eller gå tilbake til BlackVue Cloud-startsiden",
	"home page": "Home page",
	"There isn’t an_": "Det er ingen kontoer tilknyttet denne e-postadressen",
	"You can now_password": "Nå kan du logge inn med ditt nye passord",
	"Are you sure_remove admin2": "Er du sikker på at du vil slette admin permanent",
	"Admin deleted": "Admin slettet",
	"Members deleted": "Medlemmer slettet",
	"Are you sure_groupName": "Er du sikker på at du vil slette gruppe {{a}}?",
	"Requires latest firmware": "Krever nyeste fastvare",
	"Selected file(s) moved_": "Valgte filer er flyttet",
	"Are you sure_remove driver2": "Er du sikker på at du vil fjerne sjåfør {{a}} ({{b}}) fra denne gruppen?",
	"Invite sent": "Invitasjon sendt",
	"Safe driving": "Trygg kjøring",
	"Reckless driving": "Uforsvarlig kjøring",
	"Inattentive driving": "Uoppmerksom kjøring",
	"Driving events trend": "Sjåførhendelsestrend",
	"Driving details": "Kjøredetaljer",
	Driving: Driving$6,
	Idling: Idling$6,
	Distance: Distance$6,
	"Parking sessions": "Parkeringsøkter",
	"Parked time": "Parked time",
	"Idle stops": "Tomgangstopp",
	"Idle time": "Tomgangtid",
	"Impact events": "Impact Events",
	Parked: Parked$6,
	Speed: Speed$6,
	"Overspeeding alerts": "Varsler om for høy hastighet",
	Highest_2: Highest_2$6,
	Average: Average$6,
	Geofences: Geofences$6,
	"Entries into a_": "Innganger i en sone",
	"Exits from a_": "Utganger fra en sone",
	"No data": "Ingen data",
	"Hard acceleration": "Akselerering",
	"Hard braking": "Bråbremsing",
	"Hard cornering": "Skarp sving",
	"The number within the brackets_": "Tallet inne i brakettene angir gjennomsnittlig antall hendelser i timen. Dersom du kjører mindre enn én time per dag, vises totalt antall hendelser.",
	"Did you insert_": "Har du satt inn et SIM-kort?",
	"Click here for_": "<a>Klikk her</a> for flere detaljerte veiledninger.",
	"Back up all_": "<b>Sikkerhetskopier alle viktige opptak før du lagrer disse innstillingene.</b><br/>Når du lagrer innstillingene, reinitialiseres microSD-kortet og alle opptakene slettes for å sikre stabil drift.",
	"Not connected to_": "Ikke tilkoblet til skyen. Noe funksjonalitet har blitt midlertidig deaktivert.",
	"GPS Location recording off": "GPS-lokasjonsopptak av",
	"n Videos deleted": "{{count}} videoer slettet",
	Move: Move$6,
	"Driver Monitoring System (DMS) will_": "Sjåførovervåkningssystem (Driver Monitoring System – DMS) lanseres snart.",
	"An error occured while_": "En feil oppstod under forsøk på å endre antall kameraer. Prøv igjen",
	"Reached the limit_": "Grensen er nådd: {{a}}",
	"An invitation was_": "En invitasjon ble allerede sendt til denne e-postadressen.",
	"To use the_": "For å bruke skyfunksjonen. Sett inn SIM-kortet ditt.",
	"Last updated": "Sist oppdatert {{date}}",
	"Try changing your date": "Forsøk å endre datoen din.",
	"No event data_": "Ingen hendelsesdata er samlet for den valgte tiden",
	"Please select another_": "Velg en annen dag eller måned for å vise en hel rapport.",
	"more than 6_": "mer enn 6 tegn nødvendig",
	"Sign up free": "Gratis registrering",
	"Cloud storage warning": "Skylagringsadvarsel",
	"Cloud Storage Full": "Skylagringen er full",
	"Cloud storage usage_100": "Bruk av skylagring har nådd 100%. Frigjør litt lagringsplass for å kunne bruke opplasting av sanntidshendelser",
	"Cloud storage usage_": "Bruken av skylagring nådd <b>({{a}}%)</b>. \nOrganiser skylagringen din.\nTjenesten for opplasting av live hendelser er ikke tilgjengelig dersom lagringen din er full.",
	"Are you sure_delete_zone": "Vil du virkelig slette?",
	"Search Name or email": "Søk på navn eller e-post",
	"Search group name": "Søk på gruppenavn",
	"Please note that_": "Merk at videoopptak må være pauset i noen sekunder for å bruke den nye innstillingen.",
	"Currently connected Hotspot": "Nåværende tilkoblet tilkoblingspunkt",
	"Enhanced night vision": "Forbedret nattsyn",
	"To access the_": "For å få tilgang til kameraet må du oppdatere ditt abonnement.",
	"Restarting the Blackvue_": "Starter BlackVue på nytt for å bruke innstillingene.",
	"Hard acceleration event_": "Hendelse med kraftig akselerering oppstår når økningen per sekund er over {{kmh}} km/t ({{mph}} MPH)",
	"Hard braking event_": "Hendelse med kraftig oppbremsing oppstår når reduksjonen per \nsekund er over {{kmh}} km/t ({{mph}} MPH)",
	"Hard cornering event_": "Hendelse med kraftig svinging oppstår når det er mer enn 60-graders rotasjon innenfor 2 sekunder med over \n{{kmh}} km/t ({{mph}} MPH)",
	"Changes you made_": "Endringene du har gjort blir ikke lagret.",
	"My location": "Min posisjon",
	"Hotspot name (SSID)": "Navn på tilkoblingspunkt (SSID)",
	Connected: Connected$6,
	"Camera will be rebooted_": "Kameraet startes på nytt. Ønsker du likevel å fortsette?",
	"Restarting the BlackVue_": "Starter BlackVue på nytt. Vent et øyeblikk.",
	"Failed to reboot_": "Omstart av kamera mislyktes",
	"Bluetooth (Parking mode)": "BT (parkeringsmodus)",
	"Front and interior camera_": "Kameraene foran og innvendig tar opp sammen.",
	"Interior camera stops_": "Innvendig kameraopptak stopper 5 minutter etter start av parkeringsmodus. Opptak starter på nytt etter å ha gått inn i normal modus.",
	Individual_: Individual_$6,
	"Driver detection": "Sjåføroppdagelse",
	"During driving only": "Kun under kjøring",
	Always: Always$6,
	"Driver detection box": "Sjåføroppdagelsesboks",
	"DMS camera rotation": "DSM-kamerarotering",
	Low: Low$6,
	Medium: Medium$6,
	High_2: High_2$6,
	"Reboot Camera": "Omstart kameraet",
	"Latest events": "Siste hendelser",
	"G-Sensor": "G-Sensor",
	"Playback speed": "Avspillingshastighet",
	Flip: Flip$6,
	Previous: Previous$6,
	Next: Next$6,
	"Map type": "Karttype",
	"Zoom in": "Zoome inn",
	"Zoom out": "Zoome ut",
	"Move to Cloud": "Flytt til skyen",
	"Please recognize that_": "Merk at videoopptak pauses i noen sekunder slik at innstillingene tas i bruk.",
	"6 characters with_": "6 tegn og en blanding av bokstaver, tall og symboler",
	"Updating firmware": "Oppdaterer fastvaren",
	"Overspeed event occurs_": "Hendelse med for høy hastighet oppstår når dashbordkameraet advarer sjåføren om at hastighetsgrensen ble oversteget. Du kan endre den fra Fastvare > System > Volum",
	"Enter group name": "Oppgi gruppenavn",
	"Live view failed": "Live-visning mislyktes.",
	"Parking mode enter_": "Start/avslutt parkeringsmodus",
	"Cloud connectivity": "Skyforbindelse",
	Expand: Expand$6,
	Collapse: Collapse$6,
	"all day": "Hele dagen",
	"Driving style": "Kjørestil",
	"Driving impact": "Støt under kjøring",
	More: More$6,
	"No cameras to_": "Ingen kameraer kan legges til",
	"You have added_": "Du har lagt til alle tilgjengelige kameraer.",
	Multi: Multi$6,
	"Report video": "Rapporter video",
	"Sexually explicit content": "Seksuelt innhold",
	"Graphic violence": "Voldelig eller støtende",
	"Hateful speech": "Hatefull eller fornærmende",
	"Harassment or bullying": "Trakassering eller mobbing",
	"Spam or advertisement": "Spam eller reklame",
	"Infringement of my_": "Krenker rettighetene mine",
	"Other reason": "Osv.",
	"Reason for reporting": "Årsak for rapportering",
	"Reported videos will_": "Rapporterte videoer vil bli kontrollert innen 72 timer. Videoen vil ikke vises på hendelseskartet før det er bekreftet at videoen er egnet for publisering på hendelseskartet.",
	"Touch sensor": "Berøringssensor",
	"Motion and impact detection": "Bevegelses- og støtdeteksjon",
	"Settings have been changed": "Innstillingene har blitt endret",
	"Start event recording (beep)": "Start hendelsesopptak (pip)",
	"Scheduled reboots": "Planlagte omstarter",
	Safe: Safe$6,
	Reckless: Reckless$6,
	Inattentive: Inattentive$6,
	"Highest(Extreme)": "Høyest (Extreme)",
	"Public cameras": "Offentlige kameraer",
	List: List$6,
	Usage: Usage$6,
	"Video playbacks and downloads": "Videoavspilling og nedlasting",
	"of 100 times": "av 100 ganger",
	"of 10 minutes": "av 10 minutter",
	Profile: Profile$6,
	"Search geofences": "Søk i geogjerder",
	"Export CSV": "Eksporter CSV",
	"Exit fullscreen": "Avslutt fullskjerm",
	Fullscreen: Fullscreen$6,
	Upgrade: Upgrade$6,
	"Email address": "E-postadresse",
	"of Unlimited": "av ubegrenset",
	"No notifications yet": "Ingen varsler mottatt de siste 7 dagene.",
	"No videos yet": "Ingen videoer ennå",
	Management: Management$6,
	Day: Day$6,
	Month: Month$6,
	"Welcome to the BlackVue_": "Velkommen til BlackVue Cloud Viewer",
	"You can access BlackVue_": "Du har tilgang til BlackVue Cloud fra nettet når som helt, fra hvor som helst!",
	"Start tour": "Start tur",
	"Map view": "Kartvisning",
	"Check the current_": "Kontroller gjeldende GPS-posisjon og hastighet til kameraene og offentlige kameraer.",
	"Camera’s features": "Kameraets funksjoner",
	"Take a look_": "Ta en titt på de forskjellige skyrelaterte funksjonene som tilbys av BlackVue Camera.",
	"Visualize your vehicle’s_": "Visualiser kjøretøyets kjørerute over tid.",
	"Smart plan_": "Smart-plan: 90-dagers, flåteplan: 90 dager",
	"Create geofences and2_": "Opprett geogjerder og motta sanntidsvarsler.",
	"Got it": "Forstått",
	"Manage Fleet members": "Administrer flåtemedlemmer",
	"Invite fleet members_": "Inviter flåtemedlemmer og tilordne dem til grupper.",
	"The moment the_": "I det øyeblikket kameraet oppdager støtene, blir varsler listet opp her.",
	"Geofence Setup (Web)_": "Oppsett av geogjerde (nett/skrivebord) og varsler",
	"Original file play_": "Original filavspilling er kun tilgjengelig for nedlasting",
	"To get most_": "For å få mest mulig ut av BlackVue Cloud Viewer må kameraet ditt være tilkoblet skyen. Last ned BlackVue-applikasjonen og opplev sømløs sammenkobling, fra kameratillegg til skytilkobling på en gang!",
	"You haven’t driven_Today": "Du har ikke kjørt bilen din ennå i dag. Prøv å kjøre bilen med BlackVue for å kontrollere kjørerapporten.",
	"You haven’t driven_Month": "Du har ikke kjørt bilen din ennå denne måneden. Prøv å kjøre bilen med BlackVue for å kontrollere kjørerapporten.",
	"Fleet Plan only_": "Flåteplan kun tilgjengelig",
	"Overwrite locked event2_": "Overskriv låste hendelsesfiler når lagringsplassen er full",
	"DMS’s New firmware_": "Ny fastvare for DMS er tilgjengelig",
	"Highest speed_report": "<b>Høyeste hastighet</b>Største verdi av innhentede hastighetsdata som samles i meter-enheter, konvertering til km/t- og MPH-enheter\n\n<b>Gjennomsnittshastighet</b>\n(distanse / timer kjørt) *3600 snitthastighet. F.eks. (2622 / 1208 ) *3600 = 7814.907\nKm/t: Bare heltall, \nMPH-radikspunktet er opptil 2 sifre under heltall",
	"Choose a cloud_": "Velg en skytilkoblingsmetode",
	"You need an_": "Du trenger en internettforbindelse for å koble til skyen. Velg enheten du bruker for å koble til skyen.",
	"BlackVue SIM card": "BlackVue SIM-kort",
	"Support model_": "Støttet modell: DR750X-2CH LTE Plus (NA)",
	"3rd party SIM_": "Tredjeparts SIM-kort",
	"Support model_SIM": "Støttet modell: DR750X-2CH LTE Plus, DR750-2CH LTE, CM100 LTE",
	"Wi-fi hotspot": "Wi-Fi-tilkoblingspunkt",
	"Support model_Wifi": "Støttet modell: Alle BlackVue-modeller",
	"How to connect_": "Hvordan koble til skyen",
	"Download BlackVue application": "Last ned BlackVue-applikasjonen.",
	"*If you are_": "*Hvis du skal bruke BlackVue SIM-kort for skytilkoblingen din, går du til {{a}} {{b}}.",
	"Place your phone_": "Plasser telefonen i kameraets BT-rekkevidde. Start din sømløse sammenkobling innen {{a}}.",
	"Back to camera_": "Tilbake til kameralisten",
	"Upgrade for more_": "Oppgrader for flere funksjoner!",
	"Upgrading the cloud_": "Oppgradering av skyplanen lar deg oppleve flere funksjoner og administrere flere kameraer. Ønsker du å oppgradere skyplanen din?",
	"Explore cloud plans": "Utforske skyplaner",
	Later: Later$6,
	"Successfully subscribed": "Abonnement registrert!",
	"1GB data plan": "1 GB dataplan",
	"First month free_": "Første måned gratis, <a>deretter 10,99 USD/måned</a>",
	"Next billing date": "Neste faktureringsdato",
	"Once SIM card_": "Når SIM-kortet er satt inn i kameraet, kan du umiddelbart starte BlackVue Cloud-funksjonene.",
	"Go to SIM_": "Gå til SIM-administrasjon",
	"Manage your BlackVue_": "Administrer BlackVue SIM-kortet ditt her!",
	"Recommended for BlackVue_": "Anbefalt for BlackVue SIM-holdere",
	"Connect to cloud": "Koble til skyen",
	"Enter BlackVue SIM_": "Oppgi BlackVue SIM-ICCID-nummeret",
	"ICCID number is_": "ICCID-nummeret er trykt på SIM-kortpakken. Oppgi de siste 14 sifrene i ICCID-nummeret.",
	ICCID: ICCID$6,
	"SIM information": "SIM-informasjon",
	"Start your free_": "Start din gratis prøveversjon nå",
	"SIM card activate_": "SIM-kortets aktiveringsdato",
	"Based on the_": "Basert på datoen SIM-kortet settes inn i kameraet og aktiveres når strømmen kobles til",
	"Upgrade to 3GB_": "Oppgrader til 3 GB / 5 GB-planen når som helst",
	"Cancel your plan_": "Kanseller planen din når som helst",
	"No Commitment": "Ingen forpliktelse",
	"Precautions for using_": "Forholdsregler for bruk av tjenesten",
	"After 1GB is_": "Etter at 1 GB er oppbrukt, er ikke ekstra internett tilgjengelig.",
	"If you have_": "Hvis du allerede har satt inn et SIM-kort i kameraet og har benyttet det, starter din gratis prøveperiode fra når du begynner å bruke det.",
	"This content is_": "Dette innholdet er spesifisert i SIM-pakken. Vi støtter ikke kompensasjon for gratisperioder som ikke har blitt levert.",
	"If you have_2": "Hvis du har flere spørsmål, kontakter du <a>CS Team</a>",
	"When OFF, connecting_": "Når den er av, er tilkobling av kamera med sømløs sammenkobling deaktivert.",
	"1 month free": "1 måned gratis",
	"No commitment. Cancel_": "Ingen bindingstid. Kanseller når som helst.",
	"The video has been reported_": "Videoen har blitt rapportert",
	"Free for 1 month": "Gratis i 1 måned",
	"Start your free_2": "Start din gratis prøveperiode",
	"1GB free for_": "1 GB gratis i {{a}} dager",
	"1GB data": "1 GB data",
	"1 month free_2": "1-måneds gratis prøveperiode starter fra {{a}}, inkludert 1 GB data for BlackVue SIM-kort.",
	"Your next billing_": "Din neste faktureringsdato er {{a}}",
	"SIM card": "SIM-kort",
	"SIM guide": "SIM-veiledning",
	"SIM card list": "SIM-kortliste",
	"Add SIM card": "Legg til SIM-kort",
	"No SIM card_": "Ingen SIM-kort ennå",
	"Search SIM ICCID_": "Søk etter SIM-ICCID eller navn",
	"Cloud disconnected. Failed_": "Cloud frakoblet. Avspilling av videoen mislyktes",
	"This sim card_": "Dette SIM-kortet er allerede registrert på en annen konto.",
	"Incorrect BlackVue SIM_": "Feil BlackVue SIM-ICCID",
	"My shared videos": "Mine delte videoer",
	"Number of events": "Antall hendelser",
	"Added to Event Map": "Lagt til begivenhetskart",
	"Successfully added video(s)_": "Videoene er lagt til for deling på Hendelseskart! Hvis du vil sjekke statusen og administrere delte videoer, går du til Hendelseskart > Mine delte videoer.",
	"Already added to_": "Allerede lagt til Hendelseskart",
	"This video(s) is already added_": "Videoene er allerede lagt til Hendelseskart! Hvis du vil sjekke statusen og administrere delte videoer, går du til Hendelseskart > Mine delte videoer.",
	"BlackVue’s firmware is up_": "BlackVues fastvare er oppdatert",
	"Service end": "Tjeneste slutt",
	Resubscribe: Resubscribe$6,
	"Sort ascending": "Sorter stigende",
	"Sort descending": "Sorter synkende",
	plan: plan$6,
	USD: USD$6,
	"Are you sure_Cancel": "Er du sikker på at du vil kansellere abonnementet ditt? Merk følgende og bekreft nedenfor.",
	"Your current SIM_": "Ditt nåværende SIM-kortabonnement avsluttes {{a}} og du vil ikke lenger bli belastet.",
	"After canceling your_": "Etter at du har kansellert SIM-kortabonnementet ditt, kan du fortsette å benytte SIM-data til sluttdatoen for abonnementet.",
	"You can resubscribe_": "Du kan abonnere videre innen 1 måned etter at ditt nåværende abonnement avslutter. Hvis du vil abonnere på nytt, klikker du på \"Abonnere på nytt\"-knappen i SIM-kortlisten innen {{a}}.",
	"Reason to cancel_": "Årsak for kansellering av abonnementet",
	"Found an alternative": "Fant et alternativ",
	"Too expensive": "For dyrt",
	"Not required anymore": "Ikke nødvendig lenger",
	"Quality issue": "Problemer med kvaliteten",
	etc_: etc_$6,
	"Please describe in_": "Beskriv detaljert",
	"SIM card cannot_": "SIM-kortet kan ikke slettes siden dette SIM-kortet har et pågående abonnement. Hvis du ønsker å slette dette SIM-kortet, må du først kansellere abonnementet.",
	"SIM card cannot_2": "SIM-kortet kan ikke slettes fordi abonnementet på dette SIM-kortet ikke er avsluttet ennå. Prøv igjen etter at abonnementet ditt avsluttes.",
	"Are you sure_deleteSIM": "Er du sikker på at du vil slette dette SIM-kortet?<br/>\n<b>Advarsel: Du kan ikke angre denne handlingen. All informasjon om SIM-kortet ditt slettes umiddelbart.</b>",
	"ICCID number": "ICCID-nummer",
	"Activation date": "Aktiveringsdato",
	"Current plan": "Gjeldende plan",
	"Manage Plan": "Administrer plan",
	"Next billing on": "Neste fakturering den",
	"View Invoices": "Vis fakturaer",
	"Choose best plan_": "Velg den beste planen for deg",
	"Plan summary": "Planoppsummering",
	"Ends on_": "Slutter den {{a}}",
	"Start from_": "Start fra {{a}}",
	"Your subscription will_": "Abonnementet ditt oppgraderes den {{a}}, når det nåværende abonnementet ditt avsluttes.",
	"Resubscribe plan": "Gjentakende abonnementsplan",
	"Your subscription will2_": "Abonnementet ditt starter den {{a}}, når det nåværende abonnementet ditt avsluttes.",
	"Usage is estimated_": "Bruk er beregnet per {{a}}",
	"Days left_": "{{a}} dager igjen",
	"Data usage cycle": "Databrukssyklus",
	Available: Available$6,
	Used: Used$6,
	"Data used": "Data brukt",
	"Subscribe to n_": "Abonnement på {{a}} dataplan brukt <b>fra {{b}} til {{c}}</b> og {{d}} dataplan brukt fra {{e}}",
	"Will be charged_": "Belastes den {{a}}",
	"Monthly usage": "Månedlig bruk",
	"You have fewer_": "Du har mindre data igjen denne måneden!",
	"Get more data": "Få mer data!",
	"This video cannot be shared": "Denne videoen kan ikke deles",
	"This is a video cannot be shared_": "Dette er en video som ikke kan deles fordi kjøreinformasjon ikke blir funnet på det tidspunktet.",
	Cancelled: Cancelled$6,
	Terminated: Terminated$6,
	"Edit name": "Rediger navn",
	"Not connected to_2": "Ikke tilkoblet til skyen. Kontroller om kameraet er på og internett-tilkoblingsmodulen er aktivert.",
	"Some functionality is disabled_": "Noen funksjoner er deaktivert fordi kameraet ikke er koblet til skyen. Koble til skyen <a>her</a>.",
	"If you want to cancel_": "Hvis du vil kansellere planen din, klikker du på <a>Kanseller abonnement</a>.",
	"Select plan": "Velg plan",
	"Event map collects_": "Hendelseskartet innhenter og visualiserer BlackVue-hendelsesinformasjon for å gi situasjoner for de omkringliggende veiene.",
	"Share your Live_": "Del opplastingsfilen for direktesendinger. Du kan dele hendelsesvideoene dine med andre brukere rundt deg.",
	"You can check_": "Du kan sjekke ut hendelsesvideoene som er delt av andre.",
	"Service end_": "Tjenesten slutter: {{a}}",
	"DMS camera recording_": "DMS-kameraopptak i parkeringsmodus",
	Sort: Sort$6,
	"Are you sure you want_": "Er du sikker på at du vil fjerne delt video fra Hendelseskart?",
	"Remove shared video": "Fjern delt video",
	"Explore event map": "Utforsk hendelseskartet",
	"Event map": "Hendelseskart",
	"Explore the graphic_": "Utforsk den grafiske statistikken over BlackVue-hendelser som skjer rundt deg.",
	"You can filter_": "Du kan filtrere og vise hendelsene du vil vise.",
	"This video was removed by_": "Denne videoen har blitt rapportert og er fjernet av administrator.",
	Bonus: Bonus$6,
	"Your subscription plan": "Abonnementsplanen din",
	"Your free trial will_": "Din gratis prøveperiode starter fra {{a}}</br> <strong>til</strong> {{b}}.",
	"Total after free trial": "Totalt etter gratis prøveperiode",
	"This sim card is_": "Dette SIM-kortet er ikke lenger aktivt.",
	"Firmware is up_": "Fastvaren er oppdatert",
	"Keep in mind": "Husk",
	"Once 1GB of_": "Når 1 GB med data er benyttet, vil ikke tjenesten være tilgjengelig før neste tilbakestillingsdato [eller etter at du har oppgradert planen din til et høyere nivå].",
	"After the SIM_": "Etter at SIM-kortet er satt inn i kameraet, begynner den gratis prøveperioden når du begynner å benytte data.",
	"If you have_questions": "Hvis du har spørsmål, kontakter du vår <a>kundestøtte.</a>",
	"Data reset date": "Dato for tilbakestilling av data",
	"To use SIM card_": "For å bruke SIM-kort kontakter du BlackVues <a>CS Team</a>",
	"Go to Subscription": "Gå til Abonnement",
	"An error occurred_subscription": "Det oppstod en feil under abonnement på valgt plan.",
	"Please try again": "Prøv på nytt",
	"Failed to subscribe": "Abonnering mislyktes",
	"Go to Pricing": "Gå til Priser",
	"SIM cards will_": "SIM-kortene vises her når de blir tilgjengelige.",
	"1GB for 1_": "1 GB for 1 måned",
	"Pricing Data": "Datapriser",
	"If you would like to check_": "Hvis du vil sjekke statusen og administrere delte videoer, går du til Hendelseskart > Mine delte videoer.",
	"Connect to Cloud": "Koble til skyen",
	"Completed!": "Fullført!",
	"Back to App": "Tilbake til appen",
	"iOS in-app purchase": "Kjøp i iOS-app",
	"Android in-app_": "Kjøp i Android-app",
	"bonus n days": "bonus {{a}} dager",
	"Want to contribute your_": "Vil du tillate automatisk deling av automatiske opplastingsfiler til Hendelseskart?",
	"With event map_": "Du kan dele auto-opplasting av hendelsesvideoen med sjåfører i nærheten gjennom hendelseskartet.",
	"You can edit_3": "Du kan når som helst redigere automatisk deling av hendelsesfiler til hendelseskartinnstillinger ved å gå til BLACKVUE CLOUD > Kamerainnstillinger > Personverninnstillinger.",
	"If you want to remove videos_": "Siden personlige videoer kan overføres, bør du være spesielt forsiktig når du bestemmer hvilken informasjon du deler.",
	"Total events": "Totale hendelser",
	"Automatically add Live Event_": "Automatisk deling av automatisk hendelsesopplasting av filer til Hendelseskart",
	"This camera is publicly_": "Dette kameraet er kun åpent for sin posisjon.",
	incomplete_zip: incomplete_zip$6,
	"Live Event Upload_": "Opplasting av direktesending (lagringsperiode: 7 dager)\nKrever siste fastvare",
	"Thank you for_2": "Takk for tålmodigheten din.",
	"Start Web viewer": "Start nettviser",
	"Are you sure_remove driver": "Er du sikker på at du vil slette sjåføren permanent",
	"An error occurred_sim": "Det oppsto en feil under forsøk på å abonnere.",
	"Click the ADD SIM": "Klikk på LEGG TIL SIM-knappen på SIM-kortlistesiden, og gjennomgå prosessen for å legge til SIM igjen.",
	"Set download options": "Angi nedlastingsalternativer",
	"Information may be_": "Information may be transmitted with a delay and may not reflect actual balances.",
	"Swipe left and right to move": "Sveip til venstre og høyre for å flytte",
	"Scheduled maintenance Notice": "Varsel om planlagt vedlikehold",
	"Our Cloud server_": "Skyserveren vår gjennomgår planlagt vedlikehold.",
	"During that time_": "I løpet denne perioden kan skyfunksjonene være utilgjengelige.",
	"Expected maintenance start_": "Forventet starttidspunkt for vedlikehold:",
	"Expected duration_": "Forventet varighet: {{a}} timer.",
	"For more information_": "For mer informasjon kan du se <a>[Server Maintenance Notice]</a>",
	"Do not remind_": "Ikke gi meg påminnelse igjen",
	"Cloud Server Maintenance": "Vedlikehold av skyserver",
	"BlackVue Cloud Service_": "BlackVue Cloud Service er midlertidig utilgjengelig",
	"We are currently_": "Vi utfører for tiden vedlikehold.",
	"We apologize for_": "Vi beklager ubeleiligheten.",
	"Driver Monitoring System (DMS)": "Sjåførovervåkningssystem (Driver Monitoring System – DMS)",
	"Distracted occurs_": "Oppstår når sjåførens hode er mer enn 50 grader unna fronten.\n",
	"Hand distraction event occurs_": "Oppstår når sjåførens hånd oppdages nær hodet over en lengre periode (for eksempel når han røyker, holder en telefon, osv.).",
	"Mask off event occurs_": "Oppstår når sjåføren går inn i kjøretøyet uten maske eller når sjåføren tar av seg masken.",
	"DMS setting": "DMS-innstilling",
	"The DMS system has_": "DMS kombinerer en ansiktsgjenkjenningsboks for statusene \"Detektert\", \"Udetektert\", \"Distrahert\", \"Søvnighet\", \"Maske av\" og en bevegelsesgjenkjenningsboks for statusen \"Håndforstyrrelse\".",
	"DMS detection": "DMS-deteksjon",
	"There are detection criteria for_": "Det er deteksjonskriterier for hvert arrangement. Se veiledningen nedenfor.",
	"DMS camera recording_onoff": "På: DMS-kameraet tar opp i parkeringsmodus så lenge strømmen opprettholdes. <br/> Av: DMS-kameraet slår seg av kort tid etter at parkeringsmodusen er aktivert.",
	"LED lighting for each event_": "LED på førerovervåkingskameraet vil signalisere hver deteksjonshendelse (Forstyrrelse, Døsighet, etc.).",
	"Drowsy and Distracted each have_": "Trøtt og Distrahert har tre følsomhetstilstander hver.\n \n Se veiledningsgrensesnittet nedenfor.",
	"DMS event detection sensitivity": "Følsomhet for DMS-hendelsesdeteksjon",
	"Only drowsy and distracted include_": "Kun Trøtt og Distrahert har innstillinger for følsomhet. Den innstilte følsomheten bruker også samme følsomhet for to hendelser med én innstilling.",
	"When driver’s eyes close_": "Oppstår når sjåføren lukker begge øynene mens de kjører i mer enn 1 sekund eller gjesper i 2 sekunder.\n",
	"n digit": "{{a}} -sifret",
	"You are subscribed_free_Smart": "Du abonnerer på Smart-planen til BlackVue Cloud.",
	"Wi-Fi auto turn on": "Wi-Fi automatisk på",
	"Video on a map": "Video on a map",
	"This feature is only_vom": "This feature is only available to users with a Fleet Plan subscription.<br/>Please subscribe to a plan to unlock this feature.",
	"Total n days_": "Totalt {{a}} dager med en gratis prøveperiode",
	"Every events of DMC200_": "DMS-deteksjonsfunksjoner er bare aktive i normal modus. Hvis det er aktivert i parkeringsmodus, vil DMS-kameraet bare ta opp video.",
	"An undetected event occurs_": "Oppstår når sjåføren ikke oppdages foran kameraet i 1 minutt.",
	"A detected event occurs_": "A detected Event occurs when the driver is gazing in front since the power is set in the beginning.",
	"Drowsy sensitivity_": "High : When the driver closes their eyes for more than 1 second, it is considered drowsy driving.<br/><br/>Medium : When the driver closes their eyes for more than 1.5 second, it is considered drowsy driving.<br/><br/>Low : When the driver closes their eyes for more than 2 second, it is considered drowsy driving.",
	"Distracted sensitivity_": "High : If the angle of the head is more than 50 degrees away from the front for 3 seconds, it is detected as Distracted.<br/><br/>Medium : If the angle of the head is more than 50 degrees away from the front for 5 seconds, it is detected as Distracted.<br/><br/>Low : If the angle of the head is more than 50 degrees away from the front for 7 seconds, it is detected as Distracted.",
	"Start your subscription now": "Start abonnementet ditt nå",
	"Free trial period has expired": "Gratis prøveperiode er utløpt",
	"1 data plan will start from_": "Dataplanen starter fra {{a}} inkludert 1 GB data for Blackvue SIM-kort.",
	"Allow the BlackVue_": "Gi BlackVue-appen tilgang til ditt dashcams GPS-data?",
	"We use this_": "Vi lar det bruke dette slik at du kan spore din bils plassering og hastighet.",
	"You can edit_": "Du kan redigere innstillinger for GPS-tilgang når som helst ved å gå til BLACKVUE CLOUD > Kamerainnstillinger > Personverninnstillinger.",
	"SIM cards": "SIM-kort",
	"Subscription status": "Abonnementsstatus",
	Upgrades: Upgrades$6,
	"Upgrade plan": "Oppgrader abonnement",
	"Manage plan": "Administrer abonnementsplanen",
	"Next plan": "abonnementsplan for neste måned",
	OR: OR$6,
	"Cancel subscription": "Avbestille abonnementet",
	Undo: Undo$6,
	Invoice: Invoice$6,
	"Daily usage": "Daglig databruk",
	"Delete SIM": "SIM Slette",
	"New card": "Nytt kredittkort",
	data: data$6,
	"SIM card data_": "SIM-kortdataabonnement kan kanselleres på <a>sim.blackvuecloud.com</a>.",
	"Your plan from_": "Planen din fra i dag til neste faktureringsdato",
	"Applied during_": "Brukt i løpet av {{a}} ~ {{b}}",
	"From today until_": "Fra i dag og til neste betalingsdato kan du kun abonnere på samme plan som forrige måned. Betalinger for denne perioden blir fakturert i dag. <a>Gebyrene beregnes på et proporsjonalt grunnlag.</a>",
	"Choose your next plan": "Velg din neste plan",
	"Applied from_": "Brukt fra {{a}}",
	"Payment for this_": "Betaling for denne planen blir belastet {{a}}.",
	"By sharing your_2": "Ved å dele din Live View kan du la andre brukere oppleve spenningen og nytelsen ved å kjøre over hele verden. Men siden personlig video kan sendes bør du passe ekstra på når du avgjør hva slags informasjon du deler.",
	"Option camera recording_": "Opptak fra alternativt kamera i parkeringsmodus",
	"Front and option camera_": "Front- og alternativt kamera tar opp sammen.",
	"Option camera stops_": "Alternativ kamera stopper opptak 5 min. etter å ha gått inn i parkeringsmodus. Opptak starter på nytt etter å ha gått inn i normal modus.",
	"Option camera rotation": "Rotasjon av alternativt kamera",
	"Option camera": "Alternativt kamera",
	"Option camera security": "Alternativ kamerasikkerhet",
	"Resubscribe until_": "Abonner på nytt til: {{a}}",
	"Firmware Update Caution": "Advarsel om fastvareoppdatering",
	"Please check below_": "Kontroller betingelsen nedenfor før fastvareoppdatering for DMC200:",
	"The camera's Wi-Fi_": "Kameraets wifi må være på.",
	"Check if your_": "Kontroller at kameraets wifi er på.",
	"DO NOT disconnect_": "IKKE koble fra koaksialkabelen under fastvareoppdatering.",
	"The camera and_": "Kameraet og DMC200 kan bli ødelagt.",
	"DO NOT try_": "IKKE prøv å bruke andre funksjoner før kameraet er omstartet.",
	"Expecially Reboot camera_": "Spesielt omstart av kameraet og formatering av SD-kort kan føre til at de to enhetene blir ødelagt.",
	"Update anyway": "Oppdater uansett",
	"Invited on_2": "invitert {{Invited Date}} av deg. Eier",
	"BlackVue’s New firmware_": "Ny fastvare for BlackVue er tilgjengelig",
	"valid thru_": "gyldig til: {{a}}",
	"Billed monthly": "Billed monthly",
	"90 minutes Live_": "90 minutes Live View / Live Event Upload*",
	"or 2+ videos_": "or 2+ videos in full resolution*",
	"1GB Free Month_": "1GB Free Month Trial",
	"Cancel anytime": "Cancel anytime",
	"8+ hours Live_": "8+ hours Live View / Live Event Upload*",
	"or 12+ videos_": "or 12+ videos in full resolution*",
	"15+ hours Live_": "15+ hours Live View / Live Event Upload*",
	"or 23+ videos_": "or 23+ videos in full resolution*",
	Popular: Popular$6,
	"For Power Users": "For Power Users",
	"Estimates based on_": "* Estimates based on 4.5MB per minute of Live View, Quick View remote playback, or Live Event Upload file, and 190MB per full original resolution video download or playback (at 25Mbps bitrate). Daily idle Cloud connection data usage: 20MB per 24 hours. Data usage is shared among all types of services (Live View, Live Event Upload, etc.).",
	"Balanced Plan": "Balanced Plan",
	"For Light Cloud_": "For Light Cloud Use",
	"Front security (Normal mode)": "Front sikkerhet (Normal modus)",
	"Front security (Parking mode)": "Front sikkerhet (Parkeringsmodus)",
	"BT (Parking mode)": "BT (parkeringsmodus)",
	"LTE (Parking mode)": "LTE (parkeringsmodus)",
	"Wi-Fi (Parking mode)": "Wi-Fi (Parkeringsmodus)",
	"Hand distraction": "Hånddistraksjon",
	Mask: Mask$6,
	"Second drowsy is_": "Andre varsel om trøtthet gjelder for trøtthet som oppstod innen 30 sekunder etter det første tilfellet av trøtthet, som startet direkteopptaket med opplasting.",
	"Second drowsy alert": "Andre varsel om trøtthet",
	"BlackVue sim card_": "BlackVue SIM-kort kan bare brukes i Canada og USA.",
	"Global support is coming soon.": "Global støtte kommer snart.",
	"The video file not found_": "Finner ikke videofilen, eller det oppsto et problem under avspilling. Forsøk igjen.",
	"Start Voice Call": "Start taleanrop",
	"End Voice Call": "Avslutt taleanrop",
	"Voice call in use": "Taleanrop i bruk",
	"Enable microphone access_": "Aktiver mikrofontilgang for å bruke toveis talekommunikasjon. Gå til innstillingene til nettleseren for å få tilgang til mikrofonen din.",
	"You may need to_": "Du må kanskje laste inn denne siden på nytt for at de nye innstillingene skal tre i kraft.",
	"Eye status": "Øyestatus",
	"Start time of live event upload video": "Starttidspunkt for direkteopptak med opplasting",
	"Left eye": "Venstre øye",
	"Right eye": "Høyre øye",
	"Drowsy is occured when the driver close his/her eyes more then 1sec": "Det regnes som trøtthet når sjåføren lukker øynene i mer enn 1 sekund.",
	"Driver's Left eye movements with blinking count and period": "Sjåførens bevegelse av venstre øye, med blunketelling, periodetelling og periode",
	"Driver's Right eye movements with blinking count and period": "Sjåførens bevegelse av høyre øye, med blunketelling og periode",
	"Drowsy big data of the driver and after a Drowsy event occurs": "Stordata fra sjåførens blunking etter at en trøtthetshendelse har oppstått",
	"Sharing video to Event Map": "Del video til hendelseskart",
	"Want to use a Voice call?": "Vil du bruke et taleanrop?",
	"To use a voice call_": "For å bruke et taleanrop, starter du direktevisning på nytt og klikker på «Tillat»",
	"There is no_": "Det er ingen delte videoer ennå. \nListen vises når den deles.",
	"Microphone blocked": "Mikrofon blokkert",
	"Want to center the map on your location?": "Vil du sentrere kartet på posisjonen din?",
	"To let the app access your location_": "For å la appen få tilgang til posisjonen din, start Event Map på nytt og velg \"OK\" når du blir bedt om det.",
	"Location access permission required": "Tillatelse for plassering kreves.",
	"Are you sure you want_2": "Er du sikker på at du vil fjerne denne videoen fra Event Map?",
	"Two-way voice_2": "Two-way voice communication / Voice Call",
	"Not supported by DR650GW and DR650S_": "Not supported by DR650GW and DR650S",
	"DR650S Series only_": "DR650S Series only",
	"Cancel download?": "Avbryte nedlastingen?",
	"Your download is not_": "Nedlastingen din er ikke fullført. Vil du avbryte nedlastingen?",
	"Continue download": "Fortsett nedlastingen",
	"Cancel download": "Avbryte nedlastingen",
	"Share your video to the Event Map?": "Dele din video til hendelseskart?",
	"Afterwards, according to the reaction to the video_": "Etterpå kan den, ifølge reaksjonen på videoen, klassifiseres som en populær video og introduserer populære videoer.",
	"Add hashtags and a brief description to describe your video.": "Legg til hashtag og en kort beskrivelse for å beskrive videoen din.",
	"Would you like_": "Vil du dele med hendelseskart?",
	"Successfully added video_": "Videoen er lagt til for deling på hendelseskart!",
	"This video cannot_": "Denne videoen kan ikke deles fordi den mangler GPS-posisjonsdata for å feste den på kartet.",
	"This video is_": "Denne videoen er allerede lagt til hendelseskart.",
	"Share to Event Map": "Del til hendelseskartet",
	"Describe in more_": "Beskriv mer detaljert hva som skjer i videoen din (valgfritt)",
	"Description(optional)": "Beskrivelse (valgfritt)",
	"Recording mode": "Opptaksmodus",
	"Event triggers": "Hendelsesutløsere",
	DMS: DMS$6,
	"Camera connectivity": "Kameratilkobling",
	"If not allowed_2": "Hvis det ikke er tillatt, vil ikke din bils plassering og hastighet være tilgjengelig på skyen.",
	"Share Live View_": "Del direktevist video",
	"Share Live View_2": "Del direktesendt lyd",
	"Share camera profile": "Del kameraprofil",
	"Parking impact": "Støt mens parkert",
	"Parking events": "Parking Events",
	"Audio recording": "Lydopptak",
	"Toggle the mic_": "Slå mikrofonen PÅ/AV",
	"Full HD_": "Full HD @ 60fps + Full HD @ 30fps",
	"Video quality": "Videokvalitet",
	Extreme: Extreme$6,
	"More video files": "Flere opptaksfiler",
	"Fewer video files": "Færre opptaksfiler",
	"Camera rotation": "Rotering av bakkamera",
	"Video overlay": "Videooverlegg",
	"Date & time display": "Vis Tid og dato",
	"Speed unit": "Hastighetsenhet",
	"Check the orientation_": "Kontroller retningen til frontkameraet som er installert i kjøretøyet. Velg samsvarsalternativet for å ta opp videoene i oppreist retning.",
	"Rotate 180º": "Roter 180º",
	"Rear camera rotation": "Rotering av bakkamera",
	"Check the orientation_rear": "Kontroller retningen til bakkameraet som er installert i kjøretøyet. Velg samsvarsalternativet for å ta opp videoene i oppreist retning.",
	"Mirror View": "Speilvisning",
	"Select Mirror View_": "Velg Speilvisning for å snu videoen horisontalt.",
	"Check the orientation_interior": "Kontroller retningen til det ekstra kameraet som er installert i kjøretøyet. Velg samsvarsalternativet for å ta opp videoene i oppreist retning.",
	"Display off": "Skjerm av",
	"Explore crowd-sourced Events_": "Utforsk arrangementer fra publikum (sammenstøt, hard bremsing osv.) på kartet, se videoer som er delt av fellesskapet og bidra med dine egne hendelser.",
	OFF: OFF$6,
	"Reboots once-a-day_": "Starter på nytt én gang daglig til bestemt tid hvis i parkeringsmodus for forbedret stabilitet.",
	"Set time": "Still inn tid",
	"FW language": "Fastvarespråk",
	"Rear security_2": "Baksikkerhet",
	"Bluetooth (Parking mode)_2": "Bluetooth (parkeringsmodus)",
	"Failed to save_2": "Kunne ikke lagre opplastinginnstilling for direktesending",
	"Event file will_": "Hendelsesfilen lagres automatisk i opplastingslagring for direktesending.",
	"An impact was_": "An Impact was detected during Parking Mode.",
	"When exiting Parking_": "Når du går ut av parkeringsmodus, kunngjør BlackVue-en om et sammenstøt ble oppdaget mens den var i parkeringsmodus. \n\n Merknader: \n Sammenstøt genererer hendelsesvideoer. Sammenstøt generert innen 3 minutter etter at parkeringsmodusen er avsluttet blir ignorert.",
	"Protect event files": "Beskytt hendelsesfiler",
	"Turning on this_": "Slå på for å beskytte de siste {{a}} hendelsesfilene mot overskriving av normale filer eller parkeringsopptaksfiler.",
	"Impact Events in_": "Impact Events in Normal(E) and Parking Mode(I)",
	"Manual Events_": "Manual Events (M)",
	"Once 50 Events_": "Beskyttede filer inkluderer: \n\nSammenstøthendelser i normal(E) og parkeringsmodus(I) \nManuelle hendelser (M) \n\nNår {{a}} hendelser er registrert, overskriver nye hendelser de eldste.",
	"Reckless driving unit": "Uforsvarlig kjøring",
	"Hard acceleration Event": "Hard akselerasjonshendelse",
	Threshold: Threshold$6,
	"Triggers when the_": "Utløses når kameraet oppdager en akselerasjonshastighet per sekund over den innstilte terskelverdien.",
	"Triggers when the_2": "Utløses når kameraet oppdager en hastighetsreduksjon på mer enn den innstilte terskelverdien.",
	"Hard braking Event": "Hard oppbremsing",
	"Triggers when more_": "Utløses når mer enn 60 grader detekteres innen 2 sekunder under kjøring over den innstilte terskelverdien.",
	"Every event of DMC200_2": "DMS-deteksjonsfunksjoner er bare aktive i normal modus. Hvis den er strømforsynt i parkeringsmodus, vil DMS-kameraet kun ta opp video.",
	"The DMS system has_2": "DMS kombinerer en ansiktsgjenkjenningsboks for statusene “Detektert”, “Udetektert”, “Distrahert”, “Søvnighet”, “Maske av” og en bevegelsesgjenkjenningsboks for statusen “Håndforstyrrelse”.",
	"One for face_": "One for face detection : Detected, Undetected, Distracted, Drowsy",
	"The other for_": "The other for motion detection",
	"On: Normal recording_": "On: Normal recording works while power is maintained in Parking Mode",
	"Off: DMS power_": "Off: DMS power off after 5 minutes when entering Parking Mode, Normal recording works until just before off",
	"Drowsy and Distracted_": "Drowsy and Distracted each have three sensitivity conditions.",
	"Please refer to_": "Please refer to the guide interface below.",
	Drowsiness: Drowsiness$6,
	"Drowsiness occurs when_": "Døsighet oppstår når sjåføren lukker begge øynene mens de kjører i mer enn 1 sekund og gjesper i 2 sekunder.",
	"Distracted occurs when_": "Oppstår når sjåførens hode er mer enn 50 grader unna fronten.",
	"A hand distraction_": "A hand distraction occurs when the driver removes one hand from the steering wheel. [*Smoking and phone calls may be suspected.]",
	"Mask off event_": "Mask-off event occurs in two ways. First is when the driver gets in the car without a mask. Second is when the driver takes their mask off",
	"High When the_": "High : When the driver closes their eyes for more than 1 second, it is considered drowsy driving.",
	"Middle When the_": "Medium : When the driver closes their eyes for more than 1.5 second, it is considered drowsy driving.",
	"Low When the_": "Low : When the driver closes their eyes for more than 2 second, it is considered drowsy driving.",
	"High If the_": "High : If the angle of the head is more than 50 degrees away from the front for 3 seconds, it is detected as Distracted.",
	"Middle If the_": "Medium : If the angle of the head is more than 50 degrees away from the front for 5 seconds, it is detected as Distracted.",
	"Low If the_": "Low : If the angle of the head is more than 50 degrees away from the front for 7 seconds, it is detected as Distracted.",
	Direct: Direct$6,
	"Camera Wi-Fi credentials": "Kameraets Wi-Fi-påloggingsinformasjon",
	"Network name(SSID)": "Nettverksnavn (SSID)",
	"Seamless pairing": "Seamless Pairing",
	Remote: Remote$6,
	"Hotspot settings": "Aktiveringspunktinnstilling",
	"Hotspot name": "Navn på tilkoblingspunkt (SSID)",
	"Hotspot name must_": "Hotspot name must be at least 5 characters long",
	"Public cameras may_": "Offentlige kameraer kan vises på Utforsk-fanen eller på verdenskartet.",
	"Hard Cornering Event": "Hard kurvekjøring",
	"Over speed_2": "Over hastighet",
	"Second drawiness alert": "Andre døsighetsalarm",
	"Low Voltage Warning_2": "Hånddistrahering",
	"(You)_2": "{{a}} ( Deg )",
	"This video has been reported_": "Denne videoen har blitt rapportert og er fjernet av administrator.",
	"Normal Mode recording": "Normal modusopptak",
	"ON : the camera_": "PÅ: kameraet tar opp kontinuerlig i en sløyfe.",
	"OFF : the camera_": "AV : kameraet tar kun opp hendelsesvideoer mens du kjører.",
	"In both modes_": "I begge moduser utløses hendelsesvideoopptak av detekterte sammenstøt.",
	"Continuously records_": "Tar kontinuerlig opp 1 bilde per sekund 1 minutts videoer som dekker 30 minutter med handling.",
	"Choose detection regions_": "Velg deteksjonsområder manuelt for å redusere risikoen for feilaktig utløste bevegelsesopptak grunnet trær som svaier i vinden, objekter som beveger seg i det fjerne osv.",
	"Your previous plan is expired.": "Den forrige planen din er utløpt.",
	"Upgrade the plan to restore the camera": "Oppgrader planen for å gjenopprette kameraet\n(%@)",
	"Remove from cloud": "Fjern fra sky",
	"Are you sure you want to Remove_": "Vil du virkelig fjerne dette fra skysporet?",
	"Remove: It doesn’t mean_": "Fjerne: Det betyr ikke å slette kameraets data, men å lage et ekstra spor for antall skykameraer.",
	"Now the camera is removed from cloud slot": "Kameraet ble fjernet fra skysporet.",
	"How to delete camera list": "Slik slettes et kamera fra listen",
	Update: Update$6,
	"Camrea setting": "Kamerainnstilling",
	"Notification setting": "Innstillinger for push-varsler",
	"Driving reports": "Kjørerapport",
	"Cloud connection steps": "Trinn for skytilkobling",
	"Download the BlackVue app to add a camera": "Last ned BlackVue-appen for å legge til et kamera",
	"To see your camera in the BlackVue cloud viewer_": "For å se kameraet ditt i BlackVue Cloud-visning, må du først koble det til skyen. Enkelt oppsett og tilkobling av BlackVue-kameraet til skyen med BlackVue-appen for iOS og Android.",
	"Download the BlackVue app to see a Wi-Fi connected camera": "Last ned BlackVue-appen for å se et Wi-Fi-tilkoblet kamera",
	"BlackVue Cloud web viewer only supports_": "BlackVue Cloud-visning for nett støtter bare skytilkoblet dashcam. Last ned BlackVue-appen for å se ditt Wi-Fi-tilkoblede dashcam.",
	"You can restore the data if_": "Du kan gjenopprette dataene hvis du registrerer dette kameraet til samme konto igjen, men hvis kontoen er slettet vil alle filene dine gå tapt.",
	"How to add camera": "Hvordan legge til kamera",
	"Try to wait 2-3 minutes if you just registered the camera.": "Prøv å vente 2–3 minutter hvis du nettopp har registrert kameraet.",
	"Try to check the Cloud Connection Settings again_": "Prøv å sjekke skytilkoblingsinnstillingene igjen, hvis kameraet fortsatt ikke kobler til skyen.",
	"Motion Detection": "Bevegelsesdeteksjon",
	"Parking recordings occur_": "Parkeringsopptak skjer når synlig bevegelse oppdages.",
	"Motion Sensitivity": "Bevegelsesfølsomhet",
	"Motion Detection Sensitivity": "Følsomhet for bevegelsesdeteksjon",
	"Select Detection Region": "Velg oppdagelsesregion",
	"Speed alert_2": "Hastighetsvarsel",
	"Live Event Upload_2": "Live Event Upload",
	"Beep Alert": "Pip-varsel",
	"Parking Impact History_": "Historikkvarsel for parkeringssammenstøt",
	"To register your_": "For å registrere SOS-knappen din, må du bruke BlackVue-appen.",
	"SOS button on/off": "SOS-knappstatus",
	"File sharing to Event Map is_": "Fildeling til hendelseskart er for øyeblikket ikke tilgjengelig. Kom tilbake senere.",
	"Email Notifications": "E-postvarslinger",
	"Push Notifications_2": "Push-varsler",
	"Optional Camera Rotation": "Alternativ kameraretning",
	"Optional Camera Security": "Alternativ kamerasikkerhet",
	Option: Option$6,
	"(Owner)": "{{a}} (Eier)",
	"SOS button": "SOS-knapp",
	"This video has been reported_bold": "Denne videoen har blitt rapportert og er <b>fjernet av administrator.</b>",
	"Number of events_2": "Antall hendelser",
	"My Shared Videos": "Mine delte videoer",
	"No Hashtags": "Ingen hashtag",
	"I have read and agree_": "Jeg har lest og samtykker i vilkårene",
	"14 years old_": "14 år eller eldre",
	Required: Required$6,
	Optional: Optional$6,
	"Profile information_": "Profilinformasjon kan redigeres på Kontoinnstillinger-siden.",
	"Automatically Add Live_": "Automatisk deling av automatisk hendelsesopplasting av filer til Hendelseskart",
	"You must be 14 years_": "Du må være 14 år eller eldre for å opprette en BlackVue-konto",
	"Use 8 or more characters_": "Bruk 8 eller flere tegn med en blanding av enten bokstaver, tall eller symboler",
	"Protected files include_": "Beskyttede filer inkluderer: <br/>ㆍSammenstøthendelser i normal(E) og parkeringsmodus(I)<br/>ㆍManuelle hendelser (M) <br/><br/>Når {{a}} hendelser er registrert, overskriver nye hendelser de eldste.",
	"Protected files include": "Protected files include",
	"If you turn_": "Hvis du slår av taleveiledning, blir følgende lister slått av.",
	"Live Event Upload_success": "Opplastingsinnstillinger for direktesendinger er lagret.",
	"Video type": "Videotyper",
	"Notify the Owner": "Gi beskjed til eieren",
	"Adjusting the cut-off voltage_2": "Adjusting the cut-off voltage to a lower setting may result in your dash cam draining more power from your battery. This could result in warning messages of battery drain or affect other vehicle functions.\nPlease consult with your dealership before lowering the voltage.",
	Others: Others$6,
	"This video has been removed.": "Denne videoen er fjernet.",
	"Please assign cameras_": "Tilordne kameraer til denne gruppen.",
	"Are you running_": "Går du tom for sjanse til å se avspilling?",
	"Upgrade your plan_": "Oppgrader planen din til Flåteplan for ubegrenset avspilling, og andre funksjoner eksklusive for skyen.",
	"Are you running_Liveview": "Går du tom for sjansen til å se direktesending?",
	"Upgrade your plan_Liveview": "Oppgrader planen din til Flåteplan for ubegrenset sanntidsvisning, og andre funksjoner eksklusive for skyen.",
	Stay: Stay$6,
	"Go to Fleet Plan": "Gå til Flåte-plan",
	"It looks like the video file is being prepared. please try again later.": "Det ser ut til at videofilen blir klargjort. Prøv igjen senere.",
	"Oops!": "Oops!",
	"Please back up_": "Ta sikkerhetskopi av alle viktige opptak før du endrer denne innstillingen.",
	"When you save_": "Når du lagrer innstillingene, vil microSD-kortet bli formatert og alle opptak slettes for å sikre stabil drift.",
	"This is an unregistered_": "Dette er en uregistrert e-post. Vil du gå til Opprett konto-siden?",
	"Camera name must_2": "Kameranavnet må være mellom 5 og 32 tegn.",
	"G-sensor (Normal mode)": "G-sensor (normal modus)",
	"G-sensor (Parking mode)": "G-sensor (parkeringsmodus)",
	"Up & down": "Opp og ned",
	"Front & back": "Front og bak",
	"Rotate Video 180º": "Rotate Video 180º",
	Mask_2: Mask_2$6,
	"Priority event": "Priority Event",
	"There is no_camera": "There is no camera that your owner assigned to you.",
	"Camera SSID": "Camera SSID",
	"The BlackVue dashcam_2": "The BlackVue dashcam is not compatible with 5GHz wireless networks",
	"Driver detection box_2": "Driver Detection Box",
	"DMS camera recording_2": "DMS Camera Recording in Parking Mode",
	Low_2: Low_2$6,
	Medium_2: Medium_2$6,
	High_3: High_3$6,
	"Live Event Upload_3": "Live Event Upload",
	"Driving Impact": "Driving Impact",
	"Video source_2": "Video Source",
	"Front camera_2": "Front Camera",
	"Rear camera_2": "Rear Camera",
	"Optional Camera": "Optional Camera",
	"Motion Detection_2": "Motion Detection",
	"Rear camera stops_2": "Rear camera stops recording 5 minutes after entering Parking Mode. Recording restarts when entering normal mode.",
	"Passenger vehicle": "Passenger Vehicle",
	"Heavy vehicle": "Heavy Vehicle",
	Highest_3: Highest_3$6,
	Extreme_2: Extreme_2$6,
	"Less recording files": "Fewer Recording Files",
	"Camera rotation_2": "Camera Rotation",
	"Share camera profile_2": "Share Camera Profile",
	Private_2: Private_2$6,
	"BlackVue Live": "BlackVue Live",
	"Important All saved_": "Important! All saved videos are about to be deleted. Tap Cancel and back up important files if needed.",
	"Whenever saving settings_": "Whenever saving settings after changing the time zone, the SD card is initialized and all stored files are deleted.",
	"Do you want_": "Do you want to save your changes?",
	"No groups": "No groups",
	Lite: Lite$6,
	"USD per Camera": "USD per extra Camera",
	"up to Cameras": "up to Cameras",
	"All the P Plan_": "Alle <b>{{a}}</b> Plan-funksjoner, pluss:",
	"User Roles and Permissions": "Brukerroller og tillatelser",
	"Geofence Setup (Web) and alerts": "Geofence Setup (Web) and alerts",
	"N Times": "{{a}} Ganger",
	"N Minutes": "{{a}} Minutter",
	"Emergency Alarm": "Nødalarm",
	"Playback, Live View": "Avspilling, Live View",
	"Your driving record : Daily, Monthly": "Din kjørehistorikk: Daglig, Månedlig",
	"Real-time Conversation": "Sanntids samtale",
	"Initiate a conversation_": "Start en samtale med sjåføren gjennom Dashcams høyttaler og mikrofon.",
	"Remote Voice Communication": "Ekstern stemmekommunikasjon",
	"See the last location_": "Se den siste plasseringen av kameraet ditt",
	"Check your cars_": "Sjekk bilens GPS-data i sanntid på et kart for å finne kjøretøyet og få informasjon om statusen, for eksempel om det kjører eller parkeres, og hastigheten.",
	"Supported models_": "* Støttede modeller: S og Early X Series -modeller",
	"GPS Tracking &_": "GPS -sporing og video på kart (smart/flåte)",
	"Track your cars_": "Spor bilens beliggenhet og hastighet på kartet!",
	"GPS Tracking: visualize_": "GPS -sporing: Visualiser kjøreloggen på kartet.\nVideo på kart: Se kontekstuell info (hastighet, hendelsestype) og spill relaterte videoer rett fra kartet.",
	"Visualize your cars_": "Visualiser bilens posisjon og hastighet på kartet!",
	"The feature enables_": "Denne funksjonen gjør det mulig å laste opp videoopptak til skyen, inkludert 5 sekunder før en ulykke.\n",
	"Camera profile setting": "Camera profile setting",
	"Are you running_Download": "Are you running out of chance to Download Video?",
	"Upgrade your plan_Download": "Upgrade your plan to Fleet Plan for Unlimited Download, and other Cloud -Exclusive features.",
	"This feature is available for Smart and Fleet_": "This feature is available for Smart and Fleet Plan subscribers only.",
	"Rear camera will keep_": "Bakre kamera slutter å spille inn i parkeringsmodus når temperaturstatusen til dashkameraet endres til \"Høy temperatur\". Bakre kamera vil begynne å spille inn igjen etter at temperaturstatusen til dashkameraet er endret til \"Normal temperatur\". (Advarsel: For å beskytte elektronikken kan Blackvue slå seg av på grunn av høy utetemperatur.)",
	"Get Unlimited Cloud_": "Få Ubegrenset Cloud-avspilling og administrer opptil {{a}} kameraer.",
	"Up to N cameras_": "Up to {{a}} cameras (+ {{b}} USD Extra charge)",
	"N Minutes per Day": "{{a}} minutter per dag",
	"Drowsiness sensitivity is_": "Følsomheten for trøtthet angis etter blunketid for øynene og er basert på en pålitelig BlackVue-algoritme. <br> <br> Følsomheten for distraksjon angis av vinkelen til hodet til sjåføren i forhold til frontruten, og varigheten av dette.",
	"Not available with this plan": "Not available with this plan",
	"The optional camera records_": "Det valgfrie kameraet spiller inn i parkeringsmodus",
	"Smart and Fleet_": "Smart and Fleet Plan<br/>subscribers only",
	"This feature is_smart": "This feature is available for Smart and Fleet Plan subscribers only.",
	"Camera Registration": "Kameraregistrering",
	"Voice Call": "Voice Call",
	"N times per Month": "{{a}} times per Month",
	"Recommended for higher bitrate_": "Anbefales for høyere bitrate og bedre videokvalitet.",
	"Recommended for for better compatibility_": "Anbefales for bedre kompatibilitet med stasjonære og mobile enheter",
	"A minute of front camera_": "Estimert filstørrelse for 1 minutt video (frontkamera)",
	"Extreme(N Mbps): N MB_": "Extreme ({{ex1}}Mbps) : {{ex2}}MB\nHighest ({{ht1}}Mbps) : {{ht2}}MB\nHigh ({{hi1}}Mbps) : {{hi2}}MB\nNormal ({{no1}}Mbps) : {{no2}}MB",
	"File size information reflects_": "Informasjon om filstørrelse gjenspeiler maksimal mulig størrelse og faktiske filstørrelser kan variere avhenger av registreringsforhold.",
	Bitrate: Bitrate$6,
	"Connection has been_": "Forbindelsen har gått tapt.\nGjenopprette forbindelse ...",
	"Unable to establish_": "Kan ikke etablere en forbindelse med kameraet.\nForsikre deg om at enheten din er riktig tilkoblet og prøv igjen.",
	"Purchased by Payment Service": "Kjøpt av Betalingstjeneste",
	"Up to N Cameras": "Opptil {{a}} kameraer",
	"Unlimited Live View": "Ubegrenset Live View",
	"N Days GPS Tracking": "{{a}} dagers GPS-sporing",
	"Unlimited Playback and Download": "Ubegrenset avspilling og nedlasting",
	hours: hours$6,
	"Live Event Upload or_": "Live Event Upload eller 12+ videoer i full oppløsning",
	"During the usage period of the One Plan_": "I løpet av bruksperioden til One Plan-tjenesten, er det ikke mulig å endre abonnementsplanen. For å bytte til en annen plan, vennligst kontakt BlackVue kundestøtte for å avbryte One Plan-abonnementet.",
	"Service Period (Include SIM Data)": "Tjenesteperiode (Inkluderer SIM-data)",
	"Purchase the BlackVue One Package_": "Kjøp BlackVue One-pakken for å låse opp One Plan gratis i ett år.",
	"3GB SIM Data Plan": "3GB SIM-data Plan",
	"Unlimited Live View, Playback and Download": "Ubegrenset Live View, Avspilling og Nedlasting",
	"within data availability": "innenfor datatilgjengelighet",
	"The BlackVue One Plan is a 1-year_": "BlackVue One Plan er en 1-års skytjenesteplan som er tilgjengelig eksklusivt gjennom kjøp av BlackVue One-pakken, som inneholder dashkamera, 1-års 3GB/måned datatilbud (for USA og Canada) og 1-års skytjenesteplan.",
	"The BlackVue One Package is available_": "BlackVue One-pakken er eksklusivt tilgjengelig i BlackVue nettbutikk.",
	"Go to BlackVue Shop": "Gå til BlackVue Shop",
	"Anonymous Cam": "Anonymt kamera",
	"App only": "kun i appen",
	Expires: Expires$6,
	"N days remaining": "{{a}} dager igjen",
	"No action needed_": "<b>Ingen handling nødvendig.</b> Den nye reduserte prisen vil automatisk bli brukt fra din neste betaling etter 13. september.",
	"The new reduced price_": "Den nye reduserte prisen vil automatisk gjelde for kontoen din.",
	"Smart Plan Subscriber?": "Smart Plan-abonnent?",
	"Fleet Plan Subscriber?": "Fleet Plan-abonnent?",
	"Please take a moment to_": "Vennligst ta deg et øyeblikk for å autorisere oss til å migrere kontoen din.",
	"Starting from now and_": "<b>Fra nå og frem til 31. oktober</b>, kan du la oss gjøre endringen for deg ved å <a href=\"https://form.jotform.com/232411253056041\" target=\"_blank\">klikke på denne lenken</a> og oppgi e-posten til Fleet-kontoen din. Vennligst gi oss litt tid til å behandle endringen. Alternativt vil du kunne avbryte ditt eksisterende abonnement og resubscribere til den nye prisen fra 13. september.",
	"Once activated_": "Når aktivert, kan ikke One Plan settes på pause eller deaktiveres.",
	"Once the One Plan is activated_": "Når One Plan er aktivert, kan ikke One Package refunderes.",
	"Up to N Cloud Camera Slot": "Opptil {{a}} Cloud-kameraspor",
	"nGB of Cloud Storage": "{{a}}GB sky lagringsplass",
	"Get started for free_": "Get started for free, no credit card required. Includes Alert Push Notifications, limited Remote Live View and cloud storage.",
	"The BlackVue One Plan is exclusively_": "The BlackVue One Plan is exclusively available through the purchase of a BlackVue One Package. 3GB/mo data plan is for US and Canada only. BlackVue Cloud’s Free Plan, Lite Plan (1~3) and Smart Plan (1~3) accounts can upgrade to One Plan. However, Lite Plan (4~15), Smart Plan (4~15) and Fleet Plan accounts can not be upgraded to One Plan.",
	"For N year": "For {{a}} year",
	"Included in the One Package": "Included in the One Package",
	"3GB SIM Data Plan for N year": "3GB SIM Data Plan for {{a}} year",
	"One Plan Cloud Service for N year": "One Plan Cloud Service for {{a}} year",
	"The BlackVue One Package includes_": "The BlackVue One Package includes all you need to enjoy BlackVue Cloud for a whole year!",
	"4K LTE Dash Cam_": "4K LTE Dash Cam, Cloud Service and Data Plan",
	"nGB included": "{{a}}GB included",
	"nGB per camera": "{{a}}GB per camera",
	"N Days Live Event Upload": "{{a}} Days Live Event Upload",
	"Up to N Dash Cameras": "Up to {{a}} Dash Cameras",
	"Step N/N": "Trinn {{a}}/{{b}}",
	"Cloud Connection": "Skytilkobling",
	"To pair your dashcam": "For å pare dashcamen med batteriet, vennligst koble den til skyen.",
	Check: Check$6,
	"Unpair Battery": "Koble fra batteri",
	"Are you sure you want to unpair": "Er du sikker på at du vil koble fra dette batteriet (%@) fra kameraet?",
	"Unpair: It doesn't mean": "Fjerne tilkobling: Dette betyr ikke at batteridataene slettes.",
	"*The paired battery will": "*Den tilkoblede batteriet vil også bli fjernet sammen.",
	"Would you like to pair this": "Vil du pare dette batteriet?",
	"Battery successfully paired": "Batteriet er vellykket koblet.",
	"Now you can directly connect to": "Nå kan du koble deg direkte til batteriet fra kameralisten.",
	"Pairing failed": "Parring mislyktes. Prøv igjen.",
	"Battery Name": "Batterinavn",
	"Capacity History": "Kapasitetshistorikk",
	"The graph displays capacity": "Diagram viser en omtrentlig batterinivå ved å bruke data fra skytilkoblingen.\n Batterikapasiteten kan variere avhengig av temperatur, dashbordkameraets innstillinger og frekvensen av utløsende hendelser.",
	"Last 24 Hours": "Siste 24 timer",
	"Last 7 Days": "Siste 7 dager",
	"Battery Level": "Batterinivå",
	"Temperature History": "Temperaturhistorikk",
	"The graph displays temperature": "Grafen viser en omtrentlig temperaturnivå ved hjelp av data fra skytilkoblingen.",
	"Temperature Level": "Temperaturnivå",
	"Connecting alert": "[ Kobler til ]\nData vises ved tilkobling.",
	"Low Output power Alert": "[ Avstengning av utgangsstrøm ]\nUtgangsspenningen er for lav, og begrenser strømforsyningen til den tilkoblede enheten.",
	"High temp Alert": "[ Inngangsspenning avskåret ]\nBatteritemperaturen er for høy, noe som begrenser ladingen.",
	"Remaining time": "Gjenværende tid",
	"Remaining time estimate": "Gjenstående tid er et estimat basert på den totale strømforbruket til tilkoblede enheter.\n Den beregnes på nytt hvert 30.",
	"Setting changed": "Innstilling endret",
	"Setting change failed": "Innstillingsendring mislyktes",
	"Low Input power Alert": "[ Inngangsspenning avskåret ]\nLade spenningen er for lav, og ladingen er begrenset.",
	"High Input power Alert": "[ Inngangsspenning avskåret ]\nLadningsspenningen er for høy, noe som begrenser ladingen.",
	"Low temp_Cut off Alert": "[ Inngangsspenning avskåret ]\nBatteritemperaturen er for lav, noe som begrenser lading og varighet.",
	"Low temp Alert": "[ Lav temperatur ]\nBatteritemperaturen er for lav, noe som begrenser varighetstiden og ladefarten.",
	"Low capacity Alert": "[ Lav kapasitet ]\nBatterikapasiteten er for lav.\nKjør bilen for å lade den.",
	"Back to list": "Tilbake til listen",
	Saving: Saving$6,
	Now: Now$6,
	"Power supplying is limited": "Strømforsyningen er <b>begrenset</b>",
	"This battery is already paired": "Denne batteriet er allerede koblet sammen.",
	"Connecting to Battery": "Kobler til batteri",
	"Paired battery": "Batteriet er koblet",
	"Battery unpairing failed": "Batterifjerning mislyktes. Prøv igjen.",
	"A connection is already active": "En tilkobling er allerede aktiv. Vennligst prøv igjen senere.",
	"Searching for battery": "Søker etter batteri",
	"Select battery to pair with your camera": "Velg batteri å pare med kameraet ditt.",
	"Unable to connect": "Kan ikke koble til",
	"A connection error has occurred": "Det oppstod en tilkoblingsfeil. Vennligst prøv igjen.",
	"The paired dashcam has been disconnected": "Den tilkoblede dashbordkameraet har blitt koblet fra skyen.\nVennligst sjekk nedenfor forholdene.",
	"Check if the battery is not fully discharged": "Sjekk om batteriet ikke er fullstendig utladet",
	"Check the Cloud connection of the paired dashcam": "Sjekk Cloud-tilkoblingen til det tilkoblede dashkameraet.",
	"Connection lost": "Tilkobling mistet",
	"A connection error has occurred shortly": "Det har oppstått en tilkoblingsfeil. Vennligst prøv å koble til snart.",
	"Charging is limited": "Lading er <b>begrenset</b>",
	"Cannot connect to the battery": "Kan ikke koble til batteriet.",
	"Please check the Cloud connection of the camera": "Vennligst sjekk kameraets Cloud-tilkobling.",
	"Charging complete in": "Lading fullført om %@",
	"Current Capacity": "Nåværende Kapasitet",
	"Output Voltage": "Utgangsspenning",
	"Charging Voltage": "Ladespenning",
	Beep: Beep$6,
	"Battery Capacity": "Batterikapasitet",
	"Battery connection failed": "Batteritilkobling mislyktes",
	"Expansion battery": "Reservebatteri",
	"Make sure it is switched on and within range": "• Sørg for at den er slått på og innenfor rekkevidden til mobilen din.",
	"Make sure it is not wirelessly connected to another device": "• Kontroller at den ikke er trådløst koblet til en annen enhet.",
	"Detected batteries": "Detekterte batterier",
	"Can't see your battery": "Kan du ikke se batteriet?",
	"Download the Blackvue app to check": "Last ned BlackVue-appen for å sjekke batteriet ditt eksternt",
	"By Using the app": "Ved å bruke appen, kan du pare dashbordkameraet ditt med batteriet og overvåke batteriets kapasitet over skyen. Etter at du har paret, kan du sjekke batteriet i BlackVue Cloud Viewer.",
	Unpair: Unpair$6,
	"Occurs when the driver closes_": "Oppstår når sjåføren lukker begge øynene mens han kjører",
	"Occurs when the driver's head_": "Oppstår når sjåførens hode er mer enn 50 grader vekk fra fronten.",
	"Only detects distraction above_": "Registrerer bare distraksjon over den angitte verdien. Du kan endre enheten i 'Kamerainnstillinger > Hendelsesutløsere > Uforsvarlig kjøring'.",
	"Occurs when the driver is not wearing_": "Oppstår når sjåføren ikke bruker setebelte.",
	"Overlays a face detection box_": "Overlegg en ansiktsdeteksjonsboks på direkte og opptatte opptak fra DMS-kameraet.",
	"Seat Belt": "Sikkerhetsbelte",
	Detected: Detected$6,
	"No Seat Belt": "Ingen sikkerhetsbelte",
	"Fatigue Risk Alert": "Tretthetsrisiko varsel",
	"The time is synchronized_Email": "Tiden er synkronisert med tiden i e-postvarslene dine.",
	"Sends an alert when drowsiness is_": "Sender en advarsel når søvnighet oppdages etter den første søvnigheten.",
	"Data updates upon connection": "Dataoppdateringer ved tilkobling.",
	"Sends a notification if_": "Sender et varsel hvis du overskrider 'Still inn tid' under kjøringen.",
	"Data updates Alert": "[ Kobler til ]\nDataoppdateringer ved tilkobling.",
	"Cannot save settings": "Kan ikke lagre innstillinger",
	"The time is synchronized_Push": "Tiden er synkronisert med tiden i dine Push-varsler.",
	"The file has been overwritten or deleted": "Filen er blitt skrevet over eller slettet.",
	"Box Pro Models Settings": "Box Pro-modellinnstillinger",
	"Push notifications can be configured_": "Push-varsler kan konfigureres i varslingsinnstillingene til kameraet.",
	"Recording Video": "Opptak av video",
	"Cameras settings": "Kamerainnstillinger",
	"Please configure the settings": "Vennligst konfigurer innstillingene",
	"Speed Priorities": "Fartprioriteter",
	"Set Speed Priority": "Angi fartprioritet",
	"Geofence-enter": "Geogjerde - Inngang",
	"Geofence-exit": "Geogjerde - Utgang",
	"Geofence-pass": "Geogjerde - Passere",
	"Geofence-speed alert": "Geogjerde - Hastighetsvarsel",
	"Drive Position": "Kjørestilling",
	"Left-Hand Drive": "Venstrehåndsdrift",
	"Right-Hand Drive": "Høyrehåndsdrift",
	"Please configure this setting_": "Vennligst endre denne innstillingen hvis føreren ikke blir korrekt oppdaget.",
	"A new feature in the BlackVue settings_": "En ny funksjon i BlackVue-innstillingene er lagt til for å synkronisere kameratiden. Du bør synkronisere kameratiden én gang for nøyaktig tidsregistrering.",
	"Feature location_": "Funksjonsplassering:\nKamerainnstillinger> System > Tidssynkronisering",
	"Time Sync": "Tidssynkronisering",
	"You can sync the time between_": "Du kan synkronisere tiden mellom enheten din og BlackVue-kameraet. Formatering av SD-kortet er nødvendig for synkronisering. Før du fortsetter, vennligst sikkerhetskopier nødvendige videoer.",
	"Voice Alert": "Talemelding",
	"Provides a voice alert_": "Gir en talemelding fra kameraet og sender en varsling hvis du overskrider den angitte tiden under kjøreturen.",
	"Please enter a value": "Please enter a value.",
	"Notices & Notifications": "Nyheter og varsler",
	"Only detects drowsiness above_": "Registrerer bare trøtthet over den angitte verdien. Du kan endre enheten i 'Kamerainnstillinger > Hendelsesutløsere > Uforsvarlig kjøring'.",
	Promotion: Promotion$6,
	Notice: Notice$6,
	"View More": "Se mer",
	"Read More": "Les mer",
	"Detection Box": "Deteksjonsboks",
	"Seatbelt Detection Box": "Sikkerhetsbelte Deteksjonsboks",
	"Drive Position Detection Box": "Kjøreposisjons Deteksjonsboks",
	"Fleet Subscription Promotion (50%)": "Flåteabonnementskampanje (50 %)",
	"BlackVue Fleet Tracking exclusive features_": "BlackVue Fleet Tracking eksklusive funksjoner for både avanserte brukere og bedrifter (flere brukere og kameraer, geofencing, Web Viewer osv.).",
	"Special Discount (50% off)": "Spesialrabatt (50 % rabatt)",
	"*Promotion applied for 12 months": "*Kampanje gjelder for 12 måneder",
	"*Payment will be made starting next month.": "*Betaling vil skje fra og med neste måned.",
	"[About using promotions]": "[Om bruk av kampanjer]",
	"The promotion is free for the first month_": "Kampanjen er gratis den første måneden og faktureres deretter i 12 måneder fra og med påfølgende måned.",
	"For users with an existing Lite/Smart subscription_": "For brukere med et eksisterende Lite/Smart-abonnement må du kansellere det eksisterende appabonnementet ditt separat, ellers kan det eksisterende appabonnementet belastes kontoen din.",
	"Please be sure to cancel your app subscription_": "Sørg for å si opp appabonnementet ditt innen gratisperioden. Dobbeltbetalinger vil ikke bli refundert.",
	"You will be changed to Fleet Plan immediately_": "Du vil bli endret til Fleet Plan umiddelbart, selv om den gjenværende abonnementsperioden for din eksisterende Lite/Smart Plan ikke er utløpt.",
	"You can cancel Fleet Plan any time.": "Du kan kansellere Fleet Plan når som helst.",
	"From February 2025, please go to the Fleeta service and use it.": "Når kampanjen er kansellert, vil kampanjen ikke bli brukt på nytt.",
	"After promotion expires_": "Etter at kampanjen utløper, vil du automatisk bli fornyet med eksisterende Fleet Plan-abonnementsavgift.",
	"(Required) I have read the promotion instructions_": "(Obligatorisk) Jeg har lest kampanjeinstruksjonene og godtar betaling.",
	"Upgrade to Fleet Plan immediately": "Oppgrader til Fleet Plan umiddelbart",
	"Important Notice:": "Viktig merknad:",
	"Switch of BlackVue Web Viewer to Fleeta Web Viewer": "Bytt av BlackVue Web Viewer til Fleeta Web Viewer",
	"To provide better features and quality_": "For å gi bedre funksjoner og kvalitet, vil BlackVue webvisningstjeneste snart bytte til en ny flåtewebvisningstjeneste kalt Fleeta. Fleeta-tjenester vil kun være eksklusive for Fleet Plan-brukere. Fleeta-tjenesten vil bli lansert i mars 2025, med en ny eksklusiv Fleeta-app. Gå til <a href=\"https://www.fleeta.io\" target=\"_blank\">fleeta.io</a> for å finne ut mer.",
	"We kindly ask for your understanding_": "Vi ber om forståelse, siden denne endringen er ment å levere en forbedret tjeneste. For spørsmål angående denne overgangen, vennligst kontakt vårt CS-senter.",
	"Don’t show this again for this month": "Ikke vis dette igjen denne måneden",
	"Fleet Plan Subscription Promotion": "Flåteplan-abonnementskampanje",
	"Period : December 2, 2024 ~ May 31, 2025": "Periode: 2. desember 2024 ~ 31. mai 2025",
	"See more details": "Se flere detaljer",
	"To continue improve quality and provide better service_": "For å fortsette å forbedre kvaliteten og gi bedre service, vil vår BlackVue Web Viewer-tjeneste snart bytte til en eksklusiv Fleet Plan-tjeneste. Det vil ikke lenger være tilgjengelig gratis eller gjennom andre planer fra slutten av mars 2025.",
	"We have prepared special discount offers for_": "Vi har utarbeidet spesielle rabatttilbud for våre eksisterende Web Viewer-brukere. Vennligst sjekk detaljene nedenfor! Vi ber om din forståelse og støtte når vi implementerer denne endringen for å gi en bedre service.\n",
	"*If you are subscribed in-app_": "*Hvis du abonnerer i appen, må du sørge for å kansellere abonnementet i appen.",
	"Enjoy your BlackVue Cloud service with your dashcam.": "Nyt BlackVue Cloud-tjenesten med dashcam.",
	"Available Cloud Camera slot(s)_": "Tilgjengelige skykameraspor(er): {{d}}",
	"Not eligible for the promotion.": "Ikke kvalifisert for kampanjen.",
	"You have already used_": "Du har allerede brukt denne kampanjen. Når kampanjen er kansellert, kan den ikke brukes på nytt.",
	"Go to Cameras": "Gå til Kameraer",
	"Congratulations !": "Congratulations !",
	"Fleet Plan user": "Fleet Plan user",
	"Let your BlackVue monitor_": "La din BlackVue overvåke bilen din og varsle deg om hendelser. I det øyeblikket en påvirkning oppdages, vil BlackVue sende et varsel til telefonen din, ledsaget av et øyeblikksbilde.\n",
	"Live Event Upload feature automatically_": "Live Event Upload-funksjonen laster automatisk opp videoopptak, inkludert opptak fra før ulykken, til BlackVue Cloud Storage for å holde videoene dine trygge!",
	"*Buffer time varies by model.": "*Buffertiden varierer fra modell til modell.",
	Explore: Explore$6,
	"Cloud Storage": "Cloud Storage",
	"My Cloud Cameras": "Mine skykameraer",
	"My Cloud Cameras Only": "Bare mine skykameraer",
	"BlackVue Live Camera": "BlackVue Live-kamera",
	"*For BlackVue Live Cameras_": "*For BlackVue Live-kameraer er det kun kameraer som er delt som offentlige i kamerainnstillingene som kan vises på kartet.",
	"*Share Method_": "*Delingsmetode: Kamerainnstilling>Personvern",
	"Once the promotion is canceled_": "Når kampanjen er kansellert, vil kampanjen ikke bli brukt på nytt.",
	"It will show_": "Det vil dukke opp her når de blir tilgjengelige.",
	"Deactivate Cloud": "Deaktiver Cloud",
	"Are you sure you want to deactivate_": "Er du sikker på at du vil deaktivere Cloud for dette kameraet?",
	"Deactivate : It doesn’t_": "Du kan alltid aktivere skyen når som helst. Kameraet kan slettes etter at deaktiveringen er fullført.",
	Deactivate: Deactivate$6,
	"*If you made the payment through_": "*Hvis du betalte gjennom appen, må du starte appen på nytt.",
	"Connect Dashcam Locally (Wi-Fi)": "Koble til Dashcam lokalt (Wi-Fi)",
	"Cloud Connection Setting": "Innstilling for skytilkobling",
	"Camera Profile": "Kameraprofil",
	"Camera Settings": "Kamerainnstillinger",
	"Format MicroSD Card": "Formater microSD-kort",
	"Remote Firmware Update": "Ekstern fastvareoppdatering",
	"Remove from Cloud": "Fjern fra Cloud",
	"The location may not be accurate_": "Plasseringen er kanskje ikke nøyaktig fordi kameraet ikke er koblet til skyen.",
	"The location of the camera cannot be found_": "Plasseringen til kameraet ble ikke funnet. Vennligst sjekk Cloud Connection Settings.",
	"Manage\nFLEETA Drive": "Administrer\nFLEETA Disk",
	"Cloud\nConnection": "Sky\nforbindelse",
	"Available on FLEETA App": "Tilgjengelig på FLEETA-appen",
	"Available for Cloud dashcam OR on FLEETA App.": "Tilgjengelig for sky-dashcam ELLER på FLEETA-appen.",
	"Get started with_": "Start med en gratis 1-måneders prøveperiode",
	"Experience all of_": "Opplev alle FLEETA's premiumfunksjoner gratis i løpet av din 1-måneders prøveperiode.\n\nIngen forpliktelser—avbryt når som helst",
	"Welcome to FLEETA Webviewer.": "Velkommen til FLEETA Webviewer.",
	"Let FLEETA get_": "La FLEETA bli kjent med deg",
	"Help improve your_": "Hjelp med å forbedre opplevelsen din ved å dele noen detaljer",
	"Business Industry": "Næringslivsbransje",
	"Vehicle & Cargo": "Kjøretøy & Last",
	Compliance: Compliance$6,
	"Would you like to skip?": "Vil du hoppe over?",
	"What is your business industry?": "Hvilken bransje er din virksomhet i?",
	"Transportation & Logistics": "Transport og logistikk",
	"Rental & Leasing": "Utleie og leasing",
	"Construction & Building": "Bygg og anlegg",
	"Government & Public": "Offentlig sektor",
	"Facility & Utility Management": "Anlegg- og tjenestestyring",
	Manufacturing: Manufacturing$6,
	"Retail & Wholesale": "Detaljhandel og engros",
	Emergency: Emergency$6,
	Security: Security$6,
	"How many employees do you need to manage?": "Hvor mange ansatte trenger du å administrere?",
	"How many vehicles does your company operate?": "Hvor mange kjøretøy opererer selskapet ditt?",
	"Why do you use a fleet tracking service?": "Hvorfor bruker du en flåtesporingstjeneste?",
	"Route Tracking": "Ruteoppfølging",
	"Real-time Monitoring": "Sanntidsovervåking",
	"Incident Detection & Check video": "Hendelsesdeteksjon og videokontroll",
	"Behavior Monitoring & Analysis": "Atferdsmonitorering og analyse",
	"Evaluation & Management": "Evaluering og ledelse",
	"Theft Prevention": "Tyveriforebygging",
	"Monitoring & Maintenance": "Overvåking og vedlikehold",
	"Verification & Management": "Verifisering og ledelse",
	"BlackVue App Use Only": "Kun for bruk med BlackVue-appen",
	"Your current plan allow_": "Din nåværende plan tillater bruk av BlackVue-appen. For å bruke Web Viewer, vennligst abonner på Fleet Plan (FLEETA).",
	"Learn more about the Fleet_": "Lær mer om Flåteplanen (FLEETA)",
	"Special Offer": "Spesialtilbud",
	"For a limited time_": "For en begrenset tid, nyt 50% avslag på ditt Flåteplan-abonnement.",
	"See Discount Details": "Se rabattdetaljer",
	"To subscribe to the Fleet_": "For å abonnere på Flåteplanen, vennligst kanseller ditt BlackVue-abonnement i appen først for å unngå dobbel fakturering.",
	"Skip tour": "Hopp over omvisning",
	"In the cloud_": "I sky-miljøet kan du få tilgang til avspilling, se direkte (inkludert multivisning), live GPS og rapporter, alt gjennom FLEETA Web Viewer.",
	"Cloud Storage is_": "Skylagring er stedet hvor dine opplastede videoer lagres sikkert i skyen. Last opp videoene dine for å holde dem trygge lenge.",
	"Toggle to switch_": "Veksle for å bytte Kart / Liste",
	"In List View_": "I Listevisning kan du enkelt se og håndtere grupper, medlemmer og firmwareinformasjon ved et øyekast.",
	"What is Cloud Storage?": "Hva er Skylagring?",
	"Cloud Storage Overview": "Oversikt over Skylagring",
	"Difference Between FLEETA_": "Forskjell mellom FLEETA Disk og Opplasting av live-hendelser",
	"FLEETA Drive stores_": "FLEETA Disk lagrer videoer som du har lastet opp manuelt",
	"Live Event Upload automatically_": "Opplasting av live-hendelser lagrer automatisk videoer når en hendelse oppstår.",
	"Live Event Upload videos_": "Videoer fra Opplasting av live-hendelser har en utløpsperiode. Hvis du ønsker å beholde dem lenge, flytt dem til FLEETA Disk.",
	"Note: SD Card_": "Merk: SD-kortvideoer i Avspilling",
	"Videos stored on_": "Videoer lagret på SD-kortet ditt kan nås via Avspillingsmenyen.",
	"Set your image_": "Still inn bildet ditt ved hjelp av den medfølgende rammen. Når bildet er lagret, vil det vises på kamerakortet og kartvisningsikonet.",
	"*Only jpg and_": "*Kun jpg- og png-filer støttes.",
	"Set as default image": "Sett som standardbilde",
	"Camera Details": "Kameradetaljer",
	"IT & Telecommunications": "IT og telekommunikasjon",
	"The name must_32": "Navnet må være mellom 1 til 32 tegn.",
	"Unable to display the map.": "Kan ikke vise kartet.",
	"The camera location cannot be found_": "Kameraets plassering kan ikke finnes på grunn av dårlig GPS-forbindelse.",
	"Cloud Cameras": "Skykameraer",
	"Want to unlock_": "Ønsker du å låse opp funksjoner for flåtestyring?",
	"*Web subscription only": "*Kun webabonnement",
	"Uploads event_": "Laster opp hendelsesopptak til Skylagring umiddelbart når hendelsen skjer.",
	"Starts a conversation_": "Starter en samtale med sjåføren ved å bruke dashkameraets høyttaler og mikrofon.",
	"Remotely check_": "Kontroller batterinivået og statusen fjernstyrt via skyen.",
	"Receive a voice_": "Motta en talevarsling og varsler hvis kjøretiden overskrider grensen.",
	"View your_": "Se kjøreloggen din på kartet.",
	"View speed, event_": "Se hastighet, hendelsestype og spill av relaterte videoer direkte på kartet.",
	"FLEETA Tracking exclusive_": "FLEETA Tracking tilbyr eksklusive funksjoner for både avanserte brukere og bedrifter (Flere brukere og kameraer, geofencing, osv.).",
	"Cloud Cameras per Account": "Skykameraer per konto",
	"Connect Dashcam Locally_": "Koble til dashkamera lokalt (Wi-Fi) (Avspilling, Nedlasting, Se direkte)",
	"Available with_": "Tilgjengelig med BlackVue-batteri",
	"Cloud Battery": "Skybatteri",
	"Driving Reports": "Kjørerapporter",
	"Video on Map": "Video på kartet",
	"Multi Live View (Fleeta Web Viewer)": "Flere Direktevisninger (FLEETA Nettviser)",
	"Enter a number": "Skriv inn et tall",
	"Permission required.": "Tillatelse kreves.",
	"Please contact_": "Vennligst kontakt eieren for assistanse.",
	"Access not available": "Tilgang ikke tilgjengelig.",
	"This file cannot be deleted now.": "Denne filen kan ikke slettes nå.",
	"Please try again later.": "Vennligst prøv igjen senere.",
	"Permission required.\nPlease_": "Tillatelse kreves.\nVennligst kontakt eieren for assistanse.",
	"Cloud Storage is disconnected_": "Skylagring er frakoblet. Vennligst sjekk tilkoblingen.",
	"Manage the plan_": "Administrer planen for å gjenopprette kameraet",
	"Notify the owner_": "Varsle eieren om å håndtere planen",
	"Access Restricted:_": "Tilgang Begrenset: Abonnement Utløpt",
	"Access is currently_": "Tilgang er for øyeblikket ikke tilgjengelig på grunn av et utløpt abonnement.",
	"Please contact your owner_": "Vennligst kontakt din eier for å løse dette problemet.",
	"Access will be_": "Tilgangen vil bli gjenopprettet når abonnementet fornyes",
	"Cloud is disconnected_": "Skylagring er frakoblet. \nVennligst sjekk tilkoblingen.",
	"Connect to Cloud with_": "Koble til Skylagring med FLEETA APP",
	"Using Wi-Fi Hotspot": "Bruk av Wi-Fi-hotspot",
	Important: Important$6,
	"Pre-Event buffer_": "Forhåndsarrangement bufferopptak er deaktivert i denne modusen.",
	"connectivity is_": "Tilkoblingen er begrenset i denne modusen.",
	"video upload starts_": "Opplasting av video starter etter at opptaket er fullført.",
	"Power Saving": "Energisparing",
	"In all modes_": "I alle modus utløser oppdagede støt Event videoopptak.",
	"Battery Protection setting _": "Innstillingen for Batteribeskyttelse må være PÅ.",
	"At least one of_": "Minst ett av følgende innstillinger må være aktivert",
	or: or$6,
	"For BlackVue battery users": "For BlackVue batteribrukere",
	"we recommend setting_": "Vi anbefaler å sette spenningskuttet til minimumsverdien for maksimal batteribruk.",
	"No videos were found.": "Ingen videoer ble funnet.",
	"Try different filter_": "Prøv en annen filter eller tilbakestill filteret.",
	"Not avaliable with_": "Ikke tilgjengelig med gjeldende kamera",
	"Overlays a detection_": "Legger en deteksjonsboks over direkte og opptak fra DMS-kamera.",
	"A minute of_": "Ett minutt med video fra frontkameraet vil være omtrent",
	"System voice guidance": "Systemstemmeveiledning",
	"Recording trigger": "Opptakstrigger",
	"Remote Button (Optional)": "Fjernkontrollknapp (Valgfritt)",
	"Remote button settings_": "Innstillinger for fjernkontrollknapper kan ikke endres via skytilkobling. For å endre disse innstillingene, naviger til Kamera > Koble til lokalt > Kamerainnstillinger.",
	"No Registered Device": "Ingen registrerte enheter",
	"Subscription process is complete": "Abonnementsprosessen er fullført",
	"Now, go back to_": "Nå, gå tilbake til FLEETA-appen, logg inn på kontoen din, og begynn å nyte tjenesten.",
	"You can check the upload progress": "Du kan sjekke opplastingsprogresjonen i Skytjeneste > FLEETA Disk fanen.",
	"SIM card must be inserted in_": "SIM-kortet må settes inn i kameraet for å begynne å bruke Cloud.",
	"Active until:": "Aktiv til:",
	Subscribe: Subscribe$6,
	"Camera PSN": "Kamera PSN",
	"BlackVue Sim Free Trial Started!": "BlackVue Sim gratis prøveversjon startet!",
	"Enjoy a free period to use your SIM_": "Nyt en gratis periode for å bruke SIM-kortet uten abonnement!",
	"You can stay connected during the trial_": "Du kan holde kontakten under prøveperioden, men husk:",
	"Complete your subscription before the trial_": "Fullfør abonnementet før prøveperioden avsluttes for å fortsette å bruke SIM-kortet.",
	"If you don't subscribe by the end of the trial_": "Hvis du ikke abonnerer ved slutten av prøveperioden, vil SIM-tjenesten din bli deaktivert.",
	"Save Event Videos_": "Lagre hendelsesvideoer til Cloud Storage i sanntid!",
	"Note: Deleting your account doesn’t cancel": "Merk: Å slette kontoen din kansellerer ikke abonnementet ditt. For å avbestille, gå til Konto > Abonnement på FLEETA nettviseren.",
	"Available only on FLEETA App for_": "Tilgjengelig kun på FLEETA-appen for denne modellen.",
	"The cloud is deactivated": "Skyen er deaktivert.",
	"Please add a camera with FLEETA_": "Vennligst legg til et kamera med FLEETA APP for å bruke denne funksjonen.",
	"Upload videos to FLEETA_": "Last opp videoer til FLEETA Disk og hold dem trygge!",
	"You have no assigned camera_": "Du har ingen tildelt kamera.\nVennligst kontakt eieren for å be om tildeling.",
	"Camera notification settings": "Kamera varsling innstillinger",
	Vehicle: Vehicle$6,
	"App Download": "Last ned app",
	"Have a problem with_": "Har du et problem med abonnementet?",
	"Restore Purchase": "Gjenopprett kjøp",
	"Battery Pairing": "Batteriparing",
	"Playback\nLive View": "Avspilling/\nLive View",
	"Remote Playback": "Fjernavspilling",
	"Cloud connection settings": "Innstillinger for skytilkobling",
	"Go to settings": "Gå til innstillinger",
	"Only cloud cameras that_": "Kun sky-kameraer som brukerne velger å dele offentlig, vises på kartet.",
	"Live Broadcast Cameras": "Live-kringkastingskameraer",
	"*Live Broadcast Cameras_": "*Live-kringkastingskameraer er skykameraer som er satt opp til å kringkaste av brukere.",
	"Only cloud cameras_": "Kun skykameraer som brukere velger å kringkaste, vises på kartet."
};

var Dashboard$5 = "Dashboard";
var Account$5 = "Account";
var Help$5 = "Help";
var Mac$5 = "Mac";
var Windows$5 = "Windows";
var Admin$5 = "Beheerder";
var Driver$5 = "Chauffeur";
var Cameras$5 = "Camera's";
var Manage$5 = "Beheren";
var Clear$5 = "Doorzichtig";
var Show$5 = "Tonen";
var GB$5 = "{{a}}GB";
var _section$5 = "onderdeel.";
var Name$5 = "Naam";
var Password$5 = "Wachtwoord";
var Cancel$5 = "Annuleren";
var Members$5 = "Leden";
var Groups$5 = "Groepen";
var Role$5 = "Functie";
var Group$5 = "Groep";
var Status$5 = "Status";
var nPM$5 = "{{a}}VM";
var nAM$5 = "{{a}}NM";
var Newest$5 = "Nieuwste";
var Oldest$5 = "Oudste";
var Accepted$5 = "Geaccepteerd";
var Pending$5 = "In de wacht";
var Expired$5 = "Verlopen";
var All$5 = "Alle";
var Delete_$5 = "Verwijder {{a}}";
var Delete$5 = "Verwijderen";
var Rename$5 = "Naam wijzigen";
var Add$5 = "Toevoegen";
var OK$5 = "OK";
var Remove$5 = "Verwijderen";
var Files$5 = "Bestanden";
var Features$5 = "Functies";
var Settings$5 = "Instellingen";
var Upload$5 = "Uploaden";
var Privacy$5 = "Privé";
var Done$5 = "Klaar";
var Subscription$5 = "Abonnement";
var Submasters$5 = "beheerders";
var Users$5 = "chauffeurs";
var Change$5 = "Wijzigen";
var Method$5 = "Methode";
var Details$5 = "Camera-info.";
var Confirm$5 = "Bevestig";
var Address$5 = "Adres";
var Country$5 = "Land";
var State$5 = "Staat";
var ZIP$5 = "Postcode";
var Pricing$5 = "Prijsstelling";
var Free$5 = "Free";
var Smart$5 = "Smart";
var Fleet$5 = "Fleet";
var Subscrubed$5 = "Geabonneerd";
var January$5 = "januari";
var February$5 = "Feburary";
var March$5 = "maart";
var April$5 = "april";
var May$5 = "mei";
var June$5 = "juni";
var July$5 = "juli";
var August$5 = "augustus";
var September$5 = "september";
var October$5 = "oktober";
var November$5 = "november";
var December$5 = "december";
var Blackvuecloud_$5 = "www.blackvuecloud.com";
var Support$5 = "Support";
var Community$5 = "Community";
var FAQ$5 = "FAQ";
var Developers$5 = "Developers";
var Facebook$5 = "Facebook";
var Twitter$5 = "Twitter";
var Instagram$5 = "Instagram";
var Youtube$5 = "Youtube";
var Linkedin$5 = "Linkedin";
var Downloads$5 = "Downloads";
var Unauthorized$5 = "Ongeoorloofd";
var none$5 = "Geen";
var Email$5 = "E-mail";
var Customers$5 = "Customers";
var Home$5 = "Home";
var Plan$5 = "Plan";
var New$5 = "New";
var Unsubscribed$5 = "Unsubscribed";
var Edit$5 = "Edit";
var month$5 = "month";
var months$5 = "months";
var Continue$5 = "Continue";
var Back$5 = "Rug";
var Master$5 = "Owner";
var Develop$5 = "Developers";
var $9$5 = "$9";
var $15$5 = "$15";
var $10$5 = "$10";
var mo$5 = "Maand";
var City$5 = "Stad";
var Charge$5 = "In rekening brengen";
var subscribe$5 = "Abonneren";
var search$5 = "Zoeken";
var invalid_number$5 = "Het kaartnummer is geen geldig creditcardnummer";
var invalid_expiry_month$5 = "De vervalmaand van de kaart is ongeldig";
var invalid_expiry_year$5 = "Het vervaljaar van de kaart is ongeldig";
var invalid_cvc$5 = "De beveiligingscode van de kaart is ongeldig";
var incorrect_number$5 = "Het kaartnummer is onjuist";
var incomplete_number$5 = "Het kaartnummer is onvolledig";
var incomplete_cvc$5 = "De beveiligingscode van de kaart is onvolledig";
var incomplete_expiry$5 = "De vervaldatum van de kaart is onvolledig";
var expired_card$5 = "De kaart is verlopen";
var incorrect_cvc$5 = "De beveiligingscode van de kaart is niet juist";
var incorrect_zip$5 = "Validatie van de postcode van de kaart is mislukt";
var invalid_expiry_year_past$5 = "Het vervaljaar van de kaart ligt in het verleden";
var card_declined$5 = "De kaart werd geweigerd";
var missing$5 = "Er staat geen kaart op een klant die wordt belast";
var processing_error$5 = "Er is een fout opgetreden tijdens de verwerking van de kaart";
var Paypal$5 = "Paypal";
var iOS$5 = "iOS";
var Android$5 = "Android";
var Total$5 = "Totaal";
var And$5 = "en";
var Camera$5 = "Camera";
var Yes$5 = "Ja";
var No$5 = "Nee";
var News$5 = "Nieuws";
var Notifications$5 = "Meldingen";
var MPH$5 = "MPH";
var Firmware$5 = "Firmware";
var Basic$5 = "Basis";
var Resolution$5 = "Resolutie";
var Brightness$5 = "Helderheid";
var Recording$5 = "Opname";
var Highest$5 = "Hoogste";
var High$5 = "Hoog";
var Normal$5 = "Normaal";
var Sensitivity$5 = "Gevoeligheid";
var Volume$5 = "Volume";
var Close$5 = "Close";
var Cloud$5 = "Cloud";
var Public$5 = "Public";
var Front$5 = "Voorzijde";
var Rear$5 = "Achterzijde";
var Play$5 = "Afspelen";
var Stop$5 = "Stoppen";
var Pause$5 = "Pauze";
var Time$5 = "Time";
var System$5 = "Systeem";
var Event$5 = "Activiteit";
var Parking$5 = "Parkeer";
var Color$5 = "Kleur";
var Exit$5 = "Verlaten";
var Save$5 = "Opslaan";
var Impact$5 = "Botsing";
var Unlimited$5 = "Onbeperkt";
var Default$5 = "Standaard";
var Version$5 = "Versie";
var Language$5 = "Taal";
var Notification$5 = "Melding";
var Multiple$5 = "Meerdere";
var Range$5 = "Bereik";
var Download$5 = "Download";
var Manual$5 = "Handleiding";
var Satellite$5 = "Satelliet";
var Tutorials$5 = "Handleidingen";
var Filter$5 = "Filter";
var Sun$5 = "Zo";
var Mon$5 = "Ma";
var Tue$5 = "Di";
var Wed$5 = "Wo";
var Thu$5 = "Do";
var Fri$5 = "Vr";
var Sat$5 = "Za";
var Dates$5 = "Datums";
var Routes$5 = "Routes";
var Opacity$5 = "transparantie";
var Entry$5 = "Invoer-item";
var Owner$5 = "Owner";
var Undetected$5 = "onopgemerkt";
var Distracted$5 = "Afgeleid";
var Drowsy$5 = "Drowsy";
var Calling$5 = "Calling";
var Smoking$5 = "Smoking";
var Permissions$5 = "Toestemmingen";
var Private$5 = "Privé";
var Entering$5 = "Binnenkomen";
var Exiting$5 = "Verlaten";
var Acceleration$5 = "Optrekken";
var Passing$5 = "Passeren";
var Overspeed$5 = "Te hoge snelheid";
var Recipients$5 = "Ontvangers";
var Send$5 = "Verzenden";
var Note$5 = "Opmerking";
var Video$5 = "Video";
var Advanced$5 = "Geavanceerd";
var Voice$5 = "Spraak";
var Days_$5 = "Dagen";
var Mute$5 = "Geluid uit";
var UnMute$5 = "Geluid aan";
var Discard$5 = "Verwijderen";
var Report$5 = "Report";
var Individual$5 = "Individuele chauffeur op zoek naar gemoedsrust? Ondernemer op zoek naar een eenvoudige oplossing voor het beveiligen en volgen van voertuigen?";
var Subscribed$5 = "Geabonneerd";
var Geofence$5 = "Geofences";
var Driving$5 = "Rijden";
var Idling$5 = "Stationair draaien";
var Distance$5 = "Afstand";
var Parked$5 = "Parked";
var Speed$5 = "Snelheid";
var Highest_2$5 = "Hoogste";
var Average$5 = "Gemiddeld";
var Geofences$5 = "Geofencen";
var Move$5 = "Verplaatsen";
var Connected$5 = "Verbonden";
var Individual_$5 = "Individueel";
var Always$5 = "Altijd";
var Low$5 = "Laag";
var Medium$5 = "Medium";
var High_2$5 = "Hoog";
var Flip$5 = "Spiegelen";
var Previous$5 = "Vorige frame";
var Next$5 = "Volgende";
var Expand$5 = "Uitvouwen";
var Collapse$5 = "Inklappen";
var More$5 = "Meer";
var Multi$5 = "Meerdere";
var Safe$5 = "Veilig";
var Reckless$5 = "Roekeloos";
var Inattentive$5 = "Onoplettend";
var List$5 = "Lijst";
var Usage$5 = "Gebruik";
var Profile$5 = "Profiel";
var Fullscreen$5 = "Volledig scherm";
var Upgrade$5 = "Upgraden";
var Management$5 = "Beheer";
var Day$5 = "Dag";
var Month$5 = "Maand";
var Later$5 = "Later";
var ICCID$5 = "ICCID";
var Resubscribe$5 = "Opnieuw abonneren";
var plan$5 = "plan";
var USD$5 = "USD";
var etc_$5 = "enz.:";
var Available$5 = "Beschikbaar";
var Used$5 = "Verbruikt";
var Cancelled$5 = "Geannuleerd";
var Terminated$5 = "Beëindigd";
var Sort$5 = "Sorteren";
var Bonus$5 = "Bonus";
var incomplete_zip$5 = "Validatie van de postcode van de kaart is mislukt";
var Upgrades$5 = "Updates";
var OR$5 = "OF";
var Undo$5 = "Annuleren";
var Invoice$5 = "Factuur";
var data$5 = "Gegevens";
var Popular$5 = "Popular";
var Mask$5 = "Masker af";
var DMS$5 = "Bewaking van bestuurdersstatus (DMS)";
var Extreme$5 = "Extreem";
var OFF$5 = "Uit";
var Threshold$5 = "Drempelwaarde";
var Drowsiness$5 = "Slaperigheid";
var Direct$5 = "Direct";
var Remote$5 = "Op afstand";
var Update$5 = "Update";
var Option$5 = "Optie";
var Required$5 = "Vereist";
var Optional$5 = "Optioneel";
var Others$5 = "Overige";
var Stay$5 = "Blijven";
var Mask_2$5 = "Mask";
var Low_2$5 = "Low";
var Medium_2$5 = "Medium";
var High_3$5 = "High";
var Highest_3$5 = "Highest";
var Extreme_2$5 = "Extreme";
var Private_2$5 = "Private";
var Lite$5 = "Lite";
var Bitrate$5 = "Bitrate";
var hours$5 = "Uren";
var Expires$5 = "Verloopt";
var Check$5 = "Controleren";
var Saving$5 = "Opslaan";
var Now$5 = "Nu";
var Beep$5 = "Waarschuwingsgeluid";
var Unpair$5 = "Ontkoppelen";
var Detected$5 = "Gedetecteerd";
var Promotion$5 = "Promotie";
var Notice$5 = "Updates";
var Explore$5 = "Ontdekken";
var Deactivate$5 = "Deactiveren";
var Compliance$5 = "Naleving";
var Manufacturing$5 = "Productie";
var Emergency$5 = "Noodgeval";
var Security$5 = "Beveiliging";
var Important$5 = "Belangrijk";
var or$5 = "of";
var Subscribe$5 = "Abonneren";
var Vehicle$5 = "voertuig";
var nl = {
	Dashboard: Dashboard$5,
	"Payment & Subscriptions": "Betaling & Abonnementen",
	"Fleet Management": "Wagenparkbeheer",
	"Available to master": "Beschikbaar voor master",
	"Available to Fleet_": "Beschikbaar voor Wagenparkplangebruikers",
	Account: Account$5,
	"Log out": "Uitloggen",
	"© 2019 Pittasoft_": "© 2019 Pittasoft Co. Ltd",
	"Privacy policy": "Privacybeleid",
	"Terms of service": "Algemene Voorwaarden",
	Help: Help$5,
	"App store": "App store",
	"Google Play": "Google Play",
	Mac: Mac$5,
	Windows: Windows$5,
	"Free Plan": "Free Plan",
	"Basic Plan": "Basic Plan",
	"Smart Plan": "Smart Plan",
	Admin: Admin$5,
	Driver: Driver$5,
	"Period : December 3, 2024 ~ May 31, 2025": "Periode: 3 december 2024 t/m 31 mei 2025",
	Cameras: Cameras$5,
	"n of n": "{{a}} van {{b}}",
	Manage: Manage$5,
	"Upgrade Plan": "Plan upgraden",
	"Add more cameras_": "Voeg meer camera's toe, beheer uw wagenpark en nog veel meer…",
	"Usage statistics": "Gebruiksstatistieken",
	"All cameras": "Alle camera's",
	Clear: Clear$5,
	Show: Show$5,
	"Live views": "Externe liveweergave",
	"nh:nm:ns": "{{a}}h:{{b}}m:{{c}}s",
	"Video plays and_": "Video speelt af en download",
	"Space available": "Beschikbare ruimte",
	GB: GB$5,
	"n%": "{{a}}%",
	"BlackVue app for_": "BlackVue-app voor iOS en Android",
	"BlackVue viewer for_": "BlackVue-viewer voor Mac en Windows",
	"Welcome to fleet": "Welkom bij wagenpark",
	"A few things_": "Een paar dingen die u onderweg kunt verwachten:",
	"You can watch_": "U kunt video's bekijken van de camera's waaraan u bent toegewezen in de BlackVue-app of Desktop-viewer.",
	"If the master_deletes": "Als de master zijn account verwijdert, wordt ook uw account verwijderd.",
	"If the masters_Fleet": "Als het Wagenparkplanabonnement van de master verloopt, hebt u nog steeds toegang tot uw account in de alleen-lezenmodus.",
	"You have to_": "U moet een ander account registreren om een persoonlijke camera toe te voegen.",
	"The Payments &_": "De onderdelen Betalingen & Abonnementen en Wagenparkbeheer zijn alleen beschikbaar voor de master.",
	"You can manage_": "U kunt uw wagenparkgroep beheren in het",
	"_Fleet management": "Wagenparkbeheer",
	_section: _section$5,
	"The Payments_section-": "Het onderdeel Betalingen & Abonnementen is alleen beschikbaar voor de master.",
	"Youre almost there": "U bent er bijna",
	"Finish account setup": "Accountsetup voltooien",
	"Install and log_": "Installeer de BlackVue-app of Desktop-viewer en log in",
	"Download on the_": "Download van de App Store",
	"GET IT ON_": "DOWNLOAD HET VAN Google Play",
	"Download for Mac": "Download voor Mac",
	"Download for Windows": "Download voor Windows",
	"Add your camera_": "Voeg uw camera toe aan de BlackVue-app of Desktop-viewer",
	"Start managing your_": "Begin hier met het beheren van uw wagenpark en het volgen van de gebruiksstatistieken",
	"Cancelled Fleet Plan_": "Wagenparkplan geannuleerd op {{date}}",
	"The new plan_": "Het nieuwe plan wordt aan het einde van uw huidige factureringscyclus van kracht.",
	"Profile photo": "Profielfoto",
	Name: Name$5,
	"E-mail address": "E-mailadres",
	Password: Password$5,
	"Last changed_": "Laatst gewijzigd {{a}}",
	"Change password": "Wachtwoord wijzigen",
	"Delete account": "Account verwijderen",
	Cancel: Cancel$5,
	"Current password": "Huidige wachtwoord",
	"New password": "Nieuwe wachtwoord",
	"Confirm new password": "Nieuwe wachtwoord bevestigen",
	"Password changed": "Wachtwoord gewijzigd",
	"Reason for deletion_": "Reden voor verwijdering (optioneel)",
	"Account password": "Accountwachtwoord",
	Members: Members$5,
	Groups: Groups$5,
	"+ Invite member": "+ Lid uitnodigen",
	"Name, Email": "Naam, e-mail",
	Role: Role$5,
	Group: Group$5,
	"Date invited": "Datum uitgenodigd",
	Status: Status$5,
	"Group n": "Groep {{a}}",
	nPM: nPM$5,
	nAM: nAM$5,
	Newest: Newest$5,
	Oldest: Oldest$5,
	"Name, email or_": "Naam, e-mail of groep",
	Accepted: Accepted$5,
	Pending: Pending$5,
	Expired: Expired$5,
	All: All$5,
	"No results": "Geen resultaten",
	"Try different keywords": "Probeer andere trefwoorden",
	"Try changing or_": "Probeer filters te vervangen of te verwijderen",
	"Remove all filters": "Alle filters verwijderen",
	"Invite member": "Lid uitnodigen",
	"Send invite": "Uitnodiging versturen",
	"You have reached_": "U heeft de 10-submastersgrenswaarde bereikt. U kunt gebruikers blijven uitnodigen.",
	Delete_: Delete_$5,
	"Are you sure_delete": "Weet u zeker dat u dit lid en zijn/haar account wilt verwijderen?",
	Delete: Delete$5,
	Rename: Rename$5,
	"No submaster yet": "Nog geen submaster",
	"You can add_": "U kunt 1 submaster per groep toevoegen",
	"No cameras yet": "Nog geen camera's",
	"Add cameras first_": "Voeg eerst camera's toe, wijs daarna gebruikers toe",
	"Name or email": "Naam of e-mail",
	"Add submaster": "Submaster toevoegen",
	Add: Add$5,
	"Add camera": "Camera toevoegen",
	"n of n selected": "{{a}} van {{b}} geselecteerd",
	"No cameras available": "Geen camera's beschikbaar",
	"Most likely reasons_": "Meest waarschijnlijke redenen hiervoor:",
	"All cameras were_": "Alle camera's zijn aan andere groepen toegevoegd.",
	"You can remove_": "U kunt camera's uit andere groepen verwijderen en aan deze groep toevoegen.",
	"No cameras were_": "Er zijn geen camera's aan uw account toegevoegd.",
	"You can add_cameras": "U kunt camera's toevoegen in de BlackVue-app of de desktop-viewer.",
	OK: OK$5,
	"Rename group": "Groep een andere naam geven",
	"Are you sure_group": "Weet u zeker dat u deze groep wilt verwijderen?",
	"Edit Mobile app_": "Machtigingen voor Mobile app/desktop-viewer bewerken",
	Remove: Remove$5,
	"n of n users": "{{a}} van {{b}} gebruikers",
	"Youve reached the_": "U hebt de gebruikersgrenswaarde per camera bereikt",
	"Remove user": "Gebruiker verwijderen",
	"Add user": "Gebruiker toevoegen",
	"+ Add group": "+ Groep toevoegen",
	"Add group": "Groep toevoegen",
	"Group or submaster": "Groep of submaster",
	"+ Add": "+ Toevoegen",
	"of max selected": "{{a}} van max.{{b}} geselecteerd",
	"Mobile app/desktop_": "Machtigingen voor Mobiele-app/desktop-viewer",
	Files: Files$5,
	Features: Features$5,
	Settings: Settings$5,
	Upload: Upload$5,
	"Download and Playback_Cloud": "Downloaden en afspelen vanuit cloudopslag",
	"Download and Playback_SD": "Downloaden en afspelen vanaf SD-kaart",
	"Live view": "Live View",
	"Geo Fencing": "Geofencing",
	"Drive Reports": "Rijverslagen",
	"Firmware Settings": "Firmware-instellingen",
	"Push Notifications": "Push-meldingen",
	"Event Auto Upload": "Automatisch uploaden live gebeurtenis",
	Privacy: Privacy$5,
	Done: Done$5,
	"Payment method": "Betaalmethode",
	"Change payment method": "Betaalmethode wijzigen",
	Subscription: Subscription$5,
	"Space used": "Gebruikte ruimte",
	"Next billing_": "Volgende facturatie {{a}} {{b}}",
	"You manage_available": "U beheert {{a}} van {{b}} die beschikbaar zijn voor uw plan",
	Submasters: Submasters$5,
	Users: Users$5,
	Change: Change$5,
	"No transactions yet_": "U bent geabonneerd op het Gratis Plan. Nog geen transacties",
	"No transactions to_": "Geen transacties om weer te geven.<br/>Als u op zoek bent naar andere platforms (v.b. iOS, Android, PayPal) transactiegeschiedenis, dan kunt u de geschiedenis vinden op de abonnementspagina van uw eigen platform.",
	"of nGB_": "{{a}} van {{b}}GB ({{c}}%)",
	"Smart Plan users_": "SmartPlan-gebruikers kunnen het abonnement of het aantal camera's wijzigen via de mobiele BlackVue-app",
	"Transaction history": "Transactiegeschiedenis",
	"Date": "Datum",
	"Amount, USD": "Bedrag, USD",
	Method: Method$5,
	Details: Details$5,
	"iOS in-app_": "iOS in-app purchase/Android in-app purchase",
	"Change the number_": "Wijzig het aantal camera's",
	"You manage_cameras": "You manage {{a}} cameras of {{b}} available on your plan",
	"Extra cameras": "Extra camera's",
	"Total due_": "Totaal verschuldigd",
	"available on your_": "van {{a}} beschikbaar op uw abonnement",
	"Cancel Fleet Plan": "Annuleren Fleet Plan",
	"This will cancel_": "Hiermee wordt uw FleetPlan-abonnement geannuleerd. U wordt aan het einde van uw factureringscyclus gedowngrade naar het FreePlan.",
	"Reason for cancellation_": "Reden van de beëindiging (optioneel)",
	"Not now": "Niet nu",
	Confirm: Confirm$5,
	"Cardholder name": "Kaarthoudersnaam",
	"Card name": "Kaartnaam",
	"MM/YY": "MM/JJ",
	Address: Address$5,
	Country: Country$5,
	State: State$5,
	ZIP: ZIP$5,
	Pricing: Pricing$5,
	"You are subscribed_": "U bent geabonneerd op het FreePlan.",
	"With Alert Push_": "Met Alarmpushmeldingen, beperkte Liveweergave-op-afstand en cloudopslag.",
	Free: Free$5,
	Smart: Smart$5,
	Fleet: Fleet$5,
	"Get started for_": "Ga gratis aan de slag, geen creditcard nodig. \n Met Alarmpushmeldingen, beperkte Liveweergave-op-afstand en cloudopslag.",
	Subscrubed: Subscrubed$5,
	"Features included:": "Inbegrepen functies:",
	"Get unlimited Remote_": "Ontvang onbeperkte Liveweergave-op-afstand en cloudopslag en beheer tot {{a}} camera's.",
	"BlackVue Fleet Tracking_": "Exclusieve BlackVue-FleetPlan-tracking functies voor zowel power-users als bedrijven (meerdere gebruikers en camera's, geofencing, enz.)",
	"Try 1 Month Free": "Probeer het 1 maand gratis",
	"Log in": "Inloggen",
	"Remember me": "Onthoud mij",
	"Forgot password?": "Wachtwoord vergeten?",
	"Reset password": "Wachtwoord opnieuw instellen",
	"Enter email address_": "Voer het e-mailadres in dat is gebruikt tijdens de registratie en \n wij sturen u een link om uw wachtwoord te resetten.",
	"Send reset password_": "Stuur een e-mail voor het resetten van het wachtwoord",
	"Back to login": "Terug naar inloggen",
	"Check your email": "Controleer uw e-mail",
	"Weve sent an_": "We hebben een e-mail naar {{a}} gestuurd met een link om uw emailadres te bevestigen.",
	"Resend email": "Email nogmaals versturen",
	January: January$5,
	February: February$5,
	March: March$5,
	April: April$5,
	May: May$5,
	June: June$5,
	July: July$5,
	August: August$5,
	September: September$5,
	October: October$5,
	November: November$5,
	December: December$5,
	"Sign up": "Account aanmaken",
	"First name": "Voornaam",
	"Last name": "Achternaam",
	"Create a password": "Een wachtwoord creëren",
	"5 or more_": "5 of meer tekens",
	"Sign up and_": "Aanmelden en verdergaan",
	"I agree to_": "Ik ga akkoord met de %@, %@, %@ en %@.",
	"Subscribe to newsletter": "Abonneer u op de nieuwsbrief",
	"1 month free trial_": "1 maand gratis proefperiode",
	"Dont have an_": "Hebt u geen account?",
	"Thank you for_": "Hartelijk dank voor uw aanmelding bij BlackVue Cloud. Bevestig uw e-mailadres.",
	"Confirm email": "E-mail bevestigen",
	"If you didnt_": "Als u zich niet hebt aangemeld voor deze account kunt u deze e-mail negeren.",
	Blackvuecloud_: Blackvuecloud_$5,
	"invited you to_": "{{a}} heeft u uitgenodigd om u als submaster bij zijn/haar wagenpark aan te sluiten.",
	"Accept invitation": "Uitnodiging accepteren",
	"Invite expires on_": "Uitnodiging verloopt op dd mm, jj.",
	"Your Fleet Management_": "Uw bij {{a}} geregistreerde Wagenparkbeheeraccount is verwijderd door %@.",
	"If you believe_": "Als u denkt dat dit een fout is, neem dan contact op met onze klantenservice: cs@blackvue.com.",
	Support: Support$5,
	"Help center": "Helpcentrum",
	Community: Community$5,
	"Getting started": "Aan de slag",
	FAQ: FAQ$5,
	Developers: Developers$5,
	"Cloud API": "Cloud API",
	"Fleet SDK": "Fleet SDK",
	"Follow us": "Follow us",
	Facebook: Facebook$5,
	Twitter: Twitter$5,
	Instagram: Instagram$5,
	Youtube: Youtube$5,
	Linkedin: Linkedin$5,
	"BlackVue apps": "BlackVue apps",
	"Camera registraiton": "Cameraregistratie",
	"Two-way voice_": "Bi-directionele spraakcommunicatie",
	"Live GPS": "Live GPS",
	"Event live auto_": "Automatisch uploaden live gebeurtenis",
	"Event file auto_": "Activiteitenbestand auto uploaden",
	"Compatible with_": "Compatibel met DR650GW- en DR650S-modellen",
	"Not compatible with_": "Niet compatibel met DR650GW- en DR650S-modellen",
	"More cameras": "Meer camera's",
	"More users": "More users",
	"Roles and permissions": "Roles and permissions",
	"More Cloud Storage": "Meer cloudopslag",
	"Multi Live view_": "Multi Live View (Web)",
	"Longer GPS Tracking": "Longer GPS Tracking",
	"Geo Fence setup_": "Geo Fence setup (PC viewer) and alerts (PC viewer and app)",
	"Changes saved": "Wijzigingen opgeslagen",
	"Group added": "Groep toegevoegd",
	"Member added": "Lid toegevoegd",
	"Group deleted": "Groep verwijderd",
	"Member deleted": "Lid verwijderd",
	"Group renamed": "Naam van groep gewijzigd",
	"Submaster added": "Submaster toegevoegd",
	"Camera added": "Camera toegevoegd",
	"User added": "Gebruiker toegevoegd",
	"Users added": "Gebruikers toegevoegd",
	Downloads: Downloads$5,
	"The BlackVue App_": "The BlackVue App and Viewer let you use your BlackVue camera to its full potential. Whether on mobile or on home computer, BlackVue gives you the tools to fully enjoy your dashcam's functions.",
	"Compatible with all_": "Compatible with all Wi-Fi enabled BlackVue models.",
	"Supports all BlackVue_": "Supports all BlackVue models to date.",
	"confirm new password": "Nieuwe wachtwoord bevestigen",
	"Your password is_": "Het wachtwoord dat u hebt ingevoerd is onjuist",
	"Confirm password does_": "Wachtwoord komt niet overeen",
	"Please enter_email": "Voer een geldig e-mailadres in.",
	"Please enter_password": "Het wachtwoord dat u hebt ingevoerd is onjuist",
	"Internal server error_": "Interne serverfout. Probeer het nogmaals.",
	"New password is_": "Minstens 1 teken moet voor uw huidige wachtwoord anders zijn",
	"It should be_": "Het wachtwoord moet uit 5 of meer tekens bestaan",
	"Invalid permission": "Ongeldige machtiging.",
	"Input data isnt_": "Invoergegevens zijn niet beschikbaar.",
	Unauthorized: Unauthorized$5,
	"Already have subsciption": "Heb al een abonnement",
	"Already uses": "Gebruikt reeds",
	"Already logged in": "Reeds ingelogd",
	"Already sent e-mail": "Reeds e-mail verzonden.",
	"Please wait": "Even geduld a.u.b.",
	"E-mail is not_": "E-mail is nog niet geverifieerd.",
	"Update your subscription_": "Uw abonnement bijwerken",
	"Account was deleted": "Account is verwijderd.",
	"5 ~ 30_": "5 ~ 30 characters",
	"It has exceeded_": "Heeft het maximum van 9 Beheerders overschreden.",
	"Billing information": "Factureringsgegevens",
	"Please enter cardName": "Voer kaartnaam in",
	"Please enter_card": "Voer een geldig kaartnummer in",
	"Please enter address": "Voer adres in",
	"Please select country": "Selecteer land",
	"Please enter city": "Voer de plaats in",
	none: none$5,
	"Due today": "Vandaag verschuldigd",
	"Today after 1_": "Vandaag na een proefperiode van 1 maand",
	"An error occurred_": "Er is een fout opgetreden tijdens het wijzigen van het wachtwoord. Probeer het opnieuw",
	"Your account is_": "Uw account is nu actief",
	"You can now_": "U kunt nu inloggen bij uw account met het e-mailadres dat tijdens de registratie is gebruikt.",
	Email: Email$5,
	"Don’t have an account?": "Hebt u geen account?",
	"Already have an account?": "Hebt u al een account?",
	"Cloud service": "Cloud service",
	"for your BlackVue": "for your BlackVue",
	"See what your_": "See what your camera sees remotely.",
	"Receive impact alert_": "Receive Impact alert push notifications.",
	"Save footage to_": "Save footage to the cloud and do much more...",
	"Free plan included_": "Free plan included · Easy setup · Cancel anytime",
	"Taking advantage of_": "Taking advantage of a mobile or car-embedded Internet connection and a BlackVue camera, BlackVue Cloud connects you to your car from anywhere, anytime. Using the BlackVue App on your smartphone or tablet, you see in real time where your car is located and what is happening around it.",
	"Get notifications to_": "Get notifications to your phone when your parked car is hit. Check remotely what is happening around your car.",
	"Monitor your commercial_": "Monitor your commercial vehicles on a map in real time. Talk to your drivers anytime through the BlackVue App or Viewer.",
	"With BlackVue Fleet_": "With BlackVue Fleet Tracking, track in real time up to 100 vehicles from the palm of your hand or with the dedicated BlackVue Viewer.",
	"Get started now_": "Get started now with a Free plan. For unlimited video playback or Remote Live View, upgrade to Lite or Smart plan from the BlackVue App. <br/>Business and power users can unlock the power of the Fleet plan exclusively through this website.",
	"Remote Video Playback_": "Remote Video Playback and Download",
	"Compatible with DR650GW_": "Compatible with DR650GW, DR650S models",
	"Unlimited remote video_": "Unlimited remote video playback and download",
	"Longer cloud storage_": "Longer cloud storage file expiration period",
	"Longer storage period_live": "Longer storage period for Event live auto upload",
	"Longer storage period_file": "Longer storage period for Event file auto upload",
	"Goefence setup (PC_": "Geo-fence setup (PC viewer) and alerts (Windows viewer and app)",
	"App Store": "App Store",
	"Send reset password email": "Stuur een e-mail voor het resetten van het wachtwoord",
	Customers: Customers$5,
	Home: Home$5,
	"Pick a plan": "Pick a plan",
	"No customers yet": "No customers yet",
	"Customers will_": "Customers will show up here as they become available",
	"Add customer": "Add customer",
	"Report(PDF)": "Report(PDF)",
	"Subscription Period": "Subscription Period",
	Plan: Plan$5,
	New: New$5,
	Unsubscribed: Unsubscribed$5,
	"Subscription ends soon": "Subscription ends soon",
	Edit: Edit$5,
	"1 month trial": "1 month trial",
	"Edit customer details": "Edit customer details",
	"Customer name": "Customer name",
	"of 999 available_": "of 999 available on Fleet Plan",
	"Subscription starts": "Subscription starts",
	"Subscription period": "Subscription period",
	month: month$5,
	months: months$5,
	"Cloud storage": "Cloud Storage",
	"Subscription plan": "Abonnementstype",
	"Check email address": "Check email address",
	"Add customer details": "Add customer details",
	Continue: Continue$5,
	Back: Back$5,
	"An error occured": "An error occured",
	"Customer added": "Customer added",
	"Last changed": "Last changed",
	"Company name": "Company name",
	"Company address": "Company address",
	"Alert Push Notifications": "Alert Push Notifications",
	"Receive notifications on_": "Receive notifications on your phone when preset Events occur. Great in combination with BlackVue’s Parking Mode.",
	"Remote Live View": "Liveweergave op afstand",
	"Remotely monitor your_": "Remotely monitor your car in real time from anywhere, anytime.",
	"Video Backup/Auto Upload": "Video Backup/Auto Upload",
	"Back up videos_": "Back up videos to your phone or Cloud storage.",
	"Two-way Voice Communication": "Two-way Voice Communication",
	"Talk with people_": "Talk with people in the car from your smartphone. The driver can speak while keeping hands on the wheel.",
	"View your car’s_": "View your car’s location and speed on a map. With BlackVue Fleet Tracking, access 90-days’ worth of GPS data.",
	"Remote Video Playback": "Remote Video Playback",
	"Play videos stored_": "Play videos stored in the Cloud or in your dashcam anytime on your smartphone or tablet.",
	"Event Live Auto Upload": "Event Live Auto Upload",
	"Save a video stream_": "Save a video stream in real time to the Cloud. Protect yourself from break-ins and theft.",
	"Event File Auto Upload": "Event File Auto Upload",
	"Save Event videos_": "Save Event videos to the Cloud—including seconds before trigger—after they happen.",
	"Firmware-Over-the-Air (FOTA)": "Firmware-Over-the-Air (FOTA)",
	"Upgrade your dashcam’s": "Update your dashcam over the cloud",
	"When an Event_": "When an Event is created (Impact detected or manually triggered), Event Live Auto-upload lets your Cloud-compatible BlackVue save a live video stream from a camera of your choice (front or rear/interior) to the Cloud server",
	"Event File Auto-upload_": "Event File Auto-upload lets your dashcam automatically upload low-resolution versions of Event files to the Cloud.",
	Master: Master$5,
	"per Camera": "per Camera",
	"Event live auto upload_": "Event live auto upload compatible with all cloud cameras",
	"Drive report": "Drive report",
	"USA/Canada Toll Free": "USA/Canada Toll Free",
	"Monday–Saturday_": "Monday to Friday 8am-7pm / Saturday 9am-6pm (PST).",
	"Please agree to_": "You must accept Terms of Service",
	"Mac or Windows PC": "Mac or Windows PC",
	Develop: Develop$5,
	"Sign out": "Sign out",
	"Referral code": "Verwijzingscode",
	"Total after 1 month trial": "Totaal na een proefperiode van 1 maand",
	"Already Use Stripe Token": "Gebruikt reeds Stripe-penning",
	"Select period": "Selecteer periode",
	"State/Region": "Staat/regio (optioneel)",
	"ZIP/Postal": "Postcode",
	"$0.00": "$0.00",
	"$11.99": "$11.99",
	"$24.99": "$24.99",
	$9: $9$5,
	$15: $15$5,
	$10: $10$5,
	"mo + for_": "/mo + {{a}} per extra camera",
	mo: mo$5,
	"This e-mail address_": "Dit e-mailadres heeft reeds een geregistreerd account.",
	"1 month": "1 maand",
	"Limit is reset daily": "Grenswaarde wordt dagelijks gereset",
	"Limit is reset monthly": "Grenswaarde wordt maandelijks gereset",
	"Video plays and downloads": "Video speelt af en download",
	"Your master": "Your owner",
	"Youre 1 step_": "U bent één stap verwijderd van het voltooien van het Wagenparkplanabonnement",
	"Finish signing up": "Voltooi de aanmelding",
	"Enter billing information": "Factureringsgegevens invoeren",
	"Proceed to billing": "Ga verder naar facturering",
	City: City$5,
	Charge: Charge$5,
	"User already invited_": "Gebruiker al uitgenodigd door Master",
	"n% consumed": "{{a}}% gebruikt",
	"E-mail already exists": "E-mail bestaat al.",
	"Cancel your inapp_": "Annuleer uw in-appabonnement",
	"You have cancel_": "U moet uw in-appabonnement opzeggen om te upgraden naar Wagenparkplan: 1. Annuleer uw huidige abonnement in de App Store of Google Play Store. U wordt gedegradeerd naar Gratis Plan aan het einde van uw huidige factureringscyclus. Al uw gegevens blijven intact. 2. Log in bij uw blackvuecloud.com-account en upgrade naar Wagenparkplan.",
	"Edit permissions": "Machtigingen bewerken",
	"See permissions": "Machtigingen bekijken",
	"Submaster removed": "Submaster verwijderd",
	"Camera removed": "Camera verwijderd",
	"User removed": "Gebruiker verwijderd",
	"Users removed": "Gebruikers verwijderd",
	subscribe: subscribe$5,
	search: search$5,
	"permission can be_": "Machtiging kan worden ingesteld nadat de submaster de uitnodiging heeft geaccepteerd.",
	"The confirmation link_": "De bevestigingslink is niet langer geldig",
	"Possible reasons:_": "Mogelijke redenen:\n • U hebt uw e-mailadres reeds bevestigd\n • De link is verlopen of geannuleerd",
	"Failed to register_": "Registreren bij BlackVue Cloud is mislukt",
	"There was an_": "Er is een fout opgetreden tijdens het aanmeldingsproces. Als het probleem zich blijft voordoen, probeer dan opnieuw aan te melden bij BlackVue Cloud. Als u meer hulp nodig hebt, dan kunt u contact opnemen met onze klantenservice:",
	"Upgrade to Fleet_": "Upgraden naar Wagenparkplan",
	"Subscription is Canceled": "Abonnement is Geannuleerd",
	"No members yet": "Nog geen leden",
	"Please enter_group name": "Voer een geldige groepsnaam in",
	"Group Name": "Groepsnaam",
	invalid_number: invalid_number$5,
	invalid_expiry_month: invalid_expiry_month$5,
	invalid_expiry_year: invalid_expiry_year$5,
	invalid_cvc: invalid_cvc$5,
	incorrect_number: incorrect_number$5,
	incomplete_number: incomplete_number$5,
	incomplete_cvc: incomplete_cvc$5,
	incomplete_expiry: incomplete_expiry$5,
	expired_card: expired_card$5,
	incorrect_cvc: incorrect_cvc$5,
	incorrect_zip: incorrect_zip$5,
	invalid_expiry_year_past: invalid_expiry_year_past$5,
	card_declined: card_declined$5,
	missing: missing$5,
	processing_error: processing_error$5,
	"no groups yet": "Nog geen groepen",
	"groups will show_": "Groepen verschijnen hier zodra ze beschikbaar zijn",
	"Fleet members will_": "Wagenparkleden verschijnen hier zodra ze beschikbaar zijn",
	"service provider": "Serviceprovider",
	Paypal: Paypal$5,
	iOS: iOS$5,
	Android: Android$5,
	"Enter email": "Please enter a email address",
	"Enter password": "Voer wachtwoord in.",
	"Enter first name": "Voer voornaam in",
	"Enter last name": "Voer achternaam in",
	"Enter the current_": "Voer huidige wachtwoord in",
	"Enter a new_": "Voer een nieuw wachtwoord in",
	"There isnt an_": "Er is geen account gekoppeld aan dit e-mailadres",
	"Fleet Plan": "Fleet Plan",
	Total: Total$5,
	"Password you entered_": "Het wachtwoord dat u hebt ingevoerd is onjuist",
	"Incorrect email or_": "Onjuiste e-mail of wachtwoord",
	"Available to Masters": "Beschikbaar voor eigenaar",
	"Blackvue url": "https://www.blackvue.com",
	"Information We Collect_": "Informatie die we verzamelen en waarom",
	And: And$5,
	"Terms of Location-Based_": "Gebruiksvoorwaarden van op locatie gebaseerde diensten.",
	"I agree to the_": "Ik ga akkoord met de",
	"Password Reset_": "We hebben een e-mail verzonden naar {{a}} met wachtwoordreset\n -instructies.",
	"You have already_": "U bent al uitgenodigd, controleer uw e-mail.",
	"No data available_": "Geen gegevens beschikbaar in tabel",
	Camera: Camera$5,
	"You no longer_": "U hebt geen toestemming meer om de wagenparkservice te gebruiken.",
	"Please contact your_": "Neem contact op met uw Wagenparkmaster om het probleem op te lossen.",
	"You can still_": "U hebt nog steeds toegang tot uw",
	"account information": "accountgegevens.",
	"If the issue_": "Als het probleem niet is opgelost en u besluit de BlackVue Cloud-service te blijven gebruiken met het geregistreerde e-mailadres, dan moet u uw account verwijderen en opnieuw aanmelden.",
	"If the problem_": "Neem contact op met onze klantendienst als het probleem aanhoudt:",
	"Web subscription only": "Alleen webabonnement",
	"AppStore url": "https://apps.apple.com/kr",
	"We no longer_": "We verwerken geen PayPal-betalingen meer. U moet uw abonnement updaten om het aantal camera's te wijzigen: 1. Log in bij uw paypal.com-account en annuleer uw huidige Wagenparkplanabonnement om het aantal camera's te wijzigen: 2. Log in bij uw blackvuecloud.com-account en upgrade naar Wagenparkplan.",
	Yes: Yes$5,
	No: No$5,
	"Serial number": "Serienummer",
	"Cloud code": "Cloud-code",
	"Terms & Policies": "Voorwaarden & Beleidslijnen",
	News: News$5,
	Notifications: Notifications$5,
	"km/h": "km/h",
	MPH: MPH$5,
	"Baidu Maps": "Baidu Maps (alleen voor China)",
	"Google Maps": "Google Maps",
	Firmware: Firmware$5,
	Basic: Basic$5,
	"Time Zone": "Tijdzone",
	Resolution: Resolution$5,
	"Image quality": "Beeldkwaliteit",
	Brightness: Brightness$5,
	Recording: Recording$5,
	"Normal recording": "Normale opname",
	"Voice recording": "Spraakopname",
	"Video segment length": "Lengte videosegment",
	"Rear camera recording": "Opname camera achterzijde",
	Highest: Highest$5,
	High: High$5,
	Normal: Normal$5,
	"1 min": "1 min",
	"2 min": "2 min",
	"3 min": "3 min",
	Sensitivity: Sensitivity$5,
	"Motion detection": "Bewegingsdetectie",
	"Speed alert": "Snelheidsmelding",
	"Voice guidance": "Gesproken begeleiding",
	"Power on": "Aanzetten",
	"Power off": "Uitzetten",
	"Starting normal recording": "Normale opname wordt gestart",
	"Changing recording mode": "Opnamemodus wijzigen",
	"Speed alert (beep)": "Snelheidsmelding (piep)",
	"Cloud related": "Cloud-gerelateerd",
	Volume: Volume$5,
	"User text overlay": "Bedekking gebruikerstekst",
	"A-Z, a-z_": "A-Z, a-z, 0-9, :;’/\\+-_()$#\nminder dan 20 tekens.",
	"Wi-Fi auto turn off": "Wi-Fi automatisch uitzeten",
	"Login credentials": "Inloggegevens",
	"Manual recording": "Handmatige opname",
	"By sharing your_": "Door uw Live View te delen, kunt u andere gebruikers indirect de spanning en het plezier laten ervaren van rijden over de hele wereld.",
	"However, as persona_": "Echter, aangezien er persoonlijke videomateriaal kan worden verzonden, dient u extra voorzichtig te zijn bij het bepalen welke informatie u deelt.",
	"Please enter_email_2": "Gelieve een geldig e-mailadres in te geven. E -mail met enkele speciale tekens is mogelijk niet toegestaan. ex) +, &",
	"Password is incorrect": "Wachtwoord onjuist.",
	"This camera is already_": "Deze camera staat reeds geregistreerd bij een BlackVue-account.",
	"Camera name must_": "Cameranaam moet 5 tot 32 tekens bevatten.",
	"Failed to save_": "Opslaan camera-instellingen mislukt.",
	"Unallowed character detected": "Ongeoorloofd teken gedetecteerd.",
	"File(s) queued for_": "Bestand(en) in de rij om geüpload te worden naar de Cloud.",
	"Exceeded video play_": "Het afspelen van video’s & downloadlimiet overschreden.",
	"Playback Failed": "Afspelen mislukt.",
	"Exceeded your Live_": "Uw limiet voor Live View-tijd is overschreden.",
	"The camera is not_": "De camera is niet verbonden met de server.",
	"Please check the connection_": "Controleer de verbindingsstatus van de geselecteerde camera.",
	Close: Close$5,
	"Map": "Kaart",
	Cloud: Cloud$5,
	Public: Public$5,
	"Flip horizontally": "Draai horizontaal",
	Front: Front$5,
	Rear: Rear$5,
	Play: Play$5,
	Stop: Stop$5,
	Pause: Pause$5,
	"Next frame": "Volgende frame",
	"Previous frame": "Vorige frame",
	"Proximity sensor": "Nabijheidssensor",
	"Voice recording on/off": "Spraakopname aan/uit",
	"The BlackVue dashcam_": "De BlackVue dashcam is niet compatibel met 5GHz draadloze netwerken.",
	Time: Time$5,
	"Daylight saving time": "Zomertijd",
	System: System$5,
	"Incorrect camera serial_": "Onjuist serienummer camera.",
	"Lock event files": "Activiteitenbestanden vergrendelen",
	"Overwrite locked event_": "Activiteitenbestanden overschrijven indien vol",
	"Camera settings saved_": "Opslaan camera-instellingen geslaagd.",
	"Front camera": "Camera voorzijde",
	"Rear camera": "Camera achterzijde",
	Event: Event$5,
	Parking: Parking$5,
	"GPS tracking": "GPS volgen",
	"G-force detected": "G-force gedetecteerd",
	"Impact detected in_": "Botsing gedetecteerd in parkeermodus",
	"Scheduled reboot": "Gepland opnieuw opstarten",
	"Recording status": "Opname status",
	"Rear security": "Beveiliging achterzijde",
	"Time lapse": "Tijdsverloop",
	"Sync with GPS_": "Synch met GPS-tijd",
	"Overwrite locked event3_": "Overschrijf vergrendelde bestanden met nieuwe gebeurtenisbestanden wanneer het geheugen vol is",
	"Video codec": "Video-codec",
	"Tracking logs": "Logbestanden volgen",
	"Geofence alerts": "Melding van Geo-Fence",
	Color: Color$5,
	Exit: Exit$5,
	Save: Save$5,
	Impact: Impact$5,
	Unlimited: Unlimited$5,
	"Parking mode recording": "Opname in Parkeermodus",
	"Battery protection": "Batterijbescherming",
	"Cut-off timer": "Onderbrekingstimer",
	"Low voltage cut-off": "Laagspanningsonderbreking",
	"Rear camera orientation": "Oriëntatie van camera aan achterzijde",
	Default: Default$5,
	"Rotate video 180°": "Video 180° draaien",
	"Mirror video": "Video spiegelen",
	"Wi-Fi band": "Wifi-band",
	"Driving report": "Rijverslag",
	"Unsupported video codec_": "Video-codec wordt niet ondersteund (H.265).",
	"Rear camera recording_": "Opname camera achterzijde in parkeermodus",
	"Front and rear_": "Camera voor- en achterzijde nemen samen op",
	"Rear camera stops_": "Camera achterzijde stopt met opnemen 5 minuten nadat deze in parkeermodus gaat. Opname start weer bij terugkeren in normale modus.",
	"Remote firmware update": "Externe firmware-update",
	"Firmware is up-to-date": "Firmware is bijgewerkt",
	"New firmware available": "Nieuw firmware beschikbaar.",
	Version: Version$5,
	"Release date": "Publicatiedatum",
	Language: Language$5,
	"File size": "Bestandsgrootte",
	"What’s new": "Laatste nieuws",
	"Updating may take_": "Het bijwerken kan enkele minuten duren.",
	"The update process_": "Het bijwerkproces kan niet worden geannuleerd.",
	"Do not disconnect the_": "Koppel de stroomkabel niet los voordat normale opname is herstart.",
	"Downloading firmware": "Firmware wordt gedownload",
	"Once download is_": "Zodra het downloaden is voltooid, herstart de BlackVue automatisch om de nieuwe firmware toe te passen.",
	"If not allowed_": "Als dit niet is toegestaan, zijn de locatie en snelheid van uw auto niet toegankelijk via de cloud.",
	"Unable to initiate update because_": "Kan de update niet starten omdat de dashcam via directe wifi met een apparaat is verbonden.",
	Notification: Notification$5,
	Multiple: Multiple$5,
	Range: Range$5,
	"HDR night vision": "HDR-nachtzicht",
	Download: Download$5,
	"G-sensor": "G-Sensor",
	Manual: Manual$5,
	"Low voltage warning": "Waarschuwing voor lage spanning",
	Satellite: Satellite$5,
	"Data usage": "Dataverbruik",
	"Select video download quality": "Selecteer de downloadkwaliteit van de video",
	"Quick play file_": "Snel afspeelbestand (lage resolutie)",
	"Original file": "Origineel bestand",
	"You do not have permission_": "U heeft geen toestemming om deze functie uit te voeren. Neem contact op met de eigenaar van uw hoofdaccount.",
	"Interior camera recording_": "Binnencameraopname in parkeermodus",
	"Interior security": "Beveiliging binnen",
	"Interior camera rotation": "Binnencamera-rotatie",
	"Multi View": "Multiweegave",
	Tutorials: Tutorials$5,
	"Upgrade now": "Nu upgraden",
	"Members will show_": "Leden verschijnen hier zodra ze beschikbaar zijn",
	"Are you sure_delete members": "Weet u zeker dat u leden permanent wilt verwijderen?",
	"Some members may_": "Sommige leden zijn mogelijk verborgen vanwege de toegepaste filters.",
	"Invited on_": "op {{Invited Date}} door u uitgenodigd. Eigenaar",
	Filter: Filter$5,
	"Date created": "Datum gemaakt",
	"No admin yet": "Nog geen beheerder",
	"You can add_admin": "U kunt 1 beheerder per groep toevoegen",
	"Collapse all": "Alles inklappen",
	"Expand all": "Alles uitklappen",
	"Download and playback_cloud": "Downloaden en afspelen vanuit de cloudopslag",
	"Are you sure_2": "Weet u zeker dat u groep {Group name} wilt verwijderen?",
	"Are you sure_groups": "Weet u zeker dat u groepen wilt verwijderen?",
	"Add cameras first_drivers": "Voeg eerst camera's toe, wijs daarna chauffeurs toe",
	"Flip vertically": "Verticaal spiegelen",
	Sun: Sun$5,
	Mon: Mon$5,
	Tue: Tue$5,
	Wed: Wed$5,
	Thu: Thu$5,
	Fri: Fri$5,
	Sat: Sat$5,
	Dates: Dates$5,
	Routes: Routes$5,
	Opacity: Opacity$5,
	"Color and opacity": "kleur en transparantie",
	"Geofences will show_": "geofences verschijnen hier zodra ze beschikbaar zijn",
	"Start drawing a shape_": "begin met het tekenen van een vorm op de kaart",
	"Add geofence": "geofence toevoegen",
	Entry: Entry$5,
	"Show all members": "Alle leden weergeven",
	"Me and my_": "Ik en mijn auto. Verbonden",
	"add-on service for_": "extra service voor cloudcompatibele Blackvue",
	"Continue with Google": "Ga verder met Google",
	"An account with_": "Er bestaat al een account met dat e-mailadres, maar dat is niet geverifieerd. Dan voert u uw bestaande BlackVue Cloud-wachtwoord in om u in te loggen.",
	"Account does not_": "Account bestaat niet. Of probeer in te loggen met uw Apple- of Google-account.",
	"Continue with Apple": "Ga verder met Apple",
	"Get started": "Aan de slag",
	"P subscription only": "Alleen abonnement <b>{{a}}</b>",
	"+N USD for extra camera_": "+{{a}} USD for extra camera up to {{b}} Cameras",
	"Unlimited Live view": "Unlimited Live View",
	"Cameras per Account": "Cameras per Account",
	"Users per Account": "Users per Account",
	Owner: Owner$5,
	"Live View per Day": "Live View per Day",
	"Remote Video Playback_2": "Remote Video Playback and Download per Month",
	"N days": "{{a}} Days",
	"Video On Map": "Video On Map",
	Undetected: Undetected$5,
	Distracted: Distracted$5,
	Drowsy: Drowsy$5,
	"Whether on mobile_": "Whether on mobile or your computer, BlackVue gives you the tools to fully enjoy your dashcam’s functions. Download the latest <a1>firmware</a1>, <a2>mobile</a2> and <a3>desktop</a3> applications, or use <a4>BlackVue web app</a4> in your browser.",
	"Compatible with most_": "Compatible with most Wi-Fi BlackVue models. Cloud support for all Cloud-compatible dashcam models down to DR650GW Series with <b>Cloud Firmware</b>.",
	"Supports most recent BlackVue_": "Supports most recent BlackVue models and compatible with BlackVue Cloud.<br/>\nThis Viewer contains <b>two applications in one</b>: the SD Card Viewer lets you view recorded videos from your SD card and modify the settings of your BlackVue, as well as format the SD card; the <b>Cloud Viewer</b> lets you enjoy BlackVue Cloud.",
	"Contact us": "Contact us",
	"6 characters with": "6 tekens met een combinatie van letters, cijfers en symbolen",
	"Apps and more...": "Apps and more...",
	"Cameras will show_": "Cameras will show up here as they become available.",
	"Keep this page_": "Houd deze pagina open terwijl u de bevestigingscode controleert. Controleer uw spammap als u de e-mail niet in uw inbox kunt vinden.",
	"n cameras": "{{n}} camera’s",
	"n slots": "{{n}} slots",
	"Calculate your Fleet_": "Bereken de prijs van uw FleetPlan-abonnement",
	"Code you entered_": "De code die u hebt ingevoerd is onjuist/verlopen",
	Calling: Calling$5,
	Smoking: Smoking$5,
	"Smoking has been_": "Er is roken tijdens het rijden gedetecteerd.",
	"Email is already_": "E-mailadres bestaat al.",
	"Serial number and_": "Het serienummer en de cloudcode staan op uw camera",
	"Allow GPS access": "GPS-toegang toestaan",
	"Used to access_": "Wordt gebruikt om de locatie en snelheid van uw voertuig te bekijken. U kunt de GPS-instellingen later wijzigen in de privacy-instellingen van uw camera.",
	"Incorrect cloud code": "Onjuiste cloudcode",
	"An account is_": "Er is al een account geregistreerd met dit e-mailadres.",
	"Live event upload": "Live-gebeurtenis uploaden",
	Permissions: Permissions$5,
	"Assign in": "Aanmelden",
	"Are you sure_camera": "Weet je zeker dat je deze camera wilt verwijderen?",
	"Uploading videos:": "Video's downloaden:",
	"GPS location recording": "GPS-locatieregistratie",
	"When OFF, GPS_": "Wanneer UITGESCHAKELD, wordt de GPS-locatie niet geregistreerd of naar de cloudserver verzonden.",
	"As personal video_": "Aangezien persoonlijke video's kunnen worden verstuurd, moet u goed opletten welke informatie u deelt.",
	"Share location": "Locatie delen",
	Private: Private$5,
	"Used to access_2": "Wordt gebruikt om de locatie en snelheid van uw voertuig te bekijken.",
	"Share live view": "Liveweergavevideo delen",
	"Share live audio": "Liveweergave-audio delen",
	"Share camera’s name": "Dashcamnaam delen",
	"Impact detection": "Botsingdetectie",
	Entering: Entering$5,
	Exiting: Exiting$5,
	"Normal event recording": "Normale-gebeurtenisopname",
	"Harsh braking": "Hard remmen",
	Acceleration: Acceleration$5,
	"Sharp turn": "Scherpe bocht",
	"Parking event recording": "Parkeer-gebeurtenisopname",
	Passing: Passing$5,
	"Video source": "Videobron",
	Overspeed: Overspeed$5,
	"Are you sure_video": "Weet u zeker dat u deze video wilt verwijderen?",
	"Add camera to_": "Camera toevoegen aan liveweergave",
	"No routes to_": "Geen routes om weer te geven",
	"Start by adding_": "Begin met het toevoegen van datums.",
	"invite sent": "Uitnodiging verstuurd",
	Recipients: Recipients$5,
	Send: Send$5,
	"Routes selected_": "Geselecteerde routes: {{n}} van {{total}}",
	"Map service": "Kaartservice",
	"Speed units": "Snelheidseenheden",
	Note: Note$5,
	"Release notes": "Opmerkingen bij de uitgave",
	"The name must_": "De naam moet 1 tot 30 tekens bevatten.",
	Video: Video$5,
	Advanced: Advanced$5,
	"Firmware language": "Firmware-taal",
	"Wi-Fi": "Wifi",
	Voice: Voice$5,
	"Show date and_": "Datum en tijd weergeven",
	"Show speed": "Snelheid weergeven",
	"Front camera rotation": "Rotatie voorcamera",
	"Manual time settings": "Handmatige tijdinstellingen",
	"Recommended for better_": "Aanbevolen voor betere compressie, kleinere bestandsgrootte en 4K UHD.",
	"For full compatibility_": "Voor volledige compatibiliteit met oudere desktop- en mobiele apparaten.",
	"Up and down": "Omhoog en omlaag",
	"Side to side": "Van links naar rechts",
	"Front and back": "Voor en achter",
	"Detection region": "Detectiegebied",
	"Hotspot 1": "Hotspot 1",
	"Hotspot 2": "Hotspot 2",
	"Hotspot 3": "Hotspot 3",
	"Enter/exit": "Ingaan/verlaten",
	"Event recording": "Activiteitsopname",
	"Front security (Normal)": "Beveiliging voorzijde (normaal)",
	"Front security (Parking)": "Beveiliging voorzijde (parkeren)",
	"LTE (Parking)": "LTE (parkeren)",
	"Wi-Fi (Parking)": "Wifi (parkeren)",
	"Turn on at startup": "Inschakelen bij het opstarten",
	"Turn off after_": "Uitschakelen na 10 min inactiviteit",
	"Your firmware is_": "Uw firmware is up-to-date",
	"Add admin": "Beheerder toevoegen",
	"Remove All/n": "Alles verwijderen/{{a}}",
	"Are you sure_remove": "Weet u zeker dat u camera’s uit deze groep wilt verwijderen?",
	"This will cancel_2": "Hiermee wordt uw FleetPlan-abonnement geannuleerd. U wordt aan het einde van uw huidige factureringscyclus gedowngrade naar het FreePlan.",
	"You’ve reached_": "U hebt de chauffeurslimiet per camera bereikt",
	"Are you sure_remove admin": "Weet u zeker dat u beheerder {{a}}{{b}} uit deze groep wilt verwijderen?",
	"Fleet Plan · Owner": "Fleet Plan · Owner",
	"Manage cameras": "Camera's beheren",
	"Are you sure_delete zone": "Weet u zeker dat u zone \"{{zone}}\" wilt verwijderen?",
	"available on your_2": "{{a}}/{{b}} beschikbaar op uw plan",
	"The new plan_2": "Het nieuwe abonnement gaat in op het einde van uw huidige factureringscyclus ({{a}}).",
	"Canceled Fleet Plan_": "Geannuleerd FleetPlan-abonnement op {{a}}",
	"Hard braking alert (beep)": "Hard-remmenalarm (piep)",
	"Hard acceleration alert (beep)": "Snel-optrekkennalarm (piep)",
	"Hard cornering alert (beep)": "Hard-bochtomalarm (piep)",
	"SSID must be_": "SSID- moet ten minste 5 tekens lang zijn.",
	"Password must be_": "Wachtwoord moet ten minste 8 tekens lang zijn.",
	"5 to 32 characters long": "5 tot 32 tekens lang",
	"8 to 32 characters long": "8 tot 32 tekens lang",
	"Longer storage period_event": "Langere opslagperiode voor live-gebeurtenis upload",
	"Requires latest firmware_": "Dit vereist de laatste firmware. Niet compatibel met DR650S-, DR650GW-modellen",
	"After Blackvue is_": "Nadat Blackvue met de cloud is verbonden, worden de instellingen opgeslagen.",
	"This is an_": "Dit is een niet-geregistreerd e-mailadres. Wilt u een nieuwe account aanmaken?",
	"This feature is_": "Deze functie is alleen beschikbaar voor FleetPlan-abonnees.",
	"Please return to_": "Account bestaat niet. Of probeer in te loggen met uw Apple- of Google-account.",
	"Adjusting the cut-off voltage_": "Adjusting the cut-off voltage to a lower setting may result in your dash cam draining more power from your battery.\nThis could result in warning messages of battery drain or affect other vehicle functions.\nPlease consult with your dealership before lowering the voltage.",
	"Your videos will_": "Uw video's worden hier getoond zodra ze beschikbaar zijn.",
	"You drove:_": "U reed: {{distance}}, {{time}}",
	"Event count per_": "Aantal gebeurtenissen per rij-uur",
	"Are you sure_recipient": "Weet u zeker dat u deze ontvanger wilt verwijderen?",
	"(You)": "{{a}} (U)",
	"All events": "Alle gebeurtenissen",
	Days_: Days_$5,
	"Requires DMC 200_": "DMC 200 camera vereist",
	"A DMS and compatible_": "Een DMS en compatibele dashcam is vereist om dit rapport te kunnen bekijken.",
	"Notifications will show_": "Meldingen worden hier getoond zodra ze beschikbaar zijn.",
	"Try changing your_": "Probeer uw datum te wijzigen of filters te verwijderen.",
	Mute: Mute$5,
	UnMute: UnMute$5,
	"Calling and smoking_": "Bellen en roken worden alleen door DMC 200-apparaten gedetecteerd",
	"You need a DMS_": "U hebt een DMS nodig om dit rapport te kunnen bekijken.",
	"Try BlackVue Cloud": "Probeer BlackVueCloud vandaag nog",
	"Individual driver looking_": "Individuele chauffeur op zoek naar gemoedsrust? Ondernemer op zoek naar een eenvoudige oplossing voor het beveiligen en volgen van voertuigen?",
	"Whoever you are_": "Wie u ook bent, wat uw behoeften ook zijn, er is een Cloud-plan voor u!",
	"It is the account that_Driver": "Dit is het account dat uw wagenpark op BlackVueCloud heeft aangemeld na het accepteren van een e-mailuitnodiging van de eigenaar of beheerder. Een chauffeur kan worden toegewezen aan slechts één camera met de beperkte mogelijkheid om zijn of haar eigen accountprofiel te bekijken; de live-weergave en het afspelen van de aan hem of haar toegewezen camera’s.",
	"It is the account that_Admin": "Dit is het account dat uw wagenpark op BlackVueCloud heeft aangemeld na het accepteren van een e-mailuitnodiging van de eigenaar. Beheerdersaccounts kunnen de rechten krijgen die de eigenaar voor die beheerder toestaat.",
	"Video deleted": "Video verwijderd",
	"Video delete_plural": "Video’s verwijderd",
	"Driver removed from_": "Chauffeur uit groep verwijderd",
	"Admin removed from_": "Beheerder verwijderd uit groep",
	"Camera removed from_": "Camera verwijderd uit groep",
	"Are you sure_videos": "Wilt u de geselecteerde bestanden verwijderen?",
	"You have to cancel_fleet": "U moet uw in-app abonnement opzeggen om het aantal camera's te wijzigen:\n 1. Annuleer uw huidige abonnement in de App Store of Google Play Store. U wordt aan het einde van uw huidige factureringscyclus gedowngrade naar het Gratis abonnement. Al uw gegevens blijven intact.\n 2. Log in op uw blackvuecloud.com-account en upgrade naar FleetPlan-abonnement.",
	Discard: Discard$5,
	"Discard unsaved changes?": "Niet-opgeslagen wijzigingen verwijderen?",
	"Incorrect serial number": "Foutief serienummer",
	"An error occurred_again": "Er is een fout opgetreden. Probeer het nogmaals.",
	"You are subscribed_free": "U bent geabonneerd op het gratis abonnement van BlackVueCloud.",
	"When an event_": "Wanneer een gebeurtenis wordt gecreëerd (Impact gedetecteerd of handmatig getriggerd), Live-gebeurtenis upload laat uw BlackVue een live-videostream van een camera naar keuze opslaan op de Cloudserver inclusief 5 seconden vóór de gebeurtenis.",
	Report: Report$5,
	"How it work": "Hoe het werkt",
	"Cloud Camera": "Cloudcamera",
	"Internet Connection": "Internetverbinding",
	"BlackVue App/Viewer": "BlackVue App/Viewer",
	"All you need_": "Alles wat u nodig hebt is een",
	"Cloud-compatible BlackVue": "Cloud-compatible BlackVue",
	"and a cellular_": "en een mobiele-data-abonnement. Sommige modellen maken verbinding met de Cloud via een externe WiFi-hotspot. Andere modellen hebben een ingebouwde nano-simkaartlezer of ondersteuning voor een plug-in-connectiviteitsmodule.",
	"Cloud features at_": "Cloud-functies binnen handbereik",
	"Enjoy peace of_": "Geniet van uw gemoedsrust in de wetenschap dat BlackVue over uw auto waakt. Als er iets misgaat krijgt u onmiddellijk bericht van uw dashcam.",
	"Let your BlackVue_": "Laat uw BlackVue uw auto bewaken en u waarschuwen bij incidenten. Op het moment dat een aanrijding wordt gedetecteerd, stuurt uw BlackVue een melding naar uw telefoon of uw webbrowser, vergezeld van een momentopname.",
	"Check on your_": "Controleer uw auto overal met Liveweergave-op-afstand. U hebt via een webbrowser of uw telefoon toegang tot realtime videofeed van uw met de cloud verbonden dashcam en u kunt eenvoudig schakelen tussen de camera's aan de voorzijde, achterzijde of het interieur.",
	"Your BlackVue may_": "Uw BlackVue voorkomt misschien geen aanrijding waarbij de dader door rijdt, maar als het toch gebeurt, dan is de kans groot dat cruciaal videobewijs wordt vastgelegd. Blader op uw mobiele telefoon of in een webbrowser door alle video's die door uw dashcam zijn opgenomen.",
	"Worried about eating_": "Maakt u zich zorgen over het verbruik van uw data-abonnement? BlackVue's sub-streamtechnologie geeft u toegang tot extra-light versies van uw video's voor snel browsen en bekijken zonder buffer.",
	"Move files from_": "Verplaats bestanden van uw BlackVue naar de cloud. Sla een enkele video op of selecteer meerdere clips voor bulkupload. Video's die met de BlackVue-app naar uw telefoon zijn gedownload, kunt u openen en delen via het intern geheugenmenu.",
	"View your vehicle’s_": "Bekijk de locatie van uw voertuig en de rijsnelheid in realtime. Upgrade naar een SmartPlan voor toegang tot het GPS-volgsysteem van de afgelopen 7 dagen.",
	"Get more with_": "Krijg meer met SmartPlan",
	"Unlimited Remote Live_": "Onbeperkte Liveweergave-op-afstand",
	"Up to 3 dashcams_": "Tot maximaal 3 dashcams onder één enkel account",
	"Want to track_": "Wilt u een heel wagenpark volgen? Upgrade naar FleetPlan",
	"BlackVue Fleet Tracking_2": "BlackVue-wagenparktracking is een alles-in-één oplossing om uw wagenpark te beschermen en volgen. Functies en prijzen zijn flexibel aan te passen aan de behoeften van uw bedrijf.",
	"Stream real-time video_": "Onbeperkt realtime video streamen. Bitrate: 600kbps",
	"Up to 999 Dashcams": "Tot max. 999 dashcams",
	"Register up to_": "Registreer tot max. 999 dashcams per account.",
	"15GB of Cloud_": "15GB cloud-opslag",
	"15GB per additional_": "15GB per extra dashcam. Onbeperkte gebeurtenissen-auto-uploadopslag.",
	"90-days GPS_": "90-dagen GPS-trackinglogbestanden",
	"High accuracy: 15_": "Hoge nauwkeurigheid: 15 seconden, Video op een kaart, eenvoudig gegevens exporteren.",
	"Unique fleet management_": "De unieke wagenparkbeheerfuncties voegen waarde en gemak toe",
	"Create geofences and_": "Creëer geofences en ontvang realtime meldingen op uw telefoon of computer.",
	"View at a_": "Bekijk in één oogopslag de totale afgelegde afstand, de tijd van stilstand, snelheidsovertredingen, enz. in tabellen die kunnen worden afgedrukt of geëxporteerd.",
	"Multi Live View": "Multi-liveweergave",
	"Monitor up to_": "Bekijk tot 4 dashcams tegelijkertijd",
	"Benefits for you": "Uw voordelen",
	Individual: Individual$5,
	"Get notifications to_2": "Ontvang meldingen op uw telefoon wanneer uw geparkeerde auto wordt geraakt. Controleer op afstand wat er rond uw auto gebeurt. Beschikbaar op internet, mobiel, Mac en Windows.",
	"Small business owner": "Eigenaar van een klein bedrijf",
	"Monitor your commercial_2": "Monitor uw bedrijfsvoertuigen op een kaart in realtime. Praat met uw chauffeurs wanneer u maar wilt via uw browser, mobiele BlackVue-app, Mac- of Windows-viewer.",
	"Company with large_": "Bedrijf met groot wagenpark",
	"With BlackVue Fleet_2": "Met BlackVue Fleet Tracking kunt u tot 999 voertuigen in realtime volgen via uw browser, mobiele BlackVue-app, Mac- of Windows-viewer.",
	Subscribed: Subscribed$5,
	"The video was_": "De video is all eerder geüpload.",
	Geofence: Geofence$5,
	"500: Internal server error": "500: Interne serverfout",
	"404: Page not found": "404: Pagina niet gevonden",
	"Check the web address_": "Controleer het internetadres of ga terug naar de BlackVueCloud -startpagina",
	"home page": "Home page",
	"There isn’t an_": "Er is geen account gekoppeld aan dit e-mailadres",
	"You can now_password": "U kunt nu inloggen met uw nieuwe wachtwoord",
	"Are you sure_remove admin2": "Weet u zeker dat u beheerder permanent wilt verwijderen?",
	"Admin deleted": "Beheerder verwijderd",
	"Members deleted": "Leden verwijderd",
	"Are you sure_groupName": "Weet u zeker dat u groep {{a}} wilt verwijderen?",
	"Requires latest firmware": "Dit vereist de laatste firmware",
	"Selected file(s) moved_": "Geselecteerd(e) bestand(en) verplaatsen is gelukt",
	"Are you sure_remove driver2": "Weet u zeker dat u chauffeur {{a}} ({{b}}) uit deze groep wilt verwijderen?",
	"Invite sent": "Uitnodiging verzonden",
	"Safe driving": "Veilig rijden",
	"Reckless driving": "Roekeloos rijden",
	"Inattentive driving": "Onoplettend rijden",
	"Driving events trend": "Rijgebeurtenissentrend",
	"Driving details": "Gegevens van het rijden",
	Driving: Driving$5,
	Idling: Idling$5,
	Distance: Distance$5,
	"Parking sessions": "Parkeersessies",
	"Parked time": "Parked time",
	"Idle stops": "Stationair draaiend stilstaan",
	"Idle time": "Tijdsduur van stationair draaien",
	"Impact events": "Impact Events",
	Parked: Parked$5,
	Speed: Speed$5,
	"Overspeeding alerts": "Waarschuwingen snelheidsoverschrijding",
	Highest_2: Highest_2$5,
	Average: Average$5,
	Geofences: Geofences$5,
	"Entries into a_": "Binnenkomst in een zone",
	"Exits from a_": "Verlaten van een zone",
	"No data": "Geen gegevens",
	"Hard acceleration": "Optrekken",
	"Hard braking": "Hard remmen",
	"Hard cornering": "Scherpe bocht",
	"The number within the brackets_": "Het getal binnen de haakjes geeft het gemiddelde aantal gebeurtenissen per uur rijden aan. Als u minder dan een uur per dag hebt gereden, dan wordt het totale aantal gebeurtenissen getoond.",
	"Did you insert_": "Heeft u een simkaart geplaatst?",
	"Click here for_": "<a>Klik hier</a> voor meer gedetailleerde handleidingen.",
	"Back up all_": "<b>Maak een back-up van alle belangrijke opnamen voordat u deze instellingen opslaat.</b><br/>Wanneer u de instellingen opslaat, wordt de microSD-kaart opnieuw geïnitialiseerd en worden alle opnamen verwijderd om een stabiele werking te garanderen.",
	"Not connected to_": "Niet verbonden met cloud. Bepaalde functionaliteit is tijdelijk uitgeschakeld.",
	"GPS Location recording off": "GPS-locatieregistratie uit",
	"n Videos deleted": "{{count}} Video’s verwijderd",
	Move: Move$5,
	"Driver Monitoring System (DMS) will_": "Driver Monitoring System (DMS) wordt binnenkort gelanceerd.",
	"An error occured while_": "Er is een fout opgetreden toen u probeerde het aantal camera's te wijzigen. Probeer het opnieuw",
	"Reached the limit_": "Limiet bereikt: {{a}}",
	"An invitation was_": "Er is al een uitnodiging verzonden naar dit e-mailadres.",
	"To use the_": "Om de cloudfunctie te gebruiken. Plaats uw SIM-kaart.",
	"Last updated": "Laatst geüpdate {{datum}}",
	"Try changing your date": "Probeer uw datum te wijzigen.",
	"No event data_": "Geen gebeurtenisgegevens verzameld voor de geselecteerde tijd",
	"Please select another_": "Selecteer een andere dag of maand om een volledig rapport te bekijken.",
	"more than 6_": "meer dan 6 tekens vereist",
	"Sign up free": "Gratis aanmelden",
	"Cloud storage warning": "Cloudopslag waarschuwing",
	"Cloud Storage Full": "Cloudopslag vol",
	"Cloud storage usage_100": "Cloudopslaggebruik bereikte 100%. Maak wat opslagruimte vrij om live-gebeurtenisupload te kunnen gebruiken",
	"Cloud storage usage_": "Cloudopslaggebruik bereikte <b>({{a}}%)</b>. \nOrganiseer uw cloudopslag.\nLivegebeurtenis-uploadservice is niet beschikbaar als de cloudopslag vol is.",
	"Are you sure_delete_zone": "Weet u zeker dat u wilt verwijderen?",
	"Search Name or email": "Naam of e-mailadres zoeken",
	"Search group name": "Groepsnaam zoeken",
	"Please note that_": "Houd er rekening mee dat de video-opname enkele seconden wordt gepauzeerd om de nieuwe instellingen toe te passen.",
	"Currently connected Hotspot": "Huidige verbonden hotspot",
	"Enhanced night vision": "Verbeterd nachtzicht",
	"To access the_": "Update uw abonnementsplan voor toegang tot de camera.",
	"Restarting the Blackvue_": "De BlackVue wordt opnieuw opgestart om de instellingen toe te passen.",
	"Hard acceleration event_": "Er is sprake van snel-optrekken wanneer de snelheidstoename per seconde meer dan {{kmh}} km/u ({{mph}} m/u) bedraagt",
	"Hard braking event_": "Er is sprake van hard-remmen wanneer de snelheidsafname per \nseconde meer dan {{kmh}} mm/u ({{mph}} m/u) bedraagt",
	"Hard cornering event_": "Hard-bochtom treedt op wanneer meer dan 60 graden draaiing optreedt binnen 2 seconden rijden sneller dan \n{{kmh}} km/u ({{mph}} m/u)",
	"Changes you made_": "Wijzigingen die u hebt gemaakt worden mogelijk niet opgeslagen.",
	"My location": "Mijn locatie",
	"Hotspot name (SSID)": "Hotspotnaam (SSID)",
	Connected: Connected$5,
	"Camera will be rebooted_": "De camera wordt opnieuw opgestart. Wilt u nog steeds doorgaan?",
	"Restarting the BlackVue_": "BlackVue wordt opnieuw opgestart. Een ogenblik geduld.",
	"Failed to reboot_": "Camera opnieuw opstarten mislukt",
	"Bluetooth (Parking mode)": "BT (Parkeermodus)",
	"Front and interior camera_": "Voorkant- en binnencamera’s nemen samen op.",
	"Interior camera stops_": "Binnencamera stopt met opnemen na 5 min. na inschakelen parkeerstand. Het opnemen wordt hervat wanneer u naar de normale modus gaat.",
	Individual_: Individual_$5,
	"Driver detection": "Chauffeurdetectie",
	"During driving only": "Alleen tijdens het rijden",
	Always: Always$5,
	"Driver detection box": "Chauffeurdetectiebox",
	"DMS camera rotation": "DSM-camerarotatie",
	Low: Low$5,
	Medium: Medium$5,
	High_2: High_2$5,
	"Reboot Camera": "Camera opnieuw opstarten",
	"Latest events": "Laatste gebeurtenissen",
	"G-Sensor": "G-Sensor",
	"Playback speed": "Afspeelsnelheid",
	Flip: Flip$5,
	Previous: Previous$5,
	Next: Next$5,
	"Map type": "Kaarttype",
	"Zoom in": "Inzoomen",
	"Zoom out": "Uitzoomen",
	"Move to Cloud": "Ga naar de Cloud",
	"Please recognize that_": "Houd er rekening mee dat de video-opname enkele seconden wordt gepauzeerd om de instellingen toe te passen.",
	"6 characters with_": "6 tekens met een combinatie van letters, cijfers en symbolen",
	"Updating firmware": "Firmware bijwerken",
	"Overspeed event occurs_": "Te hoge snelheid-gebeurtenis treedt op wanneer de dashcam de bestuurder waarschuwt dat de snelheidslimiet werd overschreden. U kunt dit veranderen via Firmware > Systeem > Volume",
	"Enter group name": "Groepsnaam invoeren",
	"Live view failed": "Live View mislukt.",
	"Parking mode enter_": "Parkeermodus Aan/Uit",
	"Cloud connectivity": "Cloudconnectiviteit",
	Expand: Expand$5,
	Collapse: Collapse$5,
	"all day": "Hele day",
	"Driving style": "Rijstijl",
	"Driving impact": "Impact van rijden",
	More: More$5,
	"No cameras to_": "Geen camera's om toe te voegen",
	"You have added_": "U hebt alle beschikbare camera's toegevoegd.",
	Multi: Multi$5,
	"Report video": "Video melden",
	"Sexually explicit content": "Seksuele inhoud",
	"Graphic violence": "Gewelddadig of weerzinwekkend",
	"Hateful speech": "Haatdragend of beledigend",
	"Harassment or bullying": "Intimidatie of pesterijen",
	"Spam or advertisement": "Spam of reclame",
	"Infringement of my_": "Schendt mijn rechten",
	"Other reason": "Enz.",
	"Reason for reporting": "Reden voor de melding",
	"Reported videos will_": "Gemelde video's worden binnen 72 uur gecontroleerd. De video wordt pas op de gebeurteniskaart weergegeven als wordt bevestigd dat de video geschikt is om op de gebeurteniskaart te plaatsen.",
	"Touch sensor": "Aanraaksensor",
	"Motion and impact detection": "Bewegings- en botsingsdetectie",
	"Settings have been changed": "Instellingen zijn gewijzigd",
	"Start event recording (beep)": "Gebeurtenisopname starten (pieptoon)",
	"Scheduled reboots": "Geplande herstarten",
	Safe: Safe$5,
	Reckless: Reckless$5,
	Inattentive: Inattentive$5,
	"Highest(Extreme)": "Hoogst (Extreem)",
	"Public cameras": "Openbare camera's",
	List: List$5,
	Usage: Usage$5,
	"Video playbacks and downloads": "Video's afspelen en downloaden",
	"of 100 times": "van 100 keer",
	"of 10 minutes": "van 10 minuten",
	Profile: Profile$5,
	"Search geofences": "Geofences zoeken",
	"Export CSV": "CSV exporteren",
	"Exit fullscreen": "Volledig scherm afsluiten",
	Fullscreen: Fullscreen$5,
	Upgrade: Upgrade$5,
	"Email address": "E-mailadres",
	"of Unlimited": "of Onbeperkt",
	"No notifications yet": "Geen meldingen ontvangen in de afgelopen 7 dagen.",
	"No videos yet": "Nog geen video's",
	Management: Management$5,
	Day: Day$5,
	Month: Month$5,
	"Welcome to the BlackVue_": "Welkom bij de BlackVue Cloud Viewer",
	"You can access BlackVue_": "U heeft altijd en overal toegang tot BlackVue Cloud vanaf het internet!",
	"Start tour": "Rondleiding starten",
	"Map view": "Kaartweergave",
	"Check the current_": "Controleer de huidige GPS-locatie en snelheid van uw camera's en openbare camera's.",
	"Camera’s features": "Camerafuncties",
	"Take a look_": "Kijk eens naar de verschillende cloud-gerelateerde functies die BlackVue Camera te bieden heeft.",
	"Visualize your vehicle’s_": "Visualiseer de rijroute van uw voertuig na verloop van tijd.",
	"Smart plan_": "Slim-plan: 90 dagen, Vlootplan: 90 dagen",
	"Create geofences and2_": "Maak geofences en ontvang realtime meldingen.",
	"Got it": "Begrepen",
	"Manage Fleet members": "Vlootleden beheren",
	"Invite fleet members_": "Nodig vlootleden uit en wijs ze toe aan groepen.",
	"The moment the_": "Op het moment dat de camera de botsingen detecteert, worden de meldingen hier weergegeven.",
	"Geofence Setup (Web)_": "Geofence instellen (web/desktop) en waarschuwingen",
	"Original file play_": "Origineel bestand afspelen is alleen beschikbaar om te downloaden",
	"To get most_": "Om het meeste uit de BlackVue Cloud Viewer te halen, moet uw camera verbonden zijn met de cloud. Download de BlackVue-app en ervaar naadloze koppeling, van het toevoegen van camera’s tot cloud-verbinding; alles tegelijk!",
	"You haven’t driven_Today": "U heeft vandaag nog niet met uw auto gereden. Probeer met uw auto te rijden met BlackVue om uw rijverslag te controleren.",
	"You haven’t driven_Month": "U heeft deze maand nog niet met uw auto gereden. Probeer met uw auto te rijden met BlackVue om uw rijverslag te controleren.",
	"Fleet Plan only_": "Alleen vlootplan beschikbaar",
	"Overwrite locked event2_": "Overschrijf vergrendelde gebeurtenisbestanden wanneer de opslag vol is",
	"DMS’s New firmware_": "Nieuwe firmware beschikbaar voor DMS",
	"Highest speed_report": "<b>Hoogste snelheid</b>\nGrootste waarde van verzamelde snelheidsgegevens die in metereenheden verzameld zijn, te converteren naar km/u en mijl per uur\n\n<b>Gemiddelde snelheid</b>\n(afstand / gereden uren) x 3600 gemiddelde snelheid. Voorbeeld (2622 / 1208 ) x 3600 = 7814,907\nkm/u: Alleen geheel getal, \nhet radixpunt van mijl per uur is tot 2 cijfers onder het geheel getal",
	"Choose a cloud_": "Kies een cloud-verbindingsmethode",
	"You need an_": "U heeft een internetverbinding nodig om verbinding te maken met de cloud. Kies het apparaat dat u gebruikt om verbinding te maken met de cloud.",
	"BlackVue SIM card": "BlackVue-simkaart",
	"Support model_": "Ondersteunend model: DR750X-2CH LTE Plus (NA)",
	"3rd party SIM_": "Simkaart van derden",
	"Support model_SIM": "Ondersteunend model: DR750X-2CH LTE Plus, DR750-2CH LTE, CM100 LTE",
	"Wi-fi hotspot": "Wifi-hotspot",
	"Support model_Wifi": "Ondersteunend model: Alle BlackVue-modellen",
	"How to connect_": "Hoe verbinding te maken met de cloud",
	"Download BlackVue application": "Download de BlackVue-app.",
	"*If you are_": "*Als u BlackVue-simkaart gaat gebruiken voor uw cloud-verbinding, ga dan naar {{a}} {{b}}.",
	"Place your phone_": "Plaats uw telefoon in het BT-bereik van de camera. Begin uw naadloze koppeling met {{a}}.",
	"Back to camera_": "Terug naar camera lijst",
	"Upgrade for more_": "Upgrade voor meer functies!",
	"Upgrading the cloud_": "Als u het cloud-abonnement upgrade, kunt u van meer functies genieten en meerdere camera's beheren. Wilt u uw cloud-plan upgraden?",
	"Explore cloud plans": "Cloud-plannen bekijken",
	Later: Later$5,
	"Successfully subscribed": "U bent nu geabonneerd!",
	"1GB data plan": "1 GB data-abonnement",
	"First month free_": "De eerste maand gratis, <a>daarna USD 10,99 per maand</a>",
	"Next billing date": "Volgende factureringsdatum",
	"Once SIM card_": "Zodra de simkaart in het apparaat is geplaatst, kunt u meteen gebruikmaken van de BlackVue Cloud-functies.",
	"Go to SIM_": "Ga naar simbeheer",
	"Manage your BlackVue_": "Beheer uw BlackVue-simkaart hier!",
	"Recommended for BlackVue_": "Aanbevolen voor BlackVue-simhouders",
	"Connect to cloud": "Maak verbinding met de cloud",
	"Enter BlackVue SIM_": "Voer het BlackVue sim-ICCID-nummer in",
	"ICCID number is_": "Het ICCID-nummer staat op de verpakking van de simkaart. Voer de laatste 14 cijfers van het ICCID-nummer in.",
	ICCID: ICCID$5,
	"SIM information": "Siminformatie",
	"Start your free_": "Begin nu met uw gratis proefperiode",
	"SIM card activate_": "Activeringsdatum simkaart",
	"Based on the_": "Gebaseerd op de datum waarop de simkaart in het apparaat wordt geplaatst en wordt geactiveerd wanneer de stroom wordt ingeschakeld",
	"Upgrade to 3GB_": "Upgrade naar een 3 GB/5 GB-plan wanneer u maar wilt",
	"Cancel your plan_": "U kunt uw plan op elk moment opzeggen",
	"No Commitment": "Geen verbintenis",
	"Precautions for using_": "Voorzorgsmaatregelen voor het gebruik van de service",
	"After 1GB is_": "Nadat 1 GB verbruikt is, is er geen extra internet meer beschikbaar.",
	"If you have_": "Als u al een simkaart in het apparaat heeft geplaatst en deze heeft gebruikt, gaat de gratis proefperiode in op het moment dat u het apparaat gaat gebruiken.",
	"This content is_": "Deze inhoud wordt gespecificeerd in het simpakket. We ondersteunen geen compensatie voor gratis perioden die niet zijn geleverd.",
	"If you have_2": "Neem voor meer vragen contact op met het <a>CS Team</a>",
	"When OFF, connecting_": "Wanneer uitgeschakeld, is het verbinden van de camera via naadloos koppelen uitgeschakeld.",
	"1 month free": "1 maand gratis",
	"No commitment. Cancel_": "Geen verbintenis. Opzeggen kan altijd.",
	"The video has been reported_": "De video is met succes gemeld",
	"Free for 1 month": "1 maand gratis",
	"Start your free_2": "Begin uw gratis proefperiode",
	"1GB free for_": "1 GB gratis voor {{a}} dagen",
	"1GB data": "1 GB data",
	"1 month free_2": "Uw 1 maand gratis proefperiode gaat in vanaf {{a}} en is inclusief 1 GB data voor BlackVue-simkaart.",
	"Your next billing_": "Uw volgende factureringsdatum is {{a}}",
	"SIM card": "Simkaart",
	"SIM guide": "Simhandleiding",
	"SIM card list": "Simkaartlijst",
	"Add SIM card": "Simkaart toevoegen",
	"No SIM card_": "Nog geen simkaart",
	"Search SIM ICCID_": "Sim-ICCID of -naam zoeken",
	"Cloud disconnected. Failed_": "Verbinding met Cloud verbroken. Kan de video niet afspelen",
	"This sim card_": "Deze simkaart is al geregistreerd met een ander account.",
	"Incorrect BlackVue SIM_": "Onjuiste BlackVue sim-ICCID",
	"My shared videos": "Mijn gedeelde video's",
	"Number of events": "Aantal gebeurtenissen",
	"Added to Event Map": "Toegevoegd aan gebeurteniskaart",
	"Successfully added video(s)_": "Video('s) met succes toegevoegd om te delen via de gebeurteniskaart! Als u de status wilt controleren en gedeelde video's wilt beheren, ga dan naar Gebeurtenissenkaart > Mijn gedeelde video's.",
	"Already added to_": "Al toegevoegd aan de gebeurteniskaart",
	"This video(s) is already added_": "Deze video('s) is/zijn al toegevoegd aan de gebeurteniskaart! Als u de status wilt controleren en gedeelde video's wilt beheren, ga dan naar Gebeurtenissenkaart > Mijn gedeelde video's.",
	"BlackVue’s firmware is up_": "De firmware van BlackVue is up-to-date",
	"Service end": "Einde van service",
	Resubscribe: Resubscribe$5,
	"Sort ascending": "Oplopend sorteren",
	"Sort descending": "Aflopend sorteren",
	plan: plan$5,
	USD: USD$5,
	"Are you sure_Cancel": "Weet u zeker dat u uw abonnement wilt opzeggen? Houd rekening met het volgende en bevestig het hieronder.",
	"Your current SIM_": "Het huidige simkaartabonnement eindigt op {{a}} en u wordt niet langer aangerekend.",
	"After canceling your_": "Na het opzeggen van het simkaartabonnement, blijft u simdata gebruiken tot en met de einddatum van uw abonnement.",
	"You can resubscribe_": "U kunt zich binnen 1 maand nadat uw huidige abonnement is afgelopen opnieuw abonneren. Als u zich opnieuw wilt abonneren, klikt u op de knop \"Opnieuw abonneren\" in de simkaartlijst bij {{a}} om u opnieuw te abonneren.",
	"Reason to cancel_": "Reden om het abonnement op te zeggen",
	"Found an alternative": "Ik heb een alternatief gevonden",
	"Too expensive": "Te duur",
	"Not required anymore": "Ik heb het niet meer nodig",
	"Quality issue": "Kwaliteitsprobleem",
	etc_: etc_$5,
	"Please describe in_": "Beschrijf de reden in detail",
	"SIM card cannot_": "De simkaart kan niet worden verwijderd omdat er een abonnement voor deze simkaart actief is. Als u deze simkaart wilt verwijderen, moet u eerst uw abonnement opzeggen.",
	"SIM card cannot_2": "De simkaart kan niet worden verwijderd omdat het abonnement voor deze simkaart nog niet is afgelopen. Probeer het opnieuw als uw abonnement is afgelopen.",
	"Are you sure_deleteSIM": "Weet u zeker dat u deze simkaart wilt verwijderen?<br/>\n<b>Waarschuwing: U kunt deze actie niet ongedaan maken. Alle gegevens van uw simkaart zullen onmiddellijk worden verwijderd.</b>",
	"ICCID number": "ICCID-nummer",
	"Activation date": "Activeringsdatum",
	"Current plan": "Huidige plan",
	"Manage Plan": "Plan beheren",
	"Next billing on": "Volgende facturering op",
	"View Invoices": "Facturen bekijken",
	"Choose best plan_": "Kies het beste plan voor u",
	"Plan summary": "Samenvatting van het plan",
	"Ends on_": "Eindigt op {{a}}",
	"Start from_": "Gaat in vanaf {{a}}",
	"Your subscription will_": "Uw abonnement wordt opgewaardeerd op {{a}}, wanneer uw huidige plan afloopt.",
	"Resubscribe plan": "Opnieuw abonneren op plan",
	"Your subscription will2_": "Uw abonnement gaat in op {{a}}, wanneer uw huidige plan afloopt.",
	"Usage is estimated_": "Het verbruik wordt geschat per {{a}}",
	"Days left_": "Nog {{a}} dagen te gaan",
	"Data usage cycle": "Cyclus dataverbruik",
	Available: Available$5,
	Used: Used$5,
	"Data used": "Data verbruikt",
	"Subscribe to n_": "Abonneer u op {{a}} dataplan toegepast <b>van {{b}} tot {{c}}</b> en {{d}} dataplan toegepast van {{e}}",
	"Will be charged_": "Wordt aangerekend op {{a}}",
	"Monthly usage": "Maandelijks gebruik",
	"You have fewer_": "U heeft minder data over voor deze maand!",
	"Get more data": "Krijg meer data!",
	"This video cannot be shared": "Deze video kan niet worden gedeeld",
	"This is a video cannot be shared_": "Deze video kan niet worden gedeeld, omdat er op dat moment geen bestuurdersinformatie kan worden gevonden.",
	Cancelled: Cancelled$5,
	Terminated: Terminated$5,
	"Edit name": "Naam bewerken",
	"Not connected to_2": "Niet verbonden met cloud. Controleer of uw camera aan staat en of de internetconnectiviteitsmodule is ingeschakeld.",
	"Some functionality is disabled_": "Sommige functies zijn uitgeschakeld omdat de camera niet met de cloud is verbonden. Maak <a>hier</a> verbinding met de cloud.",
	"If you want to cancel_": "Als u uw abonnement wilt opzeggen, klik dan op <a> Abonnement opzeggen</a>.",
	"Select plan": "Kies een plan",
	"Event map collects_": "De gebeurteniskaart verzamelt en visualiseert BlackVue-gebeurtenisinformatie om situaties van de omliggende wegen te geven.",
	"Share your Live_": "Deel het uploadbestand van uw livegebeurtenis. U kunt de gebeurtenisvideo's delen met andere gebruikers in uw omgeving.",
	"You can check_": "U kunt de gebeurtenisvideo's bekijken die door anderen gedeeld zijn.",
	"Service end_": "Einde van service: {{a}}",
	"DMS camera recording_": "DMS-camera neemt op in de parkeermodus",
	Sort: Sort$5,
	"Are you sure you want_": "Weet u zeker dat u gedeelde video van de gebeurteniskaart wilt verwijderen?",
	"Remove shared video": "Gedeelde video verwijderen",
	"Explore event map": "Gebeurteniskaart verkennen",
	"Event map": "Gebeurteniskaart",
	"Explore the graphic_": "Bekijk de grafische statistieken van BlackVue-gebeurtenissen in uw omgeving.",
	"You can filter_": "U kunt de gebeurtenissen die u wilt weergeven filteren en bekijken.",
	"This video was removed by_": "Deze video werd gemeld en is door de beheerder verwijderd.",
	Bonus: Bonus$5,
	"Your subscription plan": "Uw abonnementsplan",
	"Your free trial will_": "Uw gratis proefperiode gaat in vanaf {{a}}</br> <strong>tot en met</strong> {{b}}.",
	"Total after free trial": "Totaal na gratis proefperiode",
	"This sim card is_": "Deze simkaart is niet meer actief.",
	"Firmware is up_": "Firmware is up-to-date",
	"Keep in mind": "Denk eraan",
	"Once 1GB of_": "Als er eenmaal 1 GB aan gegevens verbruikt is, zal de service niet meer beschikbaar zijn tot de volgende datum voor het resetten van de data (of nadat u uw plan naar een hoger niveau opgewaardeerd heeft).",
	"After the SIM_": "Nadat de simkaart in het apparaat is geplaatst, gaat de gratis proefperiode in wanneer u data begint te verbruiken.",
	"If you have_questions": "Neem voor vragen contact op met onze <a>klantenservice</a>.",
	"Data reset date": "Resetdatum van data",
	"To use SIM card_": "Als u de simkaart wilt gebruiken, neemt u contact op met het BlackVue <a>CS Team</a>",
	"Go to Subscription": "Ga naar abonnement",
	"An error occurred_subscription": "Er is een fout opgetreden bij het abonneren op het geselecteerde plan.",
	"Please try again": "Probeer het opnieuw",
	"Failed to subscribe": "Abonneren mislukt",
	"Go to Pricing": "Ga naar prijzen",
	"SIM cards will_": "De simkaarten verschijnen hier zodra ze beschikbaar zijn.",
	"1GB for 1_": "1 GB voor 1 maand",
	"Pricing Data": "Prijsgegevens",
	"If you would like to check_": "Als u de status wilt controleren en gedeelde video's wilt beheren, ga dan naar Gebeurtenissenkaart > Mijn gedeelde video's.",
	"Connect to Cloud": "Maak verbinding met de cloud",
	"Completed!": "Voltooid!",
	"Back to App": "Terug naar de app",
	"iOS in-app purchase": "In-app aankoop met iOS",
	"Android in-app_": "In-app aankoop met Android",
	"bonus n days": "bonus {{a}} dagen",
	"Want to contribute your_": "Automatisch delen van automatisch naar de gebeurteniskaart geüploade bestanden toestaan?",
	"With event map_": "U kunt de automatisch geüploade gebeurtenis delen met bestuurders in de buurt via de gebeurteniskaart.",
	"You can edit_3": "U kunt de instellingen van Automatisch delen van automatisch naar de gebeurteniskaart geüploade bestanden op elk moment bewerken door naar BLACKVUE CLOUD > Camera-instellingen > Privacyinstellingen te gaan.",
	"If you want to remove videos_": "Aangezien persoonlijke video's kunnen worden verstuurd, moet u goed opletten welke informatie u deelt.",
	"Total events": "Totaal aantal gebeurtenissen",
	"Automatically add Live Event_": "Automatisch delen van automatisch naar de gebeurteniskaart geüploade bestanden",
	"This camera is publicly_": "Deze camera is alleen openbaar voor zijn locatie.",
	incomplete_zip: incomplete_zip$5,
	"Live Event Upload_": "Upload van livegebeurtenis (opslagperiode: 7 dagen)\nVereist de nieuwste firmware",
	"Thank you for_2": "Dank u voor uw geduld.",
	"Start Web viewer": "Webviewer starten",
	"Are you sure_remove driver": "Weet u zeker dat u het stuurprogramma definitief wilt verwijderen?",
	"An error occurred_sim": "Er is een fout opgetreden bij het abonneren.",
	"Click the ADD SIM": "Klik op de knop SIM TOEVOEGEN op de simkaartlijstpagina en doorloop opnieuw de stappen voor het toevoegen van sim.",
	"Set download options": "Downloadopties instellen",
	"Information may be_": "Information may be transmitted with a delay and may not reflect actual balances.",
	"Swipe left and right to move": "Veeg naar links en rechts om te bewegen",
	"Scheduled maintenance Notice": "Kennisgeving van gepland onderhoud",
	"Our Cloud server_": "Onze cloudserver zal gepland onderhoud ondergaan.",
	"During that time_": "Gedurende die tijd kunnen de cloudfuncties niet beschikbaar zijn.",
	"Expected maintenance start_": "Verwachte begintijd van het onderhoud:",
	"Expected duration_": "Verwachte duur: {{a}} uur.",
	"For more information_": "Voor meer informatie, zie de <a>[Kennisgeving van serveronderhoud]</a>",
	"Do not remind_": "Herinner me er niet meer aan",
	"Cloud Server Maintenance": "Onderhoud van cloudserver",
	"BlackVue Cloud Service_": "BlackVue-cloudservice is tijdelijk niet beschikbaar",
	"We are currently_": "We voeren momenteel onderhoud uit.",
	"We apologize for_": "Onze verontschuldigen voor het ongemak.",
	"Driver Monitoring System (DMS)": "Bewakingssysteem voor de bestuurder (DMS)",
	"Distracted occurs_": "Gebeurt wanneer het hoofd van de bestuurder meer dan 50 graden van de voorkant verwijderd is.",
	"Hand distraction event occurs_": "Gebeurt wanneer de hand van de bestuurder gedurende lange tijd in de buurt van hun hoofd wordt gedetecteerd (bijvoorbeeld bij roken, telefoon vasthouden, etc.).",
	"Mask off event occurs_": "Gebeurt wanneer de bestuurder zonder mondmasker in het voertuig stapt of wanneer de bestuurder zijn of haar mondmasker afzet.",
	"DMS setting": "DMS-instelling",
	"The DMS system has_": "DMS combineert een gezichtsdetectiekader voor de statussen \"Gedetecteerd\", \"Ongedetecteerd\", \"Afgeleid\", \"Slaperigheid\", \"Masker af\" en een bewegingsdetectiekader voor de status \"Hand Afleiding\".",
	"DMS detection": "DMS-detectie",
	"There are detection criteria for_": "Er zijn detectiecriteria voor elk evenement. Raadpleeg de onderstaande gids.",
	"DMS camera recording_onoff": "Aan: De DMS-camera neemt op in Parkeermodus zolang de stroom wordt behouden. <br/> Uit: De DMS-camera schakelt kort na het invoeren van de Parkeermodus uit.",
	"LED lighting for each event_": "De LED op de Bestuurdersbewakingscamera geeft een signaal bij elke detectiegebeurtenis (Afleiding, Slaperigheid, etc.).",
	"Drowsy and Distracted each have_": "Slaperig en Afgeleid hebben elk drie gevoeligheidsvoorwaarden.\n \n Zie de handleidingsinterface hieronder.",
	"DMS event detection sensitivity": "DMS-gebeurtenisdetectiegevoeligheid",
	"Only drowsy and distracted include_": "Alleen slaperig en afgeleid hebben gevoeligheidsinstellingen. Ook past de ingestelde gevoeligheid dezelfde gevoeligheid toe op twee gebeurtenissen door één instelling.",
	"When driver’s eyes close_": "Gebeurt wanneer de bestuurder beide ogen sluit tijdens het rijden gedurende meer dan 1 seconde of gaapt gedurende 2 seconden.\n",
	"n digit": "{{a}} cijfers",
	"You are subscribed_free_Smart": "U bent geabonneerd op het Smart-plan van BlackVue Cloud.",
	"Wi-Fi auto turn on": "Wi-Fi automatisch aanzetten",
	"Video on a map": "Video on a map",
	"This feature is only_vom": "This feature is only available to users with a Fleet Plan subscription.<br/>Please subscribe to a plan to unlock this feature.",
	"Total n days_": "Totaal {{a}} dagen gratis proefperiode",
	"Every events of DMC200_": "DMS-detectiefuncties zijn alleen actief in de Normale Modus. Als het in Parkeermodus wordt ingeschakeld, neemt de DMS-camera alleen video op.",
	"An undetected event occurs_": "Gebeurt wanneer de bestuurder gedurende 1 minuut niet wordt gedetecteerd voor de camera.",
	"A detected event occurs_": "A detected Event occurs when the driver is gazing in front since the power is set in the beginning.",
	"Drowsy sensitivity_": "High : When the driver closes their eyes for more than 1 second, it is considered drowsy driving.<br/><br/>Medium : When the driver closes their eyes for more than 1.5 second, it is considered drowsy driving.<br/><br/>Low : When the driver closes their eyes for more than 2 second, it is considered drowsy driving.",
	"Distracted sensitivity_": "High : If the angle of the head is more than 50 degrees away from the front for 3 seconds, it is detected as Distracted.<br/><br/>Medium : If the angle of the head is more than 50 degrees away from the front for 5 seconds, it is detected as Distracted.<br/><br/>Low : If the angle of the head is more than 50 degrees away from the front for 7 seconds, it is detected as Distracted.",
	"Start your subscription now": "Start uw abonnement nu",
	"Free trial period has expired": "De gratis proefperiode is verlopen",
	"1 data plan will start from_": "Uw data-abonnement gaat in vanaf {{a}} en is inclusief 1 GB data voor BlackVue-simkaart.",
	"Allow the BlackVue_": "Wilt u de BlackVue App toegang geven tot de GPS-gegevens van uw dashcam?",
	"We use this_": "We gebruiken dit om u de locatie en snelheid van uw auto te laten volgen.",
	"You can edit_": "U kunt de toegangsinstellingen van de GPS te allen tijde bewerken door naar BLACKVUE CLOUD > Camera-instellingen > Privacy-instellingen te gaan.",
	"SIM cards": "simkaarten",
	"Subscription status": "Abonnementsstatus",
	Upgrades: Upgrades$5,
	"Upgrade plan": "Plan upgraden",
	"Manage plan": "Beheer het abonnement Plan",
	"Next plan": "abonnement voor de volgende maand",
	OR: OR$5,
	"Cancel subscription": "Annuleer abonnement",
	Undo: Undo$5,
	Invoice: Invoice$5,
	"Daily usage": "Dagelijks dataverbruik",
	"Delete SIM": "SIM Verwijderen",
	"New card": "Nieuwe creditcard",
	data: data$5,
	"SIM card data_": "Het abonnement voor het dataplan van de simkaart kan worden opgezegd via <a>sim.blackvuecloud.com</a>.",
	"Your plan from_": "Uw abonnement van vandaag tot de volgende factuurdatum",
	"Applied during_": "Toegepast gedurende {{a}} ~ {{b}}",
	"From today until_": "Vanaf vandaag tot de volgende betaaldatum kunt u zich alleen abonneren op hetzelfde abonnement als de vorige maand. Betalingen voor deze periode worden vandaag gefactureerd. <a>Kosten worden berekend op een pro-ratabasis.</a>",
	"Choose your next plan": "Kies uw volgende abonnement",
	"Applied from_": "Toegepast vanaf {{a}}",
	"Payment for this_": "De betaling voor dit abonnement zal worden verrekend op {{a}}.",
	"By sharing your_2": "Door uw Live View te delen, kunt u andere gebruikers indirect de spanning en het plezier laten ervaren van rijden over de hele wereld. Echter, aangezien er persoonlijke videomateriaal kan worden verzonden, dient u extra voorzichtig te zijn bij het bepalen welke informatie u deelt.",
	"Option camera recording_": "Optie camera-opname in de parkeermodus",
	"Front and option camera_": "Voorkant- en optie-camera nemen samen op.",
	"Option camera stops_": "Optie-camera stopt met opnemen na 5 min. na activering parkeermodus. Het opnemen wordt hervat wanneer u naar de normale modus gaat.",
	"Option camera rotation": "Optie-camerarotatie",
	"Option camera": "Optie-camera",
	"Option camera security": "Optie camerabeveiliging",
	"Resubscribe until_": "Opnieuw abonneren tot: {{a}}",
	"Firmware Update Caution": "Firmware-update waarschuwing",
	"Please check below_": "Controleer de volgende voorwaarden voordat u de firmware update voor DMC200 uitvoert:",
	"The camera's Wi-Fi_": "De WiFi van de camera moet aan staan.",
	"Check if your_": "Controleer of de WiFi van uw camera is ingeschakeld.",
	"DO NOT disconnect_": "Ontkoppel de coaxkabel NIET tijdens de firmware-update.",
	"The camera and_": "De camera en de DMC200 kunnen defect raken.",
	"DO NOT try_": "Probeer GEEN andere functies te gebruiken totdat de camera opnieuw is opgestart.",
	"Expecially Reboot camera_": "Vooral de camera opnieuw opstarten, SD-kaartindeling kan kritisch zijn voor het onbruikbaar maken van twee apparaten.",
	"Update anyway": "Toch updaten",
	"Invited on_2": "op {{Invited Date}} door u uitgenodigd. Eigenaar",
	"BlackVue’s New firmware_": "Nieuwe beschikbare firmware voor BlackVue",
	"valid thru_": "geldig tot en met: {{a}}",
	"Billed monthly": "Billed monthly",
	"90 minutes Live_": "90 minutes Live View / Live Event Upload*",
	"or 2+ videos_": "or 2+ videos in full resolution*",
	"1GB Free Month_": "1GB Free Month Trial",
	"Cancel anytime": "Cancel anytime",
	"8+ hours Live_": "8+ hours Live View / Live Event Upload*",
	"or 12+ videos_": "or 12+ videos in full resolution*",
	"15+ hours Live_": "15+ hours Live View / Live Event Upload*",
	"or 23+ videos_": "or 23+ videos in full resolution*",
	Popular: Popular$5,
	"For Power Users": "For Power Users",
	"Estimates based on_": "* Estimates based on 4.5MB per minute of Live View, Quick View remote playback, or Live Event Upload file, and 190MB per full original resolution video download or playback (at 25Mbps bitrate). Daily idle Cloud connection data usage: 20MB per 24 hours. Data usage is shared among all types of services (Live View, Live Event Upload, etc.).",
	"Balanced Plan": "Balanced Plan",
	"For Light Cloud_": "For Light Cloud Use",
	"Front security (Normal mode)": "Beveiliging voorzijde (Normale modus)",
	"Front security (Parking mode)": "Beveiliging voorzijde (Parkeermodus)",
	"BT (Parking mode)": "BT (Parkeermodus)",
	"LTE (Parking mode)": "LTE (Parkeermodus)",
	"Wi-Fi (Parking mode)": "Wifi (Parkeermode)",
	"Hand distraction": "Handafleiding",
	Mask: Mask$5,
	"Second drowsy is_": "Tweede slaperigheid is een slaperigheid die zich voordeed binnen 30 seconden na de eerste slaperigheid die de live-gebeurtenisupload opname startte.",
	"Second drowsy alert": "Tweede slaperig-waarschuwing",
	"BlackVue sim card_": "BlackVue simkaart kan alleen worden gebruikt in Canada en de VS.",
	"Global support is coming soon.": "Wereldwijde ondersteuning is binnenkort beschikbaar.",
	"The video file not found_": "Het videobestand werd niet gevonden of er was een probleem tijdens het afspelen. Probeer het nogmaals.",
	"Start Voice Call": "Start spraakoproep",
	"End Voice Call": "Stop spraakoproep",
	"Voice call in use": "Spraakoproep In gebruik",
	"Enable microphone access_": "Schakel de microfoontoegang in om de functie voor tweerichting-spraakcommunicatie te gebruiken. Ga naar de instellingspagina van uw browser voor toegang tot uw microfoon.",
	"You may need to_": "Het kan zijn dat u deze pagina opnieuw moet laden voordat de nieuwe instellingen van kracht worden.",
	"Eye status": "Oogstatus",
	"Start time of live event upload video": "Begintijd van live-gebeurtenisupload video",
	"Left eye": "Linkeroog",
	"Right eye": "Rechteroog",
	"Drowsy is occured when the driver close his/her eyes more then 1sec": "Slaperigheid treedt op als de bestuurder zijn/haar ogen meer dan 1 seconde sluit",
	"Driver's Left eye movements with blinking count and period": "Linker oogbewegingen van de bestuurder met knipperen tellen en periode meten",
	"Driver's Right eye movements with blinking count and period": "Rechter oogbewegingen van de bestuurder met knipperen tellen en periode meten",
	"Drowsy big data of the driver and after a Drowsy event occurs": "Omvangrijke data oogknipperen van de bestuurder na een slaperigheidsgebeurtenis",
	"Sharing video to Event Map": "Video delen naar Gebeurteniskaart",
	"Want to use a Voice call?": "Wilt u een spraakoproep gebruiken?",
	"To use a voice call_": "Om een spraakoproep te gebruiken, start Live View opnieuw en klik op \"Toestaan\"",
	"There is no_": "Er zijn nog geen gedeelde video's. \nLijst verschijnt wanneer deze wordt gedeeld.",
	"Microphone blocked": "Microfoon geblokkeerd",
	"Want to center the map on your location?": "Wilt u de kaart centreren op uw locatie?",
	"To let the app access your location_": "Om de app toegang te geven tot uw locatie, start u Event Map opnieuw en selecteert u \"OK\" wanneer daarom wordt gevraagd.",
	"Location access permission required": "Toestemming voor toegang tot de locatie is vereist.",
	"Are you sure you want_2": "Weet je zeker dat je deze video van Event Map wilt verwijderen?",
	"Two-way voice_2": "Two-way voice communication / Voice Call",
	"Not supported by DR650GW and DR650S_": "Not supported by DR650GW and DR650S",
	"DR650S Series only_": "DR650S Series only",
	"Cancel download?": "Downloaden annuleren?",
	"Your download is not_": "Uw download is niet voltooid. Wilt u het downloaden annuleren?",
	"Continue download": "Downloaden voortzetten",
	"Cancel download": "Downloaden annuleren",
	"Share your video to the Event Map?": "Uw video delen met de gebeurteniskaart?",
	"Afterwards, according to the reaction to the video_": "De video kan achteraf worden geclassificeerd als een populaire video aan de hand van de reactie op de video en worden geïntroduceerd op de nu-trend op de kaart.",
	"Add hashtags and a brief description to describe your video.": "Voeg hashtags en een korte beschrijving toe om uw video te beschrijven.",
	"Would you like_": "Wilt u delen via de gebeurteniskaart?",
	"Successfully added video_": "Video met succes toegevoegd om te delen via de gebeurteniskaart!",
	"This video cannot_": "Deze video kan niet worden gedeeld omdat er GPS-locatiegegevens ontbreken om er op de kaart een pin in te zetten.",
	"This video is_": "Deze video is al toegevoegd aan de gebeurteniskaart.",
	"Share to Event Map": "Delen naar gebeurteniskaart",
	"Describe in more_": "Beschrijf uitgebreid wat er in uw video gebeurt (optioneel)",
	"Description(optional)": "Beschrijving (optioneel)",
	"Recording mode": "Opnamemodus",
	"Event triggers": "Gebeurtenisactivators",
	DMS: DMS$5,
	"Camera connectivity": "Camera-connectiviteit",
	"If not allowed_2": "Als dit niet is toegestaan, zijn de locatie en snelheid van uw auto niet toegankelijk via de cloud.",
	"Share Live View_": "Liveweergavevideo delen",
	"Share Live View_2": "Liveweergave-audio delen",
	"Share camera profile": "Cameraprofiel delen",
	"Parking impact": "Impact van parkeren",
	"Parking events": "Parking Events",
	"Audio recording": "Audio-opname",
	"Toggle the mic_": "Zet de microfoon AAN/UIT",
	"Full HD_": "Full HD @ 60fps + Full HD @ 30fps",
	"Video quality": "Videokwaliteit",
	Extreme: Extreme$5,
	"More video files": "Meer opnamebestanden",
	"Fewer video files": "Minder opnamebestanden",
	"Camera rotation": "Rotatie camera achterzijde",
	"Video overlay": "Video-overlay",
	"Date & time display": "Datum- & tijdsweergave",
	"Speed unit": "Snelheidseenheden",
	"Check the orientation_": "Controleer de oriëntatie van de voorcamera die in het voertuig is geïnstalleerd. Selecteer de bijpassende optie om video's rechtop op te nemen.",
	"Rotate 180º": "Draai 180º",
	"Rear camera rotation": "Rotatie camera achterzijde",
	"Check the orientation_rear": "Controleer de oriëntatie van de achtercamera die in het voertuig is geïnstalleerd. Selecteer de bijpassende optie om video's rechtop op te nemen.",
	"Mirror View": "Weergave spiegelen",
	"Select Mirror View_": "Selecteer Weergave spiegelen om video's horizontaal op te nemen.",
	"Check the orientation_interior": "Controleer de oriëntatie van de optionele camera die in het voertuig is geïnstalleerd. Selecteer de bijpassende optie om video's rechtop op te nemen.",
	"Display off": "Scherm uit",
	"Explore crowd-sourced Events_": "Verken gecrowdsourcede gebeurtenissen (botsing, hard remmen, enz.) op de kaart, bekijk video's die door de community zijn gedeeld en draag uw eigen gebeurtenissen bij.",
	OFF: OFF$5,
	"Reboots once-a-day_": "Herstelt eenmaal per dag op de ingestelde tijd in de parkeermodus voor betere stabiliteit.",
	"Set time": "Tijd instellen",
	"FW language": "Firmware-taal",
	"Rear security_2": "Beveiliging achterzijde",
	"Bluetooth (Parking mode)_2": "Bluetooth (Parkeermodus)",
	"Failed to save_2": "Opslaan instelling Livegebeurtenisupload mislukt",
	"Event file will_": "Gebeurtenisbestand wordt automatisch opgeslagen in de opslag Livegebeurtenisupload.",
	"An impact was_": "An Impact was detected during Parking Mode.",
	"When exiting Parking_": "Als u de parkeermodus verlaat, meldt uw BlackVue of er een botsing werd gedetecteerd in Parkeermodus. \n\n Opmerkingen: \n Botsingen genereren gebeurtenisvideo's. Botsingen die binnen 3 minuten na het verlaten van Parkeermodus worden gegenereerd, worden genegeerd.",
	"Protect event files": "Gebeurtenisbestanden beveiligen",
	"Turning on this_": "Schakel in om te voorkomen dat de laatste {{a}} gebeurtenisbestanden worden overschreven door normale of parkeeropnamebestanden.",
	"Impact Events in_": "Impact Events in Normal(E) and Parking Mode(I)",
	"Manual Events_": "Manual Events (M)",
	"Once 50 Events_": "Beveiligde bestanden omvatten: \n\nBotsingen in normale (E) en parkeermodus (I) \nHandmatige gebeurtenissen (M) \n\nZodra {{a}} gebeurtenissen zijn opgenomen, zullen nieuwe gebeurtenissen de oudste overschrijven.",
	"Reckless driving unit": "Roekeloos rijden unit",
	"Hard acceleration Event": "Harde versnellingsgebeurtenis",
	Threshold: Threshold$5,
	"Triggers when the_": "Wordt geactiveerd wanneer de camera een versnellingspercentage per seconde detecteert die groter is dan de ingestelde drempelwaarde.",
	"Triggers when the_2": "Wordt geactiveerd wanneer de camera een snelheidsafname detecteert die groter is dan de ingestelde drempelwaarde.",
	"Hard braking Event": "Harde remgebeurtenis",
	"Triggers when more_": "Wordt geactiveerd wanneer er binnen 2 seconden meer dan 60 graden wordt gedetecteerd en er boven de ingestelde drempelwaarde wordt gereden.",
	"Every event of DMC200_2": "DMS-detectiefuncties zijn alleen actief in de normale modus. Als het in de parkeermodus wordt gevoed, neemt de DMS-camera alleen video op.",
	"The DMS system has_2": "DMS combineert een gezichtsdetectiekader voor de statussen \"Gedetecteerd\", \"Ongedetecteerd\", \"Afgeleid\", \"Slaperigheid\", \"Masker af\" en een bewegingsdetectiekader voor de status \"Hand Afleiding\".",
	"One for face_": "One for face detection : Detected, Undetected, Distracted, Drowsy",
	"The other for_": "The other for motion detection",
	"On: Normal recording_": "On: Normal recording works while power is maintained in Parking Mode",
	"Off: DMS power_": "Off: DMS power off after 5 minutes when entering Parking Mode, Normal recording works until just before off",
	"Drowsy and Distracted_": "Drowsy and Distracted each have three sensitivity conditions.",
	"Please refer to_": "Please refer to the guide interface below.",
	Drowsiness: Drowsiness$5,
	"Drowsiness occurs when_": "Slaperigheid treedt op wanneer de bestuurder beide ogen sluit tijdens het rijden gedurende meer dan 1 seconde en gaapt gedurende 2 seconden.",
	"Distracted occurs when_": "Gebeurt wanneer het hoofd van de bestuurder meer dan 50 graden van de voorkant verwijderd is.",
	"A hand distraction_": "A hand distraction occurs when the driver removes one hand from the steering wheel. [*Smoking and phone calls may be suspected.]",
	"Mask off event_": "Mask-off event occurs in two ways. First is when the driver gets in the car without a mask. Second is when the driver takes their mask off",
	"High When the_": "High : When the driver closes their eyes for more than 1 second, it is considered drowsy driving.",
	"Middle When the_": "Medium : When the driver closes their eyes for more than 1.5 second, it is considered drowsy driving.",
	"Low When the_": "Low : When the driver closes their eyes for more than 2 second, it is considered drowsy driving.",
	"High If the_": "High : If the angle of the head is more than 50 degrees away from the front for 3 seconds, it is detected as Distracted.",
	"Middle If the_": "Medium : If the angle of the head is more than 50 degrees away from the front for 5 seconds, it is detected as Distracted.",
	"Low If the_": "Low : If the angle of the head is more than 50 degrees away from the front for 7 seconds, it is detected as Distracted.",
	Direct: Direct$5,
	"Camera Wi-Fi credentials": "Wifi-gegevens camera",
	"Network name(SSID)": "Netwerknaam (SSID)",
	"Seamless pairing": "Seamless Pairing",
	Remote: Remote$5,
	"Hotspot settings": "Hotspotinstellingen",
	"Hotspot name": "Hotspotnaam (SSID)",
	"Hotspot name must_": "Hotspot name must be at least 5 characters long",
	"Public cameras may_": "Openbare camera's kunnen verschijnen op het tabblad Verkennen of op de wereldkaart.",
	"Hard Cornering Event": "Scherpe bochtgebeurtenis",
	"Over speed_2": "Te snel",
	"Second drawiness alert": "Tweede slaperigheidswaarschuwing",
	"Low Voltage Warning_2": "Handafleiding",
	"(You)_2": "{{a}} ( U )",
	"This video has been reported_": "Deze video werd gemeld en is door de beheerder verwijderd.",
	"Normal Mode recording": "Normale opnamemodus",
	"ON : the camera_": "AAN: de camera neemt continu op.",
	"OFF : the camera_": "UIT: de camera neemt alleen gebeurtenisvideo's op tijdens het rijden.",
	"In both modes_": "In beide modi activeren gedetecteerde botsingen video-opnamen van gebeurtenissen.",
	"Continuously records_": "Neemt continu 1 minuut durende video's van 1 frame per seconde op die 30 minuten aan actie beslaan.",
	"Choose detection regions_": "Kies de detectiegebieden om het risico te verminderen dat ongewenste bewegingsopnames worden veroorzaakt door wuivende bomen, verre bewegende objecten, enz.",
	"Your previous plan is expired.": "Uw vorige abonnement is verlopen.",
	"Upgrade the plan to restore the camera": "Waardeer het abonnement op om de camera te herstellen\n(%@)",
	"Remove from cloud": "Verwijderen uit cloud",
	"Are you sure you want to Remove_": "Weet u zeker dat u dit wilt verwijderen uit de cloud?",
	"Remove: It doesn’t mean_": "Verwijder: Dit betekent niet dat de gegevens van de camera worden verwijderd, maar dat er een plek voor een cloudcamera wordt vrijgemaakt.",
	"Now the camera is removed from cloud slot": "De camera is verwijderd uit de cloud.",
	"How to delete camera list": "Hoe verwijdert u een camera uit de lijst",
	Update: Update$5,
	"Camrea setting": "Camera-instelling",
	"Notification setting": "Instellingen push-berichten",
	"Driving reports": "Rijverslag",
	"Cloud connection steps": "Stap voor cloudverbinding",
	"Download the BlackVue app to add a camera": "Download de BlackVue-app om een ​​camera toe te voegen",
	"To see your camera in the BlackVue cloud viewer_": "Om uw camera in de BlackVue-cloudviewer te zien, moet u deze eerst met de cloud verbinden. Installeer uw BlackVue-camera eenvoudig en verbind deze met de cloud met de BlackVue-app voor iOS en Android.",
	"Download the BlackVue app to see a Wi-Fi connected camera": "Download de BlackVue-app om een met wifi verbonden camera te zien",
	"BlackVue Cloud web viewer only supports_": "BlackVue Cloud-webviewer ondersteunt alleen de met de cloud verbonden dashcam. Download de BlackVue-app om uw met wifi verbonden dashcam te zien.",
	"You can restore the data if_": "U kunt de gegevens herstellen als u deze camera opnieuw op hetzelfde account registreert, maar als het account is verwijderd, gaan al uw bestanden verloren.",
	"How to add camera": "Hoe voegt u een camera toe",
	"Try to wait 2-3 minutes if you just registered the camera.": "Wacht 2-3 minuten als u de camera net heeft geregistreerd.",
	"Try to check the Cloud Connection Settings again_": "Controleer nogmaals de Cloudverbindingsinstellingen als de camera nog steeds geen verbinding maakt met de cloud.",
	"Motion Detection": "Bewegingsdetectie",
	"Parking recordings occur_": "Parkeeropnames vinden plaats wanneer zichtbare beweging wordt gedetecteerd.",
	"Motion Sensitivity": "Bewegingsgevoeligheid",
	"Motion Detection Sensitivity": "Gevoeligheid voor bewegingsdetectie",
	"Select Detection Region": "Selecteer detectiegebied",
	"Speed alert_2": "Snelheidsmelding",
	"Live Event Upload_2": "Live Event Upload",
	"Beep Alert": "Pieptoon",
	"Parking Impact History_": "Waarschuwing voor parkeerbotsingsgeschiedenis",
	"To register your_": "Om uw SOS-knop te registreren, moet u de BlackVue-app gebruiken.",
	"SOS button on/off": "Status SOS-knop",
	"File sharing to Event Map is_": "Bestanden delen met Event Map is momenteel niet beschikbaar. Kom later terug.",
	"Email Notifications": "emailmeldingen",
	"Push Notifications_2": "Push-meldingen",
	"Optional Camera Rotation": "Optie camera-oriëntatie",
	"Optional Camera Security": "Optie camerabeveiliging",
	Option: Option$5,
	"(Owner)": "{{a}} (Eigenaar)",
	"SOS button": "SOS-knop",
	"This video has been reported_bold": "Deze video werd gemeld en <b>is door de beheerder verwijderd.</b>",
	"Number of events_2": "Aantal gebeurtenissen",
	"My Shared Videos": "Mijn gedeelde video's",
	"No Hashtags": "Geen hashtags",
	"I have read and agree_": "Ik heb alle Voorwaarden en Beleidslijnen gelezen en ga daarmee akkoord.",
	"14 years old_": "14 jaar of ouder",
	Required: Required$5,
	Optional: Optional$5,
	"Profile information_": "Profielinformatie kan worden bewerkt op de pagina Accountinstellingen.",
	"Automatically Add Live_": "Automatisch delen van automatisch naar de gebeurteniskaart geüploade bestanden",
	"You must be 14 years_": "U moet 14 jaar of ouder zijn om een ​​BlackVue-account aan kunnen te maken",
	"Use 8 or more characters_": "Gebruik 8 of meer tekens met een combinatie van letters, cijfers of symbolen",
	"Protected files include_": "Beveiligde bestanden omvatten: <br/>ㆍBotsingen in normale (E) en parkeermodus (I) <br/>ㆍHandmatige gebeurtenissen (M)<br/><br/>Zodra {{a}} gebeurtenissen zijn opgenomen, zullen nieuwe gebeurtenissen de oudste overschrijven.",
	"Protected files include": "Protected files include",
	"If you turn_": "Als u Voice Guidance uitschakelt, zijn de volgende lijsten uitgeschakeld.",
	"Live Event Upload_success": "Instellingen voor Livegebeurtenisupload zijn met succes opgeslagen.",
	"Video type": "Videotypes",
	"Notify the Owner": "De eigenaar verwittigen",
	"Adjusting the cut-off voltage_2": "Adjusting the cut-off voltage to a lower setting may result in your dash cam draining more power from your battery. This could result in warning messages of battery drain or affect other vehicle functions.\nPlease consult with your dealership before lowering the voltage.",
	Others: Others$5,
	"This video has been removed.": "Deze video is verwijderd.",
	"Please assign cameras_": "Wijs camera's toe aan deze groep.",
	"Are you running_": "Heeft u nog maar weinig mogelijkheid om Afspelen te bekijken?",
	"Upgrade your plan_": "Upgrade uw abonnement naar Fleetplan voor onbeperkt afspelen en andere functies die exclusief zijn voor de cloud.",
	"Are you running_Liveview": "Heeft u nog maar weinig tijd om Liveweergave te bekijken?",
	"Upgrade your plan_Liveview": "Upgrade uw abonnement naar Fleetplan voor onbeperkt liveweergave en andere functies die exclusief zijn voor de cloud.",
	Stay: Stay$5,
	"Go to Fleet Plan": "Ga naar Fleetplan",
	"It looks like the video file is being prepared. please try again later.": "Het lijkt erop dat het videobestand wordt voorbereid. probeer het later nog eens.",
	"Oops!": "Oeps!",
	"Please back up_": "Maak een back-up van alle belangrijke opnamen voordat u deze instelling wijzigt.",
	"When you save_": "Wanneer u de instellingen opslaat, wordt de microSD-kaart geformatteerd en worden alle opnamen verwijderd om een stabiele werking te garanderen.",
	"This is an unregistered_": "Dit is een niet-geregistreerde e-mail. Wilt u naar de pagina Account aanmaken gaan?",
	"Camera name must_2": "De cameranaam moet tussen de 5 en 32 tekens bevatten.",
	"G-sensor (Normal mode)": "G-sensor (Normale modus)",
	"G-sensor (Parking mode)": "G-sensor (Parkeermodus)",
	"Up & down": "Naar boven & naar beneden",
	"Front & back": "Naar voren & naar achteren",
	"Rotate Video 180º": "Rotate Video 180º",
	Mask_2: Mask_2$5,
	"Priority event": "Priority Event",
	"There is no_camera": "There is no camera that your owner assigned to you.",
	"Camera SSID": "Camera SSID",
	"The BlackVue dashcam_2": "The BlackVue dashcam is not compatible with 5GHz wireless networks",
	"Driver detection box_2": "Driver Detection Box",
	"DMS camera recording_2": "DMS Camera Recording in Parking Mode",
	Low_2: Low_2$5,
	Medium_2: Medium_2$5,
	High_3: High_3$5,
	"Live Event Upload_3": "Live Event Upload",
	"Driving Impact": "Driving Impact",
	"Video source_2": "Video Source",
	"Front camera_2": "Front Camera",
	"Rear camera_2": "Rear Camera",
	"Optional Camera": "Optional Camera",
	"Motion Detection_2": "Motion Detection",
	"Rear camera stops_2": "Rear camera stops recording 5 minutes after entering Parking Mode. Recording restarts when entering normal mode.",
	"Passenger vehicle": "Passenger Vehicle",
	"Heavy vehicle": "Heavy Vehicle",
	Highest_3: Highest_3$5,
	Extreme_2: Extreme_2$5,
	"Less recording files": "Fewer Recording Files",
	"Camera rotation_2": "Camera Rotation",
	"Share camera profile_2": "Share Camera Profile",
	Private_2: Private_2$5,
	"BlackVue Live": "BlackVue Live",
	"Important All saved_": "Important! All saved videos are about to be deleted. Tap Cancel and back up important files if needed.",
	"Whenever saving settings_": "Whenever saving settings after changing the time zone, the SD card is initialized and all stored files are deleted.",
	"Do you want_": "Do you want to save your changes?",
	"No groups": "No groups",
	Lite: Lite$5,
	"USD per Camera": "USD per extra Camera",
	"up to Cameras": "up to Cameras",
	"All the P Plan_": "Alle <b>{{a}}</b> Plan-functies, plus:",
	"User Roles and Permissions": "Gebruikersrollen en rechten",
	"Geofence Setup (Web) and alerts": "Geofence Setup (Web) and alerts",
	"N Times": "{{a}} Keer",
	"N Minutes": "{{a}} Minuten",
	"Emergency Alarm": "Noodalarm",
	"Playback, Live View": "Afspelen, Live View",
	"Your driving record : Daily, Monthly": "Uw rijgedrag: Dagelijks, Maandelijks",
	"Real-time Conversation": "Realtime gesprek",
	"Initiate a conversation_": "Start een gesprek met de bestuurder via de luidspreker en microfoon van de Dashcam.",
	"Remote Voice Communication": "Spraakcommunicatie op afstand",
	"See the last location_": "Zie de laatste locatie van uw camera",
	"Check your cars_": "Controleer de realtime GPS-gegevens van uw auto op een kaart om uw voertuig te vinden en informatie te verkrijgen over de status, zoals of het rijdt of geparkeerd is en de snelheid ervan.",
	"Supported models_": "* Ondersteunde modellen: S en Early X Series -modellen",
	"GPS Tracking &_": "GPS Tracking & Video op kaart (Smart/Fleet)",
	"Track your cars_": "Volg de locatie en snelheid van uw auto op de kaart!",
	"GPS Tracking: visualize_": "GPS -tracking: visualiseer uw rij -logboek op de kaart.\nVideo op kaart: bekijk contextuele info (snelheid, gebeurtenistype) en speel gerelateerde video's direct van de kaart.",
	"Visualize your cars_": "Visualiseer de locatie en snelheid van uw auto op de kaart!",
	"The feature enables_": "Deze functie maakt het mogelijk om videobeelden naar de cloud te uploaden, inclusief 5 seconden voor een ongeval.",
	"Camera profile setting": "Camera profile setting",
	"Are you running_Download": "Are you running out of chance to Download Video?",
	"Upgrade your plan_Download": "Upgrade your plan to Fleet Plan for Unlimited Download, and other Cloud -Exclusive features.",
	"This feature is available for Smart and Fleet_": "This feature is available for Smart and Fleet Plan subscribers only.",
	"Rear camera will keep_": "De achtercamera stopt met opnemen in de parkeermodus wanneer de temperatuurstatus van de dashcam wordt gewijzigd in \"Hoge temperatuur\". De achtercamera zal opnieuw beginnen met opnemen nadat de temperatuurstatus van de dashcam is gewijzigd naar \"Normale temperatuur\". (Let op: Om de elektronica te beschermen, kan Blackvue worden uitgeschakeld bij hoge buitentemperaturen.)",
	"Get Unlimited Cloud_": "Krijg onbeperkte cloudweergave en beheer tot {{a}} camera's.",
	"Up to N cameras_": "Up to {{a}} cameras (+ {{b}} USD Extra charge)",
	"N Minutes per Day": "{{a}} minuten per dag",
	"Drowsiness sensitivity is_": "Slaperigheid-gevoeligheid wordt ingesteld door de oog-knipperperiode met een betrouwbare BlackVue-algoritme. <br> <br> De gevoeligheid van afgeleid rijden wordt bepaald door de hoek van de positie van het hoofd van de bestuurder vanaf de voorkant en de tijdsduur.",
	"Not available with this plan": "Not available with this plan",
	"The optional camera records_": "De optionele camera neemt op in Parkeermodus",
	"Smart and Fleet_": "Smart and Fleet Plan<br/>subscribers only",
	"This feature is_smart": "This feature is available for Smart and Fleet Plan subscribers only.",
	"Camera Registration": "Cameraregistratie",
	"Voice Call": "Voice Call",
	"N times per Month": "{{a}} times per Month",
	"Recommended for higher bitrate_": "Aanbevolen voor hogere bitrate en betere videokwaliteit.",
	"Recommended for for better compatibility_": "Aanbevolen voor een betere compatibiliteit met desktop- en mobiele apparaten",
	"A minute of front camera_": "Geschatte bestandsgrootte voor 1 minuut video (camera aan de voorkant)",
	"Extreme(N Mbps): N MB_": "Extreme ({{ex1}}Mbps) : {{ex2}}MB\nHighest ({{ht1}}Mbps) : {{ht2}}MB\nHigh ({{hi1}}Mbps) : {{hi2}}MB\nNormal ({{no1}}Mbps) : {{no2}}MB",
	"File size information reflects_": "Informatie over bestandsgrootte weerspiegelt de maximaal mogelijke grootte en de werkelijke bestandsgroottes kunnen variëren afhankelijk van de opnamecondities.",
	Bitrate: Bitrate$5,
	"Connection has been_": "Verbinding is verloren gegaan.\nHet herstel van de verbinding ...",
	"Unable to establish_": "Niet in staat om een ​​verbinding tot stand te brengen met de camera.\nZorg ervoor dat uw apparaat correct is aangesloten en probeer het opnieuw.",
	"Purchased by Payment Service": "Gekocht door Betalingsdienst",
	"Up to N Cameras": "Tot {{a}} camera's",
	"Unlimited Live View": "Onbeperkte live-weergave",
	"N Days GPS Tracking": "{{a}} dagen GPS-tracking",
	"Unlimited Playback and Download": "Onbeperkte weergave en download",
	hours: hours$5,
	"Live Event Upload or_": "Live Event Upload of 12+ video's in volledige resolutie",
	"During the usage period of the One Plan_": "Gedurende de gebruiksperiode van de One Plan-service zijn wijzigingen in het abonnement niet mogelijk. Neem contact op met de BlackVue klantensupport om het One Plan abonnement te annuleren als je wilt overschakelen naar een ander abonnement.",
	"Service Period (Include SIM Data)": "Serviceperiode (Inclusief SIM-gegevens)",
	"Purchase the BlackVue One Package_": "Koop het BlackVue One-pakket om het One Plan gratis te ontgrendelen voor 1 jaar.",
	"3GB SIM Data Plan": "3GB SIM-gegevensplan",
	"Unlimited Live View, Playback and Download": "Onbeperkte live weergave, afspelen en downloaden",
	"within data availability": "binnen de beschikbaarheid van gegevens",
	"The BlackVue One Plan is a 1-year_": "Het BlackVue One Plan is een Cloud-serviceplan van 1 jaar dat exclusief toegankelijk is via de aankoop van een BlackVue One-pakket, dat een dashboardcamera, een 1-jarig 3GB/maand gegevensplan (voor de VS en Canada) en een 1-jarig Cloud-serviceplan bevat.",
	"The BlackVue One Package is available_": "Het BlackVue One-pakket is exclusief verkrijgbaar in de BlackVue Online Store.",
	"Go to BlackVue Shop": "Ga naar de BlackVue-winkel",
	"Anonymous Cam": "Anonieme camera",
	"App only": "alleen in de app",
	Expires: Expires$5,
	"N days remaining": "{{a}} dagen over",
	"No action needed_": "<b>Geen actie vereist.</b> De nieuwe verlaagde prijs wordt automatisch toegepast vanaf uw volgende betaling na 13 september.",
	"The new reduced price_": "De nieuwe verlaagde prijs wordt automatisch toegepast op uw account.",
	"Smart Plan Subscriber?": "Smart Plan Abonnee?",
	"Fleet Plan Subscriber?": "Fleet Plan Abonnee?",
	"Please take a moment to_": "Neem even de tijd om ons te autoriseren om uw account te migreren.",
	"Starting from now and_": "<b>Vanaf nu tot 31 oktober</b>, kunt u ons de verandering voor u laten maken door <a href=\"https://form.jotform.com/232411253056041\" target=\"_blank\">Op deze link te klikken</a> en uw Fleet account e-mailadres in te voeren. Gelieve ons wat tijd te geven om de verandering te verwerken. Als alternatief kunt u uw bestaande account annuleren en opnieuw abonneren tegen de nieuwe prijs vanaf 13 september.",
	"Once activated_": "Eenmaal geactiveerd, kan de One Plan niet worden gepauzeerd of gedeactiveerd.",
	"Once the One Plan is activated_": "Eenmaal geactiveerd, kan het One Package niet worden terugbetaald.",
	"Up to N Cloud Camera Slot": "Tot {{a}} Cloud Camera Slot(s)",
	"nGB of Cloud Storage": "{{a}}GB aan Cloudopslag",
	"Get started for free_": "Get started for free, no credit card required. Includes Alert Push Notifications, limited Remote Live View and cloud storage.",
	"The BlackVue One Plan is exclusively_": "The BlackVue One Plan is exclusively available through the purchase of a BlackVue One Package. 3GB/mo data plan is for US and Canada only. BlackVue Cloud’s Free Plan, Lite Plan (1~3) and Smart Plan (1~3) accounts can upgrade to One Plan. However, Lite Plan (4~15), Smart Plan (4~15) and Fleet Plan accounts can not be upgraded to One Plan.",
	"For N year": "For {{a}} year",
	"Included in the One Package": "Included in the One Package",
	"3GB SIM Data Plan for N year": "3GB SIM Data Plan for {{a}} year",
	"One Plan Cloud Service for N year": "One Plan Cloud Service for {{a}} year",
	"The BlackVue One Package includes_": "The BlackVue One Package includes all you need to enjoy BlackVue Cloud for a whole year!",
	"4K LTE Dash Cam_": "4K LTE Dash Cam, Cloud Service and Data Plan",
	"nGB included": "{{a}}GB included",
	"nGB per camera": "{{a}}GB per camera",
	"N Days Live Event Upload": "{{a}} Days Live Event Upload",
	"Up to N Dash Cameras": "Up to {{a}} Dash Cameras",
	"Step N/N": "Stap {{a}}/{{b}}",
	"Cloud Connection": "Cloudverbinding",
	"To pair your dashcam": "Om uw dashcam met de batterij te koppelen, sluit u deze aan op de Cloud.",
	Check: Check$5,
	"Unpair Battery": "Batterij ontkoppelen",
	"Are you sure you want to unpair": "Weet u zeker dat u deze batterij (%@) van de camera wilt ontkoppelen?",
	"Unpair: It doesn't mean": "Ontkoppelen: Dit betekent niet dat de gegevens van de batterij worden verwijderd.",
	"*The paired battery will": "*De gekoppelde batterij wordt ook samen verwijderd.",
	"Would you like to pair this": "Wil je deze batterij koppelen?",
	"Battery successfully paired": "Batterij succesvol gekoppeld.",
	"Now you can directly connect to": "U kunt nu rechtstreeks verbinding maken met de batterij vanuit de camerabrowser.",
	"Pairing failed": "Koppelen mislukt. Probeer het opnieuw.",
	"Battery Name": "Batterijnaam",
	"Capacity History": "Capaciteitshistorie",
	"The graph displays capacity": "De grafiek geeft een benaderd batterijniveau weer met behulp van gegevens uit de cloudverbinding.\n De batterijcapaciteit kan variëren afhankelijk van de temperatuur, de instellingen van de dashboardcamera en de frequentie van het activeren van gebeurtenissen.",
	"Last 24 Hours": "Laatste 24 uur",
	"Last 7 Days": "Laatste 7 dagen",
	"Battery Level": "Batterijniveau",
	"Temperature History": "Temperatuurgeschiedenis",
	"The graph displays temperature": "De grafiek geeft een geschatte temperatuurniveau weer met behulp van gegevens uit de cloudverbinding.",
	"Temperature Level": "Temperatuurniveau",
	"Connecting alert": "[ Verbinden ]\nGegevens weergegeven bij verbinding.",
	"Low Output power Alert": "[ Uitschakeling van uitvoerstroom ]\nDe uitvoerspanning is te laag, waardoor de stroomvoorziening van het aangesloten apparaat wordt beperkt.",
	"High temp Alert": "[ Invoerstroom afgesneden ]\nDe batterijtemperatuur is te hoog, wat het opladen beperkt.",
	"Remaining time": "Restende tijd",
	"Remaining time estimate": "De resterende tijd is een schatting op basis van het totale stroomverbruik van de aangesloten apparaten.\n Het wordt elke 30 seconden opnieuw berekend na aansluiting op de batterij.",
	"Setting changed": "Instelling gewijzigd",
	"Setting change failed": "Instelling wijzigen mislukt",
	"Low Input power Alert": "[ Invoerstroom afgesneden ]\nDe laadspanning is te laag, waardoor het laden wordt beperkt.",
	"High Input power Alert": "[ Invoerstroom afgesneden ]\nDe laadspanning is te hoog, wat het opladen beperkt.",
	"Low temp_Cut off Alert": "[ Invoerstroom afgesneden ]\nDe temperatuur van de batterij is te laag, wat het opladen en de gebruiksduur beperkt.",
	"Low temp Alert": "[ Lage temperatuur ]\nDe batterijtemperatuur is te laag, waardoor de gebruiksduur en laadsnelheid worden beperkt.",
	"Low capacity Alert": "[ Lage capaciteit ]\nDe batterijcapaciteit is te laag.\nRijd met de auto om hem op te laden.",
	"Back to list": "Terug naar lijst",
	Saving: Saving$5,
	Now: Now$5,
	"Power supplying is limited": "De stroomtoevoer is <b>beperkt</b>",
	"This battery is already paired": "Deze batterij is al gekoppeld.",
	"Connecting to Battery": "Verbinding met batterij",
	"Paired battery": "Batterij gekoppeld",
	"Battery unpairing failed": "Batterijkoppeling mislukt. Probeer het opnieuw.",
	"A connection is already active": "Er is al een verbinding actief. Probeer het later opnieuw.",
	"Searching for battery": "Zoeken naar batterij",
	"Select battery to pair with your camera": "Kies batterij om te koppelen met uw camera.",
	"Unable to connect": "Kan geen verbinding maken",
	"A connection error has occurred": "Er is een verbindingsfout opgetreden. Probeer het opnieuw.",
	"The paired dashcam has been disconnected": "De gekoppelde dashcam is losgekoppeld van de Cloud.\nControleer de onderstaande voorwaarden alstublieft.",
	"Check if the battery is not fully discharged": "Controleer of de batterij niet volledig ontladen is",
	"Check the Cloud connection of the paired dashcam": "Controleer de Cloud-verbinding van de gekoppelde dashcam.",
	"Connection lost": "Verbinding verloren",
	"A connection error has occurred shortly": "Er is een verbindingsfout opgetreden. Probeer binnenkort opnieuw verbinding te maken.",
	"Charging is limited": "Opladen is <b>beperkt</b>",
	"Cannot connect to the battery": "Kan geen verbinding maken met de batterij.",
	"Please check the Cloud connection of the camera": "Controleer alstublieft de Cloud-verbinding van de camera.",
	"Charging complete in": "Opladen gereed over %@",
	"Current Capacity": "Huidige Capaciteit",
	"Output Voltage": "Uitgangsspanning",
	"Charging Voltage": "Laadspanning",
	Beep: Beep$5,
	"Battery Capacity": "Capaciteit van de batterij",
	"Battery connection failed": "Batterij-verbinding mislukt",
	"Expansion battery": "Reservebatterij",
	"Make sure it is switched on and within range": "• Zorg dat het aanstaat en zich binnen bereik van uw mobiel bevindt.",
	"Make sure it is not wirelessly connected to another device": "• Zorg dat het niet draadloos is verbonden met een ander apparaat.",
	"Detected batteries": "Gedetecteerde batterijen",
	"Can't see your battery": "Ziet u uw batterij niet?",
	"Download the Blackvue app to check": "Download de BlackVue-app om uw batterij op afstand te controleren",
	"By Using the app": "Door de app te gebruiken, kunt u uw dashboardcamera koppelen aan de batterij en de capaciteit van de batterij via de cloud controleren. Na het koppelen kunt u de batterij controleren in de BlackVue Cloud Viewer.",
	Unpair: Unpair$5,
	"Occurs when the driver closes_": "Gebeurt wanneer de bestuurder beide ogen sluit tijdens het rijden",
	"Occurs when the driver's head_": "Gebeurt wanneer het hoofd van de bestuurder meer dan 50 graden van de voorkant is.",
	"Only detects distraction above_": "Detecteert alleen afleiding boven de ingestelde waarde. Je kunt de eenheid wijzigen in 'Camera-instellingen > Gebeurtenisactivators > Roekeloos rijden unit'.",
	"Occurs when the driver is not wearing_": "Gebeurt wanneer de bestuurder geen veiligheidsgordel draagt.",
	"Overlays a face detection box_": "Legt een gezichtsdetectiebox op live- en opgenomen beelden van de DMS-camera.",
	"Seat Belt": "Gordel",
	Detected: Detected$5,
	"No Seat Belt": "Geen gordel",
	"Fatigue Risk Alert": "Vermoeidheidsrisico-waarschuwing",
	"The time is synchronized_Email": "De tijd is gesynchroniseerd met de tijd in uw e-mailmeldingen.",
	"Sends an alert when drowsiness is_": "Stuurt een waarschuwing wanneer slaperigheid wordt gedetecteerd na de eerste slaperigheid.",
	"Data updates upon connection": "Gegevens worden bij verbinding bijgewerkt.",
	"Sends a notification if_": "Verstuurt een melding als u de 'Tijd instellen' tijdens uw rit overschrijdt.",
	"Data updates Alert": "[ Verbinden ]\nGegevens worden bij verbinding bijgewerkt.",
	"Cannot save settings": "Kan instellingen niet opslaan",
	"The time is synchronized_Push": "De tijd is gesynchroniseerd met de tijd in uw Push-meldingen.",
	"The file has been overwritten or deleted": "Het bestand is overschreven of verwijderd.",
	"Box Pro Models Settings": "Instellingen voor Box Pro Modellen",
	"Push notifications can be configured_": "Pushmeldingen kunnen worden geconfigureerd in de meldingsinstellingen van de camera.",
	"Recording Video": "Video-opname",
	"Cameras settings": "Camerainstellingen",
	"Please configure the settings": "Gelieve de instellingen te configureren",
	"Speed Priorities": "Snelheidsprioriteiten",
	"Set Speed Priority": "Snelheidsprioriteit instellen",
	"Geofence-enter": "Geofence-binnengaan",
	"Geofence-exit": "Geofence-verlaten",
	"Geofence-pass": "Geofence-passeren",
	"Geofence-speed alert": "Geofence-Snelheidswaarschuwing",
	"Drive Position": "Bestuurderspositie",
	"Left-Hand Drive": "Links stuur",
	"Right-Hand Drive": "Rechts stuur",
	"Please configure this setting_": "Wijzig deze instelling als de bestuurder niet correct wordt gedetecteerd.",
	"A new feature in the BlackVue settings_": "Er is een nieuwe functie in de BlackVue-instellingen toegevoegd om de cameratijd te synchroniseren. U moet uw cameratijd één keer synchroniseren voor een nauwkeurige tijdregistratie.",
	"Feature location_": "Functielocatie:\nCamera-instellingen> Systeem > Tijdsynchronisatie",
	"Time Sync": "Tijdsynchronisatie",
	"You can sync the time between_": "U kunt de tijd tussen uw apparaat en de BlackVue-camera synchroniseren. Voor synchronisatie moet de SD-kaart worden geformatteerd. Maak een back-up van alle benodigde video's voordat u doorgaat.",
	"Voice Alert": "Spraakwaarschuwing",
	"Provides a voice alert_": "Biedt een spraakmelding van de camera en stuurt een melding als je de ingestelde tijd tijdens je rit overschrijdt.",
	"Please enter a value": "Please enter a value.",
	"Notices & Notifications": "Nieuws & Meldingen",
	"Only detects drowsiness above_": "Detecteert alleen slaperigheid boven de ingestelde waarde. Je kunt de eenheid wijzigen in 'Camera-instellingen > Gebeurtenisactivators > Roekeloos rijden unit'.",
	Promotion: Promotion$5,
	Notice: Notice$5,
	"View More": "Meer bekijken",
	"Read More": "Lees verder",
	"Detection Box": "Detectiebox",
	"Seatbelt Detection Box": "Veiligheidsgordel Detectiebox",
	"Drive Position Detection Box": "Rijdpositie Detectiebox",
	"Fleet Subscription Promotion (50%)": "Promotie voor vlootabonnementen (50%)",
	"BlackVue Fleet Tracking exclusive features_": "Exclusieve functies van BlackVue Fleet Tracking voor zowel ervaren gebruikers als bedrijven (meerdere gebruikers en camera's, geofencing, webviewer enz.).",
	"Special Discount (50% off)": "Speciale korting (50% korting)",
	"*Promotion applied for 12 months": "*Promotie geldt voor 12 maanden",
	"*Payment will be made starting next month.": "*Betaling vindt vanaf volgende maand plaats.",
	"[About using promotions]": "[Over het gebruik van promoties]",
	"The promotion is free for the first month_": "De promotie is de eerste maand gratis en wordt vanaf de volgende maand voor 12 maanden gefactureerd.",
	"For users with an existing Lite/Smart subscription_": "Voor gebruikers met een bestaand Lite/Smart-abonnement moet u uw bestaande app-abonnement afzonderlijk opzeggen, anders wordt uw bestaande app-abonnement mogelijk in rekening gebracht op uw account.",
	"Please be sure to cancel your app subscription_": "Zorg ervoor dat u uw app-abonnement binnen de gratis periode opzegt. Dubbele betalingen worden niet terugbetaald.",
	"You will be changed to Fleet Plan immediately_": "U wordt onmiddellijk overgezet naar Fleet Plan, ook als de resterende abonnementstermijn van uw bestaande Lite/Smart Plan nog niet is verstreken.",
	"You can cancel Fleet Plan any time.": "U kunt Fleet Plan op elk gewenst moment opzeggen.",
	"From February 2025, please go to the Fleeta service and use it.": "Zodra de promotie is geannuleerd, wordt de promotie niet opnieuw toegepast.",
	"After promotion expires_": "Nadat de promotie is verlopen, wordt u automatisch verlengd met het bestaande Fleet Plan-abonnement.",
	"(Required) I have read the promotion instructions_": "(Verplicht) Ik heb de actie-instructies gelezen en ga akkoord met de betaling.",
	"Upgrade to Fleet Plan immediately": "Upgrade onmiddellijk naar Fleet Plan",
	"Important Notice:": "Belangrijke mededeling:",
	"Switch of BlackVue Web Viewer to Fleeta Web Viewer": "Overschakeling van BlackVue Web Viewer naar Fleeta Web Viewer",
	"To provide better features and quality_": "Om betere functies en kwaliteit te bieden, zal de BlackVue-webviewerservice binnenkort overschakelen naar een nieuwe vlootwebviewerservice genaamd Fleeta. Fleeta-services zijn alleen exclusief voor Fleet Plan-gebruikers. De Fleeta-service wordt in maart 2025 gelanceerd, met een nieuwe exclusieve Fleeta-app. Ga naar <a href=\"https://www.fleeta.io\" target=\"_blank\">fleeta.io</a> voor meer informatie.",
	"We kindly ask for your understanding_": "Wij vragen hiervoor uw begrip, aangezien deze wijziging bedoeld is om een ​​betere dienstverlening te kunnen leveren. Voor vragen over deze transitie kunt u gerust contact opnemen met ons CS-centrum.",
	"Don’t show this again for this month": "Laat dit deze maand niet meer zien",
	"Fleet Plan Subscription Promotion": "Promotie voor abonnementen op vlootplannen",
	"Period : December 2, 2024 ~ May 31, 2025": "Periode: 2 december 2024 t/m 31 mei 2025",
	"See more details": "Zie meer details",
	"To continue improve quality and provide better service_": "Om de kwaliteit te blijven verbeteren en een betere service te bieden, zal onze BlackVue Web Viewer-service binnenkort overschakelen naar een exclusieve Fleet Plan-service. Vanaf eind maart 2025 zal het niet langer gratis of via andere abonnementen beschikbaar zijn.",
	"We have prepared special discount offers for_": "We hebben speciale kortingsaanbiedingen voorbereid voor onze bestaande Web Viewer-gebruikers. Controleer de onderstaande gegevens! Wij vragen vriendelijk om uw begrip en steun bij het doorvoeren van deze wijziging om een ​​betere service te kunnen bieden.\n",
	"*If you are subscribed in-app_": "*Als u in-app bent geabonneerd, zorg er dan voor dat u uw in-app-abonnement annuleert.",
	"Enjoy your BlackVue Cloud service with your dashcam.": "Geniet van uw BlackVue Cloud-service met uw dashcam.",
	"Available Cloud Camera slot(s)_": "Beschikbare Cloud Camera-slot(s) : {{d}}",
	"Not eligible for the promotion.": "Komt niet in aanmerking voor de promotie.",
	"You have already used_": "Je hebt al gebruik gemaakt van deze promotie. Zodra de promotie is geannuleerd, kan deze niet opnieuw worden toegepast.",
	"Go to Cameras": "Ga naar Camera's",
	"Congratulations !": "Congratulations !",
	"Fleet Plan user": "Fleet Plan user",
	"Let your BlackVue monitor_": "Laat uw BlackVue uw auto in de gaten houden en u waarschuwen bij incidenten. Op het moment dat een impact wordt gedetecteerd, stuurt uw BlackVue een melding naar uw telefoon, vergezeld van een momentopname.\n",
	"Live Event Upload feature automatically_": "De functie Live Event Upload uploadt automatisch videobeelden, inclusief beelden van vóór het ongeval, naar BlackVue Cloud Storage om uw video's veilig te houden!",
	"*Buffer time varies by model.": "*Buffertijd varieert per model.",
	Explore: Explore$5,
	"Cloud Storage": "Cloudopslag",
	"My Cloud Cameras": "Mijn cloudcamera's",
	"My Cloud Cameras Only": "Alleen mijn cloudcamera's",
	"BlackVue Live Camera": "BlackVue Live-camera",
	"*For BlackVue Live Cameras_": "*Voor BlackVue Live-camera's kunnen alleen camera's die als openbaar zijn gedeeld in de camera-instellingen op de kaart worden bekeken.",
	"*Share Method_": "*Deelmethode: Camera-instelling>Privacy",
	"Once the promotion is canceled_": "Zodra de promotie is geannuleerd, wordt de promotie niet opnieuw toegepast.",
	"It will show_": "Het zal hier verschijnen als ze beschikbaar komen.",
	"Deactivate Cloud": "Deactiveer Cloud",
	"Are you sure you want to deactivate_": "Weet u zeker dat u Cloud voor deze camera wilt deactiveren?",
	"Deactivate : It doesn’t_": "U kunt de cloud altijd en op elk gewenst moment activeren. De camera kan worden verwijderd nadat de deactivering is voltooid.",
	Deactivate: Deactivate$5,
	"*If you made the payment through_": "*Als u via de app heeft betaald, start u de app opnieuw op.",
	"Connect Dashcam Locally (Wi-Fi)": "Dashcam lokaal verbinden (Wi-Fi)",
	"Cloud Connection Setting": "Cloud-verbindingsinstelling",
	"Camera Profile": "Cameraprofiel",
	"Camera Settings": "Camera-instellingen",
	"Format MicroSD Card": "MicroSD-kaart formatteren",
	"Remote Firmware Update": "Firmware-update op afstand",
	"Remove from Cloud": "Verwijderen uit de cloud",
	"The location may not be accurate_": "De locatie is mogelijk niet nauwkeurig omdat de camera niet met de cloud is verbonden.",
	"The location of the camera cannot be found_": "De locatie van de camera kan niet worden gevonden. Controleer de Cloud-verbindingsinstellingen.",
	"Manage\nFLEETA Drive": "Beheren\nFLEETA Schijf",
	"Cloud\nConnection": "Cloud\nverbinding",
	"Available on FLEETA App": "Beschikbaar op de FLEETA App",
	"Available for Cloud dashcam OR on FLEETA App.": "Beschikbaar voor Cloud dashcam OF op de FLEETA App.",
	"Get started with_": "Begin met een gratis proefperiode van 1 maand",
	"Experience all of_": "Ervaar alle premium functies van FLEETA gratis tijdens uw proefperiode van 1 maand.\n\nGeen verplichting—op elk moment opzeggen",
	"Welcome to FLEETA Webviewer.": "Welkom bij FLEETA Webviewer.",
	"Let FLEETA get_": "Laat FLEETA u leren kennen",
	"Help improve your_": "Help uw ervaring verbeteren door enkele details te delen",
	"Business Industry": "Zakelijke sector",
	"Vehicle & Cargo": "Voertuigen & Lading",
	Compliance: Compliance$5,
	"Would you like to skip?": "Wilt u overslaan?",
	"What is your business industry?": "In welke branche is uw bedrijf actief?",
	"Transportation & Logistics": "Transport en Logistiek",
	"Rental & Leasing": "Huur en Leasing",
	"Construction & Building": "Bouw en Gebouw",
	"Government & Public": "Overheid en Publiek",
	"Facility & Utility Management": "Facilitair en Nutsbeheer",
	Manufacturing: Manufacturing$5,
	"Retail & Wholesale": "Detailhandel en Groothandel",
	Emergency: Emergency$5,
	Security: Security$5,
	"How many employees do you need to manage?": "Hoeveel werknemers moet u beheren?",
	"How many vehicles does your company operate?": "Hoeveel voertuigen exploiteert uw bedrijf?",
	"Why do you use a fleet tracking service?": "Waarom gebruikt u een wagenparkvolgsysteem?",
	"Route Tracking": "Route tracking",
	"Real-time Monitoring": "Real-time monitoring",
	"Incident Detection & Check video": "Incident detectie & Video controleren",
	"Behavior Monitoring & Analysis": "Gedragsmonitoring & Analyse",
	"Evaluation & Management": "Evaluatie & Beheer",
	"Theft Prevention": "Diefstalpreventie",
	"Monitoring & Maintenance": "Monitoring & Onderhoud",
	"Verification & Management": "Verificatie & Beheer",
	"BlackVue App Use Only": "Alleen voor gebruik met de BlackVue-app",
	"Your current plan allow_": "Uw huidige plan staat het gebruik van de BlackVue-app toe. Om de Web Viewer te gebruiken, abonneer u alstublieft op het Fleet Plan (FLEETA).",
	"Learn more about the Fleet_": "Meer weten over het Vlootplan (FLEETA)",
	"Special Offer": "Speciale Aanbieding",
	"For a limited time_": "Voor een beperkte tijd, geniet van 50% korting op uw Vlootplan-abonnement.",
	"See Discount Details": "Bekijk kortingsdetails",
	"To subscribe to the Fleet_": "Om te abonneren op het Vlootplan, annuleer eerst uw BlackVue-abonnement in de app om dubbele kosten te vermijden.",
	"Skip tour": "Tour overslaan",
	"In the cloud_": "In de cloudomgeving kunt u toegang krijgen tot afspelen, live bekijken (inclusief multiview), live GPS en rapporten, allemaal via de FLEETA Web Viewer.",
	"Cloud Storage is_": "Cloudopslag is de plek waar uw geüploade video's veilig in de cloud worden opgeslagen. Upload uw video's om ze lang veilig te houden.",
	"Toggle to switch_": "Schakelen tussen Kaart / Lijst",
	"In List View_": "In de Lijstweergave kunt u gemakkelijk groepen, leden en firmware-informatie in één oogopslag bekijken en beheren.",
	"What is Cloud Storage?": "Wat is Cloudopslag?",
	"Cloud Storage Overview": "Overzicht van Cloudopslag",
	"Difference Between FLEETA_": "Verschil tussen FLEETA Schijf en Live-evenementen uploaden",
	"FLEETA Drive stores_": "FLEETA Schijf slaat video's op die je handmatig hebt geüpload",
	"Live Event Upload automatically_": "Live-evenementen uploaden slaat automatisch video's op wanneer er een gebeurtenis plaatsvindt.",
	"Live Event Upload videos_": "Video's van Live-evenementen uploaden hebben een vervaldatum. Als je ze lang wilt bewaren, verplaats ze dan naar FLEETA Schijf.",
	"Note: SD Card_": "Opmerking: SD-kaartvideo's in Afspelen",
	"Videos stored on_": "Video's opgeslagen op uw SD-kaart kunnen worden benaderd via het Afspelen-menu.",
	"Set your image_": "Stel uw afbeelding in met de meegeleverde lijst. Zodra de afbeelding is opgeslagen, wordt deze weergegeven op de camerakaart en het kaartweergavepictogram.",
	"*Only jpg and_": "*Alleen jpg- en png-bestanden worden ondersteund.",
	"Set as default image": "Instellen als standaardafbeelding",
	"Camera Details": "Cameradetails",
	"IT & Telecommunications": "IT en Telecommunicatie",
	"The name must_32": "De naam moet 1 tot 32 tekens bevatten.",
	"Unable to display the map.": "Kan de kaart niet weergeven.",
	"The camera location cannot be found_": "De locatie van de camera kan niet worden gevonden vanwege een slechte GPS-verbinding.",
	"Cloud Cameras": "Cloudcamera's",
	"Want to unlock_": "Wilt u functies voor wagenparkbeheer ontgrendelen?",
	"*Web subscription only": "*Alleen webabonnement",
	"Uploads event_": "Uploadt direct beeldmateriaal van het evenement naar de Cloudopslag zodra het evenement plaatsvindt.",
	"Starts a conversation_": "Start een gesprek met de bestuurder via de luidspreker en microfoon van de dashcam.",
	"Remotely check_": "Controleer op afstand het batterijniveau en de status via de cloud.",
	"Receive a voice_": "Ontvang een gesproken waarschuwing en meldingen als de rijtijd de limiet overschrijdt.",
	"View your_": "Bekijk uw rijlogboek op de kaart.",
	"View speed, event_": "Bekijk snelheid, gebeurtenistype en speel gerelateerde video's direct op de kaart af.",
	"FLEETA Tracking exclusive_": "FLEETA Tracking biedt exclusieve functies voor zowel powergebruikers als bedrijven (Meerdere gebruikers en camera's, geofencing, etc.).",
	"Cloud Cameras per Account": "Cloudcamera's per account",
	"Connect Dashcam Locally_": "Dashcam lokaal verbinden (Wi-Fi) (Afspelen, Downloaden, Live bekijken)",
	"Available with_": "Beschikbaar met BlackVue batterij",
	"Cloud Battery": "Cloud batterij",
	"Driving Reports": "Rijrapporten",
	"Video on Map": "Video op de kaart",
	"Multi Live View (Fleeta Web Viewer)": "Multi Live Bekijken (FLEETA Webviewer)",
	"Enter a number": "Voer een nummer in",
	"Permission required.": "Toestemming vereist.",
	"Please contact_": "Neem contact op met de eigenaar voor hulp.",
	"Access not available": "Toegang niet beschikbaar.",
	"This file cannot be deleted now.": "Dit bestand kan nu niet worden verwijderd.",
	"Please try again later.": "Probeer het later opnieuw.",
	"Permission required.\nPlease_": "Toestemming vereist.\nNeem contact op met de eigenaar voor hulp.",
	"Cloud Storage is disconnected_": "Cloudopslag is verbroken. Controleer de verbinding.",
	"Manage the plan_": "Beheer het plan om de camera te herstellen",
	"Notify the owner_": "Informeer de eigenaar om het plan te beheren",
	"Access Restricted:_": "Toegang Beperkt: Abonnement Verlopen",
	"Access is currently_": "Toegang is momenteel niet beschikbaar vanwege een verlopen abonnement.",
	"Please contact your owner_": "Neem contact op met uw eigenaar om dit probleem op te lossen.",
	"Access will be_": "Toegang wordt hersteld zodra het abonnement is vernieuwd",
	"Cloud is disconnected_": "Cloudopslag is verbroken. \nControleer de verbinding.",
	"Connect to Cloud with_": "Verbind met Cloudopslag via de FLEETA APP",
	"Using Wi-Fi Hotspot": "Gebruik van Wi-Fi-hotspot",
	Important: Important$5,
	"Pre-Event buffer_": "Pre-Event bufferopname is uitgeschakeld in deze modus.",
	"connectivity is_": "Connectiviteit is beperkt in deze modus.",
	"video upload starts_": "Het uploaden van de video begint nadat de opname is voltooid.",
	"Power Saving": "Energiebesparing",
	"In all modes_": "In alle modi activeren gedetecteerde impacts Event video-opnames.",
	"Battery Protection setting _": "De instelling voor Batterijbescherming moet AAN staan.",
	"At least one of_": "Ten minste een van de volgende instellingen moet ingeschakeld zijn",
	or: or$5,
	"For BlackVue battery users": "Voor BlackVue batterijgebruikers",
	"we recommend setting_": "We raden aan de spanningsafsluiting in te stellen op de minimale waarde voor maximaal batterijgebruik.",
	"No videos were found.": "Geen video's gevonden.",
	"Try different filter_": "Probeer een andere filter of reset de filter.",
	"Not avaliable with_": "Niet beschikbaar met de huidige camera",
	"Overlays a detection_": "Plaatst een detectiekader op live en opgenomen beelden van de DMS-camera.",
	"A minute of_": "Een minuut video van de frontcamera zal ongeveer",
	"System voice guidance": "Systeemstembegeleiding",
	"Recording trigger": "Opname Trigger",
	"Remote Button (Optional)": "Afstandsbedieningsknop (Optioneel)",
	"Remote button settings_": "Instellingen voor de afstandsbedieningsknop kunnen niet via een cloudverbinding worden gewijzigd. Om deze instellingen te wijzigen, navigeer naar Camera > Lokaal verbinden > Camerainstellingen.",
	"No Registered Device": "Geen geregistreerd apparaat",
	"Subscription process is complete": "Het abonnementsproces is voltooid",
	"Now, go back to_": "Ga nu terug naar de FLEETA-app, log in op uw account en begin met het genieten van de service.",
	"You can check the upload progress": "U kunt de voortgang van de upload controleren in het tabblad Cloudopslag > FLEETA Schijf.",
	"SIM card must be inserted in_": "Er moet een SIM-kaart in de camera zijn geplaatst om Cloud te kunnen gebruiken.",
	"Active until:": "Actief tot:",
	Subscribe: Subscribe$5,
	"Camera PSN": "Camera-PSN",
	"BlackVue Sim Free Trial Started!": "Gratis proefperiode voor BlackVue Sim gestart!",
	"Enjoy a free period to use your SIM_": "Geniet van een gratis periode om je simkaart te gebruiken zonder abonnement!",
	"You can stay connected during the trial_": "U kunt tijdens de proefperiode verbonden blijven, maar onthoud:",
	"Complete your subscription before the trial_": "Voltooi uw abonnement voordat de proefperiode afloopt om de simkaart te blijven gebruiken.",
	"If you don't subscribe by the end of the trial_": "Als u zich aan het einde van de proefperiode niet abonneert, wordt uw simkaartservice gedeactiveerd.",
	"Save Event Videos_": "Bewaar evenementvideo's in realtime in de cloudopslag!",
	"Note: Deleting your account doesn’t cancel": "Opmerking: Het verwijderen van uw account annuleert uw abonnement niet. Om te annuleren, ga naar Account > Abonnement op de FLEETA webviewer.",
	"Available only on FLEETA App for_": "Alleen beschikbaar op de FLEETA App voor dit model.",
	"The cloud is deactivated": "De cloud is gedeactiveerd.",
	"Please add a camera with FLEETA_": "Voeg alstublieft een camera toe met de FLEETA APP om deze functie te gebruiken.",
	"Upload videos to FLEETA_": "Upload video's naar FLEETA Schijf en houd ze veilig!",
	"You have no assigned camera_": "U heeft geen toegewezen camera.\nNeem contact op met de eigenaar om toewijzing aan te vragen.",
	"Camera notification settings": "Camera meldingsinstellingen",
	Vehicle: Vehicle$5,
	"App Download": "App downloaden",
	"Have a problem with_": "Heeft u een probleem met uw abonnement?",
	"Restore Purchase": "Aankoop herstellen",
	"Battery Pairing": "Batterij koppelen",
	"Playback\nLive View": "Afspelen/\nLiveweergave",
	"Remote Playback": "Afspelen op afstand",
	"Cloud connection settings": "Instellingen voor cloudverbinding",
	"Go to settings": "Ga naar instellingen",
	"Only cloud cameras that_": "Alleen cloudcamera’s die gebruikers ervoor kiezen om openbaar te delen, worden op de kaart weergegeven.",
	"Live Broadcast Cameras": "Live-uitzendcamera's",
	"*Live Broadcast Cameras_": "*Live-uitzendingcamera's zijn cloudcamera's die door gebruikers zijn ingesteld om uit te zenden.",
	"Only cloud cameras_": "Alleen cloudcamera's die gebruikers kiezen om uit te zenden, worden op de kaart getoond."
};

var Dashboard$4 = "Pulpit";
var Account$4 = "Konto";
var Help$4 = "Pomoc";
var Mac$4 = "Mac";
var Windows$4 = "Windows";
var Admin$4 = "Administrator";
var Driver$4 = "Kierowca";
var Cameras$4 = "Kamery";
var Manage$4 = "Zarządzaj";
var Clear$4 = "Jasny";
var Show$4 = "Pokazać";
var GB$4 = "{{a}} GB";
var _section$4 = "sekcji.";
var Name$4 = "Nazwisko";
var Password$4 = "Hasło";
var Cancel$4 = "Anuluj";
var Members$4 = "Członkowie";
var Groups$4 = "Grupy";
var Role$4 = "Rola";
var Group$4 = "Grupa";
var Status$4 = "Stan";
var nPM$4 = "{{a}} po południu";
var nAM$4 = "{{a}} przed południem";
var Newest$4 = "Najnowsze";
var Oldest$4 = "Najstarsze";
var Accepted$4 = "Zaakceptowane";
var Pending$4 = "Oczekujące";
var Expired$4 = "Wygasłe";
var All$4 = "Wszystko";
var Delete_$4 = "Usuń {{a}}";
var Delete$4 = "Usuń";
var Rename$4 = "Zmień nazwę";
var Add$4 = "Dodaj";
var OK$4 = "OK";
var Remove$4 = "Usuń";
var Files$4 = "Pliki";
var Features$4 = "Funkcje";
var Settings$4 = "Ustawienia";
var Upload$4 = "Przekazać plik";
var Privacy$4 = "Prywatność";
var Done$4 = "Gotowe";
var Subscription$4 = "Subskrypcja";
var Submasters$4 = "Administratorzy";
var Users$4 = "Kierowcy";
var Change$4 = "Zmień";
var Method$4 = "Metoda";
var Details$4 = "Informacje o kamerze";
var Confirm$4 = "Potwierdź";
var Address$4 = "Adres";
var Country$4 = "Kraj";
var State$4 = "Województwo";
var ZIP$4 = "ZIP";
var Pricing$4 = "Cennik";
var Free$4 = "Free";
var Smart$4 = "Smart";
var Fleet$4 = "Fleet";
var Subscrubed$4 = "Subskrybowane";
var January$4 = "styczeń";
var February$4 = "Luty";
var March$4 = "Marsz";
var April$4 = "kwiecień";
var May$4 = "Może";
var June$4 = "czerwiec";
var July$4 = "lipiec";
var August$4 = "sierpień";
var September$4 = "wrzesień";
var October$4 = "październik";
var November$4 = "listopad";
var December$4 = "grudzień";
var Blackvuecloud_$4 = "www.blackvuecloud.com";
var Support$4 = "Support";
var Community$4 = "Community";
var FAQ$4 = "FAQ";
var Developers$4 = "Developers";
var Facebook$4 = "Facebook";
var Twitter$4 = "Twitter";
var Instagram$4 = "Instagram";
var Youtube$4 = "Youtube";
var Linkedin$4 = "Linkedin";
var Downloads$4 = "Pakiety do pobrania";
var Unauthorized$4 = "Nieautoryzowane";
var none$4 = "Brak";
var Email$4 = "E-mail";
var Customers$4 = "Customers";
var Home$4 = "Home";
var Plan$4 = "Plan";
var New$4 = "New";
var Unsubscribed$4 = "Unsubscribed";
var Edit$4 = "Edit";
var month$4 = "month";
var months$4 = "months";
var Continue$4 = "Continue";
var Back$4 = "Plecy";
var Master$4 = "Owner";
var Develop$4 = "Developers";
var $9$4 = "$9";
var $15$4 = "$15";
var $10$4 = "$10";
var mo$4 = "Miesiąc";
var City$4 = "Miejscowość";
var Charge$4 = "Opłata";
var subscribe$4 = "Subskrybuj";
var search$4 = "Wyszukaj";
var invalid_number$4 = "Podany numer karty nie jest prawidłowym numerem karty kredytowej";
var invalid_expiry_month$4 = "Miesiąc wygaśnięcia karty jest nieprawidłowy";
var invalid_expiry_year$4 = "Rok wygaśnięcia karty jest nieprawidłowy";
var invalid_cvc$4 = "Kod zabezpieczający karty jest nieprawidłowy";
var incorrect_number$4 = "Numer karty jest niepoprawny";
var incomplete_number$4 = "Numer karty jest niekompletny";
var incomplete_cvc$4 = "Kod zabezpieczający karty jest niekompletny";
var incomplete_expiry$4 = "Data wygaśnięcia karty jest niekompletna";
var expired_card$4 = "Karta wygasła";
var incorrect_cvc$4 = "Kod zabezpieczający karty jest niepoprawny";
var incorrect_zip$4 = "Sprawdzanie kodu pocztowego przypisanego do karty nie powiodło się";
var invalid_expiry_year_past$4 = "Rok wygaśnięcia karty minął";
var card_declined$4 = "Karta została odrzucona";
var missing$4 = "Nie przypisano karty do klienta, od którego jest pobierana opłata.";
var processing_error$4 = "Wystąpił błąd podczas przetwarzania karty";
var Paypal$4 = "Paypal";
var iOS$4 = "iOS";
var Android$4 = "Android";
var Total$4 = "Łącznie";
var And$4 = "i";
var Camera$4 = "Camera";
var Yes$4 = "Tak";
var No$4 = "Nie";
var News$4 = "Wiadomości";
var Notifications$4 = "Powiadomienia";
var MPH$4 = "MPH";
var Firmware$4 = "Oprogramowanie układowe";
var Basic$4 = "Podstawowe";
var Resolution$4 = "Rozdzielczość";
var Brightness$4 = "Jasność";
var Recording$4 = "Nagrywanie";
var Highest$4 = "Najwyższa";
var High$4 = "Wysoka";
var Normal$4 = "Normalna";
var Sensitivity$4 = "Czułość";
var Volume$4 = "Głośność";
var Close$4 = "Close";
var Cloud$4 = "Cloud";
var Public$4 = "Public";
var Front$4 = "Przód";
var Rear$4 = "Tył";
var Play$4 = "Odtwórz";
var Stop$4 = "Zatrzymaj";
var Pause$4 = "Wstrzymaj";
var Time$4 = "Time";
var System$4 = "System";
var Event$4 = "Zdarzenie";
var Parking$4 = "Parkowanie";
var Color$4 = "Kolor";
var Exit$4 = "Zakończ";
var Save$4 = "Zapisz";
var Impact$4 = "Wstrząs";
var Unlimited$4 = "Nieograniczone";
var Default$4 = "Domyślnie";
var Version$4 = "Wersja";
var Language$4 = "Język";
var Notification$4 = "Powiadamianie";
var Multiple$4 = "Wybór wielokrotny";
var Range$4 = "Zakres";
var Download$4 = "Pobieranie";
var Manual$4 = "podręcznik";
var Satellite$4 = "Satelita";
var Tutorials$4 = "Samouczki";
var Filter$4 = "Filtr";
var Sun$4 = "nd";
var Mon$4 = "pn";
var Tue$4 = "wt";
var Wed$4 = "śr";
var Thu$4 = "cz";
var Fri$4 = "pt";
var Sat$4 = "sb";
var Dates$4 = "Daty";
var Routes$4 = "Trasy";
var Opacity$4 = "nieprzezroczystość";
var Entry$4 = "Wjazd";
var Owner$4 = "Owner";
var Undetected$4 = "nie wykryty";
var Distracted$4 = "Rozproszony";
var Drowsy$4 = "Drowsy";
var Calling$4 = "Calling";
var Smoking$4 = "Smoking";
var Permissions$4 = "Uprawnienia";
var Private$4 = "Prywatne";
var Entering$4 = "Wjazd";
var Exiting$4 = "Wyjazd";
var Acceleration$4 = "Przyspieszanie";
var Passing$4 = "Przejazd";
var Overspeed$4 = "Nadmierna prędkość";
var Recipients$4 = "Odbiorcy";
var Send$4 = "Wyślij";
var Note$4 = "Uwaga";
var Video$4 = "Wideo";
var Advanced$4 = "Zaawansowane";
var Voice$4 = "Głos";
var Days_$4 = "Dni";
var Mute$4 = "Wycisz";
var UnMute$4 = "Anuluj wyciszenie";
var Discard$4 = "Odrzuć";
var Report$4 = "Report";
var Individual$4 = "Indywidualny kierowca poszukujący użytecznych technologii? Właściciel firmy poszukujący prostego rozwiązania do ochrony i śledzenia pojazdów?";
var Subscribed$4 = "Subskrybowane";
var Geofence$4 = "Ogrodzenie wirtualne";
var Driving$4 = "Prowadzenie pojazdu";
var Idling$4 = "Bezczynność";
var Distance$4 = "Dystans";
var Parked$4 = "Parked";
var Speed$4 = "Prędkość";
var Highest_2$4 = "Najwyższa";
var Average$4 = "Średnia";
var Geofences$4 = "Ogrodzenia wirtualne";
var Move$4 = "Przenieś";
var Connected$4 = "Połączono";
var Individual_$4 = "Osoba";
var Always$4 = "Zawsze";
var Low$4 = "Niska";
var Medium$4 = "Średnia";
var High_2$4 = "Wysoka";
var Flip$4 = "Przerzuć";
var Previous$4 = "Poprzednia klatka";
var Next$4 = "Następne";
var Expand$4 = "Rozwiń";
var Collapse$4 = "Zwiń";
var More$4 = "Więcej";
var Multi$4 = "Wybór wielokrotny";
var Safe$4 = "Bezpieczny";
var Reckless$4 = "Nierozważny";
var Inattentive$4 = "Nieuważny";
var List$4 = "Lista";
var Usage$4 = "Użytkowanie";
var Profile$4 = "Profil";
var Fullscreen$4 = "Pełny ekran";
var Upgrade$4 = "Uaktualnij";
var Management$4 = "Zarządzanie";
var Day$4 = "Dzień";
var Month$4 = "Miesiąc";
var Later$4 = "Później";
var ICCID$4 = "ICCID";
var Resubscribe$4 = "Subskrybuj ponownie";
var plan$4 = "pakiet";
var USD$4 = "USD";
var etc_$4 = "itd.:";
var Available$4 = "Dostępne";
var Used$4 = "Zużyto";
var Cancelled$4 = "Anulowano";
var Terminated$4 = "Zakończono";
var Sort$4 = "Sortuj";
var Bonus$4 = "Dodatek";
var incomplete_zip$4 = "Sprawdzanie kodu pocztowego przypisanego do karty nie powiodło się";
var Upgrades$4 = "Aktualizacje";
var OR$4 = "LUB";
var Undo$4 = "Anulować";
var Invoice$4 = "Faktura";
var data$4 = "Dane";
var Popular$4 = "Popular";
var Mask$4 = "Zdjęcie maski";
var DMS$4 = "Driver Monitoring System (DMS)";
var Extreme$4 = "Ekstremalne";
var OFF$4 = "Wyłączone";
var Threshold$4 = "Wartość progowa";
var Drowsiness$4 = "Senność";
var Direct$4 = "Bezpośr.";
var Remote$4 = "Zdalne";
var Update$4 = "Aktualizuj";
var Option$4 = "Opcjonalnie";
var Required$4 = "Wymagane";
var Optional$4 = "Opcjonalne";
var Others$4 = "Inne";
var Stay$4 = "Nie zmieniaj";
var Mask_2$4 = "Mask";
var Low_2$4 = "Low";
var Medium_2$4 = "Medium";
var High_3$4 = "High";
var Highest_3$4 = "Highest";
var Extreme_2$4 = "Extreme";
var Private_2$4 = "Private";
var Lite$4 = "Lite";
var Bitrate$4 = "Surrate";
var hours$4 = "Godziny";
var Expires$4 = "Wygaśnie";
var Check$4 = "Sprawdź";
var Saving$4 = "Zapisywanie";
var Now$4 = "Teraz";
var Beep$4 = "Dźwięk ostrzeżenia";
var Unpair$4 = "Rozłącz";
var Detected$4 = "Wykryto";
var Promotion$4 = "Promocja";
var Notice$4 = "Aktualizacje";
var Explore$4 = "Badać";
var Deactivate$4 = "Dezaktywować";
var Compliance$4 = "Zgodność";
var Manufacturing$4 = "Produkcja";
var Emergency$4 = "Nagły wypadek";
var Security$4 = "Bezpieczeństwo";
var Important$4 = "Ważne";
var or$4 = "lub";
var Subscribe$4 = "Subskrybować";
var Vehicle$4 = "pojazd";
var pl = {
	Dashboard: Dashboard$4,
	"Payment & Subscriptions": "Płatności i subskrypcje",
	"Fleet Management": "Zarządzanie taborem",
	"Available to master": "Dostępne dla administratora",
	"Available to Fleet_": "Dostępne dla użytkowników planu taboru",
	Account: Account$4,
	"Log out": "Wyloguj",
	"© 2019 Pittasoft_": "© 2019 Pittasoft Co. Ltd",
	"Privacy policy": "Zasady ochrony prywatności",
	"Terms of service": "Warunki świadczenia usługi",
	Help: Help$4,
	"App store": "App store",
	"Google Play": "Google Play",
	Mac: Mac$4,
	Windows: Windows$4,
	"Free Plan": "Free Plan",
	"Basic Plan": "Basic Plan",
	"Smart Plan": "Smart Plan",
	Admin: Admin$4,
	Driver: Driver$4,
	"Period : December 3, 2024 ~ May 31, 2025": "Okres: 3 grudnia 2024 r. ~ 31 maja 2025 r",
	Cameras: Cameras$4,
	"n of n": "{{a}} z {{b}}",
	Manage: Manage$4,
	"Upgrade Plan": "Uaktualnij plan",
	"Add more cameras_": "Dodawanie kamer, zarządzanie taborem i więcej...",
	"Usage statistics": "Statystyki użycia",
	"All cameras": "Wszystkie kamery",
	Clear: Clear$4,
	Show: Show$4,
	"Live views": "Zdalny podgląd na żywo",
	"nh:nm:ns": "{{a}}h:{{b}}m:{{c}}s",
	"Video plays and_": "Odtwarzanie wideo i pobieranie",
	"Space available": "Dostępne miejsce",
	GB: GB$4,
	"n%": "{{a}}%",
	"BlackVue app for_": "Aplikacja BlackVue dla systemu iOS i Android",
	"BlackVue viewer for_": "Przeglądarka BlackVue dla systemu Mac i Windows",
	"Welcome to fleet": "Zapraszamy do taboru",
	"A few things_": "Czego możesz się spodziewać:",
	"You can watch_": "Możesz wyświetlać nagrania wideo z przypisanych kamer w aplikacji BlackVue lub Desktop Viewer.",
	"If the master_deletes": "Jeżeli administrator usunie swoje konto, Twoje konto również zostanie usunięte.",
	"If the masters_Fleet": "Jeżeli subskrypcja planu taboru administratora wygaśnie, wciąż możesz uzyskać dostęp do swojego konta w trybie tylko do odczytu.",
	"You have to_": "Aby dodać kamerę osobistą, musisz zarejestrować inne konto.",
	"The Payments &_": "Sekcje Płatności i subskrypcje oraz Zarządzanie taborem są dostępne tylko dla administratora.",
	"You can manage_": "Możesz zarządzać swoją grupą taboru w",
	"_Fleet management": "Zarządzanie taborem",
	_section: _section$4,
	"The Payments_section-": "Sekcja Płatności i subskrypcje jest dostępna tylko dla administratora.",
	"Youre almost there": "Prawie gotowe",
	"Finish account setup": "Zakończ konfigurację konta",
	"Install and log_": "Zainstaluj aplikację BlackVue lub Desktop Viewer i zaloguj się",
	"Download on the_": "Pobierz z App Store",
	"GET IT ON_": "POBIERZ z Google Play",
	"Download for Mac": "Pobierz dla Mac",
	"Download for Windows": "Pobierz dla Windows",
	"Add your camera_": "Dodaj kamerę w aplikacji BlackVue lub Desktop Viewer",
	"Start managing your_": "W tym miejscu można zarządzać taborem i wyświetlać statystki użycia",
	"Cancelled Fleet Plan_": "Plan taboru został anulowany {{date}}",
	"The new plan_": "Nowy plan będzie obowiązywać po zakończeniu bieżącego cyklu rozliczeniowego.",
	"Profile photo": "Zdjęcie profilowe",
	Name: Name$4,
	"E-mail address": "Adres e-mail",
	Password: Password$4,
	"Last changed_": "Ostatnio modyfikowane {{a}}",
	"Change password": "Zmień hasło",
	"Delete account": "Usuń konto",
	Cancel: Cancel$4,
	"Current password": "Bieżące hasło",
	"New password": "Nowe hasło",
	"Confirm new password": "Potwierdź nowe hasło",
	"Password changed": "Zmieniono hasło",
	"Reason for deletion_": "Przyczyna usunięcia (opcjonalne)",
	"Account password": "Hasło do konta",
	Members: Members$4,
	Groups: Groups$4,
	"+ Invite member": "+ Zaproś członka",
	"Name, Email": "Nazwisko, e-mail",
	Role: Role$4,
	Group: Group$4,
	"Date invited": "Data zaproszenia",
	Status: Status$4,
	"Group n": "Grupa {{a}}",
	nPM: nPM$4,
	nAM: nAM$4,
	Newest: Newest$4,
	Oldest: Oldest$4,
	"Name, email or_": "Nazwisko, e-mail lub grupa",
	Accepted: Accepted$4,
	Pending: Pending$4,
	Expired: Expired$4,
	All: All$4,
	"No results": "Brak wyników",
	"Try different keywords": "Użyj innych słów kluczowych",
	"Try changing or_": "Zmień lub usuń filtry",
	"Remove all filters": "Usuń wszystkie filtry",
	"Invite member": "Zaproś członka",
	"Send invite": "Wyślij zaproszenie",
	"You have reached_": "Osiągnięto limit 10 zastępców administratora. Możesz zapraszać kolejnych użytkowników.",
	Delete_: Delete_$4,
	"Are you sure_delete": "Czy na pewno chcesz usunąć tego członka i jego konto?",
	Delete: Delete$4,
	Rename: Rename$4,
	"No submaster yet": "Jeszcze brak zastępcy administratora",
	"You can add_": "Możesz dodać jednego zastępcę administratora dla każdej grupy",
	"No cameras yet": "Jeszcze brak kamer",
	"Add cameras first_": "Najpierw dodaj kamery, a następnie przypisz użytkowników.",
	"Name or email": "Nazwisko lub e-mail",
	"Add submaster": "Dodaj zastępcę administratora",
	Add: Add$4,
	"Add camera": "Dodaj kamerę",
	"n of n selected": "Wybrano {{a}} z {{b}}",
	"No cameras available": "Brak dostępnych kamer",
	"Most likely reasons_": "Najbardziej prawdopodobne przyczyny:",
	"All cameras were_": "Wszystkie kamery zostały dodane do innych grup.",
	"You can remove_": "Możesz usunąć kamery z innych grup i dodać je do tej grupy.",
	"No cameras were_": "Nie dodano kamer do Twojego konta.",
	"You can add_cameras": "Możesz dodać kamery w aplikacji BlackVue lub Desktop Viewer.",
	OK: OK$4,
	"Rename group": "Zmień nazwę grupy",
	"Are you sure_group": "Czy na pewno chcesz usunąć tę grupę?",
	"Edit Mobile app_": "Edytuj uprawnienia aplikacji mobilnej / przeglądarki komputerowej",
	Remove: Remove$4,
	"n of n users": "{{a}} z {{b}} użytkowników",
	"Youve reached the_": "Osiągnięto limit liczby użytkowników na kamerę",
	"Remove user": "Usuń użytkownika",
	"Add user": "Dodaj użytkownika",
	"+ Add group": "+ Dodaj grupę",
	"Add group": "Dodaj grupę",
	"Group or submaster": "Grupa lub zastępca administratora",
	"+ Add": "+ Dodaj",
	"of max selected": "Wybrano {{a}} z maks. {{b}}",
	"Mobile app/desktop_": "Uprawnienia aplikacji mobilnej / przeglądarki komputerowej",
	Files: Files$4,
	Features: Features$4,
	Settings: Settings$4,
	Upload: Upload$4,
	"Download and Playback_Cloud": "Pobieranie i odtwarzanie z magazynu chmurowego",
	"Download and Playback_SD": "Pobieranie i odtwarzanie z karty SD",
	"Live view": "Live View",
	"Geo Fencing": "Ogrodzenie wirtualne",
	"Drive Reports": "Raporty z jazdy",
	"Firmware Settings": "Ustawienia oprogramowania układowego",
	"Push Notifications": "Powiadomienia w trybie push",
	"Event Auto Upload": "Automatyczne przekazywanie podglądu na żywo związanego ze zdarzeniami",
	Privacy: Privacy$4,
	Done: Done$4,
	"Payment method": "Metoda płatności",
	"Change payment method": "Zmień metodę płatności",
	Subscription: Subscription$4,
	"Space used": "Użyte miejsce",
	"Next billing_": "Następne rozliczenie {{a}} {{b}}",
	"You manage_available": "Zarządzasz {{a}} z {{b}} elementów dostępnych w Twoim planie",
	Submasters: Submasters$4,
	Users: Users$4,
	Change: Change$4,
	"No transactions yet_": "Masz subskrypcję planu bezpłatnego. Jeszcze brak transakcji",
	"No transactions to_": "Brak transakcji do wyświetlenia.<br/>Jeżeli szukasz historii transakcji innych platform (np. iOS, Android, PayPal), skorzystaj ze strony subskrypcji własnej platformy.",
	"of nGB_": "{{a}} z {{b}} GB ({{c}}%)",
	"Smart Plan users_": "Użytkownicy planu inteligentnego mogą zmienić plan subskrypcji lub liczbę kamer przy użyciu aplikacji mobilnej BlackVue.",
	"Transaction history": "Historia transakcji",
	"Date": "Data",
	"Amount, USD": "Kwota [USD]",
	Method: Method$4,
	Details: Details$4,
	"iOS in-app_": "iOS in-app purchase/Android in-app purchase",
	"Change the number_": "Zmień liczbę kamer",
	"You manage_cameras": "You manage {{a}} cameras of {{b}} available on your plan",
	"Extra cameras": "Dodatkowe kamery",
	"Total due_": "Łączna należność",
	"available on your_": "z {{a}} dostępnych w Twoim planie",
	"Cancel Fleet Plan": "Anuluj Fleet Plan",
	"This will cancel_": "Spowoduje to anulowanie Twojej subskrypcji planu taboru. Po zakończeniu Twojego cyklu rozliczeniowego nastąpi obniżenie wersji do planu bezpłatnego.",
	"Reason for cancellation_": "Przyczyna anulowania (opcjonalna)",
	"Not now": "Nie teraz",
	Confirm: Confirm$4,
	"Cardholder name": "Nazwisko właściciela karty",
	"Card name": "Nazwa karty",
	"MM/YY": "MM/RR",
	Address: Address$4,
	Country: Country$4,
	State: State$4,
	ZIP: ZIP$4,
	Pricing: Pricing$4,
	"You are subscribed_": "Masz subskrypcję planu bezpłatnego.",
	"With Alert Push_": "Usługa obejmuje powiadomienia o alertach, ograniczony zdalny podgląd na żywo i magazyn chmurowy.",
	Free: Free$4,
	Smart: Smart$4,
	Fleet: Fleet$4,
	"Get started for_": "Usługa bezpłatna. Karta kredytowa nie jest wymagana. \nUsługa obejmuje powiadomienia o alertach, ograniczony zdalny podgląd na żywo i magazyn chmurowy.",
	Subscrubed: Subscrubed$4,
	"Features included:": "Uwzględnione funkcje:",
	"Get unlimited Remote_": "Nieograniczony zdalny podgląd na żywo, odtwarzanie z chmury i zarządzanie maksymalnie {{a}} kamerami.",
	"BlackVue Fleet Tracking_": "Specjalne funkcje śledzenia taboru BlackVue dla użytkowników zaawansowanych i firm (wielu użytkowników, wiele kamer, ogrodzenia wirtualne itp.)",
	"Try 1 Month Free": "Miesięczna bezpłatna wersja próbna",
	"Log in": "Zaloguj",
	"Remember me": "Zapamiętaj mnie",
	"Forgot password?": "Nie pamiętasz hasła?",
	"Reset password": "Resetowanie hasła",
	"Enter email address_": "Wprowadź adres e-mail używany podczas rejestracji, na który będziemy wysyłać łącze umożliwiające zresetowanie hasła.",
	"Send reset password_": "Wyślij wiadomość umożliwiającą zresetowanie hasła",
	"Back to login": "Powrót do logowania",
	"Check your email": "Sprawdź pocztę e-mail",
	"Weve sent an_": "Wysłaliśmy na adres {{a}} wiadomość e-mail z łączem umożliwiającym potwierdzenie Twojego adresu e-mail.",
	"Resend email": "Wyślij wiadomość e-mail ponownie",
	January: January$4,
	February: February$4,
	March: March$4,
	April: April$4,
	May: May$4,
	June: June$4,
	July: July$4,
	August: August$4,
	September: September$4,
	October: October$4,
	November: November$4,
	December: December$4,
	"Sign up": "Utwórz konto",
	"First name": "Imię",
	"Last name": "Nazwisko",
	"Create a password": "Utwórz hasło",
	"5 or more_": "Co najmniej 5 znaków",
	"Sign up and_": "Zarejestruj się i kontynuuj",
	"I agree to_": "Akceptuję %@, %@, %@ i %@.",
	"Subscribe to newsletter": "Subskrybuj biuletyn",
	"1 month free trial_": "Miesięczna bezpłatna subskrypcja próbna",
	"Dont have an_": "Nie masz konta?",
	"Thank you for_": "Dziękujemy za zarejestrowanie się w usłudze BlackVue Cloud. Potwierdź swój adres e-mail.",
	"Confirm email": "Potwierdź e-mail",
	"If you didnt_": "Zignoruj tę wiadomość e-mail, jeżeli to konto nie zostało utworzone przez Ciebie.",
	Blackvuecloud_: Blackvuecloud_$4,
	"invited you to_": "Użytkownik {{a}} zaprasza Cię do dołączenia do jego taboru w funkcji zastępcy administratora.",
	"Accept invitation": "Akceptuj zaproszenie",
	"Invite expires on_": "Zaproszenie wygaśnie dd-mm-rr.",
	"Your Fleet Management_": "Twoje konto do zarządzania taborem, zarejestrowane przy użyciu adresu e-mail {{a}}, zostało usunięte przez użytkownika %@.",
	"If you believe_": "Jeżeli uważasz, że nastąpiła pomyłka, skontaktuj się z działem pomocy technicznej dla klientów (cs@blackvue.com).",
	Support: Support$4,
	"Help center": "Centrum pomocy",
	Community: Community$4,
	"Getting started": "Rozpocznij",
	FAQ: FAQ$4,
	Developers: Developers$4,
	"Cloud API": "Cloud API",
	"Fleet SDK": "Fleet SDK",
	"Follow us": "Follow us",
	Facebook: Facebook$4,
	Twitter: Twitter$4,
	Instagram: Instagram$4,
	Youtube: Youtube$4,
	Linkedin: Linkedin$4,
	"BlackVue apps": "BlackVue apps",
	"Camera registraiton": "Rejestracja kamery",
	"Two-way voice_": "Dwukierunkowa komunikacja głosowa",
	"Live GPS": "GPS na żywo",
	"Event live auto_": "Automatyczne przekazywanie podglądu na żywo związanego ze zdarzeniami",
	"Event file auto_": "Automatyczne przekazywanie plików zdarzeń",
	"Compatible with_": "Zgodność z modelami DR650GW i DR650S",
	"Not compatible with_": "Brak zgodności z modelami DR650GW i DR650S",
	"More cameras": "Więcej kamer",
	"More users": "More users",
	"Roles and permissions": "Roles and permissions",
	"More Cloud Storage": "Większy rozmiar chmury",
	"Multi Live view_": "Multi Live View (Web)",
	"Longer GPS Tracking": "Longer GPS Tracking",
	"Geo Fence setup_": "Geo Fence setup (PC viewer) and alerts (PC viewer and app)",
	"Changes saved": "Zapisano zmiany",
	"Group added": "Dodano grupę",
	"Member added": "Dodano członka",
	"Group deleted": "Usunięto grupę",
	"Member deleted": "Usunięto członka",
	"Group renamed": "Zmieniono nazwę grupy",
	"Submaster added": "Dodano zastępcę administratora",
	"Camera added": "Dodano kamerę",
	"User added": "Dodano użytkownika",
	"Users added": "Dodano użytkowników",
	Downloads: Downloads$4,
	"The BlackVue App_": "The BlackVue App and Viewer let you use your BlackVue camera to its full potential. Whether on mobile or on home computer, BlackVue gives you the tools to fully enjoy your dashcam's functions.",
	"Compatible with all_": "Compatible with all Wi-Fi enabled BlackVue models.",
	"Supports all BlackVue_": "Supports all BlackVue models to date.",
	"confirm new password": "Potwierdź nowe hasło",
	"Your password is_": "Wprowadzono niepoprawne hasło",
	"Confirm password does_": "Hasło jest niezgodne",
	"Please enter_email": "Wprowadź prawidłowy adres e-mail.",
	"Please enter_password": "Wprowadzono niepoprawne hasło",
	"Internal server error_": "Wewnętrzny błąd serwera. Spróbuj ponownie później.",
	"New password is_": "Co najmniej jeden znak w bieżącym haśle jest nieprawidłowy.",
	"It should be_": "Hasło powinno składać się z co najmniej pięciu znaków.",
	"Invalid permission": "Nieprawidłowe uprawnienie.",
	"Input data isnt_": "Dane wejściowe są niedostępne.",
	Unauthorized: Unauthorized$4,
	"Already have subsciption": "Ma już subskrypcję",
	"Already uses": "Używa już",
	"Already logged in": "Jest już zalogowany",
	"Already sent e-mail": "Wysłano już wiadomość e-mail.",
	"Please wait": "Czekaj.",
	"E-mail is not_": "Adres e-mail nie został jeszcze zweryfikowany.",
	"Update your subscription_": "Aktualizuj swoją subskrypcję",
	"Account was deleted": "Konto zostało usunięte.",
	"5 ~ 30_": "5 ~ 30 characters",
	"It has exceeded_": "Przekroczono limit dziewięciu administratorów.",
	"Billing information": "Informacje rozliczeniowe",
	"Please enter cardName": "Wprowadź nazwę karty",
	"Please enter_card": "Wprowadź prawidłowy numer karty",
	"Please enter address": "Wprowadź adres",
	"Please select country": "Wybierz kraj",
	"Please enter city": "Wprowadź miejscowość",
	none: none$4,
	"Due today": "Przypada na dzisiaj",
	"Today after 1_": "Dzisiaj po miesięcznej subskrypcji próbnej",
	"An error occurred_": "Wystąpił błąd podczas próby zmiany hasła. Spróbuj ponownie.",
	"Your account is_": "Twoje konto jest teraz aktywne",
	"You can now_": "Możesz teraz zalogować się do swojego konta przy użyciu adresu e-mail używanego podczas rejestracji.",
	Email: Email$4,
	"Don’t have an account?": "Nie masz konta?",
	"Already have an account?": "Masz już konto?",
	"Cloud service": "Cloud service",
	"for your BlackVue": "for your BlackVue",
	"See what your_": "See what your camera sees remotely.",
	"Receive impact alert_": "Receive Impact alert push notifications.",
	"Save footage to_": "Save footage to the cloud and do much more...",
	"Free plan included_": "Free plan included · Easy setup · Cancel anytime",
	"Taking advantage of_": "Taking advantage of a mobile or car-embedded Internet connection and a BlackVue camera, BlackVue Cloud connects you to your car from anywhere, anytime. Using the BlackVue App on your smartphone or tablet, you see in real time where your car is located and what is happening around it.",
	"Get notifications to_": "Get notifications to your phone when your parked car is hit. Check remotely what is happening around your car.",
	"Monitor your commercial_": "Monitor your commercial vehicles on a map in real time. Talk to your drivers anytime through the BlackVue App or Viewer.",
	"With BlackVue Fleet_": "With BlackVue Fleet Tracking, track in real time up to 100 vehicles from the palm of your hand or with the dedicated BlackVue Viewer.",
	"Get started now_": "Get started now with a Free plan. For unlimited video playback or Remote Live View, upgrade to Lite or Smart plan from the BlackVue App. <br/>Business and power users can unlock the power of the Fleet plan exclusively through this website.",
	"Remote Video Playback_": "Remote Video Playback and Download",
	"Compatible with DR650GW_": "Compatible with DR650GW, DR650S models",
	"Unlimited remote video_": "Unlimited remote video playback and download",
	"Longer cloud storage_": "Longer cloud storage file expiration period",
	"Longer storage period_live": "Longer storage period for Event live auto upload",
	"Longer storage period_file": "Longer storage period for Event file auto upload",
	"Goefence setup (PC_": "Geo-fence setup (PC viewer) and alerts (Windows viewer and app)",
	"App Store": "App Store",
	"Send reset password email": "Wyślij wiadomość umożliwiającą zresetowanie hasła",
	Customers: Customers$4,
	Home: Home$4,
	"Pick a plan": "Pick a plan",
	"No customers yet": "No customers yet",
	"Customers will_": "Customers will show up here as they become available",
	"Add customer": "Add customer",
	"Report(PDF)": "Report(PDF)",
	"Subscription Period": "Subscription Period",
	Plan: Plan$4,
	New: New$4,
	Unsubscribed: Unsubscribed$4,
	"Subscription ends soon": "Subscription ends soon",
	Edit: Edit$4,
	"1 month trial": "1 month trial",
	"Edit customer details": "Edit customer details",
	"Customer name": "Customer name",
	"of 999 available_": "of 999 available on Fleet Plan",
	"Subscription starts": "Subscription starts",
	"Subscription period": "Subscription period",
	month: month$4,
	months: months$4,
	"Cloud storage": "Cloud Storage",
	"Subscription plan": "Typ subskrypcji",
	"Check email address": "Check email address",
	"Add customer details": "Add customer details",
	Continue: Continue$4,
	Back: Back$4,
	"An error occured": "An error occured",
	"Customer added": "Customer added",
	"Last changed": "Last changed",
	"Company name": "Company name",
	"Company address": "Company address",
	"Alert Push Notifications": "Alert Push Notifications",
	"Receive notifications on_": "Receive notifications on your phone when preset Events occur. Great in combination with BlackVue’s Parking Mode.",
	"Remote Live View": "Zdalny podgląd na żywo",
	"Remotely monitor your_": "Remotely monitor your car in real time from anywhere, anytime.",
	"Video Backup/Auto Upload": "Video Backup/Auto Upload",
	"Back up videos_": "Back up videos to your phone or Cloud storage.",
	"Two-way Voice Communication": "Two-way Voice Communication",
	"Talk with people_": "Talk with people in the car from your smartphone. The driver can speak while keeping hands on the wheel.",
	"View your car’s_": "View your car’s location and speed on a map. With BlackVue Fleet Tracking, access 90-days’ worth of GPS data.",
	"Remote Video Playback": "Remote Video Playback",
	"Play videos stored_": "Play videos stored in the Cloud or in your dashcam anytime on your smartphone or tablet.",
	"Event Live Auto Upload": "Event Live Auto Upload",
	"Save a video stream_": "Save a video stream in real time to the Cloud. Protect yourself from break-ins and theft.",
	"Event File Auto Upload": "Event File Auto Upload",
	"Save Event videos_": "Save Event videos to the Cloud—including seconds before trigger—after they happen.",
	"Firmware-Over-the-Air (FOTA)": "Firmware-Over-the-Air (FOTA)",
	"Upgrade your dashcam’s": "Update your dashcam over the cloud",
	"When an Event_": "When an Event is created (Impact detected or manually triggered), Event Live Auto-upload lets your Cloud-compatible BlackVue save a live video stream from a camera of your choice (front or rear/interior) to the Cloud server",
	"Event File Auto-upload_": "Event File Auto-upload lets your dashcam automatically upload low-resolution versions of Event files to the Cloud.",
	Master: Master$4,
	"per Camera": "per Camera",
	"Event live auto upload_": "Event live auto upload compatible with all cloud cameras",
	"Drive report": "Drive report",
	"USA/Canada Toll Free": "USA/Canada Toll Free",
	"Monday–Saturday_": "Monday to Friday 8am-7pm / Saturday 9am-6pm (PST).",
	"Please agree to_": "You must accept Terms of Service",
	"Mac or Windows PC": "Mac or Windows PC",
	Develop: Develop$4,
	"Sign out": "Sign out",
	"Referral code": "Kod referencyjny",
	"Total after 1 month trial": "Łącznie po miesięcznej subskrypcji próbnej",
	"Already Use Stripe Token": "Używa już tokenu Stripe",
	"Select period": "Wybierz okres",
	"State/Region": "Województwo (opcjonalne)",
	"ZIP/Postal": "Kod pocztowy",
	"$0.00": "$0.00",
	"$11.99": "$11.99",
	"$24.99": "$24.99",
	$9: $9$4,
	$15: $15$4,
	$10: $10$4,
	"mo + for_": "/mo + {{a}} per extra camera",
	mo: mo$4,
	"This e-mail address_": "Zarejestrowano już konto z tym adresem e-mail.",
	"1 month": "miesiąc",
	"Limit is reset daily": "Limit jest resetowany codziennie",
	"Limit is reset monthly": "Limit jest resetowany co miesiąc",
	"Video plays and downloads": "Odtwarzanie wideo i pobieranie",
	"Your master": "Your owner",
	"Youre 1 step_": "Wkrótce subskrypcja planu taboru będzie gotowa",
	"Finish signing up": "Zakończ rejestrację",
	"Enter billing information": "Wprowadź informacje rozliczeniowe",
	"Proceed to billing": "Przejdź do rozliczeń",
	City: City$4,
	Charge: Charge$4,
	"User already invited_": "Użytkownik został już zaproszony przez administratora",
	"n% consumed": "Używane {{a}}%",
	"E-mail already exists": "Adres e-mail już istnieje",
	"Cancel your inapp_": "Anuluj swoją subskrypcję w aplikacji",
	"You have cancel_": "Musisz anulować swoją subskrypcję w aplikacji, aby uaktualnić do planu taboru: 1. Anuluj swoją bieżącą subskrypcję w witrynie internetowej App Store lub Google Play Store. Po zakończeniu Twojego bieżącego cyklu rozliczeniowego nastąpi obniżenie wersji do planu bezpłatnego. Wszystkie Twoje dane pozostaną bez zmian. 2. Zaloguj się do swojego konta blackvuecloud.com i uaktualnij do planu taboru.",
	"Edit permissions": "Edytuj uprawnienia",
	"See permissions": "Wyświetl uprawnienia",
	"Submaster removed": "Usunięto zastępcę administratora",
	"Camera removed": "Usunięto kamerę",
	"User removed": "Usunięto użytkownika",
	"Users removed": "Usunięto użytkowników",
	subscribe: subscribe$4,
	search: search$4,
	"permission can be_": "Uprawnienie można skonfigurować po zaakceptowaniu zaproszenia przez zastępcę administratora.",
	"The confirmation link_": "Link potwierdzający jest już nieważny",
	"Possible reasons:_": "Możliwe przyczyny:\n • Twój adres e-mail został już potwierdzony.\n • Link wygasł lub został anulowany.",
	"Failed to register_": "Rejestracja w usłudze BlackVue Cloud nie powiodła się.",
	"There was an_": "Wystąpił błąd podczas rejestracji. Jeżeli problem nie zostanie rozwiązany, spróbuj ponownie zarejestrować się w usłudze BlackVue Cloud. Jeżeli potrzebujesz pomocy, skontaktuj się z naszym działem pomocy technicznej dla klientów:",
	"Upgrade to Fleet_": "Uaktualnij do planu taboru",
	"Subscription is Canceled": "Subskrypcja została anulowana",
	"No members yet": "Jeszcze brak członków",
	"Please enter_group name": "Wprowadź prawidłową nazwę grupy",
	"Group Name": "Nazwa grupy",
	invalid_number: invalid_number$4,
	invalid_expiry_month: invalid_expiry_month$4,
	invalid_expiry_year: invalid_expiry_year$4,
	invalid_cvc: invalid_cvc$4,
	incorrect_number: incorrect_number$4,
	incomplete_number: incomplete_number$4,
	incomplete_cvc: incomplete_cvc$4,
	incomplete_expiry: incomplete_expiry$4,
	expired_card: expired_card$4,
	incorrect_cvc: incorrect_cvc$4,
	incorrect_zip: incorrect_zip$4,
	invalid_expiry_year_past: invalid_expiry_year_past$4,
	card_declined: card_declined$4,
	missing: missing$4,
	processing_error: processing_error$4,
	"no groups yet": "Jeszcze brak grup",
	"groups will show_": "W tym miejscu będą wyświetlane dostępne grupy",
	"Fleet members will_": "W tym miejscu będą wyświetlani dostępni członkowie taboru",
	"service provider": "Usługodawca",
	Paypal: Paypal$4,
	iOS: iOS$4,
	Android: Android$4,
	"Enter email": "Please enter a email address",
	"Enter password": "Wprowadź hasło.",
	"Enter first name": "Wprowadź imię",
	"Enter last name": "Wprowadź nazwisko",
	"Enter the current_": "Wprowadź bieżące hasło",
	"Enter a new_": "Wprowadź nowe hasło",
	"There isnt an_": "Żadne konto nie jest skojarzone z tym adresem e-mail",
	"Fleet Plan": "Fleet Plan",
	Total: Total$4,
	"Password you entered_": "Wprowadzono niepoprawne hasło",
	"Incorrect email or_": "Niepoprawny adres e-mail lub hasło",
	"Available to Masters": "Dostępne dla właściciela",
	"Blackvue url": "https://www.blackvue.com",
	"Information We Collect_": "Jakie informacje zbieramy i dlaczego",
	And: And$4,
	"Terms of Location-Based_": "Warunki świadczenia usługi zależnej od lokalizacji.",
	"I agree to the_": "Akceptuję",
	"Password Reset_": "Wysłaliśmy wiadomość e-mail na adres {{a}} z instrukcjami dotyczącymi resetowania \n hasła.",
	"You have already_": "Wysłano już do Ciebie zaproszenie. Sprawdź pocztę e-mail.",
	"No data available_": "Brak dostępnych danych w tabeli",
	Camera: Camera$4,
	"You no longer_": "Nie masz już uprawnienia do korzystania z usługi taboru.",
	"Please contact your_": "Skontaktuj się z administratorem taboru, aby rozwiązać ten problem.",
	"You can still_": "Wciąż możesz uzyskać dostęp do",
	"account information": "informacji o swoim koncie.",
	"If the issue_": "Jeżeli problem nie zostanie rozwiązany i będziesz kontynuować korzystanie z usługi BlackVue Cloud z zarejestrowanym adresem e-mail, konieczne będzie usunięcie konta i ponowne jego utworzenie.",
	"If the problem_": "Jeżeli problem nie zostanie rozwiązany, skontaktuj się z naszym działem pomocy technicznej dla klientów:",
	"Web subscription only": "Tylko subskrypcja internetowa",
	"AppStore url": "https://apps.apple.com/kr",
	"We no longer_": "Nie przetwarzamy już płatności za pośrednictwem usługi PayPal. Musisz zaktualizować swoją subskrypcję, aby zmienić liczbę kamer: 1. Zaloguj się do swojego konta paypal.com i anuluj bieżącą subskrypcję planu taboru, aby zmienić liczbę kamer: 2. Zaloguj się do swojego konta blackvuecloud.com i uaktualnij do planu taboru.",
	Yes: Yes$4,
	No: No$4,
	"Serial number": "Numer seryjny",
	"Cloud code": "Kod chmury",
	"Terms & Policies": "Warunki i zasady",
	News: News$4,
	Notifications: Notifications$4,
	"km/h": "km/h",
	MPH: MPH$4,
	"Baidu Maps": "Baidu Maps (tylko Chiny)",
	"Google Maps": "Google Maps",
	Firmware: Firmware$4,
	Basic: Basic$4,
	"Time Zone": "Strefa czasowa",
	Resolution: Resolution$4,
	"Image quality": "Jakość obrazu",
	Brightness: Brightness$4,
	Recording: Recording$4,
	"Normal recording": "Nagrywanie normalne",
	"Voice recording": "Nagrywanie głosu",
	"Video segment length": "Długość segmentu wideo",
	"Rear camera recording": "Nagrywanie przy użyciu kamery tylnej",
	Highest: Highest$4,
	High: High$4,
	Normal: Normal$4,
	"1 min": "1 min",
	"2 min": "2 min",
	"3 min": "3 min",
	Sensitivity: Sensitivity$4,
	"Motion detection": "Wykrywanie ruchu",
	"Speed alert": "Alert prędkości",
	"Voice guidance": "Monity głosowe",
	"Power on": "Włączanie zasilania",
	"Power off": "Wyłączanie zasilania",
	"Starting normal recording": "Rozpoczynanie zwykłego nagrywania",
	"Changing recording mode": "Zmiana trybu nagrywania",
	"Speed alert (beep)": "Alert prędkości (krótki sygnał dźwiękowy)",
	"Cloud related": "Związane z chmurą",
	Volume: Volume$4,
	"User text overlay": "Wprowadzanie tekstu użytkownika",
	"A-Z, a-z_": "A–Z, a–z, 0–9, :;’/\\+-_()$#\nMniej niż 20 znaków.",
	"Wi-Fi auto turn off": "Automatyczne wyłączenie funkcji Wi-Fi",
	"Login credentials": "Poświadczenia logowania",
	"Manual recording": "Nagrywanie ręczne",
	"By sharing your_": "Udostępniając podgląd na żywo, można dzielić się z innymi użytkownikami wrażeniami z prowadzenia pojazdu w różnych krajach.",
	"However, as persona_": "W przypadku udostępniania nagrań wideo należy zadbać o właściwą ochronę prywatności.",
	"Please enter_email_2": "Proszę wpisać aktualny adres e-mail. E -mail z niektórymi znakami specjalnymi może nie być dozwolone. ex) +, &",
	"Password is incorrect": "Hasło jest niepoprawne.",
	"This camera is already_": "Ta kamera została już zarejestrowana na koncie BlackVue.",
	"Camera name must_": "Nazwa kamery musi składać się z 5–32 znaków.",
	"Failed to save_": "Nie udało się zapisać ustawień kamery.",
	"Unallowed character detected": "Wykryto niedozwolony znak.",
	"File(s) queued for_": "Pliki zostały umieszczone w kolejce przekazywania do chmury.",
	"Exceeded video play_": "Przekroczono limit odtwarzania wideo oraz pobierania.",
	"Playback Failed": "Odtwarzanie nie powiodło się.",
	"Exceeded your Live_": "Przekroczono limit czasu podglądu na żywo.",
	"The camera is not_": "Kamera nie jest połączona z serwerem.",
	"Please check the connection_": "Sprawdź stan połączenia wybranej kamery.",
	Close: Close$4,
	"Map": "Mapa",
	Cloud: Cloud$4,
	Public: Public$4,
	"Flip horizontally": "Przerzuć poziomo",
	Front: Front$4,
	Rear: Rear$4,
	Play: Play$4,
	Stop: Stop$4,
	Pause: Pause$4,
	"Next frame": "Następna klatka",
	"Previous frame": "Poprzednia klatka",
	"Proximity sensor": "Czujnik zbliżeniowy",
	"Voice recording on/off": "Włączenie/wyłączenie funkcji nagrywania głosu",
	"The BlackVue dashcam_": "Kamera samochodowa BlackVue nie jest zgodna z sieciami bezprzewodowymi 5 GHz.",
	Time: Time$4,
	"Daylight saving time": "Czas letni",
	System: System$4,
	"Incorrect camera serial_": "Niepoprawny numer seryjny kamery.",
	"Lock event files": "Zablokuj pliki zdarzeń",
	"Overwrite locked event_": "Nadpisuj zablokowane pliki zdarzeń po zapełnieniu magazynu",
	"Camera settings saved_": "Ustawienia kamery zostały pomyślnie zapisane.",
	"Front camera": "Kamera przednia",
	"Rear camera": "Kamera tylna",
	Event: Event$4,
	Parking: Parking$4,
	"GPS tracking": "Śledzenie GPS",
	"G-force detected": "Wykryto przeciążenie",
	"Impact detected in_": "Wykryto wstrząs w trybie parkowania",
	"Scheduled reboot": "Zaplanowane ponowne uruchomienie",
	"Recording status": "Stan nagrywania",
	"Rear security": "Zabezpieczenie tylne",
	"Time lapse": "Obraz poklatkowy",
	"Sync with GPS_": "Synchronizacja z czasem GPS",
	"Overwrite locked event3_": "Po zapełnieniu pamięci zastępuj zabezpieczone pliki nowymi plikami związanymi ze zdarzeniami",
	"Video codec": "Kodek wideo",
	"Tracking logs": "Dzienniki śledzenia",
	"Geofence alerts": "Alert ogrodzenia wirtualnego",
	Color: Color$4,
	Exit: Exit$4,
	Save: Save$4,
	Impact: Impact$4,
	Unlimited: Unlimited$4,
	"Parking mode recording": "Nagrywanie w trybie parkowania",
	"Battery protection": "Ochrona akumulatora",
	"Cut-off timer": "Wyłącznik automatyczny",
	"Low voltage cut-off": "Wyłączenie przy niskim poziomie napięcia",
	"Rear camera orientation": "Orientacja kamery tylnej",
	Default: Default$4,
	"Rotate video 180°": "Obróć wideo o 180°",
	"Mirror video": "Lustrzane przekształcenie wideo",
	"Wi-Fi band": "Pasmo Wi-Fi",
	"Driving report": "Raport z jazdy",
	"Unsupported video codec_": "Nieobsługiwany kodek wideo (H.265).",
	"Rear camera recording_": "Nagrywanie przy użyciu kamery tylnej w trybie parkowania",
	"Front and rear_": "Nagrywanie przy użyciu kamery przedniej i tylnej",
	"Rear camera stops_": "Nagrywanie przy użyciu kamery tylnej zostanie zatrzymane po 5 minutach od przełączenia w tryb parkowania. Nagrywanie jest wznawiane po przełączeniu w tryb normalny.",
	"Remote firmware update": "Zdalna aktualizacja oprogramowania układowego",
	"Firmware is up-to-date": "Oprogramowanie układowe jest aktualne",
	"New firmware available": "Dostępne jest nowe oprogramowanie układowe.",
	Version: Version$4,
	"Release date": "Data wydania",
	Language: Language$4,
	"File size": "Rozmiar pliku",
	"What’s new": "Co nowego?",
	"Updating may take_": "Aktualizacja może trwać kilka minut.",
	"The update process_": "Procesu aktualizacji nie można anulować.",
	"Do not disconnect the_": "Nie odłączaj przewodu zasilającego do momentu wznowienia nagrywania normalnego.",
	"Downloading firmware": "Pobieranie oprogramowania układowego",
	"Once download is_": "Po ukończeniu pobierania aplikacja BlackVue zostanie ponownie uruchomiona w celu zastosowania nowego oprogramowania układowego.",
	"If not allowed_": "Lokalizacja i prędkość pojazdu będą niedostępne za pośrednictwem chmury, jeżeli jest to niedozwolone.",
	"Unable to initiate update because_": "Nie udało się zainicjować aktualizacji, ponieważ kamera samochodowa jest połączona bezpośrednio z urządzeniem przez sieć Wi-Fi.",
	Notification: Notification$4,
	Multiple: Multiple$4,
	Range: Range$4,
	"HDR night vision": "Noktowizor HDR",
	Download: Download$4,
	"G-sensor": "G-Sensor",
	Manual: Manual$4,
	"Low voltage warning": "Ostrzeżenie o niskim napięciu",
	Satellite: Satellite$4,
	"Data usage": "Wykorzystanie danych",
	"Select video download quality": "Wybierz jakość pobierania wideo",
	"Quick play file_": "Plik szybkiego odtwarzania (niska rozdzielczość)",
	"Original file": "Oryginalny plik",
	"You do not have permission_": "Nie masz uprawnień do uruchomienia tej funkcji. Skontaktuj się z właścicielem konta głównego.",
	"Interior camera recording_": "Nagrywanie przy użyciu kamery wewnętrznej w trybie parkowania",
	"Interior security": "Zabezpieczenia wnętrza",
	"Interior camera rotation": "Obrót kamery wewnętrznej",
	"Multi View": "Wiele widoków",
	Tutorials: Tutorials$4,
	"Upgrade now": "Uaktualnij teraz",
	"Members will show_": "W tym miejscu będą wyświetlani dostępni członkowie",
	"Are you sure_delete members": "Czy na pewno chcesz trwale usunąć członków?",
	"Some members may_": "Niektórzy członkowie mogą być ukryci na skutek zastosowania filtrów.",
	"Invited on_": "zaproszony {{Invited Date}} przez Ciebie. Właściciel",
	Filter: Filter$4,
	"Date created": "Data utworzenia",
	"No admin yet": "Jeszcze brak administratora",
	"You can add_admin": "Możesz dodać jednego administratora dla każdej grupy",
	"Collapse all": "Zwiń wszystko",
	"Expand all": "Rozwiń wszystko",
	"Download and playback_cloud": "Pobieranie i odtwarzanie z chmury",
	"Are you sure_2": "Czy na pewno chcesz usunąć grupę {Group name}?",
	"Are you sure_groups": "Czy na pewno chcesz usunąć grupy?",
	"Add cameras first_drivers": "Najpierw dodaj kamery, a następnie przypisz kierowców.",
	"Flip vertically": "Przerzuć pionowo",
	Sun: Sun$4,
	Mon: Mon$4,
	Tue: Tue$4,
	Wed: Wed$4,
	Thu: Thu$4,
	Fri: Fri$4,
	Sat: Sat$4,
	Dates: Dates$4,
	Routes: Routes$4,
	Opacity: Opacity$4,
	"Color and opacity": "kolor i nieprzezroczystość",
	"Geofences will show_": "w tym miejscu będą wyświetlane dostępne ogrodzenia wirtualne",
	"Start drawing a shape_": "rozpocznij rysowanie kształtu na mapie",
	"Add geofence": "Dodaj ogrodzenie wirtualne",
	Entry: Entry$4,
	"Show all members": "Pokaż wszystkich członków",
	"Me and my_": "Ja i mój samochód. Połączono",
	"add-on service for_": "dodatkowa usługa dla produktów Blackvue zgodnych z chmurą",
	"Continue with Google": "Kontynuuj z Google",
	"An account with_": "Konto z tym adresem e-mail już istnieje, ale nie zostało zweryfikowane. Wprowadź swoje bieżące hasło usługi BlackVue Cloud.",
	"Account does not_": "Konto nie istnieje. Możesz też spróbować zalogować się na swoje konto Apple lub Google.",
	"Continue with Apple": "Kontynuuj z Apple",
	"Get started": "Rozpocznij",
	"P subscription only": "Tylko subskrypcja <b>{{a}}</b>",
	"+N USD for extra camera_": "+{{a}} USD for extra camera up to {{b}} Cameras",
	"Unlimited Live view": "Unlimited Live View",
	"Cameras per Account": "Cameras per Account",
	"Users per Account": "Users per Account",
	Owner: Owner$4,
	"Live View per Day": "Live View per Day",
	"Remote Video Playback_2": "Remote Video Playback and Download per Month",
	"N days": "{{a}} Days",
	"Video On Map": "Video On Map",
	Undetected: Undetected$4,
	Distracted: Distracted$4,
	Drowsy: Drowsy$4,
	"Whether on mobile_": "Whether on mobile or your computer, BlackVue gives you the tools to fully enjoy your dashcam’s functions. Download the latest <a1>firmware</a1>, <a2>mobile</a2> and <a3>desktop</a3> applications, or use <a4>BlackVue web app</a4> in your browser.",
	"Compatible with most_": "Compatible with most Wi-Fi BlackVue models. Cloud support for all Cloud-compatible dashcam models down to DR650GW Series with <b>Cloud Firmware</b>.",
	"Supports most recent BlackVue_": "Supports most recent BlackVue models and compatible with BlackVue Cloud.<br/>\nThis Viewer contains <b>two applications in one</b>: the SD Card Viewer lets you view recorded videos from your SD card and modify the settings of your BlackVue, as well as format the SD card; the <b>Cloud Viewer</b> lets you enjoy BlackVue Cloud.",
	"Contact us": "Contact us",
	"6 characters with": "Sześć znaków (liter, cyfry i symboli)",
	"Apps and more...": "Apps and more...",
	"Cameras will show_": "Cameras will show up here as they become available.",
	"Keep this page_": "Pozostaw tę stronę otwartą podczas sprawdzania kodu potwierdzającego. Sprawdź folder spamu, jeżeli wiadomość e-mail nie została dostarczona do Twojej skrzynki odbiorczej.",
	"n cameras": "Liczba kamer: {{n}}",
	"n slots": "Liczba gniazd: {{n}}",
	"Calculate your Fleet_": "Oblicz cenę planu taboru",
	"Code you entered_": "Wprowadzony kod jest niepoprawny lub wygasł.",
	Calling: Calling$4,
	Smoking: Smoking$4,
	"Smoking has been_": "Wykryto palenie tytoniu podczas prowadzenia pojazdu.",
	"Email is already_": "Adres e-mail już istnieje.",
	"Serial number and_": "Numer seryjny i kod chmury są umieszczone na kamerze",
	"Allow GPS access": "Zezwól na dostęp do GPS",
	"Used to access_": "Umożliwia dostęp do informacji o lokalizacji i prędkości pojazdu. Można zmienić ustawienia GPS później w ustawieniach kamery związanych z ochroną prywatności.",
	"Incorrect cloud code": "Niepoprawny kod chmurowy",
	"An account is_": "Zarejestrowano już konto z tym adresem e-mail.",
	"Live event upload": "Przekazanie podglądu zdarzenia na żywo",
	Permissions: Permissions$4,
	"Assign in": "Przypisz",
	"Are you sure_camera": "Czy na pewno chcesz usunąć tę kamerę?",
	"Uploading videos:": "Pobierz filmy:",
	"GPS location recording": "Rejestrowanie lokalizacji GPS",
	"When OFF, GPS_": "Gdy ta opcja jest wyłączona, lokalizacja GPS nie jest rejestrowana lub wysyłana do serwera chmury.",
	"As personal video_": "W przypadku przesyłania osobistych nagrań wideo należy upewnić się, że udostępniane są właściwe informacje.",
	"Share location": "Udostępnij lokację",
	Private: Private$4,
	"Used to access_2": "Umożliwia dostęp do informacji o lokalizacji i prędkości pojazdu.",
	"Share live view": "Udostępnij wideo podglądu na żywo",
	"Share live audio": "Udostępnij audio podglądu na żywo",
	"Share camera’s name": "Udostępnij nazwę kamery samochodowej",
	"Impact detection": "Detekcja udarów",
	Entering: Entering$4,
	Exiting: Exiting$4,
	"Normal event recording": "Normalne nagrywanie zdarzeń",
	"Harsh braking": "Gwałtowne hamowanie",
	Acceleration: Acceleration$4,
	"Sharp turn": "Ostry skręt",
	"Parking event recording": "Nagrywanie zdarzeń w trybie parkowania",
	Passing: Passing$4,
	"Video source": "Źródło wideo",
	Overspeed: Overspeed$4,
	"Are you sure_video": "Czy na pewno chcesz usunąć ten film?",
	"Add camera to_": "Dodaj kamerę do podglądu na żywo",
	"No routes to_": "Brak tras do wyświetlenia",
	"Start by adding_": "Rozpocznij od dodania dat.",
	"invite sent": "Wysłano zaproszenie",
	Recipients: Recipients$4,
	Send: Send$4,
	"Routes selected_": "Wybrano trasy: {{n}} z {{total}}",
	"Map service": "Usługa mapy",
	"Speed units": "Jednostki prędkości",
	Note: Note$4,
	"Release notes": "Informacje o wersji",
	"The name must_": "Nazwa musi zawierać od 1 do 30 znaków.",
	Video: Video$4,
	Advanced: Advanced$4,
	"Firmware language": "Język oprogramowania układowego",
	"Wi-Fi": "Wi-Fi",
	Voice: Voice$4,
	"Show date and_": "Wyświetl datę i godzinę",
	"Show speed": "Wyświetl prędkość",
	"Front camera rotation": "Rotacja przedniej kamery",
	"Manual time settings": "Ręczne ustawienia czasu",
	"Recommended for better_": "Zalecane ze względu na lepszą kompresję, mniejszy rozmiar pliku i format 4K UHD.",
	"For full compatibility_": "Pełna zgodność ze starszymi urządzeniami stacjonarnymi i przenośnymi.",
	"Up and down": "W górę i w dół",
	"Side to side": "Na boki",
	"Front and back": "Z przodu i z tyłu",
	"Detection region": "Obszar detekcji",
	"Hotspot 1": "Punkt dostępu 1",
	"Hotspot 2": "Punkt dostępu 2",
	"Hotspot 3": "Punkt dostępu 3",
	"Enter/exit": "Wjazd/wyjazd",
	"Event recording": "Nagrywanie zdarzeń",
	"Front security (Normal)": "Zabezpieczenie przednie (normalne)",
	"Front security (Parking)": "Zabezpieczenie przednie (parkowanie)",
	"LTE (Parking)": "LTE (parkowanie)",
	"Wi-Fi (Parking)": "Wi-Fi (parkowanie)",
	"Turn on at startup": "Włącz przy rozruchu",
	"Turn off after_": "Wyłącz po 10 minutach nieaktywności",
	"Your firmware is_": "Oprogramowanie układowe jest aktualne",
	"Add admin": "Dodaj administratora",
	"Remove All/n": "Usuń wszystko / {{a}}",
	"Are you sure_remove": "Czy na pewno chcesz usunąć kamery z tej grupy?",
	"This will cancel_2": "Spowoduje to anulowanie Twojej subskrypcji planu taboru. Po zakończeniu Twojego bieżącego cyklu rozliczeniowego nastąpi obniżenie wersji do planu bezpłatnego.",
	"You’ve reached_": "Osiągnięto limit liczby kierowców na kamerę",
	"Are you sure_remove admin": "Czy na pewno chcesz usunąć administratora {{a}}{{b}} z tej grupy?",
	"Fleet Plan · Owner": "Fleet Plan · Owner",
	"Manage cameras": "Zarządzanie kamerami",
	"Are you sure_delete zone": "Czy na pewno chcesz usunąć strefę „{{zone}}”?",
	"available on your_2": "{{a}}/{{b}} dostępne w Twoim planie",
	"The new plan_2": "Nowy plan będzie obowiązywać po zakończeniu bieżącego cyklu rozliczeniowego ({{a}}).",
	"Canceled Fleet Plan_": "Anulowano plan taboru {{a}}",
	"Hard braking alert (beep)": "Alert gwałtownego hamowania (krótki sygnał dźwiękowy)",
	"Hard acceleration alert (beep)": "Alert gwałtownego przyspieszania (krótki sygnał dźwiękowy)",
	"Hard cornering alert (beep)": "Alert ostrego skrętu (krótki sygnał dźwiękowy)",
	"SSID must be_": "Identyfikator SSID musi składać się z co najmniej pięciu znaków.",
	"Password must be_": "Hasło musi składać się z co najmniej ośmiu znaków.",
	"5 to 32 characters long": "Ciąg składający się z 5–32 znaków",
	"8 to 32 characters long": "Ciąg składający się z 8–32 znaków",
	"Longer storage period_event": "Dłuższy okres przechowywania dla przekazywania zdarzenia na żywo",
	"Requires latest firmware_": "Wymagane jest najnowsze oprogramowanie układowe. Brak zgodności z modelami DR650S i DR650GW",
	"After Blackvue is_": "Po połączeniu aplikacji BlackVue z chmurą ustawienia zostaną zapisane.",
	"This is an_": "To jest niezarejestrowany adres e-mail. Czy chcesz utworzyć nowe konto?",
	"This feature is_": "Ta funkcja jest dostępna tylko dla subskrybentów planu taboru.",
	"Please return to_": "Konto nie istnieje. Możesz też spróbować zalogować się na swoje konto Apple lub Google.",
	"Adjusting the cut-off voltage_": "Adjusting the cut-off voltage to a lower setting may result in your dash cam draining more power from your battery.\nThis could result in warning messages of battery drain or affect other vehicle functions.\nPlease consult with your dealership before lowering the voltage.",
	"Your videos will_": "W tym miejscu będą wyświetlane dostępne nagrania wideo.",
	"You drove:_": "Twoja trasa: {{distance}}, {{time}}",
	"Event count per_": "Liczba zdarzeń na godzinę prowadzenia pojazdu",
	"Are you sure_recipient": "Czy na pewno chcesz usunąć tego odbiorcę?",
	"(You)": "{{a}} (Ty)",
	"All events": "Wszystkie zdarzenia",
	Days_: Days_$4,
	"Requires DMC 200_": "Wymagana jest kamera DMC 200",
	"A DMS and compatible_": "System DMS i zgodna kamera kamera samochodowa Dashcam są wymagane do wyświetlenia tego raportu.",
	"Notifications will show_": "W tym miejscu będą wyświetlane dostępne powiadomienia.",
	"Try changing your_": "Spróbuj zmienić datę lub usunąć filtry.",
	Mute: Mute$4,
	UnMute: UnMute$4,
	"Calling and smoking_": "Wykonywanie połączeń telefonicznych i palenie tytoniu są wykrywane tylko przez urządzenie DMC 200",
	"You need a DMS_": "Usługa DMS jest niezbędna do wyświetlenia tego raportu.",
	"Try BlackVue Cloud": "Wypróbuj usługę BlackVue Cloud już dzisiaj",
	"Individual driver looking_": "Indywidualny kierowca poszukujący użytecznych technologii? Właściciel firmy poszukujący prostego rozwiązania do ochrony i śledzenia pojazdów?",
	"Whoever you are_": "Niezależnie od tego, kim jesteś i czego potrzebujesz, dostępny jest optymalny plan chmurowy dla Ciebie!",
	"It is the account that_Driver": "To konto dołączyło do Twojego taboru w chmurze BlackVue Cloud po zaakceptowaniu zaproszenia przesłanego pocztą e-mail przez właściciela lub administratora. Kierowcę można przypisać tylko do jednej kamery z ograniczoną możliwością wyświetlania profilu własnego konta, podglądu na żywo i odtwarzania nagrań z kamery.",
	"It is the account that_Admin": "To konto dołączyło do Twojego taboru w chmurze BlackVue Cloud po zaakceptowaniu zaproszenia przesłanego pocztą e-mail przez właściciela. Kontom administratorów można udzielać uprawnień akceptowanych przez odpowiedniego właściciela.",
	"Video deleted": "Usunięto nagranie wideo",
	"Video delete_plural": "Usunięto nagrania wideo",
	"Driver removed from_": "Usunięto kierowcę z grupy",
	"Admin removed from_": "Usunięto administratora z grupy",
	"Camera removed from_": "Usunięto kamerę z grupy",
	"Are you sure_videos": "Czy chcesz usunąć wybrane pliki?",
	"You have to cancel_fleet": "Aby zmienić liczbę kamer, musisz anulować swoją subskrypcję w aplikacji:\n \n 1. Anuluj swoją bieżącą subskrypcję w witrynie internetowej App Store lub Google Play Store. Po zakończeniu Twojego bieżącego cyklu rozliczeniowego nastąpi obniżenie wersji do planu bezpłatnego. Wszystkie Twoje dane pozostaną bez zmian.\n 2. Zaloguj się do swojego konta w witrynie internetowej blackvuecloud.com i uaktualnij do planu taboru.",
	Discard: Discard$4,
	"Discard unsaved changes?": "Odrzucić niezapisane zmiany?",
	"Incorrect serial number": "Niepoprawny numer seryjny",
	"An error occurred_again": "Wystąpił błąd. Spróbuj ponownie.",
	"You are subscribed_free": "Masz subskrypcję planu bezpłatnego chmury BlackVue Cloud.",
	"When an event_": "Po utworzeniu zdarzenia (wykrycia uderzenia lub wyzwolenia ręcznego) przekazanie informacji o zdarzeniu na żywo umożliwia kamerze BlackVue zapisanie na serwerze chmury strumienia podglądu na żywo z wybranej kamery, łącznie z pięcioma sekundami przed wystąpieniem zdarzenia.",
	Report: Report$4,
	"How it work": "Jak to działa",
	"Cloud Camera": "Kamera chmurowa",
	"Internet Connection": "Połączenie z Internetem",
	"BlackVue App/Viewer": "BlackVue App/Viewer",
	"All you need_": "Wszystko czego potrzebujesz to",
	"Cloud-compatible BlackVue": "Kamera BlackVue zgodna z chmurą",
	"and a cellular_": "i plan komórkowej transmisji danych. Niektóre modele łączą się z chmurą przy użyciu punktu dostępu Wi-Fi strony trzeciej. Inne są wyposażone we wbudowany czytnik kart nano SIM lub obsługują podłączane moduły komunikacyjne.",
	"Cloud features at_": "Łatwy dostęp do funkcji chmurowych",
	"Enjoy peace of_": "Można zawierzyć kamerze BlackVue monitorowanie pojazdu. Kamera samochodowa Dashcam powiadamia użytkownika natychmiast o wykrytych zagrożeniach.",
	"Let your BlackVue_": "Pozwól kamerze BlackVue monitorować pojazd i powiadamiać o zagrożeniach. Po wykryciu uderzenia kamera BlackVue wysyła powiadomienie do telefonu użytkownika lub jego przeglądarki internetowej, dołączając zdjęcie.",
	"Check on your_": "Korzystając ze zdalnego podglądu na żywo, można sprawdzić stan samochodu z dowolnego miejsca. Podgląd na żywo z kamer samochodowych Dashcam, połączonych z chmurą, można wyświetlać przy użyciu przeglądarki internetowej lub telefonu i przełączać widok z kamery przedniej, tylnej lub wewnętrznej.",
	"Your BlackVue may_": "Kamera BlackVue nie zapobiega sytuacjom, w których sprawca zbiegł z miejsca wypadku, ale może zapewnić cenne materiały dowodowe. Wszystkie nagrania wideo, wykonane przez kamerę samochodową Dashcam, można przeglądać przy użyciu telefonu komórkowego lub przeglądarki internetowej.",
	"Worried about eating_": "Martwisz się zużyciem w planie komórkowej transmisji danych? Technologia podstrumieni BlackVue umożliwia dostęp do wersji nagrań wideo o mniejszym rozmiarze, przeznaczonych do szybkiego przeglądania bez użycia buforu.",
	"Move files from_": "Pliki można przenieść z kamery BlackVue do chmury. Można zapisać pojedyncze nagranie wideo lub wybrać wiele klipów do przekazania zbiorczego. Nagranie wideo przekazane do telefonu przy użyciu aplikacji BlackVue jest dostępne i może być udostępniane przy użyciu menu Pamięć wewnętrzna.",
	"View your vehicle’s_": "Informacje dotyczące lokalizacji i prędkości pojazdu można wyświetlać w czasie rzeczywistym. Uaktualnienie do planu inteligentnego umożliwia dostęp do danych śledzenia GPS z siedmiu ubiegłych dni.",
	"Get more with_": "Zyskaj więcej dzięki planowi inteligentnemu",
	"Unlimited Remote Live_": "Nieograniczony zdalny podgląd na żywo",
	"Up to 3 dashcams_": "Maksymalnie trzy kamery samochodowe Dashcam na koncie",
	"Want to track_": "Chcesz śledzić cały tabor? Uaktualnij do planu taboru",
	"BlackVue Fleet Tracking_2": "Śledzenie taboru BlackVue jest kompletnym rozwiązaniem zapewniającym ochronę i monitorowanie taboru. Funkcje i ceny można elastycznie skalować zależnie od potrzeb firmy.",
	"Stream real-time video_": "Wideo można strumieniować w czasie rzeczywistym bez ograniczeń. Szybkość transmisji bitów: 600 kb/s",
	"Up to 999 Dashcams": "Maksymalnie 999 kamer samochodowych Dashcam",
	"Register up to_": "Na koncie można zarejestrować maksymalnie 999 kamer samochodowych Dashcam.",
	"15GB of Cloud_": "15 GB magazynu chmurowego",
	"15GB per additional_": "15 GB na każdą dodatkową kamerę samochodową Dashcam. Nieograniczony magazyn do automatycznego przekazywania zdarzeń.",
	"90-days GPS_": "Dzienniki śledzenia GPS z 90 dni",
	"High accuracy: 15_": "Duża dokładność: 15 second, wideo na mapie, łatwy eksport danych.",
	"Unique fleet management_": "Unikalne funkcje zarządzania taborem zwiększają wartość dodaną i ułatwiają korzystanie z systemu",
	"Create geofences and_": "Można tworzyć ogrodzenia wirtualne i odbierać powiadomienia w czasie rzeczywistym przy użyciu telefonu lub komputera.",
	"View at a_": "Podsumowanie informacji, takich jak łączny przejechany dystans, czas bezczynności lub zdarzenia związane z nadmierną prędkością, można wyświetlać w tabelach przystosowanych do drukowania lub eksportowania.",
	"Multi Live View": "Widok wielu podglądów na żywo",
	"Monitor up to_": "Można monitorować maksymalnie cztery kamery samochodowe Dashcam równocześnie",
	"Benefits for you": "Korzyści dla użytkownika",
	Individual: Individual$4,
	"Get notifications to_2": "Odbieranie przy użyciu telefonu powiadomień o uderzeniu zaparkowanego pojazdu. Zdalne sprawdzanie sytuacji wokół samochodu. Dostęp przy użyciu przeglądarki internetowej, telefonu komórkowego albo przeglądarki w systemie Mac i Windows.",
	"Small business owner": "Właściciele małych firm",
	"Monitor your commercial_2": "Monitorowanie pojazdów firmowych na mapie w czasie rzeczywistym. Rozmawianie z kierowcami w dowolnej chwili przy użyciu przeglądarki internetowej, aplikacji mobilnej BlackVue albo przeglądarki w systemie Mac lub Windows.",
	"Company with large_": "Firma z licznym taborem",
	"With BlackVue Fleet_2": "Korzystając z funkcji śledzenia taboru BlackVue, można monitorować w czasie rzeczywistym maksymalnie 999 pojazdów przy użyciu przeglądarki internetowej, aplikacji mobilnej BlackVue albo przeglądarki w systemie Mac lub Windows.",
	Subscribed: Subscribed$4,
	"The video was_": "Nagranie wideo zostało już przekazane.",
	Geofence: Geofence$4,
	"500: Internal server error": "500: Wewnętrzny błąd serwera",
	"404: Page not found": "404: Nie znaleziono strony",
	"Check the web address_": "Sprawdź adres internetowy lub wyświetl ponownie stronę główną usługi BlackVue Cloud.",
	"home page": "Home page",
	"There isn’t an_": "Konto skojarzone z tym adresem e-mail nie istnieje",
	"You can now_password": "Teraz możesz logować się przy użyciu nowego hasła",
	"Are you sure_remove admin2": "Czy na pewno chcesz trwale usunąć administratora",
	"Admin deleted": "Usunięto administratora",
	"Members deleted": "Usunięto członków",
	"Are you sure_groupName": "Czy na pewno chcesz usunąć grupę {{a}}?",
	"Requires latest firmware": "Wymagane jest najnowsze oprogramowanie układowe",
	"Selected file(s) moved_": "Przenoszenie wybranych plików powiodło się",
	"Are you sure_remove driver2": "Czy na pewno chcesz usunąć kierowcę {{a}} ({{b}}) z tej grupy?",
	"Invite sent": "Wysłano zaproszenie",
	"Safe driving": "Bezpieczne prowadzenie pojazdu",
	"Reckless driving": "Brawurowe prowadzenie pojazdu",
	"Inattentive driving": "Nieuważne prowadzenie pojazdu",
	"Driving events trend": "Trend zdarzeń prowadzenia pojazdu",
	"Driving details": "Szczegóły prowadzenia pojazdu",
	Driving: Driving$4,
	Idling: Idling$4,
	Distance: Distance$4,
	"Parking sessions": "Sesje parkowania",
	"Parked time": "Parked time",
	"Idle stops": "Liczba zatrzymań i bezczynności",
	"Idle time": "Czas bezczynności",
	"Impact events": "Impact Events",
	Parked: Parked$4,
	Speed: Speed$4,
	"Overspeeding alerts": "Alerty przekroczenia ograniczenia prędkości",
	Highest_2: Highest_2$4,
	Average: Average$4,
	Geofences: Geofences$4,
	"Entries into a_": "Wjazdy do strefy",
	"Exits from a_": "Wyjazdy ze strefy",
	"No data": "Brak danych",
	"Hard acceleration": "Przyspieszanie",
	"Hard braking": "Gwałtowne hamowanie",
	"Hard cornering": "Ostry skręt",
	"The number within the brackets_": "Liczba w nawiasach oznacza średnią liczbę zdarzeń na godzinę prowadzenia pojazdu. Jeżeli użytkownik prowadził pojazd przez czas krótszy niż godzina, wyświetlana jest łączna liczba zdarzeń.",
	"Did you insert_": "Czy karta SIM została zainstalowana?",
	"Click here for_": "<a>Kliknij tutaj</a>, aby uzyskać więcej szczegółowych podręczników.",
	"Back up all_": "<b>Przed zapisaniem tych ustawień wykonaj kopię zapasową wszystkich ważnych nagrań.</b><br/>Zapisanie ustawień spowoduje ponowne zainicjowanie karty microSD i usunięcie wszystkich nagrań w celu zapewnienia stabilnego funkcjonowania.",
	"Not connected to_": "Nie połączono z chmurą. Niektóre funkcje zostały tymczasowo wyłączone.",
	"GPS Location recording off": "Rejestrowanie lokalizacji GPS jest wyłączone",
	"n Videos deleted": "Liczba usuniętych nagrań wideo: {{count}}",
	Move: Move$4,
	"Driver Monitoring System (DMS) will_": "Wkrótce będzie dostępny system monitorowania kierowców (DMS, Driver Monitoring System).",
	"An error occured while_": "Wystąpił błąd podczas próby zmiany liczby kamer. Spróbuj ponownie.",
	"Reached the limit_": "Osiągnięto limit: {{a}}",
	"An invitation was_": "Wysłano już zaproszenie na ten adres e-mail.",
	"To use the_": "Aby skorzystać z funkcji chmurowej. Zainstaluj kartę SIM.",
	"Last updated": "Ostatnio aktualizowano {{date}}",
	"Try changing your date": "Spróbuj zmienić datę.",
	"No event data_": "Nie zebrano danych zdarzeń w wybranym okresie.",
	"Please select another_": "Wybierz inny dzień lub miesiąc do wyświetlenia całego raportu.",
	"more than 6_": "Wymaganych jest co najmniej sześć znaków.",
	"Sign up free": "Załóż konto bezpłatnie",
	"Cloud storage warning": "Ostrzeżenie magazynu chmurowego",
	"Cloud Storage Full": "Magazyn chmurowy jest zapełniony",
	"Cloud storage usage_100": "Osiągnięto poziom użycia magazynu chmurowego 100%. Zwolnij miejsce w magazynie, aby umożliwić przekazywanie zdarzeń na żywo.",
	"Cloud storage usage_": "Użycie magazynu chmurowego osiągnęło <b>({{a}}%)</b>. \nUporządkuj swój magazyn chmurowy.\nUsługa przekazywania zdarzeń na żywo jest niedostępna, jeżeli magazyn chmurowy jest zapełniony.",
	"Are you sure_delete_zone": "Czy na pewno chcesz usunąć pozycję?",
	"Search Name or email": "Wyszukaj nazwisko lub adres e-mail",
	"Search group name": "Wyszukaj nazwę grupy",
	"Please note that_": "Nagrywanie wideo zostanie wstrzymane na kilka sekund w celu zastosowania nowych ustawień.",
	"Currently connected Hotspot": "Obecnie połączony punkt dostępu",
	"Enhanced night vision": "Ulepszony noktowizor",
	"To access the_": "Aby uzyskać dostęp do kamery, zaktualizuj swój plan subskrypcji.",
	"Restarting the Blackvue_": "Ponowne uruchamianie aplikacji BlackVue w celu zastosowania ustawień.",
	"Hard acceleration event_": "Zdarzenie gwałtownego przyspieszenia występuje wówczas, gdy prędkość zwiększa się o ponad {{kmh}} km/h na sekundę.",
	"Hard braking event_": "Zdarzenie gwałtownego hamowania występuje wówczas, gdy prędkość zmniejsza się o ponad {{kmh}} km/h na \nsekundę.",
	"Hard cornering event_": "Zdarzenie ostrego skrętu występuje wówczas, gdy kierunek ruchu zmienia się o ponad 60 stopni w ciągu dwóch sekund przy prędkości ponad \n{{kmh}} km/h.",
	"Changes you made_": "Wprowadzone przez Ciebie zmiany nie zostały zapisane.",
	"My location": "Moja lokalizacja",
	"Hotspot name (SSID)": "Nazwa punktu dostępu (SSID)",
	Connected: Connected$4,
	"Camera will be rebooted_": "Kamera zostanie ponownie uruchomiona. Czy na pewno chcesz kontynuować?",
	"Restarting the BlackVue_": "Ponowne uruchamianie aplikacji BlackVue. Czekaj.",
	"Failed to reboot_": "Ponowne uruchamianie kamery nie powiodło się",
	"Bluetooth (Parking mode)": "BT (tryb parkowania)",
	"Front and interior camera_": "Kamera przednia i wewnętrzna nagrywają równocześnie.",
	"Interior camera stops_": "Nagrywanie przy użyciu kamery wewnętrznej zostanie zatrzymane pięć minut po przełączeniu do trybu parkowania. Nagrywanie jest wznawiane po przełączeniu do trybu normalnego.",
	Individual_: Individual_$4,
	"Driver detection": "Detekcja kierowcy",
	"During driving only": "Tylko podczas prowadzenia pojazdu",
	Always: Always$4,
	"Driver detection box": "Pole detekcji kierowcy",
	"DMS camera rotation": "Obrót kamery DSM",
	Low: Low$4,
	Medium: Medium$4,
	High_2: High_2$4,
	"Reboot Camera": "Uruchom kamerę ponownie",
	"Latest events": "Najnowsze zdarzenia",
	"G-Sensor": "G-Sensor",
	"Playback speed": "Szybkość odtwarzania",
	Flip: Flip$4,
	Previous: Previous$4,
	Next: Next$4,
	"Map type": "Typ mapy",
	"Zoom in": "Powiększ",
	"Zoom out": "Pomniejsz",
	"Move to Cloud": "Przenieś do chmury",
	"Please recognize that_": "Nagrywanie wideo zostanie wstrzymane na kilka sekund w celu zastosowania ustawień.",
	"6 characters with_": "Sześć znaków (liter, cyfry i symboli)",
	"Updating firmware": "Aktualizacja oprogramowania układowego",
	"Overspeed event occurs_": "Zdarzenie przekroczenia ograniczenia prędkości występuje wówczas, gdy kamera samochodowa Dashcam ostrzega kierowcę o nadmiernej prędkości. To ustawienie można zmienić w sekcji Oprogramowanie układowe > System > Głośność",
	"Enter group name": "Wprowadź nazwę grupy",
	"Live view failed": "Podgląd na żywo nie powiódł się.",
	"Parking mode enter_": "Przekroczenie bramy w trybie parkowania",
	"Cloud connectivity": "Łączność chmurowa",
	Expand: Expand$4,
	Collapse: Collapse$4,
	"all day": "Cały dzień",
	"Driving style": "Styl jazdy",
	"Driving impact": "Udar podczas jazdy",
	More: More$4,
	"No cameras to_": "Brak kamer do dodania",
	"You have added_": "Dodano wszystkie dostępne kamery.",
	Multi: Multi$4,
	"Report video": "Zgłoś film",
	"Sexually explicit content": "Treści seksualne",
	"Graphic violence": "Brutalne lub odrażające",
	"Hateful speech": "Pełne nienawiści lub przemocy",
	"Harassment or bullying": "Molestowanie lub nękanie",
	"Spam or advertisement": "Spam lub reklama",
	"Infringement of my_": "Narusza moje prawa",
	"Other reason": "Itd.",
	"Reason for reporting": "Przyczyna zgłoszenia",
	"Reported videos will_": "Zgłoszone filmy wideo zostaną sprawdzone w ciągu 72 godzin. Film nie zostanie wyświetlony na mapie zdarzeń, dopóki nie zostanie potwierdzone, że jest do tego celu odpowiednie.",
	"Touch sensor": "Czujnik dotykowy",
	"Motion and impact detection": "Wykrywanie ruchu i wstrząsów",
	"Settings have been changed": "Ustawienia zostały zmienione",
	"Start event recording (beep)": "Rozpocznij nagrywanie zdarzeń (krótki sygnał dźwiękowy)",
	"Scheduled reboots": "Zaplanowane ponowne uruchamianie",
	Safe: Safe$4,
	Reckless: Reckless$4,
	Inattentive: Inattentive$4,
	"Highest(Extreme)": "Najwyższa (ekstremalna)",
	"Public cameras": "Kamery publiczne",
	List: List$4,
	Usage: Usage$4,
	"Video playbacks and downloads": "Liczba odtworzeń i pobierań filmu",
	"of 100 times": "100 razy",
	"of 10 minutes": "10 minut",
	Profile: Profile$4,
	"Search geofences": "Wyszukuj ogrodzenia wirtualne",
	"Export CSV": "Eksportuj CSV",
	"Exit fullscreen": "Wyjdź z pełnego ekranu",
	Fullscreen: Fullscreen$4,
	Upgrade: Upgrade$4,
	"Email address": "Adres e-mail",
	"of Unlimited": "bez ograniczeń",
	"No notifications yet": "Brak powiadomień otrzymanych w ciągu ostatnich 7 dni.",
	"No videos yet": "Jeszcze brak filmów",
	Management: Management$4,
	Day: Day$4,
	Month: Month$4,
	"Welcome to the BlackVue_": "Witamy w przeglądarce chmury BlackVue",
	"You can access BlackVue_": "Dostęp do chmury BlackVue można uzyskać przez Internet w dowolnym czasie i w dowolnym miejscu!",
	"Start tour": "Rozpocznij trasę",
	"Map view": "Widok mapy",
	"Check the current_": "Sprawdź aktualną lokalizację GPS i prędkość swoich kamer oraz kamer publicznych.",
	"Camera’s features": "Funkcje kamery",
	"Take a look_": "Zapoznaj się z różnymi funkcjami powiązanymi z chmurą, oferowanymi przez kamerę BlackVue.",
	"Visualize your vehicle’s_": "Wizualizacja trasy pojazdu w czasie.",
	"Smart plan_": "Pakiet inteligentny: 90 dni, pakiet flotowy: 90 dni",
	"Create geofences and2_": "Możliwość tworzenia ogrodzeń wirtualnych i odbierania powiadomień w czasie rzeczywistym.",
	"Got it": "Rozumiem",
	"Manage Fleet members": "Zarządzanie członkami floty",
	"Invite fleet members_": "Możliwość zapraszania członków floty i przydzielania ich do grup.",
	"The moment the_": "W momencie gdy kamera wykryje wstrząs, tutaj zostanie wyświetlona lista powiadomień.",
	"Geofence Setup (Web)_": "Konfiguracja ogrodzeń wirtualnych (w sieci / na komputerze) i alerty",
	"Original file play_": "Odtwarzanie oryginalnego pliku jest dostępne tylko w przypadku pobrania",
	"To get most_": "Aby optymalnie wykorzystać funkcje przeglądarki chmury BlackVue, kamera musi być połączona z chmurą. Pobierz aplikację BlackVue i wypróbuj funkcję Płynnego parowania, od momentu dodania kamery do połączenia z chmurą – wszystko jednocześnie!",
	"You haven’t driven_Today": "Nie prowadzono dziś jeszcze samochodu. Przejedź się samochodem z użyciem aplikacji BlackVue, aby sprawdzić raport z jazdy.",
	"You haven’t driven_Month": "Nie prowadzono jeszcze samochodu w tym miesiącu. Przejedź się samochodem z użyciem aplikacji BlackVue, aby sprawdzić raport z jazdy.",
	"Fleet Plan only_": "Dostępny tylko pakiet flotowy",
	"Overwrite locked event2_": "Nadpisuj zablokowane pliki zdarzeń po zapełnieniu pamięci",
	"DMS’s New firmware_": "Dostępne jest nowe oprogramowanie układowe DMS",
	"Highest speed_report": "<b>Najwyższa prędkość</b>\nNajwyższa wartość zebranych danych prędkości zmierzonych w metrach Konwertowanie na km/h i mph\n\n<b>Średnia prędkość</b>\n(pokonana odległość / godziny jazdy) * średnia prędkość 3600. Np. (2622 / 1208 ) * 3600 = 7814,907\nkm/h: Tylko liczby całkowite,\nwartości MPH podawane są z dokładnością 2 cyfr po przecinku",
	"Choose a cloud_": "Wybierz metodę połączenia z chmurą",
	"You need an_": "Aby połączyć się z chmurą, wymagane jest połączenie z Internetem. Wybierz urządzenie, z którego korzystasz, aby połączyć się z chmurą.",
	"BlackVue SIM card": "Karta SIM BlackVue",
	"Support model_": "Obsługiwany model: DR750X-2CH LTE Plus (n.d.)",
	"3rd party SIM_": "Karta SIM innej firmy",
	"Support model_SIM": "Obsługiwany model: DR750X-2CH LTE Plus, DR750-2CH LTE, CM100 LTE",
	"Wi-fi hotspot": "Punkt dostępu Wi-Fi",
	"Support model_Wifi": "Obsługiwany model: Wszystkie modele BlackVue",
	"How to connect_": "Połączenie z chmurą",
	"Download BlackVue application": "Pobierz aplikację BlackVue.",
	"*If you are_": "*Aby korzystać z karty SIM BlackVue na potrzeby połączenia z chmurą, przejdź do {{a}} {{b}}.",
	"Place your phone_": "Umieść telefon w zasięgu Bluetooth kamery. Uruchom Płynne parowanie za pośrednictwem {{a}}.",
	"Back to camera_": "Powrót do listy kamer",
	"Upgrade for more_": "Zaktualizuj, aby uzyskać dostęp do większej liczby funkcji!",
	"Upgrading the cloud_": "Aktualizacja pakietu chmury umożliwi korzystanie z większej liczby funkcji i zarządzanie wieloma kamerami. Czy chcesz aktualizować pakiet chmury?",
	"Explore cloud plans": "Poznaj pakiety chmury",
	Later: Later$4,
	"Successfully subscribed": "Pomyślnie subskrybowano!",
	"1GB data plan": "Plan danych 1 GB",
	"First month free_": "W pierwszym miesiącu bezpłatnie, <a>potem 10,99 USD/miesiąc</a>",
	"Next billing date": "Data następnego rozliczenia",
	"Once SIM card_": "Po włożeniu do kamery karty SIM można od razu uruchomić funkcje Chmury BlackVue.",
	"Go to SIM_": "Przejdź do zarządzania kartą SIM",
	"Manage your BlackVue_": "Tutaj możesz zarządzać kartą SIM BlackVue!",
	"Recommended for BlackVue_": "Zalecane dla właścicieli kart SIM BlackVue",
	"Connect to cloud": "Połącz z chmurą",
	"Enter BlackVue SIM_": "Wprowadź numer ICCID karty SIM BlackVue",
	"ICCID number is_": "Numer ICCID jest wydrukowany na opakowaniu karty SIM. Wprowadź ostatnie 14 cyfr numeru ICCID.",
	ICCID: ICCID$4,
	"SIM information": "Informacje o karcie SIM",
	"Start your free_": "Rozpocznij bezpłatny okres próbny",
	"SIM card activate_": "Data aktywacji karty SIM",
	"Based on the_": "Zależny od daty włożenia karty SIM do kamery i jej aktywacji po włączeniu zasilania",
	"Upgrade to 3GB_": "Możliwość aktualizacji do 3 GB / 5 GB w dowolnym czasie",
	"Cancel your plan_": "Możliwość anulowania pakietu w dowolnym czasie",
	"No Commitment": "Bez zobowiązań",
	"Precautions for using_": "Środki ostrożności zalecane w trakcie korzystania z usługi",
	"After 1GB is_": "Po zużyciu 1 GB nie będzie dostępu do Internetu.",
	"If you have_": "Jeśli karta SIM była już włożona do kamery i używana, bezpłatny okres próbny zaczyna się od rozpoczęcia jej używania.",
	"This content is_": "Zawartość jest określona w opakowaniu karty SIM. Firma nie udziela rekompensaty za niezrealizowane bezpłatne okresy.",
	"If you have_2": "Ewentualne dodatkowe pytania należy kierować do <a>Działu obsługi klienta</a>",
	"When OFF, connecting_": "Jeśli kamera jest wyłączona, jej połączenie poprzez funkcję Płynnego parowania jest niedostępne.",
	"1 month free": "1 miesiąc bezpłatny",
	"No commitment. Cancel_": "Bez zobowiązań. Możliwość anulowania w dowolnym czasie.",
	"The video has been reported_": "Pomyślnie zgłoszono film",
	"Free for 1 month": "Bezpłatnie przez 1 miesiąc",
	"Start your free_2": "Rozpocznij swój bezpłatny okres próbny",
	"1GB free for_": "1 GB bezpłatnie przez {{a}} dni",
	"1GB data": "1 GB danych",
	"1 month free_2": "Miesięczny bezpłatny okres próbny zaczyna się od {{a}} i obejmuje 1 GB danych dla karty SIM BlackVue.",
	"Your next billing_": "Data następnego rozliczenia to {{a}}",
	"SIM card": "Karta SIM",
	"SIM guide": "Podręcznik karty SIM",
	"SIM card list": "Lista kart SIM",
	"Add SIM card": "Dodaj kartę SIM",
	"No SIM card_": "Brak jeszcze karty SIM",
	"Search SIM ICCID_": "Wyszukaj numer ICCID lub nazwę karty SIM",
	"Cloud disconnected. Failed_": "Rozłączono z chmurą. Odtwarzanie filmu nie powiodło się",
	"This sim card_": "Ta karta SIM jest już zarejestrowana na innym koncie.",
	"Incorrect BlackVue SIM_": "Nieprawidłowy numer ICCID karty SIM BlackVue",
	"My shared videos": "Moje udostępnione filmy",
	"Number of events": "Liczba zdarzeń",
	"Added to Event Map": "Dodano do mapy zdarzeń",
	"Successfully added video(s)_": "Pomyślnie dodano film(y) w celu udostępnienia na mapie zdarzeń! Aby sprawdzić stan i zarządzać udostępnianymi filmami, przejdź do opcji Mapa zdarzeń > Moje udostępniane filmy.",
	"Already added to_": "Już dodano do Mapy zdarzeń",
	"This video(s) is already added_": "Film(y) został(y) już dodany(-e) do mapy zdarzeń! Aby sprawdzić stan i zarządzać udostępnianymi filmami, przejdź do opcji Mapa zdarzeń > Moje udostępniane filmy.",
	"BlackVue’s firmware is up_": "Oprogramowanie układowe BlackVue jest aktualne",
	"Service end": "Koniec usługi",
	Resubscribe: Resubscribe$4,
	"Sort ascending": "Sortuj wzrastająco",
	"Sort descending": "Sortuj malejąco",
	plan: plan$4,
	USD: USD$4,
	"Are you sure_Cancel": "Czy na pewno chcesz anulować subskrypcję? Zapoznaj się z poniższym, a następnie potwierdź.",
	"Your current SIM_": "Twoja bieżąca subskrypcja karty SIM kończy się dnia {{a}} i nie będzie już ładowana.",
	"After canceling your_": "Po anulowaniu subskrypcji karty SIM korzystanie z danych na karcie SIM będzie możliwe do daty zakończenia subskrypcji.",
	"You can resubscribe_": "Subskrypcję można wznowić w ciągu 1 miesiąca po zakończeniu bieżącej subskrypcji. Aby wznowić subskrypcję, kliknij przycisk „Subskrybuj ponownie” na liście kart SIM przy {{a}}.",
	"Reason to cancel_": "Przyczyna anulowania subskrypcji",
	"Found an alternative": "Znaleziono alternatywę",
	"Too expensive": "Zbyt droga",
	"Not required anymore": "Już niepotrzebna",
	"Quality issue": "Problem z jakością",
	etc_: etc_$4,
	"Please describe in_": "Opisz szczegółowo",
	"SIM card cannot_": "Karty SIM nie można usunąć, ponieważ jej subskrypcja jeszcze trwa. Aby usunąć tę kartę SIM, najpierw anuluj subskrypcję.",
	"SIM card cannot_2": "Karty SIM nie można usunąć, ponieważ jej subskrypcja jeszcze trwa. Spróbuj ponownie po zakończeniu okresu subskrypcji.",
	"Are you sure_deleteSIM": "Czy na pewno chcesz usunąć tę kartę SIM?<br/>\n<b>Ostrzeżenie: Nie można cofnąć tej akcji. Wszystkie informacje o karcie SIM zostaną od razu usunięte.</b>",
	"ICCID number": "Numer ICCID",
	"Activation date": "Data aktywacji",
	"Current plan": "Bieżący pakiet",
	"Manage Plan": "Zarządzaj pakietem",
	"Next billing on": "Data następnego rozliczenia",
	"View Invoices": "Wyświetl faktury",
	"Choose best plan_": "Wybierz najlepszy pakiet dla siebie",
	"Plan summary": "Podsumowanie pakietu",
	"Ends on_": "Data zakończenia {{a}}",
	"Start from_": "Data rozpoczęcia {{a}}",
	"Your subscription will_": "Subskrypcja zostanie zaktualizowana dnia {{a}}, w momencie zakończenia bieżącego pakietu.",
	"Resubscribe plan": "Subskrybuj plan ponownie",
	"Your subscription will2_": "Twoja subskrypcja rozpocznie się dnia {{a}}, w momencie zakończenia bieżącego pakietu.",
	"Usage is estimated_": "Szacowane zużycie to {{a}}",
	"Days left_": "Pozostało {{a}} dni",
	"Data usage cycle": "Cykl wykorzystania danych",
	Available: Available$4,
	Used: Used$4,
	"Data used": "Ilość użytych danych",
	"Subscribe to n_": "Subskrybuj plan danych {{a}} zastosowany <b>od {{b}} do {{c}}</b> i plan danych {{d}} zastosowany od {{e}}",
	"Will be charged_": "Opłata zostanie pobrana dnia {{a}}",
	"Monthly usage": "Zużycie miesięczne",
	"You have fewer_": "W tym miesiącu pozostało mniej danych!",
	"Get more data": "Pobierz więcej danych!",
	"This video cannot be shared": "Nie można udostępniać tego filmu",
	"This is a video cannot be shared_": "Nie można udostępniać tego filmu, ponieważ nie można aktualnie znaleźć informacji dotyczących jazdy.",
	Cancelled: Cancelled$4,
	Terminated: Terminated$4,
	"Edit name": "Edytuj nazwę",
	"Not connected to_2": "Nie połączono z chmurą. Sprawdź, czy włączono kamerę i moduł połączenia z Internetem.",
	"Some functionality is disabled_": "Niektóre funkcje są wyłączone, ponieważ kamera nie jest połączona z chmurą. Połącz z chmurą <a>tutaj</a>.",
	"If you want to cancel_": "Aby anulować swój plan, kliknij <a>Anuluj subskrypcję</a>.",
	"Select plan": "Wybierz plan",
	"Event map collects_": "Mapa zdarzeń gromadzi informacje o zdarzeniach BlackVue i przedstawia ich wizualizację, zapewniając dane dotyczące sytuacji na pobliskich drogach.",
	"Share your Live_": "Udostępnij plik zdarzenia na żywo. Możesz udostępnić swoje filmy ze zdarzeniami innym użytkownikom wokół siebie.",
	"You can check_": "Możesz obejrzeć udostępniane przez innych filmy ze zdarzeniami.",
	"Service end_": "Koniec usługi: {{a}}",
	"DMS camera recording_": "Nagrywanie przy użyciu kamery DMS w trybie parkowania",
	Sort: Sort$4,
	"Are you sure you want_": "Czy na pewno chcesz usunąć udostępniony film z mapy zdarzeń?",
	"Remove shared video": "Usuń udostępniony film",
	"Explore event map": "Przeglądaj mapę zdarzeń",
	"Event map": "Mapa zdarzeń",
	"Explore the graphic_": "Przeglądaj statystyki graficzne zdarzeń BlackVue w okolicy.",
	"You can filter_": "Możesz filtrować i wyświetlać preferowane zdarzenia.",
	"This video was removed by_": "Ten film został zgłoszony i usunięty przez administratora.",
	Bonus: Bonus$4,
	"Your subscription plan": "Twój plan subskrypcji",
	"Your free trial will_": "Twój bezpłatny okres próbny rozpocznie się dnia {{a}},</br> <strong>i skończy</strong> {{b}}.",
	"Total after free trial": "Łącznie po bezpłatnym okresie próbnym",
	"This sim card is_": "Ta karta SIM nie jest już aktywna.",
	"Firmware is up_": "Oprogramowanie układowe jest aktualne",
	"Keep in mind": "Pamiętaj",
	"Once 1GB of_": "Po zużyciu 1 GB danych usługa będzie niedostępna do daty następnego zresetowania danych [lub do momentu aktualizacji planu do nowszego].",
	"After the SIM_": "Po włożeniu do kamery karty SIM bezpłatny okres próbny rozpocznie się z chwilą rozpoczęcia używania danych.",
	"If you have_questions": "Ewentualne pytania należy kierować do <a>Działu obsługi klienta.</a>",
	"Data reset date": "Data resetowania danych",
	"To use SIM card_": "Aby korzystać z karty SIM, skontaktuj się z <a>Działem obsługi klienta</a> BlackVue",
	"Go to Subscription": "Przejdź do subskrypcji",
	"An error occurred_subscription": "Podczas subskrybowania wybranego planu wystąpił błąd.",
	"Please try again": "Spróbuj ponownie",
	"Failed to subscribe": "Nieudana subskrypcja",
	"Go to Pricing": "Przejdź do cennika",
	"SIM cards will_": "W tym miejscu będą wyświetlane dostępne karty SIM.",
	"1GB for 1_": "1 GB na 1 miesiąc",
	"Pricing Data": "Dane cennika",
	"If you would like to check_": "Aby sprawdzić stan i zarządzać udostępnianymi filmami, przejdź do opcji Mapa zdarzeń > Moje udostępniane filmy.",
	"Connect to Cloud": "Połącz z chmurą",
	"Completed!": "Ukończone!",
	"Back to App": "Powrót do aplikacji",
	"iOS in-app purchase": "Zakup systemu iOS w ramach aplikacji",
	"Android in-app_": "Zakup systemu Android w ramach aplikacji",
	"bonus n days": "dodatkowe {{a}} dni",
	"Want to contribute your_": "Zezwalać na automatyczne udostępnianie automatycznie przesyłanych plików zdarzeń do mapy zdarzeń?",
	"With event map_": "Możesz za pośrednictwem mapy zdarzeń udostępniać automatycznie przesyłany film ze zdarzeniem znajdującym się w pobliżu kierowcom.",
	"You can edit_3": "Możesz także w dowolnym czasie edytować ustawienia funkcji automatyczne udostępnianie automatycznie przesyłanych plików zdarzeń do mapy zdarzeń, przechodząc do obszaru CHMURA BLACKVUE > Ustawienia kamery > Ustawienia prywatności.",
	"If you want to remove videos_": "W przypadku przesyłania osobistych nagrań wideo należy upewnić się, że udostępniane są właściwe informacje.",
	"Total events": "Łącznie zdarzeń",
	"Automatically add Live Event_": "Automatyczne udostępnianie automatycznie przesyłanych plików zdarzeń do mapy zdarzeń",
	"This camera is publicly_": "Ta kamera jest dostępna publicznie tylko w danej lokalizacji.",
	incomplete_zip: incomplete_zip$4,
	"Live Event Upload_": "Przesyłanie zdarzeń na żywo (czas przechowywania: 7 dni)\nWymaga najnowszej wersji oprogramowania układowego",
	"Thank you for_2": "Dziękujemy za okazaną cierpliwość.",
	"Start Web viewer": "Uruchom przeglądarkę sieciową",
	"Are you sure_remove driver": "Czy na pewno chcesz trwale usunąć kierowcę",
	"An error occurred_sim": "Podczas próby subskrybowania wystąpił błąd.",
	"Click the ADD SIM": "Kliknij przycisk DODAJ SIM na stronie listy kart SIM, a następnie przejdź ponownie proces dodawania karty SIM.",
	"Set download options": "Ustaw opcje pobierania",
	"Information may be_": "Information may be transmitted with a delay and may not reflect actual balances.",
	"Swipe left and right to move": "Aby przenieść, przesuń w lewo i w prawo",
	"Scheduled maintenance Notice": "Powiadomienie o zaplanowanej konserwacji",
	"Our Cloud server_": "Nasz serwer w chmurze będzie przechodził zaplanowaną konserwację.",
	"During that time_": "W tym czasie funkcje chmury mogą być niedostępne.",
	"Expected maintenance start_": "Oczekiwany czas rozpoczęcia konserwacji:",
	"Expected duration_": "Oczekiwany czas trwania: {{a}} godzin.",
	"For more information_": "Więcej informacji można znaleźć w <a>[Powiadomieniu o konserwacji serwera]</a>",
	"Do not remind_": "Nie przypominaj ponownie",
	"Cloud Server Maintenance": "Konserwacja serwera chmury",
	"BlackVue Cloud Service_": "Usługa chmury BlackVue jest tymczasowo niedostępna",
	"We are currently_": "Aktualnie trwają czynności konserwacyjne.",
	"We apologize for_": "Przepraszamy za niedogodności.",
	"Driver Monitoring System (DMS)": "System monitorowania kierowcy (DMS, Driver Monitoring System)",
	"Distracted occurs_": "Występuje, gdy głowa kierowcy oddala się od przedniej części o ponad 50 stopni.",
	"Hand distraction event occurs_": "Występuje, gdy ręka kierowcy jest wykrywana w pobliżu głowy przez dłuższy czas (na przykład podczas palenia, trzymania telefonu itp.).",
	"Mask off event occurs_": "Występuje, gdy kierowca wsiada do pojazdu bez maseczki lub gdy kierowca zdejmuje maseczkę.",
	"DMS setting": "Ustawienie DMS",
	"The DMS system has_": "DMS łączy pole wykrywania twarzy dla stanów \"Wykryty\", \"Niewykryty\", \"Roztargnienie\", \"Senność\", \"Zdemaskowany\" oraz pole wykrywania ruchu dla stanu \"Rozproszenie uwagi ręką\".",
	"DMS detection": "Wykrywanie DMS",
	"There are detection criteria for_": "Istnieją kryteria wykrywania dla każdego zdarzenia. Proszę zapoznać się z poniższym przewodnikiem.",
	"DMS camera recording_onoff": "Włączone: Kamera DMS nagrywa w trybie parkowania, dopóki jest podtrzymywane zasilanie. <br/> Wyłączone: Kamera DMS wyłącza się niedługo po wejściu w tryb parkowania.",
	"LED lighting for each event_": "Dioda LED na kamerze monitorującej kierowcę będzie sygnalizować każde wykrycie (Roztargnienie, Senność itp.).",
	"Drowsy and Distracted each have_": "Stany Senność i Rozproszenie mają po trzy stany czułości.\n \n Proszę zapoznać się z poniższym przewodnikiem po interfejsie.",
	"DMS event detection sensitivity": "Czułość wykrywania zdarzeń DMS",
	"Only drowsy and distracted include_": "Tylko stany Senność i Rozproszenie mają ustawienia czułości. Ponadto, jednorazowo ustawiony poziom czułości jest stosowany do dwóch zdarzeń.",
	"When driver’s eyes close_": "Występuje, gdy kierowca zamyka oba oczy podczas jazdy przez ponad 1 sekundę lub ziewa przez 2 sekundy.\n",
	"n digit": "{{a}} cyfr",
	"You are subscribed_free_Smart": "Posiadasz subskrypcję Inteligentnego pakietu chmury BlackVue.",
	"Wi-Fi auto turn on": "Automatyczne włączenie funkcji Wi-Fi",
	"Video on a map": "Video on a map",
	"This feature is only_vom": "This feature is only available to users with a Fleet Plan subscription.<br/>Please subscribe to a plan to unlock this feature.",
	"Total n days_": "Total {{a}} dias de ensaio gratuito",
	"Every events of DMC200_": "Funkcje wykrywania DMS są aktywne tylko w trybie normalnym. Jeśli zasilane w trybie parkowania, kamera DMS nagrywa tylko wideo.",
	"An undetected event occurs_": "Występuje, gdy kierowca nie zostanie wykryty przed kamerą przez 1 minutę.",
	"A detected event occurs_": "A detected Event occurs when the driver is gazing in front since the power is set in the beginning.",
	"Drowsy sensitivity_": "High : When the driver closes their eyes for more than 1 second, it is considered drowsy driving.<br/><br/>Medium : When the driver closes their eyes for more than 1.5 second, it is considered drowsy driving.<br/><br/>Low : When the driver closes their eyes for more than 2 second, it is considered drowsy driving.",
	"Distracted sensitivity_": "High : If the angle of the head is more than 50 degrees away from the front for 3 seconds, it is detected as Distracted.<br/><br/>Medium : If the angle of the head is more than 50 degrees away from the front for 5 seconds, it is detected as Distracted.<br/><br/>Low : If the angle of the head is more than 50 degrees away from the front for 7 seconds, it is detected as Distracted.",
	"Start your subscription now": "Rozpocznij subskrypcję teraz",
	"Free trial period has expired": "Darmowy okres próbny dobiegł końca",
	"1 data plan will start from_": "Wykorzystanie pakietu danych rozpocznie się od {{a}}, obejmując 1GB danych dla karty SIM Blackvue.",
	"Allow the BlackVue_": "Zezwalać aplikacji BlackVue na dostęp do danych GPS kamery samochodowej?",
	"We use this_": "Korzystając z tych danych, możesz śledzić lokalizację samochodu i jego prędkość.",
	"You can edit_": "Ustawienia dostępu do danych GPS można edytować w dowolnej chwili w sekcji BLACKVUE CLOUD > Ustawienia kamery > Ustawienia ochrony prywatności.",
	"SIM cards": "Karty SIM",
	"Subscription status": "Status subskrypcji",
	Upgrades: Upgrades$4,
	"Upgrade plan": "Uaktualnij plan",
	"Manage plan": "Zarządzaj abonamentem",
	"Next plan": "abonament na kolejny miesiąc",
	OR: OR$4,
	"Cancel subscription": "Anuluj subskrypcje",
	Undo: Undo$4,
	Invoice: Invoice$4,
	"Daily usage": "Dzienne wykorzystanie danych",
	"Delete SIM": "SIM Usuń",
	"New card": "Nowa karta kredytowa",
	data: data$4,
	"SIM card data_": "Subskrypcję danych karty SIM można anulować na stronie <a>sim.blackvuecloud.com</a>.",
	"Your plan from_": "Wykorzystanie pakietu danych od dziś do daty wystawienia następnej faktury",
	"Applied during_": "Obowiązuje w okresie {{a}} ~ {{b}}",
	"From today until_": "W okresie od dziś do następnej daty płatności można wykupić tylko taką samą subskrypcję jak w poprzednim miesiącu. Płatności za ten okres zostaną ujęte na dzisiejszej fakturze. <a>Opłaty są naliczane według stawki.</a>",
	"Choose your next plan": "Wybierz następny pakiet danych",
	"Applied from_": "Obowiązuje od {{a}}",
	"Payment for this_": "Płatność za ten pakiet zostanie naliczona dnia {{a}}.",
	"By sharing your_2": "Udostępniając podgląd na żywo, można dzielić się z innymi użytkownikami wrażeniami z prowadzenia pojazdu w różnych krajach. W przypadku udostępniania nagrań wideo należy zadbać o właściwą ochronę prywatności.",
	"Option camera recording_": "Nagrywanie przy użyciu opcjonalnej kamery w trybie parkowania",
	"Front and option camera_": "Kamera przednia i opcjonalna nagrywają jednocześnie.",
	"Option camera stops_": "Kamera opcjonalna przestaje nagrywać po 5 minutach od przejścia w tryb parkowania. Nagrywanie jest wznawiane po przełączeniu do trybu normalnego.",
	"Option camera rotation": "Obrót kamery opcjonalnej",
	"Option camera": "Kamera opcjonalna",
	"Option camera security": "Zabezpieczenie kamery opcjonalnej",
	"Resubscribe until_": "Odnów subskrypcję do: {{a}}",
	"Firmware Update Caution": "Przestroga o aktualizacji oprogramowania układowego",
	"Please check below_": "Przed aktualizacją oprogramowania układowego urządzenia DMC200 należy sprawdzić poniższe warunki:",
	"The camera's Wi-Fi_": "Wi-Fi kamery musi być włączone.",
	"Check if your_": "Należy sprawdzić, czy Wi-Fi kamery jest włączone.",
	"DO NOT disconnect_": "NIE odłączać kabla koncentrycznego podczas aktualizacji oprogramowania układowego.",
	"The camera and_": "Może dojść do uszkodzenia kamery i urządzenia DMC200.",
	"DO NOT try_": "NIE podejmować prób użycia innych funkcji do zakończenia ponownego uruchamiania kamery.",
	"Expecially Reboot camera_": "Do uszkodzenia obu urządzeń może dojść zwłaszcza w wyniku ponownego uruchomienia kamery oraz sformatowania karty SD.",
	"Update anyway": "Zaktualizuj mimo to",
	"Invited on_2": "zaproszony {{Invited Date}} przez Ciebie. Właściciel",
	"BlackVue’s New firmware_": "Dostępne jest nowe oprogramowanie układowe BlackVue",
	"valid thru_": "ważne do: {{a}}",
	"Billed monthly": "Billed monthly",
	"90 minutes Live_": "90 minutes Live View / Live Event Upload*",
	"or 2+ videos_": "or 2+ videos in full resolution*",
	"1GB Free Month_": "1GB Free Month Trial",
	"Cancel anytime": "Cancel anytime",
	"8+ hours Live_": "8+ hours Live View / Live Event Upload*",
	"or 12+ videos_": "or 12+ videos in full resolution*",
	"15+ hours Live_": "15+ hours Live View / Live Event Upload*",
	"or 23+ videos_": "or 23+ videos in full resolution*",
	Popular: Popular$4,
	"For Power Users": "For Power Users",
	"Estimates based on_": "* Estimates based on 4.5MB per minute of Live View, Quick View remote playback, or Live Event Upload file, and 190MB per full original resolution video download or playback (at 25Mbps bitrate). Daily idle Cloud connection data usage: 20MB per 24 hours. Data usage is shared among all types of services (Live View, Live Event Upload, etc.).",
	"Balanced Plan": "Balanced Plan",
	"For Light Cloud_": "For Light Cloud Use",
	"Front security (Normal mode)": "Zabezpieczenie przednie (tryb normalny)",
	"Front security (Parking mode)": "Zabezpieczenie przednie (tryb parkowania)",
	"BT (Parking mode)": "BT (tryb parkowania)",
	"LTE (Parking mode)": "LTE (tryb parkowania)",
	"Wi-Fi (Parking mode)": "Wi-Fi (tryb parkowania)",
	"Hand distraction": "Oderwanie rąk od kierownicy",
	Mask: Mask$4,
	"Second drowsy is_": "Drugi alert senności pojawia się, gdy wykryto senność w ciągu 30 sekund od pierwszego zdarzenia senności, które uruchomiło przekazywanie nagrania podglądu zdarzenia na żywo.",
	"Second drowsy alert": "Drugi alert senności",
	"BlackVue sim card_": "Karta SIM BlackVue może być używana tylko w Kanadzie i USA.",
	"Global support is coming soon.": "Wkrótce możliwa będzie globalna obsługa tych kart.",
	"The video file not found_": "Nie znaleziono pliku wideo, lub podczas odtwarzania wystąpił problem. Spróbuj ponownie.",
	"Start Voice Call": "Rozpocznij połączenie głosowe",
	"End Voice Call": "Zakończ połączenie głosowe",
	"Voice call in use": "Trwa połączenie głosowe",
	"Enable microphone access_": "Uruchom dostęp do mikrofonu, aby korzystać z funkcji dwukierunkowej komunikacji głosowej. Aby uzyskać dostęp do mikrofonu, przejdź do strony ustawień przeglądarki.",
	"You may need to_": "Aby zastosować nowe ustawienia, konieczne może być odświeżenie tej strony.",
	"Eye status": "Stan oczu",
	"Start time of live event upload video": "Czas rozpoczęcia przekazywanego wideo zdarzenia na żywo",
	"Left eye": "Lewe oko",
	"Right eye": "Prawe oko",
	"Drowsy is occured when the driver close his/her eyes more then 1sec": "Zdarzenie senności następuje, gdy kierowca zamknie oczy na dłużej niż 1 s",
	"Driver's Left eye movements with blinking count and period": "Liczba ruchów lewego oka kierowcy z liczbą mrugnięć oraz okres zliczania",
	"Driver's Right eye movements with blinking count and period": "Liczba ruchów prawego oka kierowcy z liczbą mrugnięć oraz okres zliczania",
	"Drowsy big data of the driver and after a Drowsy event occurs": "Zbiór danych dotyczących mrugania oczami kierowcy po wystąpieniu zdarzenia Senności",
	"Sharing video to Event Map": "Udostępnianie wideo na mapie zdarzeń",
	"Want to use a Voice call?": "Czy chcesz użyć połączenia głosowego?",
	"To use a voice call_": "Aby skorzystać z połączenia głosowego, uruchom ponownie Widok na żywo i kliknij „Zezwól”",
	"There is no_": "Nie ma jeszcze żadnych udostępnionych nagrań wideo. \nGdy wideo zostanie udostępnione, pojawi się lista.",
	"Microphone blocked": "Mikrofon zablokowany",
	"Want to center the map on your location?": "Chcesz wyśrodkować mapę na swojej lokalizacji?",
	"To let the app access your location_": "Aby umożliwić aplikacji dostęp do Twojej lokalizacji, uruchom ponownie MAPĘ ZDARZEŃ i po wyświetleniu monitu wybierz „OK”.",
	"Location access permission required": "Wymagane jest zezwolenie na dostęp do lokalizacji.",
	"Are you sure you want_2": "Czy na pewno chcesz usunąć ten film z MAP ZDARZEŃ?",
	"Two-way voice_2": "Two-way voice communication / Voice Call",
	"Not supported by DR650GW and DR650S_": "Not supported by DR650GW and DR650S",
	"DR650S Series only_": "DR650S Series only",
	"Cancel download?": "Czy anulować pobieranie?",
	"Your download is not_": "Pobieranie nie zostało zakończone. Czy chcesz anulować pobieranie?",
	"Continue download": "Kontynuuj pobieranie",
	"Cancel download": "Anuluj pobieranie",
	"Share your video to the Event Map?": "Czy udostępnić film na mapie zdarzeń?",
	"Afterwards, according to the reaction to the video_": "Potem, w zależności od reakcji na film, może być sklasyfikowany jako film popularny i umieszczony w obszarze Teraz popularne na mapie.",
	"Add hashtags and a brief description to describe your video.": "Dodaj hasztagi i krótki opis przedstawiający film.",
	"Would you like_": "Czy chcesz udostępnić na mapie zdarzeń?",
	"Successfully added video_": "Pomyślnie dodano film w celu udostępnienia na mapie zdarzeń.",
	"This video cannot_": "Nie można udostępniać tego filmu, ponieważ nie można aktualnie znaleźć informacji dotyczących jazdy.",
	"This video is_": "Film został już dodany do mapy zdarzeń.",
	"Share to Event Map": "Udostępnij na mapie zdarzeń",
	"Describe in more_": "Opisz szczegółowo zdarzenia przedstawione w swoim filmie (opcjonalnie)",
	"Description(optional)": "Opis (opcjonalny)",
	"Recording mode": "Tryby nagrywania",
	"Event triggers": "Akt. zdarzenia",
	DMS: DMS$4,
	"Camera connectivity": "Łączność kamery",
	"If not allowed_2": "Lokalizacja i prędkość pojazdu będą niedostępne za pośrednictwem chmury, jeżeli jest to niedozwolone.",
	"Share Live View_": "Udostępnij wideo podglądu na żywo",
	"Share Live View_2": "Udostępnij audio podglądu na żywo",
	"Share camera profile": "Udostępnij profil kamery",
	"Parking impact": "Udar podczas parkowania",
	"Parking events": "Parking Events",
	"Audio recording": "Nagrywanie dźwięku",
	"Toggle the mic_": "Wł./wył. mikrofon",
	"Full HD_": "Full HD @ 60fps + Full HD @ 30fps",
	"Video quality": "Jakość wideo",
	Extreme: Extreme$4,
	"More video files": "Więcej plików nagrań",
	"Fewer video files": "Mniej plików nagrań",
	"Camera rotation": "Obrót kamery tylnej",
	"Video overlay": "Nakł. wideo",
	"Date & time display": "Wyświetlanie daty i godziny",
	"Speed unit": "Jednostka prędkości",
	"Check the orientation_": "Sprawdź orientację kamery przedniej zainstalowanej w pojeździe. Wybierz opcję dopasowania, aby nagrywać filmy w orientacji pionowej.",
	"Rotate 180º": "Obróć o 180º",
	"Rear camera rotation": "Obrót kamery tylnej",
	"Check the orientation_rear": "Sprawdź orientację kamery tylnej zainstalowanej w pojeździe. Wybierz opcję dopasowania, aby nagrywać filmy w orientacji pionowej.",
	"Mirror View": "Odbij widok",
	"Select Mirror View_": "Wybierz Odbij widok, aby odwrócić film w poziomie.",
	"Check the orientation_interior": "Sprawdź orientację opcjonalnej kamery zainstalowanej w pojeździe. Wybierz opcję dopasowania, aby nagrywać filmy w orientacji pionowej.",
	"Display off": "Wyłączenie wyświetlacza",
	"Explore crowd-sourced Events_": "Przeglądaj na mapie zdarzenia spowodowane przez inne osoby (wypadek, gwałtowne hamowanie itd.), oglądaj filmy udostępnione przez społeczność i wysyłaj własne zdarzenia.",
	OFF: OFF$4,
	"Reboots once-a-day_": "W celu zapewnienia większej stabilności codziennie o określonej godzinie następuje ponowne uruchomienie po przełączeniu do trybu parkowania.",
	"Set time": "Ustaw godzinę",
	"FW language": "Język oprogramowania układowego",
	"Rear security_2": "Zabezpieczenie tylne",
	"Bluetooth (Parking mode)_2": "Bluetooth (tryb parkowania)",
	"Failed to save_2": "Nie udało się zapisać ustawień przesyłania zdarzenia na żywo",
	"Event file will_": "Plik zdarzenia będzie automatycznie zapisywany w magazynie przesyłania zdarzenia na żywo.",
	"An impact was_": "An Impact was detected during Parking Mode.",
	"When exiting Parking_": "Po zakończeniu trybu parkowania urządzenie BlackVue informuje, czy w jego trakcie zostało wykryte uderzenie. \n\n Uwagi: \n Uderzenia powodują nagranie filmów ze zdarzeniem. Uderzenia wykryte w ciągu trzech minut po zakończeniu trybu parkowania są ignorowane.",
	"Protect event files": "Chroń pliki zdarzenia",
	"Turning on this_": "Włącz tę funkcję, aby chronić najnowsze pliki zdarzeń ({{a}}) przed nadpisaniem przez pliki nagrań z trybu zwykłego lub parkowania.",
	"Impact Events in_": "Impact Events in Normal(E) and Parking Mode(I)",
	"Manual Events_": "Manual Events (M)",
	"Once 50 Events_": "Chronione są następujące pliki: \n\nZdarzenia uderzeń w trybie normalnym (E) i parkowania (I) \nZdarzenia nagr. ręcznie (M) \n\nPo nagraniu nast. liczby zdarzeń ({{a}}) najstarsze pliki będą zastępowane nowymi zdarzeniami.",
	"Reckless driving unit": "Brawurowe prowadzenie pojazdu - jednostka",
	"Hard acceleration Event": "Zdarzenie gwałtownego przyspieszania",
	Threshold: Threshold$4,
	"Triggers when the_": "Uruchamiane, gdy kamera wykryje wzrost prędkości na sekundę większy niż ustawiona wartość progowa.",
	"Triggers when the_2": "Uruchamiane, gdy kamera wykryje spadek prędkości większy niż ustawiona wartość progowa.",
	"Hard braking Event": "Zdarzenie gwałtownego hamowania",
	"Triggers when more_": "Uruchamiane, gdy kamera wykryje zmianę kierunku jazdy o co najmniej 60 stopni w ciągu 2 sekund podczas jazdy z prędkością wyższą niż wartość progowa.",
	"Every event of DMC200_2": "Funkcje wykrywania DMS są aktywne tylko w trybie normalnym. Jeśli zasilana w trybie parkowania, kamera DMS zapisuje tylko nagranie wideo.",
	"The DMS system has_2": "DMS łączy pole wykrywania twarzy dla stanów “Wykryty”, “Niewykryty”, “Roztargnienie”, “Senność”, “Zdemaskowany” oraz pole wykrywania ruchu dla stanu “Rozproszenie uwagi ręką”.",
	"One for face_": "One for face detection : Detected, Undetected, Distracted, Drowsy",
	"The other for_": "The other for motion detection",
	"On: Normal recording_": "On: Normal recording works while power is maintained in Parking Mode",
	"Off: DMS power_": "Off: DMS power off after 5 minutes when entering Parking Mode, Normal recording works until just before off",
	"Drowsy and Distracted_": "Drowsy and Distracted each have three sensitivity conditions.",
	"Please refer to_": "Please refer to the guide interface below.",
	Drowsiness: Drowsiness$4,
	"Drowsiness occurs when_": "Senność występuje, gdy kierowca zamyka oba oczy podczas jazdy przez ponad 1 sekundę i ziewa przez 2 sekundy.",
	"Distracted occurs when_": "Występuje, gdy głowa kierowcy oddala się od przedniej części o ponad 50 stopni.",
	"A hand distraction_": "A hand distraction occurs when the driver removes one hand from the steering wheel. [*Smoking and phone calls may be suspected.]",
	"Mask off event_": "Mask-off event occurs in two ways. First is when the driver gets in the car without a mask. Second is when the driver takes their mask off",
	"High When the_": "High : When the driver closes their eyes for more than 1 second, it is considered drowsy driving.",
	"Middle When the_": "Medium : When the driver closes their eyes for more than 1.5 second, it is considered drowsy driving.",
	"Low When the_": "Low : When the driver closes their eyes for more than 2 second, it is considered drowsy driving.",
	"High If the_": "High : If the angle of the head is more than 50 degrees away from the front for 3 seconds, it is detected as Distracted.",
	"Middle If the_": "Medium : If the angle of the head is more than 50 degrees away from the front for 5 seconds, it is detected as Distracted.",
	"Low If the_": "Low : If the angle of the head is more than 50 degrees away from the front for 7 seconds, it is detected as Distracted.",
	Direct: Direct$4,
	"Camera Wi-Fi credentials": "Poświadczenia Wi-Fi kamery",
	"Network name(SSID)": "Nazwa sieci (SSID)",
	"Seamless pairing": "Seamless Pairing",
	Remote: Remote$4,
	"Hotspot settings": "Ustawienia punktu dost.",
	"Hotspot name": "Nazwa punktu dostępu (SSID)",
	"Hotspot name must_": "Hotspot name must be at least 5 characters long",
	"Public cameras may_": "Kamery publiczne mogą pojawić się na karcie Eksploruj lub na mapie świata.",
	"Hard Cornering Event": "Zdarzenie ostrego skrętu",
	"Over speed_2": "Przekr. ogr. prędk.",
	"Second drawiness alert": "Drugi alert o senności",
	"Low Voltage Warning_2": "Oderwanie rąk od kierownicy",
	"(You)_2": "{{a}} (Ty)",
	"This video has been reported_": "Ten film został zgłoszony i usunięty przez administratora.",
	"Normal Mode recording": "Nagrywanie w trybie normalnym",
	"ON : the camera_": "Wł.: kamera nagrywa stale w pętli.",
	"OFF : the camera_": "Wył.: kamera nagrywa tylko filmy zdarzeń w trakcie jazdy.",
	"In both modes_": "W obu trybach wykryte zderzenia aktywują nagrywanie zdarzeń.",
	"Continuously records_": "Stale nagrywa filmy o długości jednej minuty z prędkością 1 kl./s trwające łącznie 30 minut.",
	"Choose detection regions_": "Wybierz regiony detekcji, aby ograniczyć ryzyko nagrywania nieistotnych zdarzeń detekcji ruchu, takich jak kołysanie drzew na wietrze lub ruch obiektów w oddali.",
	"Your previous plan is expired.": "Poprzedni plan wygasł.",
	"Upgrade the plan to restore the camera": "Uaktualnij plan, aby przywrócić kamerę\n(%@)",
	"Remove from cloud": "Usuń z chmury",
	"Are you sure you want to Remove_": "Czy na pewno chcesz usunąć z połączenia w chmurze?",
	"Remove: It doesn’t mean_": "Usuń: nie spowoduje to usunięcia danych kamery, ale zwolni połączenie dla innych kamer w chmurze.",
	"Now the camera is removed from cloud slot": "Kamera została usunięta z połączenia w chmurze.",
	"How to delete camera list": "Usuwanie kamery z listy",
	Update: Update$4,
	"Camrea setting": "Ustaw. kamery",
	"Notification setting": "Ustawienia powiadomień w trybie push",
	"Driving reports": "Raport z jazdy",
	"Cloud connection steps": "Krok połączenia z chmurą",
	"Download the BlackVue app to add a camera": "Pobierz aplikację BlackVue, aby dodać kamerę",
	"To see your camera in the BlackVue cloud viewer_": "Aby wyświetlić obraz z kamery BlackVue w przeglądarce chmury, najpierw połącz ją z chmurą. Możesz łatwo skonfigurować kamerę BlackVue i połączyć ją z chmurą w aplikacji BlackVue dla systemu iOS i Android.",
	"Download the BlackVue app to see a Wi-Fi connected camera": "Pobierz aplikację BlackVue, aby wyświetlić kamery połączone przez Wi-Fi",
	"BlackVue Cloud web viewer only supports_": "Przeglądarka chmury BlackVue obsługuje tylko kamery połączone z chmurą. Pobierz aplikację BlackVue, aby wyświetlić kamery połączone przez Wi-Fi.",
	"You can restore the data if_": "Możesz przywrócić dane, jeśli zarejestrujesz tę kamerę na tym samym koncie ponownie. Nie będzie można odzyskać plików, jeśli konto zostało usunięte.",
	"How to add camera": "Dodawanie kamery",
	"Try to wait 2-3 minutes if you just registered the camera.": "Poczekaj 2–3 minuty, jeśli kamera została zarejestrowana przed chwilą.",
	"Try to check the Cloud Connection Settings again_": "Ponownie sprawdź ustawienia połączenia z chmurą, jeśli kamera nie łączy się z chmurą.",
	"Motion Detection": "Detekcja ruchu",
	"Parking recordings occur_": "Nagrania postojowe są wykonywane po wykryciu ruchu.",
	"Motion Sensitivity": "Czułość detekcji",
	"Motion Detection Sensitivity": "Czułość wykrywania ruchu",
	"Select Detection Region": "Wybierz obszar wykrywania",
	"Speed alert_2": "Alert prędkości",
	"Live Event Upload_2": "Live Event Upload",
	"Beep Alert": "Alert dźwiękowy",
	"Parking Impact History_": "Historia alertów uderzeń na park.",
	"To register your_": "Aby zarejestrować przycisk SOS, musisz użyć aplikacji BlackVue.",
	"SOS button on/off": "Status przycisku SOS",
	"File sharing to Event Map is_": "Udostępnianie plików na mapie zdarzeń jest obecnie niedostępne. Sprawdź później.",
	"Email Notifications": "Powiadomienia email",
	"Push Notifications_2": "Powiadomienia w trybie push",
	"Optional Camera Rotation": "Orientacja kamery opcjonalnej",
	"Optional Camera Security": "Zabezpieczenie kamery opcjonalnej",
	Option: Option$4,
	"(Owner)": "{{a}} (Właściciel)",
	"SOS button": "Przycisk SOS",
	"This video has been reported_bold": "Ten film został zgłoszony i <b>usunięty przez administratora</b>.",
	"Number of events_2": "Liczba zdarzeń",
	"My Shared Videos": "Moje udost. filmy",
	"No Hashtags": "Brak hasztagów",
	"I have read and agree_": "Potwierdzam przeczytanie i akceptację wszystkich warunków i zasad",
	"14 years old_": "Co najmniej 14 lat",
	Required: Required$4,
	Optional: Optional$4,
	"Profile information_": "Informacje o profilu można edytować na stronie Ustawienia konta.",
	"Automatically Add Live_": "Automatyczne udostępnianie automatycznie przesyłanych plików zdarzeń do mapy zdarzeń",
	"You must be 14 years_": "Konto BlackVue mogą tworzyć tylko osoby w wieku co najmniej 14 lat",
	"Use 8 or more characters_": "Użyj kombinacji co najmniej 8 znaków, takich jak litery, cyfry lub symbole",
	"Protected files include_": "Chronione są następujące pliki: \n\nZdarzenia uderzeń w trybie normalnym (E) i parkowania (I) \nZdarzenia nagr. ręcznie (M) \n\nPo nagraniu nast. liczby zdarzeń ({{a}}) najstarsze pliki będą zastępowane nowymi zdarzeniami.",
	"Protected files include": "Protected files include",
	"If you turn_": "Jeśli wyłączysz funkcję głosowego przewodnika, wyłączone zostaną następujące listy.",
	"Live Event Upload_success": "Pomyślnie zapisano ustawienia przesyłania zdarzeń na żywo.",
	"Video type": "Typy wideo",
	"Notify the Owner": "Powiadom właściciela",
	"Adjusting the cut-off voltage_2": "Adjusting the cut-off voltage to a lower setting may result in your dash cam draining more power from your battery. This could result in warning messages of battery drain or affect other vehicle functions.\nPlease consult with your dealership before lowering the voltage.",
	Others: Others$4,
	"This video has been removed.": "Ten film został usunięty.",
	"Please assign cameras_": "Przypisz kamery do tej grupy.",
	"Are you running_": "Czy kończy Ci się czas na obejrzenie filmu?",
	"Upgrade your plan_": "Uaktualnij do planu flotowego, aby oglądać bez ograniczeń i korzystać z innych funkcji w chmurze.",
	"Are you running_Liveview": "Czy kończy Ci się czas na obejrzenie podglądu na żywo?",
	"Upgrade your plan_Liveview": "Uaktualnij do planu flotowego, aby używać podglądu na żywo bez ograniczeń i korzystać z innych funkcji w chmurze.",
	Stay: Stay$4,
	"Go to Fleet Plan": "Uaktualnij do planu flotowego",
	"It looks like the video file is being prepared. please try again later.": "Wygląda na to, że plik wideo jest przygotowywany. Spróbuj ponownie później.",
	"Oops!": "Ups!",
	"Please back up_": "Przed zmianą tego ustawienia wykonaj kopię zapasową wszystkich ważnych nagrań.",
	"When you save_": "Po zapisaniu ustawień karta microSD zostanie sformatowana, a wszystkie nagrania zostaną usunięte, aby zapewnić stabilną pracę.",
	"This is an unregistered_": "To jest niezarejestrowany e-mail. Czy chcesz przejść do strony Utwórz konto?",
	"Camera name must_2": "Nazwa kamery musi zawierać od 5 do 32 znaków.",
	"G-sensor (Normal mode)": "Czujnik przeciążenia (tryb normalny)",
	"G-sensor (Parking mode)": "Czujnik przeciążenia (tryb parkowania)",
	"Up & down": "W górę i w dół",
	"Front & back": "Do przodu i do tyłu",
	"Rotate Video 180º": "Rotate Video 180º",
	Mask_2: Mask_2$4,
	"Priority event": "Priority Event",
	"There is no_camera": "There is no camera that your owner assigned to you.",
	"Camera SSID": "Camera SSID",
	"The BlackVue dashcam_2": "The BlackVue dashcam is not compatible with 5GHz wireless networks",
	"Driver detection box_2": "Driver Detection Box",
	"DMS camera recording_2": "DMS Camera Recording in Parking Mode",
	Low_2: Low_2$4,
	Medium_2: Medium_2$4,
	High_3: High_3$4,
	"Live Event Upload_3": "Live Event Upload",
	"Driving Impact": "Driving Impact",
	"Video source_2": "Video Source",
	"Front camera_2": "Front Camera",
	"Rear camera_2": "Rear Camera",
	"Optional Camera": "Optional Camera",
	"Motion Detection_2": "Motion Detection",
	"Rear camera stops_2": "Rear camera stops recording 5 minutes after entering Parking Mode. Recording restarts when entering normal mode.",
	"Passenger vehicle": "Passenger Vehicle",
	"Heavy vehicle": "Heavy Vehicle",
	Highest_3: Highest_3$4,
	Extreme_2: Extreme_2$4,
	"Less recording files": "Fewer Recording Files",
	"Camera rotation_2": "Camera Rotation",
	"Share camera profile_2": "Share Camera Profile",
	Private_2: Private_2$4,
	"BlackVue Live": "BlackVue Live",
	"Important All saved_": "Important! All saved videos are about to be deleted. Tap Cancel and back up important files if needed.",
	"Whenever saving settings_": "Whenever saving settings after changing the time zone, the SD card is initialized and all stored files are deleted.",
	"Do you want_": "Do you want to save your changes?",
	"No groups": "No groups",
	Lite: Lite$4,
	"USD per Camera": "USD per extra Camera",
	"up to Cameras": "up to Cameras",
	"All the P Plan_": "Wszystkie funkcje planu <b>{{a}}</b>, a także:",
	"User Roles and Permissions": "Role i uprawnienia użytkowników",
	"Geofence Setup (Web) and alerts": "Geofence Setup (Web) and alerts",
	"N Times": "{{a}} Raz",
	"N Minutes": "{{a}} Minuty",
	"Emergency Alarm": "Alarm awaryjny",
	"Playback, Live View": "Odtwarzanie, Live View",
	"Your driving record : Daily, Monthly": "Twój rejestr jazdy: Dzienny, Miesięczny",
	"Real-time Conversation": "Rozmowa w czasie rzeczywistym",
	"Initiate a conversation_": "Zainicjuj rozmowę z kierowcą przez głośnik i mikrofon z kamery desakcyjnej.",
	"Remote Voice Communication": "Zdalna komunikacja głosowa",
	"See the last location_": "Zobacz ostatnią lokalizację aparatu",
	"Check your cars_": "Sprawdź dane GPS w czasie rzeczywistym samochodu na mapie, aby zlokalizować pojazd i uzyskać informacje o jego statusie, na przykład jeździ, czy zaparkowane, i jego prędkość.",
	"Supported models_": "* Modele obsługiwane: modele S i Early X Series",
	"GPS Tracking &_": "Śledzenie GPS i wideo na mapie (inteligentne/floty)",
	"Track your cars_": "Śledź lokalizację i prędkość samochodu na mapie!",
	"GPS Tracking: visualize_": "Śledzenie GPS: Wizualizuj dziennik jazdy na mapie.\nWideo na mapie: Wyświetl informacje kontekstowe (prędkość, typ zdarzenia) i odtwarz powiązane filmy z mapy.",
	"Visualize your cars_": "Wizualizuj lokalizację i prędkość swojego samochodu na mapie!",
	"The feature enables_": "Ta funkcja umożliwia przesyłanie nagrań wideo do chmury, w tym 5 sekund przed wypadkiem.",
	"Camera profile setting": "Camera profile setting",
	"Are you running_Download": "Are you running out of chance to Download Video?",
	"Upgrade your plan_Download": "Upgrade your plan to Fleet Plan for Unlimited Download, and other Cloud -Exclusive features.",
	"This feature is available for Smart and Fleet_": "This feature is available for Smart and Fleet Plan subscribers only.",
	"Rear camera will keep_": "Tylna kamera przestaje rejestrować w trybie parkowania, gdy stan temperatury kamerki samochodowej zostaje zmieniony na \"Wysoka temperatura\". Tylna kamera rozpocznie rejestrowanie ponownie po zmianie stanu temperatury kamerki samochodowej na \"Normalna temperatura\". (Uwaga: W celu ochrony elektroniki, Blackvue może się wyłączyć z powodu wysokiej temperatury zewnętrznej.)",
	"Get Unlimited Cloud_": "Uzyskaj nieograniczone odtwarzanie w chmurze i zarządzaj do {{a}} kamer.",
	"Up to N cameras_": "Up to {{a}} cameras (+ {{b}} USD Extra charge)",
	"N Minutes per Day": "{{a}} minut dziennie",
	"Drowsiness sensitivity is_": "Czułość senności można ustawić na podstawie częstotliwości mrugania oczami za pomocą niezawodnego algorytmu BlackVue. <br> <br> Czułość Rozproszenia uwagi ustawia się na podstawie kąta położenia głowy kierowcy względem przodu oraz czasu trwania tego położenia.",
	"Not available with this plan": "Not available with this plan",
	"The optional camera records_": "Opcjonalna kamera nagrywa w trybie parkowania",
	"Smart and Fleet_": "Smart and Fleet Plan<br/>subscribers only",
	"This feature is_smart": "This feature is available for Smart and Fleet Plan subscribers only.",
	"Camera Registration": "Rejestracja kamery",
	"Voice Call": "Voice Call",
	"N times per Month": "{{a}} times per Month",
	"Recommended for higher bitrate_": "Zalecane dla wyższej szybkości transmisji i lepszej jakości wideo.",
	"Recommended for for better compatibility_": "Zalecane dla lepszej kompatybilności z urządzeniami komputerowymi i mobilnymi",
	"A minute of front camera_": "Szacowany rozmiar pliku dla 1 -minutowej wideo (przednia aparat)",
	"Extreme(N Mbps): N MB_": "Extreme ({{ex1}}Mbps) : {{ex2}}MB\nHighest ({{ht1}}Mbps) : {{ht2}}MB\nHigh ({{hi1}}Mbps) : {{hi2}}MB\nNormal ({{no1}}Mbps) : {{no2}}MB",
	"File size information reflects_": "Informacje o rozmiarze pliku odzwierciedlają maksymalny możliwy rozmiar, a rzeczywiste rozmiary plików mogą się różnić w zależności od warunków nagrywania.",
	Bitrate: Bitrate$4,
	"Connection has been_": "Połączenie zostało utracone.\nPrzywrócenie połączenia ...",
	"Unable to establish_": "Nie można nawiązać połączenia z kamerą.\nUpewnij się, że urządzenie jest poprawnie podłączone i spróbuj ponownie.",
	"Purchased by Payment Service": "Kupione przez Serwis Płatności",
	"Up to N Cameras": "Do {{a}} kamer",
	"Unlimited Live View": "Nieograniczony podgląd na żywo",
	"N Days GPS Tracking": "Śledzenie GPS przez {{a}} dni",
	"Unlimited Playback and Download": "Odtwarzanie i pobieranie nieograniczone\n",
	hours: hours$4,
	"Live Event Upload or_": "Live Event Upload lub 12+ filmów w pełnej rozdzielczości",
	"During the usage period of the One Plan_": "W okresie korzystania z usługi One Plan, zmiany planu subskrypcji nie są możliwe. Aby przełączyć się na inny plan, skontaktuj się z Obsługą Klienta BlackVue, aby anulować subskrypcję One Plan.",
	"Service Period (Include SIM Data)": "Okres usługi (Obejmuje dane SIM)",
	"Purchase the BlackVue One Package_": "Kup pakiet BlackVue One, aby odblokować bezpłatnie One Plan na 1 rok.",
	"3GB SIM Data Plan": "Plan danych SIM 3GB",
	"Unlimited Live View, Playback and Download": "Nieograniczone oglądanie na żywo, odtwarzanie i pobieranie",
	"within data availability": "w ramach dostępności danych",
	"The BlackVue One Plan is a 1-year_": "BlackVue One Plan to 1-letni plan usługi w chmurze, dostępny wyłącznie po zakupie pakietu BlackVue One, który obejmuje kamerę samochodową, 1-letni plan danych 3GB/mies. (dla USA i Kanady) oraz 1-letni plan usługi w chmurze.",
	"The BlackVue One Package is available_": "Pakiet BlackVue One jest dostępny wyłącznie w sklepie internetowym BlackVue.",
	"Go to BlackVue Shop": "Przejdź do sklepu BlackVue",
	"Anonymous Cam": "Anonimowa kamera",
	"App only": "tylko w aplikacji",
	Expires: Expires$4,
	"N days remaining": "Pozostało {{a}} dni",
	"No action needed_": "<b>Nie jest wymagane żadne działanie.</b> Nowa obniżona cena zostanie automatycznie zastosowana od Twojej następnej płatności po 13 września.",
	"The new reduced price_": "Nowa obniżona cena zostanie automatycznie zastosowana do Twojego konta.",
	"Smart Plan Subscriber?": "Subskrybent Smart Plan?",
	"Fleet Plan Subscriber?": "Subskrybent Fleet Plan?",
	"Please take a moment to_": "Prosimy poświęcić chwilę, aby autoryzować nas do migracji Twojego konta.",
	"Starting from now and_": "<b>Począwszy od teraz do 31 października</b>, możesz pozwolić nam dokonać zmiany, klikając <a href=\"https://form.jotform.com/232411253056041\" target=\"_blank\">ten link</a> i podając adres e-mail swojego konta Fleet. Prosimy o trochę czasu na przetworzenie zmiany. W alternatywie, będziesz mógł anulować swoje istniejące konto i ponownie zapisać się po nowej cenie od 13 września.",
	"Once activated_": "Po aktywacji One Plan nie można go zatrzymać ani dezaktywować.",
	"Once the One Plan is activated_": "Po aktywacji One Plan, One Package nie może być zwrócony.",
	"Up to N Cloud Camera Slot": "Do {{a}} gniazd kamery chmury",
	"nGB of Cloud Storage": "{{a}}GB przestrzeni dyskowej w chmurze",
	"Get started for free_": "Get started for free, no credit card required. Includes Alert Push Notifications, limited Remote Live View and cloud storage.",
	"The BlackVue One Plan is exclusively_": "The BlackVue One Plan is exclusively available through the purchase of a BlackVue One Package. 3GB/mo data plan is for US and Canada only. BlackVue Cloud’s Free Plan, Lite Plan (1~3) and Smart Plan (1~3) accounts can upgrade to One Plan. However, Lite Plan (4~15), Smart Plan (4~15) and Fleet Plan accounts can not be upgraded to One Plan.",
	"For N year": "For {{a}} year",
	"Included in the One Package": "Included in the One Package",
	"3GB SIM Data Plan for N year": "3GB SIM Data Plan for {{a}} year",
	"One Plan Cloud Service for N year": "One Plan Cloud Service for {{a}} year",
	"The BlackVue One Package includes_": "The BlackVue One Package includes all you need to enjoy BlackVue Cloud for a whole year!",
	"4K LTE Dash Cam_": "4K LTE Dash Cam, Cloud Service and Data Plan",
	"nGB included": "{{a}}GB included",
	"nGB per camera": "{{a}}GB per camera",
	"N Days Live Event Upload": "{{a}} Days Live Event Upload",
	"Up to N Dash Cameras": "Up to {{a}} Dash Cameras",
	"Step N/N": "Krok {{a}}/{{b}}",
	"Cloud Connection": "Połączenie z chmurą",
	"To pair your dashcam": "Aby sparować swoją kamerę samochodową z baterią, podłącz ją do chmury.",
	Check: Check$4,
	"Unpair Battery": "Rozłącz baterię",
	"Are you sure you want to unpair": "Czy na pewno chcesz odłączyć tę baterię (%@) od kamery?",
	"Unpair: It doesn't mean": "Odłącz: To nie oznacza usuwania danych baterii.",
	"*The paired battery will": "*Sparowana bateria zostanie również usunięta razem.",
	"Would you like to pair this": "Czy chciałbyś sparować tę baterię?",
	"Battery successfully paired": "Bateria pomyślnie sparowana.",
	"Now you can directly connect to": "Teraz możesz bezpośrednio połączyć się z baterią z listy kamer.",
	"Pairing failed": "Nie udało się sparować. Spróbuj ponownie.",
	"Battery Name": "Nazwa baterii",
	"Capacity History": "Historia pojemności",
	"The graph displays capacity": "Wykres wyświetla przybliżony poziom naładowania baterii, korzystając z danych z połączenia z chmurą.\n Pojemność baterii może się różnić w zależności od temperatury, ustawień wideorejestratora samochodowego i częstotliwości występowania zdarzeń wyzwalających.",
	"Last 24 Hours": "Ostatnie 24 godziny",
	"Last 7 Days": "Ostatnie 7 dni",
	"Battery Level": "Poziom naładowania",
	"Temperature History": "Historia temperatury",
	"The graph displays temperature": "Wykres wyświetla przybliżony poziom temperatury przy użyciu danych z połączenia chmurowego.",
	"Temperature Level": "Poziom temperatury",
	"Connecting alert": "[ Łączenie ]\nDane wyświetlane po połączeniu.",
	"Low Output power Alert": "[ Wyłączenie zasilania wyjściowego ]\nNapięcie wyjściowe jest zbyt niskie, co ogranicza zasilanie podłączonego urządzenia.",
	"High temp Alert": "[ Odcięcie zasilania wejściowego ]\nTemperatura baterii jest zbyt wysoka, co ogranicza ładowanie.",
	"Remaining time": "Pozostały czas",
	"Remaining time estimate": "Pozostały czas to szacunek oparty na całkowitym zużyciu energii podłączonych urządzeń.\n Jest ponownie obliczany co 30 sekund po podłączeniu do baterii.",
	"Setting changed": "Zmiana ustawień",
	"Setting change failed": "Błąd zmiany ustawienia",
	"Low Input power Alert": "[ Odcięcie zasilania wejściowego ]\nNapięcie ładowania jest zbyt niskie, co ogranicza ładowanie.",
	"High Input power Alert": "[ Odcięcie zasilania wejściowego ]\nNapięcie ładowania jest zbyt wysokie, co ogranicza ładowanie.",
	"Low temp_Cut off Alert": "[ Odcięcie zasilania wejściowego ]\nTemperatura baterii jest zbyt niska, co ogranicza ładowanie i czas trwania.",
	"Low temp Alert": "[ Niska temperatura ]\nTemperatura baterii jest zbyt niska, co ogranicza czas działania i prędkość ładowania.",
	"Low capacity Alert": "[ Niska pojemność ]\nPojemność baterii jest zbyt niska.\nJedź samochodem, aby go naładować.",
	"Back to list": "Powrót do listy",
	Saving: Saving$4,
	Now: Now$4,
	"Power supplying is limited": "Zasilanie jest <b>ograniczone</b>",
	"This battery is already paired": "Ta bateria jest już sparowana.",
	"Connecting to Battery": "Łączenie z baterią",
	"Paired battery": "Bateria sparowana",
	"Battery unpairing failed": "Nie udało się rozłączyć baterii. Spróbuj ponownie.",
	"A connection is already active": "Połączenie jest już aktywne. Proszę spróbować ponownie później.",
	"Searching for battery": "Wyszukiwanie baterii",
	"Select battery to pair with your camera": "Wybierz baterię do sparowania z aparatem.",
	"Unable to connect": "Nie można połączyć",
	"A connection error has occurred": "Wystąpił błąd połączenia. Spróbuj ponownie.",
	"The paired dashcam has been disconnected": "Sparowana kamera samochodowa została odłączona od Chmury.\nProszę sprawdź poniższe warunki.",
	"Check if the battery is not fully discharged": "Sprawdź, czy bateria nie jest całkowicie rozładowana",
	"Check the Cloud connection of the paired dashcam": "Sprawdź połączenie z chmurą sparowanego kamery samochodowej.",
	"Connection lost": "Utracono połączenie",
	"A connection error has occurred shortly": "Wystąpił błąd połączenia. Proszę spróbować ponownie połączyć się wkrótce.",
	"Charging is limited": "Ładowanie jest <b>ograniczone</b>",
	"Cannot connect to the battery": "Nie można połączyć się z baterią.",
	"Please check the Cloud connection of the camera": "Proszę sprawdzić połączenie kamery z chmurą.",
	"Charging complete in": "Ładowanie ukończone w %@",
	"Current Capacity": "Obecna Pojemność",
	"Output Voltage": "Napięcie Wyjściowe",
	"Charging Voltage": "Napięcie Ładowania",
	Beep: Beep$4,
	"Battery Capacity": "Pojemność baterii",
	"Battery connection failed": "Nawiązanie połączenia z baterią nie powiodło się",
	"Expansion battery": "Bateria zapasowa",
	"Make sure it is switched on and within range": "• Upewnij się, że kamera jest włączona i w zasięgu urządzenia przenośnego.",
	"Make sure it is not wirelessly connected to another device": "• Upewnij się, że nie jest połączona bezprzewodowo z innym urządzeniem.",
	"Detected batteries": "Wykryte baterie",
	"Can't see your battery": "Nie widzisz swojego akumulatora?",
	"Download the Blackvue app to check": "Pobierz aplikację BlackVue aby zdalnie sprawdzić swoją baterię",
	"By Using the app": "Korzystając z aplikacji, możesz sparować kamerę samochodową z baterią i monitorować pojemność baterii w chmurze. Po sparowaniu możesz sprawdzić baterię w przeglądarce chmurowej BlackVue.",
	Unpair: Unpair$4,
	"Occurs when the driver closes_": "Występuje, gdy kierowca zamyka oba oczy podczas jazdy",
	"Occurs when the driver's head_": "Występuje, gdy głowa kierowcy jest bardziej niż 50 stopni od przodu.",
	"Only detects distraction above_": "Wykrywa tylko rozproszenie uwagi powyżej ustawionej wartości. Możesz zmienić jednostkę w \"Ustawienia kamery > Akt. zdarzenia > Brawurowe prowadzenie pojazdu - jednostka\".",
	"Occurs when the driver is not wearing_": "Występuje, gdy kierowca nie nosi pasów bezpieczeństwa.",
	"Overlays a face detection box_": "Nakładanie pudełka detekcji twarzy na obraz na żywo i zarejestrowane z kamery DMS.",
	"Seat Belt": "Pas bezpieczeństwa",
	Detected: Detected$4,
	"No Seat Belt": "Brak pasa bezpieczeństwa",
	"Fatigue Risk Alert": "Alert ryzyka zmęczenia",
	"The time is synchronized_Email": "Czas jest zsynchronizowany z czasem w twoich powiadomieniach e-mail.",
	"Sends an alert when drowsiness is_": "Wysyła alert, gdy wykryto senność po pierwszej senności.",
	"Data updates upon connection": "Dane są aktualizowane po połączeniu.",
	"Sends a notification if_": "Wysyła powiadomienie, jeśli przekroczysz 'Ustaw godzinę' podczas jazdy.",
	"Data updates Alert": "[ Łączenie ]\nDane są aktualizowane po połączeniu.",
	"Cannot save settings": "Nie można zapisać ustawień",
	"The time is synchronized_Push": "Czas jest zsynchronizowany z czasem w twoich Powiadomieniach w trybie push.",
	"The file has been overwritten or deleted": "Plik został zastąpiony lub usunięty.",
	"Box Pro Models Settings": "Ustawienia modeli Box Pro",
	"Push notifications can be configured_": "Powiadomienia push można skonfigurować w ustawieniach powiadomień kamery.",
	"Recording Video": "Nagrywanie wideo",
	"Cameras settings": "Ustawienia kamer",
	"Please configure the settings": "Proszę skonfigurować ustawienia",
	"Speed Priorities": "Priorytety prędkości",
	"Set Speed Priority": "Ustaw priorytet prędkości",
	"Geofence-enter": "Ogrodzenie wirtualne - wejście",
	"Geofence-exit": "Ogrodzenie wirtualne - wyjście",
	"Geofence-pass": "Ogrodzenie wirtualne - przejście",
	"Geofence-speed alert": "Ogrodzenie wirtualne - Alert prędkości",
	"Drive Position": "Pozycja kierowcy",
	"Left-Hand Drive": "Kierownica po lewej",
	"Right-Hand Drive": "Kierownica po prawej",
	"Please configure this setting_": "Proszę zmienić to ustawienie, jeśli kierowca nie został prawidłowo wykryty.",
	"A new feature in the BlackVue settings_": "Do ustawień BlackVue dodano nową funkcję umożliwiającą synchronizację czasu aparatu. Aby uzyskać dokładny zapis czasu, należy jednorazowo zsynchronizować czas w aparacie.",
	"Feature location_": "Lokalizacja funkcji:\nUstawienia aparatu> System > Synchronizacja czasu",
	"Time Sync": "Synchronizacja czasu",
	"You can sync the time between_": "Możesz zsynchronizować czas między swoim urządzeniem a kamerą BlackVue. Do synchronizacji wymagane jest sformatowanie karty SD. Przed kontynuacją proszę wykonać kopię zapasową niezbędnych filmów.",
	"Voice Alert": "Alert głosowy",
	"Provides a voice alert_": "Zapewnia alert głosowy z kamery i wysyła powiadomienie, jeśli przekroczysz ustawiony czas podczas jazdy.",
	"Please enter a value": "Please enter a value.",
	"Notices & Notifications": "Wiadomości i Powiadomienia",
	"Only detects drowsiness above_": "Wykrywa tylko senność powyżej ustawionej wartości. Możesz zmienić jednostkę w \"Ustawienia kamery > Akt. zdarzenia > Brawurowe prowadzenie pojazdu - jednostka\".",
	Promotion: Promotion$4,
	Notice: Notice$4,
	"View More": "Zobacz więcej",
	"Read More": "Czytaj więcej",
	"Detection Box": "Skrzynka Wykrywania",
	"Seatbelt Detection Box": "Skrzynka Wykrywania Pasa Bezpieczeństwa",
	"Drive Position Detection Box": "Skrzynka Wykrywania Pozycji Jazdy",
	"Fleet Subscription Promotion (50%)": "Promocja subskrypcji floty (50%)",
	"BlackVue Fleet Tracking exclusive features_": "Ekskluzywne funkcje BlackVue Fleet Tracking dla zaawansowanych użytkowników i firm (wielu użytkowników i kamery, geofencing, przeglądarka internetowa itp.).",
	"Special Discount (50% off)": "Specjalna zniżka (50% zniżki)",
	"*Promotion applied for 12 months": "*Promocja obowiązuje przez 12 miesięcy",
	"*Payment will be made starting next month.": "*Płatność będzie dokonywana począwszy od przyszłego miesiąca.",
	"[About using promotions]": "[O korzystaniu z promocji]",
	"The promotion is free for the first month_": "Promocja jest bezpłatna przez pierwszy miesiąc, a następnie naliczana jest opłata przez 12 miesięcy, począwszy od następnego miesiąca.",
	"For users with an existing Lite/Smart subscription_": "W przypadku użytkowników posiadających istniejącą subskrypcję Lite/Smart musisz oddzielnie anulować istniejącą subskrypcję aplikacji, w przeciwnym razie Twoje konto może zostać obciążone istniejącą subskrypcją aplikacji.",
	"Please be sure to cancel your app subscription_": "Pamiętaj, aby anulować subskrypcję aplikacji w bezpłatnym okresie. Podwójne płatności nie zostaną zwrócone.",
	"You will be changed to Fleet Plan immediately_": "Zostaniesz natychmiast zmieniony na Plan Fleet, nawet jeśli pozostały okres subskrypcji Twojego istniejącego Planu Lite/Smart jeszcze nie wygasł.",
	"You can cancel Fleet Plan any time.": "Plan flotowy możesz anulować w dowolnym momencie.",
	"From February 2025, please go to the Fleeta service and use it.": "Po anulowaniu promocji promocja nie zostanie zastosowana ponownie.",
	"After promotion expires_": "Po wygaśnięciu promocji nastąpi automatyczne odnowienie istniejącej opłaty abonamentowej Fleet Plan.",
	"(Required) I have read the promotion instructions_": "(Wymagane) Zapoznałem się z instrukcją promocji i zgadzam się na płatność.",
	"Upgrade to Fleet Plan immediately": "Natychmiast przejdź na plan flotowy",
	"Important Notice:": "Ważna uwaga:",
	"Switch of BlackVue Web Viewer to Fleeta Web Viewer": "Zmień przeglądarkę BlackVue Web Viewer na Fleeta Web Viewer",
	"To provide better features and quality_": "Aby zapewnić lepsze funkcje i jakość, przeglądarka internetowa BlackVue wkrótce zostanie przełączona na nową usługę przeglądarki internetowej floty o nazwie Fleeta. Usługi Fleet będą dostępne wyłącznie dla użytkowników Fleet Plan. Usługa Fleeta zostanie uruchomiona w marcu 2025 r. wraz z nową, ekskluzywną aplikacją Fleeta. Odwiedź <a href=\"https://www.fleeta.io\" target=\"_blank\">fleeta.io</a>, aby dowiedzieć się więcej.",
	"We kindly ask for your understanding_": "Uprzejmie prosimy o wyrozumiałość, ponieważ ta zmiana ma na celu ulepszenie usług. W przypadku jakichkolwiek pytań dotyczących tego przejścia prosimy o kontakt z naszym centrum CS.",
	"Don’t show this again for this month": "Nie pokazuj tego ponownie w tym miesiącu",
	"Fleet Plan Subscription Promotion": "Promocja subskrypcji planu flotowego",
	"Period : December 2, 2024 ~ May 31, 2025": "Okres: 2 grudnia 2024 r. ~ 31 maja 2025 r",
	"See more details": "Zobacz więcej szczegółów",
	"To continue improve quality and provide better service_": "Aby w dalszym ciągu podnosić jakość i zapewniać lepszą obsługę, nasza usługa BlackVue Web Viewer wkrótce zostanie przełączona na ekskluzywną usługę Fleet Plan. Nie będzie już dostępna bezpłatnie ani w ramach innych planów począwszy od końca marca 2025 r.",
	"We have prepared special discount offers for_": "Dla naszych obecnych użytkowników Web Viewer przygotowaliśmy specjalne oferty rabatowe. Sprawdź szczegóły poniżej! Uprzejmie prosimy o zrozumienie i wsparcie podczas wdrażania tej zmiany, aby zapewnić lepszą obsługę.\n",
	"*If you are subscribed in-app_": "*Jeśli subskrybujesz w aplikacji, pamiętaj o anulowaniu subskrypcji w aplikacji.",
	"Enjoy your BlackVue Cloud service with your dashcam.": "Korzystaj z usługi BlackVue Cloud za pomocą kamery samochodowej.",
	"Available Cloud Camera slot(s)_": "Dostępne gniazda kamery Cloud: {{d}}",
	"Not eligible for the promotion.": "Nie kwalifikuje się do promocji.",
	"You have already used_": "Skorzystałeś już z tej promocji. Po anulowaniu promocji nie można z niej skorzystać ponownie.",
	"Go to Cameras": "Przejdź do opcji Aparaty",
	"Congratulations !": "Congratulations !",
	"Fleet Plan user": "Fleet Plan user",
	"Let your BlackVue monitor_": "Pozwól swojemu BlackVue monitorować Twój samochód i powiadamiać Cię o zdarzeniach. W momencie wykrycia uderzenia BlackVue wyśle ​​powiadomienie na Twój telefon wraz ze zrzutem ekranu.\n",
	"Live Event Upload feature automatically_": "Funkcja przesyłania wydarzeń na żywo automatycznie przesyła nagrania wideo, w tym nagrania sprzed wypadku, do chmury BlackVue, aby zapewnić bezpieczeństwo Twoich filmów!",
	"*Buffer time varies by model.": "*Czas buforowania różni się w zależności od modelu.",
	Explore: Explore$4,
	"Cloud Storage": "Przechowywanie w chmurze",
	"My Cloud Cameras": "Moje kamery w chmurze",
	"My Cloud Cameras Only": "Tylko kamery My Cloud",
	"BlackVue Live Camera": "Kamera na żywo BlackVue",
	"*For BlackVue Live Cameras_": "*W przypadku kamer BlackVue Live na mapie można wyświetlać wyłącznie kamery udostępnione publicznie w ustawieniach kamery.",
	"*Share Method_": "*Metoda udostępniania: Ustawienia kamery>Prywatność",
	"Once the promotion is canceled_": "Po anulowaniu promocji promocja nie zostanie zastosowana ponownie.",
	"It will show_": "Pojawi się tutaj, gdy będą dostępne.",
	"Deactivate Cloud": "Dezaktywuj chmurę",
	"Are you sure you want to deactivate_": "Czy na pewno chcesz dezaktywować usługę Cloud dla tej kamery?",
	"Deactivate : It doesn’t_": "Zawsze możesz aktywować chmurę w dowolnym momencie. Kamerę można usunąć po zakończeniu dezaktywacji.",
	Deactivate: Deactivate$4,
	"*If you made the payment through_": "*Jeśli dokonałeś płatności za pośrednictwem aplikacji, uruchom ponownie aplikację.",
	"Connect Dashcam Locally (Wi-Fi)": "Podłącz kamerę samochodową lokalnie (Wi-Fi)",
	"Cloud Connection Setting": "Ustawienie połączenia z chmurą",
	"Camera Profile": "Profil kamery",
	"Camera Settings": "Ustawienia kamery",
	"Format MicroSD Card": "Sformatuj kartę microSD",
	"Remote Firmware Update": "Zdalna aktualizacja oprogramowania sprzętowego",
	"Remove from Cloud": "Usuń z chmury",
	"The location may not be accurate_": "Lokalizacja może nie być dokładna, ponieważ kamera nie jest połączona z chmurą.",
	"The location of the camera cannot be found_": "Nie można znaleźć lokalizacji kamery. Sprawdź ustawienia połączenia z chmurą.",
	"Manage\nFLEETA Drive": "Zarządzaj\nFLEETA Dysk",
	"Cloud\nConnection": "Połączenie\nchmurowe",
	"Available on FLEETA App": "Dostępne w aplikacji FLEETA",
	"Available for Cloud dashcam OR on FLEETA App.": "Dostępne dla kamery samochodowej w chmurze LUB w aplikacji FLEETA.",
	"Get started with_": "Rozpocznij z darmowym miesięcznym okresem próbnym",
	"Experience all of_": "Wypróbuj wszystkie premium funkcje FLEETA za darmo podczas miesięcznego okresu próbnego.\n\nBez zobowiązań—możliwość anulowania w każdej chwili",
	"Welcome to FLEETA Webviewer.": "Witamy w FLEETA Webviewer.",
	"Let FLEETA get_": "Pozwól FLEETA poznać cię",
	"Help improve your_": "Pomóż ulepszyć swoje doświadczenie, dzieląc się kilkoma szczegółami",
	"Business Industry": "Branża biznesowa",
	"Vehicle & Cargo": "Pojazdy i Ładunek",
	Compliance: Compliance$4,
	"Would you like to skip?": "Czy chcesz pominąć?",
	"What is your business industry?": "W jakiej branży działa Twoja firma?",
	"Transportation & Logistics": "Transport i Logistyka",
	"Rental & Leasing": "Wynajem i Leasing",
	"Construction & Building": "Budownictwo",
	"Government & Public": "Rząd i publiczny",
	"Facility & Utility Management": "Zarządzanie obiektami i usługami komunalnymi",
	Manufacturing: Manufacturing$4,
	"Retail & Wholesale": "Handel detaliczny i hurtowy",
	Emergency: Emergency$4,
	Security: Security$4,
	"How many employees do you need to manage?": "Ilu pracowników musisz zarządzać?",
	"How many vehicles does your company operate?": "Ile pojazdów obsługuje Twoja firma?",
	"Why do you use a fleet tracking service?": "Dlaczego korzystasz z usługi śledzenia floty?",
	"Route Tracking": "Śledzenie trasy",
	"Real-time Monitoring": "Monitorowanie w czasie rzeczywistym",
	"Incident Detection & Check video": "Wykrywanie incydentów i sprawdzanie wideo",
	"Behavior Monitoring & Analysis": "Monitorowanie i analiza zachowań",
	"Evaluation & Management": "Ocena i zarządzanie",
	"Theft Prevention": "Zapobieganie kradzieży",
	"Monitoring & Maintenance": "Monitorowanie i konserwacja",
	"Verification & Management": "Weryfikacja i zarządzanie",
	"BlackVue App Use Only": "Używaj tylko z aplikacją BlackVue",
	"Your current plan allow_": "Twój obecny plan pozwala na korzystanie z aplikacji BlackVue. Aby korzystać z przeglądarki internetowej, zapisz się na plan Fleet (FLEETA).",
	"Learn more about the Fleet_": "Dowiedz się więcej o Planie Floty (FLEETA)",
	"Special Offer": "Specjalna Oferta",
	"For a limited time_": "Przez ograniczony czas ciesz się 50% zniżką na subskrypcję Twojego Planu Floty.",
	"See Discount Details": "Zobacz szczegóły rabatu",
	"To subscribe to the Fleet_": "Aby zaprenumerować Plan Floty, proszę najpierw anulować subskrypcję BlackVue w aplikacji, aby uniknąć podwójnych opłat.",
	"Skip tour": "Pomiń wycieczkę",
	"In the cloud_": "W środowisku chmurowym można uzyskać dostęp do odtwarzania, oglądania na żywo (w tym widoku wielokrotnego), GPS na żywo oraz raportów, wszystko za pośrednictwem przeglądarki internetowej FLEETA.",
	"Cloud Storage is_": "Chmura to miejsce, gdzie twoje przesłane filmy są bezpiecznie przechowywane w chmurze. Prześlij swoje filmy, aby były bezpieczne przez długi czas.",
	"Toggle to switch_": "Przełącz, aby zmienić Mapa / Lista",
	"In List View_": "W widoku listy możesz łatwo przeglądać i zarządzać grupami, członkami oraz informacjami o oprogramowaniu układowym na pierwszy rzut oka.",
	"What is Cloud Storage?": "Co to jest Chmura?",
	"Cloud Storage Overview": "Przegląd Chmury",
	"Difference Between FLEETA_": "Różnica między FLEETA Dysk a Przesyłanie wydarzeń na żywo",
	"FLEETA Drive stores_": "FLEETA Dysk przechowuje filmy, które przesłałeś ręcznie",
	"Live Event Upload automatically_": "Przesyłanie wydarzeń na żywo automatycznie zapisuje wideo, gdy wystąpi zdarzenie.",
	"Live Event Upload videos_": "Filmy z Przesyłanie wydarzeń na żywo mają okres ważności. Jeśli chcesz je zachować na dłużej, przenieś je na FLEETA Dysk.",
	"Note: SD Card_": "Uwaga: Filmy na karcie SD w Odtwarzanie",
	"Videos stored on_": "Filmy zapisane na karcie SD można odtwarzać za pomocą menu Odtwarzanie.",
	"Set your image_": "Ustaw swój obraz za pomocą dostarczonej ramki. Po zapisaniu obraz będzie wyświetlany na karcie kamery i ikonie widoku mapy.",
	"*Only jpg and_": "*Obsługiwane są tylko pliki jpg i png.",
	"Set as default image": "Ustaw jako obraz domyślny",
	"Camera Details": "Szczegóły kamery",
	"IT & Telecommunications": "IT i telekomunikacja",
	"The name must_32": "Nazwa musi zawierać od 1 do 32 znaków.",
	"Unable to display the map.": "Nie można wyświetlić mapy.",
	"The camera location cannot be found_": "Nie można znaleźć lokalizacji kamery z powodu słabego połączenia GPS.",
	"Cloud Cameras": "Kamery w chmurze",
	"Want to unlock_": "Chcesz odblokować funkcje zarządzania flotą?",
	"*Web subscription only": "*Tylko subskrypcja webowa",
	"Uploads event_": "Natychmiast przesyła nagrania z wydarzeń do Chmura, gdy tylko zdarzenie się wydarzy.",
	"Starts a conversation_": "Rozpoczyna rozmowę z kierowcą za pomocą głośnika i mikrofonu kamery samochodowej.",
	"Remotely check_": "Zdalnie sprawdź poziom i stan baterii przez chmurę.",
	"Receive a voice_": "Otrzymaj alert głosowy i powiadomienia, jeśli czas jazdy przekroczy limit.",
	"View your_": "Zobacz swój dziennik jazdy na mapie.",
	"View speed, event_": "Zobacz prędkość, typ zdarzenia i odtwarzaj powiązane filmy bezpośrednio na mapie.",
	"FLEETA Tracking exclusive_": "FLEETA Tracking oferuje ekskluzywne funkcje zarówno dla zaawansowanych użytkowników, jak i firm (Wielu użytkowników i kamer, geofencing itp.).",
	"Cloud Cameras per Account": "Kamery w chmurze na konto",
	"Connect Dashcam Locally_": "Podłącz lokalnie kamerę samochodową (Wi-Fi) (Odtwarzanie, Pobieranie, Oglądaj na żywo)",
	"Available with_": "Dostępne z baterią BlackVue",
	"Cloud Battery": "Bateria w chmurze",
	"Driving Reports": "Raporty z jazdy",
	"Video on Map": "Wideo na mapie",
	"Multi Live View (Fleeta Web Viewer)": "Wielokrotne Oglądanie na Żywo (Przeglądarka Web FLEETA)",
	"Enter a number": "Wprowadź numer",
	"Permission required.": "Wymagane pozwolenie.",
	"Please contact_": "Proszę skontaktować się z właścicielem w celu uzyskania pomocy.",
	"Access not available": "Dostęp niedostępny.",
	"This file cannot be deleted now.": "Ten plik nie może być teraz usunięty.",
	"Please try again later.": "Proszę spróbować później.",
	"Permission required.\nPlease_": "Wymagane pozwolenie.\nProszę skontaktować się z właścicielem w celu uzyskania pomocy.",
	"Cloud Storage is disconnected_": "Chmura jest rozłączona. Proszę sprawdzić połączenie.",
	"Manage the plan_": "Zarządzaj planem przywrócenia kamery",
	"Notify the owner_": "Powiadom właściciela o zarządzaniu planem",
	"Access Restricted:_": "Dostęp Ograniczony: Subskrypcja Wygasła",
	"Access is currently_": "Dostęp jest obecnie niedostępny z powodu wygasłej subskrypcji.",
	"Please contact your owner_": "Proszę skontaktować się z właścicielem, aby rozwiązać ten problem.",
	"Access will be_": "Dostęp zostanie przywrócony po odnowieniu subskrypcji",
	"Cloud is disconnected_": "Chmura jest rozłączona. \nProszę sprawdzić połączenie.",
	"Connect to Cloud with_": "Połącz się z Chmura za pomocą FLEETA APP",
	"Using Wi-Fi Hotspot": "Korzystanie z hotspotu Wi-Fi",
	Important: Important$4,
	"Pre-Event buffer_": "Nagrywanie bufora przed zdarzeniem jest wyłączone w tym trybie.",
	"connectivity is_": "W tym trybie łączność jest ograniczona.",
	"video upload starts_": "Przesyłanie wideo rozpoczyna się po zakończeniu nagrywania.",
	"Power Saving": "Oszczędzanie energii",
	"In all modes_": "We wszystkich trybach wykryte uderzenia uruchamiają nagrania wideo z wydarzeń.",
	"Battery Protection setting _": "Ustawienie Ochrony Baterii musi być WŁĄCZONE.",
	"At least one of_": "Co najmniej jedno z poniższych ustawień musi być włączone",
	or: or$4,
	"For BlackVue battery users": "Dla użytkowników baterii BlackVue",
	"we recommend setting_": "Zalecamy ustawienie minimalnej wartości odcięcia napięcia dla maksymalnego wykorzystania baterii.",
	"No videos were found.": "Nie znaleziono żadnych filmów.",
	"Try different filter_": "Wypróbuj inny filtr lub zresetuj filtr.",
	"Not avaliable with_": "Niedostępne z obecną kamerą",
	"Overlays a detection_": "Nakłada ramkę detekcji na żywe i nagrane obrazy z kamery DMS.",
	"A minute of_": "Minuta wideo z przedniej kamery będzie mniej więcej",
	"System voice guidance": "Przewodnik głosowy systemu",
	"Recording trigger": "Wyzwalacz nagrywania",
	"Remote Button (Optional)": "Przycisk zdalny (Opcjonalnie)",
	"Remote button settings_": "Ustawienia przycisków zdalnych nie mogą być zmieniane przez połączenie chmurowe. Aby zmodyfikować te ustawienia, przejdź do Kamery > Połącz lokalnie > Ustawienia kamery.",
	"No Registered Device": "Brak zarejestrowanego urządzenia",
	"Subscription process is complete": "Proces subskrypcji został zakończony",
	"Now, go back to_": "Teraz wróć do aplikacji FLEETA, zaloguj się na swoje konto i zacznij korzystać z usługi.",
	"You can check the upload progress": "Możesz sprawdzić postęp przesyłania w zakładce Chmura > FLEETA Dysk.",
	"SIM card must be inserted in_": "Aby móc korzystać z usługi Cloud, należy włożyć kartę SIM do aparatu.",
	"Active until:": "Aktywny do:",
	Subscribe: Subscribe$4,
	"Camera PSN": "Kamera PSN",
	"BlackVue Sim Free Trial Started!": "Rozpoczął się bezpłatny okres próbny BlackVue Sim!",
	"Enjoy a free period to use your SIM_": "Ciesz się darmowym okresem korzystania z karty SIM bez abonamentu!",
	"You can stay connected during the trial_": "Podczas okresu próbnego możesz pozostać w kontakcie, ale pamiętaj:",
	"Complete your subscription before the trial_": "Zakończ subskrypcję przed zakończeniem okresu próbnego, aby móc dalej korzystać z karty SIM.",
	"If you don't subscribe by the end of the trial_": "Jeśli nie wykupisz subskrypcji do końca okresu próbnego, Twoja usługa SIM zostanie wyłączona.",
	"Save Event Videos_": "Zapisuj filmy z wydarzeń w chmurze w czasie rzeczywistym!",
	"Note: Deleting your account doesn’t cancel": "Uwaga: Usunięcie konta nie anuluje subskrypcji. Aby anulować, przejdź do Konta > Plan na przeglądarce internetowej FLEETA.",
	"Available only on FLEETA App for_": "Dostępne tylko w aplikacji FLEETA dla tego modelu.",
	"The cloud is deactivated": "Chmura jest dezaktywowana.",
	"Please add a camera with FLEETA_": "Proszę dodać kamerę do aplikacji FLEETA, aby korzystać z tej funkcji.",
	"Upload videos to FLEETA_": "Prześlij filmy na FLEETA Dysk i zachowaj ich bezpieczeństwo!",
	"You have no assigned camera_": "Nie masz przypisanej kamery.\nProszę skontaktować się z właścicielem, aby poprosić o przypisanie.",
	"Camera notification settings": "Ustawienia powiadomień kamery",
	Vehicle: Vehicle$4,
	"App Download": "Pobierz aplikację",
	"Have a problem with_": "Masz problem z subskrypcją?",
	"Restore Purchase": "Przywróć zakup",
	"Battery Pairing": "Parowanie baterii",
	"Playback\nLive View": "Odtwarzanie/\nPodgląd na żywo",
	"Remote Playback": "Zdalne odtwarzanie",
	"Cloud connection settings": "Ustawienia połączenia z chmurą",
	"Go to settings": "Przejdź do ustawień",
	"Only cloud cameras that_": "Na mapie wyświetlane są tylko kamery w chmurze, które użytkownicy zdecydują się udostępnić publicznie.",
	"Live Broadcast Cameras": "Kamery do transmisji na żywo",
	"*Live Broadcast Cameras_": "*Kamery transmisji na żywo to kamery w chmurze ustawione do nadawania przez użytkowników.",
	"Only cloud cameras_": "Na mapie wyświetlane są tylko kamery chmurowe, które użytkownicy zdecydują się transmitować."
};

var Dashboard$3 = "Панель управления";
var Account$3 = "Аккаунт";
var Help$3 = "Помощь";
var Mac$3 = "Mac";
var Windows$3 = "Windows";
var Admin$3 = "Администратор";
var Driver$3 = "Водитель";
var Cameras$3 = "Камеры";
var Manage$3 = "Управление";
var Clear$3 = "ясно";
var Show$3 = "Показать";
var GB$3 = "{{a}}GB";
var _section$3 = ".";
var Name$3 = "ФИО";
var Password$3 = "Пароль";
var Cancel$3 = "Отмена";
var Members$3 = "Члены";
var Groups$3 = "Группы";
var Role$3 = "Роль";
var Group$3 = "Группа";
var Status$3 = "Статус";
var nPM$3 = "{{a}} после полудня";
var nAM$3 = "{{a}} до полудня";
var Newest$3 = "Самые новые";
var Oldest$3 = "Самые старые";
var Accepted$3 = "Принято";
var Pending$3 = "Ожидание";
var Expired$3 = "Просрочено";
var All$3 = "Все";
var Delete_$3 = "Удалить {{a}}";
var Delete$3 = "Удалить";
var Rename$3 = "Сменить имя";
var Add$3 = "Добавить";
var OK$3 = "OK";
var Remove$3 = "Удалить";
var Files$3 = "Файлы";
var Features$3 = "Функции";
var Settings$3 = "Настройки";
var Upload$3 = "Загрузить";
var Privacy$3 = "Конфиденциальность";
var Done$3 = "Готово";
var Subscription$3 = "Подписка";
var Submasters$3 = "администраторы";
var Users$3 = "водители";
var Change$3 = "Изменить";
var Method$3 = "Способ";
var Details$3 = "Информация о камере.";
var Confirm$3 = "Подтвердить";
var Address$3 = "Адрес";
var Country$3 = "Страна";
var State$3 = "Штат";
var ZIP$3 = "Индекс";
var Pricing$3 = "Определение цены";
var Free$3 = "Free";
var Smart$3 = "Smart";
var Fleet$3 = "Fleet";
var Subscrubed$3 = "Подписка оформлена";
var January$3 = "январь";
var February$3 = "Feburary";
var March$3 = "марш";
var April$3 = "апрель";
var May$3 = "май";
var June$3 = "июнь";
var July$3 = "июль";
var August$3 = "августейший";
var September$3 = "сентябрь";
var October$3 = "октября";
var November$3 = "ноябрь";
var December$3 = "Декабрь";
var Blackvuecloud_$3 = "www.blackvuecloud.com";
var Support$3 = "Support";
var Community$3 = "Community";
var FAQ$3 = "FAQ";
var Developers$3 = "Developers";
var Facebook$3 = "Facebook";
var Twitter$3 = "Twitter";
var Instagram$3 = "Instagram";
var Youtube$3 = "Youtube";
var Linkedin$3 = "Linkedin";
var Downloads$3 = "Загрузки";
var Unauthorized$3 = "Нет авторизации";
var none$3 = "Нет";
var Email$3 = "Адрес электронной почты";
var Customers$3 = "Customers";
var Home$3 = "Home";
var Plan$3 = "Plan";
var New$3 = "New";
var Unsubscribed$3 = "Unsubscribed";
var Edit$3 = "Edit";
var month$3 = "month";
var months$3 = "months";
var Continue$3 = "Continue";
var Back$3 = "Назад";
var Master$3 = "Owner";
var Develop$3 = "Developers";
var $9$3 = "$9";
var $15$3 = "$15";
var $10$3 = "$10";
var mo$3 = "Месяц";
var City$3 = "Город";
var Charge$3 = "Плата";
var subscribe$3 = "Подписаться";
var search$3 = "Поиск";
var invalid_number$3 = "Введенный номер кредитной карты недействителен";
var invalid_expiry_month$3 = "Недопустимый месяц срока действия карты";
var invalid_expiry_year$3 = "Недопустимый год срока действия карты";
var invalid_cvc$3 = "Недопустимый защитный код карты";
var incorrect_number$3 = "Неверный номер карты";
var incomplete_number$3 = "Номер карты является неполным";
var incomplete_cvc$3 = "Защитный код карты является неполным";
var incomplete_expiry$3 = "Дата срока действия карты является неполной";
var expired_card$3 = "Срок действия карты истек";
var incorrect_cvc$3 = "Неверный защитный код карты";
var incorrect_zip$3 = "Zip-код карты не прошел проверку";
var invalid_expiry_year_past$3 = "Год срока действия карты находится в прошлом";
var card_declined$3 = "Карта отклонена";
var missing$3 = "Пользователь не зарегистрировал ни одну банковскую карту, с помощью которой может производиться оплата";
var processing_error$3 = "При обработке этой карты возникла ошибка";
var Paypal$3 = "Paypal";
var iOS$3 = "iOS";
var Android$3 = "Android";
var Total$3 = "Всего";
var And$3 = "и";
var Camera$3 = "Camera";
var Yes$3 = "Да";
var No$3 = "Нет";
var News$3 = "Новости";
var Notifications$3 = "Уведомления";
var MPH$3 = "MPH";
var Firmware$3 = "Прошивка";
var Basic$3 = "Базовые";
var Resolution$3 = "Разрешение";
var Brightness$3 = "Яркость";
var Recording$3 = "Идет запись";
var Highest$3 = "Наивысшее";
var High$3 = "Высокое";
var Normal$3 = "Обычный";
var Sensitivity$3 = "Чувствительность";
var Volume$3 = "Громкость";
var Close$3 = "Close";
var Cloud$3 = "Cloud";
var Public$3 = "Public";
var Front$3 = "Передняя камера";
var Rear$3 = "Задняя камера";
var Play$3 = "Воспроизведение";
var Stop$3 = "Остановить";
var Pause$3 = "Пауза";
var Time$3 = "Time";
var System$3 = "Система";
var Event$3 = "Событие";
var Parking$3 = "Парковка";
var Color$3 = "Цвет";
var Exit$3 = "Выход";
var Save$3 = "Сохранить";
var Impact$3 = "Удар";
var Unlimited$3 = "Без ограничений";
var Default$3 = "По умолчанию";
var Version$3 = "Версия";
var Language$3 = "Язык";
var Notification$3 = "Уведомление";
var Multiple$3 = "Мульти";
var Range$3 = "Диапазон";
var Download$3 = "Скачать";
var Manual$3 = "Руководство";
var Satellite$3 = "спутниковое";
var Tutorials$3 = "Учебные материалы";
var Filter$3 = "Фильтр";
var Sun$3 = "Вс";
var Mon$3 = "Пн";
var Tue$3 = "Вт";
var Wed$3 = "Ср";
var Thu$3 = "Чт";
var Fri$3 = "Пт";
var Sat$3 = "Сб";
var Dates$3 = "Даты";
var Routes$3 = "Маршруты";
var Opacity$3 = "прозрачность";
var Entry$3 = "Запись";
var Owner$3 = "Owner";
var Undetected$3 = "необнаруженный";
var Distracted$3 = "Отвлечённый";
var Drowsy$3 = "Drowsy";
var Calling$3 = "Calling";
var Smoking$3 = "Smoking";
var Permissions$3 = "Разрешения";
var Private$3 = "Личное";
var Entering$3 = "Въезд";
var Exiting$3 = "Выезд";
var Acceleration$3 = "Ускорение";
var Passing$3 = "Проезд";
var Overspeed$3 = "Превышение скорости";
var Recipients$3 = "Получатели";
var Send$3 = "Отправить";
var Note$3 = "Примечание";
var Video$3 = "Видео";
var Advanced$3 = "Дополнения";
var Voice$3 = "Голос";
var Days_$3 = "Дни";
var Mute$3 = "Отключить звук";
var UnMute$3 = "Включить звук";
var Discard$3 = "Отменить";
var Report$3 = "Report";
var Individual$3 = "Вы частный водитель и хотите работать без проблем? Вы владелец бизнеса в поисках простого решения для безопасности и отслеживания транспортных средств?";
var Subscribed$3 = "Подписка оформлена";
var Geofence$3 = "Геозона";
var Driving$3 = "Вождение";
var Idling$3 = "Холостой ход";
var Distance$3 = "Дистанция";
var Parked$3 = "Parked";
var Speed$3 = "Скорость";
var Highest_2$3 = "Максимально высокое";
var Average$3 = "Среднее";
var Geofences$3 = "Геозоны";
var Move$3 = "Переместить";
var Connected$3 = "Подключена";
var Individual_$3 = "Индивидуально";
var Always$3 = "Всегда";
var Low$3 = "Низкое";
var Medium$3 = "Среднее";
var High_2$3 = "Высокое";
var Flip$3 = "Перевернуть";
var Previous$3 = "Предыдущий кадр";
var Next$3 = "Далее";
var Expand$3 = "Развернуть";
var Collapse$3 = "Свернуть";
var More$3 = "Дополнительно";
var Multi$3 = "Мульти";
var Safe$3 = "Безопасный";
var Reckless$3 = "Неосторожный";
var Inattentive$3 = "Невнимательный";
var List$3 = "Список";
var Usage$3 = "Использование";
var Profile$3 = "Профиль";
var Fullscreen$3 = "Полный экран";
var Upgrade$3 = "Обновление";
var Management$3 = "Управление";
var Day$3 = "День";
var Month$3 = "Месяц";
var Later$3 = "Не сейчас";
var ICCID$3 = "ICCID";
var Resubscribe$3 = "Продлить подписку";
var plan$3 = "план";
var USD$3 = "долл. США";
var etc_$3 = "Прочее:";
var Available$3 = "Доступно";
var Used$3 = "Использовано";
var Cancelled$3 = "Отменено";
var Terminated$3 = "Завершено";
var Sort$3 = "Сортировка";
var Bonus$3 = "Бонус";
var incomplete_zip$3 = "Zip-код карты не прошел проверку";
var Upgrades$3 = "Обновления";
var OR$3 = "ИЛИ";
var Undo$3 = "Отменить";
var Invoice$3 = "Выставленный счет";
var data$3 = "Данные";
var Popular$3 = "Popular";
var Mask$3 = "Отсутствие маски";
var DMS$3 = "Мониторинг состояния водителя (DMS)";
var Extreme$3 = "Экстрим";
var OFF$3 = "Выкл";
var Threshold$3 = "Порог";
var Drowsiness$3 = "Сонливость";
var Direct$3 = "Прямая связь";
var Remote$3 = "Удаленно";
var Update$3 = "Обновить";
var Option$3 = "Дополнительно";
var Required$3 = "Обязательно";
var Optional$3 = "Необязательно";
var Others$3 = "Прочее";
var Stay$3 = "Оставить текущий план";
var Mask_2$3 = "Mask";
var Low_2$3 = "Low";
var Medium_2$3 = "Medium";
var High_3$3 = "High";
var Highest_3$3 = "Highest";
var Extreme_2$3 = "Extreme";
var Private_2$3 = "Private";
var Lite$3 = "Lite";
var Bitrate$3 = "Битрейт";
var hours$3 = "Часы";
var Expires$3 = "Истекает";
var Check$3 = "Проверка";
var Saving$3 = "Сохранение";
var Now$3 = "Сейчас";
var Beep$3 = "Звук предупреждения";
var Unpair$3 = "Разорвать связь";
var Detected$3 = "Обнаружен";
var Promotion$3 = "Акция";
var Notice$3 = "Обновления";
var Explore$3 = "Исследовать";
var Deactivate$3 = "Деактивировать";
var Compliance$3 = "Соблюдение";
var Manufacturing$3 = "Производство";
var Emergency$3 = "Аварийная служба";
var Security$3 = "Безопасность";
var Important$3 = "Важно";
var or$3 = "или";
var Subscribe$3 = "Подписаться";
var Vehicle$3 = "транспортное средство";
var ru = {
	Dashboard: Dashboard$3,
	"Payment & Subscriptions": "Оплата и подписки",
	"Fleet Management": "Управление автопарком",
	"Available to master": "Доступно для мастера",
	"Available to Fleet_": "Доступно для пользователей с тарифом Fleet",
	Account: Account$3,
	"Log out": "Выход",
	"© 2019 Pittasoft_": "© 2019 Pittasoft Co. Ltd",
	"Privacy policy": "Политика конфиденциальности",
	"Terms of service": "Условия обслуживания",
	Help: Help$3,
	"App store": "App store",
	"Google Play": "Google Play",
	Mac: Mac$3,
	Windows: Windows$3,
	"Free Plan": "Free Plan",
	"Basic Plan": "Basic Plan",
	"Smart Plan": "Smart Plan",
	Admin: Admin$3,
	Driver: Driver$3,
	"Period : December 3, 2024 ~ May 31, 2025": "Период: 3 декабря 2024 г. ~ 31 мая 2025 г.",
	Cameras: Cameras$3,
	"n of n": "{{a}} из {{b}}",
	Manage: Manage$3,
	"Upgrade Plan": "Перейти на новый план",
	"Add more cameras_": "Добавьте больше камер, управляйте автопарком и получите доступ к многими другим функциям...",
	"Usage statistics": "Статистика использования",
	"All cameras": "Все камеры",
	Clear: Clear$3,
	Show: Show$3,
	"Live views": "Удаленный просмотр в реальном времени",
	"nh:nm:ns": "{{a}}h:{{b}}m:{{c}}s",
	"Video plays and_": "Воспроизведение видео и загрузки",
	"Space available": "Доступное пространство",
	GB: GB$3,
	"n%": "{{a}}%",
	"BlackVue app for_": "Приложение BlackVue для iOS и Android",
	"BlackVue viewer for_": "BlackVue Viewer для Mac и Windows",
	"Welcome to fleet": "Добро пожаловать в автопарк",
	"A few things_": "Несколько операций, которые вы можете выполнять по пути:",
	"You can watch_": "Вы можете просматривать видео с камер, которые были зарегистрированы в приложении BlackVue или Viewer для ПК.",
	"If the master_deletes": "Если мастер удаляет свой аккаунт, ваш аккаунт будет также удален.",
	"If the masters_Fleet": "Если подписка мастера на тарифный план Fleet истечет, вы все же сможете получить доступ к вашей учетной записи, но только в режиме чтения.",
	"You have to_": "Чтобы добавить личную камеру, вы должны зарегистрировать другую учетную запись.",
	"The Payments &_": "Разделы «Платежи и подписка» и «Управление автопарком» доступны только для мастера.",
	"You can manage_": "Вы можете управлять группой автопарка в разделе",
	"_Fleet management": "Управление автопарком",
	_section: _section$3,
	"The Payments_section-": "Раздел «Платежи и подписка» доступен только для мастера.",
	"Youre almost there": "Осталось совсем немного",
	"Finish account setup": "Завершить настройку учетной записи",
	"Install and log_": "Установите приложение BlackVue или Viewer для ПК и войдите в него",
	"Download on the_": "Скачать в App Store",
	"GET IT ON_": "Скачать в Google Play",
	"Download for Mac": "Скачать для Mac",
	"Download for Windows": "Скачать для Windows",
	"Add your camera_": "Добавьте камеру в приложении BlackVue или Viewer для ПК",
	"Start managing your_": "Начните управлять своим автопарком, используя приведенную здесь статистику",
	"Cancelled Fleet Plan_": "Тарифный план Fleet отменен {{date}}",
	"The new plan_": "Новый план начнет действовать по завершению текущего платежного цикла.",
	"Profile photo": "Фотография профиля",
	Name: Name$3,
	"E-mail address": "Адрес электронной почты",
	Password: Password$3,
	"Last changed_": "Последнее изменение: {{a}}",
	"Change password": "Изменить пароль",
	"Delete account": "Удалить учетную запись",
	Cancel: Cancel$3,
	"Current password": "Текущий пароль",
	"New password": "Новый пароль",
	"Confirm new password": "Подтвердить новый пароль",
	"Password changed": "Пароль изменен",
	"Reason for deletion_": "Причина удаления (необязательно)",
	"Account password": "Пароль учетной записи",
	Members: Members$3,
	Groups: Groups$3,
	"+ Invite member": "+ Пригласить члена",
	"Name, Email": "ФИО, адрес электронной почты",
	Role: Role$3,
	Group: Group$3,
	"Date invited": "Дата приглашения",
	Status: Status$3,
	"Group n": "Группа {{a}}",
	nPM: nPM$3,
	nAM: nAM$3,
	Newest: Newest$3,
	Oldest: Oldest$3,
	"Name, email or_": "ФИО, адрес электронной почты или группа",
	Accepted: Accepted$3,
	Pending: Pending$3,
	Expired: Expired$3,
	All: All$3,
	"No results": "Нет результатов",
	"Try different keywords": "Пробуйте другие ключевые слова",
	"Try changing or_": "Попробуйте изменить или удалить фильтры",
	"Remove all filters": "Удалить все фильтры",
	"Invite member": "Пригласить члена",
	"Send invite": "Отправить приглашение",
	"You have reached_": "Вы достигли предела в 10 субмастеров. Вы можете продолжить приглашать пользователей.",
	Delete_: Delete_$3,
	"Are you sure_delete": "Действительно удалить этого члена и его учетную запись?",
	Delete: Delete$3,
	Rename: Rename$3,
	"No submaster yet": "Еще нет субмастеров",
	"You can add_": "Вы можете добавить 1 субмастера для каждой группы",
	"No cameras yet": "Еще нет камер",
	"Add cameras first_": "Сначала добавьте камеры, а затем назначьте пользователей",
	"Name or email": "ФИО или адрес электронной почты",
	"Add submaster": "Добавить субмастера",
	Add: Add$3,
	"Add camera": "Добавить камеру",
	"n of n selected": "Выбрано {{a}} из {{b}}",
	"No cameras available": "Нет доступных камер",
	"Most likely reasons_": "Наиболее вероятные причины для этого:",
	"All cameras were_": "все камеры были добавлены к другим группам.",
	"You can remove_": "Вы можете удалить камеры из других групп и добавить их в эту группу.",
	"No cameras were_": "Камеры не добавлены в вашу учетную запись.",
	"You can add_cameras": "Вы можете добавить камеры в приложении BlackVue или Viewer для ПК.",
	OK: OK$3,
	"Rename group": "Переименовать группу",
	"Are you sure_group": "Действительно удалить эту группу?",
	"Edit Mobile app_": "Изменить разрешения для приложения просмотра на мобильных устройствах или ПК",
	Remove: Remove$3,
	"n of n users": "Выбрано пользователей: {{a}} из {{b}}",
	"Youve reached the_": "Вы достигли предела числа пользователей для каждой камеры",
	"Remove user": "Удалить пользователя",
	"Add user": "Добавить пользователя",
	"+ Add group": "+ Добавить группу",
	"Add group": "Добавить группу",
	"Group or submaster": "Группа или субмастер",
	"+ Add": "+ Добавить",
	"of max selected": "Выбрано {{a}} из {{b}} (макс.)",
	"Mobile app/desktop_": "Разрешения для приложения просмотра на мобильных устройствах или ПК",
	Files: Files$3,
	Features: Features$3,
	Settings: Settings$3,
	Upload: Upload$3,
	"Download and Playback_Cloud": "Загрузка и воспроизведение из облачного хранилища",
	"Download and Playback_SD": "Загрузка и воспроизведение с SD-карты",
	"Live view": "Live View",
	"Geo Fencing": "Геозоны",
	"Drive Reports": "Отчеты о вождении",
	"Firmware Settings": "Настройки прошивки",
	"Push Notifications": "Push-уведомление",
	"Event Auto Upload": "Автовыгрузка событий в реафльном времени",
	Privacy: Privacy$3,
	Done: Done$3,
	"Payment method": "Способ оплаты",
	"Change payment method": "Изменить способ оплаты",
	Subscription: Subscription$3,
	"Space used": "Использованный объём памяти",
	"Next billing_": "Следующий счет {{a}} {{b}}",
	"You manage_available": "Вы управляете {{a}} из {{b}}, доступных в вашем тарифном плане",
	Submasters: Submasters$3,
	Users: Users$3,
	Change: Change$3,
	"No transactions yet_": "Вы подписаны на бесплатный план. Еще нет транзакций",
	"No transactions to_": "Нет транзакций для отображения.<br/>Если вы ищете историю транзакций для других платформ (таких как iOS, Android и PayPal), вы можете найти ее на странице подписки вашей собственной платформы.",
	"of nGB_": "{{a}} из {{b}} ГБ ({{c}}%)",
	"Smart Plan users_": "Пользователи плана Smart могут изменить тарифный план или количество камер через мобильное приложение BlackVue.",
	"Transaction history": "История транзакций",
	"Date": "Дата",
	"Amount, USD": "Сумма, долл. США",
	Method: Method$3,
	Details: Details$3,
	"iOS in-app_": "Покупка в приложении для iOS/Покупка в приложении для Android",
	"Change the number_": "Изменить количество камер",
	"You manage_cameras": "Вы управляете {{a}} камерами из {{b}} доступных в вашем тарифе",
	"Extra cameras": "Дополнительные камеры",
	"Total due_": "Всего к оплате",
	"available on your_": "Из {{a}} доступных в вашем тарифе",
	"Cancel Fleet Plan": "Отмена Fleet Plan",
	"This will cancel_": "Это отменит вашу подписку на план Fleet. По окончании платежного цикла вы перейдете на тариф Free.",
	"Reason for cancellation_": "Причина отмены (по желанию)",
	"Not now": "Не сейчас",
	Confirm: Confirm$3,
	"Cardholder name": "Имя владельца банковской карты",
	"Card name": "Название банковской карты",
	"MM/YY": "MM/YY",
	Address: Address$3,
	Country: Country$3,
	State: State$3,
	ZIP: ZIP$3,
	Pricing: Pricing$3,
	"You are subscribed_": "Вы оформили подписку на тариф Free.",
	"With Alert Push_": "Включает уведомления о предупреждениях, ограниченное количество удаленных просмотров в реальном времени и облачное хранилище.",
	Free: Free$3,
	Smart: Smart$3,
	Fleet: Fleet$3,
	"Get started for_": "Начните работу бесплатно, кредитная карта не требуется. \n Включает уведомления о предупреждениях, ограниченное количество удаленных просмотров в реальном времени и облачное хранилище.",
	Subscrubed: Subscrubed$3,
	"Features included:": "Доступные функции:",
	"Get unlimited Remote_": "Получите неограниченное количество удаленных просмотров в реальном времени, воспроизведение в Cloud и возможность управления {{a}} камерами.",
	"BlackVue Fleet Tracking_": "Эксклюзивные функции BlackVue Fleet Tracking для опытных пользователей и предприятий (несколько пользователей и камер, геозонирование и т. д.)",
	"Try 1 Month Free": "Получите 1 месяц бесплатного пользования",
	"Log in": "Вход",
	"Remember me": "Запомнить меня",
	"Forgot password?": "Забыли пароль?",
	"Reset password": "Восстановление пароля",
	"Enter email address_": "Введите адрес электронной почты, использованный при регистрации, \n на который мы отправим ссылку для сброса пароля.",
	"Send reset password_": "Отправить письмо для сброса пароля",
	"Back to login": "Назад на страницу входа",
	"Check your email": "Проверьте свою электронную почту",
	"Weve sent an_": "На адрес {{a}} отправлено электронное письмо со ссылкой для подтверждения электронного адреса.",
	"Resend email": "Отправить письмо еще раз",
	January: January$3,
	February: February$3,
	March: March$3,
	April: April$3,
	May: May$3,
	June: June$3,
	July: July$3,
	August: August$3,
	September: September$3,
	October: October$3,
	November: November$3,
	December: December$3,
	"Sign up": "Регистрация",
	"First name": "Имя",
	"Last name": "Фамилия",
	"Create a password": "Создать пароль",
	"5 or more_": "Не менее 5 символов",
	"Sign up and_": "Зарегистрироваться и продолжить",
	"I agree to_": "Я принимаю %@, %@, %@ и %@.",
	"Subscribe to newsletter": "Подписаться на рассылку",
	"1 month free trial_": "Бесплатная демоверсия на 1 месяц",
	"Dont have an_": "Нет учетной записи?",
	"Thank you for_": "Благодарим за регистрацию в BlackVue Cloud. Подтвердите ваш адрес электронной почты.",
	"Confirm email": "Подтвердить адрес электронной почты",
	"If you didnt_": "Если вы не регистрировали эту учетную запись, вы можете игнорировать это сообщение.",
	Blackvuecloud_: Blackvuecloud_$3,
	"invited you to_": "{{a}} приглашает вас присоединиться к его автопарку в качестве субмастера.",
	"Accept invitation": "Принять приглашение",
	"Invite expires on_": "Приглашение истекает мм дд, гг.",
	"Your Fleet Management_": "Ваша учетная запись управления автопарком, зарегистрированная с {{а}}, была удалена %@.",
	"If you believe_": "Если вы считаете, что это ошибка, свяжитесь с нашей службой поддержки по адресу: cs@blackvue.com.",
	Support: Support$3,
	"Help center": "Справочный центр",
	Community: Community$3,
	"Getting started": "Начать работу",
	FAQ: FAQ$3,
	Developers: Developers$3,
	"Cloud API": "Cloud API",
	"Fleet SDK": "Fleet SDK",
	"Follow us": "Подписывайтесь на нас",
	Facebook: Facebook$3,
	Twitter: Twitter$3,
	Instagram: Instagram$3,
	Youtube: Youtube$3,
	Linkedin: Linkedin$3,
	"BlackVue apps": "BlackVue apps",
	"Camera registraiton": "Регистрация камеры",
	"Two-way voice_": "Двусторонняя голосовая связь",
	"Live GPS": "GPS в реальном времени",
	"Event live auto_": "Автовыгрузка событий в реафльном времени",
	"Event file auto_": "Автовыгрузка файла события",
	"Compatible with_": "Совместимость с моделями DR650GW и DR650S",
	"Not compatible with_": "Несовместимость с моделями DR650GW и DR650S",
	"More cameras": "Больше камер",
	"More users": "More users",
	"Roles and permissions": "Roles and permissions",
	"More Cloud Storage": "Больше ресурсов облачного хранилища",
	"Multi Live view_": "Multi Live View (Web)",
	"Longer GPS Tracking": "Longer GPS Tracking",
	"Geo Fence setup_": "Geo Fence setup (PC viewer) and alerts (PC viewer and app)",
	"Changes saved": "Изменения сохранены",
	"Group added": "Группа добавлена",
	"Member added": "Член добавлен",
	"Group deleted": "Группа удалена",
	"Member deleted": "Член удален",
	"Group renamed": "Группа переименована",
	"Submaster added": "Субмастер добавлен",
	"Camera added": "Камера добавлена",
	"User added": "Пользователь добавлен",
	"Users added": "Пользователи добавлены",
	Downloads: Downloads$3,
	"The BlackVue App_": "The BlackVue App and Viewer let you use your BlackVue camera to its full potential. Whether on mobile or on home computer, BlackVue gives you the tools to fully enjoy your dashcam's functions.",
	"Compatible with all_": "Compatible with all Wi-Fi enabled BlackVue models.",
	"Supports all BlackVue_": "Supports all BlackVue models to date.",
	"confirm new password": "Подтвердить новый пароль",
	"Your password is_": "Вы ввели неверный пароль",
	"Confirm password does_": "Пароли не совпадают",
	"Please enter_email": "Укажите действующий адрес эл. почты.",
	"Please enter_password": "Вы ввели неверный пароль",
	"Internal server error_": "Внутренняя ошибка сервера. Повторите попытку.",
	"New password is_": "Отличие от текущего пароля должно быть по крайней мере в 1 символе",
	"It should be_": "Пароль должен содержать не менее 5 символов",
	"Invalid permission": "Разрешение недействительно.",
	"Input data isnt_": "Входные данные недоступны.",
	Unauthorized: Unauthorized$3,
	"Already have subsciption": "Уже есть подписка",
	"Already uses": "Уже используется",
	"Already logged in": "Вы уже вошли в систему",
	"Already sent e-mail": "Электронное письмо уже отправлено.",
	"Please wait": "Подождите.",
	"E-mail is not_": "Адрес электронной почты еще не подтвержден.",
	"Update your subscription_": "Обновите вашу подписку",
	"Account was deleted": "Учетная запись удалена.",
	"5 ~ 30_": "5 ~ 30 characters",
	"It has exceeded_": "Превышен предел числа администраторов (9).",
	"Billing information": "Платежная информация",
	"Please enter cardName": "Введите имя владельца карты",
	"Please enter_card": "Введите действительный номер карты",
	"Please enter address": "Введите адрес",
	"Please select country": "Выберите страну",
	"Please enter city": "Введите город",
	none: none$3,
	"Due today": "Срок оплаты сегодня",
	"Today after 1_": "Сегодня после месячного пробного периода",
	"An error occurred_": "При попытке изменить пароль произошла ошибка. Повторите попытку.",
	"Your account is_": "Ваша учетная запись активирована",
	"You can now_": "Теперь вы можете войти в свою учетную запись, используя адрес электронной почты, указанный при регистрации.",
	Email: Email$3,
	"Don’t have an account?": "Нет учетной записи?",
	"Already have an account?": "Уже есть учетная запись?",
	"Cloud service": "Cloud service",
	"for your BlackVue": "for your BlackVue",
	"See what your_": "See what your camera sees remotely.",
	"Receive impact alert_": "Receive Impact alert push notifications.",
	"Save footage to_": "Save footage to the cloud and do much more...",
	"Free plan included_": "Free plan included · Easy setup · Cancel anytime",
	"Taking advantage of_": "Taking advantage of a mobile or car-embedded Internet connection and a BlackVue camera, BlackVue Cloud connects you to your car from anywhere, anytime. Using the BlackVue App on your smartphone or tablet, you see in real time where your car is located and what is happening around it.",
	"Get notifications to_": "Get notifications to your phone when your parked car is hit. Check remotely what is happening around your car.",
	"Monitor your commercial_": "Monitor your commercial vehicles on a map in real time. Talk to your drivers anytime through the BlackVue App or Viewer.",
	"With BlackVue Fleet_": "With BlackVue Fleet Tracking, track in real time up to 100 vehicles from the palm of your hand or with the dedicated BlackVue Viewer.",
	"Get started now_": "Get started now with a Free plan. For unlimited video playback or Remote Live View, upgrade to Lite or Smart plan from the BlackVue App. <br/>Business and power users can unlock the power of the Fleet plan exclusively through this website.",
	"Remote Video Playback_": "Remote Video Playback and Download",
	"Compatible with DR650GW_": "Compatible with DR650GW, DR650S models",
	"Unlimited remote video_": "Unlimited remote video playback and download",
	"Longer cloud storage_": "Longer cloud storage file expiration period",
	"Longer storage period_live": "Longer storage period for Event live auto upload",
	"Longer storage period_file": "Longer storage period for Event file auto upload",
	"Goefence setup (PC_": "Geo-fence setup (PC viewer) and alerts (Windows viewer and app)",
	"App Store": "App Store",
	"Send reset password email": "Отправить письмо для сброса пароля",
	Customers: Customers$3,
	Home: Home$3,
	"Pick a plan": "Pick a plan",
	"No customers yet": "No customers yet",
	"Customers will_": "Customers will show up here as they become available",
	"Add customer": "Add customer",
	"Report(PDF)": "Report(PDF)",
	"Subscription Period": "Subscription Period",
	Plan: Plan$3,
	New: New$3,
	Unsubscribed: Unsubscribed$3,
	"Subscription ends soon": "Subscription ends soon",
	Edit: Edit$3,
	"1 month trial": "1 month trial",
	"Edit customer details": "Edit customer details",
	"Customer name": "Customer name",
	"of 999 available_": "of 999 available on Fleet Plan",
	"Subscription starts": "Subscription starts",
	"Subscription period": "Subscription period",
	month: month$3,
	months: months$3,
	"Cloud storage": "Cloud Storage",
	"Subscription plan": "Тип подписки",
	"Check email address": "Check email address",
	"Add customer details": "Add customer details",
	Continue: Continue$3,
	Back: Back$3,
	"An error occured": "An error occured",
	"Customer added": "Customer added",
	"Last changed": "Last changed",
	"Company name": "Company name",
	"Company address": "Company address",
	"Alert Push Notifications": "Alert Push Notifications",
	"Receive notifications on_": "Receive notifications on your phone when preset Events occur. Great in combination with BlackVue’s Parking Mode.",
	"Remote Live View": "Удаленный просмотр в реальном времени",
	"Remotely monitor your_": "Remotely monitor your car in real time from anywhere, anytime.",
	"Video Backup/Auto Upload": "Video Backup/Auto Upload",
	"Back up videos_": "Back up videos to your phone or Cloud storage.",
	"Two-way Voice Communication": "Two-way Voice Communication",
	"Talk with people_": "Talk with people in the car from your smartphone. The driver can speak while keeping hands on the wheel.",
	"View your car’s_": "View your car’s location and speed on a map. With BlackVue Fleet Tracking, access 90-days’ worth of GPS data.",
	"Remote Video Playback": "Remote Video Playback",
	"Play videos stored_": "Play videos stored in the Cloud or in your dashcam anytime on your smartphone or tablet.",
	"Event Live Auto Upload": "Event Live Auto Upload",
	"Save a video stream_": "Save a video stream in real time to the Cloud. Protect yourself from break-ins and theft.",
	"Event File Auto Upload": "Event File Auto Upload",
	"Save Event videos_": "Save Event videos to the Cloud—including seconds before trigger—after they happen.",
	"Firmware-Over-the-Air (FOTA)": "Firmware-Over-the-Air (FOTA)",
	"Upgrade your dashcam’s": "Update your dashcam over the cloud",
	"When an Event_": "When an Event is created (Impact detected or manually triggered), Event Live Auto-upload lets your Cloud-compatible BlackVue save a live video stream from a camera of your choice (front or rear/interior) to the Cloud server",
	"Event File Auto-upload_": "Event File Auto-upload lets your dashcam automatically upload low-resolution versions of Event files to the Cloud.",
	Master: Master$3,
	"per Camera": "per Camera",
	"Event live auto upload_": "Event live auto upload compatible with all cloud cameras",
	"Drive report": "Drive report",
	"USA/Canada Toll Free": "USA/Canada Toll Free",
	"Monday–Saturday_": "Monday to Friday 8am-7pm / Saturday 9am-6pm (PST).",
	"Please agree to_": "You must accept Terms of Service",
	"Mac or Windows PC": "Mac or Windows PC",
	Develop: Develop$3,
	"Sign out": "Sign out",
	"Referral code": "Реферальный код",
	"Total after 1 month trial": "Всего после месячного пробного периода",
	"Already Use Stripe Token": "Токен Stripe уже используется",
	"Select period": "Выбрать период",
	"State/Region": "Область/регион (необязательно)",
	"ZIP/Postal": "Zip-код/почтовый индекс",
	"$0.00": "$0.00",
	"$11.99": "$11.99",
	"$24.99": "$24.99",
	$9: $9$3,
	$15: $15$3,
	$10: $10$3,
	"mo + for_": "/mo + {{a}} per extra camera",
	mo: mo$3,
	"This e-mail address_": "Этот адрес эл. почты уже зарегистрирован.",
	"1 month": "1 месяц",
	"Limit is reset daily": "Лимит сбрасывается ежедневно",
	"Limit is reset monthly": "Лимит сбрасывается ежемесячно",
	"Video plays and downloads": "Воспроизведение видео и загрузки",
	"Your master": "Your owner",
	"Youre 1 step_": "До завершения оформления подписки на тарифный план Fleet остается 1 шаг",
	"Finish signing up": "Завершить оформление подписки",
	"Enter billing information": "Введите платежную информацию",
	"Proceed to billing": "Перейти к оплате",
	City: City$3,
	Charge: Charge$3,
	"User already invited_": "Пользователь уже приглашен мастером",
	"n% consumed": "Использовано {{a}}%",
	"E-mail already exists": "Адрес электронной почты уже существует",
	"Cancel your inapp_": "Отмените подписку в приложении",
	"You have cancel_": "Чтобы перейти на тарифный план Fleet, вы должны отменить подписку в приложении: 1. Отмените текущую подписку в магазине App Store или Google Play. По окончании текущего платежного цикла вы перейдете на бесплатный план. Ваши данные не будут удалены. 2. Войдите в свою учетную запись на сайте blackvuecloud.com и перейдите на тарифный план Fleet.",
	"Edit permissions": "Редактировать разрешения",
	"See permissions": "Просмотреть разрешения",
	"Submaster removed": "Субмастер удален",
	"Camera removed": "Камера удалена",
	"User removed": "Пользователь удален",
	"Users removed": "Пользователи удалены",
	subscribe: subscribe$3,
	search: search$3,
	"permission can be_": "Разрешение может быть предоставлено после принятия приглашения субмастером.",
	"The confirmation link_": "Ссылка для подтверждения больше не действительна",
	"Possible reasons:_": "Возможные причины:\n • Вы уже подтвердили свой адрес электронной почты\n • Ссылка просрочена или отменена",
	"Failed to register_": "Не удалось зарегистрироваться в BlackVue Cloud",
	"There was an_": "В процессе регистрации произошла ошибка. Если проблема не устранена, попробуйте еще раз зарегистрироваться в BlackVue Cloud. Если вам нужна дополнительная помощь, свяжитесь с нашей службой поддержки:",
	"Upgrade to Fleet_": "Перейти на тариф Fleet",
	"Subscription is Canceled": "Подписка отменена",
	"No members yet": "Еще нет членов",
	"Please enter_group name": "Введите действительное имя группы",
	"Group Name": "Имя группы",
	invalid_number: invalid_number$3,
	invalid_expiry_month: invalid_expiry_month$3,
	invalid_expiry_year: invalid_expiry_year$3,
	invalid_cvc: invalid_cvc$3,
	incorrect_number: incorrect_number$3,
	incomplete_number: incomplete_number$3,
	incomplete_cvc: incomplete_cvc$3,
	incomplete_expiry: incomplete_expiry$3,
	expired_card: expired_card$3,
	incorrect_cvc: incorrect_cvc$3,
	incorrect_zip: incorrect_zip$3,
	invalid_expiry_year_past: invalid_expiry_year_past$3,
	card_declined: card_declined$3,
	missing: missing$3,
	processing_error: processing_error$3,
	"no groups yet": "Группы пока отсутствуют",
	"groups will show_": "Когда группы станут доступными, они будут отображаться здесь",
	"Fleet members will_": "Когда члены автопарка станут доступными, они будут отображаться здесь",
	"service provider": "Поставщик услуг",
	Paypal: Paypal$3,
	iOS: iOS$3,
	Android: Android$3,
	"Enter email": "Введите адрес электронной почты",
	"Enter password": "Введите пароль.",
	"Enter first name": "Введите имя",
	"Enter last name": "Введите фамилию",
	"Enter the current_": "Введите текущий пароль",
	"Enter a new_": "Введите новый пароль",
	"There isnt an_": "Нет учетной записи, связанной с этим адресом электронной почты",
	"Fleet Plan": "Fleet Plan",
	Total: Total$3,
	"Password you entered_": "Вы ввели неверный пароль",
	"Incorrect email or_": "Неверный адрес электронной почты или пароль",
	"Available to Masters": "Доступно для владельца",
	"Blackvue url": "https://www.blackvue.com",
	"Information We Collect_": "Какие данные мы собираем и зачем",
	And: And$3,
	"Terms of Location-Based_": "Условия обслуживания на основе местоположения.",
	"I agree to the_": "Я соглашаюсь",
	"Password Reset_": "Мы отправили электронное письмо с инструкциями по смене \n пароля на адрес {{a}}.",
	"You have already_": "Вы уже приглашены, проверьте свою электронную почту.",
	"No data available_": "Данные отсутствуют в таблице",
	Camera: Camera$3,
	"You no longer_": "У вас больше нет разрешения на использование службы автопарка.",
	"Please contact your_": "Свяжитесь со своим мастером автопарка, чтобы решить эту проблему.",
	"You can still_": "Вы все еще можете получать доступ к",
	"account information": "информации учетной записи.",
	"If the issue_": "Если проблема не будет решена, а вы захотите продолжить использование службы BlackVue Cloud с зарегистрированным адресом электронной почты, вам придется удалить свою учетную запись и зарегистрироваться снова.",
	"If the problem_": "Если проблема не будет устранена, свяжитесь с нашей службой поддержки:",
	"Web subscription only": "Только веб-подписка",
	"AppStore url": "https://apps.apple.com/kr",
	"We no longer_": "Мы больше не проводим платежи через PayPal. Вы должны обновить подписку, чтобы изменить количество камер: 1. Войдите в свою учетную запись на сайте paypal.com и отмените текущую подписку на тарифный план Fleet, чтобы изменить количество камер: 2. Войдите в свою учетную запись на сайте blackvuecloud.com и перейдите на тарифный план Fleet.",
	Yes: Yes$3,
	No: No$3,
	"Serial number": "Серийный номер",
	"Cloud code": "Код облачного хранилища",
	"Terms & Policies": "Условия и политики",
	News: News$3,
	Notifications: Notifications$3,
	"km/h": "km/h",
	MPH: MPH$3,
	"Baidu Maps": "Baidu Maps (только КНР)",
	"Google Maps": "Google Maps",
	Firmware: Firmware$3,
	Basic: Basic$3,
	"Time Zone": "Часовой пояс",
	Resolution: Resolution$3,
	"Image quality": "Качество изображения",
	Brightness: Brightness$3,
	Recording: Recording$3,
	"Normal recording": "Обычная запись",
	"Voice recording": "Запись звука",
	"Video segment length": "Длина сегмента видео",
	"Rear camera recording": "Запись с задней камеры",
	Highest: Highest$3,
	High: High$3,
	Normal: Normal$3,
	"1 min": "1 мин.",
	"2 min": "2 мин.",
	"3 min": "3 мин.",
	Sensitivity: Sensitivity$3,
	"Motion detection": "Обнаружение движения",
	"Speed alert": "Оповещение скорости",
	"Voice guidance": "Голосовое управление",
	"Power on": "Питание вкл.",
	"Power off": "Отключить питание",
	"Starting normal recording": "Начало обычной записи",
	"Changing recording mode": "Изменение режима записи",
	"Speed alert (beep)": "Оповещение скорости (звуковой сигнал)",
	"Cloud related": "Связанные с Cloud",
	Volume: Volume$3,
	"User text overlay": "Наложение пользовательского текста",
	"A-Z, a-z_": "Допустимы символы A-Z, a-z, 0-9, :;’/\\+-_()$#\n. Не более 20 символов.",
	"Wi-Fi auto turn off": "Автовыключение Wi-Fi",
	"Login credentials": "Учетные данные",
	"Manual recording": "Запись вручную",
	"By sharing your_": "Предоставив другим пользователям доступ к Live View, вы позволяете им следить за вашим путешествием из любой точки мира.",
	"However, as persona_": "Однако следует помнить, что Live View может содержать конфиденциальную информацию о вас.",
	"Please enter_email_2": "Пожалуйста, введите действительный адрес электронной почты. Электронная почта с некоторыми специальными символами может быть не разрешена. Ex) +, &",
	"Password is incorrect": "Неверный пароль.",
	"This camera is already_": "Данная камера уже зарегистрирована в учетной записи BlackVue.",
	"Camera name must_": "Имя камеры должно содержать от 5 до 30 символов.",
	"Failed to save_": "Не удалось сохранить настройки камеры.",
	"Unallowed character detected": "Обнаружен запрещенный знак.",
	"File(s) queued for_": "Файл(ы) в очереди для передачи в облако.",
	"Exceeded video play_": "Исчерпан ресурс воспроизведения и загрузки видео.",
	"Playback Failed": "Воспроизведение не удалось.",
	"Exceeded your Live_": "Превышен предел просмотра в прямом эфире.",
	"The camera is not_": "Камера не подключена к серверу.",
	"Please check the connection_": "Проверьте состояние подключения выбранной камеры.",
	Close: Close$3,
	"Map": "Карта",
	Cloud: Cloud$3,
	Public: Public$3,
	"Flip horizontally": "Отразить по горизонтали",
	Front: Front$3,
	Rear: Rear$3,
	Play: Play$3,
	Stop: Stop$3,
	Pause: Pause$3,
	"Next frame": "Следующий кадр",
	"Previous frame": "Предыдущий кадр",
	"Proximity sensor": "Датчик близости",
	"Voice recording on/off": "Запись звука вкл / выкл",
	"The BlackVue dashcam_": "Видеорегистратор BlackVue несовместим с беспроводными сетями 5 Гц.",
	Time: Time$3,
	"Daylight saving time": "Летнее время",
	System: System$3,
	"Incorrect camera serial_": "Неверный серийный номер камеры.",
	"Lock event files": "Блокировать файлы события",
	"Overwrite locked event_": "Перезаписать заблокированные файлы события при заполнении",
	"Camera settings saved_": "Настройки камеры успешно сохранены.",
	"Front camera": "п/камера",
	"Rear camera": "з/камера",
	Event: Event$3,
	Parking: Parking$3,
	"GPS tracking": "Отслеживание GPS",
	"G-force detected": "Датчик ускорения",
	"Impact detected in_": "Зафиксирован удар в режиме парк.",
	"Scheduled reboot": "Плановая перезагрузка",
	"Recording status": "Состояние записи",
	"Rear security": "Задний индикатор",
	"Time lapse": "замедленная съёмка",
	"Sync with GPS_": "Синхронизация с временем GPS",
	"Overwrite locked event3_": "Перезаписать заблокированные файлы новыми файлами события при заполнении хранилища",
	"Video codec": "Видео Codec",
	"Tracking logs": "Отслеживание журналов",
	"Geofence alerts": "Оповещение геозоны",
	Color: Color$3,
	Exit: Exit$3,
	Save: Save$3,
	Impact: Impact$3,
	Unlimited: Unlimited$3,
	"Parking mode recording": "Запись в режиме парковки",
	"Battery protection": "Защита батареи",
	"Cut-off timer": "Время отключения",
	"Low voltage cut-off": "Отключение питания при низком напряжении",
	"Rear camera orientation": "Положение задней камеры",
	Default: Default$3,
	"Rotate video 180°": "Повернуть видео на 180°",
	"Mirror video": "Отразить видео",
	"Wi-Fi band": "Частота Wi-Fi",
	"Driving report": "Отчет о вождении",
	"Unsupported video codec_": "Неподдерживаемый видеокодек (H.265).",
	"Rear camera recording_": "Запись с задней камеры в режиме парковки",
	"Front and rear_": "Передняя и задняя камеры записывают видео совместно",
	"Rear camera stops_": "Задняя камера останавливает запись через 5 минут после перехода в режим парковки. Запись возобновляется после перехода в обычный режим.",
	"Remote firmware update": "Удаленное обновление прошивки",
	"Firmware is up-to-date": "Актуальная версия прошивки",
	"New firmware available": "Доступна новая прошивка.",
	Version: Version$3,
	"Release date": "Дата выпуска",
	Language: Language$3,
	"File size": "Размер файла",
	"What’s new": "Что нового",
	"Updating may take_": "Обновление может занять несколько минут.",
	"The update process_": "Обновление нельзя отменить.",
	"Do not disconnect the_": "Не отключайте кабель питания до возобновления нормальной записи.",
	"Downloading firmware": "Загрузка прошивки",
	"Once download is_": "После завершения загрузки BlackVue автоматически выполнит перезагрузку для применения новой прошивки.",
	"If not allowed_": "Если нет разрешения, то местоположение и скорость автомобиля не будут доступны в Cloud.",
	"Unable to initiate update because_": "Не удалось начать обновление, так как видеорегистратор подключен к устройству по прямому соединению Wi-Fi.",
	Notification: Notification$3,
	Multiple: Multiple$3,
	Range: Range$3,
	"HDR night vision": "Ночное видение HDR",
	Download: Download$3,
	"G-sensor": "G-Sensor",
	Manual: Manual$3,
	"Low voltage warning": "Предупреждение о низком напряжении",
	Satellite: Satellite$3,
	"Data usage": "Использование данных",
	"Select video download quality": "Выберите качество загрузки видео",
	"Quick play file_": "Файл быстрого воспроизведения (низкое разрешение)",
	"Original file": "Исходный файл",
	"You do not have permission_": "У вас нет разрешения на запуск этой функции. Пожалуйста, свяжитесь с владельцем вашей основной учетной записи.",
	"Interior camera recording_": "Запись с внутренней камеры в режиме парковки",
	"Interior security": "Внутренняя безопасность",
	"Interior camera rotation": "Вращение внутренней камеры",
	"Multi View": "Множественное представление",
	Tutorials: Tutorials$3,
	"Upgrade now": "Обновить сейчас",
	"Members will show_": "Когда члены станут доступными, они будут отображаться здесь",
	"Are you sure_delete members": "Действительно навсегда удалить членов?",
	"Some members may_": "Некоторые члены могут быть скрыты из-за применяемых фильтров.",
	"Invited on_": "приглашен вами {{Invited Date}}. Владелец",
	Filter: Filter$3,
	"Date created": "Дата создания",
	"No admin yet": "Еще нет администратора",
	"You can add_admin": "Вы можете добавить 1 администратора для каждой группы",
	"Collapse all": "Свернуть все",
	"Expand all": "Развернуть все",
	"Download and playback_cloud": "Загрузка и воспроизведение из облачного хранилища",
	"Are you sure_2": "Действительно удалить эту группу отслеживания {Group name}?",
	"Are you sure_groups": "Действительно удалить группы?",
	"Add cameras first_drivers": "Сначала добавьте камеры, а затем назначьте водителей",
	"Flip vertically": "Повернуть по вертикали",
	Sun: Sun$3,
	Mon: Mon$3,
	Tue: Tue$3,
	Wed: Wed$3,
	Thu: Thu$3,
	Fri: Fri$3,
	Sat: Sat$3,
	Dates: Dates$3,
	Routes: Routes$3,
	Opacity: Opacity$3,
	"Color and opacity": "цвет и прозрачность",
	"Geofences will show_": "когда геозоны станут доступными, они будут отображаться здесь",
	"Start drawing a shape_": "начать рисование фигуры на карте",
	"Add geofence": "Добавить геозону",
	Entry: Entry$3,
	"Show all members": "Показать всех членов",
	"Me and my_": "Я и мой автомобиль. Подключена",
	"add-on service for_": "дополнительная служба для устройств BlackVue, совместимых с облаком",
	"Continue with Google": "Продолжить с Google",
	"An account with_": "Учетная запись с этим адресом электронной почты уже существует, но адрес не подтвержден. введите ваш существующий пароль для входа в BlackVue Cloud.",
	"Account does not_": "Аккаунт не существует. Или попробуйте войти в систему, используя свою учетную запись Apple или Google.",
	"Continue with Apple": "Продолжить с Apple",
	"Get started": "Начать работу",
	"P subscription only": "<b>{{a}}</b> Только подписка",
	"+N USD for extra camera_": "+{{a}} USD for extra camera up to {{b}} Cameras",
	"Unlimited Live view": "Unlimited Live View",
	"Cameras per Account": "Cameras per Account",
	"Users per Account": "Users per Account",
	Owner: Owner$3,
	"Live View per Day": "Live View per Day",
	"Remote Video Playback_2": "Remote Video Playback and Download per Month",
	"N days": "{{a}} Days",
	"Video On Map": "Video On Map",
	Undetected: Undetected$3,
	Distracted: Distracted$3,
	Drowsy: Drowsy$3,
	"Whether on mobile_": "Whether on mobile or your computer, BlackVue gives you the tools to fully enjoy your dashcam’s functions. Download the latest <a1>firmware</a1>, <a2>mobile</a2> and <a3>desktop</a3> applications, or use <a4>BlackVue web app</a4> in your browser.",
	"Compatible with most_": "Compatible with most Wi-Fi BlackVue models. Cloud support for all Cloud-compatible dashcam models down to DR650GW Series with <b>Cloud Firmware</b>.",
	"Supports most recent BlackVue_": "Supports most recent BlackVue models and compatible with BlackVue Cloud.<br/>\nThis Viewer contains <b>two applications in one</b>: the SD Card Viewer lets you view recorded videos from your SD card and modify the settings of your BlackVue, as well as format the SD card; the <b>Cloud Viewer</b> lets you enjoy BlackVue Cloud.",
	"Contact us": "Contact us",
	"6 characters with": "6 символов с сочетанием букв, цифр и специальных знаков",
	"Apps and more...": "Apps and more...",
	"Cameras will show_": "Cameras will show up here as they become available.",
	"Keep this page_": "Не закрывайте эту страницу при проверке кода подтверждения. Если вы не можете найти письмо в папке входящих, проверьте папку спама.",
	"n cameras": "{{n}} камер",
	"n slots": "{{n}} слотов",
	"Calculate your Fleet_": "Рассчитать стоимость тарифа Fleet",
	"Code you entered_": "Код активации неверен или просрочен",
	Calling: Calling$3,
	Smoking: Smoking$3,
	"Smoking has been_": "Во время вождения зафиксировано курение.",
	"Email is already_": "Эта электронная почта уже существует.",
	"Serial number and_": "Серийный номер и облачный код напечатаны на камере",
	"Allow GPS access": "Разрешить доступ GPS",
	"Used to access_": "Используется для определения местоположения и скорости вашего автомобиля. Изменить настройки GPS можно позже в настройках конфиденциальности камеры.",
	"Incorrect cloud code": "Неверный код Cloud",
	"An account is_": "На этот адрес электронной почты уже зарегистрирована учетная запись.",
	"Live event upload": "Загрузка событий в реальном времени",
	Permissions: Permissions$3,
	"Assign in": "Назначить в",
	"Are you sure_camera": "Вы уверены, что хотите удалить эту камеру?",
	"Uploading videos:": "Загрузка видео:",
	"GPS location recording": "Запись данных о местоположении GPS",
	"When OFF, GPS_": "В состоянии отключения данные о местоположении GPS не записываются и не отправляются на облачный сервер.",
	"As personal video_": "Личное видео может пересылаться, поэтому тщательно выбирайте данные, которыми хотите поделиться.",
	"Share location": "Предоставить местоположение",
	Private: Private$3,
	"Used to access_2": "Используется для определения местоположения и скорости вашего автомобиля.",
	"Share live view": "Предоставить видео в реальном времени",
	"Share live audio": "Предоставить аудио в реальном времени",
	"Share camera’s name": "Предоставить имя видеорегистратора",
	"Impact detection": "Обнаружение воздействия",
	Entering: Entering$3,
	Exiting: Exiting$3,
	"Normal event recording": "Запись обычных событий",
	"Harsh braking": "Резкое торможение",
	Acceleration: Acceleration$3,
	"Sharp turn": "Резкий поворот",
	"Parking event recording": "Запись события парковки",
	Passing: Passing$3,
	"Video source": "Источник видеосигнала",
	Overspeed: Overspeed$3,
	"Are you sure_video": "Действительно удалить эту видеозапись?",
	"Add camera to_": "Добавить камеру к просмотру в реальном времени",
	"No routes to_": "Нет маршрутов для показа",
	"Start by adding_": "Начните с добавления дат.",
	"invite sent": "Приглашение отправлено",
	Recipients: Recipients$3,
	Send: Send$3,
	"Routes selected_": "Выбранные маршруты: {{n}} из {{total}}",
	"Map service": "Поставщик карт",
	"Speed units": "Единицы измерения скорости",
	Note: Note$3,
	"Release notes": "Замечания к выпуску",
	"The name must_": "Имя должно содержать от 1 до 30 символов.",
	Video: Video$3,
	Advanced: Advanced$3,
	"Firmware language": "Язык прошивки",
	"Wi-Fi": "Wi-Fi",
	Voice: Voice$3,
	"Show date and_": "Показать дату и время",
	"Show speed": "Показать скорость",
	"Front camera rotation": "Поворот передней камеры",
	"Manual time settings": "Настройка времени вручную",
	"Recommended for better_": "Рекомендуется для лучшего сжатия, уменьшения размера файлов и поддержки 4K UHD.",
	"For full compatibility_": "Для полной совместимости с ПК предыдущих поколений и мобильными устройствами.",
	"Up and down": "Верх и низ",
	"Side to side": "Рядом",
	"Front and back": "Спереди и сзади",
	"Detection region": "Область обнаружения",
	"Hotspot 1": "Точка доступа 1",
	"Hotspot 2": "Точка доступа 2",
	"Hotspot 3": "Точка доступа 3",
	"Enter/exit": "Вход/выход",
	"Event recording": "Запись событий",
	"Front security (Normal)": "Защита спереди (обычный режим)",
	"Front security (Parking)": "Защита спереди (режим парковки)",
	"LTE (Parking)": "LTE (парковка)",
	"Wi-Fi (Parking)": "Wi-Fi (парковка)",
	"Turn on at startup": "Включать при запуске",
	"Turn off after_": "Выключить после 10 мин. бездействия",
	"Your firmware is_": "Ваша прошивка обновлена",
	"Add admin": "Добавить администратора",
	"Remove All/n": "Удалить все/{{a}}",
	"Are you sure_remove": "Удалить камеры из этой группы?",
	"This will cancel_2": "Это отменит вашу подписку на план Fleet. По окончании текущего платежного цикла вы перейдете на тариф Free.",
	"You’ve reached_": "Вы достигли ограничения по количеству водителей на камеру.",
	"Are you sure_remove admin": "Удалить администратора {{a}}{{b}} из этой группы?",
	"Fleet Plan · Owner": "Fleet Plan · Owner",
	"Manage cameras": "Управление камерами",
	"Are you sure_delete zone": "Удалить зону «{{zone}}»?",
	"available on your_2": "{{a}}/{{b}} доступно в вашем плане",
	"The new plan_2": "Новый тариф вступит в силу в конце текущего платежного цикла ({{a}}).",
	"Canceled Fleet Plan_": "Тариф Fleet отменен {{a}}",
	"Hard braking alert (beep)": "Предупреждение о резком торможении (звуковой сигнал)",
	"Hard acceleration alert (beep)": "Предупреждение о резком ускорении (звуковой сигнал)",
	"Hard cornering alert (beep)": "Предупреждение о резком повороте (звуковой сигнал)",
	"SSID must be_": "SSID должен содержать минимум 5 символов.",
	"Password must be_": "Пароль должен содержать минимум 8 символов.",
	"5 to 32 characters long": "От 5 до 32 символов",
	"8 to 32 characters long": "От 8 до 32 символов",
	"Longer storage period_event": "Более длительный срок хранения для загрузки прямых трансляций",
	"Requires latest firmware_": "Требуется последняя версия прошивки. Не совместим с моделями DR650S, DR650GW.",
	"After Blackvue is_": "После подключения Blackvue к Cloud настройки будут сохранены.",
	"This is an_": "Этот адрес электронной почты не зарегистрирован. Создать новую учетную запись?",
	"This feature is_": "Эта функция доступна только для тарифа Fleet.",
	"Please return to_": "Аккаунт не существует. Или попробуйте войти в систему, используя свою учетную запись Apple или Google.",
	"Adjusting the cut-off voltage_": "Adjusting the cut-off voltage to a lower setting may result in your dash cam draining more power from your battery.\nThis could result in warning messages of battery drain or affect other vehicle functions.\nPlease consult with your dealership before lowering the voltage.",
	"Your videos will_": "Когда видеозаписи станут доступными, они будут отображаться здесь.",
	"You drove:_": "Вы проехали: {{distance}}, {{time}}",
	"Event count per_": "Количество событий за час вождения",
	"Are you sure_recipient": "Удалить этого получателя?",
	"(You)": "{{а}} (Вы)",
	"All events": "Все события",
	Days_: Days_$3,
	"Requires DMC 200_": "Требуется камера DMC 200",
	"A DMS and compatible_": "Для просмотра этого отчета требуется DMS и совместимый видеорегистратор.",
	"Notifications will show_": "Когда уведомления станут доступными, они будут показаны здесь.",
	"Try changing your_": "Попробуйте изменить дату или удалить фильтры.",
	Mute: Mute$3,
	UnMute: UnMute$3,
	"Calling and smoking_": "Звонки и курение распознает только устройство DMC 200",
	"You need a DMS_": "Для просмотра этого отчета необходим DMS.",
	"Try BlackVue Cloud": "Попробуйте BlackVue Cloud сегодня",
	"Individual driver looking_": "Вы частный водитель и хотите работать без проблем? Вы владелец бизнеса в поисках простого решения для безопасности и отслеживания транспортных средств?",
	"Whoever you are_": "Кем бы вы ни были и чего бы ни хотели, мы подберем для вас подходящий тариф Cloud!",
	"It is the account that_Driver": "Эта учетная запись присоединилась к вашему автопарку в BlackVue Cloud после принятия приглашения по электронной почте от владельца или администратора. За одним водителем закрепляется только одна камера с ограниченными возможностями просмотра своего профиля, просмотра в реальном времени и воспроизведения.",
	"It is the account that_Admin": "Эта учетная запись присоединилась к вашему автопарку в облаке BlackVue после принятия приглашения по электронной почте от владельца. Учетным записям администратора могут предоставляться права, разрешенные владельцем для этого администратора.",
	"Video deleted": "Видео удалено",
	"Video delete_plural": "Видео удалены",
	"Driver removed from_": "Водитель удален из группы",
	"Admin removed from_": "Администратор удален из группы",
	"Camera removed from_": "Камера удалена из группы",
	"Are you sure_videos": "Удалить выбранный(е) файл(ы)?",
	"You have to cancel_fleet": "Для изменения количества камер отмените подписку в приложении:\n \n 1. Отмените текущую подписку в магазине App Store или Google Play. По окончании текущего платежного цикла вы перейдете на тариф Free. Ваши данные не будут удалены.\n 2. Войдите в свою учетную запись на сайте blackvuecloud.com и перейдите на тариф Fleet.",
	Discard: Discard$3,
	"Discard unsaved changes?": "Отменить несохраненные изменения?",
	"Incorrect serial number": "Неверный серийный номер",
	"An error occurred_again": "Произошла ошибка. Повторите попытку.",
	"You are subscribed_free": "Вы оформили подписку на тариф Free от BlackVue Cloud.",
	"When an event_": "После создания события (обнаружение воздействия или ручной запуск) при загрузке интерактивных событий BlackVue может сохранять прямую трансляцию с выбранной камеры на сервер Cloud, начиная с 5 секунд до наступления события.",
	Report: Report$3,
	"How it work": "Принцип работы",
	"Cloud Camera": "Cloud Camera",
	"Internet Connection": "Интернет-соединение",
	"BlackVue App/Viewer": "BlackVue App/Viewer",
	"All you need_": "Все, что вам нужно, – это",
	"Cloud-compatible BlackVue": "BlackVue, совместимый с Cloud,",
	"and a cellular_": "и тарифный план с мобильной передачей данных. Некоторые модели подключаются к Cloud через стороннюю точку доступа Wi-Fi. Остальные предлагают встроенное устройство чтения карт nano-SIM или поддержку модуля подключаемого соединения.",
	"Cloud features at_": "Функции Cloud у вас под рукой",
	"Enjoy peace of_": "Занимайтесь своими делами, зная, что BlackVue следит за вашим автомобилем. Если что-то пойдет не так, видеорегистратор немедленно сообщит вам об этом.",
	"Let your BlackVue_": "BlackVue будет следить за вашим автомобилем и предупреждать о происшествиях. В момент фиксации воздействия BlackVue отправит уведомление на ваш телефон или в браузер со снимком.",
	"Check on your_": "Следите за своим автомобилем из любого места с помощью функции удаленного просмотра в реальном времени. Получайте доступ к видеотрансляции реального времени через браузер или телефон с видеорегистратора, подключенного к Cloud, и легко переключайтесь между передней, задней или внутренней камерами.",
	"Your BlackVue may_": "BlackVue не может предотвращать наезды, но есть большой шанс того, что приложение зафиксирует важные видеодоказательства. Просматривайте все видео, записанные на видеорегистратор, с мобильного телефона или браузера.",
	"Worried about eating_": "Беспокоитесь о перерасходе тарифного плана? Технология BlackVue Sub-stream позволяет получать доступ к сверхлегким версиям видео для быстрого просмотра и просмотра без буферизации.",
	"Move files from_": "Перемещайте файлы с BlackVue в Cloud. Сохраняйте видео по одному или выбирайте сразу несколько клипов для пакетной загрузки. Видео, загруженное на ваш телефон с помощью приложения BlackVue, можно просмотреть и поделиться им из меню «Внутренняя память».",
	"View your vehicle’s_": "Отслеживайте местоположение и скорость вашего автомобиля в реальном времени. Перейдите на тариф Smart и получите доступ к данным GPS-слежения за последние 7 дней.",
	"Get more with_": "Получите больше возможностей с тарифом Smart",
	"Unlimited Remote Live_": "Неограниченный удаленный просмотр в реальном времени",
	"Up to 3 dashcams_": "До 3-х видеорегистраторов на одну учетную запись",
	"Want to track_": "Хотите отслеживать весь автопарк? Перейти на тариф Fleet",
	"BlackVue Fleet Tracking_2": "BlackVue Fleet Tracking – комплексное решение для защиты и отслеживания вашего автопарка. Возможности и цены можно гибко менять под нужды вашего бизнеса.",
	"Stream real-time video_": "Потоковое видео без ограничений. Скорость: 600 кбит/с",
	"Up to 999 Dashcams": "До 999 видеорегистраторов",
	"Register up to_": "Регистрируйте до 999 видеорегистраторов на одну учетную запись.",
	"15GB of Cloud_": "15 ГБ облачного хранилища",
	"15GB per additional_": "15 ГБ на дополнительный видеорегистратор. Неограниченный объем памяти для автозагрузки событий.",
	"90-days GPS_": "Журналы GPS-слежения за 90 дней",
	"High accuracy: 15_": "Высокая точность: 15 секунд, отображение видео на карте, простой экспорт данных.",
	"Unique fleet management_": "Уникальные функции управления автопарком дают новые преимущества и удобства",
	"Create geofences and_": "Создавайте геозоны и получайте уведомления в реальном времени на свой телефон или компьютер.",
	"View at a_": "Быстрый просмотр общего пробега, времени простоя, превышения скорости и прочей информации в таблицах, которые можно распечатать или экспортировать.",
	"Multi Live View": "Мультипросмотр в реальном времени",
	"Monitor up to_": "Отслеживайте до 4 видеорегистраторов одновременно",
	"Benefits for you": "Преимущества",
	Individual: Individual$3,
	"Get notifications to_2": "Получайте уведомления на телефон, если вашу машину ударили на парковке. Следите за обстановкой вокруг вашего авто из любого места. Доступно через Интернет, мобильные устройства, Mac и Windows.",
	"Small business owner": "Владелец малого бизнеса",
	"Monitor your commercial_2": "Отслеживайте свой коммерческий транспорт на карте в реальном времени. Общайтесь со своими водителями в любое время через браузер, мобильное приложение BlackVue, программу просмотра для Mac или Windows.",
	"Company with large_": "Компания с большим автопарком",
	"With BlackVue Fleet_2": "Отслеживайте до 999 автомобилей в реальном времени через браузер, мобильное приложение BlackVue, программу просмотра Mac или Windows с помощью BlackVue Fleet Tracking.",
	Subscribed: Subscribed$3,
	"The video was_": "Видео уже загружено.",
	Geofence: Geofence$3,
	"500: Internal server error": "500: Внутренняя ошибка сервера",
	"404: Page not found": "404: Страница не найдена",
	"Check the web address_": "Проверьте веб-адрес или вернитесь на домашнюю страницу BlackVue Cloud",
	"home page": "Home page",
	"There isn’t an_": "Учетная запись с этим адресом электронной почты отсутствует",
	"You can now_password": "Теперь вы можете войти в систему, используя новый пароль",
	"Are you sure_remove admin2": "Действительно удалить администратора навсегда",
	"Admin deleted": "Администратор удален",
	"Members deleted": "Участники удалены",
	"Are you sure_groupName": "Действительно удалить группу {{a}}?",
	"Requires latest firmware": "Требуется последняя версия прошивки",
	"Selected file(s) moved_": "Выбранные файлы перемещены",
	"Are you sure_remove driver2": "Удалить водителя {{a}} ({{b}}) из этой группы?",
	"Invite sent": "Приглашение отправлено",
	"Safe driving": "Безопасное вождение",
	"Reckless driving": "Неосторожное вождение",
	"Inattentive driving": "Невнимательное вождение",
	"Driving events trend": "Тренды событий вождения",
	"Driving details": "Информация о вождении",
	Driving: Driving$3,
	Idling: Idling$3,
	Distance: Distance$3,
	"Parking sessions": "Сеансы парковки",
	"Parked time": "Parked time",
	"Idle stops": "Упоры холостого хода",
	"Idle time": "Время простоя",
	"Impact events": "Impact Events",
	Parked: Parked$3,
	Speed: Speed$3,
	"Overspeeding alerts": "Предупреждения о превышении скорости",
	Highest_2: Highest_2$3,
	Average: Average$3,
	Geofences: Geofences$3,
	"Entries into a_": "Въезды в зону",
	"Exits from a_": "Выезды из зоны",
	"No data": "Нет данных",
	"Hard acceleration": "Ускорение",
	"Hard braking": "Резкое торможение",
	"Hard cornering": "Резкий поворот",
	"The number within the brackets_": "В скобках показано среднее количество событий за час вождения. Если вы ездили менее одного часа в день, отображается общее количество событий.",
	"Did you insert_": "Вы вставили SIM-карту?",
	"Click here for_": "<a>Нажмите</a> для получения подробных инструкций.",
	"Back up all_": "<b>Перед сохранением настроек сделайте резервную копию всех важных записей.</b><br/>При сохранении настроек карта microSD будет повторно инициализирована, и все записи будут удалены для обеспечения стабильной работы.",
	"Not connected to_": "Не подключено к Cloud. Некоторые функции временно отключены.",
	"GPS Location recording off": "Запись данных о местоположении GPS отключена",
	"n Videos deleted": "{{count}} видео удалено",
	Move: Move$3,
	"Driver Monitoring System (DMS) will_": "Система мониторинга водителей (DMS) будет запущена в ближайшее время.",
	"An error occured while_": "Ошибка при попытке изменить количество камер. Повторите попытку",
	"Reached the limit_": "Достигнут предел: {{a}}",
	"An invitation was_": "Приглашение уже отправлено на этот адрес электронной почты.",
	"To use the_": "Для использования функции Cloud Вставьте SIM-карту.",
	"Last updated": "Последнее обновление {{date}}",
	"Try changing your date": "Попробуйте изменить дату.",
	"No event data_": "Данные о событиях, полученные за выбранное время, отсутствуют",
	"Please select another_": "Выберите другой день или месяц для просмотра всего отчета.",
	"more than 6_": "необходимо более 6 символов",
	"Sign up free": "Бесплатная регистрация",
	"Cloud storage warning": "Предупреждение облачного хранилища",
	"Cloud Storage Full": "Облачное хранилище заполнено",
	"Cloud storage usage_100": "Облачное хранилище данных использовано на 100%. Освободите место в хранилище для загрузки прямых трансляций.",
	"Cloud storage usage_": "Облачное хранилище использовано на <b>({{a}}%)</b>. \nОрганизуйте облачное хранилище.\nСлужба загрузки текущих событий будет недоступна, если облачное хранилище заполнено.",
	"Are you sure_delete_zone": "Удалить?",
	"Search Name or email": "Поиск по имени или электронной почте",
	"Search group name": "Поиск по названию группы",
	"Please note that_": "Для применения новых настроек запись видео будет приостановлена на несколько секунд.",
	"Currently connected Hotspot": "Точка доступа, подключенная в текущий момент",
	"Enhanced night vision": "Широкие возможности ночной съемки",
	"To access the_": "Чтобы получить доступ к камере, измените тарифный план.",
	"Restarting the Blackvue_": "Перезапуск BlackVue для применения настроек.",
	"Hard acceleration event_": "Резкое ускорение фиксируется, если скорость увеличивается больше чем на {{kmh}} км/ч в секунду",
	"Hard braking event_": "Резкое торможение фиксируется, если скорость снижается более чем на {{kmh}} км/ч \nв секунду.",
	"Hard cornering event_": "Резкий поворот фиксируется при повороте более чем на 60 градусов в течение 2 секунд при движении со скоростью выше \n15 км/ч.",
	"Changes you made_": "Внесенные изменения не могут быть сохранены.",
	"My location": "Мое местоположение",
	"Hotspot name (SSID)": "Название точки доступа (SSID)",
	Connected: Connected$3,
	"Camera will be rebooted_": "Камера будет перезагружена. Продолжить?",
	"Restarting the BlackVue_": "Перезапуск BlackVue. Пожалуйста, подождите.",
	"Failed to reboot_": "Не удалось перезагрузить камеру",
	"Bluetooth (Parking mode)": "BT (режим парковки)",
	"Front and interior camera_": "Передняя и внутренняя камеры выполняют запись одновременно.",
	"Interior camera stops_": "Внутренняя камера перестает записывать через 5 мин после входа в режим парковки. Запись возобновляется после перехода в обычный режим.",
	Individual_: Individual_$3,
	"Driver detection": "Обнаружение водителя",
	"During driving only": "Только во время вождения",
	Always: Always$3,
	"Driver detection box": "Окно обнаружения водителя",
	"DMS camera rotation": "Вращение камеры DSM",
	Low: Low$3,
	Medium: Medium$3,
	High_2: High_2$3,
	"Reboot Camera": "Перезагрузить камеру",
	"Latest events": "Последние события",
	"G-Sensor": "G-Sensor",
	"Playback speed": "Скорость воспроизведения",
	Flip: Flip$3,
	Previous: Previous$3,
	Next: Next$3,
	"Map type": "Тип карты",
	"Zoom in": "Приблизить",
	"Zoom out": "Уменьшить",
	"Move to Cloud": "Переместить в облако",
	"Please recognize that_": "Учтите, что запись видео будет приостановлена на несколько секунд, чтобы применить настройки.",
	"6 characters with_": "6 символов с сочетанием букв, цифр и специальных знаков",
	"Updating firmware": "Обновление прошивки",
	"Overspeed event occurs_": "Превышения скорости фиксируется, если видеорегистратор предупреждает водителя о превышении ограничения скорости. Изменить этот параметр можно в разделе «Прошивка» > «Система» > «Громкость».",
	"Enter group name": "Введите имя группы",
	"Live view failed": "Сбой просмотра в прямом эфире.",
	"Parking mode enter_": "Включение/выключение режима парковки",
	"Cloud connectivity": "Подключение к облаку",
	Expand: Expand$3,
	Collapse: Collapse$3,
	"all day": "Весь день",
	"Driving style": "Стиль вождения",
	"Driving impact": "Удар при вождении",
	More: More$3,
	"No cameras to_": "Нет камер для добавления",
	"You have added_": "Вы добавили все доступные камеры.",
	Multi: Multi$3,
	"Report video": "Пожаловаться на видео",
	"Sexually explicit content": "Контент сексуального характера",
	"Graphic violence": "Сцены насилия или вызывающий отвращение контент",
	"Hateful speech": "Проявление ненависти или оскорбления",
	"Harassment or bullying": "Домогательство или запугивание",
	"Spam or advertisement": "Спам или реклама",
	"Infringement of my_": "Нарушение моих прав",
	"Other reason": "Прочее",
	"Reason for reporting": "Причина жалобы",
	"Reported videos will_": "Видеоролики, на которые поступили жалобы, будут проверены в течение 72 часов. Видео не будет отображаться на карте событий до тех пор, пока не будет подтверждено, что оно подходит для такого отображения.",
	"Touch sensor": "Сенсорный датчик",
	"Motion and impact detection": "Обнаружение движения и удара",
	"Settings have been changed": "Настройки были изменены",
	"Start event recording (beep)": "Начало записи события (звуковой сигнал)",
	"Scheduled reboots": "Запланированная перезагрузка",
	Safe: Safe$3,
	Reckless: Reckless$3,
	Inattentive: Inattentive$3,
	"Highest(Extreme)": "Наивысшее (сверхвысокое)",
	"Public cameras": "Общественные камеры",
	List: List$3,
	Usage: Usage$3,
	"Video playbacks and downloads": "Воспроизведение и загрузка видео",
	"of 100 times": "/100 раз",
	"of 10 minutes": "/10 мин.",
	Profile: Profile$3,
	"Search geofences": "Поиск по геозонам",
	"Export CSV": "Экспорт CSV",
	"Exit fullscreen": "Выход из полноэкранного режима",
	Fullscreen: Fullscreen$3,
	Upgrade: Upgrade$3,
	"Email address": "Адрес эл. почты",
	"of Unlimited": "из неограниченного",
	"No notifications yet": "Никаких уведомлений, полученных за последние 7 дней.",
	"No videos yet": "Еще нет видео",
	Management: Management$3,
	Day: Day$3,
	Month: Month$3,
	"Welcome to the BlackVue_": "Добро пожаловать в BlackVue Cloud Viewer",
	"You can access BlackVue_": "Вы можете получить доступ к BlackVue Cloud в Интернете в любое время и в любом месте!",
	"Start tour": "Начать обзор",
	"Map view": "Карта",
	"Check the current_": "Получайте текущие данные о местоположении и скорости, используя GPS, ваши камеры и общедоступные камеры.",
	"Camera’s features": "Характеристики камеры",
	"Take a look_": "Ознакомьтесь с различными функциями камеры BlackVue, связанными с облаком.",
	"Visualize your vehicle’s_": "Просматривайте маршрут движения вашего автомобиля.",
	"Smart plan_": "Смарт-план: 90 дней, план для автопарка: 90 дней",
	"Create geofences and2_": "Создавайте геозоны и получайте уведомления в режиме реального времени.",
	"Got it": "Понятно",
	"Manage Fleet members": "Управление водителями автопарка",
	"Invite fleet members_": "Пригласите водителей автопарка и распределите их по группам.",
	"The moment the_": "Когда камера обнаружит удары, уведомления о них будут приведены здесь.",
	"Geofence Setup (Web)_": "Настройка геозон (веб/ПК) и оповещений",
	"Original file play_": "Воспроизведение исходных файлов доступно только при загрузке",
	"To get most_": "Для эффективной работы BlackVue Cloud Viewer ваша камера должна быть подключена к облаку. Загрузите приложение BlackVue и выполните легкое сопряжение, от добавления камеры до подключения к облаку!",
	"You haven’t driven_Today": "Вы еще не ездили на своем автомобиле сегодня. Совершите поездку на автомобиле с BlackVue, чтобы получить отчет о вождении.",
	"You haven’t driven_Month": "Вы еще не ездили на своем автомобиле в этом месяце. Совершите поездку на автомобиле с BlackVue, чтобы получить отчет о вождении.",
	"Fleet Plan only_": "Доступен только план для автопарка",
	"Overwrite locked event2_": "Перезаписывать заблокированные файлы событий при заполнении",
	"DMS’s New firmware_": "Доступна новая прошивка DMS",
	"Highest speed_report": "<b>Самая высокая скорость</b>\nНаибольшее значение скорости на основе данных, собранных в единицах счетчика. Преобразование единиц измерения км/ч и миль/ч\n\n<b>Средняя скорость<b/> (Расстояние / часы движения) х 3600 = средняя скорость. Например: (2622 / 1208 ) х 3600 = 7814,907\nкм/ч: только целое число, \nдесятичная запятая (точка) в значении скорости в милях в час определяет точность до 2 знаков после целого числа",
	"Choose a cloud_": "Выберите способ подключения к облаку",
	"You need an_": "Для связи с облаком требуется подключение к Интернету. Выберите устройство, которое будет использоваться для подключения к облаку.",
	"BlackVue SIM card": "SIM-карта BlackVue",
	"Support model_": "Поддерживаемая модель: DR750X-2CH LTE Plus (NA)",
	"3rd party SIM_": "Сторонняя SIM-карта",
	"Support model_SIM": "Поддерживаемая модель: DR750X-2CH LTE Plus, DR750-2CH LTE, CM100 LTE",
	"Wi-fi hotspot": "Точка доступа Wi-Fi",
	"Support model_Wifi": "Поддерживаемая модель: Все модели BlackVue",
	"How to connect_": "Как подключиться к облаку",
	"Download BlackVue application": "Загрузите приложение BlackVue.",
	"*If you are_": "*Если вы собираетесь использовать SIM-карту BlackVue для подключения к облаку, перейдите в {{a}} {{b}}.",
	"Place your phone_": "Поместите телефон рядом с камерой на расстоянии действия Bluetooth. Начните легкое сопряжение с помощью {{a}}.",
	"Back to camera_": "Назад к списку камер",
	"Upgrade for more_": "Смените план, чтобы получить больше функций!",
	"Upgrading the cloud_": "Смена облачного плана позволит вам использовать больше функций и управлять несколькими камерами. Хотите сменить план?",
	"Explore cloud plans": "Ознакомьтесь с облачными планами",
	Later: Later$3,
	"Successfully subscribed": "Подписка успешно оформлена!",
	"1GB data plan": "Тарифный план с объемом данных 1 ГБ",
	"First month free_": "Первый месяц бесплатно, <a>затем 10,99 долл. США в месяц</a>",
	"Next billing date": "Дата следующего платежа",
	"Once SIM card_": "Вы можете запустить функции BlackVue Cloud сразу после установки SIM-карты в камеру.",
	"Go to SIM_": "Перейти к управлению SIM-картой",
	"Manage your BlackVue_": "Управляйте своей SIM-картой BlackVue здесь!",
	"Recommended for BlackVue_": "Рекомендуется для держателей SIM-карт BlackVue",
	"Connect to cloud": "Подключение к облаку",
	"Enter BlackVue SIM_": "Введите номер ICCID SIM-карты BlackVue",
	"ICCID number is_": "Номер ICCID указан на упаковке SIM-карты. Введите последние 14 цифр номера ICCID.",
	ICCID: ICCID$3,
	"SIM information": "Информация SIM-карты",
	"Start your free_": "Начать бесплатный пробный период сейчас",
	"SIM card activate_": "Дата активации SIM-карты",
	"Based on the_": "Зависит от даты, когда SIM-карта была вставлена в камеру и активирована при подаче питания",
	"Upgrade to 3GB_": "Переход на планы 3 ГБ/5 ГБ в любое время",
	"Cancel your plan_": "Отмена плана в любое время",
	"No Commitment": "Без каких-либо обязательств",
	"Precautions for using_": "Меры предосторожности при использовании услуги",
	"After 1GB is_": "После исчерпания лимита в 1 ГБ доступ в Интернет будет недоступен.",
	"If you have_": "Если вы уже вставили SIM-карту в камеру, бесплатный пробный период начинается с того момента, когда вы начинаете использовать SIM-карту.",
	"This content is_": "Эта информация указана в комплекте SIM-карты. Мы не выплачиваем компенсацию за бесплатные периоды, которые не были предоставлены.",
	"If you have_2": "Если у вас есть дополнительные вопросы, обратитесь в <a>службу поддержки</a>",
	"When OFF, connecting_": "В выключенном состоянии подключение камеры с помощью легкого сопряжения невозможно.",
	"1 month free": "1 месяц бесплатно",
	"No commitment. Cancel_": "Без каких-либо обязательств. Возможность отмены в любое время.",
	"The video has been reported_": "Жалоба на видео отправлена",
	"Free for 1 month": "Бесплатно 1 месяц",
	"Start your free_2": "Начать бесплатный пробный период",
	"1GB free for_": "1 ГБ бесплатно в течение {{a}} дн.",
	"1GB data": "1 ГБ данных",
	"1 month free_2": "Месячный бесплатный пробный период, включающий 1 ГБ данных для SIM-карты Blackvue, начнется {{a}}.",
	"Your next billing_": "Дата следующей оплаты: {{a}}",
	"SIM card": "SIM-карта",
	"SIM guide": "Руководство к SIM-карте",
	"SIM card list": "Список SIM-карт",
	"Add SIM card": "Добавить SIM-карту",
	"No SIM card_": "SIM-карты еще нет",
	"Search SIM ICCID_": "Поиск по ICCID или имени SIM-карты",
	"Cloud disconnected. Failed_": "Нет подключения к облаку. Ошибка воспроизведения видео",
	"This sim card_": "Эта SIM-карта уже зарегистрирована в другом аккаунте.",
	"Incorrect BlackVue SIM_": "Неверный номер ICCID SIM-карты BlackVue",
	"My shared videos": "Мои опубликованные видео",
	"Number of events": "Количество событий",
	"Added to Event Map": "Добавлено на карту событий",
	"Successfully added video(s)_": "Видеозаписи добавлены на карту событий! Если вы хотите выполнить какие-либо операции с добавленными видео или проверить их статус, перейдите в раздел «Карта событий» > «Мои опубликованные видео».",
	"Already added to_": "Уже добавлены на карту событий",
	"This video(s) is already added_": "Эти видео уже добавлены на карту событий! Если вы хотите выполнить какие-либо операции с добавленными видео или проверить их статус, перейдите в раздел «Карта событий» > «Мои опубликованные видео».",
	"BlackVue’s firmware is up_": "Прошивка BlackVue обновлена",
	"Service end": "Завершение обслуживания",
	Resubscribe: Resubscribe$3,
	"Sort ascending": "Сортировка по возрастанию",
	"Sort descending": "Сортировка по убыванию",
	plan: plan$3,
	USD: USD$3,
	"Are you sure_Cancel": "Вы действительно хотите отменить подписку? Обратите внимание на следующие замечания и подтвердите их ниже.",
	"Your current SIM_": "Ваша текущая подписка на SIM-карту закончится {{a}}, и с вас больше не будет взиматься плата.",
	"After canceling your_": "После отмены подписки на SIM-карту вы можете продолжать использовать ресурс передачи данных SIM-карты до даты окончания подписки.",
	"You can resubscribe_": "Вы можете снова оформить подписку в течение 1 месяца после окончания текущей подписки. Если вы хотите снова оформить подписку, нажмите кнопку «Снова оформить подписку» в списке SIM-карт {{a}}.",
	"Reason to cancel_": "Причина отмены подписки",
	"Found an alternative": "Найдено альтернативное решение",
	"Too expensive": "Слишком дорого",
	"Not required anymore": "Больше не требуется",
	"Quality issue": "Проблема с качеством",
	etc_: etc_$3,
	"Please describe in_": "опишите подробно",
	"SIM card cannot_": "SIM-карту нельзя удалить, так как ее подписка активна. Чтобы удалить эту SIM-карту, сначала отмените подписку.",
	"SIM card cannot_2": "SIM-карту нельзя удалить, так как ее подписка еще не закончилась. Повторите попытку после окончания подписки.",
	"Are you sure_deleteSIM": "Вы уверены, что хотите удалить эту SIM-карту?<br/>\n<b>Предупреждение: это действие нельзя отменить. Вся информация о вашей SIM-карте будет немедленно удалена.</b>",
	"ICCID number": "Номер ICCID",
	"Activation date": "Дата активации",
	"Current plan": "Текущий план",
	"Manage Plan": "Управление планом",
	"Next billing on": "Дата следующего платежа",
	"View Invoices": "Просмотр счетов",
	"Choose best plan_": "Выберите лучший план для вас",
	"Plan summary": "Краткий обзор плана",
	"Ends on_": "Завершается {{a}}",
	"Start from_": "Начинается {{a}}",
	"Your subscription will_": "Ваша подписка будет обновлена {{a}}, когда закончится срок действия вашего текущего плана.",
	"Resubscribe plan": "Продлить подписку на план",
	"Your subscription will2_": "Ваша подписка начнется {{a}}, когда закончится срок действия вашего текущего плана.",
	"Usage is estimated_": "Использование оценивается по состоянию на {{a}}",
	"Days left_": "Осталось дней: {{a}}",
	"Data usage cycle": "Цикл использования данных",
	Available: Available$3,
	Used: Used$3,
	"Data used": "Использованные данные",
	"Subscribe to n_": "Подписка на план с объемом данных {{a}} действует <b>с {{b}} до {{c}}</b>, а план с объемом данных {{d}}, применяется с {{e}}",
	"Will be charged_": "Оплата взимается с {{a}}",
	"Monthly usage": "Ежемесячное использование",
	"You have fewer_": "У вас осталось меньше данных за этот месяц!",
	"Get more data": "Получите больший лимит данных!",
	"This video cannot be shared": "Это видео не может быть опубликовано",
	"This is a video cannot be shared_": "Это видео не может быть опубликовано, потому что информация о движении не может быть найдена в настоящее время.",
	Cancelled: Cancelled$3,
	Terminated: Terminated$3,
	"Edit name": "Изменить имя",
	"Not connected to_2": "Не подключено к облаку. Удостоверьтесь, что камера и модуль подключения к Интернету включены.",
	"Some functionality is disabled_": "Некоторые функции недоступны, поскольку камера не подключена к облаку. Подключитесь к облаку <a>здесь</a>.",
	"If you want to cancel_": "Если вы хотите отменить план, нажмите <a>Отменить подписку</a>.",
	"Select plan": "Выбрать план",
	"Event map collects_": "Карта событий собирает и визуализирует информацию о событиях BlackVue для отображения ситуации на окружающих дорогах.",
	"Share your Live_": "Поделитесь событием в реальном времени, загрузив файл. Вы можете поделиться своими видео событий с другими пользователями.",
	"You can check_": "Вы можете посмотреть видео событий, которые опубликовали другие пользователи.",
	"Service end_": "Завершение обслуживания: {{a}}",
	"DMS camera recording_": "Запись с камеры DMS в режиме парковки",
	Sort: Sort$3,
	"Are you sure you want_": "Вы действительно хотите удалить общие видеозаписи с карты событий?",
	"Remove shared video": "Удалить общие видеозаписи",
	"Explore event map": "Ознакомьтесь с картой событий",
	"Event map": "Карта событий",
	"Explore the graphic_": "Ознакомьтесь с графической статистикой событий BlackVue, происходящих вокруг вас.",
	"You can filter_": "Вы можете фильтровать события и просматривать только те, которые вас интересуют.",
	"This video was removed by_": "Администратор удалил это видео в связи с жалобой.",
	Bonus: Bonus$3,
	"Your subscription plan": "Ваш план подписки",
	"Your free trial will_": "Ваш бесплатный пробный период продлится с {{a}}</br> <strong>до</strong> {{b}}.",
	"Total after free trial": "Всего после бесплатного пробного периода",
	"This sim card is_": "Эта SIM-карта больше не активна.",
	"Firmware is up_": "Прошивка обновлена",
	"Keep in mind": "Важно иметь в виду",
	"Once 1GB of_": "После исчерпания лимита в 1 ГБ данных эта услуга будет недоступна до следующей даты сброса данных [или до перехода на план более высокого уровня].",
	"After the SIM_": "Бесплатный пробный период начинается после установки SIM-карты в камеру и начала передачи данных.",
	"If you have_questions": "По всем вопросам обращайтесь в нашу <a>службу поддержки.</a>",
	"Data reset date": "Дата сброса данных",
	"To use SIM card_": "Чтобы использовать SIM-карту, обратитесь в <a>службу поддержки</a> BlackVue",
	"Go to Subscription": "Перейти к подписке",
	"An error occurred_subscription": "Произошла ошибка при подписке на выбранный план.",
	"Please try again": "Повторите попытку",
	"Failed to subscribe": "Не удалось оформить подписку",
	"Go to Pricing": "Перейти к расценкам",
	"SIM cards will_": "Когда SIM-карты станут доступными, они будут отображаться здесь.",
	"1GB for 1_": "1 ГБ на 1 месяц",
	"Pricing Data": "Расценки на передачу данных",
	"If you would like to check_": "Если вы хотите выполнить какие-либо операции с добавленными видео или проверить их статус, перейдите в раздел «Карта событий» > «Мои опубликованные видео».",
	"Connect to Cloud": "Подключение к облаку",
	"Completed!": "Завершено!",
	"Back to App": "Назад к приложению",
	"iOS in-app purchase": "Покупка в приложении iOS",
	"Android in-app_": "Покупка в приложении Android",
	"bonus n days": "Бонус: {{a}} дн.",
	"Want to contribute your_": "Разрешить автоматический обмен файлами при автоматической загрузке событий на карту событий?",
	"With event map_": "Вы можете поделиться видео при автоматической загрузке события с ближайшими водителями через карту событий.",
	"You can edit_3": "Вы можете в любое время изменить настройки автоматической загрузки файлов событий на карту событий, выбрав BLACKVUE CLOUD > Настройки камеры > Настройки конфиденциальности.",
	"If you want to remove videos_": "Личное видео может пересылаться, поэтому тщательно выбирайте данные, которыми хотите поделиться.",
	"Total events": "Всего событий",
	"Automatically add Live Event_": "Автоматический обмен файлами при автоматической загрузке событий на карту событий",
	"This camera is publicly_": "Эта камера открыта для общего доступа только в пределах ее местоположения.",
	incomplete_zip: incomplete_zip$3,
	"Live Event Upload_": "Для загрузки текущих событий (срок хранения: 7 дней)\nтребуется последняя версия прошивки",
	"Thank you for_2": "Благодарим за понимание.",
	"Start Web viewer": "Запустить средство веб-просмотра",
	"Are you sure_remove driver": "Действительно навсегда удалить данные водителя?",
	"An error occurred_sim": "При оформлении подписки произошла ошибка.",
	"Click the ADD SIM": "Нажмите кнопку «ДОБАВИТЬ SIM-карту» на странице списка SIM-карт, а затем снова выполните процедуру добавления SIM-карты.",
	"Set download options": "Настройка параметров загрузки",
	"Information may be_": "Information may be transmitted with a delay and may not reflect actual balances.",
	"Swipe left and right to move": "Проведите влево/вправо для перемещения",
	"Scheduled maintenance Notice": "Уведомление о плановом техобслуживании",
	"Our Cloud server_": "Наш облачный сервер будет проходить плановое техническое обслуживание.",
	"During that time_": "В это время облачные функции могут быть недоступны.",
	"Expected maintenance start_": "Ожидаемое время начала техобслуживания:",
	"Expected duration_": "Ожидаемая продолжительность: {{a}} ч.",
	"For more information_": "Для получения дополнительной информации см. <a>[Уведомление о техобслуживании сервера]</a>",
	"Do not remind_": "Больше не напоминать",
	"Cloud Server Maintenance": "Техобслуживание облачного сервера",
	"BlackVue Cloud Service_": "Служба BlackVue Cloud временно недоступна",
	"We are currently_": "В настоящее время мы проводим техобслуживание.",
	"We apologize for_": "Приносим извинения за неудобства.",
	"Driver Monitoring System (DMS)": "Система мониторинга водителя (DMS)",
	"Distracted occurs_": "Происходит, когда голова водителя отклоняется более чем на 50 градусов от передней части.",
	"Hand distraction event occurs_": "Происходит, когда рука водителя обнаруживается около головы на протяжении продолжительного времени (например, при курении, держании телефона и т. д.).",
	"Mask off event occurs_": "Происходит, когда водитель садится в автомобиль без маски или когда водитель снимает маску.",
	"DMS setting": "Настройка DMS",
	"The DMS system has_": "Система DMS объединяет прямоугольник обнаружения лица для состояний \"Обнаружено\", \"Не обнаружено\", \"Отвлечение\", \"Сонливость\", \"Маска снята\" и прямоугольник обнаружения движения для состояния \"Отвлечение рукой\".",
	"DMS detection": "Обнаружение DMS",
	"There are detection criteria for_": "Для каждого события есть критерии обнаружения. Пожалуйста, ознакомьтесь с руководством ниже.",
	"DMS camera recording_onoff": "Вкл: Камера DMS записывает в режиме парковки, пока поддерживается питание. <br/> Выкл: Камера DMS выключается вскоре после входа в режим парковки.",
	"LED lighting for each event_": "Светодиод на камере мониторинга водителя будет сигнализировать о каждом событии обнаружения (Отвлечение, Сонливость и т. д.).",
	"Drowsy and Distracted each have_": "Состояния «Сон» и «Отвлечение внимания» имеют три уровня чувствительности. См. руководство к интерфейсу ниже.",
	"DMS event detection sensitivity": "Чувствительность обнаружения событий DMS",
	"Only drowsy and distracted include_": "Настройки чувствительности доступны только для состояний «Сон» и «Отвлечение внимания». Кроме того, одна настройка устанавливает одинаковую чувствительность для двух событий.",
	"When driver’s eyes close_": "Происходит, когда водитель закрывает оба глаза во время вождения более 1 секунды или зевает в течение 2 секунд.\n",
	"n digit": "{{a}} -значный",
	"You are subscribed_free_Smart": "Вы оформили подписку на смарт-план BlackVue Cloud.",
	"Wi-Fi auto turn on": "Автозапуск Wi-Fi",
	"Video on a map": "Video on a map",
	"This feature is only_vom": "This feature is only available to users with a Fleet Plan subscription.<br/>Please subscribe to a plan to unlock this feature.",
	"Total n days_": "Всего {{a}} дней бесплатного испытания",
	"Every events of DMC200_": "Функции обнаружения DMS активны только в нормальном режиме. Если включен режим парковки, камера DMS записывает только видео.",
	"An undetected event occurs_": "Происходит, когда водитель не обнаруживается перед камерой в течение 1 минуты.",
	"A detected event occurs_": "A detected Event occurs when the driver is gazing in front since the power is set in the beginning.",
	"Drowsy sensitivity_": "High : When the driver closes their eyes for more than 1 second, it is considered drowsy driving.<br/><br/>Medium : When the driver closes their eyes for more than 1.5 second, it is considered drowsy driving.<br/><br/>Low : When the driver closes their eyes for more than 2 second, it is considered drowsy driving.",
	"Distracted sensitivity_": "High : If the angle of the head is more than 50 degrees away from the front for 3 seconds, it is detected as Distracted.<br/><br/>Medium : If the angle of the head is more than 50 degrees away from the front for 5 seconds, it is detected as Distracted.<br/><br/>Low : If the angle of the head is more than 50 degrees away from the front for 7 seconds, it is detected as Distracted.",
	"Start your subscription now": "Оформите подписку",
	"Free trial period has expired": "Бесплатный пробный период истек.",
	"1 data plan will start from_": "Платный план, включающий 1 ГБ данных для SIM-карты Blackvue, начнется с {{a}}.",
	"Allow the BlackVue_": "Предоставить приложению BlackVue доступ к данным GPS вашего видеорегистратора?",
	"We use this_": "Мы используем это для отслеживания местоположения и скорости автомобиля.",
	"You can edit_": "Вы можете изменить настройки доступа GPS в любое время в BLACKVUE CLOUD > Настройки камеры > Настройки конфиденциальности.",
	"SIM cards": "SIM-карты",
	"Subscription status": "Статус подписки",
	Upgrades: Upgrades$3,
	"Upgrade plan": "Перейти на новый план",
	"Manage plan": "Управление планом подписки",
	"Next plan": "План подписки на следующий месяц",
	OR: OR$3,
	"Cancel subscription": "Отменить подписку",
	Undo: Undo$3,
	Invoice: Invoice$3,
	"Daily usage": "Ежедневное использование данных",
	"Delete SIM": "SIM Удалить",
	"New card": "Новая кредитная карта",
	data: data$3,
	"SIM card data_": "Подписку на тарифный план использования данных SIM-карты можно отменить на сайте <a>sim.blackvuecloud.com</a>.",
	"Your plan from_": "Ваш план действует с сегодняшнего дня до следующей даты выставления счета.",
	"Applied during_": "Применено в течение {{a}} ~ {{b}}",
	"From today until_": "С сегодняшнего дня и до следующей даты оплаты вы можете подписаться только на тот же тарифный план, что и в предыдущем месяце. Счет за этот период будет выставлен сегодня. <a>Платежи рассчитываются на пропорциональной основе.</a>",
	"Choose your next plan": "Выберите следующий тарифный план",
	"Applied from_": "Применено с {{a}}",
	"Payment for this_": "Плата за этот план будет списана {{a}}.",
	"By sharing your_2": "Предоставив другим пользователям доступ к Live View, вы позволяете им следить за вашим путешествием из любой точки мира. Однако следует помнить, что Live View может содержать конфиденциальную информацию о вас.",
	"Option camera recording_": "Запись с дополнительной камеры в режиме парковки",
	"Front and option camera_": "Передняя и дополнительная камеры записывают видео одновременно.",
	"Option camera stops_": "Дополнительная камера останавливает запись через 5 минут после перехода в режим парковки. Запись возобновляется после перехода в нормальный режим.",
	"Option camera rotation": "Вращение дополнительной камеры",
	"Option camera": "Дополнительная камера",
	"Option camera security": "Защита дополнительной камеры",
	"Resubscribe until_": "Повторная подписка до: {{a}}",
	"Firmware Update Caution": "Предупреждение об обновлении прошивки",
	"Please check below_": "Перед обновлением прошивки DMC200 ознакомьтесь с приведенным ниже условием:",
	"The camera's Wi-Fi_": "На камере должен быть включен режим Wi-Fi.",
	"Check if your_": "Убедитесь, что сеть Wi-Fi камеры работает.",
	"DO NOT disconnect_": "НЕ ОТКЛЮЧАЙТЕ коаксиальный кабель во время обновления прошивки.",
	"The camera and_": "В противном случае камера и DMC200 могут быть повреждены.",
	"DO NOT try_": "НЕ ПЫТАЙТЕСЬ ИСПОЛЬЗОВАТЬ другие функции до завершения перезагрузки камеры.",
	"Expecially Reboot camera_": "Перезагрузка камеры и форматирование SD-карты может привести к сбою этих двух устройств.",
	"Update anyway": "Все равно обновить",
	"Invited on_2": "приглашен вами {{Invited Date}}. Владелец",
	"BlackVue’s New firmware_": "Доступна новая прошивка BlackVue",
	"valid thru_": "срок действия: {{a}}",
	"Billed monthly": "Billed monthly",
	"90 minutes Live_": "90 minutes Live View / Live Event Upload*",
	"or 2+ videos_": "or 2+ videos in full resolution*",
	"1GB Free Month_": "1GB Free Month Trial",
	"Cancel anytime": "Cancel anytime",
	"8+ hours Live_": "8+ hours Live View / Live Event Upload*",
	"or 12+ videos_": "or 12+ videos in full resolution*",
	"15+ hours Live_": "15+ hours Live View / Live Event Upload*",
	"or 23+ videos_": "or 23+ videos in full resolution*",
	Popular: Popular$3,
	"For Power Users": "For Power Users",
	"Estimates based on_": "* Estimates based on 4.5MB per minute of Live View, Quick View remote playback, or Live Event Upload file, and 190MB per full original resolution video download or playback (at 25Mbps bitrate). Daily idle Cloud connection data usage: 20MB per 24 hours. Data usage is shared among all types of services (Live View, Live Event Upload, etc.).",
	"Balanced Plan": "Balanced Plan",
	"For Light Cloud_": "For Light Cloud Use",
	"Front security (Normal mode)": "Безопасность спереди (обычный режим)",
	"Front security (Parking mode)": "Безопасность спереди (режим парковки)",
	"BT (Parking mode)": "Bluetooth (режим парковки)",
	"LTE (Parking mode)": "LTE (режим парковки)",
	"Wi-Fi (Parking mode)": "Wi-Fi (режим парковки)",
	"Hand distraction": "вождение без рук",
	Mask: Mask$3,
	"Second drowsy is_": "Второе предупреждение о сонливости отправляется при возникновении аналогичного события в течение 30 секунд после первого события, запустившего запись в реальном времени.",
	"Second drowsy alert": "Второе предупреждение о сонливости",
	"BlackVue sim card_": "SIM-карту BlackVue можно использовать только в Канаде и США.",
	"Global support is coming soon.": "Скоро будет доступна международная поддержка.",
	"The video file not found_": "Видеофайл не найден, или возникла проблема во время воспроизведения. Повторите попытку.",
	"Start Voice Call": "Начать голосовой вызов",
	"End Voice Call": "Завершить голосовой вызов",
	"Voice call in use": "Выполняется голосовой вызов",
	"Enable microphone access_": "Включите доступ к микрофону, чтобы использовать функцию двусторонней голосовой связи. Перейдите на страницу настроек браузера, чтобы разрешить доступ к микрофону.",
	"You may need to_": "Возможно, вам потребуется перезагрузить эту страницу, чтобы новые настройки вступили в силу.",
	"Eye status": "Состояние глаз",
	"Start time of live event upload video": "Время начала загрузки видео по событию в реальном времени",
	"Left eye": "Левый глаз",
	"Right eye": "Правый глаз",
	"Drowsy is occured when the driver close his/her eyes more then 1sec": "Состояние сонливости определяется, когда водитель закрывает глаза более чем на 1 секунду.",
	"Driver's Left eye movements with blinking count and period": "Движения левого глаза водителя с подсчетом числа миганий и времени закрытого состояния",
	"Driver's Right eye movements with blinking count and period": "Движения правого глаза водителя с подсчетом числа миганий и времени закрытого состояния",
	"Drowsy big data of the driver and after a Drowsy event occurs": "Большие данные о миганиях водителя после обнаружении события сонного состояния",
	"Sharing video to Event Map": "Поделиться видео на карте событий",
	"Want to use a Voice call?": "Воспользоваться голосовым вызовом?",
	"To use a voice call_": "Чтобы воспользоваться голосовым вызовом, перезапустите режим просмотра в реальном времени и нажмите «Разрешить».",
	"There is no_": "Пока нет общедоступных видео. \nСписок появится при общем доступе.",
	"Microphone blocked": "Микрофон заблокирован",
	"Want to center the map on your location?": "Хотите центрировать карту на вашем местоположении?",
	"To let the app access your location_": "Чтобы разрешить приложению доступ к вашему местоположению, перезапустите Event Map и выберите «ОК» при появлении запроса.",
	"Location access permission required": "Требуется разрешение на доступ к местоположению.",
	"Are you sure you want_2": "Вы уверены, что хотите удалить это видео с КАРТЫ СОБЫТИЙ?",
	"Two-way voice_2": "Two-way voice communication / Voice Call",
	"Not supported by DR650GW and DR650S_": "Not supported by DR650GW and DR650S",
	"DR650S Series only_": "DR650S Series only",
	"Cancel download?": "Отменить загрузку?",
	"Your download is not_": "Загрузка не завершена. Действительно отменить загрузку?",
	"Continue download": "Продолжить загрузку",
	"Cancel download": "Отменить загрузку",
	"Share your video to the Event Map?": "Хотите опубликовать видео на карте событий?",
	"Afterwards, according to the reaction to the video_": "Впоследствии, в зависимости от реакции на видео, его можно классифицировать как популярное и ввести в новый тренд на карте.",
	"Add hashtags and a brief description to describe your video.": "Добавьте хэштеги и краткое описание для вашего видео.",
	"Would you like_": "Хотите опубликовать на карте событий?",
	"Successfully added video_": "Видеозаписи добавлены на карту событий!",
	"This video cannot_": "Это видео не может быть опубликовано, потому что в нем отсутствуют данные GPS о местоположении для закрепления на карте.",
	"This video is_": "Эти видеозаписи уже добавлены на карту событий.",
	"Share to Event Map": "Опубликовать на карте событий",
	"Describe in more_": "Опишите подробнее, что происходит в вашем видео (необязательно)",
	"Description(optional)": "Описание (необязательно)",
	"Recording mode": "Режим записи",
	"Event triggers": "Триггеры событий",
	DMS: DMS$3,
	"Camera connectivity": "Подключение камеры",
	"If not allowed_2": "Без вашего разрешения местоположение и скорость автомобиля не будут доступны в облаке.",
	"Share Live View_": "Предоставить видео в реальном времени",
	"Share Live View_2": "Предоставить аудио в реальном времени",
	"Share camera profile": "Разрешить общий доступ к профилю камеры",
	"Parking impact": "Удар на парковке",
	"Parking events": "Parking Events",
	"Audio recording": "Запись звука",
	"Toggle the mic_": "Включение/выключение микрофона",
	"Full HD_": "Full HD @ 60fps + Full HD @ 30fps",
	"Video quality": "Качество видео",
	Extreme: Extreme$3,
	"More video files": "Больше записанных файлов",
	"Fewer video files": "Меньше записанных файлов",
	"Camera rotation": "Поворот задней камеры",
	"Video overlay": "Наложение видео",
	"Date & time display": "Дата и время",
	"Speed unit": "Единица измерения скорости",
	"Check the orientation_": "Проверьте ориентацию передней камеры, установленной в автомобиле. Выберите соответствующий параметр, чтобы записывать видео в вертикальном положении.",
	"Rotate 180º": "Поворот на 180º",
	"Rear camera rotation": "Поворот задней камеры",
	"Check the orientation_rear": "Проверьте ориентацию задней камеры, установленной в автомобиле. Выберите соответствующий параметр, чтобы записывать видео в вертикальном положении.",
	"Mirror View": "Зеркальное отображение",
	"Select Mirror View_": "Выберите режим зеркального отображения, чтобы перевернуть видео по горизонтали.",
	"Check the orientation_interior": "Проверьте ориентацию дополнительной камеры, установленной в автомобиле. Выберите соответствующий параметр, чтобы записывать видео в вертикальном положении.",
	"Display off": "Отображение выкл.",
	"Explore crowd-sourced Events_": "Изучайте на карте события краудсорсинга (столкновения, случаи резкого торможения и т. д.), просматривайте видео, которые публикуют пользователи, и публикуйте свои собственные события.",
	OFF: OFF$3,
	"Reboots once-a-day_": "Перезагрузить один раз в день в режиме Парковки для улучшения стабильности работы устройства.",
	"Set time": "Установить время",
	"FW language": "Язык прошивки",
	"Rear security_2": "Задний индикатор безопасности",
	"Bluetooth (Parking mode)_2": "Bluetooth (режим парковки)",
	"Failed to save_2": "Не удалось сохранить параметры загрузки текущих событий",
	"Event file will_": "Файл события будет автоматически сохранен в хранилище для загрузки текущих событий.",
	"An impact was_": "An Impact was detected during Parking Mode.",
	"When exiting Parking_": "При выходе из режима парковки приложение BlackVue сообщит, было ли обнаружено столкновение во время парковки. \n\nПримечания. \nПри столкновениях создаются видео событий. Столкновения, происшедшие в течение 3 минут до и после выхода из режима парковки, игнорируются.",
	"Protect event files": "Защитить файлы событий",
	"Turning on this_": "Включите эту функцию, чтобы защитить последние файлы событий ({{a}}) от перезаписи обычными файлами или записями на парковке.",
	"Impact Events in_": "Impact Events in Normal(E) and Parking Mode(I)",
	"Manual Events_": "Manual Events (M)",
	"Once 50 Events_": "Защищенные файлы включают: \n\nСобытия столкновений в обычном режиме (E) и режиме парковки (I) \nСобытия, записанные вручную (M) \n\nПосле записи {{a}} событий, новые события будут записываться поверх самых старых.",
	"Reckless driving unit": "Предупреждение о неосторожном движении",
	"Hard acceleration Event": "Событие резкого ускорения",
	Threshold: Threshold$3,
	"Triggers when the_": "Сигнализация срабатывает, когда камера обнаруживает, что ускорение превышает заданное пороговое значение.",
	"Triggers when the_2": "Сигнализация срабатывает, когда камера обнаруживает, что скорость торможения, превышает заданное пороговое значение.",
	"Hard braking Event": "Событие резкого торможения",
	"Triggers when more_": "Сигнализация срабатывает, когда камера обнаруживает изменение траектории на 60 градусов и более в течение 2 сек., когда параметр движения превышает заданное пороговое значение.",
	"Every event of DMC200_2": "Функции обнаружения DMS активны только в нормальном режиме. Если камера питается в режиме парковки, DMS-камера записывает только видео.",
	"The DMS system has_2": "Система DMS объединяет прямоугольник обнаружения лица для состояний “Обнаружено”, “Не обнаружено”, “Отвлечение”, “Сонливость”, “Маска снята” и прямоугольник обнаружения движения для состояния “Отвлечение рукой”.",
	"One for face_": "One for face detection : Detected, Undetected, Distracted, Drowsy",
	"The other for_": "The other for motion detection",
	"On: Normal recording_": "On: Normal recording works while power is maintained in Parking Mode",
	"Off: DMS power_": "Off: DMS power off after 5 minutes when entering Parking Mode, Normal recording works until just before off",
	"Drowsy and Distracted_": "Drowsy and Distracted each have three sensitivity conditions.",
	"Please refer to_": "Please refer to the guide interface below.",
	Drowsiness: Drowsiness$3,
	"Drowsiness occurs when_": "Сонливость возникает, когда водитель закрывает оба глаза во время движения более чем на 1 секунду и зевает 2 секунды.",
	"Distracted occurs when_": "Происходит, когда голова водителя отклоняется более чем на 50 градусов от передней части.",
	"A hand distraction_": "A hand distraction occurs when the driver removes one hand from the steering wheel. [*Smoking and phone calls may be suspected.]",
	"Mask off event_": "Mask-off event occurs in two ways. First is when the driver gets in the car without a mask. Second is when the driver takes their mask off",
	"High When the_": "High : When the driver closes their eyes for more than 1 second, it is considered drowsy driving.",
	"Middle When the_": "Medium : When the driver closes their eyes for more than 1.5 second, it is considered drowsy driving.",
	"Low When the_": "Low : When the driver closes their eyes for more than 2 second, it is considered drowsy driving.",
	"High If the_": "High : If the angle of the head is more than 50 degrees away from the front for 3 seconds, it is detected as Distracted.",
	"Middle If the_": "Medium : If the angle of the head is more than 50 degrees away from the front for 5 seconds, it is detected as Distracted.",
	"Low If the_": "Low : If the angle of the head is more than 50 degrees away from the front for 7 seconds, it is detected as Distracted.",
	Direct: Direct$3,
	"Camera Wi-Fi credentials": "Учетные данные камеры Wi-Fi",
	"Network name(SSID)": "Имя сети (SSID)",
	"Seamless pairing": "Seamless Pairing",
	Remote: Remote$3,
	"Hotspot settings": "Настройки точки доступа",
	"Hotspot name": "Название точки доступа (SSID)",
	"Hotspot name must_": "Hotspot name must be at least 5 characters long",
	"Public cameras may_": "Публичные камеры могут появляться на вкладке «Исследовать» или на карте мира.",
	"Hard Cornering Event": "Событие резкого маневрирования",
	"Over speed_2": "Превышение скорости",
	"Second drawiness alert": "Второе предупреждение о сонливом состоянии",
	"Low Voltage Warning_2": "Вождение без рук",
	"(You)_2": "{{а}} (Вы)",
	"This video has been reported_": "Администратор удалил это видео в связи с жалобой.",
	"Normal Mode recording": "Обычная запись",
	"ON : the camera_": "ВКЛ.: камера ведет запись непрерывно в циклическом режиме.",
	"OFF : the camera_": "ВЫКЛ.: камера записывает только видео при возникновении событий во время вождения.",
	"In both modes_": "В обоих режимах при обнаружении столкновения запускается видеозапись события.",
	"Continuously records_": "Запись ведется непрерывно со скоростью 1 кадр в секунду. При этом создаются 1-минутные видеоролики, которые охватывают 30 минут действия.",
	"Choose detection regions_": "Выберите области обнаружения, чтобы снизить риск запуска нежелательных записей при движении из-за деревьев, колышущихся на ветру, далеких движущихся объектов и т. д.",
	"Your previous plan is expired.": "Срок действия вашего предыдущего плана истек.",
	"Upgrade the plan to restore the camera": "Обновите тарифный план для восстановления камер\n(%@)",
	"Remove from cloud": "Удаление из облака",
	"Are you sure you want to Remove_": "Действительно удалить устройство из слота облака?",
	"Remove: It doesn’t mean_": "Удаление: эта операция приводит не к удалению данных камеры, а к созданию запасного слота для нескольких облачных камер.",
	"Now the camera is removed from cloud slot": "Камера была удалена из слота облака.",
	"How to delete camera list": "Процедура удаления камеры из списка",
	Update: Update$3,
	"Camrea setting": "Настройка камеры",
	"Notification setting": "Настройки push-уведомлений",
	"Driving reports": "Отчет о вождении",
	"Cloud connection steps": "Шаг подключения к облаку",
	"Download the BlackVue app to add a camera": "Загрузите приложение BlackVue, чтобы добавить камеру",
	"To see your camera in the BlackVue cloud viewer_": "Чтобы увидеть вашу камеру в средстве просмотра BlackVue Cloud Viewer, вы должны сначала подключить ее к облаку. Легко настраивайте камеру BlackVue и подключайте ее к облаку с помощью приложения BlackVue для iOS и Android.",
	"Download the BlackVue app to see a Wi-Fi connected camera": "Загрузите приложение BlackVue, чтобы увидеть камеру, подключенную по Wi-Fi",
	"BlackVue Cloud web viewer only supports_": "Средство веб-просмотра BlackVue Cloud поддерживает только видеорегистраторы, подключенные к облаку. Загрузите приложение BlackVue, чтобы увидеть видеорегистратор, подключенный по Wi-Fi.",
	"You can restore the data if_": "Вы можете восстановить данные, если снова зарегистрируете камеру с той же учетной записью, но если учетная запись удалена, все ваши файлы будут потеряны.",
	"How to add camera": "Порядок добавления камеры",
	"Try to wait 2-3 minutes if you just registered the camera.": "Если вы только что зарегистрировали камеру, подождите 2–3 минуты.",
	"Try to check the Cloud Connection Settings again_": "Если камера по-прежнему не подключается к облаку, еще раз проверьте настройки подключения.",
	"Motion Detection": "Обнаружение движения",
	"Parking recordings occur_": "Записи на парковке происходят при обнаружении видимого движения.",
	"Motion Sensitivity": "Чувствительность обнаружения движения",
	"Motion Detection Sensitivity": "Чувствительность детектора движения",
	"Select Detection Region": "Выбрать регион обнаружения",
	"Speed alert_2": "Оповещение скорости",
	"Live Event Upload_2": "Live Event Upload",
	"Beep Alert": "Звуковой сигнал",
	"Parking Impact History_": "Предупреждение из истории столкновений на парковке",
	"To register your_": "Чтобы зарегистрировать свою кнопку SOS, вы должны использовать приложение BlackVue.",
	"SOS button on/off": "Статус кнопки тревоги (SOS)",
	"File sharing to Event Map is_": "Обмен файлами с картой событий в настоящее время недоступен. Пожалуйста, зайдите позже.",
	"Email Notifications": "Уведомления по email",
	"Push Notifications_2": "Push-уведомление",
	"Optional Camera Rotation": "Ориентация дополнительной камеры",
	"Optional Camera Security": "Защита дополнительной камеры",
	Option: Option$3,
	"(Owner)": "{{a}} (Владелец)",
	"SOS button": "Кнопка тревоги (SOS)",
	"This video has been reported_bold": "Администратор <b>удалил это видео в связи с жалобой.</b>",
	"Number of events_2": "Количество событий",
	"My Shared Videos": "Мои опубликованные видео",
	"No Hashtags": "Нет хэштегов",
	"I have read and agree_": "Я ознакомился и согласен с условиями и политиками",
	"14 years old_": "14 лет и старше",
	Required: Required$3,
	Optional: Optional$3,
	"Profile information_": "Информацию о профиле можно отредактировать на странице настройки аккаунта.",
	"Automatically Add Live_": "Автоматический обмен файлами при автоматической загрузке событий на карту событий",
	"You must be 14 years_": "Для создания учетной записи BlackVue вам должно быть не менее 14 лет",
	"Use 8 or more characters_": "Используйте не менее 8 букв, цифр и специальных символов",
	"Protected files include_": "Защищенные файлы включают: <br/>ㆍСобытия столкновений в обычном режиме (E) и режиме парковки (I) <br/>ㆍСобытия, записанные вручную (M) <br/><br/>После записи {{a}} событий, новые события будут записываться поверх самых старых.",
	"Protected files include": "Protected files include",
	"If you turn_": "Если вы отключите голосовое сопровождение, отключатся следующие списки.",
	"Live Event Upload_success": "Настройки загрузки текущих событий сохранены.",
	"Video type": "Типы видео",
	"Notify the Owner": "Уведомить владельца",
	"Adjusting the cut-off voltage_2": "Adjusting the cut-off voltage to a lower setting may result in your dash cam draining more power from your battery. This could result in warning messages of battery drain or affect other vehicle functions.\nPlease consult with your dealership before lowering the voltage.",
	Others: Others$3,
	"This video has been removed.": "Это видео было удалено.",
	"Please assign cameras_": "Назначьте камеры для этой группы.",
	"Are you running_": "У вас больше нет возможности воспроизводить записи?",
	"Upgrade your plan_": "Перейдите на тарифный план «Автопарк» для неограниченного воспроизведения и доступа к другим эксклюзивным функциям облачного сервиса.",
	"Are you running_Liveview": "У вас заканчивается время для просмотра в реальном времени?",
	"Upgrade your plan_Liveview": "Перейдите на тарифный план «Автопарк» для неограниченного просмотра в реальном времени и доступа к другим эксклюзивным функциям облачного сервиса.",
	Stay: Stay$3,
	"Go to Fleet Plan": "Перейти на тарифный план «Автопарк»",
	"It looks like the video file is being prepared. please try again later.": "Похоже, видеофайл готовится. Пожалуйста, повторите попытку позже.",
	"Oops!": "Ой!",
	"Please back up_": "Перед изменением этого параметра сделайте резервную копию всех важных записей.",
	"When you save_": "При сохранении настроек карта microSD будет отформатирована и все записи будут удалены для обеспечения стабильной работы.",
	"This is an unregistered_": "Это незарегистрированная электронная почта. Хотите перейти на страницу создания учетной записи?",
	"Camera name must_2": "Имя камеры должно быть от 5 до 32 символов.",
	"G-sensor (Normal mode)": "Гироскоп (Обычный режим)",
	"G-sensor (Parking mode)": "Гироскоп (режим парковки)",
	"Up & down": "Вверх и вниз",
	"Front & back": "Спереди и сзади",
	"Rotate Video 180º": "Rotate Video 180º",
	Mask_2: Mask_2$3,
	"Priority event": "Priority Event",
	"There is no_camera": "There is no camera that your owner assigned to you.",
	"Camera SSID": "Camera SSID",
	"The BlackVue dashcam_2": "The BlackVue dashcam is not compatible with 5GHz wireless networks",
	"Driver detection box_2": "Driver Detection Box",
	"DMS camera recording_2": "DMS Camera Recording in Parking Mode",
	Low_2: Low_2$3,
	Medium_2: Medium_2$3,
	High_3: High_3$3,
	"Live Event Upload_3": "Live Event Upload",
	"Driving Impact": "Driving Impact",
	"Video source_2": "Video Source",
	"Front camera_2": "Front Camera",
	"Rear camera_2": "Rear Camera",
	"Optional Camera": "Optional Camera",
	"Motion Detection_2": "Motion Detection",
	"Rear camera stops_2": "Rear camera stops recording 5 minutes after entering Parking Mode. Recording restarts when entering normal mode.",
	"Passenger vehicle": "Passenger Vehicle",
	"Heavy vehicle": "Heavy Vehicle",
	Highest_3: Highest_3$3,
	Extreme_2: Extreme_2$3,
	"Less recording files": "Fewer Recording Files",
	"Camera rotation_2": "Camera Rotation",
	"Share camera profile_2": "Share Camera Profile",
	Private_2: Private_2$3,
	"BlackVue Live": "BlackVue Live",
	"Important All saved_": "Important! All saved videos are about to be deleted. Tap Cancel and back up important files if needed.",
	"Whenever saving settings_": "Whenever saving settings after changing the time zone, the SD card is initialized and all stored files are deleted.",
	"Do you want_": "Do you want to save your changes?",
	"No groups": "No groups",
	Lite: Lite$3,
	"USD per Camera": "USD per extra Camera",
	"up to Cameras": "up to Cameras",
	"All the P Plan_": "Все функции плана <b>{{a}}</b>, плюс:",
	"User Roles and Permissions": "Роли и права пользователя",
	"Geofence Setup (Web) and alerts": "Geofence Setup (Web) and alerts",
	"N Times": "{{a}} Раз",
	"N Minutes": "{{a}} Минут",
	"Emergency Alarm": "Аварийная сигнализация",
	"Playback, Live View": "Воспроизведение, Live View",
	"Your driving record : Daily, Monthly": "Ваша водительская история: Ежедневно, Ежемесячно",
	"Real-time Conversation": "Разговор в реальном времени",
	"Initiate a conversation_": "Инициируйте разговор с драйвером через динамик и микрофон Dashcam.",
	"Remote Voice Communication": "Отдаленное голосовое общение",
	"See the last location_": "Смотрите последнее местоположение вашей камеры",
	"Check your cars_": "Проверьте данные GPS вашего автомобиля в реальном времени на карте, чтобы найти свой автомобиль и получить информацию о его статусе, например, о том, управляет ли он или припаркован, и его скорость.",
	"Supported models_": "* Поддерживаемые модели: S и модели ранних серий X",
	"GPS Tracking &_": "GPS -отслеживание и видео на карте (Smart/Fleet)",
	"Track your cars_": "Отслеживайте местоположение и скорость вашего автомобиля на карте!",
	"GPS Tracking: visualize_": "GPS -отслеживание: визуализируйте журнал вождения на карте.\nВидео на карте: Просмотреть контекстную информацию (скорость, тип события) и воспроизвести связанные видео прямо с карты.",
	"Visualize your cars_": "Визуализируйте местоположение и скорость вашей машины на карте!",
	"The feature enables_": "Эта функция позволяет загружать видеозаписи в облако, включая 5 секунд до аварии.",
	"Camera profile setting": "Camera profile setting",
	"Are you running_Download": "Are you running out of chance to Download Video?",
	"Upgrade your plan_Download": "Upgrade your plan to Fleet Plan for Unlimited Download, and other Cloud -Exclusive features.",
	"This feature is available for Smart and Fleet_": "This feature is available for Smart and Fleet Plan subscribers only.",
	"Rear camera will keep_": "Задняя камера прекращает запись в режиме парковки, когда статус температуры видеорегистратора меняется на \"Высокая температура\". Задняя камера начнет запись снова после того, как статус температуры видеорегистратора будет изменен на \"Нормальная температура\". (Осторожно: Для защиты электроники Blackvue может выключиться из-за высокой внешней температуры).",
	"Get Unlimited Cloud_": "Получите неограниченный облачный просмотр и управляйте до {{a}} камер.",
	"Up to N cameras_": "Up to {{a}} cameras (+ {{b}} USD Extra charge)",
	"N Minutes per Day": "{{a}} минут в день",
	"Drowsiness sensitivity is_": "Чувствительность датчика сонливости задается по периоду моргания глаз с надежным алгоритмом BlackVue. <br> <br> Чувствительность датчика отвлечения внимания определяется по углу головы водителя относительно лобового стекла и длительностью такого положения.",
	"Not available with this plan": "Not available with this plan",
	"The optional camera records_": "Дополнительная камера записывает в режиме парковки",
	"Smart and Fleet_": "Smart and Fleet Plan<br/>subscribers only",
	"This feature is_smart": "This feature is available for Smart and Fleet Plan subscribers only.",
	"Camera Registration": "Регистрация камеры",
	"Voice Call": "Voice Call",
	"N times per Month": "{{a}} times per Month",
	"Recommended for higher bitrate_": "Рекомендуется для более высокого битрейта и лучшего качества видео.",
	"Recommended for for better compatibility_": "Рекомендуется для лучшей совместимости с рабочими и мобильными устройствами",
	"A minute of front camera_": "Расчетный размер файла за 1 -минутное видео (фронтальная камера)",
	"Extreme(N Mbps): N MB_": "Extreme ({{ex1}}Mbps) : {{ex2}}MB\nHighest ({{ht1}}Mbps) : {{ht2}}MB\nHigh ({{hi1}}Mbps) : {{hi2}}MB\nNormal ({{no1}}Mbps) : {{no2}}MB",
	"File size information reflects_": "Информация о размере файла отражает максимально возможный размер, и фактические размеры файлов могут варьироваться в зависимости от условий записи.",
	Bitrate: Bitrate$3,
	"Connection has been_": "Связь была потеряна.\nВосстановление соединения ...",
	"Unable to establish_": "Невозможно установить соединение с камерой.\nПожалуйста, убедитесь, что ваше устройство правильно подключено и попробуйте еще раз.",
	"Purchased by Payment Service": "Куплено через платёжный сервис",
	"Up to N Cameras": "До {{a}} камер",
	"Unlimited Live View": "Трансляции без ограничений",
	"N Days GPS Tracking": "Отслеживание GPS в течение {{a}} дней\n",
	"Unlimited Playback and Download": "Неограниченное воспроизведение и загрузка",
	hours: hours$3,
	"Live Event Upload or_": "Live Event Upload или 12+ видео в полном разрешении",
	"During the usage period of the One Plan_": "Во время использования услуги One Plan, изменения плана подписки невозможны. Чтобы переключиться на другой план, пожалуйста, свяжитесь с технической поддержкой BlackVue для отмены подписки на One Plan.",
	"Service Period (Include SIM Data)": "Период обслуживания (включает SIM-данные)",
	"Purchase the BlackVue One Package_": "Приобретите пакет BlackVue One, чтобы бесплатно получить доступ к One Plan на 1 год.",
	"3GB SIM Data Plan": "План SIM-данных на 3 ГБ",
	"Unlimited Live View, Playback and Download": "Неограниченный просмотр в реальном времени, воспроизведение и загрузка",
	"within data availability": "в пределах доступности данных",
	"The BlackVue One Plan is a 1-year_": "BlackVue One Plan - это годовой облачный сервисный план, доступный исключительно при покупке пакета BlackVue One, который включает видеорегистратор, 1-летний план данных 3 ГБ/мес (для США и Канады) и 1-летний план облачного сервиса.",
	"The BlackVue One Package is available_": "Пакет BlackVue One доступен исключительно в интернет-магазине BlackVue.",
	"Go to BlackVue Shop": "Перейти в магазин BlackVue",
	"Anonymous Cam": "Анонимная камера",
	"App only": "только в приложении",
	Expires: Expires$3,
	"N days remaining": "Осталось {{a}} дней",
	"No action needed_": "<b>Действий не требуется.</b> Новая сниженная цена будет автоматически применена, начиная с вашего следующего платежа после 13 сентября.",
	"The new reduced price_": "Новая сниженная цена будет автоматически применена к вашему аккаунту.",
	"Smart Plan Subscriber?": "Подписчик Smart Plan?",
	"Fleet Plan Subscriber?": "Подписчик Fleet Plan?",
	"Please take a moment to_": "Пожалуйста, уделите момент, чтобы разрешить нам мигрировать ваш аккаунт.",
	"Starting from now and_": "<b>Начиная с текущего момента и до 31 октября</b>, вы можете позволить нам внести изменения для вас, перейдя <a href=\"https://form.jotform.com/232411253056041\" target=\"_blank\">по этой ссылке</a> и введя свой электронный адрес аккаунта Fleet. Пожалуйста, дайте нам некоторое время на обработку изменений. Как альтернативу, вы сможете отменить ваш текущий аккаунт и снова подписаться по новой цене с 13 сентября.",
	"Once activated_": "После активации One Plan нельзя приостановить или деактивировать.",
	"Once the One Plan is activated_": "После активации One Plan нельзя вернуть деньги за One Package.",
	"Up to N Cloud Camera Slot": "До {{a}} слотов облачной камеры",
	"nGB of Cloud Storage": "{{a}}ГБ облачного хранилища",
	"Get started for free_": "Get started for free, no credit card required. Includes Alert Push Notifications, limited Remote Live View and cloud storage.",
	"The BlackVue One Plan is exclusively_": "The BlackVue One Plan is exclusively available through the purchase of a BlackVue One Package. 3GB/mo data plan is for US and Canada only. BlackVue Cloud’s Free Plan, Lite Plan (1~3) and Smart Plan (1~3) accounts can upgrade to One Plan. However, Lite Plan (4~15), Smart Plan (4~15) and Fleet Plan accounts can not be upgraded to One Plan.",
	"For N year": "For {{a}} year",
	"Included in the One Package": "Included in the One Package",
	"3GB SIM Data Plan for N year": "3GB SIM Data Plan for {{a}} year",
	"One Plan Cloud Service for N year": "One Plan Cloud Service for {{a}} year",
	"The BlackVue One Package includes_": "The BlackVue One Package includes all you need to enjoy BlackVue Cloud for a whole year!",
	"4K LTE Dash Cam_": "4K LTE Dash Cam, Cloud Service and Data Plan",
	"nGB included": "{{a}}GB included",
	"nGB per camera": "{{a}}GB per camera",
	"N Days Live Event Upload": "{{a}} Days Live Event Upload",
	"Up to N Dash Cameras": "Up to {{a}} Dash Cameras",
	"Step N/N": "Шаг {{a}}/{{b}}",
	"Cloud Connection": "Подключение к облаку",
	"To pair your dashcam": "Чтобы сопрячь вашу видеокамеру с батареей, подключите ее к облаку.",
	Check: Check$3,
	"Unpair Battery": "Отвязать батарею",
	"Are you sure you want to unpair": "Вы уверены, что хотите отвязать эту батарею (%@) от камеры?",
	"Unpair: It doesn't mean": "Отвязать: Это не означает удаление данных аккумулятора.",
	"*The paired battery will": "*Сопряженная батарея также будет удалена вместе.",
	"Would you like to pair this": "Хотели бы вы сопрячь эту батарею?",
	"Battery successfully paired": "Батарея успешно сопряжена.",
	"Now you can directly connect to": "Теперь вы можете подключиться напрямую к батарее из списка камер.",
	"Pairing failed": "Ошибка при сопряжении. Пожалуйста, попробуйте снова.",
	"Battery Name": "Название батареи",
	"Capacity History": "История емкости",
	"The graph displays capacity": "График отображает приблизительный уровень заряда батареи с использованием данных из облачного подключения.\n Емкость батареи может изменяться в зависимости от температуры, настроек автомобильной камеры и частоты срабатывания событий.",
	"Last 24 Hours": "Последние 24 часа",
	"Last 7 Days": "Последние 7 дней",
	"Battery Level": "Уровень заряда",
	"Temperature History": "История температуры",
	"The graph displays temperature": "График отображает приблизительный уровень температуры с использованием данных из облачного соединения.",
	"Temperature Level": "Уровень температуры",
	"Connecting alert": "[ Подключение ]\nДанные отображаются при подключении.",
	"Low Output power Alert": "[ Отключение выходной мощности ]\nВыходное напряжение слишком низкое, что ограничивает подачу питания подключенного устройства.",
	"High temp Alert": "[ Входное напряжение слишком низкое ]\nТемпература батареи слишком высокая, что ограничивает зарядку.",
	"Remaining time": "Оставшееся время",
	"Remaining time estimate": "Оставшееся время - это оценка на основе общего энергопотребления подключенных устройств.\n Пересчитывается каждые 30 секунд после подключения к батарее.",
	"Setting changed": "Настройка изменена",
	"Setting change failed": "Ошибка изменения настройки",
	"Low Input power Alert": "[ Входное напряжение слишком низкое ]\nНапряжение заряда слишком низкое, ограничивая зарядку.",
	"High Input power Alert": "[ Входное напряжение слишком низкое ]\nНапряжение заряда слишком высокое, что ограничивает зарядку.",
	"Low temp_Cut off Alert": "[ Входное напряжение слишком низкое ]\nТемпература батареи слишком низкая, что ограничивает зарядку и время работы.",
	"Low temp Alert": "[ Низкая температура ]\nТемпература батареи слишком низкая, что ограничивает время работы и скорость зарядки.",
	"Low capacity Alert": "[ Низкая емкость ]\nЕмкость батареи слишком низкая.\nВодите машину, чтобы зарядить ее.",
	"Back to list": "Вернуться к списку",
	Saving: Saving$3,
	Now: Now$3,
	"Power supplying is limited": "Поставка энергии <b>ограничена</b>",
	"This battery is already paired": "Этот аккумулятор уже спарен.",
	"Connecting to Battery": "Подключение к батарее",
	"Paired battery": "Сопряженный аккумулятор",
	"Battery unpairing failed": "Не удалось отменить сопряжение батареи. Пожалуйста, попробуйте снова.",
	"A connection is already active": "Соединение уже активно. Пожалуйста, попробуйте позже.",
	"Searching for battery": "Поиск батареи",
	"Select battery to pair with your camera": "Выберите батарею для сопряжения с вашей камерой.",
	"Unable to connect": "Невозможно подключиться",
	"A connection error has occurred": "Произошла ошибка подключения. Пожалуйста, попробуйте еще раз.",
	"The paired dashcam has been disconnected": "Связанный с дашкамом датчик отключен от Облака.\nПожалуйста, проверьте нижеприведенные условия.",
	"Check if the battery is not fully discharged": "Проверьте, не полностью ли разряжена батарея",
	"Check the Cloud connection of the paired dashcam": "Проверьте подключение облачного сервиса к подключенной автомобильной камере",
	"Connection lost": "Соединение потеряно",
	"A connection error has occurred shortly": "Произошла ошибка подключения. Пожалуйста, попробуйте подключиться в ближайшее время.",
	"Charging is limited": "Зарядка <b>ограничена</b>",
	"Cannot connect to the battery": "Невозможно подключиться к батарее.",
	"Please check the Cloud connection of the camera": "Пожалуйста, проверьте подключение к облаку камеры.",
	"Charging complete in": "Зарядка завершена за %@",
	"Current Capacity": "Текущая Емкость",
	"Output Voltage": "Выходное Напряжение",
	"Charging Voltage": "Напряжение зарядки",
	Beep: Beep$3,
	"Battery Capacity": "Емкость батареи",
	"Battery connection failed": "Сбой подключения батареи",
	"Expansion battery": "Запасная батарея",
	"Make sure it is switched on and within range": "• Убедитесь, что камера включена и находится в пределах досягаемости вашего мобильного телефона.",
	"Make sure it is not wirelessly connected to another device": "• Убедитесь, что она не подключена по беспроводной сети к другому устройству.",
	"Detected batteries": "Обнаруженные батареи",
	"Can't see your battery": "Не видите аккумулятор?",
	"Download the Blackvue app to check": "Загрузите приложение BlackVue чтобы удаленно проверить свою батарею",
	"By Using the app": "Используя приложение, вы можете сопрячьте вашу автомобильную видеокамеру с батареей и отслеживать ее емкость через облако. После сопряжения вы можете проверить батарею в облаке BlackVue.",
	Unpair: Unpair$3,
	"Occurs when the driver closes_": "Происходит, когда водитель закрывает оба глаза во время вождения",
	"Occurs when the driver's head_": "Происходит, когда голова водителя отклоняется более чем на 50 градусов от передней части.",
	"Only detects distraction above_": "Обнаруживает только отвлечение сверх установленного значения. Вы можете изменить единицу измерения в \"Настройка камеры > Триггеры событий > Предупреждение о неосторожном движении\".",
	"Occurs when the driver is not wearing_": "Происходит, когда водитель не носит ремень безопасности.",
	"Overlays a face detection box_": "Наложение рамки обнаружения лиц на прямую и записанную видеосъемку камеры DMS.",
	"Seat Belt": "Ремень безопасности",
	Detected: Detected$3,
	"No Seat Belt": "Нет ремня безопасности",
	"Fatigue Risk Alert": "Предупреждение о риске усталости",
	"The time is synchronized_Email": "Время синхронизировано со временем в ваших электронных уведомлениях.",
	"Sends an alert when drowsiness is_": "Отправляет предупреждение, когда обнаруживается сонливость после первой сонливости.",
	"Data updates upon connection": "Данные обновляются при подключении.",
	"Sends a notification if_": "Отправляет уведомление, если вы превысили 'Установленное время' во время поездки.",
	"Data updates Alert": "[ Подключение ]\nДанные обновляются при подключении.",
	"Cannot save settings": "Невозможно сохранить настройки",
	"The time is synchronized_Push": "Время синхронизировано со временем в ваших Push-уведомлениях.",
	"The file has been overwritten or deleted": "Файл был перезаписан или удален.",
	"Box Pro Models Settings": "Настройки моделей Box Pro",
	"Push notifications can be configured_": "Push-уведомления можно настроить в настройках уведомлений камеры.",
	"Recording Video": "Запись видео",
	"Cameras settings": "Настройки камер",
	"Please configure the settings": "Пожалуйста, настройте параметры",
	"Speed Priorities": "Приоритеты скорости",
	"Set Speed Priority": "Установить приоритет скорости",
	"Geofence-enter": "Геозона – въезд",
	"Geofence-exit": "Геозона – выезд",
	"Geofence-pass": "Геозона – проезд",
	"Geofence-speed alert": "Геозона – Оповещение скорости",
	"Drive Position": "Позиция водителя",
	"Left-Hand Drive": "Левостороннее управление",
	"Right-Hand Drive": "Правостороннее управление",
	"Please configure this setting_": "Пожалуйста, измените эту настройку, если водитель не обнаружен правильно.",
	"A new feature in the BlackVue settings_": "В настройки BlackVue добавлена ​​новая функция для синхронизации времени камеры. Вам следует синхронизировать время камеры один раз для точной записи времени.",
	"Feature location_": "Расположение объекта:\nНастройки камеры>Система>Синхронизация времени",
	"Time Sync": "Синхронизация времени",
	"You can sync the time between_": "Вы можете синхронизировать время между вашим устройством и камерой BlackVue. Для синхронизации требуется форматирование SD-карты. Перед продолжением, пожалуйста, сделайте резервное копирование всех необходимых видео.",
	"Voice Alert": "Голосовое оповещение",
	"Provides a voice alert_": "Предоставляет голосовое оповещение с камеры и отправляет уведомление, если вы превышаете установленное время во время поездки.",
	"Please enter a value": "Please enter a value.",
	"Notices & Notifications": "Новости и уведомления",
	"Only detects drowsiness above_": "Обнаруживает только сонливость сверх установленного значения. Вы можете изменить единицу измерения в \"Настройка камеры > Триггеры событий > Предупреждение о неосторожном движении\".",
	Promotion: Promotion$3,
	Notice: Notice$3,
	"View More": "Посмотреть больше",
	"Read More": "Читать далее",
	"Detection Box": "Коробка обнаружения",
	"Seatbelt Detection Box": "Коробка обнаружения ремня безопасности",
	"Drive Position Detection Box": "Коробка обнаружения положения водителя",
	"Fleet Subscription Promotion (50%)": "Акция по подписке на флот (50%)",
	"BlackVue Fleet Tracking exclusive features_": "Эксклюзивные функции BlackVue Fleet Tracking как для опытных пользователей, так и для предприятий (несколько пользователей и камер, геозоны, веб-просмотр и т. д.).",
	"Special Discount (50% off)": "Специальная скидка (скидка 50%)",
	"*Promotion applied for 12 months": "*Акция распространяется на 12 месяцев.",
	"*Payment will be made starting next month.": "*Оплата будет произведена со следующего месяца.",
	"[About using promotions]": "[Об использовании промоакций]",
	"The promotion is free for the first month_": "Промоакция бесплатна в течение первого месяца, а затем взимается плата в течение 12 месяцев, начиная со следующего месяца.",
	"For users with an existing Lite/Smart subscription_": "Пользователям с существующей подпиской Lite/Smart необходимо отдельно отменить существующую подписку на приложение, в противном случае с вашей учетной записи может быть снята стоимость существующей подписки на приложение.",
	"Please be sure to cancel your app subscription_": "Обязательно отмените подписку на приложение в течение бесплатного периода. Двойные платежи не возвращаются.",
	"You will be changed to Fleet Plan immediately_": "Вы будете немедленно переведены на план Fleet, даже если оставшийся срок подписки вашего существующего плана Lite/Smart еще не истек.",
	"You can cancel Fleet Plan any time.": "Вы можете отменить Fleet Plan в любое время.",
	"From February 2025, please go to the Fleeta service and use it.": "После отмены акции она не будет применена повторно.",
	"After promotion expires_": "По истечении срока действия акции вам будет автоматически продлена существующая плата за подписку на план Fleet Plan.",
	"(Required) I have read the promotion instructions_": "(Обязательно) Я прочитал инструкции по акции и согласен на оплату.",
	"Upgrade to Fleet Plan immediately": "Немедленно перейти на Fleet Plan",
	"Important Notice:": "Важное примечание:",
	"Switch of BlackVue Web Viewer to Fleeta Web Viewer": "Переключение BlackVue Web Viewer на Fleeta Web Viewer",
	"To provide better features and quality_": "Чтобы обеспечить лучшие функции и качество, служба веб-просмотра BlackVue вскоре перейдет на новую службу веб-просмотра для автопарков под названием Fleeta. Услуги Fleeta будут эксклюзивными только для пользователей Fleet Plan. Сервис Fleeta будет запущен в марте 2025 года с новым эксклюзивным приложением Fleeta. Посетите <a href=\"https://www.fleeta.io\" target=\"_blank\">fleeta.io</a>, чтобы узнать больше.",
	"We kindly ask for your understanding_": "Просим вашего понимания, поскольку данное изменение призвано улучшить качество обслуживания. По любым вопросам, касающимся этого перехода, обращайтесь в наш центр CS.",
	"Don’t show this again for this month": "Больше не показывать это в этом месяце",
	"Fleet Plan Subscription Promotion": "Акция по подписке на план флота",
	"Period : December 2, 2024 ~ May 31, 2025": "Период: 2 декабря 2024 г. ~ 31 мая 2025 г.",
	"See more details": "Посмотреть более подробную информацию",
	"To continue improve quality and provide better service_": "Чтобы продолжать улучшать качество и предоставлять лучший сервис, наша служба BlackVue Web Viewer вскоре перейдет на эксклюзивную услугу Fleet Plan. С конца марта 2025 года он больше не будет доступен бесплатно или в рамках других планов.",
	"We have prepared special discount offers for_": "Мы подготовили специальные скидки для наших существующих пользователей Web Viewer. Пожалуйста, проверьте детали ниже! Мы просим вашего понимания и поддержки при внедрении этого изменения, чтобы обеспечить лучший сервис.\n",
	"*If you are subscribed in-app_": "*Если вы подписаны в приложении, обязательно отмените подписку в приложении.",
	"Enjoy your BlackVue Cloud service with your dashcam.": "Наслаждайтесь облачным сервисом BlackVue с помощью видеорегистратора.",
	"Available Cloud Camera slot(s)_": "Доступные слоты для облачной камеры: {{d}}",
	"Not eligible for the promotion.": "Не имеет права на участие в акции.",
	"You have already used_": "Вы уже воспользовались этой акцией. После отмены акции ее нельзя будет применить повторно.",
	"Go to Cameras": "Перейти к камерам",
	"Congratulations !": "Congratulations !",
	"Fleet Plan user": "Fleet Plan user",
	"Let your BlackVue monitor_": "Позвольте вашему BlackVue контролировать ваш автомобиль и предупреждать вас о происшествиях. В момент обнаружения воздействия ваш BlackVue отправит на ваш телефон уведомление, сопровождаемое снимком.\n",
	"Live Event Upload feature automatically_": "Функция загрузки событий в реальном времени автоматически загружает видеоматериалы, в том числе кадры до аварии, в облачное хранилище BlackVue, чтобы обеспечить безопасность ваших видео!",
	"*Buffer time varies by model.": "*Время буфера зависит от модели.",
	Explore: Explore$3,
	"Cloud Storage": "Облачное хранилище",
	"My Cloud Cameras": "Мои облачные камеры",
	"My Cloud Cameras Only": "Только мои облачные камеры",
	"BlackVue Live Camera": "Живая камера BlackVue",
	"*For BlackVue Live Cameras_": "*Для камер BlackVue Live на карте можно просматривать только те камеры, которые в настройках камеры указаны как общедоступные.",
	"*Share Method_": "*Метод обмена: Настройки камеры>Конфиденциальность.",
	"Once the promotion is canceled_": "После отмены акции она не будет применена повторно.",
	"It will show_": "Он появится здесь, когда они станут доступными.",
	"Deactivate Cloud": "Деактивировать облако",
	"Are you sure you want to deactivate_": "Вы уверены, что хотите отключить Cloud для этой камеры?",
	"Deactivate : It doesn’t_": "Вы всегда можете активировать облако в любое время. Камеру можно удалить после завершения деактивации.",
	Deactivate: Deactivate$3,
	"*If you made the payment through_": "*Если вы произвели оплату через приложение, перезапустите приложение.",
	"Connect Dashcam Locally (Wi-Fi)": "Подключите видеорегистратор локально (Wi-Fi)",
	"Cloud Connection Setting": "Настройка подключения к облаку",
	"Camera Profile": "Профиль камеры",
	"Camera Settings": "Настройка камеры",
	"Format MicroSD Card": "Форматирование карты microSD",
	"Remote Firmware Update": "Удаленное обновление прошивки",
	"Remove from Cloud": "Удалить из облака",
	"The location may not be accurate_": "Местоположение может быть неточным, поскольку камера не подключена к облаку.",
	"The location of the camera cannot be found_": "Невозможно определить местоположение камеры. Пожалуйста, проверьте настройки подключения к облаку.",
	"Manage\nFLEETA Drive": "Управление\nFLEETA Диск",
	"Cloud\nConnection": "Облачное\nсоединение",
	"Available on FLEETA App": "Доступно в приложении FLEETA",
	"Available for Cloud dashcam OR on FLEETA App.": "Доступно для облачного видеорегистратора ИЛИ в приложении FLEETA.",
	"Get started with_": "Начните с бесплатной пробной версии на 1 месяц",
	"Experience all of_": "Испытайте все премиум функции FLEETA бесплатно в течение вашего месячного пробного периода.\n\nБез обязательств—отмена в любое время",
	"Welcome to FLEETA Webviewer.": "Добро пожаловать в FLEETA Webviewer.",
	"Let FLEETA get_": "Позвольте FLEETA узнать вас",
	"Help improve your_": "Помогите улучшить ваш опыт, поделившись некоторыми данными",
	"Business Industry": "Отрасль бизнеса",
	"Vehicle & Cargo": "Транспортные средства и груз",
	Compliance: Compliance$3,
	"Would you like to skip?": "Хотите пропустить?",
	"What is your business industry?": "В какой отрасли работает ваш бизнес?",
	"Transportation & Logistics": "Транспорт и логистика",
	"Rental & Leasing": "Аренда и лизинг",
	"Construction & Building": "Строительство",
	"Government & Public": "Государство и общественность",
	"Facility & Utility Management": "Управление объектами и коммунальными услугами",
	Manufacturing: Manufacturing$3,
	"Retail & Wholesale": "Розничная и оптовая торговля",
	Emergency: Emergency$3,
	Security: Security$3,
	"How many employees do you need to manage?": "Сколько сотрудников вам нужно управлять?",
	"How many vehicles does your company operate?": "Сколько транспортных средств эксплуатирует ваша компания?",
	"Why do you use a fleet tracking service?": "Почему вы используете услугу отслеживания автопарка?",
	"Route Tracking": "Отслеживание маршрута",
	"Real-time Monitoring": "Мониторинг в реальном времени",
	"Incident Detection & Check video": "Обнаружение инцидентов и проверка видео",
	"Behavior Monitoring & Analysis": "Мониторинг и анализ поведения",
	"Evaluation & Management": "Оценка и управление",
	"Theft Prevention": "Предотвращение краж",
	"Monitoring & Maintenance": "Мониторинг и обслуживание",
	"Verification & Management": "Проверка и управление",
	"BlackVue App Use Only": "Использование только в приложении BlackVue",
	"Your current plan allow_": "Ваш текущий тариф позволяет использовать приложение BlackVue. Чтобы использовать веб-просмотрщик, пожалуйста, подпишитесь на тарифный план Fleet (FLEETA).",
	"Learn more about the Fleet_": "Узнайте больше о плане для автопарка (FLEETA)",
	"Special Offer": "Специальное предложение",
	"For a limited time_": "На ограниченное время наслаждайтесь 50% скидкой на подписку на ваш План Флота.",
	"See Discount Details": "Посмотреть детали скидки",
	"To subscribe to the Fleet_": "Чтобы подписаться на план для автопарка, пожалуйста, сначала отмените вашу подписку на BlackVue в приложении, чтобы избежать двойных сборов.",
	"Skip tour": "Пропустить тур",
	"In the cloud_": "В облачной среде вы можете получить доступ к воспроизведению, просмотру в реальном времени (включая мультивид), живому GPS и отчетам, все через веб-просмотрщик FLEETA.",
	"Cloud Storage is_": "Облачное хранилище - это место, где ваши загруженные видео хранятся в безопасности в облаке. Загружайте свои видео, чтобы они оставались в безопасности на долгое время.",
	"Toggle to switch_": "Переключить для выбора Карта / Список",
	"In List View_": "В режиме списка вы можете легко просматривать и управлять группами, участниками и информацией о прошивке с первого взгляда.",
	"What is Cloud Storage?": "Что такое Облачное хранилище?",
	"Cloud Storage Overview": "Обзор Облачного хранилища",
	"Difference Between FLEETA_": "Разница между FLEETA Диск и Загрузка событий в реальном времени",
	"FLEETA Drive stores_": "FLEETA Диск хранит видео, которые вы загрузили вручную",
	"Live Event Upload automatically_": "Загрузка событий в реальном времени автоматически сохраняет видео, когда происходит событие.",
	"Live Event Upload videos_": "Видео Загрузка событий в реальном времени имеют срок хранения. Если вы хотите сохранить их на долгое время, переместите их на FLEETA Диск.",
	"Note: SD Card_": "Примечание: Видео на SD-карте в режиме Воспроизведения",
	"Videos stored on_": "Видео, сохраненные на вашей SD-карте, можно просмотреть через меню Воспроизведение.",
	"Set your image_": "Установите ваше изображение, используя предоставленную рамку. После сохранения изображение будет отображаться на карточке камеры и значке просмотра карты.",
	"*Only jpg and_": "*Поддерживаются только файлы jpg и png.",
	"Set as default image": "Установить как изображение по умолчанию",
	"Camera Details": "Детали камеры",
	"IT & Telecommunications": "ИТ и телекоммуникации",
	"The name must_32": "Имя должно содержать от 1 до 32 символов.",
	"Unable to display the map.": "Невозможно отобразить карту.",
	"The camera location cannot be found_": "Из-за плохого соединения GPS невозможно найти местоположение камеры.",
	"Cloud Cameras": "Облачные камеры",
	"Want to unlock_": "Хотите разблокировать функции управления автопарком?",
	"*Web subscription only": "*Только веб-подписка",
	"Uploads event_": "Мгновенно загружает видео событий в Облачное хранилище, как только событие происходит.",
	"Starts a conversation_": "Начинает разговор с водителем с использованием динамика и микрофона видеорегистратора.",
	"Remotely check_": "Удаленно проверьте уровень заряда и состояние батареи через облако.",
	"Receive a voice_": "Получите голосовое оповещение и уведомления, если время вождения превысит лимит.",
	"View your_": "Просмотрите ваш журнал вождения на карте.",
	"View speed, event_": "Просмотрите скорость, тип события и воспроизведите связанные видео прямо на карте.",
	"FLEETA Tracking exclusive_": "FLEETA Tracking предлагает эксклюзивные функции как для опытных пользователей, так и для бизнеса (Несколько пользователей и камер, геозоны и т.д.).",
	"Cloud Cameras per Account": "Облачные камеры на аккаунт",
	"Connect Dashcam Locally_": "Подключить видеорегистратор локально (Wi-Fi) (Воспроизведение, Загрузка, Просмотр в реальном времени)",
	"Available with_": "Доступно с батареей BlackVue",
	"Cloud Battery": "Облачная батарея",
	"Driving Reports": "Отчеты о вождении",
	"Video on Map": "Видео на карте",
	"Multi Live View (Fleeta Web Viewer)": "Мульти Просмотр в реальном времени (Веб-просмотрщик FLEETA)",
	"Enter a number": "Введите число",
	"Permission required.": "Требуется разрешение.",
	"Please contact_": "Пожалуйста, свяжитесь с владельцем для получения помощи.",
	"Access not available": "Доступ недоступен.",
	"This file cannot be deleted now.": "Этот файл сейчас не может быть удален.",
	"Please try again later.": "Пожалуйста, попробуйте позже.",
	"Permission required.\nPlease_": "Требуется разрешение.\nПожалуйста, свяжитесь с владельцем для получения помощи.",
	"Cloud Storage is disconnected_": "Облачное хранилище отключено. Пожалуйста, проверьте соединение.",
	"Manage the plan_": "Управление планом по восстановлению камеры",
	"Notify the owner_": "Уведомьте владельца о необходимости управления планом",
	"Access Restricted:_": "Доступ ограничен: подписка истекла",
	"Access is currently_": "Доступ в настоящее время недоступен из-за истекшей подписки.",
	"Please contact your owner_": "Пожалуйста, свяжитесь с вашим владельцем для решения этой проблемы.",
	"Access will be_": "Доступ будет восстановлен после продления подписки",
	"Cloud is disconnected_": "Облачное хранилище отключено. \nПожалуйста, проверьте соединение.",
	"Connect to Cloud with_": "Подключитесь к Облачное хранилище с помощью FLEETA APP",
	"Using Wi-Fi Hotspot": "Использование Wi-Fi точки доступа",
	Important: Important$3,
	"Pre-Event buffer_": "В этом режиме предварительная запись буфера событий отключена.",
	"connectivity is_": "В этом режиме подключение ограничено.",
	"video upload starts_": "Загрузка видео начинается после завершения записи.",
	"Power Saving": "Энергосбережение",
	"In all modes_": "Во всех режимах обнаруженные удары запускают запись видео событий.",
	"Battery Protection setting _": "Настройка защиты батареи должна быть ВКЛЮЧЕНА.",
	"At least one of_": "По крайней мере одна из следующих настроек должна быть включена",
	or: or$3,
	"For BlackVue battery users": "Для пользователей батарей BlackVue",
	"we recommend setting_": "Мы рекомендуем установить порог отключения напряжения на минимальное значение для максимального использования батареи.",
	"No videos were found.": "Видео не найдены.",
	"Try different filter_": "Попробуйте другой фильтр или сбросьте фильтр.",
	"Not avaliable with_": "Недоступно с текущей камерой",
	"Overlays a detection_": "Накладывает рамку обнаружения на живое и записанное видео с камеры DMS.",
	"A minute of_": "Минута видео с передней камеры будет примерно",
	"System voice guidance": "Голосовое руководство системы",
	"Recording trigger": "Триггер записи",
	"Remote Button (Optional)": "Дистанционная кнопка (необязательно)",
	"Remote button settings_": "Настройки удаленной кнопки не могут быть изменены через облачное соединение. Чтобы изменить эти настройки, перейдите в Камера > Подключить локально > Настройки камеры.",
	"No Registered Device": "Нет зарегистрированных устройств",
	"Subscription process is complete": "Процесс подписки завершен",
	"Now, go back to_": "Теперь вернитесь в приложение FLEETA, войдите в свой аккаунт и начните пользоваться сервисом.",
	"You can check the upload progress": "Вы можете проверить прогресс загрузки во вкладке Облачное хранилище > FLEETA Диск.",
	"SIM card must be inserted in_": "Чтобы начать использовать Cloud, необходимо вставить SIM-карту в камеру.",
	"Active until:": "Активен до:",
	Subscribe: Subscribe$3,
	"Camera PSN": "Камера ПСН",
	"BlackVue Sim Free Trial Started!": "Бесплатная пробная версия BlackVue Sim началась!",
	"Enjoy a free period to use your SIM_": "Наслаждайтесь бесплатным периодом использования вашей SIM-карты без подписки!",
	"You can stay connected during the trial_": "Вы можете оставаться на связи во время пробного периода, но помните:",
	"Complete your subscription before the trial_": "Завершите подписку до окончания пробного периода, чтобы продолжить использование SIM-карты.",
	"If you don't subscribe by the end of the trial_": "Если вы не оформите подписку до конца пробного периода, ваша SIM-услуга будет деактивирована.",
	"Save Event Videos_": "Сохраняйте видео с мероприятий в облачное хранилище в режиме реального времени!",
	"Note: Deleting your account doesn’t cancel": "Примечание: удаление вашей учетной записи не отменяет вашу подписку. Чтобы отменить, перейдите в раздел Учетная запись > Подписка в веб-просмотрщике FLEETA.",
	"Available only on FLEETA App for_": "Доступно только в приложении FLEETA для этой модели.",
	"The cloud is deactivated": "Облако деактивировано.",
	"Please add a camera with FLEETA_": "Пожалуйста, добавьте камеру в приложение FLEETA для использования этой функции.",
	"Upload videos to FLEETA_": "Загрузите видео на FLEETA Диск и сохраните их в безопасности!",
	"You have no assigned camera_": "У вас нет назначенной камеры.\nПожалуйста, свяжитесь с владельцем, чтобы запросить назначение.",
	"Camera notification settings": "Настройки уведомлений камеры",
	Vehicle: Vehicle$3,
	"App Download": "Скачать приложение",
	"Have a problem with_": "Есть проблемы с подпиской?",
	"Restore Purchase": "Восстановить покупку",
	"Battery Pairing": "Сопряжение с аккумулятором",
	"Playback\nLive View": "Воспроизведение/\nПросмотр в реальном времени",
	"Remote Playback": "Удаленное воспроизведение",
	"Cloud connection settings": "Настройки подключения к Cloud",
	"Go to settings": "Настройки",
	"Only cloud cameras that_": "На карте отображаются только те облачные камеры, которые пользователи решили поделиться публично.",
	"Live Broadcast Cameras": "Камеры прямого эфира",
	"*Live Broadcast Cameras_": "*Камеры для прямых трансляций - это облачные камеры, настроенные пользователями для вещания.",
	"Only cloud cameras_": "На карте отображаются только те облачные камеры, которые пользователи решили транслировать."
};

var Dashboard$2 = "仪表板";
var Account$2 = "帐号";
var Help$2 = "帮助";
var Mac$2 = "Mac";
var Windows$2 = "Windows";
var Admin$2 = "管理员";
var Driver$2 = "司机";
var Cameras$2 = "摄影头";
var Manage$2 = "管理";
var Clear$2 = "删除选中";
var Show$2 = "显示";
var GB$2 = "{{a}}GB";
var _section$2 = "管理您的车队小组。";
var Name$2 = "名称";
var Password$2 = "密码";
var Cancel$2 = "取消";
var Members$2 = "成员";
var Groups$2 = "群组";
var Role$2 = "角色";
var Group$2 = "群组";
var Status$2 = "状态";
var nPM$2 = "下午 {{a}}";
var nAM$2 = "上午 {{a}}";
var Newest$2 = "最新";
var Oldest$2 = "最旧";
var Accepted$2 = "接受";
var Pending$2 = "待定";
var Expired$2 = "已过期";
var All$2 = "全部";
var Delete_$2 = "删除 {{a}}";
var Delete$2 = "删除";
var Rename$2 = "更换名称";
var Add$2 = "添加";
var OK$2 = "确定";
var Remove$2 = "删除";
var Files$2 = "文件";
var Features$2 = "特征";
var Settings$2 = "设置";
var Upload$2 = "上载";
var Privacy$2 = "隐私";
var Done$2 = "结束";
var Subscription$2 = "订阅";
var Submasters$2 = "管理员";
var Users$2 = "驾驶员";
var Change$2 = "更改";
var Method$2 = "方式";
var Details$2 = "摄像机信息";
var Confirm$2 = "确认";
var Address$2 = "地址";
var Country$2 = "国家/地区";
var State$2 = "州";
var ZIP$2 = "邮编";
var Pricing$2 = "价格";
var Free$2 = "Free";
var Smart$2 = "Smart";
var Fleet$2 = "Fleet";
var Subscrubed$2 = "已订阅";
var January$2 = "一月";
var February$2 = "二月";
var March$2 = "三月";
var April$2 = "四月";
var May$2 = "五月";
var June$2 = "六月";
var July$2 = "七月";
var August$2 = "八月";
var September$2 = "九月";
var October$2 = "十月";
var November$2 = "十一月";
var December$2 = "十二月";
var Blackvuecloud_$2 = "www.blackvuecloud.com";
var Support$2 = "支持";
var Community$2 = "社区";
var FAQ$2 = "常问问题";
var Developers$2 = "开发商";
var Facebook$2 = "Facebook";
var Twitter$2 = "Twitter";
var Instagram$2 = "Instagram";
var Youtube$2 = "Youtube";
var Linkedin$2 = "Linkedin";
var Downloads$2 = "资料下载";
var Unauthorized$2 = "未经授权";
var none$2 = "None";
var Email$2 = "电子邮件";
var Customers$2 = "Customers";
var Home$2 = "Home";
var Plan$2 = "Plan";
var New$2 = "New";
var Unsubscribed$2 = "Unsubscribed";
var Edit$2 = "Edit";
var month$2 = "month";
var months$2 = "months";
var Continue$2 = "Continue";
var Back$2 = "后退";
var Master$2 = "Owner";
var Develop$2 = "Developers";
var $9$2 = "$9";
var $15$2 = "$15";
var $10$2 = "$10";
var mo$2 = "月";
var City$2 = "城市";
var Charge$2 = "收费";
var subscribe$2 = "订阅";
var search$2 = "搜索";
var invalid_number$2 = "信用卡号无效";
var invalid_expiry_month$2 = "信用卡的到期月份无效";
var invalid_expiry_year$2 = "信用卡的到期年份无效";
var invalid_cvc$2 = "信用卡的安全码无效";
var incorrect_number$2 = "信用卡号不正确";
var incomplete_number$2 = "信用卡号不完整";
var incomplete_cvc$2 = "信用卡的安全码不完整";
var incomplete_expiry$2 = "信用卡的有效期不完整";
var expired_card$2 = "信用卡已过期";
var incorrect_cvc$2 = "信用卡的安全码不正确";
var incorrect_zip$2 = "信用卡的邮政编码验证失败";
var invalid_expiry_year_past$2 = "信用卡的到期年份是过去的年份";
var card_declined$2 = "信用卡被拒绝";
var missing$2 = "客户并无正在被收费的信用卡";
var processing_error$2 = "处理信用卡时发生错误";
var Paypal$2 = "Paypal";
var iOS$2 = "iOS";
var Android$2 = "Android";
var Total$2 = "总共";
var And$2 = "以及";
var Camera$2 = "Camera";
var Yes$2 = "是";
var No$2 = "否";
var News$2 = "新闻";
var Notifications$2 = "通知";
var MPH$2 = "MPH";
var Firmware$2 = "固件";
var Basic$2 = "基本";
var Resolution$2 = "分辨率";
var Brightness$2 = "亮度";
var Recording$2 = "录像";
var Highest$2 = "最高";
var High$2 = "高";
var Normal$2 = "正常";
var Sensitivity$2 = "敏感度";
var Volume$2 = "音量";
var Close$2 = "Close";
var Cloud$2 = "Cloud";
var Public$2 = "Public";
var Front$2 = "前";
var Rear$2 = "后";
var Play$2 = "播放";
var Stop$2 = "停止";
var Pause$2 = "暂停";
var Time$2 = "Time";
var System$2 = "系统";
var Event$2 = "事件";
var Parking$2 = "停车";
var Color$2 = "颜色";
var Exit$2 = "退出";
var Save$2 = "保存";
var Impact$2 = "碰撞";
var Unlimited$2 = "无限制";
var Default$2 = "默认";
var Version$2 = "版本";
var Language$2 = "语言";
var Notification$2 = "通知";
var Multiple$2 = "多选";
var Range$2 = "范围";
var Download$2 = "下载";
var Manual$2 = "手册";
var Satellite$2 = "卫星";
var Tutorials$2 = "手册";
var Filter$2 = "过滤";
var Sun$2 = "星期天";
var Mon$2 = "周一";
var Tue$2 = "周二";
var Wed$2 = "周三";
var Thu$2 = "周四";
var Fri$2 = "星期五";
var Sat$2 = "周六";
var Dates$2 = "日期";
var Routes$2 = "路线";
var Opacity$2 = "不透明度";
var Entry$2 = "条目";
var Owner$2 = "Owner";
var Undetected$2 = "未发现";
var Distracted$2 = "分心";
var Drowsy$2 = "Drowsy";
var Calling$2 = "Calling";
var Smoking$2 = "Smoking";
var Permissions$2 = "权限";
var Private$2 = "私有";
var Entering$2 = "进入区域";
var Exiting$2 = "离开区域";
var Acceleration$2 = "加速";
var Passing$2 = "过线";
var Overspeed$2 = "超速";
var Recipients$2 = "收件人";
var Send$2 = "發送";
var Note$2 = "温馨提示";
var Video$2 = "视频";
var Advanced$2 = "高级";
var Voice$2 = "语音";
var Days_$2 = "天数";
var Mute$2 = "静音";
var UnMute$2 = "取消静音";
var Discard$2 = "放弃";
var Report$2 = "Report";
var Individual$2 = "驾驶员希望实现安心驾驶？企业主需要一个简单的解决方案实现车辆安全和跟踪？";
var Subscribed$2 = "已订阅";
var Geofence$2 = "地理围栏";
var Driving$2 = "驾驶";
var Idling$2 = "怠速";
var Distance$2 = "距离";
var Parked$2 = "Parked";
var Speed$2 = "速度";
var Highest_2$2 = "最高";
var Average$2 = "平均";
var Geofences$2 = "地理围栏";
var Move$2 = "移动";
var Connected$2 = "连接";
var Individual_$2 = "个人";
var Always$2 = "始终";
var Low$2 = "低";
var Medium$2 = "中";
var High_2$2 = "高";
var Flip$2 = "翻转";
var Previous$2 = "前一帧";
var Next$2 = "下一步";
var Expand$2 = "展开";
var Collapse$2 = "折叠";
var More$2 = "更多信息";
var Multi$2 = "多选";
var Safe$2 = "安全";
var Reckless$2 = "鲁莽";
var Inattentive$2 = "不专心";
var List$2 = "列表";
var Usage$2 = "使用";
var Profile$2 = "个人资料";
var Fullscreen$2 = "全屏";
var Upgrade$2 = "升级";
var Management$2 = "管理";
var Day$2 = "日";
var Month$2 = "月";
var Later$2 = "以后再说";
var ICCID$2 = "ICCID";
var Resubscribe$2 = "重新订阅";
var plan$2 = "套餐";
var USD$2 = "美元";
var etc_$2 = "其它：";
var Available$2 = "可用";
var Used$2 = "已使用";
var Cancelled$2 = "已取消";
var Terminated$2 = "已终止";
var Sort$2 = "排序";
var Bonus$2 = "奖金";
var incomplete_zip$2 = "信用卡的邮政编码验证失败";
var Upgrades$2 = "升级";
var OR$2 = "或";
var Undo$2 = "撤消";
var Invoice$2 = "发票";
var data$2 = "数据";
var Popular$2 = "Popular";
var Mask$2 = "口罩摘下";
var DMS$2 = "驾驶员状态监测 (DMS)";
var Extreme$2 = "极限";
var OFF$2 = "关闭";
var Threshold$2 = "阈值";
var Drowsiness$2 = "疲劳";
var Direct$2 = "直接";
var Remote$2 = "远程";
var Update$2 = "更新";
var Option$2 = "可选";
var Required$2 = "必要配置";
var Optional$2 = "可选配置";
var Others$2 = "其他";
var Stay$2 = "停留";
var Mask_2$2 = "Mask";
var Low_2$2 = "Low";
var Medium_2$2 = "Medium";
var High_3$2 = "High";
var Highest_3$2 = "Highest";
var Extreme_2$2 = "Extreme";
var Private_2$2 = "Private";
var Lite$2 = "Lite";
var Bitrate$2 = "比特率";
var hours$2 = "小时";
var Expires$2 = "到期";
var Check$2 = "检查";
var Saving$2 = "保存中";
var Now$2 = "现在";
var Beep$2 = "警报声";
var Unpair$2 = "解除配对";
var Detected$2 = "已检测到";
var Promotion$2 = "促销";
var Notice$2 = "更新";
var Explore$2 = "探索";
var Deactivate$2 = "停用";
var Compliance$2 = "合规性";
var Manufacturing$2 = "制造业";
var Emergency$2 = "紧急";
var Security$2 = "安全";
var Important$2 = "重要";
var or$2 = "或者";
var Subscribe$2 = "订阅";
var Vehicle$2 = "车辆";
var sc = {
	Dashboard: Dashboard$2,
	"Payment & Subscriptions": "支付与订阅",
	"Fleet Management": "车队管理",
	"Available to master": "仅主负责人可用",
	"Available to Fleet_": "仅车队方案用户可用",
	Account: Account$2,
	"Log out": "退出",
	"© 2019 Pittasoft_": "© 2019 Pittasoft Co. Ltd",
	"Privacy policy": "隐私政策",
	"Terms of service": "服务条款",
	Help: Help$2,
	"App store": "App store",
	"Google Play": "Google Play",
	Mac: Mac$2,
	Windows: Windows$2,
	"Free Plan": "Free Plan",
	"Basic Plan": "Basic Plan",
	"Smart Plan": "Smart Plan",
	Admin: Admin$2,
	Driver: Driver$2,
	"Period : December 3, 2024 ~ May 31, 2025": "期间 : 2024年12月3日 ~ 2025年5月31日",
	Cameras: Cameras$2,
	"n of n": "{{a}}，共 {{b}}",
	Manage: Manage$2,
	"Upgrade Plan": "升级计划",
	"Add more cameras_": "添加更多摄像头、管理您的车队等",
	"Usage statistics": "使用情况统计",
	"All cameras": "所有摄像头",
	Clear: Clear$2,
	Show: Show$2,
	"Live views": "远程实时影像",
	"nh:nm:ns": "{{a}}h:{{b}}m:{{c}}s",
	"Video plays and_": "视频播放与下载",
	"Space available": "可用空间",
	GB: GB$2,
	"n%": "{{a}}%",
	"BlackVue app for_": "BlackVue iOS 和 Android 版",
	"BlackVue viewer for_": "BlackVue Viewer Mac 和 Windows 版",
	"Welcome to fleet": "欢迎来到车队",
	"A few things_": "使用过程中，您可以期待以下几点：",
	"You can watch_": "您可以用 BlackVue 应用或桌面版 BlackVue Viewer 观看您指定的摄像头镜头。",
	"If the master_deletes": "如果主负责人账号被删除了，您的账户也将被删除。",
	"If the masters_Fleet": "如果主负责人的车队方案订阅到期，您仍可以以只读模式访问您的帐户。",
	"You have to_": "您须注册其他帐户才能添加个人摄像头。",
	"The Payments &_": "支付与订阅和车队管理仅对主负责人可用。",
	"You can manage_": "您可以在",
	"_Fleet management": "车队管理",
	_section: _section$2,
	"The Payments_section-": "支付与订阅仅对主负责人可用。",
	"Youre almost there": "您快成功了",
	"Finish account setup": "账号创建完成",
	"Install and log_": "安装并登录 BlackVue 应用或桌面版 BlackVue Viewer",
	"Download on the_": "在 App Store 上下载",
	"GET IT ON_": "在 Google Play 上获取",
	"Download for Mac": "下载 Mac 版",
	"Download for Windows": "下载 Windows 版",
	"Add your camera_": "在 BlackVue 应用或桌面版 BlackVue Viewer 中添加摄像头",
	"Start managing your_": "从这里开始管理您的车队并跟踪使用统计数据",
	"Cancelled Fleet Plan_": "您于 {{date}} 已取消了车队方案",
	"The new plan_": "新方案将在您当前计费周期结束时生效。",
	"Profile photo": "头像",
	Name: Name$2,
	"E-mail address": "邮箱地址",
	Password: Password$2,
	"Last changed_": "最后更改 {{a}}",
	"Change password": "更换密码",
	"Delete account": "删除账号",
	Cancel: Cancel$2,
	"Current password": "当前密码",
	"New password": "新密码",
	"Confirm new password": "确认新密码",
	"Password changed": "密码已更改",
	"Reason for deletion_": "（可选）删除原因",
	"Account password": "账号密码",
	Members: Members$2,
	Groups: Groups$2,
	"+ Invite member": "+邀请成员",
	"Name, Email": "姓名、邮箱地址",
	Role: Role$2,
	Group: Group$2,
	"Date invited": "邀请日期",
	Status: Status$2,
	"Group n": "群组 {{a}}",
	nPM: nPM$2,
	nAM: nAM$2,
	Newest: Newest$2,
	Oldest: Oldest$2,
	"Name, email or_": "姓名、邮箱地址或组名",
	Accepted: Accepted$2,
	Pending: Pending$2,
	Expired: Expired$2,
	All: All$2,
	"No results": "没结果",
	"Try different keywords": "尝试其他关键字",
	"Try changing or_": "尝试更改或删除筛选器",
	"Remove all filters": "删除所有筛选器",
	"Invite member": "邀请成员",
	"Send invite": "发送邀请",
	"You have reached_": "子负责人个数已达上限（10 个）。您可以继续邀请用户。",
	Delete_: Delete_$2,
	"Are you sure_delete": "是否确定要删除该成员及其帐户？",
	Delete: Delete$2,
	Rename: Rename$2,
	"No submaster yet": "尚无子负责人",
	"You can add_": "您可以为每个群组添加一个子负责人",
	"No cameras yet": "尚无摄像头",
	"Add cameras first_": "先添加摄像头，然后分配用户",
	"Name or email": "姓名或邮箱地址",
	"Add submaster": "添加子负责人",
	Add: Add$2,
	"Add camera": "添加摄像头",
	"n of n selected": "已选择 {{b}} 中的 {{a}}",
	"No cameras available": "没有可用的摄像头",
	"Most likely reasons_": "最可能的原因是：",
	"All cameras were_": "所有摄像头都被添加到其他群组中。",
	"You can remove_": "您可以移除其他群组的摄像头，并将其添加到该组中。",
	"No cameras were_": "没有摄像头添加到您的帐户中。",
	"You can add_cameras": "您可以在 BlackVue 应用或桌面版 BlackVue Viewer 中添加摄像头。",
	OK: OK$2,
	"Rename group": "重命名群组",
	"Are you sure_group": "是否确定要删除该组？",
	"Edit Mobile app_": "编辑移动应用/桌面版查看器的权限",
	Remove: Remove$2,
	"n of n users": "{{b}} 个用户中的 {{a}} 个",
	"Youve reached the_": "您已达到每个摄像头的用户限制",
	"Remove user": "删除用户",
	"Add user": "添加用户",
	"+ Add group": "+新增群组",
	"Add group": "新增群组",
	"Group or submaster": "群组或子负责人",
	"+ Add": "+添加",
	"of max selected": "已选择最多 {{b}} 个中的 {{a}} 个",
	"Mobile app/desktop_": "移动应用/桌面版查看器权限",
	Files: Files$2,
	Features: Features$2,
	Settings: Settings$2,
	Upload: Upload$2,
	"Download and Playback_Cloud": "从云端存储中下载和回放",
	"Download and Playback_SD": "从 SD 卡中下载和回放",
	"Live view": "Live View",
	"Geo Fencing": "地理围栏",
	"Drive Reports": "行车报告",
	"Firmware Settings": "固件设置",
	"Push Notifications": "推送通知信息",
	"Event Auto Upload": "事件实时自动上传",
	Privacy: Privacy$2,
	Done: Done$2,
	"Payment method": "付款方式",
	"Change payment method": "修改支付方式",
	Subscription: Subscription$2,
	"Space used": "所使用空间",
	"Next billing_": "下个帐单 {{a}} {{b}}",
	"You manage_available": "您可管理方案中现有 {{b}} 个中的 {{a}} 个",
	Submasters: Submasters$2,
	Users: Users$2,
	Change: Change$2,
	"No transactions yet_": "您已订阅免费方案。尚无交易",
	"No transactions to_": "没有交易显示。<br/>如果您正在寻找其他平台（例如 iOS、Android 或 PayPal）的交易记录，可以在自己平台的订阅页面上找到该记录。",
	"of nGB_": "{{b}} GB 中的 {{a}}（{{c}}％）",
	"Smart Plan users_": "智能方案用户可以通过 BlackVue 移动应用程序修改订阅计划或摄像头数量",
	"Transaction history": "交易记录",
	"Date": "日期",
	"Amount, USD": "金额，美元",
	Method: Method$2,
	Details: Details$2,
	"iOS in-app_": "iOS 程序内购买/Android 程序内购买",
	"Change the number_": "更改摄像头数量",
	"You manage_cameras": "您可管理方案中现有 {{b}} 个摄像头中的 {{a}} 个摄像头。",
	"Extra cameras": "更多摄像头",
	"Total due_": "应付总额",
	"available on your_": "您的方案中可用的 {{a}} 个摄像头",
	"Cancel Fleet Plan": "取消 Fleet Plan",
	"This will cancel_": "这将取消您的车队方案订阅。您将在结算周期结束时降级为免费方案。",
	"Reason for cancellation_": "取消的原因（可选）",
	"Not now": "现在不需要",
	Confirm: Confirm$2,
	"Cardholder name": "持卡人姓名",
	"Card name": "卡名",
	"MM/YY": "MM/YY",
	Address: Address$2,
	Country: Country$2,
	State: State$2,
	ZIP: ZIP$2,
	Pricing: Pricing$2,
	"You are subscribed_": "您已订阅免费方案。",
	"With Alert Push_": "提供警报推送通知，有限的远程实时取景和云存储。",
	Free: Free$2,
	Smart: Smart$2,
	Fleet: Fleet$2,
	"Get started for_": "免费使用，无需信用卡。\n 包括警报推送通知，有限的远程实时取景和云存储。",
	Subscrubed: Subscrubed$2,
	"Features included:": "功能包括：",
	"Get unlimited Remote_": "获得无限的远程实时取景和云回放功能并管理多达 {{a}} 个摄像头。",
	"BlackVue Fleet Tracking_": "BlackVue 车队追踪功能为高级用户和企业提供专属功能（多个用户和摄像头，地理围栏等）。",
	"Try 1 Month Free": "免费试用 1 个月",
	"Log in": "登录",
	"Remember me": "记住我",
	"Forgot password?": "忘记密码？",
	"Reset password": "密码重置",
	"Enter email address_": "输入注册时使用的邮箱地址，我们将向您发送一个链接以重置密码。",
	"Send reset password_": "发送重置密码的邮件",
	"Back to login": "返回到登录",
	"Check your email": "查看你的邮件",
	"Weve sent an_": "我们已经向 {{a}} 发送了一封邮件，通过链接来确认您邮箱地址。",
	"Resend email": "重新发送邮件",
	January: January$2,
	February: February$2,
	March: March$2,
	April: April$2,
	May: May$2,
	June: June$2,
	July: July$2,
	August: August$2,
	September: September$2,
	October: October$2,
	November: November$2,
	December: December$2,
	"Sign up": "创建帐号",
	"First name": "姓氏",
	"Last name": "名字",
	"Create a password": "创建密码",
	"5 or more_": "5 个或更多字符",
	"Sign up and_": "注册并继续",
	"I agree to_": "我同意 ％s、％s、％s 和 ％s。",
	"Subscribe to newsletter": "订阅资讯",
	"1 month free trial_": "一个月免费试用",
	"Dont have an_": "还没有帐号？",
	"Thank you for_": "感谢您注册 BlackVue Cloud。请确认您的邮箱地址。",
	"Confirm email": "确认邮件",
	"If you didnt_": "如果您没有注册此帐户，可以忽略此邮件。",
	Blackvuecloud_: Blackvuecloud_$2,
	"invited you to_": "{{a}} 邀请您以子负责人的身份加入他的车队。",
	"Accept invitation": "接受邀请",
	"Invite expires on_": "邀请将在年/月/日到期。",
	"Your Fleet Management_": "您用 {{a}} 邮箱地址注册的车队管理帐户已被 ％s 删除。",
	"If you believe_": "如果您认为这是一个错误，请联系我们的客服解决：cs@blackvue.com。",
	Support: Support$2,
	"Help center": "客服中心",
	Community: Community$2,
	"Getting started": "开始",
	FAQ: FAQ$2,
	Developers: Developers$2,
	"Cloud API": "Cloud API",
	"Fleet SDK": "Fleet SDK",
	"Follow us": "跟着我们",
	Facebook: Facebook$2,
	Twitter: Twitter$2,
	Instagram: Instagram$2,
	Youtube: Youtube$2,
	Linkedin: Linkedin$2,
	"BlackVue apps": "BlackVue apps",
	"Camera registraiton": "摄像头注册",
	"Two-way voice_": "双向语音通信",
	"Live GPS": "实时GPS",
	"Event live auto_": "事件实时自动上传",
	"Event file auto_": "事件文件自动上传",
	"Compatible with_": "与 DR650GW、DR650S 型号兼容",
	"Not compatible with_": "与 DR650GW、DR650S 型号不兼容",
	"More cameras": "更多摄像头",
	"More users": "More users",
	"Roles and permissions": "Roles and permissions",
	"More Cloud Storage": "更多云存储",
	"Multi Live view_": "Multi Live View (Web)",
	"Longer GPS Tracking": "Longer GPS Tracking",
	"Geo Fence setup_": "Geo Fence setup (PC viewer) and alerts (PC viewer and app)",
	"Changes saved": "更改保存成功",
	"Group added": "群组添加成功",
	"Member added": "成员添加成功",
	"Group deleted": "群组删除成功",
	"Member deleted": "成员删除成功",
	"Group renamed": "群组重命名成功",
	"Submaster added": "子负责人添加成功",
	"Camera added": "摄像头添加成功",
	"User added": "用户添加成功",
	"Users added": "多个用户添加成功",
	Downloads: Downloads$2,
	"The BlackVue App_": "The BlackVue App and Viewer let you use your BlackVue camera to its full potential. Whether on mobile or on home computer, BlackVue gives you the tools to fully enjoy your dashcam's functions.",
	"Compatible with all_": "Compatible with all Wi-Fi enabled BlackVue models.",
	"Supports all BlackVue_": "Supports all BlackVue models to date.",
	"confirm new password": "确认新密码",
	"Your password is_": "您输入的密码不正确",
	"Confirm password does_": "密码不匹配",
	"Please enter_email": "请输入可使用的电子邮箱",
	"Please enter_password": "您输入的密码不正确",
	"Internal server error_": "内部服务器错误。请再次尝试。",
	"New password is_": "至少应包含一个与您当前密码不同的字符",
	"It should be_": "密码应包含 5 个或更多字符",
	"Invalid permission": "无效权限。",
	"Input data isnt_": "输入数据不可用。",
	Unauthorized: Unauthorized$2,
	"Already have subsciption": "已订阅",
	"Already uses": "已使用",
	"Already logged in": "已登录",
	"Already sent e-mail": "已发送邮件。",
	"Please wait": "请稍候。",
	"E-mail is not_": "邮箱尚未验证。",
	"Update your subscription_": "更新您的订阅",
	"Account was deleted": "帐户已删除。",
	"5 ~ 30_": "5 ~ 30 characters",
	"It has exceeded_": "已超过 9 位管理员的上限。",
	"Billing information": "账单信息",
	"Please enter cardName": "输入持卡人姓名",
	"Please enter_card": "输入有效的卡号",
	"Please enter address": "输入地址",
	"Please select country": "选择国家",
	"Please enter city": "输入城市",
	none: none$2,
	"Due today": "今天截止",
	"Today after 1_": "今天已结束一个月的试用期",
	"An error occurred_": "尝试更改密码时发生错误。再试一次。",
	"Your account is_": "您的帐户已激活",
	"You can now_": "现在您可以用注册时的邮箱登录您的帐户。",
	Email: Email$2,
	"Don’t have an account?": "还没有帐号？",
	"Already have an account?": "已经有帐号了？",
	"Cloud service": "Cloud service",
	"for your BlackVue": "for your BlackVue",
	"See what your_": "See what your camera sees remotely.",
	"Receive impact alert_": "Receive Impact alert push notifications.",
	"Save footage to_": "Save footage to the cloud and do much more...",
	"Free plan included_": "Free plan included · Easy setup · Cancel anytime",
	"Taking advantage of_": "Taking advantage of a mobile or car-embedded Internet connection and a BlackVue camera, BlackVue Cloud connects you to your car from anywhere, anytime. Using the BlackVue App on your smartphone or tablet, you see in real time where your car is located and what is happening around it.",
	"Get notifications to_": "Get notifications to your phone when your parked car is hit. Check remotely what is happening around your car.",
	"Monitor your commercial_": "Monitor your commercial vehicles on a map in real time. Talk to your drivers anytime through the BlackVue App or Viewer.",
	"With BlackVue Fleet_": "With BlackVue Fleet Tracking, track in real time up to 100 vehicles from the palm of your hand or with the dedicated BlackVue Viewer.",
	"Get started now_": "Get started now with a Free plan. For unlimited video playback or Remote Live View, upgrade to Lite or Smart plan from the BlackVue App. <br/>Business and power users can unlock the power of the Fleet plan exclusively through this website.",
	"Remote Video Playback_": "Remote Video Playback and Download",
	"Compatible with DR650GW_": "Compatible with DR650GW, DR650S models",
	"Unlimited remote video_": "Unlimited remote video playback and download",
	"Longer cloud storage_": "Longer cloud storage file expiration period",
	"Longer storage period_live": "Longer storage period for Event live auto upload",
	"Longer storage period_file": "Longer storage period for Event file auto upload",
	"Goefence setup (PC_": "Geo-fence setup (PC viewer) and alerts (Windows viewer and app)",
	"App Store": "App Store",
	"Send reset password email": "发送重置密码的邮件",
	Customers: Customers$2,
	Home: Home$2,
	"Pick a plan": "Pick a plan",
	"No customers yet": "No customers yet",
	"Customers will_": "Customers will show up here as they become available",
	"Add customer": "Add customer",
	"Report(PDF)": "Report(PDF)",
	"Subscription Period": "Subscription Period",
	Plan: Plan$2,
	New: New$2,
	Unsubscribed: Unsubscribed$2,
	"Subscription ends soon": "Subscription ends soon",
	Edit: Edit$2,
	"1 month trial": "1 month trial",
	"Edit customer details": "Edit customer details",
	"Customer name": "Customer name",
	"of 999 available_": "of 999 available on Fleet Plan",
	"Subscription starts": "Subscription starts",
	"Subscription period": "Subscription period",
	month: month$2,
	months: months$2,
	"Cloud storage": "Cloud Storage",
	"Subscription plan": "订阅类型",
	"Check email address": "Check email address",
	"Add customer details": "Add customer details",
	Continue: Continue$2,
	Back: Back$2,
	"An error occured": "An error occured",
	"Customer added": "Customer added",
	"Last changed": "Last changed",
	"Company name": "Company name",
	"Company address": "Company address",
	"Alert Push Notifications": "Alert Push Notifications",
	"Receive notifications on_": "Receive notifications on your phone when preset Events occur. Great in combination with BlackVue’s Parking Mode.",
	"Remote Live View": "远程实时查看",
	"Remotely monitor your_": "Remotely monitor your car in real time from anywhere, anytime.",
	"Video Backup/Auto Upload": "Video Backup/Auto Upload",
	"Back up videos_": "Back up videos to your phone or Cloud storage.",
	"Two-way Voice Communication": "Two-way Voice Communication",
	"Talk with people_": "Talk with people in the car from your smartphone. The driver can speak while keeping hands on the wheel.",
	"View your car’s_": "View your car’s location and speed on a map. With BlackVue Fleet Tracking, access 90-days’ worth of GPS data.",
	"Remote Video Playback": "Remote Video Playback",
	"Play videos stored_": "Play videos stored in the Cloud or in your dashcam anytime on your smartphone or tablet.",
	"Event Live Auto Upload": "Event Live Auto Upload",
	"Save a video stream_": "Save a video stream in real time to the Cloud. Protect yourself from break-ins and theft.",
	"Event File Auto Upload": "Event File Auto Upload",
	"Save Event videos_": "Save Event videos to the Cloud—including seconds before trigger—after they happen.",
	"Firmware-Over-the-Air (FOTA)": "Firmware-Over-the-Air (FOTA)",
	"Upgrade your dashcam’s": "Update your dashcam over the cloud",
	"When an Event_": "When an Event is created (Impact detected or manually triggered), Event Live Auto-upload lets your Cloud-compatible BlackVue save a live video stream from a camera of your choice (front or rear/interior) to the Cloud server",
	"Event File Auto-upload_": "Event File Auto-upload lets your dashcam automatically upload low-resolution versions of Event files to the Cloud.",
	Master: Master$2,
	"per Camera": "per Camera",
	"Event live auto upload_": "Event live auto upload compatible with all cloud cameras",
	"Drive report": "Drive report",
	"USA/Canada Toll Free": "USA/Canada Toll Free",
	"Monday–Saturday_": "Monday to Friday 8am-7pm / Saturday 9am-6pm (PST).",
	"Please agree to_": "You must accept Terms of Service",
	"Mac or Windows PC": "Mac or Windows PC",
	Develop: Develop$2,
	"Sign out": "Sign out",
	"Referral code": "推荐码",
	"Total after 1 month trial": "一个月试用期后总计",
	"Already Use Stripe Token": "已使用 Stripe 令牌",
	"Select period": "选择时期",
	"State/Region": "（可选）州/地区",
	"ZIP/Postal": "邮政编码",
	"$0.00": "$0.00",
	"$11.99": "$11.99",
	"$24.99": "$24.99",
	$9: $9$2,
	$15: $15$2,
	$10: $10$2,
	"mo + for_": "/mo + {{a}} per extra camera",
	mo: mo$2,
	"This e-mail address_": "此电子邮箱为已注册帐户",
	"1 month": "一个月",
	"Limit is reset daily": "每天重置限额",
	"Limit is reset monthly": "每月重置限额",
	"Video plays and downloads": "视频播放与下载",
	"Your master": "Your owner",
	"Youre 1 step_": "您距离完成车队方案订阅仅一步之遥",
	"Finish signing up": "完成注册",
	"Enter billing information": "输入帐单信息",
	"Proceed to billing": "继续进行结算",
	City: City$2,
	Charge: Charge$2,
	"User already invited_": "用户已受主负责人邀请",
	"n% consumed": "已使用 {{a}}％",
	"E-mail already exists": "邮箱地址已存在",
	"Cancel your inapp_": "取消您的应用内订阅",
	"You have cancel_": "您必须取消应用内订阅才能升级到车队方案：1.在 App Store 或 Google Play 商店中取消当前的订阅。您将在当前结算周期结束时降级为免费方案。您的所有数据将保持不变。2.登录您的 blackvuecloud.com 帐户并升级到车队方案。",
	"Edit permissions": "编辑权限",
	"See permissions": "查看权限",
	"Submaster removed": "子负责人已成功删除",
	"Camera removed": "摄像头已成功移除",
	"User removed": "用户已成功删除",
	"Users removed": "多个用户已成功删除",
	subscribe: subscribe$2,
	search: search$2,
	"permission can be_": "子负责人接受邀请后即可设置权限。",
	"The confirmation link_": "确认链接不再有效",
	"Possible reasons:_": "可能的原因：\n •您已经确认了您的邮箱地址\n •链接已过期或已被取消",
	"Failed to register_": "无法注册到 BlackVue Cloud",
	"There was an_": "注册过程中出现错误。如果问题仍然存在，请尝试再次注册 BlackVue Cloud。如果您需要进一步的帮助，请联系我们的客服：",
	"Upgrade to Fleet_": "升级到车队方案",
	"Subscription is Canceled": "订阅已取消",
	"No members yet": "尚无成员",
	"Please enter_group name": "输入有效的群组名称",
	"Group Name": "组名",
	invalid_number: invalid_number$2,
	invalid_expiry_month: invalid_expiry_month$2,
	invalid_expiry_year: invalid_expiry_year$2,
	invalid_cvc: invalid_cvc$2,
	incorrect_number: incorrect_number$2,
	incomplete_number: incomplete_number$2,
	incomplete_cvc: incomplete_cvc$2,
	incomplete_expiry: incomplete_expiry$2,
	expired_card: expired_card$2,
	incorrect_cvc: incorrect_cvc$2,
	incorrect_zip: incorrect_zip$2,
	invalid_expiry_year_past: invalid_expiry_year_past$2,
	card_declined: card_declined$2,
	missing: missing$2,
	processing_error: processing_error$2,
	"no groups yet": "尚无群组",
	"groups will show_": "群组可见时将显示在此处",
	"Fleet members will_": "车队成员可见时将显示在此处",
	"service provider": "服务提供者",
	Paypal: Paypal$2,
	iOS: iOS$2,
	Android: Android$2,
	"Enter email": "输入邮箱地址",
	"Enter password": "请输入密码。",
	"Enter first name": "输入名",
	"Enter last name": "输入姓",
	"Enter the current_": "输入当前密码",
	"Enter a new_": "输入新密码",
	"There isnt an_": "没有与此邮箱地址关联的帐户",
	"Fleet Plan": "Fleet Plan",
	Total: Total$2,
	"Password you entered_": "您输入的密码不正确",
	"Incorrect email or_": "错误的邮箱帐号或密码",
	"Available to Masters": "仅供所有者使用",
	"Blackvue url": "https://www.blackvue.com",
	"Information We Collect_": "我们收集的信息和用途",
	And: And$2,
	"Terms of Location-Based_": "位置服务使用条款。",
	"I agree to the_": "我同意",
	"Password Reset_": "我们已向 {{a}} 邮箱地址发送了一封邮件，其中包含密码重置\n 说明。",
	"You have already_": "您已经受邀，请检查您的电子邮件。",
	"No data available_": "表中无可用数据",
	Camera: Camera$2,
	"You no longer_": "您不再有权使用车队服务。",
	"Please contact your_": "请与您的车队主负责人联系以解决问题。",
	"You can still_": "您仍然可以访问您的",
	"account information": "帐户信息。",
	"If the issue_": "如果问题仍未解决并且您想继续使用已注册邮箱地址的 BlackVue Cloud 服务，您必须删除现有帐户重新注册。",
	"If the problem_": "如果删除账号重新注册后问题仍然存在，请联系我们的客服。",
	"Web subscription only": "仅限网络订阅",
	"AppStore url": "https://apps.apple.com/kr",
	"We no longer_": "我们不再处理通过 PayPal 支付的款项。您必须更新您的订阅才能更改摄像头数量：1.登录到您的 paypal.com 帐户并取消您当前的车队方案订阅以更改摄像头数量。2.登录您的 blackvuecloud.com 帐户并升级到车队方案。",
	Yes: Yes$2,
	No: No$2,
	"Serial number": "序列号",
	"Cloud code": "Cloud安全密钥",
	"Terms & Policies": "条款 & 政策",
	News: News$2,
	Notifications: Notifications$2,
	"km/h": "km/h",
	MPH: MPH$2,
	"Baidu Maps": "百度地图（仅限中国）",
	"Google Maps": "谷歌地图",
	Firmware: Firmware$2,
	Basic: Basic$2,
	"Time Zone": "时区",
	Resolution: Resolution$2,
	"Image quality": "画质",
	Brightness: Brightness$2,
	Recording: Recording$2,
	"Normal recording": "正常录制",
	"Voice recording": "录音",
	"Video segment length": "视频片段长度",
	"Rear camera recording": "后置摄像头录制",
	Highest: Highest$2,
	High: High$2,
	Normal: Normal$2,
	"1 min": "1 分钟",
	"2 min": "2 分钟",
	"3 min": "3 分钟",
	Sensitivity: Sensitivity$2,
	"Motion detection": "运动检测",
	"Speed alert": "超速警报",
	"Voice guidance": "语音导航",
	"Power on": "电源开启",
	"Power off": "电源关闭",
	"Starting normal recording": "开始正常录制",
	"Changing recording mode": "更改录制模式",
	"Speed alert (beep)": "超速警报（警笛声）",
	"Cloud related": "Cloud相关介绍",
	Volume: Volume$2,
	"User text overlay": "用户文本覆盖",
	"A-Z, a-z_": "A~Z, a~z, 0~9, :;’/\\+-_()$#\n20个字符以下",
	"Wi-Fi auto turn off": "Wi-Fi自动关闭",
	"Login credentials": "登陆证书",
	"Manual recording": "手动录制",
	"By sharing your_": "通过分享实时视频，让其他用户间接体验到可以在全世界任何地方驾驶的激情与乐趣。",
	"However, as persona_": "传送个人视频，需要特别仔细决定要分享哪些信息。",
	"Please enter_email_2": "请输入有效的电子邮件地址。可能不允许使用一些特殊字符的电子邮件。 ex） +，＆",
	"Password is incorrect": "密码错误",
	"This camera is already_": "该摄像头已注册到 BlackVue 账户。",
	"Camera name must_": "摄像机名称必须包括5-32个字符",
	"Failed to save_": "保存摄像机设置信息失败",
	"Unallowed character detected": "输入不可使用的字符",
	"File(s) queued for_": "文件已列队准备上传至Cloud",
	"Exceeded video play_": "超出视频播放 & 下载限制。",
	"Playback Failed": "视频重放失败",
	"Exceeded your Live_": "超过直播实时影像时间限度",
	"The camera is not_": "摄像机未连接到服务器",
	"Please check the connection_": "请确认所选摄像机连接状态",
	Close: Close$2,
	"Map": "地图",
	Cloud: Cloud$2,
	Public: Public$2,
	"Flip horizontally": "水平翻转",
	Front: Front$2,
	Rear: Rear$2,
	Play: Play$2,
	Stop: Stop$2,
	Pause: Pause$2,
	"Next frame": "下一帧",
	"Previous frame": "前一帧",
	"Proximity sensor": "近距离传感器",
	"Voice recording on/off": "录音开启/关闭",
	"The BlackVue dashcam_": "BlackVue 行车记录仪不兼容 5GHz 无线网络。",
	Time: Time$2,
	"Daylight saving time": "夏时制",
	System: System$2,
	"Incorrect camera serial_": "错误的摄像头序列号。",
	"Lock event files": "锁定事件文件",
	"Overwrite locked event_": "装满时覆盖锁定的事件文件",
	"Camera settings saved_": "摄像机设置保存成功",
	"Front camera": "前置摄像头",
	"Rear camera": "后置摄像头",
	Event: Event$2,
	Parking: Parking$2,
	"GPS tracking": "GPS 跟踪",
	"G-force detected": "检测到的 G-力",
	"Impact detected in_": "停车模式下检测到碰撞",
	"Scheduled reboot": "预定重启",
	"Recording status": "录制状态",
	"Rear security": "后置安全",
	"Time lapse": "延时摄影",
	"Sync with GPS_": "与 GPS 时间同步",
	"Overwrite locked event3_": "当存储空间已满，用新事件文件覆盖已锁定的文件",
	"Video codec": "视频编解码器",
	"Tracking logs": "跟踪日志",
	"Geofence alerts": "地理围栏警报",
	Color: Color$2,
	Exit: Exit$2,
	Save: Save$2,
	Impact: Impact$2,
	Unlimited: Unlimited$2,
	"Parking mode recording": "停车模式录制",
	"Battery protection": "电池保护",
	"Cut-off timer": "切断定时器",
	"Low voltage cut-off": "低电压切断",
	"Rear camera orientation": "后置摄像头定向",
	Default: Default$2,
	"Rotate video 180°": "旋转录像180°",
	"Mirror video": "镜像录像",
	"Wi-Fi band": "Wi-Fi 频段",
	"Driving report": "行车报告",
	"Unsupported video codec_": "不支持的视频编解码器 (H.265)。",
	"Rear camera recording_": "停车模式后摄像头录制",
	"Front and rear_": "前后摄像头同时录制",
	"Rear camera stops_": "进入停车模式5分钟后后摄像头停止录制。进入正常模式时录制重新开始。",
	"Remote firmware update": "远程固件更新",
	"Firmware is up-to-date": "固件已最新",
	"New firmware available": "可使用新固件",
	Version: Version$2,
	"Release date": "发布日期",
	Language: Language$2,
	"File size": "文件大小",
	"What’s new": "有什么新内容",
	"Updating may take_": "更新可能需要几分钟。",
	"The update process_": "更新过程无法取消。",
	"Do not disconnect the_": "正常录制重新开始之前请勿断开电源线。",
	"Downloading firmware": "下载固件",
	"Once download is_": "下载完成后，BlackVue 自动重启以应用新固件。",
	"If not allowed_": "如不允许，将无法通过 Cloud 访问您的车辆位置和速度。",
	"Unable to initiate update because_": "无法发起更新，因为行车记录仪通过 direct Wi-Fi 连接到一台设备。",
	Notification: Notification$2,
	Multiple: Multiple$2,
	Range: Range$2,
	"HDR night vision": "HDR 夜视",
	Download: Download$2,
	"G-sensor": "G-Sensor",
	Manual: Manual$2,
	"Low voltage warning": "低压警告",
	Satellite: Satellite$2,
	"Data usage": "数据使用量",
	"Select video download quality": "选择视频下载质量",
	"Quick play file_": "快速播放文件（低分辨率）",
	"Original file": "原始文件",
	"You do not have permission_": "您无权运行此功能。请与您的主帐户所有者联系。",
	"Interior camera recording_": "停车模式下的内置摄像头录制",
	"Interior security": "内置摄像头安全",
	"Interior camera rotation": "内置摄像头旋转",
	"Multi View": "多视图",
	Tutorials: Tutorials$2,
	"Upgrade now": "现在升级",
	"Members will show_": "成员可见时将展现在此处",
	"Are you sure_delete members": "是否要永久删除这些成员？",
	"Some members may_": "由于应用了过滤器，某些成员可能被隐藏。",
	"Invited on_": "您于 {{Invited Date}} 日邀请。所有者",
	Filter: Filter$2,
	"Date created": "创建日期",
	"No admin yet": "还没有管理员",
	"You can add_admin": "您可以为每组添加一个管理员",
	"Collapse all": "折叠全部",
	"Expand all": "展开全部",
	"Download and playback_cloud": "从云端存储中下载和回放",
	"Are you sure_2": "是否确定删除 {Group name} 群组？",
	"Are you sure_groups": "是否确定要删除这些群组？",
	"Add cameras first_drivers": "首先添加摄像头，然后分配驾驶员",
	"Flip vertically": "垂直翻转",
	Sun: Sun$2,
	Mon: Mon$2,
	Tue: Tue$2,
	Wed: Wed$2,
	Thu: Thu$2,
	Fri: Fri$2,
	Sat: Sat$2,
	Dates: Dates$2,
	Routes: Routes$2,
	Opacity: Opacity$2,
	"Color and opacity": "颜色和不透明度",
	"Geofences will show_": "地理围栏将在可用时显示在此处",
	"Start drawing a shape_": "开始在地图上画形状",
	"Add geofence": "添加地理围栏",
	Entry: Entry$2,
	"Show all members": "显示所有成员",
	"Me and my_": "我和我的车连接",
	"add-on service for_": "兼容云的 BlackVue 附加服务",
	"Continue with Google": "继续使用 Google",
	"An account with_": "具有该邮箱地帐户已存在，但未通过验证。请输入您现有的 BlackVue Cloud 密码。",
	"Account does not_": "帐户不存在。或者尝试使用您的 Apple 或 Google 帐户登录。",
	"Continue with Apple": "继续使用 Apple",
	"Get started": "开始",
	"P subscription only": "<b>{{a}}</b> 仅限订阅",
	"+N USD for extra camera_": "+{{a}} USD for extra camera up to {{b}} Cameras",
	"Unlimited Live view": "Unlimited Live View",
	"Cameras per Account": "Cameras per Account",
	"Users per Account": "Users per Account",
	Owner: Owner$2,
	"Live View per Day": "Live View per Day",
	"Remote Video Playback_2": "Remote Video Playback and Download per Month",
	"N days": "{{a}} Days",
	"Video On Map": "Video On Map",
	Undetected: Undetected$2,
	Distracted: Distracted$2,
	Drowsy: Drowsy$2,
	"Whether on mobile_": "Whether on mobile or your computer, BlackVue gives you the tools to fully enjoy your dashcam’s functions. Download the latest <a1>firmware</a1>, <a2>mobile</a2> and <a3>desktop</a3> applications, or use <a4>BlackVue web app</a4> in your browser.",
	"Compatible with most_": "Compatible with most Wi-Fi BlackVue models. Cloud support for all Cloud-compatible dashcam models down to DR650GW Series with <b>Cloud Firmware</b>.",
	"Supports most recent BlackVue_": "Supports most recent BlackVue models and compatible with BlackVue Cloud.<br/>\nThis Viewer contains <b>two applications in one</b>: the SD Card Viewer lets you view recorded videos from your SD card and modify the settings of your BlackVue, as well as format the SD card; the <b>Cloud Viewer</b> lets you enjoy BlackVue Cloud.",
	"Contact us": "Contact us",
	"6 characters with": "6 个字符，包含字母、数字和符号",
	"Apps and more...": "Apps and more...",
	"Cameras will show_": "Cameras will show up here as they become available.",
	"Keep this page_": "检查确认码时，请勿关闭此页面。如果您在收件箱中找不到电子邮件，请查看垃圾邮件文件夹。",
	"n cameras": "{{n}} 个摄像头",
	"n slots": "{{n}} 个槽位",
	"Calculate your Fleet_": "计算你的车队方案价格",
	"Code you entered_": "您输入的确认码不正确/已过期",
	Calling: Calling$2,
	Smoking: Smoking$2,
	"Smoking has been_": "行驶中检测到驾驶员有吸烟。",
	"Email is already_": "邮箱已经存在。",
	"Serial number and_": "序列号和云代码打印在摄影头上",
	"Allow GPS access": "允许 GPS 访问",
	"Used to access_": "用来访问您车辆的位置和速度。您可以稍后在摄像头的隐私设置中修改 GPS 设置。",
	"Incorrect cloud code": "云确认码不正确",
	"An account is_": "此邮箱地址已经注册了一个账户。",
	"Live event upload": "实时事件上传",
	Permissions: Permissions$2,
	"Assign in": "分配",
	"Are you sure_camera": "确定要删除此摄像机吗？",
	"Uploading videos:": "上传视频：",
	"GPS location recording": "GPS 定位录制",
	"When OFF, GPS_": "此功能关闭后，GPS 位置信息将不再记录也不会发送到云服务器。",
	"As personal video_": "由于要传送个人视频，因此您需要特别仔细决定要分享哪些信息。",
	"Share location": "定位共享",
	Private: Private$2,
	"Used to access_2": "用来访问您车辆的位置和速度。",
	"Share live view": "分享实时取景视频",
	"Share live audio": "分享实时取景音频",
	"Share camera’s name": "分享行车记录仪名称",
	"Impact detection": "碰撞检测",
	Entering: Entering$2,
	Exiting: Exiting$2,
	"Normal event recording": "正常事件录制",
	"Harsh braking": "急刹车",
	Acceleration: Acceleration$2,
	"Sharp turn": "急弯",
	"Parking event recording": "停车事件录制",
	Passing: Passing$2,
	"Video source": "视频来源",
	Overspeed: Overspeed$2,
	"Are you sure_video": "是否确定要删除该视频？",
	"Add camera to_": "将摄像头添加到实时取景",
	"No routes to_": "没有路线显示",
	"Start by adding_": "从添加日期开始。",
	"invite sent": "邀请已发送",
	Recipients: Recipients$2,
	Send: Send$2,
	"Routes selected_": "已选路线：{{n}} 条，共 {{total}} 条",
	"Map service": "地图服务",
	"Speed units": "速度单位",
	Note: Note$2,
	"Release notes": "发布说明",
	"The name must_": "名称必须包含1至30个字符。",
	Video: Video$2,
	Advanced: Advanced$2,
	"Firmware language": "固件语言",
	"Wi-Fi": "Wi-Fi",
	Voice: Voice$2,
	"Show date and_": "显示日期和时间",
	"Show speed": "显示速度",
	"Front camera rotation": "前置摄像头旋转",
	"Manual time settings": "手动设置时间",
	"Recommended for better_": "推荐以获得更好的压缩、更小的文件和 4K UHD。",
	"For full compatibility_": "实现与较老的台式机和移动设备完全兼容。",
	"Up and down": "向上和向下",
	"Side to side": "侧面至侧面",
	"Front and back": "前面和后面",
	"Detection region": "检测区域",
	"Hotspot 1": "热点 1",
	"Hotspot 2": "热点 2",
	"Hotspot 3": "热点 3",
	"Enter/exit": "进入/退出",
	"Event recording": "事件录制",
	"Front security (Normal)": "前置安全（正常）",
	"Front security (Parking)": "前置安全（停车）",
	"LTE (Parking)": "LTE (停车)",
	"Wi-Fi (Parking)": "Wi-Fi (停车)",
	"Turn on at startup": "开机时打开",
	"Turn off after_": "无活动 10 分钟后关闭",
	"Your firmware is_": "您的固件是最新的",
	"Add admin": "添加管理员",
	"Remove All/n": "删除全部/{{a}}",
	"Are you sure_remove": "是否确定要删除此群组的摄像头？",
	"This will cancel_2": "这将取消您的车队方案订阅。您将在当前结算周期结束时降级为免费方案。",
	"You’ve reached_": "您已达到每个摄像头的驾驶员限制",
	"Are you sure_remove admin": "是否确定要删除此群组的管理员 {{a}}{{b}}？",
	"Fleet Plan · Owner": "Fleet Plan · Owner",
	"Manage cameras": "管理摄像头",
	"Are you sure_delete zone": "是否确定要删除区域 {{zone}} 吗？",
	"available on your_2": "您的方案中 {{a}}/{{b}} 可用",
	"The new plan_2": "新方案将在您当前计费周期（{{a}}）结束时生效。",
	"Canceled Fleet Plan_": "您于 {{a}} 已取消了车队方案",
	"Hard braking alert (beep)": "急刹车警报（哔声）",
	"Hard acceleration alert (beep)": "急加速警报（哔声）",
	"Hard cornering alert (beep)": "急转弯警报（哔声）",
	"SSID must be_": "SSID 必须至少包含 5 个字符。",
	"Password must be_": "密码必须至少包含 8 个字符。",
	"5 to 32 characters long": "包含 5-32 个字符",
	"8 to 32 characters long": "包含 8-32 个字符",
	"Longer storage period_event": "延长实时事件上传的存储期限",
	"Requires latest firmware_": "需要最新固件。与 DR650S、DR650GW 型号不兼容",
	"After Blackvue is_": "BlackvVue 连接到云端后，将保存设置。",
	"This is an_": "该邮箱地址未被注册您想注册一个新账户吗？",
	"This feature is_": "此功能仅适用于订阅车队方案的用户。",
	"Please return to_": "帐户不存在。或者尝试使用您的 Apple 或 Google 帐户登录。",
	"Adjusting the cut-off voltage_": "Adjusting the cut-off voltage to a lower setting may result in your dash cam draining more power from your battery.\nThis could result in warning messages of battery drain or affect other vehicle functions.\nPlease consult with your dealership before lowering the voltage.",
	"Your videos will_": "您的视频可用时将显示在此处。",
	"You drove:_": "您已驾驶：{{distance}}，{{time}}",
	"Event count per_": "每小时驾驶的事件计数",
	"Are you sure_recipient": "是否确定要删除该收件人？",
	"(You)": "{{a}}（您）",
	"All events": "所有事件",
	Days_: Days_$2,
	"Requires DMC 200_": "需要 DMC 200 摄像头",
	"A DMS and compatible_": "查看此报告需要 DMS 和兼容的行车记录仪。",
	"Notifications will show_": "通知可见时将显示在此处。",
	"Try changing your_": "尝试更改您的日期或删除筛选器。",
	Mute: Mute$2,
	UnMute: UnMute$2,
	"Calling and smoking_": "通话和吸烟仅由 DMC 200 设备检测",
	"You need a DMS_": "您需要一个 DMS 来查看这个报告。",
	"Try BlackVue Cloud": "今天试用 BlackVue Cloud",
	"Individual driver looking_": "驾驶员希望实现安心驾驶？企业主需要一个简单的解决方案实现车辆安全和跟踪？",
	"Whoever you are_": "无论您是谁，无论您的需求是什么，都有一个云方案适合您!",
	"It is the account that_Driver": "此帐户在接受了所有者或管理员的电子邮件邀请后，在 BlackVue 云上加入您的车队。一个驾驶员可能只被分配到一个摄像头，只能查看他或她自己的账户资料；以及所分配的摄像头的实时取景和回放。",
	"It is the account that_Admin": "此帐户在接受了所有者的电子邮件邀请后，在 BlackVue 云上加入您的车队。管理员账户可被赋予所有者允许该管理员的权利。",
	"Video deleted": "已删除视频",
	"Video delete_plural": "已删除视频",
	"Driver removed from_": "从组中删除的驾驶员",
	"Admin removed from_": "从组中删除的管理员",
	"Camera removed from_": "从组中删除的摄像头",
	"Are you sure_videos": "希望删除所选文件吗？",
	"You have to cancel_fleet": "您必须取消程序内订阅才能更改摄像头数量：1.在 App Store 或 Google Play 商店中取消当前的订阅。您将在当前结算周期结束时降级为免费方案。您的所有数据将保持不变。2.登录您的 blackvuecloud.com 帐户并升级到车队方案。",
	Discard: Discard$2,
	"Discard unsaved changes?": "放弃未保存的更改？",
	"Incorrect serial number": "序列号错误",
	"An error occurred_again": "发生错误。请再次尝试。",
	"You are subscribed_free": "您订阅的是 BlackVue Cloud 的免费方案。",
	"When an event_": "当创建一个事件时（检测或手动触发影响），您的 BlackVue 可以通过实时事件上传从您选择的摄像头保存一个实时视频流到云服务器，包括事件发生前 5 秒的数据。",
	Report: Report$2,
	"How it work": "工作原理",
	"Cloud Camera": "云摄像头",
	"Internet Connection": "互联网连接",
	"BlackVue App/Viewer": "BlackVue App/Viewer",
	"All you need_": "您所需要的是一个",
	"Cloud-compatible BlackVue": "云端兼容的 BlackVue",
	"and a cellular_": "和一个手机数据方案。一些型号通过第三方 Wi-Fi 热点连接到云端。其他型号提供内置的 Nano SIM 卡读卡器或插入式连接模块支持。",
	"Cloud features at_": "触手可及的云功能",
	"Enjoy peace of_": "有 BlackVue 看护您的汽车，您可以享受安心时刻。如果出现任何问题，您的行车记录仪会立即给您发送信息。",
	"Let your BlackVue_": "放心使用 BlackVue 来看护您的汽车并提供事故提醒。一旦检测到撞击，BlackVue 将向您的手机或网络浏览器发送通知，并附上一张快照。",
	"Check on your_": "您可以在任何地方通过远程实时取景检查汽车。无论是通过网络浏览器还是手机，您都可以从连接到云端的行车记录仪获取实时视频资料，并在前、后或内部的摄像头之间轻松切换。",
	"Your BlackVue may_": "BlackVue 可能无法防止肇事逃逸，但如果有此事件发生，BlackVue 很有可能会捕捉到关键的视频证据。通过您的手机或网络浏览器浏览行车记录仪中的所有视频。",
	"Worried about eating_": "是否担心破坏您的数据方案？BlackVue 的子流技术可让您访问超轻版本的视频，以实现快速浏览和无缓冲观看。",
	"Move files from_": "将文件从 BlackVue 转移到云端。保存单个视频或选择多个片段进行批量上传。对于通过 BlackVue 应用程序下载到手机上的视频，您可以通过内部存储器菜单实现访问和共享。",
	"View your vehicle’s_": "实时查看车辆的位置和行驶速度。如果升级到智能方案，可以获得过去7天的 GPS 跟踪数据。",
	"Get more with_": "通过智能方案获得更多功能",
	"Unlimited Remote Live_": "无限制的远程实时取景",
	"Up to 3 dashcams_": "单个账户下最多 3 台行车记录仪",
	"Want to track_": "您是否想追踪整个车队？升级到车队方案",
	"BlackVue Fleet Tracking_2": "BlackVue 车队追踪功能是一个用于保护和跟踪车队的一体化解决方案。功能和价格可灵活调整，以满足您的业务需求。",
	"Stream real-time video_": "无限制地传输实时视频。比特率：600 kbps",
	"Up to 999 Dashcams": "多达 999 个行车记录仪",
	"Register up to_": "每个账户最多可注册 999 个行车记录仪。",
	"15GB of Cloud_": "15 GB 的云存储空间",
	"15GB per additional_": "每个额外的行车记录仪有 15 GB。无限的事件自动上载存储。",
	"90-days GPS_": "90 天的 GPS 跟踪记录",
	"High accuracy: 15_": "高精度：15 秒，地图视频，轻松导出数据。",
	"Unique fleet management_": "独特的车队管理功能提高了价值和便利性",
	"Create geofences and_": "创建地理围栏，以便在您的手机或电脑上接收实时通知。",
	"View at a_": "在可以打印或导出的表格中，一目了然地查看总行驶距离、闲置时间、超速事件等。",
	"Multi Live View": "多画面实时取景",
	"Monitor up to_": "同时监控多达 4 个行车记录仪",
	"Benefits for you": "优点",
	Individual: Individual$2,
	"Get notifications to_2": "当您停放的汽车被撞时，您的手机会收到通知。远程检查您的汽车周围发生了什么。可在网络、手机、MAC 和 Windows 上使用。",
	"Small business owner": "小企业主",
	"Monitor your commercial_2": "在地图上实时监控您的商业车辆。通过您的浏览器、BlackVue 移动应用程序、MAC 或 Windows 浏览器，随时与您的驾驶员交谈。",
	"Company with large_": "拥有大型车队的公司",
	"With BlackVue Fleet_2": "使用 BlackVue 车队追踪功能，通过您的浏览器、BlackVue 移动应用程序、MAC 或 Windows 浏览器实时追踪多达 999 辆车。",
	Subscribed: Subscribed$2,
	"The video was_": "该视频已经上传。",
	Geofence: Geofence$2,
	"500: Internal server error": "500:内部服务器错误",
	"404: Page not found": "404:找不到网页",
	"Check the web address_": "检查网页地址或回到 BlackVue Cloud 的主页",
	"home page": "Home page",
	"There isn’t an_": "没有与此邮箱地址关联的帐户",
	"You can now_password": "您现在可以用新密码登录了",
	"Are you sure_remove admin2": "是否确定要永久删除管理员？",
	"Admin deleted": "管理员已删除",
	"Members deleted": "成员已删除",
	"Are you sure_groupName": "是否确定要删除组 {{a}}？",
	"Requires latest firmware": "需要最新固件",
	"Selected file(s) moved_": "所选文件已成功迁移至云端上",
	"Are you sure_remove driver2": "是否确定要删除该组中的驾驶员 {{a}} ({{b}})？",
	"Invite sent": "邀请已发送",
	"Safe driving": "安全驾驶",
	"Reckless driving": "鲁莽驾驶",
	"Inattentive driving": "分心驾驶",
	"Driving events trend": "驾驶事件趋势",
	"Driving details": "驾驶信息",
	Driving: Driving$2,
	Idling: Idling$2,
	Distance: Distance$2,
	"Parking sessions": "停车次数",
	"Parked time": "Parked time",
	"Idle stops": "怠速停车",
	"Idle time": "怠速时间",
	"Impact events": "Impact Events",
	Parked: Parked$2,
	Speed: Speed$2,
	"Overspeeding alerts": "超速警报",
	Highest_2: Highest_2$2,
	Average: Average$2,
	Geofences: Geofences$2,
	"Entries into a_": "进入某区域",
	"Exits from a_": "从某区域离开",
	"No data": "无数据",
	"Hard acceleration": "加速",
	"Hard braking": "急刹车",
	"Hard cornering": "急弯",
	"The number within the brackets_": "括号内的数字表示每小时驾驶的平均事件数。如果您每天驾驶不到一小时，就会显示事件总数。",
	"Did you insert_": "是否已插入 SIM 卡？",
	"Click here for_": "<a>点击这里</a>获取更详细的指南。",
	"Back up all_": "<b>在保存这些设置之前，请备份所有重要的记录。</b><br/>保存设置之后会对 microSD 卡重新初始化，所有记录均被删除以确保稳定运行。",
	"Not connected to_": "没有连接到云端。一些功能已被暂时禁用。",
	"GPS Location recording off": "GPS 定位录制关闭",
	"n Videos deleted": "已删除 {{count}} 个视频",
	Move: Move$2,
	"Driver Monitoring System (DMS) will_": "驾驶员监控系统（DMS）即将推出。",
	"An error occured while_": "尝试更改摄像头数量时发生错误。再次尝试",
	"Reached the limit_": "达到限制{{a}}",
	"An invitation was_": "已经向该邮箱发送了邀请。",
	"To use the_": "要使用云功能。请插入 SIM 卡。",
	"Last updated": "最后更新于 {{date}}",
	"Try changing your date": "尝试更改日期。",
	"No event data_": "没有收集到所选时间的事件数据",
	"Please select another_": "请选择其他日期或月份来查看整个报告。",
	"more than 6_": "需要 6 个字符以上",
	"Sign up free": "免费注册",
	"Cloud storage warning": "云存储警告",
	"Cloud Storage Full": "云存储已满",
	"Cloud storage usage_100": "云存储使用量达到 100%。请清理一些存储空间，以便能够使用实时事件上传",
	"Cloud storage usage_": "云存储用量达到 <b>({{a}}%)</b>。\n 请管理云存储空间。\n如果云存储空间已满，则实时事件上传服务不可用。",
	"Are you sure_delete_zone": "确定删除?",
	"Search Name or email": "搜索姓名或电子邮件",
	"Search group name": "搜索组名",
	"Please note that_": "请注意，视频录制将暂停几秒钟，以应用新的设置。",
	"Currently connected Hotspot": "当前连接的热点",
	"Enhanced night vision": "增强夜视",
	"To access the_": "如需访问摄像头，请更新订阅方案。",
	"Restarting the Blackvue_": "为了应用设置，BlackVue将重启",
	"Hard acceleration event_": "当每秒加速超过 {{kmh}} 公里/小时（{{mph}} 英里/小时）时，就会发生急加速事件",
	"Hard braking event_": "当每 \n 秒减速超过 {{kmh}} 公里/小时（{{mph}} 英里/小时）时，就会发生急减速事件",
	"Hard cornering event_": "在驾驶速度超过 \n {{kmh}} 公里/小时（9英里/小时）时，如果在 2 秒内发生超过 60 度的旋转，就会发生急转弯事件",
	"Changes you made_": "您所做的更改可能不会被保存。",
	"My location": "我的位置",
	"Hotspot name (SSID)": "热点名称 (SSID)",
	Connected: Connected$2,
	"Camera will be rebooted_": "摄像头将被重启。是否还想继续？",
	"Restarting the BlackVue_": "重新启动 BlackVue。请稍等片刻。",
	"Failed to reboot_": "摄像头重启失败",
	"Bluetooth (Parking mode)": "BT （停车模式）",
	"Front and interior camera_": "前置和内置摄像头同时录制。",
	"Interior camera stops_": "进入停车模式 5 分钟后，内置摄像头停止录制。进入正常模式时录制重新开始。",
	Individual_: Individual_$2,
	"Driver detection": "驾驶员检测",
	"During driving only": "仅在行驶中",
	Always: Always$2,
	"Driver detection box": "驾驶员检测箱",
	"DMS camera rotation": "DSM 相机旋转",
	Low: Low$2,
	Medium: Medium$2,
	High_2: High_2$2,
	"Reboot Camera": "重启摄像头",
	"Latest events": "最新事件",
	"G-Sensor": "G-Sensor",
	"Playback speed": "播放速度",
	Flip: Flip$2,
	Previous: Previous$2,
	Next: Next$2,
	"Map type": "地图类型",
	"Zoom in": "放大",
	"Zoom out": "缩小",
	"Move to Cloud": "移至云端",
	"Please recognize that_": "请知悉视频录制会暂停几秒钟来应用设置。",
	"6 characters with_": "6 个字符，包含字母、数字和符号",
	"Updating firmware": "更新固件",
	"Overspeed event occurs_": "当行车记录仪警告驾驶员超过速度限制时，就会发生超速事件。您可以通过“固件” > “系统” > “音量”选项进行更改。",
	"Enter group name": "输入组名",
	"Live view failed": "直播实时行车影像失败",
	"Parking mode enter_": "进入/退出停车模式",
	"Cloud connectivity": "云连接",
	Expand: Expand$2,
	Collapse: Collapse$2,
	"all day": "全天",
	"Driving style": "驾驶风格",
	"Driving impact": "行驶影响",
	More: More$2,
	"No cameras to_": "没有摄像头可以添加",
	"You have added_": "您已经添加了所有可用的摄像头。",
	Multi: Multi$2,
	"Report video": "举报视频",
	"Sexually explicit content": "色情内容",
	"Graphic violence": "暴力或令人厌恶的内容",
	"Hateful speech": "仇恨或辱骂内容",
	"Harassment or bullying": "骚扰或欺凌",
	"Spam or advertisement": "垃圾邮件或广告",
	"Infringement of my_": "侵犯了我的权利",
	"Other reason": "其它",
	"Reason for reporting": "举报理由",
	"Reported videos will_": "将在72小时内对被举报的视频进行检查。在确认该视频适合发布在 Event Map 上之前，该视频将不会显示在 Event Map 上。",
	"Touch sensor": "触摸传感器",
	"Motion and impact detection": "运动和碰撞检测",
	"Settings have been changed": "设置已更改",
	"Start event recording (beep)": "开始事件录制（蜂鸣）",
	"Scheduled reboots": "预定重启",
	Safe: Safe$2,
	Reckless: Reckless$2,
	Inattentive: Inattentive$2,
	"Highest(Extreme)": "最高 (Extreme)",
	"Public cameras": "公共摄像头",
	List: List$2,
	Usage: Usage$2,
	"Video playbacks and downloads": "视频回放和下载",
	"of 100 times": "100 次",
	"of 10 minutes": "10 分钟",
	Profile: Profile$2,
	"Search geofences": "搜索地理围栏",
	"Export CSV": "导出 CSV",
	"Exit fullscreen": "退出全屏",
	Fullscreen: Fullscreen$2,
	Upgrade: Upgrade$2,
	"Email address": "电子邮件地址",
	"of Unlimited": "无限制",
	"No notifications yet": "在过去7天内未收到通知。",
	"No videos yet": "暂无视频",
	Management: Management$2,
	Day: Day$2,
	Month: Month$2,
	"Welcome to the BlackVue_": "欢迎来到 BlackVue Cloud Viewer",
	"You can access BlackVue_": "您可以随时随地从网上访问 BlackVue Cloud！",
	"Start tour": "开启精彩之旅",
	"Map view": "地图视图",
	"Check the current_": "检查您的摄像头和公共摄像头当前的 GPS 位置和速度。",
	"Camera’s features": "摄像头的功能",
	"Take a look_": "了解一下 BlackVue 摄像头提供的各种云相关功能。",
	"Visualize your vehicle’s_": "显示您车辆在一段时间内的驾驶路线。",
	"Smart plan_": "智能方案：90 天，队方案：90 天",
	"Create geofences and2_": "创建地理围栏并接收实时通知。",
	"Got it": "明白了",
	"Manage Fleet members": "管理队成员",
	"Invite fleet members_": "邀请队成员，并将他们分配到群组。",
	"The moment the_": "摄像头检测到碰撞的瞬间，通知将在这里列出。",
	"Geofence Setup (Web)_": "地理围栏设置（网络/桌面）和告警",
	"Original file play_": "原始文件播放只能下载",
	"To get most_": "为了充分利用 BlackVue Cloud Viewer，您的摄像头必须连接到云端。下载 BlackVue 应用程序，体验无缝配对功能，从摄像头添加到云端连接，一气呵成!",
	"You haven’t driven_Today": "您今天还没有驾驶您的车辆。尝试使用 BlackVue 来驾驶，可查看您的驾驶报告。",
	"You haven’t driven_Month": "您本月还未驾驶您的车辆。尝试使用 BlackVue 来驾驶，可查看您的驾驶报告。",
	"Fleet Plan only_": "仅适用于队方案",
	"Overwrite locked event2_": "当存储空间已满时，锁定的事件文件将被覆盖",
	"DMS’s New firmware_": "可获得 DMS 的新固件",
	"Highest speed_report": "<b>最高的速度<b/>\n所收集速度数据的最大值，以米为单位进行收集，转换为 Km/h 和 MPH 单位\n\n<b>平均速度<b/>\n(距离/驾驶时间) *3600 平均速度。例如（2622/1208）*3600=7814.907\nKm/h：只允许整数，\nMPH 的小数点在整数下最多 2 位",
	"Choose a cloud_": "选择云连接方法",
	"You need an_": "您需要通过互联网连接来连接到云端。选择用于连接到云端的设备。",
	"BlackVue SIM card": "BlackVue SIM 卡",
	"Support model_": "支持型号：DR750X-2CH LTE Plus (NA)",
	"3rd party SIM_": "第三方 SIM 卡",
	"Support model_SIM": "支持型号：DR750X-2CH LTE Plus，DR750-2CH LTE，CM100 LTE",
	"Wi-fi hotspot": "Wi-Fi 热点",
	"Support model_Wifi": "支持型号：所有 BlackVue 型号",
	"How to connect_": "如何连接云端",
	"Download BlackVue application": "下载 BlackVue 应用程序。",
	"*If you are_": "*如果您要使用 BlackVue 的 SIM 卡进行云端连接，转至 {{a}}{{b}}。",
	"Place your phone_": "将您的手机放在摄像头的蓝牙范围内。通过 {{a}} 开始无缝配对。",
	"Back to camera_": "返回到摄像头列表",
	"Upgrade for more_": "升级以获得更多功能!",
	"Upgrading the cloud_": "升级云套餐后，您可以享用更多功能以及管理多个摄像头。您是否愿意升级云套餐？",
	"Explore cloud plans": "了解云套餐",
	Later: Later$2,
	"Successfully subscribed": "订阅成功！",
	"1GB data plan": "1 GB 流量套餐",
	"First month free_": "第一个月免费，<a>之后 10.99 美元/月</a>",
	"Next billing date": "下一个账单日",
	"Once SIM card_": "将 SIM 卡插入摄像头后，您可以立即启动 BlackVue Cloud 功能。",
	"Go to SIM_": "转至 SIM 卡管理",
	"Manage your BlackVue_": "在此处管理您的 BlackVue SIM 卡！",
	"Recommended for BlackVue_": "推荐用于 BlackVue SIM 卡座",
	"Connect to cloud": "连接云端",
	"Enter BlackVue SIM_": "输入 BlackVue SIM ICCID 号",
	"ICCID number is_": "ICCID 号印在 SIM 卡包装上。请输入 ICCID 号的最后 14 位数字。",
	ICCID: ICCID$2,
	"SIM information": "SIM 卡信息",
	"Start your free_": "立即开始免费试用",
	"SIM card activate_": "SIM 卡激活日期",
	"Based on the_": "基于 SIM 卡插入摄像头并在通电时激活的日期",
	"Upgrade to 3GB_": "随时升级至 3 GB/5 GB 套餐",
	"Cancel your plan_": "随时取消您的套餐",
	"No Commitment": "无需承诺",
	"Precautions for using_": "使用服务相关注意事项",
	"After 1GB is_": "1 GB 用完后，将无法继续联网。",
	"If you have_": "如果您已将 SIM 卡插入摄像头并一直在使用，则免费试用期从您开始使用卡时开始计算。",
	"This content is_": "此内容在 SIM 卡包装上有说明。我们不支持对未提供的免费时段进行补偿。",
	"If you have_2": "如果您有其它问题，请联系 <a>CS 团队</a>",
	"When OFF, connecting_": "关闭时，将禁用通过无缝配对连接摄像头的功能。",
	"1 month free": "免费试用 1 个月",
	"No commitment. Cancel_": "无需承诺随时取消。",
	"The video has been reported_": "已成功举报视频",
	"Free for 1 month": "免费试用 1 个月",
	"Start your free_2": "开始免费试用",
	"1GB free for_": "1 GB 免费 {{a}} 天",
	"1GB data": "1GB 流量",
	"1 month free_2": "1 个月的免费试用期将从 {{a}} 开始，包括 Blackvue SIM 卡的 1GB 流量。",
	"Your next billing_": "您的下一个账单日是 {{a}}",
	"SIM card": "SIM 卡",
	"SIM guide": "SIM 卡指南",
	"SIM card list": "SIM 卡列表",
	"Add SIM card": "添加 SIM 卡",
	"No SIM card_": "暂无 SIM 卡",
	"Search SIM ICCID_": "搜索 SIM ICCID 或名称",
	"Cloud disconnected. Failed_": "云已断开连接。无法播放视频",
	"This sim card_": "此 SIM 卡已在另一个帐户中注册。",
	"Incorrect BlackVue SIM_": "BlackVue SIM ICCID 不正确",
	"My shared videos": "我分享的视频",
	"Number of events": "事件数",
	"Added to Event Map": "已添加到 Event Map",
	"Successfully added video(s)_": "已成功添加视频以分享到 Event Map！如果您想查看状态以及管理共享视频，请选择 Event Map > 我分享的视频。",
	"Already added to_": "已添加到 Event Map",
	"This video(s) is already added_": "该视频已添加到 Event Map！如果您想查看状态以及管理共享视频，请选择 Event Map > 我分享的视频。",
	"BlackVue’s firmware is up_": "BlackVue 的固件是最新的",
	"Service end": "服务端",
	Resubscribe: Resubscribe$2,
	"Sort ascending": "升序排序",
	"Sort descending": "降序排序",
	plan: plan$2,
	USD: USD$2,
	"Are you sure_Cancel": "是否确定要取消订阅？请注意以下事项并在下方确认。",
	"Your current SIM_": "您当前的 SIM 卡订阅将于 {{a}}结束，您将不再需要付费。",
	"After canceling your_": "取消 SIM 卡订阅后，您将继续使用 SIM 卡流量，直到订阅结束日期为止。",
	"You can resubscribe_": "您可以在当前订阅结束后的 1 个月内重新订阅。如果您想重新订阅，请点击 SIM 卡列表中的“重新订阅”按钮，通过 {{a}} 重新订阅。",
	"Reason to cancel_": "取消订阅的原因",
	"Found an alternative": "找到了替代品",
	"Too expensive": "太贵了",
	"Not required anymore": "不再需要",
	"Quality issue": "质量问题",
	etc_: etc_$2,
	"Please describe in_": "请详细描述",
	"SIM card cannot_": "无法删除 SIM 卡，因为该 SIM 卡正在订阅中。如果您想删除该 SIM 卡，请先取消订阅。",
	"SIM card cannot_2": "无法删除 SIM 卡，因为该 SIM 卡的订阅尚未结束。请在订阅结束后重试。",
	"Are you sure_deleteSIM": "是否确定要删除该 SIM 卡？<br/>\n<b>警告：无法撤销此操作。您所有 SIM 卡信息都将立即被删除。</b>",
	"ICCID number": "ICCID 号",
	"Activation date": "激活日期",
	"Current plan": "当前套餐",
	"Manage Plan": "管理套餐",
	"Next billing on": "下个账单日",
	"View Invoices": "查看发票",
	"Choose best plan_": "选择最适合您的套餐",
	"Plan summary": "套餐摘要",
	"Ends on_": "于 {{a}} 结束",
	"Start from_": "从 {{a}} 开始",
	"Your subscription will_": "当前的套餐结束时，您的订阅将在 {{a}} 升级。",
	"Resubscribe plan": "重新订阅套餐",
	"Your subscription will2_": "当前的套餐结束时，您的订阅将于 {{a}} 开始。",
	"Usage is estimated_": "估计使用截至 {{a}}",
	"Days left_": "还剩 {{a}} 天",
	"Data usage cycle": "流量使用周期",
	Available: Available$2,
	Used: Used$2,
	"Data used": "已使用流量",
	"Subscribe to n_": "订阅从 {{b}} 到 {{c}}</b> 应用的 {{a}} 数据套餐和从 {{e}} 应用的 {{d}} 数据套餐",
	"Will be charged_": "将于 {{a}} 收取费用",
	"Monthly usage": "每月使用量",
	"You have fewer_": "您本月的剩余流量较少！",
	"Get more data": "获取更多流量！",
	"This video cannot be shared": "该视频无法分享",
	"This is a video cannot be shared_": "该视频无法分享，因为当时无法找到驾驶信息。",
	Cancelled: Cancelled$2,
	Terminated: Terminated$2,
	"Edit name": "编辑名称",
	"Not connected to_2": "没有连接到云端。检查您的摄像头是否已打开，以及互联网连接模块是否已启用。",
	"Some functionality is disabled_": "由于摄像头未连接到云，某些功能被禁用。<a>此处</a>可连接到云端。",
	"If you want to cancel_": "如果您想取消您的套餐，请单击<a>取消订阅</a>。",
	"Select plan": "选择套餐",
	"Event map collects_": "Event Map 收集并显示 BlackVue 事件信息，以提供周围道路的情况信息。",
	"Share your Live_": "分享您的直播事件上传文件。您可以与周围的用户分享您的事件视频。",
	"You can check_": "您可以查看其他人分享的事件视频。",
	"Service end_": "服务结束：{{a}}",
	"DMS camera recording_": "停车模式下的 DMS 摄像头录制",
	Sort: Sort$2,
	"Are you sure you want_": "是否确定要从 Event Map 中删除共享视频？",
	"Remove shared video": "移除共享视频",
	"Explore event map": "了解 Event Map",
	"Event map": "Event Map",
	"Explore the graphic_": "了解您周围发生的 BlackVue 事件的图形统计数据。",
	"You can filter_": "您可以过滤和查看要显示的事件。",
	"This video was removed by_": "该视频已被管理员举报并删除。",
	Bonus: Bonus$2,
	"Your subscription plan": "您的订阅套餐",
	"Your free trial will_": "您的免费试用期将从 {{a}} 开始，</br> <strong>直到</strong> {{b}}。",
	"Total after free trial": "免费试用后总计",
	"This sim card is_": "此 SIM 卡不再有效。",
	"Firmware is up_": "固件是最新的",
	"Keep in mind": "记住",
	"Once 1GB of_": "使用 1 GB 流量后，该服务将在下一个流量重置日期[或在您将套餐升级到更高级别之后]才可用。",
	"After the SIM_": "SIM 卡插入摄像头后，免费试用期从您开始使用数据时开始计算。",
	"If you have_questions": "如果您有任何问题，请联系我们的<a>客户支持。</a>",
	"Data reset date": "流量重置日期",
	"To use SIM card_": "如需使用 SIM 卡，请联系 BlackVue <a>CS 团队</a>",
	"Go to Subscription": "去订阅",
	"An error occurred_subscription": "订阅所选套餐时出错。",
	"Please try again": "请再次尝试",
	"Failed to subscribe": "订阅失败",
	"Go to Pricing": "转至价格",
	"SIM cards will_": "SIM 卡可用时将显示在此处。",
	"1GB for 1_": "1 个月 1 GB",
	"Pricing Data": "价格资料",
	"If you would like to check_": "如果您想查看状态以及管理共享视频，请选择 Event Map > 我分享的视频。",
	"Connect to Cloud": "连接云",
	"Completed!": "完成！",
	"Back to App": "返回应用程序",
	"iOS in-app purchase": "iOS 应用内购买",
	"Android in-app_": "Android 应用内购买",
	"bonus n days": "奖金 {{a}} 天",
	"Want to contribute your_": "是否将事件自动上传文件自动共享到 Event Map？",
	"With event map_": "您可以通过 Event Map 与附近的驾驶员分享事件自动上传视频。",
	"You can edit_3": "您可以随时选择 BLACKVUE CLOUD > 摄像头设置 > 隐私设置，对将事件自动上传文件自动共享到 Event Map 的相关设置进行编辑。",
	"If you want to remove videos_": "由于要传送个人视频，因此您需要特别仔细决定要分享哪些信息。",
	"Total events": "总事件",
	"Automatically add Live Event_": "将事件自动上传文件自动分享到 Event Map",
	"This camera is publicly_": "该摄像头仅针对其位置公开开放。",
	incomplete_zip: incomplete_zip$2,
	"Live Event Upload_": "直播事件上传（保存期限：7 天）\n需要最新固件",
	"Thank you for_2": "感谢您的耐心等待。",
	"Start Web viewer": "启动 Web 查看器",
	"Are you sure_remove driver": "是否确定要永久删除驱动程序",
	"An error occurred_sim": "尝试订阅时出错。",
	"Click the ADD SIM": "单击 SIM 卡列表页面上的添加 SIM 卡按钮，然后再次进行 SIM 卡的添加过程。",
	"Set download options": "设置下载选项",
	"Information may be_": "Information may be transmitted with a delay and may not reflect actual balances.",
	"Swipe left and right to move": "通过左右滑动来移动",
	"Scheduled maintenance Notice": "定期维护通知",
	"Our Cloud server_": "我们的云服务器即将进行定期维护。",
	"During that time_": "在此期间，您可能无法使用云功能。",
	"Expected maintenance start_": "预计维护开始时间：",
	"Expected duration_": "预计持续时间：{{a}} 小时。",
	"For more information_": "更多信息请参考<a>【服务器维护公告】</a>",
	"Do not remind_": "不再提醒",
	"Cloud Server Maintenance": "云服务器维护",
	"BlackVue Cloud Service_": "BlackVue 云服务暂时不可使用",
	"We are currently_": "我们目前正在进行维护。",
	"We apologize for_": "我们对造成的不便表示抱歉。",
	"Driver Monitoring System (DMS)": "驾驶员监控系统 (DMS)",
	"Distracted occurs_": "当驾驶员的头部离前方超过50度时发生。",
	"Hand distraction event occurs_": "当驾驶员的手在头部附近被连续检测到一段时间时发生（例如吸烟，拿手机等）。",
	"Mask off event occurs_": "当驾驶员未戴口罩上车时或驾驶员摘下口罩时发生。",
	"DMS setting": "DMS 设置",
	"The DMS system has_": "DMS结合了于\"Detected\"、\"Undetected\"、\"Distracted\"、\"Drowsiness\"、\"Mask Off\"状态的人脸检测框和用于\"Hand Distraction\"状态的动作检测框。",
	"DMS detection": "DMS 检测",
	"There are detection criteria for_": "每个事件都有检测标准。请参考下面的指南。",
	"DMS camera recording_onoff": "开启：只要保持供电，DMS 摄像头会在停车模式下持续录制。 <br/> 关闭：DMS 摄像头在进入停车模式后会立即关闭电源。",
	"LED lighting for each event_": "驾驶员监控摄像头上的LED会在每个检测事件（分心、昏昏欲睡等）发生时进行信号提示。",
	"Drowsy and Distracted each have_": "疲劳驾驶和分心驾驶各有三个灵敏度条件。\n 请参考以下指导界面。",
	"DMS event detection sensitivity": "DMS 事件检测灵敏度",
	"Only drowsy and distracted include_": "只有疲劳驾驶和分心驾驶含有灵敏度设置。而且，设置的灵敏度通过一次设置对两个事件适用相同的灵敏度。",
	"When driver’s eyes close_": "当驾驶员连续闭眼驾驶超过1秒或打哈欠2秒以上时发生。\n",
	"n digit": "{{a}} 位数",
	"You are subscribed_free_Smart": "您已订阅 BlackVue Cloud 的智能套餐。",
	"Wi-Fi auto turn on": "Wi-Fi 自动开启",
	"Video on a map": "Video on a map",
	"This feature is only_vom": "This feature is only available to users with a Fleet Plan subscription.<br/>Please subscribe to a plan to unlock this feature.",
	"Total n days_": "免费评价版共{{a}}天\n",
	"Every events of DMC200_": "DMS检测功能仅在普通模式下生效。如果在停车模式下供电，DMS摄像头仅录制视频。",
	"An undetected event occurs_": "当驾驶员在摄像头前面连续1分钟未被检测到时发生。",
	"A detected event occurs_": "A detected Event occurs when the driver is gazing in front since the power is set in the beginning.",
	"Drowsy sensitivity_": "High : When the driver closes their eyes for more than 1 second, it is considered drowsy driving.<br/><br/>Medium : When the driver closes their eyes for more than 1.5 second, it is considered drowsy driving.<br/><br/>Low : When the driver closes their eyes for more than 2 second, it is considered drowsy driving.",
	"Distracted sensitivity_": "High : If the angle of the head is more than 50 degrees away from the front for 3 seconds, it is detected as Distracted.<br/><br/>Medium : If the angle of the head is more than 50 degrees away from the front for 5 seconds, it is detected as Distracted.<br/><br/>Low : If the angle of the head is more than 50 degrees away from the front for 7 seconds, it is detected as Distracted.",
	"Start your subscription now": "现在就开始订阅吧",
	"Free trial period has expired": "免费试用期已过",
	"1 data plan will start from_": "流量套餐将从 {{a}} 开始，包括 Blackvue SIM 卡的 1GB 流量。",
	"Allow the BlackVue_": "是否允许 BlackVue App 访问您的行车记录仪 GPS 数据？",
	"We use this_": "我们用此数据让您能够追踪车辆的位置和速度。",
	"You can edit_": "您可进入 BLACKVUE CLOUD > 摄像头设置 > 隐私设置，随时编辑 GPS 访问设置。",
	"SIM cards": "SIM 卡",
	"Subscription status": "订阅状态",
	Upgrades: Upgrades$2,
	"Upgrade plan": "升级计划",
	"Manage plan": "管理订阅计划",
	"Next plan": "下个月的订阅计划",
	OR: OR$2,
	"Cancel subscription": "取消订阅",
	Undo: Undo$2,
	Invoice: Invoice$2,
	"Daily usage": "每日数据使用量",
	"Delete SIM": "SIM 删除",
	"New card": "新信用卡",
	data: data$2,
	"SIM card data_": "可以在 <a>sim.blackvuecloud.com</a> 网址取消 SIM 卡流量套餐订阅。",
	"Your plan from_": "从今天起至下一个账单日期的套餐",
	"Applied during_": "从 {{a}} 至 {{b}} 有效",
	"From today until_": "从今天起至下一个付款日，您只能订购与上个月相同的套餐。对于这段时间的付款，将在今天开具账单。<a>费用按比例进行计算。</a>",
	"Choose your next plan": "选择下一个套餐",
	"Applied from_": "从 {{a}} 开始生效",
	"Payment for this_": "此套餐的付款将在 {{a}} 收取。",
	"By sharing your_2": "通过分享 Live View，您可让其他用户间接体验到在全世界驾驶的兴奋与乐趣。不过，由于要传送个人视频，因此您需要特别仔细决定要分享哪些信息。",
	"Option camera recording_": "停车模式下的可选摄像头录制",
	"Front and option camera_": "前置摄像头和可选摄像头同时录制。",
	"Option camera stops_": "可选摄像头在进入停车模式 5 分钟后停止录制。进入正常模式时录制重新开始。",
	"Option camera rotation": "可选摄像头旋转",
	"Option camera": "可选摄像头",
	"Option camera security": "可选摄像头安全",
	"Resubscribe until_": "重新订阅，直到：{{a}}",
	"Firmware Update Caution": "固件更新注意事项",
	"Please check below_": "在为 DMC200 进行固件更新之前，请检查以下条件：",
	"The camera's Wi-Fi_": "摄像头 Wi-Fi 必须开启",
	"Check if your_": "检查摄像头 Wi-Fi 是否打开。",
	"DO NOT disconnect_": "在固件更新过程中，请勿断开同轴电缆。",
	"The camera and_": "摄像头和 DMC200 可能会出现故障。",
	"DO NOT try_": "在摄像头重启结束之前，不要尝试使用其他功能。",
	"Expecially Reboot camera_": "特别在重启摄像头时，SD 卡格式可能是两个设备故障的关键因素。",
	"Update anyway": "仍然要更新",
	"Invited on_2": "您于 {{Invited Date}} 日邀请。所有者",
	"BlackVue’s New firmware_": "可获得 BlackVue 新固件",
	"valid thru_": "有效期至：{{a}}",
	"Billed monthly": "Billed monthly",
	"90 minutes Live_": "90 minutes Live View / Live Event Upload*",
	"or 2+ videos_": "or 2+ videos in full resolution*",
	"1GB Free Month_": "1GB Free Month Trial",
	"Cancel anytime": "Cancel anytime",
	"8+ hours Live_": "8+ hours Live View / Live Event Upload*",
	"or 12+ videos_": "or 12+ videos in full resolution*",
	"15+ hours Live_": "15+ hours Live View / Live Event Upload*",
	"or 23+ videos_": "or 23+ videos in full resolution*",
	Popular: Popular$2,
	"For Power Users": "For Power Users",
	"Estimates based on_": "* Estimates based on 4.5MB per minute of Live View, Quick View remote playback, or Live Event Upload file, and 190MB per full original resolution video download or playback (at 25Mbps bitrate). Daily idle Cloud connection data usage: 20MB per 24 hours. Data usage is shared among all types of services (Live View, Live Event Upload, etc.).",
	"Balanced Plan": "Balanced Plan",
	"For Light Cloud_": "For Light Cloud Use",
	"Front security (Normal mode)": "前置安全（正常模式）",
	"Front security (Parking mode)": "前置安全（停车模式）",
	"BT (Parking mode)": "蓝牙（停车模式）",
	"LTE (Parking mode)": "LTE（停车模式）",
	"Wi-Fi (Parking mode)": "Wi-Fi（停车模式）",
	"Hand distraction": "手部注意力分散",
	Mask: Mask$2,
	"Second drowsy is_": "第二次疲劳驾驶是指在首次疲劳驾驶后 30 秒内发生的疲劳驾驶，首次疲劳驾驶开启实时事件上传录制。",
	"Second drowsy alert": "第二次疲劳驾驶提示",
	"BlackVue sim card_": "BlackVue SIM 卡只能在加拿大和美国使用。",
	"Global support is coming soon.": "即将支持全球范围内使用。",
	"The video file not found_": "未找到视频文件，或播放时出现问题。请再试一次。",
	"Start Voice Call": "开始语音通话",
	"End Voice Call": "结束语音通话",
	"Voice call in use": "语音通话使用中",
	"Enable microphone access_": "启用麦克风访问，以使用双向语音通信功能。进入浏览器设置页面，以访问麦克风。",
	"You may need to_": "您可能需要重新加载该页面，新的设置才能生效。",
	"Eye status": "眼睛状态",
	"Start time of live event upload video": "实时事件上传视频的开始时间",
	"Left eye": "左眼",
	"Right eye": "右眼",
	"Drowsy is occured when the driver close his/her eyes more then 1sec": "当驾驶员闭眼超过 1 秒时，就会认定为疲劳驾驶。",
	"Driver's Left eye movements with blinking count and period": "驾驶员的左眼动作与眨眼次数和周期数以及周期",
	"Driver's Right eye movements with blinking count and period": "驾驶员的右眼动作与眨眼次数和周期",
	"Drowsy big data of the driver and after a Drowsy event occurs": "疲劳驾驶事件发生后，驾驶员的眨眼情况大数据",
	"Sharing video to Event Map": "将视频分享到 Event Map",
	"Want to use a Voice call?": "是否想使用语音通话？",
	"To use a voice call_": "要使用语音通话，请重新启动 Live View 并点击“允许”",
	"There is no_": "目前还没有共享的视频。\n当它被共享时，会出现一个列表。",
	"Microphone blocked": "麦克风已屏蔽",
	"Want to center the map on your location?": "想要将地图以您的位置为中心？",
	"To let the app access your location_": "要让应用程序访问您的位置，请重新启动 Event Map 并在出现提示时选择“确定”。",
	"Location access permission required": "需要位置访问权限。",
	"Are you sure you want_2": "确定要从 Event Map 中删除此视频吗？",
	"Two-way voice_2": "Two-way voice communication / Voice Call",
	"Not supported by DR650GW and DR650S_": "Not supported by DR650GW and DR650S",
	"DR650S Series only_": "DR650S Series only",
	"Cancel download?": "取消下载？",
	"Your download is not_": "当前下载尚未完成。是否要取消下载？",
	"Continue download": "继续下载",
	"Cancel download": "取消下载",
	"Share your video to the Event Map?": "将您的视频分享到 Event Map？",
	"Afterwards, according to the reaction to the video_": "之后，根据视频的热度，此视频可归类为流行视频并在热门视频上推介。",
	"Add hashtags and a brief description to describe your video.": "为您的视频添加主题标签和简短描述。",
	"Would you like_": "是否要分享到 Event Map？",
	"Successfully added video_": "已成功添加视频以分享到 Event Map！",
	"This video cannot_": "该视频缺少地图定位 GPS 位置数据，无法分享。",
	"This video is_": "该视频已添加到 Event Map。",
	"Share to Event Map": "分享到 Event Map",
	"Describe in more_": "更详细地描述视频内容（可选）",
	"Description(optional)": "描述（可选）",
	"Recording mode": "录制模式",
	"Event triggers": "事件触发器",
	DMS: DMS$2,
	"Camera connectivity": "摄像头连接情况",
	"If not allowed_2": "如不允许，将无法通过云访问您的车辆位置和速度。",
	"Share Live View_": "分享实时取景视频",
	"Share Live View_2": "分享实时取景音频",
	"Share camera profile": "分享摄像头配置文件",
	"Parking impact": "停车影响",
	"Parking events": "Parking Events",
	"Audio recording": "音频录制",
	"Toggle the mic_": "打开/关闭麦克风",
	"Full HD_": "Full HD @ 60fps + Full HD @ 30fps",
	"Video quality": "视频质量",
	Extreme: Extreme$2,
	"More video files": "更多录制文件",
	"Fewer video files": "更少录制文件",
	"Camera rotation": "后置摄像头旋转",
	"Video overlay": "视频覆盖",
	"Date & time display": "显示日期和时间",
	"Speed unit": "速度单位",
	"Check the orientation_": "请检查安装在车辆中的前置摄像头朝向。选择匹配选项，竖屏录制视频。",
	"Rotate 180º": "旋转 180º",
	"Rear camera rotation": "后置摄像头旋转",
	"Check the orientation_rear": "请检查安装在车辆中的后置摄像头朝向。选择匹配选项，竖屏录制视频。",
	"Mirror View": "镜像取景",
	"Select Mirror View_": "选择镜像取景，水平翻转视频。",
	"Check the orientation_interior": "请检查安装在车辆中的可选摄像头朝向。选择匹配选项，竖屏录制视频。",
	"Display off": "显示关闭",
	"Explore crowd-sourced Events_": "在地图上探索众包事件（碰撞、急刹车等），查看社区共享的视频并分享自己的事件。",
	OFF: OFF$2,
	"Reboots once-a-day_": "如果处在停车模式，每天在设定时间重启一次可提高稳定性。",
	"Set time": "设置时间",
	"FW language": "固件语言",
	"Rear security_2": "后置安全",
	"Bluetooth (Parking mode)_2": "蓝牙（停车模式）",
	"Failed to save_2": "未能保存实时事件上传设置",
	"Event file will_": "事件文件会自动保存在实时事件上传存储单元中。",
	"An impact was_": "An Impact was detected during Parking Mode.",
	"When exiting Parking_": "退出停车模式时，如果在停车模式期间检测到碰撞，您的 BlackVue 会发出通知。\n\n注意：\n 碰撞将生成事件视频。在退出停车模式 3 分钟内发生的碰撞会被忽略。",
	"Protect event files": "保护事件文件",
	"Turning on this_": "开启以避免最近{{a}}个事件文件被正常或停车录制文件覆盖。",
	"Impact Events in_": "受保护的文件包括：\n\n正常 (E) 和停车模式 (I) 下的碰撞事件",
	"Manual Events_": "手动录制事件 (M)",
	"Once 50 Events_": "录制事件达到{{a}}条后，新事件将会覆盖最早的事件。",
	"Reckless driving unit": "鲁莽驾驶单位",
	"Hard acceleration Event": "急加速事件",
	Threshold: Threshold$2,
	"Triggers when the_": "摄像头检测到每秒加速度超过设定阈值时触发。",
	"Triggers when the_2": "摄像头检测到减速超过设定阈值时触发。",
	"Hard braking Event": "急刹车事件",
	"Triggers when more_": "超过设定阈值行驶时，在 2 秒内检测到超过 60 度时触发。",
	"Every event of DMC200_2": "DMS检测功能仅在正常模式下生效。如果在停车模式下供电，DMS摄像头仅录制视频。",
	"The DMS system has_2": "DMS结合了于“Detected”、“Undetected”、“Distracted”、“Drowsiness”、“Mask Off”状态的人脸检测框和用于“Hand Distraction”状态的动作检测框。",
	"One for face_": "One for face detection : Detected, Undetected, Distracted, Drowsy",
	"The other for_": "The other for motion detection",
	"On: Normal recording_": "On: Normal recording works while power is maintained in Parking Mode",
	"Off: DMS power_": "Off: DMS power off after 5 minutes when entering Parking Mode, Normal recording works until just before off",
	"Drowsy and Distracted_": "Drowsy and Distracted each have three sensitivity conditions.",
	"Please refer to_": "Please refer to the guide interface below.",
	Drowsiness: Drowsiness$2,
	"Drowsiness occurs when_": "疲劳会在驾驶员驾驶时闭上双眼超过1秒并打哈欠2秒时发生。",
	"Distracted occurs when_": "当驾驶员的头部离前方超过50度时发生。",
	"A hand distraction_": "A hand distraction occurs when the driver removes one hand from the steering wheel. [*Smoking and phone calls may be suspected.]",
	"Mask off event_": "Mask-off event occurs in two ways. First is when the driver gets in the car without a mask. Second is when the driver takes their mask off",
	"High When the_": "High : When the driver closes their eyes for more than 1 second, it is considered drowsy driving.",
	"Middle When the_": "Medium : When the driver closes their eyes for more than 1.5 second, it is considered drowsy driving.",
	"Low When the_": "Low : When the driver closes their eyes for more than 2 second, it is considered drowsy driving.",
	"High If the_": "High : If the angle of the head is more than 50 degrees away from the front for 3 seconds, it is detected as Distracted.",
	"Middle If the_": "Medium : If the angle of the head is more than 50 degrees away from the front for 5 seconds, it is detected as Distracted.",
	"Low If the_": "Low : If the angle of the head is more than 50 degrees away from the front for 7 seconds, it is detected as Distracted.",
	Direct: Direct$2,
	"Camera Wi-Fi credentials": "摄像头 Wi-Fi 证书",
	"Network name(SSID)": "网络名称（SSID）",
	"Seamless pairing": "Seamless Pairing",
	Remote: Remote$2,
	"Hotspot settings": "热点设置",
	"Hotspot name": "热点名称 (SSID)",
	"Hotspot name must_": "Hotspot name must be at least 5 characters long",
	"Public cameras may_": "公共摄像头可能出现在“探索”选项卡或世界地图上。",
	"Hard Cornering Event": "急转弯事件",
	"Over speed_2": "超速",
	"Second drawiness alert": "第二次疲劳驾驶提醒",
	"Low Voltage Warning_2": "手部注意力分散",
	"(You)_2": "{{a}}（您）",
	"This video has been reported_": "该视频已被管理员举报并删除。",
	"Normal Mode recording": "正常模式录制",
	"ON : the camera_": "开：摄像头循环持续录制。",
	"OFF : the camera_": "关：摄像头仅在行驶时录制事件视频。",
	"In both modes_": "在两种模式下，检测到的碰撞都会触发事件视频录制。",
	"Continuously records_": "连续录制 1 分钟 1fps 的视频，涵盖 30 分钟的动作。",
	"Choose detection regions_": "请选择检测区域，以减少因树木随风摇摆、远处移动物体等因素而触发非必要运动录制的风险。",
	"Your previous plan is expired.": "您之前的方案已过期。",
	"Upgrade the plan to restore the camera": "请升级方案以恢复摄像头\n(%@)",
	"Remove from cloud": "从云端删除",
	"Are you sure you want to Remove_": "是否确定要从云插槽中删除此摄像头？",
	"Remove: It doesn’t mean_": "删除：并不表示要删除摄像头数据，而是为云摄像头留出一个备用插槽。",
	"Now the camera is removed from cloud slot": "摄像头已从云插槽中删除。",
	"How to delete camera list": "如何从列表中删除摄像头",
	Update: Update$2,
	"Camrea setting": "摄像头设置",
	"Notification setting": "推送通知设置",
	"Driving reports": "行车报告",
	"Cloud connection steps": "云连接步骤",
	"Download the BlackVue app to add a camera": "下载 BlackVue 应用程序以添加摄像头",
	"To see your camera in the BlackVue cloud viewer_": "如需在 BlackVue 云查看器中查看您的摄像头，必须先将其连接到云。通过 iOS 和 Android 版 BlackVue 应用程序，轻松设置 BlackVue 摄像头并将其连接到云。",
	"Download the BlackVue app to see a Wi-Fi connected camera": "下载 BlackVue 应用程序以查看 Wi-Fi 联网摄像头",
	"BlackVue Cloud web viewer only supports_": "BlackVue Cloud 网络查看器仅支持连接云的行车记录仪。请下载 BlackVue 应用程序以查看您的 Wi-Fi 联网行车记录仪。",
	"You can restore the data if_": "如果您将此摄像头再次注册到同一帐户，则可恢复数据；但如果该帐户已被删除，则您的所有文件都将随之丢失。",
	"How to add camera": "如何添加摄像头",
	"Try to wait 2-3 minutes if you just registered the camera.": "如果您刚注册此摄像头，请等待 2-3 分钟。",
	"Try to check the Cloud Connection Settings again_": "如果摄像头仍然无法连接到云，请再次检查云连接设置。",
	"Motion Detection": "运动检测",
	"Parking recordings occur_": "检测到明显移动时，即开始停车录制。",
	"Motion Sensitivity": "运动灵敏度",
	"Motion Detection Sensitivity": "运动检测灵敏度",
	"Select Detection Region": "选择检测区域",
	"Speed alert_2": "超速警报",
	"Live Event Upload_2": "Live Event Upload",
	"Beep Alert": "蜂鸣提示",
	"Parking Impact History_": "停车期间碰撞的历史记录提示",
	"To register your_": "要注册您的SOS按钮，必须使用BlackVue应用程序。",
	"SOS button on/off": "SOS 按钮状态",
	"File sharing to Event Map is_": "当前无法将文件共享到事件地图。 请稍后再回来查看。",
	"Email Notifications": "电子邮箱通知",
	"Push Notifications_2": "推送通知信息",
	"Optional Camera Rotation": "可选摄像头方向",
	"Optional Camera Security": "可选摄像头安全",
	Option: Option$2,
	"(Owner)": "{{a}} (所有者)",
	"SOS button": "SOS 按钮",
	"This video has been reported_bold": "该视频已被管理员举报并<b>删除。</b>",
	"Number of events_2": "事件数",
	"My Shared Videos": "我分享的视频",
	"No Hashtags": "无主题标签",
	"I have read and agree_": "我已阅读并同意所有条款&政策",
	"14 years old_": "年满 14 岁",
	Required: Required$2,
	Optional: Optional$2,
	"Profile information_": "可在“帐户设置”页面上编辑个人资料信息。",
	"Automatically Add Live_": "将事件自动上传文件自动分享到 Event Map",
	"You must be 14 years_": "必须年满 14 岁才能创建 BlackVue 帐户",
	"Use 8 or more characters_": "至少 8 个字符，包含字母、数字和符号",
	"Protected files include_": "受保护的文件包括：<br/>ㆍ正常 (E) 和停车模式 (I) 下的碰撞事件 <br/>ㆍ手动录制事件 (M)<br/><br/>录制事件达到{{a}}条后，新事件将会覆盖最早的事件。",
	"Protected files include": "Protected files include",
	"If you turn_": "如果关闭语音提示，则以下列表也将关闭。",
	"Live Event Upload_success": "已成功保存“实时事件上传”设置。",
	"Video type": "视频类型",
	"Notify the Owner": "通知所有者",
	"Adjusting the cut-off voltage_2": "Adjusting the cut-off voltage to a lower setting may result in your dash cam draining more power from your battery. This could result in warning messages of battery drain or affect other vehicle functions.\nPlease consult with your dealership before lowering the voltage.",
	Others: Others$2,
	"This video has been removed.": "该视频已被删除。",
	"Please assign cameras_": "请为此组分配摄像头。",
	"Are you running_": "您观看回放的机会是否已用尽？",
	"Upgrade your plan_": "将您的方案升级到车队方案，即可享受无限制回放和其他云专享功能。",
	"Are you running_Liveview": "您观看实时取景的时间是否已用尽？",
	"Upgrade your plan_Liveview": "将您的方案升级到车队方案，即可享受无限制实时取景和其他云专享功能。",
	Stay: Stay$2,
	"Go to Fleet Plan": "进入车队方案",
	"It looks like the video file is being prepared. please try again later.": "看起来正在准备视频文件。 请稍后再试。",
	"Oops!": "哎呀！",
	"Please back up_": "请在更改此设置之前备份所有重要的录音。",
	"When you save_": "当您保存设置时，microSD 卡将被格式化并删除所有录音以确保稳定运行。",
	"This is an unregistered_": "这是一封未注册的电子邮件。 您想转到“创建帐户”页面吗？",
	"Camera name must_2": "摄像机名称必须在5到32个字符之间。",
	"G-sensor (Normal mode)": "G-sensor(正常模式）",
	"G-sensor (Parking mode)": "G-sensor(停车模式）",
	"Up & down": "上下",
	"Front & back": "前 & 后",
	"Rotate Video 180º": "Rotate Video 180º",
	Mask_2: Mask_2$2,
	"Priority event": "Priority Event",
	"There is no_camera": "There is no camera that your owner assigned to you.",
	"Camera SSID": "Camera SSID",
	"The BlackVue dashcam_2": "The BlackVue dashcam is not compatible with 5GHz wireless networks",
	"Driver detection box_2": "Driver Detection Box",
	"DMS camera recording_2": "DMS Camera Recording in Parking Mode",
	Low_2: Low_2$2,
	Medium_2: Medium_2$2,
	High_3: High_3$2,
	"Live Event Upload_3": "Live Event Upload",
	"Driving Impact": "Driving Impact",
	"Video source_2": "Video Source",
	"Front camera_2": "Front Camera",
	"Rear camera_2": "Rear Camera",
	"Optional Camera": "Optional Camera",
	"Motion Detection_2": "Motion Detection",
	"Rear camera stops_2": "Rear camera stops recording 5 minutes after entering Parking Mode. Recording restarts when entering normal mode.",
	"Passenger vehicle": "Passenger Vehicle",
	"Heavy vehicle": "Heavy Vehicle",
	Highest_3: Highest_3$2,
	Extreme_2: Extreme_2$2,
	"Less recording files": "Fewer Recording Files",
	"Camera rotation_2": "Camera Rotation",
	"Share camera profile_2": "Share Camera Profile",
	Private_2: Private_2$2,
	"BlackVue Live": "BlackVue Live",
	"Important All saved_": "Important! All saved videos are about to be deleted. Tap Cancel and back up important files if needed.",
	"Whenever saving settings_": "Whenever saving settings after changing the time zone, the SD card is initialized and all stored files are deleted.",
	"Do you want_": "Do you want to save your changes?",
	"No groups": "No groups",
	Lite: Lite$2,
	"USD per Camera": "USD per extra Camera",
	"up to Cameras": "up to Cameras",
	"All the P Plan_": "<b>{{a}}</b>计划的所有功能，以及：",
	"User Roles and Permissions": "用户角色和权限",
	"Geofence Setup (Web) and alerts": "Geofence Setup (Web) and alerts",
	"N Times": "{{a}} 次",
	"N Minutes": "{{a}} 分钟",
	"Emergency Alarm": "紧急警报",
	"Playback, Live View": "回放，Live View",
	"Your driving record : Daily, Monthly": "您的驾驶记录：每日，每月",
	"Real-time Conversation": "实时对话",
	"Initiate a conversation_": "通过仪表板的扬声器和麦克风与驾驶员进行对话。",
	"Remote Voice Communication": "远程语音通信",
	"See the last location_": "查看相机的最后位置",
	"Check your cars_": "在地图上查看汽车的实时GPS数据以找到您的车辆并获取有关其状态的信息，例如开车还是停放及其速度。",
	"Supported models_": "*支持的模型：S和早期X系列模型",
	"GPS Tracking &_": "GPS跟踪和地图上的视频（智能/车队）",
	"Track your cars_": "在地图上跟踪汽车的位置和速度！",
	"GPS Tracking: visualize_": "GPS跟踪：可视化地图上的驾驶日志。\n地图上的视频：查看上下文信息（速度，事件类型），并从地图上播放相关视频。",
	"Visualize your cars_": "在地图上可视化您的车辆位置和速度！",
	"The feature enables_": "该功能允许将视频片段上传到云端，包括事故发生前的5秒钟。",
	"Camera profile setting": "Camera profile setting",
	"Are you running_Download": "Are you running out of chance to Download Video?",
	"Upgrade your plan_Download": "Upgrade your plan to Fleet Plan for Unlimited Download, and other Cloud -Exclusive features.",
	"This feature is available for Smart and Fleet_": "This feature is available for Smart and Fleet Plan subscribers only.",
	"Rear camera will keep_": "若車內温度状态升至“高温”时，后置摄像头將在停车模式下暫停錄製。若車內溫度狀態降回“正常温度”后，后置摄像头将再次开始录制。 （注意：为了保护电子设备，本設備可能会因高温而關機。）",
	"Get Unlimited Cloud_": "获得无限制的云端播放并管理最多{{a}}台摄像机。",
	"Up to N cameras_": "Up to {{a}} cameras (+ {{b}} USD Extra charge)",
	"N Minutes per Day": "每天{{a}}分钟",
	"Drowsiness sensitivity is_": "通过眼睛眨动的时间来设定疲劳驾驶灵敏度，采用可靠的 BlackVue 算法。 <br> <br> 通过驾驶员的头部位置与车头之间的角度及其持续时间来设定分心驾驶灵敏度。",
	"Not available with this plan": "Not available with this plan",
	"The optional camera records_": "可选摄像头在停车模式下录制",
	"Smart and Fleet_": "Smart and Fleet Plan<br/>subscribers only",
	"This feature is_smart": "This feature is available for Smart and Fleet Plan subscribers only.",
	"Camera Registration": "摄像头注册",
	"Voice Call": "Voice Call",
	"N times per Month": "{{a}} times per Month",
	"Recommended for higher bitrate_": "建议用于更高的比特率和更好的视频质量。",
	"Recommended for for better compatibility_": "建议更好地与台式机和移动设备兼容",
	"A minute of front camera_": "1分钟视频的估计文件大小（前置摄像头）",
	"Extreme(N Mbps): N MB_": "Extreme ({{ex1}}Mbps) : {{ex2}}MB\nHighest ({{ht1}}Mbps) : {{ht2}}MB\nHigh ({{hi1}}Mbps) : {{hi2}}MB\nNormal ({{no1}}Mbps) : {{no2}}MB",
	"File size information reflects_": "文件大小信息反映了最大可能的大小，实际文件大小可能因记录条件而有所不同。",
	Bitrate: Bitrate$2,
	"Connection has been_": "连接已经丢失。\n重新建立连接...",
	"Unable to establish_": "无法与相机建立连接。\n请确保您的设备已正确连接，然后重试。",
	"Purchased by Payment Service": "支付服务购买",
	"Up to N Cameras": "最多{{a}}台摄像头",
	"Unlimited Live View": "实时影像无限制",
	"N Days GPS Tracking": "{{a}}天GPS跟踪",
	"Unlimited Playback and Download": "无限播放和下载",
	hours: hours$2,
	"Live Event Upload or_": "Live Event Upload或12个以上全分辨率视频",
	"During the usage period of the One Plan_": "在One Plan服务使用期间，无法更改订阅计划。若要切换到其他计划，请联系BlackVue客户支持取消One Plan订阅。",
	"Service Period (Include SIM Data)": "服务期限（包含SIM数据）",
	"Purchase the BlackVue One Package_": "购买BlackVue One Package，免费解锁One Plan一年。",
	"3GB SIM Data Plan": "3GB SIM数据套餐",
	"Unlimited Live View, Playback and Download": "无限实时查看、回放和下载",
	"within data availability": "在数据可用性范围内",
	"The BlackVue One Plan is a 1-year_": "BlackVue One Plan是一个为期一年的云服务计划，仅可通过购买BlackVue One Package来使用。该套餐包括行车记录仪、1年3GB/月数据套餐（适用于美国和加拿大）和为期一年的云服务计划。",
	"The BlackVue One Package is available_": "BlackVue One Package仅在BlackVue在线商店提供。",
	"Go to BlackVue Shop": "前往BlackVue商店",
	"Anonymous Cam": "匿名相机",
	"App only": "仅限应用",
	Expires: Expires$2,
	"N days remaining": "剩余{{a}}天",
	"No action needed_": "<b>无需操作。</b> 9月13日后的下次付款将自动应用新的优惠价格。",
	"The new reduced price_": "新的优惠价格将自动应用到您的帐户。",
	"Smart Plan Subscriber?": "Smart Plan 订户？",
	"Fleet Plan Subscriber?": "Fleet Plan 订户？",
	"Please take a moment to_": "请花点时间授权我们迁移您的帐户。",
	"Starting from now and_": "<b>从现在到10月31日</b>，您可以通过<a href=\"https://form.jotform.com/232411253056041\" target=\"_blank\">点击此链接</a>并输入您的 Fleet 帐户电子邮件，让我们为您做出更改。请允许我们一些时间处理更改。或者，您可以在9月13日后取消您的现有帐户，并以新价格重新订阅。",
	"Once activated_": "一旦激活，One Plan将无法暂停或停用。",
	"Once the One Plan is activated_": "一旦激活One Plan，One Package将无法退款。",
	"Up to N Cloud Camera Slot": "最多{{a}}个云摄像机插槽",
	"nGB of Cloud Storage": "{{a}}GB云存储空间",
	"Get started for free_": "Get started for free, no credit card required. Includes Alert Push Notifications, limited Remote Live View and cloud storage.",
	"The BlackVue One Plan is exclusively_": "The BlackVue One Plan is exclusively available through the purchase of a BlackVue One Package. 3GB/mo data plan is for US and Canada only. BlackVue Cloud’s Free Plan, Lite Plan (1~3) and Smart Plan (1~3) accounts can upgrade to One Plan. However, Lite Plan (4~15), Smart Plan (4~15) and Fleet Plan accounts can not be upgraded to One Plan.",
	"For N year": "For {{a}} year",
	"Included in the One Package": "Included in the One Package",
	"3GB SIM Data Plan for N year": "3GB SIM Data Plan for {{a}} year",
	"One Plan Cloud Service for N year": "One Plan Cloud Service for {{a}} year",
	"The BlackVue One Package includes_": "The BlackVue One Package includes all you need to enjoy BlackVue Cloud for a whole year!",
	"4K LTE Dash Cam_": "4K LTE Dash Cam, Cloud Service and Data Plan",
	"nGB included": "{{a}}GB included",
	"nGB per camera": "{{a}}GB per camera",
	"N Days Live Event Upload": "{{a}} Days Live Event Upload",
	"Up to N Dash Cameras": "Up to {{a}} Dash Cameras",
	"Step N/N": "步骤 {{a}}/{{b}}",
	"Cloud Connection": "云连接",
	"To pair your dashcam": "要将您的行车记录仪与电池配对，请将其连接到云端。",
	Check: Check$2,
	"Unpair Battery": "解除电池配对",
	"Are you sure you want to unpair": "您确定要将此电池(%@)从相机中解除配对吗？",
	"Unpair: It doesn't mean": "解除配对：这并不意味着删除电池数据。",
	"*The paired battery will": "*配对的电池也将一并移除。",
	"Would you like to pair this": "您想要将此电池配对吗？",
	"Battery successfully paired": "电池成功配对。",
	"Now you can directly connect to": "现在您可以直接从摄像机列表连接到电池。",
	"Pairing failed": "配对失败。请重试。",
	"Battery Name": "电池名称",
	"Capacity History": "容量历史",
	"The graph displays capacity": "图表显示的是使用云连接的数据的近似电池电量。\n 电池容量可能会根据温度、行车记录仪设置和触发事件频率而变化。",
	"Last 24 Hours": "过去24小时",
	"Last 7 Days": "过去7天",
	"Battery Level": "电池电量",
	"Temperature History": "温度历史",
	"The graph displays temperature": "图表显示了使用云连接数据的大致温度水平。",
	"Temperature Level": "温度水平",
	"Connecting alert": "[ 连接中 ]\n连接时显示数据。",
	"Low Output power Alert": "[ 输出功率切断 ]\n输出电压过低，限制了连接设备的供电。",
	"High temp Alert": "[ 输入电源切断 ]\n电池温度过高，限制充电。",
	"Remaining time": "剩余时间",
	"Remaining time estimate": "剩余时间是根据连接设备的总功耗估算的。\n 连接到电池后，每30秒重新计算一次。",
	"Setting changed": "设置已更改",
	"Setting change failed": "设置更改失败",
	"Low Input power Alert": "[ 输入电源切断 ]\n充电电压过低，限制充电。",
	"High Input power Alert": "[ 输入电源切断 ]\n充电电压过高，限制充电。",
	"Low temp_Cut off Alert": "[ 输入电源切断 ]\n电池温度过低，限制充电和持续时间。",
	"Low temp Alert": "[ 低温 ]\n电池温度过低，限制持续时间和充电速度。",
	"Low capacity Alert": "[ 低容量 ]\n电池容量太低。\n驾驶汽车充电。",
	"Back to list": "返回列表",
	Saving: Saving$2,
	Now: Now$2,
	"Power supplying is limited": "供电<b>受限</b>",
	"This battery is already paired": "此电池已配对。",
	"Connecting to Battery": "连接到电池",
	"Paired battery": "配对电池",
	"Battery unpairing failed": "电池解除配对失败。请重试。",
	"A connection is already active": "连接已经处于活动状态。请稍后再试。",
	"Searching for battery": "正在搜索电池",
	"Select battery to pair with your camera": "请选择要与您的相机配对的电池。",
	"Unable to connect": "无法连接",
	"A connection error has occurred": "连接出错，请重试。",
	"The paired dashcam has been disconnected": "配对的行车记录仪已从云端断开连接。\n请检查以下条件。",
	"Check if the battery is not fully discharged": "检查电池是否未完全放电",
	"Check the Cloud connection of the paired dashcam": "检查已配对的行车记录仪的云连接",
	"Connection lost": "连接已断开",
	"A connection error has occurred shortly": "连接发生错误。请尝试稍后连接。",
	"Charging is limited": "充电<b>受限</b>",
	"Cannot connect to the battery": "无法连接到电池。",
	"Please check the Cloud connection of the camera": "请检查相机的云连接。",
	"Charging complete in": "充电完成时间 %@",
	"Current Capacity": "当前容量",
	"Output Voltage": "输出电压",
	"Charging Voltage": "充电电压",
	Beep: Beep$2,
	"Battery Capacity": "电池容量",
	"Battery connection failed": "电池连接失败",
	"Expansion battery": "备用电池",
	"Make sure it is switched on and within range": "• 确认摄像头已开启且处于您的手机覆盖范围内",
	"Make sure it is not wirelessly connected to another device": "• 确认摄像头并未无线连接至其他设备。",
	"Detected batteries": "检测到的电池",
	"Can't see your battery": "无法找到您的电池？",
	"Download the Blackvue app to check": "下载 BlackVue 应用程序以远程检查您的电池",
	"By Using the app": "通过应用程序，您可以将您的行车记录仪与电池配对，并在云端监控电池的容量。配对完成后，您可以在BlackVue云查看器中查看电池状态。",
	Unpair: Unpair$2,
	"Occurs when the driver closes_": "当驾驶员闭眼驾驶时发生",
	"Occurs when the driver's head_": "当驾驶员的头部偏离正前方超过 50 度时发生。",
	"Only detects distraction above_": "仅检测超过设置值的分心。您可以在‘摄像头设置 > 事件触发器 > 鲁莽驾驶单位’中更改单位。",
	"Occurs when the driver is not wearing_": "当驾驶员未系安全带时发生。",
	"Overlays a face detection box_": "在 DMS 摄像头的实时和录制的镜头上叠加人脸检测框。",
	"Seat Belt": "安全帶",
	Detected: Detected$2,
	"No Seat Belt": "沒有安全帶",
	"Fatigue Risk Alert": "疲劳风险警报",
	"The time is synchronized_Email": "时间与您的电子邮件通知中的时间同步。",
	"Sends an alert when drowsiness is_": "当在初始疲劳后检测到疲劳时发送警报。",
	"Data updates upon connection": "连接时数据更新。",
	"Sends a notification if_": "在驾驶过程中超过了'设置时间'，则发送通知。",
	"Data updates Alert": "[ 连接中 ]\n连接时数据更新。",
	"Cannot save settings": "无法保存设置",
	"The time is synchronized_Push": "时间与您的推送通知信息中的时间同步。",
	"The file has been overwritten or deleted": "文件已被覆盖或删除。",
	"Box Pro Models Settings": "Box Pro型号设置",
	"Push notifications can be configured_": "可以在相机的通知设置中配置推送通知。",
	"Recording Video": "录制视频",
	"Cameras settings": "摄像头设置",
	"Please configure the settings": "请进行设置",
	"Speed Priorities": "速度优先级",
	"Set Speed Priority": "设置速度优先级",
	"Geofence-enter": "地理围栏-进入",
	"Geofence-exit": "地理围栏-退出",
	"Geofence-pass": "地理围栏-忽略",
	"Geofence-speed alert": "地理围栏-超速警报",
	"Drive Position": "驾驶位置",
	"Left-Hand Drive": "左侧驾驶",
	"Right-Hand Drive": "右侧驾驶",
	"Please configure this setting_": "如果未正确检测到驾驶员，请更改此设置。",
	"A new feature in the BlackVue settings_": "BlackVue 设置中添加了一项新功能来同步相机时间。您应该同步一次相机时间以准确记录时间。",
	"Feature location_": "特色地点：\n相机设置 > 系统 > 时间同步",
	"Time Sync": "时间同步",
	"You can sync the time between_": "您可以同步设备和BlackVue摄像机之间的时间。同步需要格式化SD卡。进行之前，请备份任何必要的视频。",
	"Voice Alert": "语音提示",
	"Provides a voice alert_": "在驾驶过程中，如果超过设定时间，摄像头会提供语音提示，并发送通知。",
	"Please enter a value": "Please enter a value.",
	"Notices & Notifications": "新闻和通知",
	"Only detects drowsiness above_": "仅检测超过设置值的睡意。您可以在‘摄像头设置 > 事件触发器 > 鲁莽驾驶单位’中更改单位。",
	Promotion: Promotion$2,
	Notice: Notice$2,
	"View More": "查看更多",
	"Read More": "阅读更多",
	"Detection Box": "检测盒",
	"Seatbelt Detection Box": "安全带检测盒",
	"Drive Position Detection Box": "驾驶位置检测盒",
	"Fleet Subscription Promotion (50%)": "机队订阅促销 (50%)",
	"BlackVue Fleet Tracking exclusive features_": "BlackVue 车队跟踪为高级用户和企业提供的专有功能（多用户和摄像头、地理围栏、Web 查看器等）。",
	"Special Discount (50% off)": "特别折扣（50% 折扣）",
	"*Promotion applied for 12 months": "*促销申请有效期为 12 个月",
	"*Payment will be made starting next month.": "*付款将从下个月开始。",
	"[About using promotions]": "[关于使用促销]",
	"The promotion is free for the first month_": "该促销活动第一个月免费，从下个月开始按 12 个月计费。",
	"For users with an existing Lite/Smart subscription_": "对于现有 Lite/Smart 订阅的用户，您必须单独取消现有的应用程序订阅，否则可能会从您的帐户中扣除现有的应用程序订阅费用。",
	"Please be sure to cancel your app subscription_": "请务必在免费期内取消您的应用订阅。双重付款将不予退还。",
	"You will be changed to Fleet Plan immediately_": "即使您现有的精简/智能计划的剩余订阅期限尚未到期，您也将立即更改为舰队计划。",
	"You can cancel Fleet Plan any time.": "您可以随时取消舰队计划。",
	"From February 2025, please go to the Fleeta service and use it.": "促销活动一旦取消，将不再适用。",
	"After promotion expires_": "促销到期后，您将自动续订现有的舰队计划订阅费。",
	"(Required) I have read the promotion instructions_": "（必填）我已阅读促销须知并同意付款。",
	"Upgrade to Fleet Plan immediately": "立即升级至舰队计划",
	"Important Notice:": "重要通知：",
	"Switch of BlackVue Web Viewer to Fleeta Web Viewer": "将 BlackVue Web 查看器切换为 Fleeta Web 查看器",
	"To provide better features and quality_": "为了提供更好的功能和质量，BlackVue Web 查看器服务将很快切换到名为 Fleeta 的新车队 Web 查看器服务。 Fleeta 服务仅适用于 Fleet Plan 用户。 Fleeta 服务将于 2025 年 3 月推出，并推出新的 Fleeta 专属应用程序。请访问 <a href=\"https://www.fleeta.io\" target=\"_blank\">fleeta.io</a> 了解更多信息。",
	"We kindly ask for your understanding_": "我们恳请您的理解，因为此更改旨在提供改进的服务。如果对此次转换有任何疑问，请随时联系我们的客户服务中心。",
	"Don’t show this again for this month": "本月不再显示此内容",
	"Fleet Plan Subscription Promotion": "机队计划订阅促销",
	"Period : December 2, 2024 ~ May 31, 2025": "期间 : 2024年12月2日 ~ 2025年5月31日",
	"See more details": "查看更多详情",
	"To continue improve quality and provide better service_": "为了继续提高质量并提供更好的服务，我们的 BlackVue Web Viewer 服务将很快切换为 Fleet Plan 专属服务。从 2025 年 3 月下旬开始，它将不再免费提供或通过其他计划提供。",
	"We have prepared special discount offers for_": "我们为现有的 Web Viewer 用户准备了特别折扣优惠。请检查以下详细信息！为了提供更好的服务，我们实施此变更，敬请您的理解和支持。\n",
	"*If you are subscribed in-app_": "*如果您是应用内订阅，请务必取消您的应用内订阅。",
	"Enjoy your BlackVue Cloud service with your dashcam.": "使用行车记录仪享受 BlackVue 云服务。",
	"Available Cloud Camera slot(s)_": "可用云摄像机插槽：{{d}}",
	"Not eligible for the promotion.": "不符合促销资格。",
	"You have already used_": "您已经使用过此促销活动。促销一旦取消，将无法重新申请。",
	"Go to Cameras": "前往相机",
	"Congratulations !": "Congratulations !",
	"Fleet Plan user": "Fleet Plan user",
	"Let your BlackVue monitor_": "让您的 BlackVue 监控您的汽车并就事故向您发出警报。一旦检测到影响，您的 BlackVue 就会向您的手机发送一条通知，并附上快照。\n",
	"Live Event Upload feature automatically_": "现场活动上传功能会自动将视频片段（包括事故前的片段）上传到 BlackVue 云存储，以确保您的视频安全！",
	"*Buffer time varies by model.": "*缓冲时间因型号而异。",
	Explore: Explore$2,
	"Cloud Storage": "云存储",
	"My Cloud Cameras": "我的云摄像机",
	"My Cloud Cameras Only": "仅限我的云摄像机",
	"BlackVue Live Camera": "BlackVue 实时摄像机",
	"*For BlackVue Live Cameras_": "*对于 BlackVue 实时摄像机，只有在摄像机设置中共享为公共的摄像机才能在地图上查看。",
	"*Share Method_": "*分享方式：相机设置>隐私",
	"Once the promotion is canceled_": "促销活动一旦取消，将不再适用。",
	"It will show_": "当它们可用时，它将在这里显示。",
	"Deactivate Cloud": "停用云",
	"Are you sure you want to deactivate_": "您确定要为此相机停用云吗？",
	"Deactivate : It doesn’t_": "您随时可以激活云。停用完成后即可删除相机。",
	Deactivate: Deactivate$2,
	"*If you made the payment through_": "*如果您通过应用程序付款，请重新启动应用程序。",
	"Connect Dashcam Locally (Wi-Fi)": "本地连接行车记录仪 (Wi-Fi)",
	"Cloud Connection Setting": "云连接设置",
	"Camera Profile": "摄像头配置文件",
	"Camera Settings": "摄像头设置",
	"Format MicroSD Card": "格式化 microSD 卡",
	"Remote Firmware Update": "远程固件更新",
	"Remove from Cloud": "从云端删除",
	"The location may not be accurate_": "由于相机未连接云端，位置可能不准确。",
	"The location of the camera cannot be found_": "无法找到相机的位置。请检查云连接设置。",
	"Manage\nFLEETA Drive": "管理\nFLEETA 云盘",
	"Cloud\nConnection": "云\n连接",
	"Available on FLEETA App": "在FLEETA应用程序上可用",
	"Available for Cloud dashcam OR on FLEETA App.": "适用于云行车记录仪或在FLEETA应用程序上。",
	"Get started with_": "开始免费1个月试用",
	"Experience all of_": "在您的1个月试用期内免费体验FLEETA的所有高级功能。\n\n无需承诺—随时取消",
	"Welcome to FLEETA Webviewer.": "欢迎使用FLEETA Webviewer。",
	"Let FLEETA get_": "让FLEETA了解你",
	"Help improve your_": "通过分享一些细节帮助改善您的体验",
	"Business Industry": "行业",
	"Vehicle & Cargo": "车辆和货物",
	Compliance: Compliance$2,
	"Would you like to skip?": "您想跳过吗？",
	"What is your business industry?": "您的业务行业是什么？",
	"Transportation & Logistics": "交通与物流",
	"Rental & Leasing": "租赁",
	"Construction & Building": "建设与建筑",
	"Government & Public": "政府与公共",
	"Facility & Utility Management": "设施与公用事业管理",
	Manufacturing: Manufacturing$2,
	"Retail & Wholesale": "零售与批发",
	Emergency: Emergency$2,
	Security: Security$2,
	"How many employees do you need to manage?": "您需要管理多少名员工？",
	"How many vehicles does your company operate?": "您的公司运营多少辆车辆？",
	"Why do you use a fleet tracking service?": "您为什么使用车队追踪服务？",
	"Route Tracking": "路径追踪",
	"Real-time Monitoring": "实时监控",
	"Incident Detection & Check video": "事件检测与视频查看",
	"Behavior Monitoring & Analysis": "行为监控与分析",
	"Evaluation & Management": "评估与管理",
	"Theft Prevention": "防盗",
	"Monitoring & Maintenance": "监控与维护",
	"Verification & Management": "验证与管理",
	"BlackVue App Use Only": "仅限BlackVue应用使用",
	"Your current plan allow_": "您当前的计划允许使用BlackVue应用程序。要使用网页查看器，请订阅车队计划（FLEETA）。",
	"Learn more about the Fleet_": "了解更多关于FLEETA的车队计划",
	"Special Offer": "特别优惠",
	"For a limited time_": "限时享受车队计划订阅五折优惠。",
	"See Discount Details": "查看折扣详情",
	"To subscribe to the Fleet_": "若要订阅车队计划，请先取消您在应用内的BlackVue订阅，以避免重复收费。",
	"Skip tour": "跳过导览",
	"In the cloud_": "在云环境中，您可以通过FLEETA Web Viewer访问回放、实时观看（包括多视图）、实时GPS和报告。",
	"Cloud Storage is_": "云存储是您上传的视频在云中安全存储的地方。上传您的视频，长时间保持安全。",
	"Toggle to switch_": "切换地图 / 列表",
	"In List View_": "在列表视图中，您可以一目了然地轻松查看和管理群组、成员和固件信息。",
	"What is Cloud Storage?": "什么是云存储？",
	"Cloud Storage Overview": "云存储概述",
	"Difference Between FLEETA_": "FLEETA 云盘与实时事件上传的区别",
	"FLEETA Drive stores_": "FLEETA 云盘存储您手动上传的视频",
	"Live Event Upload automatically_": "实时事件上传在事件发生时自动存储视频。",
	"Live Event Upload videos_": "实时事件上传视频有有效期。如果您希望长期保存，可将它们移至FLEETA 云盘。",
	"Note: SD Card_": "注意：回放中的 SD 卡视频",
	"Videos stored on_": "存储在您的SD卡上的视频可以通过回放菜单访问。",
	"Set your image_": "使用提供的框架设置您的图像。一旦图像被保存，它将显示在相机卡和地图视图图标中。",
	"*Only jpg and_": "*仅支持jpg和png文件。",
	"Set as default image": "设为默认图片",
	"Camera Details": "摄像头详情",
	"IT & Telecommunications": "信息技术与电信",
	"The name must_32": "名称必须包含1至32个字符。",
	"Unable to display the map.": "无法显示地图。",
	"The camera location cannot be found_": "由于GPS连接差，无法找到摄像头位置。",
	"Cloud Cameras": "云摄像头",
	"Want to unlock_": "想要解锁车队管理功能吗？",
	"*Web subscription only": "*仅限网页订阅",
	"Uploads event_": "事件发生时即刻将事件影像上传到云存储。",
	"Starts a conversation_": "使用行车记录仪的扬声器和麦克风与驾驶员开始对话。",
	"Remotely check_": "通过云远程检查电池电量和状态。",
	"Receive a voice_": "如果驾驶时间超过限制，将收到语音提醒和通知。",
	"View your_": "在地图上查看您的驾驶记录。",
	"View speed, event_": "在地图上直接查看速度、事件类型并回放相关视频。",
	"FLEETA Tracking exclusive_": "FLEETA 跟踪为高级用户和企业提供独家功能（多用户和摄像头、地理围栏等）。",
	"Cloud Cameras per Account": "每个账户的云摄像头",
	"Connect Dashcam Locally_": "本地连接行车记录仪（Wi-Fi）（回放, 下载, 实时观看）",
	"Available with_": "可与BlackVue电池一起使用",
	"Cloud Battery": "云电池",
	"Driving Reports": "驾驶报告",
	"Video on Map": "地图上的视频",
	"Multi Live View (Fleeta Web Viewer)": "多路实时观看 (FLEETA 网页查看器)",
	"Enter a number": "输入一个数字",
	"Permission required.": "需要权限。",
	"Please contact_": "请联系所有者寻求帮助。",
	"Access not available": "无法访问。",
	"This file cannot be deleted now.": "该文件现在无法删除。",
	"Please try again later.": "请稍后再试。",
	"Permission required.\nPlease_": "需要权限。\n请联系所有者寻求帮助。",
	"Cloud Storage is disconnected_": "云存储已断开。请检查连接。",
	"Manage the plan_": "管理恢复摄像头的计划",
	"Notify the owner_": "通知所有者管理计划",
	"Access Restricted:_": "访问受限：订阅已过期",
	"Access is currently_": "由于订阅过期，目前无法访问。",
	"Please contact your owner_": "请联系您的所有者解决此问题。",
	"Access will be_": "续订后将恢复访问权限",
	"Cloud is disconnected_": "云存储已断开。 \n请检查连接。",
	"Connect to Cloud with_": "使用FLEETA APP连接到云存储",
	"Using Wi-Fi Hotspot": "使用 Wi-Fi 热点",
	Important: Important$2,
	"Pre-Event buffer_": "在此模式下，预事件缓冲录制被禁用。",
	"connectivity is_": "在此模式下连接受限。",
	"video upload starts_": "录制完成后开始上传视频。",
	"Power Saving": "节能",
	"In all modes_": "在所有模式下，检测到的冲击都会触发事件视频录制。",
	"Battery Protection setting _": "电池保护设置必须开启。",
	"At least one of_": "必须启用以下设置中的至少一个",
	or: or$2,
	"For BlackVue battery users": "适用于BlackVue电池用户",
	"we recommend setting_": "我们建议将电压截止设置为最小值以最大化电池使用。",
	"No videos were found.": "未找到视频。",
	"Try different filter_": "尝试不同的过滤器或重置过滤器。",
	"Not avaliable with_": "当前摄像头不支持",
	"Overlays a detection_": "在DMS摄像头的实时和录制画面上叠加一个检测框。",
	"A minute of_": "前置摄像头视频一分钟大约",
	"System voice guidance": "系统语音指导",
	"Recording trigger": "录制触发器",
	"Remote Button (Optional)": "远程按钮（可选）",
	"Remote button settings_": "无法通过云连接更改远程按钮设置。要修改这些设置，请导航至相机 > 本地连接 > 相机设置。",
	"No Registered Device": "无注册设备",
	"Subscription process is complete": "订阅过程已完成",
	"Now, go back to_": "现在，返回FLEETA应用程序，登录到您的账户，并开始享受服务。",
	"You can check the upload progress": "您可以在云存储 > FLEETA 云盘标签中检查上传进度。",
	"SIM card must be inserted in_": "必须将 SIM 卡插入相机才能开始使用云。",
	"Active until:": "有效直至：",
	Subscribe: Subscribe$2,
	"Camera PSN": "相机PSN",
	"BlackVue Sim Free Trial Started!": "BlackVue Sim 免费试用开始！",
	"Enjoy a free period to use your SIM_": "无需订阅即可享受免费使用 SIM 卡的期限！",
	"You can stay connected during the trial_": "您可以在试用期间保持联系，但请记住：",
	"Complete your subscription before the trial_": "在试用结束前完成订阅即可继续使用 SIM 卡。",
	"If you don't subscribe by the end of the trial_": "如果您在试用期结束前未订阅，您的 SIM 服务将被停用。",
	"Save Event Videos_": "将活动视频实时保存到云存储！",
	"Note: Deleting your account doesn’t cancel": "注意：删除您的账户并不会取消您的订阅。要取消订阅，请在FLEETA网页查看器中转到账户>订阅。",
	"Available only on FLEETA App for_": "该型号仅适用于FLEETA应用程序。",
	"The cloud is deactivated": "云已停用。",
	"Please add a camera with FLEETA_": "请在FLEETA APP中添加摄像头以使用此功能。",
	"Upload videos to FLEETA_": "将视频上传到FLEETA 云盘并保持安全！",
	"You have no assigned camera_": "您没有分配的摄像头。\n请联系所有者请求分配。",
	"Camera notification settings": "摄像头通知设置",
	Vehicle: Vehicle$2,
	"App Download": "应用下载",
	"Have a problem with_": "订阅有问题吗？",
	"Restore Purchase": "恢复购买",
	"Battery Pairing": "电池配对",
	"Playback\nLive View": "回放/\n实时取景",
	"Remote Playback": "远程回放",
	"Cloud connection settings": "云连接设置",
	"Go to settings": "转到“设置”",
	"Only cloud cameras that_": "只有用户选择公开分享的云摄像头会显示在地图上。",
	"Live Broadcast Cameras": "直播摄像机",
	"*Live Broadcast Cameras_": "*直播摄像机是用户设置为广播的云摄像机。",
	"Only cloud cameras_": "地图上只显示用户选择广播的云摄像头。"
};

var Dashboard$1 = "แดชบอร์ด";
var Account$1 = "บัญชี";
var Help$1 = "วิธีใช้";
var Mac$1 = "Mac";
var Windows$1 = "Windows";
var Admin$1 = "ผู้ดูแลระบบ";
var Driver$1 = "คนขับ";
var Cameras$1 = "กล้อง";
var Manage$1 = "จัดการ";
var Clear$1 = "ชัดเจน";
var Show$1 = "แสดง";
var GB$1 = "{{a}}GB";
var _section$1 = ".";
var Name$1 = "ชื่อ";
var Password$1 = "รหัสผ่าน";
var Cancel$1 = "ยกเลิก";
var Members$1 = "สมาชิก";
var Groups$1 = "กลุ่ม";
var Role$1 = "บทบาท";
var Group$1 = "กลุ่ม";
var Status$1 = "สถานะ";
var nPM$1 = "{{a}}PM";
var nAM$1 = "{{a}}AM";
var Newest$1 = "ใหม่ที่สุด";
var Oldest$1 = "เก่าที่สุด";
var Accepted$1 = "ยอมรับแล้ว";
var Pending$1 = "คงค้าง";
var Expired$1 = "หมดอายุแล้ว";
var All$1 = "ทั้งหมด";
var Delete_$1 = "ลบ {{a}}";
var Delete$1 = "ลบ";
var Rename$1 = "เปลี่ยนชื่อ";
var Add$1 = "เพิ่ม";
var OK$1 = "ตกลง";
var Remove$1 = "ลบ";
var Files$1 = "ไฟล์";
var Features$1 = "คุณสมบัติ";
var Settings$1 = "การตั้งค่า";
var Upload$1 = "ที่อัพโหลด";
var Privacy$1 = "ความเป็นส่วนตัว";
var Done$1 = "เสร็จสิ้น";
var Subscription$1 = "การสมัคร";
var Submasters$1 = "ผู้ดูแลระบบ";
var Users$1 = "คนขับ";
var Change$1 = "เปลี่ยน";
var Method$1 = "วิธีการ";
var Details$1 = "ข้อมูลของกล้อง";
var Confirm$1 = "ยืนยัน";
var Address$1 = "ที่อยู่";
var Country$1 = "ประเทศ";
var State$1 = "รัฐ";
var ZIP$1 = "รหัสไปรษณีย์";
var Pricing$1 = "การกำหนดราคา";
var Free$1 = "Free";
var Smart$1 = "Smart";
var Fleet$1 = "Fleet";
var Subscrubed$1 = "สมัครสมาชิกแล้ว";
var January$1 = "มกราคม";
var February$1 = "กุมภาพันธ์";
var March$1 = "มีนาคม";
var April$1 = "เมษายน";
var May$1 = "อาจ";
var June$1 = "มิถุนายน";
var July$1 = "กรกฎาคม";
var August$1 = "สิงหาคม";
var September$1 = "กันยายน";
var October$1 = "ตุลาคม";
var November$1 = "พฤศจิกายน";
var December$1 = "ธันวาคม";
var Blackvuecloud_$1 = "www.blackvuecloud.com";
var Support$1 = "Support";
var Community$1 = "Community";
var FAQ$1 = "FAQ";
var Developers$1 = "Developers";
var Facebook$1 = "Facebook";
var Twitter$1 = "Twitter";
var Instagram$1 = "Instagram";
var Youtube$1 = "Youtube";
var Linkedin$1 = "Linkedin";
var Downloads$1 = "ดาวน์โหลด";
var Unauthorized$1 = "ไม่ได้รับอนุญาต";
var none$1 = "ไม่มี";
var Email$1 = "อีเมล";
var Customers$1 = "Customers";
var Home$1 = "Home";
var Plan$1 = "Plan";
var New$1 = "New";
var Unsubscribed$1 = "Unsubscribed";
var Edit$1 = "Edit";
var month$1 = "month";
var months$1 = "months";
var Continue$1 = "Continue";
var Back$1 = "กลับ";
var Master$1 = "Owner";
var Develop$1 = "Developers";
var $9$1 = "$9";
var $15$1 = "$15";
var $10$1 = "$10";
var mo$1 = "เดือน";
var City$1 = "เมือง";
var Charge$1 = "เรียกเก็บเงิน";
var subscribe$1 = "สมัคร";
var search$1 = "ค้นหา";
var invalid_number$1 = "หมายเลขบัตรไม่ใช่หมายเลขบัตรเครดิตที่ถูกต้อง";
var invalid_expiry_month$1 = "เดือนหมดอายุของบัตรไม่ถูกต้อง";
var invalid_expiry_year$1 = "ปีหมดอายุของบัตรไม่ถูกต้อง";
var invalid_cvc$1 = "รหัสความปลอดภัยของบัตรไม่ถูกต้อง";
var incorrect_number$1 = "หมายเลขบัตรไม่ถูกต้อง";
var incomplete_number$1 = "หมายเลขบัตรไม่สมบูรณ์";
var incomplete_cvc$1 = "รหัสความปลอดภัยของบัตรไม่สมบูรณ์";
var incomplete_expiry$1 = "วันหมดอายุของบัตรไม่สมบูรณ์";
var expired_card$1 = "บัตรหมดอายุแล้ว";
var incorrect_cvc$1 = "รหัสความปลอดภัยของบัตรไม่ถูกต้อง";
var incorrect_zip$1 = "รหัสไปรษณีย์ของบัตรไม่ผ่านการตรวจสอบความถูกต้อง";
var invalid_expiry_year_past$1 = "ปีหมดอายุของบัตรเป็นปีที่ผ่านมา";
var card_declined$1 = "บัตรถูกปฏิเสธ";
var missing$1 = "ไม่มีบัตรสำหรับลูกค้าที่ถูกเรียกเก็บเงิน";
var processing_error$1 = "เกิดข้อผิดพลาดขณะประมวลผลบัตร";
var Paypal$1 = "Paypal";
var iOS$1 = "iOS";
var Android$1 = "Android";
var Total$1 = "รวมทั้งหมด";
var And$1 = "และ";
var Camera$1 = "Camera";
var Yes$1 = "ตกลง";
var No$1 = "No";
var News$1 = "ข่าว";
var Notifications$1 = "การแจ้งเตือน";
var MPH$1 = "MPH";
var Firmware$1 = "เฟิร์มแวร์";
var Basic$1 = "พื้นฐาน";
var Resolution$1 = "ความละเอียด";
var Brightness$1 = "ความสว่าง";
var Recording$1 = "การบันทึก";
var Highest$1 = "สูงที่สุด";
var High$1 = "สูง";
var Normal$1 = "ปกติ";
var Sensitivity$1 = "ความไว";
var Volume$1 = "ระดับเสียง";
var Close$1 = "Close";
var Cloud$1 = "Cloud";
var Public$1 = "Public";
var Front$1 = "หน้า";
var Rear$1 = "หลัง";
var Play$1 = "เล่น";
var Stop$1 = "หยุด";
var Pause$1 = "หยุดชั่วคราว";
var Time$1 = "Time";
var System$1 = "ระบบ";
var Event$1 = "เหตุการณ์";
var Parking$1 = "จอดรถ";
var Color$1 = "สี";
var Exit$1 = "ออก";
var Save$1 = "บันทึก";
var Impact$1 = "การกระแทก";
var Unlimited$1 = "ไม่จำกัด";
var Default$1 = "ค่าเริ่มต้น";
var Version$1 = "เวอร์ชั่น";
var Language$1 = "ภาษา";
var Notification$1 = "การแจ้งเตือน";
var Multiple$1 = "หลาย";
var Range$1 = "ย่าน";
var Download$1 = "ดาวน์โหลด";
var Manual$1 = "คู่มือ";
var Satellite$1 = "ดาวเทียม";
var Tutorials$1 = "บทแนะนำ";
var Filter$1 = "กรอง";
var Sun$1 = "อา.";
var Mon$1 = "จ.";
var Tue$1 = "อ.";
var Wed$1 = "พ.";
var Thu$1 = "พฤ.";
var Fri$1 = "ศ.";
var Sat$1 = "ส.";
var Dates$1 = "วันที่";
var Routes$1 = "เส้นทาง";
var Opacity$1 = "ความทึบ";
var Entry$1 = "รายการ";
var Owner$1 = "Owner";
var Undetected$1 = "ตรวจไม่พบ";
var Distracted$1 = "ซึมเศร้า";
var Drowsy$1 = "Drowsy";
var Calling$1 = "Calling";
var Smoking$1 = "Smoking";
var Permissions$1 = "สิทธิ์";
var Private$1 = "ส่วนตัว";
var Entering$1 = "กำลังเข้า";
var Exiting$1 = "กำลังออก";
var Acceleration$1 = "การเร่งความเร็ว";
var Passing$1 = "กำลังผ่าน";
var Overspeed$1 = "ความเร็วเกิน";
var Recipients$1 = "ผู้รับ";
var Send$1 = "ส่ง";
var Note$1 = "หมายเหตุ";
var Video$1 = "วิดีโอ";
var Advanced$1 = "ขั้นสูง";
var Voice$1 = "เสียงพูด";
var Days_$1 = "วัน";
var Mute$1 = "ปิดเสียง";
var UnMute$1 = "เปิดเสียง";
var Discard$1 = "ละทิ้ง";
var Report$1 = "Report";
var Individual$1 = "คนขับแต่ละคนต้องการความอุ่นใจใช่หรือไม่ เจ้าของธุรกิจต้องการโซลูชันการรักษาความปลอดภัยและการติดตามยานพาหนะแบบเรียบง่ายใช่หรือไม่";
var Subscribed$1 = "สมัครสมาชิกแล้ว";
var Geofence$1 = "ขอบเขตเสมือน";
var Driving$1 = "การขับขี่";
var Idling$1 = "หยุดทำงาน";
var Distance$1 = "ระยะทาง";
var Parked$1 = "Parked";
var Speed$1 = "ความเร็ว";
var Highest_2$1 = "สูงสุด";
var Average$1 = "เฉลี่ย";
var Geofences$1 = "ขอบเขตเสมือน";
var Move$1 = "ย้าย";
var Connected$1 = "เชื่อมต่อแล้ว";
var Individual_$1 = "รายบุคคล";
var Always$1 = "เสมอ";
var Low$1 = "ต่ำ";
var Medium$1 = "กลาง";
var High_2$1 = "สูง";
var Flip$1 = "พลิก";
var Previous$1 = "เฟรมก่อนหน้า";
var Next$1 = "ถัดไป";
var Expand$1 = "ขยาย";
var Collapse$1 = "ยุบ";
var More$1 = "เพิ่มเติม";
var Multi$1 = "หลาย";
var Safe$1 = "ปลอดภัย";
var Reckless$1 = "ประมาท";
var Inattentive$1 = "ไม่ใส่ใจ";
var List$1 = "รายการ";
var Usage$1 = "การใช้งาน";
var Profile$1 = "โปรไฟล์";
var Fullscreen$1 = "เต็มหน้าจอ";
var Upgrade$1 = "อัปเกรด";
var Management$1 = "การจัดการ";
var Day$1 = "วัน";
var Month$1 = "เดือน";
var Later$1 = "ภายหลัง";
var ICCID$1 = "ICCID";
var Resubscribe$1 = "สมัครสมาชิกใหม่";
var plan$1 = "แผน";
var USD$1 = "ดอลลาร์สหรัฐ";
var etc_$1 = "อื่นๆ :";
var Available$1 = "เหลืออยู่";
var Used$1 = "ใช้แล้ว";
var Cancelled$1 = "ยกเลิกแล้ว";
var Terminated$1 = "สิ้นสุดแล้ว";
var Sort$1 = "เรียงลำดับ";
var Bonus$1 = "โบนัส";
var incomplete_zip$1 = "รหัสไปรษณีย์ของบัตรไม่ผ่านการตรวจสอบความถูกต้อง";
var Upgrades$1 = "อัพเดท";
var OR$1 = "หรือ";
var Undo$1 = "ยกเลิก";
var Invoice$1 = "ใบแจ้งหนี้";
var data$1 = "ข้อมูล";
var Popular$1 = "Popular";
var Mask$1 = "ไม่ใส่หน้ากาก";
var DMS$1 = "การตรวจสอบสถานะของไดร์เวอร์ (DMS)";
var Extreme$1 = "สูงสุด";
var OFF$1 = "ปิด";
var Threshold$1 = "เกณฑ์";
var Drowsiness$1 = "ความง่วงนอน";
var Direct$1 = "โดยตรง";
var Remote$1 = "ระยะไกล";
var Update$1 = "อัพเดท";
var Option$1 = "ตัวเลือก";
var Required$1 = "จำเป็น";
var Optional$1 = "ตัวเลือก";
var Others$1 = "อื่น ๆ";
var Stay$1 = "คงเดิม";
var Mask_2$1 = "Mask";
var Low_2$1 = "Low";
var Medium_2$1 = "Medium";
var High_3$1 = "High";
var Highest_3$1 = "Highest";
var Extreme_2$1 = "Extreme";
var Private_2$1 = "Private";
var Lite$1 = "Lite";
var Bitrate$1 = "บิตเรต";
var hours$1 = "ชั่วโมง";
var Expires$1 = "หมดอายุ";
var Check$1 = "ตรวจสอบ";
var Saving$1 = "กำลังบันทึก";
var Now$1 = "ตอนนี้";
var Beep$1 = "เสียงเตือน";
var Unpair$1 = "ยกเลิกการจับคู่";
var Detected$1 = "ตรวจจับ";
var Promotion$1 = "โปรโมชั่น";
var Notice$1 = "การอัปเดต";
var Explore$1 = "สำรวจ";
var Deactivate$1 = "ปิดการใช้งาน";
var Compliance$1 = "การปฏิบัติตาม";
var Manufacturing$1 = "การผลิต";
var Emergency$1 = "ฉุกเฉิน";
var Security$1 = "ความปลอดภัย";
var Important$1 = "สำคัญ";
var or$1 = "หรือ";
var Subscribe$1 = "สมัครสมาชิก";
var Vehicle$1 = "ยานพาหนะ";
var th = {
	Dashboard: Dashboard$1,
	"Payment & Subscriptions": "การชำระเงินและการสมัครสมาชิก",
	"Fleet Management": "การจัดการกลุ่มยานพาหนะ",
	"Available to master": "มีให้สำหรับมาสเตอร์",
	"Available to Fleet_": "มีให้สำหรับผู้ใช้แผนกลุ่มยานพาหนะ",
	Account: Account$1,
	"Log out": "ล็อกเอาท์",
	"© 2019 Pittasoft_": "© 2019 Pittasoft Co. Ltd",
	"Privacy policy": "นโยบายความเป็นส่วนตัว",
	"Terms of service": "เงื่อนไขการใช้บริการ",
	Help: Help$1,
	"App store": "App store",
	"Google Play": "Google Play",
	Mac: Mac$1,
	Windows: Windows$1,
	"Free Plan": "Free Plan",
	"Basic Plan": "Basic Plan",
	"Smart Plan": "Smart Plan",
	Admin: Admin$1,
	Driver: Driver$1,
	"Period : December 3, 2024 ~ May 31, 2025": "ระยะเวลา : 3 ธันวาคม 2567 ~ 31 พฤษภาคม 2568",
	Cameras: Cameras$1,
	"n of n": "{{a}} จาก {{b}}",
	Manage: Manage$1,
	"Upgrade Plan": "อัปเกรดแผน",
	"Add more cameras_": "เพิ่มกล้องได้มากขึ้น จัดการกลุ่มยานพาหนะของคุณ และอีกมากมาย...",
	"Usage statistics": "สถิติการใช้งาน",
	"All cameras": "กล้องทั้งหมด",
	Clear: Clear$1,
	Show: Show$1,
	"Live views": "การดูสดจากระยะไกล",
	"nh:nm:ns": "{{a}}h:{{b}}m:{{c}}s",
	"Video plays and_": "การดาวน์โหลดและการเล่นวิดีโอ",
	"Space available": "พื้นที่ว่างที่ใช้งานได้",
	GB: GB$1,
	"n%": "{{a}}%",
	"BlackVue app for_": "แอป BlackVue สำหรับ iOS และ Android",
	"BlackVue viewer for_": "BlackVue viewer สำหรับ Mac และ Windows",
	"Welcome to fleet": "ยินดีต้อนรับสู่กลุ่มยานพาหนะ",
	"A few things_": "บางสิ่งที่คุณสามารถคาดหวังได้ระหว่างทาง:",
	"You can watch_": "คุณสามารถดูวิดีโอจากกล้องที่มอบหมายให้คุณได้ในแอป BlackVue หรือโปรแกรมดูบนเดสก์ท็อป",
	"If the master_deletes": "หากมาสเตอร์ลบบัญชีของตนเอง บัญชีของคุณก็จะถูกลบเช่นกัน",
	"If the masters_Fleet": "หากการสมัครสมาชิกแผนกลุ่มยานพาหนะของมาสเตอร์หมดอายุ คุณจะยังคงสามารถเข้าถึงบัญชีของคุณได้ในโหมดอ่านอย่างเดียว",
	"You have to_": "คุณต้องลงทะเบียนบัญชีอื่นเพื่อเพิ่มกล้องส่วนตัว",
	"The Payments &_": "ส่วนของการชำระเงินและการสมัครสมาชิก รวมทั้งการจัดการยานพาหนะมีให้สำหรับมาสเตอร์เท่านั้น",
	"You can manage_": "คุณสามารถจัดการกลุ่มยานพาหนะของคุณได้ในส่วนของ",
	"_Fleet management": "การจัดการกลุ่มยานพาหนะ",
	_section: _section$1,
	"The Payments_section-": "ส่วนของการชำระเงินและการสมัครสมาชิกมีให้สำหรับมาสเตอร์เท่านั้น",
	"Youre almost there": "เกือบเสร็จแล้ว",
	"Finish account setup": "เสร็จสิ้นการตั้งค่าบัญชี",
	"Install and log_": "ติดตั้งและเข้าสู่ระบบแอป BlackVue หรือโปรแกรมดูบนเดสก์ท็อป",
	"Download on the_": "ดาวน์โหลดบน App Store",
	"GET IT ON_": "ดาวน์โหลดบน Google Play",
	"Download for Mac": "ดาวน์โหลดสำหรับ Mac",
	"Download for Windows": "ดาวน์โหลดสำหรับ Windows",
	"Add your camera_": "เพิ่มกล้องของคุณในแอป BlackVue หรือโปรแกรมดูบนเดสก์ท็อป",
	"Start managing your_": "เริ่มการจัดการกลุ่มยานพาหนะของคุณและติดตามสถิติการใช้งานที่นี่",
	"Cancelled Fleet Plan_": "ยกเลิกแผนกลุ่มยานพาหนะเมื่อ {{date}}",
	"The new plan_": "แผนใหม่จะมีผลเมื่อสิ้นสุดรอบการเรียกเก็บเงินปัจจุบันของคุณ",
	"Profile photo": "รูปภาพโปรไฟล์",
	Name: Name$1,
	"E-mail address": "ที่อยู่อีเมล",
	Password: Password$1,
	"Last changed_": "เปลี่ยนแปลงล่าสุด {{a}}",
	"Change password": "เปลี่ยนรหัสผ่าน",
	"Delete account": "ลบบัญชี",
	Cancel: Cancel$1,
	"Current password": "รหัสผ่านปัจจุบัน",
	"New password": "รหัสผ่านใหม่",
	"Confirm new password": "ยืนยันรหัสผ่านใหม่",
	"Password changed": "เปลี่ยนรหัสผ่านแล้ว",
	"Reason for deletion_": "เหตุผลสำหรับการลบ (ไม่บังคับ)",
	"Account password": "รหัสผ่านบัญชี",
	Members: Members$1,
	Groups: Groups$1,
	"+ Invite member": "+ เชิญสมาชิก",
	"Name, Email": "ชื่อ อีเมล",
	Role: Role$1,
	Group: Group$1,
	"Date invited": "วันที่เชิญ",
	Status: Status$1,
	"Group n": "กลุ่ม {{a}}",
	nPM: nPM$1,
	nAM: nAM$1,
	Newest: Newest$1,
	Oldest: Oldest$1,
	"Name, email or_": "ชื่อ อีเมลหรือกลุ่ม",
	Accepted: Accepted$1,
	Pending: Pending$1,
	Expired: Expired$1,
	All: All$1,
	"No results": "ไม่มีผลลัพธ์",
	"Try different keywords": "ลองใช้คำหลักอื่น",
	"Try changing or_": "ลองเปลี่ยนหรือลบตัวกรอง",
	"Remove all filters": "ลบตัวกรองทั้งหมด",
	"Invite member": "เชิญสมาชิก",
	"Send invite": "ส่งคำเชิญ",
	"You have reached_": "คุณมีจำนวนซับมาสเตอร์ครบขีดจำกัดที่ 10 คนแล้ว คุณสามารถเชิญผู้ใช้ได้ต่อไป",
	Delete_: Delete_$1,
	"Are you sure_delete": "คุณแน่ใจหรือว่าต้องการลบสมาชิกคนนี้และบัญชีของเขา",
	Delete: Delete$1,
	Rename: Rename$1,
	"No submaster yet": "ยังไม่มีซับมาสเตอร์",
	"You can add_": "คุณสามารถเพิ่มซับมาสเตอร์ได้ 1 คนต่อกลุ่ม",
	"No cameras yet": "ยังไม่มีกล้อง",
	"Add cameras first_": "เพิ่มกล้องก่อน จากนั้นจึงกำหนดผู้ใช้",
	"Name or email": "ชื่อหรืออีเมล",
	"Add submaster": "เพิ่มซับมาสเตอร์",
	Add: Add$1,
	"Add camera": "เพิ่มกล้อง",
	"n of n selected": "{{a}} จาก {{b}} ได้ถูกเลือก",
	"No cameras available": "ไม่มีกล้องที่ใช้ได้",
	"Most likely reasons_": "สาเหตุที่เป็นไปได้มากที่สุด:",
	"All cameras were_": "กล้องทั้งหมดถูกเพิ่มไปยังกลุ่มอื่น",
	"You can remove_": "คุณสามารถลบกล้องออกจากกลุ่มอื่น ๆ และเพิ่มในกลุ่มนี้ได้",
	"No cameras were_": "ไม่มีการเพิ่มกล้องไปยังบัญชีของคุณ",
	"You can add_cameras": "คุณสามารถเพิ่มกล้องในแอป BlackVue หรือโปรแกรมดูบนเดสก์ท็อป",
	OK: OK$1,
	"Rename group": "เปลี่ยนชื่อกลุ่ม",
	"Are you sure_group": "คุณแน่ใจหรือว่าต้องการลบกลุ่มนี้",
	"Edit Mobile app_": "แก้ไขสิทธิ์ของแอปมือถือ/โปรแกรมดูบนเดสก์ท็อป",
	Remove: Remove$1,
	"n of n users": "ผู้ใช้ {{a}} จาก {{b}} ราย",
	"Youve reached the_": "คุณมีจำนวนผู้ใช้ครบขีดจำกัดต่อกล้องแล้ว",
	"Remove user": "ลบผู้ใช้",
	"Add user": "เพิ่มผู้ใช้",
	"+ Add group": "+ เพิ่มกลุ่ม",
	"Add group": "เพิ่มกลุ่ม",
	"Group or submaster": "กลุ่มหรือซับมาสเตอร์",
	"+ Add": "+ เพิ่ม",
	"of max selected": "มีการเลือก {{a}} จากสูงสุด {{b}} รายการ",
	"Mobile app/desktop_": "สิทธิ์ของแอปมือถือ/โปรแกรมดูบนเดสก์ท็อป",
	Files: Files$1,
	Features: Features$1,
	Settings: Settings$1,
	Upload: Upload$1,
	"Download and Playback_Cloud": "ดาวน์โหลดและเล่นภาพจากพื้นที่จัดเก็บข้อมูลบนคลาวด์",
	"Download and Playback_SD": "ดาวน์โหลดและเล่นภาพจากการ์ด SD",
	"Live view": "Live View",
	"Geo Fencing": "กำหนดขอบเขตภูมิศาสตร์",
	"Drive Reports": "รายงานการขับขี่",
	"Firmware Settings": "การตั้งค่าเฟิร์มแวร์",
	"Push Notifications": "การแจ้งเตือนแบบพุช",
	"Event Auto Upload": "อัพโหลดเหตุการณ์สดโดยอัตโนมัติ",
	Privacy: Privacy$1,
	Done: Done$1,
	"Payment method": "วิธีการชำระเงิน",
	"Change payment method": "เปลี่ยนวิธีการชำระเงิน",
	Subscription: Subscription$1,
	"Space used": "พื้นที่ที่ใช้",
	"Next billing_": "การเรียกเก็บเงินครั้งถัดไป {{a}} {{b}}",
	"You manage_available": "คุณจัดการ {{a}} จาก {{b}} รายการที่อยู่ในแผนของคุณ",
	Submasters: Submasters$1,
	Users: Users$1,
	Change: Change$1,
	"No transactions yet_": "คุณสมัครสมาชิกแผนฟรี ยังไม่มีการทำธุรกรรม",
	"No transactions to_": "ไม่มีธุรกรรมที่จะแสดง<br/>หากคุณกำลังมองหาประวัติการทำธุรกรรมของแพลตฟอร์มอื่น ๆ (เช่น iOS, Android, PayPal) คุณสามารถดูประวัติได้ที่หน้าสมัครสมาชิกในแพลตฟอร์มของคุณเอง",
	"of nGB_": "{{a}} จาก {{b}}GB ({{c}}%)",
	"Smart Plan users_": "ผู้ใช้แผนชาญฉลาดสามารถเปลี่ยนแผนการสมัครสมาชิกหรือจำนวนกล้องได้ผ่านแอปมือถือ BlackVue",
	"Transaction history": "ประวัติการทำรายการ",
	"Date": "วันที่",
	"Amount, USD": "จำนวนเงิน USD",
	Method: Method$1,
	Details: Details$1,
	"iOS in-app_": "iOS in-app purchase/Android in-app purchase",
	"Change the number_": "เปลี่ยนจำนวนกล้อง",
	"You manage_cameras": "You manage {{a}} cameras of {{b}} available on your plan",
	"Extra cameras": "กล้องเสริม",
	"Total due_": "ยอดครบกำหนดชำระทั้งหมด",
	"available on your_": "จากกล้อง {{a}} ตัวที่ใช้ได้สำหรับแผนของคุณ",
	"Cancel Fleet Plan": "ยกเลิก Fleet Plan",
	"This will cancel_": "การดำเนินการนี้จะยกเลิกการสมัครสมาชิกแผนกลุ่มยานพาหนะของคุณ คุณจะดาวน์เกรดเป็นแผนฟรีเมื่อสิ้นสุดรอบการเรียกเก็บเงิน",
	"Reason for cancellation_": "เหตุผลในการยกเลิก (ไม่บังคับ)",
	"Not now": "ไม่ใช่ตอนนี้",
	Confirm: Confirm$1,
	"Cardholder name": "ชื่อผู้ถือบัตร",
	"Card name": "ชื่อบัตร",
	"MM/YY": "MM/YY",
	Address: Address$1,
	Country: Country$1,
	State: State$1,
	ZIP: ZIP$1,
	Pricing: Pricing$1,
	"You are subscribed_": "คุณสมัครสมาชิกแผนฟรีแล้ว",
	"With Alert Push_": "มีการแจ้งเตือนแบบพุช การดูภาพสดจากระยะไกลแบบจำกัด และพื้นที่จัดเก็บข้อมูลบนคลาวด์",
	Free: Free$1,
	Smart: Smart$1,
	Fleet: Fleet$1,
	"Get started for_": "เริ่มต้นใช้งานฟรี ไม่ต้องใช้บัตรเครดิต \n รวมถึงการแจ้งเตือนแบบพุช การดูภาพสดจากระยะไกล และพื้นที่จัดเก็บข้อมูลบนคลาวด์",
	Subscrubed: Subscrubed$1,
	"Features included:": "คุณสมบัติที่มีให้:",
	"Get unlimited Remote_": "รับการดูภาพสดจากระยะไกลและการเล่นภาพบนคลาวด์แบบไม่จำกัด และจัดการกล้องได้สูงสุดถึง {{a}} ตัว",
	"BlackVue Fleet Tracking_": "คุณสมบัติพิเศษ BlackVue Fleet Tracking (การติดตามกลุ่มยานพาหนะของ BlackVue) ที่มีไว้โดยเฉพาะสำหรับผู้ใช้ระดับสูงและธุรกิจ (ผู้ใช้หลายรายและกล้องหลายตัว การสร้างขอบเขตเสมือน และอื่น ๆ)",
	"Try 1 Month Free": "ทดลองใช้ฟรี 1 เดือน",
	"Log in": "ล็อกอิน",
	"Remember me": "จดจำฉัน",
	"Forgot password?": "ลืมรหัสผ่านหรือไม่",
	"Reset password": "รีเซ็ตรหัสผ่าน",
	"Enter email address_": "ป้อนที่อยู่อีเมลที่ใช้ในระหว่างการลงทะเบียนและเราจะส่งลิงก์เพื่อรีเซ็ตรหัสผ่านของคุณ",
	"Send reset password_": "ส่งอีเมลรีเซ็ตรหัสผ่าน",
	"Back to login": "ย้อนกลับไปที่การล็อกอิน",
	"Check your email": "ตรวจสอบอีเมลของคุณ",
	"Weve sent an_": "เราได้ส่งอีเมลไปที่ {{a}} พร้อมลิงก์ที่ใช้ในการยืนยันที่อยู่อีเมลของคุณแล้ว",
	"Resend email": "ส่งอีเมลอีกครั้ง",
	January: January$1,
	February: February$1,
	March: March$1,
	April: April$1,
	May: May$1,
	June: June$1,
	July: July$1,
	August: August$1,
	September: September$1,
	October: October$1,
	November: November$1,
	December: December$1,
	"Sign up": "สร้างบัญชี",
	"First name": "ชื่อ",
	"Last name": "นามสกุล",
	"Create a password": "สร้างรหัสผ่าน",
	"5 or more_": "5 ตัวอักขระขึ้นไป",
	"Sign up and_": "สมัครใช้งานและดำเนินการต่อ",
	"I agree to_": "ฉันยอมรับ %@ %@ %@ และ %@",
	"Subscribe to newsletter": "สมัครสมาชิกรับจดหมายข่าว",
	"1 month free trial_": "ทดลองใช้ฟรี 1 เดือน",
	"Dont have an_": "ยังไม่มีบัญชีใช่หรือไม่",
	"Thank you for_": "ขอขอบคุณที่สมัครใช้งาน BlackVue Cloud โปรดยืนยันที่อยู่อีเมลของคุณ",
	"Confirm email": "ยืนยันอีเมล",
	"If you didnt_": "หากคุณไม่ได้สมัครใช้งานบัญชีนี้ โปรดไม่ต้องสนใจอีเมลนี้",
	Blackvuecloud_: Blackvuecloud_$1,
	"invited you to_": "{{a}} เชิญคุณเข้าร่วมกลุ่มยานพาหนะของเขาในฐานะซับมาสเตอร์",
	"Accept invitation": "ตอบรับคำเชิญ",
	"Invite expires on_": "คำเชิญจะหมดอายุใน วัน เดือน, ปี",
	"Your Fleet Management_": "บัญชีการจัดการยานพาหนะของคุณที่ลงทะเบียนไว้กับ {{a}} ถูกลบโดย %@",
	"If you believe_": "หากคุณเชื่อว่านี่เป็นข้อผิดพลาด โปรดติดต่อฝ่ายสนับสนุนลูกค้าของเรา: cs@blackvue.com",
	Support: Support$1,
	"Help center": "ศูนย์ช่วยเหลือ",
	Community: Community$1,
	"Getting started": "เริ่มต้น",
	FAQ: FAQ$1,
	Developers: Developers$1,
	"Cloud API": "Cloud API",
	"Fleet SDK": "Fleet SDK",
	"Follow us": "Follow us",
	Facebook: Facebook$1,
	Twitter: Twitter$1,
	Instagram: Instagram$1,
	Youtube: Youtube$1,
	Linkedin: Linkedin$1,
	"BlackVue apps": "BlackVue apps",
	"Camera registraiton": "การลงทะเบียนกล้อง",
	"Two-way voice_": "การสื่อสารด้วยเสียงสองทิศทาง",
	"Live GPS": "GPS สด",
	"Event live auto_": "อัพโหลดเหตุการณ์สดโดยอัตโนมัติ",
	"Event file auto_": "อัพโหลดไฟล์เหตุการณ์โดยอัตโนมัติ",
	"Compatible with_": "ใช้ได้กับรุ่น DR650GW, DR650S",
	"Not compatible with_": "ใช้ไม่ได้กับรุ่น DR650GW, DR650S",
	"More cameras": "กล้องอื่น ๆ",
	"More users": "More users",
	"Roles and permissions": "Roles and permissions",
	"More Cloud Storage": "ที่เก็บข้อมูลบนคลาวด์เพิ่มเติม",
	"Multi Live view_": "Multi Live View (Web)",
	"Longer GPS Tracking": "Longer GPS Tracking",
	"Geo Fence setup_": "Geo Fence setup (PC viewer) and alerts (PC viewer and app)",
	"Changes saved": "บันทึกการเปลี่ยนแปลงแล้ว",
	"Group added": "เพิ่มกลุ่มแล้ว",
	"Member added": "เพิ่มสมาชิกแล้ว",
	"Group deleted": "ลบกลุ่มแล้ว",
	"Member deleted": "ลบสมาชิกแล้ว",
	"Group renamed": "เปลี่ยนชื่อกลุ่มแล้ว",
	"Submaster added": "เพิ่มซับมาสเตอร์แล้ว",
	"Camera added": "เพิ่มกล้องแล้ว",
	"User added": "เพิ่มผู้ใช้แล้ว",
	"Users added": "เพิ่มผู้ใช้แล้ว",
	Downloads: Downloads$1,
	"The BlackVue App_": "The BlackVue App and Viewer let you use your BlackVue camera to its full potential. Whether on mobile or on home computer, BlackVue gives you the tools to fully enjoy your dashcam's functions.",
	"Compatible with all_": "Compatible with all Wi-Fi enabled BlackVue models.",
	"Supports all BlackVue_": "Supports all BlackVue models to date.",
	"confirm new password": "ยืนยันรหัสผ่านใหม่",
	"Your password is_": "รหัสผ่านที่คุณป้อนไม่ถูกต้อง",
	"Confirm password does_": "รหัสผ่านไม่ตรงกัน",
	"Please enter_email": "โปรดป้อนที่อยู่อีเมลที่ถูกต้อง",
	"Please enter_password": "รหัสผ่านที่คุณป้อนไม่ถูกต้อง",
	"Internal server error_": "ข้อผิดพลาดของเซิร์ฟเวอร์ภายใน โปรดลองอีกครั้ง",
	"New password is_": "อย่างน้อย 1 อักขระควรแตกต่างกันสำหรับรหัสผ่านปัจจุบันของคุณ",
	"It should be_": "รหัสผ่านควรมีความยาว 5 อักขระขึ้นไป",
	"Invalid permission": "สิทธิ์การใช้งานไม่ถูกต้อง",
	"Input data isnt_": "ไม่มีข้อมูลที่ป้อน",
	Unauthorized: Unauthorized$1,
	"Already have subsciption": "มีการสมัครสมาชิกแล้ว",
	"Already uses": "ใช้แล้ว",
	"Already logged in": "เข้าสู่ระบบแล้ว",
	"Already sent e-mail": "ส่งอีเมลแล้ว",
	"Please wait": "โปรดรอสักครู่",
	"E-mail is not_": "อีเมลยังไม่ได้รับการยืนยัน",
	"Update your subscription_": "อัปเดตการสมัครสมาชิกของคุณ",
	"Account was deleted": "ลบบัญชีแล้ว",
	"5 ~ 30_": "5 ~ 30 characters",
	"It has exceeded_": "มีผู้ดูแลระบบเกินจำนวนสูงสุดที่ 9 คน",
	"Billing information": "ข้อมูลการเรียกเก็บเงิน",
	"Please enter cardName": "ป้อนชื่อบัตร",
	"Please enter_card": "ป้อนหมายเลขบัตรที่ถูกต้อง",
	"Please enter address": "ป้อนที่อยู่",
	"Please select country": "เลือกประเทศ",
	"Please enter city": "ป้อนเมือง",
	none: none$1,
	"Due today": "ครบกำหนดวันนี้",
	"Today after 1_": "วันนี้หลังจากทดลองใช้ 1 เดือน",
	"An error occurred_": "เกิดข้อผิดพลาดขณะพยายามเปลี่ยนรหัสผ่าน ลองอีกครั้ง",
	"Your account is_": "บัญชีของคุณใช้งานได้แล้ว",
	"You can now_": "ตอนนี้คุณสามารถเข้าสู่ระบบบัญชีของคุณด้วยที่อยู่อีเมลที่ใช้ระหว่างการลงทะเบียน",
	Email: Email$1,
	"Don’t have an account?": "ยังไม่มีบัญชีใช่หรือไม่",
	"Already have an account?": "มีบัญชีอยู่แล้วใช่หรือไม่",
	"Cloud service": "Cloud service",
	"for your BlackVue": "for your BlackVue",
	"See what your_": "See what your camera sees remotely.",
	"Receive impact alert_": "Receive Impact alert push notifications.",
	"Save footage to_": "Save footage to the cloud and do much more...",
	"Free plan included_": "Free plan included · Easy setup · Cancel anytime",
	"Taking advantage of_": "Taking advantage of a mobile or car-embedded Internet connection and a BlackVue camera, BlackVue Cloud connects you to your car from anywhere, anytime. Using the BlackVue App on your smartphone or tablet, you see in real time where your car is located and what is happening around it.",
	"Get notifications to_": "Get notifications to your phone when your parked car is hit. Check remotely what is happening around your car.",
	"Monitor your commercial_": "Monitor your commercial vehicles on a map in real time. Talk to your drivers anytime through the BlackVue App or Viewer.",
	"With BlackVue Fleet_": "With BlackVue Fleet Tracking, track in real time up to 100 vehicles from the palm of your hand or with the dedicated BlackVue Viewer.",
	"Get started now_": "Get started now with a Free plan. For unlimited video playback or Remote Live View, upgrade to Lite or Smart plan from the BlackVue App. <br/>Business and power users can unlock the power of the Fleet plan exclusively through this website.",
	"Remote Video Playback_": "Remote Video Playback and Download",
	"Compatible with DR650GW_": "Compatible with DR650GW, DR650S models",
	"Unlimited remote video_": "Unlimited remote video playback and download",
	"Longer cloud storage_": "Longer cloud storage file expiration period",
	"Longer storage period_live": "Longer storage period for Event live auto upload",
	"Longer storage period_file": "Longer storage period for Event file auto upload",
	"Goefence setup (PC_": "Geo-fence setup (PC viewer) and alerts (Windows viewer and app)",
	"App Store": "App Store",
	"Send reset password email": "ส่งอีเมลรีเซ็ตรหัสผ่าน",
	Customers: Customers$1,
	Home: Home$1,
	"Pick a plan": "Pick a plan",
	"No customers yet": "No customers yet",
	"Customers will_": "Customers will show up here as they become available",
	"Add customer": "Add customer",
	"Report(PDF)": "Report(PDF)",
	"Subscription Period": "Subscription Period",
	Plan: Plan$1,
	New: New$1,
	Unsubscribed: Unsubscribed$1,
	"Subscription ends soon": "Subscription ends soon",
	Edit: Edit$1,
	"1 month trial": "1 month trial",
	"Edit customer details": "Edit customer details",
	"Customer name": "Customer name",
	"of 999 available_": "of 999 available on Fleet Plan",
	"Subscription starts": "Subscription starts",
	"Subscription period": "Subscription period",
	month: month$1,
	months: months$1,
	"Cloud storage": "Cloud Storage",
	"Subscription plan": "ประเภทการสมัครสมาชิก",
	"Check email address": "Check email address",
	"Add customer details": "Add customer details",
	Continue: Continue$1,
	Back: Back$1,
	"An error occured": "An error occured",
	"Customer added": "Customer added",
	"Last changed": "Last changed",
	"Company name": "Company name",
	"Company address": "Company address",
	"Alert Push Notifications": "Alert Push Notifications",
	"Receive notifications on_": "Receive notifications on your phone when preset Events occur. Great in combination with BlackVue’s Parking Mode.",
	"Remote Live View": "มุมมองสดระยะไกล",
	"Remotely monitor your_": "Remotely monitor your car in real time from anywhere, anytime.",
	"Video Backup/Auto Upload": "Video Backup/Auto Upload",
	"Back up videos_": "Back up videos to your phone or Cloud storage.",
	"Two-way Voice Communication": "Two-way Voice Communication",
	"Talk with people_": "Talk with people in the car from your smartphone. The driver can speak while keeping hands on the wheel.",
	"View your car’s_": "View your car’s location and speed on a map. With BlackVue Fleet Tracking, access 90-days’ worth of GPS data.",
	"Remote Video Playback": "Remote Video Playback",
	"Play videos stored_": "Play videos stored in the Cloud or in your dashcam anytime on your smartphone or tablet.",
	"Event Live Auto Upload": "Event Live Auto Upload",
	"Save a video stream_": "Save a video stream in real time to the Cloud. Protect yourself from break-ins and theft.",
	"Event File Auto Upload": "Event File Auto Upload",
	"Save Event videos_": "Save Event videos to the Cloud—including seconds before trigger—after they happen.",
	"Firmware-Over-the-Air (FOTA)": "Firmware-Over-the-Air (FOTA)",
	"Upgrade your dashcam’s": "Update your dashcam over the cloud",
	"When an Event_": "When an Event is created (Impact detected or manually triggered), Event Live Auto-upload lets your Cloud-compatible BlackVue save a live video stream from a camera of your choice (front or rear/interior) to the Cloud server",
	"Event File Auto-upload_": "Event File Auto-upload lets your dashcam automatically upload low-resolution versions of Event files to the Cloud.",
	Master: Master$1,
	"per Camera": "per Camera",
	"Event live auto upload_": "Event live auto upload compatible with all cloud cameras",
	"Drive report": "Drive report",
	"USA/Canada Toll Free": "USA/Canada Toll Free",
	"Monday–Saturday_": "Monday to Friday 8am-7pm / Saturday 9am-6pm (PST).",
	"Please agree to_": "You must accept Terms of Service",
	"Mac or Windows PC": "Mac or Windows PC",
	Develop: Develop$1,
	"Sign out": "Sign out",
	"Referral code": "รหัสอ้างอิง",
	"Total after 1 month trial": "ยอดรวมหลังจากทดลองใช้ 1 เดือน",
	"Already Use Stripe Token": "ใช้สไตรป์โทเค็นแล้ว",
	"Select period": "เลือกช่วงเวลา",
	"State/Region": "รัฐ/ภูมิภาค (ไม่บังคับ)",
	"ZIP/Postal": "รหัสไปรษณีย์",
	"$0.00": "$0.00",
	"$11.99": "$11.99",
	"$24.99": "$24.99",
	$9: $9$1,
	$15: $15$1,
	$10: $10$1,
	"mo + for_": "/mo + {{a}} per extra camera",
	mo: mo$1,
	"This e-mail address_": "ที่อยู่อีเมลนี้มีบัญชีหนึ่งใช้ลงทะเบียนไปแล้ว",
	"1 month": "1 เดือน",
	"Limit is reset daily": "ขีดจำกัดถูกรีเซ็ตทุกวัน",
	"Limit is reset monthly": "ขีดจำกัดถูกรีเซ็ตทุกเดือน",
	"Video plays and downloads": "การดาวน์โหลดและการเล่นวิดีโอ",
	"Your master": "Your owner",
	"Youre 1 step_": "คุณเหลืออีกเพียง 1 ขั้นตอนก็จะเสร็จสิ้นการสมัครสมาชิกแผนกลุ่มยานพาหนะ",
	"Finish signing up": "เสร็จสิ้นการสมัครใช้งาน",
	"Enter billing information": "ป้อนข้อมูลการเรียกเก็บเงิน",
	"Proceed to billing": "ดำเนินการเรียกเก็บเงิน",
	City: City$1,
	Charge: Charge$1,
	"User already invited_": "ผู้ใช้ได้รับเชิญจากมาสเตอร์แล้ว",
	"n% consumed": "ใช้ไป {{a}}%",
	"E-mail already exists": "มีอีเมลอยู่แล้ว",
	"Cancel your inapp_": "ยกเลิกการสมัครสมาชิกในแอปของคุณ",
	"You have cancel_": "คุณต้องยกเลิกการสมัครสมาชิกในแอปเพื่ออัปเกรดเป็นแผนกลุ่มยานพาหนะ: 1. ยกเลิกการสมัครสมาชิกปัจจุบันของคุณใน App Store หรือ Google Play Store คุณจะปรับลดเป็นแผนฟรีเมื่อสิ้นสุดรอบการเรียกเก็บเงินในปัจจุบันของคุณ ข้อมูลทั้งหมดของคุณจะยังคงเหมือนเดิม 2. เข้าสู่ระบบบัญชี blackvuecloud.com ของคุณและอัปเกรดเป็นแผนกลุ่มยานพาหนะ",
	"Edit permissions": "แก้ไขสิทธิ์",
	"See permissions": "ดูสิทธิ์",
	"Submaster removed": "ลบซับมาสเตอร์แล้ว",
	"Camera removed": "ลบกล้องแล้ว",
	"User removed": "ลบผู้ใช้แล้ว",
	"Users removed": "ลบผู้ใช้แล้ว",
	subscribe: subscribe$1,
	search: search$1,
	"permission can be_": "สิทธิ์จะสามารถตั้งค่าได้หลังจากที่ซับมาสเตอร์ยอมรับคำเชิญ",
	"The confirmation link_": "ลิงก์ยืนยันใช้ไม่ได้อีกต่อไป",
	"Possible reasons:_": "เหตุผลที่เป็นไปได้:\n • คุณได้ยืนยันที่อยู่อีเมลของคุณแล้ว\n • ลิงก์หมดอายุหรือถูกยกเลิก",
	"Failed to register_": "การลงทะเบียนกับ BlackVue Cloud ไม่สำเร็จ",
	"There was an_": "เกิดข้อผิดพลาดระหว่างขั้นตอนการสมัครใช้งาน หากปัญหายังคงอยู่ ให้ลองสมัครใช้งาน BlackVue Cloud อีกครั้ง หากคุณต้องการความช่วยเหลือเพิ่มเติม โปรดติดต่อฝ่ายสนับสนุนลูกค้าของเรา:",
	"Upgrade to Fleet_": "อัปเกรดเป็นแผนกลุ่มยานพาหนะ",
	"Subscription is Canceled": "การสมัครสมาชิกถูกยกเลิก",
	"No members yet": "ยังไม่มีสมาชิก",
	"Please enter_group name": "ป้อนชื่อกลุ่มที่ถูกต้อง",
	"Group Name": "ชื่อกลุ่ม",
	invalid_number: invalid_number$1,
	invalid_expiry_month: invalid_expiry_month$1,
	invalid_expiry_year: invalid_expiry_year$1,
	invalid_cvc: invalid_cvc$1,
	incorrect_number: incorrect_number$1,
	incomplete_number: incomplete_number$1,
	incomplete_cvc: incomplete_cvc$1,
	incomplete_expiry: incomplete_expiry$1,
	expired_card: expired_card$1,
	incorrect_cvc: incorrect_cvc$1,
	incorrect_zip: incorrect_zip$1,
	invalid_expiry_year_past: invalid_expiry_year_past$1,
	card_declined: card_declined$1,
	missing: missing$1,
	processing_error: processing_error$1,
	"no groups yet": "ยังไม่มีกลุ่ม",
	"groups will show_": "กลุ่มจะปรากฏที่นี่เมื่อพร้อมใช้งาน",
	"Fleet members will_": "สมาชิกกลุ่มยานพาหนะจะปรากฏตัวที่นี่เมื่อพร้อมให้บริการ",
	"service provider": "ผู้ให้บริการ",
	Paypal: Paypal$1,
	iOS: iOS$1,
	Android: Android$1,
	"Enter email": "Please enter a email address",
	"Enter password": "โปรดป้อนรหัสผ่าน",
	"Enter first name": "ป้อนชื่อจริง",
	"Enter last name": "ป้อนนามสกุล",
	"Enter the current_": "ป้อนรหัสผ่านปัจจุบัน",
	"Enter a new_": "ป้อนรหัสผ่านใหม่",
	"There isnt an_": "ไม่มีบัญชีที่เชื่อมโยงกับที่อยู่อีเมลนี้",
	"Fleet Plan": "Fleet Plan",
	Total: Total$1,
	"Password you entered_": "รหัสผ่านที่คุณป้อนไม่ถูกต้อง",
	"Incorrect email or_": "อีเมลหรือรหัสผ่านไม่ถูกต้อง",
	"Available to Masters": "มีให้สำหรับเจ้าของ",
	"Blackvue url": "https://www.blackvue.com",
	"Information We Collect_": "ข้อมูลที่เรารวบรวมและเหตุผล",
	And: And$1,
	"Terms of Location-Based_": "ข้อกำหนดการใช้บริการตามตำแหน่งที่ตั้ง",
	"I agree to the_": "ฉันเห็นด้วยกับ",
	"Password Reset_": "เราได้ส่งอีเมลไปที่ {{a}} พร้อมกับคำแนะนำในการรีเซ็ตรหัสผ่าน",
	"You have already_": "คุณได้รับเชิญแล้ว โปรดตรวจสอบอีเมลของคุณ",
	"No data available_": "ไม่มีข้อมูลในตาราง",
	Camera: Camera$1,
	"You no longer_": "คุณไม่มีสิทธิ์การใช้งานสำหรับบริการกลุ่มยานพาหนะอีกต่อไป",
	"Please contact your_": "โปรดติดต่อมาสเตอร์ของกลุ่มยานพาหนะของคุณเพื่อแก้ไขปัญหา",
	"You can still_": "คุณยังคงสามารถเข้าถึง",
	"account information": "ข้อมูลบัญชีของคุณได้",
	"If the issue_": "หากปัญหาไม่ได้รับการแก้ไขและคุณตัดสินใจที่จะใช้บริการ BlackVue Cloud ต่อไปด้วยที่อยู่อีเมลที่ลงทะเบียนไว้ คุณจะต้องลบบัญชีของคุณและสมัครใช้งานอีกครั้ง",
	"If the problem_": "หากปัญหายังคงมีอยู่ โปรดติดต่อฝ่ายสนับสนุนลูกค้าของเรา:",
	"Web subscription only": "สมัครสมาชิกผ่านเว็บเท่านั้น",
	"AppStore url": "https://apps.apple.com/kr",
	"We no longer_": "เราไม่ได้ดำเนินการกับการชำระเงินผ่าน PayPal อีกต่อไป คุณต้องอัปเดตการสมัครสมาชิกของคุณเพื่อเปลี่ยนจำนวนกล้อง: 1. เข้าสู่ระบบบัญชี paypal.com ของคุณและยกเลิกการสมัครสมาชิกแผนกลุ่มยานพาหนะในปัจจุบันของคุณเพื่อเปลี่ยนจำนวนกล้อง: 2. เข้าสู่ระบบบัญชี blackvuecloud.com ของคุณและอัปเกรดเป็นแผนกลุ่มยานพาหนะ",
	Yes: Yes$1,
	No: No$1,
	"Serial number": "หมายเลขผลิตภัณฑ์",
	"Cloud code": "รหัส Cloud",
	"Terms & Policies": "ข้อกำหนดและนโยบาย",
	News: News$1,
	Notifications: Notifications$1,
	"km/h": "km/h",
	MPH: MPH$1,
	"Baidu Maps": "Baidu Maps (ประเทศจีนเท่านั้น)",
	"Google Maps": "Google Maps",
	Firmware: Firmware$1,
	Basic: Basic$1,
	"Time Zone": "โซนเวลา",
	Resolution: Resolution$1,
	"Image quality": "คุณภาพของภาพ",
	Brightness: Brightness$1,
	Recording: Recording$1,
	"Normal recording": "การบันทึกปกติ",
	"Voice recording": "การบันทึกเสียง",
	"Video segment length": "ความยาวช่วงเวลาวิดีโอ",
	"Rear camera recording": "การบันทึกด้วยกล้องหลัง",
	Highest: Highest$1,
	High: High$1,
	Normal: Normal$1,
	"1 min": "1 น้อยที่สุด",
	"2 min": "2 น้อยที่สุด",
	"3 min": "3 น้อยที่สุด",
	Sensitivity: Sensitivity$1,
	"Motion detection": "การตรวจจับการเคลื่อนไหว",
	"Speed alert": "การเตือนเกี่ยวกับความเร็ว",
	"Voice guidance": "การนำทางด้วยเสียง",
	"Power on": "เปิดเครื่อง",
	"Power off": "ปิดเครื่อง",
	"Starting normal recording": "เริ่มการบันทึกแบบปกติ",
	"Changing recording mode": "การเปลี่ยนโหมดการบันทึก",
	"Speed alert (beep)": "การเตือนเกี่ยวกับความเร็ว (เสียงบี๊ป)",
	"Cloud related": "เกี่ยวข้องกับ Cloud",
	Volume: Volume$1,
	"User text overlay": "ข้อความที่ผู้ใช้กำหนดให้แสดง",
	"A-Z, a-z_": "A~Z, a~z, 0~9, :;’/\\+-_()$#\n ไม่เกิน 20 อักขระ",
	"Wi-Fi auto turn off": "Wi-Fi ปิดอัตโนมัติ",
	"Login credentials": "ข้อมูลประจำตัวล็อกอิน",
	"Manual recording": "การบันทึกด้วยตนเอง",
	"By sharing your_": "หากคุณแชร์การดูสด คุณสามารถเปิดให้ผู้ใช้รายอื่นมีประสบการณ์ที่น่าตื่นเต้นและสนุกสนานกับการขับขี่ไปทั่วโลก",
	"However, as persona_": "อย่างไรก็ตาม วิดีโอส่วนตัวอาจถูกเผยแพร่ไปด้วย คุณควรระมัดระวังเป็นพิเศษต่อการตัดสินใจว่าควรแชร์ข้อมูลใด",
	"Please enter_email_2": "กรุณาใส่อีเมล์ที่ถูกต้อง. อีเมลที่มีอักขระพิเศษบางตัวอาจไม่ได้รับอนุญาต อดีต) +, &",
	"Password is incorrect": "รหัสผ่านไม่ถูกต้อง",
	"This camera is already_": "ลงทะเบียนกล้องนี้แล้วในบัญชี BlackVue",
	"Camera name must_": "ชื่อกล้องต้องมี 5 ถึง 32 อักขระ",
	"Failed to save_": "บันทึกการตั้งค่ากล้องไม่สำเร็จ",
	"Unallowed character detected": "ตรวจพบอักขระที่ไม่อนุญาต",
	"File(s) queued for_": "ไฟล์ที่เข้าคิวรออัพโหลดขึ้น Cloud",
	"Exceeded video play_": "เกินขีดจำกัดการเล่นและดาวน์โหลดวิดีโอ",
	"Playback Failed": "การเล่นไม่สำเร็จ",
	"Exceeded your Live_": "เกินขีดจำกัดเวลาการดูสดของคุณ",
	"The camera is not_": "กล้องไม่ได้เชื่อมต่อกับเซิร์ฟเวอร์",
	"Please check the connection_": "โปรดตรวจสอบสถานะการเชื่อมต่อของกล้องที่เลือก",
	Close: Close$1,
	"Map": "แผนที่",
	Cloud: Cloud$1,
	Public: Public$1,
	"Flip horizontally": "พลิกแนวนอน",
	Front: Front$1,
	Rear: Rear$1,
	Play: Play$1,
	Stop: Stop$1,
	Pause: Pause$1,
	"Next frame": "เฟรมถัดไป",
	"Previous frame": "เฟรมก่อนหน้า",
	"Proximity sensor": "เซ็นเซอร์ความใกล้ชิด",
	"Voice recording on/off": "เปิด/ปิด การบันทึกเสียง",
	"The BlackVue dashcam_": "กล้องติดรถ BlackVue ใช้งานร่วมกับเครือข่ายไร้สาย 5GHz ไม่ได้",
	Time: Time$1,
	"Daylight saving time": "เวลาออมแสง",
	System: System$1,
	"Incorrect camera serial_": "หมายเลขประจำสินค้าของกล้องไม่ถูกต้อง",
	"Lock event files": "ล็อคไฟล์เหตุการณ์",
	"Overwrite locked event_": "เขียนทับไฟล์เหตุการณ์ที่ล็อคเมื่อเต็ม",
	"Camera settings saved_": "บันทึกการตั้งค่ากล้องสำเร็จ",
	"Front camera": "กล้องหน้า",
	"Rear camera": "กล้องหลัง",
	Event: Event$1,
	Parking: Parking$1,
	"GPS tracking": "การติดตาม GPS",
	"G-force detected": "ตรวจพบ G-force",
	"Impact detected in_": "ตรวจพบการกระแทกในโหมดจอดรถ",
	"Scheduled reboot": "การรีบู๊ตกำหนดล่วงหน้า",
	"Recording status": "สถานะการบันทึก",
	"Rear security": "ความปลอดภัยหลัง",
	"Time lapse": "การหน่วงเวลา",
	"Sync with GPS_": "ซิงค์กับเวลา GPS",
	"Overwrite locked event3_": "เขียนทับไฟล์ที่ล็อคด้วยไฟล์เหตุการณ์ใหม่เมื่อที่เก็บข้อมูลเต็ม",
	"Video codec": "ตัวแปลงสัญญาณวิดีโอ",
	"Tracking logs": "ติดตามบันทึก",
	"Geofence alerts": "การเตือน Geo-Fencing",
	Color: Color$1,
	Exit: Exit$1,
	Save: Save$1,
	Impact: Impact$1,
	Unlimited: Unlimited$1,
	"Parking mode recording": "การบันทึกในโหมดจอดรถ",
	"Battery protection": "การปกป้องแบตเตอรี่",
	"Cut-off timer": "ตัวตั้งเวลาตัดไฟ",
	"Low voltage cut-off": "การตัดไฟเมื่อแรงดันไฟฟ้าต่ำ",
	"Rear camera orientation": "การวางแนวกล้องหลัง",
	Default: Default$1,
	"Rotate video 180°": "หมุนวิดีโอ 180°",
	"Mirror video": "สะท้อนภาพวิดีโอ",
	"Wi-Fi band": "ย่านความถี่ Wi-Fi",
	"Driving report": "รายงานการขับขี่",
	"Unsupported video codec_": "ไม่รองรับตัวแปลงสัญญาณวิดีโอนี้ (H.265)",
	"Rear camera recording_": "การบันทึกกล้องหลังในโหมดจอดรถ",
	"Front and rear_": "การบันทึกกล้องหน้าและหลังร่วมกัน",
	"Rear camera stops_": "กล้องหลังหยุดบันทึกภาพภายใน 5 นาทีหลังจากเข้าสู่โหมดจอดรถ การบันทึกเริ่มต้นใหม่เมื่อเข้าสู่โหมดปกติ",
	"Remote firmware update": "อัปเดตเฟิร์มแวร์จากระยะไกล",
	"Firmware is up-to-date": "เฟิร์มแวร์นี้คือรุ่นล่าสุดแล้ว",
	"New firmware available": "เฟิร์มแวร์เวอร์ชั่นใหม่พร้อมใช้งาน",
	Version: Version$1,
	"Release date": "วันที่เผยแพร่",
	Language: Language$1,
	"File size": "ขนาดของไฟล์",
	"What’s new": "มีอะไรใหม่",
	"Updating may take_": "การอัปเดตอาจใช้เวลาหลายนาที",
	"The update process_": "ไม่สามารถยกเลิกกระบวนการอัปเดตได้",
	"Do not disconnect the_": "อย่าถอดสายไฟจนกว่าการบันทึกที่เป็นปกติจะมีการรีสตาร์ท",
	"Downloading firmware": "กำลังดาวน์โหลดเฟิร์มแวร์",
	"Once download is_": "เมื่อดาวน์โหลดเสร็จสิ้น BlackVue จะรีบู๊ตโดยอัตโนมัติเพื่อใช้เฟิร์มแวร์ใหม่",
	"If not allowed_": "หากไม่ได้รับอนุญาต ตำแหน่งและความเร็วของรถยนต์จะไม่สามารถเข้าถึงได้จาก Cloud",
	"Unable to initiate update because_": "ไม่สามารถเริ่มการอัปเดตได้เนื่องจากกล้องติดรถถูกเชื่อมต่อเข้ากับอุปกรณ์ผ่านทาง Wi-Fi โดยตรง",
	Notification: Notification$1,
	Multiple: Multiple$1,
	Range: Range$1,
	"HDR night vision": "วิสัยทัศน์กลางคืนระบบ HDR",
	Download: Download$1,
	"G-sensor": "G-Sensor",
	Manual: Manual$1,
	"Low voltage warning": "เตือนแรงดันไฟฟ้าต่ำ",
	Satellite: Satellite$1,
	"Data usage": "การใช้ข้อมูล",
	"Select video download quality": "เลือกคุณภาพการดาวน์โหลดวิดีโอ",
	"Quick play file_": "ไฟล์เล่นด่วน (ความละเอียดต่ำ)",
	"Original file": "ไฟล์ต้นฉบับ",
	"You do not have permission_": "คุณไม่ได้รับอนุญาตให้เรียกใช้ฟังก์ชันนี้ กรุณาติดต่อเจ้าของบัญชีหลักของคุณ",
	"Interior camera recording_": "กล้องภายในบันทึกในโหมดจอดรถ",
	"Interior security": "ความปลอดภัยภายในรถ",
	"Interior camera rotation": "การหมุนกล้องภายใน",
	"Multi View": "หลายมุมมอง",
	Tutorials: Tutorials$1,
	"Upgrade now": "อัปเกรดตอนนี้",
	"Members will show_": "สมาชิกจะปรากฏที่นี่เมื่อพร้อมให้บริการ",
	"Are you sure_delete members": "คุณแน่ใจหรือว่าต้องการลบสมาชิกอย่างถาวร",
	"Some members may_": "สมาชิกบางคนอาจถูกซ่อนไว้เนื่องจากมีการใช้ตัวกรอง",
	"Invited on_": "ถูกรับเชิญโดยคุณเมื่อ {{Invited Date}} เจ้าของ",
	Filter: Filter$1,
	"Date created": "วันที่สร้าง",
	"No admin yet": "ยังไม่มีผู้ดูแลระบบ",
	"You can add_admin": "คุณสามารถเพิ่มผู้ดูแลระบบได้ 1 คนต่อกลุ่ม",
	"Collapse all": "ยุบทั้งหมด",
	"Expand all": "ขยายทั้งหมด",
	"Download and playback_cloud": "ดาวน์โหลดและเล่นจากที่เก็บข้อมูลบนคลาวด์",
	"Are you sure_2": "คุณแน่ใจหรือว่าต้องการลบกลุ่ม {Group name}",
	"Are you sure_groups": "คุณแน่ใจหรือว่าต้องการลบกลุ่ม",
	"Add cameras first_drivers": "เพิ่มกล้องก่อน จากนั้นจึงมอบหมายคนขับ",
	"Flip vertically": "พลิกแนวตั้ง",
	Sun: Sun$1,
	Mon: Mon$1,
	Tue: Tue$1,
	Wed: Wed$1,
	Thu: Thu$1,
	Fri: Fri$1,
	Sat: Sat$1,
	Dates: Dates$1,
	Routes: Routes$1,
	Opacity: Opacity$1,
	"Color and opacity": "สีและความทึบ",
	"Geofences will show_": "ขอบเขตภูมิศาสตร์จะปรากฏขึ้นที่นี่เมื่อพร้อมใช้งาน",
	"Start drawing a shape_": "เริ่มวาดรูปร่างบนแผนที่",
	"Add geofence": "เพิ่มขอบเขตภูมิศาสตร์",
	Entry: Entry$1,
	"Show all members": "แสดงสมาชิกทั้งหมด",
	"Me and my_": "ฉันและรถของฉัน เชื่อมต่อแล้ว",
	"add-on service for_": "บริการเสริมสำหรับ Blackvue ที่เข้ากันได้กับระบบคลาวด์",
	"Continue with Google": "ดำเนินการต่อด้วย Google",
	"An account with_": "มีบัญชีที่ใช้ที่อยู่อีเมลนี้อยู่แล้ว แต่ไม่ได้รับการยืนยัน ในการเข้าสู่ระบบกับ Google ให้ป้อนรหัสผ่าน BlackVue Cloud ที่มีอยู่เพื่อเข้าสู่ระบบ",
	"Account does not_": "บัญชีไม่มีอยู่ หรือลองเข้าสู่ระบบด้วยบัญชี Apple หรือ Google ของคุณ",
	"Continue with Apple": "ดำเนินการต่อด้วย Apple",
	"Get started": "เริ่มต้น",
	"P subscription only": "<b>{{a}}</b> สมัครสมาชิกเท่านั้น",
	"+N USD for extra camera_": "+{{a}} USD for extra camera up to {{b}} Cameras",
	"Unlimited Live view": "Unlimited Live View",
	"Cameras per Account": "Cameras per Account",
	"Users per Account": "Users per Account",
	Owner: Owner$1,
	"Live View per Day": "Live View per Day",
	"Remote Video Playback_2": "Remote Video Playback and Download per Month",
	"N days": "{{a}} Days",
	"Video On Map": "Video On Map",
	Undetected: Undetected$1,
	Distracted: Distracted$1,
	Drowsy: Drowsy$1,
	"Whether on mobile_": "Whether on mobile or your computer, BlackVue gives you the tools to fully enjoy your dashcam’s functions. Download the latest <a1>firmware</a1>, <a2>mobile</a2> and <a3>desktop</a3> applications, or use <a4>BlackVue web app</a4> in your browser.",
	"Compatible with most_": "Compatible with most Wi-Fi BlackVue models. Cloud support for all Cloud-compatible dashcam models down to DR650GW Series with <b>Cloud Firmware</b>.",
	"Supports most recent BlackVue_": "Supports most recent BlackVue models and compatible with BlackVue Cloud.<br/>\nThis Viewer contains <b>two applications in one</b>: the SD Card Viewer lets you view recorded videos from your SD card and modify the settings of your BlackVue, as well as format the SD card; the <b>Cloud Viewer</b> lets you enjoy BlackVue Cloud.",
	"Contact us": "Contact us",
	"6 characters with": "6 ตัวอักขระที่มีการผสมตัวอักษร ตัวเลข และสัญลักษณ์",
	"Apps and more...": "Apps and more...",
	"Cameras will show_": "Cameras will show up here as they become available.",
	"Keep this page_": "เปิดหน้านี้ไว้ขณะตรวจสอบรหัสยืนยัน ลองดูในโฟลเดอร์สแปมของคุณ หากคุณไม่พบอีเมลในกล่องจดหมายเข้าของคุณ",
	"n cameras": "กล้อง {{n}} ตัว",
	"n slots": "สล็อต {{n}} ช่อง",
	"Calculate your Fleet_": "คำนวณราคาแผนกลุ่มยานพาหนะของคุณ",
	"Code you entered_": "รหัสที่คุณป้อนไม่ถูกต้อง/หมดอายุแล้ว",
	Calling: Calling$1,
	Smoking: Smoking$1,
	"Smoking has been_": "ตรวจพบการสูบบุหรี่ขณะขับรถ",
	"Email is already_": "มีอีเมลอยู่แล้ว",
	"Serial number and_": "หมายเลขซีเรียลและรหัสคลาวด์จะพิมพ์อยู่บนกล้องของคุณ",
	"Allow GPS access": "อนุญาตการเข้าถึง GPS",
	"Used to access_": "ใช้เพื่อเข้าถึงตำแหน่งและความเร็วยานพาหนะของคุณ คุณสามารถเปลี่ยนการตั้งค่า GPS ในภายหลังได้ในการตั้งค่าความเป็นส่วนตัวของกล้อง",
	"Incorrect cloud code": "รหัสคลาวด์ไม่ถูกต้อง",
	"An account is_": "มีการลงทะเบียนบัญชีด้วยที่อยู่อีเมลนี้แล้ว",
	"Live event upload": "อัปโหลดเหตุการณ์สด",
	Permissions: Permissions$1,
	"Assign in": "มอบหมายใน",
	"Are you sure_camera": "คุณแน่ใจหรือไม่ว่าต้องการลบกล้องนี้",
	"Uploading videos:": "ดาวน์โหลดวิดีโอ:",
	"GPS location recording": "การบันทึกตำแหน่ง GPS",
	"When OFF, GPS_": "เมื่ออยู่ในสถานะปิด ตำแหน่ง GPS จะไม่ถูกบันทึกหรือส่งไปยังเซิร์ฟเวอร์คลาวด์",
	"As personal video_": "เนื่องจากวิดีโอส่วนตัวอาจถูกส่งไปด้วย คุณควรระมัดระวังเป็นพิเศษในการตัดสินใจว่าควรแชร์ข้อมูลใด",
	"Share location": "แชร์ตำแหน่ง",
	Private: Private$1,
	"Used to access_2": "ใช้เพื่อเข้าถึงตำแหน่งและความเร็วยานพาหนะของคุณ",
	"Share live view": "แชร์วิดีโอของมุมมองสด",
	"Share live audio": "แชร์เสียงของมุมมองสด",
	"Share camera’s name": "แชร์ชื่อกล้องติดรถ",
	"Impact detection": "การตรวจจับการชน",
	Entering: Entering$1,
	Exiting: Exiting$1,
	"Normal event recording": "การบันทึกเหตุการณ์แบบปกติ",
	"Harsh braking": "การเบรกที่รุนแรง",
	Acceleration: Acceleration$1,
	"Sharp turn": "การเลี้ยวหักศอก",
	"Parking event recording": "การบันทึกเหตุการณ์ขณะจอดรถ",
	Passing: Passing$1,
	"Video source": "แหล่งวิดีโอ",
	Overspeed: Overspeed$1,
	"Are you sure_video": "คุณแน่ใจหรือไม่ว่าต้องการลบวิดีโอนี้",
	"Add camera to_": "เพิ่มกล้องเข้าไปยังมุมมองสด",
	"No routes to_": "ไม่มีเส้นทางที่จะแสดง",
	"Start by adding_": "เริ่มต้นด้วยการเพิ่มวันที่",
	"invite sent": "ส่งคำเชิญแล้ว",
	Recipients: Recipients$1,
	Send: Send$1,
	"Routes selected_": "เส้นทางที่เลือก: {{n}} จาก {{total}}",
	"Map service": "บริการแผนที่",
	"Speed units": "หน่วยความเร็ว",
	Note: Note$1,
	"Release notes": "บันทึกประจำรุ่น",
	"The name must_": "ชื่อต้องมีความยาวระหว่าง 1 ถึง 30 อักขระ",
	Video: Video$1,
	Advanced: Advanced$1,
	"Firmware language": "ภาษาเฟิร์มแวร์",
	"Wi-Fi": "Wi-Fi",
	Voice: Voice$1,
	"Show date and_": "แสดงวันที่และเวลา",
	"Show speed": "แสดงความเร็ว",
	"Front camera rotation": "การหมุนกล้องหน้า",
	"Manual time settings": "การตั้งค่าเวลาด้วยตนเอง",
	"Recommended for better_": "ขอแนะนำเพื่อการบีบอัดไฟล์ที่ดีขึ้น ลดขนาดไฟล์และ 4K UHD",
	"For full compatibility_": "เพื่อให้ใช้งานร่วมกับเดสก์ท็อปและอุปกรณ์มือถือรุ่นเก่าได้เต็มระบบ",
	"Up and down": "บนและล่าง",
	"Side to side": "ด้านถึงด้าน",
	"Front and back": "หน้าและหลัง",
	"Detection region": "พื้นที่การตรวจจับ",
	"Hotspot 1": "ฮอตสปอต 1",
	"Hotspot 2": "ฮอตสปอต 2",
	"Hotspot 3": "ฮอตสปอต 3",
	"Enter/exit": "เข้า/ออก",
	"Event recording": "การบันทึกเหตุการณ์",
	"Front security (Normal)": "การรักษาความปลอดภัยด้านหน้า (ปกติ)",
	"Front security (Parking)": "การรักษาความปลอดภัยด้านหน้า (ที่จอดรถ)",
	"LTE (Parking)": "LTE (ที่จอดรถ)",
	"Wi-Fi (Parking)": "Wi-Fi (ที่จอดรถ)",
	"Turn on at startup": "เปิดเมื่อเริ่มต้น",
	"Turn off after_": "ปิดหลังจากไม่มีการใช้งาน 10 นาที",
	"Your firmware is_": "เฟิร์มแวร์ของคุณเป็นเวอร์ชันล่าสุด",
	"Add admin": "เพิ่มผู้ดูแลระบบ",
	"Remove All/n": "ลบทั้งหมด/{{a}}",
	"Are you sure_remove": "คุณแน่ใจหรือว่าต้องการลบกล้องออกจากกลุ่มนี้",
	"This will cancel_2": "การดำเนินการนี้จะยกเลิกการสมัครสมาชิกแผนกลุ่มยานพาหนะของคุณ คุณจะปรับลดเป็นแผนฟรีเมื่อสิ้นสุดรอบการเรียกเก็บเงินในปัจจุบันของคุณ",
	"You’ve reached_": "คุณมีคนขับครบขีดจำกัดต่อกล้องแล้ว",
	"Are you sure_remove admin": "คุณแน่ใจหรือว่าต้องการลบผู้ดูแลระบบ {{a}}{{b}} ออกจากกลุ่มนี้",
	"Fleet Plan · Owner": "Fleet Plan · Owner",
	"Manage cameras": "จัดการกล้อง",
	"Are you sure_delete zone": "คุณแน่ใจหรือว่าต้องการลบโซน \"{{zone}}\"",
	"available on your_2": "กล้อง {{a}}/{{b}} ตัวที่ใช้ได้สำหรับแผนของคุณ",
	"The new plan_2": "แผนใหม่จะมีผลเมื่อสิ้นสุดรอบการเรียกเก็บเงินในปัจจุบันของคุณ ({{a}})",
	"Canceled Fleet Plan_": "ยกเลิกแผนกลุ่มยานพาหนะเมื่อ {{a}}",
	"Hard braking alert (beep)": "การแจ้งเตือนการเบรกอย่างหนักหน่วง (เสียงบี๊บ)",
	"Hard acceleration alert (beep)": "การแจ้งเตือนการเร่งความเร็วอย่างหนักหน่วง (เสียงบี๊บ)",
	"Hard cornering alert (beep)": "การแจ้งเตือนการเข้าโค้งอย่างหนักหน่วง (เสียงบี๊บ)",
	"SSID must be_": "SSID ต้องมีความยาวอย่างน้อย 5 อักขระ",
	"Password must be_": "รหัสผ่านต้องมีความยาวอย่างน้อย 8 อักขระ",
	"5 to 32 characters long": "ความยาว 5 ถึง 32 อักขระ",
	"8 to 32 characters long": "ความยาว 8 ถึง 32 อักขระ",
	"Longer storage period_event": "ระยะเวลาการจัดเก็บข้อมูลที่นานขึ้นสำหรับการอัปโหลดเหตุการณ์สด",
	"Requires latest firmware_": "ต้องใช้เฟิร์มแวร์ล่าสุด ใช้ไม่ได้กับรุ่น DR650S, DR650GW",
	"After Blackvue is_": "หลังจาก Blackvue เชื่อมต่อกับคลาวด์แล้ว การตั้งค่าจะถูกบันทึก",
	"This is an_": "นี่เป็นอีเมลที่ไม่ได้ลงทะเบียน คุณต้องการสมัครใช้งานบัญชีใหม่หรือไม่",
	"This feature is_": "คุณสมบัตินี้มีให้สำหรับผู้สมัครสมาชิกแผนกลุ่มยานพาหนะเท่านั้น",
	"Please return to_": "บัญชีไม่มีอยู่ หรือลองเข้าสู่ระบบด้วยบัญชี Apple หรือ Google ของคุณ",
	"Adjusting the cut-off voltage_": "Adjusting the cut-off voltage to a lower setting may result in your dash cam draining more power from your battery.\nThis could result in warning messages of battery drain or affect other vehicle functions.\nPlease consult with your dealership before lowering the voltage.",
	"Your videos will_": "วิดีโอของคุณจะปรากฏที่นี่เมื่อพร้อมใช้งาน",
	"You drove:_": "คุณได้ขับขี่: {{distance}} {{time}}",
	"Event count per_": "จำนวนเหตุการณ์ต่อชั่วโมงการขับขี่",
	"Are you sure_recipient": "คุณแน่ใจหรือว่าต้องการลบผู้รับรายนี้",
	"(You)": "{{a}} (คุณ)",
	"All events": "เหตุการณ์ทั้งหมด",
	Days_: Days_$1,
	"Requires DMC 200_": "ต้องใช้กล้อง DMC 200",
	"A DMS and compatible_": "ต้องใช้ DMS และกล้องติดรถที่เข้ากันได้เพื่อดูรายงานนี้",
	"Notifications will show_": "การแจ้งเตือนจะปรากฏขึ้นที่นี่เมื่อพร้อมใช้งาน",
	"Try changing your_": "ลองเปลี่ยนวันที่หรือลบตัวกรอง",
	Mute: Mute$1,
	UnMute: UnMute$1,
	"Calling and smoking_": "ตรวจพบการโทรและการสูบบุหรี่โดยอุปกรณ์ DMC 200 เท่านั้น",
	"You need a DMS_": "คุณต้องมี DMS เพื่อดูรายงานนี้",
	"Try BlackVue Cloud": "ลอง BlackVue Cloud วันนี้",
	"Individual driver looking_": "คนขับแต่ละคนต้องการความอุ่นใจใช่หรือไม่ เจ้าของธุรกิจต้องการโซลูชันการรักษาความปลอดภัยและการติดตามยานพาหนะแบบเรียบง่ายใช่หรือไม่",
	"Whoever you are_": "ไม่ว่าคุณเป็นใคร ไม่ว่าคุณต้องการอะไร เรามีแผนคลาวด์ให้คุณ!",
	"It is the account that_Driver": "นี่เป็นบัญชีที่นำกลุ่มยานพาหนะของคุณเข้าสู่ BlackVue Cloud หลังจากที่ยอมรับคำเชิญทางอีเมลจากเจ้าของหรือผู้ดูแลระบบ อาจมีการกำหนดคนขับให้กล้องเพียงตัวเดียวโดยมีการจำกัดความสามารถในการดูโปรไฟล์บัญชีของตนเอง รวมทั้งการดูภาพสดและการเล่นภาพจากกล้อง",
	"It is the account that_Admin": "นี่เป็นบัญชีที่นำกลุ่มยานพาหนะของคุณเข้าสู่ BlackVue Cloud หลังจากที่ยอมรับคำเชิญทางอีเมลจากเจ้าของ บัญชีผู้ดูแลระบบอาจได้รับสิทธิ์จากเจ้าของที่ให้การอนุญาตสำหรับผู้ดูแลระบบรายดังกล่าว",
	"Video deleted": "วีดีโอถูกลบ",
	"Video delete_plural": "วีดีโอถูกลบ",
	"Driver removed from_": "คนขับถูกลบออกจากกลุ่ม",
	"Admin removed from_": "ผู้ดูแลระบบถูกลบออกจากกลุ่ม",
	"Camera removed from_": "กล้องถูกลบออกจากกลุ่ม",
	"Are you sure_videos": "คุณต้องการลบไฟล์ที่เลือกหรือไม่",
	"You have to cancel_fleet": "คุณต้องยกเลิกการสมัครสมาชิกในแอปเพื่อเปลี่ยนจำนวนกล้อง: 1. ยกเลิกการสมัครสมาชิกปัจจุบันของคุณใน App Store หรือ Google Play Store คุณจะปรับลดเป็นแผนฟรีเมื่อสิ้นสุดรอบการเรียกเก็บเงินในปัจจุบันของคุณ ข้อมูลทั้งหมดของคุณจะยังคงเหมือนเดิม 2. ล็อกอินเข้าสู่บัญชี blackvuecloud.com ของคุณและอัปเกรดเป็นแผนกลุ่มยานพาหนะ",
	Discard: Discard$1,
	"Discard unsaved changes?": "ละทิ้งการเปลี่ยนแปลงที่ยังไม่ได้บันทึกหรือไม่",
	"Incorrect serial number": "หมายเลขประจำสินค้าไม่ถูกต้อง",
	"An error occurred_again": "เกิดข้อผิดพลาด โปรดลองอีกครั้ง",
	"You are subscribed_free": "คุณสมัครสมาชิกแผนฟรีของ BlackVue Cloud แล้ว",
	"When an event_": "เมื่อเหตุการณ์ถูกสร้างขึ้น (ตรวจพบการกระแทกหรือมีการทริกเกอร์ด้วยตนเอง) การอัปโหลดเหตุการณ์สดจะช่วยให้ BlackVue ของคุณสามารถบันทึกสตรีมวิดีโอสดจากกล้องที่คุณเลือกไปยังเซิร์ฟเวอร์ Cloud ได้ โดยรวมถึง 5 วินาทีก่อนเกิดเหตุการณ์",
	Report: Report$1,
	"How it work": "สิ่งนี้ทำงานอย่างไร",
	"Cloud Camera": "กล้องคลาวด์",
	"Internet Connection": "การเชื่อมต่ออินเทอร์เน็ต",
	"BlackVue App/Viewer": "BlackVue App/Viewer",
	"All you need_": "สิ่งที่คุณต้องมีคือ",
	"Cloud-compatible BlackVue": "BlackVue ที่เข้ากันได้กับคลาวด์",
	"and a cellular_": "และแผนข้อมูลเซลลูลาร์ บางรุ่นเชื่อมต่อกับคลาวด์ผ่านฮอตสปอต Wi-Fi ของบริษัทอื่น ส่วนรุ่นอื่น ๆ จะมีตัวอ่านการ์ด Nano SIM แบบในตัวหรือรองรับโมดูลการเชื่อมต่อแบบปลั๊กอิน",
	"Cloud features at_": "คุณสมบัติคลาวด์อยู่ที่ปลายนิ้วของคุณ",
	"Enjoy peace of_": "สบายใจได้เลยเมื่อรู้ว่า BlackVue จะคอยดูแลรถของคุณ หากมีอะไรผิดพลาด กล้องติดรถจะส่งข้อความถึงคุณทันที",
	"Let your BlackVue_": "ให้ BlackVue ตรวจสอบรถของคุณและแจ้งเตือนคุณถึงเหตุการณ์ที่เกิดขึ้น ทันทีที่ตรวจพบการกระแทก BlackVue ของคุณจะส่งการแจ้งเตือนไปยังโทรศัพท์หรือเว็บเบราว์เซอร์ของคุณพร้อมด้วยภาพสแน็ปช็อต",
	"Check on your_": "ตรวจสอบรถของคุณได้จากทุกที่ด้วย Remote Live View (การดูภาพสดจากระยะไกล) ไม่ว่าจะผ่านเว็บเบราว์เซอร์หรือโทรศัพท์ของคุณ คุณสามารถเข้าถึงฟีดวิดีโอแบบเรียลไทม์ได้จากกล้องติดรถที่เชื่อมต่อกับคลาวด์และสามารถสลับระหว่างกล้องหน้า กล้องหลัง หรือกล้องภายในได้อย่างง่ายดาย",
	"Your BlackVue may_": "BlackVue ของคุณอาจไม่ได้ป้องกันการชนแล้วหนี แต่หากสิ่งนี้เกิดขึ้น คุณก็มีโอกาสที่ดีในการรวบรวมหลักฐานจากวิดีโอที่สำคัญ เรียกดูวิดีโอทั้งหมดที่กล้องติดรถของคุณบันทึกไว้ผ่านทางโทรศัพท์มือถือหรือเว็บเบราว์เซอร์",
	"Worried about eating_": "กังวลเกี่ยวกับการใช้ข้อมูลเกินขีดจำกัดผ่านแผนข้อมูลของคุณหรือไม่ เทคโนโลยีสตรีมย่อยของ BlackVue ช่วยให้คุณเข้าถึงวิดีโอในเวอร์ชันที่ใช้ข้อมูลน้อยเป็นพิเศษเพื่อการเรียกดูที่รวดเร็วและการรับชมที่ปราศจากการบัฟเฟอร์",
	"Move files from_": "ย้ายไฟล์จาก BlackVue ของคุณไปยังคลาวด์ บันทึกวิดีโอรายการเดียวหรือเลือกคลิปวิดีโอหลายรายการเพื่อการอัปโหลดแบบเป็นกลุ่ม วิดีโอที่ดาวน์โหลดไปยังโทรศัพท์ของคุณด้วยแอป BlackVue จะสามารถเข้าถึงและแชร์ได้จากเมนู Downloaded Videos (หน่วยความจำภายใน)",
	"View your vehicle’s_": "ดูตำแหน่งและความเร็วในการเดินทางของยานพาหนะแบบเรียลไทม์ อัปเกรดเป็นแผนชาญฉลาดเพื่อเข้าถึงข้อมูลการติดตามด้วย GPS ในช่วง 7 วันที่ผ่านมา",
	"Get more with_": "ได้รับมากขึ้นด้วยแผนชาญฉลาด",
	"Unlimited Remote Live_": "การดูภาพสดจากระยะไกลแบบไม่จำกัด",
	"Up to 3 dashcams_": "กล้องติดรถสูงสุด 3 ตัวภายใต้บัญชีเดียว",
	"Want to track_": "ต้องการติดตามกลุ่มยานพาหนะทั้งหมดหรือไม่ อัปเกรดเป็นแผนกลุ่มยานพาหนะ",
	"BlackVue Fleet Tracking_2": "BlackVue Fleet Tracking (การติดตามกลุ่มยานพาหนะของ BlackVue) เป็นโซลูชันแบบครบวงจรเพื่อปกป้องและติดตามกลุ่มยานพาหนะของคุณ คุณสมบัติและระดับราคาที่ยืดหยุ่นเพื่อตอบสนองความต้องการทางธุรกิจของคุณ",
	"Stream real-time video_": "สตรีมวิดีโอแบบเรียลไทม์โดยไม่มีขีดจำกัด บิตเรต: 600 kbps",
	"Up to 999 Dashcams": "กล้องติดรถสูงสุด 999 ตัว",
	"Register up to_": "ลงทะเบียนกล้องติดรถได้ถึง 999 ตัวต่อบัญชี",
	"15GB of Cloud_": "พื้นที่จัดเก็บข้อมูลบนคลาวด์ 15 GB",
	"15GB per additional_": "15 GB ต่อกล้องติดรถเพิ่มเติม พื้นที่จัดเก็บข้อมูลที่ไม่จำกัดการอัปโหลดเหตุการณ์แบบอัตโนมัติ",
	"90-days GPS_": "บันทึกการติดตามด้วย GPS 90 วัน",
	"High accuracy: 15_": "ความแม่นยำสูง: 15 วินาที วิดีโอบนแผนที่ การส่งออกข้อมูลที่ง่ายดาย",
	"Unique fleet management_": "คุณสมบัติการจัดการกลุ่มยานพาหนะที่มีเอกลักษณ์ช่วยเพิ่มมูลค่าและความสะดวกสบาย",
	"Create geofences and_": "สร้างขอบเขตเสมือนและรับการแจ้งเตือนแบบเรียลไทม์บนโทรศัพท์หรือคอมพิวเตอร์ของคุณ",
	"View at a_": "ดูภาพรวมเกี่ยวกับระยะทางการขับขี่โดยรวม เวลาว่าง เหตุการณ์การเร่งความเร็ว และอื่น ๆ ในตารางที่สามารถพิมพ์หรือส่งออกได้",
	"Multi Live View": "การดูภาพสดแบบหลายภาพ",
	"Monitor up to_": "ตรวจสอบกล้องติดรถได้ถึง 4 ตัวพร้อมกัน",
	"Benefits for you": "ประโยชน์สำหรับคุณ",
	Individual: Individual$1,
	"Get notifications to_2": "รับการแจ้งเตือนทางโทรศัพท์เมื่อรถของคุณที่กำลังจอดอยู่ถูกชน ตรวจสอบจากระยะไกลว่าเกิดอะไรขึ้นรอบ ๆ รถของคุณ สามารถใช้งานได้บนเว็บ, อุปกรณ์มือถือ, Mac และ Windows",
	"Small business owner": "เจ้าของธุรกิจขนาดเล็ก",
	"Monitor your commercial_2": "ตรวจสอบยานพาหนะเชิงพาณิชย์ของคุณบนแผนที่แบบเรียลไทม์ พูดคุยกับคนขับของคุณได้ตลอดเวลาผ่านเบราว์เซอร์, แอปมือถือ BlackVue, โปรแกรมดูภาพบน Mac หรือ Windows",
	"Company with large_": "บริษัทที่มีกลุ่มยานพาหนะขนาดใหญ่",
	"With BlackVue Fleet_2": "ด้วย BlackVue Fleet Tracking (การติดตามกลุ่มยานพาหนะของ BlackVue) คุณสามารถติดตามยานพาหนะได้ถึง 999 คันได้แบบเรียลไทม์ผ่านทางเบราว์เซอร์, แอปมือถือ BlackVue, โปรแกรมดูภาพบน Mac หรือ Windows",
	Subscribed: Subscribed$1,
	"The video was_": "วิดีโอถูกอัปโหลดแล้ว",
	Geofence: Geofence$1,
	"500: Internal server error": "500: ข้อผิดพลาดของเซิร์ฟเวอร์ภายใน",
	"404: Page not found": "404: ไม่พบหน้า",
	"Check the web address_": "ตรวจสอบที่อยู่เว็บไซต์หรือกลับไปที่โฮมเพจของ BlackVue Cloud",
	"home page": "Home page",
	"There isn’t an_": "ไม่มีบัญชีที่เชื่อมโยงกับที่อยู่อีเมลนี้",
	"You can now_password": "ตอนนี้คุณสามารถล็อกอินด้วยรหัสผ่านใหม่ของคุณได้",
	"Are you sure_remove admin2": "คุณแน่ใจหรือว่าต้องการลบผู้ดูแลระบบอย่างถาวร",
	"Admin deleted": "ผู้ดูแลระบบถูกลบแล้ว",
	"Members deleted": "สมาชิกถูกลบแล้ว",
	"Are you sure_groupName": "คุณแน่ใจหรือว่าต้องการลบกลุ่ม {{a}}",
	"Requires latest firmware": "ต้องใช้เฟิร์มแวร์ล่าสุด",
	"Selected file(s) moved_": "ย้ายไฟล์ที่เลือกสำเร็จแล้ว",
	"Are you sure_remove driver2": "แน่ใจหรือว่าต้องการลบคนขับ {{a}} ({{b}}) ออกจากกลุ่มนี้",
	"Invite sent": "ส่งคำเชิญแล้ว",
	"Safe driving": "การขับขี่อย่างปลอดภัย",
	"Reckless driving": "การขับขี่อย่างประมาท",
	"Inattentive driving": "การขับขี่อย่างเหม่อลอย",
	"Driving events trend": "แนวโน้มเหตุการณ์การขับขี่",
	"Driving details": "รายละเอียดการขับขี่",
	Driving: Driving$1,
	Idling: Idling$1,
	Distance: Distance$1,
	"Parking sessions": "ช่วงเวลาการจอดรถ",
	"Parked time": "Parked time",
	"Idle stops": "จำนวนครั้งที่หยุดทำงาน",
	"Idle time": "เวลาที่หยุดทำงาน",
	"Impact events": "Impact Events",
	Parked: Parked$1,
	Speed: Speed$1,
	"Overspeeding alerts": "การแจ้งเตือนความเร็วเกิน",
	Highest_2: Highest_2$1,
	Average: Average$1,
	Geofences: Geofences$1,
	"Entries into a_": "เข้าสู่โซน",
	"Exits from a_": "ออกจากโซน",
	"No data": "ไม่มีข้อมูล",
	"Hard acceleration": "การเร่งความเร็ว",
	"Hard braking": "การเบรกที่รุนแรง",
	"Hard cornering": "การเลี้ยวหักศอก",
	"The number within the brackets_": "ตัวเลขในวงเล็บระบุจำนวนเหตุการณ์โดยเฉลี่ยต่อชั่วโมงการขับขี่ หากคุณขับขี่น้อยกว่าหนึ่งชั่วโมงต่อวัน จำนวนเหตุการณ์ทั้งหมดจะแสดงขึ้น",
	"Did you insert_": "คุณได้ใส่ซิมการ์ดหรือไม่",
	"Click here for_": "<a>คลิกที่นี่</a>เพื่อดูคำแนะนำโดยละเอียดเพิ่มเติม",
	"Back up all_": "<b>สำรองข้อมูลของบันทึกที่สำคัญทั้งหมดก่อนที่จะบันทึกการตั้งค่าเหล่านี้</b><br/>เมื่อคุณบันทึกการตั้งค่าแล้ว การ์ด microSD จะเริ่มต้นการทำงานใหม่และบันทึกทั้งหมดจะถูกลบออกเพื่อให้แน่ใจว่าการทำงานมีเสถียรภาพ",
	"Not connected to_": "ไม่ได้เชื่อมต่อกับคลาวด์ ฟังก์ชันบางอย่างถูกปิดใช้งานชั่วคราว",
	"GPS Location recording off": "การบันทึกตำแหน่ง GPS ถูกปิดอยู่",
	"n Videos deleted": "วิดีโอ {{count}} รายการถูกลบ",
	Move: Move$1,
	"Driver Monitoring System (DMS) will_": "ระบบการตรวจสอบคนขับ (DMS) จะพร้อมให้บริการเร็ว ๆ นี้",
	"An error occured while_": "เกิดข้อผิดพลาดขณะพยายามเปลี่ยนจำนวนกล้อง ลองอีกครั้ง",
	"Reached the limit_": "ครบขีดจำกัด: {{a}}",
	"An invitation was_": "คำเชิญถูกส่งไปยังที่อยู่อีเมลนี้แล้ว",
	"To use the_": "หากต้องการใช้คุณสมบัติคลาวด์ โปรดใส่ซิมการ์ดของคุณ",
	"Last updated": "อัปเดตล่าสุด {{date}}",
	"Try changing your date": "ลองเปลี่ยนวันที่ของคุณ",
	"No event data_": "ไม่มีการเก็บข้อมูลเหตุการณ์สำหรับเวลาที่เลือก",
	"Please select another_": "โปรดเลือกวันอื่นหรือเดือนอื่นเพื่อดูรายงานทั้งหมด",
	"more than 6_": "ต้องมีอักขระมากกว่า 6 ตัว",
	"Sign up free": "สมัครใช้งานฟรี",
	"Cloud storage warning": "คำเตือนพื้นที่จัดเก็บข้อมูลบนคลาวด์",
	"Cloud Storage Full": "พื้นที่จัดเก็บข้อมูลบนคลาวด์เต็ม",
	"Cloud storage usage_100": "การใช้งานพื้นที่จัดเก็บข้อมูลบนคลาวด์อยู่ที่ 100% โปรดล้างพื้นที่จัดเก็บข้อมูลบางส่วนเพื่อให้สามารถใช้การอัปโหลดเหตุการณ์สดได้",
	"Cloud storage usage_": "การใช้งานพื้นที่จัดเก็บข้อมูลบนคลาวด์อยู่ที่ <b>({{a}}%)</b> \nโปรดจัดการพื้นที่จัดเก็บข้อมูลบนคลาวด์ของคุณ\nบริการอัปโหลดเหตุการณ์สดจะไม่สามารถใช้งานได้หากพื้นที่จัดเก็บข้อมูลบนคลาวด์เต็ม",
	"Are you sure_delete_zone": "คุณแน่ใจว่าต้องการลบ หรือไม่",
	"Search Name or email": "ค้นหาชื่อหรืออีเมล",
	"Search group name": "ค้นหาชื่อกลุ่ม",
	"Please note that_": "โปรดทราบว่าการบันทึกวิดีโอจะหยุดชั่วคราวเป็นเวลาไม่กี่วินาทีเพื่อปรับใช้การตั้งค่าใหม่",
	"Currently connected Hotspot": "ฮอตสปอตที่เชื่อมต่ออยู่ในปัจจุบัน",
	"Enhanced night vision": "ภาพเวลากลางคืนปรับปรุงใหม่",
	"To access the_": "ในการเข้าถึงกล้อง โปรดอัพเดทแผนการสมัครสมาชิกของคุณ",
	"Restarting the Blackvue_": "รีสตาร์ท BlackVue เพื่อปรับใช้การตั้งค่า",
	"Hard acceleration event_": "เหตุการณ์การเร่งความเร็วอย่างหนักหน่วงจะเกิดขึ้นเมื่ออัตราการเร่งความเร็วต่อวินาทีสูงกว่า {{kmh}} กม./ชม. ({{mph}} ไมล์ต่อชั่วโมง)",
	"Hard braking event_": "เหตุการณ์การเบรกอย่างหนักหน่วงจะเกิดขึ้นเมื่ออัตราการลดความเร็วต่อ\nวินาทีสูงกว่า {{kmh}} กม./ชม. ({{mph}} ไมล์ต่อชั่วโมง)",
	"Hard cornering event_": "เหตุการณ์การเข้าโค้งอย่างหนักหน่วงเกิดขึ้นเมื่อมีการหมุนมากกว่า 60 องศาภายใน 2 วินาทีของการขับขี่ด้วยความเร็วมากกว่า \n{{kmh}} กม./ชม. ({{mph}} ไมล์ต่อชั่วโมง)",
	"Changes you made_": "การเปลี่ยนแปลงที่คุณทำอาจไม่ได้รับการบันทึก",
	"My location": "ตำแหน่งของฉัน",
	"Hotspot name (SSID)": "ชื่อฮอตสปอต (SSID)",
	Connected: Connected$1,
	"Camera will be rebooted_": "กล้องจะรีบูต คุณยังต้องการที่จะดำเนินการต่อหรือไม่",
	"Restarting the BlackVue_": "กำลังรีสตาร์ท BlackVue โปรดรอสักครู่",
	"Failed to reboot_": "รีบูตกล้องไม่สำเร็จ",
	"Bluetooth (Parking mode)": "BT (โหมดจอดรถ)",
	"Front and interior camera_": "การบันทึกกล้องหน้าและกล้องภายในร่วมกัน",
	"Interior camera stops_": "กล้องภายในจะหยุดการบันทึกภาพ 5 นาทีหลังจากเข้าสู่โหมดจอดรถ การบันทึกเริ่มต้นใหม่เมื่อเข้าสู่โหมดปกติ",
	Individual_: Individual_$1,
	"Driver detection": "การตรวจจับคนขับ",
	"During driving only": "ระหว่างการขับขี่เท่านั้น",
	Always: Always$1,
	"Driver detection box": "กล่องตรวจจับคนขับ",
	"DMS camera rotation": "การหมุนกล้อง DSM",
	Low: Low$1,
	Medium: Medium$1,
	High_2: High_2$1,
	"Reboot Camera": "รีบูตกล้อง",
	"Latest events": "เหตุการณ์ล่าสุด",
	"G-Sensor": "G-Sensor",
	"Playback speed": "ความเร็วในการเล่น",
	Flip: Flip$1,
	Previous: Previous$1,
	Next: Next$1,
	"Map type": "ประเภทแผนที่",
	"Zoom in": "ซูมเข้า",
	"Zoom out": "ซูมออก",
	"Move to Cloud": "ย้ายไปที่ Cloud",
	"Please recognize that_": "โปรดทราบว่าการบันทึกวิดีโอจะหยุดชั่วคราวเป็นเวลาไม่กี่วินาทีเพื่อปรับใช้การตั้งค่า",
	"6 characters with_": "6 ตัวอักขระที่มีการผสมตัวอักษร ตัวเลข และสัญลักษณ์",
	"Updating firmware": "การอัปเดตเฟิร์มแวร์",
	"Overspeed event occurs_": "เหตุการณ์ความเร็วเกินจะเกิดขึ้นเมื่อกล้องติดรถเตือนคนขับว่าความเร็วเกินขีดจำกัด คุณสามารถเปลี่ยนแปลงได้ใน เฟิร์มแวร์ > ระบบ > โวลุ่ม",
	"Enter group name": "ป้อนชื่อกลุ่ม",
	"Live view failed": "Live View ไม่สำเร็จ",
	"Parking mode enter_": "การเข้า/ออกโหมดจอดรถ",
	"Cloud connectivity": "การเชื่อมต่อ Cloud",
	Expand: Expand$1,
	Collapse: Collapse$1,
	"all day": "ทั้งวัน",
	"Driving style": "สไตล์การขับขี่",
	"Driving impact": "ผลกระทบในการขับขี่",
	More: More$1,
	"No cameras to_": "ไม่มีกล้องที่จะเพิ่ม",
	"You have added_": "คุณได้เพิ่มกล้องที่มีอยู่ทั้งหมดแล้ว",
	Multi: Multi$1,
	"Report video": "รายงานวิดีโอ",
	"Sexually explicit content": "เนื้อหาเกี่ยวกับเรื่องเพศ",
	"Graphic violence": "ความรุนแรงหรือสิ่งน่ารังเกียจ",
	"Hateful speech": "ความเกลียดชังหรือการดูถูก",
	"Harassment or bullying": "การล่วงละเมิดหรือการกลั่นแกล้ง",
	"Spam or advertisement": "สแปมหรือโฆษณา",
	"Infringement of my_": "ละเมิดสิทธิ์ของฉัน",
	"Other reason": "ฯลฯ",
	"Reason for reporting": "เหตุผลสำหรับการรายงาน",
	"Reported videos will_": "วิดีโอที่รายงานจะถูกตรวจสอบภายใน 72 ชั่วโมง วิดีโอจะไม่แสดงบนแผนที่เหตุการณ์จนกว่าจะได้รับการยืนยันว่าวิดีโอเหมาะสำหรับการโพสต์บนแผนที่เหตุการณ์",
	"Touch sensor": "เซ็นเซอร์สัมผัส",
	"Motion and impact detection": "การตรวจจับการเคลื่อนไหวและการกระแทก",
	"Settings have been changed": "เปลี่ยนการตั้งค่าแล้ว",
	"Start event recording (beep)": "เริ่มการบันทึกเหตุการณ์ (บี๊บ)",
	"Scheduled reboots": "การรีบูตตามตารางเวลา",
	Safe: Safe$1,
	Reckless: Reckless$1,
	Inattentive: Inattentive$1,
	"Highest(Extreme)": "สูงสุด (สูงสุดยอด)",
	"Public cameras": "กล้องสาธารณะ",
	List: List$1,
	Usage: Usage$1,
	"Video playbacks and downloads": "การเล่นและการดาวน์โหลดวิดีโอ",
	"of 100 times": "จาก 100 ครั้ง",
	"of 10 minutes": "จาก 10 นาที",
	Profile: Profile$1,
	"Search geofences": "ค้นหาขอบเขตเสมือน",
	"Export CSV": "ส่งออก CSV",
	"Exit fullscreen": "ออกจากโหมดเต็มหน้าจอ",
	Fullscreen: Fullscreen$1,
	Upgrade: Upgrade$1,
	"Email address": "ที่อยู่อีเมล",
	"of Unlimited": "จากไม่จำกัดจำนวน",
	"No notifications yet": "ไม่มีการแจ้งเตือนใน 7 วันที่ผ่านมา",
	"No videos yet": "ยังไม่มีวิดีโอ",
	Management: Management$1,
	Day: Day$1,
	Month: Month$1,
	"Welcome to the BlackVue_": "ยินดีต้อนรับสู่ BlackVue Cloud Viewer",
	"You can access BlackVue_": "คุณสามารถเข้าถึง BlackVue Cloud ผ่านเว็บได้จากทุกที่ทุกเวลา!",
	"Start tour": "เริ่มการทัวร์",
	"Map view": "มุมมองแผนที่",
	"Check the current_": "ตรวจสอบตำแหน่ง GPS ปัจจุบันและความเร็วกล้องของคุณรวมทั้งกล้องสาธารณะ",
	"Camera’s features": "คุณสมบัติของกล้อง",
	"Take a look_": "ดูคุณสมบัติต่างๆ ที่เกี่ยวข้องกับระบบคลาวด์ของกล้อง BlackVue",
	"Visualize your vehicle’s_": "แสดงภาพเส้นทางการขับขี่ของยานพาหนะได้ตลอดระยะเวลาที่ผ่านไป",
	"Smart plan_": "แผนสมาร์ท : 90 วัน แผนฟลีท : 90 วัน",
	"Create geofences and2_": "สร้างขอบเขตเสมือนและรับการแจ้งเตือนแบบเรียลไทม์",
	"Got it": "เข้าใจแล้ว",
	"Manage Fleet members": "จัดการสมาชิกฟลีท",
	"Invite fleet members_": "เชิญสมาชิกฟลีทและมอบหมายสมาชิกเข้าในกลุ่ม",
	"The moment the_": "ทันทีที่กล้องตรวจพบการกระแทก การแจ้งเตือนจะแสดงขึ้นที่นี่",
	"Geofence Setup (Web)_": "การตั้งค่าขอบเขตเสมือน (เว็บ/เดสก์ท็อป) และการเตือน",
	"Original file play_": "การเล่นไฟล์ต้นฉบับจะสามารถทำได้สำหรับการดาวน์โหลดเท่านั้น",
	"To get most_": "เพื่อให้ได้ประโยชน์สูงสุดจาก BlackVue Cloud Viewer กล้องของคุณต้องเชื่อมต่อกับระบบคลาวด์ ดาวน์โหลดแอปพลิเคชัน BlackVue และสัมผัสประสบการณ์การจับคู่แบบไร้รอยต่อ ตั้งแต่การเพิ่มกล้องไปจนถึงการเชื่อมต่อกับระบบคลาวด์ทั้งหมดพร้อมกัน!",
	"You haven’t driven_Today": "คุณยังไม่ได้ขับขี่รถของคุณในวันนี้ ลองขับขี่รถของคุณพร้อมกับ BlackVue เพื่อตรวจสอบรายงานการขับขี่ของคุณ",
	"You haven’t driven_Month": "คุณยังไม่ได้ขับขี่รถของคุณในเดือนนี้ ลองขับขี่รถของคุณพร้อมกับ BlackVue เพื่อตรวจสอบรายงานการขับขี่ของคุณ",
	"Fleet Plan only_": "ใช้ได้เฉพาะแผนฟลีทเท่านั้น",
	"Overwrite locked event2_": "เขียนทับไฟล์เหตุการณ์ที่ถูกล็อกเมื่อพื้นที่จัดเก็บข้อมูลเต็ม",
	"DMS’s New firmware_": "เฟิร์มแวร์ใหม่ของ DMS พร้อมใช้งานแล้ว",
	"Highest speed_report": "<b>ความเร็วสูงสุด<b/>\nค่าที่มากที่สุดจากข้อมูลความเร็วที่เก็บบันทึกไว้ ซึ่งเก็บบันทึกในหน่วยเมตร แล้วแปลงเป็นหน่วย กม./ชม. และไมล์ต่อชม.\n\nความเร็วเฉลี่ย(ระยะทาง/จำนวนชั่วโมงที่ขับขี่) *3600 ความเร็วเฉลี่ย ตัวอย่าง (2622 / 1208 ) *3600 = 7814.907\nกม./ชม. : จำนวนเต็มเท่านั้น จุดฐานของไมล์ต่อชม. \nจะต้องไม่เกิน 2 หลักภายใต้จำนวนเต็ม",
	"Choose a cloud_": "เลือกวิธีการเชื่อมต่อกับคลาวด์",
	"You need an_": "คุณต้องเชื่อมต่ออินเทอร์เน็ตเพื่อเชื่อมต่อกับระบบคลาวด์ เลือกอุปกรณ์ที่คุณใช้เพื่อเชื่อมต่อกับระบบคลาวด์",
	"BlackVue SIM card": "ซิมการ์ด BlackVue",
	"Support model_": "รุ่นที่รองรับ : DR750X-2CH LTE Plus (NA)",
	"3rd party SIM_": "ซิมการ์ดของบุคคลที่สาม",
	"Support model_SIM": "รุ่นที่รองรับ : DR750X-2CH LTE Plus, DR750-2CH LTE, CM100 LTE",
	"Wi-fi hotspot": "ฮอตสปอต Wi-fi",
	"Support model_Wifi": "รุ่นที่รองรับ : BlackVue ทุกรุ่น",
	"How to connect_": "วิธีเชื่อมต่อกับระบบคลาวด์",
	"Download BlackVue application": "ดาวน์โหลดแอปพลิเคชัน BlackVue",
	"*If you are_": "*หากคุณจะใช้ซิมการ์ด BlackVue สำหรับการเชื่อมต่อกับระบบคลาวด์ ให้ไปที่ {{a}} {{b}}",
	"Place your phone_": "วางโทรศัพท์ของคุณในระยะ BT ของกล้อง เริ่มการจับคู่แบบไร้รอยต่อของคุณโดยใช้ {{a}}",
	"Back to camera_": "กลับไปยังรายการกล้อง",
	"Upgrade for more_": "อัปเกรดเพื่อรับคุณสมบัติเพิ่มเติม!",
	"Upgrading the cloud_": "การอัปเกรดแผนระบบคลาวด์จะช่วยให้คุณสามารถใช้คุณสมบัติได้มากขึ้นและจัดการกล้องได้หลายตัว คุณต้องการอัปเกรดแผนระบบคลาวด์ของคุณหรือไม่",
	"Explore cloud plans": "สำรวจแผนระบบคลาวด์",
	Later: Later$1,
	"Successfully subscribed": "สมัครสมาชิกสำเร็จแล้ว!",
	"1GB data plan": "แผนข้อมูล 1GB",
	"First month free_": "ฟรีเดือนแรก <a>จากนั้นจะมีการเรียกเก็บเงิน 10.99 ดอลลาร์สหรัฐ/เดือน</a>",
	"Next billing date": "วันที่เรียกเก็บเงินถัดไป",
	"Once SIM card_": "เมื่อใส่ซิมการ์ดในกล้องแล้ว คุณสามารถเริ่มใช้คุณสมบัติ BlackVue Cloud ได้ทันที",
	"Go to SIM_": "ไปที่การจัดการซิม",
	"Manage your BlackVue_": "จัดการซิมการ์ด BlackVue ของคุณได้ที่นี่!",
	"Recommended for BlackVue_": "แนะนำสำหรับเจ้าของซิม BlackVue",
	"Connect to cloud": "เชื่อมต่อกับระบบคลาวด์",
	"Enter BlackVue SIM_": "ป้อนหมายเลข ICCID ของซิม BlackVue",
	"ICCID number is_": "หมายเลข ICCID จะพิมพ์อยู่บนแพ็คเกจซิมการ์ด โปรดป้อนหมายเลข ICCID 14 หลักสุดท้าย",
	ICCID: ICCID$1,
	"SIM information": "ข้อมูลซิม",
	"Start your free_": "เริ่มการทดลองใช้ฟรีของคุณตอนนี้",
	"SIM card activate_": "วันที่เปิดใช้งานซิมการ์ด",
	"Based on the_": "อิงตามวันที่ใส่ซิมการ์ดในกล้องและเปิดใช้งานเมื่อมีการจ่ายไฟ",
	"Upgrade to 3GB_": "อัปเกรดเป็นแผน 3GB/5GB ได้ทุกเมื่อ",
	"Cancel your plan_": "ยกเลิกแผนของคุณได้ตลอดเวลา",
	"No Commitment": "ไม่มีภาระผูกพัน",
	"Precautions for using_": "ข้อควรระวังในการใช้บริการ",
	"After 1GB is_": "หลังจากใช้หมด 1GB แล้ว จะไม่สามารถใช้อินเทอร์เน็ตเพิ่มเติมได้",
	"If you have_": "หากคุณใส่ซิมการ์ดลงในกล้องและเริ่มใช้งานแล้ว ระยะเวลาทดลองใช้งานฟรีจะเริ่มนับตั้งแต่ที่คุณเริ่มต้นใช้งาน",
	"This content is_": "เนื้อหานี้ระบุอยู่ในแพ็คเกจของซิม เราไม่รองรับการชดเชยสำหรับระยะเวลาใช้งานฟรีใดๆ ที่ไม่ได้ระบุไว้",
	"If you have_2": "หากคุณมีคำถามเพิ่มเติม โปรดติดต่อ <a>ทีม CS</a>",
	"When OFF, connecting_": "เมื่อปิดเครื่อง การเชื่อมต่อกล้องด้วยการจับคู่แบบไร้รอยต่อจะถูกปิดใช้งาน",
	"1 month free": "ฟรี 1 เดือน",
	"No commitment. Cancel_": "ไม่มีภาระผูกพัน ยกเลิกได้ตลอดเวลา",
	"The video has been reported_": "วิดีโอได้รับการรายงานเรียบร้อยแล้ว",
	"Free for 1 month": "ฟรีเป็นเวลา 1 เดือน",
	"Start your free_2": "เริ่มการทดลองใช้ฟรีของคุณ",
	"1GB free for_": "ฟรี 1GB เป็นเวลา {{a}} วัน",
	"1GB data": "ข้อมูล 1GB",
	"1 month free_2": "การทดลองใช้ฟรี 1 เดือนจะเริ่มตั้งแต่ {{a}} โดยรวมถึงข้อมูล 1GB สำหรับซิมการ์ด Blackvue",
	"Your next billing_": "วันที่เรียกเก็บเงินครั้งต่อไปของคุณคือ {{a}}",
	"SIM card": "ซิมการ์ด",
	"SIM guide": "คำแนะนำเกี่ยวกับซิม",
	"SIM card list": "รายการซิมการ์ด",
	"Add SIM card": "เพิ่มซิมการ์ด",
	"No SIM card_": "ยังไม่มีซิมการ์ด",
	"Search SIM ICCID_": "ค้นหาชื่อหรือ ICCID ของซิม",
	"Cloud disconnected. Failed_": "ยกเลิกการเชื่อมต่อคลาวด์แล้ว ไม่สามารถเล่นวิดีโอได้",
	"This sim card_": "ซิมการ์ดนี้ลงทะเบียนในบัญชีอื่นแล้ว",
	"Incorrect BlackVue SIM_": "ICCID ของ BlackVue ไม่ถูกต้อง",
	"My shared videos": "วิดีโอที่แชร์ของฉัน",
	"Number of events": "จำนวนเหตุการณ์",
	"Added to Event Map": "เพิ่มไปยังแผนที่เหตุการณ์แล้ว",
	"Successfully added video(s)_": "เพิ่มวิดีโอเพื่อแชร์ไปยังแผนที่เหตุการณ์สำเร็จแล้ว! หากคุณต้องการตรวจสอบสถานะและจัดการวิดีโอที่แชร์ ให้ไปที่ แผนที่เหตุการณ์ > วิดีโอที่แชร์ของฉัน",
	"Already added to_": "เพิ่มไปยังแผนที่เหตุการณ์แล้ว",
	"This video(s) is already added_": "เพิ่มวิดีโอนี้ไปยังแผนที่เหตุการณ์แล้ว! หากคุณต้องการตรวจสอบสถานะและจัดการวิดีโอที่แชร์ ให้ไปที่ แผนที่เหตุการณ์ > วิดีโอที่แชร์ของฉัน",
	"BlackVue’s firmware is up_": "เฟิร์มแวร์ของ BlackVue เป็นเวอร์ชันล่าสุด",
	"Service end": "สิ้นสุดการบริการ",
	Resubscribe: Resubscribe$1,
	"Sort ascending": "เรียงลำดับจากน้อยไปมาก",
	"Sort descending": "เรียงลำดับจากมากไปน้อย",
	plan: plan$1,
	USD: USD$1,
	"Are you sure_Cancel": "คุณแน่ใจหรือไม่ว่าต้องการยกเลิกการสมัครสมาชิกของคุณ โปรดรับทราบข้อมูลต่อไปนี้และยืนยันที่ด้านล่าง",
	"Your current SIM_": "การสมัครสมาชิกซิมการ์ดปัจจุบันของคุณจะสิ้นสุดในวันที่ {{a}} และจะไม่มีการเรียกเก็บเงินจากคุณอีกต่อไป",
	"After canceling your_": "หลังจากยกเลิกการสมัครสมาชิกซิมการ์ดแล้ว คุณจะสามารถใช้ข้อมูลซิมได้ต่อไปจนถึงวันที่สิ้นสุดการสมัครสมาชิก",
	"You can resubscribe_": "คุณสามารถสมัครสมาชิกใหม่ได้ภายในระยะเวลา 1 เดือนหลังจากการสมัครสมาชิกปัจจุบันของคุณสิ้นสุดลง หากคุณต้องการสมัครสมาชิกใหม่ โปรดคลิกปุ่ม 'สมัครสมาชิกใหม่' ในรายการซิมการ์ดก่อน {{a}} เพื่อสมัครสมาชิกใหม่",
	"Reason to cancel_": "เหตุผลในการยกเลิกการสมัครสมาชิก",
	"Found an alternative": "พบทางเลือกอื่น",
	"Too expensive": "แพงเกินไป",
	"Not required anymore": "ไม่ต้องการใช้งานอีกต่อไป",
	"Quality issue": "ปัญหาเรื่องคุณภาพ",
	etc_: etc_$1,
	"Please describe in_": "โปรดอธิบายโดยละเอียด",
	"SIM card cannot_": "ไม่สามารถลบซิมการ์ดได้เนื่องจากซิมการ์ดนี้อยู่ระหว่างการสมัครสมาชิก หากคุณต้องการลบซิมการ์ดนี้ โปรดยกเลิกการสมัครสมาชิกของคุณก่อน",
	"SIM card cannot_2": "ไม่สามารถลบซิมการ์ดได้เนื่องจากการสมัครสมาชิกสำหรับซิมการ์ดนี้ยังไม่สิ้นสุด โปรดลองอีกครั้งหลังจากการสมัครสมาชิกของคุณสิ้นสุดลง",
	"Are you sure_deleteSIM": "คุณแน่ใจหรือไม่ว่าต้องการลบซิมการ์ดนี้<br/>\n<b>คำเตือน: คุณไม่สามารถยกเลิกการดำเนินการนี้ได้ ข้อมูลซิมการ์ดทั้งหมดของคุณจะถูกลบทันที</b>",
	"ICCID number": "หมายเลข ICCID",
	"Activation date": "วันที่เปิดใช้งาน",
	"Current plan": "แผนปัจจุบัน",
	"Manage Plan": "จัดการแผน",
	"Next billing on": "การเรียกเก็บเงินครั้งต่อไปเมื่อ",
	"View Invoices": "ดูใบแจ้งหนี้",
	"Choose best plan_": "เลือกแผนที่ดีที่สุดสำหรับคุณ",
	"Plan summary": "สรุปแผน",
	"Ends on_": "สิ้นสุดเมื่อ {{a}}",
	"Start from_": "เริ่มตั้งแต่ {{a}}",
	"Your subscription will_": "การสมัครสมาชิกของคุณจะได้รับการอัปเกรดในวันที่ {{a}} เมื่อแผนปัจจุบันของคุณสิ้นสุดลง",
	"Resubscribe plan": "สมัครสมาชิกแผนใหม่",
	"Your subscription will2_": "การสมัครสมาชิกของคุณจะเริ่มในวันที่ {{a}} เมื่อแผนปัจจุบันของคุณสิ้นสุดลง",
	"Usage is estimated_": "การใช้งานถูกประมาณไว้เมื่อวันที่ {{a}}",
	"Days left_": "เหลืออีก {{a}} วัน",
	"Data usage cycle": "รอบการใช้งานข้อมูล",
	Available: Available$1,
	Used: Used$1,
	"Data used": "ข้อมูลที่ใช้ไป",
	"Subscribe to n_": "สมัครสมาชิกเพื่อใช้แผนข้อมูล {{a}} <b>ตั้งแต่ {{b}} จนถึง {{c}}</b> และใช้แผนข้อมูล {{d}} ตั้งแต่ {{e}}",
	"Will be charged_": "จะถูกเรียกเก็บเงินในวันที่ {{a}}",
	"Monthly usage": "การใช้งานรายเดือน",
	"You have fewer_": "คุณมีข้อมูลเหลือน้อยลงสำหรับเดือนนี้!",
	"Get more data": "รับข้อมูลเพิ่มเติม!",
	"This video cannot be shared": "ไม่สามารถแชร์วิดีโอนี้",
	"This is a video cannot be shared_": "ไม่สามารถแชร์วิดีโอนี้ได้เนื่องจากไม่พบข้อมูลการขับขี่ในเวลานั้น",
	Cancelled: Cancelled$1,
	Terminated: Terminated$1,
	"Edit name": "แก้ไขชื่อ",
	"Not connected to_2": "ไม่ได้เชื่อมต่อกับคลาวด์ ตรวจสอบว่ากล้องของคุณเปิดอยู่และเปิดใช้งานโมดูลการเชื่อมต่ออินเทอร์เน็ตแล้วหรือไม่",
	"Some functionality is disabled_": "ฟังก์ชันบางอย่างถูกปิดใช้งานเนื่องจากกล้องไม่ได้เชื่อมต่อกับระบบคลาวด์ เชื่อมต่อกับระบบคลาวด์ <a>ที่นี่</a>",
	"If you want to cancel_": "หากคุณต้องการยกเลิกแผน ให้คลิก<a>ยกเลิกการสมัครสมาชิก</a>",
	"Select plan": "เลือกแผน",
	"Event map collects_": "แผนที่เหตุการณ์รวบรวมและแสดงภาพข้อมูลเหตุการณ์ BlackVue เพื่อแสดงสถานการณ์ของถนนโดยรอบ",
	"Share your Live_": "แชร์ไฟล์อัปโหลดเหตุการณ์แบบเรียลไทม์ของคุณ คุณสามารถแชร์วิดีโอเหตุการณ์ของคุณกับผู้ใช้รายอื่น ๆ รอบตัวคุณได้",
	"You can check_": "คุณสามารถตรวจสอบวิดีโอเหตุการณ์ที่แชร์โดยผู้อื่น",
	"Service end_": "สิ้นสุดบริการ : {{a}}",
	"DMS camera recording_": "การบันทึกของกล้อง DMS ในโหมดจอดรถ",
	Sort: Sort$1,
	"Are you sure you want_": "คุณแน่ใจหรือไม่ว่าต้องการลบวิดีโอที่แชร์ออกจากแผนที่เหตุการณ์",
	"Remove shared video": "ลบวิดีโอที่แชร์",
	"Explore event map": "สำรวจแผนที่เหตุการณ์",
	"Event map": "แผนที่เหตุการณ์",
	"Explore the graphic_": "สำรวจสถิติกราฟิกของเหตุการณ์ BlackVue ที่เกิดขึ้นรอบตัวคุณ",
	"You can filter_": "คุณสามารถกรองและดูเหตุการณ์ใดที่คุณต้องการให้แสดงได้",
	"This video was removed by_": "วิดีโอนี้ได้รับการรายงานและถูกลบออกแล้วโดยผู้ดูแลระบบ",
	Bonus: Bonus$1,
	"Your subscription plan": "แผนการสมัครสมาชิกของคุณ",
	"Your free trial will_": "ระยะเวลาทดลองใช้ฟรีของคุณจะเริ่มตั้งแต่ {{a}}</br> <strong>จนถึง</strong> {{b}}",
	"Total after free trial": "รวมทั้งหมดหลังระยะเวลาทดลองใช้ฟรี",
	"This sim card is_": "ซิมการ์ดนี้ใช้งานไม่ได้อีกต่อไป",
	"Firmware is up_": "เฟิร์มแวร์นี้คือรุ่นล่าสุดแล้ว",
	"Keep in mind": "โปรดจำไว้ว่า",
	"Once 1GB of_": "เมื่อใช้ข้อมูล 1GB หมดแล้ว บริการจะไม่สามารถใช้งานได้อีกจนกว่าจะถึงวันที่รีเซ็ตข้อมูลครั้งถัดไป [หรือหลังจากที่คุณอัปเกรดแผนของคุณเป็นระดับที่สูงกว่า]",
	"After the SIM_": "หลังจากใส่ซิมการ์ดลงในกล้องแล้ว ระยะเวลาทดลองใช้งานฟรีจะเริ่มต้นขึ้นเมื่อคุณเริ่มใช้ข้อมูล",
	"If you have_questions": "หากคุณมีคำถามใดๆ โปรดติดต่อ<a>ฝ่ายสนับสนุนลูกค้า</a>ของเรา",
	"Data reset date": "วันที่รีเซ็ตข้อมูล",
	"To use SIM card_": "หากต้องการใช้ซิมการ์ด โปรดติดต่อ <a>ทีม CS</a> ของ BlackVue",
	"Go to Subscription": "ไปที่การสมัครสมาชิก",
	"An error occurred_subscription": "เกิดข้อผิดพลาดขณะสมัครสมาชิกแผนที่เลือก",
	"Please try again": "โปรดลองอีกครั้ง",
	"Failed to subscribe": "สมัครสมาชิกไม่สำเร็จ",
	"Go to Pricing": "ไปที่การกำหนดราคา",
	"SIM cards will_": "ซิมการ์ดจะปรากฏขึ้นที่นี่เมื่อพร้อมใช้งาน",
	"1GB for 1_": "1GB เป็นเวลา 1 เดือน",
	"Pricing Data": "ข้อมูลการกำหนดราคา",
	"If you would like to check_": "หากคุณต้องการตรวจสอบสถานะและจัดการวิดีโอที่แชร์ ให้ไปที่ แผนที่เหตุการณ์ > วิดีโอที่แชร์ของฉัน",
	"Connect to Cloud": "เชื่อมต่อกับระบบคลาวด์",
	"Completed!": "เสร็จสมบูรณ์",
	"Back to App": "กลับไปที่แอป",
	"iOS in-app purchase": "การซื้อในแอป iOS",
	"Android in-app_": "การซื้อในแอป Android",
	"bonus n days": "โบนัส {{a}} วัน",
	"Want to contribute your_": "อนุญาตการแชร์ไฟล์อัปโหลดเหตุการณ์อัตโนมัติไปยังแผนที่เหตุการณ์โดยอัตโนมัติ หรือไม่",
	"With event map_": "คุณสามารถแชร์ไฟล์อัปโหลดเหตุการณ์อัตโนมัติให้กับผู้ขับขี่ที่อยู่ใกล้เคียงผ่านแผนที่เหตุการณ์",
	"You can edit_3": "คุณสามารถแก้ไขการตั้งค่าการแชร์ไฟล์อัปโหลดเหตุการณ์อัตโนมัติไปยังแผนที่เหตุการณ์โดยอัตโนมัติได้ตลอดเวลาโดยไปที่ BLACKVUE CLOUD > การตั้งค่ากล้อง > การตั้งค่าความเป็นส่วนตัว",
	"If you want to remove videos_": "เนื่องจากวิดีโอส่วนตัวอาจถูกส่งไปด้วย คุณควรระมัดระวังเป็นพิเศษในการตัดสินใจว่าควรแชร์ข้อมูลใด",
	"Total events": "เหตุการณ์ทั้งหมด",
	"Automatically add Live Event_": "แชร์ไฟล์อัปโหลดเหตุการณ์อัตโนมัติไปยังแผนที่เหตุการณ์โดยอัตโนมัติ",
	"This camera is publicly_": "กล้องนี้เปิดตำแหน่งแบบสาธารณะเท่านั้น",
	incomplete_zip: incomplete_zip$1,
	"Live Event Upload_": "การอัปโหลดเหตุการณ์แบบเรียลไทม์ (ระยะเวลาการจัดเก็บ: 7 วัน)\nต้องใช้เฟิร์มแวร์ล่าสุด",
	"Thank you for_2": "ขอขอบคุณที่อดทนรอ",
	"Start Web viewer": "เริ่มโปรแกรมดูผ่านเว็บ",
	"Are you sure_remove driver": "คุณแน่ใจหรือไม่ว่าต้องการลบผู้ขับขี่อย่างถาวร",
	"An error occurred_sim": "เกิดข้อผิดพลาดขณะพยายามสมัครสมาชิก",
	"Click the ADD SIM": "คลิกปุ่ม เพิ่มซิม บนหน้ารายการซิมการ์ด จากนั้นทำตามขั้นตอนการเพิ่มซิมอีกครั้ง",
	"Set download options": "ตั้งค่าตัวเลือกการดาวน์โหลด",
	"Information may be_": "Information may be transmitted with a delay and may not reflect actual balances.",
	"Swipe left and right to move": "ปัดไปทางซ้ายและขวาเพื่อย้าย",
	"Scheduled maintenance Notice": "ประกาศการบำรุงรักษาตามกำหนดเวลา",
	"Our Cloud server_": "เซิร์ฟเวอร์ระบบคลาวด์ของเราจะอยู่ภายใต้การบำรุงรักษาตามกำหนดเวลา",
	"During that time_": "ในช่วงเวลาดังกล่าว คุณสมบัติของระบบคลาวด์อาจไม่พร้อมใช้งาน",
	"Expected maintenance start_": "เวลาเริ่มต้นการบำรุงรักษาที่คาดไว้:",
	"Expected duration_": "ระยะเวลาที่คาดไว้: {{a}} ชั่วโมง",
	"For more information_": "สำหรับข้อมูลเพิ่มเติม โปรดดูที่ <a>[ประกาศการบำรุงรักษาเซิร์ฟเวอร์]</a>",
	"Do not remind_": "ไม่ต้องเตือนฉันอีก",
	"Cloud Server Maintenance": "การบำรุงรักษาเซิร์ฟเวอร์ระบบคลาวด์",
	"BlackVue Cloud Service_": "บริการ BlackVue Cloud ไม่สามารถใช้งานได้ชั่วคราว",
	"We are currently_": "เรากำลังดำเนินการบำรุงรักษา",
	"We apologize for_": "เราต้องขออภัยในความไม่สะดวก.",
	"Driver Monitoring System (DMS)": "ระบบเฝ้าตรวจสอบผู้ขับขี่ (DMS)",
	"Distracted occurs_": "เกิดขึ้นเมื่อหัวของคนขับหันห่างจากด้านหน้ามากกว่า 50 องศา",
	"Hand distraction event occurs_": "เกิดขึ้นเมื่อมือของคนขับถูกตรวจจับใกล้หัวเป็นเวลานาน (เช่นเมื่อสูบบุหรี่, ถือโทรศัพท์ ฯลฯ)",
	"Mask off event occurs_": "เกิดขึ้นเมื่อคนขับเข้าสู่ยานพาหนะโดยไม่สวมหน้ากากหรือเมื่อคนขับถอนหน้ากากออก",
	"DMS setting": "การตั้งค่า DMS",
	"The DMS system has_": "DMS รวมกล่องตรวจจับใบหน้าสำหรับสถานะ \"ตรวจพบ\", \"ไม่ตรวจพบ\", \"ทำให้สะดุด\", \"ง่วงนอน\", \"ถอนหน้ากาก\" และกล่องตรวจจับการเคลื่อนไหวสำหรับสถานะ \"การทำให้สะดุดด้วยมือ",
	"DMS detection": "การตรวจจับ DMS",
	"There are detection criteria for_": "มีเกณฑ์การตรวจจับสำหรับแต่ละเหตุการณ์ โปรดอ้างอิงไปที่คู่มือด้านล่างนี้",
	"DMS camera recording_onoff": "เปิด: กล้อง DMS จะบันทึกในโหมดจอดรถ ตามที่มีพลังงานอยู่ <br/> ปิด: กล้อง DMS จะปิดตัวเองเมื่อเข้าสู่โหมดจอดรถ",
	"LED lighting for each event_": "LED บนกล้องตรวจสอบพฤติกรรมของคนขับจะสัญญาณให้ทราบทุกเหตุการณ์การตรวจจับ (การสะดุดใจ การงีบหลับ ฯลฯ)",
	"Drowsy and Distracted each have_": "เหตุการณ์การง่วงนอนและการไขว้เขวจะมีสถานะความไวอยู่สามระดับ โปรดดูอินเทอร์เฟซแสดงคำแนะนำที่ด้านล่าง",
	"DMS event detection sensitivity": "ความไวในการตรวจจับเหตุการณ์ DMS",
	"Only drowsy and distracted include_": "เฉพาะเหตุการณ์การง่วงนอนและการไขว้เขวเท่านั้นที่มีการตั้งค่าความไว นอกจากนี้ ความไวที่ตั้งค่าไว้ยังสามารถนำไปปรับใช้กับสองเหตุการณ์ด้วยการตั้งค่าครั้งเดียว",
	"When driver’s eyes close_": "เกิดขึ้นเมื่อคนขับปิดตาทั้งสองข้างในระหว่างขับเกิน 1 วินาทีหรือหายใจเบาๆ เกิน 2 วินาที\n",
	"n digit": "{{a}} หลักไปที่",
	"You are subscribed_free_Smart": "คุณสมัครสมาชิกแผนสมาร์ทของ BlackVue Cloud",
	"Wi-Fi auto turn on": "เปิด Wi-Fi อัตโนมัติ",
	"Video on a map": "Video on a map",
	"This feature is only_vom": "This feature is only available to users with a Fleet Plan subscription.<br/>Please subscribe to a plan to unlock this feature.",
	"Total n days_": "ประสบการณ์ฟรี {{a}} วัน",
	"Every events of DMC200_": "ฟีเจอร์ตรวจจับ DMS มีผลเฉพาะในโหมดปกติเท่านั้น หากเปิดในโหมดจอดรถ กล้อง DMS จะบันทึกวิดีโอเท่านั้น",
	"An undetected event occurs_": "เกิดขึ้นเมื่อคนขับไม่ถูกตรวจจับหน้ากล้องเป็นเวลา 1 นาที",
	"A detected event occurs_": "A detected Event occurs when the driver is gazing in front since the power is set in the beginning.",
	"Drowsy sensitivity_": "High : When the driver closes their eyes for more than 1 second, it is considered drowsy driving.<br/><br/>Medium : When the driver closes their eyes for more than 1.5 second, it is considered drowsy driving.<br/><br/>Low : When the driver closes their eyes for more than 2 second, it is considered drowsy driving.",
	"Distracted sensitivity_": "High : If the angle of the head is more than 50 degrees away from the front for 3 seconds, it is detected as Distracted.<br/><br/>Medium : If the angle of the head is more than 50 degrees away from the front for 5 seconds, it is detected as Distracted.<br/><br/>Low : If the angle of the head is more than 50 degrees away from the front for 7 seconds, it is detected as Distracted.",
	"Start your subscription now": "เริ่มการสมัครสมาชิกของคุณตอนนี้",
	"Free trial period has expired": "หมดเวลาการทดลองใช้งานฟรีแล้ว",
	"1 data plan will start from_": "แผนข้อมูลจะเริ่มต้นจาก {{a}} โดยรวมถึงข้อมูล 1GB สำหรับซิมการ์ด Blackvue",
	"Allow the BlackVue_": "อนุญาตให้แอป BlackVue เข้าถึงข้อมูล GPS ของกล้องติดรถหรือไม่",
	"We use this_": "เราใช้ข้อมูลนี้เพื่อให้คุณสามารถติดตามตำแหน่งและความเร็วของรถยนต์ได้",
	"You can edit_": "คุณสามารถแก้ไขการตั้งค่าการเข้าถึง GPS ได้ตลอดเวลาโดยไปที่ BLACKVUE CLOUD> การตั้งค่ากล้อง > การตั้งค่าความเป็นส่วนตัว",
	"SIM cards": "ซิมการ์ด",
	"Subscription status": "สถานะการสมัครสมาชิก",
	Upgrades: Upgrades$1,
	"Upgrade plan": "อัปเกรดแผน",
	"Manage plan": "จัดการแผนการสมัครสมาชิก",
	"Next plan": "แผนการสมัครสมาชิกสำหรับเดือนหน้า",
	OR: OR$1,
	"Cancel subscription": "ยกเลิกการสมัครสมาชิก",
	Undo: Undo$1,
	Invoice: Invoice$1,
	"Daily usage": "การใช้ข้อมูลรายวัน",
	"Delete SIM": "SIM ลบ",
	"New card": "บัตรเครดิตใหม่",
	data: data$1,
	"SIM card data_": "สามารถยกเลิกการสมัครสมาชิกแผนข้อมูลซิมการ์ดได้ที่ <a>sim.blackvuecloud.com</a>",
	"Your plan from_": "แผนของคุณจากวันนี้จนถึงวันที่เรียกเก็บเงินครั้งถัดไป",
	"Applied during_": "ปรับใช้ระหว่าง {{a}} ~ {{b}}",
	"From today until_": "จากวันนี้จนถึงวันที่ชำระเงินครั้งถัดไป คุณสามารถสมัครสมาชิกได้เฉพาะแผนที่เหมือนกับเดือนก่อนหน้า การชำระเงินสำหรับช่วงเวลานี้จะถูกเรียกเก็บในวันนี้ <a>ค่าธรรมเนียมถูกคำนวณตามสัดส่วน</a>",
	"Choose your next plan": "เลือกแผนต่อไปของคุณ",
	"Applied from_": "ปรับใช้จาก {{a}}",
	"Payment for this_": "การชำระเงินสำหรับแผนนี้จะถูกเรียกเก็บเงินในวันที่ {{a}}",
	"By sharing your_2": "หากคุณแชร์การดูสด คุณสามารถเปิดให้ผู้ใช้รายอื่นมีประสบการณ์ที่น่าตื่นเต้นและสนุกสนานกับการขับขี่ไปทั่วโลก อย่างไรก็ตาม วิดีโอส่วนตัวอาจถูกเผยแพร่ไปด้วย คุณควรระมัดระวังเป็นพิเศษต่อการตัดสินใจว่าควรแชร์ข้อมูลใด",
	"Option camera recording_": "การบันทึกกล้องเสริมในโหมดบันทึกขณะจอดรถ",
	"Front and option camera_": "กล้องหน้าและกล้องเสริมบันทึกพร้อมกัน",
	"Option camera stops_": "กล้องเสริมหยุดบันทึก 5 นาที หลังจากเข้าสู่โหมดจอดรถ การบันทึกเริ่มต้นใหม่เมื่อเข้าสู่โหมดปกติ",
	"Option camera rotation": "การหมุนกล้องเสริม",
	"Option camera": "กล้องเสริม",
	"Option camera security": "การรักษาความปลอดภัยของกล้องเสริม",
	"Resubscribe until_": "สมัครสมาชิกใหม่ได้จนถึง: {{a}}",
	"Firmware Update Caution": "ข้อควรระวังในการอัปเดตเฟิร์มแวร์",
	"Please check below_": "โปรดตรวจสอบเงื่อนไขด้านล่างก่อนการอัปเดตเฟิร์มแวร์สำหรับ DMC200:",
	"The camera's Wi-Fi_": "ต้องเปิด Wi-Fi ของกล้อง",
	"Check if your_": "ตรวจสอบว่า WI-FI ของกล้องเปิดอยู่หรือไม่",
	"DO NOT disconnect_": "อย่าถอดสายโคแอกเซียลออกในระหว่างการอัปเดตเฟิร์มแวร์",
	"The camera and_": "กล้องและ DMC200 สามารถเสียหายได้",
	"DO NOT try_": "อย่าพยายามใช้ฟีเจอร์อื่นจนกว่าการรีบูตกล้องจะเสร็จสิ้น",
	"Expecially Reboot camera_": "โดยเฉพาะอย่างยิ่งการรีบูตกล้อง การฟอร์แมตการ์ด SD มีผลที่สำคัญต่อการทำลายอุปกรณ์ทั้งสองได้",
	"Update anyway": "อัปเดตเลย",
	"Invited on_2": "ถูกรับเชิญโดยคุณเมื่อ {{Invited Date}} เจ้าของ",
	"BlackVue’s New firmware_": "เฟิร์มแวร์ใหม่ของ BlackVue พร้อมใช้งานแล้ว",
	"valid thru_": "ใช้ได้จนถึง: {{a}}",
	"Billed monthly": "Billed monthly",
	"90 minutes Live_": "90 minutes Live View / Live Event Upload*",
	"or 2+ videos_": "or 2+ videos in full resolution*",
	"1GB Free Month_": "1GB Free Month Trial",
	"Cancel anytime": "Cancel anytime",
	"8+ hours Live_": "8+ hours Live View / Live Event Upload*",
	"or 12+ videos_": "or 12+ videos in full resolution*",
	"15+ hours Live_": "15+ hours Live View / Live Event Upload*",
	"or 23+ videos_": "or 23+ videos in full resolution*",
	Popular: Popular$1,
	"For Power Users": "For Power Users",
	"Estimates based on_": "* Estimates based on 4.5MB per minute of Live View, Quick View remote playback, or Live Event Upload file, and 190MB per full original resolution video download or playback (at 25Mbps bitrate). Daily idle Cloud connection data usage: 20MB per 24 hours. Data usage is shared among all types of services (Live View, Live Event Upload, etc.).",
	"Balanced Plan": "Balanced Plan",
	"For Light Cloud_": "For Light Cloud Use",
	"Front security (Normal mode)": "ความปลอดภัยหน้า (โหมดปกติ)",
	"Front security (Parking mode)": "ความปลอดภัยหน้า (โหมดจอดรถ)",
	"BT (Parking mode)": "BT (โหมดจอดรถ)",
	"LTE (Parking mode)": "LTE (โหมดจอดรถ)",
	"Wi-Fi (Parking mode)": "Wi-Fi (โหมดจอดรถ)",
	"Hand distraction": "การใช้มือทำกิจกรรมอื่น",
	Mask: Mask$1,
	"Second drowsy is_": "เหตุการณ์ง่วงนอนครั้งที่สองคือการง่วงนอนที่เกิดขึ้นภายใน 30 วินาทีหลังจากที่การง่วงนอนครั้งแรกได้เริ่มบันทึกการอัปโหลดเหตุการณ์สด",
	"Second drowsy alert": "การแจ้งเตือนเหตุการณ์ง่วงนอนครั้งที่สอง",
	"BlackVue sim card_": "ซิมการ์ด BlackVue สามารถใช้ได้ในแคนาดาและสหรัฐอเมริกาเท่านั้น",
	"Global support is coming soon.": "การสนับสนุนทั่วโลกกำลังจะพร้อมให้บริการเร็ว ๆ นี้",
	"The video file not found_": "ไม่พบไฟล์วิดีโอ หรือมีปัญหาขณะเล่น โปรดลองอีกครั้ง",
	"Start Voice Call": "เริ่มการโทรด้วยเสียง",
	"End Voice Call": "สิ้นสุดการโทรด้วยเสียง",
	"Voice call in use": "การโทรด้วยเสียงกำลังถูกใช้งาน",
	"Enable microphone access_": "เปิดใช้งานการเข้าถึงไมโครโฟนเพื่อใช้ฟังก์ชันการสื่อสารด้วยเสียงแบบสองทาง ไปที่หน้าการตั้งค่าเบราว์เซอร์เพื่อเข้าถึงไมโครโฟนของคุณ",
	"You may need to_": "คุณอาจต้องโหลดหน้านี้ใหม่เพื่อให้การตั้งค่าใหม่มีผล",
	"Eye status": "สถานะดวงตา",
	"Start time of live event upload video": "ช่วงเวลาเริ่มต้นของการอัปโหลดวิดีโอเหตุการณ์สด",
	"Left eye": "ตาซ้าย",
	"Right eye": "ตาขวา",
	"Drowsy is occured when the driver close his/her eyes more then 1sec": "เหตุการณ์ง่วงนอนเกิดขึ้นเมื่อผู้ขับขี่หลับตานานกว่า 1 วินาที",
	"Driver's Left eye movements with blinking count and period": "การเคลื่อนไหวของตาซ้ายของผู้ขับขี่ พร้อมทั้งจำนวนการกะพริบตา จำนวนช่วงเวลา และช่วงเวลา",
	"Driver's Right eye movements with blinking count and period": "การเคลื่อนไหวของตาขวาของผู้ขับขี่ พร้อมทั้งจำนวนการกะพริบตา และช่วงเวลา",
	"Drowsy big data of the driver and after a Drowsy event occurs": "ข้อมูลขนาดใหญ่สำหรับการกะพริบตาของผู้ขับขี่หลังจากเกิดเหตุการณ์ง่วงนอนขึ้น",
	"Sharing video to Event Map": "แชร์วิดีโอไปแผนที่เหตุการณ์",
	"Want to use a Voice call?": "ต้องการใช้การโทรด้วยเสียงหรือไม่",
	"To use a voice call_": "หากต้องการใช้การโทรด้วยเสียง ให้รีสตาร์ทมุมมองสด แล้วคลิก “อนุญาต”",
	"There is no_": "ยังไม่มีวิดีโอที่แชร์ \nรายการจะปรากฏขึ้นเมื่อมีการแชร์",
	"Microphone blocked": "ไมโครโฟนถูกบล็อก",
	"Want to center the map on your location?": "ต้องการตั้งศูนย์กลางของแผนที่ไว้ที่ตำแหน่งของคุณหรือไม่?",
	"To let the app access your location_": "หากต้องการให้แอปเข้าถึงตำแหน่งของคุณ ให้รีสตาร์ท Event Map แล้วเลือก \"ตกลง\" เมื่อได้รับแจ้ง",
	"Location access permission required": "ต้องได้รับอนุญาตการเข้าถึงตำแหน่ง",
	"Are you sure you want_2": "คุณแน่ใจหรือไม่ว่าต้องการลบวิดีโอนี้ออกจาก Event Map",
	"Two-way voice_2": "Two-way voice communication / Voice Call",
	"Not supported by DR650GW and DR650S_": "Not supported by DR650GW and DR650S",
	"DR650S Series only_": "DR650S Series only",
	"Cancel download?": "ยกเลิกการดาวน์โหลดหรือไม่",
	"Your download is not_": "การดาวน์โหลดของคุณยังไม่เสร็จสมบูรณ์ คุณต้องการยกเลิกการดาวน์โหลดหรือไม่",
	"Continue download": "ดาวน์โหลดต่อ",
	"Cancel download": "ยกเลิกการดาวน์โหลด",
	"Share your video to the Event Map?": "แชร์วิดีโอของคุณไปยังแผนที่เหตุการณ์หรือไม่",
	"Afterwards, according to the reaction to the video_": "หลังจากนั้น วิดีโออาจได้รับการจัดประเภทเป็นวิดีโอยอดนิยมและนำเสนอใน รายการวิดีโอยอดนิยม ตามปฏิกิริยาที่มีต่อวิดีโอ",
	"Add hashtags and a brief description to describe your video.": "เพิ่มแฮชแท็กและคำอธิบายสั้น ๆ เพื่ออธิบายวิดีโอของคุณ",
	"Would you like_": "คุณต้องการแชร์ไปที่แผนที่เหตุการณ์หรือไม่",
	"Successfully added video_": "เพิ่มวิดีโอเพื่อแชร์ไปยังแผนที่เหตุการณ์สำเร็จแล้ว!",
	"This video cannot_": "ไม่สามารถแชร์วิดีโอนี้ได้เนื่องจากไม่มีข้อมูลตำแหน่ง GPS เพื่อปักหมุดไว้บนแผนที่",
	"This video is_": "เพิ่มวิดีโอนี้ไปยังแผนที่เหตุการณ์แล้ว!",
	"Share to Event Map": "แชร์ไปยังแผนที่เหตุการณ์",
	"Describe in more_": "อธิบายรายละเอียดเพิ่มเติมเกี่ยวกับสิ่งที่เกิดขึ้นในวิดีโอของคุณ (ตัวเลือก)",
	"Description(optional)": "คำอธิบาย (ตัวเลือก)",
	"Recording mode": "โหมดการบันทึก",
	"Event triggers": "การทริกเกอร์เหตุการณ์",
	DMS: DMS$1,
	"Camera connectivity": "การเชื่อมต่อกล้อง",
	"If not allowed_2": "หากไม่ได้รับอนุญาต จะไม่สามารถเข้าถึงตำแหน่งและความเร็วของรถยนต์จากคลาวด์ได้",
	"Share Live View_": "แชร์วิดีโอของมุมมองสด",
	"Share Live View_2": "แชร์เสียงของมุมมองสด",
	"Share camera profile": "แชร์โปรไฟล์กล้อง",
	"Parking impact": "ผลกระทบในการจอดรถ",
	"Parking events": "Parking Events",
	"Audio recording": "การบันทึกเสียง",
	"Toggle the mic_": "สลับเปิด/ปิดไมค์",
	"Full HD_": "Full HD @ 60fps + Full HD @ 30fps",
	"Video quality": "คุณภาพวีดีโอ",
	Extreme: Extreme$1,
	"More video files": "ไฟล์บันทึกเพิ่มเติม",
	"Fewer video files": "ไฟล์บันทึกน้อยลง",
	"Camera rotation": "การหมุนกล้องหลัง",
	"Video overlay": "การซ้อนทับวิดีโอ",
	"Date & time display": "แสดงวันที่และเวลา",
	"Speed unit": "หน่วยความเร็ว",
	"Check the orientation_": "ตรวจสอบทิศทางของกล้องหน้าที่ติดตั้งในยานพาหนะ เลือกตัวเลือกการจับคู่เพื่อบันทึกวิดีโอในแนวตั้ง",
	"Rotate 180º": "หมุน 180º",
	"Rear camera rotation": "การหมุนกล้องหลัง",
	"Check the orientation_rear": "ตรวจสอบทิศทางของกล้องหลังที่ติดตั้งในยานพาหนะ เลือกตัวเลือกการจับคู่เพื่อบันทึกวิดีโอในแนวตั้ง",
	"Mirror View": "มุมมองกระจก",
	"Select Mirror View_": "เลือก มุมมองกระจก เพื่อพลิกสลับด้านวิดีโอในแนวนอน",
	"Check the orientation_interior": "ตรวจสอบทิศทางของกล้องเสริมที่ติดตั้งในยานพาหนะ เลือกตัวเลือกการจับคู่เพื่อบันทึกวิดีโอในแนวตั้ง",
	"Display off": "ปิดการแสดงผล",
	"Explore crowd-sourced Events_": "สำรวจเหตุการณ์ที่มาจากฝูงชน (ผลกระทบ การเบรกอย่างแรง ฯลฯ) บนแผนที่ ดูวิดีโอที่แชร์โดยชุมชน และมีส่วนร่วมในเหตุการณ์ของคุณเอง",
	OFF: OFF$1,
	"Reboots once-a-day_": "รีบู๊ตวันละครั้งตามเวลาที่กำหนดหากอยู่ในโหมดจอดรถเพื่อปรับปรุงความเสถียร",
	"Set time": "ตั้งเวลา",
	"FW language": "ภาษาเฟิร์มแวร์",
	"Rear security_2": "ความปลอดภัยหลัง",
	"Bluetooth (Parking mode)_2": "บลูทูธ (โหมดจอดรถ)",
	"Failed to save_2": "ไม่สามารถบันทึกการตั้งค่าการอัปโหลดเหตุการณ์สด",
	"Event file will_": "ไฟล์เหตุการณ์จะถูกบันทึกโดยอัตโนมัติในพื้นที่จัดเก็บข้อมูลการอัปโหลดเหตุการณ์สด",
	"An impact was_": "An Impact was detected during Parking Mode.",
	"When exiting Parking_": "เมื่อออกจากโหมดจอดรถ BlackVue ของคุณจะประกาศว่าตรวจพบแรงกระแทกขณะอยู่ในโหมดจอดรถหรือไม่ \n\n หมายเหตุ: \n แรงกระแทกสร้างวิดีโอเหตุการณ์ แรงกระแทกที่เกิดขึ้นภายใน 3 นาทีหลังจากออกจากโหมดจอดรถจะถูกละเว้น",
	"Protect event files": "ป้องกันไฟล์เหตุการณ์",
	"Turning on this_": "เปิดเพื่อป้องกันไฟล์เหตุการณ์ {{a}} รายการล่าสุดไม่ให้ถูกเขียนทับโดยไฟล์บันทึกปกติหรือไฟล์บันทึกขณะจอดรถ",
	"Impact Events in_": "Impact Events in Normal(E) and Parking Mode(I)",
	"Manual Events_": "Manual Events (M)",
	"Once 50 Events_": "ไฟล์ที่ได้รับการป้องกัน ได้แก่: \n\nเหตุการณ์แรงกระแทกในโหมดปกติ (E) และในโหมดจอดรถ (I) \nเหตุการณ์ด้วยตนเอง (M) \n\nเมื่อมีการบันทึกเหตุการณ์ {{a}} รายการ เหตุการณ์ใหม่จะเขียนทับเหตุการณ์ที่เก่าที่สุด",
	"Reckless driving unit": "หน่วยความเร็วการขับขี่ประมาท",
	"Hard acceleration Event": "เหตุการณ์การเร่งความเร็วอย่างหนักหน่วง",
	Threshold: Threshold$1,
	"Triggers when the_": "ทริกเกอร์เมื่อกล้องตรวจพบอัตราการเร่งต่อวินาทีที่สูงกว่าค่าเกณฑ์ที่ตั้งไว้",
	"Triggers when the_2": "ทริกเกอร์เมื่อกล้องตรวจพบการลดความเร็วเกินค่าเกณฑ์ที่ตั้งไว้",
	"Hard braking Event": "เหตุการณ์การเบรกอย่างหนักหน่วง",
	"Triggers when more_": "ทริกเกอร์เมื่อตรวจพบว่ามีการเปลี่ยนวิถีมากกว่า 60 องศาภายใน 2 วินาทีขณะขับขี่ ซึ่งเกินค่าเกณฑ์ที่ตั้งไว้",
	"Every event of DMC200_2": "คุณลักษณะการตรวจจับของ DMS มีอยู่เฉพาะในโหมดปกติเท่านั้น หากมีพลังงานในโหมดจอดรถ กล้อง DMS จะบันทึกวิดีโอเท่านั้น",
	"The DMS system has_2": "DMS รวมกล่องตรวจจับใบหน้าสำหรับสถานะ “ตรวจพบ”, “ไม่ตรวจพบ”, “ทำให้สะดุด”, “ง่วงนอน”, “ถอนหน้ากาก” และกล่องตรวจจับการเคลื่อนไหวสำหรับสถานะ “การทำให้สะดุดด้วยมือ”",
	"One for face_": "One for face detection : Detected, Undetected, Distracted, Drowsy",
	"The other for_": "The other for motion detection",
	"On: Normal recording_": "On: Normal recording works while power is maintained in Parking Mode",
	"Off: DMS power_": "Off: DMS power off after 5 minutes when entering Parking Mode, Normal recording works until just before off",
	"Drowsy and Distracted_": "Drowsy and Distracted each have three sensitivity conditions.",
	"Please refer to_": "Please refer to the guide interface below.",
	Drowsiness: Drowsiness$1,
	"Drowsiness occurs when_": "ความง่วงนอนเกิดขึ้นเมื่อคนขับปิดทั้งตาขณะขับรถเกิน 1 วินาทีและหาวเปล่านาน 2 วินาที",
	"Distracted occurs when_": "เกิดขึ้นเมื่อหัวของคนขับหันห่างจากด้านหน้ามากกว่า 50 องศา",
	"A hand distraction_": "A hand distraction occurs when the driver removes one hand from the steering wheel. [*Smoking and phone calls may be suspected.]",
	"Mask off event_": "Mask-off event occurs in two ways. First is when the driver gets in the car without a mask. Second is when the driver takes their mask off",
	"High When the_": "High : When the driver closes their eyes for more than 1 second, it is considered drowsy driving.",
	"Middle When the_": "Medium : When the driver closes their eyes for more than 1.5 second, it is considered drowsy driving.",
	"Low When the_": "Low : When the driver closes their eyes for more than 2 second, it is considered drowsy driving.",
	"High If the_": "High : If the angle of the head is more than 50 degrees away from the front for 3 seconds, it is detected as Distracted.",
	"Middle If the_": "Medium : If the angle of the head is more than 50 degrees away from the front for 5 seconds, it is detected as Distracted.",
	"Low If the_": "Low : If the angle of the head is more than 50 degrees away from the front for 7 seconds, it is detected as Distracted.",
	Direct: Direct$1,
	"Camera Wi-Fi credentials": "ข้อมูลยืนยันตัวตนสำหรับ Wi-Fi ของกล้อง",
	"Network name(SSID)": "ชื่อเครือข่าย (SSID)",
	"Seamless pairing": "Seamless Pairing",
	Remote: Remote$1,
	"Hotspot settings": "การตั้งค่าฮอตสปอต",
	"Hotspot name": "ชื่อฮอตสปอต (SSID)",
	"Hotspot name must_": "Hotspot name must be at least 5 characters long",
	"Public cameras may_": "กล้องสาธารณะอาจปรากฏในแท็บสำรวจหรือแผนที่โลก.",
	"Hard Cornering Event": "เหตุการณ์การเข้าโค้งอย่างหนักหน่วง",
	"Over speed_2": "ความเร็วเกิน",
	"Second drawiness alert": "การแจ้งเตือนอาการง่วงนอนครั้งที่สอง",
	"Low Voltage Warning_2": "การใช้มือทำกิจกรรมอื่น",
	"(You)_2": "{{a}} ( คุณ )",
	"This video has been reported_": "วิดีโอนี้ได้รับการรายงานและถูกลบออกแล้วโดยผู้ดูแลระบบ",
	"Normal Mode recording": "การบันทึกโหมดปกติ (kār banth̒ụk h̄omd pkti)",
	"ON : the camera_": "เปิด : กล้องบันทึกต่อเนื่องแบบวนรอบ",
	"OFF : the camera_": "ปิด : กล้องบันทึกเฉพาะวิดีโอเหตุการณ์ขณะขับรถ",
	"In both modes_": "ในทั้งสองโหมด จะมีการตรวจจับแรงกระแทกเพื่อทริกเกอร์การบันทึกวิดีโอเหตุการณ์",
	"Continuously records_": "บันทึกวิดีโออย่างต่อเนื่องแบบ 1 เฟรมต่อวินาที โดยมีความยาว 1 นาทีต่อวิดีโอ ซึ่งครอบคลุมระยะเวลา 30 นาทีของการกระทำ",
	"Choose detection regions_": "เลือกขอบเขตการตรวจจับเพื่อลดความเสี่ยงของการทริกเกอร์การบันทึกการเคลื่อนไหวที่ไม่พึงประสงค์ เช่น ต้นไม้ที่ไหวไปมาในขณะลมพัด วัตถุที่เคลื่อนที่อยู่ห่างไกล ฯลฯ",
	"Your previous plan is expired.": "แผนก่อนหน้าของคุณหมดอายุแล้ว",
	"Upgrade the plan to restore the camera": "อัปเกรดแผนเพื่อกู้คืนกล้อง\n(%@)",
	"Remove from cloud": "ลบออกจากคลาวด์",
	"Are you sure you want to Remove_": "คุณแน่ใจหรือไม่ว่าต้องการลบออกจากสล็อตคลาวด์",
	"Remove: It doesn’t mean_": "ลบ: นี่ไม่ได้หมายถึงการลบข้อมูลของกล้อง แต่เป็นการสร้างสล็อตสำรองเพื่อรองรับจำนวนกล้องคลาวด์",
	"Now the camera is removed from cloud slot": "กล้องถูกนำออกจากสล็อตคลาวด์",
	"How to delete camera list": "วิธีลบกล้องออกจากรายการ",
	Update: Update$1,
	"Camrea setting": "การตั้งค่ากล้อง",
	"Notification setting": "การตั้งค่าการแจ้งเตือนแบบพุช",
	"Driving reports": "รายงานการขับขี่",
	"Cloud connection steps": "ขั้นตอนการเชื่อมต่อคลาวด์",
	"Download the BlackVue app to add a camera": "ดาวน์โหลดแอป BlackVue เพื่อเพิ่มกล้อง",
	"To see your camera in the BlackVue cloud viewer_": "หากต้องการดูกล้องของคุณใน BlackVue Cloud Viewer คุณต้องเชื่อมต่อกับคลาวด์ก่อน ตั้งค่าและเชื่อมต่อกล้อง BlackVue ของคุณเข้ากับ คลาวด์ได้อย่างง่ายดายด้วยแอป BlackVue สำหรับ iOS และ Android",
	"Download the BlackVue app to see a Wi-Fi connected camera": "ดาวน์โหลดแอป BlackVue เพื่อดูกล้องที่เชื่อมต่อ Wi-Fi",
	"BlackVue Cloud web viewer only supports_": "BlackVue Cloud Web Viewer รองรับเฉพาะกล้องติดรถที่เชื่อมต่อกับคลาวด์เท่านั้น โปรดดาวน์โหลดแอป BlackVue เพื่อดูกล้องติดรถที่เชื่อมต่อ Wi-Fi",
	"You can restore the data if_": "คุณสามารถกู้คืนข้อมูลได้หากคุณลงทะเบียนกล้องนี้กับบัญชีเดิมอีกครั้ง แต่ถ้าบัญชีถูกลบ ไฟล์ทั้งหมดของคุณจะสูญหาย",
	"How to add camera": "วิธีเพิ่มกล้อง",
	"Try to wait 2-3 minutes if you just registered the camera.": "รอสัก 2-3 นาที หากคุณเพิ่งลงทะเบียนกล้อง",
	"Try to check the Cloud Connection Settings again_": "หากกล้องยังคงไม่เชื่อมต่อกับคลาวด์ ลองตรวจสอบการตั้งค่าการเชื่อมต่อคลาวด์อีกครั้ง",
	"Motion Detection": "การตรวจจับการเคลื่อนไหว",
	"Parking recordings occur_": "การบันทึกในขณะจอดรถเกิดขึ้นเมื่อตรวจพบการเคลื่อนไหวที่มองเห็นได้",
	"Motion Sensitivity": "ความไวต่อการเคลื่อนไหว",
	"Motion Detection Sensitivity": "ความไวในการตรวจจับการเคลื่อนไหว",
	"Select Detection Region": "เลือกพื้นที่ตรวจจับ",
	"Speed alert_2": "การเตือนเกี่ยวกับความเร็ว",
	"Live Event Upload_2": "Live Event Upload",
	"Beep Alert": "เสียงบี๊บเตือน",
	"Parking Impact History_": "การแจ้งเตือนแรงกระแทกที่ตรวจพบในโหมดจอดรถ",
	"To register your_": "เพื่อลงทะเบียนปุ่ม SOS ของคุณ คุณต้องใช้แอป BlackVue",
	"SOS button on/off": "สถานะปุ่ม SOS",
	"File sharing to Event Map is_": "การแชร์ไฟล์ไปยัง Event Map ไม่สามารถใช้งานได้ในขณะนี้ โปรดกลับมาตรวจสอบในภายหลัง",
	"Email Notifications": "การแจ้งเตือนทางอีเมล",
	"Push Notifications_2": "การแจ้งเตือนแบบพุช",
	"Optional Camera Rotation": "ทิศทางของกล้องเสริม",
	"Optional Camera Security": "การรักษาความปลอดภัยของกล้องเสริม",
	Option: Option$1,
	"(Owner)": "{{a}} (เจ้าของ)",
	"SOS button": "ปุ่ม SOS",
	"This video has been reported_bold": "วิดีโอนี้ได้รับการรายงานและ<b>ถูกลบออกแล้วโดยผู้ดูแลระบบ</b>",
	"Number of events_2": "จำนวนเหตุการณ์",
	"My Shared Videos": "วิดีโอที่แชร์ของฉัน",
	"No Hashtags": "ไม่มีแฮชแท็ก",
	"I have read and agree_": "ฉันได้อ่านและตกลงกับข้อกำหนดและนโยบายทุกข้อ",
	"14 years old_": "อายุ 14 ปีขึ้นไป",
	Required: Required$1,
	Optional: Optional$1,
	"Profile information_": "ข้อมูลโปรไฟล์สามารถแก้ไขได้ในหน้าการตั้งค่าบัญชี",
	"Automatically Add Live_": "แชร์ไฟล์อัปโหลดเหตุการณ์อัตโนมัติไปยังแผนที่เหตุการณ์โดยอัตโนมัติ",
	"You must be 14 years_": "คุณต้องมีอายุ 14 ปีขึ้นไปจึงจะสร้างบัญชี BlackVue ได้",
	"Use 8 or more characters_": "ใช้อักขระตั้งแต่ 8 ตัวขึ้นไป โดยมีทั้งตัวอักษร ตัวเลข หรือสัญลักษณ์ผสมกัน",
	"Protected files include_": "ไฟล์ที่ได้รับการป้องกัน ได้แก่: <br/>ㆍเหตุการณ์แรงกระแทกในโหมดปกติ (E) และในโหมดจอดรถ (I) <br/>ㆍเหตุการณ์ด้วยตนเอง (M) <br/><br/>เมื่อมีการบันทึกเหตุการณ์ {{a}} รายการ เหตุการณ์ใหม่จะเขียนทับเหตุการณ์ที่เก่าที่สุด",
	"Protected files include": "Protected files include",
	"If you turn_": "หากคุณปิดการเปิดเสียงแนะนำ เราจะปิดรายการต่อไปนี้ด้วย",
	"Live Event Upload_success": "บันทึกการตั้งค่าการอัปโหลดเหตุการณ์สดเรียบร้อยแล้ว",
	"Video type": "ประเภทวีดีโอ",
	"Notify the Owner": "แจ้งเตือนเจ้าของ",
	"Adjusting the cut-off voltage_2": "Adjusting the cut-off voltage to a lower setting may result in your dash cam draining more power from your battery. This could result in warning messages of battery drain or affect other vehicle functions.\nPlease consult with your dealership before lowering the voltage.",
	Others: Others$1,
	"This video has been removed.": "วิดีโอนี้ได้ถูกลบออกแล้ว",
	"Please assign cameras_": "โปรดมอบหมายกล้องให้กับกลุ่มนี้",
	"Are you running_": "คุณพลาดโอกาสที่จะดูไฟล์วิดีโอย้อนหลังใช่หรือไม่",
	"Upgrade your plan_": "อัปเกรดแผนของคุณเป็นแผนกลุ่มยานพาหนะ เพื่อเล่นย้อนหลังได้อย่างไม่มีขีดจำกัด และเพื่อคุณสมบัติพิเศษอื่น ๆ บนคลาวด์",
	"Are you running_Liveview": "คุณหมดเวลาในการดูภาพสดใช่หรือไม่",
	"Upgrade your plan_Liveview": "อัปเกรดแผนของคุณเป็นแผนกลุ่มยานพาหนะเพื่อดูภาพสดได้อย่างไม่มีขีดจำกัด และเพื่อคุณสมบัติพิเศษอื่น ๆ บนคลาวด์",
	Stay: Stay$1,
	"Go to Fleet Plan": "ไปที่แผนกลุ่มยานพาหนะ",
	"It looks like the video file is being prepared. please try again later.": "ดูเหมือนว่ากำลังเตรียมไฟล์วิดีโอ กรุณาลองใหม่อีกครั้งในภายหลัง.",
	"Oops!": "อ๊ะ!",
	"Please back up_": "โปรดสำรองการบันทึกที่สำคัญทั้งหมดก่อนที่จะเปลี่ยนการตั้งค่านี้",
	"When you save_": "เมื่อคุณบันทึกการตั้งค่า การ์ด microSD จะถูกฟอร์แมตและการบันทึกทั้งหมดจะถูกลบเพื่อให้การทำงานมีความเสถียร",
	"This is an unregistered_": "นี่คืออีเมลที่ไม่ได้ลงทะเบียน คุณต้องการไปที่หน้าสร้างบัญชีหรือไม่?",
	"Camera name must_2": "ชื่อกล้องจะต้องอยู่ระหว่าง 5 ถึง 32 ตัวอักษร",
	"G-sensor (Normal mode)": "เซ็นเซอร์วัดแรง G (โหมดปกติ)",
	"G-sensor (Parking mode)": "เซ็นเซอร์วัดแรง G (โหมดจอดรถ)",
	"Up & down": "ขึ้นและลง",
	"Front & back": "หน้าและหลัง",
	"Rotate Video 180º": "Rotate Video 180º",
	Mask_2: Mask_2$1,
	"Priority event": "Priority Event",
	"There is no_camera": "There is no camera that your owner assigned to you.",
	"Camera SSID": "Camera SSID",
	"The BlackVue dashcam_2": "The BlackVue dashcam is not compatible with 5GHz wireless networks",
	"Driver detection box_2": "Driver Detection Box",
	"DMS camera recording_2": "DMS Camera Recording in Parking Mode",
	Low_2: Low_2$1,
	Medium_2: Medium_2$1,
	High_3: High_3$1,
	"Live Event Upload_3": "Live Event Upload",
	"Driving Impact": "Driving Impact",
	"Video source_2": "Video Source",
	"Front camera_2": "Front Camera",
	"Rear camera_2": "Rear Camera",
	"Optional Camera": "Optional Camera",
	"Motion Detection_2": "Motion Detection",
	"Rear camera stops_2": "Rear camera stops recording 5 minutes after entering Parking Mode. Recording restarts when entering normal mode.",
	"Passenger vehicle": "Passenger Vehicle",
	"Heavy vehicle": "Heavy Vehicle",
	Highest_3: Highest_3$1,
	Extreme_2: Extreme_2$1,
	"Less recording files": "Fewer Recording Files",
	"Camera rotation_2": "Camera Rotation",
	"Share camera profile_2": "Share Camera Profile",
	Private_2: Private_2$1,
	"BlackVue Live": "BlackVue Live",
	"Important All saved_": "Important! All saved videos are about to be deleted. Tap Cancel and back up important files if needed.",
	"Whenever saving settings_": "Whenever saving settings after changing the time zone, the SD card is initialized and all stored files are deleted.",
	"Do you want_": "Do you want to save your changes?",
	"No groups": "No groups",
	Lite: Lite$1,
	"USD per Camera": "USD per extra Camera",
	"up to Cameras": "up to Cameras",
	"All the P Plan_": "คุณสมบัติของแผน <b>{{a}}</b> ทั้งหมด รวมถึง:",
	"User Roles and Permissions": "บทบาทและสิทธิ์ของผู้ใช้",
	"Geofence Setup (Web) and alerts": "Geofence Setup (Web) and alerts",
	"N Times": "{{a}} ครั้ง",
	"N Minutes": "{{a}} นาที",
	"Emergency Alarm": "สัญญาณเตือนฉุกเฉิน",
	"Playback, Live View": "เล่น, ดูสด",
	"Your driving record : Daily, Monthly": "บันทึกการขับขี่ของคุณ: รายวัน, รายเดือน",
	"Real-time Conversation": "การสนทนาแบบเรียลไทม์",
	"Initiate a conversation_": "เริ่มต้นการสนทนากับคนขับผ่านลำโพงและไมโครโฟนของ Dashcam",
	"Remote Voice Communication": "การสื่อสารด้วยเสียงระยะไกล",
	"See the last location_": "ดูตำแหน่งสุดท้ายของกล้องของคุณ",
	"Check your cars_": "ตรวจสอบข้อมูล GPS แบบเรียลไทม์ของรถบนแผนที่เพื่อค้นหายานพาหนะของคุณและรับข้อมูลเกี่ยวกับสถานะของมันเช่นไม่ว่าจะขับหรือจอดรถและความเร็ว",
	"Supported models_": "* รุ่นที่รองรับ: รุ่น S และ Early X Series",
	"GPS Tracking &_": "การติดตาม GPS และวิดีโอบนแผนที่ (Smart/Fleet)",
	"Track your cars_": "ติดตามตำแหน่งและความเร็วของรถของคุณบนแผนที่!",
	"GPS Tracking: visualize_": "การติดตาม GPS: แสดงภาพบันทึกการขับขี่ของคุณบนแผนที่\nวิดีโอบนแผนที่: ดูข้อมูลบริบท (ความเร็วประเภทเหตุการณ์) และเล่นวิดีโอที่เกี่ยวข้องจากแผนที่",
	"Visualize your cars_": "แสดงผลตำแหน่งและความเร็วของรถของคุณบนแผนที่!",
	"The feature enables_": "คุณลักษณะช่วยให้อัปโหลดวิดีโอลงคลาวด์ได้ รวมถึง 5 วินาทีก่อนเกิดอุบัติเหตุ",
	"Camera profile setting": "Camera profile setting",
	"Are you running_Download": "Are you running out of chance to Download Video?",
	"Upgrade your plan_Download": "Upgrade your plan to Fleet Plan for Unlimited Download, and other Cloud -Exclusive features.",
	"This feature is available for Smart and Fleet_": "This feature is available for Smart and Fleet Plan subscribers only.",
	"Rear camera will keep_": "กล้องด้านหลังจะหยุดการบันทึกในโหมดจอดรถเมื่อสถานะอุณหภูมิของแดชแคมถูกเปลี่ยนเป็น \"อุณหภูมิสูง\" กล้องด้านหลังจะเริ่มการบันทึกอีกครั้งหลังจากสถานะอุณหภูมิของแดชแคมถูกเปลี่ยนเป็น \"อุณหภูมิปกติ\" (ควรระวัง: เพื่อป้องกันอิเล็กทรอนิกส์ แบล็ควิวอาจปิดการทำงานเนื่องจากอุณหภูมิภายนอกสูง)",
	"Get Unlimited Cloud_": "รับการเล่นคลาวด์ไร้ขีดจำกัดและจัดการกล้องสูงสุด {{a}} ตัว",
	"Up to N cameras_": "Up to {{a}} cameras (+ {{b}} USD Extra charge)",
	"N Minutes per Day": "{{a}} นาทีต่อวัน",
	"Drowsiness sensitivity is_": "ความไวของการง่วงนอนจะกำหนดโดยระยะเวลาในการกะพริบตา โดยใช้อัลกอริธึม BlackVue ที่เชื่อถือได้ <br> <br> ความไวของการไขว้เขวจะกำหนดโดยมุมตำแหน่งศีรษะของผู้ขับขี่จากด้านหน้าและระยะเวลาที่ค้างอยู่ในตำแหน่งนี้",
	"Not available with this plan": "Not available with this plan",
	"The optional camera records_": "กล้องเสริมบันทึกในโหมดจอดรถ",
	"Smart and Fleet_": "Smart and Fleet Plan<br/>subscribers only",
	"This feature is_smart": "This feature is available for Smart and Fleet Plan subscribers only.",
	"Camera Registration": "การลงทะเบียนกล้อง",
	"Voice Call": "Voice Call",
	"N times per Month": "{{a}} times per Month",
	"Recommended for higher bitrate_": "แนะนำสำหรับบิตเรตที่สูงขึ้นและคุณภาพวิดีโอที่ดีขึ้น",
	"Recommended for for better compatibility_": "แนะนำสำหรับความเข้ากันได้ดีขึ้นกับเดสก์ท็อปและอุปกรณ์มือถือ",
	"A minute of front camera_": "ขนาดไฟล์โดยประมาณสำหรับวิดีโอ 1 นาที (กล้องด้านหน้า)",
	"Extreme(N Mbps): N MB_": "Extreme ({{ex1}}Mbps) : {{ex2}}MB\nHighest ({{ht1}}Mbps) : {{ht2}}MB\nHigh ({{hi1}}Mbps) : {{hi2}}MB\nNormal ({{no1}}Mbps) : {{no2}}MB",
	"File size information reflects_": "ข้อมูลขนาดไฟล์สะท้อนขนาดสูงสุดที่เป็นไปได้และขนาดไฟล์จริงอาจแตกต่างกันไปขึ้นอยู่กับเงื่อนไขการบันทึก",
	Bitrate: Bitrate$1,
	"Connection has been_": "การเชื่อมต่อหายไป\nการเชื่อมต่อใหม่ ...",
	"Unable to establish_": "ไม่สามารถสร้างการเชื่อมต่อกับกล้องได้\nโปรดตรวจสอบให้แน่ใจว่าอุปกรณ์ของคุณเชื่อมต่ออย่างถูกต้องและลองอีกครั้ง",
	"Purchased by Payment Service": "ซื้อโดยบริการชำระเงิน",
	"Up to N Cameras": "สูงสุด {{a}} กล้อง",
	"Unlimited Live View": "การดูสดแบบไม่จำกัด",
	"N Days GPS Tracking": "การติดตาม GPS เป็นเวลา {{a}} วัน",
	"Unlimited Playback and Download": "การเล่นและดาวน์โหลดไม่จำกัด",
	hours: hours$1,
	"Live Event Upload or_": "Live Event Upload หรือวิดีโอ 12+ ในความละเอียดเต็ม",
	"During the usage period of the One Plan_": "ระหว่างระยะเวลาการใช้บริการ One Plan ไม่สามารถเปลี่ยนแปลงแผนการสมัครสมาชิกได้ หากต้องการเปลี่ยนเป็นแผนอื่น ๆ กรุณาติดต่อฝ่ายสนับสนุนลูกค้าของ BlackVue เพื่อยกเลิกการสมัครสมาชิก One Plan",
	"Service Period (Include SIM Data)": "ระยะเวลาให้บริการ (รวมข้อมูล SIM)",
	"Purchase the BlackVue One Package_": "ซื้อแพ็คเกจ BlackVue One เพื่อปลดล็อก One Plan ฟรีเป็นระยะเวลา 1 ปี",
	"3GB SIM Data Plan": "แผน SIM ขนาด 3GB",
	"Unlimited Live View, Playback and Download": "มุมมองแบบสดๆ การเล่นซ้ำและการดาวน์โหลดไร้ขีดจำกัด",
	"within data availability": "ภายในความพร้อมใช้ของข้อมูล",
	"The BlackVue One Plan is a 1-year_": "BlackVue One Plan เป็นแผนบริการคลาวด์ระยะเวลา 1 ปี ที่สามารถเข้าถึงได้เฉพาะผ่านการซื้อ BlackVue One Package ซึ่งประกอบด้วยกล้องติดรถยนต์ แผนข้อมูลขนาด 3GB/เดือน (สำหรับสหรัฐอเมริกาและแคนาดา) เป็นระยะเวลา 1 ปีและแผนบริการคลาวด์ระยะเวลา 1 ปี",
	"The BlackVue One Package is available_": "BlackVue One Package มีจำหน่ายเฉพาะที่ BlackVue Online Store",
	"Go to BlackVue Shop": "ไปที่ร้าน BlackVue",
	"Anonymous Cam": "กล้องอนุรักษ์สิทธิ์",
	"App only": "ในแอปเท่านั้น",
	Expires: Expires$1,
	"N days remaining": "เหลือเวลา {{a}} วัน",
	"No action needed_": "<b>ไม่ต้องดำเนินการใด ๆ</b> ราคาลดลงใหม่จะถูกใช้งานโดยอัตโนมัติตั้งแต่การชำระเงินครั้งถัดไปของคุณหลังจากวันที่ 13 กันยายน",
	"The new reduced price_": "ราคาลดลงใหม่จะถูกใช้งานโดยอัตโนมัติกับบัญชีของคุณ",
	"Smart Plan Subscriber?": "Smart Plan Subscriber หรือไม่?",
	"Fleet Plan Subscriber?": "Fleet Plan Subscriber หรือไม่?",
	"Please take a moment to_": "กรุณาให้เราเวลาสักครู่เพื่อให้เรามีสิทธิ์ย้ายบัญชีของคุณ",
	"Starting from now and_": "<b>ตั้งแต่ตอนนี้และจนถึงวันที่ 31 ตุลาคม</b> คุณสามารถให้เราทำการเปลี่ยนแปลงให้คุณโดย <a href=\"https://form.jotform.com/232411253056041\" target=\"_blank\">คลิกลิงก์นี้</a> และกรอกอีเมลของบัญชี Fleet ของคุณ. โปรดให้เราเวลาสักครู่เพื่อดำเนินการเปลี่ยนแปลง หรือหากต้องการคุณสามารถยกเลิกบัญชีที่มีอยู่และสมัครสมาชิกใหม่ในราคาใหม่ตั้งแต่วันที่ 13 กันยายน",
	"Once activated_": "เมื่อเปิดใช้งานแล้ว One Plan ไม่สามารถหยุดหรือปิดใช้งานได้.",
	"Once the One Plan is activated_": "เมื่อ One Plan ถูกเปิดใช้งานแล้ว One Package จะไม่สามารถขอคืนเงินได้.",
	"Up to N Cloud Camera Slot": "สูงสุด {{a}} ช่องสล็อตกล้องคลาวด์",
	"nGB of Cloud Storage": "{{a}}GB พื้นที่จัดเก็บข้อมูลในคลาวด์",
	"Get started for free_": "Get started for free, no credit card required. Includes Alert Push Notifications, limited Remote Live View and cloud storage.",
	"The BlackVue One Plan is exclusively_": "The BlackVue One Plan is exclusively available through the purchase of a BlackVue One Package. 3GB/mo data plan is for US and Canada only. BlackVue Cloud’s Free Plan, Lite Plan (1~3) and Smart Plan (1~3) accounts can upgrade to One Plan. However, Lite Plan (4~15), Smart Plan (4~15) and Fleet Plan accounts can not be upgraded to One Plan.",
	"For N year": "For {{a}} year",
	"Included in the One Package": "Included in the One Package",
	"3GB SIM Data Plan for N year": "3GB SIM Data Plan for {{a}} year",
	"One Plan Cloud Service for N year": "One Plan Cloud Service for {{a}} year",
	"The BlackVue One Package includes_": "The BlackVue One Package includes all you need to enjoy BlackVue Cloud for a whole year!",
	"4K LTE Dash Cam_": "4K LTE Dash Cam, Cloud Service and Data Plan",
	"nGB included": "{{a}}GB included",
	"nGB per camera": "{{a}}GB per camera",
	"N Days Live Event Upload": "{{a}} Days Live Event Upload",
	"Up to N Dash Cameras": "Up to {{a}} Dash Cameras",
	"Step N/N": "ขั้นตอน {{a}}/{{b}}",
	"Cloud Connection": "การเชื่อมต่อกับคลาวด์",
	"To pair your dashcam": "เพื่อจับคู่แดชแคมกับแบตเตอรีของคุณ โปรดเชื่อมต่อกับคลาวด์",
	Check: Check$1,
	"Unpair Battery": "ยกเลิกการจับคู่แบตเตอรี่",
	"Are you sure you want to unpair": "คุณแน่ใจหรือไม่ว่าต้องการยกเลิกการจับคู่ของแบตเตอรี่(%@)นี้ออกจากกล้อง?",
	"Unpair: It doesn't mean": "ยกเลิกการจับคู่: นี่ไม่ได้หมายความว่าลบข้อมูลของแบตเตอรี่",
	"*The paired battery will": "*แบตเตอรี่ที่จับคู่กันจะถูกลบออกไปด้วยกัน",
	"Would you like to pair this": "คุณต้องการจับคู่แบตเตอรี่นี้หรือไม่?",
	"Battery successfully paired": "การจับคู่แบตเตอรี่เสร็จสมบูรณ์",
	"Now you can directly connect to": "ตอนนี้คุณสามารถเชื่อมต่อกับแบตเตอรี่โดยตรงจากรายการกล้องได้แล้ว",
	"Pairing failed": "การจับคู่ล้มเหลว โปรดลองอีกครั้ง",
	"Battery Name": "ชื่อแบตเตอรี่",
	"Capacity History": "ประวัติความจุ",
	"The graph displays capacity": "กราฟแสดงระดับแบตเตอรี่โดยใช้ข้อมูลจากการเชื่อมต่อกับคลาวด์\n ความจุของแบตเตอรี่อาจแตกต่างขึ้นอยู่กับอุณหภูมิการตั้งค่ากล้องติดรถยนต์และความถี่ของเหตุการณ์ที่เป็นการกระตุ้น",
	"Last 24 Hours": "ย้อนหลัง 24 ชั่วโมง",
	"Last 7 Days": "ย้อนหลัง 7 วัน",
	"Battery Level": "ระดับแบตเตอรี่",
	"Temperature History": "ประวัติอุณหภูมิ",
	"The graph displays temperature": "กราฟแสดงระดับอุณหภูมิโดยประมาณโดยใช้ข้อมูลจากการเชื่อมต่อกับคลาวด์",
	"Temperature Level": "ระดับอุณหภูมิ",
	"Connecting alert": "[ กำลังเชื่อมต่อ ]\nข้อมูลที่แสดงเมื่อเชื่อมต่อ.",
	"Low Output power Alert": "[ การตัดการจ่ายไฟเวลาเสีย ]\nแรงดันเอาต์พุตต่ำเกินไป จำกัดการจ่ายพลังงานของอุปกรณ์ที่เชื่อมต่อ",
	"High temp Alert": "[ การตัดพลังงานนำเข้า ]\nอุณหภูมิของแบตเตอรี่สูงเกินไป จำกัดการชาร์จ",
	"Remaining time": "เวลาที่เหลือ",
	"Remaining time estimate": "เวลาที่เหลือเป็นการประมาณโดยใช้พลังงานรวมของอุปกรณ์ที่เชื่อมต่อ\n จะคำนวณใหม่ทุก 30 วินาทีหลังจากเชื่อมต่อกับแบตเตอรี่",
	"Setting changed": "การตั้งค่าเปลี่ยนแล้ว",
	"Setting change failed": "การเปลี่ยนการตั้งค่าล้มเหลว",
	"Low Input power Alert": "[ การตัดพลังงานนำเข้า ]\nแรงดันชาร์จต่ำเกินไป จำกัดการชาร์จ",
	"High Input power Alert": "[ การตัดพลังงานนำเข้า ]\nแรงดันการชาร์จสูงเกินไป จำกัดการชาร์จ",
	"Low temp_Cut off Alert": "[ การตัดพลังงานนำเข้า ]\nอุณหภูมิของแบตเตอรี่ต่ำเกินไป จำกัดการชาร์จและเวลาที่ใช้งานได้",
	"Low temp Alert": "[ อุณหภูมิต่ำ ]\nอุณหภูมิของแบตเตอรี่ต่ำเกินไป จำกัดเวลาที่ใช้งานและความเร็วในการชาร์จ",
	"Low capacity Alert": "[ ความจุต่ำ ]\nความจุของแบตเตอรี่ต่ำเกินไป\nขับรถเพื่อเติมไฟ",
	"Back to list": "กลับไปที่รายการ",
	Saving: Saving$1,
	Now: Now$1,
	"Power supplying is limited": "การจ่ายไฟถูก <b>จำกัด</b>",
	"This battery is already paired": "แบตเตอรี่นี้ถูกจับคู่แล้ว",
	"Connecting to Battery": "กำลังเชื่อมต่อกับแบตเตอรี่",
	"Paired battery": "แบตเตอรี่ที่จับคู่แล้ว",
	"Battery unpairing failed": "การยกเลิกการจับคู่แบตเตอรี่ล้มเหลว โปรดลองอีกครั้ง",
	"A connection is already active": "การเชื่อมต่อถูกเปิดใช้งานอยู่แล้ว โปรดลองอีกครั้งในภายหลัง",
	"Searching for battery": "กำลังค้นหาแบตเตอรี่",
	"Select battery to pair with your camera": "เลือกแบตเตอรี่ที่จะจับคู่กับกล้องของคุณ",
	"Unable to connect": "ไม่สามารถเชื่อมต่อ",
	"A connection error has occurred": "เกิดข้อผิดพลาดในการเชื่อมต่อ โปรดลองอีกครั้ง",
	"The paired dashcam has been disconnected": "กล้องติดรถที่ติดคู่กันถูกยกเลิกการเชื่อมต่อจากคลาวด์แล้ว\nโปรดตรวจสอบเงื่อนไขด้านล่าง",
	"Check if the battery is not fully discharged": "ตรวจสอบว่าแบตเตอรี่ไม่ได้ถูกใช้จนเต็มที่หรือไม่",
	"Check the Cloud connection of the paired dashcam": "ตรวจสอบการเชื่อมต่อกับคลาวด์ของกล้องติดรถที่จับคู่",
	"Connection lost": "การเชื่อมต่อหลุด",
	"A connection error has occurred shortly": "เกิดข้อผิดพลาดในการเชื่อมต่อ โปรดลองเชื่อมต่อในภายหลัง",
	"Charging is limited": "การชาร์จ <b>ถูก จำกัด</b> แล้ว",
	"Cannot connect to the battery": "ไม่สามารถเชื่อมต่อกับแบตเตอรี่ได้",
	"Please check the Cloud connection of the camera": "โปรดตรวจสอบการเชื่อมต่อกับคลาวด์ของกล้อง",
	"Charging complete in": "การชาร์จเสร็จสมบูรณ์ใน %@",
	"Current Capacity": "ความจุปัจจุบัน",
	"Output Voltage": "แรงดันเอาท์พุต",
	"Charging Voltage": "แรงดันชาร์จ",
	Beep: Beep$1,
	"Battery Capacity": "ความจุแบตเตอรี่",
	"Battery connection failed": "การเชื่อมต่อแบตเตอรี่ล้มเหลว",
	"Expansion battery": "แบตเตอรี่สำรอง",
	"Make sure it is switched on and within range": "• ตรวจสอบให้แน่ใจว่ากล้องเปิดอยู่และอยู่ในระยะมือถือของคุณ",
	"Make sure it is not wirelessly connected to another device": "• ตรวจสอบให้แน่ใจว่ากล้องไม่ได้เชื่อมต่อแบบไร้สายกับอุปกรณ์อื่น",
	"Detected batteries": "แบตเตอรี่ที่ตรวจพบ",
	"Can't see your battery": "ไม่เห็นแบตเตอรี่ของคุณใช่หรือไม่",
	"Download the Blackvue app to check": "ดาวน์โหลดแอป BlackVue เพื่อตรวจสอบแบตเตอรี่ของคุณจากระยะไกล",
	"By Using the app": "ด้วยการใช้แอปพลิเคชันคุณสามารถจับคู่กล้องติดรถของคุณกับแบตเตอรี่และตรวจสอบความจุของแบตเตอรี่ผ่านคลาวด์ได้ หลังจากจับคู่แล้วคุณสามารถตรวจสอบแบตเตอรี่ในมุมมองของคลาวด์ BlackVue ได้",
	Unpair: Unpair$1,
	"Occurs when the driver closes_": "เกิดขึ้นเมื่อคนขับปิดตาทั้งสองข้างขณะขับขี่",
	"Occurs when the driver's head_": "เกิดขึ้นเมื่อหัวของคนขับหันออกจากหน้าของรถมากกว่า 50 องศา.",
	"Only detects distraction above_": "ตรวจจับเฉพาะสิ่งรบกวนเมื่อเกินค่าที่ตั้งไว้ คุณสามารถเปลี่ยนหน่วยได้ใน 'การตั้งค่ากล้อง > การทริกเกอร์เหตุการณ์ > หน่วยความเร็วการขับขี่ประมาท'",
	"Occurs when the driver is not wearing_": "เกิดขึ้นเมื่อคนขับไม่ได้สวมเข็มขัดนิรภัย.",
	"Overlays a face detection box_": "ใส่กรอบตรวจจับใบหน้าลงบนภาพถ่ายในระหว่างการถ่ายภาพแบบสดและบันทึกไว้ของกล้อง DMS.",
	"Seat Belt": "ใบเก็บเงิน",
	Detected: Detected$1,
	"No Seat Belt": "ไม่มีใบเก็บเงิน",
	"Fatigue Risk Alert": "การแจ้งเตือนเกี่ยวกับความเสี่ยงจากความเหนื่อยล้า",
	"The time is synchronized_Email": "เวลาถูกซิงค์กับเวลาในการแจ้งเตือนทางอีเมลของคุณ",
	"Sends an alert when drowsiness is_": "ส่งการแจ้งเตือนเมื่อตรวจจับความง่วงหลังจากความง่วงเริ่มแรก",
	"Data updates upon connection": "ข้อมูลจะอัพเดตเมื่อเชื่อมต่อ",
	"Sends a notification if_": "ส่งการแจ้งเตือนหากคุณเกิน 'ตั้งเวลา' ขณะขับขี่",
	"Data updates Alert": "[ กำลังเชื่อมต่อ ]\nข้อมูลจะอัพเดตเมื่อเชื่อมต่อ",
	"Cannot save settings": "ไม่สามารถบันทึกการตั้งค่า",
	"The time is synchronized_Push": "เวลาถูกซิงค์กับเวลาในการแจ้งเตือนแบบพุช",
	"The file has been overwritten or deleted": "ไฟล์ถูกเขียบทับหรือถูกลบทิ้งแล้ว",
	"Box Pro Models Settings": "การตั้งค่าโมเดล Box Pro",
	"Push notifications can be configured_": "การแจ้งเตือนแบบพุชสามารถกำหนดค่าได้ในการตั้งค่าการแจ้งเตือนของกล้อง",
	"Recording Video": "การบันทึกวิดีโอ",
	"Cameras settings": "การตั้งค่ากล้อง",
	"Please configure the settings": "กรุณาตั้งค่าการตั้งค่า",
	"Speed Priorities": "ลำดับความสำคัญของความเร็ว",
	"Set Speed Priority": "ตั้งค่าลำดับความสำคัญของความเร็ว",
	"Geofence-enter": "ขอบเขตเสมือน - เข้า",
	"Geofence-exit": "ขอบเขตเสมือน - ออก",
	"Geofence-pass": "ขอบเขตเสมือน - ผ่าน",
	"Geofence-speed alert": "ขอบเขตเสมือน - การเตือนความเร็ว",
	"Drive Position": "ตำแหน่งที่นั่งคนขับ",
	"Left-Hand Drive": "การขับขี่ด้านซ้าย",
	"Right-Hand Drive": "การขับขี่ด้านขวา",
	"Please configure this setting_": "กรุณาปรับการตั้งค่านี้หากไม่สามารถตรวจจับผู้ขับขี่ได้อย่างถูกต้อง",
	"A new feature in the BlackVue settings_": "มีการเพิ่มคุณสมบัติใหม่ในการตั้งค่า BlackVue เพื่อซิงค์เวลาของกล้อง คุณควรซิงค์เวลากล้องของคุณหนึ่งครั้งเพื่อการบันทึกเวลาที่แม่นยำ",
	"Feature location_": "ตำแหน่งคุณลักษณะ:\nการตั้งค่ากล้อง> ระบบ > การซิงค์เวลา",
	"Time Sync": "การซิงค์เวลา",
	"You can sync the time between_": "คุณสามารถซิงค์เวลาระหว่างอุปกรณ์ของคุณและกล้อง BlackVue การฟอร์แมตการ์ด SD เป็นสิ่งที่จำเป็นสำหรับการซิงโครไนซ์ ก่อนที่คุณจะดำเนินการต่อ โปรดสำรองวิดีโอที่จำเป็นไว้",
	"Voice Alert": "การแจ้งเตือนด้วยเสียง",
	"Provides a voice alert_": "ให้การแจ้งเตือนด้วยเสียงจากกล้องและส่งการแจ้งเตือนไปยังแอปพลิเคชันหากคุณเกินเวลาที่ตั้งค่าไว้ระหว่างการขับขี่",
	"Please enter a value": "Please enter a value.",
	"Notices & Notifications": "ข่าวสารและการแจ้งเตือน",
	"Only detects drowsiness above_": "ตรวจจับเฉพาะอาการง่วงนอนเมื่อเกินค่าที่ตั้งไว้ คุณสามารถเปลี่ยนหน่วยได้ใน 'การตั้งค่ากล้อง > การทริกเกอร์เหตุการณ์ > หน่วยความเร็วการขับขี่ประมาท'",
	Promotion: Promotion$1,
	Notice: Notice$1,
	"View More": "ดูเพิ่มเติม",
	"Read More": "อ่านเพิ่มเติม",
	"Detection Box": "กล่องตรวจจับ",
	"Seatbelt Detection Box": "กล่องตรวจจับเข็มขัดนิรภัย",
	"Drive Position Detection Box": "กล่องตรวจจับตำแหน่งการขับขี่",
	"Fleet Subscription Promotion (50%)": "โปรโมชั่นสมัครสมาชิกยานพาหนะ (50%)",
	"BlackVue Fleet Tracking exclusive features_": "คุณสมบัติพิเศษของ BlackVue Fleet Tracking สำหรับผู้ใช้ระดับสูงและธุรกิจ (ผู้ใช้และกล้องหลายตัว, การกำหนดขอบเขตทางภูมิศาสตร์, โปรแกรมดูเว็บ ฯลฯ )",
	"Special Discount (50% off)": "ส่วนลดพิเศษ (ลด 50%)",
	"*Promotion applied for 12 months": "*โปรโมชั่นมีอายุ 12 เดือน",
	"*Payment will be made starting next month.": "*การชำระเงินจะเริ่มในเดือนหน้า",
	"[About using promotions]": "[เกี่ยวกับการใช้โปรโมชั่น]",
	"The promotion is free for the first month_": "โปรโมชั่นนี้ฟรีสำหรับเดือนแรก จากนั้นจะถูกเรียกเก็บเงินเป็นเวลา 12 เดือนโดยเริ่มตั้งแต่เดือนถัดไป",
	"For users with an existing Lite/Smart subscription_": "สำหรับผู้ใช้ที่มีการสมัครสมาชิก Lite/Smart อยู่แล้ว คุณต้องยกเลิกการสมัครสมาชิกแอปที่มีอยู่แยกกัน มิฉะนั้น การสมัครแอปที่มีอยู่ของคุณอาจถูกเรียกเก็บเงินจากบัญชีของคุณ",
	"Please be sure to cancel your app subscription_": "โปรดอย่าลืมยกเลิกการสมัครสมาชิกแอปของคุณภายในระยะเวลาฟรี การชำระเงินซ้ำซ้อนจะไม่ได้รับคืน",
	"You will be changed to Fleet Plan immediately_": "คุณจะเปลี่ยนเป็น Fleet Plan ทันที แม้ว่าระยะเวลาการสมัครสมาชิกที่เหลืออยู่ของ Lite/Smart Plan ที่มีอยู่จะยังไม่หมดอายุก็ตาม",
	"You can cancel Fleet Plan any time.": "คุณสามารถยกเลิกแผนยานพาหนะได้ตลอดเวลา",
	"From February 2025, please go to the Fleeta service and use it.": "เมื่อโปรโมชั่นถูกยกเลิกแล้ว โปรโมชั่นจะไม่ถูกนำมาใช้ซ้ำ",
	"After promotion expires_": "หลังจากโปรโมชันหมดอายุ คุณจะต่ออายุโดยอัตโนมัติด้วยค่าธรรมเนียมการสมัครสมาชิก Fleet Plan ที่มีอยู่",
	"(Required) I have read the promotion instructions_": "(จำเป็น) ฉันได้อ่านคำแนะนำในการส่งเสริมการขายและตกลงที่จะชำระเงินแล้ว",
	"Upgrade to Fleet Plan immediately": "อัปเกรดเป็นแผนยานพาหนะทันที",
	"Important Notice:": "ประกาศสำคัญ:",
	"Switch of BlackVue Web Viewer to Fleeta Web Viewer": "สลับ BlackVue Web Viewer เป็น Fleeta Web Viewer",
	"To provide better features and quality_": "เพื่อมอบฟีเจอร์และคุณภาพที่ดีขึ้น บริการดูเว็บ BlackVue จะเปลี่ยนไปใช้บริการดูเว็บฟลีตใหม่ที่เรียกว่า Fleeta เร็วๆ นี้ บริการ Fleeta จะเป็นเอกสิทธิ์สำหรับผู้ใช้ Fleet Plan เท่านั้น บริการ Fleeta จะเปิดตัวในเดือนมีนาคม 2568 พร้อมด้วยแอปพิเศษใหม่ของ Fleeta โปรดไปที่ <a href=\"https://www.fleeta.io\" target=\"_blank\">fleeta.io</a> เพื่อดูข้อมูลเพิ่มเติม",
	"We kindly ask for your understanding_": "เราขอให้คุณเข้าใจ เนื่องจากการเปลี่ยนแปลงนี้มีจุดมุ่งหมายเพื่อให้บริการที่ได้รับการปรับปรุงให้ดียิ่งขึ้น หากมีคำถามใดๆ เกี่ยวกับการเปลี่ยนแปลงนี้ โปรดติดต่อศูนย์ CS ของเรา",
	"Don’t show this again for this month": "อย่าแสดงสิ่งนี้อีกสำหรับเดือนนี้",
	"Fleet Plan Subscription Promotion": "โปรโมชั่นสมัครสมาชิกแผนยานพาหนะ",
	"Period : December 2, 2024 ~ May 31, 2025": "ระยะเวลา : 2 ธันวาคม 2567 ~ 31 พฤษภาคม 2568",
	"See more details": "ดูรายละเอียดเพิ่มเติม",
	"To continue improve quality and provide better service_": "เพื่อปรับปรุงคุณภาพและให้บริการที่ดีขึ้นต่อไป บริการ BlackVue Web Viewer ของเราจะเปลี่ยนไปใช้บริการพิเศษของ Fleet Plan ในเร็วๆ นี้ จะไม่มีให้บริการฟรีหรือผ่านแผนอื่นๆ อีกต่อไปตั้งแต่ปลายเดือนมีนาคม 2025",
	"We have prepared special discount offers for_": "เราได้เตรียมข้อเสนอส่วนลดพิเศษสำหรับผู้ใช้ Web Viewer ที่มีอยู่ของเรา กรุณาตรวจสอบรายละเอียดด้านล่าง! เราขอความกรุณาความเข้าใจและการสนับสนุนของคุณในขณะที่เราใช้การเปลี่ยนแปลงนี้เพื่อให้บริการที่ดียิ่งขึ้น\n",
	"*If you are subscribed in-app_": "*หากคุณสมัครสมาชิกในแอป โปรดอย่าลืมยกเลิกการสมัครสมาชิกในแอปของคุณ",
	"Enjoy your BlackVue Cloud service with your dashcam.": "เพลิดเพลินกับบริการ BlackVue Cloud ของคุณด้วย dashcam ของคุณ",
	"Available Cloud Camera slot(s)_": "ช่อง Cloud Camera ที่ใช้งานได้ : {{d}}",
	"Not eligible for the promotion.": "ไม่มีสิทธิ์ได้รับโปรโมชั่น",
	"You have already used_": "คุณได้ใช้โปรโมชั่นนี้แล้ว เมื่อโปรโมชั่นถูกยกเลิกแล้ว ไม่สามารถสมัครใหม่ได้",
	"Go to Cameras": "ไปที่กล้อง",
	"Congratulations !": "Congratulations !",
	"Fleet Plan user": "Fleet Plan user",
	"Let your BlackVue monitor_": "ให้ BlackVue ของคุณตรวจสอบรถของคุณและแจ้งเตือนคุณเกี่ยวกับเหตุการณ์ต่างๆ ทันทีที่ตรวจพบผลกระทบ BlackVue ของคุณจะส่งการแจ้งเตือนไปยังโทรศัพท์ของคุณพร้อมกับสแน็ปช็อต\n",
	"Live Event Upload feature automatically_": "คุณสมบัติการอัปโหลดกิจกรรมสดจะอัปโหลดฟุตเทจวิดีโอโดยอัตโนมัติ รวมถึงฟุตเทจก่อนเกิดอุบัติเหตุไปยัง BlackVue Cloud Storage เพื่อให้วิดีโอของคุณปลอดภัย!",
	"*Buffer time varies by model.": "*เวลาบัฟเฟอร์แตกต่างกันไปตามรุ่น",
	Explore: Explore$1,
	"Cloud Storage": "ที่เก็บข้อมูลบนคลาวด์",
	"My Cloud Cameras": "กล้องคลาวด์ของฉัน",
	"My Cloud Cameras Only": "กล้องคลาวด์ของฉันเท่านั้น",
	"BlackVue Live Camera": "กล้องถ่ายทอดสด BlackVue",
	"*For BlackVue Live Cameras_": "*สำหรับ BlackVue Live Cameras เฉพาะกล้องที่แชร์แบบสาธารณะในการตั้งค่ากล้องเท่านั้นที่สามารถดูได้บนแผนที่",
	"*Share Method_": "*วิธีการแชร์: การตั้งค่ากล้อง>ความเป็นส่วนตัว",
	"Once the promotion is canceled_": "เมื่อโปรโมชั่นถูกยกเลิกแล้ว โปรโมชั่นจะไม่ถูกนำมาใช้ซ้ำอีก",
	"It will show_": "มันจะปรากฏขึ้นที่นี่เมื่อพวกเขามีให้บริการ",
	"Deactivate Cloud": "ปิดการใช้งานคลาวด์",
	"Are you sure you want to deactivate_": "คุณแน่ใจหรือไม่ว่าต้องการปิดใช้งาน Cloud สำหรับกล้องนี้",
	"Deactivate : It doesn’t_": "คุณสามารถเปิดใช้งานคลาวด์ได้ตลอดเวลา กล้องสามารถลบออกได้หลังจากการปิดใช้งานเสร็จสิ้น",
	Deactivate: Deactivate$1,
	"*If you made the payment through_": "*หากคุณชำระเงินผ่านแอป โปรดรีสตาร์ทแอป",
	"Connect Dashcam Locally (Wi-Fi)": "เชื่อมต่อ Dashcam ในเครื่อง (Wi-Fi)",
	"Cloud Connection Setting": "การตั้งค่าการเชื่อมต่อคลาวด์",
	"Camera Profile": "โปรไฟล์กล้อง",
	"Camera Settings": "การตั้งค่ากล้อง",
	"Format MicroSD Card": "ฟอร์แมตการ์ด microSD",
	"Remote Firmware Update": "อัพเดตเฟิร์มแวร์ระยะไกล",
	"Remove from Cloud": "ลบออกจากคลาวด์",
	"The location may not be accurate_": "ตำแหน่งอาจไม่ถูกต้องเนื่องจากกล้องไม่ได้เชื่อมต่อกับระบบคลาวด์",
	"The location of the camera cannot be found_": "ไม่พบตำแหน่งของกล้อง โปรดตรวจสอบการตั้งค่าการเชื่อมต่อคลาวด์",
	"Manage\nFLEETA Drive": "จัดการ\nFLEETA ไดรฟ์",
	"Cloud\nConnection": "การเชื่อมต่อ\nคลาวด์",
	"Available on FLEETA App": "ใช้ได้ในแอป FLEETA",
	"Available for Cloud dashcam OR on FLEETA App.": "ใช้ได้กับกล้องติดรถบนคลาวด์หรือในแอป FLEETA",
	"Get started with_": "เริ่มต้นด้วยการทดลองใช้ฟรี 1 เดือน",
	"Experience all of_": "สัมผัสคุณสมบัติพรีเมียมของ FLEETA ฟรีในช่วงทดลองใช้ 1 เดือน\n\nไม่มีข้อผูกมัด—ยกเลิกได้ทุกเวลา",
	"Welcome to FLEETA Webviewer.": "ยินดีต้อนรับสู่ FLEETA Webviewer.",
	"Let FLEETA get_": "ให้ FLEETA รู้จักคุณ",
	"Help improve your_": "ช่วยปรับปรุงประสบการณ์ของคุณโดยการแชร์ข้อมูลบางอย่าง",
	"Business Industry": "อุตสาหกรรมธุรกิจ",
	"Vehicle & Cargo": "ยานพาหนะและสินค้า",
	Compliance: Compliance$1,
	"Would you like to skip?": "คุณต้องการข้ามไปไหม?",
	"What is your business industry?": "ธุรกิจของคุณอยู่ในอุตสาหกรรมใด?",
	"Transportation & Logistics": "การขนส่งและโลจิสติกส์",
	"Rental & Leasing": "การเช่าและลีสซิ่ง",
	"Construction & Building": "การก่อสร้างและอาคาร",
	"Government & Public": "รัฐบาลและสาธารณะ",
	"Facility & Utility Management": "การจัดการสิ่งอำนวยความสะดวกและสาธารณูปโภค",
	Manufacturing: Manufacturing$1,
	"Retail & Wholesale": "การค้าปลีกและค้าส่ง",
	Emergency: Emergency$1,
	Security: Security$1,
	"How many employees do you need to manage?": "คุณต้องจัดการพนักงานกี่คน?",
	"How many vehicles does your company operate?": "บริษัทของคุณมีรถที่ดำเนินงานกี่คัน?",
	"Why do you use a fleet tracking service?": "ทำไมคุณถึงใช้บริการติดตามรถยนต์?",
	"Route Tracking": "การติดตามเส้นทาง",
	"Real-time Monitoring": "การติดตามแบบเรียลไทม์",
	"Incident Detection & Check video": "การตรวจจับเหตุการณ์และตรวจสอบวิดีโอ",
	"Behavior Monitoring & Analysis": "การติดตามพฤติกรรมและการวิเคราะห์",
	"Evaluation & Management": "การประเมินและการจัดการ",
	"Theft Prevention": "การป้องกันการขโมย",
	"Monitoring & Maintenance": "การติดตามและบำรุงรักษา",
	"Verification & Management": "การตรวจสอบและการจัดการ",
	"BlackVue App Use Only": "ใช้เฉพาะกับแอป BlackVue",
	"Your current plan allow_": "แผนปัจจุบันของคุณอนุญาตให้ใช้แอป BlackVue หากต้องการใช้ Web Viewer กรุณาสมัครแผน Fleet (FLEETA)",
	"Learn more about the Fleet_": "เรียนรู้เพิ่มเติมเกี่ยวกับแผนฟลีท (FLEETA)",
	"Special Offer": "ข้อเสนอพิเศษ",
	"For a limited time_": "สำหรับระยะเวลาจำกัด, สนุกกับส่วนลด 50% สำหรับการสมัครใช้งานแผนฟลีทของคุณ",
	"See Discount Details": "ดูรายละเอียดส่วนลด",
	"To subscribe to the Fleet_": "เพื่อสมัครแพ็กเกจแผนกองเรือ โปรดยกเลิกการสมัครใช้งาน BlackVue ในแอปก่อนเพื่อหลีกเลี่ยงการเรียกเก็บเงินซ้ำ",
	"Skip tour": "ข้ามทัวร์",
	"In the cloud_": "ในสภาพแวดล้อมคลาวด์ คุณสามารถเข้าถึงการเล่นย้อนหลัง ดูสด (รวมถึงการดูหลายหน้าจอ) GPS สด และรายงาน ผ่านทาง FLEETA Web Viewer ได้ทั้งหมด",
	"Cloud Storage is_": "ที่เก็บข้อมูลคลาวด์คือที่ที่วิดีโอที่คุณอัปโหลดจะถูกเก็บไว้อย่างปลอดภัยในคลาวด์ อัปโหลดวิดีโอของคุณเพื่อเก็บรักษาไว้อย่างปลอดภัยเป็นเวลานาน",
	"Toggle to switch_": "สลับเพื่อเปลี่ยนแปลงระหว่างแผนที่ / รายการ",
	"In List View_": "ในมุมมองรายการ คุณสามารถดูและจัดการกลุ่ม สมาชิก และข้อมูลเฟิร์มแวร์ได้อย่างง่ายดายในทีเดียว",
	"What is Cloud Storage?": "ที่เก็บข้อมูลคลาวด์คืออะไร?",
	"Cloud Storage Overview": "ภาพรวมที่เก็บข้อมูลคลาวด์",
	"Difference Between FLEETA_": "ความแตกต่างระหว่าง FLEETA ไดรฟ์และอัปโหลดเหตุการณ์สด",
	"FLEETA Drive stores_": "FLEETA ไดรฟ์จัดเก็บวิดีโอที่คุณอัปโหลดด้วยตนเอง",
	"Live Event Upload automatically_": "อัปโหลดเหตุการณ์สดจะเก็บวิดีโอไว้อัตโนมัติเมื่อเกิดเหตุการณ์",
	"Live Event Upload videos_": "วิดีโออัปโหลดเหตุการณ์สดมีระยะเวลาหมดอายุ หากคุณต้องการเก็บไว้นาน ๆ ให้ย้ายไปยัง FLEETA ไดรฟ์",
	"Note: SD Card_": "หมายเหตุ: วิดีโอใน SD Card ที่กำลังเล่นย้อนหลัง",
	"Videos stored on_": "วิดีโอที่เก็บไว้ในการ์ด SD ของคุณสามารถเข้าถึงได้ผ่านเมนูเล่นย้อนหลัง",
	"Set your image_": "ตั้งค่ารูปภาพของคุณโดยใช้กรอบที่ให้มา หลังจากรูปภาพถูกบันทึกแล้ว จะแสดงในการ์ดกล้องและไอคอนมุมมองแผนที่",
	"*Only jpg and_": "*รองรับเฉพาะไฟล์ jpg และ png เท่านั้น",
	"Set as default image": "ตั้งเป็นรูปภาพเริ่มต้น",
	"Camera Details": "รายละเอียดกล้อง",
	"IT & Telecommunications": "ไอทีและโทรคมนาคม",
	"The name must_32": "ชื่อต้องมีความยาวระหว่าง 1 ถึง 32 อักขระ",
	"Unable to display the map.": "ไม่สามารถแสดงแผนที่ได้",
	"The camera location cannot be found_": "ไม่สามารถหาตำแหน่งกล้องได้เนื่องจากการเชื่อมต่อ GPS ไม่ดี",
	"Cloud Cameras": "กล้องคลาวด์",
	"Want to unlock_": "ต้องการปลดล็อกคุณสมบัติการจัดการฟลีทหรือไม่?",
	"*Web subscription only": "*สมัครสมาชิกเว็บเท่านั้น",
	"Uploads event_": "อัปโหลดภาพเหตุการณ์ไปยังที่เก็บข้อมูลคลาวด์ทันทีที่เกิดเหตุการณ์",
	"Starts a conversation_": "เริ่มการสนทนากับคนขับโดยใช้ลำโพงและไมโครโฟนของกล้องบันทึกภาพในรถ",
	"Remotely check_": "ตรวจสอบระดับแบตเตอรี่และสถานะจากระยะไกลผ่านคลาวด์",
	"Receive a voice_": "รับการแจ้งเตือนด้วยเสียงและการแจ้งเตือนหากเวลาขับขี่เกินขีดจำกัด",
	"View your_": "ดูบันทึกการขับขี่ของคุณบนแผนที่",
	"View speed, event_": "ดูความเร็ว ประเภทเหตุการณ์ และเล่นวิดีโอที่เกี่ยวข้องโดยตรงบนแผนที่",
	"FLEETA Tracking exclusive_": "FLEETA Tracking มีคุณสมบัติพิเศษสำหรับผู้ใช้งานระดับสูงและธุรกิจ (ผู้ใช้และกล้องหลายตัว, การกั้นพื้นที่ภูมิศาสตร์, เป็นต้น).",
	"Cloud Cameras per Account": "กล้องคลาวด์ต่อบัญชี",
	"Connect Dashcam Locally_": "เชื่อมต่อกล้องติดรถยนต์แบบใช้งานท้องถิ่น (Wi-Fi) (เล่นย้อนหลัง, ดาวน์โหลด, ดูสด)",
	"Available with_": "สามารถใช้งานร่วมกับแบตเตอรี่ BlackVue",
	"Cloud Battery": "แบตเตอรี่คลาวด์",
	"Driving Reports": "รายงานการขับขี่",
	"Video on Map": "วิดีโอบนแผนที่",
	"Multi Live View (Fleeta Web Viewer)": "มัลติไลฟ์วิว (FLEETA เว็บวิวเวอร์)",
	"Enter a number": "กรอกตัวเลข",
	"Permission required.": "ต้องการสิทธิ์",
	"Please contact_": "กรุณาติดต่อเจ้าของเพื่อขอความช่วยเหลือ",
	"Access not available": "ไม่สามารถเข้าถึงได้",
	"This file cannot be deleted now.": "ไม่สามารถลบไฟล์นี้ได้ในตอนนี้",
	"Please try again later.": "กรุณาลองใหม่อีกครั้งในภายหลัง",
	"Permission required.\nPlease_": "ต้องการสิทธิ์การเข้าถึง。\nกรุณาติดต่อเจ้าของเพื่อขอความช่วยเหลือ.",
	"Cloud Storage is disconnected_": "ที่เก็บข้อมูลคลาวด์ไม่ได้เชื่อมต่อ กรุณาตรวจสอบการเชื่อมต่อ",
	"Manage the plan_": "จัดการแผนการเพื่อเรียกคืนกล้อง",
	"Notify the owner_": "แจ้งเจ้าของให้จัดการแผน",
	"Access Restricted:_": "การเข้าถึงถูกจำกัด: การสมัครสมาชิกหมดอายุ",
	"Access is currently_": "ขณะนี้ไม่สามารถเข้าถึงได้เนื่องจากการสมัครใช้งานหมดอายุ",
	"Please contact your owner_": "กรุณาติดต่อเจ้าของเพื่อแก้ไขปัญหานี้",
	"Access will be_": "การเข้าถึงจะถูกคืนสภาพเมื่อต่ออายุการสมัครใช้งาน",
	"Cloud is disconnected_": "ที่เก็บข้อมูลคลาวด์ถูกตัดการเชื่อมต่อ \nโปรดตรวจสอบการเชื่อมต่อ",
	"Connect to Cloud with_": "เชื่อมต่อกับที่เก็บข้อมูลคลาวด์ด้วย FLEETA APP",
	"Using Wi-Fi Hotspot": "การใช้งาน Wi-Fi Hotspot",
	Important: Important$1,
	"Pre-Event buffer_": "การบันทึกบัฟเฟอร์ก่อนเหตุการณ์ถูกปิดใช้งานในโหมดนี้",
	"connectivity is_": "การเชื่อมต่อถูกจำกัดในโหมดนี้",
	"video upload starts_": "การอัปโหลดวิดีโอจะเริ่มหลังจากการบันทึกเสร็จสิ้น",
	"Power Saving": "การประหยัดพลังงาน",
	"In all modes_": "ในทุกโหมด การตรวจพบการกระแทกจะทำให้เกิดการบันทึกวิดีโอเหตุการณ์",
	"Battery Protection setting _": "การตั้งค่าการป้องกันแบตเตอรี่ต้องเปิดอยู่",
	"At least one of_": "ต้องเปิดใช้งานอย่างน้อยหนึ่งในการตั้งค่าต่อไปนี้",
	or: or$1,
	"For BlackVue battery users": "สำหรับผู้ใช้แบตเตอรี่ BlackVue",
	"we recommend setting_": "เราแนะนำให้ตั้งค่าการตัดแรงดันไฟฟ้าให้เป็นค่าต่ำสุดเพื่อการใช้งานแบตเตอรี่สูงสุด",
	"No videos were found.": "ไม่พบวิดีโอ",
	"Try different filter_": "ลองใช้ตัวกรองอื่นหรือรีเซ็ตตัวกรอง",
	"Not avaliable with_": "ไม่สามารถใช้ได้กับกล้องปัจจุบัน",
	"Overlays a detection_": "วางกล่องตรวจจับทับภาพถ่ายสดและบันทึกจากกล้อง DMS",
	"A minute of_": "วิดีโอจากกล้องหน้าหนึ่งนาทีจะประมาณ",
	"System voice guidance": "คำแนะนำเสียงของระบบ",
	"Recording trigger": "ทริกเกอร์การบันทึก",
	"Remote Button (Optional)": "ปุ่มรีโมท (ตัวเลือก)",
	"Remote button settings_": "ไม่สามารถเปลี่ยนการตั้งค่าปุ่มรีโมตผ่านการเชื่อมต่อคลาวด์ได้ หากต้องการแก้ไขการตั้งค่าเหล่านี้ ให้ไปที่ กล้อง > เชื่อมต่อแบบโลคัล > การตั้งค่ากล้อง",
	"No Registered Device": "ไม่มีอุปกรณ์ที่ลงทะเบียน",
	"Subscription process is complete": "กระบวนการสมัครสมาชิกเสร็จสิ้น",
	"Now, go back to_": "ตอนนี้กลับไปที่แอป FLEETA ลงชื่อเข้าใช้บัญชีของคุณและเริ่มสนุกกับบริการ",
	"You can check the upload progress": "คุณสามารถตรวจสอบความคืบหน้าของการอัปโหลดในแท็บ ที่เก็บข้อมูลคลาวด์ > FLEETA ไดรฟ์",
	"SIM card must be inserted in_": "ต้องใส่ซิมการ์ดในกล้องเพื่อเริ่มใช้งานคลาวด์",
	"Active until:": "ใช้งานได้จนถึง:",
	Subscribe: Subscribe$1,
	"Camera PSN": "กล้อง PSN",
	"BlackVue Sim Free Trial Started!": "BlackVue Sim ทดลองใช้ฟรีเริ่มต้นแล้ว!",
	"Enjoy a free period to use your SIM_": "เพลิดเพลินกับการใช้ซิมของคุณฟรีโดยไม่ต้องสมัครสมาชิก!",
	"You can stay connected during the trial_": "คุณสามารถเชื่อมต่อได้ตลอดช่วงทดลองใช้งาน แต่อย่าลืมว่า:",
	"Complete your subscription before the trial_": "สมัครสมาชิกของคุณให้เสร็จสิ้นก่อนช่วงทดลองใช้งานจะสิ้นสุดลงเพื่อใช้ซิมต่อไป",
	"If you don't subscribe by the end of the trial_": "หากคุณไม่สมัครรับข้อมูลก่อนสิ้นสุดช่วงทดลองใช้ บริการ SIM ของคุณจะถูกปิดใช้งาน",
	"Save Event Videos_": "บันทึกวิดีโอเหตุการณ์ไปยังที่เก็บข้อมูลบนคลาวด์แบบเรียลไทม์!",
	"Note: Deleting your account doesn’t cancel": "หมายเหตุ: การลบบัญชีของคุณไม่ได้ยกเลิกการสมัครใช้งาน หากต้องการยกเลิก ให้ไปที่ บัญชี > การสมัครใช้งาน ในตัวดูเว็บ FLEETA",
	"Available only on FLEETA App for_": "ใช้ได้เฉพาะบนแอป FLEETA สำหรับรุ่นนี้",
	"The cloud is deactivated": "คลาวด์ถูกปิดใช้งาน",
	"Please add a camera with FLEETA_": "กรุณาเพิ่มกล้องด้วยแอป FLEETA เพื่อใช้งานฟีเจอร์นี้",
	"Upload videos to FLEETA_": "อัปโหลดวิดีโอไปยัง FLEETA ไดรฟ์ และเก็บรักษาไว้อย่างปลอดภัย!",
	"You have no assigned camera_": "คุณไม่มีกล้องที่ได้รับมอบหมาย\nโปรดติดต่อเจ้าของเพื่อขอมอบหมาย",
	"Camera notification settings": "การตั้งค่าการแจ้งเตือนกล้อง",
	Vehicle: Vehicle$1,
	"App Download": "ดาวน์โหลดแอป",
	"Have a problem with_": "มีปัญหากับการสมัครสมาชิกหรือไม่?",
	"Restore Purchase": "กู้คืนการซื้อ",
	"Battery Pairing": "การจับคู่แบตเตอรี่",
	"Playback\nLive View": "การเล่น/\nLive View",
	"Remote Playback": "การเล่นระยะไกล",
	"Cloud connection settings": "การตั้งค่าการเชื่อมต่อคลาวด์",
	"Go to settings": "ให้ไปที่ การตั้งค่า",
	"Only cloud cameras that_": "เฉพาะกล้องคลาวด์ที่ผู้ใช้เลือกที่จะแชร์สาธารณะเท่านั้นที่จะแสดงบนแผนที่",
	"Live Broadcast Cameras": "กล้องถ่ายทอดสด",
	"*Live Broadcast Cameras_": "*กล้องถ่ายทอดสดคือกล้องคลาวด์ที่ผู้ใช้ตั้งค่าให้ถ่ายทอดสด",
	"Only cloud cameras_": "กล้องคลาวด์ที่ผู้ใช้เลือกที่จะถ่ายทอดสดเท่านั้นที่จะแสดงบนแผนที่"
};

var Dashboard = "Bảng điều khiển";
var Account = "Tài khoản";
var Help = "Trợ giúp";
var Mac = "Mac";
var Windows = "Windows";
var Admin = "Quản trị viên";
var Driver = "Người lái xe";
var Cameras = "Camera";
var Manage = "Quản lý";
var Clear = "Thông thoáng";
var Show = "Chỉ";
var GB = "{{a}}GB";
var _section = "phần.";
var Name = "Tên";
var Password = "Mật khẩu";
var Cancel = "Hủy";
var Members = "Thành viên";
var Groups = "Nhóm";
var Role = "Vai trò";
var Group = "Nhóm";
var Status = "Trạng thái";
var nPM = "{{a}}CH";
var nAM = "{{a}}SA";
var Newest = "Mới nhất";
var Oldest = "Cũ nhất";
var Accepted = "Đã được chấp nhận";
var Pending = "Đang chờ";
var Expired = "Đã hết hạn";
var All = "Tất cả";
var Delete_ = "Xóa {{a}}";
var Delete = "Xóa";
var Rename = "Đổi tên";
var Add = "Thêm";
var OK = "OK";
var Remove = "Xóa";
var Files = "Tập tin";
var Features = "Tính năng";
var Settings = "Thiết lập";
var Upload = "Tải lên";
var Privacy = "Quyền riêng tư";
var Done = "Xong";
var Subscription = "Sự đăng ký";
var Submasters = "quản trị viên";
var Users = "lái xe";
var Change = "Thay đổi";
var Method = "Phương thức";
var Details = "Thông tin camera";
var Confirm = "Xác nhận";
var Address = "Địa chỉ";
var Country = "Quốc gia";
var State = "Thành phố";
var ZIP = "ZIP";
var Pricing = "Mức giá";
var Free = "Free";
var Smart = "Smart";
var Fleet = "Fleet";
var Subscrubed = "Đã đăng ký";
var January = "Tháng một";
var February = "Tháng hai";
var March = "Tháng Ba";
var April = "Tháng tư";
var May = "Tháng năm";
var June = "Tháng sáu";
var July = "Tháng bảy";
var August = "Tháng tám";
var September = "Tháng Chín";
var October = "Tháng Mười";
var November = "Tháng mười một";
var December = "Tháng mười hai";
var Blackvuecloud_ = "www.blackvuecloud.com";
var Support = "Support";
var Community = "Community";
var FAQ = "FAQ";
var Developers = "Developers";
var Facebook = "Facebook";
var Twitter = "Twitter";
var Instagram = "Instagram";
var Youtube = "Youtube";
var Linkedin = "Linkedin";
var Downloads = "Tải xuống";
var Unauthorized = "Không được cấp phép";
var none = "Không có gì";
var Email = "E-mail";
var Customers = "Customers";
var Home = "Home";
var Plan = "Plan";
var New = "New";
var Unsubscribed = "Unsubscribed";
var Edit = "Edit";
var month = "month";
var months = "months";
var Continue = "Continue";
var Back = "Trở lại";
var Master = "Owner";
var Develop = "Developers";
var $9 = "$9";
var $15 = "$15";
var $10 = "$10";
var mo = "tháng";
var City = "Thành phố";
var Charge = "Tính phí";
var subscribe = "Đăng ký";
var search = "Tìm kiếm";
var invalid_number = "Đây không phải là số thẻ tín dụng hợp lệ";
var invalid_expiry_month = "Tháng hết hạn của thẻ không hợp lệ";
var invalid_expiry_year = "Năm hết hạn của thẻ không hợp lệ";
var invalid_cvc = "Mã bảo mật của thẻ không hợp lệ";
var incorrect_number = "Số thẻ không chính xác";
var incomplete_number = "Số thẻ không đầy đủ";
var incomplete_cvc = "Mã bảo mật của thẻ không đầy đủ";
var incomplete_expiry = "Ngày hết hạn của thẻ chưa được hoàn thành";
var expired_card = "Thẻ đã hết hạn";
var incorrect_cvc = "Mã bảo mật của thẻ không chính xác";
var incorrect_zip = "Không xác thực được mã zip của thẻ";
var invalid_expiry_year_past = "Năm hết hạn của thẻ là trong quá khứ";
var card_declined = "Thẻ đã bị từ chối";
var missing = "Không có thẻ nào của khách hàng bị tính phí";
var processing_error = "Đã xảy ra lỗi khi xử lý thẻ";
var Paypal = "Paypal";
var iOS = "iOS";
var Android = "Android";
var Total = "Tổng";
var And = "và";
var Camera = "Camera";
var Yes = "Ok";
var No = "No";
var News = "Tin tức";
var Notifications = "Thông báo";
var MPH = "MPH";
var Firmware = "Vi chương trình";
var Basic = "Cơ bản";
var Resolution = "Độ phân giải";
var Brightness = "Độ sáng";
var Recording = "Ghi";
var Highest = "Cao nhất";
var High = "Cao";
var Normal = "Bình thường";
var Sensitivity = "Độ nhạy";
var Volume = "Âm lượng";
var Close = "Close";
var Cloud = "Cloud";
var Public = "Public";
var Front = "Trước";
var Rear = "Sau";
var Play = "Phát";
var Stop = "Dừng";
var Pause = "Tạm dừng";
var Time = "Time";
var System = "Hệ thống";
var Event = "Sự kiện";
var Parking = "Đỗ xe";
var Color = "Màu sắc";
var Exit = "Thoát";
var Save = "Lưu";
var Impact = "Ảnh hưởng";
var Unlimited = "Không giới hạn";
var Default = "Mặc định";
var Version = "Phiên bản";
var Language = "Ngôn ngữ";
var Notification = "Thông báo";
var Multiple = "Nhiều";
var Range = "Phạm vi";
var Download = "Tải xuống";
var Manual = "Hướng dẫn sử dụng";
var Satellite = "Vệ tinh";
var Tutorials = "Hướng dẫn";
var Filter = "Bộ lọc";
var Sun = "CN";
var Mon = "Thứ 2";
var Tue = "Thứ 3";
var Wed = "Thứ 4";
var Thu = "Thứ 5";
var Fri = "Thứ 6";
var Sat = "Thứ 7";
var Dates = "Ngày";
var Routes = "(Các) tuyến";
var Opacity = "độ mờ";
var Entry = "Lối vào";
var Owner = "Owner";
var Undetected = "không bị phát hiện";
var Distracted = "Mất tập trung";
var Drowsy = "Drowsy";
var Calling = "Calling";
var Smoking = "Smoking";
var Permissions = "Quyền";
var Private = "Riêng tư";
var Entering = "Đang vào";
var Exiting = "Đang ra";
var Acceleration = "Tăng tốc";
var Passing = "Đang đi qua";
var Overspeed = "Quá tốc độ";
var Recipients = "Người nhận";
var Send = "Gửi";
var Note = "Lưu ý";
var Video = "Video";
var Advanced = "Nâng cao";
var Voice = "Thoại";
var Days_ = "Ngày";
var Mute = "Tắt tiếng";
var UnMute = "Bật tiếng";
var Discard = "Hủy";
var Report = "Report";
var Individual = "Cá nhân lái xe muốn an tâm trên lộ trình? Chủ doanh nghiệp cần một giải pháp theo dõi và bảo mật xe đơn giản?";
var Subscribed = "Đã đăng ký";
var Geofence = "Rào chắn địa lý";
var Driving = "Đang lái xe";
var Idling = "Chạy không tải";
var Distance = "Quãng đường";
var Parked = "Parked";
var Speed = "Tốc độ";
var Highest_2 = "Cao nhất";
var Average = "Trung bình";
var Geofences = "Rào chắn địa lý";
var Move = "Di chuyển";
var Connected = "Đã kết nối";
var Individual_ = "Cá nhân";
var Always = "Luôn luôn";
var Low = "Thấp";
var Medium = "Trung bình";
var High_2 = "Cao";
var Flip = "Lật";
var Previous = "Khung trước đó";
var Next = "Kế";
var Expand = "Mở rộng";
var Collapse = "Thu gọn";
var More = "Thêm";
var Multi = "Nhiều";
var Safe = "An toàn";
var Reckless = "Liều lĩnh";
var Inattentive = "Không chú ý";
var List = "Danh sách";
var Usage = "Sử dụng";
var Profile = "Hồ sơ";
var Fullscreen = "Toàn màn hình";
var Upgrade = "Nâng cấp";
var Management = "Quản lý";
var Day = "Ngày";
var Month = "tháng";
var Later = "Để sau";
var ICCID = "ICCID";
var Resubscribe = "Đăng ký lại";
var plan = "gói";
var USD = "USD";
var etc_ = "Khác:";
var Available = "Có sẵn";
var Used = "Đã sử dụng";
var Cancelled = "Đã hủy";
var Terminated = "Đã chấm dứt";
var Sort = "Sắp xếp";
var Bonus = "Tặng thêm";
var incomplete_zip = "Không xác thực được mã zip của thẻ";
var Upgrades = "Cập nhật";
var OR = "HOẶC";
var Undo = "Hủy bỏ";
var Invoice = "Hóa đơn";
var data = "Dữ liệu";
var Popular = "Popular";
var Mask = "Bỏ khẩu trang";
var DMS = "Giám sát Tình trạng Lái xe (DMS)";
var Extreme = "Thường trực";
var OFF = "Tắt";
var Threshold = "Ngưỡng";
var Drowsiness = "Buồn ngủ";
var Direct = "Trực tiếp";
var Remote = "Từ xa";
var Update = "Cập nhật";
var Option = "Tùy chọn";
var Required = "Bắt buộc";
var Optional = "Tùy chọn";
var Others = "Khác";
var Stay = "Ở lại";
var Mask_2 = "Mask";
var Low_2 = "Low";
var Medium_2 = "Medium";
var High_3 = "High";
var Highest_3 = "Highest";
var Extreme_2 = "Extreme";
var Private_2 = "Private";
var Lite = "Lite";
var Bitrate = "Bitress";
var hours = "Giờ";
var Expires = "Hết hạn";
var Check = "Kiểm tra";
var Saving = "Đang lưu";
var Now = "Bây giờ";
var Beep = "Âm thanh cảnh báo";
var Unpair = "Bỏ cặp";
var Detected = "Đã phát hiện";
var Promotion = "Khuyến mãi";
var Notice = "Cập nhật";
var Explore = "Khám phá";
var Deactivate = "Vô hiệu hóa";
var Compliance = "Tuân thủ";
var Manufacturing = "Sản xuất";
var Emergency = "Khẩn cấp";
var Security = "Bảo mật";
var Important = "Quan trọng";
var or = "hoặc";
var Subscribe = "Đặt mua";
var Vehicle = "phương tiện";
var vi = {
	Dashboard: Dashboard,
	"Payment & Subscriptions": "Thanh toán & Đăng ký",
	"Fleet Management": "Quản lý đội xe",
	"Available to master": "Có sẵn cho chủ xe",
	"Available to Fleet_": "Có sẵn cho người dùng Gói đội xe",
	Account: Account,
	"Log out": "Đăng xuất",
	"© 2019 Pittasoft_": "© 2019 Pittasoft Co. Ltd",
	"Privacy policy": "Chính sách quyền riêng tư",
	"Terms of service": "Điều khoản Dịch vụ",
	Help: Help,
	"App store": "App store",
	"Google Play": "Google Play",
	Mac: Mac,
	Windows: Windows,
	"Free Plan": "Free Plan",
	"Basic Plan": "Basic Plan",
	"Smart Plan": "Smart Plan",
	Admin: Admin,
	Driver: Driver,
	"Period : December 3, 2024 ~ May 31, 2025": "Thời gian: 3 tháng 12 năm 2024 ~ 31 tháng 5 năm 2025",
	Cameras: Cameras,
	"n of n": "{{a}} của {{b}}",
	Manage: Manage,
	"Upgrade Plan": "Nâng cấp gói",
	"Add more cameras_": "Thêm nhiều camera hơn, quản lý đội xe của bạn và hơn thế nữa…",
	"Usage statistics": "Thống kê sử dụng",
	"All cameras": "Tất cả camera",
	Clear: Clear,
	Show: Show,
	"Live views": "Xem trực tiếp từ xa",
	"nh:nm:ns": "{{a}}h:{{b}}m:{{c}}s",
	"Video plays and_": "Phát và tải xuống video",
	"Space available": "Dung lượng khả dụng",
	GB: GB,
	"n%": "{{a}}%",
	"BlackVue app for_": "Ứng dụng BlackVue dành cho iOS và Android",
	"BlackVue viewer for_": "Ứng dụng xem camera BlackVue dành cho Mac và Windows",
	"Welcome to fleet": "Chào mừng đến với đội xe",
	"A few things_": "Một số điều bạn có thể mong đợi trên đường đi:",
	"You can watch_": "Bạn có thể xem video từ camera mà bạn được chỉ định trong ứng dụng BlackVue hoặc ứng dụng xem camera trên máy tính cá nhân.",
	"If the master_deletes": "Nếu chủ đội xe xóa tài khoản của mình, tài khoản của bạn cũng sẽ bị xóa.",
	"If the masters_Fleet": "Nếu đăng ký Gói đội xe của chủ đội xe hết hạn, bạn vẫn có thể truy cập tài khoản của mình ở chế độ chỉ đọc.",
	"You have to_": "Bạn phải đăng ký một tài khoản khác để thêm camera cá nhân.",
	"The Payments &_": "Các phần Thanh toán & Đăng ký và Quản lý đội xe chỉ có thể được truy cập từ chủ đội xe.",
	"You can manage_": "Bạn có thể quản lý nhóm đội xe của mình trong",
	"_Fleet management": "Quản lý đội xe",
	_section: _section,
	"The Payments_section-": "Phần Thanh toán & Đăng ký chỉ có thể được truy cập từ chủ đội xe.",
	"Youre almost there": "Bạn đã gần tới nơi",
	"Finish account setup": "Hoàn tất thiết lập tài khoản",
	"Install and log_": "Cài đặt và đăng nhập vào Ứng dụng BlackVue hoặc ứng dụng xem camera trên máy tính cá nhân của bạn",
	"Download on the_": "Tải xuống từ App Store",
	"GET IT ON_": "TẢI XUỐNG từ Google Play",
	"Download for Mac": "Tải xuống cho Mac",
	"Download for Windows": "Tải xuống cho Windows",
	"Add your camera_": "Thêm camera của bạn trong Ứng dụng BlackVue hoặc ứng dụng xem camera trên máy tính cá nhân của bạn",
	"Start managing your_": "Bắt đầu quản lý đội xe của bạn và theo dõi số liệu thống kê sử dụng tại đây",
	"Cancelled Fleet Plan_": "Gói Đội xe bị hủy vào {{date}}",
	"The new plan_": "Gói mới sẽ có hiệu lực vào cuối chu kỳ thanh toán hiện tại của bạn.",
	"Profile photo": "Ảnh hồ sơ",
	Name: Name,
	"E-mail address": "Địa chỉ email",
	Password: Password,
	"Last changed_": "Thay đổi lần cuối {{a}}",
	"Change password": "Đổi mật khẩu",
	"Delete account": "Xóa tài khoản",
	Cancel: Cancel,
	"Current password": "Mật khẩu hiện tại",
	"New password": "Mật khẩu mới",
	"Confirm new password": "Xác nhận mật khẩu mới",
	"Password changed": "Mật khẩu đã được thay đổi",
	"Reason for deletion_": "Lý do xóa (tùy chọn)",
	"Account password": "Mật khẩu tài khoản",
	Members: Members,
	Groups: Groups,
	"+ Invite member": "+ Mời thành viên",
	"Name, Email": "Tên, Email",
	Role: Role,
	Group: Group,
	"Date invited": "Ngày mời",
	Status: Status,
	"Group n": "Nhóm {{a}}",
	nPM: nPM,
	nAM: nAM,
	Newest: Newest,
	Oldest: Oldest,
	"Name, email or_": "Tên, email hoặc nhóm",
	Accepted: Accepted,
	Pending: Pending,
	Expired: Expired,
	All: All,
	"No results": "Không có kết quả",
	"Try different keywords": "Thử các từ khóa khác",
	"Try changing or_": "Thử thay đổi hoặc xóa bộ lọc",
	"Remove all filters": "Xóa tất cả bộ lọc",
	"Invite member": "Mời thành viên",
	"Send invite": "Gửi lời mời",
	"You have reached_": "Bạn đã đạt đến giới hạn 10 chủ đội xe phụ. Bạn có thể tiếp tục mời người dùng.",
	Delete_: Delete_,
	"Are you sure_delete": "Bạn có chắc chắn muốn xóa thành viên này và tài khoản của thành viên này?",
	Delete: Delete,
	Rename: Rename,
	"No submaster yet": "Chưa có chủ đội xe phụ",
	"You can add_": "Bạn có thể thêm 1 chủ đội xe phụ cho mỗi nhóm",
	"No cameras yet": "Chưa có camera",
	"Add cameras first_": "Thêm camera trước, sau đó chỉ định người dùng",
	"Name or email": "Tên hoặc email",
	"Add submaster": "Thêm chủ đội xe phụ",
	Add: Add,
	"Add camera": "Thêm camera",
	"n of n selected": "{{a}} trên {{b}} đã được chọn",
	"No cameras available": "Không có camera",
	"Most likely reasons_": "Lý do có thể là:",
	"All cameras were_": "Tất cả camera đã được thêm vào các nhóm khác.",
	"You can remove_": "Bạn có thể xóa camera khỏi các thiết bị khác và thêm chúng vào nhóm này.",
	"No cameras were_": "Không có camera nào được thêm vào tài khoản của bạn.",
	"You can add_cameras": "Bạn có thể thêm camera trong ứng dụng BlackVue hoặc ứng dụng xem camera trên máy tính cá nhân của bạn.",
	OK: OK,
	"Rename group": "Đổi tên nhóm",
	"Are you sure_group": "Bạn có chắc chắn muốn xóa nhóm này?",
	"Edit Mobile app_": "Chỉnh sửa quyền đối với ứng dụng xem camera dành cho thiết bị di động/máy tính cá nhân",
	Remove: Remove,
	"n of n users": "{{a}} trên {{b}} người dùng",
	"Youve reached the_": "Bạn đã đạt đến giới hạn người dùng tối đa cho mỗi camera",
	"Remove user": "Xóa người dùng",
	"Add user": "Thêm người dùng",
	"+ Add group": "+ Thêm nhóm",
	"Add group": "Thêm nhóm",
	"Group or submaster": "Nhóm hoặc chủ đội xe phụ",
	"+ Add": "+ Thêm",
	"of max selected": "{{a}} trên tối đa {{b}} đã được chọn",
	"Mobile app/desktop_": "Quyền đối với ứng dụng xem camera dành cho thiết bị di động/máy tính cá nhân",
	Files: Files,
	Features: Features,
	Settings: Settings,
	Upload: Upload,
	"Download and Playback_Cloud": "Tải xuống và phát lại từ bộ nhớ đám mây",
	"Download and Playback_SD": "Tải xuống và Phát lại từ Thẻ SD",
	"Live view": "Live View",
	"Geo Fencing": "Vùng địa lý",
	"Drive Reports": "Báo cáo lái xe",
	"Firmware Settings": "Thiết lập vi chương trình",
	"Push Notifications": "Thông báo bấm để xem",
	"Event Auto Upload": "Tự động tải sự kiện trực tuyến",
	Privacy: Privacy,
	Done: Done,
	"Payment method": "Phương thức thanh toán",
	"Change payment method": "Thay đổi phương thức thanh toán",
	Subscription: Subscription,
	"Space used": "Dung lượng đã sử dụng",
	"Next billing_": "Thanh toán tiếp theo {{a}} {{b}}",
	"You manage_available": "Bạn quản lý {{a}} trong tổng số {{b}} có sẵn trong gói của mình",
	Submasters: Submasters,
	Users: Users,
	Change: Change,
	"No transactions yet_": "Bạn đã đăng ký Gói Miễn phí. Chưa có giao dịch nào",
	"No transactions to_": "Không có giao dịch nào để hiển thị.<br/>Nếu bạn đang tìm kiếm lịch sử giao dịch trên nền tảng khác (ví dụ: iOS, Android, PayPal), bạn có thể tìm lịch sử tại trang đăng ký nền tảng của riêng mình.",
	"of nGB_": "{{a}} trên {{b}}GB ({{c}}%)",
	"Smart Plan users_": "Người dùng Gói Thông Minh có thể đổi gói đăng ký hoặc số lượng camera thông qua ứng dụng di động BlackVue",
	"Transaction history": "Lịch sử giao dịch",
	"Date": "Ngày",
	"Amount, USD": "Số tiền, USD",
	Method: Method,
	Details: Details,
	"iOS in-app_": "iOS in-app purchase/Android in-app purchase",
	"Change the number_": "Thay đổi số lượng camera",
	"You manage_cameras": "You manage {{a}} cameras of {{b}} available on your plan",
	"Extra cameras": "Camera thêm",
	"Total due_": "Tổng số tiền đến hạn",
	"available on your_": "của {{a}} có sẵn trong gói của bạn",
	"Cancel Fleet Plan": "Hủy Fleet Plan",
	"This will cancel_": "Việc này sẽ hủy đăng ký Gói Đội Xe của bạn. Bạn sẽ hạ cấp xuống Gói Miễn Phí vào cuối chu kỳ thanh toán của mình.",
	"Reason for cancellation_": "Lý do hủy (tùy chọn)",
	"Not now": "Không phải bây giờ",
	Confirm: Confirm,
	"Cardholder name": "Tên chủ thẻ",
	"Card name": "Tên thẻ",
	"MM/YY": "Tháng/Năm",
	Address: Address,
	Country: Country,
	State: State,
	ZIP: ZIP,
	Pricing: Pricing,
	"You are subscribed_": "Bạn đã đăng ký gói Miễn phí.",
	"With Alert Push_": "Với Thông báo Đẩy Cảnh báo, xem Trực tiếp Từ xa có giới hạn và lưu trữ đám mây.",
	Free: Free,
	Smart: Smart,
	Fleet: Fleet,
	"Get started for_": "Bắt đầu sử dụng miễn phí, không cần thẻ tín dụng. \n Bao gồm Thông báo Đẩy Cảnh báo, Xem Trực Tiếp Từ xa có giới hạn và lưu trữ đám mây.",
	Subscrubed: Subscrubed,
	"Features included:": "Các tính năng đi kèm:",
	"Get unlimited Remote_": "Xem Trực Tiếp Từ xa không giới hạn, Phát lại qua đám mây và quản lý tối đa {{a}} camera.",
	"BlackVue Fleet Tracking_": "Các tính năng độc quyền Theo Dõi Đội Xe của BlackVue dành cho người dùng chuyên nghiệp cũng như doanh nghiệp (Nhiều người dùng và camera, định vị địa lý, v.v.)",
	"Try 1 Month Free": "Miễn phí dùng thử 1 tháng",
	"Log in": "Đăng nhập",
	"Remember me": "Ghi nhớ tôi",
	"Forgot password?": "Quên mật khẩu?",
	"Reset password": "Đặt lại mật khẩu",
	"Enter email address_": "Nhập địa chỉ email đã đăng ký và\n chúng tôi sẽ gửi cho bạn liên kết để đặt lại mật khẩu.",
	"Send reset password_": "Gửi email đặt lại mật khẩu",
	"Back to login": "Quay lại đăng nhập",
	"Check your email": "Kiểm tra thư điện tử của bạn",
	"Weve sent an_": "Chúng tôi đã gửi email đến {{a}} kèm theo một liên kết để xác nhận địa chỉ email của bạn.",
	"Resend email": "Gửi lại email",
	January: January,
	February: February,
	March: March,
	April: April,
	May: May,
	June: June,
	July: July,
	August: August,
	September: September,
	October: October,
	November: November,
	December: December,
	"Sign up": "Tạo tài khoản",
	"First name": "Tên",
	"Last name": "Họ",
	"Create a password": "Tạo mật khẩu",
	"5 or more_": "5 ký tự trở lên",
	"Sign up and_": "Đăng ký và tiếp tục",
	"I agree to_": "Tôi đồng ý với %@, %@, %@ và %@.",
	"Subscribe to newsletter": "Đăng ký nhận bản tin",
	"1 month free trial_": "1 tháng dùng thử miễn phí",
	"Dont have an_": "Không có tài khoản?",
	"Thank you for_": "Cảm ơn bạn đã đăng ký BlackVue Cloud. Vui lòng xác nhận địa chỉ email của bạn.",
	"Confirm email": "Xác nhận email",
	"If you didnt_": "Nếu bạn không đăng ký tài khoản này, bạn có thể bỏ qua email này.",
	Blackvuecloud_: Blackvuecloud_,
	"invited you to_": "{{a}} đã mời bạn tham gia đội xe của anh ấy với tư cách là chủ đội xe phụ.",
	"Accept invitation": "Chấp nhận lời mời",
	"Invite expires on_": "Lời mời hết hạn vào dd mm yy.",
	"Your Fleet Management_": "Tài khoản Quản lý đội xe của bạn được đăng ký với {{a}} đã bị xóa bởi %@.",
	"If you believe_": "Nếu bạn cho rằng đây là lỗi, vui lòng liên hệ với bộ phận hỗ trợ khách hàng của chúng tôi: cs@blackvue.com.",
	Support: Support,
	"Help center": "Trung tâm Trợ giúp",
	Community: Community,
	"Getting started": "Bắt đầu",
	FAQ: FAQ,
	Developers: Developers,
	"Cloud API": "Cloud API",
	"Fleet SDK": "Fleet SDK",
	"Follow us": "Follow us",
	Facebook: Facebook,
	Twitter: Twitter,
	Instagram: Instagram,
	Youtube: Youtube,
	Linkedin: Linkedin,
	"BlackVue apps": "BlackVue apps",
	"Camera registraiton": "Đăng ký camera",
	"Two-way voice_": "Giao tiếp bằng giọng nói hai chiều",
	"Live GPS": "GPS trực tiếp",
	"Event live auto_": "Tự động tải sự kiện trực tuyến",
	"Event file auto_": "Tự động tải lên tệp s.kiện",
	"Compatible with_": "Tương thích với các dòng sản phẩm DR650GW, DR650S",
	"Not compatible with_": "Không tương thích với các dòng sản phẩm DR650GW, DR650S",
	"More cameras": "Nhiều camera hơn",
	"More users": "More users",
	"Roles and permissions": "Roles and permissions",
	"More Cloud Storage": "Thêm bộ nhớ đám mây",
	"Multi Live view_": "Multi Live View (Web)",
	"Longer GPS Tracking": "Longer GPS Tracking",
	"Geo Fence setup_": "Geo Fence setup (PC viewer) and alerts (PC viewer and app)",
	"Changes saved": "Đã lưu các thay đổi",
	"Group added": "Đã thêm nhóm",
	"Member added": "Đã thêm thành viên",
	"Group deleted": "Nhóm đã bị xóa",
	"Member deleted": "Thành viên đã bị xóa",
	"Group renamed": "Nhóm đã được đổi tên",
	"Submaster added": "Đã thêm chủ đội xe phụ",
	"Camera added": "Đã thêm camera",
	"User added": "Đã thêm người dùng",
	"Users added": "Đã thêm các người dùng",
	Downloads: Downloads,
	"The BlackVue App_": "The BlackVue App and Viewer let you use your BlackVue camera to its full potential. Whether on mobile or on home computer, BlackVue gives you the tools to fully enjoy your dashcam's functions.",
	"Compatible with all_": "Compatible with all Wi-Fi enabled BlackVue models.",
	"Supports all BlackVue_": "Supports all BlackVue models to date.",
	"confirm new password": "Xác nhận mật khẩu mới",
	"Your password is_": "Mật khẩu bạn đã nhập không đúng",
	"Confirm password does_": "Mật khẩu không khớp",
	"Please enter_email": "Vui lòng nhập địa chỉ e-mail hợp lệ.",
	"Please enter_password": "Mật khẩu bạn đã nhập không đúng",
	"Internal server error_": "Lỗi máy chủ nội bộ. Vui lòng thử lại.",
	"New password is_": "Ít nhất 1 ký tự phải khác với mật khẩu hiện tại của bạn",
	"It should be_": "Mật khẩu phải có 5 ký tự trở lên",
	"Invalid permission": "Quyền không hợp lệ.",
	"Input data isnt_": "Dữ liệu đầu vào không khả dụng.",
	Unauthorized: Unauthorized,
	"Already have subsciption": "Đã đăng ký",
	"Already uses": "Đã sử dụng",
	"Already logged in": "Đã đăng nhập",
	"Already sent e-mail": "Đã gửi e-mail.",
	"Please wait": "Vui lòng chờ.",
	"E-mail is not_": "Email chưa được xác minh.",
	"Update your subscription_": "Cập nhật gói đăng ký của bạn",
	"Account was deleted": "Tài khoản đã bị xóa.",
	"5 ~ 30_": "5 ~ 30 characters",
	"It has exceeded_": "Đã vượt quá 9 Quản trị viên tối đa.",
	"Billing information": "Thông tin thanh toán",
	"Please enter cardName": "Nhập tên thẻ",
	"Please enter_card": "Nhập số thẻ hợp lệ",
	"Please enter address": "Nhập địa chỉ",
	"Please select country": "Chọn quốc gia",
	"Please enter city": "Nhập thành phố",
	none: none,
	"Due today": "Đến hạn vào hôm nay",
	"Today after 1_": "Ngày hôm nay sau 1 tháng dùng thử",
	"An error occurred_": "Đã xảy ra lỗi khi cố gắng thay đổi mật khẩu. Thử lại.",
	"Your account is_": "Tài khoản của bạn được kích hoạt",
	"You can now_": "Bây giờ bạn có thể đăng nhập vào tài khoản của mình bằng địa chỉ email được sử dụng trong quá trình đăng ký.",
	Email: Email,
	"Don’t have an account?": "Không có tài khoản?",
	"Already have an account?": "Bạn đã có một tài khoản?",
	"Cloud service": "Cloud service",
	"for your BlackVue": "for your BlackVue",
	"See what your_": "See what your camera sees remotely.",
	"Receive impact alert_": "Receive Impact alert push notifications.",
	"Save footage to_": "Save footage to the cloud and do much more...",
	"Free plan included_": "Free plan included · Easy setup · Cancel anytime",
	"Taking advantage of_": "Taking advantage of a mobile or car-embedded Internet connection and a BlackVue camera, BlackVue Cloud connects you to your car from anywhere, anytime. Using the BlackVue App on your smartphone or tablet, you see in real time where your car is located and what is happening around it.",
	"Get notifications to_": "Get notifications to your phone when your parked car is hit. Check remotely what is happening around your car.",
	"Monitor your commercial_": "Monitor your commercial vehicles on a map in real time. Talk to your drivers anytime through the BlackVue App or Viewer.",
	"With BlackVue Fleet_": "With BlackVue Fleet Tracking, track in real time up to 100 vehicles from the palm of your hand or with the dedicated BlackVue Viewer.",
	"Get started now_": "Get started now with a Free plan. For unlimited video playback or Remote Live View, upgrade to Lite or Smart plan from the BlackVue App. <br/>Business and power users can unlock the power of the Fleet plan exclusively through this website.",
	"Remote Video Playback_": "Remote Video Playback and Download",
	"Compatible with DR650GW_": "Compatible with DR650GW, DR650S models",
	"Unlimited remote video_": "Unlimited remote video playback and download",
	"Longer cloud storage_": "Longer cloud storage file expiration period",
	"Longer storage period_live": "Longer storage period for Event live auto upload",
	"Longer storage period_file": "Longer storage period for Event file auto upload",
	"Goefence setup (PC_": "Geo-fence setup (PC viewer) and alerts (Windows viewer and app)",
	"App Store": "App Store",
	"Send reset password email": "Gửi email đặt lại mật khẩu",
	Customers: Customers,
	Home: Home,
	"Pick a plan": "Pick a plan",
	"No customers yet": "No customers yet",
	"Customers will_": "Customers will show up here as they become available",
	"Add customer": "Add customer",
	"Report(PDF)": "Report(PDF)",
	"Subscription Period": "Subscription Period",
	Plan: Plan,
	New: New,
	Unsubscribed: Unsubscribed,
	"Subscription ends soon": "Subscription ends soon",
	Edit: Edit,
	"1 month trial": "1 month trial",
	"Edit customer details": "Edit customer details",
	"Customer name": "Customer name",
	"of 999 available_": "of 999 available on Fleet Plan",
	"Subscription starts": "Subscription starts",
	"Subscription period": "Subscription period",
	month: month,
	months: months,
	"Cloud storage": "Cloud Storage",
	"Subscription plan": "Loại đăng ký",
	"Check email address": "Check email address",
	"Add customer details": "Add customer details",
	Continue: Continue,
	Back: Back,
	"An error occured": "An error occured",
	"Customer added": "Customer added",
	"Last changed": "Last changed",
	"Company name": "Company name",
	"Company address": "Company address",
	"Alert Push Notifications": "Alert Push Notifications",
	"Receive notifications on_": "Receive notifications on your phone when preset Events occur. Great in combination with BlackVue’s Parking Mode.",
	"Remote Live View": "Xem trực tiếp từ xa",
	"Remotely monitor your_": "Remotely monitor your car in real time from anywhere, anytime.",
	"Video Backup/Auto Upload": "Video Backup/Auto Upload",
	"Back up videos_": "Back up videos to your phone or Cloud storage.",
	"Two-way Voice Communication": "Two-way Voice Communication",
	"Talk with people_": "Talk with people in the car from your smartphone. The driver can speak while keeping hands on the wheel.",
	"View your car’s_": "View your car’s location and speed on a map. With BlackVue Fleet Tracking, access 90-days’ worth of GPS data.",
	"Remote Video Playback": "Remote Video Playback",
	"Play videos stored_": "Play videos stored in the Cloud or in your dashcam anytime on your smartphone or tablet.",
	"Event Live Auto Upload": "Event Live Auto Upload",
	"Save a video stream_": "Save a video stream in real time to the Cloud. Protect yourself from break-ins and theft.",
	"Event File Auto Upload": "Event File Auto Upload",
	"Save Event videos_": "Save Event videos to the Cloud—including seconds before trigger—after they happen.",
	"Firmware-Over-the-Air (FOTA)": "Firmware-Over-the-Air (FOTA)",
	"Upgrade your dashcam’s": "Update your dashcam over the cloud",
	"When an Event_": "When an Event is created (Impact detected or manually triggered), Event Live Auto-upload lets your Cloud-compatible BlackVue save a live video stream from a camera of your choice (front or rear/interior) to the Cloud server",
	"Event File Auto-upload_": "Event File Auto-upload lets your dashcam automatically upload low-resolution versions of Event files to the Cloud.",
	Master: Master,
	"per Camera": "per Camera",
	"Event live auto upload_": "Event live auto upload compatible with all cloud cameras",
	"Drive report": "Drive report",
	"USA/Canada Toll Free": "USA/Canada Toll Free",
	"Monday–Saturday_": "Monday to Friday 8am-7pm / Saturday 9am-6pm (PST).",
	"Please agree to_": "You must accept Terms of Service",
	"Mac or Windows PC": "Mac or Windows PC",
	Develop: Develop,
	"Sign out": "Sign out",
	"Referral code": "Mã giới thiệu",
	"Total after 1 month trial": "Tổng sau 1 tháng dùng thử",
	"Already Use Stripe Token": "Đã sử dụng mã thông báo sọc",
	"Select period": "Chọn khoảng thời gian",
	"State/Region": "Bang/Khu vực (tùy chọn)",
	"ZIP/Postal": "Mã ZIP/Mã bưu điện",
	"$0.00": "$0.00",
	"$11.99": "$11.99",
	"$24.99": "$24.99",
	$9: $9,
	$15: $15,
	$10: $10,
	"mo + for_": "/mo + {{a}} per extra camera",
	mo: mo,
	"This e-mail address_": "Địa chỉ email này đã có tài khoản đăng ký.",
	"1 month": "1 tháng",
	"Limit is reset daily": "Giới hạn được đặt lại hàng ngày",
	"Limit is reset monthly": "Giới hạn được đặt lại hàng tháng",
	"Video plays and downloads": "Phát và tải xuống video",
	"Your master": "Your owner",
	"Youre 1 step_": "Bạn chỉ còn 1 bước nữa là hoàn tất đăng ký Gói Đội xe",
	"Finish signing up": "Hoàn tất đăng ký",
	"Enter billing information": "Nhập thông tin thanh toán",
	"Proceed to billing": "Tiếp tục thanh toán",
	City: City,
	Charge: Charge,
	"User already invited_": "Người dùng đã được mời bởi Chủ đội xe",
	"n% consumed": "Đã sử dụng {{a}}%",
	"E-mail already exists": "Email đã tồn tại",
	"Cancel your inapp_": "Hủy gói đăng ký trong ứng dụng của bạn",
	"You have cancel_": "Bạn phải hủy gói đăng ký trong ứng dụng của mình để nâng cấp lên Gói Đội xe: 1. Hủy gói đăng ký hiện tại của bạn trong App Store hoặc Google Play Store. Bạn sẽ hạ cấp xuống Gói Miễn phí vào cuối chu kỳ thanh toán hiện tại của mình. Tất cả dữ liệu của bạn sẽ vẫn còn nguyên vẹn. 2. Đăng nhập vào tài khoản blackvuecloud.com của bạn và nâng cấp lên Gói Đội xe.",
	"Edit permissions": "Chỉnh sửa quyền",
	"See permissions": "Xem quyền",
	"Submaster removed": "Chủ đội xe phụ đã bị xóa",
	"Camera removed": "Camera đã bị xóa",
	"User removed": "Người dùng đã bị xóa",
	"Users removed": "Người dùng đã bị xóa",
	subscribe: subscribe,
	search: search,
	"permission can be_": "Quyền có thể được thiết lập sau khi chủ đội xe phụ chấp nhận lời mời.",
	"The confirmation link_": "Liên kết xác nhận không còn hợp lệ",
	"Possible reasons:_": "Các lý do có thể xảy ra:\n • Bạn đã xác nhận địa chỉ email của mình\n • Liên kết đã hết hạn hoặc đã bị hủy",
	"Failed to register_": "Không đăng ký được với BlackVue Cloud",
	"There was an_": "Đã xảy ra lỗi trong quá trình đăng ký. Nếu sự cố vẫn tiếp diễn, hãy thử đăng ký lại BlackVue Cloud. Nếu bạn cần hỗ trợ thêm, vui lòng liên hệ với bộ phận hỗ trợ khách hàng của chúng tôi:",
	"Upgrade to Fleet_": "Nâng cấp lên Gói Đội xe",
	"Subscription is Canceled": "Đăng ký đã bị hủy",
	"No members yet": "Chưa có thành viên nào",
	"Please enter_group name": "Nhập tên nhóm hợp lệ",
	"Group Name": "Tên nhóm",
	invalid_number: invalid_number,
	invalid_expiry_month: invalid_expiry_month,
	invalid_expiry_year: invalid_expiry_year,
	invalid_cvc: invalid_cvc,
	incorrect_number: incorrect_number,
	incomplete_number: incomplete_number,
	incomplete_cvc: incomplete_cvc,
	incomplete_expiry: incomplete_expiry,
	expired_card: expired_card,
	incorrect_cvc: incorrect_cvc,
	incorrect_zip: incorrect_zip,
	invalid_expiry_year_past: invalid_expiry_year_past,
	card_declined: card_declined,
	missing: missing,
	processing_error: processing_error,
	"no groups yet": "Chưa có nhóm nào",
	"groups will show_": "Các nhóm sẽ hiển thị ở đây khi được lập",
	"Fleet members will_": "Các thành viên của đội xe sẽ hiển thị ở đây khi họ được mời",
	"service provider": "Nhà cung cấp dịch vụ",
	Paypal: Paypal,
	iOS: iOS,
	Android: Android,
	"Enter email": "Please enter a email address",
	"Enter password": "Vui lòng nhập mật khẩu.",
	"Enter first name": "Nhập tên",
	"Enter last name": "Nhập họ",
	"Enter the current_": "Nhập mật khẩu hiện tại",
	"Enter a new_": "Nhập mật khẩu mới",
	"There isnt an_": "Không có tài khoản nào được liên kết với địa chỉ email này",
	"Fleet Plan": "Fleet Plan",
	Total: Total,
	"Password you entered_": "Mật khẩu bạn đã nhập không đúng",
	"Incorrect email or_": "Email hoặc mật khẩu không chính xác",
	"Available to Masters": "Khả dụng đối với Chủ sở hữu",
	"Blackvue url": "https://www.blackvue.com",
	"Information We Collect_": "Thông Tin Chúng Tôi Thu Thập và Lý Do",
	And: And,
	"Terms of Location-Based_": "Điều khoản sử dụng dịch vụ dựa trên vị trí.",
	"I agree to the_": "Tôi đồng ý với",
	"Password Reset_": "Chúng tôi đã gửi một email đến {{a}} với hướng dẫn đặt lại mật khẩu.",
	"You have already_": "Bạn đã được mời, vui lòng kiểm tra email của bạn.",
	"No data available_": "Không có dữ liệu trong bảng",
	Camera: Camera,
	"You no longer_": "Bạn không còn được phép sử dụng dịch vụ đội xe.",
	"Please contact your_": "Vui lòng liên hệ với Chủ đội xe của bạn để giải quyết sự cố.",
	"You can still_": "Bạn vẫn có thể truy cập",
	"account information": "thông tin tài khoản.",
	"If the issue_": "Nếu sự cố không được giải quyết và bạn quyết định tiếp tục sử dụng dịch vụ BlackVue Cloud bằng địa chỉ email đã đăng ký, bạn sẽ phải xóa tài khoản của mình và đăng ký lại.",
	"If the problem_": "Nếu sự cố vẫn tiếp diễn, hãy liên hệ với bộ phận hỗ trợ khách hàng của chúng tôi:",
	"Web subscription only": "Chỉ đăng ký trên web",
	"AppStore url": "https://apps.apple.com/kr",
	"We no longer_": "Chúng tôi không còn xử lý thanh toán qua PayPal nữa. Bạn phải cập nhật gói đăng ký của mình để thay đổi số lượng camera: 1. Đăng nhập vào tài khoản paypal.com của bạn và hủy đăng ký Gói Đội xe hiện tại của bạn để thay đổi số lượng camera: 2. Đăng nhập vào tài khoản blackvuecloud.com của bạn và nâng cấp lên Gói Đội xe.",
	Yes: Yes,
	No: No,
	"Serial number": "Số sêri",
	"Cloud code": "Mã Cloud",
	"Terms & Policies": "Điều khoản & Chính sách",
	News: News,
	Notifications: Notifications,
	"km/h": "km/h",
	MPH: MPH,
	"Baidu Maps": "Baidu Maps (chỉ Trung Quốc)",
	"Google Maps": "Google Maps",
	Firmware: Firmware,
	Basic: Basic,
	"Time Zone": "Múi giờ",
	Resolution: Resolution,
	"Image quality": "Chất lượng hình ảnh",
	Brightness: Brightness,
	Recording: Recording,
	"Normal recording": "Ghi bình thường",
	"Voice recording": "Ghi âm",
	"Video segment length": "Độ dài đoạn video",
	"Rear camera recording": "Ghi camera sau",
	Highest: Highest,
	High: High,
	Normal: Normal,
	"1 min": "1 phút",
	"2 min": "2 phút",
	"3 min": "3 phút",
	Sensitivity: Sensitivity,
	"Motion detection": "Phát hiện chuyển động",
	"Speed alert": "Cảnh báo tốc độ",
	"Voice guidance": "Hướng dẫn thoại",
	"Power on": "Bật nguồn",
	"Power off": "Tắt nguồn",
	"Starting normal recording": "Bắt đầu Ghi bình thường",
	"Changing recording mode": "Thay đổi chế độ ghi",
	"Speed alert (beep)": "Cảnh báo tốc độ (bíp)",
	"Cloud related": "Liên quan đến Cloud",
	Volume: Volume,
	"User text overlay": "Lớp phủ thông điệp người dùng",
	"A-Z, a-z_": "A~Z, a~z, 0~9, :;’/\\+-_()$#\ndưới 20 ký tự.",
	"Wi-Fi auto turn off": "Wi-Fi tự động tắt",
	"Login credentials": "Thông tin đăng nhập",
	"Manual recording": "Ghi Thủ công",
	"By sharing your_": "Bằng cách chia sẻ chức năng Xem trực tiếp, bạn có thể cho phép người dùng khác gián tiếp trải nghiệm đầy lý thú và thú vị của việc lái xe khắp nơi trên thế giới.",
	"However, as persona_": "Tuy nhiên, vì video cá nhân của bạn có thể được truyền đi, bạn cần đặc biệt chú ý quyết định xem nên chia sẻ thông tin nào.",
	"Please enter_email_2": "Vui lòng nhập một địa chỉ email hợp lệ. Email với một số ký tự đặc biệt có thể không được phép. Ex) +, &",
	"Password is incorrect": "Mật khẩu không đúng.",
	"This camera is already_": "Camera này đã đăng ký tài khoản BlackVue.",
	"Camera name must_": "Tên camera phải có từ 5 đến 32 ký tự.",
	"Failed to save_": "Lưu thiết lập camera thất bại.",
	"Unallowed character detected": "Phát hiện ký tự không hợp lệ.",
	"File(s) queued for_": "Tập tin xếp hàng đợi tải lên Cloud.",
	"Exceeded video play_": "Vượt giới hạn phát & tải về video.",
	"Playback Failed": "Phát lại thất bại.",
	"Exceeded your Live_": "Vượt quá g.hạn t.gian Xem Trực tiếp của bạn.",
	"The camera is not_": "Camera chưa kết nối với máy chủ.",
	"Please check the connection_": "Vui lòng kiểm tra trạng thái kết nối của camera được chọn.",
	Close: Close,
	"Map": "Bản đồ",
	Cloud: Cloud,
	Public: Public,
	"Flip horizontally": "Xoay ngang",
	Front: Front,
	Rear: Rear,
	Play: Play,
	Stop: Stop,
	Pause: Pause,
	"Next frame": "Khung tiếp theo",
	"Previous frame": "Khung trước đó",
	"Proximity sensor": "Cảm biến tiệm cận",
	"Voice recording on/off": "Bật/tắt ghi âm",
	"The BlackVue dashcam_": "Camera hành trình BlackVue không tương thích với mạng không dây 5GHz.",
	Time: Time,
	"Daylight saving time": "Giờ t.kiệm ánh sáng ban ngày",
	System: System,
	"Incorrect camera serial_": "Sai số sê-ri camera.",
	"Lock event files": "Khóa tập tin sự kiện",
	"Overwrite locked event_": "Ghi đè tập tin sự kiện đã khóa khi đầy",
	"Camera settings saved_": "Lưu thiết lập camera thành công.",
	"Front camera": "Camera trước",
	"Rear camera": "Camera sau",
	Event: Event,
	Parking: Parking,
	"GPS tracking": "Theo dõi GPS",
	"G-force detected": "Phát hiện trọng lực",
	"Impact detected in_": "Phát hiện tác động ở chế độ đỗ",
	"Scheduled reboot": "Đã đặt lịch khởi động",
	"Recording status": "Trạng thái ghi hình",
	"Rear security": "Cảnh báo phía sau",
	"Time lapse": "Thời gian trôi qua",
	"Sync with GPS_": "Đồng bộ với thời gian GPS",
	"Overwrite locked event3_": "Ghi đè các tập tin đã khóa bằng tập tin sự kiện mới khi dung lượng lưu trữ đã đầy",
	"Video codec": "Video Codec",
	"Tracking logs": "Nhật ký theo dõi",
	"Geofence alerts": "Cảnh báo Geo-Fencing",
	Color: Color,
	Exit: Exit,
	Save: Save,
	Impact: Impact,
	Unlimited: Unlimited,
	"Parking mode recording": "Ghi hình ở chế độ đỗ xe",
	"Battery protection": "Bảo vệ ắc quy",
	"Cut-off timer": "Hẹn giờ cắt",
	"Low voltage cut-off": "Cắt điện áp thấp",
	"Rear camera orientation": "Hướng camera sau",
	Default: Default,
	"Rotate video 180°": "Xoay video 180°",
	"Mirror video": "Làm ngược video",
	"Wi-Fi band": "Băng tần Wi-Fi",
	"Driving report": "Báo cáo lái xe",
	"Unsupported video codec_": "Codec video không được hỗ trợ (H.265).",
	"Rear camera recording_": "Chức năng ghi của camera sau ở chế độ đỗ xe",
	"Front and rear_": "Ghi đồng thời camera sau và trước",
	"Rear camera stops_": "Camera sau dừng ghi trong 5 phút sau khi nhập chế độ đỗ xe. Chức năng ghi khởi động lại sau khi nhập chế độ thông thường.",
	"Remote firmware update": "Cập nhật phần mềm từ xa",
	"Firmware is up-to-date": "Phần mềm được cập nhật",
	"New firmware available": "Đã có vi chương trình mới.",
	Version: Version,
	"Release date": "Ngày phát hành",
	Language: Language,
	"File size": "Kích thước tập tin",
	"What’s new": "Thông tin mới",
	"Updating may take_": "Quá trình cập nhật có thể mất vài phút.",
	"The update process_": "Không thể hủy bỏ quá trình cập nhật.",
	"Do not disconnect the_": "Không được ngắt kết nối cáp nguồn cho đến khi chức năng ghi thông thường được khởi động lại.",
	"Downloading firmware": "Tải xuống vi chương trình",
	"Once download is_": "Sau khi hoàn tất quá trình tải về, BlackVue sẽ tự động khởi động lại để sử dụng phần mềm mới.",
	"If not allowed_": "Nếu không được phép, sẽ không thể truy cập được vị trí và tốc độ xe của bạn qua Đám mây.",
	"Unable to initiate update because_": "Không thể khởi chạy bản cập nhật vì camera hành trình được kết nối với thiết bị qua Wi-Fi trực tiếp.",
	Notification: Notification,
	Multiple: Multiple,
	Range: Range,
	"HDR night vision": "Tầm nhìn Đêm HDR",
	Download: Download,
	"G-sensor": "G-Sensor",
	Manual: Manual,
	"Low voltage warning": "Cảnh báo điện áp thấp",
	Satellite: Satellite,
	"Data usage": "Sử dụng dữ liệu",
	"Select video download quality": "Chọn chất lượng tải video",
	"Quick play file_": "Chơi nhanh tập tin (độ phân giải thấp)",
	"Original file": "Tập tin gốc",
	"You do not have permission_": "Bạn không có quyền chạy chức năng này. Vui lòng liên hệ với chủ tài khoản chính của bạn.",
	"Interior camera recording_": "Chức năng ghi của camera trước ở chế độ đỗ xe",
	"Interior security": "An ninh nội thất",
	"Interior camera rotation": "Xoay camera nội thất",
	"Multi View": "Nhiều chế độ Xem",
	Tutorials: Tutorials,
	"Upgrade now": "Nâng cấp ngay",
	"Members will show_": "Các thành viên sẽ hiển thị ở đây khi họ được mời",
	"Are you sure_delete members": "Bạn có chắc chắn muốn xóa vĩnh viễn thành viên?",
	"Some members may_": "Một số thành viên có thể bị ẩn do các bộ lọc được áp dụng.",
	"Invited on_": "được bạn mời vào {{Invited Date}} bởi bạn. Chủ sở hữu",
	Filter: Filter,
	"Date created": "Ngày tạo",
	"No admin yet": "Chưa có quản trị viên",
	"You can add_admin": "Bạn có thể thêm 1 quản trị viên cho mỗi nhóm",
	"Collapse all": "Thu gọn tất cả",
	"Expand all": "Mở rộng tất cả",
	"Download and playback_cloud": "Tải xuống và phát lại từ bộ nhớ đám mây",
	"Are you sure_2": "Bạn có chắc chắn muốn xóa nhóm {Group name}?",
	"Are you sure_groups": "Bạn có chắc chắn muốn xóa các nhóm?",
	"Add cameras first_drivers": "Thêm camera trước, sau đó chỉ định lái xe sau",
	"Flip vertically": "Xoay dọc",
	Sun: Sun,
	Mon: Mon,
	Tue: Tue,
	Wed: Wed,
	Thu: Thu,
	Fri: Fri,
	Sat: Sat,
	Dates: Dates,
	Routes: Routes,
	Opacity: Opacity,
	"Color and opacity": "màu sắc và độ mờ",
	"Geofences will show_": "vùng địa lý sẽ hiển thị ở đây khi chúng xuất hiện",
	"Start drawing a shape_": "bắt đầu vẽ một hình dạng trên bản đồ",
	"Add geofence": "Thêm vùng địa lý",
	Entry: Entry,
	"Show all members": "Hiển thị tất cảthành viên",
	"Me and my_": "Tôi và chiếc xe của tôi. Đã kết nối",
	"add-on service for_": "dịch vụ tiện ích bổ sung cho Blackvue tương thích với đám mây",
	"Continue with Google": "Tiếp tục với Google",
	"An account with_": "Tài khoản có địa chỉ email đó đã tồn tại nhưng chưa được xác minh. Hãy nhập mật khẩu BlackVue Cloud hiện có của bạn để đăng nhập.",
	"Account does not_": "Tài khoản không tồn tại. Hoặc thử đăng nhập bằng tài khoản Apple hoặc Google của bạn.",
	"Continue with Apple": "Tiếp tục với Apple",
	"Get started": "Bắt đầu",
	"P subscription only": "Chỉ đăng ký trên <b>{{a}}</b>",
	"+N USD for extra camera_": "+{{a}} USD for extra camera up to {{b}} Cameras",
	"Unlimited Live view": "Unlimited Live View",
	"Cameras per Account": "Cameras per Account",
	"Users per Account": "Users per Account",
	Owner: Owner,
	"Live View per Day": "Live View per Day",
	"Remote Video Playback_2": "Remote Video Playback and Download per Month",
	"N days": "{{a}} Days",
	"Video On Map": "Video On Map",
	Undetected: Undetected,
	Distracted: Distracted,
	Drowsy: Drowsy,
	"Whether on mobile_": "Whether on mobile or your computer, BlackVue gives you the tools to fully enjoy your dashcam’s functions. Download the latest <a1>firmware</a1>, <a2>mobile</a2> and <a3>desktop</a3> applications, or use <a4>BlackVue web app</a4> in your browser.",
	"Compatible with most_": "Compatible with most Wi-Fi BlackVue models. Cloud support for all Cloud-compatible dashcam models down to DR650GW Series with <b>Cloud Firmware</b>.",
	"Supports most recent BlackVue_": "Supports most recent BlackVue models and compatible with BlackVue Cloud.<br/>\nThis Viewer contains <b>two applications in one</b>: the SD Card Viewer lets you view recorded videos from your SD card and modify the settings of your BlackVue, as well as format the SD card; the <b>Cloud Viewer</b> lets you enjoy BlackVue Cloud.",
	"Contact us": "Contact us",
	"6 characters with": "6 ký tự với sự kết hợp của các chữ cái, số và ký hiệu",
	"Apps and more...": "Apps and more...",
	"Cameras will show_": "Cameras will show up here as they become available.",
	"Keep this page_": "Giữ trang này mở trong khi kiểm tra mã xác nhận. Hãy thử kiểm tra thư mục thư rác nếu bạn không thể tìm thấy email trong hộp thư đến của mình.",
	"n cameras": "{{n}} camera",
	"n slots": "{{n}} khe gắn",
	"Calculate your Fleet_": "Tính giá gói Đội xe của bạn",
	"Code you entered_": "Mã bạn nhập không chính xác/đã hết hạn",
	Calling: Calling,
	Smoking: Smoking,
	"Smoking has been_": "Đã phát hiện hành vi hút thuốc khi lái xe.",
	"Email is already_": "Email đã tồn tại.",
	"Serial number and_": "Số sê-ri và mã đám mây được in trên camera của bạn",
	"Allow GPS access": "Cho phép tuy cập GPS",
	"Used to access_": "Được sử dụng để truy cập vị trí và tốc độ xe của bạn. Bạn có thể thay đổi cài đặt GPS sau trong cài đặt bảo mật của camera.",
	"Incorrect cloud code": "Mã đám mây không chính xác",
	"An account is_": "Một tài khoản đã được đăng ký bằng địa chỉ email này.",
	"Live event upload": "Tải lên sự kiện trực tiếp",
	Permissions: Permissions,
	"Assign in": "Chỉ định vào",
	"Are you sure_camera": "Bạn có chắc chắn muốn xóa máy ảnh này không?",
	"Uploading videos:": "Tải video:",
	"GPS location recording": "Ghi vị trí GPS",
	"When OFF, GPS_": "Khi TẮT, vị trí GPS không được ghi lại hoặc gửi đến máy chủ đám mây.",
	"As personal video_": "Vì video cá nhân có thể được truyền đi, nên bạn cần đặc biệt cẩn thận trong việc quyết định thông tin mình chia sẻ.",
	"Share location": "Chia sẻ vị trí",
	Private: Private,
	"Used to access_2": "Được sử dụng để truy cập vị trí và tốc độ xe của bạn.",
	"Share live view": "Chia sẻ video Xem Trực tiếp",
	"Share live audio": "Chia sẻ audio Xem Trực tiếp",
	"Share camera’s name": "Chia sẻ tên camera hành trình",
	"Impact detection": "Phát hiện tác động",
	Entering: Entering,
	Exiting: Exiting,
	"Normal event recording": "Ghi sự kiện bình thường",
	"Harsh braking": "Phanh gấp",
	Acceleration: Acceleration,
	"Sharp turn": "Rẽ ngoặt",
	"Parking event recording": "Ghi hình sự kiện đỗ xe",
	Passing: Passing,
	"Video source": "Nguồn Video",
	Overspeed: Overspeed,
	"Are you sure_video": "Bạn chắc chắn muốn xóa video này?",
	"Add camera to_": "Thêm camera vào xem trực tiếp",
	"No routes to_": "Không có tuyến đường nào để hiển thị",
	"Start by adding_": "Thêm ngày để bắt đầu.",
	"invite sent": "Đã gửi lời mời",
	Recipients: Recipients,
	Send: Send,
	"Routes selected_": "Các tuyến đường đã chọn: {{n}} trong {{total}}",
	"Map service": "Dịch vụ bản đồ",
	"Speed units": "Đơn vị tốc độ",
	Note: Note,
	"Release notes": "Thông báo phát hành",
	"The name must_": "Tên phải trong khoảng từ 1 đến 30 ký tự.",
	Video: Video,
	Advanced: Advanced,
	"Firmware language": "Ngôn ngữ chương trình cơ sở",
	"Wi-Fi": "Wi-Fi",
	Voice: Voice,
	"Show date and_": "Hiển thị ngày và giờ",
	"Show speed": "Hiển thị tốc độ",
	"Front camera rotation": "Xoay camera trước",
	"Manual time settings": "Cài đặt thời gian thủ công",
	"Recommended for better_": "Được khuyên dùng để nén tốt hơn, giảm kích thước thư mục và 4K UHD.",
	"For full compatibility_": "Nhằm tương thích hoàn toàn với máy tính và thiết bị di động cũ.",
	"Up and down": "Lên và xuống",
	"Side to side": "Trái và phải",
	"Front and back": "Trước và sau",
	"Detection region": "Vùng phát hiện",
	"Hotspot 1": "Điểm phát sóng 1",
	"Hotspot 2": "Điểm phát sóng 2",
	"Hotspot 3": "Điểm phát sóng 3",
	"Enter/exit": "Vào/ra",
	"Event recording": "Ghi sự kiện",
	"Front security (Normal)": "Cảnh báo phía trước (Thường)",
	"Front security (Parking)": "Cảnh báo phía trước (Đỗ xe)",
	"LTE (Parking)": "LTE (Đỗ xe)",
	"Wi-Fi (Parking)": "Wi-Fi (Đỗ xe)",
	"Turn on at startup": "Bật khi khởi động",
	"Turn off after_": "Tắt sau 10 phút không hoạt động",
	"Your firmware is_": "Chương trình cơ sở đã được cập nhật",
	"Add admin": "Thêm quản trị viên",
	"Remove All/n": "Xóa Tất cả/{{a}}",
	"Are you sure_remove": "Bạn có chắc chắn muốn xóa camera khỏi nhóm này?",
	"This will cancel_2": "Việc này sẽ hủy đăng ký Gói Đội Xe của bạn. Bạn sẽ hạ cấp xuống Gói Miễn Phí vào cuối chu kỳ thanh toán hiện tại của mình.",
	"You’ve reached_": "Bạn đã đạt đến số lái xe giới hạn cho mỗi camera.",
	"Are you sure_remove admin": "Bạn chắc chắn muốn xóa quản trị viên {{a}}{{b}} khỏi nhóm này?",
	"Fleet Plan · Owner": "Fleet Plan · Owner",
	"Manage cameras": "Quản lý camera",
	"Are you sure_delete zone": "Bạn chắc chắn muốn xóa vùng \"{{zone}}\"?",
	"available on your_2": "{{a}}/{{b}} có sẵn trong gói của bạn",
	"The new plan_2": "Gói mới sẽ có hiệu lực vào cuối chu kỳ thanh toán hiện tại của bạn ({{a}}).",
	"Canceled Fleet Plan_": "Đã hủy Gói Đội Xe vào {{a}}",
	"Hard braking alert (beep)": "Cảnh báo phanh gấp (bíp)",
	"Hard acceleration alert (beep)": "Cảnh báo tăng tốc (bíp)",
	"Hard cornering alert (beep)": "Cảnh báo rẽ ngoặt (bíp)",
	"SSID must be_": "SSID phải dài ít nhất 5 ký tự.",
	"Password must be_": "Mật khẩu phải dài ít nhất 8 ký tự.",
	"5 to 32 characters long": "Dài từ 5 đến 32 ký tự",
	"8 to 32 characters long": "Dài từ 8 đến 32 ký tự",
	"Longer storage period_event": "Cần nhiều thời gian lưu trữ hơn để tải lên sự kiện trực tiếp",
	"Requires latest firmware_": "Yêu cầu chương trình cơ sở mới nhất. Không tương thích với các mẫu DR650S, DR650GW",
	"After Blackvue is_": "Sau khi Blackvue được kết nối với đám mây, các cài đặt sẽ được lưu.",
	"This is an_": "Đây là một E-mail chưa đăng ký. Bạn có muốn đăng ký tài khoản mới?",
	"This feature is_": "Tính năng này chỉ khả dụng cho những người đăng ký Gói Đội Xe.",
	"Please return to_": "Tài khoản không tồn tại. Hoặc thử đăng nhập bằng tài khoản Apple hoặc Google của bạn.",
	"Adjusting the cut-off voltage_": "Adjusting the cut-off voltage to a lower setting may result in your dash cam draining more power from your battery.\nThis could result in warning messages of battery drain or affect other vehicle functions.\nPlease consult with your dealership before lowering the voltage.",
	"Your videos will_": "Video của bạn sẽ hiển thị ở đây khi đã sẵn sàng.",
	"You drove:_": "Bạn đã lái: {{distance}}, {{time}}",
	"Event count per_": "Số sự kiện mỗi giờ lái xe",
	"Are you sure_recipient": "Bạn chắc chắn muốn xóa người nhận này?",
	"(You)": "{{a}} (Bạn)",
	"All events": "Tất cả sự kiện",
	Days_: Days_,
	"Requires DMC 200_": "Yêu cầu camera DMC 200",
	"A DMS and compatible_": "Cần có DMS và camera hành trình tương thích để xem báo cáo này.",
	"Notifications will show_": "Thông báo sẽ hiển thị ở đây khi đã sẵn sàng.",
	"Try changing your_": "Hãy thử thay đổi ngày của bạn hoặc xóa bộ lọc.",
	Mute: Mute,
	UnMute: UnMute,
	"Calling and smoking_": "Chỉ thiết bị DMC 200 mới phát hiện được cuộc gọi và hành vi hút thuốc",
	"You need a DMS_": "Bạn cần DMS để xem báo cáo này.",
	"Try BlackVue Cloud": "Dùng thử BlackVue Cloud ngay hôm nay",
	"Individual driver looking_": "Cá nhân lái xe muốn an tâm trên lộ trình? Chủ doanh nghiệp cần một giải pháp theo dõi và bảo mật xe đơn giản?",
	"Whoever you are_": "Bất kể bạn là ai, bất kể nhu cầu của bạn là gì, đã có gói Đám mây dành cho bạn!",
	"It is the account that_Driver": "Đây là tài khoản đã tham gia đội xe của bạn trên BlackVue cloud, sau khi chấp nhận lời mời qua email từ Chủ Sở Hữu hoặc Quản trị viên. Mỗi lái xe chỉ có thể được chỉ định đến một camera với những giới hạn trong khả năng xem hồ sơ tài khoản của họ; trong chế độ xem trực tiếp và phát lại trên camera được chỉ định của họ.",
	"It is the account that_Admin": "Đây là tài khoản đã tham gia đội xe của bạn trên BlackVue cloud, sau khi chấp nhận lời mời qua email từ Chủ Sở Hữu. Tài khoản quản trị viên có thể được cấp các quyền mà Chủ Sở Hữu cho phép đối với Quản trị viên đó.",
	"Video deleted": "Video đã xóa",
	"Video delete_plural": "Video đã xóa",
	"Driver removed from_": "Lái xe đã bị xóa khỏi nhóm",
	"Admin removed from_": "Quản trị viên đã bị xóa khỏi nhóm",
	"Camera removed from_": "Camera đã bị xóa khỏi nhóm",
	"Are you sure_videos": "Bạn muốn xóa (các) tập tin đã chọn không?",
	"You have to cancel_fleet": "Bạn phải hủy đăng ký trong ứng dụng của mình để thay đổi số lượng camera: 1. Hủy gói đăng ký hiện tại của bạn trong App Store hoặc Google Play Store. Bạn sẽ hạ cấp xuống Gói Miễn Phí vào cuối chu kỳ thanh toán hiện tại của mình. Tất cả dữ liệu của bạn sẽ vẫn còn nguyên vẹn. 2. Đăng nhập vào tài khoản blackvuecloud.com của bạn và nâng cấp lên Gói Đội Xe.",
	Discard: Discard,
	"Discard unsaved changes?": "Hủy những thay đổi chưa lưu?",
	"Incorrect serial number": "Số sê-ri không chính xác",
	"An error occurred_again": "Đã xảy ra lỗi. Vui lòng thử lại.",
	"You are subscribed_free": "Bạn đã đăng ký gói Miễn phí của BlackVue Cloud.",
	"When an event_": "Khi một sự kiện được tạo (do đã phát hiện tác động hoặc được kích hoạt theo cách thủ công), tính năng Tải lên sự kiện trực tiếp cho phép BlackVue của bạn lưu luồng video trực tiếp từ camera đã chọn vào máy chủ Đám mây, bao gồm 5 giây trước sự kiện.",
	Report: Report,
	"How it work": "Cách hoạt động",
	"Cloud Camera": "Camera Đám mây",
	"Internet Connection": "Kết nối Internet",
	"BlackVue App/Viewer": "BlackVue App/Viewer",
	"All you need_": "Tất cả những gì bạn cần là",
	"Cloud-compatible BlackVue": "BlackVue tương thích với đám mây",
	"and a cellular_": "và gói dữ liệu di động. Một số mẫu sản phẩm kết nối với Đám mây thông qua điểm phát sóng Wi-Fi của bên thứ ba. Những mẫu khác cung cấp đầu đọc thẻ Nano SIM tích hợp hoặc hỗ trợ mô-đun kết nối plug-in.",
	"Cloud features at_": "Các tính năng đám mây trong tầm tay bạn",
	"Enjoy peace of_": "Hãy tận hưởng cảm giác yên tâm khi biết BlackVue đang trông chừng xe của bạn. Nếu có hiện tượng lạ, camera hành trình sẽ thông báo cho bạn ngay lập tức.",
	"Let your BlackVue_": "Hãy để BlackVue giám sát xe của bạn và cảnh báo cho bạn về các sự cố. Thời điểm tác động được phát hiện, BlackVue sẽ gửi thông báo đến điện thoại hoặc trình duyệt web của bạn, kèm theo ảnh chụp nhanh.",
	"Check on your_": "Để mắt đến xe của bạn ở bất kỳ đâu với chế độ Xem Trực Tiếp Từ xa. Cho dù thông qua trình duyệt web hay điện thoại, chỉ cần truy cập nguồn cấp dữ liệu video thời gian thực từ camera hành trình được kết nối với Đám mây của bạn là có thể dễ dàng chuyển đổi giữa các camera trước, sau hoặc bên trong.",
	"Your BlackVue may_": "BlackVue trên xe có thể không ngăn chặn được những tình huống tai nạn chớp nhoáng, nhưng nếu xảy ra, nhiều khả năng camera sẽ ghi lại bằng chứng video quan trọng. Xem qua tất cả video được camera hành trình của bạn ghi lại từ điện thoại di động hoặc trình duyệt web.",
	"Worried about eating_": "Lo lắng về việc sẽ tốn nhiều dữ liệu? Công nghệ Luồng phụ của BlackVue cho phép bạn truy cập các phiên bản video siêu nhẹ để duyệt nhanh và xem không cần vùng đệm.",
	"Move files from_": "Di chuyển tệp từ BlackVue của bạn sang Đám mây. Lưu một video hoặc chọn nhiều clip để tải lên hàng loạt. Bạn có thể truy cập và chia sẻ video tải xuống điện thoại bằng ứng dụng BlackVue từ menu Bộ Nhớ Trong.",
	"View your vehicle’s_": "Xem vị trí xe của bạn và tốc độ di chuyển theo thời gian thực. Nâng cấp lên Gói Thông Minh để có quyền truy cập dữ liệu theo dõi GPS trong 7 ngày qua.",
	"Get more with_": "Nhận được nhiều hơn với Gói Thông Minh",
	"Unlimited Remote Live_": "Xem Trực Tiếp Từ xa không giới hạn",
	"Up to 3 dashcams_": "Tối đa 3 camera hành trình trong một tài khoản",
	"Want to track_": "Bạn muốn theo dõi cả một đội xe? Nâng cấp lên Gói Đội Xe",
	"BlackVue Fleet Tracking_2": "BlackVue Fleet Tracking là giải pháp tất cả trong một để bảo vệ và theo dõi đội xe của bạn. Tính năng và mức giá cả linh hoạt để đáp ứng nhu cầu doanh nghiệp của bạn.",
	"Stream real-time video_": "Truyền phát video thời gian thực không giới hạn. Tốc độ bit: 600kbps",
	"Up to 999 Dashcams": "Tối đa 999 Camera Hành trình",
	"Register up to_": "Đăng ký lên đến 999 camera hành trình cho mỗi tài khoản.",
	"15GB of Cloud_": "15GB Bộ nhớ Đám mây",
	"15GB per additional_": "15GB cho mỗi camera hành trình bổ sung. Bộ nhớ Tự động tải lên Sự kiện không giới hạn.",
	"90-days GPS_": "Nhật ký Theo dõi GPS trong 90 ngày",
	"High accuracy: 15_": "Độ chính xác cao: 15 giây, Video Trên Bản đồ, dễ dàng xuất dữ liệu.",
	"Unique fleet management_": "Các tính năng quản lý đội xe độc ​​đáo tăng thêm giá trị và sự tiện lợi",
	"Create geofences and_": "Tạo rào chắn địa lý và nhận thông báo theo thời gian thực trên điện thoại hoặc máy tính của bạn.",
	"View at a_": "Xem nhanh tổng quãng đường đã đi, thời gian không tải, các tình huống tăng tốc, v.v., dưới dạng bảng có thể in hoặc xuất được.",
	"Multi Live View": "Nhiều chế độ Xem Trực Tiếp",
	"Monitor up to_": "Giám sát đồng thời 4 camera hành trình",
	"Benefits for you": "Lợi ích dành cho bạn",
	Individual: Individual,
	"Get notifications to_2": "Nhận thông báo trên điện thoại khi xe của bạn bị va chạm lúc đang đỗ. Kiểm tra từ xa những gì đang xảy ra xung quanh xe của bạn. Có sẵn trên web, điện thoại, Mac và Windows.",
	"Small business owner": "Chủ doanh nghiệp nhỏ",
	"Monitor your commercial_2": "Giám sát các phương tiện thương mại của bạn trên bản đồ theo thời gian thực. Nói chuyện với lái xe của bạn bất cứ lúc nào thông qua trình duyệt, ứng dụng di động BlackVue, trình xem Mac hoặc Windows.",
	"Company with large_": "Doanh nghiệp có đội xe lớn",
	"With BlackVue Fleet_2": "Với BlackVue Fleet Tracking, theo dõi tới 999 phương tiện trong thời gian thực thông qua trình duyệt, ứng dụng di động BlackVue, trình xem Mac hoặc Windows của bạn.",
	Subscribed: Subscribed,
	"The video was_": "Video đã được tải lên.",
	Geofence: Geofence,
	"500: Internal server error": "500: Lỗi máy chủ nội bộ",
	"404: Page not found": "404: Không tìm thấy trang",
	"Check the web address_": "Kiểm tra địa chỉ web hoặc quay lại trang chủ BlackVue Cloud",
	"home page": "Home page",
	"There isn’t an_": "Không có tài khoản nào được liên kết với địa chỉ email này",
	"You can now_password": "Bây giờ bạn có thể đăng nhập bằng mật khẩu mới của mình",
	"Are you sure_remove admin2": "Bạn chắc chắn muốn xóa vĩnh viễn quản trị viên?",
	"Admin deleted": "Quản trị viên đã xóa",
	"Members deleted": "Thành viên đã xóa",
	"Are you sure_groupName": "Bạn chắc chắn muốn xóa nhóm {{a}}?",
	"Requires latest firmware": "Yêu cầu chương trình cơ sở mới nhất",
	"Selected file(s) moved_": "Đã di chuyển thành công (các) tệp được chọn",
	"Are you sure_remove driver2": "Bạn chắc chắn muốn xóa lái xe {{a}} ({{b}}) khỏi nhóm này?",
	"Invite sent": "Đã gửi lời mời",
	"Safe driving": "Lái xe an toàn",
	"Reckless driving": "Lái xe liều lĩnh",
	"Inattentive driving": "Lái xe không chú ý",
	"Driving events trend": "Xu hướng sự kiện lái xe",
	"Driving details": "Chi tiết lái xe",
	Driving: Driving,
	Idling: Idling,
	Distance: Distance,
	"Parking sessions": "Lần đỗ xe",
	"Parked time": "Parked time",
	"Idle stops": "Dừng không tải",
	"Idle time": "Thời gian không tải",
	"Impact events": "Impact Events",
	Parked: Parked,
	Speed: Speed,
	"Overspeeding alerts": "Cảnh báo quá tốc độ",
	Highest_2: Highest_2,
	Average: Average,
	Geofences: Geofences,
	"Entries into a_": "Vào khu vực",
	"Exits from a_": "Ra khỏi khu vực",
	"No data": "Không có dữ liệu",
	"Hard acceleration": "Tăng tốc",
	"Hard braking": "Phanh gấp",
	"Hard cornering": "Rẽ ngoặt",
	"The number within the brackets_": "Con số trong dấu ngoặc cho biết số sự kiện trung bình mỗi giờ lái xe. Nếu trong ngày bạn lái xe ít hơn một giờ, tổng số sự kiện sẽ được hiển thị.",
	"Did you insert_": "Bạn đã cắm thẻ SIM vào chưa?",
	"Click here for_": "<a>Nhấp vào đây</a> để biết thêm hướng dẫn chi tiết.",
	"Back up all_": "<b>Sao lưu tất cả bản ghi quan trọng trước khi lưu những cài đặt này.</b><br/>Khi bạn lưu cài đặt, thẻ microSD sẽ được khởi động lại và tất cả bản ghi sẽ bị xóa để đảm bảo hoạt động ổn định.",
	"Not connected to_": "Không kết nối với đám mây. Một số chức năng đã tạm thời bị vô hiệu hóa.",
	"GPS Location recording off": "Ghi vị trí GPS đã tắt",
	"n Videos deleted": "{{count}} Video đã xóa",
	Move: Move,
	"Driver Monitoring System (DMS) will_": "Hệ thống Giám sát Lái Xe (DMS) sẽ sớm được ra mắt.",
	"An error occured while_": "Đã xảy ra lỗi khi cố gắng thay đổi số lượng camera. Hãy thử lại",
	"Reached the limit_": "Đã đạt đến giới hạn: {{a}}",
	"An invitation was_": "Một lời mời đã được gửi đến địa chỉ email này.",
	"To use the_": "Để sử dụng tính năng đám mây. Vui lòng lắp thẻ SIM của bạn.",
	"Last updated": "Cập nhật lần cuối {{date}}",
	"Try changing your date": "Thử thay đổi ngày của bạn.",
	"No event data_": "Không có dữ liệu sự kiện nào được thu thập cho thời gian đã chọn",
	"Please select another_": "Vui lòng chọn ngày hoặc tháng khác để xem toàn bộ báo cáo.",
	"more than 6_": "yêu cầu nhiều hơn 6 ký tự",
	"Sign up free": "Đăng kí miễn phí",
	"Cloud storage warning": "Cảnh báo lưu trữ đám mây",
	"Cloud Storage Full": "Bộ nhớ lưu trữ đám mây đã đầy",
	"Cloud storage usage_100": "Mức sử dụng bộ nhớ đám mây đã đạt 100%. Vui lòng giải phóng bộ nhớ để có thể sử dụng tính năng Tải lên sự kiện trực tiếp",
	"Cloud storage usage_": "Mức sử dụng bộ nhớ đám mây đã đạt <b>({{a}}%)</b>. \nSắp xếp bộ nhớ đám mây của bạn.\nDịch vụ tải lên sự kiện trực tiếp sẽ không khả dụng nếu bộ nhớ lưu trữ đám mây đã đầy.",
	"Are you sure_delete_zone": "Bạn thực sự muốn xóa không?",
	"Search Name or email": "Tìm kiếm Tên hoặc email",
	"Search group name": "Tìm kiếm tên nhóm",
	"Please note that_": "Xin lưu ý rằng quá trình Quay video sẽ bị tạm dừng trong vài giây để áp dụng cài đặt mới.",
	"Currently connected Hotspot": "Điểm phát sóng được kết nối hiện tại",
	"Enhanced night vision": "Nhìn ban đêm cải tiến",
	"To access the_": "Để truy cập camera, vui lòng cập nhật kế hoạch đăng ký của bạn.",
	"Restarting the Blackvue_": "Khởi động lại BlackVue để áp dụng thiết lập.",
	"Hard acceleration event_": "Tình huống tăng tốc xảy ra khi tốc độ tăng mỗi giây lớn hơn {{kmh}} km/h ({{mph}} MPH)",
	"Hard braking event_": "Tình huống phanh gấp xảy ra khi tốc độ giảm mỗi \ngiây lớn hơn {{kmh}} km/h ({{mph}} MPH)",
	"Hard cornering event_": "Tình huống rẽ ngoặt xảy ra khi xe quay hơn 60 độ trong vòng 2 giây với vận tốc trên \n{{kmh}} km/h ({{mph}} MPH)",
	"Changes you made_": "Những thay đổi bạn đã thực hiện có thể không được lưu.",
	"My location": "Vị trí của tôi",
	"Hotspot name (SSID)": "Tên điểm phát sóng (SSID)",
	Connected: Connected,
	"Camera will be rebooted_": "Camera sẽ được khởi động lại. Bạn vẫn muốn tiếp tục?",
	"Restarting the BlackVue_": "Khởi động lại BlackVue. Vui lòng chờ trong giây lát.",
	"Failed to reboot_": "Không thể khởi động lại camera",
	"Bluetooth (Parking mode)": "BT (Chế độ đỗ xe)",
	"Front and interior camera_": "Camera trước và trong xe ghi hình cùng nhau.",
	"Interior camera stops_": "5 phút sau khi vào chế độ đỗ xe, camera trong sẽ dừng ghi. Chức năng ghi khởi động lại sau khi nhập chế độ thông thường.",
	Individual_: Individual_,
	"Driver detection": "Phát hiện lái xe",
	"During driving only": "Chỉ khi lái xe",
	Always: Always,
	"Driver detection box": "Hộp phát hiện lái xe",
	"DMS camera rotation": "Xoay camera DMS",
	Low: Low,
	Medium: Medium,
	High_2: High_2,
	"Reboot Camera": "Khởi động lại camera",
	"Latest events": "Sự kiện gần nhất",
	"G-Sensor": "G-Sensor",
	"Playback speed": "Tốc độ phát lại",
	Flip: Flip,
	Previous: Previous,
	Next: Next,
	"Map type": "Loại bản đồ",
	"Zoom in": "Phóng to",
	"Zoom out": "Thu nhỏ",
	"Move to Cloud": "Di chuyển đến đám mây",
	"Please recognize that_": "Vui lòng nhận biết rằng quá trình quay Video sẽ tạm dừng trong vài giây để áp dụng cài đặt.",
	"6 characters with_": "6 ký tự với sự kết hợp của các chữ cái, số và ký hiệu",
	"Updating firmware": "Đang cập nhật chương trình cơ sở",
	"Overspeed event occurs_": "Tình huống vượt quá tốc độ xảy ra khi camera hành trình cảnh báo người lái đã vượt quá tốc độ cho phép. Bạn có thể thay đổi nó trên Chương trình cơ sở > Hệ thống > Âm lượng",
	"Enter group name": "Nhập tên nhóm",
	"Live view failed": "Xem Trực tiếp thất bại.",
	"Parking mode enter_": "Chế độ đỗ xe Vào/Ra",
	"Cloud connectivity": "Kết nối cloud",
	Expand: Expand,
	Collapse: Collapse,
	"all day": "Cả ngày",
	"Driving style": "Phong cách lái xe",
	"Driving impact": "Tác động lái xe",
	More: More,
	"No cameras to_": "Không có camera để thêm",
	"You have added_": "Bạn đã thêm tất cả camera khả dụng.",
	Multi: Multi,
	"Report video": "Báo cáo video",
	"Sexually explicit content": "Nội dung tình dục",
	"Graphic violence": "Bạo lực hoặc kinh khủng",
	"Hateful speech": "Thù ghét hoặc lạm dụng",
	"Harassment or bullying": "Quấy rối hoặc bắt nạt",
	"Spam or advertisement": "Thư rác hoặc quảng cáo",
	"Infringement of my_": "Vi phạm quyền lợi của tôi",
	"Other reason": "Khác",
	"Reason for reporting": "Lý do báo cáo",
	"Reported videos will_": "Các video được báo cáo sẽ được kiểm tra trong vòng 72 giờ. Video sẽ không được hiển thị trên bản đồ sự kiện cho đến khi được xác nhận rằng video đó phù hợp để đăng trên bản đồ sự kiện.",
	"Touch sensor": "Cảm biến chạm",
	"Motion and impact detection": "Phát hiện chuyển động và tác động",
	"Settings have been changed": "Cài đặt đã được thay đổi",
	"Start event recording (beep)": "Bắt đầu ghi sự kiện (bíp)",
	"Scheduled reboots": "Đã đặt lịch khởi động",
	Safe: Safe,
	Reckless: Reckless,
	Inattentive: Inattentive,
	"Highest(Extreme)": "Cao nhất (Cực hạn)",
	"Public cameras": "Camera công cộng",
	List: List,
	Usage: Usage,
	"Video playbacks and downloads": "Phát và tải về video",
	"of 100 times": "trong 100 lần",
	"of 10 minutes": "trong 10 phút",
	Profile: Profile,
	"Search geofences": "Tìm kiếm địa lý ảo",
	"Export CSV": "Xuất CSV",
	"Exit fullscreen": "Thoát toàn màn hình",
	Fullscreen: Fullscreen,
	Upgrade: Upgrade,
	"Email address": "Địa chỉ email",
	"of Unlimited": "trong Không giới hạn",
	"No notifications yet": "Không có thông báo nhận được trong 7 ngày qua.",
	"No videos yet": "Chưa có video nào",
	Management: Management,
	Day: Day,
	Month: Month,
	"Welcome to the BlackVue_": "Chào mừng đến với BlackVue Cloud Viewer",
	"You can access BlackVue_": "Bạn có thể truy cập BlackVue Cloud qua web từ mọi lúc, mọi nơi!",
	"Start tour": "Bắt đầu chuyến đi",
	"Map view": "Xem bản đồ",
	"Check the current_": "Kiểm tra vị trí GPS hiện tại, tốc độ camera của bạn và camera công cộng.",
	"Camera’s features": "Tính năng của camera",
	"Take a look_": "Hãy xem các tính năng khác nhau liên quan đến Đám mây do BlackVue Camera cung cấp.",
	"Visualize your vehicle’s_": "Trực quan hóa lộ trình lái xe theo thời gian.",
	"Smart plan_": "Gói thông minh: 90 ngày, Gói cho đội xe : 90 ngày",
	"Create geofences and2_": "Tạo rào chắn địa lý ảo và nhận thông báo theo thời gian thực.",
	"Got it": "Đã xong",
	"Manage Fleet members": "Quản lý Thành viên đội xe",
	"Invite fleet members_": "Mời thành viên đội xe và chỉ định họ vào từng nhóm.",
	"The moment the_": "Thời điểm camera phát hiện tác động, thông báo sẽ được liệt kê ở đây.",
	"Geofence Setup (Web)_": "Thiết lập địa lý ảo (web/máy tính để bàn) và cảnh báo",
	"Original file play_": "Phát tệp gốc chỉ khả dụng để tải về",
	"To get most_": "Để tận dụng tối đa BlackVue Cloud viewer, camera của bạn phải kết nối với Đám mây. Tải về ứng dụng BlackVue và trải nghiệm tính năng Ghép nối không gián đoạn, xuyên suốt từ việc bổ sung camera đến kết nối Đám mây!",
	"You haven’t driven_Today": "Hôm nay, bạn chưa lái xe của mình. Hãy thử lái xe với BlackVue để kiểm tra báo cáo lái xe của bạn.",
	"You haven’t driven_Month": "Tháng này, bạn chưa lái xe của mình. Hãy thử lái xe với BlackVue để kiểm tra báo cáo lái xe của bạn.",
	"Fleet Plan only_": "Chỉ có Gói cho đội xe",
	"Overwrite locked event2_": "Ghi đè tập tin sự kiện bị khóa khi bộ nhớ đầy",
	"DMS’s New firmware_": "Có chương trình cơ sở mới của DMS",
	"Highest speed_report": "<b>Tốc độ cao nhất</b>\nGiá trị lớn nhất đã thu thập của dữ liệu vận tốc được tính theo đơn vị Mét Chuyển đổi sang đơn vị Km/h và MPH\n\nTốc độ trung bình</b>\n(Khoảng cách / số giờ lái xe) *3600 là ra tốc độ trung bình. Ví dụ (2622 / 1208 ) *3600 = 7814,907\nKm/h: Chỉ dùng số nguyên, \nphần thập phân của MPH lấy tối đa 2 chữ số",
	"Choose a cloud_": "Chọn phương thức kết nối Đám mây",
	"You need an_": "Bạn cần có Internet để kết nối với đám mây. Chọn thiết bị đang sử dụng để kết nối với đám mây.",
	"BlackVue SIM card": "Thẻ SIM BlackVue",
	"Support model_": "Kiểu máy hỗ trợ: DR750X-2CH LTE Plus (NA)",
	"3rd party SIM_": "Thẻ SIM của bên thứ 3",
	"Support model_SIM": "Kiểu máy hỗ trợ: DR750X-2CH LTE Plus, DR750-2CH LTE, CM100 LTE",
	"Wi-fi hotspot": "Điểm phát sóng Wi-Fi",
	"Support model_Wifi": "Kiểu máy hỗ trợ: Tất cả kiểu máy BlackVue",
	"How to connect_": "Cách kết nối với Đám mây",
	"Download BlackVue application": "Tải về ứng dụng BlackVue.",
	"*If you are_": "*Nếu bạn định sử dụng thẻ SIM BlackVue cho kết nối Đám mây, hãy chuyển đến {{a}} {{b}}.",
	"Place your phone_": "Đặt điện thoại của bạn nằm trong phạm vi Bluetooth của camera. Bắt đầu Ghép nối không gián đoạn với {{a}}.",
	"Back to camera_": "Quay lại danh sách camera",
	"Upgrade for more_": "Nâng cấp để có nhiều tính năng hơn!",
	"Upgrading the cloud_": "Nâng cấp gói đám mây cho phép bạn tận hưởng nhiều tính năng hơn và quản lý nhiều camera. Bạn có muốn nâng cấp gói đám mây không?",
	"Explore cloud plans": "Khám phá các gói đám mây",
	Later: Later,
	"Successfully subscribed": "Đăng ký thành công!",
	"1GB data plan": "Gói dữ liệu 1GB",
	"First month free_": "Miễn phí tháng đầu tiên, <a>sau đó là 10,99 USD/tháng</a>",
	"Next billing date": "Ngày thanh toán tiếp theo",
	"Once SIM card_": "Sau khi lắp thẻ SIM vào camera, bạn có thể khởi động các tính năng BlackVue Cloud ngay lập tức.",
	"Go to SIM_": "Đến phần Quản lý SIM",
	"Manage your BlackVue_": "Quản lý thẻ SIM BlackVue của bạn tại đây!",
	"Recommended for BlackVue_": "Khuyên dùng với người sở hữu SIM BlackVue",
	"Connect to cloud": "Kết nối với đám mây",
	"Enter BlackVue SIM_": "Nhập số ICCID của SIM BlackVue",
	"ICCID number is_": "Số ICCID được in trên gói thẻ SIM. Vui lòng nhập 14 chữ số cuối của số ICCID.",
	ICCID: ICCID,
	"SIM information": "Thông tin SIM",
	"Start your free_": "Bắt đầu dùng thử miễn phí ngay bây giờ",
	"SIM card activate_": "Ngày kích hoạt thẻ SIM",
	"Based on the_": "Dựa trên ngày thẻ SIM được lắp vào camera và được kích hoạt khi có nguồn điện",
	"Upgrade to 3GB_": "Nâng cấp lên gói 3GB/5GB bất kỳ lúc nào",
	"Cancel your plan_": "Có thể hủy gói bất kỳ lúc nào",
	"No Commitment": "Không cam kết",
	"Precautions for using_": "Các lưu ý khi sử dụng dịch vụ",
	"After 1GB is_": "Sau khi hết 1GB dữ liệu, bạn sẽ không thể truy cập Internet được nữa.",
	"If you have_": "Nếu bạn đã lắp thẻ SIM vào camera và đang sử dụng thì thời gian dùng thử miễn phí sẽ tính từ khi bắt đầu sử dụng.",
	"This content is_": "Nội dung này được chỉ định trong gói SIM. Chúng tôi không hỗ trợ bồi thường cho những khoảng thời gian miễn phí chưa được cung cấp.",
	"If you have_2": "Nếu có thêm câu hỏi, vui lòng liên hệ với <a>Bộ phận CSKH</a>",
	"When OFF, connecting_": "Khi Tắt, kết nối camera qua tính năng Ghép nối không gián đoạn cũng bị tắt.",
	"1 month free": "1 tháng miễn phí",
	"No commitment. Cancel_": "Không cam kết. Hủy bất kỳ lúc nào.",
	"The video has been reported_": "Video đã được báo cáo thành công",
	"Free for 1 month": "Miễn phí 1 tháng",
	"Start your free_2": "Bắt đầu dùng thử miễn phí",
	"1GB free for_": "Miễn phí 1GB trong {{a}} ngày",
	"1GB data": "1GB dữ liệu",
	"1 month free_2": "Thời gian 1 tháng dùng thử miễn phí được tính từ {{a}}, bao gồm 1GB dữ liệu cho thẻ SIM Blackvue.",
	"Your next billing_": "Ngày thanh toán tiếp theo là {{a}}",
	"SIM card": "Thẻ SIM",
	"SIM guide": "Hướng dẫn SIM",
	"SIM card list": "Danh sách thẻ SIM",
	"Add SIM card": "Thêm thẻ SIM",
	"No SIM card_": "Chưa có thẻ SIM",
	"Search SIM ICCID_": "Tìm kiếm ICCID của SIM hoặc tên",
	"Cloud disconnected. Failed_": "Đám mây bị ngắt kết nối. Không thể phát video",
	"This sim card_": "Thẻ sim này đã được đăng ký cho một tài khoản khác.",
	"Incorrect BlackVue SIM_": "ICCID của SIM BlackVue không chính xác",
	"My shared videos": "Video đã chia sẻ của tôi",
	"Number of events": "Số lượng sự kiện",
	"Added to Event Map": "Đã thêm vào Bản đồ Sự kiện",
	"Successfully added video(s)_": "Đã thêm thành công (các) video để chia sẻ vào Bản đồ Sự kiện! Nếu muốn kiểm tra trạng thái và quản lý các video được chia sẻ, hãy chuyển đến Bản đồ Sự kiện > Video được chia sẻ của tôi.",
	"Already added to_": "Đã được thêm vào Bản đồ Sự kiện",
	"This video(s) is already added_": "Những video này đã được thêm vào Bản đồ Sự kiện! Nếu muốn kiểm tra trạng thái và quản lý các video được chia sẻ, hãy chuyển đến Bản đồ Sự kiện > Video được chia sẻ của tôi.",
	"BlackVue’s firmware is up_": "Chương trình cơ sở của BlackVue đã được cập nhật",
	"Service end": "Kết thúc dịch vụ",
	Resubscribe: Resubscribe,
	"Sort ascending": "Sắp xếp tăng dần",
	"Sort descending": "Sắp xếp giảm dần",
	plan: plan,
	USD: USD,
	"Are you sure_Cancel": "Bạn có chắc chắn muốn hủy đăng ký không? Vui lòng lưu ý những điều sau và xác nhận xuống phía dưới.",
	"Your current SIM_": "Gói thẻ SIM đăng ký hiện tại của bạn kết thúc vào {{a}} và bạn sẽ không bị tính phí nữa.",
	"After canceling your_": "Sau khi hủy đăng ký thẻ SIM, bạn sẽ tiếp tục sử dụng dữ liệu SIM cho đến ngày kết thúc đăng ký.",
	"You can resubscribe_": "Bạn có thể đăng ký lại trong vòng 1 tháng sau khi đăng ký hiện tại kết thúc. Nếu muốn đăng ký lại, vui lòng nhấp vào nút \"Đăng ký lại\" trong danh sách thẻ SIM trước {{a}}.",
	"Reason to cancel_": "Lý do hủy đăng ký",
	"Found an alternative": "Đã tìm thấy giải pháp thay thế",
	"Too expensive": "Chi phí cao",
	"Not required anymore": "Không cần thiết nữa",
	"Quality issue": "Vấn đề chất lượng",
	etc_: etc_,
	"Please describe in_": "Vui lòng mô tả chi tiết",
	"SIM card cannot_": "Không thể xóa vì thẻ SIM này đang được đăng ký. Nếu muốn xóa thẻ SIM này, trước tiên hãy hủy đăng ký của bạn.",
	"SIM card cannot_2": "Không thể xóa thẻ SIM vì đăng ký của thẻ SIM này vẫn chưa kết thúc. Vui lòng thử lại sau khi kết thúc thời hạn đăng ký.",
	"Are you sure_deleteSIM": "Bạn chắc chắn muốn xóa thẻ SIM này?<br/>\n<b>Cảnh báo: Bạn không thể hoàn tác thao tác này. Tất cả thông tin thẻ SIM của bạn sẽ bị xóa ngay lập tức.</b>",
	"ICCID number": "Số ICCID",
	"Activation date": "Ngày kích hoạt",
	"Current plan": "Gói hiện tại",
	"Manage Plan": "Quản lý Gói",
	"Next billing on": "Thanh toán tiếp theo vào",
	"View Invoices": "Xem Hóa đơn",
	"Choose best plan_": "Chọn gói tốt nhất cho bạn",
	"Plan summary": "Tóm tắt về gói",
	"Ends on_": "Kết thúc vào {{a}}",
	"Start from_": "Bắt đầu từ {{a}}",
	"Your subscription will_": "Đăng ký sẽ được nâng cấp vào {{a}}, sau khi gói hiện tại kết thúc.",
	"Resubscribe plan": "Đăng ký lại gói",
	"Your subscription will2_": "Đăng ký sẽ bắt đầu vào {{a}}, sau khi gói hiện tại kết thúc.",
	"Usage is estimated_": "Mức sử dụng được ước tính kể từ {{a}}",
	"Days left_": "{{a}} Ngày còn lại",
	"Data usage cycle": "Chu kỳ sử dụng dữ liệu",
	Available: Available,
	Used: Used,
	"Data used": "Dữ liệu đã sử dụng",
	"Subscribe to n_": "Thời hạn đăng ký gói dữ liệu {{a}} được áp dụng <b>từ {{b}} đến {{c}}</b> và gói dữ liệu {{d}} được áp dụng từ {{e}}",
	"Will be charged_": "Sẽ bị tính phí vào {{a}}",
	"Monthly usage": "Mức sử dụng hàng tháng",
	"You have fewer_": "Bạn chỉ còn một chút dữ liệu cho tháng này!",
	"Get more data": "Nhận thêm dữ liệu!",
	"This video cannot be shared": "Không thể chia sẻ video này",
	"This is a video cannot be shared_": "Không thể chia sẻ video này vì không tìm thấy thông tin lái xe tại thời điểm đó.",
	Cancelled: Cancelled,
	Terminated: Terminated,
	"Edit name": "Chỉnh sửa tên",
	"Not connected to_2": "Không kết nối với đám mây. Kiểm tra xem camera của bạn đã bật hay chưa và mô-đun kết nối Internet bật hay chưa.",
	"Some functionality is disabled_": "Một số chức năng bị tắt do camera chưa được kết nối với Đám mây. Kết nối với đám mây <a>tại đây</a>.",
	"If you want to cancel_": "Nếu muốn hủy gói của mình, hãy nhấp vào <a>Hủy đăng ký</a>.",
	"Select plan": "Chọn gói",
	"Event map collects_": "Bản đồ sự kiện sẽ thu thập và trực quan hóa thông tin sự kiện BlackVue để cung cấp các tình huống của những tuyến đường xung quanh.",
	"Share your Live_": "Chia sẻ tệp tải lên Sự kiện trực tiếp của bạn. Bạn có thể chia sẻ video sự kiện của mình với những người dùng khác xung quanh.",
	"You can check_": "Bạn có thể xem các video sự kiện được chia sẻ bởi những người khác.",
	"Service end_": "Kết thúc dịch vụ: {{a}}",
	"DMS camera recording_": "Ghi camera DMS ở chế độ đỗ xe",
	Sort: Sort,
	"Are you sure you want_": "Bạn chắc chắn muốn xóa video đã chia sẻ khỏi Bản đồ Sự kiện?",
	"Remove shared video": "Xóa video đã chia sẻ",
	"Explore event map": "Khám phá bản đồ sự kiện",
	"Event map": "Bản đồ sự kiện",
	"Explore the graphic_": "Khám phá số liệu thống kê đồ họa về các sự kiện BlackVue xảy ra xung quanh bạn.",
	"You can filter_": "Bạn có thể lọc và xem các sự kiện muốn hiển thị.",
	"This video was removed by_": "Video này đã được quản trị viên báo cáo và xóa.",
	Bonus: Bonus,
	"Your subscription plan": "Gói đăng ký của bạn",
	"Your free trial will_": "Thời gian dùng thử miễn phí của bạn sẽ bắt đầu từ {{a}},</br><strong>cho đến</strong> {{b}}.",
	"Total after free trial": "Tổng số sau khi dùng thử miễn phí",
	"This sim card is_": "Thẻ sim này không còn hoạt động.",
	"Firmware is up_": "Chương trình cơ sở được cập nhật",
	"Keep in mind": "Ghi nhớ",
	"Once 1GB of_": "Sau khi dùng hết 1GB dữ liệu, dịch vụ sẽ không khả dụng cho đến ngày Đặt lại dữ liệu tiếp theo [hoặc sau khi bạn nâng cấp lên gói cao hơn].",
	"After the SIM_": "Sau khi lắp thẻ SIM vào camera, thời gian dùng thử miễn phí sẽ được tính từ khi bắt đầu sử dụng dữ liệu.",
	"If you have_questions": "Nếu có bất kỳ câu hỏi nào, vui lòng liên hệ với <a>Bộ phận Chăm sóc Khách hàng</a> của chúng tôi.",
	"Data reset date": "Ngày đặt lại dữ liệu",
	"To use SIM card_": "Để sử dụng thẻ SIM, vui lòng liên hệ với <a>Bộ phận CSKH</a> của BlackVue",
	"Go to Subscription": "Đến phần Đăng ký",
	"An error occurred_subscription": "Đã xảy ra lỗi khi đăng ký gói đã chọn.",
	"Please try again": "Vui lòng thử lại",
	"Failed to subscribe": "Không đăng ký được",
	"Go to Pricing": "Đến phần Giá",
	"SIM cards will_": "Thẻ SIM sẽ hiển thị ở đây khi khả dụng.",
	"1GB for 1_": "1GB trong 1 tháng",
	"Pricing Data": "Giá Dữ liệu",
	"If you would like to check_": "Nếu muốn kiểm tra trạng thái và quản lý các video được chia sẻ, hãy chuyển đến Bản đồ Sự kiện > Video được chia sẻ của tôi.",
	"Connect to Cloud": "Kết nối với Đám mây",
	"Completed!": "Hoàn thành!",
	"Back to App": "Quay lại Ứng dụng",
	"iOS in-app purchase": "Mua ứng dụng trong iOS",
	"Android in-app_": "Mua ứng dụng trong Android",
	"bonus n days": "tặng thêm {{a}} ngày",
	"Want to contribute your_": "Cho phép tự động chia sẻ lên Bản đồ Sự kiện các tệp Sự kiện tự động tải lên?",
	"With event map_": "Bạn có thể chia sẻ video Sự kiện tự động tải lên với các tài xế lân cận thông qua bản đồ sự kiện.",
	"You can edit_3": "Bạn có thể chỉnh sửa cài đặt Tự động chia sẻ tệp Sự kiện tự động tải lên bất kỳ lúc nào bằng cách đến phần BLACKVUE CLOUD > Cài đặt camera > Cài đặt Quyền riêng tư.",
	"If you want to remove videos_": "Vì video cá nhân có thể được truyền đi, nên bạn cần đặc biệt cẩn thận trong việc quyết định thông tin mình chia sẻ.",
	"Total events": "Tổng số sự kiện",
	"Automatically add Live Event_": "Tự động chia sẻ lên Bản đồ Sự kiện các tệp Sự kiện tự động tải lên",
	"This camera is publicly_": "Camera này chỉ được mở công khai cho vị trí của nó.",
	incomplete_zip: incomplete_zip,
	"Live Event Upload_": "Tải lên Sự kiện Trực tiếp (Thời gian lưu trữ: 7 ngày)\nYêu cầu chương trình cơ sở mới nhất",
	"Thank you for_2": "Cảm ơn vì sự kiên nhẫn của bạn.",
	"Start Web viewer": "Khởi động Trình xem web",
	"Are you sure_remove driver": "Bạn có chắc chắn muốn xóa vĩnh viễn tài xế không",
	"An error occurred_sim": "Đã xảy ra lỗi khi cố gắng đăng ký.",
	"Click the ADD SIM": "Nhấp vào nút THÊM SIM trên trang danh sách Thẻ SIM, sau đó thực hiện lại quy trình thêm sim.",
	"Set download options": "Đặt các tùy chọn tải về",
	"Information may be_": "Information may be transmitted with a delay and may not reflect actual balances.",
	"Swipe left and right to move": "Vuốt sang trái và phải để di chuyển",
	"Scheduled maintenance Notice": "Thông báo Bảo trì Theo lịch",
	"Our Cloud server_": "Máy chủ Đám mây của chúng tôi sẽ được bảo trì theo lịch xếp trước.",
	"During that time_": "Trong thời gian đó, các tính năng Đám mây có thể không khả dụng.",
	"Expected maintenance start_": "Thời gian dự kiến bắt đầu bảo trì:",
	"Expected duration_": "Thời lượng dự kiến: {{a}} giờ.",
	"For more information_": "Để biết thêm thông tin, vui lòng tham khảo <a>[Thông báo Bảo trì Máy chủ]</a>",
	"Do not remind_": "Không nhắc lại nữa",
	"Cloud Server Maintenance": "Bảo trì Máy chủ Đám mây",
	"BlackVue Cloud Service_": "Dịch vụ Đám mây BlackVue tạm thời không khả dụng",
	"We are currently_": "Chúng tôi hiện đang tiến hành bảo trì.",
	"We apologize for_": "Xin lỗi vì sự bất tiện này.",
	"Driver Monitoring System (DMS)": "Hệ thống giám sát tài xế (DMS)",
	"Distracted occurs_": "Xảy ra khi đầu của tài xế cách xa phía trước hơn 50 độ.",
	"Hand distraction event occurs_": "Xảy ra khi tay lái của tài xế được phát hiện gần đầu trong một khoảng thời gian kéo dài (như khi hút thuốc, cầm điện thoại, v.v.).",
	"Mask off event occurs_": "Xảy ra khi tài xế lên xe mà không đeo khẩu trang hoặc khi tài xế tháo khẩu trang.",
	"DMS setting": "Cài đặt DMS",
	"The DMS system has_": "DMS kết hợp hộp phát hiện khuôn mặt cho các trạng thái \"Phát hiện\", \"Không phát hiện\", \"Lạc đề\", \"Buồn ngủ\", \"Mất khẩu trang\" và hộp phát hiện chuyển động cho trạng thái \"Lạc tay\".",
	"DMS detection": "Phát hiện DMS",
	"There are detection criteria for_": "Có tiêu chí phát hiện cho mỗi sự kiện. Vui lòng tham khảo hướng dẫn bên dưới.",
	"DMS camera recording_onoff": "Bật: Camera DMS ghi hình trong Chế độ Đỗ xe miễn là có nguồn điện. <br/> Tắt: Camera DMS tắt ngay sau khi vào Chế độ Đỗ xe.",
	"LED lighting for each event_": "Đèn LED trên Camera Giám sát Tài xế sẽ hiển thị mỗi sự kiện phát hiện (Lơ đễnh, Buồn ngủ, v.v.).\n",
	"Drowsy and Distracted each have_": "Buồn ngủ và Mất tập trung đều có ba trạng thái độ nhạy. Vui lòng tham khảo giao diện hướng dẫn bên dưới.",
	"DMS event detection sensitivity": "Độ nhạy phát hiện sự kiện DMS",
	"Only drowsy and distracted include_": "Chỉ buồn ngủ và mất tập trung có bao gồm cài đặt độ nhạy. Ngoài ra, độ nhạy cài đặt áp dụng cùng độ nhạy cho hai sự kiện theo một cài đặt.",
	"When driver’s eyes close_": "Xảy ra khi tài xế nhắm mắt trong lúc lái xe hơn 1 giây hoặc ngáp trong 2 giây.\n",
	"n digit": "{{a}} chữ số",
	"You are subscribed_free_Smart": "Bạn đã đăng ký gói Thông minh của BlackVue Cloud.",
	"Wi-Fi auto turn on": "Wi-Fi tự động bật",
	"Video on a map": "Video on a map",
	"This feature is only_vom": "This feature is only available to users with a Fleet Plan subscription.<br/>Please subscribe to a plan to unlock this feature.",
	"Total n days_": "Trải nghiệm miễn phí trong {{a}} ngày",
	"Every events of DMC200_": "Các tính năng phát hiện DMS chỉ hoạt động trong Chế độ Bình thường. Nếu được cấp điện trong Chế độ Đỗ xe, máy quay DMS chỉ ghi video.",
	"An undetected event occurs_": "Xảy ra khi tài xế không được phát hiện trước camera trong 1 phút.",
	"A detected event occurs_": "A detected Event occurs when the driver is gazing in front since the power is set in the beginning.",
	"Drowsy sensitivity_": "High : When the driver closes their eyes for more than 1 second, it is considered drowsy driving.<br/><br/>Medium : When the driver closes their eyes for more than 1.5 second, it is considered drowsy driving.<br/><br/>Low : When the driver closes their eyes for more than 2 second, it is considered drowsy driving.",
	"Distracted sensitivity_": "High : If the angle of the head is more than 50 degrees away from the front for 3 seconds, it is detected as Distracted.<br/><br/>Medium : If the angle of the head is more than 50 degrees away from the front for 5 seconds, it is detected as Distracted.<br/><br/>Low : If the angle of the head is more than 50 degrees away from the front for 7 seconds, it is detected as Distracted.",
	"Start your subscription now": "Bắt đầu đăng ký của bạn ngay bây giờ",
	"Free trial period has expired": "Thời gian dùng thử miễn phí đã hết hạn",
	"1 data plan will start from_": "Gói dữ liệu sẽ bắt đầu từ {{a}} bao gồm 1GB dữ liệu cho thẻ SIM Blackvue.",
	"Allow the BlackVue_": "Cho phép ứng dụng BlackVue truy cập dữ liệu GPS của camera hành trình?",
	"We use this_": "Chúng tôi sử dụng tính năng này để cho phép bạn theo dõi vị trí và tốc độ xe của bạn.",
	"You can edit_": "Bạn có thể chỉnh sửa cài đặt truy cập GPS bất kỳ lúc nào bằng cách truy cập vào BLACKVUE CLOUD > Cài đặt camera > Cài đặt bảo mật.",
	"SIM cards": "Thẻ SIM",
	"Subscription status": "Tình trạng thuê bao",
	Upgrades: Upgrades,
	"Upgrade plan": "Nâng cấp gói",
	"Manage plan": "Quản lý gói đăng ký",
	"Next plan": "gói đăng ký cho tháng tiếp theo",
	OR: OR,
	"Cancel subscription": "Hủy đăng ký",
	Undo: Undo,
	Invoice: Invoice,
	"Daily usage": "Sử dụng dữ liệu hàng ngày",
	"Delete SIM": "SIM Xóa",
	"New card": "Thẻ tín dụng mới",
	data: data,
	"SIM card data_": "Có thể hủy đăng ký gói dữ liệu thẻ SIM tại <a>sim.blackvuecloud.com</a>.",
	"Your plan from_": "Hôm nay đến hạn thanh toán tiếp theo cho gói của bạn",
	"Applied during_": "Đã áp dụng trong {{a}} ~ {{b}}",
	"From today until_": "Từ hôm nay cho đến ngày thanh toán tiếp theo, bạn chỉ có thể đăng ký gói cước giống như tháng trước. Các khoản thanh toán cho khoảng thời gian này sẽ được lập hóa đơn ngay hôm nay. <a>Phí được tính trên cơ sở chia theo tỷ lệ.</a>",
	"Choose your next plan": "Chọn gói tiếp theo của bạn",
	"Applied from_": "Đã áp dụng từ {{a}}",
	"Payment for this_": "Thanh toán cho gói này sẽ được tính vào {{a}}.",
	"By sharing your_2": "Bằng cách chia sẻ chức năng Xem trực tiếp, bạn có thể cho phép người dùng khác gián tiếp trải nghiệm đầy lý thú và thú vị của việc lái xe khắp nơi trên thế giới. Tuy nhiên, vì video cá nhân của bạn có thể được truyền đi, bạn cần đặc biệt chú ý quyết định xem nên chia sẻ thông tin nào.",
	"Option camera recording_": "Tùy chọn ghi camera ở chế độ đỗ xe",
	"Front and option camera_": "Camera trước và tùy chọn ghi lại cùng nhau.",
	"Option camera stops_": "Camera tùy chọn dừng quay 5 phút sau khi vào chế độ đỗ. Chức năng ghi khởi động lại sau khi nhập chế độ thông thường.",
	"Option camera rotation": "Xoay camera tùy chọn",
	"Option camera": "Camera tùy chọn",
	"Option camera security": "Tùy chọn Bảo mật camera",
	"Resubscribe until_": "Đăng ký lại cho đến khi: {{a}}",
	"Firmware Update Caution": "Cẩn trọng khi cập nhật chương trình điều khiển",
	"Please check below_": "Vui lòng kiểm tra điều kiện bên dưới trước khi cập nhật chương trình điều khiển cho DMC200:",
	"The camera's Wi-Fi_": "Wi-Fi của camera phải được bật.",
	"Check if your_": "Kiểm tra xem WI-FI của camera của bạn đã bật chưa.",
	"DO NOT disconnect_": "KHÔNG ngắt kết nối cáp đồng trục trong khi cập nhật chương trình điều khiển.",
	"The camera and_": "Camera và DMC200 có thể bị hỏng.",
	"DO NOT try_": "KHÔNG cố gắng sử dụng các tính năng khác cho đến khi quá trình khởi động lại camera hoàn tất.",
	"Expecially Reboot camera_": "Đặc biệt là khởi động lại camera, định dạng thẻ SD có thể rất quan trọng đối với việc hỏng hai thiết bị.",
	"Update anyway": "Vẫn cập nhật",
	"Invited on_2": "được bạn mời vào {{Invited Date}} bởi bạn. Chủ sở hữu",
	"BlackVue’s New firmware_": "Đã có chương trình điều khiển mới của BlackVue",
	"valid thru_": "hợp lệ thông qua: {{a}}",
	"Billed monthly": "Billed monthly",
	"90 minutes Live_": "90 minutes Live View / Live Event Upload*",
	"or 2+ videos_": "or 2+ videos in full resolution*",
	"1GB Free Month_": "1GB Free Month Trial",
	"Cancel anytime": "Cancel anytime",
	"8+ hours Live_": "8+ hours Live View / Live Event Upload*",
	"or 12+ videos_": "or 12+ videos in full resolution*",
	"15+ hours Live_": "15+ hours Live View / Live Event Upload*",
	"or 23+ videos_": "or 23+ videos in full resolution*",
	Popular: Popular,
	"For Power Users": "For Power Users",
	"Estimates based on_": "* Estimates based on 4.5MB per minute of Live View, Quick View remote playback, or Live Event Upload file, and 190MB per full original resolution video download or playback (at 25Mbps bitrate). Daily idle Cloud connection data usage: 20MB per 24 hours. Data usage is shared among all types of services (Live View, Live Event Upload, etc.).",
	"Balanced Plan": "Balanced Plan",
	"For Light Cloud_": "For Light Cloud Use",
	"Front security (Normal mode)": "Cảnh báo phía trước (Chế độ thường)",
	"Front security (Parking mode)": "Cảnh báo phía trước (Chế độ đỗ)",
	"BT (Parking mode)": "BT (Chế độ đỗ)",
	"LTE (Parking mode)": "LTE (Chế độ đỗ)",
	"Wi-Fi (Parking mode)": "Wi-Fi (Chế độ đỗ)",
	"Hand distraction": "Tay không tập trung",
	Mask: Mask,
	"Second drowsy is_": "Buồn ngủ lần thứ hai là trạng thái buồn ngủ xảy ra trong vòng 30 giây kể từ khi buồn ngủ đầu tiên bắt đầu ghi hình tải lên sự kiện trực tiếp.",
	"Second drowsy alert": "Cảnh báo buồn ngủ lần thứ hai",
	"BlackVue sim card_": "Thẻ sim BlackVue chỉ có thể được sử dụng ở Canada và Hoa Kỳ.",
	"Global support is coming soon.": "Sắp ra mắt chế độ hỗ trợ toàn cầu.",
	"The video file not found_": "Không tìm thấy tệp video hoặc đã xảy ra sự cố khi phát. Vui lòng Thử lại.",
	"Start Voice Call": "Bắt đầu Cuộc Gọi Thoại",
	"End Voice Call": "Kết thúc Cuộc Gọi Thoại",
	"Voice call in use": "Đang sử dụng cuộc gọi thoại",
	"Enable microphone access_": "Bật quyền truy cập micrô để sử dụng chức năng giao tiếp bằng giọng nói hai chiều. Truy cập trang cài đặt trình duyệt để truy cập micrô của bạn.",
	"You may need to_": "Bạn có thể cần tải lại trang này để cài đặt mới có hiệu lực.",
	"Eye status": "Tình trạng mắt",
	"Start time of live event upload video": "Thời gian bắt đầu của video tải lên sự kiện trực tiếp",
	"Left eye": "Mắt trái",
	"Right eye": "Mắt phải",
	"Drowsy is occured when the driver close his/her eyes more then 1sec": "Buồn ngủ xảy ra khi người lái xe nhắm mắt hơn 1 giây",
	"Driver's Left eye movements with blinking count and period": "Chuyển động Mắt Trái của người lái xe với số lần nhấp nháy và số lượng chu kỳ và khoảng thời gian",
	"Driver's Right eye movements with blinking count and period": "Chuyển động Mắt Phải của người lái xe với số lần nhấp nháy và khoảng thời gian",
	"Drowsy big data of the driver and after a Drowsy event occurs": "Dữ liệu lớn nháy mắt của trình điều khiển sau khi xảy ra sự kiện Buồn ngủ",
	"Sharing video to Event Map": "Chia sẻ video lên Bản đồ Sự kiện",
	"Want to use a Voice call?": "Bạn muốn sử dụng Cuộc Gọi Thoại?",
	"To use a voice call_": "Để sử dụng cuộc gọi thoại, hãy khởi động lại Chế độ Xem Trực Tiếp và nhấn “Cho phép”",
	"There is no_": "Không có video được chia sẻ nào. \nDanh sách sẽ xuất hiện khi được chia sẻ.",
	"Microphone blocked": "Micrô bị chặn",
	"Want to center the map on your location?": "Muốn căn giữa bản đồ vào vị trí của bạn?",
	"To let the app access your location_": "Để cho phép ứng dụng truy cập vị trí của bạn, hãy khởi động lại Event Map và chọn \"OK\" khi được nhắc.",
	"Location access permission required": "Quyền truy cập vị trí là bắt buộc.",
	"Are you sure you want_2": "Bạn có chắc chắn muốn xóa video này khỏi Event Map không?",
	"Two-way voice_2": "Two-way voice communication / Voice Call",
	"Not supported by DR650GW and DR650S_": "Not supported by DR650GW and DR650S",
	"DR650S Series only_": "DR650S Series only",
	"Cancel download?": "Hủy tải xuống?",
	"Your download is not_": "Quá trình tải xuống của bạn chưa hoàn tất. Bạn có muốn hủy tải xuống không?",
	"Continue download": "Tiếp tục tải xuống",
	"Cancel download": "Hủy tải xuống",
	"Share your video to the Event Map?": "Chia sẻ video của bạn lên Bản Đồ Sự Kiện?",
	"Afterwards, according to the reaction to the video_": "Sau đó, dựa theo phản ứng với video, video có thể được phân loại là video phổ biến và được giới thiệu trên video phổ biến.",
	"Add hashtags and a brief description to describe your video.": "Thêm thẻ bắt đầu bằng # và mô tả ngắn gọn để mô tả video của bạn.",
	"Would you like_": "Bạn có muốn chia sẻ lên Bản đồ Sự kiện không?",
	"Successfully added video_": "Đã thêm thành công video để chia sẻ vào Bản đồ Sự kiện!",
	"This video cannot_": "Không thể chia sẻ video này vì thiếu dữ liệu vị trí GPS để ghim video trên bản đồ.",
	"This video is_": "Video này đã được thêm vào Bản đồ Sự kiện.",
	"Share to Event Map": "Chia sẻ lên Bản đồ Sự kiện",
	"Describe in more_": "Mô tả chi tiết hơn những gì trong video của bạn (không bắt buộc)",
	"Description(optional)": "Mô tả(không bắt buộc)",
	"Recording mode": "Các chế độ Ghi",
	"Event triggers": "Kích hoạt Sự kiện",
	DMS: DMS,
	"Camera connectivity": "Kết nối Camera",
	"If not allowed_2": "Nếu không được phép, sẽ không thể truy cập được vị trí và tốc độ xe của bạn qua Đám mây.",
	"Share Live View_": "Chia sẻ video Xem Trực tiếp",
	"Share Live View_2": "Chia sẻ audio Xem Trực tiếp",
	"Share camera profile": "Chia sẻ Hồ sơ Camera",
	"Parking impact": "Tác động đỗ xe",
	"Parking events": "Parking Events",
	"Audio recording": "Ghi Âm",
	"Toggle the mic_": "BẬT/TẮT mic",
	"Full HD_": "Full HD @ 60fps + Full HD @ 30fps",
	"Video quality": "Chất lượng video",
	Extreme: Extreme,
	"More video files": "Hiển thị Nhiều Tệp tin Ghi âm hơn",
	"Fewer video files": "Hiển thị Ít Tệp tin Ghi âm hơn",
	"Camera rotation": "Xoay camera sau",
	"Video overlay": "Lớp phủ Video",
	"Date & time display": "H.thị ngày & giờ",
	"Speed unit": "Đơn vị Tốc độ",
	"Check the orientation_": "Kiểm tra hướng của camera trước được lắp trên xe. Chọn tùy chọn phù hợp để quay video theo hướng thẳng đứng.",
	"Rotate 180º": "Xoay 180º",
	"Rear camera rotation": "Xoay camera sau",
	"Check the orientation_rear": "Kiểm tra hướng của camera sau được lắp trên xe. Chọn tùy chọn phù hợp để quay video theo hướng thẳng đứng.",
	"Mirror View": "Chức năng Lật Video",
	"Select Mirror View_": "Chọn Chức năng Lật Video để lật video theo chiều ngang.",
	"Check the orientation_interior": "Kiểm tra hướng của camera tùy chọn được lắp trên xe. Chọn tùy chọn phù hợp để quay video theo hướng thẳng đứng.",
	"Display off": "Hiển thị tắt",
	"Explore crowd-sourced Events_": "Khám phá các Sự kiện do cộng đồng cung cấp (Va chạm, Phanh gấp, v.v.) trên bản đồ, xem video do cộng đồng chia sẻ và đóng góp Sự kiện của riêng bạn.",
	OFF: OFF,
	"Reboots once-a-day_": "Khởi động mỗi ngày một lần vào giờ cố định nếu ở chế độ đỗ để tăng tính ổn định.",
	"Set time": "Đặt giờ",
	"FW language": "Ngôn ngữ vi chương trình",
	"Rear security_2": "Cảnh báo phía sau",
	"Bluetooth (Parking mode)_2": "Bluetooth (Chế độ đỗ xe)",
	"Failed to save_2": "Không thể lưu cài đặt Tải lên Sự kiện Trực tiếp.",
	"Event file will_": "Tệp sự kiện sẽ được lưu tự động trong bộ lưu trữ Tải lên Sự kiện Trực tiếp.",
	"An impact was_": "An Impact was detected during Parking Mode.",
	"When exiting Parking_": "Khi thoát khỏi Chế độ Đỗ xe, BlackVue của bạn sẽ thông báo nếu phát hiện thấy Va chạm khi ở Chế độ Đỗ xe. \n\n Lưu ý: \n Va chạm tạo video Sự kiện. Các va chạm được tạo ra trong vòng 3 phút sau khi thoát khỏi Chế độ Đỗ xe sẽ bị bỏ qua.",
	"Protect event files": "Bảo vệ Tệp tin Sự kiện",
	"Turning on this_": "Bật để bảo vệ các tệp Sự kiện {{a}} cuối cùng không bị ghi đè bởi các tệp ghi Bình thường hoặc Đỗ xe.",
	"Impact Events in_": "Impact Events in Normal(E) and Parking Mode(I)",
	"Manual Events_": "Manual Events (M)",
	"Once 50 Events_": "Các tệp được bảo vệ bao gồm: \n\nCác sự kiện Va chạm ở chế độ Bình thường(E) và Chế độ đỗ xe(I) \nSự kiện Thủ công (M) \n\nSau khi {{a}} Sự kiện được ghi lại, Sự kiện mới sẽ ghi đè lên sự kiện cũ nhất.",
	"Reckless driving unit": "Tốc độ lái xe nguy hiểm",
	"Hard acceleration Event": "Sự kiện Tăng tốc Gấp",
	Threshold: Threshold,
	"Triggers when the_": "Kích hoạt khi camera phát hiện tốc độ gia tốc mỗi giây cao hơn giá trị ngưỡng đã đặt.",
	"Triggers when the_2": "Kích hoạt khi camera phát hiện tốc độ giảm nhiều hơn giá trị ngưỡng đã đặt.",
	"Hard braking Event": "Sự kiện Phanh gấp",
	"Triggers when more_": "Kích hoạt khi phát hiện góc nghiêng hơn 60 độ trong vòng 2 giây khi lái xe trên giá trị ngưỡng đã đặt.",
	"Every event of DMC200_2": "Các tính năng phát hiện DMS chỉ hoạt động trong Chế độ Bình thường. Nếu được cấp điện trong Chế độ Đỗ xe, camera DMS chỉ ghi lại video.",
	"The DMS system has_2": "DMS kết hợp hộp phát hiện khuôn mặt cho các trạng thái “Phát hiện”, “Không phát hiện”, “Lạc đề”, “Buồn ngủ”, “Mất khẩu trang” và hộp phát hiện chuyển động cho trạng thái “Lạc tay”.",
	"One for face_": "One for face detection : Detected, Undetected, Distracted, Drowsy",
	"The other for_": "The other for motion detection",
	"On: Normal recording_": "On: Normal recording works while power is maintained in Parking Mode",
	"Off: DMS power_": "Off: DMS power off after 5 minutes when entering Parking Mode, Normal recording works until just before off",
	"Drowsy and Distracted_": "Drowsy and Distracted each have three sensitivity conditions.",
	"Please refer to_": "Please refer to the guide interface below.",
	Drowsiness: Drowsiness,
	"Drowsiness occurs when_": "Buồn ngủ xảy ra khi tài xế nhắm mắt trong thời gian hơn 1 giây khi đang lái và ngáp trong vòng 2 giây.",
	"Distracted occurs when_": "Xảy ra khi đầu của tài xế cách xa phía trước hơn 50 độ.",
	"A hand distraction_": "A hand distraction occurs when the driver removes one hand from the steering wheel. [*Smoking and phone calls may be suspected.]",
	"Mask off event_": "Mask-off event occurs in two ways. First is when the driver gets in the car without a mask. Second is when the driver takes their mask off",
	"High When the_": "High : When the driver closes their eyes for more than 1 second, it is considered drowsy driving.",
	"Middle When the_": "Medium : When the driver closes their eyes for more than 1.5 second, it is considered drowsy driving.",
	"Low When the_": "Low : When the driver closes their eyes for more than 2 second, it is considered drowsy driving.",
	"High If the_": "High : If the angle of the head is more than 50 degrees away from the front for 3 seconds, it is detected as Distracted.",
	"Middle If the_": "Medium : If the angle of the head is more than 50 degrees away from the front for 5 seconds, it is detected as Distracted.",
	"Low If the_": "Low : If the angle of the head is more than 50 degrees away from the front for 7 seconds, it is detected as Distracted.",
	Direct: Direct,
	"Camera Wi-Fi credentials": "Thông tin xác thực Wi-Fi của Camera",
	"Network name(SSID)": "Tên mạng (SSID)",
	"Seamless pairing": "Seamless Pairing",
	Remote: Remote,
	"Hotspot settings": "Cài đặt Điểm phát sóng",
	"Hotspot name": "Tên điểm phát sóng (SSID)",
	"Hotspot name must_": "Hotspot name must be at least 5 characters long",
	"Public cameras may_": "Camera công cộng có thể xuất hiện trên tab Khám phá hoặc bản đồ Thế giới.",
	"Hard Cornering Event": "Sự kiện Cua gấp",
	"Over speed_2": "Quá Tốc độ",
	"Second drawiness alert": "Cảnh báo Buồn ngủ Lần Hai",
	"Low Voltage Warning_2": "Tay không tập trung",
	"(You)_2": "{{a}} ( Bạn )",
	"This video has been reported_": "Video này đã được quản trị viên báo cáo và xóa.",
	"Normal Mode recording": "Ghi âm chế độ bình thường",
	"ON : the camera_": "BẬT : camera quay liên tục theo vòng lặp.",
	"OFF : the camera_": "TẮT : camera chỉ quay video Sự kiện khi đang lái xe.",
	"In both modes_": "Ở cả hai chế độ, các Va chamj được phát hiện sẽ kích hoạt các bản ghi video Sự kiện.",
	"Continuously records_": "Liên tục ghi lại các video 1 phút 1 khung hình mỗi giây bao gồm 30 phút hành động.",
	"Choose detection regions_": "Chọn các khu vực phát hiện để giảm nguy cơ kích hoạt các bản ghi chuyển động không mong muốn do cây cối đung đưa trong gió, các vật thể chuyển động ở xa, v.v.",
	"Your previous plan is expired.": "Gói trước đó của bạn đã hết hạn.",
	"Upgrade the plan to restore the camera": "Nâng cấp gói khôi phục camera\n(%@)",
	"Remove from cloud": "Xóa khỏi đám mây",
	"Are you sure you want to Remove_": "Bạn có chắc chắn muốn xóa camera khỏi khe cắm Đám mây?",
	"Remove: It doesn’t mean_": "Xóa: Điều đó không có nghĩa là xóa dữ liệu của camera mà là tạo một khe trống cho số lượng camera trên đám mây.",
	"Now the camera is removed from cloud slot": "Camera đã được tháo khỏi khe cắm Đám mây.",
	"How to delete camera list": "Cách xóa camera khỏi danh sách",
	Update: Update,
	"Camrea setting": "Cài đặt camera",
	"Notification setting": "Thiết lập thông báo đẩy",
	"Driving reports": "Báo cáo lái xe",
	"Cloud connection steps": "Bước Kết nối Đám mây",
	"Download the BlackVue app to add a camera": "Tải xuống ứng dụng BlackVue để thêm camera",
	"To see your camera in the BlackVue cloud viewer_": "Để xem camera của bạn trong BlackVue cloud viewer, trước tiên bạn phải kết nối camera với đám mây. Dễ dàng thiết lập và kết nối camera BlackVue của bạn với Đám mây với ứng dụng BlackVue cho iOS và Android.",
	"Download the BlackVue app to see a Wi-Fi connected camera": "Tải xuống ứng dụng BlackVue để xem camera được kết nối Wi-Fi hay chưa",
	"BlackVue Cloud web viewer only supports_": "BlackVue Cloud web viewer chỉ hỗ trợ camera hành trình được kết nối với đám mây. Vui lòng tải xuống ứng dụng BlackVue để xem camera hành trình được kết nối Wi-Fi của bạn.",
	"You can restore the data if_": "Bạn có thể khôi phục dữ liệu nếu bạn đăng ký lại camera này vào cùng một tài khoản. nhưng nếu tài khoản đã bị xóa thì tất cả các tệp của bạn sẽ bị mất.",
	"How to add camera": "Cách thêm camera",
	"Try to wait 2-3 minutes if you just registered the camera.": "Cố gắng đợi 2-3 phút nếu bạn vừa đăng ký camera.",
	"Try to check the Cloud Connection Settings again_": "Hãy thử kiểm tra lại Cài đặt Kết nối Đám mây, nếu camera vẫn chưa kết nối với Đám mây.",
	"Motion Detection": "Phát hiện Chuyển động",
	"Parking recordings occur_": "Ghi hình đỗ xe khi phát hiện chuyển động có thể nhìn thấy được.",
	"Motion Sensitivity": "Độ nhạy Chuyển động",
	"Motion Detection Sensitivity": "Độ nhạy cảm phát hiện chuyển động",
	"Select Detection Region": "Chọn vùng phát hiện",
	"Speed alert_2": "Cảnh báo tốc độ",
	"Live Event Upload_2": "Live Event Upload",
	"Beep Alert": "Cảnh báo tiếng bíp",
	"Parking Impact History_": "Cảnh báo Lịch sử Va chạm Đỗ xe",
	"To register your_": "Để đăng ký nút SOS của bạn, bạn phải sử dụng ứng dụng BlackVue.",
	"SOS button on/off": "Trạng thái Nút SOS",
	"File sharing to Event Map is_": "Tính năng chia sẻ tệp lên Bản đồ sự kiện hiện không khả dụng. Vui lòng kiểm tra lại sau.",
	"Email Notifications": "Thông báo email",
	"Push Notifications_2": "Thông báo bấm để xem",
	"Optional Camera Rotation": "Tùy chọn hướng camera",
	"Optional Camera Security": "Tùy chọn Bảo mật camera",
	Option: Option,
	"(Owner)": "{{a}} (Chủ Sở Hữu)",
	"SOS button": "Nút SOS",
	"This video has been reported_bold": "Video này đã được quản trị viên báo cáo và <b>xóa.</b>",
	"Number of events_2": "Số lượng sự kiện",
	"My Shared Videos": "Video Được Chia sẻ Của tôi",
	"No Hashtags": "Không có thẻ bắt đầu bằng dấu thăng",
	"I have read and agree_": "Tôi đã đọc và chấp thuận mọi Điều khoản và Chính sách",
	"14 years old_": "14 tuổi trở lên",
	Required: Required,
	Optional: Optional,
	"Profile information_": "Thông tin hồ sơ có thể được chỉnh sửa trên trang Cài đặt Tài khoản.",
	"Automatically Add Live_": "Tự động chia sẻ lên bản đồ Sự kiện các tệp Sự kiện tự động tải lên",
	"You must be 14 years_": "Bạn phải từ 14 tuổi trở lên để tạo tài khoản BlackVue",
	"Use 8 or more characters_": "Sử dụng 8 ký tự trở lên kết hợp cả chữ cái, số hoặc ký hiệu",
	"Protected files include_": "Các tệp được bảo vệ bao gồm: <br/>ㆍCác sự kiện Va chạm ở chế độ Bình thường(E) và Chế độ đỗ xe(I) <br/>ㆍSự kiện Thủ công (M) <br/><br/>Sau khi {{a}} Sự kiện được ghi lại, Sự kiện mới sẽ ghi đè lên sự kiện cũ nhất.",
	"Protected files include": "Protected files include",
	"If you turn_": "Nếu bạn tắt Hướng dẫn giọng nói, các danh sách sau sẽ tắt.",
	"Live Event Upload_success": "Đã lưu thành công cài đặt Tải lên Sự kiện Trực tiếp.",
	"Video type": "Kiểu video",
	"Notify the Owner": "Thông báo cho Chủ sở hữu",
	"Adjusting the cut-off voltage_2": "Adjusting the cut-off voltage to a lower setting may result in your dash cam draining more power from your battery. This could result in warning messages of battery drain or affect other vehicle functions.\nPlease consult with your dealership before lowering the voltage.",
	Others: Others,
	"This video has been removed.": "Video này đã bị xoá.",
	"Please assign cameras_": "Vui lòng chỉ định camera cho nhóm này.",
	"Are you running_": "Bạn sắp hết thời gian để xem Phát lại?",
	"Upgrade your plan_": "Hãy nâng cấp gói của bạn lên Gói Fleet Plan để Phát lại Không giới hạn và các tính năng khác dành riêng cho Đám mây.",
	"Are you running_Liveview": "Bạn sắp hết thời gian để Xem Trực tiếp?",
	"Upgrade your plan_Liveview": "Hãy nâng cấp gói của bạn lên Gói Fleet Plan để Xem Trực Tiếp Không giới hạn và các tính năng khác dành riêng cho Đám mây.",
	Stay: Stay,
	"Go to Fleet Plan": "Nâng cấp gói Fleet Plan",
	"It looks like the video file is being prepared. please try again later.": "Có vẻ như tệp video đang được chuẩn bị. vui lòng thử lại sau.",
	"Oops!": "Ối!",
	"Please back up_": "Vui lòng sao lưu tất cả các bản ghi quan trọng trước khi thay đổi cài đặt này.",
	"When you save_": "Khi bạn lưu cài đặt, thẻ nhớ microSD sẽ được định dạng và tất cả các bản ghi sẽ bị xóa để đảm bảo hoạt động ổn định.",
	"This is an unregistered_": "Đây là một email chưa đăng ký. Bạn có muốn vào trang Tạo tài khoản không?",
	"Camera name must_2": "Tên máy ảnh phải có từ 5 đến 32 ký tự.",
	"G-sensor (Normal mode)": "Cảm biến G (c.độ Bình thường)",
	"G-sensor (Parking mode)": "Cảm biến G (chế độ Đỗ)",
	"Up & down": "Lên & xuống",
	"Front & back": "Trước & sau",
	"Rotate Video 180º": "Rotate Video 180º",
	Mask_2: Mask_2,
	"Priority event": "Priority Event",
	"There is no_camera": "There is no camera that your owner assigned to you.",
	"Camera SSID": "Camera SSID",
	"The BlackVue dashcam_2": "The BlackVue dashcam is not compatible with 5GHz wireless networks",
	"Driver detection box_2": "Driver Detection Box",
	"DMS camera recording_2": "DMS Camera Recording in Parking Mode",
	Low_2: Low_2,
	Medium_2: Medium_2,
	High_3: High_3,
	"Live Event Upload_3": "Live Event Upload",
	"Driving Impact": "Driving Impact",
	"Video source_2": "Video Source",
	"Front camera_2": "Front Camera",
	"Rear camera_2": "Rear Camera",
	"Optional Camera": "Optional Camera",
	"Motion Detection_2": "Motion Detection",
	"Rear camera stops_2": "Rear camera stops recording 5 minutes after entering Parking Mode. Recording restarts when entering normal mode.",
	"Passenger vehicle": "Passenger Vehicle",
	"Heavy vehicle": "Heavy Vehicle",
	Highest_3: Highest_3,
	Extreme_2: Extreme_2,
	"Less recording files": "Fewer Recording Files",
	"Camera rotation_2": "Camera Rotation",
	"Share camera profile_2": "Share Camera Profile",
	Private_2: Private_2,
	"BlackVue Live": "BlackVue Live",
	"Important All saved_": "Important! All saved videos are about to be deleted. Tap Cancel and back up important files if needed.",
	"Whenever saving settings_": "Whenever saving settings after changing the time zone, the SD card is initialized and all stored files are deleted.",
	"Do you want_": "Do you want to save your changes?",
	"No groups": "No groups",
	Lite: Lite,
	"USD per Camera": "USD per extra Camera",
	"up to Cameras": "up to Cameras",
	"All the P Plan_": "Tất cả các tính năng của gói <b>{{a}}</b>, cộng thêm:",
	"User Roles and Permissions": "Vai trò và Quyền hạn người dùng",
	"Geofence Setup (Web) and alerts": "Geofence Setup (Web) and alerts",
	"N Times": "{{a}} Lần",
	"N Minutes": "{{a}} Phút",
	"Emergency Alarm": "Báo động khẩn cấp",
	"Playback, Live View": "Phát lại,Live View",
	"Your driving record : Daily, Monthly": "Lịch sử lái xe của bạn: Hằng ngày, Hàng tháng",
	"Real-time Conversation": "Cuộc trò chuyện thời gian thực",
	"Initiate a conversation_": "Bắt đầu một cuộc trò chuyện với người lái xe thông qua loa và micrô của dashcam.",
	"Remote Voice Communication": "Giao tiếp bằng giọng nói từ xa",
	"See the last location_": "Xem vị trí cuối cùng của máy ảnh của bạn",
	"Check your cars_": "Kiểm tra dữ liệu GPS thời gian thực của xe của bạn trên bản đồ để xác định vị trí xe của bạn và lấy thông tin về tình trạng của nó, chẳng hạn như việc lái xe hay đỗ và tốc độ của nó.",
	"Supported models_": "* Các mô hình được hỗ trợ: Các mô hình S Series S và S Early X",
	"GPS Tracking &_": "Theo dõi GPS & Video trên bản đồ (Thông minh/Hạm đội)",
	"Track your cars_": "Theo dõi vị trí xe hơi của bạn và tốc độ trên bản đồ!",
	"GPS Tracking: visualize_": "Theo dõi GPS: Hình dung nhật ký lái xe của bạn trên bản đồ.\nVideo trên bản đồ: Xem thông tin theo ngữ cảnh (tốc độ, loại sự kiện) và phát các video liên quan ngay từ bản đồ.",
	"Visualize your cars_": "Hình dung vị trí và tốc độ của xe ô tô trên bản đồ!",
	"The feature enables_": "Tính năng cho phép tải lên hình ảnh video lên đám mây, bao gồm 5 giây trước khi xảy ra tai nạn.\n",
	"Camera profile setting": "Camera profile setting",
	"Are you running_Download": "Are you running out of chance to Download Video?",
	"Upgrade your plan_Download": "Upgrade your plan to Fleet Plan for Unlimited Download, and other Cloud -Exclusive features.",
	"This feature is available for Smart and Fleet_": "This feature is available for Smart and Fleet Plan subscribers only.",
	"Rear camera will keep_": "Máy quay phía sau dừng ghi hình ở chế độ Đỗ xe khi trạng thái nhiệt độ của máy ghi đối nhiệt độ \"Cao\". Máy quay phía sau sẽ bắt đầu ghi hình lại sau khi trạng thái nhiệt độ của máy ghi đối nhiệt độ \"Bình thường\". (Lưu ý: Để bảo vệ điện tử, Blackvue có thể tắt do nhiệt độ môi trường cao.)",
	"Get Unlimited Cloud_": "Nhận phát lại đám mây không giới hạn và quản lý tối đa {{a}} camera.",
	"Up to N cameras_": "Up to {{a}} cameras (+ {{b}} USD Extra charge)",
	"N Minutes per Day": "{{a}} phút mỗi ngày",
	"Drowsiness sensitivity is_": "Độ nhạy buồn ngủ được thiết lập theo thời gian nhấp nháy của mắt bằng thuật toán BlackVue đáng tin cậy. <br> <br> Độ nhạy của Mất tập trung được thiết lập bằng góc vị trí đầu của người lái xe so với phía trước và thời gian kéo dài của sự việc.",
	"Not available with this plan": "Not available with this plan",
	"The optional camera records_": "Máy ảnh tùy chọn ghi hình trong Chế độ Đỗ Xe",
	"Smart and Fleet_": "Smart and Fleet Plan<br/>subscribers only",
	"This feature is_smart": "This feature is available for Smart and Fleet Plan subscribers only.",
	"Camera Registration": "Đăng ký camera",
	"Voice Call": "Voice Call",
	"N times per Month": "{{a}} times per Month",
	"Recommended for higher bitrate_": "Được đề xuất cho bitrate cao hơn và chất lượng video tốt hơn.",
	"Recommended for for better compatibility_": "Được đề xuất để tương thích tốt hơn với thiết bị máy tính để bàn và thiết bị di động",
	"A minute of front camera_": "Kích thước tệp ước tính cho video 1 phút (camera trước)",
	"Extreme(N Mbps): N MB_": "Extreme ({{ex1}}Mbps) : {{ex2}}MB\nHighest ({{ht1}}Mbps) : {{ht2}}MB\nHigh ({{hi1}}Mbps) : {{hi2}}MB\nNormal ({{no1}}Mbps) : {{no2}}MB",
	"File size information reflects_": "Thông tin kích thước tệp phản ánh kích thước tối đa có thể và kích thước tệp thực tế có thể thay đổi phụ thuộc vào điều kiện ghi.",
	Bitrate: Bitrate,
	"Connection has been_": "Kết nối đã bị mất.\nThiết lập lại kết nối ...",
	"Unable to establish_": "Không thể thiết lập kết nối với máy ảnh.\nVui lòng đảm bảo thiết bị của bạn được kết nối đúng cách và thử lại.",
	"Purchased by Payment Service": "Được mua bởi Dịch vụ Thanh toán",
	"Up to N Cameras": "Tối đa {{a}} Camera",
	"Unlimited Live View": "Xem Trực tiếp Không giới hạn",
	"N Days GPS Tracking": "Theo dõi GPS trong {{a}} ngày",
	"Unlimited Playback and Download": "Phát lại và Tải xuống không giới hạn",
	hours: hours,
	"Live Event Upload or_": "Live Event Upload hoặc 12+ video độ phân giải đầy đủ",
	"During the usage period of the One Plan_": "Trong thời gian sử dụng dịch vụ One Plan, không thể thay đổi kế hoạch đăng ký. Để chuyển sang kế hoạch khác, vui lòng liên hệ Hỗ trợ Khách hàng của BlackVue để hủy đăng ký One Plan.",
	"Service Period (Include SIM Data)": "Khoảng thời gian dịch vụ (Bao gồm dữ liệu SIM)",
	"Purchase the BlackVue One Package_": "Mua Gói BlackVue One để mở khóa One Plan miễn phí trong 1 năm.",
	"3GB SIM Data Plan": "Gói dữ liệu SIM 3GB",
	"Unlimited Live View, Playback and Download": "Xem trực tiếp, Phát lại và Tải xuống không giới hạn",
	"within data availability": "trong phạm vi dữ liệu có sẵn",
	"The BlackVue One Plan is a 1-year_": "BlackVue One Plan là một kế hoạch dịch vụ đám mây kéo dài 1 năm chỉ có thể truy cập thông qua việc mua Gói BlackVue One, bao gồm camera hành trình, gói dữ liệu 3GB/tháng trong 1 năm (dành cho Mỹ và Canada) và kế hoạch dịch vụ đám mây trong 1 năm.",
	"The BlackVue One Package is available_": "Gói BlackVue One chỉ có sẵn tại cửa hàng trực tuyến BlackVue.",
	"Go to BlackVue Shop": "Đi đến cửa hàng BlackVue",
	"Anonymous Cam": "Camera ẩn danh",
	"App only": "chỉ có trong ứng dụng",
	Expires: Expires,
	"N days remaining": "Còn lại {{a}} ngày",
	"No action needed_": "<b>Không cần hành động gì.</b> Giá mới giảm sẽ được áp dụng tự động bắt đầu từ lần thanh toán tiếp theo của bạn sau ngày 13 tháng 9.",
	"The new reduced price_": "Giá mới giảm sẽ tự động áp dụng vào tài khoản của bạn.",
	"Smart Plan Subscriber?": "Người đăng ký Kế hoạch Thông minh?",
	"Fleet Plan Subscriber?": "Người đăng ký Kế hoạch Fleet?",
	"Please take a moment to_": "Vui lòng dành một khoảnh khắc để cho phép chúng tôi di chuyển tài khoản của bạn.",
	"Starting from now and_": "<b>Bắt đầu từ bây giờ cho đến ngày 31 tháng 10</b>, bạn có thể để chúng tôi thực hiện thay đổi cho bạn bằng cách <a href=\"https://form.jotform.com/232411253056041\" target=\"_blank\">Nhấp vào liên kết này</a> và nhập email tài khoản Fleet của bạn. Xin vui lòng cho chúng tôi một thời gian để xử lý thay đổi. Hoặc nếu bạn muốn, bạn có thể hủy tài khoản hiện tại của mình và đăng ký lại với giá mới từ ngày 13 tháng 9.",
	"Once activated_": "Sau khi kích hoạt, One Plan không thể tạm dừng hoặc vô hiệu hóa.",
	"Once the One Plan is activated_": "Sau khi kích hoạt One Plan, One Package không thể hoàn lại tiền.",
	"Up to N Cloud Camera Slot": "Lên đến {{a}} khe camera cloud",
	"nGB of Cloud Storage": "{{a}}GB lưu trữ trên đám mây",
	"Get started for free_": "Get started for free, no credit card required. Includes Alert Push Notifications, limited Remote Live View and cloud storage.",
	"The BlackVue One Plan is exclusively_": "The BlackVue One Plan is exclusively available through the purchase of a BlackVue One Package. 3GB/mo data plan is for US and Canada only. BlackVue Cloud’s Free Plan, Lite Plan (1~3) and Smart Plan (1~3) accounts can upgrade to One Plan. However, Lite Plan (4~15), Smart Plan (4~15) and Fleet Plan accounts can not be upgraded to One Plan.",
	"For N year": "For {{a}} year",
	"Included in the One Package": "Included in the One Package",
	"3GB SIM Data Plan for N year": "3GB SIM Data Plan for {{a}} year",
	"One Plan Cloud Service for N year": "One Plan Cloud Service for {{a}} year",
	"The BlackVue One Package includes_": "The BlackVue One Package includes all you need to enjoy BlackVue Cloud for a whole year!",
	"4K LTE Dash Cam_": "4K LTE Dash Cam, Cloud Service and Data Plan",
	"nGB included": "{{a}}GB included",
	"nGB per camera": "{{a}}GB per camera",
	"N Days Live Event Upload": "{{a}} Days Live Event Upload",
	"Up to N Dash Cameras": "Up to {{a}} Dash Cameras",
	"Step N/N": "Bước {{a}}/{{b}}",
	"Cloud Connection": "Kết nối với Đám mây",
	"To pair your dashcam": "Để kết nối dashcam của bạn với pin, vui lòng kết nối nó với Đám mây.",
	Check: Check,
	"Unpair Battery": "Hủy kết nối pin",
	"Are you sure you want to unpair": "Bạn có chắc chắn muốn hủy kết nối pin (%@) này từ máy ảnh không?",
	"Unpair: It doesn't mean": "Hủy kết nối: Điều này không có nghĩa là xóa dữ liệu của pin.",
	"*The paired battery will": "*Pin đã được ghép cũng sẽ được gỡ bỏ cùng nhau.",
	"Would you like to pair this": "Bạn có muốn ghép cặp pin này không?",
	"Battery successfully paired": "Pin đã được kết nối thành công.",
	"Now you can directly connect to": "Bây giờ bạn có thể kết nối trực tiếp với pin từ danh sách máy ảnh.",
	"Pairing failed": "Kết nối không thành công. Vui lòng thử lại.",
	"Battery Name": "Tên pin",
	"Capacity History": "Lịch sử dung lượng",
	"The graph displays capacity": "Biểu đồ hiển thị mức pin xấp xỉ bằng cách sử dụng dữ liệu từ kết nối đám mây.\n Dung lượng pin có thể thay đổi tùy thuộc vào nhiệt độ, cài đặt của dashcam và tần suất của các sự kiện kích hoạt.",
	"Last 24 Hours": "24 Giờ Qua",
	"Last 7 Days": "7 Ngày Qua",
	"Battery Level": "Mức pin",
	"Temperature History": "Lịch sử nhiệt độ",
	"The graph displays temperature": "Đồ thị hiển thị mức nhiệt độ xấp xỉ bằng cách sử dụng dữ liệu từ kết nối đám mây.",
	"Temperature Level": "Mức nhiệt độ",
	"Connecting alert": "[ Đang kết nối ]\nDữ liệu hiển thị khi kết nối.",
	"Low Output power Alert": "[ Cắt nguồn đầu ra ]\nĐiện áp đầu ra quá thấp, giới hạn nguồn cấp điện của thiết bị được kết nối.",
	"High temp Alert": "[ Ngắt nguồn vào ]\nNhiệt độ pin quá cao, giới hạn sạc.",
	"Remaining time": "Thời gian còn lại",
	"Remaining time estimate": "Thời gian còn lại là một ước lượng dựa trên tổng lượng điện tiêu thụ của các thiết bị được kết nối.\n Nó được tính toán lại mỗi 30 giây sau khi kết nối với pin.",
	"Setting changed": "Cài đặt đã thay đổi",
	"Setting change failed": "Cài đặt thay đổi thất bại",
	"Low Input power Alert": "[ Ngắt nguồn vào ]\nĐiện áp sạc quá thấp, hạn chế sạc.",
	"High Input power Alert": "[ Ngắt nguồn vào ]\nĐiện áp sạc quá cao, giới hạn sạc.",
	"Low temp_Cut off Alert": "[ Ngắt nguồn vào ]\nNhiệt độ pin quá thấp, giới hạn việc sạc và thời gian sử dụng.",
	"Low temp Alert": "[ Nhiệt độ thấp ]\nNhiệt độ pin quá thấp, hạn chế thời gian sử dụng và tốc độ sạc.",
	"Low capacity Alert": "[ Dung lượng thấp ]\nDung lượng pin quá thấp.\nLái xe để sạc nó.",
	"Back to list": "Quay lại danh sách",
	Saving: Saving,
	Now: Now,
	"Power supplying is limited": "Cung cấp điện bị <b>hạn chế</b>",
	"This battery is already paired": "Pin sudah dipasangkan.",
	"Connecting to Battery": "Đang kết nối với pin",
	"Paired battery": "Pin đã ghép nối",
	"Battery unpairing failed": "Thất bại trong việc hủy kết nối pin. Vui lòng thử lại.",
	"A connection is already active": "Một kết nối đã hoạt động. Vui lòng thử lại sau.",
	"Searching for battery": "Tìm kiếm pin",
	"Select battery to pair with your camera": "Chọn pin để ghép với máy ảnh của bạn.",
	"Unable to connect": "Không thể kết nối",
	"A connection error has occurred": "Đã xảy ra lỗi kết nối. Vui lòng thử lại.",
	"The paired dashcam has been disconnected": "Camera gắn kết đã được ngắt kết nối từ Đám mây.\nVui lòng kiểm tra các điều kiện dưới đây.",
	"Check if the battery is not fully discharged": "Kiểm tra xem pin có bị xả hết không",
	"Check the Cloud connection of the paired dashcam": "Kiểm tra kết nối đám mây của camera gắn trên kính được ghép cặp",
	"Connection lost": "Mất kết nối",
	"A connection error has occurred shortly": "Đã xảy ra lỗi kết nối. Vui lòng thử kết nối trong thời gian sớm nhất.",
	"Charging is limited": "Sạc <b>bị hạn chế</b>",
	"Cannot connect to the battery": "Không thể kết nối với pin.",
	"Please check the Cloud connection of the camera": "Vui lòng kiểm tra kết nối đám mây của camera.",
	"Charging complete in": "Quá trình sạc hoàn tất sau %@",
	"Current Capacity": "Dung Lượng Hiện Tại",
	"Output Voltage": "Điện Áp Đầu Ra",
	"Charging Voltage": "Điện Áp Sạc",
	Beep: Beep,
	"Battery Capacity": "Dung lượng pin",
	"Battery connection failed": "Kết nối pin không thành công",
	"Expansion battery": "Pin dự phòng",
	"Make sure it is switched on and within range": "• Đảm bảo rằng nó đã được bật và nằm trong phạm vi phủ sóng của điện thoại di động của bạn.",
	"Make sure it is not wirelessly connected to another device": "• Đảm bảo rằng nó không được kết nối không dây với thiết bị khác.",
	"Detected batteries": "Pin được phát hiện",
	"Can't see your battery": "Không thể nhìn thấy pin của bạn?",
	"Download the Blackvue app to check": "Tải ứng dụng BlackVue để kiểm tra pin từ xa",
	"By Using the app": "Bằng cách sử dụng ứng dụng, bạn có thể kết nối camera gắn trên ô tô với pin và giám sát dung lượng pin thông qua Đám mây. Sau khi kết nối, bạn có thể kiểm tra pin trong trình xem Đám mây BlackVue.",
	Unpair: Unpair,
	"Occurs when the driver closes_": "Xảy ra khi lái xe đóng cả hai mắt khi lái xe",
	"Occurs when the driver's head_": "Xảy ra khi đầu của tài xế nghiêng hơn 50 độ so với phía trước.",
	"Only detects distraction above_": "Chỉ phát hiện sự lơ đễnh vượt quá giá trị đã thiết lập. Bạn có thể thay đổi đơn vị trong 'Thiết lập camera > Kích hoạt Sự kiện > Tốc độ lái xe nguy hiểm'.",
	"Occurs when the driver is not wearing_": "Xảy ra khi lái xe không đeo dây an toàn.",
	"Overlays a face detection box_": "Наложение рамки обнаружения лиц на прямую и записанную видеосъемку камеры DMS.",
	"Seat Belt": "Dây an toàn",
	Detected: Detected,
	"No Seat Belt": "Không có dây an toàn",
	"Fatigue Risk Alert": "Cảnh báo rủi ro mệt mỏi",
	"The time is synchronized_Email": "Thời gian được đồng bộ hóa với thời gian trong thông báo qua email của bạn.",
	"Sends an alert when drowsiness is_": "Gửi cảnh báo khi phát hiện buồn ngủ sau khi buồn ngủ ban đầu.",
	"Data updates upon connection": "Dữ liệu sẽ được cập nhật khi kết nối.",
	"Sends a notification if_": "Gửi thông báo nếu bạn vượt quá 'Đặt giờ' trong khi lái xe.",
	"Data updates Alert": "[ Đang kết nối ]\nDữ liệu sẽ được cập nhật khi kết nối.",
	"Cannot save settings": "Không thể lưu cài đặt",
	"The time is synchronized_Push": "Thời gian được đồng bộ hóa với thời gian trong thông báo bấm để xem của bạn.",
	"The file has been overwritten or deleted": "Tệp đã bị ghi đè hoặc xóa.",
	"Box Pro Models Settings": "Cài đặt Mẫu Box Pro",
	"Push notifications can be configured_": "Thông báo đẩy có thể được cấu hình trong cài đặt thông báo của máy ảnh.",
	"Recording Video": "Ghi hình Video",
	"Cameras settings": "Cài đặt máy ảnh",
	"Please configure the settings": "Vui lòng cấu hình cài đặt",
	"Speed Priorities": "Ưu tiên tốc độ",
	"Set Speed Priority": "Đặt mức ưu tiên tốc độ",
	"Geofence-enter": "Rào chắn địa lý - nhập",
	"Geofence-exit": "Rào chắn địa lý - thoát",
	"Geofence-pass": "Rào chắn địa lý - vượt qua",
	"Geofence-speed alert": "Rào chắn địa lý - Cảnh báo tốc độ",
	"Drive Position": "Vị trí ghế lái",
	"Left-Hand Drive": "Lái xe bên trái",
	"Right-Hand Drive": "Lái xe bên phải",
	"Please configure this setting_": "Vui lòng thay đổi cài đặt này nếu tài xế không được phát hiện chính xác.",
	"A new feature in the BlackVue settings_": "Một tính năng mới trong cài đặt BlackVue đã được thêm vào để đồng bộ hóa thời gian của camera. Bạn nên đồng bộ thời gian của máy ảnh một lần để ghi lại thời gian chính xác.",
	"Feature location_": "Vị trí đặc điểm:\nCài đặt máy ảnh> Hệ thống > Đồng bộ hóa thời gian",
	"Time Sync": "Đồng bộ hóa thời gian",
	"You can sync the time between_": "Bạn có thể đồng bộ thời gian giữa thiết bị của mình và camera BlackVue. Định dạng thẻ SD là cần thiết để đồng bộ hóa. Trước khi tiếp tục, hãy sao lưu bất kỳ video cần thiết nào.",
	"Voice Alert": "Cảnh báo bằng giọng nói",
	"Provides a voice alert_": "Cung cấp cảnh báo bằng giọng nói từ camera và gửi thông báo nếu bạn vượt quá thời gian đã đặt trong khi lái xe.",
	"Please enter a value": "Please enter a value.",
	"Notices & Notifications": "Tin tức & Thông báo",
	"Only detects drowsiness above_": "Chỉ phát hiện buồn ngủ vượt quá giá trị đã thiết lập. Bạn có thể thay đổi đơn vị trong 'Thiết lập camera > Kích hoạt Sự kiện > Tốc độ lái xe nguy hiểm'.",
	Promotion: Promotion,
	Notice: Notice,
	"View More": "Xem thêm",
	"Read More": "Đọc thêm",
	"Detection Box": "Hộp Phát Hiện",
	"Seatbelt Detection Box": "Hộp Phát Hiện Dây An Toàn",
	"Drive Position Detection Box": "Hộp Phát Hiện Vị Trí Lái Xe",
	"Fleet Subscription Promotion (50%)": "Khuyến mãi đăng ký đội xe (50%)",
	"BlackVue Fleet Tracking exclusive features_": "Các tính năng độc quyền của BlackVue Fleet Tracking dành cho người dùng thành thạo cũng như doanh nghiệp (Nhiều người dùng và camera, tính năng định vị địa lý, Trình xem web, v.v.).",
	"Special Discount (50% off)": "Giảm giá đặc biệt (giảm 50%)",
	"*Promotion applied for 12 months": "*Chương trình áp dụng trong 12 tháng",
	"*Payment will be made starting next month.": "*Việc thanh toán sẽ được thực hiện bắt đầu từ tháng tới.",
	"[About using promotions]": "[Về việc sử dụng khuyến mãi]",
	"The promotion is free for the first month_": "Chương trình khuyến mãi miễn phí trong tháng đầu tiên và sau đó được tính phí trong 12 tháng bắt đầu từ tháng tiếp theo.",
	"For users with an existing Lite/Smart subscription_": "Đối với người dùng đã đăng ký Lite/Smart hiện tại, bạn phải hủy riêng đăng ký ứng dụng hiện tại của mình, nếu không đăng ký ứng dụng hiện tại có thể bị tính phí vào tài khoản của bạn.",
	"Please be sure to cancel your app subscription_": "Hãy chắc chắn hủy đăng ký ứng dụng của bạn trong thời gian miễn phí. Thanh toán gấp đôi sẽ không được hoàn trả.",
	"You will be changed to Fleet Plan immediately_": "Bạn sẽ được chuyển sang Gói Hạm đội ngay lập tức, ngay cả khi thời hạn đăng ký còn lại của Gói Lite/Thông minh hiện tại của bạn chưa hết hạn.",
	"You can cancel Fleet Plan any time.": "Bạn có thể hủy Gói Hạm đội bất kỳ lúc nào.",
	"From February 2025, please go to the Fleeta service and use it.": "Khi chương trình khuyến mãi bị hủy, chương trình khuyến mãi sẽ không được áp dụng lại.",
	"After promotion expires_": "Sau khi hết khuyến mãi, bạn sẽ tự động được gia hạn với phí đăng ký Gói Hạm đội hiện có.",
	"(Required) I have read the promotion instructions_": "(Bắt buộc) Tôi đã đọc hướng dẫn khuyến mãi và đồng ý thanh toán.",
	"Upgrade to Fleet Plan immediately": "Nâng cấp lên Gói Hạm đội ngay lập tức",
	"Important Notice:": "Thông báo quan trọng:",
	"Switch of BlackVue Web Viewer to Fleeta Web Viewer": "Chuyển đổi Trình xem web BlackVue sang Trình xem web Fleeta",
	"To provide better features and quality_": "Để cung cấp các tính năng và chất lượng tốt hơn, dịch vụ xem web BlackVue sẽ sớm chuyển sang dịch vụ xem web nhóm mới có tên Fleeta. Các dịch vụ của Fleeta sẽ chỉ dành riêng cho người dùng Fleet Plan. Dịch vụ Fleeta sẽ được ra mắt vào tháng 3 năm 2025, với Ứng dụng mới độc quyền của Fleeta. Vui lòng truy cập <a href=\"https://www.fleeta.io\" target=\"_blank\">fleeta.io</a> để tìm hiểu thêm.",
	"We kindly ask for your understanding_": "Chúng tôi mong bạn thông cảm vì thay đổi này nhằm mục đích cung cấp dịch vụ được cải thiện. Nếu có bất kỳ câu hỏi nào liên quan đến quá trình chuyển đổi này, vui lòng liên hệ với trung tâm CS của chúng tôi.",
	"Don’t show this again for this month": "Không hiển thị lại nội dung này trong tháng này",
	"Fleet Plan Subscription Promotion": "Khuyến mãi đăng ký gói Hạm đội",
	"Period : December 2, 2024 ~ May 31, 2025": "Thời gian: 2 tháng 12 năm 2024 ~ 31 tháng 5 năm 2025",
	"See more details": "Xem thêm chi tiết",
	"To continue improve quality and provide better service_": "Để tiếp tục nâng cao chất lượng và cung cấp dịch vụ tốt hơn, dịch vụ BlackVue Web Viewer của chúng tôi sẽ sớm chuyển sang dịch vụ độc quyền của Fleet Plan. Nó sẽ không còn được cung cấp miễn phí hoặc thông qua các gói khác kể từ cuối tháng 3 năm 2025.",
	"We have prepared special discount offers for_": "Chúng tôi đã chuẩn bị các ưu đãi giảm giá đặc biệt cho người dùng Web Viewer hiện tại của chúng tôi. Vui lòng kiểm tra chi tiết bên dưới! Chúng tôi mong bạn thông cảm và hỗ trợ khi chúng tôi thực hiện thay đổi này để cung cấp dịch vụ tốt hơn.\n",
	"*If you are subscribed in-app_": "*Nếu bạn đã đăng ký trong ứng dụng, vui lòng đảm bảo hủy đăng ký trong ứng dụng của bạn.",
	"Enjoy your BlackVue Cloud service with your dashcam.": "Tận hưởng dịch vụ BlackVue Cloud với camera hành trình của bạn.",
	"Available Cloud Camera slot(s)_": "(Các) khe cắm Cloud Camera có sẵn : {{d}}",
	"Not eligible for the promotion.": "Không đủ điều kiện cho khuyến mãi.",
	"You have already used_": "Bạn đã sử dụng khuyến mãi này. Một khi chương trình khuyến mãi bị hủy thì không thể áp dụng lại.",
	"Go to Cameras": "Đi tới Máy ảnh",
	"Congratulations !": "Congratulations !",
	"Fleet Plan user": "Fleet Plan user",
	"Let your BlackVue monitor_": "Hãy để BlackVue giám sát xe của bạn và cảnh báo bạn về các sự cố. Thời điểm phát hiện Tác động, BlackVue sẽ gửi thông báo đến điện thoại của bạn kèm theo ảnh chụp nhanh.\n",
	"Live Event Upload feature automatically_": "Tính năng Tải lên sự kiện trực tiếp tự động tải các cảnh quay video, bao gồm cả cảnh quay trước tai nạn, lên Bộ lưu trữ đám mây BlackVue để giữ an toàn cho video của bạn!",
	"*Buffer time varies by model.": "*Thời gian đệm thay đổi tùy theo model.",
	Explore: Explore,
	"Cloud Storage": "Lưu trữ đám mây",
	"My Cloud Cameras": "Máy ảnh đám mây của tôi",
	"My Cloud Cameras Only": "Chỉ máy ảnh đám mây của tôi",
	"BlackVue Live Camera": "Máy ảnh trực tiếp BlackVue",
	"*For BlackVue Live Cameras_": "*Đối với Camera BlackVue Live, chỉ những camera được chia sẻ ở chế độ công khai trong cài đặt camera mới có thể xem được trên bản đồ.",
	"*Share Method_": "*Phương pháp chia sẻ: Cài đặt camera>Quyền riêng tư",
	"Once the promotion is canceled_": "Khi chương trình khuyến mãi bị hủy, chương trình khuyến mãi sẽ không được áp dụng lại.",
	"It will show_": "Nó sẽ xuất hiện ở đây khi chúng trở nên có sẵn.",
	"Deactivate Cloud": "Vô hiệu hóa đám mây",
	"Are you sure you want to deactivate_": "Bạn có chắc chắn muốn tắt Cloud cho máy ảnh này không?",
	"Deactivate : It doesn’t_": "Bạn luôn có thể kích hoạt đám mây bất cứ lúc nào. Máy ảnh có thể bị xóa sau khi quá trình hủy kích hoạt hoàn tất.",
	Deactivate: Deactivate,
	"*If you made the payment through_": "*Nếu bạn thực hiện thanh toán qua ứng dụng, vui lòng khởi động lại ứng dụng.",
	"Connect Dashcam Locally (Wi-Fi)": "Kết nối Dashcam cục bộ (Wi-Fi)",
	"Cloud Connection Setting": "Cài đặt kết nối đám mây",
	"Camera Profile": "Hồ sơ camera",
	"Camera Settings": "Thiết lập camera",
	"Format MicroSD Card": "Định dạng thẻ microSD",
	"Remote Firmware Update": "Cập nhật chương trình cơ sở từ xa",
	"Remove from Cloud": "Xóa khỏi đám mây",
	"The location may not be accurate_": "Vị trí có thể không chính xác do máy ảnh không được kết nối với đám mây.",
	"The location of the camera cannot be found_": "Không thể tìm thấy vị trí của máy ảnh. Vui lòng kiểm tra Cài đặt kết nối đám mây.",
	"Manage\nFLEETA Drive": "Quản lý\nFLEETA Lưu trữ",
	"Cloud\nConnection": "Kết nối\nđám mây",
	"Available on FLEETA App": "Có sẵn trên ứng dụng FLEETA",
	"Available for Cloud dashcam OR on FLEETA App.": "Có sẵn cho dashcam đám mây HOẶC trên ứng dụng FLEETA.",
	"Get started with_": "Bắt đầu với thử nghiệm miễn phí 1 tháng",
	"Experience all of_": "Trải nghiệm tất cả tính năng cao cấp của FLEETA miễn phí trong suốt tháng dùng thử của bạn.\n\nKhông ràng buộc—hủy bất cứ lúc nào",
	"Welcome to FLEETA Webviewer.": "Chào mừng bạn đến với FLEETA Webviewer.",
	"Let FLEETA get_": "Hãy để FLEETA hiểu bạn",
	"Help improve your_": "Giúp cải thiện trải nghiệm của bạn bằng cách chia sẻ một số chi tiết",
	"Business Industry": "Ngành kinh doanh",
	"Vehicle & Cargo": "Xe và Hàng hóa",
	Compliance: Compliance,
	"Would you like to skip?": "Bạn có muốn bỏ qua không?",
	"What is your business industry?": "Ngành nghề kinh doanh của bạn là gì?",
	"Transportation & Logistics": "Vận tải và Logistics",
	"Rental & Leasing": "Thuê và Cho thuê",
	"Construction & Building": "Xây dựng và Tòa nhà",
	"Government & Public": "Chính phủ và Công cộng",
	"Facility & Utility Management": "Quản lý Cơ sở và Tiện ích",
	Manufacturing: Manufacturing,
	"Retail & Wholesale": "Bán lẻ và Bán buôn",
	Emergency: Emergency,
	Security: Security,
	"How many employees do you need to manage?": "Bạn cần quản lý bao nhiêu nhân viên?",
	"How many vehicles does your company operate?": "Công ty bạn vận hành bao nhiêu xe?",
	"Why do you use a fleet tracking service?": "Tại sao bạn sử dụng dịch vụ theo dõi đội xe?",
	"Route Tracking": "Theo dõi tuyến đường",
	"Real-time Monitoring": "Giám sát thời gian thực",
	"Incident Detection & Check video": "Phát hiện sự cố và kiểm tra video",
	"Behavior Monitoring & Analysis": "Giám sát hành vi và phân tích",
	"Evaluation & Management": "Đánh giá & Quản lý",
	"Theft Prevention": "Ngăn chặn trộm cắp",
	"Monitoring & Maintenance": "Giám sát & Bảo trì",
	"Verification & Management": "Xác minh & Quản lý",
	"BlackVue App Use Only": "Chỉ sử dụng trên ứng dụng BlackVue",
	"Your current plan allow_": "Gói hiện tại của bạn cho phép sử dụng ứng dụng BlackVue. Để sử dụng Web Viewer, vui lòng đăng ký Gói Fleet (FLEETA).",
	"Learn more about the Fleet_": "Tìm hiểu thêm về Kế hoạch Đội xe (FLEETA)",
	"Special Offer": "Ưu đãi đặc biệt",
	"For a limited time_": "Trong thời gian có hạn, hãy tận hưởng ưu đãi giảm 50% cho đăng ký Kế hoạch Đội xe của bạn.",
	"See Discount Details": "Xem chi tiết giảm giá",
	"To subscribe to the Fleet_": "Để đăng ký Kế hoạch Đội xe, vui lòng hủy đăng ký BlackVue trong ứng dụng trước để tránh phí trùng lặp.",
	"Skip tour": "Bỏ qua tour",
	"In the cloud_": "Trong môi trường đám mây, bạn có thể truy cập phát lại, xem trực tiếp (bao gồm đa nhìn), GPS trực tiếp và báo cáo, tất cả thông qua FLEETA Web Viewer.",
	"Cloud Storage is_": "Lưu trữ đám mây là nơi các video bạn đã tải lên được lưu trữ an toàn trong đám mây. Tải lên video của bạn để giữ chúng an toàn trong thời gian dài.",
	"Toggle to switch_": "Chuyển đổi để chuyển Map / List",
	"In List View_": "Trong Chế độ Xem Danh sách, bạn có thể dễ dàng xem và quản lý nhóm, thành viên và thông tin firmware chỉ qua một cái nhìn.",
	"What is Cloud Storage?": "Lưu trữ đám mây là gì?",
	"Cloud Storage Overview": "Tổng quan Lưu trữ đám mây",
	"Difference Between FLEETA_": "Sự khác biệt giữa FLEETA Lưu trữ và Tải lên sự kiện trực tiếp",
	"FLEETA Drive stores_": "FLEETA Lưu trữ lưu trữ các video bạn đã tải lên thủ công",
	"Live Event Upload automatically_": "Tải lên sự kiện trực tiếp tự động lưu trữ video khi có sự kiện xảy ra.",
	"Live Event Upload videos_": "Video Tải lên sự kiện trực tiếp có thời gian hết hạn. Nếu bạn muốn giữ chúng lâu dài, hãy chuyển chúng đến FLEETA Lưu trữ.",
	"Note: SD Card_": "Lưu ý: Video trên thẻ SD đang Phát lại",
	"Videos stored on_": "Các video lưu trên thẻ SD của bạn có thể được truy cập thông qua menu Phát lại.",
	"Set your image_": "Đặt hình ảnh của bạn bằng khung được cung cấp. Khi hình ảnh được lưu, nó sẽ được hiển thị trên thẻ camera và biểu tượng xem bản đồ.",
	"*Only jpg and_": "*Chỉ hỗ trợ các tệp jpg và png.",
	"Set as default image": "Đặt làm hình ảnh mặc định",
	"Camera Details": "Chi tiết camera",
	"IT & Telecommunications": "CNTT & Viễn thông",
	"The name must_32": "Tên phải trong khoảng từ 1 đến 32 ký tự.",
	"Unable to display the map.": "Không thể hiển thị bản đồ.",
	"The camera location cannot be found_": "Không thể tìm thấy vị trí camera do kết nối GPS kém.",
	"Cloud Cameras": "Camera đám mây",
	"Want to unlock_": "Bạn muốn mở khóa các tính năng quản lý đội xe?",
	"*Web subscription only": "*Chỉ đăng ký qua web",
	"Uploads event_": "Tải lên hình ảnh sự kiện lên Lưu trữ đám mây ngay lập tức khi sự kiện xảy ra.",
	"Starts a conversation_": "Bắt đầu cuộc trò chuyện với người lái xe sử dụng loa và microphone của camera hành trình.",
	"Remotely check_": "Kiểm tra từ xa mức pin và trạng thái qua đám mây.",
	"Receive a voice_": "Nhận cảnh báo bằng giọng nói và thông báo nếu thời gian lái xe vượt quá giới hạn.",
	"View your_": "Xem nhật ký lái xe của bạn trên bản đồ.",
	"View speed, event_": "Xem tốc độ, loại sự kiện và phát video liên quan trực tiếp trên bản đồ.",
	"FLEETA Tracking exclusive_": "FLEETA Tracking cung cấp các tính năng độc quyền cho cả người dùng năng lượng và doanh nghiệp (Nhiều người dùng và camera, hàng rào địa lý, v.v.).",
	"Cloud Cameras per Account": "Camera đám mây mỗi tài khoản",
	"Connect Dashcam Locally_": "Kết nối Dashcam cục bộ (Wi-Fi) (Phát lại, Tải xuống, Xem trực tiếp)",
	"Available with_": "Có sẵn với pin BlackVue",
	"Cloud Battery": "Pin đám mây",
	"Driving Reports": "Báo cáo lái xe",
	"Video on Map": "Video trên Bản đồ",
	"Multi Live View (Fleeta Web Viewer)": "Xem Trực Tiếp Nhiều Cửa Sổ (Người Xem Web FLEETA)",
	"Enter a number": "Nhập một số",
	"Permission required.": "Cần có sự cho phép.",
	"Please contact_": "Vui lòng liên hệ chủ sở hữu để được hỗ trợ.",
	"Access not available": "Không thể truy cập.",
	"This file cannot be deleted now.": "Tệp này không thể xóa ngay bây giờ.",
	"Please try again later.": "Vui lòng thử lại sau.",
	"Permission required.\nPlease_": "Cần có quyền.\nVui lòng liên hệ chủ sở hữu để được hỗ trợ.",
	"Cloud Storage is disconnected_": "Lưu trữ đám mây đã ngắt kết nối. Vui lòng kiểm tra kết nối.",
	"Manage the plan_": "Quản lý kế hoạch khôi phục camera",
	"Notify the owner_": "Thông báo cho chủ sở hữu quản lý kế hoạch",
	"Access Restricted:_": "Truy cập Bị Hạn Chế: Đăng ký Hết Hạn",
	"Access is currently_": "Hiện tại không thể truy cập do gói đăng ký đã hết hạn.",
	"Please contact your owner_": "Vui lòng liên hệ chủ sở hữu của bạn để giải quyết vấn đề này.",
	"Access will be_": "Quyền truy cập sẽ được khôi phục khi đăng ký được gia hạn",
	"Cloud is disconnected_": "Lưu trữ đám mây bị ngắt kết nối. \nVui lòng kiểm tra kết nối.",
	"Connect to Cloud with_": "Kết nối với Lưu trữ đám mây bằng FLEETA APP",
	"Using Wi-Fi Hotspot": "Sử dụng điểm phát Wi-Fi",
	Important: Important,
	"Pre-Event buffer_": "Ghi âm bộ đệm trước sự kiện bị vô hiệu hóa trong chế độ này.",
	"connectivity is_": "Kết nối bị hạn chế trong chế độ này.",
	"video upload starts_": "Tải lên video bắt đầu sau khi ghi âm hoàn tất.",
	"Power Saving": "Tiết kiệm năng lượng",
	"In all modes_": "Trong tất cả các chế độ, các va chạm được phát hiện sẽ kích hoạt ghi video Sự kiện.",
	"Battery Protection setting _": "Cài đặt Bảo vệ Pin phải được BẬT.",
	"At least one of_": "Ít nhất một trong những cài đặt sau phải được bật",
	or: or,
	"For BlackVue battery users": "Dành cho người dùng pin BlackVue",
	"we recommend setting_": "Chúng tôi khuyên bạn nên thiết lập mức cắt điện áp tối thiểu để sử dụng pin tối đa.",
	"No videos were found.": "Không tìm thấy video nào.",
	"Try different filter_": "Thử bộ lọc khác hoặc đặt lại bộ lọc.",
	"Not avaliable with_": "Không khả dụng với camera hiện tại",
	"Overlays a detection_": "Đè một hộp phát hiện lên hình ảnh trực tiếp và đã ghi của camera DMS.",
	"A minute of_": "Một phút video camera trước sẽ khoảng",
	"System voice guidance": "Hướng dẫn bằng giọng nói của hệ thống",
	"Recording trigger": "Kích hoạt ghi",
	"Remote Button (Optional)": "Nút từ xa (Tùy chọn)",
	"Remote button settings_": "Cài đặt nút từ xa không thể thay đổi qua kết nối đám mây. Để chỉnh sửa các cài đặt này, điều hướng đến Camera > Kết nối Cục bộ > Cài đặt Camera.",
	"No Registered Device": "Không có thiết bị đăng ký",
	"Subscription process is complete": "Quá trình đăng ký đã hoàn tất",
	"Now, go back to_": "Bây giờ, quay lại ứng dụng FLEETA, đăng nhập vào tài khoản của bạn và bắt đầu tận hưởng dịch vụ.",
	"You can check the upload progress": "Bạn có thể kiểm tra tiến trình tải lên trong tab Lưu trữ đám mây > FLEETA Lưu trữ.",
	"SIM card must be inserted in_": "Phải lắp thẻ SIM vào máy ảnh để bắt đầu sử dụng Cloud.",
	"Active until:": "Hoạt động cho đến:",
	Subscribe: Subscribe,
	"Camera PSN": "Máy ảnh PSN",
	"BlackVue Sim Free Trial Started!": "Đã bắt đầu dùng thử miễn phí BlackVue Sim!",
	"Enjoy a free period to use your SIM_": "Tận hưởng thời gian sử dụng SIM miễn phí mà không cần đăng ký!",
	"You can stay connected during the trial_": "Bạn có thể duy trì kết nối trong thời gian dùng thử nhưng hãy nhớ:",
	"Complete your subscription before the trial_": "Hãy hoàn tất đăng ký của bạn trước khi hết thời gian dùng thử để tiếp tục sử dụng SIM.",
	"If you don't subscribe by the end of the trial_": "Nếu bạn không đăng ký trước khi kết thúc thời gian dùng thử, dịch vụ SIM của bạn sẽ bị ngừng hoạt động.",
	"Save Event Videos_": "Lưu Video sự kiện vào Bộ nhớ đám mây trong thời gian thực!",
	"Note: Deleting your account doesn’t cancel": "Lưu ý: Xóa tài khoản của bạn không hủy bỏ gói đăng ký. Để hủy, hãy vào Tài khoản > Đăng ký trên trình xem web FLEETA.",
	"Available only on FLEETA App for_": "Chỉ có sẵn trên ứng dụng FLEETA cho mẫu này.",
	"The cloud is deactivated": "Đám mây bị vô hiệu hóa.",
	"Please add a camera with FLEETA_": "Vui lòng thêm camera với APP FLEETA để sử dụng tính năng này.",
	"Upload videos to FLEETA_": "Tải video lên FLEETA Lưu trữ và giữ an toàn!",
	"You have no assigned camera_": "Bạn không có máy ảnh được chỉ định.\nVui lòng liên hệ với chủ sở hữu để yêu cầu phân công.",
	"Camera notification settings": "Cài đặt thông báo camera",
	Vehicle: Vehicle,
	"App Download": "Tải ứng dụng",
	"Have a problem with_": "Có vấn đề với việc đăng ký không?",
	"Restore Purchase": "Khôi phục mua hàng",
	"Battery Pairing": "Ghép nối pin",
	"Playback\nLive View": "Phát lại/\nXem trực tiếp",
	"Remote Playback": "Phát lại từ xa",
	"Cloud connection settings": "Cài đặt kết nối đám mây",
	"Go to settings": "Vào mục cài đặt",
	"Only cloud cameras that_": "Chỉ những camera đám mây mà người dùng chọn chia sẻ công khai mới được hiển thị trên bản đồ.",
	"Live Broadcast Cameras": "Camera Phát sóng Trực tiếp",
	"*Live Broadcast Cameras_": "*Camera truyền hình trực tiếp là camera đám mây được người dùng thiết lập để phát sóng.",
	"Only cloud cameras_": "Chỉ những camera đám mây mà người dùng chọn phát sóng mới được hiển thị trên bản đồ."
};

var resources = {
    ar: {
        translation: ar,
    },
    de: {
        translation: de,
    },
    en: {
        translation: en,
    },
    es: {
        translation: es,
    },
    fi: {
        translation: fi,
    },
    fr: {
        translation: fr,
    },
    id: {
        translation: id,
    },
    it: {
        translation: it,
    },
    ja: {
        translation: ja,
    },
    ko: {
        translation: ko,
    },
    nb: {
        translation: nb,
    },
    nl: {
        translation: nl,
    },
    pl: {
        translation: pl,
    },
    ru: {
        translation: ru,
    },
    sc: {
        translation: sc,
    },
    th: {
        translation: th,
    },
    vi: {
        translation: vi,
    },
};

console.log("resources", resources);
i18next
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
    resources: resources,
    lng: "en",
    fallbackLng: "en",
    interpolation: {
        escapeValue: false,
    },
    // allow keys to be phrases having `:`, `.`
    nsSeparator: false,
    keySeparator: false,
});
var i18n = i18next;

var img$7 = "data:image/svg+xml,%3csvg width='18' height='20' viewBox='0 0 18 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cg filter='url(%23filter0_ddd_34522_69)'%3e%3cpath d='M3 16.2632L9 3L15 16.2632L14.2 17L9 15L3.8 17L3 16.2632Z' fill='%230095E0'/%3e%3cpath d='M9.17949 14.5333L9 14.4643L8.82051 14.5333L3.91033 16.4219L3.60444 16.1401L9 4.2131L14.3956 16.1401L14.0897 16.4219L9.17949 14.5333Z' stroke='white'/%3e%3c/g%3e%3cdefs%3e%3cfilter id='filter0_ddd_34522_69' x='0' y='0' width='18' height='20' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3e%3cfeFlood flood-opacity='0' result='BackgroundImageFix'/%3e%3cfeColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha'/%3e%3cfeOffset/%3e%3cfeGaussianBlur stdDeviation='1.5'/%3e%3cfeColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0'/%3e%3cfeBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_34522_69'/%3e%3cfeColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha'/%3e%3cfeOffset dy='1'/%3e%3cfeGaussianBlur stdDeviation='0.5'/%3e%3cfeColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0'/%3e%3cfeBlend mode='normal' in2='effect1_dropShadow_34522_69' result='effect2_dropShadow_34522_69'/%3e%3cfeColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha'/%3e%3cfeOffset/%3e%3cfeGaussianBlur stdDeviation='0.5'/%3e%3cfeColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0'/%3e%3cfeBlend mode='normal' in2='effect2_dropShadow_34522_69' result='effect3_dropShadow_34522_69'/%3e%3cfeBlend mode='normal' in='SourceGraphic' in2='effect3_dropShadow_34522_69' result='shape'/%3e%3c/filter%3e%3c/defs%3e%3c/svg%3e";

var img$6 = "data:image/svg+xml,%3csvg width='38' height='47' viewBox='0 0 38 47' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cellipse cx='7' cy='40.5' rx='6' ry='3.5' fill='%23D81A26'/%3e%3cg filter='url(%23filter0_d_2_21912)'%3e%3cpath d='M30 7H9V4H5V41H9V25H30L25 16L30 7Z' fill='%23D81A26'/%3e%3cpath d='M8.5 7V7.5H9H29.1502L24.5629 15.7572L24.428 16L24.5629 16.2428L29.1502 24.5H9H8.5V25V40.5H5.5V4.5H8.5V7Z' stroke='white'/%3e%3c/g%3e%3cdefs%3e%3cfilter id='filter0_d_2_21912' x='0' y='0' width='35' height='47' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3e%3cfeFlood flood-opacity='0' result='BackgroundImageFix'/%3e%3cfeColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha'/%3e%3cfeOffset dy='1'/%3e%3cfeGaussianBlur stdDeviation='2.5'/%3e%3cfeColorMatrix type='matrix' values='0 0 0 0 0.847059 0 0 0 0 0.101961 0 0 0 0 0.14902 0 0 0 0.45 0'/%3e%3cfeBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_2_21912'/%3e%3cfeBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_2_21912' result='shape'/%3e%3c/filter%3e%3c/defs%3e%3c/svg%3e";

var img$5 = "data:image/svg+xml,%3csvg width='38' height='42' viewBox='0 0 38 42' fill='none' xmlns='http://www.w3.org/2000/svg' id='event-marker'%3e%3cg filter='url(%23filter0_d_14309_4166)'%3e%3cpath d='M5.5 17.7143C5.5 10.4259 11.5344 4.5 19 4.5C26.4656 4.5 32.5 10.4259 32.5 17.7143C32.5 23.4606 28.7508 28.3588 23.5031 30.1757C22.8482 30.4025 22.3353 30.9237 21.9187 31.4855C21.513 32.0326 21.1524 32.6838 20.8209 33.2824L20.7849 33.3475C20.4332 33.9822 20.1176 34.5436 19.7904 34.9497C19.4543 35.3668 19.2007 35.5 19 35.5C18.7997 35.5 18.5487 35.3681 18.2162 34.9528C17.8919 34.5479 17.5801 33.9882 17.2306 33.3537L17.2044 33.3061C16.8723 32.7031 16.5096 32.0444 16.0975 31.4906C15.6777 30.9265 15.1601 30.4053 14.4969 30.1757C9.24924 28.3588 5.5 23.4606 5.5 17.7143Z' fill='%23D81A26' stroke='white'/%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M15.4834 18.1562V18.3464C15.4739 18.4957 15.5025 18.6449 15.5664 18.7796V19.2656L13.2837 21.3788L13.9996 18.1034L10.7 18.209L13.3148 16.1592L10.7208 14.046L14.01 14.1834L13.3356 10.8973L15.774 13.1584L17.3304 10.2L17.7765 13.4754L20.7856 12.3026L19.25 14.7645H18.4821C18.2047 14.762 17.9327 14.8429 17.7002 14.997C17.4676 15.1511 17.2849 15.3716 17.1747 15.6309L16.6455 17.237H16.3861C16.1484 17.2423 15.9218 17.3409 15.7537 17.5122C15.5855 17.6834 15.4887 17.9141 15.4834 18.1562ZM24.7932 15.4162C24.9246 15.5146 25.0276 15.6472 25.0917 15.8L25.6831 17.8815H26.3368C26.4315 17.8866 26.521 17.9272 26.5881 17.9954C26.6551 18.0637 26.695 18.1549 26.7 18.2513V18.4415C26.6952 18.539 26.6557 18.6314 26.5889 18.7015C26.522 18.7715 26.4324 18.8143 26.3368 18.8219H26.2434L26.5236 19.1071V23.5343C26.5324 23.6974 26.4791 23.8577 26.3747 23.9817C26.2703 24.1057 26.1229 24.1839 25.9633 24.2H25.4964C25.2266 24.2 24.9464 23.8196 24.9464 23.5343V22.4777H17.6831V23.5343C17.6919 23.6974 17.6386 23.8577 17.5342 23.9817C17.4298 24.1057 17.2824 24.1839 17.1228 24.2H16.6559C16.3861 24.2 16.106 23.8196 16.106 23.5343V19.1071L16.4795 18.7268H16.3861C16.2894 18.7194 16.1985 18.677 16.13 18.6072C16.0614 18.5374 16.0198 18.4448 16.0126 18.3464V18.1562C16.02 18.0588 16.0621 17.9676 16.1308 17.8995C16.1996 17.8315 16.2904 17.7912 16.3861 17.7864H17.0294L17.6831 15.8C17.7475 15.6306 17.862 15.4857 18.0107 15.3854C18.1594 15.2851 18.3349 15.2343 18.5132 15.24H24.3446C24.5069 15.2568 24.6618 15.3177 24.7932 15.4162ZM24.3446 16.0853H18.5132L17.6831 18.5366H25.1851L24.3446 16.0853ZM17.822 20.9236C17.9227 20.966 18.0307 20.9879 18.1397 20.9879C18.2496 20.9893 18.3586 20.9685 18.4605 20.9266C18.5624 20.8848 18.6552 20.8227 18.7334 20.7441C18.8115 20.6655 18.8736 20.5718 18.916 20.4686C18.9584 20.3653 18.9802 20.2545 18.9802 20.1426C18.9802 19.9156 18.8916 19.6979 18.734 19.5374C18.5764 19.3769 18.3626 19.2868 18.1397 19.2868C18.0298 19.2868 17.921 19.309 17.8196 19.3521C17.7182 19.3952 17.6263 19.4585 17.549 19.5381C17.4718 19.6177 17.4109 19.7121 17.3698 19.8159C17.3287 19.9197 17.3082 20.0307 17.3096 20.1426C17.3096 20.2536 17.3311 20.3635 17.3728 20.4661C17.4145 20.5687 17.4756 20.6618 17.5527 20.7403C17.6298 20.8188 17.7213 20.8811 17.822 20.9236ZM24.3071 20.9236C24.4078 20.966 24.5158 20.9879 24.6248 20.9879C24.7338 20.9879 24.8417 20.966 24.9424 20.9236C25.0432 20.8811 25.1346 20.8188 25.2117 20.7403C25.2888 20.6618 25.35 20.5687 25.3917 20.4661C25.4334 20.3635 25.4549 20.2536 25.4549 20.1426C25.4562 20.0307 25.4358 19.9197 25.3947 19.8159C25.3536 19.7121 25.2926 19.6177 25.2154 19.5381C25.1382 19.4585 25.0462 19.3952 24.9448 19.3521C24.8435 19.309 24.7347 19.2868 24.6248 19.2868C24.5149 19.2868 24.4061 19.309 24.3047 19.3521C24.2033 19.3952 24.1113 19.4585 24.0341 19.5381C23.9569 19.6177 23.896 19.7121 23.8549 19.8159C23.8138 19.9197 23.7933 20.0307 23.7947 20.1426C23.7947 20.2536 23.8162 20.3635 23.8579 20.4661C23.8996 20.5687 23.9607 20.6618 24.0378 20.7403C24.1149 20.8188 24.2064 20.8811 24.3071 20.9236Z' fill='white'/%3e%3c/g%3e%3cdefs%3e%3cfilter id='filter0_d_14309_4166' x='0' y='0' width='38' height='42' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3e%3cfeFlood flood-opacity='0' result='BackgroundImageFix'/%3e%3cfeColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha'/%3e%3cfeOffset dy='1'/%3e%3cfeGaussianBlur stdDeviation='2.5'/%3e%3cfeColorMatrix type='matrix' values='0 0 0 0 0.847059 0 0 0 0 0.101961 0 0 0 0 0.14902 0 0 0 0.45 0'/%3e%3cfeBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_14309_4166'/%3e%3cfeBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_14309_4166' result='shape'/%3e%3c/filter%3e%3c/defs%3e%3c/svg%3e";

var img$4 = "data:image/svg+xml,%3csvg width='38' height='42' viewBox='0 0 38 42' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cg filter='url(%23filter0_d_14309_4165)'%3e%3cpath d='M32.5 17.7143C32.5 23.4606 28.7508 28.3588 23.5031 30.1757C22.8482 30.4025 22.3353 30.9237 21.9187 31.4855C21.513 32.0326 21.1524 32.6838 20.8209 33.2824C20.8089 33.3042 20.7969 33.3259 20.7849 33.3475C20.4332 33.9822 20.1176 34.5436 19.7904 34.9497C19.4543 35.3668 19.2007 35.5 19 35.5C18.7997 35.5 18.5487 35.3681 18.2162 34.9528C17.8919 34.5479 17.5801 33.9882 17.2306 33.3537L17.2044 33.3061C16.8723 32.7031 16.5096 32.0444 16.0975 31.4906C15.6777 30.9265 15.1601 30.4053 14.4969 30.1757C9.24924 28.3588 5.5 23.4606 5.5 17.7143C5.5 10.4259 11.5344 4.5 19 4.5C26.4656 4.5 32.5 10.4259 32.5 17.7143Z' fill='%23D81A26' stroke='white'/%3e%3cpath d='M19 28.5C24.9371 28.5 29.75 23.6871 29.75 17.75C29.75 11.8129 24.9371 7 19 7C13.0629 7 8.25 11.8129 8.25 17.75C8.25 23.6871 13.0629 28.5 19 28.5Z' fill='%23FFEC00'/%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M19.6283 9.37707C19.4992 9.17482 19.2609 9.08132 19.0203 9.14043L15.177 10.0849C14.9311 10.1453 14.7686 10.3373 14.7426 10.5777L14.6211 12.0171L14.1712 12.1276C14.0236 12.1639 13.935 12.3197 13.9733 12.4755L14.008 12.6166C14.0463 12.7725 14.197 12.8694 14.3446 12.8332L14.4355 12.8108L14.2681 13.0983L15.0086 16.1115C15.0601 16.3211 15.2836 16.4928 15.4868 16.4429L15.8182 16.3615C16.0213 16.3115 16.1302 16.0625 16.0786 15.8529L15.9042 15.1433L20.7151 13.961L20.8895 14.6707C20.941 14.8803 21.1582 15.0492 21.3613 14.9993L21.6874 14.9191C21.8905 14.8692 22.009 14.6135 21.9575 14.4038L21.2171 11.3907L20.9355 11.2135L21.0263 11.1912C21.1739 11.1549 21.2626 10.9991 21.2243 10.8433L21.1896 10.7022C21.1513 10.5463 21.0006 10.4494 20.853 10.4856L20.4031 10.5962L19.6283 9.37707ZM15.3125 10.6365L19.1559 9.69204L20.1131 11.2116L15.1686 12.4266L15.3125 10.6365ZM15.9067 14C15.6127 14.0723 15.3112 13.8832 15.2366 13.5798C15.1621 13.2764 15.3416 12.969 15.6356 12.8968C15.9296 12.8246 16.2311 13.0137 16.3057 13.317C16.3803 13.6204 16.2007 13.9278 15.9067 14ZM20.183 12.9491C19.889 13.0214 19.5875 12.8323 19.5129 12.5289C19.4384 12.2255 19.6179 11.9182 19.9119 11.8459C20.2059 11.7737 20.5074 11.9628 20.582 12.2662C20.6565 12.5696 20.477 12.8769 20.183 12.9491Z' fill='%2313131C'/%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M24.58 16.8921C23.1909 16.4248 21.7381 16.1247 20.26 16C21.6337 16.322 22.9523 16.8081 24.18 17.4452C24.75 17.7664 25.29 18.2838 25.36 18.605C25.43 18.9262 25.04 19.283 24.52 19.6042L25.47 20.6391C25.7906 20.3789 26.0668 20.0783 26.29 19.7469C26.416 19.5383 26.4942 19.3093 26.52 19.0735C26.5457 18.8376 26.5185 18.5995 26.44 18.3731C26.2626 17.9875 25.964 17.6559 25.58 17.4185C25.2675 17.2133 24.9324 17.037 24.58 16.8921ZM18.53 16.1874C19.6923 16.54 20.8141 16.9911 21.88 17.5345C22.4473 17.8054 22.942 18.1828 23.33 18.6407C23.4462 18.7834 23.5185 18.9507 23.5395 19.126C23.5606 19.3013 23.5297 19.4785 23.45 19.6399C23.274 19.931 23.0063 20.1698 22.68 20.3268C22.0954 20.557 21.6084 20.9477 21.29 21.442C21.2357 21.5342 21.2073 21.6367 21.2073 21.7409C21.2073 21.8012 21.2351 21.8919 21.2584 21.9576C21.2781 22.0128 21.3058 22.0645 21.3398 22.1123C21.3817 22.171 21.4436 22.2527 21.5 22.3074C21.5973 22.4016 21.6902 22.4565 21.7884 22.5144C21.8119 22.5283 21.8358 22.5423 21.86 22.5571C22.9835 23.1653 24.3254 23.3664 25.61 23.1192L25.8 24.4485C24.1666 24.613 22.5244 24.214 21.21 23.3333C21.0411 23.2146 20.8839 23.0833 20.74 22.9408C20.588 22.7745 20.5032 22.6775 20.38 22.3876C20.2568 22.0978 20.2448 21.9603 20.2568 21.7385C20.2689 21.5167 20.3348 21.2998 20.45 21.103C20.9089 20.4781 21.5879 20.0073 22.38 19.7648C22.88 19.5418 23.18 19.2652 22.91 18.8727C22.5945 18.4452 22.1865 18.0782 21.71 17.7932C20.7099 17.1685 19.6451 16.6308 18.53 16.1874ZM17.12 16.4639C17.5749 16.709 17.9694 17.0337 18.28 17.4185C18.4516 17.6272 18.5364 17.8827 18.52 18.1411C18.4831 18.4094 18.3329 18.6551 18.1 18.828C17.6598 19.1343 17.1571 19.3615 16.62 19.4971C16.104 19.6334 15.4317 19.8022 15.05 19.8272C14.1513 19.886 13.2575 20.0516 12.43 20.3625C12.05 20.5052 11.75 20.7372 11.73 20.8799C11.71 21.0226 11.8 21.1832 12.01 21.4509L10.78 22.2092C10.6095 21.964 10.4845 21.6959 10.41 21.4152C10.3076 21.0755 10.3466 20.7141 10.52 20.3981C10.6839 20.1508 10.9022 19.9356 11.1617 19.7655C11.4212 19.5953 11.7165 19.4737 12.03 19.4079C12.5248 19.2748 13.0346 19.1911 13.55 19.1581C14.0462 19.1313 14.5438 19.1313 15.04 19.1581C15.5461 19.138 16.0504 19.0903 16.55 19.0154C17.0221 18.9418 17.4738 18.7873 17.88 18.5604C17.9764 18.5068 18.0598 18.4366 18.1252 18.3538C18.1907 18.2711 18.2369 18.1775 18.2611 18.0785C18.2854 17.9796 18.2871 17.8773 18.2663 17.7777C18.2455 17.6781 18.2026 17.5833 18.14 17.4987C17.8807 17.0966 17.5339 16.7447 17.12 16.4639Z' fill='%2313131C'/%3e%3c/g%3e%3cdefs%3e%3cfilter id='filter0_d_14309_4165' x='0' y='0' width='38' height='42' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3e%3cfeFlood flood-opacity='0' result='BackgroundImageFix'/%3e%3cfeColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha'/%3e%3cfeOffset dy='1'/%3e%3cfeGaussianBlur stdDeviation='2.5'/%3e%3cfeColorMatrix type='matrix' values='0 0 0 0 0.847059 0 0 0 0 0.101961 0 0 0 0 0.14902 0 0 0 0.45 0'/%3e%3cfeBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_14309_4165'/%3e%3cfeBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_14309_4165' result='shape'/%3e%3c/filter%3e%3c/defs%3e%3c/svg%3e";

var img$3 = "data:image/svg+xml,%3csvg width='38' height='42' viewBox='0 0 38 42' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cg filter='url(%23filter0_d_14312_4187)'%3e%3cpath d='M5.5 17.7143C5.5 10.4259 11.5344 4.5 19 4.5C26.4656 4.5 32.5 10.4259 32.5 17.7143C32.5 23.4606 28.7508 28.3588 23.5031 30.1757C22.8482 30.4025 22.3353 30.9237 21.9187 31.4855C21.513 32.0326 21.1524 32.6838 20.8209 33.2824L20.7849 33.3475C20.4332 33.9822 20.1176 34.5436 19.7904 34.9497C19.4543 35.3668 19.2007 35.5 19 35.5C18.7997 35.5 18.5487 35.3681 18.2162 34.9528C17.8919 34.5479 17.5801 33.9882 17.2306 33.3537L17.2044 33.3061C16.8723 32.7031 16.5096 32.0444 16.0975 31.4906C15.6777 30.9265 15.1601 30.4053 14.4969 30.1757C9.24924 28.3588 5.5 23.4606 5.5 17.7143Z' fill='%23D81A26' stroke='white'/%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M23.3471 11.5H27.8238V12.3313L25.1545 16.1063H27.8471V17.3H23.3471V16.446L25.9712 12.7052H23.3471V11.5ZM19.5 15.5H22.4608V16.1559L22.2574 16.504L20.951 18.4928H22.5V19.5H19.5V18.8314L20.1056 17.8891L21.0189 16.5072H19.5V15.5Z' fill='white'/%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M18.14 16.8875C18.14 18.206 17.0744 19.2749 15.76 19.2749C14.4455 19.2749 13.38 18.206 13.38 16.8875C13.38 15.5689 14.4455 14.5 15.76 14.5C17.0744 14.5 18.14 15.5689 18.14 16.8875ZM20.5 22.6367C20.5 21.0518 17.34 20.2493 15.75 20.2493C14.16 20.2493 11 21.0518 11 22.6367V23.8305H12.77C12.77 23.0323 13.0861 22.2669 13.6487 21.7025C14.2113 21.1381 14.9743 20.8211 15.77 20.8211C16.5656 20.8211 17.3287 21.1381 17.8913 21.7025C18.4539 22.2669 18.77 23.0323 18.77 23.8305H20.54L20.5 22.6367ZM15.75 21.6737C15.1798 21.6737 14.6329 21.9009 14.2297 22.3054C13.8265 22.7098 13.6 23.2584 13.6 23.8304H17.93C17.93 23.5446 17.8734 23.2617 17.7635 22.9981C17.6536 22.7344 17.4925 22.4953 17.2897 22.2946C17.0869 22.094 16.8463 21.9357 16.582 21.8291C16.3176 21.7225 16.0349 21.6697 15.75 21.6737Z' fill='white'/%3e%3c/g%3e%3cdefs%3e%3cfilter id='filter0_d_14312_4187' x='0' y='0' width='38' height='42' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3e%3cfeFlood flood-opacity='0' result='BackgroundImageFix'/%3e%3cfeColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha'/%3e%3cfeOffset dy='1'/%3e%3cfeGaussianBlur stdDeviation='2.5'/%3e%3cfeColorMatrix type='matrix' values='0 0 0 0 0.847059 0 0 0 0 0.101961 0 0 0 0 0.14902 0 0 0 0.45 0'/%3e%3cfeBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_14312_4187'/%3e%3cfeBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_14312_4187' result='shape'/%3e%3c/filter%3e%3c/defs%3e%3c/svg%3e";

var img$2 = "data:image/svg+xml,%3csvg width='38' height='42' viewBox='0 0 38 42' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cg filter='url(%23filter0_d_14732_4121)'%3e%3cpath d='M32.5 17.7143C32.5 23.4606 28.7508 28.3588 23.5031 30.1757C22.8482 30.4025 22.3353 30.9237 21.9187 31.4855C21.513 32.0326 21.1524 32.6838 20.8209 33.2824C20.8089 33.3042 20.7969 33.3259 20.7849 33.3475C20.4332 33.9822 20.1176 34.5436 19.7904 34.9497C19.4543 35.3668 19.2007 35.5 19 35.5C18.7997 35.5 18.5487 35.3681 18.2162 34.9528C17.8919 34.5479 17.5801 33.9882 17.2306 33.3537L17.2044 33.3061C16.8723 32.7031 16.5096 32.0444 16.0975 31.4906C15.6777 30.9265 15.1601 30.4053 14.4969 30.1757C9.24924 28.3588 5.5 23.4606 5.5 17.7143C5.5 10.4259 11.5344 4.5 19 4.5C26.4656 4.5 32.5 10.4259 32.5 17.7143Z' fill='%23D81A26' stroke='white'/%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M19.0065 10.1747C21.4852 10.1747 23.5016 12.0149 23.5016 14.2771C23.5016 18.3795 19.0065 21.8958 19.0065 21.8958C19.0065 21.8958 14.5113 18.3795 14.5113 14.2771C14.5113 12.0149 16.5277 10.1747 19.0065 10.1747ZM21.3373 14.5034C21.3373 15.7907 20.2937 16.8342 19.0065 16.8342C17.7192 16.8342 16.6756 15.7907 16.6756 14.5034C16.6756 13.2161 17.7192 12.1726 19.0065 12.1726C20.2937 12.1726 21.3373 13.2161 21.3373 14.5034ZM21.6421 20.3556C21.3913 20.3112 21.1525 20.482 21.1089 20.7371C21.0652 20.9922 21.2332 21.235 21.484 21.2794C21.8294 21.3405 22.1498 21.4136 22.4405 21.4964C22.6856 21.5663 22.9401 21.4208 23.0088 21.1715C23.0775 20.9222 22.9345 20.6634 22.6893 20.5935C22.3654 20.5012 22.0144 20.4214 21.6421 20.3556ZM16.5289 21.2794C16.7798 21.235 16.9477 20.9922 16.9041 20.7371C16.8604 20.482 16.6217 20.3112 16.3708 20.3556C15.9985 20.4214 15.6475 20.5012 15.3236 20.5935C15.0785 20.6634 14.9354 20.9222 15.0041 21.1715C15.0729 21.4208 15.3273 21.5663 15.5725 21.4964C15.8631 21.4136 16.1835 21.3405 16.5289 21.2794ZM14.0174 22.2933C14.175 22.09 14.1407 21.7952 13.9408 21.6348C13.7408 21.4745 13.4509 21.5094 13.2933 21.7127C13.1267 21.9275 13.0129 22.1871 13.0129 22.481C13.0129 22.775 13.1267 23.0345 13.2933 23.2493C13.4509 23.4527 13.7408 23.4875 13.9408 23.3272C14.1407 23.1669 14.175 22.8721 14.0174 22.6688C13.9473 22.5784 13.935 22.5175 13.935 22.481C13.935 22.4446 13.9473 22.3837 14.0174 22.2933ZM24.7197 21.7127C24.562 21.5094 24.2721 21.4745 24.0722 21.6348C23.8722 21.7952 23.8379 22.09 23.9956 22.2933C24.0657 22.3837 24.0779 22.4446 24.0779 22.481C24.0779 22.5175 24.0657 22.5784 23.9956 22.6688C23.8379 22.8721 23.8722 23.1669 24.0722 23.3272C24.2721 23.4875 24.562 23.4527 24.7197 23.2493C24.8862 23.0345 25 22.775 25 22.481C25 22.1871 24.8862 21.9275 24.7197 21.7127ZM15.5725 23.4656C15.3273 23.3958 15.0729 23.5412 15.0041 23.7906C14.9354 24.0399 15.0785 24.2987 15.3236 24.3685C15.6475 24.4608 15.9985 24.5406 16.3708 24.6065C16.6217 24.6509 16.8604 24.4801 16.9041 24.225C16.9477 23.9699 16.7798 23.7271 16.5289 23.6827C16.1835 23.6216 15.8631 23.5485 15.5725 23.4656ZM22.6893 24.3685C22.9345 24.2987 23.0775 24.0399 23.0088 23.7906C22.9401 23.5412 22.6856 23.3958 22.4405 23.4656C22.1498 23.5485 21.8294 23.6216 21.484 23.6827C21.2332 23.7271 21.0652 23.9699 21.1089 24.225C21.1525 24.4801 21.3913 24.6509 21.6421 24.6065C22.0144 24.5406 22.3654 24.4608 22.6893 24.3685ZM18.5069 23.8798C18.2524 23.8719 18.0397 24.0752 18.0319 24.334C18.0241 24.5929 18.2241 24.8091 18.4786 24.8171C18.6525 24.8225 18.8286 24.8253 19.0065 24.8253C19.1844 24.8253 19.3605 24.8225 19.5343 24.8171C19.7888 24.8091 19.9888 24.5929 19.981 24.334C19.9732 24.0752 19.7605 23.8719 19.506 23.8798C19.3416 23.8849 19.175 23.8876 19.0065 23.8876C18.838 23.8876 18.6713 23.8849 18.5069 23.8798Z' fill='white'/%3e%3c/g%3e%3cdefs%3e%3cfilter id='filter0_d_14732_4121' x='0' y='0' width='38' height='42' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3e%3cfeFlood flood-opacity='0' result='BackgroundImageFix'/%3e%3cfeColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha'/%3e%3cfeOffset dy='1'/%3e%3cfeGaussianBlur stdDeviation='2.5'/%3e%3cfeColorMatrix type='matrix' values='0 0 0 0 0.847059 0 0 0 0 0.101961 0 0 0 0 0.14902 0 0 0 0.45 0'/%3e%3cfeBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_14732_4121'/%3e%3cfeBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_14732_4121' result='shape'/%3e%3c/filter%3e%3c/defs%3e%3c/svg%3e";

var img$1 = "data:image/svg+xml,%3csvg width='38' height='42' viewBox='0 0 38 42' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cg filter='url(%23filter0_d_14309_4173)'%3e%3cpath d='M32 26.5C32 28.433 30.433 30 28.5 30H23.3983C23.0741 30 22.6913 30.1046 22.4204 30.4163C22.0812 30.8065 21.7882 31.3438 21.5336 31.8517C21.4361 32.0464 21.3447 32.2355 21.2569 32.4172C21.1031 32.7353 20.9602 33.0309 20.8142 33.2945C20.4564 33.9407 20.1364 34.5153 19.8038 34.9329C19.4617 35.3624 19.2039 35.5 19 35.5C18.7977 35.5 18.544 35.3654 18.2077 34.9422C17.8801 34.53 17.5655 33.9619 17.212 33.32C17.0682 33.0588 16.9281 32.7682 16.7771 32.4551C16.6852 32.2646 16.5894 32.0658 16.4862 31.8603C16.2284 31.3464 15.9301 30.8027 15.5821 30.409C15.3111 30.1025 14.9319 30 14.6106 30H9.5C7.567 30 6 28.433 6 26.5V8.5C6 6.567 7.567 5 9.5 5H28.5C30.433 5 32 6.567 32 8.5V26.5Z' fill='%230095E0' stroke='white'/%3e%3cpath d='M18.1084 19.7684V23.5H15.5V12.501H19.8236C20.5795 12.4855 21.329 12.6441 22.0158 12.9649C22.6289 13.2488 23.1448 13.7117 23.4976 14.2947C23.8438 14.8785 24.0165 15.5515 23.9949 16.2326C24.0225 16.7278 23.9371 17.2227 23.7452 17.6787C23.5533 18.1347 23.2601 18.5394 22.8886 18.8613C21.9949 19.5461 20.8906 19.8859 19.7729 19.8199L18.1084 19.7684ZM18.1084 17.7067H19.8236C20.232 17.7336 20.635 17.6008 20.9502 17.3356C21.0801 17.199 21.182 17.0376 21.25 16.8606C21.3179 16.6836 21.3506 16.4947 21.346 16.3048C21.3703 15.8551 21.2251 15.4128 20.94 15.0678C20.7967 14.9148 20.6232 14.7943 20.4307 14.7144C20.2383 14.6344 20.0314 14.5968 19.8236 14.6039H18.1084V17.7067Z' fill='white'/%3e%3c/g%3e%3cdefs%3e%3cfilter id='filter0_d_14309_4173' x='0' y='0' width='38' height='42' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3e%3cfeFlood flood-opacity='0' result='BackgroundImageFix'/%3e%3cfeColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha'/%3e%3cfeOffset dy='1'/%3e%3cfeGaussianBlur stdDeviation='2.5'/%3e%3cfeColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0.584314 0 0 0 0 0.878431 0 0 0 0.45 0'/%3e%3cfeBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_14309_4173'/%3e%3cfeBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_14309_4173' result='shape'/%3e%3c/filter%3e%3c/defs%3e%3c/svg%3e";

var img = "data:image/svg+xml,%3csvg width='39' height='43' viewBox='0 0 39 43' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cg filter='url(%23filter0_d_2_28495)'%3e%3cpath d='M32 27.5C32 29.433 30.433 31 28.5 31H23.3983C23.0741 31 22.6913 31.1046 22.4204 31.4163C22.0812 31.8065 21.7882 32.3438 21.5336 32.8517C21.4361 33.0464 21.3447 33.2355 21.2568 33.4172C21.1031 33.7353 20.9602 34.0309 20.8142 34.2945C20.4564 34.9407 20.1364 35.5153 19.8038 35.9329C19.4617 36.3624 19.2039 36.5 19 36.5C18.7977 36.5 18.544 36.3654 18.2077 35.9422C17.8801 35.53 17.5655 34.9619 17.212 34.32C17.0682 34.0588 16.9281 33.7682 16.7771 33.4551C16.6852 33.2646 16.5894 33.0658 16.4862 32.8603C16.2284 32.3464 15.9301 31.8027 15.582 31.409C15.3111 31.1025 14.9319 31 14.6106 31H9.5C7.567 31 6 29.433 6 27.5V9.5C6 7.567 7.567 6 9.5 6H28.5C30.433 6 32 7.567 32 9.5V27.5Z' fill='%230095E0' stroke='white'/%3e%3cpath d='M18.1084 20.7684V24.5H15.5V13.501H19.8236C20.5795 13.4855 21.329 13.6441 22.0158 13.9649C22.6289 14.2488 23.1448 14.7117 23.4976 15.2947C23.8438 15.8785 24.0165 16.5515 23.9949 17.2326C24.0225 17.7278 23.9371 18.2227 23.7452 18.6787C23.5533 19.1347 23.2601 19.5394 22.8886 19.8613C21.9949 20.5461 20.8906 20.8859 19.7729 20.8199L18.1084 20.7684ZM18.1084 18.7067H19.8236C20.232 18.7336 20.635 18.6008 20.9502 18.3356C21.0801 18.199 21.182 18.0376 21.25 17.8606C21.3179 17.6836 21.3506 17.4947 21.346 17.3048C21.3703 16.8551 21.2251 16.4128 20.94 16.0678C20.7967 15.9148 20.6232 15.7943 20.4307 15.7144C20.2383 15.6344 20.0314 15.5968 19.8236 15.6039H18.1084V18.7067Z' fill='white'/%3e%3ccircle cx='30' cy='8' r='3.5' fill='%23D81A26' stroke='white'/%3e%3c/g%3e%3cdefs%3e%3cfilter id='filter0_d_2_28495' x='0' y='0' width='39' height='43' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3e%3cfeFlood flood-opacity='0' result='BackgroundImageFix'/%3e%3cfeColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha'/%3e%3cfeOffset dy='1'/%3e%3cfeGaussianBlur stdDeviation='2.5'/%3e%3cfeColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0.584314 0 0 0 0 0.878431 0 0 0 0.45 0'/%3e%3cfeBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_2_28495'/%3e%3cfeBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_2_28495' result='shape'/%3e%3c/filter%3e%3c/defs%3e%3c/svg%3e";

var GetStartIcon = function (tindx) { return "<svg width=\"32\" height=\"47\" viewBox=\"0 0 32 47\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<ellipse cx=\"16\" cy=\"40.5\" rx=\"6\" ry=\"3.5\" fill=\"#D81A26\"/>\n<g filter=\"url(#filter0_d_22345_157536)\">\n<mask id=\"path-2-inside-1_22345_157536\" fill=\"white\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M18 25.8186C23.1202 24.8781 27 20.3921 27 15C27 8.92487 22.0751 4 16 4C9.92487 4 5 8.92487 5 15C5 20.3921 8.87976 24.8781 14 25.8186V41H18V25.8186Z\"/>\n</mask>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M18 25.8186C23.1202 24.8781 27 20.3921 27 15C27 8.92487 22.0751 4 16 4C9.92487 4 5 8.92487 5 15C5 20.3921 8.87976 24.8781 14 25.8186V41H18V25.8186Z\" fill=\"#D81A26\"/>\n<path d=\"M18 25.8186L17.8193 24.8351L17 24.9856V25.8186H18ZM14 25.8186H15V24.9856L14.1807 24.8351L14 25.8186ZM14 41H13V42H14V41ZM18 41V42H19V41H18ZM26 15C26 19.9009 22.4735 23.9802 17.8193 24.8351L18.1807 26.8022C23.767 25.776 28 20.8834 28 15H26ZM16 5C21.5228 5 26 9.47715 26 15H28C28 8.37258 22.6274 3 16 3V5ZM6 15C6 9.47715 10.4772 5 16 5V3C9.37258 3 4 8.37258 4 15H6ZM14.1807 24.8351C9.52652 23.9802 6 19.9009 6 15H4C4 20.8834 8.23301 25.776 13.8193 26.8022L14.1807 24.8351ZM15 41V25.8186H13V41H15ZM18 40H14V42H18V40ZM17 25.8186V41H19V25.8186H17Z\" fill=\"white\" mask=\"url(#path-2-inside-1_22345_157536)\"/>\n</g>\n<text text-anchor=\"middle\" alignment-baseline=\"middle\"  fill=\"#ffffff\" x=\"16\" y=\"16\" font-size=\"10\" font-family=\"rotobo\">A".concat(tindx, "</text>\n<defs>\n<filter id=\"filter0_d_22345_157536\" x=\"0\" y=\"0\" width=\"32\" height=\"47\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\">\n<feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"/>\n<feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\"/>\n<feOffset dy=\"1\"/>\n<feGaussianBlur stdDeviation=\"2.5\"/>\n<feColorMatrix type=\"matrix\" values=\"0 0 0 0 0.847059 0 0 0 0 0.101961 0 0 0 0 0.14902 0 0 0 0.45 0\"/>\n<feBlend mode=\"normal\" in2=\"BackgroundImageFix\" result=\"effect1_dropShadow_22345_157536\"/>\n<feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"effect1_dropShadow_22345_157536\" result=\"shape\"/>\n</filter>\n</defs>\n</svg>"); };

var GPSTrackingIcons = __spreadArray([
    {
        src: img$7,
        name: "location",
        width: 18,
        height: 20,
    },
    {
        src: img$6,
        name: "end",
        width: 38,
        height: 47,
    },
    {
        src: img$5,
        name: "impact",
        width: 38,
        height: 42,
    },
    {
        src: img$5,
        name: "impact-clicked",
        width: 46,
        height: 50,
    },
    {
        src: img$4,
        name: "reckless",
        width: 38,
        height: 42,
    },
    {
        src: img$4,
        name: "reckless-clicked",
        width: 46,
        height: 50,
    },
    {
        src: img$3,
        name: "ai",
        width: 38,
        height: 42,
    },
    {
        src: img$3,
        name: "ai-clicked",
        width: 46,
        height: 50,
    },
    {
        src: img$2,
        name: "geofence",
        width: 38,
        height: 42,
    },
    {
        src: img$2,
        name: "geofence-clicked",
        width: 46,
        height: 50,
    },
    {
        src: img$1,
        name: "parking-normal",
        width: 39,
        height: 43,
    },
    {
        src: img$1,
        name: "parking-normal-clicked",
        width: 46,
        height: 50,
    },
    {
        src: img,
        name: "parking-impact",
        width: 39,
        height: 43,
    },
    {
        src: img,
        name: "parking-impact-clicked",
        width: 46,
        height: 50,
    }
], _.range(0, 100).map(function (i) { return ({
    src: GetStartIcon(i),
    name: "start-".concat(i),
    width: 38,
    height: 47,
    string: true,
}); }), true);

var getOrientation = function (key) {
    var _a, _b;
    // console.log(
    //   "orientation",
    //   key,
    //   window.orientation,
    //   window.screen?.orientation?.type,
    //   window.innerWidth,
    //   window.innerHeight,
    //   window.innerHeight > window.innerWidth
    // );
    if ((_b = (_a = window.screen) === null || _a === void 0 ? void 0 : _a.orientation) === null || _b === void 0 ? void 0 : _b.type) {
        if (window.screen.orientation.type.startsWith("landscape")) {
            return "landscape";
        }
        else {
            return "portrait";
        }
    }
    if (window.orientation) {
        if (Math.abs(window.orientation) === 90) {
            return "landscape";
        }
        else {
            return "portrait";
        }
    }
    if (window.innerHeight > window.innerWidth) {
        return "portrait";
    }
    else {
        return "landscape";
    }
};
var useScreenOrientation = function (key) {
    var _a = useState(getOrientation()), orientation = _a[0], setOrientation = _a[1];
    var updateOrientation = _.debounce(function () {
        var ori = getOrientation();
        // console.log("orientation", key, "updateOrientation", ori);
        setOrientation(ori);
    }, 100, { trailing: true });
    useEffect(function () {
        window.addEventListener("orientationchange", updateOrientation);
        return function () {
            // console.log("orientation", key, "remove");
            window.removeEventListener("orientationchange", updateOrientation);
        };
    }, []);
    // console.log("orientation", key, "useScreenOrientation", orientation);
    return orientation;
};

var useWindowSize = function () {
    // Initialize state with undefined width/height so server and client renders match
    // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
    var _a = useState({
        width: undefined,
        height: undefined,
    }), windowSize = _a[0], setWindowSize = _a[1];
    useEffect(function () {
        // Handler to call on window resize
        function handleResize() {
            var _a;
            var timeout = 0;
            var ios = ((_a = detect()) === null || _a === void 0 ? void 0 : _a.name) === "ios-webview";
            if (navigator.userAgent.indexOf("LM-Q815K") > -1) {
                timeout = 100;
            }
            // Set window width/height to state
            setTimeout(function () {
                setWindowSize({
                    width: ios ? window.outerWidth : window.innerWidth,
                    height: ios ? window.outerHeight : window.innerHeight,
                });
            }, timeout);
            // console.log("handleResize");
        }
        // ResizeObserver 사용하면 줄일때는 이벤트가 발생하는데, 창 크기를 키울때 이벤트가 발생안함..
        // if (ResizeObserver) {
        //   const resizeObserver = new ResizeObserver(handleResize);
        //   resizeObserver.observe(document.body);
        //   return () => {
        //     resizeObserver.unobserve(document.body);
        //   };
        // } else
        {
            // Add event listener
            window.addEventListener("resize", handleResize);
            // Call handler right away so state gets updated with initial window size
            handleResize();
            // Remove event listener on cleanup
            return function () { return window.removeEventListener("resize", handleResize); };
        }
    }, []); // Empty array ensures that effect is only run on mount
    return windowSize;
};

export { ADASLDWS, AI_EVENTS, ALPHA_API_GATEWAY_URI, ALPHA_API_SERVER_URI, ALPHA_GPS_WS_SERVER_URI, ALPHA_WS_SERVER_URI, index as API, API_GATEWAY_URI, API_SERVER_URI, APPSTORE, APP_VERSION, BATTERY_CLOUD_SUPPORTED, BATTERY_PROTECTION_WARNING_MODELS, BOTTOM_RIGHT, BOXPRO_EXTEND_MODELS, BOXPRO_MODELS, BatteryChangeSettingResult, BatteryFailPart, BatteryHistoryType, BatteryManualCommand, BatteryManualStatus, BatteryModel, BlackVueCloud, CAMERA_SETTING_UNSUPPORTED, CircleMode, CloudConnectionSettings, Countries, DARKMODE_MAP_STYLE, DEFAULT_LOCATION, DEFAULT_MAP_STYLE, DEFAULT_ZOOM, DMC100_MODELS, DMC200_MODELS, DMS_EVENTS, DMStoDegree, DROWS_SUPPORTED, DarkColors, DirectMode, DrawRectangle, DsmDrivePosition, DsmSensitivity, DsmSensitivityUXUI, ECODE_TO_MTYPE, ELITE_MODELS, ENABLED_CLOUD_OLD_MODELS, ERROR_TIMEOUT, EVENTMAP_REV_API_SERVER_URI, EVENTMAP_REV_TILE_URI, EVENT_AUTO_UPLOAD_MODELS, EventAbbrToEventFull, EventName, EventNames, FIRMWARE_INFO_URI, FIRMWARE_SETTINGS, FLEETA_PROMO_CODE, FLEET_EXTRA, FLEET_PRICE, FORMAT_MICROSD_CARD_MODEL, FenceTypeCode, FenceTypeName, Firmware$h as Firmware, FirmwareLanguages, Front$h as Front, FwAbbr, GEOFENCE_LINE_LAYER, GEOFENCE_LINE_LAYER_NAME, GEOFENCE_LINE_SOURCE_NAME, GEOFENCE_POLYGON_LAYER, GEOFENCE_POLYGON_LAYER_NAME, GEOFENCE_POLYGON_LINE_LAYER, GEOFENCE_POLYGON_LINE_LAYER_NAME, GEOFENCE_POLYGON_SOURCE_NAME, GOOGLEPLAY, GOOGLE_API_KEY, GPSTrackingIcons, GPS_WS_SERVER_URI, HDR_RESTARTING_MODEL, HELPCENTER, HELPCENTER_MOBILE, HIGHTEMPER_PROTECTION_MODALS, INITIAL_MAP_LOCATION, InformationWe, Interior, LITE, LITE_EXTRA, LOW_VOLTAGE_MODELS, Languages, LightColors, LocationMarkerIcon, LowvoltageTime, LowvoltageVolt, LowvoltageVolt_GPRO, MACAPP, MAINTENANCE_SERVER_URI, MAX_CAM_COUNT, MCODE_TO_TEXT, MOBILE_BOUNDS_PADDING, MOBILE_NAME, MODELS_1CH, MODELS_2CH, MODELS_3CH, MSG_CODE_TYPE, MTYPE_TO_ECODE, MobileLang, NON_WIFI_SLEEP_MODELS, NO_INT_MAP_STYLE, NO_LIVEVIEW_EVENTS, NO_PLAYBACK_EVENTS, NO_THUMBNAIL_EVENTS, OLD_MODELS, OPTION_CAMERA_MODELS, Option$h as Option, PARKING_EVENTS, PC_BOUNDS_PADDING, PRODUCTION_API_GATEWAY_URI, PRODUCTION_API_SERVER_URI, PRODUCTION_GPS_WS_SERVER_URI, PRODUCTION_WS_SERVER_URI, PSN650, Privacy_Policy, RCT_TIMESYNC_MODALS, ROWS_PER_PAGE, Rear$h as Rear, RoleNames, SATELLITE_MAP_STYLE, SERVER_MAINTENANCE_NOTICE_URI, SIGMASTAR_MODELS, SIGMASTAR_XPLUS_MODELS, SIMCARD_URI, SMART, SMART_EXTRA, SOS_BUTTON_MODELS, STAGE_API_GATEWAY_URI, STAGE_API_SERVER_URI, STRIPE_API_KEY, STRIPE_OS_TYPE, SUPPORT_REBOOT_FW, ScheduledRebootTime, SemanticDarkColors, StatusColors, StatusNames, SystemADASLDWS, THUMBNAIL_EVENTS, TOKEN_TYPE, TOP_LEFT, TOP_RIGHT, TOUCH_SENSOR_MODELS, TUTORIAL, TermsConditions, TermsOfLocation, TimeZone, TimeZoneCountries, TimeZoneList, UPLOADING_QUEUE_UPDATE_INTERVAL, UnableAddCameraPSN4, UserNames, VideoImage, VideoResolution, WINDOWAPP, WS_SERVER_URI, Webviewer, axiosInst, cardLanguages, changeLandscape, changePortrait, config, convertGeofenceToGeometries, convertLowFilenameToOrignal, createOnFulfilled, createPermissions, delay, disableRotate, doDownload, downloadBlob, enableRotate, eventToText, eventmapAxiosInst, eventmapJwtAxiosInst, exceedLiveview, exitFullscreen, findNewFw, generateAuthToken, getAngle, getDirection, getDirectionString, getDirectionVOD, getElementByXpath, getEvent, getFileRes, getFirmwareConfig, getFotaURI, getIcon, getLbURI, getLocationLabel, getMarker, getOriginalFilename, getPlanFromServiceID, getS3URI, getSpeedValue, getTextWidth, getZIndexOfMarker, hideGNB, i18n, initGeofenceSourcesAndLayers, isFullscreen, jwtAxiosInst, makeAppGPSTrackingInfoPanel, makeClusterMarker, makeGPSTrackingInfoPanel, makeLiveviewMarker, makeLocationMarker, makeLocationOnlyLabel, multiDownload, parseNMEA, renderGeofences, requestFullscreen, resources, sendMessageBack, showGNB, simulateDblClick, sleep, theme, toggleFullscreen, updateGeofence, useScreenOrientation, useWindowSize };
//# sourceMappingURL=index.js.map
